// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kyVrY":[function(require,module,exports,__globalThis) {
require("3ee1318e6b1ed89a").register(require("5f18d9da7c5d435c").getBundleURL('hmjwG'), JSON.parse("[\"hmjwG\",\"index.1777760e.js\",\"j4umq\",\"IBMi.1bcde794.svg\",\"jUFmD\",\"connectria-logo-c.237aabf7.png\",\"atxOJ\",\"aws-logo.9b34d3da.png\",\"b3TBH\",\"aws_gov-logo.74a59d52.png\",\"7ippB\",\"azure_arm-logo.987077d6.png\",\"ahjo7\",\"gce-logo.562570c9.png\",\"e2N0m\",\"IBM_i.c69401d6.png\",\"fkPXb\",\"k8s-logo.723aeb15.png\",\"laSvJ\",\"vmware_vsphere-logo.86c962ec.png\",\"K7gaz\",\"CloudWatchAlarmsDashboard.20944365.js\",\"rHy52\",\"AzureAlertsDashboard.ba8cc499.js\",\"QOOw3\",\"CostSavingsWidget.43219cf2.js\",\"dPHxE\",\"CostSavingsWidget.4ea0ebc1.js\",\"jNO3W\",\"CostSavingsWidget.a73cf84c.css\",\"itGhn\",\"DevicesDashboard.a0f1342d.js\",\"fkLYS\",\"TrendMicroDashboard.c3c9f44b.js\",\"5Sf2N\",\"TrendMicroDashboard.67ebb94f.js\",\"hNch6\",\"ComplianceDashboardCard.acfaba22.js\",\"9VI9m\",\"hippa.3d8d7e91.png\",\"6DvuC\",\"pci.a514349d.png\",\"eg4vg\",\"icon-CSA.6da9721a.png\",\"3KW1v\",\"icon-GDPR.72c7abc8.png\",\"9wdV7\",\"APRACPS.fbf87630.png\",\"2ke77\",\"ASAE 3150.8ef7e210.png\",\"c9IGM\",\"aure_wellarchitected_framework.90d23c32.png\",\"eY2Tu\",\"AUSGovISM.c58441c8.png\",\"cg3gq\",\"aws_wellarchitected_framework.77898e05.png\",\"ftPUb\",\"CIS Amazon Web.0ead7e67.png\",\"er4iT\",\"CIS Azure.09c98ef6.png\",\"br4dr\",\"FEDRAMP.73b3f24e.png\",\"72261\",\"Hitrust.44e0e35a.png\",\"aWtiL\",\"icon-NIST.84107ca6.png\",\"fWYJV\",\"icon-NISTCSF.75fc4555.png\",\"cwZem\",\"icon-NISTv4.4d62d73d.png\",\"7REIZ\",\"icon-NISTv5.0d4ea283.png\",\"epapS\",\"iso27001.563226fa.png\",\"kpa4Q\",\"MonetarySingapore.24b30885.png\",\"8xsh6\",\"PCICSS.e7149cc1.png\",\"1S91i\",\"SOC2.d59412b6.png\",\"4FO1N\",\"SecurityAdvisorDashboard.2487df68.js\",\"kcSmY\",\"ResourceManagementPage.28a0887a.js\",\"hFeJI\",\"Checked Icon.e9be27de.svg\",\"ebvIZ\",\"ExternalLinkIcon.b2df7da9.svg\",\"3Jtyg\",\"network_interfaces.866228e8.svg\",\"8xwfm\",\"virtual_machines.06d3857a.svg\",\"6DFwx\",\"storage_accounts.e6606261.svg\",\"dOc6U\",\"disk.9f020d7d.svg\",\"01XC5\",\"ec2.fc3c5e1a.svg\",\"eEuXA\",\"database.b48a0935.svg\",\"d5wfs\",\"security-group.79cf295c.svg\",\"6fUB8\",\"DevicesPage.a3419471.js\",\"1JJpK\",\"ResourceManagementPage.51044f2c.js\",\"kImt5\",\"IbmDashboard.e83680bc.js\",\"hTl6g\",\"IbmDashboard.2c25fe07.js\",\"hrZSR\",\"IbmDashboard.9c8a51a5.css\",\"hyhOp\",\"IbmHostReportDashboard.a641a94e.js\",\"41EKD\",\"IbmHostReportDashboard.f7190c01.css\",\"iWm9i\",\"IbmHostDashboard.e83f020f.js\",\"jOqYm\",\"BlueMatadorDetails.da58c2e6.js\",\"l4sqK\",\"CloudWatchAlarms.571d9423.js\",\"dJ1KK\",\"AzureAlerts.77594a50.js\",\"dtdNv\",\"BackupJobsDashborard.dd3e19cc.js\",\"5kAkc\",\"BackupAllJobs.a1298804.js\",\"6P6YR\",\"cost-dashboard.32f4273d.js\",\"1Fp5x\",\"cost-dashboard.5791551a.js\",\"eKyJe\",\"cost-dashboard.a48ddc48.js\",\"bgfX8\",\"cost-dashboard.f9a17002.css\",\"kxFyJ\",\"SpendByResources.d0722968.js\",\"cGrnM\",\"SpendByResources.d9e5d631.js\",\"6o8se\",\"SpendByResources.12c8f7b6.css\",\"6C52O\",\"SpendByTagsReport.60159c6f.js\",\"BegZJ\",\"SpendByTagsReport.e75d68e6.css\",\"gWRhS\",\"cost-savings-dashboard.592ee43d.js\",\"7Wht9\",\"TrendMicroDetail.be0aa788.js\",\"jKMDA\",\"SecurityAdvisor.c1fbc7ca.js\",\"lNDvf\",\"CompliancePage.ceb0429f.js\",\"k1a9N\",\"NotificationsPage.d9078c7f.js\",\"72D6V\",\"RunbookListPage.3b856bcf.js\",\"3Lyer\",\"RunbookListPage.8d816b5e.js\",\"aBAMO\",\"CloudsIcon.d28265b8.svg\",\"24loL\",\"RunbookDetailPage.a6dca202.js\",\"dT9qh\",\"OpsList.9895349c.js\",\"4ivy8\",\"PowerIcon.3b809877.svg\",\"asNW6\",\"OpsConfigurationForm.cefe8b99.js\",\"58xf6\",\"OpsConfigurationForm.c5dd7d9a.js\",\"atp14\",\"HourGlass.59d2ce02.svg\",\"kbkIi\",\"Repeatonce.db21500e.svg\",\"7GGKS\",\"Repeatrepeat.6a0d2a25.svg\",\"aGzbt\",\"OpsDetailPage.e7cda823.js\",\"jvf7B\",\"EnvironmentReportPage.e810ad06.js\",\"8THKA\",\"cover_bg.e50389c6.png\",\"lvikM\",\"cover_fg.475ffaee.jpeg\",\"4QAGZ\",\"summary_background.7761ad55.png\",\"33Ejt\",\"resources.a74ae7b6.png\",\"1u4EB\",\"performance.1af19722.png\",\"a2OqM\",\"security.478cfe5d.png\",\"frnCU\",\"compliance.c2f9f6d2.png\",\"kOWBm\",\"spend.79ab3d3a.png\",\"9xL14\",\"resource_compute.bc331019.png\",\"gBMal\",\"resource_storage.309b8855.png\",\"5Bevn\",\"resource_container.d2dfe1db.png\",\"fzIEj\",\"resource_network.c581e76d.png\",\"jXOZN\",\"resource_identity.9a146638.png\",\"drhEm\",\"resource_other.621bf4e6.png\",\"g8ios\",\"issue_active.ca19ee63.png\",\"43VEd\",\"bulletpoint.1b009cfe.png\",\"73d4c\",\"issue_alert.a51cfcae.png\",\"58G5j\",\"issue_warning.e6d27eee.png\",\"2Ougo\",\"issue_resolved.bc938311.png\",\"eVKI1\",\"malware_active.5d16110f.png\",\"bkn8x\",\"malware_resolved.953987af.png\",\"lqWcY\",\"advisory_active.a473cacd.jpeg\",\"c1rhM\",\"saving_major.ec86e4a8.png\",\"5iDl9\",\"saving_minor.82ccb265.png\",\"7ag7d\",\"saving_addressed.4cd89875.png\",\"4shva\",\"connectria-logo.3536dc57.png\",\"bL7BP\",\"AWSSupport.cece9578.js\",\"lNGDC\",\"ConnectriaTicketFullPage.353cae69.js\",\"2on7u\",\"ConnectriaNewTicketFullPage.54121c04.js\",\"adJh5\",\"TicketsPage.71c9290f.js\",\"lLLVA\",\"InvoicesPage.1db7a39a.js\",\"kCwWs\",\"ExportCloudProperties.9c12f046.js\",\"2Qt4h\",\"index.4d2b5a28.css\"]"));

},{"3ee1318e6b1ed89a":"dixf5","5f18d9da7c5d435c":"fGflc"}],"dixf5":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"fGflc":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"2MXAg":[function(require,module,exports,__globalThis) {
/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _esSymbolJs = require("core-js/modules/es.symbol.js");
var _esSymbolDescriptionJs = require("core-js/modules/es.symbol.description.js");
var _esSymbolAsyncIteratorJs = require("core-js/modules/es.symbol.async-iterator.js");
var _esSymbolHasInstanceJs = require("core-js/modules/es.symbol.has-instance.js");
var _esSymbolIsConcatSpreadableJs = require("core-js/modules/es.symbol.is-concat-spreadable.js");
var _esSymbolIteratorJs = require("core-js/modules/es.symbol.iterator.js");
var _esSymbolMatchJs = require("core-js/modules/es.symbol.match.js");
var _esSymbolReplaceJs = require("core-js/modules/es.symbol.replace.js");
var _esSymbolSearchJs = require("core-js/modules/es.symbol.search.js");
var _esSymbolSpeciesJs = require("core-js/modules/es.symbol.species.js");
var _esSymbolSplitJs = require("core-js/modules/es.symbol.split.js");
var _esSymbolToPrimitiveJs = require("core-js/modules/es.symbol.to-primitive.js");
var _esSymbolToStringTagJs = require("core-js/modules/es.symbol.to-string-tag.js");
var _esSymbolUnscopablesJs = require("core-js/modules/es.symbol.unscopables.js");
var _esArrayConcatJs = require("core-js/modules/es.array.concat.js");
var _esArrayCopyWithinJs = require("core-js/modules/es.array.copy-within.js");
var _esArrayFillJs = require("core-js/modules/es.array.fill.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esArrayFindJs = require("core-js/modules/es.array.find.js");
var _esArrayFindIndexJs = require("core-js/modules/es.array.find-index.js");
var _esArrayFlatJs = require("core-js/modules/es.array.flat.js");
var _esArrayFlatMapJs = require("core-js/modules/es.array.flat-map.js");
var _esArrayFromJs = require("core-js/modules/es.array.from.js");
var _esArrayIncludesJs = require("core-js/modules/es.array.includes.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esArrayJoinJs = require("core-js/modules/es.array.join.js");
var _esArrayMapJs = require("core-js/modules/es.array.map.js");
var _esArrayOfJs = require("core-js/modules/es.array.of.js");
var _esArraySliceJs = require("core-js/modules/es.array.slice.js");
var _esArraySortJs = require("core-js/modules/es.array.sort.js");
var _esArraySpeciesJs = require("core-js/modules/es.array.species.js");
var _esArraySpliceJs = require("core-js/modules/es.array.splice.js");
var _esArrayUnscopablesFlatJs = require("core-js/modules/es.array.unscopables.flat.js");
var _esArrayUnscopablesFlatMapJs = require("core-js/modules/es.array.unscopables.flat-map.js");
var _esArrayBufferConstructorJs = require("core-js/modules/es.array-buffer.constructor.js");
var _esDateToPrimitiveJs = require("core-js/modules/es.date.to-primitive.js");
var _esFunctionHasInstanceJs = require("core-js/modules/es.function.has-instance.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esJsonToStringTagJs = require("core-js/modules/es.json.to-string-tag.js");
var _esMapJs = require("core-js/modules/es.map.js");
var _esMathAcoshJs = require("core-js/modules/es.math.acosh.js");
var _esMathAsinhJs = require("core-js/modules/es.math.asinh.js");
var _esMathAtanhJs = require("core-js/modules/es.math.atanh.js");
var _esMathCbrtJs = require("core-js/modules/es.math.cbrt.js");
var _esMathClz32Js = require("core-js/modules/es.math.clz32.js");
var _esMathCoshJs = require("core-js/modules/es.math.cosh.js");
var _esMathExpm1Js = require("core-js/modules/es.math.expm1.js");
var _esMathFroundJs = require("core-js/modules/es.math.fround.js");
var _esMathHypotJs = require("core-js/modules/es.math.hypot.js");
var _esMathImulJs = require("core-js/modules/es.math.imul.js");
var _esMathLog10Js = require("core-js/modules/es.math.log10.js");
var _esMathLog1PJs = require("core-js/modules/es.math.log1p.js");
var _esMathLog2Js = require("core-js/modules/es.math.log2.js");
var _esMathSignJs = require("core-js/modules/es.math.sign.js");
var _esMathSinhJs = require("core-js/modules/es.math.sinh.js");
var _esMathTanhJs = require("core-js/modules/es.math.tanh.js");
var _esMathToStringTagJs = require("core-js/modules/es.math.to-string-tag.js");
var _esMathTruncJs = require("core-js/modules/es.math.trunc.js");
var _esNumberConstructorJs = require("core-js/modules/es.number.constructor.js");
var _esNumberEpsilonJs = require("core-js/modules/es.number.epsilon.js");
var _esNumberIsFiniteJs = require("core-js/modules/es.number.is-finite.js");
var _esNumberIsIntegerJs = require("core-js/modules/es.number.is-integer.js");
var _esNumberIsNanJs = require("core-js/modules/es.number.is-nan.js");
var _esNumberIsSafeIntegerJs = require("core-js/modules/es.number.is-safe-integer.js");
var _esNumberMaxSafeIntegerJs = require("core-js/modules/es.number.max-safe-integer.js");
var _esNumberMinSafeIntegerJs = require("core-js/modules/es.number.min-safe-integer.js");
var _esNumberParseFloatJs = require("core-js/modules/es.number.parse-float.js");
var _esNumberParseIntJs = require("core-js/modules/es.number.parse-int.js");
var _esNumberToFixedJs = require("core-js/modules/es.number.to-fixed.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esObjectDefineGetterJs = require("core-js/modules/es.object.define-getter.js");
var _esObjectDefineSetterJs = require("core-js/modules/es.object.define-setter.js");
var _esObjectEntriesJs = require("core-js/modules/es.object.entries.js");
var _esObjectFreezeJs = require("core-js/modules/es.object.freeze.js");
var _esObjectFromEntriesJs = require("core-js/modules/es.object.from-entries.js");
var _esObjectGetOwnPropertyDescriptorJs = require("core-js/modules/es.object.get-own-property-descriptor.js");
var _esObjectGetOwnPropertyDescriptorsJs = require("core-js/modules/es.object.get-own-property-descriptors.js");
var _esObjectGetOwnPropertyNamesJs = require("core-js/modules/es.object.get-own-property-names.js");
var _esObjectGetPrototypeOfJs = require("core-js/modules/es.object.get-prototype-of.js");
var _esObjectIsJs = require("core-js/modules/es.object.is.js");
var _esObjectIsExtensibleJs = require("core-js/modules/es.object.is-extensible.js");
var _esObjectIsFrozenJs = require("core-js/modules/es.object.is-frozen.js");
var _esObjectIsSealedJs = require("core-js/modules/es.object.is-sealed.js");
var _esObjectKeysJs = require("core-js/modules/es.object.keys.js");
var _esObjectLookupGetterJs = require("core-js/modules/es.object.lookup-getter.js");
var _esObjectLookupSetterJs = require("core-js/modules/es.object.lookup-setter.js");
var _esObjectPreventExtensionsJs = require("core-js/modules/es.object.prevent-extensions.js");
var _esObjectSealJs = require("core-js/modules/es.object.seal.js");
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _esObjectValuesJs = require("core-js/modules/es.object.values.js");
var _esPromiseJs = require("core-js/modules/es.promise.js");
var _esPromiseFinallyJs = require("core-js/modules/es.promise.finally.js");
var _esReflectApplyJs = require("core-js/modules/es.reflect.apply.js");
var _esReflectConstructJs = require("core-js/modules/es.reflect.construct.js");
var _esReflectDefinePropertyJs = require("core-js/modules/es.reflect.define-property.js");
var _esReflectDeletePropertyJs = require("core-js/modules/es.reflect.delete-property.js");
var _esReflectGetJs = require("core-js/modules/es.reflect.get.js");
var _esReflectGetOwnPropertyDescriptorJs = require("core-js/modules/es.reflect.get-own-property-descriptor.js");
var _esReflectGetPrototypeOfJs = require("core-js/modules/es.reflect.get-prototype-of.js");
var _esReflectHasJs = require("core-js/modules/es.reflect.has.js");
var _esReflectIsExtensibleJs = require("core-js/modules/es.reflect.is-extensible.js");
var _esReflectOwnKeysJs = require("core-js/modules/es.reflect.own-keys.js");
var _esReflectPreventExtensionsJs = require("core-js/modules/es.reflect.prevent-extensions.js");
var _esReflectSetJs = require("core-js/modules/es.reflect.set.js");
var _esReflectSetPrototypeOfJs = require("core-js/modules/es.reflect.set-prototype-of.js");
var _esRegexpConstructorJs = require("core-js/modules/es.regexp.constructor.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esRegexpFlagsJs = require("core-js/modules/es.regexp.flags.js");
var _esRegexpToStringJs = require("core-js/modules/es.regexp.to-string.js");
var _esSetJs = require("core-js/modules/es.set.js");
var _esStringCodePointAtJs = require("core-js/modules/es.string.code-point-at.js");
var _esStringEndsWithJs = require("core-js/modules/es.string.ends-with.js");
var _esStringFromCodePointJs = require("core-js/modules/es.string.from-code-point.js");
var _esStringIncludesJs = require("core-js/modules/es.string.includes.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esStringPadEndJs = require("core-js/modules/es.string.pad-end.js");
var _esStringPadStartJs = require("core-js/modules/es.string.pad-start.js");
var _esStringRawJs = require("core-js/modules/es.string.raw.js");
var _esStringRepeatJs = require("core-js/modules/es.string.repeat.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
var _esStringSearchJs = require("core-js/modules/es.string.search.js");
var _esStringSplitJs = require("core-js/modules/es.string.split.js");
var _esStringStartsWithJs = require("core-js/modules/es.string.starts-with.js");
var _esStringTrimJs = require("core-js/modules/es.string.trim.js");
var _esStringTrimEndJs = require("core-js/modules/es.string.trim-end.js");
var _esStringTrimStartJs = require("core-js/modules/es.string.trim-start.js");
var _esStringAnchorJs = require("core-js/modules/es.string.anchor.js");
var _esStringBigJs = require("core-js/modules/es.string.big.js");
var _esStringBlinkJs = require("core-js/modules/es.string.blink.js");
var _esStringBoldJs = require("core-js/modules/es.string.bold.js");
var _esStringFixedJs = require("core-js/modules/es.string.fixed.js");
var _esStringFontcolorJs = require("core-js/modules/es.string.fontcolor.js");
var _esStringFontsizeJs = require("core-js/modules/es.string.fontsize.js");
var _esStringItalicsJs = require("core-js/modules/es.string.italics.js");
var _esStringLinkJs = require("core-js/modules/es.string.link.js");
var _esStringSmallJs = require("core-js/modules/es.string.small.js");
var _esStringStrikeJs = require("core-js/modules/es.string.strike.js");
var _esStringSubJs = require("core-js/modules/es.string.sub.js");
var _esStringSupJs = require("core-js/modules/es.string.sup.js");
var _esTypedArrayFloat32ArrayJs = require("core-js/modules/es.typed-array.float32-array.js");
var _esTypedArrayFloat64ArrayJs = require("core-js/modules/es.typed-array.float64-array.js");
var _esTypedArrayInt8ArrayJs = require("core-js/modules/es.typed-array.int8-array.js");
var _esTypedArrayInt16ArrayJs = require("core-js/modules/es.typed-array.int16-array.js");
var _esTypedArrayInt32ArrayJs = require("core-js/modules/es.typed-array.int32-array.js");
var _esTypedArrayUint8ArrayJs = require("core-js/modules/es.typed-array.uint8-array.js");
var _esTypedArrayUint8ClampedArrayJs = require("core-js/modules/es.typed-array.uint8-clamped-array.js");
var _esTypedArrayUint16ArrayJs = require("core-js/modules/es.typed-array.uint16-array.js");
var _esTypedArrayUint32ArrayJs = require("core-js/modules/es.typed-array.uint32-array.js");
var _esTypedArrayCopyWithinJs = require("core-js/modules/es.typed-array.copy-within.js");
var _esTypedArrayEveryJs = require("core-js/modules/es.typed-array.every.js");
var _esTypedArrayFillJs = require("core-js/modules/es.typed-array.fill.js");
var _esTypedArrayFilterJs = require("core-js/modules/es.typed-array.filter.js");
var _esTypedArrayFindJs = require("core-js/modules/es.typed-array.find.js");
var _esTypedArrayFindIndexJs = require("core-js/modules/es.typed-array.find-index.js");
var _esTypedArrayForEachJs = require("core-js/modules/es.typed-array.for-each.js");
var _esTypedArrayFromJs = require("core-js/modules/es.typed-array.from.js");
var _esTypedArrayIncludesJs = require("core-js/modules/es.typed-array.includes.js");
var _esTypedArrayIndexOfJs = require("core-js/modules/es.typed-array.index-of.js");
var _esTypedArrayIteratorJs = require("core-js/modules/es.typed-array.iterator.js");
var _esTypedArrayJoinJs = require("core-js/modules/es.typed-array.join.js");
var _esTypedArrayLastIndexOfJs = require("core-js/modules/es.typed-array.last-index-of.js");
var _esTypedArrayMapJs = require("core-js/modules/es.typed-array.map.js");
var _esTypedArrayOfJs = require("core-js/modules/es.typed-array.of.js");
var _esTypedArrayReduceJs = require("core-js/modules/es.typed-array.reduce.js");
var _esTypedArrayReduceRightJs = require("core-js/modules/es.typed-array.reduce-right.js");
var _esTypedArrayReverseJs = require("core-js/modules/es.typed-array.reverse.js");
var _esTypedArraySetJs = require("core-js/modules/es.typed-array.set.js");
var _esTypedArraySliceJs = require("core-js/modules/es.typed-array.slice.js");
var _esTypedArraySomeJs = require("core-js/modules/es.typed-array.some.js");
var _esTypedArraySortJs = require("core-js/modules/es.typed-array.sort.js");
var _esTypedArraySubarrayJs = require("core-js/modules/es.typed-array.subarray.js");
var _esTypedArrayToLocaleStringJs = require("core-js/modules/es.typed-array.to-locale-string.js");
var _esTypedArrayToStringJs = require("core-js/modules/es.typed-array.to-string.js");
var _esWeakMapJs = require("core-js/modules/es.weak-map.js");
var _esWeakSetJs = require("core-js/modules/es.weak-set.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _webQueueMicrotaskJs = require("core-js/modules/web.queue-microtask.js");
var _webUrlJs = require("core-js/modules/web.url.js");
var _webUrlToJsonJs = require("core-js/modules/web.url.to-json.js");
var _webUrlSearchParamsJs = require("core-js/modules/web.url-search-params.js");
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("regenerator-runtime/runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _history = require("history");
var _reactRouterDom = require("react-router-dom");
var _awsAmplify = require("aws-amplify");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _appJsx = require("./layouts/App/App.jsx");
var _appJsxDefault = parcelHelpers.interopDefault(_appJsx);
var _loginJsx = require("./layouts/Login/Login.jsx");
var _loginJsxDefault = parcelHelpers.interopDefault(_loginJsx);
var _notFound = require("./components/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _privateRoute = require("./utility/PrivateRoute");
var _privateRouteDefault = parcelHelpers.interopDefault(_privateRoute);
var _misc = require("./utility/misc");
var _commonService = require("./services/CommonService");
var _commonServiceDefault = parcelHelpers.interopDefault(_commonService);
var _maintenanceJs = require("./views/Maintenance.js");
var _maintenanceJsDefault = parcelHelpers.interopDefault(_maintenanceJs);
var _accessDenied = require("./views/AccessDenied");
var _accessDeniedDefault = parcelHelpers.interopDefault(_accessDenied);
// import {checkCognitoAuth} from "./utility/CognitoAuth";
var _appState = require("./AppState");
var _blackDashboardReactScss = require("./assets/scss/black-dashboard-react.scss");
var _demoCss = require("./assets/demo/demo.css");
var _nucleoIconsCss = require("./assets/css/nucleo-icons.css");
var _styleCss = require("react-image-lightbox/style.css");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _styleCss1 = require("reactflow/dist/style.css");
//REDIRECT OLD SITE TO NEW - TEMP TILL WE FIND DNS
if (window.location.hostname.indexOf('tria-labs.connectria.com') > -1) window.location.hostname = 'next-gen.tria.connectria.com';
var hist = (0, _history.createBrowserHistory)();
var ignoredRoutes = [
    'v3/auth/provider/local',
    '.js',
    '/login',
    '/tfa/verify',
    '/domain/organizations/get',
    '/cloud/all/cost/savings/',
    '/plugin/support/portal/',
    '/v3/auth/initiate'
];
var failedAttempts = 0;
function HealthCheck() {
    return _HealthCheck.apply(this, arguments);
}
function _HealthCheck() {
    _HealthCheck = // setInterval(async () => {
    //   await HealthCheck()
    // }, 30000);
    (0, _asyncToGenerator._)(function() {
        var u, ex;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, _awsAmplify.Auth).currentAuthenticatedUser({
                            bypassCache: true
                        })
                    ];
                case 1:
                    u = _state.sent();
                    console.log(u);
                    return [
                        3,
                        3
                    ];
                case 2:
                    ex = _state.sent();
                    console.log(ex);
                    window.location.href = "/login".concat((0, _misc.buildRurl)());
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _HealthCheck.apply(this, arguments);
}
(0, _axiosDefault.default).interceptors.response.use(function(response) {
    return response;
}, /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(error) {
        var _appState1, stateApp, stateAppActions, i;
        return (0, _tsGenerator._)(this, function(_state) {
            console.log(error);
            if (typeof error.response != 'undefined' && error.response.status === 401) {
                _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
                //await checkCognitoAuth(stateApp.env)
                if (error.response != null && error.response.config != null) for(i = 0; i < ignoredRoutes.length; i++){
                    if (error.response.config.url.indexOf(ignoredRoutes[i]) > -1) return [
                        2
                    ];
                }
                //not on the login page, redirect
                console.log('unauthorized');
                window.location.href = "/login".concat((0, _misc.buildRurl)());
            }
            throw error;
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}());
(0, _reactDomDefault.default).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Router), {
    history: hist,
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                exact: true,
                from: "/",
                to: "/app/dashboard"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/login",
                exact: true,
                render: function(props) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginJsxDefault.default), (0, _objectSpread._)({}, props));
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/access-denied",
                exact: true,
                render: function(props) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessDeniedDefault.default), (0, _objectSpread._)({}, props));
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/maintenance",
                exact: true,
                render: function(props) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maintenanceJsDefault.default), (0, _objectSpread._)({}, props));
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateRouteDefault.default), {
                path: "/app/*",
                component: (0, _appJsxDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "*",
                component: (0, _notFoundDefault.default)
            })
        ]
    })
}), document.getElementById('root'));

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","core-js/modules/es.symbol.js":"fbGtf","core-js/modules/es.symbol.description.js":"frtRG","core-js/modules/es.symbol.async-iterator.js":"dqNG3","core-js/modules/es.symbol.has-instance.js":"YEkxs","core-js/modules/es.symbol.is-concat-spreadable.js":"Q8JET","core-js/modules/es.symbol.iterator.js":"cZRFB","core-js/modules/es.symbol.match.js":"1abPC","core-js/modules/es.symbol.replace.js":"6qr1U","core-js/modules/es.symbol.search.js":"bQFAO","core-js/modules/es.symbol.species.js":"88T64","core-js/modules/es.symbol.split.js":"Y720e","core-js/modules/es.symbol.to-primitive.js":"h4SxC","core-js/modules/es.symbol.to-string-tag.js":"flK7u","core-js/modules/es.symbol.unscopables.js":"1zhDF","core-js/modules/es.array.concat.js":"8RGhQ","core-js/modules/es.array.copy-within.js":"dFDn6","core-js/modules/es.array.fill.js":"1sfLZ","core-js/modules/es.array.filter.js":"e5Mkj","core-js/modules/es.array.find.js":"6LHE7","core-js/modules/es.array.find-index.js":"352xl","core-js/modules/es.array.flat.js":"gEzC0","core-js/modules/es.array.flat-map.js":"76irp","core-js/modules/es.array.from.js":"fuEh6","core-js/modules/es.array.includes.js":"3DkDJ","core-js/modules/es.array.iterator.js":"6J6Pu","core-js/modules/es.array.join.js":"gMeOj","core-js/modules/es.array.map.js":"czAZJ","core-js/modules/es.array.of.js":"cZvLO","core-js/modules/es.array.slice.js":"lIfM1","core-js/modules/es.array.sort.js":"aRnSS","core-js/modules/es.array.species.js":"fZYxD","core-js/modules/es.array.splice.js":"dQJ6h","core-js/modules/es.array.unscopables.flat.js":"XsOmQ","core-js/modules/es.array.unscopables.flat-map.js":"jklTo","core-js/modules/es.array-buffer.constructor.js":"10D4I","core-js/modules/es.date.to-primitive.js":"2yxfN","core-js/modules/es.function.has-instance.js":"4kV53","core-js/modules/es.function.name.js":"lJHpl","core-js/modules/es.json.to-string-tag.js":"5n1PG","core-js/modules/es.map.js":"cgPPQ","core-js/modules/es.math.acosh.js":"3tHxB","core-js/modules/es.math.asinh.js":"4G5bk","core-js/modules/es.math.atanh.js":"lyzd1","core-js/modules/es.math.cbrt.js":"gPtBO","core-js/modules/es.math.clz32.js":"8FmOw","core-js/modules/es.math.cosh.js":"hUnly","core-js/modules/es.math.expm1.js":"9Lupv","core-js/modules/es.math.fround.js":"cRADm","core-js/modules/es.math.hypot.js":"ebBZ6","core-js/modules/es.math.imul.js":"JDP36","core-js/modules/es.math.log10.js":"i8llG","core-js/modules/es.math.log1p.js":"idC7g","core-js/modules/es.math.log2.js":"jYWHq","core-js/modules/es.math.sign.js":"jK4YE","core-js/modules/es.math.sinh.js":"fCq0b","core-js/modules/es.math.tanh.js":"4zVaR","core-js/modules/es.math.to-string-tag.js":"jYiMT","core-js/modules/es.math.trunc.js":"cNhKx","core-js/modules/es.number.constructor.js":"4SoNN","core-js/modules/es.number.epsilon.js":"jQLWg","core-js/modules/es.number.is-finite.js":"ecIuF","core-js/modules/es.number.is-integer.js":"jlSHy","core-js/modules/es.number.is-nan.js":"rBnUu","core-js/modules/es.number.is-safe-integer.js":"8qIoh","core-js/modules/es.number.max-safe-integer.js":"3buzz","core-js/modules/es.number.min-safe-integer.js":"gAM0z","core-js/modules/es.number.parse-float.js":"3emdE","core-js/modules/es.number.parse-int.js":"cnWQY","core-js/modules/es.number.to-fixed.js":"cARKM","core-js/modules/es.object.assign.js":"ihzwW","core-js/modules/es.object.define-getter.js":"9um4m","core-js/modules/es.object.define-setter.js":"4OsR9","core-js/modules/es.object.entries.js":"hkrb6","core-js/modules/es.object.freeze.js":"j5wZE","core-js/modules/es.object.from-entries.js":"jhyaM","core-js/modules/es.object.get-own-property-descriptor.js":"jSesk","core-js/modules/es.object.get-own-property-descriptors.js":"jEcOZ","core-js/modules/es.object.get-own-property-names.js":"4C8zp","core-js/modules/es.object.get-prototype-of.js":"h4PNm","core-js/modules/es.object.is.js":"bg0Gs","core-js/modules/es.object.is-extensible.js":"keWpV","core-js/modules/es.object.is-frozen.js":"hmEBJ","core-js/modules/es.object.is-sealed.js":"8A1Yf","core-js/modules/es.object.keys.js":"lYJul","core-js/modules/es.object.lookup-getter.js":"gW6nC","core-js/modules/es.object.lookup-setter.js":"6LLFo","core-js/modules/es.object.prevent-extensions.js":"2mA3E","core-js/modules/es.object.seal.js":"hTD2S","core-js/modules/es.object.to-string.js":"960Av","core-js/modules/es.object.values.js":"aGyku","core-js/modules/es.promise.js":"is7gu","core-js/modules/es.promise.finally.js":"5VPH4","core-js/modules/es.reflect.apply.js":"gB6dg","core-js/modules/es.reflect.construct.js":"eNY0D","core-js/modules/es.reflect.define-property.js":"cSswi","core-js/modules/es.reflect.delete-property.js":"g1HId","core-js/modules/es.reflect.get.js":"gykFO","core-js/modules/es.reflect.get-own-property-descriptor.js":"grkNa","core-js/modules/es.reflect.get-prototype-of.js":"DD8SS","core-js/modules/es.reflect.has.js":"gVdUt","core-js/modules/es.reflect.is-extensible.js":"eyQ17","core-js/modules/es.reflect.own-keys.js":"6ICFT","core-js/modules/es.reflect.prevent-extensions.js":"7WFT6","core-js/modules/es.reflect.set.js":"j3YwZ","core-js/modules/es.reflect.set-prototype-of.js":"enTUc","core-js/modules/es.regexp.constructor.js":"jdv2T","core-js/modules/es.regexp.exec.js":"jqZha","core-js/modules/es.regexp.flags.js":"2BmqD","core-js/modules/es.regexp.to-string.js":"20XVe","core-js/modules/es.set.js":"i3LVh","core-js/modules/es.string.code-point-at.js":"3Pezk","core-js/modules/es.string.ends-with.js":"g3adR","core-js/modules/es.string.from-code-point.js":"3D8UA","core-js/modules/es.string.includes.js":"6HJrH","core-js/modules/es.string.iterator.js":"Q5Pd0","core-js/modules/es.string.match.js":"8w1Hg","core-js/modules/es.string.pad-end.js":"krtEZ","core-js/modules/es.string.pad-start.js":"kz3aD","core-js/modules/es.string.raw.js":"bCLbx","core-js/modules/es.string.repeat.js":"4JDEG","core-js/modules/es.string.replace.js":"1dK4X","core-js/modules/es.string.search.js":"bURcY","core-js/modules/es.string.split.js":"vSLTn","core-js/modules/es.string.starts-with.js":"9no8N","core-js/modules/es.string.trim.js":"4DumU","core-js/modules/es.string.trim-end.js":"kl4IZ","core-js/modules/es.string.trim-start.js":"1Eoub","core-js/modules/es.string.anchor.js":"6ZCBg","core-js/modules/es.string.big.js":"YaAC8","core-js/modules/es.string.blink.js":"lywK7","core-js/modules/es.string.bold.js":"1Ttf8","core-js/modules/es.string.fixed.js":"aic6R","core-js/modules/es.string.fontcolor.js":"dwgEV","core-js/modules/es.string.fontsize.js":"gxccO","core-js/modules/es.string.italics.js":"ob1YY","core-js/modules/es.string.link.js":"2o4DR","core-js/modules/es.string.small.js":"5jffo","core-js/modules/es.string.strike.js":"68x7j","core-js/modules/es.string.sub.js":"4l5iT","core-js/modules/es.string.sup.js":"gA1yC","core-js/modules/es.typed-array.float32-array.js":"p1Zu8","core-js/modules/es.typed-array.float64-array.js":"baLvg","core-js/modules/es.typed-array.int8-array.js":"6QugB","core-js/modules/es.typed-array.int16-array.js":"2kxtr","core-js/modules/es.typed-array.int32-array.js":"imPfF","core-js/modules/es.typed-array.uint8-array.js":"kFdW6","core-js/modules/es.typed-array.uint8-clamped-array.js":"f25ck","core-js/modules/es.typed-array.uint16-array.js":"bpIfx","core-js/modules/es.typed-array.uint32-array.js":"aVXFQ","core-js/modules/es.typed-array.copy-within.js":"6a2xZ","core-js/modules/es.typed-array.every.js":"fYohF","core-js/modules/es.typed-array.fill.js":"eUwit","core-js/modules/es.typed-array.filter.js":"byYdd","core-js/modules/es.typed-array.find.js":"4TKC3","core-js/modules/es.typed-array.find-index.js":"dxzWH","core-js/modules/es.typed-array.for-each.js":"6UPEo","core-js/modules/es.typed-array.from.js":"e5EzV","core-js/modules/es.typed-array.includes.js":"lRVLC","core-js/modules/es.typed-array.index-of.js":"1anZM","core-js/modules/es.typed-array.iterator.js":"ho2tp","core-js/modules/es.typed-array.join.js":"1QC5G","core-js/modules/es.typed-array.last-index-of.js":"f3Z1B","core-js/modules/es.typed-array.map.js":"1PogV","core-js/modules/es.typed-array.of.js":"aZ40M","core-js/modules/es.typed-array.reduce.js":"1zz7d","core-js/modules/es.typed-array.reduce-right.js":"bgWqn","core-js/modules/es.typed-array.reverse.js":"l27V6","core-js/modules/es.typed-array.set.js":"951XZ","core-js/modules/es.typed-array.slice.js":"hEb3t","core-js/modules/es.typed-array.some.js":"kCDTa","core-js/modules/es.typed-array.sort.js":"76Oi3","core-js/modules/es.typed-array.subarray.js":"4wLnW","core-js/modules/es.typed-array.to-locale-string.js":"4pCzt","core-js/modules/es.typed-array.to-string.js":"dIEMx","core-js/modules/es.weak-map.js":"2rWO3","core-js/modules/es.weak-set.js":"49HaD","core-js/modules/web.dom-collections.for-each.js":"k7no3","core-js/modules/web.dom-collections.iterator.js":"ix44t","core-js/modules/web.immediate.js":"dJTOQ","core-js/modules/web.queue-microtask.js":"8J4gq","core-js/modules/web.url.js":"9p0om","core-js/modules/web.url.to-json.js":"63Jin","core-js/modules/web.url-search-params.js":"4r7ig","react/jsx-runtime":"1elNt","regenerator-runtime/runtime":"iYihS","react":"gVheC","react-dom":"d8jlt","history":"99v96","react-router-dom":"acq4R","aws-amplify":"75VoS","axios":"ebRwi","./layouts/App/App.jsx":"dTzhW","./layouts/Login/Login.jsx":"tLiGr","./components/NotFound":"3DAIL","./utility/PrivateRoute":"kpn7c","./utility/misc":"bM8Mk","./services/CommonService":"9DECy","./views/Maintenance.js":"2sBwV","./views/AccessDenied":"7GYCp","./AppState":"8UGXH","./assets/scss/black-dashboard-react.scss":"ep8Cn","./assets/demo/demo.css":"jwREl","./assets/css/nucleo-icons.css":"jmQHV","react-image-lightbox/style.css":"778iy","react-datepicker/dist/react-datepicker.css":"OsGbX","reactflow/dist/style.css":"3T38Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3uGjr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kznVD":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"awG4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread;
});
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"4QmId","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4QmId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byksX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"bkVhC","./_iterable_to_array_limit.js":"flq32","./_non_iterable_rest.js":"hf2PL","./_unsupported_iterable_to_array.js":"8BcAR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkVhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"flq32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hf2PL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8BcAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"fwJyR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fwJyR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2jVI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86BcK":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", function() {
    return __rewriteRelativeImportExtension;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, _typeOf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function ownKeys1(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, _typeOf._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"668P4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fbGtf":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require("9907e25c4a0aca96");
require("6ca7b218a3c5142b");
require("733763f50161f4ff");
require("c7e8ec39e8a501c2");
require("c7f11a8d456724");

},{"9907e25c4a0aca96":"9HNHy","6ca7b218a3c5142b":"5KXvw","733763f50161f4ff":"5BXaq","c7e8ec39e8a501c2":"3ydPO","c7f11a8d456724":"fEuZH"}],"9HNHy":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("aa5b0a4df7071e1c");
var globalThis = require("8c408afdfdfd6dab");
var call = require("ec29447784c0114a");
var uncurryThis = require("2ae82c68e0ae40f");
var IS_PURE = require("33b2452838c11281");
var DESCRIPTORS = require("fe806d898b4ac536");
var NATIVE_SYMBOL = require("22d83c4d1a79086a");
var fails = require("4d2b1c3a38702ef3");
var hasOwn = require("e759feb93fde3dec");
var isPrototypeOf = require("5787c74359c86565");
var anObject = require("cb32a2177bbbabaa");
var toIndexedObject = require("20c01e2a38c99bca");
var toPropertyKey = require("db20fe52e48e74e7");
var $toString = require("62c50d67351dd58a");
var createPropertyDescriptor = require("22cebb6457d12409");
var nativeObjectCreate = require("31dc62cd3a5d2fda");
var objectKeys = require("14509c82c4f3e2e9");
var getOwnPropertyNamesModule = require("e62ee144604e88fa");
var getOwnPropertyNamesExternal = require("d7fe574b8ddea4e9");
var getOwnPropertySymbolsModule = require("fc2b88a87581c564");
var getOwnPropertyDescriptorModule = require("7260979738a18766");
var definePropertyModule = require("c58a10205146713c");
var definePropertiesModule = require("a86b1c2861165466");
var propertyIsEnumerableModule = require("dfca683f72250bcc");
var defineBuiltIn = require("55a26bb040d83918");
var defineBuiltInAccessor = require("97712bd669b06ccf");
var shared = require("b2130786c0cb0f80");
var sharedKey = require("aaac558287b5aa94");
var hiddenKeys = require("c6ea7d7218c4c1f0");
var uid = require("f4a251fc6a0ec32a");
var wellKnownSymbol = require("2d3c3a8ae405672f");
var wrappedWellKnownSymbolModule = require("a99e55c559023f8b");
var defineWellKnownSymbol = require("baa63ea979fa51ca");
var defineSymbolToPrimitive = require("ecef47c4fbdd606b");
var setToStringTag = require("f57a8c7fd7d84ffb");
var InternalStateModule = require("37236ad9fe95a3e");
var $forEach = require("c50230ad6eef7275").forEach;
var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = globalThis.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = globalThis.RangeError;
var TypeError = globalThis.TypeError;
var QObject = globalThis.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function fallbackDefineProperty(O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
    nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
};
var setSymbolDescriptor = DESCRIPTORS && fails(function() {
    return nativeObjectCreate(nativeDefineProperty({}, 'a', {
        get: function get() {
            return nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;
var wrap = function wrap(tag, description) {
    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
    setInternalState(symbol, {
        type: SYMBOL,
        tag: tag,
        description: description
    });
    if (!DESCRIPTORS) symbol.description = description;
    return symbol;
};
var $defineProperty = function defineProperty(O, P, Attributes) {
    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
    anObject(O);
    var key = toPropertyKey(P);
    anObject(Attributes);
    if (hasOwn(AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
            O[HIDDEN][key] = true;
        } else {
            if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
            Attributes = nativeObjectCreate(Attributes, {
                enumerable: createPropertyDescriptor(0, false)
            });
        }
        return setSymbolDescriptor(O, key, Attributes);
    }
    return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties(O, Properties) {
    anObject(O);
    var properties = toIndexedObject(Properties);
    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
    $forEach(keys, function(key) {
        if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
    });
    return O;
};
var $create = function create(O, Properties) {
    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = toPropertyKey(V);
    var enumerable = call(nativePropertyIsEnumerable, this, P);
    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = toIndexedObject(O);
    var key = toPropertyKey(P);
    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
    var result = [];
    $forEach(names, function(key) {
        if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
    });
    return result;
};
var $getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
    var result = [];
    $forEach(names, function(key) {
        if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) push(result, AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
    $Symbol = function Symbol() {
        if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
        var tag = uid(description);
        var setter = function setter1(value) {
            var $this = this === undefined ? globalThis : this;
            if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
            if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
            var descriptor = createPropertyDescriptor(1, value);
            try {
                setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof RangeError)) throw error;
                fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return wrap(tag, description);
    };
    SymbolPrototype = $Symbol[PROTOTYPE];
    defineBuiltIn(SymbolPrototype, 'toString', function toString() {
        return getInternalState(this).tag;
    });
    defineBuiltIn($Symbol, 'withoutSetter', function(description) {
        return wrap(uid(description), description);
    });
    propertyIsEnumerableModule.f = $propertyIsEnumerable;
    definePropertyModule.f = $defineProperty;
    definePropertiesModule.f = $defineProperties;
    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
    wrappedWellKnownSymbolModule.f = function(name) {
        return wrap(wellKnownSymbol(name), name);
    };
    if (DESCRIPTORS) {
        // https://github.com/tc39/proposal-Symbol-description
        defineBuiltInAccessor(SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return getInternalState(this).description;
            }
        });
        if (!IS_PURE) defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$({
    global: true,
    constructor: true,
    wrap: true,
    forced: !NATIVE_SYMBOL,
    sham: !NATIVE_SYMBOL
}, {
    Symbol: $Symbol
});
$forEach(objectKeys(WellKnownSymbolsStore), function(name) {
    defineWellKnownSymbol(name);
});
$({
    target: SYMBOL,
    stat: true,
    forced: !NATIVE_SYMBOL
}, {
    useSetter: function useSetter() {
        USE_SETTER = true;
    },
    useSimple: function useSimple() {
        USE_SETTER = false;
    }
});
$({
    target: 'Object',
    stat: true,
    forced: !NATIVE_SYMBOL,
    sham: !DESCRIPTORS
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$({
    target: 'Object',
    stat: true,
    forced: !NATIVE_SYMBOL
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;

},{"aa5b0a4df7071e1c":"gD2TP","8c408afdfdfd6dab":"4naf8","ec29447784c0114a":"ebTVd","2ae82c68e0ae40f":"jsw26","33b2452838c11281":"6KD1D","fe806d898b4ac536":"ihfdR","22d83c4d1a79086a":"cvGX9","4d2b1c3a38702ef3":"8SraZ","e759feb93fde3dec":"h2GWh","5787c74359c86565":"fVGN3","cb32a2177bbbabaa":"2dEST","20c01e2a38c99bca":"gGepo","db20fe52e48e74e7":"9pd5y","62c50d67351dd58a":"ffo0a","22cebb6457d12409":"jtAW3","31dc62cd3a5d2fda":"5ZmqN","14509c82c4f3e2e9":"ahqdT","e62ee144604e88fa":"busKr","d7fe574b8ddea4e9":"hdcmz","fc2b88a87581c564":"b3HZA","7260979738a18766":"hRqf9","c58a10205146713c":"4d2AB","a86b1c2861165466":"1WKFx","dfca683f72250bcc":"heKXZ","55a26bb040d83918":"jlXZ9","97712bd669b06ccf":"g2LDG","b2130786c0cb0f80":"h8old","aaac558287b5aa94":"3txZ3","c6ea7d7218c4c1f0":"9HbEz","f4a251fc6a0ec32a":"6zL6V","2d3c3a8ae405672f":"6dJgl","a99e55c559023f8b":"ceP3T","baa63ea979fa51ca":"9Keq4","ecef47c4fbdd606b":"fmflI","f57a8c7fd7d84ffb":"3q5sA","37236ad9fe95a3e":"4Dlpx","c50230ad6eef7275":"giEdW"}],"gD2TP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var globalThis = require("23dea28abc8414d1");
var getOwnPropertyDescriptor = require("2ec751f39e500b85").f;
var createNonEnumerableProperty = require("b4567636b28a3b3a");
var defineBuiltIn = require("50460aa43dd4048a");
var defineGlobalProperty = require("581238c99f8c2c30");
var copyConstructorProperties = require("566a383894c688bc");
var isForced = require("f0e2e697f04e8ad9");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = globalThis;
    else if (STATIC) target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
    else target = globalThis[TARGET] && globalThis[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, _typeOf._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, _typeOf._)(targetProperty))) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};

},{"@swc/helpers/_/_type_of":"668P4","23dea28abc8414d1":"4naf8","2ec751f39e500b85":"hRqf9","b4567636b28a3b3a":"3IHVb","50460aa43dd4048a":"jlXZ9","581238c99f8c2c30":"lnRSs","566a383894c688bc":"5kBDz","f0e2e697f04e8ad9":"g6zdI"}],"4naf8":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
'use strict';
var check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check((typeof globalThis === "undefined" ? "undefined" : (0, _typeOf._)(globalThis)) == 'object' && globalThis) || check((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check((typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self) || check((typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global) || check((0, _typeOf._)(undefined) == 'object' && undefined) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

},{"@swc/helpers/_/_type_of":"668P4"}],"hRqf9":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("c04e6fb248689dba");
var call = require("553ec943aa2a4554");
var propertyIsEnumerableModule = require("bbc5e69071aa2fbd");
var createPropertyDescriptor = require("1d2ffbfd99e01f41");
var toIndexedObject = require("c4ea69a78a643d87");
var toPropertyKey = require("8ab18ff766aa2ab9");
var hasOwn = require("3761c5d34b7aa48f");
var IE8_DOM_DEFINE = require("c4dfcc26308f1b4a");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"c04e6fb248689dba":"ihfdR","553ec943aa2a4554":"ebTVd","bbc5e69071aa2fbd":"heKXZ","1d2ffbfd99e01f41":"jtAW3","c4ea69a78a643d87":"gGepo","8ab18ff766aa2ab9":"9pd5y","3761c5d34b7aa48f":"h2GWh","c4dfcc26308f1b4a":"hwfrY"}],"ihfdR":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("735b783268fd06c0");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});

},{"735b783268fd06c0":"8SraZ"}],"8SraZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"ebTVd":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_BIND = require("44e025d030d66023");
var call = Function.prototype.call;
module.exports = NATIVE_BIND ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{"44e025d030d66023":"hQNpA"}],"hQNpA":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("2642aa7619056f20");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

},{"2642aa7619056f20":"8SraZ"}],"heKXZ":[function(require,module,exports,__globalThis) {
'use strict';
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"jtAW3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"gGepo":[function(require,module,exports,__globalThis) {
'use strict';
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("9d8f8f50ac9468eb");
var requireObjectCoercible = require("f7224aed72953ac4");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"9d8f8f50ac9468eb":"dnbS6","f7224aed72953ac4":"a0P0K"}],"dnbS6":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("7ba7e65983d7b662");
var fails = require("df551e12a7c872dd");
var classof = require("1d34ea813cebff9c");
var $Object = Object;
var split = uncurryThis(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

},{"7ba7e65983d7b662":"jsw26","df551e12a7c872dd":"8SraZ","1d34ea813cebff9c":"fGBNn"}],"jsw26":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_BIND = require("829dd7a4e960cf9e");
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
    return function() {
        return call.apply(fn, arguments);
    };
};

},{"829dd7a4e960cf9e":"hQNpA"}],"fGBNn":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("1c71c3f6daac476c");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"1c71c3f6daac476c":"jsw26"}],"a0P0K":[function(require,module,exports,__globalThis) {
'use strict';
var isNullOrUndefined = require("74607922ed30019f");
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};

},{"74607922ed30019f":"9lebS"}],"9lebS":[function(require,module,exports,__globalThis) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

},{}],"9pd5y":[function(require,module,exports,__globalThis) {
'use strict';
var toPrimitive = require("53a3a67ac381c4e8");
var isSymbol = require("b992ca9cdcf7937b");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, 'string');
    return isSymbol(key) ? key : key + '';
};

},{"53a3a67ac381c4e8":"invap","b992ca9cdcf7937b":"g5d9N"}],"invap":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("70235907dc93b4b0");
var isObject = require("46fb53dace408c8e");
var isSymbol = require("677bdc4d74d2f983");
var getMethod = require("80395bcde336a28b");
var ordinaryToPrimitive = require("49552a7324952190");
var wellKnownSymbol = require("aea01c71276624bf");
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return ordinaryToPrimitive(input, pref);
};

},{"70235907dc93b4b0":"ebTVd","46fb53dace408c8e":"8iIJm","677bdc4d74d2f983":"g5d9N","80395bcde336a28b":"b2lgj","49552a7324952190":"2eNQe","aea01c71276624bf":"6dJgl"}],"8iIJm":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isCallable = require("f87cee1cb79cbcca");
module.exports = function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, _typeOf._)(it)) == 'object' ? it !== null : isCallable(it);
};

},{"@swc/helpers/_/_type_of":"668P4","f87cee1cb79cbcca":"37CJl"}],"37CJl":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = (typeof document === "undefined" ? "undefined" : (0, _typeOf._)(document)) == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

},{"@swc/helpers/_/_type_of":"668P4"}],"g5d9N":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var getBuiltIn = require("6b6c481cdfb7df35");
var isCallable = require("2af44fcbdbf14c83");
var isPrototypeOf = require("76e903e830c40e7c");
var USE_SYMBOL_AS_UID = require("7e2fe930b3598e22");
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, _typeOf._)(it)) == 'symbol';
} : function(it) {
    var $Symbol = getBuiltIn('Symbol');
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"@swc/helpers/_/_type_of":"668P4","6b6c481cdfb7df35":"iXpu0","2af44fcbdbf14c83":"37CJl","76e903e830c40e7c":"fVGN3","7e2fe930b3598e22":"6vIjR"}],"iXpu0":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("e057fc33d60763c1");
var isCallable = require("f1d62079325906cb");
var aFunction = function aFunction(argument) {
    return isCallable(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

},{"e057fc33d60763c1":"4naf8","f1d62079325906cb":"37CJl"}],"fVGN3":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("83f14842ef67e16a");
module.exports = uncurryThis({}.isPrototypeOf);

},{"83f14842ef67e16a":"jsw26"}],"6vIjR":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("da4a972af0214ea0");
module.exports = NATIVE_SYMBOL && !Symbol.sham && (0, _typeOf._)(Symbol.iterator) == 'symbol';

},{"@swc/helpers/_/_type_of":"668P4","da4a972af0214ea0":"cvGX9"}],"cvGX9":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("53b951dfb9de4d22");
var fails = require("b37df495bcdc1d99");
var globalThis = require("e5929e9affd2affc");
var $String = globalThis.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"53b951dfb9de4d22":"7Fmxi","b37df495bcdc1d99":"8SraZ","e5929e9affd2affc":"4naf8"}],"7Fmxi":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("d049c1c2aa0eee5b");
var userAgent = require("4eb5796bbafe334d");
var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"d049c1c2aa0eee5b":"4naf8","4eb5796bbafe334d":"7UNqW"}],"7UNqW":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("888bcb4c75dc4ad");
var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;
module.exports = userAgent ? String(userAgent) : '';

},{"888bcb4c75dc4ad":"4naf8"}],"b2lgj":[function(require,module,exports,__globalThis) {
'use strict';
var aCallable = require("bbfed17b24e215f4");
var isNullOrUndefined = require("492a86e2970f6a26");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"bbfed17b24e215f4":"ehOyc","492a86e2970f6a26":"9lebS"}],"ehOyc":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("4094667126ecac05");
var tryToString = require("fce2a7573db493fa");
var $TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError(tryToString(argument) + ' is not a function');
};

},{"4094667126ecac05":"37CJl","fce2a7573db493fa":"b8XMV"}],"b8XMV":[function(require,module,exports,__globalThis) {
'use strict';
var $String = String;
module.exports = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return 'Object';
    }
};

},{}],"2eNQe":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("abe9ca006f56626e");
var isCallable = require("c96b3a89fec6248a");
var isObject = require("551615fda0214f1b");
var $TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw new $TypeError("Can't convert object to primitive value");
};

},{"abe9ca006f56626e":"ebTVd","c96b3a89fec6248a":"37CJl","551615fda0214f1b":"8iIJm"}],"6dJgl":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("ad5ef4474219c101");
var shared = require("6a2cda01df6b4c79");
var hasOwn = require("dccc28ffa5beeb54");
var uid = require("48d6af1225853d44");
var NATIVE_SYMBOL = require("9f762329148684");
var USE_SYMBOL_AS_UID = require("1ce268781e409df2");
var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol('Symbol.' + name);
    return WellKnownSymbolsStore[name];
};

},{"ad5ef4474219c101":"4naf8","6a2cda01df6b4c79":"h8old","dccc28ffa5beeb54":"h2GWh","48d6af1225853d44":"6zL6V","9f762329148684":"cvGX9","1ce268781e409df2":"6vIjR"}],"h8old":[function(require,module,exports,__globalThis) {
'use strict';
var store = require("84eeed9891aafe14");
module.exports = function(key, value) {
    return store[key] || (store[key] = value || {});
};

},{"84eeed9891aafe14":"aIhmU"}],"aIhmU":[function(require,module,exports,__globalThis) {
'use strict';
var IS_PURE = require("7b43004672b1879f");
var globalThis = require("bc8329e77dc2c1cc");
var defineGlobalProperty = require("dfb72a1d809f7b02");
var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
(store.versions || (store.versions = [])).push({
    version: '3.39.0',
    mode: IS_PURE ? 'pure' : 'global',
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

},{"7b43004672b1879f":"6KD1D","bc8329e77dc2c1cc":"4naf8","dfb72a1d809f7b02":"lnRSs"}],"6KD1D":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = false;

},{}],"lnRSs":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("2d1c29655635b9ea");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(globalThis, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        globalThis[key] = value;
    }
    return value;
};

},{"2d1c29655635b9ea":"4naf8"}],"h2GWh":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("f5dcaa60a713971f");
var toObject = require("ab17c4f45fcf0841");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"f5dcaa60a713971f":"jsw26","ab17c4f45fcf0841":"gxWv7"}],"gxWv7":[function(require,module,exports,__globalThis) {
'use strict';
var requireObjectCoercible = require("f45a7b5dcdc4a410");
var $Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $Object(requireObjectCoercible(argument));
};

},{"f45a7b5dcdc4a410":"a0P0K"}],"6zL6V":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("5da0fe4507da20a3");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

},{"5da0fe4507da20a3":"jsw26"}],"hwfrY":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("9b4278b13c076bf");
var fails = require("8aee5d88a5f9b6b5");
var createElement = require("1db4d60148afcf21");
// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement('div'), 'a', {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});

},{"9b4278b13c076bf":"ihfdR","8aee5d88a5f9b6b5":"8SraZ","1db4d60148afcf21":"5Nn9T"}],"5Nn9T":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("845bcece0e6d354");
var isObject = require("824df78b2e007250");
var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"845bcece0e6d354":"4naf8","824df78b2e007250":"8iIJm"}],"3IHVb":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("a8753383ef98ee18");
var definePropertyModule = require("189ab650b8f71085");
var createPropertyDescriptor = require("1168c8162aa30435");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"a8753383ef98ee18":"ihfdR","189ab650b8f71085":"4d2AB","1168c8162aa30435":"jtAW3"}],"4d2AB":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("ca50eb9163928400");
var IE8_DOM_DEFINE = require("d482f9e5478795e8");
var V8_PROTOTYPE_DEFINE_BUG = require("b6ad7537efb06f4b");
var anObject = require("16365a73399e7fe7");
var toPropertyKey = require("fab1d366c47796d9");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

},{"ca50eb9163928400":"ihfdR","d482f9e5478795e8":"hwfrY","b6ad7537efb06f4b":"cJYxt","16365a73399e7fe7":"2dEST","fab1d366c47796d9":"9pd5y"}],"cJYxt":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("b22a5a2de93e3ad2");
var fails = require("249a5b857c2dfccd");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

},{"b22a5a2de93e3ad2":"ihfdR","249a5b857c2dfccd":"8SraZ"}],"2dEST":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("2b6c6258a0a6082f");
var $String = String;
var $TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError($String(argument) + ' is not an object');
};

},{"2b6c6258a0a6082f":"8iIJm"}],"jlXZ9":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("99ee13632b3fa68");
var definePropertyModule = require("9ebb3e3004fccc0a");
var makeBuiltIn = require("f10cc812a3094053");
var defineGlobalProperty = require("d354802d852d9c2b");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

},{"99ee13632b3fa68":"37CJl","9ebb3e3004fccc0a":"4d2AB","f10cc812a3094053":"brrqs","d354802d852d9c2b":"lnRSs"}],"brrqs":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("ca84677f1ebd1804");
var fails = require("13360f2842eba261");
var isCallable = require("103e488c0928755a");
var hasOwn = require("cbf9b0e0779cc368");
var DESCRIPTORS = require("3f2eb7efeae2f72b");
var CONFIGURABLE_FUNCTION_NAME = require("548b10f284264c72").CONFIGURABLE;
var inspectSource = require("358f00f3103bd55b");
var InternalStateModule = require("9b2ce14119fd2412");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
    return defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn = module.exports = function makeBuiltIn(value, name, options) {
    if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS) defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && hasOwn(options, 'constructor') && options.constructor) {
            if (DESCRIPTORS) defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

},{"ca84677f1ebd1804":"jsw26","13360f2842eba261":"8SraZ","103e488c0928755a":"37CJl","cbf9b0e0779cc368":"h2GWh","3f2eb7efeae2f72b":"ihfdR","548b10f284264c72":"cE4Pk","358f00f3103bd55b":"hD4ao","9b2ce14119fd2412":"4Dlpx"}],"cE4Pk":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("8ad2bacb0e20b95c");
var hasOwn = require("4eabfd8f83afc9d5");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"8ad2bacb0e20b95c":"ihfdR","4eabfd8f83afc9d5":"h2GWh"}],"hD4ao":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("26e26db98367212e");
var isCallable = require("40ed9a4f6ae66648");
var store = require("485d48d6f4c6739e");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"26e26db98367212e":"jsw26","40ed9a4f6ae66648":"37CJl","485d48d6f4c6739e":"aIhmU"}],"4Dlpx":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_WEAK_MAP = require("d3f0c9f3327b2fd6");
var globalThis = require("28c3574d0c39fe7e");
var isObject = require("f82e6cc0ac249fa5");
var createNonEnumerableProperty = require("c0ae163eea4ef97");
var hasOwn = require("6dea7358344877bb");
var shared = require("3e035a1241da2f0");
var sharedKey = require("88d6ccc27e779e5a");
var hiddenKeys = require("d40b9b3abdbb956e");
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;
var enforce = function enforce(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function set(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function get(it) {
        return store.get(it) || {};
    };
    has = function has(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;
    set = function set(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function get(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function has(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"d3f0c9f3327b2fd6":"akad7","28c3574d0c39fe7e":"4naf8","f82e6cc0ac249fa5":"8iIJm","c0ae163eea4ef97":"3IHVb","6dea7358344877bb":"h2GWh","3e035a1241da2f0":"aIhmU","88d6ccc27e779e5a":"3txZ3","d40b9b3abdbb956e":"9HbEz"}],"akad7":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("8b1a8c1dbfd18eb5");
var isCallable = require("aa77fff8d5ef0565");
var WeakMap = globalThis.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"8b1a8c1dbfd18eb5":"4naf8","aa77fff8d5ef0565":"37CJl"}],"3txZ3":[function(require,module,exports,__globalThis) {
'use strict';
var shared = require("dbc8182adeb8c92f");
var uid = require("90b4ffb58508a6e5");
var keys = shared('keys');
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"dbc8182adeb8c92f":"h8old","90b4ffb58508a6e5":"6zL6V"}],"9HbEz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {};

},{}],"5kBDz":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("d91d786cc71453ce");
var ownKeys = require("88cb809f98beddc6");
var getOwnPropertyDescriptorModule = require("10ea642aad5f7c21");
var definePropertyModule = require("39ff598ce822187e");
module.exports = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

},{"d91d786cc71453ce":"h2GWh","88cb809f98beddc6":"8iAdE","10ea642aad5f7c21":"hRqf9","39ff598ce822187e":"4d2AB"}],"8iAdE":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("3cc1e4329d869e34");
var uncurryThis = require("2b8e77cbdbe3db7a");
var getOwnPropertyNamesModule = require("d703bcb62fcda216");
var getOwnPropertySymbolsModule = require("157674bad2772c6d");
var anObject = require("a09e060b9cae3c6c");
var concat = uncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"3cc1e4329d869e34":"iXpu0","2b8e77cbdbe3db7a":"jsw26","d703bcb62fcda216":"busKr","157674bad2772c6d":"b3HZA","a09e060b9cae3c6c":"2dEST"}],"busKr":[function(require,module,exports,__globalThis) {
'use strict';
var internalObjectKeys = require("6d8591e17a49376c");
var enumBugKeys = require("2c933f93dd98f385");
var hiddenKeys = enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
};

},{"6d8591e17a49376c":"ikyTq","2c933f93dd98f385":"5sgn8"}],"ikyTq":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("363ee0e6bb4f46a7");
var hasOwn = require("3183fe0b0bf6f6ac");
var toIndexedObject = require("28192ac12e934672");
var indexOf = require("a5f9c5d8e993ccd6").indexOf;
var hiddenKeys = require("57775908f1581bc6");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"363ee0e6bb4f46a7":"jsw26","3183fe0b0bf6f6ac":"h2GWh","28192ac12e934672":"gGepo","a5f9c5d8e993ccd6":"pBaPo","57775908f1581bc6":"9HbEz"}],"pBaPo":[function(require,module,exports,__globalThis) {
'use strict';
var toIndexedObject = require("d5dcbcd68ac5acd0");
var toAbsoluteIndex = require("212b13aecfa48226");
var lengthOfArrayLike = require("e5a8b3e1da4c5637");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"d5dcbcd68ac5acd0":"gGepo","212b13aecfa48226":"3itgc","e5a8b3e1da4c5637":"fp6Bt"}],"3itgc":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("72fe0a53ad43912c");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"72fe0a53ad43912c":"wKg8O"}],"wKg8O":[function(require,module,exports,__globalThis) {
'use strict';
var trunc = require("3403cba02b5f61d8");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};

},{"3403cba02b5f61d8":"am6nv"}],"am6nv":[function(require,module,exports,__globalThis) {
'use strict';
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};

},{}],"fp6Bt":[function(require,module,exports,__globalThis) {
'use strict';
var toLength = require("23d9716c54a2ab90");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"23d9716c54a2ab90":"4f0fH"}],"4f0fH":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("c48d3a8b8ac52b0b");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"c48d3a8b8ac52b0b":"wKg8O"}],"5sgn8":[function(require,module,exports,__globalThis) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

},{}],"b3HZA":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"g6zdI":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("10299561ea0c7870");
var isCallable = require("8b1ecdaf59f07210");
var replacement = /#|\.prototype\./;
var isForced = function isForced(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function normalize(string) {
    return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
module.exports = isForced;

},{"10299561ea0c7870":"8SraZ","8b1ecdaf59f07210":"37CJl"}],"ffo0a":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("3e4265f3f6994add");
var $String = String;
module.exports = function(argument) {
    if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $String(argument);
};

},{"3e4265f3f6994add":"7T1aN"}],"7T1aN":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("397e535b3976d304");
var isCallable = require("eebd8012c2d2c3ae");
var classofRaw = require("8da113eeaf06c4ba");
var wellKnownSymbol = require("df252844008f634");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

},{"397e535b3976d304":"khCzU","eebd8012c2d2c3ae":"37CJl","8da113eeaf06c4ba":"fGBNn","df252844008f634":"6dJgl"}],"khCzU":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("6306cd4835715127");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
module.exports = String(test) === '[object z]';

},{"6306cd4835715127":"6dJgl"}],"5ZmqN":[function(require,module,exports,__globalThis) {
'use strict';
/* global ActiveXObject -- old IE, WSH */ var anObject = require("3bbe31d8f504111f");
var definePropertiesModule = require("a9712f03fc468b49");
var enumBugKeys = require("d9e0c389f84efa79");
var hiddenKeys = require("8a43b6a211717cde");
var html = require("78d31e3a50d79c6e");
var documentCreateElement = require("e29f7e32a0583f3");
var sharedKey = require("a6edaba97f293fc9");
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function EmptyConstructor() {};
var scriptTag = function scriptTag(content) {
    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write(scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var JS = 'java' + SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function NullProtoObject1() {
    try {
        activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"3bbe31d8f504111f":"2dEST","a9712f03fc468b49":"1WKFx","d9e0c389f84efa79":"5sgn8","8a43b6a211717cde":"9HbEz","78d31e3a50d79c6e":"kC0aD","e29f7e32a0583f3":"5Nn9T","a6edaba97f293fc9":"3txZ3"}],"1WKFx":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("aa39c539d0a1ec3f");
var V8_PROTOTYPE_DEFINE_BUG = require("2e9118dcee7eb93e");
var definePropertyModule = require("d88f5f00164c2da2");
var anObject = require("12ac356c5e06e57d");
var toIndexedObject = require("3cbdc44082c2f8b8");
var objectKeys = require("634da70e74fce29b");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};

},{"aa39c539d0a1ec3f":"ihfdR","2e9118dcee7eb93e":"cJYxt","d88f5f00164c2da2":"4d2AB","12ac356c5e06e57d":"2dEST","3cbdc44082c2f8b8":"gGepo","634da70e74fce29b":"ahqdT"}],"ahqdT":[function(require,module,exports,__globalThis) {
'use strict';
var internalObjectKeys = require("fb982c683f43ec98");
var enumBugKeys = require("7cabc30df1982d48");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
};

},{"fb982c683f43ec98":"ikyTq","7cabc30df1982d48":"5sgn8"}],"kC0aD":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("14cb391fa4a0dda8");
module.exports = getBuiltIn('document', 'documentElement');

},{"14cb391fa4a0dda8":"iXpu0"}],"hdcmz":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
/* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = require("279dbc8649868a7a");
var toIndexedObject = require("430d7ab8977dd85e");
var $getOwnPropertyNames = require("a5a6278a4291e239").f;
var arraySlice = require("a0e199be640bf61f");
var windowNames = (typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function getWindowNames(it) {
    try {
        return $getOwnPropertyNames(it);
    } catch (error) {
        return arraySlice(windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && classof(it) === 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
};

},{"@swc/helpers/_/_type_of":"668P4","279dbc8649868a7a":"fGBNn","430d7ab8977dd85e":"gGepo","a5a6278a4291e239":"busKr","a0e199be640bf61f":"iIoNC"}],"iIoNC":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("5250b5c9324ccbe");
module.exports = uncurryThis([].slice);

},{"5250b5c9324ccbe":"jsw26"}],"g2LDG":[function(require,module,exports,__globalThis) {
'use strict';
var makeBuiltIn = require("5bd1cd8472955124");
var defineProperty = require("1413185c6323bbbc");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) makeBuiltIn(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) makeBuiltIn(descriptor.set, name, {
        setter: true
    });
    return defineProperty.f(target, name, descriptor);
};

},{"5bd1cd8472955124":"brrqs","1413185c6323bbbc":"4d2AB"}],"ceP3T":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("2e34ececd06658d9");
exports.f = wellKnownSymbol;

},{"2e34ececd06658d9":"6dJgl"}],"9Keq4":[function(require,module,exports,__globalThis) {
'use strict';
var path = require("8d5159b7d317832f");
var hasOwn = require("42a3ea18819bfbb");
var wrappedWellKnownSymbolModule = require("7ec639749e279eeb");
var defineProperty = require("cbbe4becefd5c21c").f;
module.exports = function(NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
        value: wrappedWellKnownSymbolModule.f(NAME)
    });
};

},{"8d5159b7d317832f":"f8NAR","42a3ea18819bfbb":"h2GWh","7ec639749e279eeb":"ceP3T","cbbe4becefd5c21c":"4d2AB"}],"f8NAR":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("34c09090b9638032");
module.exports = globalThis;

},{"34c09090b9638032":"4naf8"}],"fmflI":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("b56ca5a55bb4c0e1");
var getBuiltIn = require("f5359b167e9be384");
var wellKnownSymbol = require("e7eef3415c62682d");
var defineBuiltIn = require("8cc59229c8e85f40");
module.exports = function() {
    var Symbol = getBuiltIn('Symbol');
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return call(valueOf, this);
    }, {
        arity: 1
    });
};

},{"b56ca5a55bb4c0e1":"ebTVd","f5359b167e9be384":"iXpu0","e7eef3415c62682d":"6dJgl","8cc59229c8e85f40":"jlXZ9"}],"3q5sA":[function(require,module,exports,__globalThis) {
'use strict';
var defineProperty = require("93a3d85da48077c").f;
var hasOwn = require("2ebf7179e87d878f");
var wellKnownSymbol = require("5b1eb5d1639e9eb7");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

},{"93a3d85da48077c":"4d2AB","2ebf7179e87d878f":"h2GWh","5b1eb5d1639e9eb7":"6dJgl"}],"giEdW":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("13e0747865316a42");
var uncurryThis = require("99224cc18a4a792e");
var IndexedObject = require("57aaeabd9d30911");
var toObject = require("3acffc809f3b03fb");
var lengthOfArrayLike = require("1fc4c4e55871562c");
var arraySpeciesCreate = require("76c922b575fbf7bd");
var push = uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self = IndexedObject(O);
        var length = lengthOfArrayLike(self);
        var boundFunction = bind(callbackfn, that);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
};

},{"13e0747865316a42":"7xEW7","99224cc18a4a792e":"jsw26","57aaeabd9d30911":"dnbS6","3acffc809f3b03fb":"gxWv7","1fc4c4e55871562c":"fp6Bt","76c922b575fbf7bd":"ai7Xg"}],"7xEW7":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("92f6f475baa85665");
var aCallable = require("547ee4f9dab0cc76");
var NATIVE_BIND = require("5acd31cba656d393");
var bind = uncurryThis(uncurryThis.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

},{"92f6f475baa85665":"kBsBX","547ee4f9dab0cc76":"ehOyc","5acd31cba656d393":"hQNpA"}],"kBsBX":[function(require,module,exports,__globalThis) {
'use strict';
var classofRaw = require("8e77093015e1e67f");
var uncurryThis = require("9daa4dbbca634c9e");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

},{"8e77093015e1e67f":"fGBNn","9daa4dbbca634c9e":"jsw26"}],"ai7Xg":[function(require,module,exports,__globalThis) {
'use strict';
var arraySpeciesConstructor = require("4580767bbbe40f0b");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

},{"4580767bbbe40f0b":"1IwHR"}],"1IwHR":[function(require,module,exports,__globalThis) {
'use strict';
var isArray = require("a9e5b9af57e551f6");
var isConstructor = require("2b4d84c184e08f4f");
var isObject = require("f4bec83e8d6008c9");
var wellKnownSymbol = require("4a13cf47b259a825");
var SPECIES = wellKnownSymbol('species');
var $Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $Array : C;
};

},{"a9e5b9af57e551f6":"9wuMi","2b4d84c184e08f4f":"2hXCr","f4bec83e8d6008c9":"8iIJm","4a13cf47b259a825":"6dJgl"}],"9wuMi":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("ccb261b2d73a4fca");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return classof(argument) === 'Array';
};

},{"ccb261b2d73a4fca":"fGBNn"}],"2hXCr":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("3b3e7fa8cfe4b3ac");
var fails = require("84df2127d2d40501");
var isCallable = require("ae35eceee587c4bc");
var classof = require("7bd40df22601ee7e");
var getBuiltIn = require("271ff92378cbc486");
var inspectSource = require("74840ba4357c1c30");
var noop = function noop() {};
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"3b3e7fa8cfe4b3ac":"jsw26","84df2127d2d40501":"8SraZ","ae35eceee587c4bc":"37CJl","7bd40df22601ee7e":"7T1aN","271ff92378cbc486":"iXpu0","74840ba4357c1c30":"hD4ao"}],"5KXvw":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5bb0291a1de27cc2");
var getBuiltIn = require("8e0d0366f8700097");
var hasOwn = require("1d19a51e347c2d9e");
var toString = require("eab6cb58642f38b1");
var shared = require("41937bc543544e22");
var NATIVE_SYMBOL_REGISTRY = require("8877198f0deded1d");
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({
    target: 'Symbol',
    stat: true,
    forced: !NATIVE_SYMBOL_REGISTRY
}, {
    'for': function(key) {
        var string = toString(key);
        if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = getBuiltIn('Symbol')(string);
        StringToSymbolRegistry[string] = symbol;
        SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

},{"5bb0291a1de27cc2":"gD2TP","8e0d0366f8700097":"iXpu0","1d19a51e347c2d9e":"h2GWh","eab6cb58642f38b1":"ffo0a","41937bc543544e22":"h8old","8877198f0deded1d":"3tldI"}],"3tldI":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_SYMBOL = require("a735884940a2eb73");
/* eslint-disable es/no-symbol -- safe */ module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;

},{"a735884940a2eb73":"cvGX9"}],"5BXaq":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("8dbad7485118eaf8");
var hasOwn = require("9fce8a9af4b186a4");
var isSymbol = require("4e16fd56c67f82fb");
var tryToString = require("59b7b3dea7d1b71d");
var shared = require("77b2ea800463b7d6");
var NATIVE_SYMBOL_REGISTRY = require("ca42326fb3cb6e68");
var SymbolToStringRegistry = shared('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({
    target: 'Symbol',
    stat: true,
    forced: !NATIVE_SYMBOL_REGISTRY
}, {
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
        if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
    }
});

},{"8dbad7485118eaf8":"gD2TP","9fce8a9af4b186a4":"h2GWh","4e16fd56c67f82fb":"g5d9N","59b7b3dea7d1b71d":"b8XMV","77b2ea800463b7d6":"h8old","ca42326fb3cb6e68":"3tldI"}],"3ydPO":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("c758539029f56af9");
var getBuiltIn = require("cd08b356bcae0b47");
var apply = require("2f13fa715711850");
var call = require("4cfb95fb9a0e28fc");
var uncurryThis = require("50b40a77c21daf7f");
var fails = require("56cf5d4bc1afd666");
var isCallable = require("42bed86e3e73f3d2");
var isSymbol = require("bca8b9ce5f71243b");
var arraySlice = require("1bb05f05134df4c2");
var getReplacerFunction = require("1136e300bbee8f1e");
var NATIVE_SYMBOL = require("d8156a48adf3010b");
var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function() {
    var symbol = getBuiltIn('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $stringify([
        symbol
    ]) !== '[null]' || $stringify({
        a: symbol
    }) !== '{}' || $stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function() {
    return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
});
var stringifyWithSymbolsFix = function stringifyWithSymbolsFix(it, replacer) {
    var args = arraySlice(arguments);
    var $replacer = getReplacerFunction(replacer);
    if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
        if (!isSymbol(value)) return value;
    };
    return apply($stringify, null, args);
};
var fixIllFormed = function fixIllFormed(match, offset, string) {
    var prev = charAt(string, offset - 1);
    var next = charAt(string, offset + 1);
    if (exec(low, match) && !exec(hi, next) || exec(hi, match) && !exec(low, prev)) return '\\u' + numberToString(charCodeAt(match, 0), 16);
    return match;
};
if ($stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = arraySlice(arguments);
        var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
        return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
});

},{"c758539029f56af9":"gD2TP","cd08b356bcae0b47":"iXpu0","2f13fa715711850":"kuGqn","4cfb95fb9a0e28fc":"ebTVd","50b40a77c21daf7f":"jsw26","56cf5d4bc1afd666":"8SraZ","42bed86e3e73f3d2":"37CJl","bca8b9ce5f71243b":"g5d9N","1bb05f05134df4c2":"iIoNC","1136e300bbee8f1e":"fYaYC","d8156a48adf3010b":"cvGX9"}],"kuGqn":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var NATIVE_BIND = require("d07466971ded2aca");
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = (typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{"@swc/helpers/_/_type_of":"668P4","d07466971ded2aca":"hQNpA"}],"fYaYC":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("d58a1810bb01cb9f");
var isArray = require("fc692ad896e8fbbf");
var isCallable = require("78f870626b97cbe9");
var classof = require("1da5109b0acae5a0");
var toString = require("71deb4f6b3f33cf0");
var push = uncurryThis([].push);
module.exports = function(replacer) {
    if (isCallable(replacer)) return replacer;
    if (!isArray(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') push(keys, element);
        else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if (isArray(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

},{"d58a1810bb01cb9f":"jsw26","fc692ad896e8fbbf":"9wuMi","78f870626b97cbe9":"37CJl","1da5109b0acae5a0":"fGBNn","71deb4f6b3f33cf0":"ffo0a"}],"fEuZH":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("840946d70e8a2143");
var NATIVE_SYMBOL = require("ab5e4f7a7726b049");
var fails = require("dbf1e55f293c4447");
var getOwnPropertySymbolsModule = require("52dfb60ffa243118");
var toObject = require("7dd92ded8a0ad49a");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function() {
    getOwnPropertySymbolsModule.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({
    target: 'Object',
    stat: true,
    forced: FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
    }
});

},{"840946d70e8a2143":"gD2TP","ab5e4f7a7726b049":"cvGX9","dbf1e55f293c4447":"8SraZ","52dfb60ffa243118":"b3HZA","7dd92ded8a0ad49a":"gxWv7"}],"frtRG":[function(require,module,exports,__globalThis) {
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';
var $ = require("97b172d75b2d24d2");
var DESCRIPTORS = require("f4d7d8fd842c0756");
var globalThis = require("5eee5f2c9436b192");
var uncurryThis = require("3168cbf7cd0b9882");
var hasOwn = require("a16d92d5b8266639");
var isCallable = require("c20ab10c7fc8df3c");
var isPrototypeOf = require("f1577de30367373a");
var toString = require("a801f47d1f3aec6");
var defineBuiltInAccessor = require("4040e115390d9ece");
var copyConstructorProperties = require("76bfc13417714c00");
var NativeSymbol = globalThis.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) || // Safari 12 bug
NativeSymbol().description !== undefined)) {
    var EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
        var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
        if (description === '') EmptyStringDescriptionStore[result] = true;
        return result;
    };
    copyConstructorProperties(SymbolWrapper, NativeSymbol);
    SymbolWrapper.prototype = SymbolPrototype;
    SymbolPrototype.constructor = SymbolWrapper;
    var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
    var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
    var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
    var regexp = /^Symbol\((.*)\)[^)]+$/;
    var replace = uncurryThis(''.replace);
    var stringSlice = uncurryThis(''.slice);
    defineBuiltInAccessor(SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = thisSymbolValue(this);
            if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
            var string = symbolDescriptiveString(symbol);
            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: SymbolWrapper
    });
}

},{"97b172d75b2d24d2":"gD2TP","f4d7d8fd842c0756":"ihfdR","5eee5f2c9436b192":"4naf8","3168cbf7cd0b9882":"jsw26","a16d92d5b8266639":"h2GWh","c20ab10c7fc8df3c":"37CJl","f1577de30367373a":"fVGN3","a801f47d1f3aec6":"ffo0a","4040e115390d9ece":"g2LDG","76bfc13417714c00":"5kBDz"}],"dqNG3":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("2d360c40368e9a3");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');

},{"2d360c40368e9a3":"9Keq4"}],"YEkxs":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("81bebfae66866813");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');

},{"81bebfae66866813":"9Keq4"}],"Q8JET":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("ccf6a8a73e56cd3a");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');

},{"ccf6a8a73e56cd3a":"9Keq4"}],"cZRFB":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("1c415af53b28a6ea");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

},{"1c415af53b28a6ea":"9Keq4"}],"1abPC":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("d4aa350c591898c3");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');

},{"d4aa350c591898c3":"9Keq4"}],"6qr1U":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("120ed8f933c050ae");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');

},{"120ed8f933c050ae":"9Keq4"}],"bQFAO":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("e61fe26d945e7ea9");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');

},{"e61fe26d945e7ea9":"9Keq4"}],"88T64":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("9202fdf8a23f6674");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');

},{"9202fdf8a23f6674":"9Keq4"}],"Y720e":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("75b48d0f3b5ea4e1");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');

},{"75b48d0f3b5ea4e1":"9Keq4"}],"h4SxC":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("66e19094d20833e6");
var defineSymbolToPrimitive = require("24c2fb6481a71c59");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

},{"66e19094d20833e6":"9Keq4","24c2fb6481a71c59":"fmflI"}],"flK7u":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("79fc56cab59273aa");
var defineWellKnownSymbol = require("f48b67430238cd9f");
var setToStringTag = require("94b18c3989610f3b");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');

},{"79fc56cab59273aa":"iXpu0","f48b67430238cd9f":"9Keq4","94b18c3989610f3b":"3q5sA"}],"1zhDF":[function(require,module,exports,__globalThis) {
'use strict';
var defineWellKnownSymbol = require("37a7f6188e0dd54c");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');

},{"37a7f6188e0dd54c":"9Keq4"}],"8RGhQ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ae9bcc3c886d2e43");
var fails = require("320b7f8f99977d72");
var isArray = require("c9c4d35908c64a9b");
var isObject = require("e40ffb4fd8cdd6ef");
var toObject = require("600c6b55241cb08d");
var lengthOfArrayLike = require("c35064fc908d412e");
var doesNotExceedSafeInteger = require("d3e233a6dd5508d7");
var createProperty = require("4da7fb5e70719532");
var arraySpeciesCreate = require("706ee6e3130d3c44");
var arrayMethodHasSpeciesSupport = require("76c3a5d37e98bd2f");
var wellKnownSymbol = require("210a9ec1468bd8f4");
var V8_VERSION = require("64448af9c74a3ff5");
var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var isConcatSpreadable = function isConcatSpreadable(O) {
    if (!isObject(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray(O);
};
var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = toObject(this);
        var A = arraySpeciesCreate(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if (isConcatSpreadable(E)) {
                len = lengthOfArrayLike(E);
                doesNotExceedSafeInteger(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
            } else {
                doesNotExceedSafeInteger(n + 1);
                createProperty(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

},{"ae9bcc3c886d2e43":"gD2TP","320b7f8f99977d72":"8SraZ","c9c4d35908c64a9b":"9wuMi","e40ffb4fd8cdd6ef":"8iIJm","600c6b55241cb08d":"gxWv7","c35064fc908d412e":"fp6Bt","d3e233a6dd5508d7":"h7wyy","4da7fb5e70719532":"Xwqbj","706ee6e3130d3c44":"ai7Xg","76c3a5d37e98bd2f":"7AF65","210a9ec1468bd8f4":"6dJgl","64448af9c74a3ff5":"7Fmxi"}],"h7wyy":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
    return it;
};

},{}],"Xwqbj":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("667a2d5a858194a6");
var definePropertyModule = require("2daa2f41b7310fd4");
var createPropertyDescriptor = require("7bb9efd811e3f83f");
module.exports = function(object, key, value) {
    if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
    else object[key] = value;
};

},{"667a2d5a858194a6":"ihfdR","2daa2f41b7310fd4":"4d2AB","7bb9efd811e3f83f":"jtAW3"}],"7AF65":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("bbe4de7ca7a1c6be");
var wellKnownSymbol = require("6cb3e4ca309911dc");
var V8_VERSION = require("4d1dd9e6baf7a81f");
var SPECIES = wellKnownSymbol('species');
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION >= 51 || !fails(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

},{"bbe4de7ca7a1c6be":"8SraZ","6cb3e4ca309911dc":"6dJgl","4d1dd9e6baf7a81f":"7Fmxi"}],"dFDn6":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("4890937a7e7c636b");
var copyWithin = require("7256897b95da01b3");
var addToUnscopables = require("4c4cc4b0d9ea98ec");
// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({
    target: 'Array',
    proto: true
}, {
    copyWithin: copyWithin
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');

},{"4890937a7e7c636b":"gD2TP","7256897b95da01b3":"3LfXK","4c4cc4b0d9ea98ec":"hq1ko"}],"3LfXK":[function(require,module,exports,__globalThis) {
'use strict';
var toObject = require("67e19c72f7fbebd0");
var toAbsoluteIndex = require("5063d303bf924d87");
var lengthOfArrayLike = require("e3d01b6d6197aedd");
var deletePropertyOrThrow = require("6ffaf2643c0abf62");
var min = Math.min;
// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var to = toAbsoluteIndex(target, len);
    var from = toAbsoluteIndex(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
        to += inc;
        from += inc;
    }
    return O;
};

},{"67e19c72f7fbebd0":"gxWv7","5063d303bf924d87":"3itgc","e3d01b6d6197aedd":"fp6Bt","6ffaf2643c0abf62":"ieW8l"}],"ieW8l":[function(require,module,exports,__globalThis) {
'use strict';
var tryToString = require("49f65044bb4dad7f");
var $TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

},{"49f65044bb4dad7f":"b8XMV"}],"hq1ko":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("d4032cdcc50314e7");
var create = require("3ca2a6909ac2dcef");
var defineProperty = require("545ab457bf71d338").f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"d4032cdcc50314e7":"6dJgl","3ca2a6909ac2dcef":"5ZmqN","545ab457bf71d338":"4d2AB"}],"1sfLZ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("52cb142d804aabd3");
var fill = require("daf335b8230cfcc7");
var addToUnscopables = require("3e31c661bed82a2d");
// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({
    target: 'Array',
    proto: true
}, {
    fill: fill
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

},{"52cb142d804aabd3":"gD2TP","daf335b8230cfcc7":"453wW","3e31c661bed82a2d":"hq1ko"}],"453wW":[function(require,module,exports,__globalThis) {
'use strict';
var toObject = require("45e35cf118865951");
var toAbsoluteIndex = require("ae17acf5d72570ed");
var lengthOfArrayLike = require("94aaef7256431b15");
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = toObject(this);
    var length = lengthOfArrayLike(O);
    var argumentsLength = arguments.length;
    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

},{"45e35cf118865951":"gxWv7","ae17acf5d72570ed":"3itgc","94aaef7256431b15":"fp6Bt"}],"e5Mkj":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("a465bc55e057d26f");
var $filter = require("fa9926c68c33923f").filter;
var arrayMethodHasSpeciesSupport = require("9232c94be2f9c639");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"a465bc55e057d26f":"gD2TP","fa9926c68c33923f":"giEdW","9232c94be2f9c639":"7AF65"}],"6LHE7":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("a6cb3a492b52d21c");
var $find = require("ad97e1511b32e588").find;
var addToUnscopables = require("62fd950aac3d5249");
var FIND = 'find';
var SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

},{"a6cb3a492b52d21c":"gD2TP","ad97e1511b32e588":"giEdW","62fd950aac3d5249":"hq1ko"}],"352xl":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("dcce3e96aeb32c26");
var $findIndex = require("25f2fe0b92321096").findIndex;
var addToUnscopables = require("1c93cc746ac8ffb1");
var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

},{"dcce3e96aeb32c26":"gD2TP","25f2fe0b92321096":"giEdW","1c93cc746ac8ffb1":"hq1ko"}],"gEzC0":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("eea83811f9bf5b44");
var flattenIntoArray = require("d9157408980dcae4");
var toObject = require("1603b1d7d71c6d78");
var lengthOfArrayLike = require("95d7017c9e9cedeb");
var toIntegerOrInfinity = require("9b0770c8bd20c0f9");
var arraySpeciesCreate = require("4c36764bcb49234f");
// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({
    target: 'Array',
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = toObject(this);
        var sourceLen = lengthOfArrayLike(O);
        var A = arraySpeciesCreate(O, 0);
        A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
        return A;
    }
});

},{"eea83811f9bf5b44":"gD2TP","d9157408980dcae4":"5eaCa","1603b1d7d71c6d78":"gxWv7","95d7017c9e9cedeb":"fp6Bt","9b0770c8bd20c0f9":"wKg8O","4c36764bcb49234f":"ai7Xg"}],"5eaCa":[function(require,module,exports,__globalThis) {
'use strict';
var isArray = require("ebb82f00ac94e25c");
var lengthOfArrayLike = require("d2ce61b77ec49b3f");
var doesNotExceedSafeInteger = require("d3f4210cd620e3d6");
var bind = require("a7c8b8651480c6c9");
// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function flattenIntoArray1(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? bind(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && isArray(element)) {
                elementLen = lengthOfArrayLike(element);
                targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                doesNotExceedSafeInteger(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
module.exports = flattenIntoArray;

},{"ebb82f00ac94e25c":"9wuMi","d2ce61b77ec49b3f":"fp6Bt","d3f4210cd620e3d6":"h7wyy","a7c8b8651480c6c9":"7xEW7"}],"76irp":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e4ee3b9d2bc1ffb2");
var flattenIntoArray = require("378c1e23131cdaae");
var aCallable = require("74e7f70118e2a778");
var toObject = require("1a2d0561d09775b8");
var lengthOfArrayLike = require("f7bbb0ab5ee7446c");
var arraySpeciesCreate = require("51d35c0066e59cdb");
// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({
    target: 'Array',
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = toObject(this);
        var sourceLen = lengthOfArrayLike(O);
        var A;
        aCallable(callbackfn);
        A = arraySpeciesCreate(O, 0);
        A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});

},{"e4ee3b9d2bc1ffb2":"gD2TP","378c1e23131cdaae":"5eaCa","74e7f70118e2a778":"ehOyc","1a2d0561d09775b8":"gxWv7","f7bbb0ab5ee7446c":"fp6Bt","51d35c0066e59cdb":"ai7Xg"}],"fuEh6":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("76f1b3b688a029fa");
var from = require("55358907c05b685d");
var checkCorrectnessOfIteration = require("98fd99047e51c8be");
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({
    target: 'Array',
    stat: true,
    forced: INCORRECT_ITERATION
}, {
    from: from
});

},{"76f1b3b688a029fa":"gD2TP","55358907c05b685d":"bnqz2","98fd99047e51c8be":"21ceT"}],"bnqz2":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("c006aee3ec90867f");
var call = require("bdaed06b86eeb767");
var toObject = require("ca05db7523b31410");
var callWithSafeIterationClosing = require("47fe223c8f6c2dd5");
var isArrayIteratorMethod = require("75eba7673a242ae6");
var isConstructor = require("188dc0b37c140076");
var lengthOfArrayLike = require("32c4effc8b33b2c2");
var createProperty = require("a6ed280c439df9d0");
var getIterator = require("3faaa09a63a90825");
var getIteratorMethod = require("13cbec27e4dd055f");
var $Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = toObject(arrayLike);
    var IS_CONSTRUCTOR = isConstructor(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = getIteratorMethod(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = getIterator(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = call(next, iterator)).done; index++){
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            createProperty(result, index, value);
        }
    } else {
        length = lengthOfArrayLike(O);
        result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty(result, index, value);
        }
    }
    result.length = index;
    return result;
};

},{"c006aee3ec90867f":"7xEW7","bdaed06b86eeb767":"ebTVd","ca05db7523b31410":"gxWv7","47fe223c8f6c2dd5":"8XN57","75eba7673a242ae6":"8FXTb","188dc0b37c140076":"2hXCr","32c4effc8b33b2c2":"fp6Bt","a6ed280c439df9d0":"Xwqbj","3faaa09a63a90825":"cAVpj","13cbec27e4dd055f":"lf0Zm"}],"8XN57":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("4afbb4be48dcf066");
var iteratorClose = require("d24fa1ffea48fa52");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (error) {
        iteratorClose(iterator, 'throw', error);
    }
};

},{"4afbb4be48dcf066":"2dEST","d24fa1ffea48fa52":"cxu35"}],"cxu35":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("a4a3a7d4a45c4219");
var anObject = require("feb876e7da2df7bd");
var getMethod = require("2e660cdfabd9c61f");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);
    try {
        innerResult = getMethod(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = call(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    anObject(innerResult);
    return value;
};

},{"a4a3a7d4a45c4219":"ebTVd","feb876e7da2df7bd":"2dEST","2e660cdfabd9c61f":"b2lgj"}],"8FXTb":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("85b004b6ab4bc5da");
var Iterators = require("6de391ad2976ca02");
var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"85b004b6ab4bc5da":"6dJgl","6de391ad2976ca02":"3N1ND"}],"3N1ND":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {};

},{}],"cAVpj":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("132ebf774107ae29");
var aCallable = require("e248489b4825ceb7");
var anObject = require("18a343d2ef625577");
var tryToString = require("7e576a1564cef99e");
var getIteratorMethod = require("4a7b0311be0471b2");
var $TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
    throw new $TypeError(tryToString(argument) + ' is not iterable');
};

},{"132ebf774107ae29":"ebTVd","e248489b4825ceb7":"ehOyc","18a343d2ef625577":"2dEST","7e576a1564cef99e":"b8XMV","4a7b0311be0471b2":"lf0Zm"}],"lf0Zm":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("32d61dafd81dde78");
var getMethod = require("84e24a6ac7559d3a");
var isNullOrUndefined = require("f0707282c0d93eeb");
var Iterators = require("1c181d5c49efd5d1");
var wellKnownSymbol = require("d10d0e0ae49498c5");
var ITERATOR = wellKnownSymbol('iterator');
module.exports = function(it) {
    if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
};

},{"32d61dafd81dde78":"7T1aN","84e24a6ac7559d3a":"b2lgj","f0707282c0d93eeb":"9lebS","1c181d5c49efd5d1":"3N1ND","d10d0e0ae49498c5":"6dJgl"}],"21ceT":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("a5154de5c7fcf21e");
var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;
try {
    var called = 0;
    var iteratorWithReturn = {
        next: function next() {
            return {
                done: !!called++
            };
        },
        'return': function() {
            SAFE_CLOSING = true;
        }
    };
    iteratorWithReturn[ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from(iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

},{"a5154de5c7fcf21e":"6dJgl"}],"3DkDJ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ffa5d46bdab873f9");
var $includes = require("abe71b6f5a2c149").includes;
var fails = require("119354898116a770");
var addToUnscopables = require("9a828f869e1adf81");
// FF99+ bug
var BROKEN_ON_SPARSE = fails(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({
    target: 'Array',
    proto: true,
    forced: BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

},{"ffa5d46bdab873f9":"gD2TP","abe71b6f5a2c149":"pBaPo","119354898116a770":"8SraZ","9a828f869e1adf81":"hq1ko"}],"6J6Pu":[function(require,module,exports,__globalThis) {
'use strict';
var toIndexedObject = require("c8e067881939a0cb");
var addToUnscopables = require("275b8f0cb65b77aa");
var Iterators = require("21f4d3653c90f049");
var InternalStateModule = require("85efa8d5848315f6");
var defineProperty = require("94a17682acfdceb4").f;
var defineIterator = require("bb30bdef31147b17");
var createIterResultObject = require("d8384af5151f994c");
var IS_PURE = require("fdcc207797f592fe");
var DESCRIPTORS = require("11e42ff2bbda8d0a");
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function(iterated, kind) {
    setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return createIterResultObject(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return createIterResultObject(index, false);
        case 'values':
            return createIterResultObject(target[index], false);
    }
    return createIterResultObject([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
    defineProperty(values, 'name', {
        value: 'values'
    });
} catch (error) {}

},{"c8e067881939a0cb":"gGepo","275b8f0cb65b77aa":"hq1ko","21f4d3653c90f049":"3N1ND","85efa8d5848315f6":"4Dlpx","94a17682acfdceb4":"4d2AB","bb30bdef31147b17":"cMggn","d8384af5151f994c":"2q5E9","fdcc207797f592fe":"6KD1D","11e42ff2bbda8d0a":"ihfdR"}],"cMggn":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("923c1bf4a39ae90c");
var call = require("46a3f73465955199");
var IS_PURE = require("c1577e63189cf935");
var FunctionName = require("dc625e1bb584faf6");
var isCallable = require("d55d91c410baca17");
var createIteratorConstructor = require("3e4ae607dbb6e78b");
var getPrototypeOf = require("48ca4ae1d4998232");
var setPrototypeOf = require("1263258b63630933");
var setToStringTag = require("9b61caf69f87dfde");
var createNonEnumerableProperty = require("7f30a3ab1bf5e1c1");
var defineBuiltIn = require("c027b4da648348d3");
var wellKnownSymbol = require("d4ad91965213ee1");
var Iterators = require("b616a206eb405268");
var IteratorsCore = require("4f9ec7e9f5d20965");
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis = function returnThis() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return call(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
        } else $({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    Iterators[NAME] = defaultIterator;
    return methods;
};

},{"923c1bf4a39ae90c":"gD2TP","46a3f73465955199":"ebTVd","c1577e63189cf935":"6KD1D","dc625e1bb584faf6":"cE4Pk","d55d91c410baca17":"37CJl","3e4ae607dbb6e78b":"gNdyA","48ca4ae1d4998232":"lFnuf","1263258b63630933":"hmY3h","9b61caf69f87dfde":"3q5sA","7f30a3ab1bf5e1c1":"3IHVb","c027b4da648348d3":"jlXZ9","d4ad91965213ee1":"6dJgl","b616a206eb405268":"3N1ND","4f9ec7e9f5d20965":"9S88x"}],"gNdyA":[function(require,module,exports,__globalThis) {
'use strict';
var IteratorPrototype = require("6d3197d79123a33d").IteratorPrototype;
var create = require("f19338a88747fb05");
var createPropertyDescriptor = require("cc176dfbf6ea0553");
var setToStringTag = require("bc433e6ab6880430");
var Iterators = require("2f833e0e1738e7e0");
var returnThis = function returnThis() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = create(IteratorPrototype, {
        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
};

},{"6d3197d79123a33d":"9S88x","f19338a88747fb05":"5ZmqN","cc176dfbf6ea0553":"jtAW3","bc433e6ab6880430":"3q5sA","2f833e0e1738e7e0":"3N1ND"}],"9S88x":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("cdb9dcd93b52b3fc");
var isCallable = require("db955145706fc55a");
var isObject = require("83e5df3d56e8834f");
var create = require("45d6f1a3c372cdf6");
var getPrototypeOf = require("a97459767d74fdc3");
var defineBuiltIn = require("3bdf78f362001d7c");
var wellKnownSymbol = require("d3901e60df7842c9");
var IS_PURE = require("e736fd193ddc96e5");
var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
    else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function() {
    var test = {};
    // FF44- legacy iterators case
    return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) defineBuiltIn(IteratorPrototype, ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"cdb9dcd93b52b3fc":"8SraZ","db955145706fc55a":"37CJl","83e5df3d56e8834f":"8iIJm","45d6f1a3c372cdf6":"5ZmqN","a97459767d74fdc3":"lFnuf","3bdf78f362001d7c":"jlXZ9","d3901e60df7842c9":"6dJgl","e736fd193ddc96e5":"6KD1D"}],"lFnuf":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("da54a59ea207dd");
var isCallable = require("71ab2a7bcc8c8fc8");
var toObject = require("7a3afd2bb40b0292");
var sharedKey = require("296d7a2db8e23969");
var CORRECT_PROTOTYPE_GETTER = require("58de29d5e883862f");
var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object ? ObjectPrototype : null;
};

},{"da54a59ea207dd":"h2GWh","71ab2a7bcc8c8fc8":"37CJl","7a3afd2bb40b0292":"gxWv7","296d7a2db8e23969":"3txZ3","58de29d5e883862f":"7WzpM"}],"7WzpM":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("85ffc28af2e8afc1");
module.exports = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"85ffc28af2e8afc1":"8SraZ"}],"hmY3h":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable no-proto -- safe */ var uncurryThisAccessor = require("995a94425a563d6");
var isObject = require("caa27fe2635f1f44");
var requireObjectCoercible = require("a751660a0fcdf70");
var aPossiblePrototype = require("6e2c833ee2a62cf6");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        requireObjectCoercible(O);
        aPossiblePrototype(proto);
        if (!isObject(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

},{"995a94425a563d6":"ibG0L","caa27fe2635f1f44":"8iIJm","a751660a0fcdf70":"a0P0K","6e2c833ee2a62cf6":"bqV2q"}],"ibG0L":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("27a2d181325e1926");
var aCallable = require("36b26076b1e2fac1");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

},{"27a2d181325e1926":"jsw26","36b26076b1e2fac1":"ehOyc"}],"bqV2q":[function(require,module,exports,__globalThis) {
'use strict';
var isPossiblePrototype = require("fcc5bbb526d602c6");
var $String = String;
var $TypeError = TypeError;
module.exports = function(argument) {
    if (isPossiblePrototype(argument)) return argument;
    throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

},{"fcc5bbb526d602c6":"4AmzI"}],"4AmzI":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("a504c97d35bacd6c");
module.exports = function(argument) {
    return isObject(argument) || argument === null;
};

},{"a504c97d35bacd6c":"8iIJm"}],"2q5E9":[function(require,module,exports,__globalThis) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

},{}],"gMeOj":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1fd3a81d59354079");
var uncurryThis = require("878a42cfd07db75d");
var IndexedObject = require("c417af28e9abb2b");
var toIndexedObject = require("cdcc2dbc58a28c02");
var arrayMethodIsStrict = require("733e226e143494d1");
var nativeJoin = uncurryThis([].join);
var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({
    target: 'Array',
    proto: true,
    forced: FORCED
}, {
    join: function join(separator) {
        return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
    }
});

},{"1fd3a81d59354079":"gD2TP","878a42cfd07db75d":"jsw26","c417af28e9abb2b":"dnbS6","cdcc2dbc58a28c02":"gGepo","733e226e143494d1":"gl0vh"}],"gl0vh":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("77f0d106558781f");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && fails(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

},{"77f0d106558781f":"8SraZ"}],"czAZJ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5fce1361821ac187");
var $map = require("a7a3b0905c6ea58c").map;
var arrayMethodHasSpeciesSupport = require("869912db050ffcc6");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"5fce1361821ac187":"gD2TP","a7a3b0905c6ea58c":"giEdW","869912db050ffcc6":"7AF65"}],"cZvLO":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("c49bbaeadf669473");
var fails = require("2b7c23018838f50");
var isConstructor = require("5ca03f92538fd001");
var createProperty = require("d87cf2a2bcbb5c2c");
var $Array = Array;
var ISNT_GENERIC = fails(function() {
    function F() {}
    // eslint-disable-next-line es/no-array-of -- safe
    return !($Array.of.call(F) instanceof F);
});
// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$({
    target: 'Array',
    stat: true,
    forced: ISNT_GENERIC
}, {
    of: function of() {
        var index = 0;
        var argumentsLength = arguments.length;
        var result = new (isConstructor(this) ? this : $Array)(argumentsLength);
        while(argumentsLength > index)createProperty(result, index, arguments[index++]);
        result.length = argumentsLength;
        return result;
    }
});

},{"c49bbaeadf669473":"gD2TP","2b7c23018838f50":"8SraZ","5ca03f92538fd001":"2hXCr","d87cf2a2bcbb5c2c":"Xwqbj"}],"lIfM1":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f4626508f1e86a5e");
var isArray = require("c55f884cac32042");
var isConstructor = require("c7ab28f7c42930d4");
var isObject = require("d62f4c68d4a29c88");
var toAbsoluteIndex = require("598be77178793bf1");
var lengthOfArrayLike = require("f9b9299dc750b2dd");
var toIndexedObject = require("ff620c60ded20435");
var createProperty = require("49168568b59df51b");
var wellKnownSymbol = require("f02f140688adf449");
var arrayMethodHasSpeciesSupport = require("eb9bbc0536d1f202");
var nativeSlice = require("88cb1064f5f88f9e");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = toIndexedObject(this);
        var length = lengthOfArrayLike(O);
        var k = toAbsoluteIndex(start, length);
        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if (isArray(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) Constructor = undefined;
            else if (isObject(Constructor)) {
                Constructor = Constructor[SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $Array || Constructor === undefined) return nativeSlice(O, k, fin);
        }
        result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
        result.length = n;
        return result;
    }
});

},{"f4626508f1e86a5e":"gD2TP","c55f884cac32042":"9wuMi","c7ab28f7c42930d4":"2hXCr","d62f4c68d4a29c88":"8iIJm","598be77178793bf1":"3itgc","f9b9299dc750b2dd":"fp6Bt","ff620c60ded20435":"gGepo","49168568b59df51b":"Xwqbj","f02f140688adf449":"6dJgl","eb9bbc0536d1f202":"7AF65","88cb1064f5f88f9e":"iIoNC"}],"aRnSS":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("bcbafe2730da3578");
var uncurryThis = require("45fd6781824a0ecc");
var aCallable = require("227e835045b72b76");
var toObject = require("d460a9dbedc2e639");
var lengthOfArrayLike = require("eb5d266a4b580e05");
var deletePropertyOrThrow = require("ab9af39e90a45cab");
var toString = require("2874e3c4ed670355");
var fails = require("b077ecec4e3b8790");
var internalSort = require("b1c0993c5b4a0232");
var arrayMethodIsStrict = require("fc67c1f531962716");
var FF = require("5463fbeb0c308d9");
var IE_OR_EDGE = require("44ffda3b5c0f4b25");
var V8 = require("f9fbdc3cf34ed30");
var WEBKIT = require("f4067f6b9a5e38cb");
var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);
// IE8-
var FAILS_ON_UNDEFINED = fails(function() {
    test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function() {
    test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');
var STABLE_SORT = !fails(function() {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 70;
    if (FF && FF > 3) return;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)test.push({
            k: chr + index,
            v: value
        });
    }
    test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < test.length; index++){
        chr = test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
var getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return toString(x) > toString(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({
    target: 'Array',
    proto: true,
    forced: FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) aCallable(comparefn);
        var array = toObject(this);
        if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
        var items = [];
        var arrayLength = lengthOfArrayLike(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
        internalSort(items, getSortCompare(comparefn));
        itemsLength = lengthOfArrayLike(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)deletePropertyOrThrow(array, index++);
        return array;
    }
});

},{"bcbafe2730da3578":"gD2TP","45fd6781824a0ecc":"jsw26","227e835045b72b76":"ehOyc","d460a9dbedc2e639":"gxWv7","eb5d266a4b580e05":"fp6Bt","ab9af39e90a45cab":"ieW8l","2874e3c4ed670355":"ffo0a","b077ecec4e3b8790":"8SraZ","b1c0993c5b4a0232":"6F6CU","fc67c1f531962716":"gl0vh","5463fbeb0c308d9":"aYGh2","44ffda3b5c0f4b25":"8uxsz","f9fbdc3cf34ed30":"7Fmxi","f4067f6b9a5e38cb":"cqPJu"}],"6F6CU":[function(require,module,exports,__globalThis) {
'use strict';
var arraySlice = require("477ba4a4642e124b");
var floor = Math.floor;
var sort = function sort1(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = floor(length / 2);
        var left = sort(arraySlice(array, 0, middle), comparefn);
        var right = sort(arraySlice(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
module.exports = sort;

},{"477ba4a4642e124b":"iIoNC"}],"aYGh2":[function(require,module,exports,__globalThis) {
'use strict';
var userAgent = require("a5aa79c2b523d5ed");
var firefox = userAgent.match(/firefox\/(\d+)/i);
module.exports = !!firefox && +firefox[1];

},{"a5aa79c2b523d5ed":"7UNqW"}],"8uxsz":[function(require,module,exports,__globalThis) {
'use strict';
var UA = require("e23e24a84dc58074");
module.exports = /MSIE|Trident/.test(UA);

},{"e23e24a84dc58074":"7UNqW"}],"cqPJu":[function(require,module,exports,__globalThis) {
'use strict';
var userAgent = require("b4f554b2b39611d1");
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
module.exports = !!webkit && +webkit[1];

},{"b4f554b2b39611d1":"7UNqW"}],"fZYxD":[function(require,module,exports,__globalThis) {
'use strict';
var setSpecies = require("42da8ff88dc4c1c4");
// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');

},{"42da8ff88dc4c1c4":"7q10a"}],"7q10a":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("b05e11590de6536b");
var defineBuiltInAccessor = require("5ccd92fa5628281e");
var wellKnownSymbol = require("5145e81a7788c772");
var DESCRIPTORS = require("19428004aa07279c");
var SPECIES = wellKnownSymbol('species');
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineBuiltInAccessor(Constructor, SPECIES, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};

},{"b05e11590de6536b":"iXpu0","5ccd92fa5628281e":"g2LDG","5145e81a7788c772":"6dJgl","19428004aa07279c":"ihfdR"}],"dQJ6h":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("fcdd299870ca460d");
var toObject = require("5f536a62c5bdccdf");
var toAbsoluteIndex = require("ec98ec63afca6e23");
var toIntegerOrInfinity = require("d308f711ad345c5e");
var lengthOfArrayLike = require("5b3d6eaf0671a489");
var setArrayLength = require("32601ab988fd40d3");
var doesNotExceedSafeInteger = require("b495b3fcd17928be");
var arraySpeciesCreate = require("f92c3217c97e3529");
var createProperty = require("5390d505f7091be7");
var deletePropertyOrThrow = require("3105e86fb8ab7be");
var arrayMethodHasSpeciesSupport = require("68735e235584e669");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var max = Math.max;
var min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = toObject(this);
        var len = lengthOfArrayLike(O);
        var actualStart = toAbsoluteIndex(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
        }
        doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
        A = arraySpeciesCreate(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) createProperty(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else deletePropertyOrThrow(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)deletePropertyOrThrow(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else deletePropertyOrThrow(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        setArrayLength(O, len - actualDeleteCount + insertCount);
        return A;
    }
});

},{"fcdd299870ca460d":"gD2TP","5f536a62c5bdccdf":"gxWv7","ec98ec63afca6e23":"3itgc","d308f711ad345c5e":"wKg8O","5b3d6eaf0671a489":"fp6Bt","32601ab988fd40d3":"FB44O","b495b3fcd17928be":"h7wyy","f92c3217c97e3529":"ai7Xg","5390d505f7091be7":"Xwqbj","3105e86fb8ab7be":"ieW8l","68735e235584e669":"7AF65"}],"FB44O":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("dc66120e0129528");
var isArray = require("60f73fd41619acc2");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) throw new $TypeError('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

},{"dc66120e0129528":"ihfdR","60f73fd41619acc2":"9wuMi"}],"XsOmQ":[function(require,module,exports,__globalThis) {
'use strict';
// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require("38dfe1dec51aa5e");
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');

},{"38dfe1dec51aa5e":"hq1ko"}],"jklTo":[function(require,module,exports,__globalThis) {
'use strict';
// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require("a292f2e262c4e9cd");
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

},{"a292f2e262c4e9cd":"hq1ko"}],"10D4I":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("b5b7367238f03d69");
var globalThis = require("c579499e0a76aa10");
var arrayBufferModule = require("e47ed91aa3516c0b");
var setSpecies = require("933de36f1a956134");
var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = globalThis[ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({
    global: true,
    constructor: true,
    forced: NativeArrayBuffer !== ArrayBuffer
}, {
    ArrayBuffer: ArrayBuffer
});
setSpecies(ARRAY_BUFFER);

},{"b5b7367238f03d69":"gD2TP","c579499e0a76aa10":"4naf8","e47ed91aa3516c0b":"icQUr","933de36f1a956134":"7q10a"}],"icQUr":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("b2866645d252be10");
var uncurryThis = require("6f1278f8f2a16115");
var DESCRIPTORS = require("82c590a9dd8cc3ac");
var NATIVE_ARRAY_BUFFER = require("923679fae99d4d2f");
var FunctionName = require("9840ef06cc46dddb");
var createNonEnumerableProperty = require("78ca6eb037349755");
var defineBuiltInAccessor = require("e693d9164e48343");
var defineBuiltIns = require("649a7a39c0607d74");
var fails = require("57aab94a1cd1d913");
var anInstance = require("7333f43e52f40b38");
var toIntegerOrInfinity = require("1fd77d2940b4fd75");
var toLength = require("8739fe5c743af579");
var toIndex = require("e3fc7a8bc754578a");
var fround = require("93dd6846d2a65063");
var IEEE754 = require("d85071d33c34155a");
var getPrototypeOf = require("eae7b83555f02284");
var setPrototypeOf = require("fd01028813b4814f");
var arrayFill = require("8fdeb7296fb95696");
var arraySlice = require("c0dac2bdd3636e95");
var inheritIfRequired = require("3606a69f7ceacab3");
var copyConstructorProperties = require("5a0e685d057e2415");
var setToStringTag = require("dd3d1adef426fc5");
var InternalStateModule = require("ea12fbd2f22b2f25");
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = globalThis[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = globalThis[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = globalThis.Array;
var RangeError = globalThis.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);
var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;
var packInt8 = function packInt8(number) {
    return [
        number & 0xFF
    ];
};
var packInt16 = function packInt16(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var packInt32 = function packInt32(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var unpackInt32 = function unpackInt32(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var packFloat32 = function packFloat32(number) {
    return packIEEE754(fround(number), 23, 4);
};
var packFloat64 = function packFloat64(number) {
    return packIEEE754(number, 52, 8);
};
var addGetter = function addGetter(Constructor, key, getInternalState) {
    defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
        configurable: true,
        get: function get() {
            return getInternalState(this)[key];
        }
    });
};
var get = function get(view, count, index, isLittleEndian) {
    var store = getInternalDataViewState(view);
    var intIndex = toIndex(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = arraySlice(bytes, start, start + count);
    return boolIsLittleEndian ? pack : reverse(pack);
};
var set = function set(view, count, index, conversion, value, isLittleEndian) {
    var store = getInternalDataViewState(view);
    var intIndex = toIndex(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!NATIVE_ARRAY_BUFFER) {
    $ArrayBuffer = function ArrayBuffer(length) {
        anInstance(this, ArrayBufferPrototype);
        var byteLength = toIndex(length);
        setInternalState(this, {
            type: ARRAY_BUFFER,
            bytes: fill(Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!DESCRIPTORS) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];
    $DataView = function DataView(buffer, byteOffset, byteLength) {
        anInstance(this, DataViewPrototype);
        anInstance(buffer, ArrayBufferPrototype);
        var bufferState = getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = toIntegerOrInfinity(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
        byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
        if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
        setInternalState(this, {
            type: DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!DESCRIPTORS) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    DataViewPrototype = $DataView[PROTOTYPE];
    if (DESCRIPTORS) {
        addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
        addGetter($DataView, 'buffer', getInternalDataViewState);
        addGetter($DataView, 'byteLength', getInternalDataViewState);
        addGetter($DataView, 'byteOffset', getInternalDataViewState);
    }
    defineBuiltIns(DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
    /* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */ if (!fails(function() {
        NativeArrayBuffer(1);
    }) || !fails(function() {
        new NativeArrayBuffer(-1);
    }) || fails(function() {
        new NativeArrayBuffer();
        new NativeArrayBuffer(1.5);
        new NativeArrayBuffer(NaN);
        return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new, sonarjs/inconsistent-function-call -- required for testing */ $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, ArrayBufferPrototype);
            return inheritIfRequired(new NativeArrayBuffer(toIndex(length)), this, $ArrayBuffer);
        };
        $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;
        ArrayBufferPrototype.constructor = $ArrayBuffer;
        copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
    } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) setPrototypeOf(DataViewPrototype, ObjectPrototype);
    // iOS Safari 7.x bug
    var testView = new $DataView(new $ArrayBuffer(2));
    var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
    testView.setInt8(0, 2147483648);
    testView.setInt8(1, 2147483649);
    if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
module.exports = {
    ArrayBuffer: $ArrayBuffer,
    DataView: $DataView
};

},{"b2866645d252be10":"4naf8","6f1278f8f2a16115":"jsw26","82c590a9dd8cc3ac":"ihfdR","923679fae99d4d2f":"4kGiq","9840ef06cc46dddb":"cE4Pk","78ca6eb037349755":"3IHVb","e693d9164e48343":"g2LDG","649a7a39c0607d74":"iYMvV","57aab94a1cd1d913":"8SraZ","7333f43e52f40b38":"9RDjg","1fd77d2940b4fd75":"wKg8O","8739fe5c743af579":"4f0fH","e3fc7a8bc754578a":"cSMkA","93dd6846d2a65063":"lV5N7","d85071d33c34155a":"7etnM","eae7b83555f02284":"lFnuf","fd01028813b4814f":"hmY3h","8fdeb7296fb95696":"453wW","c0dac2bdd3636e95":"iIoNC","3606a69f7ceacab3":"a2ozq","5a0e685d057e2415":"5kBDz","dd3d1adef426fc5":"3q5sA","ea12fbd2f22b2f25":"4Dlpx"}],"4kGiq":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

},{}],"iYMvV":[function(require,module,exports,__globalThis) {
'use strict';
var defineBuiltIn = require("e34e683e23dcb4bb");
module.exports = function(target, src, options) {
    for(var key in src)defineBuiltIn(target, key, src[key], options);
    return target;
};

},{"e34e683e23dcb4bb":"jlXZ9"}],"9RDjg":[function(require,module,exports,__globalThis) {
'use strict';
var isPrototypeOf = require("55f8840091c5bf21");
var $TypeError = TypeError;
module.exports = function(it, Prototype) {
    if (isPrototypeOf(Prototype, it)) return it;
    throw new $TypeError('Incorrect invocation');
};

},{"55f8840091c5bf21":"fVGN3"}],"cSMkA":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("10a259b760ce2864");
var toLength = require("f24767d66362404d");
var $RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = toIntegerOrInfinity(it);
    var length = toLength(number);
    if (number !== length) throw new $RangeError('Wrong length or index');
    return length;
};

},{"10a259b760ce2864":"wKg8O","f24767d66362404d":"4f0fH"}],"lV5N7":[function(require,module,exports,__globalThis) {
'use strict';
var floatRound = require("8f9dfe0502a74d7");
var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
module.exports = Math.fround || function fround(x) {
    return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};

},{"8f9dfe0502a74d7":"7m3fA"}],"7m3fA":[function(require,module,exports,__globalThis) {
'use strict';
var sign = require("9113322676fa66ef");
var abs = Math.abs;
var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;
var roundTiesToEven = function roundTiesToEven(n) {
    return n + INVERSE_EPSILON - INVERSE_EPSILON;
};
module.exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = abs(n);
    var s = sign(n);
    if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};

},{"9113322676fa66ef":"g5byZ"}],"g5byZ":[function(require,module,exports,__globalThis) {
'use strict';
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};

},{}],"7etnM":[function(require,module,exports,__globalThis) {
'use strict';
// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var pack = function pack(number, mantissaLength, bytes) {
    var buffer = $Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = floor(log(number) / LN2);
        c = pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[index - 1] |= sign * 128;
    return buffer;
};
var unpack = function unpack(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};
module.exports = {
    pack: pack,
    unpack: unpack
};

},{}],"a2ozq":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("9f474ed504af79a9");
var isObject = require("bd2a6951ff768696");
var setPrototypeOf = require("972057e738a2788f");
// makes subclassing work correct for wrapped built-ins
module.exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
    return $this;
};

},{"9f474ed504af79a9":"37CJl","bd2a6951ff768696":"8iIJm","972057e738a2788f":"hmY3h"}],"2yxfN":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("af14b1f4d994a127");
var defineBuiltIn = require("53d6ff102d14faf");
var dateToPrimitive = require("5ca81c5eeb540a34");
var wellKnownSymbol = require("5e5f3eb0bfd879e9");
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);

},{"af14b1f4d994a127":"h2GWh","53d6ff102d14faf":"jlXZ9","5ca81c5eeb540a34":"2qLnY","5e5f3eb0bfd879e9":"6dJgl"}],"2qLnY":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("38c74c72615b5acf");
var ordinaryToPrimitive = require("474ad3f08d0bd65b");
var $TypeError = TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function(hint) {
    anObject(this);
    if (hint === 'string' || hint === 'default') hint = 'string';
    else if (hint !== 'number') throw new $TypeError('Incorrect hint');
    return ordinaryToPrimitive(this, hint);
};

},{"38c74c72615b5acf":"2dEST","474ad3f08d0bd65b":"2eNQe"}],"4kV53":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("b12e30f0adef9477");
var isObject = require("bd77085fbbf1d61e");
var definePropertyModule = require("cd75990201b9bb5");
var isPrototypeOf = require("753d0304b6cfae74");
var wellKnownSymbol = require("96031184f21018fc");
var makeBuiltIn = require("ac5dcf87aefc69c2");
var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype;
// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype)) definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, {
    value: makeBuiltIn(function(O) {
        if (!isCallable(this) || !isObject(O)) return false;
        var P = this.prototype;
        return isObject(P) ? isPrototypeOf(P, O) : O instanceof this;
    }, HAS_INSTANCE)
});

},{"b12e30f0adef9477":"37CJl","bd77085fbbf1d61e":"8iIJm","cd75990201b9bb5":"4d2AB","753d0304b6cfae74":"fVGN3","96031184f21018fc":"6dJgl","ac5dcf87aefc69c2":"brrqs"}],"lJHpl":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("b7ae6c9060bb031e");
var FUNCTION_NAME_EXISTS = require("dbb3f5c37b15a691").EXISTS;
var uncurryThis = require("ba7e18d66fc2fe0e");
var defineBuiltInAccessor = require("c4fdf1e400153454");
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function get() {
        try {
            return regExpExec(nameRE, functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});

},{"b7ae6c9060bb031e":"ihfdR","dbb3f5c37b15a691":"cE4Pk","ba7e18d66fc2fe0e":"jsw26","c4fdf1e400153454":"g2LDG"}],"5n1PG":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("66109b3bb99843e");
var setToStringTag = require("925145db661479ea");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(globalThis.JSON, 'JSON', true);

},{"66109b3bb99843e":"4naf8","925145db661479ea":"3q5sA"}],"cgPPQ":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("569f941c898a31a4");

},{"569f941c898a31a4":"3iZl7"}],"3iZl7":[function(require,module,exports,__globalThis) {
'use strict';
var collection = require("d6ad832f14f0fa71");
var collectionStrong = require("bfbad00b2e97bcca");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong);

},{"d6ad832f14f0fa71":"fn4lx","bfbad00b2e97bcca":"kpShx"}],"fn4lx":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("7f7d2ffaf036b70c");
var globalThis = require("23fed902470e3d4c");
var uncurryThis = require("58d7b96f0152237");
var isForced = require("30876c2e1f5df872");
var defineBuiltIn = require("b827fda460342f0d");
var InternalMetadataModule = require("6163d338080ca134");
var iterate = require("f05c3889843e7603");
var anInstance = require("38cbb680894f59a3");
var isCallable = require("799d274b4fe226e7");
var isNullOrUndefined = require("36192c2af1f673a1");
var isObject = require("9e3db26fb26723ec");
var fails = require("f5cb548db0e3391e");
var checkCorrectnessOfIteration = require("80e8f5144d6954d9");
var setToStringTag = require("4fbd135f98af11c4");
var inheritIfRequired = require("585a6aeda8432eb3");
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = globalThis[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
        defineBuiltIn(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        InternalMetadataModule.enable();
    } else if (isForced(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = fails(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && fails(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                anInstance(dummy, NativePrototype);
                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    setToStringTag(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

},{"7f7d2ffaf036b70c":"gD2TP","23fed902470e3d4c":"4naf8","58d7b96f0152237":"jsw26","30876c2e1f5df872":"g6zdI","b827fda460342f0d":"jlXZ9","6163d338080ca134":"lmr1u","f05c3889843e7603":"gjriO","38cbb680894f59a3":"9RDjg","799d274b4fe226e7":"37CJl","36192c2af1f673a1":"9lebS","9e3db26fb26723ec":"8iIJm","f5cb548db0e3391e":"8SraZ","80e8f5144d6954d9":"21ceT","4fbd135f98af11c4":"3q5sA","585a6aeda8432eb3":"a2ozq"}],"lmr1u":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var $ = require("3242fc68c548334b");
var uncurryThis = require("d7dc323978454584");
var hiddenKeys = require("33c7a5cefcfa8a48");
var isObject = require("949cc173e657f4a8");
var hasOwn = require("e6764a7848fbe604");
var defineProperty = require("77d05ce7ff38a94f").f;
var getOwnPropertyNamesModule = require("491415e519a00a7c");
var getOwnPropertyNamesExternalModule = require("1a3edc3a1e92ccaf");
var isExtensible = require("1f8f4e666c381f6");
var uid = require("2f09fd9212a3372e");
var FREEZING = require("858ced62f45384ee");
var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;
var setMetadata = function setMetadata(it) {
    defineProperty(it, METADATA, {
        value: {
            objectID: 'O' + id++,
            weakData: {} // weak collections IDs
        }
    });
};
var fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return (typeof it === "undefined" ? "undefined" : (0, _typeOf._)(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        setMetadata(it);
    // return object ID
    }
    return it[METADATA].objectID;
};
var getWeakData = function getWeakData(it, create) {
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[METADATA].weakData;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
    return it;
};
var enable = function enable() {
    meta.enable = function() {};
    REQUIRED = true;
    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
    var splice = uncurryThis([].splice);
    var test = {};
    test[METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
        });
    }
};
var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
};
hiddenKeys[METADATA] = true;

},{"@swc/helpers/_/_type_of":"668P4","3242fc68c548334b":"gD2TP","d7dc323978454584":"jsw26","33c7a5cefcfa8a48":"9HbEz","949cc173e657f4a8":"8iIJm","e6764a7848fbe604":"h2GWh","77d05ce7ff38a94f":"4d2AB","491415e519a00a7c":"busKr","1a3edc3a1e92ccaf":"hdcmz","1f8f4e666c381f6":"hCJ0Z","2f09fd9212a3372e":"6zL6V","858ced62f45384ee":"88qwO"}],"hCJ0Z":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("de1e0227a248bfd3");
var isObject = require("68a5b2cef468256c");
var classof = require("cb8542af391c6b0e");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("79d81d484af31adc");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function() {
    $isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!isObject(it)) return false;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
    return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

},{"de1e0227a248bfd3":"8SraZ","68a5b2cef468256c":"8iIJm","cb8542af391c6b0e":"fGBNn","79d81d484af31adc":"1BJ24"}],"1BJ24":[function(require,module,exports,__globalThis) {
'use strict';
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = require("5bca09ebe0e39932");
module.exports = fails(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});

},{"5bca09ebe0e39932":"8SraZ"}],"88qwO":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("388690d33020cebb");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

},{"388690d33020cebb":"8SraZ"}],"gjriO":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var bind = require("2f267ed50e670495");
var call = require("c0af58bb1ef1cc62");
var anObject = require("7fa6542c03ca9239");
var tryToString = require("fa596d1a4c07b72a");
var isArrayIteratorMethod = require("fd753cc641a6f10a");
var lengthOfArrayLike = require("2a15dee148d3db96");
var isPrototypeOf = require("417f9a13deeb58a6");
var getIterator = require("43af53be1b24dae5");
var getIteratorMethod = require("bf7ad32b21aed0b4");
var iteratorClose = require("5241389e1d6eeb73");
var $TypeError = TypeError;
var Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var ResultPrototype = Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) iteratorClose(iterator, 'normal', condition);
        return new Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            anObject(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && isPrototypeOf(ResultPrototype, result)) return result;
            }
            return new Result(false);
        }
        iterator = getIterator(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = call(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            iteratorClose(iterator, 'throw', error);
        }
        if ((typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
    }
    return new Result(false);
};

},{"@swc/helpers/_/_type_of":"668P4","2f267ed50e670495":"7xEW7","c0af58bb1ef1cc62":"ebTVd","7fa6542c03ca9239":"2dEST","fa596d1a4c07b72a":"b8XMV","fd753cc641a6f10a":"8FXTb","2a15dee148d3db96":"fp6Bt","417f9a13deeb58a6":"fVGN3","43af53be1b24dae5":"cAVpj","bf7ad32b21aed0b4":"lf0Zm","5241389e1d6eeb73":"cxu35"}],"kpShx":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("4087699e0041f387");
var defineBuiltInAccessor = require("1731ca06a03e84a3");
var defineBuiltIns = require("c048d7069b65e14b");
var bind = require("5aecbe8fa3c5a74e");
var anInstance = require("d3ad95b3aaf27c8a");
var isNullOrUndefined = require("cac009f0bbf34bb8");
var iterate = require("a9a2814559569c97");
var defineIterator = require("eb2045e367047a1c");
var createIterResultObject = require("14b36f47f4e70181");
var setSpecies = require("dfd8ed3bea972a50");
var DESCRIPTORS = require("b83fb10f1c8587e6");
var fastKey = require("77d5ccb3a2fbc893").fastKey;
var InternalStateModule = require("79afb9c26314edc8");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
module.exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: create(null),
                first: null,
                last: null,
                size: 0
            });
            if (!DESCRIPTORS) that.size = 0;
            if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if (DESCRIPTORS) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function getEntry(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        defineBuiltIns(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = create(null);
                if (DESCRIPTORS) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if (DESCRIPTORS) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        defineBuiltIns(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
            configurable: true,
            get: function get() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return createIterResultObject(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return createIterResultObject(entry.key, false);
            if (kind === 'values') return createIterResultObject(entry.value, false);
            return createIterResultObject([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        setSpecies(CONSTRUCTOR_NAME);
    }
};

},{"4087699e0041f387":"5ZmqN","1731ca06a03e84a3":"g2LDG","c048d7069b65e14b":"iYMvV","5aecbe8fa3c5a74e":"7xEW7","d3ad95b3aaf27c8a":"9RDjg","cac009f0bbf34bb8":"9lebS","a9a2814559569c97":"gjriO","eb2045e367047a1c":"cMggn","14b36f47f4e70181":"2q5E9","dfd8ed3bea972a50":"7q10a","b83fb10f1c8587e6":"ihfdR","77d5ccb3a2fbc893":"lmr1u","79afb9c26314edc8":"4Dlpx"}],"3tHxB":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("902411673b5fb2fc");
var log1p = require("a4cfbc2e86c91e88");
// eslint-disable-next-line es/no-math-acosh -- required for testing
var $acosh = Math.acosh;
var log = Math.log;
var sqrt = Math.sqrt;
var LN2 = Math.LN2;
var FORCED = !$acosh || Math.floor($acosh(Number.MAX_VALUE)) !== 710 || $acosh(Infinity) !== Infinity;
// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    acosh: function acosh(x) {
        var n = +x;
        return n < 1 ? NaN : n > 94906265.62425156 ? log(n) + LN2 : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
    }
});

},{"902411673b5fb2fc":"gD2TP","a4cfbc2e86c91e88":"is50C"}],"is50C":[function(require,module,exports,__globalThis) {
'use strict';
var log = Math.log;
// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
module.exports = Math.log1p || function log1p(x) {
    var n = +x;
    return n > -0.00000001 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
};

},{}],"4G5bk":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("7dffb6067574667e");
// eslint-disable-next-line es/no-math-asinh -- required for testing
var $asinh = Math.asinh;
var log = Math.log;
var sqrt = Math.sqrt;
function asinh(x) {
    var n = +x;
    return !isFinite(n) || n === 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
}
var FORCED = !($asinh && 1 / $asinh(0) > 0);
// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    asinh: asinh
});

},{"7dffb6067574667e":"gD2TP"}],"lyzd1":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("852dfc47c3d9c449");
// eslint-disable-next-line es/no-math-atanh -- required for testing
var $atanh = Math.atanh;
var log = Math.log;
var FORCED = !($atanh && 1 / $atanh(-0) < 0);
// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    atanh: function atanh(x) {
        var n = +x;
        return n === 0 ? n : log((1 + n) / (1 - n)) / 2;
    }
});

},{"852dfc47c3d9c449":"gD2TP"}],"gPtBO":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("387aa8b70c72a94d");
var sign = require("dac8a302b6d1f627");
var abs = Math.abs;
var pow = Math.pow;
// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({
    target: 'Math',
    stat: true
}, {
    cbrt: function cbrt(x) {
        var n = +x;
        return sign(n) * pow(abs(n), 1 / 3);
    }
});

},{"387aa8b70c72a94d":"gD2TP","dac8a302b6d1f627":"g5byZ"}],"8FmOw":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("2c4d345d25b6d18c");
var floor = Math.floor;
var log = Math.log;
var LOG2E = Math.LOG2E;
// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$({
    target: 'Math',
    stat: true
}, {
    clz32: function clz32(x) {
        var n = x >>> 0;
        return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
    }
});

},{"2c4d345d25b6d18c":"gD2TP"}],"hUnly":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f8f6f4e4d2e4cfe0");
var expm1 = require("c0bbc641191a15a9");
// eslint-disable-next-line es/no-math-cosh -- required for testing
var $cosh = Math.cosh;
var abs = Math.abs;
var E = Math.E;
var FORCED = !$cosh || $cosh(710) === Infinity;
// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    cosh: function cosh(x) {
        var t = expm1(abs(x) - 1) + 1;
        return (t + 1 / (t * E * E)) * (E / 2);
    }
});

},{"f8f6f4e4d2e4cfe0":"gD2TP","c0bbc641191a15a9":"dxK4r"}],"dxK4r":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line es/no-math-expm1 -- safe
var $expm1 = Math.expm1;
var exp = Math.exp;
// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
module.exports = !$expm1 || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 || $expm1(-0.00000000000000002) !== -0.00000000000000002 ? function expm1(x) {
    var n = +x;
    return n === 0 ? n : n > -0.000001 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
} : $expm1;

},{}],"9Lupv":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("54b4d24b57e9de25");
var expm1 = require("5648f7662bee3fb6");
// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$({
    target: 'Math',
    stat: true,
    forced: expm1 !== Math.expm1
}, {
    expm1: expm1
});

},{"54b4d24b57e9de25":"gD2TP","5648f7662bee3fb6":"dxK4r"}],"cRADm":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1c1b96b0ca7c4a89");
var fround = require("47950f9c73209332");
// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$({
    target: 'Math',
    stat: true
}, {
    fround: fround
});

},{"1c1b96b0ca7c4a89":"gD2TP","47950f9c73209332":"lV5N7"}],"ebBZ6":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("bf5ef278fe0c2a2d");
// eslint-disable-next-line es/no-math-hypot -- required for testing
var $hypot = Math.hypot;
var abs = Math.abs;
var sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$({
    target: 'Math',
    stat: true,
    arity: 2,
    forced: FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * sqrt(sum);
    }
});

},{"bf5ef278fe0c2a2d":"gD2TP"}],"JDP36":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("26821e3060ae31ef");
var fails = require("4ae16bb469711695");
// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;
var FORCED = fails(function() {
    return $imul(0xFFFFFFFF, 5) !== -5 || $imul.length !== 2;
});
// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    imul: function imul(x, y) {
        var UINT16 = 0xFFFF;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});

},{"26821e3060ae31ef":"gD2TP","4ae16bb469711695":"8SraZ"}],"i8llG":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e28aca710c97445a");
var log10 = require("e386fc2f96575e54");
// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({
    target: 'Math',
    stat: true
}, {
    log10: log10
});

},{"e28aca710c97445a":"gD2TP","e386fc2f96575e54":"8adim"}],"8adim":[function(require,module,exports,__globalThis) {
'use strict';
var log = Math.log;
var LOG10E = Math.LOG10E;
// eslint-disable-next-line es/no-math-log10 -- safe
module.exports = Math.log10 || function log10(x) {
    return log(x) * LOG10E;
};

},{}],"idC7g":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ec799bb6317cd425");
var log1p = require("a686ef564d9d2882");
// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$({
    target: 'Math',
    stat: true
}, {
    log1p: log1p
});

},{"ec799bb6317cd425":"gD2TP","a686ef564d9d2882":"is50C"}],"jYWHq":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("266355161c4f030d");
var log = Math.log;
var LN2 = Math.LN2;
// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({
    target: 'Math',
    stat: true
}, {
    log2: function log2(x) {
        return log(x) / LN2;
    }
});

},{"266355161c4f030d":"gD2TP"}],"jK4YE":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("69e2ea3a560b4a42");
var sign = require("22dfbc4f803ce611");
// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({
    target: 'Math',
    stat: true
}, {
    sign: sign
});

},{"69e2ea3a560b4a42":"gD2TP","22dfbc4f803ce611":"g5byZ"}],"fCq0b":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ebfcc20cba7b1e4e");
var fails = require("e96ed0b70941abe1");
var expm1 = require("cfb0aa3c75dc889");
var abs = Math.abs;
var exp = Math.exp;
var E = Math.E;
var FORCED = fails(function() {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-0.00000000000000002) !== -0.00000000000000002;
});
// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$({
    target: 'Math',
    stat: true,
    forced: FORCED
}, {
    sinh: function sinh(x) {
        var n = +x;
        return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
    }
});

},{"ebfcc20cba7b1e4e":"gD2TP","e96ed0b70941abe1":"8SraZ","cfb0aa3c75dc889":"dxK4r"}],"4zVaR":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("75ca6aa3ab3c490c");
var expm1 = require("fbda4dec68bbb02f");
var exp = Math.exp;
// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$({
    target: 'Math',
    stat: true
}, {
    tanh: function tanh(x) {
        var n = +x;
        var a = expm1(n);
        var b = expm1(-n);
        return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
    }
});

},{"75ca6aa3ab3c490c":"gD2TP","fbda4dec68bbb02f":"dxK4r"}],"jYiMT":[function(require,module,exports,__globalThis) {
'use strict';
var setToStringTag = require("8c4fc1e6a65b6d2f");
// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);

},{"8c4fc1e6a65b6d2f":"3q5sA"}],"cNhKx":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f97de92e01c210b9");
var trunc = require("15d9fc8fa50b9dc3");
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({
    target: 'Math',
    stat: true
}, {
    trunc: trunc
});

},{"f97de92e01c210b9":"gD2TP","15d9fc8fa50b9dc3":"am6nv"}],"4SoNN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var $ = require("6a137a118d1bb06a");
var IS_PURE = require("6befc110db857fa5");
var DESCRIPTORS = require("dac0f49ddd258f02");
var globalThis = require("be627f07e88786cb");
var path = require("2945e9e965681f9c");
var uncurryThis = require("d6ad03f4a8d178a7");
var isForced = require("b7d12a59a0877cf0");
var hasOwn = require("a63fe8ba771ddd66");
var inheritIfRequired = require("1fa70215a385f43f");
var isPrototypeOf = require("ac9a98828b299940");
var isSymbol = require("a2f71c36cf1dfa06");
var toPrimitive = require("1398c779e833098a");
var fails = require("58c10e766b715db4");
var getOwnPropertyNames = require("eae30770a8520200").f;
var getOwnPropertyDescriptor = require("a3f2314ca43c8870").f;
var defineProperty = require("673bf972e777267f").f;
var thisNumberValue = require("dc2cfe6c86ab9553");
var trim = require("27f6d5a76060ef23").trim;
var NUMBER = 'Number';
var NativeNumber = globalThis[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = globalThis.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function toNumeric(value) {
    var primValue = toPrimitive(value, 'number');
    return (typeof primValue === "undefined" ? "undefined" : (0, _typeOf._)(primValue)) == 'bigint' ? primValue : toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function toNumber(argument) {
    var it = toPrimitive(argument, 'number');
    var first, third, radix, maxCode, digits, length, index, code;
    if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
    if (typeof it == 'string' && it.length > 2) {
        it = trim(it);
        first = charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(charCodeAt(it, 1)){
                // fast equal of /^0b[01]+$/i
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break;
                // fast equal of /^0o[0-7]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break;
                default:
                    return +it;
            }
            digits = stringSlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
var calledWithNew = function calledWithNew(dummy) {
    // includes check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
        thisNumberValue(dummy);
    });
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};
NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
$({
    global: true,
    constructor: true,
    wrap: true,
    forced: FORCED
}, {
    Number: NumberWrapper
});
// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function copyConstructorProperties(target, source) {
    for(var keys = DESCRIPTORS ? getOwnPropertyNames(source) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
};
if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);

},{"@swc/helpers/_/_type_of":"668P4","6a137a118d1bb06a":"gD2TP","6befc110db857fa5":"6KD1D","dac0f49ddd258f02":"ihfdR","be627f07e88786cb":"4naf8","2945e9e965681f9c":"f8NAR","d6ad03f4a8d178a7":"jsw26","b7d12a59a0877cf0":"g6zdI","a63fe8ba771ddd66":"h2GWh","1fa70215a385f43f":"a2ozq","ac9a98828b299940":"fVGN3","a2f71c36cf1dfa06":"g5d9N","1398c779e833098a":"invap","58c10e766b715db4":"8SraZ","eae30770a8520200":"busKr","a3f2314ca43c8870":"hRqf9","673bf972e777267f":"4d2AB","dc2cfe6c86ab9553":"XdrB6","27f6d5a76060ef23":"6FZTw"}],"XdrB6":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("4875831adea9aec3");
// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);

},{"4875831adea9aec3":"jsw26"}],"6FZTw":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("17f5a3ff1a1c6ce6");
var requireObjectCoercible = require("56083d5e0450dab9");
var toString = require("3c5616504c7d56e9");
var whitespaces = require("eacd32ca91d3c555");
var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = toString(requireObjectCoercible($this));
        if (TYPE & 1) string = replace(string, ltrim, '');
        if (TYPE & 2) string = replace(string, rtrim, '$1');
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: createMethod(3)
};

},{"17f5a3ff1a1c6ce6":"jsw26","56083d5e0450dab9":"a0P0K","3c5616504c7d56e9":"ffo0a","eacd32ca91d3c555":"jMBz0"}],"jMBz0":[function(require,module,exports,__globalThis) {
'use strict';
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

},{}],"jQLWg":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("6a152397506f58aa");
// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    EPSILON: Math.pow(2, -52)
});

},{"6a152397506f58aa":"gD2TP"}],"ecIuF":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1cd8bc612ab8a9aa");
var numberIsFinite = require("2741aaae50f5c5db");
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({
    target: 'Number',
    stat: true
}, {
    isFinite: numberIsFinite
});

},{"1cd8bc612ab8a9aa":"gD2TP","2741aaae50f5c5db":"1KIrP"}],"1KIrP":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("7a63d25015bc275e");
var globalIsFinite = globalThis.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && globalIsFinite(it);
};

},{"7a63d25015bc275e":"4naf8"}],"jlSHy":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ce2c3fa51ce7a2b6");
var isIntegralNumber = require("3e3a085edc93c707");
// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({
    target: 'Number',
    stat: true
}, {
    isInteger: isIntegralNumber
});

},{"ce2c3fa51ce7a2b6":"gD2TP","3e3a085edc93c707":"9bKv0"}],"9bKv0":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("de18539dea9401a");
var floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"de18539dea9401a":"8iIJm"}],"rBnUu":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("677c53d72f4dc4b5");
// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({
    target: 'Number',
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number;
    }
});

},{"677c53d72f4dc4b5":"gD2TP"}],"8qIoh":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("dab33bcdb73caa98");
var isIntegralNumber = require("3e8bd2979ca91bb4");
var abs = Math.abs;
// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$({
    target: 'Number',
    stat: true
}, {
    isSafeInteger: function isSafeInteger(number) {
        return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
    }
});

},{"dab33bcdb73caa98":"gD2TP","3e8bd2979ca91bb4":"9bKv0"}],"3buzz":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f08cf5dcc31074a6");
// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

},{"f08cf5dcc31074a6":"gD2TP"}],"gAM0z":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("d7c9fce3c9d3d189");
// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MIN_SAFE_INTEGER: -9007199254740991
});

},{"d7c9fce3c9d3d189":"gD2TP"}],"3emdE":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("6edfd3b7fb98ea3e");
var parseFloat = require("bae0a47a096d7522");
// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$({
    target: 'Number',
    stat: true,
    forced: Number.parseFloat !== parseFloat
}, {
    parseFloat: parseFloat
});

},{"6edfd3b7fb98ea3e":"gD2TP","bae0a47a096d7522":"jGlhc"}],"jGlhc":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("69bd3378e63391c8");
var fails = require("842d738e09e8ac6b");
var uncurryThis = require("1779e25eab454452");
var toString = require("a6c37474f58f0739");
var trim = require("595d7b3426fbca88").trim;
var whitespaces = require("3acff994bd3a41b1");
var charAt = uncurryThis(''.charAt);
var $parseFloat = globalThis.parseFloat;
var Symbol = globalThis.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity || ITERATOR && !fails(function() {
    $parseFloat(Object(ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
    var trimmedString = trim(toString(string));
    var result = $parseFloat(trimmedString);
    return result === 0 && charAt(trimmedString, 0) === '-' ? -0 : result;
} : $parseFloat;

},{"69bd3378e63391c8":"4naf8","842d738e09e8ac6b":"8SraZ","1779e25eab454452":"jsw26","a6c37474f58f0739":"ffo0a","595d7b3426fbca88":"6FZTw","3acff994bd3a41b1":"jMBz0"}],"cnWQY":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("3882f0ce9a7bc56f");
var parseInt = require("f2f29cbfccb05e47");
// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({
    target: 'Number',
    stat: true,
    forced: Number.parseInt !== parseInt
}, {
    parseInt: parseInt
});

},{"3882f0ce9a7bc56f":"gD2TP","f2f29cbfccb05e47":"OUgsg"}],"OUgsg":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("272fde501e24d305");
var fails = require("48c528ae508d02e");
var uncurryThis = require("7e7198f2f1540a47");
var toString = require("dd517d0a64474028");
var trim = require("b0ec8b6ceac29d85").trim;
var whitespaces = require("5252068313c033be");
var $parseInt = globalThis.parseInt;
var Symbol = globalThis.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22 || ITERATOR && !fails(function() {
    $parseInt(Object(ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
    var S = trim(toString(string));
    return $parseInt(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
} : $parseInt;

},{"272fde501e24d305":"4naf8","48c528ae508d02e":"8SraZ","7e7198f2f1540a47":"jsw26","dd517d0a64474028":"ffo0a","b0ec8b6ceac29d85":"6FZTw","5252068313c033be":"jMBz0"}],"cARKM":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("cd4f6c8df33e40b4");
var uncurryThis = require("46d8af161e2dc0d6");
var toIntegerOrInfinity = require("fb6b6174bcfa90f");
var thisNumberValue = require("a88d9905e1f83adc");
var $repeat = require("9b93ef6d7f240c15");
var fails = require("d57e63cfa5cbb68e");
var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);
var pow = function pow1(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function log(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var multiply = function multiply(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = floor(c2 / 1e7);
    }
};
var divide = function divide(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = floor(c / n);
        c = c % n * 1e7;
    }
};
var dataToString = function dataToString(data) {
    var index = 6;
    var s = '';
    while(--index >= 0)if (s !== '' || index === 0 || data[index] !== 0) {
        var t = $String(data[index]);
        s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
    return s;
};
var FORCED = fails(function() {
    return nativeToFixed(0.00008, 3) !== '0.000' || nativeToFixed(0.9, 0) !== '1' || nativeToFixed(1.255, 2) !== '1.25' || nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function() {
    // V8 ~ Android 4.3-
    nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({
    target: 'Number',
    proto: true,
    forced: FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = thisNumberValue(this);
        var fractDigits = toIntegerOrInfinity(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = '';
        var result = '0';
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number !== number) return 'NaN';
        if (number <= -1000000000000000000000 || number >= 1e21) return $String(number);
        if (number < 0) {
            sign = '-';
            number = -number;
        }
        if (number > 1e-21) {
            e = log(number * pow(2, 69, 1)) - 69;
            z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    multiply(data, 1e7, 0);
                    j -= 7;
                }
                multiply(data, pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    divide(data, 8388608);
                    j -= 23;
                }
                divide(data, 1 << j);
                multiply(data, 1, 1);
                divide(data, 2);
                result = dataToString(data);
            } else {
                multiply(data, 0, z);
                multiply(data, 1 << -e, 0);
                result = dataToString(data) + repeat('0', fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? '0.' + repeat('0', fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});

},{"cd4f6c8df33e40b4":"gD2TP","46d8af161e2dc0d6":"jsw26","fb6b6174bcfa90f":"wKg8O","a88d9905e1f83adc":"XdrB6","9b93ef6d7f240c15":"1Nchr","d57e63cfa5cbb68e":"8SraZ"}],"1Nchr":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("810ed4f57c077da5");
var toString = require("f870ae4664ae9b8c");
var requireObjectCoercible = require("b05eac101d7c2112");
var $RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
    var str = toString(requireObjectCoercible(this));
    var result = '';
    var n = toIntegerOrInfinity(count);
    if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};

},{"810ed4f57c077da5":"wKg8O","f870ae4664ae9b8c":"ffo0a","b05eac101d7c2112":"a0P0K"}],"ihzwW":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("9e39c36176ea9027");
var assign = require("eca15ea3e03a62cf");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== assign
}, {
    assign: assign
});

},{"9e39c36176ea9027":"gD2TP","eca15ea3e03a62cf":"cHd8y"}],"cHd8y":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("6bef1f1b71c0d15f");
var uncurryThis = require("d01fdbe6acf1dc69");
var call = require("152344c6f1cc0727");
var fails = require("e500b6660dae4ed2");
var objectKeys = require("a51f09aa538cbbc9");
var getOwnPropertySymbolsModule = require("1e00e3b82b1b3cb6");
var propertyIsEnumerableModule = require("df8aa13044dccc97");
var toObject = require("fb90ba2f91e5c029");
var IndexedObject = require("33842bab271c4900");
// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function() {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS && $assign({
        b: 1
    }, $assign(defineProperty({}, 'a', {
        enumerable: true,
        get: function get() {
            defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"6bef1f1b71c0d15f":"ihfdR","d01fdbe6acf1dc69":"jsw26","152344c6f1cc0727":"ebTVd","e500b6660dae4ed2":"8SraZ","a51f09aa538cbbc9":"ahqdT","1e00e3b82b1b3cb6":"b3HZA","df8aa13044dccc97":"heKXZ","fb90ba2f91e5c029":"gxWv7","33842bab271c4900":"dnbS6"}],"9um4m":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("8f6b558a4e940099");
var DESCRIPTORS = require("96523e310a3fe908");
var FORCED = require("67741c7cd2815bff");
var aCallable = require("60e72fdc0dc9cee8");
var toObject = require("81722f8311309945");
var definePropertyModule = require("e74b2be534174483");
// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) $({
    target: 'Object',
    proto: true,
    forced: FORCED
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        definePropertyModule.f(toObject(this), P, {
            get: aCallable(getter),
            enumerable: true,
            configurable: true
        });
    }
});

},{"8f6b558a4e940099":"gD2TP","96523e310a3fe908":"ihfdR","67741c7cd2815bff":"b97ni","60e72fdc0dc9cee8":"ehOyc","81722f8311309945":"gxWv7","e74b2be534174483":"4d2AB"}],"b97ni":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable no-undef, no-useless-call, sonarjs/no-reference-error -- required for testing */ /* eslint-disable es/no-legacy-object-prototype-accessor-methods -- required for testing */ var IS_PURE = require("8edc7d10fd60cc1f");
var globalThis = require("199488e7120262f2");
var fails = require("67c1b3060370d6f1");
var WEBKIT = require("a7f7bf4b6fabffe9");
// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if (WEBKIT && WEBKIT < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    __defineSetter__.call(null, key, function() {});
    delete globalThis[key];
});

},{"8edc7d10fd60cc1f":"6KD1D","199488e7120262f2":"4naf8","67c1b3060370d6f1":"8SraZ","a7f7bf4b6fabffe9":"cqPJu"}],"4OsR9":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("9bd3ca02d43a34c6");
var DESCRIPTORS = require("14adf2205f0de0f1");
var FORCED = require("25f3087f814cb2fd");
var aCallable = require("8f5516e8b83f7c81");
var toObject = require("1864c5e0fe7b94e4");
var definePropertyModule = require("fbfc447cbc7c8274");
// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS) $({
    target: 'Object',
    proto: true,
    forced: FORCED
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        definePropertyModule.f(toObject(this), P, {
            set: aCallable(setter),
            enumerable: true,
            configurable: true
        });
    }
});

},{"9bd3ca02d43a34c6":"gD2TP","14adf2205f0de0f1":"ihfdR","25f3087f814cb2fd":"b97ni","8f5516e8b83f7c81":"ehOyc","1864c5e0fe7b94e4":"gxWv7","fbfc447cbc7c8274":"4d2AB"}],"hkrb6":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f61a79561ef771d5");
var $entries = require("f45db476330e9273").entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({
    target: 'Object',
    stat: true
}, {
    entries: function entries(O) {
        return $entries(O);
    }
});

},{"f61a79561ef771d5":"gD2TP","f45db476330e9273":"1A8Zv"}],"1A8Zv":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("d3708b44f56d5dbe");
var fails = require("41285041ee215b4b");
var uncurryThis = require("fae894139558d631");
var objectGetPrototypeOf = require("d1ebe3ffdc898f92");
var objectKeys = require("8ca7d570e80b9ce7");
var toIndexedObject = require("cd0bc0f155d9ce86");
var $propertyIsEnumerable = require("8a6b90d3c1a4843d").f;
var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var createMethod = function createMethod(TO_ENTRIES) {
    return function(it) {
        var O = toIndexedObject(it);
        var keys = objectKeys(O);
        var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: createMethod(false)
};

},{"d3708b44f56d5dbe":"ihfdR","41285041ee215b4b":"8SraZ","fae894139558d631":"jsw26","d1ebe3ffdc898f92":"lFnuf","8ca7d570e80b9ce7":"ahqdT","cd0bc0f155d9ce86":"gGepo","8a6b90d3c1a4843d":"heKXZ"}],"j5wZE":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("41df7dcb1db288e9");
var FREEZING = require("fff8fcdf7f021ed");
var fails = require("349eb9a58219946d");
var isObject = require("aba4dbd0c2e0df38");
var onFreeze = require("83d388d2147293dd").onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function() {
    $freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
}, {
    freeze: function freeze(it) {
        return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
    }
});

},{"41df7dcb1db288e9":"gD2TP","fff8fcdf7f021ed":"88qwO","349eb9a58219946d":"8SraZ","aba4dbd0c2e0df38":"8iIJm","83d388d2147293dd":"lmr1u"}],"jhyaM":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("48c4d449b4b6a74e");
var iterate = require("ee4e4a7ea4b35347");
var createProperty = require("34466cd01816d06a");
// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$({
    target: 'Object',
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        iterate(iterable, function(k, v) {
            createProperty(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});

},{"48c4d449b4b6a74e":"gD2TP","ee4e4a7ea4b35347":"gjriO","34466cd01816d06a":"Xwqbj"}],"jSesk":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5e9e720f67356476");
var fails = require("c8df38aee3cb5769");
var toIndexedObject = require("10375c86bad61030");
var nativeGetOwnPropertyDescriptor = require("3b00a68c12a1896c").f;
var DESCRIPTORS = require("76539d9475dc0bf0");
var FORCED = !DESCRIPTORS || fails(function() {
    nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({
    target: 'Object',
    stat: true,
    forced: FORCED,
    sham: !DESCRIPTORS
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
    }
});

},{"5e9e720f67356476":"gD2TP","c8df38aee3cb5769":"8SraZ","10375c86bad61030":"gGepo","3b00a68c12a1896c":"hRqf9","76539d9475dc0bf0":"ihfdR"}],"jEcOZ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("40e7403e4fec8fc5");
var DESCRIPTORS = require("4e8e0ded689e341a");
var ownKeys = require("ca8e12f795281afd");
var toIndexedObject = require("2a0629723aea50a6");
var getOwnPropertyDescriptorModule = require("d8f1f7a76c234914");
var createProperty = require("d34666d556a98edd");
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({
    target: 'Object',
    stat: true,
    sham: !DESCRIPTORS
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = toIndexedObject(object);
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        var keys = ownKeys(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) createProperty(result, key, descriptor);
        }
        return result;
    }
});

},{"40e7403e4fec8fc5":"gD2TP","4e8e0ded689e341a":"ihfdR","ca8e12f795281afd":"8iAdE","2a0629723aea50a6":"gGepo","d8f1f7a76c234914":"hRqf9","d34666d556a98edd":"Xwqbj"}],"4C8zp":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("effeafa72fa4fcc2");
var fails = require("9f4f815a609d62de");
var getOwnPropertyNames = require("4a158a7faad2d27f").f;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: getOwnPropertyNames
});

},{"effeafa72fa4fcc2":"gD2TP","9f4f815a609d62de":"8SraZ","4a158a7faad2d27f":"hdcmz"}],"h4PNm":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("9b00c005c1d693fb");
var fails = require("ffe585e19c7a1096");
var toObject = require("a7cc68351642ae12");
var nativeGetPrototypeOf = require("46d7a597f20859a8");
var CORRECT_PROTOTYPE_GETTER = require("765be3ffdd1dfa5d");
var FAILS_ON_PRIMITIVES = fails(function() {
    nativeGetPrototypeOf(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return nativeGetPrototypeOf(toObject(it));
    }
});

},{"9b00c005c1d693fb":"gD2TP","ffe585e19c7a1096":"8SraZ","a7cc68351642ae12":"gxWv7","46d7a597f20859a8":"lFnuf","765be3ffdd1dfa5d":"7WzpM"}],"bg0Gs":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("451600d6bdd8e576");
var is = require("56b2e52d42ffd002");
// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({
    target: 'Object',
    stat: true
}, {
    is: is
});

},{"451600d6bdd8e576":"gD2TP","56b2e52d42ffd002":"832So"}],"832So":[function(require,module,exports,__globalThis) {
'use strict';
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

},{}],"keWpV":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("435e06d616210775");
var $isExtensible = require("cdaf74e91df56e60");
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$({
    target: 'Object',
    stat: true,
    forced: Object.isExtensible !== $isExtensible
}, {
    isExtensible: $isExtensible
});

},{"435e06d616210775":"gD2TP","cdaf74e91df56e60":"hCJ0Z"}],"hmEBJ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("d0fbaa7eb6b5ad4d");
var fails = require("421049f6c11462a7");
var isObject = require("9ed59196a9b50c30");
var classof = require("590e67d09aaa38f");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("c1ee6c6b89bec975");
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $isFrozen = Object.isFrozen;
var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function() {
    $isFrozen(1);
});
// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$({
    target: 'Object',
    stat: true,
    forced: FORCED
}, {
    isFrozen: function isFrozen(it) {
        if (!isObject(it)) return true;
        if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
        return $isFrozen ? $isFrozen(it) : false;
    }
});

},{"d0fbaa7eb6b5ad4d":"gD2TP","421049f6c11462a7":"8SraZ","9ed59196a9b50c30":"8iIJm","590e67d09aaa38f":"fGBNn","c1ee6c6b89bec975":"1BJ24"}],"8A1Yf":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e0d9427683afd111");
var fails = require("8b49b6806ae62eca");
var isObject = require("97ad0f68c00a1ff0");
var classof = require("7f6c54dd5bc88c64");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("c8a04ae167e7ad37");
// eslint-disable-next-line es/no-object-issealed -- safe
var $isSealed = Object.isSealed;
var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function() {
    $isSealed(1);
});
// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$({
    target: 'Object',
    stat: true,
    forced: FORCED
}, {
    isSealed: function isSealed(it) {
        if (!isObject(it)) return true;
        if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
        return $isSealed ? $isSealed(it) : false;
    }
});

},{"e0d9427683afd111":"gD2TP","8b49b6806ae62eca":"8SraZ","97ad0f68c00a1ff0":"8iIJm","7f6c54dd5bc88c64":"fGBNn","c8a04ae167e7ad37":"1BJ24"}],"lYJul":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("928eae3c9269318e");
var toObject = require("bffeb5a63b3d1ddc");
var nativeKeys = require("4e7619f3294f09c8");
var fails = require("16ceb2cf691ec6a8");
var FAILS_ON_PRIMITIVES = fails(function() {
    nativeKeys(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return nativeKeys(toObject(it));
    }
});

},{"928eae3c9269318e":"gD2TP","bffeb5a63b3d1ddc":"gxWv7","4e7619f3294f09c8":"ahqdT","16ceb2cf691ec6a8":"8SraZ"}],"gW6nC":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("3213681dc3c35763");
var DESCRIPTORS = require("4aa54b730f2d3e5b");
var FORCED = require("f722ba9b4a4e493a");
var toObject = require("d9187b4f4abc84a2");
var toPropertyKey = require("a283188d11fd1310");
var getPrototypeOf = require("81f1f2335bc409e6");
var getOwnPropertyDescriptor = require("73cff62f53644df3").f;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if (DESCRIPTORS) $({
    target: 'Object',
    proto: true,
    forced: FORCED
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = toObject(this);
        var key = toPropertyKey(P);
        var desc;
        do {
            if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = getPrototypeOf(O));
    }
});

},{"3213681dc3c35763":"gD2TP","4aa54b730f2d3e5b":"ihfdR","f722ba9b4a4e493a":"b97ni","d9187b4f4abc84a2":"gxWv7","a283188d11fd1310":"9pd5y","81f1f2335bc409e6":"lFnuf","73cff62f53644df3":"hRqf9"}],"6LLFo":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("cfcc7acaa30d169a");
var DESCRIPTORS = require("95cf98e445e49077");
var FORCED = require("32af9c4b10e71d8a");
var toObject = require("a3a2f8d0bb0d269a");
var toPropertyKey = require("fc6f1b0f9f6a3207");
var getPrototypeOf = require("4f72764854999276");
var getOwnPropertyDescriptor = require("940efcd169764424").f;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if (DESCRIPTORS) $({
    target: 'Object',
    proto: true,
    forced: FORCED
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = toObject(this);
        var key = toPropertyKey(P);
        var desc;
        do {
            if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = getPrototypeOf(O));
    }
});

},{"cfcc7acaa30d169a":"gD2TP","95cf98e445e49077":"ihfdR","32af9c4b10e71d8a":"b97ni","a3a2f8d0bb0d269a":"gxWv7","fc6f1b0f9f6a3207":"9pd5y","4f72764854999276":"lFnuf","940efcd169764424":"hRqf9"}],"2mA3E":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("dd30e23e7eea933c");
var isObject = require("16f89a44f17d8f35");
var onFreeze = require("4ddba3dd9dcca781").onFreeze;
var FREEZING = require("fa786d6ffa5b300e");
var fails = require("3a7088156a6b24b9");
// eslint-disable-next-line es/no-object-preventextensions -- safe
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function() {
    $preventExtensions(1);
});
// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
}, {
    preventExtensions: function preventExtensions(it) {
        return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
    }
});

},{"dd30e23e7eea933c":"gD2TP","16f89a44f17d8f35":"8iIJm","4ddba3dd9dcca781":"lmr1u","fa786d6ffa5b300e":"88qwO","3a7088156a6b24b9":"8SraZ"}],"hTD2S":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("7431c9c36c061192");
var isObject = require("254eb19750975bda");
var onFreeze = require("2f01f54810b729a0").onFreeze;
var FREEZING = require("f352701af16ccb01");
var fails = require("c5798f0bf47c2f71");
// eslint-disable-next-line es/no-object-seal -- safe
var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function() {
    $seal(1);
});
// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
}, {
    seal: function seal(it) {
        return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
    }
});

},{"7431c9c36c061192":"gD2TP","254eb19750975bda":"8iIJm","2f01f54810b729a0":"lmr1u","f352701af16ccb01":"88qwO","c5798f0bf47c2f71":"8SraZ"}],"960Av":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("2f5378debd330ed5");
var defineBuiltIn = require("5e0718aecf12f1e8");
var toString = require("6b32f4accffdcba8");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
    unsafe: true
});

},{"2f5378debd330ed5":"khCzU","5e0718aecf12f1e8":"jlXZ9","6b32f4accffdcba8":"aFRug"}],"aFRug":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("312e54676af41375");
var classof = require("2dbce13c946fe9d0");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
    return '[object ' + classof(this) + ']';
};

},{"312e54676af41375":"khCzU","2dbce13c946fe9d0":"7T1aN"}],"aGyku":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("eb35dc894cb42ba5");
var $values = require("f1b9830bcb61759d").values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({
    target: 'Object',
    stat: true
}, {
    values: function values(O) {
        return $values(O);
    }
});

},{"eb35dc894cb42ba5":"gD2TP","f1b9830bcb61759d":"1A8Zv"}],"is7gu":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require("71201fb984fca5e2");
require("944d2d67bf4aa279");
require("259dee16b78a9293");
require("bac68e84460cf44d");
require("35807fabff0322bf");
require("8713c69981abff7e");

},{"71201fb984fca5e2":"hBAwp","944d2d67bf4aa279":"4zpe0","259dee16b78a9293":"5xOlQ","bac68e84460cf44d":"iuxko","35807fabff0322bf":"cZZKW","8713c69981abff7e":"dc6pU"}],"hBAwp":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("cdd137752c5b4a8e");
var IS_PURE = require("27c8c7e1f0444fd2");
var IS_NODE = require("e9cf171cc5f9ff78");
var globalThis = require("d198a89966b49f7a");
var call = require("643c25bd5b0dfc21");
var defineBuiltIn = require("76c41f8cfb7124b7");
var setPrototypeOf = require("6f7c1c1190868f98");
var setToStringTag = require("8b9ff6cd5f4bf470");
var setSpecies = require("e2d999cd3139e29e");
var aCallable = require("37ba5f9496a9ce6f");
var isCallable = require("c754acf38f3fbf83");
var isObject = require("f9d3438feb00503");
var anInstance = require("eea1cec1753c28d3");
var speciesConstructor = require("2b3f8c9a01947fd4");
var task = require("d7da4b96347ff949").set;
var microtask = require("5967e7e0ab765b55");
var hostReportErrors = require("45c77ce65cdfa56e");
var perform = require("ed2bd3e4981b5b7f");
var Queue = require("67a62e6e19993e50");
var InternalStateModule = require("d047e80fbdc4abaf");
var NativePromiseConstructor = require("cb21f79465bb7a4f");
var PromiseConstructorDetection = require("d92ec88829ba956d");
var newPromiseCapabilityModule = require("f518fe10c60b8bee");
var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
// helpers
var isThenable = function isThenable(it) {
    var then;
    return isObject(it) && isCallable(then = it.then) ? then : false;
};
var callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state === FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                state.rejection = HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new TypeError('Promise-chain cycle'));
            else if (then = isThenable(result)) call(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) onUnhandled(state);
    });
};
var dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if (DISPATCH_EVENT) {
        event = document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        globalThis.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
    else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};
var onUnhandled = function onUnhandled(state) {
    call(task, globalThis, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = perform(function() {
                if (IS_NODE) process.emit('unhandledRejection', value, promise);
                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var isUnhandled = function isUnhandled(state) {
    return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function onHandleUnhandled(state) {
    call(task, globalThis, function() {
        var promise = state.facade;
        if (IS_NODE) process.emit('rejectionHandled', promise);
        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
    });
};
var bind = function bind(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = REJECTED;
    notify(state, true);
};
var internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
        var then = isThenable(value);
        if (then) microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
            } catch (error) {
                internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
        }
    } catch (error) {
        internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    PromiseConstructor = function Promise(executor) {
        anInstance(this, PromisePrototype);
        aCallable(executor);
        call(Internal, this);
        var state = getInternalPromiseState(this);
        try {
            executor(bind(internalResolve, state), bind(internalReject, state));
        } catch (error) {
            internalReject(state, error);
        }
    };
    PromisePrototype = PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    Internal = function Promise(executor) {
        setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new Queue(),
            rejection: false,
            state: PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = getInternalPromiseState(this);
        var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
        state.parent = true;
        reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
        reaction.fail = isCallable(onRejected) && onRejected;
        reaction.domain = IS_NODE ? process.domain : undefined;
        if (state.state === PENDING) state.reactions.add(reaction);
        else microtask(function() {
            callReaction(reaction, state);
        });
        return reaction.promise;
    });
    OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new Internal();
        var state = getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = bind(internalResolve, state);
        this.reject = bind(internalReject, state);
    };
    newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
    if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
        nativeThen = NativePromisePrototype.then;
        if (!NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new PromiseConstructor(function(resolve, reject) {
                call(nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({
    global: true,
    constructor: true,
    wrap: true,
    forced: FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

},{"cdd137752c5b4a8e":"gD2TP","27c8c7e1f0444fd2":"6KD1D","e9cf171cc5f9ff78":"kzs70","d198a89966b49f7a":"4naf8","643c25bd5b0dfc21":"ebTVd","76c41f8cfb7124b7":"jlXZ9","6f7c1c1190868f98":"hmY3h","8b9ff6cd5f4bf470":"3q5sA","e2d999cd3139e29e":"7q10a","37ba5f9496a9ce6f":"ehOyc","c754acf38f3fbf83":"37CJl","f9d3438feb00503":"8iIJm","eea1cec1753c28d3":"9RDjg","2b3f8c9a01947fd4":"1Johb","d7da4b96347ff949":"iFrSo","5967e7e0ab765b55":"6gdfi","45c77ce65cdfa56e":"evUlL","ed2bd3e4981b5b7f":"hHxaK","67a62e6e19993e50":"K2HVM","d047e80fbdc4abaf":"4Dlpx","cb21f79465bb7a4f":"jf03M","d92ec88829ba956d":"2WlPb","f518fe10c60b8bee":"k9KEN"}],"kzs70":[function(require,module,exports,__globalThis) {
'use strict';
var ENVIRONMENT = require("5fac34e3c4c0e043");
module.exports = ENVIRONMENT === 'NODE';

},{"5fac34e3c4c0e043":"8tXV2"}],"8tXV2":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
/* global Bun, Deno -- detection */ var globalThis = require("7dc361f46ecde901");
var userAgent = require("9f6e24ecbba66a9e");
var classof = require("a008a59fdc341842");
var userAgentStartsWith = function userAgentStartsWith(string) {
    return userAgent.slice(0, string.length) === string;
};
module.exports = function() {
    if (userAgentStartsWith('Bun/')) return 'BUN';
    if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if (userAgentStartsWith('Deno/')) return 'DENO';
    if (userAgentStartsWith('Node.js/')) return 'NODE';
    if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
    if (globalThis.Deno && (0, _typeOf._)(Deno.version) == 'object') return 'DENO';
    if (classof(globalThis.process) === 'process') return 'NODE';
    if (globalThis.window && globalThis.document) return 'BROWSER';
    return 'REST';
}();

},{"@swc/helpers/_/_type_of":"668P4","7dc361f46ecde901":"4naf8","9f6e24ecbba66a9e":"7UNqW","a008a59fdc341842":"fGBNn"}],"1Johb":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("1dd3546388607f52");
var aConstructor = require("1407b26f20411731");
var isNullOrUndefined = require("e59a7a10597b8e96");
var wellKnownSymbol = require("16c256a8cc3c03fd");
var SPECIES = wellKnownSymbol('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

},{"1dd3546388607f52":"2dEST","1407b26f20411731":"ciuOu","e59a7a10597b8e96":"9lebS","16c256a8cc3c03fd":"6dJgl"}],"ciuOu":[function(require,module,exports,__globalThis) {
'use strict';
var isConstructor = require("f0753b26326019c1");
var tryToString = require("8e6a26f37529644e");
var $TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if (isConstructor(argument)) return argument;
    throw new $TypeError(tryToString(argument) + ' is not a constructor');
};

},{"f0753b26326019c1":"2hXCr","8e6a26f37529644e":"b8XMV"}],"iFrSo":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("629a4d99f4fe5b2e");
var apply = require("e574be68c288c7c8");
var bind = require("df212787338802d3");
var isCallable = require("afdf018c2d01bbc6");
var hasOwn = require("35a3e849940fd612");
var fails = require("b8bf5434d2248ca7");
var html = require("731f9370cc21fc3b");
var arraySlice = require("ec358060964e4bde");
var createElement = require("907adb6d219da7a3");
var validateArgumentsLength = require("f398561ebd49a798");
var IS_IOS = require("8a8e342aaad83bb");
var IS_NODE = require("6eef8b4e43dd6731");
var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;
fails(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $location = globalThis.location;
});
var run = function run(id) {
    if (hasOwn(queue, id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
    }
};
var runner = function runner(id) {
    return function() {
        run(id);
    };
};
var eventListener = function eventListener(event) {
    run(event.data);
};
var globalPostMessageDefer = function globalPostMessageDefer(id) {
    // old engines have not location.origin
    globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
    set = function setImmediate(handler) {
        validateArgumentsLength(arguments.length, 1);
        var fn = isCallable(handler) ? handler : Function(handler);
        var args = arraySlice(arguments, 1);
        queue[++counter] = function() {
            apply(fn, undefined, args);
        };
        defer(counter);
        return counter;
    };
    clear = function clearImmediate(id) {
        delete queue[id];
    };
    // Node.js 0.8-
    if (IS_NODE) defer = function defer(id) {
        process.nextTick(runner(id));
    };
    else if (Dispatch && Dispatch.now) defer = function defer(id) {
        Dispatch.now(runner(id));
    };
    else if (MessageChannel && !IS_IOS) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = eventListener;
        defer = bind(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (globalThis.addEventListener && isCallable(globalThis.postMessage) && !globalThis.importScripts && $location && $location.protocol !== 'file:' && !fails(globalPostMessageDefer)) {
        defer = globalPostMessageDefer;
        globalThis.addEventListener('message', eventListener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in createElement('script')) defer = function defer(id) {
        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
            html.removeChild(this);
            run(id);
        };
    };
    else defer = function defer(id) {
        setTimeout(runner(id), 0);
    };
}
module.exports = {
    set: set,
    clear: clear
};

},{"629a4d99f4fe5b2e":"4naf8","e574be68c288c7c8":"kuGqn","df212787338802d3":"7xEW7","afdf018c2d01bbc6":"37CJl","35a3e849940fd612":"h2GWh","b8bf5434d2248ca7":"8SraZ","731f9370cc21fc3b":"kC0aD","ec358060964e4bde":"iIoNC","907adb6d219da7a3":"5Nn9T","f398561ebd49a798":"jHJH4","8a8e342aaad83bb":"bs0y0","6eef8b4e43dd6731":"kzs70"}],"jHJH4":[function(require,module,exports,__globalThis) {
'use strict';
var $TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $TypeError('Not enough arguments');
    return passed;
};

},{}],"bs0y0":[function(require,module,exports,__globalThis) {
'use strict';
var userAgent = require("88313d0d5d3e28c");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"88313d0d5d3e28c":"7UNqW"}],"6gdfi":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("f872aba82a3b0b65");
var safeGetBuiltIn = require("d65d53880ca448da");
var bind = require("c6f841b26dc6586e");
var macrotask = require("e7b8d665c6b82c12").set;
var Queue = require("78ca3b778736fc30");
var IS_IOS = require("e694c6aea443b084");
var IS_IOS_PEBBLE = require("b0a0e151fbd36f02");
var IS_WEBOS_WEBKIT = require("d48f26179ef02c02");
var IS_NODE = require("e809fd0b68a5879f");
var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;
// modern engines have queueMicrotask method
if (!microtask) {
    var queue = new Queue();
    var flush = function flush() {
        var parent, fn;
        if (IS_NODE && (parent = process.domain)) parent.exit();
        while(fn = queue.get())try {
            fn();
        } catch (error) {
            if (queue.head) notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
        toggle = true;
        node = document.createTextNode('');
        new MutationObserver(flush).observe(node, {
            characterData: true
        });
        notify = function notify() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        promise = Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        promise.constructor = Promise;
        then = bind(promise.then, promise);
        notify = function notify() {
            then(flush);
        };
    // Node.js without promises
    } else if (IS_NODE) notify = function notify() {
        process.nextTick(flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        macrotask = bind(macrotask, globalThis);
        notify = function notify() {
            macrotask(flush);
        };
    }
    microtask = function microtask(fn) {
        if (!queue.head) notify();
        queue.add(fn);
    };
}
module.exports = microtask;

},{"f872aba82a3b0b65":"4naf8","d65d53880ca448da":"lpzqk","c6f841b26dc6586e":"7xEW7","e7b8d665c6b82c12":"iFrSo","78ca3b778736fc30":"K2HVM","e694c6aea443b084":"bs0y0","b0a0e151fbd36f02":"8cQqi","d48f26179ef02c02":"alslr","e809fd0b68a5879f":"kzs70"}],"lpzqk":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("fea114a3220626fd");
var DESCRIPTORS = require("8329936952af7ff");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!DESCRIPTORS) return globalThis[name];
    var descriptor = getOwnPropertyDescriptor(globalThis, name);
    return descriptor && descriptor.value;
};

},{"fea114a3220626fd":"4naf8","8329936952af7ff":"ihfdR"}],"K2HVM":[function(require,module,exports,__globalThis) {
'use strict';
var Queue = function Queue() {
    this.head = null;
    this.tail = null;
};
Queue.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = Queue;

},{}],"8cQqi":[function(require,module,exports,__globalThis) {
'use strict';
var userAgent = require("6993865deab208b1");
module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';

},{"6993865deab208b1":"7UNqW"}],"alslr":[function(require,module,exports,__globalThis) {
'use strict';
var userAgent = require("c48e030879980deb");
module.exports = /web0s(?!.*chrome)/i.test(userAgent);

},{"c48e030879980deb":"7UNqW"}],"evUlL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

},{}],"hHxaK":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

},{}],"jf03M":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("5c31330fc800d47f");
module.exports = globalThis.Promise;

},{"5c31330fc800d47f":"4naf8"}],"2WlPb":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("858d6f549d7f3b06");
var NativePromiseConstructor = require("914dda54bcca9f98");
var isCallable = require("9560dd8306c037cf");
var isForced = require("dc1381594b318fd4");
var inspectSource = require("f6b84f5d53cc51bf");
var wellKnownSymbol = require("28acb9f62af6dfc2");
var ENVIRONMENT = require("45a29d2d770fea8");
var IS_PURE = require("c00f2fe103f19409");
var V8_VERSION = require("dc99ee072f0f0ef8");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new NativePromiseConstructor(function(resolve) {
            resolve(1);
        });
        var FakePromise = function FakePromise(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[SPECIES] = FakePromise;
        SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: SUBCLASSING
};

},{"858d6f549d7f3b06":"4naf8","914dda54bcca9f98":"jf03M","9560dd8306c037cf":"37CJl","dc1381594b318fd4":"g6zdI","f6b84f5d53cc51bf":"hD4ao","28acb9f62af6dfc2":"6dJgl","45a29d2d770fea8":"8tXV2","c00f2fe103f19409":"6KD1D","dc99ee072f0f0ef8":"7Fmxi"}],"k9KEN":[function(require,module,exports,__globalThis) {
'use strict';
var aCallable = require("b85cb5089dafddf1");
var $TypeError = TypeError;
var PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = aCallable(resolve);
    this.reject = aCallable(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function(C) {
    return new PromiseCapability(C);
};

},{"b85cb5089dafddf1":"ehOyc"}],"4zpe0":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5fe91bc37669c5a0");
var call = require("f3e846242a85204b");
var aCallable = require("b44cc3ada152502d");
var newPromiseCapabilityModule = require("598afe33e3f52cb1");
var perform = require("e989f176969dcec5");
var iterate = require("3f72073566ddc960");
var PROMISE_STATICS_INCORRECT_ITERATION = require("881fce5de451c4fe");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({
    target: 'Promise',
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION
}, {
    all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapabilityModule.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                call($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

},{"5fe91bc37669c5a0":"gD2TP","f3e846242a85204b":"ebTVd","b44cc3ada152502d":"ehOyc","598afe33e3f52cb1":"k9KEN","e989f176969dcec5":"hHxaK","3f72073566ddc960":"gjriO","881fce5de451c4fe":"hhF4S"}],"hhF4S":[function(require,module,exports,__globalThis) {
'use strict';
var NativePromiseConstructor = require("d3fcaf55cfa61757");
var checkCorrectnessOfIteration = require("27318831369e2a7e");
var FORCED_PROMISE_CONSTRUCTOR = require("a7dca7fabf4d8c44").CONSTRUCTOR;
module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function(iterable) {
    NativePromiseConstructor.all(iterable).then(undefined, function() {});
});

},{"d3fcaf55cfa61757":"jf03M","27318831369e2a7e":"21ceT","a7dca7fabf4d8c44":"2WlPb"}],"5xOlQ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f9109f39e0c1eace");
var IS_PURE = require("b0f691f2694fd89e");
var FORCED_PROMISE_CONSTRUCTOR = require("f07c13c93306bd7f").CONSTRUCTOR;
var NativePromiseConstructor = require("31561c9d3d855c60");
var getBuiltIn = require("1ba3086b4a897ac4");
var isCallable = require("7dd264a6360c2a5a");
var defineBuiltIn = require("baa11ffea0878c3e");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({
    target: 'Promise',
    proto: true,
    forced: FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
    var method = getBuiltIn('Promise').prototype['catch'];
    if (NativePromisePrototype['catch'] !== method) defineBuiltIn(NativePromisePrototype, 'catch', method, {
        unsafe: true
    });
}

},{"f9109f39e0c1eace":"gD2TP","b0f691f2694fd89e":"6KD1D","f07c13c93306bd7f":"2WlPb","31561c9d3d855c60":"jf03M","1ba3086b4a897ac4":"iXpu0","7dd264a6360c2a5a":"37CJl","baa11ffea0878c3e":"jlXZ9"}],"iuxko":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("4068f648151c1330");
var call = require("658417f940db2db2");
var aCallable = require("5199435aa17f3955");
var newPromiseCapabilityModule = require("f7224a0a89bb6794");
var perform = require("477a19c99b10aa32");
var iterate = require("970f1b07d9125958");
var PROMISE_STATICS_INCORRECT_ITERATION = require("d71553795a1298b8");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({
    target: 'Promise',
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapabilityModule.f(C);
        var reject = capability.reject;
        var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            iterate(iterable, function(promise) {
                call($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

},{"4068f648151c1330":"gD2TP","658417f940db2db2":"ebTVd","5199435aa17f3955":"ehOyc","f7224a0a89bb6794":"k9KEN","477a19c99b10aa32":"hHxaK","970f1b07d9125958":"gjriO","d71553795a1298b8":"hhF4S"}],"cZZKW":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ec46f4bb3616ad7b");
var newPromiseCapabilityModule = require("3f8b88f93499a7cd");
var FORCED_PROMISE_CONSTRUCTOR = require("2ae203822949c331").CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({
    target: 'Promise',
    stat: true,
    forced: FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = newPromiseCapabilityModule.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

},{"ec46f4bb3616ad7b":"gD2TP","3f8b88f93499a7cd":"k9KEN","2ae203822949c331":"2WlPb"}],"dc6pU":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("a4f3ef37c946dd2b");
var getBuiltIn = require("2794b78b0ca3694f");
var IS_PURE = require("c6e440c7abf54a3a");
var NativePromiseConstructor = require("c3eef09c8272b2fa");
var FORCED_PROMISE_CONSTRUCTOR = require("ca944314fb589e9b").CONSTRUCTOR;
var promiseResolve = require("95f41bf564123591");
var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({
    target: 'Promise',
    stat: true,
    forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
    }
});

},{"a4f3ef37c946dd2b":"gD2TP","2794b78b0ca3694f":"iXpu0","c6e440c7abf54a3a":"6KD1D","c3eef09c8272b2fa":"jf03M","ca944314fb589e9b":"2WlPb","95f41bf564123591":"WSmSP"}],"WSmSP":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("5304a07f7517b45f");
var isObject = require("6179ead91f16d16e");
var newPromiseCapability = require("1e7f70c2e43192d5");
module.exports = function(C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

},{"5304a07f7517b45f":"2dEST","6179ead91f16d16e":"8iIJm","1e7f70c2e43192d5":"k9KEN"}],"5VPH4":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5967530d4e981375");
var IS_PURE = require("ea0758f982664c1b");
var NativePromiseConstructor = require("252abba36f7f031b");
var fails = require("672a58147e86eb31");
var getBuiltIn = require("5ba40ea71aea909");
var isCallable = require("ea376840732ca40e");
var speciesConstructor = require("83b04bdccb7f39e2");
var promiseResolve = require("a624c6d6ecebe4ab");
var defineBuiltIn = require("7367d4d000a0f3e2");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    NativePromisePrototype['finally'].call({
        then: function then() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({
    target: 'Promise',
    proto: true,
    real: true,
    forced: NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = speciesConstructor(this, getBuiltIn('Promise'));
        var isFunction = isCallable(onFinally);
        return this.then(isFunction ? function(x) {
            return promiseResolve(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return promiseResolve(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
    var method = getBuiltIn('Promise').prototype['finally'];
    if (NativePromisePrototype['finally'] !== method) defineBuiltIn(NativePromisePrototype, 'finally', method, {
        unsafe: true
    });
}

},{"5967530d4e981375":"gD2TP","ea0758f982664c1b":"6KD1D","252abba36f7f031b":"jf03M","672a58147e86eb31":"8SraZ","5ba40ea71aea909":"iXpu0","ea376840732ca40e":"37CJl","83b04bdccb7f39e2":"1Johb","a624c6d6ecebe4ab":"WSmSP","7367d4d000a0f3e2":"jlXZ9"}],"gB6dg":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1c621266486af366");
var functionApply = require("8dc2c7c905c7079");
var aCallable = require("65b541dabe35d529");
var anObject = require("536113b176a05b60");
var fails = require("e032bfdb61e2620b");
// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function() {});
});
// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({
    target: 'Reflect',
    stat: true,
    forced: OPTIONAL_ARGUMENTS_LIST
}, {
    apply: function apply(target, thisArgument, argumentsList) {
        return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
    }
});

},{"1c621266486af366":"gD2TP","8dc2c7c905c7079":"kuGqn","65b541dabe35d529":"ehOyc","536113b176a05b60":"2dEST","e032bfdb61e2620b":"8SraZ"}],"eNY0D":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("df593a7c66399ae2");
var getBuiltIn = require("aa786cd255199284");
var apply = require("c585a7fc86970645");
var bind = require("d05ce57b271ff568");
var aConstructor = require("488fff441ba5bfef");
var anObject = require("688b651555d83b8f");
var isObject = require("c7a921b7c24a97c");
var create = require("2ff4acc7df7eb046");
var fails = require("2ad48193afce6a95");
var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function() {
    function F() {}
    return !(nativeConstruct(function() {}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function() {
    nativeConstruct(function() {});
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;
$({
    target: 'Reflect',
    stat: true,
    forced: FORCED,
    sham: FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        aConstructor(Target);
        anObject(args);
        var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
        if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            apply(push, $args, args);
            return new (apply(bind, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = create(isObject(proto) ? proto : ObjectPrototype);
        var result = apply(Target, instance, args);
        return isObject(result) ? result : instance;
    }
});

},{"df593a7c66399ae2":"gD2TP","aa786cd255199284":"iXpu0","c585a7fc86970645":"kuGqn","d05ce57b271ff568":"bo5xC","488fff441ba5bfef":"ciuOu","688b651555d83b8f":"2dEST","c7a921b7c24a97c":"8iIJm","2ff4acc7df7eb046":"5ZmqN","2ad48193afce6a95":"8SraZ"}],"bo5xC":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("94a95e8ae25b0044");
var aCallable = require("4072cb1aa6784cb2");
var isObject = require("16c540423602bd07");
var hasOwn = require("2a423fe0321fe359");
var arraySlice = require("29b660c46e7d5c44");
var NATIVE_BIND = require("14cd4065b37036f8");
var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};
var construct = function construct(C, argsLength, args) {
    if (!hasOwn(factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
    }
    return factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */ ) {
    var F = aCallable(this);
    var Prototype = F.prototype;
    var partArgs = arraySlice(arguments, 1);
    var boundFunction = function bound() {
        var args = concat(partArgs, arraySlice(arguments));
        return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
    };
    if (isObject(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

},{"94a95e8ae25b0044":"jsw26","4072cb1aa6784cb2":"ehOyc","16c540423602bd07":"8iIJm","2a423fe0321fe359":"h2GWh","29b660c46e7d5c44":"iIoNC","14cd4065b37036f8":"hQNpA"}],"cSswi":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("dc2eaf4c122f82d4");
var DESCRIPTORS = require("55416992b3cdb7ec");
var anObject = require("c2c755875e2adbfa");
var toPropertyKey = require("578d27629d28889e");
var definePropertyModule = require("426724837dbcc1e9");
var fails = require("71d0ba7a21c21fc7");
// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty(definePropertyModule.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
});
// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$({
    target: 'Reflect',
    stat: true,
    forced: ERROR_INSTEAD_OF_FALSE,
    sham: !DESCRIPTORS
}, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        anObject(target);
        var key = toPropertyKey(propertyKey);
        anObject(attributes);
        try {
            definePropertyModule.f(target, key, attributes);
            return true;
        } catch (error) {
            return false;
        }
    }
});

},{"dc2eaf4c122f82d4":"gD2TP","55416992b3cdb7ec":"ihfdR","c2c755875e2adbfa":"2dEST","578d27629d28889e":"9pd5y","426724837dbcc1e9":"4d2AB","71d0ba7a21c21fc7":"8SraZ"}],"g1HId":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("6dcb929d30bdbfde");
var anObject = require("3dedf4d14121a863");
var getOwnPropertyDescriptor = require("fbd53ec455a05b95").f;
// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$({
    target: 'Reflect',
    stat: true
}, {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
        return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
    }
});

},{"6dcb929d30bdbfde":"gD2TP","3dedf4d14121a863":"2dEST","fbd53ec455a05b95":"hRqf9"}],"gykFO":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("36af64a139a04a9f");
var call = require("2b0e8e0105e0ccfb");
var isObject = require("c12275a56fb80891");
var anObject = require("8afae34daed2ddfd");
var isDataDescriptor = require("a0fe3971b7cb6675");
var getOwnPropertyDescriptorModule = require("64fb71955ccea62a");
var getPrototypeOf = require("42f515e0257c869d");
// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if (anObject(target) === receiver) return target[propertyKey];
    descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
    if (descriptor) return isDataDescriptor(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
    if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}
$({
    target: 'Reflect',
    stat: true
}, {
    get: get
});

},{"36af64a139a04a9f":"gD2TP","2b0e8e0105e0ccfb":"ebTVd","c12275a56fb80891":"8iIJm","8afae34daed2ddfd":"2dEST","a0fe3971b7cb6675":"kZNaH","64fb71955ccea62a":"hRqf9","42f515e0257c869d":"lFnuf"}],"kZNaH":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("50fb4bd8f6d0c370");
module.exports = function(descriptor) {
    return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};

},{"50fb4bd8f6d0c370":"h2GWh"}],"grkNa":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("d7bd54e98aaffcc7");
var DESCRIPTORS = require("7232f0c071c940d0");
var anObject = require("10cdead7a28df296");
var getOwnPropertyDescriptorModule = require("de341026ceb57ac3");
// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$({
    target: 'Reflect',
    stat: true,
    sham: !DESCRIPTORS
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
    }
});

},{"d7bd54e98aaffcc7":"gD2TP","7232f0c071c940d0":"ihfdR","10cdead7a28df296":"2dEST","de341026ceb57ac3":"hRqf9"}],"DD8SS":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e0d7bd3b2cd5e427");
var anObject = require("28c21999f76acbe2");
var objectGetPrototypeOf = require("5d4e809754fe7c85");
var CORRECT_PROTOTYPE_GETTER = require("b7b6a27574b33ffc");
// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({
    target: 'Reflect',
    stat: true,
    sham: !CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(target) {
        return objectGetPrototypeOf(anObject(target));
    }
});

},{"e0d7bd3b2cd5e427":"gD2TP","28c21999f76acbe2":"2dEST","5d4e809754fe7c85":"lFnuf","b7b6a27574b33ffc":"7WzpM"}],"gVdUt":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f5a4987d6328de60");
// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$({
    target: 'Reflect',
    stat: true
}, {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});

},{"f5a4987d6328de60":"gD2TP"}],"eyQ17":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f1cf95331dac0a5c");
var anObject = require("6ffd352ee2b78315");
var $isExtensible = require("ec1223a1980707d0");
// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$({
    target: 'Reflect',
    stat: true
}, {
    isExtensible: function isExtensible(target) {
        anObject(target);
        return $isExtensible(target);
    }
});

},{"f1cf95331dac0a5c":"gD2TP","6ffd352ee2b78315":"2dEST","ec1223a1980707d0":"hCJ0Z"}],"6ICFT":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e6256b53ff8e7ff7");
var ownKeys = require("62694a198a2d39f1");
// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({
    target: 'Reflect',
    stat: true
}, {
    ownKeys: ownKeys
});

},{"e6256b53ff8e7ff7":"gD2TP","62694a198a2d39f1":"8iAdE"}],"7WFT6":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("21a794712b7c3b28");
var getBuiltIn = require("b2540e28cfeb7421");
var anObject = require("5c89b74916f5e3f1");
var FREEZING = require("368dee480fe6c03a");
// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$({
    target: 'Reflect',
    stat: true,
    sham: !FREEZING
}, {
    preventExtensions: function preventExtensions(target) {
        anObject(target);
        try {
            var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
            if (objectPreventExtensions) objectPreventExtensions(target);
            return true;
        } catch (error) {
            return false;
        }
    }
});

},{"21a794712b7c3b28":"gD2TP","b2540e28cfeb7421":"iXpu0","5c89b74916f5e3f1":"2dEST","368dee480fe6c03a":"88qwO"}],"j3YwZ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("ecfb0dd8a941692d");
var call = require("ff301a827b8a1848");
var anObject = require("2c02940a559ef1bc");
var isObject = require("7a2e80973762c50c");
var isDataDescriptor = require("21efaf46e8fea96f");
var fails = require("8f78be83a230ea4a");
var definePropertyModule = require("acf3c26369354b83");
var getOwnPropertyDescriptorModule = require("4893e43c9a11fc63");
var getPrototypeOf = require("48482fa6862b803a");
var createPropertyDescriptor = require("de1987fde7f85915");
// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if (isObject(prototype = getPrototypeOf(target))) return set(prototype, propertyKey, V, receiver);
        ownDescriptor = createPropertyDescriptor(0);
    }
    if (isDataDescriptor(ownDescriptor)) {
        if (ownDescriptor.writable === false || !isObject(receiver)) return false;
        if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            definePropertyModule.f(receiver, propertyKey, existingDescriptor);
        } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        call(setter, receiver, V);
    }
    return true;
}
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails(function() {
    var Constructor = function Constructor() {};
    var object = definePropertyModule.f(new Constructor(), 'a', {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});
$({
    target: 'Reflect',
    stat: true,
    forced: MS_EDGE_BUG
}, {
    set: set
});

},{"ecfb0dd8a941692d":"gD2TP","ff301a827b8a1848":"ebTVd","2c02940a559ef1bc":"2dEST","7a2e80973762c50c":"8iIJm","21efaf46e8fea96f":"kZNaH","8f78be83a230ea4a":"8SraZ","acf3c26369354b83":"4d2AB","4893e43c9a11fc63":"hRqf9","48482fa6862b803a":"lFnuf","de1987fde7f85915":"jtAW3"}],"enTUc":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1901fc8accbc2376");
var anObject = require("1c4ec63b43256656");
var aPossiblePrototype = require("2fee865898c5ee13");
var objectSetPrototypeOf = require("f549073ca7dfb3d2");
// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) $({
    target: 'Reflect',
    stat: true
}, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        anObject(target);
        aPossiblePrototype(proto);
        try {
            objectSetPrototypeOf(target, proto);
            return true;
        } catch (error) {
            return false;
        }
    }
});

},{"1901fc8accbc2376":"gD2TP","1c4ec63b43256656":"2dEST","2fee865898c5ee13":"bqV2q","f549073ca7dfb3d2":"hmY3h"}],"jdv2T":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("c8639d3a74e6bb07");
var globalThis = require("31e10ac977d93a17");
var uncurryThis = require("7f079a60fe35f235");
var isForced = require("66b0d772c6e443af");
var inheritIfRequired = require("11d7cdfa8687037e");
var createNonEnumerableProperty = require("5fcf789712ec006");
var create = require("488fe57e39be2d0d");
var getOwnPropertyNames = require("8b1d3e9ebc10b376").f;
var isPrototypeOf = require("6c4ec99bc7b85243");
var isRegExp = require("28b4ed60c7ffe147");
var toString = require("f00c99d31179ed39");
var getRegExpFlags = require("867ea555b957a0aa");
var stickyHelpers = require("86e9756a5a6a0176");
var proxyAccessor = require("438bf11983e20900");
var defineBuiltIn = require("818c2b1aecf93017");
var fails = require("5b540f0dbf00266f");
var hasOwn = require("5cfbf10059a84a33");
var enforceInternalState = require("2ff319236881379d").enforce;
var setSpecies = require("7f2183994b17a7e8");
var wellKnownSymbol = require("7edc7513ec6ac4d0");
var UNSUPPORTED_DOT_ALL = require("fbaf905791cdbfe");
var UNSUPPORTED_NCG = require("28f5087d79ccd92a");
var MATCH = wellKnownSymbol('match');
var NativeRegExp = globalThis.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = globalThis.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;
// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;
var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var BASE_FORCED = DESCRIPTORS && (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function() {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
}));
var handleDotAll = function handleDotAll(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = charAt(string, index);
        if (chr === '\\') {
            result += chr + charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === '.') result += '[\\s\\S]';
        else {
            if (chr === '[') brackets = true;
            else if (chr === ']') brackets = false;
            result += chr;
        }
    }
    return result;
};
var handleNCG = function handleNCG(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var named = [];
    var names = create(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = '';
    var chr;
    for(; index <= length; index++){
        chr = charAt(string, index);
        if (chr === '\\') chr += charAt(string, ++index);
        else if (chr === ']') brackets = false;
        else if (!brackets) switch(true){
            case chr === '[':
                brackets = true;
                break;
            case chr === '(':
                result += chr;
                // ignore non-capturing groups
                if (stringSlice(string, index + 1, index + 3) === '?:') continue;
                if (exec(IS_NCG, stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                groupid++;
                continue;
            case chr === '>' && ncg:
                if (groupname === '' || hasOwn(names, groupname)) throw new SyntaxError('Invalid capture group name');
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = '';
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
    var RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
        var patternIsRegExp = isRegExp(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) return pattern;
        if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
        }
        pattern = pattern === undefined ? '' : toString(pattern);
        flags = flags === undefined ? '' : toString(flags);
        rawPattern = pattern;
        if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
            dotAll = !!flags && stringIndexOf(flags, 's') > -1;
            if (dotAll) flags = replace(flags, /s/g, '');
        }
        rawFlags = flags;
        if (MISSED_STICKY && 'sticky' in re1) {
            sticky = !!flags && stringIndexOf(flags, 'y') > -1;
            if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
        }
        if (UNSUPPORTED_NCG) {
            handled = handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;)proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
    RegExpPrototype.constructor = RegExpWrapper;
    RegExpWrapper.prototype = RegExpPrototype;
    defineBuiltIn(globalThis, 'RegExp', RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

},{"c8639d3a74e6bb07":"ihfdR","31e10ac977d93a17":"4naf8","7f079a60fe35f235":"jsw26","66b0d772c6e443af":"g6zdI","11d7cdfa8687037e":"a2ozq","5fcf789712ec006":"3IHVb","488fe57e39be2d0d":"5ZmqN","8b1d3e9ebc10b376":"busKr","6c4ec99bc7b85243":"fVGN3","28b4ed60c7ffe147":"aGrU8","f00c99d31179ed39":"ffo0a","867ea555b957a0aa":"kXQYO","86e9756a5a6a0176":"34VgK","438bf11983e20900":"bNWye","818c2b1aecf93017":"jlXZ9","5b540f0dbf00266f":"8SraZ","5cfbf10059a84a33":"h2GWh","2ff319236881379d":"4Dlpx","7f2183994b17a7e8":"7q10a","7edc7513ec6ac4d0":"6dJgl","fbaf905791cdbfe":"8quRA","28f5087d79ccd92a":"2Al5O"}],"aGrU8":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("4ca57df9821dbfa3");
var classof = require("b867bee476fc5018");
var wellKnownSymbol = require("42cd33b6dbd61bee");
var MATCH = wellKnownSymbol('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

},{"4ca57df9821dbfa3":"8iIJm","b867bee476fc5018":"fGBNn","42cd33b6dbd61bee":"6dJgl"}],"kXQYO":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("fd54476372f3a204");
var hasOwn = require("a12d2126c329f45");
var isPrototypeOf = require("815509f48e0b1e36");
var regExpFlags = require("37fba4854c4ab846");
var RegExpPrototype = RegExp.prototype;
module.exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R) ? call(regExpFlags, R) : flags;
};

},{"fd54476372f3a204":"ebTVd","a12d2126c329f45":"h2GWh","815509f48e0b1e36":"fVGN3","37fba4854c4ab846":"kR9Fx"}],"kR9Fx":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("136abace0aec2b5c");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = anObject(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};

},{"136abace0aec2b5c":"2dEST"}],"34VgK":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("797bef35e651cb5e");
var globalThis = require("d87f6288614c07bc");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = globalThis.RegExp;
var UNSUPPORTED_Y = fails(function() {
    var re = $RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
    return !$RegExp('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
module.exports = {
    BROKEN_CARET: BROKEN_CARET,
    MISSED_STICKY: MISSED_STICKY,
    UNSUPPORTED_Y: UNSUPPORTED_Y
};

},{"797bef35e651cb5e":"8SraZ","d87f6288614c07bc":"4naf8"}],"bNWye":[function(require,module,exports,__globalThis) {
'use strict';
var defineProperty = require("e52fa9ee07db5896").f;
module.exports = function(Target, Source, key) {
    key in Target || defineProperty(Target, key, {
        configurable: true,
        get: function get() {
            return Source[key];
        },
        set: function set(it) {
            Source[key] = it;
        }
    });
};

},{"e52fa9ee07db5896":"4d2AB"}],"8quRA":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("e4784e58ea762065");
var globalThis = require("ea51a856230c58ac");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
    var re = $RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});

},{"e4784e58ea762065":"8SraZ","ea51a856230c58ac":"4naf8"}],"2Al5O":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("b9b1a0fbdd999ded");
var globalThis = require("f47a97b0c4cfeafc");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
    var re = $RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

},{"b9b1a0fbdd999ded":"8SraZ","f47a97b0c4cfeafc":"4naf8"}],"jqZha":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("72ba4de9841213e");
var exec = require("d4ebaff1663cc5b9");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== exec
}, {
    exec: exec
});

},{"72ba4de9841213e":"gD2TP","d4ebaff1663cc5b9":"lt6Bu"}],"lt6Bu":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = require("698f504b4733b02d");
var uncurryThis = require("6d0d2df39383a10b");
var toString = require("382af5492ddc18e6");
var regexpFlags = require("96e0244464229d3");
var stickyHelpers = require("3bd1d72d4987e0ff");
var shared = require("12c3e6e355312395");
var create = require("38d060dff8e4ab54");
var getInternalState = require("aec1e11e2cd92d19").get;
var UNSUPPORTED_DOT_ALL = require("7d9db6b4177b833a");
var UNSUPPORTED_NCG = require("b26a8ca5152d0a8d");
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    call(nativeExec, re1, 'a');
    call(nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = call(patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = replace(flags, 'y', '');
        if (indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = call(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = stringSlice(match.input, charsAdded);
            match[0] = stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    call(nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
module.exports = patchedExec;

},{"698f504b4733b02d":"ebTVd","6d0d2df39383a10b":"jsw26","382af5492ddc18e6":"ffo0a","96e0244464229d3":"kR9Fx","3bd1d72d4987e0ff":"34VgK","12c3e6e355312395":"h8old","38d060dff8e4ab54":"5ZmqN","aec1e11e2cd92d19":"4Dlpx","7d9db6b4177b833a":"8quRA","b26a8ca5152d0a8d":"2Al5O"}],"2BmqD":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("abb60413048cbe14");
var DESCRIPTORS = require("32574bd865b8e6e5");
var defineBuiltInAccessor = require("ba3ead2b02aa5c9b");
var regExpFlags = require("67e6b6bed174b69b");
var fails = require("f4050f72fe5dda92");
// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = globalThis.RegExp;
var RegExpPrototype = RegExp.prototype;
var FORCED = DESCRIPTORS && fails(function() {
    var INDICES_SUPPORT = true;
    try {
        RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function addGetter(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function get() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
    configurable: true,
    get: regExpFlags
});

},{"abb60413048cbe14":"4naf8","32574bd865b8e6e5":"ihfdR","ba3ead2b02aa5c9b":"g2LDG","67e6b6bed174b69b":"kR9Fx","f4050f72fe5dda92":"8SraZ"}],"20XVe":[function(require,module,exports,__globalThis) {
'use strict';
var PROPER_FUNCTION_NAME = require("9e28bead644082e").PROPER;
var defineBuiltIn = require("ffafe1474cec37ac");
var anObject = require("3135197806fbedfd");
var $toString = require("ce5dcf9b5e077a79");
var fails = require("577ada37101f923c");
var getRegExpFlags = require("7011e05c0011871a");
var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];
var NOT_GENERIC = fails(function() {
    return nativeToString.call({
        source: 'a',
        flags: 'b'
    }) !== '/a/b';
});
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
}, {
    unsafe: true
});

},{"9e28bead644082e":"cE4Pk","ffafe1474cec37ac":"jlXZ9","3135197806fbedfd":"2dEST","ce5dcf9b5e077a79":"ffo0a","577ada37101f923c":"8SraZ","7011e05c0011871a":"kXQYO"}],"i3LVh":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("24fec2aa1f17259b");

},{"24fec2aa1f17259b":"2AYQF"}],"2AYQF":[function(require,module,exports,__globalThis) {
'use strict';
var collection = require("7bd19ab966686a7d");
var collectionStrong = require("f40aa2253a9ed039");
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong);

},{"7bd19ab966686a7d":"fn4lx","f40aa2253a9ed039":"kpShx"}],"3Pezk":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("4793fe8f86582840");
var codeAt = require("785f7a78d0dffe20").codeAt;
// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({
    target: 'String',
    proto: true
}, {
    codePointAt: function codePointAt(pos) {
        return codeAt(this, pos);
    }
});

},{"4793fe8f86582840":"gD2TP","785f7a78d0dffe20":"6s5lj"}],"6s5lj":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("8b9beff9818f042");
var toIntegerOrInfinity = require("d3e375e7697978fb");
var toString = require("545a72c28133c459");
var requireObjectCoercible = require("5bafa9e5b372669c");
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);
var createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString(requireObjectCoercible($this));
        var position = toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
};

},{"8b9beff9818f042":"jsw26","d3e375e7697978fb":"wKg8O","545a72c28133c459":"ffo0a","5bafa9e5b372669c":"a0P0K"}],"g3adR":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("b3cd31deb9d32a8c");
var uncurryThis = require("c719ddda901eac13");
var getOwnPropertyDescriptor = require("e75304a6599a5e3c").f;
var toLength = require("99883df659b0f5cb");
var toString = require("e5d8defa036db553");
var notARegExp = require("4c78f4ce8264459e");
var requireObjectCoercible = require("da4ce5f132e95194");
var correctIsRegExpLogic = require("58da9c5323c25a0f");
var IS_PURE = require("e85ff4c5cebafc14");
var slice = uncurryThis(''.slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({
    target: 'String',
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = toString(requireObjectCoercible(this));
        notARegExp(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : min(toLength(endPosition), len);
        var search = toString(searchString);
        return slice(that, end - search.length, end) === search;
    }
});

},{"b3cd31deb9d32a8c":"gD2TP","c719ddda901eac13":"kBsBX","e75304a6599a5e3c":"hRqf9","99883df659b0f5cb":"4f0fH","e5d8defa036db553":"ffo0a","4c78f4ce8264459e":"3N240","da4ce5f132e95194":"a0P0K","58da9c5323c25a0f":"hyWXS","e85ff4c5cebafc14":"6KD1D"}],"3N240":[function(require,module,exports,__globalThis) {
'use strict';
var isRegExp = require("7b932b7711b6ae16");
var $TypeError = TypeError;
module.exports = function(it) {
    if (isRegExp(it)) throw new $TypeError("The method doesn't accept regular expressions");
    return it;
};

},{"7b932b7711b6ae16":"aGrU8"}],"hyWXS":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("303b9f26f388462e");
var MATCH = wellKnownSymbol('match');
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

},{"303b9f26f388462e":"6dJgl"}],"3D8UA":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f7ab90f668dfed5f");
var uncurryThis = require("f19d1a907413c68d");
var toAbsoluteIndex = require("6914a342ea61c319");
var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);
// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({
    target: 'String',
    stat: true,
    arity: 1,
    forced: INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
            elements[i] = code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return join(elements, '');
    }
});

},{"f7ab90f668dfed5f":"gD2TP","f19d1a907413c68d":"jsw26","6914a342ea61c319":"3itgc"}],"6HJrH":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("1cde7a4fbe24deb1");
var uncurryThis = require("d9ff51b37cd276ef");
var notARegExp = require("b1c9b74814a0e4ee");
var requireObjectCoercible = require("36f262aff4650984");
var toString = require("c6f2de0a65cb2a09");
var correctIsRegExpLogic = require("30dec888dfe829e2");
var stringIndexOf = uncurryThis(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({
    target: 'String',
    proto: true,
    forced: !correctIsRegExpLogic('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"1cde7a4fbe24deb1":"gD2TP","d9ff51b37cd276ef":"jsw26","b1c9b74814a0e4ee":"3N240","36f262aff4650984":"a0P0K","c6f2de0a65cb2a09":"ffo0a","30dec888dfe829e2":"hyWXS"}],"Q5Pd0":[function(require,module,exports,__globalThis) {
'use strict';
var charAt = require("e8b36e9e8f60deb1").charAt;
var toString = require("99724183e9ac759e");
var InternalStateModule = require("75c45c226da41a58");
var defineIterator = require("5bce8e62b9ff7984");
var createIterResultObject = require("cab4a14c8e102263");
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function(iterated) {
    setInternalState(this, {
        type: STRING_ITERATOR,
        string: toString(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return createIterResultObject(undefined, true);
    point = charAt(string, index);
    state.index += point.length;
    return createIterResultObject(point, false);
});

},{"e8b36e9e8f60deb1":"6s5lj","99724183e9ac759e":"ffo0a","75c45c226da41a58":"4Dlpx","5bce8e62b9ff7984":"cMggn","cab4a14c8e102263":"2q5E9"}],"8w1Hg":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("1a72ba86dc4099cd");
var fixRegExpWellKnownSymbolLogic = require("3e8300c8dcd37861");
var anObject = require("4e367ba2e602279b");
var isNullOrUndefined = require("a9817085717103ac");
var toLength = require("3ad5c9f9719d1735");
var toString = require("a1912f278569b4e6");
var requireObjectCoercible = require("d83ac9e10edfa0ef");
var getMethod = require("4fa13f5559b9cbba");
var advanceStringIndex = require("357167b0f8a6ba45");
var regExpExec = require("3b40f00a568e6a6b");
// @@match logic
fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = requireObjectCoercible(this);
            var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = regExpExec(rx, S)) !== null){
                var matchStr = toString(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});

},{"1a72ba86dc4099cd":"ebTVd","3e8300c8dcd37861":"goVsT","4e367ba2e602279b":"2dEST","a9817085717103ac":"9lebS","3ad5c9f9719d1735":"4f0fH","a1912f278569b4e6":"ffo0a","d83ac9e10edfa0ef":"a0P0K","4fa13f5559b9cbba":"b2lgj","357167b0f8a6ba45":"ijgGm","3b40f00a568e6a6b":"bXbvr"}],"goVsT":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove from `core-js@4` since it's moved to entry points
require("a7057ee05361671");
var call = require("771b9a32e3d08596");
var defineBuiltIn = require("5a9ef6cc43262548");
var regexpExec = require("b286e3fd8e91d745");
var fails = require("f56adef42dd3c42");
var wellKnownSymbol = require("39c5bea895574e43");
var createNonEnumerableProperty = require("1c6881441295e4f4");
var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !fails(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: call(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: call(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        defineBuiltIn(String.prototype, KEY, methods[0]);
        defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

},{"a7057ee05361671":"jqZha","771b9a32e3d08596":"ebTVd","5a9ef6cc43262548":"jlXZ9","b286e3fd8e91d745":"lt6Bu","f56adef42dd3c42":"8SraZ","39c5bea895574e43":"6dJgl","1c6881441295e4f4":"3IHVb"}],"ijgGm":[function(require,module,exports,__globalThis) {
'use strict';
var charAt = require("7830b1b106fe9c2f").charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? charAt(S, index).length : 1);
};

},{"7830b1b106fe9c2f":"6s5lj"}],"bXbvr":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("fe012fd0e62b041c");
var anObject = require("953f0ef3a583db2e");
var isCallable = require("7b1bebb22aa6d09f");
var classof = require("41458309d054e6d9");
var regexpExec = require("2da13aa8500d5870");
var $TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if (isCallable(exec)) {
        var result = call(exec, R, S);
        if (result !== null) anObject(result);
        return result;
    }
    if (classof(R) === 'RegExp') return call(regexpExec, R, S);
    throw new $TypeError('RegExp#exec called on incompatible receiver');
};

},{"fe012fd0e62b041c":"ebTVd","953f0ef3a583db2e":"2dEST","7b1bebb22aa6d09f":"37CJl","41458309d054e6d9":"fGBNn","2da13aa8500d5870":"lt6Bu"}],"krtEZ":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("bde41783ec0f17a4");
var $padEnd = require("794108b869e92a52").end;
var WEBKIT_BUG = require("271b5f05be76b6dd");
// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({
    target: 'String',
    proto: true,
    forced: WEBKIT_BUG
}, {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"bde41783ec0f17a4":"gD2TP","794108b869e92a52":"3Ihy4","271b5f05be76b6dd":"UseEs"}],"3Ihy4":[function(require,module,exports,__globalThis) {
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis = require("3f3ae64f3613324a");
var toLength = require("86f2220ab33aea88");
var toString = require("ce16e4ba37e115ac");
var $repeat = require("3fe5759e7801b635");
var requireObjectCoercible = require("3c8ec8ea0d5bc9c");
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function createMethod(IS_END) {
    return function($this, maxLength, fillString) {
        var S = toString(requireObjectCoercible($this));
        var intMaxLength = toLength(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? ' ' : toString(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr === '') return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
module.exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: createMethod(true)
};

},{"3f3ae64f3613324a":"jsw26","86f2220ab33aea88":"4f0fH","ce16e4ba37e115ac":"ffo0a","3fe5759e7801b635":"1Nchr","3c8ec8ea0d5bc9c":"a0P0K"}],"UseEs":[function(require,module,exports,__globalThis) {
'use strict';
// https://github.com/zloirock/core-js/issues/280
var userAgent = require("ea42f18a4a6e86a9");
module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

},{"ea42f18a4a6e86a9":"7UNqW"}],"kz3aD":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("31f9b30345fd3179");
var $padStart = require("10950b9580001d1d").start;
var WEBKIT_BUG = require("c86924140d1ee1af");
// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({
    target: 'String',
    proto: true,
    forced: WEBKIT_BUG
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"31f9b30345fd3179":"gD2TP","10950b9580001d1d":"3Ihy4","c86924140d1ee1af":"UseEs"}],"bCLbx":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("d77bea9ed21ff4bc");
var uncurryThis = require("7ed823ef2298b758");
var toIndexedObject = require("1210aa921fc34970");
var toObject = require("4320a1855b3e38fb");
var toString = require("c2348ecf591fb82d");
var lengthOfArrayLike = require("4b1f320aa7c99da8");
var push = uncurryThis([].push);
var join = uncurryThis([].join);
// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$({
    target: 'String',
    stat: true
}, {
    raw: function raw(template) {
        var rawTemplate = toIndexedObject(toObject(template).raw);
        var literalSegments = lengthOfArrayLike(rawTemplate);
        if (!literalSegments) return '';
        var argumentsLength = arguments.length;
        var elements = [];
        var i = 0;
        while(true){
            push(elements, toString(rawTemplate[i++]));
            if (i === literalSegments) return join(elements, '');
            if (i < argumentsLength) push(elements, toString(arguments[i]));
        }
    }
});

},{"d77bea9ed21ff4bc":"gD2TP","7ed823ef2298b758":"jsw26","1210aa921fc34970":"gGepo","4320a1855b3e38fb":"gxWv7","c2348ecf591fb82d":"ffo0a","4b1f320aa7c99da8":"fp6Bt"}],"4JDEG":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("b68f16bf09eba421");
var repeat = require("12e67b43b198a56f");
// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({
    target: 'String',
    proto: true
}, {
    repeat: repeat
});

},{"b68f16bf09eba421":"gD2TP","12e67b43b198a56f":"1Nchr"}],"1dK4X":[function(require,module,exports,__globalThis) {
'use strict';
var apply = require("f8fd16f994f85406");
var call = require("b5234e1018cb2916");
var uncurryThis = require("c3560c75b4ad1ef2");
var fixRegExpWellKnownSymbolLogic = require("c4a2369a79c5aaa2");
var fails = require("daa534dec0372986");
var anObject = require("317f495e148be81e");
var isCallable = require("36464dd17d2a7224");
var isNullOrUndefined = require("cea091f017783d94");
var toIntegerOrInfinity = require("3847a5ff118f8ebb");
var toLength = require("effd88adfbb6b4bc");
var toString = require("953b724c90cd8db6");
var requireObjectCoercible = require("154963922e7c9354");
var advanceStringIndex = require("90f011aa61b831b4");
var getMethod = require("af552ab4c89e35be");
var getSubstitution = require("3726cfd8dc51c82c");
var regExpExec = require("6de55154ce28598");
var wellKnownSymbol = require("4b6a0c7e75a1080a");
var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
var maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
    return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = requireObjectCoercible(this);
            var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = anObject(this);
            var S = toString(string);
            if (typeof replaceValue == 'string' && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = isCallable(replaceValue);
            if (!functionalReplace) replaceValue = toString(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = regExpExec(rx, S);
                if (result === null) break;
                push(results, result);
                if (!global) break;
                var matchStr = toString(result[0]);
                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = toString(result[0]);
                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                    replacement = toString(apply(replaceValue, undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + stringSlice(S, nextSourcePosition);
        }
    ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"f8fd16f994f85406":"kuGqn","b5234e1018cb2916":"ebTVd","c3560c75b4ad1ef2":"jsw26","c4a2369a79c5aaa2":"goVsT","daa534dec0372986":"8SraZ","317f495e148be81e":"2dEST","36464dd17d2a7224":"37CJl","cea091f017783d94":"9lebS","3847a5ff118f8ebb":"wKg8O","effd88adfbb6b4bc":"4f0fH","953b724c90cd8db6":"ffo0a","154963922e7c9354":"a0P0K","90f011aa61b831b4":"ijgGm","af552ab4c89e35be":"b2lgj","3726cfd8dc51c82c":"8eoYY","6de55154ce28598":"bXbvr","4b6a0c7e75a1080a":"6dJgl"}],"8eoYY":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("3cf51fea5d34c201");
var toObject = require("999f669befd62c27");
var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = toObject(namedCaptures);
        symbols = SUBSTITUTION_SYMBOLS;
    }
    return replace(replacement, symbols, function(match, ch) {
        var capture;
        switch(charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return stringSlice(str, 0, position);
            case "'":
                return stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};

},{"3cf51fea5d34c201":"jsw26","999f669befd62c27":"gxWv7"}],"bURcY":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("8d11f7aaad1fe3c1");
var fixRegExpWellKnownSymbolLogic = require("2fc7060ff2c5a42c");
var anObject = require("80bcaa170d414768");
var isNullOrUndefined = require("2f12d91ea8b88054");
var requireObjectCoercible = require("87e0667ca38b48b9");
var sameValue = require("fc5195de5b8ec5e0");
var toString = require("ac1a7a91b5d23dc3");
var getMethod = require("d51bcc8729521f43");
var regExpExec = require("d8c3d3bfc882cda6");
// @@search logic
fixRegExpWellKnownSymbolLogic('search', function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = requireObjectCoercible(this);
            var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
            return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = regExpExec(rx, S);
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});

},{"8d11f7aaad1fe3c1":"ebTVd","2fc7060ff2c5a42c":"goVsT","80bcaa170d414768":"2dEST","2f12d91ea8b88054":"9lebS","87e0667ca38b48b9":"a0P0K","fc5195de5b8ec5e0":"832So","ac1a7a91b5d23dc3":"ffo0a","d51bcc8729521f43":"b2lgj","d8c3d3bfc882cda6":"bXbvr"}],"vSLTn":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("731f563170e1c210");
var uncurryThis = require("897d2896927b6e02");
var fixRegExpWellKnownSymbolLogic = require("508b20464a6b5517");
var anObject = require("f367d08a248e8be6");
var isNullOrUndefined = require("31434b1694b351f9");
var requireObjectCoercible = require("9311135c1a422443");
var speciesConstructor = require("55e35ece01e7fba0");
var advanceStringIndex = require("8bb35ae79f87add1");
var toLength = require("49f0536d42765acd");
var toString = require("b9744dd298874d6b");
var getMethod = require("7948c6f9df3714fb");
var regExpExec = require("2c9f875738c0535c");
var stickyHelpers = require("ff11a5dc8ee4e1e9");
var fails = require("1a700d67237f1f2b");
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var push = uncurryThis([].push);
var stringSlice = uncurryThis(''.slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});
var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
'.'.split(/()()/).length > 1 || ''.split(/.?/).length;
// @@split logic
fixRegExpWellKnownSymbolLogic('split', function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit = '0'.split(undefined, 0).length ? function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    } : nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = requireObjectCoercible(this);
            var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
            return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = anObject(this);
            var S = toString(string);
            if (!BUGGY) {
                var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                if (res.done) return res.value;
            }
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return regExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                var e;
                if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                else {
                    push(A, stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            push(A, stringSlice(S, p));
            return A;
        }
    ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

},{"731f563170e1c210":"ebTVd","897d2896927b6e02":"jsw26","508b20464a6b5517":"goVsT","f367d08a248e8be6":"2dEST","31434b1694b351f9":"9lebS","9311135c1a422443":"a0P0K","55e35ece01e7fba0":"1Johb","8bb35ae79f87add1":"ijgGm","49f0536d42765acd":"4f0fH","b9744dd298874d6b":"ffo0a","7948c6f9df3714fb":"b2lgj","2c9f875738c0535c":"bXbvr","ff11a5dc8ee4e1e9":"34VgK","1a700d67237f1f2b":"8SraZ"}],"9no8N":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("dde854d8a76d436d");
var uncurryThis = require("75ef62d12e51b46c");
var getOwnPropertyDescriptor = require("ff3b80c156be6132").f;
var toLength = require("573cc620487e2f6b");
var toString = require("3d6be1b7c00bafd");
var notARegExp = require("40ed833d044b85cd");
var requireObjectCoercible = require("7b57b8afdd10d7e4");
var correctIsRegExpLogic = require("80ffa3ecff44b920");
var IS_PURE = require("d76fe9fb1319d805");
var stringSlice = uncurryThis(''.slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({
    target: 'String',
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = toString(requireObjectCoercible(this));
        notARegExp(searchString);
        var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = toString(searchString);
        return stringSlice(that, index, index + search.length) === search;
    }
});

},{"dde854d8a76d436d":"gD2TP","75ef62d12e51b46c":"kBsBX","ff3b80c156be6132":"hRqf9","573cc620487e2f6b":"4f0fH","3d6be1b7c00bafd":"ffo0a","40ed833d044b85cd":"3N240","7b57b8afdd10d7e4":"a0P0K","80ffa3ecff44b920":"hyWXS","d76fe9fb1319d805":"6KD1D"}],"4DumU":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("4a60febef79e9fd2");
var $trim = require("aa85dc53780a7a31").trim;
var forcedStringTrimMethod = require("d62e07fb0a0f0c26");
// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({
    target: 'String',
    proto: true,
    forced: forcedStringTrimMethod('trim')
}, {
    trim: function trim() {
        return $trim(this);
    }
});

},{"4a60febef79e9fd2":"gD2TP","aa85dc53780a7a31":"6FZTw","d62e07fb0a0f0c26":"lWUOT"}],"lWUOT":[function(require,module,exports,__globalThis) {
'use strict';
var PROPER_FUNCTION_NAME = require("9e0c4c0dbddf03dd").PROPER;
var fails = require("92328d780355dc79");
var whitespaces = require("8c0d7fed4094a2b6");
var non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function(METHOD_NAME) {
    return fails(function() {
        return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
    });
};

},{"9e0c4c0dbddf03dd":"cE4Pk","92328d780355dc79":"8SraZ","8c0d7fed4094a2b6":"jMBz0"}],"kl4IZ":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this line from `core-js@4`
require("251a593a444ed436");
var $ = require("91f4001402f2b9ee");
var trimEnd = require("c6b02e29a67a6f26");
// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimEnd !== trimEnd
}, {
    trimEnd: trimEnd
});

},{"251a593a444ed436":"meQt9","91f4001402f2b9ee":"gD2TP","c6b02e29a67a6f26":"btukS"}],"meQt9":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("de7842587ae70a42");
var trimEnd = require("324b25d4226efe2d");
// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimRight !== trimEnd
}, {
    trimRight: trimEnd
});

},{"de7842587ae70a42":"gD2TP","324b25d4226efe2d":"btukS"}],"btukS":[function(require,module,exports,__globalThis) {
'use strict';
var $trimEnd = require("bc94349b4fc95bb3").end;
var forcedStringTrimMethod = require("71fc76130b4f9a6");
// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
module.exports = forcedStringTrimMethod('trimEnd') ? function trimEnd() {
    return $trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;

},{"bc94349b4fc95bb3":"6FZTw","71fc76130b4f9a6":"lWUOT"}],"1Eoub":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this line from `core-js@4`
require("654c60d6d97014cd");
var $ = require("26b6a882a1c5bba9");
var trimStart = require("b5f2740011c04718");
// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimStart !== trimStart
}, {
    trimStart: trimStart
});

},{"654c60d6d97014cd":"8uIyy","26b6a882a1c5bba9":"gD2TP","b5f2740011c04718":"kgfxk"}],"8uIyy":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("2da1b55d02d90d4a");
var trimStart = require("8b6aefe7df6c88a");
// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimLeft !== trimStart
}, {
    trimLeft: trimStart
});

},{"2da1b55d02d90d4a":"gD2TP","8b6aefe7df6c88a":"kgfxk"}],"kgfxk":[function(require,module,exports,__globalThis) {
'use strict';
var $trimStart = require("a3878f82301e4d4").start;
var forcedStringTrimMethod = require("ee8e5c2b54df0ba4");
// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
    return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;

},{"a3878f82301e4d4":"6FZTw","ee8e5c2b54df0ba4":"lWUOT"}],"6ZCBg":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("e7d648b06f4dd9c6");
var createHTML = require("8b0114ba5e653efc");
var forcedStringHTMLMethod = require("1caf9e0d6204ce0a");
// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('anchor')
}, {
    anchor: function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    }
});

},{"e7d648b06f4dd9c6":"gD2TP","8b0114ba5e653efc":"hJDG5","1caf9e0d6204ce0a":"3hpFC"}],"hJDG5":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("427762aaf6075552");
var requireObjectCoercible = require("3a91b63413ffe383");
var toString = require("515bd1582fb5b4c0");
var quot = /"/g;
var replace = uncurryThis(''.replace);
// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function(string, tag, attribute, value) {
    var S = toString(requireObjectCoercible(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};

},{"427762aaf6075552":"jsw26","3a91b63413ffe383":"a0P0K","515bd1582fb5b4c0":"ffo0a"}],"3hpFC":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("b7fe2964c39bac");
// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function(METHOD_NAME) {
    return fails(function() {
        var test = ''[METHOD_NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    });
};

},{"b7fe2964c39bac":"8SraZ"}],"YaAC8":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("c559cd7b113e236e");
var createHTML = require("5a30563bc26230a8");
var forcedStringHTMLMethod = require("eec66acdfc1a2a7d");
// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('big')
}, {
    big: function big() {
        return createHTML(this, 'big', '', '');
    }
});

},{"c559cd7b113e236e":"gD2TP","5a30563bc26230a8":"hJDG5","eec66acdfc1a2a7d":"3hpFC"}],"lywK7":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("676512d3c55a414");
var createHTML = require("7e21be1f712bc51d");
var forcedStringHTMLMethod = require("46de4ecf79c13e");
// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('blink')
}, {
    blink: function blink() {
        return createHTML(this, 'blink', '', '');
    }
});

},{"676512d3c55a414":"gD2TP","7e21be1f712bc51d":"hJDG5","46de4ecf79c13e":"3hpFC"}],"1Ttf8":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("48f4b5d0c5a6a4fb");
var createHTML = require("e17c07d10b887dd3");
var forcedStringHTMLMethod = require("5287465832c168a5");
// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('bold')
}, {
    bold: function bold() {
        return createHTML(this, 'b', '', '');
    }
});

},{"48f4b5d0c5a6a4fb":"gD2TP","e17c07d10b887dd3":"hJDG5","5287465832c168a5":"3hpFC"}],"aic6R":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("6490db7677e8f73e");
var createHTML = require("e6e19e0e56c49b86");
var forcedStringHTMLMethod = require("bb7b77345df5335f");
// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fixed')
}, {
    fixed: function fixed() {
        return createHTML(this, 'tt', '', '');
    }
});

},{"6490db7677e8f73e":"gD2TP","e6e19e0e56c49b86":"hJDG5","bb7b77345df5335f":"3hpFC"}],"dwgEV":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("138910cd530370a2");
var createHTML = require("d72a479e3b3815bd");
var forcedStringHTMLMethod = require("5690c1466282cf0f");
// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fontcolor')
}, {
    fontcolor: function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    }
});

},{"138910cd530370a2":"gD2TP","d72a479e3b3815bd":"hJDG5","5690c1466282cf0f":"3hpFC"}],"gxccO":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("f502df9771a160ae");
var createHTML = require("ee2ef8461dec89b6");
var forcedStringHTMLMethod = require("2a2e9c2933145580");
// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fontsize')
}, {
    fontsize: function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    }
});

},{"f502df9771a160ae":"gD2TP","ee2ef8461dec89b6":"hJDG5","2a2e9c2933145580":"3hpFC"}],"ob1YY":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("24cfbc86c4210c6b");
var createHTML = require("e302ce8a79ba595b");
var forcedStringHTMLMethod = require("3ecf3c8b0c95d02f");
// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('italics')
}, {
    italics: function italics() {
        return createHTML(this, 'i', '', '');
    }
});

},{"24cfbc86c4210c6b":"gD2TP","e302ce8a79ba595b":"hJDG5","3ecf3c8b0c95d02f":"3hpFC"}],"2o4DR":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("bab8a92d9901152a");
var createHTML = require("252613bc1bb91720");
var forcedStringHTMLMethod = require("3fb7b9ac770c40c");
// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('link')
}, {
    link: function link(url) {
        return createHTML(this, 'a', 'href', url);
    }
});

},{"bab8a92d9901152a":"gD2TP","252613bc1bb91720":"hJDG5","3fb7b9ac770c40c":"3hpFC"}],"5jffo":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("d3ac4973e86c28f9");
var createHTML = require("8bd5ccba40c1dac2");
var forcedStringHTMLMethod = require("8a5bdd05bf3f9b34");
// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('small')
}, {
    small: function small() {
        return createHTML(this, 'small', '', '');
    }
});

},{"d3ac4973e86c28f9":"gD2TP","8bd5ccba40c1dac2":"hJDG5","8a5bdd05bf3f9b34":"3hpFC"}],"68x7j":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("4d6202cdf03d0d61");
var createHTML = require("ec6f6be679741e37");
var forcedStringHTMLMethod = require("1920bc41bac741db");
// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('strike')
}, {
    strike: function strike() {
        return createHTML(this, 'strike', '', '');
    }
});

},{"4d6202cdf03d0d61":"gD2TP","ec6f6be679741e37":"hJDG5","1920bc41bac741db":"3hpFC"}],"4l5iT":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("5ac641dbd7ba3f29");
var createHTML = require("ef70fadb3bd40f3e");
var forcedStringHTMLMethod = require("2b14944b2c33ed44");
// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('sub')
}, {
    sub: function sub() {
        return createHTML(this, 'sub', '', '');
    }
});

},{"5ac641dbd7ba3f29":"gD2TP","ef70fadb3bd40f3e":"hJDG5","2b14944b2c33ed44":"3hpFC"}],"gA1yC":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("783c2c194676a06b");
var createHTML = require("bca2bfdd086dcdc1");
var forcedStringHTMLMethod = require("36843058161d815a");
// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('sup')
}, {
    sup: function sup() {
        return createHTML(this, 'sup', '', '');
    }
});

},{"783c2c194676a06b":"gD2TP","bca2bfdd086dcdc1":"hJDG5","36843058161d815a":"3hpFC"}],"p1Zu8":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("6371023cd6dad94a");
// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"6371023cd6dad94a":"fEWoT"}],"fEWoT":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("c9bb9be26763d5d6");
var globalThis = require("f3461bcb45a0da3b");
var call = require("513171f829dcf492");
var DESCRIPTORS = require("9195003f05246e2");
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require("5c32747745583fde");
var ArrayBufferViewCore = require("f129cadcdd085794");
var ArrayBufferModule = require("14a230ba5c5e071a");
var anInstance = require("848002acbadbae2c");
var createPropertyDescriptor = require("c540a4ec697b43da");
var createNonEnumerableProperty = require("8248ffc9c9f95531");
var isIntegralNumber = require("aa784a976357a5bd");
var toLength = require("da59162d19efb47d");
var toIndex = require("30e058c823038e07");
var toOffset = require("c43d9ac9910fd1d");
var toUint8Clamped = require("ac65ec03272627eb");
var toPropertyKey = require("9477a245724234e7");
var hasOwn = require("9d37aa52098c7b96");
var classof = require("361c9958906a5ff0");
var isObject = require("4f80387d0e9c94a2");
var isSymbol = require("d414fa9976906f9c");
var create = require("97d75eb5fba6dc4c");
var isPrototypeOf = require("c3126acc51f6b7f5");
var setPrototypeOf = require("402069064923c62e");
var getOwnPropertyNames = require("442bd1b967e53ad0").f;
var typedArrayFrom = require("e60d2aff236b9889");
var forEach = require("5464ebf657a71f52").forEach;
var setSpecies = require("e76408bbdddedcb");
var defineBuiltInAccessor = require("a6c477e34b27b3ce");
var definePropertyModule = require("3b65fa2a837fee2b");
var getOwnPropertyDescriptorModule = require("2db4073983cef2bc");
var arrayFromConstructorAndList = require("76805b4ea64de991");
var InternalStateModule = require("7ab72b6c1b29c546");
var inheritIfRequired = require("1d46546a1b5897a9");
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError = globalThis.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';
var addGetter = function addGetter(it, key) {
    defineBuiltInAccessor(it, key, {
        configurable: true,
        get: function get() {
            return getInternalState(this)[key];
        }
    });
};
var isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};
var isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
};
var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = toPropertyKey(key);
    return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
};
var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = toPropertyKey(key);
    if (isTypedArrayIndex(target, key) && isObject(descriptor) && hasOwn(descriptor, 'value') && !hasOwn(descriptor, 'get') && !hasOwn(descriptor, 'set') && !descriptor.configurable && (!hasOwn(descriptor, 'writable') || descriptor.writable) && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return nativeDefineProperty(target, key, descriptor);
};
if (DESCRIPTORS) {
    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
        getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
        definePropertyModule.f = wrappedDefineProperty;
        addGetter(TypedArrayPrototype, 'buffer');
        addGetter(TypedArrayPrototype, 'byteOffset');
        addGetter(TypedArrayPrototype, 'byteLength');
        addGetter(TypedArrayPrototype, 'length');
    }
    $({
        target: 'Object',
        stat: true,
        forced: !NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
        defineProperty: wrappedDefineProperty
    });
    module.exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + TYPE;
        var SETTER = 'set' + TYPE;
        var NativeTypedArrayConstructor = globalThis[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function getter(that, index) {
            var data = getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function setter(that, index, value) {
            var data = getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
        };
        var addElement = function addElement(that, index) {
            nativeDefineProperty(that, index, {
                get: function get() {
                    return getter(this, index);
                },
                set: function set(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                anInstance(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!isObject(data)) {
                    length = toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new ArrayBuffer(byteLength);
                } else if (isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = toOffset(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
                    } else {
                        byteLength = toLength($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
                else return call(typedArrayFrom, TypedArrayConstructor, data);
                setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
        } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                anInstance(dummy, TypedArrayConstructorPrototype);
                return inheritIfRequired(function() {
                    if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
                    if (isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
                    return call(typedArrayFrom, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
            forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
        enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if (TYPED_ARRAY_TAG) createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
        if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
        setSpecies(CONSTRUCTOR_NAME);
    };
} else module.exports = function() {};

},{"c9bb9be26763d5d6":"gD2TP","f3461bcb45a0da3b":"4naf8","513171f829dcf492":"ebTVd","9195003f05246e2":"ihfdR","5c32747745583fde":"a0x3D","f129cadcdd085794":"7Qezi","14a230ba5c5e071a":"icQUr","848002acbadbae2c":"9RDjg","c540a4ec697b43da":"jtAW3","8248ffc9c9f95531":"3IHVb","aa784a976357a5bd":"9bKv0","da59162d19efb47d":"4f0fH","30e058c823038e07":"cSMkA","c43d9ac9910fd1d":"cyDm3","ac65ec03272627eb":"44MPj","9477a245724234e7":"9pd5y","9d37aa52098c7b96":"h2GWh","361c9958906a5ff0":"7T1aN","4f80387d0e9c94a2":"8iIJm","d414fa9976906f9c":"g5d9N","97d75eb5fba6dc4c":"5ZmqN","c3126acc51f6b7f5":"fVGN3","402069064923c62e":"hmY3h","442bd1b967e53ad0":"busKr","e60d2aff236b9889":"eTIk8","5464ebf657a71f52":"giEdW","e76408bbdddedcb":"7q10a","a6c477e34b27b3ce":"g2LDG","3b65fa2a837fee2b":"4d2AB","2db4073983cef2bc":"hRqf9","76805b4ea64de991":"ca60S","7ab72b6c1b29c546":"4Dlpx","1d46546a1b5897a9":"a2ozq"}],"a0x3D":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */ var globalThis = require("891f2fe9b403b8ab");
var fails = require("6c663a269461a969");
var checkCorrectnessOfIteration = require("d8cf3a97649eee7c");
var NATIVE_ARRAY_BUFFER_VIEWS = require("c788c77daaeab24a").NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer = globalThis.ArrayBuffer;
var Int8Array = globalThis.Int8Array;
module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function() {
    Int8Array(1);
}) || !fails(function() {
    new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function(iterable) {
    new Int8Array();
    new Int8Array(null);
    new Int8Array(1.5);
    new Int8Array(iterable);
}, true) || fails(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});

},{"891f2fe9b403b8ab":"4naf8","6c663a269461a969":"8SraZ","d8cf3a97649eee7c":"21ceT","c788c77daaeab24a":"7Qezi"}],"7Qezi":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_ARRAY_BUFFER = require("4142cc1b1f950662");
var DESCRIPTORS = require("fa237bbf2050dd6d");
var globalThis = require("9603af1373955d3d");
var isCallable = require("1b44b7e19e6f660d");
var isObject = require("af39713fe0cf7587");
var hasOwn = require("dd5eec94b1519471");
var classof = require("b9eebb2d4c13b0d6");
var tryToString = require("36a2290066710aa0");
var createNonEnumerableProperty = require("fdfbb82e20f81a19");
var defineBuiltIn = require("81ef6d90bc6acdce");
var defineBuiltInAccessor = require("96421c541af03be5");
var isPrototypeOf = require("ab8263bb2af6274");
var getPrototypeOf = require("ba5da2480b30b79");
var setPrototypeOf = require("b6e4d282cbe3e34a");
var wellKnownSymbol = require("3d5af0d43aa6e42b");
var uid = require("8007fa7370557b8e");
var InternalStateModule = require("82848943f937d383");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = globalThis.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = globalThis.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = globalThis.TypeError;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(globalThis.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var isView = function isView(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return klass === 'DataView' || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var getTypedArrayConstructor = function getTypedArrayConstructor1(it) {
    var proto = getPrototypeOf(it);
    if (!isObject(proto)) return;
    var state = getInternalState(proto);
    return state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};
var isTypedArray = function isTypedArray(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var aTypedArray = function aTypedArray(it) {
    if (isTypedArray(it)) return it;
    throw new TypeError('Target is not a typed array');
};
var aTypedArrayConstructor = function aTypedArrayConstructor(C) {
    if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
    throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};
var exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced, options) {
    if (!DESCRIPTORS) return;
    if (forced) for(var ARRAY in TypedArrayConstructorsList){
        var TypedArrayConstructor = globalThis[ARRAY];
        if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!TypedArrayPrototype[KEY] || forced) defineBuiltIn(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
};
var exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!DESCRIPTORS) return;
    if (setPrototypeOf) {
        if (forced) for(ARRAY in TypedArrayConstructorsList){
            TypedArrayConstructor = globalThis[ARRAY];
            if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in TypedArrayConstructorsList){
        TypedArrayConstructor = globalThis[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
};
for(NAME in TypedArrayConstructorsList){
    Constructor = globalThis[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
    else NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for(NAME in BigIntArrayConstructorsList){
    Constructor = globalThis[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    TypedArray = function TypedArray() {
        throw new TypeError('Incorrect invocation');
    };
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (globalThis[NAME]) setPrototypeOf(globalThis[NAME], TypedArray);
    }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
    TypedArrayPrototype = TypedArray.prototype;
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (globalThis[NAME]) setPrototypeOf(globalThis[NAME].prototype, TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
    TYPED_ARRAY_TAG_REQUIRED = true;
    defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
        configurable: true,
        get: function get() {
            return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
        }
    });
    for(NAME in TypedArrayConstructorsList)if (globalThis[NAME]) createNonEnumerableProperty(globalThis[NAME], TYPED_ARRAY_TAG, NAME);
}
module.exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
    aTypedArray: aTypedArray,
    aTypedArrayConstructor: aTypedArrayConstructor,
    exportTypedArrayMethod: exportTypedArrayMethod,
    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
    getTypedArrayConstructor: getTypedArrayConstructor,
    isView: isView,
    isTypedArray: isTypedArray,
    TypedArray: TypedArray,
    TypedArrayPrototype: TypedArrayPrototype
};

},{"4142cc1b1f950662":"4kGiq","fa237bbf2050dd6d":"ihfdR","9603af1373955d3d":"4naf8","1b44b7e19e6f660d":"37CJl","af39713fe0cf7587":"8iIJm","dd5eec94b1519471":"h2GWh","b9eebb2d4c13b0d6":"7T1aN","36a2290066710aa0":"b8XMV","fdfbb82e20f81a19":"3IHVb","81ef6d90bc6acdce":"jlXZ9","96421c541af03be5":"g2LDG","ab8263bb2af6274":"fVGN3","ba5da2480b30b79":"lFnuf","b6e4d282cbe3e34a":"hmY3h","3d5af0d43aa6e42b":"6dJgl","8007fa7370557b8e":"6zL6V","82848943f937d383":"4Dlpx"}],"cyDm3":[function(require,module,exports,__globalThis) {
'use strict';
var toPositiveInteger = require("3d42e5f9448f0334");
var $RangeError = RangeError;
module.exports = function(it, BYTES) {
    var offset = toPositiveInteger(it);
    if (offset % BYTES) throw new $RangeError('Wrong offset');
    return offset;
};

},{"3d42e5f9448f0334":"eRtnN"}],"eRtnN":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("e509d82728a7abb4");
var $RangeError = RangeError;
module.exports = function(it) {
    var result = toIntegerOrInfinity(it);
    if (result < 0) throw new $RangeError("The argument can't be less than 0");
    return result;
};

},{"e509d82728a7abb4":"wKg8O"}],"44MPj":[function(require,module,exports,__globalThis) {
'use strict';
var round = Math.round;
module.exports = function(it) {
    var value = round(it);
    return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};

},{}],"eTIk8":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("2b6f4dcfa87227c8");
var call = require("a99e72870b261c00");
var aConstructor = require("6fedb000997de8c9");
var toObject = require("5d2230babf0781b0");
var lengthOfArrayLike = require("224522d7906614b9");
var getIterator = require("fa7f27b53f48b0c9");
var getIteratorMethod = require("244fea79be1425e4");
var isArrayIteratorMethod = require("c86f6f22440f76d6");
var isBigIntArray = require("a9c73ae28faf529e");
var aTypedArrayConstructor = require("1213d44fe73ec45d").aTypedArrayConstructor;
var toBigInt = require("17f40af3180f13f6");
module.exports = function from(source /* , mapfn, thisArg */ ) {
    var C = aConstructor(this);
    var O = toObject(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = getIteratorMethod(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
        iterator = getIterator(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = call(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = bind(mapfn, arguments[2]);
    length = lengthOfArrayLike(O);
    result = new (aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = isBigIntArray(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
    }
    return result;
};

},{"2b6f4dcfa87227c8":"7xEW7","a99e72870b261c00":"ebTVd","6fedb000997de8c9":"ciuOu","5d2230babf0781b0":"gxWv7","224522d7906614b9":"fp6Bt","fa7f27b53f48b0c9":"cAVpj","244fea79be1425e4":"lf0Zm","c86f6f22440f76d6":"8FXTb","a9c73ae28faf529e":"aOE9T","1213d44fe73ec45d":"7Qezi","17f40af3180f13f6":"5nokW"}],"aOE9T":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("4eaea61d57855c23");
module.exports = function(it) {
    var klass = classof(it);
    return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};

},{"4eaea61d57855c23":"7T1aN"}],"5nokW":[function(require,module,exports,__globalThis) {
'use strict';
var toPrimitive = require("e84ff6c898741836");
var $TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function(argument) {
    var prim = toPrimitive(argument, 'number');
    if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};

},{"e84ff6c898741836":"invap"}],"ca60S":[function(require,module,exports,__globalThis) {
'use strict';
var lengthOfArrayLike = require("2dee1f257e46a7db");
module.exports = function(Constructor, list, $length) {
    var index = 0;
    var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};

},{"2dee1f257e46a7db":"fp6Bt"}],"baLvg":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("5afb75924dde7be2");
// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float64', function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"5afb75924dde7be2":"fEWoT"}],"6QugB":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("f65338540449e43b");
// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"f65338540449e43b":"fEWoT"}],"2kxtr":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("618af5c93cf1cc05");
// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int16', function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"618af5c93cf1cc05":"fEWoT"}],"imPfF":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("c7ce36d83e80a30f");
// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"c7ce36d83e80a30f":"fEWoT"}],"kFdW6":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("1fba800ad35b335f");
// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"1fba800ad35b335f":"fEWoT"}],"f25ck":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("2cd7a1d58fa59b7d");
// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);

},{"2cd7a1d58fa59b7d":"fEWoT"}],"bpIfx":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("ca953ee05f39cdaa");
// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"ca953ee05f39cdaa":"fEWoT"}],"aVXFQ":[function(require,module,exports,__globalThis) {
'use strict';
var createTypedArrayConstructor = require("682a05de60a0a1e1");
// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});

},{"682a05de60a0a1e1":"fEWoT"}],"6a2xZ":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("9998fdf0f56ef0da");
var ArrayBufferViewCore = require("3136ffe0165b4705");
var $ArrayCopyWithin = require("45547c073d8e02f");
var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */ ) {
    return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

},{"9998fdf0f56ef0da":"jsw26","3136ffe0165b4705":"7Qezi","45547c073d8e02f":"3LfXK"}],"fYohF":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("cb5a1a9d977d55c8");
var $every = require("9bc5b51fcf1b899f").every;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */ ) {
    return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"cb5a1a9d977d55c8":"7Qezi","9bc5b51fcf1b899f":"giEdW"}],"eUwit":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("24d20a7fba3c1708");
var $fill = require("3a12c8f811e83e62");
var toBigInt = require("bec3653efa2d8600");
var classof = require("ff46ad00880fddaa");
var call = require("5e0ee530611ef38d");
var uncurryThis = require("800a47a98b497e55");
var fails = require("faaaddc6a409cf90");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function valueOf() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */ ) {
    var length = arguments.length;
    aTypedArray(this);
    var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
    return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

},{"24d20a7fba3c1708":"7Qezi","3a12c8f811e83e62":"453wW","bec3653efa2d8600":"5nokW","ff46ad00880fddaa":"7T1aN","5e0ee530611ef38d":"ebTVd","800a47a98b497e55":"jsw26","faaaddc6a409cf90":"8SraZ"}],"byYdd":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("6846524790b14a7c");
var $filter = require("69eb0f28238e9173").filter;
var fromSameTypeAndList = require("d404a3c06ca3bb3e");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */ ) {
    var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return fromSameTypeAndList(this, list);
});

},{"6846524790b14a7c":"7Qezi","69eb0f28238e9173":"giEdW","d404a3c06ca3bb3e":"bya5J"}],"bya5J":[function(require,module,exports,__globalThis) {
'use strict';
var arrayFromConstructorAndList = require("b597c909ed514557");
var getTypedArrayConstructor = require("671cb65500632ecc").getTypedArrayConstructor;
module.exports = function(instance, list) {
    return arrayFromConstructorAndList(getTypedArrayConstructor(instance), list);
};

},{"b597c909ed514557":"ca60S","671cb65500632ecc":"7Qezi"}],"4TKC3":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("2ee42d54019723d0");
var $find = require("f74f952feb3fa9ac").find;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */ ) {
    return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"2ee42d54019723d0":"7Qezi","f74f952feb3fa9ac":"giEdW"}],"dxzWH":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("8a1e1a9ff0bdb479");
var $findIndex = require("faaa2d0f518f9401").findIndex;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */ ) {
    return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"8a1e1a9ff0bdb479":"7Qezi","faaa2d0f518f9401":"giEdW"}],"6UPEo":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("905afd384f4e3de6");
var $forEach = require("d55109422f6a63d3").forEach;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */ ) {
    $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"905afd384f4e3de6":"7Qezi","d55109422f6a63d3":"giEdW"}],"e5EzV":[function(require,module,exports,__globalThis) {
'use strict';
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require("e24f9b87534e32a3");
var exportTypedArrayStaticMethod = require("9358eeabcbb18f49").exportTypedArrayStaticMethod;
var typedArrayFrom = require("49819eabcb3ccea1");
// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);

},{"e24f9b87534e32a3":"a0x3D","9358eeabcbb18f49":"7Qezi","49819eabcb3ccea1":"eTIk8"}],"lRVLC":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("7cf07194bf630e10");
var $includes = require("6783fff4c8e274ff").includes;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */ ) {
    return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"7cf07194bf630e10":"7Qezi","6783fff4c8e274ff":"pBaPo"}],"1anZM":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("19c9cea2a3392f92");
var $indexOf = require("728bfde1b6b9fa8c").indexOf;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */ ) {
    return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"19c9cea2a3392f92":"7Qezi","728bfde1b6b9fa8c":"pBaPo"}],"ho2tp":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("3da36adbfe4f1c5e");
var fails = require("87513a57210d794");
var uncurryThis = require("ab6b74db00db51f7");
var ArrayBufferViewCore = require("21e9ae10aded4ff7");
var ArrayIterators = require("fe81c4288afbe8ee");
var wellKnownSymbol = require("ddb435c2e5bdfda1");
var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = globalThis.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;
var GENERIC = !fails(function() {
    TypedArrayPrototype[ITERATOR].call([
        1
    ]);
});
var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === 'values';
var typedArrayValues = function values() {
    return arrayValues(aTypedArray(this));
};
// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
    return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
    return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
    name: 'values'
});
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
    name: 'values'
});

},{"3da36adbfe4f1c5e":"4naf8","87513a57210d794":"8SraZ","ab6b74db00db51f7":"jsw26","21e9ae10aded4ff7":"7Qezi","fe81c4288afbe8ee":"6J6Pu","ddb435c2e5bdfda1":"6dJgl"}],"1QC5G":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("4a1cb40dad4dd1ac");
var uncurryThis = require("68cfb4a8ab57e7b8");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);
// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
    return $join(aTypedArray(this), separator);
});

},{"4a1cb40dad4dd1ac":"7Qezi","68cfb4a8ab57e7b8":"jsw26"}],"f3Z1B":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("83d52c5c09010d50");
var apply = require("a5b16a6fc92268b4");
var $lastIndexOf = require("9b20398976dd53df");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */ ) {
    var length = arguments.length;
    return apply($lastIndexOf, aTypedArray(this), length > 1 ? [
        searchElement,
        arguments[1]
    ] : [
        searchElement
    ]);
});

},{"83d52c5c09010d50":"7Qezi","a5b16a6fc92268b4":"kuGqn","9b20398976dd53df":"38nHG"}],"38nHG":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable es/no-array-prototype-lastindexof -- safe */ var apply = require("4ca7787412cb919d");
var toIndexedObject = require("883419ed27232d44");
var toIntegerOrInfinity = require("ec6d0c7c9b243b67");
var lengthOfArrayLike = require("f185a9d11d03524a");
var arrayMethodIsStrict = require("6d58dcee43d16a4d");
var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return -1;
    var index = length - 1;
    if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $lastIndexOf;

},{"4ca7787412cb919d":"kuGqn","883419ed27232d44":"gGepo","ec6d0c7c9b243b67":"wKg8O","f185a9d11d03524a":"fp6Bt","6d58dcee43d16a4d":"gl0vh"}],"1PogV":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("47e7bb602930e61a");
var $map = require("8e0cd2bb3fe997bb").map;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */ ) {
    return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
        return new (getTypedArrayConstructor(O))(length);
    });
});

},{"47e7bb602930e61a":"7Qezi","8e0cd2bb3fe997bb":"giEdW"}],"aZ40M":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("8205d0df207de27c");
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require("ff4c68a63e37d828");
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of() {
    var index = 0;
    var length = arguments.length;
    var result = new (aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);

},{"8205d0df207de27c":"7Qezi","ff4c68a63e37d828":"a0x3D"}],"1zz7d":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("44c8794ad6be555f");
var $reduce = require("1163c739252ce603").left;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"44c8794ad6be555f":"7Qezi","1163c739252ce603":"DHHU2"}],"DHHU2":[function(require,module,exports,__globalThis) {
'use strict';
var aCallable = require("93e7a99f8d3bc817");
var toObject = require("915d05570b61a3c9");
var IndexedObject = require("da310552be96f5db");
var lengthOfArrayLike = require("f4209260f2003c23");
var $TypeError = TypeError;
var REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = toObject(that);
        var self = IndexedObject(O);
        var length = lengthOfArrayLike(O);
        aCallable(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $TypeError(REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: createMethod(true)
};

},{"93e7a99f8d3bc817":"ehOyc","915d05570b61a3c9":"gxWv7","da310552be96f5db":"dnbS6","f4209260f2003c23":"fp6Bt"}],"bgWqn":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("b70766ffaffbfa51");
var $reduceRight = require("5f58f990e3d5d551").right;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"b70766ffaffbfa51":"7Qezi","5f58f990e3d5d551":"DHHU2"}],"l27V6":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("2692a9613069388b");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;
// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
    var that = this;
    var length = aTypedArray(that).length;
    var middle = floor(length / 2);
    var index = 0;
    var value;
    while(index < middle){
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
    }
    return that;
});

},{"2692a9613069388b":"7Qezi"}],"951XZ":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("3c4f43e566ab7632");
var call = require("8bf28e9cdb4b51e7");
var ArrayBufferViewCore = require("3cf762b146f90585");
var lengthOfArrayLike = require("16f38bcdf8d74421");
var toOffset = require("4a9c5a15d77842f8");
var toIndexedObject = require("e57503c492a0d3da");
var fails = require("52b307bfea7391a");
var RangeError = globalThis.RangeError;
var Int8Array = globalThis.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    call($set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function() {
    var array = new Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    aTypedArray(this);
    var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = toIndexedObject(arrayLike);
    if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
    var length = this.length;
    var len = lengthOfArrayLike(src);
    var index = 0;
    if (len + offset > length) throw new RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

},{"3c4f43e566ab7632":"4naf8","8bf28e9cdb4b51e7":"ebTVd","3cf762b146f90585":"7Qezi","16f38bcdf8d74421":"fp6Bt","4a9c5a15d77842f8":"cyDm3","e57503c492a0d3da":"gxWv7","52b307bfea7391a":"8SraZ"}],"hEb3t":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("d8cf74b619b99d16");
var fails = require("cde6d683247bdb44");
var arraySlice = require("a6442c63e141a126");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var FORCED = fails(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
});
// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
    var list = arraySlice(aTypedArray(this), start, end);
    var C = getTypedArrayConstructor(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
}, FORCED);

},{"d8cf74b619b99d16":"7Qezi","cde6d683247bdb44":"8SraZ","a6442c63e141a126":"iIoNC"}],"kCDTa":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("78c3191738d81c4d");
var $some = require("b1ba67becb59f503").some;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */ ) {
    return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"78c3191738d81c4d":"7Qezi","b1ba67becb59f503":"giEdW"}],"76Oi3":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("1319b11c96d7a212");
var uncurryThis = require("443f315e07e91c29");
var fails = require("8dc6cee8a97e45cb");
var aCallable = require("d6c4034c4939c7d5");
var internalSort = require("f3e3e1c809574ce3");
var ArrayBufferViewCore = require("cab25e21cd947849");
var FF = require("c53adf7878431ec6");
var IE_OR_EDGE = require("90728397db1428a3");
var V8 = require("c20e84b46e983c4f");
var WEBKIT = require("8b919df81d7fcf47");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = globalThis.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);
// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function() {
    nativeSort(new Uint16Array(2), null);
}) && fails(function() {
    nativeSort(new Uint16Array(2), {});
}));
var STABLE_SORT = !!nativeSort && !fails(function() {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 74;
    if (FF) return FF < 67;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 602;
    var array = new Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);
    if (STABLE_SORT) return nativeSort(this, comparefn);
    return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

},{"1319b11c96d7a212":"4naf8","443f315e07e91c29":"kBsBX","8dc6cee8a97e45cb":"8SraZ","d6c4034c4939c7d5":"ehOyc","f3e3e1c809574ce3":"6F6CU","cab25e21cd947849":"7Qezi","c53adf7878431ec6":"aYGh2","90728397db1428a3":"8uxsz","c20e84b46e983c4f":"7Fmxi","8b919df81d7fcf47":"cqPJu"}],"4wLnW":[function(require,module,exports,__globalThis) {
'use strict';
var ArrayBufferViewCore = require("d3219a9d813dfae3");
var toLength = require("815a66ab54718368");
var toAbsoluteIndex = require("576f4ad682879893");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
    var O = aTypedArray(this);
    var length = O.length;
    var beginIndex = toAbsoluteIndex(begin, length);
    var C = getTypedArrayConstructor(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex));
});

},{"d3219a9d813dfae3":"7Qezi","815a66ab54718368":"4f0fH","576f4ad682879893":"3itgc"}],"4pCzt":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("d23c9dad2cb3d012");
var apply = require("961a14c04c94ca8e");
var ArrayBufferViewCore = require("aa830556bb66a52b");
var fails = require("1477df799d469d0c");
var arraySlice = require("6bdde3bff05f534b");
var Int8Array = globalThis.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function() {
    $toLocaleString.call(new Int8Array(1));
});
var FORCED = fails(function() {
    return [
        1,
        2
    ].toLocaleString() !== new Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !fails(function() {
    Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
    return apply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this), arraySlice(arguments));
}, FORCED);

},{"d23c9dad2cb3d012":"4naf8","961a14c04c94ca8e":"kuGqn","aa830556bb66a52b":"7Qezi","1477df799d469d0c":"8SraZ","6bdde3bff05f534b":"iIoNC"}],"dIEMx":[function(require,module,exports,__globalThis) {
'use strict';
var exportTypedArrayMethod = require("ba1ad98ce5955ae6").exportTypedArrayMethod;
var fails = require("7fb7589d87925c0e");
var globalThis = require("9ae1b5b748ef0512");
var uncurryThis = require("9d0cad3ff385c8e1");
var Uint8Array = globalThis.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);
if (fails(function() {
    arrayToString.call({});
})) arrayToString = function toString() {
    return join(this);
};
var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;
// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);

},{"ba1ad98ce5955ae6":"7Qezi","7fb7589d87925c0e":"8SraZ","9ae1b5b748ef0512":"4naf8","9d0cad3ff385c8e1":"jsw26"}],"2rWO3":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("a8c1e25017437d");

},{"a8c1e25017437d":"amSsA"}],"amSsA":[function(require,module,exports,__globalThis) {
'use strict';
var FREEZING = require("4e60997043599c68");
var globalThis = require("5341adea83e89c0c");
var uncurryThis = require("182f989a492de7c6");
var defineBuiltIns = require("b41734fbe20d8ad4");
var InternalMetadataModule = require("78ba01528267d962");
var collection = require("32fff688dc79e50c");
var collectionWeak = require("b362d8e7ff41644e");
var isObject = require("40b9e3e73f50872d");
var enforceInternalState = require("e46a6ca6b98d61d0").enforce;
var fails = require("878a9525b93f8113");
var NATIVE_WEAK_MAP = require("2163c9ee83b27dfc");
var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;
var IS_IE11 = !globalThis.ActiveXObject && 'ActiveXObject' in globalThis;
var InternalWeakMap;
var wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return FREEZING && fails(function() {
        var frozenArray = freeze([]);
        nativeSet(new $WeakMap(), frozenArray, 1);
        return !isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) {
    if (IS_IE11) {
        InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
        InternalMetadataModule.enable();
        var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
        var nativeHas = uncurryThis(WeakMapPrototype.has);
        var nativeGet = uncurryThis(WeakMapPrototype.get);
        defineBuiltIns(WeakMapPrototype, {
            'delete': function(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return nativeDelete(this, key);
            },
            has: function has(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeHas(this, key) || state.frozen.has(key);
                }
                return nativeHas(this, key);
            },
            get: function get(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
                }
                return nativeGet(this, key);
            },
            set: function set(key, value) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
                } else nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if (hasMSEdgeFreezingBug()) defineBuiltIns(WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if (isArray(key)) {
                if (isFrozen(key)) arrayIntegrityLevel = freeze;
                else if (isSealed(key)) arrayIntegrityLevel = seal;
            }
            nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}

},{"4e60997043599c68":"88qwO","5341adea83e89c0c":"4naf8","182f989a492de7c6":"jsw26","b41734fbe20d8ad4":"iYMvV","78ba01528267d962":"lmr1u","32fff688dc79e50c":"fn4lx","b362d8e7ff41644e":"ypKcu","40b9e3e73f50872d":"8iIJm","e46a6ca6b98d61d0":"4Dlpx","878a9525b93f8113":"8SraZ","2163c9ee83b27dfc":"akad7"}],"ypKcu":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("1805cb6220d706e7");
var defineBuiltIns = require("5263c73c3566f1ef");
var getWeakData = require("9764e89aab31dc9a").getWeakData;
var anInstance = require("e632c1106cb00cea");
var anObject = require("602fe1299f06e16c");
var isNullOrUndefined = require("bfb5a8bfdc9265b1");
var isObject = require("211f42379f0813a");
var iterate = require("830bf4bd7bf8261c");
var ArrayIterationModule = require("ffaf20b85e78d82f");
var hasOwn = require("cef0026b9b05e2");
var InternalStateModule = require("96b7fea7b9fcfa28");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;
// fallback for uncaught frozen keys
var uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return find(store.entries, function(it) {
        return it[0] === key;
    });
};
UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: id++,
                frozen: null
            });
            if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = getWeakData(anObject(key), true);
            if (data === true) uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        defineBuiltIns(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state)['delete'](key);
                return data && hasOwn(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state).has(key);
                return data && hasOwn(data, state.id);
            }
        });
        defineBuiltIns(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if (isObject(key)) {
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

},{"1805cb6220d706e7":"jsw26","5263c73c3566f1ef":"iYMvV","9764e89aab31dc9a":"lmr1u","e632c1106cb00cea":"9RDjg","602fe1299f06e16c":"2dEST","bfb5a8bfdc9265b1":"9lebS","211f42379f0813a":"8iIJm","830bf4bd7bf8261c":"gjriO","ffaf20b85e78d82f":"giEdW","cef0026b9b05e2":"h2GWh","96b7fea7b9fcfa28":"4Dlpx"}],"49HaD":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("12401c27bcb73ff5");

},{"12401c27bcb73ff5":"knePI"}],"knePI":[function(require,module,exports,__globalThis) {
'use strict';
var collection = require("bb905240cfe53967");
var collectionWeak = require("3bcac50549cb5487");
// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function(init) {
    return function WeakSet() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionWeak);

},{"bb905240cfe53967":"fn4lx","3bcac50549cb5487":"ypKcu"}],"k7no3":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("f2983879ab6ef4f");
var DOMIterables = require("74a037ab8118876");
var DOMTokenListPrototype = require("a3359ffcd052df79");
var forEach = require("9e6862fbf1bc54d2");
var createNonEnumerableProperty = require("833a1c6e8a10b1ff");
var handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
        createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
    } catch (error) {
        CollectionPrototype.forEach = forEach;
    }
};
for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype);
handlePrototype(DOMTokenListPrototype);

},{"f2983879ab6ef4f":"4naf8","74a037ab8118876":"cD8IV","a3359ffcd052df79":"dQSR9","9e6862fbf1bc54d2":"lvFPY","833a1c6e8a10b1ff":"3IHVb"}],"cD8IV":[function(require,module,exports,__globalThis) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

},{}],"dQSR9":[function(require,module,exports,__globalThis) {
'use strict';
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require("a6fc44eba1875331");
var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"a6fc44eba1875331":"5Nn9T"}],"lvFPY":[function(require,module,exports,__globalThis) {
'use strict';
var $forEach = require("1a0535b754110eb5").forEach;
var arrayMethodIsStrict = require("df61bc1b7a92de0f");
var STRICT_METHOD = arrayMethodIsStrict('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

},{"1a0535b754110eb5":"giEdW","df61bc1b7a92de0f":"gl0vh"}],"ix44t":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("c051336c9ece485c");
var DOMIterables = require("b1dd6223fec045b2");
var DOMTokenListPrototype = require("2927608065790e8a");
var ArrayIteratorMethods = require("107ef5eaf95c92b0");
var createNonEnumerableProperty = require("2f02b421bbdb9eb4");
var setToStringTag = require("46e3db6eb678f758");
var wellKnownSymbol = require("6a4d2091548e6557");
var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
        } catch (error) {
            CollectionPrototype[ITERATOR] = ArrayValues;
        }
        setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var COLLECTION_NAME in DOMIterables)handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

},{"c051336c9ece485c":"4naf8","b1dd6223fec045b2":"cD8IV","2927608065790e8a":"dQSR9","107ef5eaf95c92b0":"6J6Pu","2f02b421bbdb9eb4":"3IHVb","46e3db6eb678f758":"3q5sA","6a4d2091548e6557":"6dJgl"}],"dJTOQ":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require("52e9b3eefbbce1ed");
require("292fa64716f5b39e");

},{"52e9b3eefbbce1ed":"1AgRk","292fa64716f5b39e":"6gd77"}],"1AgRk":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("79389288a80b279c");
var globalThis = require("e4d64249a0133d14");
var clearImmediate = require("84ba5ca62b8b14c9").clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$({
    global: true,
    bind: true,
    enumerable: true,
    forced: globalThis.clearImmediate !== clearImmediate
}, {
    clearImmediate: clearImmediate
});

},{"79389288a80b279c":"gD2TP","e4d64249a0133d14":"4naf8","84ba5ca62b8b14c9":"iFrSo"}],"6gd77":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("33581c362196ed1f");
var globalThis = require("503bb555249cad41");
var setTask = require("4219ce460223bd08").set;
var schedulersFix = require("738dc378e6a94c64");
// https://github.com/oven-sh/bun/issues/1633
var setImmediate = globalThis.setImmediate ? schedulersFix(setTask, false) : setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({
    global: true,
    bind: true,
    enumerable: true,
    forced: globalThis.setImmediate !== setImmediate
}, {
    setImmediate: setImmediate
});

},{"33581c362196ed1f":"gD2TP","503bb555249cad41":"4naf8","4219ce460223bd08":"iFrSo","738dc378e6a94c64":"ipLhC"}],"ipLhC":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("aa6765693e58a0fe");
var apply = require("a68ecfcbf29c46f6");
var isCallable = require("7087588d33667af2");
var ENVIRONMENT = require("864edee099e8affb");
var USER_AGENT = require("3a3a5a2cfab86f21");
var arraySlice = require("cff2c830bdea4f24");
var validateArgumentsLength = require("58a74f00cee1ac64");
var Function = globalThis.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === 'BUN' && function() {
    var version = globalThis.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
        var fn = isCallable(handler) ? handler : Function(handler);
        var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            apply(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

},{"aa6765693e58a0fe":"4naf8","a68ecfcbf29c46f6":"kuGqn","7087588d33667af2":"37CJl","864edee099e8affb":"8tXV2","3a3a5a2cfab86f21":"7UNqW","cff2c830bdea4f24":"iIoNC","58a74f00cee1ac64":"jHJH4"}],"8J4gq":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("6f7278673cd963e5");
var globalThis = require("4f851b5e5b332d48");
var microtask = require("b80db4539abf09d9");
var aCallable = require("889c274f5e23b39");
var validateArgumentsLength = require("15983ab5c2fbc059");
var fails = require("c36112b7edfed618");
var DESCRIPTORS = require("74b26aee0ae17038");
// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9249
var WRONG_ARITY = fails(function() {
    // getOwnPropertyDescriptor for prevent experimental warning in Node 11
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis, 'queueMicrotask').value.length !== 1;
});
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$({
    global: true,
    enumerable: true,
    dontCallGetSet: true,
    forced: WRONG_ARITY
}, {
    queueMicrotask: function queueMicrotask(fn) {
        validateArgumentsLength(arguments.length, 1);
        microtask(aCallable(fn));
    }
});

},{"6f7278673cd963e5":"gD2TP","4f851b5e5b332d48":"4naf8","b80db4539abf09d9":"6gdfi","889c274f5e23b39":"ehOyc","15983ab5c2fbc059":"jHJH4","c36112b7edfed618":"8SraZ","74b26aee0ae17038":"ihfdR"}],"9p0om":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("99544a7edcd747a5");

},{"99544a7edcd747a5":"2PxLN"}],"2PxLN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("19928ff2abfc3536");
var $ = require("d446e2097c7c2b23");
var DESCRIPTORS = require("cd0458003d61a323");
var USE_NATIVE_URL = require("592c96d240ad401c");
var globalThis = require("2e7550752ce99b71");
var bind = require("c128b8cb3e38a436");
var uncurryThis = require("9ee66bece60e18c5");
var defineBuiltIn = require("763c39a8b521ff54");
var defineBuiltInAccessor = require("1c9277bbea264bc7");
var anInstance = require("f0dd676601f7cb0b");
var hasOwn = require("deee7b2fe3c1e96f");
var assign = require("ff3437c5b86d6c26");
var arrayFrom = require("3c2f033d1a197fd6");
var arraySlice = require("9fdfccae2d327739");
var codeAt = require("8ba5b2695179827").codeAt;
var toASCII = require("23751b8f28dcd37");
var $toString = require("5f808b1954b24403");
var setToStringTag = require("f969f30083a50975");
var validateArgumentsLength = require("b15c5243fe0e0f6");
var URLSearchParamsModule = require("e8b262dfe3e4c989");
var InternalStateModule = require("9a3ca045fbb43248");
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var NativeURL = globalThis.URL;
var TypeError = globalThis.TypeError;
var parseInt = globalThis.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);
var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';
var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function parseIPv4(input) {
    var parts = split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === '') parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === '') return input;
        radix = 10;
        if (part.length > 1 && charAt(part, 0) === '0') {
            radix = exec(HEX_START, part) ? 16 : 8;
            part = stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === '') number = 0;
        else {
            if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
            number = parseInt(part, radix);
        }
        push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return charAt(input, pointer);
    };
    if (chr() === ':') {
        if (charAt(input, 1) !== ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ':') {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && exec(HEX, chr())){
            value = value * 16 + parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === '.') {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === '.' && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!exec(DIGIT, chr())) return;
                while(exec(DIGIT, chr())){
                    number = parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ':') {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    return currLength > maxLength ? currStart : maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == 'number') {
        result = [];
        for(index = 0; index < 4; index++){
            unshift(result, host % 256);
            host = floor(host / 256);
        }
        return join(result, '.');
    }
    // ipv6
    if ((typeof host === "undefined" ? "undefined" : (0, _typeOf._)(host)) == 'object') {
        result = '';
        compress = findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ':' : '::';
                ignore0 = true;
            } else {
                result += numberToString(host[index], 16);
                if (index < 7) result += ':';
            }
        }
        return '[' + result + ']';
    }
    return host;
};
var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
});
var percentEncode = function percentEncode(chr, set) {
    var code = codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length === 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) === ':' || !normalized && second === '|');
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length === 2 || (third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function isSingleDot(segment) {
    return segment === '.' || toLowerCase(segment) === '%2e';
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function isDoubleDot(segment) {
    segment = toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};
var URLState = function URLState1(url, isBase, base) {
    var urlString = $toString(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new TypeError(failure);
        searchParams = getInternalSearchParamsState(new URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || SCHEME_START;
        var pointer = 0;
        var buffer = '';
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $toString(input);
        if (!stateOverride) {
            url.scheme = '';
            url.username = '';
            url.password = '';
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
            input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
        }
        input = replace(input, TAB_AND_NEW_LINE, '');
        codePoints = arrayFrom(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case SCHEME_START:
                    if (chr && exec(ALPHA, chr)) {
                        buffer += toLowerCase(chr);
                        state = SCHEME;
                    } else if (!stateOverride) {
                        state = NO_SCHEME;
                        continue;
                    } else return INVALID_SCHEME;
                    break;
                case SCHEME:
                    if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) buffer += toLowerCase(chr);
                    else if (chr === ':') {
                        if (stateOverride && (url.isSpecial() !== hasOwn(specialSchemes, buffer) || buffer === 'file' && (url.includesCredentials() || url.port !== null) || url.scheme === 'file' && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = '';
                        if (url.scheme === 'file') state = FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === '/') {
                            state = PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            push(url.path, '');
                            state = CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = '';
                        state = NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return INVALID_SCHEME;
                    break;
                case NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== '#') return INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === '#') {
                        url.scheme = base.scheme;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        url.cannotBeABaseURL = true;
                        state = FRAGMENT;
                        break;
                    }
                    state = base.scheme === 'file' ? FILE : RELATIVE;
                    continue;
                case SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === '/' && codePoints[pointer + 1] === '/') {
                        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = RELATIVE;
                        continue;
                    }
                    break;
                case PATH_OR_AUTHORITY:
                    if (chr === '/') {
                        state = AUTHORITY;
                        break;
                    } else {
                        state = PATH;
                        continue;
                    }
                case RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                    } else if (chr === '/' || chr === '\\' && url.isSpecial()) state = RELATIVE_SLASH;
                    else if (chr === '?') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = '';
                        state = QUERY;
                    } else if (chr === '#') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        state = FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.path.length--;
                        state = PATH;
                        continue;
                    }
                    break;
                case RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === '/' || chr === '\\')) state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === '/') state = AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = PATH;
                        continue;
                    }
                    break;
                case SPECIAL_AUTHORITY_SLASHES:
                    state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
                    pointer++;
                    break;
                case SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== '/' && chr !== '\\') {
                        state = AUTHORITY;
                        continue;
                    }
                    break;
                case AUTHORITY:
                    if (chr === '@') {
                        if (seenAt) buffer = '%40' + buffer;
                        seenAt = true;
                        bufferCodePoints = arrayFrom(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ':' && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = '';
                    } else if (chr === EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (seenAt && buffer === '') return INVALID_AUTHORITY;
                        pointer -= arrayFrom(buffer).length + 1;
                        buffer = '';
                        state = HOST;
                    } else buffer += chr;
                    break;
                case HOST:
                case HOSTNAME:
                    if (stateOverride && url.scheme === 'file') {
                        state = FILE_HOST;
                        continue;
                    } else if (chr === ':' && !seenBracket) {
                        if (buffer === '') return INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = PORT;
                        if (stateOverride === HOSTNAME) return;
                    } else if (chr === EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (url.isSpecial() && buffer === '') return INVALID_HOST;
                        if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === '[') seenBracket = true;
                        else if (chr === ']') seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case PORT:
                    if (exec(DIGIT, chr)) buffer += chr;
                    else if (chr === EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial() || stateOverride) {
                        if (buffer !== '') {
                            var port = parseInt(buffer, 10);
                            if (port > 0xFFFF) return INVALID_PORT;
                            url.port = url.isSpecial() && port === specialSchemes[url.scheme] ? null : port;
                            buffer = '';
                        }
                        if (stateOverride) return;
                        state = PATH_START;
                        continue;
                    } else return INVALID_PORT;
                    break;
                case FILE:
                    url.scheme = 'file';
                    if (chr === '/' || chr === '\\') state = FILE_SLASH;
                    else if (base && base.scheme === 'file') switch(chr){
                        case EOF:
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = base.query;
                            break;
                        case '?':
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = '';
                            state = QUERY;
                            break;
                        case '#':
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = base.query;
                            url.fragment = '';
                            state = FRAGMENT;
                            break;
                        default:
                            if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                                url.host = base.host;
                                url.path = arraySlice(base.path);
                                url.shortenPath();
                            }
                            state = PATH;
                            continue;
                    }
                    else {
                        state = PATH;
                        continue;
                    }
                    break;
                case FILE_SLASH:
                    if (chr === '/' || chr === '\\') {
                        state = FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                        if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = PATH;
                    continue;
                case FILE_HOST:
                    if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
                        if (!stateOverride && isWindowsDriveLetter(buffer)) state = PATH;
                        else if (buffer === '') {
                            url.host = '';
                            if (stateOverride) return;
                            state = PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === 'localhost') url.host = '';
                            if (stateOverride) return;
                            buffer = '';
                            state = PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case PATH_START:
                    if (url.isSpecial()) {
                        state = PATH;
                        if (chr !== '/' && chr !== '\\') continue;
                    } else if (!stateOverride && chr === '?') {
                        url.query = '';
                        state = QUERY;
                    } else if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = FRAGMENT;
                    } else if (chr !== EOF) {
                        state = PATH;
                        if (chr !== '/') continue;
                    }
                    break;
                case PATH:
                    if (chr === EOF || chr === '/' || chr === '\\' && url.isSpecial() || !stateOverride && (chr === '?' || chr === '#')) {
                        if (isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) push(url.path, '');
                        } else if (isSingleDot(buffer)) {
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) push(url.path, '');
                        } else {
                            if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = '';
                                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
                            }
                            push(url.path, buffer);
                        }
                        buffer = '';
                        if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) while(url.path.length > 1 && url.path[0] === '')shift(url.path);
                        if (chr === '?') {
                            url.query = '';
                            state = QUERY;
                        } else if (chr === '#') {
                            url.fragment = '';
                            state = FRAGMENT;
                        }
                    } else buffer += percentEncode(chr, pathPercentEncodeSet);
                    break;
                case CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === '?') {
                        url.query = '';
                        state = QUERY;
                    } else if (chr === '#') {
                        url.fragment = '';
                        state = FRAGMENT;
                    } else if (chr !== EOF) url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
                    break;
                case QUERY:
                    if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = FRAGMENT;
                    } else if (chr !== EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += '%27';
                        else if (chr === '#') url.query += '%23';
                        else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
                    }
                    break;
                case FRAGMENT:
                    if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
        var result, codePoints, index;
        if (charAt(input, 0) === '[') {
            if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
            result = parseIPv6(stringSlice(input, 1, -1));
            if (!result) return INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
            result = '';
            codePoints = arrayFrom(input);
            for(index = 0; index < codePoints.length; index++)result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = toASCII(input);
            if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
            result = parseIPv4(input);
            if (result === null) return INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
        return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
        return this.username !== '' || this.password !== '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
        return hasOwn(specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ':';
        if (host !== null) {
            output += '//';
            if (url.includesCredentials()) output += username + (password ? ':' + password : '') + '@';
            output += serializeHost(host);
            if (port !== null) output += ':' + port;
        } else if (scheme === 'file') output += '//';
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
        if (query !== null) output += '?' + query;
        if (fragment !== null) output += '#' + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
        var failure = this.parse(href);
        if (failure) throw new TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === 'blob') try {
            return new URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return 'null';
        }
        if (scheme === 'file' || !this.isSpecial()) return 'null';
        return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
        return this.scheme + ':';
    },
    setProtocol: function setProtocol(protocol) {
        this.parse($toString(protocol) + ':', SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
        return this.username;
    },
    setUsername: function setUsername(username) {
        var codePoints = arrayFrom($toString(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = '';
        for(var i = 0; i < codePoints.length; i++)this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
        return this.password;
    },
    setPassword: function setPassword(password) {
        var codePoints = arrayFrom($toString(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = '';
        for(var i = 0; i < codePoints.length; i++)this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
        var host = this.host;
        var port = this.port;
        return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
    },
    setHost: function setHost(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
        var host = this.host;
        return host === null ? '' : serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
        var port = this.port;
        return port === null ? '' : $toString(port);
    },
    setPort: function setPort(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $toString(port);
        if (port === '') this.port = null;
        else this.parse(port, PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    },
    setPathname: function setPathname(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
        var query = this.query;
        return query ? '?' + query : '';
    },
    setSearch: function setSearch(search) {
        search = $toString(search);
        if (search === '') this.query = null;
        else {
            if (charAt(search, 0) === '?') search = stringSlice(search, 1);
            this.query = '';
            this.parse(search, QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
        var fragment = this.fragment;
        return fragment ? '#' + fragment : '';
    },
    setHash: function setHash(hash) {
        hash = $toString(hash);
        if (hash === '') {
            this.fragment = null;
            return;
        }
        if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
        this.fragment = '';
        this.parse(hash, FRAGMENT);
    },
    update: function update() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */ ) {
    var that = anInstance(this, URLPrototype);
    var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = setInternalState(that, new URLState(url, false, base));
    if (!DESCRIPTORS) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var URLPrototype = URLConstructor.prototype;
var accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: function get() {
            return getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if (DESCRIPTORS) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
    return getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
    return getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if (NativeURL) {
    var nativeCreateObjectURL = NativeURL.createObjectURL;
    var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}
setToStringTag(URLConstructor, 'URL');
$({
    global: true,
    constructor: true,
    forced: !USE_NATIVE_URL,
    sham: !DESCRIPTORS
}, {
    URL: URLConstructor
});

},{"@swc/helpers/_/_type_of":"668P4","19928ff2abfc3536":"Q5Pd0","d446e2097c7c2b23":"gD2TP","cd0458003d61a323":"ihfdR","592c96d240ad401c":"d3b1h","2e7550752ce99b71":"4naf8","c128b8cb3e38a436":"7xEW7","9ee66bece60e18c5":"jsw26","763c39a8b521ff54":"jlXZ9","1c9277bbea264bc7":"g2LDG","f0dd676601f7cb0b":"9RDjg","deee7b2fe3c1e96f":"h2GWh","ff3437c5b86d6c26":"cHd8y","3c2f033d1a197fd6":"bnqz2","9fdfccae2d327739":"iIoNC","8ba5b2695179827":"6s5lj","23751b8f28dcd37":"cHf0l","5f808b1954b24403":"ffo0a","f969f30083a50975":"3q5sA","b15c5243fe0e0f6":"jHJH4","e8b262dfe3e4c989":"a8ZGz","9a3ca045fbb43248":"4Dlpx"}],"d3b1h":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("b638e4b55492b349");
var wellKnownSymbol = require("d3a18943af316a4c");
var DESCRIPTORS = require("f39eaf2672eb61e1");
var IS_PURE = require("f816319c57ebd10b");
var ITERATOR = wellKnownSymbol('iterator');
module.exports = !fails(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'https://a');
    var params = url.searchParams;
    var params2 = new URLSearchParams('a=1&a=2&b=3');
    var result = '';
    url.pathname = 'c%20d';
    params.forEach(function(value, key) {
        params['delete']('b');
        result += key + value;
    });
    params2['delete']('a', 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2['delete']('b', undefined);
    return IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && (IS_PURE || !DESCRIPTORS) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
});

},{"b638e4b55492b349":"8SraZ","d3a18943af316a4c":"6dJgl","f39eaf2672eb61e1":"ihfdR","f816319c57ebd10b":"6KD1D"}],"cHf0l":[function(require,module,exports,__globalThis) {
'use strict';
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = require("5fc1d380e4ee310c");
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                push(output, value);
                counter--;
            }
        } else push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    while(delta > baseMinusTMin * tMax >> 1){
        delta = floor(delta / baseMinusTMin);
        k += base;
    }
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = initialN;
    var delta = 0;
    var bias = initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) push(output, fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) push(output, delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) throw new $RangeError(OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > maxInt) throw new $RangeError(OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = base;
                while(true){
                    var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = base - t;
                    push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
                    q = floor(qMinusT / baseMinusT);
                    k += base;
                }
                push(output, fromCharCode(digitToBasic(q)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return join(output, '');
};
module.exports = function(input) {
    var encoded = [];
    var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
    }
    return join(encoded, '.');
};

},{"5fc1d380e4ee310c":"jsw26"}],"a8ZGz":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("12e7a75121005a18");
require("aed1dbd908154980");
var $ = require("2c283453b2df07f7");
var globalThis = require("f8300b17f61c07ea");
var safeGetBuiltIn = require("c6afc8e42ff4d861");
var getBuiltIn = require("c5226e6ac6c1a4ca");
var call = require("c70bfc3d71513918");
var uncurryThis = require("a30c0c0ecacbf883");
var DESCRIPTORS = require("9dc980ea97e54f2d");
var USE_NATIVE_URL = require("34e5e214071de9f5");
var defineBuiltIn = require("d5c866a8dfde6bfe");
var defineBuiltInAccessor = require("cfb67c7a1a4f1af9");
var defineBuiltIns = require("f0c2290e210049d5");
var setToStringTag = require("c7a2f88a5440a541");
var createIteratorConstructor = require("fb2d9f4ac91c2856");
var InternalStateModule = require("5e8fcf76ef17aca5");
var anInstance = require("486653683495e4a1");
var isCallable = require("34563d35f35f9929");
var hasOwn = require("b866aa0bde936df4");
var bind = require("b5970b9126e1d395");
var classof = require("71cd06e9ca4a93a2");
var anObject = require("7e16c364467ce62d");
var isObject = require("9a0912d2261bbada");
var $toString = require("9d062cdf188403bf");
var create = require("1caa2aad22025751");
var createPropertyDescriptor = require("bf766970034bde82");
var getIterator = require("c6d4d2a85cdef35a");
var getIteratorMethod = require("6668155f748c33e9");
var createIterResultObject = require("982e5845e606dff7");
var validateArgumentsLength = require("9a407fe1b80ba6f5");
var wellKnownSymbol = require("778323e4214f089d");
var arraySort = require("83b87fb1800baf72");
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError = globalThis.TypeError;
var encodeURIComponent = globalThis.encodeURIComponent;
var fromCharCode = String.fromCharCode;
var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var exec = uncurryThis(/./.exec);
var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;
var parseHexOctet = function parseHexOctet(string, start) {
    var substr = stringSlice(string, start, start + 2);
    if (!exec(VALID_HEX, substr)) return NaN;
    return $parseInt(substr, 16);
};
var getLeadingOnes = function getLeadingOnes(octet) {
    var count = 0;
    for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
    return count;
};
var utf8Decode = function utf8Decode(octets) {
    var codePoint = null;
    switch(octets.length){
        case 1:
            codePoint = octets[0];
            break;
        case 2:
            codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
            break;
        case 3:
            codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
            break;
        case 4:
            codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
            break;
    }
    return codePoint > 0x10FFFF ? null : codePoint;
};
var decode = function decode(input) {
    input = replace(input, plus, ' ');
    var length = input.length;
    var result = '';
    var i = 0;
    while(i < length){
        var decodedChar = charAt(input, i);
        if (decodedChar === '%') {
            if (charAt(input, i + 1) === '%' || i + 3 > length) {
                result += '%';
                i++;
                continue;
            }
            var octet = parseHexOctet(input, i + 1);
            // eslint-disable-next-line no-self-compare -- NaN check
            if (octet !== octet) {
                result += decodedChar;
                i++;
                continue;
            }
            i += 2;
            var byteSequenceLength = getLeadingOnes(octet);
            if (byteSequenceLength === 0) decodedChar = fromCharCode(octet);
            else {
                if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                    result += FALLBACK_REPLACER;
                    i++;
                    continue;
                }
                var octets = [
                    octet
                ];
                var sequenceIndex = 1;
                while(sequenceIndex < byteSequenceLength){
                    i++;
                    if (i + 3 > length || charAt(input, i) !== '%') break;
                    var nextByte = parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (nextByte !== nextByte) {
                        i += 3;
                        break;
                    }
                    if (nextByte > 191 || nextByte < 128) break;
                    push(octets, nextByte);
                    i += 2;
                    sequenceIndex++;
                }
                if (octets.length !== byteSequenceLength) {
                    result += FALLBACK_REPLACER;
                    continue;
                }
                var codePoint = utf8Decode(octets);
                if (codePoint === null) result += FALLBACK_REPLACER;
                else decodedChar = fromCodePoint(codePoint);
            }
        }
        result += decodedChar;
        i++;
    }
    return result;
};
var find = /[!'()~]|%20/g;
var replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
};
var replacer = function replacer(match) {
    return replacements[match];
};
var serialize = function serialize(it) {
    return replace(encodeURIComponent(it), find, replacer);
};
var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
    setInternalState(this, {
        type: URL_SEARCH_PARAMS_ITERATOR,
        target: getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, URL_SEARCH_PARAMS, function next() {
    var state = getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return createIterResultObject(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case 'keys':
            return createIterResultObject(entry.key, false);
        case 'values':
            return createIterResultObject(entry.value, false);
    }
    return createIterResultObject([
        entry.key,
        entry.value
    ], false);
}, true);
var URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if (isObject(init)) this.parseObject(init);
        else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
    }
};
URLSearchParamsState.prototype = {
    type: URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
        this.url = url;
        this.update();
    },
    parseObject: function parseObject(object) {
        var entries = this.entries;
        var iteratorMethod = getIteratorMethod(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = getIterator(object, iteratorMethod);
            next = iterator.next;
            while(!(step = call(next, iterator)).done){
                entryIterator = getIterator(anObject(step.value));
                entryNext = entryIterator.next;
                if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done) throw new TypeError('Expected sequence with length 2');
                push(entries, {
                    key: $toString(first.value),
                    value: $toString(second.value)
                });
            }
        } else for(var key in object)if (hasOwn(object, key)) push(entries, {
            key: key,
            value: $toString(object[key])
        });
    },
    parseQuery: function parseQuery(query) {
        if (query) {
            var entries = this.entries;
            var attributes = split(query, '&');
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = split(attribute, '=');
                    push(entries, {
                        key: decode(shift(entry)),
                        value: decode(join(entry, '='))
                    });
                }
            }
        }
    },
    serialize: function serialize1() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            push(result, serialize(entry.key) + '=' + serialize(entry.value));
        }
        return join(result, '&');
    },
    update: function update() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams() {
    anInstance(this, URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = setInternalState(this, new URLSearchParamsState(init));
    if (!DESCRIPTORS) this.size = state.entries.length;
};
var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
defineBuiltIns(URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = getInternalParamsState(this);
        validateArgumentsLength(arguments.length, 2);
        push(state.entries, {
            key: $toString(name),
            value: $toString(value)
        });
        if (!DESCRIPTORS) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function(name /* , value */ ) {
        var state = getInternalParamsState(this);
        var length = validateArgumentsLength(arguments.length, 1);
        var entries = state.entries;
        var key = $toString(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $toString($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!DESCRIPTORS) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = getInternalParamsState(this).entries;
        validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = getInternalParamsState(this).entries;
        validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = getInternalParamsState(this).entries;
        var length = validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $toString($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = getInternalParamsState(this);
        validateArgumentsLength(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $toString(name);
        var val = $toString(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) push(entries, {
            key: key,
            value: val
        });
        if (!DESCRIPTORS) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = getInternalParamsState(this);
        arraySort(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = getInternalParamsState(this).entries;
        var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new URLSearchParamsIterator(this, 'entries');
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
    name: 'entries'
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
    return getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
        return getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
$({
    global: true,
    constructor: true,
    forced: !USE_NATIVE_URL
}, {
    URLSearchParams: URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
    var headersHas = uncurryThis(HeadersPrototype.has);
    var headersSet = uncurryThis(HeadersPrototype.set);
    var wrapRequestOptions = function wrapRequestOptions(init) {
        if (isObject(init)) {
            var body = init.body;
            var headers;
            if (classof(body) === URL_SEARCH_PARAMS) {
                headers = init.headers ? new Headers(init.headers) : new Headers();
                if (!headersHas(headers, 'content-type')) headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                return create(init, {
                    body: createPropertyDescriptor(0, $toString(body)),
                    headers: createPropertyDescriptor(0, headers)
                });
            }
        }
        return init;
    };
    if (isCallable(nativeFetch)) $({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        }
    });
    if (isCallable(NativeRequest)) {
        var RequestConstructor = function Request(input /* , init */ ) {
            anInstance(this, RequestPrototype);
            return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        };
        RequestPrototype.constructor = RequestConstructor;
        RequestConstructor.prototype = RequestPrototype;
        $({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: RequestConstructor
        });
    }
}
module.exports = {
    URLSearchParams: URLSearchParamsConstructor,
    getState: getInternalParamsState
};

},{"12e7a75121005a18":"6J6Pu","aed1dbd908154980":"3D8UA","2c283453b2df07f7":"gD2TP","f8300b17f61c07ea":"4naf8","c6afc8e42ff4d861":"lpzqk","c5226e6ac6c1a4ca":"iXpu0","c70bfc3d71513918":"ebTVd","a30c0c0ecacbf883":"jsw26","9dc980ea97e54f2d":"ihfdR","34e5e214071de9f5":"d3b1h","d5c866a8dfde6bfe":"jlXZ9","cfb67c7a1a4f1af9":"g2LDG","f0c2290e210049d5":"iYMvV","c7a2f88a5440a541":"3q5sA","fb2d9f4ac91c2856":"gNdyA","5e8fcf76ef17aca5":"4Dlpx","486653683495e4a1":"9RDjg","34563d35f35f9929":"37CJl","b866aa0bde936df4":"h2GWh","b5970b9126e1d395":"7xEW7","71cd06e9ca4a93a2":"7T1aN","7e16c364467ce62d":"2dEST","9a0912d2261bbada":"8iIJm","9d062cdf188403bf":"ffo0a","1caa2aad22025751":"5ZmqN","bf766970034bde82":"jtAW3","c6d4d2a85cdef35a":"cAVpj","6668155f748c33e9":"lf0Zm","982e5845e606dff7":"2q5E9","9a407fe1b80ba6f5":"jHJH4","778323e4214f089d":"6dJgl","83b87fb1800baf72":"6F6CU"}],"63Jin":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("bfa898e24eaaf3ba");
var call = require("f2e0e6e15a74c3f4");
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({
    target: 'URL',
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return call(URL.prototype.toString, this);
    }
});

},{"bfa898e24eaaf3ba":"gD2TP","f2e0e6e15a74c3f4":"ebTVd"}],"4r7ig":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("d31c1e63d588cf96");

},{"d31c1e63d588cf96":"a8ZGz"}],"1elNt":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"5mt7x"}],"5mt7x":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"hAlka","3fd2a064dc1f3641":"gVheC"}],"hAlka":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"gVheC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"hKabY"}],"hKabY":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function forEach(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function count(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"@swc/helpers/_/_type_of":"668P4","f790cf940e488cc5":"hAlka"}],"iYihS":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
var runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, _typeOf._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, _typeOf._)(globalThis)) === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{"@swc/helpers/_/_type_of":"668P4"}],"d8jlt":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"57rmM"}],"57rmM":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === (0, _typeOf._)(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== (0, _typeOf._)(b.style)) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function get() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function onError(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, _typeOf._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, _typeOf._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function persist() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function key(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var _$d = f, _$e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = _$d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, _$e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = _$d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = _$d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, _$e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(_$e) === _$d && (w = new w(u, t + "enter", x, c, _$e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = _$d ? ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, _$d))) {
                    ne(g, J, c, _$e);
                    break a;
                }
                K && K(a, h, _$d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = _$d ? ue(_$d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = _$d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, _$e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = _$e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(_$d, L), 0 < K.length && (L = new Ld(L, a, null, c, _$e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) _$d = oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, _typeOf._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function $f() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function O() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var _$c = b[a];
                    do _$c = _$c(!0);
                    while (null !== _$c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function b(a) {
                var _$b = d.refs;
                _$b === Fg && (_$b = d.refs = {});
                null === a ? delete _$b[e] : _$b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)) && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, _typeOf._)(d)) && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === (typeof f === "undefined" ? "undefined" : (0, _typeOf._)(f)) && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var _$a = f(b._source);
        if (!He(g, _$a)) {
            _$a = c(b._source);
            He(n, _$a) || (l(_$a), _$a = Ig(w), e.mutableReadLanes |= _$a & e.pendingLanes);
            _$a = e.mutableReadLanes;
            e.entangledLanes |= _$a;
            for(var _$d = e.entanglements, h = _$a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                _$d[k] |= _$a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var _$a = p.getSnapshot, _$c = p.setSnapshot;
            try {
                _$c(_$a(b._source));
                var _$d = Ig(w);
                e.mutableReadLanes |= _$d & e.pendingLanes;
            } catch (q) {
                _$c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function useCallback(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function useMutableSource(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function useState() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function useState() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function useTransition() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, _typeOf._)(l)) && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function Bi(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function Ci() {};
Di = function Di(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function Ei(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, _typeOf._)(k)) && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function ck(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a), ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = mk(g);
                h.call(_$a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function e() {
                var _$a = mk(g);
                k.call(_$a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function ec(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function fc(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function gc(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function hc(a, b) {
    return b();
};
yb = function yb(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function Hb(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function Ib() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function Jb(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"@swc/helpers/_/_type_of":"668P4","5393afc8c463ef07":"gVheC","dc13beaf0535b548":"hAlka","ece50e903283a22f":"fXTxA"}],"fXTxA":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"laXjn"}],"laXjn":[function(require,module,exports,__globalThis) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var f, g, h, k;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, _typeOf._)(performance)) && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function w1() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function g(a, b) {
        u = setTimeout(a, b);
    };
    h = function h() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function k() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function k() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function f(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function g(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function h() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === (typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{"@swc/helpers/_/_type_of":"668P4"}],"99v96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createLocation", function() {
    return createLocation;
});
parcelHelpers.export(exports, "locationsAreEqual", function() {
    return locationsAreEqual;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","resolve-pathname":"fshVp","value-equal":"aTBfb","tiny-warning":"b8oEm","tiny-invariant":"01Hp1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4f7v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fshVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aTBfb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === 'object' || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b8oEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"01Hp1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return invariant;
});
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"acq4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _reactRouter.MemoryRouter;
});
parcelHelpers.export(exports, "Prompt", function() {
    return 0, _reactRouter.Prompt;
});
parcelHelpers.export(exports, "Redirect", function() {
    return 0, _reactRouter.Redirect;
});
parcelHelpers.export(exports, "Route", function() {
    return 0, _reactRouter.Route;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _reactRouter.Router;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return 0, _reactRouter.StaticRouter;
});
parcelHelpers.export(exports, "Switch", function() {
    return 0, _reactRouter.Switch;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _reactRouter.generatePath;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _reactRouter.matchPath;
});
parcelHelpers.export(exports, "useHistory", function() {
    return 0, _reactRouter.useHistory;
});
parcelHelpers.export(exports, "useLocation", function() {
    return 0, _reactRouter.useLocation;
});
parcelHelpers.export(exports, "useParams", function() {
    return 0, _reactRouter.useParams;
});
parcelHelpers.export(exports, "useRouteMatch", function() {
    return 0, _reactRouter.useRouteMatch;
});
parcelHelpers.export(exports, "withRouter", function() {
    return 0, _reactRouter.withRouter;
});
parcelHelpers.export(exports, "BrowserRouter", function() {
    return BrowserRouter;
});
parcelHelpers.export(exports, "HashRouter", function() {
    return HashRouter;
});
parcelHelpers.export(exports, "Link", function() {
    return Link;
});
parcelHelpers.export(exports, "NavLink", function() {
    return NavLink;
});
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"3x1LR","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","history":"99v96","prop-types":"3KNJy","tiny-warning":"b8oEm","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","tiny-invariant":"01Hp1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3x1LR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
parcelHelpers.export(exports, "Prompt", function() {
    return Prompt;
});
parcelHelpers.export(exports, "Redirect", function() {
    return Redirect;
});
parcelHelpers.export(exports, "Route", function() {
    return Route;
});
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return StaticRouter;
});
parcelHelpers.export(exports, "Switch", function() {
    return Switch;
});
parcelHelpers.export(exports, "__HistoryContext", function() {
    return historyContext;
});
parcelHelpers.export(exports, "__RouterContext", function() {
    return context;
});
parcelHelpers.export(exports, "generatePath", function() {
    return generatePath;
});
parcelHelpers.export(exports, "matchPath", function() {
    return matchPath;
});
parcelHelpers.export(exports, "useHistory", function() {
    return useHistory;
});
parcelHelpers.export(exports, "useLocation", function() {
    return useLocation;
});
parcelHelpers.export(exports, "useParams", function() {
    return useParams;
});
parcelHelpers.export(exports, "useRouteMatch", function() {
    return useRouteMatch;
});
parcelHelpers.export(exports, "withRouter", function() {
    return withRouter;
});
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","history":"99v96","tiny-warning":"b8oEm","tiny-invariant":"01Hp1","@babel/runtime/helpers/esm/extends":"d4f7v","path-to-regexp":"acDtt","react-is":"aFYMr","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6hLbZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inheritsLoose;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"hyVPU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hyVPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _setPrototypeOf;
});
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KNJy":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"lOspF"}],"lOspF":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6Gm2l"}],"6Gm2l":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"acDtt":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if ((0, _typeOf._)(tokens[i]) === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"@swc/helpers/_/_type_of":"668P4","828472a1e168de2b":"9gjbG"}],"9gjbG":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"aFYMr":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e96cece4daa9961");

},{"3e96cece4daa9961":"hT5Eg"}],"hT5Eg":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{"@swc/helpers/_/_type_of":"668P4"}],"8FYSI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d2C2V":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"jLNEy"}],"jLNEy":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"dtOPO"}],"dtOPO":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{"@swc/helpers/_/_type_of":"668P4"}],"75VoS":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", function() {
    return 0, _core.Amplify;
});
parcelHelpers.export(exports, "Analytics", function() {
    return 0, _analytics.Analytics;
});
parcelHelpers.export(exports, "AWSPinpointProvider", function() {
    return 0, _analytics.AWSPinpointProvider;
});
parcelHelpers.export(exports, "AWSKinesisProvider", function() {
    return 0, _analytics.AWSKinesisProvider;
});
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", function() {
    return 0, _analytics.AWSKinesisFirehoseProvider;
});
parcelHelpers.export(exports, "AmazonPersonalizeProvider", function() {
    return 0, _analytics.AmazonPersonalizeProvider;
});
parcelHelpers.export(exports, "Auth", function() {
    return 0, _auth.Auth;
});
parcelHelpers.export(exports, "Storage", function() {
    return 0, _storage.Storage;
});
parcelHelpers.export(exports, "StorageClass", function() {
    return 0, _storage.StorageClass;
});
parcelHelpers.export(exports, "API", function() {
    return 0, _api.API;
});
parcelHelpers.export(exports, "APIClass", function() {
    return 0, _api.APIClass;
});
parcelHelpers.export(exports, "graphqlOperation", function() {
    return 0, _api.graphqlOperation;
});
parcelHelpers.export(exports, "AuthModeStrategyType", function() {
    return 0, _datastore.AuthModeStrategyType;
});
parcelHelpers.export(exports, "DataStore", function() {
    return 0, _datastore.DataStore;
});
parcelHelpers.export(exports, "Predicates", function() {
    return 0, _datastore.Predicates;
});
parcelHelpers.export(exports, "SortDirection", function() {
    return 0, _datastore.SortDirection;
});
parcelHelpers.export(exports, "syncExpression", function() {
    return 0, _datastore.syncExpression;
});
parcelHelpers.export(exports, "PubSub", function() {
    return 0, _pubsub.PubSub;
});
parcelHelpers.export(exports, "Cache", function() {
    return 0, _cache.Cache;
});
parcelHelpers.export(exports, "Interactions", function() {
    return 0, _interactions.Interactions;
});
parcelHelpers.export(exports, "Notifications", function() {
    return 0, _notifications.Notifications;
});
parcelHelpers.export(exports, "Predictions", function() {
    return 0, _predictions.Predictions;
});
parcelHelpers.export(exports, "Logger", function() {
    return 0, _core.ConsoleLogger;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _core.Hub;
});
parcelHelpers.export(exports, "ClientDevice", function() {
    return 0, _core.ClientDevice;
});
parcelHelpers.export(exports, "Signer", function() {
    return 0, _core.Signer;
});
parcelHelpers.export(exports, "I18n", function() {
    return 0, _core.I18n;
});
parcelHelpers.export(exports, "ServiceWorker", function() {
    return 0, _core.ServiceWorker;
});
parcelHelpers.export(exports, "AWSCloudWatchProvider", function() {
    return 0, _core.AWSCloudWatchProvider;
});
parcelHelpers.export(exports, "withSSRContext", function() {
    return 0, _withSSRContext.withSSRContext;
});
parcelHelpers.export(exports, "Geo", function() {
    return 0, _geo.Geo;
});
var _core = require("@aws-amplify/core");
var _analytics = require("@aws-amplify/analytics");
var _auth = require("@aws-amplify/auth");
var _storage = require("@aws-amplify/storage");
var _api = require("@aws-amplify/api");
var _datastore = require("@aws-amplify/datastore");
var _pubsub = require("@aws-amplify/pubsub");
var _cache = require("@aws-amplify/cache");
var _interactions = require("@aws-amplify/interactions");
var _notifications = require("@aws-amplify/notifications");
var _predictions = require("@aws-amplify/predictions");
var _withSSRContext = require("./withSSRContext");
var _geo = require("@aws-amplify/geo");

},{"@aws-amplify/core":"3rlh1","@aws-amplify/analytics":"4FqWo","@aws-amplify/auth":"ilv20","@aws-amplify/storage":"dt8H8","@aws-amplify/api":"6PDaW","@aws-amplify/datastore":"fPd7W","@aws-amplify/pubsub":"bJVAp","@aws-amplify/cache":"hVdVQ","@aws-amplify/interactions":"lH2Zb","@aws-amplify/notifications":"29fbL","@aws-amplify/predictions":"lJ5pk","./withSSRContext":"dqyLX","@aws-amplify/geo":"3VEgf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rlh1":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", function() {
    return 0, _amplify.Amplify;
});
parcelHelpers.export(exports, "AmplifyClass", function() {
    return 0, _amplify.AmplifyClass;
});
parcelHelpers.export(exports, "ClientDevice", function() {
    return 0, _clientDevice.ClientDevice;
});
parcelHelpers.export(exports, "ConsoleLogger", function() {
    return 0, _logger.ConsoleLogger;
});
parcelHelpers.export(exports, "Logger", function() {
    return 0, _logger.ConsoleLogger;
});
parcelHelpers.export(exports, "invalidParameter", function() {
    return 0, _errors.invalidParameter;
});
parcelHelpers.export(exports, "missingConfig", function() {
    return 0, _errors.missingConfig;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _hub.Hub;
});
parcelHelpers.export(exports, "I18n", function() {
    return 0, _i18N.I18n;
});
parcelHelpers.export(exports, "browserOrNode", function() {
    return 0, _js.browserOrNode;
});
parcelHelpers.export(exports, "filenameToContentType", function() {
    return 0, _js.filenameToContentType;
});
parcelHelpers.export(exports, "generateRandomString", function() {
    return 0, _js.generateRandomString;
});
parcelHelpers.export(exports, "isEmpty", function() {
    return 0, _js.isEmpty;
});
parcelHelpers.export(exports, "isStrictObject", function() {
    return 0, _js.isStrictObject;
});
parcelHelpers.export(exports, "isTextFile", function() {
    return 0, _js.isTextFile;
});
parcelHelpers.export(exports, "isWebWorker", function() {
    return 0, _js.isWebWorker;
});
parcelHelpers.export(exports, "makeQuerablePromise", function() {
    return 0, _js.makeQuerablePromise;
});
parcelHelpers.export(exports, "objectLessAttributes", function() {
    return 0, _js.objectLessAttributes;
});
parcelHelpers.export(exports, "sortByField", function() {
    return 0, _js.sortByField;
});
parcelHelpers.export(exports, "transferKeyToLowerCase", function() {
    return 0, _js.transferKeyToLowerCase;
});
parcelHelpers.export(exports, "transferKeyToUpperCase", function() {
    return 0, _js.transferKeyToUpperCase;
});
parcelHelpers.export(exports, "Signer", function() {
    return 0, _signer.Signer;
});
parcelHelpers.export(exports, "parseAWSExports", function() {
    return 0, _parseAWSExports.parseAWSExports;
});
parcelHelpers.export(exports, "AWSCloudWatchProvider", function() {
    return 0, _providers.AWSCloudWatchProvider;
});
parcelHelpers.export(exports, "FacebookOAuth", function() {
    return 0, _oauthHelper.FacebookOAuth;
});
parcelHelpers.export(exports, "GoogleOAuth", function() {
    return 0, _oauthHelper.GoogleOAuth;
});
parcelHelpers.export(exports, "AppState", function() {
    return 0, _rncomponents.AppState;
});
parcelHelpers.export(exports, "AsyncStorage", function() {
    return 0, _rncomponents.AsyncStorage;
});
parcelHelpers.export(exports, "Linking", function() {
    return 0, _rncomponents.Linking;
});
parcelHelpers.export(exports, "Credentials", function() {
    return 0, _credentials.Credentials;
});
parcelHelpers.export(exports, "CredentialsClass", function() {
    return 0, _credentials.CredentialsClass;
});
parcelHelpers.export(exports, "ServiceWorker", function() {
    return 0, _serviceWorker.ServiceWorker;
});
parcelHelpers.export(exports, "StorageHelper", function() {
    return 0, _storageHelper.StorageHelper;
});
parcelHelpers.export(exports, "MemoryStorage", function() {
    return 0, _storageHelper.MemoryStorage;
});
parcelHelpers.export(exports, "UniversalStorage", function() {
    return 0, _universalStorage.UniversalStorage;
});
parcelHelpers.export(exports, "Platform", function() {
    return 0, _platform.Platform;
});
parcelHelpers.export(exports, "getAmplifyUserAgentObject", function() {
    return 0, _platform.getAmplifyUserAgentObject;
});
parcelHelpers.export(exports, "getAmplifyUserAgent", function() {
    return 0, _platform.getAmplifyUserAgent;
});
parcelHelpers.export(exports, "ApiAction", function() {
    return 0, _types.ApiAction;
});
parcelHelpers.export(exports, "AuthAction", function() {
    return 0, _types.AuthAction;
});
parcelHelpers.export(exports, "AnalyticsAction", function() {
    return 0, _types.AnalyticsAction;
});
parcelHelpers.export(exports, "Category", function() {
    return 0, _types.Category;
});
parcelHelpers.export(exports, "DataStoreAction", function() {
    return 0, _types.DataStoreAction;
});
parcelHelpers.export(exports, "Framework", function() {
    return 0, _types.Framework;
});
parcelHelpers.export(exports, "GeoAction", function() {
    return 0, _types.GeoAction;
});
parcelHelpers.export(exports, "InteractionsAction", function() {
    return 0, _types.InteractionsAction;
});
parcelHelpers.export(exports, "InAppMessagingAction", function() {
    return 0, _types.InAppMessagingAction;
});
parcelHelpers.export(exports, "PredictionsAction", function() {
    return 0, _types.PredictionsAction;
});
parcelHelpers.export(exports, "PubSubAction", function() {
    return 0, _types.PubSubAction;
});
parcelHelpers.export(exports, "PushNotificationAction", function() {
    return 0, _types.PushNotificationAction;
});
parcelHelpers.export(exports, "StorageAction", function() {
    return 0, _types.StorageAction;
});
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function() {
    return 0, _constants.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER;
});
parcelHelpers.export(exports, "USER_AGENT_HEADER", function() {
    return 0, _constants.USER_AGENT_HEADER;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", function() {
    return 0, _util.AWS_CLOUDWATCH_BASE_BUFFER_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", function() {
    return 0, _util.AWS_CLOUDWATCH_CATEGORY;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", function() {
    return 0, _util.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", function() {
    return 0, _util.AWS_CLOUDWATCH_MAX_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", function() {
    return 0, _util.AWS_CLOUDWATCH_PROVIDER_NAME;
});
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", function() {
    return 0, _util.BackgroundManagerNotOpenError;
});
parcelHelpers.export(exports, "BackgroundProcessManager", function() {
    return 0, _util.BackgroundProcessManager;
});
parcelHelpers.export(exports, "BackgroundProcessManagerState", function() {
    return 0, _util.BackgroundProcessManagerState;
});
parcelHelpers.export(exports, "DateUtils", function() {
    return 0, _util.DateUtils;
});
parcelHelpers.export(exports, "Mutex", function() {
    return 0, _util.Mutex;
});
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", function() {
    return 0, _util.NO_CREDS_ERROR_STRING;
});
parcelHelpers.export(exports, "NonRetryableError", function() {
    return 0, _util.NonRetryableError;
});
parcelHelpers.export(exports, "RETRY_ERROR_CODES", function() {
    return 0, _util.RETRY_ERROR_CODES;
});
parcelHelpers.export(exports, "Reachability", function() {
    return 0, _util.Reachability;
});
parcelHelpers.export(exports, "isNonRetryableError", function() {
    return 0, _util.isNonRetryableError;
});
parcelHelpers.export(exports, "jitteredBackoff", function() {
    return 0, _util.jitteredBackoff;
});
parcelHelpers.export(exports, "jitteredExponentialRetry", function() {
    return 0, _util.jitteredExponentialRetry;
});
parcelHelpers.export(exports, "retry", function() {
    return 0, _util.retry;
});
parcelHelpers.export(exports, "urlSafeDecode", function() {
    return 0, _util.urlSafeDecode;
});
parcelHelpers.export(exports, "urlSafeEncode", function() {
    return 0, _util.urlSafeEncode;
});
parcelHelpers.export(exports, "Constants", function() {
    return Constants;
});
var _amplify = require("./Amplify");
var _platform = require("./Platform");
var _clientDevice = require("./ClientDevice");
var _logger = require("./Logger");
var _errors = require("./Errors");
var _hub = require("./Hub");
var _i18N = require("./I18n");
var _js = require("./JS");
var _signer = require("./Signer");
var _parseAWSExports = require("./parseAWSExports");
var _providers = require("./Providers");
var _oauthHelper = require("./OAuthHelper");
var _rncomponents = require("./RNComponents");
var _credentials = require("./Credentials");
var _serviceWorker = require("./ServiceWorker");
var _storageHelper = require("./StorageHelper");
var _universalStorage = require("./UniversalStorage");
var _types = require("./Platform/types");
var _constants = require("./constants");
var _util = require("./Util");
var Constants = {
    userAgent: (0, _platform.Platform).userAgent
};
/**
 * @deprecated use named import
 */ exports.default = (0, _amplify.Amplify);

},{"./Amplify":"fr4N4","./Platform":"jNyBX","./ClientDevice":"580p9","./Logger":"jVGZ5","./Errors":false,"./Hub":"5RtWX","./I18n":"hwXvC","./JS":"58R8D","./Signer":"byego","./parseAWSExports":"jNxFP","./Providers":"aPXfS","./OAuthHelper":false,"./RNComponents":false,"./Credentials":"knFIj","./ServiceWorker":"kspiO","./StorageHelper":"5ekFt","./UniversalStorage":"8JhHm","./Platform/types":"jomcL","./constants":"jxe0I","./Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fr4N4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyClass", function() {
    return AmplifyClass;
});
parcelHelpers.export(exports, "Amplify", function() {
    return Amplify;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _logger.ConsoleLogger)('Amplify');
var AmplifyClass = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, _logger.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else logger.debug('no getModuleName method for component', comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = __read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable['getCategory'] && typeof pluggable['getCategory'] === 'function') this._components.map(function(comp) {
            if (comp['addPluggable'] && typeof comp['addPluggable'] === 'function') comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var Amplify = new AmplifyClass();

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jVGZ5":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsoleLogger", function() {
    return 0, _consoleLogger.ConsoleLogger;
});
parcelHelpers.export(exports, "LOG_TYPE", function() {
    return 0, _consoleLogger.LOG_TYPE;
});
var _consoleLogger = require("./ConsoleLogger");

},{"./ConsoleLogger":"dY8EL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dY8EL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_TYPE", function() {
    return LOG_TYPE;
});
parcelHelpers.export(exports, "ConsoleLogger", function() {
    return ConsoleLogger;
});
var _constants = require("../Util/Constants");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var LOG_TYPE;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})(LOG_TYPE || (LOG_TYPE = {}));
var ConsoleLogger = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = LOG_TYPE.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(':') + '.' + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== 'undefined' && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = LOG_LEVELS[logger_level_name];
        var type_level = LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === LOG_TYPE.ERROR && console.error) log = console.error.bind(console);
        if (type === LOG_TYPE.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = '';
        if (msg.length === 1 && typeof msg[0] === 'string') {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = __values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.WARN
        ], __read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.ERROR
        ], __read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.DEBUG
        ], __read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.VERBOSE
        ], __read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, _constants.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

},{"../Util/Constants":"4siXq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4siXq":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", function() {
    return AWS_CLOUDWATCH_BASE_BUFFER_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", function() {
    return AWS_CLOUDWATCH_CATEGORY;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", function() {
    return AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", function() {
    return AWS_CLOUDWATCH_MAX_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", function() {
    return AWS_CLOUDWATCH_PROVIDER_NAME;
});
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", function() {
    return NO_CREDS_ERROR_STRING;
});
parcelHelpers.export(exports, "RETRY_ERROR_CODES", function() {
    return RETRY_ERROR_CODES;
});
var AWS_CLOUDWATCH_BASE_BUFFER_SIZE = 26;
var AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE = 1048576;
var AWS_CLOUDWATCH_MAX_EVENT_SIZE = 256000;
var AWS_CLOUDWATCH_CATEGORY = 'Logging';
var AWS_CLOUDWATCH_PROVIDER_NAME = 'AWSCloudWatch';
var NO_CREDS_ERROR_STRING = 'No credentials';
var RETRY_ERROR_CODES = [
    'ResourceNotFoundException',
    'InvalidSequenceTokenException'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNyBX":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", function() {
    return Platform;
});
parcelHelpers.export(exports, "getAmplifyUserAgentObject", function() {
    return getAmplifyUserAgentObject;
});
parcelHelpers.export(exports, "getAmplifyUserAgent", function() {
    return getAmplifyUserAgent;
});
var _types = require("./types");
var _version = require("./version");
var _detectFramework = require("./detectFramework");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var BASE_USER_AGENT = "aws-amplify";
var PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat(BASE_USER_AGENT, "/").concat((0, _version.version));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function get() {
            return (0, _detectFramework.detectFramework)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function get() {
            return this.framework === (0, _types.Framework).ReactNative || this.framework === (0, _types.Framework).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, _detectFramework.observeFrameworkChanges)(fcn);
    };
    return PlatformBuilder;
}();
var Platform = new PlatformBuilder();
var getAmplifyUserAgentObject = function getAmplifyUserAgentObject(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework;
    var userAgent = [
        [
            BASE_USER_AGENT,
            (0, _version.version)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        'framework',
        (0, _detectFramework.detectFramework)()
    ]);
    return userAgent;
};
var getAmplifyUserAgent = function getAmplifyUserAgent(customUserAgentDetails) {
    var userAgent = getAmplifyUserAgentObject(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = __read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(' ');
    return userAgentString;
};

},{"./types":"jomcL","./version":"fBLLc","./detectFramework":"kTkOK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jomcL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Framework", function() {
    return Framework;
});
parcelHelpers.export(exports, "Category", function() {
    return Category;
});
parcelHelpers.export(exports, "AnalyticsAction", function() {
    return AnalyticsAction;
});
parcelHelpers.export(exports, "ApiAction", function() {
    return ApiAction;
});
parcelHelpers.export(exports, "AuthAction", function() {
    return AuthAction;
});
parcelHelpers.export(exports, "DataStoreAction", function() {
    return DataStoreAction;
});
parcelHelpers.export(exports, "GeoAction", function() {
    return GeoAction;
});
parcelHelpers.export(exports, "InAppMessagingAction", function() {
    return InAppMessagingAction;
});
parcelHelpers.export(exports, "InteractionsAction", function() {
    return InteractionsAction;
});
parcelHelpers.export(exports, "PredictionsAction", function() {
    return PredictionsAction;
});
parcelHelpers.export(exports, "PubSubAction", function() {
    return PubSubAction;
});
parcelHelpers.export(exports, "PushNotificationAction", function() {
    return PushNotificationAction;
});
parcelHelpers.export(exports, "StorageAction", function() {
    return StorageAction;
});
var Framework;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})(Framework || (Framework = {}));
var Category;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})(Category || (Category = {}));
var AnalyticsAction;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})(AnalyticsAction || (AnalyticsAction = {}));
var ApiAction;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})(ApiAction || (ApiAction = {}));
var AuthAction;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})(AuthAction || (AuthAction = {}));
var DataStoreAction;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})(DataStoreAction || (DataStoreAction = {}));
var GeoAction;
(function(GeoAction) {
    GeoAction["None"] = "0";
})(GeoAction || (GeoAction = {}));
var InAppMessagingAction;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
})(InAppMessagingAction || (InAppMessagingAction = {}));
var InteractionsAction;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})(InteractionsAction || (InteractionsAction = {}));
var PredictionsAction;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})(PredictionsAction || (PredictionsAction = {}));
var PubSubAction;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})(PubSubAction || (PubSubAction = {}));
var PushNotificationAction;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})(PushNotificationAction || (PushNotificationAction = {}));
var StorageAction;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
})(StorageAction || (StorageAction = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBLLc":[function(require,module,exports,__globalThis) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return version;
});
var version = '5.3.26';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kTkOK":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameworkChangeObservers", function() {
    return frameworkChangeObservers;
});
parcelHelpers.export(exports, "detectFramework", function() {
    return detectFramework;
});
parcelHelpers.export(exports, "observeFrameworkChanges", function() {
    return observeFrameworkChanges;
});
parcelHelpers.export(exports, "clearCache", function() {
    return clearCache;
});
var _types = require("./types");
var _detection = require("./detection");
// We want to cache detection since the framework won't change
var frameworkCache;
var frameworkChangeObservers = [];
// Setup the detection reset tracking / timeout delays
var resetTriggered = false;
var SSR_RESET_TIMEOUT = 10; // ms
var WEB_RESET_TIMEOUT = 10; // ms
var PRIME_FRAMEWORK_DELAY = 1000; // ms
var detectFramework = function detectFramework() {
    if (!frameworkCache) {
        frameworkCache = (0, _detection.detect)();
        if (resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while(frameworkChangeObservers.length)frameworkChangeObservers.pop()();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        frameworkChangeObservers.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        resetTimeout((0, _types.Framework).ServerSideUnknown, SSR_RESET_TIMEOUT);
        resetTimeout((0, _types.Framework).WebUnknown, WEB_RESET_TIMEOUT);
    }
    return frameworkCache;
};
var observeFrameworkChanges = function observeFrameworkChanges(fcn) {
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if (resetTriggered) return;
    frameworkChangeObservers.push(fcn);
};
function clearCache() {
    frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function resetTimeout(framework, delay) {
    if (frameworkCache === framework && !resetTriggered) setTimeout(function() {
        clearCache();
        resetTriggered = true;
        setTimeout(detectFramework, PRIME_FRAMEWORK_DELAY);
    }, delay);
}

},{"./types":"jomcL","./detection":"hf2EC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hf2EC":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detect", function() {
    return detect;
});
var _types = require("../types");
var _react = require("./React");
var _vue = require("./Vue");
var _svelte = require("./Svelte");
var _next = require("./Next");
var _nuxt = require("./Nuxt");
var _angular = require("./Angular");
var _reactNative = require("./ReactNative");
var _expo = require("./Expo");
var _web = require("./Web");
// These are in the order of detection where when both are detectable, the early Framework will be reported
var detectionMap = [
    // First, detect mobile
    {
        platform: (0, _types.Framework).Expo,
        detectionMethod: (0, _expo.expoDetect)
    },
    {
        platform: (0, _types.Framework).ReactNative,
        detectionMethod: (0, _reactNative.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, _types.Framework).NextJs,
        detectionMethod: (0, _next.nextWebDetect)
    },
    {
        platform: (0, _types.Framework).Nuxt,
        detectionMethod: (0, _nuxt.nuxtWebDetect)
    },
    {
        platform: (0, _types.Framework).Angular,
        detectionMethod: (0, _angular.angularWebDetect)
    },
    {
        platform: (0, _types.Framework).React,
        detectionMethod: (0, _react.reactWebDetect)
    },
    {
        platform: (0, _types.Framework).VueJs,
        detectionMethod: (0, _vue.vueWebDetect)
    },
    {
        platform: (0, _types.Framework).Svelte,
        detectionMethod: (0, _svelte.svelteWebDetect)
    },
    {
        platform: (0, _types.Framework).WebUnknown,
        detectionMethod: (0, _web.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, _types.Framework).NextJsSSR,
        detectionMethod: (0, _next.nextSSRDetect)
    },
    {
        platform: (0, _types.Framework).NuxtSSR,
        detectionMethod: (0, _nuxt.nuxtSSRDetect)
    },
    {
        platform: (0, _types.Framework).ReactSSR,
        detectionMethod: (0, _react.reactSSRDetect)
    },
    {
        platform: (0, _types.Framework).VueJsSSR,
        detectionMethod: (0, _vue.vueSSRDetect)
    },
    {
        platform: (0, _types.Framework).AngularSSR,
        detectionMethod: (0, _angular.angularSSRDetect)
    },
    {
        platform: (0, _types.Framework).SvelteSSR,
        detectionMethod: (0, _svelte.svelteSSRDetect)
    }
];
function detect() {
    var _a;
    return ((_a = detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, _types.Framework).ServerSideUnknown;
}

},{"../types":"jomcL","./React":"hbF7t","./Vue":"19gI0","./Svelte":"jCyCb","./Next":"5T7ZV","./Nuxt":"gzCwO","./Angular":"c7uZn","./ReactNative":"h4UrI","./Expo":"bXX26","./Web":"9Tuu9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hbF7t":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with react 18.2 - built using Vite
parcelHelpers.export(exports, "reactWebDetect", function() {
    return reactWebDetect;
});
parcelHelpers.export(exports, "reactSSRDetect", function() {
    return reactSSRDetect;
});
var _helpers = require("./helpers");
var process = require("76821670e4d57432");
function reactWebDetect() {
    var elementKeyPrefixedWithReact = function elementKeyPrefixedWithReact(key) {
        return key.startsWith('_react') || key.startsWith('__react');
    };
    var elementIsReactEnabled = function elementIsReactEnabled(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function allElementsWithId() {
        return Array.from(document.querySelectorAll('[id]'));
    };
    return (0, _helpers.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function reactSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== 'undefined' && !!Object.keys(process.env).find(function(key) {
        return key.includes('react');
    });
}

},{"76821670e4d57432":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4avz9":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"7lyme":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalExists", function() {
    return globalExists;
});
parcelHelpers.export(exports, "globalThisExists", function() {
    return globalThisExists;
});
parcelHelpers.export(exports, "windowExists", function() {
    return windowExists;
});
parcelHelpers.export(exports, "documentExists", function() {
    return documentExists;
});
parcelHelpers.export(exports, "processExists", function() {
    return processExists;
});
parcelHelpers.export(exports, "keyPrefixMatch", function() {
    return keyPrefixMatch;
});
var global = arguments[3];
var process = require("c86167827cfb2a42");
var globalExists = function globalExists() {
    return typeof global !== 'undefined';
};
var globalThisExists = function globalThisExists() {
    return typeof globalThis !== 'undefined';
};
var windowExists = function windowExists() {
    return typeof window !== 'undefined';
};
var documentExists = function documentExists() {
    return typeof document !== 'undefined';
};
var processExists = function processExists() {
    return typeof process !== 'undefined';
};
var keyPrefixMatch = function keyPrefixMatch(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};

},{"c86167827cfb2a42":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"19gI0":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with vue 3.3.2
parcelHelpers.export(exports, "vueWebDetect", function() {
    return vueWebDetect;
});
parcelHelpers.export(exports, "vueSSRDetect", function() {
    return vueSSRDetect;
});
var _helpers = require("./helpers");
var global = arguments[3];
function vueWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, '__VUE');
}
function vueSSRDetect() {
    return (0, _helpers.globalExists)() && (0, _helpers.keyPrefixMatch)(global, '__VUE');
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jCyCb":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with svelte 3.59
parcelHelpers.export(exports, "svelteWebDetect", function() {
    return svelteWebDetect;
});
parcelHelpers.export(exports, "svelteSSRDetect", function() {
    return svelteSSRDetect;
});
var _helpers = require("./helpers");
var process = require("138f303fa47701cc");
function svelteWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, '__SVELTE');
}
function svelteSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== 'undefined' && !!Object.keys(process.env).find(function(key) {
        return key.includes('svelte');
    });
}

},{"138f303fa47701cc":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5T7ZV":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with next 13.4 / react 18.2
parcelHelpers.export(exports, "nextWebDetect", function() {
    return nextWebDetect;
});
parcelHelpers.export(exports, "nextSSRDetect", function() {
    return nextSSRDetect;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _helpers = require("./helpers");
var global = arguments[3];
function nextWebDetect() {
    // @ts-ignore
    return (0, _helpers.windowExists)() && window['next'] && (0, _typeOf._)(window['next']) === 'object';
}
function nextSSRDetect() {
    return (0, _helpers.globalExists)() && ((0, _helpers.keyPrefixMatch)(global, '__next') || (0, _helpers.keyPrefixMatch)(global, '__NEXT'));
}

},{"@swc/helpers/_/_type_of":"668P4","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gzCwO":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with nuxt 2.15 / vue 2.7
parcelHelpers.export(exports, "nuxtWebDetect", function() {
    return nuxtWebDetect;
});
parcelHelpers.export(exports, "nuxtSSRDetect", function() {
    return nuxtSSRDetect;
});
var _helpers = require("./helpers");
var global = arguments[3];
function nuxtWebDetect() {
    return (0, _helpers.windowExists)() && // @ts-ignore
    (window['__NUXT__'] !== undefined || window['$nuxt'] !== undefined);
}
function nuxtSSRDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global['__NUXT_PATHS__'] !== 'undefined';
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c7uZn":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with @angular/core 16.0.0
parcelHelpers.export(exports, "angularWebDetect", function() {
    return angularWebDetect;
});
parcelHelpers.export(exports, "angularSSRDetect", function() {
    return angularSSRDetect;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _helpers = require("./helpers");
var process = require("6c589ba30cc3d7d");
function angularWebDetect() {
    var angularVersionSetInDocument = Boolean((0, _helpers.documentExists)() && document.querySelector('[ng-version]'));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, _helpers.windowExists)() && typeof window['ng'] !== 'undefined');
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function angularSSRDetect() {
    var _a;
    return (0, _helpers.processExists)() && (0, _typeOf._)(process.env) === 'object' && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith('ng ')) || false;
}

},{"@swc/helpers/_/_type_of":"668P4","6c589ba30cc3d7d":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h4UrI":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactNativeDetect", function() {
    return reactNativeDetect;
});
function reactNativeDetect() {
    return typeof navigator !== 'undefined' && typeof navigator.product !== 'undefined' && navigator.product === 'ReactNative';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bXX26":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with expo 48 / react-native 0.71.3
parcelHelpers.export(exports, "expoDetect", function() {
    return expoDetect;
});
var _helpers = require("./helpers");
var global = arguments[3];
function expoDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global['expo'] !== 'undefined';
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Tuu9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webDetect", function() {
    return webDetect;
});
var _helpers = require("./helpers");
function webDetect() {
    return (0, _helpers.windowExists)();
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"580p9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDevice", function() {
    return ClientDevice;
});
var _browser = require("./browser");
var ClientDevice = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, _browser.clientInfo)();
    };
    ClientDevice.dimension = function() {
        return (0, _browser.dimension)();
    };
    return ClientDevice;
}();

},{"./browser":"83cuF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"83cuF":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clientInfo", function() {
    return clientInfo;
});
parcelHelpers.export(exports, "dimension", function() {
    return dimension;
});
parcelHelpers.export(exports, "browserType", function() {
    return browserType;
});
var _logger = require("../Logger");
var logger = new (0, _logger.ConsoleLogger)('ClientDevice_Browser');
function clientInfo() {
    if (typeof window === 'undefined') return {};
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = browserType(userAgent);
    var timezone = browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join('/'),
        language: language,
        timezone: timezone
    };
}
function dimension() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: '',
        version: ''
    };
}

},{"../Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RtWX":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HubClass", function() {
    return HubClass;
});
parcelHelpers.export(exports, "Hub", function() {
    return Hub;
});
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)('Hub');
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
function isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var HubClass = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'ui',
            'xr'
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = __spreadArray([], __read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = __spreadArray([], __read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = '';
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: __assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = 'noname';
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if (isLegacyCallback(callback)) {
            logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== 'function') throw new Error('No callback supplied to Hub');
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = __read(match), groups = _a.slice(1);
                    var dispatchingCapsule = __assign(__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var Hub = new HubClass('__default__');

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwXvC":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", function() {
    return I18n;
});
var _i18N = require("./I18n");
var _logger = require("../Logger");
var _amplify = require("../Amplify");
var logger = new (0, _logger.ConsoleLogger)('I18n');
var _config = null;
var _i18n = null;
/**
 * Export I18n APIs
 */ var I18n = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        logger.debug('configure I18n');
        if (!config) return _config;
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    };
    I18n.getModuleName = function() {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        logger.debug('create I18n instance');
        if (_i18n) return;
        _i18n = new (0, _i18N.I18n)(_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return _i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === 'undefined' ? key : defVal;
        return _i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!_i18n) _i18n = new (0, _i18N.I18n)(_config);
        return true;
    };
    return I18n;
}();
(0, _amplify.Amplify).register(I18n);

},{"./I18n":"kEkfq","../Logger":"jVGZ5","../Amplify":"fr4N4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kEkfq":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", function() {
    return I18n;
});
var _logger = require("../Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)('I18n');
/**
 * Language transition class
 */ var I18n = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== 'undefined' && window && window.navigator) this._lang = window.navigator.language;
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== 'undefined' ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf('-') > 0) val = this.getByLanguage(key, lang.split('-')[0]);
        if (val) return val;
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = __assign(__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

},{"../Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"58R8D":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", function() {
    return isEmpty;
});
parcelHelpers.export(exports, "sortByField", function() {
    return sortByField;
});
parcelHelpers.export(exports, "objectLessAttributes", function() {
    return objectLessAttributes;
});
parcelHelpers.export(exports, "filenameToContentType", function() {
    return filenameToContentType;
});
parcelHelpers.export(exports, "isTextFile", function() {
    return isTextFile;
});
parcelHelpers.export(exports, "generateRandomString", function() {
    return generateRandomString;
});
parcelHelpers.export(exports, "makeQuerablePromise", function() {
    return makeQuerablePromise;
});
parcelHelpers.export(exports, "isWebWorker", function() {
    return isWebWorker;
});
parcelHelpers.export(exports, "browserOrNode", function() {
    return browserOrNode;
});
parcelHelpers.export(exports, "transferKeyToLowerCase", function() {
    return transferKeyToLowerCase;
});
parcelHelpers.export(exports, "transferKeyToUpperCase", function() {
    return transferKeyToUpperCase;
});
parcelHelpers.export(exports, "isStrictObject", function() {
    return isStrictObject;
});
var process = require("6dd1111aaf1faf9b");
var MIME_MAP = [
    {
        type: 'text/plain',
        ext: 'txt'
    },
    {
        type: 'text/html',
        ext: 'html'
    },
    {
        type: 'text/javascript',
        ext: 'js'
    },
    {
        type: 'text/css',
        ext: 'css'
    },
    {
        type: 'text/csv',
        ext: 'csv'
    },
    {
        type: 'text/yaml',
        ext: 'yml'
    },
    {
        type: 'text/yaml',
        ext: 'yaml'
    },
    {
        type: 'text/calendar',
        ext: 'ics'
    },
    {
        type: 'text/calendar',
        ext: 'ical'
    },
    {
        type: 'image/apng',
        ext: 'apng'
    },
    {
        type: 'image/bmp',
        ext: 'bmp'
    },
    {
        type: 'image/gif',
        ext: 'gif'
    },
    {
        type: 'image/x-icon',
        ext: 'ico'
    },
    {
        type: 'image/x-icon',
        ext: 'cur'
    },
    {
        type: 'image/jpeg',
        ext: 'jpg'
    },
    {
        type: 'image/jpeg',
        ext: 'jpeg'
    },
    {
        type: 'image/jpeg',
        ext: 'jfif'
    },
    {
        type: 'image/jpeg',
        ext: 'pjp'
    },
    {
        type: 'image/jpeg',
        ext: 'pjpeg'
    },
    {
        type: 'image/png',
        ext: 'png'
    },
    {
        type: 'image/svg+xml',
        ext: 'svg'
    },
    {
        type: 'image/tiff',
        ext: 'tif'
    },
    {
        type: 'image/tiff',
        ext: 'tiff'
    },
    {
        type: 'image/webp',
        ext: 'webp'
    },
    {
        type: 'application/json',
        ext: 'json'
    },
    {
        type: 'application/xml',
        ext: 'xml'
    },
    {
        type: 'application/x-sh',
        ext: 'sh'
    },
    {
        type: 'application/zip',
        ext: 'zip'
    },
    {
        type: 'application/x-rar-compressed',
        ext: 'rar'
    },
    {
        type: 'application/x-tar',
        ext: 'tar'
    },
    {
        type: 'application/x-bzip',
        ext: 'bz'
    },
    {
        type: 'application/x-bzip2',
        ext: 'bz2'
    },
    {
        type: 'application/pdf',
        ext: 'pdf'
    },
    {
        type: 'application/java-archive',
        ext: 'jar'
    },
    {
        type: 'application/msword',
        ext: 'doc'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xls'
    },
    {
        type: 'application/vnd.ms-excel',
        ext: 'xlsx'
    },
    {
        type: 'message/rfc822',
        ext: 'eml'
    }
];
var isEmpty = function isEmpty(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var sortByField = function sortByField(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        if (typeof a_val === 'undefined') return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var objectLessAttributes = function objectLessAttributes(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var filenameToContentType = function filenameToContentType(filename, defVal) {
    if (defVal === void 0) defVal = 'application/octet-stream';
    var name = filename.toLowerCase();
    var filtered = MIME_MAP.filter(function(mime) {
        return name.endsWith('.' + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var isTextFile = function isTextFile(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) return true;
    return 'application/json' === type || 'application/xml' === type || 'application/sh' === type;
};
var generateRandomString = function generateRandomString() {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var makeQuerablePromise = function makeQuerablePromise(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var isWebWorker = function isWebWorker() {
    if (typeof self === 'undefined') return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' && self instanceof selfContext.WorkerGlobalScope;
};
var browserOrNode = function browserOrNode() {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var transferKeyToLowerCase = function transferKeyToLowerCase1(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var transferKeyToUpperCase = function transferKeyToUpperCase1(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var isStrictObject = function isStrictObject(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};

},{"6dd1111aaf1faf9b":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byego":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Signer", function() {
    return Signer;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _util = require("./Util");
var _signatureV4 = require("./clients/middleware/signing/signer/signatureV4");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IOT_SERVICE_NAME = 'iotdevicegateway';
// Best practice regex to parse the service and region from an AWS endpoint
var AWS_ENDPOINT_REGEX = /([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(.cn)?$/;
var Signer = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, accessInfo, serviceInfo) {
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        var requestToSign = __assign(__assign({}, request), {
            body: request.data,
            url: new URL(request.url)
        });
        var options = getOptions(requestToSign, accessInfo, serviceInfo);
        var signedRequest = (0, _signatureV4.signRequest)(requestToSign, options);
        // Prior to using `signRequest`, Signer accepted urls as strings and outputted urls as string. Coerce the property
        // back to a string so as not to disrupt consumers of Signer.
        signedRequest.url = signedRequest.url.toString();
        // HTTP headers should be case insensitive but, to maintain parity with the previous Signer implementation and
        // limit the impact of this implementation swap, replace lowercased headers with title cased ones.
        signedRequest.headers.Authorization = signedRequest.headers.authorization;
        signedRequest.headers['X-Amz-Security-Token'] = signedRequest.headers['x-amz-security-token'];
        delete signedRequest.headers.authorization;
        delete signedRequest.headers['x-amz-security-token'];
        return signedRequest;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = (typeof urlOrRequest === "undefined" ? "undefined" : (0, _typeOf._)(urlOrRequest)) === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = (typeof urlOrRequest === "undefined" ? "undefined" : (0, _typeOf._)(urlOrRequest)) === 'object' ? urlOrRequest.method : 'GET';
        var body = (typeof urlOrRequest === "undefined" ? "undefined" : (0, _typeOf._)(urlOrRequest)) === 'object' ? urlOrRequest.body : undefined;
        var presignable = {
            body: body,
            method: method,
            url: new URL(urlToSign)
        };
        var options = getOptions(presignable, accessInfo, serviceInfo, expiration);
        var signedUrl = (0, _signatureV4.presignUrl)(presignable, options);
        if (accessInfo.session_token && !sessionTokenRequiredInSigning(options.signingService)) signedUrl.searchParams.append((0, _signatureV4.TOKEN_QUERY_PARAM), accessInfo.session_token);
        return signedUrl.toString();
    };
    return Signer;
}();
var getOptions = function getOptions(request, accessInfo, serviceInfo, expiration) {
    var _a = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {}, access_key = _a.access_key, secret_key = _a.secret_key, session_token = _a.session_token;
    var _b = parseServiceInfo(request.url), urlRegion = _b.region, urlService = _b.service;
    var _c = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {}, _d = _c.region, region = _d === void 0 ? urlRegion : _d, _e = _c.service, service = _e === void 0 ? urlService : _e;
    var credentials = __assign({
        accessKeyId: access_key,
        secretAccessKey: secret_key
    }, sessionTokenRequiredInSigning(service) ? {
        sessionToken: session_token
    } : {});
    return __assign({
        credentials: credentials,
        signingDate: (0, _util.DateUtils).getDateWithClockOffset(),
        signingRegion: region,
        signingService: service
    }, expiration && {
        expiration: expiration
    });
};
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var parseServiceInfo = function parseServiceInfo(url) {
    var _a;
    var host = url.host;
    var matched = (_a = host.match(AWS_ENDPOINT_REGEX)) !== null && _a !== void 0 ? _a : [];
    var parsed = matched.slice(1, 3);
    if (parsed[1] === 'es') // Elastic Search
    parsed = parsed.reverse();
    return {
        service: parsed[0],
        region: parsed[1]
    };
};
// IoT service does not allow the session token in the canonical request
// https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var sessionTokenRequiredInSigning = function sessionTokenRequiredInSigning(service) {
    return service !== IOT_SERVICE_NAME;
};

},{"@swc/helpers/_/_type_of":"668P4","./Util":"5E0Hy","./clients/middleware/signing/signer/signatureV4":"2tT6s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5E0Hy":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", function() {
    return 0, _retry.NonRetryableError;
});
parcelHelpers.export(exports, "isNonRetryableError", function() {
    return 0, _retry.isNonRetryableError;
});
parcelHelpers.export(exports, "jitteredBackoff", function() {
    return 0, _retry.jitteredBackoff;
});
parcelHelpers.export(exports, "jitteredExponentialRetry", function() {
    return 0, _retry.jitteredExponentialRetry;
});
parcelHelpers.export(exports, "retry", function() {
    return 0, _retry.retry;
});
parcelHelpers.export(exports, "Mutex", function() {
    return 0, _mutexDefault.default;
});
parcelHelpers.export(exports, "Reachability", function() {
    return 0, _reachabilityDefault.default;
});
parcelHelpers.export(exports, "DateUtils", function() {
    return 0, _dateUtils.DateUtils;
});
parcelHelpers.export(exports, "urlSafeDecode", function() {
    return 0, _stringUtils.urlSafeDecode;
});
parcelHelpers.export(exports, "urlSafeEncode", function() {
    return 0, _stringUtils.urlSafeEncode;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", function() {
    return 0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", function() {
    return 0, _constants.AWS_CLOUDWATCH_CATEGORY;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", function() {
    return 0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", function() {
    return 0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE;
});
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", function() {
    return 0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME;
});
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", function() {
    return 0, _constants.NO_CREDS_ERROR_STRING;
});
parcelHelpers.export(exports, "RETRY_ERROR_CODES", function() {
    return 0, _constants.RETRY_ERROR_CODES;
});
parcelHelpers.export(exports, "BackgroundProcessManager", function() {
    return 0, _backgroundProcessManager.BackgroundProcessManager;
});
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", function() {
    return 0, _backgroundProcessManager.BackgroundManagerNotOpenError;
});
parcelHelpers.export(exports, "BackgroundProcessManagerState", function() {
    return 0, _backgroundProcessManager.BackgroundProcessManagerState;
});
var _retry = require("./Retry");
var _mutex = require("./Mutex");
var _mutexDefault = parcelHelpers.interopDefault(_mutex);
var _reachability = require("./Reachability");
var _reachabilityDefault = parcelHelpers.interopDefault(_reachability);
var _dateUtils = require("./DateUtils");
var _stringUtils = require("./StringUtils");
var _constants = require("./Constants");
var _backgroundProcessManager = require("./BackgroundProcessManager");

},{"./Retry":"2d9ab","./Mutex":"47qe0","./Reachability":"b5eoY","./DateUtils":"ic7zB","./StringUtils":"cCkPA","./Constants":false,"./BackgroundProcessManager":"lMpbt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2d9ab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", function() {
    return NonRetryableError;
});
parcelHelpers.export(exports, "isNonRetryableError", function() {
    return isNonRetryableError;
});
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "retry", function() {
    return retry;
});
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "jitteredBackoff", function() {
    return jitteredBackoff;
});
parcelHelpers.export(exports, "jitteredExponentialRetry", function() {
    return jitteredExponentialRetry;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _consoleLogger = require("../Logger/ConsoleLogger");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _consoleLogger.ConsoleLogger)('Util');
var NonRetryableError = /** @class */ function(_super) {
    __extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var isNonRetryableError = function isNonRetryableError(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, onTerminate) {
    return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a) {
            if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function wakeUp() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function _loop_1() {
                                        var _b, _c, err_1, retryIn_1;
                                        return __generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, __spreadArray([], __read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if (isNonRetryableError(err_1)) {
                                                        logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if ((typeof state_1 === "undefined" ? "undefined" : (0, _typeOf._)(state_1)) === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var MAX_DELAY_MS = 300000;
function jitteredBackoff(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var jitteredExponentialRetry = function jitteredExponentialRetry(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs), onTerminate);
};

},{"@swc/helpers/_/_type_of":"668P4","../Logger/ConsoleLogger":"dY8EL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47qe0":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
exports.default = Mutex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b5eoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, _core.browserOrNode)().isNode) return (0, _zenObservableTsDefault.default).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, _core.isWebWorker)() ? self : window;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function notifyOnline() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function notifyOffline() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function _loop_1(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = __values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
exports.default = ReachabilityNavigator;

},{"@aws-amplify/core":"3rlh1","zen-observable-ts":"57mma","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"57mma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", function() {
    return Observable;
});
var _zenObservable = require("zen-observable");
var _zenObservableDefault = parcelHelpers.interopDefault(_zenObservable);
var Observable = (0, _zenObservableDefault.default);
exports.default = Observable;

},{"zen-observable":"kW3N9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kW3N9":[function(require,module,exports,__globalThis) {
module.exports = require("fe6bb7da9da67ed3").Observable;

},{"fe6bb7da9da67ed3":"b9Fnb"}],"b9Fnb":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Observable = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var hasSymbols = function hasSymbols() {
    return typeof Symbol === 'function';
};
var hasSymbol = function hasSymbol(name) {
    return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function getSymbol(name) {
    return hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if (hasSymbols() && !hasSymbol('observable')) Symbol.observable = Symbol('observable');
var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===
function getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : Observable;
}
function isObservable(x) {
    return x instanceof Observable; // SPEC: Brand check
}
function hostReportError(e) {
    if (hostReportError.log) hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            hostReportError(e);
        }
    });
}
function cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        hostReportError(e);
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        hostReportError(e);
    }
    if (subscription._state === 'closed') cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        enqueue(function() {
            return flushSubscription(subscription);
        });
        return;
    }
    notifySubscription(subscription, type, value);
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        _classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    _createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    closeSubscription(this);
                    cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function get() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        _classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    _createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function get() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        _classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    _createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, _typeOf._)(observer)) !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function next(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function next(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function next(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function next(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function next(v) {
                                observer.next(v);
                            },
                            error: function error(e) {
                                observer.error(e);
                            },
                            complete: function complete() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function next(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function next(value) {
                                    observer.next(value);
                                },
                                error: function error(e) {
                                    observer.error(e);
                                },
                                complete: function complete() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: SymbolObservable,
            value: function value() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = getMethod(x, SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if (isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if (hasSymbol('iterator')) {
                    method = getMethod(x, SymbolIterator);
                    if (method) return new C(function(observer) {
                        enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: SymbolSpecies,
            get: function get() {
                return this;
            }
        }
    ]);
    return Observable;
}();
exports.Observable = Observable;
if (hasSymbols()) Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
        symbol: SymbolObservable,
        hostReportError: hostReportError
    },
    configurable: true
});

},{"@swc/helpers/_/_type_of":"668P4"}],"ic7zB":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateUtils", function() {
    return DateUtils;
});
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var FIVE_MINUTES_IN_MS = 300000;
var DateUtils = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function getDateWithClockOffset() {
        if (DateUtils.clockOffset) return new Date(new Date().getTime() + DateUtils.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function getClockOffset() {
        return DateUtils.clockOffset;
    },
    getHeaderStringFromDate: function getHeaderStringFromDate(date) {
        if (date === void 0) date = DateUtils.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function getDateFromHeaderString(header) {
        var _a = __read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function isClockSkewed(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function isClockSkewError(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            'BadRequestException',
            'InvalidSignatureException'
        ].includes(headers['x-amzn-errortype']) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function setClockOffset(offset) {
        DateUtils.clockOffset = offset;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cCkPA":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlSafeEncode", function() {
    return urlSafeEncode;
});
parcelHelpers.export(exports, "urlSafeDecode", function() {
    return urlSafeDecode;
});
function urlSafeEncode(str) {
    return str.split('').map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, '0');
    }).join('');
}
function urlSafeDecode(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lMpbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundProcessManager", function() {
    return BackgroundProcessManager;
});
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", function() {
    return BackgroundManagerNotOpenError;
});
parcelHelpers.export(exports, "BackgroundProcessManagerState", function() {
    return BackgroundProcessManagerState;
});
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private For internal Amplify use.
 *
 * Creates a new scope for promises, observables, and other types of work or
 * processes that may be running in the background. This manager provides
 * an singular entrypoint to request termination and await completion.
 *
 * As work completes on its own prior to close, the manager removes them
 * from the registry to avoid holding references to completed jobs.
 */ var BackgroundProcessManager = /** @class */ function() {
    /**
     * Creates a new manager for promises, observables, and other types
     * of work that may be running in the background. This manager provides
     * a centralized mechanism to request termination and await completion.
     */ function BackgroundProcessManager() {
        /**
         * A string indicating whether the manager is accepting new work ("Open"),
         * waiting for work to complete ("Closing"), or fully done with all
         * submitted work and *not* accepting new jobs ("Closed").
         */ this._state = BackgroundProcessManagerState.Open;
        /**
         * The list of outstanding jobs we'll need to wait for upon `close()`
         */ this.jobs = new Set();
    }
    BackgroundProcessManager.prototype.add = function(jobOrDescription, optionalDescription) {
        var job;
        var description;
        if (typeof jobOrDescription === 'string') {
            job = undefined;
            description = jobOrDescription;
        } else {
            job = jobOrDescription;
            description = optionalDescription;
        }
        var error = this.closedFailure(description);
        if (error) return error;
        if (job === undefined) return this.addHook(description);
        else if (typeof job === 'function') return this.addFunction(job, description);
        else if (job instanceof BackgroundProcessManager) return this.addManager(job, description);
        else throw new Error('If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.');
    };
    /**
     * Adds a **cleaner** function that doesn't immediately get executed.
     * Instead, the caller gets a **terminate** function back. The *cleaner* is
     * invoked only once the mananger *closes* or the returned **terminate**
     * function is called.
     *
     * @param clean The cleanup function.
     * @param description Optional description to help identify pending jobs.
     * @returns A terminate function.
     */ BackgroundProcessManager.prototype.addCleaner = function(clean, description) {
        var _this = this;
        var _a = this.addHook(description), resolve = _a.resolve, onTerminate = _a.onTerminate;
        var proxy = function proxy() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                clean()
                            ];
                        case 1:
                            _a.sent();
                            resolve();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        onTerminate.then(proxy);
        return proxy;
    };
    BackgroundProcessManager.prototype.addFunction = function(job, description) {
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolve) {
            terminate = resolve;
        });
        // finally! start the job.
        var jobResult = job(onTerminate);
        // depending on what the job gives back, register the result
        // so we can monitor for completion.
        if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === 'function') this.registerPromise(jobResult, terminate, description);
        // At the end of the day, or you know, method call, it doesn't matter
        // what the return value is at all; we just pass it through to the
        // caller.
        return jobResult;
    };
    BackgroundProcessManager.prototype.addManager = function(manager, description) {
        var _this = this;
        this.addCleaner(function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                manager.close()
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        }, description);
    };
    /**
     * Creates and registers a fabricated job for processes that need to operate
     * with callbacks/hooks. The returned `resolve` and `reject`
     * functions can be used to signal the job is done successfully or not.
     * The returned `onTerminate` is a promise that will resolve when the
     * manager is requesting the termination of the job.
     *
     * @param description Optional description to help identify pending jobs.
     * @returns `{ resolve, reject, onTerminate }`
     */ BackgroundProcessManager.prototype.addHook = function(description) {
        // the resolve/reject functions we'll provide to the caller to signal
        // the state of the job.
        var resolve;
        var reject;
        // the underlying promise we'll use to manage it, pretty much like
        // any other promise.
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolveTerminate) {
            terminate = resolveTerminate;
        });
        this.registerPromise(promise, terminate, description);
        return {
            resolve: resolve,
            reject: reject,
            onTerminate: onTerminate
        };
    };
    /**
     * Adds a Promise based job to the list of jobs for monitoring and listens
     * for either a success or failure, upon which the job is considered "done"
     * and removed from the registry.
     *
     * @param promise A promise that is on its way to being returned to a
     * caller, which needs to be tracked as a background job.
     * @param terminate The termination function to register, which can be
     * invoked to request the job stop.
     * @param description Optional description to help identify pending jobs.
     */ BackgroundProcessManager.prototype.registerPromise = function(promise, terminate, description) {
        var _this = this;
        var jobEntry = {
            promise: promise,
            terminate: terminate,
            description: description
        };
        this.jobs.add(jobEntry);
        // in all of my testing, it is safe to multi-subscribe to a promise.
        // so, rather than create another layer of promising, we're just going
        // to hook into the promise we already have, and when it's done
        // (successfully or not), we no longer need to wait for it upon close.
        //
        // sorry this is a bit hand-wavy:
        //
        // i believe we use `.then` and `.catch` instead of `.finally` because
        // `.finally` is invoked in a different order in the sequence, and this
        // breaks assumptions throughout and causes failures.
        promise.then(function() {
            _this.jobs.delete(jobEntry);
        }).catch(function() {
            _this.jobs.delete(jobEntry);
        });
    };
    Object.defineProperty(BackgroundProcessManager.prototype, "length", {
        /**
         * The number of jobs being waited on.
         *
         * We don't use this for anything. It's just informational for the caller,
         * and can be used in logging and testing.
         *
         * @returns the number of jobs.
         */ get: function get() {
            return this.jobs.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "state", {
        /**
         * The execution state of the manager. One of:
         *
         * 1. "Open" -> Accepting new jobs
         * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
         * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
         */ get: function get() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "pending", {
        /**
         * The registered `description` of all still-pending jobs.
         *
         * @returns descriptions as an array.
         */ get: function get() {
            return Array.from(this.jobs).map(function(job) {
                return job.description;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isOpen", {
        /**
         * Whether the manager is accepting new jobs.
         */ get: function get() {
            return this._state === BackgroundProcessManagerState.Open;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosing", {
        /**
         * Whether the manager is rejecting new work, but still waiting for
         * submitted work to complete.
         */ get: function get() {
            return this._state === BackgroundProcessManagerState.Closing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosed", {
        /**
         * Whether the manager is rejecting work and done waiting for submitted
         * work to complete.
         */ get: function get() {
            return this._state === BackgroundProcessManagerState.Closed;
        },
        enumerable: false,
        configurable: true
    });
    BackgroundProcessManager.prototype.closedFailure = function(description) {
        if (!this.isOpen) return Promise.reject(new BackgroundManagerNotOpenError([
            "The manager is ".concat(this.state, "."),
            "You tried to add \"".concat(description, "\"."),
            "Pending jobs: [\n".concat(this.pending.map(function(t) {
                return '    ' + t;
            }).join(',\n'), "\n]")
        ].join('\n')));
    };
    /**
     * Signals jobs to stop (for those that accept interruptions) and waits
     * for confirmation that jobs have stopped.
     *
     * This immediately puts the manager into a closing state and just begins
     * to reject new work. After all work in the manager is complete, the
     * manager goes into a `Completed` state and `close()` returns.
     *
     * This call is idempotent.
     *
     * If the manager is already closing or closed, `finalCleaup` is not executed.
     *
     * @param onClosed
     * @returns The settled results of each still-running job's promise. If the
     * manager is already closed, this will contain the results as of when the
     * manager's `close()` was called in an `Open` state.
     */ BackgroundProcessManager.prototype.close = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, job;
            var e_1, _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!this.isOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._state = BackgroundProcessManagerState.Closing;
                        try {
                            for(_a = __values(Array.from(this.jobs)), _b = _a.next(); !_b.done; _b = _a.next()){
                                job = _b.value;
                                try {
                                    job.terminate();
                                } catch (error) {
                                    // Due to potential races with a job's natural completion, it's
                                    // reasonable to expect the termination call to fail. Hence,
                                    // not logging as an error.
                                    console.warn("Failed to send termination signal to job. Error: ".concat(error.message), job);
                                }
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        // Use `allSettled()` because we want to wait for all to finish. We do
                        // not want to stop waiting if there is a failure.
                        this._closingPromise = Promise.allSettled(Array.from(this.jobs).map(function(j) {
                            return j.promise;
                        }));
                        return [
                            4 /*yield*/ ,
                            this._closingPromise
                        ];
                    case 1:
                        _d.sent();
                        this._state = BackgroundProcessManagerState.Closed;
                        _d.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._closingPromise
                        ];
                }
            });
        });
    };
    /**
     * Signals the manager to start accepting work (again) and returns once
     * the manager is ready to do so.
     *
     * If the state is already `Open`, this call is a no-op.
     *
     * If the state is `Closed`, this call simply updates state and returns.
     *
     * If the state is `Closing`, this call waits for completion before it
     * updates the state and returns.
     */ BackgroundProcessManager.prototype.open = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isClosing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this._state = BackgroundProcessManagerState.Open;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackgroundProcessManager;
}();
/**
 *
 */ var BackgroundManagerNotOpenError = /** @class */ function(_super) {
    __extends(BackgroundManagerNotOpenError, _super);
    function BackgroundManagerNotOpenError(message) {
        return _super.call(this, "BackgroundManagerNotOpenError: ".concat(message)) || this;
    }
    return BackgroundManagerNotOpenError;
}(Error);
var BackgroundProcessManagerState;
(function(BackgroundProcessManagerState) {
    /**
     * Accepting new jobs.
     */ BackgroundProcessManagerState["Open"] = "Open";
    /**
     * Not accepting new jobs. Waiting for submitted jobs to complete.
     */ BackgroundProcessManagerState["Closing"] = "Closing";
    /**
     * Not accepting new jobs. All submitted jobs are complete.
     */ BackgroundProcessManagerState["Closed"] = "Closed";
})(BackgroundProcessManagerState || (BackgroundProcessManagerState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2tT6s":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 replace Signer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", function() {
    return 0, _signRequest.signRequest;
});
parcelHelpers.export(exports, "presignUrl", function() {
    return 0, _presignUrl.presignUrl;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return 0, _constants.TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "getHashedPayload", function() {
    return 0, _getHashedPayload.getHashedPayload;
});
var _signRequest = require("./signRequest");
var _presignUrl = require("./presignUrl");
var _constants = require("./constants");
var _getHashedPayload = require("./utils/getHashedPayload");

},{"./signRequest":"dCCl6","./presignUrl":"dkRwv","./constants":"frxal","./utils/getHashedPayload":"8TceH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dCCl6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", function() {
    return signRequest;
});
var _getSignedHeaders = require("./utils/getSignedHeaders");
var _getSigningValues = require("./utils/getSigningValues");
var _constants = require("./constants");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var signRequest = function signRequest(request, options) {
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    var headers = __assign({}, request.headers);
    headers[0, _constants.HOST_HEADER] = request.url.host;
    headers[0, _constants.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, _constants.TOKEN_HEADER] = sessionToken;
    var requestToSign = __assign(__assign({}, request), {
        headers: headers
    });
    // calculate and add the signature to the request
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    var credentialEntry = "Credential=".concat(accessKeyId, "/").concat(credentialScope);
    var signedHeadersEntry = "SignedHeaders=".concat((0, _getSignedHeaders.getSignedHeaders)(headers));
    var signatureEntry = "Signature=".concat(signature);
    headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.SHA256_ALGORITHM_IDENTIFIER), " ").concat(credentialEntry, ", ").concat(signedHeadersEntry, ", ").concat(signatureEntry);
    return requestToSign;
};

},{"./utils/getSignedHeaders":"aGJ5y","./utils/getSigningValues":"a9VXR","./constants":"frxal","./utils/getSignature":"1QRjI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGJ5y":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignedHeaders", function() {
    return getSignedHeaders;
});
var getSignedHeaders = function getSignedHeaders(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(';');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a9VXR":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningValues", function() {
    return getSigningValues;
});
var _getCredentialScope = require("./getCredentialScope");
var _getFormattedDates = require("./getFormattedDates");
var getSigningValues = function getSigningValues(_a) {
    var credentials = _a.credentials, _b = _a.signingDate, signingDate = _b === void 0 ? new Date() : _b, signingRegion = _a.signingRegion, signingService = _a.signingService, _c = _a.uriEscapePath, uriEscapePath = _c === void 0 ? true : _c;
    // get properties from credentials
    var accessKeyId = credentials.accessKeyId, secretAccessKey = credentials.secretAccessKey, sessionToken = credentials.sessionToken;
    // get formatted dates for signing
    var _d = (0, _getFormattedDates.getFormattedDates)(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
    // copy header and set signing properties
    var credentialScope = (0, _getCredentialScope.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};

},{"./getCredentialScope":"cfih6","./getFormattedDates":"2Ix3y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cfih6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialScope", function() {
    return getCredentialScope;
});
var _constants = require("../constants");
var getCredentialScope = function getCredentialScope(date, region, service) {
    return "".concat(date, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};

},{"../constants":"frxal","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"frxal":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", function() {
    return ALGORITHM_QUERY_PARAM;
});
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", function() {
    return AMZ_DATE_QUERY_PARAM;
});
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", function() {
    return CREDENTIAL_QUERY_PARAM;
});
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", function() {
    return EXPIRES_QUERY_PARAM;
});
parcelHelpers.export(exports, "REGION_SET_PARAM", function() {
    return REGION_SET_PARAM;
});
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", function() {
    return SIGNATURE_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", function() {
    return SIGNED_HEADERS_QUERY_PARAM;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "AUTH_HEADER", function() {
    return AUTH_HEADER;
});
parcelHelpers.export(exports, "HOST_HEADER", function() {
    return HOST_HEADER;
});
parcelHelpers.export(exports, "AMZ_DATE_HEADER", function() {
    return AMZ_DATE_HEADER;
});
parcelHelpers.export(exports, "TOKEN_HEADER", function() {
    return TOKEN_HEADER;
});
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", function() {
    return KEY_TYPE_IDENTIFIER;
});
parcelHelpers.export(exports, "SHA256_ALGORITHM_IDENTIFIER", function() {
    return SHA256_ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "SIGNATURE_IDENTIFIER", function() {
    return SIGNATURE_IDENTIFIER;
});
parcelHelpers.export(exports, "EMPTY_HASH", function() {
    return EMPTY_HASH;
});
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", function() {
    return UNSIGNED_PAYLOAD;
});
var ALGORITHM_QUERY_PARAM = 'X-Amz-Algorithm';
var AMZ_DATE_QUERY_PARAM = 'X-Amz-Date';
var CREDENTIAL_QUERY_PARAM = 'X-Amz-Credential';
var EXPIRES_QUERY_PARAM = 'X-Amz-Expires';
var REGION_SET_PARAM = 'X-Amz-Region-Set';
var SIGNATURE_QUERY_PARAM = 'X-Amz-Signature';
var SIGNED_HEADERS_QUERY_PARAM = 'X-Amz-SignedHeaders';
var TOKEN_QUERY_PARAM = 'X-Amz-Security-Token';
var AUTH_HEADER = 'authorization';
var HOST_HEADER = 'host';
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var KEY_TYPE_IDENTIFIER = 'aws4_request';
var SHA256_ALGORITHM_IDENTIFIER = 'AWS4-HMAC-SHA256';
var SIGNATURE_IDENTIFIER = 'AWS4';
var EMPTY_HASH = 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
var UNSIGNED_PAYLOAD = 'UNSIGNED-PAYLOAD';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Ix3y":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormattedDates", function() {
    return getFormattedDates;
});
var getFormattedDates = function getFormattedDates(date) {
    var longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QRjI":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignature", function() {
    return getSignature;
});
var _dataHashHelpers = require("./dataHashHelpers");
var _getCanonicalRequest = require("./getCanonicalRequest");
var _getSigningKey = require("./getSigningKey");
var _getStringToSign = require("./getStringToSign");
var getSignature = function getSignature(request, _a) {
    var credentialScope = _a.credentialScope, longDate = _a.longDate, secretAccessKey = _a.secretAccessKey, shortDate = _a.shortDate, signingRegion = _a.signingRegion, signingService = _a.signingService, uriEscapePath = _a.uriEscapePath;
    // step 1: create a canonical request
    var canonicalRequest = (0, _getCanonicalRequest.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    var hashedRequest = (0, _dataHashHelpers.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    var stringToSign = (0, _getStringToSign.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    var signature = (0, _dataHashHelpers.getHashedDataAsHex)((0, _getSigningKey.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

},{"./dataHashHelpers":"eBHPH","./getCanonicalRequest":"hjw41","./getSigningKey":"d6PXj","./getStringToSign":"E7i3P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eBHPH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedData", function() {
    return getHashedData;
});
parcelHelpers.export(exports, "getHashedDataAsHex", function() {
    return getHashedDataAsHex;
});
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var getHashedData = function getHashedData(key, data) {
    var sha256 = new (0, _sha256Js.Sha256)(key);
    sha256.update(data);
    // TODO: V6 flip to async digest
    var hashedData = sha256.digestSync();
    return hashedData;
};
var getHashedDataAsHex = function getHashedDataAsHex(key, data) {
    var hashedData = getHashedData(key, data);
    return (0, _utilHexEncoding.toHex)(hashedData);
};

},{"@aws-crypto/sha256-js":"1pg4I","@aws-sdk/util-hex-encoding":"dTdhV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1pg4I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("847e9f41fbd48d18");
(0, tslib_1.__exportStar)(require("952fa851a97011d6"), exports);

},{"847e9f41fbd48d18":"6vDGG","952fa851a97011d6":"cBehM"}],"6vDGG":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cBehM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("4cf08e042cbd4f6b");
var constants_1 = require("2f5507f5e1102429");
var RawSha256_1 = require("c4be19be66a5b026");
var util_1 = require("2d947ee16d17c108");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"4cf08e042cbd4f6b":"6vDGG","2f5507f5e1102429":"ciFKs","c4be19be66a5b026":"1lh4r","2d947ee16d17c108":"1R05H"}],"ciFKs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"1lh4r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("611362490e842507");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"611362490e842507":"ciFKs"}],"1R05H":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("d546aa13e7a4f234");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function get() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("688570fbe8307eb0");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function get() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("9f8c2d94c37c0290");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function get() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("65327eb5bf877089");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function get() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"d546aa13e7a4f234":"1CD9C","688570fbe8307eb0":"kNGoz","9f8c2d94c37c0290":"13Gve","65327eb5bf877089":"9noVK"}],"1CD9C":[function(require,module,exports,__globalThis) {
var Buffer = require("c6f30219801e45d2").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("edd31833385d65db");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function fromUtf8(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"c6f30219801e45d2":"cvSE8","edd31833385d65db":"iZmxX"}],"cvSE8":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)));
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, _typeOf._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"@swc/helpers/_/_type_of":"668P4","9c62938f1dccc73c":"MlSYJ","aceacb6a4531a9d2":"15Xnl"}],"MlSYJ":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"15Xnl":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"iZmxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function fromUtf8(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function toUtf8(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"9OMpz","./whatwgEncodingApi":"clj9V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9OMpz":[function(require,module,exports,__globalThis) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var fromUtf8 = function fromUtf8(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function toUtf8(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"clj9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNGoz":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"13Gve":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"9noVK":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"dTdhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ parcelHelpers.export(exports, "fromHex", function() {
    return fromHex;
});
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ parcelHelpers.export(exports, "toHex", function() {
    return toHex;
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0" + encodedByte;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hjw41":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalRequest", function() {
    return getCanonicalRequest;
});
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQueryString = require("./getCanonicalQueryString");
var _getCanonicalUri = require("./getCanonicalUri");
var _getHashedPayload = require("./getHashedPayload");
var _getSignedHeaders = require("./getSignedHeaders");
var getCanonicalRequest = function getCanonicalRequest(_a, uriEscapePath) {
    var body = _a.body, headers = _a.headers, method = _a.method, url = _a.url;
    if (uriEscapePath === void 0) uriEscapePath = true;
    return [
        method,
        (0, _getCanonicalUri.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, _getCanonicalQueryString.getCanonicalQueryString)(url.searchParams),
        (0, _getCanonicalHeaders.getCanonicalHeaders)(headers),
        (0, _getSignedHeaders.getSignedHeaders)(headers),
        (0, _getHashedPayload.getHashedPayload)(body)
    ].join('\n');
};

},{"./getCanonicalHeaders":"8mDLP","./getCanonicalQueryString":"etapY","./getCanonicalUri":"kltn4","./getHashedPayload":"8TceH","./getSignedHeaders":"aGJ5y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mDLP":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return getCanonicalHeaders;
});
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalHeaders = function getCanonicalHeaders(headers) {
    return Object.entries(headers).map(function(_a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return {
            key: key.toLowerCase(),
            value: (_b = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, ' ')) !== null && _b !== void 0 ? _b : ''
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(entry) {
        return "".concat(entry.key, ":").concat(entry.value, "\n");
    }).join('');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"etapY":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQueryString", function() {
    return getCanonicalQueryString;
});
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalQueryString = function getCanonicalQueryString(searchParams) {
    return Array.from(searchParams).sort(function(_a, _b) {
        var _c = __read(_a, 2), keyA = _c[0], valA = _c[1];
        var _d = __read(_b, 2), keyB = _d[0], valB = _d[1];
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(function(_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return "".concat(escapeUri(key), "=").concat(escapeUri(val));
    }).join('&');
};
var escapeUri = function escapeUri(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kltn4":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalUri", function() {
    return getCanonicalUri;
});
var getCanonicalUri = function getCanonicalUri(pathname, uriEscapePath) {
    if (uriEscapePath === void 0) uriEscapePath = true;
    return pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, '/') : pathname : '/';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TceH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedPayload", function() {
    return getHashedPayload;
});
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getHashedPayload = function getHashedPayload(body) {
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, _constants.EMPTY_HASH;
    if (isSourceData(body)) {
        var hashedData = (0, _dataHashHelpers.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, _constants.UNSIGNED_PAYLOAD;
};
var isSourceData = function isSourceData(body) {
    return typeof body === 'string' || ArrayBuffer.isView(body) || isArrayBuffer(body);
};
var isArrayBuffer = function isArrayBuffer(arg) {
    return typeof ArrayBuffer === 'function' && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === '[object ArrayBuffer]';
};

},{"../constants":"frxal","./dataHashHelpers":"eBHPH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d6PXj":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningKey", function() {
    return getSigningKey;
});
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getSigningKey = function getSigningKey(secretAccessKey, date, region, service) {
    var key = "".concat((0, _constants.SIGNATURE_IDENTIFIER)).concat(secretAccessKey);
    var dateKey = (0, _dataHashHelpers.getHashedData)(key, date);
    var regionKey = (0, _dataHashHelpers.getHashedData)(dateKey, region);
    var serviceKey = (0, _dataHashHelpers.getHashedData)(regionKey, service);
    var signingKey = (0, _dataHashHelpers.getHashedData)(serviceKey, (0, _constants.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

},{"../constants":"frxal","./dataHashHelpers":"eBHPH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"E7i3P":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStringToSign", function() {
    return getStringToSign;
});
var _constants = require("../constants");
var getStringToSign = function getStringToSign(date, credentialScope, hashedRequest) {
    return [
        (0, _constants.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join('\n');
};

},{"../constants":"frxal","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dkRwv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presignUrl", function() {
    return presignUrl;
});
var _constants = require("./constants");
var _getSigningValues = require("./utils/getSigningValues");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var presignUrl = function presignUrl(_a, _b) {
    var _c, _d, _e, _f;
    var body = _a.body, _g = _a.method, method = _g === void 0 ? 'GET' : _g, url = _a.url;
    var expiration = _b.expiration, options = __rest(_b, [
        "expiration"
    ]);
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    // @ts-ignore URL constructor accepts a URL object
    var presignedUrl = new URL(url);
    Object.entries(__assign(__assign((_c = {}, _c[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.SHA256_ALGORITHM_IDENTIFIER), _c[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(accessKeyId, "/").concat(credentialScope), _c[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate, _c[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = (0, _constants.HOST_HEADER), _c), expiration && (_d = {}, _d[0, _constants.EXPIRES_QUERY_PARAM] = expiration.toString(), _d)), sessionToken && (_e = {}, _e[0, _constants.TOKEN_QUERY_PARAM] = sessionToken, _e))).forEach(function(_a) {
        var _$_b = __read(_a, 2), key = _$_b[0], value = _$_b[1];
        presignedUrl.searchParams.append(key, value);
    });
    var requestToSign = {
        body: body,
        headers: (_f = {}, _f[0, _constants.HOST_HEADER] = url.host, _f),
        method: method,
        url: presignedUrl
    };
    // calculate and add the signature to the url
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    presignedUrl.searchParams.append((0, _constants.SIGNATURE_QUERY_PARAM), signature);
    return presignedUrl;
};

},{"./constants":"frxal","./utils/getSigningValues":"a9VXR","./utils/getSignature":"1QRjI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNxFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAWSExports", function() {
    return parseAWSExports;
});
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)('Parser');
var parseAWSExports = function parseAWSExports(config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region']
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) amplifyConfig.Auth = {
        userPoolId: config['aws_user_pools_id'],
        userPoolWebClientId: config['aws_user_pools_web_client_id'],
        region: config['aws_cognito_region'],
        identityPoolId: config['aws_cognito_identity_pool_id'],
        identityPoolRegion: config['aws_cognito_region'],
        mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable',
        signUpVerificationMethod: config['aws_cognito_sign_up_verification_method'] || 'code'
    };
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) storageConfig = {
        AWSS3: {
            bucket: config['aws_user_files_s3_bucket'],
            region: config['aws_user_files_s3_bucket_region'],
            dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing']
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config['Logging']) amplifyConfig.Logging = __assign(__assign({}, config['Logging']), {
        region: config['aws_project_region']
    });
    // Geo
    if (config['geo']) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo['amazon_location_service']) amplifyConfig.Geo = {
            AmazonLocationService: config.geo['amazon_location_service']
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPXfS":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", function() {
    return 0, _awscloudWatchProvider.AWSCloudWatchProvider;
});
var _awscloudWatchProvider = require("./AWSCloudWatchProvider");

},{"./AWSCloudWatchProvider":"eX5Mv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eX5Mv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", function() {
    return AWSCloudWatchProvider;
});
var _clientCloudwatchLogs = require("@aws-sdk/client-cloudwatch-logs");
var _ = require("../..");
var _logger = require("../Logger");
var _platform = require("../Platform");
var _parseAWSExports = require("../parseAWSExports");
var _constants = require("../Util/Constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)('AWSCloudWatch');
var AWSCloudWatchProvider = /** @class */ function() {
    function AWSCloudWatchProvider(config) {
        this.configure(config);
        this._dataTracker = {
            eventUploadInProgress: false,
            logEvents: []
        };
        this._currentLogBatch = [];
        this._initiateLogPushInterval();
    }
    AWSCloudWatchProvider.prototype.getProviderName = function() {
        return AWSCloudWatchProvider.PROVIDER_NAME;
    };
    AWSCloudWatchProvider.prototype.getCategoryName = function() {
        return AWSCloudWatchProvider.CATEGORY;
    };
    AWSCloudWatchProvider.prototype.getLogQueue = function() {
        return this._dataTracker.logEvents;
    };
    AWSCloudWatchProvider.prototype.configure = function(config) {
        if (!config) return this._config || {};
        var conf = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(config).Logging, config);
        this._config = conf;
        return this._config;
    };
    AWSCloudWatchProvider.prototype.createLogGroup = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('creating new log group in CloudWatch - ', params.logGroupName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogGroupCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.error("error creating log group - ".concat(error_1));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogGroups = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('getting list of log groups');
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogGroupsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.error("error getting log group - ".concat(error_2));
                        throw error_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.createLogStream = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_3;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('creating new log stream in CloudWatch - ', params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogStreamCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.error("error creating log stream - ".concat(error_3));
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogStreams = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('getting list of log streams');
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogStreamsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.error("error getting log stream - ".concat(error_4));
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('getting log events from stream - ', params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.GetLogEventsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_5 = _a.sent();
                        logger.error("error getting log events - ".concat(error_5));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.pushLogs = function(logs) {
        logger.debug('pushing log events to Cloudwatch...');
        this._dataTracker.logEvents = __spreadArray(__spreadArray([], __read(this._dataTracker.logEvents), false), __read(logs), false);
    };
    AWSCloudWatchProvider.prototype._validateLogGroupExistsAndCreate = function(logGroupName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currGroups, foundGroups, err_1, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._dataTracker.verifiedLogGroup) return [
                            2 /*return*/ ,
                            this._dataTracker.verifiedLogGroup
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogGroups({
                                logGroupNamePrefix: logGroupName
                            })
                        ];
                    case 3:
                        currGroups = _a.sent();
                        if (!(typeof currGroups === 'string') && currGroups.logGroups) {
                            foundGroups = currGroups.logGroups.filter(function(group) {
                                return group.logGroupName === logGroupName;
                            });
                            if (foundGroups.length > 0) {
                                this._dataTracker.verifiedLogGroup = foundGroups[0];
                                return [
                                    2 /*return*/ ,
                                    foundGroups[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogGroup({
                                logGroupName: logGroupName
                            })
                        ];
                    case 4:
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 5:
                        err_1 = _a.sent();
                        errString = "failure during log group search: ".concat(err_1);
                        logger.error(errString);
                        throw err_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._validateLogStreamExists = function(logGroupName, logStreamName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currStreams, foundStreams, err_2, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogStreams({
                                logGroupName: logGroupName,
                                logStreamNamePrefix: logStreamName
                            })
                        ];
                    case 2:
                        currStreams = _a.sent();
                        if (currStreams.logStreams) {
                            foundStreams = currStreams.logStreams.filter(function(stream) {
                                return stream.logStreamName === logStreamName;
                            });
                            if (foundStreams.length > 0) {
                                this._nextSequenceToken = foundStreams[0].uploadSequenceToken;
                                return [
                                    2 /*return*/ ,
                                    foundStreams[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogStream({
                                logGroupName: logGroupName,
                                logStreamName: logStreamName
                            })
                        ];
                    case 3:
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        err_2 = _a.sent();
                        errString = "failure during log stream search: ".concat(err_2);
                        logger.error(errString);
                        throw err_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._sendLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, cmd, client, output, err_3, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        logger.debug('sending log events to stream - ', params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.PutLogEventsCommand)(params);
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 2:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        err_3 = _a.sent();
                        errString = "failure during log push: ".concat(err_3);
                        logger.error(errString);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initCloudWatchLogs = function() {
        return new (0, _clientCloudwatchLogs.CloudWatchLogsClient)({
            region: this._config.region,
            credentials: this._config.credentials,
            customUserAgent: (0, _platform.getAmplifyUserAgentObject)(),
            endpoint: this._config.endpoint
        });
    };
    AWSCloudWatchProvider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _.Credentials).get().then(function(credentials) {
                                if (!credentials) return false;
                                var cred = (0, _.Credentials).shear(credentials);
                                logger.debug('set credentials for logging', cred);
                                _this._config.credentials = cred;
                                return true;
                            }).catch(function(error) {
                                logger.warn('ensure credentials error', error);
                                return false;
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getNextSequenceToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            var logStream, err_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._nextSequenceToken && this._nextSequenceToken.length > 0) return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._validateLogGroupExistsAndCreate(this._config.logGroupName)
                        ];
                    case 2:
                        _a.sent();
                        this._nextSequenceToken = undefined;
                        return [
                            4 /*yield*/ ,
                            this._validateLogStreamExists(this._config.logGroupName, this._config.logStreamName)
                        ];
                    case 3:
                        logStream = _a.sent();
                        if (logStream) this._nextSequenceToken = logStream.uploadSequenceToken;
                        return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                    case 4:
                        err_4 = _a.sent();
                        logger.error("failure while getting next sequence token: ".concat(err_4));
                        throw err_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._safeUploadLogEvents = function() {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, logBatch, putLogsPayload, sendLogEventsResponse, err_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        logBatch = this._currentLogBatch.length === 0 ? this._getBufferedBatchOfLogs() : this._currentLogBatch;
                        putLogsPayload = {
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName,
                            logEvents: logBatch,
                            sequenceToken: seqToken
                        };
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(putLogsPayload)
                        ];
                    case 2:
                        sendLogEventsResponse = _a.sent();
                        this._nextSequenceToken = sendLogEventsResponse.nextSequenceToken;
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsResponse
                        ];
                    case 3:
                        err_5 = _a.sent();
                        logger.error("error during _safeUploadLogEvents: ".concat(err_5));
                        if ((0, _constants.RETRY_ERROR_CODES).includes(err_5.name)) this._getNewSequenceTokenAndSubmit({
                            logEvents: this._currentLogBatch,
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName
                        });
                        else {
                            this._dataTracker.eventUploadInProgress = false;
                            throw err_5;
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getBufferedBatchOfLogs = function() {
        /**
         * CloudWatch has restrictions on the size of the log events that get sent up.
         * We need to track both the size of each event and the total size of the batch
         * of logs.
         *
         * We also need to ensure that the logs in the batch are sorted in chronological order.
         * https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html
         */ var currentEventIdx = 0;
        var totalByteSize = 0;
        while(currentEventIdx < this._dataTracker.logEvents.length){
            var currentEvent = this._dataTracker.logEvents[currentEventIdx];
            var eventSize = currentEvent ? new TextEncoder().encode(currentEvent.message).length + (0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE) : 0;
            if (eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE)) {
                var errString = "Log entry exceeds maximum size for CloudWatch logs. Log size: ".concat(eventSize, ". Truncating log message.");
                logger.warn(errString);
                currentEvent.message = currentEvent.message.substring(0, eventSize);
            }
            if (totalByteSize + eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE)) break;
            totalByteSize += eventSize;
            currentEventIdx++;
        }
        this._currentLogBatch = this._dataTracker.logEvents.splice(0, currentEventIdx);
        return this._currentLogBatch;
    };
    AWSCloudWatchProvider.prototype._getNewSequenceTokenAndSubmit = function(payload) {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, sendLogEventsRepsonse, err_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        this._nextSequenceToken = undefined;
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        payload.sequenceToken = seqToken;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(payload)
                        ];
                    case 2:
                        sendLogEventsRepsonse = _a.sent();
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsRepsonse
                        ];
                    case 3:
                        err_6 = _a.sent();
                        logger.error("error when retrying log submission with new sequence token: ".concat(err_6));
                        this._dataTracker.eventUploadInProgress = false;
                        throw err_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initiateLogPushInterval = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        this._timer = setInterval(function() {
            return __awaiter(_this, void 0, void 0, function() {
                var err_7;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!this._getDocUploadPermissibility()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this._safeUploadLogEvents()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_7 = _a.sent();
                            logger.error("error when calling _safeUploadLogEvents in the timer interval - ".concat(err_7));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }, 2000);
    };
    AWSCloudWatchProvider.prototype._getDocUploadPermissibility = function() {
        return (this._dataTracker.logEvents.length !== 0 || this._currentLogBatch.length !== 0) && !this._dataTracker.eventUploadInProgress;
    };
    AWSCloudWatchProvider.PROVIDER_NAME = (0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME);
    AWSCloudWatchProvider.CATEGORY = (0, _constants.AWS_CLOUDWATCH_CATEGORY);
    return AWSCloudWatchProvider;
}();

},{"@aws-sdk/client-cloudwatch-logs":"59afR","../..":"3rlh1","../Logger":"jVGZ5","../Platform":"jNyBX","../parseAWSExports":"jNxFP","../Util/Constants":"4siXq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"59afR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloudWatchLogsClient = require("./CloudWatchLogsClient");
parcelHelpers.exportAll(_cloudWatchLogsClient, exports);
var _cloudWatchLogs = require("./CloudWatchLogs");
parcelHelpers.exportAll(_cloudWatchLogs, exports);
var _associateKmsKeyCommand = require("./commands/AssociateKmsKeyCommand");
parcelHelpers.exportAll(_associateKmsKeyCommand, exports);
var _cancelExportTaskCommand = require("./commands/CancelExportTaskCommand");
parcelHelpers.exportAll(_cancelExportTaskCommand, exports);
var _createExportTaskCommand = require("./commands/CreateExportTaskCommand");
parcelHelpers.exportAll(_createExportTaskCommand, exports);
var _createLogGroupCommand = require("./commands/CreateLogGroupCommand");
parcelHelpers.exportAll(_createLogGroupCommand, exports);
var _createLogStreamCommand = require("./commands/CreateLogStreamCommand");
parcelHelpers.exportAll(_createLogStreamCommand, exports);
var _deleteDestinationCommand = require("./commands/DeleteDestinationCommand");
parcelHelpers.exportAll(_deleteDestinationCommand, exports);
var _deleteLogGroupCommand = require("./commands/DeleteLogGroupCommand");
parcelHelpers.exportAll(_deleteLogGroupCommand, exports);
var _deleteLogStreamCommand = require("./commands/DeleteLogStreamCommand");
parcelHelpers.exportAll(_deleteLogStreamCommand, exports);
var _deleteMetricFilterCommand = require("./commands/DeleteMetricFilterCommand");
parcelHelpers.exportAll(_deleteMetricFilterCommand, exports);
var _deleteQueryDefinitionCommand = require("./commands/DeleteQueryDefinitionCommand");
parcelHelpers.exportAll(_deleteQueryDefinitionCommand, exports);
var _deleteResourcePolicyCommand = require("./commands/DeleteResourcePolicyCommand");
parcelHelpers.exportAll(_deleteResourcePolicyCommand, exports);
var _deleteRetentionPolicyCommand = require("./commands/DeleteRetentionPolicyCommand");
parcelHelpers.exportAll(_deleteRetentionPolicyCommand, exports);
var _deleteSubscriptionFilterCommand = require("./commands/DeleteSubscriptionFilterCommand");
parcelHelpers.exportAll(_deleteSubscriptionFilterCommand, exports);
var _describeDestinationsCommand = require("./commands/DescribeDestinationsCommand");
parcelHelpers.exportAll(_describeDestinationsCommand, exports);
var _describeDestinationsPaginator = require("./pagination/DescribeDestinationsPaginator");
parcelHelpers.exportAll(_describeDestinationsPaginator, exports);
var _describeExportTasksCommand = require("./commands/DescribeExportTasksCommand");
parcelHelpers.exportAll(_describeExportTasksCommand, exports);
var _describeLogGroupsCommand = require("./commands/DescribeLogGroupsCommand");
parcelHelpers.exportAll(_describeLogGroupsCommand, exports);
var _describeLogGroupsPaginator = require("./pagination/DescribeLogGroupsPaginator");
parcelHelpers.exportAll(_describeLogGroupsPaginator, exports);
var _describeLogStreamsCommand = require("./commands/DescribeLogStreamsCommand");
parcelHelpers.exportAll(_describeLogStreamsCommand, exports);
var _describeLogStreamsPaginator = require("./pagination/DescribeLogStreamsPaginator");
parcelHelpers.exportAll(_describeLogStreamsPaginator, exports);
var _describeMetricFiltersCommand = require("./commands/DescribeMetricFiltersCommand");
parcelHelpers.exportAll(_describeMetricFiltersCommand, exports);
var _describeMetricFiltersPaginator = require("./pagination/DescribeMetricFiltersPaginator");
parcelHelpers.exportAll(_describeMetricFiltersPaginator, exports);
var _describeQueriesCommand = require("./commands/DescribeQueriesCommand");
parcelHelpers.exportAll(_describeQueriesCommand, exports);
var _describeQueryDefinitionsCommand = require("./commands/DescribeQueryDefinitionsCommand");
parcelHelpers.exportAll(_describeQueryDefinitionsCommand, exports);
var _describeResourcePoliciesCommand = require("./commands/DescribeResourcePoliciesCommand");
parcelHelpers.exportAll(_describeResourcePoliciesCommand, exports);
var _describeSubscriptionFiltersCommand = require("./commands/DescribeSubscriptionFiltersCommand");
parcelHelpers.exportAll(_describeSubscriptionFiltersCommand, exports);
var _describeSubscriptionFiltersPaginator = require("./pagination/DescribeSubscriptionFiltersPaginator");
parcelHelpers.exportAll(_describeSubscriptionFiltersPaginator, exports);
var _disassociateKmsKeyCommand = require("./commands/DisassociateKmsKeyCommand");
parcelHelpers.exportAll(_disassociateKmsKeyCommand, exports);
var _filterLogEventsCommand = require("./commands/FilterLogEventsCommand");
parcelHelpers.exportAll(_filterLogEventsCommand, exports);
var _filterLogEventsPaginator = require("./pagination/FilterLogEventsPaginator");
parcelHelpers.exportAll(_filterLogEventsPaginator, exports);
var _getLogEventsCommand = require("./commands/GetLogEventsCommand");
parcelHelpers.exportAll(_getLogEventsCommand, exports);
var _getLogEventsPaginator = require("./pagination/GetLogEventsPaginator");
parcelHelpers.exportAll(_getLogEventsPaginator, exports);
var _getLogGroupFieldsCommand = require("./commands/GetLogGroupFieldsCommand");
parcelHelpers.exportAll(_getLogGroupFieldsCommand, exports);
var _getLogRecordCommand = require("./commands/GetLogRecordCommand");
parcelHelpers.exportAll(_getLogRecordCommand, exports);
var _getQueryResultsCommand = require("./commands/GetQueryResultsCommand");
parcelHelpers.exportAll(_getQueryResultsCommand, exports);
var _listTagsLogGroupCommand = require("./commands/ListTagsLogGroupCommand");
parcelHelpers.exportAll(_listTagsLogGroupCommand, exports);
var _putDestinationCommand = require("./commands/PutDestinationCommand");
parcelHelpers.exportAll(_putDestinationCommand, exports);
var _putDestinationPolicyCommand = require("./commands/PutDestinationPolicyCommand");
parcelHelpers.exportAll(_putDestinationPolicyCommand, exports);
var _putLogEventsCommand = require("./commands/PutLogEventsCommand");
parcelHelpers.exportAll(_putLogEventsCommand, exports);
var _putMetricFilterCommand = require("./commands/PutMetricFilterCommand");
parcelHelpers.exportAll(_putMetricFilterCommand, exports);
var _putQueryDefinitionCommand = require("./commands/PutQueryDefinitionCommand");
parcelHelpers.exportAll(_putQueryDefinitionCommand, exports);
var _putResourcePolicyCommand = require("./commands/PutResourcePolicyCommand");
parcelHelpers.exportAll(_putResourcePolicyCommand, exports);
var _putRetentionPolicyCommand = require("./commands/PutRetentionPolicyCommand");
parcelHelpers.exportAll(_putRetentionPolicyCommand, exports);
var _putSubscriptionFilterCommand = require("./commands/PutSubscriptionFilterCommand");
parcelHelpers.exportAll(_putSubscriptionFilterCommand, exports);
var _startQueryCommand = require("./commands/StartQueryCommand");
parcelHelpers.exportAll(_startQueryCommand, exports);
var _stopQueryCommand = require("./commands/StopQueryCommand");
parcelHelpers.exportAll(_stopQueryCommand, exports);
var _tagLogGroupCommand = require("./commands/TagLogGroupCommand");
parcelHelpers.exportAll(_tagLogGroupCommand, exports);
var _testMetricFilterCommand = require("./commands/TestMetricFilterCommand");
parcelHelpers.exportAll(_testMetricFilterCommand, exports);
var _untagLogGroupCommand = require("./commands/UntagLogGroupCommand");
parcelHelpers.exportAll(_untagLogGroupCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./CloudWatchLogsClient":"i8wCc","./CloudWatchLogs":false,"./commands/AssociateKmsKeyCommand":false,"./commands/CancelExportTaskCommand":false,"./commands/CreateExportTaskCommand":false,"./commands/CreateLogGroupCommand":"8RjO6","./commands/CreateLogStreamCommand":"9C9RJ","./commands/DeleteDestinationCommand":false,"./commands/DeleteLogGroupCommand":false,"./commands/DeleteLogStreamCommand":false,"./commands/DeleteMetricFilterCommand":false,"./commands/DeleteQueryDefinitionCommand":false,"./commands/DeleteResourcePolicyCommand":false,"./commands/DeleteRetentionPolicyCommand":false,"./commands/DeleteSubscriptionFilterCommand":false,"./commands/DescribeDestinationsCommand":false,"./pagination/DescribeDestinationsPaginator":false,"./commands/DescribeExportTasksCommand":false,"./commands/DescribeLogGroupsCommand":"6i2Hb","./pagination/DescribeLogGroupsPaginator":false,"./commands/DescribeLogStreamsCommand":"ceYdg","./pagination/DescribeLogStreamsPaginator":false,"./commands/DescribeMetricFiltersCommand":false,"./pagination/DescribeMetricFiltersPaginator":false,"./commands/DescribeQueriesCommand":false,"./commands/DescribeQueryDefinitionsCommand":false,"./commands/DescribeResourcePoliciesCommand":false,"./commands/DescribeSubscriptionFiltersCommand":false,"./pagination/DescribeSubscriptionFiltersPaginator":false,"./commands/DisassociateKmsKeyCommand":false,"./commands/FilterLogEventsCommand":false,"./pagination/FilterLogEventsPaginator":false,"./commands/GetLogEventsCommand":"78xAw","./pagination/GetLogEventsPaginator":false,"./commands/GetLogGroupFieldsCommand":false,"./commands/GetLogRecordCommand":false,"./commands/GetQueryResultsCommand":false,"./commands/ListTagsLogGroupCommand":false,"./commands/PutDestinationCommand":false,"./commands/PutDestinationPolicyCommand":false,"./commands/PutLogEventsCommand":"kEN1N","./commands/PutMetricFilterCommand":false,"./commands/PutQueryDefinitionCommand":false,"./commands/PutResourcePolicyCommand":false,"./commands/PutRetentionPolicyCommand":false,"./commands/PutSubscriptionFilterCommand":false,"./commands/StartQueryCommand":false,"./commands/StopQueryCommand":false,"./commands/TagLogGroupCommand":false,"./commands/TestMetricFilterCommand":false,"./commands/UntagLogGroupCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8wCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudWatchLogsClient", function() {
    return CloudWatchLogsClient;
});
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>You can use Amazon CloudWatch Logs to monitor, store, and access your log files from
 *       EC2 instances, AWS CloudTrail, or other sources. You can then retrieve the associated
 *       log data from CloudWatch Logs using the CloudWatch console, CloudWatch Logs commands in the
 *       AWS CLI, CloudWatch Logs API, or CloudWatch Logs SDK.</p>
 *          <p>You can use CloudWatch Logs to:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <b>Monitor logs from EC2 instances in real-time</b>: You
 *           can use CloudWatch Logs to monitor applications and systems using log data. For example,
 *           CloudWatch Logs can track the number of errors that occur in your application logs and
 *           send you a notification whenever the rate of errors exceeds a threshold that you specify.
 *           CloudWatch Logs uses your log data for monitoring so no code changes are required. For
 *           example, you can monitor application logs for specific literal terms (such as
 *           "NullReferenceException") or count the number of occurrences of a literal term at a
 *           particular position in log data (such as "404" status codes in an Apache access log). When
 *           the term you are searching for is found, CloudWatch Logs reports the data to a CloudWatch
 *           metric that you specify.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Monitor AWS CloudTrail logged events</b>: You can
 *           create alarms in CloudWatch and receive notifications of particular API activity as
 *           captured by CloudTrail. You can use the notification to perform troubleshooting.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Archive log data</b>: You can use CloudWatch Logs to
 *           store your log data in highly durable storage. You can change the log retention setting so
 *           that any log events older than this setting are automatically deleted. The CloudWatch Logs
 *           agent makes it easy to quickly send both rotated and non-rotated log data off of a host
 *           and into the log service. You can then access the raw log data when you need it.</p>
 *             </li>
 *          </ul>
 */ var CloudWatchLogsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(CloudWatchLogsClient, _super);
    function CloudWatchLogsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    CloudWatchLogsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CloudWatchLogsClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"6vI83","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6vI83":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", function() {
    return ClientDefaultValues;
});
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function credentialDefaultProvider(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"1aR25","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"8HQZt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1aR25":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-cloudwatch-logs\",\"description\":\"AWS SDK for JavaScript Cloudwatch Logs Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test\":\"exit 0\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cloudwatch-logs\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-cloudwatch-logs\"}}");

},{}],"cEl0z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("62ec12493516a334");
(0, tslib_1.__exportStar)(require("e099a4a7ffb231f5"), exports);
var ie11Sha256_1 = require("de15e02776b0e316");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function get() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("8c4446d1ab49a729");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function get() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"62ec12493516a334":"d2ymI","e099a4a7ffb231f5":"tOtTN","de15e02776b0e316":"kytpI","8c4446d1ab49a729":"kyDUK"}],"d2ymI":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tOtTN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("a7f146ad1f3cbfc1");
var webCryptoSha256_1 = require("725c2de9fef54f64");
var sha256_js_1 = require("acd71c1991c101d8");
var supports_web_crypto_1 = require("b78851f350642902");
var ie11_detection_1 = require("d3a26cad479a1048");
var util_locate_window_1 = require("cb5027cfddf0ae5a");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"a7f146ad1f3cbfc1":"kytpI","725c2de9fef54f64":"kyDUK","acd71c1991c101d8":"1pg4I","b78851f350642902":"g0Ghc","d3a26cad479a1048":"gJG7X","cb5027cfddf0ae5a":"ljvil"}],"kytpI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("d8dc3989d6db06cb");
var constants_1 = require("d71db60dd455789b");
var util_utf8_browser_1 = require("b2a4d6e137ed6620");
var util_locate_window_1 = require("fb05deefe8f5231");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"d8dc3989d6db06cb":"eRP7L","d71db60dd455789b":"afoh6","b2a4d6e137ed6620":"iZmxX","fb05deefe8f5231":"ljvil"}],"eRP7L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"afoh6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"ljvil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locateWindow", function() {
    return locateWindow;
});
var fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return fallbackWindow;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kyDUK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("fd29082ab97241f2");
var constants_1 = require("a96b793b8f5ad16");
var util_locate_window_1 = require("3b3155587be8430d");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"fd29082ab97241f2":"1R05H","a96b793b8f5ad16":"afoh6","3b3155587be8430d":"ljvil"}],"g0Ghc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("77b6e702e4b0428a");
tslib_1.__exportStar(require("150bdc65f19f6fe8"), exports);

},{"77b6e702e4b0428a":"g9b8h","150bdc65f19f6fe8":"36D44"}],"g9b8h":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"36D44":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("d9d4edfd7f160da1");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && (0, _typeOf._)(window.crypto.subtle) === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" && (0, _typeOf._)(window.crypto) === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"@swc/helpers/_/_type_of":"668P4","d9d4edfd7f160da1":"g9b8h"}],"gJG7X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("349d4ad1a84f9391");
tslib_1.__exportStar(require("21db5ac52614a3fc"), exports);
tslib_1.__exportStar(require("d258f06221e01140"), exports);
tslib_1.__exportStar(require("ffb697f6ff78bfa1"), exports);
tslib_1.__exportStar(require("84552afc7d264010"), exports);
tslib_1.__exportStar(require("14b671c7aac632d"), exports);

},{"349d4ad1a84f9391":"4eh7s","21db5ac52614a3fc":"1ppqY","d258f06221e01140":"8zSRZ","ffb697f6ff78bfa1":"84MMK","84552afc7d264010":"7Y1ON","14b671c7aac632d":"6xkTm"}],"4eh7s":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ppqY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"8zSRZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"84MMK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"7Y1ON":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"6xkTm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"lTbku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"hgriS","./stream-collector":"irsLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hgriS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", function() {
    return FetchHttpHandler;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, _querystringBuilder.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _$_a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_$_a = _b.return)) _$_a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, _protocolHttp.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, _protocolHttp.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

},{"tslib":"fMoho","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/querystring-builder":"4emBh","./request-timeout":"5eapE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMoho":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bfGiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpResponse":"foxxV","./httpRequest":"28uGN","./httpHandler":"NqDLG","./isValidHostname":"iKte5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"foxxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28uGN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"dxGSc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxGSc":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"NqDLG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iKte5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4emBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", function() {
    return buildQueryString;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, _utilUriEscape.escapeUri)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, _utilUriEscape.escapeUri)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"6XdAl","@aws-sdk/util-uri-escape":"ZXyQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6XdAl":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ZXyQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"7x4pk","./escape-uri-path":"aAhtl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7x4pk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", function() {
    return escapeUri;
});
var escapeUri = function escapeUri(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aAhtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", function() {
    return escapeUriPath;
});
var _escapeUri = require("./escape-uri");
var escapeUriPath = function escapeUriPath(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"7x4pk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5eapE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", function() {
    return requestTimeout;
});
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irsLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", function() {
    return streamCollector;
});
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function streamCollector(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"fMoho","@aws-sdk/util-base64-browser":"kTMBh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kTMBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a base-64 encoded string to a Uint8Array of bytes.
 *
 * @param input The base-64 encoded string
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "fromBase64", function() {
    return fromBase64;
});
/**
 * Converts a Uint8Array of binary data to a base-64 encoded string.
 *
 * @param input The binary data to encode
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "toBase64", function() {
    return toBase64;
});
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iUhkq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"8nmMY","./invalidProvider":"5mTWt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nmMY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", function() {
    return invalidFunction;
});
var invalidFunction = function invalidFunction(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5mTWt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", function() {
    return invalidProvider;
});
var invalidProvider = function invalidProvider(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"822il":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _defaultStrategy = require("./defaultStrategy");
parcelHelpers.exportAll(_defaultStrategy, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);

},{"./retryMiddleware":"fKUIX","./omitRetryHeadersMiddleware":"af8k9","./defaultStrategy":"7PTol","./configurations":"4nYBT","./delayDecider":"eeqB6","./retryDecider":"3t0qz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKUIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return retryMiddleware;
});
parcelHelpers.export(exports, "retryMiddlewareOptions", function() {
    return retryMiddlewareOptions;
});
parcelHelpers.export(exports, "getRetryPlugin", function() {
    return getRetryPlugin;
});
var _tslib = require("tslib");
var retryMiddleware = function retryMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, _tslib.__spread)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function getRetryPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"9kFzn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9kFzn":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"af8k9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", function() {
    return omitRetryHeadersMiddleware;
});
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", function() {
    return omitRetryHeadersMiddlewareOptions;
});
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", function() {
    return getOmitRetryHeadersPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function omitRetryHeadersMiddleware() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function getOmitRetryHeadersPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"9kFzn","@aws-sdk/protocol-http":"bfGiN","./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"co8Un":[function(require,module,exports,__globalThis) {
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", function() {
    return DEFAULT_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", function() {
    return MAXIMUM_RETRY_DELAY;
});
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", function() {
    return THROTTLING_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", function() {
    return INITIAL_RETRY_TOKENS;
});
parcelHelpers.export(exports, "RETRY_COST", function() {
    return RETRY_COST;
});
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", function() {
    return TIMEOUT_RETRY_COST;
});
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", function() {
    return NO_RETRY_INCREMENT;
});
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", function() {
    return INVOCATION_ID_HEADER;
});
parcelHelpers.export(exports, "REQUEST_HEADER", function() {
    return REQUEST_HEADER;
});
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7PTol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", function() {
    return DEFAULT_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", function() {
    return DEFAULT_RETRY_MODE;
});
parcelHelpers.export(exports, "StandardRetryStrategy", function() {
    return StandardRetryStrategy;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = "standard";
var StandardRetryStrategy = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = DEFAULT_RETRY_MODE;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = DEFAULT_MAX_ATTEMPTS;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function _loop_1() {
                            var _$_a, response, output, err_1, delay_1;
                            return (0, _tslib.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _$_a = _b.sent(), response = _$_a.response, output = _$_a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err_1) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if ((typeof state_1 === "undefined" ? "undefined" : (0, _typeOf._)(state_1)) === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();

},{"@swc/helpers/_/_type_of":"668P4","tslib":"9kFzn","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/service-error-classification":"iFCvv","uuid":"bvm5J","./constants":"co8Un","./defaultRetryQuota":"kbRba","./delayDecider":"eeqB6","./retryDecider":"3t0qz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFCvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", function() {
    return isRetryableByTrait;
});
parcelHelpers.export(exports, "isClockSkewError", function() {
    return isClockSkewError;
});
parcelHelpers.export(exports, "isThrottlingError", function() {
    return isThrottlingError;
});
parcelHelpers.export(exports, "isTransientError", function() {
    return isTransientError;
});
var _constants = require("./constants");
var isRetryableByTrait = function isRetryableByTrait(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function isClockSkewError(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function isThrottlingError(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function isTransientError(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"aefPg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aefPg":[function(require,module,exports,__globalThis) {
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", function() {
    return CLOCK_SKEW_ERROR_CODES;
});
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", function() {
    return THROTTLING_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", function() {
    return TRANSIENT_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", function() {
    return TRANSIENT_ERROR_STATUS_CODES;
});
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bvm5J":[function(require,module,exports,__globalThis) {
var v1 = require("c6df88204e1f4299");
var v4 = require("3855f0864044f01d");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"c6df88204e1f4299":"iOYTH","3855f0864044f01d":"efGBG"}],"iOYTH":[function(require,module,exports,__globalThis) {
var rng = require("3d2d1ae5ae56a8b5");
var bytesToUuid = require("862e80dd3f0567cf");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"3d2d1ae5ae56a8b5":"kRNvg","862e80dd3f0567cf":"5BPJs"}],"kRNvg":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"5BPJs":[function(require,module,exports,__globalThis) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = bytesToUuid;

},{}],"efGBG":[function(require,module,exports,__globalThis) {
var rng = require("24932e89aef21842");
var bytesToUuid = require("5cc20217cefb381c");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"24932e89aef21842":"kRNvg","5cc20217cefb381c":"5BPJs"}],"kbRba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", function() {
    return getDefaultRetryQuota;
});
var _constants = require("./constants");
var getDefaultRetryQuota = function getDefaultRetryQuota(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function getCapacityAmount(error) {
        return error.name === "TimeoutError" ? (0, _constants.TIMEOUT_RETRY_COST) : (0, _constants.RETRY_COST);
    };
    var hasRetryTokens = function hasRetryTokens(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function retrieveRetryTokens(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function releaseRetryTokens(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, _constants.NO_RETRY_INCREMENT);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eeqB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", function() {
    return defaultDelayDecider;
});
var _constants = require("./constants");
var defaultDelayDecider = function defaultDelayDecider(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3t0qz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", function() {
    return defaultRetryDecider;
});
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function defaultRetryDecider(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"iFCvv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4nYBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", function() {
    return ENV_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", function() {
    return CONFIG_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", function() {
    return NODE_MAX_ATTEMPT_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "resolveRetryConfig", function() {
    return resolveRetryConfig;
});
parcelHelpers.export(exports, "ENV_RETRY_MODE", function() {
    return ENV_RETRY_MODE;
});
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", function() {
    return CONFIG_RETRY_MODE;
});
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", function() {
    return NODE_RETRY_MODE_CONFIG_OPTIONS;
});
var _tslib = require("tslib");
var _defaultStrategy = require("./defaultStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + ENV_MAX_ATTEMPTS + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    configFileSelector: function configFileSelector(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + CONFIG_MAX_ATTEMPTS + " mast be a number, got \"" + value + "\"");
        return maxAttempt;
    },
    default: (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function resolveRetryConfig(input) {
    var maxAttempts = normalizeMaxAttempts(input.maxAttempts);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, _defaultStrategy.StandardRetryStrategy)(maxAttempts)
    });
};
var normalizeMaxAttempts = function normalizeMaxAttempts(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _defaultStrategy.DEFAULT_RETRY_MODE)
};

},{"tslib":"9kFzn","./defaultStrategy":"7PTol","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jY9Ci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", function() {
    return calculateBodyLength;
});
function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ohFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", function() {
    return defaultUserAgent;
});
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function defaultUserAgent(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _$_a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_$_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _$_a === void 0 ? void 0 : _$_a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"3yM1h","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3yM1h":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"E5jm7":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
!function(e, t) {
    module.exports = t();
}(undefined, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var _$r = t.match(e);
                    return _$r && _$r.length > 0 && _$r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var _$r = t.match(e);
                    return _$r && _$r.length > 1 && _$r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var _$t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (_$t.push(0), 10 === _$t[0]) switch(_$t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var _$t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (_$t.push(0), !(1 === _$t[0] && _$t[1] < 5)) return 1 === _$t[0] && _$t[1] < 6 ? "Cupcake" : 1 === _$t[0] && _$t[1] >= 6 ? "Donut" : 2 === _$t[0] && _$t[1] < 2 ? "Eclair" : 2 === _$t[0] && 2 === _$t[1] ? "Froyo" : 2 === _$t[0] && _$t[1] > 2 ? "Gingerbread" : 3 === _$t[0] ? "Honeycomb" : 4 === _$t[0] && _$t[1] < 1 ? "Ice Cream Sandwich" : 4 === _$t[0] && _$t[1] < 4 ? "Jelly Bean" : 4 === _$t[0] && _$t[1] >= 4 ? "KitKat" : 5 === _$t[0] ? "Lollipop" : 6 === _$t[0] ? "Marshmallow" : 7 === _$t[0] ? "Nougat" : 8 === _$t[0] ? "Oreo" : 9 === _$t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var _$r = a - e.getVersionPrecision(t), _$n = t + new Array(_$r + 1).join(".0");
                        return e.map(_$n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var _$r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(_$r = 0; _$r < e.length; _$r += 1)n.push(t(e[_$r]));
                    return n;
                }, e.find = function(e, t) {
                    var _$r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(_$r = 0, n = e.length; _$r < n; _$r += 1){
                        var i = e[_$r];
                        if (t(i, _$r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var _$t, _$r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function o() {
                        var _$e = s[_$t];
                        "object" == (typeof _$e === "undefined" ? "undefined" : (0, _typeOf._)(_$e)) && null !== _$e && Object.keys(_$e).forEach(function(t) {
                            n[t] = _$e[t];
                        });
                    };
                    for(_$t = 0, _$r = s.length; _$t < _$r; _$t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var _$r = 0; _$r < t.length; _$r++){
                    var n = t[_$r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var _$t, _$r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, _$t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function get() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function get() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function get() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function get() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], _$r = null, n && a(_$t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var _$t = e.prototype;
                return _$t.getUA = function() {
                    return this._ua;
                }, _$t.test = function(e) {
                    return e.test(this._ua);
                }, _$t.parseBrowser = function() {
                    var _$e = this;
                    this.parsedResult.browser = {};
                    var _$t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(_$e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return _$e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return _$t && (this.parsedResult.browser = _$t.describe(this.getUA())), this.parsedResult.browser;
                }, _$t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, _$t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, _$t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, _$t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, _$t.parseOS = function() {
                    var _$e = this;
                    this.parsedResult.os = {};
                    var _$t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(_$e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return _$e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return _$t && (this.parsedResult.os = _$t.describe(this.getUA())), this.parsedResult.os;
                }, _$t.getOSName = function(e) {
                    var _$t = this.getOS().name;
                    return e ? String(_$t).toLowerCase() || "" : _$t || "";
                }, _$t.getOSVersion = function() {
                    return this.getOS().version;
                }, _$t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, _$t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var _$t = this.getPlatform().type;
                    return e ? String(_$t).toLowerCase() || "" : _$t || "";
                }, _$t.parsePlatform = function() {
                    var _$e = this;
                    this.parsedResult.platform = {};
                    var _$t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(_$e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return _$e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return _$t && (this.parsedResult.platform = _$t.describe(this.getUA())), this.parsedResult.platform;
                }, _$t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, _$t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, _$t.parseEngine = function() {
                    var _$e = this;
                    this.parsedResult.engine = {};
                    var _$t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(_$e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return _$e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return _$t && (this.parsedResult.engine = _$t.describe(this.getUA())), this.parsedResult.engine;
                }, _$t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, _$t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, _$t.satisfies = function(e) {
                    var _$t = this, _$r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && (_$r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(_$r), _$u = o.default.find(a, function(e) {
                            return _$t.isOS(e);
                        });
                        if (_$u) {
                            var d = this.satisfies(_$r[_$u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return _$t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(_$r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return _$t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, _$t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var _$r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === _$r;
                }, _$t.compareVersion = function(e) {
                    var _$t = [
                        0
                    ], _$r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (_$r = e.substr(1), "=" === e[1] ? (n = !0, _$r = e.substr(2)) : _$t = [], ">" === e[0] ? _$t.push(1) : _$t.push(-1)) : "=" === e[0] ? _$r = e.substr(1) : "~" === e[0] && (n = !0, _$r = e.substr(1)), _$t.indexOf(o.default.compareVersions(i, _$r, n)) > -1;
                }, _$t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, _$t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, _$t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, _$t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, _$t.some = function(e) {
                    var _$t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return _$t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Googlebot"
                        }, _$r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Opera"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Opera"
                        }, _$r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Samsung Internet for Android"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "NAVER Whale Browser"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "MZ Browser"
                        }, _$r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Focus"
                        }, _$r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Swing"
                        }, _$r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Opera Coast"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Opera Touch"
                        }, _$r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Yandex Browser"
                        }, _$r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "UC Browser"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Maxthon"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Epiphany"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Puffin"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Sleipnir"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "K-Meleon"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "WeChat"
                        }, _$r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, _$r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Internet Explorer"
                        }, _$r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Microsoft Edge"
                        }, _$r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Microsoft Edge"
                        }, _$r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Vivaldi"
                        }, _$r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "SeaMonkey"
                        }, _$r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Sailfish"
                        }, _$r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Amazon Silk"
                        }, _$r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "PhantomJS"
                        }, _$r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "SlimerJS"
                        }, _$r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "BlackBerry"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "WebOS Browser"
                        }, _$r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Bada"
                        }, _$r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Tizen"
                        }, _$r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "QupZilla"
                        }, _$r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Firefox"
                        }, _$r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Electron"
                        }, _$r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Miui"
                        }, _$r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Chromium"
                        }, _$r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Chrome"
                        }, _$r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Google Search"
                        }, _$r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: function test(e) {
                        var _$t = !e.test(/like android/i), _$r = e.test(/android/i);
                        return _$t && _$r;
                    },
                    describe: function describe(e) {
                        var _$t = {
                            name: "Android Browser"
                        }, _$r = i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "PlayStation 4"
                        }, _$r = i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: "Safari"
                        }, _$r = i.default.getFirstMatch(s, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function describe(e) {
                        var _$t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(_$t, e),
                            version: i.default.getSecondMatch(_$t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), _$r = i.default.getWindowsVersionName(_$t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: _$t,
                            versionName: _$r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: s.OS_MAP.iOS
                        }, _$r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), _$r = i.default.getMacOSVersionName(_$t), n = {
                            name: s.OS_MAP.MacOS,
                            version: _$t
                        };
                        return _$r && (n.versionName = _$r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: _$t
                        };
                    }
                },
                {
                    test: function test(e) {
                        var _$t = !e.test(/like android/i), _$r = e.test(/android/i);
                        return _$t && _$r;
                    },
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), _$r = i.default.getAndroidVersionName(_$t), n = {
                            name: s.OS_MAP.Android,
                            version: _$t
                        };
                        return _$r && (n.versionName = _$r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), _$r = {
                            name: s.OS_MAP.WebOS
                        };
                        return _$t && _$t.length && (_$r.version = _$t), _$r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function describe() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function describe() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: _$t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function describe() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", _$r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return _$t && (_$r.model = _$t), _$r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function test(e) {
                        var _$t = e.test(/ipod|iphone/i), _$r = e.test(/like (ipod|iphone)/i);
                        return _$t && !_$r;
                    },
                    describe: function describe(e) {
                        var _$t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: _$t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function test(e) {
                        var _$t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && _$t >= 3;
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function test(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function describe() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function test(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function describe(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var _$t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: _$t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: s.ENGINE_MAP.Trident
                        }, _$r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: function test(e) {
                        return e.test(/presto/i);
                    },
                    describe: function describe(e) {
                        var _$t = {
                            name: s.ENGINE_MAP.Presto
                        }, _$r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: function test(e) {
                        var _$t = e.test(/gecko/i), _$r = e.test(/like gecko/i);
                        return _$t && !_$r;
                    },
                    describe: function describe(e) {
                        var _$t = {
                            name: s.ENGINE_MAP.Gecko
                        }, _$r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function describe() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function describe(e) {
                        var _$t = {
                            name: s.ENGINE_MAP.WebKit
                        }, _$r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return _$r && (_$t.version = _$r), _$t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

},{"@swc/helpers/_/_type_of":"668P4"}],"8HQZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", function() {
    return ClientSharedValues;
});
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2014-03-28",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "CloudWatch Logs",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"7Nxeq","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Nxeq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "logs.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "logs.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "logs.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "logs.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "logs.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "logs.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "logs.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "logs.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "logs.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "logs.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "logs.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "logs.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "logs.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "logs.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "logs.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "logs.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "logs.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "logs.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "logs.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "logs.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "logs-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "logs-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "logs-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "logs-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "logs.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "logs.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "logs.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "logs.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "logs.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "logs.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "logs.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "logs.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "logs.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "logs.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "logs"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3j6kE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function parseUrl(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"2AIKk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2AIKk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", function() {
    return parseQueryString;
});
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"5ZoIK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ZoIK":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kfZQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./EndpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./RegionConfig");
parcelHelpers.exportAll(_regionConfig, exports);

},{"./EndpointsConfig":"aLbhN","./RegionConfig":"litQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aLbhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", function() {
    return resolveEndpointsConfig;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var resolveEndpointsConfig = function resolveEndpointsConfig(input) {
    var _a;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? normalizeEndpoint(input) : function() {
            return getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var normalizeEndpoint = function normalizeEndpoint(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if ((typeof endpoint === "undefined" ? "undefined" : (0, _typeOf._)(endpoint)) === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var getEndPointFromRegion = function getEndPointFromRegion(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"2mqK7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2mqK7":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"litQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", function() {
    return REGION_ENV_NAME;
});
parcelHelpers.export(exports, "REGION_INI_NAME", function() {
    return REGION_INI_NAME;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", function() {
    return NODE_REGION_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", function() {
    return NODE_REGION_CONFIG_FILE_OPTIONS;
});
parcelHelpers.export(exports, "resolveRegionConfig", function() {
    return resolveRegionConfig;
});
var _tslib = require("tslib");
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function _default() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};
var resolveRegionConfig = function resolveRegionConfig(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: normalizeRegion(input.region)
    });
};
var normalizeRegion = function normalizeRegion(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};

},{"tslib":"2mqK7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g0Zhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", function() {
    return contentLengthMiddleware;
});
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", function() {
    return contentLengthMiddlewareOptions;
});
parcelHelpers.export(exports, "getContentLengthPlugin", function() {
    return getContentLengthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function getContentLengthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"al6FD","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"al6FD":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jHFHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", function() {
    return resolveHostHeaderConfig;
});
parcelHelpers.export(exports, "hostHeaderMiddleware", function() {
    return hostHeaderMiddleware;
});
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", function() {
    return hostHeaderMiddlewareOptions;
});
parcelHelpers.export(exports, "getHostHeaderPlugin", function() {
    return getHostHeaderPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function hostHeaderMiddleware(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function getHostHeaderPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"bs2Dn","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bs2Dn":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dyXzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"dLrTw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dLrTw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", function() {
    return loggerMiddleware;
});
parcelHelpers.export(exports, "loggerMiddlewareOptions", function() {
    return loggerMiddlewareOptions;
});
parcelHelpers.export(exports, "getLoggerPlugin", function() {
    return getLoggerPlugin;
});
var _tslib = require("tslib");
var loggerMiddleware = function loggerMiddleware() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function getLoggerPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"cMvRZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMvRZ":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"chM5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"kLesP","./middleware":"dviJz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kLesP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", function() {
    return resolveAwsAuthConfig;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _signatureV4 = require("@aws-sdk/signature-v4");
function resolveAwsAuthConfig(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function signer() {
        return normalizeProvider(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, _signatureV4.SignatureV4)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function normalizeProvider(input) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"cRT7q","@aws-sdk/signature-v4":"3LPO6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cRT7q":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LPO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);

},{"./credentialDerivation":"gA2T8","./SignatureV4":"1MViS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gA2T8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */ parcelHelpers.export(exports, "createScope", function() {
    return createScope;
});
parcelHelpers.export(exports, "getSigningKey", function() {
    return getSigningKey;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "clearCredentialCache", function() {
    return clearCredentialCache;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
function createScope(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, _constants.KEY_TYPE_IDENTIFIER);
}
var getSigningKey = function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, _utilHexEncoding.toHex)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in signingKeyCache) return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
}
function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

},{"tslib":"gTWgQ","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gTWgQ":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1UGiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", function() {
    return ALGORITHM_QUERY_PARAM;
});
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", function() {
    return CREDENTIAL_QUERY_PARAM;
});
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", function() {
    return AMZ_DATE_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", function() {
    return SIGNED_HEADERS_QUERY_PARAM;
});
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", function() {
    return EXPIRES_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", function() {
    return SIGNATURE_QUERY_PARAM;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "AUTH_HEADER", function() {
    return AUTH_HEADER;
});
parcelHelpers.export(exports, "AMZ_DATE_HEADER", function() {
    return AMZ_DATE_HEADER;
});
parcelHelpers.export(exports, "DATE_HEADER", function() {
    return DATE_HEADER;
});
parcelHelpers.export(exports, "GENERATED_HEADERS", function() {
    return GENERATED_HEADERS;
});
parcelHelpers.export(exports, "SIGNATURE_HEADER", function() {
    return SIGNATURE_HEADER;
});
parcelHelpers.export(exports, "SHA256_HEADER", function() {
    return SHA256_HEADER;
});
parcelHelpers.export(exports, "TOKEN_HEADER", function() {
    return TOKEN_HEADER;
});
parcelHelpers.export(exports, "HOST_HEADER", function() {
    return HOST_HEADER;
});
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", function() {
    return ALWAYS_UNSIGNABLE_HEADERS;
});
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", function() {
    return PROXY_HEADER_PATTERN;
});
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", function() {
    return SEC_HEADER_PATTERN;
});
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", function() {
    return UNSIGNABLE_PATTERNS;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", function() {
    return ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", function() {
    return EVENT_ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", function() {
    return UNSIGNED_PAYLOAD;
});
parcelHelpers.export(exports, "MAX_CACHE_SIZE", function() {
    return MAX_CACHE_SIZE;
});
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", function() {
    return KEY_TYPE_IDENTIFIER;
});
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", function() {
    return MAX_PRESIGNED_TTL;
});
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1MViS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", function() {
    return SignatureV4;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _hasHeader = require("./hasHeader");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = normalizeRegionProvider(region);
        this.credentialProvider = normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = credentials.accessKeyId + "/" + scope;
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _hasHeader.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = (0, _constants.ALGORITHM_IDENTIFIER) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, _getCanonicalQuery.getCanonicalQuery)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, _constants.ALGORITHM_IDENTIFIER) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, _utilHexEncoding.toHex)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var formatDate = function formatDate(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var getCanonicalHeaderList = function getCanonicalHeaderList(headers) {
    return Object.keys(headers).sort().join(";");
};
var normalizeRegionProvider = function normalizeRegionProvider(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var normalizeCredentialsProvider = function normalizeCredentialsProvider(credentials) {
    if ((typeof credentials === "undefined" ? "undefined" : (0, _typeOf._)(credentials)) === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"gTWgQ","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","./credentialDerivation":"gA2T8","./getCanonicalHeaders":"3fcRk","./getCanonicalQuery":"6bGAS","./getPayloadHash":"3dDIV","./hasHeader":"5Atvk","./moveHeadersToQuery":"lsriS","./prepareRequest":"lxoo5","./utilDate":"6CtpL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fcRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return getCanonicalHeaders;
});
var _tslib = require("tslib");
var _constants = require("./constants");
function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}

},{"tslib":"gTWgQ","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6bGAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return getCanonicalQuery;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function _loop_1(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}

},{"tslib":"gTWgQ","@aws-sdk/util-uri-escape":"ZXyQp","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3dDIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getPayloadHash", function() {
    return getPayloadHash;
});
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
}

},{"tslib":"gTWgQ","@aws-sdk/is-array-buffer":"jH4ux","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jH4ux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", function() {
    return isArrayBuffer;
});
var isArrayBuffer = function isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Atvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", function() {
    return hasHeader;
});
var _tslib = require("tslib");
function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

},{"tslib":"gTWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lsriS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return moveHeadersToQuery;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
}

},{"tslib":"gTWgQ","./cloneRequest":"b3SzD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b3SzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "cloneRequest", function() {
    return cloneRequest;
});
var _tslib = require("tslib");
function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
}
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"tslib":"gTWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lxoo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "prepareRequest", function() {
    return prepareRequest;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
function prepareRequest(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}

},{"tslib":"gTWgQ","./cloneRequest":"b3SzD","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6CtpL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", function() {
    return iso8601;
});
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dviJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", function() {
    return awsAuthMiddleware;
});
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", function() {
    return awsAuthMiddlewareOptions;
});
parcelHelpers.export(exports, "getAwsAuthPlugin", function() {
    return getAwsAuthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var isClockSkewed = function isClockSkewed(newServerTime, systemClockOffset) {
    return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if (isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function getAwsAuthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};

},{"tslib":"cRT7q","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kIyUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"2QXGp","./user-agent-middleware":"dvaiR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2QXGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", function() {
    return resolveUserAgentConfig;
});
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"eqDkx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eqDkx":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dvaiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return userAgentMiddleware;
});
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", function() {
    return getUserAgentMiddlewareOptions;
});
parcelHelpers.export(exports, "getUserAgentPlugin", function() {
    return getUserAgentPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function userAgentMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function escapeUserAgent(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function getUserAgentPlugin(config) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"eqDkx","@aws-sdk/protocol-http":"bfGiN","./constants":"h3KjP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h3KjP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", function() {
    return USER_AGENT;
});
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", function() {
    return X_AMZ_USER_AGENT;
});
parcelHelpers.export(exports, "SPACE", function() {
    return SPACE;
});
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", function() {
    return UA_ESCAPE_REGEX;
});
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6UNh4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _documentType = require("./document-type");
parcelHelpers.exportAll(_documentType, exports);
var _exception = require("./exception");
parcelHelpers.exportAll(_exception, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _retryableTrait = require("./retryable-trait");
parcelHelpers.exportAll(_retryableTrait, exports);
var _sdkError = require("./sdk-error");
parcelHelpers.exportAll(_sdkError, exports);

},{"./client":"cld3U","./command":"4ml49","./document-type":"eOcGT","./exception":"2qkZF","./extended-encode-uri-component":"boRvB","./get-array-if-single-item":"gPMPO","./get-value-from-text-node":"lCOpr","./lazy-json":"cnq16","./date-utils":"c5TbK","./split-every":"dmF0m","./constants":"ld9uE","./retryable-trait":"bSQ1d","./sdk-error":"bLYLt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cld3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"jfbQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jfbQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"6f5BJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6f5BJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", function() {
    return constructStack;
});
var _tslib = require("tslib");
var constructStack = function constructStack1() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function sort(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function removeByName(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function removeByReference(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function cloneTo(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function expandRelativeMiddlewareList1(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function getMiddlewareList() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, _tslib.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function add(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"" + name + "\" middleware with " + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function addRelativeTo(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"" + name + "\" middleware " + toOverride.relation + " \"" + toOverride.toMiddleware + "\" middleware cannot be overridden " + ("by same-name middleware " + entry.relation + " \"" + entry.toMiddleware + "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function clone() {
            return cloneTo(constructStack());
        },
        use: function use(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function remove(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function removeByTag(toRemove) {
            var isRemoved = false;
            var filterCb = function filterCb(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function concat(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function resolve(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"4ZbuQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ZbuQ":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ml49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", function() {
    return Command;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"jfbQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eOcGT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2qkZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boRvB":[function(require,module,exports,__globalThis) {
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return extendedEncodeURIComponent;
});
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gPMPO":[function(require,module,exports,__globalThis) {
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", function() {
    return getArrayIfSingleItem;
});
var getArrayIfSingleItem = function getArrayIfSingleItem(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lCOpr":[function(require,module,exports,__globalThis) {
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", function() {
    return getValueFromTextNode;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var getValueFromTextNode = function getValueFromTextNode1(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if ((0, _typeOf._)(obj[key]) === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cnq16":[function(require,module,exports,__globalThis) {
/**
 * Lazy String holder for JSON typed contents.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", function() {
    return StringWrapper;
});
parcelHelpers.export(exports, "LazyJsonString", function() {
    return LazyJsonString;
});
var _tslib = require("tslib");
var StringWrapper = function StringWrapper() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = /** @class */ function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"d1ysp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d1ysp":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5TbK":[function(require,module,exports,__globalThis) {
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", function() {
    return dateToUtcString;
});
var days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return days[dayOfWeek] + ", " + dayOfMonthString + " " + months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dmF0m":[function(require,module,exports,__globalThis) {
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", function() {
    return splitEvery;
});
function splitEvery(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ld9uE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", function() {
    return SENSITIVE_STRING;
});
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bSQ1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bLYLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8RjO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogGroupCommand", function() {
    return CreateLogGroupCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log group with the specified name. You can create up to 20,000 log groups per account.</p>
 *          <p>You must use the following guidelines when naming a log group:</p>
 *          <ul>
 *             <li>
 *                <p>Log group names must be unique within a region for an AWS account.</p>
 *             </li>
 *             <li>
 *                <p>Log group names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>Log group names consist of the following characters: a-z, A-Z, 0-9, '_' (underscore), '-' (hyphen),
 *           '/' (forward slash), '.' (period), and '#' (number sign)</p>
 *             </li>
 *          </ul>
 *          <p>When you create a log group, by default the log events in the log group never expire. To set
 *     a retention policy so that events expire and are deleted after a specified time, use
 *       <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutRetentionPolicy.html">PutRetentionPolicy</a>.</p>
 *          <p>If you associate a AWS Key Management Service (AWS KMS) customer master key (CMK) with the log group, ingested data is encrypted using the CMK.
 *       This association is stored as long as the data encrypted with the CMK is still within Amazon CloudWatch Logs.
 *       This enables Amazon CloudWatch Logs to decrypt this data whenever it is requested.</p>
 *          <p>If you attempt to associate a CMK with the log group but the CMK does not exist or the
 *       CMK is disabled, you receive an <code>InvalidParameterException</code> error. </p>
 *          <important>
 *             <p> CloudWatch Logs supports only symmetric CMKs. Do not associate an asymmetric CMK with
 *         your log group. For more information, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric
 *           Keys</a>.</p>
 *          </important>
 */ var CreateLogGroupCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogGroupCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogGroupCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogGroupRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function outputFilterSensitiveLog(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogGroupCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogGroupCommand)(input, context);
    };
    CreateLogGroupCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogGroupCommand)(output, context);
    };
    return CreateLogGroupCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZkQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssociateKmsKeyRequest", function() {
    return AssociateKmsKeyRequest;
});
parcelHelpers.export(exports, "InvalidParameterException", function() {
    return InvalidParameterException;
});
parcelHelpers.export(exports, "OperationAbortedException", function() {
    return OperationAbortedException;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "ServiceUnavailableException", function() {
    return ServiceUnavailableException;
});
parcelHelpers.export(exports, "CancelExportTaskRequest", function() {
    return CancelExportTaskRequest;
});
parcelHelpers.export(exports, "InvalidOperationException", function() {
    return InvalidOperationException;
});
parcelHelpers.export(exports, "CreateExportTaskRequest", function() {
    return CreateExportTaskRequest;
});
parcelHelpers.export(exports, "CreateExportTaskResponse", function() {
    return CreateExportTaskResponse;
});
parcelHelpers.export(exports, "LimitExceededException", function() {
    return LimitExceededException;
});
parcelHelpers.export(exports, "ResourceAlreadyExistsException", function() {
    return ResourceAlreadyExistsException;
});
parcelHelpers.export(exports, "CreateLogGroupRequest", function() {
    return CreateLogGroupRequest;
});
parcelHelpers.export(exports, "CreateLogStreamRequest", function() {
    return CreateLogStreamRequest;
});
parcelHelpers.export(exports, "DataAlreadyAcceptedException", function() {
    return DataAlreadyAcceptedException;
});
parcelHelpers.export(exports, "DeleteDestinationRequest", function() {
    return DeleteDestinationRequest;
});
parcelHelpers.export(exports, "DeleteLogGroupRequest", function() {
    return DeleteLogGroupRequest;
});
parcelHelpers.export(exports, "DeleteLogStreamRequest", function() {
    return DeleteLogStreamRequest;
});
parcelHelpers.export(exports, "DeleteMetricFilterRequest", function() {
    return DeleteMetricFilterRequest;
});
parcelHelpers.export(exports, "DeleteQueryDefinitionRequest", function() {
    return DeleteQueryDefinitionRequest;
});
parcelHelpers.export(exports, "DeleteQueryDefinitionResponse", function() {
    return DeleteQueryDefinitionResponse;
});
parcelHelpers.export(exports, "DeleteResourcePolicyRequest", function() {
    return DeleteResourcePolicyRequest;
});
parcelHelpers.export(exports, "DeleteRetentionPolicyRequest", function() {
    return DeleteRetentionPolicyRequest;
});
parcelHelpers.export(exports, "DeleteSubscriptionFilterRequest", function() {
    return DeleteSubscriptionFilterRequest;
});
parcelHelpers.export(exports, "DescribeDestinationsRequest", function() {
    return DescribeDestinationsRequest;
});
parcelHelpers.export(exports, "Destination", function() {
    return Destination;
});
parcelHelpers.export(exports, "DescribeDestinationsResponse", function() {
    return DescribeDestinationsResponse;
});
parcelHelpers.export(exports, "ExportTaskStatusCode", function() {
    return ExportTaskStatusCode;
});
parcelHelpers.export(exports, "DescribeExportTasksRequest", function() {
    return DescribeExportTasksRequest;
});
parcelHelpers.export(exports, "ExportTaskExecutionInfo", function() {
    return ExportTaskExecutionInfo;
});
parcelHelpers.export(exports, "ExportTaskStatus", function() {
    return ExportTaskStatus;
});
parcelHelpers.export(exports, "ExportTask", function() {
    return ExportTask;
});
parcelHelpers.export(exports, "DescribeExportTasksResponse", function() {
    return DescribeExportTasksResponse;
});
parcelHelpers.export(exports, "DescribeLogGroupsRequest", function() {
    return DescribeLogGroupsRequest;
});
parcelHelpers.export(exports, "LogGroup", function() {
    return LogGroup;
});
parcelHelpers.export(exports, "DescribeLogGroupsResponse", function() {
    return DescribeLogGroupsResponse;
});
parcelHelpers.export(exports, "OrderBy", function() {
    return OrderBy;
});
parcelHelpers.export(exports, "DescribeLogStreamsRequest", function() {
    return DescribeLogStreamsRequest;
});
parcelHelpers.export(exports, "LogStream", function() {
    return LogStream;
});
parcelHelpers.export(exports, "DescribeLogStreamsResponse", function() {
    return DescribeLogStreamsResponse;
});
parcelHelpers.export(exports, "DescribeMetricFiltersRequest", function() {
    return DescribeMetricFiltersRequest;
});
parcelHelpers.export(exports, "MetricTransformation", function() {
    return MetricTransformation;
});
parcelHelpers.export(exports, "MetricFilter", function() {
    return MetricFilter;
});
parcelHelpers.export(exports, "DescribeMetricFiltersResponse", function() {
    return DescribeMetricFiltersResponse;
});
parcelHelpers.export(exports, "QueryStatus", function() {
    return QueryStatus;
});
parcelHelpers.export(exports, "DescribeQueriesRequest", function() {
    return DescribeQueriesRequest;
});
parcelHelpers.export(exports, "QueryInfo", function() {
    return QueryInfo;
});
parcelHelpers.export(exports, "DescribeQueriesResponse", function() {
    return DescribeQueriesResponse;
});
parcelHelpers.export(exports, "DescribeQueryDefinitionsRequest", function() {
    return DescribeQueryDefinitionsRequest;
});
parcelHelpers.export(exports, "QueryDefinition", function() {
    return QueryDefinition;
});
parcelHelpers.export(exports, "DescribeQueryDefinitionsResponse", function() {
    return DescribeQueryDefinitionsResponse;
});
parcelHelpers.export(exports, "DescribeResourcePoliciesRequest", function() {
    return DescribeResourcePoliciesRequest;
});
parcelHelpers.export(exports, "ResourcePolicy", function() {
    return ResourcePolicy;
});
parcelHelpers.export(exports, "DescribeResourcePoliciesResponse", function() {
    return DescribeResourcePoliciesResponse;
});
parcelHelpers.export(exports, "DescribeSubscriptionFiltersRequest", function() {
    return DescribeSubscriptionFiltersRequest;
});
parcelHelpers.export(exports, "Distribution", function() {
    return Distribution;
});
parcelHelpers.export(exports, "SubscriptionFilter", function() {
    return SubscriptionFilter;
});
parcelHelpers.export(exports, "DescribeSubscriptionFiltersResponse", function() {
    return DescribeSubscriptionFiltersResponse;
});
parcelHelpers.export(exports, "DisassociateKmsKeyRequest", function() {
    return DisassociateKmsKeyRequest;
});
parcelHelpers.export(exports, "FilteredLogEvent", function() {
    return FilteredLogEvent;
});
parcelHelpers.export(exports, "FilterLogEventsRequest", function() {
    return FilterLogEventsRequest;
});
parcelHelpers.export(exports, "SearchedLogStream", function() {
    return SearchedLogStream;
});
parcelHelpers.export(exports, "FilterLogEventsResponse", function() {
    return FilterLogEventsResponse;
});
parcelHelpers.export(exports, "GetLogEventsRequest", function() {
    return GetLogEventsRequest;
});
parcelHelpers.export(exports, "OutputLogEvent", function() {
    return OutputLogEvent;
});
parcelHelpers.export(exports, "GetLogEventsResponse", function() {
    return GetLogEventsResponse;
});
parcelHelpers.export(exports, "GetLogGroupFieldsRequest", function() {
    return GetLogGroupFieldsRequest;
});
parcelHelpers.export(exports, "LogGroupField", function() {
    return LogGroupField;
});
parcelHelpers.export(exports, "GetLogGroupFieldsResponse", function() {
    return GetLogGroupFieldsResponse;
});
parcelHelpers.export(exports, "GetLogRecordRequest", function() {
    return GetLogRecordRequest;
});
parcelHelpers.export(exports, "GetLogRecordResponse", function() {
    return GetLogRecordResponse;
});
parcelHelpers.export(exports, "GetQueryResultsRequest", function() {
    return GetQueryResultsRequest;
});
parcelHelpers.export(exports, "ResultField", function() {
    return ResultField;
});
parcelHelpers.export(exports, "QueryStatistics", function() {
    return QueryStatistics;
});
parcelHelpers.export(exports, "GetQueryResultsResponse", function() {
    return GetQueryResultsResponse;
});
parcelHelpers.export(exports, "InputLogEvent", function() {
    return InputLogEvent;
});
parcelHelpers.export(exports, "InvalidSequenceTokenException", function() {
    return InvalidSequenceTokenException;
});
parcelHelpers.export(exports, "ListTagsLogGroupRequest", function() {
    return ListTagsLogGroupRequest;
});
parcelHelpers.export(exports, "ListTagsLogGroupResponse", function() {
    return ListTagsLogGroupResponse;
});
parcelHelpers.export(exports, "PutDestinationRequest", function() {
    return PutDestinationRequest;
});
parcelHelpers.export(exports, "PutDestinationResponse", function() {
    return PutDestinationResponse;
});
parcelHelpers.export(exports, "PutDestinationPolicyRequest", function() {
    return PutDestinationPolicyRequest;
});
parcelHelpers.export(exports, "PutLogEventsRequest", function() {
    return PutLogEventsRequest;
});
parcelHelpers.export(exports, "RejectedLogEventsInfo", function() {
    return RejectedLogEventsInfo;
});
parcelHelpers.export(exports, "PutLogEventsResponse", function() {
    return PutLogEventsResponse;
});
parcelHelpers.export(exports, "UnrecognizedClientException", function() {
    return UnrecognizedClientException;
});
parcelHelpers.export(exports, "PutMetricFilterRequest", function() {
    return PutMetricFilterRequest;
});
parcelHelpers.export(exports, "PutQueryDefinitionRequest", function() {
    return PutQueryDefinitionRequest;
});
parcelHelpers.export(exports, "PutQueryDefinitionResponse", function() {
    return PutQueryDefinitionResponse;
});
parcelHelpers.export(exports, "PutResourcePolicyRequest", function() {
    return PutResourcePolicyRequest;
});
parcelHelpers.export(exports, "PutResourcePolicyResponse", function() {
    return PutResourcePolicyResponse;
});
parcelHelpers.export(exports, "PutRetentionPolicyRequest", function() {
    return PutRetentionPolicyRequest;
});
parcelHelpers.export(exports, "PutSubscriptionFilterRequest", function() {
    return PutSubscriptionFilterRequest;
});
parcelHelpers.export(exports, "QueryCompileErrorLocation", function() {
    return QueryCompileErrorLocation;
});
parcelHelpers.export(exports, "QueryCompileError", function() {
    return QueryCompileError;
});
parcelHelpers.export(exports, "MalformedQueryException", function() {
    return MalformedQueryException;
});
parcelHelpers.export(exports, "StartQueryRequest", function() {
    return StartQueryRequest;
});
parcelHelpers.export(exports, "StartQueryResponse", function() {
    return StartQueryResponse;
});
parcelHelpers.export(exports, "StopQueryRequest", function() {
    return StopQueryRequest;
});
parcelHelpers.export(exports, "StopQueryResponse", function() {
    return StopQueryResponse;
});
parcelHelpers.export(exports, "TagLogGroupRequest", function() {
    return TagLogGroupRequest;
});
parcelHelpers.export(exports, "TestMetricFilterRequest", function() {
    return TestMetricFilterRequest;
});
parcelHelpers.export(exports, "MetricFilterMatchRecord", function() {
    return MetricFilterMatchRecord;
});
parcelHelpers.export(exports, "TestMetricFilterResponse", function() {
    return TestMetricFilterResponse;
});
parcelHelpers.export(exports, "UntagLogGroupRequest", function() {
    return UntagLogGroupRequest;
});
var _tslib = require("tslib");
var AssociateKmsKeyRequest;
(function(AssociateKmsKeyRequest) {
    AssociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
var InvalidParameterException;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidParameterException || (InvalidParameterException = {}));
var OperationAbortedException;
(function(OperationAbortedException) {
    OperationAbortedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OperationAbortedException || (OperationAbortedException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var CancelExportTaskRequest;
(function(CancelExportTaskRequest) {
    CancelExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
var InvalidOperationException;
(function(InvalidOperationException) {
    InvalidOperationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidOperationException || (InvalidOperationException = {}));
var CreateExportTaskRequest;
(function(CreateExportTaskRequest) {
    CreateExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
var CreateExportTaskResponse;
(function(CreateExportTaskResponse) {
    CreateExportTaskResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceAlreadyExistsException;
(function(ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
var CreateLogGroupRequest;
(function(CreateLogGroupRequest) {
    CreateLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
var CreateLogStreamRequest;
(function(CreateLogStreamRequest) {
    CreateLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
var DataAlreadyAcceptedException;
(function(DataAlreadyAcceptedException) {
    DataAlreadyAcceptedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
var DeleteDestinationRequest;
(function(DeleteDestinationRequest) {
    DeleteDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
var DeleteLogGroupRequest;
(function(DeleteLogGroupRequest) {
    DeleteLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
var DeleteLogStreamRequest;
(function(DeleteLogStreamRequest) {
    DeleteLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
var DeleteMetricFilterRequest;
(function(DeleteMetricFilterRequest) {
    DeleteMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
var DeleteQueryDefinitionRequest;
(function(DeleteQueryDefinitionRequest) {
    DeleteQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
var DeleteQueryDefinitionResponse;
(function(DeleteQueryDefinitionResponse) {
    DeleteQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
var DeleteResourcePolicyRequest;
(function(DeleteResourcePolicyRequest) {
    DeleteResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
var DeleteRetentionPolicyRequest;
(function(DeleteRetentionPolicyRequest) {
    DeleteRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
var DeleteSubscriptionFilterRequest;
(function(DeleteSubscriptionFilterRequest) {
    DeleteSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
var DescribeDestinationsRequest;
(function(DescribeDestinationsRequest) {
    DescribeDestinationsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
var Destination;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Destination || (Destination = {}));
var DescribeDestinationsResponse;
(function(DescribeDestinationsResponse) {
    DescribeDestinationsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
var ExportTaskStatusCode;
(function(ExportTaskStatusCode) {
    ExportTaskStatusCode["CANCELLED"] = "CANCELLED";
    ExportTaskStatusCode["COMPLETED"] = "COMPLETED";
    ExportTaskStatusCode["FAILED"] = "FAILED";
    ExportTaskStatusCode["PENDING"] = "PENDING";
    ExportTaskStatusCode["PENDING_CANCEL"] = "PENDING_CANCEL";
    ExportTaskStatusCode["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
var DescribeExportTasksRequest;
(function(DescribeExportTasksRequest) {
    DescribeExportTasksRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
var ExportTaskExecutionInfo;
(function(ExportTaskExecutionInfo) {
    ExportTaskExecutionInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
var ExportTaskStatus;
(function(ExportTaskStatus) {
    ExportTaskStatus.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskStatus || (ExportTaskStatus = {}));
var ExportTask;
(function(ExportTask) {
    ExportTask.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTask || (ExportTask = {}));
var DescribeExportTasksResponse;
(function(DescribeExportTasksResponse) {
    DescribeExportTasksResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
var DescribeLogGroupsRequest;
(function(DescribeLogGroupsRequest) {
    DescribeLogGroupsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
var LogGroup;
(function(LogGroup) {
    LogGroup.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroup || (LogGroup = {}));
var DescribeLogGroupsResponse;
(function(DescribeLogGroupsResponse) {
    DescribeLogGroupsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
var OrderBy;
(function(OrderBy) {
    OrderBy["LastEventTime"] = "LastEventTime";
    OrderBy["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
var DescribeLogStreamsRequest;
(function(DescribeLogStreamsRequest) {
    DescribeLogStreamsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
var LogStream;
(function(LogStream) {
    LogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogStream || (LogStream = {}));
var DescribeLogStreamsResponse;
(function(DescribeLogStreamsResponse) {
    DescribeLogStreamsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
var DescribeMetricFiltersRequest;
(function(DescribeMetricFiltersRequest) {
    DescribeMetricFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
var MetricTransformation;
(function(MetricTransformation) {
    MetricTransformation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricTransformation || (MetricTransformation = {}));
var MetricFilter;
(function(MetricFilter) {
    MetricFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilter || (MetricFilter = {}));
var DescribeMetricFiltersResponse;
(function(DescribeMetricFiltersResponse) {
    DescribeMetricFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
var QueryStatus;
(function(QueryStatus) {
    QueryStatus["Cancelled"] = "Cancelled";
    QueryStatus["Complete"] = "Complete";
    QueryStatus["Failed"] = "Failed";
    QueryStatus["Running"] = "Running";
    QueryStatus["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
var DescribeQueriesRequest;
(function(DescribeQueriesRequest) {
    DescribeQueriesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
var QueryInfo;
(function(QueryInfo) {
    QueryInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryInfo || (QueryInfo = {}));
var DescribeQueriesResponse;
(function(DescribeQueriesResponse) {
    DescribeQueriesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
var DescribeQueryDefinitionsRequest;
(function(DescribeQueryDefinitionsRequest) {
    DescribeQueryDefinitionsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
var QueryDefinition;
(function(QueryDefinition) {
    QueryDefinition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryDefinition || (QueryDefinition = {}));
var DescribeQueryDefinitionsResponse;
(function(DescribeQueryDefinitionsResponse) {
    DescribeQueryDefinitionsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
var DescribeResourcePoliciesRequest;
(function(DescribeResourcePoliciesRequest) {
    DescribeResourcePoliciesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
var ResourcePolicy;
(function(ResourcePolicy) {
    ResourcePolicy.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourcePolicy || (ResourcePolicy = {}));
var DescribeResourcePoliciesResponse;
(function(DescribeResourcePoliciesResponse) {
    DescribeResourcePoliciesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
var DescribeSubscriptionFiltersRequest;
(function(DescribeSubscriptionFiltersRequest) {
    DescribeSubscriptionFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
var Distribution;
(function(Distribution) {
    Distribution["ByLogStream"] = "ByLogStream";
    Distribution["Random"] = "Random";
})(Distribution || (Distribution = {}));
var SubscriptionFilter;
(function(SubscriptionFilter) {
    SubscriptionFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscriptionFilter || (SubscriptionFilter = {}));
var DescribeSubscriptionFiltersResponse;
(function(DescribeSubscriptionFiltersResponse) {
    DescribeSubscriptionFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
var DisassociateKmsKeyRequest;
(function(DisassociateKmsKeyRequest) {
    DisassociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
var FilteredLogEvent;
(function(FilteredLogEvent) {
    FilteredLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilteredLogEvent || (FilteredLogEvent = {}));
var FilterLogEventsRequest;
(function(FilterLogEventsRequest) {
    FilterLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
var SearchedLogStream;
(function(SearchedLogStream) {
    SearchedLogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SearchedLogStream || (SearchedLogStream = {}));
var FilterLogEventsResponse;
(function(FilterLogEventsResponse) {
    FilterLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
var GetLogEventsRequest;
(function(GetLogEventsRequest) {
    GetLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
var OutputLogEvent;
(function(OutputLogEvent) {
    OutputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputLogEvent || (OutputLogEvent = {}));
var GetLogEventsResponse;
(function(GetLogEventsResponse) {
    GetLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
var GetLogGroupFieldsRequest;
(function(GetLogGroupFieldsRequest) {
    GetLogGroupFieldsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
var LogGroupField;
(function(LogGroupField) {
    LogGroupField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroupField || (LogGroupField = {}));
var GetLogGroupFieldsResponse;
(function(GetLogGroupFieldsResponse) {
    GetLogGroupFieldsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
var GetLogRecordRequest;
(function(GetLogRecordRequest) {
    GetLogRecordRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
var GetLogRecordResponse;
(function(GetLogRecordResponse) {
    GetLogRecordResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
var GetQueryResultsRequest;
(function(GetQueryResultsRequest) {
    GetQueryResultsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
var ResultField;
(function(ResultField) {
    ResultField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResultField || (ResultField = {}));
var QueryStatistics;
(function(QueryStatistics) {
    QueryStatistics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryStatistics || (QueryStatistics = {}));
var GetQueryResultsResponse;
(function(GetQueryResultsResponse) {
    GetQueryResultsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
var InputLogEvent;
(function(InputLogEvent) {
    InputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputLogEvent || (InputLogEvent = {}));
var InvalidSequenceTokenException;
(function(InvalidSequenceTokenException) {
    InvalidSequenceTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
var ListTagsLogGroupRequest;
(function(ListTagsLogGroupRequest) {
    ListTagsLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
var ListTagsLogGroupResponse;
(function(ListTagsLogGroupResponse) {
    ListTagsLogGroupResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
var PutDestinationRequest;
(function(PutDestinationRequest) {
    PutDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationRequest || (PutDestinationRequest = {}));
var PutDestinationResponse;
(function(PutDestinationResponse) {
    PutDestinationResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationResponse || (PutDestinationResponse = {}));
var PutDestinationPolicyRequest;
(function(PutDestinationPolicyRequest) {
    PutDestinationPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
var PutLogEventsRequest;
(function(PutLogEventsRequest) {
    PutLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
var RejectedLogEventsInfo;
(function(RejectedLogEventsInfo) {
    RejectedLogEventsInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
var PutLogEventsResponse;
(function(PutLogEventsResponse) {
    PutLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
var UnrecognizedClientException;
(function(UnrecognizedClientException) {
    UnrecognizedClientException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
var PutMetricFilterRequest;
(function(PutMetricFilterRequest) {
    PutMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
var PutQueryDefinitionRequest;
(function(PutQueryDefinitionRequest) {
    PutQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
var PutQueryDefinitionResponse;
(function(PutQueryDefinitionResponse) {
    PutQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
var PutResourcePolicyRequest;
(function(PutResourcePolicyRequest) {
    PutResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
var PutResourcePolicyResponse;
(function(PutResourcePolicyResponse) {
    PutResourcePolicyResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
var PutRetentionPolicyRequest;
(function(PutRetentionPolicyRequest) {
    PutRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
var PutSubscriptionFilterRequest;
(function(PutSubscriptionFilterRequest) {
    PutSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
var QueryCompileErrorLocation;
(function(QueryCompileErrorLocation) {
    QueryCompileErrorLocation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
var QueryCompileError;
(function(QueryCompileError) {
    QueryCompileError.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileError || (QueryCompileError = {}));
var MalformedQueryException;
(function(MalformedQueryException) {
    MalformedQueryException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MalformedQueryException || (MalformedQueryException = {}));
var StartQueryRequest;
(function(StartQueryRequest) {
    StartQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryRequest || (StartQueryRequest = {}));
var StartQueryResponse;
(function(StartQueryResponse) {
    StartQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryResponse || (StartQueryResponse = {}));
var StopQueryRequest;
(function(StopQueryRequest) {
    StopQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryRequest || (StopQueryRequest = {}));
var StopQueryResponse;
(function(StopQueryResponse) {
    StopQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryResponse || (StopQueryResponse = {}));
var TagLogGroupRequest;
(function(TagLogGroupRequest) {
    TagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
var TestMetricFilterRequest;
(function(TestMetricFilterRequest) {
    TestMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
var MetricFilterMatchRecord;
(function(MetricFilterMatchRecord) {
    MetricFilterMatchRecord.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
var TestMetricFilterResponse;
(function(TestMetricFilterResponse) {
    TestMetricFilterResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
var UntagLogGroupRequest;
(function(UntagLogGroupRequest) {
    UntagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fkUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AssociateKmsKeyCommand", function() {
    return serializeAws_json1_1AssociateKmsKeyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1CancelExportTaskCommand", function() {
    return serializeAws_json1_1CancelExportTaskCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1CreateExportTaskCommand", function() {
    return serializeAws_json1_1CreateExportTaskCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogGroupCommand", function() {
    return serializeAws_json1_1CreateLogGroupCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogStreamCommand", function() {
    return serializeAws_json1_1CreateLogStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDestinationCommand", function() {
    return serializeAws_json1_1DeleteDestinationCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogGroupCommand", function() {
    return serializeAws_json1_1DeleteLogGroupCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogStreamCommand", function() {
    return serializeAws_json1_1DeleteLogStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteMetricFilterCommand", function() {
    return serializeAws_json1_1DeleteMetricFilterCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteQueryDefinitionCommand", function() {
    return serializeAws_json1_1DeleteQueryDefinitionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteResourcePolicyCommand", function() {
    return serializeAws_json1_1DeleteResourcePolicyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteRetentionPolicyCommand", function() {
    return serializeAws_json1_1DeleteRetentionPolicyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteSubscriptionFilterCommand", function() {
    return serializeAws_json1_1DeleteSubscriptionFilterCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDestinationsCommand", function() {
    return serializeAws_json1_1DescribeDestinationsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeExportTasksCommand", function() {
    return serializeAws_json1_1DescribeExportTasksCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogGroupsCommand", function() {
    return serializeAws_json1_1DescribeLogGroupsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogStreamsCommand", function() {
    return serializeAws_json1_1DescribeLogStreamsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeMetricFiltersCommand", function() {
    return serializeAws_json1_1DescribeMetricFiltersCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueriesCommand", function() {
    return serializeAws_json1_1DescribeQueriesCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueryDefinitionsCommand", function() {
    return serializeAws_json1_1DescribeQueryDefinitionsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeResourcePoliciesCommand", function() {
    return serializeAws_json1_1DescribeResourcePoliciesCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeSubscriptionFiltersCommand", function() {
    return serializeAws_json1_1DescribeSubscriptionFiltersCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DisassociateKmsKeyCommand", function() {
    return serializeAws_json1_1DisassociateKmsKeyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1FilterLogEventsCommand", function() {
    return serializeAws_json1_1FilterLogEventsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetLogEventsCommand", function() {
    return serializeAws_json1_1GetLogEventsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetLogGroupFieldsCommand", function() {
    return serializeAws_json1_1GetLogGroupFieldsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetLogRecordCommand", function() {
    return serializeAws_json1_1GetLogRecordCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetQueryResultsCommand", function() {
    return serializeAws_json1_1GetQueryResultsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsLogGroupCommand", function() {
    return serializeAws_json1_1ListTagsLogGroupCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationCommand", function() {
    return serializeAws_json1_1PutDestinationCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationPolicyCommand", function() {
    return serializeAws_json1_1PutDestinationPolicyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutLogEventsCommand", function() {
    return serializeAws_json1_1PutLogEventsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutMetricFilterCommand", function() {
    return serializeAws_json1_1PutMetricFilterCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutQueryDefinitionCommand", function() {
    return serializeAws_json1_1PutQueryDefinitionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutResourcePolicyCommand", function() {
    return serializeAws_json1_1PutResourcePolicyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutRetentionPolicyCommand", function() {
    return serializeAws_json1_1PutRetentionPolicyCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutSubscriptionFilterCommand", function() {
    return serializeAws_json1_1PutSubscriptionFilterCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StartQueryCommand", function() {
    return serializeAws_json1_1StartQueryCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StopQueryCommand", function() {
    return serializeAws_json1_1StopQueryCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1TagLogGroupCommand", function() {
    return serializeAws_json1_1TagLogGroupCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1TestMetricFilterCommand", function() {
    return serializeAws_json1_1TestMetricFilterCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1UntagLogGroupCommand", function() {
    return serializeAws_json1_1UntagLogGroupCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1AssociateKmsKeyCommand", function() {
    return deserializeAws_json1_1AssociateKmsKeyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CancelExportTaskCommand", function() {
    return deserializeAws_json1_1CancelExportTaskCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CreateExportTaskCommand", function() {
    return deserializeAws_json1_1CreateExportTaskCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogGroupCommand", function() {
    return deserializeAws_json1_1CreateLogGroupCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogStreamCommand", function() {
    return deserializeAws_json1_1CreateLogStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDestinationCommand", function() {
    return deserializeAws_json1_1DeleteDestinationCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogGroupCommand", function() {
    return deserializeAws_json1_1DeleteLogGroupCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogStreamCommand", function() {
    return deserializeAws_json1_1DeleteLogStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteMetricFilterCommand", function() {
    return deserializeAws_json1_1DeleteMetricFilterCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteQueryDefinitionCommand", function() {
    return deserializeAws_json1_1DeleteQueryDefinitionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteResourcePolicyCommand", function() {
    return deserializeAws_json1_1DeleteResourcePolicyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteRetentionPolicyCommand", function() {
    return deserializeAws_json1_1DeleteRetentionPolicyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteSubscriptionFilterCommand", function() {
    return deserializeAws_json1_1DeleteSubscriptionFilterCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDestinationsCommand", function() {
    return deserializeAws_json1_1DescribeDestinationsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeExportTasksCommand", function() {
    return deserializeAws_json1_1DescribeExportTasksCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogGroupsCommand", function() {
    return deserializeAws_json1_1DescribeLogGroupsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogStreamsCommand", function() {
    return deserializeAws_json1_1DescribeLogStreamsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeMetricFiltersCommand", function() {
    return deserializeAws_json1_1DescribeMetricFiltersCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueriesCommand", function() {
    return deserializeAws_json1_1DescribeQueriesCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueryDefinitionsCommand", function() {
    return deserializeAws_json1_1DescribeQueryDefinitionsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeResourcePoliciesCommand", function() {
    return deserializeAws_json1_1DescribeResourcePoliciesCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeSubscriptionFiltersCommand", function() {
    return deserializeAws_json1_1DescribeSubscriptionFiltersCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DisassociateKmsKeyCommand", function() {
    return deserializeAws_json1_1DisassociateKmsKeyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1FilterLogEventsCommand", function() {
    return deserializeAws_json1_1FilterLogEventsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogEventsCommand", function() {
    return deserializeAws_json1_1GetLogEventsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogGroupFieldsCommand", function() {
    return deserializeAws_json1_1GetLogGroupFieldsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogRecordCommand", function() {
    return deserializeAws_json1_1GetLogRecordCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetQueryResultsCommand", function() {
    return deserializeAws_json1_1GetQueryResultsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsLogGroupCommand", function() {
    return deserializeAws_json1_1ListTagsLogGroupCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationCommand", function() {
    return deserializeAws_json1_1PutDestinationCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationPolicyCommand", function() {
    return deserializeAws_json1_1PutDestinationPolicyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutLogEventsCommand", function() {
    return deserializeAws_json1_1PutLogEventsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutMetricFilterCommand", function() {
    return deserializeAws_json1_1PutMetricFilterCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutQueryDefinitionCommand", function() {
    return deserializeAws_json1_1PutQueryDefinitionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutResourcePolicyCommand", function() {
    return deserializeAws_json1_1PutResourcePolicyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutRetentionPolicyCommand", function() {
    return deserializeAws_json1_1PutRetentionPolicyCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutSubscriptionFilterCommand", function() {
    return deserializeAws_json1_1PutSubscriptionFilterCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StartQueryCommand", function() {
    return deserializeAws_json1_1StartQueryCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StopQueryCommand", function() {
    return deserializeAws_json1_1StopQueryCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1TagLogGroupCommand", function() {
    return deserializeAws_json1_1TagLogGroupCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1TestMetricFilterCommand", function() {
    return deserializeAws_json1_1TestMetricFilterCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1UntagLogGroupCommand", function() {
    return deserializeAws_json1_1UntagLogGroupCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AssociateKmsKeyCommand = function serializeAws_json1_1AssociateKmsKeyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.AssociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1AssociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CancelExportTaskCommand = function serializeAws_json1_1CancelExportTaskCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CancelExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CancelExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateExportTaskCommand = function serializeAws_json1_1CreateExportTaskCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CreateExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogGroupCommand = function serializeAws_json1_1CreateLogGroupCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogStreamCommand = function serializeAws_json1_1CreateLogStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDestinationCommand = function serializeAws_json1_1DeleteDestinationCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteDestination"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogGroupCommand = function serializeAws_json1_1DeleteLogGroupCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogStreamCommand = function serializeAws_json1_1DeleteLogStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteMetricFilterCommand = function serializeAws_json1_1DeleteMetricFilterCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteQueryDefinitionCommand = function serializeAws_json1_1DeleteQueryDefinitionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteResourcePolicyCommand = function serializeAws_json1_1DeleteResourcePolicyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteRetentionPolicyCommand = function serializeAws_json1_1DeleteRetentionPolicyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterCommand = function serializeAws_json1_1DeleteSubscriptionFilterCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDestinationsCommand = function serializeAws_json1_1DescribeDestinationsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeDestinations"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDestinationsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeExportTasksCommand = function serializeAws_json1_1DescribeExportTasksCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeExportTasks"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeExportTasksRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogGroupsCommand = function serializeAws_json1_1DescribeLogGroupsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogGroups"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogGroupsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogStreamsCommand = function serializeAws_json1_1DescribeLogStreamsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogStreams"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogStreamsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeMetricFiltersCommand = function serializeAws_json1_1DescribeMetricFiltersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeMetricFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeMetricFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueriesCommand = function serializeAws_json1_1DescribeQueriesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueries"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueriesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsCommand = function serializeAws_json1_1DescribeQueryDefinitionsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueryDefinitions"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueryDefinitionsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeResourcePoliciesCommand = function serializeAws_json1_1DescribeResourcePoliciesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeResourcePolicies"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeResourcePoliciesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersCommand = function serializeAws_json1_1DescribeSubscriptionFiltersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeSubscriptionFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeSubscriptionFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisassociateKmsKeyCommand = function serializeAws_json1_1DisassociateKmsKeyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DisassociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1DisassociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1FilterLogEventsCommand = function serializeAws_json1_1FilterLogEventsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.FilterLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1FilterLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogEventsCommand = function serializeAws_json1_1GetLogEventsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogGroupFieldsCommand = function serializeAws_json1_1GetLogGroupFieldsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogGroupFields"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogGroupFieldsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogRecordCommand = function serializeAws_json1_1GetLogRecordCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogRecord"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogRecordRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetQueryResultsCommand = function serializeAws_json1_1GetQueryResultsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetQueryResults"
            };
            body = JSON.stringify(serializeAws_json1_1GetQueryResultsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsLogGroupCommand = function serializeAws_json1_1ListTagsLogGroupCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.ListTagsLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationCommand = function serializeAws_json1_1PutDestinationCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestination"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationPolicyCommand = function serializeAws_json1_1PutDestinationPolicyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestinationPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutLogEventsCommand = function serializeAws_json1_1PutLogEventsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1PutLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutMetricFilterCommand = function serializeAws_json1_1PutMetricFilterCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutQueryDefinitionCommand = function serializeAws_json1_1PutQueryDefinitionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1PutQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutResourcePolicyCommand = function serializeAws_json1_1PutResourcePolicyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRetentionPolicyCommand = function serializeAws_json1_1PutRetentionPolicyCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutSubscriptionFilterCommand = function serializeAws_json1_1PutSubscriptionFilterCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartQueryCommand = function serializeAws_json1_1StartQueryCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StartQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StartQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopQueryCommand = function serializeAws_json1_1StopQueryCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StopQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StopQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagLogGroupCommand = function serializeAws_json1_1TagLogGroupCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1TagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TestMetricFilterCommand = function serializeAws_json1_1TestMetricFilterCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TestMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1TestMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagLogGroupCommand = function serializeAws_json1_1UntagLogGroupCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.UntagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1UntagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommand = function deserializeAws_json1_1AssociateKmsKeyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AssociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommandError = function deserializeAws_json1_1AssociateKmsKeyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommand = function deserializeAws_json1_1CancelExportTaskCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CancelExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommandError = function deserializeAws_json1_1CancelExportTaskCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidOperationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommand = function deserializeAws_json1_1CreateExportTaskCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateExportTaskResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommandError = function deserializeAws_json1_1CreateExportTaskCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommand = function deserializeAws_json1_1CreateLogGroupCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommandError = function deserializeAws_json1_1CreateLogGroupCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommand = function deserializeAws_json1_1CreateLogStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommandError = function deserializeAws_json1_1CreateLogStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommand = function deserializeAws_json1_1DeleteDestinationCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommandError = function deserializeAws_json1_1DeleteDestinationCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommand = function deserializeAws_json1_1DeleteLogGroupCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommandError = function deserializeAws_json1_1DeleteLogGroupCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommand = function deserializeAws_json1_1DeleteLogStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommandError = function deserializeAws_json1_1DeleteLogStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommand = function deserializeAws_json1_1DeleteMetricFilterCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommandError = function deserializeAws_json1_1DeleteMetricFilterCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommand = function deserializeAws_json1_1DeleteQueryDefinitionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommandError = function deserializeAws_json1_1DeleteQueryDefinitionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommand = function deserializeAws_json1_1DeleteResourcePolicyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommandError = function deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommand = function deserializeAws_json1_1DeleteRetentionPolicyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommandError = function deserializeAws_json1_1DeleteRetentionPolicyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommand = function deserializeAws_json1_1DeleteSubscriptionFilterCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommandError = function deserializeAws_json1_1DeleteSubscriptionFilterCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommand = function deserializeAws_json1_1DescribeDestinationsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDestinationsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDestinationsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommandError = function deserializeAws_json1_1DescribeDestinationsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommand = function deserializeAws_json1_1DescribeExportTasksCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeExportTasksCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeExportTasksResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommandError = function deserializeAws_json1_1DescribeExportTasksCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommand = function deserializeAws_json1_1DescribeLogGroupsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogGroupsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogGroupsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommandError = function deserializeAws_json1_1DescribeLogGroupsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommand = function deserializeAws_json1_1DescribeLogStreamsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogStreamsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommandError = function deserializeAws_json1_1DescribeLogStreamsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommand = function deserializeAws_json1_1DescribeMetricFiltersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeMetricFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeMetricFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommandError = function deserializeAws_json1_1DescribeMetricFiltersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommand = function deserializeAws_json1_1DescribeQueriesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueriesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueriesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommandError = function deserializeAws_json1_1DescribeQueriesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommand = function deserializeAws_json1_1DescribeQueryDefinitionsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueryDefinitionsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueryDefinitionsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommandError = function deserializeAws_json1_1DescribeQueryDefinitionsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommand = function deserializeAws_json1_1DescribeResourcePoliciesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeResourcePoliciesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeResourcePoliciesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommandError = function deserializeAws_json1_1DescribeResourcePoliciesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommand = function deserializeAws_json1_1DescribeSubscriptionFiltersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeSubscriptionFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeSubscriptionFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommandError = function deserializeAws_json1_1DescribeSubscriptionFiltersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommand = function deserializeAws_json1_1DisassociateKmsKeyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisassociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommandError = function deserializeAws_json1_1DisassociateKmsKeyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommand = function deserializeAws_json1_1FilterLogEventsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1FilterLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1FilterLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommandError = function deserializeAws_json1_1FilterLogEventsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommand = function deserializeAws_json1_1GetLogEventsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommandError = function deserializeAws_json1_1GetLogEventsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommand = function deserializeAws_json1_1GetLogGroupFieldsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogGroupFieldsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogGroupFieldsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommandError = function deserializeAws_json1_1GetLogGroupFieldsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommand = function deserializeAws_json1_1GetLogRecordCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogRecordResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommandError = function deserializeAws_json1_1GetLogRecordCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommand = function deserializeAws_json1_1GetQueryResultsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetQueryResultsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetQueryResultsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommandError = function deserializeAws_json1_1GetQueryResultsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommand = function deserializeAws_json1_1ListTagsLogGroupCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsLogGroupResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommandError = function deserializeAws_json1_1ListTagsLogGroupCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommand = function deserializeAws_json1_1PutDestinationCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutDestinationResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommandError = function deserializeAws_json1_1PutDestinationCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommand = function deserializeAws_json1_1PutDestinationPolicyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommandError = function deserializeAws_json1_1PutDestinationPolicyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommand = function deserializeAws_json1_1PutLogEventsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommandError = function deserializeAws_json1_1PutLogEventsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommand = function deserializeAws_json1_1PutMetricFilterCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommandError = function deserializeAws_json1_1PutMetricFilterCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommand = function deserializeAws_json1_1PutQueryDefinitionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommandError = function deserializeAws_json1_1PutQueryDefinitionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommand = function deserializeAws_json1_1PutResourcePolicyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutResourcePolicyResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommandError = function deserializeAws_json1_1PutResourcePolicyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommand = function deserializeAws_json1_1PutRetentionPolicyCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommandError = function deserializeAws_json1_1PutRetentionPolicyCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommand = function deserializeAws_json1_1PutSubscriptionFilterCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommandError = function deserializeAws_json1_1PutSubscriptionFilterCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommand = function deserializeAws_json1_1StartQueryCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommandError = function deserializeAws_json1_1StartQueryCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1MalformedQueryExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommand = function deserializeAws_json1_1StopQueryCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommandError = function deserializeAws_json1_1StopQueryCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommand = function deserializeAws_json1_1TagLogGroupCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommandError = function deserializeAws_json1_1TagLogGroupCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommand = function deserializeAws_json1_1TestMetricFilterCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TestMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TestMetricFilterResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommandError = function deserializeAws_json1_1TestMetricFilterCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommand = function deserializeAws_json1_1UntagLogGroupCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommandError = function deserializeAws_json1_1UntagLogGroupCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse = function deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1DataAlreadyAcceptedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "DataAlreadyAcceptedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidOperationExceptionResponse = function deserializeAws_json1_1InvalidOperationExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidOperationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidOperationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidParameterExceptionResponse = function deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidSequenceTokenExceptionResponse = function deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidSequenceTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidSequenceTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1MalformedQueryExceptionResponse = function deserializeAws_json1_1MalformedQueryExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1MalformedQueryException(body, context);
            contents = (0, _tslib.__assign)({
                name: "MalformedQueryException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1OperationAbortedExceptionResponse = function deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1OperationAbortedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "OperationAbortedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse = function deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceAlreadyExistsException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceAlreadyExistsException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1UnrecognizedClientExceptionResponse = function deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1UnrecognizedClientException(body, context);
            contents = (0, _tslib.__assign)({
                name: "UnrecognizedClientException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AssociateKmsKeyRequest = function serializeAws_json1_1AssociateKmsKeyRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1CancelExportTaskRequest = function serializeAws_json1_1CancelExportTaskRequest(input, context) {
    return (0, _tslib.__assign)({}, input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1CreateExportTaskRequest = function serializeAws_json1_1CreateExportTaskRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destination !== undefined && input.destination !== null && {
        destination: input.destination
    }), input.destinationPrefix !== undefined && input.destinationPrefix !== null && {
        destinationPrefix: input.destinationPrefix
    }), input.from !== undefined && input.from !== null && {
        from: input.from
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.taskName !== undefined && input.taskName !== null && {
        taskName: input.taskName
    }), input.to !== undefined && input.to !== null && {
        to: input.to
    });
};
var serializeAws_json1_1CreateLogGroupRequest = function serializeAws_json1_1CreateLogGroupRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1CreateLogStreamRequest = function serializeAws_json1_1CreateLogStreamRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteDestinationRequest = function serializeAws_json1_1DeleteDestinationRequest(input, context) {
    return (0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1DeleteLogGroupRequest = function serializeAws_json1_1DeleteLogGroupRequest(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteLogStreamRequest = function serializeAws_json1_1DeleteLogStreamRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteMetricFilterRequest = function serializeAws_json1_1DeleteMetricFilterRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteQueryDefinitionRequest = function serializeAws_json1_1DeleteQueryDefinitionRequest(input, context) {
    return (0, _tslib.__assign)({}, input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    });
};
var serializeAws_json1_1DeleteResourcePolicyRequest = function serializeAws_json1_1DeleteResourcePolicyRequest(input, context) {
    return (0, _tslib.__assign)({}, input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1DeleteRetentionPolicyRequest = function serializeAws_json1_1DeleteRetentionPolicyRequest(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterRequest = function serializeAws_json1_1DeleteSubscriptionFilterRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DescribeDestinationsRequest = function serializeAws_json1_1DescribeDestinationsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DestinationNamePrefix !== undefined && input.DestinationNamePrefix !== null && {
        DestinationNamePrefix: input.DestinationNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeExportTasksRequest = function serializeAws_json1_1DescribeExportTasksRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.statusCode !== undefined && input.statusCode !== null && {
        statusCode: input.statusCode
    }), input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1DescribeLogGroupsRequest = function serializeAws_json1_1DescribeLogGroupsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupNamePrefix !== undefined && input.logGroupNamePrefix !== null && {
        logGroupNamePrefix: input.logGroupNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeLogStreamsRequest = function serializeAws_json1_1DescribeLogStreamsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.descending !== undefined && input.descending !== null && {
        descending: input.descending
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.orderBy !== undefined && input.orderBy !== null && {
        orderBy: input.orderBy
    });
};
var serializeAws_json1_1DescribeMetricFiltersRequest = function serializeAws_json1_1DescribeMetricFiltersRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeQueriesRequest = function serializeAws_json1_1DescribeQueriesRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.status !== undefined && input.status !== null && {
        status: input.status
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsRequest = function serializeAws_json1_1DescribeQueryDefinitionsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.queryDefinitionNamePrefix !== undefined && input.queryDefinitionNamePrefix !== null && {
        queryDefinitionNamePrefix: input.queryDefinitionNamePrefix
    });
};
var serializeAws_json1_1DescribeResourcePoliciesRequest = function serializeAws_json1_1DescribeResourcePoliciesRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersRequest = function serializeAws_json1_1DescribeSubscriptionFiltersRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DisassociateKmsKeyRequest = function serializeAws_json1_1DisassociateKmsKeyRequest(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1FilterLogEventsRequest = function serializeAws_json1_1FilterLogEventsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.interleaved !== undefined && input.interleaved !== null && {
        interleaved: input.interleaved
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.logStreamNames !== undefined && input.logStreamNames !== null && {
        logStreamNames: serializeAws_json1_1InputLogStreamNames(input.logStreamNames, context)
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogEventsRequest = function serializeAws_json1_1GetLogEventsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startFromHead !== undefined && input.startFromHead !== null && {
        startFromHead: input.startFromHead
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogGroupFieldsRequest = function serializeAws_json1_1GetLogGroupFieldsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.time !== undefined && input.time !== null && {
        time: input.time
    });
};
var serializeAws_json1_1GetLogRecordRequest = function serializeAws_json1_1GetLogRecordRequest(input, context) {
    return (0, _tslib.__assign)({}, input.logRecordPointer !== undefined && input.logRecordPointer !== null && {
        logRecordPointer: input.logRecordPointer
    });
};
var serializeAws_json1_1GetQueryResultsRequest = function serializeAws_json1_1GetQueryResultsRequest(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1InputLogEvent = function serializeAws_json1_1InputLogEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.message !== undefined && input.message !== null && {
        message: input.message
    }), input.timestamp !== undefined && input.timestamp !== null && {
        timestamp: input.timestamp
    });
};
var serializeAws_json1_1InputLogEvents = function serializeAws_json1_1InputLogEvents(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1InputLogEvent(entry, context);
    });
};
var serializeAws_json1_1InputLogStreamNames = function serializeAws_json1_1InputLogStreamNames(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsLogGroupRequest = function serializeAws_json1_1ListTagsLogGroupRequest(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1LogGroupNames = function serializeAws_json1_1LogGroupNames(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1MetricTransformation = function serializeAws_json1_1MetricTransformation(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.defaultValue !== undefined && input.defaultValue !== null && {
        defaultValue: input.defaultValue
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.metricValue !== undefined && input.metricValue !== null && {
        metricValue: input.metricValue
    });
};
var serializeAws_json1_1MetricTransformations = function serializeAws_json1_1MetricTransformations(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1MetricTransformation(entry, context);
    });
};
var serializeAws_json1_1PutDestinationPolicyRequest = function serializeAws_json1_1PutDestinationPolicyRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.accessPolicy !== undefined && input.accessPolicy !== null && {
        accessPolicy: input.accessPolicy
    }), input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1PutDestinationRequest = function serializeAws_json1_1PutDestinationRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    }), input.targetArn !== undefined && input.targetArn !== null && {
        targetArn: input.targetArn
    });
};
var serializeAws_json1_1PutLogEventsRequest = function serializeAws_json1_1PutLogEventsRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logEvents !== undefined && input.logEvents !== null && {
        logEvents: serializeAws_json1_1InputLogEvents(input.logEvents, context)
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.sequenceToken !== undefined && input.sequenceToken !== null && {
        sequenceToken: input.sequenceToken
    });
};
var serializeAws_json1_1PutMetricFilterRequest = function serializeAws_json1_1PutMetricFilterRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricTransformations !== undefined && input.metricTransformations !== null && {
        metricTransformations: serializeAws_json1_1MetricTransformations(input.metricTransformations, context)
    });
};
var serializeAws_json1_1PutQueryDefinitionRequest = function serializeAws_json1_1PutQueryDefinitionRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.name !== undefined && input.name !== null && {
        name: input.name
    }), input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    });
};
var serializeAws_json1_1PutResourcePolicyRequest = function serializeAws_json1_1PutResourcePolicyRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.policyDocument !== undefined && input.policyDocument !== null && {
        policyDocument: input.policyDocument
    }), input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1PutRetentionPolicyRequest = function serializeAws_json1_1PutRetentionPolicyRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.retentionInDays !== undefined && input.retentionInDays !== null && {
        retentionInDays: input.retentionInDays
    });
};
var serializeAws_json1_1PutSubscriptionFilterRequest = function serializeAws_json1_1PutSubscriptionFilterRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationArn !== undefined && input.destinationArn !== null && {
        destinationArn: input.destinationArn
    }), input.distribution !== undefined && input.distribution !== null && {
        distribution: input.distribution
    }), input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    });
};
var serializeAws_json1_1StartQueryRequest = function serializeAws_json1_1StartQueryRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1StopQueryRequest = function serializeAws_json1_1StopQueryRequest(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1TagList = function serializeAws_json1_1TagList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagLogGroupRequest = function serializeAws_json1_1TagLogGroupRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1Tags = function serializeAws_json1_1Tags(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1TestEventMessages = function serializeAws_json1_1TestEventMessages(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TestMetricFilterRequest = function serializeAws_json1_1TestMetricFilterRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logEventMessages !== undefined && input.logEventMessages !== null && {
        logEventMessages: serializeAws_json1_1TestEventMessages(input.logEventMessages, context)
    });
};
var serializeAws_json1_1UntagLogGroupRequest = function serializeAws_json1_1UntagLogGroupRequest(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1TagList(input.tags, context)
    });
};
var deserializeAws_json1_1CreateExportTaskResponse = function deserializeAws_json1_1CreateExportTaskResponse(output, context) {
    return {
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined
    };
};
var deserializeAws_json1_1DataAlreadyAcceptedException = function deserializeAws_json1_1DataAlreadyAcceptedException(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1DeleteQueryDefinitionResponse = function deserializeAws_json1_1DeleteQueryDefinitionResponse(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1DescribeDestinationsResponse = function deserializeAws_json1_1DescribeDestinationsResponse(output, context) {
    return {
        destinations: output.destinations !== undefined && output.destinations !== null ? deserializeAws_json1_1Destinations(output.destinations, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeExportTasksResponse = function deserializeAws_json1_1DescribeExportTasksResponse(output, context) {
    return {
        exportTasks: output.exportTasks !== undefined && output.exportTasks !== null ? deserializeAws_json1_1ExportTasks(output.exportTasks, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogGroupsResponse = function deserializeAws_json1_1DescribeLogGroupsResponse(output, context) {
    return {
        logGroups: output.logGroups !== undefined && output.logGroups !== null ? deserializeAws_json1_1LogGroups(output.logGroups, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogStreamsResponse = function deserializeAws_json1_1DescribeLogStreamsResponse(output, context) {
    return {
        logStreams: output.logStreams !== undefined && output.logStreams !== null ? deserializeAws_json1_1LogStreams(output.logStreams, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeMetricFiltersResponse = function deserializeAws_json1_1DescribeMetricFiltersResponse(output, context) {
    return {
        metricFilters: output.metricFilters !== undefined && output.metricFilters !== null ? deserializeAws_json1_1MetricFilters(output.metricFilters, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeQueriesResponse = function deserializeAws_json1_1DescribeQueriesResponse(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queries: output.queries !== undefined && output.queries !== null ? deserializeAws_json1_1QueryInfoList(output.queries, context) : undefined
    };
};
var deserializeAws_json1_1DescribeQueryDefinitionsResponse = function deserializeAws_json1_1DescribeQueryDefinitionsResponse(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queryDefinitions: output.queryDefinitions !== undefined && output.queryDefinitions !== null ? deserializeAws_json1_1QueryDefinitionList(output.queryDefinitions, context) : undefined
    };
};
var deserializeAws_json1_1DescribeResourcePoliciesResponse = function deserializeAws_json1_1DescribeResourcePoliciesResponse(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        resourcePolicies: output.resourcePolicies !== undefined && output.resourcePolicies !== null ? deserializeAws_json1_1ResourcePolicies(output.resourcePolicies, context) : undefined
    };
};
var deserializeAws_json1_1DescribeSubscriptionFiltersResponse = function deserializeAws_json1_1DescribeSubscriptionFiltersResponse(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        subscriptionFilters: output.subscriptionFilters !== undefined && output.subscriptionFilters !== null ? deserializeAws_json1_1SubscriptionFilters(output.subscriptionFilters, context) : undefined
    };
};
var deserializeAws_json1_1Destination = function deserializeAws_json1_1Destination(output, context) {
    return {
        accessPolicy: output.accessPolicy !== undefined && output.accessPolicy !== null ? output.accessPolicy : undefined,
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationName: output.destinationName !== undefined && output.destinationName !== null ? output.destinationName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined,
        targetArn: output.targetArn !== undefined && output.targetArn !== null ? output.targetArn : undefined
    };
};
var deserializeAws_json1_1Destinations = function deserializeAws_json1_1Destinations(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Destination(entry, context);
    });
};
var deserializeAws_json1_1ExportTask = function deserializeAws_json1_1ExportTask(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? output.destination : undefined,
        destinationPrefix: output.destinationPrefix !== undefined && output.destinationPrefix !== null ? output.destinationPrefix : undefined,
        executionInfo: output.executionInfo !== undefined && output.executionInfo !== null ? deserializeAws_json1_1ExportTaskExecutionInfo(output.executionInfo, context) : undefined,
        from: output.from !== undefined && output.from !== null ? output.from : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        status: output.status !== undefined && output.status !== null ? deserializeAws_json1_1ExportTaskStatus(output.status, context) : undefined,
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined,
        taskName: output.taskName !== undefined && output.taskName !== null ? output.taskName : undefined,
        to: output.to !== undefined && output.to !== null ? output.to : undefined
    };
};
var deserializeAws_json1_1ExportTaskExecutionInfo = function deserializeAws_json1_1ExportTaskExecutionInfo(output, context) {
    return {
        completionTime: output.completionTime !== undefined && output.completionTime !== null ? output.completionTime : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined
    };
};
var deserializeAws_json1_1ExportTasks = function deserializeAws_json1_1ExportTasks(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ExportTask(entry, context);
    });
};
var deserializeAws_json1_1ExportTaskStatus = function deserializeAws_json1_1ExportTaskStatus(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExtractedValues = function deserializeAws_json1_1ExtractedValues(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1FilteredLogEvent = function deserializeAws_json1_1FilteredLogEvent(output, context) {
    return {
        eventId: output.eventId !== undefined && output.eventId !== null ? output.eventId : undefined,
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1FilteredLogEvents = function deserializeAws_json1_1FilteredLogEvents(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1FilteredLogEvent(entry, context);
    });
};
var deserializeAws_json1_1FilterLogEventsResponse = function deserializeAws_json1_1FilterLogEventsResponse(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1FilteredLogEvents(output.events, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        searchedLogStreams: output.searchedLogStreams !== undefined && output.searchedLogStreams !== null ? deserializeAws_json1_1SearchedLogStreams(output.searchedLogStreams, context) : undefined
    };
};
var deserializeAws_json1_1GetLogEventsResponse = function deserializeAws_json1_1GetLogEventsResponse(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1OutputLogEvents(output.events, context) : undefined,
        nextBackwardToken: output.nextBackwardToken !== undefined && output.nextBackwardToken !== null ? output.nextBackwardToken : undefined,
        nextForwardToken: output.nextForwardToken !== undefined && output.nextForwardToken !== null ? output.nextForwardToken : undefined
    };
};
var deserializeAws_json1_1GetLogGroupFieldsResponse = function deserializeAws_json1_1GetLogGroupFieldsResponse(output, context) {
    return {
        logGroupFields: output.logGroupFields !== undefined && output.logGroupFields !== null ? deserializeAws_json1_1LogGroupFieldList(output.logGroupFields, context) : undefined
    };
};
var deserializeAws_json1_1GetLogRecordResponse = function deserializeAws_json1_1GetLogRecordResponse(output, context) {
    return {
        logRecord: output.logRecord !== undefined && output.logRecord !== null ? deserializeAws_json1_1LogRecord(output.logRecord, context) : undefined
    };
};
var deserializeAws_json1_1GetQueryResultsResponse = function deserializeAws_json1_1GetQueryResultsResponse(output, context) {
    return {
        results: output.results !== undefined && output.results !== null ? deserializeAws_json1_1QueryResults(output.results, context) : undefined,
        statistics: output.statistics !== undefined && output.statistics !== null ? deserializeAws_json1_1QueryStatistics(output.statistics, context) : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1InvalidOperationException = function deserializeAws_json1_1InvalidOperationException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidParameterException = function deserializeAws_json1_1InvalidParameterException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidSequenceTokenException = function deserializeAws_json1_1InvalidSequenceTokenException(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function deserializeAws_json1_1LimitExceededException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListTagsLogGroupResponse = function deserializeAws_json1_1ListTagsLogGroupResponse(output, context) {
    return {
        tags: output.tags !== undefined && output.tags !== null ? deserializeAws_json1_1Tags(output.tags, context) : undefined
    };
};
var deserializeAws_json1_1LogGroup = function deserializeAws_json1_1LogGroup(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        kmsKeyId: output.kmsKeyId !== undefined && output.kmsKeyId !== null ? output.kmsKeyId : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricFilterCount: output.metricFilterCount !== undefined && output.metricFilterCount !== null ? output.metricFilterCount : undefined,
        retentionInDays: output.retentionInDays !== undefined && output.retentionInDays !== null ? output.retentionInDays : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined
    };
};
var deserializeAws_json1_1LogGroupField = function deserializeAws_json1_1LogGroupField(output, context) {
    return {
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        percent: output.percent !== undefined && output.percent !== null ? output.percent : undefined
    };
};
var deserializeAws_json1_1LogGroupFieldList = function deserializeAws_json1_1LogGroupFieldList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroupField(entry, context);
    });
};
var deserializeAws_json1_1LogGroupNames = function deserializeAws_json1_1LogGroupNames(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1LogGroups = function deserializeAws_json1_1LogGroups(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroup(entry, context);
    });
};
var deserializeAws_json1_1LogRecord = function deserializeAws_json1_1LogRecord(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1LogStream = function deserializeAws_json1_1LogStream(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        firstEventTimestamp: output.firstEventTimestamp !== undefined && output.firstEventTimestamp !== null ? output.firstEventTimestamp : undefined,
        lastEventTimestamp: output.lastEventTimestamp !== undefined && output.lastEventTimestamp !== null ? output.lastEventTimestamp : undefined,
        lastIngestionTime: output.lastIngestionTime !== undefined && output.lastIngestionTime !== null ? output.lastIngestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined,
        uploadSequenceToken: output.uploadSequenceToken !== undefined && output.uploadSequenceToken !== null ? output.uploadSequenceToken : undefined
    };
};
var deserializeAws_json1_1LogStreams = function deserializeAws_json1_1LogStreams(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogStream(entry, context);
    });
};
var deserializeAws_json1_1MalformedQueryException = function deserializeAws_json1_1MalformedQueryException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        queryCompileError: output.queryCompileError !== undefined && output.queryCompileError !== null ? deserializeAws_json1_1QueryCompileError(output.queryCompileError, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilter = function deserializeAws_json1_1MetricFilter(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricTransformations: output.metricTransformations !== undefined && output.metricTransformations !== null ? deserializeAws_json1_1MetricTransformations(output.metricTransformations, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilterMatches = function deserializeAws_json1_1MetricFilterMatches(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilterMatchRecord(entry, context);
    });
};
var deserializeAws_json1_1MetricFilterMatchRecord = function deserializeAws_json1_1MetricFilterMatchRecord(output, context) {
    return {
        eventMessage: output.eventMessage !== undefined && output.eventMessage !== null ? output.eventMessage : undefined,
        eventNumber: output.eventNumber !== undefined && output.eventNumber !== null ? output.eventNumber : undefined,
        extractedValues: output.extractedValues !== undefined && output.extractedValues !== null ? deserializeAws_json1_1ExtractedValues(output.extractedValues, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilters = function deserializeAws_json1_1MetricFilters(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilter(entry, context);
    });
};
var deserializeAws_json1_1MetricTransformation = function deserializeAws_json1_1MetricTransformation(output, context) {
    return {
        defaultValue: output.defaultValue !== undefined && output.defaultValue !== null ? output.defaultValue : undefined,
        metricName: output.metricName !== undefined && output.metricName !== null ? output.metricName : undefined,
        metricNamespace: output.metricNamespace !== undefined && output.metricNamespace !== null ? output.metricNamespace : undefined,
        metricValue: output.metricValue !== undefined && output.metricValue !== null ? output.metricValue : undefined
    };
};
var deserializeAws_json1_1MetricTransformations = function deserializeAws_json1_1MetricTransformations(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricTransformation(entry, context);
    });
};
var deserializeAws_json1_1OperationAbortedException = function deserializeAws_json1_1OperationAbortedException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1OutputLogEvent = function deserializeAws_json1_1OutputLogEvent(output, context) {
    return {
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1OutputLogEvents = function deserializeAws_json1_1OutputLogEvents(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1OutputLogEvent(entry, context);
    });
};
var deserializeAws_json1_1PutDestinationResponse = function deserializeAws_json1_1PutDestinationResponse(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? deserializeAws_json1_1Destination(output.destination, context) : undefined
    };
};
var deserializeAws_json1_1PutLogEventsResponse = function deserializeAws_json1_1PutLogEventsResponse(output, context) {
    return {
        nextSequenceToken: output.nextSequenceToken !== undefined && output.nextSequenceToken !== null ? output.nextSequenceToken : undefined,
        rejectedLogEventsInfo: output.rejectedLogEventsInfo !== undefined && output.rejectedLogEventsInfo !== null ? deserializeAws_json1_1RejectedLogEventsInfo(output.rejectedLogEventsInfo, context) : undefined
    };
};
var deserializeAws_json1_1PutQueryDefinitionResponse = function deserializeAws_json1_1PutQueryDefinitionResponse(output, context) {
    return {
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined
    };
};
var deserializeAws_json1_1PutResourcePolicyResponse = function deserializeAws_json1_1PutResourcePolicyResponse(output, context) {
    return {
        resourcePolicy: output.resourcePolicy !== undefined && output.resourcePolicy !== null ? deserializeAws_json1_1ResourcePolicy(output.resourcePolicy, context) : undefined
    };
};
var deserializeAws_json1_1QueryCompileError = function deserializeAws_json1_1QueryCompileError(output, context) {
    return {
        location: output.location !== undefined && output.location !== null ? deserializeAws_json1_1QueryCompileErrorLocation(output.location, context) : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1QueryCompileErrorLocation = function deserializeAws_json1_1QueryCompileErrorLocation(output, context) {
    return {
        endCharOffset: output.endCharOffset !== undefined && output.endCharOffset !== null ? output.endCharOffset : undefined,
        startCharOffset: output.startCharOffset !== undefined && output.startCharOffset !== null ? output.startCharOffset : undefined
    };
};
var deserializeAws_json1_1QueryDefinition = function deserializeAws_json1_1QueryDefinition(output, context) {
    return {
        lastModified: output.lastModified !== undefined && output.lastModified !== null ? output.lastModified : undefined,
        logGroupNames: output.logGroupNames !== undefined && output.logGroupNames !== null ? deserializeAws_json1_1LogGroupNames(output.logGroupNames, context) : undefined,
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined
    };
};
var deserializeAws_json1_1QueryDefinitionList = function deserializeAws_json1_1QueryDefinitionList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryDefinition(entry, context);
    });
};
var deserializeAws_json1_1QueryInfo = function deserializeAws_json1_1QueryInfo(output, context) {
    return {
        createTime: output.createTime !== undefined && output.createTime !== null ? output.createTime : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1QueryInfoList = function deserializeAws_json1_1QueryInfoList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryInfo(entry, context);
    });
};
var deserializeAws_json1_1QueryResults = function deserializeAws_json1_1QueryResults(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultRows(entry, context);
    });
};
var deserializeAws_json1_1QueryStatistics = function deserializeAws_json1_1QueryStatistics(output, context) {
    return {
        bytesScanned: output.bytesScanned !== undefined && output.bytesScanned !== null ? output.bytesScanned : undefined,
        recordsMatched: output.recordsMatched !== undefined && output.recordsMatched !== null ? output.recordsMatched : undefined,
        recordsScanned: output.recordsScanned !== undefined && output.recordsScanned !== null ? output.recordsScanned : undefined
    };
};
var deserializeAws_json1_1RejectedLogEventsInfo = function deserializeAws_json1_1RejectedLogEventsInfo(output, context) {
    return {
        expiredLogEventEndIndex: output.expiredLogEventEndIndex !== undefined && output.expiredLogEventEndIndex !== null ? output.expiredLogEventEndIndex : undefined,
        tooNewLogEventStartIndex: output.tooNewLogEventStartIndex !== undefined && output.tooNewLogEventStartIndex !== null ? output.tooNewLogEventStartIndex : undefined,
        tooOldLogEventEndIndex: output.tooOldLogEventEndIndex !== undefined && output.tooOldLogEventEndIndex !== null ? output.tooOldLogEventEndIndex : undefined
    };
};
var deserializeAws_json1_1ResourceAlreadyExistsException = function deserializeAws_json1_1ResourceAlreadyExistsException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function deserializeAws_json1_1ResourceNotFoundException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourcePolicies = function deserializeAws_json1_1ResourcePolicies(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResourcePolicy(entry, context);
    });
};
var deserializeAws_json1_1ResourcePolicy = function deserializeAws_json1_1ResourcePolicy(output, context) {
    return {
        lastUpdatedTime: output.lastUpdatedTime !== undefined && output.lastUpdatedTime !== null ? output.lastUpdatedTime : undefined,
        policyDocument: output.policyDocument !== undefined && output.policyDocument !== null ? output.policyDocument : undefined,
        policyName: output.policyName !== undefined && output.policyName !== null ? output.policyName : undefined
    };
};
var deserializeAws_json1_1ResultField = function deserializeAws_json1_1ResultField(output, context) {
    return {
        field: output.field !== undefined && output.field !== null ? output.field : undefined,
        value: output.value !== undefined && output.value !== null ? output.value : undefined
    };
};
var deserializeAws_json1_1ResultRows = function deserializeAws_json1_1ResultRows(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultField(entry, context);
    });
};
var deserializeAws_json1_1SearchedLogStream = function deserializeAws_json1_1SearchedLogStream(output, context) {
    return {
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        searchedCompletely: output.searchedCompletely !== undefined && output.searchedCompletely !== null ? output.searchedCompletely : undefined
    };
};
var deserializeAws_json1_1SearchedLogStreams = function deserializeAws_json1_1SearchedLogStreams(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SearchedLogStream(entry, context);
    });
};
var deserializeAws_json1_1ServiceUnavailableException = function deserializeAws_json1_1ServiceUnavailableException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1StartQueryResponse = function deserializeAws_json1_1StartQueryResponse(output, context) {
    return {
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined
    };
};
var deserializeAws_json1_1StopQueryResponse = function deserializeAws_json1_1StopQueryResponse(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilter = function deserializeAws_json1_1SubscriptionFilter(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationArn: output.destinationArn !== undefined && output.destinationArn !== null ? output.destinationArn : undefined,
        distribution: output.distribution !== undefined && output.distribution !== null ? output.distribution : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilters = function deserializeAws_json1_1SubscriptionFilters(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SubscriptionFilter(entry, context);
    });
};
var deserializeAws_json1_1Tags = function deserializeAws_json1_1Tags(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1TestMetricFilterResponse = function deserializeAws_json1_1TestMetricFilterResponse(output, context) {
    return {
        matches: output.matches !== undefined && output.matches !== null ? deserializeAws_json1_1MetricFilterMatches(output.matches, context) : undefined
    };
};
var deserializeAws_json1_1UnrecognizedClientException = function deserializeAws_json1_1UnrecognizedClientException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function buildHttpRpcRequest(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1RCV6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);

},{"./deserializerMiddleware":"3hbBu","./serializerMiddleware":"bUVil","./serdePlugin":"bbRvK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3hbBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", function() {
    return deserializerMiddleware;
});
var _tslib = require("tslib");
var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"4CYEX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4CYEX":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bUVil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", function() {
    return serializerMiddleware;
});
var _tslib = require("tslib");
var serializerMiddleware = function serializerMiddleware(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"4CYEX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bbRvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", function() {
    return deserializerMiddlewareOption;
});
parcelHelpers.export(exports, "serializerMiddlewareOption", function() {
    return serializerMiddlewareOption;
});
parcelHelpers.export(exports, "getSerdePlugin", function() {
    return getSerdePlugin;
});
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function applyToStack(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"3hbBu","./serializerMiddleware":"bUVil","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9C9RJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogStreamCommand", function() {
    return CreateLogStreamCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log stream for the specified log group. A log stream is a sequence of log events
 *       that originate from a single source, such as an application instance or a resource that is
 *       being monitored.</p>
 *          <p>There is no limit on the number of log streams that you can create for a log group. There is a limit
 *     of 50 TPS on <code>CreateLogStream</code> operations, after which transactions are throttled.</p>
 *          <p>You must use the following guidelines when naming a log stream:</p>
 *          <ul>
 *             <li>
 *                <p>Log stream names must be unique within the log group.</p>
 *             </li>
 *             <li>
 *                <p>Log stream names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>The ':' (colon) and '*' (asterisk) characters are not allowed.</p>
 *             </li>
 *          </ul>
 */ var CreateLogStreamCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogStreamCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogStreamCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogStreamRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function outputFilterSensitiveLog(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogStreamCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogStreamCommand)(input, context);
    };
    CreateLogStreamCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogStreamCommand)(output, context);
    };
    return CreateLogStreamCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6i2Hb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogGroupsCommand", function() {
    return DescribeLogGroupsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the specified log groups. You can list all your log groups or filter the results by prefix.
 *       The results are ASCII-sorted by log group name.</p>
 */ var DescribeLogGroupsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogGroupsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogGroupsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogGroupsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogGroupsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogGroupsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogGroupsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogGroupsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogGroupsCommand)(input, context);
    };
    DescribeLogGroupsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogGroupsCommand)(output, context);
    };
    return DescribeLogGroupsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ceYdg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogStreamsCommand", function() {
    return DescribeLogStreamsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the log streams for the specified log group.
 *       You can list all the log streams or filter the results by prefix.
 *       You can also control how the results are ordered.</p>
 *          <p>This operation has a limit of five transactions per second, after which transactions are throttled.</p>
 */ var DescribeLogStreamsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogStreamsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogStreamsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogStreamsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogStreamsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogStreamsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogStreamsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogStreamsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogStreamsCommand)(input, context);
    };
    DescribeLogStreamsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogStreamsCommand)(output, context);
    };
    return DescribeLogStreamsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"78xAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetLogEventsCommand", function() {
    return GetLogEventsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists log events from the specified log stream. You can list all of the log events or
 *       filter using a time range.</p>
 *
 *          <p>By default, this operation returns as many log events as can fit in a response size of 1MB (up to 10,000 log events).
 *       You can get additional log events by specifying one of the tokens in a subsequent call.
 *       This operation can return empty results while there are more log events available through the token.</p>
 */ var GetLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(GetLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.GetLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1GetLogEventsCommand)(input, context);
    };
    GetLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1GetLogEventsCommand)(output, context);
    };
    return GetLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kEN1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutLogEventsCommand", function() {
    return PutLogEventsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Uploads a batch of log events to the specified log stream.</p>
 *          <p>You must include the sequence token obtained from the response of the previous call. An
 *       upload in a newly created log stream does not require a sequence token. You can also get the
 *       sequence token in the <code>expectedSequenceToken</code> field from
 *         <code>InvalidSequenceTokenException</code>. If you call <code>PutLogEvents</code> twice
 *       within a narrow time period using the same value for <code>sequenceToken</code>, both calls
 *       might be successful or one might be rejected.</p>
 *          <p>The batch of events must satisfy the following constraints:</p>
 *          <ul>
 *             <li>
 *                <p>The maximum batch size is 1,048,576 bytes. This size is calculated as the sum of
 *           all event messages in UTF-8, plus 26 bytes for each log event.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be more than 2 hours in the future.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be older than 14 days or older than the retention
 *           period of the log group.</p>
 *             </li>
 *             <li>
 *                <p>The log events in the batch must be in chronological order by their timestamp. The
 *           timestamp is the time the event occurred, expressed as the number of milliseconds after
 *           Jan 1, 1970 00:00:00 UTC. (In AWS Tools for PowerShell and the AWS SDK for .NET, the
 *           timestamp is specified in .NET format: yyyy-mm-ddThh:mm:ss. For example,
 *           2017-09-15T13:45:30.) </p>
 *             </li>
 *             <li>
 *                <p>A batch of log events in a single request cannot span more than 24 hours. Otherwise, the operation fails.</p>
 *             </li>
 *             <li>
 *                <p>The maximum number of log events in a batch is 10,000.</p>
 *             </li>
 *             <li>
 *                <p>There is a quota of 5 requests per second per log stream. Additional requests are throttled. This quota can't be changed.</p>
 *             </li>
 *          </ul>
 *          <p>If a call to <code>PutLogEvents</code> returns "UnrecognizedClientException" the most likely cause is an invalid AWS access key ID or secret key. </p>
 */ var PutLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutLogEventsCommand)(input, context);
    };
    PutLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutLogEventsCommand)(output, context);
    };
    return PutLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpBPz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", function() {
    return GoogleOAuth;
});
parcelHelpers.export(exports, "FacebookOAuth", function() {
    return FacebookOAuth;
});
var _googleOAuth = require("./GoogleOAuth");
var _facebookOAuth = require("./FacebookOAuth");
var GoogleOAuth = new (0, _googleOAuth.GoogleOAuth)();
var FacebookOAuth = new (0, _facebookOAuth.FacebookOAuth)();

},{"./GoogleOAuth":"dthS6","./FacebookOAuth":"9IZHN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dthS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", function() {
    return GoogleOAuth;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)('CognitoCredentials');
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        logger.debug('google api already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var GoogleOAuth = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug('need to wait for the Google SDK loaded');
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, _js.browserOrNode)().isBrowser) ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    logger.debug('google Auth undefined');
                    rej(new (0, _util.NonRetryableError)('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === 'network_error') // Not using NonRetryableError so handler will be retried
                        rej('Network error reloading google auth response');
                        else rej(new (0, _util.NonRetryableError)('Failed to reload google auth response'));
                    });
                } else rej(new (0, _util.NonRetryableError)('User is not signed in with Google'));
            }).catch(function(err) {
                logger.debug('Failed to refresh google token', err);
                rej(new (0, _util.NonRetryableError)('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}();

},{"../Logger":"jVGZ5","../JS":"58R8D","../Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9IZHN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FacebookOAuth", function() {
    return FacebookOAuth;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)('CognitoCredentials');
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        logger.debug('FB SDK already loaded');
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var FacebookOAuth = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug('need to wait for the Facebook SDK loaded');
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, _js.browserOrNode)().isBrowser) fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            logger.debug(errorMessage);
            return Promise.reject(new (0, _util.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, _util.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        logger.debug(errorMessage);
                        rej(new (0, _util.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: 'public_profile,email'
            });
        });
    };
    return FacebookOAuth;
}();

},{"../Logger":"jVGZ5","../JS":"58R8D","../Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"knFIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsClass", function() {
    return CredentialsClass;
});
parcelHelpers.export(exports, "Credentials", function() {
    return Credentials;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var _storageHelper = require("./StorageHelper");
var _js = require("./JS");
var _oauthHelper = require("./OAuthHelper");
var _util = require("./Util");
var _amplify = require("./Amplify");
var _cognitoIdentity = require("./AwsClients/CognitoIdentity");
var _parseAWSExports = require("./parseAWSExports");
var _hub = require("./Hub");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)('Credentials');
var CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var COGNITO_IDENTITY_KEY_PREFIX = 'CognitoIdentityId-';
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var dispatchCredentialsEvent = function dispatchCredentialsEvent(event, data, message) {
    (0, _hub.Hub).dispatch('core', {
        event: event,
        data: data,
        message: message
    }, 'Credentials', AMPLIFY_SYMBOL);
};
var CredentialsClass = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = (0, _oauthHelper.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers['facebook'] = (0, _oauthHelper.FacebookOAuth).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = __assign(__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, _storageHelper.StorageHelper)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        dispatchCredentialsEvent('credentials_configured', null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat(COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            logger.debug('getting new cred promise');
            this._gettingCredPromise = (0, _js.makeQuerablePromise)(this._keepAlive());
        } else logger.debug('getting old cred promise');
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return __awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            logger.debug('credentials not changed and not expired, directly return');
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? (0, _amplify.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        logger.debug('Error attempting to refreshing the session', err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
            logger.debug('getting refreshed jwt token from federation provider');
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            logger.debug('no refresh handler for provider:', provider);
            this.clear();
            return Promise.reject('no refresh handler for provider');
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, _util.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === 'string' && e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) _this.clear();
            logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            logger.debug('no credentials for expiration check');
            return true;
        }
        logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        logger.debug('setting credentials for guest');
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject('cannot get guest credentials when mandatory signin enabled')
                        ];
                        if (!identityPoolId) {
                            logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [
                                2 /*return*/ ,
                                Promise.reject('No Cognito Identity pool provided for unauthenticated access')
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            logger.debug('region is not configured for getting the credentials');
                            return [
                                2 /*return*/ ,
                                Promise.reject('region is not configured for getting the credentials')
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function guestCredentialsProvider() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return __generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, 'guest', false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === 'ResourceNotFoundException' && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                logger.debug('Failed to load guest credentials');
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function guestCredentialsProvider_1() {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return __generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        return __generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, 'guest', false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com'
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject('You must specify a federated provider');
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!identityPoolRegion && !region) {
            logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function authenticatedCredentialsProvider() {
            return __awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!identityPoolRegion && !region) {
            logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function credentialsProvider() {
            return __awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return __awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug('Load credentials successfully', credentials);
                                if (this._identityId && !credentials.identityId) credentials['identityId'] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                                if (source === 'federated') {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        logger.debug('Failed to put federated info into auth storage', e);
                                    }
                                }
                                if (!(source === 'guest')) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    logger.debug('Failed to load credentials', credentials);
                    logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === 'session') return this._setCredentialsFromSession(params);
        else if (source === 'federation') return this._setCredentialsFromFederation(params);
        else if (source === 'guest') return this._setCredentialsForGuest();
        else {
            logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        logger.debug('Failed to get the cached guest identityId', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        logger.debug('Failed to cache guest identityId', e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return __generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var Credentials = new CredentialsClass(null);
(0, _amplify.Amplify).register(Credentials);

},{"./Logger":"jVGZ5","./StorageHelper":"5ekFt","./JS":"58R8D","./OAuthHelper":"hpBPz","./Util":"5E0Hy","./Amplify":"fr4N4","./AwsClients/CognitoIdentity":"dP4eT","./parseAWSExports":"jNxFP","./Hub":"5RtWX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ekFt":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", function() {
    return MemoryStorage;
});
parcelHelpers.export(exports, "StorageHelper", function() {
    return StorageHelper;
});
var dataMemory = {};
/** @class */ var MemoryStorage = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
var StorageHelper = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dP4eT":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", function() {
    return 0, _getId.getId;
});
parcelHelpers.export(exports, "getCredentialsForIdentity", function() {
    return 0, _getCredentialsForIdentity.getCredentialsForIdentity;
});
var _getId = require("./getId");
var _getCredentialsForIdentity = require("./getCredentialsForIdentity");

},{"./getId":"52QTt","./getCredentialsForIdentity":"jlmxN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"52QTt":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", function() {
    return getId;
});
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getIdSerializer = function getIdSerializer(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)('GetId');
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getIdDeserializer = function getIdDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getId = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getIdSerializer, getIdDeserializer, (0, _base.defaultConfig));

},{"./base":"5UjG1","../../clients":"cD43M","../../clients/internal":"ddv9k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5UjG1":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityTransferHandler", function() {
    return cognitoIdentityTransferHandler;
});
parcelHelpers.export(exports, "defaultConfig", function() {
    return defaultConfig;
});
parcelHelpers.export(exports, "getSharedHeaders", function() {
    return getSharedHeaders;
});
parcelHelpers.export(exports, "buildHttpRpcRequest", function() {
    return buildHttpRpcRequest;
});
var _clients = require("../../clients");
var _composeTransferHandler = require("../../clients/internal/composeTransferHandler");
var _retry = require("../../clients/middleware/retry");
var _platform = require("../../Platform");
var _detectFramework = require("../../Platform/detectFramework");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = 'cognito-identity';
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function endpointResolver(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, _clients.getDnsSuffix)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var disableCacheMiddleware = function disableCacheMiddleware() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    request.headers['cache-control'] = 'no-store';
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var cognitoIdentityTransferHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _clients.unauthenticatedHandler), [
    disableCacheMiddleware
]);
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _clients.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
(0, _detectFramework.observeFrameworkChanges)(function() {
    defaultConfig.userAgentValue = (0, _platform.getAmplifyUserAgent)();
});
var getSharedHeaders = function getSharedHeaders(operation) {
    return {
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': "AWSCognitoIdentityService.".concat(operation)
    };
};
var buildHttpRpcRequest = function buildHttpRpcRequest(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: 'POST'
    };
};

},{"../../clients":"cD43M","../../clients/internal/composeTransferHandler":"gZ7pH","../../clients/middleware/retry":"4tNHX","../../Platform":"jNyBX","../../Platform/detectFramework":"kTkOK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cD43M":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", function() {
    return 0, _endpoints.getDnsSuffix;
});
parcelHelpers.export(exports, "fetchTransferHandler", function() {
    return 0, _fetch.fetchTransferHandler;
});
parcelHelpers.export(exports, "unauthenticatedHandler", function() {
    return 0, _unauthenticated.unauthenticatedHandler;
});
parcelHelpers.export(exports, "authenticatedHandler", function() {
    return 0, _authenticated.authenticatedHandler;
});
parcelHelpers.export(exports, "getHashedPayload", function() {
    return 0, _signatureV4.getHashedPayload;
});
parcelHelpers.export(exports, "presignUrl", function() {
    return 0, _signatureV4.presignUrl;
});
parcelHelpers.export(exports, "signRequest", function() {
    return 0, _signatureV4.signRequest;
});
parcelHelpers.export(exports, "EMPTY_SHA256_HASH", function() {
    return 0, _constants.EMPTY_HASH;
});
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return 0, _extendedEncodeURIComponent.extendedEncodeURIComponent;
});
parcelHelpers.export(exports, "signingMiddleware", function() {
    return 0, _signing.signingMiddleware;
});
parcelHelpers.export(exports, "getRetryDecider", function() {
    return 0, _retry.getRetryDecider;
});
parcelHelpers.export(exports, "jitteredBackoff", function() {
    return 0, _retry.jitteredBackoff;
});
parcelHelpers.export(exports, "retryMiddleware", function() {
    return 0, _retry.retryMiddleware;
});
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return 0, _userAgent.userAgentMiddleware;
});
parcelHelpers.export(exports, "parseJsonBody", function() {
    return 0, _serde.parseJsonBody;
});
parcelHelpers.export(exports, "parseJsonError", function() {
    return 0, _serde.parseJsonError;
});
parcelHelpers.export(exports, "parseMetadata", function() {
    return 0, _serde.parseMetadata;
});
parcelHelpers.export(exports, "withMemoization", function() {
    return 0, _memoization.withMemoization;
});
var _endpoints = require("./endpoints");
var _fetch = require("./handlers/fetch");
var _unauthenticated = require("./handlers/unauthenticated");
var _authenticated = require("./handlers/authenticated");
var _signatureV4 = require("./middleware/signing/signer/signatureV4");
var _constants = require("./middleware/signing/signer/signatureV4/constants");
var _extendedEncodeURIComponent = require("./middleware/signing/utils/extendedEncodeURIComponent");
var _signing = require("./middleware/signing");
var _retry = require("./middleware/retry");
var _userAgent = require("./middleware/userAgent");
var _serde = require("./serde");
var _memoization = require("./utils/memoization");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./endpoints":"dNrJb","./handlers/fetch":false,"./handlers/unauthenticated":"cqaZL","./handlers/authenticated":false,"./middleware/signing/signer/signatureV4":"2tT6s","./middleware/signing/signer/signatureV4/constants":"frxal","./middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","./middleware/signing":"9ytdg","./middleware/retry":"4tNHX","./middleware/userAgent":"gWdeK","./serde":"g2QPG","./utils/memoization":"dTJWW","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dNrJb":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", function() {
    return 0, _getDnsSuffix.getDnsSuffix;
});
var _getDnsSuffix = require("./getDnsSuffix");

},{"./getDnsSuffix":"OF1rB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OF1rB":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", function() {
    return getDnsSuffix;
});
var _partitions = require("./partitions");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getDnsSuffix = function getDnsSuffix(region) {
    var e_1, _a;
    var partitions = (0, _partitions.partitionsInfo).partitions;
    try {
        for(var partitions_1 = __values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _partitions.defaultPartition).outputs.dnsSuffix;
};

},{"./partitions":"kNHAa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNHAa":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPartition", function() {
    return defaultPartition;
});
parcelHelpers.export(exports, "partitionsInfo", function() {
    return partitionsInfo;
});
var defaultPartition = {
    id: 'aws',
    outputs: {
        dnsSuffix: 'amazonaws.com'
    },
    regionRegex: '^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$',
    regions: [
        'aws-global'
    ]
};
var partitionsInfo = {
    partitions: [
        defaultPartition,
        {
            id: 'aws-cn',
            outputs: {
                dnsSuffix: 'amazonaws.com.cn'
            },
            regionRegex: '^cn\\-\\w+\\-\\d+$',
            regions: [
                'aws-cn-global'
            ]
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"GHQhD":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTransferHandler", function() {
    return fetchTransferHandler;
});
var _isomorphicUnfetch = require("isomorphic-unfetch"); // TODO: remove this dependency in v6
var _memoization = require("../utils/memoization");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var shouldSendBody = function shouldSendBody(method) {
    return ![
        'HEAD',
        'GET',
        'DELETE'
    ].includes(method.toUpperCase());
};
var fetchTransferHandler = function fetchTransferHandler(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return __awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return __generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error('Network error');
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, _memoization.withMemoization)(function() {
                            return resp.text();
                        }),
                        blob: (0, _memoization.withMemoization)(function() {
                            return resp.blob();
                        }),
                        json: (0, _memoization.withMemoization)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};

},{"isomorphic-unfetch":"cSe6x","../utils/memoization":"dTJWW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cSe6x":[function(require,module,exports,__globalThis) {
module.exports = self.fetch || (self.fetch = require("b3738725eb27f9ce").default || require("b3738725eb27f9ce"));

},{"b3738725eb27f9ce":"bNOnZ"}],"bNOnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(e, n) {
        return n = n || {}, new Promise(function(t, r) {
            var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function a1() {
                return {
                    ok: 2 == (s.status / 100 | 0),
                    statusText: s.statusText,
                    status: s.status,
                    url: s.responseURL,
                    text: function text() {
                        return Promise.resolve(s.responseText);
                    },
                    json: function json() {
                        return Promise.resolve(s.responseText).then(JSON.parse);
                    },
                    blob: function blob() {
                        return Promise.resolve(new Blob([
                            s.response
                        ]));
                    },
                    clone: a,
                    headers: {
                        keys: function keys() {
                            return o;
                        },
                        entries: function entries() {
                            return u;
                        },
                        get: function get(e) {
                            return i[e.toLowerCase()];
                        },
                        has: function has(e) {
                            return e.toLowerCase() in i;
                        }
                    }
                };
            };
            for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
                s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                    o.push(n = n.toLowerCase()), u.push([
                        n,
                        t
                    ]), i[n] = i[n] ? i[n] + "," + t : t;
                }), t(a());
            }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
            s.send(n.body || null);
        });
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dTJWW":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withMemoization", function() {
    return withMemoization;
});
var withMemoization = function withMemoization(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cqaZL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unauthenticatedHandler", function() {
    return unauthenticatedHandler;
});
var _retry = require("../middleware/retry");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var unauthenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware)
]);

},{"../middleware/retry":"4tNHX","../middleware/userAgent":"gWdeK","../internal/composeTransferHandler":"gZ7pH","./fetch":"GHQhD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tNHX":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return 0, _middleware.retryMiddleware;
});
parcelHelpers.export(exports, "jitteredBackoff", function() {
    return 0, _jitteredBackoff.jitteredBackoff;
});
parcelHelpers.export(exports, "getRetryDecider", function() {
    return 0, _defaultRetryDecider.getRetryDecider;
});
var _middleware = require("./middleware");
var _jitteredBackoff = require("./jitteredBackoff");
var _defaultRetryDecider = require("./defaultRetryDecider");

},{"./middleware":"g2hxw","./jitteredBackoff":"7Lxk8","./defaultRetryDecider":"hjJfJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g2hxw":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return retryMiddleware;
});
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var DEFAULT_RETRY_ATTEMPTS = 3;
var retryMiddleware = function retryMiddleware(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error('maxAttempts must be greater than 0');
    return function(next, context) {
        return function retryMiddleware(request) {
            var _$_a;
            return __awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_$_a = context.attemptsCount) !== null && _$_a !== void 0 ? _$_a : 0;
                            handleTerminalErrorOrResponse = function handleTerminalErrorOrResponse() {
                                if (response) {
                                    addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error('Request aborted.');
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var cancellableSleep = function cancellableSleep(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener('abort', function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener('abort', cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var addOrIncrementMetadataAttempts = function addOrIncrementMetadataAttempts(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== '[object Object]') return;
    nextHandlerOutput['$metadata'] = __assign(__assign({}, (_a = nextHandlerOutput['$metadata']) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Lxk8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredBackoff", function() {
    return jitteredBackoff;
});
var _retry = require("../../../Util/Retry");
var DEFAULT_MAX_DELAY_MS = 300000;
var jitteredBackoff = function jitteredBackoff(attempt) {
    var delayFunction = (0, _retry.jitteredBackoff)(DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? DEFAULT_MAX_DELAY_MS : delay;
};

},{"../../../Util/Retry":"2d9ab","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hjJfJ":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRetryDecider", function() {
    return getRetryDecider;
});
var _isClockSkewError = require("./isClockSkewError");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getRetryDecider = function getRetryDecider(errorParser) {
    return function(response, error) {
        return __awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            isConnectionError(error) || isThrottlingError(statusCode, errorCode) || (0, _isClockSkewError.isClockSkewError)(errorCode) || isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var THROTTLING_ERROR_CODES = [
    'BandwidthLimitExceeded',
    'EC2ThrottledException',
    'LimitExceededException',
    'PriorRequestNotComplete',
    'ProvisionedThroughputExceededException',
    'RequestLimitExceeded',
    'RequestThrottled',
    'RequestThrottledException',
    'SlowDown',
    'ThrottledException',
    'Throttling',
    'ThrottlingException',
    'TooManyRequestsException'
];
var TIMEOUT_ERROR_CODES = [
    'TimeoutError',
    'RequestTimeout',
    'RequestTimeoutException'
];
var isThrottlingError = function isThrottlingError(statusCode, errorCode) {
    return statusCode === 429 || THROTTLING_ERROR_CODES.includes(errorCode);
};
var isConnectionError = function isConnectionError(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === 'Network error';
};
var isServerSideError = function isServerSideError(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || TIMEOUT_ERROR_CODES.includes(errorCode);
};

},{"./isClockSkewError":"gCLt9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCLt9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewError", function() {
    return isClockSkewError;
});
var CLOCK_SKEW_ERROR_CODES = [
    'AuthFailure',
    'InvalidSignatureException',
    'RequestExpired',
    'RequestInTheFuture',
    'RequestTimeTooSkewed',
    'SignatureDoesNotMatch',
    'BadRequestException'
];
var isClockSkewError = function isClockSkewError(errorCode) {
    return CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gWdeK":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return 0, _middleware.userAgentMiddleware;
});
var _middleware = require("./middleware");

},{"./middleware":"i8RBu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8RBu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return userAgentMiddleware;
});
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var userAgentMiddleware = function userAgentMiddleware(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? 'x-amz-user-agent' : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? '' : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZ7pH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeTransferHandler", function() {
    return composeTransferHandler;
});
var composeTransferHandler = function composeTransferHandler(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function composedHandler(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bO3n6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticatedHandler", function() {
    return authenticatedHandler;
});
var _retry = require("../middleware/retry");
var _signing = require("../middleware/signing");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var authenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware),
    (0, _signing.signingMiddleware)
]);

},{"../middleware/retry":"4tNHX","../middleware/signing":"9ytdg","../middleware/userAgent":"gWdeK","../internal/composeTransferHandler":"gZ7pH","./fetch":"GHQhD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ytdg":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", function() {
    return 0, _middleware.signingMiddleware;
});
var _middleware = require("./middleware");

},{"./middleware":"g7THz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g7THz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", function() {
    return signingMiddleware;
});
var _signatureV4 = require("./signer/signatureV4");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var signingMiddleware = function signingMiddleware(_a) {
    var credentials = _a.credentials, region = _a.region, service = _a.service, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
    var currentSystemClockOffset;
    return function(next) {
        return function signingMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var signRequestOptions, _$_a, signedRequest, response, dateString;
                var _b;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
                            _b = {};
                            if (!(typeof credentials === 'function')) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                credentials()
                            ];
                        case 1:
                            _$_a = _c.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _$_a = credentials;
                            _c.label = 3;
                        case 3:
                            signRequestOptions = (_b.credentials = _$_a, _b.signingDate = (0, _getSkewCorrectedDate.getSkewCorrectedDate)(currentSystemClockOffset), _b.signingRegion = region, _b.signingService = service, _b.uriEscapePath = uriEscapePath, _b);
                            return [
                                4 /*yield*/ ,
                                (0, _signatureV4.signRequest)(request, signRequestOptions)
                            ];
                        case 4:
                            signedRequest = _c.sent();
                            return [
                                4 /*yield*/ ,
                                next(signedRequest)
                            ];
                        case 5:
                            response = _c.sent();
                            dateString = getDateHeader(response);
                            if (dateString) currentSystemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function getDateHeader(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, headers = _d.headers;
    return (_c = (_b = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _b !== void 0 ? _b : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _c !== void 0 ? _c : headers === null || headers === void 0 ? void 0 : headers['x-amz-date'];
};

},{"./signer/signatureV4":"2tT6s","./utils/getSkewCorrectedDate":"7UTN1","./utils/getUpdatedSystemClockOffset":"4qK3e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7UTN1":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", function() {
    return getSkewCorrectedDate;
});
var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4qK3e":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", function() {
    return getUpdatedSystemClockOffset;
});
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function getUpdatedSystemClockOffset(clockTimeInMilliseconds, currentSystemClockOffset) {
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"gMoJz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMoJz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", function() {
    return isClockSkewed;
});
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
var SKEW_WINDOW = 300000;
var isClockSkewed = function isClockSkewed(clockTimeInMilliseconds, clockOffsetInMilliseconds) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= SKEW_WINDOW;
};

},{"./getSkewCorrectedDate":"7UTN1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gx4L4":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Wraps encodeURIComponent to encode additional characters to fully adhere to RFC 3986.
 * @see https://github.com/aws/aws-sdk-js-v3/blob/86b432c464150069678b25ff88d57c2ca26e75a2/packages/smithy-client/src/extended-encode-uri-component.ts#L7
 *
 * @param uri URI string to encode
 * @returns RFC 3986 encoded string
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return extendedEncodeURIComponent;
});
var extendedEncodeURIComponent = function extendedEncodeURIComponent(uri) {
    // Match characters normally not encoded by `encodeURIComponent`
    var extendedCharacters = /[!'()*]/g;
    return encodeURIComponent(uri).replace(extendedCharacters, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g2QPG":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", function() {
    return 0, _responseInfo.parseMetadata;
});
parcelHelpers.export(exports, "parseJsonBody", function() {
    return 0, _json.parseJsonBody;
});
parcelHelpers.export(exports, "parseJsonError", function() {
    return 0, _json.parseJsonError;
});
var _responseInfo = require("./responseInfo");
var _json = require("./json");

},{"./responseInfo":"d9FuD","./json":"jR1RV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9FuD":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", function() {
    return parseMetadata;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var parseMetadata = function parseMetadata(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return __assign(__assign({}, isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers['x-amzn-requestid']) !== null && _a !== void 0 ? _a : headers['x-amzn-request-id']) !== null && _b !== void 0 ? _b : headers['x-amz-request-id'],
        extendedRequestId: headers['x-amz-id-2'],
        cfId: headers['x-amz-cf-id']
    });
};
var isMetadataBearer = function isMetadataBearer(response) {
    return (0, _typeOf._)(response === null || response === void 0 ? void 0 : response['$metadata']) === 'object';
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jR1RV":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonError", function() {
    return parseJsonError;
});
parcelHelpers.export(exports, "parseJsonBody", function() {
    return parseJsonBody;
});
var _responseInfo = require("./responseInfo");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var parseJsonError = function parseJsonError(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        parseJsonBody(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
                        var _a = __read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes('#')) return cleanValue.split('#')[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers['x-amzn-errortype']) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : 'UnknownError');
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : 'Unknown error';
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseJsonBody = function parseJsonBody(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var output;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error('Missing response payload');
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};

},{"./responseInfo":"d9FuD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddv9k":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This index should NOT be included in the ../index.ts because the composer functions
 * here requires TypeScript >= 4. Given other scoped packages may use TypeScript < 4,
 * they should not be exposed to upper level index.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", function() {
    return 0, _composeServiceApi.composeServiceApi;
});
parcelHelpers.export(exports, "composeTransferHandler", function() {
    return 0, _composeTransferHandler.composeTransferHandler;
});
var _composeServiceApi = require("./composeServiceApi");
var _composeTransferHandler = require("./composeTransferHandler");

},{"./composeServiceApi":"5aofV","./composeTransferHandler":"gZ7pH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5aofV":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", function() {
    return composeServiceApi;
});
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var composeServiceApi = function composeServiceApi(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return __awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = __assign(__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, __assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jlmxN":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialsForIdentity", function() {
    return getCredentialsForIdentity;
});
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getCredentialsForIdentitySerializer = function getCredentialsForIdentitySerializer(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)('GetCredentialsForIdentity');
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getCredentialsForIdentityDeserializer = function getCredentialsForIdentityDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: deserializeCredentials(body.Credentials),
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var deserializeCredentials = function deserializeCredentials(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output['AccessKeyId'],
        SecretKey: output['SecretKey'],
        SessionToken: output['SessionToken'],
        Expiration: new Date(output['Expiration'] * 1000)
    };
};
var getCredentialsForIdentity = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getCredentialsForIdentitySerializer, getCredentialsForIdentityDeserializer, (0, _base.defaultConfig));

},{"./base":"5UjG1","../../clients":"cD43M","../../clients/internal":"ddv9k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kspiO":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorker", function() {
    return 0, _serviceWorker.ServiceWorkerClass;
});
var _serviceWorker = require("./ServiceWorker");

},{"./ServiceWorker":"O7sSM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"O7sSM":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorkerClass", function() {
    return ServiceWorkerClass;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _logger = require("../Logger");
var _js = require("../JS");
var _amplify = require("../Amplify");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var ServiceWorkerClass = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, _logger.ConsoleLogger)('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function get() {
            return this._serviceWorker;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = '/service-worker.js';
        if (scope === void 0) scope = '/';
        this._logger.debug("registering ".concat(filePath));
        this._logger.debug("registering service worker with scope ".concat(scope));
        return new Promise(function(resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: ".concat(registration));
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed ".concat(error));
                return reject(error);
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, _js.browserOrNode)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: ".concat(JSON.stringify(subscription)));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: ".concat(JSON.stringify(subscription)));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error('Service Worker not available'));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage((typeof message === "undefined" ? "undefined" : (0, _typeOf._)(message)) === 'object' ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: ".concat(currentState));
            if ((0, _amplify.Amplify).Analytics && typeof (0, _amplify.Amplify).Analytics.record === 'function') (0, _amplify.Amplify).Analytics.record({
                name: 'ServiceWorker',
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener('message', function(event) {
            _this._logger.debug("ServiceWorker message event: ".concat(event));
        });
    };
    return ServiceWorkerClass;
}();

},{"@swc/helpers/_/_type_of":"668P4","../Logger":"jVGZ5","../JS":"58R8D","../Amplify":"fr4N4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8JhHm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniversalStorage", function() {
    return UniversalStorage;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _universalCookie = require("universal-cookie");
var _universalCookieDefault = parcelHelpers.interopDefault(_universalCookie);
var _js = require("../JS");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isBrowser = (0, _js.browserOrNode)().isBrowser;
var ONE_YEAR_IN_MS = 31536000000;
var UniversalStorage = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, _universalCookieDefault.default)();
        this.store = isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, _universalCookieDefault.default)(decodeURIComponent(context.req.headers.cookie)) : new (0, _universalCookieDefault.default)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function get() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: '/'
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        var sessionTokenTypes = [
            'LastAuthUser',
            'accessToken',
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            'refreshToken',
            // Required for CognitoUserSession
            'idToken'
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : '')) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, __assign(__assign({}, options), {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: isBrowser && window.location.hostname === 'localhost' ? false : true
        }));
    };
    return UniversalStorage;
}();

},{"universal-cookie":"ltyKT","../JS":"58R8D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ltyKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Cookies;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var cookie = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ var hasRequiredCookie;
function requireCookie() {
    if (hasRequiredCookie) return cookie;
    hasRequiredCookie = 1;
    /**
	 * Module exports.
	 * @public
	 */ cookie.parse = parse;
    cookie.serialize = serialize;
    /**
	 * Module variables.
	 * @private
	 */ var __toString = Object.prototype.toString;
    var __hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
	 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
	 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
	 * which has been replaced by the token definition in RFC 7230 appendix B.
	 *
	 * cookie-name       = token
	 * token             = 1*tchar
	 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
	 *                     "*" / "+" / "-" / "." / "^" / "_" /
	 *                     "`" / "|" / "~" / DIGIT / ALPHA
	 */ var cookieNameRegExp = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
    /**
	 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
	 *
	 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
	 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
	 *                     ; US-ASCII characters excluding CTLs,
	 *                     ; whitespace DQUOTE, comma, semicolon,
	 *                     ; and backslash
	 */ var cookieValueRegExp = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/;
    /**
	 * RegExp to match domain-value in RFC 6265 sec 4.1.1
	 *
	 * domain-value      = <subdomain>
	 *                     ; defined in [RFC1034], Section 3.5, as
	 *                     ; enhanced by [RFC1123], Section 2.1
	 * <subdomain>       = <label> | <subdomain> "." <label>
	 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
	 *                     Labels must be 63 characters or less.
	 *                     'let-dig' not 'letter' in the first char, per RFC1123
	 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	 * <let-dig-hyp>     = <let-dig> | "-"
	 * <let-dig>         = <letter> | <digit>
	 * <letter>          = any one of the 52 alphabetic characters A through Z in
	 *                     upper case and a through z in lower case
	 * <digit>           = any one of the ten digits 0 through 9
	 *
	 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
	 *
	 * > (Note that a leading %x2E ("."), if present, is ignored even though that
	 * character is not permitted, but a trailing %x2E ("."), if present, will
	 * cause the user agent to ignore the attribute.)
	 */ var domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
    /**
	 * RegExp to match path-value in RFC 6265 sec 4.1.1
	 *
	 * path-value        = <any CHAR except CTLs or ";">
	 * CHAR              = %x01-7F
	 *                     ; defined in RFC 5234 appendix B.1
	 */ var pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
    /**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [opt]
	 * @return {object}
	 * @public
	 */ function parse(str, opt) {
        if (typeof str !== 'string') throw new TypeError('argument str must be a string');
        var obj = {};
        var len = str.length;
        // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
        if (len < 2) return obj;
        var dec = opt && opt.decode || decode;
        var index = 0;
        var eqIdx = 0;
        var endIdx = 0;
        do {
            eqIdx = str.indexOf('=', index);
            if (eqIdx === -1) break; // No more cookie pairs.
            endIdx = str.indexOf(';', index);
            if (endIdx === -1) endIdx = len;
            else if (eqIdx > endIdx) {
                // backtrack on prior semicolon
                index = str.lastIndexOf(';', eqIdx - 1) + 1;
                continue;
            }
            var keyStartIdx = startIndex(str, index, eqIdx);
            var keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
            var key = str.slice(keyStartIdx, keyEndIdx);
            // only assign once
            if (!__hasOwnProperty.call(obj, key)) {
                var valStartIdx = startIndex(str, eqIdx + 1, endIdx);
                var valEndIdx = endIndex(str, endIdx, valStartIdx);
                if (str.charCodeAt(valStartIdx) === 0x22 /* " */  && str.charCodeAt(valEndIdx - 1) === 0x22 /* " */ ) {
                    valStartIdx++;
                    valEndIdx--;
                }
                var val = str.slice(valStartIdx, valEndIdx);
                obj[key] = tryDecode(val, dec);
            }
            index = endIdx + 1;
        }while (index < len);
        return obj;
    }
    function startIndex(str, index, max) {
        do {
            var code = str.charCodeAt(index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
        }while (++index < max);
        return max;
    }
    function endIndex(str, index, min) {
        while(index > min){
            var code = str.charCodeAt(--index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
        }
        return min;
    }
    /**
	 * Serialize data into a cookie header.
	 *
	 * Serialize a name value pair into a cookie string suitable for
	 * http headers. An optional options object specifies cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [opt]
	 * @return {string}
	 * @public
	 */ function serialize(name, val, opt) {
        var enc = opt && opt.encode || encodeURIComponent;
        if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
        if (!cookieNameRegExp.test(name)) throw new TypeError('argument name is invalid');
        var value = enc(val);
        if (!cookieValueRegExp.test(value)) throw new TypeError('argument val is invalid');
        var str = name + '=' + value;
        if (!opt) return str;
        if (null != opt.maxAge) {
            var maxAge = Math.floor(opt.maxAge);
            if (!isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
            str += '; Max-Age=' + maxAge;
        }
        if (opt.domain) {
            if (!domainValueRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
            str += '; Domain=' + opt.domain;
        }
        if (opt.path) {
            if (!pathValueRegExp.test(opt.path)) throw new TypeError('option path is invalid');
            str += '; Path=' + opt.path;
        }
        if (opt.expires) {
            var expires = opt.expires;
            if (!isDate(expires) || isNaN(expires.valueOf())) throw new TypeError('option expires is invalid');
            str += '; Expires=' + expires.toUTCString();
        }
        if (opt.httpOnly) str += '; HttpOnly';
        if (opt.secure) str += '; Secure';
        if (opt.partitioned) str += '; Partitioned';
        if (opt.priority) {
            var priority = typeof opt.priority === 'string' ? opt.priority.toLowerCase() : opt.priority;
            switch(priority){
                case 'low':
                    str += '; Priority=Low';
                    break;
                case 'medium':
                    str += '; Priority=Medium';
                    break;
                case 'high':
                    str += '; Priority=High';
                    break;
                default:
                    throw new TypeError('option priority is invalid');
            }
        }
        if (opt.sameSite) {
            var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
            switch(sameSite){
                case true:
                    str += '; SameSite=Strict';
                    break;
                case 'lax':
                    str += '; SameSite=Lax';
                    break;
                case 'strict':
                    str += '; SameSite=Strict';
                    break;
                case 'none':
                    str += '; SameSite=None';
                    break;
                default:
                    throw new TypeError('option sameSite is invalid');
            }
        }
        return str;
    }
    /**
	 * URL-decode string value. Optimized to skip native call when no %.
	 *
	 * @param {string} str
	 * @returns {string}
	 */ function decode(str) {
        return str.indexOf('%') !== -1 ? decodeURIComponent(str) : str;
    }
    /**
	 * Determine if value is a Date.
	 *
	 * @param {*} val
	 * @private
	 */ function isDate(val) {
        return __toString.call(val) === '[object Date]';
    }
    /**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */ function tryDecode(str, decode) {
        try {
            return decode(str);
        } catch (e) {
            return str;
        }
    }
    return cookie;
}
var cookieExports = requireCookie();
function hasDocumentCookie() {
    var testingValue = typeof global === 'undefined' ? undefined : global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') return testingValue;
    // Can we get/set cookies on document.cookie?
    return (typeof document === "undefined" ? "undefined" : (0, _typeOf._)(document)) === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') return cookieExports.parse(cookies);
    else if ((typeof cookies === "undefined" ? "undefined" : (0, _typeOf._)(cookies)) === 'object' && cookies !== null) return cookies;
    else return {};
}
function readCookie(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var cleanValue = cleanupCookieValue(value);
    if (!options.doNotParse) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}
var Cookies = /*#__PURE__*/ function() {
    "use strict";
    function Cookies(cookies) {
        var _this = this;
        var defaultSetOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, Cookies);
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = function() {
            if (!_this.HAS_DOCUMENT_COOKIE) return;
            var previousCookies = _this.cookies;
            _this.cookies = cookieExports.parse(document.cookie);
            _this._checkChanges(previousCookies);
        };
        var domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }
    (0, _createClass._)(Cookies, [
        {
            key: "_emitChange",
            value: function _emitChange(params) {
                for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
            }
        },
        {
            key: "_checkChanges",
            value: function _checkChanges(previousCookies) {
                var _this = this;
                var names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
                names.forEach(function(name) {
                    if (previousCookies[name] !== _this.cookies[name]) _this._emitChange({
                        name: name,
                        value: readCookie(_this.cookies[name])
                    });
                });
            }
        },
        {
            key: "_startPolling",
            value: function _startPolling() {
                this.pollingInterval = setInterval(this.update, 300);
            }
        },
        {
            key: "_stopPolling",
            value: function _stopPolling() {
                if (this.pollingInterval) clearInterval(this.pollingInterval);
            }
        },
        {
            key: "get",
            value: function get(name) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!options.doNotUpdate) this.update();
                return readCookie(this.cookies[name], options);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (!options.doNotUpdate) this.update();
                var result = {};
                for(var name in this.cookies)result[name] = readCookie(this.cookies[name], options);
                return result;
            }
        },
        {
            key: "set",
            value: function set(name, value, options) {
                if (options) options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
                else options = this.defaultSetOptions;
                var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
                this.cookies = Object.assign(Object.assign({}, this.cookies), (0, _defineProperty._)({}, name, stringValue));
                if (this.HAS_DOCUMENT_COOKIE) document.cookie = cookieExports.serialize(name, stringValue, options);
                this._emitChange({
                    name: name,
                    value: value,
                    options: options
                });
            }
        },
        {
            key: "remove",
            value: function remove(name, options) {
                var finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), {
                    expires: new Date(1970, 1, 1, 0, 0, 1),
                    maxAge: 0
                });
                this.cookies = Object.assign({}, this.cookies);
                delete this.cookies[name];
                if (this.HAS_DOCUMENT_COOKIE) document.cookie = cookieExports.serialize(name, '', finalOptions);
                this._emitChange({
                    name: name,
                    value: undefined,
                    options: options
                });
            }
        },
        {
            key: "addChangeListener",
            value: function addChangeListener(callback) {
                this.changeListeners.push(callback);
                if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
                    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === 'object' && 'cookieStore' in window) window.cookieStore.addEventListener('change', this.update);
                    else this._startPolling();
                }
            }
        },
        {
            key: "removeChangeListener",
            value: function removeChangeListener(callback) {
                var idx = this.changeListeners.indexOf(callback);
                if (idx >= 0) this.changeListeners.splice(idx, 1);
                if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
                    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === 'object' && 'cookieStore' in window) window.cookieStore.removeEventListener('change', this.update);
                    else this._stopPolling();
                }
            }
        }
    ]);
    return Cookies;
}();

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9EBwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k7tiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jxe0I":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function() {
    return INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER;
});
parcelHelpers.export(exports, "USER_AGENT_HEADER", function() {
    return USER_AGENT_HEADER;
});
var hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER = hasSymbol ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER') : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var USER_AGENT_HEADER = 'x-amz-user-agent';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4FqWo":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Analytics", function() {
    return 0, _analytics.Analytics;
});
parcelHelpers.export(exports, "AWSPinpointProvider", function() {
    return 0, _providers.AWSPinpointProvider;
});
parcelHelpers.export(exports, "AWSKinesisProvider", function() {
    return 0, _providers.AWSKinesisProvider;
});
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", function() {
    return 0, _providers.AWSKinesisFirehoseProvider;
});
parcelHelpers.export(exports, "AmazonPersonalizeProvider", function() {
    return 0, _providers.AmazonPersonalizeProvider;
});
var _analytics = require("./Analytics");
var _providers = require("./Providers");

},{"./Analytics":"l22sr","./Providers":"nvQ6G","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l22sr":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsClass", function() {
    return AnalyticsClass;
});
parcelHelpers.export(exports, "Analytics", function() {
    return Analytics;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awspinpointProvider = require("./Providers/AWSPinpointProvider");
var _trackers = require("./trackers");
var logger = new (0, _core.ConsoleLogger)('AnalyticsClass');
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var dispatchAnalyticsEvent = function dispatchAnalyticsEvent(event, data, message) {
    (0, _core.Hub).dispatch('analytics', {
        event: event,
        data: data,
        message: message
    }, 'Analytics', AMPLIFY_SYMBOL);
};
var trackers = {
    pageView: (0, _trackers.PageViewTracker),
    event: (0, _trackers.EventTracker),
    session: (0, _trackers.SessionTracker)
};
var _instance = null;
/**
 * Provide mobile analytics client functions
 */ var AnalyticsClass = /** @class */ function() {
    /**
     * Initialize Analtyics
     * @param config - Configuration of the Analytics
     */ function AnalyticsClass() {
        this._config = {};
        this._pluggables = [];
        this._disabled = false;
        this._trackers = {};
        _instance = this;
        this.record = this.record.bind(this);
        (0, _core.Hub).listen('auth', listener);
        (0, _core.Hub).listen('storage', listener);
        (0, _core.Hub).listen('analytics', listener);
        (0, _core.Hub).listen('core', listener);
    }
    AnalyticsClass.prototype.getModuleName = function() {
        return 'Analytics';
    };
    /**
     * configure Analytics
     * @param {Object} config - Configuration of the Analytics
     */ AnalyticsClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        logger.debug('configure Analytics', config);
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Analytics, config);
        if (this._config['disabled']) this._disabled = true;
        // turn on the autoSessionRecord if not specified
        if (this._config['autoSessionRecord'] === undefined) this._config['autoSessionRecord'] = true;
        this._pluggables.forEach(function(pluggable) {
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === 'AWSPinpoint' && !_this._config['AWSPinpoint'] ? _this._config : _this._config[pluggable.getProviderName()];
            pluggable.configure((0, _tslib.__assign)({
                disabled: _this._config['disabled'],
                autoSessionRecord: _this._config['autoSessionRecord']
            }, providerConfig));
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _awspinpointProvider.AWSPinpointProvider)());
        dispatchAnalyticsEvent('configured', null, "The Analytics category has been configured successfully");
        logger.debug('current configuration', this._config);
        return this._config;
    };
    /**
     * add plugin into Analytics category
     * @param pluggable - an instance of the plugin
     */ AnalyticsClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Analytics') {
            this._pluggables.push(pluggable);
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === 'AWSPinpoint' && !this._config['AWSPinpoint'] ? this._config : this._config[pluggable.getProviderName()];
            var config = (0, _tslib.__assign)({
                disabled: this._config['disabled']
            }, providerConfig);
            pluggable.configure(config);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.getPluggable = function(providerName) {
        for(var i = 0; i < this._pluggables.length; i += 1){
            var pluggable = this._pluggables[i];
            if (pluggable.getProviderName() === providerName) return pluggable;
        }
        logger.debug('No plugin found with providerName', providerName);
        return null;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.removePluggable = function(providerName) {
        var idx = 0;
        while(idx < this._pluggables.length){
            if (this._pluggables[idx].getProviderName() === providerName) break;
            idx += 1;
        }
        if (idx === this._pluggables.length) {
            logger.debug('No plugin found with providerName', providerName);
            return;
        } else {
            this._pluggables.splice(idx, idx + 1);
            return;
        }
    };
    /**
     * stop sending events
     */ AnalyticsClass.prototype.disable = function() {
        this._disabled = true;
    };
    /**
     * start sending events
     */ AnalyticsClass.prototype.enable = function() {
        this._disabled = false;
    };
    /**
     * Record Session start
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.startSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: '_session.start'
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent('record', event, 'Recording Analytics session start event');
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record Session stop
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.stopSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: '_session.stop'
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent('record', event, 'Recording Analytics session stop event');
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record one analytic event and send it to Pinpoint
     * @param event - An object with the name of the event, attributes of the event and event metrics.
     * @param [provider] - name of the provider.
     */ AnalyticsClass.prototype.record = function(event, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params;
            return (0, _tslib.__generator)(this, function(_a) {
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent('record', params.event, 'Recording Analytics event');
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    AnalyticsClass.prototype.updateEndpoint = function(attrs, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = (0, _tslib.__assign)((0, _tslib.__assign)({}, attrs), {
                    name: '_update_endpoint'
                });
                return [
                    2 /*return*/ ,
                    this.record(event, provider)
                ];
            });
        });
    };
    AnalyticsClass.prototype._sendEvent = function(params) {
        var _this = this;
        if (this._disabled) {
            logger.debug('Analytics has been disabled');
            return Promise.resolve();
        }
        var provider = params.provider ? params.provider : 'AWSPinpoint';
        return new Promise(function(resolve, reject) {
            _this._pluggables.forEach(function(pluggable) {
                if (pluggable.getProviderName() === provider) pluggable.record(params, {
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    };
    AnalyticsClass.prototype.autoTrack = function(trackerType, opts) {
        if (!trackers[trackerType]) {
            logger.debug('invalid tracker type');
            return;
        }
        // to sync up two different configuration ways of auto session tracking
        if (trackerType === 'session') this._config['autoSessionRecord'] = opts['enable'];
        var tracker = this._trackers[trackerType];
        if (!tracker) this._trackers[trackerType] = new trackers[trackerType](this.record, opts);
        else tracker.configure(opts);
    };
    return AnalyticsClass;
}();
var endpointUpdated = false;
var authConfigured = false;
var analyticsConfigured = false;
var credentialsConfigured = false;
var listener = function listener(capsule) {
    var channel = capsule.channel, payload = capsule.payload;
    logger.debug('on hub capsule ' + channel, payload);
    switch(channel){
        case 'auth':
            authEvent(payload);
            break;
        case 'storage':
            storageEvent(payload);
            break;
        case 'analytics':
            analyticsEvent(payload);
            break;
        case 'core':
            coreEvent(payload);
            break;
        default:
            break;
    }
};
var storageEvent = function storageEvent(payload) {
    var _a = payload.data, attrs = _a.attrs, metrics = _a.metrics;
    if (!attrs) return;
    if (analyticsConfigured) _instance.record({
        name: 'Storage',
        attributes: attrs,
        metrics: metrics
    }).catch(function(e) {
        logger.debug('Failed to send the storage event automatically', e);
    });
};
var authEvent = function authEvent(payload) {
    var event = payload.event;
    if (!event) return;
    var recordAuthEvent = function recordAuthEvent(eventName) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(authConfigured && analyticsConfigured)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            _instance.record({
                                name: "_userauth." + eventName
                            })
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        err_1 = _a.sent();
                        logger.debug("Failed to send the " + eventName + " event automatically", err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    switch(event){
        case 'signIn':
            return recordAuthEvent('sign_in');
        case 'signUp':
            return recordAuthEvent('sign_up');
        case 'signOut':
            return recordAuthEvent('sign_out');
        case 'signIn_failure':
            return recordAuthEvent('auth_fail');
        case 'configured':
            authConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var analyticsEvent = function analyticsEvent(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case 'pinpointProvider_configured':
            analyticsConfigured = true;
            if (authConfigured || credentialsConfigured) sendEvents();
            break;
    }
};
var coreEvent = function coreEvent(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case 'credentials_configured':
            credentialsConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var sendEvents = function sendEvents() {
    var config = _instance.configure();
    if (!endpointUpdated && config['autoSessionRecord']) {
        _instance.updateEndpoint({
            immediate: true
        }).catch(function(e) {
            logger.debug('Failed to update the endpoint', e);
        });
        endpointUpdated = true;
    }
    _instance.autoTrack('session', {
        enable: config['autoSessionRecord']
    });
};
var Analytics = new AnalyticsClass();
(0, _core.Amplify).register(Analytics);

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","./Providers/AWSPinpointProvider":"2eV5C","./trackers":"a0O3X","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eOnzl":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2eV5C":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", function() {
    return AWSPinpointProvider;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var _userAgent = require("../utils/UserAgent");
var _eventBuffer = require("./EventBuffer");
var _eventBufferDefault = parcelHelpers.interopDefault(_eventBuffer);
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var dispatchAnalyticsEvent = function dispatchAnalyticsEvent(event, data) {
    (0, _core.Hub).dispatch('analytics', {
        event: event,
        data: data
    }, 'Analytics', AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)('AWSPinpointProvider');
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var FORBIDDEN_CODE = 403;
var MOBILE_SERVICE_NAME = 'mobiletargeting';
var EXPIRED_TOKEN_CODE = 'ExpiredTokenException';
var UPDATE_ENDPOINT = '_update_endpoint';
var SESSION_START = '_session.start';
var SESSION_STOP = '_session.stop';
var BEACON_SUPPORTED = typeof navigator !== 'undefined' && navigator && typeof navigator.sendBeacon === 'function';
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
// params: { event: {name: , .... }, timeStamp, config, resendLimits }
var AWSPinpointProvider = /** @class */ function() {
    function AWSPinpointProvider(config) {
        this._endpointGenerating = true;
        this._endpointUpdateInProgress = false;
        this._buffer = null;
        this._endpointBuffer = [];
        this._config = config ? config : {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._clientInfo = (0, _core.ClientDevice).clientInfo();
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProvider.prototype.getCategory = function() {
        return AWSPinpointProvider.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProvider.prototype.getProviderName = function() {
        return AWSPinpointProvider.providerName;
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSPinpointProvider.prototype.configure = function(config) {
        var _this = this;
        logger.debug('configure Analytics', config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        // If autoSessionRecord is enabled, we need to wait for the endpoint to be
        // updated before sending any events. See `sendEvents` in `Analytics.ts`
        this._endpointGenerating = !!config['autoSessionRecord'];
        if (this._config.appId && !this._config.disabled) {
            if (!this._config.endpointId) {
                var cacheKey = this.getProviderName() + '_' + this._config.appId;
                this._getEndpointId(cacheKey).then(function(endpointId) {
                    logger.debug('setting endpoint id from the cache', endpointId);
                    _this._config.endpointId = endpointId;
                    dispatchAnalyticsEvent('pinpointProvider_configured', null);
                }).catch(function(err) {
                    logger.debug('Failed to generate endpointId', err);
                });
            } else dispatchAnalyticsEvent('pinpointProvider_configured', null);
        } else this._flushBuffer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSPinpointProvider.prototype.record = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, timestamp;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('_public record', params);
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials || !this._config.appId || !this._config.region) {
                            logger.debug('cannot send events without credentials, applicationId or region');
                            return [
                                2 /*return*/ ,
                                handlers.reject(new Error('No credentials, applicationId or region'))
                            ];
                        }
                        this._init(credentials);
                        timestamp = new Date().getTime();
                        // attach the session and eventId
                        this._generateSession(params);
                        params.event.eventId = (0, _uuid.v1)();
                        Object.assign(params, {
                            timestamp: timestamp,
                            config: this._config
                        });
                        if (params.event.immediate) return [
                            2 /*return*/ ,
                            this._send(params, handlers)
                        ];
                        else this._putToBuffer(params, handlers);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._sendEndpointUpdate = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var next;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._endpointUpdateInProgress) {
                            this._endpointBuffer.push(endpointObject);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._endpointUpdateInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._updateEndpoint(endpointObject)
                        ];
                    case 1:
                        _a.sent();
                        next = this._endpointBuffer.shift();
                        this._endpointUpdateInProgress = false;
                        next && this._sendEndpointUpdate(next);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     * @param params - params for event recording
     * Put events into buffer
     */ AWSPinpointProvider.prototype._putToBuffer = function(params, handlers) {
        var _a;
        if (params.event.name === UPDATE_ENDPOINT) {
            this._sendEndpointUpdate({
                params: params,
                handlers: handlers
            });
            return;
        }
        (_a = this._buffer) === null || _a === void 0 || _a.push({
            params: params,
            handlers: handlers
        });
    };
    AWSPinpointProvider.prototype._generateSession = function(params) {
        this._sessionId = this._sessionId || (0, _uuid.v1)();
        var event = params.event;
        switch(event.name){
            case SESSION_START:
                // refresh the session id and session start time
                this._sessionStartTimestamp = new Date().getTime();
                this._sessionId = (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
                break;
            case SESSION_STOP:
                var stopTimestamp = new Date().getTime();
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    Duration: stopTimestamp - this._sessionStartTimestamp,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString(),
                    StopTimestamp: new Date(stopTimestamp).toISOString()
                };
                this._sessionId = undefined;
                this._sessionStartTimestamp = undefined;
                break;
            default:
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
        }
    };
    AWSPinpointProvider.prototype._send = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = params.event;
                switch(event.name){
                    case UPDATE_ENDPOINT:
                        return [
                            2 /*return*/ ,
                            this._updateEndpoint({
                                params: params,
                                handlers: handlers
                            })
                        ];
                    case SESSION_STOP:
                        return [
                            2 /*return*/ ,
                            this._pinpointSendStopSession(params, handlers)
                        ];
                    default:
                        return [
                            2 /*return*/ ,
                            this._pinpointPutEvents(params, handlers)
                        ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._generateBatchItemContext = function(params) {
        var _a, _b;
        var event = params.event, timestamp = params.timestamp, config = params.config;
        var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
        var appId = config.appId, endpointId = config.endpointId;
        var endpointContext = {};
        return {
            ApplicationId: appId,
            EventsRequest: {
                BatchItem: (_a = {}, _a[endpointId] = {
                    Endpoint: endpointContext,
                    Events: (_b = {}, _b[eventId] = {
                        EventType: name,
                        Timestamp: new Date(timestamp).toISOString(),
                        Attributes: attributes,
                        Metrics: metrics,
                        Session: session
                    }, _b)
                }, _a)
            }
        };
    };
    AWSPinpointProvider.prototype._pinpointPutEvents = function(params, handlers) {
        var _a, _b, _c, _d, _e;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventId, endpointId, eventParams, _f, credentials, region, data, _g, StatusCode, Message, err_1;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        eventId = params.event.eventId, endpointId = params.config.endpointId;
                        eventParams = this._generateBatchItemContext(params);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _f = this._config, credentials = _f.credentials, region = _f.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, eventParams)
                        ];
                    case 2:
                        data = _h.sent();
                        _g = (_e = (_d = (_c = (_b = (_a = data.EventsResponse) === null || _a === void 0 ? void 0 : _a.Results) === null || _b === void 0 ? void 0 : _b[endpointId]) === null || _c === void 0 ? void 0 : _c.EventsItemResponse) === null || _d === void 0 ? void 0 : _d[eventId]) !== null && _e !== void 0 ? _e : {}, StatusCode = _g.StatusCode, Message = _g.Message;
                        if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                            logger.debug('record event success. ', data);
                            return [
                                2 /*return*/ ,
                                handlers.resolve(data)
                            ];
                        } else if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) // TODO: v6 integrate retry to the service handler retryDecider
                        this._retry(params, handlers);
                        else {
                            logger.error("Event " + eventId + " is not accepted, the error is " + Message);
                            return [
                                2 /*return*/ ,
                                handlers.reject(data)
                            ];
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _h.sent();
                        this._eventError(err_1);
                        return [
                            2 /*return*/ ,
                            handlers.reject(err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._pinpointSendStopSession = function(params, handlers) {
        if (!BEACON_SUPPORTED) {
            this._pinpointPutEvents(params, handlers);
            return;
        }
        var eventParams = this._generateBatchItemContext(params);
        var region = this._config.region;
        var ApplicationId = eventParams.ApplicationId, EventsRequest = eventParams.EventsRequest;
        var accessInfo = {
            secret_key: this._config.credentials.secretAccessKey,
            access_key: this._config.credentials.accessKeyId,
            session_token: this._config.credentials.sessionToken
        };
        var url = "https://pinpoint." + region + ".amazonaws.com/v1/apps/" + ApplicationId + "/events/legacy";
        var body = JSON.stringify(EventsRequest);
        var method = 'POST';
        var request = {
            url: url,
            body: body,
            method: method
        };
        var serviceInfo = {
            region: region,
            service: MOBILE_SERVICE_NAME
        };
        var requestUrl = (0, _core.Signer).signUrl(request, accessInfo, serviceInfo);
        var success = navigator.sendBeacon(requestUrl, body);
        if (success) return handlers.resolve('sendBeacon success');
        return handlers.reject('sendBeacon failure');
    };
    AWSPinpointProvider.prototype._retry = function(params, handlers) {
        var resendLimit = params.config.resendLimit;
        // For backward compatibility
        params.resendLimit = typeof params.resendLimit === 'number' ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending event " + params.eventName + " with " + params.resendLimit + " retry times left");
            this._pinpointPutEvents(params, handlers);
        } else logger.debug("retry times used up for event " + params.eventName);
    };
    AWSPinpointProvider.prototype._updateEndpoint = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params, handlers, config, event, appId, endpointId, request, update_params, _a, credentials, region, data, err_2, failureData;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        params = endpointObject.params, handlers = endpointObject.handlers;
                        config = params.config, event = params.event;
                        appId = config.appId, endpointId = config.endpointId;
                        request = this._endpointRequest(config, (0, _core.transferKeyToLowerCase)(event, [], [
                            'attributes',
                            'userAttributes',
                            'Attributes',
                            'UserAttributes'
                        ]));
                        update_params = {
                            ApplicationId: appId,
                            EndpointId: endpointId,
                            EndpointRequest: request
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.updateEndpoint)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).UpdateEndpoint)
                            }, update_params)
                        ];
                    case 2:
                        data = _b.sent();
                        logger.debug('updateEndpoint success', data);
                        this._endpointGenerating = false;
                        this._resumeBuffer();
                        handlers.resolve(data);
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        err_2 = _b.sent();
                        failureData = {
                            err: err_2,
                            update_params: update_params,
                            endpointObject: endpointObject
                        };
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateFailure(failureData)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateFailure = function(failureData) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err, endpointObject, statusCode, exponential;
            return (0, _tslib.__generator)(this, function(_a) {
                err = failureData.err, endpointObject = failureData.endpointObject;
                statusCode = err.$metadata && err.$metadata.httpStatusCode;
                logger.debug('updateEndpoint error', err);
                switch(statusCode){
                    case FORBIDDEN_CODE:
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateForbidden(failureData)
                        ];
                    default:
                        if (RETRYABLE_CODES.includes(statusCode)) {
                            exponential = true;
                            return [
                                2 /*return*/ ,
                                this._retryEndpointUpdate(endpointObject, exponential)
                            ];
                        }
                        logger.error('updateEndpoint failed', err);
                        endpointObject.handlers.reject(err);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateForbidden = function(failureData) {
        var err = failureData.err, endpointObject = failureData.endpointObject;
        var code = err.code, retryable = err.retryable;
        if (code !== EXPIRED_TOKEN_CODE && !retryable) return endpointObject.handlers.reject(err);
        this._retryEndpointUpdate(endpointObject);
    };
    AWSPinpointProvider.prototype._retryEndpointUpdate = function(endpointObject, exponential) {
        if (exponential === void 0) exponential = false;
        logger.debug('_retryEndpointUpdate', endpointObject);
        var params = endpointObject.params;
        // TODO: implement retry with exp back off once exp function is available
        var resendLimit = params.config.resendLimit;
        params.resendLimit = typeof params.resendLimit === 'number' ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending endpoint update " + params.event.eventId + " with " + params.resendLimit + " retry attempts remaining");
            // insert at the front of endpointBuffer
            this._endpointBuffer.length ? this._endpointBuffer.unshift(endpointObject) : this._updateEndpoint(endpointObject);
            return;
        }
        logger.warn("resending endpoint update " + params.event.eventId + " failed after " + params.config.resendLimit + " attempts");
        if (this._endpointGenerating) logger.error('Initial endpoint update failed. ');
    };
    /**
     * @private
     * @param config
     * Configure credentials and init buffer
     */ AWSPinpointProvider.prototype._init = function(credentials) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var identityId;
            return (0, _tslib.__generator)(this, function(_a) {
                logger.debug('init provider');
                if (this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
                    logger.debug('no change for aws credentials, directly return from init');
                    return [
                        2 /*return*/ 
                    ];
                }
                identityId = this._config.credentials ? this._config.credentials.identityId : null;
                this._config.credentials = credentials;
                if (!this._bufferExists() || identityId !== credentials.identityId) // if the identity has changed, flush the buffer and instantiate a new one
                // this will cause the old buffer to send any remaining events
                // with the old credentials and then stop looping and shortly thereafter get picked up by GC
                this._initBuffer();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._bufferExists = function() {
        return this._buffer && this._buffer instanceof (0, _eventBufferDefault.default);
    };
    AWSPinpointProvider.prototype._initBuffer = function() {
        if (this._bufferExists()) this._flushBuffer();
        this._buffer = new (0, _eventBufferDefault.default)(this._config);
        // if the first endpoint update hasn't yet resolved pause the buffer to
        // prevent race conditions. It will be resumed as soon as that request succeeds
        if (this._endpointGenerating) this._buffer.pause();
    };
    AWSPinpointProvider.prototype._flushBuffer = function() {
        var _a;
        if (this._bufferExists()) {
            (_a = this._buffer) === null || _a === void 0 || _a.flush();
            this._buffer = null;
        }
    };
    AWSPinpointProvider.prototype._resumeBuffer = function() {
        var _a;
        if (this._bufferExists()) (_a = this._buffer) === null || _a === void 0 || _a.resume();
    };
    AWSPinpointProvider.prototype._getEndpointId = function(cacheKey) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointId, ttl, expiration;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem(cacheKey)
                        ];
                    case 1:
                        endpointId = _a.sent();
                        logger.debug('endpointId from cache', endpointId, 'type', typeof endpointId === "undefined" ? "undefined" : (0, _typeOf._)(endpointId));
                        if (!endpointId) {
                            endpointId = (0, _uuid.v1)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                        }
                        return [
                            2 /*return*/ ,
                            endpointId
                        ];
                }
            });
        });
    };
    /**
     * EndPoint request
     * @return {Object} - The request of updating endpoint
     */ AWSPinpointProvider.prototype._endpointRequest = function(config, event) {
        var credentials = config.credentials;
        var clientInfo = this._clientInfo || {};
        var clientContext = config.clientContext || {};
        // for now we have three different ways for default endpoint configurations
        // clientInfo
        // clientContext (deprecated)
        // config.endpoint
        var defaultEndpointConfig = config.endpoint || {};
        var demographicByClientInfo = {
            appVersion: clientInfo.appVersion,
            make: clientInfo.make,
            model: clientInfo.model,
            modelVersion: clientInfo.version,
            platform: clientInfo.platform
        };
        // for backward compatibility
        var clientId = clientContext.clientId, appTitle = clientContext.appTitle, appVersionName = clientContext.appVersionName, appVersionCode = clientContext.appVersionCode, appPackageName = clientContext.appPackageName, demographicByClientContext = (0, _tslib.__rest)(clientContext, [
            "clientId",
            "appTitle",
            "appVersionName",
            "appVersionCode",
            "appPackageName"
        ]);
        var channelType = event.address ? clientInfo.platform === 'android' ? 'GCM' : 'APNS' : undefined;
        var tmp = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
            channelType: channelType,
            requestId: (0, _uuid.v1)(),
            effectiveDate: new Date().toISOString()
        }, defaultEndpointConfig), event), {
            attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.attributes), event.attributes),
            demographic: (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, demographicByClientInfo), demographicByClientContext), defaultEndpointConfig.demographic), event.demographic),
            location: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.location), event.location),
            metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.metrics), event.metrics),
            user: {
                userId: event.userId || defaultEndpointConfig.userId || credentials.identityId,
                userAttributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.userAttributes), event.userAttributes)
            }
        });
        // eliminate unnecessary params
        var userId = tmp.userId, userAttributes = tmp.userAttributes, name = tmp.name, session = tmp.session, eventId = tmp.eventId, immediate = tmp.immediate, ret = (0, _tslib.__rest)(tmp, [
            "userId",
            "userAttributes",
            "name",
            "session",
            "eventId",
            "immediate"
        ]);
        return (0, _core.transferKeyToUpperCase)(ret, [], [
            'metrics',
            'userAttributes',
            'attributes'
        ]);
    };
    AWSPinpointProvider.prototype._eventError = function(err) {
        logger.error('record event failed.', err);
        logger.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" in order to record events');
    };
    AWSPinpointProvider.prototype._getCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, err_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            null
                        ];
                        logger.debug('set credentials for analytics', credentials);
                        return [
                            2 /*return*/ ,
                            (0, _core.Credentials).shear(credentials)
                        ];
                    case 2:
                        err_3 = _a.sent();
                        logger.debug('ensure credentials error', err_3);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.category = 'Analytics';
    AWSPinpointProvider.providerName = 'AWSPinpoint';
    return AWSPinpointProvider;
}();

},{"@swc/helpers/_/_type_of":"668P4","tslib":"eOnzl","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","uuid":"bvm5J","../utils/UserAgent":"gxK6D","./EventBuffer":"5I0ha","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVdVQ":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCache", function() {
    return 0, _browserStorageCache.BrowserStorageCache;
});
parcelHelpers.export(exports, "InMemoryCache", function() {
    return 0, _inMemoryCache.InMemoryCache;
});
// Standard `Cache` export to maintain interoperability with React Native
parcelHelpers.export(exports, "Cache", function() {
    return 0, _browserStorageCache.BrowserStorageCache;
});
var _browserStorageCache = require("./BrowserStorageCache");
var _inMemoryCache = require("./InMemoryCache");

},{"./BrowserStorageCache":"5lQDf","./InMemoryCache":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5lQDf":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCacheClass", function() {
    return BrowserStorageCacheClass;
});
parcelHelpers.export(exports, "BrowserStorageCache", function() {
    return BrowserStorageCache;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _utils = require("./Utils");
var _storageCache = require("./StorageCache");
var logger = new (0, _core.ConsoleLogger)('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var BrowserStorageCacheClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, _utils.defaultConfig), config) : (0, _utils.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, _utils.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, _utils.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, _utils.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, _utils.defaultConfig).keyPrefix) {
            logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = (0, _utils.getCurrTime).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, _storageCache.StorageCache));
var BrowserStorageCache = new BrowserStorageCacheClass();
(0, _core.Amplify).register(BrowserStorageCache);

},{"tslib":"4rCQU","@aws-amplify/core":"3rlh1","./Utils":"9pvvt","./StorageCache":"eK8nw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rCQU":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9pvvt":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheObject", function() {
    return 0, _cacheUtils.CacheObject;
});
parcelHelpers.export(exports, "defaultConfig", function() {
    return 0, _cacheUtils.defaultConfig;
});
parcelHelpers.export(exports, "getByteLength", function() {
    return 0, _cacheUtils.getByteLength;
});
parcelHelpers.export(exports, "getCurrTime", function() {
    return 0, _cacheUtils.getCurrTime;
});
parcelHelpers.export(exports, "isInteger", function() {
    return 0, _cacheUtils.isInteger;
});
parcelHelpers.export(exports, "CacheList", function() {
    return 0, _cacheListDefault.default;
});
var _cacheUtils = require("./CacheUtils");
var _cacheList = require("./CacheList");
var _cacheListDefault = parcelHelpers.interopDefault(_cacheList);

},{"./CacheUtils":"1jtBv","./CacheList":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1jtBv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", function() {
    return defaultConfig;
});
/**
 * return the byte size of the string
 * @param str
 */ parcelHelpers.export(exports, "getByteLength", function() {
    return getByteLength;
});
/**
 * get current time
 */ parcelHelpers.export(exports, "getCurrTime", function() {
    return getCurrTime;
});
/**
 * check if passed value is an integer
 */ parcelHelpers.export(exports, "isInteger", function() {
    return isInteger;
});
parcelHelpers.export(exports, "CacheObject", function() {
    return CacheObject;
});
var _core = require("@aws-amplify/core");
var defaultConfig = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, _core.StorageHelper)().getStorage()
};
function getByteLength(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function getCurrTime() {
    var currTime = new Date();
    return currTime.getTime();
}
function isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return _isInteger(value);
}
function _isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var store = {};
var CacheObject = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        store = {};
    };
    CacheObject.getItem = function(key) {
        return store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete store[key];
    };
    return CacheObject;
}();

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eK8nw":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageCache", function() {
    return StorageCache;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _utils = require("./Utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('StorageCache');
/**
 * Initialization of the cache
 *
 */ var StorageCache = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, _utils.isInteger)(this.config.capacityInBytes)) {
            logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
        if (!(0, _utils.isInteger)(this.config.itemMaxSize)) {
            logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (!(0, _utils.isInteger)(this.config.defaultTTL)) {
            logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = (0, _utils.defaultConfig).defaultTTL;
        }
        if (!(0, _utils.isInteger)(this.config.defaultPriority)) {
            logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = (0, _utils.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, _utils.getCurrTime)(),
            visitedTime: (0, _utils.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value),
            byteSize: 0
        };
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();

},{"@swc/helpers/_/_type_of":"668P4","./Utils":"9pvvt","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0bYL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", function() {
    return 0, _getInAppMessages.getInAppMessages;
});
parcelHelpers.export(exports, "putEvents", function() {
    return 0, _putEvents.putEvents;
});
parcelHelpers.export(exports, "updateEndpoint", function() {
    return 0, _updateEndpoint.updateEndpoint;
});
var _getInAppMessages = require("./getInAppMessages");
var _putEvents = require("./putEvents");
var _updateEndpoint = require("./updateEndpoint");

},{"./getInAppMessages":"15wxL","./putEvents":"e1f1Q","./updateEndpoint":"cHApM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15wxL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", function() {
    return getInAppMessages;
});
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getInAppMessagesSerializer = function getInAppMessagesSerializer(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId), "/inappmessages");
    return {
        method: 'GET',
        headers: headers,
        url: url
    };
};
var getInAppMessagesDeserializer = function getInAppMessagesDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, InAppMessageCampaigns;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    InAppMessageCampaigns = _a.sent().InAppMessageCampaigns;
                    return [
                        2 /*return*/ ,
                        {
                            InAppMessagesResponse: {
                                InAppMessageCampaigns: InAppMessageCampaigns
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getInAppMessages = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), getInAppMessagesSerializer, getInAppMessagesDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"an928":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", function() {
    return defaultConfig;
});
parcelHelpers.export(exports, "getSharedHeaders", function() {
    return getSharedHeaders;
});
var _endpoints = require("../../clients/endpoints");
var _retry = require("../../clients/middleware/retry");
var _json = require("../../clients/serde/json");
var _platform = require("../../Platform");
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = 'mobiletargeting';
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function endpointResolver(_a) {
    var region = _a.region;
    return {
        url: new URL("https://pinpoint.".concat(region, ".").concat((0, _endpoints.getDnsSuffix)(region)))
    };
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _json.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
var getSharedHeaders = function getSharedHeaders() {
    return {
        'content-type': 'application/json'
    };
};

},{"../../clients/endpoints":"dNrJb","../../clients/middleware/retry":"4tNHX","../../clients/serde/json":"jR1RV","../../Platform":"jNyBX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e1f1Q":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putEvents", function() {
    return putEvents;
});
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putEventsSerializer = function putEventsSerializer(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EventsRequest = _a.EventsRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/events");
    var body = JSON.stringify(EventsRequest !== null && EventsRequest !== void 0 ? EventsRequest : {});
    return {
        method: 'POST',
        headers: headers,
        url: url,
        body: body
    };
};
var putEventsDeserializer = function putEventsDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, Results;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    Results = _a.sent().Results;
                    return [
                        2 /*return*/ ,
                        {
                            EventsResponse: {
                                Results: Results
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var putEvents = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), putEventsSerializer, putEventsDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cHApM":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEndpoint", function() {
    return updateEndpoint;
});
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var updateEndpointSerializer = function updateEndpointSerializer(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId, EndpointRequest = _a.EndpointRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId));
    var body = JSON.stringify(EndpointRequest !== null && EndpointRequest !== void 0 ? EndpointRequest : {});
    return {
        method: 'PUT',
        headers: headers,
        url: url,
        body: body
    };
};
var updateEndpointDeserializer = function updateEndpointDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, _a, Message, RequestID;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _b.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    _a = _b.sent(), Message = _a.Message, RequestID = _a.RequestID;
                    return [
                        2 /*return*/ ,
                        {
                            MessageBody: {
                                Message: Message,
                                RequestID: RequestID
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var updateEndpoint = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), updateEndpointSerializer, updateEndpointDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gxK6D":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalyticsUserAgent", function() {
    return getAnalyticsUserAgent;
});
parcelHelpers.export(exports, "getAnalyticsUserAgentString", function() {
    return getAnalyticsUserAgentString;
});
var _core = require("@aws-amplify/core");
function getAnalyticsUserAgent(action) {
    return (0, _core.getAmplifyUserAgentObject)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}
function getAnalyticsUserAgentString(action) {
    return (0, _core.getAmplifyUserAgent)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5I0ha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _appUtils = require("../utils/AppUtils");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)('EventsBuffer');
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var EventsBuffer = /** @class */ function() {
    function EventsBuffer(config) {
        this._pause = false;
        this._flush = false;
        logger.debug('Instantiating buffer with config:', config);
        this._buffer = [];
        this._config = config;
        this._sendBatch = this._sendBatch.bind(this);
        this._startLoop();
    }
    EventsBuffer.prototype.push = function(event) {
        var _a;
        // if the buffer is currently at the configured limit, pushing would exceed it
        if (this._buffer.length >= this._config.bufferSize) {
            logger.debug('Exceeded analytics events buffer size');
            return event.handlers.reject(new Error('Exceeded the size of analytics events buffer'));
        }
        var eventId = event.params.event.eventId;
        var bufferElement = (_a = {}, _a[eventId] = event, _a);
        this._buffer.push(bufferElement);
    };
    EventsBuffer.prototype.pause = function() {
        this._pause = true;
    };
    EventsBuffer.prototype.resume = function() {
        this._pause = false;
    };
    EventsBuffer.prototype.flush = function() {
        this._flush = true;
    };
    EventsBuffer.prototype._startLoop = function() {
        if (this._interval) clearInterval(this._interval);
        var flushInterval = this._config.flushInterval;
        this._interval = setInterval(this._sendBatch, flushInterval);
    };
    EventsBuffer.prototype._sendBatch = function() {
        var bufferLength = this._buffer.length;
        if (this._flush && !bufferLength) clearInterval(this._interval);
        // Do not send the batch of events if
        // the Buffer is paused or is empty or the App is not in the foreground
        // Apps should be in the foreground since
        // the OS may restrict access to the network in the background
        if (this._pause || !bufferLength || !(0, _appUtils.isAppInForeground)()) return;
        var flushSize = this._config.flushSize;
        var batchSize = Math.min(flushSize, bufferLength);
        var bufferSubset = this._buffer.splice(0, batchSize);
        this._putEvents(bufferSubset);
    };
    EventsBuffer.prototype._putEvents = function(buffer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventMap, batchEventParams, _a, credentials, region, data, err_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        eventMap = this._bufferToMap(buffer);
                        batchEventParams = this._generateBatchEventParams(eventMap);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, batchEventParams)
                        ];
                    case 2:
                        data = _b.sent();
                        this._processPutEventsSuccessResponse(data, eventMap);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        return [
                            2 /*return*/ ,
                            this._handlePutEventsFailure(err_1, eventMap)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsBuffer.prototype._generateBatchEventParams = function(eventMap) {
        var batchEventParams = {
            ApplicationId: '',
            EventsRequest: {
                BatchItem: {}
            }
        };
        Object.values(eventMap).forEach(function(item) {
            var params = item.params;
            var event = params.event, timestamp = params.timestamp, config = params.config;
            var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
            var appId = config.appId, endpointId = config.endpointId;
            var batchItem = batchEventParams.EventsRequest.BatchItem;
            batchEventParams.ApplicationId = batchEventParams.ApplicationId || appId;
            if (!batchItem[endpointId]) batchItem[endpointId] = {
                Endpoint: {},
                Events: {}
            };
            batchItem[endpointId].Events[eventId] = {
                EventType: name,
                Timestamp: new Date(timestamp).toISOString(),
                Attributes: attributes,
                Metrics: metrics,
                Session: session
            };
        });
        return batchEventParams;
    };
    EventsBuffer.prototype._handlePutEventsFailure = function(err, eventMap) {
        logger.debug('_putEvents Failed: ', err);
        var statusCode = err.$metadata && err.$metadata.httpStatusCode;
        if (RETRYABLE_CODES.includes(statusCode)) {
            var retryableEvents = Object.values(eventMap);
            this._retry(retryableEvents);
            return;
        }
    };
    EventsBuffer.prototype._processPutEventsSuccessResponse = function(data, eventMap) {
        var _a;
        var _b = ((_a = data.EventsResponse) !== null && _a !== void 0 ? _a : {}).Results, Results = _b === void 0 ? {} : _b;
        var retryableEvents = [];
        Object.entries(Results).forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), endpointId = _b[0], endpointValues = _b[1];
            var _c;
            var responses = (_c = endpointValues.EventsItemResponse) !== null && _c !== void 0 ? _c : {};
            Object.entries(responses).forEach(function(_a) {
                var _b, _c;
                var _d = (0, _tslib.__read)(_a, 2), eventId = _d[0], eventValues = _d[1];
                var eventObject = eventMap[eventId];
                if (!eventObject) return;
                var _e = eventValues !== null && eventValues !== void 0 ? eventValues : {}, StatusCode = _e.StatusCode, Message = _e.Message;
                // manually crafting handlers response to keep API consistant
                var response = {
                    EventsResponse: {
                        Results: (_b = {}, _b[endpointId] = {
                            EventsItemResponse: (_c = {}, _c[eventId] = {
                                StatusCode: StatusCode,
                                Message: Message
                            }, _c)
                        }, _b)
                    }
                };
                if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                    eventObject.handlers.resolve(response);
                    return;
                }
                if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) {
                    retryableEvents.push(eventObject);
                    return;
                }
                var name = eventObject.params.event.name;
                logger.error("event " + eventId + " : " + name + " failed with error: " + Message);
                return eventObject.handlers.reject(response);
            });
        });
        if (retryableEvents.length) this._retry(retryableEvents);
    };
    EventsBuffer.prototype._retry = function(retryableEvents) {
        var _a;
        // retryable events that haven't reached the resendLimit
        var eligibleEvents = [];
        retryableEvents.forEach(function(event) {
            var _a;
            var params = event.params;
            var _b = params.event, eventId = _b.eventId, name = _b.name;
            if (params.resendLimit-- > 0) {
                logger.debug("resending event " + eventId + " : " + name + " with " + params.resendLimit + " retry attempts remaining");
                eligibleEvents.push((_a = {}, _a[eventId] = event, _a));
                return;
            }
            logger.debug("no retry attempts remaining for event " + eventId + " : " + name);
        });
        // add the events to the front of the buffer
        (_a = this._buffer).unshift.apply(_a, (0, _tslib.__spread)(eligibleEvents));
    };
    // convert buffer to map, i.e. { eventId1: { params, handler }, eventId2: { params, handlers } }
    // this allows us to easily access the handlers after receiving a batch response
    EventsBuffer.prototype._bufferToMap = function(buffer) {
        return buffer.reduce(function(acc, curVal) {
            var _a = (0, _tslib.__read)(Object.entries(curVal), 1), _b = (0, _tslib.__read)(_a[0], 2), key = _b[0], value = _b[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    return EventsBuffer;
}();
exports.default = EventsBuffer;

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","../utils/AppUtils":"44ieJ","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"44ieJ":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAppInForeground", function() {
    return isAppInForeground;
});
var isAppInForeground = function isAppInForeground() {
    return true;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0O3X":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", function() {
    return 0, _pageViewTracker.PageViewTracker;
});
parcelHelpers.export(exports, "EventTracker", function() {
    return 0, _eventTracker.EventTracker;
});
parcelHelpers.export(exports, "SessionTracker", function() {
    return 0, _sessionTracker.SessionTracker;
});
var _pageViewTracker = require("./PageViewTracker");
var _eventTracker = require("./EventTracker");
var _sessionTracker = require("./SessionTracker");

},{"./PageViewTracker":"eGwCs","./EventTracker":"4QTf3","./SessionTracker":"bsn1E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eGwCs":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", function() {
    return PageViewTracker;
});
var _tslib = require("tslib");
var _methodEmbed = require("../utils/MethodEmbed");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('PageViewTracker');
var PREV_URL_KEY = 'aws-amplify-analytics-prevUrl';
var getUrl = function getUrl() {
    if (!(0, _core.browserOrNode)().isBrowser) return '';
    else return window.location.origin + window.location.pathname;
};
var defaultOpts = {
    enable: false,
    provider: 'AWSPinpoint',
    getUrl: getUrl
};
var PageViewTracker = /** @class */ function() {
    function PageViewTracker(tracker, opts) {
        logger.debug('initialize pageview tracker with opts', opts);
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        if (this._config.type === 'SPA') this._pageViewTrackSPA();
        else this._pageViewTrackDefault();
    }
    PageViewTracker.prototype.configure = function(opts) {
        Object.assign(this._config, opts);
        // if spa, need to remove those listeners if disabled
        if (this._config.type === 'SPA') this._pageViewTrackSPA();
        return this._config;
    };
    PageViewTracker.prototype._isSameUrl = function() {
        var prevUrl = sessionStorage.getItem(PREV_URL_KEY);
        var curUrl = this._config.getUrl();
        if (prevUrl === curUrl) {
            logger.debug('the url is same');
            return true;
        } else return false;
    };
    PageViewTracker.prototype._pageViewTrackDefault = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !window.sessionStorage) {
                            logger.debug('not in the supported web enviroment');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (this._config.enable && !this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || 'pageView',
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug('Failed to record the page view event', e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState || !window.sessionStorage) {
                            logger.debug('not in the supported web enviroment');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (!this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || 'pageView',
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug('Failed to record the page view event', e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._pageViewTrackSPA = function() {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState) {
            logger.debug('not in the supported web enviroment');
            return;
        }
        if (this._config.enable && !this._hasEnabled) {
            (0, _methodEmbed.MethodEmbed).add(history, 'pushState', this._trackFunc);
            (0, _methodEmbed.MethodEmbed).add(history, 'replaceState', this._trackFunc);
            window.addEventListener('popstate', this._trackFunc);
            this._trackFunc();
            this._hasEnabled = true;
        } else {
            (0, _methodEmbed.MethodEmbed).remove(history, 'pushState');
            (0, _methodEmbed.MethodEmbed).remove(history, 'replaceState');
            window.removeEventListener('popstate', this._trackFunc);
            this._hasEnabled = false;
        }
    };
    return PageViewTracker;
}();

},{"tslib":"eOnzl","../utils/MethodEmbed":"in1wq","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"in1wq":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MethodEmbed", function() {
    return MethodEmbed;
});
var _tslib = require("tslib");
var lists = [];
var MethodEmbed = /** @class */ function() {
    function MethodEmbed(context, methodName) {
        this.context = context;
        this.methodName = methodName;
        this._originalMethod = context[methodName].bind(context);
    }
    MethodEmbed.add = function(context, methodName, methodOverride) {
        getInstance(context, methodName).set(methodOverride);
    };
    MethodEmbed.remove = function(context, methodName) {
        getInstance(context, methodName).remove();
    };
    MethodEmbed.prototype.set = function(methodOverride) {
        var _this = this;
        this.context[this.methodName] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return methodOverride(_this._originalMethod.apply(_this, (0, _tslib.__spread)(args)));
        };
    };
    MethodEmbed.prototype.remove = function() {
        this.context[this.methodName] = this._originalMethod;
    };
    return MethodEmbed;
}();
function getInstance(context, methodName) {
    var instance = lists.filter(function(h) {
        return h.context === context && h.methodName === methodName;
    })[0];
    if (!instance) {
        instance = new MethodEmbed(context, methodName);
        lists.push(instance);
    }
    return instance;
}

},{"tslib":"eOnzl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4QTf3":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTracker", function() {
    return EventTracker;
});
var _tslib = require("tslib");
var _domUtils = require("../vendor/dom-utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('EventTracker');
var defaultOpts = {
    enable: false,
    events: [
        'click'
    ],
    selectorPrefix: 'data-amplify-analytics-',
    provider: 'AWSPinpoint'
};
var EventTracker = /** @class */ function() {
    function EventTracker(tracker, opts) {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener) {
            logger.debug('not in the supported web environment');
            return;
        }
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._delegates = {};
        this._trackFunc = this._trackFunc.bind(this);
        logger.debug('initialize pageview tracker with opts', this._config);
        this.configure(this._config);
    }
    EventTracker.prototype.configure = function(opts) {
        var _this = this;
        Object.assign(this._config, opts);
        if (!this._config.enable) {
            Object.keys(this._delegates).forEach(function(key) {
                if (typeof _this._delegates[key].destroy === 'function') _this._delegates[key].destroy();
            });
            this._delegates = {};
        } else if (this._config.enable && Object.keys(this._delegates).length === 0) {
            var selector_1 = '[' + this._config.selectorPrefix + 'on]';
            this._config.events.forEach(function(evt) {
                _this._delegates[evt] = (0, _domUtils.delegate)(document, evt, selector_1, _this._trackFunc, {
                    composed: true,
                    useCapture: true
                });
            });
        }
        return this._config;
    };
    EventTracker.prototype._trackFunc = function(event, element) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, events, eventName, attrs, defaultAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        customAttrs = {};
                        events = element.getAttribute(this._config.selectorPrefix + 'on').split(/\s*,\s*/);
                        eventName = element.getAttribute(this._config.selectorPrefix + 'name');
                        attrs = element.getAttribute(this._config.selectorPrefix + 'attrs');
                        if (attrs) attrs.split(/\s*,\s*/).forEach(function(attr) {
                            var tmp = attr.trim().split(/\s*:\s*/);
                            customAttrs[tmp[0]] = tmp[1];
                        });
                        if (!(typeof this._config.attributes === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        defaultAttrs = _a;
                        attributes = Object.assign({
                            type: event.type,
                            target: event.target.localName + " with id " + event.target.id
                        }, defaultAttrs, customAttrs);
                        logger.debug('events needed to be recorded', events);
                        logger.debug('attributes needed to be attached', customAttrs);
                        if (events.indexOf(event.type) < 0) {
                            logger.debug("event " + event.type + " is not selected to be recorded");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._tracker({
                            name: eventName || 'event',
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("Failed to record the " + event.type + " event', " + e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return EventTracker;
}();

},{"tslib":"eOnzl","../vendor/dom-utils":"kOmfH","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kOmfH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closest", function() {
    return 0, _closest.closest;
});
parcelHelpers.export(exports, "delegate", function() {
    return 0, _delegate.delegate;
});
parcelHelpers.export(exports, "dispatch", function() {
    return 0, _dispatch.dispatch;
});
parcelHelpers.export(exports, "getAttributes", function() {
    return 0, _getAttributes.getAttributes;
});
parcelHelpers.export(exports, "matches", function() {
    return 0, _matches.matches;
});
parcelHelpers.export(exports, "parents", function() {
    return 0, _parents.parents;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return 0, _parseUrl.parseUrl;
});
var _closest = require("./closest");
var _delegate = require("./delegate");
var _dispatch = require("./dispatch");
var _getAttributes = require("./get-attributes");
var _matches = require("./matches");
var _parents = require("./parents");
var _parseUrl = require("./parse-url");

},{"./closest":false,"./delegate":"6wqgF","./dispatch":false,"./get-attributes":false,"./matches":false,"./parents":false,"./parse-url":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kdusL":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the closest parent element that matches the passed selector.
 * @param {Element} element The element whose parents to check.
 * @param {string} selector The CSS selector to match against.
 * @param {boolean=} shouldCheckSelf True if the selector should test against
 *     the passed element itself.
 * @return {Element|undefined} The matching element or undefined.
 */ parcelHelpers.export(exports, "closest", function() {
    return closest;
});
var _matches = require("./matches");
var _parents = require("./parents");
function closest(element, selector, shouldCheckSelf) {
    if (shouldCheckSelf === void 0) shouldCheckSelf = false;
    if (!(element && element.nodeType === 1 && selector)) return;
    var parentElements = (shouldCheckSelf ? [
        element
    ] : []).concat((0, _parents.parents)(element));
    for(var i = 0, parent_1; parent_1 = parentElements[i]; i++){
        if ((0, _matches.matches)(parent_1, selector)) return parent_1;
    }
}

},{"./matches":"iG3qm","./parents":"23Iu7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iG3qm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tests if a DOM elements matches any of the test DOM elements or selectors.
 * @param {Element} element The DOM element to test.
 * @param {Element|string|Array<Element|string>} test A DOM element, a CSS
 *     selector, or an array of DOM elements or CSS selectors to match against.
 * @return {boolean} True of any part of the test matches.
 */ parcelHelpers.export(exports, "matches", function() {
    return matches;
});
var _core = require("@aws-amplify/core");
var proto = (0, _core.browserOrNode)().isBrowser && window['Element'] ? window['Element'].prototype : null;
var nativeMatches = proto ? proto.matches || // @ts-ignore
proto.matchesSelector || // @ts-ignore
proto.webkitMatchesSelector || // @ts-ignore
proto.mozMatchesSelector || // @ts-ignore
proto.msMatchesSelector || // @ts-ignore
proto.oMatchesSelector : null;
function matches(element, test) {
    // Validate input.
    if (element && element.nodeType === 1 && test) {
        // if test is a string or DOM element test it.
        if (typeof test === 'string' || test.nodeType === 1) return element === test || matchesSelector(element, /** @type {string} */ test);
        else if ('length' in test) // if it has a length property iterate over the items
        // and return true if any match.
        for(var i = 0, item = void 0; item = test[i]; i++){
            if (element === item || matchesSelector(element, item)) return true;
        }
    }
    // Still here? Return false
    return false;
}
/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */ function matchesSelector(element, selector) {
    if (typeof selector !== 'string') return false;
    if (nativeMatches) return nativeMatches.call(element, selector);
    var nodes = element.parentNode.querySelectorAll(selector);
    for(var i = 0, node = void 0; node = nodes[i]; i++){
        if (node === element) return true;
    }
    return false;
}

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"23Iu7":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parents", function() {
    return parents;
});
function parents(ele) {
    var list = [];
    var element = ele;
    while(element && element.parentNode && element.parentNode.nodeType === 1){
        element = /** @type {!Element} */ element.parentNode;
        list.push(element);
    }
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6wqgF":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Delegates the handling of events for an element matching a selector to an
 * ancestor of the matching element.
 * @param {!Node} ancestor The ancestor element to add the listener to.
 * @param {string} eventType The event type to listen to.
 * @param {string} selector A CSS selector to match against child elements.
 * @param {!Function} callback A function to run any time the event happens.
 * @param {Object=} opts A configuration options object. The available options:
 *     - useCapture<boolean>: If true, bind to the event capture phase.
 *     - deep<boolean>: If true, delegate into shadow trees.
 * @return {Object} The delegate object. It contains a destroy method.
 */ parcelHelpers.export(exports, "delegate", function() {
    return delegate;
});
var _closest = require("./closest");
var _matches = require("./matches");
function delegate(ancestor, eventType, selector, callback, opts) {
    if (opts === void 0) opts = {};
    // Defines the event listener.
    var listener = function listener(event) {
        var delegateTarget;
        // If opts.composed is true and the event originated from inside a Shadow
        // tree, check the composed path nodes.
        if (opts['composed'] && typeof event['composedPath'] === 'function') {
            var composedPath = event.composedPath();
            for(var i = 0, node = void 0; node = composedPath[i]; i++)if (node.nodeType === 1 && (0, _matches.matches)(node, selector)) delegateTarget = node;
        } else // Otherwise check the parents.
        delegateTarget = (0, _closest.closest)(event.target, selector, true);
        if (delegateTarget) callback.call(delegateTarget, event, delegateTarget);
    };
    ancestor.addEventListener(eventType, listener, opts['useCapture']);
    return {
        destroy: function destroy() {
            ancestor.removeEventListener(eventType, listener, opts['useCapture']);
        }
    };
}

},{"./closest":"kdusL","./matches":"iG3qm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bsn1E":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTracker", function() {
    return SessionTracker;
});
var _tslib = require("tslib");
// the session tracker for web
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('SessionTracker');
var defaultOpts = {
    enable: false,
    provider: 'AWSPinpoint'
};
var initialEventSent = false;
var SessionTracker = /** @class */ function() {
    function SessionTracker(tracker, opts) {
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        this._trackBeforeUnload = this._trackBeforeUnload.bind(this);
        this.configure(this._config);
    }
    SessionTracker.prototype._envCheck = function() {
        if (!(0, _core.browserOrNode)().isBrowser) return false;
        if (!document || !document.addEventListener) {
            logger.debug('not in the supported web environment');
            return false;
        }
        if (typeof document.hidden !== 'undefined') {
            this._hidden = 'hidden';
            this._visibilityChange = 'visibilitychange';
        } else if (typeof document['msHidden'] !== 'undefined') {
            this._hidden = 'msHidden';
            this._visibilityChange = 'msvisibilitychange';
        } else if (typeof document['webkitHidden'] !== 'undefined') {
            this._hidden = 'webkitHidden';
            this._visibilityChange = 'webkitvisibilitychange';
        } else {
            logger.debug('not in the supported web environment');
            return false;
        }
        return true;
    };
    SessionTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof this._config.attributes === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        if (document.visibilityState === this._hidden) this._tracker({
                            name: '_session.stop',
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug('record session stop event failed.', e);
                        });
                        else this._tracker({
                            name: '_session.start',
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug('record session start event failed.', e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype._trackBeforeUnload = function(event) {
        // before unload callback cannot be async => https://github.com/aws-amplify/amplify-js/issues/2088
        var _this = this;
        var customAttrs = typeof this._config.attributes === 'function' ? Promise.resolve(this._config.attributes()) : Promise.resolve(this._config.attributes);
        customAttrs.then(function(custom) {
            var attributes = Object.assign({}, custom);
            _this._tracker({
                name: '_session.stop',
                attributes: attributes,
                immediate: true
            }, _this._config.provider).catch(function(e) {
                logger.debug('record session stop event failed.', e);
            });
        });
    };
    // to keep configure a synchronized function
    SessionTracker.prototype._sendInitialEvent = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (initialEventSent) {
                            logger.debug('the start session has been sent when the page is loaded');
                            return [
                                2 /*return*/ 
                            ];
                        } else initialEventSent = true;
                        if (!(typeof this._config.attributes === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        this._tracker({
                            name: '_session.start',
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug('record session start event failed.', e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype.configure = function(opts) {
        if (!this._envCheck()) return this._config;
        Object.assign(this._config, opts);
        if (this._config.enable && !this._hasEnabled) {
            // send a start session as soon as it's enabled
            this._sendInitialEvent();
            // listen on events
            document.addEventListener(this._visibilityChange, this._trackFunc, false);
            window.addEventListener('beforeunload', this._trackBeforeUnload, false);
            this._hasEnabled = true;
        } else if (!this._config.enable && this._hasEnabled) {
            document.removeEventListener(this._visibilityChange, this._trackFunc, false);
            window.removeEventListener('beforeunload', this._trackBeforeUnload, false);
            this._hasEnabled = false;
        }
        return this._config;
    };
    return SessionTracker;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"nvQ6G":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", function() {
    return 0, _awspinpointProvider.AWSPinpointProvider;
});
parcelHelpers.export(exports, "AWSKinesisProvider", function() {
    return 0, _awskinesisProvider.AWSKinesisProvider;
});
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", function() {
    return 0, _awskinesisFirehoseProvider.AWSKinesisFirehoseProvider;
});
parcelHelpers.export(exports, "AmazonPersonalizeProvider", function() {
    return 0, _amazonPersonalizeProvider.AmazonPersonalizeProvider;
});
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _awskinesisFirehoseProvider = require("./AWSKinesisFirehoseProvider");
var _amazonPersonalizeProvider = require("./AmazonPersonalizeProvider");

},{"./AWSPinpointProvider":"2eV5C","./AWSKinesisProvider":"2sXdp","./AWSKinesisFirehoseProvider":"fxYWT","./AmazonPersonalizeProvider":"8mvSm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sXdp":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisProvider", function() {
    return AWSKinesisProvider;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientKinesis = require("@aws-sdk/client-kinesis");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)('AWSKinesisProvider');
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
var AWSKinesisProvider = /** @class */ function() {
    function AWSKinesisProvider(config) {
        this._buffer = [];
        this._config = config || {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._setupTimer();
    }
    AWSKinesisProvider.prototype._setupTimer = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        var _a = this._config, flushSize = _a.flushSize, flushInterval = _a.flushInterval;
        this._timer = setInterval(function() {
            var size = _this._buffer.length < flushSize ? _this._buffer.length : flushSize;
            var events = [];
            for(var i = 0; i < size; i += 1){
                var params = _this._buffer.shift();
                events.push(params);
            }
            _this._sendFromBuffer(events);
        }, flushInterval);
    };
    /**
     * get the category of the plugin
     */ AWSKinesisProvider.prototype.getCategory = function() {
        return 'Analytics';
    };
    /**
     * get provider name of the plugin
     */ AWSKinesisProvider.prototype.getProviderName = function() {
        return 'AWSKinesis';
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSKinesisProvider.prototype.configure = function(config) {
        logger.debug('configure Analytics', config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        this._setupTimer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSKinesisProvider.prototype.record = function(params) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials
                        });
                        if ((_a = params.event) === null || _a === void 0 ? void 0 : _a.immediate) {
                            this._sendEvents([
                                params
                            ]);
                            return [
                                2 /*return*/ ,
                                Promise.resolve(true)
                            ];
                        } else return [
                            2 /*return*/ ,
                            this._putToBuffer(params)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSKinesisProvider.prototype.updateEndpoint = function() {
        logger.debug('updateEndpoint is not implemented in Kinesis provider');
        return Promise.resolve(true);
    };
    /**
     * @private
     * @param params - params for the event recording
     * Put events into buffer
     */ AWSKinesisProvider.prototype._putToBuffer = function(params) {
        if (this._buffer.length < BUFFER_SIZE) {
            this._buffer.push(params);
            return Promise.resolve(true);
        } else {
            logger.debug('exceed analytics events buffer size');
            return Promise.reject(false);
        }
    };
    AWSKinesisProvider.prototype._sendFromBuffer = function(events) {
        var _this = this;
        // collapse events by credentials
        // events = [ {params} ]
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < events.length; i += 1){
            var cred = events[i].credentials;
            if (i === 0) {
                group.push(events[i]);
                preCred = cred;
            } else if (cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug('no change for cred, put event in the same group');
                group.push(events[i]);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(events[i]);
                preCred = cred;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(evts) {
            _this._sendEvents(evts);
        });
    };
    AWSKinesisProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // spit by streamName
            var evt = params.event;
            var streamName = evt.streamName;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = evt.data && typeof evt.data !== 'string' ? JSON.stringify(evt.data) : evt.data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var PartitionKey = evt.partitionKey || 'partition-' + credentials.identityId;
            var record = {
                Data: Data,
                PartitionKey: PartitionKey
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var command, err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger.debug('putting records to kinesis with records', records[streamName]);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            command = new (0, _clientKinesis.PutRecordsCommand)({
                                Records: records[streamName],
                                StreamName: streamName
                            });
                            return [
                                4 /*yield*/ ,
                                this._kinesis.send(command)
                            ];
                        case 2:
                            _a.sent();
                            logger.debug('Upload records to stream', streamName);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_1 = _a.sent();
                            logger.debug('Failed to upload records to Kinesis', err_1);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSKinesisProvider.prototype._init = function(config, credentials) {
        logger.debug('init clients');
        if (this._kinesis && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug('no change for analytics config, directly return from init');
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region, endpoint = config.endpoint;
        return this._initKinesis(region, endpoint, credentials);
    };
    AWSKinesisProvider.prototype._initKinesis = function(region, endpoint, credentials) {
        logger.debug('initialize kinesis with credentials', credentials);
        this._kinesis = new (0, _clientKinesis.KinesisClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record),
            endpoint: endpoint
        });
        return true;
    };
    /**
     * @private
     * check if current credentials exists
     */ AWSKinesisProvider.prototype._getCredentials = function() {
        var _this = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug('set credentials for analytics', _this._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug('ensure credentials error', err);
            return null;
        });
    };
    return AWSKinesisProvider;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-sdk/client-kinesis":"eAkwt","@aws-sdk/util-utf8-browser":"iZmxX","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eAkwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _kinesisClient = require("./KinesisClient");
parcelHelpers.exportAll(_kinesisClient, exports);
var _kinesis = require("./Kinesis");
parcelHelpers.exportAll(_kinesis, exports);
var _addTagsToStreamCommand = require("./commands/AddTagsToStreamCommand");
parcelHelpers.exportAll(_addTagsToStreamCommand, exports);
var _createStreamCommand = require("./commands/CreateStreamCommand");
parcelHelpers.exportAll(_createStreamCommand, exports);
var _decreaseStreamRetentionPeriodCommand = require("./commands/DecreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_decreaseStreamRetentionPeriodCommand, exports);
var _deleteStreamCommand = require("./commands/DeleteStreamCommand");
parcelHelpers.exportAll(_deleteStreamCommand, exports);
var _deregisterStreamConsumerCommand = require("./commands/DeregisterStreamConsumerCommand");
parcelHelpers.exportAll(_deregisterStreamConsumerCommand, exports);
var _describeLimitsCommand = require("./commands/DescribeLimitsCommand");
parcelHelpers.exportAll(_describeLimitsCommand, exports);
var _describeStreamCommand = require("./commands/DescribeStreamCommand");
parcelHelpers.exportAll(_describeStreamCommand, exports);
var _waitForStreamExists = require("./waiters/waitForStreamExists");
parcelHelpers.exportAll(_waitForStreamExists, exports);
var _waitForStreamNotExists = require("./waiters/waitForStreamNotExists");
parcelHelpers.exportAll(_waitForStreamNotExists, exports);
var _describeStreamConsumerCommand = require("./commands/DescribeStreamConsumerCommand");
parcelHelpers.exportAll(_describeStreamConsumerCommand, exports);
var _describeStreamSummaryCommand = require("./commands/DescribeStreamSummaryCommand");
parcelHelpers.exportAll(_describeStreamSummaryCommand, exports);
var _disableEnhancedMonitoringCommand = require("./commands/DisableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_disableEnhancedMonitoringCommand, exports);
var _enableEnhancedMonitoringCommand = require("./commands/EnableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_enableEnhancedMonitoringCommand, exports);
var _getRecordsCommand = require("./commands/GetRecordsCommand");
parcelHelpers.exportAll(_getRecordsCommand, exports);
var _getShardIteratorCommand = require("./commands/GetShardIteratorCommand");
parcelHelpers.exportAll(_getShardIteratorCommand, exports);
var _increaseStreamRetentionPeriodCommand = require("./commands/IncreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_increaseStreamRetentionPeriodCommand, exports);
var _listShardsCommand = require("./commands/ListShardsCommand");
parcelHelpers.exportAll(_listShardsCommand, exports);
var _listStreamConsumersCommand = require("./commands/ListStreamConsumersCommand");
parcelHelpers.exportAll(_listStreamConsumersCommand, exports);
var _listStreamConsumersPaginator = require("./pagination/ListStreamConsumersPaginator");
parcelHelpers.exportAll(_listStreamConsumersPaginator, exports);
var _listStreamsCommand = require("./commands/ListStreamsCommand");
parcelHelpers.exportAll(_listStreamsCommand, exports);
var _listTagsForStreamCommand = require("./commands/ListTagsForStreamCommand");
parcelHelpers.exportAll(_listTagsForStreamCommand, exports);
var _mergeShardsCommand = require("./commands/MergeShardsCommand");
parcelHelpers.exportAll(_mergeShardsCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordsCommand = require("./commands/PutRecordsCommand");
parcelHelpers.exportAll(_putRecordsCommand, exports);
var _registerStreamConsumerCommand = require("./commands/RegisterStreamConsumerCommand");
parcelHelpers.exportAll(_registerStreamConsumerCommand, exports);
var _removeTagsFromStreamCommand = require("./commands/RemoveTagsFromStreamCommand");
parcelHelpers.exportAll(_removeTagsFromStreamCommand, exports);
var _splitShardCommand = require("./commands/SplitShardCommand");
parcelHelpers.exportAll(_splitShardCommand, exports);
var _startStreamEncryptionCommand = require("./commands/StartStreamEncryptionCommand");
parcelHelpers.exportAll(_startStreamEncryptionCommand, exports);
var _stopStreamEncryptionCommand = require("./commands/StopStreamEncryptionCommand");
parcelHelpers.exportAll(_stopStreamEncryptionCommand, exports);
var _subscribeToShardCommand = require("./commands/SubscribeToShardCommand");
parcelHelpers.exportAll(_subscribeToShardCommand, exports);
var _updateShardCountCommand = require("./commands/UpdateShardCountCommand");
parcelHelpers.exportAll(_updateShardCountCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./KinesisClient":"hFqJe","./Kinesis":false,"./commands/AddTagsToStreamCommand":false,"./commands/CreateStreamCommand":false,"./commands/DecreaseStreamRetentionPeriodCommand":false,"./commands/DeleteStreamCommand":false,"./commands/DeregisterStreamConsumerCommand":false,"./commands/DescribeLimitsCommand":false,"./commands/DescribeStreamCommand":false,"./waiters/waitForStreamExists":false,"./waiters/waitForStreamNotExists":false,"./commands/DescribeStreamConsumerCommand":false,"./commands/DescribeStreamSummaryCommand":false,"./commands/DisableEnhancedMonitoringCommand":false,"./commands/EnableEnhancedMonitoringCommand":false,"./commands/GetRecordsCommand":false,"./commands/GetShardIteratorCommand":false,"./commands/IncreaseStreamRetentionPeriodCommand":false,"./commands/ListShardsCommand":false,"./commands/ListStreamConsumersCommand":false,"./pagination/ListStreamConsumersPaginator":false,"./commands/ListStreamsCommand":false,"./commands/ListTagsForStreamCommand":false,"./commands/MergeShardsCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordsCommand":"7gn9k","./commands/RegisterStreamConsumerCommand":false,"./commands/RemoveTagsFromStreamCommand":false,"./commands/SplitShardCommand":false,"./commands/StartStreamEncryptionCommand":false,"./commands/StopStreamEncryptionCommand":false,"./commands/SubscribeToShardCommand":false,"./commands/UpdateShardCountCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hFqJe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KinesisClient", function() {
    return KinesisClient;
});
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _eventstreamSerdeConfigResolver = require("@aws-sdk/eventstream-serde-config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Streams Service API Reference</fullname>
 *         <p>Amazon Kinesis Data Streams is a managed service that scales elastically for
 *             real-time processing of streaming big data.</p>
 */ var KinesisClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(KinesisClient, _super);
    function KinesisClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        var _config_7 = (0, _eventstreamSerdeConfigResolver.resolveEventStreamSerdeConfig)(_config_6);
        _this = _super.call(this, _config_7) || this;
        _this.config = _config_7;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    KinesisClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return KinesisClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"7QUww","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/eventstream-serde-config-resolver":"fxdMw","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7QUww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", function() {
    return ClientDefaultValues;
});
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _eventstreamSerdeBrowser = require("@aws-sdk/eventstream-serde-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function credentialDefaultProvider(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    eventStreamSerdeProvider: (0, _eventstreamSerdeBrowser.eventStreamSerdeProvider),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"1Bv1F","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/eventstream-serde-browser":"eHxWA","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"3BGdL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Bv1F":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-kinesis\",\"description\":\"AWS SDK for JavaScript Kinesis Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test\":\"exit 0\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/eventstream-serde-browser\":\"3.6.1\",\"@aws-sdk/eventstream-serde-config-resolver\":\"3.6.1\",\"@aws-sdk/eventstream-serde-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"@aws-sdk/util-waiter\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-kinesis\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-kinesis\"}}");

},{}],"eHxWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./provider":"8FjsJ","./EventStreamMarshaller":"haGlH","./utils":"1LOzm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FjsJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", function() {
    return eventStreamSerdeProvider;
});
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function eventStreamSerdeProvider(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"haGlH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"haGlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", function() {
    return EventStreamMarshaller;
});
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _eventstreamSerdeUniversal = require("@aws-sdk/eventstream-serde-universal");
var _utils = require("./utils");
/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, _eventstreamSerdeUniversal.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = isReadableStream(body) ? (0, _utils.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, _utils.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var isReadableStream = function isReadableStream(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

},{"@aws-sdk/eventstream-marshaller":"rVrTA","@aws-sdk/eventstream-serde-universal":"2t1dy","./utils":"1LOzm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"rVrTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _int64 = require("./Int64");
parcelHelpers.exportAll(_int64, exports);
var _message = require("./Message");
parcelHelpers.exportAll(_message, exports);

},{"./EventStreamMarshaller":"9JiTD","./Int64":"alU3V","./Message":"h7wrT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JiTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", function() {
    return EventStreamMarshaller;
});
var _crc32 = require("@aws-crypto/crc32");
var _headerMarshaller = require("./HeaderMarshaller");
var _splitMessage = require("./splitMessage");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, _headerMarshaller.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, _crc32.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, _splitMessage.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();

},{"@aws-crypto/crc32":"5zVRa","./HeaderMarshaller":"aKI8K","./splitMessage":"8Qj0j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5zVRa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
var tslib_1 = require("ff93ff6885dc1cf");
var util_1 = require("c823117d943f0b79");
function crc32(data) {
    return new Crc32().update(data).digest();
}
exports.crc32 = crc32;
var Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, tslib_1.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
exports.Crc32 = Crc32;
// prettier-ignore
var a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
var aws_crc32_1 = require("584239808b1ee7cb");
Object.defineProperty(exports, "AwsCrc32", {
    enumerable: true,
    get: function get() {
        return aws_crc32_1.AwsCrc32;
    }
});

},{"ff93ff6885dc1cf":"78SAV","c823117d943f0b79":"1R05H","584239808b1ee7cb":"gPocM"}],"78SAV":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gPocM":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = void 0;
var tslib_1 = require("b907f97435eccd7a");
var util_1 = require("3a796558421f7605");
var index_1 = require("3cb74d8e5af5d83d");
var AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new index_1.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash)) return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, util_1.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
exports.AwsCrc32 = AwsCrc32;

},{"b907f97435eccd7a":"78SAV","3a796558421f7605":"1R05H","3cb74d8e5af5d83d":"5zVRa"}],"aKI8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderMarshaller", function() {
    return HeaderMarshaller;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _int64 = require("./Int64");
/**
 * @internal
 */ var HeaderMarshaller = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, _tslib.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, _tslib.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, _int64.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, _utilHexEncoding.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: LONG_TAG,
                        value: new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: TIMESTAMP_TAG,
                        value: new Date(new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: UUID_TAG,
                        value: (0, _utilHexEncoding.toHex)(uuidBytes.subarray(0, 4)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(4, 6)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(6, 8)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(8, 10)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
var BOOLEAN_TAG = "boolean";
var BYTE_TAG = "byte";
var SHORT_TAG = "short";
var INT_TAG = "integer";
var LONG_TAG = "long";
var BINARY_TAG = "binary";
var STRING_TAG = "string";
var TIMESTAMP_TAG = "timestamp";
var UUID_TAG = "uuid";
var UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

},{"tslib":"78SAV","@aws-sdk/util-hex-encoding":"dTdhV","./Int64":"alU3V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"alU3V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Int64", function() {
    return Int64;
});
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var Int64 = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) negate(bytes);
        return parseInt((0, _utilHexEncoding.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

},{"@aws-sdk/util-hex-encoding":"dTdhV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Qj0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "splitMessage", function() {
    return splitMessage;
});
var _crc32 = require("@aws-crypto/crc32");
// All prelude components are unsigned, 32-bit integers
var PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - CHECKSUM_LENGTH, false);
    var checksummer = new (0, _crc32.Crc32)().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
    };
}

},{"@aws-crypto/crc32":"5zVRa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h7wrT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2t1dy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);

},{"./provider":"8QUUN","./EventStreamMarshaller":"gbe5j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8QUUN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", function() {
    return eventStreamSerdeProvider;
});
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function eventStreamSerdeProvider(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"gbe5j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gbe5j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", function() {
    return EventStreamMarshaller;
});
var _tslib = require("tslib");
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _getChunkedStream = require("./getChunkedStream");
var _getUnmarshalledStream = require("./getUnmarshalledStream");
var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, _getChunkedStream.getChunkedStream)(body);
        var unmarshalledStream = (0, _getUnmarshalledStream.getUnmarshalledStream)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function serializedIterator() {
            return (0, _tslib.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, _tslib.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

},{"tslib":"dRdOi","@aws-sdk/eventstream-marshaller":"rVrTA","./getChunkedStream":"1qlSF","./getUnmarshalledStream":"8qfGv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRdOi":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1qlSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChunkedStream", function() {
    return getChunkedStream;
});
var _tslib = require("tslib");
function getChunkedStream(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function allocateMessage(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function iterator() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

},{"tslib":"dRdOi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qfGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUnmarshalledStream", function() {
    return getUnmarshalledStream;
});
var _tslib = require("tslib");
function getUnmarshalledStream(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, _tslib.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}

},{"tslib":"dRdOi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1LOzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamtoIterable", function() {
    return readableStreamtoIterable;
});
parcelHelpers.export(exports, "iterableToReadableStream", function() {
    return iterableToReadableStream;
});
var _tslib = require("tslib");
var readableStreamtoIterable = function readableStreamtoIterable(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var iterableToReadableStream = function iterableToReadableStream(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function pull(controller) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"fCvjy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fCvjy":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3BGdL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", function() {
    return ClientSharedValues;
});
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2013-12-02",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Kinesis",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"bnUVz","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bnUVz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "kinesis.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "kinesis.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "kinesis.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "kinesis.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "kinesis.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "kinesis.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "kinesis.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "kinesis.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "kinesis.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "kinesis.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "kinesis.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "kinesis.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "kinesis.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "kinesis.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "kinesis.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "kinesis.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "kinesis.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "kinesis.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "kinesis.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "kinesis.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "kinesis.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "kinesis-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "kinesis-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "kinesis-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "kinesis-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "kinesis.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "kinesis.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "kinesis.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "kinesis.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "kinesis.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "kinesis.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "kinesis.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "kinesis.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "kinesis.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "kinesis.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "kinesis"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxdMw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamSerdeConfig = require("./EventStreamSerdeConfig");
parcelHelpers.exportAll(_eventStreamSerdeConfig, exports);

},{"./EventStreamSerdeConfig":"8wY6r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8wY6r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEventStreamSerdeConfig", function() {
    return resolveEventStreamSerdeConfig;
});
var _tslib = require("tslib");
var resolveEventStreamSerdeConfig = function resolveEventStreamSerdeConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

},{"tslib":"8t8vB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8t8vB":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gn9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordsCommand", function() {
    return PutRecordsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a Kinesis data stream in a single call (also
 *             referred to as a <code>PutRecords</code> request). Use this operation to send data into
 *             the stream for data ingestion and processing. </p>
 *         <p>Each <code>PutRecords</code> request can support up to 500 records. Each record in
 *             the request can be as large as 1 MiB, up to a limit of 5 MiB for the entire request,
 *             including partition keys. Each shard can support writes up to 1,000 records per second,
 *             up to a maximum data write total of 1 MiB per second.</p>
 *         <p>You must specify the name of the stream that captures, stores, and transports the
 *             data; and an array of request <code>Records</code>, with each record in the array
 *             requiring a partition key and data blob. The record size limit applies to the total size
 *             of the partition key and data blob.</p>
 *         <p>The data blob can be any type of data; for example, a segment from a log file,
 *             geographic/location data, website clickstream data, and so on.</p>
 *         <p>The partition key is used by Kinesis Data Streams as input to a hash function that
 *             maps the partition key and associated data to a specific shard. An MD5 hash function is
 *             used to map partition keys to 128-bit integer values and to map associated data records
 *             to shards. As a result of this hashing mechanism, all data records with the same
 *             partition key map to the same shard within the stream. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-add-data-to-stream">Adding Data to a Stream</a> in the <i>Amazon Kinesis Data Streams
 *                 Developer Guide</i>.</p>
 *         <p>Each record in the <code>Records</code> array may include an optional parameter,
 *                 <code>ExplicitHashKey</code>, which overrides the partition key to shard mapping.
 *             This parameter allows a data producer to determine explicitly the shard where the record
 *             is stored. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <p>The <code>PutRecords</code> response includes an array of response
 *                 <code>Records</code>. Each record in the response array directly correlates with a
 *             record in the request array using natural ordering, from the top to the bottom of the
 *             request and response. The response <code>Records</code> array always includes the same
 *             number of records as the request array.</p>
 *         <p>The response <code>Records</code> array includes both successfully and
 *             unsuccessfully processed records. Kinesis Data Streams attempts to process all records
 *             in each <code>PutRecords</code> request. A single record failure does not stop the
 *             processing of subsequent records. As a result, PutRecords doesn't guarantee the ordering
 *             of records. If you need to read records in the same order they are written to the
 *             stream, use <a>PutRecord</a> instead of <code>PutRecords</code>, and write to
 *             the same shard.</p>
 *         <p>A successfully processed record includes <code>ShardId</code> and
 *                 <code>SequenceNumber</code> values. The <code>ShardId</code> parameter identifies
 *             the shard in the stream where the record is stored. The <code>SequenceNumber</code>
 *             parameter is an identifier assigned to the put record, unique to all records in the
 *             stream.</p>
 *         <p>An unsuccessfully processed record includes <code>ErrorCode</code> and
 *                 <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error
 *             and can be one of the following values:
 *                 <code>ProvisionedThroughputExceededException</code> or <code>InternalFailure</code>.
 *                 <code>ErrorMessage</code> provides more detailed information about the
 *                 <code>ProvisionedThroughputExceededException</code> exception including the account
 *             ID, stream name, and shard ID of the record that was throttled. For more information
 *             about partially successful responses, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/kinesis-using-sdk-java-add-data-to-stream.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <important>
 *             <p>After you write a record to a stream, you cannot modify that record or its order
 *                 within the stream.</p>
 *         </important>
 *         <p>By default, data records are accessible for 24 hours from the time that they are
 *             added to a stream. You can use <a>IncreaseStreamRetentionPeriod</a> or <a>DecreaseStreamRetentionPeriod</a> to modify this retention period.</p>
 */ var PutRecordsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "PutRecordsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordsInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordsOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordsCommand)(input, context);
    };
    PutRecordsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordsCommand)(output, context);
    };
    return PutRecordsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"dLNd8","../protocols/Aws_json1_1":"dGZXC","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dLNd8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddTagsToStreamInput", function() {
    return AddTagsToStreamInput;
});
parcelHelpers.export(exports, "InvalidArgumentException", function() {
    return InvalidArgumentException;
});
parcelHelpers.export(exports, "LimitExceededException", function() {
    return LimitExceededException;
});
parcelHelpers.export(exports, "ResourceInUseException", function() {
    return ResourceInUseException;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "HashKeyRange", function() {
    return HashKeyRange;
});
parcelHelpers.export(exports, "ChildShard", function() {
    return ChildShard;
});
parcelHelpers.export(exports, "ConsumerStatus", function() {
    return ConsumerStatus;
});
parcelHelpers.export(exports, "Consumer", function() {
    return Consumer;
});
parcelHelpers.export(exports, "ConsumerDescription", function() {
    return ConsumerDescription;
});
parcelHelpers.export(exports, "CreateStreamInput", function() {
    return CreateStreamInput;
});
parcelHelpers.export(exports, "DecreaseStreamRetentionPeriodInput", function() {
    return DecreaseStreamRetentionPeriodInput;
});
parcelHelpers.export(exports, "DeleteStreamInput", function() {
    return DeleteStreamInput;
});
parcelHelpers.export(exports, "DeregisterStreamConsumerInput", function() {
    return DeregisterStreamConsumerInput;
});
parcelHelpers.export(exports, "DescribeLimitsInput", function() {
    return DescribeLimitsInput;
});
parcelHelpers.export(exports, "DescribeLimitsOutput", function() {
    return DescribeLimitsOutput;
});
parcelHelpers.export(exports, "DescribeStreamInput", function() {
    return DescribeStreamInput;
});
parcelHelpers.export(exports, "EncryptionType", function() {
    return EncryptionType;
});
parcelHelpers.export(exports, "MetricsName", function() {
    return MetricsName;
});
parcelHelpers.export(exports, "EnhancedMetrics", function() {
    return EnhancedMetrics;
});
parcelHelpers.export(exports, "SequenceNumberRange", function() {
    return SequenceNumberRange;
});
parcelHelpers.export(exports, "Shard", function() {
    return Shard;
});
parcelHelpers.export(exports, "StreamStatus", function() {
    return StreamStatus;
});
parcelHelpers.export(exports, "StreamDescription", function() {
    return StreamDescription;
});
parcelHelpers.export(exports, "DescribeStreamOutput", function() {
    return DescribeStreamOutput;
});
parcelHelpers.export(exports, "DescribeStreamConsumerInput", function() {
    return DescribeStreamConsumerInput;
});
parcelHelpers.export(exports, "DescribeStreamConsumerOutput", function() {
    return DescribeStreamConsumerOutput;
});
parcelHelpers.export(exports, "DescribeStreamSummaryInput", function() {
    return DescribeStreamSummaryInput;
});
parcelHelpers.export(exports, "StreamDescriptionSummary", function() {
    return StreamDescriptionSummary;
});
parcelHelpers.export(exports, "DescribeStreamSummaryOutput", function() {
    return DescribeStreamSummaryOutput;
});
parcelHelpers.export(exports, "DisableEnhancedMonitoringInput", function() {
    return DisableEnhancedMonitoringInput;
});
parcelHelpers.export(exports, "EnhancedMonitoringOutput", function() {
    return EnhancedMonitoringOutput;
});
parcelHelpers.export(exports, "EnableEnhancedMonitoringInput", function() {
    return EnableEnhancedMonitoringInput;
});
parcelHelpers.export(exports, "ExpiredIteratorException", function() {
    return ExpiredIteratorException;
});
parcelHelpers.export(exports, "ExpiredNextTokenException", function() {
    return ExpiredNextTokenException;
});
parcelHelpers.export(exports, "GetRecordsInput", function() {
    return GetRecordsInput;
});
parcelHelpers.export(exports, "_Record", function() {
    return _Record;
});
parcelHelpers.export(exports, "GetRecordsOutput", function() {
    return GetRecordsOutput;
});
parcelHelpers.export(exports, "KMSAccessDeniedException", function() {
    return KMSAccessDeniedException;
});
parcelHelpers.export(exports, "KMSDisabledException", function() {
    return KMSDisabledException;
});
parcelHelpers.export(exports, "KMSInvalidStateException", function() {
    return KMSInvalidStateException;
});
parcelHelpers.export(exports, "KMSNotFoundException", function() {
    return KMSNotFoundException;
});
parcelHelpers.export(exports, "KMSOptInRequired", function() {
    return KMSOptInRequired;
});
parcelHelpers.export(exports, "KMSThrottlingException", function() {
    return KMSThrottlingException;
});
parcelHelpers.export(exports, "ProvisionedThroughputExceededException", function() {
    return ProvisionedThroughputExceededException;
});
parcelHelpers.export(exports, "ShardIteratorType", function() {
    return ShardIteratorType;
});
parcelHelpers.export(exports, "GetShardIteratorInput", function() {
    return GetShardIteratorInput;
});
parcelHelpers.export(exports, "GetShardIteratorOutput", function() {
    return GetShardIteratorOutput;
});
parcelHelpers.export(exports, "IncreaseStreamRetentionPeriodInput", function() {
    return IncreaseStreamRetentionPeriodInput;
});
parcelHelpers.export(exports, "InternalFailureException", function() {
    return InternalFailureException;
});
parcelHelpers.export(exports, "ShardFilterType", function() {
    return ShardFilterType;
});
parcelHelpers.export(exports, "ShardFilter", function() {
    return ShardFilter;
});
parcelHelpers.export(exports, "ListShardsInput", function() {
    return ListShardsInput;
});
parcelHelpers.export(exports, "ListShardsOutput", function() {
    return ListShardsOutput;
});
parcelHelpers.export(exports, "ListStreamConsumersInput", function() {
    return ListStreamConsumersInput;
});
parcelHelpers.export(exports, "ListStreamConsumersOutput", function() {
    return ListStreamConsumersOutput;
});
parcelHelpers.export(exports, "ListStreamsInput", function() {
    return ListStreamsInput;
});
parcelHelpers.export(exports, "ListStreamsOutput", function() {
    return ListStreamsOutput;
});
parcelHelpers.export(exports, "ListTagsForStreamInput", function() {
    return ListTagsForStreamInput;
});
parcelHelpers.export(exports, "Tag", function() {
    return Tag;
});
parcelHelpers.export(exports, "ListTagsForStreamOutput", function() {
    return ListTagsForStreamOutput;
});
parcelHelpers.export(exports, "MergeShardsInput", function() {
    return MergeShardsInput;
});
parcelHelpers.export(exports, "PutRecordInput", function() {
    return PutRecordInput;
});
parcelHelpers.export(exports, "PutRecordOutput", function() {
    return PutRecordOutput;
});
parcelHelpers.export(exports, "PutRecordsRequestEntry", function() {
    return PutRecordsRequestEntry;
});
parcelHelpers.export(exports, "PutRecordsInput", function() {
    return PutRecordsInput;
});
parcelHelpers.export(exports, "PutRecordsResultEntry", function() {
    return PutRecordsResultEntry;
});
parcelHelpers.export(exports, "PutRecordsOutput", function() {
    return PutRecordsOutput;
});
parcelHelpers.export(exports, "RegisterStreamConsumerInput", function() {
    return RegisterStreamConsumerInput;
});
parcelHelpers.export(exports, "RegisterStreamConsumerOutput", function() {
    return RegisterStreamConsumerOutput;
});
parcelHelpers.export(exports, "RemoveTagsFromStreamInput", function() {
    return RemoveTagsFromStreamInput;
});
parcelHelpers.export(exports, "SplitShardInput", function() {
    return SplitShardInput;
});
parcelHelpers.export(exports, "StartStreamEncryptionInput", function() {
    return StartStreamEncryptionInput;
});
parcelHelpers.export(exports, "StopStreamEncryptionInput", function() {
    return StopStreamEncryptionInput;
});
parcelHelpers.export(exports, "StartingPosition", function() {
    return StartingPosition;
});
parcelHelpers.export(exports, "SubscribeToShardInput", function() {
    return SubscribeToShardInput;
});
parcelHelpers.export(exports, "SubscribeToShardEvent", function() {
    return SubscribeToShardEvent;
});
parcelHelpers.export(exports, "SubscribeToShardEventStream", function() {
    return SubscribeToShardEventStream;
});
parcelHelpers.export(exports, "SubscribeToShardOutput", function() {
    return SubscribeToShardOutput;
});
parcelHelpers.export(exports, "ScalingType", function() {
    return ScalingType;
});
parcelHelpers.export(exports, "UpdateShardCountInput", function() {
    return UpdateShardCountInput;
});
parcelHelpers.export(exports, "UpdateShardCountOutput", function() {
    return UpdateShardCountOutput;
});
var _tslib = require("tslib");
var AddTagsToStreamInput;
(function(AddTagsToStreamInput) {
    AddTagsToStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AddTagsToStreamInput || (AddTagsToStreamInput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var HashKeyRange;
(function(HashKeyRange) {
    HashKeyRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HashKeyRange || (HashKeyRange = {}));
var ChildShard;
(function(ChildShard) {
    ChildShard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ChildShard || (ChildShard = {}));
var ConsumerStatus;
(function(ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "ACTIVE";
    ConsumerStatus["CREATING"] = "CREATING";
    ConsumerStatus["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
var Consumer;
(function(Consumer) {
    Consumer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Consumer || (Consumer = {}));
var ConsumerDescription;
(function(ConsumerDescription) {
    ConsumerDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConsumerDescription || (ConsumerDescription = {}));
var CreateStreamInput;
(function(CreateStreamInput) {
    CreateStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateStreamInput || (CreateStreamInput = {}));
var DecreaseStreamRetentionPeriodInput;
(function(DecreaseStreamRetentionPeriodInput) {
    DecreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DecreaseStreamRetentionPeriodInput || (DecreaseStreamRetentionPeriodInput = {}));
var DeleteStreamInput;
(function(DeleteStreamInput) {
    DeleteStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteStreamInput || (DeleteStreamInput = {}));
var DeregisterStreamConsumerInput;
(function(DeregisterStreamConsumerInput) {
    DeregisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeregisterStreamConsumerInput || (DeregisterStreamConsumerInput = {}));
var DescribeLimitsInput;
(function(DescribeLimitsInput) {
    DescribeLimitsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsInput || (DescribeLimitsInput = {}));
var DescribeLimitsOutput;
(function(DescribeLimitsOutput) {
    DescribeLimitsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsOutput || (DescribeLimitsOutput = {}));
var DescribeStreamInput;
(function(DescribeStreamInput) {
    DescribeStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamInput || (DescribeStreamInput = {}));
var EncryptionType;
(function(EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
var MetricsName;
(function(MetricsName) {
    MetricsName["ALL"] = "ALL";
    MetricsName["INCOMING_BYTES"] = "IncomingBytes";
    MetricsName["INCOMING_RECORDS"] = "IncomingRecords";
    MetricsName["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
    MetricsName["OUTGOING_BYTES"] = "OutgoingBytes";
    MetricsName["OUTGOING_RECORDS"] = "OutgoingRecords";
    MetricsName["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
    MetricsName["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
var EnhancedMetrics;
(function(EnhancedMetrics) {
    EnhancedMetrics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMetrics || (EnhancedMetrics = {}));
var SequenceNumberRange;
(function(SequenceNumberRange) {
    SequenceNumberRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SequenceNumberRange || (SequenceNumberRange = {}));
var Shard;
(function(Shard) {
    Shard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Shard || (Shard = {}));
var StreamStatus;
(function(StreamStatus) {
    StreamStatus["ACTIVE"] = "ACTIVE";
    StreamStatus["CREATING"] = "CREATING";
    StreamStatus["DELETING"] = "DELETING";
    StreamStatus["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
var StreamDescription;
(function(StreamDescription) {
    StreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescription || (StreamDescription = {}));
var DescribeStreamOutput;
(function(DescribeStreamOutput) {
    DescribeStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamOutput || (DescribeStreamOutput = {}));
var DescribeStreamConsumerInput;
(function(DescribeStreamConsumerInput) {
    DescribeStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerInput || (DescribeStreamConsumerInput = {}));
var DescribeStreamConsumerOutput;
(function(DescribeStreamConsumerOutput) {
    DescribeStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerOutput || (DescribeStreamConsumerOutput = {}));
var DescribeStreamSummaryInput;
(function(DescribeStreamSummaryInput) {
    DescribeStreamSummaryInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryInput || (DescribeStreamSummaryInput = {}));
var StreamDescriptionSummary;
(function(StreamDescriptionSummary) {
    StreamDescriptionSummary.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescriptionSummary || (StreamDescriptionSummary = {}));
var DescribeStreamSummaryOutput;
(function(DescribeStreamSummaryOutput) {
    DescribeStreamSummaryOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryOutput || (DescribeStreamSummaryOutput = {}));
var DisableEnhancedMonitoringInput;
(function(DisableEnhancedMonitoringInput) {
    DisableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisableEnhancedMonitoringInput || (DisableEnhancedMonitoringInput = {}));
var EnhancedMonitoringOutput;
(function(EnhancedMonitoringOutput) {
    EnhancedMonitoringOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMonitoringOutput || (EnhancedMonitoringOutput = {}));
var EnableEnhancedMonitoringInput;
(function(EnableEnhancedMonitoringInput) {
    EnableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnableEnhancedMonitoringInput || (EnableEnhancedMonitoringInput = {}));
var ExpiredIteratorException;
(function(ExpiredIteratorException) {
    ExpiredIteratorException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredIteratorException || (ExpiredIteratorException = {}));
var ExpiredNextTokenException;
(function(ExpiredNextTokenException) {
    ExpiredNextTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredNextTokenException || (ExpiredNextTokenException = {}));
var GetRecordsInput;
(function(GetRecordsInput) {
    GetRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsInput || (GetRecordsInput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var GetRecordsOutput;
(function(GetRecordsOutput) {
    GetRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsOutput || (GetRecordsOutput = {}));
var KMSAccessDeniedException;
(function(KMSAccessDeniedException) {
    KMSAccessDeniedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSAccessDeniedException || (KMSAccessDeniedException = {}));
var KMSDisabledException;
(function(KMSDisabledException) {
    KMSDisabledException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSDisabledException || (KMSDisabledException = {}));
var KMSInvalidStateException;
(function(KMSInvalidStateException) {
    KMSInvalidStateException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSInvalidStateException || (KMSInvalidStateException = {}));
var KMSNotFoundException;
(function(KMSNotFoundException) {
    KMSNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSNotFoundException || (KMSNotFoundException = {}));
var KMSOptInRequired;
(function(KMSOptInRequired) {
    KMSOptInRequired.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSOptInRequired || (KMSOptInRequired = {}));
var KMSThrottlingException;
(function(KMSThrottlingException) {
    KMSThrottlingException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSThrottlingException || (KMSThrottlingException = {}));
var ProvisionedThroughputExceededException;
(function(ProvisionedThroughputExceededException) {
    ProvisionedThroughputExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
var ShardIteratorType;
(function(ShardIteratorType) {
    ShardIteratorType["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
    ShardIteratorType["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
    ShardIteratorType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardIteratorType["LATEST"] = "LATEST";
    ShardIteratorType["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
var GetShardIteratorInput;
(function(GetShardIteratorInput) {
    GetShardIteratorInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorInput || (GetShardIteratorInput = {}));
var GetShardIteratorOutput;
(function(GetShardIteratorOutput) {
    GetShardIteratorOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorOutput || (GetShardIteratorOutput = {}));
var IncreaseStreamRetentionPeriodInput;
(function(IncreaseStreamRetentionPeriodInput) {
    IncreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(IncreaseStreamRetentionPeriodInput || (IncreaseStreamRetentionPeriodInput = {}));
var InternalFailureException;
(function(InternalFailureException) {
    InternalFailureException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InternalFailureException || (InternalFailureException = {}));
var ShardFilterType;
(function(ShardFilterType) {
    ShardFilterType["AFTER_SHARD_ID"] = "AFTER_SHARD_ID";
    ShardFilterType["AT_LATEST"] = "AT_LATEST";
    ShardFilterType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardFilterType["AT_TRIM_HORIZON"] = "AT_TRIM_HORIZON";
    ShardFilterType["FROM_TIMESTAMP"] = "FROM_TIMESTAMP";
    ShardFilterType["FROM_TRIM_HORIZON"] = "FROM_TRIM_HORIZON";
})(ShardFilterType || (ShardFilterType = {}));
var ShardFilter;
(function(ShardFilter) {
    ShardFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ShardFilter || (ShardFilter = {}));
var ListShardsInput;
(function(ListShardsInput) {
    ListShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsInput || (ListShardsInput = {}));
var ListShardsOutput;
(function(ListShardsOutput) {
    ListShardsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsOutput || (ListShardsOutput = {}));
var ListStreamConsumersInput;
(function(ListStreamConsumersInput) {
    ListStreamConsumersInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersInput || (ListStreamConsumersInput = {}));
var ListStreamConsumersOutput;
(function(ListStreamConsumersOutput) {
    ListStreamConsumersOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersOutput || (ListStreamConsumersOutput = {}));
var ListStreamsInput;
(function(ListStreamsInput) {
    ListStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsInput || (ListStreamsInput = {}));
var ListStreamsOutput;
(function(ListStreamsOutput) {
    ListStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsOutput || (ListStreamsOutput = {}));
var ListTagsForStreamInput;
(function(ListTagsForStreamInput) {
    ListTagsForStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamInput || (ListTagsForStreamInput = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var ListTagsForStreamOutput;
(function(ListTagsForStreamOutput) {
    ListTagsForStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamOutput || (ListTagsForStreamOutput = {}));
var MergeShardsInput;
(function(MergeShardsInput) {
    MergeShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MergeShardsInput || (MergeShardsInput = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var PutRecordsRequestEntry;
(function(PutRecordsRequestEntry) {
    PutRecordsRequestEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsRequestEntry || (PutRecordsRequestEntry = {}));
var PutRecordsInput;
(function(PutRecordsInput) {
    PutRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsInput || (PutRecordsInput = {}));
var PutRecordsResultEntry;
(function(PutRecordsResultEntry) {
    PutRecordsResultEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsResultEntry || (PutRecordsResultEntry = {}));
var PutRecordsOutput;
(function(PutRecordsOutput) {
    PutRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsOutput || (PutRecordsOutput = {}));
var RegisterStreamConsumerInput;
(function(RegisterStreamConsumerInput) {
    RegisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerInput || (RegisterStreamConsumerInput = {}));
var RegisterStreamConsumerOutput;
(function(RegisterStreamConsumerOutput) {
    RegisterStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerOutput || (RegisterStreamConsumerOutput = {}));
var RemoveTagsFromStreamInput;
(function(RemoveTagsFromStreamInput) {
    RemoveTagsFromStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RemoveTagsFromStreamInput || (RemoveTagsFromStreamInput = {}));
var SplitShardInput;
(function(SplitShardInput) {
    SplitShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplitShardInput || (SplitShardInput = {}));
var StartStreamEncryptionInput;
(function(StartStreamEncryptionInput) {
    StartStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartStreamEncryptionInput || (StartStreamEncryptionInput = {}));
var StopStreamEncryptionInput;
(function(StopStreamEncryptionInput) {
    StopStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopStreamEncryptionInput || (StopStreamEncryptionInput = {}));
var StartingPosition;
(function(StartingPosition) {
    StartingPosition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartingPosition || (StartingPosition = {}));
var SubscribeToShardInput;
(function(SubscribeToShardInput) {
    SubscribeToShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardInput || (SubscribeToShardInput = {}));
var SubscribeToShardEvent;
(function(SubscribeToShardEvent) {
    SubscribeToShardEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardEvent || (SubscribeToShardEvent = {}));
var SubscribeToShardEventStream;
(function(SubscribeToShardEventStream) {
    SubscribeToShardEventStream.visit = function(value, visitor) {
        if (value.SubscribeToShardEvent !== undefined) return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
        if (value.ResourceNotFoundException !== undefined) return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ResourceInUseException !== undefined) return visitor.ResourceInUseException(value.ResourceInUseException);
        if (value.KMSDisabledException !== undefined) return visitor.KMSDisabledException(value.KMSDisabledException);
        if (value.KMSInvalidStateException !== undefined) return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
        if (value.KMSAccessDeniedException !== undefined) return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
        if (value.KMSNotFoundException !== undefined) return visitor.KMSNotFoundException(value.KMSNotFoundException);
        if (value.KMSOptInRequired !== undefined) return visitor.KMSOptInRequired(value.KMSOptInRequired);
        if (value.KMSThrottlingException !== undefined) return visitor.KMSThrottlingException(value.KMSThrottlingException);
        if (value.InternalFailureException !== undefined) return visitor.InternalFailureException(value.InternalFailureException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SubscribeToShardEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.SubscribeToShardEvent !== undefined) return {
            SubscribeToShardEvent: SubscribeToShardEvent.filterSensitiveLog(obj.SubscribeToShardEvent)
        };
        if (obj.ResourceNotFoundException !== undefined) return {
            ResourceNotFoundException: ResourceNotFoundException.filterSensitiveLog(obj.ResourceNotFoundException)
        };
        if (obj.ResourceInUseException !== undefined) return {
            ResourceInUseException: ResourceInUseException.filterSensitiveLog(obj.ResourceInUseException)
        };
        if (obj.KMSDisabledException !== undefined) return {
            KMSDisabledException: KMSDisabledException.filterSensitiveLog(obj.KMSDisabledException)
        };
        if (obj.KMSInvalidStateException !== undefined) return {
            KMSInvalidStateException: KMSInvalidStateException.filterSensitiveLog(obj.KMSInvalidStateException)
        };
        if (obj.KMSAccessDeniedException !== undefined) return {
            KMSAccessDeniedException: KMSAccessDeniedException.filterSensitiveLog(obj.KMSAccessDeniedException)
        };
        if (obj.KMSNotFoundException !== undefined) return {
            KMSNotFoundException: KMSNotFoundException.filterSensitiveLog(obj.KMSNotFoundException)
        };
        if (obj.KMSOptInRequired !== undefined) return {
            KMSOptInRequired: KMSOptInRequired.filterSensitiveLog(obj.KMSOptInRequired)
        };
        if (obj.KMSThrottlingException !== undefined) return {
            KMSThrottlingException: KMSThrottlingException.filterSensitiveLog(obj.KMSThrottlingException)
        };
        if (obj.InternalFailureException !== undefined) return {
            InternalFailureException: InternalFailureException.filterSensitiveLog(obj.InternalFailureException)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
var SubscribeToShardOutput;
(function(SubscribeToShardOutput) {
    SubscribeToShardOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EventStream && {
            EventStream: "STREAMING_CONTENT"
        });
    };
})(SubscribeToShardOutput || (SubscribeToShardOutput = {}));
var ScalingType;
(function(ScalingType) {
    ScalingType["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
var UpdateShardCountInput;
(function(UpdateShardCountInput) {
    UpdateShardCountInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountInput || (UpdateShardCountInput = {}));
var UpdateShardCountOutput;
(function(UpdateShardCountOutput) {
    UpdateShardCountOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountOutput || (UpdateShardCountOutput = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGZXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AddTagsToStreamCommand", function() {
    return serializeAws_json1_1AddTagsToStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1CreateStreamCommand", function() {
    return serializeAws_json1_1CreateStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DecreaseStreamRetentionPeriodCommand", function() {
    return serializeAws_json1_1DecreaseStreamRetentionPeriodCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteStreamCommand", function() {
    return serializeAws_json1_1DeleteStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeregisterStreamConsumerCommand", function() {
    return serializeAws_json1_1DeregisterStreamConsumerCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLimitsCommand", function() {
    return serializeAws_json1_1DescribeLimitsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamCommand", function() {
    return serializeAws_json1_1DescribeStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamConsumerCommand", function() {
    return serializeAws_json1_1DescribeStreamConsumerCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamSummaryCommand", function() {
    return serializeAws_json1_1DescribeStreamSummaryCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DisableEnhancedMonitoringCommand", function() {
    return serializeAws_json1_1DisableEnhancedMonitoringCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1EnableEnhancedMonitoringCommand", function() {
    return serializeAws_json1_1EnableEnhancedMonitoringCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetRecordsCommand", function() {
    return serializeAws_json1_1GetRecordsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1GetShardIteratorCommand", function() {
    return serializeAws_json1_1GetShardIteratorCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1IncreaseStreamRetentionPeriodCommand", function() {
    return serializeAws_json1_1IncreaseStreamRetentionPeriodCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListShardsCommand", function() {
    return serializeAws_json1_1ListShardsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamConsumersCommand", function() {
    return serializeAws_json1_1ListStreamConsumersCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamsCommand", function() {
    return serializeAws_json1_1ListStreamsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForStreamCommand", function() {
    return serializeAws_json1_1ListTagsForStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1MergeShardsCommand", function() {
    return serializeAws_json1_1MergeShardsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", function() {
    return serializeAws_json1_1PutRecordCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordsCommand", function() {
    return serializeAws_json1_1PutRecordsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1RegisterStreamConsumerCommand", function() {
    return serializeAws_json1_1RegisterStreamConsumerCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1RemoveTagsFromStreamCommand", function() {
    return serializeAws_json1_1RemoveTagsFromStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1SplitShardCommand", function() {
    return serializeAws_json1_1SplitShardCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StartStreamEncryptionCommand", function() {
    return serializeAws_json1_1StartStreamEncryptionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StopStreamEncryptionCommand", function() {
    return serializeAws_json1_1StopStreamEncryptionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1SubscribeToShardCommand", function() {
    return serializeAws_json1_1SubscribeToShardCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1UpdateShardCountCommand", function() {
    return serializeAws_json1_1UpdateShardCountCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1AddTagsToStreamCommand", function() {
    return deserializeAws_json1_1AddTagsToStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CreateStreamCommand", function() {
    return deserializeAws_json1_1CreateStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand", function() {
    return deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteStreamCommand", function() {
    return deserializeAws_json1_1DeleteStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeregisterStreamConsumerCommand", function() {
    return deserializeAws_json1_1DeregisterStreamConsumerCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLimitsCommand", function() {
    return deserializeAws_json1_1DescribeLimitsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamCommand", function() {
    return deserializeAws_json1_1DescribeStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamConsumerCommand", function() {
    return deserializeAws_json1_1DescribeStreamConsumerCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamSummaryCommand", function() {
    return deserializeAws_json1_1DescribeStreamSummaryCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DisableEnhancedMonitoringCommand", function() {
    return deserializeAws_json1_1DisableEnhancedMonitoringCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1EnableEnhancedMonitoringCommand", function() {
    return deserializeAws_json1_1EnableEnhancedMonitoringCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetRecordsCommand", function() {
    return deserializeAws_json1_1GetRecordsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1GetShardIteratorCommand", function() {
    return deserializeAws_json1_1GetShardIteratorCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand", function() {
    return deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListShardsCommand", function() {
    return deserializeAws_json1_1ListShardsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamConsumersCommand", function() {
    return deserializeAws_json1_1ListStreamConsumersCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamsCommand", function() {
    return deserializeAws_json1_1ListStreamsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForStreamCommand", function() {
    return deserializeAws_json1_1ListTagsForStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1MergeShardsCommand", function() {
    return deserializeAws_json1_1MergeShardsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", function() {
    return deserializeAws_json1_1PutRecordCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordsCommand", function() {
    return deserializeAws_json1_1PutRecordsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1RegisterStreamConsumerCommand", function() {
    return deserializeAws_json1_1RegisterStreamConsumerCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1RemoveTagsFromStreamCommand", function() {
    return deserializeAws_json1_1RemoveTagsFromStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1SplitShardCommand", function() {
    return deserializeAws_json1_1SplitShardCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StartStreamEncryptionCommand", function() {
    return deserializeAws_json1_1StartStreamEncryptionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StopStreamEncryptionCommand", function() {
    return deserializeAws_json1_1StopStreamEncryptionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1SubscribeToShardCommand", function() {
    return deserializeAws_json1_1SubscribeToShardCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateShardCountCommand", function() {
    return deserializeAws_json1_1UpdateShardCountCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AddTagsToStreamCommand = function serializeAws_json1_1AddTagsToStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.AddTagsToStream"
            };
            body = JSON.stringify(serializeAws_json1_1AddTagsToStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateStreamCommand = function serializeAws_json1_1CreateStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.CreateStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function serializeAws_json1_1DecreaseStreamRetentionPeriodCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DecreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1DecreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteStreamCommand = function serializeAws_json1_1DeleteStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeleteStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeregisterStreamConsumerCommand = function serializeAws_json1_1DeregisterStreamConsumerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeregisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DeregisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLimitsCommand = function serializeAws_json1_1DescribeLimitsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeLimits"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLimitsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamCommand = function serializeAws_json1_1DescribeStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamConsumerCommand = function serializeAws_json1_1DescribeStreamConsumerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamSummaryCommand = function serializeAws_json1_1DescribeStreamSummaryCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamSummary"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamSummaryInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringCommand = function serializeAws_json1_1DisableEnhancedMonitoringCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DisableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1DisableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringCommand = function serializeAws_json1_1EnableEnhancedMonitoringCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.EnableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1EnableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetRecordsCommand = function serializeAws_json1_1GetRecordsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetRecords"
            };
            body = JSON.stringify(serializeAws_json1_1GetRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetShardIteratorCommand = function serializeAws_json1_1GetShardIteratorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetShardIterator"
            };
            body = JSON.stringify(serializeAws_json1_1GetShardIteratorInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function serializeAws_json1_1IncreaseStreamRetentionPeriodCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.IncreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1IncreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListShardsCommand = function serializeAws_json1_1ListShardsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListShards"
            };
            body = JSON.stringify(serializeAws_json1_1ListShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamConsumersCommand = function serializeAws_json1_1ListStreamConsumersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreamConsumers"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamConsumersInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamsCommand = function serializeAws_json1_1ListStreamsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForStreamCommand = function serializeAws_json1_1ListTagsForStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListTagsForStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1MergeShardsCommand = function serializeAws_json1_1MergeShardsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.MergeShards"
            };
            body = JSON.stringify(serializeAws_json1_1MergeShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function serializeAws_json1_1PutRecordCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordsCommand = function serializeAws_json1_1PutRecordsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecords"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RegisterStreamConsumerCommand = function serializeAws_json1_1RegisterStreamConsumerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RegisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1RegisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RemoveTagsFromStreamCommand = function serializeAws_json1_1RemoveTagsFromStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RemoveTagsFromStream"
            };
            body = JSON.stringify(serializeAws_json1_1RemoveTagsFromStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SplitShardCommand = function serializeAws_json1_1SplitShardCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SplitShard"
            };
            body = JSON.stringify(serializeAws_json1_1SplitShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartStreamEncryptionCommand = function serializeAws_json1_1StartStreamEncryptionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StartStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopStreamEncryptionCommand = function serializeAws_json1_1StopStreamEncryptionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StopStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SubscribeToShardCommand = function serializeAws_json1_1SubscribeToShardCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SubscribeToShard"
            };
            body = JSON.stringify(serializeAws_json1_1SubscribeToShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateShardCountCommand = function serializeAws_json1_1UpdateShardCountCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.UpdateShardCount"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateShardCountInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommand = function deserializeAws_json1_1AddTagsToStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AddTagsToStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommandError = function deserializeAws_json1_1AddTagsToStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommand = function deserializeAws_json1_1CreateStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommandError = function deserializeAws_json1_1CreateStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError = function deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommand = function deserializeAws_json1_1DeleteStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommandError = function deserializeAws_json1_1DeleteStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommand = function deserializeAws_json1_1DeregisterStreamConsumerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeregisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommandError = function deserializeAws_json1_1DeregisterStreamConsumerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommand = function deserializeAws_json1_1DescribeLimitsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLimitsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLimitsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommandError = function deserializeAws_json1_1DescribeLimitsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommand = function deserializeAws_json1_1DescribeStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommandError = function deserializeAws_json1_1DescribeStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommand = function deserializeAws_json1_1DescribeStreamConsumerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommandError = function deserializeAws_json1_1DescribeStreamConsumerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommand = function deserializeAws_json1_1DescribeStreamSummaryCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamSummaryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamSummaryOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommandError = function deserializeAws_json1_1DescribeStreamSummaryCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommand = function deserializeAws_json1_1DisableEnhancedMonitoringCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommandError = function deserializeAws_json1_1DisableEnhancedMonitoringCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommand = function deserializeAws_json1_1EnableEnhancedMonitoringCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1EnableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommandError = function deserializeAws_json1_1EnableEnhancedMonitoringCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommand = function deserializeAws_json1_1GetRecordsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommandError = function deserializeAws_json1_1GetRecordsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredIteratorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommand = function deserializeAws_json1_1GetShardIteratorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetShardIteratorCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetShardIteratorOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommandError = function deserializeAws_json1_1GetShardIteratorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError = function deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommand = function deserializeAws_json1_1ListShardsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListShardsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommandError = function deserializeAws_json1_1ListShardsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommand = function deserializeAws_json1_1ListStreamConsumersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamConsumersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamConsumersOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommandError = function deserializeAws_json1_1ListStreamConsumersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommand = function deserializeAws_json1_1ListStreamsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommandError = function deserializeAws_json1_1ListStreamsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommand = function deserializeAws_json1_1ListTagsForStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommandError = function deserializeAws_json1_1ListTagsForStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommand = function deserializeAws_json1_1MergeShardsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1MergeShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommandError = function deserializeAws_json1_1MergeShardsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function deserializeAws_json1_1PutRecordCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function deserializeAws_json1_1PutRecordCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommand = function deserializeAws_json1_1PutRecordsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommandError = function deserializeAws_json1_1PutRecordsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommand = function deserializeAws_json1_1RegisterStreamConsumerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RegisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1RegisterStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommandError = function deserializeAws_json1_1RegisterStreamConsumerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommand = function deserializeAws_json1_1RemoveTagsFromStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RemoveTagsFromStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommandError = function deserializeAws_json1_1RemoveTagsFromStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommand = function deserializeAws_json1_1SplitShardCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SplitShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommandError = function deserializeAws_json1_1SplitShardCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommand = function deserializeAws_json1_1StartStreamEncryptionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommandError = function deserializeAws_json1_1StartStreamEncryptionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommand = function deserializeAws_json1_1StopStreamEncryptionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommandError = function deserializeAws_json1_1StopStreamEncryptionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommand = function deserializeAws_json1_1SubscribeToShardCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SubscribeToShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1SubscribeToShardOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommandError = function deserializeAws_json1_1SubscribeToShardCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommand = function deserializeAws_json1_1UpdateShardCountCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateShardCountCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateShardCountOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommandError = function deserializeAws_json1_1UpdateShardCountCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ExpiredIteratorExceptionResponse = function deserializeAws_json1_1ExpiredIteratorExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredIteratorException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredIteratorException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ExpiredNextTokenExceptionResponse = function deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredNextTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredNextTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSAccessDeniedExceptionResponse = function deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSAccessDeniedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSAccessDeniedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSDisabledExceptionResponse = function deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSDisabledException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSDisabledException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSInvalidStateExceptionResponse = function deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSInvalidStateException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSInvalidStateException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSNotFoundExceptionResponse = function deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSOptInRequiredResponse = function deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSOptInRequired(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSOptInRequired",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSThrottlingExceptionResponse = function deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSThrottlingException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSThrottlingException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse = function deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ProvisionedThroughputExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ProvisionedThroughputExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AddTagsToStreamInput = function serializeAws_json1_1AddTagsToStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagMap(input.Tags, context)
    });
};
var serializeAws_json1_1CreateStreamInput = function serializeAws_json1_1CreateStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardCount !== undefined && input.ShardCount !== null && {
        ShardCount: input.ShardCount
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodInput = function serializeAws_json1_1DecreaseStreamRetentionPeriodInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeleteStreamInput = function serializeAws_json1_1DeleteStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.EnforceConsumerDeletion !== undefined && input.EnforceConsumerDeletion !== null && {
        EnforceConsumerDeletion: input.EnforceConsumerDeletion
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeregisterStreamConsumerInput = function serializeAws_json1_1DeregisterStreamConsumerInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeLimitsInput = function serializeAws_json1_1DescribeLimitsInput(input, context) {
    return {};
};
var serializeAws_json1_1DescribeStreamConsumerInput = function serializeAws_json1_1DescribeStreamConsumerInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeStreamInput = function serializeAws_json1_1DescribeStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DescribeStreamSummaryInput = function serializeAws_json1_1DescribeStreamSummaryInput(input, context) {
    return (0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringInput = function serializeAws_json1_1DisableEnhancedMonitoringInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringInput = function serializeAws_json1_1EnableEnhancedMonitoringInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1GetRecordsInput = function serializeAws_json1_1GetRecordsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.ShardIterator !== undefined && input.ShardIterator !== null && {
        ShardIterator: input.ShardIterator
    });
};
var serializeAws_json1_1GetShardIteratorInput = function serializeAws_json1_1GetShardIteratorInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.ShardIteratorType !== undefined && input.ShardIteratorType !== null && {
        ShardIteratorType: input.ShardIteratorType
    }), input.StartingSequenceNumber !== undefined && input.StartingSequenceNumber !== null && {
        StartingSequenceNumber: input.StartingSequenceNumber
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodInput = function serializeAws_json1_1IncreaseStreamRetentionPeriodInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListShardsInput = function serializeAws_json1_1ListShardsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.ShardFilter !== undefined && input.ShardFilter !== null && {
        ShardFilter: serializeAws_json1_1ShardFilter(input.ShardFilter, context)
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListStreamConsumersInput = function serializeAws_json1_1ListStreamConsumersInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1ListStreamsInput = function serializeAws_json1_1ListStreamsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartStreamName !== undefined && input.ExclusiveStartStreamName !== null && {
        ExclusiveStartStreamName: input.ExclusiveStartStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListTagsForStreamInput = function serializeAws_json1_1ListTagsForStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MergeShardsInput = function serializeAws_json1_1MergeShardsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AdjacentShardToMerge !== undefined && input.AdjacentShardToMerge !== null && {
        AdjacentShardToMerge: input.AdjacentShardToMerge
    }), input.ShardToMerge !== undefined && input.ShardToMerge !== null && {
        ShardToMerge: input.ShardToMerge
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MetricsNameList = function serializeAws_json1_1MetricsNameList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1PutRecordInput = function serializeAws_json1_1PutRecordInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    }), input.SequenceNumberForOrdering !== undefined && input.SequenceNumberForOrdering !== null && {
        SequenceNumberForOrdering: input.SequenceNumberForOrdering
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsInput = function serializeAws_json1_1PutRecordsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordsRequestEntryList(input.Records, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsRequestEntry = function serializeAws_json1_1PutRecordsRequestEntry(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    });
};
var serializeAws_json1_1PutRecordsRequestEntryList = function serializeAws_json1_1PutRecordsRequestEntryList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1PutRecordsRequestEntry(entry, context);
    });
};
var serializeAws_json1_1RegisterStreamConsumerInput = function serializeAws_json1_1RegisterStreamConsumerInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1RemoveTagsFromStreamInput = function serializeAws_json1_1RemoveTagsFromStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1ShardFilter = function serializeAws_json1_1ShardFilter(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1SplitShardInput = function serializeAws_json1_1SplitShardInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.NewStartingHashKey !== undefined && input.NewStartingHashKey !== null && {
        NewStartingHashKey: input.NewStartingHashKey
    }), input.ShardToSplit !== undefined && input.ShardToSplit !== null && {
        ShardToSplit: input.ShardToSplit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StartingPosition = function serializeAws_json1_1StartingPosition(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.SequenceNumber !== undefined && input.SequenceNumber !== null && {
        SequenceNumber: input.SequenceNumber
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1StartStreamEncryptionInput = function serializeAws_json1_1StartStreamEncryptionInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StopStreamEncryptionInput = function serializeAws_json1_1StopStreamEncryptionInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1SubscribeToShardInput = function serializeAws_json1_1SubscribeToShardInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.StartingPosition !== undefined && input.StartingPosition !== null && {
        StartingPosition: serializeAws_json1_1StartingPosition(input.StartingPosition, context)
    });
};
var serializeAws_json1_1TagKeyList = function serializeAws_json1_1TagKeyList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagMap = function serializeAws_json1_1TagMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1UpdateShardCountInput = function serializeAws_json1_1UpdateShardCountInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ScalingType !== undefined && input.ScalingType !== null && {
        ScalingType: input.ScalingType
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TargetShardCount !== undefined && input.TargetShardCount !== null && {
        TargetShardCount: input.TargetShardCount
    });
};
var deserializeAws_json1_1ChildShard = function deserializeAws_json1_1ChildShard(output, context) {
    return {
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShards: output.ParentShards !== undefined && output.ParentShards !== null ? deserializeAws_json1_1ShardIdList(output.ParentShards, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ChildShardList = function deserializeAws_json1_1ChildShardList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ChildShard(entry, context);
    });
};
var deserializeAws_json1_1Consumer = function deserializeAws_json1_1Consumer(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined
    };
};
var deserializeAws_json1_1ConsumerDescription = function deserializeAws_json1_1ConsumerDescription(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined
    };
};
var deserializeAws_json1_1ConsumerList = function deserializeAws_json1_1ConsumerList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Consumer(entry, context);
    });
};
var deserializeAws_json1_1DescribeLimitsOutput = function deserializeAws_json1_1DescribeLimitsOutput(output, context) {
    return {
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        ShardLimit: output.ShardLimit !== undefined && output.ShardLimit !== null ? output.ShardLimit : undefined
    };
};
var deserializeAws_json1_1DescribeStreamConsumerOutput = function deserializeAws_json1_1DescribeStreamConsumerOutput(output, context) {
    return {
        ConsumerDescription: output.ConsumerDescription !== undefined && output.ConsumerDescription !== null ? deserializeAws_json1_1ConsumerDescription(output.ConsumerDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamOutput = function deserializeAws_json1_1DescribeStreamOutput(output, context) {
    return {
        StreamDescription: output.StreamDescription !== undefined && output.StreamDescription !== null ? deserializeAws_json1_1StreamDescription(output.StreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamSummaryOutput = function deserializeAws_json1_1DescribeStreamSummaryOutput(output, context) {
    return {
        StreamDescriptionSummary: output.StreamDescriptionSummary !== undefined && output.StreamDescriptionSummary !== null ? deserializeAws_json1_1StreamDescriptionSummary(output.StreamDescriptionSummary, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMetrics = function deserializeAws_json1_1EnhancedMetrics(output, context) {
    return {
        ShardLevelMetrics: output.ShardLevelMetrics !== undefined && output.ShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.ShardLevelMetrics, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMonitoringList = function deserializeAws_json1_1EnhancedMonitoringList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1EnhancedMetrics(entry, context);
    });
};
var deserializeAws_json1_1EnhancedMonitoringOutput = function deserializeAws_json1_1EnhancedMonitoringOutput(output, context) {
    return {
        CurrentShardLevelMetrics: output.CurrentShardLevelMetrics !== undefined && output.CurrentShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.CurrentShardLevelMetrics, context) : undefined,
        DesiredShardLevelMetrics: output.DesiredShardLevelMetrics !== undefined && output.DesiredShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.DesiredShardLevelMetrics, context) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined
    };
};
var deserializeAws_json1_1ExpiredIteratorException = function deserializeAws_json1_1ExpiredIteratorException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExpiredNextTokenException = function deserializeAws_json1_1ExpiredNextTokenException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1GetRecordsOutput = function deserializeAws_json1_1GetRecordsOutput(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        NextShardIterator: output.NextShardIterator !== undefined && output.NextShardIterator !== null ? output.NextShardIterator : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1GetShardIteratorOutput = function deserializeAws_json1_1GetShardIteratorOutput(output, context) {
    return {
        ShardIterator: output.ShardIterator !== undefined && output.ShardIterator !== null ? output.ShardIterator : undefined
    };
};
var deserializeAws_json1_1HashKeyRange = function deserializeAws_json1_1HashKeyRange(output, context) {
    return {
        EndingHashKey: output.EndingHashKey !== undefined && output.EndingHashKey !== null ? output.EndingHashKey : undefined,
        StartingHashKey: output.StartingHashKey !== undefined && output.StartingHashKey !== null ? output.StartingHashKey : undefined
    };
};
var deserializeAws_json1_1InternalFailureException = function deserializeAws_json1_1InternalFailureException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function deserializeAws_json1_1InvalidArgumentException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSAccessDeniedException = function deserializeAws_json1_1KMSAccessDeniedException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSDisabledException = function deserializeAws_json1_1KMSDisabledException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSInvalidStateException = function deserializeAws_json1_1KMSInvalidStateException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSNotFoundException = function deserializeAws_json1_1KMSNotFoundException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSOptInRequired = function deserializeAws_json1_1KMSOptInRequired(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSThrottlingException = function deserializeAws_json1_1KMSThrottlingException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function deserializeAws_json1_1LimitExceededException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListShardsOutput = function deserializeAws_json1_1ListShardsOutput(output, context) {
    return {
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined
    };
};
var deserializeAws_json1_1ListStreamConsumersOutput = function deserializeAws_json1_1ListStreamConsumersOutput(output, context) {
    return {
        Consumers: output.Consumers !== undefined && output.Consumers !== null ? deserializeAws_json1_1ConsumerList(output.Consumers, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var deserializeAws_json1_1ListStreamsOutput = function deserializeAws_json1_1ListStreamsOutput(output, context) {
    return {
        HasMoreStreams: output.HasMoreStreams !== undefined && output.HasMoreStreams !== null ? output.HasMoreStreams : undefined,
        StreamNames: output.StreamNames !== undefined && output.StreamNames !== null ? deserializeAws_json1_1StreamNameList(output.StreamNames, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForStreamOutput = function deserializeAws_json1_1ListTagsForStreamOutput(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1TagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1MetricsNameList = function deserializeAws_json1_1MetricsNameList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededException = function deserializeAws_json1_1ProvisionedThroughputExceededException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1PutRecordOutput = function deserializeAws_json1_1PutRecordOutput(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsOutput = function deserializeAws_json1_1PutRecordsOutput(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        FailedRecordCount: output.FailedRecordCount !== undefined && output.FailedRecordCount !== null ? output.FailedRecordCount : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1PutRecordsResultEntryList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntry = function deserializeAws_json1_1PutRecordsResultEntry(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntryList = function deserializeAws_json1_1PutRecordsResultEntryList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordsResultEntry(entry, context);
    });
};
var deserializeAws_json1_1_Record = function deserializeAws_json1_1_Record(output, context) {
    return {
        ApproximateArrivalTimestamp: output.ApproximateArrivalTimestamp !== undefined && output.ApproximateArrivalTimestamp !== null ? new Date(Math.round(output.ApproximateArrivalTimestamp * 1000)) : undefined,
        Data: output.Data !== undefined && output.Data !== null ? context.base64Decoder(output.Data) : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        PartitionKey: output.PartitionKey !== undefined && output.PartitionKey !== null ? output.PartitionKey : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined
    };
};
var deserializeAws_json1_1RecordList = function deserializeAws_json1_1RecordList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1_Record(entry, context);
    });
};
var deserializeAws_json1_1RegisterStreamConsumerOutput = function deserializeAws_json1_1RegisterStreamConsumerOutput(output, context) {
    return {
        Consumer: output.Consumer !== undefined && output.Consumer !== null ? deserializeAws_json1_1Consumer(output.Consumer, context) : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function deserializeAws_json1_1ResourceInUseException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function deserializeAws_json1_1ResourceNotFoundException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SequenceNumberRange = function deserializeAws_json1_1SequenceNumberRange(output, context) {
    return {
        EndingSequenceNumber: output.EndingSequenceNumber !== undefined && output.EndingSequenceNumber !== null ? output.EndingSequenceNumber : undefined,
        StartingSequenceNumber: output.StartingSequenceNumber !== undefined && output.StartingSequenceNumber !== null ? output.StartingSequenceNumber : undefined
    };
};
var deserializeAws_json1_1Shard = function deserializeAws_json1_1Shard(output, context) {
    return {
        AdjacentParentShardId: output.AdjacentParentShardId !== undefined && output.AdjacentParentShardId !== null ? output.AdjacentParentShardId : undefined,
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShardId: output.ParentShardId !== undefined && output.ParentShardId !== null ? output.ParentShardId : undefined,
        SequenceNumberRange: output.SequenceNumberRange !== undefined && output.SequenceNumberRange !== null ? deserializeAws_json1_1SequenceNumberRange(output.SequenceNumberRange, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ShardIdList = function deserializeAws_json1_1ShardIdList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ShardList = function deserializeAws_json1_1ShardList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Shard(entry, context);
    });
};
var deserializeAws_json1_1StreamDescription = function deserializeAws_json1_1StreamDescription(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        HasMoreShards: output.HasMoreShards !== undefined && output.HasMoreShards !== null ? output.HasMoreShards : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamDescriptionSummary = function deserializeAws_json1_1StreamDescriptionSummary(output, context) {
    return {
        ConsumerCount: output.ConsumerCount !== undefined && output.ConsumerCount !== null ? output.ConsumerCount : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamNameList = function deserializeAws_json1_1StreamNameList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1SubscribeToShardEvent = function deserializeAws_json1_1SubscribeToShardEvent(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        ContinuationSequenceNumber: output.ContinuationSequenceNumber !== undefined && output.ContinuationSequenceNumber !== null ? output.ContinuationSequenceNumber : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1SubscribeToShardEventStream = function deserializeAws_json1_1SubscribeToShardEventStream(output, context) {
    if (output.InternalFailureException !== undefined && output.InternalFailureException !== null) return {
        InternalFailureException: deserializeAws_json1_1InternalFailureException(output.InternalFailureException, context)
    };
    if (output.KMSAccessDeniedException !== undefined && output.KMSAccessDeniedException !== null) return {
        KMSAccessDeniedException: deserializeAws_json1_1KMSAccessDeniedException(output.KMSAccessDeniedException, context)
    };
    if (output.KMSDisabledException !== undefined && output.KMSDisabledException !== null) return {
        KMSDisabledException: deserializeAws_json1_1KMSDisabledException(output.KMSDisabledException, context)
    };
    if (output.KMSInvalidStateException !== undefined && output.KMSInvalidStateException !== null) return {
        KMSInvalidStateException: deserializeAws_json1_1KMSInvalidStateException(output.KMSInvalidStateException, context)
    };
    if (output.KMSNotFoundException !== undefined && output.KMSNotFoundException !== null) return {
        KMSNotFoundException: deserializeAws_json1_1KMSNotFoundException(output.KMSNotFoundException, context)
    };
    if (output.KMSOptInRequired !== undefined && output.KMSOptInRequired !== null) return {
        KMSOptInRequired: deserializeAws_json1_1KMSOptInRequired(output.KMSOptInRequired, context)
    };
    if (output.KMSThrottlingException !== undefined && output.KMSThrottlingException !== null) return {
        KMSThrottlingException: deserializeAws_json1_1KMSThrottlingException(output.KMSThrottlingException, context)
    };
    if (output.ResourceInUseException !== undefined && output.ResourceInUseException !== null) return {
        ResourceInUseException: deserializeAws_json1_1ResourceInUseException(output.ResourceInUseException, context)
    };
    if (output.ResourceNotFoundException !== undefined && output.ResourceNotFoundException !== null) return {
        ResourceNotFoundException: deserializeAws_json1_1ResourceNotFoundException(output.ResourceNotFoundException, context)
    };
    if (output.SubscribeToShardEvent !== undefined && output.SubscribeToShardEvent !== null) return {
        SubscribeToShardEvent: deserializeAws_json1_1SubscribeToShardEvent(output.SubscribeToShardEvent, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var deserializeAws_json1_1SubscribeToShardOutput = function deserializeAws_json1_1SubscribeToShardOutput(output, context) {
    return {
        EventStream: output.EventStream !== undefined && output.EventStream !== null ? deserializeAws_json1_1SubscribeToShardEventStream(output.EventStream, context) : undefined
    };
};
var deserializeAws_json1_1Tag = function deserializeAws_json1_1Tag(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagList = function deserializeAws_json1_1TagList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1UpdateShardCountOutput = function deserializeAws_json1_1UpdateShardCountOutput(output, context) {
    return {
        CurrentShardCount: output.CurrentShardCount !== undefined && output.CurrentShardCount !== null ? output.CurrentShardCount : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        TargetShardCount: output.TargetShardCount !== undefined && output.TargetShardCount !== null ? output.TargetShardCount : undefined
    };
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function buildHttpRpcRequest(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxYWT":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", function() {
    return AWSKinesisFirehoseProvider;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _clientFirehose = require("@aws-sdk/client-firehose");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)('AWSKineisFirehoseProvider');
var AWSKinesisFirehoseProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSKinesisFirehoseProvider, _super);
    function AWSKinesisFirehoseProvider(config) {
        return _super.call(this, config) || this;
    }
    /**
     * get provider name of the plugin
     */ AWSKinesisFirehoseProvider.prototype.getProviderName = function() {
        return 'AWSKinesisFirehose';
    };
    AWSKinesisFirehoseProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // split by streamName
            var evt = params.event;
            var streamName = evt.streamName, data = evt.data;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = data && typeof data !== 'string' ? JSON.stringify(data) : data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var record = {
                Data: Data
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            logger.debug('putting records to kinesis', streamName, 'with records', records[streamName]);
            _this._kinesisFirehose.send(new (0, _clientFirehose.PutRecordBatchCommand)({
                Records: records[streamName],
                DeliveryStreamName: streamName
            })).then(function(res) {
                return logger.debug('Upload records to stream', streamName);
            }).catch(function(err) {
                return logger.debug('Failed to upload records to Kinesis', err);
            });
        });
    };
    AWSKinesisFirehoseProvider.prototype._init = function(config, credentials) {
        logger.debug('init clients');
        if (this._kinesisFirehose && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug('no change for analytics config, directly return from init');
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        return this._initFirehose(region, credentials);
    };
    AWSKinesisFirehoseProvider.prototype._initFirehose = function(region, credentials) {
        logger.debug('initialize kinesis firehose with credentials', credentials);
        this._kinesisFirehose = new (0, _clientFirehose.FirehoseClient)({
            apiVersion: '2015-08-04',
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    return AWSKinesisFirehoseProvider;
}((0, _awskinesisProvider.AWSKinesisProvider));

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","./AWSKinesisProvider":"2sXdp","@aws-sdk/client-firehose":"jfjSa","@aws-sdk/util-utf8-browser":"iZmxX","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jfjSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _firehoseClient = require("./FirehoseClient");
parcelHelpers.exportAll(_firehoseClient, exports);
var _firehose = require("./Firehose");
parcelHelpers.exportAll(_firehose, exports);
var _createDeliveryStreamCommand = require("./commands/CreateDeliveryStreamCommand");
parcelHelpers.exportAll(_createDeliveryStreamCommand, exports);
var _deleteDeliveryStreamCommand = require("./commands/DeleteDeliveryStreamCommand");
parcelHelpers.exportAll(_deleteDeliveryStreamCommand, exports);
var _describeDeliveryStreamCommand = require("./commands/DescribeDeliveryStreamCommand");
parcelHelpers.exportAll(_describeDeliveryStreamCommand, exports);
var _listDeliveryStreamsCommand = require("./commands/ListDeliveryStreamsCommand");
parcelHelpers.exportAll(_listDeliveryStreamsCommand, exports);
var _listTagsForDeliveryStreamCommand = require("./commands/ListTagsForDeliveryStreamCommand");
parcelHelpers.exportAll(_listTagsForDeliveryStreamCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordBatchCommand = require("./commands/PutRecordBatchCommand");
parcelHelpers.exportAll(_putRecordBatchCommand, exports);
var _startDeliveryStreamEncryptionCommand = require("./commands/StartDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_startDeliveryStreamEncryptionCommand, exports);
var _stopDeliveryStreamEncryptionCommand = require("./commands/StopDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_stopDeliveryStreamEncryptionCommand, exports);
var _tagDeliveryStreamCommand = require("./commands/TagDeliveryStreamCommand");
parcelHelpers.exportAll(_tagDeliveryStreamCommand, exports);
var _untagDeliveryStreamCommand = require("./commands/UntagDeliveryStreamCommand");
parcelHelpers.exportAll(_untagDeliveryStreamCommand, exports);
var _updateDestinationCommand = require("./commands/UpdateDestinationCommand");
parcelHelpers.exportAll(_updateDestinationCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./FirehoseClient":"9eNrP","./Firehose":false,"./commands/CreateDeliveryStreamCommand":false,"./commands/DeleteDeliveryStreamCommand":false,"./commands/DescribeDeliveryStreamCommand":false,"./commands/ListDeliveryStreamsCommand":false,"./commands/ListTagsForDeliveryStreamCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordBatchCommand":"lLpZW","./commands/StartDeliveryStreamEncryptionCommand":false,"./commands/StopDeliveryStreamEncryptionCommand":false,"./commands/TagDeliveryStreamCommand":false,"./commands/UntagDeliveryStreamCommand":false,"./commands/UpdateDestinationCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eNrP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirehoseClient", function() {
    return FirehoseClient;
});
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Firehose API Reference</fullname>
 *          <p>Amazon Kinesis Data Firehose is a fully managed service that delivers real-time
 *          streaming data to destinations such as Amazon Simple Storage Service (Amazon S3), Amazon
 *          Elasticsearch Service (Amazon ES), Amazon Redshift, and Splunk.</p>
 */ var FirehoseClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(FirehoseClient, _super);
    function FirehoseClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    FirehoseClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return FirehoseClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"3z64N","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3z64N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", function() {
    return ClientDefaultValues;
});
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function credentialDefaultProvider(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"hBp6e","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"hOYXY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hBp6e":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-firehose\",\"description\":\"AWS SDK for JavaScript Firehose Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test\":\"exit 0\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-firehose\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-firehose\"}}");

},{}],"hOYXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", function() {
    return ClientSharedValues;
});
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2015-08-04",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Firehose",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"lNb4h","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lNb4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "firehose.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "firehose.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "firehose.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "firehose.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "firehose.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "firehose.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "firehose.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "firehose.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "firehose.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "firehose.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "firehose.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "firehose.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "firehose.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "firehose.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "firehose.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "firehose.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "firehose.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "firehose.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "firehose.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "firehose.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "firehose.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "firehose-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "firehose-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "firehose.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "firehose.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "firehose.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "firehose.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "firehose.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "firehose.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "firehose.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "firehose.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "firehose"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLpZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordBatchCommand", function() {
    return PutRecordBatchCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a delivery stream in a single call, which can
 *          achieve higher throughput per producer than when writing single records. To write single
 *          data records into a delivery stream, use <a>PutRecord</a>. Applications using
 *          these operations are referred to as producers.</p>
 *          <p>For information about service quota, see <a href="https://docs.aws.amazon.com/firehose/latest/dev/limits.html">Amazon Kinesis Data Firehose
 *          Quota</a>.</p>
 *          <p>Each <a>PutRecordBatch</a> request supports up to 500 records. Each record
 *          in the request can be as large as 1,000 KB (before 64-bit encoding), up to a limit of 4 MB
 *          for the entire request. These limits cannot be changed.</p>
 *          <p>You must specify the name of the delivery stream and the data record when using <a>PutRecord</a>. The data record consists of a data blob that can be up to 1,000
 *          KB in size, and any kind of data. For example, it could be a segment from a log file,
 *          geographic location data, website clickstream data, and so on.</p>
 *          <p>Kinesis Data Firehose buffers records before delivering them to the destination. To
 *          disambiguate the data blobs at the destination, a common solution is to use delimiters in
 *          the data, such as a newline (<code>\n</code>) or some other character unique within the
 *          data. This allows the consumer application to parse individual data items when reading the
 *          data from the destination.</p>
 *          <p>The <a>PutRecordBatch</a> response includes a count of failed records,
 *             <code>FailedPutCount</code>, and an array of responses, <code>RequestResponses</code>.
 *          Even if the <a>PutRecordBatch</a> call succeeds, the value of
 *             <code>FailedPutCount</code> may be greater than 0, indicating that there are records for
 *          which the operation didn't succeed. Each entry in the <code>RequestResponses</code> array
 *          provides additional information about the processed record. It directly correlates with a
 *          record in the request array using the same ordering, from the top to the bottom. The
 *          response array always includes the same number of records as the request array.
 *             <code>RequestResponses</code> includes both successfully and unsuccessfully processed
 *          records. Kinesis Data Firehose tries to process all records in each <a>PutRecordBatch</a> request. A single record failure does not stop the processing
 *          of subsequent records. </p>
 *          <p>A successfully processed record includes a <code>RecordId</code> value, which is
 *          unique for the record. An unsuccessfully processed record includes <code>ErrorCode</code>
 *          and <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error,
 *          and is one of the following values: <code>ServiceUnavailableException</code> or
 *             <code>InternalFailure</code>. <code>ErrorMessage</code> provides more detailed
 *          information about the error.</p>
 *          <p>If there is an internal server error or a timeout, the write might have completed or
 *          it might have failed. If <code>FailedPutCount</code> is greater than 0, retry the request,
 *          resending only those records that might have failed processing. This minimizes the possible
 *          duplicate records and also reduces the total bytes sent (and corresponding charges). We
 *          recommend that you handle any duplicates at the destination.</p>
 *          <p>If <a>PutRecordBatch</a> throws <code>ServiceUnavailableException</code>,
 *          back off and retry. If the exception persists, it is possible that the throughput limits
 *          have been exceeded for the delivery stream.</p>
 *
 *          <p>Data records sent to Kinesis Data Firehose are stored for 24 hours from the time they
 *          are added to a delivery stream as it attempts to send the records to the destination. If
 *          the destination is unreachable for more than 24 hours, the data is no longer
 *          available.</p>
 *          <important>
 *             <p>Don't concatenate two or more base64 strings to form the data fields of your records.
 *             Instead, concatenate the raw data, then perform base64 encoding.</p>
 *          </important>
 */ var PutRecordBatchCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordBatchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordBatchCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordBatchCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "PutRecordBatchCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordBatchInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordBatchOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordBatchCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordBatchCommand)(input, context);
    };
    PutRecordBatchCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordBatchCommand)(output, context);
    };
    return PutRecordBatchCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"cGmm8","../protocols/Aws_json1_1":"lKm6X","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGmm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferingHints", function() {
    return BufferingHints;
});
parcelHelpers.export(exports, "CloudWatchLoggingOptions", function() {
    return CloudWatchLoggingOptions;
});
parcelHelpers.export(exports, "CompressionFormat", function() {
    return CompressionFormat;
});
parcelHelpers.export(exports, "ConcurrentModificationException", function() {
    return ConcurrentModificationException;
});
parcelHelpers.export(exports, "ContentEncoding", function() {
    return ContentEncoding;
});
parcelHelpers.export(exports, "CopyCommand", function() {
    return CopyCommand;
});
parcelHelpers.export(exports, "KeyType", function() {
    return KeyType;
});
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfigurationInput", function() {
    return DeliveryStreamEncryptionConfigurationInput;
});
parcelHelpers.export(exports, "ElasticsearchBufferingHints", function() {
    return ElasticsearchBufferingHints;
});
parcelHelpers.export(exports, "ProcessorParameterName", function() {
    return ProcessorParameterName;
});
parcelHelpers.export(exports, "ProcessorParameter", function() {
    return ProcessorParameter;
});
parcelHelpers.export(exports, "Processor", function() {
    return Processor;
});
parcelHelpers.export(exports, "ProcessingConfiguration", function() {
    return ProcessingConfiguration;
});
parcelHelpers.export(exports, "ElasticsearchRetryOptions", function() {
    return ElasticsearchRetryOptions;
});
parcelHelpers.export(exports, "KMSEncryptionConfig", function() {
    return KMSEncryptionConfig;
});
parcelHelpers.export(exports, "EncryptionConfiguration", function() {
    return EncryptionConfiguration;
});
parcelHelpers.export(exports, "S3DestinationConfiguration", function() {
    return S3DestinationConfiguration;
});
parcelHelpers.export(exports, "VpcConfiguration", function() {
    return VpcConfiguration;
});
parcelHelpers.export(exports, "ElasticsearchDestinationConfiguration", function() {
    return ElasticsearchDestinationConfiguration;
});
parcelHelpers.export(exports, "HiveJsonSerDe", function() {
    return HiveJsonSerDe;
});
parcelHelpers.export(exports, "OpenXJsonSerDe", function() {
    return OpenXJsonSerDe;
});
parcelHelpers.export(exports, "Deserializer", function() {
    return Deserializer;
});
parcelHelpers.export(exports, "InputFormatConfiguration", function() {
    return InputFormatConfiguration;
});
parcelHelpers.export(exports, "OrcCompression", function() {
    return OrcCompression;
});
parcelHelpers.export(exports, "OrcFormatVersion", function() {
    return OrcFormatVersion;
});
parcelHelpers.export(exports, "OrcSerDe", function() {
    return OrcSerDe;
});
parcelHelpers.export(exports, "ParquetCompression", function() {
    return ParquetCompression;
});
parcelHelpers.export(exports, "ParquetWriterVersion", function() {
    return ParquetWriterVersion;
});
parcelHelpers.export(exports, "ParquetSerDe", function() {
    return ParquetSerDe;
});
parcelHelpers.export(exports, "Serializer", function() {
    return Serializer;
});
parcelHelpers.export(exports, "OutputFormatConfiguration", function() {
    return OutputFormatConfiguration;
});
parcelHelpers.export(exports, "SchemaConfiguration", function() {
    return SchemaConfiguration;
});
parcelHelpers.export(exports, "DataFormatConversionConfiguration", function() {
    return DataFormatConversionConfiguration;
});
parcelHelpers.export(exports, "ExtendedS3DestinationConfiguration", function() {
    return ExtendedS3DestinationConfiguration;
});
parcelHelpers.export(exports, "HttpEndpointBufferingHints", function() {
    return HttpEndpointBufferingHints;
});
parcelHelpers.export(exports, "HttpEndpointConfiguration", function() {
    return HttpEndpointConfiguration;
});
parcelHelpers.export(exports, "HttpEndpointCommonAttribute", function() {
    return HttpEndpointCommonAttribute;
});
parcelHelpers.export(exports, "HttpEndpointRequestConfiguration", function() {
    return HttpEndpointRequestConfiguration;
});
parcelHelpers.export(exports, "HttpEndpointRetryOptions", function() {
    return HttpEndpointRetryOptions;
});
parcelHelpers.export(exports, "HttpEndpointDestinationConfiguration", function() {
    return HttpEndpointDestinationConfiguration;
});
parcelHelpers.export(exports, "KinesisStreamSourceConfiguration", function() {
    return KinesisStreamSourceConfiguration;
});
parcelHelpers.export(exports, "RedshiftRetryOptions", function() {
    return RedshiftRetryOptions;
});
parcelHelpers.export(exports, "RedshiftDestinationConfiguration", function() {
    return RedshiftDestinationConfiguration;
});
parcelHelpers.export(exports, "SplunkRetryOptions", function() {
    return SplunkRetryOptions;
});
parcelHelpers.export(exports, "SplunkDestinationConfiguration", function() {
    return SplunkDestinationConfiguration;
});
parcelHelpers.export(exports, "Tag", function() {
    return Tag;
});
parcelHelpers.export(exports, "CreateDeliveryStreamInput", function() {
    return CreateDeliveryStreamInput;
});
parcelHelpers.export(exports, "CreateDeliveryStreamOutput", function() {
    return CreateDeliveryStreamOutput;
});
parcelHelpers.export(exports, "InvalidArgumentException", function() {
    return InvalidArgumentException;
});
parcelHelpers.export(exports, "InvalidKMSResourceException", function() {
    return InvalidKMSResourceException;
});
parcelHelpers.export(exports, "LimitExceededException", function() {
    return LimitExceededException;
});
parcelHelpers.export(exports, "ResourceInUseException", function() {
    return ResourceInUseException;
});
parcelHelpers.export(exports, "DeleteDeliveryStreamInput", function() {
    return DeleteDeliveryStreamInput;
});
parcelHelpers.export(exports, "DeleteDeliveryStreamOutput", function() {
    return DeleteDeliveryStreamOutput;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "DeliveryStreamFailureType", function() {
    return DeliveryStreamFailureType;
});
parcelHelpers.export(exports, "FailureDescription", function() {
    return FailureDescription;
});
parcelHelpers.export(exports, "DeliveryStreamEncryptionStatus", function() {
    return DeliveryStreamEncryptionStatus;
});
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfiguration", function() {
    return DeliveryStreamEncryptionConfiguration;
});
parcelHelpers.export(exports, "DeliveryStreamStatus", function() {
    return DeliveryStreamStatus;
});
parcelHelpers.export(exports, "S3DestinationDescription", function() {
    return S3DestinationDescription;
});
parcelHelpers.export(exports, "VpcConfigurationDescription", function() {
    return VpcConfigurationDescription;
});
parcelHelpers.export(exports, "ElasticsearchDestinationDescription", function() {
    return ElasticsearchDestinationDescription;
});
parcelHelpers.export(exports, "ExtendedS3DestinationDescription", function() {
    return ExtendedS3DestinationDescription;
});
parcelHelpers.export(exports, "HttpEndpointDescription", function() {
    return HttpEndpointDescription;
});
parcelHelpers.export(exports, "HttpEndpointDestinationDescription", function() {
    return HttpEndpointDestinationDescription;
});
parcelHelpers.export(exports, "RedshiftDestinationDescription", function() {
    return RedshiftDestinationDescription;
});
parcelHelpers.export(exports, "SplunkDestinationDescription", function() {
    return SplunkDestinationDescription;
});
parcelHelpers.export(exports, "DestinationDescription", function() {
    return DestinationDescription;
});
parcelHelpers.export(exports, "KinesisStreamSourceDescription", function() {
    return KinesisStreamSourceDescription;
});
parcelHelpers.export(exports, "SourceDescription", function() {
    return SourceDescription;
});
parcelHelpers.export(exports, "DeliveryStreamDescription", function() {
    return DeliveryStreamDescription;
});
parcelHelpers.export(exports, "DescribeDeliveryStreamInput", function() {
    return DescribeDeliveryStreamInput;
});
parcelHelpers.export(exports, "DescribeDeliveryStreamOutput", function() {
    return DescribeDeliveryStreamOutput;
});
parcelHelpers.export(exports, "S3DestinationUpdate", function() {
    return S3DestinationUpdate;
});
parcelHelpers.export(exports, "ElasticsearchDestinationUpdate", function() {
    return ElasticsearchDestinationUpdate;
});
parcelHelpers.export(exports, "ExtendedS3DestinationUpdate", function() {
    return ExtendedS3DestinationUpdate;
});
parcelHelpers.export(exports, "ListDeliveryStreamsInput", function() {
    return ListDeliveryStreamsInput;
});
parcelHelpers.export(exports, "ListDeliveryStreamsOutput", function() {
    return ListDeliveryStreamsOutput;
});
parcelHelpers.export(exports, "ListTagsForDeliveryStreamInput", function() {
    return ListTagsForDeliveryStreamInput;
});
parcelHelpers.export(exports, "ListTagsForDeliveryStreamOutput", function() {
    return ListTagsForDeliveryStreamOutput;
});
parcelHelpers.export(exports, "_Record", function() {
    return _Record;
});
parcelHelpers.export(exports, "PutRecordInput", function() {
    return PutRecordInput;
});
parcelHelpers.export(exports, "PutRecordOutput", function() {
    return PutRecordOutput;
});
parcelHelpers.export(exports, "ServiceUnavailableException", function() {
    return ServiceUnavailableException;
});
parcelHelpers.export(exports, "PutRecordBatchInput", function() {
    return PutRecordBatchInput;
});
parcelHelpers.export(exports, "PutRecordBatchResponseEntry", function() {
    return PutRecordBatchResponseEntry;
});
parcelHelpers.export(exports, "PutRecordBatchOutput", function() {
    return PutRecordBatchOutput;
});
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionInput", function() {
    return StartDeliveryStreamEncryptionInput;
});
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionOutput", function() {
    return StartDeliveryStreamEncryptionOutput;
});
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionInput", function() {
    return StopDeliveryStreamEncryptionInput;
});
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionOutput", function() {
    return StopDeliveryStreamEncryptionOutput;
});
parcelHelpers.export(exports, "TagDeliveryStreamInput", function() {
    return TagDeliveryStreamInput;
});
parcelHelpers.export(exports, "TagDeliveryStreamOutput", function() {
    return TagDeliveryStreamOutput;
});
parcelHelpers.export(exports, "UntagDeliveryStreamInput", function() {
    return UntagDeliveryStreamInput;
});
parcelHelpers.export(exports, "UntagDeliveryStreamOutput", function() {
    return UntagDeliveryStreamOutput;
});
parcelHelpers.export(exports, "HttpEndpointDestinationUpdate", function() {
    return HttpEndpointDestinationUpdate;
});
parcelHelpers.export(exports, "RedshiftDestinationUpdate", function() {
    return RedshiftDestinationUpdate;
});
parcelHelpers.export(exports, "SplunkDestinationUpdate", function() {
    return SplunkDestinationUpdate;
});
parcelHelpers.export(exports, "UpdateDestinationInput", function() {
    return UpdateDestinationInput;
});
parcelHelpers.export(exports, "UpdateDestinationOutput", function() {
    return UpdateDestinationOutput;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var BufferingHints;
(function(BufferingHints) {
    BufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(BufferingHints || (BufferingHints = {}));
var CloudWatchLoggingOptions;
(function(CloudWatchLoggingOptions) {
    CloudWatchLoggingOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CloudWatchLoggingOptions || (CloudWatchLoggingOptions = {}));
var CompressionFormat;
(function(CompressionFormat) {
    CompressionFormat["GZIP"] = "GZIP";
    CompressionFormat["HADOOP_SNAPPY"] = "HADOOP_SNAPPY";
    CompressionFormat["SNAPPY"] = "Snappy";
    CompressionFormat["UNCOMPRESSED"] = "UNCOMPRESSED";
    CompressionFormat["ZIP"] = "ZIP";
})(CompressionFormat || (CompressionFormat = {}));
var ConcurrentModificationException;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
var ContentEncoding;
(function(ContentEncoding) {
    ContentEncoding["GZIP"] = "GZIP";
    ContentEncoding["NONE"] = "NONE";
})(ContentEncoding || (ContentEncoding = {}));
var CopyCommand;
(function(CopyCommand) {
    CopyCommand.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CopyCommand || (CopyCommand = {}));
var KeyType;
(function(KeyType) {
    KeyType["AWS_OWNED_CMK"] = "AWS_OWNED_CMK";
    KeyType["CUSTOMER_MANAGED_CMK"] = "CUSTOMER_MANAGED_CMK";
})(KeyType || (KeyType = {}));
var DeliveryStreamEncryptionConfigurationInput;
(function(DeliveryStreamEncryptionConfigurationInput) {
    DeliveryStreamEncryptionConfigurationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfigurationInput || (DeliveryStreamEncryptionConfigurationInput = {}));
var ElasticsearchBufferingHints;
(function(ElasticsearchBufferingHints) {
    ElasticsearchBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchBufferingHints || (ElasticsearchBufferingHints = {}));
var ProcessorParameterName;
(function(ProcessorParameterName) {
    ProcessorParameterName["BUFFER_INTERVAL_IN_SECONDS"] = "BufferIntervalInSeconds";
    ProcessorParameterName["BUFFER_SIZE_IN_MB"] = "BufferSizeInMBs";
    ProcessorParameterName["LAMBDA_ARN"] = "LambdaArn";
    ProcessorParameterName["LAMBDA_NUMBER_OF_RETRIES"] = "NumberOfRetries";
    ProcessorParameterName["ROLE_ARN"] = "RoleArn";
})(ProcessorParameterName || (ProcessorParameterName = {}));
var ProcessorParameter;
(function(ProcessorParameter) {
    ProcessorParameter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessorParameter || (ProcessorParameter = {}));
var Processor;
(function(Processor) {
    Processor.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Processor || (Processor = {}));
var ProcessingConfiguration;
(function(ProcessingConfiguration) {
    ProcessingConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessingConfiguration || (ProcessingConfiguration = {}));
var ElasticsearchRetryOptions;
(function(ElasticsearchRetryOptions) {
    ElasticsearchRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchRetryOptions || (ElasticsearchRetryOptions = {}));
var KMSEncryptionConfig;
(function(KMSEncryptionConfig) {
    KMSEncryptionConfig.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSEncryptionConfig || (KMSEncryptionConfig = {}));
var EncryptionConfiguration;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
var S3DestinationConfiguration;
(function(S3DestinationConfiguration) {
    S3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationConfiguration || (S3DestinationConfiguration = {}));
var VpcConfiguration;
(function(VpcConfiguration) {
    VpcConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfiguration || (VpcConfiguration = {}));
var ElasticsearchDestinationConfiguration;
(function(ElasticsearchDestinationConfiguration) {
    ElasticsearchDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationConfiguration || (ElasticsearchDestinationConfiguration = {}));
var HiveJsonSerDe;
(function(HiveJsonSerDe) {
    HiveJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HiveJsonSerDe || (HiveJsonSerDe = {}));
var OpenXJsonSerDe;
(function(OpenXJsonSerDe) {
    OpenXJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OpenXJsonSerDe || (OpenXJsonSerDe = {}));
var Deserializer;
(function(Deserializer) {
    Deserializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Deserializer || (Deserializer = {}));
var InputFormatConfiguration;
(function(InputFormatConfiguration) {
    InputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputFormatConfiguration || (InputFormatConfiguration = {}));
var OrcCompression;
(function(OrcCompression) {
    OrcCompression["NONE"] = "NONE";
    OrcCompression["SNAPPY"] = "SNAPPY";
    OrcCompression["ZLIB"] = "ZLIB";
})(OrcCompression || (OrcCompression = {}));
var OrcFormatVersion;
(function(OrcFormatVersion) {
    OrcFormatVersion["V0_11"] = "V0_11";
    OrcFormatVersion["V0_12"] = "V0_12";
})(OrcFormatVersion || (OrcFormatVersion = {}));
var OrcSerDe;
(function(OrcSerDe) {
    OrcSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OrcSerDe || (OrcSerDe = {}));
var ParquetCompression;
(function(ParquetCompression) {
    ParquetCompression["GZIP"] = "GZIP";
    ParquetCompression["SNAPPY"] = "SNAPPY";
    ParquetCompression["UNCOMPRESSED"] = "UNCOMPRESSED";
})(ParquetCompression || (ParquetCompression = {}));
var ParquetWriterVersion;
(function(ParquetWriterVersion) {
    ParquetWriterVersion["V1"] = "V1";
    ParquetWriterVersion["V2"] = "V2";
})(ParquetWriterVersion || (ParquetWriterVersion = {}));
var ParquetSerDe;
(function(ParquetSerDe) {
    ParquetSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ParquetSerDe || (ParquetSerDe = {}));
var Serializer;
(function(Serializer) {
    Serializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Serializer || (Serializer = {}));
var OutputFormatConfiguration;
(function(OutputFormatConfiguration) {
    OutputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputFormatConfiguration || (OutputFormatConfiguration = {}));
var SchemaConfiguration;
(function(SchemaConfiguration) {
    SchemaConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SchemaConfiguration || (SchemaConfiguration = {}));
var DataFormatConversionConfiguration;
(function(DataFormatConversionConfiguration) {
    DataFormatConversionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataFormatConversionConfiguration || (DataFormatConversionConfiguration = {}));
var ExtendedS3DestinationConfiguration;
(function(ExtendedS3DestinationConfiguration) {
    ExtendedS3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationConfiguration || (ExtendedS3DestinationConfiguration = {}));
var HttpEndpointBufferingHints;
(function(HttpEndpointBufferingHints) {
    HttpEndpointBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointBufferingHints || (HttpEndpointBufferingHints = {}));
var HttpEndpointConfiguration;
(function(HttpEndpointConfiguration) {
    HttpEndpointConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AccessKey && {
            AccessKey: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointConfiguration || (HttpEndpointConfiguration = {}));
var HttpEndpointCommonAttribute;
(function(HttpEndpointCommonAttribute) {
    HttpEndpointCommonAttribute.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.AttributeName && {
            AttributeName: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AttributeValue && {
            AttributeValue: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointCommonAttribute || (HttpEndpointCommonAttribute = {}));
var HttpEndpointRequestConfiguration;
(function(HttpEndpointRequestConfiguration) {
    HttpEndpointRequestConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.CommonAttributes && {
            CommonAttributes: obj.CommonAttributes.map(function(item) {
                return HttpEndpointCommonAttribute.filterSensitiveLog(item);
            })
        });
    };
})(HttpEndpointRequestConfiguration || (HttpEndpointRequestConfiguration = {}));
var HttpEndpointRetryOptions;
(function(HttpEndpointRetryOptions) {
    HttpEndpointRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointRetryOptions || (HttpEndpointRetryOptions = {}));
var HttpEndpointDestinationConfiguration;
(function(HttpEndpointDestinationConfiguration) {
    HttpEndpointDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationConfiguration || (HttpEndpointDestinationConfiguration = {}));
var KinesisStreamSourceConfiguration;
(function(KinesisStreamSourceConfiguration) {
    KinesisStreamSourceConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceConfiguration || (KinesisStreamSourceConfiguration = {}));
var RedshiftRetryOptions;
(function(RedshiftRetryOptions) {
    RedshiftRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RedshiftRetryOptions || (RedshiftRetryOptions = {}));
var RedshiftDestinationConfiguration;
(function(RedshiftDestinationConfiguration) {
    RedshiftDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationConfiguration || (RedshiftDestinationConfiguration = {}));
var SplunkRetryOptions;
(function(SplunkRetryOptions) {
    SplunkRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkRetryOptions || (SplunkRetryOptions = {}));
var SplunkDestinationConfiguration;
(function(SplunkDestinationConfiguration) {
    SplunkDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationConfiguration || (SplunkDestinationConfiguration = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var CreateDeliveryStreamInput;
(function(CreateDeliveryStreamInput) {
    CreateDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationConfiguration && {
            RedshiftDestinationConfiguration: RedshiftDestinationConfiguration.filterSensitiveLog(obj.RedshiftDestinationConfiguration)
        }), obj.HttpEndpointDestinationConfiguration && {
            HttpEndpointDestinationConfiguration: HttpEndpointDestinationConfiguration.filterSensitiveLog(obj.HttpEndpointDestinationConfiguration)
        });
    };
})(CreateDeliveryStreamInput || (CreateDeliveryStreamInput = {}));
var CreateDeliveryStreamOutput;
(function(CreateDeliveryStreamOutput) {
    CreateDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateDeliveryStreamOutput || (CreateDeliveryStreamOutput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var InvalidKMSResourceException;
(function(InvalidKMSResourceException) {
    InvalidKMSResourceException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidKMSResourceException || (InvalidKMSResourceException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var DeleteDeliveryStreamInput;
(function(DeleteDeliveryStreamInput) {
    DeleteDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamInput || (DeleteDeliveryStreamInput = {}));
var DeleteDeliveryStreamOutput;
(function(DeleteDeliveryStreamOutput) {
    DeleteDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamOutput || (DeleteDeliveryStreamOutput = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var DeliveryStreamFailureType;
(function(DeliveryStreamFailureType) {
    DeliveryStreamFailureType["CREATE_ENI_FAILED"] = "CREATE_ENI_FAILED";
    DeliveryStreamFailureType["CREATE_KMS_GRANT_FAILED"] = "CREATE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["DELETE_ENI_FAILED"] = "DELETE_ENI_FAILED";
    DeliveryStreamFailureType["DISABLED_KMS_KEY"] = "DISABLED_KMS_KEY";
    DeliveryStreamFailureType["ENI_ACCESS_DENIED"] = "ENI_ACCESS_DENIED";
    DeliveryStreamFailureType["INVALID_KMS_KEY"] = "INVALID_KMS_KEY";
    DeliveryStreamFailureType["KMS_ACCESS_DENIED"] = "KMS_ACCESS_DENIED";
    DeliveryStreamFailureType["KMS_KEY_NOT_FOUND"] = "KMS_KEY_NOT_FOUND";
    DeliveryStreamFailureType["KMS_OPT_IN_REQUIRED"] = "KMS_OPT_IN_REQUIRED";
    DeliveryStreamFailureType["RETIRE_KMS_GRANT_FAILED"] = "RETIRE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["SECURITY_GROUP_ACCESS_DENIED"] = "SECURITY_GROUP_ACCESS_DENIED";
    DeliveryStreamFailureType["SECURITY_GROUP_NOT_FOUND"] = "SECURITY_GROUP_NOT_FOUND";
    DeliveryStreamFailureType["SUBNET_ACCESS_DENIED"] = "SUBNET_ACCESS_DENIED";
    DeliveryStreamFailureType["SUBNET_NOT_FOUND"] = "SUBNET_NOT_FOUND";
    DeliveryStreamFailureType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DeliveryStreamFailureType || (DeliveryStreamFailureType = {}));
var FailureDescription;
(function(FailureDescription) {
    FailureDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FailureDescription || (FailureDescription = {}));
var DeliveryStreamEncryptionStatus;
(function(DeliveryStreamEncryptionStatus) {
    DeliveryStreamEncryptionStatus["DISABLED"] = "DISABLED";
    DeliveryStreamEncryptionStatus["DISABLING"] = "DISABLING";
    DeliveryStreamEncryptionStatus["DISABLING_FAILED"] = "DISABLING_FAILED";
    DeliveryStreamEncryptionStatus["ENABLED"] = "ENABLED";
    DeliveryStreamEncryptionStatus["ENABLING"] = "ENABLING";
    DeliveryStreamEncryptionStatus["ENABLING_FAILED"] = "ENABLING_FAILED";
})(DeliveryStreamEncryptionStatus || (DeliveryStreamEncryptionStatus = {}));
var DeliveryStreamEncryptionConfiguration;
(function(DeliveryStreamEncryptionConfiguration) {
    DeliveryStreamEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfiguration || (DeliveryStreamEncryptionConfiguration = {}));
var DeliveryStreamStatus;
(function(DeliveryStreamStatus) {
    DeliveryStreamStatus["ACTIVE"] = "ACTIVE";
    DeliveryStreamStatus["CREATING"] = "CREATING";
    DeliveryStreamStatus["CREATING_FAILED"] = "CREATING_FAILED";
    DeliveryStreamStatus["DELETING"] = "DELETING";
    DeliveryStreamStatus["DELETING_FAILED"] = "DELETING_FAILED";
})(DeliveryStreamStatus || (DeliveryStreamStatus = {}));
var S3DestinationDescription;
(function(S3DestinationDescription) {
    S3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationDescription || (S3DestinationDescription = {}));
var VpcConfigurationDescription;
(function(VpcConfigurationDescription) {
    VpcConfigurationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfigurationDescription || (VpcConfigurationDescription = {}));
var ElasticsearchDestinationDescription;
(function(ElasticsearchDestinationDescription) {
    ElasticsearchDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationDescription || (ElasticsearchDestinationDescription = {}));
var ExtendedS3DestinationDescription;
(function(ExtendedS3DestinationDescription) {
    ExtendedS3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationDescription || (ExtendedS3DestinationDescription = {}));
var HttpEndpointDescription;
(function(HttpEndpointDescription) {
    HttpEndpointDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointDescription || (HttpEndpointDescription = {}));
var HttpEndpointDestinationDescription;
(function(HttpEndpointDestinationDescription) {
    HttpEndpointDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointDescription.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationDescription || (HttpEndpointDestinationDescription = {}));
var RedshiftDestinationDescription;
(function(RedshiftDestinationDescription) {
    RedshiftDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationDescription || (RedshiftDestinationDescription = {}));
var SplunkDestinationDescription;
(function(SplunkDestinationDescription) {
    SplunkDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationDescription || (SplunkDestinationDescription = {}));
var DestinationDescription;
(function(DestinationDescription) {
    DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationDescription && {
            RedshiftDestinationDescription: RedshiftDestinationDescription.filterSensitiveLog(obj.RedshiftDestinationDescription)
        }), obj.HttpEndpointDestinationDescription && {
            HttpEndpointDestinationDescription: HttpEndpointDestinationDescription.filterSensitiveLog(obj.HttpEndpointDestinationDescription)
        });
    };
})(DestinationDescription || (DestinationDescription = {}));
var KinesisStreamSourceDescription;
(function(KinesisStreamSourceDescription) {
    KinesisStreamSourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceDescription || (KinesisStreamSourceDescription = {}));
var SourceDescription;
(function(SourceDescription) {
    SourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SourceDescription || (SourceDescription = {}));
var DeliveryStreamDescription;
(function(DeliveryStreamDescription) {
    DeliveryStreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Destinations && {
            Destinations: obj.Destinations.map(function(item) {
                return DestinationDescription.filterSensitiveLog(item);
            })
        });
    };
})(DeliveryStreamDescription || (DeliveryStreamDescription = {}));
var DescribeDeliveryStreamInput;
(function(DescribeDeliveryStreamInput) {
    DescribeDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDeliveryStreamInput || (DescribeDeliveryStreamInput = {}));
var DescribeDeliveryStreamOutput;
(function(DescribeDeliveryStreamOutput) {
    DescribeDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeliveryStreamDescription && {
            DeliveryStreamDescription: DeliveryStreamDescription.filterSensitiveLog(obj.DeliveryStreamDescription)
        });
    };
})(DescribeDeliveryStreamOutput || (DescribeDeliveryStreamOutput = {}));
var S3DestinationUpdate;
(function(S3DestinationUpdate) {
    S3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationUpdate || (S3DestinationUpdate = {}));
var ElasticsearchDestinationUpdate;
(function(ElasticsearchDestinationUpdate) {
    ElasticsearchDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationUpdate || (ElasticsearchDestinationUpdate = {}));
var ExtendedS3DestinationUpdate;
(function(ExtendedS3DestinationUpdate) {
    ExtendedS3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationUpdate || (ExtendedS3DestinationUpdate = {}));
var ListDeliveryStreamsInput;
(function(ListDeliveryStreamsInput) {
    ListDeliveryStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsInput || (ListDeliveryStreamsInput = {}));
var ListDeliveryStreamsOutput;
(function(ListDeliveryStreamsOutput) {
    ListDeliveryStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsOutput || (ListDeliveryStreamsOutput = {}));
var ListTagsForDeliveryStreamInput;
(function(ListTagsForDeliveryStreamInput) {
    ListTagsForDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamInput || (ListTagsForDeliveryStreamInput = {}));
var ListTagsForDeliveryStreamOutput;
(function(ListTagsForDeliveryStreamOutput) {
    ListTagsForDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamOutput || (ListTagsForDeliveryStreamOutput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var PutRecordBatchInput;
(function(PutRecordBatchInput) {
    PutRecordBatchInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchInput || (PutRecordBatchInput = {}));
var PutRecordBatchResponseEntry;
(function(PutRecordBatchResponseEntry) {
    PutRecordBatchResponseEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchResponseEntry || (PutRecordBatchResponseEntry = {}));
var PutRecordBatchOutput;
(function(PutRecordBatchOutput) {
    PutRecordBatchOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchOutput || (PutRecordBatchOutput = {}));
var StartDeliveryStreamEncryptionInput;
(function(StartDeliveryStreamEncryptionInput) {
    StartDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionInput || (StartDeliveryStreamEncryptionInput = {}));
var StartDeliveryStreamEncryptionOutput;
(function(StartDeliveryStreamEncryptionOutput) {
    StartDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionOutput || (StartDeliveryStreamEncryptionOutput = {}));
var StopDeliveryStreamEncryptionInput;
(function(StopDeliveryStreamEncryptionInput) {
    StopDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionInput || (StopDeliveryStreamEncryptionInput = {}));
var StopDeliveryStreamEncryptionOutput;
(function(StopDeliveryStreamEncryptionOutput) {
    StopDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionOutput || (StopDeliveryStreamEncryptionOutput = {}));
var TagDeliveryStreamInput;
(function(TagDeliveryStreamInput) {
    TagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamInput || (TagDeliveryStreamInput = {}));
var TagDeliveryStreamOutput;
(function(TagDeliveryStreamOutput) {
    TagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamOutput || (TagDeliveryStreamOutput = {}));
var UntagDeliveryStreamInput;
(function(UntagDeliveryStreamInput) {
    UntagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamInput || (UntagDeliveryStreamInput = {}));
var UntagDeliveryStreamOutput;
(function(UntagDeliveryStreamOutput) {
    UntagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamOutput || (UntagDeliveryStreamOutput = {}));
var HttpEndpointDestinationUpdate;
(function(HttpEndpointDestinationUpdate) {
    HttpEndpointDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationUpdate || (HttpEndpointDestinationUpdate = {}));
var RedshiftDestinationUpdate;
(function(RedshiftDestinationUpdate) {
    RedshiftDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationUpdate || (RedshiftDestinationUpdate = {}));
var SplunkDestinationUpdate;
(function(SplunkDestinationUpdate) {
    SplunkDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationUpdate || (SplunkDestinationUpdate = {}));
var UpdateDestinationInput;
(function(UpdateDestinationInput) {
    UpdateDestinationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationUpdate && {
            RedshiftDestinationUpdate: RedshiftDestinationUpdate.filterSensitiveLog(obj.RedshiftDestinationUpdate)
        }), obj.HttpEndpointDestinationUpdate && {
            HttpEndpointDestinationUpdate: HttpEndpointDestinationUpdate.filterSensitiveLog(obj.HttpEndpointDestinationUpdate)
        });
    };
})(UpdateDestinationInput || (UpdateDestinationInput = {}));
var UpdateDestinationOutput;
(function(UpdateDestinationOutput) {
    UpdateDestinationOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateDestinationOutput || (UpdateDestinationOutput = {}));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lKm6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1CreateDeliveryStreamCommand", function() {
    return serializeAws_json1_1CreateDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDeliveryStreamCommand", function() {
    return serializeAws_json1_1DeleteDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDeliveryStreamCommand", function() {
    return serializeAws_json1_1DescribeDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListDeliveryStreamsCommand", function() {
    return serializeAws_json1_1ListDeliveryStreamsCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForDeliveryStreamCommand", function() {
    return serializeAws_json1_1ListTagsForDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", function() {
    return serializeAws_json1_1PutRecordCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordBatchCommand", function() {
    return serializeAws_json1_1PutRecordBatchCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StartDeliveryStreamEncryptionCommand", function() {
    return serializeAws_json1_1StartDeliveryStreamEncryptionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1StopDeliveryStreamEncryptionCommand", function() {
    return serializeAws_json1_1StopDeliveryStreamEncryptionCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1TagDeliveryStreamCommand", function() {
    return serializeAws_json1_1TagDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1UntagDeliveryStreamCommand", function() {
    return serializeAws_json1_1UntagDeliveryStreamCommand;
});
parcelHelpers.export(exports, "serializeAws_json1_1UpdateDestinationCommand", function() {
    return serializeAws_json1_1UpdateDestinationCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1CreateDeliveryStreamCommand", function() {
    return deserializeAws_json1_1CreateDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDeliveryStreamCommand", function() {
    return deserializeAws_json1_1DeleteDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDeliveryStreamCommand", function() {
    return deserializeAws_json1_1DescribeDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListDeliveryStreamsCommand", function() {
    return deserializeAws_json1_1ListDeliveryStreamsCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForDeliveryStreamCommand", function() {
    return deserializeAws_json1_1ListTagsForDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", function() {
    return deserializeAws_json1_1PutRecordCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordBatchCommand", function() {
    return deserializeAws_json1_1PutRecordBatchCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StartDeliveryStreamEncryptionCommand", function() {
    return deserializeAws_json1_1StartDeliveryStreamEncryptionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1StopDeliveryStreamEncryptionCommand", function() {
    return deserializeAws_json1_1StopDeliveryStreamEncryptionCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1TagDeliveryStreamCommand", function() {
    return deserializeAws_json1_1TagDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1UntagDeliveryStreamCommand", function() {
    return deserializeAws_json1_1UntagDeliveryStreamCommand;
});
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateDestinationCommand", function() {
    return deserializeAws_json1_1UpdateDestinationCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1CreateDeliveryStreamCommand = function serializeAws_json1_1CreateDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.CreateDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDeliveryStreamCommand = function serializeAws_json1_1DeleteDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DeleteDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDeliveryStreamCommand = function serializeAws_json1_1DescribeDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DescribeDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListDeliveryStreamsCommand = function serializeAws_json1_1ListDeliveryStreamsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListDeliveryStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListDeliveryStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamCommand = function serializeAws_json1_1ListTagsForDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListTagsForDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function serializeAws_json1_1PutRecordCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordBatchCommand = function serializeAws_json1_1PutRecordBatchCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecordBatch"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordBatchInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionCommand = function serializeAws_json1_1StartDeliveryStreamEncryptionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StartDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionCommand = function serializeAws_json1_1StopDeliveryStreamEncryptionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StopDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagDeliveryStreamCommand = function serializeAws_json1_1TagDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.TagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1TagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagDeliveryStreamCommand = function serializeAws_json1_1UntagDeliveryStreamCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UntagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1UntagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateDestinationCommand = function serializeAws_json1_1UpdateDestinationCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UpdateDestination"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateDestinationInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommand = function deserializeAws_json1_1CreateDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommandError = function deserializeAws_json1_1CreateDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommand = function deserializeAws_json1_1DeleteDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommandError = function deserializeAws_json1_1DeleteDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommand = function deserializeAws_json1_1DescribeDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommandError = function deserializeAws_json1_1DescribeDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommand = function deserializeAws_json1_1ListDeliveryStreamsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListDeliveryStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListDeliveryStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommandError = function deserializeAws_json1_1ListDeliveryStreamsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommand = function deserializeAws_json1_1ListTagsForDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommandError = function deserializeAws_json1_1ListTagsForDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function deserializeAws_json1_1PutRecordCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function deserializeAws_json1_1PutRecordCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommand = function deserializeAws_json1_1PutRecordBatchCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordBatchCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordBatchOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommandError = function deserializeAws_json1_1PutRecordBatchCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommand = function deserializeAws_json1_1StartDeliveryStreamEncryptionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError = function deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommand = function deserializeAws_json1_1StopDeliveryStreamEncryptionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError = function deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommand = function deserializeAws_json1_1TagDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommandError = function deserializeAws_json1_1TagDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommand = function deserializeAws_json1_1UntagDeliveryStreamCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UntagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommandError = function deserializeAws_json1_1UntagDeliveryStreamCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommand = function deserializeAws_json1_1UpdateDestinationCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateDestinationOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommandError = function deserializeAws_json1_1UpdateDestinationCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ConcurrentModificationExceptionResponse = function deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidKMSResourceExceptionResponse = function deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidKMSResourceException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidKMSResourceException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1BufferingHints = function serializeAws_json1_1BufferingHints(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1CloudWatchLoggingOptions = function serializeAws_json1_1CloudWatchLoggingOptions(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.LogGroupName !== undefined && input.LogGroupName !== null && {
        LogGroupName: input.LogGroupName
    }), input.LogStreamName !== undefined && input.LogStreamName !== null && {
        LogStreamName: input.LogStreamName
    });
};
var serializeAws_json1_1ColumnToJsonKeyMappings = function serializeAws_json1_1ColumnToJsonKeyMappings(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1CopyCommand = function serializeAws_json1_1CopyCommand(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CopyOptions !== undefined && input.CopyOptions !== null && {
        CopyOptions: input.CopyOptions
    }), input.DataTableColumns !== undefined && input.DataTableColumns !== null && {
        DataTableColumns: input.DataTableColumns
    }), input.DataTableName !== undefined && input.DataTableName !== null && {
        DataTableName: input.DataTableName
    });
};
var serializeAws_json1_1CreateDeliveryStreamInput = function serializeAws_json1_1CreateDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ElasticsearchDestinationConfiguration !== undefined && input.ElasticsearchDestinationConfiguration !== null && {
        ElasticsearchDestinationConfiguration: serializeAws_json1_1ElasticsearchDestinationConfiguration(input.ElasticsearchDestinationConfiguration, context)
    }), input.ExtendedS3DestinationConfiguration !== undefined && input.ExtendedS3DestinationConfiguration !== null && {
        ExtendedS3DestinationConfiguration: serializeAws_json1_1ExtendedS3DestinationConfiguration(input.ExtendedS3DestinationConfiguration, context)
    }), input.HttpEndpointDestinationConfiguration !== undefined && input.HttpEndpointDestinationConfiguration !== null && {
        HttpEndpointDestinationConfiguration: serializeAws_json1_1HttpEndpointDestinationConfiguration(input.HttpEndpointDestinationConfiguration, context)
    }), input.KinesisStreamSourceConfiguration !== undefined && input.KinesisStreamSourceConfiguration !== null && {
        KinesisStreamSourceConfiguration: serializeAws_json1_1KinesisStreamSourceConfiguration(input.KinesisStreamSourceConfiguration, context)
    }), input.RedshiftDestinationConfiguration !== undefined && input.RedshiftDestinationConfiguration !== null && {
        RedshiftDestinationConfiguration: serializeAws_json1_1RedshiftDestinationConfiguration(input.RedshiftDestinationConfiguration, context)
    }), input.S3DestinationConfiguration !== undefined && input.S3DestinationConfiguration !== null && {
        S3DestinationConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3DestinationConfiguration, context)
    }), input.SplunkDestinationConfiguration !== undefined && input.SplunkDestinationConfiguration !== null && {
        SplunkDestinationConfiguration: serializeAws_json1_1SplunkDestinationConfiguration(input.SplunkDestinationConfiguration, context)
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1DataFormatConversionConfiguration = function serializeAws_json1_1DataFormatConversionConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.InputFormatConfiguration !== undefined && input.InputFormatConfiguration !== null && {
        InputFormatConfiguration: serializeAws_json1_1InputFormatConfiguration(input.InputFormatConfiguration, context)
    }), input.OutputFormatConfiguration !== undefined && input.OutputFormatConfiguration !== null && {
        OutputFormatConfiguration: serializeAws_json1_1OutputFormatConfiguration(input.OutputFormatConfiguration, context)
    }), input.SchemaConfiguration !== undefined && input.SchemaConfiguration !== null && {
        SchemaConfiguration: serializeAws_json1_1SchemaConfiguration(input.SchemaConfiguration, context)
    });
};
var serializeAws_json1_1DeleteDeliveryStreamInput = function serializeAws_json1_1DeleteDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AllowForceDelete !== undefined && input.AllowForceDelete !== null && {
        AllowForceDelete: input.AllowForceDelete
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput = function serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KeyARN !== undefined && input.KeyARN !== null && {
        KeyARN: input.KeyARN
    }), input.KeyType !== undefined && input.KeyType !== null && {
        KeyType: input.KeyType
    });
};
var serializeAws_json1_1DescribeDeliveryStreamInput = function serializeAws_json1_1DescribeDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartDestinationId !== undefined && input.ExclusiveStartDestinationId !== null && {
        ExclusiveStartDestinationId: input.ExclusiveStartDestinationId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1Deserializer = function serializeAws_json1_1Deserializer(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.HiveJsonSerDe !== undefined && input.HiveJsonSerDe !== null && {
        HiveJsonSerDe: serializeAws_json1_1HiveJsonSerDe(input.HiveJsonSerDe, context)
    }), input.OpenXJsonSerDe !== undefined && input.OpenXJsonSerDe !== null && {
        OpenXJsonSerDe: serializeAws_json1_1OpenXJsonSerDe(input.OpenXJsonSerDe, context)
    });
};
var serializeAws_json1_1ElasticsearchBufferingHints = function serializeAws_json1_1ElasticsearchBufferingHints(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1ElasticsearchDestinationConfiguration = function serializeAws_json1_1ElasticsearchDestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    }), input.VpcConfiguration !== undefined && input.VpcConfiguration !== null && {
        VpcConfiguration: serializeAws_json1_1VpcConfiguration(input.VpcConfiguration, context)
    });
};
var serializeAws_json1_1ElasticsearchDestinationUpdate = function serializeAws_json1_1ElasticsearchDestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    });
};
var serializeAws_json1_1ElasticsearchRetryOptions = function serializeAws_json1_1ElasticsearchRetryOptions(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1EncryptionConfiguration = function serializeAws_json1_1EncryptionConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KMSEncryptionConfig !== undefined && input.KMSEncryptionConfig !== null && {
        KMSEncryptionConfig: serializeAws_json1_1KMSEncryptionConfig(input.KMSEncryptionConfig, context)
    }), input.NoEncryptionConfig !== undefined && input.NoEncryptionConfig !== null && {
        NoEncryptionConfig: input.NoEncryptionConfig
    });
};
var serializeAws_json1_1ExtendedS3DestinationConfiguration = function serializeAws_json1_1ExtendedS3DestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    });
};
var serializeAws_json1_1ExtendedS3DestinationUpdate = function serializeAws_json1_1ExtendedS3DestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    });
};
var serializeAws_json1_1HiveJsonSerDe = function serializeAws_json1_1HiveJsonSerDe(input, context) {
    return (0, _tslib.__assign)({}, input.TimestampFormats !== undefined && input.TimestampFormats !== null && {
        TimestampFormats: serializeAws_json1_1ListOfNonEmptyStrings(input.TimestampFormats, context)
    });
};
var serializeAws_json1_1HttpEndpointBufferingHints = function serializeAws_json1_1HttpEndpointBufferingHints(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1HttpEndpointCommonAttribute = function serializeAws_json1_1HttpEndpointCommonAttribute(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AttributeName !== undefined && input.AttributeName !== null && {
        AttributeName: input.AttributeName
    }), input.AttributeValue !== undefined && input.AttributeValue !== null && {
        AttributeValue: input.AttributeValue
    });
};
var serializeAws_json1_1HttpEndpointCommonAttributesList = function serializeAws_json1_1HttpEndpointCommonAttributesList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var serializeAws_json1_1HttpEndpointConfiguration = function serializeAws_json1_1HttpEndpointConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AccessKey !== undefined && input.AccessKey !== null && {
        AccessKey: input.AccessKey
    }), input.Name !== undefined && input.Name !== null && {
        Name: input.Name
    }), input.Url !== undefined && input.Url !== null && {
        Url: input.Url
    });
};
var serializeAws_json1_1HttpEndpointDestinationConfiguration = function serializeAws_json1_1HttpEndpointDestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1HttpEndpointDestinationUpdate = function serializeAws_json1_1HttpEndpointDestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1HttpEndpointRequestConfiguration = function serializeAws_json1_1HttpEndpointRequestConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.CommonAttributes !== undefined && input.CommonAttributes !== null && {
        CommonAttributes: serializeAws_json1_1HttpEndpointCommonAttributesList(input.CommonAttributes, context)
    }), input.ContentEncoding !== undefined && input.ContentEncoding !== null && {
        ContentEncoding: input.ContentEncoding
    });
};
var serializeAws_json1_1HttpEndpointRetryOptions = function serializeAws_json1_1HttpEndpointRetryOptions(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1InputFormatConfiguration = function serializeAws_json1_1InputFormatConfiguration(input, context) {
    return (0, _tslib.__assign)({}, input.Deserializer !== undefined && input.Deserializer !== null && {
        Deserializer: serializeAws_json1_1Deserializer(input.Deserializer, context)
    });
};
var serializeAws_json1_1KinesisStreamSourceConfiguration = function serializeAws_json1_1KinesisStreamSourceConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KinesisStreamARN !== undefined && input.KinesisStreamARN !== null && {
        KinesisStreamARN: input.KinesisStreamARN
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1KMSEncryptionConfig = function serializeAws_json1_1KMSEncryptionConfig(input, context) {
    return (0, _tslib.__assign)({}, input.AWSKMSKeyARN !== undefined && input.AWSKMSKeyARN !== null && {
        AWSKMSKeyARN: input.AWSKMSKeyARN
    });
};
var serializeAws_json1_1ListDeliveryStreamsInput = function serializeAws_json1_1ListDeliveryStreamsInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ExclusiveStartDeliveryStreamName !== undefined && input.ExclusiveStartDeliveryStreamName !== null && {
        ExclusiveStartDeliveryStreamName: input.ExclusiveStartDeliveryStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListOfNonEmptyStrings = function serializeAws_json1_1ListOfNonEmptyStrings(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamInput = function serializeAws_json1_1ListTagsForDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1OpenXJsonSerDe = function serializeAws_json1_1OpenXJsonSerDe(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CaseInsensitive !== undefined && input.CaseInsensitive !== null && {
        CaseInsensitive: input.CaseInsensitive
    }), input.ColumnToJsonKeyMappings !== undefined && input.ColumnToJsonKeyMappings !== null && {
        ColumnToJsonKeyMappings: serializeAws_json1_1ColumnToJsonKeyMappings(input.ColumnToJsonKeyMappings, context)
    }), input.ConvertDotsInJsonKeysToUnderscores !== undefined && input.ConvertDotsInJsonKeysToUnderscores !== null && {
        ConvertDotsInJsonKeysToUnderscores: input.ConvertDotsInJsonKeysToUnderscores
    });
};
var serializeAws_json1_1OrcSerDe = function serializeAws_json1_1OrcSerDe(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.BloomFilterColumns !== undefined && input.BloomFilterColumns !== null && {
        BloomFilterColumns: serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(input.BloomFilterColumns, context)
    }), input.BloomFilterFalsePositiveProbability !== undefined && input.BloomFilterFalsePositiveProbability !== null && {
        BloomFilterFalsePositiveProbability: input.BloomFilterFalsePositiveProbability
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.DictionaryKeyThreshold !== undefined && input.DictionaryKeyThreshold !== null && {
        DictionaryKeyThreshold: input.DictionaryKeyThreshold
    }), input.EnablePadding !== undefined && input.EnablePadding !== null && {
        EnablePadding: input.EnablePadding
    }), input.FormatVersion !== undefined && input.FormatVersion !== null && {
        FormatVersion: input.FormatVersion
    }), input.PaddingTolerance !== undefined && input.PaddingTolerance !== null && {
        PaddingTolerance: input.PaddingTolerance
    }), input.RowIndexStride !== undefined && input.RowIndexStride !== null && {
        RowIndexStride: input.RowIndexStride
    }), input.StripeSizeBytes !== undefined && input.StripeSizeBytes !== null && {
        StripeSizeBytes: input.StripeSizeBytes
    });
};
var serializeAws_json1_1OutputFormatConfiguration = function serializeAws_json1_1OutputFormatConfiguration(input, context) {
    return (0, _tslib.__assign)({}, input.Serializer !== undefined && input.Serializer !== null && {
        Serializer: serializeAws_json1_1Serializer(input.Serializer, context)
    });
};
var serializeAws_json1_1ParquetSerDe = function serializeAws_json1_1ParquetSerDe(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.EnableDictionaryCompression !== undefined && input.EnableDictionaryCompression !== null && {
        EnableDictionaryCompression: input.EnableDictionaryCompression
    }), input.MaxPaddingBytes !== undefined && input.MaxPaddingBytes !== null && {
        MaxPaddingBytes: input.MaxPaddingBytes
    }), input.PageSizeBytes !== undefined && input.PageSizeBytes !== null && {
        PageSizeBytes: input.PageSizeBytes
    }), input.WriterVersion !== undefined && input.WriterVersion !== null && {
        WriterVersion: input.WriterVersion
    });
};
var serializeAws_json1_1ProcessingConfiguration = function serializeAws_json1_1ProcessingConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.Processors !== undefined && input.Processors !== null && {
        Processors: serializeAws_json1_1ProcessorList(input.Processors, context)
    });
};
var serializeAws_json1_1Processor = function serializeAws_json1_1Processor(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Parameters !== undefined && input.Parameters !== null && {
        Parameters: serializeAws_json1_1ProcessorParameterList(input.Parameters, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1ProcessorList = function serializeAws_json1_1ProcessorList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Processor(entry, context);
    });
};
var serializeAws_json1_1ProcessorParameter = function serializeAws_json1_1ProcessorParameter(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ParameterName !== undefined && input.ParameterName !== null && {
        ParameterName: input.ParameterName
    }), input.ParameterValue !== undefined && input.ParameterValue !== null && {
        ParameterValue: input.ParameterValue
    });
};
var serializeAws_json1_1ProcessorParameterList = function serializeAws_json1_1ProcessorParameterList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var serializeAws_json1_1PutRecordBatchInput = function serializeAws_json1_1PutRecordBatchInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordBatchRequestEntryList(input.Records, context)
    });
};
var serializeAws_json1_1PutRecordBatchRequestEntryList = function serializeAws_json1_1PutRecordBatchRequestEntryList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1_Record(entry, context);
    });
};
var serializeAws_json1_1PutRecordInput = function serializeAws_json1_1PutRecordInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Record !== undefined && input.Record !== null && {
        Record: serializeAws_json1_1_Record(input.Record, context)
    });
};
var serializeAws_json1_1_Record = function serializeAws_json1_1_Record(input, context) {
    return (0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    });
};
var serializeAws_json1_1RedshiftDestinationConfiguration = function serializeAws_json1_1RedshiftDestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftDestinationUpdate = function serializeAws_json1_1RedshiftDestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftRetryOptions = function serializeAws_json1_1RedshiftRetryOptions(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1S3DestinationConfiguration = function serializeAws_json1_1S3DestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1S3DestinationUpdate = function serializeAws_json1_1S3DestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1SchemaConfiguration = function serializeAws_json1_1SchemaConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CatalogId !== undefined && input.CatalogId !== null && {
        CatalogId: input.CatalogId
    }), input.DatabaseName !== undefined && input.DatabaseName !== null && {
        DatabaseName: input.DatabaseName
    }), input.Region !== undefined && input.Region !== null && {
        Region: input.Region
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.TableName !== undefined && input.TableName !== null && {
        TableName: input.TableName
    }), input.VersionId !== undefined && input.VersionId !== null && {
        VersionId: input.VersionId
    });
};
var serializeAws_json1_1SecurityGroupIdList = function serializeAws_json1_1SecurityGroupIdList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Serializer = function serializeAws_json1_1Serializer(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.OrcSerDe !== undefined && input.OrcSerDe !== null && {
        OrcSerDe: serializeAws_json1_1OrcSerDe(input.OrcSerDe, context)
    }), input.ParquetSerDe !== undefined && input.ParquetSerDe !== null && {
        ParquetSerDe: serializeAws_json1_1ParquetSerDe(input.ParquetSerDe, context)
    });
};
var serializeAws_json1_1SplunkDestinationConfiguration = function serializeAws_json1_1SplunkDestinationConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1SplunkDestinationUpdate = function serializeAws_json1_1SplunkDestinationUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1SplunkRetryOptions = function serializeAws_json1_1SplunkRetryOptions(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionInput = function serializeAws_json1_1StartDeliveryStreamEncryptionInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionInput = function serializeAws_json1_1StopDeliveryStreamEncryptionInput(input, context) {
    return (0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1SubnetIdList = function serializeAws_json1_1SubnetIdList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Tag = function serializeAws_json1_1Tag(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Key !== undefined && input.Key !== null && {
        Key: input.Key
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var serializeAws_json1_1TagDeliveryStreamInput = function serializeAws_json1_1TagDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1TagDeliveryStreamInputTagList = function serializeAws_json1_1TagDeliveryStreamInputTagList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Tag(entry, context);
    });
};
var serializeAws_json1_1TagKeyList = function serializeAws_json1_1TagKeyList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1UntagDeliveryStreamInput = function serializeAws_json1_1UntagDeliveryStreamInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1UpdateDestinationInput = function serializeAws_json1_1UpdateDestinationInput(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CurrentDeliveryStreamVersionId !== undefined && input.CurrentDeliveryStreamVersionId !== null && {
        CurrentDeliveryStreamVersionId: input.CurrentDeliveryStreamVersionId
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DestinationId !== undefined && input.DestinationId !== null && {
        DestinationId: input.DestinationId
    }), input.ElasticsearchDestinationUpdate !== undefined && input.ElasticsearchDestinationUpdate !== null && {
        ElasticsearchDestinationUpdate: serializeAws_json1_1ElasticsearchDestinationUpdate(input.ElasticsearchDestinationUpdate, context)
    }), input.ExtendedS3DestinationUpdate !== undefined && input.ExtendedS3DestinationUpdate !== null && {
        ExtendedS3DestinationUpdate: serializeAws_json1_1ExtendedS3DestinationUpdate(input.ExtendedS3DestinationUpdate, context)
    }), input.HttpEndpointDestinationUpdate !== undefined && input.HttpEndpointDestinationUpdate !== null && {
        HttpEndpointDestinationUpdate: serializeAws_json1_1HttpEndpointDestinationUpdate(input.HttpEndpointDestinationUpdate, context)
    }), input.RedshiftDestinationUpdate !== undefined && input.RedshiftDestinationUpdate !== null && {
        RedshiftDestinationUpdate: serializeAws_json1_1RedshiftDestinationUpdate(input.RedshiftDestinationUpdate, context)
    }), input.S3DestinationUpdate !== undefined && input.S3DestinationUpdate !== null && {
        S3DestinationUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3DestinationUpdate, context)
    }), input.SplunkDestinationUpdate !== undefined && input.SplunkDestinationUpdate !== null && {
        SplunkDestinationUpdate: serializeAws_json1_1SplunkDestinationUpdate(input.SplunkDestinationUpdate, context)
    });
};
var serializeAws_json1_1VpcConfiguration = function serializeAws_json1_1VpcConfiguration(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.SecurityGroupIds !== undefined && input.SecurityGroupIds !== null && {
        SecurityGroupIds: serializeAws_json1_1SecurityGroupIdList(input.SecurityGroupIds, context)
    }), input.SubnetIds !== undefined && input.SubnetIds !== null && {
        SubnetIds: serializeAws_json1_1SubnetIdList(input.SubnetIds, context)
    });
};
var deserializeAws_json1_1BufferingHints = function deserializeAws_json1_1BufferingHints(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1CloudWatchLoggingOptions = function deserializeAws_json1_1CloudWatchLoggingOptions(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        LogGroupName: output.LogGroupName !== undefined && output.LogGroupName !== null ? output.LogGroupName : undefined,
        LogStreamName: output.LogStreamName !== undefined && output.LogStreamName !== null ? output.LogStreamName : undefined
    };
};
var deserializeAws_json1_1ColumnToJsonKeyMappings = function deserializeAws_json1_1ColumnToJsonKeyMappings(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1ConcurrentModificationException = function deserializeAws_json1_1ConcurrentModificationException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1CopyCommand = function deserializeAws_json1_1CopyCommand(output, context) {
    return {
        CopyOptions: output.CopyOptions !== undefined && output.CopyOptions !== null ? output.CopyOptions : undefined,
        DataTableColumns: output.DataTableColumns !== undefined && output.DataTableColumns !== null ? output.DataTableColumns : undefined,
        DataTableName: output.DataTableName !== undefined && output.DataTableName !== null ? output.DataTableName : undefined
    };
};
var deserializeAws_json1_1CreateDeliveryStreamOutput = function deserializeAws_json1_1CreateDeliveryStreamOutput(output, context) {
    return {
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined
    };
};
var deserializeAws_json1_1DataFormatConversionConfiguration = function deserializeAws_json1_1DataFormatConversionConfiguration(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        InputFormatConfiguration: output.InputFormatConfiguration !== undefined && output.InputFormatConfiguration !== null ? deserializeAws_json1_1InputFormatConfiguration(output.InputFormatConfiguration, context) : undefined,
        OutputFormatConfiguration: output.OutputFormatConfiguration !== undefined && output.OutputFormatConfiguration !== null ? deserializeAws_json1_1OutputFormatConfiguration(output.OutputFormatConfiguration, context) : undefined,
        SchemaConfiguration: output.SchemaConfiguration !== undefined && output.SchemaConfiguration !== null ? deserializeAws_json1_1SchemaConfiguration(output.SchemaConfiguration, context) : undefined
    };
};
var deserializeAws_json1_1DeleteDeliveryStreamOutput = function deserializeAws_json1_1DeleteDeliveryStreamOutput(output, context) {
    return {};
};
var deserializeAws_json1_1DeliveryStreamDescription = function deserializeAws_json1_1DeliveryStreamDescription(output, context) {
    return {
        CreateTimestamp: output.CreateTimestamp !== undefined && output.CreateTimestamp !== null ? new Date(Math.round(output.CreateTimestamp * 1000)) : undefined,
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined,
        DeliveryStreamEncryptionConfiguration: output.DeliveryStreamEncryptionConfiguration !== undefined && output.DeliveryStreamEncryptionConfiguration !== null ? deserializeAws_json1_1DeliveryStreamEncryptionConfiguration(output.DeliveryStreamEncryptionConfiguration, context) : undefined,
        DeliveryStreamName: output.DeliveryStreamName !== undefined && output.DeliveryStreamName !== null ? output.DeliveryStreamName : undefined,
        DeliveryStreamStatus: output.DeliveryStreamStatus !== undefined && output.DeliveryStreamStatus !== null ? output.DeliveryStreamStatus : undefined,
        DeliveryStreamType: output.DeliveryStreamType !== undefined && output.DeliveryStreamType !== null ? output.DeliveryStreamType : undefined,
        Destinations: output.Destinations !== undefined && output.Destinations !== null ? deserializeAws_json1_1DestinationDescriptionList(output.Destinations, context) : undefined,
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        HasMoreDestinations: output.HasMoreDestinations !== undefined && output.HasMoreDestinations !== null ? output.HasMoreDestinations : undefined,
        LastUpdateTimestamp: output.LastUpdateTimestamp !== undefined && output.LastUpdateTimestamp !== null ? new Date(Math.round(output.LastUpdateTimestamp * 1000)) : undefined,
        Source: output.Source !== undefined && output.Source !== null ? deserializeAws_json1_1SourceDescription(output.Source, context) : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamEncryptionConfiguration = function deserializeAws_json1_1DeliveryStreamEncryptionConfiguration(output, context) {
    return {
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        KeyARN: output.KeyARN !== undefined && output.KeyARN !== null ? output.KeyARN : undefined,
        KeyType: output.KeyType !== undefined && output.KeyType !== null ? output.KeyType : undefined,
        Status: output.Status !== undefined && output.Status !== null ? output.Status : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamNameList = function deserializeAws_json1_1DeliveryStreamNameList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamOutput = function deserializeAws_json1_1DescribeDeliveryStreamOutput(output, context) {
    return {
        DeliveryStreamDescription: output.DeliveryStreamDescription !== undefined && output.DeliveryStreamDescription !== null ? deserializeAws_json1_1DeliveryStreamDescription(output.DeliveryStreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1Deserializer = function deserializeAws_json1_1Deserializer(output, context) {
    return {
        HiveJsonSerDe: output.HiveJsonSerDe !== undefined && output.HiveJsonSerDe !== null ? deserializeAws_json1_1HiveJsonSerDe(output.HiveJsonSerDe, context) : undefined,
        OpenXJsonSerDe: output.OpenXJsonSerDe !== undefined && output.OpenXJsonSerDe !== null ? deserializeAws_json1_1OpenXJsonSerDe(output.OpenXJsonSerDe, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescription = function deserializeAws_json1_1DestinationDescription(output, context) {
    return {
        DestinationId: output.DestinationId !== undefined && output.DestinationId !== null ? output.DestinationId : undefined,
        ElasticsearchDestinationDescription: output.ElasticsearchDestinationDescription !== undefined && output.ElasticsearchDestinationDescription !== null ? deserializeAws_json1_1ElasticsearchDestinationDescription(output.ElasticsearchDestinationDescription, context) : undefined,
        ExtendedS3DestinationDescription: output.ExtendedS3DestinationDescription !== undefined && output.ExtendedS3DestinationDescription !== null ? deserializeAws_json1_1ExtendedS3DestinationDescription(output.ExtendedS3DestinationDescription, context) : undefined,
        HttpEndpointDestinationDescription: output.HttpEndpointDestinationDescription !== undefined && output.HttpEndpointDestinationDescription !== null ? deserializeAws_json1_1HttpEndpointDestinationDescription(output.HttpEndpointDestinationDescription, context) : undefined,
        RedshiftDestinationDescription: output.RedshiftDestinationDescription !== undefined && output.RedshiftDestinationDescription !== null ? deserializeAws_json1_1RedshiftDestinationDescription(output.RedshiftDestinationDescription, context) : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        SplunkDestinationDescription: output.SplunkDestinationDescription !== undefined && output.SplunkDestinationDescription !== null ? deserializeAws_json1_1SplunkDestinationDescription(output.SplunkDestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescriptionList = function deserializeAws_json1_1DestinationDescriptionList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1DestinationDescription(entry, context);
    });
};
var deserializeAws_json1_1ElasticsearchBufferingHints = function deserializeAws_json1_1ElasticsearchBufferingHints(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1ElasticsearchDestinationDescription = function deserializeAws_json1_1ElasticsearchDestinationDescription(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1ElasticsearchBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterEndpoint: output.ClusterEndpoint !== undefined && output.ClusterEndpoint !== null ? output.ClusterEndpoint : undefined,
        DomainARN: output.DomainARN !== undefined && output.DomainARN !== null ? output.DomainARN : undefined,
        IndexName: output.IndexName !== undefined && output.IndexName !== null ? output.IndexName : undefined,
        IndexRotationPeriod: output.IndexRotationPeriod !== undefined && output.IndexRotationPeriod !== null ? output.IndexRotationPeriod : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1ElasticsearchRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        TypeName: output.TypeName !== undefined && output.TypeName !== null ? output.TypeName : undefined,
        VpcConfigurationDescription: output.VpcConfigurationDescription !== undefined && output.VpcConfigurationDescription !== null ? deserializeAws_json1_1VpcConfigurationDescription(output.VpcConfigurationDescription, context) : undefined
    };
};
var deserializeAws_json1_1ElasticsearchRetryOptions = function deserializeAws_json1_1ElasticsearchRetryOptions(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1EncryptionConfiguration = function deserializeAws_json1_1EncryptionConfiguration(output, context) {
    return {
        KMSEncryptionConfig: output.KMSEncryptionConfig !== undefined && output.KMSEncryptionConfig !== null ? deserializeAws_json1_1KMSEncryptionConfig(output.KMSEncryptionConfig, context) : undefined,
        NoEncryptionConfig: output.NoEncryptionConfig !== undefined && output.NoEncryptionConfig !== null ? output.NoEncryptionConfig : undefined
    };
};
var deserializeAws_json1_1ExtendedS3DestinationDescription = function deserializeAws_json1_1ExtendedS3DestinationDescription(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        DataFormatConversionConfiguration: output.DataFormatConversionConfiguration !== undefined && output.DataFormatConversionConfiguration !== null ? deserializeAws_json1_1DataFormatConversionConfiguration(output.DataFormatConversionConfiguration, context) : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined
    };
};
var deserializeAws_json1_1FailureDescription = function deserializeAws_json1_1FailureDescription(output, context) {
    return {
        Details: output.Details !== undefined && output.Details !== null ? output.Details : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1HiveJsonSerDe = function deserializeAws_json1_1HiveJsonSerDe(output, context) {
    return {
        TimestampFormats: output.TimestampFormats !== undefined && output.TimestampFormats !== null ? deserializeAws_json1_1ListOfNonEmptyStrings(output.TimestampFormats, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointBufferingHints = function deserializeAws_json1_1HttpEndpointBufferingHints(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttribute = function deserializeAws_json1_1HttpEndpointCommonAttribute(output, context) {
    return {
        AttributeName: output.AttributeName !== undefined && output.AttributeName !== null ? output.AttributeName : undefined,
        AttributeValue: output.AttributeValue !== undefined && output.AttributeValue !== null ? output.AttributeValue : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttributesList = function deserializeAws_json1_1HttpEndpointCommonAttributesList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var deserializeAws_json1_1HttpEndpointDescription = function deserializeAws_json1_1HttpEndpointDescription(output, context) {
    return {
        Name: output.Name !== undefined && output.Name !== null ? output.Name : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_json1_1HttpEndpointDestinationDescription = function deserializeAws_json1_1HttpEndpointDestinationDescription(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1HttpEndpointBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        EndpointConfiguration: output.EndpointConfiguration !== undefined && output.EndpointConfiguration !== null ? deserializeAws_json1_1HttpEndpointDescription(output.EndpointConfiguration, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RequestConfiguration: output.RequestConfiguration !== undefined && output.RequestConfiguration !== null ? deserializeAws_json1_1HttpEndpointRequestConfiguration(output.RequestConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1HttpEndpointRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRequestConfiguration = function deserializeAws_json1_1HttpEndpointRequestConfiguration(output, context) {
    return {
        CommonAttributes: output.CommonAttributes !== undefined && output.CommonAttributes !== null ? deserializeAws_json1_1HttpEndpointCommonAttributesList(output.CommonAttributes, context) : undefined,
        ContentEncoding: output.ContentEncoding !== undefined && output.ContentEncoding !== null ? output.ContentEncoding : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRetryOptions = function deserializeAws_json1_1HttpEndpointRetryOptions(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1InputFormatConfiguration = function deserializeAws_json1_1InputFormatConfiguration(output, context) {
    return {
        Deserializer: output.Deserializer !== undefined && output.Deserializer !== null ? deserializeAws_json1_1Deserializer(output.Deserializer, context) : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function deserializeAws_json1_1InvalidArgumentException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidKMSResourceException = function deserializeAws_json1_1InvalidKMSResourceException(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KinesisStreamSourceDescription = function deserializeAws_json1_1KinesisStreamSourceDescription(output, context) {
    return {
        DeliveryStartTimestamp: output.DeliveryStartTimestamp !== undefined && output.DeliveryStartTimestamp !== null ? new Date(Math.round(output.DeliveryStartTimestamp * 1000)) : undefined,
        KinesisStreamARN: output.KinesisStreamARN !== undefined && output.KinesisStreamARN !== null ? output.KinesisStreamARN : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1KMSEncryptionConfig = function deserializeAws_json1_1KMSEncryptionConfig(output, context) {
    return {
        AWSKMSKeyARN: output.AWSKMSKeyARN !== undefined && output.AWSKMSKeyARN !== null ? output.AWSKMSKeyARN : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function deserializeAws_json1_1LimitExceededException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListDeliveryStreamsOutput = function deserializeAws_json1_1ListDeliveryStreamsOutput(output, context) {
    return {
        DeliveryStreamNames: output.DeliveryStreamNames !== undefined && output.DeliveryStreamNames !== null ? deserializeAws_json1_1DeliveryStreamNameList(output.DeliveryStreamNames, context) : undefined,
        HasMoreDeliveryStreams: output.HasMoreDeliveryStreams !== undefined && output.HasMoreDeliveryStreams !== null ? output.HasMoreDeliveryStreams : undefined
    };
};
var deserializeAws_json1_1ListOfNonEmptyStrings = function deserializeAws_json1_1ListOfNonEmptyStrings(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutput = function deserializeAws_json1_1ListTagsForDeliveryStreamOutput(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList = function deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1OpenXJsonSerDe = function deserializeAws_json1_1OpenXJsonSerDe(output, context) {
    return {
        CaseInsensitive: output.CaseInsensitive !== undefined && output.CaseInsensitive !== null ? output.CaseInsensitive : undefined,
        ColumnToJsonKeyMappings: output.ColumnToJsonKeyMappings !== undefined && output.ColumnToJsonKeyMappings !== null ? deserializeAws_json1_1ColumnToJsonKeyMappings(output.ColumnToJsonKeyMappings, context) : undefined,
        ConvertDotsInJsonKeysToUnderscores: output.ConvertDotsInJsonKeysToUnderscores !== undefined && output.ConvertDotsInJsonKeysToUnderscores !== null ? output.ConvertDotsInJsonKeysToUnderscores : undefined
    };
};
var deserializeAws_json1_1OrcSerDe = function deserializeAws_json1_1OrcSerDe(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        BloomFilterColumns: output.BloomFilterColumns !== undefined && output.BloomFilterColumns !== null ? deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(output.BloomFilterColumns, context) : undefined,
        BloomFilterFalsePositiveProbability: output.BloomFilterFalsePositiveProbability !== undefined && output.BloomFilterFalsePositiveProbability !== null ? output.BloomFilterFalsePositiveProbability : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        DictionaryKeyThreshold: output.DictionaryKeyThreshold !== undefined && output.DictionaryKeyThreshold !== null ? output.DictionaryKeyThreshold : undefined,
        EnablePadding: output.EnablePadding !== undefined && output.EnablePadding !== null ? output.EnablePadding : undefined,
        FormatVersion: output.FormatVersion !== undefined && output.FormatVersion !== null ? output.FormatVersion : undefined,
        PaddingTolerance: output.PaddingTolerance !== undefined && output.PaddingTolerance !== null ? output.PaddingTolerance : undefined,
        RowIndexStride: output.RowIndexStride !== undefined && output.RowIndexStride !== null ? output.RowIndexStride : undefined,
        StripeSizeBytes: output.StripeSizeBytes !== undefined && output.StripeSizeBytes !== null ? output.StripeSizeBytes : undefined
    };
};
var deserializeAws_json1_1OutputFormatConfiguration = function deserializeAws_json1_1OutputFormatConfiguration(output, context) {
    return {
        Serializer: output.Serializer !== undefined && output.Serializer !== null ? deserializeAws_json1_1Serializer(output.Serializer, context) : undefined
    };
};
var deserializeAws_json1_1ParquetSerDe = function deserializeAws_json1_1ParquetSerDe(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        EnableDictionaryCompression: output.EnableDictionaryCompression !== undefined && output.EnableDictionaryCompression !== null ? output.EnableDictionaryCompression : undefined,
        MaxPaddingBytes: output.MaxPaddingBytes !== undefined && output.MaxPaddingBytes !== null ? output.MaxPaddingBytes : undefined,
        PageSizeBytes: output.PageSizeBytes !== undefined && output.PageSizeBytes !== null ? output.PageSizeBytes : undefined,
        WriterVersion: output.WriterVersion !== undefined && output.WriterVersion !== null ? output.WriterVersion : undefined
    };
};
var deserializeAws_json1_1ProcessingConfiguration = function deserializeAws_json1_1ProcessingConfiguration(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        Processors: output.Processors !== undefined && output.Processors !== null ? deserializeAws_json1_1ProcessorList(output.Processors, context) : undefined
    };
};
var deserializeAws_json1_1Processor = function deserializeAws_json1_1Processor(output, context) {
    return {
        Parameters: output.Parameters !== undefined && output.Parameters !== null ? deserializeAws_json1_1ProcessorParameterList(output.Parameters, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1ProcessorList = function deserializeAws_json1_1ProcessorList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Processor(entry, context);
    });
};
var deserializeAws_json1_1ProcessorParameter = function deserializeAws_json1_1ProcessorParameter(output, context) {
    return {
        ParameterName: output.ParameterName !== undefined && output.ParameterName !== null ? output.ParameterName : undefined,
        ParameterValue: output.ParameterValue !== undefined && output.ParameterValue !== null ? output.ParameterValue : undefined
    };
};
var deserializeAws_json1_1ProcessorParameterList = function deserializeAws_json1_1ProcessorParameterList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var deserializeAws_json1_1PutRecordBatchOutput = function deserializeAws_json1_1PutRecordBatchOutput(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        FailedPutCount: output.FailedPutCount !== undefined && output.FailedPutCount !== null ? output.FailedPutCount : undefined,
        RequestResponses: output.RequestResponses !== undefined && output.RequestResponses !== null ? deserializeAws_json1_1PutRecordBatchResponseEntryList(output.RequestResponses, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntry = function deserializeAws_json1_1PutRecordBatchResponseEntry(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntryList = function deserializeAws_json1_1PutRecordBatchResponseEntryList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordBatchResponseEntry(entry, context);
    });
};
var deserializeAws_json1_1PutRecordOutput = function deserializeAws_json1_1PutRecordOutput(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1RedshiftDestinationDescription = function deserializeAws_json1_1RedshiftDestinationDescription(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterJDBCURL: output.ClusterJDBCURL !== undefined && output.ClusterJDBCURL !== null ? output.ClusterJDBCURL : undefined,
        CopyCommand: output.CopyCommand !== undefined && output.CopyCommand !== null ? deserializeAws_json1_1CopyCommand(output.CopyCommand, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1RedshiftRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        Username: output.Username !== undefined && output.Username !== null ? output.Username : undefined
    };
};
var deserializeAws_json1_1RedshiftRetryOptions = function deserializeAws_json1_1RedshiftRetryOptions(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function deserializeAws_json1_1ResourceInUseException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function deserializeAws_json1_1ResourceNotFoundException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1S3DestinationDescription = function deserializeAws_json1_1S3DestinationDescription(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1SchemaConfiguration = function deserializeAws_json1_1SchemaConfiguration(output, context) {
    return {
        CatalogId: output.CatalogId !== undefined && output.CatalogId !== null ? output.CatalogId : undefined,
        DatabaseName: output.DatabaseName !== undefined && output.DatabaseName !== null ? output.DatabaseName : undefined,
        Region: output.Region !== undefined && output.Region !== null ? output.Region : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        TableName: output.TableName !== undefined && output.TableName !== null ? output.TableName : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1SecurityGroupIdList = function deserializeAws_json1_1SecurityGroupIdList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Serializer = function deserializeAws_json1_1Serializer(output, context) {
    return {
        OrcSerDe: output.OrcSerDe !== undefined && output.OrcSerDe !== null ? deserializeAws_json1_1OrcSerDe(output.OrcSerDe, context) : undefined,
        ParquetSerDe: output.ParquetSerDe !== undefined && output.ParquetSerDe !== null ? deserializeAws_json1_1ParquetSerDe(output.ParquetSerDe, context) : undefined
    };
};
var deserializeAws_json1_1ServiceUnavailableException = function deserializeAws_json1_1ServiceUnavailableException(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SourceDescription = function deserializeAws_json1_1SourceDescription(output, context) {
    return {
        KinesisStreamSourceDescription: output.KinesisStreamSourceDescription !== undefined && output.KinesisStreamSourceDescription !== null ? deserializeAws_json1_1KinesisStreamSourceDescription(output.KinesisStreamSourceDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkDestinationDescription = function deserializeAws_json1_1SplunkDestinationDescription(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        HECAcknowledgmentTimeoutInSeconds: output.HECAcknowledgmentTimeoutInSeconds !== undefined && output.HECAcknowledgmentTimeoutInSeconds !== null ? output.HECAcknowledgmentTimeoutInSeconds : undefined,
        HECEndpoint: output.HECEndpoint !== undefined && output.HECEndpoint !== null ? output.HECEndpoint : undefined,
        HECEndpointType: output.HECEndpointType !== undefined && output.HECEndpointType !== null ? output.HECEndpointType : undefined,
        HECToken: output.HECToken !== undefined && output.HECToken !== null ? output.HECToken : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1SplunkRetryOptions(output.RetryOptions, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkRetryOptions = function deserializeAws_json1_1SplunkRetryOptions(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionOutput = function deserializeAws_json1_1StartDeliveryStreamEncryptionOutput(output, context) {
    return {};
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionOutput = function deserializeAws_json1_1StopDeliveryStreamEncryptionOutput(output, context) {
    return {};
};
var deserializeAws_json1_1SubnetIdList = function deserializeAws_json1_1SubnetIdList(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Tag = function deserializeAws_json1_1Tag(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagDeliveryStreamOutput = function deserializeAws_json1_1TagDeliveryStreamOutput(output, context) {
    return {};
};
var deserializeAws_json1_1UntagDeliveryStreamOutput = function deserializeAws_json1_1UntagDeliveryStreamOutput(output, context) {
    return {};
};
var deserializeAws_json1_1UpdateDestinationOutput = function deserializeAws_json1_1UpdateDestinationOutput(output, context) {
    return {};
};
var deserializeAws_json1_1VpcConfigurationDescription = function deserializeAws_json1_1VpcConfigurationDescription(output, context) {
    return {
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        SecurityGroupIds: output.SecurityGroupIds !== undefined && output.SecurityGroupIds !== null ? deserializeAws_json1_1SecurityGroupIdList(output.SecurityGroupIds, context) : undefined,
        SubnetIds: output.SubnetIds !== undefined && output.SubnetIds !== null ? deserializeAws_json1_1SubnetIdList(output.SubnetIds, context) : undefined,
        VpcId: output.VpcId !== undefined && output.VpcId !== null ? output.VpcId : undefined
    };
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function buildHttpRpcRequest(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mvSm":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonPersonalizeProvider", function() {
    return AmazonPersonalizeProvider;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientPersonalizeEvents = require("@aws-sdk/client-personalize-events");
var _amazonPersonalizeHelper = require("./AmazonPersonalizeHelper");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)('AmazonPersonalizeProvider');
// events buffer
var FLUSH_SIZE = 5;
var FLUSH_SIZE_THRESHHOLD = 10;
var FLUSH_INTERVAL = 5000; // 5s
var IDENTIFY_EVENT = 'Identify';
var AmazonPersonalizeProvider = /** @class */ function() {
    function AmazonPersonalizeProvider(config) {
        this._buffer = [];
        this._config = config ? config : {};
        this._config.flushSize = this._config.flushSize > 0 && this._config.flushSize <= FLUSH_SIZE_THRESHHOLD ? this._config.flushSize : FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._sessionManager = new (0, _amazonPersonalizeHelper.SessionInfoManager)();
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        // flush event buffer
        this._setupTimer();
    }
    AmazonPersonalizeProvider.prototype._setupTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var flushInterval = this._config.flushInterval;
        var that = this;
        this._timer = setInterval(function() {
            that._sendFromBuffer();
        }, flushInterval);
    };
    /**
     * Record event
     * @param eventType      - type of the event action. e.g. "Click"
     * @param properties     - properties of the event
     * @return Promise
     */ AmazonPersonalizeProvider.prototype.record = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, _a, eventType, properties, requestParams, isLoaded;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials,
                            sentAt: new Date()
                        });
                        _a = params.event, eventType = _a.eventType, properties = _a.properties;
                        if (eventType === IDENTIFY_EVENT) {
                            this._sessionManager.updateSessionInfo(properties && properties.userId ? properties.userId : '', this._sessionInfo);
                            return [
                                2 /*return*/ 
                            ];
                        } else if (!(0, _isEmptyDefault.default)(params.event.userId)) this._sessionManager.updateSessionInfo(params.event.userId, this._sessionInfo);
                        requestParams = this.generateRequestParams(params, this._sessionInfo);
                        if (!(eventType === 'MediaAutoTrack')) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!this._isBrowser) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!!(0, _isEmptyDefault.default)((0, _getDefault.default)(requestParams, 'eventData.properties.domElementId', null))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.isElementFullyLoaded(this.loadElement, requestParams.eventData.properties['domElementId'], 500, 5)
                        ];
                    case 2:
                        isLoaded = _b.sent();
                        if (isLoaded) new (0, _amazonPersonalizeHelper.MediaAutoTrack)(requestParams, this);
                        else logger.debug('Cannot find the media element.');
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        logger.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type.");
                        _b.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        logger.debug('MediaAutoTrack only for browser');
                        _b.label = 6;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            this.putToBuffer(requestParams)
                        ];
                }
            });
        });
    };
    AmazonPersonalizeProvider.prototype.loadElement = function(domId) {
        return new Promise(function(resolve, reject) {
            if (document.getElementById(domId) && document.getElementById(domId).clientHeight) return resolve(true);
            else return reject(true);
        });
    };
    AmazonPersonalizeProvider.prototype.isElementFullyLoaded = function(operation, params, delay, times) {
        var _this = this;
        var wait = function wait(ms) {
            return new Promise(function(r) {
                return setTimeout(r, ms);
            });
        };
        return new Promise(function(resolve, reject) {
            return operation(params).then(resolve).catch(function(reason) {
                if (times - 1 > 0) return wait(delay).then(_this.isElementFullyLoaded.bind(null, operation, params, delay, times - 1)).then(resolve).catch(reject);
                return reject(reason);
            });
        });
    };
    /**
     * get the category of the plugin
     */ AmazonPersonalizeProvider.prototype.getCategory = function() {
        return 'Analytics';
    };
    /**
     * get provider name of the plugin
     */ AmazonPersonalizeProvider.prototype.getProviderName = function() {
        return 'AmazonPersonalize';
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AmazonPersonalizeProvider.prototype.configure = function(config) {
        logger.debug('configure Analytics', config);
        var conf = config ? config : {};
        this._config = Object.assign({}, this._config, conf);
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._setupTimer();
        return this._config;
    };
    /**
     * Generate the requestParams from customer input params and sessionInfo
     * @private
     * @param eventData      - customer input for event data
     * @param api            - api name
     * @return RequestParams - wrapper object with all information required for make request
     */ AmazonPersonalizeProvider.prototype.generateRequestParams = function(params, sessionInfo) {
        var requestParams = {};
        var _a = params.event, eventType = _a.eventType, properties = _a.properties;
        requestParams.eventData = {
            eventType: eventType,
            properties: properties
        };
        requestParams.sessionInfo = sessionInfo;
        requestParams.sentAt = params.sentAt;
        requestParams.credentials = params.credentials;
        requestParams.config = params.config;
        return requestParams;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AmazonPersonalizeProvider.prototype._sendEvents = function(group) {
        var groupLen = group.length;
        if (groupLen === 0) {
            logger.debug('events array is empty, directly return');
            return;
        }
        var _a = group[0], config = _a.config, credentials = _a.credentials, sessionInfo = _a.sessionInfo;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        if (groupLen > 0) {
            var events = [];
            for(var i = 0; i < groupLen; i += 1){
                var params = group.shift();
                var eventPayload = this._generateSingleRecordPayload(params, sessionInfo);
                events.push(eventPayload);
            }
            var payload_1 = {};
            payload_1.trackingId = sessionInfo.trackingId;
            payload_1.sessionId = sessionInfo.sessionId;
            payload_1.userId = sessionInfo.userId;
            payload_1.eventList = [];
            events.forEach(function(event) {
                // @ts-ignore
                payload_1.eventList.push(event);
            });
            var command = new (0, _clientPersonalizeEvents.PutEventsCommand)(payload_1);
            this._personalize.send(command, function(err) {
                if (err) logger.debug('Failed to call putEvents in Personalize', err);
                else logger.debug('Put events');
            });
        }
    };
    /**
     * Put event into buffer
     * @private
     * @param params - params for the event recording
     */ AmazonPersonalizeProvider.prototype.putToBuffer = function(params) {
        if (this._buffer.length < this._config.flushSize) this._buffer.push(params);
        else {
            this._buffer.push(params);
            this._sendFromBuffer();
        }
        return Promise.resolve(true);
    };
    /**
     * flush the buffer and batch sending the request
     * @private
     * @param eventsParams - the buffer for cache the payload
     */ AmazonPersonalizeProvider.prototype._sendFromBuffer = function() {
        var _this = this;
        var size = this._buffer.length;
        if (size <= 0) return;
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < size; i += 1){
            var currRequestParams = this._buffer.shift();
            var cred = currRequestParams.credentials;
            var sessionInfo = currRequestParams.sessionInfo;
            if (i === 0) {
                group.push(currRequestParams);
                preCred = cred;
            } else if ((0, _isEqualDefault.default)(sessionInfo, this._sessionInfo) && cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug('no change for cred, put event in the same group');
                group.push(currRequestParams);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(currRequestParams);
                preCred = cred;
                this._sessionInfo = sessionInfo;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(group) {
            _this._sendEvents(group);
        });
    };
    /**
     * Generate the record payload for single event
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._generateSingleRecordPayload = function(params, sessionInfo) {
        var eventData = params.eventData, sentAt = params.sentAt;
        var trackPayload = {};
        trackPayload.sentAt = sentAt;
        trackPayload.properties = eventData.properties && JSON.stringify(eventData.properties);
        trackPayload.eventId = this._sessionManager.getTimerKey() + sessionInfo.sessionId;
        trackPayload.eventType = eventData.eventType;
        return trackPayload;
    };
    /**
     * Initialize the personalize client
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._init = function(config, credentials) {
        logger.debug('init clients');
        if (this._personalize && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug('no change for analytics config, directly return from init');
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        logger.debug('initialize personalize with credentials', credentials);
        this._personalize = new (0, _clientPersonalizeEvents.PersonalizeEventsClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    /**
     * check if current credentials exists
     * @private
     */ AmazonPersonalizeProvider.prototype._getCredentials = function() {
        var that = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug('set credentials for analytics', that._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug('ensure credentials error', err);
            return null;
        });
    };
    return AmazonPersonalizeProvider;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-sdk/client-personalize-events":"ljv3X","./AmazonPersonalizeHelper":"ckMSu","lodash/get":"jeneQ","lodash/isEmpty":"15wZF","lodash/isEqual":"6bbKw","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ljv3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _personalizeEventsClient = require("./PersonalizeEventsClient");
parcelHelpers.exportAll(_personalizeEventsClient, exports);
var _personalizeEvents = require("./PersonalizeEvents");
parcelHelpers.exportAll(_personalizeEvents, exports);
var _putEventsCommand = require("./commands/PutEventsCommand");
parcelHelpers.exportAll(_putEventsCommand, exports);
var _putItemsCommand = require("./commands/PutItemsCommand");
parcelHelpers.exportAll(_putItemsCommand, exports);
var _putUsersCommand = require("./commands/PutUsersCommand");
parcelHelpers.exportAll(_putUsersCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./PersonalizeEventsClient":"1TRdF","./PersonalizeEvents":false,"./commands/PutEventsCommand":"1G0l4","./commands/PutItemsCommand":false,"./commands/PutUsersCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1TRdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PersonalizeEventsClient", function() {
    return PersonalizeEventsClient;
});
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Amazon Personalize can consume real-time user event data, such as <i>stream</i> or <i>click</i> data, and use
 *       it for model training either alone or combined with historical data. For more information see <a>recording-events</a>.</p>
 */ var PersonalizeEventsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(PersonalizeEventsClient, _super);
    function PersonalizeEventsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    PersonalizeEventsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return PersonalizeEventsClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"h2SFZ","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h2SFZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", function() {
    return ClientDefaultValues;
});
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function credentialDefaultProvider(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"febmM","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"eioSM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"febmM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-personalize-events\",\"description\":\"AWS SDK for JavaScript Personalize Events Client for Node.js, Browser and React Native\",\"version\":\"3.6.1\",\"scripts\":{\"clean\":\"yarn remove-definitions && yarn remove-dist && yarn remove-documentation\",\"build-documentation\":\"yarn remove-documentation && typedoc ./\",\"prepublishOnly\":\"yarn build\",\"pretest\":\"yarn build:cjs\",\"remove-definitions\":\"rimraf ./types\",\"remove-dist\":\"rimraf ./dist\",\"remove-documentation\":\"rimraf ./docs\",\"test\":\"exit 0\",\"build:cjs\":\"tsc -p tsconfig.json\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build\":\"yarn build:cjs && yarn build:es\",\"postbuild\":\"downlevel-dts types types/ts3.4\"},\"main\":\"./dist/cjs/index.js\",\"types\":\"./types/index.d.ts\",\"module\":\"./dist/es/index.js\",\"browser\":{\"./runtimeConfig\":\"./runtimeConfig.browser\"},\"react-native\":{\"./runtimeConfig\":\"./runtimeConfig.native\"},\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"^1.0.0\",\"@aws-crypto/sha256-js\":\"^1.0.0\",\"@aws-sdk/config-resolver\":\"3.6.1\",\"@aws-sdk/credential-provider-node\":\"3.6.1\",\"@aws-sdk/fetch-http-handler\":\"3.6.1\",\"@aws-sdk/hash-node\":\"3.6.1\",\"@aws-sdk/invalid-dependency\":\"3.6.1\",\"@aws-sdk/middleware-content-length\":\"3.6.1\",\"@aws-sdk/middleware-host-header\":\"3.6.1\",\"@aws-sdk/middleware-logger\":\"3.6.1\",\"@aws-sdk/middleware-retry\":\"3.6.1\",\"@aws-sdk/middleware-serde\":\"3.6.1\",\"@aws-sdk/middleware-signing\":\"3.6.1\",\"@aws-sdk/middleware-stack\":\"3.6.1\",\"@aws-sdk/middleware-user-agent\":\"3.6.1\",\"@aws-sdk/node-config-provider\":\"3.6.1\",\"@aws-sdk/node-http-handler\":\"3.6.1\",\"@aws-sdk/protocol-http\":\"3.6.1\",\"@aws-sdk/smithy-client\":\"3.6.1\",\"@aws-sdk/types\":\"3.6.1\",\"@aws-sdk/url-parser\":\"3.6.1\",\"@aws-sdk/url-parser-native\":\"3.6.1\",\"@aws-sdk/util-base64-browser\":\"3.6.1\",\"@aws-sdk/util-base64-node\":\"3.6.1\",\"@aws-sdk/util-body-length-browser\":\"3.6.1\",\"@aws-sdk/util-body-length-node\":\"3.6.1\",\"@aws-sdk/util-user-agent-browser\":\"3.6.1\",\"@aws-sdk/util-user-agent-node\":\"3.6.1\",\"@aws-sdk/util-utf8-browser\":\"3.6.1\",\"@aws-sdk/util-utf8-node\":\"3.6.1\",\"tslib\":\"^2.0.0\"},\"devDependencies\":{\"@aws-sdk/client-documentation-generator\":\"3.6.1\",\"@types/node\":\"^12.7.5\",\"downlevel-dts\":\"0.7.0\",\"jest\":\"^26.1.0\",\"rimraf\":\"^3.0.0\",\"typedoc\":\"^0.19.2\",\"typescript\":\"~4.1.2\"},\"engines\":{\"node\":\">=10.0.0\"},\"typesVersions\":{\"<4.0\":{\"types/*\":[\"types/ts3.4/*\"]}},\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-personalize-events\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-personalize-events\"}}");

},{}],"eioSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", function() {
    return ClientSharedValues;
});
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2018-03-22",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Personalize Events",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"4ncNE","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ncNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "personalize-events.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "personalize-events.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "personalize-events.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "personalize-events.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "personalize-events.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    var regionInfo = undefined;
    region;
    if (AWS_REGIONS.has(region)) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    if (AWS_CN_REGIONS.has(region)) regionInfo = {
        hostname: AWS_CN_TEMPLATE.replace("{region}", region),
        partition: "aws-cn"
    };
    if (AWS_ISO_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
        partition: "aws-iso"
    };
    if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
        partition: "aws-iso-b"
    };
    if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
        hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
        partition: "aws-us-gov"
    };
    // Finally, assume it's an AWS partition endpoint.
    if (regionInfo === undefined) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "personalize"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1G0l4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutEventsCommand", function() {
    return PutEventsCommand;
});
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Records user interaction event data. For more information see <a>event-record-api</a>.</p>
 */ var PutEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PersonalizeEventsClient";
        var commandName = "PutEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function outputFilterSensitiveLog(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PutEventsCommand)(input, context);
    };
    PutEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PutEventsCommand)(output, context);
    };
    return PutEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"jDuD1","../protocols/Aws_restJson1":"dH2Ht","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDuD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidInputException", function() {
    return InvalidInputException;
});
parcelHelpers.export(exports, "Event", function() {
    return Event;
});
parcelHelpers.export(exports, "PutEventsRequest", function() {
    return PutEventsRequest;
});
parcelHelpers.export(exports, "Item", function() {
    return Item;
});
parcelHelpers.export(exports, "PutItemsRequest", function() {
    return PutItemsRequest;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "User", function() {
    return User;
});
parcelHelpers.export(exports, "PutUsersRequest", function() {
    return PutUsersRequest;
});
var _tslib = require("tslib");
var InvalidInputException;
(function(InvalidInputException) {
    InvalidInputException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidInputException || (InvalidInputException = {}));
var Event;
(function(Event) {
    Event.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Event || (Event = {}));
var PutEventsRequest;
(function(PutEventsRequest) {
    PutEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutEventsRequest || (PutEventsRequest = {}));
var Item;
(function(Item) {
    Item.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Item || (Item = {}));
var PutItemsRequest;
(function(PutItemsRequest) {
    PutItemsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutItemsRequest || (PutItemsRequest = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var User;
(function(User) {
    User.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(User || (User = {}));
var PutUsersRequest;
(function(PutUsersRequest) {
    PutUsersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutUsersRequest || (PutUsersRequest = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dH2Ht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1PutEventsCommand", function() {
    return serializeAws_restJson1PutEventsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PutItemsCommand", function() {
    return serializeAws_restJson1PutItemsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PutUsersCommand", function() {
    return serializeAws_restJson1PutUsersCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutEventsCommand", function() {
    return deserializeAws_restJson1PutEventsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutItemsCommand", function() {
    return deserializeAws_restJson1PutItemsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutUsersCommand", function() {
    return deserializeAws_restJson1PutUsersCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var serializeAws_restJson1PutEventsCommand = function serializeAws_restJson1PutEventsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/events";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventList !== undefined && input.eventList !== null && {
                        eventList: serializeAws_restJson1EventList(input.eventList, context)
                    }), input.sessionId !== undefined && input.sessionId !== null && {
                        sessionId: input.sessionId
                    }), input.trackingId !== undefined && input.trackingId !== null && {
                        trackingId: input.trackingId
                    }), input.userId !== undefined && input.userId !== null && {
                        userId: input.userId
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutItemsCommand = function serializeAws_restJson1PutItemsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/items";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.items !== undefined && input.items !== null && {
                        items: serializeAws_restJson1ItemList(input.items, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutUsersCommand = function serializeAws_restJson1PutUsersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/users";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.users !== undefined && input.users !== null && {
                        users: serializeAws_restJson1UserList(input.users, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommand = function deserializeAws_restJson1PutEventsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutEventsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommandError = function deserializeAws_restJson1PutEventsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommand = function deserializeAws_restJson1PutItemsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutItemsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommandError = function deserializeAws_restJson1PutItemsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommand = function deserializeAws_restJson1PutUsersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutUsersCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommandError = function deserializeAws_restJson1PutUsersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1InvalidInputExceptionResponse = function deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "InvalidInputException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_restJson1Event = function serializeAws_restJson1Event(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventId !== undefined && input.eventId !== null && {
        eventId: input.eventId
    }), input.eventType !== undefined && input.eventType !== null && {
        eventType: input.eventType
    }), input.eventValue !== undefined && input.eventValue !== null && {
        eventValue: input.eventValue
    }), input.impression !== undefined && input.impression !== null && {
        impression: serializeAws_restJson1Impression(input.impression, context)
    }), input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.recommendationId !== undefined && input.recommendationId !== null && {
        recommendationId: input.recommendationId
    }), input.sentAt !== undefined && input.sentAt !== null && {
        sentAt: Math.round(input.sentAt.getTime() / 1000)
    });
};
var serializeAws_restJson1EventList = function serializeAws_restJson1EventList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Event(entry, context);
    });
};
var serializeAws_restJson1Impression = function serializeAws_restJson1Impression(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_restJson1Item = function serializeAws_restJson1Item(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    });
};
var serializeAws_restJson1ItemList = function serializeAws_restJson1ItemList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Item(entry, context);
    });
};
var serializeAws_restJson1User = function serializeAws_restJson1User(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.userId !== undefined && input.userId !== null && {
        userId: input.userId
    });
};
var serializeAws_restJson1UserList = function serializeAws_restJson1UserList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1User(entry, context);
    });
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ckMSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", function() {
    return 0, _sessionInfoManager.SessionInfoManager;
});
parcelHelpers.export(exports, "MediaAutoTrack", function() {
    return 0, _mediaAutoTrack.MediaAutoTrack;
});
var _sessionInfoManager = require("./SessionInfoManager");
var _mediaAutoTrack = require("./MediaAutoTrack");

},{"./SessionInfoManager":"Nivvt","./MediaAutoTrack":"lo4lH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Nivvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", function() {
    return SessionInfoManager;
});
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _uuid = require("uuid");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var PERSONALIZE_CACHE = '_awsct';
var PERSONALIZE_CACHE_USERID = '_awsct_uid';
var PERSONALIZE_CACHE_SESSIONID = '_awsct_sid';
var DEFAULT_CACHE_PREFIX = 'personalize';
var TIMER_INTERVAL = 30000;
var DELIMITER = '.';
var CACHE_EXPIRY_IN_DAYS = 7;
var logger = new (0, _core.ConsoleLogger)('AmazonPersonalizeProvider');
var SessionInfoManager = /** @class */ function() {
    function SessionInfoManager(prefixKey) {
        if (prefixKey === void 0) prefixKey = '';
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        this._timerKey = (0, _uuid.v1)().substr(0, 15);
        this._refreshTimer();
    }
    SessionInfoManager.prototype._refreshTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var that = this;
        this._timer = setInterval(function() {
            that._timerKey = (0, _uuid.v1)().substr(0, 15);
        }, TIMER_INTERVAL);
    };
    SessionInfoManager.prototype.storeValue = function(key, value) {
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 86400000 * CACHE_EXPIRY_IN_DAYS);
        (0, _cache.Cache).setItem(this._getCachePrefix(key), value, {
            expires: expire.getTime()
        });
    };
    SessionInfoManager.prototype.retrieveValue = function(key) {
        return (0, _cache.Cache).getItem(this._getCachePrefix(key));
    };
    SessionInfoManager.prototype._getCachePrefix = function(key) {
        if (this._isBrowser) return key + DELIMITER + window.location.host;
        return DEFAULT_CACHE_PREFIX;
    };
    SessionInfoManager.prototype.getTimerKey = function() {
        return this._timerKey;
    };
    SessionInfoManager.prototype.updateSessionInfo = function(userId, sessionInfo) {
        var existUserId = sessionInfo.userId;
        var existSessionId = sessionInfo.sessionId;
        if (this._isRequireNewSession(userId, existUserId, existSessionId)) {
            var newSessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_USERID, userId);
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, newSessionId);
            sessionInfo.sessionId = newSessionId;
        } else if (this._isRequireUpdateSessionInfo(userId, existUserId, existSessionId)) this.storeValue(PERSONALIZE_CACHE_USERID, userId);
        sessionInfo.userId = userId;
    };
    SessionInfoManager.prototype._isRequireUpdateSessionInfo = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // anonymouse => sign in : hasSession && s_userId == null && curr_userId !=null
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        return !isNoCachedSession && (0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEmptyDefault.default)(userId);
    };
    SessionInfoManager.prototype.retrieveSessionInfo = function(trackingId) {
        var sessionInfo = {};
        sessionInfo.trackingId = trackingId;
        sessionInfo.sessionId = this.retrieveValue(PERSONALIZE_CACHE_SESSIONID);
        sessionInfo.userId = this.retrieveValue(PERSONALIZE_CACHE_USERID);
        if ((0, _isEmptyDefault.default)(sessionInfo.sessionId)) {
            sessionInfo.sessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, sessionInfo.sessionId);
        }
        this.storeValue(PERSONALIZE_CACHE, trackingId);
        return sessionInfo;
    };
    SessionInfoManager.prototype._isRequireNewSession = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // new session => 1. no cached session info 2. signOut: s_userId !=null && curr_userId ==null
        // 3. switch account: s_userId !=null && curr_userId !=null && s_userId != curr_userId
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        var isSignoutCase = (0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId);
        var isSwitchUserCase = !(0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEqualDefault.default)(userId, cachedSessionUserId);
        return isNoCachedSession || isSignoutCase || isSwitchUserCase;
    };
    return SessionInfoManager;
}();

},{"lodash/isEmpty":"15wZF","lodash/isEqual":"6bbKw","uuid":"bvm5J","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15wZF":[function(require,module,exports,__globalThis) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"bPWWi","d63799a808049d04":"58o8p","1f4ee6aee3a7eae0":"jmDAu","b708be4f72c2a706":"jQGs4","ab4b4eaf96f9163a":"mL7I2","80b58ade5ee2f70":"5BMZo","3a444e8bd8b275f2":"36IG4","6af418b3352c301b":"cJbMf"}],"bPWWi":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"36IG4","3ec652610d8dd5d3":"208F5"}],"36IG4":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"208F5":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"2fV7A"}],"2fV7A":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"58o8p":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"53qXk","28e3344aae951f13":"03QB1","b286298be5b1d9a4":"7ryvA","3ae50c158f89813":"lp29B","9f458755f627d456":"g0Y3e","8e9160b373d7fe66":"iuqvy","b210627dd951641f":"7w7D8"}],"53qXk":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"bRlM4","f83c375075418382":"cN4l5"}],"bRlM4":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"6n7j5","16db51a0e009bd8c":"aeApT"}],"6n7j5":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"8ck2f","cabbc2adfaeb27d9":"8lEuR","cbb5703fe1562e7f":"8ffGS","388b819f47a43aa5":"7w7D8"}],"8ck2f":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"iuqvy","3cba3c966459d528":"8ffGS"}],"iuqvy":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"aflde","9b2aaf31b7bdd837":"6KCfR","46d5beb3375f8a28":"exVj8"}],"aflde":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"cN4l5"}],"cN4l5":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"@swc/helpers/_/_type_of":"668P4","cd92e8811deaabf5":"iHmGM"}],"iHmGM":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{"@swc/helpers/_/_type_of":"668P4"}],"6KCfR":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"aflde"}],"exVj8":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"8ffGS":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{"@swc/helpers/_/_type_of":"668P4"}],"8lEuR":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"fMSAF"}],"fMSAF":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"cN4l5"}],"7w7D8":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"aeApT":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"03QB1":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"bRlM4","29224713b8d411e6":"cN4l5"}],"7ryvA":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"bRlM4","a5c6637bac681a0":"cN4l5"}],"lp29B":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"bRlM4","ca486d41cdf819d4":"cN4l5"}],"g0Y3e":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"bRlM4","7a9a6581834a8452":"cN4l5"}],"jmDAu":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function isArguments(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"hvpUQ","bead821d6af018b5":"lm2eo"}],"hvpUQ":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"iuqvy","b6cdbe52dcf709f8":"lm2eo"}],"lm2eo":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
}
module.exports = isObjectLike;

},{"@swc/helpers/_/_type_of":"668P4"}],"jQGs4":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"mL7I2":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"8ck2f","f3db08d4d1110aaf":"f9Q8Z"}],"f9Q8Z":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"5BMZo":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"cN4l5","a1e87b138cf75d1d":"h4jjK"}],"h4jjK":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"cJbMf":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"3GkRb","903f50eb1c16d257":"8g9lw","fa49853a82034c30":"hZg2H"}],"3GkRb":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"iuqvy","f661b3a120d7a4cb":"f9Q8Z","cdd86c83797c0618":"lm2eo"}],"8g9lw":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"hZg2H":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"iHmGM"}],"6bbKw":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"aP9FI"}],"aP9FI":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"l7P77","809bbb0c20650dbc":"lm2eo"}],"l7P77":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"hxIkB","96bc8a1825db53a5":"a10oQ","8bdece495e87fb69":"6izmf","bb94920432a68eca":"9k1JC","45495edff98e5837":"58o8p","18256411ae9e2858":"jQGs4","e5ba7abf54247fc5":"5BMZo","50d786bb5c7366af":"cJbMf"}],"hxIkB":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"4pLro","ceda2a63c77c915":"gXjo2","91ee1b348d9d7172":"fvPkJ","3fe28318f65b9332":"8WEr4","724ca4def8b84e06":"631vb","e9ceacb40d9582bd":"eXKez"}],"4pLro":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"bqAv0","b700cb849df2c166":"gu7Mx","d76dd90eead6cced":"6YLaC","3d210628ba60ec8":"5pysT","76026bf2d4cfff93":"5bMeQ"}],"bqAv0":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"gu7Mx":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"b99O6"}],"b99O6":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"8Gfg3"}],"8Gfg3":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"6YLaC":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"b99O6"}],"5pysT":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"b99O6"}],"5bMeQ":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"b99O6"}],"gXjo2":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"4pLro"}],"fvPkJ":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"8WEr4":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"631vb":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"eXKez":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"4pLro","1494efbafafa9552":"03QB1","6049e8027fe9407f":"CQbJD"}],"CQbJD":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"YzSka","d2967b0e32ccfa56":"d7ROV","ca21409ea89624c0":"5FZQk","f88fd07f8dd1f67d":"k11Cx","dbf3eae765642a3b":"hYpiP"}],"YzSka":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"63axu","a07dcf3fd3097a0c":"4pLro","92c01c953ef00ded":"03QB1"}],"63axu":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"iYuPM","bc25d439ccd1fb47":"kEVYK","f096b37295a92ab0":"4JYrB","d88173cbc6a133c8":"fm2qo","afb9b3bae0461cbf":"hodnJ"}],"iYuPM":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"c2chn"}],"c2chn":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bRlM4"}],"kEVYK":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"4JYrB":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"c2chn"}],"fm2qo":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"c2chn"}],"hodnJ":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"c2chn"}],"d7ROV":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"iz6u0"}],"iz6u0":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"43uyZ"}],"43uyZ":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{"@swc/helpers/_/_type_of":"668P4"}],"5FZQk":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"iz6u0"}],"k11Cx":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"iz6u0"}],"hYpiP":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"iz6u0"}],"a10oQ":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"h6Zwg","1ee20de911db0cb0":"3m5PV","defff3d81be91b23":"dF80X"}],"h6Zwg":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"CQbJD","9a831e81e9a1f98c":"hSWIH","1a2b6c8a7399c39f":"d1akK"}],"hSWIH":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"d1akK":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"3m5PV":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"dF80X":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"6izmf":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"aflde","dbf6aa5033a0f48":"aHxYs","539966708f906e61":"8Gfg3","8142d4017f0a425f":"a10oQ","48cddf732eff33ba":"hOBwA","9dc78b26c5daba20":"3eQLH"}],"aHxYs":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"cN4l5"}],"hOBwA":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"3eQLH":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"9k1JC":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lY5il"}],"lY5il":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"1VPsK","aa79b69a13f924db":"9pWhx","e3ad83e53433bc8a":"kLvI9"}],"1VPsK":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"iS8Vi","148b85918856c33a":"jQGs4"}],"iS8Vi":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"9pWhx":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"5GLUD","6b1c62cea92cdb9":"hZ3M8"}],"5GLUD":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"hZ3M8":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"kLvI9":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"vD0Yx","e8453365fdacc8da":"bPWWi","7760b47b02971dfa":"mL7I2"}],"vD0Yx":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"yuCUc","9cdb51ffa56f149b":"jmDAu","38cd49f1e493b3d7":"jQGs4","b379831fe1873fed":"5BMZo","f362a34cd8321bb7":"heeP8","c019db5297494469":"cJbMf"}],"yuCUc":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"heeP8":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var _typeOf = require("@swc/helpers/_/_type_of");
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{"@swc/helpers/_/_type_of":"668P4"}],"lo4lH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaAutoTrack", function() {
    return MediaAutoTrack;
});
var HTML5_MEDIA_EVENT;
(function(HTML5_MEDIA_EVENT) {
    HTML5_MEDIA_EVENT["PLAY"] = "play";
    HTML5_MEDIA_EVENT["PAUSE"] = "pause";
    HTML5_MEDIA_EVENT["ENDED"] = "Ended";
})(HTML5_MEDIA_EVENT || (HTML5_MEDIA_EVENT = {}));
var MEDIA_TYPE;
(function(MEDIA_TYPE) {
    MEDIA_TYPE["IFRAME"] = "IFRAME";
    MEDIA_TYPE["VIDEO"] = "VIDEO";
    MEDIA_TYPE["AUDIO"] = "AUDIO";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
var EVENT_TYPE;
(function(EVENT_TYPE) {
    EVENT_TYPE["PLAY"] = "Play";
    EVENT_TYPE["ENDED"] = "Ended";
    EVENT_TYPE["PAUSE"] = "Pause";
    EVENT_TYPE["TIME_WATCHED"] = "TimeWatched";
})(EVENT_TYPE || (EVENT_TYPE = {}));
var MediaAutoTrack = /** @class */ function() {
    function MediaAutoTrack(params, provider) {
        var _a;
        this.eventActionMapping = (_a = {}, _a[EVENT_TYPE.ENDED] = this.endedEventAction.bind(this), _a[EVENT_TYPE.PLAY] = this.playEventAction.bind(this), _a[EVENT_TYPE.PAUSE] = this.pauseEventAction.bind(this), _a);
        var eventData = params.eventData;
        this._params = params;
        this._mediaElement = document.getElementById(eventData.properties['domElementId']);
        this._started = false;
        this._provider = provider;
        var mediaTrackFunMapping = {
            IFRAME: this._iframeMediaTracker,
            VIDEO: this._html5MediaTracker,
            AUDIO: this._html5MediaTracker
        };
        mediaTrackFunMapping[this._mediaElement.tagName].bind(this)();
        this._initYoutubeFrame();
    }
    MediaAutoTrack.prototype._initYoutubeFrame = function() {
        this._youTubeIframeLoader = {
            src: 'https://www.youtube.com/iframe_api',
            loading: false,
            loaded: false,
            listeners: [],
            load: function load(callback) {
                var _this = this;
                this.listeners.push(callback);
                if (this.loaded) {
                    setTimeout(function() {
                        _this.done();
                    });
                    return;
                }
                if (this.loading) return;
                this.loading = true;
                window['onYouTubeIframeAPIReady'] = function() {
                    _this.loaded = true;
                    _this.done();
                };
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.src;
                document.body.appendChild(script);
            },
            done: function done() {
                delete window['onYouTubeIframeAPIReady'];
                while(this.listeners.length)this.listeners.pop()(window['YT']);
            }
        };
    };
    MediaAutoTrack.prototype._iframeMediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.IFRAME, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._youTubeIframeLoader.load(function(YT) {
            that._iframePlayer = new YT.Player(that._mediaElement.id, {
                events: {
                    onStateChange: that._onPlayerStateChange.bind(that)
                }
            });
        });
    };
    MediaAutoTrack.prototype._onPlayerStateChange = function(event) {
        var iframeEventMapping = {
            0: EVENT_TYPE.ENDED,
            1: EVENT_TYPE.PLAY,
            2: EVENT_TYPE.PAUSE
        };
        var eventType = iframeEventMapping[event.data];
        if (eventType) this.eventActionMapping[eventType](MEDIA_TYPE.IFRAME);
    };
    MediaAutoTrack.prototype._html5MediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.VIDEO, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PLAY, function() {
            that.eventActionMapping[EVENT_TYPE.PLAY](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PAUSE, function() {
            that.eventActionMapping[EVENT_TYPE.PAUSE](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.ENDED, function() {
            that.eventActionMapping[EVENT_TYPE.ENDED](MEDIA_TYPE.VIDEO);
        }, false);
    };
    MediaAutoTrack.prototype.playEventAction = function(mediaType) {
        this._started = true;
        this.recordEvent(mediaType, EVENT_TYPE.PLAY);
    };
    MediaAutoTrack.prototype.pauseEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.PAUSE);
    };
    MediaAutoTrack.prototype.endedEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.ENDED);
    };
    MediaAutoTrack.prototype.recordEvent = function(mediaType, eventType) {
        var newParams = Object.assign({}, this._params);
        var eventData = newParams.eventData;
        eventData.eventType = eventType;
        var currentPlayTime;
        if (mediaType === MEDIA_TYPE.VIDEO) {
            currentPlayTime = this._mediaElement.currentTime;
            eventData.properties.duration = this._mediaElement.duration;
        } else {
            currentPlayTime = this._financial(this._iframePlayer.getCurrentTime());
            eventData.properties.duration = this._financial(this._iframePlayer.getDuration());
        }
        var percentage = parseFloat(currentPlayTime) / parseFloat(eventData.properties.duration);
        eventData.properties.eventValue = Number(percentage.toFixed(4));
        delete eventData.properties.domElementId;
        this._provider.putToBuffer(newParams);
    };
    MediaAutoTrack.prototype._financial = function(x) {
        return Number.parseFloat(x).toFixed(4);
    };
    return MediaAutoTrack;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jeneQ":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"3bgbL"}],"3bgbL":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"cLKKN","c3296f04fad32769":"ih6jk"}],"cLKKN":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"jQGs4","e823e604d75f975b":"gbNmb","f5fff1c342107fbd":"kcJlt","b04e8cc634273c23":"23Zly"}],"gbNmb":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"@swc/helpers/_/_type_of":"668P4","1efcc081e9a448a8":"jQGs4","4cdff6c9e9ff5d38":"5eB4J"}],"5eB4J":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"@swc/helpers/_/_type_of":"668P4","6118c0d5630f51ce":"iuqvy","74644060ad1a1d3c":"lm2eo"}],"kcJlt":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"axjLO"}],"axjLO":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"ajNZD"}],"ajNZD":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"CQbJD"}],"23Zly":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"33R5Z"}],"33R5Z":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"aflde","8439a3a1551d0706":"5ZiZU","4b12c9f502d3288a":"jQGs4","a0ebd327d618908a":"5eB4J"}],"5ZiZU":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"ih6jk":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"5eB4J"}],"ilv20":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth", function() {
    return 0, _auth.Auth;
});
parcelHelpers.export(exports, "CognitoUser", function() {
    return 0, _amazonCognitoIdentityJs.CognitoUser;
});
parcelHelpers.export(exports, "CookieStorage", function() {
    return 0, _amazonCognitoIdentityJs.CookieStorage;
});
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", function() {
    return 0, _auth1.CognitoHostedUIIdentityProvider;
});
parcelHelpers.export(exports, "appendToCognitoUserAgent", function() {
    return 0, _amazonCognitoIdentityJs.appendToCognitoUserAgent;
});
parcelHelpers.export(exports, "AuthErrorStrings", function() {
    return 0, _authErrorStrings.AuthErrorStrings;
});
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", function() {
    return 0, _auth1.GRAPHQL_AUTH_MODE;
});
var _auth = require("./Auth");
var _auth1 = require("./types/Auth");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _authErrorStrings = require("./common/AuthErrorStrings");
/**
 * @deprecated use named import
 */ exports.default = (0, _auth.Auth);

},{"./Auth":"4GZ7C","./types/Auth":"9VnfC","amazon-cognito-identity-js":"flUAS","./common/AuthErrorStrings":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4GZ7C":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthClass", function() {
    return AuthClass;
});
parcelHelpers.export(exports, "Auth", function() {
    return Auth;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _types = require("./types");
var _core = require("@aws-amplify/core");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _internals = require("amazon-cognito-identity-js/internals");
var _url = require("url");
var _oauth = require("./OAuth/OAuth");
var _oauthDefault = parcelHelpers.interopDefault(_oauth);
var _urlListener = require("./urlListener");
var _urlListenerDefault = parcelHelpers.interopDefault(_urlListener);
var _errors = require("./Errors");
var _auth = require("./types/Auth");
var logger = new (0, _core.ConsoleLogger)('AuthClass');
var USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var OAUTH_FLOW_MS_TIMEOUT = 10000;
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var dispatchAuthEvent = function dispatchAuthEvent(event, data, message) {
    (0, _core.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var MAX_DEVICES = 60;
var MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var AuthClass = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, _core.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function wrapped(error, data) {
                if (data) dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                else dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, _core.Hub).listen('auth', function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case 'verify':
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
        (0, _internals.addAuthCategoryToCognitoUserAgent)();
        (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        (0, _core.Platform).observeFrameworkChanges(function() {
            (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return 'Auth';
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, (0, _core.parseAWSExports)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, _amazonCognitoIdentityJs.CookieStorage)(cookieStorage);
            else this._storage = config.ssr ? new (0, _core.UniversalStorage)() : new (0, _core.StorageHelper)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') this._storageSync = this._storage['sync']();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, _amazonCognitoIdentityJs.CognitoUserPool)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, _types.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new (0, _oauthDefault.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, _urlListenerDefault.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage['getItem'] === 'function') {
            var pollingInitiated = this.isTrueStorageValue('amplify-polling-started');
            if (pollingInitiated) {
                dispatchAuthEvent('autoSignIn_failure', null, (0, _auth.AuthErrorTypes).AutoSignInError);
                this._storage.removeItem('amplify-auto-sign-in');
            }
            this._storage.removeItem('amplify-polling-started');
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: 'email',
                Value: email
            }));
            if (phone_number) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: 'phone_number',
                Value: phone_number
            }));
        } else if (params && (typeof params === "undefined" ? "undefined" : (0, _typeOf._)(params)) === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params['attributes'];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params['validationData'];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem('amplify-auto-sign-in', 'true');
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        logger.debug('signUp attrs:', attributes);
        logger.debug('signUp validation data:', validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                } else {
                    dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === 'link') this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function listenEvent1(_a) {
            var payload = _a.payload;
            if (payload.event === 'confirmSignUp') _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, _core.Hub).listen('auth', listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem('amplify-polling-started', 'true');
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                dispatchAuthEvent('autoSignIn_failure', null, 'Please confirm your account and use your credentials to sign in.');
                _this._storage.removeItem('amplify-auto-sign-in');
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                dispatchAuthEvent('autoSignIn', value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, _core.Hub).remove('auth', listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem('amplify-polling-started');
                                }
                                _this._storage.removeItem('amplify-auto-sign-in');
                            }, function(error) {
                                logger.error(error);
                                _this._storage.removeItem('amplify-auto-sign-in');
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean' ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    dispatchAuthEvent('confirmSignUp', data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue('amplify-auto-sign-in');
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        dispatchAuthEvent('autoSignIn_failure', null, (0, _auth.AuthErrorTypes).AutoSignInError);
                        _this._storage.removeItem('amplify-auto-sign-in');
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === 'true' : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, _types.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') logger.warn('The password should be defined under the first parameter object!');
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function onSuccess(session) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug(session);
                                delete user['challengeName'];
                                delete user['challengeParam'];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, 'session')
                                ];
                            case 3:
                                cred = _a.sent();
                                logger.debug('succeed to get cognito credentials', cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                logger.debug('cannot get cognito credentials', e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                logger.error('Failed to get the signed in user', e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function onFailure(err) {
                logger.debug('signIn failure', err);
                dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function customChallenge(challengeParam) {
                logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function mfaRequired(challengeName, challengeParam) {
                logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function mfaSetup(challengeName, challengeParam) {
                logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
                logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function totpRequired(challengeName, challengeParam) {
                logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function selectMFAType(challengeName, challengeParam) {
                logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error('Pending sign-in attempt already in progress');
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug('getting preferred mfa failed', err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej('invalid MFA Type');
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = 'SMS_MFA';
                else ret = 'NOMFA';
            } else if (mfaList.length === 0) ret = 'NOMFA';
            else logger.debug('invalid case for getPreferredMFA', data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug('getting user data failed', err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case 'TOTP':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SOFTWARE_TOKEN_MFA':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'SMS':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'SMS_MFA':
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 'NOMFA':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') return [
                            2 /*return*/ ,
                            Promise.resolve('No change for mfa type')
                        ];
                        else if (currentMFAType === 'SMS_MFA') smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === 'SMS_MFA') smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === 'SOFTWARE_TOKEN_MFA') totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        logger.debug('no validmfa method provided');
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    logger.debug('Set user mfa success', result);
                                    logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug('getting user data failed', err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function onFailure(err) {
                    logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function associateSecretCode(secretCode) {
                    logger.debug('associateSoftwareToken success', secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        logger.debug('verification totp token', user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === 'function') signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function onFailure(err) {
                    logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function onSuccess(data) {
                    if (!isLoggedIn) dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    dispatchAuthEvent('verify', user, "A user " + user.getUsername() + " has been verified");
                    logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function onSuccess(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    logger.debug('cannot get cognito credentials', e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    logger.debug('cannot get updated Cognito User', e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function onFailure(err) {
                    logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function onSuccess(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, 'session')
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug('succeed to get cognito credentials', cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    logger.debug('cannot get cognito credentials', e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function onFailure(err) {
                    logger.debug('completeNewPassword failure', err);
                    dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function mfaRequired(challengeName, challengeParam) {
                    logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function mfaSetup(challengeName, challengeParam) {
                    logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function totpRequired(challengeName, challengeParam) {
                    logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                logger.debug('Failed to get user from user pool');
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error('No current user.'))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                logger.debug('Failed to get the user session', err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        dispatchAuthEvent('userDeleted', result, 'The authenticated user has been deleted.');
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            logger.debug('failed to clear cached items');
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            dispatchAuthEvent('signOut', _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            logger.debug('no Congito User pool');
                                            rej(new Error('Cognito User pool does not exist'));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== 'sub' && key.indexOf('_verified') < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        dispatchAuthEvent('updateUserAttributes_failure', err, 'Failed to update attributes');
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        dispatchAuthEvent('updateUserAttributes', attrs, 'Attributes successfully updated');
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    AuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) verified['email'] = attrs['email'];
                else unverified['email'] = attrs['email'];
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) verified['phone_number'] = attrs['phone_number'];
                else unverified['phone_number'] = attrs['phone_number'];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return (typeof err === "undefined" ? "undefined" : (0, _typeOf._)(err)) === 'object' && Object.prototype.hasOwnProperty.call(err, 'message');
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Access Token has been revoked';
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Refresh Token has been revoked';
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'User is disabled.';
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'User does not exist.';
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Refresh Token has expired';
    };
    AuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === 'Password reset required for the user';
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                logger.debug('OAuth signIn in progress, waiting for resolution...');
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            logger.debug('OAuth signIn in progress timeout');
                                            (0, _core.Hub).remove('auth', hostedUISignCallback);
                                            res();
                                        }, OAUTH_FLOW_MS_TIMEOUT);
                                        (0, _core.Hub).listen('auth', hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === 'cognitoHostedUI' || event === 'cognitoHostedUI_failure') {
                                                logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, _core.Hub).remove('auth', hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    logger.debug('Failed to get user from user pool');
                                    rej('No current user');
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                if (scope.split(' ').includes(USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    logger.debug('getting user data failed', err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    logger.debug("Unable to get the user data because the " + USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) federatedUser = (0, _tslib.__assign)((0, _tslib.__assign)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        logger.debug('get current authenticated federated user', this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === 'No userPool') logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        logger.debug('The user is not authenticated by the error', e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error('No User Pool in the configuration.'));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    AuthClass.prototype._userSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            logger.debug('the user is null');
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, _auth.AuthErrorTypes).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                logger.debug('Failed to get the session from user', user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                logger.debug('Succeed to get the user session', session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        } catch (e) {
                            logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                logger.debug('getting session success', session);
                                return _this.Credentials.set(session, 'session');
                            }).catch(function() {
                                logger.debug('getting guest credentials');
                                return _this.Credentials.set(null, 'guest');
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function onSuccess(success) {
                    return resolve(success);
                },
                onFailure: function onFailure(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function onSuccess(data) {
                    resolve(data);
                    return;
                },
                onFailure: function onFailure(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug('failed to get the user session', err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function onSuccess(data) {
                                                                logger.debug('global sign out success');
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function onFailure(err) {
                                                                logger.debug('global sign out failed', err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    logger.debug('user sign out', user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, _core.browserOrNode)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error('Signout timeout fail'));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        if (opts === void 0) opts = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_12, e_13, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        logger.debug('failed to clear cached items');
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            11
                        ];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_13);
                        throw e_13;
                    case 7:
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 8:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        logger.debug('no current Cognito user');
                        _a.label = 10;
                    case 10:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        logger.debug('no Cognito User pool');
                        _a.label = 12;
                    case 12:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        logger.debug('change password failure', err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function onSuccess() {
                    resolve();
                    return;
                },
                onFailure: function onFailure(err) {
                    logger.debug('forgot password failure', err);
                    dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function inputVerificationCode(data) {
                    dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function onSuccess(success) {
                    dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function onFailure(err) {
                    dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_14, info, err_2, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_14 = _a.sent();
                        logger.debug('Failed to retrieve credentials while getting current user info', e_14);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        logger.error('currentUserInfo error', err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, _types.isFederatedSignInOptions)(providerOrOptions) || (0, _types.isFederatedSignInOptionsCustom)(providerOrOptions) || (0, _types.hasCustomState)(providerOrOptions) || typeof providerOrOptions === 'undefined')) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, _auth.CognitoHostedUIIdentityProvider).Cognito
                        };
                        provider = (0, _types.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, _types.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, 'federation')
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        logger.debug('federated sign in credentials', credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        dispatchAuthEvent('parsingCallbackUrl', {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, _core.browserOrNode)().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!((0, _url.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _$_b = (0, _tslib.__read)(_a, 1), k = _$_b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!((0, _url.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).find(function(_a) {
                            var _$_b = (0, _tslib.__read)(_a, 1), k = _$_b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, _amazonCognitoIdentityJs.CognitoUserSession)({
                            IdToken: new (0, _amazonCognitoIdentityJs.CognitoIdToken)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, _amazonCognitoIdentityJs.CognitoRefreshToken)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, _amazonCognitoIdentityJs.CognitoAccessToken)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, 'session')
                        ];
                    case 4:
                        credentials = _b.sent();
                        logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') window.history.replaceState(window.history.state, '', this._config.oauth.redirectSignIn);
                        dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split('-').splice(1).join('-');
                            dispatchAuthEvent('customOAuthState', (0, _core.urlSafeDecode)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        logger.debug('Error in cognito hosted auth response', err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== 'undefined') window.history.replaceState(window.history.state, '', this._config.oauth.redirectSignIn);
                        dispatchAuthEvent('signIn_failure', err_3, "The OAuth response flow failed");
                        dispatchAuthEvent('cognitoHostedUI_failure', err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        dispatchAuthEvent('customState_failure', err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === 'email_verified' || attribute.Name === 'phone_number_verified') obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === 'function' && value.toLowerCase() === 'true';
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, _amazonCognitoIdentityJs.CognitoUser)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === 'function' && typeof obj.setItem === 'function' && typeof obj.removeItem === 'function' && typeof obj.clear === 'function';
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, _auth.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, _auth.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, _errors.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, _errors.NoUserPoolError)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function onSuccess(data) {
                                        res(data);
                                    },
                                    onFailure: function onFailure(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject('The user is not authenticated')
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function onSuccess(data) {
                                        res(data);
                                    },
                                    onFailure: function onFailure(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_4);
                        throw new Error('The user is not authenticated');
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function onSuccess(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === 'device_name';
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function onFailure(err) {
                                        if (err.code === 'InvalidParameterException') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === 'NetworkError') rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices(MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var Auth = new AuthClass(null);
(0, _core.Amplify).register(Auth);

},{"@swc/helpers/_/_type_of":"668P4","tslib":"byrV7","./types":"17Pn9","@aws-amplify/core":"3rlh1","amazon-cognito-identity-js":"flUAS","amazon-cognito-identity-js/internals":"8XDsn","url":"7NJu4","./OAuth/OAuth":"1w9JI","./urlListener":"fh3I6","./Errors":"jFy1A","./types/Auth":"9VnfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byrV7":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17Pn9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("./Auth");
parcelHelpers.exportAll(_auth, exports);

},{"./Auth":"9VnfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9VnfC":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", function() {
    return CognitoHostedUIIdentityProvider;
});
parcelHelpers.export(exports, "isFederatedSignInOptions", function() {
    return isFederatedSignInOptions;
});
parcelHelpers.export(exports, "isFederatedSignInOptionsCustom", function() {
    return isFederatedSignInOptionsCustom;
});
parcelHelpers.export(exports, "hasCustomState", function() {
    return hasCustomState;
});
parcelHelpers.export(exports, "isCognitoHostedOpts", function() {
    return isCognitoHostedOpts;
});
parcelHelpers.export(exports, "AuthErrorTypes", function() {
    return AuthErrorTypes;
});
parcelHelpers.export(exports, "isUsernamePasswordOpts", function() {
    return isUsernamePasswordOpts;
});
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", function() {
    return GRAPHQL_AUTH_MODE;
});
var CognitoHostedUIIdentityProvider;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})(CognitoHostedUIIdentityProvider || (CognitoHostedUIIdentityProvider = {}));
function isFederatedSignInOptions(obj) {
    var keys = [
        'provider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isFederatedSignInOptionsCustom(obj) {
    var keys = [
        'customProvider'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function hasCustomState(obj) {
    var keys = [
        'customState'
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isCognitoHostedOpts(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var AuthErrorTypes;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
var GRAPHQL_AUTH_MODE;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})(GRAPHQL_AUTH_MODE || (GRAPHQL_AUTH_MODE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"flUAS":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticationDetails", function() {
    return 0, _authenticationDetailsDefault.default;
});
parcelHelpers.export(exports, "AuthenticationHelper", function() {
    return 0, _authenticationHelperDefault.default;
});
parcelHelpers.export(exports, "CognitoAccessToken", function() {
    return 0, _cognitoAccessTokenDefault.default;
});
parcelHelpers.export(exports, "CognitoIdToken", function() {
    return 0, _cognitoIdTokenDefault.default;
});
parcelHelpers.export(exports, "CognitoRefreshToken", function() {
    return 0, _cognitoRefreshTokenDefault.default;
});
parcelHelpers.export(exports, "CognitoUser", function() {
    return 0, _cognitoUserDefault.default;
});
parcelHelpers.export(exports, "CognitoUserAttribute", function() {
    return 0, _cognitoUserAttributeDefault.default;
});
parcelHelpers.export(exports, "CognitoUserPool", function() {
    return 0, _cognitoUserPoolDefault.default;
});
parcelHelpers.export(exports, "CognitoUserSession", function() {
    return 0, _cognitoUserSessionDefault.default;
});
parcelHelpers.export(exports, "CookieStorage", function() {
    return 0, _cookieStorageDefault.default;
});
parcelHelpers.export(exports, "DateHelper", function() {
    return 0, _dateHelperDefault.default;
});
parcelHelpers.export(exports, "appendToCognitoUserAgent", function() {
    return 0, _userAgent.appendToCognitoUserAgent;
});
parcelHelpers.export(exports, "WordArray", function() {
    return 0, _wordArrayDefault.default;
});
var _authenticationDetails = require("./AuthenticationDetails");
var _authenticationDetailsDefault = parcelHelpers.interopDefault(_authenticationDetails);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _cognitoUserPool = require("./CognitoUserPool");
var _cognitoUserPoolDefault = parcelHelpers.interopDefault(_cognitoUserPool);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _cookieStorage = require("./CookieStorage");
var _cookieStorageDefault = parcelHelpers.interopDefault(_cookieStorage);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _userAgent = require("./UserAgent");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);

},{"./AuthenticationDetails":"jW7Sm","./AuthenticationHelper":"R0j9n","./CognitoAccessToken":"l3zc9","./CognitoIdToken":"jfEAe","./CognitoRefreshToken":"kvOSC","./CognitoUser":"6zzEX","./CognitoUserAttribute":"87Ou2","./CognitoUserPool":"dQMFB","./CognitoUserSession":"5rwHR","./CookieStorage":"7vKGK","./DateHelper":"4be16","./UserAgent":"hfaDf","./utils/WordArray":"a561J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jW7Sm":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AuthenticationDetails;
});
var AuthenticationDetails = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"R0j9n":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AuthenticationHelper;
});
var _buffer = require("buffer");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);
var _sha256Js = require("@aws-crypto/sha256-js");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function randomBytes(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _wordArrayDefault.default)().random(nBytes).toString(), 'hex');
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */ var AuthenticationHelper = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, _bigIntegerDefault.default)(initN, 16);
        this.g = new (0, _bigIntegerDefault.default)('2', 16);
        this.k = new (0, _bigIntegerDefault.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, _buffer.Buffer).from('Caldera Derived Key', 'utf8');
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = randomBytes(128).toString('hex');
        var randomBigInt = new (0, _bigIntegerDefault.default)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return randomBytes(40).toString('base64');
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = randomBytes(16).toString('hex');
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, _bigIntegerDefault.default)(hexRandom, 16));
        this.g.modPow(new (0, _bigIntegerDefault.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, _bigIntegerDefault.default).ZERO)) callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, _bigIntegerDefault.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString('hex');
        return new Array(64 - hashHex.length).join('0') + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, _buffer.Buffer).from(hexStr, 'hex'));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, _buffer.Buffer).concat([
            this.infoBits,
            (0, _buffer.Buffer).from(String.fromCharCode(1), 'utf8')
        ]);
        var awsCryptoHash = new (0, _sha256Js.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, _sha256Js.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, _bigIntegerDefault.default).ZERO)) throw new Error('B cannot be zero.');
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, _bigIntegerDefault.default).ZERO)) throw new Error('U cannot be zero.');
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, _bigIntegerDefault.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, _buffer.Buffer).from(_this4.padHex(sValue), 'hex'), (0, _buffer.Buffer).from(_this4.padHex(_this4.UValue), 'hex'));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, _bigIntegerDefault.default))) throw new Error('Not a BigInteger');
        var isNegative = bigInt.compareTo((0, _bigIntegerDefault.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split('').map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return '0123456789ABCDEF'.charAt(invertedNibble);
            }).join('');
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, _bigIntegerDefault.default)(invertedNibbles, 16).add((0, _bigIntegerDefault.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith('FF8')) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

},{"buffer":"9YJhN","./utils/WordArray":"a561J","@aws-crypto/sha256-js":"1pg4I","./BigInteger":"du3Hf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9YJhN":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
'use strict';
var base64 = require("2eef3896765c9283");
var ieee754 = require("3f12005c1e1b81ab");
var isArray = require("4375d8445b71f5dc");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"2eef3896765c9283":"MlSYJ","3f12005c1e1b81ab":"15Xnl","4375d8445b71f5dc":"2AOfc"}],"2AOfc":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"a561J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return WordArray;
});
var _cryptoSecureRandomInt = require("./cryptoSecureRandomInt");
var _cryptoSecureRandomIntDefault = parcelHelpers.interopDefault(_cryptoSecureRandomInt);
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join('');
}
var WordArray = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, _cryptoSecureRandomIntDefault.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return hexStringify(this);
    };
    return WordArray;
}();

},{"./cryptoSecureRandomInt":"eXwu1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXwu1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cryptoSecureRandomInt;
});
var global = arguments[3];
var crypto;
// Native crypto from window (Browser)
if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!crypto && typeof global !== 'undefined' && global.crypto) crypto = global.crypto;
// Native crypto import via require (NodeJS)
if (!crypto && true) try {
    crypto = require("161b1906c5522933");
} catch (err) {}
function cryptoSecureRandomInt() {
    if (crypto) {
        // Use getRandomValues method (Browser)
        if (typeof crypto.getRandomValues === 'function') try {
            return crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof crypto.randomBytes === 'function') try {
            return crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error('Native crypto module could not be used to get secure random number.');
}

},{"161b1906c5522933":"ixEMk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ixEMk":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"du3Hf":[function(require,module,exports,__globalThis) {
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var inBrowser = typeof navigator !== 'undefined';
if (inBrowser && j_lm && navigator.appName == 'Microsoft Internet Explorer') {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != 'Netscape') {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var BI_RC = new Array();
var rr, vv;
rr = '0'.charCodeAt(0);
for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
rr = 'a'.charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
rr = 'A'.charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-') mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return '-' + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
    var km = (1 << k) - 1, d, m = false, r = '', i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : '0';
}
// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = nbi();
    var y = nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = nbv(1), z = new Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
    i = nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l3zc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoAccessToken;
});
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
/** @class */ var CognitoAccessToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || '') || this;
    }
    _inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    return CognitoAccessToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"jzaeI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzaeI":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoJwtToken;
});
var _buffer = require("buffer");
/** @class */ var CognitoJwtToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || '';
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split('.')[1];
        try {
            return JSON.parse((0, _buffer.Buffer).from(payload, 'base64').toString('utf8'));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

},{"buffer":"9YJhN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jfEAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoIdToken;
});
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
/** @class */ var CognitoIdToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || '') || this;
    }
    _inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    return CognitoIdToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"jzaeI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kvOSC":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoRefreshToken;
});
var CognitoRefreshToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || '';
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6zzEX":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoUser;
});
var _buffer = require("buffer");
var _sha256Js = require("@aws-crypto/sha256-js");
var _platform = require("./Platform");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var isNavigatorAvailable = typeof navigator !== 'undefined';
var userAgent = isNavigatorAvailable ? (0, _platform.Platform).isReactNative ? 'react-native' : navigator.userAgent : 'nodejs';
/** @class */ var CognitoUser = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error('Username and Pool information are required.');
        this.username = data.Username || '';
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = 'USER_SRP_AUTH';
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'CUSTOM_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('InitiateAuth', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === 'CUSTOM_CHALLENGE') {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error('Authentication flow type is invalid.'));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var dateHelper = new (0, _dateHelperDefault.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === 'CUSTOM_AUTH') authParameters.CHALLENGE_NAME = 'SRP_A';
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request('InitiateAuth', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this2.pool.getUserPoolName(), 'utf8'),
                        (0, _buffer.Buffer).from(_this2.username, 'utf8'),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, _buffer.Buffer).from(dateNow, 'utf8')
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString('base64');
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var _respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request('RespondToAuthChallenge', challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return _respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: 'PASSWORD_VERIFIER',
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    _respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error('PASSWORD parameter is required'));
            return;
        }
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === 'SMS_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'SELECT_MFA_TYPE') {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === 'MFA_SETUP') {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === 'CUSTOM_CHALLENGE') {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === 'DEVICE_SRP_AUTH') {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request('ConfirmDevice', {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error('New password is required.'));
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: 'NEW_PASSWORD_REQUIRED',
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.deviceGroupKey);
        var dateHelper = new (0, _dateHelperDefault.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: 'DEVICE_SRP_AUTH',
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this6.deviceGroupKey, 'utf8'),
                        (0, _buffer.Buffer).from(_this6.deviceKey, 'utf8'),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, 'base64'),
                        (0, _buffer.Buffer).from(dateNow, 'utf8')
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString('base64');
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request('RespondToAuthChallenge', jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmSignUp', jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: 'CUSTOM_CHALLENGE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || 'SMS_MFA';
        if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === 'DEVICE_SRP_AUTH') {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, _authenticationHelperDefault.default)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
                    PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request('ConfirmDevice', {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('ChangePassword', {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: 'SMS',
            AttributeName: 'phone_number'
        };
        mfaOptions.push(mfaEnabled);
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('SetUserMFAPreference', {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        var mfaOptions = [];
        this.client.request('SetUserSettings', {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, 'SUCCESS');
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error('User is not authenticated'), null);
        this.client.request('UpdateUserAttributes', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, 'SUCCESS', result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, _cognitoUserAttributeDefault.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest('GetUser', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error('User is not authenticated'), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error('User is not authenticated'), null);
        this.client.request('DeleteUserAttributes', {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, 'SUCCESS');
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request('ResendConfirmationCode', jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error('Username is null. Cannot retrieve a new session'), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, _cognitoIdTokenDefault.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, _cognitoAccessTokenDefault.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, _cognitoRefreshTokenDefault.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, _cognitoUserSessionDefault.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.requestWithRetry('InitiateAuth', jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === 'NotAuthorizedException') _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, _cognitoIdTokenDefault.default)(authResult);
        var accessToken = new (0, _cognitoAccessTokenDefault.default)(authResult);
        var refreshToken = new (0, _cognitoRefreshTokenDefault.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, _cognitoUserSessionDefault.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ForgotPassword', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('ConfirmForgotPassword', jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetUserAttributeVerificationCode', {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === 'function') return callback.inputVerificationCode(data);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('VerifyUserAttribute', {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('ForgetDevice', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('UpdateDeviceStatus', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: 'not_remembered'
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request('ListDevices', requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error('User is not authenticated'));
        this.client.request('GlobalSignOut', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess('SUCCESS');
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== 'function') {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== 'function') throw new Error('Invalid revokeTokenCallback. It should be a function.');
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error('User is not authenticated');
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error('No Access token available');
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === 'function') try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry('RevokeToken', {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: 'SELECT_MFA_TYPE',
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request('RespondToAuthChallenge', jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === 'SMS_MFA') return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === 'SOFTWARE_TOKEN_MFA') return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('AssociateSoftwareToken', {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request('AssociateSoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request('VerifySoftwareToken', {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: 'MFA_SETUP',
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request('RespondToAuthChallenge', jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request('VerifySoftwareToken', {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

},{"buffer":"9YJhN","@aws-crypto/sha256-js":"1pg4I","./Platform":"lbqS0","./BigInteger":"du3Hf","./AuthenticationHelper":"R0j9n","./CognitoAccessToken":"l3zc9","./CognitoIdToken":"jfEAe","./CognitoRefreshToken":"kvOSC","./CognitoUserSession":"5rwHR","./DateHelper":"4be16","./CognitoUserAttribute":"87Ou2","./StorageHelper":"lnJvp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lbqS0":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", function() {
    return Platform;
});
parcelHelpers.export(exports, "getUserAgent", function() {
    return getUserAgent;
});
var _version = require("./version");
var BASE_USER_AGENT = "aws-amplify/" + (0, _version.version);
var Platform = {
    userAgent: BASE_USER_AGENT,
    isReactNative: typeof navigator !== 'undefined' && navigator.product === 'ReactNative'
};
var getUserAgent = function getUserAgent() {
    return Platform.userAgent;
};
/**
 * @deprecated use named import
 */ exports.default = Platform;

},{"./version":"WZ3cM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"WZ3cM":[function(require,module,exports,__globalThis) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return version;
});
var version = '5.0.4';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rwHR":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoUserSession;
});
var CognitoUserSession = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error('Id token and Access Token must be present.');
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4be16":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return DateHelper;
});
var monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
var weekNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
/** @class */ var DateHelper = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = weekNames[now.getUTCDay()];
        var month = monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"87Ou2":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoUserAttribute;
});
var CognitoUserAttribute = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || '';
        this.Value = Value || '';
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lnJvp":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", function() {
    return MemoryStorage;
});
parcelHelpers.export(exports, "default", function() {
    return StorageHelper;
});
var dataMemory = {};
var MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var StorageHelper = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.cognito.test-ls', 1);
            this.storageWindow.removeItem('aws.cognito.test-ls');
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dQMFB":[function(require,module,exports,__globalThis) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CognitoUserPool;
});
var _client = require("./Client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
var USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var CognitoUserPool = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error('Both UserPoolId and ClientId are required.');
        if (UserPoolId.length > USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error('Invalid UserPoolId format.');
        var region = UserPoolId.split('_')[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, _clientDefault.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split('_')[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request('SignUp', jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, _cognitoUserDefault.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, _cognitoUserDefault.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

},{"./Client":"5xj9e","./CognitoUser":"6zzEX","./StorageHelper":"lnJvp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5xj9e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Client;
});
var _isomorphicUnfetch = require("isomorphic-unfetch");
var _userAgent = require("./UserAgent");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
var CognitoError = /*#__PURE__*/ function(_Error) {
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    _inheritsLoose(CognitoError, _Error);
    return CognitoError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/** @class */ var Client = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
            'X-Amz-User-Agent': (0, _userAgent.getAmplifyUserAgent)(),
            'Cache-Control': 'no-store'
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error('Network error');
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split('#').pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get('x-amzn-errortype')) try {
                var code = response.headers.get('x-amzn-errortype').split(':')[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === 'Network error') err.code = 'NetworkError';
            return callback(err);
        });
    };
    return Client;
}();
var logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var NonRetryableError = /*#__PURE__*/ function(_Error2) {
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    _inheritsLoose(NonRetryableError, _Error2);
    return NonRetryableError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
var isNonRetryableError = function isNonRetryableError(obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== 'function') throw Error('functionToRetry must be a function');
    logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        logger.debug("error on " + functionToRetry.name, err);
        if (isNonRetryableError(err)) {
            logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var MAX_DELAY_MS = 300000;
function jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
}

},{"isomorphic-unfetch":"cSe6x","./UserAgent":"hfaDf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hfaDf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendToCognitoUserAgent", function() {
    return appendToCognitoUserAgent;
});
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", function() {
    return addAuthCategoryToCognitoUserAgent;
});
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", function() {
    return addFrameworkToCognitoUserAgent;
});
parcelHelpers.export(exports, "getAmplifyUserAgent", function() {
    return getAmplifyUserAgent;
});
var _platform = require("./Platform");
var _constants = require("./Platform/constants");
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = (0, _platform.getUserAgent)();
var appendToCognitoUserAgent = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if (UserAgent.prototype.userAgent && !UserAgent.prototype.userAgent.includes(content)) UserAgent.prototype.userAgent = UserAgent.prototype.userAgent.concat(' ', content);
    if (!UserAgent.prototype.userAgent || UserAgent.prototype.userAgent === '') UserAgent.prototype.userAgent = content;
};
var addAuthCategoryToCognitoUserAgent = function addAuthCategoryToCognitoUserAgent() {
    UserAgent.category = (0, _constants.AUTH_CATEGORY);
};
var addFrameworkToCognitoUserAgent = function addFrameworkToCognitoUserAgent(framework) {
    UserAgent.framework = framework;
};
var getAmplifyUserAgent = function getAmplifyUserAgent(action) {
    var uaCategoryAction = UserAgent.category ? " " + UserAgent.category : '';
    var uaFramework = UserAgent.framework ? " framework/" + UserAgent.framework : '';
    var userAgent = "" + UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
// class for defining the amzn user-agent
exports.default = UserAgent;

},{"./Platform":"lbqS0","./Platform/constants":"hu7Sn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hu7Sn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FRAMEWORK", function() {
    return FRAMEWORK;
});
parcelHelpers.export(exports, "AUTH_CATEGORY", function() {
    return AUTH_CATEGORY;
});
var FRAMEWORK = {
    None: '0',
    ReactNative: '1'
};
var AUTH_CATEGORY = 'auth';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7vKGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CookieStorage;
});
var _jsCookie = require("js-cookie");
/** @class */ var CookieStorage = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = '/';
        if (Object.prototype.hasOwnProperty.call(data, 'expires')) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, 'secure')) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
            if (![
                'strict',
                'lax',
                'none'
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === 'none' && !this.secure) throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        _jsCookie.set(key, value, options);
        return _jsCookie.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return _jsCookie.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return _jsCookie.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = _jsCookie.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

},{"js-cookie":"7G5HO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7G5HO":[function(require,module,exports,__globalThis) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"8XDsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", function() {
    return 0, _userAgent.addAuthCategoryToCognitoUserAgent;
});
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", function() {
    return 0, _userAgent.addFrameworkToCognitoUserAgent;
});
var _userAgent = require("../UserAgent");

},{"../UserAgent":"hfaDf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7NJu4":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var punycode = require("6aa635927f16f681");
var util = require("3270586ce442e355");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
}, querystring = require("768fe205c74a17e8");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && util.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === "undefined" ? "undefined" : (0, _typeOf._)(url)));
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (util.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!util.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

},{"@swc/helpers/_/_type_of":"668P4","6aa635927f16f681":"b2VnN","3270586ce442e355":"7pKDA","768fe205c74a17e8":"2djPJ"}],"b2VnN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && (0, _typeOf._)(define.amd) == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(undefined);

},{"@swc/helpers/_/_type_of":"668P4"}],"7pKDA":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
module.exports = {
    isString: function isString(arg) {
        return typeof arg === 'string';
    },
    isObject: function isObject(arg) {
        return (typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)) === 'object' && arg !== null;
    },
    isNull: function isNull(arg) {
        return arg === null;
    },
    isNullOrUndefined: function isNullOrUndefined(arg) {
        return arg == null;
    }
};

},{"@swc/helpers/_/_type_of":"668P4"}],"2djPJ":[function(require,module,exports,__globalThis) {
'use strict';
exports.decode = exports.parse = require("636e0b84222e531a");
exports.encode = exports.stringify = require("8e17006a06cc4f8");

},{"636e0b84222e531a":"6Hf3W","8e17006a06cc4f8":"78b0p"}],"6Hf3W":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!hasOwnProperty(obj, k)) obj[k] = v;
        else if (isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],"78b0p":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var stringifyPrimitive = function stringifyPrimitive(v) {
    switch(typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object') return map(objectKeys(obj), function(k) {
        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
        if (isArray(obj[k])) return map(obj[k], function(v) {
            return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

},{"@swc/helpers/_/_type_of":"668P4"}],"1w9JI":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _url = require("url"); // Used for OAuth parsing of Cognito Hosted UI
var _urlOpener = require("./urlOpener");
var _oauthStorage = require("./oauthStorage");
var _buffer = require("buffer");
var _auth = require("../types/Auth");
var _core = require("@aws-amplify/core");
var _sha256Js = require("@aws-crypto/sha256-js");
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var dispatchAuthEvent = function dispatchAuthEvent(event, data, message) {
    (0, _core.Hub).dispatch('auth', {
        event: event,
        data: data,
        message: message
    }, 'Auth', AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)('OAuth');
var OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, _urlOpener.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === 'string';
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = 'code';
        if (provider === void 0) provider = (0, _auth.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, _core.urlSafeEncode)(customState) : generatedState;
        _oauthStorage.setState(state);
        var pkce_key = this._generateRandom(128);
        _oauthStorage.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries((0, _tslib.__assign)((0, _tslib.__assign)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === 'code' ? {
            code_challenge: code_challenge
        } : {}), responseType === 'code' ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, _url.parse)(currentUrl).query || '').split('&').map(function(pairings) {
                            return pairings.split('=');
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _$_c = (0, _tslib.__read)(_a, 2), k = _$_c[0], v = _$_c[1];
                            return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, _url.parse)(currentUrl).pathname || '/';
                        redirectSignInPathname = (0, _url.parse)(this._config.redirectSignIn).pathname || '/';
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = _oauthStorage.getPKCE();
                        oAuthTokenBody = (0, _tslib.__assign)({
                            grant_type: 'authorization_code',
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join('&');
                        customUserAgentDetails = {
                            category: (0, _core.Category).Auth,
                            action: (0, _core.AuthAction).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: (_b = {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }, _b[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, _tslib.__generator)(this, function(_b) {
                _a = ((0, _url.parse)(currentUrl).hash || '#').substr(1) // Remove # from returned code
                .split('&').map(function(pairings) {
                    return pairings.split('=');
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, _tslib.__assign)((0, _tslib.__assign)({}, ((0, _url.parse)(currentUrl).hash || '#').substr(1).split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, _url.parse)(currentUrl).query || '').split('&').map(function(entry) {
                            return entry.split('=');
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = _oauthStorage.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error('Invalid state in OAuth flow');
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, _tslib.__generator)(this, function(_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join('&');
                dispatchAuthEvent('oAuthSignOut', {
                    oAuth: 'signOut'
                }, "Signing out from " + oAuthLogoutEndpoint);
                logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString('base64');
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}();
exports.default = OAuth;

},{"tslib":"byrV7","url":"7NJu4","./urlOpener":"jAoxu","./oauthStorage":"9yxHU","buffer":"2MtSL","../types/Auth":"9VnfC","@aws-amplify/core":"3rlh1","@aws-crypto/sha256-js":"1pg4I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jAoxu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "launchUri", function() {
    return launchUri;
});
var SELF = '_self';
var launchUri = function launchUri(url) {
    var windowProxy = window.open(url, SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9yxHU":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setState", function() {
    return setState;
});
parcelHelpers.export(exports, "getState", function() {
    return getState;
});
parcelHelpers.export(exports, "setPKCE", function() {
    return setPKCE;
});
parcelHelpers.export(exports, "getPKCE", function() {
    return getPKCE;
});
parcelHelpers.export(exports, "clearAll", function() {
    return clearAll;
});
var setState = function setState(state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var getState = function getState() {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var setPKCE = function setPKCE(private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var getPKCE = function getPKCE() {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var clearAll = function clearAll() {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2MtSL":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
'use strict';
var base64 = require("cc9ef38945ca7514");
var ieee754 = require("2029602ab8d0f68");
var isArray = require("e1d6f34cfc72b474");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"cc9ef38945ca7514":"MlSYJ","2029602ab8d0f68":"15Xnl","e1d6f34cfc72b474":"54a0w"}],"54a0w":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"fh3I6":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
exports.default = function(callback) {
    if ((0, _core.browserOrNode)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, _core.browserOrNode)().isNode) ;
    else throw new Error('Not supported');
};

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jFy1A":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", function() {
    return AuthError;
});
parcelHelpers.export(exports, "NoUserPoolError", function() {
    return NoUserPoolError;
});
parcelHelpers.export(exports, "authErrorMessages", function() {
    return authErrorMessages;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _authErrorStrings = require("./common/AuthErrorStrings");
var logger = new (0, _core.ConsoleLogger)('AuthError');
var AuthError = /** @class */ function(_super) {
    (0, _tslib.__extends)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = authErrorMessages[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var NoUserPoolError = /** @class */ function(_super) {
    (0, _tslib.__extends)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}(AuthError);
var authErrorMessages = {
    noConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n\t\t\t\tRefer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, _authErrorStrings.AuthErrorStrings).SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object'
    },
    noMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEVICE_CONFIG
    },
    networkError: {
        message: (0, _authErrorStrings.AuthErrorStrings).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, _authErrorStrings.AuthErrorStrings).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG
    }
};

},{"tslib":"byrV7","@aws-amplify/core":"3rlh1","./common/AuthErrorStrings":"1aakP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1aakP":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthErrorStrings", function() {
    return AuthErrorStrings;
});
var AuthErrorStrings;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})(AuthErrorStrings || (AuthErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dt8H8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", function() {
    return 0, _providers.AWSS3Provider;
});
parcelHelpers.export(exports, "StorageClass", function() {
    return 0, _storage.Storage;
});
parcelHelpers.export(exports, "Storage", function() {
    return 0, _storage.StorageInstance;
});
var _storage = require("./Storage");
var _providers = require("./providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Storage":"bVIQD","./providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bVIQD":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Storage", function() {
    return Storage;
});
parcelHelpers.export(exports, "StorageInstance", function() {
    return StorageInstance;
});
var _core = require("@aws-amplify/core");
var _providers = require("./providers");
var _utils = require("./AwsClients/S3/utils");
var _awss3UploadTask = require("./providers/AWSS3UploadTask");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)('StorageClass');
var loggerStorageInstance = new (0, _core.ConsoleLogger)('Storage'); // Logging relating to Storage instance management
var DEFAULT_PROVIDER = 'AWSS3';
/**
 * Provide storage methods to use AWS S3
 */ var Storage = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._abortControllerMap = new WeakMap();
        logger.debug('Storage Options', this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return 'Storage';
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Storage') {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug('No plugin found with providerName', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        var _a;
        logger.debug('configure Storage');
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        var storageConfig = (_a = amplifyConfig.Storage) !== null && _a !== void 0 ? _a : {};
        var defaultProviderConfigKeys = [
            'bucket',
            'region',
            'level',
            'track',
            'customPrefix',
            'ContentMD5',
            'serverSideEncryption',
            'SSECustomerAlgorithm',
            'SSECustomerKey',
            // TODO(AllanZhengYP): remove in V6.
            'SSECustomerKeyMD5',
            'SSEKMSKeyId'
        ];
        var hasDefaultProviderConfigKeys = function hasDefaultProviderConfigKeys(config) {
            return Object.keys(config).find(function(key) {
                return defaultProviderConfigKeys.includes(key);
            });
        };
        if (hasDefaultProviderConfigKeys(storageConfig) && !storageConfig[DEFAULT_PROVIDER]) storageConfig[DEFAULT_PROVIDER] = {};
        Object.entries(storageConfig).forEach(function(_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (key && defaultProviderConfigKeys.includes(key) && value !== undefined) {
                storageConfig[DEFAULT_PROVIDER][key] = value;
                delete storageConfig[key];
            }
        });
        // only update new values for each provider
        Object.keys(storageConfig).forEach(function(providerName) {
            if (typeof storageConfig[providerName] !== 'string') _this._config[providerName] = __assign(__assign({}, _this._config[providerName]), storageConfig[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _providers.AWSS3Provider)());
        return this._config;
    };
    Storage.prototype.getAbortController = function() {
        return new AbortController();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, abortController) {
        this._abortControllerMap.set(request, abortController);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== 'undefined' && typeof x['pause'] === 'function' && typeof x['resume'] === 'function';
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, _awss3UploadTask.AWSS3UploadTask)) return request._cancel();
        var abortController = this._abortControllerMap.get(request);
        if (abortController) // TODO: [v6] clean up the aborted promise in the weak map.
        // Not doing it yet to avoid breaking changes when users may abort a request twice.
        abortController.abort(message);
        else logger.debug('The request does not map to any cancel token');
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var abortController = this.getAbortController();
        if (typeof plugin.copy !== 'function') return Promise.reject(".copy is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin.copy(src, dest, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var abortController = this.getAbortController();
        var responsePromise = plugin.get(key, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, _utils.isCancelError)(error);
    };
    Storage.prototype.getProperties = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            throw new Error('No plugin found with providerName');
        }
        var abortController = this.getAbortController();
        if (typeof plugin.getProperties !== 'function') return Promise.reject(".getProperties is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin === null || plugin === void 0 ? void 0 : plugin.getProperties(key, __assign({}, config));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        var abortController = this.getAbortController();
        var response = plugin.put(key, object, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, abortController);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        return plugin.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug('No plugin found with providerName', provider);
            return Promise.reject('No plugin found in Storage for the provider');
        }
        return plugin.list(path, config);
    };
    return Storage;
}();
/**
 * Configure & register Storage singleton instance.
 */ var _instance = null;
var getInstance = function getInstance() {
    if (_instance) return _instance;
    loggerStorageInstance.debug('Create Storage Instance, debug');
    _instance = new Storage();
    _instance.vault = new Storage();
    var old_configure = _instance.configure;
    _instance.configure = function(options) {
        loggerStorageInstance.debug('storage configure called');
        var vaultConfig = __assign({}, old_configure.call(_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== 'string') vaultConfig[providerName] = __assign(__assign({}, vaultConfig[providerName]), {
                level: 'private'
            });
        });
        loggerStorageInstance.debug('storage vault configure called');
        _instance.vault.configure(vaultConfig);
    };
    return _instance;
};
var StorageInstance = getInstance();
(0, _core.Amplify).register(StorageInstance);

},{"@aws-amplify/core":"3rlh1","./providers":"3XtUA","./AwsClients/S3/utils":"kSyt3","./providers/AWSS3UploadTask":"3YUiw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3XtUA":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", function() {
    return 0, _awss3Provider.AWSS3Provider;
});
var _awss3Provider = require("./AWSS3Provider");

},{"./AWSS3Provider":"lkzM9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lkzM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", function() {
    return AWSS3Provider;
});
var _typeOf = require("@swc/helpers/_/_type_of");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _storageErrorStrings = require("../common/StorageErrorStrings");
var _storageUtils = require("../common/StorageUtils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _awss3ProviderManagedUpload = require("./AWSS3ProviderManagedUpload");
var _awss3UploadTask = require("./AWSS3UploadTask");
var _storageConstants = require("../common/StorageConstants");
var _events = require("events");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.ConsoleLogger)('AWSS3Provider');
var DEFAULT_STORAGE_LEVEL = 'public';
var DEFAULT_PRESIGN_EXPIRATION = 900;
var AWSS3Provider = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, _core.StorageHelper)().getStorage();
        (0, _core.Hub).listen('auth', function(data) {
            var payload = data.payload;
            if (payload.event === 'signOut' || payload.event === 'signIn') _this._storage.removeItem((0, _storageConstants.UPLOADS_STORAGE_KEY));
        });
        logger.debug('Storage Options', this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        logger.debug('configure Storage', config);
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) logger.debug('Do not have bucket yet');
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var _a;
        var s3Config = addTaskInput.s3Config, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, track = (_a = config.track, _a === void 0 ? false : _a);
        if (!(file instanceof Blob)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).INVALID_BLOB);
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === 'function') progressCallback(event);
                else logger.warn('progressCallback should be a function, not a ' + (typeof progressCallback === "undefined" ? "undefined" : (0, _typeOf._)(progressCallback)));
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === 'function') completeCallback(event);
                else logger.warn('completeCallback should be a function, not a ' + (typeof completeCallback === "undefined" ? "undefined" : (0, _typeOf._)(completeCallback)));
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === 'function') errorCallback(err);
                else logger.warn('errorCallback should be a function, not a ' + (typeof errorCallback === "undefined" ? "undefined" : (0, _typeOf._)(errorCallback)));
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, _core.Credentials).get().then(function(credentials) {
            var cred = (0, _core.Credentials).shear(credentials);
            return (0, _s3ClientUtils.getPrefix)(__assign(__assign({}, config), {
                level: addTaskInput.accessLevel,
                credentials: cred
            }));
        });
        var task = new (0, _awss3UploadTask.AWSS3UploadTask)({
            s3Config: s3Config,
            file: file,
            emitter: emitter,
            level: addTaskInput.accessLevel,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, _storageUtils.dispatchStorageEvent)(track, 'upload', {
            method: 'put',
            result: 'success'
        }, null, "Upload Task created successfully for ".concat(key));
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, srcLevel, srcIdentityId, srcKey, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, error_1;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        srcLevel = (_a = src.level, _a === void 0 ? DEFAULT_STORAGE_LEVEL : _a), srcIdentityId = src.identityId, srcKey = src.key;
                        destLevel = (_b = dest.level, _b === void 0 ? DEFAULT_STORAGE_LEVEL : _b), destKey = dest.key;
                        if (!srcKey || typeof srcKey !== 'string') throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== 'string') throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_DEST_KEY);
                        if (srcLevel !== 'protected' && srcIdentityId) logger.warn("You may copy files from another user if the source level is \"protected\", currently it's ".concat(srcLevel));
                        srcPrefix = this._prefix(__assign(__assign(__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix(__assign(__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = "".concat(bucket, "/").concat(srcPrefix).concat(srcKey);
                        finalDestKey = "".concat(destPrefix).concat(destKey);
                        logger.debug("copying ".concat(finalSrcKey, " to ").concat(finalDestKey));
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: 'COPY'
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.copyObject)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).Copy
                            })), params)
                        ];
                    case 3:
                        _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'copy', {
                            method: 'copy',
                            result: 'success'
                        }, null, "Copy success from ".concat(srcKey, " to ").concat(destKey));
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'copy', {
                            method: 'copy',
                            result: 'failed'
                        }, null, "Copy failed from ".concat(srcKey, " to ").concat(destKey));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, validateObjectExistence, prefix, final_key, emitter, s3Config, params, response, error_2, error_3, url, _b, _c, error_4;
            var _d, _e;
            return __generator(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _f.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback, validateObjectExistence = (_d = opt.validateObjectExistence, _d === void 0 ? false : _d);
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new _events.EventEmitter();
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            emitter: emitter,
                            storageAction: (0, _core.StorageAction).Get
                        }));
                        logger.debug('get ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 2;
                    case 2:
                        _f.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === 'function') emitter.on((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT), function(progress) {
                                progressCallback(progress);
                            });
                            else logger.warn('progressCallback should be a function, not a ' + (typeof progressCallback === "undefined" ? "undefined" : (0, _typeOf._)(progressCallback)));
                        }
                        return [
                            4 /*yield*/ ,
                            (0, _s3.getObject)(s3Config, params)
                        ];
                    case 3:
                        response = _f.sent();
                        emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
                        (0, _storageUtils.dispatchStorageEvent)(track, 'download', {
                            method: 'get',
                            result: 'success'
                        }, {
                            fileSize: Number(response.Body['size'] || response.Body['length'])
                        }, "Download success for ".concat(key));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'download', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Download failed with ".concat(error_2.message));
                        throw error_2;
                    case 5:
                        if (!validateObjectExistence) return [
                            3 /*break*/ ,
                            9
                        ];
                        _f.label = 6;
                    case 6:
                        _f.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 7:
                        _f.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_3 = _f.sent();
                        if (((_a = error_3.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "".concat(key, " not found"));
                        throw error_3;
                    case 9:
                        _f.trys.push([
                            9,
                            12,
                            ,
                            13
                        ]);
                        _b = (0, _s3.getPresignedGetObjectUrl);
                        _c = [
                            __assign({}, s3Config)
                        ];
                        _e = {
                            expiration: expires || DEFAULT_PRESIGN_EXPIRATION
                        };
                        return [
                            4 /*yield*/ ,
                            s3Config.credentials()
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, [
                                __assign.apply(void 0, _c.concat([
                                    (_e.credentials = _f.sent(), _e.signingRegion = s3Config.region, _e.signingService = (0, _s3.SERVICE_NAME), _e)
                                ])),
                                params
                            ])
                        ];
                    case 11:
                        url = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'success'
                        }, null, "Signed URL: ".concat(url));
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 12:
                        error_4 = _f.sent();
                        logger.warn('get signed url error', error_4);
                        (0, _storageUtils.dispatchStorageEvent)(track, 'getSignedUrl', {
                            method: 'get',
                            result: 'failed'
                        }, null, "Could not get a signed URL for ".concat(key));
                        throw error_4;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Properties of the object
     *
     * @param {string} key - key of the object
     * @param {S3ProviderGetPropertiesConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderGetPropertiesOutput>} - A promise resolves to contentType,
     * contentLength, eTag, lastModified, metadata
     */ AWSS3Provider.prototype.getProperties = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, prefix, final_key, s3Config, params, response, getPropertiesResponse, error_5;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = (_b = opt.track, _b === void 0 ? false : _b), SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug("getProperties ".concat(key, " from ").concat(final_key));
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).GetProperties
                        }));
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 3:
                        response = _c.sent();
                        getPropertiesResponse = {
                            contentLength: response.ContentLength,
                            contentType: response.ContentType,
                            eTag: response.ETag,
                            lastModified: response.LastModified,
                            metadata: response.Metadata
                        };
                        (0, _storageUtils.dispatchStorageEvent)(track, 'getProperties', {
                            method: 'getProperties',
                            result: 'success'
                        }, null, "getProperties successful for ".concat(key));
                        return [
                            2 /*return*/ ,
                            getPropertiesResponse
                        ];
                    case 4:
                        error_5 = _c.sent();
                        if (((_a = error_5.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, 'getProperties', {
                            method: 'getProperties',
                            result: 'failed'
                        }, null, "".concat(key, " not found"));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : 'binary/octet-stream';
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new _events.EventEmitter();
        var uploader = new (0, _awss3ProviderManagedUpload.AWSS3ProviderManagedUpload)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                storageAction: (0, _core.StorageAction).Put
            }));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Config: s3Config,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === 'function') emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
                    progressCallback(progress);
                });
                else logger.warn('progressCallback should be a function, not a ' + (typeof progressCallback === "undefined" ? "undefined" : (0, _typeOf._)(progressCallback)));
            }
            return uploader.upload().then(function(response) {
                logger.debug('upload result', response);
                (0, _storageUtils.dispatchStorageEvent)(track, 'upload', {
                    method: 'put',
                    result: 'success'
                }, null, "Upload success for ".concat(key));
                return {
                    key: key
                };
            });
        } catch (error) {
            logger.warn('error uploading', error);
            (0, _storageUtils.dispatchStorageEvent)(track, 'upload', {
                method: 'put',
                result: 'failed'
            }, null, "Error uploading ".concat(key));
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, params, s3Config, response, error_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug('remove ' + key + ' from ' + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).Remove
                        }));
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.deleteObject)(s3Config, params)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'delete', {
                            method: 'remove',
                            result: 'success'
                        }, null, "Deleted ".concat(key, " successfully"));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_6 = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, 'delete', {
                            method: 'remove',
                            result: 'failed'
                        }, null, "Deletion of ".concat(key, " failed with ").concat(error_6));
                        throw error_6;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return __awaiter(this, void 0, void 0, function() {
            var list, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).List
                            })), __assign({}, params))
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            list.results = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            list.nextToken = response.NextContinuationToken;
                            list.hasNextToken = response.IsTruncated;
                        }
                        return [
                            2 /*return*/ ,
                            list
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified
     * and file size for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, pageSize, nextToken, prefix, final_path, list, MAX_PAGE_SIZE, listResult, params, error_7;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, pageSize = opt.pageSize, nextToken = opt.nextToken;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        logger.debug('list ' + path + ' from ' + final_path);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        MAX_PAGE_SIZE = 1000;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: MAX_PAGE_SIZE,
                            ContinuationToken: nextToken
                        };
                        params.ContinuationToken = nextToken;
                        if (!(pageSize === 'ALL')) return [
                            3 /*break*/ ,
                            7
                        ];
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _c.sent();
                        (_a = list.results).push.apply(_a, __spreadArray([], __read(listResult.results), false));
                        if (listResult.nextToken) params.ContinuationToken = listResult.nextToken;
                        _c.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _c.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        if (pageSize && pageSize <= MAX_PAGE_SIZE && typeof pageSize === 'number') params.MaxKeys = pageSize;
                        else logger.warn("pageSize should be from 0 - ".concat(MAX_PAGE_SIZE, "."));
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _c.sent();
                        (_b = list.results).push.apply(_b, __spreadArray([], __read(listResult.results), false));
                        list.hasNextToken = listResult.hasNextToken;
                        list.nextToken = (0, listResult.nextToken);
                        _c.label = 9;
                    case 9:
                        (0, _storageUtils.dispatchStorageEvent)(track, 'list', {
                            method: 'list',
                            result: 'success'
                        }, null, "".concat(list.results.length, " items returned from list operation"));
                        logger.debug('list', list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_7 = _c.sent();
                        logger.error('list InvalidArgument', error_7);
                        (0, _storageUtils.dispatchStorageEvent)(track, 'list', {
                            method: 'list',
                            result: 'failed'
                        }, null, "Listing items failed: ".concat(error_7.message));
                        throw error_7;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_8;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug('set credentials for storage', cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_8 = _a.sent();
                        logger.warn('ensure credentials error', error_8);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return (typeof config === "undefined" ? "undefined" : (0, _typeOf._)(config)) === 'object' && config.hasOwnProperty('credentials');
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : 'private/') + identityId + '/';
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : 'protected/') + identityId + '/';
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : 'public/';
        switch(level){
            case 'private':
                return privatePath;
            case 'protected':
                return protectedPath;
            default:
                return publicPath;
        }
    };
    AWSS3Provider.CATEGORY = 'Storage';
    AWSS3Provider.PROVIDER_NAME = 'AWSS3';
    return AWSS3Provider;
}();

},{"@swc/helpers/_/_type_of":"668P4","@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","../common/StorageErrorStrings":"5FJDR","../common/StorageUtils":"2VK2g","../common/S3ClientUtils":"iu1YF","./AWSS3ProviderManagedUpload":"6BvX7","./AWSS3UploadTask":"3YUiw","../common/StorageConstants":"34577","events":"dar5h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8H3Qf":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", function() {
    return 0, _base.SERVICE_NAME;
});
parcelHelpers.export(exports, "getObject", function() {
    return 0, _getObject.getObject;
});
parcelHelpers.export(exports, "getPresignedGetObjectUrl", function() {
    return 0, _getObject.getPresignedGetObjectUrl;
});
parcelHelpers.export(exports, "listObjectsV2", function() {
    return 0, _listObjectsV2.listObjectsV2;
});
parcelHelpers.export(exports, "putObject", function() {
    return 0, _putObject.putObject;
});
parcelHelpers.export(exports, "createMultipartUpload", function() {
    return 0, _createMultipartUpload.createMultipartUpload;
});
parcelHelpers.export(exports, "uploadPart", function() {
    return 0, _uploadPart.uploadPart;
});
parcelHelpers.export(exports, "completeMultipartUpload", function() {
    return 0, _completeMultipartUpload.completeMultipartUpload;
});
parcelHelpers.export(exports, "listParts", function() {
    return 0, _listParts.listParts;
});
parcelHelpers.export(exports, "abortMultipartUpload", function() {
    return 0, _abortMultipartUpload.abortMultipartUpload;
});
parcelHelpers.export(exports, "copyObject", function() {
    return 0, _copyObject.copyObject;
});
parcelHelpers.export(exports, "headObject", function() {
    return 0, _headObject.headObject;
});
parcelHelpers.export(exports, "deleteObject", function() {
    return 0, _deleteObject.deleteObject;
});
var _base = require("./base");
var _getObject = require("./getObject");
var _listObjectsV2 = require("./listObjectsV2");
var _putObject = require("./putObject");
var _createMultipartUpload = require("./createMultipartUpload");
var _uploadPart = require("./uploadPart");
var _completeMultipartUpload = require("./completeMultipartUpload");
var _listParts = require("./listParts");
var _abortMultipartUpload = require("./abortMultipartUpload");
var _copyObject = require("./copyObject");
var _headObject = require("./headObject");
var _deleteObject = require("./deleteObject");

},{"./base":"5CQ3l","./getObject":"jm2cc","./listObjectsV2":"5tZz8","./putObject":"28JPR","./createMultipartUpload":"40v7G","./uploadPart":"hY7Iz","./completeMultipartUpload":"cP4XE","./listParts":"jAX3y","./abortMultipartUpload":"3NnE9","./copyObject":"dpqr0","./headObject":"cwNBH","./deleteObject":"cUAyH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5CQ3l":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", function() {
    return SERVICE_NAME;
});
parcelHelpers.export(exports, "isDnsCompatibleBucketName", function() {
    return isDnsCompatibleBucketName;
});
parcelHelpers.export(exports, "defaultConfig", function() {
    return defaultConfig;
});
var _core = require("@aws-amplify/core");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("./utils");
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var SERVICE_NAME = 's3';
/**
 * The endpoint resolver function that returns the endpoint URL for a given region, and input parameters.
 */ var endpointResolver = function endpointResolver(options, apiInput) {
    var region = options.region, useAccelerateEndpoint = options.useAccelerateEndpoint, customEndpoint = options.customEndpoint, forcePathStyle = options.forcePathStyle;
    var endpoint;
    // 1. get base endpoint
    if (customEndpoint) endpoint = new URL(customEndpoint);
    else if (useAccelerateEndpoint) {
        if (forcePathStyle) throw new Error('Path style URLs are not supported with S3 Transfer Acceleration.');
        endpoint = new URL("https://s3-accelerate.".concat((0, _awsClientUtils.getDnsSuffix)(region)));
    } else endpoint = new URL("https://s3.".concat(region, ".").concat((0, _awsClientUtils.getDnsSuffix)(region)));
    // 2. inject bucket name
    if (apiInput === null || apiInput === void 0 ? void 0 : apiInput.Bucket) {
        if (!isDnsCompatibleBucketName(apiInput.Bucket)) throw new Error("Invalid bucket name: \"".concat(apiInput.Bucket, "\"."));
        if (forcePathStyle || apiInput.Bucket.includes('.')) endpoint.pathname = "/".concat(apiInput.Bucket);
        else endpoint.host = "".concat(apiInput.Bucket, ".").concat(endpoint.host);
    }
    return {
        url: endpoint
    };
};
var isDnsCompatibleBucketName = function isDnsCompatibleBucketName(bucketName) {
    return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _awsClientUtils.getRetryDecider)((0, _utils.parseXmlError)),
    computeDelay: (0, _awsClientUtils.jitteredBackoff),
    userAgentValue: (0, _core.getAmplifyUserAgent)(),
    useAccelerateEndpoint: false,
    uriEscapePath: false
};

},{"@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-client-utils":"cD43M","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kSyt3":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlBody", function() {
    return 0, _parsePayload.parseXmlBody;
});
parcelHelpers.export(exports, "parseXmlError", function() {
    return 0, _parsePayload.parseXmlError;
});
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", function() {
    return 0, _runtime.SEND_DOWNLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", function() {
    return 0, _runtime.SEND_UPLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "s3TransferHandler", function() {
    return 0, _runtime.s3TransferHandler;
});
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", function() {
    return 0, _runtime.CANCELED_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "isCancelError", function() {
    return 0, _runtime.isCancelError;
});
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", function() {
    return 0, _runtime.CONTENT_SHA256_HEADER;
});
parcelHelpers.export(exports, "deserializeBoolean", function() {
    return 0, _deserializeHelpers.deserializeBoolean;
});
parcelHelpers.export(exports, "deserializeMetadata", function() {
    return 0, _deserializeHelpers.deserializeMetadata;
});
parcelHelpers.export(exports, "deserializeNumber", function() {
    return 0, _deserializeHelpers.deserializeNumber;
});
parcelHelpers.export(exports, "deserializeTimestamp", function() {
    return 0, _deserializeHelpers.deserializeTimestamp;
});
parcelHelpers.export(exports, "emptyArrayGuard", function() {
    return 0, _deserializeHelpers.emptyArrayGuard;
});
parcelHelpers.export(exports, "map", function() {
    return 0, _deserializeHelpers.map;
});
parcelHelpers.export(exports, "assignStringVariables", function() {
    return 0, _serializeHelpers.assignStringVariables;
});
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", function() {
    return 0, _serializeHelpers.serializeObjectConfigsToHeaders;
});
parcelHelpers.export(exports, "serializePathnameObjectKey", function() {
    return 0, _serializeHelpers.serializePathnameObjectKey;
});
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", function() {
    return 0, _serializeHelpers.serializeObjectSsecOptionsToHeaders;
});
parcelHelpers.export(exports, "toBase64", function() {
    return 0, _runtime.toBase64;
});
parcelHelpers.export(exports, "utf8Encode", function() {
    return 0, _runtime.utf8Encode;
});
var _parsePayload = require("./parsePayload");
var _runtime = require("../runtime");
var _deserializeHelpers = require("./deserializeHelpers");
var _serializeHelpers = require("./serializeHelpers");

},{"./parsePayload":"6LB8T","../runtime":"d4Suo","./deserializeHelpers":"JQAKY","./serializeHelpers":"gNA5n","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6LB8T":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlError", function() {
    return parseXmlError;
});
parcelHelpers.export(exports, "parseXmlBody", function() {
    return parseXmlBody;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _runtime = require("../runtime");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var parseXmlError = function parseXmlError(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var statusCode, body, code, message, error;
        var _a, _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    statusCode = response.statusCode;
                    return [
                        4 /*yield*/ ,
                        parseXmlBody(response)
                    ];
                case 1:
                    body = _c.sent();
                    code = (body === null || body === void 0 ? void 0 : body['Code']) ? body.Code : statusCode === 404 ? 'NotFound' : statusCode.toString();
                    message = (_b = (_a = body === null || body === void 0 ? void 0 : body['message']) !== null && _a !== void 0 ? _a : body === null || body === void 0 ? void 0 : body['Message']) !== null && _b !== void 0 ? _b : code;
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseXmlBody = function parseXmlBody(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var data;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) // S3 can return 200 without a body indicating failure.
                    throw new Error('S3 aborted request.');
                    return [
                        4 /*yield*/ ,
                        response.body.text()
                    ];
                case 1:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) try {
                        return [
                            2 /*return*/ ,
                            (0, _runtime.parser).parse(data)
                        ];
                    } catch (error) {
                        throw new Error('Failed to parse XML response.');
                    }
                    return [
                        2 /*return*/ ,
                        {}
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","../runtime":"d4Suo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4Suo":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Entry point for browser-specific S3 client utilities. It's used where DOMParser is available.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", function() {
    return 0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", function() {
    return 0, _constants.SEND_UPLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", function() {
    return 0, _constants.CANCELED_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", function() {
    return 0, _constants.CONTENT_SHA256_HEADER;
});
parcelHelpers.export(exports, "s3TransferHandler", function() {
    return 0, _xhr.s3TransferHandler;
});
parcelHelpers.export(exports, "parser", function() {
    return 0, _dom.parser;
});
parcelHelpers.export(exports, "isCancelError", function() {
    return 0, _xhrTransferHandler.isCancelError;
});
parcelHelpers.export(exports, "toBase64", function() {
    return 0, _indexBrowser.toBase64;
});
parcelHelpers.export(exports, "utf8Encode", function() {
    return 0, _indexBrowser.utf8Encode;
});
var _constants = require("./constants");
var _xhr = require("./s3TransferHandler/xhr");
var _dom = require("./xmlParser/dom");
var _xhrTransferHandler = require("./xhrTransferHandler");
var _indexBrowser = require("./base64/index.browser");

},{"./constants":"3LpYx","./s3TransferHandler/xhr":"gVp0P","./xmlParser/dom":"hRe9F","./xhrTransferHandler":"iOmPL","./base64/index.browser":"iE3B9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LpYx":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", function() {
    return SEND_UPLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", function() {
    return SEND_DOWNLOAD_PROGRESS_EVENT;
});
parcelHelpers.export(exports, "NETWORK_ERROR_MESSAGE", function() {
    return NETWORK_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "NETWORK_ERROR_CODE", function() {
    return NETWORK_ERROR_CODE;
});
parcelHelpers.export(exports, "ABORT_ERROR_MESSAGE", function() {
    return ABORT_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "ABORT_ERROR_CODE", function() {
    return ABORT_ERROR_CODE;
});
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", function() {
    return CANCELED_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "CANCELED_ERROR_CODE", function() {
    return CANCELED_ERROR_CODE;
});
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", function() {
    return CONTENT_SHA256_HEADER;
});
var SEND_UPLOAD_PROGRESS_EVENT = 'sendUploadProgress';
var SEND_DOWNLOAD_PROGRESS_EVENT = 'sendDownloadProgress';
var NETWORK_ERROR_MESSAGE = 'Network Error';
var NETWORK_ERROR_CODE = 'ECONNABORTED';
var ABORT_ERROR_MESSAGE = 'Request aborted';
var ABORT_ERROR_CODE = 'ERR_ABORTED';
var CANCELED_ERROR_MESSAGE = 'canceled';
var CANCELED_ERROR_CODE = 'ERR_CANCELED';
var CONTENT_SHA256_HEADER = 'x-amz-content-sha256';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gVp0P":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s3TransferHandler", function() {
    return s3TransferHandler;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _contentSha256Middleware = require("../contentSha256middleware");
var _xhrTransferHandler = require("../xhrTransferHandler");
var s3TransferHandler = (0, _composers.composeTransferHandler)((0, _xhrTransferHandler.xhrTransferHandler), [
    (0, _contentSha256Middleware.contentSha256Middleware),
    (0, _awsClientUtils.userAgentMiddleware),
    (0, _awsClientUtils.retryMiddleware),
    (0, _awsClientUtils.signingMiddleware)
]);

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","../contentSha256middleware":"9oaKA","../xhrTransferHandler":"iOmPL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9oaKA":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentSha256Middleware", function() {
    return contentSha256Middleware;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _constants = require("./constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var contentSha256Middleware = function contentSha256Middleware(options) {
    return function(next) {
        return function contentSha256Middleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var hash;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!request.headers[0, _constants.CONTENT_SHA256_HEADER]) return [
                                3 /*break*/ ,
                                1
                            ];
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _awsClientUtils.getHashedPayload)(request.body)
                            ];
                        case 2:
                            hash = _a.sent();
                            request.headers[0, _constants.CONTENT_SHA256_HEADER] = hash;
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                    }
                });
            });
        };
    };
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","./constants":"3LpYx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iOmPL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhrTransferHandler", function() {
    return xhrTransferHandler;
});
parcelHelpers.export(exports, "isCancelError", function() {
    return isCancelError;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _core = require("@aws-amplify/core");
var _constants = require("./constants");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)('xhr-http-handler');
var xhrTransferHandler = function xhrTransferHandler(request, options) {
    var url = request.url, method = request.method, headers = request.headers, body = request.body;
    var emitter = options.emitter, responseType = options.responseType, abortSignal = options.abortSignal;
    return new Promise(function(resolve, reject) {
        var _a;
        var xhr = new XMLHttpRequest();
        xhr.open(method.toUpperCase(), url.toString());
        Object.entries(headers).filter(function(_a) {
            var _b = __read(_a, 1), header = _b[0];
            return !FORBIDDEN_HEADERS.includes(header);
        }).forEach(function(_a) {
            var _b = __read(_a, 2), header = _b[0], value = _b[1];
            xhr.setRequestHeader(header, value);
        });
        xhr.responseType = responseType;
        if (emitter) {
            xhr.upload.addEventListener('progress', function(event) {
                emitter.emit((0, _constants.SEND_UPLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
            xhr.addEventListener('progress', function(event) {
                emitter.emit((0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
        }
        xhr.addEventListener('error', function() {
            var error = simulateAxiosError((0, _constants.NETWORK_ERROR_MESSAGE), (0, _constants.NETWORK_ERROR_CODE), xhr, options);
            logger.error((0, _constants.NETWORK_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Handle browser request cancellation (as opposed to a manual cancellation)
        xhr.addEventListener('abort', function() {
            // The abort event can be triggered after the error or load event. So we need to check if the xhr is null.
            if (!xhr || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted)) return;
            var error = simulateAxiosError((0, _constants.ABORT_ERROR_MESSAGE), (0, _constants.ABORT_ERROR_CODE), xhr, options);
            logger.error((0, _constants.ABORT_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Skip handling timeout error since we don't have a timeout
        xhr.addEventListener('readystatechange', function() {
            if (!xhr || xhr.readyState !== xhr.DONE) return;
            var onloadend = function onloadend() {
                // The load event is triggered after the error/abort/load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var responseHeaders = convertResponseHeaders(xhr.getAllResponseHeaders());
                var responseType = xhr.responseType;
                var responseBlob = xhr.response;
                var responseText = responseType === 'text' ? xhr.responseText : '';
                var bodyMixIn = {
                    blob: function blob() {
                        return Promise.resolve(responseBlob);
                    },
                    text: (0, _awsClientUtils.withMemoization)(function() {
                        return responseType === 'blob' ? readBlobAsText(responseBlob) : Promise.resolve(responseText);
                    }),
                    json: function json() {
                        return Promise.reject(// S3 does not support JSON response. So fail-fast here with nicer error message.
                        new Error('Parsing response to JSON is not implemented. Please use response.text() instead.'));
                    }
                };
                var response = {
                    statusCode: xhr.status,
                    headers: responseHeaders,
                    // The xhr.responseType is only set to 'blob' for streaming binary S3 object data. The streaming data is
                    // exposed via public interface of Storage.get(). So we need to return the response as a Blob object for
                    // backward compatibility. In other cases, the response payload is only used internally, we return it is
                    // {@link ResponseBodyMixin}
                    body: xhr.responseType === 'blob' ? Object.assign(responseBlob, bodyMixIn) : bodyMixIn
                };
                resolve(response);
                xhr = null; // clean up request
            };
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            // @see https://github.com/axios/axios/blob/9588fcdec8aca45c3ba2f7968988a5d03f23168c/lib/adapters/xhr.js#L98-L99
            setTimeout(onloadend);
        });
        if (abortSignal) {
            var onCancelled = function onCancelled() {
                // The abort event is triggered after the error or load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var canceledError = simulateAxiosCanceledError((0, _constants.CANCELED_ERROR_MESSAGE) !== null && (0, _constants.CANCELED_ERROR_MESSAGE) !== void 0 ? (0, _constants.CANCELED_ERROR_MESSAGE) : abortSignal.reason, (0, _constants.CANCELED_ERROR_CODE), xhr, options);
                xhr.abort();
                reject(canceledError);
                xhr = null;
            };
            abortSignal.aborted ? onCancelled() : abortSignal.addEventListener('abort', onCancelled);
        }
        if (typeof ReadableStream === 'function' && body instanceof ReadableStream) // This does not matter as previous implementation uses Axios which does not support ReadableStream anyway.
        throw new Error('ReadableStream request payload is not supported.');
        xhr.send((_a = body) !== null && _a !== void 0 ? _a : null);
    });
};
// TODO: V6 remove this
var simulateAxiosError = function simulateAxiosError(message, code, request, config) {
    return Object.assign(new Error(message), {
        code: code,
        config: config,
        request: request
    });
};
var simulateAxiosCanceledError = function simulateAxiosCanceledError(message, code, request, config) {
    var error = simulateAxiosError(message, code, request, config);
    error.name = 'CanceledError';
    error['__CANCEL__'] = true;
    return error;
};
var isCancelError = function isCancelError(error) {
    return !!(error === null || error === void 0 ? void 0 : error['__CANCEL__']);
};
/**
 * Convert xhr.getAllResponseHeaders() string to a Record<string, string>. Note that modern browser already returns
 * header names in lowercase.
 * @param xhrHeaders - string of headers returned from xhr.getAllResponseHeaders()
 */ var convertResponseHeaders = function convertResponseHeaders(xhrHeaders) {
    if (!xhrHeaders) return {};
    return xhrHeaders.split('\r\n').reduce(function(headerMap, line) {
        var parts = line.split(': ');
        var header = parts.shift();
        var value = parts.join(': ');
        headerMap[header.toLowerCase()] = value;
        return headerMap;
    }, {});
};
var readBlobAsText = function readBlobAsText(blob) {
    var reader = new FileReader();
    return new Promise(function(resolve, reject) {
        reader.onloadend = function() {
            if (reader.readyState !== FileReader.DONE) return;
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
        reader.readAsText(blob);
    });
};
// To add more forbidden headers as found set by S3. Intentionally NOT list all of them here to save bundle size.
// https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
var FORBIDDEN_HEADERS = [
    'host'
];

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core":"3rlh1","./constants":"3LpYx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hRe9F":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Drop-in replacement for fast-xml-parser's XmlParser class used in the AWS SDK S3 client XML deserializer. This
 * implementation is not tested against the full xml conformance test suite. It is only tested against the XML responses
 * from S3. This implementation requires the `DOMParser` class in the runtime.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", function() {
    return parser;
});
var parser = {
    parse: function parse(xmlStr) {
        var domParser = new DOMParser();
        var xml = domParser.parseFromString(xmlStr, 'text/xml');
        var parsedObj = parseXmlNode(xml);
        var rootKey = Object.keys(parsedObj)[0];
        return parsedObj[rootKey];
    }
};
var parseXmlNode = function parseXmlNode1(node) {
    var _a;
    var _b, _c;
    if (isDocumentNode(node)) return _a = {}, _a[node.documentElement.nodeName] = parseXmlNode(node.documentElement), _a;
    if (node.nodeType === Node.TEXT_NODE) return (_b = node.nodeValue) === null || _b === void 0 ? void 0 : _b.trim();
    if (isElementNode(node)) {
        // Node like <Location>foo</Location> will be converted to { Location: 'foo' }
        // instead of { Location: { '#text': 'foo' } }.
        if (isTextOnlyElementNode(node)) return (_c = node.childNodes[0]) === null || _c === void 0 ? void 0 : _c.nodeValue;
        var nodeValue = {};
        // convert attributes
        for(var i = 0; i < node.attributes.length; i++){
            var attr = node.attributes[i];
            if (!isNamespaceAttributeName(attr.nodeName)) nodeValue[attr.nodeName] = attr.nodeValue;
        }
        // convert child nodes
        if (node.children.length > 0) for(var i = 0; i < node.children.length; i++){
            var child = node.children[i];
            var childValue = parseXmlNode(child);
            if (childValue === undefined) continue;
            var childName = child.nodeName;
            if (nodeValue[childName] === undefined) nodeValue[childName] = childValue;
            else if (Array.isArray(nodeValue[childName])) nodeValue[childName].push(childValue);
            else nodeValue[childName] = [
                nodeValue[childName],
                childValue
            ];
        }
        // Return empty element node as empty string instead of `{}`, which is the default behavior of fast-xml-parser.
        return Object.keys(nodeValue).length === 0 ? '' : nodeValue;
    }
};
var isElementNode = function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
};
var isDocumentNode = function isDocumentNode(node) {
    return node.nodeType === Node.DOCUMENT_NODE;
};
var isTextOnlyElementNode = function isTextOnlyElementNode(node) {
    var _a;
    return hasOnlyNamespaceAttributes(node) && node.children.length === 0 && ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.nodeType) === Node.TEXT_NODE;
};
var hasOnlyNamespaceAttributes = function hasOnlyNamespaceAttributes(node) {
    for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes[i];
        if (!isNamespaceAttributeName(attr.nodeName)) return false;
    }
    return true;
};
var isNamespaceAttributeName = function isNamespaceAttributeName(name) {
    return name === 'xmlns' || name.startsWith('xmlns:');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iE3B9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utf8Encode", function() {
    return utf8Encode;
});
parcelHelpers.export(exports, "toBase64", function() {
    return toBase64;
});
function bytesToBase64(bytes) {
    var base64Str = Array.from(bytes, function(x) {
        return String.fromCodePoint(x);
    }).join('');
    return btoa(base64Str);
}
function utf8Encode(input) {
    return new TextEncoder().encode(input);
}
function toBase64(input) {
    if (typeof input === 'string') return bytesToBase64(utf8Encode(input));
    return bytesToBase64(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"JQAKY":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "deserializeNumber", function() {
    return deserializeNumber;
});
parcelHelpers.export(exports, "deserializeBoolean", function() {
    return deserializeBoolean;
});
parcelHelpers.export(exports, "deserializeTimestamp", function() {
    return deserializeTimestamp;
});
parcelHelpers.export(exports, "emptyArrayGuard", function() {
    return emptyArrayGuard;
});
parcelHelpers.export(exports, "deserializeMetadata", function() {
    return deserializeMetadata;
});
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var map = function map(obj, instructions) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = __values(Object.entries(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], instruction = _d[1];
            var _e = __read(Array.isArray(instruction) ? instruction : [
                instruction
            ], 2), accessor = _e[0], deserializer = _e[1];
            if (obj.hasOwnProperty(accessor)) result[key] = deserializer ? deserializer(obj[accessor]) : String(obj[accessor]);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
};
var deserializeNumber = function deserializeNumber(value) {
    return value ? Number(value) : undefined;
};
var deserializeBoolean = function deserializeBoolean(value) {
    return value ? value === 'true' : undefined;
};
var deserializeTimestamp = function deserializeTimestamp(value) {
    return value ? new Date(value) : undefined;
};
var emptyArrayGuard = function emptyArrayGuard(value, deserializer) {
    if (value === '') return [];
    var valueArray = (Array.isArray(value) ? value : [
        value
    ]).filter(function(e) {
        return e != null;
    });
    return deserializer(valueArray);
};
var deserializeMetadata = function deserializeMetadata(headers) {
    var objectMetadataHeaderPrefix = 'x-amz-meta-';
    var deserialized = Object.keys(headers).filter(function(header) {
        return header.startsWith(objectMetadataHeaderPrefix);
    }).reduce(function(acc, header) {
        acc[header.replace(objectMetadataHeaderPrefix, '')] = headers[header];
        return acc;
    }, {});
    return Object.keys(deserialized).length > 0 ? deserialized : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gNA5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignStringVariables", function() {
    return assignStringVariables;
});
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", function() {
    return serializeObjectSsecOptionsToHeaders;
});
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", function() {
    return serializeObjectConfigsToHeaders;
});
parcelHelpers.export(exports, "serializePathnameObjectKey", function() {
    return serializePathnameObjectKey;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _md5Js = require("@aws-sdk/md5-js");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("../utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var assignStringVariables = function assignStringVariables(values) {
    var e_1, _a;
    var queryParams = {};
    try {
        for(var _b = __values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) queryParams[key] = value.toString();
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return queryParams;
};
var serializeObjectSsecOptionsToHeaders = function serializeObjectSsecOptionsToHeaders(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var getMd5Digest, _a, _b, _c, _d;
        var _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    getMd5Digest = function getMd5Digest(content) {
                        return __awaiter(void 0, void 0, void 0, function() {
                            var md5Hasher;
                            return __generator(this, function(_a) {
                                md5Hasher = new (0, _md5Js.Md5)();
                                md5Hasher.update((0, _utils.utf8Encode)(content));
                                return [
                                    2 /*return*/ ,
                                    md5Hasher.digest()
                                ];
                            });
                        });
                    };
                    _a = assignStringVariables;
                    _e = {
                        'x-amz-server-side-encryption-customer-algorithm': input.SSECustomerAlgorithm,
                        // base64 encoded is need
                        // see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html#specifying-s3-c-encryption
                        'x-amz-server-side-encryption-customer-key': input.SSECustomerKey && (0, _utils.toBase64)(input.SSECustomerKey)
                    };
                    // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                    // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                    _b = 'x-amz-server-side-encryption-customer-key-md5';
                    _c = input.SSECustomerKey;
                    if (!_c) return [
                        3 /*break*/ ,
                        2
                    ];
                    _d = (0, _utils.toBase64);
                    return [
                        4 /*yield*/ ,
                        getMd5Digest(input.SSECustomerKey)
                    ];
                case 1:
                    _c = _d.apply(void 0, [
                        _f.sent()
                    ]);
                    _f.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                            // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                            (_e[_b] = _c, _e)
                        ])
                    ];
            }
        });
    });
};
var serializeObjectConfigsToHeaders = function serializeObjectConfigsToHeaders(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var _a;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        serializeObjectSsecOptionsToHeaders(input)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        __assign.apply(void 0, [
                            __assign.apply(void 0, _a.concat([
                                _c.sent()
                            ])),
                            assignStringVariables(__assign({
                                'x-amz-server-side-encryption': input.ServerSideEncryption,
                                'x-amz-server-side-encryption-aws-kms-key-id': input.SSEKMSKeyId,
                                'x-amz-acl': input.ACL,
                                'cache-control': input.CacheControl,
                                'content-disposition': input.ContentDisposition,
                                'content-language': input.ContentLanguage,
                                'content-encoding': input.ContentEncoding,
                                'content-type': input.ContentType,
                                expires: (_b = input.Expires) === null || _b === void 0 ? void 0 : _b.toUTCString(),
                                'x-amz-tagging': input.Tagging
                            }, serializeMetadata(input.Metadata)))
                        ])
                    ];
            }
        });
    });
};
var serializeMetadata = function serializeMetadata(metadata) {
    if (metadata === void 0) metadata = {};
    return Object.keys(metadata).reduce(function(acc, suffix) {
        acc["x-amz-meta-".concat(suffix.toLowerCase())] = metadata[suffix];
        return acc;
    }, {});
};
var serializePathnameObjectKey = function serializePathnameObjectKey(url, key) {
    return url.pathname.replace(/\/$/, '') + "/".concat(key.split('/').map((0, _awsClientUtils.extendedEncodeURIComponent)).join('/'));
};

},{"@aws-sdk/md5-js":"3GaA7","@aws-amplify/core/internals/aws-client-utils":"cD43M","../utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3GaA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Md5", function() {
    return Md5;
});
var _tslib = require("tslib");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _constants = require("./constants");
var Md5 = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, _constants.INIT));
        this.buffer = new DataView(new ArrayBuffer((0, _constants.BLOCK_SIZE)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if (isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, _constants.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, _tslib.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, _constants.BLOCK_SIZE) >= (0, _constants.BLOCK_SIZE) - 8) {
                        for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, _constants.DIGEST_LENGTH)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") return (0, _utilUtf8Browser.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"tslib":"m02BL","@aws-sdk/util-utf8-browser":"iZmxX","./constants":"8bZZx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"m02BL":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8bZZx":[function(require,module,exports,__globalThis) {
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLOCK_SIZE", function() {
    return BLOCK_SIZE;
});
parcelHelpers.export(exports, "DIGEST_LENGTH", function() {
    return DIGEST_LENGTH;
});
parcelHelpers.export(exports, "INIT", function() {
    return INIT;
});
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jm2cc":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getObject", function() {
    return getObject;
});
parcelHelpers.export(exports, "getPresignedGetObjectUrl", function() {
    return getPresignedGetObjectUrl;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _core = require("@aws-amplify/core");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getObjectSerializer = function getObjectSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, query, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    query = (0, _utils.map)(input, {
                        'response-cache-control': 'ResponseCacheControl',
                        'response-content-disposition': 'ResponseContentDisposition',
                        'response-content-encoding': 'ResponseContentEncoding',
                        'response-content-language': 'ResponseContentLanguage',
                        'response-content-type': 'ResponseContentType'
                    });
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams(query).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: 'GET',
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var getObjectDeserializer = function getObjectDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    if (!response.body) throw new Error('Got empty response body.');
                    else return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            DeleteMarker: [
                                'x-amz-delete-marker',
                                (0, _utils.deserializeBoolean)
                            ],
                            AcceptRanges: 'accept-ranges',
                            Expiration: 'x-amz-expiration',
                            Restore: 'x-amz-restore',
                            LastModified: [
                                'last-modified',
                                (0, _utils.deserializeTimestamp)
                            ],
                            ContentLength: [
                                'content-length',
                                (0, _utils.deserializeNumber)
                            ],
                            ETag: 'etag',
                            ChecksumCRC32: 'x-amz-checksum-crc32',
                            ChecksumCRC32C: 'x-amz-checksum-crc32c',
                            ChecksumSHA1: 'x-amz-checksum-sha1',
                            ChecksumSHA256: 'x-amz-checksum-sha256',
                            MissingMeta: [
                                'x-amz-missing-meta',
                                (0, _utils.deserializeNumber)
                            ],
                            VersionId: 'x-amz-version-id',
                            CacheControl: 'cache-control',
                            ContentDisposition: 'content-disposition',
                            ContentEncoding: 'content-encoding',
                            ContentLanguage: 'content-language',
                            ContentRange: 'content-range',
                            ContentType: 'content-type',
                            Expires: [
                                'expires',
                                (0, _utils.deserializeTimestamp)
                            ],
                            WebsiteRedirectLocation: 'x-amz-website-redirect-location',
                            ServerSideEncryption: 'x-amz-server-side-encryption',
                            SSECustomerAlgorithm: 'x-amz-server-side-encryption-customer-algorithm',
                            SSECustomerKeyMD5: 'x-amz-server-side-encryption-customer-key-md5',
                            SSEKMSKeyId: 'x-amz-server-side-encryption-aws-kms-key-id',
                            BucketKeyEnabled: [
                                'x-amz-server-side-encryption-bucket-key-enabled',
                                (0, _utils.deserializeBoolean)
                            ],
                            StorageClass: 'x-amz-storage-class',
                            RequestCharged: 'x-amz-request-charged',
                            ReplicationStatus: 'x-amz-replication-status',
                            PartsCount: [
                                'x-amz-mp-parts-count',
                                (0, _utils.deserializeNumber)
                            ],
                            TagCount: [
                                'x-amz-tagging-count',
                                (0, _utils.deserializeNumber)
                            ],
                            ObjectLockMode: 'x-amz-object-lock-mode',
                            ObjectLockRetainUntilDate: [
                                'x-amz-object-lock-retain-until-date',
                                (0, _utils.deserializeTimestamp)
                            ],
                            ObjectLockLegalHoldStatus: 'x-amz-object-lock-legal-hold'
                        })), {
                            Metadata: (0, _utils.deserializeMetadata)(response.headers),
                            $metadata: (0, _awsClientUtils.parseMetadata)(response),
                            Body: response.body
                        })
                    ];
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var getObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), getObjectSerializer, getObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'blob'
}));
var getPresignedGetObjectUrl = function getPresignedGetObjectUrl(config, input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var endpoint, _a, url, headers, method, _b, _c, _d, headerName, value;
        var e_1, _e;
        var _f;
        return __generator(this, function(_g) {
            switch(_g.label){
                case 0:
                    endpoint = (0, _base.defaultConfig).endpointResolver(config, input);
                    return [
                        4 /*yield*/ ,
                        getObjectSerializer(input, endpoint)
                    ];
                case 1:
                    _a = _g.sent(), url = _a.url, headers = _a.headers, method = _a.method;
                    // TODO: set content sha256 query parameter with value of UNSIGNED-PAYLOAD.
                    // It requires changes in presignUrl. Without this change, the generated url still works,
                    // but not the same as other tools like AWS SDK and CLI.
                    url.searchParams.append((0, _utils.CONTENT_SHA256_HEADER), (0, _awsClientUtils.EMPTY_SHA256_HASH));
                    url.searchParams.append((_f = config.userAgentHeader) !== null && _f !== void 0 ? _f : (0, _core.USER_AGENT_HEADER), config.userAgentValue);
                    try {
                        for(_b = __values(Object.entries(headers).sort(function(_a, _b) {
                            var _c = __read(_a, 1), key1 = _c[0];
                            var _d = __read(_b, 1), key2 = _d[0];
                            return key1.localeCompare(key2);
                        })), _c = _b.next(); !_c.done; _c = _b.next()){
                            _d = __read(_c.value, 2), headerName = _d[0], value = _d[1];
                            url.searchParams.append(headerName, value);
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    return [
                        2 /*return*/ ,
                        (0, _awsClientUtils.presignUrl)({
                            method: method,
                            url: url,
                            body: null
                        }, __assign(__assign({}, (0, _base.defaultConfig)), config)).toString()
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","@aws-amplify/core":"3rlh1","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5tZz8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listObjectsV2", function() {
    return listObjectsV2;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listObjectsV2Serializer = function listObjectsV2Serializer(input, endpoint) {
    var headers = (0, _utils.assignStringVariables)({
        'x-amz-request-payer': input.RequestPayer,
        'x-amz-expected-bucket-owner': input.ExpectedBucketOwner
    });
    var query = (0, _utils.assignStringVariables)({
        'list-type': '2',
        'continuation-token': input.ContinuationToken,
        delimiter: input.Delimiter,
        'encoding-type': input.EncodingType,
        'fetch-owner': input.FetchOwner,
        'max-keys': input.MaxKeys,
        prefix: input.Prefix,
        'start-after': input.StartAfter
    });
    var url = new URL(endpoint.url.toString());
    url.search = new URLSearchParams(query).toString();
    return {
        method: 'GET',
        headers: headers,
        url: url
    };
};
var listObjectsV2Deserializer = function listObjectsV2Deserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        CommonPrefixes: [
                            'CommonPrefixes',
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCommonPrefixList);
                            }
                        ],
                        Contents: [
                            'Contents',
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeObjectList);
                            }
                        ],
                        ContinuationToken: 'ContinuationToken',
                        Delimiter: 'Delimiter',
                        EncodingType: 'EncodingType',
                        IsTruncated: [
                            'IsTruncated',
                            (0, _utils.deserializeBoolean)
                        ],
                        KeyCount: [
                            'KeyCount',
                            (0, _utils.deserializeNumber)
                        ],
                        MaxKeys: [
                            'MaxKeys',
                            (0, _utils.deserializeNumber)
                        ],
                        Name: 'Name',
                        NextContinuationToken: 'NextContinuationToken',
                        Prefix: 'Prefix',
                        StartAfter: 'StartAfter'
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCommonPrefixList = function deserializeCommonPrefixList(output) {
    return output.map(deserializeCommonPrefix);
};
var deserializeCommonPrefix = function deserializeCommonPrefix(output) {
    return (0, _utils.map)(output, {
        Prefix: 'Prefix'
    });
};
var deserializeObjectList = function deserializeObjectList(output) {
    return output.map(deserializeObject);
};
var deserializeObject = function deserializeObject(output) {
    return (0, _utils.map)(output, {
        Key: 'Key',
        LastModified: [
            'LastModified',
            (0, _utils.deserializeTimestamp)
        ],
        ETag: 'ETag',
        ChecksumAlgorithm: [
            'ChecksumAlgorithm',
            function(value) {
                return (0, _utils.emptyArrayGuard)(value, deserializeChecksumAlgorithmList);
            }
        ],
        Size: [
            'Size',
            (0, _utils.deserializeNumber)
        ],
        StorageClass: 'StorageClass',
        Owner: [
            'Owner',
            deserializeOwner
        ]
    });
};
var deserializeChecksumAlgorithmList = function deserializeChecksumAlgorithmList(output) {
    return output.map(function(entry) {
        return String(entry);
    });
};
var deserializeOwner = function deserializeOwner(output) {
    return (0, _utils.map)(output, {
        DisplayName: 'DisplayName',
        ID: 'ID'
    });
};
var listObjectsV2 = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listObjectsV2Serializer, listObjectsV2Deserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28JPR":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putObject", function() {
    return putObject;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putObjectSerializer = function putObjectSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(__assign(__assign({}, input), {
                            ContentType: (_b = input.ContentType) !== null && _b !== void 0 ? _b : 'application/octet-stream'
                        }))
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _c.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            'content-md5': input.ContentMD5
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: 'PUT',
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var putObjectDeserializer = function putObjectDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: 'etag',
                            VersionId: 'x-amz-version-id'
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var putObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), putObjectSerializer, putObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40v7G":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMultipartUpload", function() {
    return createMultipartUpload;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var createMultipartUploadSerializer = function createMultipartUploadSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = 'uploads';
                    return [
                        2 /*return*/ ,
                        {
                            method: 'POST',
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var createMultipartUploadDeserializer = function createMultipartUploadDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: 'UploadId'
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var createMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), createMultipartUploadSerializer, createMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hY7Iz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uploadPart", function() {
    return uploadPart;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var uploadPartSerializer = function uploadPartSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            'content-md5': input.ContentMD5
                        })
                    ]);
                    headers['content-type'] = 'application/octet-stream';
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        partNumber: input.PartNumber + '',
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: 'PUT',
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var uploadPartDeserializer = function uploadPartDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: 'etag'
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var uploadPart = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), uploadPartSerializer, uploadPartDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cP4XE":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeMultipartUpload", function() {
    return completeMultipartUpload;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var INVALID_PARAMETER_ERROR_MSG = 'Invalid parameter for ComplteMultipartUpload API';
var completeMultipartUploadSerializer = function completeMultipartUploadSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    headers['content-type'] = 'application/xml';
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: 'POST',
                            headers: headers,
                            url: url,
                            body: '<?xml version="1.0" encoding="UTF-8"?>' + serializeCompletedMultipartUpload(input.MultipartUpload)
                        }
                    ];
            }
        });
    });
};
var serializeCompletedMultipartUpload = function serializeCompletedMultipartUpload(input) {
    var _a;
    if (!((_a = input.Parts) === null || _a === void 0 ? void 0 : _a.length)) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return "<CompleteMultipartUpload xmlns=\"http://s3.amazonaws.com/doc/2006-03-01/\">".concat(input.Parts.map(serializeCompletedPartList).join(''), "</CompleteMultipartUpload>");
};
var serializeCompletedPartList = function serializeCompletedPartList(input) {
    if (!input.ETag || input.PartNumber == null) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return "<Part><ETag>".concat(input.ETag, "</ETag><PartNumber>").concat(input.PartNumber, "</PartNumber></Part>");
};
/**
 * Parse CompleteMultipartUpload API response payload, which may be empty or error indicating internal
 * server error, even when the status code is 200.
 *
 * Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
 */ var parseXmlBodyOrThrow = function parseXmlBodyOrThrow(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (!(parsed.Code !== undefined && parsed.Message !== undefined)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(__assign(__assign({}, response), {
                            statusCode: 500
                        }))
                    ];
                case 2:
                    error = _a.sent();
                    error.$metadata.httpStatusCode = response.statusCode;
                    throw error;
                case 3:
                    return [
                        2 /*return*/ ,
                        parsed
                    ];
            }
        });
    });
};
var completeMultipartUploadDeserializer = function completeMultipartUploadDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        parseXmlBodyOrThrow(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        ETag: 'ETag',
                        Key: 'Key',
                        Location: 'Location'
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
// CompleteMultiPartUpload API returns 200 status code with empty body or error message.
// This indicates internal server error after the response has been sent to the client.
// Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
var retryWhenErrorWith200StatusCode = function retryWhenErrorWith200StatusCode(response, error) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, defaultRetryDecider;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode === 200)) return [
                        3 /*break*/ ,
                        2
                    ];
                    if (!response.body) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (parsed.Code !== undefined && parsed.Message !== undefined) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 2:
                    defaultRetryDecider = (0, _base.defaultConfig).retryDecider;
                    return [
                        2 /*return*/ ,
                        defaultRetryDecider(response, error)
                    ];
            }
        });
    });
};
var completeMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), completeMultipartUploadSerializer, completeMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text',
    retryDecider: retryWhenErrorWith200StatusCode
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jAX3y":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listParts", function() {
    return listParts;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listPartsSerializer = function listPartsSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: 'GET',
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var listPartsDeserializer = function listPartsDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: 'UploadId',
                        Parts: [
                            'Part',
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCompletedPartList);
                            }
                        ]
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCompletedPartList = function deserializeCompletedPartList(input) {
    return input.map(function(item) {
        return (0, _utils.map)(item, {
            PartNumber: [
                'PartNumber',
                (0, _utils.deserializeNumber)
            ],
            ETag: 'ETag',
            Size: [
                'Size',
                (0, _utils.deserializeNumber)
            ]
        });
    });
};
var listParts = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listPartsSerializer, listPartsDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NnE9":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abortMultipartUpload", function() {
    return abortMultipartUpload;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var abortMultipartUploadSerializer = function abortMultipartUploadSerializer(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    url.search = new URLSearchParams({
        uploadId: input.UploadId
    }).toString();
    return {
        method: 'DELETE',
        headers: {},
        url: url
    };
};
var abortMultipartUploadDeserializer = function abortMultipartUploadDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var abortMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), abortMultipartUploadSerializer, abortMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dpqr0":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyObject", function() {
    return copyObject;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var copyObjectSerializer = function copyObjectSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            'x-amz-copy-source': input.CopySource,
                            'x-amz-metadata-directive': input.MetadataDirective
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: 'PUT',
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var copyObjectDeserializer = function copyObjectDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var copyObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), copyObjectSerializer, copyObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cwNBH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "headObject", function() {
    return headObject;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var headObjectSerializer = function headObjectSerializer(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: 'HEAD',
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var headObjectDeserializer = function headObjectDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    contents = __assign(__assign({}, (0, _utils.map)(response.headers, {
                        ContentLength: [
                            'content-length',
                            (0, _utils.deserializeNumber)
                        ],
                        ContentType: 'content-type',
                        ETag: 'etag',
                        LastModified: [
                            'last-modified',
                            (0, _utils.deserializeTimestamp)
                        ],
                        VersionId: 'x-amz-version-id'
                    })), {
                        Metadata: (0, _utils.deserializeMetadata)(response.headers)
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var headObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), headObjectSerializer, headObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cUAyH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteObject", function() {
    return deleteObject;
});
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var deleteObjectSerializer = function deleteObjectSerializer(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    return {
        method: 'DELETE',
        headers: {},
        url: url
    };
};
var deleteObjectDeserializer = function deleteObjectDeserializer(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, content;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    content = (0, _utils.map)(response.headers, {
                        DeleteMarker: [
                            'x-amz-delete-marker',
                            (0, _utils.deserializeBoolean)
                        ],
                        VersionId: 'x-amz-version-id',
                        RequestCharged: 'x-amz-request-charged'
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, content), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var deleteObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), deleteObjectSerializer, deleteObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: 'text'
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5FJDR":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageErrorStrings", function() {
    return StorageErrorStrings;
});
parcelHelpers.export(exports, "AWSS3ProviderMultipartCopierErrors", function() {
    return AWSS3ProviderMultipartCopierErrors;
});
parcelHelpers.export(exports, "AWSS3ProviderUploadErrorStrings", function() {
    return AWSS3ProviderUploadErrorStrings;
});
var StorageErrorStrings;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = "source param should be an object with the property \"key\" with value of type string";
    StorageErrorStrings["NO_DEST_KEY"] = "destination param should be an object with the property \"key\" with value of type string";
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})(StorageErrorStrings || (StorageErrorStrings = {}));
var AWSS3ProviderMultipartCopierErrors;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})(AWSS3ProviderMultipartCopierErrors || (AWSS3ProviderMultipartCopierErrors = {}));
var AWSS3ProviderUploadErrorStrings;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})(AWSS3ProviderUploadErrorStrings || (AWSS3ProviderUploadErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VK2g":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "byteLength", function() {
    return byteLength;
});
parcelHelpers.export(exports, "dispatchStorageEvent", function() {
    return dispatchStorageEvent;
});
parcelHelpers.export(exports, "isFile", function() {
    return isFile;
});
parcelHelpers.export(exports, "isBlob", function() {
    return isBlob;
});
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var byteLength = function byteLength(x) {
    if (typeof x === 'string') return x.length;
    else if (isArrayBuffer(x)) return x.byteLength;
    else if (isBlob(x)) return x.size;
    else throw new Error('Cannot determine byte length of ' + x);
};
var dispatchStorageEvent = function dispatchStorageEvent(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data['metrics'] = metrics;
        (0, _core.Hub).dispatch('storage', {
            event: event,
            data: data,
            message: message
        }, 'Storage', (0, _storageConstants.AMPLIFY_SYMBOL));
    }
};
var isFile = function isFile(x) {
    return typeof x !== 'undefined' && x instanceof File;
};
var isBlob = function isBlob(x) {
    return typeof x !== 'undefined' && x instanceof Blob;
};
var isArrayBuffer = function isArrayBuffer(x) {
    return typeof x !== 'undefined' && x instanceof ArrayBuffer;
};

},{"@aws-amplify/core":"3rlh1","./StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"34577":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", function() {
    return AMPLIFY_SYMBOL;
});
parcelHelpers.export(exports, "localTestingStorageEndpoint", function() {
    return localTestingStorageEndpoint;
});
parcelHelpers.export(exports, "UPLOADS_STORAGE_KEY", function() {
    return UPLOADS_STORAGE_KEY;
});
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var localTestingStorageEndpoint = 'http://localhost:20005';
var UPLOADS_STORAGE_KEY = '__uploadInProgress';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iu1YF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrefix", function() {
    return getPrefix;
});
parcelHelpers.export(exports, "credentialsProvider", function() {
    return credentialsProvider;
});
parcelHelpers.export(exports, "loadS3Config", function() {
    return loadS3Config;
});
parcelHelpers.export(exports, "DEFAULT_PART_SIZE", function() {
    return DEFAULT_PART_SIZE;
});
parcelHelpers.export(exports, "MAX_OBJECT_SIZE", function() {
    return MAX_OBJECT_SIZE;
});
parcelHelpers.export(exports, "MAX_PARTS_COUNT", function() {
    return MAX_PARTS_COUNT;
});
parcelHelpers.export(exports, "DEFAULT_QUEUE_SIZE", function() {
    return DEFAULT_QUEUE_SIZE;
});
parcelHelpers.export(exports, "calculatePartSize", function() {
    return calculatePartSize;
});
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.Logger)('S3ClientUtils');
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var INVALID_CRED = {
    accessKeyId: '',
    secretAccessKey: ''
};
var getPrefix = function getPrefix(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : 'private/') + resolvedIdentityId + '/';
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : 'protected/') + resolvedIdentityId + '/';
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : 'public/';
    switch(level){
        case 'private':
            return privatePath;
        case 'protected':
            return protectedPath;
        default:
            return publicPath;
    }
};
var credentialsProvider = function credentialsProvider() {
    return __awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, _core.Credentials).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                    cred = (0, _core.Credentials).shear(credentials);
                    logger.debug('credentials provider get credentials', cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    logger.warn('credentials provider error', error_1);
                    return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var loadS3Config = function loadS3Config(config) {
    if (!config.region) // Same error thrown by aws-sdk
    throw new Error('Region is missing.');
    return __assign(__assign(__assign({}, config), {
        region: config.region,
        credentials: config.credentials ? function() {
            return Promise.resolve(config.credentials);
        } : credentialsProvider,
        userAgentValue: (0, _core.getAmplifyUserAgent)({
            category: (0, _core.Category).Storage,
            action: config.storageAction
        })
    }), config.dangerouslyConnectToHttpEndpointForTesting ? {
        customEndpoint: (0, _storageConstants.localTestingStorageEndpoint),
        forcePathStyle: true
    } : {});
};
var MiB = 1048576;
var GiB = 1024 * MiB;
var TiB = 1024 * GiB;
var DEFAULT_PART_SIZE = 5 * MiB;
var MAX_OBJECT_SIZE = 5 * TiB;
var MAX_PARTS_COUNT = 10000;
var DEFAULT_QUEUE_SIZE = 4;
var calculatePartSize = function calculatePartSize(totalSize) {
    var partSize = DEFAULT_PART_SIZE;
    var partsCount = Math.ceil(totalSize / partSize);
    while(partsCount > MAX_PARTS_COUNT){
        partSize *= 2;
        partsCount = Math.ceil(totalSize / partSize);
    }
    return partSize;
};

},{"@aws-amplify/core":"3rlh1","./StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6BvX7":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3ProviderManagedUpload", function() {
    return AWSS3ProviderManagedUpload;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _events = require("events");
var _md5Utils = require("../common/MD5utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.ConsoleLogger)('AWSS3ProviderManagedUpload');
var AWSS3ProviderManagedUpload = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        this.opts = null;
        this.completedParts = [];
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = __assign({
            isObjectLockEnabled: false
        }, opts);
        this.emitter = emitter;
        this.s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opts), {
            emitter: emitter,
            storageAction: (0, _core.StorageAction).Put
        }));
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var isObjectLockEnabled, _a, _b, _c, _d, _e, numberOfPartsToUpload, parts, start, error_1;
            var _f;
            var _this = this;
            return __generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        _g.trys.push([
                            0,
                            12,
                            ,
                            14
                        ]);
                        isObjectLockEnabled = this.opts.isObjectLockEnabled;
                        if (!(isObjectLockEnabled === true)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.params;
                        return [
                            4 /*yield*/ ,
                            (0, _md5Utils.calculateContentMd5)(// @ts-expect-error currently ReadableStream<any> is not being supported in put api
                            this.params.Body)
                        ];
                    case 1:
                        _a.ContentMD5 = _g.sent();
                        _g.label = 2;
                    case 2:
                        this.body = this.validateAndSanitizeBody(this.params.Body);
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= (0, _s3ClientUtils.DEFAULT_PART_SIZE))) return [
                            3 /*break*/ ,
                            4
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        _b = (0, _s3.putObject);
                        _c = [
                            this.s3Config
                        ];
                        _d = [
                            __assign({}, this.params)
                        ];
                        _f = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.apply(void 0, _c.concat([
                                __assign.apply(void 0, _d.concat([
                                    (_f.Key = _g.sent(), _f)
                                ]))
                            ]))
                        ];
                    case 4:
                        // Step 1: Determine appropriate part size.
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytesToUpload);
                        // Step 2: Initiate the multi part upload
                        _e = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 5:
                        // Step 2: Initiate the multi part upload
                        _e.uploadId = _g.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.partSize);
                        parts = this.createParts();
                        start = 0;
                        _g.label = 6;
                    case 6:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            9
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE)))
                        ];
                    case 7:
                        // Upload as many as `queueSize` parts simultaneously
                        _g.sent();
                        _g.label = 8;
                    case 8:
                        start += (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 9:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 10:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _g.sent()
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        error_1 = _g.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 13:
                        // if any error is thrown, call cleanup
                        _g.sent();
                        logger.error('Error. Cancelling the multipart upload.');
                        throw error_1;
                    case 14:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.partSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new (0, _events.EventEmitter)(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.partSize;
            }
            return parts;
        } catch (error) {
            logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var response, _a, _b, _c, error_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent(), _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        response = _e.sent();
                        logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 3:
                        error_2 = _e.sent();
                        logger.error(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return __awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var isObjectLockEnabled, _$_a, _b, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, ContentMD5, res, _c, _d;
                                    var _e;
                                    return __generator(this, function(_f) {
                                        switch(_f.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                isObjectLockEnabled = this.opts.isObjectLockEnabled;
                                                if (!isObjectLockEnabled) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _$_a = this.params;
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _md5Utils.calculateContentMd5)(part.bodyPart)
                                                ];
                                            case 1:
                                                _$_a.ContentMD5 = _f.sent();
                                                _f.label = 2;
                                            case 2:
                                                _b = this.params, Key = _b.Key, Bucket = _b.Bucket, SSECustomerAlgorithm = _b.SSECustomerAlgorithm, SSECustomerKey = _b.SSECustomerKey, SSECustomerKeyMD5 = _b.SSECustomerKeyMD5, ContentMD5 = _b.ContentMD5;
                                                _c = (0, _s3.uploadPart);
                                                _d = [
                                                    __assign(__assign({}, this.s3Config), {
                                                        emitter: part.emitter
                                                    })
                                                ];
                                                _e = {
                                                    PartNumber: part.partNumber,
                                                    Body: part.bodyPart,
                                                    UploadId: uploadId
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getObjectKeyWithPrefix(this.params.Key)
                                                ];
                                            case 3:
                                                return [
                                                    4 /*yield*/ ,
                                                    _c.apply(void 0, _d.concat([
                                                        (_e.Key = _f.sent(), _e.Bucket = Bucket, _e.SSECustomerAlgorithm = SSECustomerAlgorithm, _e.SSECustomerKey = SSECustomerKey, _e.SSECustomerKeyMD5 = SSECustomerKeyMD5, _e.ContentMD5 = ContentMD5, _e)
                                                    ]))
                                                ];
                                            case 4:
                                                res = _f.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.error('Error happened while uploading a part. Cancelling the multipart upload');
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, Key, error_4;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a.MultipartUpload = {
                            Parts: this.completedParts
                        }, _a);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.completeMultipartUpload)(__assign(__assign({}, this.s3Config), {
                                emitter: undefined
                            }), input)
                        ];
                    case 3:
                        Key = _b.sent().Key;
                        return [
                            2 /*return*/ ,
                            Key
                        ];
                    case 4:
                        error_4 = _b.sent();
                        logger.error('Error happened while finishing the upload.');
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, data;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        if (!uploadId) // This is a single part upload;
                        return [
                            2 /*return*/ 
                        ];
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.abortMultipartUpload)(this.s3Config, input)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listParts)(this.s3Config, input)
                        ];
                    case 3:
                        data = _b.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error('Multipart upload clean up failed.');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, _utils.SEND_UPLOAD_PROGRESS_EVENT));
        part.emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === 'number') return input.byteLength;
        else if (typeof input.length === 'number') return input.length;
        else if (typeof input.size === 'number') return input.size;
        else if (typeof input.path === 'string') ;
        else throw new Error('Cannot determine length of ' + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        var sanitizedBody = this.isGenericObject(body) ? JSON.stringify(body) : body;
        /* TODO: streams and files for nodejs
        if (
            typeof body.path === 'string' &&
            require('fs').lstatSync(body.path).size > 0
        ) {
            sanitizedBody = body;
        } */ if (this.byteLength(sanitizedBody) > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytesToUpload, " Bytes"));
        return sanitizedBody;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && (typeof body === "undefined" ? "undefined" : (0, _typeOf._)(body)) === 'object') try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype.getObjectKeyWithPrefix = function(keyWithoutPrefix) {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _s3ClientUtils.getPrefix);
                        _b = [
                            __assign({}, this.opts)
                        ];
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            (0, _s3ClientUtils.credentialsProvider)()
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, [
                                __assign.apply(void 0, _b.concat([
                                    (_c.credentials = _d.sent(), _c)
                                ]))
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _d.sent() + keyWithoutPrefix
                        ];
                }
            });
        });
    };
    return AWSS3ProviderManagedUpload;
}();

},{"@swc/helpers/_/_type_of":"668P4","@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","events":"dar5h","../common/MD5utils":"cUKuj","../common/S3ClientUtils":"iu1YF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dar5h":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var R = (typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, _typeOf._)(listener)));
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function get() {
        return defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, _typeOf._)(emitter)));
}

},{"@swc/helpers/_/_type_of":"668P4"}],"cUKuj":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateContentMd5", function() {
    return calculateContentMd5;
});
var _md5Js = require("@aws-sdk/md5-js");
var _utils = require("../AwsClients/S3/utils");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var calculateContentMd5 = function calculateContentMd5(content) {
    return __awaiter(void 0, void 0, void 0, function() {
        var hasher, buffer, digest;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    hasher = new (0, _md5Js.Md5)();
                    if (!(typeof content === 'string')) return [
                        3 /*break*/ ,
                        1
                    ];
                    hasher.update(content);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        readFile(content)
                    ];
                case 2:
                    buffer = _a.sent();
                    hasher.update(buffer);
                    _a.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        hasher.digest()
                    ];
                case 4:
                    digest = _a.sent();
                    return [
                        2 /*return*/ ,
                        (0, _utils.toBase64)(digest)
                    ];
            }
        });
    });
};
var readFile = function readFile(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            if (reader.result) resolve(reader.result);
            reader.onabort = function() {
                return reject(new Error('Read aborted'));
            };
            reader.onerror = function() {
                return reject(reader.error);
            };
        };
        if (file !== undefined) reader.readAsArrayBuffer(file);
    });
};

},{"@aws-sdk/md5-js":"3GaA7","../AwsClients/S3/utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3YUiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3UploadTaskState", function() {
    return AWSS3UploadTaskState;
});
parcelHelpers.export(exports, "TaskEvents", function() {
    return TaskEvents;
});
parcelHelpers.export(exports, "AWSS3UploadTask", function() {
    return AWSS3UploadTask;
});
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _storageUtils = require("../common/StorageUtils");
var _storageConstants = require("../common/StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.Logger)('AWSS3UploadTask');
var AWSS3UploadTaskState;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})(AWSS3UploadTaskState || (AWSS3UploadTaskState = {}));
var TaskEvents;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})(TaskEvents || (TaskEvents = {}));
function comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var AWSS3UploadTask = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Config = _a.s3Config, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.queueSize = (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = AWSS3UploadTaskState.INIT;
        this.prefixPromise = prefixPromise;
        this.s3Config = s3Config;
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage['sync'] === 'function') this.storageSync = this.storage['sync']();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on(TaskEvents.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function get() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function get() {
            return this.state === AWSS3UploadTaskState.IN_PROGRESS;
        },
        enumerable: false,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return __awaiter(this, void 0, void 0, function() {
            var objectKeyPrefix, _b, Contents, obj;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        objectKeyPrefix = _c.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)(this.s3Config, {
                                Bucket: bucket,
                                Prefix: objectKeyPrefix + key
                            })
                        ];
                    case 2:
                        _b = _c.sent().Contents, Contents = _b === void 0 ? [] : _b;
                        obj = Contents.find(function(o) {
                            return o.Key === "".concat(objectKeyPrefix).concat(key);
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, _storageUtils.isFile)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join('-');
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join('-');
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, _a, Parts, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _e.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        _b = (0, _s3.listParts);
                        _c = [
                            this.s3Config
                        ];
                        _d = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, _c.concat([
                                (_d.Key = _e.sent() + this.params.Key, _d.UploadId = cachedUploadFileData.uploadId, _d)
                            ]))
                        ];
                    case 3:
                        _a = _e.sent().Parts, Parts = _a === void 0 ? [] : _a;
                        return [
                            2 /*return*/ ,
                            {
                                parts: Parts,
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.totalBytes > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytes, " Bytes"));
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return __awaiter(this, void 0, void 0, function() {
            var tasks;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, _storageConstants.UPLOADS_STORAGE_KEY)) || '{}';
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, _storageUtils.byteLength)(chunk);
                this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== AWSS3UploadTaskState.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_1;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.completeMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c.MultipartUpload = {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: __spreadArray([], __read(this.completedParts), false).sort(comparePartNumber)
                                }, _c)
                            ]))
                        ];
                    case 2:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._verifyFileSize()
                        ];
                    case 3:
                        _d.sent();
                        this._emitEvent(TaskEvents.UPLOAD_COMPLETE, {
                            key: this.params.Key
                        });
                        this._removeFromCache();
                        this.state = AWSS3UploadTaskState.COMPLETED;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _d.sent();
                        logger.error('error completing upload', err_1);
                        this._emitEvent(TaskEvents.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, abortSignal) {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c, err_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.uploadPart);
                        _b = [
                            __assign(__assign({}, this.s3Config), {
                                abortSignal: abortSignal
                            })
                        ];
                        _c = [
                            __assign({}, input)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 3:
                        _e.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_2 = _e.sent();
                        if (this.state === AWSS3UploadTaskState.PAUSED) logger.log('upload paused');
                        else if (this.state === AWSS3UploadTaskState.CANCELLED) logger.log('upload aborted');
                        else logger.error('error starting next part of upload: ', err_2);
                        // xhr transfer handlers' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, _utils.isCancelError)(err_2) && err_2.message !== (0, _utils.CANCELED_ERROR_MESSAGE)) {
                            this._emitEvent(TaskEvents.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== AWSS3UploadTaskState.PAUSED) {
            var abortController = new AbortController();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, abortController.signal),
                abortController: abortController
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return __awaiter(this, void 0, void 0, function() {
            var valid, obj, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _a.sent();
                        logger.log('Could not get file on s3 for size matching: ', e_1);
                        // Don't gate verification on auth or other errors
                        // unrelated to file size verification
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (!valid) throw new Error('File size does not match between local file and file on s3');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ''
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = AWSS3UploadTaskState.IN_PROGRESS;
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytes);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        if (this._isDone()) this._completeUpload();
                        else this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, _utils.isCancelError)(err_3)) {
                            logger.error('Error initializing the upload task', err_3);
                            this._emitEvent(TaskEvents.ERROR, err_3);
                        }
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn('This task has already been cancelled');
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn('This task has already been completed');
        else if (this.state === AWSS3UploadTaskState.IN_PROGRESS) logger.warn('Upload task already in progress');
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = AWSS3UploadTaskState.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_4;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!(this.state === AWSS3UploadTaskState.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.warn('This task has already been cancelled');
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === AWSS3UploadTaskState.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.warn('This task has already been completed');
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = AWSS3UploadTaskState.CANCELLED;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        _a = (0, _s3.abortMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c)
                            ]))
                        ];
                    case 5:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 6:
                        _d.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 7:
                        err_4 = _d.sent();
                        logger.error('Error cancelling upload task', err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn('This task has already been cancelled');
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn('This task has already been completed');
        else if (this.state === AWSS3UploadTaskState.PAUSED) logger.warn('This task is already paused');
        this.state = AWSS3UploadTaskState.PAUSED;
        // Abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.abortController.abort();
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, __spreadArray([], __read(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })), false));
    };
    return AWSS3UploadTask;
}();

},{"@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","../common/S3ClientUtils":"iu1YF","../common/StorageUtils":"2VK2g","../common/StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6PDaW":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API", function() {
    return 0, _api.API;
});
parcelHelpers.export(exports, "APIClass", function() {
    return 0, _api.APIClass;
});
parcelHelpers.export(exports, "graphqlOperation", function() {
    return 0, _apiGraphql.graphqlOperation;
});
parcelHelpers.export(exports, "GraphQLAuthError", function() {
    return 0, _apiGraphql.GraphQLAuthError;
});
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", function() {
    return 0, _apiGraphql.GRAPHQL_AUTH_MODE;
});
var _api = require("./API");
var _apiGraphql = require("@aws-amplify/api-graphql");

},{"./API":"jP8On","@aws-amplify/api-graphql":"eWncu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jP8On":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APIClass", function() {
    return APIClass;
});
parcelHelpers.export(exports, "API", function() {
    return API;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internalAPI = require("./internals/InternalAPI");
var logger = new (0, _core.ConsoleLogger)('API');
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var APIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(APIClass, _super);
    function APIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APIClass.prototype.getModuleName = function() {
        return 'API';
    };
    APIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return APIClass;
}((0, _internalAPI.InternalAPIClass));
var API = new APIClass(null);
(0, _core.Amplify).register(API);

},{"tslib":"b0CnX","@aws-amplify/core":"3rlh1","./internals/InternalAPI":"icpYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b0CnX":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icpYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPIClass", function() {
    return InternalAPIClass;
});
parcelHelpers.export(exports, "InternalAPI", function() {
    return InternalAPI;
});
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api-graphql/internals");
var _apiRest = require("@aws-amplify/api-rest");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('API');
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var InternalAPIClass = /** @class */ function() {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalAPIClass(options) {
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        this._restApi = new (0, _apiRest.RestAPIClass)(options);
        this._graphqlApi = new (0, _internals.InternalGraphQLAPIClass)(options);
        logger.debug('API Options', this._options);
    }
    InternalAPIClass.prototype.getModuleName = function() {
        return 'InternalAPI';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalAPIClass.prototype.configure = function(options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.get = function(apiName, path, init) {
        return this._restApi.get(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Get));
    };
    /**
     * Make a POST request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.post = function(apiName, path, init) {
        return this._restApi.post(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Post));
    };
    /**
     * Make a PUT request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.put = function(apiName, path, init) {
        return this._restApi.put(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Put));
    };
    /**
     * Make a PATCH request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.patch = function(apiName, path, init) {
        return this._restApi.patch(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Patch));
    };
    /**
     * Make a DEL request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.del = function(apiName, path, init) {
        return this._restApi.del(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Del));
    };
    /**
     * Make a HEAD request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.head = function(apiName, path, init) {
        return this._restApi.head(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Head));
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @return If the error was from an api request cancellation
     */ InternalAPIClass.prototype.isCancel = function(error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request for either a GraphQL request or a Rest API request.
     * @param request - request to cancel
     * @param [message] - custom error message
     * @return If the request was cancelled
     */ InternalAPIClass.prototype.cancel = function(request, message) {
        if (this._restApi.hasCancelToken(request)) return this._restApi.cancel(request, message);
        else if (this._graphqlApi.hasCancelToken(request)) return this._graphqlApi.cancel(request, message);
        return false;
    };
    InternalAPIClass.prototype.getInitWithCustomUserAgentDetails = function(init, action) {
        var customUserAgentDetails = {
            category: (0, _core.Category).API,
            action: action
        };
        var initParams = (0, _tslib.__assign)((0, _tslib.__assign)({}, init), {
            customUserAgentDetails: customUserAgentDetails
        });
        return initParams;
    };
    /**
     * Getting endpoint for API
     * @param apiName - The name of the api
     * @return The endpoint of the api
     */ InternalAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._restApi.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalAPIClass.prototype.getGraphqlOperationType = function(operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    InternalAPIClass.prototype.graphql = function(options, additionalHeaders, customUserAgentDetails) {
        var apiUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).API,
            action: (0, _core.ApiAction).GraphQl
        }, customUserAgentDetails);
        return this._graphqlApi.graphql(options, additionalHeaders, apiUserAgentDetails);
    };
    return InternalAPIClass;
}();
var InternalAPI = new InternalAPIClass(null);
(0, _core.Amplify).register(InternalAPI);

},{"tslib":"b0CnX","@aws-amplify/api-graphql/internals":"fZD2p","@aws-amplify/api-rest":"by3r2","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fZD2p":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalGraphQLAPI", function() {
    return 0, _internalGraphQLAPI.InternalGraphQLAPI;
});
parcelHelpers.export(exports, "InternalGraphQLAPIClass", function() {
    return 0, _internalGraphQLAPI.InternalGraphQLAPIClass;
});
var _internalGraphQLAPI = require("./InternalGraphQLAPI");

},{"./InternalGraphQLAPI":"8V6kZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8V6kZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", function() {
    return graphqlOperation;
});
parcelHelpers.export(exports, "InternalGraphQLAPIClass", function() {
    return InternalGraphQLAPIClass;
});
parcelHelpers.export(exports, "InternalGraphQLAPI", function() {
    return InternalGraphQLAPI;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _graphql = require("graphql");
var _core = require("@aws-amplify/core");
var _internals = require("@aws-amplify/pubsub/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _types = require("../types");
var _apiRest = require("@aws-amplify/api-rest");
var USER_AGENT_HEADER = 'x-amz-user-agent';
var logger = new (0, _core.ConsoleLogger)('GraphQLAPI');
var graphqlOperation = function graphqlOperation(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var InternalGraphQLAPIClass = /** @class */ function() {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalGraphQLAPIClass(options) {
        this._api = null;
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug('API Options', this._options);
    }
    InternalGraphQLAPIClass.prototype.getModuleName = function() {
        return 'InternalGraphQLAPI';
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalGraphQLAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug('configure GraphQL API', {
            opt: opt
        });
        if (opt['aws_project_region']) opt = Object.assign({}, opt, {
            region: opt['aws_project_region'],
            header: {}
        });
        if (typeof opt.graphql_headers !== 'undefined' && typeof opt.graphql_headers !== 'function') {
            logger.warn('graphql_headers should be a function');
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ InternalGraphQLAPIClass.prototype.createInstance = function() {
        logger.debug('create Rest instance');
        if (this._options) {
            this._api = new (0, _apiRest.RestClient)(this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        } else return Promise.reject('API not configured');
    };
    InternalGraphQLAPIClass.prototype._headerBasedAuth = function(defaultAuthenticationType, additionalHeaders) {
        if (additionalHeaders === void 0) additionalHeaders = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case 'API_KEY':
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 'AWS_IAM':
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 'OPENID_CONNECT':
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 'AMAZON_COGNITO_USER_POOLS':
                                return [
                                    3 /*break*/ ,
                                    11
                                ];
                            case 'AWS_LAMBDA':
                                return [
                                    3 /*break*/ ,
                                    15
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 1:
                        if (!apiKey) throw new Error((0, _types.GraphQLAuthError).NO_API_KEY);
                        headers = {
                            Authorization: null,
                            'X-Api-Key': apiKey
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error((0, _types.GraphQLAuthError).NO_CREDENTIALS);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        _c.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        token = void 0;
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem('federatedInfo')
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            6
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) token = currentUser.token;
                        _c.label = 8;
                    case 8:
                        if (!token) throw new Error((0, _types.GraphQLAuthError).NO_FEDERATED_JWT);
                        headers = {
                            Authorization: token
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Auth.currentSession()
                        ];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        if (!additionalHeaders.Authorization) throw new Error((0, _types.GraphQLAuthError).NO_AUTH_TOKEN);
                        headers = {
                            Authorization: additionalHeaders.Authorization
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 17:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalGraphQLAPIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, _graphql.parse)(operation);
        var definitions = doc.definitions;
        var _a = (0, _tslib.__read)(definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ InternalGraphQLAPIClass.prototype.graphql = function(_a, additionalHeaders, customUserAgentDetails) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode, authToken = _a.authToken;
        var query = typeof paramQuery === 'string' ? (0, _graphql.parse)(paramQuery) : (0, _graphql.parse)((0, _graphql.print)(paramQuery));
        var _c = (0, _tslib.__read)(query.definitions.filter(function(def) {
            return def.kind === 'OperationDefinition';
        }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        var headers = additionalHeaders || {};
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) headers.Authorization = authToken;
        switch(operationType){
            case 'query':
            case 'mutation':
                this.createInstanceIfNotCreated();
                var cancellableToken = this._api.getCancellableToken();
                var initParams = {
                    cancellableToken: cancellableToken,
                    withCredentials: this._options.withCredentials
                };
                var responsePromise = this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, initParams, customUserAgentDetails);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case 'subscription':
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, customUserAgentDetails);
            default:
                throw new Error("invalid operation type: ".concat(operationType));
        }
    };
    InternalGraphQLAPIClass.prototype._graphql = function(_a, additionalHeaders, initParams, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        if (initParams === void 0) initParams = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        this.createInstanceIfNotCreated();
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function graphql_headers() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 1:
                        _e = _l.sent();
                        _l.label = 2;
                    case 2:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 3:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 5;
                    case 5:
                        _g = _h;
                        _l.label = 6;
                    case 6:
                        _j = [
                            (0, _tslib.__assign).apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 7:
                        headers = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _k)
                        ]);
                        body = {
                            query: (0, _graphql.print)(query),
                            variables: variables
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? 'appsync' : 'execute-api',
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, _graphql.GraphQLError)('No graphql endpoint provided.');
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 8;
                    case 8:
                        _l.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 9:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) throw err_1;
                        response = {
                            data: {},
                            errors: [
                                new (0, _graphql.GraphQLError)(err_1.message, null, null, null, null, err_1)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    InternalGraphQLAPIClass.prototype.createInstanceIfNotCreated = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ InternalGraphQLAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ InternalGraphQLAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ InternalGraphQLAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    InternalGraphQLAPIClass.prototype._graphqlSubscribe = function(_a, additionalHeaders, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode, authToken = _a.authToken;
        if (additionalHeaders === void 0) additionalHeaders = {};
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function graphql_headers() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
        if ((0, _internals.InternalPubSub) && typeof (0, _internals.InternalPubSub).subscribe === 'function') return (0, _internals.InternalPubSub).subscribe('', {
            provider: (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, _graphql.print)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers,
            additionalHeaders: additionalHeaders,
            authToken: authToken
        }, customUserAgentDetails);
        else {
            logger.debug('No pubsub module applied for subscription');
            throw new Error('No pubsub module applied for subscription');
        }
    };
    /**
     * @private
     */ InternalGraphQLAPIClass.prototype._ensureCredentials = function() {
        var _this = this;
        return this.Credentials.get().then(function(credentials) {
            if (!credentials) return false;
            var cred = _this.Credentials.shear(credentials);
            logger.debug('set credentials for api', cred);
            return true;
        }).catch(function(err) {
            logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return InternalGraphQLAPIClass;
}();
var InternalGraphQLAPI = new InternalGraphQLAPIClass(null);
(0, _core.Amplify).register(InternalGraphQLAPI);

},{"tslib":"fPXxt","graphql":"10HlN","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub/internals":"4KMnX","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","../types":"4viCr","@aws-amplify/api-rest":"by3r2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPXxt":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"10HlN":[function(require,module,exports,__globalThis) {
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */ // The GraphQL.js version info.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return 0, _versionMjs.version;
}) // The primary entry point into fulfilling a GraphQL request.
;
parcelHelpers.export(exports, "versionInfo", function() {
    return 0, _versionMjs.versionInfo;
});
parcelHelpers.export(exports, "graphql", function() {
    return 0, _graphqlMjs.graphql;
}) // Create and operate on GraphQL type definitions and schema.
;
parcelHelpers.export(exports, "graphqlSync", function() {
    return 0, _graphqlMjs.graphqlSync;
});
parcelHelpers.export(exports, "GraphQLSchema", function() {
    return 0, _indexMjs.GraphQLSchema;
});
parcelHelpers.export(exports, "GraphQLDirective", function() {
    return 0, _indexMjs.GraphQLDirective;
});
parcelHelpers.export(exports, "GraphQLScalarType", function() {
    return 0, _indexMjs.GraphQLScalarType;
});
parcelHelpers.export(exports, "GraphQLObjectType", function() {
    return 0, _indexMjs.GraphQLObjectType;
});
parcelHelpers.export(exports, "GraphQLInterfaceType", function() {
    return 0, _indexMjs.GraphQLInterfaceType;
});
parcelHelpers.export(exports, "GraphQLUnionType", function() {
    return 0, _indexMjs.GraphQLUnionType;
});
parcelHelpers.export(exports, "GraphQLEnumType", function() {
    return 0, _indexMjs.GraphQLEnumType;
});
parcelHelpers.export(exports, "GraphQLInputObjectType", function() {
    return 0, _indexMjs.GraphQLInputObjectType;
});
parcelHelpers.export(exports, "GraphQLList", function() {
    return 0, _indexMjs.GraphQLList;
});
parcelHelpers.export(exports, "GraphQLNonNull", function() {
    return 0, _indexMjs.GraphQLNonNull;
});
parcelHelpers.export(exports, "specifiedScalarTypes", function() {
    return 0, _indexMjs.specifiedScalarTypes;
});
parcelHelpers.export(exports, "GraphQLInt", function() {
    return 0, _indexMjs.GraphQLInt;
});
parcelHelpers.export(exports, "GraphQLFloat", function() {
    return 0, _indexMjs.GraphQLFloat;
});
parcelHelpers.export(exports, "GraphQLString", function() {
    return 0, _indexMjs.GraphQLString;
});
parcelHelpers.export(exports, "GraphQLBoolean", function() {
    return 0, _indexMjs.GraphQLBoolean;
});
parcelHelpers.export(exports, "GraphQLID", function() {
    return 0, _indexMjs.GraphQLID;
});
parcelHelpers.export(exports, "specifiedDirectives", function() {
    return 0, _indexMjs.specifiedDirectives;
});
parcelHelpers.export(exports, "GraphQLIncludeDirective", function() {
    return 0, _indexMjs.GraphQLIncludeDirective;
});
parcelHelpers.export(exports, "GraphQLSkipDirective", function() {
    return 0, _indexMjs.GraphQLSkipDirective;
});
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", function() {
    return 0, _indexMjs.GraphQLDeprecatedDirective;
});
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", function() {
    return 0, _indexMjs.GraphQLSpecifiedByDirective;
});
parcelHelpers.export(exports, "TypeKind", function() {
    return 0, _indexMjs.TypeKind;
});
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", function() {
    return 0, _indexMjs.DEFAULT_DEPRECATION_REASON;
});
parcelHelpers.export(exports, "introspectionTypes", function() {
    return 0, _indexMjs.introspectionTypes;
});
parcelHelpers.export(exports, "__Schema", function() {
    return 0, _indexMjs.__Schema;
});
parcelHelpers.export(exports, "__Directive", function() {
    return 0, _indexMjs.__Directive;
});
parcelHelpers.export(exports, "__DirectiveLocation", function() {
    return 0, _indexMjs.__DirectiveLocation;
});
parcelHelpers.export(exports, "__Type", function() {
    return 0, _indexMjs.__Type;
});
parcelHelpers.export(exports, "__Field", function() {
    return 0, _indexMjs.__Field;
});
parcelHelpers.export(exports, "__InputValue", function() {
    return 0, _indexMjs.__InputValue;
});
parcelHelpers.export(exports, "__EnumValue", function() {
    return 0, _indexMjs.__EnumValue;
});
parcelHelpers.export(exports, "__TypeKind", function() {
    return 0, _indexMjs.__TypeKind;
});
parcelHelpers.export(exports, "SchemaMetaFieldDef", function() {
    return 0, _indexMjs.SchemaMetaFieldDef;
});
parcelHelpers.export(exports, "TypeMetaFieldDef", function() {
    return 0, _indexMjs.TypeMetaFieldDef;
});
parcelHelpers.export(exports, "TypeNameMetaFieldDef", function() {
    return 0, _indexMjs.TypeNameMetaFieldDef;
});
parcelHelpers.export(exports, "isSchema", function() {
    return 0, _indexMjs.isSchema;
});
parcelHelpers.export(exports, "isDirective", function() {
    return 0, _indexMjs.isDirective;
});
parcelHelpers.export(exports, "isType", function() {
    return 0, _indexMjs.isType;
});
parcelHelpers.export(exports, "isScalarType", function() {
    return 0, _indexMjs.isScalarType;
});
parcelHelpers.export(exports, "isObjectType", function() {
    return 0, _indexMjs.isObjectType;
});
parcelHelpers.export(exports, "isInterfaceType", function() {
    return 0, _indexMjs.isInterfaceType;
});
parcelHelpers.export(exports, "isUnionType", function() {
    return 0, _indexMjs.isUnionType;
});
parcelHelpers.export(exports, "isEnumType", function() {
    return 0, _indexMjs.isEnumType;
});
parcelHelpers.export(exports, "isInputObjectType", function() {
    return 0, _indexMjs.isInputObjectType;
});
parcelHelpers.export(exports, "isListType", function() {
    return 0, _indexMjs.isListType;
});
parcelHelpers.export(exports, "isNonNullType", function() {
    return 0, _indexMjs.isNonNullType;
});
parcelHelpers.export(exports, "isInputType", function() {
    return 0, _indexMjs.isInputType;
});
parcelHelpers.export(exports, "isOutputType", function() {
    return 0, _indexMjs.isOutputType;
});
parcelHelpers.export(exports, "isLeafType", function() {
    return 0, _indexMjs.isLeafType;
});
parcelHelpers.export(exports, "isCompositeType", function() {
    return 0, _indexMjs.isCompositeType;
});
parcelHelpers.export(exports, "isAbstractType", function() {
    return 0, _indexMjs.isAbstractType;
});
parcelHelpers.export(exports, "isWrappingType", function() {
    return 0, _indexMjs.isWrappingType;
});
parcelHelpers.export(exports, "isNullableType", function() {
    return 0, _indexMjs.isNullableType;
});
parcelHelpers.export(exports, "isNamedType", function() {
    return 0, _indexMjs.isNamedType;
});
parcelHelpers.export(exports, "isRequiredArgument", function() {
    return 0, _indexMjs.isRequiredArgument;
});
parcelHelpers.export(exports, "isRequiredInputField", function() {
    return 0, _indexMjs.isRequiredInputField;
});
parcelHelpers.export(exports, "isSpecifiedScalarType", function() {
    return 0, _indexMjs.isSpecifiedScalarType;
});
parcelHelpers.export(exports, "isIntrospectionType", function() {
    return 0, _indexMjs.isIntrospectionType;
});
parcelHelpers.export(exports, "isSpecifiedDirective", function() {
    return 0, _indexMjs.isSpecifiedDirective;
});
parcelHelpers.export(exports, "assertSchema", function() {
    return 0, _indexMjs.assertSchema;
});
parcelHelpers.export(exports, "assertDirective", function() {
    return 0, _indexMjs.assertDirective;
});
parcelHelpers.export(exports, "assertType", function() {
    return 0, _indexMjs.assertType;
});
parcelHelpers.export(exports, "assertScalarType", function() {
    return 0, _indexMjs.assertScalarType;
});
parcelHelpers.export(exports, "assertObjectType", function() {
    return 0, _indexMjs.assertObjectType;
});
parcelHelpers.export(exports, "assertInterfaceType", function() {
    return 0, _indexMjs.assertInterfaceType;
});
parcelHelpers.export(exports, "assertUnionType", function() {
    return 0, _indexMjs.assertUnionType;
});
parcelHelpers.export(exports, "assertEnumType", function() {
    return 0, _indexMjs.assertEnumType;
});
parcelHelpers.export(exports, "assertInputObjectType", function() {
    return 0, _indexMjs.assertInputObjectType;
});
parcelHelpers.export(exports, "assertListType", function() {
    return 0, _indexMjs.assertListType;
});
parcelHelpers.export(exports, "assertNonNullType", function() {
    return 0, _indexMjs.assertNonNullType;
});
parcelHelpers.export(exports, "assertInputType", function() {
    return 0, _indexMjs.assertInputType;
});
parcelHelpers.export(exports, "assertOutputType", function() {
    return 0, _indexMjs.assertOutputType;
});
parcelHelpers.export(exports, "assertLeafType", function() {
    return 0, _indexMjs.assertLeafType;
});
parcelHelpers.export(exports, "assertCompositeType", function() {
    return 0, _indexMjs.assertCompositeType;
});
parcelHelpers.export(exports, "assertAbstractType", function() {
    return 0, _indexMjs.assertAbstractType;
});
parcelHelpers.export(exports, "assertWrappingType", function() {
    return 0, _indexMjs.assertWrappingType;
});
parcelHelpers.export(exports, "assertNullableType", function() {
    return 0, _indexMjs.assertNullableType;
});
parcelHelpers.export(exports, "assertNamedType", function() {
    return 0, _indexMjs.assertNamedType;
});
parcelHelpers.export(exports, "getNullableType", function() {
    return 0, _indexMjs.getNullableType;
});
parcelHelpers.export(exports, "getNamedType", function() {
    return 0, _indexMjs.getNamedType;
});
parcelHelpers.export(exports, "validateSchema", function() {
    return 0, _indexMjs.validateSchema;
});
parcelHelpers.export(exports, "assertValidSchema", function() {
    return 0, _indexMjs.assertValidSchema;
});
// Parse and operate on GraphQL language source files.
parcelHelpers.export(exports, "Token", function() {
    return 0, _indexMjs1.Token;
});
parcelHelpers.export(exports, "Source", function() {
    return 0, _indexMjs1.Source;
});
parcelHelpers.export(exports, "Location", function() {
    return 0, _indexMjs1.Location;
});
parcelHelpers.export(exports, "getLocation", function() {
    return 0, _indexMjs1.getLocation;
});
parcelHelpers.export(exports, "printLocation", function() {
    return 0, _indexMjs1.printLocation;
});
parcelHelpers.export(exports, "printSourceLocation", function() {
    return 0, _indexMjs1.printSourceLocation;
});
parcelHelpers.export(exports, "Lexer", function() {
    return 0, _indexMjs1.Lexer;
});
parcelHelpers.export(exports, "TokenKind", function() {
    return 0, _indexMjs1.TokenKind;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _indexMjs1.parse;
});
parcelHelpers.export(exports, "parseValue", function() {
    return 0, _indexMjs1.parseValue;
});
parcelHelpers.export(exports, "parseType", function() {
    return 0, _indexMjs1.parseType;
});
parcelHelpers.export(exports, "print", function() {
    return 0, _indexMjs1.print;
});
parcelHelpers.export(exports, "visit", function() {
    return 0, _indexMjs1.visit;
});
parcelHelpers.export(exports, "visitInParallel", function() {
    return 0, _indexMjs1.visitInParallel;
});
parcelHelpers.export(exports, "getVisitFn", function() {
    return 0, _indexMjs1.getVisitFn;
});
parcelHelpers.export(exports, "BREAK", function() {
    return 0, _indexMjs1.BREAK;
});
parcelHelpers.export(exports, "Kind", function() {
    return 0, _indexMjs1.Kind;
});
parcelHelpers.export(exports, "DirectiveLocation", function() {
    return 0, _indexMjs1.DirectiveLocation;
});
parcelHelpers.export(exports, "isDefinitionNode", function() {
    return 0, _indexMjs1.isDefinitionNode;
});
parcelHelpers.export(exports, "isExecutableDefinitionNode", function() {
    return 0, _indexMjs1.isExecutableDefinitionNode;
});
parcelHelpers.export(exports, "isSelectionNode", function() {
    return 0, _indexMjs1.isSelectionNode;
});
parcelHelpers.export(exports, "isValueNode", function() {
    return 0, _indexMjs1.isValueNode;
});
parcelHelpers.export(exports, "isTypeNode", function() {
    return 0, _indexMjs1.isTypeNode;
});
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", function() {
    return 0, _indexMjs1.isTypeSystemDefinitionNode;
});
parcelHelpers.export(exports, "isTypeDefinitionNode", function() {
    return 0, _indexMjs1.isTypeDefinitionNode;
});
parcelHelpers.export(exports, "isTypeSystemExtensionNode", function() {
    return 0, _indexMjs1.isTypeSystemExtensionNode;
});
parcelHelpers.export(exports, "isTypeExtensionNode", function() {
    return 0, _indexMjs1.isTypeExtensionNode;
});
// Execute GraphQL queries.
parcelHelpers.export(exports, "execute", function() {
    return 0, _indexMjs2.execute;
});
parcelHelpers.export(exports, "executeSync", function() {
    return 0, _indexMjs2.executeSync;
});
parcelHelpers.export(exports, "defaultFieldResolver", function() {
    return 0, _indexMjs2.defaultFieldResolver;
});
parcelHelpers.export(exports, "defaultTypeResolver", function() {
    return 0, _indexMjs2.defaultTypeResolver;
});
parcelHelpers.export(exports, "responsePathAsArray", function() {
    return 0, _indexMjs2.responsePathAsArray;
});
parcelHelpers.export(exports, "getDirectiveValues", function() {
    return 0, _indexMjs2.getDirectiveValues;
});
parcelHelpers.export(exports, "subscribe", function() {
    return 0, _indexMjs3.subscribe;
});
parcelHelpers.export(exports, "createSourceEventStream", function() {
    return 0, _indexMjs3.createSourceEventStream;
});
// Validate GraphQL documents.
parcelHelpers.export(exports, "validate", function() {
    return 0, _indexMjs4.validate;
});
parcelHelpers.export(exports, "ValidationContext", function() {
    return 0, _indexMjs4.ValidationContext;
});
parcelHelpers.export(exports, "specifiedRules", function() {
    return 0, _indexMjs4.specifiedRules;
});
parcelHelpers.export(exports, "ExecutableDefinitionsRule", function() {
    return 0, _indexMjs4.ExecutableDefinitionsRule;
});
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", function() {
    return 0, _indexMjs4.FieldsOnCorrectTypeRule;
});
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", function() {
    return 0, _indexMjs4.FragmentsOnCompositeTypesRule;
});
parcelHelpers.export(exports, "KnownArgumentNamesRule", function() {
    return 0, _indexMjs4.KnownArgumentNamesRule;
});
parcelHelpers.export(exports, "KnownDirectivesRule", function() {
    return 0, _indexMjs4.KnownDirectivesRule;
});
parcelHelpers.export(exports, "KnownFragmentNamesRule", function() {
    return 0, _indexMjs4.KnownFragmentNamesRule;
});
parcelHelpers.export(exports, "KnownTypeNamesRule", function() {
    return 0, _indexMjs4.KnownTypeNamesRule;
});
parcelHelpers.export(exports, "LoneAnonymousOperationRule", function() {
    return 0, _indexMjs4.LoneAnonymousOperationRule;
});
parcelHelpers.export(exports, "NoFragmentCyclesRule", function() {
    return 0, _indexMjs4.NoFragmentCyclesRule;
});
parcelHelpers.export(exports, "NoUndefinedVariablesRule", function() {
    return 0, _indexMjs4.NoUndefinedVariablesRule;
});
parcelHelpers.export(exports, "NoUnusedFragmentsRule", function() {
    return 0, _indexMjs4.NoUnusedFragmentsRule;
});
parcelHelpers.export(exports, "NoUnusedVariablesRule", function() {
    return 0, _indexMjs4.NoUnusedVariablesRule;
});
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", function() {
    return 0, _indexMjs4.OverlappingFieldsCanBeMergedRule;
});
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", function() {
    return 0, _indexMjs4.PossibleFragmentSpreadsRule;
});
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", function() {
    return 0, _indexMjs4.ProvidedRequiredArgumentsRule;
});
parcelHelpers.export(exports, "ScalarLeafsRule", function() {
    return 0, _indexMjs4.ScalarLeafsRule;
});
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", function() {
    return 0, _indexMjs4.SingleFieldSubscriptionsRule;
});
parcelHelpers.export(exports, "UniqueArgumentNamesRule", function() {
    return 0, _indexMjs4.UniqueArgumentNamesRule;
});
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", function() {
    return 0, _indexMjs4.UniqueDirectivesPerLocationRule;
});
parcelHelpers.export(exports, "UniqueFragmentNamesRule", function() {
    return 0, _indexMjs4.UniqueFragmentNamesRule;
});
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", function() {
    return 0, _indexMjs4.UniqueInputFieldNamesRule;
});
parcelHelpers.export(exports, "UniqueOperationNamesRule", function() {
    return 0, _indexMjs4.UniqueOperationNamesRule;
});
parcelHelpers.export(exports, "UniqueVariableNamesRule", function() {
    return 0, _indexMjs4.UniqueVariableNamesRule;
});
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", function() {
    return 0, _indexMjs4.ValuesOfCorrectTypeRule;
});
parcelHelpers.export(exports, "VariablesAreInputTypesRule", function() {
    return 0, _indexMjs4.VariablesAreInputTypesRule;
});
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", function() {
    return 0, _indexMjs4.VariablesInAllowedPositionRule;
});
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", function() {
    return 0, _indexMjs4.LoneSchemaDefinitionRule;
});
parcelHelpers.export(exports, "UniqueOperationTypesRule", function() {
    return 0, _indexMjs4.UniqueOperationTypesRule;
});
parcelHelpers.export(exports, "UniqueTypeNamesRule", function() {
    return 0, _indexMjs4.UniqueTypeNamesRule;
});
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", function() {
    return 0, _indexMjs4.UniqueEnumValueNamesRule;
});
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", function() {
    return 0, _indexMjs4.UniqueFieldDefinitionNamesRule;
});
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", function() {
    return 0, _indexMjs4.UniqueDirectiveNamesRule;
});
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", function() {
    return 0, _indexMjs4.PossibleTypeExtensionsRule;
});
parcelHelpers.export(exports, "NoDeprecatedCustomRule", function() {
    return 0, _indexMjs4.NoDeprecatedCustomRule;
});
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", function() {
    return 0, _indexMjs4.NoSchemaIntrospectionCustomRule;
});
// Create, format, and print GraphQL errors.
parcelHelpers.export(exports, "GraphQLError", function() {
    return 0, _indexMjs5.GraphQLError;
});
parcelHelpers.export(exports, "syntaxError", function() {
    return 0, _indexMjs5.syntaxError;
});
parcelHelpers.export(exports, "locatedError", function() {
    return 0, _indexMjs5.locatedError;
});
parcelHelpers.export(exports, "printError", function() {
    return 0, _indexMjs5.printError;
});
parcelHelpers.export(exports, "formatError", function() {
    return 0, _indexMjs5.formatError;
});
// Utilities for operating on GraphQL type schema and parsed sources.
parcelHelpers.export(exports, "getIntrospectionQuery", function() {
    return 0, _indexMjs6.getIntrospectionQuery;
});
parcelHelpers.export(exports, "getOperationAST", function() {
    return 0, _indexMjs6.getOperationAST;
});
parcelHelpers.export(exports, "getOperationRootType", function() {
    return 0, _indexMjs6.getOperationRootType;
});
parcelHelpers.export(exports, "introspectionFromSchema", function() {
    return 0, _indexMjs6.introspectionFromSchema;
});
parcelHelpers.export(exports, "buildClientSchema", function() {
    return 0, _indexMjs6.buildClientSchema;
});
parcelHelpers.export(exports, "buildASTSchema", function() {
    return 0, _indexMjs6.buildASTSchema;
});
parcelHelpers.export(exports, "buildSchema", function() {
    return 0, _indexMjs6.buildSchema;
});
parcelHelpers.export(exports, "getDescription", function() {
    return 0, _indexMjs6.getDescription;
});
parcelHelpers.export(exports, "extendSchema", function() {
    return 0, _indexMjs6.extendSchema;
});
parcelHelpers.export(exports, "lexicographicSortSchema", function() {
    return 0, _indexMjs6.lexicographicSortSchema;
});
parcelHelpers.export(exports, "printSchema", function() {
    return 0, _indexMjs6.printSchema;
});
parcelHelpers.export(exports, "printType", function() {
    return 0, _indexMjs6.printType;
});
parcelHelpers.export(exports, "printIntrospectionSchema", function() {
    return 0, _indexMjs6.printIntrospectionSchema;
});
parcelHelpers.export(exports, "typeFromAST", function() {
    return 0, _indexMjs6.typeFromAST;
});
parcelHelpers.export(exports, "valueFromAST", function() {
    return 0, _indexMjs6.valueFromAST;
});
parcelHelpers.export(exports, "valueFromASTUntyped", function() {
    return 0, _indexMjs6.valueFromASTUntyped;
});
parcelHelpers.export(exports, "astFromValue", function() {
    return 0, _indexMjs6.astFromValue;
});
parcelHelpers.export(exports, "TypeInfo", function() {
    return 0, _indexMjs6.TypeInfo;
});
parcelHelpers.export(exports, "visitWithTypeInfo", function() {
    return 0, _indexMjs6.visitWithTypeInfo;
});
parcelHelpers.export(exports, "coerceInputValue", function() {
    return 0, _indexMjs6.coerceInputValue;
});
parcelHelpers.export(exports, "concatAST", function() {
    return 0, _indexMjs6.concatAST;
});
parcelHelpers.export(exports, "separateOperations", function() {
    return 0, _indexMjs6.separateOperations;
});
parcelHelpers.export(exports, "stripIgnoredCharacters", function() {
    return 0, _indexMjs6.stripIgnoredCharacters;
});
parcelHelpers.export(exports, "isEqualType", function() {
    return 0, _indexMjs6.isEqualType;
});
parcelHelpers.export(exports, "isTypeSubTypeOf", function() {
    return 0, _indexMjs6.isTypeSubTypeOf;
});
parcelHelpers.export(exports, "doTypesOverlap", function() {
    return 0, _indexMjs6.doTypesOverlap;
});
parcelHelpers.export(exports, "assertValidName", function() {
    return 0, _indexMjs6.assertValidName;
});
parcelHelpers.export(exports, "isValidNameError", function() {
    return 0, _indexMjs6.isValidNameError;
});
parcelHelpers.export(exports, "BreakingChangeType", function() {
    return 0, _indexMjs6.BreakingChangeType;
});
parcelHelpers.export(exports, "DangerousChangeType", function() {
    return 0, _indexMjs6.DangerousChangeType;
});
parcelHelpers.export(exports, "findBreakingChanges", function() {
    return 0, _indexMjs6.findBreakingChanges;
});
parcelHelpers.export(exports, "findDangerousChanges", function() {
    return 0, _indexMjs6.findDangerousChanges;
});
parcelHelpers.export(exports, "findDeprecatedUsages", function() {
    return 0, _indexMjs6.findDeprecatedUsages;
});
var _versionMjs = require("./version.mjs");
var _graphqlMjs = require("./graphql.mjs");
var _indexMjs = require("./type/index.mjs");
var _indexMjs1 = require("./language/index.mjs");
var _indexMjs2 = require("./execution/index.mjs");
var _indexMjs3 = require("./subscription/index.mjs");
var _indexMjs4 = require("./validation/index.mjs");
var _indexMjs5 = require("./error/index.mjs");
var _indexMjs6 = require("./utilities/index.mjs");

},{"./version.mjs":"4XzyB","./graphql.mjs":"4QmNS","./type/index.mjs":"lpt1P","./language/index.mjs":"gn83r","./execution/index.mjs":"cGDrM","./subscription/index.mjs":"bzHzs","./validation/index.mjs":"67Cb0","./error/index.mjs":"7JUwy","./utilities/index.mjs":"2INRG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4XzyB":[function(require,module,exports,__globalThis) {
/**
 * Note: This file is autogenerated using "resources/gen-version.js" script and
 * automatically updated by "npm version" command.
 */ /**
 * A string containing the version of the GraphQL.js library
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", function() {
    return version;
});
parcelHelpers.export(exports, "versionInfo", function() {
    return versionInfo;
});
var version = '15.8.0';
var versionInfo = Object.freeze({
    major: 15,
    minor: 8,
    patch: 0,
    preReleaseTag: null
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4QmNS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * contextValue:
 *    The context value is provided as an argument to resolver functions after
 *    field arguments. It is used to pass shared information useful at any point
 *    during executing this query, for example the currently logged in user and
 *    connections to databases or other services.
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 * typeResolver:
 *    A type resolver function to use when none is provided by the schema.
 *    If not provided, the default type resolver is used (which looks for a
 *    `__typename` field or alternatively calls the `isTypeOf` method).
 */ parcelHelpers.export(exports, "graphql", function() {
    return graphql;
});
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */ parcelHelpers.export(exports, "graphqlSync", function() {
    return graphqlSync;
});
var _isPromiseMjs = require("./jsutils/isPromise.mjs");
var _isPromiseMjsDefault = parcelHelpers.interopDefault(_isPromiseMjs);
var _parserMjs = require("./language/parser.mjs");
var _validateMjs = require("./validation/validate.mjs");
var _validateMjs1 = require("./type/validate.mjs");
var _executeMjs = require("./execution/execute.mjs");
function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    var _arguments = arguments;
    /* eslint-enable no-redeclare */ // Always return a Promise for a consistent API.
    return new Promise(function(resolve) {
        return resolve(_arguments.length === 1 ? graphqlImpl(argsOrSchema) : graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        }));
    });
}
function graphqlSync(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    var result = arguments.length === 1 ? graphqlImpl(argsOrSchema) : graphqlImpl({
        schema: argsOrSchema,
        source: source,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    }); // Assert that the execution was synchronous.
    if ((0, _isPromiseMjsDefault.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function graphqlImpl(args) {
    var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // Validate Schema
    var schemaValidationErrors = (0, _validateMjs1.validateSchema)(schema);
    if (schemaValidationErrors.length > 0) return {
        errors: schemaValidationErrors
    };
     // Parse
    var document;
    try {
        document = (0, _parserMjs.parse)(source);
    } catch (syntaxError) {
        return {
            errors: [
                syntaxError
            ]
        };
    } // Validate
    var validationErrors = (0, _validateMjs.validate)(schema, document);
    if (validationErrors.length > 0) return {
        errors: validationErrors
    };
     // Execute
    return (0, _executeMjs.execute)({
        schema: schema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}

},{"./jsutils/isPromise.mjs":"5tmMu","./language/parser.mjs":"Q1jFp","./validation/validate.mjs":"OZYxA","./type/validate.mjs":"70lDP","./execution/execute.mjs":"e0yfk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5tmMu":[function(require,module,exports,__globalThis) {
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */ // eslint-disable-next-line no-redeclare
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPromise;
});
function isPromise(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Q1jFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Configuration options to control parser behavior
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ parcelHelpers.export(exports, "parse", function() {
    return parse;
});
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ parcelHelpers.export(exports, "parseValue", function() {
    return parseValue;
});
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ parcelHelpers.export(exports, "parseType", function() {
    return parseType;
});
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _kindsMjs = require("./kinds.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _sourceMjs = require("./source.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");
var _lexerMjs = require("./lexer.mjs");
function parse(source, options) {
    var parser = new Parser(source, options);
    return parser.parseDocument();
}
function parseValue(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return value;
}
function parseType(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return type;
}
var Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, _sourceMjs.isSource)(source) ? source : new (0, _sourceMjs.Source)(source);
        this._lexer = new (0, _lexerMjs.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        return {
            kind: (0, _kindsMjs.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).DOCUMENT,
            definitions: this.many((0, _tokenKindMjs.TokenKind).SOF, this.parseDefinition, (0, _tokenKindMjs.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseVariableDefinition, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).DOLLAR);
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).SELECTION_SET,
            selections: this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseSelection, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, _tokenKindMjs.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, _kindsMjs.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, item, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, _tokenKindMjs.TokenKind).NAME)) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, _tokenKindMjs.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, _tokenKindMjs.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, _tokenKindMjs.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).STRING:
            case (0, _tokenKindMjs.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, _tokenKindMjs.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, _kindsMjs.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, _kindsMjs.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, _tokenKindMjs.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, _kindsMjs.Kind).STRING,
            value: token.value,
            block: token.kind === (0, _tokenKindMjs.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).LIST,
            values: this.any((0, _tokenKindMjs.TokenKind).BRACKET_L, item, (0, _tokenKindMjs.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).OBJECT,
            fields: this.any((0, _tokenKindMjs.TokenKind).BRACE_L, item, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, _tokenKindMjs.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, _tokenKindMjs.TokenKind).BRACKET_R);
            type = {
                kind: (0, _kindsMjs.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BANG)) return {
            kind: (0, _kindsMjs.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, _tokenKindMjs.TokenKind).STRING) || this.peek((0, _tokenKindMjs.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP) || this.peek((0, _tokenKindMjs.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, _tokenKindMjs.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseFieldDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, _directiveLocationMjs.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, _astMjs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function getTokenDesc(token) {
    var value = token.value;
    return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function getTokenKindDesc(kind) {
    return (0, _lexerMjs.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

},{"../error/syntaxError.mjs":"hOPJ2","./kinds.mjs":"ffJlp","./ast.mjs":"diDO0","./tokenKind.mjs":"2TYsC","./source.mjs":"llYv9","./directiveLocation.mjs":"tgdMp","./lexer.mjs":"6UkL9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hOPJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ parcelHelpers.export(exports, "syntaxError", function() {
    return syntaxError;
});
var _graphQLErrorMjs = require("./GraphQLError.mjs");
function syntaxError(source, position, description) {
    return new (0, _graphQLErrorMjs.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

},{"./GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e4y57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", function() {
    return GraphQLError;
});
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ parcelHelpers.export(exports, "printError", function() {
    return printError;
});
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _locationMjs = require("../language/location.mjs");
var _printLocationMjs = require("../language/printLocation.mjs");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var GraphQLError = /*#__PURE__*/ function(_Error) {
    _inherits(GraphQLError, _Error);
    var _super = _createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        _classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, _locationMjs.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, _locationMjs.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, _isObjectLikeMjsDefault.default)(originalExtensions)) _this.extensions = _objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties(_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty(_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return _possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty(_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    _createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return printError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, _printLocationMjs.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, _printLocationMjs.printSourceLocation)(error.source, location);
    }
    return output;
}

},{"../jsutils/isObjectLike.mjs":"ji7lb","../polyfills/symbols.mjs":"26hb6","../language/location.mjs":"eMiPl","../language/printLocation.mjs":"hQEyy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ji7lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isObjectLike;
});
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isObjectLike(value) {
    return _typeof(value) == 'object' && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"26hb6":[function(require,module,exports,__globalThis) {
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SYMBOL_ITERATOR", function() {
    return SYMBOL_ITERATOR;
});
parcelHelpers.export(exports, "SYMBOL_ASYNC_ITERATOR", function() {
    return SYMBOL_ASYNC_ITERATOR;
});
parcelHelpers.export(exports, "SYMBOL_TO_STRING_TAG", function() {
    return SYMBOL_TO_STRING_TAG;
});
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eMiPl":[function(require,module,exports,__globalThis) {
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocation", function() {
    return getLocation;
});
function getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hQEyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printLocation", function() {
    return printLocation;
});
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printSourceLocation", function() {
    return printSourceLocation;
});
var _locationMjs = require("./location.mjs");
function printLocation(location) {
    return printSourceLocation(location.source, (0, _locationMjs.getLocation)(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function whitespace(len) {
    return Array(len + 1).join(' ');
}
function leftPad(len, str) {
    return whitespace(len - str.length) + str;
}

},{"./location.mjs":"eMiPl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ffJlp":[function(require,module,exports,__globalThis) {
/**
 * The set of allowed kind values for AST nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Kind", function() {
    return Kind;
});
var Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"diDO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Location", function() {
    return Location;
});
parcelHelpers.export(exports, "Token", function() {
    return Token;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "isNode", function() {
    return isNode;
}) /**
 * The list of all possible AST node types.
 */ ;
var _defineInspectMjs = require("../jsutils/defineInspect.mjs");
var _defineInspectMjsDefault = parcelHelpers.interopDefault(_defineInspectMjs);
var Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Location);
var Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Token);
function isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
}

},{"../jsutils/defineInspect.mjs":"8FViL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FViL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return defineInspect;
});
var _invariantMjs = require("./invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, _invariantMjsDefault.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, _nodejsCustomInspectSymbolMjsDefault.default) classObject.prototype[0, _nodejsCustomInspectSymbolMjsDefault.default] = fn;
}

},{"./invariant.mjs":"agtax","./nodejsCustomInspectSymbol.mjs":"9CTVu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"agtax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return invariant;
});
function invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CTVu":[function(require,module,exports,__globalThis) {
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
exports.default = nodejsCustomInspectSymbol;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2TYsC":[function(require,module,exports,__globalThis) {
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenKind", function() {
    return TokenKind;
});
var TokenKind = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"llYv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", function() {
    return Source;
});
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isSource", function() {
    return isSource;
});
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Source = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, _devAssertMjsDefault.default)(0, "Body must be a string. Received: ".concat((0, _inspectMjsDefault.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, _devAssertMjsDefault.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, _devAssertMjsDefault.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    _createClass(Source, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function isSource(source) {
    return (0, _instanceOfMjsDefault.default)(source, Source);
}

},{"../polyfills/symbols.mjs":"26hb6","../jsutils/inspect.mjs":"4vyEo","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/instanceOf.mjs":"4pPiF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4vyEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return inspect;
});
/* eslint-disable flowtype/no-weak-types */ var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
    return formatValue(value, []);
}
function formatValue(value, seenValues) {
    switch(_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return formatArray(value, seenValues);
    return formatObject(value, seenValues);
}
function formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return '[' + getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min(MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push(formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function getCustomFn(object) {
    var customInspectFn = object[String((0, _nodejsCustomInspectSymbolMjsDefault.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

},{"./nodejsCustomInspectSymbol.mjs":"9CTVu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dIY2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return devAssert;
});
function devAssert(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4pPiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inspectMjs = require("./inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
exports.default = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

},{"./inspect.mjs":"4vyEo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tgdMp":[function(require,module,exports,__globalThis) {
/**
 * The set of allowed directive location values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectiveLocation", function() {
    return DirectiveLocation;
});
var DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6UkL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lexer", function() {
    return Lexer;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "isPunctuatorTokenKind", function() {
    return isPunctuatorTokenKind;
});
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _blockStringMjs = require("./blockString.mjs");
var Lexer = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, _tokenKindMjs.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
        }while (token.kind === (0, _tokenKindMjs.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function isPunctuatorTokenKind(kind) {
    return kind === (0, _tokenKindMjs.TokenKind).BANG || kind === (0, _tokenKindMjs.TokenKind).DOLLAR || kind === (0, _tokenKindMjs.TokenKind).AMP || kind === (0, _tokenKindMjs.TokenKind).PAREN_L || kind === (0, _tokenKindMjs.TokenKind).PAREN_R || kind === (0, _tokenKindMjs.TokenKind).SPREAD || kind === (0, _tokenKindMjs.TokenKind).COLON || kind === (0, _tokenKindMjs.TokenKind).EQUALS || kind === (0, _tokenKindMjs.TokenKind).AT || kind === (0, _tokenKindMjs.TokenKind).BRACKET_L || kind === (0, _tokenKindMjs.TokenKind).BRACKET_R || kind === (0, _tokenKindMjs.TokenKind).BRACE_L || kind === (0, _tokenKindMjs.TokenKind).PIPE || kind === (0, _tokenKindMjs.TokenKind).BRACE_R;
}
function printCharCode(code) {
    return isNaN(code) ? (0, _tokenKindMjs.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return readBlockString(source, pos, _line, _col, prev, lexer);
                return readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return readName(source, pos, _line, _col, prev);
        }
        throw (0, _syntaxErrorMjs.syntaxError)(source, pos, unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    } else {
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || isNameStart(code)) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
    return new (0, _astMjs.Token)(isFloat ? (0, _tokenKindMjs.TokenKind).FLOAT : (0, _tokenKindMjs.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringMjs.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function uniCharCode(a, b, c, d) {
    return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

},{"../error/syntaxError.mjs":"hOPJ2","./ast.mjs":"diDO0","./tokenKind.mjs":"2TYsC","./blockString.mjs":"Ye6Ih","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Ye6Ih":[function(require,module,exports,__globalThis) {
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dedentBlockStringValue", function() {
    return dedentBlockStringValue;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "getBlockStringIndentation", function() {
    return getBlockStringIndentation;
});
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ parcelHelpers.export(exports, "printBlockString", function() {
    return printBlockString;
});
function dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OZYxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */ parcelHelpers.export(exports, "validate", function() {
    return validate;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "validateSDL", function() {
    return validateSDL;
});
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */ parcelHelpers.export(exports, "assertValidSDL", function() {
    return assertValidSDL;
});
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */ parcelHelpers.export(exports, "assertValidSDLExtension", function() {
    return assertValidSDLExtension;
});
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _visitorMjs = require("../language/visitor.mjs");
var _validateMjs = require("../type/validate.mjs");
var _typeInfoMjs = require("../utilities/TypeInfo.mjs");
var _specifiedRulesMjs = require("./specifiedRules.mjs");
var _validationContextMjs = require("./ValidationContext.mjs");
function validate(schema, documentAST) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _specifiedRulesMjs.specifiedRules);
    var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, _typeInfoMjs.TypeInfo)(schema);
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        maxErrors: undefined
    };
    documentAST || (0, _devAssertMjsDefault.default)(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.
    (0, _validateMjs.assertValidSchema)(schema);
    var abortObj = Object.freeze({});
    var errors = [];
    var context = new (0, _validationContextMjs.ValidationContext)(schema, documentAST, typeInfo, function(error) {
        if (options.maxErrors != null && errors.length >= options.maxErrors) {
            errors.push(new (0, _graphQLErrorMjs.GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    var visitor = (0, _visitorMjs.visitInParallel)(rules.map(function(rule) {
        return rule(context);
    })); // Visit the whole document with each instance of all provided rules.
    try {
        (0, _visitorMjs.visit)(documentAST, (0, _typeInfoMjs.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function validateSDL(documentAST, schemaToExtend) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _specifiedRulesMjs.specifiedSDLRules);
    var errors = [];
    var context = new (0, _validationContextMjs.SDLValidationContext)(documentAST, schemaToExtend, function(error) {
        errors.push(error);
    });
    var visitors = rules.map(function(rule) {
        return rule(context);
    });
    (0, _visitorMjs.visit)(documentAST, (0, _visitorMjs.visitInParallel)(visitors));
    return errors;
}
function assertValidSDL(documentAST) {
    var errors = validateSDL(documentAST);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
function assertValidSDLExtension(documentAST, schema) {
    var errors = validateSDL(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}

},{"../jsutils/devAssert.mjs":"dIY2Y","../error/GraphQLError.mjs":"e4y57","../language/visitor.mjs":"aHQOA","../type/validate.mjs":"70lDP","../utilities/TypeInfo.mjs":"ju2gk","./specifiedRules.mjs":"1HAr9","./ValidationContext.mjs":"b8dcx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aHQOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryDocumentKeys", function() {
    return QueryDocumentKeys;
});
parcelHelpers.export(exports, "BREAK", function() {
    return BREAK;
});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ parcelHelpers.export(exports, "visit", function() {
    return visit;
});
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ parcelHelpers.export(exports, "visitInParallel", function() {
    return visitInParallel;
});
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ parcelHelpers.export(exports, "getVisitFn", function() {
    return getVisitFn;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _astMjs = require("./ast.mjs");
var QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var BREAK = Object.freeze({});
function visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, _astMjs.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, _inspectMjsDefault.default)(node), "."));
            var visitFn = getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, _astMjs.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === BREAK) skipping[i] = BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === BREAK) skipping[i] = BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

},{"../jsutils/inspect.mjs":"4vyEo","./ast.mjs":"diDO0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"70lDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */ parcelHelpers.export(exports, "validateSchema", function() {
    return validateSchema;
});
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */ parcelHelpers.export(exports, "assertValidSchema", function() {
    return assertValidSchema;
});
var _findMjs = require("../polyfills/find.mjs");
var _findMjsDefault = parcelHelpers.interopDefault(_findMjs);
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _locatedErrorMjs = require("../error/locatedError.mjs");
var _assertValidNameMjs = require("../utilities/assertValidName.mjs");
var _typeComparatorsMjs = require("../utilities/typeComparators.mjs");
var _schemaMjs = require("./schema.mjs");
var _introspectionMjs = require("./introspection.mjs");
var _directivesMjs = require("./directives.mjs");
var _definitionMjs = require("./definition.mjs");
function validateSchema(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, _schemaMjs.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    var context = new SchemaValidationContext(schema);
    validateRootTypes(context);
    validateDirectives(context);
    validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    var errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function assertValidSchema(schema) {
    var errors = validateSchema(schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
var SchemaValidationContext = /*#__PURE__*/ function() {
    function SchemaValidationContext(schema) {
        this._errors = [];
        this.schema = schema;
    }
    var _proto = SchemaValidationContext.prototype;
    _proto.reportError = function reportError(message, nodes) {
        var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this.addError(new (0, _graphQLErrorMjs.GraphQLError)(message, _nodes));
    };
    _proto.addError = function addError(error) {
        this._errors.push(error);
    };
    _proto.getErrors = function getErrors() {
        return this._errors;
    };
    return SchemaValidationContext;
}();
function validateRootTypes(context) {
    var schema = context.schema;
    var queryType = schema.getQueryType();
    if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
    else if (!(0, _definitionMjs.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError("Query root type must be Object type, it cannot be ".concat((0, _inspectMjsDefault.default)(queryType), "."), (_getOperationTypeNode = getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    var mutationType = schema.getMutationType();
    if (mutationType && !(0, _definitionMjs.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, _inspectMjsDefault.default)(mutationType), "."), (_getOperationTypeNode2 = getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, _definitionMjs.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, _inspectMjsDefault.default)(subscriptionType), "."), (_getOperationTypeNode3 = getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function getOperationTypeNode(schema, operation) {
    var operationNodes = getAllSubNodes(schema, function(node) {
        return node.operationTypes;
    });
    for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
        var node = operationNodes[_i2];
        if (node.operation === operation) return node.type;
    }
    return undefined;
}
function validateDirectives(context) {
    for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
        var directive = _context$schema$getDi2[_i4];
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, _directivesMjs.isDirective)(directive)) {
            context.reportError("Expected directive but got: ".concat((0, _inspectMjsDefault.default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
            var arg = _directive$args2[_i6];
            // Ensure they are named correctly.
            validateName(context, arg); // Ensure the type is an input type.
            if (!(0, _definitionMjs.isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, _inspectMjsDefault.default)(arg.type), "."), arg.astNode);
            if ((0, _definitionMjs.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                    getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    var error = (0, _assertValidNameMjs.isValidNameError)(node.name);
    if (error) context.addError((0, _locatedErrorMjs.locatedError)(error, node.astNode));
}
function validateTypes(context) {
    var validateInputObjectCircularRefs = createInputObjectCircularRefsValidator(context);
    var typeMap = context.schema.getTypeMap();
    for(var _i8 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(typeMap); _i8 < _objectValues2.length; _i8++){
        var type = _objectValues2[_i8];
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, _definitionMjs.isNamedType)(type)) {
            context.reportError("Expected GraphQL named type but got: ".concat((0, _inspectMjsDefault.default)(type), "."), type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, _introspectionMjs.isIntrospectionType)(type)) validateName(context, type);
        if ((0, _definitionMjs.isObjectType)(type)) {
            // Ensure fields are valid
            validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            validateInterfaces(context, type);
        } else if ((0, _definitionMjs.isInterfaceType)(type)) {
            // Ensure fields are valid.
            validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            validateInterfaces(context, type);
        } else if ((0, _definitionMjs.isUnionType)(type)) // Ensure Unions include valid member types.
        validateUnionMembers(context, type);
        else if ((0, _definitionMjs.isEnumType)(type)) // Ensure Enums have valid values.
        validateEnumValues(context, type);
        else if ((0, _definitionMjs.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function validateFields(context, type) {
    var fields = (0, _objectValuesMjsDefault.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), getAllNodes(type));
    for(var _i10 = 0; _i10 < fields.length; _i10++){
        var field = fields[_i10];
        // Ensure they are named correctly.
        validateName(context, field); // Ensure the type is an output type
        if (!(0, _definitionMjs.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, _inspectMjsDefault.default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
            var arg = _field$args2[_i12];
            var argName = arg.name; // Ensure they are named correctly.
            validateName(context, arg); // Ensure the type is an input type
            if (!(0, _definitionMjs.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, _inspectMjsDefault.default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, _definitionMjs.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                    getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function validateInterfaces(context, type) {
    var ifaceTypeNames = Object.create(null);
    for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
        var iface = _type$getInterfaces2[_i14];
        if (!(0, _definitionMjs.isInterfaceType)(iface)) {
            context.reportError("Type ".concat((0, _inspectMjsDefault.default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, _inspectMjsDefault.default)(iface), "."), getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        validateTypeImplementsAncestors(context, type, iface);
        validateTypeImplementsInterface(context, type, iface);
    }
}
function validateTypeImplementsInterface(context, type, iface) {
    var typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for(var _i16 = 0, _objectValues4 = (0, _objectValuesMjsDefault.default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
        var ifaceField = _objectValues4[_i16];
        var fieldName = ifaceField.name;
        var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                ifaceField.astNode
            ].concat(getAllNodes(type)));
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, _typeComparatorsMjs.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, _inspectMjsDefault.default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, _inspectMjsDefault.default)(typeField.type), "."), [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        var _loop = function _loop(_i18, _ifaceField$args2) {
            var ifaceArg = _ifaceField$args2[_i18];
            var argName = ifaceArg.name;
            var typeArg = (0, _findMjsDefault.default)(typeField.args, function(arg) {
                return arg.name === argName;
            }); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                return "continue";
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, _typeComparatorsMjs.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, _inspectMjsDefault.default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, _inspectMjsDefault.default)(typeArg.type), "."), [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        };
        for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
            var _ret = _loop(_i18, _ifaceField$args2);
            if (_ret === "continue") continue;
        } // Assert additional arguments must not be required.
        var _loop2 = function _loop2(_i20, _typeField$args2) {
            var typeArg = _typeField$args2[_i20];
            var argName = typeArg.name;
            var ifaceArg = (0, _findMjsDefault.default)(ifaceField.args, function(arg) {
                return arg.name === argName;
            });
            if (!ifaceArg && (0, _definitionMjs.isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        };
        for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
    }
}
function validateTypeImplementsAncestors(context, type, iface) {
    var ifaceInterfaces = type.getInterfaces();
    for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
        var transitive = _iface$getInterfaces2[_i22];
        if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat(getAllImplementsInterfaceNodes(iface, transitive), getAllImplementsInterfaceNodes(type, iface)));
    }
}
function validateUnionMembers(context, union) {
    var memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), getAllNodes(union));
    var includedTypeNames = Object.create(null);
    for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
        var memberType = memberTypes[_i24];
        if (includedTypeNames[memberType.name]) {
            context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, _definitionMjs.isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, _inspectMjsDefault.default)(memberType), "."), getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function validateEnumValues(context, enumType) {
    var enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), getAllNodes(enumType));
    for(var _i26 = 0; _i26 < enumValues.length; _i26++){
        var enumValue = enumValues[_i26];
        var valueName = enumValue.name; // Ensure valid name.
        validateName(context, enumValue);
        if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
}
function validateInputFields(context, inputObj) {
    var fields = (0, _objectValuesMjsDefault.default)(inputObj.getFields());
    if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), getAllNodes(inputObj));
     // Ensure the arguments are valid
    for(var _i28 = 0; _i28 < fields.length; _i28++){
        var field = fields[_i28];
        // Ensure they are named correctly.
        validateName(context, field); // Ensure the type is an input type
        if (!(0, _definitionMjs.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, _inspectMjsDefault.default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, _definitionMjs.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    var fieldPath = []; // Position in the type path
    var fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        var fields = (0, _objectValuesMjsDefault.default)(inputObj.getFields());
        for(var _i30 = 0; _i30 < fields.length; _i30++){
            var field = fields[_i30];
            if ((0, _definitionMjs.isNonNullType)(field.type) && (0, _definitionMjs.isInputObjectType)(field.type.ofType)) {
                var fieldType = field.type.ofType;
                var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                fieldPath.push(field);
                if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                else {
                    var cyclePath = fieldPath.slice(cycleIndex);
                    var pathStr = cyclePath.map(function(fieldObj) {
                        return fieldObj.name;
                    }).join('.');
                    context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                        return fieldObj.astNode;
                    }));
                }
                fieldPath.pop();
            }
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function getAllNodes(object) {
    var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
    return astNode ? extensionASTNodes ? [
        astNode
    ].concat(extensionASTNodes) : [
        astNode
    ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}
function getAllSubNodes(object, getter) {
    var subNodes = [];
    for(var _i32 = 0, _getAllNodes2 = getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
        var _getter;
        var node = _getAllNodes2[_i32];
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
    }
    return subNodes;
}
function getAllImplementsInterfaceNodes(type, iface) {
    return getAllSubNodes(type, function(typeNode) {
        return typeNode.interfaces;
    }).filter(function(ifaceNode) {
        return ifaceNode.name.value === iface.name;
    });
}
function getUnionMemberTypeNodes(union, typeName) {
    return getAllSubNodes(union, function(unionNode) {
        return unionNode.types;
    }).filter(function(typeNode) {
        return typeNode.name.value === typeName;
    });
}
function getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
        return node.name.value === (0, _directivesMjs.GraphQLDeprecatedDirective).name;
    });
}

},{"../polyfills/find.mjs":"caL9z","../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../error/GraphQLError.mjs":"e4y57","../error/locatedError.mjs":"4qusX","../utilities/assertValidName.mjs":"1lasf","../utilities/typeComparators.mjs":"fc5HZ","./schema.mjs":"gzZTY","./introspection.mjs":"fg0io","./directives.mjs":"k3NFN","./definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"caL9z":[function(require,module,exports,__globalThis) {
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var find = Array.prototype.find ? function find(list, predicate) {
    return Array.prototype.find.call(list, predicate);
} : function(list, predicate) {
    for(var _i2 = 0; _i2 < list.length; _i2++){
        var value = list[_i2];
        if (predicate(value)) return value;
    }
};
exports.default = find;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Pvqa":[function(require,module,exports,__globalThis) {
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectValues = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
exports.default = objectValues;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4qusX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given an arbitrary value, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */ parcelHelpers.export(exports, "locatedError", function() {
    return locatedError;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("./GraphQLError.mjs");
function locatedError(rawOriginalError, nodes, path) {
    var _nodes;
    // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
    var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, _inspectMjsDefault.default)(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.
    if (Array.isArray(originalError.path)) return originalError;
    return new (0, _graphQLErrorMjs.GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}

},{"../jsutils/inspect.mjs":"4vyEo","./GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1lasf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Upholds the spec rules about naming.
 */ parcelHelpers.export(exports, "assertValidName", function() {
    return assertValidName;
});
/**
 * Returns an Error if a name is invalid.
 */ parcelHelpers.export(exports, "isValidNameError", function() {
    return isValidNameError;
});
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
function assertValidName(name) {
    var error = isValidNameError(name);
    if (error) throw error;
    return name;
}
function isValidNameError(name) {
    typeof name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Expected name to be a string.');
    if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, _graphQLErrorMjs.GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
    if (!NAME_RX.test(name)) return new (0, _graphQLErrorMjs.GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
}

},{"../jsutils/devAssert.mjs":"dIY2Y","../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fc5HZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provided two types, return true if the types are equal (invariant).
 */ parcelHelpers.export(exports, "isEqualType", function() {
    return isEqualType;
});
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */ parcelHelpers.export(exports, "isTypeSubTypeOf", function() {
    return isTypeSubTypeOf;
});
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */ parcelHelpers.export(exports, "doTypesOverlap", function() {
    return doTypesOverlap;
});
var _definitionMjs = require("../type/definition.mjs");
function isEqualType(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, _definitionMjs.isNonNullType)(typeA) && (0, _definitionMjs.isNonNullType)(typeB)) return isEqualType(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, _definitionMjs.isListType)(typeA) && (0, _definitionMjs.isListType)(typeB)) return isEqualType(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function isTypeSubTypeOf(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, _definitionMjs.isNonNullType)(superType)) {
        if ((0, _definitionMjs.isNonNullType)(maybeSubType)) return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, _definitionMjs.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, _definitionMjs.isListType)(superType)) {
        if ((0, _definitionMjs.isListType)(maybeSubType)) return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, _definitionMjs.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, _definitionMjs.isAbstractType)(superType) && ((0, _definitionMjs.isInterfaceType)(maybeSubType) || (0, _definitionMjs.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function doTypesOverlap(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, _definitionMjs.isAbstractType)(typeA)) {
        if ((0, _definitionMjs.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some(function(type) {
            return schema.isSubType(typeB, type);
        });
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, _definitionMjs.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

},{"../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hN98Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isType", function() {
    return isType;
});
parcelHelpers.export(exports, "assertType", function() {
    return assertType;
});
/**
 * There are predicates for each kind of GraphQL type.
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isScalarType", function() {
    return isScalarType;
});
parcelHelpers.export(exports, "assertScalarType", function() {
    return assertScalarType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isObjectType", function() {
    return isObjectType;
});
parcelHelpers.export(exports, "assertObjectType", function() {
    return assertObjectType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isInterfaceType", function() {
    return isInterfaceType;
});
parcelHelpers.export(exports, "assertInterfaceType", function() {
    return assertInterfaceType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isUnionType", function() {
    return isUnionType;
});
parcelHelpers.export(exports, "assertUnionType", function() {
    return assertUnionType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isEnumType", function() {
    return isEnumType;
});
parcelHelpers.export(exports, "assertEnumType", function() {
    return assertEnumType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isInputObjectType", function() {
    return isInputObjectType;
});
parcelHelpers.export(exports, "assertInputObjectType", function() {
    return assertInputObjectType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isListType", function() {
    return isListType;
});
parcelHelpers.export(exports, "assertListType", function() {
    return assertListType;
});
// eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isNonNullType", function() {
    return isNonNullType;
});
parcelHelpers.export(exports, "assertNonNullType", function() {
    return assertNonNullType;
});
/**
 * These types may be used as input types for arguments and directives.
 */ parcelHelpers.export(exports, "isInputType", function() {
    return isInputType;
});
parcelHelpers.export(exports, "assertInputType", function() {
    return assertInputType;
});
/**
 * These types may be used as output types as the result of fields.
 */ parcelHelpers.export(exports, "isOutputType", function() {
    return isOutputType;
});
parcelHelpers.export(exports, "assertOutputType", function() {
    return assertOutputType;
});
/**
 * These types may describe types which may be leaf values.
 */ parcelHelpers.export(exports, "isLeafType", function() {
    return isLeafType;
});
parcelHelpers.export(exports, "assertLeafType", function() {
    return assertLeafType;
});
/**
 * These types may describe the parent context of a selection set.
 */ parcelHelpers.export(exports, "isCompositeType", function() {
    return isCompositeType;
});
parcelHelpers.export(exports, "assertCompositeType", function() {
    return assertCompositeType;
});
/**
 * These types may describe the parent context of a selection set.
 */ parcelHelpers.export(exports, "isAbstractType", function() {
    return isAbstractType;
});
parcelHelpers.export(exports, "assertAbstractType", function() {
    return assertAbstractType;
});
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         parents: { type: new GraphQLList(PersonType) },
 *         children: { type: new GraphQLList(PersonType) },
 *       })
 *     })
 *
 */ // FIXME: workaround to fix issue with Babel parser
/* ::
declare class GraphQLList<+T: GraphQLType> {
  +ofType: T;
  static <T>(ofType: T): GraphQLList<T>;
  // Note: constructors cannot be used for covariant types. Drop the "new".
  constructor(ofType: GraphQLType): void;
}
*/ parcelHelpers.export(exports, "GraphQLList", function() {
    return GraphQLList;
}) // Need to cast through any to alter the prototype.
;
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 *     const RowType = new GraphQLObjectType({
 *       name: 'Row',
 *       fields: () => ({
 *         id: { type: new GraphQLNonNull(GraphQLString) },
 *       })
 *     })
 *
 * Note: the enforcement of non-nullability occurs within the executor.
 */ // FIXME: workaround to fix issue with Babel parser
/* ::
declare class GraphQLNonNull<+T: GraphQLNullableType> {
  +ofType: T;
  static <T>(ofType: T): GraphQLNonNull<T>;
  // Note: constructors cannot be used for covariant types. Drop the "new".
  constructor(ofType: GraphQLType): void;
}
*/ parcelHelpers.export(exports, "GraphQLNonNull", function() {
    return GraphQLNonNull;
}) // Need to cast through any to alter the prototype.
;
/**
 * These types wrap and modify other types
 */ parcelHelpers.export(exports, "isWrappingType", function() {
    return isWrappingType;
});
parcelHelpers.export(exports, "assertWrappingType", function() {
    return assertWrappingType;
});
/**
 * These types can all accept null as a value.
 */ parcelHelpers.export(exports, "isNullableType", function() {
    return isNullableType;
});
parcelHelpers.export(exports, "assertNullableType", function() {
    return assertNullableType;
});
/* eslint-disable no-redeclare */ parcelHelpers.export(exports, "getNullableType", function() {
    return getNullableType;
});
/**
 * These named types do not include modifiers like List or NonNull.
 */ parcelHelpers.export(exports, "isNamedType", function() {
    return isNamedType;
});
parcelHelpers.export(exports, "assertNamedType", function() {
    return assertNamedType;
});
/* eslint-disable no-redeclare */ parcelHelpers.export(exports, "getNamedType", function() {
    return getNamedType;
});
parcelHelpers.export(exports, "GraphQLScalarType", function() {
    return GraphQLScalarType;
});
parcelHelpers.export(exports, "GraphQLObjectType", function() {
    return GraphQLObjectType;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "argsToArgsConfig", function() {
    return argsToArgsConfig;
});
parcelHelpers.export(exports, "isRequiredArgument", function() {
    return isRequiredArgument;
});
parcelHelpers.export(exports, "GraphQLInterfaceType", function() {
    return GraphQLInterfaceType;
});
parcelHelpers.export(exports, "GraphQLUnionType", function() {
    return GraphQLUnionType;
});
parcelHelpers.export(exports, "GraphQLEnumType", function() {
    return GraphQLEnumType;
});
parcelHelpers.export(exports, "GraphQLInputObjectType", function() {
    return GraphQLInputObjectType;
});
parcelHelpers.export(exports, "isRequiredInputField", function() {
    return isRequiredInputField;
});
var _objectEntriesMjs = require("../polyfills/objectEntries.mjs");
var _objectEntriesMjsDefault = parcelHelpers.interopDefault(_objectEntriesMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _keyMapMjs = require("../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _mapValueMjs = require("../jsutils/mapValue.mjs");
var _mapValueMjsDefault = parcelHelpers.interopDefault(_mapValueMjs);
var _toObjMapMjs = require("../jsutils/toObjMap.mjs");
var _toObjMapMjsDefault = parcelHelpers.interopDefault(_toObjMapMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _keyValMapMjs = require("../jsutils/keyValMap.mjs");
var _keyValMapMjsDefault = parcelHelpers.interopDefault(_keyValMapMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
var _didYouMeanMjs = require("../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _identityFuncMjs = require("../jsutils/identityFunc.mjs");
var _identityFuncMjsDefault = parcelHelpers.interopDefault(_identityFuncMjs);
var _defineInspectMjs = require("../jsutils/defineInspect.mjs");
var _defineInspectMjsDefault = parcelHelpers.interopDefault(_defineInspectMjs);
var _suggestionListMjs = require("../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _kindsMjs = require("../language/kinds.mjs");
var _printerMjs = require("../language/printer.mjs");
var _valueFromASTUntypedMjs = require("../utilities/valueFromASTUntyped.mjs");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function isType(type) {
    return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
}
function assertType(type) {
    if (!isType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL type."));
    return type;
}
function isScalarType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLScalarType);
}
function assertScalarType(type) {
    if (!isScalarType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Scalar type."));
    return type;
}
function isObjectType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLObjectType);
}
function assertObjectType(type) {
    if (!isObjectType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Object type."));
    return type;
}
function isInterfaceType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
    if (!isInterfaceType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Interface type."));
    return type;
}
function isUnionType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLUnionType);
}
function assertUnionType(type) {
    if (!isUnionType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Union type."));
    return type;
}
function isEnumType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLEnumType);
}
function assertEnumType(type) {
    if (!isEnumType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Enum type."));
    return type;
}
function isInputObjectType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
    if (!isInputObjectType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Input Object type."));
    return type;
}
function isListType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLList);
}
function assertListType(type) {
    if (!isListType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL List type."));
    return type;
}
function isNonNullType(type) {
    return (0, _instanceOfMjsDefault.default)(type, GraphQLNonNull);
}
function assertNonNullType(type) {
    if (!isNonNullType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL Non-Null type."));
    return type;
}
function isInputType(type) {
    return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
}
function assertInputType(type) {
    if (!isInputType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL input type."));
    return type;
}
function isOutputType(type) {
    return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
}
function assertOutputType(type) {
    if (!isOutputType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL output type."));
    return type;
}
function isLeafType(type) {
    return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
    if (!isLeafType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL leaf type."));
    return type;
}
function isCompositeType(type) {
    return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
    if (!isCompositeType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL composite type."));
    return type;
}
function isAbstractType(type) {
    return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
    if (!isAbstractType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL abstract type."));
    return type;
}
function GraphQLList(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof GraphQLList) this.ofType = assertType(ofType);
    else return new GraphQLList(ofType);
}
GraphQLList.prototype.toString = function toString() {
    return '[' + String(this.ofType) + ']';
};
GraphQLList.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty(GraphQLList.prototype, (0, _symbolsMjs.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLList';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLList);
function GraphQLNonNull(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof GraphQLNonNull) this.ofType = assertNullableType(ofType);
    else return new GraphQLNonNull(ofType);
}
GraphQLNonNull.prototype.toString = function toString() {
    return String(this.ofType) + '!';
};
GraphQLNonNull.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty(GraphQLNonNull.prototype, (0, _symbolsMjs.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLNonNull';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLNonNull);
function isWrappingType(type) {
    return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
    if (!isWrappingType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL wrapping type."));
    return type;
}
function isNullableType(type) {
    return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
    if (!isNullableType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL nullable type."));
    return type;
}
function getNullableType(type) {
    /* eslint-enable no-redeclare */ if (type) return isNonNullType(type) ? type.ofType : type;
}
function isNamedType(type) {
    return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
}
function assertNamedType(type) {
    if (!isNamedType(type)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(type), " to be a GraphQL named type."));
    return type;
}
function getNamedType(type) {
    /* eslint-enable no-redeclare */ if (type) {
        var unwrappedType = type;
        while(isWrappingType(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */ function resolveThunk(thunk) {
    // $FlowFixMe[incompatible-use]
    return typeof thunk === 'function' ? thunk() : thunk;
}
function undefineIfEmpty(arr) {
    return arr && arr.length > 0 ? arr : undefined;
}
var GraphQLScalarType = /*#__PURE__*/ function() {
    function GraphQLScalarType(config) {
        var _config$parseValue, _config$serialize, _config$parseLiteral;
        var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, _identityFuncMjsDefault.default);
        this.name = config.name;
        this.description = config.description;
        this.specifiedByUrl = config.specifiedByUrl;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, _identityFuncMjsDefault.default);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
            return parseValue((0, _valueFromASTUntypedMjs.valueFromASTUntyped)(node, variables));
        };
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
        config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, _inspectMjsDefault.default)(config.specifiedByUrl), "."));
        config.serialize == null || typeof config.serialize === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
        if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
    var _proto = GraphQLScalarType.prototype;
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            name: this.name,
            description: this.description,
            specifiedByUrl: this.specifiedByUrl,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
        };
    };
    _proto.toString = function toString() {
        return this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLScalarType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLScalarType';
            }
        }
    ]);
    return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLScalarType);
var GraphQLObjectType = /*#__PURE__*/ function() {
    function GraphQLObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        this._fields = defineFieldMap.bind(undefined, config);
        this._interfaces = defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
        config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, _inspectMjsDefault.default)(config.isTypeOf), "."));
    }
    var _proto2 = GraphQLObjectType.prototype;
    _proto2.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto2.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto2.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes || []
        };
    };
    _proto2.toString = function toString() {
        return this.name;
    };
    _proto2.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLObjectType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLObjectType';
            }
        }
    ]);
    return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLObjectType);
function defineInterfaces(config) {
    var _resolveThunk;
    var interfaces = (_resolveThunk = resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
    Array.isArray(interfaces) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
    return interfaces;
}
function defineFieldMap(config) {
    var fieldMap = resolveThunk(config.fields);
    isPlainObj(fieldMap) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, _mapValueMjsDefault.default)(fieldMap, function(fieldConfig, fieldName) {
        var _fieldConfig$args;
        isPlainObj(fieldConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
        !('isDeprecated' in fieldConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, _inspectMjsDefault.default)(fieldConfig.resolve), "."));
        var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        isPlainObj(argsConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
        var args = (0, _objectEntriesMjsDefault.default)(argsConfig).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, _toObjMapMjsDefault.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: args,
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            isDeprecated: fieldConfig.deprecationReason != null,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, _toObjMapMjsDefault.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function isPlainObj(obj) {
    return (0, _isObjectLikeMjsDefault.default)(obj) && !Array.isArray(obj);
}
function fieldsToFieldsConfig(fields) {
    return (0, _mapValueMjsDefault.default)(fields, function(field) {
        return {
            description: field.description,
            type: field.type,
            args: argsToArgsConfig(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        };
    });
}
function argsToArgsConfig(args) {
    return (0, _keyValMapMjsDefault.default)(args, function(arg) {
        return arg.name;
    }, function(arg) {
        return {
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        };
    });
}
function isRequiredArgument(arg) {
    return isNonNullType(arg.type) && arg.defaultValue === undefined;
}
var GraphQLInterfaceType = /*#__PURE__*/ function() {
    function GraphQLInterfaceType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        this._fields = defineFieldMap.bind(undefined, config);
        this._interfaces = defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspectMjsDefault.default)(config.resolveType), "."));
    }
    var _proto3 = GraphQLInterfaceType.prototype;
    _proto3.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto3.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto3.toConfig = function toConfig() {
        var _this$extensionASTNod2;
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
        };
    };
    _proto3.toString = function toString() {
        return this.name;
    };
    _proto3.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLInterfaceType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInterfaceType';
            }
        }
    ]);
    return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLInterfaceType);
var GraphQLUnionType = /*#__PURE__*/ function() {
    function GraphQLUnionType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        this._types = defineTypes.bind(undefined, config);
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, _devAssertMjsDefault.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspectMjsDefault.default)(config.resolveType), "."));
    }
    var _proto4 = GraphQLUnionType.prototype;
    _proto4.getTypes = function getTypes() {
        if (typeof this._types === 'function') this._types = this._types();
        return this._types;
    };
    _proto4.toConfig = function toConfig() {
        var _this$extensionASTNod3;
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
        };
    };
    _proto4.toString = function toString() {
        return this.name;
    };
    _proto4.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLUnionType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLUnionType';
            }
        }
    ]);
    return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLUnionType);
function defineTypes(config) {
    var types = resolveThunk(config.types);
    Array.isArray(types) || (0, _devAssertMjsDefault.default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
    return types;
}
var GraphQLEnumType = /*#__PURE__*/ function() {
    function GraphQLEnumType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        this._values = defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map(function(enumValue) {
            return [
                enumValue.value,
                enumValue
            ];
        }));
        this._nameLookup = (0, _keyMapMjsDefault.default)(this._values, function(value) {
            return value.name;
        });
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
    }
    var _proto5 = GraphQLEnumType.prototype;
    _proto5.getValues = function getValues() {
        return this._values;
    };
    _proto5.getValue = function getValue(name) {
        return this._nameLookup[name];
    };
    _proto5.serialize = function serialize(outputValue) {
        var enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, _graphQLErrorMjs.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, _inspectMjsDefault.default)(outputValue)));
        return enumValue.name;
    };
    _proto5.parseValue = function parseValue(inputValue) /* T */ {
        if (typeof inputValue !== 'string') {
            var valueStr = (0, _inspectMjsDefault.default)(inputValue);
            throw new (0, _graphQLErrorMjs.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + didYouMeanEnumValue(this, valueStr));
        }
        var enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, _graphQLErrorMjs.GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    };
    _proto5.parseLiteral = function parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, _kindsMjs.Kind).ENUM) {
            var valueStr = (0, _printerMjs.print)(valueNode);
            throw new (0, _graphQLErrorMjs.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + didYouMeanEnumValue(this, valueStr), valueNode);
        }
        var enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            var _valueStr = (0, _printerMjs.print)(valueNode);
            throw new (0, _graphQLErrorMjs.GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + didYouMeanEnumValue(this, _valueStr), valueNode);
        }
        return enumValue.value;
    };
    _proto5.toConfig = function toConfig() {
        var _this$extensionASTNod4;
        var values = (0, _keyValMapMjsDefault.default)(this.getValues(), function(value) {
            return value.name;
        }, function(value) {
            return {
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
        };
    };
    _proto5.toString = function toString() {
        return this.name;
    };
    _proto5.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLEnumType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLEnumType';
            }
        }
    ]);
    return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLEnumType);
function didYouMeanEnumValue(enumType, unknownValueStr) {
    var allNames = enumType.getValues().map(function(value) {
        return value.name;
    });
    var suggestedValues = (0, _suggestionListMjsDefault.default)(unknownValueStr, allNames);
    return (0, _didYouMeanMjsDefault.default)('the enum value', suggestedValues);
}
function defineEnumValues(typeName, valueMap) {
    isPlainObj(valueMap) || (0, _devAssertMjsDefault.default)(0, "".concat(typeName, " values must be an object with value names as keys."));
    return (0, _objectEntriesMjsDefault.default)(valueMap).map(function(_ref2) {
        var valueName = _ref2[0], valueConfig = _ref2[1];
        isPlainObj(valueConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, _inspectMjsDefault.default)(valueConfig), "."));
        !('isDeprecated' in valueConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        return {
            name: valueName,
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            isDeprecated: valueConfig.deprecationReason != null,
            deprecationReason: valueConfig.deprecationReason,
            extensions: valueConfig.extensions && (0, _toObjMapMjsDefault.default)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
var GraphQLInputObjectType = /*#__PURE__*/ function() {
    function GraphQLInputObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
        this._fields = defineInputFieldMap.bind(undefined, config);
        typeof config.name === 'string' || (0, _devAssertMjsDefault.default)(0, 'Must provide name.');
    }
    var _proto6 = GraphQLInputObjectType.prototype;
    _proto6.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto6.toConfig = function toConfig() {
        var _this$extensionASTNod5;
        var fields = (0, _mapValueMjsDefault.default)(this.getFields(), function(field) {
            return {
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
        };
    };
    _proto6.toString = function toString() {
        return this.name;
    };
    _proto6.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLInputObjectType, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInputObjectType';
            }
        }
    ]);
    return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLInputObjectType);
function defineInputFieldMap(config) {
    var fieldMap = resolveThunk(config.fields);
    isPlainObj(fieldMap) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, _mapValueMjsDefault.default)(fieldMap, function(fieldConfig, fieldName) {
        !('resolve' in fieldConfig) || (0, _devAssertMjsDefault.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, _toObjMapMjsDefault.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function isRequiredInputField(field) {
    return isNonNullType(field.type) && field.defaultValue === undefined;
}

},{"../polyfills/objectEntries.mjs":"ccmaZ","../polyfills/symbols.mjs":"26hb6","../jsutils/inspect.mjs":"4vyEo","../jsutils/keyMap.mjs":"aZdAt","../jsutils/mapValue.mjs":"190m2","../jsutils/toObjMap.mjs":"aJhPA","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/keyValMap.mjs":"6DAN9","../jsutils/instanceOf.mjs":"4pPiF","../jsutils/didYouMean.mjs":"gdkI5","../jsutils/isObjectLike.mjs":"ji7lb","../jsutils/identityFunc.mjs":"d6cSe","../jsutils/defineInspect.mjs":"8FViL","../jsutils/suggestionList.mjs":"634S6","../error/GraphQLError.mjs":"e4y57","../language/kinds.mjs":"ffJlp","../language/printer.mjs":"dA3NC","../utilities/valueFromASTUntyped.mjs":"iFTmE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ccmaZ":[function(require,module,exports,__globalThis) {
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectEntries = Object.entries || function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
exports.default = objectEntries;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZdAt":[function(require,module,exports,__globalThis) {
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return keyMap;
});
function keyMap(list, keyFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = item;
        return map;
    }, Object.create(null));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"190m2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mapValue;
});
var _objectEntriesMjs = require("../polyfills/objectEntries.mjs");
var _objectEntriesMjsDefault = parcelHelpers.interopDefault(_objectEntriesMjs);
function mapValue(map, fn) {
    var result = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, _objectEntriesMjsDefault.default)(map); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var _key = _ref2[0];
        var _value = _ref2[1];
        result[_key] = fn(_value, _key);
    }
    return result;
}

},{"../polyfills/objectEntries.mjs":"ccmaZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aJhPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toObjMap;
});
var _objectEntriesMjs = require("../polyfills/objectEntries.mjs");
var _objectEntriesMjsDefault = parcelHelpers.interopDefault(_objectEntriesMjs);
function toObjMap(obj) {
    /* eslint-enable no-redeclare */ if (Object.getPrototypeOf(obj) === null) return obj;
    var map = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, _objectEntriesMjsDefault.default)(obj); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var key = _ref2[0];
        var value = _ref2[1];
        map[key] = value;
    }
    return map;
}

},{"../polyfills/objectEntries.mjs":"ccmaZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6DAN9":[function(require,module,exports,__globalThis) {
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return keyValMap;
});
function keyValMap(list, keyFn, valFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = valFn(item);
        return map;
    }, Object.create(null));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdkI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return didYouMean;
});
var MAX_SUGGESTIONS = 5;
function didYouMean(firstArg, secondArg) {
    var _ref = typeof firstArg === 'string' ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ], subMessage = _ref[0], suggestionsArg = _ref[1];
    var message = ' Did you mean ';
    if (subMessage) message += subMessage + ' ';
    var suggestions = suggestionsArg.map(function(x) {
        return "\"".concat(x, "\"");
    });
    switch(suggestions.length){
        case 0:
            return '';
        case 1:
            return message + suggestions[0] + '?';
        case 2:
            return message + suggestions[0] + ' or ' + suggestions[1] + '?';
    }
    var selected = suggestions.slice(0, MAX_SUGGESTIONS);
    var lastItem = selected.pop();
    return message + selected.join(', ') + ', or ' + lastItem + '?';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d6cSe":[function(require,module,exports,__globalThis) {
/**
 * Returns the first argument it receives.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return identityFunc;
});
function identityFunc(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"634S6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return suggestionList;
});
var _naturalCompareMjs = require("./naturalCompare.mjs");
var _naturalCompareMjsDefault = parcelHelpers.interopDefault(_naturalCompareMjs);
function suggestionList(input, options) {
    var optionsByDistance = Object.create(null);
    var lexicalDistance = new LexicalDistance(input);
    var threshold = Math.floor(input.length * 0.4) + 1;
    for(var _i2 = 0; _i2 < options.length; _i2++){
        var option = options[_i2];
        var distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort(function(a, b) {
        var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, _naturalCompareMjsDefault.default)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ var LexicalDistance = /*#__PURE__*/ function() {
    function LexicalDistance(input) {
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    var _proto = LexicalDistance.prototype;
    _proto.measure = function measure(option, threshold) {
        if (this._input === option) return 0;
        var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        var a = stringToArray(optionLowerCase);
        var b = this._inputArray;
        if (a.length < b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var aLength = a.length;
        var bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        var rows = this._rows;
        for(var j = 0; j <= bLength; j++)rows[0][j] = j;
        for(var i = 1; i <= aLength; i++){
            var upRow = rows[(i - 1) % 3];
            var currentRow = rows[i % 3];
            var smallestCell = currentRow[0] = i;
            for(var _j = 1; _j <= bLength; _j++){
                var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost // substitute
                );
                if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                    // transposition
                    var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[_j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        var distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    };
    return LexicalDistance;
}();
function stringToArray(str) {
    var strLength = str.length;
    var array = new Array(strLength);
    for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

},{"./naturalCompare.mjs":"gukLP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gukLP":[function(require,module,exports,__globalThis) {
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return naturalCompare;
});
function naturalCompare(aStr, bStr) {
    var aIdx = 0;
    var bIdx = 0;
    while(aIdx < aStr.length && bIdx < bStr.length){
        var aChar = aStr.charCodeAt(aIdx);
        var bChar = bStr.charCodeAt(bIdx);
        if (isDigit(aChar) && isDigit(bChar)) {
            var aNum = 0;
            do {
                ++aIdx;
                aNum = aNum * 10 + aChar - DIGIT_0;
                aChar = aStr.charCodeAt(aIdx);
            }while (isDigit(aChar) && aNum > 0);
            var bNum = 0;
            do {
                ++bIdx;
                bNum = bNum * 10 + bChar - DIGIT_0;
                bChar = bStr.charCodeAt(bIdx);
            }while (isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIdx;
            ++bIdx;
        }
    }
    return aStr.length - bStr.length;
}
var DIGIT_0 = 48;
var DIGIT_9 = 57;
function isDigit(code) {
    return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dA3NC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ parcelHelpers.export(exports, "print", function() {
    return print;
});
var _visitorMjs = require("./visitor.mjs");
var _blockStringMjs = require("./blockString.mjs");
function print(ast) {
    return (0, _visitorMjs.visit)(ast, {
        leave: printDocASTReducer
    });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
        var directives = join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([
            op,
            join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = wrap('', alias, ': ') + name;
        var argsLine = prefix + wrap('(', join(args, ', '), ')');
        if (argsLine.length > MAX_LINE_LENGTH) argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
        return join([
            argsLine,
            join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + wrap(' ', join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return join([
            '...',
            wrap('on ', typeCondition),
            join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, _blockStringMjs.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + wrap('(', join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return join([
            'schema',
            join(directives, ' '),
            block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return join([
            'scalar',
            name,
            join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return join([
            'type',
            name,
            wrap('implements ', join(interfaces, ' & ')),
            join(directives, ' '),
            block(fields)
        ], ' ');
    }),
    FieldDefinition: addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
    }),
    InputValueDefinition: addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return join([
            name + ': ' + type,
            wrap('= ', defaultValue),
            join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return join([
            'interface',
            name,
            wrap('implements ', join(interfaces, ' & ')),
            join(directives, ' '),
            block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return join([
            'union',
            name,
            join(directives, ' '),
            types && types.length !== 0 ? '= ' + join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return join([
            'enum',
            name,
            join(directives, ' '),
            block(values)
        ], ' ');
    }),
    EnumValueDefinition: addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return join([
            name,
            join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return join([
            'input',
            name,
            join(directives, ' '),
            block(fields)
        ], ' ');
    }),
    DirectiveDefinition: addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return join([
            'extend schema',
            join(directives, ' '),
            block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return join([
            'extend scalar',
            name,
            join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return join([
            'extend type',
            name,
            wrap('implements ', join(interfaces, ' & ')),
            join(directives, ' '),
            block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return join([
            'extend interface',
            name,
            wrap('implements ', join(interfaces, ' & ')),
            join(directives, ' '),
            block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return join([
            'extend union',
            name,
            join(directives, ' '),
            types && types.length !== 0 ? '= ' + join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return join([
            'extend enum',
            name,
            join(directives, ' '),
            block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return join([
            'extend input',
            name,
            join(directives, ' '),
            block(fields)
        ], ' ');
    }
};
function addDescription(cb) {
    return function(node) {
        return join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function block(array) {
    return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function indent(str) {
    return wrap('  ', str.replace(/\n/g, '\n  '));
}
function isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some(isMultiline);
}

},{"./visitor.mjs":"aHQOA","./blockString.mjs":"Ye6Ih","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFTmE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */ parcelHelpers.export(exports, "valueFromASTUntyped", function() {
    return valueFromASTUntyped;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _keyValMapMjs = require("../jsutils/keyValMap.mjs");
var _keyValMapMjsDefault = parcelHelpers.interopDefault(_keyValMapMjs);
var _kindsMjs = require("../language/kinds.mjs");
function valueFromASTUntyped(valueNode, variables) {
    switch(valueNode.kind){
        case (0, _kindsMjs.Kind).NULL:
            return null;
        case (0, _kindsMjs.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, _kindsMjs.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, _kindsMjs.Kind).STRING:
        case (0, _kindsMjs.Kind).ENUM:
        case (0, _kindsMjs.Kind).BOOLEAN:
            return valueNode.value;
        case (0, _kindsMjs.Kind).LIST:
            return valueNode.values.map(function(node) {
                return valueFromASTUntyped(node, variables);
            });
        case (0, _kindsMjs.Kind).OBJECT:
            return (0, _keyValMapMjsDefault.default)(valueNode.fields, function(field) {
                return field.name.value;
            }, function(field) {
                return valueFromASTUntyped(field.value, variables);
            });
        case (0, _kindsMjs.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    } // istanbul ignore next (Not reachable. All possible value nodes have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected value node: ' + (0, _inspectMjsDefault.default)(valueNode));
}

},{"../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../jsutils/keyValMap.mjs":"6DAN9","../language/kinds.mjs":"ffJlp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gzZTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Test if the given value is a GraphQL schema.
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isSchema", function() {
    return isSchema;
});
parcelHelpers.export(exports, "assertSchema", function() {
    return assertSchema;
});
parcelHelpers.export(exports, "GraphQLSchema", function() {
    return GraphQLSchema;
});
var _findMjs = require("../polyfills/find.mjs");
var _findMjsDefault = parcelHelpers.interopDefault(_findMjs);
var _arrayFromMjs = require("../polyfills/arrayFrom.mjs");
var _arrayFromMjsDefault = parcelHelpers.interopDefault(_arrayFromMjs);
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _toObjMapMjs = require("../jsutils/toObjMap.mjs");
var _toObjMapMjsDefault = parcelHelpers.interopDefault(_toObjMapMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _introspectionMjs = require("./introspection.mjs");
var _directivesMjs = require("./directives.mjs");
var _definitionMjs = require("./definition.mjs");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function isSchema(schema) {
    return (0, _instanceOfMjsDefault.default)(schema, GraphQLSchema);
}
function assertSchema(schema) {
    if (!isSchema(schema)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(schema), " to be a GraphQL schema."));
    return schema;
}
var GraphQLSchema = /*#__PURE__*/ function() {
    // Used as a cache for validateSchema().
    function GraphQLSchema(config) {
        var _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, _isObjectLikeMjsDefault.default)(config) || (0, _devAssertMjsDefault.default)(0, 'Must provide configuration object.');
        !config.types || Array.isArray(config.types) || (0, _devAssertMjsDefault.default)(0, "\"types\" must be Array if provided but got: ".concat((0, _inspectMjsDefault.default)(config.types), "."));
        !config.directives || Array.isArray(config.directives) || (0, _devAssertMjsDefault.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, _inspectMjsDefault.default)(config.directives), "."));
        this.description = config.description;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = config.extensionASTNodes;
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, _directivesMjs.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        var allReferencedTypes = new Set(config.types);
        if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
            var directive = _this$_directives2[_i4];
            // Directives are not validated until validateSchema() is called.
            if ((0, _directivesMjs.isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                collectReferencedTypes(arg.type, allReferencedTypes);
            }
        }
        collectReferencedTypes((0, _introspectionMjs.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for(var _i8 = 0, _arrayFrom2 = (0, _arrayFromMjsDefault.default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
            var namedType = _arrayFrom2[_i8];
            if (namedType == null) continue;
            var typeName = namedType.name;
            typeName || (0, _devAssertMjsDefault.default)(0, 'One of the provided types for building the Schema is missing a name.');
            if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
            this._typeMap[typeName] = namedType;
            if ((0, _definitionMjs.isInterfaceType)(namedType)) // Store implementations by interface.
            for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                var iface = _namedType$getInterfa2[_i10];
                if ((0, _definitionMjs.isInterfaceType)(iface)) {
                    var implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            }
            else if ((0, _definitionMjs.isObjectType)(namedType)) // Store implementations by objects.
            for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                var _iface = _namedType$getInterfa4[_i12];
                if ((0, _definitionMjs.isInterfaceType)(_iface)) {
                    var _implementations = this._implementationsMap[_iface.name];
                    if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    _implementations.objects.push(namedType);
                }
            }
        }
    }
    var _proto = GraphQLSchema.prototype;
    _proto.getQueryType = function getQueryType() {
        return this._queryType;
    };
    _proto.getMutationType = function getMutationType() {
        return this._mutationType;
    };
    _proto.getSubscriptionType = function getSubscriptionType() {
        return this._subscriptionType;
    };
    _proto.getTypeMap = function getTypeMap() {
        return this._typeMap;
    };
    _proto.getType = function getType(name) {
        return this.getTypeMap()[name];
    };
    _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
        return (0, _definitionMjs.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    };
    _proto.getImplementations = function getImplementations(interfaceType) {
        var implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    } // @deprecated: use isSubType instead - will be removed in v16.
    ;
    _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
        return this.isSubType(abstractType, possibleType);
    };
    _proto.isSubType = function isSubType(abstractType, maybeSubType) {
        var map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, _definitionMjs.isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                var type = _abstractType$getType2[_i14];
                map[type.name] = true;
            }
            else {
                var implementations = this.getImplementations(abstractType);
                for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                    var _type = _implementations$obje2[_i16];
                    map[_type.name] = true;
                }
                for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                    var _type2 = _implementations$inte2[_i18];
                    map[_type2.name] = true;
                }
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    };
    _proto.getDirectives = function getDirectives() {
        return this._directives;
    };
    _proto.getDirective = function getDirective(name) {
        return (0, _findMjsDefault.default)(this.getDirectives(), function(directive) {
            return directive.name === name;
        });
    };
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: (0, _objectValuesMjsDefault.default)(this.getTypeMap()),
            directives: this.getDirectives().slice(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
            assumeValid: this.__validationErrors !== undefined
        };
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLSchema, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLSchema';
            }
        }
    ]);
    return GraphQLSchema;
}();
function collectReferencedTypes(type, typeSet) {
    var namedType = (0, _definitionMjs.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, _definitionMjs.isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
            var memberType = _namedType$getTypes2[_i20];
            collectReferencedTypes(memberType, typeSet);
        }
        else if ((0, _definitionMjs.isObjectType)(namedType) || (0, _definitionMjs.isInterfaceType)(namedType)) {
            for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                var interfaceType = _namedType$getInterfa6[_i22];
                collectReferencedTypes(interfaceType, typeSet);
            }
            for(var _i24 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                var field = _objectValues2[_i24];
                collectReferencedTypes(field.type, typeSet);
                for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                    var arg = _field$args2[_i26];
                    collectReferencedTypes(arg.type, typeSet);
                }
            }
        } else if ((0, _definitionMjs.isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, _objectValuesMjsDefault.default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
            var _field = _objectValues4[_i28];
            collectReferencedTypes(_field.type, typeSet);
        }
    }
    return typeSet;
}

},{"../polyfills/find.mjs":"caL9z","../polyfills/arrayFrom.mjs":"8YpN1","../polyfills/objectValues.mjs":"9Pvqa","../polyfills/symbols.mjs":"26hb6","../jsutils/inspect.mjs":"4vyEo","../jsutils/toObjMap.mjs":"aJhPA","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/instanceOf.mjs":"4pPiF","../jsutils/isObjectLike.mjs":"ji7lb","./introspection.mjs":"fg0io","./directives.mjs":"k3NFN","./definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8YpN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolsMjs = require("./symbols.mjs");
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var arrayFrom = Array.from || function(obj, mapFn, thisArg) {
    if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
     // Is Iterable?
    var iteratorMethod = obj[0, _symbolsMjs.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        var iterator = iteratorMethod.call(obj);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i){
            result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
            // After a very large number of iterations, produce an error.
            // istanbul ignore if (Too big to actually test)
            if (i > 9999999) throw new TypeError('Near-infinite iteration.');
        }
        return result;
    } // Is Array like?
    var length = obj.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
        return _result;
    }
    return [];
};
exports.default = arrayFrom;

},{"./symbols.mjs":"26hb6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fg0io":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__Schema", function() {
    return __Schema;
});
parcelHelpers.export(exports, "__Directive", function() {
    return __Directive;
});
parcelHelpers.export(exports, "__DirectiveLocation", function() {
    return __DirectiveLocation;
});
parcelHelpers.export(exports, "__Type", function() {
    return __Type;
});
parcelHelpers.export(exports, "__Field", function() {
    return __Field;
});
parcelHelpers.export(exports, "__InputValue", function() {
    return __InputValue;
});
parcelHelpers.export(exports, "__EnumValue", function() {
    return __EnumValue;
});
parcelHelpers.export(exports, "TypeKind", function() {
    return TypeKind;
});
parcelHelpers.export(exports, "__TypeKind", function() {
    return __TypeKind;
});
parcelHelpers.export(exports, "SchemaMetaFieldDef", function() {
    return SchemaMetaFieldDef;
});
parcelHelpers.export(exports, "TypeMetaFieldDef", function() {
    return TypeMetaFieldDef;
});
parcelHelpers.export(exports, "TypeNameMetaFieldDef", function() {
    return TypeNameMetaFieldDef;
});
parcelHelpers.export(exports, "introspectionTypes", function() {
    return introspectionTypes;
});
parcelHelpers.export(exports, "isIntrospectionType", function() {
    return isIntrospectionType;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _printerMjs = require("../language/printer.mjs");
var _directiveLocationMjs = require("../language/directiveLocation.mjs");
var _astFromValueMjs = require("../utilities/astFromValue.mjs");
var _scalarsMjs = require("./scalars.mjs");
var _definitionMjs = require("./definition.mjs");
var __Schema = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__Schema',
    description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
    fields: function fields() {
        return {
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(schema) {
                    return schema.description;
                }
            },
            types: {
                description: 'A list of all types supported by this server.',
                type: new (0, _definitionMjs.GraphQLNonNull)(new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__Type))),
                resolve: function resolve(schema) {
                    return (0, _objectValuesMjsDefault.default)(schema.getTypeMap());
                }
            },
            queryType: {
                description: 'The type that query operations will be rooted at.',
                type: new (0, _definitionMjs.GraphQLNonNull)(__Type),
                resolve: function resolve(schema) {
                    return schema.getQueryType();
                }
            },
            mutationType: {
                description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                type: __Type,
                resolve: function resolve(schema) {
                    return schema.getMutationType();
                }
            },
            subscriptionType: {
                description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                type: __Type,
                resolve: function resolve(schema) {
                    return schema.getSubscriptionType();
                }
            },
            directives: {
                description: 'A list of all directives supported by this server.',
                type: new (0, _definitionMjs.GraphQLNonNull)(new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__Directive))),
                resolve: function resolve(schema) {
                    return schema.getDirectives();
                }
            }
        };
    }
});
var __Directive = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__Directive',
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: function fields() {
        return {
            name: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
                resolve: function resolve(directive) {
                    return directive.name;
                }
            },
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(directive) {
                    return directive.description;
                }
            },
            isRepeatable: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
                resolve: function resolve(directive) {
                    return directive.isRepeatable;
                }
            },
            locations: {
                type: new (0, _definitionMjs.GraphQLNonNull)(new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__DirectiveLocation))),
                resolve: function resolve(directive) {
                    return directive.locations;
                }
            },
            args: {
                type: new (0, _definitionMjs.GraphQLNonNull)(new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__InputValue))),
                args: {
                    includeDeprecated: {
                        type: (0, _scalarsMjs.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref) {
                    var includeDeprecated = _ref.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            }
        };
    }
});
var __DirectiveLocation = new (0, _definitionMjs.GraphQLEnumType)({
    name: '__DirectiveLocation',
    description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
    values: {
        QUERY: {
            value: (0, _directiveLocationMjs.DirectiveLocation).QUERY,
            description: 'Location adjacent to a query operation.'
        },
        MUTATION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).MUTATION,
            description: 'Location adjacent to a mutation operation.'
        },
        SUBSCRIPTION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).SUBSCRIPTION,
            description: 'Location adjacent to a subscription operation.'
        },
        FIELD: {
            value: (0, _directiveLocationMjs.DirectiveLocation).FIELD,
            description: 'Location adjacent to a field.'
        },
        FRAGMENT_DEFINITION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_DEFINITION,
            description: 'Location adjacent to a fragment definition.'
        },
        FRAGMENT_SPREAD: {
            value: (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_SPREAD,
            description: 'Location adjacent to a fragment spread.'
        },
        INLINE_FRAGMENT: {
            value: (0, _directiveLocationMjs.DirectiveLocation).INLINE_FRAGMENT,
            description: 'Location adjacent to an inline fragment.'
        },
        VARIABLE_DEFINITION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).VARIABLE_DEFINITION,
            description: 'Location adjacent to a variable definition.'
        },
        SCHEMA: {
            value: (0, _directiveLocationMjs.DirectiveLocation).SCHEMA,
            description: 'Location adjacent to a schema definition.'
        },
        SCALAR: {
            value: (0, _directiveLocationMjs.DirectiveLocation).SCALAR,
            description: 'Location adjacent to a scalar definition.'
        },
        OBJECT: {
            value: (0, _directiveLocationMjs.DirectiveLocation).OBJECT,
            description: 'Location adjacent to an object type definition.'
        },
        FIELD_DEFINITION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).FIELD_DEFINITION,
            description: 'Location adjacent to a field definition.'
        },
        ARGUMENT_DEFINITION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).ARGUMENT_DEFINITION,
            description: 'Location adjacent to an argument definition.'
        },
        INTERFACE: {
            value: (0, _directiveLocationMjs.DirectiveLocation).INTERFACE,
            description: 'Location adjacent to an interface definition.'
        },
        UNION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).UNION,
            description: 'Location adjacent to a union definition.'
        },
        ENUM: {
            value: (0, _directiveLocationMjs.DirectiveLocation).ENUM,
            description: 'Location adjacent to an enum definition.'
        },
        ENUM_VALUE: {
            value: (0, _directiveLocationMjs.DirectiveLocation).ENUM_VALUE,
            description: 'Location adjacent to an enum value definition.'
        },
        INPUT_OBJECT: {
            value: (0, _directiveLocationMjs.DirectiveLocation).INPUT_OBJECT,
            description: 'Location adjacent to an input object type definition.'
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, _directiveLocationMjs.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: 'Location adjacent to an input object field definition.'
        }
    }
});
var __Type = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__Type',
    description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
    fields: function fields() {
        return {
            kind: {
                type: new (0, _definitionMjs.GraphQLNonNull)(__TypeKind),
                resolve: function resolve(type) {
                    if ((0, _definitionMjs.isScalarType)(type)) return TypeKind.SCALAR;
                    if ((0, _definitionMjs.isObjectType)(type)) return TypeKind.OBJECT;
                    if ((0, _definitionMjs.isInterfaceType)(type)) return TypeKind.INTERFACE;
                    if ((0, _definitionMjs.isUnionType)(type)) return TypeKind.UNION;
                    if ((0, _definitionMjs.isEnumType)(type)) return TypeKind.ENUM;
                    if ((0, _definitionMjs.isInputObjectType)(type)) return TypeKind.INPUT_OBJECT;
                    if ((0, _definitionMjs.isListType)(type)) return TypeKind.LIST;
                     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
                    if ((0, _definitionMjs.isNonNullType)(type)) return TypeKind.NON_NULL;
                     // istanbul ignore next (Not reachable. All possible types have been considered)
                    (0, _invariantMjsDefault.default)(0, "Unexpected type: \"".concat((0, _inspectMjsDefault.default)(type), "\"."));
                }
            },
            name: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(type) {
                    return type.name !== undefined ? type.name : undefined;
                }
            },
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(type) {
                    return type.description !== undefined ? type.description : undefined;
                }
            },
            specifiedByUrl: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                }
            },
            fields: {
                type: new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__Field)),
                args: {
                    includeDeprecated: {
                        type: (0, _scalarsMjs.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref2) {
                    var includeDeprecated = _ref2.includeDeprecated;
                    if ((0, _definitionMjs.isObjectType)(type) || (0, _definitionMjs.isInterfaceType)(type)) {
                        var fields = (0, _objectValuesMjsDefault.default)(type.getFields());
                        return includeDeprecated ? fields : fields.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            interfaces: {
                type: new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__Type)),
                resolve: function resolve(type) {
                    if ((0, _definitionMjs.isObjectType)(type) || (0, _definitionMjs.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__Type)),
                resolve: function resolve(type, _args, _context, _ref3) {
                    var schema = _ref3.schema;
                    if ((0, _definitionMjs.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__EnumValue)),
                args: {
                    includeDeprecated: {
                        type: (0, _scalarsMjs.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref4) {
                    var includeDeprecated = _ref4.includeDeprecated;
                    if ((0, _definitionMjs.isEnumType)(type)) {
                        var values = type.getValues();
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            inputFields: {
                type: new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__InputValue)),
                args: {
                    includeDeprecated: {
                        type: (0, _scalarsMjs.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref5) {
                    var includeDeprecated = _ref5.includeDeprecated;
                    if ((0, _definitionMjs.isInputObjectType)(type)) {
                        var values = (0, _objectValuesMjsDefault.default)(type.getFields());
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            ofType: {
                type: __Type,
                resolve: function resolve(type) {
                    return type.ofType !== undefined ? type.ofType : undefined;
                }
            }
        };
    }
});
var __Field = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__Field',
    description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
    fields: function fields() {
        return {
            name: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
                resolve: function resolve(field) {
                    return field.name;
                }
            },
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(field) {
                    return field.description;
                }
            },
            args: {
                type: new (0, _definitionMjs.GraphQLNonNull)(new (0, _definitionMjs.GraphQLList)(new (0, _definitionMjs.GraphQLNonNull)(__InputValue))),
                args: {
                    includeDeprecated: {
                        type: (0, _scalarsMjs.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref6) {
                    var includeDeprecated = _ref6.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            },
            type: {
                type: new (0, _definitionMjs.GraphQLNonNull)(__Type),
                resolve: function resolve(field) {
                    return field.type;
                }
            },
            isDeprecated: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(field) {
                    return field.deprecationReason;
                }
            }
        };
    }
});
var __InputValue = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__InputValue',
    description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
    fields: function fields() {
        return {
            name: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
                resolve: function resolve(inputValue) {
                    return inputValue.name;
                }
            },
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(inputValue) {
                    return inputValue.description;
                }
            },
            type: {
                type: new (0, _definitionMjs.GraphQLNonNull)(__Type),
                resolve: function resolve(inputValue) {
                    return inputValue.type;
                }
            },
            defaultValue: {
                type: (0, _scalarsMjs.GraphQLString),
                description: 'A GraphQL-formatted string representing the default value for this input value.',
                resolve: function resolve(inputValue) {
                    var type = inputValue.type, defaultValue = inputValue.defaultValue;
                    var valueAST = (0, _astFromValueMjs.astFromValue)(defaultValue, type);
                    return valueAST ? (0, _printerMjs.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.deprecationReason;
                }
            }
        };
    }
});
var __EnumValue = new (0, _definitionMjs.GraphQLObjectType)({
    name: '__EnumValue',
    description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
    fields: function fields() {
        return {
            name: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
                resolve: function resolve(enumValue) {
                    return enumValue.name;
                }
            },
            description: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.description;
                }
            },
            isDeprecated: {
                type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, _scalarsMjs.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason;
                }
            }
        };
    }
});
var TypeKind = Object.freeze({
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    INPUT_OBJECT: 'INPUT_OBJECT',
    LIST: 'LIST',
    NON_NULL: 'NON_NULL'
});
var __TypeKind = new (0, _definitionMjs.GraphQLEnumType)({
    name: '__TypeKind',
    description: 'An enum describing what kind of type a given `__Type` is.',
    values: {
        SCALAR: {
            value: TypeKind.SCALAR,
            description: 'Indicates this type is a scalar.'
        },
        OBJECT: {
            value: TypeKind.OBJECT,
            description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
        },
        INTERFACE: {
            value: TypeKind.INTERFACE,
            description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
        },
        UNION: {
            value: TypeKind.UNION,
            description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
        },
        ENUM: {
            value: TypeKind.ENUM,
            description: 'Indicates this type is an enum. `enumValues` is a valid field.'
        },
        INPUT_OBJECT: {
            value: TypeKind.INPUT_OBJECT,
            description: 'Indicates this type is an input object. `inputFields` is a valid field.'
        },
        LIST: {
            value: TypeKind.LIST,
            description: 'Indicates this type is a list. `ofType` is a valid field.'
        },
        NON_NULL: {
            value: TypeKind.NON_NULL,
            description: 'Indicates this type is a non-null. `ofType` is a valid field.'
        }
    }
});
var SchemaMetaFieldDef = {
    name: '__schema',
    type: new (0, _definitionMjs.GraphQLNonNull)(__Schema),
    description: 'Access the current type schema of this server.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref7) {
        var schema = _ref7.schema;
        return schema;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var TypeMetaFieldDef = {
    name: '__type',
    type: __Type,
    description: 'Request the type information of a single type.',
    args: [
        {
            name: 'name',
            description: undefined,
            type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: undefined,
            astNode: undefined
        }
    ],
    resolve: function resolve(_source, _ref8, _context, _ref9) {
        var name = _ref8.name;
        var schema = _ref9.schema;
        return schema.getType(name);
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var TypeNameMetaFieldDef = {
    name: '__typename',
    type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
    description: 'The name of the current Object type at runtime.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref10) {
        var parentType = _ref10.parentType;
        return parentType.name;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var introspectionTypes = Object.freeze([
    __Schema,
    __Directive,
    __DirectiveLocation,
    __Type,
    __Field,
    __InputValue,
    __EnumValue,
    __TypeKind
]);
function isIntrospectionType(type) {
    return introspectionTypes.some(function(_ref11) {
        var name = _ref11.name;
        return type.name === name;
    });
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../language/printer.mjs":"dA3NC","../language/directiveLocation.mjs":"tgdMp","../utilities/astFromValue.mjs":"iDso7","./scalars.mjs":"5S8Ww","./definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iDso7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a GraphQL Value AST given a JavaScript object.
 * Function will match JavaScript/JSON values to GraphQL AST schema format
 * by using suggested GraphQLInputType. For example:
 *
 *     astFromValue("value", GraphQLString)
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Mixed         | Enum Value           |
 * | null          | NullValue            |
 *
 */ parcelHelpers.export(exports, "astFromValue", function() {
    return astFromValue;
});
var _isFiniteMjs = require("../polyfills/isFinite.mjs");
var _isFiniteMjsDefault = parcelHelpers.interopDefault(_isFiniteMjs);
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _safeArrayFromMjs = require("../jsutils/safeArrayFrom.mjs");
var _safeArrayFromMjsDefault = parcelHelpers.interopDefault(_safeArrayFromMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _scalarsMjs = require("../type/scalars.mjs");
var _definitionMjs = require("../type/definition.mjs");
function astFromValue(value, type) {
    if ((0, _definitionMjs.isNonNullType)(type)) {
        var astValue = astFromValue(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, _kindsMjs.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, _kindsMjs.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, _definitionMjs.isListType)(type)) {
        var itemType = type.ofType;
        var items = (0, _safeArrayFromMjsDefault.default)(value);
        if (items != null) {
            var valuesNodes = [];
            for(var _i2 = 0; _i2 < items.length; _i2++){
                var item = items[_i2];
                var itemNode = astFromValue(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, _kindsMjs.Kind).LIST,
                values: valuesNodes
            };
        }
        return astFromValue(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, _definitionMjs.isInputObjectType)(type)) {
        if (!(0, _isObjectLikeMjsDefault.default)(value)) return null;
        var fieldNodes = [];
        for(var _i4 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldValue = astFromValue(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, _kindsMjs.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, _kindsMjs.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, _kindsMjs.Kind).OBJECT,
            fields: fieldNodes
        };
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        var serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === 'boolean') return {
            kind: (0, _kindsMjs.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === 'number' && (0, _isFiniteMjsDefault.default)(serialized)) {
            var stringNum = String(serialized);
            return integerStringRegExp.test(stringNum) ? {
                kind: (0, _kindsMjs.Kind).INT,
                value: stringNum
            } : {
                kind: (0, _kindsMjs.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === 'string') {
            // Enum types use Enum literals.
            if ((0, _definitionMjs.isEnumType)(type)) return {
                kind: (0, _kindsMjs.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, _scalarsMjs.GraphQLID) && integerStringRegExp.test(serialized)) return {
                kind: (0, _kindsMjs.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, _kindsMjs.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError("Cannot convert value to AST: ".concat((0, _inspectMjsDefault.default)(serialized), "."));
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected input type: ' + (0, _inspectMjsDefault.default)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ var integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

},{"../polyfills/isFinite.mjs":"ljKBr","../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../jsutils/isObjectLike.mjs":"ji7lb","../jsutils/safeArrayFrom.mjs":"5mRH7","../language/kinds.mjs":"ffJlp","../type/scalars.mjs":"5S8Ww","../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ljKBr":[function(require,module,exports,__globalThis) {
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isFinitePolyfill = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
exports.default = isFinitePolyfill;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5mRH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return safeArrayFrom;
});
var _symbolsMjs = require("../polyfills/symbols.mjs");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function safeArrayFrom(collection) {
    var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function mapFn(item) {
        return item;
    };
    if (collection == null || _typeof(collection) !== 'object') return null;
    if (Array.isArray(collection)) return collection.map(mapFn);
     // Is Iterable?
    var iteratorMethod = collection[0, _symbolsMjs.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        // $FlowFixMe[incompatible-use]
        var iterator = iteratorMethod.call(collection);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
        return result;
    } // Is Array like?
    var length = collection.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i){
            if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
            _result.push(mapFn(collection[String(_i)], _i));
        }
        return _result;
    }
    return null;
}

},{"../polyfills/symbols.mjs":"26hb6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5S8Ww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLInt", function() {
    return GraphQLInt;
});
parcelHelpers.export(exports, "GraphQLFloat", function() {
    return GraphQLFloat;
});
parcelHelpers.export(exports, "GraphQLString", function() {
    return GraphQLString;
});
parcelHelpers.export(exports, "GraphQLBoolean", function() {
    return GraphQLBoolean;
});
parcelHelpers.export(exports, "GraphQLID", function() {
    return GraphQLID;
});
parcelHelpers.export(exports, "specifiedScalarTypes", function() {
    return specifiedScalarTypes;
});
parcelHelpers.export(exports, "isSpecifiedScalarType", function() {
    return isSpecifiedScalarType;
});
var _isFiniteMjs = require("../polyfills/isFinite.mjs");
var _isFiniteMjsDefault = parcelHelpers.interopDefault(_isFiniteMjs);
var _isIntegerMjs = require("../polyfills/isInteger.mjs");
var _isIntegerMjsDefault = parcelHelpers.interopDefault(_isIntegerMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _printerMjs = require("../language/printer.mjs");
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _definitionMjs = require("./definition.mjs"); // As per the GraphQL Spec, Integers are only treated as valid when a valid
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var MAX_INT = 2147483647;
var MIN_INT = -2147483648;
function serializeInt(outputValue) {
    var coercedValue = serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, _isIntegerMjsDefault.default)(num)) throw new (0, _graphQLErrorMjs.GraphQLError)("Int cannot represent non-integer value: ".concat((0, _inspectMjsDefault.default)(coercedValue)));
    if (num > MAX_INT || num < MIN_INT) throw new (0, _graphQLErrorMjs.GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, _inspectMjsDefault.default)(coercedValue));
    return num;
}
function coerceInt(inputValue) {
    if (!(0, _isIntegerMjsDefault.default)(inputValue)) throw new (0, _graphQLErrorMjs.GraphQLError)("Int cannot represent non-integer value: ".concat((0, _inspectMjsDefault.default)(inputValue)));
    if (inputValue > MAX_INT || inputValue < MIN_INT) throw new (0, _graphQLErrorMjs.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
    return inputValue;
}
var GraphQLInt = new (0, _definitionMjs.GraphQLScalarType)({
    name: 'Int',
    description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
    serialize: serializeInt,
    parseValue: coerceInt,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).INT) throw new (0, _graphQLErrorMjs.GraphQLError)("Int cannot represent non-integer value: ".concat((0, _printerMjs.print)(valueNode)), valueNode);
        var num = parseInt(valueNode.value, 10);
        if (num > MAX_INT || num < MIN_INT) throw new (0, _graphQLErrorMjs.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
        return num;
    }
});
function serializeFloat(outputValue) {
    var coercedValue = serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, _isFiniteMjsDefault.default)(num)) throw new (0, _graphQLErrorMjs.GraphQLError)("Float cannot represent non numeric value: ".concat((0, _inspectMjsDefault.default)(coercedValue)));
    return num;
}
function coerceFloat(inputValue) {
    if (!(0, _isFiniteMjsDefault.default)(inputValue)) throw new (0, _graphQLErrorMjs.GraphQLError)("Float cannot represent non numeric value: ".concat((0, _inspectMjsDefault.default)(inputValue)));
    return inputValue;
}
var GraphQLFloat = new (0, _definitionMjs.GraphQLScalarType)({
    name: 'Float',
    description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
    serialize: serializeFloat,
    parseValue: coerceFloat,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).FLOAT && valueNode.kind !== (0, _kindsMjs.Kind).INT) throw new (0, _graphQLErrorMjs.GraphQLError)("Float cannot represent non numeric value: ".concat((0, _printerMjs.print)(valueNode)), valueNode);
        return parseFloat(valueNode.value);
    }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function serializeObject(outputValue) {
    if ((0, _isObjectLikeMjsDefault.default)(outputValue)) {
        if (typeof outputValue.valueOf === 'function') {
            var valueOfResult = outputValue.valueOf();
            if (!(0, _isObjectLikeMjsDefault.default)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === 'function') // $FlowFixMe[incompatible-use]
        return outputValue.toJSON();
    }
    return outputValue;
}
function serializeString(outputValue) {
    var coercedValue = serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.
    if (typeof coercedValue === 'string') return coercedValue;
    if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
    if ((0, _isFiniteMjsDefault.default)(coercedValue)) return coercedValue.toString();
    throw new (0, _graphQLErrorMjs.GraphQLError)("String cannot represent value: ".concat((0, _inspectMjsDefault.default)(outputValue)));
}
function coerceString(inputValue) {
    if (typeof inputValue !== 'string') throw new (0, _graphQLErrorMjs.GraphQLError)("String cannot represent a non string value: ".concat((0, _inspectMjsDefault.default)(inputValue)));
    return inputValue;
}
var GraphQLString = new (0, _definitionMjs.GraphQLScalarType)({
    name: 'String',
    description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
    serialize: serializeString,
    parseValue: coerceString,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).STRING) throw new (0, _graphQLErrorMjs.GraphQLError)("String cannot represent a non string value: ".concat((0, _printerMjs.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function serializeBoolean(outputValue) {
    var coercedValue = serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue;
    if ((0, _isFiniteMjsDefault.default)(coercedValue)) return coercedValue !== 0;
    throw new (0, _graphQLErrorMjs.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, _inspectMjsDefault.default)(coercedValue)));
}
function coerceBoolean(inputValue) {
    if (typeof inputValue !== 'boolean') throw new (0, _graphQLErrorMjs.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, _inspectMjsDefault.default)(inputValue)));
    return inputValue;
}
var GraphQLBoolean = new (0, _definitionMjs.GraphQLScalarType)({
    name: 'Boolean',
    description: 'The `Boolean` scalar type represents `true` or `false`.',
    serialize: serializeBoolean,
    parseValue: coerceBoolean,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).BOOLEAN) throw new (0, _graphQLErrorMjs.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, _printerMjs.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function serializeID(outputValue) {
    var coercedValue = serializeObject(outputValue);
    if (typeof coercedValue === 'string') return coercedValue;
    if ((0, _isIntegerMjsDefault.default)(coercedValue)) return String(coercedValue);
    throw new (0, _graphQLErrorMjs.GraphQLError)("ID cannot represent value: ".concat((0, _inspectMjsDefault.default)(outputValue)));
}
function coerceID(inputValue) {
    if (typeof inputValue === 'string') return inputValue;
    if ((0, _isIntegerMjsDefault.default)(inputValue)) return inputValue.toString();
    throw new (0, _graphQLErrorMjs.GraphQLError)("ID cannot represent value: ".concat((0, _inspectMjsDefault.default)(inputValue)));
}
var GraphQLID = new (0, _definitionMjs.GraphQLScalarType)({
    name: 'ID',
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize: serializeID,
    parseValue: coerceID,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).STRING && valueNode.kind !== (0, _kindsMjs.Kind).INT) throw new (0, _graphQLErrorMjs.GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, _printerMjs.print)(valueNode), valueNode);
        return valueNode.value;
    }
});
var specifiedScalarTypes = Object.freeze([
    GraphQLString,
    GraphQLInt,
    GraphQLFloat,
    GraphQLBoolean,
    GraphQLID
]);
function isSpecifiedScalarType(type) {
    return specifiedScalarTypes.some(function(_ref) {
        var name = _ref.name;
        return type.name === name;
    });
}

},{"../polyfills/isFinite.mjs":"ljKBr","../polyfills/isInteger.mjs":"7N9Om","../jsutils/inspect.mjs":"4vyEo","../jsutils/isObjectLike.mjs":"ji7lb","../language/kinds.mjs":"ffJlp","../language/printer.mjs":"dA3NC","../error/GraphQLError.mjs":"e4y57","./definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7N9Om":[function(require,module,exports,__globalThis) {
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
exports.default = isInteger;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k3NFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Test if the given value is a GraphQL directive.
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isDirective", function() {
    return isDirective;
});
parcelHelpers.export(exports, "assertDirective", function() {
    return assertDirective;
});
parcelHelpers.export(exports, "GraphQLDirective", function() {
    return GraphQLDirective;
});
parcelHelpers.export(exports, "GraphQLIncludeDirective", function() {
    return GraphQLIncludeDirective;
});
parcelHelpers.export(exports, "GraphQLSkipDirective", function() {
    return GraphQLSkipDirective;
});
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", function() {
    return DEFAULT_DEPRECATION_REASON;
});
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", function() {
    return GraphQLDeprecatedDirective;
});
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", function() {
    return GraphQLSpecifiedByDirective;
});
parcelHelpers.export(exports, "specifiedDirectives", function() {
    return specifiedDirectives;
});
parcelHelpers.export(exports, "isSpecifiedDirective", function() {
    return isSpecifiedDirective;
});
var _objectEntriesMjs = require("../polyfills/objectEntries.mjs");
var _objectEntriesMjsDefault = parcelHelpers.interopDefault(_objectEntriesMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _toObjMapMjs = require("../jsutils/toObjMap.mjs");
var _toObjMapMjsDefault = parcelHelpers.interopDefault(_toObjMapMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _defineInspectMjs = require("../jsutils/defineInspect.mjs");
var _defineInspectMjsDefault = parcelHelpers.interopDefault(_defineInspectMjs);
var _directiveLocationMjs = require("../language/directiveLocation.mjs");
var _scalarsMjs = require("./scalars.mjs");
var _definitionMjs = require("./definition.mjs");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function isDirective(directive) {
    return (0, _instanceOfMjsDefault.default)(directive, GraphQLDirective);
}
function assertDirective(directive) {
    if (!isDirective(directive)) throw new Error("Expected ".concat((0, _inspectMjsDefault.default)(directive), " to be a GraphQL directive."));
    return directive;
}
var GraphQLDirective = /*#__PURE__*/ function() {
    function GraphQLDirective(config) {
        var _config$isRepeatable, _config$args;
        this.name = config.name;
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = config.extensions && (0, _toObjMapMjsDefault.default)(config.extensions);
        this.astNode = config.astNode;
        config.name || (0, _devAssertMjsDefault.default)(0, 'Directive must be named.');
        Array.isArray(config.locations) || (0, _devAssertMjsDefault.default)(0, "@".concat(config.name, " locations must be an Array."));
        var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, _isObjectLikeMjsDefault.default)(args) && !Array.isArray(args) || (0, _devAssertMjsDefault.default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
        this.args = (0, _objectEntriesMjsDefault.default)(args).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, _toObjMapMjsDefault.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
    }
    var _proto = GraphQLDirective.prototype;
    _proto.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, _definitionMjs.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    };
    _proto.toString = function toString() {
        return '@' + this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    _createClass(GraphQLDirective, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLDirective';
            }
        }
    ]);
    return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(GraphQLDirective);
var GraphQLIncludeDirective = new GraphQLDirective({
    name: 'include',
    description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
    locations: [
        (0, _directiveLocationMjs.DirectiveLocation).FIELD,
        (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_SPREAD,
        (0, _directiveLocationMjs.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
            description: 'Included when true.'
        }
    }
});
var GraphQLSkipDirective = new GraphQLDirective({
    name: 'skip',
    description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
    locations: [
        (0, _directiveLocationMjs.DirectiveLocation).FIELD,
        (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_SPREAD,
        (0, _directiveLocationMjs.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLBoolean)),
            description: 'Skipped when true.'
        }
    }
});
var DEFAULT_DEPRECATION_REASON = 'No longer supported';
var GraphQLDeprecatedDirective = new GraphQLDirective({
    name: 'deprecated',
    description: 'Marks an element of a GraphQL schema as no longer supported.',
    locations: [
        (0, _directiveLocationMjs.DirectiveLocation).FIELD_DEFINITION,
        (0, _directiveLocationMjs.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, _directiveLocationMjs.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, _directiveLocationMjs.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, _scalarsMjs.GraphQLString),
            description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
            defaultValue: DEFAULT_DEPRECATION_REASON
        }
    }
});
var GraphQLSpecifiedByDirective = new GraphQLDirective({
    name: 'specifiedBy',
    description: 'Exposes a URL that specifies the behaviour of this scalar.',
    locations: [
        (0, _directiveLocationMjs.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, _definitionMjs.GraphQLNonNull)((0, _scalarsMjs.GraphQLString)),
            description: 'The URL that specifies the behaviour of this scalar.'
        }
    }
});
var specifiedDirectives = Object.freeze([
    GraphQLIncludeDirective,
    GraphQLSkipDirective,
    GraphQLDeprecatedDirective,
    GraphQLSpecifiedByDirective
]);
function isSpecifiedDirective(directive) {
    return specifiedDirectives.some(function(_ref2) {
        var name = _ref2.name;
        return name === directive.name;
    });
}

},{"../polyfills/objectEntries.mjs":"ccmaZ","../polyfills/symbols.mjs":"26hb6","../jsutils/inspect.mjs":"4vyEo","../jsutils/toObjMap.mjs":"aJhPA","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/instanceOf.mjs":"4pPiF","../jsutils/isObjectLike.mjs":"ji7lb","../jsutils/defineInspect.mjs":"8FViL","../language/directiveLocation.mjs":"tgdMp","./scalars.mjs":"5S8Ww","./definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ju2gk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeInfo", function() {
    return TypeInfo;
});
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ parcelHelpers.export(exports, "visitWithTypeInfo", function() {
    return visitWithTypeInfo;
});
var _findMjs = require("../polyfills/find.mjs");
var _findMjsDefault = parcelHelpers.interopDefault(_findMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _astMjs = require("../language/ast.mjs");
var _visitorMjs = require("../language/visitor.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _typeFromASTMjs = require("./typeFromAST.mjs");
var TypeInfo = /*#__PURE__*/ function() {
    function TypeInfo(schema, // to support non-spec-compliant code bases. You should never need to use it.
    // It may disappear in the future.
    getFieldDefFn, // beginning somewhere other than documents.
    initialType) {
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : getFieldDef;
        if (initialType) {
            if ((0, _definitionMjs.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, _definitionMjs.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, _definitionMjs.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    var _proto = TypeInfo.prototype;
    _proto.getType = function getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    };
    _proto.getParentType = function getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    };
    _proto.getInputType = function getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    };
    _proto.getParentInputType = function getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    };
    _proto.getFieldDef = function getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    };
    _proto.getDefaultValue = function getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    };
    _proto.getDirective = function getDirective() {
        return this._directive;
    };
    _proto.getArgument = function getArgument() {
        return this._argument;
    };
    _proto.getEnumValue = function getEnumValue() {
        return this._enumValue;
    };
    _proto.enter = function enter(node) {
        var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, _kindsMjs.Kind).SELECTION_SET:
                var namedType = (0, _definitionMjs.getNamedType)(this.getType());
                this._parentTypeStack.push((0, _definitionMjs.isCompositeType)(namedType) ? namedType : undefined);
                break;
            case (0, _kindsMjs.Kind).FIELD:
                var parentType = this.getParentType();
                var fieldDef;
                var fieldType;
                if (parentType) {
                    fieldDef = this._getFieldDef(schema, parentType, node);
                    if (fieldDef) fieldType = fieldDef.type;
                }
                this._fieldDefStack.push(fieldDef);
                this._typeStack.push((0, _definitionMjs.isOutputType)(fieldType) ? fieldType : undefined);
                break;
            case (0, _kindsMjs.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, _kindsMjs.Kind).OPERATION_DEFINITION:
                var type;
                switch(node.operation){
                    case 'query':
                        type = schema.getQueryType();
                        break;
                    case 'mutation':
                        type = schema.getMutationType();
                        break;
                    case 'subscription':
                        type = schema.getSubscriptionType();
                        break;
                }
                this._typeStack.push((0, _definitionMjs.isObjectType)(type) ? type : undefined);
                break;
            case (0, _kindsMjs.Kind).INLINE_FRAGMENT:
            case (0, _kindsMjs.Kind).FRAGMENT_DEFINITION:
                var typeConditionAST = node.typeCondition;
                var outputType = typeConditionAST ? (0, _typeFromASTMjs.typeFromAST)(schema, typeConditionAST) : (0, _definitionMjs.getNamedType)(this.getType());
                this._typeStack.push((0, _definitionMjs.isOutputType)(outputType) ? outputType : undefined);
                break;
            case (0, _kindsMjs.Kind).VARIABLE_DEFINITION:
                var inputType = (0, _typeFromASTMjs.typeFromAST)(schema, node.type);
                this._inputTypeStack.push((0, _definitionMjs.isInputType)(inputType) ? inputType : undefined);
                break;
            case (0, _kindsMjs.Kind).ARGUMENT:
                var _this$getDirective;
                var argDef;
                var argType;
                var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                if (fieldOrDirective) {
                    argDef = (0, _findMjsDefault.default)(fieldOrDirective.args, function(arg) {
                        return arg.name === node.name.value;
                    });
                    if (argDef) argType = argDef.type;
                }
                this._argument = argDef;
                this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                this._inputTypeStack.push((0, _definitionMjs.isInputType)(argType) ? argType : undefined);
                break;
            case (0, _kindsMjs.Kind).LIST:
                var listType = (0, _definitionMjs.getNullableType)(this.getInputType());
                var itemType = (0, _definitionMjs.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                this._defaultValueStack.push(undefined);
                this._inputTypeStack.push((0, _definitionMjs.isInputType)(itemType) ? itemType : undefined);
                break;
            case (0, _kindsMjs.Kind).OBJECT_FIELD:
                var objectType = (0, _definitionMjs.getNamedType)(this.getInputType());
                var inputFieldType;
                var inputField;
                if ((0, _definitionMjs.isInputObjectType)(objectType)) {
                    inputField = objectType.getFields()[node.name.value];
                    if (inputField) inputFieldType = inputField.type;
                }
                this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                this._inputTypeStack.push((0, _definitionMjs.isInputType)(inputFieldType) ? inputFieldType : undefined);
                break;
            case (0, _kindsMjs.Kind).ENUM:
                var enumType = (0, _definitionMjs.getNamedType)(this.getInputType());
                var enumValue;
                if ((0, _definitionMjs.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                this._enumValue = enumValue;
                break;
        }
    };
    _proto.leave = function leave(node) {
        switch(node.kind){
            case (0, _kindsMjs.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, _kindsMjs.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, _kindsMjs.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, _kindsMjs.Kind).OPERATION_DEFINITION:
            case (0, _kindsMjs.Kind).INLINE_FRAGMENT:
            case (0, _kindsMjs.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, _kindsMjs.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, _kindsMjs.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, _kindsMjs.Kind).LIST:
            case (0, _kindsMjs.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, _kindsMjs.Kind).ENUM:
                this._enumValue = null;
                break;
        }
    };
    return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function getFieldDef(schema, parentType, fieldNode) {
    var name = fieldNode.name.value;
    if (name === (0, _introspectionMjs.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, _introspectionMjs.SchemaMetaFieldDef;
    if (name === (0, _introspectionMjs.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, _introspectionMjs.TypeMetaFieldDef;
    if (name === (0, _introspectionMjs.TypeNameMetaFieldDef).name && (0, _definitionMjs.isCompositeType)(parentType)) return 0, _introspectionMjs.TypeNameMetaFieldDef;
    if ((0, _definitionMjs.isObjectType)(parentType) || (0, _definitionMjs.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = (0, _visitorMjs.getVisitFn)(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, _astMjs.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = (0, _visitorMjs.getVisitFn)(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}

},{"../polyfills/find.mjs":"caL9z","../language/kinds.mjs":"ffJlp","../language/ast.mjs":"diDO0","../language/visitor.mjs":"aHQOA","../type/definition.mjs":"hN98Z","../type/introspection.mjs":"fg0io","./typeFromAST.mjs":"2b0nl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2b0nl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a Schema and an AST node describing a type, return a GraphQLType
 * definition which applies to that type. For example, if provided the parsed
 * AST node for `[User]`, a GraphQLList instance will be returned, containing
 * the type called "User" found in the schema. If a type called "User" is not
 * found in the schema, then undefined will be returned.
 */ /* eslint-disable no-redeclare */ parcelHelpers.export(exports, "typeFromAST", function() {
    return typeFromAST;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _definitionMjs = require("../type/definition.mjs");
function typeFromAST(schema, typeNode) {
    /* eslint-enable no-redeclare */ var innerType;
    if (typeNode.kind === (0, _kindsMjs.Kind).LIST_TYPE) {
        innerType = typeFromAST(schema, typeNode.type);
        return innerType && new (0, _definitionMjs.GraphQLList)(innerType);
    }
    if (typeNode.kind === (0, _kindsMjs.Kind).NON_NULL_TYPE) {
        innerType = typeFromAST(schema, typeNode.type);
        return innerType && new (0, _definitionMjs.GraphQLNonNull)(innerType);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if (typeNode.kind === (0, _kindsMjs.Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
     // istanbul ignore next (Not reachable. All possible type nodes have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected type node: ' + (0, _inspectMjsDefault.default)(typeNode));
}

},{"../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../language/kinds.mjs":"ffJlp","../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1HAr9":[function(require,module,exports,__globalThis) {
// Spec Section: "Executable Definitions"
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "specifiedRules", function() {
    return specifiedRules;
});
parcelHelpers.export(exports, "specifiedSDLRules", function() {
    return specifiedSDLRules;
});
var _executableDefinitionsRuleMjs = require("./rules/ExecutableDefinitionsRule.mjs"); // Spec Section: "Operation Name Uniqueness"
var _uniqueOperationNamesRuleMjs = require("./rules/UniqueOperationNamesRule.mjs"); // Spec Section: "Lone Anonymous Operation"
var _loneAnonymousOperationRuleMjs = require("./rules/LoneAnonymousOperationRule.mjs"); // Spec Section: "Subscriptions with Single Root Field"
var _singleFieldSubscriptionsRuleMjs = require("./rules/SingleFieldSubscriptionsRule.mjs"); // Spec Section: "Fragment Spread Type Existence"
var _knownTypeNamesRuleMjs = require("./rules/KnownTypeNamesRule.mjs"); // Spec Section: "Fragments on Composite Types"
var _fragmentsOnCompositeTypesRuleMjs = require("./rules/FragmentsOnCompositeTypesRule.mjs"); // Spec Section: "Variables are Input Types"
var _variablesAreInputTypesRuleMjs = require("./rules/VariablesAreInputTypesRule.mjs"); // Spec Section: "Leaf Field Selections"
var _scalarLeafsRuleMjs = require("./rules/ScalarLeafsRule.mjs"); // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
var _fieldsOnCorrectTypeRuleMjs = require("./rules/FieldsOnCorrectTypeRule.mjs"); // Spec Section: "Fragment Name Uniqueness"
var _uniqueFragmentNamesRuleMjs = require("./rules/UniqueFragmentNamesRule.mjs"); // Spec Section: "Fragment spread target defined"
var _knownFragmentNamesRuleMjs = require("./rules/KnownFragmentNamesRule.mjs"); // Spec Section: "Fragments must be used"
var _noUnusedFragmentsRuleMjs = require("./rules/NoUnusedFragmentsRule.mjs"); // Spec Section: "Fragment spread is possible"
var _possibleFragmentSpreadsRuleMjs = require("./rules/PossibleFragmentSpreadsRule.mjs"); // Spec Section: "Fragments must not form cycles"
var _noFragmentCyclesRuleMjs = require("./rules/NoFragmentCyclesRule.mjs"); // Spec Section: "Variable Uniqueness"
var _uniqueVariableNamesRuleMjs = require("./rules/UniqueVariableNamesRule.mjs"); // Spec Section: "All Variable Used Defined"
var _noUndefinedVariablesRuleMjs = require("./rules/NoUndefinedVariablesRule.mjs"); // Spec Section: "All Variables Used"
var _noUnusedVariablesRuleMjs = require("./rules/NoUnusedVariablesRule.mjs"); // Spec Section: "Directives Are Defined"
var _knownDirectivesRuleMjs = require("./rules/KnownDirectivesRule.mjs"); // Spec Section: "Directives Are Unique Per Location"
var _uniqueDirectivesPerLocationRuleMjs = require("./rules/UniqueDirectivesPerLocationRule.mjs"); // Spec Section: "Argument Names"
var _knownArgumentNamesRuleMjs = require("./rules/KnownArgumentNamesRule.mjs"); // Spec Section: "Argument Uniqueness"
var _uniqueArgumentNamesRuleMjs = require("./rules/UniqueArgumentNamesRule.mjs"); // Spec Section: "Value Type Correctness"
var _valuesOfCorrectTypeRuleMjs = require("./rules/ValuesOfCorrectTypeRule.mjs"); // Spec Section: "Argument Optionality"
var _providedRequiredArgumentsRuleMjs = require("./rules/ProvidedRequiredArgumentsRule.mjs"); // Spec Section: "All Variable Usages Are Allowed"
var _variablesInAllowedPositionRuleMjs = require("./rules/VariablesInAllowedPositionRule.mjs"); // Spec Section: "Field Selection Merging"
var _overlappingFieldsCanBeMergedRuleMjs = require("./rules/OverlappingFieldsCanBeMergedRule.mjs"); // Spec Section: "Input Object Field Uniqueness"
var _uniqueInputFieldNamesRuleMjs = require("./rules/UniqueInputFieldNamesRule.mjs"); // SDL-specific validation rules
var _loneSchemaDefinitionRuleMjs = require("./rules/LoneSchemaDefinitionRule.mjs");
var _uniqueOperationTypesRuleMjs = require("./rules/UniqueOperationTypesRule.mjs");
var _uniqueTypeNamesRuleMjs = require("./rules/UniqueTypeNamesRule.mjs");
var _uniqueEnumValueNamesRuleMjs = require("./rules/UniqueEnumValueNamesRule.mjs");
var _uniqueFieldDefinitionNamesRuleMjs = require("./rules/UniqueFieldDefinitionNamesRule.mjs");
var _uniqueDirectiveNamesRuleMjs = require("./rules/UniqueDirectiveNamesRule.mjs");
var _possibleTypeExtensionsRuleMjs = require("./rules/PossibleTypeExtensionsRule.mjs");
var specifiedRules = Object.freeze([
    (0, _executableDefinitionsRuleMjs.ExecutableDefinitionsRule),
    (0, _uniqueOperationNamesRuleMjs.UniqueOperationNamesRule),
    (0, _loneAnonymousOperationRuleMjs.LoneAnonymousOperationRule),
    (0, _singleFieldSubscriptionsRuleMjs.SingleFieldSubscriptionsRule),
    (0, _knownTypeNamesRuleMjs.KnownTypeNamesRule),
    (0, _fragmentsOnCompositeTypesRuleMjs.FragmentsOnCompositeTypesRule),
    (0, _variablesAreInputTypesRuleMjs.VariablesAreInputTypesRule),
    (0, _scalarLeafsRuleMjs.ScalarLeafsRule),
    (0, _fieldsOnCorrectTypeRuleMjs.FieldsOnCorrectTypeRule),
    (0, _uniqueFragmentNamesRuleMjs.UniqueFragmentNamesRule),
    (0, _knownFragmentNamesRuleMjs.KnownFragmentNamesRule),
    (0, _noUnusedFragmentsRuleMjs.NoUnusedFragmentsRule),
    (0, _possibleFragmentSpreadsRuleMjs.PossibleFragmentSpreadsRule),
    (0, _noFragmentCyclesRuleMjs.NoFragmentCyclesRule),
    (0, _uniqueVariableNamesRuleMjs.UniqueVariableNamesRule),
    (0, _noUndefinedVariablesRuleMjs.NoUndefinedVariablesRule),
    (0, _noUnusedVariablesRuleMjs.NoUnusedVariablesRule),
    (0, _knownDirectivesRuleMjs.KnownDirectivesRule),
    (0, _uniqueDirectivesPerLocationRuleMjs.UniqueDirectivesPerLocationRule),
    (0, _knownArgumentNamesRuleMjs.KnownArgumentNamesRule),
    (0, _uniqueArgumentNamesRuleMjs.UniqueArgumentNamesRule),
    (0, _valuesOfCorrectTypeRuleMjs.ValuesOfCorrectTypeRule),
    (0, _providedRequiredArgumentsRuleMjs.ProvidedRequiredArgumentsRule),
    (0, _variablesInAllowedPositionRuleMjs.VariablesInAllowedPositionRule),
    (0, _overlappingFieldsCanBeMergedRuleMjs.OverlappingFieldsCanBeMergedRule),
    (0, _uniqueInputFieldNamesRuleMjs.UniqueInputFieldNamesRule)
]);
var specifiedSDLRules = Object.freeze([
    (0, _loneSchemaDefinitionRuleMjs.LoneSchemaDefinitionRule),
    (0, _uniqueOperationTypesRuleMjs.UniqueOperationTypesRule),
    (0, _uniqueTypeNamesRuleMjs.UniqueTypeNamesRule),
    (0, _uniqueEnumValueNamesRuleMjs.UniqueEnumValueNamesRule),
    (0, _uniqueFieldDefinitionNamesRuleMjs.UniqueFieldDefinitionNamesRule),
    (0, _uniqueDirectiveNamesRuleMjs.UniqueDirectiveNamesRule),
    (0, _knownTypeNamesRuleMjs.KnownTypeNamesRule),
    (0, _knownDirectivesRuleMjs.KnownDirectivesRule),
    (0, _uniqueDirectivesPerLocationRuleMjs.UniqueDirectivesPerLocationRule),
    (0, _possibleTypeExtensionsRuleMjs.PossibleTypeExtensionsRule),
    (0, _knownArgumentNamesRuleMjs.KnownArgumentNamesOnDirectivesRule),
    (0, _uniqueArgumentNamesRuleMjs.UniqueArgumentNamesRule),
    (0, _uniqueInputFieldNamesRuleMjs.UniqueInputFieldNamesRule),
    (0, _providedRequiredArgumentsRuleMjs.ProvidedRequiredArgumentsOnDirectivesRule)
]);

},{"./rules/ExecutableDefinitionsRule.mjs":"cQd2g","./rules/UniqueOperationNamesRule.mjs":"hiYSX","./rules/LoneAnonymousOperationRule.mjs":"4bhQU","./rules/SingleFieldSubscriptionsRule.mjs":"8LYfh","./rules/KnownTypeNamesRule.mjs":"cymvC","./rules/FragmentsOnCompositeTypesRule.mjs":"9ikXa","./rules/VariablesAreInputTypesRule.mjs":"c34nn","./rules/ScalarLeafsRule.mjs":"8VtZE","./rules/FieldsOnCorrectTypeRule.mjs":"emuRG","./rules/UniqueFragmentNamesRule.mjs":"btgAU","./rules/KnownFragmentNamesRule.mjs":"CqkcL","./rules/NoUnusedFragmentsRule.mjs":"jBysz","./rules/PossibleFragmentSpreadsRule.mjs":"lRxXk","./rules/NoFragmentCyclesRule.mjs":"hO8Y4","./rules/UniqueVariableNamesRule.mjs":"eSmdU","./rules/NoUndefinedVariablesRule.mjs":"5dXjy","./rules/NoUnusedVariablesRule.mjs":"7Fxnf","./rules/KnownDirectivesRule.mjs":"icSQy","./rules/UniqueDirectivesPerLocationRule.mjs":"lVij4","./rules/KnownArgumentNamesRule.mjs":"454uw","./rules/UniqueArgumentNamesRule.mjs":"eJPzp","./rules/ValuesOfCorrectTypeRule.mjs":"9hkVW","./rules/ProvidedRequiredArgumentsRule.mjs":"7gmuj","./rules/VariablesInAllowedPositionRule.mjs":"aACfV","./rules/OverlappingFieldsCanBeMergedRule.mjs":"E5YPN","./rules/UniqueInputFieldNamesRule.mjs":"cLbRy","./rules/LoneSchemaDefinitionRule.mjs":"adXGS","./rules/UniqueOperationTypesRule.mjs":"fYcAh","./rules/UniqueTypeNamesRule.mjs":"21Bmd","./rules/UniqueEnumValueNamesRule.mjs":"4ouc6","./rules/UniqueFieldDefinitionNamesRule.mjs":"fvec4","./rules/UniqueDirectiveNamesRule.mjs":"k26ww","./rules/PossibleTypeExtensionsRule.mjs":"9hVFH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQd2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 */ parcelHelpers.export(exports, "ExecutableDefinitionsRule", function() {
    return ExecutableDefinitionsRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _predicatesMjs = require("../../language/predicates.mjs");
function ExecutableDefinitionsRule(context) {
    return {
        Document: function Document(node) {
            for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                var definition = _node$definitions2[_i2];
                if (!(0, _predicatesMjs.isExecutableDefinitionNode)(definition)) {
                    var defName = definition.kind === (0, _kindsMjs.Kind).SCHEMA_DEFINITION || definition.kind === (0, _kindsMjs.Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                }
            }
            return false;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/predicates.mjs":"iXXFP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iXXFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDefinitionNode", function() {
    return isDefinitionNode;
});
parcelHelpers.export(exports, "isExecutableDefinitionNode", function() {
    return isExecutableDefinitionNode;
});
parcelHelpers.export(exports, "isSelectionNode", function() {
    return isSelectionNode;
});
parcelHelpers.export(exports, "isValueNode", function() {
    return isValueNode;
});
parcelHelpers.export(exports, "isTypeNode", function() {
    return isTypeNode;
});
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", function() {
    return isTypeSystemDefinitionNode;
});
parcelHelpers.export(exports, "isTypeDefinitionNode", function() {
    return isTypeDefinitionNode;
});
parcelHelpers.export(exports, "isTypeSystemExtensionNode", function() {
    return isTypeSystemExtensionNode;
});
parcelHelpers.export(exports, "isTypeExtensionNode", function() {
    return isTypeExtensionNode;
});
var _kindsMjs = require("./kinds.mjs");
function isDefinitionNode(node) {
    return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).OPERATION_DEFINITION || node.kind === (0, _kindsMjs.Kind).FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).FIELD || node.kind === (0, _kindsMjs.Kind).FRAGMENT_SPREAD || node.kind === (0, _kindsMjs.Kind).INLINE_FRAGMENT;
}
function isValueNode(node) {
    return node.kind === (0, _kindsMjs.Kind).VARIABLE || node.kind === (0, _kindsMjs.Kind).INT || node.kind === (0, _kindsMjs.Kind).FLOAT || node.kind === (0, _kindsMjs.Kind).STRING || node.kind === (0, _kindsMjs.Kind).BOOLEAN || node.kind === (0, _kindsMjs.Kind).NULL || node.kind === (0, _kindsMjs.Kind).ENUM || node.kind === (0, _kindsMjs.Kind).LIST || node.kind === (0, _kindsMjs.Kind).OBJECT;
}
function isTypeNode(node) {
    return node.kind === (0, _kindsMjs.Kind).NAMED_TYPE || node.kind === (0, _kindsMjs.Kind).LIST_TYPE || node.kind === (0, _kindsMjs.Kind).NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

},{"./kinds.mjs":"ffJlp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hiYSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 */ parcelHelpers.export(exports, "UniqueOperationNamesRule", function() {
    return UniqueOperationNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueOperationNamesRule(context) {
    var knownOperationNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition(node) {
            var operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                    knownOperationNames[operationName.value],
                    operationName
                ]));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: function FragmentDefinition() {
            return false;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4bhQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 */ parcelHelpers.export(exports, "LoneAnonymousOperationRule", function() {
    return LoneAnonymousOperationRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
function LoneAnonymousOperationRule(context) {
    var operationCount = 0;
    return {
        Document: function Document(node) {
            operationCount = node.definitions.filter(function(definition) {
                return definition.kind === (0, _kindsMjs.Kind).OPERATION_DEFINITION;
            }).length;
        },
        OperationDefinition: function OperationDefinition(node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)('This anonymous operation must be the only defined operation.', node));
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8LYfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Subscriptions must only include one field.
 *
 * A GraphQL subscription is valid only if it contains a single root field.
 */ parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", function() {
    return SingleFieldSubscriptionsRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function SingleFieldSubscriptionsRule(context) {
    return {
        OperationDefinition: function OperationDefinition(node) {
            if (node.operation === 'subscription') {
                if (node.selectionSet.selections.length !== 1) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
            }
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cymvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 */ parcelHelpers.export(exports, "KnownTypeNamesRule", function() {
    return KnownTypeNamesRule;
});
var _didYouMeanMjs = require("../../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _suggestionListMjs = require("../../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _predicatesMjs = require("../../language/predicates.mjs");
var _scalarsMjs = require("../../type/scalars.mjs");
var _introspectionMjs = require("../../type/introspection.mjs");
function KnownTypeNamesRule(context) {
    var schema = context.getSchema();
    var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, _predicatesMjs.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    }
    var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
    return {
        NamedType: function NamedType(node, _1, parent, _2, ancestors) {
            var typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                var isSDL = definitionNode != null && isSDLNode(definitionNode);
                if (isSDL && isStandardTypeName(typeName)) return;
                var suggestedTypes = (0, _suggestionListMjsDefault.default)(typeName, isSDL ? standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, _didYouMeanMjsDefault.default)(suggestedTypes), node));
            }
        }
    };
}
var standardTypeNames = [].concat((0, _scalarsMjs.specifiedScalarTypes), (0, _introspectionMjs.introspectionTypes)).map(function(type) {
    return type.name;
});
function isStandardTypeName(typeName) {
    return standardTypeNames.indexOf(typeName) !== -1;
}
function isSDLNode(value) {
    return !Array.isArray(value) && ((0, _predicatesMjs.isTypeSystemDefinitionNode)(value) || (0, _predicatesMjs.isTypeSystemExtensionNode)(value));
}

},{"../../jsutils/didYouMean.mjs":"gdkI5","../../jsutils/suggestionList.mjs":"634S6","../../error/GraphQLError.mjs":"e4y57","../../language/predicates.mjs":"iXXFP","../../type/scalars.mjs":"5S8Ww","../../type/introspection.mjs":"fg0io","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ikXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 */ parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", function() {
    return FragmentsOnCompositeTypesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _printerMjs = require("../../language/printer.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _typeFromASTMjs = require("../../utilities/typeFromAST.mjs");
function FragmentsOnCompositeTypesRule(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var typeCondition = node.typeCondition;
            if (typeCondition) {
                var type = (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, _definitionMjs.isCompositeType)(type)) {
                    var typeStr = (0, _printerMjs.print)(typeCondition);
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                }
            }
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var type = (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, _definitionMjs.isCompositeType)(type)) {
                var typeStr = (0, _printerMjs.print)(node.typeCondition);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
            }
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","../../language/printer.mjs":"dA3NC","../../type/definition.mjs":"hN98Z","../../utilities/typeFromAST.mjs":"2b0nl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c34nn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 */ parcelHelpers.export(exports, "VariablesAreInputTypesRule", function() {
    return VariablesAreInputTypesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _printerMjs = require("../../language/printer.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _typeFromASTMjs = require("../../utilities/typeFromAST.mjs");
function VariablesAreInputTypesRule(context) {
    return {
        VariableDefinition: function VariableDefinition(node) {
            var type = (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), node.type);
            if (type && !(0, _definitionMjs.isInputType)(type)) {
                var variableName = node.variable.name.value;
                var typeName = (0, _printerMjs.print)(node.type);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
            }
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","../../language/printer.mjs":"dA3NC","../../type/definition.mjs":"hN98Z","../../utilities/typeFromAST.mjs":"2b0nl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8VtZE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */ parcelHelpers.export(exports, "ScalarLeafsRule", function() {
    return ScalarLeafsRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function ScalarLeafsRule(context) {
    return {
        Field: function Field(node) {
            var type = context.getType();
            var selectionSet = node.selectionSet;
            if (type) {
                if ((0, _definitionMjs.isLeafType)((0, _definitionMjs.getNamedType)(type))) {
                    if (selectionSet) {
                        var fieldName = node.name.value;
                        var typeStr = (0, _inspectMjsDefault.default)(type);
                        context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                    }
                } else if (!selectionSet) {
                    var _fieldName = node.name.value;
                    var _typeStr = (0, _inspectMjsDefault.default)(type);
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                }
            }
        }
    };
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../error/GraphQLError.mjs":"e4y57","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"emuRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 */ parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", function() {
    return FieldsOnCorrectTypeRule;
});
var _arrayFromMjs = require("../../polyfills/arrayFrom.mjs");
var _arrayFromMjsDefault = parcelHelpers.interopDefault(_arrayFromMjs);
var _didYouMeanMjs = require("../../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _suggestionListMjs = require("../../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _naturalCompareMjs = require("../../jsutils/naturalCompare.mjs");
var _naturalCompareMjsDefault = parcelHelpers.interopDefault(_naturalCompareMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function FieldsOnCorrectTypeRule(context) {
    return {
        Field: function Field(node) {
            var type = context.getParentType();
            if (type) {
                var fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    var schema = context.getSchema();
                    var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    var suggestion = (0, _didYouMeanMjsDefault.default)('to use an inline fragment on', getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === '') suggestion = (0, _didYouMeanMjsDefault.default)(getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, _definitionMjs.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    var suggestedTypes = new Set();
    var usageCount = Object.create(null);
    for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
        var possibleType = _schema$getPossibleTy2[_i2];
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
            var _usageCount$possibleI;
            var possibleInterface = _possibleType$getInte2[_i4];
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return (0, _arrayFromMjsDefault.default)(suggestedTypes).sort(function(typeA, typeB) {
        // Suggest both interface and object types based on how common they are.
        var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, _definitionMjs.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, _definitionMjs.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, _naturalCompareMjsDefault.default)(typeA.name, typeB.name);
    }).map(function(x) {
        return x.name;
    });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function getSuggestedFieldNames(type, fieldName) {
    if ((0, _definitionMjs.isObjectType)(type) || (0, _definitionMjs.isInterfaceType)(type)) {
        var possibleFieldNames = Object.keys(type.getFields());
        return (0, _suggestionListMjsDefault.default)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

},{"../../polyfills/arrayFrom.mjs":"8YpN1","../../jsutils/didYouMean.mjs":"gdkI5","../../jsutils/suggestionList.mjs":"634S6","../../jsutils/naturalCompare.mjs":"gukLP","../../error/GraphQLError.mjs":"e4y57","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"btgAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 */ parcelHelpers.export(exports, "UniqueFragmentNamesRule", function() {
    return UniqueFragmentNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueFragmentNamesRule(context) {
    var knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                knownFragmentNames[fragmentName],
                node.name
            ]));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"CqkcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 */ parcelHelpers.export(exports, "KnownFragmentNamesRule", function() {
    return KnownFragmentNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function KnownFragmentNamesRule(context) {
    return {
        FragmentSpread: function FragmentSpread(node) {
            var fragmentName = node.name.value;
            var fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jBysz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 */ parcelHelpers.export(exports, "NoUnusedFragmentsRule", function() {
    return NoUnusedFragmentsRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function NoUnusedFragmentsRule(context) {
    var operationDefs = [];
    var fragmentDefs = [];
    return {
        OperationDefinition: function OperationDefinition(node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave: function leave() {
                var fragmentNameUsed = Object.create(null);
                for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                    var operation = operationDefs[_i2];
                    for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                        var fragment = _context$getRecursive2[_i4];
                        fragmentNameUsed[fragment.name.value] = true;
                    }
                }
                for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                    var fragmentDef = fragmentDefs[_i6];
                    var fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                }
            }
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRxXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */ parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", function() {
    return PossibleFragmentSpreadsRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _typeFromASTMjs = require("../../utilities/typeFromAST.mjs");
var _typeComparatorsMjs = require("../../utilities/typeComparators.mjs");
function PossibleFragmentSpreadsRule(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var fragType = context.getType();
            var parentType = context.getParentType();
            if ((0, _definitionMjs.isCompositeType)(fragType) && (0, _definitionMjs.isCompositeType)(parentType) && !(0, _typeComparatorsMjs.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, _inspectMjsDefault.default)(parentType);
                var fragTypeStr = (0, _inspectMjsDefault.default)(fragType);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        },
        FragmentSpread: function FragmentSpread(node) {
            var fragName = node.name.value;
            var fragType = getFragmentType(context, fragName);
            var parentType = context.getParentType();
            if (fragType && parentType && !(0, _typeComparatorsMjs.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, _inspectMjsDefault.default)(parentType);
                var fragTypeStr = (0, _inspectMjsDefault.default)(fragType);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        }
    };
}
function getFragmentType(context, name) {
    var frag = context.getFragment(name);
    if (frag) {
        var type = (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, _definitionMjs.isCompositeType)(type)) return type;
    }
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../error/GraphQLError.mjs":"e4y57","../../type/definition.mjs":"hN98Z","../../utilities/typeFromAST.mjs":"2b0nl","../../utilities/typeComparators.mjs":"fc5HZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hO8Y4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoFragmentCyclesRule", function() {
    return NoFragmentCyclesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function NoFragmentCyclesRule(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    var spreadPath = []; // Position in the spread path
    var spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        var fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
            var spreadNode = spreadNodes[_i2];
            var spreadName = spreadNode.name.value;
            var cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                var spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                var cyclePath = spreadPath.slice(cycleIndex);
                var viaPath = cyclePath.slice(0, -1).map(function(s) {
                    return '"' + s.name.value + '"';
                }).join(', ');
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eSmdU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */ parcelHelpers.export(exports, "UniqueVariableNamesRule", function() {
    return UniqueVariableNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueVariableNamesRule(context) {
    var knownVariableNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            knownVariableNames = Object.create(null);
        },
        VariableDefinition: function VariableDefinition(node) {
            var variableName = node.variable.name.value;
            if (knownVariableNames[variableName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                knownVariableNames[variableName],
                node.variable.name
            ]));
            else knownVariableNames[variableName] = node.variable.name;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5dXjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 */ parcelHelpers.export(exports, "NoUndefinedVariablesRule", function() {
    return NoUndefinedVariablesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function NoUndefinedVariablesRule(context) {
    var variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                variableNameDefined = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                        node,
                        operation
                    ]));
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Fxnf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 */ parcelHelpers.export(exports, "NoUnusedVariablesRule", function() {
    return NoUnusedVariablesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function NoUnusedVariablesRule(context) {
    var variableDefs = [];
    return {
        OperationDefinition: {
            enter: function enter() {
                variableDefs = [];
            },
            leave: function leave(operation) {
                var variableNameUsed = Object.create(null);
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    variableNameUsed[node.name.value] = true;
                }
                for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                    var variableDef = _variableDefs2[_i4];
                    var variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                }
            }
        },
        VariableDefinition: function VariableDefinition(def) {
            variableDefs.push(def);
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icSQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 */ parcelHelpers.export(exports, "KnownDirectivesRule", function() {
    return KnownDirectivesRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _directiveLocationMjs = require("../../language/directiveLocation.mjs");
var _directivesMjs = require("../../type/directives.mjs");
function KnownDirectivesRule(context) {
    var locationsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, _directivesMjs.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        locationsMap[directive.name] = directive.locations;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
            return name.value;
        });
    }
    return {
        Directive: function Directive(node, _key, _parent, _path, ancestors) {
            var name = node.name.value;
            var locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                return;
            }
            var candidateLocation = getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
        }
    };
}
function getDirectiveLocationForASTPath(ancestors) {
    var appliedTo = ancestors[ancestors.length - 1];
    !Array.isArray(appliedTo) || (0, _invariantMjsDefault.default)(0);
    switch(appliedTo.kind){
        case (0, _kindsMjs.Kind).OPERATION_DEFINITION:
            return getDirectiveLocationForOperation(appliedTo.operation);
        case (0, _kindsMjs.Kind).FIELD:
            return (0, _directiveLocationMjs.DirectiveLocation).FIELD;
        case (0, _kindsMjs.Kind).FRAGMENT_SPREAD:
            return (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, _kindsMjs.Kind).INLINE_FRAGMENT:
            return (0, _directiveLocationMjs.DirectiveLocation).INLINE_FRAGMENT;
        case (0, _kindsMjs.Kind).FRAGMENT_DEFINITION:
            return (0, _directiveLocationMjs.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, _kindsMjs.Kind).VARIABLE_DEFINITION:
            return (0, _directiveLocationMjs.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, _kindsMjs.Kind).SCHEMA_DEFINITION:
        case (0, _kindsMjs.Kind).SCHEMA_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).SCHEMA;
        case (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).SCALAR;
        case (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).OBJECT;
        case (0, _kindsMjs.Kind).FIELD_DEFINITION:
            return (0, _directiveLocationMjs.DirectiveLocation).FIELD_DEFINITION;
        case (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).INTERFACE;
        case (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).UNION;
        case (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).ENUM;
        case (0, _kindsMjs.Kind).ENUM_VALUE_DEFINITION:
            return (0, _directiveLocationMjs.DirectiveLocation).ENUM_VALUE;
        case (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, _directiveLocationMjs.DirectiveLocation).INPUT_OBJECT;
        case (0, _kindsMjs.Kind).INPUT_VALUE_DEFINITION:
            var parentNode = ancestors[ancestors.length - 3];
            return parentNode.kind === (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, _directiveLocationMjs.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, _directiveLocationMjs.DirectiveLocation).ARGUMENT_DEFINITION;
    }
}
function getDirectiveLocationForOperation(operation) {
    switch(operation){
        case 'query':
            return (0, _directiveLocationMjs.DirectiveLocation).QUERY;
        case 'mutation':
            return (0, _directiveLocationMjs.DirectiveLocation).MUTATION;
        case 'subscription':
            return (0, _directiveLocationMjs.DirectiveLocation).SUBSCRIPTION;
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected operation: ' + (0, _inspectMjsDefault.default)(operation));
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../jsutils/invariant.mjs":"agtax","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/directiveLocation.mjs":"tgdMp","../../type/directives.mjs":"k3NFN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lVij4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all non-repeatable directives at
 * a given location are uniquely named.
 */ parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", function() {
    return UniqueDirectivesPerLocationRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _predicatesMjs = require("../../language/predicates.mjs");
var _directivesMjs = require("../../type/directives.mjs");
function UniqueDirectivesPerLocationRule(context) {
    var uniqueDirectiveMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, _directivesMjs.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
    var schemaDirectives = Object.create(null);
    var typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter: function enter(node) {
            if (node.directives == null) return;
            var seenDirectives;
            if (node.kind === (0, _kindsMjs.Kind).SCHEMA_DEFINITION || node.kind === (0, _kindsMjs.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, _predicatesMjs.isTypeDefinitionNode)(node) || (0, _predicatesMjs.isTypeExtensionNode)(node)) {
                var typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                var _directive = _node$directives2[_i6];
                var directiveName = _directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                        seenDirectives[directiveName],
                        _directive
                    ]));
                    else seenDirectives[directiveName] = _directive;
                }
            }
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/predicates.mjs":"iXXFP","../../type/directives.mjs":"k3NFN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"454uw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 */ parcelHelpers.export(exports, "KnownArgumentNamesRule", function() {
    return KnownArgumentNamesRule;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "KnownArgumentNamesOnDirectivesRule", function() {
    return KnownArgumentNamesOnDirectivesRule;
});
var _didYouMeanMjs = require("../../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _suggestionListMjs = require("../../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _directivesMjs = require("../../type/directives.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function KnownArgumentNamesRule(context) {
    return _objectSpread(_objectSpread({}, KnownArgumentNamesOnDirectivesRule(context)), {}, {
        Argument: function Argument(argNode) {
            var argDef = context.getArgument();
            var fieldDef = context.getFieldDef();
            var parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                var argName = argNode.name.value;
                var knownArgsNames = fieldDef.args.map(function(arg) {
                    return arg.name;
                });
                var suggestions = (0, _suggestionListMjsDefault.default)(argName, knownArgsNames);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, _didYouMeanMjsDefault.default)(suggestions), argNode));
            }
        }
    });
}
function KnownArgumentNamesOnDirectivesRule(context) {
    var directiveArgs = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, _directivesMjs.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        directiveArgs[directive.name] = directive.args.map(function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: function Directive(directiveNode) {
            var directiveName = directiveNode.name.value;
            var knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                var argNode = _directiveNode$argume2[_i6];
                var argName = argNode.name.value;
                if (knownArgs.indexOf(argName) === -1) {
                    var suggestions = (0, _suggestionListMjsDefault.default)(argName, knownArgs);
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, _didYouMeanMjsDefault.default)(suggestions), argNode));
                }
            }
            return false;
        }
    };
}

},{"../../jsutils/didYouMean.mjs":"gdkI5","../../jsutils/suggestionList.mjs":"634S6","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../type/directives.mjs":"k3NFN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eJPzp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 */ parcelHelpers.export(exports, "UniqueArgumentNamesRule", function() {
    return UniqueArgumentNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueArgumentNamesRule(context) {
    var knownArgNames = Object.create(null);
    return {
        Field: function Field() {
            knownArgNames = Object.create(null);
        },
        Directive: function Directive() {
            knownArgNames = Object.create(null);
        },
        Argument: function Argument(node) {
            var argName = node.name.value;
            if (knownArgNames[argName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                knownArgNames[argName],
                node.name
            ]));
            else knownArgNames[argName] = node.name;
            return false;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9hkVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 */ parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", function() {
    return ValuesOfCorrectTypeRule;
});
var _objectValuesMjs = require("../../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _keyMapMjs = require("../../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _didYouMeanMjs = require("../../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _suggestionListMjs = require("../../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _printerMjs = require("../../language/printer.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function ValuesOfCorrectTypeRule(context) {
    return {
        ListValue: function ListValue(node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            var type = (0, _definitionMjs.getNullableType)(context.getParentInputType());
            if (!(0, _definitionMjs.isListType)(type)) {
                isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue: function ObjectValue(node) {
            var type = (0, _definitionMjs.getNamedType)(context.getInputType());
            if (!(0, _definitionMjs.isInputObjectType)(type)) {
                isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            var fieldNodeMap = (0, _keyMapMjsDefault.default)(node.fields, function(field) {
                return field.name.value;
            });
            for(var _i2 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                var fieldDef = _objectValues2[_i2];
                var fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, _definitionMjs.isRequiredInputField)(fieldDef)) {
                    var typeStr = (0, _inspectMjsDefault.default)(fieldDef.type);
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var parentType = (0, _definitionMjs.getNamedType)(context.getParentInputType());
            var fieldType = context.getInputType();
            if (!fieldType && (0, _definitionMjs.isInputObjectType)(parentType)) {
                var suggestions = (0, _suggestionListMjsDefault.default)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, _didYouMeanMjsDefault.default)(suggestions), node));
            }
        },
        NullValue: function NullValue(node) {
            var type = context.getInputType();
            if ((0, _definitionMjs.isNonNullType)(type)) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Expected value of type \"".concat((0, _inspectMjsDefault.default)(type), "\", found ").concat((0, _printerMjs.print)(node), "."), node));
        },
        EnumValue: function EnumValue(node) {
            return isValidValueNode(context, node);
        },
        IntValue: function IntValue(node) {
            return isValidValueNode(context, node);
        },
        FloatValue: function FloatValue(node) {
            return isValidValueNode(context, node);
        },
        StringValue: function StringValue(node) {
            return isValidValueNode(context, node);
        },
        BooleanValue: function BooleanValue(node) {
            return isValidValueNode(context, node);
        }
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    var locationType = context.getInputType();
    if (!locationType) return;
    var type = (0, _definitionMjs.getNamedType)(locationType);
    if (!(0, _definitionMjs.isLeafType)(type)) {
        var typeStr = (0, _inspectMjsDefault.default)(locationType);
        context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, _printerMjs.print)(node), "."), node));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        var parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            var _typeStr = (0, _inspectMjsDefault.default)(locationType);
            context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, _printerMjs.print)(node), "."), node));
        }
    } catch (error) {
        var _typeStr2 = (0, _inspectMjsDefault.default)(locationType);
        if (error instanceof (0, _graphQLErrorMjs.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, _printerMjs.print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
}

},{"../../polyfills/objectValues.mjs":"9Pvqa","../../jsutils/keyMap.mjs":"aZdAt","../../jsutils/inspect.mjs":"4vyEo","../../jsutils/didYouMean.mjs":"gdkI5","../../jsutils/suggestionList.mjs":"634S6","../../error/GraphQLError.mjs":"e4y57","../../language/printer.mjs":"dA3NC","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gmuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */ parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", function() {
    return ProvidedRequiredArgumentsRule;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "ProvidedRequiredArgumentsOnDirectivesRule", function() {
    return ProvidedRequiredArgumentsOnDirectivesRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _keyMapMjs = require("../../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _printerMjs = require("../../language/printer.mjs");
var _directivesMjs = require("../../type/directives.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ProvidedRequiredArgumentsRule(context) {
    return _objectSpread(_objectSpread({}, ProvidedRequiredArgumentsOnDirectivesRule(context)), {}, {
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(fieldNode) {
                var _fieldNode$arguments;
                var fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                 // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                var argNodeMap = (0, _keyMapMjsDefault.default)(argNodes, function(arg) {
                    return arg.name.value;
                });
                for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                    var argDef = _fieldDef$args2[_i2];
                    var argNode = argNodeMap[argDef.name];
                    if (!argNode && (0, _definitionMjs.isRequiredArgument)(argDef)) {
                        var argTypeStr = (0, _inspectMjsDefault.default)(argDef.type);
                        context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                    }
                }
            }
        }
    });
}
function ProvidedRequiredArgumentsOnDirectivesRule(context) {
    var requiredArgsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, _directivesMjs.specifiedDirectives);
    for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
        var directive = definedDirectives[_i4];
        requiredArgsMap[directive.name] = (0, _keyMapMjsDefault.default)(directive.args.filter((0, _definitionMjs.isRequiredArgument)), function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
        var def = astDefinitions[_i6];
        if (def.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            requiredArgsMap[def.name.value] = (0, _keyMapMjsDefault.default)(argNodes.filter(isRequiredArgumentNode), function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(directiveNode) {
                var directiveName = directiveNode.name.value;
                var requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                    var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    var argNodeMap = (0, _keyMapMjsDefault.default)(_argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                        var argName = _Object$keys2[_i8];
                        if (!argNodeMap[argName]) {
                            var argType = requiredArgs[argName].type;
                            var argTypeStr = (0, _definitionMjs.isType)(argType) ? (0, _inspectMjsDefault.default)(argType) : (0, _printerMjs.print)(argType);
                            context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                        }
                    }
                }
            }
        }
    };
}
function isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, _kindsMjs.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../jsutils/keyMap.mjs":"aZdAt","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/printer.mjs":"dA3NC","../../type/directives.mjs":"k3NFN","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aACfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Variables passed to field arguments conform to type
 */ parcelHelpers.export(exports, "VariablesInAllowedPositionRule", function() {
    return VariablesInAllowedPositionRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _typeFromASTMjs = require("../../utilities/typeFromAST.mjs");
var _typeComparatorsMjs = require("../../utilities/typeComparators.mjs");
function VariablesInAllowedPositionRule(context) {
    var varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                varDefMap = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var type = _ref2.type;
                    var defaultValue = _ref2.defaultValue;
                    var varName = node.name.value;
                    var varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        var schema = context.getSchema();
                        var varType = (0, _typeFromASTMjs.typeFromAST)(schema, varDef.type);
                        if (varType && !allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            var varTypeStr = (0, _inspectMjsDefault.default)(varType);
                            var typeStr = (0, _inspectMjsDefault.default)(type);
                            context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                varDef,
                                node
                            ]));
                        }
                    }
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, _definitionMjs.isNonNullType)(locationType) && !(0, _definitionMjs.isNonNullType)(varType)) {
        var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, _kindsMjs.Kind).NULL;
        var hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        var nullableLocationType = locationType.ofType;
        return (0, _typeComparatorsMjs.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, _typeComparatorsMjs.isTypeSubTypeOf)(schema, varType, locationType);
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../type/definition.mjs":"hN98Z","../../utilities/typeFromAST.mjs":"2b0nl","../../utilities/typeComparators.mjs":"fc5HZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"E5YPN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 */ parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", function() {
    return OverlappingFieldsCanBeMergedRule;
});
var _findMjs = require("../../polyfills/find.mjs");
var _findMjsDefault = parcelHelpers.interopDefault(_findMjs);
var _objectEntriesMjs = require("../../polyfills/objectEntries.mjs");
var _objectEntriesMjsDefault = parcelHelpers.interopDefault(_objectEntriesMjs);
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _printerMjs = require("../../language/printer.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _typeFromASTMjs = require("../../utilities/typeFromAST.mjs");
function reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(function(_ref) {
        var responseName = _ref[0], subReason = _ref[1];
        return "subfields \"".concat(responseName, "\" conflict because ") + reasonMessage(subReason);
    }).join(' and ');
    return reason;
}
function OverlappingFieldsCanBeMergedRule(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    var comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    var cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet: function SelectionSet(selectionSet) {
            var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                var _ref3 = conflicts[_i2];
                var _ref2$ = _ref3[0];
                var responseName = _ref2$[0];
                var reason = _ref2$[1];
                var fields1 = _ref3[1];
                var fields2 = _ref3[2];
                var reasonMsg = reasonMessage(reason);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    var conflicts = [];
    var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(var i = 0; i < fragmentNames.length; i++){
        collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(var j = i + 1; j < fragmentNames.length; j++)collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    var fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for(var i = 0; i < fragmentNames2.length; i++)collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    var fragment1 = context.getFragment(fragmentName1);
    var fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
    var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for(var j = 0; j < fragmentNames2.length; j++)collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for(var i = 0; i < fragmentNames1.length; i++)collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    var conflicts = [];
    var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
    var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
    collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for(var _i5 = 0, _objectEntries2 = (0, _objectEntriesMjsDefault.default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
        var _ref5 = _objectEntries2[_i5];
        var responseName = _ref5[0];
        var fields = _ref5[1];
        // This compares every field in the list to every other field in this list
        // (except to itself). If the list only has one item, nothing needs to
        // be compared.
        if (fields.length > 1) {
            for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
        var responseName = _Object$keys2[_i7];
        var fields2 = fieldMap2[responseName];
        if (fields2) {
            var fields1 = fieldMap1[responseName];
            for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
    var parentType2 = field2[0], node2 = field2[1], def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, _definitionMjs.isObjectType)(parentType1) && (0, _definitionMjs.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        var _node1$arguments, _node2$arguments;
        // Two aliases must refer to the same field.
        var name1 = node1.name.value;
        var name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.
        if (!sameArguments(args1, args2)) return [
            [
                responseName,
                'they have differing arguments'
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && doTypesConflict(type1, type2)) return [
        [
            responseName,
            "they return conflicting types \"".concat((0, _inspectMjsDefault.default)(type1), "\" and \"").concat((0, _inspectMjsDefault.default)(type2), "\"")
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    var selectionSet1 = node1.selectionSet;
    var selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, _definitionMjs.getNamedType)(type1), selectionSet1, (0, _definitionMjs.getNamedType)(type2), selectionSet2);
        return subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function sameArguments(arguments1, arguments2) {
    if (arguments1.length !== arguments2.length) return false;
    return arguments1.every(function(argument1) {
        var argument2 = (0, _findMjsDefault.default)(arguments2, function(argument) {
            return argument.name.value === argument1.name.value;
        });
        if (!argument2) return false;
        return sameValue(argument1.value, argument2.value);
    });
}
function sameValue(value1, value2) {
    return (0, _printerMjs.print)(value1) === (0, _printerMjs.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function doTypesConflict(type1, type2) {
    if ((0, _definitionMjs.isListType)(type1)) return (0, _definitionMjs.isListType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, _definitionMjs.isListType)(type2)) return true;
    if ((0, _definitionMjs.isNonNullType)(type1)) return (0, _definitionMjs.isNonNullType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, _definitionMjs.isNonNullType)(type2)) return true;
    if ((0, _definitionMjs.isLeafType)(type1) || (0, _definitionMjs.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    var cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (!cached) {
        var nodeAndDefs = Object.create(null);
        var fragmentNames = Object.create(null);
        _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
        cached = [
            nodeAndDefs,
            Object.keys(fragmentNames)
        ];
        cachedFieldsAndFragmentNames.set(selectionSet, cached);
    }
    return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    var fragmentType = (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
        var selection = _selectionSet$selecti2[_i9];
        switch(selection.kind){
            case (0, _kindsMjs.Kind).FIELD:
                var fieldName = selection.name.value;
                var fieldDef = void 0;
                if ((0, _definitionMjs.isObjectType)(parentType) || (0, _definitionMjs.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                var responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            case (0, _kindsMjs.Kind).FRAGMENT_SPREAD:
                fragmentNames[selection.name.value] = true;
                break;
            case (0, _kindsMjs.Kind).INLINE_FRAGMENT:
                var typeCondition = selection.typeCondition;
                var inlineFragmentType = typeCondition ? (0, _typeFromASTMjs.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
        }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(function(_ref6) {
                var reason = _ref6[0];
                return reason;
            })
        ],
        conflicts.reduce(function(allFields, _ref7) {
            var fields1 = _ref7[1];
            return allFields.concat(fields1);
        }, [
            node1
        ]),
        conflicts.reduce(function(allFields, _ref8) {
            var fields2 = _ref8[2];
            return allFields.concat(fields2);
        }, [
            node2
        ])
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */ var PairSet = /*#__PURE__*/ function() {
    function PairSet() {
        this._data = Object.create(null);
    }
    var _proto = PairSet.prototype;
    _proto.has = function has(a, b, areMutuallyExclusive) {
        var first = this._data[a];
        var result = first && first[b];
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true,
        // hence if we want to know if this PairSet "has" these two with no
        // exclusivity, we have to ensure it was added as such.
        if (areMutuallyExclusive === false) return result === false;
        return true;
    };
    _proto.add = function add(a, b, areMutuallyExclusive) {
        this._pairSetAdd(a, b, areMutuallyExclusive);
        this._pairSetAdd(b, a, areMutuallyExclusive);
    };
    _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
        var map = this._data[a];
        if (!map) {
            map = Object.create(null);
            this._data[a] = map;
        }
        map[b] = areMutuallyExclusive;
    };
    return PairSet;
}();

},{"../../polyfills/find.mjs":"caL9z","../../polyfills/objectEntries.mjs":"ccmaZ","../../jsutils/inspect.mjs":"4vyEo","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/printer.mjs":"dA3NC","../../type/definition.mjs":"hN98Z","../../utilities/typeFromAST.mjs":"2b0nl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cLbRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 */ parcelHelpers.export(exports, "UniqueInputFieldNamesRule", function() {
    return UniqueInputFieldNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueInputFieldNamesRule(context) {
    var knownNameStack = [];
    var knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter: function enter() {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave: function leave() {
                knownNames = knownNameStack.pop();
            }
        },
        ObjectField: function ObjectField(node) {
            var fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                knownNames[fieldName],
                node.name
            ]));
            else knownNames[fieldName] = node.name;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"adXGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */ parcelHelpers.export(exports, "LoneSchemaDefinitionRule", function() {
    return LoneSchemaDefinitionRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function LoneSchemaDefinitionRule(context) {
    var _ref, _ref2, _oldSchema$astNode;
    var oldSchema = context.getSchema();
    var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    var schemaDefinitionsCount = 0;
    return {
        SchemaDefinition: function SchemaDefinition(node) {
            if (alreadyDefined) {
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)('Cannot define a new schema within a schema extension.', node));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)('Must provide only one schema definition.', node));
            ++schemaDefinitionsCount;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fYcAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique operation types
 *
 * A GraphQL document is only valid if it has only one type per operation.
 */ parcelHelpers.export(exports, "UniqueOperationTypesRule", function() {
    return UniqueOperationTypesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueOperationTypesRule(context) {
    var schema = context.getSchema();
    var definedOperationTypes = Object.create(null);
    var existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
            var operationType = operationTypesNodes[_i2];
            var operation = operationType.operation;
            var alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
            else if (alreadyDefinedOperationType) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                alreadyDefinedOperationType,
                operationType
            ]));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"21Bmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique type names
 *
 * A GraphQL document is only valid if all defined types have unique names.
 */ parcelHelpers.export(exports, "UniqueTypeNamesRule", function() {
    return UniqueTypeNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueTypeNamesRule(context) {
    var knownTypeNames = Object.create(null);
    var schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        var typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
            knownTypeNames[typeName],
            node.name
        ]));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ouc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique enum value names
 *
 * A GraphQL enum type is only valid if all its values are uniquely named.
 */ parcelHelpers.export(exports, "UniqueEnumValueNamesRule", function() {
    return UniqueEnumValueNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function UniqueEnumValueNamesRule(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        var typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        var valueNames = knownValueNames[typeName];
        for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
            var valueDef = valueNodes[_i2];
            var valueName = valueDef.name.value;
            var existingType = existingTypeMap[typeName];
            if ((0, _definitionMjs.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
            else if (valueNames[valueName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                valueNames[valueName],
                valueDef.name
            ]));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

},{"../../error/GraphQLError.mjs":"e4y57","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fvec4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique field definition names
 *
 * A GraphQL complex type is only valid if all its fields are uniquely named.
 */ parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", function() {
    return UniqueFieldDefinitionNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _definitionMjs = require("../../type/definition.mjs");
function UniqueFieldDefinitionNamesRule(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        var typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        var fieldNames = knownFieldNames[typeName];
        for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
            var fieldDef = fieldNodes[_i2];
            var fieldName = fieldDef.name.value;
            if (hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
            else if (fieldNames[fieldName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                fieldNames[fieldName],
                fieldDef.name
            ]));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function hasField(type, fieldName) {
    if ((0, _definitionMjs.isObjectType)(type) || (0, _definitionMjs.isInterfaceType)(type) || (0, _definitionMjs.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

},{"../../error/GraphQLError.mjs":"e4y57","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k26ww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unique directive names
 *
 * A GraphQL document is only valid if all defined directives have unique names.
 */ parcelHelpers.export(exports, "UniqueDirectiveNamesRule", function() {
    return UniqueDirectiveNamesRule;
});
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
function UniqueDirectiveNamesRule(context) {
    var knownDirectiveNames = Object.create(null);
    var schema = context.getSchema();
    return {
        DirectiveDefinition: function DirectiveDefinition(node) {
            var directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                knownDirectiveNames[directiveName],
                node.name
            ]));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

},{"../../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9hVFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Possible type extension
 *
 * A type extension is only valid if the type is defined and has the same kind.
 */ parcelHelpers.export(exports, "PossibleTypeExtensionsRule", function() {
    return PossibleTypeExtensionsRule;
});
var _inspectMjs = require("../../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _didYouMeanMjs = require("../../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _suggestionListMjs = require("../../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _graphQLErrorMjs = require("../../error/GraphQLError.mjs");
var _kindsMjs = require("../../language/kinds.mjs");
var _predicatesMjs = require("../../language/predicates.mjs");
var _definitionMjs = require("../../type/definition.mjs");
var _defKindToExtKind;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function PossibleTypeExtensionsRule(context) {
    var schema = context.getSchema();
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, _predicatesMjs.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    }
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        var typeName = node.name.value;
        var defNode = definedTypes[typeName];
        var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        var expectedKind;
        if (defNode) expectedKind = defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                var kindStr = extensionKindToTypeName(node.kind);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                    defNode,
                    node
                ] : node));
            }
        } else {
            var allTypeNames = Object.keys(definedTypes);
            if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
            var suggestedTypes = (0, _suggestionListMjsDefault.default)(typeName, allTypeNames);
            context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, _didYouMeanMjsDefault.default)(suggestedTypes), node.name));
        }
    }
}
var defKindToExtKind = (_defKindToExtKind = {}, _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION, (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION, (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION, (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION, (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION, (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION), _defKindToExtKind);
function typeToExtKind(type) {
    if ((0, _definitionMjs.isScalarType)(type)) return (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, _definitionMjs.isObjectType)(type)) return (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, _definitionMjs.isInterfaceType)(type)) return (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, _definitionMjs.isUnionType)(type)) return (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION;
    if ((0, _definitionMjs.isEnumType)(type)) return (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION;
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isInputObjectType)(type)) return (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION;
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected type: ' + (0, _inspectMjsDefault.default)(type));
}
function extensionKindToTypeName(kind) {
    switch(kind){
        case (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION:
            return 'scalar';
        case (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION:
            return 'object';
        case (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION:
            return 'interface';
        case (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION:
            return 'union';
        case (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION:
            return 'enum';
        case (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return 'input object';
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected kind: ' + (0, _inspectMjsDefault.default)(kind));
}

},{"../../jsutils/inspect.mjs":"4vyEo","../../jsutils/invariant.mjs":"agtax","../../jsutils/didYouMean.mjs":"gdkI5","../../jsutils/suggestionList.mjs":"634S6","../../error/GraphQLError.mjs":"e4y57","../../language/kinds.mjs":"ffJlp","../../language/predicates.mjs":"iXXFP","../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b8dcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASTValidationContext", function() {
    return ASTValidationContext;
});
parcelHelpers.export(exports, "SDLValidationContext", function() {
    return SDLValidationContext;
});
parcelHelpers.export(exports, "ValidationContext", function() {
    return ValidationContext;
});
var _kindsMjs = require("../language/kinds.mjs");
var _visitorMjs = require("../language/visitor.mjs");
var _typeInfoMjs = require("../utilities/TypeInfo.mjs");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var ASTValidationContext = /*#__PURE__*/ function() {
    function ASTValidationContext(ast, onError) {
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    var _proto = ASTValidationContext.prototype;
    _proto.reportError = function reportError(error) {
        this._onError(error);
    };
    _proto.getDocument = function getDocument() {
        return this._ast;
    };
    _proto.getFragment = function getFragment(name) {
        var fragments = this._fragments;
        if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
            if (statement.kind === (0, _kindsMjs.Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
            return frags;
        }, Object.create(null));
        return fragments[name];
    };
    _proto.getFragmentSpreads = function getFragmentSpreads(node) {
        var spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            var setsToVisit = [
                node
            ];
            while(setsToVisit.length !== 0){
                var set = setsToVisit.pop();
                for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                    var selection = _set$selections2[_i2];
                    if (selection.kind === (0, _kindsMjs.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                    else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                }
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    };
    _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
        var fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            var collectedNames = Object.create(null);
            var nodesToVisit = [
                operation.selectionSet
            ];
            while(nodesToVisit.length !== 0){
                var node = nodesToVisit.pop();
                for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                    var spread = _this$getFragmentSpre2[_i4];
                    var fragName = spread.name.value;
                    if (collectedNames[fragName] !== true) {
                        collectedNames[fragName] = true;
                        var fragment = this.getFragment(fragName);
                        if (fragment) {
                            fragments.push(fragment);
                            nodesToVisit.push(fragment.selectionSet);
                        }
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    };
    return ASTValidationContext;
}();
var SDLValidationContext = /*#__PURE__*/ function(_ASTValidationContext) {
    _inheritsLoose(SDLValidationContext, _ASTValidationContext);
    function SDLValidationContext(ast, schema, onError) {
        var _this;
        _this = _ASTValidationContext.call(this, ast, onError) || this;
        _this._schema = schema;
        return _this;
    }
    var _proto2 = SDLValidationContext.prototype;
    _proto2.getSchema = function getSchema() {
        return this._schema;
    };
    return SDLValidationContext;
}(ASTValidationContext);
var ValidationContext = /*#__PURE__*/ function(_ASTValidationContext2) {
    _inheritsLoose(ValidationContext, _ASTValidationContext2);
    function ValidationContext(schema, ast, typeInfo, onError) {
        var _this2;
        _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
        _this2._schema = schema;
        _this2._typeInfo = typeInfo;
        _this2._variableUsages = new Map();
        _this2._recursiveVariableUsages = new Map();
        return _this2;
    }
    var _proto3 = ValidationContext.prototype;
    _proto3.getSchema = function getSchema() {
        return this._schema;
    };
    _proto3.getVariableUsages = function getVariableUsages(node) {
        var usages = this._variableUsages.get(node);
        if (!usages) {
            var newUsages = [];
            var typeInfo = new (0, _typeInfoMjs.TypeInfo)(this._schema);
            (0, _visitorMjs.visit)(node, (0, _typeInfoMjs.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: function VariableDefinition() {
                    return false;
                },
                Variable: function Variable(variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    };
    _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
        var usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                var frag = _this$getRecursivelyR2[_i6];
                usages = usages.concat(this.getVariableUsages(frag));
            }
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    };
    _proto3.getType = function getType() {
        return this._typeInfo.getType();
    };
    _proto3.getParentType = function getParentType() {
        return this._typeInfo.getParentType();
    };
    _proto3.getInputType = function getInputType() {
        return this._typeInfo.getInputType();
    };
    _proto3.getParentInputType = function getParentInputType() {
        return this._typeInfo.getParentInputType();
    };
    _proto3.getFieldDef = function getFieldDef() {
        return this._typeInfo.getFieldDef();
    };
    _proto3.getDirective = function getDirective() {
        return this._typeInfo.getDirective();
    };
    _proto3.getArgument = function getArgument() {
        return this._typeInfo.getArgument();
    };
    _proto3.getEnumValue = function getEnumValue() {
        return this._typeInfo.getEnumValue();
    };
    return ValidationContext;
}(ASTValidationContext);

},{"../language/kinds.mjs":"ffJlp","../language/visitor.mjs":"aHQOA","../utilities/TypeInfo.mjs":"ju2gk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e0yfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g "a"
 * 2) fragment "spreads" e.g. "...c"
 * 3) inline fragment "spreads" e.g. "...on Type { a }"
 */ /**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */ parcelHelpers.export(exports, "execute", function() {
    return execute;
});
/**
 * Also implements the "Evaluating requests" section of the GraphQL specification.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */ parcelHelpers.export(exports, "executeSync", function() {
    return executeSync;
});
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 *
 * @internal
 */ parcelHelpers.export(exports, "assertValidExecutionArguments", function() {
    return assertValidExecutionArguments;
});
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 *
 * @internal
 */ parcelHelpers.export(exports, "buildExecutionContext", function() {
    return buildExecutionContext;
});
/**
 * Given a selectionSet, adds all of the fields in that selection to
 * the passed in map of fields, and returns it at the end.
 *
 * CollectFields requires the "runtime type" of an object. For a field which
 * returns an Interface or Union type, the "runtime type" will be the actual
 * Object type returned by that field.
 *
 * @internal
 */ parcelHelpers.export(exports, "collectFields", function() {
    return collectFields;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "buildResolveInfo", function() {
    return buildResolveInfo;
});
parcelHelpers.export(exports, "defaultTypeResolver", function() {
    return defaultTypeResolver;
});
parcelHelpers.export(exports, "defaultFieldResolver", function() {
    return defaultFieldResolver;
});
/**
 * This method looks up the field on the given type definition.
 * It has special casing for the three introspection fields,
 * __schema, __type and __typename. __typename is special because
 * it can always be queried as a field, even in situations where no
 * other fields are allowed, like on a Union. __schema and __type
 * could get automatically added to the query type, but that would
 * require mutating type definitions, which would cause issues.
 *
 * @internal
 */ parcelHelpers.export(exports, "getFieldDef", function() {
    return getFieldDef;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _memoize3Mjs = require("../jsutils/memoize3.mjs");
var _memoize3MjsDefault = parcelHelpers.interopDefault(_memoize3Mjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _isPromiseMjs = require("../jsutils/isPromise.mjs");
var _isPromiseMjsDefault = parcelHelpers.interopDefault(_isPromiseMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _safeArrayFromMjs = require("../jsutils/safeArrayFrom.mjs");
var _safeArrayFromMjsDefault = parcelHelpers.interopDefault(_safeArrayFromMjs);
var _promiseReduceMjs = require("../jsutils/promiseReduce.mjs");
var _promiseReduceMjsDefault = parcelHelpers.interopDefault(_promiseReduceMjs);
var _promiseForObjectMjs = require("../jsutils/promiseForObject.mjs");
var _promiseForObjectMjsDefault = parcelHelpers.interopDefault(_promiseForObjectMjs);
var _pathMjs = require("../jsutils/Path.mjs");
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _locatedErrorMjs = require("../error/locatedError.mjs");
var _kindsMjs = require("../language/kinds.mjs");
var _validateMjs = require("../type/validate.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _typeFromASTMjs = require("../utilities/typeFromAST.mjs");
var _getOperationRootTypeMjs = require("../utilities/getOperationRootType.mjs");
var _valuesMjs = require("./values.mjs");
function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? executeImpl(argsOrSchema) : executeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}
function executeSync(args) {
    var result = executeImpl(args); // Assert that the execution was synchronous.
    if ((0, _isPromiseMjsDefault.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function executeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.
    assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
    // a "Response" with only errors is returned.
    var exeContext = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) return {
        errors: exeContext
    };
     // Return a Promise that will eventually resolve to the data described by
    // The "Response" section of the GraphQL specification.
    //
    // If errors are encountered while executing a GraphQL field, only that
    // field and its descendants will be omitted, and sibling fields will still
    // be executed. An execution which encounters errors will still result in a
    // resolved Promise.
    var data = executeOperation(exeContext, exeContext.operation, rootValue);
    return buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */ function buildResponse(exeContext, data) {
    if ((0, _isPromiseMjsDefault.default)(data)) return data.then(function(resolved) {
        return buildResponse(exeContext, resolved);
    });
    return exeContext.errors.length === 0 ? {
        data: data
    } : {
        errors: exeContext.errors,
        data: data
    };
}
function assertValidExecutionArguments(schema, document, rawVariableValues) {
    document || (0, _devAssertMjsDefault.default)(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.
    (0, _validateMjs.assertValidSchema)(schema); // Variables, if provided, must be an object.
    rawVariableValues == null || (0, _isObjectLikeMjsDefault.default)(rawVariableValues) || (0, _devAssertMjsDefault.default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
    var _definition$name, _operation$variableDe;
    var operation;
    var fragments = Object.create(null);
    for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
        var definition = _document$definitions2[_i2];
        switch(definition.kind){
            case (0, _kindsMjs.Kind).OPERATION_DEFINITION:
                if (operationName == null) {
                    if (operation !== undefined) return [
                        new (0, _graphQLErrorMjs.GraphQLError)('Must provide operation name if query contains multiple operations.')
                    ];
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                break;
            case (0, _kindsMjs.Kind).FRAGMENT_DEFINITION:
                fragments[definition.name.value] = definition;
                break;
        }
    }
    if (!operation) {
        if (operationName != null) return [
            new (0, _graphQLErrorMjs.GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
        ];
        return [
            new (0, _graphQLErrorMjs.GraphQLError)('Must provide an operation.')
        ];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
    var coercedVariableValues = (0, _valuesMjs.getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
        maxErrors: 50
    });
    if (coercedVariableValues.errors) return coercedVariableValues.errors;
    return {
        schema: schema,
        fragments: fragments,
        rootValue: rootValue,
        contextValue: contextValue,
        operation: operation,
        variableValues: coercedVariableValues.coerced,
        fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : defaultFieldResolver,
        typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : defaultTypeResolver,
        errors: []
    };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */ function executeOperation(exeContext, operation, rootValue) {
    var type = (0, _getOperationRootTypeMjs.getOperationRootType)(exeContext.schema, operation);
    var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
    // at which point we still log the error and null the parent field, which
    // in this case is the entire response.
    try {
        var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);
        if ((0, _isPromiseMjsDefault.default)(result)) return result.then(undefined, function(error) {
            exeContext.errors.push(error);
            return Promise.resolve(null);
        });
        return result;
    } catch (error) {
        exeContext.errors.push(error);
        return null;
    }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */ function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
    return (0, _promiseReduceMjsDefault.default)(Object.keys(fields), function(results, responseName) {
        var fieldNodes = fields[responseName];
        var fieldPath = (0, _pathMjs.addPath)(path, responseName, parentType.name);
        var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result === undefined) return results;
        if ((0, _isPromiseMjsDefault.default)(result)) return result.then(function(resolvedResult) {
            results[responseName] = resolvedResult;
            return results;
        });
        results[responseName] = result;
        return results;
    }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */ function executeFields(exeContext, parentType, sourceValue, path, fields) {
    var results = Object.create(null);
    var containsPromise = false;
    for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
        var responseName = _Object$keys2[_i4];
        var fieldNodes = fields[responseName];
        var fieldPath = (0, _pathMjs.addPath)(path, responseName, parentType.name);
        var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result !== undefined) {
            results[responseName] = result;
            if ((0, _isPromiseMjsDefault.default)(result)) containsPromise = true;
        }
    } // If there are no promises, we can just return the object
    if (!containsPromise) return results;
     // Otherwise, results is a map from field name to the result of resolving that
    // field, which is possibly a promise. Return a promise that will return this
    // same map, but with any promises replaced with the values they resolved to.
    return (0, _promiseForObjectMjsDefault.default)(results);
}
function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
        var selection = _selectionSet$selecti2[_i6];
        switch(selection.kind){
            case (0, _kindsMjs.Kind).FIELD:
                if (!shouldIncludeNode(exeContext, selection)) continue;
                var name = getFieldEntryKey(selection);
                if (!fields[name]) fields[name] = [];
                fields[name].push(selection);
                break;
            case (0, _kindsMjs.Kind).INLINE_FRAGMENT:
                if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                break;
            case (0, _kindsMjs.Kind).FRAGMENT_SPREAD:
                var fragName = selection.name.value;
                if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) continue;
                visitedFragmentNames[fragName] = true;
                var fragment = exeContext.fragments[fragName];
                if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
        }
    }
    return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */ function shouldIncludeNode(exeContext, node) {
    var skip = (0, _valuesMjs.getDirectiveValues)((0, _directivesMjs.GraphQLSkipDirective), node, exeContext.variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    var include = (0, _valuesMjs.getDirectiveValues)((0, _directivesMjs.GraphQLIncludeDirective), node, exeContext.variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function doesFragmentConditionMatch(exeContext, fragment, type) {
    var typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    var conditionalType = (0, _typeFromASTMjs.typeFromAST)(exeContext.schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, _definitionMjs.isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */ function resolveField(exeContext, parentType, source, fieldNodes, path) {
    var _fieldDef$resolve;
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);
    if (!fieldDef) return;
    var returnType = fieldDef.type;
    var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
    var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).
    try {
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        // TODO: find a way to memoize, in case this field is within a List type.
        var args = (0, _valuesMjs.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var _contextValue = exeContext.contextValue;
        var result = resolveFn(source, args, _contextValue, info);
        var completed;
        if ((0, _isPromiseMjsDefault.default)(result)) completed = result.then(function(resolved) {
            return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
        });
        else completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, _isPromiseMjsDefault.default)(completed)) // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.
        return completed.then(undefined, function(rawError) {
            var error = (0, _locatedErrorMjs.locatedError)(rawError, fieldNodes, (0, _pathMjs.pathToArray)(path));
            return handleFieldError(error, returnType, exeContext);
        });
        return completed;
    } catch (rawError) {
        var error = (0, _locatedErrorMjs.locatedError)(rawError, fieldNodes, (0, _pathMjs.pathToArray)(path));
        return handleFieldError(error, returnType, exeContext);
    }
}
function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
    // The resolve function's optional fourth argument is a collection of
    // information about the current execution state.
    return {
        fieldName: fieldDef.name,
        fieldNodes: fieldNodes,
        returnType: fieldDef.type,
        parentType: parentType,
        path: path,
        schema: exeContext.schema,
        fragments: exeContext.fragments,
        rootValue: exeContext.rootValue,
        operation: exeContext.operation,
        variableValues: exeContext.variableValues
    };
}
function handleFieldError(error, returnType, exeContext) {
    // If the field type is non-nullable, then it is resolved without any
    // protection from errors, however it still properly locates the error.
    if ((0, _definitionMjs.isNonNullType)(returnType)) throw error;
     // Otherwise, error protection is applied, logging the error and resolving
    // a null value for this field if one is encountered.
    exeContext.errors.push(error);
    return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */ function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If result is an Error, throw a located error.
    if (result instanceof Error) throw result;
     // If field type is NonNull, complete for inner type, and throw field error
    // if result is null.
    if ((0, _definitionMjs.isNonNullType)(returnType)) {
        var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
        if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
        return completed;
    } // If result value is null or undefined then return null.
    if (result == null) return null;
     // If field type is List, complete each item in the list with the inner type
    if ((0, _definitionMjs.isListType)(returnType)) return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
    // returning null if serialization is not possible.
    if ((0, _definitionMjs.isLeafType)(returnType)) return completeLeafValue(returnType, result);
     // If field type is an abstract type, Interface or Union, determine the
    // runtime Object type and complete for that type.
    if ((0, _definitionMjs.isAbstractType)(returnType)) return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is Object, execute and complete all sub-selections.
    // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isObjectType)(returnType)) return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
     // istanbul ignore next (Not reachable. All possible output types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Cannot complete value of unexpected output type: ' + (0, _inspectMjsDefault.default)(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */ function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
    // This is specified as a simple map, however we're optimizing the path
    // where the list contains no Promises by avoiding creating another Promise.
    var itemType = returnType.ofType;
    var containsPromise = false;
    var completedResults = (0, _safeArrayFromMjsDefault.default)(result, function(item, index) {
        // No need to modify the info object containing the path,
        // since from here on it is not ever accessed by resolver functions.
        var itemPath = (0, _pathMjs.addPath)(path, index, undefined);
        try {
            var completedItem;
            if ((0, _isPromiseMjsDefault.default)(item)) completedItem = item.then(function(resolved) {
                return completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
            });
            else completedItem = completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
            if ((0, _isPromiseMjsDefault.default)(completedItem)) {
                containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
                // to take a second callback for the error case.
                return completedItem.then(undefined, function(rawError) {
                    var error = (0, _locatedErrorMjs.locatedError)(rawError, fieldNodes, (0, _pathMjs.pathToArray)(itemPath));
                    return handleFieldError(error, itemType, exeContext);
                });
            }
            return completedItem;
        } catch (rawError) {
            var error = (0, _locatedErrorMjs.locatedError)(rawError, fieldNodes, (0, _pathMjs.pathToArray)(itemPath));
            return handleFieldError(error, itemType, exeContext);
        }
    });
    if (completedResults == null) throw new (0, _graphQLErrorMjs.GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
    return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */ function completeLeafValue(returnType, result) {
    var serializedResult = returnType.serialize(result);
    if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, _inspectMjsDefault.default)(returnType), "\" but ") + "received: ".concat((0, _inspectMjsDefault.default)(result)));
    return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */ function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
    var _returnType$resolveTy;
    var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
    var contextValue = exeContext.contextValue;
    var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
    if ((0, _isPromiseMjsDefault.default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
        return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
    return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
    if (runtimeTypeOrName == null) throw new (0, _graphQLErrorMjs.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
     // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0
    var runtimeTypeName = (0, _definitionMjs.isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
    if (typeof runtimeTypeName !== 'string') throw new (0, _graphQLErrorMjs.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, _inspectMjsDefault.default)(result), ", received \"").concat((0, _inspectMjsDefault.default)(runtimeTypeOrName), "\"."));
    var runtimeType = exeContext.schema.getType(runtimeTypeName);
    if (runtimeType == null) throw new (0, _graphQLErrorMjs.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
    if (!(0, _definitionMjs.isObjectType)(runtimeType)) throw new (0, _graphQLErrorMjs.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
    if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, _graphQLErrorMjs.GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
    return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */ function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If there is an isTypeOf predicate function, call it with the
    // current result. If isTypeOf returns false, then raise an error rather
    // than continuing execution.
    if (returnType.isTypeOf) {
        var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
        if ((0, _isPromiseMjsDefault.default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
            if (!resolvedIsTypeOf) throw invalidReturnTypeError(returnType, result, fieldNodes);
            return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
        });
        if (!isTypeOf) throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
    return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}
function invalidReturnTypeError(returnType, result, fieldNodes) {
    return new (0, _graphQLErrorMjs.GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, _inspectMjsDefault.default)(result), "."), fieldNodes);
}
function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
    // Collect sub-fields to execute to complete this value.
    var subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
    return executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */ var collectSubfields = (0, _memoize3MjsDefault.default)(_collectSubfields);
function _collectSubfields(exeContext, returnType, fieldNodes) {
    var subFieldNodes = Object.create(null);
    var visitedFragmentNames = Object.create(null);
    for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
        var node = fieldNodes[_i8];
        if (node.selectionSet) subFieldNodes = collectFields(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
    return subFieldNodes;
}
var defaultTypeResolver = function defaultTypeResolver(value, contextValue, info, abstractType) {
    // First, look for `__typename`.
    if ((0, _isObjectLikeMjsDefault.default)(value) && typeof value.__typename === 'string') return value.__typename;
     // Otherwise, test each possible type.
    var possibleTypes = info.schema.getPossibleTypes(abstractType);
    var promisedIsTypeOfResults = [];
    for(var i = 0; i < possibleTypes.length; i++){
        var type = possibleTypes[i];
        if (type.isTypeOf) {
            var isTypeOfResult = type.isTypeOf(value, contextValue, info);
            if ((0, _isPromiseMjsDefault.default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
            else if (isTypeOfResult) return type.name;
        }
    }
    if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
        for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
            if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
        }
    });
};
var defaultFieldResolver = function defaultFieldResolver(source, args, contextValue, info) {
    // ensure source is a value for which property access is acceptable.
    if ((0, _isObjectLikeMjsDefault.default)(source) || typeof source === 'function') {
        var property = source[info.fieldName];
        if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
        return property;
    }
};
function getFieldDef(schema, parentType, fieldName) {
    if (fieldName === (0, _introspectionMjs.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, _introspectionMjs.SchemaMetaFieldDef;
    else if (fieldName === (0, _introspectionMjs.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, _introspectionMjs.TypeMetaFieldDef;
    else if (fieldName === (0, _introspectionMjs.TypeNameMetaFieldDef).name) return 0, _introspectionMjs.TypeNameMetaFieldDef;
    return parentType.getFields()[fieldName];
}

},{"../jsutils/inspect.mjs":"4vyEo","../jsutils/memoize3.mjs":"6mgBb","../jsutils/invariant.mjs":"agtax","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/isPromise.mjs":"5tmMu","../jsutils/isObjectLike.mjs":"ji7lb","../jsutils/safeArrayFrom.mjs":"5mRH7","../jsutils/promiseReduce.mjs":"lDCuH","../jsutils/promiseForObject.mjs":"2ipXt","../jsutils/Path.mjs":"9U02K","../error/GraphQLError.mjs":"e4y57","../error/locatedError.mjs":"4qusX","../language/kinds.mjs":"ffJlp","../type/validate.mjs":"70lDP","../type/introspection.mjs":"fg0io","../type/directives.mjs":"k3NFN","../type/definition.mjs":"hN98Z","../utilities/typeFromAST.mjs":"2b0nl","../utilities/getOperationRootType.mjs":"cFOlo","./values.mjs":"cjyw1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6mgBb":[function(require,module,exports,__globalThis) {
/**
 * Memoizes the provided three-argument function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoize3;
});
function memoize3(fn) {
    var cache0;
    return function memoized(a1, a2, a3) {
        if (!cache0) cache0 = new WeakMap();
        var cache1 = cache0.get(a1);
        var cache2;
        if (cache1) {
            cache2 = cache1.get(a2);
            if (cache2) {
                var cachedValue = cache2.get(a3);
                if (cachedValue !== undefined) return cachedValue;
            }
        } else {
            cache1 = new WeakMap();
            cache0.set(a1, cache1);
        }
        if (!cache2) {
            cache2 = new WeakMap();
            cache1.set(a2, cache2);
        }
        var newValue = fn(a1, a2, a3);
        cache2.set(a3, newValue);
        return newValue;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lDCuH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return promiseReduce;
});
var _isPromiseMjs = require("./isPromise.mjs");
var _isPromiseMjsDefault = parcelHelpers.interopDefault(_isPromiseMjs);
function promiseReduce(values, callback, initialValue) {
    return values.reduce(function(previous, value) {
        return (0, _isPromiseMjsDefault.default)(previous) ? previous.then(function(resolved) {
            return callback(resolved, value);
        }) : callback(previous, value);
    }, initialValue);
}

},{"./isPromise.mjs":"5tmMu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ipXt":[function(require,module,exports,__globalThis) {
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return promiseForObject;
});
function promiseForObject(object) {
    var keys = Object.keys(object);
    var valuesAndPromises = keys.map(function(name) {
        return object[name];
    });
    return Promise.all(valuesAndPromises).then(function(values) {
        return values.reduce(function(resolvedObject, value, i) {
            resolvedObject[keys[i]] = value;
            return resolvedObject;
        }, Object.create(null));
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9U02K":[function(require,module,exports,__globalThis) {
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPath", function() {
    return addPath;
});
/**
 * Given a Path, return an Array of the path keys.
 */ parcelHelpers.export(exports, "pathToArray", function() {
    return pathToArray;
});
function addPath(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function pathToArray(path) {
    var flattened = [];
    var curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cFOlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Extracts the root type of the operation from the schema.
 */ parcelHelpers.export(exports, "getOperationRootType", function() {
    return getOperationRootType;
});
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
function getOperationRootType(schema, operation) {
    if (operation.operation === 'query') {
        var queryType = schema.getQueryType();
        if (!queryType) throw new (0, _graphQLErrorMjs.GraphQLError)('Schema does not define the required query root type.', operation);
        return queryType;
    }
    if (operation.operation === 'mutation') {
        var mutationType = schema.getMutationType();
        if (!mutationType) throw new (0, _graphQLErrorMjs.GraphQLError)('Schema is not configured for mutations.', operation);
        return mutationType;
    }
    if (operation.operation === 'subscription') {
        var subscriptionType = schema.getSubscriptionType();
        if (!subscriptionType) throw new (0, _graphQLErrorMjs.GraphQLError)('Schema is not configured for subscriptions.', operation);
        return subscriptionType;
    }
    throw new (0, _graphQLErrorMjs.GraphQLError)('Can only have query, mutation and subscription operations.', operation);
}

},{"../error/GraphQLError.mjs":"e4y57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cjyw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 *
 * @internal
 */ parcelHelpers.export(exports, "getVariableValues", function() {
    return getVariableValues;
});
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 *
 * @internal
 */ parcelHelpers.export(exports, "getArgumentValues", function() {
    return getArgumentValues;
});
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */ parcelHelpers.export(exports, "getDirectiveValues", function() {
    return getDirectiveValues;
});
var _findMjs = require("../polyfills/find.mjs");
var _findMjsDefault = parcelHelpers.interopDefault(_findMjs);
var _keyMapMjs = require("../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _printPathArrayMjs = require("../jsutils/printPathArray.mjs");
var _printPathArrayMjsDefault = parcelHelpers.interopDefault(_printPathArrayMjs);
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _kindsMjs = require("../language/kinds.mjs");
var _printerMjs = require("../language/printer.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _typeFromASTMjs = require("../utilities/typeFromAST.mjs");
var _valueFromASTMjs = require("../utilities/valueFromAST.mjs");
var _coerceInputValueMjs = require("../utilities/coerceInputValue.mjs");
function getVariableValues(schema, varDefNodes, inputs, options) {
    var errors = [];
    var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        var coerced = coerceVariableValues(schema, varDefNodes, inputs, function(error) {
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, _graphQLErrorMjs.GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function coerceVariableValues(schema, varDefNodes, inputs, onError) {
    var coercedValues = {};
    var _loop = function _loop(_i2) {
        var varDefNode = varDefNodes[_i2];
        var varName = varDefNode.variable.name.value;
        var varType = (0, _typeFromASTMjs.typeFromAST)(schema, varDefNode.type);
        if (!(0, _definitionMjs.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            var varTypeStr = (0, _printerMjs.print)(varDefNode.type);
            onError(new (0, _graphQLErrorMjs.GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
            return "continue";
        }
        if (!hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, _valueFromASTMjs.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, _definitionMjs.isNonNullType)(varType)) {
                var _varTypeStr = (0, _inspectMjsDefault.default)(varType);
                onError(new (0, _graphQLErrorMjs.GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
            }
            return "continue";
        }
        var value = inputs[varName];
        if (value === null && (0, _definitionMjs.isNonNullType)(varType)) {
            var _varTypeStr2 = (0, _inspectMjsDefault.default)(varType);
            onError(new (0, _graphQLErrorMjs.GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
            return "continue";
        }
        coercedValues[varName] = (0, _coerceInputValueMjs.coerceInputValue)(value, varType, function(path, invalidValue, error) {
            var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, _inspectMjsDefault.default)(invalidValue);
            if (path.length > 0) prefix += " at \"".concat(varName).concat((0, _printPathArrayMjsDefault.default)(path), "\"");
            onError(new (0, _graphQLErrorMjs.GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
        });
    };
    for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
        var _ret = _loop(_i2);
        if (_ret === "continue") continue;
    }
    return coercedValues;
}
function getArgumentValues(def, node, variableValues) {
    var _node$arguments;
    var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    var argNodeMap = (0, _keyMapMjsDefault.default)(argumentNodes, function(arg) {
        return arg.name.value;
    });
    for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
        var argDef = _def$args2[_i4];
        var name = argDef.name;
        var argType = argDef.type;
        var argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, _definitionMjs.isNonNullType)(argType)) throw new (0, _graphQLErrorMjs.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, _inspectMjsDefault.default)(argType), "\" ") + 'was not provided.', node);
            continue;
        }
        var valueNode = argumentNode.value;
        var isNull = valueNode.kind === (0, _kindsMjs.Kind).NULL;
        if (valueNode.kind === (0, _kindsMjs.Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variableValues == null || !hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, _definitionMjs.isNonNullType)(argType)) throw new (0, _graphQLErrorMjs.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, _inspectMjsDefault.default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, _definitionMjs.isNonNullType)(argType)) throw new (0, _graphQLErrorMjs.GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, _inspectMjsDefault.default)(argType), "\" ") + 'must not be null.', valueNode);
        var coercedValue = (0, _valueFromASTMjs.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, _graphQLErrorMjs.GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, _printerMjs.print)(valueNode), "."), valueNode);
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function getDirectiveValues(directiveDef, node, variableValues) {
    var directiveNode = node.directives && (0, _findMjsDefault.default)(node.directives, function(directive) {
        return directive.name.value === directiveDef.name;
    });
    if (directiveNode) return getArgumentValues(directiveDef, directiveNode, variableValues);
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

},{"../polyfills/find.mjs":"caL9z","../jsutils/keyMap.mjs":"aZdAt","../jsutils/inspect.mjs":"4vyEo","../jsutils/printPathArray.mjs":"47TbB","../error/GraphQLError.mjs":"e4y57","../language/kinds.mjs":"ffJlp","../language/printer.mjs":"dA3NC","../type/definition.mjs":"hN98Z","../utilities/typeFromAST.mjs":"2b0nl","../utilities/valueFromAST.mjs":"cxoyu","../utilities/coerceInputValue.mjs":"cCJu2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47TbB":[function(require,module,exports,__globalThis) {
/**
 * Build a string describing the path.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return printPathArray;
});
function printPathArray(path) {
    return path.map(function(key) {
        return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
    }).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cxoyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Mixed         |
 * | NullValue            | null          |
 *
 */ parcelHelpers.export(exports, "valueFromAST", function() {
    return valueFromAST;
}) // Returns true if the provided valueNode is a variable which is not defined
;
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _keyMapMjs = require("../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _definitionMjs = require("../type/definition.mjs");
function valueFromAST(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, _kindsMjs.Kind).VARIABLE) {
        var variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        var variableValue = variables[variableName];
        if (variableValue === null && (0, _definitionMjs.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, _definitionMjs.isNonNullType)(type)) {
        if (valueNode.kind === (0, _kindsMjs.Kind).NULL) return; // Invalid: intentionally return no value.
        return valueFromAST(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, _kindsMjs.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, _definitionMjs.isListType)(type)) {
        var itemType = type.ofType;
        if (valueNode.kind === (0, _kindsMjs.Kind).LIST) {
            var coercedValues = [];
            for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                var itemNode = _valueNode$values2[_i2];
                if (isMissingVariable(itemNode, variables)) {
                    // If an array contains a missing variable, it is either coerced to
                    // null or if the item type is non-null, it considered invalid.
                    if ((0, _definitionMjs.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                    coercedValues.push(null);
                } else {
                    var itemValue = valueFromAST(itemNode, itemType, variables);
                    if (itemValue === undefined) return; // Invalid: intentionally return no value.
                    coercedValues.push(itemValue);
                }
            }
            return coercedValues;
        }
        var coercedValue = valueFromAST(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, _definitionMjs.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, _kindsMjs.Kind).OBJECT) return; // Invalid: intentionally return no value.
        var coercedObj = Object.create(null);
        var fieldNodes = (0, _keyMapMjsDefault.default)(valueNode.fields, function(field) {
            return field.name.value;
        });
        for(var _i4 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldNode = fieldNodes[field.name];
            if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, _definitionMjs.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            var fieldValue = valueFromAST(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        var result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected input type: ' + (0, _inspectMjsDefault.default)(type));
}
// in the set of variables.
function isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, _kindsMjs.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/keyMap.mjs":"aZdAt","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../language/kinds.mjs":"ffJlp","../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cCJu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Coerces a JavaScript value given a GraphQL Input Type.
 */ parcelHelpers.export(exports, "coerceInputValue", function() {
    return coerceInputValue;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _didYouMeanMjs = require("../jsutils/didYouMean.mjs");
var _didYouMeanMjsDefault = parcelHelpers.interopDefault(_didYouMeanMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _safeArrayFromMjs = require("../jsutils/safeArrayFrom.mjs");
var _safeArrayFromMjsDefault = parcelHelpers.interopDefault(_safeArrayFromMjs);
var _suggestionListMjs = require("../jsutils/suggestionList.mjs");
var _suggestionListMjsDefault = parcelHelpers.interopDefault(_suggestionListMjs);
var _printPathArrayMjs = require("../jsutils/printPathArray.mjs");
var _printPathArrayMjsDefault = parcelHelpers.interopDefault(_printPathArrayMjs);
var _pathMjs = require("../jsutils/Path.mjs");
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _definitionMjs = require("../type/definition.mjs");
function coerceInputValue(inputValue, type) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOnError;
    return coerceInputValueImpl(inputValue, type, onError);
}
function defaultOnError(path, invalidValue, error) {
    var errorPrefix = 'Invalid value ' + (0, _inspectMjsDefault.default)(invalidValue);
    if (path.length > 0) errorPrefix += " at \"value".concat((0, _printPathArrayMjsDefault.default)(path), "\"");
    error.message = errorPrefix + ': ' + error.message;
    throw error;
}
function coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, _definitionMjs.isNonNullType)(type)) {
        if (inputValue != null) return coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Expected non-nullable type \"".concat((0, _inspectMjsDefault.default)(type), "\" not to be null.")));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, _definitionMjs.isListType)(type)) {
        var itemType = type.ofType;
        var coercedList = (0, _safeArrayFromMjsDefault.default)(inputValue, function(itemValue, index) {
            var itemPath = (0, _pathMjs.addPath)(path, index, undefined);
            return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
        if (coercedList != null) return coercedList;
         // Lists accept a non-list value as a list of one.
        return [
            coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, _definitionMjs.isInputObjectType)(type)) {
        if (!(0, _isObjectLikeMjsDefault.default)(inputValue)) {
            onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
            return;
        }
        var coercedValue = {};
        var fieldDefs = type.getFields();
        for(var _i2 = 0, _objectValues2 = (0, _objectValuesMjsDefault.default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
            var field = _objectValues2[_i2];
            var fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, _definitionMjs.isNonNullType)(field.type)) {
                    var typeStr = (0, _inspectMjsDefault.default)(field.type);
                    onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                }
                continue;
            }
            coercedValue[field.name] = coerceInputValueImpl(fieldValue, field.type, onError, (0, _pathMjs.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
            var fieldName = _Object$keys2[_i4];
            if (!fieldDefs[fieldName]) {
                var suggestions = (0, _suggestionListMjsDefault.default)(fieldName, Object.keys(type.getFields()));
                onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, _didYouMeanMjsDefault.default)(suggestions)));
            }
        }
        return coercedValue;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isLeafType)(type)) {
        var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, _graphQLErrorMjs.GraphQLError)) onError((0, _pathMjs.pathToArray)(path), inputValue, error);
            else onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
            return;
        }
        if (parseResult === undefined) onError((0, _pathMjs.pathToArray)(path), inputValue, new (0, _graphQLErrorMjs.GraphQLError)("Expected type \"".concat(type.name, "\".")));
        return parseResult;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected input type: ' + (0, _inspectMjsDefault.default)(type));
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../jsutils/didYouMean.mjs":"gdkI5","../jsutils/isObjectLike.mjs":"ji7lb","../jsutils/safeArrayFrom.mjs":"5mRH7","../jsutils/suggestionList.mjs":"634S6","../jsutils/printPathArray.mjs":"47TbB","../jsutils/Path.mjs":"9U02K","../error/GraphQLError.mjs":"e4y57","../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lpt1P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSchema", function() {
    return 0, _schemaMjs.isSchema;
});
parcelHelpers.export(exports, "assertSchema", function() {
    return 0, _schemaMjs.assertSchema;
});
parcelHelpers.export(exports, "GraphQLSchema", function() {
    return 0, _schemaMjs.GraphQLSchema;
});
parcelHelpers.export(exports, "isType", function() {
    return 0, _definitionMjs.isType;
});
parcelHelpers.export(exports, "isScalarType", function() {
    return 0, _definitionMjs.isScalarType;
});
parcelHelpers.export(exports, "isObjectType", function() {
    return 0, _definitionMjs.isObjectType;
});
parcelHelpers.export(exports, "isInterfaceType", function() {
    return 0, _definitionMjs.isInterfaceType;
});
parcelHelpers.export(exports, "isUnionType", function() {
    return 0, _definitionMjs.isUnionType;
});
parcelHelpers.export(exports, "isEnumType", function() {
    return 0, _definitionMjs.isEnumType;
});
parcelHelpers.export(exports, "isInputObjectType", function() {
    return 0, _definitionMjs.isInputObjectType;
});
parcelHelpers.export(exports, "isListType", function() {
    return 0, _definitionMjs.isListType;
});
parcelHelpers.export(exports, "isNonNullType", function() {
    return 0, _definitionMjs.isNonNullType;
});
parcelHelpers.export(exports, "isInputType", function() {
    return 0, _definitionMjs.isInputType;
});
parcelHelpers.export(exports, "isOutputType", function() {
    return 0, _definitionMjs.isOutputType;
});
parcelHelpers.export(exports, "isLeafType", function() {
    return 0, _definitionMjs.isLeafType;
});
parcelHelpers.export(exports, "isCompositeType", function() {
    return 0, _definitionMjs.isCompositeType;
});
parcelHelpers.export(exports, "isAbstractType", function() {
    return 0, _definitionMjs.isAbstractType;
});
parcelHelpers.export(exports, "isWrappingType", function() {
    return 0, _definitionMjs.isWrappingType;
});
parcelHelpers.export(exports, "isNullableType", function() {
    return 0, _definitionMjs.isNullableType;
});
parcelHelpers.export(exports, "isNamedType", function() {
    return 0, _definitionMjs.isNamedType;
});
parcelHelpers.export(exports, "isRequiredArgument", function() {
    return 0, _definitionMjs.isRequiredArgument;
});
parcelHelpers.export(exports, "isRequiredInputField", function() {
    return 0, _definitionMjs.isRequiredInputField;
});
parcelHelpers.export(exports, "assertType", function() {
    return 0, _definitionMjs.assertType;
});
parcelHelpers.export(exports, "assertScalarType", function() {
    return 0, _definitionMjs.assertScalarType;
});
parcelHelpers.export(exports, "assertObjectType", function() {
    return 0, _definitionMjs.assertObjectType;
});
parcelHelpers.export(exports, "assertInterfaceType", function() {
    return 0, _definitionMjs.assertInterfaceType;
});
parcelHelpers.export(exports, "assertUnionType", function() {
    return 0, _definitionMjs.assertUnionType;
});
parcelHelpers.export(exports, "assertEnumType", function() {
    return 0, _definitionMjs.assertEnumType;
});
parcelHelpers.export(exports, "assertInputObjectType", function() {
    return 0, _definitionMjs.assertInputObjectType;
});
parcelHelpers.export(exports, "assertListType", function() {
    return 0, _definitionMjs.assertListType;
});
parcelHelpers.export(exports, "assertNonNullType", function() {
    return 0, _definitionMjs.assertNonNullType;
});
parcelHelpers.export(exports, "assertInputType", function() {
    return 0, _definitionMjs.assertInputType;
});
parcelHelpers.export(exports, "assertOutputType", function() {
    return 0, _definitionMjs.assertOutputType;
});
parcelHelpers.export(exports, "assertLeafType", function() {
    return 0, _definitionMjs.assertLeafType;
});
parcelHelpers.export(exports, "assertCompositeType", function() {
    return 0, _definitionMjs.assertCompositeType;
});
parcelHelpers.export(exports, "assertAbstractType", function() {
    return 0, _definitionMjs.assertAbstractType;
});
parcelHelpers.export(exports, "assertWrappingType", function() {
    return 0, _definitionMjs.assertWrappingType;
});
parcelHelpers.export(exports, "assertNullableType", function() {
    return 0, _definitionMjs.assertNullableType;
});
parcelHelpers.export(exports, "assertNamedType", function() {
    return 0, _definitionMjs.assertNamedType;
});
parcelHelpers.export(exports, "getNullableType", function() {
    return 0, _definitionMjs.getNullableType;
});
parcelHelpers.export(exports, "getNamedType", function() {
    return 0, _definitionMjs.getNamedType;
});
parcelHelpers.export(exports, "GraphQLScalarType", function() {
    return 0, _definitionMjs.GraphQLScalarType;
});
parcelHelpers.export(exports, "GraphQLObjectType", function() {
    return 0, _definitionMjs.GraphQLObjectType;
});
parcelHelpers.export(exports, "GraphQLInterfaceType", function() {
    return 0, _definitionMjs.GraphQLInterfaceType;
});
parcelHelpers.export(exports, "GraphQLUnionType", function() {
    return 0, _definitionMjs.GraphQLUnionType;
});
parcelHelpers.export(exports, "GraphQLEnumType", function() {
    return 0, _definitionMjs.GraphQLEnumType;
});
parcelHelpers.export(exports, "GraphQLInputObjectType", function() {
    return 0, _definitionMjs.GraphQLInputObjectType;
});
parcelHelpers.export(exports, "GraphQLList", function() {
    return 0, _definitionMjs.GraphQLList;
});
parcelHelpers.export(exports, "GraphQLNonNull", function() {
    return 0, _definitionMjs.GraphQLNonNull;
});
parcelHelpers.export(exports, "isDirective", function() {
    return 0, _directivesMjs.isDirective;
});
parcelHelpers.export(exports, "assertDirective", function() {
    return 0, _directivesMjs.assertDirective;
});
parcelHelpers.export(exports, "GraphQLDirective", function() {
    return 0, _directivesMjs.GraphQLDirective;
});
parcelHelpers.export(exports, "isSpecifiedDirective", function() {
    return 0, _directivesMjs.isSpecifiedDirective;
});
parcelHelpers.export(exports, "specifiedDirectives", function() {
    return 0, _directivesMjs.specifiedDirectives;
});
parcelHelpers.export(exports, "GraphQLIncludeDirective", function() {
    return 0, _directivesMjs.GraphQLIncludeDirective;
});
parcelHelpers.export(exports, "GraphQLSkipDirective", function() {
    return 0, _directivesMjs.GraphQLSkipDirective;
});
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", function() {
    return 0, _directivesMjs.GraphQLDeprecatedDirective;
});
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", function() {
    return 0, _directivesMjs.GraphQLSpecifiedByDirective;
});
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", function() {
    return 0, _directivesMjs.DEFAULT_DEPRECATION_REASON;
});
// Common built-in scalar instances.
parcelHelpers.export(exports, "isSpecifiedScalarType", function() {
    return 0, _scalarsMjs.isSpecifiedScalarType;
});
parcelHelpers.export(exports, "specifiedScalarTypes", function() {
    return 0, _scalarsMjs.specifiedScalarTypes;
});
parcelHelpers.export(exports, "GraphQLInt", function() {
    return 0, _scalarsMjs.GraphQLInt;
});
parcelHelpers.export(exports, "GraphQLFloat", function() {
    return 0, _scalarsMjs.GraphQLFloat;
});
parcelHelpers.export(exports, "GraphQLString", function() {
    return 0, _scalarsMjs.GraphQLString;
});
parcelHelpers.export(exports, "GraphQLBoolean", function() {
    return 0, _scalarsMjs.GraphQLBoolean;
});
parcelHelpers.export(exports, "GraphQLID", function() {
    return 0, _scalarsMjs.GraphQLID;
});
parcelHelpers.export(exports, "isIntrospectionType", function() {
    return 0, _introspectionMjs.isIntrospectionType;
});
parcelHelpers.export(exports, "introspectionTypes", function() {
    return 0, _introspectionMjs.introspectionTypes;
});
parcelHelpers.export(exports, "__Schema", function() {
    return 0, _introspectionMjs.__Schema;
});
parcelHelpers.export(exports, "__Directive", function() {
    return 0, _introspectionMjs.__Directive;
});
parcelHelpers.export(exports, "__DirectiveLocation", function() {
    return 0, _introspectionMjs.__DirectiveLocation;
});
parcelHelpers.export(exports, "__Type", function() {
    return 0, _introspectionMjs.__Type;
});
parcelHelpers.export(exports, "__Field", function() {
    return 0, _introspectionMjs.__Field;
});
parcelHelpers.export(exports, "__InputValue", function() {
    return 0, _introspectionMjs.__InputValue;
});
parcelHelpers.export(exports, "__EnumValue", function() {
    return 0, _introspectionMjs.__EnumValue;
});
parcelHelpers.export(exports, "__TypeKind", function() {
    return 0, _introspectionMjs.__TypeKind;
});
parcelHelpers.export(exports, "TypeKind", function() {
    return 0, _introspectionMjs.TypeKind;
});
parcelHelpers.export(exports, "SchemaMetaFieldDef", function() {
    return 0, _introspectionMjs.SchemaMetaFieldDef;
});
parcelHelpers.export(exports, "TypeMetaFieldDef", function() {
    return 0, _introspectionMjs.TypeMetaFieldDef;
});
parcelHelpers.export(exports, "TypeNameMetaFieldDef", function() {
    return 0, _introspectionMjs.TypeNameMetaFieldDef;
});
// Validate GraphQL schema.
parcelHelpers.export(exports, "validateSchema", function() {
    return 0, _validateMjs.validateSchema;
});
parcelHelpers.export(exports, "assertValidSchema", function() {
    return 0, _validateMjs.assertValidSchema;
});
var _schemaMjs = require("./schema.mjs");
var _definitionMjs = require("./definition.mjs");
var _directivesMjs = require("./directives.mjs");
var _scalarsMjs = require("./scalars.mjs");
var _introspectionMjs = require("./introspection.mjs");
var _validateMjs = require("./validate.mjs");

},{"./schema.mjs":"gzZTY","./definition.mjs":"hN98Z","./directives.mjs":"k3NFN","./scalars.mjs":"5S8Ww","./introspection.mjs":"fg0io","./validate.mjs":"70lDP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gn83r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", function() {
    return 0, _sourceMjs.Source;
});
parcelHelpers.export(exports, "getLocation", function() {
    return 0, _locationMjs.getLocation;
});
parcelHelpers.export(exports, "printLocation", function() {
    return 0, _printLocationMjs.printLocation;
});
parcelHelpers.export(exports, "printSourceLocation", function() {
    return 0, _printLocationMjs.printSourceLocation;
});
parcelHelpers.export(exports, "Kind", function() {
    return 0, _kindsMjs.Kind;
});
parcelHelpers.export(exports, "TokenKind", function() {
    return 0, _tokenKindMjs.TokenKind;
});
parcelHelpers.export(exports, "Lexer", function() {
    return 0, _lexerMjs.Lexer;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parserMjs.parse;
});
parcelHelpers.export(exports, "parseValue", function() {
    return 0, _parserMjs.parseValue;
});
parcelHelpers.export(exports, "parseType", function() {
    return 0, _parserMjs.parseType;
});
parcelHelpers.export(exports, "print", function() {
    return 0, _printerMjs.print;
});
parcelHelpers.export(exports, "visit", function() {
    return 0, _visitorMjs.visit;
});
parcelHelpers.export(exports, "visitInParallel", function() {
    return 0, _visitorMjs.visitInParallel;
});
parcelHelpers.export(exports, "getVisitFn", function() {
    return 0, _visitorMjs.getVisitFn;
});
parcelHelpers.export(exports, "BREAK", function() {
    return 0, _visitorMjs.BREAK;
});
parcelHelpers.export(exports, "Location", function() {
    return 0, _astMjs.Location;
});
parcelHelpers.export(exports, "Token", function() {
    return 0, _astMjs.Token;
});
parcelHelpers.export(exports, "isDefinitionNode", function() {
    return 0, _predicatesMjs.isDefinitionNode;
});
parcelHelpers.export(exports, "isExecutableDefinitionNode", function() {
    return 0, _predicatesMjs.isExecutableDefinitionNode;
});
parcelHelpers.export(exports, "isSelectionNode", function() {
    return 0, _predicatesMjs.isSelectionNode;
});
parcelHelpers.export(exports, "isValueNode", function() {
    return 0, _predicatesMjs.isValueNode;
});
parcelHelpers.export(exports, "isTypeNode", function() {
    return 0, _predicatesMjs.isTypeNode;
});
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", function() {
    return 0, _predicatesMjs.isTypeSystemDefinitionNode;
});
parcelHelpers.export(exports, "isTypeDefinitionNode", function() {
    return 0, _predicatesMjs.isTypeDefinitionNode;
});
parcelHelpers.export(exports, "isTypeSystemExtensionNode", function() {
    return 0, _predicatesMjs.isTypeSystemExtensionNode;
});
parcelHelpers.export(exports, "isTypeExtensionNode", function() {
    return 0, _predicatesMjs.isTypeExtensionNode;
});
parcelHelpers.export(exports, "DirectiveLocation", function() {
    return 0, _directiveLocationMjs.DirectiveLocation;
});
var _sourceMjs = require("./source.mjs");
var _locationMjs = require("./location.mjs");
var _printLocationMjs = require("./printLocation.mjs");
var _kindsMjs = require("./kinds.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _lexerMjs = require("./lexer.mjs");
var _parserMjs = require("./parser.mjs");
var _printerMjs = require("./printer.mjs");
var _visitorMjs = require("./visitor.mjs");
var _astMjs = require("./ast.mjs");
var _predicatesMjs = require("./predicates.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");

},{"./source.mjs":"llYv9","./location.mjs":"eMiPl","./printLocation.mjs":"hQEyy","./kinds.mjs":"ffJlp","./tokenKind.mjs":"2TYsC","./lexer.mjs":"6UkL9","./parser.mjs":"Q1jFp","./printer.mjs":"dA3NC","./visitor.mjs":"aHQOA","./ast.mjs":"diDO0","./predicates.mjs":"iXXFP","./directiveLocation.mjs":"tgdMp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGDrM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responsePathAsArray", function() {
    return 0, _pathMjs.pathToArray;
});
parcelHelpers.export(exports, "execute", function() {
    return 0, _executeMjs.execute;
});
parcelHelpers.export(exports, "executeSync", function() {
    return 0, _executeMjs.executeSync;
});
parcelHelpers.export(exports, "defaultFieldResolver", function() {
    return 0, _executeMjs.defaultFieldResolver;
});
parcelHelpers.export(exports, "defaultTypeResolver", function() {
    return 0, _executeMjs.defaultTypeResolver;
});
parcelHelpers.export(exports, "getDirectiveValues", function() {
    return 0, _valuesMjs.getDirectiveValues;
});
var _pathMjs = require("../jsutils/Path.mjs");
var _executeMjs = require("./execute.mjs");
var _valuesMjs = require("./values.mjs");

},{"../jsutils/Path.mjs":"9U02K","./execute.mjs":"e0yfk","./values.mjs":"cjyw1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bzHzs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribe", function() {
    return 0, _subscribeMjs.subscribe;
});
parcelHelpers.export(exports, "createSourceEventStream", function() {
    return 0, _subscribeMjs.createSourceEventStream;
});
var _subscribeMjs = require("./subscribe.mjs");

},{"./subscribe.mjs":"hxafo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hxafo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribe", function() {
    return subscribe;
});
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise which resolves to either an AsyncIterable (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to the AsyncIterable for the
 * event stream returned by the resolver.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */ parcelHelpers.export(exports, "createSourceEventStream", function() {
    return createSourceEventStream;
});
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _isAsyncIterableMjs = require("../jsutils/isAsyncIterable.mjs");
var _isAsyncIterableMjsDefault = parcelHelpers.interopDefault(_isAsyncIterableMjs);
var _pathMjs = require("../jsutils/Path.mjs");
var _graphQLErrorMjs = require("../error/GraphQLError.mjs");
var _locatedErrorMjs = require("../error/locatedError.mjs");
var _valuesMjs = require("../execution/values.mjs");
var _executeMjs = require("../execution/execute.mjs");
var _getOperationRootTypeMjs = require("../utilities/getOperationRootType.mjs");
var _mapAsyncIteratorMjs = require("./mapAsyncIterator.mjs");
var _mapAsyncIteratorMjsDefault = parcelHelpers.interopDefault(_mapAsyncIteratorMjs);
function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? subscribeImpl(argsOrSchema) : subscribeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        subscribeFieldResolver: subscribeFieldResolver
    });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */ function reportGraphQLError(error) {
    if (error instanceof (0, _graphQLErrorMjs.GraphQLError)) return {
        errors: [
            error
        ]
    };
    throw error;
}
function subscribeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
    var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
    // GraphQL `execute` function, with `payload` as the rootValue.
    // This implements the "MapSourceToResponseEvent" algorithm described in
    // the GraphQL specification. The `execute` function provides the
    // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
    // "ExecuteQuery" algorithm, for which `execute` is also used.
    var mapSourceToResponse = function mapSourceToResponse(payload) {
        return (0, _executeMjs.execute)({
            schema: schema,
            document: document,
            rootValue: payload,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver
        });
    }; // Resolve the Source Stream, then map every source value to a
    // ExecutionResult value as described above.
    return sourcePromise.then(function(resultOrStream) {
        return (0, _isAsyncIterableMjsDefault.default)(resultOrStream) ? (0, _mapAsyncIteratorMjsDefault.default)(resultOrStream, mapSourceToResponse, reportGraphQLError) : resultOrStream;
    });
}
function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
    // If arguments are missing or incorrectly typed, this is an internal
    // developer mistake which should throw an early error.
    (0, _executeMjs.assertValidExecutionArguments)(schema, document, variableValues);
    return new Promise(function(resolve) {
        // If a valid context cannot be created due to incorrect arguments,
        // this will throw an error.
        var exeContext = (0, _executeMjs.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
        resolve(Array.isArray(exeContext) ? {
            errors: exeContext
        } : executeSubscription(exeContext));
    }).catch(reportGraphQLError);
}
function executeSubscription(exeContext) {
    var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
    var type = (0, _getOperationRootTypeMjs.getOperationRootType)(schema, operation);
    var fields = (0, _executeMjs.collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, _executeMjs.getFieldDef)(schema, type, fieldName);
    if (!fieldDef) throw new (0, _graphQLErrorMjs.GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    var path = (0, _pathMjs.addPath)(undefined, responseName, type.name);
    var info = (0, _executeMjs.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.
    return new Promise(function(resolveResult) {
        var _fieldDef$subscribe;
        // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
        // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        var args = (0, _valuesMjs.getArgumentValues)(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
        // AsyncIterable yielding raw payloads.
        var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
        resolveResult(resolveFn(rootValue, args, contextValue, info));
    }).then(function(eventStream) {
        if (eventStream instanceof Error) throw (0, _locatedErrorMjs.locatedError)(eventStream, fieldNodes, (0, _pathMjs.pathToArray)(path));
         // Assert field returned an event stream, otherwise yield an error.
        if (!(0, _isAsyncIterableMjsDefault.default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, _inspectMjsDefault.default)(eventStream), "."));
        return eventStream;
    }, function(error) {
        throw (0, _locatedErrorMjs.locatedError)(error, fieldNodes, (0, _pathMjs.pathToArray)(path));
    });
}

},{"../jsutils/inspect.mjs":"4vyEo","../jsutils/isAsyncIterable.mjs":"d1VXA","../jsutils/Path.mjs":"9U02K","../error/GraphQLError.mjs":"e4y57","../error/locatedError.mjs":"4qusX","../execution/values.mjs":"cjyw1","../execution/execute.mjs":"e0yfk","../utilities/getOperationRootType.mjs":"cFOlo","./mapAsyncIterator.mjs":"3Ohv4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d1VXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAsyncIterable;
});
var _symbolsMjs = require("../polyfills/symbols.mjs");
function isAsyncIterable(maybeAsyncIterable) {
    return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, _symbolsMjs.SYMBOL_ASYNC_ITERATOR]) === 'function';
}

},{"../polyfills/symbols.mjs":"26hb6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Ohv4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mapAsyncIterator;
});
var _symbolsMjs = require("../polyfills/symbols.mjs");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function mapAsyncIterator(iterable, callback, rejectCallback) {
    // $FlowFixMe[prop-missing]
    var iteratorMethod = iterable[0, _symbolsMjs.SYMBOL_ASYNC_ITERATOR];
    var iterator = iteratorMethod.call(iterable);
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function abruptClose(error) {
            var rethrow = function rethrow() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject = rejectCallback;
        mapReject = function mapReject(error) {
            return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
        };
    }
    /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */ return _defineProperty({
        next: function next() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function _return() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function _throw(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, (0, _symbolsMjs.SYMBOL_ASYNC_ITERATOR), function() {
        return this;
    });
}
function asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

},{"../polyfills/symbols.mjs":"26hb6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"67Cb0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateMjs.validate;
});
parcelHelpers.export(exports, "ValidationContext", function() {
    return 0, _validationContextMjs.ValidationContext;
});
// All validation rules in the GraphQL Specification.
parcelHelpers.export(exports, "specifiedRules", function() {
    return 0, _specifiedRulesMjs.specifiedRules;
}) // Spec Section: "Executable Definitions"
;
parcelHelpers.export(exports, "ExecutableDefinitionsRule", function() {
    return 0, _executableDefinitionsRuleMjs.ExecutableDefinitionsRule;
}) // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
;
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", function() {
    return 0, _fieldsOnCorrectTypeRuleMjs.FieldsOnCorrectTypeRule;
}) // Spec Section: "Fragments on Composite Types"
;
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", function() {
    return 0, _fragmentsOnCompositeTypesRuleMjs.FragmentsOnCompositeTypesRule;
}) // Spec Section: "Argument Names"
;
parcelHelpers.export(exports, "KnownArgumentNamesRule", function() {
    return 0, _knownArgumentNamesRuleMjs.KnownArgumentNamesRule;
}) // Spec Section: "Directives Are Defined"
;
parcelHelpers.export(exports, "KnownDirectivesRule", function() {
    return 0, _knownDirectivesRuleMjs.KnownDirectivesRule;
}) // Spec Section: "Fragment spread target defined"
;
parcelHelpers.export(exports, "KnownFragmentNamesRule", function() {
    return 0, _knownFragmentNamesRuleMjs.KnownFragmentNamesRule;
}) // Spec Section: "Fragment Spread Type Existence"
;
parcelHelpers.export(exports, "KnownTypeNamesRule", function() {
    return 0, _knownTypeNamesRuleMjs.KnownTypeNamesRule;
}) // Spec Section: "Lone Anonymous Operation"
;
parcelHelpers.export(exports, "LoneAnonymousOperationRule", function() {
    return 0, _loneAnonymousOperationRuleMjs.LoneAnonymousOperationRule;
}) // Spec Section: "Fragments must not form cycles"
;
parcelHelpers.export(exports, "NoFragmentCyclesRule", function() {
    return 0, _noFragmentCyclesRuleMjs.NoFragmentCyclesRule;
}) // Spec Section: "All Variable Used Defined"
;
parcelHelpers.export(exports, "NoUndefinedVariablesRule", function() {
    return 0, _noUndefinedVariablesRuleMjs.NoUndefinedVariablesRule;
}) // Spec Section: "Fragments must be used"
;
parcelHelpers.export(exports, "NoUnusedFragmentsRule", function() {
    return 0, _noUnusedFragmentsRuleMjs.NoUnusedFragmentsRule;
}) // Spec Section: "All Variables Used"
;
parcelHelpers.export(exports, "NoUnusedVariablesRule", function() {
    return 0, _noUnusedVariablesRuleMjs.NoUnusedVariablesRule;
}) // Spec Section: "Field Selection Merging"
;
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", function() {
    return 0, _overlappingFieldsCanBeMergedRuleMjs.OverlappingFieldsCanBeMergedRule;
}) // Spec Section: "Fragment spread is possible"
;
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", function() {
    return 0, _possibleFragmentSpreadsRuleMjs.PossibleFragmentSpreadsRule;
}) // Spec Section: "Argument Optionality"
;
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", function() {
    return 0, _providedRequiredArgumentsRuleMjs.ProvidedRequiredArgumentsRule;
}) // Spec Section: "Leaf Field Selections"
;
parcelHelpers.export(exports, "ScalarLeafsRule", function() {
    return 0, _scalarLeafsRuleMjs.ScalarLeafsRule;
}) // Spec Section: "Subscriptions with Single Root Field"
;
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", function() {
    return 0, _singleFieldSubscriptionsRuleMjs.SingleFieldSubscriptionsRule;
}) // Spec Section: "Argument Uniqueness"
;
parcelHelpers.export(exports, "UniqueArgumentNamesRule", function() {
    return 0, _uniqueArgumentNamesRuleMjs.UniqueArgumentNamesRule;
}) // Spec Section: "Directives Are Unique Per Location"
;
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", function() {
    return 0, _uniqueDirectivesPerLocationRuleMjs.UniqueDirectivesPerLocationRule;
}) // Spec Section: "Fragment Name Uniqueness"
;
parcelHelpers.export(exports, "UniqueFragmentNamesRule", function() {
    return 0, _uniqueFragmentNamesRuleMjs.UniqueFragmentNamesRule;
}) // Spec Section: "Input Object Field Uniqueness"
;
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", function() {
    return 0, _uniqueInputFieldNamesRuleMjs.UniqueInputFieldNamesRule;
}) // Spec Section: "Operation Name Uniqueness"
;
parcelHelpers.export(exports, "UniqueOperationNamesRule", function() {
    return 0, _uniqueOperationNamesRuleMjs.UniqueOperationNamesRule;
}) // Spec Section: "Variable Uniqueness"
;
parcelHelpers.export(exports, "UniqueVariableNamesRule", function() {
    return 0, _uniqueVariableNamesRuleMjs.UniqueVariableNamesRule;
}) // Spec Section: "Values Type Correctness"
;
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", function() {
    return 0, _valuesOfCorrectTypeRuleMjs.ValuesOfCorrectTypeRule;
}) // Spec Section: "Variables are Input Types"
;
parcelHelpers.export(exports, "VariablesAreInputTypesRule", function() {
    return 0, _variablesAreInputTypesRuleMjs.VariablesAreInputTypesRule;
}) // Spec Section: "All Variable Usages Are Allowed"
;
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", function() {
    return 0, _variablesInAllowedPositionRuleMjs.VariablesInAllowedPositionRule;
}) // SDL-specific validation rules
;
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", function() {
    return 0, _loneSchemaDefinitionRuleMjs.LoneSchemaDefinitionRule;
});
parcelHelpers.export(exports, "UniqueOperationTypesRule", function() {
    return 0, _uniqueOperationTypesRuleMjs.UniqueOperationTypesRule;
});
parcelHelpers.export(exports, "UniqueTypeNamesRule", function() {
    return 0, _uniqueTypeNamesRuleMjs.UniqueTypeNamesRule;
});
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", function() {
    return 0, _uniqueEnumValueNamesRuleMjs.UniqueEnumValueNamesRule;
});
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", function() {
    return 0, _uniqueFieldDefinitionNamesRuleMjs.UniqueFieldDefinitionNamesRule;
});
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", function() {
    return 0, _uniqueDirectiveNamesRuleMjs.UniqueDirectiveNamesRule;
});
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", function() {
    return 0, _possibleTypeExtensionsRuleMjs.PossibleTypeExtensionsRule;
}) // Optional rules not defined by the GraphQL Specification
;
parcelHelpers.export(exports, "NoDeprecatedCustomRule", function() {
    return 0, _noDeprecatedCustomRuleMjs.NoDeprecatedCustomRule;
});
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", function() {
    return 0, _noSchemaIntrospectionCustomRuleMjs.NoSchemaIntrospectionCustomRule;
});
var _validateMjs = require("./validate.mjs");
var _validationContextMjs = require("./ValidationContext.mjs");
var _specifiedRulesMjs = require("./specifiedRules.mjs");
var _executableDefinitionsRuleMjs = require("./rules/ExecutableDefinitionsRule.mjs");
var _fieldsOnCorrectTypeRuleMjs = require("./rules/FieldsOnCorrectTypeRule.mjs");
var _fragmentsOnCompositeTypesRuleMjs = require("./rules/FragmentsOnCompositeTypesRule.mjs");
var _knownArgumentNamesRuleMjs = require("./rules/KnownArgumentNamesRule.mjs");
var _knownDirectivesRuleMjs = require("./rules/KnownDirectivesRule.mjs");
var _knownFragmentNamesRuleMjs = require("./rules/KnownFragmentNamesRule.mjs");
var _knownTypeNamesRuleMjs = require("./rules/KnownTypeNamesRule.mjs");
var _loneAnonymousOperationRuleMjs = require("./rules/LoneAnonymousOperationRule.mjs");
var _noFragmentCyclesRuleMjs = require("./rules/NoFragmentCyclesRule.mjs");
var _noUndefinedVariablesRuleMjs = require("./rules/NoUndefinedVariablesRule.mjs");
var _noUnusedFragmentsRuleMjs = require("./rules/NoUnusedFragmentsRule.mjs");
var _noUnusedVariablesRuleMjs = require("./rules/NoUnusedVariablesRule.mjs");
var _overlappingFieldsCanBeMergedRuleMjs = require("./rules/OverlappingFieldsCanBeMergedRule.mjs");
var _possibleFragmentSpreadsRuleMjs = require("./rules/PossibleFragmentSpreadsRule.mjs");
var _providedRequiredArgumentsRuleMjs = require("./rules/ProvidedRequiredArgumentsRule.mjs");
var _scalarLeafsRuleMjs = require("./rules/ScalarLeafsRule.mjs");
var _singleFieldSubscriptionsRuleMjs = require("./rules/SingleFieldSubscriptionsRule.mjs");
var _uniqueArgumentNamesRuleMjs = require("./rules/UniqueArgumentNamesRule.mjs");
var _uniqueDirectivesPerLocationRuleMjs = require("./rules/UniqueDirectivesPerLocationRule.mjs");
var _uniqueFragmentNamesRuleMjs = require("./rules/UniqueFragmentNamesRule.mjs");
var _uniqueInputFieldNamesRuleMjs = require("./rules/UniqueInputFieldNamesRule.mjs");
var _uniqueOperationNamesRuleMjs = require("./rules/UniqueOperationNamesRule.mjs");
var _uniqueVariableNamesRuleMjs = require("./rules/UniqueVariableNamesRule.mjs");
var _valuesOfCorrectTypeRuleMjs = require("./rules/ValuesOfCorrectTypeRule.mjs");
var _variablesAreInputTypesRuleMjs = require("./rules/VariablesAreInputTypesRule.mjs");
var _variablesInAllowedPositionRuleMjs = require("./rules/VariablesInAllowedPositionRule.mjs");
var _loneSchemaDefinitionRuleMjs = require("./rules/LoneSchemaDefinitionRule.mjs");
var _uniqueOperationTypesRuleMjs = require("./rules/UniqueOperationTypesRule.mjs");
var _uniqueTypeNamesRuleMjs = require("./rules/UniqueTypeNamesRule.mjs");
var _uniqueEnumValueNamesRuleMjs = require("./rules/UniqueEnumValueNamesRule.mjs");
var _uniqueFieldDefinitionNamesRuleMjs = require("./rules/UniqueFieldDefinitionNamesRule.mjs");
var _uniqueDirectiveNamesRuleMjs = require("./rules/UniqueDirectiveNamesRule.mjs");
var _possibleTypeExtensionsRuleMjs = require("./rules/PossibleTypeExtensionsRule.mjs");
var _noDeprecatedCustomRuleMjs = require("./rules/custom/NoDeprecatedCustomRule.mjs");
var _noSchemaIntrospectionCustomRuleMjs = require("./rules/custom/NoSchemaIntrospectionCustomRule.mjs");

},{"./validate.mjs":"OZYxA","./ValidationContext.mjs":"b8dcx","./specifiedRules.mjs":"1HAr9","./rules/ExecutableDefinitionsRule.mjs":"cQd2g","./rules/FieldsOnCorrectTypeRule.mjs":"emuRG","./rules/FragmentsOnCompositeTypesRule.mjs":"9ikXa","./rules/KnownArgumentNamesRule.mjs":"454uw","./rules/KnownDirectivesRule.mjs":"icSQy","./rules/KnownFragmentNamesRule.mjs":"CqkcL","./rules/KnownTypeNamesRule.mjs":"cymvC","./rules/LoneAnonymousOperationRule.mjs":"4bhQU","./rules/NoFragmentCyclesRule.mjs":"hO8Y4","./rules/NoUndefinedVariablesRule.mjs":"5dXjy","./rules/NoUnusedFragmentsRule.mjs":"jBysz","./rules/NoUnusedVariablesRule.mjs":"7Fxnf","./rules/OverlappingFieldsCanBeMergedRule.mjs":"E5YPN","./rules/PossibleFragmentSpreadsRule.mjs":"lRxXk","./rules/ProvidedRequiredArgumentsRule.mjs":"7gmuj","./rules/ScalarLeafsRule.mjs":"8VtZE","./rules/SingleFieldSubscriptionsRule.mjs":"8LYfh","./rules/UniqueArgumentNamesRule.mjs":"eJPzp","./rules/UniqueDirectivesPerLocationRule.mjs":"lVij4","./rules/UniqueFragmentNamesRule.mjs":"btgAU","./rules/UniqueInputFieldNamesRule.mjs":"cLbRy","./rules/UniqueOperationNamesRule.mjs":"hiYSX","./rules/UniqueVariableNamesRule.mjs":"eSmdU","./rules/ValuesOfCorrectTypeRule.mjs":"9hkVW","./rules/VariablesAreInputTypesRule.mjs":"c34nn","./rules/VariablesInAllowedPositionRule.mjs":"aACfV","./rules/LoneSchemaDefinitionRule.mjs":"adXGS","./rules/UniqueOperationTypesRule.mjs":"fYcAh","./rules/UniqueTypeNamesRule.mjs":"21Bmd","./rules/UniqueEnumValueNamesRule.mjs":"4ouc6","./rules/UniqueFieldDefinitionNamesRule.mjs":"fvec4","./rules/UniqueDirectiveNamesRule.mjs":"k26ww","./rules/PossibleTypeExtensionsRule.mjs":"9hVFH","./rules/custom/NoDeprecatedCustomRule.mjs":"ePWID","./rules/custom/NoSchemaIntrospectionCustomRule.mjs":"dX7ZQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ePWID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * No deprecated
 *
 * A GraphQL document is only valid if all selected fields and all used enum values have not been
 * deprecated.
 *
 * Note: This rule is optional and is not part of the Validation section of the GraphQL
 * Specification. The main purpose of this rule is detection of deprecated usages and not
 * necessarily to forbid their use when querying a service.
 */ parcelHelpers.export(exports, "NoDeprecatedCustomRule", function() {
    return NoDeprecatedCustomRule;
});
var _invariantMjs = require("../../../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _graphQLErrorMjs = require("../../../error/GraphQLError.mjs");
var _definitionMjs = require("../../../type/definition.mjs");
function NoDeprecatedCustomRule(context) {
    return {
        Field: function Field(node) {
            var fieldDef = context.getFieldDef();
            var deprecationReason = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.deprecationReason;
            if (fieldDef && deprecationReason != null) {
                var parentType = context.getParentType();
                parentType != null || (0, _invariantMjsDefault.default)(0);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("The field ".concat(parentType.name, ".").concat(fieldDef.name, " is deprecated. ").concat(deprecationReason), node));
            }
        },
        Argument: function Argument(node) {
            var argDef = context.getArgument();
            var deprecationReason = argDef === null || argDef === void 0 ? void 0 : argDef.deprecationReason;
            if (argDef && deprecationReason != null) {
                var directiveDef = context.getDirective();
                if (directiveDef != null) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Directive \"@".concat(directiveDef.name, "\" argument \"").concat(argDef.name, "\" is deprecated. ").concat(deprecationReason), node));
                else {
                    var parentType = context.getParentType();
                    var fieldDef = context.getFieldDef();
                    parentType != null && fieldDef != null || (0, _invariantMjsDefault.default)(0);
                    context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("Field \"".concat(parentType.name, ".").concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" is deprecated. ").concat(deprecationReason), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var inputObjectDef = (0, _definitionMjs.getNamedType)(context.getParentInputType());
            if ((0, _definitionMjs.isInputObjectType)(inputObjectDef)) {
                var inputFieldDef = inputObjectDef.getFields()[node.name.value]; // flowlint-next-line unnecessary-optional-chain:off
                var deprecationReason = inputFieldDef === null || inputFieldDef === void 0 ? void 0 : inputFieldDef.deprecationReason;
                if (deprecationReason != null) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("The input field ".concat(inputObjectDef.name, ".").concat(inputFieldDef.name, " is deprecated. ").concat(deprecationReason), node));
            }
        },
        EnumValue: function EnumValue(node) {
            var enumValueDef = context.getEnumValue();
            var deprecationReason = enumValueDef === null || enumValueDef === void 0 ? void 0 : enumValueDef.deprecationReason;
            if (enumValueDef && deprecationReason != null) {
                var enumTypeDef = (0, _definitionMjs.getNamedType)(context.getInputType());
                enumTypeDef != null || (0, _invariantMjsDefault.default)(0);
                context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("The enum value \"".concat(enumTypeDef.name, ".").concat(enumValueDef.name, "\" is deprecated. ").concat(deprecationReason), node));
            }
        }
    };
}

},{"../../../jsutils/invariant.mjs":"agtax","../../../error/GraphQLError.mjs":"e4y57","../../../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dX7ZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prohibit introspection queries
 *
 * A GraphQL document is only valid if all fields selected are not fields that
 * return an introspection type.
 *
 * Note: This rule is optional and is not part of the Validation section of the
 * GraphQL Specification. This rule effectively disables introspection, which
 * does not reflect best practices and should only be done if absolutely necessary.
 */ parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", function() {
    return NoSchemaIntrospectionCustomRule;
});
var _graphQLErrorMjs = require("../../../error/GraphQLError.mjs");
var _definitionMjs = require("../../../type/definition.mjs");
var _introspectionMjs = require("../../../type/introspection.mjs");
function NoSchemaIntrospectionCustomRule(context) {
    return {
        Field: function Field(node) {
            var type = (0, _definitionMjs.getNamedType)(context.getType());
            if (type && (0, _introspectionMjs.isIntrospectionType)(type)) context.reportError(new (0, _graphQLErrorMjs.GraphQLError)("GraphQL introspection has been disabled, but the requested query contained the field \"".concat(node.name.value, "\"."), node));
        }
    };
}

},{"../../../error/GraphQLError.mjs":"e4y57","../../../type/definition.mjs":"hN98Z","../../../type/introspection.mjs":"fg0io","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7JUwy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", function() {
    return 0, _graphQLErrorMjs.GraphQLError;
});
parcelHelpers.export(exports, "printError", function() {
    return 0, _graphQLErrorMjs.printError;
});
parcelHelpers.export(exports, "syntaxError", function() {
    return 0, _syntaxErrorMjs.syntaxError;
});
parcelHelpers.export(exports, "locatedError", function() {
    return 0, _locatedErrorMjs.locatedError;
});
parcelHelpers.export(exports, "formatError", function() {
    return 0, _formatErrorMjs.formatError;
});
var _graphQLErrorMjs = require("./GraphQLError.mjs");
var _syntaxErrorMjs = require("./syntaxError.mjs");
var _locatedErrorMjs = require("./locatedError.mjs");
var _formatErrorMjs = require("./formatError.mjs");

},{"./GraphQLError.mjs":"e4y57","./syntaxError.mjs":"hOPJ2","./locatedError.mjs":"4qusX","./formatError.mjs":"iA5RU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iA5RU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ parcelHelpers.export(exports, "formatError", function() {
    return formatError;
}) /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ ;
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
function formatError(error) {
    var _error$message;
    error || (0, _devAssertMjsDefault.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
}

},{"../jsutils/devAssert.mjs":"dIY2Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2INRG":[function(require,module,exports,__globalThis) {
// Produce the GraphQL query recommended for a full schema introspection.
// Accepts optional IntrospectionOptions.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntrospectionQuery", function() {
    return 0, _getIntrospectionQueryMjs.getIntrospectionQuery;
});
// Gets the target Operation from a Document.
parcelHelpers.export(exports, "getOperationAST", function() {
    return 0, _getOperationASTMjs.getOperationAST;
}) // Gets the Type for the target Operation AST.
;
parcelHelpers.export(exports, "getOperationRootType", function() {
    return 0, _getOperationRootTypeMjs.getOperationRootType;
}) // Convert a GraphQLSchema to an IntrospectionQuery.
;
parcelHelpers.export(exports, "introspectionFromSchema", function() {
    return 0, _introspectionFromSchemaMjs.introspectionFromSchema;
}) // Build a GraphQLSchema from an introspection result.
;
parcelHelpers.export(exports, "buildClientSchema", function() {
    return 0, _buildClientSchemaMjs.buildClientSchema;
}) // Build a GraphQLSchema from GraphQL Schema language.
;
parcelHelpers.export(exports, "buildASTSchema", function() {
    return 0, _buildASTSchemaMjs.buildASTSchema;
});
parcelHelpers.export(exports, "buildSchema", function() {
    return 0, _buildASTSchemaMjs.buildSchema;
});
// Extends an existing GraphQLSchema from a parsed GraphQL Schema language AST.
parcelHelpers.export(exports, "extendSchema", function() {
    return 0, _extendSchemaMjs.extendSchema;
}) // Sort a GraphQLSchema.
;
parcelHelpers.export(exports, "getDescription", function() {
    return 0, _extendSchemaMjs.getDescription;
});
parcelHelpers.export(exports, "lexicographicSortSchema", function() {
    return 0, _lexicographicSortSchemaMjs.lexicographicSortSchema;
}) // Print a GraphQLSchema to GraphQL Schema language.
;
parcelHelpers.export(exports, "printSchema", function() {
    return 0, _printSchemaMjs.printSchema;
}) // Create a GraphQLType from a GraphQL language AST.
;
parcelHelpers.export(exports, "printType", function() {
    return 0, _printSchemaMjs.printType;
});
parcelHelpers.export(exports, "printIntrospectionSchema", function() {
    return 0, _printSchemaMjs.printIntrospectionSchema;
});
parcelHelpers.export(exports, "typeFromAST", function() {
    return 0, _typeFromASTMjs.typeFromAST;
}) // Create a JavaScript value from a GraphQL language AST with a type.
;
parcelHelpers.export(exports, "valueFromAST", function() {
    return 0, _valueFromASTMjs.valueFromAST;
}) // Create a JavaScript value from a GraphQL language AST without a type.
;
parcelHelpers.export(exports, "valueFromASTUntyped", function() {
    return 0, _valueFromASTUntypedMjs.valueFromASTUntyped;
}) // Create a GraphQL language AST from a JavaScript value.
;
parcelHelpers.export(exports, "astFromValue", function() {
    return 0, _astFromValueMjs.astFromValue;
}) // A helper to use within recursive-descent visitors which need to be aware of
;
// the GraphQL type system.
parcelHelpers.export(exports, "TypeInfo", function() {
    return 0, _typeInfoMjs.TypeInfo;
}) // Coerces a JavaScript value to a GraphQL type, or produces errors.
;
parcelHelpers.export(exports, "visitWithTypeInfo", function() {
    return 0, _typeInfoMjs.visitWithTypeInfo;
});
parcelHelpers.export(exports, "coerceInputValue", function() {
    return 0, _coerceInputValueMjs.coerceInputValue;
}) // Concatenates multiple AST together.
;
parcelHelpers.export(exports, "concatAST", function() {
    return 0, _concatASTMjs.concatAST;
}) // Separates an AST into an AST per Operation.
;
parcelHelpers.export(exports, "separateOperations", function() {
    return 0, _separateOperationsMjs.separateOperations;
}) // Strips characters that are not significant to the validity or execution
;
// of a GraphQL document.
parcelHelpers.export(exports, "stripIgnoredCharacters", function() {
    return 0, _stripIgnoredCharactersMjs.stripIgnoredCharacters;
}) // Comparators for types
;
parcelHelpers.export(exports, "isEqualType", function() {
    return 0, _typeComparatorsMjs.isEqualType;
}) // Asserts that a string is a valid GraphQL name
;
parcelHelpers.export(exports, "isTypeSubTypeOf", function() {
    return 0, _typeComparatorsMjs.isTypeSubTypeOf;
});
parcelHelpers.export(exports, "doTypesOverlap", function() {
    return 0, _typeComparatorsMjs.doTypesOverlap;
});
parcelHelpers.export(exports, "assertValidName", function() {
    return 0, _assertValidNameMjs.assertValidName;
}) // Compares two GraphQLSchemas and detects breaking changes.
;
parcelHelpers.export(exports, "isValidNameError", function() {
    return 0, _assertValidNameMjs.isValidNameError;
});
parcelHelpers.export(exports, "BreakingChangeType", function() {
    return 0, _findBreakingChangesMjs.BreakingChangeType;
});
parcelHelpers.export(exports, "DangerousChangeType", function() {
    return 0, _findBreakingChangesMjs.DangerousChangeType;
});
parcelHelpers.export(exports, "findBreakingChanges", function() {
    return 0, _findBreakingChangesMjs.findBreakingChanges;
});
parcelHelpers.export(exports, "findDangerousChanges", function() {
    return 0, _findBreakingChangesMjs.findDangerousChanges;
});
// @deprecated: Report all deprecated usage within a GraphQL document.
parcelHelpers.export(exports, "findDeprecatedUsages", function() {
    return 0, _findDeprecatedUsagesMjs.findDeprecatedUsages;
});
var _getIntrospectionQueryMjs = require("./getIntrospectionQuery.mjs");
var _getOperationASTMjs = require("./getOperationAST.mjs");
var _getOperationRootTypeMjs = require("./getOperationRootType.mjs");
var _introspectionFromSchemaMjs = require("./introspectionFromSchema.mjs");
var _buildClientSchemaMjs = require("./buildClientSchema.mjs");
var _buildASTSchemaMjs = require("./buildASTSchema.mjs");
var _extendSchemaMjs = require("./extendSchema.mjs");
var _lexicographicSortSchemaMjs = require("./lexicographicSortSchema.mjs");
var _printSchemaMjs = require("./printSchema.mjs");
var _typeFromASTMjs = require("./typeFromAST.mjs");
var _valueFromASTMjs = require("./valueFromAST.mjs");
var _valueFromASTUntypedMjs = require("./valueFromASTUntyped.mjs");
var _astFromValueMjs = require("./astFromValue.mjs");
var _typeInfoMjs = require("./TypeInfo.mjs");
var _coerceInputValueMjs = require("./coerceInputValue.mjs");
var _concatASTMjs = require("./concatAST.mjs");
var _separateOperationsMjs = require("./separateOperations.mjs");
var _stripIgnoredCharactersMjs = require("./stripIgnoredCharacters.mjs");
var _typeComparatorsMjs = require("./typeComparators.mjs");
var _assertValidNameMjs = require("./assertValidName.mjs");
var _findBreakingChangesMjs = require("./findBreakingChanges.mjs");
var _findDeprecatedUsagesMjs = require("./findDeprecatedUsages.mjs");

},{"./getIntrospectionQuery.mjs":"2soKo","./getOperationAST.mjs":"4fIQ0","./getOperationRootType.mjs":"cFOlo","./introspectionFromSchema.mjs":"keRa9","./buildClientSchema.mjs":"dF1nb","./buildASTSchema.mjs":"3yfqY","./extendSchema.mjs":"2z0Ou","./lexicographicSortSchema.mjs":"3YVwi","./printSchema.mjs":"aJYt5","./typeFromAST.mjs":"2b0nl","./valueFromAST.mjs":"cxoyu","./valueFromASTUntyped.mjs":"iFTmE","./astFromValue.mjs":"iDso7","./TypeInfo.mjs":"ju2gk","./coerceInputValue.mjs":"cCJu2","./concatAST.mjs":"5LWWv","./separateOperations.mjs":"2rPRC","./stripIgnoredCharacters.mjs":"eVVwQ","./typeComparators.mjs":"fc5HZ","./assertValidName.mjs":"1lasf","./findBreakingChanges.mjs":"kJQKe","./findDeprecatedUsages.mjs":"8RUI2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2soKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntrospectionQuery", function() {
    return getIntrospectionQuery;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function getIntrospectionQuery(options) {
    var optionsWithDefault = _objectSpread({
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false
    }, options);
    var descriptions = optionsWithDefault.descriptions ? 'description' : '';
    var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
    var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
    var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : '';
    }
    return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4fIQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ parcelHelpers.export(exports, "getOperationAST", function() {
    return getOperationAST;
});
var _kindsMjs = require("../language/kinds.mjs");
function getOperationAST(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === (0, _kindsMjs.Kind).OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}

},{"../language/kinds.mjs":"ffJlp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"keRa9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */ parcelHelpers.export(exports, "introspectionFromSchema", function() {
    return introspectionFromSchema;
});
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _parserMjs = require("../language/parser.mjs");
var _executeMjs = require("../execution/execute.mjs");
var _getIntrospectionQueryMjs = require("./getIntrospectionQuery.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function introspectionFromSchema(schema, options) {
    var optionsWithDefaults = _objectSpread({
        specifiedByUrl: true,
        directiveIsRepeatable: true,
        schemaDescription: true,
        inputValueDeprecation: true
    }, options);
    var document = (0, _parserMjs.parse)((0, _getIntrospectionQueryMjs.getIntrospectionQuery)(optionsWithDefaults));
    var result = (0, _executeMjs.executeSync)({
        schema: schema,
        document: document
    });
    !result.errors && result.data || (0, _invariantMjsDefault.default)(0);
    return result.data;
}

},{"../jsutils/invariant.mjs":"agtax","../language/parser.mjs":"Q1jFp","../execution/execute.mjs":"e0yfk","./getIntrospectionQuery.mjs":"2soKo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dF1nb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */ parcelHelpers.export(exports, "buildClientSchema", function() {
    return buildClientSchema;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _keyValMapMjs = require("../jsutils/keyValMap.mjs");
var _keyValMapMjsDefault = parcelHelpers.interopDefault(_keyValMapMjs);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _parserMjs = require("../language/parser.mjs");
var _schemaMjs = require("../type/schema.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _scalarsMjs = require("../type/scalars.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _valueFromASTMjs = require("./valueFromAST.mjs");
function buildClientSchema(introspection, options) {
    (0, _isObjectLikeMjsDefault.default)(introspection) && (0, _isObjectLikeMjsDefault.default)(introspection.__schema) || (0, _devAssertMjsDefault.default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, _inspectMjsDefault.default)(introspection), ".")); // Get the schema from the introspection result.
    var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    var typeMap = (0, _keyValMapMjsDefault.default)(schemaIntrospection.types, function(typeIntrospection) {
        return typeIntrospection.name;
    }, function(typeIntrospection) {
        return buildType(typeIntrospection);
    }); // Include standard types only if they are used.
    for(var _i2 = 0, _ref2 = [].concat((0, _scalarsMjs.specifiedScalarTypes), (0, _introspectionMjs.introspectionTypes)); _i2 < _ref2.length; _i2++){
        var stdType = _ref2[_i2];
        if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
    } // Get the root Query, Mutation, and Subscription types.
    var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, _schemaMjs.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: (0, _objectValuesMjsDefault.default)(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, _introspectionMjs.TypeKind).LIST) {
            var itemRef = typeRef.ofType;
            if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
            return new (0, _definitionMjs.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, _introspectionMjs.TypeKind).NON_NULL) {
            var nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
            var nullableType = getType(nullableRef);
            return new (0, _definitionMjs.GraphQLNonNull)((0, _definitionMjs.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        var typeName = typeRef.name;
        if (!typeName) throw new Error("Unknown type reference: ".concat((0, _inspectMjsDefault.default)(typeRef), "."));
        var type = typeMap[typeName];
        if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
        return type;
    }
    function getObjectType(typeRef) {
        return (0, _definitionMjs.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, _definitionMjs.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        if (type != null && type.name != null && type.kind != null) switch(type.kind){
            case (0, _introspectionMjs.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, _introspectionMjs.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, _introspectionMjs.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, _introspectionMjs.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, _introspectionMjs.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, _introspectionMjs.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        var typeStr = (0, _inspectMjsDefault.default)(type);
        throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, _definitionMjs.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByUrl: scalarIntrospection.specifiedByUrl
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, _introspectionMjs.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            var implementingIntrospectionStr = (0, _inspectMjsDefault.default)(implementingIntrospection);
            throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, _definitionMjs.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(objectIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(objectIntrospection);
            }
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, _definitionMjs.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(interfaceIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(interfaceIntrospection);
            }
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            var unionIntrospectionStr = (0, _inspectMjsDefault.default)(unionIntrospection);
            throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
        }
        return new (0, _definitionMjs.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: function types() {
                return unionIntrospection.possibleTypes.map(getObjectType);
            }
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            var enumIntrospectionStr = (0, _inspectMjsDefault.default)(enumIntrospection);
            throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
        }
        return new (0, _definitionMjs.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, _keyValMapMjsDefault.default)(enumIntrospection.enumValues, function(valueIntrospection) {
                return valueIntrospection.name;
            }, function(valueIntrospection) {
                return {
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                };
            })
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            var inputObjectIntrospectionStr = (0, _inspectMjsDefault.default)(inputObjectIntrospection);
            throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
        }
        return new (0, _definitionMjs.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: function fields() {
                return buildInputValueDefMap(inputObjectIntrospection.inputFields);
            }
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, _inspectMjsDefault.default)(typeIntrospection), "."));
        return (0, _keyValMapMjsDefault.default)(typeIntrospection.fields, function(fieldIntrospection) {
            return fieldIntrospection.name;
        }, buildField);
    }
    function buildField(fieldIntrospection) {
        var type = getType(fieldIntrospection.type);
        if (!(0, _definitionMjs.isOutputType)(type)) {
            var typeStr = (0, _inspectMjsDefault.default)(type);
            throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
        }
        if (!fieldIntrospection.args) {
            var fieldIntrospectionStr = (0, _inspectMjsDefault.default)(fieldIntrospection);
            throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, _keyValMapMjsDefault.default)(inputValueIntrospections, function(inputValue) {
            return inputValue.name;
        }, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        var type = getType(inputValueIntrospection.type);
        if (!(0, _definitionMjs.isInputType)(type)) {
            var typeStr = (0, _inspectMjsDefault.default)(type);
            throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
        }
        var defaultValue = inputValueIntrospection.defaultValue != null ? (0, _valueFromASTMjs.valueFromAST)((0, _parserMjs.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            var directiveIntrospectionStr = (0, _inspectMjsDefault.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
        }
        if (!directiveIntrospection.locations) {
            var _directiveIntrospectionStr = (0, _inspectMjsDefault.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
        }
        return new (0, _directivesMjs.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/devAssert.mjs":"dIY2Y","../jsutils/keyValMap.mjs":"6DAN9","../jsutils/isObjectLike.mjs":"ji7lb","../language/parser.mjs":"Q1jFp","../type/schema.mjs":"gzZTY","../type/directives.mjs":"k3NFN","../type/scalars.mjs":"5S8Ww","../type/introspection.mjs":"fg0io","../type/definition.mjs":"hN98Z","./valueFromAST.mjs":"cxoyu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3yfqY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query
 * and Mutation.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */ parcelHelpers.export(exports, "buildASTSchema", function() {
    return buildASTSchema;
});
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */ parcelHelpers.export(exports, "buildSchema", function() {
    return buildSchema;
});
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _parserMjs = require("../language/parser.mjs");
var _validateMjs = require("../validation/validate.mjs");
var _schemaMjs = require("../type/schema.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _extendSchemaMjs = require("./extendSchema.mjs");
function buildASTSchema(documentAST, options) {
    documentAST != null && documentAST.kind === (0, _kindsMjs.Kind).DOCUMENT || (0, _devAssertMjsDefault.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, _validateMjs.assertValidSDL)(documentAST);
    var emptySchemaConfig = {
        description: undefined,
        types: [],
        directives: [],
        extensions: undefined,
        extensionASTNodes: [],
        assumeValid: false
    };
    var config = (0, _extendSchemaMjs.extendSchemaImpl)(emptySchemaConfig, documentAST, options);
    if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
        var type = _config$types2[_i2];
        switch(type.name){
            // Note: While this could make early assertions to get the correctly
            // typed values below, that would throw immediately while type system
            // validation with validateSchema() will produce more actionable results.
            case 'Query':
                config.query = type;
                break;
            case 'Mutation':
                config.mutation = type;
                break;
            case 'Subscription':
                config.subscription = type;
                break;
        }
    }
    var directives = config.directives; // If specified directives were not explicitly declared, add them.
    var _loop = function _loop(_i4) {
        var stdDirective = (0, _directivesMjs.specifiedDirectives)[_i4];
        if (directives.every(function(directive) {
            return directive.name !== stdDirective.name;
        })) directives.push(stdDirective);
    };
    for(var _i4 = 0; _i4 < (0, _directivesMjs.specifiedDirectives).length; _i4++)_loop(_i4);
    return new (0, _schemaMjs.GraphQLSchema)(config);
}
function buildSchema(source, options) {
    var document = (0, _parserMjs.parse)(source, {
        noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
        allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
        allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
        experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
    });
    return buildASTSchema(document, {
        commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
        assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    });
}

},{"../jsutils/devAssert.mjs":"dIY2Y","../language/kinds.mjs":"ffJlp","../language/parser.mjs":"Q1jFp","../validation/validate.mjs":"OZYxA","../type/schema.mjs":"gzZTY","../type/directives.mjs":"k3NFN","./extendSchema.mjs":"2z0Ou","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2z0Ou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 *
 * Accepts options as a third argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */ parcelHelpers.export(exports, "extendSchema", function() {
    return extendSchema;
});
/**
 * @internal
 */ parcelHelpers.export(exports, "extendSchemaImpl", function() {
    return extendSchemaImpl;
});
/**
 * Given an ast node, returns its string description.
 * @deprecated: provided to ease adoption and will be removed in v16.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */ parcelHelpers.export(exports, "getDescription", function() {
    return getDescription;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _keyMapMjs = require("../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _mapValueMjs = require("../jsutils/mapValue.mjs");
var _mapValueMjsDefault = parcelHelpers.interopDefault(_mapValueMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _kindsMjs = require("../language/kinds.mjs");
var _tokenKindMjs = require("../language/tokenKind.mjs");
var _blockStringMjs = require("../language/blockString.mjs");
var _predicatesMjs = require("../language/predicates.mjs");
var _validateMjs = require("../validation/validate.mjs");
var _valuesMjs = require("../execution/values.mjs");
var _schemaMjs = require("../type/schema.mjs");
var _scalarsMjs = require("../type/scalars.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _valueFromASTMjs = require("./valueFromAST.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function extendSchema(schema, documentAST, options) {
    (0, _schemaMjs.assertSchema)(schema);
    documentAST != null && documentAST.kind === (0, _kindsMjs.Kind).DOCUMENT || (0, _devAssertMjsDefault.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, _validateMjs.assertValidSDLExtension)(documentAST, schema);
    var schemaConfig = schema.toConfig();
    var extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
    return schemaConfig === extendedConfig ? schema : new (0, _schemaMjs.GraphQLSchema)(extendedConfig);
}
function extendSchemaImpl(schemaConfig, documentAST, options) {
    var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
    // Collect the type definitions and extensions found in the document.
    var typeDefs = [];
    var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
    // have the same name. For example, a type named "skip".
    var directiveDefs = [];
    var schemaDef; // Schema extensions are collected which may add additional operation types.
    var schemaExtensions = [];
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var def = _documentAST$definiti2[_i2];
        if (def.kind === (0, _kindsMjs.Kind).SCHEMA_DEFINITION) schemaDef = def;
        else if (def.kind === (0, _kindsMjs.Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
        else if ((0, _predicatesMjs.isTypeDefinitionNode)(def)) typeDefs.push(def);
        else if ((0, _predicatesMjs.isTypeExtensionNode)(def)) {
            var extendedTypeName = def.name.value;
            var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
            typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                def
            ]) : [
                def
            ];
        } else if (def.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
    } // If this document contains no new types, extensions, or directives then
    // return the same unmodified GraphQLSchema instance.
    if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
    var typeMap = Object.create(null);
    for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
        var existingType = _schemaConfig$types2[_i4];
        typeMap[existingType.name] = extendNamedType(existingType);
    }
    for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
        var _stdTypeMap$name;
        var typeNode = typeDefs[_i6];
        var name = typeNode.name.value;
        typeMap[name] = (_stdTypeMap$name = stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
    }
    var operationTypes = _objectSpread(_objectSpread({
        // Get the extended root operation types.
        query: schemaConfig.query && replaceNamedType(schemaConfig.query),
        mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
        subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
    }, schemaDef && getOperationTypes([
        schemaDef
    ])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.
    return _objectSpread(_objectSpread({
        description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
    }, operationTypes), {}, {
        types: (0, _objectValuesMjsDefault.default)(typeMap),
        directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
        extensions: undefined,
        astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
        extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
        assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
    }); // Below are functions used for producing this schema that have closed over
    // this scope and have access to the schema, cache, and newly defined types.
    function replaceType(type) {
        if ((0, _definitionMjs.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, _definitionMjs.GraphQLList)(replaceType(type.ofType));
        if ((0, _definitionMjs.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, _definitionMjs.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return typeMap[type.name];
    }
    function replaceDirective(directive) {
        var config = directive.toConfig();
        return new (0, _directivesMjs.GraphQLDirective)(_objectSpread(_objectSpread({}, config), {}, {
            args: (0, _mapValueMjsDefault.default)(config.args, extendArg)
        }));
    }
    function extendNamedType(type) {
        if ((0, _introspectionMjs.isIntrospectionType)(type) || (0, _scalarsMjs.isSpecifiedScalarType)(type)) // Builtin types are not extended.
        return type;
        if ((0, _definitionMjs.isScalarType)(type)) return extendScalarType(type);
        if ((0, _definitionMjs.isObjectType)(type)) return extendObjectType(type);
        if ((0, _definitionMjs.isInterfaceType)(type)) return extendInterfaceType(type);
        if ((0, _definitionMjs.isUnionType)(type)) return extendUnionType(type);
        if ((0, _definitionMjs.isEnumType)(type)) return extendEnumType(type);
         // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, _definitionMjs.isInputObjectType)(type)) return extendInputObjectType(type);
         // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, _invariantMjsDefault.default)(0, 'Unexpected type: ' + (0, _inspectMjsDefault.default)(type));
    }
    function extendInputObjectType(type) {
        var _typeExtensionsMap$co;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
        return new (0, _definitionMjs.GraphQLInputObjectType)(_objectSpread(_objectSpread({}, config), {}, {
            fields: function fields() {
                return _objectSpread(_objectSpread({}, (0, _mapValueMjsDefault.default)(config.fields, function(field) {
                    return _objectSpread(_objectSpread({}, field), {}, {
                        type: replaceType(field.type)
                    });
                })), buildInputFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendEnumType(type) {
        var _typeExtensionsMap$ty;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
        return new (0, _definitionMjs.GraphQLEnumType)(_objectSpread(_objectSpread({}, config), {}, {
            values: _objectSpread(_objectSpread({}, config.values), buildEnumValueMap(extensions)),
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendScalarType(type) {
        var _typeExtensionsMap$co2;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
        var specifiedByUrl = config.specifiedByUrl;
        for(var _i8 = 0; _i8 < extensions.length; _i8++){
            var _getSpecifiedByUrl;
            var extensionNode = extensions[_i8];
            specifiedByUrl = (_getSpecifiedByUrl = getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
        }
        return new (0, _definitionMjs.GraphQLScalarType)(_objectSpread(_objectSpread({}, config), {}, {
            specifiedByUrl: specifiedByUrl,
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendObjectType(type) {
        var _typeExtensionsMap$co3;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
        return new (0, _definitionMjs.GraphQLObjectType)(_objectSpread(_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return _objectSpread(_objectSpread({}, (0, _mapValueMjsDefault.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendInterfaceType(type) {
        var _typeExtensionsMap$co4;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
        return new (0, _definitionMjs.GraphQLInterfaceType)(_objectSpread(_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return _objectSpread(_objectSpread({}, (0, _mapValueMjsDefault.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendUnionType(type) {
        var _typeExtensionsMap$co5;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
        return new (0, _definitionMjs.GraphQLUnionType)(_objectSpread(_objectSpread({}, config), {}, {
            types: function types() {
                return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendField(field) {
        return _objectSpread(_objectSpread({}, field), {}, {
            type: replaceType(field.type),
            // $FlowFixMe[incompatible-call]
            args: (0, _mapValueMjsDefault.default)(field.args, extendArg)
        });
    }
    function extendArg(arg) {
        return _objectSpread(_objectSpread({}, arg), {}, {
            type: replaceType(arg.type)
        });
    }
    function getOperationTypes(nodes) {
        var opTypes = {};
        for(var _i10 = 0; _i10 < nodes.length; _i10++){
            var _node$operationTypes;
            var node = nodes[_i10];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                var operationType = operationTypesNodes[_i12];
                opTypes[operationType.operation] = getNamedType(operationType.type);
            }
        } // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return opTypes;
    }
    function getNamedType(node) {
        var _stdTypeMap$name2;
        var name = node.name.value;
        var type = (_stdTypeMap$name2 = stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
        if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
        return type;
    }
    function getWrappedType(node) {
        if (node.kind === (0, _kindsMjs.Kind).LIST_TYPE) return new (0, _definitionMjs.GraphQLList)(getWrappedType(node.type));
        if (node.kind === (0, _kindsMjs.Kind).NON_NULL_TYPE) return new (0, _definitionMjs.GraphQLNonNull)(getWrappedType(node.type));
        return getNamedType(node);
    }
    function buildDirective(node) {
        var locations = node.locations.map(function(_ref) {
            var value = _ref.value;
            return value;
        });
        return new (0, _directivesMjs.GraphQLDirective)({
            name: node.name.value,
            description: getDescription(node, options),
            locations: locations,
            isRepeatable: node.repeatable,
            args: buildArgumentMap(node.arguments),
            astNode: node
        });
    }
    function buildFieldMap(nodes) {
        var fieldConfigMap = Object.create(null);
        for(var _i14 = 0; _i14 < nodes.length; _i14++){
            var _node$fields;
            var node = nodes[_i14];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                var field = nodeFields[_i16];
                fieldConfigMap[field.name.value] = {
                    // Note: While this could make assertions to get the correctly typed
                    // value, that would throw immediately while type system validation
                    // with validateSchema() will produce more actionable results.
                    type: getWrappedType(field.type),
                    description: getDescription(field, options),
                    args: buildArgumentMap(field.arguments),
                    deprecationReason: getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return fieldConfigMap;
    }
    function buildArgumentMap(args) {
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var argsNodes = args !== null && args !== void 0 ? args : [];
        var argConfigMap = Object.create(null);
        for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
            var arg = argsNodes[_i18];
            // Note: While this could make assertions to get the correctly typed
            // value, that would throw immediately while type system validation
            // with validateSchema() will produce more actionable results.
            var type = getWrappedType(arg.type);
            argConfigMap[arg.name.value] = {
                type: type,
                description: getDescription(arg, options),
                defaultValue: (0, _valueFromASTMjs.valueFromAST)(arg.defaultValue, type),
                deprecationReason: getDeprecationReason(arg),
                astNode: arg
            };
        }
        return argConfigMap;
    }
    function buildInputFieldMap(nodes) {
        var inputFieldMap = Object.create(null);
        for(var _i20 = 0; _i20 < nodes.length; _i20++){
            var _node$fields2;
            var node = nodes[_i20];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
            for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                var field = fieldsNodes[_i22];
                // Note: While this could make assertions to get the correctly typed
                // value, that would throw immediately while type system validation
                // with validateSchema() will produce more actionable results.
                var type = getWrappedType(field.type);
                inputFieldMap[field.name.value] = {
                    type: type,
                    description: getDescription(field, options),
                    defaultValue: (0, _valueFromASTMjs.valueFromAST)(field.defaultValue, type),
                    deprecationReason: getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return inputFieldMap;
    }
    function buildEnumValueMap(nodes) {
        var enumValueMap = Object.create(null);
        for(var _i24 = 0; _i24 < nodes.length; _i24++){
            var _node$values;
            var node = nodes[_i24];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                var value = valuesNodes[_i26];
                enumValueMap[value.name.value] = {
                    description: getDescription(value, options),
                    deprecationReason: getDeprecationReason(value),
                    astNode: value
                };
            }
        }
        return enumValueMap;
    }
    function buildInterfaces(nodes) {
        var interfaces = [];
        for(var _i28 = 0; _i28 < nodes.length; _i28++){
            var _node$interfaces;
            var node = nodes[_i28];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
            for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                var type = interfacesNodes[_i30];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                interfaces.push(getNamedType(type));
            }
        }
        return interfaces;
    }
    function buildUnionTypes(nodes) {
        var types = [];
        for(var _i32 = 0; _i32 < nodes.length; _i32++){
            var _node$types;
            var node = nodes[_i32];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
            for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                var type = typeNodes[_i34];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                types.push(getNamedType(type));
            }
        }
        return types;
    }
    function buildType(astNode) {
        var _typeExtensionsMap$na;
        var name = astNode.name.value;
        var description = getDescription(astNode, options);
        var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
        switch(astNode.kind){
            case (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION:
                var extensionASTNodes = extensionNodes;
                var allNodes = [
                    astNode
                ].concat(extensionASTNodes);
                return new (0, _definitionMjs.GraphQLObjectType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: extensionASTNodes
                });
            case (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION:
                var _extensionASTNodes = extensionNodes;
                var _allNodes = [
                    astNode
                ].concat(_extensionASTNodes);
                return new (0, _definitionMjs.GraphQLInterfaceType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(_allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(_allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes
                });
            case (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION:
                var _extensionASTNodes2 = extensionNodes;
                var _allNodes2 = [
                    astNode
                ].concat(_extensionASTNodes2);
                return new (0, _definitionMjs.GraphQLEnumType)({
                    name: name,
                    description: description,
                    values: buildEnumValueMap(_allNodes2),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes2
                });
            case (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION:
                var _extensionASTNodes3 = extensionNodes;
                var _allNodes3 = [
                    astNode
                ].concat(_extensionASTNodes3);
                return new (0, _definitionMjs.GraphQLUnionType)({
                    name: name,
                    description: description,
                    types: function types() {
                        return buildUnionTypes(_allNodes3);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes3
                });
            case (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION:
                var _extensionASTNodes4 = extensionNodes;
                return new (0, _definitionMjs.GraphQLScalarType)({
                    name: name,
                    description: description,
                    specifiedByUrl: getSpecifiedByUrl(astNode),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes4
                });
            case (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION:
                var _extensionASTNodes5 = extensionNodes;
                var _allNodes4 = [
                    astNode
                ].concat(_extensionASTNodes5);
                return new (0, _definitionMjs.GraphQLInputObjectType)({
                    name: name,
                    description: description,
                    fields: function fields() {
                        return buildInputFieldMap(_allNodes4);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes5
                });
        } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)
        (0, _invariantMjsDefault.default)(0, 'Unexpected type definition node: ' + (0, _inspectMjsDefault.default)(astNode));
    }
}
var stdTypeMap = (0, _keyMapMjsDefault.default)((0, _scalarsMjs.specifiedScalarTypes).concat((0, _introspectionMjs.introspectionTypes)), function(type) {
    return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */ function getDeprecationReason(node) {
    var deprecated = (0, _valuesMjs.getDirectiveValues)((0, _directivesMjs.GraphQLDeprecatedDirective), node);
    return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */ function getSpecifiedByUrl(node) {
    var specifiedBy = (0, _valuesMjs.getDirectiveValues)((0, _directivesMjs.GraphQLSpecifiedByDirective), node);
    return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
function getDescription(node, options) {
    if (node.description) return node.description.value;
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
        var rawValue = getLeadingCommentBlock(node);
        if (rawValue !== undefined) return (0, _blockStringMjs.dedentBlockStringValue)('\n' + rawValue);
    }
}
function getLeadingCommentBlock(node) {
    var loc = node.loc;
    if (!loc) return;
    var comments = [];
    var token = loc.startToken.prev;
    while(token != null && token.kind === (0, _tokenKindMjs.TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
        var value = String(token.value);
        comments.push(value);
        token = token.prev;
    }
    return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/keyMap.mjs":"aZdAt","../jsutils/inspect.mjs":"4vyEo","../jsutils/mapValue.mjs":"190m2","../jsutils/invariant.mjs":"agtax","../jsutils/devAssert.mjs":"dIY2Y","../language/kinds.mjs":"ffJlp","../language/tokenKind.mjs":"2TYsC","../language/blockString.mjs":"Ye6Ih","../language/predicates.mjs":"iXXFP","../validation/validate.mjs":"OZYxA","../execution/values.mjs":"cjyw1","../type/schema.mjs":"gzZTY","../type/scalars.mjs":"5S8Ww","../type/introspection.mjs":"fg0io","../type/directives.mjs":"k3NFN","../type/definition.mjs":"hN98Z","./valueFromAST.mjs":"cxoyu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3YVwi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sort GraphQLSchema.
 *
 * This function returns a sorted copy of the given GraphQLSchema.
 */ parcelHelpers.export(exports, "lexicographicSortSchema", function() {
    return lexicographicSortSchema;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _keyValMapMjs = require("../jsutils/keyValMap.mjs");
var _keyValMapMjsDefault = parcelHelpers.interopDefault(_keyValMapMjs);
var _naturalCompareMjs = require("../jsutils/naturalCompare.mjs");
var _naturalCompareMjsDefault = parcelHelpers.interopDefault(_naturalCompareMjs);
var _schemaMjs = require("../type/schema.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _definitionMjs = require("../type/definition.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function lexicographicSortSchema(schema) {
    var schemaConfig = schema.toConfig();
    var typeMap = (0, _keyValMapMjsDefault.default)(sortByName(schemaConfig.types), function(type) {
        return type.name;
    }, sortNamedType);
    return new (0, _schemaMjs.GraphQLSchema)(_objectSpread(_objectSpread({}, schemaConfig), {}, {
        types: (0, _objectValuesMjsDefault.default)(typeMap),
        directives: sortByName(schemaConfig.directives).map(sortDirective),
        query: replaceMaybeType(schemaConfig.query),
        mutation: replaceMaybeType(schemaConfig.mutation),
        subscription: replaceMaybeType(schemaConfig.subscription)
    }));
    function replaceType(type) {
        if ((0, _definitionMjs.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, _definitionMjs.GraphQLList)(replaceType(type.ofType));
        else if ((0, _definitionMjs.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, _definitionMjs.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        return typeMap[type.name];
    }
    function replaceMaybeType(maybeType) {
        return maybeType && replaceNamedType(maybeType);
    }
    function sortDirective(directive) {
        var config = directive.toConfig();
        return new (0, _directivesMjs.GraphQLDirective)(_objectSpread(_objectSpread({}, config), {}, {
            locations: sortBy(config.locations, function(x) {
                return x;
            }),
            args: sortArgs(config.args)
        }));
    }
    function sortArgs(args) {
        return sortObjMap(args, function(arg) {
            return _objectSpread(_objectSpread({}, arg), {}, {
                type: replaceType(arg.type)
            });
        });
    }
    function sortFields(fieldsMap) {
        return sortObjMap(fieldsMap, function(field) {
            return _objectSpread(_objectSpread({}, field), {}, {
                type: replaceType(field.type),
                args: sortArgs(field.args)
            });
        });
    }
    function sortInputFields(fieldsMap) {
        return sortObjMap(fieldsMap, function(field) {
            return _objectSpread(_objectSpread({}, field), {}, {
                type: replaceType(field.type)
            });
        });
    }
    function sortTypes(arr) {
        return sortByName(arr).map(replaceNamedType);
    }
    function sortNamedType(type) {
        if ((0, _definitionMjs.isScalarType)(type) || (0, _introspectionMjs.isIntrospectionType)(type)) return type;
        if ((0, _definitionMjs.isObjectType)(type)) {
            var config = type.toConfig();
            return new (0, _definitionMjs.GraphQLObjectType)(_objectSpread(_objectSpread({}, config), {}, {
                interfaces: function interfaces() {
                    return sortTypes(config.interfaces);
                },
                fields: function fields() {
                    return sortFields(config.fields);
                }
            }));
        }
        if ((0, _definitionMjs.isInterfaceType)(type)) {
            var _config = type.toConfig();
            return new (0, _definitionMjs.GraphQLInterfaceType)(_objectSpread(_objectSpread({}, _config), {}, {
                interfaces: function interfaces() {
                    return sortTypes(_config.interfaces);
                },
                fields: function fields() {
                    return sortFields(_config.fields);
                }
            }));
        }
        if ((0, _definitionMjs.isUnionType)(type)) {
            var _config2 = type.toConfig();
            return new (0, _definitionMjs.GraphQLUnionType)(_objectSpread(_objectSpread({}, _config2), {}, {
                types: function types() {
                    return sortTypes(_config2.types);
                }
            }));
        }
        if ((0, _definitionMjs.isEnumType)(type)) {
            var _config3 = type.toConfig();
            return new (0, _definitionMjs.GraphQLEnumType)(_objectSpread(_objectSpread({}, _config3), {}, {
                values: sortObjMap(_config3.values)
            }));
        } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, _definitionMjs.isInputObjectType)(type)) {
            var _config4 = type.toConfig();
            return new (0, _definitionMjs.GraphQLInputObjectType)(_objectSpread(_objectSpread({}, _config4), {}, {
                fields: function fields() {
                    return sortInputFields(_config4.fields);
                }
            }));
        } // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, _invariantMjsDefault.default)(0, 'Unexpected type: ' + (0, _inspectMjsDefault.default)(type));
    }
}
function sortObjMap(map, sortValueFn) {
    var sortedMap = Object.create(null);
    var sortedKeys = sortBy(Object.keys(map), function(x) {
        return x;
    });
    for(var _i2 = 0; _i2 < sortedKeys.length; _i2++){
        var key = sortedKeys[_i2];
        var value = map[key];
        sortedMap[key] = sortValueFn ? sortValueFn(value) : value;
    }
    return sortedMap;
}
function sortByName(array) {
    return sortBy(array, function(obj) {
        return obj.name;
    });
}
function sortBy(array, mapToKey) {
    return array.slice().sort(function(obj1, obj2) {
        var key1 = mapToKey(obj1);
        var key2 = mapToKey(obj2);
        return (0, _naturalCompareMjsDefault.default)(key1, key2);
    });
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../jsutils/keyValMap.mjs":"6DAN9","../jsutils/naturalCompare.mjs":"gukLP","../type/schema.mjs":"gzZTY","../type/directives.mjs":"k3NFN","../type/introspection.mjs":"fg0io","../type/definition.mjs":"hN98Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aJYt5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */ parcelHelpers.export(exports, "printSchema", function() {
    return printSchema;
});
parcelHelpers.export(exports, "printIntrospectionSchema", function() {
    return printIntrospectionSchema;
});
parcelHelpers.export(exports, "printType", function() {
    return printType;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _printerMjs = require("../language/printer.mjs");
var _blockStringMjs = require("../language/blockString.mjs");
var _introspectionMjs = require("../type/introspection.mjs");
var _scalarsMjs = require("../type/scalars.mjs");
var _directivesMjs = require("../type/directives.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _astFromValueMjs = require("./astFromValue.mjs");
function printSchema(schema, options) {
    return printFilteredSchema(schema, function(n) {
        return !(0, _directivesMjs.isSpecifiedDirective)(n);
    }, isDefinedType, options);
}
function printIntrospectionSchema(schema, options) {
    return printFilteredSchema(schema, (0, _directivesMjs.isSpecifiedDirective), (0, _introspectionMjs.isIntrospectionType), options);
}
function isDefinedType(type) {
    return !(0, _scalarsMjs.isSpecifiedScalarType)(type) && !(0, _introspectionMjs.isIntrospectionType)(type);
}
function printFilteredSchema(schema, directiveFilter, typeFilter, options) {
    var directives = schema.getDirectives().filter(directiveFilter);
    var types = (0, _objectValuesMjsDefault.default)(schema.getTypeMap()).filter(typeFilter);
    return [
        printSchemaDefinition(schema)
    ].concat(directives.map(function(directive) {
        return printDirective(directive, options);
    }), types.map(function(type) {
        return printType(type, options);
    })).filter(Boolean).join('\n\n') + '\n';
}
function printSchemaDefinition(schema) {
    if (schema.description == null && isSchemaOfCommonNames(schema)) return;
    var operationTypes = [];
    var queryType = schema.getQueryType();
    if (queryType) operationTypes.push("  query: ".concat(queryType.name));
    var mutationType = schema.getMutationType();
    if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
    return printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */ function isSchemaOfCommonNames(schema) {
    var queryType = schema.getQueryType();
    if (queryType && queryType.name !== 'Query') return false;
    var mutationType = schema.getMutationType();
    if (mutationType && mutationType.name !== 'Mutation') return false;
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
    return true;
}
function printType(type, options) {
    if ((0, _definitionMjs.isScalarType)(type)) return printScalar(type, options);
    if ((0, _definitionMjs.isObjectType)(type)) return printObject(type, options);
    if ((0, _definitionMjs.isInterfaceType)(type)) return printInterface(type, options);
    if ((0, _definitionMjs.isUnionType)(type)) return printUnion(type, options);
    if ((0, _definitionMjs.isEnumType)(type)) return printEnum(type, options);
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isInputObjectType)(type)) return printInputObject(type, options);
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected type: ' + (0, _inspectMjsDefault.default)(type));
}
function printScalar(type, options) {
    return printDescription(options, type) + "scalar ".concat(type.name) + printSpecifiedByUrl(type);
}
function printImplementedInterfaces(type) {
    var interfaces = type.getInterfaces();
    return interfaces.length ? ' implements ' + interfaces.map(function(i) {
        return i.name;
    }).join(' & ') : '';
}
function printObject(type, options) {
    return printDescription(options, type) + "type ".concat(type.name) + printImplementedInterfaces(type) + printFields(options, type);
}
function printInterface(type, options) {
    return printDescription(options, type) + "interface ".concat(type.name) + printImplementedInterfaces(type) + printFields(options, type);
}
function printUnion(type, options) {
    var types = type.getTypes();
    var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
    return printDescription(options, type) + 'union ' + type.name + possibleTypes;
}
function printEnum(type, options) {
    var values = type.getValues().map(function(value, i) {
        return printDescription(options, value, '  ', !i) + '  ' + value.name + printDeprecated(value.deprecationReason);
    });
    return printDescription(options, type) + "enum ".concat(type.name) + printBlock(values);
}
function printInputObject(type, options) {
    var fields = (0, _objectValuesMjsDefault.default)(type.getFields()).map(function(f, i) {
        return printDescription(options, f, '  ', !i) + '  ' + printInputValue(f);
    });
    return printDescription(options, type) + "input ".concat(type.name) + printBlock(fields);
}
function printFields(options, type) {
    var fields = (0, _objectValuesMjsDefault.default)(type.getFields()).map(function(f, i) {
        return printDescription(options, f, '  ', !i) + '  ' + f.name + printArgs(options, f.args, '  ') + ': ' + String(f.type) + printDeprecated(f.deprecationReason);
    });
    return printBlock(fields);
}
function printBlock(items) {
    return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}
function printArgs(options, args) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (args.length === 0) return '';
     // If every arg does not have a description, print them on one line.
    if (args.every(function(arg) {
        return !arg.description;
    })) return '(' + args.map(printInputValue).join(', ') + ')';
    return '(\n' + args.map(function(arg, i) {
        return printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
    }).join('\n') + '\n' + indentation + ')';
}
function printInputValue(arg) {
    var defaultAST = (0, _astFromValueMjs.astFromValue)(arg.defaultValue, arg.type);
    var argDecl = arg.name + ': ' + String(arg.type);
    if (defaultAST) argDecl += " = ".concat((0, _printerMjs.print)(defaultAST));
    return argDecl + printDeprecated(arg.deprecationReason);
}
function printDirective(directive, options) {
    return printDescription(options, directive) + 'directive @' + directive.name + printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}
function printDeprecated(reason) {
    if (reason == null) return '';
    var reasonAST = (0, _astFromValueMjs.astFromValue)(reason, (0, _scalarsMjs.GraphQLString));
    if (reasonAST && reason !== (0, _directivesMjs.DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, _printerMjs.print)(reasonAST) + ')';
    return ' @deprecated';
}
function printSpecifiedByUrl(scalar) {
    if (scalar.specifiedByUrl == null) return '';
    var url = scalar.specifiedByUrl;
    var urlAST = (0, _astFromValueMjs.astFromValue)(url, (0, _scalarsMjs.GraphQLString));
    urlAST || (0, _invariantMjsDefault.default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
    return ' @specifiedBy(url: ' + (0, _printerMjs.print)(urlAST) + ')';
}
function printDescription(options, def) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var description = def.description;
    if (description == null) return '';
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return printDescriptionWithComments(description, indentation, firstInBlock);
    var preferMultipleLines = description.length > 70;
    var blockString = (0, _blockStringMjs.printBlockString)(description, '', preferMultipleLines);
    var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
    return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}
function printDescriptionWithComments(description, indentation, firstInBlock) {
    var prefix = indentation && !firstInBlock ? '\n' : '';
    var comment = description.split('\n').map(function(line) {
        return indentation + (line !== '' ? '# ' + line : '#');
    }).join('\n');
    return prefix + comment + '\n';
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../language/printer.mjs":"dA3NC","../language/blockString.mjs":"Ye6Ih","../type/introspection.mjs":"fg0io","../type/scalars.mjs":"5S8Ww","../type/directives.mjs":"k3NFN","../type/definition.mjs":"hN98Z","./astFromValue.mjs":"iDso7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5LWWv":[function(require,module,exports,__globalThis) {
/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAST", function() {
    return concatAST;
});
function concatAST(documents) {
    var definitions = [];
    for(var _i2 = 0; _i2 < documents.length; _i2++){
        var doc = documents[_i2];
        definitions = definitions.concat(doc.definitions);
    }
    return {
        kind: 'Document',
        definitions: definitions
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2rPRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */ parcelHelpers.export(exports, "separateOperations", function() {
    return separateOperations;
});
var _kindsMjs = require("../language/kinds.mjs");
var _visitorMjs = require("../language/visitor.mjs");
function separateOperations(documentAST) {
    var operations = [];
    var depGraph = Object.create(null); // Populate metadata and build a dependency graph.
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definitionNode = _documentAST$definiti2[_i2];
        switch(definitionNode.kind){
            case (0, _kindsMjs.Kind).OPERATION_DEFINITION:
                operations.push(definitionNode);
                break;
            case (0, _kindsMjs.Kind).FRAGMENT_DEFINITION:
                depGraph[definitionNode.name.value] = collectDependencies(definitionNode.selectionSet);
                break;
        }
    } // For each operation, produce a new synthesized AST which includes only what
    // is necessary for completing that operation.
    var separatedDocumentASTs = Object.create(null);
    var _loop = function _loop(_i4) {
        var operation = operations[_i4];
        var dependencies = new Set();
        for(var _i6 = 0, _collectDependencies2 = collectDependencies(operation.selectionSet); _i6 < _collectDependencies2.length; _i6++){
            var fragmentName = _collectDependencies2[_i6];
            collectTransitiveDependencies(dependencies, depGraph, fragmentName);
        } // Provides the empty string for anonymous operations.
        var operationName = operation.name ? operation.name.value : ''; // The list of definition nodes to be included for this operation, sorted
        // to retain the same order as the original document.
        separatedDocumentASTs[operationName] = {
            kind: (0, _kindsMjs.Kind).DOCUMENT,
            definitions: documentAST.definitions.filter(function(node) {
                return node === operation || node.kind === (0, _kindsMjs.Kind).FRAGMENT_DEFINITION && dependencies.has(node.name.value);
            })
        };
    };
    for(var _i4 = 0; _i4 < operations.length; _i4++)_loop(_i4);
    return separatedDocumentASTs;
}
// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
    if (!collected.has(fromName)) {
        collected.add(fromName);
        var immediateDeps = depGraph[fromName];
        if (immediateDeps !== undefined) for(var _i8 = 0; _i8 < immediateDeps.length; _i8++){
            var toName = immediateDeps[_i8];
            collectTransitiveDependencies(collected, depGraph, toName);
        }
    }
}
function collectDependencies(selectionSet) {
    var dependencies = [];
    (0, _visitorMjs.visit)(selectionSet, {
        FragmentSpread: function FragmentSpread(node) {
            dependencies.push(node.name.value);
        }
    });
    return dependencies;
}

},{"../language/kinds.mjs":"ffJlp","../language/visitor.mjs":"aHQOA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eVVwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Strips characters that are not significant to the validity or execution
 * of a GraphQL document:
 *   - UnicodeBOM
 *   - WhiteSpace
 *   - LineTerminator
 *   - Comment
 *   - Comma
 *   - BlockString indentation
 *
 * Note: It is required to have a delimiter character between neighboring
 * non-punctuator tokens and this function always uses single space as delimiter.
 *
 * It is guaranteed that both input and output documents if parsed would result
 * in the exact same AST except for nodes location.
 *
 * Warning: It is guaranteed that this function will always produce stable results.
 * However, it's not guaranteed that it will stay the same between different
 * releases due to bugfixes or changes in the GraphQL specification.
 *
 * Query example:
 *
 * query SomeQuery($foo: String!, $bar: String) {
 *   someField(foo: $foo, bar: $bar) {
 *     a
 *     b {
 *       c
 *       d
 *     }
 *   }
 * }
 *
 * Becomes:
 *
 * query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
 *
 * SDL example:
 *
 * """
 * Type description
 * """
 * type Foo {
 *   """
 *   Field description
 *   """
 *   bar: String
 * }
 *
 * Becomes:
 *
 * """Type description""" type Foo{"""Field description""" bar:String}
 */ parcelHelpers.export(exports, "stripIgnoredCharacters", function() {
    return stripIgnoredCharacters;
});
var _sourceMjs = require("../language/source.mjs");
var _tokenKindMjs = require("../language/tokenKind.mjs");
var _lexerMjs = require("../language/lexer.mjs");
var _blockStringMjs = require("../language/blockString.mjs");
function stripIgnoredCharacters(source) {
    var sourceObj = (0, _sourceMjs.isSource)(source) ? source : new (0, _sourceMjs.Source)(source);
    var body = sourceObj.body;
    var lexer = new (0, _lexerMjs.Lexer)(sourceObj);
    var strippedBody = '';
    var wasLastAddedTokenNonPunctuator = false;
    while(lexer.advance().kind !== (0, _tokenKindMjs.TokenKind).EOF){
        var currentToken = lexer.token;
        var tokenKind = currentToken.kind;
        /**
     * Every two non-punctuator tokens should have space between them.
     * Also prevent case of non-punctuator token following by spread resulting
     * in invalid token (e.g. `1...` is invalid Float token).
     */ var isNonPunctuator = !(0, _lexerMjs.isPunctuatorTokenKind)(currentToken.kind);
        if (wasLastAddedTokenNonPunctuator) {
            if (isNonPunctuator || currentToken.kind === (0, _tokenKindMjs.TokenKind).SPREAD) strippedBody += ' ';
        }
        var tokenBody = body.slice(currentToken.start, currentToken.end);
        if (tokenKind === (0, _tokenKindMjs.TokenKind).BLOCK_STRING) strippedBody += dedentBlockString(tokenBody);
        else strippedBody += tokenBody;
        wasLastAddedTokenNonPunctuator = isNonPunctuator;
    }
    return strippedBody;
}
function dedentBlockString(blockStr) {
    // skip leading and trailing triple quotations
    var rawStr = blockStr.slice(3, -3);
    var body = (0, _blockStringMjs.dedentBlockStringValue)(rawStr);
    if ((0, _blockStringMjs.getBlockStringIndentation)(body) > 0) body = '\n' + body;
    var lastChar = body[body.length - 1];
    var hasTrailingQuote = lastChar === '"' && body.slice(-4) !== '\\"""';
    if (hasTrailingQuote || lastChar === '\\') body += '\n';
    return '"""' + body + '"""';
}

},{"../language/source.mjs":"llYv9","../language/tokenKind.mjs":"2TYsC","../language/lexer.mjs":"6UkL9","../language/blockString.mjs":"Ye6Ih","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kJQKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreakingChangeType", function() {
    return BreakingChangeType;
});
parcelHelpers.export(exports, "DangerousChangeType", function() {
    return DangerousChangeType;
});
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */ parcelHelpers.export(exports, "findBreakingChanges", function() {
    return findBreakingChanges;
});
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */ parcelHelpers.export(exports, "findDangerousChanges", function() {
    return findDangerousChanges;
});
var _objectValuesMjs = require("../polyfills/objectValues.mjs");
var _objectValuesMjsDefault = parcelHelpers.interopDefault(_objectValuesMjs);
var _keyMapMjs = require("../jsutils/keyMap.mjs");
var _keyMapMjsDefault = parcelHelpers.interopDefault(_keyMapMjs);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _invariantMjs = require("../jsutils/invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _naturalCompareMjs = require("../jsutils/naturalCompare.mjs");
var _naturalCompareMjsDefault = parcelHelpers.interopDefault(_naturalCompareMjs);
var _printerMjs = require("../language/printer.mjs");
var _visitorMjs = require("../language/visitor.mjs");
var _scalarsMjs = require("../type/scalars.mjs");
var _definitionMjs = require("../type/definition.mjs");
var _astFromValueMjs = require("./astFromValue.mjs");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var BreakingChangeType = Object.freeze({
    TYPE_REMOVED: 'TYPE_REMOVED',
    TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
    TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
    VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
    REQUIRED_INPUT_FIELD_ADDED: 'REQUIRED_INPUT_FIELD_ADDED',
    IMPLEMENTED_INTERFACE_REMOVED: 'IMPLEMENTED_INTERFACE_REMOVED',
    FIELD_REMOVED: 'FIELD_REMOVED',
    FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
    REQUIRED_ARG_ADDED: 'REQUIRED_ARG_ADDED',
    ARG_REMOVED: 'ARG_REMOVED',
    ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
    DIRECTIVE_REMOVED: 'DIRECTIVE_REMOVED',
    DIRECTIVE_ARG_REMOVED: 'DIRECTIVE_ARG_REMOVED',
    REQUIRED_DIRECTIVE_ARG_ADDED: 'REQUIRED_DIRECTIVE_ARG_ADDED',
    DIRECTIVE_REPEATABLE_REMOVED: 'DIRECTIVE_REPEATABLE_REMOVED',
    DIRECTIVE_LOCATION_REMOVED: 'DIRECTIVE_LOCATION_REMOVED'
});
var DangerousChangeType = Object.freeze({
    VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
    TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION',
    OPTIONAL_INPUT_FIELD_ADDED: 'OPTIONAL_INPUT_FIELD_ADDED',
    OPTIONAL_ARG_ADDED: 'OPTIONAL_ARG_ADDED',
    IMPLEMENTED_INTERFACE_ADDED: 'IMPLEMENTED_INTERFACE_ADDED',
    ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE'
});
function findBreakingChanges(oldSchema, newSchema) {
    var breakingChanges = findSchemaChanges(oldSchema, newSchema).filter(function(change) {
        return change.type in BreakingChangeType;
    });
    return breakingChanges;
}
function findDangerousChanges(oldSchema, newSchema) {
    var dangerousChanges = findSchemaChanges(oldSchema, newSchema).filter(function(change) {
        return change.type in DangerousChangeType;
    });
    return dangerousChanges;
}
function findSchemaChanges(oldSchema, newSchema) {
    return [].concat(findTypeChanges(oldSchema, newSchema), findDirectiveChanges(oldSchema, newSchema));
}
function findDirectiveChanges(oldSchema, newSchema) {
    var schemaChanges = [];
    var directivesDiff = diff(oldSchema.getDirectives(), newSchema.getDirectives());
    for(var _i2 = 0, _directivesDiff$remov2 = directivesDiff.removed; _i2 < _directivesDiff$remov2.length; _i2++){
        var oldDirective = _directivesDiff$remov2[_i2];
        schemaChanges.push({
            type: BreakingChangeType.DIRECTIVE_REMOVED,
            description: "".concat(oldDirective.name, " was removed.")
        });
    }
    for(var _i4 = 0, _directivesDiff$persi2 = directivesDiff.persisted; _i4 < _directivesDiff$persi2.length; _i4++){
        var _ref2 = _directivesDiff$persi2[_i4];
        var _oldDirective = _ref2[0];
        var newDirective = _ref2[1];
        var argsDiff = diff(_oldDirective.args, newDirective.args);
        for(var _i6 = 0, _argsDiff$added2 = argsDiff.added; _i6 < _argsDiff$added2.length; _i6++){
            var newArg = _argsDiff$added2[_i6];
            if ((0, _definitionMjs.isRequiredArgument)(newArg)) schemaChanges.push({
                type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
                description: "A required arg ".concat(newArg.name, " on directive ").concat(_oldDirective.name, " was added.")
            });
        }
        for(var _i8 = 0, _argsDiff$removed2 = argsDiff.removed; _i8 < _argsDiff$removed2.length; _i8++){
            var oldArg = _argsDiff$removed2[_i8];
            schemaChanges.push({
                type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
                description: "".concat(oldArg.name, " was removed from ").concat(_oldDirective.name, ".")
            });
        }
        if (_oldDirective.isRepeatable && !newDirective.isRepeatable) schemaChanges.push({
            type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
            description: "Repeatable flag was removed from ".concat(_oldDirective.name, ".")
        });
        for(var _i10 = 0, _oldDirective$locatio2 = _oldDirective.locations; _i10 < _oldDirective$locatio2.length; _i10++){
            var location = _oldDirective$locatio2[_i10];
            if (newDirective.locations.indexOf(location) === -1) schemaChanges.push({
                type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
                description: "".concat(location, " was removed from ").concat(_oldDirective.name, ".")
            });
        }
    }
    return schemaChanges;
}
function findTypeChanges(oldSchema, newSchema) {
    var schemaChanges = [];
    var typesDiff = diff((0, _objectValuesMjsDefault.default)(oldSchema.getTypeMap()), (0, _objectValuesMjsDefault.default)(newSchema.getTypeMap()));
    for(var _i12 = 0, _typesDiff$removed2 = typesDiff.removed; _i12 < _typesDiff$removed2.length; _i12++){
        var oldType = _typesDiff$removed2[_i12];
        schemaChanges.push({
            type: BreakingChangeType.TYPE_REMOVED,
            description: (0, _scalarsMjs.isSpecifiedScalarType)(oldType) ? "Standard scalar ".concat(oldType.name, " was removed because it is not referenced anymore.") : "".concat(oldType.name, " was removed.")
        });
    }
    for(var _i14 = 0, _typesDiff$persisted2 = typesDiff.persisted; _i14 < _typesDiff$persisted2.length; _i14++){
        var _ref4 = _typesDiff$persisted2[_i14];
        var _oldType = _ref4[0];
        var newType = _ref4[1];
        if ((0, _definitionMjs.isEnumType)(_oldType) && (0, _definitionMjs.isEnumType)(newType)) schemaChanges.push.apply(schemaChanges, findEnumTypeChanges(_oldType, newType));
        else if ((0, _definitionMjs.isUnionType)(_oldType) && (0, _definitionMjs.isUnionType)(newType)) schemaChanges.push.apply(schemaChanges, findUnionTypeChanges(_oldType, newType));
        else if ((0, _definitionMjs.isInputObjectType)(_oldType) && (0, _definitionMjs.isInputObjectType)(newType)) schemaChanges.push.apply(schemaChanges, findInputObjectTypeChanges(_oldType, newType));
        else if ((0, _definitionMjs.isObjectType)(_oldType) && (0, _definitionMjs.isObjectType)(newType)) schemaChanges.push.apply(schemaChanges, findFieldChanges(_oldType, newType).concat(findImplementedInterfacesChanges(_oldType, newType)));
        else if ((0, _definitionMjs.isInterfaceType)(_oldType) && (0, _definitionMjs.isInterfaceType)(newType)) schemaChanges.push.apply(schemaChanges, findFieldChanges(_oldType, newType).concat(findImplementedInterfacesChanges(_oldType, newType)));
        else if (_oldType.constructor !== newType.constructor) schemaChanges.push({
            type: BreakingChangeType.TYPE_CHANGED_KIND,
            description: "".concat(_oldType.name, " changed from ") + "".concat(typeKindName(_oldType), " to ").concat(typeKindName(newType), ".")
        });
    }
    return schemaChanges;
}
function findInputObjectTypeChanges(oldType, newType) {
    var schemaChanges = [];
    var fieldsDiff = diff((0, _objectValuesMjsDefault.default)(oldType.getFields()), (0, _objectValuesMjsDefault.default)(newType.getFields()));
    for(var _i16 = 0, _fieldsDiff$added2 = fieldsDiff.added; _i16 < _fieldsDiff$added2.length; _i16++){
        var newField = _fieldsDiff$added2[_i16];
        if ((0, _definitionMjs.isRequiredInputField)(newField)) schemaChanges.push({
            type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
            description: "A required field ".concat(newField.name, " on input type ").concat(oldType.name, " was added.")
        });
        else schemaChanges.push({
            type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
            description: "An optional field ".concat(newField.name, " on input type ").concat(oldType.name, " was added.")
        });
    }
    for(var _i18 = 0, _fieldsDiff$removed2 = fieldsDiff.removed; _i18 < _fieldsDiff$removed2.length; _i18++){
        var oldField = _fieldsDiff$removed2[_i18];
        schemaChanges.push({
            type: BreakingChangeType.FIELD_REMOVED,
            description: "".concat(oldType.name, ".").concat(oldField.name, " was removed.")
        });
    }
    for(var _i20 = 0, _fieldsDiff$persisted2 = fieldsDiff.persisted; _i20 < _fieldsDiff$persisted2.length; _i20++){
        var _ref6 = _fieldsDiff$persisted2[_i20];
        var _oldField = _ref6[0];
        var _newField = _ref6[1];
        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(_oldField.type, _newField.type);
        if (!isSafe) schemaChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: "".concat(oldType.name, ".").concat(_oldField.name, " changed type from ") + "".concat(String(_oldField.type), " to ").concat(String(_newField.type), ".")
        });
    }
    return schemaChanges;
}
function findUnionTypeChanges(oldType, newType) {
    var schemaChanges = [];
    var possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());
    for(var _i22 = 0, _possibleTypesDiff$ad2 = possibleTypesDiff.added; _i22 < _possibleTypesDiff$ad2.length; _i22++){
        var newPossibleType = _possibleTypesDiff$ad2[_i22];
        schemaChanges.push({
            type: DangerousChangeType.TYPE_ADDED_TO_UNION,
            description: "".concat(newPossibleType.name, " was added to union type ").concat(oldType.name, ".")
        });
    }
    for(var _i24 = 0, _possibleTypesDiff$re2 = possibleTypesDiff.removed; _i24 < _possibleTypesDiff$re2.length; _i24++){
        var oldPossibleType = _possibleTypesDiff$re2[_i24];
        schemaChanges.push({
            type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
            description: "".concat(oldPossibleType.name, " was removed from union type ").concat(oldType.name, ".")
        });
    }
    return schemaChanges;
}
function findEnumTypeChanges(oldType, newType) {
    var schemaChanges = [];
    var valuesDiff = diff(oldType.getValues(), newType.getValues());
    for(var _i26 = 0, _valuesDiff$added2 = valuesDiff.added; _i26 < _valuesDiff$added2.length; _i26++){
        var newValue = _valuesDiff$added2[_i26];
        schemaChanges.push({
            type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
            description: "".concat(newValue.name, " was added to enum type ").concat(oldType.name, ".")
        });
    }
    for(var _i28 = 0, _valuesDiff$removed2 = valuesDiff.removed; _i28 < _valuesDiff$removed2.length; _i28++){
        var oldValue = _valuesDiff$removed2[_i28];
        schemaChanges.push({
            type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
            description: "".concat(oldValue.name, " was removed from enum type ").concat(oldType.name, ".")
        });
    }
    return schemaChanges;
}
function findImplementedInterfacesChanges(oldType, newType) {
    var schemaChanges = [];
    var interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());
    for(var _i30 = 0, _interfacesDiff$added2 = interfacesDiff.added; _i30 < _interfacesDiff$added2.length; _i30++){
        var newInterface = _interfacesDiff$added2[_i30];
        schemaChanges.push({
            type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
            description: "".concat(newInterface.name, " added to interfaces implemented by ").concat(oldType.name, ".")
        });
    }
    for(var _i32 = 0, _interfacesDiff$remov2 = interfacesDiff.removed; _i32 < _interfacesDiff$remov2.length; _i32++){
        var oldInterface = _interfacesDiff$remov2[_i32];
        schemaChanges.push({
            type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
            description: "".concat(oldType.name, " no longer implements interface ").concat(oldInterface.name, ".")
        });
    }
    return schemaChanges;
}
function findFieldChanges(oldType, newType) {
    var schemaChanges = [];
    var fieldsDiff = diff((0, _objectValuesMjsDefault.default)(oldType.getFields()), (0, _objectValuesMjsDefault.default)(newType.getFields()));
    for(var _i34 = 0, _fieldsDiff$removed4 = fieldsDiff.removed; _i34 < _fieldsDiff$removed4.length; _i34++){
        var oldField = _fieldsDiff$removed4[_i34];
        schemaChanges.push({
            type: BreakingChangeType.FIELD_REMOVED,
            description: "".concat(oldType.name, ".").concat(oldField.name, " was removed.")
        });
    }
    for(var _i36 = 0, _fieldsDiff$persisted4 = fieldsDiff.persisted; _i36 < _fieldsDiff$persisted4.length; _i36++){
        var _ref8 = _fieldsDiff$persisted4[_i36];
        var _oldField2 = _ref8[0];
        var newField = _ref8[1];
        schemaChanges.push.apply(schemaChanges, findArgChanges(oldType, _oldField2, newField));
        var isSafe = isChangeSafeForObjectOrInterfaceField(_oldField2.type, newField.type);
        if (!isSafe) schemaChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: "".concat(oldType.name, ".").concat(_oldField2.name, " changed type from ") + "".concat(String(_oldField2.type), " to ").concat(String(newField.type), ".")
        });
    }
    return schemaChanges;
}
function findArgChanges(oldType, oldField, newField) {
    var schemaChanges = [];
    var argsDiff = diff(oldField.args, newField.args);
    for(var _i38 = 0, _argsDiff$removed4 = argsDiff.removed; _i38 < _argsDiff$removed4.length; _i38++){
        var oldArg = _argsDiff$removed4[_i38];
        schemaChanges.push({
            type: BreakingChangeType.ARG_REMOVED,
            description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(oldArg.name, " was removed.")
        });
    }
    for(var _i40 = 0, _argsDiff$persisted2 = argsDiff.persisted; _i40 < _argsDiff$persisted2.length; _i40++){
        var _ref10 = _argsDiff$persisted2[_i40];
        var _oldArg = _ref10[0];
        var newArg = _ref10[1];
        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(_oldArg.type, newArg.type);
        if (!isSafe) schemaChanges.push({
            type: BreakingChangeType.ARG_CHANGED_KIND,
            description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " has changed type from ") + "".concat(String(_oldArg.type), " to ").concat(String(newArg.type), ".")
        });
        else if (_oldArg.defaultValue !== undefined) {
            if (newArg.defaultValue === undefined) schemaChanges.push({
                type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
                description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " defaultValue was removed.")
            });
            else {
                // Since we looking only for client's observable changes we should
                // compare default values in the same representation as they are
                // represented inside introspection.
                var oldValueStr = stringifyValue(_oldArg.defaultValue, _oldArg.type);
                var newValueStr = stringifyValue(newArg.defaultValue, newArg.type);
                if (oldValueStr !== newValueStr) schemaChanges.push({
                    type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
                    description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " has changed defaultValue from ").concat(oldValueStr, " to ").concat(newValueStr, ".")
                });
            }
        }
    }
    for(var _i42 = 0, _argsDiff$added4 = argsDiff.added; _i42 < _argsDiff$added4.length; _i42++){
        var _newArg = _argsDiff$added4[_i42];
        if ((0, _definitionMjs.isRequiredArgument)(_newArg)) schemaChanges.push({
            type: BreakingChangeType.REQUIRED_ARG_ADDED,
            description: "A required arg ".concat(_newArg.name, " on ").concat(oldType.name, ".").concat(oldField.name, " was added.")
        });
        else schemaChanges.push({
            type: DangerousChangeType.OPTIONAL_ARG_ADDED,
            description: "An optional arg ".concat(_newArg.name, " on ").concat(oldType.name, ".").concat(oldField.name, " was added.")
        });
    }
    return schemaChanges;
}
function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
    if ((0, _definitionMjs.isListType)(oldType)) return (0, _definitionMjs.isListType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) || // moving from nullable to non-null of the same underlying type is safe
    (0, _definitionMjs.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType);
    if ((0, _definitionMjs.isNonNullType)(oldType)) // if they're both non-null, make sure the underlying types are compatible
    return (0, _definitionMjs.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
    return (0, _definitionMjs.isNamedType)(newType) && oldType.name === newType.name || // moving from nullable to non-null of the same underlying type is safe
    (0, _definitionMjs.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType);
}
function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
    if ((0, _definitionMjs.isListType)(oldType)) // if they're both lists, make sure the underlying types are compatible
    return (0, _definitionMjs.isListType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
    if ((0, _definitionMjs.isNonNullType)(oldType)) return(// compatible
    (0, _definitionMjs.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) || // moving from non-null to nullable of the same underlying type is safe
    !(0, _definitionMjs.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType));
     // if they're both named types, see if their names are equivalent
    return (0, _definitionMjs.isNamedType)(newType) && oldType.name === newType.name;
}
function typeKindName(type) {
    if ((0, _definitionMjs.isScalarType)(type)) return 'a Scalar type';
    if ((0, _definitionMjs.isObjectType)(type)) return 'an Object type';
    if ((0, _definitionMjs.isInterfaceType)(type)) return 'an Interface type';
    if ((0, _definitionMjs.isUnionType)(type)) return 'a Union type';
    if ((0, _definitionMjs.isEnumType)(type)) return 'an Enum type';
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, _definitionMjs.isInputObjectType)(type)) return 'an Input type';
     // istanbul ignore next (Not reachable. All possible named types have been considered)
    (0, _invariantMjsDefault.default)(0, 'Unexpected type: ' + (0, _inspectMjsDefault.default)(type));
}
function stringifyValue(value, type) {
    var ast = (0, _astFromValueMjs.astFromValue)(value, type);
    ast != null || (0, _invariantMjsDefault.default)(0);
    var sortedAST = (0, _visitorMjs.visit)(ast, {
        ObjectValue: function ObjectValue(objectNode) {
            // Make a copy since sort mutates array
            var fields = [].concat(objectNode.fields);
            fields.sort(function(fieldA, fieldB) {
                return (0, _naturalCompareMjsDefault.default)(fieldA.name.value, fieldB.name.value);
            });
            return _objectSpread(_objectSpread({}, objectNode), {}, {
                fields: fields
            });
        }
    });
    return (0, _printerMjs.print)(sortedAST);
}
function diff(oldArray, newArray) {
    var added = [];
    var removed = [];
    var persisted = [];
    var oldMap = (0, _keyMapMjsDefault.default)(oldArray, function(_ref11) {
        var name = _ref11.name;
        return name;
    });
    var newMap = (0, _keyMapMjsDefault.default)(newArray, function(_ref12) {
        var name = _ref12.name;
        return name;
    });
    for(var _i44 = 0; _i44 < oldArray.length; _i44++){
        var oldItem = oldArray[_i44];
        var newItem = newMap[oldItem.name];
        if (newItem === undefined) removed.push(oldItem);
        else persisted.push([
            oldItem,
            newItem
        ]);
    }
    for(var _i46 = 0; _i46 < newArray.length; _i46++){
        var _newItem = newArray[_i46];
        if (oldMap[_newItem.name] === undefined) added.push(_newItem);
    }
    return {
        added: added,
        persisted: persisted,
        removed: removed
    };
}

},{"../polyfills/objectValues.mjs":"9Pvqa","../jsutils/keyMap.mjs":"aZdAt","../jsutils/inspect.mjs":"4vyEo","../jsutils/invariant.mjs":"agtax","../jsutils/naturalCompare.mjs":"gukLP","../language/printer.mjs":"dA3NC","../language/visitor.mjs":"aHQOA","../type/scalars.mjs":"5S8Ww","../type/definition.mjs":"hN98Z","./astFromValue.mjs":"iDso7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8RUI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A validation rule which reports deprecated usages.
 *
 * Returns a list of GraphQLError instances describing each deprecated use.
 *
 * @deprecated Please use `validate` with `NoDeprecatedCustomRule` instead:
 *
 * ```
 * import { validate, NoDeprecatedCustomRule } from 'graphql'
 *
 * const errors = validate(schema, document, [NoDeprecatedCustomRule])
 * ```
 */ parcelHelpers.export(exports, "findDeprecatedUsages", function() {
    return findDeprecatedUsages;
});
var _validateMjs = require("../validation/validate.mjs");
var _noDeprecatedCustomRuleMjs = require("../validation/rules/custom/NoDeprecatedCustomRule.mjs");
function findDeprecatedUsages(schema, ast) {
    return (0, _validateMjs.validate)(schema, ast, [
        (0, _noDeprecatedCustomRuleMjs.NoDeprecatedCustomRule)
    ]);
}

},{"../validation/validate.mjs":"OZYxA","../validation/rules/custom/NoDeprecatedCustomRule.mjs":"ePWID","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KMnX":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSub", function() {
    return 0, _internalPubSub.InternalPubSub;
});
parcelHelpers.export(exports, "InternalPubSubClass", function() {
    return 0, _internalPubSub.InternalPubSubClass;
});
var _internalPubSub = require("./InternalPubSub");

},{"./InternalPubSub":"6yQcq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6yQcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSubClass", function() {
    return InternalPubSubClass;
});
parcelHelpers.export(exports, "InternalPubSub", function() {
    return InternalPubSub;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _providers = require("../Providers");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)('PubSub');
var InternalPubSubClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function InternalPubSubClass(options) {
        this._options = options !== null && options !== void 0 ? options : {};
        logger.debug('PubSub Options', this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(InternalPubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function get() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, _providers.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    InternalPubSubClass.prototype.getModuleName = function() {
        return 'InternalPubSub';
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ InternalPubSubClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        logger.debug('configure PubSub', {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ InternalPubSubClass.prototype.addPluggable = function(pluggable) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var config;
            return (0, _tslib.__generator)(this, function(_a) {
                if (pluggable && pluggable.getCategory() === 'PubSub') {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * remove plugin from PubSub category
     * @param providerName - the name of the plugin
     */ InternalPubSubClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
    };
    InternalPubSubClass.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    InternalPubSubClass.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + String(providerName));
        return [
            provider
        ];
    };
    InternalPubSubClass.prototype.publish = function(topics, msg, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    InternalPubSubClass.prototype.subscribe = function(topics, options, customUserAgentDetails) {
        if (isNode && this._options && this._options.ssr) throw new Error('Subscriptions are not supported for Server-Side Rendering (SSR)');
        logger.debug('subscribe options', options);
        var providers = this.getProviders(options);
        var pubSubUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).PubSub,
            action: (0, _core.PubSubAction).Subscribe
        }, customUserAgentDetails);
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options, pubSubUserAgentDetails)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function next(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function error(_error) {
                        return observer.error({
                            provider: provider,
                            error: _error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return InternalPubSubClass;
}();
var InternalPubSub = new InternalPubSubClass();
(0, _core.Amplify).register(InternalPubSub);

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","../Providers":"5uOZ2","zen-observable-ts":"57mma","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cUWSL":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5uOZ2":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", function() {
    return 0, _pubSubProvider.AbstractPubSubProvider;
});
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", function() {
    return 0, _awsappSyncRealTimeProvider.AWSAppSyncRealTimeProvider;
});
parcelHelpers.export(exports, "AWSIoTProvider", function() {
    return 0, _awsiotProvider.AWSIoTProvider;
});
parcelHelpers.export(exports, "MqttOverWSProvider", function() {
    return 0, _mqttOverWSProvider.MqttOverWSProvider;
});
parcelHelpers.export(exports, "mqttTopicMatch", function() {
    return 0, _mqttOverWSProvider.mqttTopicMatch;
});
var _pubSubProvider = require("./PubSubProvider");
var _awsappSyncRealTimeProvider = require("./AWSAppSyncRealTimeProvider");
var _awsiotProvider = require("./AWSIotProvider");
var _mqttOverWSProvider = require("./MqttOverWSProvider");

},{"./PubSubProvider":false,"./AWSAppSyncRealTimeProvider":"dF0zQ","./AWSIotProvider":false,"./MqttOverWSProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNpQm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", function() {
    return AbstractPubSubProvider;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('AbstractPubSubProvider');
var AbstractPubSubProvider = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, config), this._config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return 'PubSub';
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function get() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dF0zQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", function() {
    return AWSAppSyncRealTimeProvider;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _graphql = require("graphql");
var _url = require("url");
var _uuid = require("uuid");
var _buffer = require("buffer");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _auth = require("@aws-amplify/auth");
var _pubSubProvider = require("../PubSubProvider");
var _pubSub = require("../../types/PubSub");
var _constants = require("../constants");
var _connectionStateMonitor = require("../../utils/ConnectionStateMonitor");
var _reconnectionMonitor = require("../../utils/ReconnectionMonitor");
var logger = new (0, _core.Logger)('AWSAppSyncRealTimeProvider');
var dispatchApiEvent = function dispatchApiEvent(event, data, message) {
    (0, _core.Hub).dispatch('api', {
        event: event,
        data: data,
        message: message
    }, 'PubSub', (0, _constants.AMPLIFY_SYMBOL));
};
/**
 * @returns base64url-encoded string - https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ var base64urlEncode = function base64urlEncode(str) {
    var base64Str = (0, _buffer.Buffer).from(str).toString('base64');
    var base64UrlStr = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return base64UrlStr;
};
var standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
var customDomainPath = '/realtime';
var AWSAppSyncRealTimeProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        _this.keepAliveTimeout = (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT);
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.connectionStateMonitor = new (0, _connectionStateMonitor.ConnectionStateMonitor)();
        _this.reconnectionMonitor = new (0, _reconnectionMonitor.ReconnectionMonitor)();
        // Monitor the connection state and pass changes along to Hub
        _this.connectionStateMonitorSubscription = _this.connectionStateMonitor.connectionStateObservable.subscribe(function(connectionState) {
            dispatchApiEvent((0, _constants.CONNECTION_STATE_CHANGE), {
                provider: _this,
                connectionState: connectionState
            }, "Connection state is " + connectionState);
            _this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, _pubSub.ConnectionState).ConnectionDisrupted) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            //   ConnectionDisrupted or Connecting
            if ([
                (0, _pubSub.ConnectionState).Connected,
                (0, _pubSub.ConnectionState).ConnectedPendingDisconnect,
                (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive,
                (0, _pubSub.ConnectionState).ConnectedPendingNetwork,
                (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork,
                (0, _pubSub.ConnectionState).Disconnected
            ].includes(connectionState)) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).HALT_RECONNECT);
        });
        return _this;
    }
    /**
     * Mark the socket closed and release all active listeners
     */ AWSAppSyncRealTimeProvider.prototype.close = function() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
    };
    AWSAppSyncRealTimeProvider.prototype.getNewWebSocket = function(url, protocol) {
        return new WebSocket(url, protocol);
    };
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return 'AWSAppSyncRealTimeProvider';
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error('Not used here');
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                throw new Error('Operation not supported');
            });
        });
    };
    // Check if url matches standard domain pattern
    AWSAppSyncRealTimeProvider.prototype.isCustomDomain = function(url) {
        return url.match(standardDomainPattern) === null;
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options, customUserAgentDetails) {
        var _this = this;
        var appSyncGraphqlEndpoint = options === null || options === void 0 ? void 0 : options.appSyncGraphqlEndpoint;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            if (!options || !appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionStartActive_1 = false;
                var subscriptionId_1 = (0, _uuid.v4)();
                var startSubscription_1 = function startSubscription_1() {
                    if (!subscriptionStartActive_1) {
                        subscriptionStartActive_1 = true;
                        var startSubscriptionPromise = _this._startSubscriptionWithAWSAppSyncRealTime({
                            options: options,
                            observer: observer,
                            subscriptionId: subscriptionId_1,
                            customUserAgentDetails: customUserAgentDetails
                        }).catch(function(err) {
                            logger.debug((0, _pubSub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err);
                            _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
                        });
                        startSubscriptionPromise.finally(function() {
                            subscriptionStartActive_1 = false;
                        });
                    }
                };
                var reconnectSubscription_1;
                // Add an observable to the reconnection list to manage reconnection for this subscription
                reconnectSubscription_1 = new (0, _zenObservableTsDefault.default)(function(observer) {
                    _this.reconnectionMonitor.addObserver(observer);
                }).subscribe(function() {
                    startSubscription_1();
                });
                startSubscription_1();
                return function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    // Cleanup reconnection subscription
                                    reconnectSubscription_1 === null || reconnectSubscription_1 === void 0 || reconnectSubscription_1.unsubscribe();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        3,
                                        4,
                                        5
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 2:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error('Subscription never connected');
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 3:
                                    err_1 = _a.sent();
                                    logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function get() {
            return !this.options['aws_appsync_dangerously_connect_to_http_endpoint_for_testing'];
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId, customUserAgentDetails = _a.customUserAgentDetails;
        var _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _c, graphql_headers, _d, additionalHeaders, subscriptionState, data, dataString, headerObj, _e, _f, subscriptionMessage, stringToAWSRealTime, err_2, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _c = options.graphql_headers, graphql_headers = _c === void 0 ? function graphql_headers() {
                            return {};
                        } : _c, _d = options.additionalHeaders, additionalHeaders = _d === void 0 ? {} : _d;
                        subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query !== null && query !== void 0 ? query : '',
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: undefined
                        });
                        dataString = JSON.stringify(data);
                        _e = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: '',
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 1:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _e.concat([
                                _j.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _f.concat([
                                    _j.sent()
                                ])),
                                additionalHeaders
                            ]),
                            (_h = {}, _h[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _h)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: (0, _tslib.__assign)({}, headerObj)
                                }
                            },
                            type: (0, _constants.MESSAGE_TYPES).GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).OPENING_CONNECTION);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 4:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _j.sent();
                        this._logStartSubscriptionError(subscriptionId, observer, err_2);
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _g = (_b = this.subscriptionObserverMap.get(subscriptionId)) !== null && _b !== void 0 ? _b : {}, subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            query: query !== null && query !== void 0 ? query : '',
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, (0, _constants.START_ACK_TIMEOUT))
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Log logic for start subscription failures
    AWSAppSyncRealTimeProvider.prototype._logStartSubscriptionError = function(subscriptionId, observer, err) {
        var _a;
        logger.debug({
            err: err
        });
        var message = String((_a = err.message) !== null && _a !== void 0 ? _a : '');
        // Resolving to give the state observer time to propogate the update
        Promise.resolve(this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED));
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, _core.isNonRetryableError)(err)) observer.error({
                errors: [
                    (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message))
                ]
            });
            else logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message);
            var subscriptionFailedCallback = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === 'function') subscriptionFailedCallback();
        }
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var subscriptionObserver, subscriptionState;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
                if (subscriptionObserver) {
                    subscriptionState = subscriptionObserver.subscriptionState;
                    // This in case unsubscribe is invoked before sending start subscription message
                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).PENDING) return [
                        2 /*return*/ ,
                        new Promise(function(res, rej) {
                            var observer = subscriptionObserver.observer, subscriptionState = subscriptionObserver.subscriptionState, variables = subscriptionObserver.variables, query = subscriptionObserver.query;
                            _this.subscriptionObserverMap.set(subscriptionId, {
                                observer: observer,
                                subscriptionState: subscriptionState,
                                variables: variables,
                                query: query,
                                subscriptionReadyCallback: res,
                                subscriptionFailedCallback: rej
                            });
                        })
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, _constants.SOCKET_STATUS).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: (0, _constants.MESSAGE_TYPES).GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            logger.debug('closing WebSocket...');
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        var _this = this;
        if (typeof message.data !== 'string') return;
        logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(String(message.data)), _b = _a.id, id = _b === void 0 ? '' : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? '' : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, _constants.MESSAGE_TYPES).GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_START_ACK) {
            logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === 'function') subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            dispatchApiEvent((0, _pubSub.CONTROL_MSG).SUBSCRIPTION_ACK, {
                query: query,
                variables: variables
            }, 'Connection established for subscription');
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_KEEP_ALIVE) {
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            this.keepAliveTimeoutId = setTimeout(function() {
                return _this._errorDisconnect((0, _pubSub.CONTROL_MSG).TIMEOUT_DISCONNECT);
            }, this.keepAliveTimeout);
            this.keepAliveAlertTimeoutId = setTimeout(function() {
                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE_MISSED);
            }, (0, _constants.DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT));
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_ERROR) {
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload));
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload)))
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === 'function') subscriptionFailedCallback();
            }
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        logger.debug("Disconnect error: " + msg);
        if (this.awsRealTimeSocket) {
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            var observer = subscriptionObserver.observer, query = subscriptionObserver.query, variables = subscriptionObserver.variables;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, _constants.SUBSCRIPTION_STATUS).FAILED
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            logger.debug('timeoutStartSubscription', JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        if (this.socketStatus === (0, _constants.SOCKET_STATUS).READY) return;
        return new Promise(function(res, rej) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var payloadString, authHeader, headerString, headerQs, discoverableEndpoint, protocol, awsRealTimeUrl, authTokenSubprotocol, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === (0, _constants.SOCKET_STATUS).CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CONNECTING;
                            payloadString = '{}';
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: '/connect',
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    additionalHeaders: additionalHeaders
                                })
                            ];
                        case 2:
                            authHeader = _a.sent();
                            headerString = authHeader ? JSON.stringify(authHeader) : '';
                            headerQs = base64urlEncode(headerString);
                            discoverableEndpoint = appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : '';
                            if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat(customDomainPath);
                            else discoverableEndpoint = discoverableEndpoint.replace('appsync-api', 'appsync-realtime-api').replace('gogi-beta', 'grt-beta');
                            protocol = this.isSSLEnabled ? 'wss://' : 'ws://';
                            discoverableEndpoint = discoverableEndpoint.replace('https://', protocol).replace('http://', protocol);
                            awsRealTimeUrl = discoverableEndpoint;
                            authTokenSubprotocol = "header-" + headerQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake(awsRealTimeUrl, authTokenSubprotocol)
                            ];
                        case 3:
                            _a.sent();
                            this.promiseArray.forEach(function(_a) {
                                var _$res = _a.res;
                                logger.debug('Notifying connection successful');
                                _$res();
                            });
                            this.socketStatus = (0, _constants.SOCKET_STATUS).READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.debug('Connection exited with', err_3);
                            this.promiseArray.forEach(function(_a) {
                                var _$rej = _a.rej;
                                return _$rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = undefined;
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(awsRealTimeUrl, subprotocol) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                awsRealTimeUrl,
                                subprotocol
                            ], (0, _constants.MAX_DELAY_MS))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(awsRealTimeUrl, subprotocol) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err_4, _a, errorType, errorCode;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = _this.getNewWebSocket(awsRealTimeUrl, [
                                        'graphql-ws',
                                        subprotocol
                                    ]);
                                    newSocket.onerror = function() {
                                        logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error('Connection handshake error'));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    if (_this.awsRealTimeSocket) {
                                        var ackOk_1 = false;
                                        _this.awsRealTimeSocket.onerror = function(error) {
                                            logger.debug("WebSocket error " + JSON.stringify(error));
                                        };
                                        _this.awsRealTimeSocket.onclose = function(event) {
                                            logger.debug("WebSocket closed " + event.reason);
                                            rej(new Error(JSON.stringify(event)));
                                        };
                                        _this.awsRealTimeSocket.onmessage = function(message) {
                                            if (typeof message.data !== 'string') return;
                                            logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                            var data = JSON.parse(message.data);
                                            var type = data.type, _a = data.payload, _$_b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _$_b === void 0 ? (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT) : _$_b;
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ACK) {
                                                ackOk_1 = true;
                                                if (_this.awsRealTimeSocket) {
                                                    _this.keepAliveTimeout = connectionTimeoutMs;
                                                    _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                                    _this.awsRealTimeSocket.onerror = function(err) {
                                                        logger.debug(err);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                    _this.awsRealTimeSocket.onclose = function(event) {
                                                        logger.debug("WebSocket closed " + event.reason);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                }
                                                res('Cool, connected to AWS AppSyncRealTime');
                                                return;
                                            }
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ERROR) {
                                                var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (0, _tslib.__read)(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? '' : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                                rej({
                                                    errorType: errorType,
                                                    errorCode: errorCode
                                                });
                                            }
                                        };
                                        var gqlInit = {
                                            type: (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_INIT
                                        };
                                        _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                        var checkAckOk_1 = function checkAckOk_1(ackOk) {
                                            if (!ackOk) {
                                                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
                                                rej(new Error("Connection timeout: ack from AWSAppSyncRealTime was not received after " + (0, _constants.CONNECTION_INIT_TIMEOUT) + " ms"));
                                            }
                                        };
                                        setTimeout(function() {
                                            return checkAckOk_1(ackOk_1);
                                        }, (0, _constants.CONNECTION_INIT_TIMEOUT));
                                    }
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        _a = err_4, errorType = _a.errorType, errorCode = _a.errorCode;
                        if ((0, _constants.NON_RETRYABLE_CODES).includes(errorCode)) throw new (0, _core.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                            AWS_LAMBDA: this._customAuthHeader
                        };
                        if (!(!authenticationType || !headerHandler[authenticationType])) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.debug("Authentication type " + authenticationType + " not supported");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 1:
                        handler = headerHandler[authenticationType];
                        host = _url.parse(appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : '').host;
                        logger.debug("Authenticating with " + authenticationType);
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var session;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var token, federatedInfo, currentUser;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem('federatedInfo')
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) token = currentUser.token;
                        _b.label = 4;
                    case 4:
                        if (!token) throw new Error('No federated jwt');
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var dt, dtStr;
            return (0, _tslib.__generator)(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, '');
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        'x-amz-date': dtStr,
                        'x-api-key': apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: 'appsync'
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get().then(function(credentials) {
                                var _$_a = credentials, secretAccessKey = _$_a.secretAccessKey, accessKeyId = _$_a.accessKeyId, sessionToken = _$_a.sessionToken;
                                return {
                                    secret_key: secretAccessKey,
                                    access_key: accessKeyId,
                                    session_token: sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: 'POST',
                            headers: (0, _tslib.__assign)({}, (0, _constants.AWS_APPSYNC_REALTIME_HEADERS))
                        };
                        signed_params = (0, _core.Signer).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._customAuthHeader = function(_a) {
        var host = _a.host, additionalHeaders = _a.additionalHeaders;
        if (!additionalHeaders || !additionalHeaders['Authorization']) throw new Error('No auth token specified');
        return {
            Authorization: additionalHeaders.Authorization,
            host: host
        };
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, _core.Credentials).shear(credentials);
            logger.debug('set credentials for AWSAppSyncRealTimeProvider', cred);
            return true;
        }).catch(function(err) {
            logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, _pubSubProvider.AbstractPubSubProvider));

},{"tslib":"cUWSL","zen-observable-ts":"57mma","graphql":"10HlN","url":"7NJu4","uuid":"bvm5J","buffer":"uEI7y","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@aws-amplify/auth":"ilv20","../PubSubProvider":"hNpQm","../../types/PubSub":"dTFhH","../constants":"dleHk","../../utils/ConnectionStateMonitor":"04hIN","../../utils/ReconnectionMonitor":"ikPBr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"uEI7y":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
'use strict';
var base64 = require("d66f2e1ecf9cf00c");
var ieee754 = require("edca2e5113247e77");
var isArray = require("afbe907bb3b486b3");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"d66f2e1ecf9cf00c":"MlSYJ","edca2e5113247e77":"15Xnl","afbe907bb3b486b3":"fppCB"}],"fppCB":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"dTFhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", function() {
    return CONTROL_MSG;
});
parcelHelpers.export(exports, "ConnectionState", function() {
    return ConnectionState;
});
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var ConnectionState;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})(ConnectionState || (ConnectionState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dleHk":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_DELAY_MS", function() {
    return MAX_DELAY_MS;
});
parcelHelpers.export(exports, "NON_RETRYABLE_CODES", function() {
    return NON_RETRYABLE_CODES;
});
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", function() {
    return CONNECTION_STATE_CHANGE;
});
parcelHelpers.export(exports, "MESSAGE_TYPES", function() {
    return MESSAGE_TYPES;
});
parcelHelpers.export(exports, "SUBSCRIPTION_STATUS", function() {
    return SUBSCRIPTION_STATUS;
});
parcelHelpers.export(exports, "SOCKET_STATUS", function() {
    return SOCKET_STATUS;
});
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", function() {
    return AMPLIFY_SYMBOL;
});
parcelHelpers.export(exports, "AWS_APPSYNC_REALTIME_HEADERS", function() {
    return AWS_APPSYNC_REALTIME_HEADERS;
});
parcelHelpers.export(exports, "CONNECTION_INIT_TIMEOUT", function() {
    return CONNECTION_INIT_TIMEOUT;
});
parcelHelpers.export(exports, "START_ACK_TIMEOUT", function() {
    return START_ACK_TIMEOUT;
});
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_TIMEOUT", function() {
    return DEFAULT_KEEP_ALIVE_TIMEOUT;
});
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT", function() {
    return DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT;
});
parcelHelpers.export(exports, "RECONNECT_DELAY", function() {
    return RECONNECT_DELAY;
});
parcelHelpers.export(exports, "RECONNECT_INTERVAL", function() {
    return RECONNECT_INTERVAL;
});
var MAX_DELAY_MS = 5000;
var NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var CONNECTION_STATE_CHANGE = 'ConnectionStateChange';
var MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
var SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})(SOCKET_STATUS || (SOCKET_STATUS = {}));
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';
var AWS_APPSYNC_REALTIME_HEADERS = {
    accept: 'application/json, text/javascript',
    'content-encoding': 'amz-1.0',
    'content-type': 'application/json; charset=UTF-8'
};
var CONNECTION_INIT_TIMEOUT = 15000;
var START_ACK_TIMEOUT = 15000;
var DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT = 65000;
var RECONNECT_DELAY = 5000;
var RECONNECT_INTERVAL = 60000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"04hIN":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONNECTION_CHANGE", function() {
    return CONNECTION_CHANGE;
});
parcelHelpers.export(exports, "ConnectionStateMonitor", function() {
    return ConnectionStateMonitor;
});
var _tslib = require("tslib");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _pubSub = require("../types/PubSub");
var _reachabilityMonitor = require("./ReachabilityMonitor");
var CONNECTION_CHANGE = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: 'unhealthy'
    },
    KEEP_ALIVE: {
        keepAliveState: 'healthy'
    },
    CONNECTION_ESTABLISHED: {
        connectionState: 'connected'
    },
    CONNECTION_FAILED: {
        intendedConnectionState: 'disconnected',
        connectionState: 'disconnected'
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: 'disconnected'
    },
    OPENING_CONNECTION: {
        intendedConnectionState: 'connected',
        connectionState: 'connecting'
    },
    CLOSED: {
        connectionState: 'disconnected'
    },
    ONLINE: {
        networkState: 'connected'
    },
    OFFLINE: {
        networkState: 'disconnected'
    }
};
var ConnectionStateMonitor = /** @class */ function() {
    function ConnectionStateMonitor() {
        var _this = this;
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: 'connected',
            connectionState: 'disconnected',
            intendedConnectionState: 'disconnected',
            keepAliveState: 'healthy'
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            var _b;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
            (_b = _this._initialNetworkStateSubscription) === null || _b === void 0 || _b.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, _zenObservableTsDefault.default)(function(connectionStateObserver) {
            connectionStateObserver.next(_this._linkedConnectionState);
            _this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ ConnectionStateMonitor.prototype.enableNetworkMonitoring = function() {
        var _this = this;
        var _a;
        // If no initial network state was discovered, stop trying
        (_a = this._initialNetworkStateSubscription) === null || _a === void 0 || _a.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
        });
    };
    /**
     * Turn network state monitoring off if it isn't off already
     */ ConnectionStateMonitor.prototype.disableNetworkMonitoring = function() {
        var _a;
        (_a = this._networkMonitoringSubscription) === null || _a === void 0 || _a.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    };
    Object.defineProperty(ConnectionStateMonitor.prototype, "connectionStateObservable", {
        /**
         * Get the observable that allows us to monitor the connection state
         *
         * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
         */ get: function get() {
            var _this = this;
            var previous;
            // The linked state aggregates state changes to any of the network, connection,
            // intendedConnection and keepAliveHealth. Some states will change these independent
            // states without changing the overall connection state.
            // After translating from linked states to ConnectionState, then remove any duplicates
            return this._linkedConnectionStateObservable.map(function(value) {
                return _this.connectionStatesTranslator(value);
            }).filter(function(current) {
                var toInclude = current !== previous;
                previous = current;
                return toInclude;
            });
        },
        enumerable: true,
        configurable: true
    });
    /*
     * Updates local connection state and emits the full state to the observer.
     */ ConnectionStateMonitor.prototype.record = function(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === 'connected') this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === 'disconnected') this.disableNetworkMonitoring();
        // Maintain the socket state
        var newSocketStatus = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._linkedConnectionState), statusUpdates);
        this._linkedConnectionState = (0, _tslib.__assign)({}, newSocketStatus);
        this._linkedConnectionStateObserver.next(this._linkedConnectionState);
    };
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ ConnectionStateMonitor.prototype.connectionStatesTranslator = function(_a) {
        var connectionState = _a.connectionState, networkState = _a.networkState, intendedConnectionState = _a.intendedConnectionState, keepAliveState = _a.keepAliveState;
        if (connectionState === 'connected' && networkState === 'disconnected') return (0, _pubSub.ConnectionState).ConnectedPendingNetwork;
        if (connectionState === 'connected' && intendedConnectionState === 'disconnected') return (0, _pubSub.ConnectionState).ConnectedPendingDisconnect;
        if (connectionState === 'disconnected' && intendedConnectionState === 'connected' && networkState === 'disconnected') return (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork;
        if (connectionState === 'disconnected' && intendedConnectionState === 'connected') return (0, _pubSub.ConnectionState).ConnectionDisrupted;
        if (connectionState === 'connected' && keepAliveState === 'unhealthy') return (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === 'connecting') return (0, _pubSub.ConnectionState).Connecting;
        if (connectionState === 'disconnected') return (0, _pubSub.ConnectionState).Disconnected;
        return (0, _pubSub.ConnectionState).Connected;
    };
    return ConnectionStateMonitor;
}();

},{"tslib":"cUWSL","zen-observable-ts":"57mma","../types/PubSub":"dTFhH","./ReachabilityMonitor":"6G1lb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6G1lb":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", function() {
    return ReachabilityMonitor;
});
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = function ReachabilityMonitor() {
    return new (0, _core.Reachability)().networkMonitor();
};

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ikPBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReconnectEvent", function() {
    return ReconnectEvent;
});
parcelHelpers.export(exports, "ReconnectionMonitor", function() {
    return ReconnectionMonitor;
});
var _constants = require("../Providers/constants");
var ReconnectEvent;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})(ReconnectEvent || (ReconnectEvent = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ var ReconnectionMonitor = /** @class */ function() {
    function ReconnectionMonitor() {
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ ReconnectionMonitor.prototype.addObserver = function(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    };
    /**
     * Given a reconnect event, start the appropriate behavior
     */ ReconnectionMonitor.prototype.record = function(event) {
        var _this = this;
        if (event === ReconnectEvent.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(function() {
                // Reconnect now
                _this._triggerReconnect();
                // Retry reconnect every periodically until it works
                _this.reconnectIntervalId = setInterval(function() {
                    _this._triggerReconnect();
                }, (0, _constants.RECONNECT_INTERVAL));
            }, (0, _constants.RECONNECT_DELAY));
        }
        if (event === ReconnectEvent.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    };
    /**
     * Complete all reconnect observers
     */ ReconnectionMonitor.prototype.close = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.complete) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    ReconnectionMonitor.prototype._triggerReconnect = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.next) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    return ReconnectionMonitor;
}();

},{"../Providers/constants":"dleHk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4viCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", function() {
    return 0, _auth.GRAPHQL_AUTH_MODE;
});
parcelHelpers.export(exports, "GraphQLAuthError", function() {
    return GraphQLAuthError;
});
var _auth = require("@aws-amplify/auth");
var GraphQLAuthError;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})(GraphQLAuthError || (GraphQLAuthError = {}));

},{"@aws-amplify/auth":"ilv20","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"by3r2":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPI", function() {
    return 0, _restAPI.RestAPI;
});
parcelHelpers.export(exports, "RestAPIClass", function() {
    return 0, _restAPI.RestAPIClass;
});
parcelHelpers.export(exports, "RestClient", function() {
    return 0, _restClient.RestClient;
});
var _restAPI = require("./RestAPI");
var _restClient = require("./RestClient");

},{"./RestAPI":"g8YJt","./RestClient":"1QqNN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g8YJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPIClass", function() {
    return RestAPIClass;
});
parcelHelpers.export(exports, "RestAPI", function() {
    return RestAPI;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _restClient = require("./RestClient");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('RestAPI');
/**
 * Export Cloud Logic APIs
 */ var RestAPIClass = /** @class */ function() {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function RestAPIClass(options) {
        this._api = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug('API Options', this._options);
    }
    RestAPIClass.prototype.getModuleName = function() {
        return 'RestAPI';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ RestAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug('configure Rest API', {
            opt: opt
        });
        if (opt['aws_project_region']) {
            if (opt['aws_cloud_logic_custom']) {
                var custom = opt['aws_cloud_logic_custom'];
                opt.endpoints = typeof custom === 'string' ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt['aws_project_region'],
                header: {}
            });
        }
        if (Array.isArray(opt.endpoints)) // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== 'undefined' && typeof endpoint.custom_header !== 'function') {
                logger.warn('Rest API ' + endpoint.name + ', custom_header should be a function');
                endpoint.custom_header = undefined;
            }
        });
        else if (this._options && Array.isArray(this._options.endpoints)) opt.endpoints = this._options.endpoints;
        else opt.endpoints = [];
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ RestAPIClass.prototype.createInstance = function() {
        logger.debug('create Rest API instance');
        this._api = new (0, _restClient.RestClient)(this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.get = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.post = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.put = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.patch = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.del = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.head = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ RestAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._api.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */ RestAPIClass.prototype.getEndpointInfo = function(apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) throw new Error("API category not configured");
        var apiConfig = cloud_logic_array.find(function(api) {
            return api.name === apiName;
        });
        if (!apiConfig) throw new Error("API ".concat(apiName, " does not exist"));
        var response = {
            endpoint: apiConfig.endpoint + path
        };
        if (typeof apiConfig.region === 'string') response.region = apiConfig.region;
        else if (typeof this._options.region === 'string') response.region = this._options.region;
        if (typeof apiConfig.service === 'string') response.service = apiConfig.service || 'execute-api';
        else response.service = 'execute-api';
        if (typeof apiConfig.custom_header === 'function') response.custom_header = apiConfig.custom_header;
        else response.custom_header = undefined;
        return response;
    };
    return RestAPIClass;
}();
var RestAPI = new RestAPIClass(null);
(0, _core.Amplify).register(RestAPI);

},{"tslib":"1ORaD","./RestClient":"1QqNN","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ORaD":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QqNN":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestClient", function() {
    return RestClient;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _url = require("url");
var logger = new (0, _core.ConsoleLogger)('RestClient');
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var RestClient = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = 'us-east-1'; // this will be updated by endpoint function
        this._service = 'execute-api'; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */ this._cancelTokenMap = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug('API Options', this._options);
        if (this._cancelTokenMap == null) this._cancelTokenMap = new WeakMap();
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(urlOrApiInfo, method, init) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl, credentials, error_1, signedParams, response, error_2, headers, dateHeader, responseDate, requestDate, rawClientDate;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        logger.debug(method, urlOrApiInfo);
                        region = 'us-east-1';
                        service = 'execute-api';
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === 'string') {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        } else {
                            url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: 'json',
                            timeout: 0,
                            cancelToken: null
                        };
                        libraryHeaders = {};
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === 'function' && initParams.body instanceof FormData) {
                                libraryHeaders['Content-Type'] = 'multipart/form-data';
                                params.data = initParams.body;
                            } else {
                                libraryHeaders['Content-Type'] = 'application/json; charset=UTF-8';
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params['withCredentials'] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        if (initParams.cancellableToken) params.cancelToken = initParams.cancellableToken.token;
                        params['signerServiceInfo'] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === 'function')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = (0, _url.parse)(url, true, true), search = _b.search, parsedUrl = (0, _tslib.__rest)(_b, [
                            "search"
                        ]);
                        params.url = (0, _url.format)((0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl), {
                            query: (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers['Authorization'] !== 'undefined') {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Credentials.get()
                        ];
                    case 5:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_1 = _c.sent();
                        logger.debug('No credentials available, the request will be unsigned');
                        return [
                            2 /*return*/ ,
                            this._request(params, isAllResponse)
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        signedParams = this._sign((0, _tslib.__assign)({}, params), credentials, {
                            region: region,
                            service: service
                        });
                        return [
                            4 /*yield*/ ,
                            (0, _axiosDefault.default)(signedParams)
                        ];
                    case 8:
                        response = _c.sent();
                        return [
                            2 /*return*/ ,
                            isAllResponse ? response : response.data
                        ];
                    case 9:
                        error_2 = _c.sent();
                        logger.debug(error_2);
                        if ((0, _core.DateUtils).isClockSkewError(error_2)) {
                            headers = error_2.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            responseDate = new Date(dateHeader);
                            requestDate = (0, _core.DateUtils).getDateFromHeaderString(signedParams.headers['x-amz-date']);
                            // Compare local clock to the server clock
                            if ((0, _core.DateUtils).isClockSkewed(responseDate)) {
                                rawClientDate = requestDate.getTime() - (0, _core.DateUtils).getClockOffset();
                                (0, _core.DateUtils).setClockOffset(responseDate.getTime() - rawClientDate);
                                return [
                                    2 /*return*/ ,
                                    this.ajax(urlOrApiInfo, method, init)
                                ];
                            }
                        }
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'GET', init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PUT', init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PATCH', init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'POST', init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'DELETE', init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'HEAD', init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ RestClient.prototype.cancel = function(request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) {
            source.cancel(message);
            return true;
        }
        return false;
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestClient.prototype.hasCancelToken = function(request) {
        return this._cancelTokenMap.has(request);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestClient.prototype.isCancel = function(error) {
        return (0, _axiosDefault.default).isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */ RestClient.prototype.getCancellableToken = function() {
        return (0, _axiosDefault.default).CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */ RestClient.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = '';
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === 'string') _this._region = v.region;
                else if (typeof _this._options.region === 'string') _this._region = _this._options.region;
                if (typeof v.service === 'string') _this._service = v.service || 'execute-api';
                else _this._service = 'execute-api';
                if (typeof v.custom_header === 'function') _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._sign = function(params, credentials, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = (0, _tslib.__rest)(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, _core.Signer).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        logger.debug('Signed Request: ', signed_params);
        delete signed_params.headers['host'];
        return signed_params;
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, _axiosDefault.default)(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split('/');
        return {
            host: parts[2],
            path: '/' + parts.slice(3).join('/')
        };
    };
    return RestClient;
}();

},{"tslib":"1ORaD","@aws-amplify/core":"3rlh1","axios":"fKFWg","url":"7NJu4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKFWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _axiosJsDefault.default;
});
parcelHelpers.export(exports, "Axios", function() {
    return Axios;
});
parcelHelpers.export(exports, "AxiosError", function() {
    return AxiosError;
});
parcelHelpers.export(exports, "CanceledError", function() {
    return CanceledError;
});
parcelHelpers.export(exports, "isCancel", function() {
    return isCancel;
});
parcelHelpers.export(exports, "CancelToken", function() {
    return CancelToken;
});
parcelHelpers.export(exports, "VERSION", function() {
    return VERSION;
});
parcelHelpers.export(exports, "all", function() {
    return all;
});
parcelHelpers.export(exports, "Cancel", function() {
    return Cancel;
});
parcelHelpers.export(exports, "isAxiosError", function() {
    return isAxiosError;
});
parcelHelpers.export(exports, "spread", function() {
    return spread;
});
parcelHelpers.export(exports, "toFormData", function() {
    return toFormData;
});
parcelHelpers.export(exports, "AxiosHeaders", function() {
    return AxiosHeaders;
});
parcelHelpers.export(exports, "HttpStatusCode", function() {
    return HttpStatusCode;
});
parcelHelpers.export(exports, "formToJSON", function() {
    return formToJSON;
});
parcelHelpers.export(exports, "getAdapter", function() {
    return getAdapter;
});
parcelHelpers.export(exports, "mergeConfig", function() {
    return mergeConfig;
});
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var Axios = (0, _axiosJsDefault.default).Axios, AxiosError = (0, _axiosJsDefault.default).AxiosError, CanceledError = (0, _axiosJsDefault.default).CanceledError, isCancel = (0, _axiosJsDefault.default).isCancel, CancelToken = (0, _axiosJsDefault.default).CancelToken, VERSION = (0, _axiosJsDefault.default).VERSION, all = (0, _axiosJsDefault.default).all, Cancel = (0, _axiosJsDefault.default).Cancel, isAxiosError = (0, _axiosJsDefault.default).isAxiosError, spread = (0, _axiosJsDefault.default).spread, toFormData = (0, _axiosJsDefault.default).toFormData, AxiosHeaders = (0, _axiosJsDefault.default).AxiosHeaders, HttpStatusCode = (0, _axiosJsDefault.default).HttpStatusCode, formToJSON = (0, _axiosJsDefault.default).formToJSON, getAdapter = (0, _axiosJsDefault.default).getAdapter, mergeConfig = (0, _axiosJsDefault.default).mergeConfig;

},{"./lib/axios.js":"3iITV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3iITV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    var context = new (0, _axiosJsDefault.default)(defaultConfig);
    var instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = function(thing) {
    return (0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
};
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"iMPRy","./helpers/bind.js":"pSHhG","./core/Axios.js":"kAG1W","./core/mergeConfig.js":"1udYh","./defaults/index.js":"aqcfZ","./helpers/formDataToJSON.js":"97tof","./cancel/CanceledError.js":"5AXiQ","./cancel/CancelToken.js":"8XhLJ","./cancel/isCancel.js":"aXSb2","./env/data.js":"09Z6G","./helpers/toFormData.js":"3rd2Z","./core/AxiosError.js":"102bD","./helpers/spread.js":"9dE0m","./helpers/isAxiosError.js":"fai4N","./core/AxiosHeaders.js":"fCSNz","./adapters/adapters.js":"1CqCB","./helpers/HttpStatusCode.js":"bkq8L","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iMPRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
var process = require("527a8960612e3852");
'use strict';
// utils is a library of generic helper functions non-specific to axios
var toString = Object.prototype.toString;
var getPrototypeOf = Object.getPrototypeOf;
var kindOf = function(cache) {
    return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return kindOf(thing) === type;
    };
};
var typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, _typeOf._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var isObject = function(thing) {
    return thing !== null && (typeof thing === "undefined" ? "undefined" : (0, _typeOf._)(thing)) === 'object';
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var isPlainObject = function(val) {
    if (kindOf(val) !== 'object') return false;
    var prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var isStream = function(val) {
    return isObject(val) && isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var isURLSearchParams = kindOfTest('URLSearchParams');
var _map = (0, _slicedToArray._)([
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest), 4), isReadableStream = _map[0], isRequest = _map[1], isResponse = _map[2], isHeaders = _map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    var i;
    var l;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var _global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
}();
var isContextDefined = function(context) {
    return !isUndefined(context) && context !== _global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    var caseless = (isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    forEach(b, function(val, key) {
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var toArray = function(thing) {
    if (!thing) return null;
    if (isArray(thing)) return thing;
    var i = thing.length;
    if (!isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var isHTMLForm = kindOfTest('HTMLFormElement');
var toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var isRegExp = kindOfTest('RegExp');
var reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var freezeMethods = function(obj) {
    reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
var toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var noop = function() {};
var toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
var ALPHA = 'abcdefghijklmnopqrstuvwxyz';
var DIGIT = '0123456789';
var ALPHABET = {
    DIGIT: DIGIT,
    ALPHA: ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
var generateString = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, alphabet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ALPHABET.ALPHA_DIGIT;
    var str = '';
    var length = alphabet.length;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
var toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                var target = isArray(source) ? [] : {};
                forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var isAsyncFn = kindOfTest('AsyncFunction');
var isThenable = function(thing) {
    return thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var _setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        _global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === 'function', isFunction(_global.postMessage));
var asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;
// *********************
exports.default = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isBoolean: isBoolean,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isReadableStream: isReadableStream,
    isRequest: isRequest,
    isResponse: isResponse,
    isHeaders: isHeaders,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isRegExp: isRegExp,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isTypedArray: isTypedArray,
    isFileList: isFileList,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM,
    inherits: inherits,
    toFlatObject: toFlatObject,
    kindOf: kindOf,
    kindOfTest: kindOfTest,
    endsWith: endsWith,
    toArray: toArray,
    forEachEntry: forEachEntry,
    matchAll: matchAll,
    isHTMLForm: isHTMLForm,
    hasOwnProperty: hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors: reduceDescriptors,
    freezeMethods: freezeMethods,
    toObjectSet: toObjectSet,
    toCamelCase: toCamelCase,
    noop: noop,
    toFiniteNumber: toFiniteNumber,
    findKey: findKey,
    global: _global,
    isContextDefined: isContextDefined,
    ALPHABET: ALPHABET,
    generateString: generateString,
    isSpecCompliantForm: isSpecCompliantForm,
    toJSONObject: toJSONObject,
    isAsyncFn: isAsyncFn,
    isThenable: isThenable,
    setImmediate: _setImmediate,
    asap: asap
};

},{"@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","527a8960612e3852":"4avz9","./helpers/bind.js":"pSHhG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"pSHhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return bind;
});
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kAG1W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
var validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, _classCallCheck._)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    (0, _createClass._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var err, dummy, stack;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    ;
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === 'string') {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
                    silentJSONParsing: validators.transitional(validators.boolean),
                    forcedJSONParsing: validators.transitional(validators.boolean),
                    clarifyTimeoutError: validators.transitional(validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                        encode: validators.function,
                        serialize: validators.function
                    }, true);
                }
                // Set config.method
                config.method = (config.method || this.defaults.method || 'get').toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
                headers && (0, _utilsJsDefault.default).forEach([
                    'delete',
                    'get',
                    'head',
                    'post',
                    'put',
                    'patch',
                    'common'
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, _dispatchRequestJsDefault.default).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
                var fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
                return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_ts_generator":"2jVI5","./../utils.js":"iMPRy","../helpers/buildURL.js":"5QtEF","./InterceptorManager.js":"cbdFl","./dispatchRequest.js":"lwpXK","./mergeConfig.js":"1udYh","./buildFullPath.js":"ificr","../helpers/validator.js":"783po","./AxiosHeaders.js":"fCSNz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5QtEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildURL;
});
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || encode;
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"iMPRy","../helpers/AxiosURLSearchParams.js":"geweC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"geweC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    var charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
var prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"3rd2Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rd2Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("3149f3ec0dec4ed5").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
var predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    var useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign(predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            var result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"@swc/helpers/_/_type_of":"668P4","3149f3ec0dec4ed5":"cvSE8","../utils.js":"iMPRy","../core/AxiosError.js":"102bD","../platform/node/classes/FormData.js":"jjfbf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"102bD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var prototype = AxiosError.prototype;
var descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach(function(code) {
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== 'isAxiosError';
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jjfbf":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cbdFl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
var InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, _classCallCheck._)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, _createClass._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
exports.default = InterceptorManager;

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","./../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwpXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return dispatchRequest;
});
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    var adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"ae8yX","../cancel/isCancel.js":"aXSb2","../defaults/index.js":"aqcfZ","../cancel/CanceledError.js":"5AXiQ","../core/AxiosHeaders.js":"fCSNz","../adapters/adapters.js":"1CqCB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ae8yX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return transformData;
});
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    var config = this || (0, _indexJsDefault.default);
    var context = response || config;
    var headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    var data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"iMPRy","../defaults/index.js":"aqcfZ","../core/AxiosHeaders.js":"fCSNz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aqcfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || '';
            var hasJSONContentType = contentType.indexOf('application/json') > -1;
            var isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], function(method) {
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"iMPRy","../core/AxiosError.js":"102bD","./transitional.js":"lppyD","../helpers/toFormData.js":"3rd2Z","../helpers/toURLEncodedForm.js":"9eCtJ","../platform/index.js":"aJtTp","../helpers/formDataToJSON.js":"97tof","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lppyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eCtJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toURLEncodedForm;
});
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"iMPRy","./toFormData.js":"3rd2Z","../platform/index.js":"aJtTp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aJtTp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = (0, _objectSpread._)({}, _utilsJs, (0, _indexJsDefault.default));

},{"@swc/helpers/_/_object_spread":"awG4j","./node/index.js":"dA5fW","./common/utils.js":"8VDAK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dA5fW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"31UtS","./classes/FormData.js":"gDjPL","./classes/Blob.js":"bfza7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"31UtS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"geweC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gDjPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bfza7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8VDAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", function() {
    return hasBrowserEnv;
});
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", function() {
    return hasStandardBrowserWebWorkerEnv;
});
parcelHelpers.export(exports, "hasStandardBrowserEnv", function() {
    return hasStandardBrowserEnv;
});
parcelHelpers.export(exports, "navigator", function() {
    return _navigator;
});
parcelHelpers.export(exports, "origin", function() {
    return origin;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
var _navigator = (typeof navigator === "undefined" ? "undefined" : (0, _typeOf._)(navigator)) === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var hasStandardBrowserWebWorkerEnv = function() {
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();
var origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"97tof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === '__proto__') return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        var obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, function(name, value) {
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fCSNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
var $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    var accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, _classCallCheck._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, _createClass._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = normalizeHeader(_header);
                    if (!lHeader) throw new Error('header name must be a non-empty string');
                    var key = (0, _utilsJsDefault.default).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, _utilsJsDefault.default).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
                else if ((0, _utilsJsDefault.default).isHeaders(header)) try {
                    for(var _iterator = header.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        setHeader(value, key, rewrite);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = normalizeHeader(header);
                if (header) {
                    var key = (0, _utilsJsDefault.default).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return parseTokens(value);
                        if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError('parser must be boolean|regexp|function');
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = normalizeHeader(header);
                if (header) {
                    var key = (0, _utilsJsDefault.default).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = normalizeHeader(_header);
                    if (_header) {
                        var key = (0, _utilsJsDefault.default).findKey(self, _header);
                        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, _utilsJsDefault.default).forEach(this, function(value, header) {
                    var key = (0, _utilsJsDefault.default).findKey(headers, header);
                    if (key) {
                        self[key] = normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, _toConsumableArray._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, _utilsJsDefault.default).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, _slicedToArray._)(param, 2), header = _param[0], value = _param[1];
                    return header + ': ' + value;
                }).join('\n');
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return 'AxiosHeaders';
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$internals] = this[$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","../utils.js":"iMPRy","../helpers/parseHeaders.js":"2bVOd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4zJ2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"gt6mn","./_iterable_to_array.js":"jS08c","./_non_iterable_spread.js":"8ALHQ","./_unsupported_iterable_to_array.js":"8BcAR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gt6mn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"fwJyR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jS08c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ALHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2bVOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aXSb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isCancel;
});
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5AXiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"102bD","../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1CqCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _fetchJsDefault = parcelHelpers.interopDefault(_fetchJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: (0, _fetchJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
var renderReason = function(reason) {
    return "- ".concat(reason);
};
var isResolvedHandle = function(adapter) {
    return (0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
};
exports.default = {
    getAdapter: function(adapters) {
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, _slicedToArray._)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? 'is not supported by the environment' : 'is not available in the build');
            });
            var s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, _axiosErrorJsDefault.default)("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"@swc/helpers/_/_sliced_to_array":"byksX","../utils.js":"iMPRy","./http.js":"jjfbf","./xhr.js":"1snQH","./fetch.js":"8zkUs","../core/AxiosError.js":"102bD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1snQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, _resolveConfigJsDefault.default)(config);
        var requestData = _config.data;
        var requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, _slicedToArray._)((0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, _slicedToArray._)((0, _progressEventReducerJs.progressEventReducer)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        var protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"@swc/helpers/_/_sliced_to_array":"byksX","./../utils.js":"iMPRy","./../core/settle.js":"3Gx0Z","../defaults/transitional.js":"lppyD","../core/AxiosError.js":"102bD","../cancel/CanceledError.js":"5AXiQ","../helpers/parseProtocol.js":"5RPbj","../platform/index.js":"aJtTp","../core/AxiosHeaders.js":"fCSNz","../helpers/progressEventReducer.js":"cRCA3","../helpers/resolveConfig.js":"3lW3t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Gx0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return settle;
});
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"102bD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RPbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parseProtocol;
});
'use strict';
function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cRCA3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", function() {
    return progressEventReducer;
});
parcelHelpers.export(exports, "progressEventDecorator", function() {
    return progressEventDecorator;
});
parcelHelpers.export(exports, "asyncDecorator", function() {
    return asyncDecorator;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var progressEventReducer = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, _defineProperty._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? 'download' : 'upload', true);
        listener(data);
    }, freq);
};
var progressEventDecorator = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var asyncDecorator = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, _utilsJsDefault.default).asap(function() {
            return fn.apply(void 0, (0, _toConsumableArray._)(args));
        });
    };
};

},{"@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_to_consumable_array":"4zJ2w","./speedometer.js":"2rPbD","./throttle.js":"gQD0W","../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2rPbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gQD0W":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3lW3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = function(config) {
    var newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    var contentType;
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            var _ref = (0, _toArray._)(contentType ? contentType.split(';').map(function(token) {
                return token.trim();
            }).filter(Boolean) : []), type = _ref[0], tokens = _ref.slice(1);
            headers.setContentType([
                type || 'multipart/form-data'
            ].concat((0, _toConsumableArray._)(tokens)).join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"@swc/helpers/_/_to_array":"aeYFL","@swc/helpers/_/_to_consumable_array":"4zJ2w","../platform/index.js":"aJtTp","../utils.js":"iMPRy","./isURLSameOrigin.js":"4aZGc","./cookies.js":"3S59w","../core/buildFullPath.js":"ificr","../core/mergeConfig.js":"1udYh","../core/AxiosHeaders.js":"fCSNz","./buildURL.js":"5QtEF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aeYFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_array(arr) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"bkVhC","./_iterable_to_array.js":"jS08c","./_non_iterable_rest.js":"hf2PL","./_unsupported_iterable_to_array.js":"8BcAR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4aZGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"iMPRy","../platform/index.js":"aJtTp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3S59w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push('path=' + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};

},{"./../utils.js":"iMPRy","../platform/index.js":"aJtTp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ificr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildFullPath;
});
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"5guai","../helpers/combineURLs.js":"byy8R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5guai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAbsoluteURL;
});
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byy8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return combineURLs;
});
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1udYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergeConfig;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
var headersToObject = function(thing) {
    return thing instanceof (0, _axiosHeadersJsDefault.default) ? (0, _objectSpread._)({}, thing) : thing;
};
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b) {
            return mergeDeepProperties(headersToObject(a), headersToObject(b), true);
        }
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"@swc/helpers/_/_object_spread":"awG4j","../utils.js":"iMPRy","./AxiosHeaders.js":"fCSNz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8zkUs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
var isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
var encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? function(encoder) {
    return function(str) {
        return encoder.encode(str);
    };
}(new TextEncoder()) : /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(str) {
        var _;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Uint8Array.bind;
                    return [
                        4,
                        new Response(str).arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function(str) {
        return _ref.apply(this, arguments);
    };
}());
var test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, _toConsumableArray._)(args));
    } catch (e) {
        return false;
    }
};
var supportsRequestStream = isReadableStreamSupported && test(function() {
    var duplexAccessed = false;
    var hasContentType = new Request((0, _indexJsDefault.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
var DEFAULT_CHUNK_SIZE = 65536;
var supportsResponseStream = isReadableStreamSupported && test(function() {
    return (0, _utilsJsDefault.default).isReadableStream(new Response('').body);
});
var resolvers = {
    stream: supportsResponseStream && function(res) {
        return res.body;
    }
};
isFetchSupported && function(res) {
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach(function(type) {
        !resolvers[type] && (resolvers[type] = (0, _utilsJsDefault.default).isFunction(res[type]) ? function(res) {
            return res[type]();
        } : function(_, config) {
            throw new (0, _axiosErrorJsDefault.default)("Response type '".concat(type, "' is not supported"), (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
        });
    });
}(new Response);
var getBodyLength = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(body) {
        var _request;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (body == null) return [
                        2,
                        0
                    ];
                    if ((0, _utilsJsDefault.default).isBlob(body)) return [
                        2,
                        body.size
                    ];
                    if (!(0, _utilsJsDefault.default).isSpecCompliantForm(body)) return [
                        3,
                        2
                    ];
                    _request = new Request((0, _indexJsDefault.default).origin, {
                        method: 'POST',
                        body: body
                    });
                    return [
                        4,
                        _request.arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 2:
                    if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return [
                        2,
                        body.byteLength
                    ];
                    if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
                    if (!(0, _utilsJsDefault.default).isString(body)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        encodeText(body)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBodyLength(body) {
        return _ref.apply(this, arguments);
    };
}();
var resolveBodyLength = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(headers, body) {
        var length;
        return (0, _tsGenerator._)(this, function(_state) {
            length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
            return [
                2,
                length == null ? getBodyLength(body) : length
            ];
        });
    });
    return function resolveBodyLength(headers, body) {
        return _ref.apply(this, arguments);
    };
}();
exports.default = isFetchSupported && /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveConfig = (0, _resolveConfigJsDefault.default)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? 'same-origin' : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
                    composedSignal = (0, _composeSignalsJsDefault.default)([
                        signal,
                        cancelToken && cancelToken.toAbortSignal()
                    ], timeout);
                    unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                        composedSignal.unsubscribe();
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _tmp = onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head';
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        resolveBodyLength(headers, data)
                    ];
                case 2:
                    _tmp = (requestContentLength = _state.sent()) !== 0;
                    _state.label = 3;
                case 3:
                    if (_tmp) {
                        _request = new Request(url, {
                            method: 'POST',
                            body: data,
                            duplex: "half"
                        });
                        ;
                        if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                        if (_request.body) {
                            _progressEventDecorator = (0, _slicedToArray._)((0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                            data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
                        }
                    }
                    if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
                    // Cloudflare Workers throws when credentials are defined
                    // see https://github.com/cloudflare/workerd/issues/902
                    isCredentialsSupported = "credentials" in Request.prototype;
                    request = new Request(url, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fetchOptions), {
                        signal: composedSignal,
                        method: method.toUpperCase(),
                        headers: headers.normalize().toJSON(),
                        body: data,
                        duplex: "half",
                        credentials: isCredentialsSupported ? withCredentials : undefined
                    }));
                    return [
                        4,
                        fetch(request)
                    ];
                case 4:
                    response = _state.sent();
                    isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
                    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                        options = {};
                        [
                            'status',
                            'statusText',
                            'headers'
                        ].forEach(function(prop) {
                            options[prop] = response[prop];
                        });
                        responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
                        _ref = (0, _slicedToArray._)(onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                        response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress1, function() {
                            flush1 && flush1();
                            unsubscribe && unsubscribe();
                        }), options);
                    }
                    responseType = responseType || 'text';
                    return [
                        4,
                        resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config)
                    ];
                case 5:
                    responseData = _state.sent();
                    !isStreamResponse && unsubscribe && unsubscribe();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, _settleJsDefault.default)(resolve, reject, {
                                data: responseData,
                                headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                                status: response.status,
                                statusText: response.statusText,
                                config: config,
                                request: request
                            });
                        })
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    err = _state.sent();
                    unsubscribe && unsubscribe();
                    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
                        cause: err.cause || err
                    });
                    throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","../platform/index.js":"aJtTp","../utils.js":"iMPRy","../core/AxiosError.js":"102bD","../helpers/composeSignals.js":"k57qg","../helpers/trackStream.js":"8mp7t","../core/AxiosHeaders.js":"fCSNz","../helpers/progressEventReducer.js":"cRCA3","../helpers/resolveConfig.js":"3lW3t","../core/settle.js":"3Gx0Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bAOpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k57qg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)("timeout ".concat(timeout, " of ms exceeded"), (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener('abort', onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, _utilsJsDefault.default).asap(unsubscribe);
        };
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"5AXiQ","../core/AxiosError.js":"102bD","../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mp7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", function() {
    return streamChunk;
});
parcelHelpers.export(exports, "readBytes", function() {
    return readBytes;
});
parcelHelpers.export(exports, "trackStream", function() {
    return trackStream;
});
var _asyncGeneratorDelegate = require("@swc/helpers/_/_async_generator_delegate");
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _awaitAsyncGenerator = require("@swc/helpers/_/_await_async_generator");
var _wrapAsyncGenerator = require("@swc/helpers/_/_wrap_async_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
var streamChunk = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, _tsGenerator._)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var readBytes = /*#__PURE__*/ function() {
    var _ref = (0, _wrapAsyncGenerator._)(function(iterable, chunkSize) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, _asyncIterator._)(readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, _tsValues._)((0, _asyncGeneratorDelegate._)((0, _asyncIterator._)(streamChunk(chunk, chunkSize)), (0, _awaitAsyncGenerator._)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize) {
        return _ref.apply(this, arguments);
    };
}();
var readStream = /*#__PURE__*/ function() {
    var _ref = (0, _wrapAsyncGenerator._)(function(stream) {
        var reader, _ref, done, value;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, _tsValues._)((0, _asyncGeneratorDelegate._)((0, _asyncIterator._)(stream), (0, _awaitAsyncGenerator._)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, _awaitAsyncGenerator._)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function readStream(stream) {
        return _ref.apply(this, arguments);
    };
}();
var trackStream = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = readBytes(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, _asyncToGenerator._)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@swc/helpers/_/_async_generator_delegate":"hlELB","@swc/helpers/_/_async_iterator":"OkBt7","@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_await_async_generator":"d4PiL","@swc/helpers/_/_wrap_async_generator":"iyWut","@swc/helpers/_/_ts_generator":"2jVI5","@swc/helpers/_/_ts_values":"ynngT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hlELB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_generator_delegate;
});
function _async_generator_delegate(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        return pump("return", value);
    };
    return iter;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OkBt7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_iterator;
});
function _async_iterator(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(s);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4PiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _await_async_generator;
});
var _awaitValueJs = require("./_await_value.js");
function _await_async_generator(value) {
    return new (0, _awaitValueJs._)(value);
}

},{"./_await_value.js":"dPB24","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dPB24":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _await_value;
});
function _await_value(value) {
    this.wrapped = value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iyWut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_async_generator;
});
var _asyncGeneratorJs = require("./_async_generator.js");
function _wrap_async_generator(fn) {
    return function() {
        return new (0, _asyncGeneratorJs._)(fn.apply(this, arguments));
    };
}

},{"./_async_generator.js":"eJxFm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eJxFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_generator;
});
var _awaitValueJs = require("./_await_value.js");
function _async_generator(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, _awaitValueJs._);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) _async_generator.prototype[Symbol.asyncIterator] = function() {
    return this;
};
_async_generator.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
_async_generator.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
_async_generator.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

},{"./_await_value.js":"dPB24","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ynngT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"783po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
var validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, _typeOf._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, _typeOf._)(options)) !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions: assertOptions,
    validators: validators
};

},{"@swc/helpers/_/_type_of":"668P4","../env/data.js":"09Z6G","../core/AxiosError.js":"102bD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"09Z6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", function() {
    return VERSION;
});
var VERSION = "1.7.7";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8XhLJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, _classCallCheck._)(this, CancelToken);
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, _createClass._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
exports.default = CancelToken;

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","./CanceledError.js":"5AXiQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9dE0m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return spread;
});
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fai4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAxiosError;
});
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"iMPRy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkq8L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(function(param) {
    var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@swc/helpers/_/_sliced_to_array":"byksX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eWncu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLAuthError", function() {
    return 0, _types.GraphQLAuthError;
});
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", function() {
    return 0, _types.GRAPHQL_AUTH_MODE;
});
parcelHelpers.export(exports, "GraphQLAPI", function() {
    return 0, _graphQLAPI.GraphQLAPI;
});
parcelHelpers.export(exports, "GraphQLAPIClass", function() {
    return 0, _graphQLAPI.GraphQLAPIClass;
});
parcelHelpers.export(exports, "graphqlOperation", function() {
    return 0, _graphQLAPI.graphqlOperation;
});
var _graphQLAPI = require("./GraphQLAPI");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
exports.default = (0, _graphQLAPI.GraphQLAPI);

},{"./GraphQLAPI":"iO0J1","./types":"4viCr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iO0J1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", function() {
    return graphqlOperation;
});
parcelHelpers.export(exports, "GraphQLAPIClass", function() {
    return GraphQLAPIClass;
});
parcelHelpers.export(exports, "GraphQLAPI", function() {
    return GraphQLAPI;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var graphqlOperation = function graphqlOperation(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var GraphQLAPIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(GraphQLAPIClass, _super);
    function GraphQLAPIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphQLAPIClass.prototype.getModuleName = function() {
        return 'GraphQLAPI';
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ GraphQLAPIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return GraphQLAPIClass;
}((0, _internals.InternalGraphQLAPIClass));
var GraphQLAPI = new GraphQLAPIClass(null);
(0, _core.Amplify).register(GraphQLAPI);

},{"tslib":"fPXxt","@aws-amplify/core":"3rlh1","./internals":"fZD2p","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPd7W":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataStore", function() {
    return 0, _datastore.DataStore;
});
parcelHelpers.export(exports, "DataStoreClass", function() {
    return 0, _datastore.DataStoreClass;
});
parcelHelpers.export(exports, "initSchema", function() {
    return 0, _datastore.initSchema;
});
parcelHelpers.export(exports, "AsyncCollection", function() {
    return 0, _datastore.AsyncCollection;
});
parcelHelpers.export(exports, "AsyncItem", function() {
    return 0, _datastore.AsyncItem;
});
parcelHelpers.export(exports, "Predicates", function() {
    return 0, _predicates.Predicates;
});
parcelHelpers.export(exports, "ModelPredicateCreator", function() {
    return 0, _predicates.ModelPredicateCreator;
});
parcelHelpers.export(exports, "ModelSortPredicateCreator", function() {
    return 0, _predicates.ModelSortPredicateCreator;
});
parcelHelpers.export(exports, "NAMESPACES", function() {
    return 0, _util.NAMESPACES;
});
parcelHelpers.export(exports, "utils", function() {
    return utils;
});
var _datastore = require("./datastore/datastore");
var _predicates = require("./predicates");
var _util = require("./util");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var utils = {
    USER: (0, _util.USER),
    traverseModel: (0, _util.traverseModel),
    validatePredicate: (0, _util.validatePredicate),
    isNonModelConstructor: (0, _util.isNonModelConstructor),
    isModelConstructor: (0, _util.isModelConstructor)
};

},{"./datastore/datastore":"xIgIr","./predicates":"bohgw","./util":"iFXfl","./types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"xIgIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "syncClasses", function() {
    return syncClasses;
});
/**
 * Registers a model instance against a data source (DataStore, API, or
 * Detached/None).
 *
 * The API option is demonstrative. Lazy loading against API is not yet
 * implemented.
 *
 * @param result A model instance or array of instances
 * @param attachment A ModelAttachment data source
 * @returns passes the `result` back through after attachment
 */ parcelHelpers.export(exports, "attached", function() {
    return attached;
});
parcelHelpers.export(exports, "getAttachment", function() {
    return getAttachment;
});
parcelHelpers.export(exports, "AsyncItem", function() {
    return AsyncItem;
});
parcelHelpers.export(exports, "AsyncCollection", function() {
    return AsyncCollection;
});
parcelHelpers.export(exports, "DataStoreClass", function() {
    return DataStore;
});
parcelHelpers.export(exports, "initSchema", function() {
    return initSchema;
});
parcelHelpers.export(exports, "DataStore", function() {
    return instance;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _immer = require("immer");
var _uuid = require("uuid");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _authModeStrategies = require("../authModeStrategies");
var _predicates = require("../predicates");
var _storage = require("../storage/storage");
var _relationship = require("../storage/relationship");
var _sync = require("../sync");
var _types = require("../types");
var _util = require("../util");
var _next = require("../predicates/next");
var _utils = require("../sync/utils");
(0, _immer.setAutoFreeze)(true);
(0, _immer.enablePatches)();
var logger = new (0, _core.ConsoleLogger)('DataStore');
var ulid = (0, _util.monotonicUlidFactory)(Date.now());
var isNode = (0, _core.browserOrNode)().isNode;
var SETTING_SCHEMA_VERSION = 'schemaVersion';
var schema;
var modelNamespaceMap = new WeakMap();
/**
 * Stores data for crafting the correct update mutation input for a model.
 *
 * - `Patch[]` - array of changed fields and metadata.
 * - `PersistentModel` - the source model, used for diffing object-type fields.
 */ var modelPatchesMap = new WeakMap();
var getModelDefinition = function getModelDefinition(modelConstructor) {
    var namespace = modelNamespaceMap.get(modelConstructor);
    var definition = namespace ? schema.namespaces[namespace].models[modelConstructor.name] : undefined;
    return definition;
};
/**
 * Determines whether the given object is a Model Constructor that DataStore can
 * safely use to construct objects and discover related metadata.
 *
 * @param obj The object to test.
 */ var isValidModelConstructor = function isValidModelConstructor(obj) {
    return (0, _util.isModelConstructor)(obj) && modelNamespaceMap.has(obj);
};
var namespaceResolver = function namespaceResolver(modelConstructor) {
    var resolver = modelNamespaceMap.get(modelConstructor);
    if (!resolver) throw new Error("Namespace Resolver for '" + modelConstructor.name + "' not found! This is probably a bug in '@amplify-js/datastore'.");
    return resolver;
};
/**
 * Creates a predicate without any conditions that can be passed to customer
 * code to have conditions added to it.
 *
 * For example, in this query:
 *
 * ```ts
 * await DataStore.query(
 * 	Model,
 * 	item => item.field.eq('value')
 * );
 * ```
 *
 * `buildSeedPredicate(Model)` is used to create `item`, which is passed to the
 * predicate function, which in turn uses that "seed" predicate (`item`) to build
 * a predicate tree.
 *
 * @param modelConstructor The model the predicate will query.
 */ var buildSeedPredicate = function buildSeedPredicate(modelConstructor) {
    if (!modelConstructor) throw new Error('Missing modelConstructor');
    var modelSchema = getModelDefinition(modelConstructor);
    if (!modelSchema) throw new Error('Missing modelSchema');
    var pks = (0, _util.extractPrimaryKeyFieldNames)(modelSchema);
    if (!pks) throw new Error('Could not determine PK');
    return (0, _next.recursivePredicateFor)({
        builder: modelConstructor,
        schema: modelSchema,
        pkField: pks
    });
};
var syncClasses;
var userClasses;
var dataStoreClasses;
var storageClasses;
/**
 * Maps a model to its related models for memoization/immutability.
 */ var modelInstanceAssociationsMap = new WeakMap();
/**
 * Describes whether and to what a model is attached for lazy loading purposes.
 */ var ModelAttachment;
(function(ModelAttachment) {
    /**
     * Model doesn't lazy load from any data source.
     *
     * Related entity properties provided at instantiation are returned
     * via the respective lazy interfaces when their properties are invoked.
     */ ModelAttachment["Detached"] = "Detached";
    /**
     * Model lazy loads from the global DataStore.
     */ ModelAttachment["DataStore"] = "DataStore";
    /**
     * Demonstrative. Not yet implemented.
     */ ModelAttachment["API"] = "API";
})(ModelAttachment || (ModelAttachment = {}));
/**
 * Tells us which data source a model is attached to (lazy loads from).
 *
 * If `Deatched`, the model's lazy properties will only ever return properties
 * from memory provided at construction time.
 */ var attachedModelInstances = new WeakMap();
function attached(result, attachment) {
    if (Array.isArray(result)) result.map(function(record) {
        return attached(record, attachment);
    });
    else result && attachedModelInstances.set(result, attachment);
    return result;
}
var getAttachment = function getAttachment(instance) {
    return attachedModelInstances.has(instance) ? attachedModelInstances.get(instance) : ModelAttachment.Detached;
};
var initSchema = function initSchema(userSchema) {
    var _a;
    if (schema !== undefined) {
        console.warn('The schema has already been initialized');
        return userClasses;
    }
    logger.log('validating schema', {
        schema: userSchema
    });
    checkSchemaCodegenVersion(userSchema.codegenVersion);
    var internalUserNamespace = (0, _tslib.__assign)({
        name: (0, _util.USER)
    }, userSchema);
    logger.log('DataStore', 'Init models');
    userClasses = createTypeClasses(internalUserNamespace);
    logger.log('DataStore', 'Models initialized');
    var dataStoreNamespace = getNamespace();
    var storageNamespace = (0, _storage.ExclusiveStorage).getNamespace();
    var syncNamespace = (0, _sync.SyncEngine).getNamespace();
    dataStoreClasses = createTypeClasses(dataStoreNamespace);
    storageClasses = createTypeClasses(storageNamespace);
    syncClasses = createTypeClasses(syncNamespace);
    schema = {
        namespaces: (_a = {}, _a[dataStoreNamespace.name] = dataStoreNamespace, _a[internalUserNamespace.name] = internalUserNamespace, _a[storageNamespace.name] = storageNamespace, _a[syncNamespace.name] = syncNamespace, _a),
        version: userSchema.version,
        codegenVersion: userSchema.codegenVersion
    };
    Object.keys(schema.namespaces).forEach(function(namespace) {
        var e_1, _a;
        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(schema.namespaces[namespace]), 2), relations = _b[0], keys = _b[1];
        schema.namespaces[namespace].relationships = relations;
        schema.namespaces[namespace].keys = keys;
        var modelAssociations = new Map();
        Object.values(schema.namespaces[namespace].models).forEach(function(model) {
            var e_2, _a, e_3, _b;
            var connectedModels = [];
            Object.values(model.fields).filter(function(field) {
                return field.association && field.association.connectionType === 'BELONGS_TO' && field.type.model !== model.name;
            }).forEach(function(field) {
                return connectedModels.push(field.type.model);
            });
            modelAssociations.set(model.name, connectedModels);
            // Precompute model info (such as pk fields) so that downstream schema consumers
            // (such as predicate builders) don't have to reach back into "DataStore" space
            // to go looking for it.
            Object.values(model.fields).forEach(function(field) {
                var relatedModel = userClasses[field.type.model];
                if ((0, _util.isModelConstructor)(relatedModel)) Object.defineProperty(field.type, 'modelConstructor', {
                    get: function get() {
                        var relatedModelDefinition = getModelDefinition(relatedModel);
                        if (!relatedModelDefinition) throw new Error("Could not find model definition for " + relatedModel.name);
                        return {
                            builder: relatedModel,
                            schema: relatedModelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(relatedModelDefinition)
                        };
                    }
                });
            });
            // compatibility with legacy/pre-PK codegen for lazy loading to inject
            // index fields into the model definition.
            // definition.cloudFields = { ...definition.fields };
            var indexes = schema.namespaces[namespace].relationships[model.name].indexes;
            var indexFields = new Set();
            try {
                for(var indexes_1 = (0, _tslib.__values)(indexes), indexes_1_1 = indexes_1.next(); !indexes_1_1.done; indexes_1_1 = indexes_1.next()){
                    var index = indexes_1_1.value;
                    try {
                        for(var _c = (e_3 = void 0, (0, _tslib.__values)(index[1])), _d = _c.next(); !_d.done; _d = _c.next()){
                            var indexField = _d.value;
                            indexFields.add(indexField);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (indexes_1_1 && !indexes_1_1.done && (_a = indexes_1.return)) _a.call(indexes_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            model.allFields = (0, _tslib.__assign)((0, _tslib.__assign)({}, Object.fromEntries((0, _tslib.__spread)(indexFields.values()).map(function(name) {
                return [
                    name,
                    {
                        name: name,
                        type: 'ID',
                        isArray: false
                    }
                ];
            }))), model.fields);
        });
        var result = new Map();
        var count = 1000;
        while(count > 0){
            if (modelAssociations.size === 0) break;
            count--;
            if (count === 0) throw new Error('Models are not topologically sortable. Please verify your schema.');
            try {
                for(var _c = (e_1 = void 0, (0, _tslib.__values)(Array.from(modelAssociations.keys()))), _d = _c.next(); !_d.done; _d = _c.next()){
                    var modelName = _d.value;
                    var parents = modelAssociations.get(modelName);
                    if (parents === null || parents === void 0 ? void 0 : parents.every(function(x) {
                        return result.has(x);
                    })) result.set(modelName, parents);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            Array.from(result.keys()).forEach(function(x) {
                return modelAssociations.delete(x);
            });
        }
        schema.namespaces[namespace].modelTopologicalOrdering = result;
    });
    return userClasses;
};
/**
 * Throws an exception if the schema has *not* been initialized
 * by `initSchema()`.
 *
 * **To be called before trying to access schema.**
 *
 * Currently this only needs to be called in `start()` and `clear()` because
 * all other functions will call start first.
 */ var checkSchemaInitialized = function checkSchemaInitialized() {
    if (schema === undefined) {
        var message = 'Schema is not initialized. DataStore will not function as expected. This could happen if you have multiple versions of DataStore installed. Please see https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js/#check-for-duplicate-versions';
        logger.error(message);
        throw new Error(message);
    }
};
/**
 * Throws an exception if the schema is using a codegen version that is not supported.
 *
 * Set the supported version by setting majorVersion and minorVersion
 * This functions similar to ^ version range.
 * The tested codegenVersion major version must exactly match the set majorVersion
 * The tested codegenVersion minor version must be gt or equal to the set minorVersion
 * Example: For a min supported version of 5.4.0 set majorVersion = 5 and minorVersion = 4
 *
 * This regex will not work when setting a supported range with minor version
 * of 2 or more digits.
 * i.e. minorVersion = 10 will not work
 * The regex will work for testing a codegenVersion with multi digit minor
 * versions as long as the minimum minorVersion is single digit.
 * i.e. codegenVersion = 5.30.1, majorVersion = 5, minorVersion = 4 PASSES
 *
 * @param codegenVersion schema codegenVersion
 */ var checkSchemaCodegenVersion = function checkSchemaCodegenVersion(codegenVersion) {
    var majorVersion = 3;
    var minorVersion = 2;
    var isValid = false;
    try {
        var versionParts = codegenVersion.split('.');
        var _a = (0, _tslib.__read)(versionParts, 4), major = _a[0], minor = _a[1], patch = _a[2], patchrevision = _a[3];
        isValid = Number(major) === majorVersion && Number(minor) >= minorVersion;
    } catch (err) {
        console.log("Error parsing codegen version: " + codegenVersion + "\n" + err);
    }
    if (!isValid) {
        var message = "Models were generated with an unsupported version of codegen. Codegen artifacts are from " + (codegenVersion || 'an unknown version') + ", whereas ^" + majorVersion + "." + minorVersion + ".0 is required. " + "Update to the latest CLI and run 'amplify codegen models'.";
        logger.error(message);
        throw new Error(message);
    }
};
var createTypeClasses = function createTypeClasses(namespace) {
    var classes = {};
    Object.entries(namespace.models).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], modelDefinition = _b[1];
        var clazz = createModelClass(modelDefinition);
        classes[modelName] = clazz;
        modelNamespaceMap.set(clazz, namespace.name);
    });
    Object.entries(namespace.nonModels || {}).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), typeName = _b[0], typeDefinition = _b[1];
        var clazz = createNonModelClass(typeDefinition);
        classes[typeName] = clazz;
    });
    return classes;
};
/**
 * Collection of instantiated models to allow storage of metadata apart from
 * the model visible to the consuming app -- in case the app doesn't have
 * metadata fields (_version, _deleted, etc.) exposed on the model itself.
 */ var instancesMetadata = new WeakSet();
function modelInstanceCreator(modelConstructor, init) {
    instancesMetadata.add(init);
    return new modelConstructor(init);
}
var validateModelFields = function validateModelFields1(modelDefinition) {
    return function(k, v) {
        var fieldDefinition = modelDefinition.fields[k];
        if (fieldDefinition !== undefined) {
            var type_1 = fieldDefinition.type, isRequired_1 = fieldDefinition.isRequired, isArrayNullable = fieldDefinition.isArrayNullable, name_1 = fieldDefinition.name, isArray = fieldDefinition.isArray;
            var timestamps = (0, _types.isSchemaModelWithAttributes)(modelDefinition) ? (0, _util.getTimestampFields)(modelDefinition) : {};
            var isTimestampField = !!timestamps[name_1];
            if ((!isArray && isRequired_1 || isArray && !isArrayNullable) && !isTimestampField && (v === null || v === undefined)) throw new Error("Field " + name_1 + " is required");
            if ((0, _types.isSchemaModelWithAttributes)(modelDefinition) && !(0, _util.isIdManaged)(modelDefinition)) {
                var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                if (keys.includes(k) && v === '') {
                    logger.error((0, _util.errorMessages).idEmptyString, {
                        k: k,
                        value: v
                    });
                    throw new Error((0, _util.errorMessages).idEmptyString);
                }
            }
            if ((0, _types.isGraphQLScalarType)(type_1)) {
                var jsType_1 = (0, _types.GraphQLScalarType).getJSType(type_1);
                var validateScalar_1 = (0, _types.GraphQLScalarType).getValidationFunction(type_1);
                if (type_1 === 'AWSJSON') {
                    if ((typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === jsType_1) return;
                    if (typeof v === 'string') try {
                        JSON.parse(v);
                        return;
                    } catch (error) {
                        throw new Error("Field " + name_1 + " is an invalid JSON object. " + v);
                    }
                }
                if (isArray) {
                    var errorTypeText = jsType_1;
                    if (!isRequired_1) errorTypeText = jsType_1 + " | null | undefined";
                    if (!Array.isArray(v) && !isArrayNullable) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) + " received. " + v);
                    if (!(0, _util.isNullOrUndefined)(v) && v.some(function(e) {
                        return (0, _util.isNullOrUndefined)(e) ? isRequired_1 : (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) !== jsType_1;
                    })) {
                        var elemTypes = v.map(function(e) {
                            return e === null ? 'null' : typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e);
                        }).join(',');
                        throw new Error("All elements in the " + name_1 + " array should be of type " + errorTypeText + ", [" + elemTypes + "] received. " + v);
                    }
                    if (validateScalar_1 && !(0, _util.isNullOrUndefined)(v)) {
                        var validationStatus = v.map(function(e) {
                            if (!(0, _util.isNullOrUndefined)(e)) return validateScalar_1(e);
                            else if ((0, _util.isNullOrUndefined)(e) && !isRequired_1) return true;
                            else return false;
                        });
                        if (!validationStatus.every(function(s) {
                            return s;
                        })) throw new Error("All elements in the " + name_1 + " array should be of type " + type_1 + ", validation failed for one or more elements. " + v);
                    }
                } else if (!isRequired_1 && v === undefined) return;
                else if ((typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) !== jsType_1 && v !== null) throw new Error("Field " + name_1 + " should be of type " + jsType_1 + ", " + (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) + " received. " + v);
                else if (!(0, _util.isNullOrUndefined)(v) && validateScalar_1 && !validateScalar_1(v) // TODO: why never, TS ... why ...
                ) throw new Error("Field " + name_1 + " should be of type " + type_1 + ", validation failed. " + v);
            } else if ((0, _types.isNonModelFieldType)(type_1)) // do not check non model fields if undefined or null
            {
                if (!(0, _util.isNullOrUndefined)(v)) {
                    var subNonModelDefinition_1 = schema.namespaces.user.nonModels[type_1.nonModel];
                    var modelValidator_1 = validateModelFields(subNonModelDefinition_1);
                    if (isArray) {
                        var errorTypeText = type_1.nonModel;
                        if (!isRequired_1) errorTypeText = type_1.nonModel + " | null | undefined";
                        if (!Array.isArray(v)) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) + " received. " + v);
                        v.forEach(function(item) {
                            if ((0, _util.isNullOrUndefined)(item) && isRequired_1 || (typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) !== 'object' && typeof item !== 'undefined') throw new Error("All elements in the " + name_1 + " array should be of type " + type_1.nonModel + ", [" + (typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) + "] received. " + item);
                            if (!(0, _util.isNullOrUndefined)(item)) Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                                modelValidator_1(subKey, item[subKey]);
                            });
                        });
                    } else {
                        if ((typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) !== 'object') throw new Error("Field " + name_1 + " should be of type " + type_1.nonModel + ", " + (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) + " recieved. " + v);
                        Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                            modelValidator_1(subKey, v[subKey]);
                        });
                    }
                }
            }
        }
    };
};
var castInstanceType = function castInstanceType(modelDefinition, k, v) {
    var _a = modelDefinition.fields[k] || {}, isArray = _a.isArray, type = _a.type;
    // attempt to parse stringified JSON
    if (typeof v === 'string' && (isArray || type === 'AWSJSON' || (0, _types.isNonModelFieldType)(type) || (0, _types.isModelFieldType)(type))) try {
        return JSON.parse(v);
    } catch (_b) {
    // if JSON is invalid, don't throw and let modelValidator handle it
    }
    // cast from numeric representation of boolean to JS boolean
    if (typeof v === 'number' && type === 'Boolean') return Boolean(v);
    return v;
};
/**
 * Records the patches (as if against an empty object) used to initialize
 * an instance of a Model. This can be used for determining which fields to
 * send to the cloud durnig a CREATE mutation.
 */ var initPatches = new WeakMap();
/**
 * Attempts to apply type-aware, casted field values from a given `init`
 * object to the given `draft`.
 *
 * @param init The initialization object to extract field values from.
 * @param modelDefinition The definition describing the target object shape.
 * @param draft The draft to apply field values to.
 */ var initializeInstance = function initializeInstance(init, modelDefinition, draft) {
    var modelValidator = validateModelFields(modelDefinition);
    Object.entries(init).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        var parsedValue = castInstanceType(modelDefinition, k, v);
        modelValidator(k, parsedValue);
        draft[k] = parsedValue;
    });
};
/**
 * Updates a draft to standardize its customer-defined fields so that they are
 * consistent with the data as it would look after having been synchronized from
 * Cloud storage.
 *
 * The exceptions to this are:
 *
 * 1. Non-schema/Internal [sync] metadata fields.
 * 2. Cloud-managed fields, which are `null` until set by cloud storage.
 *
 * This function should be expanded if/when deviations between canonical Cloud
 * storage data and locally managed data are found. For now, the known areas
 * that require normalization are:
 *
 * 1. Ensuring all non-metadata fields are *defined*. (I.e., turn `undefined` -> `null`.)
 *
 * @param modelDefinition Definition for the draft. Used to discover all fields.
 * @param draft The instance draft to apply normalizations to.
 */ var normalize = function normalize(modelDefinition, draft) {
    var e_4, _a;
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(modelDefinition.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
            var k = _c.value;
            if (draft[k] === undefined) draft[k] = null;
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
};
var createModelClass = function createModelClass(modelDefinition) {
    var e_5, _a;
    var clazz = /** @class */ function() {
        function Model(init) {
            // we create a base instance first so we can distinguish which fields were explicitly
            // set by customer code versus those set by normalization. only those fields
            // which are explicitly set by customers should be part of create mutations.
            var patches = [];
            var baseInstance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, modelDefinition, draft);
                // model is initialized inside a DataStore component (e.g. by Sync Engine, Storage Engine, etc.)
                var isInternallyInitialized = instancesMetadata.has(init);
                var modelInstanceMetadata = isInternallyInitialized ? init : {};
                var _id = modelInstanceMetadata.id;
                if ((0, _util.isIdManaged)(modelDefinition)) {
                    var isInternalModel = _id !== null && _id !== undefined;
                    var id = isInternalModel ? _id : modelDefinition.syncable ? (0, _uuid.v4)() : ulid();
                    draft.id = id;
                } else if ((0, _util.isIdOptionallyManaged)(modelDefinition)) // only auto-populate if the id was not provided
                draft.id = draft.id || (0, _uuid.v4)();
                if (!isInternallyInitialized) checkReadOnlyPropertyOnCreate(draft, modelDefinition);
                var _version = modelInstanceMetadata._version, _lastChangedAt = modelInstanceMetadata._lastChangedAt, _deleted = modelInstanceMetadata._deleted;
                if (modelDefinition.syncable) {
                    draft._version = _version;
                    draft._lastChangedAt = _lastChangedAt;
                    draft._deleted = _deleted;
                }
            }, function(p) {
                return patches = p;
            });
            // now that we have a list of patches that encapsulate the explicit, customer-provided
            // fields, we can normalize. patches from normalization are ignored, because the changes
            // are only create to provide a consistent view of the data for fields pre/post sync
            // where possible. (not all fields can be normalized pre-sync, because they're generally
            // "cloud managed" fields, like createdAt and updatedAt.)
            var normalized = (0, _immer.produce)(baseInstance, function(draft) {
                return normalize(modelDefinition, draft);
            });
            initPatches.set(normalized, patches);
            return normalized;
        }
        Model.copyOf = function(source, fn) {
            var modelConstructor = Object.getPrototypeOf(source || {}).constructor;
            if (!isValidModelConstructor(modelConstructor)) {
                var msg = 'The source object is not a valid model';
                logger.error(msg, {
                    source: source
                });
                throw new Error(msg);
            }
            var patches = [];
            var model = (0, _immer.produce)(source, function(draft) {
                fn(draft);
                var keyNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                // Keys are immutable
                keyNames.forEach(function(key) {
                    if (draft[key] !== source[key]) logger.warn("copyOf() does not update PK fields. The '" + key + "' update is being ignored.", {
                        source: source
                    });
                    draft[key] = source[key];
                });
                var modelValidator = validateModelFields(modelDefinition);
                Object.entries(draft).forEach(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    var parsedValue = castInstanceType(modelDefinition, k, v);
                    modelValidator(k, parsedValue);
                });
                normalize(modelDefinition, draft);
            }, function(p) {
                return patches = p;
            });
            var hasExistingPatches = modelPatchesMap.has(source);
            if (patches.length || hasExistingPatches) {
                if (hasExistingPatches) {
                    var _a = (0, _tslib.__read)(modelPatchesMap.get(source), 2), existingPatches = _a[0], existingSource = _a[1];
                    var mergedPatches = (0, _util.mergePatches)(existingSource, existingPatches, patches);
                    modelPatchesMap.set(model, [
                        mergedPatches,
                        existingSource
                    ]);
                    checkReadOnlyPropertyOnUpdate(mergedPatches, modelDefinition);
                } else {
                    modelPatchesMap.set(model, [
                        patches,
                        source
                    ]);
                    checkReadOnlyPropertyOnUpdate(patches, modelDefinition);
                }
            } else // always register patches when performing a copyOf, even if the
            // patches list is empty. this allows `save()` to recognize when an
            // instance is the result of a `copyOf()`. without more significant
            // refactoring, this is the only way for `save()` to know which
            // diffs (patches) are relevant for `storage` to use in building
            // the list of "changed" fields for mutations.
            modelPatchesMap.set(model, [
                [],
                source
            ]);
            return attached(model, ModelAttachment.DataStore);
        };
        // "private" method (that's hidden via `Setting`) for `withSSRContext` to use
        // to gain access to `modelInstanceCreator` and `clazz` for persisting IDs from server to client.
        Model.fromJSON = function(json) {
            var _this = this;
            if (Array.isArray(json)) return json.map(function(init) {
                return _this.fromJSON(init);
            });
            var instance = modelInstanceCreator(clazz, json);
            var modelValidator = validateModelFields(modelDefinition);
            Object.entries(instance).forEach(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                modelValidator(k, v);
            });
            return attached(instance, ModelAttachment.DataStore);
        };
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, 'name', {
        value: modelDefinition.name
    });
    // Add getters/setters for relationship fields.
    //  getter - for lazy loading
    //  setter - for FK management
    var allModelRelationships = (0, _relationship.ModelRelationship).allFrom({
        builder: clazz,
        schema: modelDefinition,
        pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
    });
    var _loop_1 = function _loop_1(relationship) {
        var field = relationship.field;
        Object.defineProperty(clazz.prototype, modelDefinition.fields[field].name, {
            set: function set(model) {
                if (!((typeof model === "undefined" ? "undefined" : (0, _typeOf._)(model)) === 'object' || typeof model === 'undefined')) return;
                // if model is undefined or null, the connection should be removed
                if (model) // Avoid validation error when processing AppSync response with nested
                // selection set. Nested entitites lack version field and can not be validated
                // TODO: explore a more reliable method to solve this
                {
                    if (model.hasOwnProperty('_version')) {
                        var modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                        if (!isValidModelConstructor(modelConstructor)) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not a valid instance of a model";
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                        if (modelConstructor.name.toLowerCase() !== relationship.remoteModelConstructor.name.toLowerCase()) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not an instance of " + relationship.remoteModelConstructor.name;
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                    }
                }
                // if the relationship can be managed automagically, set the FK's
                if (relationship.isComplete) {
                    for(var i = 0; i < relationship.localJoinFields.length; i++)this[relationship.localJoinFields[i]] = model === null || model === void 0 ? void 0 : model[relationship.remoteJoinFields[i]];
                    var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                    instanceMemos[field] = model || undefined;
                }
            },
            get: function get() {
                var _this = this;
                /**
                 * Bucket for holding related models instances specific to `this` instance.
                 */ var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                // if the memos already has a result for this field, we'll use it.
                // there is no "cache" invalidation of any kind; memos are permanent to
                // keep an immutable perception of the instance.
                if (!instanceMemos.hasOwnProperty(field)) {
                    // before we populate the memo, we need to know where to look for relatives.
                    // today, this only supports DataStore. Models aren't managed elsewhere in Amplify.
                    if (getAttachment(this) === ModelAttachment.DataStore) {
                        // when we fetch the results using a query constructed under the guidance
                        // of the relationship metadata, we DO NOT AWAIT resolution. we want to
                        // drop the promise into the memo's synchronously, eliminating the chance
                        // for a race.
                        var resultPromise = instance.query(relationship.remoteModelConstructor, function(base) {
                            return base.and(function(q) {
                                return relationship.remoteJoinFields.map(function(field, index) {
                                    // TODO: anything we can use instead of `any` here?
                                    return q[field].eq(_this[relationship.localJoinFields[index]]);
                                });
                            });
                        });
                        // results in hand, how we return them to the caller depends on the relationship type.
                        if (relationship.type === 'HAS_MANY') // collections should support async iteration, even though we don't
                        // leverage it fully [yet].
                        instanceMemos[field] = new AsyncCollection(resultPromise);
                        else // non-collections should only ever return 1 value *or nothing*.
                        // if we have more than 1 record, something's amiss. it's not our job
                        // pick a result for the customer. it's our job to say "something's wrong."
                        instanceMemos[field] = resultPromise.then(function(rows) {
                            if (rows.length > 1) {
                                // should never happen for a HAS_ONE or BELONGS_TO.
                                var err = new Error("\n\t\t\t\t\t\t\t\t\tData integrity error.\n\t\t\t\t\t\t\t\t\tToo many records found for a HAS_ONE/BELONGS_TO field '" + modelDefinition.name + "." + field + "'\n\t\t\t\t\t\t\t\t");
                                console.error(err);
                                throw err;
                            } else return rows[0];
                        });
                    } else if (getAttachment(this) === ModelAttachment.API) throw new Error('Lazy loading from API is not yet supported!');
                    else {
                        if (relationship.type === 'HAS_MANY') return new AsyncCollection([]);
                        else return Promise.resolve(undefined);
                    }
                }
                return instanceMemos[field];
            }
        });
    };
    try {
        for(var allModelRelationships_1 = (0, _tslib.__values)(allModelRelationships), allModelRelationships_1_1 = allModelRelationships_1.next(); !allModelRelationships_1_1.done; allModelRelationships_1_1 = allModelRelationships_1.next()){
            var relationship = allModelRelationships_1_1.value;
            _loop_1(relationship);
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (allModelRelationships_1_1 && !allModelRelationships_1_1.done && (_a = allModelRelationships_1.return)) _a.call(allModelRelationships_1);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return clazz;
};
/**
 * An eventually loaded related model instance.
 */ var AsyncItem = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncItem, _super);
    function AsyncItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AsyncItem;
}(Promise);
/**
 * A collection of related model instances.
 *
 * This collection can be async-iterated or turned directly into an array using `toArray()`.
 */ var AsyncCollection = /** @class */ function() {
    function AsyncCollection(values) {
        this.values = values;
    }
    /**
     * Facilitates async iteration.
     *
     * ```ts
     * for await (const item of collection) {
     *   handle(item)
     * }
     * ```
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of
     */ AsyncCollection.prototype[Symbol.asyncIterator] = function() {
        var _this = this;
        var values;
        var index = 0;
        return {
            next: function next() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var result;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!values) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.values
                                ];
                            case 1:
                                values = _a.sent();
                                _a.label = 2;
                            case 2:
                                if (index < values.length) {
                                    result = {
                                        value: values[index],
                                        done: false
                                    };
                                    index++;
                                    return [
                                        2 /*return*/ ,
                                        result
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    {
                                        value: null,
                                        done: true
                                    }
                                ];
                        }
                    });
                });
            }
        };
    };
    /**
     * Turns the collection into an array, up to the amount specified in `max` param.
     *
     * ```ts
     * const all = await collection.toArray();
     * const first100 = await collection.toArray({max: 100});
     * ```
     */ AsyncCollection.prototype.toArray = function(_a) {
        var _b = (_a === void 0 ? {} : _a).max, max = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b;
        var e_6, _c;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var output, i, _d, _e, element, e_6_1;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        output = [];
                        i = 0;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        _d = (0, _tslib.__asyncValues)(this);
                        _f.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _d.next()
                        ];
                    case 3:
                        if (!(_e = _f.sent(), !_e.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        element = _e.value;
                        if (i < max) {
                            output.push(element);
                            i++;
                        } else return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_6_1 = _f.sent();
                        e_6 = {
                            error: e_6_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _f.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(_e && !_e.done && (_c = _d.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(_d)
                        ];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_6) throw e_6.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        return [
                            2 /*return*/ ,
                            output
                        ];
                }
            });
        });
    };
    return AsyncCollection;
}();
var checkReadOnlyPropertyOnCreate = function checkReadOnlyPropertyOnCreate(draft, modelDefinition) {
    var modelKeys = Object.keys(draft);
    var fields = modelDefinition.fields;
    modelKeys.forEach(function(key) {
        if (fields[key] && fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var checkReadOnlyPropertyOnUpdate = function checkReadOnlyPropertyOnUpdate(patches, modelDefinition) {
    var patchArray = patches.map(function(p) {
        return [
            p.path[0],
            p.value
        ];
    });
    var fields = modelDefinition.fields;
    patchArray.forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], val = _b[1];
        if (!val || !fields[key]) return;
        if (fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var createNonModelClass = function createNonModelClass(typeDefinition) {
    var clazz = /** @class */ function() {
        function Model(init) {
            var instance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, typeDefinition, draft);
            });
            return instance;
        }
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, 'name', {
        value: typeDefinition.name
    });
    (0, _util.registerNonModelClass)(clazz);
    return clazz;
};
function isQueryOne(obj) {
    return typeof obj === 'string';
}
function defaultConflictHandler(conflictData) {
    var localModel = conflictData.localModel, modelConstructor = conflictData.modelConstructor, remoteModel = conflictData.remoteModel;
    var _version = remoteModel._version;
    return modelInstanceCreator(modelConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, localModel), {
        _version: _version
    }));
}
function defaultErrorHandler(error) {
    logger.warn(error);
}
function getModelConstructorByModelName(namespaceName, modelName) {
    var result;
    switch(namespaceName){
        case 0, _util.DATASTORE:
            result = dataStoreClasses[modelName];
            break;
        case 0, _util.USER:
            result = userClasses[modelName];
            break;
        case 0, _util.SYNC:
            result = syncClasses[modelName];
            break;
        case 0, _util.STORAGE:
            result = storageClasses[modelName];
            break;
        default:
            throw new Error("Invalid namespace: " + namespaceName);
    }
    if (isValidModelConstructor(result)) return result;
    else {
        var msg = "Model name is not valid for namespace. modelName: " + modelName + ", namespace: " + namespaceName;
        logger.error(msg);
        throw new Error(msg);
    }
}
/**
 * Queries the DataStore metadata tables to see if they are the expected
 * version. If not, clobbers the whole DB. If so, leaves them alone.
 * Otherwise, simply writes the schema version.
 *
 * SIDE EFFECT:
 * 1. Creates a transaction
 * 1. Updates data.
 *
 * @param storage Storage adapter containing the metadata.
 * @param version The expected schema version.
 */ function checkSchemaVersion(storage, version) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var Setting, modelDefinition;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    Setting = dataStoreClasses.Setting;
                    modelDefinition = schema.namespaces[0, _util.DATASTORE].models.Setting;
                    return [
                        4 /*yield*/ ,
                        storage.runExclusive(function(s) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var _$_a, schemaVersionSetting, storedValue;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                s.query(Setting, (0, _predicates.ModelPredicateCreator).createFromAST(modelDefinition, {
                                                    and: {
                                                        key: {
                                                            eq: SETTING_SCHEMA_VERSION
                                                        }
                                                    }
                                                }), {
                                                    page: 0,
                                                    limit: 1
                                                })
                                            ];
                                        case 1:
                                            _$_a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), schemaVersionSetting = _$_a[0];
                                            if (!(schemaVersionSetting !== undefined && schemaVersionSetting.value !== undefined)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            storedValue = JSON.parse(schemaVersionSetting.value);
                                            if (!(storedValue !== version)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                s.clear(false)
                                            ];
                                        case 2:
                                            _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 4:
                                            return [
                                                4 /*yield*/ ,
                                                s.save(modelInstanceCreator(Setting, {
                                                    key: SETTING_SCHEMA_VERSION,
                                                    value: JSON.stringify(version)
                                                }))
                                            ];
                                        case 5:
                                            _b.sent();
                                            _b.label = 6;
                                        case 6:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var syncSubscription;
function getNamespace() {
    var namespace = {
        name: (0, _util.DATASTORE),
        relationships: {},
        enums: {},
        nonModels: {},
        models: {
            Setting: {
                name: 'Setting',
                pluralName: 'Settings',
                syncable: false,
                fields: {
                    id: {
                        name: 'id',
                        type: 'ID',
                        isRequired: true,
                        isArray: false
                    },
                    key: {
                        name: 'key',
                        type: 'String',
                        isRequired: true,
                        isArray: false
                    },
                    value: {
                        name: 'value',
                        type: 'String',
                        isRequired: true,
                        isArray: false
                    }
                }
            }
        }
    };
    return namespace;
}
var DataStoreState;
(function(DataStoreState) {
    DataStoreState["NotRunning"] = "Not Running";
    DataStoreState["Starting"] = "Starting";
    DataStoreState["Running"] = "Running";
    DataStoreState["Stopping"] = "Stopping";
    DataStoreState["Clearing"] = "Clearing";
})(DataStoreState || (DataStoreState = {}));
// TODO: How can we get rid of the non-null assertions?
// https://github.com/aws-amplify/amplify-js/pull/10477/files#r1007363485
var DataStore = /** @class */ function() {
    function DataStore() {
        var _this = this;
        // reference to configured category instances. Used for preserving SSR context
        this.Auth = (0, _auth.Auth);
        this.InternalAPI = (0, _internals.InternalAPI);
        this.Cache = (0, _cache.Cache);
        // Non-null assertions (bang operator) have been added to most of these properties
        // to make TS happy. These properties are all expected to be set immediately after
        // construction.
        // TODO: Refactor to use proper DI if possible. If not possible, change these to
        // optionals and implement conditional checks throughout. Rinse/repeat on all
        // sync engine processors, storage engine, adapters, etc..
        this.amplifyConfig = {};
        this.syncPredicates = new WeakMap();
        // object that gets passed to descendent classes. Allows us to pass these down by reference
        this.amplifyContext = {
            Auth: this.Auth,
            InternalAPI: this.InternalAPI,
            Cache: this.Cache
        };
        /**
         * **IMPORTANT!**
         *
         * Accumulator for background things that can **and MUST** be called when
         * DataStore stops.
         *
         * These jobs **MUST** be *idempotent promises* that resolve ONLY
         * once the intended jobs are completely finished and/or otherwise destroyed
         * and cleaned up with ZERO outstanding:
         *
         * 1. side effects (e.g., state changes)
         * 1. callbacks
         * 1. subscriptions
         * 1. calls to storage
         * 1. *etc.*
         *
         * Methods that create pending promises, subscriptions, callbacks, or any
         * type of side effect **MUST** be registered with the manager. And, a new
         * manager must be created after each `exit()`.
         *
         * Failure to comply will put DataStore into a highly unpredictable state
         * when it needs to stop or clear -- which occurs when restarting with new
         * sync expressions, during testing, and potentially during app code
         * recovery handling, etc..
         *
         * It is up to the discretion of each disposer whether to wait for job
         * completion or to cancel operations and issue failures *as long as the
         * disposer returns in a reasonable amount of time.*
         *
         * (Reasonable = *seconds*, not minutes.)
         */ this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        /**
         * Indicates what state DataStore is in.
         *
         * Not [yet?] used for actual state management; but for messaging
         * when errors occur, to help troubleshoot.
         */ this.state = DataStoreState.NotRunning;
        /**
         * If not already done:
         * 1. Attaches and initializes storage.
         * 2. Loads the schema and records metadata.
         * 3. If `this.amplifyConfig.aws_appsync_graphqlEndpoint` contains a URL,
         * attaches a sync engine, starts it, and subscribes.
         */ this.start = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var aws_appsync_graphqlEndpoint, _a, fullSyncIntervalInMilliseconds;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            this.state = DataStoreState.Starting;
                                            if (!(this.initialized === undefined)) return [
                                                3 /*break*/ ,
                                                1
                                            ];
                                            logger.debug('Starting DataStore');
                                            this.initialized = new Promise(function(res, rej) {
                                                _this.initResolve = res;
                                                _this.initReject = rej;
                                            });
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 2:
                                            _b.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        case 3:
                                            this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.init()
                                            ];
                                        case 4:
                                            _b.sent();
                                            checkSchemaInitialized();
                                            return [
                                                4 /*yield*/ ,
                                                checkSchemaVersion(this.storage, schema.version)
                                            ];
                                        case 5:
                                            _b.sent();
                                            aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                                            if (!aws_appsync_graphqlEndpoint) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            logger.debug('GraphQL endpoint available', aws_appsync_graphqlEndpoint);
                                            _a = this;
                                            return [
                                                4 /*yield*/ ,
                                                this.processSyncExpressions()
                                            ];
                                        case 6:
                                            _a.syncPredicates = _b.sent();
                                            this.sync = new (0, _sync.SyncEngine)(schema, namespaceResolver, syncClasses, userClasses, this.storage, modelInstanceCreator, this.conflictHandler, this.errorHandler, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, this.amplifyContext, this.connectivityMonitor);
                                            fullSyncIntervalInMilliseconds = this.fullSyncInterval * 60000;
                                            syncSubscription = this.sync.start({
                                                fullSyncInterval: fullSyncIntervalInMilliseconds
                                            }).subscribe({
                                                next: function next(_a) {
                                                    var type = _a.type, data = _a.data;
                                                    // In Node, we need to wait for queries to be synced to prevent returning empty arrays.
                                                    // In the Browser, we can begin returning data once subscriptions are in place.
                                                    var readyType = isNode ? (0, _sync.ControlMessage).SYNC_ENGINE_SYNC_QUERIES_READY : (0, _sync.ControlMessage).SYNC_ENGINE_STORAGE_SUBSCRIBED;
                                                    if (type === readyType) _this.initResolve();
                                                    (0, _core.Hub).dispatch('datastore', {
                                                        event: type,
                                                        data: data
                                                    });
                                                },
                                                error: function error(err) {
                                                    logger.warn('Sync error', err);
                                                    _this.initReject();
                                                }
                                            });
                                            return [
                                                3 /*break*/ ,
                                                8
                                            ];
                                        case 7:
                                            logger.warn("Data won't be synchronized. No GraphQL endpoint configured. Did you forget `Amplify.configure(awsconfig)`?", {
                                                config: this.amplifyConfig
                                            });
                                            this.initResolve();
                                            _b.label = 8;
                                        case 8:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 9:
                                            _b.sent();
                                            this.state = DataStoreState.Running;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }, 'datastore start').catch(this.handleAddProcError('DataStore.start()'))
                    ];
                });
            });
        };
        this.query = function(modelConstructor, identifierOrCriteria, paginationProducer) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var result, msg, modelDefinition, pagination, keyFields, msg, predicate, predicate, seedPredicate, predicate, returnOne;
                                var _a;
                                var _b;
                                return (0, _tslib.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _c.sent();
                                            if (!this.storage) throw new Error('No storage to query');
                                            //#region Input validation
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = 'Constructor is not for a valid model';
                                                logger.error(msg, {
                                                    modelConstructor: modelConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (typeof identifierOrCriteria === 'string') {
                                                if (paginationProducer !== undefined) logger.warn('Pagination is ignored when querying by id');
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error('Invalid model definition provided!');
                                            pagination = this.processPagination(modelDefinition, paginationProducer);
                                            keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                            if (!isQueryOne(identifierOrCriteria)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            if (keyFields.length > 1) {
                                                msg = (0, _util.errorMessages).queryByPkWithCompositeKeyPresent;
                                                logger.error(msg, {
                                                    keyFields: keyFields
                                                });
                                                throw new Error(msg);
                                            }
                                            predicate = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_a = {}, _a[keyFields[0]] = identifierOrCriteria, _a));
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 2:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 3:
                                            if (!(0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            predicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 4:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 5:
                                            if (!(!identifierOrCriteria || (0, _predicates.isPredicatesAll)(identifierOrCriteria))) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (_b = this.storage) === null || _b === void 0 ? void 0 : _b.query(modelConstructor, undefined, pagination)
                                            ];
                                        case 6:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 7:
                                            seedPredicate = (0, _next.recursivePredicateFor)({
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            });
                                            predicate = (0, _next.internals)(identifierOrCriteria(seedPredicate));
                                            return [
                                                4 /*yield*/ ,
                                                predicate.fetch(this.storage)
                                            ];
                                        case 8:
                                            result = _c.sent();
                                            result = (0, _util.inMemoryPagination)(result, pagination);
                                            _c.label = 9;
                                        case 9:
                                            returnOne = isQueryOne(identifierOrCriteria) || (0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition);
                                            return [
                                                2 /*return*/ ,
                                                attached(returnOne ? result[0] : result, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, 'datastore query').catch(this.handleAddProcError('DataStore.query()'))
                    ];
                });
            });
        };
        this.save = function(model, condition) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var updatedPatchesTuple, initPatchesTuple, patchesTuple, modelConstructor, msg, modelDefinition, modelMeta, producedCondition, _a, savedModel;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _b.sent();
                                            if (!this.storage) throw new Error('No storage to save to');
                                            updatedPatchesTuple = modelPatchesMap.get(model);
                                            initPatchesTuple = initPatches.has(model) ? [
                                                initPatches.get(model),
                                                {}
                                            ] : undefined;
                                            patchesTuple = updatedPatchesTuple || initPatchesTuple;
                                            modelConstructor = model ? model.constructor : undefined;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = 'Object is not an instance of a valid model';
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error('Model Definition could not be found for model');
                                            modelMeta = {
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            };
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var nonHasManyRelationships, nonHasManyRelationships_1, nonHasManyRelationships_1_1, relationship, queryObject, related, e_7_1;
                                                        var e_7, _a;
                                                        var _$_b;
                                                        return (0, _tslib.__generator)(this, function(_c) {
                                                            switch(_c.label){
                                                                case 0:
                                                                    nonHasManyRelationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                                                                        return r.type === 'BELONGS_TO';
                                                                    });
                                                                    _c.label = 1;
                                                                case 1:
                                                                    _c.trys.push([
                                                                        1,
                                                                        6,
                                                                        7,
                                                                        8
                                                                    ]);
                                                                    nonHasManyRelationships_1 = (0, _tslib.__values)(nonHasManyRelationships), nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    _c.label = 2;
                                                                case 2:
                                                                    if (!!nonHasManyRelationships_1_1.done) return [
                                                                        3 /*break*/ ,
                                                                        5
                                                                    ];
                                                                    relationship = nonHasManyRelationships_1_1.value;
                                                                    queryObject = relationship.createRemoteQueryObject(model);
                                                                    if (!(queryObject !== null)) return [
                                                                        3 /*break*/ ,
                                                                        4
                                                                    ];
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.query(relationship.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(relationship.remoteDefinition, queryObject))
                                                                    ];
                                                                case 3:
                                                                    related = _c.sent();
                                                                    if (related.length === 0) throw new Error([
                                                                        "Data integrity error. You tried to save a " + modelDefinition.name + " (" + JSON.stringify(model) + ")",
                                                                        "but the instance assigned to the \"" + relationship.field + "\" property",
                                                                        "does not exist in the local database. If you're trying to create the related",
                                                                        "\"" + ((_$_b = relationship.remoteDefinition) === null || _$_b === void 0 ? void 0 : _$_b.name) + "\", you must save it independently first."
                                                                    ].join(' '));
                                                                    _c.label = 4;
                                                                case 4:
                                                                    nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        2
                                                                    ];
                                                                case 5:
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 6:
                                                                    e_7_1 = _c.sent();
                                                                    e_7 = {
                                                                        error: e_7_1
                                                                    };
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 7:
                                                                    try {
                                                                        if (nonHasManyRelationships_1_1 && !nonHasManyRelationships_1_1.done && (_a = nonHasManyRelationships_1.return)) _a.call(nonHasManyRelationships_1);
                                                                    } finally{
                                                                        if (e_7) throw e_7.error;
                                                                    }
                                                                    return [
                                                                        7 /*endfinally*/ 
                                                                    ];
                                                                case 8:
                                                                    return [
                                                                        2 /*return*/ 
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _b.sent();
                                            producedCondition = condition ? (0, _next.internals)(condition((0, _next.predicateFor)(modelMeta))).toStoragePredicate() : undefined;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var saved;
                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.save(model, producedCondition, undefined, patchesTuple)
                                                                    ];
                                                                case 1:
                                                                    saved = _a.sent();
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        s.query(modelConstructor, (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model))
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 3:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), savedModel = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(savedModel, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, 'datastore save').catch(this.handleAddProcError('DataStore.save()'))
                    ];
                });
            });
        };
        this.setConflictHandler = function(config) {
            var configDataStore = config.DataStore;
            var conflictHandlerIsDefault = function conflictHandlerIsDefault() {
                return _this.conflictHandler === defaultConflictHandler;
            };
            if (configDataStore && configDataStore.conflictHandler) return configDataStore.conflictHandler;
            if (conflictHandlerIsDefault() && config.conflictHandler) return config.conflictHandler;
            return _this.conflictHandler || defaultConflictHandler;
        };
        this.setErrorHandler = function(config) {
            var configDataStore = config.DataStore;
            var errorHandlerIsDefault = function errorHandlerIsDefault() {
                return _this.errorHandler === defaultErrorHandler;
            };
            if (configDataStore && configDataStore.errorHandler) return configDataStore.errorHandler;
            if (errorHandlerIsDefault() && config.errorHandler) return config.errorHandler;
            return _this.errorHandler || defaultErrorHandler;
        };
        this.delete = function(modelOrConstructor, identifierOrCriteria) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var condition, msg, modelConstructor, msg, modelDefinition, keyFields, msg, msg, _a, deleted, model, modelConstructor, msg, modelDefinition, pkPredicate, msg, _b, _c, deleted;
                                var _d;
                                return (0, _tslib.__generator)(this, function(_e) {
                                    switch(_e.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _e.sent();
                                            if (!this.storage) throw new Error('No storage to delete from');
                                            if (!modelOrConstructor) {
                                                msg = 'Model or Model Constructor required';
                                                logger.error(msg, {
                                                    modelOrConstructor: modelOrConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (!isValidModelConstructor(modelOrConstructor)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            modelConstructor = modelOrConstructor;
                                            if (!identifierOrCriteria) {
                                                msg = 'Id to delete or criteria required. Do you want to delete all? Pass Predicates.ALL';
                                                logger.error(msg, {
                                                    identifierOrCriteria: identifierOrCriteria
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error('Could not find model definition for modelConstructor.');
                                            if (typeof identifierOrCriteria === 'string') {
                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                if (keyFields.length > 1) {
                                                    msg = (0, _util.errorMessages).deleteByPkWithCompositeKeyPresent;
                                                    logger.error(msg, {
                                                        keyFields: keyFields
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_d = {}, _d[keyFields[0]] = identifierOrCriteria, _d));
                                            } else {
                                                if ((0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) condition = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                                else condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                if (!condition || !(0, _predicates.ModelPredicateCreator).isValidPredicate(condition)) {
                                                    msg = 'Criteria required. Do you want to delete all? Pass Predicates.ALL';
                                                    logger.error(msg, {
                                                        condition: condition
                                                    });
                                                    throw new Error(msg);
                                                }
                                            }
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(modelConstructor, condition)
                                            ];
                                        case 2:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), deleted = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                        case 3:
                                            model = modelOrConstructor;
                                            modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = 'Object is not an instance of a valid model';
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error('Could not find model definition for modelConstructor.');
                                            pkPredicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model);
                                            if (identifierOrCriteria) {
                                                if (typeof identifierOrCriteria !== 'function') {
                                                    msg = 'Invalid criteria';
                                                    logger.error(msg, {
                                                        identifierOrCriteria: identifierOrCriteria
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                            } else condition = pkPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(model, condition)
                                            ];
                                        case 4:
                                            _b = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), _c = (0, _tslib.__read)(_b[0], 1), deleted = _c[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, 'datastore delete').catch(this.handleAddProcError('DataStore.delete()'))
                    ];
                });
            });
        };
        this.observe = function(modelOrConstructor, identifierOrCriteria) {
            var executivePredicate;
            var modelConstructor = modelOrConstructor && isValidModelConstructor(modelOrConstructor) ? modelOrConstructor : undefined;
            if (modelOrConstructor && modelConstructor === undefined) {
                var model = modelOrConstructor;
                var modelConstructor_1 = model && Object.getPrototypeOf(model).constructor;
                if (isValidModelConstructor(modelConstructor_1)) {
                    if (identifierOrCriteria) logger.warn('idOrCriteria is ignored when using a model instance', {
                        model: model,
                        identifierOrCriteria: identifierOrCriteria
                    });
                    return _this.observe(modelConstructor_1, model.id);
                } else {
                    var msg = 'The model is not an instance of a PersistentModelConstructor';
                    logger.error(msg, {
                        model: model
                    });
                    throw new Error(msg);
                }
            }
            // observe should not accept object literal syntax
            if (identifierOrCriteria && modelConstructor && (0, _types.isIdentifierObject)(identifierOrCriteria, getModelDefinition(modelConstructor))) {
                var msg = (0, _util.errorMessages).observeWithObjectLiteral;
                logger.error(msg, {
                    objectLiteral: identifierOrCriteria
                });
                throw new Error(msg);
            }
            if (identifierOrCriteria !== undefined && modelConstructor === undefined) {
                var msg = 'Cannot provide criteria without a modelConstructor';
                logger.error(msg, identifierOrCriteria);
                throw new Error(msg);
            }
            if (modelConstructor && !isValidModelConstructor(modelConstructor)) {
                var msg = 'Constructor is not for a valid model';
                logger.error(msg, {
                    modelConstructor: modelConstructor
                });
                throw new Error(msg);
            }
            if (modelConstructor && typeof identifierOrCriteria === 'string') {
                var buildIdPredicate = function buildIdPredicate(seed) {
                    return seed.id.eq(identifierOrCriteria);
                };
                executivePredicate = (0, _next.internals)(buildIdPredicate(buildSeedPredicate(modelConstructor)));
            } else if (modelConstructor && typeof identifierOrCriteria === 'function') executivePredicate = (0, _next.internals)(identifierOrCriteria(buildSeedPredicate(modelConstructor)));
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var source;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this.start()
                                    ];
                                case 1:
                                    _a.sent();
                                    // Filter the events returned by Storage according to namespace,
                                    // append original element data, and subscribe to the observable
                                    source = this.storage.observe(modelConstructor).filter(function(_a) {
                                        var model = _a.model;
                                        return namespaceResolver(model) === (0, _util.USER);
                                    }).subscribe({
                                        next: function next(item) {
                                            return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var message, modelDefinition, keyFields, primaryKeysAndValues, freshElement, _$_a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                message = item;
                                                                if (!(item.opType !== 'DELETE')) return [
                                                                    3 /*break*/ ,
                                                                    2
                                                                ];
                                                                modelDefinition = getModelDefinition(item.model);
                                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                                primaryKeysAndValues = (0, _util.extractPrimaryKeysAndValues)(item.element, keyFields);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.query(item.model, primaryKeysAndValues)
                                                                ];
                                                            case 1:
                                                                freshElement = _b.sent();
                                                                message = (0, _tslib.__assign)((0, _tslib.__assign)({}, message), {
                                                                    element: freshElement
                                                                });
                                                                _b.label = 2;
                                                            case 2:
                                                                _$_a = !executivePredicate;
                                                                if (_$_a) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    executivePredicate.matches(message.element)
                                                                ];
                                                            case 3:
                                                                _$_a = _b.sent();
                                                                _b.label = 4;
                                                            case 4:
                                                                if (_$_a) observer.next(message);
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            }, 'datastore observe message handler');
                                        },
                                        error: function error(err) {
                                            return observer.error(err);
                                        },
                                        complete: function complete() {
                                            return observer.complete();
                                        }
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, 'datastore observe observable initialization').catch(_this.handleAddProcError('DataStore.observe()')).catch(function(error) {
                    observer.error(error);
                });
                // better than no cleaner, but if the subscriber is handling the
                // complete() message async and not registering with the context,
                // this will still be problematic.
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (source) source.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, 'DataStore.observe() cleanup');
            });
        };
        this.observeQuery = function(model, criteria, options) {
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var items = new Map();
                var itemsChanged = new Map();
                var deletedItemIds = [];
                var handle;
                // let predicate: ModelPredicate<T> | undefined;
                var executivePredicate;
                /**
                 * As the name suggests, this geneates a snapshot in the form of
                 * 	`{items: T[], isSynced: boolean}`
                 * and sends it to the observer.
                 *
                 * SIDE EFFECT: The underlying generation and emission methods may touch:
                 * `items`, `itemsChanged`, and `deletedItemIds`.
                 *
                 * Refer to `generateSnapshot` and `emitSnapshot` for more details.
                 */ var generateAndEmitSnapshot = function generateAndEmitSnapshot() {
                    var snapshot = generateSnapshot();
                    emitSnapshot(snapshot);
                };
                // a mechanism to return data after X amount of seconds OR after the
                // "limit" (itemsChanged >= this.syncPageSize) has been reached, whichever comes first
                var limitTimerRace = new (0, _util.DeferredCallbackResolver)({
                    callback: generateAndEmitSnapshot,
                    errorHandler: observer.error,
                    maxInterval: 2000
                });
                var sort = (options || {}).sort;
                var sortOptions = sort ? {
                    sort: sort
                } : undefined;
                var modelDefinition = getModelDefinition(model);
                if (!modelDefinition) throw new Error('Could not find model definition.');
                if (model && typeof criteria === 'function') executivePredicate = (0, _next.internals)(criteria(buildSeedPredicate(model)));
                else if ((0, _predicates.isPredicatesAll)(criteria)) executivePredicate = undefined;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var err_1;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.query(model, criteria, sortOptions)
                                    ];
                                case 1:
                                    // first, query and return any locally-available records
                                    _a.sent().forEach(function(item) {
                                        var itemModelDefinition = getModelDefinition(model);
                                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                                        items.set(idOrPk, item);
                                    });
                                    // Observe the model and send a stream of updates (debounced).
                                    // We need to post-filter results instead of passing criteria through
                                    // to have visibility into items that move from in-set to out-of-set.
                                    // We need to explicitly remove those items from the existing snapshot.
                                    handle = this.observe(model).subscribe(function(_a) {
                                        var element = _a.element, _$model = _a.model, opType = _a.opType;
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var itemModelDefinition, idOrPk, _$_a, isSynced, limit;
                                                var _b, _c;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            itemModelDefinition = getModelDefinition(_$model);
                                                            idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, element);
                                                            _$_a = executivePredicate;
                                                            if (!_$_a) return [
                                                                3 /*break*/ ,
                                                                2
                                                            ];
                                                            return [
                                                                4 /*yield*/ ,
                                                                executivePredicate.matches(element)
                                                            ];
                                                        case 1:
                                                            _$_a = !_d.sent();
                                                            _d.label = 2;
                                                        case 2:
                                                            if (_$_a) {
                                                                if (opType === 'UPDATE' && (items.has(idOrPk) || itemsChanged.has(idOrPk))) // tracking as a "deleted item" will include the item in
                                                                // page limit calculations and ensure it is removed from the
                                                                // final items collection, regardless of which collection(s)
                                                                // it is currently in. (I mean, it could be in both, right!?)
                                                                deletedItemIds.push(idOrPk);
                                                                else // ignore updates for irrelevant/filtered items.
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            }
                                                            // Flag items which have been recently deleted
                                                            // NOTE: Merging of separate operations to the same model instance is handled upstream
                                                            // in the `mergePage` method within src/sync/merger.ts. The final state of a model instance
                                                            // depends on the LATEST record (for a given id).
                                                            if (opType === 'DELETE') deletedItemIds.push(idOrPk);
                                                            else itemsChanged.set(idOrPk, element);
                                                            isSynced = (_c = (_b = this.sync) === null || _b === void 0 ? void 0 : _b.getModelSyncedStatus(_$model)) !== null && _c !== void 0 ? _c : false;
                                                            limit = itemsChanged.size - deletedItemIds.length >= this.syncPageSize;
                                                            if (limit || isSynced) limitTimerRace.resolve();
                                                            // kicks off every subsequent race as results sync down
                                                            limitTimerRace.start();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        }, 'handle observeQuery observed event');
                                    });
                                    // returns a set of initial/locally-available results
                                    generateAndEmitSnapshot();
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    observer.error(err_1);
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, 'datastore observequery startup').catch(_this.handleAddProcError('DataStore.observeQuery()')).catch(function(error) {
                    observer.error(error);
                });
                /**
                 * Combines the `items`, `itemsChanged`, and `deletedItemIds` collections into
                 * a snapshot in the form of `{ items: T[], isSynced: boolean}`.
                 *
                 * SIDE EFFECT: The shared `items` collection is recreated.
                 */ var generateSnapshot = function generateSnapshot() {
                    var _a, _b;
                    var isSynced = (_b = (_a = _this.sync) === null || _a === void 0 ? void 0 : _a.getModelSyncedStatus(model)) !== null && _b !== void 0 ? _b : false;
                    var itemsArray = (0, _tslib.__spread)(Array.from(items.values()), Array.from(itemsChanged.values()));
                    items.clear();
                    itemsArray.forEach(function(item) {
                        var itemModelDefinition = getModelDefinition(model);
                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                        items.set(idOrPk, item);
                    });
                    // remove deleted items from the final result set
                    deletedItemIds.forEach(function(idOrPk) {
                        return items.delete(idOrPk);
                    });
                    var snapshot = Array.from(items.values());
                    // we sort after we merge the snapshots (items, itemsChanged)
                    // otherwise, the merge may not
                    if (options === null || options === void 0 ? void 0 : options.sort) sortItems(snapshot);
                    return {
                        items: snapshot,
                        isSynced: isSynced
                    };
                };
                /**
                 * Emits the list of items to the observer.
                 *
                 * SIDE EFFECT: `itemsChanged` and `deletedItemIds` are cleared to prepare
                 * for the next snapshot.
                 *
                 * @param snapshot The generated items data to emit.
                 */ var emitSnapshot = function emitSnapshot(snapshot) {
                    // send the generated snapshot to the primary subscription.
                    // NOTE: This observer's handler *could* be async ...
                    observer.next(snapshot);
                    // reset the changed items sets
                    itemsChanged.clear();
                    deletedItemIds = [];
                };
                /**
                 * Sorts an `Array` of `T` according to the sort instructions given in the
                 * original  `observeQuery()` call.
                 *
                 * @param itemsToSort A array of model type.
                 */ var sortItems = function sortItems(itemsToSort) {
                    var modelDefinition = getModelDefinition(model);
                    var pagination = _this.processPagination(modelDefinition, options);
                    var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
                    if (sortPredicates.length) {
                        var compareFn = (0, _util.sortCompareFunction)(sortPredicates);
                        itemsToSort.sort(compareFn);
                    }
                };
                /**
                 * Force one last snapshot when the model is fully synced.
                 *
                 * This reduces latency for that last snapshot, which will otherwise
                 * wait for the configured timeout.
                 *
                 * @param payload The payload from the Hub event.
                 */ var hubCallback = function hubCallback1(_a) {
                    var payload = _a.payload;
                    var _b;
                    var event = payload.event, data = payload.data;
                    if (event === (0, _sync.ControlMessage).SYNC_ENGINE_MODEL_SYNCED && ((_b = data === null || data === void 0 ? void 0 : data.model) === null || _b === void 0 ? void 0 : _b.name) === model.name) {
                        generateAndEmitSnapshot();
                        (0, _core.Hub).remove('datastore', hubCallback);
                    }
                };
                (0, _core.Hub).listen('datastore', hubCallback);
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (handle) handle.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, 'datastore observequery cleaner');
            });
        };
        this.configure = function(config) {
            if (config === void 0) config = {};
            _this.amplifyContext.Auth = _this.Auth;
            _this.amplifyContext.InternalAPI = _this.InternalAPI;
            _this.amplifyContext.Cache = _this.Cache;
            var configDataStore = config.DataStore, configAuthModeStrategyType = config.authModeStrategyType, configConflictHandler = config.conflictHandler, configErrorHandler = config.errorHandler, configMaxRecordsToSync = config.maxRecordsToSync, configSyncPageSize = config.syncPageSize, configFullSyncInterval = config.fullSyncInterval, configSyncExpressions = config.syncExpressions, configAuthProviders = config.authProviders, configStorageAdapter = config.storageAdapter, configFromAmplify = (0, _tslib.__rest)(config, [
                "DataStore",
                "authModeStrategyType",
                "conflictHandler",
                "errorHandler",
                "maxRecordsToSync",
                "syncPageSize",
                "fullSyncInterval",
                "syncExpressions",
                "authProviders",
                "storageAdapter"
            ]);
            _this.amplifyConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, configFromAmplify), _this.amplifyConfig);
            _this.conflictHandler = _this.setConflictHandler(config);
            _this.errorHandler = _this.setErrorHandler(config);
            var authModeStrategyType = configDataStore && configDataStore.authModeStrategyType || configAuthModeStrategyType || (0, _types.AuthModeStrategyType).DEFAULT;
            switch(authModeStrategyType){
                case (0, _types.AuthModeStrategyType).MULTI_AUTH:
                    _this.authModeStrategy = (0, _authModeStrategies.multiAuthStrategy)(_this.amplifyContext);
                    break;
                case (0, _types.AuthModeStrategyType).DEFAULT:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
                default:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
            }
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.authProviders = configDataStore && configDataStore.authProviders || configAuthProviders;
            _this.syncExpressions = configDataStore && configDataStore.syncExpressions || configSyncExpressions || _this.syncExpressions;
            _this.maxRecordsToSync = configDataStore && configDataStore.maxRecordsToSync || configMaxRecordsToSync || _this.maxRecordsToSync || 10000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.maxRecordsToSync = _this.maxRecordsToSync;
            _this.syncPageSize = configDataStore && configDataStore.syncPageSize || configSyncPageSize || _this.syncPageSize || 1000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.syncPageSize = _this.syncPageSize;
            _this.fullSyncInterval = configDataStore && configDataStore.fullSyncInterval || configFullSyncInterval || _this.fullSyncInterval || 1440; // 1 day
            _this.storageAdapter = configDataStore && configDataStore.storageAdapter || configStorageAdapter || _this.storageAdapter || undefined;
            _this.sessionId = _this.retrieveSessionId();
        };
    }
    DataStore.prototype.getModuleName = function() {
        return 'DataStore';
    };
    /**
     * Builds a function to capture `BackgroundManagerNotOpenError`'s to produce friendlier,
     * more instructive errors for customers.
     *
     * @param operation The name of the operation (usually a Datastore method) the customer
     * tried to call.
     */ DataStore.prototype.handleAddProcError = function(operation) {
        var _this = this;
        /**
         * If the tested error is a `BackgroundManagerNotOpenError`, it will be captured
         * and replaced with a friendlier message that instructs the App Developer.
         *
         * @param err An error to test.
         */ var handler = function handler(err) {
            if (err.message.startsWith('BackgroundManagerNotOpenError')) throw new Error([
                "DataStoreStateError: Tried to execute `" + operation + "` while DataStore was \"" + _this.state + "\".",
                "This can only be done while DataStore is \"Started\" or \"Stopped\". To remedy:",
                'Ensure all calls to `stop()` and `clear()` have completed first.',
                'If this is not possible, retry the operation until it succeeds.'
            ].join('\n'));
            else throw err;
        };
        return handler;
    };
    /**
     * Clears all data from storage and removes all data, schema info, other
     * initialization details, and then stops DataStore.
     *
     * That said, reinitialization is required after clearing. This can be done
     * by explicitiliy calling `start()` or any method that implicitly starts
     * DataStore, such as `query()`, `save()`, or `delete()`.
     */ DataStore.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        checkSchemaInitialized();
                        this.state = DataStoreState.Clearing;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (!(this.storage === undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // connect to storage so that it can be cleared without fully starting DataStore
                        this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                        return [
                            4 /*yield*/ ,
                            this.storage.init()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.storage.clear()
                        ];
                    case 6:
                        _a.sent();
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.storage = undefined;
                        this.sync = undefined;
                        this.syncPredicates = new WeakMap();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 7:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Stops all DataStore sync activities.
     *
     * TODO: "Waits for graceful termination of
     * running queries and terminates subscriptions."
     */ DataStore.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.state = DataStoreState.Stopping;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.sync = undefined;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 4:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Validates given pagination input from a query and creates a pagination
     * argument for use against the storage layer.
     *
     * @param modelDefinition
     * @param paginationProducer
     */ DataStore.prototype.processPagination = function(modelDefinition, paginationProducer) {
        var sortPredicate;
        var _a = paginationProducer || {}, limit = _a.limit, page = _a.page, sort = _a.sort;
        if (limit === undefined && page === undefined && sort === undefined) return undefined;
        if (page !== undefined && limit === undefined) throw new Error('Limit is required when requesting a page');
        if (page !== undefined) {
            if (typeof page !== 'number') throw new Error('Page should be a number');
            if (page < 0) throw new Error("Page can't be negative");
        }
        if (limit !== undefined) {
            if (typeof limit !== 'number') throw new Error('Limit should be a number');
            if (limit < 0) throw new Error("Limit can't be negative");
        }
        if (sort) sortPredicate = (0, _predicates.ModelSortPredicateCreator).createFromExisting(modelDefinition, sort);
        return {
            limit: limit,
            page: page,
            sort: sortPredicate
        };
    };
    /**
     * Examines the configured `syncExpressions` and produces a WeakMap of
     * SchemaModel -> predicate to use during sync.
     */ DataStore.prototype.processSyncExpressions = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var syncPredicates;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.syncExpressions || !this.syncExpressions.length) return [
                            2 /*return*/ ,
                            new WeakMap()
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(this.syncExpressions.map(function(syncExpression) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _$_a, modelConstructor, conditionProducer, modelDefinition, condition, predicate;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    syncExpression
                                                ];
                                            case 1:
                                                _$_a = _b.sent(), modelConstructor = _$_a.modelConstructor, conditionProducer = _$_a.conditionProducer;
                                                modelDefinition = getModelDefinition(modelConstructor);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.unwrapPromise(conditionProducer)
                                                ];
                                            case 2:
                                                condition = _b.sent();
                                                if ((0, _predicates.isPredicatesAll)(condition)) return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        null
                                                    ]
                                                ];
                                                predicate = (0, _next.internals)(condition((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        predicate
                                                    ]
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        syncPredicates = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.weakMapFromEntries(syncPredicates)
                        ];
                }
            });
        });
    };
    DataStore.prototype.unwrapPromise = function(conditionProducer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var condition, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            conditionProducer()
                        ];
                    case 1:
                        condition = _a.sent();
                        return [
                            2 /*return*/ ,
                            condition || conditionProducer
                        ];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1 instanceof TypeError) return [
                            2 /*return*/ ,
                            conditionProducer
                        ];
                        throw error_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DataStore.prototype.weakMapFromEntries = function(entries) {
        return entries.reduce(function(map, _a) {
            var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], predicate = _b[1];
            if (map.has(modelDefinition)) {
                var name_2 = modelDefinition.name;
                logger.warn("You can only utilize one Sync Expression per model.\n          Subsequent sync expressions for the " + name_2 + " model will be ignored.");
                return map;
            }
            if (predicate) map.set(modelDefinition, predicate);
            return map;
        }, new WeakMap());
    };
    /**
     * A session ID to allow CMS to open databases against multiple apps.
     * This session ID is only expected be set by AWS Amplify Studio.
     */ DataStore.prototype.retrieveSessionId = function() {
        try {
            var sessionId = sessionStorage.getItem('datastoreSessionId');
            if (sessionId) {
                var aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                var appSyncUrl = aws_appsync_graphqlEndpoint.split('/')[2];
                var _a = (0, _tslib.__read)(appSyncUrl.split('.'), 1), appSyncId = _a[0];
                return sessionId + "-" + appSyncId;
            }
        } catch (_b) {}
        return undefined;
    };
    return DataStore;
}();
var instance = new DataStore();
(0, _core.Amplify).register(instance);

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","immer":"8nxw2","uuid":"bvm5J","zen-observable-ts":"57mma","../authModeStrategies":"c6XSG","../predicates":"bohgw","../storage/storage":"gjDZS","../storage/relationship":"bT2iw","../sync":"4SDgb","../types":"9W0ar","../util":"iFXfl","../predicates/next":"8zsMQ","../sync/utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6j6uC":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPI", function() {
    return 0, _internalAPI.InternalAPI;
});
parcelHelpers.export(exports, "InternalAPIClass", function() {
    return 0, _internalAPI.InternalAPIClass;
});
var _internalAPI = require("./InternalAPI");

},{"./InternalAPI":"icpYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nxw2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", function() {
    return un;
});
parcelHelpers.export(exports, "applyPatches", function() {
    return pn;
});
parcelHelpers.export(exports, "castDraft", function() {
    return K;
});
parcelHelpers.export(exports, "castImmutable", function() {
    return $;
});
parcelHelpers.export(exports, "createDraft", function() {
    return ln;
});
parcelHelpers.export(exports, "current", function() {
    return D;
});
parcelHelpers.export(exports, "enableAllPlugins", function() {
    return J;
});
parcelHelpers.export(exports, "enableES5", function() {
    return N;
});
parcelHelpers.export(exports, "enableMapSet", function() {
    return C;
});
parcelHelpers.export(exports, "enablePatches", function() {
    return T;
});
parcelHelpers.export(exports, "finishDraft", function() {
    return dn;
});
parcelHelpers.export(exports, "freeze", function() {
    return d;
});
parcelHelpers.export(exports, "immerable", function() {
    return L;
});
parcelHelpers.export(exports, "isDraft", function() {
    return t;
});
parcelHelpers.export(exports, "isDraftable", function() {
    return r;
});
parcelHelpers.export(exports, "nothing", function() {
    return H;
});
parcelHelpers.export(exports, "original", function() {
    return e;
});
parcelHelpers.export(exports, "produce", function() {
    return fn;
});
parcelHelpers.export(exports, "produceWithPatches", function() {
    return cn;
});
parcelHelpers.export(exports, "setAutoFreeze", function() {
    return sn;
});
parcelHelpers.export(exports, "setUseProxies", function() {
    return vn;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function n(n) {
    for(var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)r[e - 1] = arguments[e];
    var _$i, o;
    throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n) {
    return !!n && !!n[Q];
}
function r(n) {
    return !!n && (function(n) {
        if (!n || "object" != (typeof n === "undefined" ? "undefined" : (0, _typeOf._)(n))) return !1;
        var t = Object.getPrototypeOf(n);
        if (null === t) return !0;
        var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
        return r === Object || "function" == typeof r && Function.toString.call(r) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v(n));
}
function e(r) {
    return t(r) || n(23, r), r[Q].t;
}
function i(n, t, r) {
    void 0 === r && (r = !1), 0 === o(n) ? (r ? Object.keys : nn)(n).forEach(function(e) {
        r && "symbol" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) || t(e, n[e], n);
    }) : n.forEach(function(r, e) {
        return t(e, r, n);
    });
}
function o(n) {
    var t = n[Q];
    return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, t) {
    return 2 === o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function a(n, t) {
    return 2 === o(n) ? n.get(t) : n[t];
}
function f(n, t, r) {
    var e = o(n);
    2 === e ? n.set(t, r) : 3 === e ? (n.delete(t), n.add(r)) : n[t] = r;
}
function c(n, t) {
    return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var t = tn(n);
    delete t[Q];
    for(var r = nn(t), e = 0; e < r.length; e++){
        var _$i = r[e], o = t[_$i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[_$i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[_$i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), t);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || t(n) || !r(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, t) {
        return d(t, !0);
    }, !0), n);
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != (typeof n === "undefined" ? "undefined" : (0, _typeOf._)(n)) || Object.isFrozen(n);
}
function b(t) {
    var r = rn[t];
    return r || n(18, t), r;
}
function m(n, t) {
    rn[n] || (rn[n] = t);
}
function _() {
    return U;
}
function j(n, t) {
    t && (b("Patches"), n.u = [], n.s = [], n.v = t);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var t = n[Q];
    0 === t.i || 1 === t.i ? t.j() : t.O = !0;
}
function P(t, e) {
    e._ = e.p.length;
    var _$i = e.p[0], o = void 0 !== t && t !== _$i;
    return e.h.g || b("ES5").S(e, t, o), o ? (_$i[Q].P && (O(e), n(4)), r(t) && (t = M(e, t), e.l || x(e, t)), e.u && b("Patches").M(_$i[Q], t, e.u, e.s)) : t = M(e, _$i, []), O(e), e.u && e.v(e.u, e.s), t !== H ? t : void 0;
}
function M(n, t, r) {
    if (y(t)) return t;
    var e = t[Q];
    if (!e) return i(t, function(i, o) {
        return A(n, e, t, i, o, r);
    }, !0), t;
    if (e.A !== n) return t;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(t, i) {
            return A(n, e, o, t, i, r);
        }), x(n, o, !1), r && n.u && b("Patches").R(e, r, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (t(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !t(v)) return;
        e.m = !1;
    }
    if (r(c) && !y(c)) {
        if (!e.h.F && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, t, r) {
    void 0 === r && (r = !1), n.h.F && n.m && d(t, r);
}
function z(n, t) {
    var r = n[Q];
    return (r ? p(r) : n)[t];
}
function I(n, t) {
    if (t in n) for(var r = Object.getPrototypeOf(n); r;){
        var e = Object.getOwnPropertyDescriptor(r, t);
        if (e) return e;
        r = Object.getPrototypeOf(r);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function R(n, t, r) {
    var e = s(t) ? b("MapSet").N(t, r) : v(t) ? b("MapSet").T(t, r) : n.g ? function(n, t) {
        var _$r = Array.isArray(n), e = {
            i: _$r ? 1 : 0,
            A: t ? t.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: t,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, _$i = e, o = en;
        _$r && (_$i = [
            e
        ], o = on);
        var u = Proxy.revocable(_$i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(t, r) : b("ES5").J(t, r);
    return (r ? r.A : _()).p.push(e), e;
}
function D(e) {
    return t(e) || n(22, e), function n(t) {
        if (!r(t)) return t;
        var _$e, u = t[Q], c = o(t);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, _$e = F(t, c), u.I = !1;
        } else _$e = F(t, c);
        return i(_$e, function(t, r) {
            u && a(u.t, t) === r || f(_$e, t, n(r));
        }), 3 === c ? new Set(_$e) : _$e;
    }(e);
}
function F(n, t) {
    switch(t){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function N() {
    function r(n, t) {
        var r = s[n];
        return r ? r.enumerable = t : s[n] = r = {
            configurable: !0,
            enumerable: t,
            get: function get() {
                var _$t = this[Q];
                return en.get(_$t, n);
            },
            set: function set(t) {
                var r = this[Q];
                en.set(r, n, t);
            }
        }, r;
    }
    function e(n) {
        for(var t = n.length - 1; t >= 0; t--){
            var r = n[t][Q];
            if (!r.P) switch(r.i){
                case 5:
                    a(r) && k(r);
                    break;
                case 4:
                    o(r) && k(r);
            }
        }
    }
    function o(n) {
        for(var t = n.t, r = n.k, e = nn(r), _$i = e.length - 1; _$i >= 0; _$i--){
            var o = e[_$i];
            if (o !== Q) {
                var a = t[o];
                if (void 0 === a && !u(t, o)) return !0;
                var f = r[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!t[Q];
        return e.length !== nn(t).length + (v ? 0 : 1);
    }
    function a(n) {
        var t = n.k;
        if (t.length !== n.t.length) return !0;
        var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!r || r.get);
    }
    function f(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var s = {};
    m("ES5", {
        J: function J(n, t) {
            var e = Array.isArray(n), _$i = function(n, t) {
                if (n) {
                    for(var e = Array(t.length), _$i = 0; _$i < t.length; _$i++)Object.defineProperty(e, "" + _$i, r(_$i, !0));
                    return e;
                }
                var o = tn(t);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = r(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(t), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: n,
                k: _$i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(_$i, Q, {
                value: o,
                writable: !0
            }), _$i;
        },
        S: function S(n, r, o) {
            o ? t(r) && r[Q].A === n && e(n.p) : (n.u && function n(t) {
                if (t && "object" == (typeof t === "undefined" ? "undefined" : (0, _typeOf._)(t))) {
                    var _$r = t[Q];
                    if (_$r) {
                        var _$e = _$r.t, _$o = _$r.k, f = _$r.D, c = _$r.i;
                        if (4 === c) i(_$o, function(t) {
                            t !== Q && (void 0 !== _$e[t] || u(_$e, t) ? f[t] || n(_$o[t]) : (f[t] = !0, k(_$r)));
                        }), i(_$e, function(_n) {
                            void 0 !== _$o[_n] || u(_$o, _n) || (f[_n] = !1, k(_$r));
                        });
                        else if (5 === c) {
                            if (a(_$r) && (k(_$r), f.length = !0), _$o.length < _$e.length) for(var s = _$o.length; s < _$e.length; s++)f[s] = !1;
                            else for(var v = _$e.length; v < _$o.length; v++)f[v] = !0;
                            for(var p = Math.min(_$o.length, _$e.length), l = 0; l < p; l++)void 0 === f[l] && n(_$o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function K(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!r(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var t = Object.create(Object.getPrototypeOf(n));
        for(var _$i in n)t[_$i] = e(n[_$i]);
        return u(n, L) && (t[L] = n[L]), t;
    }
    function f(n) {
        return t(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function $(t, r) {
            return r.forEach(function(r) {
                for(var _$i = r.path, u = r.op, f = t, s = 0; s < _$i.length - 1; s++){
                    var v = o(f), p = "" + _$i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != (0, _typeOf._)(f = a(f, p)) && n(15, _$i.join("/"));
                }
                var l = o(f), d = e(r.value), h = _$i[_$i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(r.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), t;
        },
        R: function R(n, t, r, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, t, r, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = t.concat(n);
                                r.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, t, r, e);
                case 5:
                case 1:
                    return function(n, t, r, e) {
                        var _$i = n.t, o = n.D, u = n.o;
                        if (u.length < _$i.length) {
                            var a = [
                                u,
                                _$i
                            ];
                            _$i = a[0], u = a[1];
                            var s = [
                                e,
                                r
                            ];
                            r = s[0], e = s[1];
                        }
                        for(var v = 0; v < _$i.length; v++)if (o[v] && u[v] !== _$i[v]) {
                            var p = t.concat([
                                v
                            ]);
                            r.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(_$i[v])
                            });
                        }
                        for(var l = _$i.length; l < u.length; l++){
                            var d = t.concat([
                                l
                            ]);
                            r.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        _$i.length < u.length && e.push({
                            op: "replace",
                            path: t.concat([
                                "length"
                            ]),
                            value: _$i.length
                        });
                    }(n, t, r, e);
                case 3:
                    return function(n, t, r, e) {
                        var _$i = n.t, o = n.o, u = 0;
                        _$i.forEach(function(n) {
                            if (!o.has(n)) {
                                var _$i = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: "remove",
                                    path: _$i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: _$i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!_$i.has(n)) {
                                var o = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, t, r, e);
            }
        },
        M: function M(n, t, r, e) {
            r.push({
                op: "replace",
                path: [],
                value: t === H ? void 0 : t
            }), e.push({
                op: "replace",
                path: [],
                value: n.t
            });
        }
    });
}
function C() {
    function t(n, t) {
        function r() {
            this.constructor = n;
        }
        a(n, t), n.prototype = (r.prototype = t.prototype, new r);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(t) {
            if (r(t)) {
                var e = R(n.A.h, t, n);
                n.p.set(t, e), n.o.add(e);
            } else n.o.add(t);
        }));
    }
    function u(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var a = function a1(n, t) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, t) {
            n.__proto__ = t;
        } || function(n, t) {
            for(var r in t)t.hasOwnProperty(r) && (n[r] = t[r]);
        })(n, t);
    }, f = function() {
        function n(n, t) {
            return this[Q] = {
                i: 2,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        t(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function get() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, t) {
            var r = this[Q];
            return u(r), p(r).has(n) && p(r).get(n) === t || (e(r), k(r), r.D.set(n, !0), r.o.set(n, t), r.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var _$t = this[Q];
            return u(_$t), e(_$t), k(_$t), _$t.D.set(n, !1), _$t.o.delete(n), !0;
        }, o.clear = function() {
            var _$n = this[Q];
            u(_$n), p(_$n).size && (e(_$n), k(_$n), _$n.D = new Map, i(_$n.t, function(t) {
                _$n.D.set(t, !1);
            }), _$n.o.clear());
        }, o.forEach = function(n, t) {
            var r = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(t, r.get(i), i, r);
            });
        }, o.get = function(n) {
            var _$t = this[Q];
            u(_$t);
            var _$i = p(_$t).get(n);
            if (_$t.I || !r(_$i)) return _$i;
            if (_$i !== _$t.t.get(n)) return _$i;
            var o = R(_$t.A.h, _$i, _$t);
            return e(_$t), _$t.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var _$n, _$t = this, r = this.keys();
            return (_$n = {})[V] = function() {
                return _$t.values();
            }, _$n.next = function() {
                var _$n = r.next();
                return _$n.done ? _$n : {
                    done: !1,
                    value: _$t.get(_$n.value)
                };
            }, _$n;
        }, o.entries = function() {
            var _$n, _$t = this, r = this.keys();
            return (_$n = {})[V] = function() {
                return _$t.entries();
            }, _$n.next = function() {
                var _$n = r.next();
                if (_$n.done) return _$n;
                var e = _$t.get(_$n.value);
                return {
                    done: !1,
                    value: [
                        _$n.value,
                        e
                    ]
                };
            }, _$n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, t) {
            return this[Q] = {
                i: 3,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        t(n, Set);
        var r = n.prototype;
        return Object.defineProperty(r, "size", {
            get: function get() {
                return p(this[Q]).size;
            }
        }), r.has = function(n) {
            var _$t = this[Q];
            return u(_$t), _$t.o ? !!_$t.o.has(n) || !(!_$t.p.has(n) || !_$t.o.has(_$t.p.get(n))) : _$t.t.has(n);
        }, r.add = function(n) {
            var _$t = this[Q];
            return u(_$t), this.has(n) || (o(_$t), k(_$t), _$t.o.add(n)), this;
        }, r.delete = function(n) {
            if (!this.has(n)) return !1;
            var _$t = this[Q];
            return u(_$t), o(_$t), k(_$t), _$t.o.delete(n) || !!_$t.p.has(n) && _$t.o.delete(_$t.p.get(n));
        }, r.clear = function() {
            var _$n = this[Q];
            u(_$n), p(_$n).size && (o(_$n), k(_$n), _$n.o.clear());
        }, r.values = function() {
            var _$n = this[Q];
            return u(_$n), o(_$n), _$n.o.values();
        }, r.entries = function() {
            var _$n = this[Q];
            return u(_$n), o(_$n), _$n.o.entries();
        }, r.keys = function() {
            return this.values();
        }, r[V] = function() {
            return this.values();
        }, r.forEach = function(n, t) {
            for(var r = this.values(), e = r.next(); !e.done;)n.call(t, e.value, e.value, this), e = r.next();
        }, n;
    }();
    m("MapSet", {
        N: function N(n, t) {
            return new f(n, t);
        },
        T: function T(n, t) {
            return new c(n, t);
        }
    });
}
function J() {
    N(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == (0, _typeOf._)(Symbol("x")), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function nn(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, tn = Object.getOwnPropertyDescriptors || function(n) {
    var t = {};
    return nn(n).forEach(function(r) {
        t[r] = Object.getOwnPropertyDescriptor(n, r);
    }), t;
}, rn = {}, en = {
    get: function get(n, t) {
        if (t === Q) return n;
        var e = p(n);
        if (!u(e, t)) return function(n, t, r) {
            var e, _$i = I(t, r);
            return _$i ? "value" in _$i ? _$i.value : null === (e = _$i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, t);
        var _$i = e[t];
        return n.I || !r(_$i) ? _$i : _$i === z(n.t, t) ? (E(n), n.o[t] = R(n.A.h, _$i, n)) : _$i;
    },
    has: function has(n, t) {
        return t in p(n);
    },
    ownKeys: function ownKeys(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function set(n, t, r) {
        var e = I(p(n), t);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, r), !0;
        if (!n.P) {
            var _$i = z(p(n), t), o = null == _$i ? void 0 : _$i[Q];
            if (o && o.t === r) return n.o[t] = r, n.D[t] = !1, !0;
            if (c(r, _$i) && (void 0 !== r || u(n.t, t))) return !0;
            E(n), k(n);
        }
        return n.o[t] === r && "number" != typeof r && (void 0 !== r || t in n.o) || (n.o[t] = r, n.D[t] = !0, !0);
    },
    deleteProperty: function deleteProperty(n, t) {
        return void 0 !== z(n.t, t) || t in n.t ? (n.D[t] = !1, E(n), k(n)) : delete n.D[t], n.o && delete n.o[t], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, t) {
        var r = p(n), e = Reflect.getOwnPropertyDescriptor(r, t);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== t,
            enumerable: e.enumerable,
            value: r[t]
        } : e;
    },
    defineProperty: function defineProperty() {
        n(11);
    },
    getPrototypeOf: function getPrototypeOf(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function setPrototypeOf() {
        n(12);
    }
}, on = {};
i(en, function(n, t) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
    };
}), on.deleteProperty = function(t, r) {
    return en.deleteProperty.call(this, t[0], r);
}, on.set = function(t, r, e) {
    return en.set.call(this, t[0], r, e, t[0]);
};
var un = function() {
    function e(t) {
        var _$e = this;
        this.g = B, this.F = !0, this.produce = function(t, i, o) {
            if ("function" == typeof t && "function" != typeof i) {
                var u = i;
                i = t;
                var a = _$e;
                return function(n) {
                    var _$t = this;
                    void 0 === n && (n = u);
                    for(var _$r = arguments.length, _$e = Array(_$r > 1 ? _$r - 1 : 0), _$o = 1; _$o < _$r; _$o++)_$e[_$o - 1] = arguments[_$o];
                    return a.produce(n, function(n) {
                        var _$r;
                        return (_$r = i).call.apply(_$r, [
                            _$t,
                            n
                        ].concat(_$e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), r(t)) {
                var c = w(_$e), s = R(_$e, t, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!t || "object" != (typeof t === "undefined" ? "undefined" : (0, _typeOf._)(t))) {
                if ((f = i(t)) === H) return;
                return void 0 === f && (f = t), _$e.F && d(f, !0), f;
            }
            n(21, t);
        }, this.produceWithPatches = function(n, t) {
            var r, _$i;
            return "function" == typeof n ? function(t) {
                for(var r = arguments.length, _$i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)_$i[o - 1] = arguments[o];
                return _$e.produceWithPatches(t, function(t) {
                    return n.apply(void 0, [
                        t
                    ].concat(_$i));
                });
            } : [
                _$e.produce(n, t, function(n, t) {
                    r = n, _$i = t;
                }),
                r,
                _$i
            ];
        }, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze);
    }
    var _$i = e.prototype;
    return _$i.createDraft = function(e) {
        r(e) || n(8), t(e) && (e = D(e));
        var _$i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, g(_$i), o;
    }, _$i.finishDraft = function(t, r) {
        var _$e = t && t[Q];
        var _$i = _$e.A;
        return j(_$i, r), P(void 0, _$i);
    }, _$i.setAutoFreeze = function(n) {
        this.F = n;
    }, _$i.setUseProxies = function(t) {
        t && !B && n(20), this.g = t;
    }, _$i.applyPatches = function(n, r) {
        var _$e;
        for(_$e = r.length - 1; _$e >= 0; _$e--){
            var _$i = r[_$e];
            if (0 === _$i.path.length && "replace" === _$i.op) {
                n = _$i.value;
                break;
            }
        }
        var o = b("Patches").$;
        return t(n) ? o(n, r) : this.produce(n, function(n) {
            return o(n, r.slice(_$e + 1));
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c6XSG":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", function() {
    return 0, _defaultAuthStrategy.defaultAuthStrategy;
});
parcelHelpers.export(exports, "multiAuthStrategy", function() {
    return 0, _multiAuthStrategy.multiAuthStrategy;
});
var _defaultAuthStrategy = require("./defaultAuthStrategy");
var _multiAuthStrategy = require("./multiAuthStrategy");

},{"./defaultAuthStrategy":"7AlEr","./multiAuthStrategy":"3xq5r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7AlEr":[function(require,module,exports,__globalThis) {
// Default behavior is to use the primary auth mode for an API,
// so we are returning an empty array so that DataStore will default
// to using the primary auth mode.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", function() {
    return defaultAuthStrategy;
});
var defaultAuthStrategy = function defaultAuthStrategy() {
    return [];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3xq5r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiAuthStrategy", function() {
    return multiAuthStrategy;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _auth = require("@aws-amplify/auth");
var _apiGraphql = require("@aws-amplify/api-graphql");
var _types = require("../types");
function getProviderFromRule(rule) {
    // private with no provider means userPools
    if (rule.allow === 'private' && !rule.provider) return (0, _types.ModelAttributeAuthProvider).USER_POOLS;
    // public with no provider means apiKey
    if (rule.allow === 'public' && !rule.provider) return (0, _types.ModelAttributeAuthProvider).API_KEY;
    return rule.provider;
}
function sortAuthRulesWithPriority(rules) {
    var allowSortPriority = [
        (0, _types.ModelAttributeAuthAllow).CUSTOM,
        (0, _types.ModelAttributeAuthAllow).OWNER,
        (0, _types.ModelAttributeAuthAllow).GROUPS,
        (0, _types.ModelAttributeAuthAllow).PRIVATE,
        (0, _types.ModelAttributeAuthAllow).PUBLIC
    ];
    var providerSortPriority = [
        (0, _types.ModelAttributeAuthProvider).FUNCTION,
        (0, _types.ModelAttributeAuthProvider).USER_POOLS,
        (0, _types.ModelAttributeAuthProvider).OIDC,
        (0, _types.ModelAttributeAuthProvider).IAM,
        (0, _types.ModelAttributeAuthProvider).API_KEY
    ];
    return (0, _tslib.__spread)(rules).sort(function(a, b) {
        if (a.allow === b.allow) return providerSortPriority.indexOf(getProviderFromRule(a)) - providerSortPriority.indexOf(getProviderFromRule(b));
        return allowSortPriority.indexOf(a.allow) - allowSortPriority.indexOf(b.allow);
    });
}
function getAuthRules(_a) {
    var rules = _a.rules, currentUser = _a.currentUser;
    // Using Set to ensure uniqueness
    var authModes = new Set();
    rules.forEach(function(rule) {
        switch(rule.allow){
            case (0, _types.ModelAttributeAuthAllow).CUSTOM:
                // custom with no provider -> function
                if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).FUNCTION) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                break;
            case (0, _types.ModelAttributeAuthAllow).GROUPS:
            case (0, _types.ModelAttributeAuthAllow).OWNER:
                // We shouldn't attempt User Pool or OIDC if there isn't an authenticated user
                if (currentUser) {
                    if (rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).OIDC) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).OPENID_CONNECT);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PRIVATE:
                // We shouldn't attempt private if there isn't an authenticated user
                if (currentUser) {
                    // private with no provider means userPools
                    if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PUBLIC:
                if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                else if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).API_KEY) // public with no provider means apiKey
                authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).API_KEY);
                break;
            default:
                break;
        }
    });
    return Array.from(authModes);
}
var multiAuthStrategy = function multiAuthStrategy(amplifyContext) {
    return function(_a) {
        var schema = _a.schema, modelName = _a.modelName;
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var currentUser, e_1, attributes, authAttribute, sortedRules;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        amplifyContext.Auth = amplifyContext.Auth || (0, _auth.Auth);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            amplifyContext.Auth.currentAuthenticatedUser()
                        ];
                    case 2:
                        currentUser = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        attributes = schema.namespaces.user.models[modelName].attributes;
                        if (attributes) {
                            authAttribute = attributes.find(function(attr) {
                                return attr.type === 'auth';
                            });
                            if ((_b = authAttribute === null || authAttribute === void 0 ? void 0 : authAttribute.properties) === null || _b === void 0 ? void 0 : _b.rules) {
                                sortedRules = sortAuthRulesWithPriority(authAttribute.properties.rules);
                                return [
                                    2 /*return*/ ,
                                    getAuthRules({
                                        currentUser: currentUser,
                                        rules: sortedRules
                                    })
                                ];
                            }
                        }
                        return [
                            2 /*return*/ ,
                            []
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@aws-amplify/auth":"ilv20","@aws-amplify/api-graphql":"eWncu","../types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9W0ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSchemaModel", function() {
    return isSchemaModel;
});
parcelHelpers.export(exports, "isSchemaModelWithAttributes", function() {
    return isSchemaModelWithAttributes;
});
parcelHelpers.export(exports, "isAssociatedWith", function() {
    return isAssociatedWith;
});
parcelHelpers.export(exports, "isTargetNameAssociation", function() {
    return isTargetNameAssociation;
});
parcelHelpers.export(exports, "isFieldAssociation", function() {
    return isFieldAssociation;
});
parcelHelpers.export(exports, "isModelAttributeAuth", function() {
    return isModelAttributeAuth;
});
parcelHelpers.export(exports, "isModelAttributeKey", function() {
    return isModelAttributeKey;
});
parcelHelpers.export(exports, "isModelAttributePrimaryKey", function() {
    return isModelAttributePrimaryKey;
});
parcelHelpers.export(exports, "isModelAttributeCompositeKey", function() {
    return isModelAttributeCompositeKey;
});
parcelHelpers.export(exports, "ModelAttributeAuthAllow", function() {
    return ModelAttributeAuthAllow;
});
parcelHelpers.export(exports, "ModelAttributeAuthProvider", function() {
    return ModelAttributeAuthProvider;
});
parcelHelpers.export(exports, "GraphQLScalarType", function() {
    return GraphQLScalarType;
});
parcelHelpers.export(exports, "isGraphQLScalarType", function() {
    return isGraphQLScalarType;
});
parcelHelpers.export(exports, "isModelFieldType", function() {
    return isModelFieldType;
});
parcelHelpers.export(exports, "isNonModelFieldType", function() {
    return isNonModelFieldType;
});
parcelHelpers.export(exports, "isEnumFieldType", function() {
    return isEnumFieldType;
});
parcelHelpers.export(exports, "isIdentifierObject", function() {
    return isIdentifierObject;
});
parcelHelpers.export(exports, "OpType", function() {
    return OpType;
});
parcelHelpers.export(exports, "isPredicateObj", function() {
    return isPredicateObj;
});
parcelHelpers.export(exports, "isPredicateGroup", function() {
    return isPredicateGroup;
});
parcelHelpers.export(exports, "QueryOne", function() {
    return QueryOne;
});
parcelHelpers.export(exports, "SortDirection", function() {
    return SortDirection;
});
parcelHelpers.export(exports, "AuthModeStrategyType", function() {
    return AuthModeStrategyType;
});
parcelHelpers.export(exports, "ModelOperation", function() {
    return ModelOperation;
});
parcelHelpers.export(exports, "syncExpression", function() {
    return syncExpression;
});
parcelHelpers.export(exports, "ProcessName", function() {
    return ProcessName;
});
parcelHelpers.export(exports, "DISCARD", function() {
    return DISCARD;
});
parcelHelpers.export(exports, "LimitTimerRaceResolvedValues", function() {
    return LimitTimerRaceResolvedValues;
});
parcelHelpers.export(exports, "PredicateInternalsKey", function() {
    return PredicateInternalsKey;
}) // #endregion
;
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _util = require("./util");
function isSchemaModel(obj) {
    return obj && obj.pluralName !== undefined;
}
function isSchemaModelWithAttributes(m) {
    return isSchemaModel(m) && m.attributes !== undefined;
}
function isAssociatedWith(obj) {
    return obj && obj.associatedWith;
}
function isTargetNameAssociation(obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.targetName) || (obj === null || obj === void 0 ? void 0 : obj.targetNames);
}
function isFieldAssociation(obj, fieldName) {
    var _a, _b;
    return (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.association) === null || _b === void 0 ? void 0 : _b.connectionType;
}
function isModelAttributeAuth(attr) {
    return attr.type === 'auth' && attr.properties && attr.properties.rules && attr.properties.rules.length > 0;
}
function isModelAttributeKey(attr) {
    return attr.type === 'key' && attr.properties && attr.properties.fields && attr.properties.fields.length > 0;
}
function isModelAttributePrimaryKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name === undefined;
}
function isModelAttributeCompositeKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name !== undefined && attr.properties.fields.length > 2;
}
var ModelAttributeAuthAllow;
(function(ModelAttributeAuthAllow) {
    ModelAttributeAuthAllow["CUSTOM"] = "custom";
    ModelAttributeAuthAllow["OWNER"] = "owner";
    ModelAttributeAuthAllow["GROUPS"] = "groups";
    ModelAttributeAuthAllow["PRIVATE"] = "private";
    ModelAttributeAuthAllow["PUBLIC"] = "public";
})(ModelAttributeAuthAllow || (ModelAttributeAuthAllow = {}));
var ModelAttributeAuthProvider;
(function(ModelAttributeAuthProvider) {
    ModelAttributeAuthProvider["FUNCTION"] = "function";
    ModelAttributeAuthProvider["USER_POOLS"] = "userPools";
    ModelAttributeAuthProvider["OIDC"] = "oidc";
    ModelAttributeAuthProvider["IAM"] = "iam";
    ModelAttributeAuthProvider["API_KEY"] = "apiKey";
})(ModelAttributeAuthProvider || (ModelAttributeAuthProvider = {}));
var GraphQLScalarType;
(function(GraphQLScalarType) {
    GraphQLScalarType[GraphQLScalarType["ID"] = 0] = "ID";
    GraphQLScalarType[GraphQLScalarType["String"] = 1] = "String";
    GraphQLScalarType[GraphQLScalarType["Int"] = 2] = "Int";
    GraphQLScalarType[GraphQLScalarType["Float"] = 3] = "Float";
    GraphQLScalarType[GraphQLScalarType["Boolean"] = 4] = "Boolean";
    GraphQLScalarType[GraphQLScalarType["AWSDate"] = 5] = "AWSDate";
    GraphQLScalarType[GraphQLScalarType["AWSTime"] = 6] = "AWSTime";
    GraphQLScalarType[GraphQLScalarType["AWSDateTime"] = 7] = "AWSDateTime";
    GraphQLScalarType[GraphQLScalarType["AWSTimestamp"] = 8] = "AWSTimestamp";
    GraphQLScalarType[GraphQLScalarType["AWSEmail"] = 9] = "AWSEmail";
    GraphQLScalarType[GraphQLScalarType["AWSJSON"] = 10] = "AWSJSON";
    GraphQLScalarType[GraphQLScalarType["AWSURL"] = 11] = "AWSURL";
    GraphQLScalarType[GraphQLScalarType["AWSPhone"] = 12] = "AWSPhone";
    GraphQLScalarType[GraphQLScalarType["AWSIPAddress"] = 13] = "AWSIPAddress";
})(GraphQLScalarType || (GraphQLScalarType = {}));
(function(GraphQLScalarType) {
    function getJSType(scalar) {
        switch(scalar){
            case 'Boolean':
                return 'boolean';
            case 'ID':
            case 'String':
            case 'AWSDate':
            case 'AWSTime':
            case 'AWSDateTime':
            case 'AWSEmail':
            case 'AWSURL':
            case 'AWSPhone':
            case 'AWSIPAddress':
                return 'string';
            case 'Int':
            case 'Float':
            case 'AWSTimestamp':
                return 'number';
            case 'AWSJSON':
                return 'object';
            default:
                throw new Error('Invalid scalar type');
        }
    }
    GraphQLScalarType.getJSType = getJSType;
    function getValidationFunction(scalar) {
        switch(scalar){
            case 'AWSDate':
                return 0, _util.isAWSDate;
            case 'AWSTime':
                return 0, _util.isAWSTime;
            case 'AWSDateTime':
                return 0, _util.isAWSDateTime;
            case 'AWSTimestamp':
                return 0, _util.isAWSTimestamp;
            case 'AWSEmail':
                return 0, _util.isAWSEmail;
            case 'AWSJSON':
                return 0, _util.isAWSJSON;
            case 'AWSURL':
                return 0, _util.isAWSURL;
            case 'AWSPhone':
                return 0, _util.isAWSPhone;
            case 'AWSIPAddress':
                return 0, _util.isAWSIPAddress;
            default:
                return undefined;
        }
    }
    GraphQLScalarType.getValidationFunction = getValidationFunction;
})(GraphQLScalarType || (GraphQLScalarType = {}));
function isGraphQLScalarType(obj) {
    return obj && GraphQLScalarType[obj] !== undefined;
}
function isModelFieldType(obj) {
    var modelField = 'model';
    if (obj && obj[modelField]) return true;
    return false;
}
function isNonModelFieldType(obj) {
    var typeField = 'nonModel';
    if (obj && obj[typeField]) return true;
    return false;
}
function isEnumFieldType(obj) {
    var modelField = 'enum';
    if (obj && obj[modelField]) return true;
    return false;
}
function isIdentifierObject(obj, modelDefinition) {
    var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object' && obj && keys.every(function(k) {
        return obj[k] !== undefined;
    });
}
var OpType;
(function(OpType) {
    OpType["INSERT"] = "INSERT";
    OpType["UPDATE"] = "UPDATE";
    OpType["DELETE"] = "DELETE";
})(OpType || (OpType = {}));
function isPredicateObj(obj) {
    return obj && obj.field !== undefined;
}
function isPredicateGroup(obj) {
    return obj && obj.type !== undefined;
}
var QueryOne;
(function(QueryOne) {
    QueryOne[QueryOne["FIRST"] = 0] = "FIRST";
    QueryOne[QueryOne["LAST"] = 1] = "LAST";
})(QueryOne || (QueryOne = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["ASCENDING"] = "ASCENDING";
    SortDirection["DESCENDING"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
var AuthModeStrategyType;
(function(AuthModeStrategyType) {
    AuthModeStrategyType["DEFAULT"] = "DEFAULT";
    AuthModeStrategyType["MULTI_AUTH"] = "MULTI_AUTH";
})(AuthModeStrategyType || (AuthModeStrategyType = {}));
var ModelOperation;
(function(ModelOperation) {
    ModelOperation["CREATE"] = "CREATE";
    ModelOperation["READ"] = "READ";
    ModelOperation["UPDATE"] = "UPDATE";
    ModelOperation["DELETE"] = "DELETE";
})(ModelOperation || (ModelOperation = {}));
function syncExpression(modelConstructor, conditionProducer) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                {
                    modelConstructor: modelConstructor,
                    conditionProducer: conditionProducer
                }
            ];
        });
    });
}
var ProcessName;
(function(ProcessName) {
    ProcessName["sync"] = "sync";
    ProcessName["mutate"] = "mutate";
    ProcessName["subscribe"] = "subscribe";
})(ProcessName || (ProcessName = {}));
var DISCARD = Symbol('DISCARD');
var LimitTimerRaceResolvedValues;
(function(LimitTimerRaceResolvedValues) {
    LimitTimerRaceResolvedValues["LIMIT"] = "LIMIT";
    LimitTimerRaceResolvedValues["TIMER"] = "TIMER";
})(LimitTimerRaceResolvedValues || (LimitTimerRaceResolvedValues = {}));
/**
 * A pointer used by DataStore internally to lookup predicate details
 * that should not be exposed on public customer interfaces.
 */ var PredicateInternalsKey = /** @class */ function() {
    function PredicateInternalsKey() {
        this.__isPredicateInternalsKeySentinel = true;
    }
    return PredicateInternalsKey;
}();

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","./util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFXfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ID", function() {
    return ID;
});
parcelHelpers.export(exports, "DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR", function() {
    return DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR;
});
parcelHelpers.export(exports, "IDENTIFIER_KEY_SEPARATOR", function() {
    return IDENTIFIER_KEY_SEPARATOR;
});
parcelHelpers.export(exports, "errorMessages", function() {
    return errorMessages;
});
parcelHelpers.export(exports, "NAMESPACES", function() {
    return NAMESPACES;
});
parcelHelpers.export(exports, "USER", function() {
    return USER;
});
parcelHelpers.export(exports, "SYNC", function() {
    return SYNC;
});
parcelHelpers.export(exports, "STORAGE", function() {
    return STORAGE;
});
parcelHelpers.export(exports, "DATASTORE", function() {
    return DATASTORE;
});
parcelHelpers.export(exports, "exhaustiveCheck", function() {
    return exhaustiveCheck;
});
parcelHelpers.export(exports, "isNullOrUndefined", function() {
    return isNullOrUndefined;
});
parcelHelpers.export(exports, "validatePredicate", function() {
    return validatePredicate;
});
parcelHelpers.export(exports, "validatePredicateField", function() {
    return validatePredicateField;
});
parcelHelpers.export(exports, "isModelConstructor", function() {
    return isModelConstructor;
});
parcelHelpers.export(exports, "registerNonModelClass", function() {
    return registerNonModelClass;
});
parcelHelpers.export(exports, "isNonModelConstructor", function() {
    return isNonModelConstructor;
});
parcelHelpers.export(exports, "traverseModel", function() {
    return traverseModel;
});
parcelHelpers.export(exports, "isPrivateMode", function() {
    return isPrivateMode;
});
parcelHelpers.export(exports, "isSafariCompatabilityMode", function() {
    return isSafariCompatabilityMode;
});
parcelHelpers.export(exports, "monotonicUlidFactory", function() {
    return monotonicUlidFactory;
});
/**
 * Uses performance.now() if available, otherwise, uses Date.now() (e.g. react native without a polyfill)
 *
 * The values returned by performance.now() always increase at a constant rate,
 * independent of the system clock (which might be adjusted manually or skewed
 * by software like NTP).
 *
 * Otherwise, performance.timing.navigationStart + performance.now() will be
 * approximately equal to Date.now()
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Performance/now#Example
 */ parcelHelpers.export(exports, "getNow", function() {
    return getNow;
});
parcelHelpers.export(exports, "sortCompareFunction", function() {
    return sortCompareFunction;
});
// deep compare any 2 values
// primitives or object types (including arrays, Sets, and Maps)
// returns true if equal by value
// if nullish is true, treat undefined and null values as equal
// to normalize for GQL response values for undefined fields
parcelHelpers.export(exports, "valuesEqual", function() {
    return valuesEqual;
});
/**
 * Statelessly extracts the specified page from an array.
 *
 * @param records - The source array to extract a page from.
 * @param pagination - A definition of the page to extract.
 * @returns This items from `records` matching the `pagination` definition.
 */ parcelHelpers.export(exports, "inMemoryPagination", function() {
    return inMemoryPagination;
});
/**
 * An `aysnc` implementation of `Array.some()`. Returns as soon as a match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if "some" items match; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncSome", function() {
    return asyncSome;
});
/**
 * An `aysnc` implementation of `Array.every()`. Returns as soon as a non-match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if every item matches; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncEvery", function() {
    return asyncEvery;
});
/**
 * An `async` implementation of `Array.filter()`. Returns after all items have been filtered.
 * TODO: Return AsyncIterable.
 * @param items The items to filter.
 * @param matches The `async` matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<T>` of matching items.
 */ parcelHelpers.export(exports, "asyncFilter", function() {
    return asyncFilter;
});
parcelHelpers.export(exports, "isAWSDate", function() {
    return isAWSDate;
});
parcelHelpers.export(exports, "isAWSTime", function() {
    return isAWSTime;
});
parcelHelpers.export(exports, "isAWSDateTime", function() {
    return isAWSDateTime;
});
parcelHelpers.export(exports, "isAWSTimestamp", function() {
    return isAWSTimestamp;
});
parcelHelpers.export(exports, "isAWSEmail", function() {
    return isAWSEmail;
});
parcelHelpers.export(exports, "isAWSJSON", function() {
    return isAWSJSON;
});
parcelHelpers.export(exports, "isAWSURL", function() {
    return isAWSURL;
});
parcelHelpers.export(exports, "isAWSPhone", function() {
    return isAWSPhone;
});
parcelHelpers.export(exports, "isAWSIPAddress", function() {
    return isAWSIPAddress;
});
parcelHelpers.export(exports, "DeferredPromise", function() {
    return DeferredPromise;
});
parcelHelpers.export(exports, "DeferredCallbackResolver", function() {
    return DeferredCallbackResolver;
});
/**
 * merge two sets of patches created by immer produce.
 * newPatches take precedent over oldPatches for patches modifying the same path.
 * In the case many consecutive pathces are merged the original model should
 * always be the root model.
 *
 * Example:
 * A -> B, patches1
 * B -> C, patches2
 *
 * mergePatches(A, patches1, patches2) to get patches for A -> C
 *
 * @param originalSource the original Model the patches should be applied to
 * @param oldPatches immer produce patch list
 * @param newPatches immer produce patch list (will take precedence)
 * @return merged patches
 */ parcelHelpers.export(exports, "mergePatches", function() {
    return mergePatches;
});
parcelHelpers.export(exports, "getStorename", function() {
    return getStorename;
});
parcelHelpers.export(exports, "processCompositeKeys", function() {
    return processCompositeKeys;
});
parcelHelpers.export(exports, "extractKeyIfExists", function() {
    return extractKeyIfExists;
});
parcelHelpers.export(exports, "extractPrimaryKeyFieldNames", function() {
    return extractPrimaryKeyFieldNames;
});
parcelHelpers.export(exports, "extractPrimaryKeyValues", function() {
    return extractPrimaryKeyValues;
});
parcelHelpers.export(exports, "extractPrimaryKeysAndValues", function() {
    return extractPrimaryKeysAndValues;
});
parcelHelpers.export(exports, "isIdManaged", function() {
    return isIdManaged;
});
parcelHelpers.export(exports, "isIdOptionallyManaged", function() {
    return isIdOptionallyManaged;
});
parcelHelpers.export(exports, "establishRelationAndKeys", function() {
    return establishRelationAndKeys;
});
parcelHelpers.export(exports, "getIndex", function() {
    return getIndex;
});
parcelHelpers.export(exports, "getIndexFromAssociation", function() {
    return getIndexFromAssociation;
});
parcelHelpers.export(exports, "extractTargetNamesFromSrc", function() {
    return extractTargetNamesFromSrc;
});
parcelHelpers.export(exports, "indexNameFromKeys", function() {
    return indexNameFromKeys;
});
parcelHelpers.export(exports, "keysEqual", function() {
    return keysEqual;
});
parcelHelpers.export(exports, "getIndexKeys", function() {
    return getIndexKeys;
});
parcelHelpers.export(exports, "getTimestampFields", function() {
    return getTimestampFields;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _buffer = require("buffer");
var _ulid = require("ulid");
var _uuid = require("uuid");
var _immer = require("immer");
var _types = require("./types");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _predicates = require("./predicates");
var ID = 'id';
var DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR = '#';
var IDENTIFIER_KEY_SEPARATOR = '-';
var errorMessages = {
    idEmptyString: 'An index field cannot contain an empty string value',
    queryByPkWithCompositeKeyPresent: 'Models with composite primary keys cannot be queried by a single key value. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys',
    deleteByPkWithCompositeKeyPresent: 'Models with composite primary keys cannot be deleted by a single key value, unless using a predicate. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys',
    observeWithObjectLiteral: 'Object literal syntax cannot be used with observe. Use a predicate instead: https://docs.amplify.aws/lib/datastore/data-access/q/platform/js/#predicates'
};
var NAMESPACES;
(function(NAMESPACES) {
    NAMESPACES["DATASTORE"] = "datastore";
    NAMESPACES["USER"] = "user";
    NAMESPACES["SYNC"] = "sync";
    NAMESPACES["STORAGE"] = "storage";
})(NAMESPACES || (NAMESPACES = {}));
var DATASTORE = NAMESPACES.DATASTORE;
var USER = NAMESPACES.USER;
var SYNC = NAMESPACES.SYNC;
var STORAGE = NAMESPACES.STORAGE;
var exhaustiveCheck = function exhaustiveCheck(obj, throwOnError) {
    if (throwOnError === void 0) throwOnError = true;
    if (throwOnError) throw new Error("Invalid " + obj);
};
var isNullOrUndefined = function isNullOrUndefined(val) {
    return typeof val === 'undefined' || val === undefined || val === null;
};
var validatePredicate = function validatePredicate1(model, groupType, predicatesOrGroups) {
    var filterType;
    var isNegation = false;
    if (predicatesOrGroups.length === 0) return true;
    switch(groupType){
        case 'not':
            filterType = 'every';
            isNegation = true;
            break;
        case 'and':
            filterType = 'every';
            break;
        case 'or':
            filterType = 'some';
            break;
        default:
            throw new Error("Invalid " + groupType);
    }
    var result = predicatesOrGroups[filterType](function(predicateOrGroup) {
        if ((0, _types.isPredicateObj)(predicateOrGroup)) {
            var field = predicateOrGroup.field, operator = predicateOrGroup.operator, operand = predicateOrGroup.operand;
            var value = model[field];
            return validatePredicateField(value, operator, operand);
        }
        if ((0, _types.isPredicateGroup)(predicateOrGroup)) {
            var type = predicateOrGroup.type, predicates = predicateOrGroup.predicates;
            return validatePredicate(model, type, predicates);
        }
        throw new Error('Not a predicate or group');
    });
    return isNegation ? !result : result;
};
var validatePredicateField = function validatePredicateField(value, operator, operand) {
    switch(operator){
        case 'ne':
            return value !== operand;
        case 'eq':
            return value === operand;
        case 'le':
            return value <= operand;
        case 'lt':
            return value < operand;
        case 'ge':
            return value >= operand;
        case 'gt':
            return value > operand;
        case 'between':
            var _c = (0, _tslib.__read)(operand, 2), min = _c[0], max = _c[1];
            return value >= min && value <= max;
        case 'beginsWith':
            return !isNullOrUndefined(value) && value.startsWith(operand);
        case 'contains':
            return !isNullOrUndefined(value) && value.indexOf(operand) > -1;
        case 'notContains':
            return isNullOrUndefined(value) || value.indexOf(operand) === -1;
        default:
            return false;
    }
};
var isModelConstructor = function isModelConstructor(obj) {
    return obj && typeof obj.copyOf === 'function';
};
var nonModelClasses = new WeakSet();
function registerNonModelClass(clazz) {
    nonModelClasses.add(clazz);
}
var isNonModelConstructor = function isNonModelConstructor(obj) {
    return nonModelClasses.has(obj);
};
var topologicallySortedModels = new WeakMap();
var traverseModel = function traverseModel(srcModelName, instance, namespace, modelInstanceCreator, getModelConstructorByModelName) {
    var modelConstructor = getModelConstructorByModelName(namespace.name, srcModelName);
    var result = [];
    var newInstance = modelConstructor.copyOf(instance, function() {});
    result.unshift({
        modelName: srcModelName,
        item: newInstance,
        instance: newInstance
    });
    if (!topologicallySortedModels.has(namespace)) topologicallySortedModels.set(namespace, Array.from(namespace.modelTopologicalOrdering.keys()));
    var sortedModels = topologicallySortedModels.get(namespace);
    result.sort(function(a, b) {
        return sortedModels.indexOf(a.modelName) - sortedModels.indexOf(b.modelName);
    });
    return result;
};
var privateModeCheckResult;
var isPrivateMode = function isPrivateMode() {
    return new Promise(function(resolve) {
        var dbname = (0, _uuid.v4)();
        var db;
        var isPrivate = function isPrivate() {
            privateModeCheckResult = false;
            resolve(true);
        };
        var isNotPrivate = function isNotPrivate() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            if (!(db && db.result && typeof db.result.close === 'function')) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                db.result.close()
                            ];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                indexedDB.deleteDatabase(dbname)
                            ];
                        case 3:
                            _c.sent();
                            privateModeCheckResult = true;
                            return [
                                2 /*return*/ ,
                                resolve(false)
                            ];
                    }
                });
            });
        };
        if (privateModeCheckResult === true) return isNotPrivate();
        if (privateModeCheckResult === false) return isPrivate();
        if (indexedDB === null) return isPrivate();
        db = indexedDB.open(dbname);
        db.onerror = isPrivate;
        db.onsuccess = isNotPrivate;
    });
};
var safariCompatabilityModeResult;
var isSafariCompatabilityMode = function isSafariCompatabilityMode() {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var dbName_1, storeName_1, indexName_1, db_1, rwTx, rwStore, result, error_1;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    dbName_1 = (0, _uuid.v4)();
                    storeName_1 = 'indexedDBFeatureProbeStore';
                    indexName_1 = 'idx';
                    if (indexedDB === null) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (safariCompatabilityModeResult !== undefined) return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var dbOpenRequest = indexedDB.open(dbName_1);
                            dbOpenRequest.onerror = function() {
                                return resolve(false);
                            };
                            dbOpenRequest.onsuccess = function() {
                                var db = dbOpenRequest.result;
                                resolve(db);
                            };
                            dbOpenRequest.onupgradeneeded = function(event) {
                                var _$_c;
                                var db = (_$_c = event === null || event === void 0 ? void 0 : event.target) === null || _$_c === void 0 ? void 0 : _$_c.result;
                                db.onerror = function() {
                                    return resolve(false);
                                };
                                var store = db.createObjectStore(storeName_1, {
                                    autoIncrement: true
                                });
                                store.createIndex(indexName_1, [
                                    'id'
                                ]);
                            };
                        })
                    ];
                case 1:
                    db_1 = _c.sent();
                    if (!db_1) throw new Error('Could not open probe DB');
                    rwTx = db_1.transaction(storeName_1, 'readwrite');
                    rwStore = rwTx.objectStore(storeName_1);
                    rwStore.add({
                        id: 1
                    });
                    rwTx.commit();
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var tx = db_1.transaction(storeName_1, 'readonly');
                            var store = tx.objectStore(storeName_1);
                            var index = store.index(indexName_1);
                            var getRequest = index.get([
                                1
                            ]);
                            getRequest.onerror = function() {
                                return resolve(false);
                            };
                            getRequest.onsuccess = function(event) {
                                var _$_c;
                                resolve((_$_c = event === null || event === void 0 ? void 0 : event.target) === null || _$_c === void 0 ? void 0 : _$_c.result);
                            };
                        })
                    ];
                case 2:
                    result = _c.sent();
                    if (!(db_1 && typeof db_1.close === 'function')) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        db_1.close()
                    ];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        indexedDB.deleteDatabase(dbName_1)
                    ];
                case 5:
                    _c.sent();
                    if (result === undefined) safariCompatabilityModeResult = true;
                    else safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    error_1 = _c.sent();
                    safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
            }
        });
    });
};
var randomBytes = function randomBytes(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _amazonCognitoIdentityJs.WordArray)().random(nBytes).toString(), 'hex');
};
var prng = function prng() {
    return randomBytes(1).readUInt8(0) / 0xff;
};
function monotonicUlidFactory(seed) {
    var ulid = (0, _ulid.monotonicFactory)(prng);
    return function() {
        return ulid(seed);
    };
}
function getNow() {
    if (typeof performance !== 'undefined' && performance && typeof performance.now === 'function') return performance.now() | 0; // convert to integer
    else return Date.now();
}
function sortCompareFunction(sortPredicates) {
    return function compareFunction(a, b) {
        var e_1, _c;
        try {
            // enable multi-field sort by iterating over predicates until
            // a comparison returns -1 or 1
            for(var sortPredicates_1 = (0, _tslib.__values)(sortPredicates), sortPredicates_1_1 = sortPredicates_1.next(); !sortPredicates_1_1.done; sortPredicates_1_1 = sortPredicates_1.next()){
                var predicate = sortPredicates_1_1.value;
                var field = predicate.field, sortDirection = predicate.sortDirection;
                // reverse result when direction is descending
                var sortMultiplier = sortDirection === (0, _types.SortDirection).ASCENDING ? 1 : -1;
                if (a[field] < b[field]) return -1 * sortMultiplier;
                if (a[field] > b[field]) return 1 * sortMultiplier;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (sortPredicates_1_1 && !sortPredicates_1_1.done && (_c = sortPredicates_1.return)) _c.call(sortPredicates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return 0;
    };
}
function valuesEqual(valA, valB, nullish) {
    var e_2, _c;
    if (nullish === void 0) nullish = false;
    var a = valA;
    var b = valB;
    var nullishCompare = function nullishCompare(_a, _b) {
        return (_a === undefined || _a === null) && (_b === undefined || _b === null);
    };
    // if one of the values is a primitive and the other is an object
    if (a instanceof Object && !(b instanceof Object) || !(a instanceof Object) && b instanceof Object) return false;
    // compare primitive types
    if (!(a instanceof Object)) {
        if (nullish && nullishCompare(a, b)) return true;
        return a === b;
    }
    // make sure object types match
    if (Array.isArray(a) && !Array.isArray(b) || Array.isArray(b) && !Array.isArray(a)) return false;
    if (a instanceof Set && b instanceof Set) {
        a = (0, _tslib.__spread)(a);
        b = (0, _tslib.__spread)(b);
    }
    if (a instanceof Map && b instanceof Map) {
        a = Object.fromEntries(a);
        b = Object.fromEntries(b);
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    // last condition is to ensure that [] !== [null] even if nullish. However [undefined] === [null] when nullish
    if (aKeys.length !== bKeys.length && (!nullish || Array.isArray(a))) return false;
    // iterate through the longer set of keys
    // e.g., for a nullish comparison of a={ a: 1 } and b={ a: 1, b: null }
    // we want to iterate through bKeys
    var keys = aKeys.length >= bKeys.length ? aKeys : bKeys;
    try {
        for(var keys_1 = (0, _tslib.__values)(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
            var key = keys_1_1.value;
            var aVal = a[key];
            var bVal = b[key];
            if (!valuesEqual(aVal, bVal, nullish)) return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (keys_1_1 && !keys_1_1.done && (_c = keys_1.return)) _c.call(keys_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function inMemoryPagination(records, pagination) {
    if (pagination && records.length > 1) {
        if (pagination.sort) {
            var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
            if (sortPredicates.length) {
                var compareFn = sortCompareFunction(sortPredicates);
                records.sort(compareFn);
            }
        }
        var _c = pagination.page, page = _c === void 0 ? 0 : _c, _d = pagination.limit, limit = _d === void 0 ? 0 : _d;
        var start = Math.max(0, page * limit) || 0;
        var end = limit > 0 ? start + limit : records.length;
        return records.slice(start, end);
    }
    return records;
}
function asyncSome(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_1, items_1_1, item, e_3_1;
        var e_3, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                    _d.label = 1;
                case 1:
                    if (!!items_1_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_1_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (_d.sent()) return [
                        2 /*return*/ ,
                        true
                    ];
                    _d.label = 3;
                case 3:
                    items_1_1 = items_1.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_3_1 = _d.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_1_1 && !items_1_1.done && (_c = items_1.return)) _c.call(items_1);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        false
                    ];
            }
        });
    });
}
function asyncEvery(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_2, items_2_1, item, e_4_1;
        var e_4, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_2 = (0, _tslib.__values)(items), items_2_1 = items_2.next();
                    _d.label = 1;
                case 1:
                    if (!!items_2_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_2_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (!_d.sent()) return [
                        2 /*return*/ ,
                        false
                    ];
                    _d.label = 3;
                case 3:
                    items_2_1 = items_2.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_4_1 = _d.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_2_1 && !items_2_1.done && (_c = items_2.return)) _c.call(items_2);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
function asyncFilter(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var results, items_3, items_3_1, item, e_5_1;
        var e_5, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    results = [];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    items_3 = (0, _tslib.__values)(items), items_3_1 = items_3.next();
                    _d.label = 2;
                case 2:
                    if (!!items_3_1.done) return [
                        3 /*break*/ ,
                        5
                    ];
                    item = items_3_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 3:
                    if (_d.sent()) results.push(item);
                    _d.label = 4;
                case 4:
                    items_3_1 = items_3.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 6:
                    e_5_1 = _d.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    try {
                        if (items_3_1 && !items_3_1.done && (_c = items_3.return)) _c.call(items_3);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 8:
                    return [
                        2 /*return*/ ,
                        results
                    ];
            }
        });
    });
}
var isAWSDate = function isAWSDate(val) {
    return !!/^\d{4}-\d{2}-\d{2}(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTime = function isAWSTime(val) {
    return !!/^\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSDateTime = function isAWSDateTime(val) {
    return !!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTimestamp = function isAWSTimestamp(val) {
    return !!/^\d+$/.exec(String(val));
};
var isAWSEmail = function isAWSEmail(val) {
    return !!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.exec(val);
};
var isAWSJSON = function isAWSJSON(val) {
    try {
        JSON.parse(val);
        return true;
    } catch (_c) {
        return false;
    }
};
var isAWSURL = function isAWSURL(val) {
    try {
        return new URL(val), true;
    } catch (_c) {
        return false;
    }
};
var isAWSPhone = function isAWSPhone(val) {
    return !!/^\+?\d[\d\s-]+$/.exec(val);
};
var isAWSIPAddress = function isAWSIPAddress(val) {
    return !!/((^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$)|(^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$))$/.exec(val);
};
var DeferredPromise = /** @class */ function() {
    function DeferredPromise() {
        var self = this;
        this.promise = new Promise(function(resolve, reject) {
            self.resolve = resolve;
            self.reject = reject;
        });
    }
    return DeferredPromise;
}();
var DeferredCallbackResolver = /** @class */ function() {
    function DeferredCallbackResolver(options) {
        this.limitPromise = new DeferredPromise();
        this.raceInFlight = false;
        this.callback = function() {};
        this.defaultErrorHandler = function(msg) {
            if (msg === void 0) msg = 'DeferredCallbackResolver error';
            throw new Error(msg);
        };
        this.callback = options.callback;
        this.errorHandler = options.errorHandler || this.defaultErrorHandler;
        this.maxInterval = options.maxInterval || 2000;
    }
    DeferredCallbackResolver.prototype.startTimer = function() {
        var _this = this;
        this.timerPromise = new Promise(function(resolve, reject) {
            _this.timer = setTimeout(function() {
                resolve((0, _types.LimitTimerRaceResolvedValues).TIMER);
            }, _this.maxInterval);
        });
    };
    DeferredCallbackResolver.prototype.racePromises = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var winner, err_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        this.raceInFlight = true;
                        this.startTimer();
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                this.timerPromise,
                                this.limitPromise.promise
                            ])
                        ];
                    case 1:
                        winner = _c.sent();
                        this.callback();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        err_1 = _c.sent();
                        this.errorHandler(err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // reset for the next race
                        this.clear();
                        this.raceInFlight = false;
                        this.limitPromise = new DeferredPromise();
                        return [
                            2 /*return*/ ,
                            winner
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DeferredCallbackResolver.prototype.start = function() {
        if (!this.raceInFlight) this.racePromises();
    };
    DeferredCallbackResolver.prototype.clear = function() {
        clearTimeout(this.timer);
    };
    DeferredCallbackResolver.prototype.resolve = function() {
        this.limitPromise.resolve((0, _types.LimitTimerRaceResolvedValues).LIMIT);
    };
    return DeferredCallbackResolver;
}();
function mergePatches(originalSource, oldPatches, newPatches) {
    var patchesToMerge = oldPatches.concat(newPatches);
    var patches;
    (0, _immer.produce)(originalSource, function(draft) {
        (0, _immer.applyPatches)(draft, patchesToMerge);
    }, function(p) {
        patches = p;
    });
    return patches;
}
var getStorename = function getStorename(namespace, modelName) {
    var storeName = namespace + "_" + modelName;
    return storeName;
};
var processCompositeKeys = function processCompositeKeys(attributes) {
    var extractCompositeSortKey = function extractCompositeSortKey(_c) {
        var // ignore the HK (fields[0]) we only need to include the composite sort key fields[1...n]
        _d = (0, _tslib.__read)(_c.properties.fields), sortKeyFields = _d.slice(1);
        return sortKeyFields;
    };
    var compositeKeyFields = attributes.filter((0, _types.isModelAttributeCompositeKey)).map(extractCompositeSortKey);
    /*
        if 2 sets of fields have any intersecting fields => combine them into 1 union set
        e.g., ['a', 'b', 'c'] and ['a', 'b', 'd'] => ['a', 'b', 'c', 'd']
    */ var combineIntersecting = function combineIntersecting(fields) {
        return fields.reduce(function(combined, sortKeyFields) {
            var sortKeyFieldsSet = new Set(sortKeyFields);
            if (combined.length === 0) {
                combined.push(sortKeyFieldsSet);
                return combined;
            }
            // does the current set share values with another set we've already added to `combined`?
            var intersectingSetIdx = combined.findIndex(function(existingSet) {
                return (0, _tslib.__spread)(existingSet).some(function(f) {
                    return sortKeyFieldsSet.has(f);
                });
            });
            if (intersectingSetIdx > -1) {
                var union = new Set((0, _tslib.__spread)(combined[intersectingSetIdx], sortKeyFieldsSet));
                // combine the current set with the intersecting set we found above
                combined[intersectingSetIdx] = union;
            } else // none of the sets in `combined` have intersecting values with the current set
            combined.push(sortKeyFieldsSet);
            return combined;
        }, []);
    };
    var initial = combineIntersecting(compositeKeyFields);
    // a single pass pay not be enough to correctly combine all the fields
    // call the function once more to get a final merged list of sets
    var combined = combineIntersecting(initial);
    return combined;
};
var extractKeyIfExists = function extractKeyIfExists(modelDefinition) {
    var _c;
    var keyAttribute = (_c = modelDefinition === null || modelDefinition === void 0 ? void 0 : modelDefinition.attributes) === null || _c === void 0 ? void 0 : _c.find((0, _types.isModelAttributeKey));
    return keyAttribute;
};
var extractPrimaryKeyFieldNames = function extractPrimaryKeyFieldNames(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields;
    return [
        ID
    ];
};
var extractPrimaryKeyValues = function extractPrimaryKeyValues(model, keyFields) {
    return keyFields.map(function(key) {
        return model[key];
    });
};
var extractPrimaryKeysAndValues = function extractPrimaryKeysAndValues(model, keyFields) {
    var primaryKeysAndValues = {};
    keyFields.forEach(function(key) {
        return primaryKeysAndValues[key] = model[key];
    });
    return primaryKeysAndValues;
};
var isIdManaged = function isIdManaged(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return false;
    return true;
};
var isIdOptionallyManaged = function isIdOptionallyManaged(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields[0] === ID;
    return false;
};
var establishRelationAndKeys = function establishRelationAndKeys(namespace) {
    var relationship = {};
    var keys = {};
    Object.keys(namespace.models).forEach(function(mKey) {
        var e_6, _c;
        relationship[mKey] = {
            indexes: [],
            relationTypes: []
        };
        keys[mKey] = {};
        var model = namespace.models[mKey];
        Object.keys(model.fields).forEach(function(attr) {
            var fieldAttribute = model.fields[attr];
            if ((0, _typeOf._)(fieldAttribute.type) === 'object' && 'model' in fieldAttribute.type) {
                var connectionType = fieldAttribute.association.connectionType;
                relationship[mKey].relationTypes.push({
                    fieldName: fieldAttribute.name,
                    modelName: fieldAttribute.type.model,
                    relationType: connectionType,
                    targetName: fieldAttribute.association['targetName'],
                    targetNames: fieldAttribute.association['targetNames'],
                    associatedWith: fieldAttribute.association['associatedWith']
                });
                if (connectionType === 'BELONGS_TO') {
                    var targetNames = extractTargetNamesFromSrc(fieldAttribute.association);
                    if (targetNames) {
                        var idxName_1 = indexNameFromKeys(targetNames);
                        var idxExists = relationship[mKey].indexes.find(function(_c) {
                            var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                            return index === idxName_1;
                        });
                        if (!idxExists) relationship[mKey].indexes.push([
                            idxName_1,
                            targetNames
                        ]);
                    }
                }
            }
        });
        if (model.attributes) {
            keys[mKey].compositeKeys = processCompositeKeys(model.attributes);
            var _loop_1 = function _loop_1(attribute) {
                if (!(0, _types.isModelAttributeKey)(attribute)) return "continue";
                var fields = attribute.properties.fields;
                if ((0, _types.isModelAttributePrimaryKey)(attribute)) {
                    keys[mKey].primaryKey = fields;
                    return "continue";
                }
                // create indexes for all other keys
                var idxName = indexNameFromKeys(fields);
                var idxExists = relationship[mKey].indexes.find(function(_c) {
                    var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                    return index === idxName;
                });
                if (!idxExists) relationship[mKey].indexes.push([
                    idxName,
                    fields
                ]);
            };
            try {
                for(var _d = (0, _tslib.__values)(model.attributes), _e = _d.next(); !_e.done; _e = _d.next()){
                    var attribute = _e.value;
                    _loop_1(attribute);
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
        }
        // set 'id' as the PK for models without a custom PK explicitly defined
        if (!keys[mKey].primaryKey) keys[mKey].primaryKey = [
            ID
        ];
        // create primary index
        relationship[mKey].indexes.push([
            'byPk',
            keys[mKey].primaryKey,
            {
                unique: true
            }
        ]);
    });
    return [
        relationship,
        keys
    ];
};
var getIndex = function getIndex(rel, src) {
    var indexName;
    rel.some(function(relItem) {
        if (relItem.modelName === src) {
            var targetNames = extractTargetNamesFromSrc(relItem);
            indexName = targetNames && indexNameFromKeys(targetNames);
            return true;
        }
    });
    return indexName;
};
var getIndexFromAssociation = function getIndexFromAssociation(indexes, src) {
    var indexName;
    if (Array.isArray(src)) indexName = indexNameFromKeys(src);
    else indexName = src;
    var associationIndex = indexes.find(function(_c) {
        var _d = (0, _tslib.__read)(_c, 1), idxName = _d[0];
        return idxName === indexName;
    });
    return associationIndex && associationIndex[0];
};
var extractTargetNamesFromSrc = function extractTargetNamesFromSrc(src) {
    var targetName = src === null || src === void 0 ? void 0 : src.targetName;
    var targetNames = src === null || src === void 0 ? void 0 : src.targetNames;
    if (Array.isArray(targetNames)) return targetNames;
    else if (typeof targetName === 'string') return [
        targetName
    ];
    else return undefined;
};
var indexNameFromKeys = function indexNameFromKeys(keys) {
    return keys.reduce(function(prev, cur, idx) {
        if (idx === 0) return cur;
        return "" + prev + IDENTIFIER_KEY_SEPARATOR + cur;
    }, '');
};
var keysEqual = function keysEqual(keysA, keysB) {
    if (keysA.length !== keysB.length) return false;
    return keysA.every(function(key, idx) {
        return key === keysB[idx];
    });
};
var getIndexKeys = function getIndexKeys(namespace, modelName) {
    var _c, _d;
    var keyPath = (_d = (_c = namespace === null || namespace === void 0 ? void 0 : namespace.keys) === null || _c === void 0 ? void 0 : _c[modelName]) === null || _d === void 0 ? void 0 : _d.primaryKey;
    if (keyPath) return keyPath;
    return [
        ID
    ];
};
var getTimestampFields = function getTimestampFields(definition) {
    var _c, _d;
    var modelAttributes = (_c = definition.attributes) === null || _c === void 0 ? void 0 : _c.find(function(attr) {
        return attr.type === 'model';
    });
    var timestampFieldsMap = (_d = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _d === void 0 ? void 0 : _d.timestamps;
    var defaultFields = {
        createdAt: 'createdAt',
        updatedAt: 'updatedAt'
    };
    var customFields = timestampFieldsMap || {};
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultFields), customFields);
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","buffer":"7NC4b","ulid":"c7Ar3","uuid":"bvm5J","immer":"8nxw2","./types":"9W0ar","amazon-cognito-identity-js":"flUAS","./predicates":"bohgw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7NC4b":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
'use strict';
var base64 = require("8912f9896669a94d");
var ieee754 = require("cef07915f0cfc4ed");
var isArray = require("7fecdd7358c4d78c");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError('Invalid typed array length');
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new Error('If encoding is specified then the first argument must be a string');
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === 'string') return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('\'offset\' is out of bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('\'length\' is out of bounds');
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
            if (typeof obj.length !== 'number' || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === 'Buffer' && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('Arguments must be Buffers');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') string = '' + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
        case undefined:
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>';
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError('Argument must be a Buffer');
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    } else if (typeof val === 'number') val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, '');
}
function toHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"8912f9896669a94d":"MlSYJ","cef07915f0cfc4ed":"15Xnl","7fecdd7358c4d78c":"3Xt1f"}],"3Xt1f":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == '[object Array]';
};

},{}],"c7Ar3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceCharAt", function() {
    return replaceCharAt;
});
parcelHelpers.export(exports, "incrementBase32", function() {
    return incrementBase32;
});
parcelHelpers.export(exports, "randomChar", function() {
    return randomChar;
});
parcelHelpers.export(exports, "encodeTime", function() {
    return encodeTime;
});
parcelHelpers.export(exports, "encodeRandom", function() {
    return encodeRandom;
});
parcelHelpers.export(exports, "decodeTime", function() {
    return decodeTime;
});
parcelHelpers.export(exports, "detectPrng", function() {
    return detectPrng;
});
parcelHelpers.export(exports, "factory", function() {
    return factory;
});
parcelHelpers.export(exports, "monotonicFactory", function() {
    return monotonicFactory;
});
parcelHelpers.export(exports, "ulid", function() {
    return ulid;
});
function createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function replaceCharAt(str, index, char) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + char + str.substr(index + 1);
}
function incrementBase32(str) {
    var done = undefined;
    var index = str.length;
    var char = void 0;
    var charIndex = void 0;
    var maxCharIndex = ENCODING_LEN - 1;
    while(!done && index-- >= 0){
        char = str[index];
        charIndex = ENCODING.indexOf(char);
        if (charIndex === -1) throw createError("incorrectly encoded string");
        if (charIndex === maxCharIndex) {
            str = replaceCharAt(str, index, ENCODING[0]);
            continue;
        }
        done = replaceCharAt(str, index, ENCODING[charIndex + 1]);
    }
    if (typeof done === "string") return done;
    throw createError("cannot increment this string");
}
function randomChar(prng) {
    var rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) rand = ENCODING_LEN - 1;
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) throw new Error(now + " must be a number");
    if (now > TIME_MAX) throw createError("cannot encode time greater than " + TIME_MAX);
    if (now < 0) throw createError("time must be positive");
    if (Number.isInteger(now) === false) throw createError("time must be an integer");
    var mod = void 0;
    var str = "";
    for(; len > 0; len--){
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    var str = "";
    for(; len > 0; len--)str = randomChar(prng) + str;
    return str;
}
function decodeTime(id) {
    if (id.length !== TIME_LEN + RANDOM_LEN) throw createError("malformed ulid");
    var time = id.substr(0, TIME_LEN).split("").reverse().reduce(function(carry, char, index) {
        var encodingIndex = ENCODING.indexOf(char);
        if (encodingIndex === -1) throw createError("invalid character found: " + char);
        return carry += encodingIndex * Math.pow(ENCODING_LEN, index);
    }, 0);
    if (time > TIME_MAX) throw createError("malformed ulid, timestamp too large");
    return time;
}
function detectPrng() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];
    if (!root) root = typeof window !== "undefined" ? window : null;
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) return function() {
        var buffer = new Uint8Array(1);
        browserCrypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
    else try {
        var nodeCrypto = require("1002b1ce995ee642");
        return function() {
            return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
        };
    } catch (e) {}
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function() {
            return Math.random();
        };
    }
    throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
    };
}
function monotonicFactory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    var lastTime = 0;
    var lastRandom = void 0;
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        if (seedTime <= lastTime) {
            var incrementedRandom = lastRandom = incrementBase32(lastRandom);
            return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        var newRandom = lastRandom = encodeRandom(RANDOM_LEN, currPrng);
        return encodeTime(seedTime, TIME_LEN) + newRandom;
    };
}
var ulid = factory();

},{"1002b1ce995ee642":"bkmob","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkmob":[function(require,module,exports,__globalThis) {

},{}],"bohgw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", function() {
    return 0, _sort.ModelSortPredicateCreator;
});
parcelHelpers.export(exports, "isPredicatesAll", function() {
    return isPredicatesAll;
});
parcelHelpers.export(exports, "comparisonKeys", function() {
    return comparisonKeys;
});
parcelHelpers.export(exports, "PredicateAll", function() {
    return PredicateAll;
});
parcelHelpers.export(exports, "Predicates", function() {
    return Predicates;
});
parcelHelpers.export(exports, "ModelPredicateCreator", function() {
    return ModelPredicateCreator;
});
var _tslib = require("tslib");
var _util = require("../util");
var _sort = require("./sort");
var predicatesAllSet = new WeakSet();
function isPredicatesAll(predicate) {
    return predicatesAllSet.has(predicate);
}
/**
 * The valid logical grouping keys for a predicate group.
 */ var groupKeys = new Set([
    'and',
    'or',
    'not'
]);
/**
 * Determines whether an object is a GraphQL style predicate "group", which must be an
 * object containing a single "group key", which then contains the child condition(s).
 *
 * E.g.,
 *
 * ```
 * { and: [ ... ] }
 * { not: { ... } }
 * ```
 *
 * @param o The object to test.
 */ var isGroup = function isGroup(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return keys.length === 1 && groupKeys.has(keys[0]);
};
/**
 * Determines whether an object specifies no conditions and should match everything,
 * as would be the case with `Predicates.ALL`.
 *
 * @param o The object to test.
 */ var isEmpty = function isEmpty(o) {
    return !Array.isArray(o) && Object.keys(o).length === 0;
};
var comparisonKeys = new Set([
    'eq',
    'ne',
    'gt',
    'lt',
    'ge',
    'le',
    'contains',
    'notContains',
    'beginsWith',
    'between'
]);
/**
 * Determines whether an object is a GraphQL style predicate comparison node, which must
 * be an object containing a single "comparison operator" key, which then contains the
 * operand or operands to compare against.
 *
 * @param o The object to test.
 */ var isComparison = function isComparison(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return !Array.isArray(o) && keys.length === 1 && comparisonKeys.has(keys[0]);
};
/**
 * A light check to determine whether an object is a valid GraphQL Condition AST.
 *
 * @param o The object to test.
 */ var isValid = function isValid1(o) {
    if (Array.isArray(o)) return o.every(function(v) {
        return isValid(v);
    });
    else return Object.keys(o).length <= 1;
};
var PredicateAll = Symbol('A predicate that matches all records');
var Predicates = /** @class */ function() {
    function Predicates() {}
    Object.defineProperty(Predicates, "ALL", {
        get: function get() {
            var predicate = function predicate(c) {
                return c;
            };
            predicatesAllSet.add(predicate);
            return predicate;
        },
        enumerable: true,
        configurable: true
    });
    return Predicates;
}();
var ModelPredicateCreator = /** @class */ function() {
    function ModelPredicateCreator() {}
    /**
     * Determines whether the given storage predicate (lookup key) is a predicate
     * key that DataStore recognizes.
     *
     * @param predicate The storage predicate (lookup key) to test.
     */ ModelPredicateCreator.isValidPredicate = function(predicate) {
        return ModelPredicateCreator.predicateGroupsMap.has(predicate);
    };
    /**
     * Looks for the storage predicate AST that corresponds to a given storage
     * predicate key.
     *
     * The key must have been created internally by a DataStore utility
     * method, such as `ModelPredicate.createFromAST()`.
     *
     * @param predicate The predicate reference to look up.
     * @param throwOnInvalid Whether to throw an exception if the predicate
     * isn't a valid DataStore predicate.
     */ ModelPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelPredicateCreator.isValidPredicate(predicate)) throw new Error('The predicate is not valid');
        return ModelPredicateCreator.predicateGroupsMap.get(predicate);
    };
    /**
     * using the PK values from the given `model` (which can be a partial of T
     * Creates a predicate that matches an instance described by `modelDefinition`
     * that contains only PK field values.)
     *
     * @param modelDefinition The model definition to create a predicate for.
     * @param model The model instance to extract value equalities from.
     */ ModelPredicateCreator.createForPk = function(modelDefinition, model) {
        var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
        var keyValues = (0, _util.extractPrimaryKeyValues)(model, keyFields);
        var predicate = this.createFromAST(modelDefinition, {
            and: keyFields.map(function(field, idx) {
                var _a;
                var operand = keyValues[idx];
                return _a = {}, _a[field] = {
                    eq: operand
                }, _a;
            })
        });
        return predicate;
    };
    /**
     * Searches a `Model` table for records matching the given equalities object.
     *
     * This only matches against fields given in the equalities object. No other
     * fields are tested by the predicate.
     *
     * @param modelDefinition The model we need a predicate for.
     * @param flatEqualities An object holding field equalities to search for.
     */ ModelPredicateCreator.createFromFlatEqualities = function(modelDefinition, flatEqualities) {
        var ast = {
            and: Object.entries(flatEqualities).map(function(_a) {
                var _b;
                var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                return _b = {}, _b[k] = {
                    eq: v
                }, _b;
            })
        };
        return this.createFromAST(modelDefinition, ast);
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into an
     * AST that can be used for a storage adapter predicate. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param gql GraphQL style filter node.
     */ ModelPredicateCreator.transformGraphQLFilterNodeToPredicateAST = function(gql) {
        var _this = this;
        if (!isValid(gql)) throw new Error('Invalid GraphQL Condition or subtree: ' + JSON.stringify(gql));
        if (isEmpty(gql)) return {
            type: 'and',
            predicates: []
        };
        else if (isGroup(gql)) {
            var groupkey = Object.keys(gql)[0];
            var children = this.transformGraphQLFilterNodeToPredicateAST(gql[groupkey]);
            return {
                type: groupkey,
                predicates: Array.isArray(children) ? children : [
                    children
                ]
            };
        } else if (isComparison(gql)) {
            var operatorKey = Object.keys(gql)[0];
            return {
                operator: operatorKey,
                operand: gql[operatorKey]
            };
        } else {
            if (Array.isArray(gql)) return gql.map(function(o) {
                return _this.transformGraphQLFilterNodeToPredicateAST(o);
            });
            else {
                var fieldKey = Object.keys(gql)[0];
                return (0, _tslib.__assign)({
                    field: fieldKey
                }, this.transformGraphQLFilterNodeToPredicateAST(gql[fieldKey]));
            }
        }
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into a predicate
     * that storage adapters understand. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param modelDefinition The model that the AST/predicate must be compatible with.
     * @param ast The graphQL style AST that should specify conditions for `modelDefinition`.
     */ ModelPredicateCreator.createFromAST = function(modelDefinition, ast) {
        var key = {};
        ModelPredicateCreator.predicateGroupsMap.set(key, this.transformGraphQLFilterNodeToPredicateAST(ast));
        return key;
    };
    /**
     * Map of storage predicates (key objects) to storage predicate AST's.
     */ ModelPredicateCreator.predicateGroupsMap = new WeakMap();
    return ModelPredicateCreator;
}();

},{"tslib":"86BcK","../util":"iFXfl","./sort":"lO2Jp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lO2Jp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", function() {
    return ModelSortPredicateCreator;
});
var ModelSortPredicateCreator = /** @class */ function() {
    function ModelSortPredicateCreator() {}
    ModelSortPredicateCreator.createPredicateBuilder = function(modelDefinition) {
        var modelName = modelDefinition.name;
        var fieldNames = new Set(Object.keys(modelDefinition.fields));
        var handler;
        var predicate = new Proxy({}, handler = {
            get: function get(_target, propertyKey, receiver) {
                var field = propertyKey;
                if (!fieldNames.has(field)) throw new Error("Invalid field for model. field: " + field + ", model: " + modelName);
                var result = function result(sortDirection) {
                    var _a;
                    (_a = ModelSortPredicateCreator.sortPredicateGroupsMap.get(receiver)) === null || _a === void 0 || _a.push({
                        field: field,
                        sortDirection: sortDirection
                    });
                    return receiver;
                };
                return result;
            }
        });
        ModelSortPredicateCreator.sortPredicateGroupsMap.set(predicate, []);
        return predicate;
    };
    ModelSortPredicateCreator.isValidPredicate = function(predicate) {
        return ModelSortPredicateCreator.sortPredicateGroupsMap.has(predicate);
    };
    ModelSortPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelSortPredicateCreator.isValidPredicate(predicate)) throw new Error('The predicate is not valid');
        var predicateGroup = ModelSortPredicateCreator.sortPredicateGroupsMap.get(predicate);
        if (predicateGroup) return predicateGroup;
        else throw new Error('Predicate group not found');
    };
    // transforms cb-style predicate into Proxy
    ModelSortPredicateCreator.createFromExisting = function(modelDefinition, existing) {
        if (!existing || !modelDefinition) return undefined;
        return existing(ModelSortPredicateCreator.createPredicateBuilder(modelDefinition));
    };
    ModelSortPredicateCreator.sortPredicateGroupsMap = new WeakMap();
    return ModelSortPredicateCreator;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gjDZS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExclusiveStorage", function() {
    return ExclusiveStorage;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenPush = require("zen-push");
var _zenPushDefault = parcelHelpers.interopDefault(_zenPush);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("../sync/utils");
var _getDefaultAdapter = require("./adapter/getDefaultAdapter");
var _getDefaultAdapterDefault = parcelHelpers.interopDefault(_getDefaultAdapter);
var logger = new (0, _core.Logger)('DataStore');
var StorageClass = /** @class */ function() {
    function StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.getModelConstructorByModelName = getModelConstructorByModelName;
        this.modelInstanceCreator = modelInstanceCreator;
        this.adapter = adapter;
        this.sessionId = sessionId;
        this.adapter = this.adapter || (0, _getDefaultAdapterDefault.default)();
        this.pushStream = new (0, _zenPushDefault.default)();
    }
    StorageClass.getNamespace = function() {
        var namespace = {
            name: (0, _util.STORAGE),
            relationships: {},
            enums: {},
            models: {},
            nonModels: {}
        };
        return namespace;
    };
    StorageClass.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resolve, reject;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.initialized !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        logger.debug('Starting Storage');
                        this.initialized = new Promise(function(res, rej) {
                            resolve = res;
                            reject = rej;
                        });
                        this.adapter.setUp(this.schema, this.namespaceResolver, this.modelInstanceCreator, this.getModelConstructorByModelName, this.sessionId).then(resolve, reject);
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.save(model, condition)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(r) {
                            var _$_a = (0, _tslib.__read)(r, 2), savedElement = _$_a[0], opType = _$_a[1];
                            // truthy when save is called by the Merger
                            var syncResponse = !!mutator;
                            var updateMutationInput;
                            // don't attempt to calc mutation input when storage.save
                            // is called by Merger, i.e., when processing an AppSync response
                            if ((opType === (0, _types.OpType).UPDATE || opType === (0, _types.OpType).INSERT) && !syncResponse) {
                                //
                                // TODO: LOOK!!!
                                // the `model` used here is in effect regardless of what model
                                // comes back from adapter.save().
                                // Prior to fix, SQLite adapter had been returning two models
                                // of different types, resulting in invalid outbox entries.
                                //
                                // the bug is essentially fixed in SQLite adapter.
                                // leaving as-is, because it's currently unclear whether anything
                                // depends on this remaining as-is.
                                //
                                updateMutationInput = _this.getChangedFieldsInput(model, savedElement, patchesTuple);
                                // // an update without changed user fields
                                // => don't create mutationEvent
                                if (updateMutationInput === null) return result;
                            }
                            var element = updateMutationInput || savedElement;
                            var modelConstructor = Object.getPrototypeOf(savedElement).constructor;
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: condition && (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) || null,
                                savedElement: savedElement
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    StorageClass.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var models, deleted, modelConstructor, namespaceName, modelDefinition, modelIds;
            var _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _b.sent();
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.delete(modelOrModelConstructor, condition)
                        ];
                    case 2:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), models = _a[0], deleted = _a[1];
                        modelConstructor = (0, _util.isModelConstructor)(modelOrModelConstructor) ? modelOrModelConstructor : Object.getPrototypeOf(modelOrModelConstructor || {}).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
                        modelIds = new Set(models.map(function(model) {
                            var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                            return modelId;
                        }));
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor) && !Array.isArray(deleted)) deleted = [
                            deleted
                        ];
                        deleted.forEach(function(model) {
                            var modelConstructor = Object.getPrototypeOf(model).constructor;
                            var theCondition;
                            if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) {
                                var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                                theCondition = modelIds.has(modelId) ? (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) : undefined;
                            }
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: (0, _types.OpType).DELETE,
                                element: model,
                                mutator: mutator,
                                condition: theCondition || null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deleted
                            ]
                        ];
                }
            });
        });
    };
    StorageClass.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.query(modelConstructor, predicate, pagination)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.queryOne(modelConstructor, firstOrLast)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        var listenToAll = !modelConstructor;
        var _a = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate, false) || {}, predicates = _a.predicates, type = _a.type;
        var result = this.pushStream.observable.filter(function(_a) {
            var mutator = _a.mutator;
            return !skipOwn || mutator !== skipOwn;
        }).map(function(_a) {
            var _mutator = _a.mutator, message = (0, _tslib.__rest)(_a, [
                "mutator"
            ]);
            return message;
        });
        if (!listenToAll) result = result.filter(function(_a) {
            var model = _a.model, element = _a.element;
            if (modelConstructor !== model) return false;
            if (!!predicates && !!type) return (0, _util.validatePredicate)(element, type, predicates);
            return true;
        });
        return result;
    };
    StorageClass.prototype.clear = function(completeObservable) {
        if (completeObservable === void 0) completeObservable = true;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.initialized = undefined;
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.clear()
                        ];
                    case 1:
                        _a.sent();
                        if (completeObservable) this.pushStream.complete();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.batchSave = function(modelConstructor, items, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error('Storage adapter is missing');
                        return [
                            4 /*yield*/ ,
                            this.adapter.batchSave(modelConstructor, items)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), element = _b[0], opType = _b[1];
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // returns null if no user fields were changed (determined by value comparison)
    StorageClass.prototype.getChangedFieldsInput = function(model, originalElement, patchesTuple) {
        var e_1, _a;
        var _b;
        var containsPatches = patchesTuple && patchesTuple.length;
        if (!containsPatches) return null;
        var _c = (0, _tslib.__read)(patchesTuple, 2), patches = _c[0], source = _c[1];
        var updatedElement = {};
        // extract array of updated fields from patches
        var updatedFields = patches.map(function(patch) {
            return patch.path && patch.path[0];
        });
        // check model def for association and replace with targetName if exists
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespace = this.namespaceResolver(modelConstructor);
        var fields = this.schema.namespaces[namespace].models[modelConstructor.name].fields;
        var _d = ((_b = this.schema.namespaces[namespace].keys) === null || _b === void 0 ? void 0 : _b[modelConstructor.name]) || {}, primaryKey = _d.primaryKey, _e = _d.compositeKeys, compositeKeys = _e === void 0 ? [] : _e;
        // set original values for these fields
        updatedFields.forEach(function(field) {
            var e_2, _a, e_3, _b, e_4, _c, e_5, _d, e_6, _e;
            var _f;
            var targetNames = (0, _types.isTargetNameAssociation)((_f = fields[field]) === null || _f === void 0 ? void 0 : _f.association);
            if (Array.isArray(targetNames)) try {
                // if field refers to a belongsTo relation, use the target field instead
                for(var targetNames_1 = (0, _tslib.__values)(targetNames), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                    var targetName = targetNames_1_1.value;
                    // check field values by value. Ignore unchanged fields
                    if (!(0, _util.valuesEqual)(source[targetName], originalElement[targetName])) {
                        // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                        updatedElement[targetName] = originalElement[targetName] === undefined ? null : originalElement[targetName];
                        try {
                            for(var compositeKeys_1 = (e_3 = void 0, (0, _tslib.__values)(compositeKeys)), compositeKeys_1_1 = compositeKeys_1.next(); !compositeKeys_1_1.done; compositeKeys_1_1 = compositeKeys_1.next()){
                                var fieldSet = compositeKeys_1_1.value;
                                // include all of the fields that comprise the composite key
                                if (fieldSet.has(targetName)) try {
                                    for(var fieldSet_1 = (e_4 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_1_1 = fieldSet_1.next(); !fieldSet_1_1.done; fieldSet_1_1 = fieldSet_1.next()){
                                        var compositeField = fieldSet_1_1.value;
                                        updatedElement[compositeField] = originalElement[compositeField];
                                    }
                                } catch (e_4_1) {
                                    e_4 = {
                                        error: e_4_1
                                    };
                                } finally{
                                    try {
                                        if (fieldSet_1_1 && !fieldSet_1_1.done && (_c = fieldSet_1.return)) _c.call(fieldSet_1);
                                    } finally{
                                        if (e_4) throw e_4.error;
                                    }
                                }
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (compositeKeys_1_1 && !compositeKeys_1_1.done && (_b = compositeKeys_1.return)) _b.call(compositeKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (targetNames_1_1 && !targetNames_1_1.done && (_a = targetNames_1.return)) _a.call(targetNames_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            else {
                // Backwards compatibility pre-CPK
                // if field refers to a belongsTo relation, use the target field instead
                var key = targetNames || field;
                // check field values by value. Ignore unchanged fields
                if (!(0, _util.valuesEqual)(source[key], originalElement[key])) {
                    // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                    updatedElement[key] = originalElement[key] === undefined ? null : originalElement[key];
                    try {
                        for(var compositeKeys_2 = (0, _tslib.__values)(compositeKeys), compositeKeys_2_1 = compositeKeys_2.next(); !compositeKeys_2_1.done; compositeKeys_2_1 = compositeKeys_2.next()){
                            var fieldSet = compositeKeys_2_1.value;
                            // include all of the fields that comprise the composite key
                            if (fieldSet.has(key)) try {
                                for(var fieldSet_2 = (e_6 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_2_1 = fieldSet_2.next(); !fieldSet_2_1.done; fieldSet_2_1 = fieldSet_2.next()){
                                    var compositeField = fieldSet_2_1.value;
                                    updatedElement[compositeField] = originalElement[compositeField];
                                }
                            } catch (e_6_1) {
                                e_6 = {
                                    error: e_6_1
                                };
                            } finally{
                                try {
                                    if (fieldSet_2_1 && !fieldSet_2_1.done && (_e = fieldSet_2.return)) _e.call(fieldSet_2);
                                } finally{
                                    if (e_6) throw e_6.error;
                                }
                            }
                        }
                    } catch (e_5_1) {
                        e_5 = {
                            error: e_5_1
                        };
                    } finally{
                        try {
                            if (compositeKeys_2_1 && !compositeKeys_2_1.done && (_d = compositeKeys_2.return)) _d.call(compositeKeys_2);
                        } finally{
                            if (e_5) throw e_5.error;
                        }
                    }
                }
            }
        });
        // Exit early when there are no changes introduced in the update mutation
        if (Object.keys(updatedElement).length === 0) return null;
        // include field(s) from custom PK if one is specified for the model
        if (primaryKey && primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                updatedElement[pkField] = originalElement[pkField];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var id = originalElement.id, _version = originalElement._version, _lastChangedAt = originalElement._lastChangedAt, _deleted = originalElement._deleted;
        // For update mutations we only want to send fields with changes
        // and the required internal fields
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedElement), {
            id: id,
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        });
    };
    return StorageClass;
}();
var ExclusiveStorage = /** @class */ function() {
    function ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.mutex = new (0, _core.Mutex)();
        this.storage = new StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId);
    }
    ExclusiveStorage.prototype.runExclusive = function(fn) {
        return this.mutex.runExclusive(fn.bind(this, this.storage));
    };
    ExclusiveStorage.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.save(model, condition, mutator, patchesTuple);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        if ((0, _util.isModelConstructor)(modelOrModelConstructor)) {
                            var modelConstructor = modelOrModelConstructor;
                            return storage.delete(modelConstructor, condition, mutator);
                        } else {
                            var model = modelOrModelConstructor;
                            return storage.delete(model, condition, mutator);
                        }
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.query(modelConstructor, predicate, pagination);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.queryOne(modelConstructor, firstOrLast);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.getNamespace = function() {
        return StorageClass.getNamespace();
    };
    ExclusiveStorage.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        return this.storage.observe(modelConstructor, predicate, skipOwn);
    };
    ExclusiveStorage.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runExclusive(function(storage) {
                                return storage.clear();
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ExclusiveStorage.prototype.batchSave = function(modelConstructor, items) {
        return this.storage.batchSave(modelConstructor, items);
    };
    ExclusiveStorage.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.storage.init()
                ];
            });
        });
    };
    return ExclusiveStorage;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","zen-push":"lYxKt","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","../sync/utils":"3udIx","./adapter/getDefaultAdapter":"28vIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lYxKt":[function(require,module,exports,__globalThis) {
'use strict';
var Observable = require("8ee1d41987ca192");
function addMethods(target, methods) {
    Object.keys(methods).forEach(function(k) {
        var desc = Object.getOwnPropertyDescriptor(methods, k);
        desc.enumerable = false;
        Object.defineProperty(target, k, desc);
    });
}
function send(p, message, value) {
    if (p._observer) sendMessage(p._observer, message, value);
    else if (p._observers) {
        var list = [];
        p._observers.forEach(function(to) {
            list.push(to);
        });
        list.forEach(function(to) {
            sendMessage(to, message, value);
        });
    }
}
function sendMessage(observer, message, value) {
    if (observer.closed) return;
    switch(message){
        case 'next':
            return observer.next(value);
        case 'error':
            return observer.error(value);
        case 'complete':
            return observer.complete(value);
    }
}
function hasObserver(p) {
    return p._observer || p._observers && p._observers.size > 0;
}
function addObserver(p, observer) {
    if (p._observers) p._observers.add(observer);
    else if (!p._observer) p._observer = observer;
    else {
        p._observers = new Set();
        p._observers.add(p._observer);
        p._observers.add(observer);
        p._observer = null;
    }
}
function deleteObserver(p, observer) {
    if (p._observers) p._observers.delete(observer);
    else if (p._observer === observer) p._observer = null;
}
function notifyStart(p, opts) {
    !hasObserver(p) && opts && opts.start && opts.start();
}
function notifyPause(p, opts) {
    !hasObserver(p) && opts && opts.pause && opts.pause();
}
function PushStream(opts) {
    var p = this;
    this._observer = null;
    this._observers = null;
    this._observable = new Observable(function(observer) {
        notifyStart(p, opts);
        addObserver(p, observer);
        return function() {
            deleteObserver(p, observer);
            notifyPause(p, opts);
        };
    });
}
addMethods(PushStream.prototype, {
    get observable () {
        return this._observable;
    },
    get observed () {
        return hasObserver(this);
    },
    next: function next(x) {
        send(this, 'next', x);
    },
    error: function error(e) {
        send(this, 'error', e);
    },
    complete: function complete(x) {
        send(this, 'complete', x);
    }
});
module.exports = PushStream;

},{"8ee1d41987ca192":"8RDbS"}],"8RDbS":[function(require,module,exports,__globalThis) {
module.exports = require("b4c55f2c243ab7f3").Observable;

},{"b4c55f2c243ab7f3":"8bnYs"}],"8bnYs":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
(function(fn, name) {
    var e;
    fn(exports, module);
})(function(exports1, module1) {
    function hasSymbol(name) {
        return typeof Symbol === "function" && Boolean(Symbol[name]);
    }
    function getSymbol(name) {
        return hasSymbol(name) ? Symbol[name] : "@@" + name;
    }
    // Ponyfill Symbol.observable for interoperability with other libraries
    if (typeof Symbol === "function" && !Symbol.observable) Symbol.observable = Symbol("observable");
    // === Abstract Operations ===
    function hostReportError(e) {
        setTimeout(function() {
            throw e;
        });
    }
    function getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== "function") throw new TypeError(value + " is not a function");
        return value;
    }
    function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[getSymbol("species")];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : Observable;
    }
    function addMethods(target, methods) {
        Object.keys(methods).forEach(function(k) {
            var desc = Object.getOwnPropertyDescriptor(methods, k);
            desc.enumerable = false;
            Object.defineProperty(target, k, desc);
        });
    }
    function cleanupSubscription(subscription) {
        // Assert:  observer._observer is undefined
        var cleanup = subscription._cleanup;
        if (!cleanup) return;
        // Drop the reference to the cleanup function so that we won't call it
        // more than once
        subscription._cleanup = undefined;
        // Call the cleanup function
        try {
            cleanup();
        } catch (e) {
            hostReportError(e);
        }
    }
    function subscriptionClosed(subscription) {
        return subscription._observer === undefined;
    }
    function closeSubscription(subscription) {
        if (subscriptionClosed(subscription)) return;
        subscription._observer = undefined;
        cleanupSubscription(subscription);
    }
    function cleanupFromSubscription(subscription) {
        return function() {
            subscription.unsubscribe();
        };
    }
    function Subscription(observer, subscriber) {
        // Assert: subscriber is callable
        // The observer must be an object
        if (Object(observer) !== observer) throw new TypeError("Observer must be an object");
        this._cleanup = undefined;
        this._observer = observer;
        try {
            var start$0 = getMethod(observer, "start");
            if (start$0) start$0.call(observer, this);
        } catch (e) {
            hostReportError(e);
        }
        if (subscriptionClosed(this)) return;
        observer = new SubscriptionObserver(this);
        try {
            // Call the subscriber function
            var cleanup$0 = subscriber.call(undefined, observer);
            // The return value must be undefined, null, a subscription object, or a function
            if (cleanup$0 != null) {
                if (typeof cleanup$0.unsubscribe === "function") cleanup$0 = cleanupFromSubscription(cleanup$0);
                else if (typeof cleanup$0 !== "function") throw new TypeError(cleanup$0 + " is not a function");
                this._cleanup = cleanup$0;
            }
        } catch (e) {
            // If an error occurs during startup, then attempt to send the error
            // to the observer
            observer.error(e);
            return;
        }
        // If the stream is already finished, then perform cleanup
        if (subscriptionClosed(this)) cleanupSubscription(this);
    }
    addMethods(Subscription.prototype = {}, {
        get closed () {
            return subscriptionClosed(this);
        },
        unsubscribe: function unsubscribe() {
            closeSubscription(this);
        }
    });
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    addMethods(SubscriptionObserver.prototype = {}, {
        get closed () {
            return subscriptionClosed(this._subscription);
        },
        next: function next(value) {
            var subscription = this._subscription;
            // If the stream is closed, then return undefined
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            try {
                // If the observer has a "next" method, send the next value
                var m$0 = getMethod(observer, "next");
                if (m$0) m$0.call(observer, value);
            } catch (e) {
                hostReportError(e);
            }
        },
        error: function error(value) {
            var subscription = this._subscription;
            // If the stream is closed, throw the error to the caller
            if (subscriptionClosed(subscription)) {
                hostReportError(value);
                return;
            }
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$1 = getMethod(observer, "error");
                if (m$1) m$1.call(observer, value);
                else throw value;
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        },
        complete: function complete() {
            var subscription = this._subscription;
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$2 = getMethod(observer, "complete");
                if (m$2) m$2.call(observer);
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        }
    });
    function Observable(subscriber) {
        // Constructor cannot be called as a function
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        // The stream subscriber must be a function
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    addMethods(Observable.prototype, {
        subscribe: function subscribe(observer) {
            for(var args = [], __$0 = 1; __$0 < arguments.length; ++__$0)args.push(arguments[__$0]);
            if (typeof observer === 'function') observer = {
                next: observer,
                error: args[0],
                complete: args[1]
            };
            else if ((typeof observer === "undefined" ? "undefined" : (0, _typeOf._)(observer)) !== 'object' || observer === null) observer = {};
            return new Subscription(observer, this._subscriber);
        },
        forEach: function forEach(fn) {
            var __this = this;
            return new Promise(function(resolve, reject) {
                if (typeof fn !== "function") return Promise.reject(new TypeError(fn + " is not a function"));
                __this.subscribe({
                    _subscription: null,
                    start: function start(subscription) {
                        if (Object(subscription) !== subscription) throw new TypeError(subscription + " is not an object");
                        this._subscription = subscription;
                    },
                    next: function next(value) {
                        var subscription = this._subscription;
                        if (subscription.closed) return;
                        try {
                            fn(value);
                        } catch (err) {
                            reject(err);
                            subscription.unsubscribe();
                        }
                    },
                    error: reject,
                    complete: resolve
                });
            });
        },
        map: function map(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function next(value) {
                        if (observer.closed) return;
                        try {
                            value = fn(value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function error(e) {
                        observer.error(e);
                    },
                    complete: function complete() {
                        observer.complete();
                    }
                });
            });
        },
        filter: function filter(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function next(value) {
                        if (observer.closed) return;
                        try {
                            if (!fn(value)) return;
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function error(e) {
                        observer.error(e);
                    },
                    complete: function complete() {
                        observer.complete();
                    }
                });
            });
        },
        reduce: function reduce(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            var hasSeed = arguments.length > 1;
            var hasValue = false;
            var seed = arguments[1];
            var acc = seed;
            return new C(function(observer) {
                return __this.subscribe({
                    next: function next(value) {
                        if (observer.closed) return;
                        var first = !hasValue;
                        hasValue = true;
                        if (!first || hasSeed) try {
                            acc = fn(acc, value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        else acc = value;
                    },
                    error: function error(e) {
                        observer.error(e);
                    },
                    complete: function complete() {
                        if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                        observer.next(acc);
                        observer.complete();
                    }
                });
            });
        }
    });
    Object.defineProperty(Observable.prototype, getSymbol("observable"), {
        value: function value() {
            return this;
        },
        writable: true,
        configurable: true
    });
    addMethods(Observable, {
        from: function from(x) {
            var C = typeof this === "function" ? this : Observable;
            if (x == null) throw new TypeError(x + " is not an object");
            var method = getMethod(x, getSymbol("observable"));
            if (method) {
                var observable$0 = method.call(x);
                if (Object(observable$0) !== observable$0) throw new TypeError(observable$0 + " is not an object");
                if (observable$0.constructor === C) return observable$0;
                return new C(function(observer) {
                    return observable$0.subscribe(observer);
                });
            }
            if (hasSymbol("iterator") && (method = getMethod(x, getSymbol("iterator")))) return new C(function(observer) {
                for(var __$0 = method.call(x)[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done;){
                    var item$0 = __$1.value;
                    observer.next(item$0);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            if (Array.isArray(x)) return new C(function(observer) {
                for(var i$0 = 0; i$0 < x.length; ++i$0){
                    observer.next(x[i$0]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            throw new TypeError(x + " is not observable");
        },
        of: function of() {
            for(var items = [], __$0 = 0; __$0 < arguments.length; ++__$0)items.push(arguments[__$0]);
            var C = typeof this === "function" ? this : Observable;
            return new C(function(observer) {
                for(var i$1 = 0; i$1 < items.length; ++i$1){
                    observer.next(items[i$1]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        }
    });
    Object.defineProperty(Observable, getSymbol("species"), {
        get: function get() {
            return this;
        },
        configurable: true
    });
    Object.defineProperty(Observable, "extensions", {
        value: {
            observableSymbol: getSymbol("observable"),
            setHostReportError: function setHostReportError(fn) {
                hostReportError = fn;
            }
        }
    });
    exports1.Observable = Observable;
}, "*");

},{"@swc/helpers/_/_type_of":"668P4"}],"3udIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransformerMutationType", function() {
    return TransformerMutationType;
});
parcelHelpers.export(exports, "getMetadataFields", function() {
    return getMetadataFields;
});
parcelHelpers.export(exports, "generateSelectionSet", function() {
    return generateSelectionSet;
});
parcelHelpers.export(exports, "getAuthorizationRules", function() {
    return getAuthorizationRules;
});
parcelHelpers.export(exports, "buildSubscriptionGraphQLOperation", function() {
    return buildSubscriptionGraphQLOperation;
});
parcelHelpers.export(exports, "buildGraphQLOperation", function() {
    return buildGraphQLOperation;
});
parcelHelpers.export(exports, "createMutationInstanceFromModelOperation", function() {
    return createMutationInstanceFromModelOperation;
});
parcelHelpers.export(exports, "predicateToGraphQLCondition", function() {
    return predicateToGraphQLCondition;
});
/**
 * @param predicatesGroup - Predicate Group
    @returns GQL Filter Expression from Predicate Group
    
    @remarks Flattens redundant list predicates
    @example

    ```js
    { and:[{ and:[{ username:  { eq: 'bob' }}] }] }
    ```
    Becomes
    ```js
    { and:[{ username: { eq: 'bob' }}] }
    ```
    */ parcelHelpers.export(exports, "predicateToGraphQLFilter", function() {
    return predicateToGraphQLFilter;
});
/**
 *
 * @param group - selective sync predicate group
 * @returns set of distinct field names in the filter group
 */ parcelHelpers.export(exports, "filterFields", function() {
    return filterFields;
});
/**
 *
 * @param modelDefinition
 * @returns set of field names used with dynamic auth modes configured for the provided model definition
 */ parcelHelpers.export(exports, "dynamicAuthFields", function() {
    return dynamicAuthFields;
});
/**
 *
 * @param group - selective sync predicate group
 * @returns the total number of OR'd predicates in the filter group
 *
 * @example returns 2
 * ```js
 * { type: "or", predicates: [
 * { field: "username", operator: "beginsWith", operand: "a" },
 * { field: "title", operator: "contains", operand: "abc" },
 * ]}
 * ```
 */ parcelHelpers.export(exports, "countFilterCombinations", function() {
    return countFilterCombinations;
});
/**
 *
 * @param group - selective sync predicate group
 * @returns name of repeated field | null
 *
 * @example returns "username"
 * ```js
 * { type: "and", predicates: [
 * 		{ field: "username", operator: "beginsWith", operand: "a" },
 * 		{ field: "username", operator: "contains", operand: "abc" },
 * ] }
 * ```
 */ parcelHelpers.export(exports, "repeatedFieldInGroup", function() {
    return repeatedFieldInGroup;
});
parcelHelpers.export(exports, "RTFError", function() {
    return RTFError;
});
parcelHelpers.export(exports, "generateRTFRemediation", function() {
    return generateRTFRemediation;
});
parcelHelpers.export(exports, "getUserGroupsFromToken", function() {
    return getUserGroupsFromToken;
});
parcelHelpers.export(exports, "getModelAuthModes", function() {
    return getModelAuthModes;
});
parcelHelpers.export(exports, "getForbiddenError", function() {
    return getForbiddenError;
});
parcelHelpers.export(exports, "getClientSideAuthError", function() {
    return getClientSideAuthError;
});
parcelHelpers.export(exports, "getTokenForCustomAuth", function() {
    return getTokenForCustomAuth;
});
// Util that takes a modelDefinition and model and returns either the id value(s) or the custom primary key value(s)
parcelHelpers.export(exports, "getIdentifierValue", function() {
    return getIdentifierValue;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _apiGraphql = require("@aws-amplify/api-graphql");
var _api = require("@aws-amplify/api");
var _core = require("@aws-amplify/core");
var _types = require("../types");
var _util = require("../util");
var logger = new (0, _core.Logger)('DataStore');
var GraphQLOperationType;
(function(GraphQLOperationType) {
    GraphQLOperationType["LIST"] = "query";
    GraphQLOperationType["CREATE"] = "mutation";
    GraphQLOperationType["UPDATE"] = "mutation";
    GraphQLOperationType["DELETE"] = "mutation";
    GraphQLOperationType["GET"] = "query";
})(GraphQLOperationType || (GraphQLOperationType = {}));
var TransformerMutationType;
(function(TransformerMutationType) {
    TransformerMutationType["CREATE"] = "Create";
    TransformerMutationType["UPDATE"] = "Update";
    TransformerMutationType["DELETE"] = "Delete";
    TransformerMutationType["GET"] = "Get";
})(TransformerMutationType || (TransformerMutationType = {}));
var dummyMetadata = {
    _version: undefined,
    _lastChangedAt: undefined,
    _deleted: undefined
};
var metadataFields = Object.keys(dummyMetadata);
function getMetadataFields() {
    return metadataFields;
}
function generateSelectionSet(namespace, modelDefinition) {
    var scalarFields = getScalarFields(modelDefinition);
    var nonModelFields = getNonModelFields(namespace, modelDefinition);
    var implicitOwnerField = getImplicitOwnerField(modelDefinition, scalarFields);
    var scalarAndMetadataFields = Object.values(scalarFields).map(function(_a) {
        var name = _a.name;
        return name;
    }).concat(implicitOwnerField).concat(nonModelFields);
    if ((0, _types.isSchemaModel)(modelDefinition)) scalarAndMetadataFields = scalarAndMetadataFields.concat(getMetadataFields()).concat(getConnectionFields(modelDefinition, namespace));
    var result = scalarAndMetadataFields.join('\n');
    return result;
}
function getImplicitOwnerField(modelDefinition, scalarFields) {
    var ownerFields = getOwnerFields(modelDefinition);
    if (!scalarFields.owner && ownerFields.includes('owner')) return [
        'owner'
    ];
    return [];
}
function getOwnerFields(modelDefinition) {
    var ownerFields = [];
    if ((0, _types.isSchemaModelWithAttributes)(modelDefinition)) modelDefinition.attributes.forEach(function(attr) {
        if (attr.properties && attr.properties.rules) {
            var rule = attr.properties.rules.find(function(rule) {
                return rule.allow === 'owner';
            });
            if (rule && rule.ownerField) ownerFields.push(rule.ownerField);
        }
    });
    return ownerFields;
}
function getScalarFields(modelDefinition) {
    var fields = modelDefinition.fields;
    var result = Object.values(fields).filter(function(field) {
        if ((0, _types.isGraphQLScalarType)(field.type) || (0, _types.isEnumFieldType)(field.type)) return true;
        return false;
    }).reduce(function(acc, field) {
        acc[field.name] = field;
        return acc;
    }, {});
    return result;
}
// Used for generating the selection set for queries and mutations
function getConnectionFields(modelDefinition, namespace) {
    var result = [];
    Object.values(modelDefinition.fields).filter(function(_a) {
        var association = _a.association;
        return association && Object.keys(association).length;
    }).forEach(function(_a) {
        var name = _a.name, association = _a.association;
        var connectionType = (association || {}).connectionType;
        switch(connectionType){
            case 'HAS_ONE':
            case 'HAS_MANY':
                break;
            case 'BELONGS_TO':
                if ((0, _types.isTargetNameAssociation)(association)) {
                    // New codegen (CPK)
                    if (association.targetNames && association.targetNames.length > 0) {
                        // Need to retrieve relations in order to get connected model keys
                        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(namespace), 1), relations = _b[0];
                        var connectedModelName = modelDefinition.fields[name].type['model'];
                        var byPkIndex = relations[connectedModelName].indexes.find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), name = _b[0];
                            return name === 'byPk';
                        });
                        var keyFields = byPkIndex && byPkIndex[1];
                        var keyFieldSelectionSet = keyFields === null || keyFields === void 0 ? void 0 : keyFields.join(' ');
                        // We rely on `_deleted` when we process the sync query (e.g. in batchSave in the adapters)
                        result.push(name + " { " + keyFieldSelectionSet + " _deleted }");
                    } else // backwards-compatability for schema generated prior to custom primary key support
                    result.push(name + " { id _deleted }");
                }
                break;
            default:
                throw new Error("Invalid connection type " + connectionType);
        }
    });
    return result;
}
function getNonModelFields(namespace, modelDefinition) {
    var result = [];
    Object.values(modelDefinition.fields).forEach(function(_a) {
        var name = _a.name, type = _a.type;
        if ((0, _types.isNonModelFieldType)(type)) {
            var typeDefinition = namespace.nonModels[type.nonModel];
            var scalarFields = Object.values(getScalarFields(typeDefinition)).map(function(_a) {
                var name = _a.name;
                return name;
            });
            var nested_1 = [];
            Object.values(typeDefinition.fields).forEach(function(field) {
                var type = field.type, name = field.name;
                if ((0, _types.isNonModelFieldType)(type)) {
                    var typeDefinition_1 = namespace.nonModels[type.nonModel];
                    nested_1.push(name + " { " + generateSelectionSet(namespace, typeDefinition_1) + " }");
                }
            });
            result.push(name + " { " + scalarFields.join(' ') + " " + nested_1.join(' ') + " }");
        }
    });
    return result;
}
function getAuthorizationRules(modelDefinition) {
    // Searching for owner authorization on attributes
    var authConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
        return attr && attr.type === 'auth';
    });
    var _a = (authConfig || {}).properties, _b = (_a === void 0 ? {} : _a).rules, rules = _b === void 0 ? [] : _b;
    var resultRules = [];
    // Multiple rules can be declared for allow: owner
    rules.forEach(function(rule) {
        // setting defaults for backwards compatibility with old cli
        var _a = rule.identityClaim, identityClaim = _a === void 0 ? 'cognito:username' : _a, _b = rule.ownerField, ownerField = _b === void 0 ? 'owner' : _b, _c = rule.operations, operations = _c === void 0 ? [
            'create',
            'update',
            'delete',
            'read'
        ] : _c, _d = rule.provider, provider = _d === void 0 ? 'userPools' : _d, _e = rule.groupClaim, groupClaim = _e === void 0 ? 'cognito:groups' : _e, _f = rule.allow, authStrategy = _f === void 0 ? 'iam' : _f, _g = rule.groups, groups = _g === void 0 ? [] : _g, _h = rule.groupsField, groupsField = _h === void 0 ? '' : _h;
        var isReadAuthorized = operations.includes('read');
        var isOwnerAuth = authStrategy === 'owner';
        if (!isReadAuthorized && !isOwnerAuth) return;
        var authRule = {
            identityClaim: identityClaim,
            ownerField: ownerField,
            provider: provider,
            groupClaim: groupClaim,
            authStrategy: authStrategy,
            groups: groups,
            groupsField: groupsField,
            areSubscriptionsPublic: false
        };
        if (isOwnerAuth) {
            // look for the subscription level override
            // only pay attention to the public level
            var modelConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
                return attr && attr.type === 'model';
            });
            // find the subscriptions level. ON is default
            var _j = (modelConfig || {}).properties, _k = (_j === void 0 ? {} : _j).subscriptions, _l = (_k === void 0 ? {} : _k).level, level = _l === void 0 ? 'on' : _l;
            // treat subscriptions as public for owner auth with unprotected reads
            // when `read` is omitted from `operations`
            authRule.areSubscriptionsPublic = !operations.includes('read') || level === 'public';
        }
        if (isOwnerAuth) {
            // owner rules has least priority
            resultRules.push(authRule);
            return;
        }
        resultRules.unshift(authRule);
    });
    return resultRules;
}
function buildSubscriptionGraphQLOperation(namespace, modelDefinition, transformerMutationType, isOwnerAuthorization, ownerField, filterArg) {
    if (filterArg === void 0) filterArg = false;
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name;
    var opName = "on" + transformerMutationType + typeName;
    var docArgs = [];
    var opArgs = [];
    if (filterArg) {
        docArgs.push("$filter: ModelSubscription" + typeName + "FilterInput");
        opArgs.push('filter: $filter');
    }
    if (isOwnerAuthorization) {
        docArgs.push("$" + ownerField + ": String!");
        opArgs.push(ownerField + ": $" + ownerField);
    }
    var docStr = docArgs.length ? "(" + docArgs.join(',') + ")" : '';
    var opStr = opArgs.length ? "(" + opArgs.join(',') + ")" : '';
    return [
        transformerMutationType,
        opName,
        "subscription operation" + docStr + "{\n\t\t\t" + opName + opStr + "{\n\t\t\t\t" + selectionSet + "\n\t\t\t}\n\t\t}"
    ];
}
function buildGraphQLOperation(namespace, modelDefinition, graphQLOpType) {
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
    var operation;
    var documentArgs;
    var operationArgs;
    var transformerMutationType;
    switch(graphQLOpType){
        case 'LIST':
            operation = "sync" + pluralTypeName;
            documentArgs = "($limit: Int, $nextToken: String, $lastSync: AWSTimestamp, $filter: Model" + typeName + "FilterInput)";
            operationArgs = '(limit: $limit, nextToken: $nextToken, lastSync: $lastSync, filter: $filter)';
            selectionSet = "items {\n\t\t\t\t\t\t\t" + selectionSet + "\n\t\t\t\t\t\t}\n\t\t\t\t\t\tnextToken\n\t\t\t\t\t\tstartedAt";
            break;
        case 'CREATE':
            operation = "create" + typeName;
            documentArgs = "($input: Create" + typeName + "Input!)";
            operationArgs = '(input: $input)';
            transformerMutationType = TransformerMutationType.CREATE;
            break;
        case 'UPDATE':
            operation = "update" + typeName;
            documentArgs = "($input: Update" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = '(input: $input, condition: $condition)';
            transformerMutationType = TransformerMutationType.UPDATE;
            break;
        case 'DELETE':
            operation = "delete" + typeName;
            documentArgs = "($input: Delete" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = '(input: $input, condition: $condition)';
            transformerMutationType = TransformerMutationType.DELETE;
            break;
        case 'GET':
            operation = "get" + typeName;
            documentArgs = "($id: ID!)";
            operationArgs = '(id: $id)';
            transformerMutationType = TransformerMutationType.GET;
            break;
        default:
            throw new Error("Invalid graphQlOpType " + graphQLOpType);
    }
    return [
        [
            transformerMutationType,
            operation,
            GraphQLOperationType[graphQLOpType] + " operation" + documentArgs + "{\n\t\t" + operation + operationArgs + "{\n\t\t\t" + selectionSet + "\n\t\t}\n\t}"
        ]
    ];
}
function createMutationInstanceFromModelOperation(relationships, modelDefinition, opType, model, element, condition, MutationEventConstructor, modelInstanceCreator, id) {
    var operation;
    switch(opType){
        case (0, _types.OpType).INSERT:
            operation = TransformerMutationType.CREATE;
            break;
        case (0, _types.OpType).UPDATE:
            operation = TransformerMutationType.UPDATE;
            break;
        case (0, _types.OpType).DELETE:
            operation = TransformerMutationType.DELETE;
            break;
        default:
            throw new Error("Invalid opType " + opType);
    }
    // stringify nested objects of type AWSJSON
    // this allows us to return parsed JSON to users (see `castInstanceType()` in datastore.ts),
    // but still send the object correctly over the wire
    var replacer = function replacer(k, v) {
        var isAWSJSON = k && v !== null && (typeof v === "undefined" ? "undefined" : (0, _typeOf._)(v)) === 'object' && modelDefinition.fields[k] && modelDefinition.fields[k].type === 'AWSJSON';
        if (isAWSJSON) return JSON.stringify(v);
        return v;
    };
    var modelId = getIdentifierValue(modelDefinition, element);
    var optionalId = (0, _types.OpType).INSERT && id ? {
        id: id
    } : {};
    var mutationEvent = modelInstanceCreator(MutationEventConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, optionalId), {
        data: JSON.stringify(element, replacer),
        modelId: modelId,
        model: model.name,
        operation: operation,
        condition: JSON.stringify(condition)
    }));
    return mutationEvent;
}
function predicateToGraphQLCondition(predicate, modelDefinition) {
    var result = {};
    if (!predicate || !Array.isArray(predicate.predicates)) return result;
    // This is compatible with how the GQL Transform currently generates the Condition Input,
    // i.e. any PK and SK fields are omitted and can't be used as conditions.
    // However, I think this limits usability.
    // What if we want to delete all records where SK > some value
    // Or all records where PK = some value but SKs are different values
    // TODO: if the Transform gets updated we'll need to modify this logic to only omit
    // key fields from the predicate/condition when ALL of the keyFields are present and using `eq` operators
    var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return predicateToGraphQLFilter(predicate, keyFields);
}
function predicateToGraphQLFilter(predicatesGroup, fieldsToOmit, root) {
    if (fieldsToOmit === void 0) fieldsToOmit = [];
    if (root === void 0) root = true;
    var result = {};
    if (!predicatesGroup || !Array.isArray(predicatesGroup.predicates)) return result;
    var type = predicatesGroup.type, predicates = predicatesGroup.predicates;
    var isList = type === 'and' || type === 'or';
    result[type] = isList ? [] : {};
    var children = [];
    predicates.forEach(function(predicate) {
        var _a, _b;
        if ((0, _types.isPredicateObj)(predicate)) {
            var field = predicate.field, operator = predicate.operator, operand = predicate.operand;
            if (fieldsToOmit.includes(field)) return;
            var gqlField = (_a = {}, _a[field] = (_b = {}, _b[operator] = operand, _b), _a);
            children.push(gqlField);
            return;
        }
        var child = predicateToGraphQLFilter(predicate, fieldsToOmit, false);
        if (Object.keys(child).length > 0) children.push(child);
    });
    // flatten redundant list predicates
    if (children.length === 1) {
        var _a = (0, _tslib.__read)(children, 1), child = _a[0];
        if (// any nested list node
        isList && !root || // root list node where the only child is also a list node
        isList && root && ('and' in child || 'or' in child)) {
            delete result[type];
            Object.assign(result, child);
            return result;
        }
    }
    children.forEach(function(child) {
        if (isList) result[type].push(child);
        else result[type] = child;
    });
    if (isList) {
        if (result[type].length === 0) return {};
    } else {
        if (Object.keys(result[type]).length === 0) return {};
    }
    return result;
}
function filterFields(group) {
    var fields = new Set();
    if (!group || !Array.isArray(group.predicates)) return fields;
    var predicates = group.predicates;
    var stack = (0, _tslib.__spread)(predicates);
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateObj)(current)) fields.add(current.field);
        else if ((0, _types.isPredicateGroup)(current)) stack.push.apply(stack, (0, _tslib.__spread)(current.predicates));
    }
    return fields;
}
function dynamicAuthFields(modelDefinition) {
    var e_1, _a;
    var rules = getAuthorizationRules(modelDefinition);
    var fields = new Set();
    try {
        for(var rules_1 = (0, _tslib.__values)(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()){
            var rule = rules_1_1.value;
            if (rule.groupsField && !rule.groups.length) // dynamic group rule will have no values in `rule.groups`
            fields.add(rule.groupsField);
            else if (rule.ownerField) fields.add(rule.ownerField);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return fields;
}
function countFilterCombinations(group) {
    if (!group || !Array.isArray(group.predicates)) return 0;
    var count = 0;
    var stack = [
        group
    ];
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateGroup)(current)) {
            var predicates = current.predicates, type = current.type;
            // ignore length = 1; groups with 1 predicate will get flattened when converted to gqlFilter
            if (type === 'or' && predicates.length > 1) count += predicates.length;
            stack.push.apply(stack, (0, _tslib.__spread)(predicates));
        }
    }
    // if we didn't encounter any OR groups, default to 1
    return count || 1;
}
function repeatedFieldInGroup(group) {
    if (!group || !Array.isArray(group.predicates)) return null;
    // convert to filter in order to flatten redundant groups
    var gqlFilter = predicateToGraphQLFilter(group);
    var stack = [
        gqlFilter
    ];
    var hasGroupRepeatedFields = function hasGroupRepeatedFields(fields) {
        var e_2, _a;
        var seen = {};
        try {
            for(var fields_1 = (0, _tslib.__values)(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()){
                var f = fields_1_1.value;
                var _b = (0, _tslib.__read)(Object.keys(f), 1), fieldName = _b[0];
                if (seen[fieldName]) return fieldName;
                seen[fieldName] = true;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return null;
    };
    while(stack.length > 0){
        var current = stack.pop();
        var _a = (0, _tslib.__read)(Object.keys(current), 1), key = _a[0];
        var values = current[key];
        if (!Array.isArray(values)) return null;
        // field value will be single object
        var predicateObjects = values.filter(function(v) {
            return !Array.isArray(Object.values(v)[0]);
        });
        // group value will be an array
        var predicateGroups = values.filter(function(v) {
            return Array.isArray(Object.values(v)[0]);
        });
        if (key === 'and') {
            var repeatedField = hasGroupRepeatedFields(predicateObjects);
            if (repeatedField) return repeatedField;
        }
        stack.push.apply(stack, (0, _tslib.__spread)(predicateGroups));
    }
    return null;
}
var RTFError;
(function(RTFError) {
    RTFError[RTFError["UnknownField"] = 0] = "UnknownField";
    RTFError[RTFError["MaxAttributes"] = 1] = "MaxAttributes";
    RTFError[RTFError["MaxCombinations"] = 2] = "MaxCombinations";
    RTFError[RTFError["RepeatedFieldname"] = 3] = "RepeatedFieldname";
    RTFError[RTFError["NotGroup"] = 4] = "NotGroup";
    RTFError[RTFError["FieldNotInType"] = 5] = "FieldNotInType";
})(RTFError || (RTFError = {}));
function generateRTFRemediation(errorType, modelDefinition, predicatesGroup) {
    var selSyncFields = filterFields(predicatesGroup);
    var selSyncFieldStr = (0, _tslib.__spread)(selSyncFields).join(', ');
    var dynamicAuthModeFields = dynamicAuthFields(modelDefinition);
    var dynamicAuthFieldsStr = (0, _tslib.__spread)(dynamicAuthModeFields).join(', ');
    var filterCombinations = countFilterCombinations(predicatesGroup);
    var repeatedField = repeatedFieldInGroup(predicatesGroup);
    switch(errorType){
        case RTFError.UnknownField:
            return "Your API was generated with an older version of the CLI that doesn't support backend subscription filtering.To enable backend subscription filtering, upgrade your Amplify CLI to the latest version and push your app by running `amplify upgrade` followed by `amplify push`";
        case RTFError.MaxAttributes:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + selSyncFields.size + " different model fields: " + selSyncFieldStr + ".\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth each utilize 1 field.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.MaxCombinations:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + filterCombinations + " field combinations (total number of predicates in an OR expression).\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth factor in to the number of combinations you're using.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.RepeatedFieldname:
            return "Your selective sync expression for " + modelDefinition.name + " contains multiple entries for " + repeatedField + " in the same AND group.";
        case RTFError.NotGroup:
            return "Your selective sync expression for " + modelDefinition.name + " uses a `not` group. If you'd like to filter subscriptions in the backend, " + "rewrite your expression using `ne` or `notContains` operators.";
        case RTFError.FieldNotInType:
            // no remediation instructions. We'll surface the message directly
            return '';
    }
}
function getUserGroupsFromToken(token, rule) {
    // validate token against groupClaim
    var userGroups = token[rule.groupClaim] || [];
    if (typeof userGroups === 'string') {
        var parsedGroups = void 0;
        try {
            parsedGroups = JSON.parse(userGroups);
        } catch (e) {
            parsedGroups = userGroups;
        }
        userGroups = [].concat(parsedGroups);
    }
    return userGroups;
}
function getModelAuthModes(_a) {
    var authModeStrategy = _a.authModeStrategy, defaultAuthMode = _a.defaultAuthMode, modelName = _a.modelName, schema = _a.schema;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var operations, modelAuthModes, error_1;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    operations = Object.values((0, _types.ModelOperation));
                    modelAuthModes = {
                        CREATE: [],
                        READ: [],
                        UPDATE: [],
                        DELETE: []
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.all(operations.map(function(operation) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var authModes;
                                return (0, _tslib.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                authModeStrategy({
                                                    schema: schema,
                                                    modelName: modelName,
                                                    operation: operation
                                                })
                                            ];
                                        case 1:
                                            authModes = _a.sent();
                                            if (typeof authModes === 'string') modelAuthModes[operation] = [
                                                authModes
                                            ];
                                            else if (Array.isArray(authModes) && authModes.length) modelAuthModes[operation] = authModes;
                                            else // Use default auth mode if nothing is returned from authModeStrategy
                                            modelAuthModes[operation] = [
                                                defaultAuthMode
                                            ];
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }))
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    error_1 = _b.sent();
                    logger.debug("Error getting auth modes for model: " + modelName, error_1);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        modelAuthModes
                    ];
            }
        });
    });
}
function getForbiddenError(error) {
    var forbiddenErrorMessages = [
        'Request failed with status code 401',
        'Request failed with status code 403'
    ];
    var forbiddenError;
    if (error && error.errors) forbiddenError = error.errors.find(function(err) {
        return forbiddenErrorMessages.includes(err.message);
    });
    else if (error && error.message) forbiddenError = error;
    if (forbiddenError) return forbiddenError.message;
    return null;
}
function getClientSideAuthError(error) {
    var clientSideAuthErrors = Object.values((0, _api.GraphQLAuthError));
    var clientSideError = error && error.message && clientSideAuthErrors.find(function(clientError) {
        return error.message.includes(clientError);
    });
    return clientSideError || null;
}
function getTokenForCustomAuth(authMode, amplifyConfig) {
    if (amplifyConfig === void 0) amplifyConfig = {};
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _a, functionAuthProvider, token, error_2;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(authMode === (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _a = amplifyConfig.authProviders, functionAuthProvider = (_a === void 0 ? {
                        functionAuthProvider: null
                    } : _a).functionAuthProvider;
                    if (!(functionAuthProvider && typeof functionAuthProvider === 'function')) return [
                        3 /*break*/ ,
                        5
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionAuthProvider()
                    ];
                case 2:
                    token = _b.sent().token;
                    return [
                        2 /*return*/ ,
                        token
                    ];
                case 3:
                    error_2 = _b.sent();
                    throw new Error("Error retrieving token from `functionAuthProvider`: " + error_2);
                case 4:
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    // TODO: add docs link once available
                    throw new Error("You must provide a `functionAuthProvider` function to `DataStore.configure` when using " + (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function getIdentifierValue(modelDefinition, model) {
    var pkFieldNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    var idOrPk = pkFieldNames.map(function(f) {
        return model[f];
    }).join((0, _util.IDENTIFIER_KEY_SEPARATOR));
    return idOrPk;
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-amplify/api-graphql":"eWncu","@aws-amplify/api":"6PDaW","@aws-amplify/core":"3rlh1","../types":"9W0ar","../util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28vIg":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _indexedDBAdapter = require("../IndexedDBAdapter");
var _indexedDBAdapterDefault = parcelHelpers.interopDefault(_indexedDBAdapter);
var _asyncStorageAdapter = require("../AsyncStorageAdapter");
var _asyncStorageAdapterDefault = parcelHelpers.interopDefault(_asyncStorageAdapter);
var getDefaultAdapter = function getDefaultAdapter() {
    var isBrowser = (0, _core.browserOrNode)().isBrowser;
    if (isBrowser && window.indexedDB || (0, _core.isWebWorker)() && self.indexedDB) return 0, _indexedDBAdapterDefault.default;
    return 0, _asyncStorageAdapterDefault.default;
};
exports.default = getDefaultAdapter;

},{"@aws-amplify/core":"3rlh1","../IndexedDBAdapter":"31vIO","../AsyncStorageAdapter":"aPgAF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"31vIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _idb = require("idb");
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var logger = new (0, _core.ConsoleLogger)('DataStore');
/**
 * The point after which queries composed of multiple simple OR conditions
 * should scan-and-filter instead of individual queries for each condition.
 *
 * At some point, this should be configurable and/or dynamic based on table
 * size and possibly even on observed average seek latency. For now, it's
 * based on an manual "binary search" for the breakpoint as measured in the
 * unit test suite. This isn't necessarily optimal. But, it's at least derived
 * empirically, rather than theoretically and without any verification!
 *
 * REMEMBER! If you run more realistic benchmarks and update this value, update
 * this comment so the validity and accuracy of future query tuning exercises
 * can be compared to the methods used to derive the current value. E.g.,
 *
 * 1. In browser benchmark > unit test benchmark
 * 2. Multi-browser benchmark > single browser benchmark
 * 3. Benchmarks of various table sizes > static table size benchmark
 *
 * etc...
 *
 */ var MULTI_OR_CONDITION_SCAN_BREAKPOINT = 7;
//
var DB_VERSION = 3;
var IndexedDBAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(IndexedDBAdapter, _super);
    function IndexedDBAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.safariCompatabilityMode = false;
        /**
         * Checks the given path against the browser's IndexedDB implementation for
         * necessary compatibility transformations, applying those transforms if needed.
         *
         * @param `keyArr` strings to compatibilize for browser-indexeddb index operations
         * @returns An array or string, depending on and given key,
         * that is ensured to be compatible with the IndexedDB implementation's nuances.
         */ _this.canonicalKeyPath = function(keyArr) {
            if (_this.safariCompatabilityMode) return keyArr.length > 1 ? keyArr : keyArr[0];
            return keyArr;
        };
        return _this;
    //#endregion
    }
    // checks are called by StorageAdapterBase class
    IndexedDBAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.setSafariCompatabilityMode()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initialize IndexedDB database
     * Create new DB if one doesn't exist
     * Upgrade outdated DB
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns IDB Database instance
     */ IndexedDBAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _idb.openDB(this.dbName, DB_VERSION, {
                                upgrade: function upgrade(db, oldVersion, newVersion, txn) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var _$_a, _b, storeName, origStore, tmpName, _c, namespaceName, modelName, modelInCurrentSchema, newStore, cursor, count, e_1_1, error_1;
                                        var e_1, _d;
                                        var _this = this;
                                        return (0, _tslib.__generator)(this, function(_e) {
                                            switch(_e.label){
                                                case 0:
                                                    // create new database
                                                    if (oldVersion === 0) {
                                                        Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                            var namespace = _this.schema.namespaces[namespaceName];
                                                            Object.keys(namespace.models).forEach(function(modelName) {
                                                                var storeName = (0, _util.getStorename)(namespaceName, modelName);
                                                                _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                            });
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    if (!((oldVersion === 1 || oldVersion === 2) && newVersion === 3)) return [
                                                        3 /*break*/ ,
                                                        16
                                                    ];
                                                    _e.label = 1;
                                                case 1:
                                                    _e.trys.push([
                                                        1,
                                                        14,
                                                        ,
                                                        15
                                                    ]);
                                                    _e.label = 2;
                                                case 2:
                                                    _e.trys.push([
                                                        2,
                                                        11,
                                                        12,
                                                        13
                                                    ]);
                                                    _$_a = (0, _tslib.__values)(txn.objectStoreNames), _b = _$_a.next();
                                                    _e.label = 3;
                                                case 3:
                                                    if (!!_b.done) return [
                                                        3 /*break*/ ,
                                                        10
                                                    ];
                                                    storeName = _b.value;
                                                    origStore = txn.objectStore(storeName);
                                                    tmpName = "tmp_" + storeName;
                                                    origStore.name = tmpName;
                                                    _c = this.getNamespaceAndModelFromStorename(storeName), namespaceName = _c.namespaceName, modelName = _c.modelName;
                                                    modelInCurrentSchema = modelName in this.schema.namespaces[namespaceName].models;
                                                    if (!modelInCurrentSchema) {
                                                        // delete original
                                                        db.deleteObjectStore(tmpName);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    }
                                                    newStore = this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                    return [
                                                        4 /*yield*/ ,
                                                        origStore.openCursor()
                                                    ];
                                                case 4:
                                                    cursor = _e.sent();
                                                    count = 0;
                                                    _e.label = 5;
                                                case 5:
                                                    if (!(cursor && cursor.value)) return [
                                                        3 /*break*/ ,
                                                        8
                                                    ];
                                                    // we don't pass key, since they are all new entries in the new store
                                                    return [
                                                        4 /*yield*/ ,
                                                        newStore.put(cursor.value)
                                                    ];
                                                case 6:
                                                    // we don't pass key, since they are all new entries in the new store
                                                    _e.sent();
                                                    return [
                                                        4 /*yield*/ ,
                                                        cursor.continue()
                                                    ];
                                                case 7:
                                                    cursor = _e.sent();
                                                    count++;
                                                    return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                case 8:
                                                    // delete original
                                                    db.deleteObjectStore(tmpName);
                                                    logger.debug(count + " " + storeName + " records migrated");
                                                    _e.label = 9;
                                                case 9:
                                                    _b = _$_a.next();
                                                    return [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 10:
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 11:
                                                    e_1_1 = _e.sent();
                                                    e_1 = {
                                                        error: e_1_1
                                                    };
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 12:
                                                    try {
                                                        if (_b && !_b.done && (_d = _$_a.return)) _d.call(_$_a);
                                                    } finally{
                                                        if (e_1) throw e_1.error;
                                                    }
                                                    return [
                                                        7 /*endfinally*/ 
                                                    ];
                                                case 13:
                                                    // add new models created after IndexedDB, but before migration
                                                    // this case may happen when a user has not opened an app for
                                                    // some time and a new model is added during that time
                                                    Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                        var namespace = _this.schema.namespaces[namespaceName];
                                                        var objectStoreNames = new Set(txn.objectStoreNames);
                                                        Object.keys(namespace.models).map(function(modelName) {
                                                            return [
                                                                modelName,
                                                                (0, _util.getStorename)(namespaceName, modelName)
                                                            ];
                                                        }).filter(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), storeName = _b[1];
                                                            return !objectStoreNames.has(storeName);
                                                        }).forEach(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], storeName = _b[1];
                                                            _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                        });
                                                    });
                                                    return [
                                                        3 /*break*/ ,
                                                        15
                                                    ];
                                                case 14:
                                                    error_1 = _e.sent();
                                                    logger.error('Error migrating IndexedDB data', error_1);
                                                    txn.abort();
                                                    throw error_1;
                                                case 15:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 16:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype._get = function(storeOrStoreName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var index, storeName, store, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof storeOrStoreName === 'string') {
                            storeName = storeOrStoreName;
                            index = this.db.transaction(storeName, 'readonly').store.index('byPk');
                        } else {
                            store = storeOrStoreName;
                            index = store.index('byPk');
                        }
                        return [
                            4 /*yield*/ ,
                            index.get(this.canonicalKeyPath(keyArr))
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.clear = function() {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.db) === null || _a === void 0 || _a.close();
                        return [
                            4 /*yield*/ ,
                            _idb.deleteDB(this.dbName)
                        ];
                    case 2:
                        _b.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, set, connectionStoreNames, modelKeyValues, tx, store, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, store_1, itemKeyValues, fromDB_1, opType, key, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _c.sent();
                        _b = this.saveMetadata(model), storeName = _b.storeName, set = _b.set, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        tx = this.db.transaction((0, _tslib.__spread)([
                            storeName
                        ], Array.from(set.values())), 'readwrite');
                        store = tx.objectStore(storeName);
                        return [
                            4 /*yield*/ ,
                            this._get(store, modelKeyValues)
                        ];
                    case 2:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 3;
                    case 3:
                        _c.trys.push([
                            3,
                            11,
                            12,
                            17
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 5:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        store_1 = tx.objectStore(storeName_1);
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(store_1, itemKeyValues)
                        ];
                    case 6:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            store_1.index('byPk').getKey(this.canonicalKeyPath(itemKeyValues))
                        ];
                    case 7:
                        key = _c.sent();
                        return [
                            4 /*yield*/ ,
                            store_1.put(item, key)
                        ];
                    case 8:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            4 /*yield*/ ,
                            tx.done
                        ];
                    case 18:
                        _c.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, queryByKey)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!hasSort) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                if (hasPagination) return [
                                                    2 /*return*/ ,
                                                    this.enginePagination(storeName, pagination)
                                                ];
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 2:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, cursor, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.transaction([
                                storeName
                            ], 'readonly').objectStore(storeName).openCursor(undefined, firstOrLast === (0, _types.QueryOne).FIRST ? 'next' : 'prev')
                        ];
                    case 2:
                        cursor = _a.sent();
                        result = cursor ? cursor.value : undefined;
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, result, txn, store, _loop_1, this_1, items_1, items_1_1, item, e_3_1;
            var e_3, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        result = [];
                        txn = this.db.transaction(storeName, 'readwrite');
                        store = txn.store;
                        _loop_1 = function _loop_1(item) {
                            var model, connectedModels, keyValues, _deleted, index, key, instance;
                            return (0, _tslib.__generator)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        model = this_1.modelInstanceCreator(modelConstructor, item);
                                        connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                                        keyValues = this_1.getIndexKeyValuesFromModel(model);
                                        _deleted = item._deleted;
                                        index = store.index('byPk');
                                        return [
                                            4 /*yield*/ ,
                                            index.getKey(this_1.canonicalKeyPath(keyValues))
                                        ];
                                    case 1:
                                        key = _a.sent();
                                        if (!!_deleted) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        instance = connectedModels.find(function(_a) {
                                            var instance = _a.instance;
                                            var instanceKeyValues = _this.getIndexKeyValuesFromModel(instance);
                                            return (0, _util.keysEqual)(instanceKeyValues, keyValues);
                                        }).instance;
                                        result.push([
                                            instance,
                                            key ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            store.put(instance, key)
                                        ];
                                    case 2:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 3:
                                        result.push([
                                            item,
                                            (0, _types.OpType).DELETE
                                        ]);
                                        if (!key) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            store.delete(key)
                                        ];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!items_1_1.done) return [
                            3 /*break*/ ,
                            6
                        ];
                        item = items_1_1.value;
                        return [
                            5 /*yield**/ ,
                            _loop_1(item)
                        ];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        items_1_1 = items_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        try {
                            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 10:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_4, _a, e_5, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var connectionStoreNames, tx, _c, _d, deleteItem, storeName, items, store, items_2, items_2_1, item, key, keyValues, itemKey, e_5_1, e_4_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        connectionStoreNames = deleteQueue.map(function(_a) {
                            var storeName = _a.storeName;
                            return storeName;
                        });
                        tx = this.db.transaction((0, _tslib.__spread)(connectionStoreNames), 'readwrite');
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            22,
                            23,
                            28
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 3:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            21
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        store = tx.objectStore(storeName);
                        _e.label = 4;
                    case 4:
                        _e.trys.push([
                            4,
                            14,
                            15,
                            20
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 6:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            13
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            12
                        ];
                        key = void 0;
                        if (!((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object')) return [
                            3 /*break*/ ,
                            8
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(item);
                        return [
                            4 /*yield*/ ,
                            store.index('byPk').getKey(this.canonicalKeyPath(keyValues))
                        ];
                    case 7:
                        key = _e.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        itemKey = item.toString();
                        return [
                            4 /*yield*/ ,
                            store.index('byPk').getKey(itemKey)
                        ];
                    case 9:
                        key = _e.sent();
                        _e.label = 10;
                    case 10:
                        if (!(key !== undefined)) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            store.delete(key)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 14:
                        e_5_1 = _e.sent();
                        e_5 = {
                            error: e_5_1
                        };
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 15:
                        _e.trys.push([
                            15,
                            ,
                            18,
                            19
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            17
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 16:
                        _e.sent();
                        _e.label = 17;
                    case 17:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        if (e_5) throw e_5.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 20:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 21:
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 22:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 23:
                        _e.trys.push([
                            23,
                            ,
                            26,
                            27
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            25
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 24:
                        _e.sent();
                        _e.label = 25;
                    case 25:
                        return [
                            3 /*break*/ ,
                            27
                        ];
                    case 26:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 27:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 28:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    IndexedDBAdapter.prototype.checkPrivate = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var isPrivate;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _util.isPrivateMode)().then(function(isPrivate) {
                                return isPrivate;
                            })
                        ];
                    case 1:
                        isPrivate = _a.sent();
                        if (isPrivate) {
                            logger.error("IndexedDB not supported in this browser's private mode");
                            return [
                                2 /*return*/ ,
                                Promise.reject("IndexedDB not supported in this browser's private mode")
                            ];
                        } else return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Whether the browser's implementation of IndexedDB is coercing single-field
     * indexes to a scalar key.
     *
     * If this returns `true`, we need to treat indexes containing a single field
     * as scalars.
     *
     * See PR description for reference:
     * https://github.com/aws-amplify/amplify-js/pull/10527
     */ IndexedDBAdapter.prototype.setSafariCompatabilityMode = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, _util.isSafariCompatabilityMode)()
                        ];
                    case 1:
                        _a.safariCompatabilityMode = _b.sent();
                        if (this.safariCompatabilityMode === true) logger.debug('IndexedDB Adapter is running in Safari Compatability Mode');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getNamespaceAndModelFromStorename = function(storeName) {
        var _a = (0, _tslib.__read)(storeName.split('_')), namespaceName = _a[0], modelNameArr = _a.slice(1);
        return {
            namespaceName: namespaceName,
            modelName: modelNameArr.join('_')
        };
    };
    IndexedDBAdapter.prototype.createObjectStoreForModel = function(db, namespaceName, storeName, modelName) {
        var store = db.createObjectStore(storeName, {
            autoIncrement: true
        });
        var indexes = this.schema.namespaces[namespaceName].relationships[modelName].indexes;
        indexes.forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 3), idxName = _b[0], keyPath = _b[1], options = _b[2];
            store.createIndex(idxName, keyPath, options);
        });
        return store;
    };
    IndexedDBAdapter.prototype.getByKey = function(storeName, keyValue) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValue)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Tries to generate an index fetcher for the given predicates. Assumes
     * that the given predicate conditions are contained by an AND group and
     * should therefore all match a single record.
     *
     * @param storeName The table to query.
     * @param predicates The predicates to try to AND together.
     * @param transaction
     */ IndexedDBAdapter.prototype.matchingIndexQueries = function(storeName, predicates, transaction) {
        var e_6, _a, e_7, _b;
        var _this = this;
        // could be expanded later to include `exec()` and a `cardinality` estimate?
        var queries = [];
        var predicateIndex = new Map();
        try {
            for(var predicates_1 = (0, _tslib.__values)(predicates), predicates_1_1 = predicates_1.next(); !predicates_1_1.done; predicates_1_1 = predicates_1.next()){
                var predicate = predicates_1_1.value;
                predicateIndex.set(String(predicate.field), predicate);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (predicates_1_1 && !predicates_1_1.done && (_a = predicates_1.return)) _a.call(predicates_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var store = transaction.objectStore(storeName);
        var _loop_2 = function _loop_2(name_1) {
            var e_8, _a;
            var idx = store.index(name_1);
            var keypath = Array.isArray(idx.keyPath) ? idx.keyPath : [
                idx.keyPath
            ];
            var matchingPredicateValues = [];
            try {
                for(var keypath_1 = (e_8 = void 0, (0, _tslib.__values)(keypath)), keypath_1_1 = keypath_1.next(); !keypath_1_1.done; keypath_1_1 = keypath_1.next()){
                    var field = keypath_1_1.value;
                    var p = predicateIndex.get(field);
                    if (p && p.operand !== null && p.operand !== undefined) matchingPredicateValues.push(p.operand);
                    else break;
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (keypath_1_1 && !keypath_1_1.done && (_a = keypath_1.return)) _a.call(keypath_1);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            // if we have a matching predicate field for each component of this index,
            // we can build a query for it. otherwise, we can't.
            if (matchingPredicateValues.length === keypath.length) // re-create a transaction, because the transaction used to fetch the
            // indexes may no longer be active.
            queries.push(function() {
                return _this.db.transaction(storeName).objectStore(storeName).index(name_1).getAll(_this.canonicalKeyPath(matchingPredicateValues));
            });
        };
        try {
            for(var _c = (0, _tslib.__values)(store.indexNames), _d = _c.next(); !_d.done; _d = _c.next()){
                var name_1 = _d.value;
                _loop_2(name_1);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return queries;
    };
    IndexedDBAdapter.prototype.baseQueryIndex = function(storeName, predicates, transaction) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, fieldPredicates, txn, result, groupQueries, objectQueries, indexedQueries;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        // the predicate objects we care about tend to be nested at least
                        // one level down: `{and: {or: {and: { <the predicates we want> }}}}`
                        // so, we unpack and/or groups until we find a group with more than 1
                        // child OR a child that is not a group (and is therefore a predicate "object").
                        while(predicateObjs.length === 1 && (0, _types.isPredicateGroup)(predicateObjs[0]) && predicateObjs[0].type !== 'not'){
                            type = predicateObjs[0].type;
                            predicateObjs = predicateObjs[0].predicates;
                        }
                        fieldPredicates = predicateObjs.filter(function(p) {
                            return (0, _types.isPredicateObj)(p) && p.operator === 'eq';
                        });
                        txn = transaction || this.db.transaction(storeName);
                        result = {};
                        if (!(type === 'or')) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(predicateObjs.filter(function(o) {
                                return (0, _types.isPredicateGroup)(o) && o.type === 'and';
                            }).map(function(o) {
                                return _this.baseQueryIndex(storeName, o, txn);
                            })).then(function(queries) {
                                return queries.filter(function(q) {
                                    return q.indexedQueries.length === 1;
                                }).map(function(i) {
                                    return i.indexedQueries;
                                });
                            })
                        ];
                    case 1:
                        groupQueries = _a.sent();
                        objectQueries = predicateObjs.filter(function(o) {
                            return (0, _types.isPredicateObj)(o);
                        }).map(function(o) {
                            return _this.matchingIndexQueries(storeName, [
                                o
                            ], txn);
                        });
                        indexedQueries = (0, _tslib.__spread)(groupQueries, objectQueries).map(function(q) {
                            return q[0];
                        }).filter(function(i) {
                            return i;
                        });
                        // if, after hunting for base queries, we don't have exactly 1 base query
                        // for each child group + object, stop trying to optimize. we're not dealing
                        // with a simple query that fits the intended optimization path.
                        if (predicateObjs.length > indexedQueries.length) result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        else result = {
                            groupType: 'or',
                            indexedQueries: indexedQueries
                        };
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (type === 'and') // our potential indexes or lacks thereof.
                        // note that we're only optimizing for `eq` right now.
                        result = {
                            groupType: type,
                            indexedQueries: this.matchingIndexQueries(storeName, fieldPredicates, txn)
                        };
                        else result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        _a.label = 3;
                    case 3:
                        if (!!transaction) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, _a, groupType, indexedQueries, candidateResults, distinctResults, indexedQueries_1, indexedQueries_1_1, query, resultGroup, resultGroup_1, resultGroup_1_1, item, distinctificationString, e_9_1, filtered;
            var e_9, _b, e_10, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.baseQueryIndex(storeName, predicates)
                        ];
                    case 1:
                        _a = _d.sent(), groupType = _a.groupType, indexedQueries = _a.indexedQueries;
                        if (!(groupType === 'and' && indexedQueries.length > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            indexedQueries[0]()
                        ];
                    case 2:
                        // each condition must be satsified, we can form a base set with any
                        // ONE of those conditions and then filter.
                        candidateResults = _d.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 3:
                        if (!(groupType === 'or' && indexedQueries.length > 0 && indexedQueries.length <= MULTI_OR_CONDITION_SCAN_BREAKPOINT)) return [
                            3 /*break*/ ,
                            12
                        ];
                        distinctResults = new Map();
                        _d.label = 4;
                    case 4:
                        _d.trys.push([
                            4,
                            9,
                            10,
                            11
                        ]);
                        indexedQueries_1 = (0, _tslib.__values)(indexedQueries), indexedQueries_1_1 = indexedQueries_1.next();
                        _d.label = 5;
                    case 5:
                        if (!!indexedQueries_1_1.done) return [
                            3 /*break*/ ,
                            8
                        ];
                        query = indexedQueries_1_1.value;
                        return [
                            4 /*yield*/ ,
                            query()
                        ];
                    case 6:
                        resultGroup = _d.sent();
                        try {
                            for(resultGroup_1 = (e_10 = void 0, (0, _tslib.__values)(resultGroup)), resultGroup_1_1 = resultGroup_1.next(); !resultGroup_1_1.done; resultGroup_1_1 = resultGroup_1.next()){
                                item = resultGroup_1_1.value;
                                distinctificationString = JSON.stringify(item);
                                distinctResults.set(distinctificationString, item);
                            }
                        } catch (e_10_1) {
                            e_10 = {
                                error: e_10_1
                            };
                        } finally{
                            try {
                                if (resultGroup_1_1 && !resultGroup_1_1.done && (_c = resultGroup_1.return)) _c.call(resultGroup_1);
                            } finally{
                                if (e_10) throw e_10.error;
                            }
                        }
                        _d.label = 7;
                    case 7:
                        indexedQueries_1_1 = indexedQueries_1.next();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 9:
                        e_9_1 = _d.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        try {
                            if (indexedQueries_1_1 && !indexedQueries_1_1.done && (_b = indexedQueries_1.return)) _b.call(indexedQueries_1);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        // we could conceivably check for special conditions and return early here.
                        // but, this is simpler and has not yet had a measurable performance impact.
                        candidateResults = Array.from(distinctResults.values());
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 13:
                        // nothing intelligent we can do with `not` groups unless or until we start
                        // smashing comparison operators against indexes -- at which point we could
                        // perform some reversal here.
                        candidateResults = _d.sent();
                        _d.label = 14;
                    case 14:
                        filtered = predicateObjs ? candidateResults.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : candidateResults;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    IndexedDBAdapter.prototype.enginePagination = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, _a, page, _b, limit, initialRecord, cursor, pageResults, hasLimit;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!pagination) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = pagination.page, page = _a === void 0 ? 0 : _a, _b = pagination.limit, limit = _b === void 0 ? 0 : _b;
                        initialRecord = Math.max(0, page * limit) || 0;
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName).objectStore(storeName).openCursor()
                        ];
                    case 1:
                        cursor = _c.sent();
                        if (!(cursor && initialRecord > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.advance(initialRecord)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        pageResults = [];
                        hasLimit = typeof limit === 'number' && limit > 0;
                        _c.label = 4;
                    case 4:
                        if (!(cursor && cursor.value)) return [
                            3 /*break*/ ,
                            6
                        ];
                        pageResults.push(cursor.value);
                        if (hasLimit && pageResults.length === limit) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.continue()
                        ];
                    case 5:
                        cursor = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 6:
                        result = pageResults;
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 8:
                        result = _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    return IndexedDBAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new IndexedDBAdapter();

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-amplify/core":"3rlh1","idb":"crryf","../../types":"9W0ar","../../util":"iFXfl","./StorageAdapterBase":"eAtlR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crryf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", function() {
    return 0, _wrapIdbValueJs.u;
});
parcelHelpers.export(exports, "wrap", function() {
    return 0, _wrapIdbValueJs.w;
});
parcelHelpers.export(exports, "deleteDB", function() {
    return deleteDB;
});
parcelHelpers.export(exports, "openDB", function() {
    return openDB;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', function(event) {
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction));
    });
    if (blocked) request.addEventListener('blocked', function() {
        return blocked();
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener('close', function() {
            return terminated();
        });
        if (blocking) db.addEventListener('versionchange', function() {
            return blocking();
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', function() {
        return blocked();
    });
    return (0, _wrapIdbValueJs.w)(request).then(function() {
        return undefined;
    });
}
var readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
var writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
var cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, '');
    var useIndex = prop !== targetFuncName;
    var isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    var method = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(storeName) {
            var _len, args, _key, _target, tx, _$target, returnVal;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
                        tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            (_target = _$target)[targetFuncName].apply(_target, (0, _toConsumableArray._)(args))
                        ];
                    case 1:
                        returnVal = _state.sent();
                        if (!isWrite) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            tx.done
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            returnVal
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)(function(oldTraps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","./wrap-idb-value.js":"eYyb9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eYyb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", function() {
    return reverseTransformCache;
});
parcelHelpers.export(exports, "i", function() {
    return instanceOfAny;
});
parcelHelpers.export(exports, "r", function() {
    return replaceTraps;
});
parcelHelpers.export(exports, "u", function() {
    return unwrap;
});
parcelHelpers.export(exports, "w", function() {
    return wrap;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var instanceOfAny = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var idbProxyableTypes;
var cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var cursorRequestMap = new WeakMap();
var transactionDoneMap = new WeakMap();
var transactionStoreNamesMap = new WeakMap();
var transformCache = new WeakMap();
var reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        var success = function() {
            resolve(wrap(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
var idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            unwrap(this),
            storeNames
        ].concat((0, _toConsumableArray._)(args)));
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function') return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    var newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
var unwrap = function(value) {
    return reverseTransformCache.get(value);
};

},{"@swc/helpers/_/_to_consumable_array":"4zJ2w","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eAtlR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageAdapterBase", function() {
    return StorageAdapterBase;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _types = require("../../types");
var _util = require("../../util");
var _relationship = require("../relationship");
var logger = new (0, _core.ConsoleLogger)('DataStore');
var DB_NAME = 'amplify-datastore';
var StorageAdapterBase = /** @class */ function() {
    function StorageAdapterBase() {
        this.dbName = DB_NAME;
    }
    /**
     * Initializes local DB
     *
     * @param theSchema
     * @param namespaceResolver
     * @param modelInstanceCreator
     * @param getModelConstructorByModelName
     * @param sessionId
     */ StorageAdapterBase.prototype.setUp = function(theSchema, namespaceResolver, modelInstanceCreator, getModelConstructorByModelName, sessionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preSetUpChecks()
                        ];
                    case 1:
                        _b.sent();
                        if (!!this.initPromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.initPromise = new Promise(function(res, rej) {
                            _this.resolve = res;
                            _this.reject = rej;
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.initPromise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        if (sessionId) this.dbName = DB_NAME + "-" + sessionId;
                        this.schema = theSchema;
                        this.namespaceResolver = namespaceResolver;
                        this.modelInstanceCreator = modelInstanceCreator;
                        this.getModelConstructorByModelName = getModelConstructorByModelName;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        if (!!this.db) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.initDb()
                        ];
                    case 6:
                        _a.db = _b.sent();
                        this.resolve();
                        _b.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_1 = _b.sent();
                        this.reject(error_1);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @param modelConstructor
     * @returns local DB table name
     */ StorageAdapterBase.prototype.getStorenameForModel = function(modelConstructor) {
        var namespace = this.namespaceResolver(modelConstructor);
        var modelName = modelConstructor.name;
        return (0, _util.getStorename)(namespace, modelName);
    };
    /**
     *
     * @param model - instantiated model record
     * @returns the record's primary key values
     */ StorageAdapterBase.prototype.getIndexKeyValuesFromModel = function(model) {
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespaceName = this.namespaceResolver(modelConstructor);
        var keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        return (0, _util.extractPrimaryKeyValues)(model, keys);
    };
    /**
     * Common metadata for `save` operation
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.saveMetadata = function(model) {
        var _this = this;
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var connectedModels = (0, _util.traverseModel)(modelConstructor.name, model, this.schema.namespaces[namespaceName], this.modelInstanceCreator, this.getModelConstructorByModelName);
        var set = new Set();
        var connectionStoreNames = Object.values(connectedModels).map(function(_a) {
            var modelName = _a.modelName, item = _a.item, instance = _a.instance;
            var storeName = (0, _util.getStorename)(namespaceName, modelName);
            set.add(storeName);
            var keys = (0, _util.getIndexKeys)(_this.schema.namespaces[namespaceName], modelName);
            return {
                storeName: storeName,
                item: item,
                instance: instance,
                keys: keys
            };
        });
        var modelKeyValues = this.getIndexKeyValuesFromModel(model);
        return {
            storeName: storeName,
            set: set,
            connectionStoreNames: connectionStoreNames,
            modelKeyValues: modelKeyValues
        };
    };
    /**
     * Enforces conditional save. Throws if condition is not met.
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.validateSaveCondition = function(condition, fromDB) {
        if (!(condition && fromDB)) return;
        var predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
        var _a = predicates, predicateObjs = _a.predicates, type = _a.type;
        var isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
        if (!isValid) {
            var msg = 'Conditional update failed';
            logger.error(msg, {
                model: fromDB,
                condition: predicateObjs
            });
            throw new Error(msg);
        }
    };
    /**
     * Instantiate models from POJO records returned from the database
     *
     * @param namespaceName - string model namespace
     * @param srcModelName - string model name
     * @param records - array of uninstantiated records
     * @returns
     */ StorageAdapterBase.prototype.load = function(namespaceName, srcModelName, records) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var namespace, relations, connectionStoreNames, modelConstructor;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                namespace = this.schema.namespaces[namespaceName];
                relations = namespace.relationships[srcModelName].relationTypes;
                connectionStoreNames = relations.map(function(_a) {
                    var modelName = _a.modelName;
                    return (0, _util.getStorename)(namespaceName, modelName);
                });
                modelConstructor = this.getModelConstructorByModelName(namespaceName, srcModelName);
                if (connectionStoreNames.length === 0) return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
                return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
            });
        });
    };
    /**
     * Extracts operands from a predicate group into an array of key values
     * Used in the query method
     *
     * @param predicates - predicate group
     * @param keyPath - string array of key names ['id', 'sortKey']
     * @returns string[] of key values
     *
     * @example
     * ```js
     * { and:[{ id: { eq: 'abc' }}, { sortKey: { eq: 'def' }}] }
     * ```
     * Becomes
     * ```
     * ['abc', 'def']
     * ```
     */ StorageAdapterBase.prototype.keyValueFromPredicate = function(predicates, keyPath) {
        var e_1, _a;
        var predicateObjs = predicates.predicates;
        if (predicateObjs.length !== keyPath.length) return;
        var keyValues = [];
        var _loop_1 = function _loop_1(key) {
            var predicateObj = predicateObjs.find(function(p) {
                // it's a relevant predicate object only if it's an equality
                // operation for a key field from the key:
                return (0, _types.isPredicateObj)(p) && p.field === key && p.operator === 'eq' && p.operand !== null && p.operand !== undefined;
            });
            predicateObj && keyValues.push(predicateObj.operand);
        };
        try {
            for(var keyPath_1 = (0, _tslib.__values)(keyPath), keyPath_1_1 = keyPath_1.next(); !keyPath_1_1.done; keyPath_1_1 = keyPath_1.next()){
                var key = keyPath_1_1.value;
                _loop_1(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keyPath_1_1 && !keyPath_1_1.done && (_a = keyPath_1.return)) _a.call(keyPath_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return keyValues.length === keyPath.length ? keyValues : undefined;
    };
    /**
     * Common metadata for `query` operation
     * used by individual storage adapters
     *
     * @param modelConstructor
     * @param predicate
     * @param pagination
     */ StorageAdapterBase.prototype.queryMetadata = function(modelConstructor, predicate, pagination) {
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var predicates = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate);
        var keyPath = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        var queryByKey = predicates && this.keyValueFromPredicate(predicates, keyPath);
        var hasSort = pagination && pagination.sort;
        var hasPagination = pagination && pagination.limit;
        return {
            storeName: storeName,
            namespaceName: namespaceName,
            queryByKey: queryByKey,
            predicates: predicates,
            hasSort: hasSort,
            hasPagination: hasPagination
        };
    };
    /**
     * Delete record
     * Cascades to related records (for Has One and Has Many relationships)
     *
     * @param modelOrModelConstructor
     * @param condition
     * @returns
     */ StorageAdapterBase.prototype.delete = function(modelOrModelConstructor, condition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteQueue, modelConstructor, namespace, models, deletedModels, deletedModels, model, modelConstructor, namespaceName, storeName, keyValues, fromDB, msg, predicates, _a, predicateObjs, type, isValid, msg, deletedModels;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preOpCheck()
                        ];
                    case 1:
                        _b.sent();
                        deleteQueue = [];
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) return [
                            3 /*break*/ ,
                            9
                        ];
                        modelConstructor = modelOrModelConstructor;
                        namespace = this.namespaceResolver(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.query(modelConstructor, condition)
                        ];
                    case 2:
                        models = _b.sent();
                        if (!(condition !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 4:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 7:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 9:
                        model = modelOrModelConstructor;
                        modelConstructor = Object.getPrototypeOf(model).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        if (!condition) return [
                            3 /*break*/ ,
                            12
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(model);
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValues)
                        ];
                    case 10:
                        fromDB = _b.sent();
                        if (fromDB === undefined) {
                            msg = 'Model instance not found in storage';
                            logger.warn(msg, {
                                model: model
                            });
                            return [
                                2 /*return*/ ,
                                [
                                    [
                                        model
                                    ],
                                    []
                                ]
                            ];
                        }
                        predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
                        _a = predicates, predicateObjs = _a.predicates, type = _a.type;
                        isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
                        if (!isValid) {
                            msg = 'Conditional update failed';
                            logger.error(msg, {
                                model: fromDB,
                                condition: predicateObjs
                            });
                            throw new Error(msg);
                        }
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 11:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 15:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                [
                                    model
                                ],
                                deletedModels
                            ]
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Recursively traverse relationship graph and add
     * all Has One and Has Many relations to `deleteQueue` param
     *
     * Actual deletion of records added to `deleteQueue` occurs in the `delete` method
     *
     * @param models
     * @param modelConstructor
     * @param namespace
     * @param deleteQueue
     */ StorageAdapterBase.prototype.deleteTraverse = function(models, modelConstructor, namespace, deleteQueue) {
        var models_1, models_1_1;
        var e_2, _a, e_3, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var cascadingRelationTypes, model, modelDefinition, modelMeta, relationships, relationships_1, relationships_1_1, r, queryObject, relatedRecords, e_3_1, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        cascadingRelationTypes = [
                            'HAS_ONE',
                            'HAS_MANY'
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            19,
                            20,
                            25
                        ]);
                        models_1 = (0, _tslib.__asyncValues)(models);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            models_1.next()
                        ];
                    case 3:
                        if (!(models_1_1 = _c.sent(), !models_1_1.done)) return [
                            3 /*break*/ ,
                            18
                        ];
                        model = models_1_1.value;
                        modelDefinition = this.schema.namespaces[namespace].models[modelConstructor.name];
                        modelMeta = {
                            builder: modelConstructor,
                            schema: modelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                        };
                        relationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                            return cascadingRelationTypes.includes(r.type);
                        });
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            11,
                            12,
                            17
                        ]);
                        relationships_1 = (0, _tslib.__asyncValues)(relationships);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            relationships_1.next()
                        ];
                    case 6:
                        if (!(relationships_1_1 = _c.sent(), !relationships_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        r = relationships_1_1.value;
                        queryObject = r.createRemoteQueryObject(model);
                        if (!(queryObject !== null)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.query(r.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(r.remoteDefinition, queryObject))
                        ];
                    case 7:
                        relatedRecords = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relatedRecords, r.remoteModelConstructor, namespace, deleteQueue)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_3_1 = _c.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(relationships_1_1 && !relationships_1_1.done && (_b = relationships_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(relationships_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 18:
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 19:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 20:
                        _c.trys.push([
                            20,
                            ,
                            23,
                            24
                        ]);
                        if (!(models_1_1 && !models_1_1.done && (_a = models_1.return))) return [
                            3 /*break*/ ,
                            22
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(models_1)
                        ];
                    case 21:
                        _c.sent();
                        _c.label = 22;
                    case 22:
                        return [
                            3 /*break*/ ,
                            24
                        ];
                    case 23:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 24:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 25:
                        deleteQueue.push({
                            storeName: (0, _util.getStorename)(namespace, modelConstructor.name),
                            items: models
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StorageAdapterBase;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","../../predicates":"bohgw","../../types":"9W0ar","../../util":"iFXfl","../relationship":"bT2iw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bT2iw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelRelationship", function() {
    return ModelRelationship;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
/**
 * Defines a relationship from a LOCAL model.field to a REMOTE model.field and helps
 * navigate the relationship, providing a simplified peek at the relationship details
 * pertinent to setting FK's and constructing join conditions.
 *
 * Because I mean, relationships are tough.
 *
 */ var ModelRelationship = /** @class */ function() {
    /**
     * @param modelDefinition The "local" model.
     * @param field The "local" model field.
     */ function ModelRelationship(model, field) {
        if (!(0, _types.isFieldAssociation)(model.schema, field)) throw new Error(model.schema.name + "." + field + " is not a relationship.");
        this.localModel = model;
        this._field = field;
    }
    /**
     * Returns a ModelRelationship for the the given model and field if the pair
     * indicates a relationship to another model. Else, returns `null`.
     *
     * @param model The model the relationship field exists in.
     * @param field The field that may relates the local model to the remote model.
     */ ModelRelationship.from = function(model, field) {
        if ((0, _types.isFieldAssociation)(model.schema, field)) return new this(model, field);
        else return null;
    };
    /**
     * Enumerates all valid `ModelRelationship`'s on the given model.
     *
     * @param model The model definition to enumerate relationships of.
     */ ModelRelationship.allFrom = function(model) {
        var e_1, _a;
        var relationships = [];
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(model.schema.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
                var field = _c.value;
                var relationship = ModelRelationship.from(model, field);
                relationship && relationships.push(relationship);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return relationships;
    };
    Object.defineProperty(ModelRelationship.prototype, "localDefinition", {
        get: function get() {
            return this.localModel.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "field", {
        /**
         * The virtual/computed field on the local model that should contain
         * the related model.
         */ get: function get() {
            return this._field;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localConstructor", {
        /**
         * The constructor that can be used to query DataStore or create instance for
         * the local model.
         */ get: function get() {
            return this.localModel.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "type", {
        /**
         * The name/type of the relationship the local model has with the remote model
         * via the defined local model field.
         */ get: function get() {
            return this.localAssocation.connectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssocation", {
        /**
         * Raw details about the local FK as-is from the local model's field definition in
         * the schema. This field requires interpretation.
         *
         * @see localJoinFields
         * @see localAssociatedWith
         */ get: function get() {
            return this.localDefinition.fields[this.field].association;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localJoinFields", {
        /**
         * The field names on the local model that can be used to query or queried to match
         * with instances of the remote model.
         *
         * Fields are returned in-order to match the order of `this.remoteKeyFields`.
         */ get: function get() {
            /**
             * This is relatively straightforward, actually.
             *
             * If we have explicitly stated targetNames, codegen is telling us authoritatively
             * to use those fields for this relationship. The local model "points to" fields
             * in the remote one.
             *
             * In other cases, the remote model points to this one's
             */ if (this.localAssocation.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.localAssocation.targetName
            ];
            else if (this.localAssocation.targetNames) return this.localAssocation.targetNames;
            else return this.localPKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localPKFields", {
        /**
         * The field names on the local model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function get() {
            return this.localModel.pkField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteDefinition", {
        get: function get() {
            var _a;
            return (_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelType", {
        get: function get() {
            return this.localDefinition.fields[this.field].type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelConstructor", {
        /**
         * Constructor that can be used to query DataStore or create instances for
         * the remote model.
         */ get: function get() {
            return this.remoteModelType.modelConstructor.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remotePKFields", {
        /**
         * The field names on the remote model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function get() {
            var _a;
            return ((_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.pkField) || [
                'id'
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssociatedWith", {
        /**
         * The `associatedWith` fields from the local perspective.
         *
         * When present, these fields indicate which fields on the remote model to use
         * when looking for a remote association and/or determining the final remote
         * key fields.
         */ get: function get() {
            if (this.localAssocation.connectionType === 'HAS_MANY' || this.localAssocation.connectionType === 'HAS_ONE') // This de-arraying is theoretically unnecessary going forward.
            return Array.isArray(this.localAssocation.associatedWith) ? this.localAssocation.associatedWith : [
                this.localAssocation.associatedWith
            ];
            else return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "explicitRemoteAssociation", {
        /**
         * The `remote` model's associated field's `assocation` metadata, if
         * present.
         *
         * This is used when determining if the remote model's associated field
         * specifies which FK fields to use. If this value is `undefined`, the
         * name of the remote field (`this.localAssociatedWith`) *is* the remote
         * key field.
         */ get: function get() {
            var _a;
            if (this.localAssociatedWith) {
                if (this.localAssociatedWith.length === 1) return (_a = this.remoteDefinition.fields[this.localAssociatedWith[0]]) === null || _a === void 0 ? void 0 : _a.association;
                else return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteJoinFields", {
        /**
         * The field names on the remote model that can used to query or queried to match
         * with instances of the local model.
         *
         * Fields are returned in-order to match the order of `this.localKeyFields`.
         */ get: function get() {
            /**
             * If the local relationship explicitly names "associated with" fields, we
             * need to see if this points direction to a reciprocating assocation. If it
             * does, the remote assocation indicates what fields to use.
             */ var _a, _b, _c;
            if ((_a = this.explicitRemoteAssociation) === null || _a === void 0 ? void 0 : _a.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.explicitRemoteAssociation.targetName
            ];
            else if ((_b = this.explicitRemoteAssociation) === null || _b === void 0 ? void 0 : _b.targetNames) return (_c = this.explicitRemoteAssociation) === null || _c === void 0 ? void 0 : _c.targetNames;
            else if (this.localAssociatedWith) return this.localAssociatedWith;
            else return this.remotePKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "isComplete", {
        /**
         * Whether this relationship everything necessary to get, set, and query from
         * the perspective of the local model provided at instantiation.
         */ get: function get() {
            return this.localJoinFields.length > 0 && this.remoteJoinFields.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates an FK mapper object with respect to the given related instance.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	parentId: remote.customId,
     * 	parentName: remote.name
     * }
     * ```
     *
     * @param remote The remote related instance.
     */ ModelRelationship.prototype.createLocalFKObject = function(remote) {
        var fk = {};
        for(var i = 0; i < this.localJoinFields.length; i++)fk[this.localJoinFields[i]] = remote[this.remoteJoinFields[i]];
        return fk;
    };
    /**
     * Creates an query mapper object to help fetch the remote instance(s) or
     * `null` if any of the necessary local fields are `null` or `undefined`.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	customId: local.parentId
     * 	name: local.parentName
     * }
     * ```
     *
     * If the local fields are not populated, returns
     *
     * @param local The local instance.
     */ ModelRelationship.prototype.createRemoteQueryObject = function(local) {
        var query = {};
        for(var i = 0; i < this.remoteJoinFields.length; i++){
            var localValue = local[this.localJoinFields[i]];
            if (localValue === null || localValue === undefined) return null;
            query[this.remoteJoinFields[i]] = local[this.localJoinFields[i]];
        }
        return query;
    };
    return ModelRelationship;
}();

},{"tslib":"86BcK","../types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPgAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncStorageAdapter", function() {
    return AsyncStorageAdapter;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _asyncStorageDatabase = require("./AsyncStorageDatabase");
var _asyncStorageDatabaseDefault = parcelHelpers.interopDefault(_asyncStorageDatabase);
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var AsyncStorageAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncStorageAdapter, _super);
    function AsyncStorageAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // no-ops for this adapter
    AsyncStorageAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AsyncStorageAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Open AsyncStorage database
     * Create new DB if one doesn't exist
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns AsyncStorageDatabase instance
     */ AsyncStorageAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var db;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        db = new (0, _asyncStorageDatabaseDefault.default)();
                        return [
                            4 /*yield*/ ,
                            db.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            db
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.clear()
                        ];
                    case 1:
                        _a.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, keys, batch, _loop_1, this_1, items_1, items_1_1, item;
            var e_1, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = (0, _util.getStorename)(namespaceName, modelName);
                        keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelName);
                        batch = [];
                        _loop_1 = function _loop_1(item) {
                            var model = this_1.modelInstanceCreator(modelConstructor, item);
                            var connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                            var keyValuesPath = this_1.getIndexKeyValuesPath(model);
                            var instance = connectedModels.find(function(_a) {
                                var instance = _a.instance;
                                var instanceKeyValuesPath = _this.getIndexKeyValuesPath(instance);
                                return (0, _util.keysEqual)([
                                    instanceKeyValuesPath
                                ], [
                                    keyValuesPath
                                ]);
                            }).instance;
                            batch.push(instance);
                        };
                        this_1 = this;
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.db.batchSave(storeName, batch, keys)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype._get = function(storeName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemKeyValuesPath;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        itemKeyValuesPath = keyArr.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                        return [
                            4 /*yield*/ ,
                            this.db.get(itemKeyValuesPath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, connectionStoreNames, modelKeyValues, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, itemKeyValues, fromDB_1, opType, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = this.saveMetadata(model), storeName = _b.storeName, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, modelKeyValues)
                        ];
                    case 1:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            9,
                            10,
                            15
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 4:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(storeName_1, itemKeyValues)
                        ];
                    case 5:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.db.save(item, storeName_1, keys, itemKeyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)))
                        ];
                    case 6:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _c.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var keyValues, record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                keyValues = queryByKey.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, keyValues)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!(hasSort || hasPagination)) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 1:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getByKey = function(storeName, keyValuePath) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.get(keyValuePath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, all, filtered;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 1:
                        all = _a.sent();
                        filtered = predicateObjs ? all.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : all;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    AsyncStorageAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.getOne(firstOrLast, storeName)
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_3, _a, e_4, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, _d, deleteItem, storeName, items, items_2, items_2_1, item, keyValuesPath, e_4_1, e_3_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            17,
                            18,
                            23
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 2:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            16
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([
                            3,
                            9,
                            10,
                            15
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 5:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === 'object')) return [
                            3 /*break*/ ,
                            7
                        ];
                        keyValuesPath = this.getIndexKeyValuesPath(item);
                        return [
                            4 /*yield*/ ,
                            this.db.delete(keyValuesPath, storeName)
                        ];
                    case 6:
                        _e.sent();
                        _e.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _e.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 17:
                        e_3_1 = _e.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 18:
                        _e.trys.push([
                            18,
                            ,
                            21,
                            22
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            20
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 19:
                        _e.sent();
                        _e.label = 20;
                    case 20:
                        return [
                            3 /*break*/ ,
                            22
                        ];
                    case 21:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 22:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 23:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    /**
     * Retrieves concatenated primary key values from a model
     *
     * @param model
     * @returns
     */ AsyncStorageAdapter.prototype.getIndexKeyValuesPath = function(model) {
        return this.getIndexKeyValuesFromModel(model).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
    };
    return AsyncStorageAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new AsyncStorageAdapter();

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","./AsyncStorageDatabase":"lhXYC","../../types":"9W0ar","../../util":"iFXfl","./StorageAdapterBase":"eAtlR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lhXYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _types = require("../../types");
var _util = require("../../util");
var _inMemoryStore = require("./InMemoryStore");
var DB_NAME = '@AmplifyDatastore';
var COLLECTION = 'Collection';
var DATA = 'Data';
var monotonicFactoriesMap = new Map();
var AsyncStorageDatabase = /** @class */ function() {
    function AsyncStorageDatabase() {
        /**
         * Maps storeNames to a map of ulid->id
         */ this._collectionInMemoryIndex = new Map();
        this.storage = (0, _inMemoryStore.createInMemoryStore)();
    }
    /**
     * Collection index is map of stores (i.e. sync, metadata, mutation event, and data)
     * @param storeName {string} - Name of the store
     * @returns Map of ulid->id
     */ AsyncStorageDatabase.prototype.getCollectionIndex = function(storeName) {
        if (!this._collectionInMemoryIndex.has(storeName)) this._collectionInMemoryIndex.set(storeName, new Map());
        return this._collectionInMemoryIndex.get(storeName);
    };
    /**
     * Return ULID for store if it exists, otherwise create a new one
     * @param storeName {string} - Name of the store
     * @returns ulid
     */ AsyncStorageDatabase.prototype.getMonotonicFactory = function(storeName) {
        if (!monotonicFactoriesMap.has(storeName)) monotonicFactoriesMap.set(storeName, (0, _util.monotonicUlidFactory)());
        return monotonicFactoriesMap.get(storeName);
    };
    AsyncStorageDatabase.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, keysForCollectionEntries, allKeys_1, allKeys_1_1, key, _a, dbName, storeName, recordType, ulidOrId, id, ulid, id_1, newUlid, oldKey, newKey, item, e_1_1;
            var e_1, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this._collectionInMemoryIndex.clear();
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _c.sent();
                        keysForCollectionEntries = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            12,
                            13,
                            14
                        ]);
                        allKeys_1 = (0, _tslib.__values)(allKeys), allKeys_1_1 = allKeys_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!allKeys_1_1.done) return [
                            3 /*break*/ ,
                            11
                        ];
                        key = allKeys_1_1.value;
                        _a = (0, _tslib.__read)(key.split('::'), 5), dbName = _a[0], storeName = _a[1], recordType = _a[2], ulidOrId = _a[3], id = _a[4];
                        if (!(dbName === DB_NAME)) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!(recordType === DATA)) return [
                            3 /*break*/ ,
                            9
                        ];
                        ulid = void 0;
                        if (!(id === undefined)) return [
                            3 /*break*/ ,
                            7
                        ];
                        id_1 = ulidOrId;
                        newUlid = this.getMonotonicFactory(storeName)();
                        oldKey = this.getLegacyKeyForItem(storeName, id_1);
                        newKey = this.getKeyForItem(storeName, id_1, newUlid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(oldKey)
                        ];
                    case 4:
                        item = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(newKey, item)
                        ];
                    case 5:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(oldKey)
                        ];
                    case 6:
                        _c.sent();
                        ulid = newUlid;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        ulid = ulidOrId;
                        _c.label = 8;
                    case 8:
                        this.getCollectionIndex(storeName).set(id, ulid);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        if (recordType === COLLECTION) keysForCollectionEntries.push(key);
                        _c.label = 10;
                    case 10:
                        allKeys_1_1 = allKeys_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        try {
                            if (allKeys_1_1 && !allKeys_1_1.done && (_b = allKeys_1.return)) _b.call(allKeys_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        if (!(keysForCollectionEntries.length > 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(keysForCollectionEntries)
                        ];
                    case 15:
                        _c.sent();
                        _c.label = 16;
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.save = function(item, storeName, keys, keyValuesPath) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var idxName, ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        idxName = (0, _util.indexNameFromKeys)(keys);
                        ulid = ((_a = this.getCollectionIndex(storeName)) === null || _a === void 0 ? void 0 : _a.get(idxName)) || this.getMonotonicFactory(storeName)();
                        itemKey = this.getKeyForItem(storeName, keyValuesPath, ulid);
                        // Set key in collection index
                        (_b = this.getCollectionIndex(storeName)) === null || _b === void 0 || _b.set(keyValuesPath, ulid);
                        // Save item in db
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(itemKey, JSON.stringify(item))
                        ];
                    case 1:
                        // Save item in db
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.batchSave = function(storeName, items, keys) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, collection, keysToDelete, keysToSave, allItemsKeys, itemsMap, _loop_1, this_1, items_1, items_1_1, item, existingRecordsMap, existingRecordsKeys, allItemsKeys_1, allItemsKeys_1_1, key;
            var e_2, _a, e_3, _b;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        result = [];
                        collection = this.getCollectionIndex(storeName);
                        keysToDelete = new Set();
                        keysToSave = new Set();
                        allItemsKeys = [];
                        itemsMap = {};
                        _loop_1 = function _loop_1(item) {
                            // Extract keys from concatenated key path, map to item values
                            var keyValues = keys.map(function(field) {
                                return item[field];
                            });
                            var _deleted = item._deleted;
                            // If id is in the store, retrieve, otherwise generate new ULID
                            var ulid = collection.get(keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR))) || this_1.getMonotonicFactory(storeName)();
                            // Generate the "longer key" for the item
                            var key = this_1.getKeyForItem(storeName, keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)), ulid);
                            allItemsKeys.push(key);
                            itemsMap[key] = {
                                ulid: ulid,
                                model: item
                            };
                            if (_deleted) keysToDelete.add(key);
                            else keysToSave.add(key);
                        };
                        this_1 = this;
                        try {
                            /* Populate allItemKeys, keysToDelete, and keysToSave */ for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(allItemsKeys)
                        ];
                    case 1:
                        existingRecordsMap = _c.sent();
                        existingRecordsKeys = existingRecordsMap.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
                            return !!v;
                        }).reduce(function(set, _a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return set.add(k);
                        }, new Set());
                        // Delete
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToDelete.size === 0) {
                                    resolve();
                                    return;
                                }
                                var keysToDeleteArray = Array.from(keysToDelete);
                                keysToDeleteArray.forEach(function(key) {
                                    // key: full db key
                                    // keys: PK and/or SK keys
                                    var primaryKeyValues = keys.map(function(field) {
                                        return itemsMap[key].model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.delete(primaryKeyValues);
                                });
                                _this.storage.multiRemove(keysToDeleteArray, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 2:
                        // Delete
                        _c.sent();
                        // Save
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToSave.size === 0) {
                                    resolve();
                                    return;
                                }
                                var entriesToSet = Array.from(keysToSave).map(function(key) {
                                    return [
                                        key,
                                        JSON.stringify(itemsMap[key].model)
                                    ];
                                });
                                keysToSave.forEach(function(key) {
                                    var _a = itemsMap[key], model = _a.model, ulid = _a.ulid;
                                    // Retrieve values from model, use as key for collection index
                                    var keyValues = keys.map(function(field) {
                                        return model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.set(keyValues, ulid);
                                });
                                _this.storage.multiSet(entriesToSet, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 3:
                        // Save
                        _c.sent();
                        try {
                            for(allItemsKeys_1 = (0, _tslib.__values)(allItemsKeys), allItemsKeys_1_1 = allItemsKeys_1.next(); !allItemsKeys_1_1.done; allItemsKeys_1_1 = allItemsKeys_1.next()){
                                key = allItemsKeys_1_1.value;
                                if (keysToDelete.has(key) && existingRecordsKeys.has(key)) result.push([
                                    itemsMap[key].model,
                                    (0, _types.OpType).DELETE
                                ]);
                                else if (keysToSave.has(key)) result.push([
                                    itemsMap[key].model,
                                    existingRecordsKeys.has(key) ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                ]);
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (allItemsKeys_1_1 && !allItemsKeys_1_1.done && (_b = allItemsKeys_1.return)) _b.call(allItemsKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.get = function(keyValuePath, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey, recordAsString, record;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(keyValuePath);
                        itemKey = this.getKeyForItem(storeName, keyValuePath, ulid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        recordAsString = _a.sent();
                        record = recordAsString && JSON.parse(recordAsString);
                        return [
                            2 /*return*/ ,
                            record
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getOne = function(firstOrLast, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, itemId, ulid, itemKey, itemString, _b, result;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = (0, _tslib.__read)(firstOrLast === (0, _types.QueryOne).FIRST ? function() {
                            var e_4, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_1 = (0, _tslib.__values)(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()){
                                    _b = (0, _tslib.__read)(collection_1_1.value, 2), id = _b[0], ulid = _b[1];
                                    break;
                                } // Get first element of the set
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }() : function() {
                            var e_5, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_2 = (0, _tslib.__values)(collection), collection_2_1 = collection_2.next(); !collection_2_1.done; collection_2_1 = collection_2.next())_b = (0, _tslib.__read)(collection_2_1.value, 2), id = _b[0], ulid = _b[1];
                                 // Get last element of the set
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (collection_2_1 && !collection_2_1.done && (_a = collection_2.return)) _a.call(collection_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }(), 2), itemId = _a[0], ulid = _a[1];
                        itemKey = this.getKeyForItem(storeName, itemId, ulid);
                        _b = itemKey;
                        if (!_b) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        _b = _c.sent();
                        _c.label = 2;
                    case 2:
                        itemString = _b;
                        result = itemString ? JSON.parse(itemString) || undefined : undefined;
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * This function gets all the records stored in async storage for a particular storeName
     * It then loads all the records for that filtered set of keys using multiGet()
     */ AsyncStorageDatabase.prototype.getAll = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, _b, page, _c, limit, start, end, keysForStore, count, collection_3, collection_3_1, _d, id, ulid, storeRecordStrings, records;
            var e_6, _e;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = pagination || {}, _b = _a.page, page = _b === void 0 ? 0 : _b, _c = _a.limit, limit = _c === void 0 ? 0 : _c;
                        start = Math.max(0, page * limit) || 0;
                        end = limit > 0 ? start + limit : undefined;
                        keysForStore = [];
                        count = 0;
                        try {
                            for(collection_3 = (0, _tslib.__values)(collection), collection_3_1 = collection_3.next(); !collection_3_1.done; collection_3_1 = collection_3.next()){
                                _d = (0, _tslib.__read)(collection_3_1.value, 2), id = _d[0], ulid = _d[1];
                                count++;
                                if (count <= start) continue;
                                keysForStore.push(this.getKeyForItem(storeName, id, ulid));
                                if (count === end) break;
                            }
                        } catch (e_6_1) {
                            e_6 = {
                                error: e_6_1
                            };
                        } finally{
                            try {
                                if (collection_3_1 && !collection_3_1.done && (_e = collection_3.return)) _e.call(collection_3);
                            } finally{
                                if (e_6) throw e_6.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(keysForStore)
                        ];
                    case 1:
                        storeRecordStrings = _f.sent();
                        records = storeRecordStrings.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return value;
                        }).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return JSON.parse(value);
                        });
                        return [
                            2 /*return*/ ,
                            records
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.delete = function(key, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(key);
                        itemKey = this.getKeyForItem(storeName, key, ulid);
                        this.getCollectionIndex(storeName).delete(key);
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(itemKey)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Clear the AsyncStorage of all DataStore entries
     */ AsyncStorageDatabase.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, allDataStoreKeys;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _a.sent();
                        allDataStoreKeys = allKeys.filter(function(key) {
                            return key.startsWith(DB_NAME);
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(allDataStoreKeys)
                        ];
                    case 2:
                        _a.sent();
                        this._collectionInMemoryIndex.clear();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getKeyForItem = function(storeName, id, ulid) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + ulid + "::" + id;
    };
    AsyncStorageDatabase.prototype.getLegacyKeyForItem = function(storeName, id) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + id;
    };
    AsyncStorageDatabase.prototype.getKeyPrefixForStoreItems = function(storeName) {
        return DB_NAME + "::" + storeName + "::" + DATA;
    };
    return AsyncStorageDatabase;
}();
exports.default = AsyncStorageDatabase;

},{"tslib":"86BcK","../../types":"9W0ar","../../util":"iFXfl","./InMemoryStore":"kjZTe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kjZTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", function() {
    return InMemoryStore;
});
parcelHelpers.export(exports, "createInMemoryStore", function() {
    return createInMemoryStore;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var InMemoryStore = /** @class */ function() {
    function InMemoryStore() {
        var _this = this;
        this.db = new Map();
        this.getAllKeys = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        Array.from(this.db.keys())
                    ];
                });
            });
        };
        this.multiGet = function(keys) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        keys.reduce(function(res, k) {
                            return res.push([
                                k,
                                _this.db.get(k)
                            ]), res;
                        }, [])
                    ];
                });
            });
        };
        this.multiRemove = function(keys, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    keys.forEach(function(k) {
                        return _this.db.delete(k);
                    });
                    typeof callback === 'function' && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.multiSet = function(entries, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    entries.forEach(function(_a) {
                        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
                        _this.setItem(key, value);
                    });
                    typeof callback === 'function' && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.setItem = function(key, value) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.set(key, value)
                    ];
                });
            });
        };
        this.removeItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.delete(key)
                    ];
                });
            });
        };
        this.getItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.get(key)
                    ];
                });
            });
        };
    }
    return InMemoryStore;
}();
function createInMemoryStore() {
    return new InMemoryStore();
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4SDgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlMessage", function() {
    return ControlMessage;
});
parcelHelpers.export(exports, "SyncEngine", function() {
    return SyncEngine;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _datastoreConnectivity = require("./datastoreConnectivity");
var _datastoreConnectivityDefault = parcelHelpers.interopDefault(_datastoreConnectivity);
var _merger = require("./merger");
var _outbox = require("./outbox");
var _mutation = require("./processors/mutation");
var _subscription = require("./processors/subscription");
var _sync = require("./processors/sync");
var _utils = require("./utils");
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)('DataStore');
var ownSymbol = Symbol('sync');
var ControlMessage;
(function(ControlMessage) {
    ControlMessage["SYNC_ENGINE_STORAGE_SUBSCRIBED"] = "storageSubscribed";
    ControlMessage["SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED"] = "subscriptionsEstablished";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_STARTED"] = "syncQueriesStarted";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_READY"] = "syncQueriesReady";
    ControlMessage["SYNC_ENGINE_MODEL_SYNCED"] = "modelSynced";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED"] = "outboxMutationEnqueued";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED"] = "outboxMutationProcessed";
    ControlMessage["SYNC_ENGINE_OUTBOX_STATUS"] = "outboxStatus";
    ControlMessage["SYNC_ENGINE_NETWORK_STATUS"] = "networkStatus";
    ControlMessage["SYNC_ENGINE_READY"] = "ready";
})(ControlMessage || (ControlMessage = {}));
var SyncEngine = /** @class */ function() {
    function SyncEngine(schema, namespaceResolver, modelClasses, userModelClasses, storage, modelInstanceCreator, conflictHandler, errorHandler, syncPredicates, amplifyConfig, authModeStrategy, amplifyContext, connectivityMonitor) {
        var _this = this;
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.modelClasses = modelClasses;
        this.userModelClasses = userModelClasses;
        this.storage = storage;
        this.modelInstanceCreator = modelInstanceCreator;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.amplifyContext = amplifyContext;
        this.connectivityMonitor = connectivityMonitor;
        this.online = false;
        this.modelSyncedStatus = new WeakMap();
        this.connectionDisrupted = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.waitForSleepState = new Promise(function(resolve) {
            _this.syncQueriesObservableStartSleeping = resolve;
        });
        var MutationEvent = this.modelClasses['MutationEvent'];
        this.outbox = new (0, _outbox.MutationEventOutbox)(this.schema, MutationEvent, modelInstanceCreator, ownSymbol);
        this.modelMerger = new (0, _merger.ModelMerger)(this.outbox, ownSymbol);
        this.syncQueriesProcessor = new (0, _sync.SyncProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.subscriptionsProcessor = new (0, _subscription.SubscriptionProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.mutationsProcessor = new (0, _mutation.MutationProcessor)(this.schema, this.storage, this.userModelClasses, this.outbox, this.modelInstanceCreator, MutationEvent, this.amplifyConfig, this.authModeStrategy, errorHandler, conflictHandler, this.amplifyContext);
        this.datastoreConnectivity = this.connectivityMonitor || new (0, _datastoreConnectivityDefault.default)();
    }
    SyncEngine.prototype.getModelSyncedStatus = function(modelConstructor) {
        return this.modelSyncedStatus.get(modelConstructor);
    };
    SyncEngine.prototype.start = function(params) {
        var _this = this;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            logger.log('starting sync engine...');
            var subscriptions = [];
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1, startPromise, hasMutationsInOutbox;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.setupModels(params)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                observer.error(err_1);
                                return [
                                    2 /*return*/ 
                                ];
                            case 3:
                                startPromise = new Promise(function(doneStarting, failedStarting) {
                                    _this.datastoreConnectivity.status().subscribe(function(_a) {
                                        var online = _a.online;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var ctlSubsObservable_1, dataSubsObservable, err_2, error_1;
                                                            var _$_a;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_b) {
                                                                switch(_b.label){
                                                                    case 0:
                                                                        if (!(online && !this.online)) return [
                                                                            3 /*break*/ ,
                                                                            10
                                                                        ];
                                                                        this.online = online;
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                            data: {
                                                                                active: this.online
                                                                            }
                                                                        });
                                                                        dataSubsObservable = void 0;
                                                                        if (!isNode) return [
                                                                            3 /*break*/ ,
                                                                            1
                                                                        ];
                                                                        logger.warn('Realtime disabled when in a server-side environment');
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            6
                                                                        ];
                                                                    case 1:
                                                                        this.stopDisruptionListener = this.startDisruptionListener();
                                                                        //#region GraphQL Subscriptions
                                                                        _$_a = (0, _tslib.__read)(this.subscriptionsProcessor.start(), 2), ctlSubsObservable_1 = _$_a[0], dataSubsObservable = _$_a[1];
                                                                        _b.label = 2;
                                                                    case 2:
                                                                        _b.trys.push([
                                                                            2,
                                                                            4,
                                                                            ,
                                                                            5
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                onTerminate.then(reject);
                                                                                var ctlSubsSubscription = ctlSubsObservable_1.subscribe({
                                                                                    next: function next(msg) {
                                                                                        if (msg === (0, _subscription.CONTROL_MSG).CONNECTED) resolve();
                                                                                    },
                                                                                    error: function error(err) {
                                                                                        reject(err);
                                                                                        var handleDisconnect = _this.disconnectionHandler();
                                                                                        handleDisconnect(err);
                                                                                    }
                                                                                });
                                                                                subscriptions.push(ctlSubsSubscription);
                                                                            })
                                                                        ];
                                                                    case 3:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            5
                                                                        ];
                                                                    case 4:
                                                                        err_2 = _b.sent();
                                                                        observer.error(err_2);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 5:
                                                                        logger.log('Realtime ready');
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED
                                                                        });
                                                                        _b.label = 6;
                                                                    case 6:
                                                                        _b.trys.push([
                                                                            6,
                                                                            8,
                                                                            ,
                                                                            9
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                var syncQuerySubscription = _this.syncQueriesObservable().subscribe({
                                                                                    next: function next(message) {
                                                                                        var type = message.type;
                                                                                        if (type === ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY) resolve();
                                                                                        observer.next(message);
                                                                                    },
                                                                                    complete: function complete() {
                                                                                        resolve();
                                                                                    },
                                                                                    error: function error(_error) {
                                                                                        reject(_error);
                                                                                    }
                                                                                });
                                                                                if (syncQuerySubscription) subscriptions.push(syncQuerySubscription);
                                                                            })
                                                                        ];
                                                                    case 7:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            9
                                                                        ];
                                                                    case 8:
                                                                        error_1 = _b.sent();
                                                                        observer.error(error_1);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 9:
                                                                        //#endregion
                                                                        //#region process mutations (outbox)
                                                                        subscriptions.push(this.mutationsProcessor.start().subscribe(function(_a) {
                                                                            var modelDefinition = _a.modelDefinition, item = _a.model, hasMore = _a.hasMore;
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED,
                                                                                                    data: {
                                                                                                        model: modelConstructor,
                                                                                                        element: model
                                                                                                    }
                                                                                                });
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                                                    data: {
                                                                                                        isEmpty: !hasMore
                                                                                                    }
                                                                                                });
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, 'mutation processor event');
                                                                        }));
                                                                        //#endregion
                                                                        //#region Merge subscriptions buffer
                                                                        // TODO: extract to function
                                                                        if (!isNode) subscriptions.push(dataSubsObservable.subscribe(function(_a) {
                                                                            var _$_b = (0, _tslib.__read)(_a, 3), _transformerMutationType = _$_b[0], modelDefinition = _$_b[1], item = _$_b[2];
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, 'subscription dataSubsObservable event');
                                                                        }));
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            11
                                                                        ];
                                                                    case 10:
                                                                        if (!online) {
                                                                            this.online = online;
                                                                            observer.next({
                                                                                type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                                data: {
                                                                                    active: this.online
                                                                                }
                                                                            });
                                                                            subscriptions.forEach(function(sub) {
                                                                                return sub.unsubscribe();
                                                                            });
                                                                            subscriptions = [];
                                                                        }
                                                                        _b.label = 11;
                                                                    case 11:
                                                                        doneStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, 'datastore connectivity event')
                                                ];
                                            });
                                        });
                                    });
                                });
                                this.storage.observe(null, null, ownSymbol).filter(function(_a) {
                                    var model = _a.model;
                                    var modelDefinition = _this.getModelDefinition(model);
                                    return modelDefinition.syncable === true;
                                }).subscribe({
                                    next: function next(_a) {
                                        var opType = _a.opType, model = _a.model, element = _a.element, condition = _a.condition;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.add(function() {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var namespace, MutationEventConstructor, modelDefinition, graphQLCondition, mutationEvent;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        namespace = this.schema.namespaces[this.namespaceResolver(model)];
                                                                        MutationEventConstructor = this.modelClasses['MutationEvent'];
                                                                        modelDefinition = this.getModelDefinition(model);
                                                                        graphQLCondition = (0, _utils.predicateToGraphQLCondition)(condition, modelDefinition);
                                                                        mutationEvent = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, this.getModelDefinition(model), opType, model, element, graphQLCondition, MutationEventConstructor, this.modelInstanceCreator);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.outbox.enqueue(this.storage, mutationEvent)
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED,
                                                                            data: {
                                                                                model: model,
                                                                                element: element
                                                                            }
                                                                        });
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                            data: {
                                                                                isEmpty: false
                                                                            }
                                                                        });
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            startPromise
                                                                        ];
                                                                    case 2:
                                                                        _a.sent();
                                                                        // Set by the this.datastoreConnectivity.status().subscribe() loop
                                                                        if (this.online) this.mutationsProcessor.resume();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, 'storage event')
                                                ];
                                            });
                                        });
                                    }
                                });
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_STORAGE_SUBSCRIBED
                                });
                                return [
                                    4 /*yield*/ ,
                                    this.outbox.peek(this.storage)
                                ];
                            case 4:
                                hasMutationsInOutbox = _a.sent() === undefined;
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                    data: {
                                        isEmpty: hasMutationsInOutbox
                                    }
                                });
                                return [
                                    4 /*yield*/ ,
                                    startPromise
                                ];
                            case 5:
                                _a.sent();
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_READY
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, 'sync start');
        });
    };
    SyncEngine.prototype.getModelsMetadataWithNextFullSync = function(currentTimeStamp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelLastSync, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = Map.bind;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.add(function() {
                                return _this.getModelsMetadata();
                            }, 'sync/index getModelsMetadataWithNextFullSync')
                        ];
                    case 1:
                        modelLastSync = new (_a.apply(Map, [
                            void 0,
                            _b.sent().map(function(_a) {
                                var namespace = _a.namespace, model = _a.model, lastSync = _a.lastSync, lastFullSync = _a.lastFullSync, fullSyncInterval = _a.fullSyncInterval, lastSyncPredicate = _a.lastSyncPredicate;
                                var nextFullSync = lastFullSync + fullSyncInterval;
                                var syncFrom = !lastFullSync || nextFullSync < currentTimeStamp ? 0 // perform full sync if expired
                                 : lastSync; // perform delta sync
                                return [
                                    _this.schema.namespaces[namespace].models[model],
                                    [
                                        namespace,
                                        syncFrom
                                    ]
                                ];
                            })
                        ]))();
                        return [
                            2 /*return*/ ,
                            modelLastSync
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.syncQueriesObservable = function() {
        var _this = this;
        if (!this.online) return (0, _zenObservableTsDefault.default).of();
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var syncQueriesSubscription;
            _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var terminated, _loop_1, this_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                terminated = false;
                                _loop_1 = function _loop_1() {
                                    var count, modelLastSync, paginatingModels, lastFullSyncStartedAt, syncInterval, start, syncDuration, lastStartedAt, msNextFullSync;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                count = new WeakMap();
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.getModelsMetadataWithNextFullSync(Date.now())
                                                ];
                                            case 1:
                                                modelLastSync = _a.sent();
                                                paginatingModels = new Set(modelLastSync.keys());
                                                return [
                                                    4 /*yield*/ ,
                                                    new Promise(function(resolve, reject) {
                                                        if (!_this.runningProcesses.isOpen) resolve();
                                                        onTerminate.then(function() {
                                                            return resolve();
                                                        });
                                                        syncQueriesSubscription = _this.syncQueriesProcessor.start(modelLastSync).subscribe({
                                                            next: function next(_a) {
                                                                var namespace = _a.namespace, modelDefinition = _a.modelDefinition, items = _a.items, done = _a.done, startedAt = _a.startedAt, isFullSync = _a.isFullSync;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var modelConstructor, modelName, modelMetadata_1, lastFullSync, fullSyncInterval, counts;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                if (!count.has(modelConstructor)) {
                                                                                    count.set(modelConstructor, {
                                                                                        new: 0,
                                                                                        updated: 0,
                                                                                        deleted: 0
                                                                                    });
                                                                                    start = (0, _util.getNow)();
                                                                                    lastStartedAt = lastStartedAt === undefined ? startedAt : Math.max(lastStartedAt, startedAt);
                                                                                }
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.runExclusive(function(storage) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var idsInOutbox, oneByOne, page, opTypeCount, oneByOne_1, oneByOne_1_1, item, opType, e_1_1, _$_a, _$_b, _c, counts;
                                                                                            var e_1, _d;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.outbox.getModelIds(storage)
                                                                                                        ];
                                                                                                    case 1:
                                                                                                        idsInOutbox = _e.sent();
                                                                                                        oneByOne = [];
                                                                                                        page = items.filter(function(item) {
                                                                                                            var itemId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                                                                                            if (!idsInOutbox.has(itemId)) return true;
                                                                                                            oneByOne.push(item);
                                                                                                            return false;
                                                                                                        });
                                                                                                        opTypeCount = [];
                                                                                                        _e.label = 2;
                                                                                                    case 2:
                                                                                                        _e.trys.push([
                                                                                                            2,
                                                                                                            7,
                                                                                                            8,
                                                                                                            9
                                                                                                        ]);
                                                                                                        oneByOne_1 = (0, _tslib.__values)(oneByOne), oneByOne_1_1 = oneByOne_1.next();
                                                                                                        _e.label = 3;
                                                                                                    case 3:
                                                                                                        if (!!oneByOne_1_1.done) return [
                                                                                                            3 /*break*/ ,
                                                                                                            6
                                                                                                        ];
                                                                                                        item = oneByOne_1_1.value;
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.merge(storage, item, modelDefinition)
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        opType = _e.sent();
                                                                                                        if (opType !== undefined) opTypeCount.push([
                                                                                                            item,
                                                                                                            opType
                                                                                                        ]);
                                                                                                        _e.label = 5;
                                                                                                    case 5:
                                                                                                        oneByOne_1_1 = oneByOne_1.next();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            3
                                                                                                        ];
                                                                                                    case 6:
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 7:
                                                                                                        e_1_1 = _e.sent();
                                                                                                        e_1 = {
                                                                                                            error: e_1_1
                                                                                                        };
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 8:
                                                                                                        try {
                                                                                                            if (oneByOne_1_1 && !oneByOne_1_1.done && (_d = oneByOne_1.return)) _d.call(oneByOne_1);
                                                                                                        } finally{
                                                                                                            if (e_1) throw e_1.error;
                                                                                                        }
                                                                                                        return [
                                                                                                            7 /*endfinally*/ 
                                                                                                        ];
                                                                                                    case 9:
                                                                                                        _$_b = (_$_a = opTypeCount.push).apply;
                                                                                                        _c = [
                                                                                                            opTypeCount
                                                                                                        ];
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.mergePage(storage, modelConstructor, page, modelDefinition)
                                                                                                        ];
                                                                                                    case 10:
                                                                                                        _$_b.apply(_$_a, _c.concat([
                                                                                                            (0, _tslib.__spread).apply(void 0, [
                                                                                                                _e.sent()
                                                                                                            ])
                                                                                                        ]));
                                                                                                        counts = count.get(modelConstructor);
                                                                                                        opTypeCount.forEach(function(_a) {
                                                                                                            var _$_b = (0, _tslib.__read)(_a, 2), opType = _$_b[1];
                                                                                                            switch(opType){
                                                                                                                case (0, _types.OpType).INSERT:
                                                                                                                    counts.new++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).UPDATE:
                                                                                                                    counts.updated++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).DELETE:
                                                                                                                    counts.deleted++;
                                                                                                                    break;
                                                                                                                default:
                                                                                                                    throw new Error("Invalid opType " + opType);
                                                                                                            }
                                                                                                        });
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    })
                                                                                ];
                                                                            case 1:
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ _b.sent();
                                                                                if (!done) return [
                                                                                    3 /*break*/ ,
                                                                                    4
                                                                                ];
                                                                                modelName = modelDefinition.name;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.getModelMetadata(namespace, modelName)
                                                                                ];
                                                                            case 2:
                                                                                modelMetadata_1 = _b.sent();
                                                                                lastFullSync = modelMetadata_1.lastFullSync, fullSyncInterval = modelMetadata_1.fullSyncInterval;
                                                                                syncInterval = fullSyncInterval;
                                                                                lastFullSyncStartedAt = lastFullSyncStartedAt === undefined ? lastFullSync : Math.max(lastFullSyncStartedAt, isFullSync ? startedAt : lastFullSync);
                                                                                modelMetadata_1 = this.modelClasses.ModelMetadata.copyOf(modelMetadata_1, function(draft) {
                                                                                    draft.lastSync = startedAt;
                                                                                    draft.lastFullSync = isFullSync ? startedAt : modelMetadata_1.lastFullSync;
                                                                                });
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.save(modelMetadata_1, undefined, ownSymbol)
                                                                                ];
                                                                            case 3:
                                                                                _b.sent();
                                                                                counts = count.get(modelConstructor);
                                                                                this.modelSyncedStatus.set(modelConstructor, true);
                                                                                observer.next({
                                                                                    type: ControlMessage.SYNC_ENGINE_MODEL_SYNCED,
                                                                                    data: {
                                                                                        model: modelConstructor,
                                                                                        isFullSync: isFullSync,
                                                                                        isDeltaSync: !isFullSync,
                                                                                        counts: counts
                                                                                    }
                                                                                });
                                                                                paginatingModels.delete(modelDefinition);
                                                                                if (paginatingModels.size === 0) {
                                                                                    syncDuration = (0, _util.getNow)() - start;
                                                                                    resolve();
                                                                                    observer.next({
                                                                                        type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY
                                                                                    });
                                                                                    syncQueriesSubscription.unsubscribe();
                                                                                }
                                                                                _b.label = 4;
                                                                            case 4:
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            },
                                                            error: function error(_error) {
                                                                observer.error(_error);
                                                            }
                                                        });
                                                        observer.next({
                                                            type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_STARTED,
                                                            data: {
                                                                models: Array.from(paginatingModels).map(function(_a) {
                                                                    var name = _a.name;
                                                                    return name;
                                                                })
                                                            }
                                                        });
                                                    })
                                                ];
                                            case 2:
                                                _a.sent();
                                                if (!lastFullSyncStartedAt) msNextFullSync = syncInterval - syncDuration;
                                                else msNextFullSync = lastFullSyncStartedAt + syncInterval - (lastStartedAt + syncDuration);
                                                logger.debug("Next fullSync in " + msNextFullSync / 1000 + " seconds. (" + new Date(Date.now() + msNextFullSync) + ")");
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var sleepTimer, unsleep, sleep;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                sleep = new Promise(function(_unsleep) {
                                                                    unsleep = _unsleep;
                                                                    sleepTimer = setTimeout(unsleep, msNextFullSync);
                                                                });
                                                                onTerminate.then(function() {
                                                                    terminated = true;
                                                                    _this.syncQueriesObservableStartSleeping();
                                                                    unsleep();
                                                                });
                                                                this.unsleepSyncQueriesObservable = unsleep;
                                                                this.syncQueriesObservableStartSleeping();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    sleep
                                                                ];
                                                            });
                                                        });
                                                    }, 'syncQueriesObservable sleep')
                                                ];
                                            case 3:
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                _a.sent();
                                                this_1.unsleepSyncQueriesObservable = null;
                                                this_1.waitForSleepState = new Promise(function(resolve) {
                                                    _this.syncQueriesObservableStartSleeping = resolve;
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                };
                                this_1 = this;
                                _a.label = 1;
                            case 1:
                                if (!(!observer.closed && !terminated)) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    5 /*yield**/ ,
                                    _loop_1()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, 'syncQueriesObservable main');
        });
    };
    SyncEngine.prototype.disconnectionHandler = function() {
        var _this = this;
        return function(msg) {
            // This implementation is tied to AWSAppSyncRealTimeProvider 'Connection closed', 'Timeout disconnect' msg
            if ((0, _pubsub.CONTROL_MSG).CONNECTION_CLOSED === msg || (0, _pubsub.CONTROL_MSG).TIMEOUT_DISCONNECT === msg) _this.datastoreConnectivity.socketDisconnected();
        };
    };
    SyncEngine.prototype.unsubscribeConnectivity = function() {
        this.datastoreConnectivity.unsubscribe();
    };
    /**
     * Stops all subscription activities and resolves when all activies report
     * that they're disconnected, done retrying, etc..
     */ SyncEngine.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('stopping sync engine');
                        /**
                         * Gracefully disconnecting subscribers first just prevents *more* work
                         * from entering the pipelines.
                         */ this.unsubscribeConnectivity();
                        /**
                         * Stop listening for websocket connection disruption
                         */ this.stopDisruptionListener && this.stopDisruptionListener();
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ return [
                            4 /*yield*/ ,
                            this.mutationsProcessor.stop()
                        ];
                    case 1:
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.subscriptionsProcessor.stop()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.datastoreConnectivity.stop()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.syncQueriesProcessor.stop()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 6:
                        _a.sent();
                        logger.debug('sync engine stopped and ready to restart');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.setupModels = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var fullSyncInterval, ModelMetadataConstructor, models, savedModel, promises, result, _a, _b, modelMetadata, modelName, e_2_1;
            var e_2, _c;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        fullSyncInterval = params.fullSyncInterval;
                        ModelMetadataConstructor = this.modelClasses.ModelMetadata;
                        models = [];
                        Object.values(this.schema.namespaces).forEach(function(namespace) {
                            Object.values(namespace.models).filter(function(_a) {
                                var syncable = _a.syncable;
                                return syncable;
                            }).forEach(function(model) {
                                models.push([
                                    namespace.name,
                                    model
                                ]);
                                if (namespace.name === (0, _util.USER)) {
                                    var modelConstructor = _this.userModelClasses[model.name];
                                    _this.modelSyncedStatus.set(modelConstructor, false);
                                }
                            });
                        });
                        promises = models.map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), namespace = _b[0], model = _b[1];
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var modelMetadata, syncPredicate, lastSyncPredicate, prevSyncPredicate, syncPredicateUpdated_1;
                                var _c, _$_d, _e, _f;
                                return (0, _tslib.__generator)(this, function(_g) {
                                    switch(_g.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.getModelMetadata(namespace, model.name)
                                            ];
                                        case 1:
                                            modelMetadata = _g.sent();
                                            syncPredicate = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
                                            lastSyncPredicate = syncPredicate ? JSON.stringify(syncPredicate) : null;
                                            if (!(modelMetadata === undefined)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(this.modelInstanceCreator(ModelMetadataConstructor, {
                                                    model: model.name,
                                                    namespace: namespace,
                                                    lastSync: null,
                                                    fullSyncInterval: fullSyncInterval,
                                                    lastFullSync: null,
                                                    lastSyncPredicate: lastSyncPredicate
                                                }), undefined, ownSymbol)
                                            ];
                                        case 2:
                                            _c = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _$_d = (0, _tslib.__read)(_c[0], 1), savedModel = _$_d[0];
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 3:
                                            prevSyncPredicate = modelMetadata.lastSyncPredicate ? modelMetadata.lastSyncPredicate : null;
                                            syncPredicateUpdated_1 = prevSyncPredicate !== lastSyncPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(ModelMetadataConstructor.copyOf(modelMetadata, function(draft) {
                                                    draft.fullSyncInterval = fullSyncInterval;
                                                    // perform a base sync if the syncPredicate changed in between calls to DataStore.start
                                                    // ensures that the local store contains all the data specified by the syncExpression
                                                    if (syncPredicateUpdated_1) {
                                                        draft.lastSync = null;
                                                        draft.lastFullSync = null;
                                                        draft.lastSyncPredicate = lastSyncPredicate;
                                                    }
                                                }))
                                            ];
                                        case 4:
                                            _e = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _f = (0, _tslib.__read)(_e[0], 1), savedModel = _f[0];
                                            _g.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ ,
                                                savedModel
                                            ];
                                    }
                                });
                            });
                        });
                        result = {};
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 2:
                        _a = (0, _tslib.__values).apply(void 0, [
                            _d.sent()
                        ]), _b = _a.next();
                        _d.label = 3;
                    case 3:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        modelMetadata = _b.value;
                        modelName = modelMetadata.model;
                        result[modelName] = modelMetadata;
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelsMetadata = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, modelsMetadata;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata)
                        ];
                    case 1:
                        modelsMetadata = _a.sent();
                        return [
                            2 /*return*/ ,
                            modelsMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelMetadata = function(namespace, model) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, predicate, _a, modelMetadata;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(this.schema.namespaces[0, _util.SYNC].models[ModelMetadata.name], {
                            and: [
                                {
                                    namespace: {
                                        eq: namespace
                                    }
                                },
                                {
                                    model: {
                                        eq: model
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata, predicate, {
                                page: 0,
                                limit: 1
                            })
                        ];
                    case 1:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            1
                        ]), modelMetadata = _a[0];
                        return [
                            2 /*return*/ ,
                            modelMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelDefinition = function(modelConstructor) {
        var namespaceName = this.namespaceResolver(modelConstructor);
        var modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
        return modelDefinition;
    };
    SyncEngine.getNamespace = function() {
        var namespace = {
            name: (0, _util.SYNC),
            relationships: {},
            enums: {
                OperationType: {
                    name: 'OperationType',
                    values: [
                        'CREATE',
                        'UPDATE',
                        'DELETE'
                    ]
                }
            },
            nonModels: {},
            models: {
                MutationEvent: {
                    name: 'MutationEvent',
                    pluralName: 'MutationEvents',
                    syncable: false,
                    fields: {
                        id: {
                            name: 'id',
                            type: 'ID',
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: 'model',
                            type: 'String',
                            isRequired: true,
                            isArray: false
                        },
                        data: {
                            name: 'data',
                            type: 'String',
                            isRequired: true,
                            isArray: false
                        },
                        modelId: {
                            name: 'modelId',
                            type: 'String',
                            isRequired: true,
                            isArray: false
                        },
                        operation: {
                            name: 'operation',
                            type: {
                                enum: 'Operationtype'
                            },
                            isArray: false,
                            isRequired: true
                        },
                        condition: {
                            name: 'condition',
                            type: 'String',
                            isArray: false,
                            isRequired: true
                        }
                    }
                },
                ModelMetadata: {
                    name: 'ModelMetadata',
                    pluralName: 'ModelsMetadata',
                    syncable: false,
                    fields: {
                        id: {
                            name: 'id',
                            type: 'ID',
                            isRequired: true,
                            isArray: false
                        },
                        namespace: {
                            name: 'namespace',
                            type: 'String',
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: 'model',
                            type: 'String',
                            isRequired: true,
                            isArray: false
                        },
                        lastSync: {
                            name: 'lastSync',
                            type: 'Int',
                            isRequired: false,
                            isArray: false
                        },
                        lastFullSync: {
                            name: 'lastFullSync',
                            type: 'Int',
                            isRequired: false,
                            isArray: false
                        },
                        fullSyncInterval: {
                            name: 'fullSyncInterval',
                            type: 'Int',
                            isRequired: true,
                            isArray: false
                        },
                        lastSyncPredicate: {
                            name: 'lastSyncPredicate',
                            type: 'String',
                            isRequired: false,
                            isArray: false
                        }
                    }
                }
            }
        };
        return namespace;
    };
    /**
     * listen for websocket connection disruption
     *
     * May indicate there was a period of time where messages
     * from AppSync were missed. A sync needs to be triggered to
     * retrieve the missed data.
     */ SyncEngine.prototype.startDisruptionListener = function() {
        var _this = this;
        return (0, _core.Hub).listen('api', function(data) {
            if (data.source === 'PubSub' && data.payload.event === (0, _pubsub.CONNECTION_STATE_CHANGE)) {
                var connectionState = data.payload.data.connectionState;
                switch(connectionState){
                    // Do not need to listen for ConnectionDisruptedPendingNetwork
                    // Normal network reconnection logic will handle the sync
                    case (0, _pubsub.ConnectionState).ConnectionDisrupted:
                        _this.connectionDisrupted = true;
                        break;
                    case (0, _pubsub.ConnectionState).Connected:
                        if (_this.connectionDisrupted) _this.scheduleSync();
                        _this.connectionDisrupted = false;
                        break;
                }
            }
        });
    };
    /*
     * Schedule a sync to start when syncQueriesObservable enters sleep state
     * Start sync immediately if syncQueriesObservable is already in sleep state
     */ SyncEngine.prototype.scheduleSync = function() {
        var _this = this;
        return this.runningProcesses.isOpen && this.runningProcesses.add(function() {
            return _this.waitForSleepState.then(function() {
                // unsleepSyncQueriesObservable will be set if waitForSleepState has resolved
                _this.unsleepSyncQueriesObservable();
            });
        });
    };
    return SyncEngine;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub":"bJVAp","zen-observable-ts":"57mma","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","./datastoreConnectivity":"LQTxI","./merger":"bjDLh","./outbox":"awQ3l","./processors/mutation":"hZWX4","./processors/subscription":"j7cif","./processors/sync":"bkNXz","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJVAp":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSub", function() {
    return 0, _pubSub.PubSub;
});
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", function() {
    return 0, _constants.CONNECTION_STATE_CHANGE;
});
parcelHelpers.export(exports, "ConnectionState", function() {
    return 0, _types.ConnectionState;
});
parcelHelpers.export(exports, "CONTROL_MSG", function() {
    return 0, _types.CONTROL_MSG;
});
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", function() {
    return 0, _providers.AWSAppSyncRealTimeProvider;
});
parcelHelpers.export(exports, "AWSIoTProvider", function() {
    return 0, _providers.AWSIoTProvider;
});
parcelHelpers.export(exports, "AbstractPubSubProvider", function() {
    return 0, _providers.AbstractPubSubProvider;
});
parcelHelpers.export(exports, "MqttOverWSProvider", function() {
    return 0, _providers.MqttOverWSProvider;
});
parcelHelpers.export(exports, "mqttTopicMatch", function() {
    return 0, _providers.mqttTopicMatch;
});
var _pubSub = require("./PubSub");
var _constants = require("./Providers/constants");
var _types = require("./types");
var _providers = require("./Providers");

},{"./PubSub":"gqEBt","./Providers/constants":"dleHk","./types":"fmtdF","./Providers":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gqEBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSubClass", function() {
    return PubSubClass;
});
parcelHelpers.export(exports, "PubSub", function() {
    return PubSub;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var PubSubClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(PubSubClass, _super);
    function PubSubClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PubSubClass.prototype.getModuleName = function() {
        return 'PubSub';
    };
    PubSubClass.prototype.subscribe = function(topics, options) {
        return _super.prototype.subscribe.call(this, topics, options);
    };
    return PubSubClass;
}((0, _internals.InternalPubSubClass));
var PubSub = new PubSubClass();
(0, _core.Amplify).register(PubSub);

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","./internals":"4KMnX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fmtdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", function() {
    return 0, _pubSub.CONTROL_MSG;
});
parcelHelpers.export(exports, "ConnectionState", function() {
    return 0, _pubSub.ConnectionState;
});
var _pubSub = require("./PubSub");

},{"./PubSub":"dTFhH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"LQTxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _core = require("@aws-amplify/core");
var _datastoreReachability = require("./datastoreReachability");
var logger = new (0, _core.ConsoleLogger)('DataStore');
var RECONNECTING_IN = 5000; // 5s this may be configurable in the future
var DataStoreConnectivity = /** @class */ function() {
    function DataStoreConnectivity() {
        this.connectionStatus = {
            online: false
        };
    }
    DataStoreConnectivity.prototype.status = function() {
        var _this = this;
        if (this.observer) throw new Error('Subscriber already exists');
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            // Will be used to forward socket connection changes, enhancing Reachability
            _this.subscription = (0, _datastoreReachability.ReachabilityMonitor).subscribe(function(_a) {
                var online = _a.online;
                _this.connectionStatus.online = online;
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                observer.next(observerResult);
            });
            return function() {
                clearTimeout(_this.timeout);
                _this.unsubscribe();
            };
        });
    };
    DataStoreConnectivity.prototype.unsubscribe = function() {
        if (this.subscription) {
            clearTimeout(this.timeout);
            this.subscription.unsubscribe();
        }
    };
    // for consistency with other background processors.
    DataStoreConnectivity.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.unsubscribe();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DataStoreConnectivity.prototype.socketDisconnected = function() {
        var _this = this;
        if (this.observer && typeof this.observer.next === 'function') {
            this.observer.next({
                online: false
            }); // Notify network issue from the socket
            this.timeout = setTimeout(function() {
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                _this.observer.next(observerResult);
            }, RECONNECTING_IN); // giving time for socket cleanup and network status stabilization
        }
    };
    return DataStoreConnectivity;
}();
exports.default = DataStoreConnectivity;

},{"tslib":"86BcK","zen-observable-ts":"57mma","@aws-amplify/core":"3rlh1","./datastoreReachability":"j6Xwg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j6Xwg":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", function() {
    return ReachabilityMonitor;
});
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = new (0, _core.Reachability)().networkMonitor();

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bjDLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelMerger", function() {
    return ModelMerger;
});
var _tslib = require("tslib");
var _types = require("../types");
var _utils = require("./utils");
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#merger
var ModelMerger = /** @class */ function() {
    function ModelMerger(outbox, ownSymbol) {
        this.outbox = outbox;
        this.ownSymbol = ownSymbol;
    }
    /**
     *
     * @param storage Storage adapter that contains the data.
     * @param model The model from an outbox mutation.
     * @returns The type of operation (INSERT/UPDATE/DELETE)
     */ ModelMerger.prototype.merge = function(storage, model, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, mutationsForModel, isDelete;
            var _a, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.outbox.getForModel(storage, model, modelDefinition)
                        ];
                    case 1:
                        mutationsForModel = _c.sent();
                        isDelete = model._deleted;
                        if (!(mutationsForModel.length === 0)) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!isDelete) return [
                            3 /*break*/ ,
                            3
                        ];
                        result = (0, _types.OpType).DELETE;
                        return [
                            4 /*yield*/ ,
                            storage.delete(model, undefined, this.ownSymbol)
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.save(model, undefined, this.ownSymbol)
                        ];
                    case 4:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _c.sent(),
                            1
                        ]), _b = (0, _tslib.__read)(_a[0], 2), result = _b[1];
                        _c.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    ModelMerger.prototype.mergePage = function(storage, modelConstructor, items, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemsMap, items_1, items_1_1, item, modelId, page;
            var e_1, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        itemsMap = new Map();
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                modelId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                itemsMap.set(modelId, item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        page = (0, _tslib.__spread)(itemsMap.values());
                        return [
                            4 /*yield*/ ,
                            storage.batchSave(modelConstructor, page, this.ownSymbol)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return ModelMerger;
}();

},{"tslib":"86BcK","../types":"9W0ar","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"awQ3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationEventOutbox", function() {
    return MutationEventOutbox;
});
var _tslib = require("tslib");
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("./utils");
// TODO: Persist deleted ids
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#outbox
var MutationEventOutbox = /** @class */ function() {
    function MutationEventOutbox(schema, MutationEvent, modelInstanceCreator, ownSymbol) {
        this.schema = schema;
        this.MutationEvent = MutationEvent;
        this.modelInstanceCreator = modelInstanceCreator;
        this.ownSymbol = ownSymbol;
    }
    MutationEventOutbox.prototype.enqueue = function(storage, mutationEvent) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.runExclusive(function(s) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var mutationEventModelDefinition, predicate, _$_a, first, incomingMutationType, merged_1, incomingConditionJSON, incomingCondition, merged;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models['MutationEvent'];
                                                predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                                    and: [
                                                        {
                                                            modelId: {
                                                                eq: mutationEvent.modelId
                                                            }
                                                        },
                                                        {
                                                            id: {
                                                                ne: this.inProgressMutationEventId
                                                            }
                                                        }
                                                    ]
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    s.query(this.MutationEvent, predicate)
                                                ];
                                            case 1:
                                                _$_a = (0, _tslib.__read).apply(void 0, [
                                                    _b.sent(),
                                                    1
                                                ]), first = _$_a[0];
                                                if (!(first === undefined)) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(mutationEvent, undefined, this.ownSymbol)
                                                ];
                                            case 2:
                                                _b.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                incomingMutationType = mutationEvent.operation;
                                                if (!(first.operation === (0, _utils.TransformerMutationType).CREATE)) return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                                if (!(incomingMutationType === (0, _utils.TransformerMutationType).DELETE)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 4:
                                                _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    7
                                                ];
                                            case 5:
                                                merged_1 = this.mergeUserFields(first, mutationEvent);
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(this.MutationEvent.copyOf(first, function(draft) {
                                                        draft.data = merged_1.data;
                                                    }), undefined, this.ownSymbol)
                                                ];
                                            case 6:
                                                _b.sent();
                                                _b.label = 7;
                                            case 7:
                                                return [
                                                    3 /*break*/ ,
                                                    12
                                                ];
                                            case 8:
                                                incomingConditionJSON = mutationEvent.condition;
                                                incomingCondition = JSON.parse(incomingConditionJSON);
                                                merged = void 0;
                                                if (!(Object.keys(incomingCondition).length === 0)) return [
                                                    3 /*break*/ ,
                                                    10
                                                ];
                                                merged = this.mergeUserFields(first, mutationEvent);
                                                // delete all for model
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 9:
                                                // delete all for model
                                                _b.sent();
                                                _b.label = 10;
                                            case 10:
                                                merged = merged || mutationEvent;
                                                // Enqueue new one
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(merged, undefined, this.ownSymbol)
                                                ];
                                            case 11:
                                                // Enqueue new one
                                                _b.sent();
                                                _b.label = 12;
                                            case 12:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.dequeue = function(storage, record, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.peek(storage)
                        ];
                    case 1:
                        head = _a.sent();
                        if (!record) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.syncOutboxVersionsOnDequeue(storage, record, head, recordOp)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.delete(head)
                        ];
                    case 4:
                        _a.sent();
                        this.inProgressMutationEventId = undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    /**
     * Doing a peek() implies that the mutation goes "inProgress"
     *
     * @param storage
     */ MutationEventOutbox.prototype.peek = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.queryOne(this.MutationEvent, (0, _types.QueryOne).FIRST)
                        ];
                    case 1:
                        head = _a.sent();
                        this.inProgressMutationEventId = head ? head.id : undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getForModel = function(storage, model, userModelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEventModelDefinition, modelId, mutationEvents;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models.MutationEvent;
                        modelId = (0, _utils.getIdentifierValue)(userModelDefinition, model);
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                and: {
                                    modelId: {
                                        eq: modelId
                                    }
                                }
                            }))
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        return [
                            2 /*return*/ ,
                            mutationEvents
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getModelIds = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEvents, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent)
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        result = new Set();
                        mutationEvents.forEach(function(_a) {
                            var modelId = _a.modelId;
                            return result.add(modelId);
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // applies _version from the AppSync mutation response to other items
    // in the mutation queue with the same id
    // see https://github.com/aws-amplify/amplify-js/pull/7354 for more details
    MutationEventOutbox.prototype.syncOutboxVersionsOnDequeue = function(storage, record, head, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _version, _lastChangedAt, _deleted, _incomingData, incomingData, data, __version, __lastChangedAt, __deleted, _outgoingData, outgoingData, mutationEventModelDefinition, userModelDefinition, recordId, predicate, outdatedMutations, reconciledMutations;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (head.operation !== recordOp) return [
                            2 /*return*/ 
                        ];
                        _version = record._version, _lastChangedAt = record._lastChangedAt, _deleted = record._deleted, _incomingData = (0, _tslib.__rest)(record, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        incomingData = this.removeTimestampFields(head.model, _incomingData);
                        data = JSON.parse(head.data);
                        if (!data) return [
                            2 /*return*/ 
                        ];
                        __version = data._version, __lastChangedAt = data._lastChangedAt, __deleted = data._deleted, _outgoingData = (0, _tslib.__rest)(data, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        outgoingData = this.removeTimestampFields(head.model, _outgoingData);
                        // Don't sync the version when the data in the response does not match the data
                        // in the request, i.e., when there's a handled conflict
                        //
                        // NOTE: `incomingData` contains all the fields in the record, and `outgoingData`
                        // only contains updated fields, resulting in an error when doing a comparison
                        // of two equal mutations. Fix this, or mitigate otherwise.
                        if (!(0, _util.valuesEqual)(incomingData, outgoingData, true)) return [
                            2 /*return*/ 
                        ];
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models['MutationEvent'];
                        userModelDefinition = this.schema.namespaces['user'].models[head.model];
                        recordId = (0, _utils.getIdentifierValue)(userModelDefinition, record);
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                            and: [
                                {
                                    modelId: {
                                        eq: recordId
                                    }
                                },
                                {
                                    id: {
                                        ne: this.inProgressMutationEventId
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, predicate)
                        ];
                    case 1:
                        outdatedMutations = _a.sent();
                        if (!outdatedMutations.length) return [
                            2 /*return*/ 
                        ];
                        reconciledMutations = outdatedMutations.map(function(m) {
                            var oldData = JSON.parse(m.data);
                            var newData = (0, _tslib.__assign)((0, _tslib.__assign)({}, oldData), {
                                _version: _version,
                                _lastChangedAt: _lastChangedAt
                            });
                            return _this.MutationEvent.copyOf(m, function(draft) {
                                draft.data = JSON.stringify(newData);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            storage.delete(this.MutationEvent, predicate)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all(reconciledMutations.map(function(m) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    storage.save(m, undefined, this.ownSymbol)
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.mergeUserFields = function(previous, current) {
        var _a = JSON.parse(previous.data), _version = _a._version, _lastChangedAt = _a._lastChangedAt, _deleted = _a._deleted, previousData = (0, _tslib.__rest)(_a, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var _b = JSON.parse(current.data), __version = _b._version, __lastChangedAt = _b._lastChangedAt, __deleted = _b._deleted, currentData = (0, _tslib.__rest)(_b, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var data = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        }, previousData), currentData));
        return this.modelInstanceCreator(this.MutationEvent, (0, _tslib.__assign)((0, _tslib.__assign)({}, current), {
            data: data
        }));
    };
    /*
    if a model is using custom timestamp fields
    the custom field names will be stored in the model attributes

    e.g.
    "attributes": [
    {
            "type": "model",
            "properties": {
                "timestamps": {
                    "createdAt": "createdOn",
                    "updatedAt": "updatedOn"
                }
            }
    }
    ]
    */ MutationEventOutbox.prototype.removeTimestampFields = function(model, record) {
        var _a, _b;
        var CREATED_AT_DEFAULT_KEY = 'createdAt';
        var UPDATED_AT_DEFAULT_KEY = 'updatedAt';
        var createdTimestampKey = CREATED_AT_DEFAULT_KEY;
        var updatedTimestampKey = UPDATED_AT_DEFAULT_KEY;
        var modelAttributes = (_a = this.schema.namespaces[0, _util.USER].models[model].attributes) === null || _a === void 0 ? void 0 : _a.find(function(attr) {
            return attr.type === 'model';
        });
        var timestampFieldsMap = (_b = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _b === void 0 ? void 0 : _b.timestamps;
        if (timestampFieldsMap) {
            createdTimestampKey = timestampFieldsMap[CREATED_AT_DEFAULT_KEY];
            updatedTimestampKey = timestampFieldsMap[UPDATED_AT_DEFAULT_KEY];
        }
        delete record[createdTimestampKey];
        delete record[updatedTimestampKey];
        return record;
    };
    return MutationEventOutbox;
}();

},{"tslib":"86BcK","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hZWX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJitteredBackoff", function() {
    return safeJitteredBackoff;
});
parcelHelpers.export(exports, "MutationProcessor", function() {
    return MutationProcessor;
});
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _util = require("../../util");
var _utils = require("../utils");
var _errorMaps = require("./errorMaps");
var MAX_ATTEMPTS = 10;
var logger = new (0, _core.ConsoleLogger)('DataStore');
var MutationProcessor = /** @class */ function() {
    function MutationProcessor(schema, storage, userClasses, outbox, modelInstanceCreator, MutationEvent, amplifyConfig, authModeStrategy, errorHandler, conflictHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.storage = storage;
        this.userClasses = userClasses;
        this.outbox = outbox;
        this.modelInstanceCreator = modelInstanceCreator;
        this.MutationEvent = MutationEvent;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.conflictHandler = conflictHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.processing = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.amplifyContext.InternalAPI = this.amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    MutationProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, 'CREATE'), 1), createMutation = _a[0];
                var _b = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, 'UPDATE'), 1), updateMutation = _b[0];
                var _c = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, 'DELETE'), 1), deleteMutation = _c[0];
                _this.typeQuery.set(model, [
                    createMutation,
                    updateMutation,
                    deleteMutation
                ]);
            });
        });
    };
    MutationProcessor.prototype.isReady = function() {
        return this.observer !== undefined;
    };
    MutationProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            try {
                _this.resume();
            } catch (error) {
                logger.error('mutations processor start error', error);
                throw error;
            }
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        // The observer has unsubscribed and/or `stop()` has been called.
                        this.removeObserver();
                        this.pause();
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return observable;
    };
    MutationProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.removeObserver();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.removeObserver = function() {
        var _a, _b;
        (_b = (_a = this.observer) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
        this.observer = undefined;
    };
    MutationProcessor.prototype.resume = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var head, namespaceName, _loop_1, this_1, _$_a;
                                    var _this = this;
                                    var _b, _c;
                                    return (0, _tslib.__generator)(this, function(_d) {
                                        switch(_d.label){
                                            case 0:
                                                if (this.processing || !this.isReady() || !this.runningProcesses.isOpen) return [
                                                    2 /*return*/ 
                                                ];
                                                this.processing = true;
                                                namespaceName = (0, _util.USER);
                                                _loop_1 = function _loop_1() {
                                                    var model, operation, data, condition, modelConstructor, result, opName, modelDefinition, modelAuthModes, operationAuthModes_1, authModeAttempts_1, authModeRetry_1, error_1, record, hasMore;
                                                    var _$_a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                model = head.model, operation = head.operation, data = head.data, condition = head.condition;
                                                                modelConstructor = this_1.userClasses[model];
                                                                result = undefined;
                                                                opName = undefined;
                                                                modelDefinition = undefined;
                                                                _b.label = 1;
                                                            case 1:
                                                                _b.trys.push([
                                                                    1,
                                                                    4,
                                                                    ,
                                                                    5
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    (0, _utils.getModelAuthModes)({
                                                                        authModeStrategy: this_1.authModeStrategy,
                                                                        defaultAuthMode: this_1.amplifyConfig.aws_appsync_authenticationType,
                                                                        modelName: model,
                                                                        schema: this_1.schema
                                                                    })
                                                                ];
                                                            case 2:
                                                                modelAuthModes = _b.sent();
                                                                operationAuthModes_1 = modelAuthModes[operation.toUpperCase()];
                                                                authModeAttempts_1 = 0;
                                                                authModeRetry_1 = function() {
                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                        var response, error_2, e_1;
                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                            switch(_a.label){
                                                                                case 0:
                                                                                    _a.trys.push([
                                                                                        0,
                                                                                        2,
                                                                                        ,
                                                                                        9
                                                                                    ]);
                                                                                    logger.debug("Attempting mutation with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.jitteredRetry(namespaceName, model, operation, data, condition, modelConstructor, this.MutationEvent, head, operationAuthModes_1[authModeAttempts_1], onTerminate)
                                                                                    ];
                                                                                case 1:
                                                                                    response = _a.sent();
                                                                                    logger.debug("Mutation sent successfully with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        response
                                                                                    ];
                                                                                case 2:
                                                                                    error_2 = _a.sent();
                                                                                    authModeAttempts_1++;
                                                                                    if (!(authModeAttempts_1 >= operationAuthModes_1.length)) return [
                                                                                        3 /*break*/ ,
                                                                                        7
                                                                                    ];
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1]);
                                                                                    _a.label = 3;
                                                                                case 3:
                                                                                    _a.trys.push([
                                                                                        3,
                                                                                        5,
                                                                                        ,
                                                                                        6
                                                                                    ]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.errorHandler({
                                                                                            recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                                                            localModel: null,
                                                                                            message: error_2.message,
                                                                                            model: modelConstructor.name,
                                                                                            operation: opName,
                                                                                            errorType: (0, _errorMaps.getMutationErrorType)(error_2),
                                                                                            process: (0, _types.ProcessName).sync,
                                                                                            remoteModel: null,
                                                                                            cause: error_2
                                                                                        })
                                                                                    ];
                                                                                case 4:
                                                                                    _a.sent();
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 5:
                                                                                    e_1 = _a.sent();
                                                                                    logger.error('Mutation error handler failed with:', e_1);
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 6:
                                                                                    throw error_2;
                                                                                case 7:
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1] + ". Retrying with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        authModeRetry_1()
                                                                                    ];
                                                                                case 8:
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        _a.sent()
                                                                                    ];
                                                                                case 9:
                                                                                    return [
                                                                                        2 /*return*/ 
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                };
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    authModeRetry_1()
                                                                ];
                                                            case 3:
                                                                _$_a = (0, _tslib.__read).apply(void 0, [
                                                                    _b.sent(),
                                                                    3
                                                                ]), result = _$_a[0], opName = _$_a[1], modelDefinition = _$_a[2];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 4:
                                                                error_1 = _b.sent();
                                                                if (error_1.message === 'Offline' || error_1.message === 'RetryMutation') return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 5:
                                                                if (!(result === undefined)) return [
                                                                    3 /*break*/ ,
                                                                    7
                                                                ];
                                                                logger.debug('done retrying');
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage)
                                                                                        ];
                                                                                    case 1:
                                                                                        _a.sent();
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 6:
                                                                _b.sent();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                            case 7:
                                                                record = result.data[opName];
                                                                hasMore = false;
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage, record, operation)
                                                                                        ];
                                                                                    case 1:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        _a.sent();
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.peek(storage)
                                                                                        ];
                                                                                    case 2:
                                                                                        hasMore = _a.sent() !== undefined;
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 8:
                                                                _b.sent();
                                                                (_c = (_b = this_1.observer) === null || _b === void 0 ? void 0 : _b.next) === null || _c === void 0 || _c.call(_b, {
                                                                    operation: operation,
                                                                    modelDefinition: modelDefinition,
                                                                    model: record,
                                                                    hasMore: hasMore
                                                                });
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                };
                                                this_1 = this;
                                                _d.label = 1;
                                            case 1:
                                                _$_a = this.processing && this.runningProcesses.isOpen;
                                                if (!_$_a) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.outbox.peek(this.storage)
                                                ];
                                            case 2:
                                                _$_a = (head = _d.sent()) !== undefined;
                                                _d.label = 3;
                                            case 3:
                                                if (!_$_a) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    5 /*yield**/ ,
                                                    _loop_1()
                                                ];
                                            case 4:
                                                _d.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 5:
                                                // pauses itself
                                                this.pause();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, 'mutation resume loop')
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.jitteredRetry = function(namespaceName, model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent, authMode, onTerminate) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.retry)(function(model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _$_a, query, variables, graphQLCondition, opName, modelDefinition, authToken, tryWith, attempt, opType, customUserAgentDetails, result, err_1, _b, error, _c, _d, code, retryWith, err_2, _e, _f, opName_1, query_1, authToken_1, serverData, namespace, updatedMutation;
                                    var _g;
                                    return (0, _tslib.__generator)(this, function(_h) {
                                        switch(_h.label){
                                            case 0:
                                                _$_a = (0, _tslib.__read)(this.createQueryVariables(namespaceName, model, operation, data, condition), 5), query = _$_a[0], variables = _$_a[1], graphQLCondition = _$_a[2], opName = _$_a[3], modelDefinition = _$_a[4];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _h.sent();
                                                tryWith = {
                                                    query: query,
                                                    variables: variables,
                                                    authMode: authMode,
                                                    authToken: authToken
                                                };
                                                attempt = 0;
                                                opType = this.opTypeFromTransformerOperation(operation);
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                _h.label = 2;
                                            case 2:
                                                _h.trys.push([
                                                    2,
                                                    4,
                                                    ,
                                                    17
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql(tryWith, undefined, customUserAgentDetails)
                                                ];
                                            case 3:
                                                result = _h.sent();
                                                // Use `as any` because TypeScript doesn't seem to like passing tuples
                                                // through generic params.
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        result,
                                                        opName,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 4:
                                                err_1 = _h.sent();
                                                if (!(err_1.errors && err_1.errors.length > 0)) return [
                                                    3 /*break*/ ,
                                                    15
                                                ];
                                                _b = (0, _tslib.__read)(err_1.errors, 1), error = _b[0];
                                                _c = error.originalError, _d = (_c === void 0 ? {} : _c).code, code = _d === void 0 ? null : _d;
                                                if (error.errorType === 'Unauthorized') throw new (0, _core.NonRetryableError)('Unauthorized');
                                                if (error.message === 'Network Error' || code === 'ECONNABORTED' // refers to axios timeout error caused by device's bad network condition
                                                ) {
                                                    if (!this.processing) throw new (0, _core.NonRetryableError)('Offline');
                                                    // TODO: Check errors on different env (react-native or other browsers)
                                                    throw new Error('Network Error');
                                                }
                                                if (!(error.errorType === 'ConflictUnhandled')) return [
                                                    3 /*break*/ ,
                                                    13
                                                ];
                                                // TODO: add on ConflictConditionalCheck error query last from server
                                                attempt++;
                                                retryWith = void 0;
                                                if (!(attempt > MAX_ATTEMPTS)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                retryWith = (0, _types.DISCARD);
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 5:
                                                _h.trys.push([
                                                    5,
                                                    7,
                                                    ,
                                                    8
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.conflictHandler({
                                                        modelConstructor: modelConstructor,
                                                        localModel: this.modelInstanceCreator(modelConstructor, variables.input),
                                                        remoteModel: this.modelInstanceCreator(modelConstructor, error.data),
                                                        operation: opType,
                                                        attempts: attempt
                                                    })
                                                ];
                                            case 6:
                                                retryWith = _h.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 7:
                                                err_2 = _h.sent();
                                                logger.warn('conflict trycatch', err_2);
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 8:
                                                if (!(retryWith === (0, _types.DISCARD))) return [
                                                    3 /*break*/ ,
                                                    11
                                                ];
                                                _e = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(this.schema.namespaces[namespaceName], modelDefinition, 'GET'), 1), _f = (0, _tslib.__read)(_e[0], 3), opName_1 = _f[1], query_1 = _f[2];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 9:
                                                authToken_1 = _h.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query_1,
                                                        variables: {
                                                            id: variables.input.id
                                                        },
                                                        authMode: authMode,
                                                        authToken: authToken_1
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 10:
                                                serverData = _h.sent();
                                                // onTerminate cancel graphql()
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        serverData,
                                                        opName_1,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 11:
                                                namespace = this.schema.namespaces[namespaceName];
                                                updatedMutation = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, modelDefinition, opType, modelConstructor, retryWith, graphQLCondition, MutationEvent, this.modelInstanceCreator, mutationEvent.id);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.storage.save(updatedMutation)
                                                ];
                                            case 12:
                                                _h.sent();
                                                throw new (0, _core.NonRetryableError)('RetryMutation');
                                            case 13:
                                                try {
                                                    this.errorHandler({
                                                        recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                        localModel: variables.input,
                                                        message: error.message,
                                                        operation: operation,
                                                        errorType: (0, _errorMaps.getMutationErrorType)(error),
                                                        errorInfo: error.errorInfo,
                                                        process: (0, _types.ProcessName).mutate,
                                                        cause: error,
                                                        remoteModel: error.data ? this.modelInstanceCreator(modelConstructor, error.data) : null
                                                    });
                                                } catch (err) {
                                                    logger.warn('Mutation error handler failed with:', err);
                                                } finally{
                                                    // Return empty tuple, dequeues the mutation
                                                    return [
                                                        2 /*return*/ ,
                                                        error.data ? [
                                                            {
                                                                data: (_g = {}, _g[opName] = error.data, _g)
                                                            },
                                                            opName,
                                                            modelDefinition
                                                        ] : []
                                                    ];
                                                }
                                                _h.label = 14;
                                            case 14:
                                                return [
                                                    3 /*break*/ ,
                                                    16
                                                ];
                                            case 15:
                                                // Catch-all for client-side errors that don't come back in the `GraphQLError` format.
                                                // These errors should not be retried.
                                                throw new (0, _core.NonRetryableError)(err_1);
                                            case 16:
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 17:
                                                if (tryWith) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _h.label = 18;
                                            case 18:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                model,
                                operation,
                                data,
                                condition,
                                modelConstructor,
                                MutationEvent,
                                mutationEvent
                            ], safeJitteredBackoff, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.createQueryVariables = function(namespaceName, model, operation, data, condition) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _d, _e;
        var modelDefinition = this.schema.namespaces[namespaceName].models[model];
        var primaryKey = this.schema.namespaces[namespaceName].keys[model].primaryKey;
        var auth = (_d = modelDefinition.attributes) === null || _d === void 0 ? void 0 : _d.find(function(a) {
            return a.type === 'auth';
        });
        var ownerFields = ((_e = auth === null || auth === void 0 ? void 0 : auth.properties) === null || _e === void 0 ? void 0 : _e.rules.map(function(rule) {
            return rule.ownerField;
        }).filter(function(f) {
            return f;
        })) || [
            'owner'
        ];
        var queriesTuples = this.typeQuery.get(modelDefinition);
        var _f = (0, _tslib.__read)(queriesTuples.find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), transformerMutationType = _b[0];
            return transformerMutationType === operation;
        }), 3), opName = _f[1], query = _f[2];
        var _g = JSON.parse(data), _version = _g._version, parsedData = (0, _tslib.__rest)(_g, [
            "_version"
        ]);
        // include all the fields that comprise a custom PK if one is specified
        var deleteInput = {};
        if (primaryKey === null || primaryKey === void 0 ? void 0 : primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                deleteInput[pkField] = parsedData[pkField];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        else deleteInput[0, _util.ID] = parsedData.id;
        var mutationInput;
        if (operation === (0, _utils.TransformerMutationType).DELETE) // For DELETE mutations, only the key(s) are included in the input
        mutationInput = deleteInput;
        else {
            // Otherwise, we construct the mutation input with the following logic
            mutationInput = {};
            var modelFields = Object.values(modelDefinition.fields);
            try {
                for(var modelFields_1 = (0, _tslib.__values)(modelFields), modelFields_1_1 = modelFields_1.next(); !modelFields_1_1.done; modelFields_1_1 = modelFields_1.next()){
                    var _h = modelFields_1_1.value, name_1 = _h.name, type = _h.type, association = _h.association, isReadOnly = _h.isReadOnly;
                    // omit readonly fields. cloud storage doesn't need them and won't take them!
                    if (isReadOnly) continue;
                    // omit owner fields if it's `null`. cloud storage doesn't allow it.
                    if (ownerFields.includes(name_1) && parsedData[name_1] === null) continue;
                    // model fields should be stripped out from the input
                    if ((0, _types.isModelFieldType)(type)) {
                        // except for belongs to relations - we need to replace them with the correct foreign key(s)
                        if ((0, _types.isTargetNameAssociation)(association) && association.connectionType === 'BELONGS_TO') {
                            var targetNames = (0, _util.extractTargetNamesFromSrc)(association);
                            if (targetNames) try {
                                // instead of including the connected model itself, we add its key(s) to the mutation input
                                for(var targetNames_1 = (e_4 = void 0, (0, _tslib.__values)(targetNames)), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                                    var targetName = targetNames_1_1.value;
                                    mutationInput[targetName] = parsedData[targetName];
                                }
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (targetNames_1_1 && !targetNames_1_1.done && (_c = targetNames_1.return)) _c.call(targetNames_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                        }
                        continue;
                    }
                    // scalar fields / non-model types
                    if (operation === (0, _utils.TransformerMutationType).UPDATE) {
                        if (!parsedData.hasOwnProperty(name_1)) continue;
                    }
                    // all other fields are added to the input object
                    mutationInput[name_1] = parsedData[name_1];
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (modelFields_1_1 && !modelFields_1_1.done && (_b = modelFields_1.return)) _b.call(modelFields_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        }
        // Build mutation variables input object
        var input = (0, _tslib.__assign)((0, _tslib.__assign)({}, mutationInput), {
            _version: _version
        });
        var graphQLCondition = JSON.parse(condition);
        var variables = (0, _tslib.__assign)({
            input: input
        }, operation === (0, _utils.TransformerMutationType).CREATE ? {} : {
            condition: Object.keys(graphQLCondition).length > 0 ? graphQLCondition : null
        });
        return [
            query,
            variables,
            graphQLCondition,
            opName,
            modelDefinition
        ];
    };
    MutationProcessor.prototype.opTypeFromTransformerOperation = function(operation) {
        switch(operation){
            case (0, _utils.TransformerMutationType).CREATE:
                return (0, _types.OpType).INSERT;
            case (0, _utils.TransformerMutationType).DELETE:
                return (0, _types.OpType).DELETE;
            case (0, _utils.TransformerMutationType).UPDATE:
                return (0, _types.OpType).UPDATE;
            case (0, _utils.TransformerMutationType).GET:
                break;
            default:
                throw new Error("Invalid operation " + operation);
        }
        // because it makes TS happy ...
        return undefined;
    };
    MutationProcessor.prototype.pause = function() {
        this.processing = false;
    };
    return MutationProcessor;
}();
var MAX_RETRY_DELAY_MS = 300000;
var originalJitteredBackoff = (0, _core.jitteredBackoff)(MAX_RETRY_DELAY_MS);
var safeJitteredBackoff = function safeJitteredBackoff(attempt, _args, error) {
    var attemptResult = originalJitteredBackoff(attempt);
    // If this is the last attempt and it is a network error, we retry indefinitively every 5 minutes
    if (attemptResult === false && (error === null || error === void 0 ? void 0 : error.message) === 'Network Error') return MAX_RETRY_DELAY_MS;
    return attemptResult;
};

},{"tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","@aws-amplify/core":"3rlh1","zen-observable-ts":"57mma","../../types":"9W0ar","../../util":"iFXfl","../utils":"3udIx","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k8bnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mutationErrorMap", function() {
    return mutationErrorMap;
});
parcelHelpers.export(exports, "subscriptionErrorMap", function() {
    return subscriptionErrorMap;
});
parcelHelpers.export(exports, "syncErrorMap", function() {
    return syncErrorMap;
});
parcelHelpers.export(exports, "getMutationErrorType", function() {
    return getMutationErrorType;
});
parcelHelpers.export(exports, "getSubscriptionErrorType", function() {
    return getSubscriptionErrorType;
});
parcelHelpers.export(exports, "getSyncErrorType", function() {
    return getSyncErrorType;
});
/**
 * Categorizes an error with a broad error type, intended to make
 * customer error handling code simpler.
 * @param errorMap Error names and a list of patterns that indicate them (each pattern as a regex or function)
 * @param error The underying error to categorize.
 */ parcelHelpers.export(exports, "mapErrorToType", function() {
    return mapErrorToType;
});
var _tslib = require("tslib");
var connectionTimeout = function connectionTimeout(error) {
    return /^Connection failed: Connection Timeout/.test(error.message);
};
var serverError = function serverError(error) {
    return /^Error: Request failed with status code 5\d\d/.test(error.message);
};
var mutationErrorMap = {
    BadModel: function BadModel() {
        return false;
    },
    BadRecord: function BadRecord(error) {
        var message = error.message;
        return /^Cannot return \w+ for [\w-_]+ type/.test(message) || /^Variable '.+' has coerced Null value for NonNull type/.test(message); // newly required field, out of date client
    },
    ConfigError: function ConfigError() {
        return false;
    },
    Transient: function Transient(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function Unauthorized(error) {
        return error.message === 'Unauthorized' || /^Request failed with status code 401/.test(error.message);
    }
};
var subscriptionErrorMap = {
    BadModel: function BadModel() {
        return false;
    },
    BadRecord: function BadRecord() {
        return false;
    },
    ConfigError: function ConfigError() {
        return false;
    },
    Transient: function Transient(observableError) {
        var error = unwrapObservableError(observableError);
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function Unauthorized(observableError) {
        var error = unwrapObservableError(observableError);
        return /Connection failed.+Unauthorized/.test(error.message);
    }
};
var syncErrorMap = {
    BadModel: function BadModel() {
        return false;
    },
    BadRecord: function BadRecord(error) {
        return /^Cannot return \w+ for [\w-_]+ type/.test(error.message);
    },
    ConfigError: function ConfigError() {
        return false;
    },
    Transient: function Transient(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function Unauthorized(error) {
        return error.errorType === 'Unauthorized';
    }
};
/**
 * Get the first error reason of an observable.
 * Allows for error maps to be easily applied to observable errors
 *
 * @param observableError an error from ZenObservable subscribe error callback
 */ function unwrapObservableError(observableError) {
    var _a = observableError.error, _b = (0, _tslib.__read)((_a === void 0 ? {
        errors: []
    } : _a).errors, 1), error = _b[0];
    return error;
}
function getMutationErrorType(error) {
    return mapErrorToType(mutationErrorMap, error);
}
function getSubscriptionErrorType(error) {
    return mapErrorToType(subscriptionErrorMap, error);
}
function getSyncErrorType(error) {
    return mapErrorToType(syncErrorMap, error);
}
function mapErrorToType(errorMap, error) {
    var e_1, _a;
    var errorTypes = (0, _tslib.__spread)(Object.keys(errorMap));
    try {
        for(var errorTypes_1 = (0, _tslib.__values)(errorTypes), errorTypes_1_1 = errorTypes_1.next(); !errorTypes_1_1.done; errorTypes_1_1 = errorTypes_1.next()){
            var errorType = errorTypes_1_1.value;
            var matcher = errorMap[errorType];
            if (matcher === null || matcher === void 0 ? void 0 : matcher(error)) return errorType;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (errorTypes_1_1 && !errorTypes_1_1.done && (_a = errorTypes_1.return)) _a.call(errorTypes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return 'Unknown';
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j7cif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", function() {
    return CONTROL_MSG;
});
parcelHelpers.export(exports, "USER_CREDENTIALS", function() {
    return USER_CREDENTIALS;
});
parcelHelpers.export(exports, "SubscriptionProcessor", function() {
    return SubscriptionProcessor;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _predicates = require("../../predicates");
var _util = require("../../util");
var _errorMaps = require("./errorMaps");
var Buffer = require("a5da572164cb8f31").Buffer;
var logger = new (0, _core.ConsoleLogger)('DataStore');
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTED"] = "CONNECTED";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var USER_CREDENTIALS;
(function(USER_CREDENTIALS) {
    USER_CREDENTIALS[USER_CREDENTIALS["none"] = 0] = "none";
    USER_CREDENTIALS[USER_CREDENTIALS["unauth"] = 1] = "unauth";
    USER_CREDENTIALS[USER_CREDENTIALS["auth"] = 2] = "auth";
})(USER_CREDENTIALS || (USER_CREDENTIALS = {}));
var SubscriptionProcessor = /** @class */ function() {
    function SubscriptionProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        if (amplifyContext === void 0) amplifyContext = {
            Auth: (0, _auth.Auth),
            InternalAPI: (0, _internals.InternalAPI),
            Cache: (0, _cache.Cache)
        };
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.buffer = [];
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
    }
    SubscriptionProcessor.prototype.buildSubscription = function(namespace, model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload, authMode, filterArg) {
        if (filterArg === void 0) filterArg = false;
        var aws_appsync_authenticationType = this.amplifyConfig.aws_appsync_authenticationType;
        var _a = this.getAuthorizationInfo(model, userCredentials, aws_appsync_authenticationType, cognitoTokenPayload, oidcTokenPayload, authMode) || {}, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue;
        var _b = (0, _tslib.__read)((0, _utils.buildSubscriptionGraphQLOperation)(namespace, model, transformerMutationType, isOwner, ownerField, filterArg), 3), opType = _b[0], opName = _b[1], query = _b[2];
        return {
            authMode: authMode,
            opType: opType,
            opName: opName,
            query: query,
            isOwner: isOwner,
            ownerField: ownerField,
            ownerValue: ownerValue
        };
    };
    SubscriptionProcessor.prototype.getAuthorizationInfo = function(model, userCredentials, defaultAuthType, cognitoTokenPayload, oidcTokenPayload, authMode) {
        if (cognitoTokenPayload === void 0) cognitoTokenPayload = {};
        if (oidcTokenPayload === void 0) oidcTokenPayload = {};
        var rules = (0, _utils.getAuthorizationRules)(model);
        // Return null if user doesn't have proper credentials for private API with IAM auth
        var iamPrivateAuth = authMode === (0, _api.GRAPHQL_AUTH_MODE).AWS_IAM && rules.find(function(rule) {
            return rule.authStrategy === 'private' && rule.provider === 'iam';
        });
        if (iamPrivateAuth && userCredentials === USER_CREDENTIALS.unauth) return null;
        // Group auth should take precedence over owner auth, so we are checking
        // if rule(s) have group authorization as well as if either the Cognito or
        // OIDC token has a groupClaim. If so, we are returning auth info before
        // any further owner-based auth checks.
        var groupAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === 'groups' && [
                'userPools',
                'oidc'
            ].includes(rule.provider);
        });
        var validGroup = (authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS || authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT) && groupAuthRules.find(function(groupAuthRule) {
            // validate token against groupClaim
            var cognitoUserGroups = (0, _utils.getUserGroupsFromToken)(cognitoTokenPayload, groupAuthRule);
            var oidcUserGroups = (0, _utils.getUserGroupsFromToken)(oidcTokenPayload, groupAuthRule);
            return (0, _tslib.__spread)(cognitoUserGroups, oidcUserGroups).find(function(userGroup) {
                return groupAuthRule.groups.find(function(group) {
                    return group === userGroup;
                });
            });
        });
        if (validGroup) return {
            authMode: authMode,
            isOwner: false
        };
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the Cognito token via the
        // identityClaim from the auth rule.
        var cognitoOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS ? rules.filter(function(rule) {
            return rule.authStrategy === 'owner' && rule.provider === 'userPools';
        }) : [];
        var ownerAuthInfo;
        cognitoOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = cognitoTokenPayload[ownerAuthRule.identityClaim];
            // AuthZ for "list of owners" is handled dynamically in the subscription auth request
            // resolver. It doesn't rely on a subscription arg.
            // Only pass a subscription arg for single owner auth
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the OIDC token via the
        // identityClaim from the auth rule.
        var oidcOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT ? rules.filter(function(rule) {
            return rule.authStrategy === 'owner' && rule.provider === 'oidc';
        }) : [];
        oidcOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = oidcTokenPayload[ownerAuthRule.identityClaim];
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Fallback: return authMode or default auth type
        return {
            authMode: authMode || defaultAuthType,
            isOwner: false
        };
    };
    SubscriptionProcessor.prototype.hubQueryCompletionListener = function(completed, capsule) {
        var event = capsule.payload.event;
        if (event === (0, _pubsub.CONTROL_MSG).SUBSCRIPTION_ACK) completed();
    };
    SubscriptionProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = this.runningProcesses || new (0, _core.BackgroundProcessManager)();
        var ctlObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var promises = [];
            // Creating subs for each model/operation combo so they can be unsubscribed
            // independently, since the auth retry behavior is asynchronous.
            var subscriptions = {};
            var cognitoTokenPayload, oidcTokenPayload;
            var userCredentials = USER_CREDENTIALS.none;
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var credentials, err_1, session, err_2, _a, aws_cognito_region, AuthConfig, token, federatedInfo, currentUser, payload, err_3;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _b.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentCredentials()
                                ];
                            case 1:
                                credentials = _b.sent();
                                userCredentials = credentials.authenticated ? USER_CREDENTIALS.auth : USER_CREDENTIALS.unauth;
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                _b.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentSession()
                                ];
                            case 4:
                                session = _b.sent();
                                cognitoTokenPayload = session.getIdToken().decodePayload();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                err_2 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                _b.trys.push([
                                    6,
                                    11,
                                    ,
                                    12
                                ]);
                                _a = this.amplifyConfig, aws_cognito_region = _a.aws_cognito_region, AuthConfig = _a.Auth;
                                if (!aws_cognito_region || AuthConfig && !AuthConfig.region) throw 'Auth is not configured';
                                token = void 0;
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Cache.getItem('federatedInfo')
                                ];
                            case 7:
                                federatedInfo = _b.sent();
                                if (!federatedInfo) return [
                                    3 /*break*/ ,
                                    8
                                ];
                                token = federatedInfo.token;
                                return [
                                    3 /*break*/ ,
                                    10
                                ];
                            case 8:
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentAuthenticatedUser()
                                ];
                            case 9:
                                currentUser = _b.sent();
                                if (currentUser) token = currentUser.token;
                                _b.label = 10;
                            case 10:
                                if (token) {
                                    payload = token.split('.')[1];
                                    oidcTokenPayload = JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
                                }
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 11:
                                err_3 = _b.sent();
                                logger.debug('error getting OIDC JWT', err_3);
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 12:
                                Object.values(this.schema.namespaces).forEach(function(namespace) {
                                    Object.values(namespace.models).filter(function(_a) {
                                        var syncable = _a.syncable;
                                        return syncable;
                                    }).forEach(function(modelDefinition) {
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var modelAuthModes, readAuthModes, operations, operationAuthModeAttempts, predicatesGroup, addFilterArg, subscriptionRetry;
                                                var _a, _$_b, _c;
                                                var _this = this;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                (0, _utils.getModelAuthModes)({
                                                                    authModeStrategy: this.authModeStrategy,
                                                                    defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                                                    modelName: modelDefinition.name,
                                                                    schema: this.schema
                                                                })
                                                            ];
                                                        case 1:
                                                            modelAuthModes = _d.sent();
                                                            readAuthModes = modelAuthModes.READ;
                                                            subscriptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, subscriptions), (_a = {}, _a[modelDefinition.name] = (_$_b = {}, _$_b[(0, _utils.TransformerMutationType).CREATE] = [], _$_b[(0, _utils.TransformerMutationType).UPDATE] = [], _$_b[(0, _utils.TransformerMutationType).DELETE] = [], _$_b), _a));
                                                            operations = [
                                                                (0, _utils.TransformerMutationType).CREATE,
                                                                (0, _utils.TransformerMutationType).UPDATE,
                                                                (0, _utils.TransformerMutationType).DELETE
                                                            ];
                                                            operationAuthModeAttempts = (_c = {}, _c[(0, _utils.TransformerMutationType).CREATE] = 0, _c[(0, _utils.TransformerMutationType).UPDATE] = 0, _c[(0, _utils.TransformerMutationType).DELETE] = 0, _c);
                                                            predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(modelDefinition), false);
                                                            addFilterArg = predicatesGroup !== undefined;
                                                            subscriptionRetry = function(operation, addFilter) {
                                                                if (addFilter === void 0) addFilter = addFilterArg;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var _a, transformerMutationType, opName, query, isOwner, ownerField, ownerValue, authMode, authToken, variables, customUserAgentDetails, queryObservable, subscriptionReadyCallback;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                _a = this.buildSubscription(namespace, modelDefinition, operation, userCredentials, cognitoTokenPayload, oidcTokenPayload, readAuthModes[operationAuthModeAttempts[operation]], addFilter), transformerMutationType = _a.opType, opName = _a.opName, query = _a.query, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue, authMode = _a.authMode;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                                                ];
                                                                            case 1:
                                                                                authToken = _b.sent();
                                                                                variables = {};
                                                                                customUserAgentDetails = {
                                                                                    category: (0, _core.Category).DataStore,
                                                                                    action: (0, _core.DataStoreAction).Subscribe
                                                                                };
                                                                                if (addFilter && predicatesGroup) variables['filter'] = (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
                                                                                if (isOwner) {
                                                                                    if (!ownerValue) {
                                                                                        observer.error('Owner field required, sign in is needed in order to perform this operation');
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                    }
                                                                                    variables[ownerField] = ownerValue;
                                                                                }
                                                                                logger.debug("Attempting " + operation + " subscription with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                queryObservable = this.amplifyContext.InternalAPI.graphql((0, _tslib.__assign)((0, _tslib.__assign)({
                                                                                    query: query,
                                                                                    variables: variables
                                                                                }, {
                                                                                    authMode: authMode
                                                                                }), {
                                                                                    authToken: authToken
                                                                                }), undefined, customUserAgentDetails);
                                                                                // TODO: consider onTerminate.then(() => API.cancel(...))
                                                                                subscriptions[modelDefinition.name][transformerMutationType].push(queryObservable.map(function(_a) {
                                                                                    var value = _a.value;
                                                                                    return value;
                                                                                }).subscribe({
                                                                                    next: function next(_a) {
                                                                                        var data = _a.data, errors = _a.errors;
                                                                                        if (Array.isArray(errors) && errors.length > 0) {
                                                                                            var messages = errors.map(function(_a) {
                                                                                                var message = _a.message;
                                                                                                return message;
                                                                                            });
                                                                                            logger.warn("Skipping incoming subscription. Messages: " + messages.join('\n'));
                                                                                            _this.drainBuffer();
                                                                                            return;
                                                                                        }
                                                                                        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(_this.syncPredicates.get(modelDefinition), false);
                                                                                        // @ts-ignore
                                                                                        var _$_b = data, _c = opName, record = _$_b[_c];
                                                                                        // checking incoming subscription against syncPredicate.
                                                                                        // once AppSync implements filters on subscriptions, we'll be
                                                                                        // able to set these when establishing the subscription instead.
                                                                                        // Until then, we'll need to filter inbound
                                                                                        if (_this.passesPredicateValidation(record, predicatesGroup)) _this.pushToBuffer(transformerMutationType, modelDefinition, record);
                                                                                        _this.drainBuffer();
                                                                                    },
                                                                                    error: function error(subscriptionError) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var _a, _$_b, _c, _$_d, message, isRTFError, e_1;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        _a = subscriptionError.error, _$_b = (0, _tslib.__read)((_a === void 0 ? {
                                                                                                            errors: []
                                                                                                        } : _a).errors, 1), _c = _$_b[0], _$_d = (_c === void 0 ? {} : _c).message, message = _$_d === void 0 ? '' : _$_d;
                                                                                                        isRTFError = // only attempt catch if a filter variable was added to the subscription query
                                                                                                        addFilter && this.catchRTFError(message, modelDefinition, predicatesGroup);
                                                                                                        // Catch RTF errors
                                                                                                        if (isRTFError) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            // retry subscription connection without filter
                                                                                                            subscriptionRetry(operation, false);
                                                                                                            return [
                                                                                                                2 /*return*/ 
                                                                                                            ];
                                                                                                        }
                                                                                                        if (message.includes((0, _pubsub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR) || message.includes((0, _pubsub.CONTROL_MSG).CONNECTION_FAILED)) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            operationAuthModeAttempts[operation]++;
                                                                                                            if (operationAuthModeAttempts[operation] >= readAuthModes.length) // last auth mode retry. Continue with error
                                                                                                            logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1]);
                                                                                                            else {
                                                                                                                // retry with different auth mode. Do not trigger
                                                                                                                // observer error or error handler
                                                                                                                logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1] + ". Retrying with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                                                subscriptionRetry(operation);
                                                                                                                return [
                                                                                                                    2 /*return*/ 
                                                                                                                ];
                                                                                                            }
                                                                                                        }
                                                                                                        logger.warn('subscriptionError', message);
                                                                                                        _e.label = 1;
                                                                                                    case 1:
                                                                                                        _e.trys.push([
                                                                                                            1,
                                                                                                            3,
                                                                                                            ,
                                                                                                            4
                                                                                                        ]);
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.errorHandler({
                                                                                                                recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                                                                                localModel: null,
                                                                                                                message: message,
                                                                                                                model: modelDefinition.name,
                                                                                                                operation: operation,
                                                                                                                errorType: (0, _errorMaps.getSubscriptionErrorType)(subscriptionError),
                                                                                                                process: (0, _types.ProcessName).subscribe,
                                                                                                                remoteModel: null,
                                                                                                                cause: subscriptionError
                                                                                                            })
                                                                                                        ];
                                                                                                    case 2:
                                                                                                        _e.sent();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 3:
                                                                                                        e_1 = _e.sent();
                                                                                                        logger.error('Subscription error handler failed with:', e_1);
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        if (typeof subscriptionReadyCallback === 'function') subscriptionReadyCallback();
                                                                                                        if (message.includes('"errorType":"Unauthorized"') || message.includes('"errorType":"OperationDisabled"')) return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                        observer.error(message);
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                }));
                                                                                promises.push(function() {
                                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                        var boundFunction;
                                                                                        var _this = this;
                                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                                            switch(_a.label){
                                                                                                case 0:
                                                                                                    return [
                                                                                                        4 /*yield*/ ,
                                                                                                        new Promise(function(res) {
                                                                                                            subscriptionReadyCallback = res;
                                                                                                            boundFunction = _this.hubQueryCompletionListener.bind(_this, res);
                                                                                                            (0, _core.Hub).listen('api', boundFunction);
                                                                                                        })
                                                                                                    ];
                                                                                                case 1:
                                                                                                    _a.sent();
                                                                                                    (0, _core.Hub).remove('api', boundFunction);
                                                                                                    return [
                                                                                                        2 /*return*/ 
                                                                                                    ];
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                }());
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            };
                                                            operations.forEach(function(op) {
                                                                return subscriptionRetry(op);
                                                            });
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                                this.runningProcesses.isOpen && this.runningProcesses.add(function() {
                                    return Promise.all(promises).then(function() {
                                        observer.next(CONTROL_MSG.CONNECTED);
                                    });
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, 'subscription processor new subscriber');
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        Object.keys(subscriptions).forEach(function(modelName) {
                            subscriptions[modelName][(0, _utils.TransformerMutationType).CREATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).UPDATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).DELETE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        var dataObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.dataObserver = observer;
            _this.drainBuffer();
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        this.dataObserver = null;
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return [
            ctlObservable,
            dataObservable
        ];
    };
    SubscriptionProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SubscriptionProcessor.prototype.passesPredicateValidation = function(record, predicatesGroup) {
        if (!predicatesGroup) return true;
        var predicates = predicatesGroup.predicates, type = predicatesGroup.type;
        return (0, _util.validatePredicate)(record, type, predicates);
    };
    SubscriptionProcessor.prototype.pushToBuffer = function(transformerMutationType, modelDefinition, data) {
        this.buffer.push([
            transformerMutationType,
            modelDefinition,
            data
        ]);
    };
    SubscriptionProcessor.prototype.drainBuffer = function() {
        var _this = this;
        if (this.dataObserver) {
            this.buffer.forEach(function(data) {
                return _this.dataObserver.next(data);
            });
            this.buffer = [];
        }
    };
    /**
     * @returns true if the service returned an RTF subscription error
     * @remarks logs a warning with remediation instructions
     *
     */ SubscriptionProcessor.prototype.catchRTFError = function(message, modelDefinition, predicatesGroup) {
        var header = "Backend subscriptions filtering error.\nSubscriptions filtering will be applied clientside.\n";
        var messageErrorTypeMap = {
            'UnknownArgument: Unknown field argument filter': (0, _utils.RTFError).UnknownField,
            'Filters exceed maximum attributes limit': (0, _utils.RTFError).MaxAttributes,
            'Filters combination exceed maximum limit': (0, _utils.RTFError).MaxCombinations,
            'filter uses same fieldName multiple time': (0, _utils.RTFError).RepeatedFieldname,
            "The variables input contains a field name 'not'": (0, _utils.RTFError).NotGroup,
            'The variables input contains a field that is not defined for input object type': (0, _utils.RTFError).FieldNotInType
        };
        var _a = (0, _tslib.__read)(Object.entries(messageErrorTypeMap).find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), errorMsg = _b[0];
            return message.includes(errorMsg);
        }) || [], 2), _errorMsg = _a[0], errorType = _a[1];
        if (errorType !== undefined) {
            var remediationMessage = (0, _utils.generateRTFRemediation)(errorType, modelDefinition, predicatesGroup);
            logger.warn(header + "\n" + message + "\n" + remediationMessage);
            return true;
        }
        return false;
    };
    return SubscriptionProcessor;
}();

},{"a5da572164cb8f31":"7NC4b","tslib":"86BcK","@aws-amplify/api":"6PDaW","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub":"bJVAp","zen-observable-ts":"57mma","../../types":"9W0ar","../utils":"3udIx","../../predicates":"bohgw","../../util":"iFXfl","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkNXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncProcessor", function() {
    return SyncProcessor;
});
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _errorMaps = require("./errorMaps");
var opResultDefaults = {
    items: [],
    nextToken: null,
    startedAt: null
};
var logger = new (0, _core.ConsoleLogger)('DataStore');
var SyncProcessor = /** @class */ function() {
    function SyncProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        amplifyContext.InternalAPI = amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    SyncProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, 'LIST'), 1), _b = (0, _tslib.__read)(_a[0]), opNameQuery = _b.slice(1);
                _this.typeQuery.set(model, opNameQuery);
            });
        });
    };
    SyncProcessor.prototype.graphqlFilterFromPredicate = function(model) {
        if (!this.syncPredicates) return null;
        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
        if (!predicatesGroup) return null;
        return (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
    };
    SyncProcessor.prototype.retrievePage = function(modelDefinition, lastSync, nextToken, limit, filter, onTerminate) {
        if (limit === void 0) limit = null;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, opName, query, variables, modelAuthModes, readAuthModes, authModeAttempts, authModeRetry, data, _b, _c, opResult, items, newNextToken, startedAt;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _tslib.__read)(this.typeQuery.get(modelDefinition), 2), opName = _a[0], query = _a[1];
                        variables = {
                            limit: limit,
                            nextToken: nextToken,
                            lastSync: lastSync,
                            filter: filter
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _utils.getModelAuthModes)({
                                authModeStrategy: this.authModeStrategy,
                                defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                modelName: modelDefinition.name,
                                schema: this.schema
                            })
                        ];
                    case 1:
                        modelAuthModes = _d.sent();
                        readAuthModes = modelAuthModes.READ;
                        authModeAttempts = 0;
                        authModeRetry = function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var response, error_1, authMode;
                                var _a;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            if (!this.runningProcesses.isOpen) throw new Error('sync.retreievePage termination was requested. Exiting.');
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([
                                                1,
                                                3,
                                                ,
                                                5
                                            ]);
                                            logger.debug("Attempting sync with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                this.jitteredRetry({
                                                    query: query,
                                                    variables: variables,
                                                    opName: opName,
                                                    modelDefinition: modelDefinition,
                                                    authMode: readAuthModes[authModeAttempts],
                                                    onTerminate: onTerminate
                                                })
                                            ];
                                        case 2:
                                            response = _b.sent();
                                            logger.debug("Sync successful with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                2 /*return*/ ,
                                                response
                                            ];
                                        case 3:
                                            error_1 = _b.sent();
                                            authModeAttempts++;
                                            if (authModeAttempts >= readAuthModes.length) {
                                                authMode = readAuthModes[authModeAttempts - 1];
                                                logger.debug("Sync failed with authMode: " + authMode, error_1);
                                                if ((0, _utils.getClientSideAuthError)(error_1) || (0, _utils.getForbiddenError)(error_1)) {
                                                    // return empty list of data so DataStore will continue to sync other models
                                                    logger.warn("User is unauthorized to query " + opName + " with auth mode " + authMode + ". No data could be returned.");
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            data: (_a = {}, _a[opName] = opResultDefaults, _a)
                                                        }
                                                    ];
                                                }
                                                throw error_1;
                                            }
                                            logger.debug("Sync failed with authMode: " + readAuthModes[authModeAttempts - 1] + ". Retrying with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                authModeRetry()
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ ,
                                                _b.sent()
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4 /*yield*/ ,
                            authModeRetry()
                        ];
                    case 2:
                        data = _d.sent().data;
                        _b = data, _c = opName, opResult = _b[_c];
                        items = opResult.items, newNextToken = opResult.nextToken, startedAt = opResult.startedAt;
                        return [
                            2 /*return*/ ,
                            {
                                nextToken: newNextToken,
                                startedAt: startedAt,
                                items: items
                            }
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.jitteredRetry = function(_a) {
        var query = _a.query, variables = _a.variables, opName = _a.opName, modelDefinition = _a.modelDefinition, authMode = _a.authMode, onTerminate = _a.onTerminate;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(function(query, variables) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var authToken, customUserAgentDetails, error_2, clientOrForbiddenErrorMessage, hasItems, unauthorized, otherErrors, result;
                                    var _this = this;
                                    var _$_a, _$_b, _c, _d;
                                    return (0, _tslib.__generator)(this, function(_e) {
                                        switch(_e.label){
                                            case 0:
                                                _e.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    6
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _e.sent();
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query,
                                                        variables: variables,
                                                        authMode: authMode,
                                                        authToken: authToken
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _e.sent()
                                                ];
                                            case 3:
                                                error_2 = _e.sent();
                                                clientOrForbiddenErrorMessage = (0, _utils.getClientSideAuthError)(error_2) || (0, _utils.getForbiddenError)(error_2);
                                                if (clientOrForbiddenErrorMessage) {
                                                    logger.error('Sync processor retry error:', error_2);
                                                    throw new (0, _core.NonRetryableError)(clientOrForbiddenErrorMessage);
                                                }
                                                hasItems = Boolean((_$_b = (_$_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _$_a === void 0 ? void 0 : _$_a[opName]) === null || _$_b === void 0 ? void 0 : _$_b.items);
                                                unauthorized = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.some(function(err) {
                                                    return err.errorType === 'Unauthorized';
                                                });
                                                otherErrors = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.filter(function(err) {
                                                    return err.errorType !== 'Unauthorized';
                                                });
                                                result = error_2;
                                                if (hasItems) result.data[opName].items = result.data[opName].items.filter(function(item) {
                                                    return item !== null;
                                                });
                                                if (!(hasItems && (otherErrors === null || otherErrors === void 0 ? void 0 : otherErrors.length))) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(otherErrors.map(function(err) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var e_1;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        _a.trys.push([
                                                                            0,
                                                                            2,
                                                                            ,
                                                                            3
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.errorHandler({
                                                                                recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                                                localModel: null,
                                                                                message: err.message,
                                                                                model: modelDefinition.name,
                                                                                operation: opName,
                                                                                errorType: (0, _errorMaps.getSyncErrorType)(err),
                                                                                process: (0, _types.ProcessName).sync,
                                                                                remoteModel: null,
                                                                                cause: err
                                                                            })
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 2:
                                                                        e_1 = _a.sent();
                                                                        logger.error('Sync error handler failed with:', e_1);
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 3:
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }))
                                                ];
                                            case 4:
                                                _e.sent();
                                                (0, _core.Hub).dispatch('datastore', {
                                                    event: 'nonApplicableDataReceived',
                                                    data: {
                                                        errors: otherErrors,
                                                        modelName: modelDefinition.name
                                                    }
                                                });
                                                _e.label = 5;
                                            case 5:
                                                /**
                                         * Handle $util.unauthorized() in resolver request mapper, which responses with something
                                         * like this:
                                         *
                                         * ```
                                         * {
                                         * 	data: { syncYourModel: null },
                                         * 	errors: [
                                         * 		{
                                         * 			path: ['syncLegacyJSONComments'],
                                         * 			data: null,
                                         * 			errorType: 'Unauthorized',
                                         * 			errorInfo: null,
                                         * 			locations: [{ line: 2, column: 3, sourceName: null }],
                                         * 			message:
                                         * 				'Not Authorized to access syncYourModel on type Query',
                                         * 			},
                                         * 		],
                                         * 	}
                                         * ```
                                         *
                                         * The correct handling for this is to signal that we've encountered a non-retryable error,
                                         * since the server has responded with an auth error and *NO DATA* at this point.
                                         */ if (unauthorized) {
                                                    this.errorHandler({
                                                        recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                        localModel: null,
                                                        message: error_2.message,
                                                        model: modelDefinition.name,
                                                        operation: opName,
                                                        errorType: (0, _errorMaps.getSyncErrorType)(error_2.errors[0]),
                                                        process: (0, _types.ProcessName).sync,
                                                        remoteModel: null,
                                                        cause: error_2
                                                    });
                                                    throw new (0, _core.NonRetryableError)(error_2);
                                                }
                                                if ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c[opName].items) === null || _d === void 0 ? void 0 : _d.length) return [
                                                    2 /*return*/ ,
                                                    result
                                                ];
                                                throw error_2;
                                            case 6:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                query,
                                variables
                            ], undefined, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.start = function(typesLastSync) {
        var _this = this;
        var _a = this.amplifyConfig, maxRecordsToSync = _a.maxRecordsToSync, syncPageSize = _a.syncPageSize;
        var parentPromises = new Map();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var sortedTypesLastSyncs = Object.values(_this.schema.namespaces).reduce(function(map, namespace) {
                var e_2, _a;
                try {
                    for(var _b = (0, _tslib.__values)(Array.from(namespace.modelTopologicalOrdering.keys())), _c = _b.next(); !_c.done; _c = _b.next()){
                        var modelName = _c.value;
                        var typeLastSync = typesLastSync.get(namespace.models[modelName]);
                        map.set(namespace.models[modelName], typeLastSync);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                return map;
            }, new Map());
            var allModelsReady = Array.from(sortedTypesLastSyncs.entries()).filter(function(_a) {
                var _b = (0, _tslib.__read)(_a, 1), syncable = _b[0].syncable;
                return syncable;
            }).map(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], _c = (0, _tslib.__read)(_b[1], 2), namespace = _c[0], lastSync = _c[1];
                return _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var done, nextToken, startedAt, items, recordsReceived, filter, parents, promises, promise;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    done = false;
                                    nextToken = null;
                                    startedAt = null;
                                    items = null;
                                    recordsReceived = 0;
                                    filter = this.graphqlFilterFromPredicate(modelDefinition);
                                    parents = this.schema.namespaces[namespace].modelTopologicalOrdering.get(modelDefinition.name);
                                    promises = parents.map(function(parent) {
                                        return parentPromises.get(namespace + "_" + parent);
                                    });
                                    promise = new Promise(function(res) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var limit, error_3, e_3;
                                            var _$_a;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        return [
                                                            4 /*yield*/ ,
                                                            Promise.all(promises)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        _b.label = 2;
                                                    case 2:
                                                        /**
                                                     * If `runningProcesses` is not open, it means that the sync processor has been
                                                     * stopped (for example by calling `DataStore.clear()` upstream) and has not yet
                                                     * finished terminating and/or waiting for its background processes to complete.
                                                     */ if (!this.runningProcesses.isOpen) {
                                                            logger.debug("Sync processor has been stopped, terminating sync for " + modelDefinition.name);
                                                            return [
                                                                2 /*return*/ ,
                                                                res()
                                                            ];
                                                        }
                                                        limit = Math.min(maxRecordsToSync - recordsReceived, syncPageSize);
                                                        _b.label = 3;
                                                    case 3:
                                                        _b.trys.push([
                                                            3,
                                                            5,
                                                            ,
                                                            10
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.retrievePage(modelDefinition, lastSync, nextToken, limit, filter, onTerminate)
                                                        ];
                                                    case 4:
                                                        _$_a = _b.sent(), items = _$_a.items, nextToken = _$_a.nextToken, startedAt = _$_a.startedAt;
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 5:
                                                        error_3 = _b.sent();
                                                        _b.label = 6;
                                                    case 6:
                                                        _b.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.errorHandler({
                                                                recoverySuggestion: 'Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues',
                                                                localModel: null,
                                                                message: error_3.message,
                                                                model: modelDefinition.name,
                                                                operation: null,
                                                                errorType: (0, _errorMaps.getSyncErrorType)(error_3),
                                                                process: (0, _types.ProcessName).sync,
                                                                remoteModel: null,
                                                                cause: error_3
                                                            })
                                                        ];
                                                    case 7:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 8:
                                                        e_3 = _b.sent();
                                                        logger.error('Sync error handler failed with:', e_3);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 9:
                                                        /**
                                                     * If there's an error, this model fails, but the rest of the sync should
                                                     * continue. To facilitate this, we explicitly mark this model as `done`
                                                     * with no items and allow the loop to continue organically. This ensures
                                                     * all callbacks (subscription messages) happen as normal, so anything
                                                     * waiting on them knows the model is as done as it can be.
                                                     */ done = true;
                                                        items = [];
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 10:
                                                        recordsReceived += items.length;
                                                        done = nextToken === null || recordsReceived >= maxRecordsToSync;
                                                        observer.next({
                                                            namespace: namespace,
                                                            modelDefinition: modelDefinition,
                                                            items: items,
                                                            done: done,
                                                            startedAt: startedAt,
                                                            isFullSync: !lastSync
                                                        });
                                                        _b.label = 11;
                                                    case 11:
                                                        if (!done) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        _b.label = 12;
                                                    case 12:
                                                        res();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    parentPromises.set(namespace + "_" + modelDefinition.name, promise);
                                    return [
                                        4 /*yield*/ ,
                                        promise
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "adding model " + modelDefinition.name);
            });
            Promise.all(allModelsReady).then(function() {
                observer.complete();
            });
        });
        return observable;
    };
    SyncProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('stopping sync processor');
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        logger.debug('sync processor stopped');
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SyncProcessor;
}();

},{"tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","zen-observable-ts":"57mma","../../types":"9W0ar","../utils":"3udIx","@aws-amplify/core":"3rlh1","../../predicates":"bohgw","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8zsMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "internals", function() {
    return internals;
});
parcelHelpers.export(exports, "FieldCondition", function() {
    return FieldCondition;
});
parcelHelpers.export(exports, "GroupCondition", function() {
    return GroupCondition;
});
/**
 * Creates a "seed" predicate that can be used to build an executable condition.
 * This is used in `query()`, for example, to seed customer- E.g.,
 *
 * ```
 * const p = predicateFor({builder: modelConstructor, schema: modelSchema, pkField: string[]});
 * p.and(child => [
 *   child.field.eq('whatever'),
 *   child.childModel.childField.eq('whatever else'),
 *   child.childModel.or(child => [
 *     child.otherField.contains('x'),
 *     child.otherField.contains('y'),
 *     child.otherField.contains('z'),
 *   ])
 * ])
 * ```
 *
 * `predicateFor()` returns objecst with recursive getters. To facilitate this,
 * a `query` and `tail` can be provided to "accumulate" nested conditions.
 *
 * @param ModelType The ModelMeta used to build child properties.
 * @param field Scopes the query branch to a field.
 * @param query A base query to build on. Omit to start a new query.
 * @param tail The point in an existing `query` to attach new conditions to.
 * @returns A ModelPredicate (builder) that customers can create queries with.
 * (As shown in function description.)
 */ parcelHelpers.export(exports, "recursivePredicateFor", function() {
    return recursivePredicateFor;
});
parcelHelpers.export(exports, "predicateFor", function() {
    return predicateFor;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
var _index = require("./index");
var _relationship = require("../storage/relationship");
var _util = require("../util");
var ops = (0, _tslib.__spread)((0, _index.comparisonKeys));
/**
 * A map from keys (exposed to customers) to the internal predicate data
 * structures invoking code should not muck with.
 */ var predicateInternalsMap = new Map();
/**
 * Creates a link between a key (and generates a key if needed) and an internal
 * `GroupCondition`, which allows us to return a key object instead of the gory
 * conditions details to customers/invoking code.
 *
 * @param condition The internal condition to keep hidden.
 * @param key The object DataStore will use to find the internal condition.
 * If no key is given, an empty one is created.
 */ var registerPredicateInternals = function registerPredicateInternals(condition, key) {
    var finalKey = key || new (0, _types.PredicateInternalsKey)();
    predicateInternalsMap.set(finalKey, condition);
    return finalKey;
};
var internals = function internals(key) {
    if (!predicateInternalsMap.has(key)) throw new Error("Invalid predicate. Terminate your predicate with a valid condition (e.g., `p => p.field.eq('value')`) or pass `Predicates.ALL`.");
    return predicateInternalsMap.get(key);
};
/**
 * Maps operators to negated operators.
 * Used to facilitate propagation of negation down a tree of conditions.
 */ var negations = {
    and: 'or',
    or: 'and',
    not: 'and',
    eq: 'ne',
    ne: 'eq',
    gt: 'le',
    ge: 'lt',
    lt: 'ge',
    le: 'gt',
    contains: 'notContains',
    notContains: 'contains'
};
/**
 * A condition that can operate against a single "primitive" field of a model or item.
 * @member field The field of *some record* to test against.
 * @member operator The equality or comparison operator to use.
 * @member operands The operands for the equality/comparison check.
 */ var FieldCondition = /** @class */ function() {
    function FieldCondition(field, operator, operands) {
        this.field = field;
        this.operator = operator;
        this.operands = operands;
        this.validate();
    }
    /**
     * Creates a copy of self.
     * @param extract Not used. Present only to fulfill the `UntypedCondition` interface.
     * @returns A new, identitical `FieldCondition`.
     */ FieldCondition.prototype.copy = function(extract) {
        return [
            new FieldCondition(this.field, this.operator, (0, _tslib.__spread)(this.operands)),
            undefined
        ];
    };
    /**
     * Produces a tree structure similar to a graphql condition. The returned
     * structure is "dumb" and is intended for another query/condition
     * generation mechanism to interpret, such as the cloud or storage query
     * builders.
     *
     * E.g.,
     *
     * ```json
     * {
     * 	"name": {
     * 		"eq": "robert"
     * 	}
     * }
     * ```
     */ FieldCondition.prototype.toAST = function() {
        var _a, _b;
        return _a = {}, _a[this.field] = (_b = {}, _b[this.operator] = this.operator === 'between' ? [
            this.operands[0],
            this.operands[1]
        ] : this.operands[0], _b), _a;
    };
    /**
     * Produces a new condition (`FieldCondition` or `GroupCondition`) that
     * matches the opposite of this condition.
     *
     * Intended to be used when applying De Morgan's Law, which can be done to
     * produce more efficient queries against the storage layer if a negation
     * appears in the query tree.
     *
     * For example:
     *
     * 1. `name.eq('robert')` becomes `name.ne('robert')`
     * 2. `price.between(100, 200)` becomes `m => m.or(m => [m.price.lt(100), m.price.gt(200)])`
     *
     * @param model The model meta to use when construction a new `GroupCondition`
     * for cases where the negation requires multiple `FieldCondition`'s.
     */ FieldCondition.prototype.negated = function(model) {
        if (this.operator === 'between') return new GroupCondition(model, undefined, undefined, 'or', [
            new FieldCondition(this.field, 'lt', [
                this.operands[0]
            ]),
            new FieldCondition(this.field, 'gt', [
                this.operands[1]
            ])
        ]);
        else if (this.operator === 'beginsWith') // beginsWith negation doesn't have a good, safe optimation right now.
        // just re-wrap it in negation. The adapter will have to scan-and-filter,
        // as is likely optimal for negated beginsWith conditions *anyway*.
        return new GroupCondition(model, undefined, undefined, 'not', [
            new FieldCondition(this.field, 'beginsWith', [
                this.operands[0]
            ])
        ]);
        else return new FieldCondition(this.field, negations[this.operator], this.operands);
    };
    /**
     * Not implemented. Not needed. GroupCondition instead consumes FieldConditions and
     * transforms them into legacy predicates. (*For now.*)
     * @param storage N/A. If ever implemented, the storage adapter to query.
     * @returns N/A. If ever implemented, return items from `storage` that match.
     */ FieldCondition.prototype.fetch = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.reject('No implementation needed [yet].')
                ];
            });
        });
    };
    /**
     * Determins whether a given item matches the expressed condition.
     * @param item The item to test.
     * @returns `Promise<boolean>`, `true` if matches; `false` otherwise.
     */ FieldCondition.prototype.matches = function(item) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var v, operations, operation, result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                v = item[this.field];
                operations = {
                    eq: function eq() {
                        return v === _this.operands[0];
                    },
                    ne: function ne() {
                        return v !== _this.operands[0];
                    },
                    gt: function gt() {
                        return v > _this.operands[0];
                    },
                    ge: function ge() {
                        return v >= _this.operands[0];
                    },
                    lt: function lt() {
                        return v < _this.operands[0];
                    },
                    le: function le() {
                        return v <= _this.operands[0];
                    },
                    contains: function contains() {
                        return (v === null || v === void 0 ? void 0 : v.indexOf(_this.operands[0])) > -1;
                    },
                    notContains: function notContains() {
                        return !v ? true : v.indexOf(_this.operands[0]) === -1;
                    },
                    beginsWith: function beginsWith() {
                        return v === null || v === void 0 ? void 0 : v.startsWith(_this.operands[0]);
                    },
                    between: function between() {
                        return v >= _this.operands[0] && v <= _this.operands[1];
                    }
                };
                operation = operations[this.operator];
                if (operation) {
                    result = operation();
                    return [
                        2 /*return*/ ,
                        result
                    ];
                } else throw new Error("Invalid operator given: " + this.operator);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Checks `this.operands` for compatibility with `this.operator`.
     */ FieldCondition.prototype.validate = function() {
        var _this = this;
        /**
         * Creates a validator that checks for a particular `operands` count.
         * Throws an exception if the `count` disagrees with `operands.length`.
         * @param count The number of `operands` expected.
         */ var argumentCount = function argumentCount(count) {
            var argsClause = count === 1 ? 'argument is' : 'arguments are';
            return function() {
                if (_this.operands.length !== count) return "Exactly " + count + " " + argsClause + " required.";
            };
        };
        // NOTE: validations should return a message on failure.
        // hence, they should be "joined" together with logical OR's
        // as seen in the `between:` entry.
        var validations = {
            eq: argumentCount(1),
            ne: argumentCount(1),
            gt: argumentCount(1),
            ge: argumentCount(1),
            lt: argumentCount(1),
            le: argumentCount(1),
            contains: argumentCount(1),
            notContains: argumentCount(1),
            beginsWith: argumentCount(1),
            between: function between() {
                return argumentCount(2)() || (_this.operands[0] > _this.operands[1] ? 'The first argument must be less than or equal to the second argument.' : null);
            }
        };
        var validate = validations[this.operator];
        if (validate) {
            var e = validate();
            if (typeof e === 'string') throw new Error("Incorrect usage of `" + this.operator + "()`: " + e);
        } else throw new Error("Non-existent operator: `" + this.operator + "()`");
    };
    return FieldCondition;
}();
/**
 * Small utility function to generate a monotonically increasing ID.
 * Used by GroupCondition to help keep track of which group is doing what,
 * when, and where during troubleshooting.
 */ var getGroupId = function() {
    var seed = 1;
    return function() {
        return "group_" + seed++;
    };
}();
/**
 * A set of sub-conditions to operate against a model, optionally scoped to
 * a specific field, combined with the given operator (one of `and`, `or`, or `not`).
 * @member groupId Used to distinguish between GroupCondition instances for
 * debugging and troublehsooting.
 * @member model A metadata object that tells GroupCondition what to query and how.
 * @member field The field on the model that the sub-conditions apply to.
 * @member operator How to group child conditions together.
 * @member operands The child conditions.
 */ var GroupCondition = /** @class */ function() {
    function GroupCondition(/**
     * The `ModelMeta` of the model to query and/or filter against.
     * Expected to contain:
     *
     * ```js
     * {
     * 	builder: ModelConstructor,
     * 	schema: SchemaModel,
     * 	pkField: string[]
     * }
     * ```
     */ model, /**
     * If populated, this group specifices a condition on a relationship.
     *
     * If `field` does *not* point to a related model, that's an error. It
     * could indicate that the `GroupCondition` was instantiated with bad
     * data, or that the model metadata is incorrect.
     */ field, /**
     * If a `field` is given, whether the relationship is a `HAS_ONE`,
     * 'HAS_MANY`, or `BELONGS_TO`.
     *
     * TODO: Remove this and replace with derivation using
     * `ModelRelationship.from(this.model, this.field).relationship`;
     */ relationshipType, /**
     *
     */ operator, /**
     *
     */ operands, /**
     * Whether this GroupCondition is the result of an optimize call.
     *
     * This is used to guard against infinitely fetch -> optimize -> fetch
     * recursion.
     */ isOptimized) {
        if (isOptimized === void 0) isOptimized = false;
        this.model = model;
        this.field = field;
        this.relationshipType = relationshipType;
        this.operator = operator;
        this.operands = operands;
        this.isOptimized = isOptimized;
        // `groupId` was used for development/debugging.
        // Should we leave this in for future troubleshooting?
        this.groupId = getGroupId();
    }
    /**
     * Returns a copy of a GroupCondition, which also returns the copy of a
     * given reference node to "extract".
     * @param extract A node of interest. Its copy will *also* be returned if the node exists.
     * @returns [The full copy, the copy of `extract` | undefined]
     */ GroupCondition.prototype.copy = function(extract) {
        var copied = new GroupCondition(this.model, this.field, this.relationshipType, this.operator, []);
        var extractedCopy = extract === this ? copied : undefined;
        this.operands.forEach(function(o) {
            var _a = (0, _tslib.__read)(o.copy(extract), 2), operandCopy = _a[0], extractedFromOperand = _a[1];
            copied.operands.push(operandCopy);
            extractedCopy = extractedCopy || extractedFromOperand;
        });
        return [
            copied,
            extractedCopy
        ];
    };
    /**
     * Creates a new `GroupCondition` that contains only the local field conditions,
     * omitting related model conditions. That resulting `GroupCondition` can be
     * used to produce predicates that are compatible with the storage adapters and
     * Cloud storage.
     *
     * @param negate Whether the condition tree should be negated according
     * to De Morgan's law.
     */ GroupCondition.prototype.withFieldConditionsOnly = function(negate) {
        var _this = this;
        var negateChildren = negate !== (this.operator === 'not');
        return new GroupCondition(this.model, undefined, undefined, negate ? negations[this.operator] : this.operator, this.operands.filter(function(o) {
            return o instanceof FieldCondition;
        }).map(function(o) {
            return negateChildren ? o.negated(_this.model) : o;
        }));
    };
    /**
     * Returns a version of the predicate tree with unnecessary logical groups
     * condensed and merged together. This is intended to create a dense tree
     * with leaf nodes (`FieldCondition`'s) aggregated under as few group conditions
     * as possible for the most efficient fetching possible -- it allows `fetch()`.
     *
     * E.g. a grouping like this:
     *
     * ```yaml
     * and:
     * 	and:
     * 		id:
     * 			eq: "abc"
     * 	and:
     * 		name:
     * 			eq: "xyz"
     * ```
     *
     * Will become this:
     *
     * ```yaml
     * and:
     * 	id:
     * 		eq: "abc"
     * 	name:
     * 		eq: "xyz"
     * ```
     *
     * This allows `fetch()` to pass both the `id` and `name` conditions to the adapter
     * together, which can then decide what index to use based on both fields together.
     *
     * @param preserveNode Whether to preserve the current node and to explicitly not eliminate
     * it during optimization. Used internally to preserve the root node and children of
     * `not` groups. `not` groups will always have a single child, so there's nothing to
     * optimize below a `not` (for now), and it makes the query logic simpler later.
     */ GroupCondition.prototype.optimized = function(preserveNode) {
        var _this = this;
        if (preserveNode === void 0) preserveNode = true;
        var operands = this.operands.map(function(o) {
            return o instanceof GroupCondition ? o.optimized(_this.operator === 'not') : o;
        });
        // we're only collapsing and/or groups that contains a single child for now,
        // because they're much more common and much more trivial to collapse. basically,
        // an `and`/`or` that contains a single child doesn't require the layer of
        // logical grouping.
        if (!preserveNode && [
            'and',
            'or'
        ].includes(this.operator) && !this.field && operands.length === 1) {
            var operand = operands[0];
            if (operand instanceof FieldCondition) {
                // between conditions should NOT be passed up the chain. if they
                // need to be *negated* later, it is important that they be properly
                // contained in an AND group. when de morgan's law is applied, the
                // conditions are reversed and the AND group flips to an OR. this
                // doesn't work right if the a `between` doesn't live in an AND group.
                if (operand.operator !== 'between') return operand;
            } else return operand;
        }
        return new GroupCondition(this.model, this.field, this.relationshipType, this.operator, operands, true);
    };
    /**
     * Fetches matching records from a given storage adapter using legacy predicates (for now).
     * @param storage The storage adapter this predicate will query against.
     * @param breadcrumb For debugging/troubleshooting. A list of the `groupId`'s this
     * GroupdCondition.fetch is nested within.
     * @param negate Whether to match on the `NOT` of `this`.
     * @returns An `Promise` of `any[]` from `storage` matching the child conditions.
     */ GroupCondition.prototype.fetch = function(storage, breadcrumb, negate) {
        if (breadcrumb === void 0) breadcrumb = [];
        if (negate === void 0) negate = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resultGroups, operator, negateChildren, groups, conditions, groups_1, groups_1_1, g, relatives, relationship, allJoinConditions, relatives_1, relatives_1_1, relative, relativeConditions, i, predicate, _a, _b, e_1_1, predicate, _c, _d, _e, _f, getPKValue, resultIndex, resultGroups_1, resultGroups_1_1, group, intersectWith, _g, _h, k, resultGroups_2, resultGroups_2_1, group, group_1, group_1_1, item;
            var e_1, _j, e_2, _k, _l, e_3, _m, e_4, _o, e_5, _p, e_6, _q;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_r) {
                switch(_r.label){
                    case 0:
                        if (!this.isOptimized) return [
                            2 /*return*/ ,
                            this.optimized().fetch(storage)
                        ];
                        resultGroups = [];
                        operator = negate ? negations[this.operator] : this.operator;
                        negateChildren = negate !== (this.operator === 'not');
                        groups = this.operands.filter(function(op) {
                            return op instanceof GroupCondition;
                        });
                        conditions = this.operands.filter(function(op) {
                            return op instanceof FieldCondition;
                        });
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        groups_1 = (0, _tslib.__values)(groups), groups_1_1 = groups_1.next();
                        _r.label = 2;
                    case 2:
                        if (!!groups_1_1.done) return [
                            3 /*break*/ ,
                            9
                        ];
                        g = groups_1_1.value;
                        return [
                            4 /*yield*/ ,
                            g.fetch(storage, (0, _tslib.__spread)(breadcrumb, [
                                this.groupId
                            ]), negateChildren)
                        ];
                    case 3:
                        relatives = _r.sent();
                        // no relatives -> no need to attempt to perform a "join" query for
                        // candidate results:
                        //
                        // select a.* from a,b where b.id in EMPTY_SET ==> EMPTY_SET
                        //
                        // Additionally, the entire (sub)-query can be short-circuited if
                        // the operator is `AND`. Illustrated in SQL:
                        //
                        // select a.* from a where
                        //   id in [a,b,c]
                        //     AND                        <
                        //   id in EMTPY_SET            <<< Look!
                        //     AND                        <
                        //   id in [x,y,z]
                        //
                        // YIELDS: EMPTY_SET           // <-- Easy peasy. Lemon squeezy.
                        //
                        if (relatives.length === 0) {
                            // aggressively short-circuit as soon as we know the group condition will fail
                            if (operator === 'and') return [
                                2 /*return*/ ,
                                []
                            ];
                            // less aggressive short-circuit if we know the relatives will produce no
                            // candidate results; but aren't sure yet how this affects the group condition.
                            resultGroups.push([]);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        }
                        if (!g.field) return [
                            3 /*break*/ ,
                            7
                        ];
                        relationship = (0, _relationship.ModelRelationship).from(this.model, g.field);
                        if (!relationship) return [
                            3 /*break*/ ,
                            5
                        ];
                        allJoinConditions = [];
                        try {
                            for(relatives_1 = (e_2 = void 0, (0, _tslib.__values)(relatives)), relatives_1_1 = relatives_1.next(); !relatives_1_1.done; relatives_1_1 = relatives_1.next()){
                                relative = relatives_1_1.value;
                                relativeConditions = [];
                                for(i = 0; i < relationship.localJoinFields.length; i++)relativeConditions.push((_l = {}, _l[relationship.localJoinFields[i]] = {
                                    eq: relative[relationship.remoteJoinFields[i]]
                                }, _l));
                                allJoinConditions.push({
                                    and: relativeConditions
                                });
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (relatives_1_1 && !relatives_1_1.done && (_k = relatives_1.return)) _k.call(relatives_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        predicate = (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, {
                            or: allJoinConditions
                        });
                        _b = (_a = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 4:
                        _b.apply(_a, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        throw new Error('Missing field metadata.');
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        // relatives are not actually relatives. they're candidate results.
                        resultGroups.push(relatives);
                        _r.label = 8;
                    case 8:
                        groups_1_1 = groups_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        e_1_1 = _r.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        try {
                            if (groups_1_1 && !groups_1_1.done && (_j = groups_1.return)) _j.call(groups_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (!(conditions.length > 0)) return [
                            3 /*break*/ ,
                            14
                        ];
                        predicate = this.withFieldConditionsOnly(negateChildren).toStoragePredicate();
                        _d = (_c = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 13:
                        _d.apply(_c, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        if (!(conditions.length === 0 && resultGroups.length === 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        _f = (_e = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder)
                        ];
                    case 15:
                        _f.apply(_e, [
                            _r.sent()
                        ]);
                        _r.label = 16;
                    case 16:
                        getPKValue = function getPKValue(item) {
                            return JSON.stringify(_this.model.pkField.map(function(name) {
                                return item[name];
                            }));
                        };
                        if (operator === 'and') {
                            if (resultGroups.length === 0) return [
                                2 /*return*/ ,
                                []
                            ];
                            try {
                                // for each group, we intersect, removing items from the result index
                                // that aren't present in each subsequent group.
                                for(resultGroups_1 = (0, _tslib.__values)(resultGroups), resultGroups_1_1 = resultGroups_1.next(); !resultGroups_1_1.done; resultGroups_1_1 = resultGroups_1.next()){
                                    group = resultGroups_1_1.value;
                                    if (resultIndex === undefined) resultIndex = new Map(group.map(function(item) {
                                        return [
                                            getPKValue(item),
                                            item
                                        ];
                                    }));
                                    else {
                                        intersectWith = new Map(group.map(function(item) {
                                            return [
                                                getPKValue(item),
                                                item
                                            ];
                                        }));
                                        try {
                                            for(_g = (e_4 = void 0, (0, _tslib.__values)(resultIndex.keys())), _h = _g.next(); !_h.done; _h = _g.next()){
                                                k = _h.value;
                                                if (!intersectWith.has(k)) resultIndex.delete(k);
                                            }
                                        } catch (e_4_1) {
                                            e_4 = {
                                                error: e_4_1
                                            };
                                        } finally{
                                            try {
                                                if (_h && !_h.done && (_o = _g.return)) _o.call(_g);
                                            } finally{
                                                if (e_4) throw e_4.error;
                                            }
                                        }
                                    }
                                }
                            } catch (e_3_1) {
                                e_3 = {
                                    error: e_3_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_1_1 && !resultGroups_1_1.done && (_m = resultGroups_1.return)) _m.call(resultGroups_1);
                                } finally{
                                    if (e_3) throw e_3.error;
                                }
                            }
                        } else if (operator === 'or' || operator === 'not') {
                            // it's OK to handle NOT here, because NOT must always only negate
                            // a single child predicate. NOT logic will have been distributed down
                            // to the leaf conditions already.
                            resultIndex = new Map();
                            try {
                                // just merge the groups, performing DISTINCT-ification by ID.
                                for(resultGroups_2 = (0, _tslib.__values)(resultGroups), resultGroups_2_1 = resultGroups_2.next(); !resultGroups_2_1.done; resultGroups_2_1 = resultGroups_2.next()){
                                    group = resultGroups_2_1.value;
                                    try {
                                        for(group_1 = (e_6 = void 0, (0, _tslib.__values)(group)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()){
                                            item = group_1_1.value;
                                            resultIndex.set(getPKValue(item), item);
                                        }
                                    } catch (e_6_1) {
                                        e_6 = {
                                            error: e_6_1
                                        };
                                    } finally{
                                        try {
                                            if (group_1_1 && !group_1_1.done && (_q = group_1.return)) _q.call(group_1);
                                        } finally{
                                            if (e_6) throw e_6.error;
                                        }
                                    }
                                }
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_2_1 && !resultGroups_2_1.done && (_p = resultGroups_2.return)) _p.call(resultGroups_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                        }
                        return [
                            2 /*return*/ ,
                            Array.from((resultIndex === null || resultIndex === void 0 ? void 0 : resultIndex.values()) || [])
                        ];
                }
            });
        });
    };
    /**
     * Determines whether a single item matches the conditions of `this`.
     * When checking the target `item`'s properties, each property will be `await`'d
     * to ensure lazy-loading is respected where applicable.
     * @param item The item to match against.
     * @param ignoreFieldName Tells `match()` that the field name has already been dereferenced.
     * (Used for iterating over children on HAS_MANY checks.)
     * @returns A boolean (promise): `true` if matched, `false` otherwise.
     */ GroupCondition.prototype.matches = function(item, ignoreFieldName) {
        if (ignoreFieldName === void 0) ignoreFieldName = false;
        var e_7, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemToCheck, _b, itemToCheck_1, itemToCheck_1_1, singleItem, e_7_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(this.field && !ignoreFieldName)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            item[this.field]
                        ];
                    case 1:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _b = item;
                        _c.label = 3;
                    case 3:
                        itemToCheck = _b;
                        // if there is no item to check, we can stop recursing immediately.
                        // a condition cannot match against an item that does not exist. this
                        // can occur when `item.field` is optional in the schema.
                        if (!itemToCheck) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (!(this.relationshipType === 'HAS_MANY' && typeof itemToCheck[Symbol.asyncIterator] === 'function')) return [
                            3 /*break*/ ,
                            17
                        ];
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            10,
                            11,
                            16
                        ]);
                        itemToCheck_1 = (0, _tslib.__asyncValues)(itemToCheck);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            itemToCheck_1.next()
                        ];
                    case 6:
                        if (!(itemToCheck_1_1 = _c.sent(), !itemToCheck_1_1.done)) return [
                            3 /*break*/ ,
                            9
                        ];
                        singleItem = itemToCheck_1_1.value;
                        return [
                            4 /*yield*/ ,
                            this.matches(singleItem, true)
                        ];
                    case 7:
                        if (_c.sent()) return [
                            2 /*return*/ ,
                            true
                        ];
                        _c.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 10:
                        e_7_1 = _c.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            ,
                            14,
                            15
                        ]);
                        if (!(itemToCheck_1_1 && !itemToCheck_1_1.done && (_a = itemToCheck_1.return))) return [
                            3 /*break*/ ,
                            13
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(itemToCheck_1)
                        ];
                    case 12:
                        _c.sent();
                        _c.label = 13;
                    case 13:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        if (e_7) throw e_7.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 17:
                        if (!(this.operator === 'or')) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncSome)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 18:
                        if (!(this.operator === 'and')) return [
                            3 /*break*/ ,
                            19
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncEvery)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 19:
                        if (!(this.operator === 'not')) return [
                            3 /*break*/ ,
                            21
                        ];
                        if (this.operands.length !== 1) throw new Error('Invalid arguments! `not()` accepts exactly one predicate expression.');
                        return [
                            4 /*yield*/ ,
                            this.operands[0].matches(itemToCheck)
                        ];
                    case 20:
                        return [
                            2 /*return*/ ,
                            !_c.sent()
                        ];
                    case 21:
                        throw new Error('Invalid group operator!');
                }
            });
        });
    };
    /**
     * Tranfsorm to a AppSync GraphQL compatible AST.
     * (Does not support filtering in nested types.)
     */ GroupCondition.prototype.toAST = function() {
        var _a;
        if (this.field) throw new Error('Nested type conditions are not supported!');
        return _a = {}, _a[this.operator] = this.operands.map(function(operand) {
            return operand.toAST();
        }), _a;
    };
    /**
     * Turn this predicate group into something a storage adapter
     * understands how to use.
     */ GroupCondition.prototype.toStoragePredicate = function() {
        return (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, this.toAST());
    };
    /**
     * A JSON representation that's good for debugging.
     */ GroupCondition.prototype.toJSON = function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            model: this.model.schema.name
        });
    };
    return GroupCondition;
}();
function recursivePredicateFor(ModelType, allowRecursion, field, query, tail) {
    if (allowRecursion === void 0) allowRecursion = true;
    // to be used if we don't have a base query or tail to build onto
    var starter = new GroupCondition(ModelType, field, undefined, 'and', []);
    var baseCondition = query && tail ? query : starter;
    var tailCondition = query && tail ? tail : starter;
    // our eventual return object, which can be built upon.
    // next steps will be to add or(), and(), not(), and field.op() methods.
    var link = {};
    // so it can be looked up later with in the internals when processing conditions.
    registerPredicateInternals(baseCondition, link);
    var copyLink = function copyLink() {
        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), _$query = _a[0], newTail = _a[1];
        var newLink = recursivePredicateFor(ModelType, allowRecursion, undefined, _$query, newTail);
        return {
            query: _$query,
            newTail: newTail,
            newLink: newLink
        };
    };
    // Adds .or() and .and() methods to the link.
    // TODO: If revisiting this code, consider writing a Proxy instead.
    [
        'and',
        'or'
    ].forEach(function(op) {
        link[op] = function(builder) {
            // or() and and() will return a copy of the original link
            // to head off mutability concerns.
            var _a = copyLink(), _$query = _a.query, newTail = _a.newTail;
            var childConditions = builder(recursivePredicateFor(ModelType, allowRecursion));
            if (!Array.isArray(childConditions)) throw new Error("Invalid predicate. `" + op + "` groups must return an array of child conditions.");
            // the customer will supply a child predicate, which apply to the `model.field`
            // of the tail GroupCondition.
            newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, op, childConditions.map(function(c) {
                return internals(c);
            })));
            // FinalPredicate
            return registerPredicateInternals(_$query);
        };
    });
    // TODO: If revisiting this code, consider proxy.
    link.not = function(builder) {
        // not() will return a copy of the original link
        // to head off mutability concerns.
        var _a = copyLink(), _$query = _a.query, newTail = _a.newTail;
        // unlike and() and or(), the customer will supply a "singular" child predicate.
        // the difference being: not() does not accept an array of predicate-like objects.
        // it negates only a *single* predicate subtree.
        newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, 'not', [
            internals(builder(recursivePredicateFor(ModelType, allowRecursion)))
        ]));
        // A `FinalModelPredicate`.
        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
        // or query storage: `.__query.fetch(storage)`.
        return registerPredicateInternals(_$query);
    };
    var _loop_1 = function _loop_1(fieldName) {
        Object.defineProperty(link, fieldName, {
            enumerable: true,
            get: function get() {
                var def = ModelType.schema.allFields[fieldName];
                if (!def.association) // we're looking at a value field. we need to return a
                // "field matcher object", which contains all of the comparison
                // functions ('eq', 'ne', 'gt', etc.), scoped to operate
                // against the target field (fieldName).
                return ops.reduce(function(fieldMatcher, operator) {
                    var _a;
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, fieldMatcher), (_a = {}, _a[operator] = function() {
                        var operands = [];
                        for(var _i = 0; _i < arguments.length; _i++)operands[_i] = arguments[_i];
                        // build off a fresh copy of the existing `link`, just in case
                        // the same link is being used elsewhere by the customer.
                        var _a = copyLink(), _$query = _a.query, newTail = _a.newTail;
                        // normalize operands. if any of the values are `undefiend`, use
                        // `null` instead, because that's what will be stored cross-platform.
                        var normalizedOperands = operands.map(function(o) {
                            return o === undefined ? null : o;
                        });
                        // add the given condition to the link's TAIL node.
                        // remember: the base link might go N nodes deep! e.g.,
                        newTail === null || newTail === void 0 || newTail.operands.push(new FieldCondition(fieldName, operator, normalizedOperands));
                        // A `FinalModelPredicate`.
                        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
                        // or query storage: `.__query.fetch(storage)`.
                        return registerPredicateInternals(_$query);
                    }, _a));
                }, {});
                else {
                    if (!allowRecursion) throw new Error('Predication on releated models is not supported in this context.');
                    else if (def.association.connectionType === 'BELONGS_TO' || def.association.connectionType === 'HAS_ONE' || def.association.connectionType === 'HAS_MANY') {
                        // the use has just typed '.someRelatedModel'. we need to given them
                        // back a predicate chain.
                        var relatedMeta = def.type.modelConstructor;
                        if (!relatedMeta) throw new Error('Related model metadata is missing. This is a bug! Please report it.');
                        // `Model.reletedModelField` returns a copy of the original link,
                        // and will contains copies of internal GroupConditions
                        // to head off mutability concerns.
                        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), newquery = _a[0], oldtail = _a[1];
                        var newtail = new GroupCondition(relatedMeta, fieldName, def.association.connectionType, 'and', []);
                        // `oldtail` here refers to the *copy* of the old tail.
                        // so, it's safe to modify at this point. and we need to modify
                        // it to push the *new* tail onto the end of it.
                        oldtail.operands.push(newtail);
                        var newlink = recursivePredicateFor(relatedMeta, allowRecursion, undefined, newquery, newtail);
                        return newlink;
                    } else throw new Error("Related model definition doesn't have a typedef. This is a bug! Please report it.");
                }
            }
        });
    };
    // For each field on the model schema, we want to add a getter
    // that creates the appropriate new `link` in the query chain.
    // TODO: If revisiting, consider a proxy.
    for(var fieldName in ModelType.schema.allFields)_loop_1(fieldName);
    return link;
}
function predicateFor(ModelType) {
    // the cast here is just a cheap way to reduce the surface area from
    // the recursive type.
    return recursivePredicateFor(ModelType, false);
}

},{"tslib":"86BcK","../types":"9W0ar","./index":"bohgw","../storage/relationship":"bT2iw","../util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lH2Zb":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interactions", function() {
    return 0, _interactions.Interactions;
});
parcelHelpers.export(exports, "AbstractInteractionsProvider", function() {
    return 0, _interactionsProvider.AbstractInteractionsProvider;
});
parcelHelpers.export(exports, "AWSLexProvider", function() {
    return 0, _awslexProvider.AWSLexProvider;
});
parcelHelpers.export(exports, "AWSLexV2Provider", function() {
    return 0, _awslexV2Provider.AWSLexV2Provider;
});
var _interactions = require("./Interactions");
var _interactionsProvider = require("./Providers/InteractionsProvider");
var _awslexProvider = require("./Providers/AWSLexProvider");
var _awslexV2Provider = require("./Providers/AWSLexV2Provider");

},{"./Interactions":"8Wbhl","./Providers/InteractionsProvider":"6ZXQe","./Providers/AWSLexProvider":"lRej8","./Providers/AWSLexV2Provider":"gy36g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Wbhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionsClass", function() {
    return InteractionsClass;
});
parcelHelpers.export(exports, "Interactions", function() {
    return Interactions;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _providers = require("./Providers");
var logger = new (0, _core.ConsoleLogger)('Interactions');
var InteractionsClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     */ function InteractionsClass(options) {
        if (options === void 0) options = {};
        this._options = options;
        logger.debug('Interactions Options', this._options);
        this._pluggables = {};
    }
    InteractionsClass.prototype.getModuleName = function() {
        return 'Interactions';
    };
    /**
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     * @return {InteractionsOptions} - The current configuration
     */ InteractionsClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.Interactions || options : {};
        logger.debug('configure Interactions', {
            opt: opt
        });
        this._options = (0, _tslib.__assign)((0, _tslib.__assign)({
            bots: {}
        }, opt), opt.Interactions);
        var aws_bots_config = this._options.aws_bots_config;
        var bots_config = this._options.bots;
        if (!Object.keys(bots_config).length && aws_bots_config) // Convert aws_bots_config to bots object
        {
            if (Array.isArray(aws_bots_config)) aws_bots_config.forEach(function(bot) {
                _this._options.bots[bot.name] = bot;
            });
        }
        // configure bots to their specific providers
        Object.keys(bots_config).forEach(function(botKey) {
            var _a;
            var bot = bots_config[botKey];
            var providerName = bot.providerName || 'AWSLexProvider';
            // add default provider if required
            if (!_this._pluggables.AWSLexProvider && providerName === 'AWSLexProvider') _this._pluggables.AWSLexProvider = new (0, _providers.AWSLexProvider)();
            // configure bot with it's respective provider
            if (_this._pluggables[providerName]) _this._pluggables[providerName].configure((_a = {}, _a[bot.name] = bot, _a));
            else logger.debug("bot " + bot.name + " was not configured as " + providerName + " provider was not found");
        });
        return this._options;
    };
    InteractionsClass.prototype.addPluggable = function(pluggable) {
        var _this = this;
        if (pluggable && pluggable.getCategory() === 'Interactions') {
            if (!this._pluggables[pluggable.getProviderName()]) {
                // configure bots for the new plugin
                Object.keys(this._options.bots).filter(function(botKey) {
                    return _this._options.bots[botKey].providerName === pluggable.getProviderName();
                }).forEach(function(botKey) {
                    var _a;
                    var bot = _this._options.bots[botKey];
                    pluggable.configure((_a = {}, _a[bot.name] = bot, _a));
                });
                this._pluggables[pluggable.getProviderName()] = pluggable;
                return;
            } else throw new Error('Pluggable ' + pluggable.getProviderName() + ' already plugged');
        }
    };
    InteractionsClass.prototype.send = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var botProvider;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._options.bots || !this._options.bots[botname]) return [
                            2 /*return*/ ,
                            Promise.reject('Bot ' + botname + ' does not exist')
                        ];
                        botProvider = this._options.bots[botname].providerName || 'AWSLexProvider';
                        if (!this._pluggables[botProvider]) return [
                            2 /*return*/ ,
                            Promise.reject('Bot ' + botProvider + ' does not have valid pluggin did you try addPluggable first?')
                        ];
                        return [
                            4 /*yield*/ ,
                            this._pluggables[botProvider].sendMessage(botname, message)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    InteractionsClass.prototype.onComplete = function(botname, callback) {
        if (!this._options.bots || !this._options.bots[botname]) throw new Error('Bot ' + botname + ' does not exist');
        var botProvider = this._options.bots[botname].providerName || 'AWSLexProvider';
        if (!this._pluggables[botProvider]) throw new Error('Bot ' + botProvider + ' does not have valid pluggin did you try addPluggable first?');
        this._pluggables[botProvider].onComplete(botname, callback);
    };
    return InteractionsClass;
}();
var Interactions = new InteractionsClass();
(0, _core.Amplify).register(Interactions);

},{"tslib":"2gCWu","@aws-amplify/core":"3rlh1","./Providers":"aUnj8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2gCWu":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aUnj8":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", function() {
    return 0, _awslexProvider.AWSLexProvider;
});
parcelHelpers.export(exports, "AWSLexV2Provider", function() {
    return 0, _awslexV2Provider.AWSLexV2Provider;
});
parcelHelpers.export(exports, "AbstractInteractionsProvider", function() {
    return 0, _interactionsProvider.AbstractInteractionsProvider;
});
var _awslexProvider = require("./AWSLexProvider");
var _awslexV2Provider = require("./AWSLexV2Provider");
var _interactionsProvider = require("./InteractionsProvider");

},{"./AWSLexProvider":"lRej8","./AWSLexV2Provider":false,"./InteractionsProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRej8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", function() {
    return AWSLexProvider;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _interactionsProvider = require("./InteractionsProvider");
var _clientLexRuntimeService = require("@aws-sdk/client-lex-runtime-service");
var _core = require("@aws-amplify/core");
var _utils = require("./AWSLexProviderHelper/utils");
var logger = new (0, _core.ConsoleLogger)('AWSLexProvider');
var AWSLexProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSLexProvider, _super);
    function AWSLexProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this._botsCompleteCallback = {};
        return _this;
    }
    AWSLexProvider.prototype.getProviderName = function() {
        return 'AWSLexProvider';
    };
    AWSLexProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        var propertiesToTest = [
            'name',
            'alias',
            'region'
        ];
        Object.keys(config).forEach(function(botKey) {
            var botConfig = config[botKey];
            // is bot config correct
            if (!propertiesToTest.every(function(x) {
                return x in botConfig;
            })) throw new Error('invalid bot configuration');
        });
        return _super.prototype.configure.call(this, config);
    };
    /**
     * @private
     * @deprecated
     * This is used internally by 'sendMessage' to call onComplete callback
     * for a bot if configured
     */ AWSLexProvider.prototype.reportBotStatus = function(data, botname) {
        var _this = this;
        // Check if state is fulfilled to resolve onFullfilment promise
        logger.debug('postContent state', data.dialogState);
        if (data.dialogState === 'ReadyForFulfillment' || data.dialogState === 'Fulfilled') {
            if (typeof this._botsCompleteCallback[botname] === 'function') setTimeout(function() {
                return _this._botsCompleteCallback[botname](null, data);
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === 'function') setTimeout(function() {
                return _this._config[botname].onComplete(null, data);
            }, 0);
        }
        if (data.dialogState === 'Failed') {
            if (typeof this._botsCompleteCallback[botname] === 'function') setTimeout(function() {
                return _this._botsCompleteCallback[botname]('Bot conversation failed');
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === 'function') setTimeout(function() {
                return _this._config[botname].onComplete('Bot conversation failed');
            }, 0);
        }
    };
    AWSLexProvider.prototype.sendMessage = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, error_1, params, postTextCommand, data, err_1, content, messageType, inputStream, _a, postContentCommand, data, audioArray, _b, response, err_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        // check if bot exists
                        if (!this._config[botname]) return [
                            2 /*return*/ ,
                            Promise.reject('Bot ' + botname + ' does not exist')
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 2:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                    case 4:
                        this.lexRuntimeServiceClient = new (0, _clientLexRuntimeService.LexRuntimeServiceClient)({
                            region: this._config[botname].region,
                            credentials: credentials,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        if (!(typeof message === 'string')) return [
                            3 /*break*/ ,
                            9
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            inputText: message,
                            userId: credentials.identityId
                        };
                        logger.debug('postText to lex', message);
                        _c.label = 5;
                    case 5:
                        _c.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        postTextCommand = new (0, _clientLexRuntimeService.PostTextCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postTextCommand)
                        ];
                    case 6:
                        data = _c.sent();
                        this.reportBotStatus(data, botname);
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    case 7:
                        err_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_1)
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 9:
                        content = message.content, messageType = message.options.messageType;
                        if (!(messageType === 'voice')) return [
                            3 /*break*/ ,
                            13
                        ];
                        if ((typeof content === "undefined" ? "undefined" : (0, _typeOf._)(content)) !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('invalid content type')
                        ];
                        if (!(content instanceof Uint8Array)) return [
                            3 /*break*/ ,
                            10
                        ];
                        _a = content;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(content)
                        ];
                    case 11:
                        _a = _c.sent();
                        _c.label = 12;
                    case 12:
                        inputStream = _a;
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: 'audio/x-l16; sample-rate=16000; channel-count=1',
                            userId: credentials.identityId,
                            accept: 'audio/mpeg',
                            inputStream: inputStream
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (typeof content !== 'string') return [
                            2 /*return*/ ,
                            Promise.reject('invalid content type')
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: 'text/plain; charset=utf-8',
                            inputStream: content,
                            userId: credentials.identityId,
                            accept: 'audio/mpeg'
                        };
                        _c.label = 14;
                    case 14:
                        logger.debug('postContent to lex', message);
                        _c.label = 15;
                    case 15:
                        _c.trys.push([
                            15,
                            20,
                            ,
                            21
                        ]);
                        postContentCommand = new (0, _clientLexRuntimeService.PostContentCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postContentCommand)
                        ];
                    case 16:
                        data = _c.sent();
                        if (!data.audioStream) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(data.audioStream)
                        ];
                    case 17:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        _b = undefined;
                        _c.label = 19;
                    case 19:
                        audioArray = _b;
                        response = (0, _tslib.__assign)((0, _tslib.__assign)({}, data), {
                            audioStream: audioArray
                        });
                        this.reportBotStatus(response, botname);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 20:
                        err_2 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_2)
                        ];
                    case 21:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSLexProvider.prototype.onComplete = function(botname, callback) {
        // does bot exist
        if (!this._config[botname]) throw new Error('Bot ' + botname + ' does not exist');
        this._botsCompleteCallback[botname] = callback;
    };
    return AWSLexProvider;
}((0, _interactionsProvider.AbstractInteractionsProvider));

},{"@swc/helpers/_/_type_of":"668P4","tslib":"2gCWu","./InteractionsProvider":"6ZXQe","@aws-sdk/client-lex-runtime-service":"3Q3uZ","@aws-amplify/core":"3rlh1","./AWSLexProviderHelper/utils":"ep5zt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6ZXQe":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractInteractionsProvider", function() {
    return AbstractInteractionsProvider;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('AbstractInteractionsProvider');
var AbstractInteractionsProvider = /** @class */ function() {
    function AbstractInteractionsProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractInteractionsProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._config), config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractInteractionsProvider.prototype.getCategory = function() {
        return 'Interactions';
    };
    Object.defineProperty(AbstractInteractionsProvider.prototype, "options", {
        get: function get() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractInteractionsProvider;
}();

},{"tslib":"2gCWu","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Q3uZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", function() {
    return 0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException;
});
var _lexRuntimeService = require("./LexRuntimeService");
parcelHelpers.exportAll(_lexRuntimeService, exports);
var _lexRuntimeServiceClient = require("./LexRuntimeServiceClient");
parcelHelpers.exportAll(_lexRuntimeServiceClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _lexRuntimeServiceServiceException = require("./models/LexRuntimeServiceServiceException");

},{"./LexRuntimeService":false,"./LexRuntimeServiceClient":"b0HTK","./commands":"drgSa","./models":false,"./models/LexRuntimeServiceServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b0HTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceClient", function() {
    return LexRuntimeServiceClient;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LexRuntimeServiceClient = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceClient, _super);
    function LexRuntimeServiceClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LexRuntimeServiceClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LexRuntimeServiceClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","@aws-sdk/config-resolver":"gu4pD","@aws-sdk/middleware-content-length":"eL4Ub","@aws-sdk/middleware-host-header":"4bXMX","@aws-sdk/middleware-logger":"8erYw","@aws-sdk/middleware-recursion-detection":"l81JW","@aws-sdk/middleware-retry":"fR8xr","@aws-sdk/middleware-signing":"7a9MX","@aws-sdk/middleware-user-agent":"8E67h","@aws-sdk/smithy-client":"alQg0","./runtimeConfig":"d4LcD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gu4pD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"4TG5X","./regionConfig":"kbLZy","./regionInfo":"d3mg8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TG5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"cLap0","./NodeUseFipsEndpointConfigOptions":"53tgq","./resolveCustomEndpointsConfig":"3NaN5","./resolveEndpointsConfig":"7edTs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cLap0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", function() {
    return ENV_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", function() {
    return CONFIG_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", function() {
    return DEFAULT_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5vFvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _booleanSelector = require("./booleanSelector");
parcelHelpers.exportAll(_booleanSelector, exports);

},{"./booleanSelector":"eS7UQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eS7UQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectorType", function() {
    return SelectorType;
});
parcelHelpers.export(exports, "booleanSelector", function() {
    return booleanSelector;
});
var SelectorType;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));
var booleanSelector = function booleanSelector(obj, key, type) {
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error("Cannot load ".concat(type, " \"").concat(key, "\". Expected \"true\" or \"false\", got ").concat(obj[key], "."));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53tgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", function() {
    return ENV_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", function() {
    return CONFIG_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", function() {
    return DEFAULT_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NaN5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", function() {
    return resolveCustomEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function resolveCustomEndpointsConfig(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2OCR6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _normalizeProvider = require("./normalizeProvider");
parcelHelpers.exportAll(_normalizeProvider, exports);

},{"./normalizeProvider":"4nawr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4nawr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeProvider", function() {
    return normalizeProvider;
});
var normalizeProvider = function normalizeProvider(input) {
    if (typeof input === "function") return input;
    var promisified = Promise.resolve(input);
    return function() {
        return promisified;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7edTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", function() {
    return resolveEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function resolveEndpointsConfig(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./utils/getEndpointFromRegion":"5p6la","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5p6la":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", function() {
    return getEndpointFromRegion;
});
var _tslib = require("tslib");
var getEndpointFromRegion = function getEndpointFromRegion(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbLZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"lRPbk","./resolveRegionConfig":"1DAGI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRPbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", function() {
    return REGION_ENV_NAME;
});
parcelHelpers.export(exports, "REGION_INI_NAME", function() {
    return REGION_INI_NAME;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", function() {
    return NODE_REGION_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", function() {
    return NODE_REGION_CONFIG_FILE_OPTIONS;
});
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function _default() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1DAGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", function() {
    return resolveRegionConfig;
});
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function resolveRegionConfig(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function region1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function useFipsEndpoint1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","./getRealRegion":"hmeUf","./isFipsRegion":"i8GPw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hmeUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", function() {
    return getRealRegion;
});
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function getRealRegion(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"i8GPw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8GPw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", function() {
    return isFipsRegion;
});
var isFipsRegion = function isFipsRegion(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d3mg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"2h6AU","./RegionHash":"2Dzri","./getRegionInfo":"i13YL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2h6AU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Dzri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i13YL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", function() {
    return getRegionInfo;
});
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function getRegionInfo(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"86BcK","./getHostnameFromVariants":"b8j9C","./getResolvedHostname":"D627q","./getResolvedPartition":"4UESF","./getResolvedSigningRegion":"2YoOr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b8j9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", function() {
    return getHostnameFromVariants;
});
var getHostnameFromVariants = function getHostnameFromVariants(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"D627q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", function() {
    return getResolvedHostname;
});
var getResolvedHostname = function getResolvedHostname(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4UESF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", function() {
    return getResolvedPartition;
});
var getResolvedPartition = function getResolvedPartition(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2YoOr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", function() {
    return getResolvedSigningRegion;
});
var getResolvedSigningRegion = function getResolvedSigningRegion(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eL4Ub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", function() {
    return contentLengthMiddleware;
});
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", function() {
    return contentLengthMiddlewareOptions;
});
parcelHelpers.export(exports, "getContentLengthPlugin", function() {
    return getContentLengthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function getContentLengthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f8OeQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"joyjT","./httpRequest":"098yS","./httpResponse":"49uKQ","./isValidHostname":"dbHlq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"joyjT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"098yS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49uKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dbHlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4bXMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", function() {
    return resolveHostHeaderConfig;
});
parcelHelpers.export(exports, "hostHeaderMiddleware", function() {
    return hostHeaderMiddleware;
});
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", function() {
    return hostHeaderMiddlewareOptions;
});
parcelHelpers.export(exports, "getHostHeaderPlugin", function() {
    return getHostHeaderPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function hostHeaderMiddleware(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function getHostHeaderPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8erYw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"QyXV7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"QyXV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", function() {
    return loggerMiddleware;
});
parcelHelpers.export(exports, "loggerMiddlewareOptions", function() {
    return loggerMiddlewareOptions;
});
parcelHelpers.export(exports, "getLoggerPlugin", function() {
    return getLoggerPlugin;
});
var _tslib = require("tslib");
var loggerMiddleware = function loggerMiddleware() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function getLoggerPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l81JW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recursionDetectionMiddleware", function() {
    return recursionDetectionMiddleware;
});
parcelHelpers.export(exports, "addRecursionDetectionMiddlewareOptions", function() {
    return addRecursionDetectionMiddlewareOptions;
});
parcelHelpers.export(exports, "getRecursionDetectionPlugin", function() {
    return getRecursionDetectionPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var process = require("390cf85b5344aa6c");
var TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware = function recursionDetectionMiddleware(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, functionName, traceId, nonEmptyString;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if (!(0, _protocolHttp.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) return [
                        2,
                        next(args)
                    ];
                    functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
                    traceId = process.env[ENV_TRACE_ID];
                    nonEmptyString = function nonEmptyString(str) {
                        return typeof str === "string" && str.length > 0;
                    };
                    if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[TRACE_ID_HEADER_NAME] = traceId;
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
};
var addRecursionDetectionMiddlewareOptions = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
var getRecursionDetectionPlugin = function getRecursionDetectionPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
        }
    };
};

},{"390cf85b5344aa6c":"4avz9","tslib":"86BcK","@aws-sdk/protocol-http":"hsGX6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hsGX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"bm7sA","./httpRequest":"f2L6x","./httpResponse":"hJEi1","./isValidHostname":"5DUhf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bm7sA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f2L6x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hJEi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5DUhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fR8xr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"ehWwQ","./DefaultRateLimiter":"9kPux","./StandardRetryStrategy":"9mCQW","./config":"hHa0h","./configurations":"2xFBa","./delayDecider":"3iteg","./omitRetryHeadersMiddleware":"3cKz1","./retryDecider":"lwkK2","./retryMiddleware":"kjJyl","./types":"gplCd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ehWwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", function() {
    return AdaptiveRetryStrategy;
});
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function beforeRequest() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function afterRequest(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"86BcK","./config":"hHa0h","./DefaultRateLimiter":"9kPux","./StandardRetryStrategy":"9mCQW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hHa0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", function() {
    return RETRY_MODES;
});
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", function() {
    return DEFAULT_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", function() {
    return DEFAULT_RETRY_MODE;
});
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9kPux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", function() {
    return DefaultRateLimiter;
});
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"86BcK","@aws-sdk/service-error-classification":"iEb89","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iEb89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", function() {
    return isRetryableByTrait;
});
parcelHelpers.export(exports, "isClockSkewError", function() {
    return isClockSkewError;
});
parcelHelpers.export(exports, "isThrottlingError", function() {
    return isThrottlingError;
});
parcelHelpers.export(exports, "isTransientError", function() {
    return isTransientError;
});
var _constants = require("./constants");
var isRetryableByTrait = function isRetryableByTrait(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function isClockSkewError(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function isThrottlingError(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function isTransientError(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"87rG2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"87rG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", function() {
    return CLOCK_SKEW_ERROR_CODES;
});
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", function() {
    return THROTTLING_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", function() {
    return TRANSIENT_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", function() {
    return TRANSIENT_ERROR_STATUS_CODES;
});
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", function() {
    return NODEJS_TIMEOUT_ERROR_CODES;
});
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9mCQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", function() {
    return StandardRetryStrategy;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function _loop_1() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if ((typeof state_1 === "undefined" ? "undefined" : (0, _typeOf._)(state_1)) === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function getDelayFromRetryAfterHeader(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function asSdkError(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/service-error-classification":"iEb89","uuid":"fAGzL","./config":"hHa0h","./constants":"6Pp0Q","./defaultRetryQuota":"47ztD","./delayDecider":"3iteg","./retryDecider":"lwkK2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fAGzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"8Txxz","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Txxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"kQQyd","./stringify.js":"kZ7bc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kQQyd":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kZ7bc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"aX8ct","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aX8ct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3x2ZQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3x2ZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Pp0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", function() {
    return DEFAULT_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", function() {
    return MAXIMUM_RETRY_DELAY;
});
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", function() {
    return THROTTLING_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", function() {
    return INITIAL_RETRY_TOKENS;
});
parcelHelpers.export(exports, "RETRY_COST", function() {
    return RETRY_COST;
});
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", function() {
    return TIMEOUT_RETRY_COST;
});
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", function() {
    return NO_RETRY_INCREMENT;
});
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", function() {
    return INVOCATION_ID_HEADER;
});
parcelHelpers.export(exports, "REQUEST_HEADER", function() {
    return REQUEST_HEADER;
});
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47ztD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", function() {
    return getDefaultRetryQuota;
});
var _constants = require("./constants");
var getDefaultRetryQuota = function getDefaultRetryQuota(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function getCapacityAmount(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function hasRetryTokens(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function retrieveRetryTokens(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function releaseRetryTokens(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3iteg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", function() {
    return defaultDelayDecider;
});
var _constants = require("./constants");
var defaultDelayDecider = function defaultDelayDecider(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwkK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", function() {
    return defaultRetryDecider;
});
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function defaultRetryDecider(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"iEb89","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2xFBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", function() {
    return ENV_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", function() {
    return CONFIG_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", function() {
    return NODE_MAX_ATTEMPT_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "resolveRetryConfig", function() {
    return resolveRetryConfig;
});
parcelHelpers.export(exports, "ENV_RETRY_MODE", function() {
    return ENV_RETRY_MODE;
});
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", function() {
    return CONFIG_RETRY_MODE;
});
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", function() {
    return NODE_RETRY_MODE_CONFIG_OPTIONS;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    configFileSelector: function configFileSelector(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function resolveRetryConfig(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function retryStrategy() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./AdaptiveRetryStrategy":"ehWwQ","./config":"hHa0h","./StandardRetryStrategy":"9mCQW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3cKz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", function() {
    return omitRetryHeadersMiddleware;
});
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", function() {
    return omitRetryHeadersMiddlewareOptions;
});
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", function() {
    return getOmitRetryHeadersPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function omitRetryHeadersMiddleware() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function getOmitRetryHeadersPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kjJyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return retryMiddleware;
});
parcelHelpers.export(exports, "retryMiddlewareOptions", function() {
    return retryMiddlewareOptions;
});
parcelHelpers.export(exports, "getRetryPlugin", function() {
    return getRetryPlugin;
});
var _tslib = require("tslib");
var retryMiddleware = function retryMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function getRetryPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gplCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a9MX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"lXM3t","./middleware":"b357s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lXM3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", function() {
    return resolveAwsAuthConfig;
});
parcelHelpers.export(exports, "resolveSigV4AuthConfig", function() {
    return resolveSigV4AuthConfig;
});
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function resolveAwsAuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function signer() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function signer(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function resolveSigV4AuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function normalizeCredentialProvider(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"dN7r8","@aws-sdk/signature-v4":"dPbM8","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dN7r8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"9CcJJ","./ProviderError":"cXkWn","./TokenProviderError":"lKMlk","./chain":"bhXFi","./fromStatic":"fshlJ","./memoize":"hwgWf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CcJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", function() {
    return CredentialsProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cXkWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", function() {
    return ProviderError;
});
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lKMlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", function() {
    return TokenProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bhXFi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", function() {
    return chain;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function _loop_1(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fshlJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", function() {
    return fromStatic;
});
var fromStatic = function fromStatic(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwgWf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
var _tslib = require("tslib");
var memoize = function memoize(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function coalesceProvider() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dPbM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return 0, _getCanonicalHeaders.getCanonicalHeaders;
});
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return 0, _getCanonicalQuery.getCanonicalQuery;
});
parcelHelpers.export(exports, "getPayloadHash", function() {
    return 0, _getPayloadHash.getPayloadHash;
});
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return 0, _moveHeadersToQuery.moveHeadersToQuery;
});
parcelHelpers.export(exports, "prepareRequest", function() {
    return 0, _prepareRequest.prepareRequest;
});
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"2c5Im","./getCanonicalHeaders":"glkhC","./getCanonicalQuery":"fBu4t","./getPayloadHash":"kbirI","./moveHeadersToQuery":"beRjG","./prepareRequest":"kXIRz","./credentialDerivation":"9Ay5s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2c5Im":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", function() {
    return SignatureV4;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if ((typeof credentials === "undefined" ? "undefined" : (0, _typeOf._)(credentials)) !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function formatDate(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function getCanonicalHeaderList(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/util-hex-encoding":"2LppL","@aws-sdk/util-middleware":"2OCR6","./constants":"kn99E","./credentialDerivation":"9Ay5s","./getCanonicalHeaders":"glkhC","./getCanonicalQuery":"fBu4t","./getPayloadHash":"kbirI","./headerUtil":"e1gG6","./moveHeadersToQuery":"beRjG","./prepareRequest":"kXIRz","./utilDate":"3FVMU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LppL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", function() {
    return fromHex;
});
parcelHelpers.export(exports, "toHex", function() {
    return toHex;
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kn99E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", function() {
    return ALGORITHM_QUERY_PARAM;
});
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", function() {
    return CREDENTIAL_QUERY_PARAM;
});
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", function() {
    return AMZ_DATE_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", function() {
    return SIGNED_HEADERS_QUERY_PARAM;
});
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", function() {
    return EXPIRES_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", function() {
    return SIGNATURE_QUERY_PARAM;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "REGION_SET_PARAM", function() {
    return REGION_SET_PARAM;
});
parcelHelpers.export(exports, "AUTH_HEADER", function() {
    return AUTH_HEADER;
});
parcelHelpers.export(exports, "AMZ_DATE_HEADER", function() {
    return AMZ_DATE_HEADER;
});
parcelHelpers.export(exports, "DATE_HEADER", function() {
    return DATE_HEADER;
});
parcelHelpers.export(exports, "GENERATED_HEADERS", function() {
    return GENERATED_HEADERS;
});
parcelHelpers.export(exports, "SIGNATURE_HEADER", function() {
    return SIGNATURE_HEADER;
});
parcelHelpers.export(exports, "SHA256_HEADER", function() {
    return SHA256_HEADER;
});
parcelHelpers.export(exports, "TOKEN_HEADER", function() {
    return TOKEN_HEADER;
});
parcelHelpers.export(exports, "HOST_HEADER", function() {
    return HOST_HEADER;
});
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", function() {
    return ALWAYS_UNSIGNABLE_HEADERS;
});
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", function() {
    return PROXY_HEADER_PATTERN;
});
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", function() {
    return SEC_HEADER_PATTERN;
});
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", function() {
    return UNSIGNABLE_PATTERNS;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", function() {
    return ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", function() {
    return ALGORITHM_IDENTIFIER_V4A;
});
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", function() {
    return EVENT_ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", function() {
    return UNSIGNED_PAYLOAD;
});
parcelHelpers.export(exports, "MAX_CACHE_SIZE", function() {
    return MAX_CACHE_SIZE;
});
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", function() {
    return KEY_TYPE_IDENTIFIER;
});
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", function() {
    return MAX_PRESIGNED_TTL;
});
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Ay5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", function() {
    return createScope;
});
parcelHelpers.export(exports, "getSigningKey", function() {
    return getSigningKey;
});
parcelHelpers.export(exports, "clearCredentialCache", function() {
    return clearCredentialCache;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function createScope(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"2LppL","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"glkhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return getCanonicalHeaders;
});
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"86BcK","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBu4t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return getCanonicalQuery;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function _loop_1(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"gFLYo","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gFLYo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"4oTvF","./escape-uri-path":"7CXhJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4oTvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", function() {
    return escapeUri;
});
var escapeUri = function escapeUri(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7CXhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", function() {
    return escapeUriPath;
});
var _escapeUri = require("./escape-uri");
var escapeUriPath = function escapeUriPath(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"4oTvF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbirI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", function() {
    return getPayloadHash;
});
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/is-array-buffer":"fO0Lw","@aws-sdk/util-hex-encoding":"2LppL","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fO0Lw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", function() {
    return isArrayBuffer;
});
var isArrayBuffer = function isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e1gG6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", function() {
    return hasHeader;
});
parcelHelpers.export(exports, "getHeaderValue", function() {
    return getHeaderValue;
});
parcelHelpers.export(exports, "deleteHeader", function() {
    return deleteHeader;
});
var _tslib = require("tslib");
var hasHeader = function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function getHeaderValue(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function deleteHeader(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"beRjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return moveHeadersToQuery;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"86BcK","./cloneRequest":"3k3gD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3k3gD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", function() {
    return cloneRequest;
});
parcelHelpers.export(exports, "cloneQuery", function() {
    return cloneQuery;
});
var _tslib = require("tslib");
var cloneRequest = function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kXIRz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", function() {
    return prepareRequest;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function prepareRequest(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"86BcK","./cloneRequest":"3k3gD","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3FVMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", function() {
    return iso8601;
});
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
var iso8601 = function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b357s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", function() {
    return awsAuthMiddleware;
});
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", function() {
    return awsAuthMiddlewareOptions;
});
parcelHelpers.export(exports, "getAwsAuthPlugin", function() {
    return getAwsAuthPlugin;
});
parcelHelpers.export(exports, "getSigV4AuthPlugin", function() {
    return getSigV4AuthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function getDateHeader(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function getAwsAuthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./utils/getSkewCorrectedDate":"518Bv","./utils/getUpdatedSystemClockOffset":"gLERW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"518Bv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", function() {
    return getSkewCorrectedDate;
});
var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gLERW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", function() {
    return getUpdatedSystemClockOffset;
});
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function getUpdatedSystemClockOffset(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"6asaS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6asaS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", function() {
    return isClockSkewed;
});
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function isClockSkewed(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"518Bv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8E67h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"dRbDD","./user-agent-middleware":"4Uklr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRbDD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", function() {
    return resolveUserAgentConfig;
});
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Uklr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return userAgentMiddleware;
});
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", function() {
    return getUserAgentMiddlewareOptions;
});
parcelHelpers.export(exports, "getUserAgentPlugin", function() {
    return getUserAgentPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function userAgentMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function escapeUserAgent(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function getUserAgentPlugin(config) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./constants":"9JZPR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JZPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", function() {
    return USER_AGENT;
});
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", function() {
    return X_AMZ_USER_AGENT;
});
parcelHelpers.export(exports, "SPACE", function() {
    return SPACE;
});
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", function() {
    return UA_ESCAPE_REGEX;
});
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"alQg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"5rm7f","./command":"j5DTN","./constants":"gScML","./date-utils":"6obag","./default-error-handler":"bs7hr","./defaults-mode":"1ODvk","./emitWarningIfUnsupportedVersion":"dM5eG","./exceptions":"7a9Y9","./extended-encode-uri-component":"1E3WA","./get-array-if-single-item":"3C1eR","./get-value-from-text-node":"2whIO","./lazy-json":"2sD0L","./object-mapping":"7BD7s","./parse-utils":"8DCnR","./resolve-path":"16FIx","./ser-utils":"3CiOx","./split-every":"idSjo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rm7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"3LtOU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LtOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"2AYZg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2AYZg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", function() {
    return constructStack;
});
var _tslib = require("tslib");
var constructStack = function constructStack1() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function sort(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function removeByName(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function removeByReference(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function cloneTo(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function expandRelativeMiddlewareList1(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function getMiddlewareList(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function add(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"".concat(name, "\" middleware with ").concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function addRelativeTo(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"".concat(name, "\" middleware ").concat(toOverride.relation, " \"").concat(toOverride.toMiddleware, "\" middleware cannot be overridden ") + "by same-name middleware ".concat(entry.relation, " \"").concat(entry.toMiddleware, "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function clone() {
            return cloneTo(constructStack());
        },
        use: function use(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function remove(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function removeByTag(toRemove) {
            var isRemoved = false;
            var filterCb = function filterCb(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function concat(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function identify() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function resolve(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j5DTN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", function() {
    return Command;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"3LtOU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gScML":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", function() {
    return SENSITIVE_STRING;
});
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6obag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", function() {
    return dateToUtcString;
});
parcelHelpers.export(exports, "parseRfc3339DateTime", function() {
    return parseRfc3339DateTime;
});
parcelHelpers.export(exports, "parseRfc7231DateTime", function() {
    return parseRfc7231DateTime;
});
parcelHelpers.export(exports, "parseEpochTimestamp", function() {
    return parseEpochTimestamp;
});
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function parseRfc3339DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function parseRfc7231DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function parseEpochTimestamp(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function buildDate(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function parseTwoDigitYear(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function adjustRfc850Year(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function parseMonthByShortName(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function validateDayOfMonth(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function parseDateValue(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function parseMilliseconds(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function stripLeadingZeroes(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"86BcK","./parse-utils":"8DCnR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8DCnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", function() {
    return parseBoolean;
});
parcelHelpers.export(exports, "expectBoolean", function() {
    return expectBoolean;
});
parcelHelpers.export(exports, "expectNumber", function() {
    return expectNumber;
});
parcelHelpers.export(exports, "expectFloat32", function() {
    return expectFloat32;
});
parcelHelpers.export(exports, "expectLong", function() {
    return expectLong;
});
parcelHelpers.export(exports, "expectInt", function() {
    return expectInt;
});
parcelHelpers.export(exports, "expectInt32", function() {
    return expectInt32;
});
parcelHelpers.export(exports, "expectShort", function() {
    return expectShort;
});
parcelHelpers.export(exports, "expectByte", function() {
    return expectByte;
});
parcelHelpers.export(exports, "expectNonNull", function() {
    return expectNonNull;
});
parcelHelpers.export(exports, "expectObject", function() {
    return expectObject;
});
parcelHelpers.export(exports, "expectString", function() {
    return expectString;
});
parcelHelpers.export(exports, "expectUnion", function() {
    return expectUnion;
});
parcelHelpers.export(exports, "strictParseDouble", function() {
    return strictParseDouble;
});
parcelHelpers.export(exports, "strictParseFloat", function() {
    return strictParseFloat;
});
parcelHelpers.export(exports, "strictParseFloat32", function() {
    return strictParseFloat32;
});
parcelHelpers.export(exports, "limitedParseDouble", function() {
    return limitedParseDouble;
});
parcelHelpers.export(exports, "handleFloat", function() {
    return handleFloat;
});
parcelHelpers.export(exports, "limitedParseFloat", function() {
    return limitedParseFloat;
});
parcelHelpers.export(exports, "limitedParseFloat32", function() {
    return limitedParseFloat32;
});
parcelHelpers.export(exports, "strictParseLong", function() {
    return strictParseLong;
});
parcelHelpers.export(exports, "strictParseInt", function() {
    return strictParseInt;
});
parcelHelpers.export(exports, "strictParseInt32", function() {
    return strictParseInt32;
});
parcelHelpers.export(exports, "strictParseShort", function() {
    return strictParseShort;
});
parcelHelpers.export(exports, "strictParseByte", function() {
    return strictParseByte;
});
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var parseBoolean = function parseBoolean(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error("Unable to parse boolean value \"".concat(value, "\""));
    }
};
var expectBoolean = function expectBoolean(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectNumber = function expectNumber(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function expectFloat32(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function expectLong(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function expectInt32(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function expectShort(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function expectByte(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function expectSizedInt(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function castInt(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function expectNonNull(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function expectObject(value) {
    if (value === null || value === undefined) return undefined;
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function expectString(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value))) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectUnion = function expectUnion(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function strictParseDouble(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function strictParseFloat32(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function parseNumber(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function limitedParseDouble(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function limitedParseFloat32(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function parseFloatString(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function strictParseLong(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function strictParseInt32(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function strictParseShort(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function strictParseByte(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function stackTraceWarning(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bs7hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", function() {
    return throwDefaultError;
});
var _exceptions = require("./exceptions");
var throwDefaultError = function throwDefaultError(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"7a9Y9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a9Y9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", function() {
    return ServiceException;
});
parcelHelpers.export(exports, "decorateServiceException", function() {
    return decorateServiceException;
});
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function decorateServiceException(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ODvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", function() {
    return loadConfigsForDefaultMode;
});
var loadConfigsForDefaultMode = function loadConfigsForDefaultMode(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dM5eG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", function() {
    return emitWarningIfUnsupportedVersion;
});
var process = require("829cfc0ffb172e56");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function emitWarningIfUnsupportedVersion(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"829cfc0ffb172e56":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1E3WA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return extendedEncodeURIComponent;
});
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3C1eR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", function() {
    return getArrayIfSingleItem;
});
var getArrayIfSingleItem = function getArrayIfSingleItem(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2whIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", function() {
    return getValueFromTextNode;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var getValueFromTextNode = function getValueFromTextNode1(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if ((0, _typeOf._)(obj[key]) === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sD0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", function() {
    return StringWrapper;
});
parcelHelpers.export(exports, "LazyJsonString", function() {
    return LazyJsonString;
});
var _tslib = require("tslib");
var StringWrapper = function StringWrapper() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7BD7s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "convertMap", function() {
    return convertMap;
});
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function convertMap(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function mapWithFilter(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"16FIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", function() {
    return resolvedPath;
});
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function resolvedPath(_resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        _resolvedPath = _resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return _resolvedPath;
};

},{"./extended-encode-uri-component":"1E3WA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3CiOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", function() {
    return serializeFloat;
});
var serializeFloat = function serializeFloat(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"idSjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", function() {
    return splitEvery;
});
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4LcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function defaultConfigProvider() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"86BcK","../package.json":"c5v9L","@aws-crypto/sha256-browser":"lGVg4","@aws-sdk/config-resolver":"gu4pD","@aws-sdk/fetch-http-handler":"aYKXX","@aws-sdk/invalid-dependency":"6Zzfj","@aws-sdk/middleware-retry":"fR8xr","@aws-sdk/util-base64-browser":"cXiT2","@aws-sdk/util-body-length-browser":"gnPhH","@aws-sdk/util-user-agent-browser":"adKTH","@aws-sdk/util-utf8-browser":"3N6ZC","./runtimeConfig.shared":"i9C8V","@aws-sdk/smithy-client":"alQg0","@aws-sdk/util-defaults-mode-browser":"gpbLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5v9L":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-lex-runtime-service\",\"description\":\"AWS SDK for JavaScript Lex Runtime Service Client for Node.js, Browser and React Native\",\"version\":\"3.186.4\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"tsc -p tsconfig.cjs.json\",\"build:docs\":\"typedoc\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"test\":\"yarn test:unit\",\"test:unit\":\"ts-mocha test/**/*.spec.ts\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"2.0.0\",\"@aws-crypto/sha256-js\":\"2.0.0\",\"@aws-sdk/client-sts\":\"3.186.4\",\"@aws-sdk/config-resolver\":\"3.186.0\",\"@aws-sdk/credential-provider-node\":\"3.186.0\",\"@aws-sdk/fetch-http-handler\":\"3.186.0\",\"@aws-sdk/hash-node\":\"3.186.0\",\"@aws-sdk/invalid-dependency\":\"3.186.0\",\"@aws-sdk/middleware-content-length\":\"3.186.0\",\"@aws-sdk/middleware-host-header\":\"3.186.0\",\"@aws-sdk/middleware-logger\":\"3.186.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.186.0\",\"@aws-sdk/middleware-retry\":\"3.186.0\",\"@aws-sdk/middleware-serde\":\"3.186.0\",\"@aws-sdk/middleware-signing\":\"3.186.0\",\"@aws-sdk/middleware-stack\":\"3.186.0\",\"@aws-sdk/middleware-user-agent\":\"3.186.0\",\"@aws-sdk/node-config-provider\":\"3.186.0\",\"@aws-sdk/node-http-handler\":\"3.186.0\",\"@aws-sdk/protocol-http\":\"3.186.0\",\"@aws-sdk/smithy-client\":\"3.186.0\",\"@aws-sdk/types\":\"3.186.0\",\"@aws-sdk/url-parser\":\"3.186.0\",\"@aws-sdk/util-base64-browser\":\"3.186.0\",\"@aws-sdk/util-base64-node\":\"3.186.0\",\"@aws-sdk/util-body-length-browser\":\"3.186.0\",\"@aws-sdk/util-body-length-node\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-browser\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-node\":\"3.186.0\",\"@aws-sdk/util-user-agent-browser\":\"3.186.0\",\"@aws-sdk/util-user-agent-node\":\"3.186.0\",\"@aws-sdk/util-utf8-browser\":\"3.186.0\",\"@aws-sdk/util-utf8-node\":\"3.186.0\",\"tslib\":\"^2.3.1\"},\"devDependencies\":{\"@aws-sdk/service-client-documentation-generator\":\"3.186.0\",\"@tsconfig/recommended\":\"1.0.1\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^12.7.5\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typedoc\":\"0.19.2\",\"typescript\":\"~4.6.2\"},\"overrides\":{\"typedoc\":{\"typescript\":\"~4.6.2\"}},\"engines\":{\"node\":\">=12.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-service\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-lex-runtime-service\"}}");

},{}],"lGVg4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("d869f679f32f407d");
(0, tslib_1.__exportStar)(require("b0f537c8404fabe7"), exports);
var ie11Sha256_1 = require("ce93437bcebd91ab");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function get() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("68cca9e6fee69adf");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function get() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"d869f679f32f407d":"f3j8T","b0f537c8404fabe7":"2Z80W","ce93437bcebd91ab":"8M3DA","68cca9e6fee69adf":"kgHl2"}],"f3j8T":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Z80W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("453cd7d5fb36332a");
var webCryptoSha256_1 = require("ef4321517786adfd");
var sha256_js_1 = require("e69e134258c464b3");
var supports_web_crypto_1 = require("f6560285c113a981");
var ie11_detection_1 = require("7008797b0496e8b2");
var util_locate_window_1 = require("4579f58fc373ace9");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"453cd7d5fb36332a":"8M3DA","ef4321517786adfd":"kgHl2","e69e134258c464b3":"iDAqR","f6560285c113a981":"gGrlG","7008797b0496e8b2":"aTIbG","4579f58fc373ace9":"ljvil"}],"8M3DA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("bf6d3fc2e60ba76d");
var constants_1 = require("b87616627cf2e0f5");
var util_utf8_browser_1 = require("f850988d1d541c92");
var util_locate_window_1 = require("e2bdadc602eaf4f6");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"bf6d3fc2e60ba76d":"a2Ugv","b87616627cf2e0f5":"32UPK","f850988d1d541c92":"3N6ZC","e2bdadc602eaf4f6":"ljvil"}],"a2Ugv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"32UPK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"3N6ZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function fromUtf8(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function toUtf8(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"doi3l","./whatwgEncodingApi":"lCpEM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"doi3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var fromUtf8 = function fromUtf8(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function toUtf8(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lCpEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kgHl2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("43a5977a498abeed");
var constants_1 = require("c3ed919bd9996f19");
var util_locate_window_1 = require("c35752418ef0f254");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"43a5977a498abeed":"8fK1S","c3ed919bd9996f19":"32UPK","c35752418ef0f254":"ljvil"}],"8fK1S":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("9193df0db021fb26");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function get() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("459998af8963a091");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function get() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("b42a68361f012efb");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function get() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("b7e6168de801e09f");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function get() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"9193df0db021fb26":"dniPO","459998af8963a091":"9nkeM","b42a68361f012efb":"fykUp","b7e6168de801e09f":"gl7iq"}],"dniPO":[function(require,module,exports,__globalThis) {
var Buffer = require("721a4c132673e957").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f3d90b8be1dc9038");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function fromUtf8(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"721a4c132673e957":"cvSE8","f3d90b8be1dc9038":"3N6ZC"}],"9nkeM":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"fykUp":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"gl7iq":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"iDAqR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("418d1b4dc54207be");
(0, tslib_1.__exportStar)(require("6982378e65309145"), exports);

},{"418d1b4dc54207be":"j1GTA","6982378e65309145":"eEURr"}],"j1GTA":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eEURr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("ab77c912e1099c27");
var constants_1 = require("ce9cc4978892bad6");
var RawSha256_1 = require("ea4a3f6061c5aada");
var util_1 = require("ec7e02f81b214b94");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"ab77c912e1099c27":"j1GTA","ce9cc4978892bad6":"gXt9h","ea4a3f6061c5aada":"kcc1i","ec7e02f81b214b94":"8fK1S"}],"gXt9h":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"kcc1i":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("36bcd02814e436e3");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"36bcd02814e436e3":"gXt9h"}],"gGrlG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("d4ba5b9f002454df");
tslib_1.__exportStar(require("42b6a840a4585dcd"), exports);

},{"d4ba5b9f002454df":"gF2FI","42b6a840a4585dcd":"aqGWG"}],"gF2FI":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aqGWG":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("467da325f4507076");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && (0, _typeOf._)(window.crypto.subtle) === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" && (0, _typeOf._)(window.crypto) === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"@swc/helpers/_/_type_of":"668P4","467da325f4507076":"gF2FI"}],"aTIbG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("4e93ca2400d71317");
tslib_1.__exportStar(require("f6df223ac5240f29"), exports);
tslib_1.__exportStar(require("c68313cfb7180b41"), exports);
tslib_1.__exportStar(require("46c26437e48ef7b3"), exports);
tslib_1.__exportStar(require("903a910efecb3acb"), exports);
tslib_1.__exportStar(require("bea87aa20e4b99bd"), exports);

},{"4e93ca2400d71317":"hmuDU","f6df223ac5240f29":"bdF35","c68313cfb7180b41":"8SweG","46c26437e48ef7b3":"76wxZ","903a910efecb3acb":"3xdwY","bea87aa20e4b99bd":"1Ty8Q"}],"hmuDU":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bdF35":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"8SweG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"76wxZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"3xdwY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1Ty8Q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"aYKXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"dGqow","./stream-collector":"m8aaR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGqow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", function() {
    return FetchHttpHandler;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _$_a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_$_a = _b.return)) _$_a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/querystring-builder":"dxT9Q","./request-timeout":"4Ne3U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxT9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", function() {
    return buildQueryString;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"gFLYo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Ne3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", function() {
    return requestTimeout;
});
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"m8aaR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", function() {
    return streamCollector;
});
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function streamCollector(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"86BcK","@aws-sdk/util-base64-browser":"cXiT2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cXiT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", function() {
    return fromBase64;
});
parcelHelpers.export(exports, "toBase64", function() {
    return toBase64;
});
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Zzfj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"4keLO","./invalidProvider":"2UYGf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4keLO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", function() {
    return invalidFunction;
});
var invalidFunction = function invalidFunction(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2UYGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", function() {
    return invalidProvider;
});
var invalidProvider = function invalidProvider(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gnPhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"drduY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drduY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", function() {
    return calculateBodyLength;
});
var calculateBodyLength = function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"adKTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", function() {
    return defaultUserAgent;
});
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function defaultUserAgent(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _$_a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_$_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _$_a === void 0 ? void 0 : _$_a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"86BcK","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9C8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2016-11-28",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lex Runtime Service",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"9rmyt","./endpoints":"hwk60","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9rmyt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function parseUrl1(url) {
    if (typeof url === 'string') return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"9eFh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eFh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", function() {
    return parseQueryString;
});
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwk60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {
    "us-east-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-east-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-gov-west-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-gov-west-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-west-2": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-west-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    }
};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-1-fips",
            "us-east-2",
            "us-west-1",
            "us-west-2",
            "us-west-2-fips"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1",
            "us-gov-west-1-fips"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "lex",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/config-resolver":"gu4pD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gpbLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resolveDefaultsModeConfig = require("./resolveDefaultsModeConfig");
parcelHelpers.exportAll(_resolveDefaultsModeConfig, exports);

},{"./resolveDefaultsModeConfig":"br1ph","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"br1ph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveDefaultsModeConfig", function() {
    return resolveDefaultsModeConfig;
});
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var _constants = require("./constants");
var resolveDefaultsModeConfig = function resolveDefaultsModeConfig(_a) {
    var _b = _a === void 0 ? {} : _a, defaultsMode = _b.defaultsMode;
    return (0, _propertyProvider.memoize)(function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var mode, _$_a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof defaultsMode === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            defaultsMode()
                        ];
                    case 1:
                        _$_a = _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _$_a = defaultsMode;
                        _b.label = 3;
                    case 3:
                        mode = _$_a;
                        switch(mode === null || mode === void 0 ? void 0 : mode.toLowerCase()){
                            case "auto":
                                return [
                                    2,
                                    Promise.resolve(isMobileBrowser() ? "mobile" : "standard")
                                ];
                            case "mobile":
                            case "in-region":
                            case "cross-region":
                            case "standard":
                            case "legacy":
                                return [
                                    2,
                                    Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase())
                                ];
                            case undefined:
                                return [
                                    2,
                                    Promise.resolve("legacy")
                                ];
                            default:
                                throw new Error("Invalid parameter for \"defaultsMode\", expect ".concat((0, _constants.DEFAULTS_MODE_OPTIONS).join(", "), ", got ").concat(mode));
                        }
                        return [
                            2
                        ];
                }
            });
        });
    });
};
var isMobileBrowser = function isMobileBrowser() {
    var _a, _b;
    var parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
    var platform = (_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.platform) === null || _b === void 0 ? void 0 : _b.type;
    return platform === "tablet" || platform === "mobile";
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"a0t3P","bowser":"E5jm7","./constants":"fclGj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0t3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"Lil5i","./ProviderError":"6d2lg","./TokenProviderError":"dp0z4","./chain":"bnGGl","./fromStatic":"8Iwth","./memoize":"dfFCm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Lil5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", function() {
    return CredentialsProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6d2lg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", function() {
    return ProviderError;
});
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dp0z4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", function() {
    return TokenProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bnGGl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", function() {
    return chain;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function _loop_1(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Iwth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", function() {
    return fromStatic;
});
var fromStatic = function fromStatic(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dfFCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
var _tslib = require("tslib");
var memoize = function memoize(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function coalesceProvider() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fclGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULTS_MODE_OPTIONS", function() {
    return DEFAULTS_MODE_OPTIONS;
});
var DEFAULTS_MODE_OPTIONS = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drgSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deleteSessionCommand = require("./DeleteSessionCommand");
parcelHelpers.exportAll(_deleteSessionCommand, exports);
var _getSessionCommand = require("./GetSessionCommand");
parcelHelpers.exportAll(_getSessionCommand, exports);
var _postContentCommand = require("./PostContentCommand");
parcelHelpers.exportAll(_postContentCommand, exports);
var _postTextCommand = require("./PostTextCommand");
parcelHelpers.exportAll(_postTextCommand, exports);
var _putSessionCommand = require("./PutSessionCommand");
parcelHelpers.exportAll(_putSessionCommand, exports);

},{"./DeleteSessionCommand":false,"./GetSessionCommand":false,"./PostContentCommand":"hVNkY","./PostTextCommand":"2kixx","./PutSessionCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVNkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostContentCommand", function() {
    return PostContentCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostContentCommand = function(_super) {
    (0, _tslib.__extends)(PostContentCommand, _super);
    function PostContentCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostContentCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostContentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostContentRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostContentResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostContentCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostContentCommand)(input, context);
    };
    PostContentCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostContentCommand)(output, context);
    };
    return PostContentCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"8ZTRr","@aws-sdk/smithy-client":"alQg0","../models/models_0":"l9pMX","../protocols/Aws_restJson1":"esFav","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ZTRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"5RECM","./serdePlugin":"136kt","./serializerMiddleware":"gMbhA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RECM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", function() {
    return deserializerMiddleware;
});
var _tslib = require("tslib");
var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"136kt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", function() {
    return deserializerMiddlewareOption;
});
parcelHelpers.export(exports, "serializerMiddlewareOption", function() {
    return serializerMiddlewareOption;
});
parcelHelpers.export(exports, "getSerdePlugin", function() {
    return getSerdePlugin;
});
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function applyToStack(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"5RECM","./serializerMiddleware":"gMbhA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMbhA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", function() {
    return serializerMiddleware;
});
var _tslib = require("tslib");
var serializerMiddleware = function serializerMiddleware(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function endpoint() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9pMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadRequestException", function() {
    return BadRequestException;
});
parcelHelpers.export(exports, "ConflictException", function() {
    return ConflictException;
});
parcelHelpers.export(exports, "InternalFailureException", function() {
    return InternalFailureException;
});
parcelHelpers.export(exports, "LimitExceededException", function() {
    return LimitExceededException;
});
parcelHelpers.export(exports, "NotFoundException", function() {
    return NotFoundException;
});
parcelHelpers.export(exports, "FulfillmentState", function() {
    return FulfillmentState;
});
parcelHelpers.export(exports, "MessageFormatType", function() {
    return MessageFormatType;
});
parcelHelpers.export(exports, "DialogActionType", function() {
    return DialogActionType;
});
parcelHelpers.export(exports, "ConfirmationStatus", function() {
    return ConfirmationStatus;
});
parcelHelpers.export(exports, "BadGatewayException", function() {
    return BadGatewayException;
});
parcelHelpers.export(exports, "DependencyFailedException", function() {
    return DependencyFailedException;
});
parcelHelpers.export(exports, "LoopDetectedException", function() {
    return LoopDetectedException;
});
parcelHelpers.export(exports, "NotAcceptableException", function() {
    return NotAcceptableException;
});
parcelHelpers.export(exports, "DialogState", function() {
    return DialogState;
});
parcelHelpers.export(exports, "RequestTimeoutException", function() {
    return RequestTimeoutException;
});
parcelHelpers.export(exports, "UnsupportedMediaTypeException", function() {
    return UnsupportedMediaTypeException;
});
parcelHelpers.export(exports, "ContentType", function() {
    return ContentType;
});
parcelHelpers.export(exports, "ActiveContextTimeToLiveFilterSensitiveLog", function() {
    return ActiveContextTimeToLiveFilterSensitiveLog;
});
parcelHelpers.export(exports, "ActiveContextFilterSensitiveLog", function() {
    return ActiveContextFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteSessionRequestFilterSensitiveLog", function() {
    return DeleteSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteSessionResponseFilterSensitiveLog", function() {
    return DeleteSessionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetSessionRequestFilterSensitiveLog", function() {
    return GetSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DialogActionFilterSensitiveLog", function() {
    return DialogActionFilterSensitiveLog;
});
parcelHelpers.export(exports, "IntentSummaryFilterSensitiveLog", function() {
    return IntentSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetSessionResponseFilterSensitiveLog", function() {
    return GetSessionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PostContentRequestFilterSensitiveLog", function() {
    return PostContentRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "PostContentResponseFilterSensitiveLog", function() {
    return PostContentResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PostTextRequestFilterSensitiveLog", function() {
    return PostTextRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "IntentConfidenceFilterSensitiveLog", function() {
    return IntentConfidenceFilterSensitiveLog;
});
parcelHelpers.export(exports, "PredictedIntentFilterSensitiveLog", function() {
    return PredictedIntentFilterSensitiveLog;
});
parcelHelpers.export(exports, "ButtonFilterSensitiveLog", function() {
    return ButtonFilterSensitiveLog;
});
parcelHelpers.export(exports, "GenericAttachmentFilterSensitiveLog", function() {
    return GenericAttachmentFilterSensitiveLog;
});
parcelHelpers.export(exports, "ResponseCardFilterSensitiveLog", function() {
    return ResponseCardFilterSensitiveLog;
});
parcelHelpers.export(exports, "SentimentResponseFilterSensitiveLog", function() {
    return SentimentResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PostTextResponseFilterSensitiveLog", function() {
    return PostTextResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutSessionRequestFilterSensitiveLog", function() {
    return PutSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutSessionResponseFilterSensitiveLog", function() {
    return PutSessionResponseFilterSensitiveLog;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("./LexRuntimeServiceServiceException");
var BadRequestException = function(_super) {
    (0, _tslib.__extends)(BadRequestException, _super);
    function BadRequestException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadRequestException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "BadRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BadRequestException.prototype);
        return _this;
    }
    return BadRequestException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        return _this;
    }
    return ConflictException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var InternalFailureException = function(_super) {
    (0, _tslib.__extends)(InternalFailureException, _super);
    function InternalFailureException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalFailureException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalFailureException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalFailureException.prototype);
        return _this;
    }
    return InternalFailureException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LimitExceededException = function(_super) {
    (0, _tslib.__extends)(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        return _this;
    }
    return LimitExceededException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotFoundException = function(_super) {
    (0, _tslib.__extends)(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        return _this;
    }
    return NotFoundException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var FulfillmentState;
(function(FulfillmentState) {
    FulfillmentState["FAILED"] = "Failed";
    FulfillmentState["FULFILLED"] = "Fulfilled";
    FulfillmentState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(FulfillmentState || (FulfillmentState = {}));
var MessageFormatType;
(function(MessageFormatType) {
    MessageFormatType["COMPOSITE"] = "Composite";
    MessageFormatType["CUSTOM_PAYLOAD"] = "CustomPayload";
    MessageFormatType["PLAIN_TEXT"] = "PlainText";
    MessageFormatType["SSML"] = "SSML";
})(MessageFormatType || (MessageFormatType = {}));
var DialogActionType;
(function(DialogActionType) {
    DialogActionType["CLOSE"] = "Close";
    DialogActionType["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogActionType["DELEGATE"] = "Delegate";
    DialogActionType["ELICIT_INTENT"] = "ElicitIntent";
    DialogActionType["ELICIT_SLOT"] = "ElicitSlot";
})(DialogActionType || (DialogActionType = {}));
var ConfirmationStatus;
(function(ConfirmationStatus) {
    ConfirmationStatus["CONFIRMED"] = "Confirmed";
    ConfirmationStatus["DENIED"] = "Denied";
    ConfirmationStatus["NONE"] = "None";
})(ConfirmationStatus || (ConfirmationStatus = {}));
var BadGatewayException = function(_super) {
    (0, _tslib.__extends)(BadGatewayException, _super);
    function BadGatewayException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadGatewayException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "BadGatewayException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, BadGatewayException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return BadGatewayException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DependencyFailedException = function(_super) {
    (0, _tslib.__extends)(DependencyFailedException, _super);
    function DependencyFailedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "DependencyFailedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "DependencyFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DependencyFailedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return DependencyFailedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LoopDetectedException = function(_super) {
    (0, _tslib.__extends)(LoopDetectedException, _super);
    function LoopDetectedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LoopDetectedException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "LoopDetectedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, LoopDetectedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return LoopDetectedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotAcceptableException = function(_super) {
    (0, _tslib.__extends)(NotAcceptableException, _super);
    function NotAcceptableException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotAcceptableException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotAcceptableException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotAcceptableException.prototype);
        return _this;
    }
    return NotAcceptableException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DialogState;
(function(DialogState) {
    DialogState["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogState["ELICIT_INTENT"] = "ElicitIntent";
    DialogState["ELICIT_SLOT"] = "ElicitSlot";
    DialogState["FAILED"] = "Failed";
    DialogState["FULFILLED"] = "Fulfilled";
    DialogState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(DialogState || (DialogState = {}));
var RequestTimeoutException = function(_super) {
    (0, _tslib.__extends)(RequestTimeoutException, _super);
    function RequestTimeoutException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "RequestTimeoutException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "RequestTimeoutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RequestTimeoutException.prototype);
        return _this;
    }
    return RequestTimeoutException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var UnsupportedMediaTypeException = function(_super) {
    (0, _tslib.__extends)(UnsupportedMediaTypeException, _super);
    function UnsupportedMediaTypeException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "UnsupportedMediaTypeException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "UnsupportedMediaTypeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UnsupportedMediaTypeException.prototype);
        return _this;
    }
    return UnsupportedMediaTypeException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ContentType;
(function(ContentType) {
    ContentType["GENERIC"] = "application/vnd.amazonaws.card.generic";
})(ContentType || (ContentType = {}));
var ActiveContextTimeToLiveFilterSensitiveLog = function ActiveContextTimeToLiveFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ActiveContextFilterSensitiveLog = function ActiveContextFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.parameters && {
        parameters: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var DeleteSessionRequestFilterSensitiveLog = function DeleteSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteSessionResponseFilterSensitiveLog = function DeleteSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetSessionRequestFilterSensitiveLog = function GetSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DialogActionFilterSensitiveLog = function DialogActionFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentSummaryFilterSensitiveLog = function IntentSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetSessionResponseFilterSensitiveLog = function GetSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentRequestFilterSensitiveLog = function PostContentRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentResponseFilterSensitiveLog = function PostContentResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedInputTranscript && {
        encodedInputTranscript: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostTextRequestFilterSensitiveLog = function PostTextRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.inputText && {
        inputText: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentConfidenceFilterSensitiveLog = function IntentConfidenceFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PredictedIntentFilterSensitiveLog = function PredictedIntentFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ButtonFilterSensitiveLog = function ButtonFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GenericAttachmentFilterSensitiveLog = function GenericAttachmentFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ResponseCardFilterSensitiveLog = function ResponseCardFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SentimentResponseFilterSensitiveLog = function SentimentResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PostTextResponseFilterSensitiveLog = function PostTextResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.alternativeIntents && {
        alternativeIntents: obj.alternativeIntents.map(function(item) {
            return PredictedIntentFilterSensitiveLog(item);
        })
    }), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionRequestFilterSensitiveLog = function PutSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionResponseFilterSensitiveLog = function PutSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};

},{"tslib":"86BcK","@aws-sdk/smithy-client":"alQg0","./LexRuntimeServiceServiceException":"1vMJc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1vMJc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", function() {
    return LexRuntimeServiceServiceException;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LexRuntimeServiceServiceException = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceServiceException, _super);
    function LexRuntimeServiceServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LexRuntimeServiceServiceException.prototype);
        return _this;
    }
    return LexRuntimeServiceServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"alQg0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"esFav":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteSessionCommand", function() {
    return serializeAws_restJson1DeleteSessionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetSessionCommand", function() {
    return serializeAws_restJson1GetSessionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PostContentCommand", function() {
    return serializeAws_restJson1PostContentCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PostTextCommand", function() {
    return serializeAws_restJson1PostTextCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PutSessionCommand", function() {
    return serializeAws_restJson1PutSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteSessionCommand", function() {
    return deserializeAws_restJson1DeleteSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetSessionCommand", function() {
    return deserializeAws_restJson1GetSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PostContentCommand", function() {
    return deserializeAws_restJson1PostContentCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PostTextCommand", function() {
    return deserializeAws_restJson1PostTextCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutSessionCommand", function() {
    return deserializeAws_restJson1PutSessionCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("../models/LexRuntimeServiceServiceException");
var _models0 = require("../models/models_0");
var Buffer = require("140ff1ec17a71939").Buffer;
var serializeAws_restJson1DeleteSessionCommand = function serializeAws_restJson1DeleteSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetSessionCommand = function serializeAws_restJson1GetSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    query = map({
                        checkpointLabelFilter: [
                            ,
                            input.checkpointLabelFilter
                        ]
                    });
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostContentCommand = function serializeAws_restJson1PostContentCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
                        "content-type": input.contentType || "application/octet-stream",
                        "x-amz-lex-session-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.sessionAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.sessionAttributes)));
                            }
                        ],
                        "x-amz-lex-request-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.requestAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.requestAttributes)));
                            }
                        ],
                        accept: input.accept,
                        "x-amz-lex-active-contexts": [
                            function() {
                                return isSerializableHeaderValue(input.activeContexts);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.activeContexts)));
                            }
                        ]
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/content";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    if (input.inputStream !== undefined) body = input.inputStream;
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostTextCommand = function serializeAws_restJson1PostTextCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.inputText != null && {
                        inputText: input.inputText
                    }), input.requestAttributes != null && {
                        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutSessionCommand = function serializeAws_restJson1PutSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "content-type": "application/json",
                        accept: input.accept
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.dialogAction != null && {
                        dialogAction: serializeAws_restJson1DialogAction(input.dialogAction, context)
                    }), input.recentIntentSummaryView != null && {
                        recentIntentSummaryView: serializeAws_restJson1IntentSummaryList(input.recentIntentSummaryView, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommand = function deserializeAws_restJson1DeleteSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.botAlias != null) contents.botAlias = (0, _smithyClient.expectString)(data.botAlias);
                    if (data.botName != null) contents.botName = (0, _smithyClient.expectString)(data.botName);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.userId != null) contents.userId = (0, _smithyClient.expectString)(data.userId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommandError = function deserializeAws_restJson1DeleteSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommand = function deserializeAws_restJson1GetSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.dialogAction != null) contents.dialogAction = deserializeAws_restJson1DialogAction(data.dialogAction, context);
                    if (data.recentIntentSummaryView != null) contents.recentIntentSummaryView = deserializeAws_restJson1IntentSummaryList(data.recentIntentSummaryView, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommandError = function deserializeAws_restJson1GetSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostContentCommand = function deserializeAws_restJson1PostContentCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PostContentCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                nluIntentConfidence: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-nlu-intent-confidence"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-nlu-intent-confidence"])).toString("utf8"));
                    }
                ],
                alternativeIntents: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-alternative-intents"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-alternative-intents"])).toString("utf8"));
                    }
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                sentimentResponse: [
                    ,
                    output.headers["x-amz-lex-sentiment"]
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                inputTranscript: [
                    ,
                    output.headers["x-amz-lex-input-transcript"]
                ],
                encodedInputTranscript: [
                    ,
                    output.headers["x-amz-lex-encoded-input-transcript"]
                ],
                botVersion: [
                    ,
                    output.headers["x-amz-lex-bot-version"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PostContentCommandError = function deserializeAws_restJson1PostContentCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.lexruntimeservice#RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.lexruntimeservice#UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                    }
                    return [
                        3,
                        24
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    return [
                        4,
                        deserializeAws_restJson1RequestTimeoutExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    throw _d.sent();
                case 22:
                    return [
                        4,
                        deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context)
                    ];
                case 23:
                    throw _d.sent();
                case 24:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 25;
                case 25:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommand = function deserializeAws_restJson1PostTextCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PostTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.alternativeIntents != null) contents.alternativeIntents = deserializeAws_restJson1IntentList(data.alternativeIntents, context);
                    if (data.botVersion != null) contents.botVersion = (0, _smithyClient.expectString)(data.botVersion);
                    if (data.dialogState != null) contents.dialogState = (0, _smithyClient.expectString)(data.dialogState);
                    if (data.intentName != null) contents.intentName = (0, _smithyClient.expectString)(data.intentName);
                    if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
                    if (data.messageFormat != null) contents.messageFormat = (0, _smithyClient.expectString)(data.messageFormat);
                    if (data.nluIntentConfidence != null) contents.nluIntentConfidence = deserializeAws_restJson1IntentConfidence(data.nluIntentConfidence, context);
                    if (data.responseCard != null) contents.responseCard = deserializeAws_restJson1ResponseCard(data.responseCard, context);
                    if (data.sentimentResponse != null) contents.sentimentResponse = deserializeAws_restJson1SentimentResponse(data.sentimentResponse, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.slotToElicit != null) contents.slotToElicit = (0, _smithyClient.expectString)(data.slotToElicit);
                    if (data.slots != null) contents.slots = deserializeAws_restJson1StringMap(data.slots, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommandError = function deserializeAws_restJson1PostTextCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutSessionCommand = function deserializeAws_restJson1PutSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PutSessionCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PutSessionCommandError = function deserializeAws_restJson1PutSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1BadGatewayExceptionResponse = function deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.BadGatewayException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1BadRequestExceptionResponse = function deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.BadRequestException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1DependencyFailedExceptionResponse = function deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.DependencyFailedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalFailureExceptionResponse = function deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalFailureException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LimitExceededExceptionResponse = function deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({
                retryAfterSeconds: [
                    ,
                    parsedOutput.headers["retry-after"]
                ]
            });
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.LimitExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LoopDetectedExceptionResponse = function deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.LoopDetectedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotAcceptableExceptionResponse = function deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotAcceptableException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotFoundExceptionResponse = function deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1RequestTimeoutExceptionResponse = function deserializeAws_restJson1RequestTimeoutExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.RequestTimeoutException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse = function deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.UnsupportedMediaTypeException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1ActiveContext = function serializeAws_restJson1ActiveContext(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.name != null && {
        name: input.name
    }), input.parameters != null && {
        parameters: serializeAws_restJson1ActiveContextParametersMap(input.parameters, context)
    }), input.timeToLive != null && {
        timeToLive: serializeAws_restJson1ActiveContextTimeToLive(input.timeToLive, context)
    });
};
var serializeAws_restJson1ActiveContextParametersMap = function serializeAws_restJson1ActiveContextParametersMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1ActiveContextsList = function serializeAws_restJson1ActiveContextsList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1ActiveContext(entry, context);
    });
};
var serializeAws_restJson1ActiveContextTimeToLive = function serializeAws_restJson1ActiveContextTimeToLive(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.timeToLiveInSeconds != null && {
        timeToLiveInSeconds: input.timeToLiveInSeconds
    }), input.turnsToLive != null && {
        turnsToLive: input.turnsToLive
    });
};
var serializeAws_restJson1DialogAction = function serializeAws_restJson1DialogAction(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.message != null && {
        message: input.message
    }), input.messageFormat != null && {
        messageFormat: input.messageFormat
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    }), input.type != null && {
        type: input.type
    });
};
var serializeAws_restJson1IntentSummary = function serializeAws_restJson1IntentSummary(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.checkpointLabel != null && {
        checkpointLabel: input.checkpointLabel
    }), input.confirmationStatus != null && {
        confirmationStatus: input.confirmationStatus
    }), input.dialogActionType != null && {
        dialogActionType: input.dialogActionType
    }), input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    });
};
var serializeAws_restJson1IntentSummaryList = function serializeAws_restJson1IntentSummaryList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1IntentSummary(entry, context);
    });
};
var serializeAws_restJson1StringMap = function serializeAws_restJson1StringMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_restJson1ActiveContext = function deserializeAws_restJson1ActiveContext(output, context) {
    return {
        name: (0, _smithyClient.expectString)(output.name),
        parameters: output.parameters != null ? deserializeAws_restJson1ActiveContextParametersMap(output.parameters, context) : undefined,
        timeToLive: output.timeToLive != null ? deserializeAws_restJson1ActiveContextTimeToLive(output.timeToLive, context) : undefined
    };
};
var deserializeAws_restJson1ActiveContextParametersMap = function deserializeAws_restJson1ActiveContextParametersMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1ActiveContextsList = function deserializeAws_restJson1ActiveContextsList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ActiveContext(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ActiveContextTimeToLive = function deserializeAws_restJson1ActiveContextTimeToLive(output, context) {
    return {
        timeToLiveInSeconds: (0, _smithyClient.expectInt32)(output.timeToLiveInSeconds),
        turnsToLive: (0, _smithyClient.expectInt32)(output.turnsToLive)
    };
};
var deserializeAws_restJson1Button = function deserializeAws_restJson1Button(output, context) {
    return {
        text: (0, _smithyClient.expectString)(output.text),
        value: (0, _smithyClient.expectString)(output.value)
    };
};
var deserializeAws_restJson1DialogAction = function deserializeAws_restJson1DialogAction(output, context) {
    return {
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        message: (0, _smithyClient.expectString)(output.message),
        messageFormat: (0, _smithyClient.expectString)(output.messageFormat),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined,
        type: (0, _smithyClient.expectString)(output.type)
    };
};
var deserializeAws_restJson1GenericAttachment = function deserializeAws_restJson1GenericAttachment(output, context) {
    return {
        attachmentLinkUrl: (0, _smithyClient.expectString)(output.attachmentLinkUrl),
        buttons: output.buttons != null ? deserializeAws_restJson1listOfButtons(output.buttons, context) : undefined,
        imageUrl: (0, _smithyClient.expectString)(output.imageUrl),
        subTitle: (0, _smithyClient.expectString)(output.subTitle),
        title: (0, _smithyClient.expectString)(output.title)
    };
};
var deserializeAws_restJson1genericAttachmentList = function deserializeAws_restJson1genericAttachmentList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1GenericAttachment(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentConfidence = function deserializeAws_restJson1IntentConfidence(output, context) {
    return {
        score: (0, _smithyClient.limitedParseDouble)(output.score)
    };
};
var deserializeAws_restJson1IntentList = function deserializeAws_restJson1IntentList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1PredictedIntent(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentSummary = function deserializeAws_restJson1IntentSummary(output, context) {
    return {
        checkpointLabel: (0, _smithyClient.expectString)(output.checkpointLabel),
        confirmationStatus: (0, _smithyClient.expectString)(output.confirmationStatus),
        dialogActionType: (0, _smithyClient.expectString)(output.dialogActionType),
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1IntentSummaryList = function deserializeAws_restJson1IntentSummaryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1IntentSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1listOfButtons = function deserializeAws_restJson1listOfButtons(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Button(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PredictedIntent = function deserializeAws_restJson1PredictedIntent(output, context) {
    return {
        intentName: (0, _smithyClient.expectString)(output.intentName),
        nluIntentConfidence: output.nluIntentConfidence != null ? deserializeAws_restJson1IntentConfidence(output.nluIntentConfidence, context) : undefined,
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1ResponseCard = function deserializeAws_restJson1ResponseCard(output, context) {
    return {
        contentType: (0, _smithyClient.expectString)(output.contentType),
        genericAttachments: output.genericAttachments != null ? deserializeAws_restJson1genericAttachmentList(output.genericAttachments, context) : undefined,
        version: (0, _smithyClient.expectString)(output.version)
    };
};
var deserializeAws_restJson1SentimentResponse = function deserializeAws_restJson1SentimentResponse(output, context) {
    return {
        sentimentLabel: (0, _smithyClient.expectString)(output.sentimentLabel),
        sentimentScore: (0, _smithyClient.expectString)(output.sentimentScore)
    };
};
var deserializeAws_restJson1StringMap = function deserializeAws_restJson1StringMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function parseErrorBody(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"140ff1ec17a71939":"cvSE8","tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/smithy-client":"alQg0","../models/LexRuntimeServiceServiceException":"1vMJc","../models/models_0":"l9pMX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2kixx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostTextCommand", function() {
    return PostTextCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostTextCommand = function(_super) {
    (0, _tslib.__extends)(PostTextCommand, _super);
    function PostTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostTextCommand)(input, context);
    };
    PostTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostTextCommand)(output, context);
    };
    return PostTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"8ZTRr","@aws-sdk/smithy-client":"alQg0","../models/models_0":"l9pMX","../protocols/Aws_restJson1":"esFav","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ep5zt":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", function() {
    return convert;
});
parcelHelpers.export(exports, "base64ToArrayBuffer", function() {
    return base64ToArrayBuffer;
});
parcelHelpers.export(exports, "gzipDecompressToString", function() {
    return gzipDecompressToString;
});
var _tslib = require("tslib");
var _fflate = require("fflate");
var convert = function convert(stream) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            if (stream instanceof Blob || stream instanceof ReadableStream) return [
                2 /*return*/ ,
                new Response(stream).arrayBuffer().then(function(buffer) {
                    return new Uint8Array(buffer);
                })
            ];
            else return [
                2 /*return*/ ,
                Promise.reject('Invalid content type')
            ];
            return [
                2 /*return*/ 
            ];
        });
    });
};
var base64ToArrayBuffer = function base64ToArrayBuffer(base64) {
    return Uint8Array.from(window.atob(base64), function(c) {
        return c.charCodeAt(0);
    });
};
var gzipDecompressToString = function gzipDecompressToString(data) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve, reject) {
                            (0, _fflate.gunzip)(data, function(err, resp) {
                                if (err) reject(err);
                                else resolve((0, _fflate.strFromU8)(resp));
                            });
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};

},{"tslib":"2gCWu","fflate":"86IGF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86IGF":[function(require,module,exports,__globalThis) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", function() {
    return FlateErrorCode;
});
parcelHelpers.export(exports, "Deflate", function() {
    return Deflate;
});
parcelHelpers.export(exports, "AsyncDeflate", function() {
    return AsyncDeflate;
});
parcelHelpers.export(exports, "deflate", function() {
    return deflate;
});
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", function() {
    return deflateSync;
});
parcelHelpers.export(exports, "Inflate", function() {
    return Inflate;
});
parcelHelpers.export(exports, "AsyncInflate", function() {
    return AsyncInflate;
});
parcelHelpers.export(exports, "inflate", function() {
    return inflate;
});
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", function() {
    return inflateSync;
});
parcelHelpers.export(exports, "Gzip", function() {
    return Gzip;
});
parcelHelpers.export(exports, "AsyncGzip", function() {
    return AsyncGzip;
});
parcelHelpers.export(exports, "gzip", function() {
    return gzip;
});
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", function() {
    return gzipSync;
});
parcelHelpers.export(exports, "Gunzip", function() {
    return Gunzip;
});
parcelHelpers.export(exports, "AsyncGunzip", function() {
    return AsyncGunzip;
});
parcelHelpers.export(exports, "gunzip", function() {
    return gunzip;
});
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", function() {
    return gunzipSync;
});
parcelHelpers.export(exports, "Zlib", function() {
    return Zlib;
});
parcelHelpers.export(exports, "AsyncZlib", function() {
    return AsyncZlib;
});
parcelHelpers.export(exports, "zlib", function() {
    return zlib;
});
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", function() {
    return zlibSync;
});
parcelHelpers.export(exports, "Unzlib", function() {
    return Unzlib;
});
parcelHelpers.export(exports, "AsyncUnzlib", function() {
    return AsyncUnzlib;
});
parcelHelpers.export(exports, "unzlib", function() {
    return unzlib;
});
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", function() {
    return unzlibSync;
});
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", function() {
    return gzip;
});
parcelHelpers.export(exports, "AsyncCompress", function() {
    return AsyncGzip;
});
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compressSync", function() {
    return gzipSync;
});
parcelHelpers.export(exports, "Compress", function() {
    return Gzip;
});
parcelHelpers.export(exports, "Decompress", function() {
    return Decompress;
});
parcelHelpers.export(exports, "AsyncDecompress", function() {
    return AsyncDecompress;
});
parcelHelpers.export(exports, "decompress", function() {
    return decompress;
});
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", function() {
    return decompressSync;
});
parcelHelpers.export(exports, "DecodeUTF8", function() {
    return DecodeUTF8;
});
parcelHelpers.export(exports, "EncodeUTF8", function() {
    return EncodeUTF8;
});
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", function() {
    return strToU8;
});
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", function() {
    return strFromU8;
});
parcelHelpers.export(exports, "ZipPassThrough", function() {
    return ZipPassThrough;
});
parcelHelpers.export(exports, "ZipDeflate", function() {
    return ZipDeflate;
});
parcelHelpers.export(exports, "AsyncZipDeflate", function() {
    return AsyncZipDeflate;
});
parcelHelpers.export(exports, "Zip", function() {
    return Zip;
});
parcelHelpers.export(exports, "zip", function() {
    return zip;
});
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", function() {
    return zipSync;
});
parcelHelpers.export(exports, "UnzipPassThrough", function() {
    return UnzipPassThrough;
});
parcelHelpers.export(exports, "UnzipInflate", function() {
    return UnzipInflate;
});
parcelHelpers.export(exports, "AsyncUnzipInflate", function() {
    return AsyncUnzipInflate;
});
parcelHelpers.export(exports, "Unzip", function() {
    return Unzip;
});
parcelHelpers.export(exports, "unzip", function() {
    return unzip;
});
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", function() {
    return unzipSync;
});
var ch2 = {};
var wk = function wk(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function freb(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function hMap(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >>> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function max(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function bits(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function bits16(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function shft(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function slc(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? u16 : v.BYTES_PER_ELEMENT == 4 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var err = function err1(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function inflt(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function cbuf(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function wbits(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function wbits16(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function hTree(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        et,
        0
    ];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var ln = function ln1(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function lc(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function w(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var clen = function clen(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function wfblk(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
        var dst = syms[i] & 31;
        wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function hsh(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function crc() {
    var c = -1;
    return {
        p: function p(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function d() {
            return ~c;
        }
    };
};
// Alder32
var adler = function adler() {
    var a = 1, b = 0;
    return {
        p: function p(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function d() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var dopt = function dopt(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var mrg = function mrg(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function wcln(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var ch = [];
// clone bufs
var cbfs = function cbfs(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function wrkr(fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function bInflt() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gu8
    ];
};
var bDflt = function bDflt() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function gze() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function guze() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function zle() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function zule() {
    return [
        zlv
    ];
};
// post buf
var pbf = function pbf(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var gu8 = function gu8(o) {
    return o && o.size && new u8(o.size);
};
// async helper
var cbify = function cbify(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function astrm(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var astrmify = function astrmify(fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var b2 = function b2(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function b4(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function b8(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function wbytes(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function gzh(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function gzs(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function gzl(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function gzhl(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var zlh = function zlh(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var zlv = function zlv(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, 'invalid zlib data');
    if (d[1] & 32) err(6, 'invalid zlib data: preset dictionaries not supported');
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, 0, function() {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gu8(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) err(6, 'invalid gzip data');
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, 0, function() {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0]));
    }, 3, cb);
}
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, 0, function() {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gu8(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function cb() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, out) : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function fltn1(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function dutf8(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function w(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) err(8);
        return out;
    }
}
// deflate bit flag
var dbf = function dbf(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function slzh(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function zh(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function z64e(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function exfl(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function wzh(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function wzf(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u);
            var chks_1 = [
                header
            ];
            var pAll_1 = function pAll_1() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function t() {
                    if (file.terminate) file.terminate();
                },
                r: function r() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function r() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function t() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function tAll() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function cbd(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function cbf() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function _loop_1(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function cbl(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function _loop_2() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function start() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function terminate() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function mt(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var term = [];
    var tAll = function tAll() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function cbd(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295;
        if (z) {
            e = b4(data, e - 12);
            if (b4(data, e) != 0x6064B50) {
                cbd(err(13, 0, 1), null);
                return tAll;
            }
            c = lft = b4(data, e + 32);
            o = b4(data, e + 48);
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function _loop_3(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function cbl(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, inflateSync(infl, new u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50) err(13);
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
            else err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gy36g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexV2Provider", function() {
    return AWSLexV2Provider;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _interactionsProvider = require("./InteractionsProvider");
var _clientLexRuntimeV2 = require("@aws-sdk/client-lex-runtime-v2");
var _core = require("@aws-amplify/core");
var _utils = require("./AWSLexProviderHelper/utils");
var _commonUtils = require("./AWSLexProviderHelper/commonUtils");
var logger = new (0, _core.ConsoleLogger)('AWSLexV2Provider');
var AWSLexV2Provider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSLexV2Provider, _super);
    /**
     * Initialize Interactions with AWS configurations
     * @param {InteractionsOptions} options - Configuration object for Interactions
     */ function AWSLexV2Provider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this._botsCompleteCallback = {};
        return _this;
    }
    /**
     * get provider name of the plugin
     * @returns {string} name of the provider
     */ AWSLexV2Provider.prototype.getProviderName = function() {
        return 'AWSLexV2Provider';
    };
    /**
     * Configure Interactions part with aws configuration
     * @param {AWSLexV2ProviderOptions} config - Configuration of the Interactions
     * @return {AWSLexV2ProviderOptions} - Current configuration
     */ AWSLexV2Provider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        var propertiesToTest = [
            'name',
            'botId',
            'aliasId',
            'localeId',
            'providerName',
            'region'
        ];
        Object.keys(config).forEach(function(botKey) {
            var botConfig = config[botKey];
            // is bot config correct
            if (!propertiesToTest.every(function(x) {
                return x in botConfig;
            })) throw new Error('invalid bot configuration');
        });
        return _super.prototype.configure.call(this, config);
    };
    /**
     * Send a message to a bot
     * @async
     * @param {string} botname - Bot name to send the message
     * @param {string | InteractionsMessage} message - message to send to the bot
     * @return {Promise<InteractionsResponse>} A promise resolves to the response from the bot
     */ AWSLexV2Provider.prototype.sendMessage = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, error_1, response, reqBaseParams;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // check if bot exists
                        if (!this._config[botname]) return [
                            2 /*return*/ ,
                            Promise.reject('Bot ' + botname + ' does not exist')
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject('No credentials')
                        ];
                    case 4:
                        this._lexRuntimeServiceV2Client = new (0, _clientLexRuntimeV2.LexRuntimeV2Client)({
                            region: this._config[botname].region,
                            credentials: credentials,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        reqBaseParams = {
                            botAliasId: this._config[botname].aliasId,
                            botId: this._config[botname].botId,
                            localeId: this._config[botname].localeId,
                            sessionId: credentials.identityId
                        };
                        if (!(typeof message === 'string')) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleRecognizeTextCommand(botname, message, reqBaseParams)
                        ];
                    case 5:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this._handleRecognizeUtteranceCommand(botname, message, reqBaseParams)
                        ];
                    case 7:
                        response = _a.sent();
                        _a.label = 8;
                    case 8:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    /**
     * Attach a onComplete callback function to a bot.
     * The callback is called once the bot's intent is fulfilled
     * @param {string} botname - Bot name to attach the onComplete callback
     * @param {(err: Error | null, confirmation: InteractionsResponse) => void} callback - called when Intent Fulfilled
     */ AWSLexV2Provider.prototype.onComplete = function(botname, callback) {
        // does bot exist
        if (!this._config[botname]) throw new Error('Bot ' + botname + ' does not exist');
        this._botsCompleteCallback[botname] = callback;
    };
    /**
     * @private
     * call onComplete callback for a bot if configured
     */ AWSLexV2Provider.prototype._reportBotStatus = function(data, botname) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var sessionState = data === null || data === void 0 ? void 0 : data.sessionState;
        // Check if state is fulfilled to resolve onFullfilment promise
        logger.debug('postContent state', (_a = sessionState === null || sessionState === void 0 ? void 0 : sessionState.intent) === null || _a === void 0 ? void 0 : _a.state);
        var isConfigOnCompleteAttached = typeof ((_b = this._config) === null || _b === void 0 ? void 0 : _b[botname].onComplete) === 'function';
        var isApiOnCompleteAttached = typeof ((_c = this._botsCompleteCallback) === null || _c === void 0 ? void 0 : _c[botname]) === 'function';
        // no onComplete callbacks added
        if (!isConfigOnCompleteAttached && !isApiOnCompleteAttached) return;
        if (((_d = sessionState === null || sessionState === void 0 ? void 0 : sessionState.intent) === null || _d === void 0 ? void 0 : _d.state) === 'ReadyForFulfillment' || ((_e = sessionState === null || sessionState === void 0 ? void 0 : sessionState.intent) === null || _e === void 0 ? void 0 : _e.state) === 'Fulfilled') {
            if (isApiOnCompleteAttached) setTimeout(function() {
                var _a;
                return (_a = _this._botsCompleteCallback) === null || _a === void 0 ? void 0 : _a[botname](null, data);
            }, 0);
            if (isConfigOnCompleteAttached) setTimeout(function() {
                return _this._config[botname].onComplete(null, data);
            }, 0);
        }
        if (((_f = sessionState === null || sessionState === void 0 ? void 0 : sessionState.intent) === null || _f === void 0 ? void 0 : _f.state) === 'Failed') {
            var error_2 = new Error('Bot conversation failed');
            if (isApiOnCompleteAttached) setTimeout(function() {
                return _this._botsCompleteCallback[botname](error_2);
            }, 0);
            if (isConfigOnCompleteAttached) setTimeout(function() {
                return _this._config[botname].onComplete(error_2);
            }, 0);
        }
    };
    /**
     * Format UtteranceCommandOutput's response
     * decompress attributes
     * update audioStream format
     */ AWSLexV2Provider.prototype._formatUtteranceCommandOutput = function(data) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var response, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = [
                            (0, _tslib.__assign)({}, data)
                        ];
                        _b = {};
                        return [
                            4 /*yield*/ ,
                            (0, _commonUtils.unGzipBase64AsJson)(data.messages)
                        ];
                    case 1:
                        _b.messages = _d.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _commonUtils.unGzipBase64AsJson)(data.sessionState)
                        ];
                    case 2:
                        _b.sessionState = _d.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _commonUtils.unGzipBase64AsJson)(data.interpretations)
                        ];
                    case 3:
                        _b.interpretations = _d.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _commonUtils.unGzipBase64AsJson)(data.requestAttributes)
                        ];
                    case 4:
                        _b.requestAttributes = _d.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _commonUtils.unGzipBase64AsJson)(data.inputTranscript)
                        ];
                    case 5:
                        _b.inputTranscript = _d.sent();
                        if (!data.audioStream) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(data.audioStream)
                        ];
                    case 6:
                        _c = _d.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        _c = undefined;
                        _d.label = 8;
                    case 8:
                        response = (0, _tslib.__assign).apply(void 0, _a.concat([
                            (_b.audioStream = _c, _b)
                        ]));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    /**
     * handle client's `RecognizeTextCommand`
     * used for sending simple text message
     */ AWSLexV2Provider.prototype._handleRecognizeTextCommand = function(botname, data, baseParams) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params, recognizeTextCommand, data_1, err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug('postText to lex2', data);
                        params = (0, _tslib.__assign)((0, _tslib.__assign)({}, baseParams), {
                            text: data
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        recognizeTextCommand = new (0, _clientLexRuntimeV2.RecognizeTextCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this._lexRuntimeServiceV2Client.send(recognizeTextCommand)
                        ];
                    case 2:
                        data_1 = _a.sent();
                        this._reportBotStatus(data_1, botname);
                        return [
                            2 /*return*/ ,
                            data_1
                        ];
                    case 3:
                        err_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * handle client's `RecognizeUtteranceCommand`
     * used for obj text or obj voice message
     */ AWSLexV2Provider.prototype._handleRecognizeUtteranceCommand = function(botname, data, baseParams) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var content, messageType, params, inputStream, _a, recognizeUtteranceCommand, data_2, response, err_2;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        content = data.content, messageType = data.options.messageType;
                        logger.debug('postContent to lex2', data);
                        if (!(messageType === 'voice')) return [
                            3 /*break*/ ,
                            4
                        ];
                        if ((typeof content === "undefined" ? "undefined" : (0, _typeOf._)(content)) !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('invalid content type')
                        ];
                        if (!(content instanceof Uint8Array)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = content;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(content)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        inputStream = _a;
                        params = (0, _tslib.__assign)((0, _tslib.__assign)({}, baseParams), {
                            requestContentType: 'audio/x-l16; sample-rate=16000; channel-count=1',
                            inputStream: inputStream
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        // text input
                        if (typeof content !== 'string') return [
                            2 /*return*/ ,
                            Promise.reject('invalid content type')
                        ];
                        params = (0, _tslib.__assign)((0, _tslib.__assign)({}, baseParams), {
                            requestContentType: 'text/plain; charset=utf-8',
                            inputStream: content
                        });
                        _b.label = 5;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        recognizeUtteranceCommand = new (0, _clientLexRuntimeV2.RecognizeUtteranceCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this._lexRuntimeServiceV2Client.send(recognizeUtteranceCommand)
                        ];
                    case 6:
                        data_2 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this._formatUtteranceCommandOutput(data_2)
                        ];
                    case 7:
                        response = _b.sent();
                        this._reportBotStatus(response, botname);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 8:
                        err_2 = _b.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_2)
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AWSLexV2Provider;
}((0, _interactionsProvider.AbstractInteractionsProvider));

},{"@swc/helpers/_/_type_of":"668P4","tslib":"2gCWu","./InteractionsProvider":"6ZXQe","@aws-sdk/client-lex-runtime-v2":"gCeTS","@aws-amplify/core":"3rlh1","./AWSLexProviderHelper/utils":"ep5zt","./AWSLexProviderHelper/commonUtils":"k3RFQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCeTS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeV2ServiceException", function() {
    return 0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException;
});
var _lexRuntimeV2 = require("./LexRuntimeV2");
parcelHelpers.exportAll(_lexRuntimeV2, exports);
var _lexRuntimeV2Client = require("./LexRuntimeV2Client");
parcelHelpers.exportAll(_lexRuntimeV2Client, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _lexRuntimeV2ServiceException = require("./models/LexRuntimeV2ServiceException");

},{"./LexRuntimeV2":false,"./LexRuntimeV2Client":"njZd6","./commands":"gBqVW","./models":false,"./models/LexRuntimeV2ServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"njZd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeV2Client", function() {
    return LexRuntimeV2Client;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _eventstreamSerdeConfigResolver = require("@aws-sdk/eventstream-serde-config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareEventstream = require("@aws-sdk/middleware-eventstream");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LexRuntimeV2Client = function(_super) {
    (0, _tslib.__extends)(LexRuntimeV2Client, _super);
    function LexRuntimeV2Client(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareEventstream.resolveEventStreamConfig)(_config_5);
        var _config_7 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_6);
        var _config_8 = (0, _eventstreamSerdeConfigResolver.resolveEventStreamSerdeConfig)(_config_7);
        _this = _super.call(this, _config_8) || this;
        _this.config = _config_8;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LexRuntimeV2Client.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LexRuntimeV2Client;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","@aws-sdk/config-resolver":"kNL14","@aws-sdk/eventstream-serde-config-resolver":"gtqnJ","@aws-sdk/middleware-content-length":"8AfsD","@aws-sdk/middleware-eventstream":"h1wdU","@aws-sdk/middleware-host-header":"56C7f","@aws-sdk/middleware-logger":"cb1UL","@aws-sdk/middleware-recursion-detection":"l81JW","@aws-sdk/middleware-retry":"k3cT9","@aws-sdk/middleware-signing":"ddrf8","@aws-sdk/middleware-user-agent":"h6INu","@aws-sdk/smithy-client":"kHS8Y","./runtimeConfig":"gSDsF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNL14":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"jM2G7","./regionConfig":"joH0j","./regionInfo":"crQv2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jM2G7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"hfh6M","./NodeUseFipsEndpointConfigOptions":"hyRIY","./resolveCustomEndpointsConfig":"f9Yih","./resolveEndpointsConfig":"kYjrj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hfh6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", function() {
    return ENV_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", function() {
    return CONFIG_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", function() {
    return DEFAULT_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hyRIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", function() {
    return ENV_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", function() {
    return CONFIG_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", function() {
    return DEFAULT_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f9Yih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", function() {
    return resolveCustomEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function resolveCustomEndpointsConfig(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kYjrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", function() {
    return resolveEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function resolveEndpointsConfig(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./utils/getEndpointFromRegion":"9Snjy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Snjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", function() {
    return getEndpointFromRegion;
});
var _tslib = require("tslib");
var getEndpointFromRegion = function getEndpointFromRegion(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"joH0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"jjef1","./resolveRegionConfig":"hLwGJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jjef1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", function() {
    return REGION_ENV_NAME;
});
parcelHelpers.export(exports, "REGION_INI_NAME", function() {
    return REGION_INI_NAME;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", function() {
    return NODE_REGION_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", function() {
    return NODE_REGION_CONFIG_FILE_OPTIONS;
});
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function _default() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hLwGJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", function() {
    return resolveRegionConfig;
});
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function resolveRegionConfig(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function region1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function useFipsEndpoint1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","./getRealRegion":"eE9XM","./isFipsRegion":"9nrZI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eE9XM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", function() {
    return getRealRegion;
});
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function getRealRegion(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"9nrZI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9nrZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", function() {
    return isFipsRegion;
});
var isFipsRegion = function isFipsRegion(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crQv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"9PALw","./RegionHash":"d7v1J","./getRegionInfo":"2lR1i","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9PALw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d7v1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2lR1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", function() {
    return getRegionInfo;
});
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function getRegionInfo(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"86BcK","./getHostnameFromVariants":"9JE6l","./getResolvedHostname":"5yLzL","./getResolvedPartition":"57tTz","./getResolvedSigningRegion":"bp9ZW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JE6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", function() {
    return getHostnameFromVariants;
});
var getHostnameFromVariants = function getHostnameFromVariants(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5yLzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", function() {
    return getResolvedHostname;
});
var getResolvedHostname = function getResolvedHostname(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"57tTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", function() {
    return getResolvedPartition;
});
var getResolvedPartition = function getResolvedPartition(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bp9ZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", function() {
    return getResolvedSigningRegion;
});
var getResolvedSigningRegion = function getResolvedSigningRegion(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gtqnJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamSerdeConfig = require("./EventStreamSerdeConfig");
parcelHelpers.exportAll(_eventStreamSerdeConfig, exports);

},{"./EventStreamSerdeConfig":"5QX6O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5QX6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEventStreamSerdeConfig", function() {
    return resolveEventStreamSerdeConfig;
});
var _tslib = require("tslib");
var resolveEventStreamSerdeConfig = function resolveEventStreamSerdeConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8AfsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", function() {
    return contentLengthMiddleware;
});
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", function() {
    return contentLengthMiddlewareOptions;
});
parcelHelpers.export(exports, "getContentLengthPlugin", function() {
    return getContentLengthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function getContentLengthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iCVKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"iO7c4","./httpRequest":"dG0ko","./httpResponse":"4TROg","./isValidHostname":"7DK0b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iO7c4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dG0ko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TROg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7DK0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h1wdU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configuration = require("./configuration");
parcelHelpers.exportAll(_configuration, exports);
var _handlingMiddleware = require("./handling-middleware");
parcelHelpers.exportAll(_handlingMiddleware, exports);
var _headersMiddleware = require("./headers-middleware");
parcelHelpers.exportAll(_headersMiddleware, exports);
var _plugin = require("./plugin");
parcelHelpers.exportAll(_plugin, exports);

},{"./configuration":"3FiCY","./handling-middleware":"k357P","./headers-middleware":"dRbFD","./plugin":"hCJyM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3FiCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEventStreamConfig", function() {
    return resolveEventStreamConfig;
});
var _tslib = require("tslib");
function resolveEventStreamConfig(input) {
    var eventSigner = input.signer;
    var eventStreamPayloadHandler = input.eventStreamPayloadHandlerProvider((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventSigner: eventSigner
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventSigner: eventSigner,
        eventStreamPayloadHandler: eventStreamPayloadHandler
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k357P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamHandlingMiddleware", function() {
    return eventStreamHandlingMiddleware;
});
parcelHelpers.export(exports, "eventStreamHandlingMiddlewareOptions", function() {
    return eventStreamHandlingMiddlewareOptions;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var eventStreamHandlingMiddleware = function eventStreamHandlingMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                        2,
                        next(args)
                    ];
                    return [
                        2,
                        options.eventStreamPayloadHandler.handle(next, args, context)
                    ];
                });
            });
        };
    };
};
var eventStreamHandlingMiddlewareOptions = {
    tags: [
        "EVENT_STREAM",
        "SIGNATURE",
        "HANDLE"
    ],
    name: "eventStreamHandlingMiddleware",
    relation: "after",
    toMiddleware: "awsAuthMiddleware",
    override: true
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"cyK1k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cyK1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"cYRnx","./httpRequest":"dLhte","./httpResponse":"9mSIT","./isValidHostname":"iwBWQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cYRnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dLhte":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9mSIT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iwBWQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRbFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamHeaderMiddleware", function() {
    return eventStreamHeaderMiddleware;
});
parcelHelpers.export(exports, "eventStreamHeaderMiddlewareOptions", function() {
    return eventStreamHeaderMiddlewareOptions;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var eventStreamHeaderMiddleware = function eventStreamHeaderMiddleware(next) {
    return function(args) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var request;
            return (0, _tslib.__generator)(this, function(_a) {
                request = args.request;
                if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                    2,
                    next(args)
                ];
                request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), {
                    "Content-Type": "application/vnd.amazon.eventstream",
                    "x-amz-content-sha256": "STREAMING-AWS4-HMAC-SHA256-EVENTS"
                });
                return [
                    2,
                    next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                        request: request
                    }))
                ];
            });
        });
    };
};
var eventStreamHeaderMiddlewareOptions = {
    step: "build",
    tags: [
        "EVENT_STREAM",
        "HEADER",
        "CONTENT_TYPE",
        "CONTENT_SHA256"
    ],
    name: "eventStreamHeaderMiddleware",
    override: true
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"cyK1k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hCJyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEventStreamPlugin", function() {
    return getEventStreamPlugin;
});
var _handlingMiddleware = require("./handling-middleware");
var _headersMiddleware = require("./headers-middleware");
var getEventStreamPlugin = function getEventStreamPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo((0, _handlingMiddleware.eventStreamHandlingMiddleware)(options), (0, _handlingMiddleware.eventStreamHandlingMiddlewareOptions));
            clientStack.add((0, _headersMiddleware.eventStreamHeaderMiddleware), (0, _headersMiddleware.eventStreamHeaderMiddlewareOptions));
        }
    };
};

},{"./handling-middleware":"k357P","./headers-middleware":"dRbFD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"56C7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", function() {
    return resolveHostHeaderConfig;
});
parcelHelpers.export(exports, "hostHeaderMiddleware", function() {
    return hostHeaderMiddleware;
});
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", function() {
    return hostHeaderMiddlewareOptions;
});
parcelHelpers.export(exports, "getHostHeaderPlugin", function() {
    return getHostHeaderPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function hostHeaderMiddleware(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function getHostHeaderPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cb1UL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"d75FX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d75FX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", function() {
    return loggerMiddleware;
});
parcelHelpers.export(exports, "loggerMiddlewareOptions", function() {
    return loggerMiddlewareOptions;
});
parcelHelpers.export(exports, "getLoggerPlugin", function() {
    return getLoggerPlugin;
});
var _tslib = require("tslib");
var loggerMiddleware = function loggerMiddleware() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function getLoggerPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k3cT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"h3JAx","./DefaultRateLimiter":"cJnGy","./StandardRetryStrategy":"4v7uk","./config":"ahd6F","./configurations":"3Xw3h","./delayDecider":"1F7fC","./omitRetryHeadersMiddleware":"64JNG","./retryDecider":"gixR3","./retryMiddleware":"jMFXL","./types":"9KLxH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h3JAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", function() {
    return AdaptiveRetryStrategy;
});
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function beforeRequest() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function afterRequest(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"86BcK","./config":"ahd6F","./DefaultRateLimiter":"cJnGy","./StandardRetryStrategy":"4v7uk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ahd6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", function() {
    return RETRY_MODES;
});
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", function() {
    return DEFAULT_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", function() {
    return DEFAULT_RETRY_MODE;
});
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cJnGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", function() {
    return DefaultRateLimiter;
});
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"86BcK","@aws-sdk/service-error-classification":"89KAP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"89KAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", function() {
    return isRetryableByTrait;
});
parcelHelpers.export(exports, "isClockSkewError", function() {
    return isClockSkewError;
});
parcelHelpers.export(exports, "isThrottlingError", function() {
    return isThrottlingError;
});
parcelHelpers.export(exports, "isTransientError", function() {
    return isTransientError;
});
var _constants = require("./constants");
var isRetryableByTrait = function isRetryableByTrait(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function isClockSkewError(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function isThrottlingError(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function isTransientError(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"hRBp6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hRBp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", function() {
    return CLOCK_SKEW_ERROR_CODES;
});
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", function() {
    return THROTTLING_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", function() {
    return TRANSIENT_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", function() {
    return TRANSIENT_ERROR_STATUS_CODES;
});
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", function() {
    return NODEJS_TIMEOUT_ERROR_CODES;
});
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4v7uk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", function() {
    return StandardRetryStrategy;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function _loop_1() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if ((typeof state_1 === "undefined" ? "undefined" : (0, _typeOf._)(state_1)) === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function getDelayFromRetryAfterHeader(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function asSdkError(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","@aws-sdk/service-error-classification":"89KAP","uuid":"fvWfr","./config":"ahd6F","./constants":"c2cbq","./defaultRetryQuota":"k9nME","./delayDecider":"1F7fC","./retryDecider":"gixR3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fvWfr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"ltadU","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ltadU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"96JXc","./stringify.js":"1FsrO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"96JXc":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1FsrO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"iwbTK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iwbTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"aewa3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aewa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c2cbq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", function() {
    return DEFAULT_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", function() {
    return MAXIMUM_RETRY_DELAY;
});
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", function() {
    return THROTTLING_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", function() {
    return INITIAL_RETRY_TOKENS;
});
parcelHelpers.export(exports, "RETRY_COST", function() {
    return RETRY_COST;
});
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", function() {
    return TIMEOUT_RETRY_COST;
});
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", function() {
    return NO_RETRY_INCREMENT;
});
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", function() {
    return INVOCATION_ID_HEADER;
});
parcelHelpers.export(exports, "REQUEST_HEADER", function() {
    return REQUEST_HEADER;
});
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k9nME":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", function() {
    return getDefaultRetryQuota;
});
var _constants = require("./constants");
var getDefaultRetryQuota = function getDefaultRetryQuota(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function getCapacityAmount(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function hasRetryTokens(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function retrieveRetryTokens(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function releaseRetryTokens(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"c2cbq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1F7fC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", function() {
    return defaultDelayDecider;
});
var _constants = require("./constants");
var defaultDelayDecider = function defaultDelayDecider(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"c2cbq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gixR3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", function() {
    return defaultRetryDecider;
});
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function defaultRetryDecider(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"89KAP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Xw3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", function() {
    return ENV_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", function() {
    return CONFIG_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", function() {
    return NODE_MAX_ATTEMPT_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "resolveRetryConfig", function() {
    return resolveRetryConfig;
});
parcelHelpers.export(exports, "ENV_RETRY_MODE", function() {
    return ENV_RETRY_MODE;
});
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", function() {
    return CONFIG_RETRY_MODE;
});
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", function() {
    return NODE_RETRY_MODE_CONFIG_OPTIONS;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    configFileSelector: function configFileSelector(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function resolveRetryConfig(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function retryStrategy() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./AdaptiveRetryStrategy":"h3JAx","./config":"ahd6F","./StandardRetryStrategy":"4v7uk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"64JNG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", function() {
    return omitRetryHeadersMiddleware;
});
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", function() {
    return omitRetryHeadersMiddlewareOptions;
});
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", function() {
    return getOmitRetryHeadersPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function omitRetryHeadersMiddleware() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function getOmitRetryHeadersPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","./constants":"c2cbq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jMFXL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return retryMiddleware;
});
parcelHelpers.export(exports, "retryMiddlewareOptions", function() {
    return retryMiddlewareOptions;
});
parcelHelpers.export(exports, "getRetryPlugin", function() {
    return getRetryPlugin;
});
var _tslib = require("tslib");
var retryMiddleware = function retryMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function getRetryPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9KLxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddrf8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"jT7Zm","./middleware":"d3UQl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jT7Zm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", function() {
    return resolveAwsAuthConfig;
});
parcelHelpers.export(exports, "resolveSigV4AuthConfig", function() {
    return resolveSigV4AuthConfig;
});
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function resolveAwsAuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function signer() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function signer(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function resolveSigV4AuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function normalizeCredentialProvider(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"l4NMz","@aws-sdk/signature-v4":"izAIL","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l4NMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"8drCi","./ProviderError":"78qkK","./TokenProviderError":"TJTR7","./chain":"1mub5","./fromStatic":"aJhrQ","./memoize":"9Qqni","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8drCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", function() {
    return CredentialsProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"78qkK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"78qkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", function() {
    return ProviderError;
});
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"TJTR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", function() {
    return TokenProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"78qkK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1mub5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", function() {
    return chain;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function _loop_1(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"78qkK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aJhrQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", function() {
    return fromStatic;
});
var fromStatic = function fromStatic(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Qqni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
var _tslib = require("tslib");
var memoize = function memoize(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function coalesceProvider() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"izAIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return 0, _getCanonicalHeaders.getCanonicalHeaders;
});
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return 0, _getCanonicalQuery.getCanonicalQuery;
});
parcelHelpers.export(exports, "getPayloadHash", function() {
    return 0, _getPayloadHash.getPayloadHash;
});
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return 0, _moveHeadersToQuery.moveHeadersToQuery;
});
parcelHelpers.export(exports, "prepareRequest", function() {
    return 0, _prepareRequest.prepareRequest;
});
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"fiz54","./getCanonicalHeaders":"efgIk","./getCanonicalQuery":"2wY8Z","./getPayloadHash":"9eyCU","./moveHeadersToQuery":"9mZmb","./prepareRequest":"7H63r","./credentialDerivation":"2lyli","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fiz54":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", function() {
    return SignatureV4;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if ((typeof credentials === "undefined" ? "undefined" : (0, _typeOf._)(credentials)) !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function formatDate(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function getCanonicalHeaderList(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/util-hex-encoding":"k6hCo","@aws-sdk/util-middleware":"2OCR6","./constants":"4aXtJ","./credentialDerivation":"2lyli","./getCanonicalHeaders":"efgIk","./getCanonicalQuery":"2wY8Z","./getPayloadHash":"9eyCU","./headerUtil":"6mmDS","./moveHeadersToQuery":"9mZmb","./prepareRequest":"7H63r","./utilDate":"cMmOX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k6hCo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", function() {
    return fromHex;
});
parcelHelpers.export(exports, "toHex", function() {
    return toHex;
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4aXtJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", function() {
    return ALGORITHM_QUERY_PARAM;
});
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", function() {
    return CREDENTIAL_QUERY_PARAM;
});
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", function() {
    return AMZ_DATE_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", function() {
    return SIGNED_HEADERS_QUERY_PARAM;
});
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", function() {
    return EXPIRES_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", function() {
    return SIGNATURE_QUERY_PARAM;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "REGION_SET_PARAM", function() {
    return REGION_SET_PARAM;
});
parcelHelpers.export(exports, "AUTH_HEADER", function() {
    return AUTH_HEADER;
});
parcelHelpers.export(exports, "AMZ_DATE_HEADER", function() {
    return AMZ_DATE_HEADER;
});
parcelHelpers.export(exports, "DATE_HEADER", function() {
    return DATE_HEADER;
});
parcelHelpers.export(exports, "GENERATED_HEADERS", function() {
    return GENERATED_HEADERS;
});
parcelHelpers.export(exports, "SIGNATURE_HEADER", function() {
    return SIGNATURE_HEADER;
});
parcelHelpers.export(exports, "SHA256_HEADER", function() {
    return SHA256_HEADER;
});
parcelHelpers.export(exports, "TOKEN_HEADER", function() {
    return TOKEN_HEADER;
});
parcelHelpers.export(exports, "HOST_HEADER", function() {
    return HOST_HEADER;
});
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", function() {
    return ALWAYS_UNSIGNABLE_HEADERS;
});
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", function() {
    return PROXY_HEADER_PATTERN;
});
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", function() {
    return SEC_HEADER_PATTERN;
});
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", function() {
    return UNSIGNABLE_PATTERNS;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", function() {
    return ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", function() {
    return ALGORITHM_IDENTIFIER_V4A;
});
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", function() {
    return EVENT_ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", function() {
    return UNSIGNED_PAYLOAD;
});
parcelHelpers.export(exports, "MAX_CACHE_SIZE", function() {
    return MAX_CACHE_SIZE;
});
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", function() {
    return KEY_TYPE_IDENTIFIER;
});
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", function() {
    return MAX_PRESIGNED_TTL;
});
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2lyli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", function() {
    return createScope;
});
parcelHelpers.export(exports, "getSigningKey", function() {
    return getSigningKey;
});
parcelHelpers.export(exports, "clearCredentialCache", function() {
    return clearCredentialCache;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function createScope(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"k6hCo","./constants":"4aXtJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"efgIk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return getCanonicalHeaders;
});
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"86BcK","./constants":"4aXtJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2wY8Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return getCanonicalQuery;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function _loop_1(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"d3YWy","./constants":"4aXtJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d3YWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"1M3wJ","./escape-uri-path":"40te8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1M3wJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", function() {
    return escapeUri;
});
var escapeUri = function escapeUri(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40te8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", function() {
    return escapeUriPath;
});
var _escapeUri = require("./escape-uri");
var escapeUriPath = function escapeUriPath(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"1M3wJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eyCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", function() {
    return getPayloadHash;
});
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/is-array-buffer":"koaJF","@aws-sdk/util-hex-encoding":"k6hCo","./constants":"4aXtJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"koaJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", function() {
    return isArrayBuffer;
});
var isArrayBuffer = function isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6mmDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", function() {
    return hasHeader;
});
parcelHelpers.export(exports, "getHeaderValue", function() {
    return getHeaderValue;
});
parcelHelpers.export(exports, "deleteHeader", function() {
    return deleteHeader;
});
var _tslib = require("tslib");
var hasHeader = function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function getHeaderValue(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function deleteHeader(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9mZmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return moveHeadersToQuery;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"86BcK","./cloneRequest":"dKM99","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dKM99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", function() {
    return cloneRequest;
});
parcelHelpers.export(exports, "cloneQuery", function() {
    return cloneQuery;
});
var _tslib = require("tslib");
var cloneRequest = function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7H63r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", function() {
    return prepareRequest;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function prepareRequest(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"86BcK","./cloneRequest":"dKM99","./constants":"4aXtJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMmOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", function() {
    return iso8601;
});
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
var iso8601 = function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d3UQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", function() {
    return awsAuthMiddleware;
});
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", function() {
    return awsAuthMiddlewareOptions;
});
parcelHelpers.export(exports, "getAwsAuthPlugin", function() {
    return getAwsAuthPlugin;
});
parcelHelpers.export(exports, "getSigV4AuthPlugin", function() {
    return getSigV4AuthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function getDateHeader(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function getAwsAuthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","./utils/getSkewCorrectedDate":"80HSJ","./utils/getUpdatedSystemClockOffset":"9dNoy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"80HSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", function() {
    return getSkewCorrectedDate;
});
var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9dNoy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", function() {
    return getUpdatedSystemClockOffset;
});
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function getUpdatedSystemClockOffset(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"bqeRw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bqeRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", function() {
    return isClockSkewed;
});
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function isClockSkewed(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"80HSJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h6INu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"gZ0eO","./user-agent-middleware":"gn5PK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZ0eO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", function() {
    return resolveUserAgentConfig;
});
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gn5PK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return userAgentMiddleware;
});
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", function() {
    return getUserAgentMiddlewareOptions;
});
parcelHelpers.export(exports, "getUserAgentPlugin", function() {
    return getUserAgentPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function userAgentMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function escapeUserAgent(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function getUserAgentPlugin(config) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","./constants":"30Bvm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"30Bvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", function() {
    return USER_AGENT;
});
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", function() {
    return X_AMZ_USER_AGENT;
});
parcelHelpers.export(exports, "SPACE", function() {
    return SPACE;
});
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", function() {
    return UA_ESCAPE_REGEX;
});
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kHS8Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"jHEBa","./command":"gHmpI","./constants":"68v8u","./date-utils":"dJ1Cu","./default-error-handler":"a0wkr","./defaults-mode":"7T0Sh","./emitWarningIfUnsupportedVersion":"lq651","./exceptions":"h2QHn","./extended-encode-uri-component":"SnUe8","./get-array-if-single-item":"Lsf9Y","./get-value-from-text-node":"6NdUE","./lazy-json":"kmWhe","./object-mapping":"fwo6X","./parse-utils":"hxISD","./resolve-path":"aP1kS","./ser-utils":"eNjaG","./split-every":"hgeQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jHEBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"lLaby","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLaby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"6YmUW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6YmUW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", function() {
    return constructStack;
});
var _tslib = require("tslib");
var constructStack = function constructStack1() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function sort(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function removeByName(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function removeByReference(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function cloneTo(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function expandRelativeMiddlewareList1(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function getMiddlewareList(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function add(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"".concat(name, "\" middleware with ").concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function addRelativeTo(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"".concat(name, "\" middleware ").concat(toOverride.relation, " \"").concat(toOverride.toMiddleware, "\" middleware cannot be overridden ") + "by same-name middleware ".concat(entry.relation, " \"").concat(entry.toMiddleware, "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function clone() {
            return cloneTo(constructStack());
        },
        use: function use(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function remove(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function removeByTag(toRemove) {
            var isRemoved = false;
            var filterCb = function filterCb(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function concat(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function identify() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function resolve(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gHmpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", function() {
    return Command;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"lLaby","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"68v8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", function() {
    return SENSITIVE_STRING;
});
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dJ1Cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", function() {
    return dateToUtcString;
});
parcelHelpers.export(exports, "parseRfc3339DateTime", function() {
    return parseRfc3339DateTime;
});
parcelHelpers.export(exports, "parseRfc7231DateTime", function() {
    return parseRfc7231DateTime;
});
parcelHelpers.export(exports, "parseEpochTimestamp", function() {
    return parseEpochTimestamp;
});
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function parseRfc3339DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function parseRfc7231DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function parseEpochTimestamp(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function buildDate(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function parseTwoDigitYear(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function adjustRfc850Year(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function parseMonthByShortName(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function validateDayOfMonth(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function parseDateValue(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function parseMilliseconds(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function stripLeadingZeroes(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"86BcK","./parse-utils":"hxISD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hxISD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", function() {
    return parseBoolean;
});
parcelHelpers.export(exports, "expectBoolean", function() {
    return expectBoolean;
});
parcelHelpers.export(exports, "expectNumber", function() {
    return expectNumber;
});
parcelHelpers.export(exports, "expectFloat32", function() {
    return expectFloat32;
});
parcelHelpers.export(exports, "expectLong", function() {
    return expectLong;
});
parcelHelpers.export(exports, "expectInt", function() {
    return expectInt;
});
parcelHelpers.export(exports, "expectInt32", function() {
    return expectInt32;
});
parcelHelpers.export(exports, "expectShort", function() {
    return expectShort;
});
parcelHelpers.export(exports, "expectByte", function() {
    return expectByte;
});
parcelHelpers.export(exports, "expectNonNull", function() {
    return expectNonNull;
});
parcelHelpers.export(exports, "expectObject", function() {
    return expectObject;
});
parcelHelpers.export(exports, "expectString", function() {
    return expectString;
});
parcelHelpers.export(exports, "expectUnion", function() {
    return expectUnion;
});
parcelHelpers.export(exports, "strictParseDouble", function() {
    return strictParseDouble;
});
parcelHelpers.export(exports, "strictParseFloat", function() {
    return strictParseFloat;
});
parcelHelpers.export(exports, "strictParseFloat32", function() {
    return strictParseFloat32;
});
parcelHelpers.export(exports, "limitedParseDouble", function() {
    return limitedParseDouble;
});
parcelHelpers.export(exports, "handleFloat", function() {
    return handleFloat;
});
parcelHelpers.export(exports, "limitedParseFloat", function() {
    return limitedParseFloat;
});
parcelHelpers.export(exports, "limitedParseFloat32", function() {
    return limitedParseFloat32;
});
parcelHelpers.export(exports, "strictParseLong", function() {
    return strictParseLong;
});
parcelHelpers.export(exports, "strictParseInt", function() {
    return strictParseInt;
});
parcelHelpers.export(exports, "strictParseInt32", function() {
    return strictParseInt32;
});
parcelHelpers.export(exports, "strictParseShort", function() {
    return strictParseShort;
});
parcelHelpers.export(exports, "strictParseByte", function() {
    return strictParseByte;
});
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var parseBoolean = function parseBoolean(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error("Unable to parse boolean value \"".concat(value, "\""));
    }
};
var expectBoolean = function expectBoolean(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectNumber = function expectNumber(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function expectFloat32(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function expectLong(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function expectInt32(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function expectShort(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function expectByte(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function expectSizedInt(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function castInt(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function expectNonNull(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function expectObject(value) {
    if (value === null || value === undefined) return undefined;
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function expectString(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value))) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectUnion = function expectUnion(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function strictParseDouble(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function strictParseFloat32(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function parseNumber(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function limitedParseDouble(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function limitedParseFloat32(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function parseFloatString(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function strictParseLong(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function strictParseInt32(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function strictParseShort(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function strictParseByte(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function stackTraceWarning(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0wkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", function() {
    return throwDefaultError;
});
var _exceptions = require("./exceptions");
var throwDefaultError = function throwDefaultError(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"h2QHn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h2QHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", function() {
    return ServiceException;
});
parcelHelpers.export(exports, "decorateServiceException", function() {
    return decorateServiceException;
});
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function decorateServiceException(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7T0Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", function() {
    return loadConfigsForDefaultMode;
});
var loadConfigsForDefaultMode = function loadConfigsForDefaultMode(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lq651":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", function() {
    return emitWarningIfUnsupportedVersion;
});
var process = require("5ce8c215af571c27");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function emitWarningIfUnsupportedVersion(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"5ce8c215af571c27":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"SnUe8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return extendedEncodeURIComponent;
});
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Lsf9Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", function() {
    return getArrayIfSingleItem;
});
var getArrayIfSingleItem = function getArrayIfSingleItem(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6NdUE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", function() {
    return getValueFromTextNode;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var getValueFromTextNode = function getValueFromTextNode1(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if ((0, _typeOf._)(obj[key]) === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kmWhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", function() {
    return StringWrapper;
});
parcelHelpers.export(exports, "LazyJsonString", function() {
    return LazyJsonString;
});
var _tslib = require("tslib");
var StringWrapper = function StringWrapper() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fwo6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "convertMap", function() {
    return convertMap;
});
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function convertMap(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function mapWithFilter(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aP1kS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", function() {
    return resolvedPath;
});
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function resolvedPath(_resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        _resolvedPath = _resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return _resolvedPath;
};

},{"./extended-encode-uri-component":"SnUe8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eNjaG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", function() {
    return serializeFloat;
});
var serializeFloat = function serializeFloat(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hgeQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", function() {
    return splitEvery;
});
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gSDsF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _eventstreamSerdeBrowser = require("@aws-sdk/eventstream-serde-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function defaultConfigProvider() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        eventStreamPayloadHandlerProvider: (_f = config === null || config === void 0 ? void 0 : config.eventStreamPayloadHandlerProvider) !== null && _f !== void 0 ? _f : function() {
            return {
                handle: (0, _invalidDependency.invalidFunction)("event stream request is not supported in browser.")
            };
        },
        eventStreamSerdeProvider: (_g = config === null || config === void 0 ? void 0 : config.eventStreamSerdeProvider) !== null && _g !== void 0 ? _g : (0, _eventstreamSerdeBrowser.eventStreamSerdeProvider),
        maxAttempts: (_h = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _h !== void 0 ? _h : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_j = config === null || config === void 0 ? void 0 : config.region) !== null && _j !== void 0 ? _j : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_k = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _k !== void 0 ? _k : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_l = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _l !== void 0 ? _l : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_m = config === null || config === void 0 ? void 0 : config.sha256) !== null && _m !== void 0 ? _m : (0, _sha256Browser.Sha256),
        streamCollector: (_o = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _o !== void 0 ? _o : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_p = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _p !== void 0 ? _p : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_q = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _q !== void 0 ? _q : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_r = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _r !== void 0 ? _r : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_s = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _s !== void 0 ? _s : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"86BcK","../package.json":"1j3Op","@aws-crypto/sha256-browser":"90eDC","@aws-sdk/config-resolver":"kNL14","@aws-sdk/eventstream-serde-browser":"bCxNX","@aws-sdk/fetch-http-handler":"cu2dj","@aws-sdk/invalid-dependency":"kwvBH","@aws-sdk/middleware-retry":"k3cT9","@aws-sdk/util-base64-browser":"ioEwz","@aws-sdk/util-body-length-browser":"6ktb5","@aws-sdk/util-user-agent-browser":"iw9RT","@aws-sdk/util-utf8-browser":"8Biif","./runtimeConfig.shared":"jxlv1","@aws-sdk/smithy-client":"kHS8Y","@aws-sdk/util-defaults-mode-browser":"gpbLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1j3Op":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-lex-runtime-v2\",\"description\":\"AWS SDK for JavaScript Lex Runtime V2 Client for Node.js, Browser and React Native\",\"version\":\"3.186.4\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"tsc -p tsconfig.cjs.json\",\"build:docs\":\"typedoc\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"2.0.0\",\"@aws-crypto/sha256-js\":\"2.0.0\",\"@aws-sdk/client-sts\":\"3.186.4\",\"@aws-sdk/config-resolver\":\"3.186.0\",\"@aws-sdk/credential-provider-node\":\"3.186.0\",\"@aws-sdk/eventstream-handler-node\":\"3.186.0\",\"@aws-sdk/eventstream-serde-browser\":\"3.186.0\",\"@aws-sdk/eventstream-serde-config-resolver\":\"3.186.0\",\"@aws-sdk/eventstream-serde-node\":\"3.186.0\",\"@aws-sdk/fetch-http-handler\":\"3.186.0\",\"@aws-sdk/hash-node\":\"3.186.0\",\"@aws-sdk/invalid-dependency\":\"3.186.0\",\"@aws-sdk/middleware-content-length\":\"3.186.0\",\"@aws-sdk/middleware-eventstream\":\"3.186.0\",\"@aws-sdk/middleware-host-header\":\"3.186.0\",\"@aws-sdk/middleware-logger\":\"3.186.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.186.0\",\"@aws-sdk/middleware-retry\":\"3.186.0\",\"@aws-sdk/middleware-serde\":\"3.186.0\",\"@aws-sdk/middleware-signing\":\"3.186.0\",\"@aws-sdk/middleware-stack\":\"3.186.0\",\"@aws-sdk/middleware-user-agent\":\"3.186.0\",\"@aws-sdk/node-config-provider\":\"3.186.0\",\"@aws-sdk/node-http-handler\":\"3.186.0\",\"@aws-sdk/protocol-http\":\"3.186.0\",\"@aws-sdk/smithy-client\":\"3.186.0\",\"@aws-sdk/types\":\"3.186.0\",\"@aws-sdk/url-parser\":\"3.186.0\",\"@aws-sdk/util-base64-browser\":\"3.186.0\",\"@aws-sdk/util-base64-node\":\"3.186.0\",\"@aws-sdk/util-body-length-browser\":\"3.186.0\",\"@aws-sdk/util-body-length-node\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-browser\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-node\":\"3.186.0\",\"@aws-sdk/util-user-agent-browser\":\"3.186.0\",\"@aws-sdk/util-user-agent-node\":\"3.186.0\",\"@aws-sdk/util-utf8-browser\":\"3.186.0\",\"@aws-sdk/util-utf8-node\":\"3.186.0\",\"tslib\":\"^2.3.1\"},\"devDependencies\":{\"@aws-sdk/service-client-documentation-generator\":\"3.186.0\",\"@tsconfig/recommended\":\"1.0.1\",\"@types/node\":\"^12.7.5\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typedoc\":\"0.19.2\",\"typescript\":\"~4.6.2\"},\"overrides\":{\"typedoc\":{\"typescript\":\"~4.6.2\"}},\"engines\":{\"node\":\">=12.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-v2\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-lex-runtime-v2\"}}");

},{}],"90eDC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("a4293f4d40dc53f7");
(0, tslib_1.__exportStar)(require("c510c53cb233269f"), exports);
var ie11Sha256_1 = require("1b7b895f23ab6410");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function get() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("b9293defd1504244");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function get() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"a4293f4d40dc53f7":"5tw7A","c510c53cb233269f":"csHOU","1b7b895f23ab6410":"3VKng","b9293defd1504244":"ijthu"}],"5tw7A":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"csHOU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("1a2d9bf5b56c9fc5");
var webCryptoSha256_1 = require("aafe61402d2d5b71");
var sha256_js_1 = require("dbd5242b416bdc9");
var supports_web_crypto_1 = require("56ca2cc4042d34d5");
var ie11_detection_1 = require("71050bf38188b9f5");
var util_locate_window_1 = require("d0a0da0fff7e109");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"1a2d9bf5b56c9fc5":"3VKng","aafe61402d2d5b71":"ijthu","dbd5242b416bdc9":"cbmUL","56ca2cc4042d34d5":"5hm3x","71050bf38188b9f5":"92JjB","d0a0da0fff7e109":"ljvil"}],"3VKng":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("6f00ef06f4a4c60d");
var constants_1 = require("4296bd6c694dd0e3");
var util_utf8_browser_1 = require("c63277b2a30ea18b");
var util_locate_window_1 = require("ffdcd4ea3bc491f6");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"6f00ef06f4a4c60d":"bTWwm","4296bd6c694dd0e3":"l5x3t","c63277b2a30ea18b":"8Biif","ffdcd4ea3bc491f6":"ljvil"}],"bTWwm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"l5x3t":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"8Biif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function fromUtf8(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function toUtf8(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"hVxvl","./whatwgEncodingApi":"8HuVA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVxvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var fromUtf8 = function fromUtf8(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function toUtf8(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8HuVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ijthu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("933d627de73a356b");
var constants_1 = require("1a1bc46937625412");
var util_locate_window_1 = require("480b93ea3bcb3262");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"933d627de73a356b":"iB4hV","1a1bc46937625412":"l5x3t","480b93ea3bcb3262":"ljvil"}],"iB4hV":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("23d5368e6f23b373");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function get() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("5cbbf5c01ff7bb66");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function get() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("5283780456a04c06");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function get() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("c6d0b23e29aa47b4");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function get() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"23d5368e6f23b373":"fYrbQ","5cbbf5c01ff7bb66":"MV4Dr","5283780456a04c06":"eb4fY","c6d0b23e29aa47b4":"fPrxb"}],"fYrbQ":[function(require,module,exports,__globalThis) {
var Buffer = require("cb437f3952e11887").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("8ee89c859addc454");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function fromUtf8(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"cb437f3952e11887":"cvSE8","8ee89c859addc454":"8Biif"}],"MV4Dr":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"eb4fY":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"fPrxb":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"cbmUL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("df8d546a9bea752a");
(0, tslib_1.__exportStar)(require("ede947d5ff40db47"), exports);

},{"df8d546a9bea752a":"4Wyse","ede947d5ff40db47":"lqIlA"}],"4Wyse":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lqIlA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("5cbf5014882b88cf");
var constants_1 = require("df1b0342669e224d");
var RawSha256_1 = require("e0a22db7b652609f");
var util_1 = require("a5f1304f713dc8d3");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"5cbf5014882b88cf":"4Wyse","df1b0342669e224d":"29yJN","e0a22db7b652609f":"fsRh0","a5f1304f713dc8d3":"iB4hV"}],"29yJN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"fsRh0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("30634dcf891563b6");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"30634dcf891563b6":"29yJN"}],"5hm3x":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("e095c334c2570ee4");
tslib_1.__exportStar(require("9be73ffb90261f23"), exports);

},{"e095c334c2570ee4":"bSIKA","9be73ffb90261f23":"1Zey5"}],"bSIKA":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Zey5":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("bc7be562082ba21e");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && (0, _typeOf._)(window.crypto.subtle) === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" && (0, _typeOf._)(window.crypto) === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"@swc/helpers/_/_type_of":"668P4","bc7be562082ba21e":"bSIKA"}],"92JjB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("5ca55e01681fc67");
tslib_1.__exportStar(require("b5cbd9e9d2ca552"), exports);
tslib_1.__exportStar(require("1675e5d41f42ebe1"), exports);
tslib_1.__exportStar(require("acc30281f59b519a"), exports);
tslib_1.__exportStar(require("b49ed5e076163bd4"), exports);
tslib_1.__exportStar(require("b266b7eca57827eb"), exports);

},{"5ca55e01681fc67":"4x1NE","b5cbd9e9d2ca552":"iZRWQ","1675e5d41f42ebe1":"lKlwq","acc30281f59b519a":"86OWW","b49ed5e076163bd4":"gjztQ","b266b7eca57827eb":"5K8Az"}],"4x1NE":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iZRWQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"lKlwq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"86OWW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"gjztQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"5K8Az":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"bCxNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./EventStreamMarshaller":"i504P","./provider":"hLxjG","./utils":"fJCaI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i504P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", function() {
    return EventStreamMarshaller;
});
var _eventstreamSerdeUniversal = require("@aws-sdk/eventstream-serde-universal");
var _utils = require("./utils");
var EventStreamMarshaller = function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.universalMarshaller = new (0, _eventstreamSerdeUniversal.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = isReadableStream(body) ? (0, _utils.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, _utils.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var isReadableStream = function isReadableStream(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

},{"@aws-sdk/eventstream-serde-universal":"2VhB0","./utils":"fJCaI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VhB0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);

},{"./EventStreamMarshaller":"8xTai","./provider":"bMAz5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8xTai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", function() {
    return EventStreamMarshaller;
});
var _tslib = require("tslib");
var _eventstreamCodec = require("@aws-sdk/eventstream-codec");
var _getChunkedStream = require("./getChunkedStream");
var _getUnmarshalledStream = require("./getUnmarshalledStream");
var EventStreamMarshaller = function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventStreamCodec = new (0, _eventstreamCodec.EventStreamCodec)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, _getChunkedStream.getChunkedStream)(body);
        var unmarshalledStream = (0, _getUnmarshalledStream.getUnmarshalledStream)(chunkedStream, {
            eventStreamCodec: this.eventStreamCodec,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        var self = this;
        var serializedIterator = function serializedIterator() {
            return (0, _tslib.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, _tslib.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4,
                                (0, _tslib.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventStreamCodec.encode(serializer(chunk));
                            return [
                                4,
                                (0, _tslib.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3,
                                1
                            ];
                        case 6:
                            return [
                                3,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3,
                                10
                            ];
                            return [
                                4,
                                (0, _tslib.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7
                            ];
                        case 12:
                            return [
                                7
                            ];
                        case 13:
                            return [
                                4,
                                (0, _tslib.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            return [
                                4,
                                _b.sent()
                            ];
                        case 15:
                            _b.sent();
                            return [
                                2
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

},{"tslib":"86BcK","@aws-sdk/eventstream-codec":"9oWhf","./getChunkedStream":"gViiy","./getUnmarshalledStream":"atiBu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9oWhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamCodec = require("./EventStreamCodec");
parcelHelpers.exportAll(_eventStreamCodec, exports);
var _int64 = require("./Int64");
parcelHelpers.exportAll(_int64, exports);
var _message = require("./Message");
parcelHelpers.exportAll(_message, exports);

},{"./EventStreamCodec":"9c5Je","./Int64":"i4snO","./Message":"2jcng","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9c5Je":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamCodec", function() {
    return EventStreamCodec;
});
var _crc32 = require("@aws-crypto/crc32");
var _headerMarshaller = require("./HeaderMarshaller");
var _splitMessage = require("./splitMessage");
var EventStreamCodec = function() {
    function EventStreamCodec(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, _headerMarshaller.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    EventStreamCodec.prototype.encode = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, _crc32.Crc32)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    EventStreamCodec.prototype.decode = function(message) {
        var _a = (0, _splitMessage.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    EventStreamCodec.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamCodec;
}();

},{"@aws-crypto/crc32":"c0tRF","./HeaderMarshaller":"962Mw","./splitMessage":"7t6n1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c0tRF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
var tslib_1 = require("eb190ce5d781d2");
var util_1 = require("b0d4507b4ec71f92");
function crc32(data) {
    return new Crc32().update(data).digest();
}
exports.crc32 = crc32;
var Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, tslib_1.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
exports.Crc32 = Crc32;
// prettier-ignore
var a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
var aws_crc32_1 = require("ec5c1fdc84f4e928");
Object.defineProperty(exports, "AwsCrc32", {
    enumerable: true,
    get: function get() {
        return aws_crc32_1.AwsCrc32;
    }
});

},{"eb190ce5d781d2":"764fU","b0d4507b4ec71f92":"40k2W","ec5c1fdc84f4e928":"gpFbs"}],"764fU":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40k2W":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("3d26551dda3117c9");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function get() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("a945d3de4dda2099");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function get() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("d33f2c3f27ec71dc");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function get() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("ff40339e2ea5b29");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function get() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"3d26551dda3117c9":"9p5l6","a945d3de4dda2099":"3GWIK","d33f2c3f27ec71dc":"7dS1w","ff40339e2ea5b29":"glCLb"}],"9p5l6":[function(require,module,exports,__globalThis) {
var Buffer = require("78f881cb7cdbd421").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("befc9fe24c8f855a");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function fromUtf8(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"78f881cb7cdbd421":"cvSE8","befc9fe24c8f855a":"iZmxX"}],"3GWIK":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"7dS1w":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"glCLb":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"gpFbs":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = void 0;
var tslib_1 = require("bee24bf490010395");
var util_1 = require("4d1faea5abf6593e");
var index_1 = require("3def414f17585db6");
var AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new index_1.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash)) return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, util_1.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
exports.AwsCrc32 = AwsCrc32;

},{"bee24bf490010395":"764fU","4d1faea5abf6593e":"40k2W","3def414f17585db6":"c0tRF"}],"962Mw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderMarshaller", function() {
    return HeaderMarshaller;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _int64 = require("./Int64");
var HeaderMarshaller = function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, _tslib.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, _tslib.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, _int64.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: ".concat(header.value));
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, _utilHexEncoding.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name_1 = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name_1] = {
                        type: BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name_1] = {
                        type: BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name_1] = {
                        type: BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name_1] = {
                        type: SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name_1] = {
                        type: INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name_1] = {
                        type: LONG_TAG,
                        value: new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name_1] = {
                        type: BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name_1] = {
                        type: STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name_1] = {
                        type: TIMESTAMP_TAG,
                        value: new Date(new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name_1] = {
                        type: UUID_TAG,
                        value: "".concat((0, _utilHexEncoding.toHex)(uuidBytes.subarray(0, 4)), "-").concat((0, _utilHexEncoding.toHex)(uuidBytes.subarray(4, 6)), "-").concat((0, _utilHexEncoding.toHex)(uuidBytes.subarray(6, 8)), "-").concat((0, _utilHexEncoding.toHex)(uuidBytes.subarray(8, 10)), "-").concat((0, _utilHexEncoding.toHex)(uuidBytes.subarray(10)))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
var BOOLEAN_TAG = "boolean";
var BYTE_TAG = "byte";
var SHORT_TAG = "short";
var INT_TAG = "integer";
var LONG_TAG = "long";
var BINARY_TAG = "binary";
var STRING_TAG = "string";
var TIMESTAMP_TAG = "timestamp";
var UUID_TAG = "uuid";
var UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"cDtwb","./Int64":"i4snO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cDtwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", function() {
    return fromHex;
});
parcelHelpers.export(exports, "toHex", function() {
    return toHex;
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i4snO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Int64", function() {
    return Int64;
});
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var Int64 = function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error("".concat(number, " is too large (or, if negative, too small) to represent as an Int64"));
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) negate(bytes);
        return new Int64(bytes);
    };
    Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) negate(bytes);
        return parseInt((0, _utilHexEncoding.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

},{"@aws-sdk/util-hex-encoding":"cDtwb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7t6n1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitMessage", function() {
    return splitMessage;
});
var _crc32 = require("@aws-crypto/crc32");
var PRELUDE_MEMBER_LENGTH = 4;
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
var CHECKSUM_LENGTH = 4;
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - CHECKSUM_LENGTH, false);
    var checksummer = new (0, _crc32.Crc32)().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (".concat(expectedPreludeChecksum, ") does not match the calculated CRC32 checksum (").concat(checksummer.digest(), ")"));
    checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (".concat(checksummer.digest(), ") did not match the expected value of ").concat(expectedMessageChecksum));
    return {
        headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
    };
}

},{"@aws-crypto/crc32":"c0tRF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2jcng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gViiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChunkedStream", function() {
    return getChunkedStream;
});
var _tslib = require("tslib");
function getChunkedStream(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function allocateMessage(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false);
    };
    var iterator = function iterator() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4,
                            (0, _tslib.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3,
                            15
                        ];
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
                            messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) return [
                                3,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
                        currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3,
                            14
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 12:
                        return [
                            4,
                            _b.sent()
                        ];
                    case 13:
                        _b.sent();
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3,
                            11
                        ];
                    case 15:
                        return [
                            3,
                            1
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"atiBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUnmarshalledStream", function() {
    return getUnmarshalledStream;
});
var _tslib = require("tslib");
function getUnmarshalledStream(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event_1, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, _tslib.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4,
                            (0, _tslib.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventStreamCodec.decode(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4,
                            (0, _tslib.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3,
                            9
                        ];
                        event_1 = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4,
                            (0, _tslib.__await)(options.deserializer(event_1))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: ".concat(message.headers[":event-type"].value));
                    case 10:
                        return [
                            3,
                            1
                        ];
                    case 11:
                        return [
                            3,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3,
                            15
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7
                        ];
                    case 17:
                        return [
                            7
                        ];
                    case 18:
                        return [
                            2
                        ];
                }
            });
        });
    }, _a;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bMAz5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", function() {
    return eventStreamSerdeProvider;
});
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function eventStreamSerdeProvider(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"8xTai","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fJCaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamtoIterable", function() {
    return readableStreamtoIterable;
});
parcelHelpers.export(exports, "iterableToReadableStream", function() {
    return iterableToReadableStream;
});
var _tslib = require("tslib");
var readableStreamtoIterable = function readableStreamtoIterable(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4,
                            (0, _tslib.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4,
                            (0, _tslib.__await)(value)
                        ];
                    case 6:
                        return [
                            4,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3,
                            2
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
    }, _a;
};
var iterableToReadableStream = function iterableToReadableStream(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function pull(controller) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hLxjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", function() {
    return eventStreamSerdeProvider;
});
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function eventStreamSerdeProvider(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"i504P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cu2dj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"i5jf5","./stream-collector":"ix8IB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i5jf5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", function() {
    return FetchHttpHandler;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _$_a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_$_a = _b.return)) _$_a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","@aws-sdk/querystring-builder":"4L01S","./request-timeout":"fOgDS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4L01S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", function() {
    return buildQueryString;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"d3YWy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fOgDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", function() {
    return requestTimeout;
});
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ix8IB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", function() {
    return streamCollector;
});
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function streamCollector(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"86BcK","@aws-sdk/util-base64-browser":"ioEwz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ioEwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", function() {
    return fromBase64;
});
parcelHelpers.export(exports, "toBase64", function() {
    return toBase64;
});
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kwvBH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"a37Fg","./invalidProvider":"5pBB3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a37Fg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", function() {
    return invalidFunction;
});
var invalidFunction = function invalidFunction(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5pBB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", function() {
    return invalidProvider;
});
var invalidProvider = function invalidProvider(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6ktb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"hubJg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hubJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", function() {
    return calculateBodyLength;
});
var calculateBodyLength = function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iw9RT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", function() {
    return defaultUserAgent;
});
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function defaultUserAgent(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _$_a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_$_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _$_a === void 0 ? void 0 : _$_a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"86BcK","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jxlv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2020-08-07",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lex Runtime V2",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"lemSv","./endpoints":"7TFm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lemSv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function parseUrl1(url) {
    if (typeof url === 'string') return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"3RcBL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3RcBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", function() {
    return parseQueryString;
});
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7TFm7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime-v2-lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime-v2-lex.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime-v2-lex.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime-v2-lex.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime-v2-lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime-v2-lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "lex",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/config-resolver":"kNL14","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gBqVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deleteSessionCommand = require("./DeleteSessionCommand");
parcelHelpers.exportAll(_deleteSessionCommand, exports);
var _getSessionCommand = require("./GetSessionCommand");
parcelHelpers.exportAll(_getSessionCommand, exports);
var _putSessionCommand = require("./PutSessionCommand");
parcelHelpers.exportAll(_putSessionCommand, exports);
var _recognizeTextCommand = require("./RecognizeTextCommand");
parcelHelpers.exportAll(_recognizeTextCommand, exports);
var _recognizeUtteranceCommand = require("./RecognizeUtteranceCommand");
parcelHelpers.exportAll(_recognizeUtteranceCommand, exports);
var _startConversationCommand = require("./StartConversationCommand");
parcelHelpers.exportAll(_startConversationCommand, exports);

},{"./DeleteSessionCommand":false,"./GetSessionCommand":false,"./PutSessionCommand":false,"./RecognizeTextCommand":"4amTA","./RecognizeUtteranceCommand":"czLMa","./StartConversationCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4amTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecognizeTextCommand", function() {
    return RecognizeTextCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var RecognizeTextCommand = function(_super) {
    (0, _tslib.__extends)(RecognizeTextCommand, _super);
    function RecognizeTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    RecognizeTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeV2Client";
        var commandName = "RecognizeTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.RecognizeTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.RecognizeTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RecognizeTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1RecognizeTextCommand)(input, context);
    };
    RecognizeTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1RecognizeTextCommand)(output, context);
    };
    return RecognizeTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"2c1Zy","@aws-sdk/smithy-client":"kHS8Y","../models/models_0":"kyRls","../protocols/Aws_restJson1":"8M4zb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2c1Zy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"k20RZ","./serdePlugin":"gxWiH","./serializerMiddleware":"a3XqH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k20RZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", function() {
    return deserializerMiddleware;
});
var _tslib = require("tslib");
var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gxWiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", function() {
    return deserializerMiddlewareOption;
});
parcelHelpers.export(exports, "serializerMiddlewareOption", function() {
    return serializerMiddlewareOption;
});
parcelHelpers.export(exports, "getSerdePlugin", function() {
    return getSerdePlugin;
});
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function applyToStack(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"k20RZ","./serializerMiddleware":"a3XqH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a3XqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", function() {
    return serializerMiddleware;
});
var _tslib = require("tslib");
var serializerMiddleware = function serializerMiddleware(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function endpoint() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kyRls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessDeniedException", function() {
    return AccessDeniedException;
});
parcelHelpers.export(exports, "ConflictException", function() {
    return ConflictException;
});
parcelHelpers.export(exports, "InternalServerException", function() {
    return InternalServerException;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "ThrottlingException", function() {
    return ThrottlingException;
});
parcelHelpers.export(exports, "ValidationException", function() {
    return ValidationException;
});
parcelHelpers.export(exports, "ConfirmationState", function() {
    return ConfirmationState;
});
parcelHelpers.export(exports, "Shape", function() {
    return Shape;
});
parcelHelpers.export(exports, "IntentState", function() {
    return IntentState;
});
parcelHelpers.export(exports, "SentimentType", function() {
    return SentimentType;
});
parcelHelpers.export(exports, "MessageContentType", function() {
    return MessageContentType;
});
parcelHelpers.export(exports, "StyleType", function() {
    return StyleType;
});
parcelHelpers.export(exports, "DialogActionType", function() {
    return DialogActionType;
});
parcelHelpers.export(exports, "BadGatewayException", function() {
    return BadGatewayException;
});
parcelHelpers.export(exports, "DependencyFailedException", function() {
    return DependencyFailedException;
});
parcelHelpers.export(exports, "ConversationMode", function() {
    return ConversationMode;
});
parcelHelpers.export(exports, "InputMode", function() {
    return InputMode;
});
parcelHelpers.export(exports, "PlaybackInterruptionReason", function() {
    return PlaybackInterruptionReason;
});
parcelHelpers.export(exports, "StartConversationRequestEventStream", function() {
    return StartConversationRequestEventStream;
});
parcelHelpers.export(exports, "StartConversationResponseEventStream", function() {
    return StartConversationResponseEventStream;
});
parcelHelpers.export(exports, "ActiveContextTimeToLiveFilterSensitiveLog", function() {
    return ActiveContextTimeToLiveFilterSensitiveLog;
});
parcelHelpers.export(exports, "ActiveContextFilterSensitiveLog", function() {
    return ActiveContextFilterSensitiveLog;
});
parcelHelpers.export(exports, "AudioInputEventFilterSensitiveLog", function() {
    return AudioInputEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "AudioResponseEventFilterSensitiveLog", function() {
    return AudioResponseEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteSessionRequestFilterSensitiveLog", function() {
    return DeleteSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteSessionResponseFilterSensitiveLog", function() {
    return DeleteSessionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetSessionRequestFilterSensitiveLog", function() {
    return GetSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ValueFilterSensitiveLog", function() {
    return ValueFilterSensitiveLog;
});
parcelHelpers.export(exports, "ConfidenceScoreFilterSensitiveLog", function() {
    return ConfidenceScoreFilterSensitiveLog;
});
parcelHelpers.export(exports, "SentimentScoreFilterSensitiveLog", function() {
    return SentimentScoreFilterSensitiveLog;
});
parcelHelpers.export(exports, "SentimentResponseFilterSensitiveLog", function() {
    return SentimentResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ButtonFilterSensitiveLog", function() {
    return ButtonFilterSensitiveLog;
});
parcelHelpers.export(exports, "ImageResponseCardFilterSensitiveLog", function() {
    return ImageResponseCardFilterSensitiveLog;
});
parcelHelpers.export(exports, "MessageFilterSensitiveLog", function() {
    return MessageFilterSensitiveLog;
});
parcelHelpers.export(exports, "RuntimeHintValueFilterSensitiveLog", function() {
    return RuntimeHintValueFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutSessionResponseFilterSensitiveLog", function() {
    return PutSessionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "RecognizeUtteranceRequestFilterSensitiveLog", function() {
    return RecognizeUtteranceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "RecognizeUtteranceResponseFilterSensitiveLog", function() {
    return RecognizeUtteranceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DisconnectionEventFilterSensitiveLog", function() {
    return DisconnectionEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "DTMFInputEventFilterSensitiveLog", function() {
    return DTMFInputEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "PlaybackCompletionEventFilterSensitiveLog", function() {
    return PlaybackCompletionEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "TextInputEventFilterSensitiveLog", function() {
    return TextInputEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "HeartbeatEventFilterSensitiveLog", function() {
    return HeartbeatEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "PlaybackInterruptionEventFilterSensitiveLog", function() {
    return PlaybackInterruptionEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "TextResponseEventFilterSensitiveLog", function() {
    return TextResponseEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "TranscriptEventFilterSensitiveLog", function() {
    return TranscriptEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "ElicitSubSlotFilterSensitiveLog", function() {
    return ElicitSubSlotFilterSensitiveLog;
});
parcelHelpers.export(exports, "DialogActionFilterSensitiveLog", function() {
    return DialogActionFilterSensitiveLog;
});
parcelHelpers.export(exports, "RuntimeHintDetailsFilterSensitiveLog", function() {
    return RuntimeHintDetailsFilterSensitiveLog;
});
parcelHelpers.export(exports, "RuntimeHintsFilterSensitiveLog", function() {
    return RuntimeHintsFilterSensitiveLog;
});
parcelHelpers.export(exports, "SlotFilterSensitiveLog", function() {
    return SlotFilterSensitiveLog;
});
parcelHelpers.export(exports, "IntentFilterSensitiveLog", function() {
    return IntentFilterSensitiveLog;
});
parcelHelpers.export(exports, "InterpretationFilterSensitiveLog", function() {
    return InterpretationFilterSensitiveLog;
});
parcelHelpers.export(exports, "SessionStateFilterSensitiveLog", function() {
    return SessionStateFilterSensitiveLog;
});
parcelHelpers.export(exports, "ConfigurationEventFilterSensitiveLog", function() {
    return ConfigurationEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutSessionRequestFilterSensitiveLog", function() {
    return PutSessionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "RecognizeTextRequestFilterSensitiveLog", function() {
    return RecognizeTextRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "StartConversationRequestEventStreamFilterSensitiveLog", function() {
    return StartConversationRequestEventStreamFilterSensitiveLog;
});
parcelHelpers.export(exports, "StartConversationRequestFilterSensitiveLog", function() {
    return StartConversationRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetSessionResponseFilterSensitiveLog", function() {
    return GetSessionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "IntentResultEventFilterSensitiveLog", function() {
    return IntentResultEventFilterSensitiveLog;
});
parcelHelpers.export(exports, "RecognizeTextResponseFilterSensitiveLog", function() {
    return RecognizeTextResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "StartConversationResponseEventStreamFilterSensitiveLog", function() {
    return StartConversationResponseEventStreamFilterSensitiveLog;
});
parcelHelpers.export(exports, "StartConversationResponseFilterSensitiveLog", function() {
    return StartConversationResponseFilterSensitiveLog;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeV2ServiceException = require("./LexRuntimeV2ServiceException");
var AccessDeniedException = function(_super) {
    (0, _tslib.__extends)(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "AccessDeniedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        return _this;
    }
    return AccessDeniedException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        return _this;
    }
    return ConflictException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var InternalServerException = function(_super) {
    (0, _tslib.__extends)(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalServerException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        return _this;
    }
    return InternalServerException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ResourceNotFoundException = function(_super) {
    (0, _tslib.__extends)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ThrottlingException = function(_super) {
    (0, _tslib.__extends)(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ThrottlingException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        return _this;
    }
    return ThrottlingException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ValidationException = function(_super) {
    (0, _tslib.__extends)(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ValidationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        return _this;
    }
    return ValidationException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ConfirmationState;
(function(ConfirmationState) {
    ConfirmationState["CONFIRMED"] = "Confirmed";
    ConfirmationState["DENIED"] = "Denied";
    ConfirmationState["NONE"] = "None";
})(ConfirmationState || (ConfirmationState = {}));
var Shape;
(function(Shape) {
    Shape["COMPOSITE"] = "Composite";
    Shape["LIST"] = "List";
    Shape["SCALAR"] = "Scalar";
})(Shape || (Shape = {}));
var IntentState;
(function(IntentState) {
    IntentState["FAILED"] = "Failed";
    IntentState["FULFILLED"] = "Fulfilled";
    IntentState["FULFILLMENT_IN_PROGRESS"] = "FulfillmentInProgress";
    IntentState["IN_PROGRESS"] = "InProgress";
    IntentState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
    IntentState["WAITING"] = "Waiting";
})(IntentState || (IntentState = {}));
var SentimentType;
(function(SentimentType) {
    SentimentType["MIXED"] = "MIXED";
    SentimentType["NEGATIVE"] = "NEGATIVE";
    SentimentType["NEUTRAL"] = "NEUTRAL";
    SentimentType["POSITIVE"] = "POSITIVE";
})(SentimentType || (SentimentType = {}));
var MessageContentType;
(function(MessageContentType) {
    MessageContentType["CUSTOM_PAYLOAD"] = "CustomPayload";
    MessageContentType["IMAGE_RESPONSE_CARD"] = "ImageResponseCard";
    MessageContentType["PLAIN_TEXT"] = "PlainText";
    MessageContentType["SSML"] = "SSML";
})(MessageContentType || (MessageContentType = {}));
var StyleType;
(function(StyleType) {
    StyleType["DEFAULT"] = "Default";
    StyleType["SPELL_BY_LETTER"] = "SpellByLetter";
    StyleType["SPELL_BY_WORD"] = "SpellByWord";
})(StyleType || (StyleType = {}));
var DialogActionType;
(function(DialogActionType) {
    DialogActionType["CLOSE"] = "Close";
    DialogActionType["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogActionType["DELEGATE"] = "Delegate";
    DialogActionType["ELICIT_INTENT"] = "ElicitIntent";
    DialogActionType["ELICIT_SLOT"] = "ElicitSlot";
    DialogActionType["NONE"] = "None";
})(DialogActionType || (DialogActionType = {}));
var BadGatewayException = function(_super) {
    (0, _tslib.__extends)(BadGatewayException, _super);
    function BadGatewayException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadGatewayException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "BadGatewayException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, BadGatewayException.prototype);
        return _this;
    }
    return BadGatewayException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var DependencyFailedException = function(_super) {
    (0, _tslib.__extends)(DependencyFailedException, _super);
    function DependencyFailedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "DependencyFailedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "DependencyFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DependencyFailedException.prototype);
        return _this;
    }
    return DependencyFailedException;
}((0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException));
var ConversationMode;
(function(ConversationMode) {
    ConversationMode["AUDIO"] = "AUDIO";
    ConversationMode["TEXT"] = "TEXT";
})(ConversationMode || (ConversationMode = {}));
var InputMode;
(function(InputMode) {
    InputMode["DTMF"] = "DTMF";
    InputMode["SPEECH"] = "Speech";
    InputMode["TEXT"] = "Text";
})(InputMode || (InputMode = {}));
var PlaybackInterruptionReason;
(function(PlaybackInterruptionReason) {
    PlaybackInterruptionReason["DTMF_START_DETECTED"] = "DTMF_START_DETECTED";
    PlaybackInterruptionReason["TEXT_DETECTED"] = "TEXT_DETECTED";
    PlaybackInterruptionReason["VOICE_START_DETECTED"] = "VOICE_START_DETECTED";
})(PlaybackInterruptionReason || (PlaybackInterruptionReason = {}));
var StartConversationRequestEventStream;
(function(StartConversationRequestEventStream) {
    StartConversationRequestEventStream.visit = function(value, visitor) {
        if (value.ConfigurationEvent !== undefined) return visitor.ConfigurationEvent(value.ConfigurationEvent);
        if (value.AudioInputEvent !== undefined) return visitor.AudioInputEvent(value.AudioInputEvent);
        if (value.DTMFInputEvent !== undefined) return visitor.DTMFInputEvent(value.DTMFInputEvent);
        if (value.TextInputEvent !== undefined) return visitor.TextInputEvent(value.TextInputEvent);
        if (value.PlaybackCompletionEvent !== undefined) return visitor.PlaybackCompletionEvent(value.PlaybackCompletionEvent);
        if (value.DisconnectionEvent !== undefined) return visitor.DisconnectionEvent(value.DisconnectionEvent);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(StartConversationRequestEventStream || (StartConversationRequestEventStream = {}));
var StartConversationResponseEventStream;
(function(StartConversationResponseEventStream) {
    StartConversationResponseEventStream.visit = function(value, visitor) {
        if (value.PlaybackInterruptionEvent !== undefined) return visitor.PlaybackInterruptionEvent(value.PlaybackInterruptionEvent);
        if (value.TranscriptEvent !== undefined) return visitor.TranscriptEvent(value.TranscriptEvent);
        if (value.IntentResultEvent !== undefined) return visitor.IntentResultEvent(value.IntentResultEvent);
        if (value.TextResponseEvent !== undefined) return visitor.TextResponseEvent(value.TextResponseEvent);
        if (value.AudioResponseEvent !== undefined) return visitor.AudioResponseEvent(value.AudioResponseEvent);
        if (value.HeartbeatEvent !== undefined) return visitor.HeartbeatEvent(value.HeartbeatEvent);
        if (value.AccessDeniedException !== undefined) return visitor.AccessDeniedException(value.AccessDeniedException);
        if (value.ResourceNotFoundException !== undefined) return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ValidationException !== undefined) return visitor.ValidationException(value.ValidationException);
        if (value.ThrottlingException !== undefined) return visitor.ThrottlingException(value.ThrottlingException);
        if (value.InternalServerException !== undefined) return visitor.InternalServerException(value.InternalServerException);
        if (value.ConflictException !== undefined) return visitor.ConflictException(value.ConflictException);
        if (value.DependencyFailedException !== undefined) return visitor.DependencyFailedException(value.DependencyFailedException);
        if (value.BadGatewayException !== undefined) return visitor.BadGatewayException(value.BadGatewayException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(StartConversationResponseEventStream || (StartConversationResponseEventStream = {}));
var ActiveContextTimeToLiveFilterSensitiveLog = function ActiveContextTimeToLiveFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ActiveContextFilterSensitiveLog = function ActiveContextFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.contextAttributes && {
        contextAttributes: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var AudioInputEventFilterSensitiveLog = function AudioInputEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var AudioResponseEventFilterSensitiveLog = function AudioResponseEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteSessionRequestFilterSensitiveLog = function DeleteSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteSessionResponseFilterSensitiveLog = function DeleteSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetSessionRequestFilterSensitiveLog = function GetSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ValueFilterSensitiveLog = function ValueFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ConfidenceScoreFilterSensitiveLog = function ConfidenceScoreFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SentimentScoreFilterSensitiveLog = function SentimentScoreFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SentimentResponseFilterSensitiveLog = function SentimentResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ButtonFilterSensitiveLog = function ButtonFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ImageResponseCardFilterSensitiveLog = function ImageResponseCardFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var MessageFilterSensitiveLog = function MessageFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.content && {
        content: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var RuntimeHintValueFilterSensitiveLog = function RuntimeHintValueFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PutSessionResponseFilterSensitiveLog = function PutSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RecognizeUtteranceRequestFilterSensitiveLog = function RecognizeUtteranceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionState && {
        sessionState: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var RecognizeUtteranceResponseFilterSensitiveLog = function RecognizeUtteranceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisconnectionEventFilterSensitiveLog = function DisconnectionEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DTMFInputEventFilterSensitiveLog = function DTMFInputEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.inputCharacter && {
        inputCharacter: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PlaybackCompletionEventFilterSensitiveLog = function PlaybackCompletionEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TextInputEventFilterSensitiveLog = function TextInputEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.text && {
        text: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var HeartbeatEventFilterSensitiveLog = function HeartbeatEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaybackInterruptionEventFilterSensitiveLog = function PlaybackInterruptionEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TextResponseEventFilterSensitiveLog = function TextResponseEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.messages && {
        messages: obj.messages.map(function(item) {
            return MessageFilterSensitiveLog(item);
        })
    });
};
var TranscriptEventFilterSensitiveLog = function TranscriptEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ElicitSubSlotFilterSensitiveLog = function ElicitSubSlotFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DialogActionFilterSensitiveLog = function DialogActionFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RuntimeHintDetailsFilterSensitiveLog = function RuntimeHintDetailsFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RuntimeHintsFilterSensitiveLog = function RuntimeHintsFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SlotFilterSensitiveLog = function SlotFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var IntentFilterSensitiveLog = function IntentFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var InterpretationFilterSensitiveLog = function InterpretationFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SessionStateFilterSensitiveLog = function SessionStateFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.activeContexts && {
        activeContexts: obj.activeContexts.map(function(item) {
            return ActiveContextFilterSensitiveLog(item);
        })
    });
};
var ConfigurationEventFilterSensitiveLog = function ConfigurationEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.welcomeMessages && {
        welcomeMessages: obj.welcomeMessages.map(function(item) {
            return MessageFilterSensitiveLog(item);
        })
    });
};
var PutSessionRequestFilterSensitiveLog = function PutSessionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.messages && {
        messages: obj.messages.map(function(item) {
            return MessageFilterSensitiveLog(item);
        })
    });
};
var RecognizeTextRequestFilterSensitiveLog = function RecognizeTextRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.text && {
        text: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var StartConversationRequestEventStreamFilterSensitiveLog = function StartConversationRequestEventStreamFilterSensitiveLog(obj) {
    var _a;
    if (obj.ConfigurationEvent !== undefined) return {
        ConfigurationEvent: ConfigurationEventFilterSensitiveLog(obj.ConfigurationEvent)
    };
    if (obj.AudioInputEvent !== undefined) return {
        AudioInputEvent: AudioInputEventFilterSensitiveLog(obj.AudioInputEvent)
    };
    if (obj.DTMFInputEvent !== undefined) return {
        DTMFInputEvent: DTMFInputEventFilterSensitiveLog(obj.DTMFInputEvent)
    };
    if (obj.TextInputEvent !== undefined) return {
        TextInputEvent: TextInputEventFilterSensitiveLog(obj.TextInputEvent)
    };
    if (obj.PlaybackCompletionEvent !== undefined) return {
        PlaybackCompletionEvent: PlaybackCompletionEventFilterSensitiveLog(obj.PlaybackCompletionEvent)
    };
    if (obj.DisconnectionEvent !== undefined) return {
        DisconnectionEvent: DisconnectionEventFilterSensitiveLog(obj.DisconnectionEvent)
    };
    if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
};
var StartConversationRequestFilterSensitiveLog = function StartConversationRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.requestEventStream && {
        requestEventStream: "STREAMING_CONTENT"
    });
};
var GetSessionResponseFilterSensitiveLog = function GetSessionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.messages && {
        messages: obj.messages.map(function(item) {
            return MessageFilterSensitiveLog(item);
        })
    });
};
var IntentResultEventFilterSensitiveLog = function IntentResultEventFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RecognizeTextResponseFilterSensitiveLog = function RecognizeTextResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.messages && {
        messages: obj.messages.map(function(item) {
            return MessageFilterSensitiveLog(item);
        })
    });
};
var StartConversationResponseEventStreamFilterSensitiveLog = function StartConversationResponseEventStreamFilterSensitiveLog(obj) {
    var _a;
    if (obj.PlaybackInterruptionEvent !== undefined) return {
        PlaybackInterruptionEvent: PlaybackInterruptionEventFilterSensitiveLog(obj.PlaybackInterruptionEvent)
    };
    if (obj.TranscriptEvent !== undefined) return {
        TranscriptEvent: TranscriptEventFilterSensitiveLog(obj.TranscriptEvent)
    };
    if (obj.IntentResultEvent !== undefined) return {
        IntentResultEvent: IntentResultEventFilterSensitiveLog(obj.IntentResultEvent)
    };
    if (obj.TextResponseEvent !== undefined) return {
        TextResponseEvent: TextResponseEventFilterSensitiveLog(obj.TextResponseEvent)
    };
    if (obj.AudioResponseEvent !== undefined) return {
        AudioResponseEvent: AudioResponseEventFilterSensitiveLog(obj.AudioResponseEvent)
    };
    if (obj.HeartbeatEvent !== undefined) return {
        HeartbeatEvent: HeartbeatEventFilterSensitiveLog(obj.HeartbeatEvent)
    };
    if (obj.AccessDeniedException !== undefined) return {
        AccessDeniedException: obj.AccessDeniedException
    };
    if (obj.ResourceNotFoundException !== undefined) return {
        ResourceNotFoundException: obj.ResourceNotFoundException
    };
    if (obj.ValidationException !== undefined) return {
        ValidationException: obj.ValidationException
    };
    if (obj.ThrottlingException !== undefined) return {
        ThrottlingException: obj.ThrottlingException
    };
    if (obj.InternalServerException !== undefined) return {
        InternalServerException: obj.InternalServerException
    };
    if (obj.ConflictException !== undefined) return {
        ConflictException: obj.ConflictException
    };
    if (obj.DependencyFailedException !== undefined) return {
        DependencyFailedException: obj.DependencyFailedException
    };
    if (obj.BadGatewayException !== undefined) return {
        BadGatewayException: obj.BadGatewayException
    };
    if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
};
var StartConversationResponseFilterSensitiveLog = function StartConversationResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.responseEventStream && {
        responseEventStream: "STREAMING_CONTENT"
    });
};

},{"tslib":"86BcK","@aws-sdk/smithy-client":"kHS8Y","./LexRuntimeV2ServiceException":"02AMA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"02AMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeV2ServiceException", function() {
    return LexRuntimeV2ServiceException;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LexRuntimeV2ServiceException = function(_super) {
    (0, _tslib.__extends)(LexRuntimeV2ServiceException, _super);
    function LexRuntimeV2ServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LexRuntimeV2ServiceException.prototype);
        return _this;
    }
    return LexRuntimeV2ServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"kHS8Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8M4zb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteSessionCommand", function() {
    return serializeAws_restJson1DeleteSessionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetSessionCommand", function() {
    return serializeAws_restJson1GetSessionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PutSessionCommand", function() {
    return serializeAws_restJson1PutSessionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1RecognizeTextCommand", function() {
    return serializeAws_restJson1RecognizeTextCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1RecognizeUtteranceCommand", function() {
    return serializeAws_restJson1RecognizeUtteranceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1StartConversationCommand", function() {
    return serializeAws_restJson1StartConversationCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteSessionCommand", function() {
    return deserializeAws_restJson1DeleteSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetSessionCommand", function() {
    return deserializeAws_restJson1GetSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutSessionCommand", function() {
    return deserializeAws_restJson1PutSessionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1RecognizeTextCommand", function() {
    return deserializeAws_restJson1RecognizeTextCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1RecognizeUtteranceCommand", function() {
    return deserializeAws_restJson1RecognizeUtteranceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1StartConversationCommand", function() {
    return deserializeAws_restJson1StartConversationCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeV2ServiceException = require("../models/LexRuntimeV2ServiceException");
var _models0 = require("../models/models_0");
var serializeAws_restJson1DeleteSessionCommand = function serializeAws_restJson1DeleteSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetSessionCommand = function serializeAws_restJson1GetSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutSessionCommand = function serializeAws_restJson1PutSessionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "content-type": "application/json",
                        responsecontenttype: input.responseContentType
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.messages != null && {
                        messages: serializeAws_restJson1Messages(input.messages, context)
                    }), input.requestAttributes != null && {
                        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
                    }), input.sessionState != null && {
                        sessionState: serializeAws_restJson1SessionState(input.sessionState, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1RecognizeTextCommand = function serializeAws_restJson1RecognizeTextCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.requestAttributes != null && {
                        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
                    }), input.sessionState != null && {
                        sessionState: serializeAws_restJson1SessionState(input.sessionState, context)
                    }), input.text != null && {
                        text: input.text
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1RecognizeUtteranceCommand = function serializeAws_restJson1RecognizeUtteranceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
                        "content-type": input.requestContentType || "application/octet-stream",
                        "x-amz-lex-session-state": input.sessionState,
                        "x-amz-lex-request-attributes": input.requestAttributes,
                        "response-content-type": input.responseContentType
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/utterance";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    if (input.inputStream !== undefined) body = input.inputStream;
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1StartConversationCommand = function serializeAws_restJson1StartConversationCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "x-amz-lex-conversation-mode": input.conversationMode
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/conversation";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botId", function() {
                        return input.botId;
                    }, "{botId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAliasId", function() {
                        return input.botAliasId;
                    }, "{botAliasId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "localeId", function() {
                        return input.localeId;
                    }, "{localeId}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "sessionId", function() {
                        return input.sessionId;
                    }, "{sessionId}", false);
                    if (input.requestEventStream !== undefined) body = serializeAws_restJson1StartConversationRequestEventStream(input.requestEventStream, context);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommand = function deserializeAws_restJson1DeleteSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.botAliasId != null) contents.botAliasId = (0, _smithyClient.expectString)(data.botAliasId);
                    if (data.botId != null) contents.botId = (0, _smithyClient.expectString)(data.botId);
                    if (data.localeId != null) contents.localeId = (0, _smithyClient.expectString)(data.localeId);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommandError = function deserializeAws_restJson1DeleteSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "ValidationException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 15;
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommand = function deserializeAws_restJson1GetSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.interpretations != null) contents.interpretations = deserializeAws_restJson1Interpretations(data.interpretations, context);
                    if (data.messages != null) contents.messages = deserializeAws_restJson1Messages(data.messages, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.sessionState != null) contents.sessionState = deserializeAws_restJson1SessionState(data.sessionState, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommandError = function deserializeAws_restJson1GetSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutSessionCommand = function deserializeAws_restJson1PutSessionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PutSessionCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                messages: [
                    ,
                    output.headers["x-amz-lex-messages"]
                ],
                sessionState: [
                    ,
                    output.headers["x-amz-lex-session-state"]
                ],
                requestAttributes: [
                    ,
                    output.headers["x-amz-lex-request-attributes"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PutSessionCommandError = function deserializeAws_restJson1PutSessionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "ValidationException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1RecognizeTextCommand = function deserializeAws_restJson1RecognizeTextCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1RecognizeTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.interpretations != null) contents.interpretations = deserializeAws_restJson1Interpretations(data.interpretations, context);
                    if (data.messages != null) contents.messages = deserializeAws_restJson1Messages(data.messages, context);
                    if (data.requestAttributes != null) contents.requestAttributes = deserializeAws_restJson1StringMap(data.requestAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.sessionState != null) contents.sessionState = deserializeAws_restJson1SessionState(data.sessionState, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1RecognizeTextCommandError = function deserializeAws_restJson1RecognizeTextCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "ValidationException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1RecognizeUtteranceCommand = function deserializeAws_restJson1RecognizeUtteranceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1RecognizeUtteranceCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                inputMode: [
                    ,
                    output.headers["x-amz-lex-input-mode"]
                ],
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                messages: [
                    ,
                    output.headers["x-amz-lex-messages"]
                ],
                interpretations: [
                    ,
                    output.headers["x-amz-lex-interpretations"]
                ],
                sessionState: [
                    ,
                    output.headers["x-amz-lex-session-state"]
                ],
                requestAttributes: [
                    ,
                    output.headers["x-amz-lex-request-attributes"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                inputTranscript: [
                    ,
                    output.headers["x-amz-lex-input-transcript"]
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1RecognizeUtteranceCommandError = function deserializeAws_restJson1RecognizeUtteranceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#BadGatewayException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                10
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimev2#ResourceNotFoundException":
                            return [
                                3,
                                12
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                14
                            ];
                        case "ValidationException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1StartConversationCommand = function deserializeAws_restJson1StartConversationCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1StartConversationCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output)
            });
            data = output.body;
            contents.responseEventStream = deserializeAws_restJson1StartConversationResponseEventStream(data, context);
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1StartConversationCommandError = function deserializeAws_restJson1StartConversationCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimev2#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimev2#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimev2#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimev2#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeV2ServiceException.LexRuntimeV2ServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1AccessDeniedExceptionResponse = function deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.AccessDeniedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1BadGatewayExceptionResponse = function deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.BadGatewayException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1DependencyFailedExceptionResponse = function deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.DependencyFailedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalServerExceptionResponse = function deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalServerException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ResourceNotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ThrottlingExceptionResponse = function deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ThrottlingException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ValidationExceptionResponse = function deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ValidationException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1StartConversationRequestEventStream = function serializeAws_restJson1StartConversationRequestEventStream(input, context) {
    var eventMarshallingVisitor = function eventMarshallingVisitor(event) {
        return (0, _models0.StartConversationRequestEventStream).visit(event, {
            ConfigurationEvent: function ConfigurationEvent(value) {
                return serializeAws_restJson1ConfigurationEvent_event(value, context);
            },
            AudioInputEvent: function AudioInputEvent(value) {
                return serializeAws_restJson1AudioInputEvent_event(value, context);
            },
            DTMFInputEvent: function DTMFInputEvent(value) {
                return serializeAws_restJson1DTMFInputEvent_event(value, context);
            },
            TextInputEvent: function TextInputEvent(value) {
                return serializeAws_restJson1TextInputEvent_event(value, context);
            },
            PlaybackCompletionEvent: function PlaybackCompletionEvent(value) {
                return serializeAws_restJson1PlaybackCompletionEvent_event(value, context);
            },
            DisconnectionEvent: function DisconnectionEvent(value) {
                return serializeAws_restJson1DisconnectionEvent_event(value, context);
            },
            _: function _(value) {
                return value;
            }
        });
    };
    return context.eventStreamMarshaller.serialize(input, eventMarshallingVisitor);
};
var serializeAws_restJson1AudioInputEvent_event = function serializeAws_restJson1AudioInputEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "AudioInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1AudioInputEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var serializeAws_restJson1ConfigurationEvent_event = function serializeAws_restJson1ConfigurationEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "ConfigurationEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1ConfigurationEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var serializeAws_restJson1DisconnectionEvent_event = function serializeAws_restJson1DisconnectionEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "DisconnectionEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1DisconnectionEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var serializeAws_restJson1DTMFInputEvent_event = function serializeAws_restJson1DTMFInputEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "DTMFInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1DTMFInputEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var serializeAws_restJson1PlaybackCompletionEvent_event = function serializeAws_restJson1PlaybackCompletionEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "PlaybackCompletionEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1PlaybackCompletionEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var serializeAws_restJson1TextInputEvent_event = function serializeAws_restJson1TextInputEvent_event(input, context) {
    var headers = {
        ":event-type": {
            type: "string",
            value: "TextInputEvent"
        },
        ":message-type": {
            type: "string",
            value: "event"
        },
        ":content-type": {
            type: "string",
            value: "application/json"
        }
    };
    var body = new Uint8Array();
    body = serializeAws_restJson1TextInputEvent(input, context);
    body = context.utf8Decoder(JSON.stringify(body));
    return {
        headers: headers,
        body: body
    };
};
var deserializeAws_restJson1StartConversationResponseEventStream = function deserializeAws_restJson1StartConversationResponseEventStream(output, context) {
    return context.eventStreamMarshaller.deserialize(output, function(event) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return (0, _tslib.__generator)(this, function(_q) {
                switch(_q.label){
                    case 0:
                        if (!(event["PlaybackInterruptionEvent"] != null)) return [
                            3,
                            2
                        ];
                        _a = {};
                        return [
                            4,
                            deserializeAws_restJson1PlaybackInterruptionEvent_event(event["PlaybackInterruptionEvent"], context)
                        ];
                    case 1:
                        return [
                            2,
                            (_a.PlaybackInterruptionEvent = _q.sent(), _a)
                        ];
                    case 2:
                        if (!(event["TranscriptEvent"] != null)) return [
                            3,
                            4
                        ];
                        _b = {};
                        return [
                            4,
                            deserializeAws_restJson1TranscriptEvent_event(event["TranscriptEvent"], context)
                        ];
                    case 3:
                        return [
                            2,
                            (_b.TranscriptEvent = _q.sent(), _b)
                        ];
                    case 4:
                        if (!(event["IntentResultEvent"] != null)) return [
                            3,
                            6
                        ];
                        _c = {};
                        return [
                            4,
                            deserializeAws_restJson1IntentResultEvent_event(event["IntentResultEvent"], context)
                        ];
                    case 5:
                        return [
                            2,
                            (_c.IntentResultEvent = _q.sent(), _c)
                        ];
                    case 6:
                        if (!(event["TextResponseEvent"] != null)) return [
                            3,
                            8
                        ];
                        _d = {};
                        return [
                            4,
                            deserializeAws_restJson1TextResponseEvent_event(event["TextResponseEvent"], context)
                        ];
                    case 7:
                        return [
                            2,
                            (_d.TextResponseEvent = _q.sent(), _d)
                        ];
                    case 8:
                        if (!(event["AudioResponseEvent"] != null)) return [
                            3,
                            10
                        ];
                        _e = {};
                        return [
                            4,
                            deserializeAws_restJson1AudioResponseEvent_event(event["AudioResponseEvent"], context)
                        ];
                    case 9:
                        return [
                            2,
                            (_e.AudioResponseEvent = _q.sent(), _e)
                        ];
                    case 10:
                        if (!(event["HeartbeatEvent"] != null)) return [
                            3,
                            12
                        ];
                        _f = {};
                        return [
                            4,
                            deserializeAws_restJson1HeartbeatEvent_event(event["HeartbeatEvent"], context)
                        ];
                    case 11:
                        return [
                            2,
                            (_f.HeartbeatEvent = _q.sent(), _f)
                        ];
                    case 12:
                        if (!(event["AccessDeniedException"] != null)) return [
                            3,
                            14
                        ];
                        _g = {};
                        return [
                            4,
                            deserializeAws_restJson1AccessDeniedException_event(event["AccessDeniedException"], context)
                        ];
                    case 13:
                        return [
                            2,
                            (_g.AccessDeniedException = _q.sent(), _g)
                        ];
                    case 14:
                        if (!(event["ResourceNotFoundException"] != null)) return [
                            3,
                            16
                        ];
                        _h = {};
                        return [
                            4,
                            deserializeAws_restJson1ResourceNotFoundException_event(event["ResourceNotFoundException"], context)
                        ];
                    case 15:
                        return [
                            2,
                            (_h.ResourceNotFoundException = _q.sent(), _h)
                        ];
                    case 16:
                        if (!(event["ValidationException"] != null)) return [
                            3,
                            18
                        ];
                        _j = {};
                        return [
                            4,
                            deserializeAws_restJson1ValidationException_event(event["ValidationException"], context)
                        ];
                    case 17:
                        return [
                            2,
                            (_j.ValidationException = _q.sent(), _j)
                        ];
                    case 18:
                        if (!(event["ThrottlingException"] != null)) return [
                            3,
                            20
                        ];
                        _k = {};
                        return [
                            4,
                            deserializeAws_restJson1ThrottlingException_event(event["ThrottlingException"], context)
                        ];
                    case 19:
                        return [
                            2,
                            (_k.ThrottlingException = _q.sent(), _k)
                        ];
                    case 20:
                        if (!(event["InternalServerException"] != null)) return [
                            3,
                            22
                        ];
                        _l = {};
                        return [
                            4,
                            deserializeAws_restJson1InternalServerException_event(event["InternalServerException"], context)
                        ];
                    case 21:
                        return [
                            2,
                            (_l.InternalServerException = _q.sent(), _l)
                        ];
                    case 22:
                        if (!(event["ConflictException"] != null)) return [
                            3,
                            24
                        ];
                        _m = {};
                        return [
                            4,
                            deserializeAws_restJson1ConflictException_event(event["ConflictException"], context)
                        ];
                    case 23:
                        return [
                            2,
                            (_m.ConflictException = _q.sent(), _m)
                        ];
                    case 24:
                        if (!(event["DependencyFailedException"] != null)) return [
                            3,
                            26
                        ];
                        _o = {};
                        return [
                            4,
                            deserializeAws_restJson1DependencyFailedException_event(event["DependencyFailedException"], context)
                        ];
                    case 25:
                        return [
                            2,
                            (_o.DependencyFailedException = _q.sent(), _o)
                        ];
                    case 26:
                        if (!(event["BadGatewayException"] != null)) return [
                            3,
                            28
                        ];
                        _p = {};
                        return [
                            4,
                            deserializeAws_restJson1BadGatewayException_event(event["BadGatewayException"], context)
                        ];
                    case 27:
                        return [
                            2,
                            (_p.BadGatewayException = _q.sent(), _p)
                        ];
                    case 28:
                        return [
                            2,
                            {
                                $unknown: output
                            }
                        ];
                }
            });
        });
    });
};
var deserializeAws_restJson1AccessDeniedException_event = function deserializeAws_restJson1AccessDeniedException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AudioResponseEvent_event = function deserializeAws_restJson1AudioResponseEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1AudioResponseEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BadGatewayException_event = function deserializeAws_restJson1BadGatewayException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ConflictException_event = function deserializeAws_restJson1ConflictException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DependencyFailedException_event = function deserializeAws_restJson1DependencyFailedException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1HeartbeatEvent_event = function deserializeAws_restJson1HeartbeatEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1HeartbeatEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1IntentResultEvent_event = function deserializeAws_restJson1IntentResultEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1IntentResultEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1InternalServerException_event = function deserializeAws_restJson1InternalServerException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PlaybackInterruptionEvent_event = function deserializeAws_restJson1PlaybackInterruptionEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1PlaybackInterruptionEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundException_event = function deserializeAws_restJson1ResourceNotFoundException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TextResponseEvent_event = function deserializeAws_restJson1TextResponseEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1TextResponseEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ThrottlingException_event = function deserializeAws_restJson1ThrottlingException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TranscriptEvent_event = function deserializeAws_restJson1TranscriptEvent_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    contents = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    Object.assign(contents, deserializeAws_restJson1TranscriptEvent(data, context));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ValidationException_event = function deserializeAws_restJson1ValidationException_event(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    return [
                        2,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
            }
        });
    });
};
var serializeAws_restJson1ActiveContext = function serializeAws_restJson1ActiveContext(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.contextAttributes != null && {
        contextAttributes: serializeAws_restJson1ActiveContextParametersMap(input.contextAttributes, context)
    }), input.name != null && {
        name: input.name
    }), input.timeToLive != null && {
        timeToLive: serializeAws_restJson1ActiveContextTimeToLive(input.timeToLive, context)
    });
};
var serializeAws_restJson1ActiveContextParametersMap = function serializeAws_restJson1ActiveContextParametersMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1ActiveContextsList = function serializeAws_restJson1ActiveContextsList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1ActiveContext(entry, context);
    });
};
var serializeAws_restJson1ActiveContextTimeToLive = function serializeAws_restJson1ActiveContextTimeToLive(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.timeToLiveInSeconds != null && {
        timeToLiveInSeconds: input.timeToLiveInSeconds
    }), input.turnsToLive != null && {
        turnsToLive: input.turnsToLive
    });
};
var serializeAws_restJson1AudioInputEvent = function serializeAws_restJson1AudioInputEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.audioChunk != null && {
        audioChunk: context.base64Encoder(input.audioChunk)
    }), input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.contentType != null && {
        contentType: input.contentType
    }), input.eventId != null && {
        eventId: input.eventId
    });
};
var serializeAws_restJson1Button = function serializeAws_restJson1Button(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.text != null && {
        text: input.text
    }), input.value != null && {
        value: input.value
    });
};
var serializeAws_restJson1ButtonsList = function serializeAws_restJson1ButtonsList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Button(entry, context);
    });
};
var serializeAws_restJson1ConfigurationEvent = function serializeAws_restJson1ConfigurationEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.disablePlayback != null && {
        disablePlayback: input.disablePlayback
    }), input.eventId != null && {
        eventId: input.eventId
    }), input.requestAttributes != null && {
        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
    }), input.responseContentType != null && {
        responseContentType: input.responseContentType
    }), input.sessionState != null && {
        sessionState: serializeAws_restJson1SessionState(input.sessionState, context)
    }), input.welcomeMessages != null && {
        welcomeMessages: serializeAws_restJson1Messages(input.welcomeMessages, context)
    });
};
var serializeAws_restJson1DialogAction = function serializeAws_restJson1DialogAction(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.slotElicitationStyle != null && {
        slotElicitationStyle: input.slotElicitationStyle
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.subSlotToElicit != null && {
        subSlotToElicit: serializeAws_restJson1ElicitSubSlot(input.subSlotToElicit, context)
    }), input.type != null && {
        type: input.type
    });
};
var serializeAws_restJson1DisconnectionEvent = function serializeAws_restJson1DisconnectionEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.eventId != null && {
        eventId: input.eventId
    });
};
var serializeAws_restJson1DTMFInputEvent = function serializeAws_restJson1DTMFInputEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.eventId != null && {
        eventId: input.eventId
    }), input.inputCharacter != null && {
        inputCharacter: input.inputCharacter
    });
};
var serializeAws_restJson1ElicitSubSlot = function serializeAws_restJson1ElicitSubSlot1(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.name != null && {
        name: input.name
    }), input.subSlotToElicit != null && {
        subSlotToElicit: serializeAws_restJson1ElicitSubSlot(input.subSlotToElicit, context)
    });
};
var serializeAws_restJson1ImageResponseCard = function serializeAws_restJson1ImageResponseCard(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.buttons != null && {
        buttons: serializeAws_restJson1ButtonsList(input.buttons, context)
    }), input.imageUrl != null && {
        imageUrl: input.imageUrl
    }), input.subtitle != null && {
        subtitle: input.subtitle
    }), input.title != null && {
        title: input.title
    });
};
var serializeAws_restJson1Intent = function serializeAws_restJson1Intent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.confirmationState != null && {
        confirmationState: input.confirmationState
    }), input.name != null && {
        name: input.name
    }), input.slots != null && {
        slots: serializeAws_restJson1Slots(input.slots, context)
    }), input.state != null && {
        state: input.state
    });
};
var serializeAws_restJson1Message = function serializeAws_restJson1Message(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.content != null && {
        content: input.content
    }), input.contentType != null && {
        contentType: input.contentType
    }), input.imageResponseCard != null && {
        imageResponseCard: serializeAws_restJson1ImageResponseCard(input.imageResponseCard, context)
    });
};
var serializeAws_restJson1Messages = function serializeAws_restJson1Messages(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Message(entry, context);
    });
};
var serializeAws_restJson1PlaybackCompletionEvent = function serializeAws_restJson1PlaybackCompletionEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.eventId != null && {
        eventId: input.eventId
    });
};
var serializeAws_restJson1RuntimeHintDetails = function serializeAws_restJson1RuntimeHintDetails(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.runtimeHintValues != null && {
        runtimeHintValues: serializeAws_restJson1RuntimeHintValuesList(input.runtimeHintValues, context)
    }), input.subSlotHints != null && {
        subSlotHints: serializeAws_restJson1SlotHintsSlotMap(input.subSlotHints, context)
    });
};
var serializeAws_restJson1RuntimeHints = function serializeAws_restJson1RuntimeHints(input, context) {
    return (0, _tslib.__assign)({}, input.slotHints != null && {
        slotHints: serializeAws_restJson1SlotHintsIntentMap(input.slotHints, context)
    });
};
var serializeAws_restJson1RuntimeHintValue = function serializeAws_restJson1RuntimeHintValue(input, context) {
    return (0, _tslib.__assign)({}, input.phrase != null && {
        phrase: input.phrase
    });
};
var serializeAws_restJson1RuntimeHintValuesList = function serializeAws_restJson1RuntimeHintValuesList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1RuntimeHintValue(entry, context);
    });
};
var serializeAws_restJson1SessionState = function serializeAws_restJson1SessionState(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
    }), input.dialogAction != null && {
        dialogAction: serializeAws_restJson1DialogAction(input.dialogAction, context)
    }), input.intent != null && {
        intent: serializeAws_restJson1Intent(input.intent, context)
    }), input.originatingRequestId != null && {
        originatingRequestId: input.originatingRequestId
    }), input.runtimeHints != null && {
        runtimeHints: serializeAws_restJson1RuntimeHints(input.runtimeHints, context)
    }), input.sessionAttributes != null && {
        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
    });
};
var serializeAws_restJson1Slot = function serializeAws_restJson1Slot(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.shape != null && {
        shape: input.shape
    }), input.subSlots != null && {
        subSlots: serializeAws_restJson1Slots(input.subSlots, context)
    }), input.value != null && {
        value: serializeAws_restJson1Value(input.value, context)
    }), input.values != null && {
        values: serializeAws_restJson1Values(input.values, context)
    });
};
var serializeAws_restJson1SlotHintsIntentMap = function serializeAws_restJson1SlotHintsIntentMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = serializeAws_restJson1SlotHintsSlotMap(value, context), _b));
    }, {});
};
var serializeAws_restJson1SlotHintsSlotMap = function serializeAws_restJson1SlotHintsSlotMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = serializeAws_restJson1RuntimeHintDetails(value, context), _b));
    }, {});
};
var serializeAws_restJson1Slots = function serializeAws_restJson1Slots(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = serializeAws_restJson1Slot(value, context), _b));
    }, {});
};
var serializeAws_restJson1StringList = function serializeAws_restJson1StringList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1StringMap = function serializeAws_restJson1StringMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TextInputEvent = function serializeAws_restJson1TextInputEvent(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.clientTimestampMillis != null && {
        clientTimestampMillis: input.clientTimestampMillis
    }), input.eventId != null && {
        eventId: input.eventId
    }), input.text != null && {
        text: input.text
    });
};
var serializeAws_restJson1Value = function serializeAws_restJson1Value(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.interpretedValue != null && {
        interpretedValue: input.interpretedValue
    }), input.originalValue != null && {
        originalValue: input.originalValue
    }), input.resolvedValues != null && {
        resolvedValues: serializeAws_restJson1StringList(input.resolvedValues, context)
    });
};
var serializeAws_restJson1Values = function serializeAws_restJson1Values(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Slot(entry, context);
    });
};
var deserializeAws_restJson1ActiveContext = function deserializeAws_restJson1ActiveContext(output, context) {
    return {
        contextAttributes: output.contextAttributes != null ? deserializeAws_restJson1ActiveContextParametersMap(output.contextAttributes, context) : undefined,
        name: (0, _smithyClient.expectString)(output.name),
        timeToLive: output.timeToLive != null ? deserializeAws_restJson1ActiveContextTimeToLive(output.timeToLive, context) : undefined
    };
};
var deserializeAws_restJson1ActiveContextParametersMap = function deserializeAws_restJson1ActiveContextParametersMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1ActiveContextsList = function deserializeAws_restJson1ActiveContextsList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ActiveContext(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ActiveContextTimeToLive = function deserializeAws_restJson1ActiveContextTimeToLive(output, context) {
    return {
        timeToLiveInSeconds: (0, _smithyClient.expectInt32)(output.timeToLiveInSeconds),
        turnsToLive: (0, _smithyClient.expectInt32)(output.turnsToLive)
    };
};
var deserializeAws_restJson1AudioResponseEvent = function deserializeAws_restJson1AudioResponseEvent(output, context) {
    return {
        audioChunk: output.audioChunk != null ? context.base64Decoder(output.audioChunk) : undefined,
        contentType: (0, _smithyClient.expectString)(output.contentType),
        eventId: (0, _smithyClient.expectString)(output.eventId)
    };
};
var deserializeAws_restJson1Button = function deserializeAws_restJson1Button(output, context) {
    return {
        text: (0, _smithyClient.expectString)(output.text),
        value: (0, _smithyClient.expectString)(output.value)
    };
};
var deserializeAws_restJson1ButtonsList = function deserializeAws_restJson1ButtonsList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Button(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ConfidenceScore = function deserializeAws_restJson1ConfidenceScore(output, context) {
    return {
        score: (0, _smithyClient.limitedParseDouble)(output.score)
    };
};
var deserializeAws_restJson1DialogAction = function deserializeAws_restJson1DialogAction(output, context) {
    return {
        slotElicitationStyle: (0, _smithyClient.expectString)(output.slotElicitationStyle),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        subSlotToElicit: output.subSlotToElicit != null ? deserializeAws_restJson1ElicitSubSlot(output.subSlotToElicit, context) : undefined,
        type: (0, _smithyClient.expectString)(output.type)
    };
};
var deserializeAws_restJson1ElicitSubSlot = function deserializeAws_restJson1ElicitSubSlot1(output, context) {
    return {
        name: (0, _smithyClient.expectString)(output.name),
        subSlotToElicit: output.subSlotToElicit != null ? deserializeAws_restJson1ElicitSubSlot(output.subSlotToElicit, context) : undefined
    };
};
var deserializeAws_restJson1HeartbeatEvent = function deserializeAws_restJson1HeartbeatEvent(output, context) {
    return {
        eventId: (0, _smithyClient.expectString)(output.eventId)
    };
};
var deserializeAws_restJson1ImageResponseCard = function deserializeAws_restJson1ImageResponseCard(output, context) {
    return {
        buttons: output.buttons != null ? deserializeAws_restJson1ButtonsList(output.buttons, context) : undefined,
        imageUrl: (0, _smithyClient.expectString)(output.imageUrl),
        subtitle: (0, _smithyClient.expectString)(output.subtitle),
        title: (0, _smithyClient.expectString)(output.title)
    };
};
var deserializeAws_restJson1Intent = function deserializeAws_restJson1Intent(output, context) {
    return {
        confirmationState: (0, _smithyClient.expectString)(output.confirmationState),
        name: (0, _smithyClient.expectString)(output.name),
        slots: output.slots != null ? deserializeAws_restJson1Slots(output.slots, context) : undefined,
        state: (0, _smithyClient.expectString)(output.state)
    };
};
var deserializeAws_restJson1IntentResultEvent = function deserializeAws_restJson1IntentResultEvent(output, context) {
    return {
        eventId: (0, _smithyClient.expectString)(output.eventId),
        inputMode: (0, _smithyClient.expectString)(output.inputMode),
        interpretations: output.interpretations != null ? deserializeAws_restJson1Interpretations(output.interpretations, context) : undefined,
        requestAttributes: output.requestAttributes != null ? deserializeAws_restJson1StringMap(output.requestAttributes, context) : undefined,
        sessionId: (0, _smithyClient.expectString)(output.sessionId),
        sessionState: output.sessionState != null ? deserializeAws_restJson1SessionState(output.sessionState, context) : undefined
    };
};
var deserializeAws_restJson1Interpretation = function deserializeAws_restJson1Interpretation(output, context) {
    return {
        intent: output.intent != null ? deserializeAws_restJson1Intent(output.intent, context) : undefined,
        nluConfidence: output.nluConfidence != null ? deserializeAws_restJson1ConfidenceScore(output.nluConfidence, context) : undefined,
        sentimentResponse: output.sentimentResponse != null ? deserializeAws_restJson1SentimentResponse(output.sentimentResponse, context) : undefined
    };
};
var deserializeAws_restJson1Interpretations = function deserializeAws_restJson1Interpretations(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Interpretation(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1Message = function deserializeAws_restJson1Message(output, context) {
    return {
        content: (0, _smithyClient.expectString)(output.content),
        contentType: (0, _smithyClient.expectString)(output.contentType),
        imageResponseCard: output.imageResponseCard != null ? deserializeAws_restJson1ImageResponseCard(output.imageResponseCard, context) : undefined
    };
};
var deserializeAws_restJson1Messages = function deserializeAws_restJson1Messages(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Message(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PlaybackInterruptionEvent = function deserializeAws_restJson1PlaybackInterruptionEvent(output, context) {
    return {
        causedByEventId: (0, _smithyClient.expectString)(output.causedByEventId),
        eventId: (0, _smithyClient.expectString)(output.eventId),
        eventReason: (0, _smithyClient.expectString)(output.eventReason)
    };
};
var deserializeAws_restJson1RuntimeHintDetails = function deserializeAws_restJson1RuntimeHintDetails(output, context) {
    return {
        runtimeHintValues: output.runtimeHintValues != null ? deserializeAws_restJson1RuntimeHintValuesList(output.runtimeHintValues, context) : undefined,
        subSlotHints: output.subSlotHints != null ? deserializeAws_restJson1SlotHintsSlotMap(output.subSlotHints, context) : undefined
    };
};
var deserializeAws_restJson1RuntimeHints = function deserializeAws_restJson1RuntimeHints(output, context) {
    return {
        slotHints: output.slotHints != null ? deserializeAws_restJson1SlotHintsIntentMap(output.slotHints, context) : undefined
    };
};
var deserializeAws_restJson1RuntimeHintValue = function deserializeAws_restJson1RuntimeHintValue(output, context) {
    return {
        phrase: (0, _smithyClient.expectString)(output.phrase)
    };
};
var deserializeAws_restJson1RuntimeHintValuesList = function deserializeAws_restJson1RuntimeHintValuesList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RuntimeHintValue(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SentimentResponse = function deserializeAws_restJson1SentimentResponse(output, context) {
    return {
        sentiment: (0, _smithyClient.expectString)(output.sentiment),
        sentimentScore: output.sentimentScore != null ? deserializeAws_restJson1SentimentScore(output.sentimentScore, context) : undefined
    };
};
var deserializeAws_restJson1SentimentScore = function deserializeAws_restJson1SentimentScore(output, context) {
    return {
        mixed: (0, _smithyClient.limitedParseDouble)(output.mixed),
        negative: (0, _smithyClient.limitedParseDouble)(output.negative),
        neutral: (0, _smithyClient.limitedParseDouble)(output.neutral),
        positive: (0, _smithyClient.limitedParseDouble)(output.positive)
    };
};
var deserializeAws_restJson1SessionState = function deserializeAws_restJson1SessionState(output, context) {
    return {
        activeContexts: output.activeContexts != null ? deserializeAws_restJson1ActiveContextsList(output.activeContexts, context) : undefined,
        dialogAction: output.dialogAction != null ? deserializeAws_restJson1DialogAction(output.dialogAction, context) : undefined,
        intent: output.intent != null ? deserializeAws_restJson1Intent(output.intent, context) : undefined,
        originatingRequestId: (0, _smithyClient.expectString)(output.originatingRequestId),
        runtimeHints: output.runtimeHints != null ? deserializeAws_restJson1RuntimeHints(output.runtimeHints, context) : undefined,
        sessionAttributes: output.sessionAttributes != null ? deserializeAws_restJson1StringMap(output.sessionAttributes, context) : undefined
    };
};
var deserializeAws_restJson1Slot = function deserializeAws_restJson1Slot(output, context) {
    return {
        shape: (0, _smithyClient.expectString)(output.shape),
        subSlots: output.subSlots != null ? deserializeAws_restJson1Slots(output.subSlots, context) : undefined,
        value: output.value != null ? deserializeAws_restJson1Value(output.value, context) : undefined,
        values: output.values != null ? deserializeAws_restJson1Values(output.values, context) : undefined
    };
};
var deserializeAws_restJson1SlotHintsIntentMap = function deserializeAws_restJson1SlotHintsIntentMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1SlotHintsSlotMap(value, context), _b));
    }, {});
};
var deserializeAws_restJson1SlotHintsSlotMap = function deserializeAws_restJson1SlotHintsSlotMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1RuntimeHintDetails(value, context), _b));
    }, {});
};
var deserializeAws_restJson1Slots = function deserializeAws_restJson1Slots(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1Slot(value, context), _b));
    }, {});
};
var deserializeAws_restJson1StringList = function deserializeAws_restJson1StringList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1StringMap = function deserializeAws_restJson1StringMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1TextResponseEvent = function deserializeAws_restJson1TextResponseEvent(output, context) {
    return {
        eventId: (0, _smithyClient.expectString)(output.eventId),
        messages: output.messages != null ? deserializeAws_restJson1Messages(output.messages, context) : undefined
    };
};
var deserializeAws_restJson1TranscriptEvent = function deserializeAws_restJson1TranscriptEvent(output, context) {
    return {
        eventId: (0, _smithyClient.expectString)(output.eventId),
        transcript: (0, _smithyClient.expectString)(output.transcript)
    };
};
var deserializeAws_restJson1Value = function deserializeAws_restJson1Value(output, context) {
    return {
        interpretedValue: (0, _smithyClient.expectString)(output.interpretedValue),
        originalValue: (0, _smithyClient.expectString)(output.originalValue),
        resolvedValues: output.resolvedValues != null ? deserializeAws_restJson1StringList(output.resolvedValues, context) : undefined
    };
};
var deserializeAws_restJson1Values = function deserializeAws_restJson1Values(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Slot(entry, context);
    });
    return retVal;
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function parseErrorBody(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"iCVKV","@aws-sdk/smithy-client":"kHS8Y","../models/LexRuntimeV2ServiceException":"02AMA","../models/models_0":"kyRls","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"czLMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecognizeUtteranceCommand", function() {
    return RecognizeUtteranceCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var RecognizeUtteranceCommand = function(_super) {
    (0, _tslib.__extends)(RecognizeUtteranceCommand, _super);
    function RecognizeUtteranceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    RecognizeUtteranceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeV2Client";
        var commandName = "RecognizeUtteranceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.RecognizeUtteranceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.RecognizeUtteranceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RecognizeUtteranceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1RecognizeUtteranceCommand)(input, context);
    };
    RecognizeUtteranceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1RecognizeUtteranceCommand)(output, context);
    };
    return RecognizeUtteranceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"2c1Zy","@aws-sdk/smithy-client":"kHS8Y","../models/models_0":"kyRls","../protocols/Aws_restJson1":"8M4zb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k3RFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unGzipBase64AsJson", function() {
    return unGzipBase64AsJson;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _utils = require("./utils");
var unGzipBase64AsJson = function unGzipBase64AsJson(gzipBase64) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var decodedArrayBuffer, objString, error_1;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof gzipBase64 === 'undefined') return [
                        2 /*return*/ ,
                        undefined
                    ];
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    decodedArrayBuffer = (0, _utils.base64ToArrayBuffer)(gzipBase64);
                    return [
                        4 /*yield*/ ,
                        (0, _utils.gzipDecompressToString)(decodedArrayBuffer)
                    ];
                case 2:
                    objString = _a.sent();
                    return [
                        2 /*return*/ ,
                        JSON.parse(objString)
                    ];
                case 3:
                    error_1 = _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.reject('unable to decode and decompress ' + error_1)
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};

},{"tslib":"2gCWu","./utils":"ep5zt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"29fbL":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", function() {
    return 0, _notificationsDefault.default;
});
parcelHelpers.export(exports, "AWSPinpointProviderCommon", function() {
    return 0, _common.AWSPinpointProviderCommon;
});
parcelHelpers.export(exports, "InAppMessageInteractionEvent", function() {
    return 0, _inAppMessaging.InAppMessageInteractionEvent;
});
parcelHelpers.export(exports, "PushNotificationPermissionStatus", function() {
    return 0, _types.PushNotificationPermissionStatus;
});
var _notifications = require("./Notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _common = require("./common");
var _inAppMessaging = require("./InAppMessaging");
var _types = require("./PushNotification/types");

},{"./Notifications":"8snMy","./common":false,"./InAppMessaging":false,"./PushNotification/types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8snMy":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var logger = new (0, _core.ConsoleLogger)('Notifications');
var NotificationsClass = /** @class */ function() {
    function NotificationsClass() {
        var _this = this;
        this.config = {};
        /**
         * Configure Notifications
         * @param {Object} config - Notifications configuration object
         */ this.configure = function(_a) {
            var config = (_a === void 0 ? {} : _a).Notifications;
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug('configure Notifications', config);
            // Configure sub-categories
            _this.inAppMessaging.configure(_this.config.InAppMessaging);
            if (_this.config.Push) try {
                // only instantiate once
                if (!_this.pushNotification) _this.pushNotification = new (0, _pushNotificationDefault.default)();
                _this.pushNotification.configure(_this.config.Push);
            } catch (err) {
                logger.error(err);
            }
            return _this.config;
        };
        this.identifyUser = function(userId, userInfo) {
            var identifyFunctions = [];
            if (_this.inAppMessaging) identifyFunctions.push(_this.inAppMessaging.identifyUser);
            if (_this.pushNotification) identifyFunctions.push(_this.pushNotification.identifyUser);
            return Promise.all(identifyFunctions.map(function(identifyFunction) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    identifyFunction(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                logger.error('Failed to identify user', err_1);
                                throw err_1;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.inAppMessaging = new (0, _inAppMessagingDefault.default)();
    }
    /**
     * Get the name of the module category
     * @returns {string} name of the module category
     */ NotificationsClass.prototype.getModuleName = function() {
        return 'Notifications';
    };
    Object.defineProperty(NotificationsClass.prototype, "InAppMessaging", {
        get: function get() {
            return this.inAppMessaging;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClass.prototype, "Push", {
        get: function get() {
            var _a;
            return (_a = this.pushNotification) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: true,
        configurable: true
    });
    return NotificationsClass;
}();
var Notifications = new NotificationsClass();
exports.default = Notifications;
(0, _core.Amplify).register(Notifications);

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","./InAppMessaging":"ahkvG","./PushNotification":"9aljh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ahkvG":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _inAppMessagingDefault.default;
});
parcelHelpers.export(exports, "InAppMessageInteractionEvent", function() {
    return 0, _types.InAppMessageInteractionEvent;
});
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _types = require("./types");

},{"./InAppMessaging":"j8jN5","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8jN5":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _common = require("../common");
var _providers = require("./Providers");
var _types = require("./types");
var STORAGE_KEY_SUFFIX = '_inAppMessages';
var logger = new (0, _core.ConsoleLogger)('Notifications.InAppMessaging');
var InAppMessaging = /** @class */ function() {
    function InAppMessaging() {
        var _this = this;
        this.config = {};
        this.listeningForAnalyticEvents = false;
        this.pluggables = [];
        this.storageSynced = false;
        /**
         * Configure InAppMessaging
         * @param {Object} config - InAppMessaging configuration object
         */ this.configure = function(_a) {
            if (_a === void 0) _a = {};
            var _b = _a.listenForAnalyticsEvents, listenForAnalyticsEvents = _b === void 0 ? true : _b, config = (0, _tslib.__rest)(_a, [
                "listenForAnalyticsEvents"
            ]);
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug('configure InAppMessaging', _this.config);
            _this.pluggables.forEach(function(pluggable) {
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            });
            if (_this.pluggables.length === 0) _this.addPluggable(new (0, _providers.AWSPinpointProvider)());
            if (listenForAnalyticsEvents && !_this.listeningForAnalyticEvents) {
                (0, _core.Hub).listen('analytics', _this.analyticsListener);
                _this.listeningForAnalyticEvents = true;
            }
            return _this.config;
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(providerName) {
            var _a;
            var pluggable = (_a = _this.pluggables.find(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            })) !== null && _a !== void 0 ? _a : null;
            if (!pluggable) logger.debug("No plugin found with name " + providerName);
            return pluggable;
        };
        /**
         * Add plugin into InAppMessaging
         * @param {InAppMessagingProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(pluggable) {
            if (pluggable && pluggable.getCategory() === 'Notifications' && pluggable.getSubCategory() === 'InAppMessaging') {
                if (_this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable " + pluggable.getProviderName() + " has already been added.");
                _this.pluggables.push(pluggable);
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            }
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function(providerName) {
            var index = _this.pluggables.findIndex(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            });
            if (index === -1) logger.debug("No plugin found with name " + providerName);
            else _this.pluggables.splice(index, 1);
        };
        /**
         * Get the map resources that are currently available through the provider
         * @param {string} provider
         * @returns - Array of available map resources
         */ this.syncMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var messages, key, err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.getInAppMessages()
                                ];
                            case 1:
                                messages = _a.sent();
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.setMessages(key, messages)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                logger.error('Failed to sync messages', err_1);
                                throw err_1;
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.clearMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var key;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.removeMessages(key)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.dispatchEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var messages, flattenedMessages;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                Promise.all(this.pluggables.map(function(pluggable) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var key, messages;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.getMessages(key)
                                                    ];
                                                case 1:
                                                    messages = _a.sent();
                                                    return [
                                                        2 /*return*/ ,
                                                        pluggable.processInAppMessages(messages, event)
                                                    ];
                                            }
                                        });
                                    });
                                }))
                            ];
                        case 1:
                            messages = _a.sent();
                            flattenedMessages = (0, _flattenDefault.default)(messages);
                            if (flattenedMessages.length) (0, _common.notifyEventListeners)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, this.conflictHandler(flattenedMessages));
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.identifyUser = function(userId, userInfo) {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.identifyUser(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_2 = _a.sent();
                                logger.error('Failed to identify user', err_2);
                                throw err_2;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.onMessageReceived = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, handler);
        };
        this.onMessageDisplayed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, handler);
        };
        this.onMessageDismissed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, handler);
        };
        this.onMessageActionTaken = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, handler);
        };
        this.notifyMessageInteraction = function(message, type) {
            (0, _common.notifyEventListeners)(type, message);
        };
        this.setConflictHandler = function(handler) {
            _this.conflictHandler = handler;
        };
        this.analyticsListener = function(_a) {
            var payload = _a.payload;
            var event = payload.event, data = payload.data;
            switch(event){
                case 'record':
                    _this.dispatchEvent(data);
                    break;
                default:
                    break;
            }
        };
        this.syncStorage = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            storage = this.config.storage;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!(typeof storage.sync === 'function')) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.storageSynced = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.error('Failed to sync storage', err_3);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, storedMessages, err_4;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storedMessages = storage.getItem(key);
                            return [
                                2 /*return*/ ,
                                storedMessages ? JSON.parse(storedMessages) : []
                            ];
                        case 3:
                            err_4 = _a.sent();
                            logger.error('Failed to retrieve in-app messages from storage', err_4);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.setMessages = function(key, messages) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!messages) return [
                                2 /*return*/ 
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            storage = this.config.storage;
                            storage.setItem(key, JSON.stringify(messages));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_5 = _a.sent();
                            logger.error('Failed to store in-app messages', err_5);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.removeMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_6;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storage.removeItem(key);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_6 = _a.sent();
                            logger.error('Failed to remove in-app messages from storage', err_6);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.defaultConflictHandler = function(messages) {
            // default behavior is to return the message closest to expiry
            // this function assumes that messages processed by providers already filters out expired messages
            var sorted = messages.sort(function(a, b) {
                var _a, _b;
                var endDateA = (_a = a.metadata) === null || _a === void 0 ? void 0 : _a.endDate;
                var endDateB = (_b = b.metadata) === null || _b === void 0 ? void 0 : _b.endDate;
                // if both message end dates are falsy or have the same date string, treat them as equal
                if (endDateA === endDateB) return 0;
                // if only message A has an end date, treat it as closer to expiry
                if (endDateA && !endDateB) return -1;
                // if only message B has an end date, treat it as closer to expiry
                if (!endDateA && endDateB) return 1;
                // otherwise, compare them
                return new Date(endDateA) < new Date(endDateB) ? -1 : 1;
            });
            // always return the top sorted
            return sorted[0];
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.setConflictHandler(this.defaultConflictHandler);
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ InAppMessaging.prototype.getModuleName = function() {
        return 'InAppMessaging';
    };
    return InAppMessaging;
}();
exports.default = InAppMessaging;

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","lodash/flatten":"b7fAH","../common":"fGILj","./Providers":"au5Fu","./types":"bbtoH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b7fAH":[function(require,module,exports,__globalThis) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"8iQ0s"}],"8iQ0s":[function(require,module,exports,__globalThis) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"iS8Vi","ec5f080ebf5764e8":"SMYwm"}],"SMYwm":[function(require,module,exports,__globalThis) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"aflde","ee6f325d7f5309b1":"jmDAu","ff8d93236e335297":"jQGs4"}],"fGILj":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProviderCommon", function() {
    return 0, _awspinpointProviderCommonDefault.default;
});
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", function() {
    return 0, _constants.AMPLIFY_SYMBOL;
});
parcelHelpers.export(exports, "addEventListener", function() {
    return 0, _eventListeners.addEventListener;
});
parcelHelpers.export(exports, "notifyEventListeners", function() {
    return 0, _eventListeners.notifyEventListeners;
});
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", function() {
    return 0, _eventListeners.notifyEventListenersAndAwaitHandlers;
});
var _awspinpointProviderCommon = require("./AWSPinpointProviderCommon");
var _awspinpointProviderCommonDefault = parcelHelpers.interopDefault(_awspinpointProviderCommon);
var _constants = require("./constants");
var _eventListeners = require("./eventListeners");

},{"./AWSPinpointProviderCommon":"7T8Yf","./constants":"8Gtaq","./eventListeners":"bXDAU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7T8Yf":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var AWSPinpointProviderCommon = /** @class */ function() {
    function AWSPinpointProviderCommon(logger) {
        var _this = this;
        var _a;
        this.config = {};
        this.endpointInitialized = false;
        this.initialized = false;
        this.identifyUser = function(userId, userInfo) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint(userId, userInfo)
                            ];
                        case 3:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_1 = _a.sent();
                            this.logger.error('Error identifying user', err_1);
                            throw err_1;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.init = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, endpointId, storage, providerName, _b, err_2;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            _a = this.config, endpointId = _a.endpointId, storage = _a.storage;
                            providerName = this.getProviderName();
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                6,
                                ,
                                7
                            ]);
                            if (!(typeof storage.sync === 'function')) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            if (!!endpointId) return [
                                3 /*break*/ ,
                                5
                            ];
                            _b = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getEndpointId()
                            ];
                        case 4:
                            _b.endpointId = _c.sent();
                            _c.label = 5;
                        case 5:
                            this.initialized = true;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            err_2 = _c.sent();
                            this.logger.error("Failed to initialize " + providerName, err_2);
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getUserAgentValue = function() {
            var customUserAgentDetails;
            if (_this.getSubCategory() === 'PushNotification') customUserAgentDetails = {
                category: (0, _core.Category).PushNotification,
                action: (0, _core.PushNotificationAction).None
            };
            else customUserAgentDetails = {
                category: (0, _core.Category).InAppMessaging,
                action: (0, _core.InAppMessagingAction).None
            };
            return (0, _core.getAmplifyUserAgent)(customUserAgentDetails);
        };
        this.recordAnalyticsEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, _b, appId, credentials, endpointId, region, input, err_3;
                var _c, _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            // Update credentials
                            _a = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            // Update credentials
                            _a.credentials = _e.sent();
                            // Assert required configuration properties to make `putEvents` request are present
                            this.assertNotEmptyConfiguration();
                            _b = this.config, appId = _b.appId, credentials = _b.credentials, endpointId = _b.endpointId, region = _b.region;
                            _e.label = 2;
                        case 2:
                            _e.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            input = {
                                ApplicationId: appId,
                                EventsRequest: {
                                    BatchItem: (_c = {}, _c[endpointId] = {
                                        Endpoint: {},
                                        Events: (_d = {}, _d[(0, _uuid.v4)()] = event, _d)
                                    }, _c)
                                }
                            };
                            this.logger.debug('recording analytics event');
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.putEvents)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _e.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _e.sent();
                            this.logger.error('Error recording analytics event', err_3);
                            throw err_3;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.updateEndpoint = function(userId, userInfo) {
            if (userId === void 0) userId = null;
            if (userInfo === void 0) userInfo = null;
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, credentialsUpdated, _a, appId, endpointId, _b, endpointInfo, region, _c, address, attributes, demographic, location_1, metrics, optOut, _d, appVersion, make, model, platform, version, input, err_4;
                var _this = this;
                var _e;
                return (0, _tslib.__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            credentials = _f.sent();
                            credentialsUpdated = !this.config.credentials || Object.keys(credentials).some(function(key) {
                                return credentials[key] !== _this.config.credentials[key];
                            });
                            // If endpoint is already initialized, and nothing else is changing, just early return
                            if (this.endpointInitialized && !credentialsUpdated && !userId && !userInfo) return [
                                2 /*return*/ 
                            ];
                            // Update credentials
                            this.config.credentials = credentials;
                            // Assert required configuration properties to make `updateEndpoint` request are present
                            this.assertNotEmptyConfiguration();
                            _a = this.config, appId = _a.appId, endpointId = _a.endpointId, _b = _a.endpointInfo, endpointInfo = _b === void 0 ? {} : _b, region = _a.region;
                            _f.label = 2;
                        case 2:
                            _f.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            _c = userInfo !== null && userInfo !== void 0 ? userInfo : {}, address = _c.address, attributes = _c.attributes, demographic = _c.demographic, location_1 = _c.location, metrics = _c.metrics, optOut = _c.optOut;
                            _d = this.clientInfo, appVersion = _d.appVersion, make = _d.make, model = _d.model, platform = _d.platform, version = _d.version;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId,
                                EndpointRequest: {
                                    RequestId: (0, _uuid.v4)(),
                                    EffectiveDate: new Date().toISOString(),
                                    ChannelType: endpointInfo.channelType,
                                    Address: address !== null && address !== void 0 ? address : endpointInfo.address,
                                    Attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.attributes), attributes),
                                    Demographic: (0, _tslib.__assign)({
                                        AppVersion: appVersion,
                                        Make: make,
                                        Model: model,
                                        ModelVersion: version,
                                        Platform: platform
                                    }, (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.demographic), demographic))),
                                    Location: (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.location), location_1)),
                                    Metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.metrics), metrics),
                                    OptOut: optOut !== null && optOut !== void 0 ? optOut : endpointInfo.optOut,
                                    User: {
                                        UserId: (_e = userId !== null && userId !== void 0 ? userId : endpointInfo.userId) !== null && _e !== void 0 ? _e : credentials.identityId,
                                        UserAttributes: attributes !== null && attributes !== void 0 ? attributes : endpointInfo.userAttributes
                                    }
                                }
                            };
                            this.logger.debug('updating endpoint');
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.updateEndpoint)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _f.sent();
                            this.endpointInitialized = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_4 = _f.sent();
                            throw err_4;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getEndpointId = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var appId, cacheKey, cachedEndpointId, endpointId, ttl, expiration;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            appId = this.config.appId;
                            cacheKey = this.getSubCategory() === 'PushNotification' ? this.getProviderName() + "_" + appId : this.getSubCategory() + ":" + this.getProviderName() + ":" + appId;
                            return [
                                4 /*yield*/ ,
                                (0, _cache.Cache).getItem(cacheKey)
                            ];
                        case 1:
                            cachedEndpointId = _a.sent();
                            // Found in cache, just return it
                            if (cachedEndpointId) return [
                                2 /*return*/ ,
                                cachedEndpointId
                            ];
                            endpointId = (0, _uuid.v4)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                            return [
                                2 /*return*/ ,
                                endpointId
                            ];
                    }
                });
            });
        };
        this.getCredentials = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                (0, _core.Credentials).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            if (!credentials) {
                                this.logger.debug('no credentials found');
                                return [
                                    2 /*return*/ ,
                                    null
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                (0, _core.Credentials).shear(credentials)
                            ];
                        case 2:
                            err_5 = _a.sent();
                            this.logger.error('Error getting credentials:', err_5);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.assertNotEmptyConfiguration = function() {
            var _a = _this.config, appId = _a.appId, credentials = _a.credentials, region = _a.region;
            if (!appId || !credentials || !region) throw new Error('One or more of credentials, appId or region is not configured');
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.clientInfo = (_a = (0, _core.ClientDevice).clientInfo()) !== null && _a !== void 0 ? _a : {};
        this.logger = logger;
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProviderCommon.prototype.getCategory = function() {
        return AWSPinpointProviderCommon.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProviderCommon.prototype.getProviderName = function() {
        return AWSPinpointProviderCommon.providerName;
    };
    AWSPinpointProviderCommon.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.config), config);
        this.logger.debug("configure " + this.getProviderName() + this.getSubCategory() + "Provider", this.config);
        return this.config;
    };
    AWSPinpointProviderCommon.category = 'Notifications';
    AWSPinpointProviderCommon.providerName = 'AWSPinpoint';
    return AWSPinpointProviderCommon;
}();
exports.default = AWSPinpointProviderCommon;

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","uuid":"bvm5J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Gtaq":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", function() {
    return AMPLIFY_SYMBOL;
});
var AMPLIFY_SYMBOL = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function' ? Symbol.for('amplify_default') : '@@amplify_default';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bXDAU":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventListeners", function() {
    return notifyEventListeners;
});
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", function() {
    return notifyEventListenersAndAwaitHandlers;
});
parcelHelpers.export(exports, "addEventListener", function() {
    return addEventListener;
});
var _tslib = require("tslib");
var eventListeners = {};
var notifyEventListeners = function notifyEventListeners(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    (_a = eventListeners[type]) === null || _a === void 0 || _a.forEach(function(listener) {
        listener.handleEvent.apply(listener, (0, _tslib.__spread)(args));
    });
};
var notifyEventListenersAndAwaitHandlers = function notifyEventListenersAndAwaitHandlers(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    return Promise.all(Array.from((_a = eventListeners[type]) !== null && _a !== void 0 ? _a : []).map(function(listener) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            listener.handleEvent.apply(listener, (0, _tslib.__spread)(args))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }));
};
var addEventListener = function addEventListener(type, handler) {
    // If there is no listener set for the event type, just create it
    if (!eventListeners[type]) eventListeners[type] = new Set();
    var listener = {
        handleEvent: handler,
        remove: function remove() {
            eventListeners[type].delete(listener);
        }
    };
    eventListeners[type].add(listener);
    return listener;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"au5Fu":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", function() {
    return 0, _awspinpointProviderDefault.default;
});
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awspinpointProviderDefault = parcelHelpers.interopDefault(_awspinpointProvider);

},{"./AWSPinpointProvider":"co7Ur","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"co7Ur":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _common = require("../../../common");
var _sessionTracker = require("../../SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
var _types = require("../../types");
var _types1 = require("./types");
var _utils = require("./utils");
var MESSAGE_DAILY_COUNT_KEY = 'pinpointProvider_inAppMessages_dailyCount';
var MESSAGE_TOTAL_COUNT_KEY = 'pinpointProvider_inAppMessages_totalCount';
var AWSPinpointProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSPinpointProvider, _super);
    function AWSPinpointProvider() {
        var _this = _super.call(this, (0, _utils.logger)) || this;
        _this.configured = false;
        _this.configure = function(config) {
            if (config === void 0) config = {};
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _super.prototype.configure.call(_this, config)), {
                endpointInfo: {
                    channelType: 'IN_APP'
                }
            });
            // some configuration steps should not be re-run even if provider is re-configured for some reason
            if (!_this.configured) {
                _this.sessionTracker = new (0, _sessionTrackerDefault.default)(_this.sessionStateChangeHandler);
                _this.sessionTracker.start();
                // wire up default Pinpoint message event handling
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISMISSED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_ACTION_TAKEN);
                });
            }
            _this.configured = true;
            (0, _utils.dispatchInAppMessagingEvent)('pinpointProvider_configured', null);
            return _this.config;
        };
        _this.getInAppMessages = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, appId, credentials, endpointId, region, input, response, messages, err_1;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            // There is no way to granuarly reconcile the filter memoization as the keys are composited from a message id and
                            // event properties thus opting to just clear them out when getting messages rather than leave potentially
                            // obsolete entries that will no longer serve any purpose.
                            (0, _utils.clearMemo)();
                            _b.label = 3;
                        case 3:
                            _b.trys.push([
                                3,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint()
                            ];
                        case 4:
                            _b.sent();
                            _a = this.config, appId = _a.appId, credentials = _a.credentials, endpointId = _a.endpointId, region = _a.region;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId
                            };
                            this.logger.debug('getting in-app messages');
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.getInAppMessages)({
                                    credentials: credentials,
                                    region: region
                                }, input)
                            ];
                        case 5:
                            response = _b.sent();
                            messages = response.InAppMessagesResponse.InAppMessageCampaigns;
                            (0, _utils.dispatchInAppMessagingEvent)('getInAppMessages', messages);
                            return [
                                2 /*return*/ ,
                                messages
                            ];
                        case 6:
                            err_1 = _b.sent();
                            this.logger.error('Error getting in-app messages', err_1);
                            throw err_1;
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.processInAppMessages = function(messages, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var highestPrioritySeen;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ ,
                                this.normalizeMessages(messages.reduce(function(acc, message) {
                                    var messageQualifies = (0, _utils.matchesEventType)(message, event) && (0, _utils.matchesAttributes)(message, event) && (0, _utils.matchesMetrics)(message, event) && (0, _utils.isBeforeEndDate)(message) && _this.isBelowCap(message);
                                    // filter all qualifying messages returning only those that are of (relative) highest priority
                                    if (messageQualifies) {
                                        // have not yet encountered message with priority
                                        if (!highestPrioritySeen) {
                                            // this message has priority, so reset the accumulator with this message only
                                            if (message.Priority) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            } else // this message also has no priority, so just add this message to accumulator
                                            acc.push(message);
                                        } else if (message.Priority) {
                                            // this message has higher priority (lower number), so reset the accumulator with this message only
                                            if (message.Priority < highestPrioritySeen) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            // this message has the same priority, so just add this message to accumulator
                                            } else if (message.Priority === highestPrioritySeen) acc.push(message);
                                        }
                                    }
                                    return acc;
                                }, []))
                            ];
                    }
                });
            });
        };
        _this.sessionStateChangeHandler = function(state) {
            if (state === 'started') // reset all session counts
            _this.sessionMessageCountMap = {};
        };
        _this.isBelowCap = function(_a) {
            var CampaignId = _a.CampaignId, SessionCap = _a.SessionCap, DailyCap = _a.DailyCap, TotalCap = _a.TotalCap;
            var _b = _this.getMessageCounts(CampaignId), sessionCount = _b.sessionCount, dailyCount = _b.dailyCount, totalCount = _b.totalCount;
            return (!SessionCap || sessionCount < SessionCap) && (!DailyCap || dailyCount < DailyCap) && (!TotalCap || totalCount < TotalCap);
        };
        // Use the current session count in memory or initialize as empty count
        _this.getSessionCount = function(messageId) {
            return _this.sessionMessageCountMap[messageId] || 0;
        };
        _this.getDailyCount = function() {
            var storage = _this.config.storage;
            var today = (0, _utils.getStartOfDay)();
            var item = storage.getItem(MESSAGE_DAILY_COUNT_KEY);
            // Parse stored count or initialize as empty count
            var counter = item ? JSON.parse(item) : {
                count: 0,
                lastCountTimestamp: today
            };
            // If the stored counter timestamp is today, use it as the count, otherwise reset to 0
            return counter.lastCountTimestamp === today ? counter.count : 0;
        };
        _this.getTotalCountMap = function() {
            var storage = _this.config.storage;
            var item = storage.getItem(MESSAGE_TOTAL_COUNT_KEY);
            // Parse stored count map or initialize as empty
            return item ? JSON.parse(item) : {};
        };
        _this.getTotalCount = function(messageId) {
            var countMap = _this.getTotalCountMap();
            // Return stored count or initialize as empty count
            return countMap[messageId] || 0;
        };
        _this.getMessageCounts = function(messageId) {
            try {
                return {
                    sessionCount: _this.getSessionCount(messageId),
                    dailyCount: _this.getDailyCount(),
                    totalCount: _this.getTotalCount(messageId)
                };
            } catch (err) {
                _this.logger.error('Failed to get message counts from storage', err);
            }
        };
        _this.setSessionCount = function(messageId, count) {
            _this.sessionMessageCountMap[messageId] = count;
        };
        _this.setDailyCount = function(count) {
            var storage = _this.config.storage;
            var dailyCount = {
                count: count,
                lastCountTimestamp: (0, _utils.getStartOfDay)()
            };
            try {
                storage.setItem(MESSAGE_DAILY_COUNT_KEY, JSON.stringify(dailyCount));
            } catch (err) {
                _this.logger.error('Failed to save daily message count to storage', err);
            }
        };
        _this.setTotalCountMap = function(countMap) {
            var storage = _this.config.storage;
            try {
                storage.setItem(MESSAGE_TOTAL_COUNT_KEY, JSON.stringify(countMap));
            } catch (err) {
                _this.logger.error('Failed to save total count to storage', err);
            }
        };
        _this.setTotalCount = function(messageId, count) {
            var _a;
            var updatedMap = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.getTotalCountMap()), (_a = {}, _a[messageId] = count, _a));
            _this.setTotalCountMap(updatedMap);
        };
        _this.incrementCounts = function(messageId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, sessionCount, dailyCount, totalCount;
                return (0, _tslib.__generator)(this, function(_b) {
                    _a = this.getMessageCounts(messageId), sessionCount = _a.sessionCount, dailyCount = _a.dailyCount, totalCount = _a.totalCount;
                    this.setSessionCount(messageId, sessionCount + 1);
                    this.setDailyCount(dailyCount + 1);
                    this.setTotalCount(messageId, totalCount + 1);
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        _this.normalizeMessages = function(messages) {
            return messages.map(function(message) {
                var CampaignId = message.CampaignId, InAppMessage = message.InAppMessage;
                return {
                    id: CampaignId,
                    content: (0, _utils.extractContent)(message),
                    layout: (0, _utils.interpretLayout)(InAppMessage.Layout),
                    metadata: (0, _utils.extractMetadata)(message)
                };
            });
        };
        _this.recordMessageEvent = function(message, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            (0, _utils.recordAnalyticsEvent)(event, message);
                            if (!(event === (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                this.incrementCounts(message.id)
                            ];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.sessionMessageCountMap = {};
        return _this;
    }
    /**
     * get the sub-category of the plugin
     */ AWSPinpointProvider.prototype.getSubCategory = function() {
        return AWSPinpointProvider.subCategory;
    };
    AWSPinpointProvider.subCategory = 'InAppMessaging';
    return AWSPinpointProvider;
}((0, _common.AWSPinpointProviderCommon));
exports.default = AWSPinpointProvider;

},{"tslib":"86BcK","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","../../../common":"fGILj","../../SessionTracker":"3jGxe","../../types":"bbtoH","./types":"hyGsE","./utils":"4Zk3y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3jGxe":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sessionTracker = require("./SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
exports.default = (0, _sessionTrackerDefault.default);

},{"./SessionTracker":"bTAdv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bTAdv":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _noop = require("lodash/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
// Per https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
var hidden;
var visibilityChange;
var isBrowser = (0, _core.browserOrNode)().isBrowser;
if (isBrowser && document) {
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document['msHidden'] !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document['webkitHidden'] !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
}
var logger = new (0, _core.ConsoleLogger)('InAppMessagingSessionTracker');
var SessionTracker = /** @class */ function() {
    function SessionTracker(sessionStateChangeHandler) {
        var _this = this;
        if (sessionStateChangeHandler === void 0) sessionStateChangeHandler = (0, _noopDefault.default);
        this.start = function() {
            if (isBrowser) document === null || document === void 0 || document.addEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.end = function() {
            if (isBrowser) document === null || document === void 0 || document.removeEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.getSessionState = function() {
            if (isBrowser && document && !document[hidden]) return 'started';
            // If, for any reason, document is undefined the session will never start
            return 'ended';
        };
        this.visibilityChangeHandler = function() {
            if (!isBrowser || !document) return;
            if (document[hidden]) {
                logger.debug('App is now hidden');
                _this.sessionStateChangeHandler('ended');
            } else {
                logger.debug('App is now visible');
                _this.sessionStateChangeHandler('started');
            }
        };
        this.sessionStateChangeHandler = sessionStateChangeHandler;
    }
    return SessionTracker;
}();
exports.default = SessionTracker;

},{"@aws-amplify/core":"3rlh1","lodash/noop":"dS0xS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dS0xS":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"bbtoH":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InAppMessageInteractionEvent", function() {
    return InAppMessageInteractionEvent;
});
var InAppMessageInteractionEvent;
(function(InAppMessageInteractionEvent) {
    InAppMessageInteractionEvent["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISPLAYED"] = "MESSAGE_DISPLAYED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISMISSED"] = "MESSAGE_DISMISSED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_ACTION_TAKEN"] = "MESSAGE_ACTION_TAKEN_EVENT";
})(InAppMessageInteractionEvent || (InAppMessageInteractionEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hyGsE":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointMessageEvent", function() {
    return AWSPinpointMessageEvent;
});
var AWSPinpointMessageEvent;
(function(AWSPinpointMessageEvent) {
    AWSPinpointMessageEvent["MESSAGE_DISPLAYED"] = "_inapp.message_displayed";
    AWSPinpointMessageEvent["MESSAGE_DISMISSED"] = "_inapp.message_dismissed";
    AWSPinpointMessageEvent["MESSAGE_ACTION_TAKEN"] = "_inapp.message_clicked";
})(AWSPinpointMessageEvent || (AWSPinpointMessageEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Zk3y":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
parcelHelpers.export(exports, "dispatchInAppMessagingEvent", function() {
    return dispatchInAppMessagingEvent;
});
parcelHelpers.export(exports, "recordAnalyticsEvent", function() {
    return recordAnalyticsEvent;
});
parcelHelpers.export(exports, "getStartOfDay", function() {
    return getStartOfDay;
});
parcelHelpers.export(exports, "matchesEventType", function() {
    return matchesEventType;
});
parcelHelpers.export(exports, "matchesAttributes", function() {
    return matchesAttributes;
});
parcelHelpers.export(exports, "matchesMetrics", function() {
    return matchesMetrics;
});
parcelHelpers.export(exports, "getComparator", function() {
    return getComparator;
});
parcelHelpers.export(exports, "isBeforeEndDate", function() {
    return isBeforeEndDate;
});
parcelHelpers.export(exports, "isQuietTime", function() {
    return isQuietTime;
});
parcelHelpers.export(exports, "clearMemo", function() {
    return clearMemo;
});
parcelHelpers.export(exports, "interpretLayout", function() {
    return interpretLayout;
});
parcelHelpers.export(exports, "extractContent", function() {
    return extractContent;
});
parcelHelpers.export(exports, "extractMetadata", function() {
    return extractMetadata;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _common = require("../../../common");
var DELIVERY_TYPE = 'IN_APP_MESSAGE';
var eventNameMemo = {};
var eventAttributesMemo = {};
var eventMetricsMemo = {};
var logger = new (0, _core.ConsoleLogger)('InAppMessaging.AWSPinpointProvider');
var dispatchInAppMessagingEvent = function dispatchInAppMessagingEvent(event, data, message) {
    (0, _core.Hub).dispatch('inAppMessaging', {
        event: event,
        data: data,
        message: message
    }, 'InAppMessaging', (0, _common.AMPLIFY_SYMBOL));
};
var recordAnalyticsEvent = function recordAnalyticsEvent(event, message) {
    if ((0, _core.Amplify).Analytics && typeof (0, _core.Amplify).Analytics.record === 'function') {
        var id = message.id, metadata = message.metadata;
        (0, _core.Amplify).Analytics.record({
            name: event,
            attributes: {
                campaign_id: id,
                delivery_type: DELIVERY_TYPE,
                treatment_id: metadata === null || metadata === void 0 ? void 0 : metadata.treatmentId
            }
        });
    } else logger.debug('Analytics module is not registered into Amplify');
};
var getStartOfDay = function getStartOfDay() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return now.toISOString();
};
var matchesEventType = function matchesEventType(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var eventType = _b.name;
    var _c;
    var EventType = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).EventType;
    var memoKey = CampaignId + ":" + eventType;
    if (!eventNameMemo.hasOwnProperty(memoKey)) eventNameMemo[memoKey] = !!(EventType === null || EventType === void 0 ? void 0 : EventType.Values.includes(eventType));
    return eventNameMemo[memoKey];
};
var matchesAttributes = function matchesAttributes(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var attributes = _b.attributes;
    var _c;
    var Attributes = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Attributes;
    if ((0, _isEmptyDefault.default)(Attributes)) // if message does not have attributes defined it does not matter what attributes are on the event
    return true;
    if ((0, _isEmptyDefault.default)(attributes)) // if message does have attributes but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(attributes);
    if (!eventAttributesMemo.hasOwnProperty(memoKey)) eventAttributesMemo[memoKey] = Object.entries(Attributes).every(function(_a) {
        var _$_b = (0, _tslib.__read)(_a, 2), key = _$_b[0], Values = _$_b[1].Values;
        return Values.includes(attributes[key]);
    });
    return eventAttributesMemo[memoKey];
};
var matchesMetrics = function matchesMetrics(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var metrics = _b.metrics;
    var _c;
    var Metrics = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Metrics;
    if ((0, _isEmptyDefault.default)(Metrics)) // if message does not have metrics defined it does not matter what metrics are on the event
    return true;
    if ((0, _isEmptyDefault.default)(metrics)) // if message does have metrics but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(metrics);
    if (!eventMetricsMemo.hasOwnProperty(memoKey)) eventMetricsMemo[memoKey] = Object.entries(Metrics).every(function(_a) {
        var _$_b = (0, _tslib.__read)(_a, 2), key = _$_b[0], _c = _$_b[1], ComparisonOperator = _c.ComparisonOperator, Value = _c.Value;
        var compare = getComparator(ComparisonOperator);
        // if there is some unknown comparison operator, treat as a comparison failure
        return compare ? compare(Value, metrics[key]) : false;
    });
    return eventMetricsMemo[memoKey];
};
var getComparator = function getComparator(operator) {
    switch(operator){
        case 'EQUAL':
            return function(metricsVal, eventVal) {
                return metricsVal === eventVal;
            };
        case 'GREATER_THAN':
            return function(metricsVal, eventVal) {
                return metricsVal < eventVal;
            };
        case 'GREATER_THAN_OR_EQUAL':
            return function(metricsVal, eventVal) {
                return metricsVal <= eventVal;
            };
        case 'LESS_THAN':
            return function(metricsVal, eventVal) {
                return metricsVal > eventVal;
            };
        case 'LESS_THAN_OR_EQUAL':
            return function(metricsVal, eventVal) {
                return metricsVal >= eventVal;
            };
        default:
            return null;
    }
};
var isBeforeEndDate = function isBeforeEndDate(_a) {
    var Schedule = _a.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate)) return true;
    return new Date() < new Date(Schedule.EndDate);
};
var isQuietTime = function isQuietTime(message) {
    var Schedule = message.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.QuietTime)) return false;
    var pattern = /^[0-2]\d:[0-5]\d$/; // basic sanity check, not a fully featured HH:MM validation
    var _a = Schedule.QuietTime, Start = _a.Start, End = _a.End;
    if (!Start || !End || Start === End || !pattern.test(Start) || !pattern.test(End)) return false;
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    var _b = (0, _tslib.__read)(Start.split(':'), 2), startHours = _b[0], startMinutes = _b[1];
    var _c = (0, _tslib.__read)(End.split(':'), 2), endHours = _c[0], endMinutes = _c[1];
    start.setHours(Number.parseInt(startHours, 10), Number.parseInt(startMinutes, 10), 0, 0);
    end.setHours(Number.parseInt(endHours, 10), Number.parseInt(endMinutes, 10), 0, 0);
    // if quiet time includes midnight, bump the end time to the next day
    if (start > end) end.setDate(end.getDate() + 1);
    var isQuietTime = now >= start && now <= end;
    if (isQuietTime) logger.debug('message filtered due to quiet time', message);
    return isQuietTime;
};
var clearMemo = function clearMemo() {
    eventNameMemo = {};
    eventAttributesMemo = {};
    eventMetricsMemo = {};
};
var interpretLayout = function interpretLayout(layout) {
    if (layout === 'MOBILE_FEED') return 'MODAL';
    if (layout === 'OVERLAYS') return 'FULL_SCREEN';
    // cast as PinpointInAppMessage['InAppMessage']['Layout'] allows `string` as a value
    return layout;
};
var extractContent = function extractContent(_a) {
    var message = _a.InAppMessage;
    var _b, _c;
    return (_c = (_b = message === null || message === void 0 ? void 0 : message.Content) === null || _b === void 0 ? void 0 : _b.map(function(content) {
        var BackgroundColor = content.BackgroundColor, BodyConfig = content.BodyConfig, HeaderConfig = content.HeaderConfig, ImageUrl = content.ImageUrl, PrimaryBtn = content.PrimaryBtn, SecondaryBtn = content.SecondaryBtn;
        var defaultPrimaryButton = PrimaryBtn === null || PrimaryBtn === void 0 ? void 0 : PrimaryBtn.DefaultConfig;
        var defaultSecondaryButton = SecondaryBtn === null || SecondaryBtn === void 0 ? void 0 : SecondaryBtn.DefaultConfig;
        var extractedContent = {};
        if (BackgroundColor) extractedContent.container = {
            style: {
                backgroundColor: BackgroundColor
            }
        };
        if (HeaderConfig) extractedContent.header = {
            content: HeaderConfig.Header,
            style: {
                color: HeaderConfig.TextColor,
                textAlign: HeaderConfig.Alignment.toLowerCase()
            }
        };
        if (BodyConfig) extractedContent.body = {
            content: BodyConfig.Body,
            style: {
                color: BodyConfig.TextColor,
                textAlign: BodyConfig.Alignment.toLowerCase()
            }
        };
        if (ImageUrl) extractedContent.image = {
            src: ImageUrl
        };
        if (defaultPrimaryButton) extractedContent.primaryButton = {
            title: defaultPrimaryButton.Text,
            action: defaultPrimaryButton.ButtonAction,
            url: defaultPrimaryButton.Link,
            style: {
                backgroundColor: defaultPrimaryButton.BackgroundColor,
                borderRadius: defaultPrimaryButton.BorderRadius,
                color: defaultPrimaryButton.TextColor
            }
        };
        if (defaultSecondaryButton) extractedContent.secondaryButton = {
            title: defaultSecondaryButton.Text,
            action: defaultSecondaryButton.ButtonAction,
            url: defaultSecondaryButton.Link,
            style: {
                backgroundColor: defaultSecondaryButton.BackgroundColor,
                borderRadius: defaultSecondaryButton.BorderRadius,
                color: defaultSecondaryButton.TextColor
            }
        };
        return extractedContent;
    })) !== null && _c !== void 0 ? _c : [];
};
var extractMetadata = function extractMetadata(_a) {
    var InAppMessage = _a.InAppMessage, Priority = _a.Priority, Schedule = _a.Schedule, TreatmentId = _a.TreatmentId;
    return {
        customData: InAppMessage === null || InAppMessage === void 0 ? void 0 : InAppMessage.CustomConfig,
        endDate: Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate,
        priority: Priority,
        treatmentId: TreatmentId
    };
};

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","lodash/isEmpty":"15wZF","../../../common":"fGILj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9aljh":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _pushNotificationDefault.default;
});
parcelHelpers.export(exports, "PushNotificationPermissionStatus", function() {
    return 0, _types.PushNotificationPermissionStatus;
});
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var _types = require("./types");

},{"./PushNotification":"fPIAz","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPIAz":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _platformNotSupportedError = require("./PlatformNotSupportedError");
var _platformNotSupportedErrorDefault = parcelHelpers.interopDefault(_platformNotSupportedError);
var PushNotification = /** @class */ function() {
    function PushNotification() {
        var _this = this;
        /**
         * Configure PushNotification
         * @param {Object} config - PushNotification configuration object
         */ this.configure = function(_) {
            if (_ === void 0) _ = {};
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Add plugin into PushNotification
         * @param {PushNotificationProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.enable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.identifyUser = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getLaunchNotification = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.getBadgeCount = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.setBadgeCount = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getPermissionStatus = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.requestPermissions = function(_) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.onNotificationReceivedInBackground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationReceivedInForeground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onTokenReceived = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationOpened = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ PushNotification.prototype.getModuleName = function() {
        throw new (0, _platformNotSupportedErrorDefault.default)();
    };
    return PushNotification;
}();
exports.default = PushNotification;

},{"tslib":"86BcK","./PlatformNotSupportedError":"jy2rr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jy2rr":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var PlatformNotSupportedError = /** @class */ function(_super) {
    (0, _tslib.__extends)(PlatformNotSupportedError, _super);
    function PlatformNotSupportedError() {
        var _this = _super.call(this, 'Function not supported on current platform') || this;
        _this.name = 'PlatformNotSupportedError';
        return _this;
    }
    return PlatformNotSupportedError;
}(Error);
exports.default = PlatformNotSupportedError;

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lJ5pk":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Predictions", function() {
    return 0, _predictions.Predictions;
});
parcelHelpers.export(exports, "AmazonAIIdentifyPredictionsProvider", function() {
    return 0, _providers.AmazonAIIdentifyPredictionsProvider;
});
parcelHelpers.export(exports, "AmazonAIConvertPredictionsProvider", function() {
    return 0, _providers.AmazonAIConvertPredictionsProvider;
});
parcelHelpers.export(exports, "AmazonAIPredictionsProvider", function() {
    return 0, _providers.AmazonAIPredictionsProvider;
});
parcelHelpers.export(exports, "AmazonAIInterpretPredictionsProvider", function() {
    return 0, _providers.AmazonAIInterpretPredictionsProvider;
});
var _predictions = require("./Predictions");
var _providers = require("./Providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Predictions":"3ZuVO","./Providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ZuVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PredictionsClass", function() {
    return PredictionsClass;
});
parcelHelpers.export(exports, "Predictions", function() {
    return Predictions;
});
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)('Predictions');
var PredictionsClass = /** @class */ function() {
    /**
     * Initialize Predictions with AWS configurations
     * @param {PredictionsOptions} options - Configuration object for Predictions
     */ function PredictionsClass(options) {
        this._options = options;
        this._convertPluggables = [];
        this._identifyPluggables = [];
        this._interpretPluggables = [];
    }
    PredictionsClass.prototype.getModuleName = function() {
        return 'Predictions';
    };
    /**
     * add plugin/pluggable into Predictions category
     * @param {Object} pluggable - an instance of the plugin/pluggable
     **/ PredictionsClass.prototype.addPluggable = function(pluggable) {
        if (this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable with name " + pluggable.getProviderName() + " has already been added.");
        var pluggableAdded = false;
        if (this.implementsConvertPluggable(pluggable)) {
            this._convertPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsIdentifyPluggable(pluggable)) {
            this._identifyPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsInterpretPluggable(pluggable)) {
            this._interpretPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (pluggableAdded) this.configurePluggable(pluggable);
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.getPluggable = function(providerName) {
        var pluggable = this.getAllProviders().find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug('No plugin found with providerName=>', providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.removePluggable = function(providerName) {
        this._convertPluggables = this._convertPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._identifyPluggables = this._identifyPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._interpretPluggables = this._interpretPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * To make both top level providers and category level providers work with same interface and configuration
     * this method duplicates Predictions config into parent level config (for top level provider) and
     * category level config (such as convert, identify etc) and pass both to each provider.
     */ PredictionsClass.prototype.configure = function(options) {
        var _this = this;
        var predictionsConfig = options ? options.predictions || options : {};
        predictionsConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, predictionsConfig), options);
        this._options = Object.assign({}, this._options, predictionsConfig);
        logger.debug('configure Predictions', this._options);
        this.getAllProviders().forEach(function(pluggable) {
            return _this.configurePluggable(pluggable);
        });
    };
    PredictionsClass.prototype.interpret = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._interpretPluggables, options);
        return pluggableToExecute.interpret(input);
    };
    PredictionsClass.prototype.convert = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._convertPluggables, options);
        return pluggableToExecute.convert(input);
    };
    PredictionsClass.prototype.identify = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._identifyPluggables, options);
        return pluggableToExecute.identify(input);
    };
    // tslint:disable-next-line: max-line-length
    PredictionsClass.prototype.getPluggableToExecute = function(pluggables, providerOptions) {
        // Give preference to provider name first since it is more specific to this call, even if
        // there is only one provider configured to error out if the name provided is not the one matched.
        if (providerOptions && providerOptions.providerName) return (0, _tslib.__spread)(pluggables).find(function(pluggable) {
            return pluggable.getProviderName() === providerOptions.providerName;
        });
        else {
            if (pluggables.length === 1) return pluggables[0];
            else throw new Error("More than one or no providers are configured, Either specify a provider name or configure exactly one provider");
        }
    };
    PredictionsClass.prototype.getAllProviders = function() {
        return (0, _tslib.__spread)(this._convertPluggables, this._identifyPluggables, this._interpretPluggables);
    };
    PredictionsClass.prototype.configurePluggable = function(pluggable) {
        var categoryConfig = Object.assign({}, this._options['predictions'], this._options[pluggable.getCategory().toLowerCase()] // Actual category level config
        );
        pluggable.configure(categoryConfig);
    };
    PredictionsClass.prototype.implementsConvertPluggable = function(obj) {
        return obj && typeof obj.convert === 'function';
    };
    PredictionsClass.prototype.implementsIdentifyPluggable = function(obj) {
        return obj && typeof obj.identify === 'function';
    };
    PredictionsClass.prototype.implementsInterpretPluggable = function(obj) {
        return obj && typeof obj.interpret === 'function';
    };
    return PredictionsClass;
}();
var Predictions = new PredictionsClass({});
(0, _core.Amplify).register(Predictions);

},{"tslib":"bZghs","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bZghs":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dqyLX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSRContext", function() {
    return withSSRContext;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _core = require("@aws-amplify/core");
var _datastore = require("@aws-amplify/datastore");
// ! We have to use this exact reference, since it gets mutated with Amplify.Auth
var _index = require("./index");
var requiredModules = [
    // API cannot function without Auth
    (0, _auth.Auth),
    // Auth cannot function without Credentials
    (0, _core.Credentials)
];
// These modules have been tested with SSR
var defaultModules = [
    (0, _api.API),
    (0, _auth.Auth),
    (0, _datastore.DataStore)
];
function withSSRContext(context) {
    if (context === void 0) context = {};
    var _a = context.modules, modules = _a === void 0 ? defaultModules : _a, req = context.req;
    if (modules.includes((0, _datastore.DataStore)) && !modules.includes((0, _internals.InternalAPI))) modules.push((0, _internals.InternalAPI));
    var previousConfig = (0, _index.Amplify).configure();
    var amplify = new (0, _core.AmplifyClass)();
    var storage = new (0, _core.UniversalStorage)({
        req: req
    });
    requiredModules.forEach(function(m) {
        if (!modules.includes(m)) // @ts-ignore This expression is not constructable.
        // Type 'Function' has no construct signatures.ts(2351)
        amplify.register(new m.constructor());
    });
    // Associate new module instances with this amplify
    modules.forEach(function(m) {
        amplify.register(new m.constructor());
    });
    // Configure new Amplify instances with previous configuration
    amplify.configure((0, _tslib.__assign)((0, _tslib.__assign)({}, previousConfig), {
        storage: storage
    }));
    return amplify;
}

},{"tslib":"86BcK","@aws-amplify/api":"6PDaW","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/core":"3rlh1","@aws-amplify/datastore":"fPd7W","./index":"75VoS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3VEgf":[function(require,module,exports,__globalThis) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geo", function() {
    return 0, _geo.Geo;
});
var _geo = require("./Geo");

},{"./Geo":"fMwG4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMwG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeoClass", function() {
    return GeoClass;
});
parcelHelpers.export(exports, "Geo", function() {
    return Geo;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _amazonLocationServiceProvider = require("./Providers/AmazonLocationServiceProvider");
var _util = require("./util");
var logger = new (0, _core.ConsoleLogger)('Geo');
var DEFAULT_PROVIDER = 'AmazonLocationService';
var GeoClass = /** @class */ function() {
    function GeoClass() {
        this._config = {};
        this._pluggables = [];
        logger.debug('Geo Options', this._config);
    }
    /**
     * get the name of the module category
     * @returns {string} name of the module category
     */ GeoClass.prototype.getModuleName = function() {
        return GeoClass.MODULE;
    };
    /**
     * add plugin into Geo category
     * @param {Object} pluggable - an instance of the plugin
     */ GeoClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === 'Geo') {
            this._pluggables.push(pluggable);
            var config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug('No plugin found with providerName', providerName);
            throw new Error('No plugin found in Geo for the provider');
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Geo
     * @param {Object} config - Configuration object for Geo
     * @return {Object} - Current configuration
     */ GeoClass.prototype.configure = function(config) {
        var _this = this;
        logger.debug('configure Geo');
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Geo, config);
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _amazonLocationServiceProvider.AmazonLocationServiceProvider)());
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @param {string} provider
     * @returns - Array of available map resources
     */ GeoClass.prototype.getAvailableMaps = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getAvailableMaps();
    };
    /**
     * Get the map resource set as default in amplify config
     * @param {string} provider
     * @returns - Map resource set as the default in amplify config
     */ GeoClass.prototype.getDefaultMap = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getDefaultMap();
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ GeoClass.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByText(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_1 = _b.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for search term suggestions based on input text
     * @param  {string} text - The text string that is to be search for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ GeoClass.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_2;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchForSuggestions(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_2 = _b.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for location by unique ID
     * @param  {string} placeId - Unique ID of the location that is to be searched for
     * @param  {searchByPlaceIdOptions} options? - Optional parameters to the search
     * @returns {Promise<Place>} - Resolves to a place with the given placeId
     */ GeoClass.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var providerName, prov, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        providerName = DEFAULT_PROVIDER;
                        prov = this.getPluggable(providerName);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByPlaceId(placeId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ GeoClass.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, _b, lng, lat, error_4;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b = (0, _tslib.__read)(coordinates, 2), lng = _b[0], lat = _b[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        (0, _util.validateCoordinates)(lng, lat);
                        return [
                            4 /*yield*/ ,
                            prov.searchByCoordinates(coordinates, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 3:
                        error_4 = _c.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create geofences
     * @param geofences - Single or array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<SaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ GeoClass.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceInputArray, error_5;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofences)) geofenceInputArray = [
                            geofences
                        ];
                        else geofenceInputArray = geofences;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.saveGeofences(geofenceInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_5 = _b.sent();
                        logger.debug(error_5);
                        throw error_5;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get a single geofence by geofenceId
     * @param geofenceId: GeofenceId - The string id of the geofence to get
     * @param options?: GeofenceOptions - Optional parameters for getting a geofence
     * @returns Promise<Geofence> - Promise that resolves to a geofence object
     */ GeoClass.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_6;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.getGeofence(geofenceId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_6 = _b.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List geofences
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ GeoClass.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_7;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.listGeofences(options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_7 = _b.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ GeoClass.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceIdsInputArray, error_8;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofenceIds)) geofenceIdsInputArray = [
                            geofenceIds
                        ];
                        else geofenceIdsInputArray = geofenceIds;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.deleteGeofences(geofenceIdsInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_8 = _b.sent();
                        logger.debug(error_8);
                        throw error_8;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    GeoClass.MODULE = 'Geo';
    return GeoClass;
}();
var Geo = new GeoClass();
(0, _core.Amplify).register(Geo);

},{"tslib":"6BFzs","@aws-amplify/core":"3rlh1","./Providers/AmazonLocationServiceProvider":"grnCH","./util":"9llQK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6BFzs":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"grnCH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonLocationServiceProvider", function() {
    return AmazonLocationServiceProvider;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _camelcaseKeys = require("camelcase-keys");
var _camelcaseKeysDefault = parcelHelpers.interopDefault(_camelcaseKeys);
var _core = require("@aws-amplify/core");
var _clientLocation = require("@aws-sdk/client-location");
var _util = require("../util");
var logger = new (0, _core.ConsoleLogger)('AmazonLocationServiceProvider');
var AmazonLocationServiceProvider = /** @class */ function() {
    /**
     * Initialize Geo with AWS configurations
     * @param {Object} config - Configuration object for Geo
     */ function AmazonLocationServiceProvider(config) {
        this._config = config ? config : {};
        logger.debug('Geo Options', this._config);
    }
    /**
     * get the category of the plugin
     * @returns {string} name of the category
     */ AmazonLocationServiceProvider.prototype.getCategory = function() {
        return AmazonLocationServiceProvider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     * @returns {string} name of the provider
     */ AmazonLocationServiceProvider.prototype.getProviderName = function() {
        return AmazonLocationServiceProvider.PROVIDER_NAME;
    };
    /**
     * Configure Geo part with aws configuration
     * @param {Object} config - Configuration of the Geo
     * @return {Object} - Current configuration
     */ AmazonLocationServiceProvider.prototype.configure = function(config) {
        logger.debug('configure Amazon Location Service Provider', config);
        if (!config) return this._config;
        this._config = Object.assign({}, this._config, config);
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @returns {AmazonLocationServiceMapStyle[]}- Array of available map resources
     */ AmazonLocationServiceProvider.prototype.getAvailableMaps = function() {
        this._verifyMapResources();
        var mapStyles = [];
        var availableMaps = this._config.maps.items;
        var region = this._config.region;
        for(var mapName in availableMaps){
            var style = availableMaps[mapName].style;
            mapStyles.push({
                mapName: mapName,
                style: style,
                region: region
            });
        }
        return mapStyles;
    };
    /**
     * Get the map resource set as default in amplify config
     * @returns {AmazonLocationServiceMapStyle} - Map resource set as the default in amplify config
     */ AmazonLocationServiceProvider.prototype.getDefaultMap = function() {
        this._verifyMapResources();
        var mapName = this._config.maps.default;
        var style = this._config.maps.items[mapName].style;
        var region = this._config.region;
        return {
            mapName: mapName,
            style: style,
            region: region
        };
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ AmazonLocationServiceProvider.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_1, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForTextCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults, {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Search for suggestions based on the input text
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ AmazonLocationServiceProvider.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_2, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForSuggestionsCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 5:
                        results = response.Results.map(function(result) {
                            return {
                                text: result.Text,
                                placeId: result.PlaceId
                            };
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyPlaceId = function(placeId) {
        if (placeId.length === 0) {
            var errorString = 'PlaceId cannot be an empty string.';
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, searchByPlaceIdInput, command, response, error_3, place;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        this._verifyPlaceId(placeId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        searchByPlaceIdInput = {
                            PlaceId: placeId,
                            IndexName: (options === null || options === void 0 ? void 0 : options.searchIndexName) || this._config.search_indices.default
                        };
                        command = new (0, _clientLocation.GetPlaceCommand)(searchByPlaceIdInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 5:
                        place = response.Place;
                        if (place) return [
                            2 /*return*/ ,
                            (0, _camelcaseKeysDefault.default)(place, {
                                deep: true
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ AmazonLocationServiceProvider.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_4, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Position: coordinates,
                            IndexName: this._config.search_indices.default
                        };
                        if (options) {
                            if (options.searchIndexName) locationServiceInput.IndexName = options.searchIndexName;
                            locationServiceInput.MaxResults = options.maxResults;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForPositionCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults[0], {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Create geofences inside of a geofence collection
     * @param geofences - Array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<AmazonLocationServiceSaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ AmazonLocationServiceProvider.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, PascalGeofences, results, geofenceBatches, apiLimit;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofences.length < 1) throw new Error('Geofence input array is empty');
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofencesInput)(geofences);
                        PascalGeofences = geofences.map(function(_a) {
                            var geofenceId = _a.geofenceId, polygon = _a.geometry.polygon;
                            return {
                                GeofenceId: geofenceId,
                                Geometry: {
                                    Polygon: polygon
                                }
                            };
                        });
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceBatches = [];
                        while(PascalGeofences.length > 0){
                            apiLimit = 10;
                            geofenceBatches.push(PascalGeofences.splice(0, apiLimit));
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_5;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                _a.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchPutGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_5 = _a.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofence) {
                                                    results.errors.push({
                                                        geofenceId: geofence.GeofenceId,
                                                        error: {
                                                            code: 'APIConnectionError',
                                                            message: error_5.message
                                                        }
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                // Push all successes to results
                                                response.Successes.forEach(function(success) {
                                                    var GeofenceId = success.GeofenceId, CreateTime = success.CreateTime, UpdateTime = success.UpdateTime;
                                                    results.successes.push({
                                                        geofenceId: GeofenceId,
                                                        createTime: CreateTime,
                                                        updateTime: UpdateTime
                                                    });
                                                });
                                                // Push all errors to results
                                                response.Errors.forEach(function(error) {
                                                    var _$_a = error.Error, Code = _$_a.Code, Message = _$_a.Message, GeofenceId = error.GeofenceId;
                                                    results.errors.push({
                                                        error: {
                                                            code: Code,
                                                            message: Message
                                                        },
                                                        geofenceId: GeofenceId
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Get geofence from a geofence collection
     * @param geofenceId:string
     * @param options?: Optional parameters for getGeofence
     * @returns {Promise<AmazonLocationServiceGeofence>} - Promise that resolves to a geofence object
     */ AmazonLocationServiceProvider.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, commandInput, command, response, error_6, GeofenceId, CreateTime, UpdateTime, Status, Geometry, geofence;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofenceId)(geofenceId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        commandInput = {
                            GeofenceId: geofenceId,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.GetGeofenceCommand)(commandInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_6 = _a.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 5:
                        GeofenceId = response.GeofenceId, CreateTime = response.CreateTime, UpdateTime = response.UpdateTime, Status = response.Status, Geometry = response.Geometry;
                        geofence = {
                            createTime: CreateTime,
                            geofenceId: GeofenceId,
                            geometry: {
                                polygon: Geometry.Polygon
                            },
                            status: Status,
                            updateTime: UpdateTime
                        };
                        return [
                            2 /*return*/ ,
                            geofence
                        ];
                }
            });
        });
    };
    /**
     * List geofences from a geofence collection
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ AmazonLocationServiceProvider.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, listGeofencesInput, command, response, error_7, NextToken, Entries, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        listGeofencesInput = {
                            NextToken: options === null || options === void 0 ? void 0 : options.nextToken,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.ListGeofencesCommand)(listGeofencesInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_7 = _a.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 5:
                        NextToken = response.NextToken, Entries = response.Entries;
                        results = {
                            entries: Entries.map(function(_a) {
                                var GeofenceId = _a.GeofenceId, CreateTime = _a.CreateTime, UpdateTime = _a.UpdateTime, Status = _a.Status, Polygon = _a.Geometry.Polygon;
                                return {
                                    geofenceId: GeofenceId,
                                    createTime: CreateTime,
                                    updateTime: UpdateTime,
                                    status: Status,
                                    geometry: {
                                        polygon: Polygon
                                    }
                                };
                            }),
                            nextToken: NextToken
                        };
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences from a geofence collection
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ AmazonLocationServiceProvider.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, badGeofenceIds, results, geofenceIdBatches, count;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofenceIds.length < 1) throw new Error('GeofenceId input array is empty');
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error('No credentials');
                        this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        badGeofenceIds = geofenceIds.filter(function(geofenceId) {
                            try {
                                (0, _util.validateGeofenceId)(geofenceId);
                            } catch (error) {
                                return true;
                            }
                        });
                        if (badGeofenceIds.length > 0) throw new Error("Invalid geofence ids: " + badGeofenceIds.join(', '));
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceIdBatches = [];
                        count = 0;
                        while(count < geofenceIds.length)geofenceIdBatches.push(geofenceIds.slice(count, count += 10));
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceIdBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_8, badGeofenceIds;
                                    var _$_a;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                _b.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchDeleteGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_8 = _b.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofenceId) {
                                                    var errorObject = {
                                                        geofenceId: geofenceId,
                                                        error: {
                                                            code: error_8.message,
                                                            message: error_8.message
                                                        }
                                                    };
                                                    results.errors.push(errorObject);
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                badGeofenceIds = response.Errors.map(function(_a) {
                                                    var geofenceId = _a.geofenceId;
                                                    return geofenceId;
                                                });
                                                (_$_a = results.successes).push.apply(_$_a, (0, _tslib.__spread)(batch.filter(function(Id) {
                                                    return !badGeofenceIds.includes(Id);
                                                })));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AmazonLocationServiceProvider.prototype._ensureCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, cred, error_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug('Set credentials for storage. Credentials are:', cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_9 = _a.sent();
                        logger.debug('Ensure credentials error. Credentials are:', error_9);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyMapResources = function() {
        if (!this._config.maps) {
            var errorString = "No map resources found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
        if (!this._config.maps.default) {
            var errorString = "No default map resource found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifySearchIndex = function(optionalSearchIndex) {
        if ((!this._config.search_indices || !this._config.search_indices.default) && !optionalSearchIndex) {
            var errorString = 'No Search Index found in amplify config, please run `amplify add geo` to create one and run `amplify push` after.';
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifyGeofenceCollections = function(optionalGeofenceCollectionName) {
        if ((!this._config.geofenceCollections || !this._config.geofenceCollections.default) && !optionalGeofenceCollectionName) {
            var errorString = 'No Geofence Collections found, please run `amplify add geo` to create one and run `amplify push` after.';
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchPutGeofenceCall = function(PascalGeofences, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var geofenceInput, client, command, response, error_10;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        geofenceInput = {
                            Entries: PascalGeofences,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchPutGeofenceCommand)(geofenceInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_10 = _a.sent();
                        throw error_10;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchDeleteGeofenceCall = function(geofenceIds, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteGeofencesInput, client, command, response, error_11;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        deleteGeofencesInput = {
                            GeofenceIds: geofenceIds,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchDeleteGeofenceCommand)(deleteGeofencesInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_11 = _a.sent();
                        throw error_11;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.CATEGORY = 'Geo';
    AmazonLocationServiceProvider.PROVIDER_NAME = 'AmazonLocationService';
    return AmazonLocationServiceProvider;
}();

},{"tslib":"6BFzs","camelcase-keys":"2sk6s","@aws-amplify/core":"3rlh1","@aws-sdk/client-location":"cvUL3","../util":"9llQK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sk6s":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var mapObj = require("bb83174fd2ff41c9");
var camelCase = require("cca3cebeca29a2f8");
var QuickLru = require("f54dcd543b16f228");
var has = function(array, key) {
    return array.some(function(x) {
        if (typeof x === 'string') return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
};
var cache = new QuickLru({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
var isObject = function(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
};
var camelCaseConvert = function(input, options) {
    if (!isObject(input)) return input;
    options = (0, _objectSpread._)({
        deep: false,
        pascalCase: false
    }, options);
    var exclude = options.exclude, pascalCase = options.pascalCase, stopPaths = options.stopPaths, deep = options.deep;
    var stopPathsSet = new Set(stopPaths);
    var makeMapper = function(parentPath) {
        return function(key, value) {
            if (deep && isObject(value)) {
                var path = parentPath === undefined ? key : "".concat(parentPath, ".").concat(key);
                if (!stopPathsSet.has(path)) value = mapObj(value, makeMapper(path));
            }
            if (!(exclude && has(exclude, key))) {
                var cacheKey = pascalCase ? "".concat(key, "_") : key;
                if (cache.has(cacheKey)) key = cache.get(cacheKey);
                else {
                    var ret = camelCase(key, {
                        pascalCase: pascalCase
                    });
                    if (key.length < 100) cache.set(cacheKey, ret);
                    key = ret;
                }
            }
            return [
                key,
                value
            ];
        };
    };
    return mapObj(input, makeMapper(undefined));
};
module.exports = function(input, options) {
    if (Array.isArray(input)) return Object.keys(input).map(function(key) {
        return camelCaseConvert(input[key], options);
    });
    return camelCaseConvert(input, options);
};

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_type_of":"668P4","bb83174fd2ff41c9":"kqPHR","cca3cebeca29a2f8":"2ZllB","f54dcd543b16f228":"alLML"}],"kqPHR":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isObject = function(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && value !== null;
};
var mapObjectSkip = Symbol('skip');
// Customized for this use-case
var isObjectCustom = function(value) {
    return isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
};
var mapObject = function(object, mapper, options) {
    var isSeen = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new WeakMap();
    options = (0, _objectSpread._)({
        deep: false,
        target: {}
    }, options);
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    var target = options.target;
    delete options.target;
    var mapArray = function(array) {
        return array.map(function(element) {
            return isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element;
        });
    };
    if (Array.isArray(object)) return mapArray(object);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var mapResult = mapper(key, value, object);
            if (mapResult === mapObjectSkip) continue;
            var _mapResult = (0, _slicedToArray._)(mapResult, 3), newKey = _mapResult[0], newValue = _mapResult[1], tmp = _mapResult[2], _ref = tmp === void 0 ? {} : tmp, _ref_shouldRecurse = _ref.shouldRecurse, shouldRecurse = _ref_shouldRecurse === void 0 ? true : _ref_shouldRecurse;
            // Drop `__proto__` keys.
            if (newKey === '__proto__') continue;
            if (options.deep && shouldRecurse && isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
            target[newKey] = newValue;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
module.exports = function(object, mapper, options) {
    if (!isObject(object)) throw new TypeError("Expected an object, got `".concat(object, "` (").concat(typeof object === "undefined" ? "undefined" : (0, _typeOf._)(object), ")"));
    return mapObject(object, mapper, options);
};
module.exports.mapObjectSkip = mapObjectSkip;

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4"}],"2ZllB":[function(require,module,exports,__globalThis) {
'use strict';
var preserveCamelCase = function(string) {
    var isLastCharLower = false;
    var isLastCharUpper = false;
    var isLastLastCharUpper = false;
    for(var i = 0; i < string.length; i++){
        var character = string[i];
        if (isLastCharLower && /[a-zA-Z]/.test(character) && character.toUpperCase() === character) {
            string = string.slice(0, i) + '-' + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(character) && character.toLowerCase() === character) {
            string = string.slice(0, i - 1) + '-' + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = character.toLowerCase() === character && character.toUpperCase() !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = character.toUpperCase() === character && character.toLowerCase() !== character;
        }
    }
    return string;
};
var camelCase = function(input, options) {
    if (!(typeof input === 'string' || Array.isArray(input))) throw new TypeError('Expected the input to be `string | string[]`');
    options = Object.assign({
        pascalCase: false
    }, options);
    var postProcess = function(x) {
        return options.pascalCase ? x.charAt(0).toUpperCase() + x.slice(1) : x;
    };
    if (Array.isArray(input)) input = input.map(function(x) {
        return x.trim();
    }).filter(function(x) {
        return x.length;
    }).join('-');
    else input = input.trim();
    if (input.length === 0) return '';
    if (input.length === 1) return options.pascalCase ? input.toUpperCase() : input.toLowerCase();
    var hasUpperCase = input !== input.toLowerCase();
    if (hasUpperCase) input = preserveCamelCase(input);
    input = input.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function(_, p1) {
        return p1.toUpperCase();
    }).replace(/\d+(\w|$)/g, function(m) {
        return m.toUpperCase();
    });
    return postProcess(input);
};
module.exports = camelCase;
// TODO: Remove this for the next major release
module.exports.default = camelCase;

},{}],"alLML":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
'use strict';
var QuickLRU = /*#__PURE__*/ function() {
    function QuickLRU() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, QuickLRU);
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError('`maxSize` must be a number greater than 0');
        this.maxSize = options.maxSize;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    (0, _createClass._)(QuickLRU, [
        {
            key: "_set",
            value: function _set(key, value) {
                this.cache.set(key, value);
                this._size++;
                if (this._size >= this.maxSize) {
                    this._size = 0;
                    this.oldCache = this.cache;
                    this.cache = new Map();
                }
            }
        },
        {
            key: "get",
            value: function get(key) {
                if (this.cache.has(key)) return this.cache.get(key);
                if (this.oldCache.has(key)) {
                    var value = this.oldCache.get(key);
                    this.oldCache.delete(key);
                    this._set(key, value);
                    return value;
                }
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                if (this.cache.has(key)) this.cache.set(key, value);
                else this._set(key, value);
                return this;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.cache.has(key) || this.oldCache.has(key);
            }
        },
        {
            key: "peek",
            value: function peek(key) {
                if (this.cache.has(key)) return this.cache.get(key);
                if (this.oldCache.has(key)) return this.oldCache.get(key);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var deleted = this.cache.delete(key);
                if (deleted) this._size--;
                return this.oldCache.delete(key) || deleted;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.cache.clear();
                this.oldCache.clear();
                this._size = 0;
            }
        },
        {
            key: "keys",
            value: function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            _step_value = (0, _slicedToArray._)(_step.value, 1), key = _step_value[0];
                            return [
                                4,
                                key
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, value, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            _step_value = (0, _slicedToArray._)(_step.value, 2), value = _step_value[1];
                            return [
                                4,
                                value
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, item1, _item, key, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.cache[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            item = _step.value;
                            return [
                                4,
                                item
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 9;
                        case 9:
                            _state.trys.push([
                                9,
                                14,
                                15,
                                16
                            ]);
                            _iterator1 = this.oldCache[Symbol.iterator]();
                            _state.label = 10;
                        case 10:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                13
                            ];
                            item1 = _step1.value;
                            _item = (0, _slicedToArray._)(item1, 1), key = _item[0];
                            if (!!this.cache.has(key)) return [
                                3,
                                12
                            ];
                            return [
                                4,
                                item1
                            ];
                        case 11:
                            _state.sent();
                            _state.label = 12;
                        case 12:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                10
                            ];
                        case 13:
                            return [
                                3,
                                16
                            ];
                        case 14:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                16
                            ];
                        case 15:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 16:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "size",
            get: function get() {
                var oldCacheSize = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.oldCache.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!this.cache.has(key)) oldCacheSize++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this._size + oldCacheSize;
            }
        }
    ]);
    return QuickLRU;
}();
module.exports = QuickLRU;

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5"}],"cvUL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", function() {
    return 0, _locationServiceException.LocationServiceException;
});
var _location = require("./Location");
parcelHelpers.exportAll(_location, exports);
var _locationClient = require("./LocationClient");
parcelHelpers.exportAll(_locationClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _pagination = require("./pagination");
parcelHelpers.exportAll(_pagination, exports);
var _locationServiceException = require("./models/LocationServiceException");

},{"./Location":false,"./LocationClient":"jYDhq","./commands":"9Rcjt","./models":false,"./pagination":false,"./models/LocationServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jYDhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationClient", function() {
    return LocationClient;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LocationClient = function(_super) {
    (0, _tslib.__extends)(LocationClient, _super);
    function LocationClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LocationClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LocationClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","@aws-sdk/config-resolver":"hrpyw","@aws-sdk/middleware-content-length":"5rsXh","@aws-sdk/middleware-host-header":"cj0v1","@aws-sdk/middleware-logger":"6uZPJ","@aws-sdk/middleware-recursion-detection":"l81JW","@aws-sdk/middleware-retry":"ijyar","@aws-sdk/middleware-signing":"5XJJZ","@aws-sdk/middleware-user-agent":"1ZRPH","@aws-sdk/smithy-client":"6yS5y","./runtimeConfig":"2UBhJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hrpyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"6x2PN","./regionConfig":"9Vx4e","./regionInfo":"aDVZ8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6x2PN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"6gtgL","./NodeUseFipsEndpointConfigOptions":"kd72E","./resolveCustomEndpointsConfig":"9gzGs","./resolveEndpointsConfig":"67yy8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gtgL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", function() {
    return ENV_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", function() {
    return CONFIG_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", function() {
    return DEFAULT_USE_DUALSTACK_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kd72E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", function() {
    return ENV_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", function() {
    return CONFIG_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", function() {
    return DEFAULT_USE_FIPS_ENDPOINT;
});
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", function() {
    return NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS;
});
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function configFileSelector(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9gzGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", function() {
    return resolveCustomEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function resolveCustomEndpointsConfig(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"67yy8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", function() {
    return resolveEndpointsConfig;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function resolveEndpointsConfig(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./utils/getEndpointFromRegion":"75X2L","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75X2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", function() {
    return getEndpointFromRegion;
});
var _tslib = require("tslib");
var getEndpointFromRegion = function getEndpointFromRegion(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Vx4e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"dW40D","./resolveRegionConfig":"lW1Hi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dW40D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", function() {
    return REGION_ENV_NAME;
});
parcelHelpers.export(exports, "REGION_INI_NAME", function() {
    return REGION_INI_NAME;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", function() {
    return NODE_REGION_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", function() {
    return NODE_REGION_CONFIG_FILE_OPTIONS;
});
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function _default() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lW1Hi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", function() {
    return resolveRegionConfig;
});
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function resolveRegionConfig(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function region1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function useFipsEndpoint1() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","./getRealRegion":"7qQ4P","./isFipsRegion":"4RbtZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7qQ4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", function() {
    return getRealRegion;
});
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function getRealRegion(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"4RbtZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4RbtZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", function() {
    return isFipsRegion;
});
var isFipsRegion = function isFipsRegion(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aDVZ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"80oMe","./RegionHash":"gjkpo","./getRegionInfo":"j29r8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"80oMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gjkpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j29r8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", function() {
    return getRegionInfo;
});
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function getRegionInfo(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"86BcK","./getHostnameFromVariants":"fGvhT","./getResolvedHostname":"hHIjA","./getResolvedPartition":"jJD5s","./getResolvedSigningRegion":"gQkaW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGvhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", function() {
    return getHostnameFromVariants;
});
var getHostnameFromVariants = function getHostnameFromVariants(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hHIjA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", function() {
    return getResolvedHostname;
});
var getResolvedHostname = function getResolvedHostname(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jJD5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", function() {
    return getResolvedPartition;
});
var getResolvedPartition = function getResolvedPartition(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gQkaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", function() {
    return getResolvedSigningRegion;
});
var getResolvedSigningRegion = function getResolvedSigningRegion(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rsXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", function() {
    return contentLengthMiddleware;
});
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", function() {
    return contentLengthMiddlewareOptions;
});
parcelHelpers.export(exports, "getContentLengthPlugin", function() {
    return getContentLengthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function getContentLengthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k6jTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"7Fcpb","./httpRequest":"eRSKt","./httpResponse":"aso92","./isValidHostname":"00bl8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Fcpb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eRSKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", function() {
    return HttpRequest;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && (0, _typeOf._)(req["query"]) === "object" && (0, _typeOf._)(req["headers"]) === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aso92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", function() {
    return HttpResponse;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && (0, _typeOf._)(resp.headers) === "object";
    };
    return HttpResponse;
}();

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"00bl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", function() {
    return isValidHostname;
});
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cj0v1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", function() {
    return resolveHostHeaderConfig;
});
parcelHelpers.export(exports, "hostHeaderMiddleware", function() {
    return hostHeaderMiddleware;
});
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", function() {
    return hostHeaderMiddlewareOptions;
});
parcelHelpers.export(exports, "getHostHeaderPlugin", function() {
    return getHostHeaderPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function hostHeaderMiddleware(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function getHostHeaderPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6uZPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"i9ywG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9ywG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", function() {
    return loggerMiddleware;
});
parcelHelpers.export(exports, "loggerMiddlewareOptions", function() {
    return loggerMiddlewareOptions;
});
parcelHelpers.export(exports, "getLoggerPlugin", function() {
    return getLoggerPlugin;
});
var _tslib = require("tslib");
var loggerMiddleware = function loggerMiddleware() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function getLoggerPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ijyar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"emddA","./DefaultRateLimiter":"cCOer","./StandardRetryStrategy":"imedv","./config":"hQIHz","./configurations":"Q2Mhy","./delayDecider":"ebtOs","./omitRetryHeadersMiddleware":"fKO21","./retryDecider":"63w1T","./retryMiddleware":"cus98","./types":"eV7Cn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"emddA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", function() {
    return AdaptiveRetryStrategy;
});
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function beforeRequest() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function afterRequest(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"86BcK","./config":"hQIHz","./DefaultRateLimiter":"cCOer","./StandardRetryStrategy":"imedv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hQIHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", function() {
    return RETRY_MODES;
});
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", function() {
    return DEFAULT_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", function() {
    return DEFAULT_RETRY_MODE;
});
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cCOer":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", function() {
    return DefaultRateLimiter;
});
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"86BcK","@aws-sdk/service-error-classification":"cClIb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cClIb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", function() {
    return isRetryableByTrait;
});
parcelHelpers.export(exports, "isClockSkewError", function() {
    return isClockSkewError;
});
parcelHelpers.export(exports, "isThrottlingError", function() {
    return isThrottlingError;
});
parcelHelpers.export(exports, "isTransientError", function() {
    return isTransientError;
});
var _constants = require("./constants");
var isRetryableByTrait = function isRetryableByTrait(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function isClockSkewError(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function isThrottlingError(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function isTransientError(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"e6KTO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6KTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", function() {
    return CLOCK_SKEW_ERROR_CODES;
});
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", function() {
    return THROTTLING_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", function() {
    return TRANSIENT_ERROR_CODES;
});
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", function() {
    return TRANSIENT_ERROR_STATUS_CODES;
});
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", function() {
    return NODEJS_TIMEOUT_ERROR_CODES;
});
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"imedv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", function() {
    return StandardRetryStrategy;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function _loop_1() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if ((typeof state_1 === "undefined" ? "undefined" : (0, _typeOf._)(state_1)) === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function getDelayFromRetryAfterHeader(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function asSdkError(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/service-error-classification":"cClIb","uuid":"hL32H","./config":"hQIHz","./constants":"9v1Q8","./defaultRetryQuota":"dVIOY","./delayDecider":"ebtOs","./retryDecider":"63w1T","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hL32H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"bNikX","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bNikX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"h8iZ0","./stringify.js":"bHrmw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h8iZ0":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bHrmw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"2p45N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2p45N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3piaN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3piaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9v1Q8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", function() {
    return DEFAULT_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", function() {
    return MAXIMUM_RETRY_DELAY;
});
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", function() {
    return THROTTLING_RETRY_DELAY_BASE;
});
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", function() {
    return INITIAL_RETRY_TOKENS;
});
parcelHelpers.export(exports, "RETRY_COST", function() {
    return RETRY_COST;
});
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", function() {
    return TIMEOUT_RETRY_COST;
});
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", function() {
    return NO_RETRY_INCREMENT;
});
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", function() {
    return INVOCATION_ID_HEADER;
});
parcelHelpers.export(exports, "REQUEST_HEADER", function() {
    return REQUEST_HEADER;
});
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dVIOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", function() {
    return getDefaultRetryQuota;
});
var _constants = require("./constants");
var getDefaultRetryQuota = function getDefaultRetryQuota(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function getCapacityAmount(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function hasRetryTokens(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function retrieveRetryTokens(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function releaseRetryTokens(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ebtOs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", function() {
    return defaultDelayDecider;
});
var _constants = require("./constants");
var defaultDelayDecider = function defaultDelayDecider(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"63w1T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", function() {
    return defaultRetryDecider;
});
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function defaultRetryDecider(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"cClIb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Q2Mhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", function() {
    return ENV_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", function() {
    return CONFIG_MAX_ATTEMPTS;
});
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", function() {
    return NODE_MAX_ATTEMPT_CONFIG_OPTIONS;
});
parcelHelpers.export(exports, "resolveRetryConfig", function() {
    return resolveRetryConfig;
});
parcelHelpers.export(exports, "ENV_RETRY_MODE", function() {
    return ENV_RETRY_MODE;
});
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", function() {
    return CONFIG_RETRY_MODE;
});
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", function() {
    return NODE_RETRY_MODE_CONFIG_OPTIONS;
});
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    configFileSelector: function configFileSelector(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function resolveRetryConfig(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function retryStrategy() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function environmentVariableSelector(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function configFileSelector(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./AdaptiveRetryStrategy":"emddA","./config":"hQIHz","./StandardRetryStrategy":"imedv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKO21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", function() {
    return omitRetryHeadersMiddleware;
});
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", function() {
    return omitRetryHeadersMiddlewareOptions;
});
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", function() {
    return getOmitRetryHeadersPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function omitRetryHeadersMiddleware() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function getOmitRetryHeadersPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cus98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", function() {
    return retryMiddleware;
});
parcelHelpers.export(exports, "retryMiddlewareOptions", function() {
    return retryMiddlewareOptions;
});
parcelHelpers.export(exports, "getRetryPlugin", function() {
    return getRetryPlugin;
});
var _tslib = require("tslib");
var retryMiddleware = function retryMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function getRetryPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eV7Cn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5XJJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"hNCtD","./middleware":"isI8R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNCtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", function() {
    return resolveAwsAuthConfig;
});
parcelHelpers.export(exports, "resolveSigV4AuthConfig", function() {
    return resolveSigV4AuthConfig;
});
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function resolveAwsAuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function signer() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function signer(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function resolveSigV4AuthConfig(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function normalizeCredentialProvider(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"ltIOt","@aws-sdk/signature-v4":"bJCrY","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ltIOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"dlwv5","./ProviderError":"8HNAw","./TokenProviderError":"gzwxR","./chain":"3udw1","./fromStatic":"9RC52","./memoize":"bUYoe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dlwv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", function() {
    return CredentialsProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8HNAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", function() {
    return ProviderError;
});
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gzwxR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", function() {
    return TokenProviderError;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3udw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", function() {
    return chain;
});
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function _loop_1(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9RC52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", function() {
    return fromStatic;
});
var fromStatic = function fromStatic(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bUYoe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
var _tslib = require("tslib");
var memoize = function memoize(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function coalesceProvider() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJCrY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return 0, _getCanonicalHeaders.getCanonicalHeaders;
});
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return 0, _getCanonicalQuery.getCanonicalQuery;
});
parcelHelpers.export(exports, "getPayloadHash", function() {
    return 0, _getPayloadHash.getPayloadHash;
});
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return 0, _moveHeadersToQuery.moveHeadersToQuery;
});
parcelHelpers.export(exports, "prepareRequest", function() {
    return 0, _prepareRequest.prepareRequest;
});
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"3u9XY","./getCanonicalHeaders":"bx7bM","./getCanonicalQuery":"b9kbm","./getPayloadHash":"giq6m","./moveHeadersToQuery":"ilF8D","./prepareRequest":"ajmAz","./credentialDerivation":"5dTfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3u9XY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", function() {
    return SignatureV4;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if ((typeof credentials === "undefined" ? "undefined" : (0, _typeOf._)(credentials)) !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function formatDate(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function getCanonicalHeaderList(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@aws-sdk/util-hex-encoding":"i3yua","@aws-sdk/util-middleware":"2OCR6","./constants":"17jwR","./credentialDerivation":"5dTfS","./getCanonicalHeaders":"bx7bM","./getCanonicalQuery":"b9kbm","./getPayloadHash":"giq6m","./headerUtil":"dJVHr","./moveHeadersToQuery":"ilF8D","./prepareRequest":"ajmAz","./utilDate":"e3juT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i3yua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", function() {
    return fromHex;
});
parcelHelpers.export(exports, "toHex", function() {
    return toHex;
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17jwR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", function() {
    return ALGORITHM_QUERY_PARAM;
});
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", function() {
    return CREDENTIAL_QUERY_PARAM;
});
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", function() {
    return AMZ_DATE_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", function() {
    return SIGNED_HEADERS_QUERY_PARAM;
});
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", function() {
    return EXPIRES_QUERY_PARAM;
});
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", function() {
    return SIGNATURE_QUERY_PARAM;
});
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", function() {
    return TOKEN_QUERY_PARAM;
});
parcelHelpers.export(exports, "REGION_SET_PARAM", function() {
    return REGION_SET_PARAM;
});
parcelHelpers.export(exports, "AUTH_HEADER", function() {
    return AUTH_HEADER;
});
parcelHelpers.export(exports, "AMZ_DATE_HEADER", function() {
    return AMZ_DATE_HEADER;
});
parcelHelpers.export(exports, "DATE_HEADER", function() {
    return DATE_HEADER;
});
parcelHelpers.export(exports, "GENERATED_HEADERS", function() {
    return GENERATED_HEADERS;
});
parcelHelpers.export(exports, "SIGNATURE_HEADER", function() {
    return SIGNATURE_HEADER;
});
parcelHelpers.export(exports, "SHA256_HEADER", function() {
    return SHA256_HEADER;
});
parcelHelpers.export(exports, "TOKEN_HEADER", function() {
    return TOKEN_HEADER;
});
parcelHelpers.export(exports, "HOST_HEADER", function() {
    return HOST_HEADER;
});
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", function() {
    return ALWAYS_UNSIGNABLE_HEADERS;
});
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", function() {
    return PROXY_HEADER_PATTERN;
});
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", function() {
    return SEC_HEADER_PATTERN;
});
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", function() {
    return UNSIGNABLE_PATTERNS;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", function() {
    return ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", function() {
    return ALGORITHM_IDENTIFIER_V4A;
});
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", function() {
    return EVENT_ALGORITHM_IDENTIFIER;
});
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", function() {
    return UNSIGNED_PAYLOAD;
});
parcelHelpers.export(exports, "MAX_CACHE_SIZE", function() {
    return MAX_CACHE_SIZE;
});
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", function() {
    return KEY_TYPE_IDENTIFIER;
});
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", function() {
    return MAX_PRESIGNED_TTL;
});
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5dTfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", function() {
    return createScope;
});
parcelHelpers.export(exports, "getSigningKey", function() {
    return getSigningKey;
});
parcelHelpers.export(exports, "clearCredentialCache", function() {
    return clearCredentialCache;
});
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function createScope(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"i3yua","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bx7bM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", function() {
    return getCanonicalHeaders;
});
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"86BcK","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b9kbm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", function() {
    return getCanonicalQuery;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function _loop_1(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"9ZH99","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ZH99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"9Vlcn","./escape-uri-path":"6tPfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Vlcn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", function() {
    return escapeUri;
});
var escapeUri = function escapeUri(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function hexEncode(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6tPfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", function() {
    return escapeUriPath;
});
var _escapeUri = require("./escape-uri");
var escapeUriPath = function escapeUriPath(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"9Vlcn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"giq6m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", function() {
    return getPayloadHash;
});
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/is-array-buffer":"4mNIj","@aws-sdk/util-hex-encoding":"i3yua","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4mNIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", function() {
    return isArrayBuffer;
});
var isArrayBuffer = function isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dJVHr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", function() {
    return hasHeader;
});
parcelHelpers.export(exports, "getHeaderValue", function() {
    return getHeaderValue;
});
parcelHelpers.export(exports, "deleteHeader", function() {
    return deleteHeader;
});
var _tslib = require("tslib");
var hasHeader = function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function getHeaderValue(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function deleteHeader(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ilF8D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", function() {
    return moveHeadersToQuery;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"86BcK","./cloneRequest":"hKxuc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKxuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", function() {
    return cloneRequest;
});
parcelHelpers.export(exports, "cloneQuery", function() {
    return cloneQuery;
});
var _tslib = require("tslib");
var cloneRequest = function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ajmAz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", function() {
    return prepareRequest;
});
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function prepareRequest(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"86BcK","./cloneRequest":"hKxuc","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e3juT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", function() {
    return iso8601;
});
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
var iso8601 = function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"isI8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", function() {
    return awsAuthMiddleware;
});
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", function() {
    return awsAuthMiddlewareOptions;
});
parcelHelpers.export(exports, "getAwsAuthPlugin", function() {
    return getAwsAuthPlugin;
});
parcelHelpers.export(exports, "getSigV4AuthPlugin", function() {
    return getSigV4AuthPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function getDateHeader(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function getAwsAuthPlugin(options) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./utils/getSkewCorrectedDate":"9WSC7","./utils/getUpdatedSystemClockOffset":"dzuy9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9WSC7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", function() {
    return getSkewCorrectedDate;
});
var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dzuy9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", function() {
    return getUpdatedSystemClockOffset;
});
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function getUpdatedSystemClockOffset(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"lw2DU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lw2DU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", function() {
    return isClockSkewed;
});
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function isClockSkewed(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"9WSC7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ZRPH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"3nzno","./user-agent-middleware":"i5uwN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3nzno":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", function() {
    return resolveUserAgentConfig;
});
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i5uwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", function() {
    return userAgentMiddleware;
});
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", function() {
    return getUserAgentMiddlewareOptions;
});
parcelHelpers.export(exports, "getUserAgentPlugin", function() {
    return getUserAgentPlugin;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function userAgentMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function escapeUserAgent(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function getUserAgentPlugin(config) {
    return {
        applyToStack: function applyToStack(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./constants":"jDE9x","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDE9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", function() {
    return USER_AGENT;
});
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", function() {
    return X_AMZ_USER_AGENT;
});
parcelHelpers.export(exports, "SPACE", function() {
    return SPACE;
});
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", function() {
    return UA_ESCAPE_REGEX;
});
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6yS5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"ivUKX","./command":"9XB6P","./constants":"cpIKJ","./date-utils":"sd4m2","./default-error-handler":"aEzmO","./defaults-mode":"6CC7y","./emitWarningIfUnsupportedVersion":"k6BsV","./exceptions":"dlYUN","./extended-encode-uri-component":"lLtny","./get-array-if-single-item":"2QL4f","./get-value-from-text-node":"krFAH","./lazy-json":"9CqeP","./object-mapping":"fTvky","./parse-utils":"93HHS","./resolve-path":"92rlt","./ser-utils":"5RkK2","./split-every":"avMYA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ivUKX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", function() {
    return Client;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"irbe4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irbe4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"lykEV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lykEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", function() {
    return constructStack;
});
var _tslib = require("tslib");
var constructStack = function constructStack1() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function sort(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function removeByName(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function removeByReference(toRemove) {
        var isRemoved = false;
        var filterCb = function filterCb(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function cloneTo(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function expandRelativeMiddlewareList1(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function getMiddlewareList(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function add(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error("\"".concat(name, "\" middleware with ").concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function addRelativeTo(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error("\"".concat(name, "\" middleware ").concat(toOverride.relation, " \"").concat(toOverride.toMiddleware, "\" middleware cannot be overridden ") + "by same-name middleware ".concat(entry.relation, " \"").concat(entry.toMiddleware, "\" middleware."));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function clone() {
            return cloneTo(constructStack());
        },
        use: function use(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function remove(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function removeByTag(toRemove) {
            var isRemoved = false;
            var filterCb = function filterCb(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function concat(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function identify() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function resolve(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9XB6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", function() {
    return Command;
});
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"irbe4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cpIKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", function() {
    return SENSITIVE_STRING;
});
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"sd4m2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", function() {
    return dateToUtcString;
});
parcelHelpers.export(exports, "parseRfc3339DateTime", function() {
    return parseRfc3339DateTime;
});
parcelHelpers.export(exports, "parseRfc7231DateTime", function() {
    return parseRfc7231DateTime;
});
parcelHelpers.export(exports, "parseEpochTimestamp", function() {
    return parseEpochTimestamp;
});
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function parseRfc3339DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function parseRfc7231DateTime(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function parseEpochTimestamp(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function buildDate(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function parseTwoDigitYear(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function adjustRfc850Year(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function parseMonthByShortName(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function validateDayOfMonth(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function parseDateValue(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function parseMilliseconds(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function stripLeadingZeroes(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"86BcK","./parse-utils":"93HHS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"93HHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", function() {
    return parseBoolean;
});
parcelHelpers.export(exports, "expectBoolean", function() {
    return expectBoolean;
});
parcelHelpers.export(exports, "expectNumber", function() {
    return expectNumber;
});
parcelHelpers.export(exports, "expectFloat32", function() {
    return expectFloat32;
});
parcelHelpers.export(exports, "expectLong", function() {
    return expectLong;
});
parcelHelpers.export(exports, "expectInt", function() {
    return expectInt;
});
parcelHelpers.export(exports, "expectInt32", function() {
    return expectInt32;
});
parcelHelpers.export(exports, "expectShort", function() {
    return expectShort;
});
parcelHelpers.export(exports, "expectByte", function() {
    return expectByte;
});
parcelHelpers.export(exports, "expectNonNull", function() {
    return expectNonNull;
});
parcelHelpers.export(exports, "expectObject", function() {
    return expectObject;
});
parcelHelpers.export(exports, "expectString", function() {
    return expectString;
});
parcelHelpers.export(exports, "expectUnion", function() {
    return expectUnion;
});
parcelHelpers.export(exports, "strictParseDouble", function() {
    return strictParseDouble;
});
parcelHelpers.export(exports, "strictParseFloat", function() {
    return strictParseFloat;
});
parcelHelpers.export(exports, "strictParseFloat32", function() {
    return strictParseFloat32;
});
parcelHelpers.export(exports, "limitedParseDouble", function() {
    return limitedParseDouble;
});
parcelHelpers.export(exports, "handleFloat", function() {
    return handleFloat;
});
parcelHelpers.export(exports, "limitedParseFloat", function() {
    return limitedParseFloat;
});
parcelHelpers.export(exports, "limitedParseFloat32", function() {
    return limitedParseFloat32;
});
parcelHelpers.export(exports, "strictParseLong", function() {
    return strictParseLong;
});
parcelHelpers.export(exports, "strictParseInt", function() {
    return strictParseInt;
});
parcelHelpers.export(exports, "strictParseInt32", function() {
    return strictParseInt32;
});
parcelHelpers.export(exports, "strictParseShort", function() {
    return strictParseShort;
});
parcelHelpers.export(exports, "strictParseByte", function() {
    return strictParseByte;
});
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tslib = require("tslib");
var parseBoolean = function parseBoolean(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error("Unable to parse boolean value \"".concat(value, "\""));
    }
};
var expectBoolean = function expectBoolean(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectNumber = function expectNumber(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function expectFloat32(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function expectLong(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function expectInt32(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function expectShort(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function expectByte(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function expectSizedInt(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function castInt(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function expectNonNull(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function expectObject(value) {
    if (value === null || value === undefined) return undefined;
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function expectString(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value))) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value), ": ").concat(value));
};
var expectUnion = function expectUnion(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function strictParseDouble(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function strictParseFloat32(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function parseNumber(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function limitedParseDouble(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function limitedParseFloat32(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function parseFloatString(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function strictParseLong(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function strictParseInt32(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function strictParseShort(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function strictParseByte(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function stackTraceWarning(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"@swc/helpers/_/_type_of":"668P4","tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aEzmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", function() {
    return throwDefaultError;
});
var _exceptions = require("./exceptions");
var throwDefaultError = function throwDefaultError(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"dlYUN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dlYUN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", function() {
    return ServiceException;
});
parcelHelpers.export(exports, "decorateServiceException", function() {
    return decorateServiceException;
});
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function decorateServiceException(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6CC7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", function() {
    return loadConfigsForDefaultMode;
});
var loadConfigsForDefaultMode = function loadConfigsForDefaultMode(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k6BsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", function() {
    return emitWarningIfUnsupportedVersion;
});
var process = require("5d372f430481d1db");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function emitWarningIfUnsupportedVersion(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"5d372f430481d1db":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLtny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", function() {
    return extendedEncodeURIComponent;
});
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2QL4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", function() {
    return getArrayIfSingleItem;
});
var getArrayIfSingleItem = function getArrayIfSingleItem(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"krFAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", function() {
    return getValueFromTextNode;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var getValueFromTextNode = function getValueFromTextNode1(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if ((0, _typeOf._)(obj[key]) === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CqeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", function() {
    return StringWrapper;
});
parcelHelpers.export(exports, "LazyJsonString", function() {
    return LazyJsonString;
});
var _tslib = require("tslib");
var StringWrapper = function StringWrapper() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fTvky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "convertMap", function() {
    return convertMap;
});
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function convertMap(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function mapWithFilter(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"92rlt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", function() {
    return resolvedPath;
});
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function resolvedPath(_resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        _resolvedPath = _resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return _resolvedPath;
};

},{"./extended-encode-uri-component":"lLtny","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RkK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", function() {
    return serializeFloat;
});
var serializeFloat = function serializeFloat(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"avMYA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", function() {
    return splitEvery;
});
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2UBhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function defaultConfigProvider() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"86BcK","../package.json":"8eHCo","@aws-crypto/sha256-browser":"5ntfd","@aws-sdk/config-resolver":"hrpyw","@aws-sdk/fetch-http-handler":"cBfhd","@aws-sdk/invalid-dependency":"hv19g","@aws-sdk/middleware-retry":"ijyar","@aws-sdk/util-base64-browser":"jzZOQ","@aws-sdk/util-body-length-browser":"6rztZ","@aws-sdk/util-user-agent-browser":"83az5","@aws-sdk/util-utf8-browser":"belsf","./runtimeConfig.shared":"8dpP6","@aws-sdk/smithy-client":"6yS5y","@aws-sdk/util-defaults-mode-browser":"gpbLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8eHCo":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"@aws-sdk/client-location\",\"description\":\"AWS SDK for JavaScript Location Client for Node.js, Browser and React Native\",\"version\":\"3.186.4\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"tsc -p tsconfig.cjs.json\",\"build:docs\":\"typedoc\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha256-browser\":\"2.0.0\",\"@aws-crypto/sha256-js\":\"2.0.0\",\"@aws-sdk/client-sts\":\"3.186.4\",\"@aws-sdk/config-resolver\":\"3.186.0\",\"@aws-sdk/credential-provider-node\":\"3.186.0\",\"@aws-sdk/fetch-http-handler\":\"3.186.0\",\"@aws-sdk/hash-node\":\"3.186.0\",\"@aws-sdk/invalid-dependency\":\"3.186.0\",\"@aws-sdk/middleware-content-length\":\"3.186.0\",\"@aws-sdk/middleware-host-header\":\"3.186.0\",\"@aws-sdk/middleware-logger\":\"3.186.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.186.0\",\"@aws-sdk/middleware-retry\":\"3.186.0\",\"@aws-sdk/middleware-serde\":\"3.186.0\",\"@aws-sdk/middleware-signing\":\"3.186.0\",\"@aws-sdk/middleware-stack\":\"3.186.0\",\"@aws-sdk/middleware-user-agent\":\"3.186.0\",\"@aws-sdk/node-config-provider\":\"3.186.0\",\"@aws-sdk/node-http-handler\":\"3.186.0\",\"@aws-sdk/protocol-http\":\"3.186.0\",\"@aws-sdk/smithy-client\":\"3.186.0\",\"@aws-sdk/types\":\"3.186.0\",\"@aws-sdk/url-parser\":\"3.186.0\",\"@aws-sdk/util-base64-browser\":\"3.186.0\",\"@aws-sdk/util-base64-node\":\"3.186.0\",\"@aws-sdk/util-body-length-browser\":\"3.186.0\",\"@aws-sdk/util-body-length-node\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-browser\":\"3.186.0\",\"@aws-sdk/util-defaults-mode-node\":\"3.186.0\",\"@aws-sdk/util-user-agent-browser\":\"3.186.0\",\"@aws-sdk/util-user-agent-node\":\"3.186.0\",\"@aws-sdk/util-utf8-browser\":\"3.186.0\",\"@aws-sdk/util-utf8-node\":\"3.186.0\",\"tslib\":\"^2.3.1\"},\"devDependencies\":{\"@aws-sdk/service-client-documentation-generator\":\"3.186.0\",\"@tsconfig/recommended\":\"1.0.1\",\"@types/node\":\"^12.7.5\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typedoc\":\"0.19.2\",\"typescript\":\"~4.6.2\"},\"overrides\":{\"typedoc\":{\"typescript\":\"~4.6.2\"}},\"engines\":{\"node\":\">=12.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-location\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-location\"}}");

},{}],"5ntfd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("2c225c7bd6ec0fe");
(0, tslib_1.__exportStar)(require("17fd527626e0957b"), exports);
var ie11Sha256_1 = require("b94d2f24e70883f0");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function get() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("3c3335554c325413");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function get() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"2c225c7bd6ec0fe":"gaeA7","17fd527626e0957b":"evCVJ","b94d2f24e70883f0":"b5qUp","3c3335554c325413":"1UM5e"}],"gaeA7":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"evCVJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("c668b1c6d918bcf6");
var webCryptoSha256_1 = require("eeda03e8bf347205");
var sha256_js_1 = require("39b1cf8cf20b539e");
var supports_web_crypto_1 = require("52eba68e276c6ae3");
var ie11_detection_1 = require("94511351fb1d82e6");
var util_locate_window_1 = require("65ca30ea13342516");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"c668b1c6d918bcf6":"b5qUp","eeda03e8bf347205":"1UM5e","39b1cf8cf20b539e":"dbsiN","52eba68e276c6ae3":"3HGak","94511351fb1d82e6":"5ouwi","65ca30ea13342516":"ljvil"}],"b5qUp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("a38a5551ac6d8db2");
var constants_1 = require("c08111ec498c1a04");
var util_utf8_browser_1 = require("6ecfdac05b8dbe2b");
var util_locate_window_1 = require("9d645356577258e3");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"a38a5551ac6d8db2":"aO8Pd","c08111ec498c1a04":"jAHBB","6ecfdac05b8dbe2b":"belsf","9d645356577258e3":"ljvil"}],"aO8Pd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"jAHBB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"belsf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function fromUtf8(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function toUtf8(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"jIvnd","./whatwgEncodingApi":"gV0ys","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jIvnd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
var fromUtf8 = function fromUtf8(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function toUtf8(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gV0ys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", function() {
    return fromUtf8;
});
parcelHelpers.export(exports, "toUtf8", function() {
    return toUtf8;
});
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1UM5e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("92792c9325c69b4b");
var constants_1 = require("250c7f026fb5aedc");
var util_locate_window_1 = require("8f9e852ccf95572b");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"92792c9325c69b4b":"lve8V","250c7f026fb5aedc":"jAHBB","8f9e852ccf95572b":"ljvil"}],"lve8V":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("6970649ba32f1037");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function get() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("3cab579e81cbc793");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function get() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("60a229355ca01f85");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function get() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("9df39cb9b7de08d0");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function get() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"6970649ba32f1037":"4KX2a","3cab579e81cbc793":"gKhpv","60a229355ca01f85":"aDO63","9df39cb9b7de08d0":"14wV5"}],"4KX2a":[function(require,module,exports,__globalThis) {
var Buffer = require("34441391e056678b").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f03a51a5418c7d38");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function fromUtf8(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"34441391e056678b":"cvSE8","f03a51a5418c7d38":"belsf"}],"gKhpv":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"aDO63":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"14wV5":[function(require,module,exports,__globalThis) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"dbsiN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("20c2714b53edfe01");
(0, tslib_1.__exportStar)(require("513196a22bbc18cf"), exports);

},{"20c2714b53edfe01":"4ZhS8","513196a22bbc18cf":"3vgVs"}],"4ZhS8":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vgVs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("c06a41fb36a29a5");
var constants_1 = require("2dc139b64fda8f50");
var RawSha256_1 = require("aff94597fafaa776");
var util_1 = require("28ce9add8905c498");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"c06a41fb36a29a5":"4ZhS8","2dc139b64fda8f50":"iIRtp","aff94597fafaa776":"2Jb8c","28ce9add8905c498":"lve8V"}],"iIRtp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"2Jb8c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("24d866a02214a751");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"24d866a02214a751":"iIRtp"}],"3HGak":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("6e3c17eeb0c4fc72");
tslib_1.__exportStar(require("f9aef6f49e6927f"), exports);

},{"6e3c17eeb0c4fc72":"3w13k","f9aef6f49e6927f":"dOav9"}],"3w13k":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dOav9":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("e4ab527815ab542b");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && (0, _typeOf._)(window.crypto.subtle) === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" && (0, _typeOf._)(window.crypto) === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"@swc/helpers/_/_type_of":"668P4","e4ab527815ab542b":"3w13k"}],"5ouwi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("b50b9aa22aecfe99");
tslib_1.__exportStar(require("e3ed86ecc71f3053"), exports);
tslib_1.__exportStar(require("aadf0a87a5a4af6"), exports);
tslib_1.__exportStar(require("46bfbd58b14d6ddd"), exports);
tslib_1.__exportStar(require("df010a1df45e9da0"), exports);
tslib_1.__exportStar(require("d2102a2d7714dbcd"), exports);

},{"b50b9aa22aecfe99":"4HzYa","e3ed86ecc71f3053":"eukmf","aadf0a87a5a4af6":"c2Nkg","46bfbd58b14d6ddd":"bJJdo","df010a1df45e9da0":"1dZio","d2102a2d7714dbcd":"1tK0U"}],"4HzYa":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeOf._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eukmf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"c2Nkg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"bJJdo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1dZio":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1tK0U":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"cBfhd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"ja5Au","./stream-collector":"ceemt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ja5Au":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", function() {
    return FetchHttpHandler;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _$_a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_$_a = _b.return)) _$_a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/querystring-builder":"3mpCm","./request-timeout":"1SCXU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3mpCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", function() {
    return buildQueryString;
});
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"9ZH99","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1SCXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", function() {
    return requestTimeout;
});
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ceemt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", function() {
    return streamCollector;
});
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function streamCollector(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"86BcK","@aws-sdk/util-base64-browser":"jzZOQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzZOQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", function() {
    return fromBase64;
});
parcelHelpers.export(exports, "toBase64", function() {
    return toBase64;
});
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hv19g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"khaJN","./invalidProvider":"irIaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"khaJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", function() {
    return invalidFunction;
});
var invalidFunction = function invalidFunction(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irIaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", function() {
    return invalidProvider;
});
var invalidProvider = function invalidProvider(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6rztZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"ANGDG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ANGDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", function() {
    return calculateBodyLength;
});
var calculateBodyLength = function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"83az5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", function() {
    return defaultUserAgent;
});
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function defaultUserAgent(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _$_a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_$_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _$_a === void 0 ? void 0 : _$_a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"86BcK","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8dpP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", function() {
    return getRuntimeConfig;
});
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function getRuntimeConfig(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2020-11-19",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Location",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"7a0Jq","./endpoints":"6kVHH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a0Jq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function parseUrl1(url) {
    if (typeof url === 'string') return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"aRzPi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aRzPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", function() {
    return parseQueryString;
});
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6kVHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", function() {
    return defaultRegionInfoProvider;
});
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function defaultRegionInfoProvider(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "geo",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/config-resolver":"hrpyw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Rcjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _associateTrackerConsumerCommand = require("./AssociateTrackerConsumerCommand");
parcelHelpers.exportAll(_associateTrackerConsumerCommand, exports);
var _batchDeleteDevicePositionHistoryCommand = require("./BatchDeleteDevicePositionHistoryCommand");
parcelHelpers.exportAll(_batchDeleteDevicePositionHistoryCommand, exports);
var _batchDeleteGeofenceCommand = require("./BatchDeleteGeofenceCommand");
parcelHelpers.exportAll(_batchDeleteGeofenceCommand, exports);
var _batchEvaluateGeofencesCommand = require("./BatchEvaluateGeofencesCommand");
parcelHelpers.exportAll(_batchEvaluateGeofencesCommand, exports);
var _batchGetDevicePositionCommand = require("./BatchGetDevicePositionCommand");
parcelHelpers.exportAll(_batchGetDevicePositionCommand, exports);
var _batchPutGeofenceCommand = require("./BatchPutGeofenceCommand");
parcelHelpers.exportAll(_batchPutGeofenceCommand, exports);
var _batchUpdateDevicePositionCommand = require("./BatchUpdateDevicePositionCommand");
parcelHelpers.exportAll(_batchUpdateDevicePositionCommand, exports);
var _calculateRouteCommand = require("./CalculateRouteCommand");
parcelHelpers.exportAll(_calculateRouteCommand, exports);
var _calculateRouteMatrixCommand = require("./CalculateRouteMatrixCommand");
parcelHelpers.exportAll(_calculateRouteMatrixCommand, exports);
var _createGeofenceCollectionCommand = require("./CreateGeofenceCollectionCommand");
parcelHelpers.exportAll(_createGeofenceCollectionCommand, exports);
var _createMapCommand = require("./CreateMapCommand");
parcelHelpers.exportAll(_createMapCommand, exports);
var _createPlaceIndexCommand = require("./CreatePlaceIndexCommand");
parcelHelpers.exportAll(_createPlaceIndexCommand, exports);
var _createRouteCalculatorCommand = require("./CreateRouteCalculatorCommand");
parcelHelpers.exportAll(_createRouteCalculatorCommand, exports);
var _createTrackerCommand = require("./CreateTrackerCommand");
parcelHelpers.exportAll(_createTrackerCommand, exports);
var _deleteGeofenceCollectionCommand = require("./DeleteGeofenceCollectionCommand");
parcelHelpers.exportAll(_deleteGeofenceCollectionCommand, exports);
var _deleteMapCommand = require("./DeleteMapCommand");
parcelHelpers.exportAll(_deleteMapCommand, exports);
var _deletePlaceIndexCommand = require("./DeletePlaceIndexCommand");
parcelHelpers.exportAll(_deletePlaceIndexCommand, exports);
var _deleteRouteCalculatorCommand = require("./DeleteRouteCalculatorCommand");
parcelHelpers.exportAll(_deleteRouteCalculatorCommand, exports);
var _deleteTrackerCommand = require("./DeleteTrackerCommand");
parcelHelpers.exportAll(_deleteTrackerCommand, exports);
var _describeGeofenceCollectionCommand = require("./DescribeGeofenceCollectionCommand");
parcelHelpers.exportAll(_describeGeofenceCollectionCommand, exports);
var _describeMapCommand = require("./DescribeMapCommand");
parcelHelpers.exportAll(_describeMapCommand, exports);
var _describePlaceIndexCommand = require("./DescribePlaceIndexCommand");
parcelHelpers.exportAll(_describePlaceIndexCommand, exports);
var _describeRouteCalculatorCommand = require("./DescribeRouteCalculatorCommand");
parcelHelpers.exportAll(_describeRouteCalculatorCommand, exports);
var _describeTrackerCommand = require("./DescribeTrackerCommand");
parcelHelpers.exportAll(_describeTrackerCommand, exports);
var _disassociateTrackerConsumerCommand = require("./DisassociateTrackerConsumerCommand");
parcelHelpers.exportAll(_disassociateTrackerConsumerCommand, exports);
var _getDevicePositionCommand = require("./GetDevicePositionCommand");
parcelHelpers.exportAll(_getDevicePositionCommand, exports);
var _getDevicePositionHistoryCommand = require("./GetDevicePositionHistoryCommand");
parcelHelpers.exportAll(_getDevicePositionHistoryCommand, exports);
var _getGeofenceCommand = require("./GetGeofenceCommand");
parcelHelpers.exportAll(_getGeofenceCommand, exports);
var _getMapGlyphsCommand = require("./GetMapGlyphsCommand");
parcelHelpers.exportAll(_getMapGlyphsCommand, exports);
var _getMapSpritesCommand = require("./GetMapSpritesCommand");
parcelHelpers.exportAll(_getMapSpritesCommand, exports);
var _getMapStyleDescriptorCommand = require("./GetMapStyleDescriptorCommand");
parcelHelpers.exportAll(_getMapStyleDescriptorCommand, exports);
var _getMapTileCommand = require("./GetMapTileCommand");
parcelHelpers.exportAll(_getMapTileCommand, exports);
var _getPlaceCommand = require("./GetPlaceCommand");
parcelHelpers.exportAll(_getPlaceCommand, exports);
var _listDevicePositionsCommand = require("./ListDevicePositionsCommand");
parcelHelpers.exportAll(_listDevicePositionsCommand, exports);
var _listGeofenceCollectionsCommand = require("./ListGeofenceCollectionsCommand");
parcelHelpers.exportAll(_listGeofenceCollectionsCommand, exports);
var _listGeofencesCommand = require("./ListGeofencesCommand");
parcelHelpers.exportAll(_listGeofencesCommand, exports);
var _listMapsCommand = require("./ListMapsCommand");
parcelHelpers.exportAll(_listMapsCommand, exports);
var _listPlaceIndexesCommand = require("./ListPlaceIndexesCommand");
parcelHelpers.exportAll(_listPlaceIndexesCommand, exports);
var _listRouteCalculatorsCommand = require("./ListRouteCalculatorsCommand");
parcelHelpers.exportAll(_listRouteCalculatorsCommand, exports);
var _listTagsForResourceCommand = require("./ListTagsForResourceCommand");
parcelHelpers.exportAll(_listTagsForResourceCommand, exports);
var _listTrackerConsumersCommand = require("./ListTrackerConsumersCommand");
parcelHelpers.exportAll(_listTrackerConsumersCommand, exports);
var _listTrackersCommand = require("./ListTrackersCommand");
parcelHelpers.exportAll(_listTrackersCommand, exports);
var _putGeofenceCommand = require("./PutGeofenceCommand");
parcelHelpers.exportAll(_putGeofenceCommand, exports);
var _searchPlaceIndexForPositionCommand = require("./SearchPlaceIndexForPositionCommand");
parcelHelpers.exportAll(_searchPlaceIndexForPositionCommand, exports);
var _searchPlaceIndexForSuggestionsCommand = require("./SearchPlaceIndexForSuggestionsCommand");
parcelHelpers.exportAll(_searchPlaceIndexForSuggestionsCommand, exports);
var _searchPlaceIndexForTextCommand = require("./SearchPlaceIndexForTextCommand");
parcelHelpers.exportAll(_searchPlaceIndexForTextCommand, exports);
var _tagResourceCommand = require("./TagResourceCommand");
parcelHelpers.exportAll(_tagResourceCommand, exports);
var _untagResourceCommand = require("./UntagResourceCommand");
parcelHelpers.exportAll(_untagResourceCommand, exports);
var _updateGeofenceCollectionCommand = require("./UpdateGeofenceCollectionCommand");
parcelHelpers.exportAll(_updateGeofenceCollectionCommand, exports);
var _updateMapCommand = require("./UpdateMapCommand");
parcelHelpers.exportAll(_updateMapCommand, exports);
var _updatePlaceIndexCommand = require("./UpdatePlaceIndexCommand");
parcelHelpers.exportAll(_updatePlaceIndexCommand, exports);
var _updateRouteCalculatorCommand = require("./UpdateRouteCalculatorCommand");
parcelHelpers.exportAll(_updateRouteCalculatorCommand, exports);
var _updateTrackerCommand = require("./UpdateTrackerCommand");
parcelHelpers.exportAll(_updateTrackerCommand, exports);

},{"./AssociateTrackerConsumerCommand":false,"./BatchDeleteDevicePositionHistoryCommand":false,"./BatchDeleteGeofenceCommand":"f9QbY","./BatchEvaluateGeofencesCommand":false,"./BatchGetDevicePositionCommand":false,"./BatchPutGeofenceCommand":"6G5dO","./BatchUpdateDevicePositionCommand":false,"./CalculateRouteCommand":false,"./CalculateRouteMatrixCommand":false,"./CreateGeofenceCollectionCommand":false,"./CreateMapCommand":false,"./CreatePlaceIndexCommand":false,"./CreateRouteCalculatorCommand":false,"./CreateTrackerCommand":false,"./DeleteGeofenceCollectionCommand":false,"./DeleteMapCommand":false,"./DeletePlaceIndexCommand":false,"./DeleteRouteCalculatorCommand":false,"./DeleteTrackerCommand":false,"./DescribeGeofenceCollectionCommand":false,"./DescribeMapCommand":false,"./DescribePlaceIndexCommand":false,"./DescribeRouteCalculatorCommand":false,"./DescribeTrackerCommand":false,"./DisassociateTrackerConsumerCommand":false,"./GetDevicePositionCommand":false,"./GetDevicePositionHistoryCommand":false,"./GetGeofenceCommand":"4Sb9m","./GetMapGlyphsCommand":false,"./GetMapSpritesCommand":false,"./GetMapStyleDescriptorCommand":false,"./GetMapTileCommand":false,"./GetPlaceCommand":"aCfAq","./ListDevicePositionsCommand":false,"./ListGeofenceCollectionsCommand":false,"./ListGeofencesCommand":"c6YDt","./ListMapsCommand":false,"./ListPlaceIndexesCommand":false,"./ListRouteCalculatorsCommand":false,"./ListTagsForResourceCommand":false,"./ListTrackerConsumersCommand":false,"./ListTrackersCommand":false,"./PutGeofenceCommand":false,"./SearchPlaceIndexForPositionCommand":"8uRyG","./SearchPlaceIndexForSuggestionsCommand":"gEjA4","./SearchPlaceIndexForTextCommand":"aO5IJ","./TagResourceCommand":false,"./UntagResourceCommand":false,"./UpdateGeofenceCollectionCommand":false,"./UpdateMapCommand":false,"./UpdatePlaceIndexCommand":false,"./UpdateRouteCalculatorCommand":false,"./UpdateTrackerCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f9QbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchDeleteGeofenceCommand", function() {
    return BatchDeleteGeofenceCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchDeleteGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchDeleteGeofenceCommand, _super);
    function BatchDeleteGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchDeleteGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchDeleteGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchDeleteGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchDeleteGeofenceCommand)(input, context);
    };
    BatchDeleteGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchDeleteGeofenceCommand)(output, context);
    };
    return BatchDeleteGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"el26T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"3LlHo","./serdePlugin":"8H2p3","./serializerMiddleware":"l5WcC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LlHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", function() {
    return deserializerMiddleware;
});
var _tslib = require("tslib");
var deserializerMiddleware = function deserializerMiddleware(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8H2p3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", function() {
    return deserializerMiddlewareOption;
});
parcelHelpers.export(exports, "serializerMiddlewareOption", function() {
    return serializerMiddlewareOption;
});
parcelHelpers.export(exports, "getSerdePlugin", function() {
    return getSerdePlugin;
});
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function applyToStack(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"3LlHo","./serializerMiddleware":"l5WcC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5WcC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", function() {
    return serializerMiddleware;
});
var _tslib = require("tslib");
var serializerMiddleware = function serializerMiddleware(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function endpoint() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b7IJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessDeniedException", function() {
    return AccessDeniedException;
});
parcelHelpers.export(exports, "ConflictException", function() {
    return ConflictException;
});
parcelHelpers.export(exports, "InternalServerException", function() {
    return InternalServerException;
});
parcelHelpers.export(exports, "ResourceNotFoundException", function() {
    return ResourceNotFoundException;
});
parcelHelpers.export(exports, "ServiceQuotaExceededException", function() {
    return ServiceQuotaExceededException;
});
parcelHelpers.export(exports, "ThrottlingException", function() {
    return ThrottlingException;
});
parcelHelpers.export(exports, "ValidationException", function() {
    return ValidationException;
});
parcelHelpers.export(exports, "AssociateTrackerConsumerRequestFilterSensitiveLog", function() {
    return AssociateTrackerConsumerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "AssociateTrackerConsumerResponseFilterSensitiveLog", function() {
    return AssociateTrackerConsumerResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ValidationExceptionFieldFilterSensitiveLog", function() {
    return ValidationExceptionFieldFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog", function() {
    return BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchItemErrorFilterSensitiveLog", function() {
    return BatchItemErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog", function() {
    return BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog", function() {
    return BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteGeofenceRequestFilterSensitiveLog", function() {
    return BatchDeleteGeofenceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteGeofenceErrorFilterSensitiveLog", function() {
    return BatchDeleteGeofenceErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchDeleteGeofenceResponseFilterSensitiveLog", function() {
    return BatchDeleteGeofenceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PositionalAccuracyFilterSensitiveLog", function() {
    return PositionalAccuracyFilterSensitiveLog;
});
parcelHelpers.export(exports, "DevicePositionUpdateFilterSensitiveLog", function() {
    return DevicePositionUpdateFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchEvaluateGeofencesRequestFilterSensitiveLog", function() {
    return BatchEvaluateGeofencesRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchEvaluateGeofencesErrorFilterSensitiveLog", function() {
    return BatchEvaluateGeofencesErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchEvaluateGeofencesResponseFilterSensitiveLog", function() {
    return BatchEvaluateGeofencesResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchGetDevicePositionRequestFilterSensitiveLog", function() {
    return BatchGetDevicePositionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DevicePositionFilterSensitiveLog", function() {
    return DevicePositionFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchGetDevicePositionErrorFilterSensitiveLog", function() {
    return BatchGetDevicePositionErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchGetDevicePositionResponseFilterSensitiveLog", function() {
    return BatchGetDevicePositionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CircleFilterSensitiveLog", function() {
    return CircleFilterSensitiveLog;
});
parcelHelpers.export(exports, "GeofenceGeometryFilterSensitiveLog", function() {
    return GeofenceGeometryFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchPutGeofenceRequestEntryFilterSensitiveLog", function() {
    return BatchPutGeofenceRequestEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchPutGeofenceRequestFilterSensitiveLog", function() {
    return BatchPutGeofenceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchPutGeofenceErrorFilterSensitiveLog", function() {
    return BatchPutGeofenceErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchPutGeofenceSuccessFilterSensitiveLog", function() {
    return BatchPutGeofenceSuccessFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchPutGeofenceResponseFilterSensitiveLog", function() {
    return BatchPutGeofenceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchUpdateDevicePositionRequestFilterSensitiveLog", function() {
    return BatchUpdateDevicePositionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchUpdateDevicePositionErrorFilterSensitiveLog", function() {
    return BatchUpdateDevicePositionErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "BatchUpdateDevicePositionResponseFilterSensitiveLog", function() {
    return BatchUpdateDevicePositionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteCarModeOptionsFilterSensitiveLog", function() {
    return CalculateRouteCarModeOptionsFilterSensitiveLog;
});
parcelHelpers.export(exports, "TruckDimensionsFilterSensitiveLog", function() {
    return TruckDimensionsFilterSensitiveLog;
});
parcelHelpers.export(exports, "TruckWeightFilterSensitiveLog", function() {
    return TruckWeightFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteTruckModeOptionsFilterSensitiveLog", function() {
    return CalculateRouteTruckModeOptionsFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteRequestFilterSensitiveLog", function() {
    return CalculateRouteRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "LegGeometryFilterSensitiveLog", function() {
    return LegGeometryFilterSensitiveLog;
});
parcelHelpers.export(exports, "StepFilterSensitiveLog", function() {
    return StepFilterSensitiveLog;
});
parcelHelpers.export(exports, "LegFilterSensitiveLog", function() {
    return LegFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteSummaryFilterSensitiveLog", function() {
    return CalculateRouteSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteResponseFilterSensitiveLog", function() {
    return CalculateRouteResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteMatrixRequestFilterSensitiveLog", function() {
    return CalculateRouteMatrixRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "RouteMatrixEntryErrorFilterSensitiveLog", function() {
    return RouteMatrixEntryErrorFilterSensitiveLog;
});
parcelHelpers.export(exports, "RouteMatrixEntryFilterSensitiveLog", function() {
    return RouteMatrixEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteMatrixSummaryFilterSensitiveLog", function() {
    return CalculateRouteMatrixSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "CalculateRouteMatrixResponseFilterSensitiveLog", function() {
    return CalculateRouteMatrixResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateGeofenceCollectionRequestFilterSensitiveLog", function() {
    return CreateGeofenceCollectionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateGeofenceCollectionResponseFilterSensitiveLog", function() {
    return CreateGeofenceCollectionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "MapConfigurationFilterSensitiveLog", function() {
    return MapConfigurationFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateMapRequestFilterSensitiveLog", function() {
    return CreateMapRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateMapResponseFilterSensitiveLog", function() {
    return CreateMapResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DataSourceConfigurationFilterSensitiveLog", function() {
    return DataSourceConfigurationFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreatePlaceIndexRequestFilterSensitiveLog", function() {
    return CreatePlaceIndexRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreatePlaceIndexResponseFilterSensitiveLog", function() {
    return CreatePlaceIndexResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateRouteCalculatorRequestFilterSensitiveLog", function() {
    return CreateRouteCalculatorRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateRouteCalculatorResponseFilterSensitiveLog", function() {
    return CreateRouteCalculatorResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateTrackerRequestFilterSensitiveLog", function() {
    return CreateTrackerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "CreateTrackerResponseFilterSensitiveLog", function() {
    return CreateTrackerResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteGeofenceCollectionRequestFilterSensitiveLog", function() {
    return DeleteGeofenceCollectionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteGeofenceCollectionResponseFilterSensitiveLog", function() {
    return DeleteGeofenceCollectionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteMapRequestFilterSensitiveLog", function() {
    return DeleteMapRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteMapResponseFilterSensitiveLog", function() {
    return DeleteMapResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeletePlaceIndexRequestFilterSensitiveLog", function() {
    return DeletePlaceIndexRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeletePlaceIndexResponseFilterSensitiveLog", function() {
    return DeletePlaceIndexResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteRouteCalculatorRequestFilterSensitiveLog", function() {
    return DeleteRouteCalculatorRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteRouteCalculatorResponseFilterSensitiveLog", function() {
    return DeleteRouteCalculatorResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteTrackerRequestFilterSensitiveLog", function() {
    return DeleteTrackerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DeleteTrackerResponseFilterSensitiveLog", function() {
    return DeleteTrackerResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeGeofenceCollectionRequestFilterSensitiveLog", function() {
    return DescribeGeofenceCollectionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeGeofenceCollectionResponseFilterSensitiveLog", function() {
    return DescribeGeofenceCollectionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeMapRequestFilterSensitiveLog", function() {
    return DescribeMapRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeMapResponseFilterSensitiveLog", function() {
    return DescribeMapResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribePlaceIndexRequestFilterSensitiveLog", function() {
    return DescribePlaceIndexRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribePlaceIndexResponseFilterSensitiveLog", function() {
    return DescribePlaceIndexResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeRouteCalculatorRequestFilterSensitiveLog", function() {
    return DescribeRouteCalculatorRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeRouteCalculatorResponseFilterSensitiveLog", function() {
    return DescribeRouteCalculatorResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeTrackerRequestFilterSensitiveLog", function() {
    return DescribeTrackerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DescribeTrackerResponseFilterSensitiveLog", function() {
    return DescribeTrackerResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "DisassociateTrackerConsumerRequestFilterSensitiveLog", function() {
    return DisassociateTrackerConsumerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "DisassociateTrackerConsumerResponseFilterSensitiveLog", function() {
    return DisassociateTrackerConsumerResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTagsForResourceRequestFilterSensitiveLog", function() {
    return ListTagsForResourceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTagsForResourceResponseFilterSensitiveLog", function() {
    return ListTagsForResourceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "TagResourceRequestFilterSensitiveLog", function() {
    return TagResourceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "TagResourceResponseFilterSensitiveLog", function() {
    return TagResourceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UntagResourceRequestFilterSensitiveLog", function() {
    return UntagResourceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UntagResourceResponseFilterSensitiveLog", function() {
    return UntagResourceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetGeofenceRequestFilterSensitiveLog", function() {
    return GetGeofenceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetGeofenceResponseFilterSensitiveLog", function() {
    return GetGeofenceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofenceCollectionsRequestFilterSensitiveLog", function() {
    return ListGeofenceCollectionsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseEntryFilterSensitiveLog", function() {
    return ListGeofenceCollectionsResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseFilterSensitiveLog", function() {
    return ListGeofenceCollectionsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofencesRequestFilterSensitiveLog", function() {
    return ListGeofencesRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofenceResponseEntryFilterSensitiveLog", function() {
    return ListGeofenceResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListGeofencesResponseFilterSensitiveLog", function() {
    return ListGeofencesResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutGeofenceRequestFilterSensitiveLog", function() {
    return PutGeofenceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "PutGeofenceResponseFilterSensitiveLog", function() {
    return PutGeofenceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateGeofenceCollectionRequestFilterSensitiveLog", function() {
    return UpdateGeofenceCollectionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateGeofenceCollectionResponseFilterSensitiveLog", function() {
    return UpdateGeofenceCollectionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetDevicePositionRequestFilterSensitiveLog", function() {
    return GetDevicePositionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetDevicePositionResponseFilterSensitiveLog", function() {
    return GetDevicePositionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetDevicePositionHistoryRequestFilterSensitiveLog", function() {
    return GetDevicePositionHistoryRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetDevicePositionHistoryResponseFilterSensitiveLog", function() {
    return GetDevicePositionHistoryResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapGlyphsRequestFilterSensitiveLog", function() {
    return GetMapGlyphsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapGlyphsResponseFilterSensitiveLog", function() {
    return GetMapGlyphsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapSpritesRequestFilterSensitiveLog", function() {
    return GetMapSpritesRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapSpritesResponseFilterSensitiveLog", function() {
    return GetMapSpritesResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapStyleDescriptorRequestFilterSensitiveLog", function() {
    return GetMapStyleDescriptorRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapStyleDescriptorResponseFilterSensitiveLog", function() {
    return GetMapStyleDescriptorResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapTileRequestFilterSensitiveLog", function() {
    return GetMapTileRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetMapTileResponseFilterSensitiveLog", function() {
    return GetMapTileResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetPlaceRequestFilterSensitiveLog", function() {
    return GetPlaceRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "PlaceGeometryFilterSensitiveLog", function() {
    return PlaceGeometryFilterSensitiveLog;
});
parcelHelpers.export(exports, "TimeZoneFilterSensitiveLog", function() {
    return TimeZoneFilterSensitiveLog;
});
parcelHelpers.export(exports, "PlaceFilterSensitiveLog", function() {
    return PlaceFilterSensitiveLog;
});
parcelHelpers.export(exports, "GetPlaceResponseFilterSensitiveLog", function() {
    return GetPlaceResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListDevicePositionsRequestFilterSensitiveLog", function() {
    return ListDevicePositionsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListDevicePositionsResponseEntryFilterSensitiveLog", function() {
    return ListDevicePositionsResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListDevicePositionsResponseFilterSensitiveLog", function() {
    return ListDevicePositionsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListMapsRequestFilterSensitiveLog", function() {
    return ListMapsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListMapsResponseEntryFilterSensitiveLog", function() {
    return ListMapsResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListMapsResponseFilterSensitiveLog", function() {
    return ListMapsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListPlaceIndexesRequestFilterSensitiveLog", function() {
    return ListPlaceIndexesRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListPlaceIndexesResponseEntryFilterSensitiveLog", function() {
    return ListPlaceIndexesResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListPlaceIndexesResponseFilterSensitiveLog", function() {
    return ListPlaceIndexesResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListRouteCalculatorsRequestFilterSensitiveLog", function() {
    return ListRouteCalculatorsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListRouteCalculatorsResponseEntryFilterSensitiveLog", function() {
    return ListRouteCalculatorsResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListRouteCalculatorsResponseFilterSensitiveLog", function() {
    return ListRouteCalculatorsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTrackerConsumersRequestFilterSensitiveLog", function() {
    return ListTrackerConsumersRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTrackerConsumersResponseFilterSensitiveLog", function() {
    return ListTrackerConsumersResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTrackersRequestFilterSensitiveLog", function() {
    return ListTrackersRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTrackersResponseEntryFilterSensitiveLog", function() {
    return ListTrackersResponseEntryFilterSensitiveLog;
});
parcelHelpers.export(exports, "ListTrackersResponseFilterSensitiveLog", function() {
    return ListTrackersResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateMapRequestFilterSensitiveLog", function() {
    return UpdateMapRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateMapResponseFilterSensitiveLog", function() {
    return UpdateMapResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForPositionRequestFilterSensitiveLog", function() {
    return SearchPlaceIndexForPositionRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchForPositionResultFilterSensitiveLog", function() {
    return SearchForPositionResultFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForPositionSummaryFilterSensitiveLog", function() {
    return SearchPlaceIndexForPositionSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForPositionResponseFilterSensitiveLog", function() {
    return SearchPlaceIndexForPositionResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog", function() {
    return SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchForSuggestionsResultFilterSensitiveLog", function() {
    return SearchForSuggestionsResultFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog", function() {
    return SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog", function() {
    return SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForTextRequestFilterSensitiveLog", function() {
    return SearchPlaceIndexForTextRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchForTextResultFilterSensitiveLog", function() {
    return SearchForTextResultFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForTextSummaryFilterSensitiveLog", function() {
    return SearchPlaceIndexForTextSummaryFilterSensitiveLog;
});
parcelHelpers.export(exports, "SearchPlaceIndexForTextResponseFilterSensitiveLog", function() {
    return SearchPlaceIndexForTextResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdatePlaceIndexRequestFilterSensitiveLog", function() {
    return UpdatePlaceIndexRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdatePlaceIndexResponseFilterSensitiveLog", function() {
    return UpdatePlaceIndexResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateRouteCalculatorRequestFilterSensitiveLog", function() {
    return UpdateRouteCalculatorRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateRouteCalculatorResponseFilterSensitiveLog", function() {
    return UpdateRouteCalculatorResponseFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateTrackerRequestFilterSensitiveLog", function() {
    return UpdateTrackerRequestFilterSensitiveLog;
});
parcelHelpers.export(exports, "UpdateTrackerResponseFilterSensitiveLog", function() {
    return UpdateTrackerResponseFilterSensitiveLog;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("./LocationServiceException");
var AccessDeniedException = function(_super) {
    (0, _tslib.__extends)(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "AccessDeniedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return AccessDeniedException;
}((0, _locationServiceException.LocationServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConflictException;
}((0, _locationServiceException.LocationServiceException));
var InternalServerException = function(_super) {
    (0, _tslib.__extends)(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalServerException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalServerException;
}((0, _locationServiceException.LocationServiceException));
var ResourceNotFoundException = function(_super) {
    (0, _tslib.__extends)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotFoundException;
}((0, _locationServiceException.LocationServiceException));
var ServiceQuotaExceededException = function(_super) {
    (0, _tslib.__extends)(ServiceQuotaExceededException, _super);
    function ServiceQuotaExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ServiceQuotaExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ServiceQuotaExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ServiceQuotaExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ServiceQuotaExceededException;
}((0, _locationServiceException.LocationServiceException));
var ThrottlingException = function(_super) {
    (0, _tslib.__extends)(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ThrottlingException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ThrottlingException;
}((0, _locationServiceException.LocationServiceException));
var ValidationException = function(_super) {
    (0, _tslib.__extends)(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ValidationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        _this.Reason = opts.Reason;
        _this.FieldList = opts.FieldList;
        return _this;
    }
    return ValidationException;
}((0, _locationServiceException.LocationServiceException));
var AssociateTrackerConsumerRequestFilterSensitiveLog = function AssociateTrackerConsumerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var AssociateTrackerConsumerResponseFilterSensitiveLog = function AssociateTrackerConsumerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ValidationExceptionFieldFilterSensitiveLog = function ValidationExceptionFieldFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog = function BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchItemErrorFilterSensitiveLog = function BatchItemErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog = function BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog = function BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceRequestFilterSensitiveLog = function BatchDeleteGeofenceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceErrorFilterSensitiveLog = function BatchDeleteGeofenceErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceResponseFilterSensitiveLog = function BatchDeleteGeofenceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PositionalAccuracyFilterSensitiveLog = function PositionalAccuracyFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionUpdateFilterSensitiveLog = function DevicePositionUpdateFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchEvaluateGeofencesRequestFilterSensitiveLog = function BatchEvaluateGeofencesRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositionUpdates && {
        DevicePositionUpdates: obj.DevicePositionUpdates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchEvaluateGeofencesErrorFilterSensitiveLog = function BatchEvaluateGeofencesErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchEvaluateGeofencesResponseFilterSensitiveLog = function BatchEvaluateGeofencesResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionRequestFilterSensitiveLog = function BatchGetDevicePositionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionFilterSensitiveLog = function DevicePositionFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchGetDevicePositionErrorFilterSensitiveLog = function BatchGetDevicePositionErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionResponseFilterSensitiveLog = function BatchGetDevicePositionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var CircleFilterSensitiveLog = function CircleFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Center && {
        Center: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GeofenceGeometryFilterSensitiveLog = function GeofenceGeometryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Polygon && {
        Polygon: obj.Polygon.map(function(item) {
            return 0, _smithyClient.SENSITIVE_STRING;
        })
    }), obj.Circle && {
        Circle: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchPutGeofenceRequestEntryFilterSensitiveLog = function BatchPutGeofenceRequestEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var BatchPutGeofenceRequestFilterSensitiveLog = function BatchPutGeofenceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return BatchPutGeofenceRequestEntryFilterSensitiveLog(item);
        })
    });
};
var BatchPutGeofenceErrorFilterSensitiveLog = function BatchPutGeofenceErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceSuccessFilterSensitiveLog = function BatchPutGeofenceSuccessFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceResponseFilterSensitiveLog = function BatchPutGeofenceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionRequestFilterSensitiveLog = function BatchUpdateDevicePositionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Updates && {
        Updates: obj.Updates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchUpdateDevicePositionErrorFilterSensitiveLog = function BatchUpdateDevicePositionErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionResponseFilterSensitiveLog = function BatchUpdateDevicePositionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteCarModeOptionsFilterSensitiveLog = function CalculateRouteCarModeOptionsFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckDimensionsFilterSensitiveLog = function TruckDimensionsFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckWeightFilterSensitiveLog = function TruckWeightFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteTruckModeOptionsFilterSensitiveLog = function CalculateRouteTruckModeOptionsFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteRequestFilterSensitiveLog = function CalculateRouteRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePosition && {
        DeparturePosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPosition && {
        DestinationPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.WaypointPositions && {
        WaypointPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegGeometryFilterSensitiveLog = function LegGeometryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.LineString && {
        LineString: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var StepFilterSensitiveLog = function StepFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegFilterSensitiveLog = function LegFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.Geometry && {
        Geometry: LegGeometryFilterSensitiveLog(obj.Geometry)
    }), obj.Steps && {
        Steps: obj.Steps.map(function(item) {
            return StepFilterSensitiveLog(item);
        })
    });
};
var CalculateRouteSummaryFilterSensitiveLog = function CalculateRouteSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RouteBBox && {
        RouteBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CalculateRouteResponseFilterSensitiveLog = function CalculateRouteResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Legs && {
        Legs: obj.Legs.map(function(item) {
            return LegFilterSensitiveLog(item);
        })
    }), obj.Summary && {
        Summary: CalculateRouteSummaryFilterSensitiveLog(obj.Summary)
    });
};
var CalculateRouteMatrixRequestFilterSensitiveLog = function CalculateRouteMatrixRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePositions && {
        DeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPositions && {
        DestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var RouteMatrixEntryErrorFilterSensitiveLog = function RouteMatrixEntryErrorFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RouteMatrixEntryFilterSensitiveLog = function RouteMatrixEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixSummaryFilterSensitiveLog = function CalculateRouteMatrixSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixResponseFilterSensitiveLog = function CalculateRouteMatrixResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.SnappedDeparturePositions && {
        SnappedDeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.SnappedDestinationPositions && {
        SnappedDestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CreateGeofenceCollectionRequestFilterSensitiveLog = function CreateGeofenceCollectionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateGeofenceCollectionResponseFilterSensitiveLog = function CreateGeofenceCollectionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var MapConfigurationFilterSensitiveLog = function MapConfigurationFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapRequestFilterSensitiveLog = function CreateMapRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapResponseFilterSensitiveLog = function CreateMapResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DataSourceConfigurationFilterSensitiveLog = function DataSourceConfigurationFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexRequestFilterSensitiveLog = function CreatePlaceIndexRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexResponseFilterSensitiveLog = function CreatePlaceIndexResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorRequestFilterSensitiveLog = function CreateRouteCalculatorRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorResponseFilterSensitiveLog = function CreateRouteCalculatorResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerRequestFilterSensitiveLog = function CreateTrackerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerResponseFilterSensitiveLog = function CreateTrackerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionRequestFilterSensitiveLog = function DeleteGeofenceCollectionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionResponseFilterSensitiveLog = function DeleteGeofenceCollectionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapRequestFilterSensitiveLog = function DeleteMapRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapResponseFilterSensitiveLog = function DeleteMapResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexRequestFilterSensitiveLog = function DeletePlaceIndexRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexResponseFilterSensitiveLog = function DeletePlaceIndexResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorRequestFilterSensitiveLog = function DeleteRouteCalculatorRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorResponseFilterSensitiveLog = function DeleteRouteCalculatorResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerRequestFilterSensitiveLog = function DeleteTrackerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerResponseFilterSensitiveLog = function DeleteTrackerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionRequestFilterSensitiveLog = function DescribeGeofenceCollectionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionResponseFilterSensitiveLog = function DescribeGeofenceCollectionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapRequestFilterSensitiveLog = function DescribeMapRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapResponseFilterSensitiveLog = function DescribeMapResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexRequestFilterSensitiveLog = function DescribePlaceIndexRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexResponseFilterSensitiveLog = function DescribePlaceIndexResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorRequestFilterSensitiveLog = function DescribeRouteCalculatorRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorResponseFilterSensitiveLog = function DescribeRouteCalculatorResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerRequestFilterSensitiveLog = function DescribeTrackerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerResponseFilterSensitiveLog = function DescribeTrackerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerRequestFilterSensitiveLog = function DisassociateTrackerConsumerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerResponseFilterSensitiveLog = function DisassociateTrackerConsumerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceRequestFilterSensitiveLog = function ListTagsForResourceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceResponseFilterSensitiveLog = function ListTagsForResourceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceRequestFilterSensitiveLog = function TagResourceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceResponseFilterSensitiveLog = function TagResourceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceRequestFilterSensitiveLog = function UntagResourceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceResponseFilterSensitiveLog = function UntagResourceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceRequestFilterSensitiveLog = function GetGeofenceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceResponseFilterSensitiveLog = function GetGeofenceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofenceCollectionsRequestFilterSensitiveLog = function ListGeofenceCollectionsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseEntryFilterSensitiveLog = function ListGeofenceCollectionsResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseFilterSensitiveLog = function ListGeofenceCollectionsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofencesRequestFilterSensitiveLog = function ListGeofencesRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceResponseEntryFilterSensitiveLog = function ListGeofenceResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofencesResponseFilterSensitiveLog = function ListGeofencesResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListGeofenceResponseEntryFilterSensitiveLog(item);
        })
    });
};
var PutGeofenceRequestFilterSensitiveLog = function PutGeofenceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var PutGeofenceResponseFilterSensitiveLog = function PutGeofenceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionRequestFilterSensitiveLog = function UpdateGeofenceCollectionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionResponseFilterSensitiveLog = function UpdateGeofenceCollectionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionRequestFilterSensitiveLog = function GetDevicePositionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionResponseFilterSensitiveLog = function GetDevicePositionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetDevicePositionHistoryRequestFilterSensitiveLog = function GetDevicePositionHistoryRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionHistoryResponseFilterSensitiveLog = function GetDevicePositionHistoryResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var GetMapGlyphsRequestFilterSensitiveLog = function GetMapGlyphsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapGlyphsResponseFilterSensitiveLog = function GetMapGlyphsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesRequestFilterSensitiveLog = function GetMapSpritesRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesResponseFilterSensitiveLog = function GetMapSpritesResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorRequestFilterSensitiveLog = function GetMapStyleDescriptorRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorResponseFilterSensitiveLog = function GetMapStyleDescriptorResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileRequestFilterSensitiveLog = function GetMapTileRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileResponseFilterSensitiveLog = function GetMapTileResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetPlaceRequestFilterSensitiveLog = function GetPlaceRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceGeometryFilterSensitiveLog = function PlaceGeometryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Point && {
        Point: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var TimeZoneFilterSensitiveLog = function TimeZoneFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceFilterSensitiveLog = function PlaceFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: PlaceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var GetPlaceResponseFilterSensitiveLog = function GetPlaceResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var ListDevicePositionsRequestFilterSensitiveLog = function ListDevicePositionsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListDevicePositionsResponseEntryFilterSensitiveLog = function ListDevicePositionsResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ListDevicePositionsResponseFilterSensitiveLog = function ListDevicePositionsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListDevicePositionsResponseEntryFilterSensitiveLog(item);
        })
    });
};
var ListMapsRequestFilterSensitiveLog = function ListMapsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseEntryFilterSensitiveLog = function ListMapsResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseFilterSensitiveLog = function ListMapsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesRequestFilterSensitiveLog = function ListPlaceIndexesRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseEntryFilterSensitiveLog = function ListPlaceIndexesResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseFilterSensitiveLog = function ListPlaceIndexesResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsRequestFilterSensitiveLog = function ListRouteCalculatorsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseEntryFilterSensitiveLog = function ListRouteCalculatorsResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseFilterSensitiveLog = function ListRouteCalculatorsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersRequestFilterSensitiveLog = function ListTrackerConsumersRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersResponseFilterSensitiveLog = function ListTrackerConsumersResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersRequestFilterSensitiveLog = function ListTrackersRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseEntryFilterSensitiveLog = function ListTrackersResponseEntryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseFilterSensitiveLog = function ListTrackersResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapRequestFilterSensitiveLog = function UpdateMapRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapResponseFilterSensitiveLog = function UpdateMapResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForPositionRequestFilterSensitiveLog = function SearchPlaceIndexForPositionRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForPositionResultFilterSensitiveLog = function SearchForPositionResultFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForPositionSummaryFilterSensitiveLog = function SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForPositionResponseFilterSensitiveLog = function SearchPlaceIndexForPositionResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForPositionResultFilterSensitiveLog(item);
        })
    });
};
var SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog = function SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForSuggestionsResultFilterSensitiveLog = function SearchForSuggestionsResultFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog = function SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog = function SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj.Summary)
    });
};
var SearchPlaceIndexForTextRequestFilterSensitiveLog = function SearchPlaceIndexForTextRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForTextResultFilterSensitiveLog = function SearchForTextResultFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForTextSummaryFilterSensitiveLog = function SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.ResultBBox && {
        ResultBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForTextResponseFilterSensitiveLog = function SearchPlaceIndexForTextResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForTextResultFilterSensitiveLog(item);
        })
    });
};
var UpdatePlaceIndexRequestFilterSensitiveLog = function UpdatePlaceIndexRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdatePlaceIndexResponseFilterSensitiveLog = function UpdatePlaceIndexResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorRequestFilterSensitiveLog = function UpdateRouteCalculatorRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorResponseFilterSensitiveLog = function UpdateRouteCalculatorResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerRequestFilterSensitiveLog = function UpdateTrackerRequestFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerResponseFilterSensitiveLog = function UpdateTrackerResponseFilterSensitiveLog(obj) {
    return (0, _tslib.__assign)({}, obj);
};

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6yS5y","./LocationServiceException":"g5vja","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g5vja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", function() {
    return LocationServiceException;
});
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LocationServiceException = function(_super) {
    (0, _tslib.__extends)(LocationServiceException, _super);
    function LocationServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LocationServiceException.prototype);
        return _this;
    }
    return LocationServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6yS5y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"76VEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1AssociateTrackerConsumerCommand", function() {
    return serializeAws_restJson1AssociateTrackerConsumerCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", function() {
    return serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteGeofenceCommand", function() {
    return serializeAws_restJson1BatchDeleteGeofenceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchEvaluateGeofencesCommand", function() {
    return serializeAws_restJson1BatchEvaluateGeofencesCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchGetDevicePositionCommand", function() {
    return serializeAws_restJson1BatchGetDevicePositionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchPutGeofenceCommand", function() {
    return serializeAws_restJson1BatchPutGeofenceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1BatchUpdateDevicePositionCommand", function() {
    return serializeAws_restJson1BatchUpdateDevicePositionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteCommand", function() {
    return serializeAws_restJson1CalculateRouteCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteMatrixCommand", function() {
    return serializeAws_restJson1CalculateRouteMatrixCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CreateGeofenceCollectionCommand", function() {
    return serializeAws_restJson1CreateGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CreateMapCommand", function() {
    return serializeAws_restJson1CreateMapCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CreatePlaceIndexCommand", function() {
    return serializeAws_restJson1CreatePlaceIndexCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CreateRouteCalculatorCommand", function() {
    return serializeAws_restJson1CreateRouteCalculatorCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1CreateTrackerCommand", function() {
    return serializeAws_restJson1CreateTrackerCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DeleteGeofenceCollectionCommand", function() {
    return serializeAws_restJson1DeleteGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DeleteMapCommand", function() {
    return serializeAws_restJson1DeleteMapCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DeletePlaceIndexCommand", function() {
    return serializeAws_restJson1DeletePlaceIndexCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DeleteRouteCalculatorCommand", function() {
    return serializeAws_restJson1DeleteRouteCalculatorCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DeleteTrackerCommand", function() {
    return serializeAws_restJson1DeleteTrackerCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DescribeGeofenceCollectionCommand", function() {
    return serializeAws_restJson1DescribeGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DescribeMapCommand", function() {
    return serializeAws_restJson1DescribeMapCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DescribePlaceIndexCommand", function() {
    return serializeAws_restJson1DescribePlaceIndexCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DescribeRouteCalculatorCommand", function() {
    return serializeAws_restJson1DescribeRouteCalculatorCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DescribeTrackerCommand", function() {
    return serializeAws_restJson1DescribeTrackerCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1DisassociateTrackerConsumerCommand", function() {
    return serializeAws_restJson1DisassociateTrackerConsumerCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionCommand", function() {
    return serializeAws_restJson1GetDevicePositionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionHistoryCommand", function() {
    return serializeAws_restJson1GetDevicePositionHistoryCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetGeofenceCommand", function() {
    return serializeAws_restJson1GetGeofenceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetMapGlyphsCommand", function() {
    return serializeAws_restJson1GetMapGlyphsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetMapSpritesCommand", function() {
    return serializeAws_restJson1GetMapSpritesCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetMapStyleDescriptorCommand", function() {
    return serializeAws_restJson1GetMapStyleDescriptorCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetMapTileCommand", function() {
    return serializeAws_restJson1GetMapTileCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1GetPlaceCommand", function() {
    return serializeAws_restJson1GetPlaceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListDevicePositionsCommand", function() {
    return serializeAws_restJson1ListDevicePositionsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofenceCollectionsCommand", function() {
    return serializeAws_restJson1ListGeofenceCollectionsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofencesCommand", function() {
    return serializeAws_restJson1ListGeofencesCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListMapsCommand", function() {
    return serializeAws_restJson1ListMapsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListPlaceIndexesCommand", function() {
    return serializeAws_restJson1ListPlaceIndexesCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListRouteCalculatorsCommand", function() {
    return serializeAws_restJson1ListRouteCalculatorsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListTagsForResourceCommand", function() {
    return serializeAws_restJson1ListTagsForResourceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackerConsumersCommand", function() {
    return serializeAws_restJson1ListTrackerConsumersCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackersCommand", function() {
    return serializeAws_restJson1ListTrackersCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1PutGeofenceCommand", function() {
    return serializeAws_restJson1PutGeofenceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForPositionCommand", function() {
    return serializeAws_restJson1SearchPlaceIndexForPositionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", function() {
    return serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForTextCommand", function() {
    return serializeAws_restJson1SearchPlaceIndexForTextCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1TagResourceCommand", function() {
    return serializeAws_restJson1TagResourceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UntagResourceCommand", function() {
    return serializeAws_restJson1UntagResourceCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UpdateGeofenceCollectionCommand", function() {
    return serializeAws_restJson1UpdateGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UpdateMapCommand", function() {
    return serializeAws_restJson1UpdateMapCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UpdatePlaceIndexCommand", function() {
    return serializeAws_restJson1UpdatePlaceIndexCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UpdateRouteCalculatorCommand", function() {
    return serializeAws_restJson1UpdateRouteCalculatorCommand;
});
parcelHelpers.export(exports, "serializeAws_restJson1UpdateTrackerCommand", function() {
    return serializeAws_restJson1UpdateTrackerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1AssociateTrackerConsumerCommand", function() {
    return deserializeAws_restJson1AssociateTrackerConsumerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", function() {
    return deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteGeofenceCommand", function() {
    return deserializeAws_restJson1BatchDeleteGeofenceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchEvaluateGeofencesCommand", function() {
    return deserializeAws_restJson1BatchEvaluateGeofencesCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchGetDevicePositionCommand", function() {
    return deserializeAws_restJson1BatchGetDevicePositionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchPutGeofenceCommand", function() {
    return deserializeAws_restJson1BatchPutGeofenceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1BatchUpdateDevicePositionCommand", function() {
    return deserializeAws_restJson1BatchUpdateDevicePositionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteCommand", function() {
    return deserializeAws_restJson1CalculateRouteCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteMatrixCommand", function() {
    return deserializeAws_restJson1CalculateRouteMatrixCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CreateGeofenceCollectionCommand", function() {
    return deserializeAws_restJson1CreateGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CreateMapCommand", function() {
    return deserializeAws_restJson1CreateMapCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CreatePlaceIndexCommand", function() {
    return deserializeAws_restJson1CreatePlaceIndexCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CreateRouteCalculatorCommand", function() {
    return deserializeAws_restJson1CreateRouteCalculatorCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1CreateTrackerCommand", function() {
    return deserializeAws_restJson1CreateTrackerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteGeofenceCollectionCommand", function() {
    return deserializeAws_restJson1DeleteGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteMapCommand", function() {
    return deserializeAws_restJson1DeleteMapCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeletePlaceIndexCommand", function() {
    return deserializeAws_restJson1DeletePlaceIndexCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteRouteCalculatorCommand", function() {
    return deserializeAws_restJson1DeleteRouteCalculatorCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteTrackerCommand", function() {
    return deserializeAws_restJson1DeleteTrackerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeGeofenceCollectionCommand", function() {
    return deserializeAws_restJson1DescribeGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeMapCommand", function() {
    return deserializeAws_restJson1DescribeMapCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DescribePlaceIndexCommand", function() {
    return deserializeAws_restJson1DescribePlaceIndexCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeRouteCalculatorCommand", function() {
    return deserializeAws_restJson1DescribeRouteCalculatorCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeTrackerCommand", function() {
    return deserializeAws_restJson1DescribeTrackerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1DisassociateTrackerConsumerCommand", function() {
    return deserializeAws_restJson1DisassociateTrackerConsumerCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionCommand", function() {
    return deserializeAws_restJson1GetDevicePositionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionHistoryCommand", function() {
    return deserializeAws_restJson1GetDevicePositionHistoryCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetGeofenceCommand", function() {
    return deserializeAws_restJson1GetGeofenceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapGlyphsCommand", function() {
    return deserializeAws_restJson1GetMapGlyphsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapSpritesCommand", function() {
    return deserializeAws_restJson1GetMapSpritesCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapStyleDescriptorCommand", function() {
    return deserializeAws_restJson1GetMapStyleDescriptorCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapTileCommand", function() {
    return deserializeAws_restJson1GetMapTileCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1GetPlaceCommand", function() {
    return deserializeAws_restJson1GetPlaceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListDevicePositionsCommand", function() {
    return deserializeAws_restJson1ListDevicePositionsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofenceCollectionsCommand", function() {
    return deserializeAws_restJson1ListGeofenceCollectionsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofencesCommand", function() {
    return deserializeAws_restJson1ListGeofencesCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListMapsCommand", function() {
    return deserializeAws_restJson1ListMapsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListPlaceIndexesCommand", function() {
    return deserializeAws_restJson1ListPlaceIndexesCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListRouteCalculatorsCommand", function() {
    return deserializeAws_restJson1ListRouteCalculatorsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListTagsForResourceCommand", function() {
    return deserializeAws_restJson1ListTagsForResourceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackerConsumersCommand", function() {
    return deserializeAws_restJson1ListTrackerConsumersCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackersCommand", function() {
    return deserializeAws_restJson1ListTrackersCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1PutGeofenceCommand", function() {
    return deserializeAws_restJson1PutGeofenceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForPositionCommand", function() {
    return deserializeAws_restJson1SearchPlaceIndexForPositionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", function() {
    return deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForTextCommand", function() {
    return deserializeAws_restJson1SearchPlaceIndexForTextCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1TagResourceCommand", function() {
    return deserializeAws_restJson1TagResourceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UntagResourceCommand", function() {
    return deserializeAws_restJson1UntagResourceCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateGeofenceCollectionCommand", function() {
    return deserializeAws_restJson1UpdateGeofenceCollectionCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateMapCommand", function() {
    return deserializeAws_restJson1UpdateMapCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UpdatePlaceIndexCommand", function() {
    return deserializeAws_restJson1UpdatePlaceIndexCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateRouteCalculatorCommand", function() {
    return deserializeAws_restJson1UpdateRouteCalculatorCommand;
});
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateTrackerCommand", function() {
    return deserializeAws_restJson1UpdateTrackerCommand;
});
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("../models/LocationServiceException");
var _models0 = require("../models/models_0");
var serializeAws_restJson1AssociateTrackerConsumerCommand = function serializeAws_restJson1AssociateTrackerConsumerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.ConsumerArn != null && {
                        ConsumerArn: input.ConsumerArn
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/delete-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1DeviceIdsList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteGeofenceCommand = function serializeAws_restJson1BatchDeleteGeofenceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/delete-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.GeofenceIds != null && {
                        GeofenceIds: serializeAws_restJson1IdList(input.GeofenceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchEvaluateGeofencesCommand = function serializeAws_restJson1BatchEvaluateGeofencesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DevicePositionUpdates != null && {
                        DevicePositionUpdates: serializeAws_restJson1DevicePositionUpdateList(input.DevicePositionUpdates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchGetDevicePositionCommand = function serializeAws_restJson1BatchGetDevicePositionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/get-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1IdList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceCommand = function serializeAws_restJson1BatchPutGeofenceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/put-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Entries != null && {
                        Entries: serializeAws_restJson1BatchPutGeofenceRequestEntryList(input.Entries, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchUpdateDevicePositionCommand = function serializeAws_restJson1BatchUpdateDevicePositionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Updates != null && {
                        Updates: serializeAws_restJson1DevicePositionUpdateList(input.Updates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteCommand = function serializeAws_restJson1CalculateRouteCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePosition != null && {
                        DeparturePosition: serializeAws_restJson1Position(input.DeparturePosition, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPosition != null && {
                        DestinationPosition: serializeAws_restJson1Position(input.DestinationPosition, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.IncludeLegGeometry != null && {
                        IncludeLegGeometry: input.IncludeLegGeometry
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }), input.WaypointPositions != null && {
                        WaypointPositions: serializeAws_restJson1WaypointPositionList(input.WaypointPositions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteMatrixCommand = function serializeAws_restJson1CalculateRouteMatrixCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route-matrix";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePositions != null && {
                        DeparturePositions: serializeAws_restJson1PositionList(input.DeparturePositions, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPositions != null && {
                        DestinationPositions: serializeAws_restJson1PositionList(input.DestinationPositions, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateGeofenceCollectionCommand = function serializeAws_restJson1CreateGeofenceCollectionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CollectionName != null && {
                        CollectionName: input.CollectionName
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateMapCommand = function serializeAws_restJson1CreateMapCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Configuration != null && {
                        Configuration: serializeAws_restJson1MapConfiguration(input.Configuration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.MapName != null && {
                        MapName: input.MapName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreatePlaceIndexCommand = function serializeAws_restJson1CreatePlaceIndexCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.IndexName != null && {
                        IndexName: input.IndexName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateRouteCalculatorCommand = function serializeAws_restJson1CreateRouteCalculatorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CalculatorName != null && {
                        CalculatorName: input.CalculatorName
                    }), input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateTrackerCommand = function serializeAws_restJson1CreateTrackerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }), input.TrackerName != null && {
                        TrackerName: input.TrackerName
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteGeofenceCollectionCommand = function serializeAws_restJson1DeleteGeofenceCollectionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteMapCommand = function serializeAws_restJson1DeleteMapCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeletePlaceIndexCommand = function serializeAws_restJson1DeletePlaceIndexCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteRouteCalculatorCommand = function serializeAws_restJson1DeleteRouteCalculatorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteTrackerCommand = function serializeAws_restJson1DeleteTrackerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeGeofenceCollectionCommand = function serializeAws_restJson1DescribeGeofenceCollectionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeMapCommand = function serializeAws_restJson1DescribeMapCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribePlaceIndexCommand = function serializeAws_restJson1DescribePlaceIndexCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeRouteCalculatorCommand = function serializeAws_restJson1DescribeRouteCalculatorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeTrackerCommand = function serializeAws_restJson1DescribeTrackerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DisassociateTrackerConsumerCommand = function serializeAws_restJson1DisassociateTrackerConsumerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ConsumerArn", function() {
                        return input.ConsumerArn;
                    }, "{ConsumerArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionCommand = function serializeAws_restJson1GetDevicePositionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionHistoryCommand = function serializeAws_restJson1GetDevicePositionHistoryCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EndTimeExclusive != null && {
                        EndTimeExclusive: input.EndTimeExclusive.toISOString().split(".")[0] + "Z"
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }), input.StartTimeInclusive != null && {
                        StartTimeInclusive: input.StartTimeInclusive.toISOString().split(".")[0] + "Z"
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetGeofenceCommand = function serializeAws_restJson1GetGeofenceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapGlyphsCommand = function serializeAws_restJson1GetMapGlyphsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontStack", function() {
                        return input.FontStack;
                    }, "{FontStack}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontUnicodeRange", function() {
                        return input.FontUnicodeRange;
                    }, "{FontUnicodeRange}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapSpritesCommand = function serializeAws_restJson1GetMapSpritesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/sprites/{FileName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FileName", function() {
                        return input.FileName;
                    }, "{FileName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapStyleDescriptorCommand = function serializeAws_restJson1GetMapStyleDescriptorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/style-descriptor";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapTileCommand = function serializeAws_restJson1GetMapTileCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Z", function() {
                        return input.Z;
                    }, "{Z}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "X", function() {
                        return input.X;
                    }, "{X}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Y", function() {
                        return input.Y;
                    }, "{Y}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetPlaceCommand = function serializeAws_restJson1GetPlaceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/places/{PlaceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "PlaceId", function() {
                        return input.PlaceId;
                    }, "{PlaceId}", false);
                    query = map({
                        language: [
                            ,
                            input.Language
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListDevicePositionsCommand = function serializeAws_restJson1ListDevicePositionsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofenceCollectionsCommand = function serializeAws_restJson1ListGeofenceCollectionsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/list-collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofencesCommand = function serializeAws_restJson1ListGeofencesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/list-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListMapsCommand = function serializeAws_restJson1ListMapsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/list-maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListPlaceIndexesCommand = function serializeAws_restJson1ListPlaceIndexesCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/list-indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListRouteCalculatorsCommand = function serializeAws_restJson1ListRouteCalculatorsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/list-calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTagsForResourceCommand = function serializeAws_restJson1ListTagsForResourceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackerConsumersCommand = function serializeAws_restJson1ListTrackerConsumersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackersCommand = function serializeAws_restJson1ListTrackersCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/list-trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutGeofenceCommand = function serializeAws_restJson1PutGeofenceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Geometry != null && {
                        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForPositionCommand = function serializeAws_restJson1SearchPlaceIndexForPositionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/position";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Position != null && {
                        Position: serializeAws_restJson1Position(input.Position, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/suggestions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForTextCommand = function serializeAws_restJson1SearchPlaceIndexForTextCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1TagResourceCommand = function serializeAws_restJson1TagResourceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UntagResourceCommand = function serializeAws_restJson1UntagResourceCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    query = map({
                        tagKeys: [
                            function() {
                                return input.TagKeys !== void 0;
                            },
                            function() {
                                return (input.TagKeys || []).map(function(_entry) {
                                    return _entry;
                                });
                            }
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateGeofenceCollectionCommand = function serializeAws_restJson1UpdateGeofenceCollectionCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateMapCommand = function serializeAws_restJson1UpdateMapCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdatePlaceIndexCommand = function serializeAws_restJson1UpdatePlaceIndexCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateRouteCalculatorCommand = function serializeAws_restJson1UpdateRouteCalculatorCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateTrackerCommand = function serializeAws_restJson1UpdateTrackerCommand(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommand = function deserializeAws_restJson1AssociateTrackerConsumerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1AssociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommandError = function deserializeAws_restJson1AssociateTrackerConsumerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "ValidationException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ServiceQuotaExceededExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 17;
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError = function deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommand = function deserializeAws_restJson1BatchDeleteGeofenceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteGeofenceErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommandError = function deserializeAws_restJson1BatchDeleteGeofenceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommand = function deserializeAws_restJson1BatchEvaluateGeofencesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchEvaluateGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchEvaluateGeofencesErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommandError = function deserializeAws_restJson1BatchEvaluateGeofencesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommand = function deserializeAws_restJson1BatchGetDevicePositionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchGetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchGetDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommandError = function deserializeAws_restJson1BatchGetDevicePositionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommand = function deserializeAws_restJson1BatchPutGeofenceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchPutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchPutGeofenceErrorList(data.Errors, context);
                    if (data.Successes != null) contents.Successes = deserializeAws_restJson1BatchPutGeofenceSuccessList(data.Successes, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommandError = function deserializeAws_restJson1BatchPutGeofenceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommand = function deserializeAws_restJson1BatchUpdateDevicePositionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchUpdateDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchUpdateDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommandError = function deserializeAws_restJson1BatchUpdateDevicePositionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommand = function deserializeAws_restJson1CalculateRouteCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Legs != null) contents.Legs = deserializeAws_restJson1LegList(data.Legs, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommandError = function deserializeAws_restJson1CalculateRouteCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommand = function deserializeAws_restJson1CalculateRouteMatrixCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteMatrixCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.RouteMatrix != null) contents.RouteMatrix = deserializeAws_restJson1RouteMatrix(data.RouteMatrix, context);
                    if (data.SnappedDeparturePositions != null) contents.SnappedDeparturePositions = deserializeAws_restJson1PositionList(data.SnappedDeparturePositions, context);
                    if (data.SnappedDestinationPositions != null) contents.SnappedDestinationPositions = deserializeAws_restJson1PositionList(data.SnappedDestinationPositions, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteMatrixSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommandError = function deserializeAws_restJson1CalculateRouteMatrixCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommand = function deserializeAws_restJson1CreateGeofenceCollectionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommandError = function deserializeAws_restJson1CreateGeofenceCollectionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommand = function deserializeAws_restJson1CreateMapCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommandError = function deserializeAws_restJson1CreateMapCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommand = function deserializeAws_restJson1CreatePlaceIndexCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommandError = function deserializeAws_restJson1CreatePlaceIndexCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommand = function deserializeAws_restJson1CreateRouteCalculatorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommandError = function deserializeAws_restJson1CreateRouteCalculatorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommand = function deserializeAws_restJson1CreateTrackerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommandError = function deserializeAws_restJson1CreateTrackerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommand = function deserializeAws_restJson1DeleteGeofenceCollectionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommandError = function deserializeAws_restJson1DeleteGeofenceCollectionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommand = function deserializeAws_restJson1DeleteMapCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommandError = function deserializeAws_restJson1DeleteMapCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommand = function deserializeAws_restJson1DeletePlaceIndexCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeletePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommandError = function deserializeAws_restJson1DeletePlaceIndexCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommand = function deserializeAws_restJson1DeleteRouteCalculatorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommandError = function deserializeAws_restJson1DeleteRouteCalculatorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommand = function deserializeAws_restJson1DeleteTrackerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommandError = function deserializeAws_restJson1DeleteTrackerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommand = function deserializeAws_restJson1DescribeGeofenceCollectionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommandError = function deserializeAws_restJson1DescribeGeofenceCollectionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommand = function deserializeAws_restJson1DescribeMapCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Configuration != null) contents.Configuration = deserializeAws_restJson1MapConfiguration(data.Configuration, context);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommandError = function deserializeAws_restJson1DescribeMapCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommand = function deserializeAws_restJson1DescribePlaceIndexCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.DataSourceConfiguration != null) contents.DataSourceConfiguration = deserializeAws_restJson1DataSourceConfiguration(data.DataSourceConfiguration, context);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommandError = function deserializeAws_restJson1DescribePlaceIndexCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommand = function deserializeAws_restJson1DescribeRouteCalculatorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommandError = function deserializeAws_restJson1DescribeRouteCalculatorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommand = function deserializeAws_restJson1DescribeTrackerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PositionFiltering != null) contents.PositionFiltering = (0, _smithyClient.expectString)(data.PositionFiltering);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommandError = function deserializeAws_restJson1DescribeTrackerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommand = function deserializeAws_restJson1DisassociateTrackerConsumerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DisassociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommandError = function deserializeAws_restJson1DisassociateTrackerConsumerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommand = function deserializeAws_restJson1GetDevicePositionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Accuracy != null) contents.Accuracy = deserializeAws_restJson1PositionalAccuracy(data.Accuracy, context);
                    if (data.DeviceId != null) contents.DeviceId = (0, _smithyClient.expectString)(data.DeviceId);
                    if (data.Position != null) contents.Position = deserializeAws_restJson1Position(data.Position, context);
                    if (data.PositionProperties != null) contents.PositionProperties = deserializeAws_restJson1PropertyMap(data.PositionProperties, context);
                    if (data.ReceivedTime != null) contents.ReceivedTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.ReceivedTime));
                    if (data.SampleTime != null) contents.SampleTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.SampleTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommandError = function deserializeAws_restJson1GetDevicePositionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommand = function deserializeAws_restJson1GetDevicePositionHistoryCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommandError = function deserializeAws_restJson1GetDevicePositionHistoryCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommand = function deserializeAws_restJson1GetGeofenceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.Geometry != null) contents.Geometry = deserializeAws_restJson1GeofenceGeometry(data.Geometry, context);
                    if (data.Status != null) contents.Status = (0, _smithyClient.expectString)(data.Status);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommandError = function deserializeAws_restJson1GetGeofenceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommand = function deserializeAws_restJson1GetMapGlyphsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapGlyphsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommandError = function deserializeAws_restJson1GetMapGlyphsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommand = function deserializeAws_restJson1GetMapSpritesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapSpritesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommandError = function deserializeAws_restJson1GetMapSpritesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommand = function deserializeAws_restJson1GetMapStyleDescriptorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapStyleDescriptorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommandError = function deserializeAws_restJson1GetMapStyleDescriptorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommand = function deserializeAws_restJson1GetMapTileCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapTileCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommandError = function deserializeAws_restJson1GetMapTileCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommand = function deserializeAws_restJson1GetPlaceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetPlaceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Place != null) contents.Place = deserializeAws_restJson1Place(data.Place, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommandError = function deserializeAws_restJson1GetPlaceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommand = function deserializeAws_restJson1ListDevicePositionsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListDevicePositionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListDevicePositionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommandError = function deserializeAws_restJson1ListDevicePositionsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommand = function deserializeAws_restJson1ListGeofenceCollectionsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofenceCollectionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommandError = function deserializeAws_restJson1ListGeofenceCollectionsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommand = function deserializeAws_restJson1ListGeofencesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommandError = function deserializeAws_restJson1ListGeofencesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommand = function deserializeAws_restJson1ListMapsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListMapsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListMapsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommandError = function deserializeAws_restJson1ListMapsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommand = function deserializeAws_restJson1ListPlaceIndexesCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListPlaceIndexesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListPlaceIndexesResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommandError = function deserializeAws_restJson1ListPlaceIndexesCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommand = function deserializeAws_restJson1ListRouteCalculatorsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListRouteCalculatorsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListRouteCalculatorsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommandError = function deserializeAws_restJson1ListRouteCalculatorsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommand = function deserializeAws_restJson1ListTagsForResourceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTagsForResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommandError = function deserializeAws_restJson1ListTagsForResourceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommand = function deserializeAws_restJson1ListTrackerConsumersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackerConsumersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.ConsumerArns != null) contents.ConsumerArns = deserializeAws_restJson1ArnList(data.ConsumerArns, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommandError = function deserializeAws_restJson1ListTrackerConsumersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommand = function deserializeAws_restJson1ListTrackersCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListTrackersResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommandError = function deserializeAws_restJson1ListTrackersCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommand = function deserializeAws_restJson1PutGeofenceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommandError = function deserializeAws_restJson1PutGeofenceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "ValidationException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 15;
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommand = function deserializeAws_restJson1SearchPlaceIndexForPositionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForPositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForPositionResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForPositionSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommandError = function deserializeAws_restJson1SearchPlaceIndexForPositionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForSuggestionsResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError = function deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommand = function deserializeAws_restJson1SearchPlaceIndexForTextCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForTextResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForTextSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommandError = function deserializeAws_restJson1SearchPlaceIndexForTextCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommand = function deserializeAws_restJson1TagResourceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1TagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommandError = function deserializeAws_restJson1TagResourceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommand = function deserializeAws_restJson1UntagResourceCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UntagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommandError = function deserializeAws_restJson1UntagResourceCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommand = function deserializeAws_restJson1UpdateGeofenceCollectionCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommandError = function deserializeAws_restJson1UpdateGeofenceCollectionCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommand = function deserializeAws_restJson1UpdateMapCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommandError = function deserializeAws_restJson1UpdateMapCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommand = function deserializeAws_restJson1UpdatePlaceIndexCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommandError = function deserializeAws_restJson1UpdatePlaceIndexCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommand = function deserializeAws_restJson1UpdateRouteCalculatorCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommandError = function deserializeAws_restJson1UpdateRouteCalculatorCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommand = function deserializeAws_restJson1UpdateTrackerCommand(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommandError = function deserializeAws_restJson1UpdateTrackerCommandError(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1AccessDeniedExceptionResponse = function deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.AccessDeniedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalServerExceptionResponse = function deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalServerException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ResourceNotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ServiceQuotaExceededExceptionResponse = function deserializeAws_restJson1ServiceQuotaExceededExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ServiceQuotaExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ThrottlingExceptionResponse = function deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ThrottlingException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ValidationExceptionResponse = function deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.fieldList != null) contents.FieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            if (data.reason != null) contents.Reason = (0, _smithyClient.expectString)(data.reason);
            exception = new (0, _models0.ValidationException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntry = function serializeAws_restJson1BatchPutGeofenceRequestEntry(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.GeofenceId != null && {
        GeofenceId: input.GeofenceId
    }), input.Geometry != null && {
        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntryList = function serializeAws_restJson1BatchPutGeofenceRequestEntryList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1BatchPutGeofenceRequestEntry(entry, context);
    });
};
var serializeAws_restJson1BoundingBox = function serializeAws_restJson1BoundingBox(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1CalculateRouteCarModeOptions = function serializeAws_restJson1CalculateRouteCarModeOptions(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    });
};
var serializeAws_restJson1CalculateRouteTruckModeOptions = function serializeAws_restJson1CalculateRouteTruckModeOptions(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    }), input.Dimensions != null && {
        Dimensions: serializeAws_restJson1TruckDimensions(input.Dimensions, context)
    }), input.Weight != null && {
        Weight: serializeAws_restJson1TruckWeight(input.Weight, context)
    });
};
var serializeAws_restJson1Circle = function serializeAws_restJson1Circle(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Center != null && {
        Center: serializeAws_restJson1Position(input.Center, context)
    }), input.Radius != null && {
        Radius: (0, _smithyClient.serializeFloat)(input.Radius)
    });
};
var serializeAws_restJson1CountryCodeList = function serializeAws_restJson1CountryCodeList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DataSourceConfiguration = function serializeAws_restJson1DataSourceConfiguration(input, context) {
    return (0, _tslib.__assign)({}, input.IntendedUse != null && {
        IntendedUse: input.IntendedUse
    });
};
var serializeAws_restJson1DeviceIdsList = function serializeAws_restJson1DeviceIdsList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DevicePositionUpdate = function serializeAws_restJson1DevicePositionUpdate(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Accuracy != null && {
        Accuracy: serializeAws_restJson1PositionalAccuracy(input.Accuracy, context)
    }), input.DeviceId != null && {
        DeviceId: input.DeviceId
    }), input.Position != null && {
        Position: serializeAws_restJson1Position(input.Position, context)
    }), input.PositionProperties != null && {
        PositionProperties: serializeAws_restJson1PropertyMap(input.PositionProperties, context)
    }), input.SampleTime != null && {
        SampleTime: input.SampleTime.toISOString().split(".")[0] + "Z"
    });
};
var serializeAws_restJson1DevicePositionUpdateList = function serializeAws_restJson1DevicePositionUpdateList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1DevicePositionUpdate(entry, context);
    });
};
var serializeAws_restJson1GeofenceGeometry = function serializeAws_restJson1GeofenceGeometry(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Circle != null && {
        Circle: serializeAws_restJson1Circle(input.Circle, context)
    }), input.Polygon != null && {
        Polygon: serializeAws_restJson1LinearRings(input.Polygon, context)
    });
};
var serializeAws_restJson1IdList = function serializeAws_restJson1IdList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1LinearRing = function serializeAws_restJson1LinearRing(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1LinearRings = function serializeAws_restJson1LinearRings(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1LinearRing(entry, context);
    });
};
var serializeAws_restJson1MapConfiguration = function serializeAws_restJson1MapConfiguration(input, context) {
    return (0, _tslib.__assign)({}, input.Style != null && {
        Style: input.Style
    });
};
var serializeAws_restJson1Position = function serializeAws_restJson1Position(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1PositionalAccuracy = function serializeAws_restJson1PositionalAccuracy(input, context) {
    return (0, _tslib.__assign)({}, input.Horizontal != null && {
        Horizontal: (0, _smithyClient.serializeFloat)(input.Horizontal)
    });
};
var serializeAws_restJson1PositionList = function serializeAws_restJson1PositionList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1PropertyMap = function serializeAws_restJson1PropertyMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TagMap = function serializeAws_restJson1TagMap(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TruckDimensions = function serializeAws_restJson1TruckDimensions(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Height != null && {
        Height: (0, _smithyClient.serializeFloat)(input.Height)
    }), input.Length != null && {
        Length: (0, _smithyClient.serializeFloat)(input.Length)
    }), input.Unit != null && {
        Unit: input.Unit
    }), input.Width != null && {
        Width: (0, _smithyClient.serializeFloat)(input.Width)
    });
};
var serializeAws_restJson1TruckWeight = function serializeAws_restJson1TruckWeight(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Total != null && {
        Total: (0, _smithyClient.serializeFloat)(input.Total)
    }), input.Unit != null && {
        Unit: input.Unit
    });
};
var serializeAws_restJson1WaypointPositionList = function serializeAws_restJson1WaypointPositionList(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var deserializeAws_restJson1ArnList = function deserializeAws_restJson1ArnList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryError = function deserializeAws_restJson1BatchDeleteDevicePositionHistoryError(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList = function deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteDevicePositionHistoryError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteGeofenceError = function deserializeAws_restJson1BatchDeleteGeofenceError(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchDeleteGeofenceErrorList = function deserializeAws_restJson1BatchDeleteGeofenceErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchEvaluateGeofencesError = function deserializeAws_restJson1BatchEvaluateGeofencesError(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchEvaluateGeofencesErrorList = function deserializeAws_restJson1BatchEvaluateGeofencesErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchEvaluateGeofencesError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetDevicePositionError = function deserializeAws_restJson1BatchGetDevicePositionError(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchGetDevicePositionErrorList = function deserializeAws_restJson1BatchGetDevicePositionErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchGetDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchItemError = function deserializeAws_restJson1BatchItemError(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1BatchPutGeofenceError = function deserializeAws_restJson1BatchPutGeofenceError(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchPutGeofenceErrorList = function deserializeAws_restJson1BatchPutGeofenceErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchPutGeofenceSuccess = function deserializeAws_restJson1BatchPutGeofenceSuccess(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1BatchPutGeofenceSuccessList = function deserializeAws_restJson1BatchPutGeofenceSuccessList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceSuccess(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchUpdateDevicePositionError = function deserializeAws_restJson1BatchUpdateDevicePositionError(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchUpdateDevicePositionErrorList = function deserializeAws_restJson1BatchUpdateDevicePositionErrorList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchUpdateDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BoundingBox = function deserializeAws_restJson1BoundingBox(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1CalculateRouteMatrixSummary = function deserializeAws_restJson1CalculateRouteMatrixSummary(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        ErrorCount: (0, _smithyClient.expectInt32)(output.ErrorCount),
        RouteCount: (0, _smithyClient.expectInt32)(output.RouteCount)
    };
};
var deserializeAws_restJson1CalculateRouteSummary = function deserializeAws_restJson1CalculateRouteSummary(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        RouteBBox: output.RouteBBox != null ? deserializeAws_restJson1BoundingBox(output.RouteBBox, context) : undefined
    };
};
var deserializeAws_restJson1Circle = function deserializeAws_restJson1Circle(output, context) {
    return {
        Center: output.Center != null ? deserializeAws_restJson1Position(output.Center, context) : undefined,
        Radius: (0, _smithyClient.limitedParseDouble)(output.Radius)
    };
};
var deserializeAws_restJson1CountryCodeList = function deserializeAws_restJson1CountryCodeList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1DataSourceConfiguration = function deserializeAws_restJson1DataSourceConfiguration(output, context) {
    return {
        IntendedUse: (0, _smithyClient.expectString)(output.IntendedUse)
    };
};
var deserializeAws_restJson1DevicePosition = function deserializeAws_restJson1DevicePosition(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        ReceivedTime: output.ReceivedTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.ReceivedTime)) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1DevicePositionList = function deserializeAws_restJson1DevicePositionList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1DevicePosition(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1GeofenceGeometry = function deserializeAws_restJson1GeofenceGeometry(output, context) {
    return {
        Circle: output.Circle != null ? deserializeAws_restJson1Circle(output.Circle, context) : undefined,
        Polygon: output.Polygon != null ? deserializeAws_restJson1LinearRings(output.Polygon, context) : undefined
    };
};
var deserializeAws_restJson1Leg = function deserializeAws_restJson1Leg(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        Geometry: output.Geometry != null ? deserializeAws_restJson1LegGeometry(output.Geometry, context) : undefined,
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined,
        Steps: output.Steps != null ? deserializeAws_restJson1StepList(output.Steps, context) : undefined
    };
};
var deserializeAws_restJson1LegGeometry = function deserializeAws_restJson1LegGeometry(output, context) {
    return {
        LineString: output.LineString != null ? deserializeAws_restJson1LineString(output.LineString, context) : undefined
    };
};
var deserializeAws_restJson1LegList = function deserializeAws_restJson1LegList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Leg(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRing = function deserializeAws_restJson1LinearRing(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRings = function deserializeAws_restJson1LinearRings(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1LinearRing(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LineString = function deserializeAws_restJson1LineString(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListDevicePositionsResponseEntry = function deserializeAws_restJson1ListDevicePositionsResponseEntry(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1ListDevicePositionsResponseEntryList = function deserializeAws_restJson1ListDevicePositionsResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListDevicePositionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntry = function deserializeAws_restJson1ListGeofenceCollectionsResponseEntry(output, context) {
    return {
        CollectionName: (0, _smithyClient.expectString)(output.CollectionName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList = function deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceCollectionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceResponseEntry = function deserializeAws_restJson1ListGeofenceResponseEntry(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        Geometry: output.Geometry != null ? deserializeAws_restJson1GeofenceGeometry(output.Geometry, context) : undefined,
        Status: (0, _smithyClient.expectString)(output.Status),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceResponseEntryList = function deserializeAws_restJson1ListGeofenceResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListMapsResponseEntry = function deserializeAws_restJson1ListMapsResponseEntry(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        MapName: (0, _smithyClient.expectString)(output.MapName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListMapsResponseEntryList = function deserializeAws_restJson1ListMapsResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListMapsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntry = function deserializeAws_restJson1ListPlaceIndexesResponseEntry(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        IndexName: (0, _smithyClient.expectString)(output.IndexName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntryList = function deserializeAws_restJson1ListPlaceIndexesResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListPlaceIndexesResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntry = function deserializeAws_restJson1ListRouteCalculatorsResponseEntry(output, context) {
    return {
        CalculatorName: (0, _smithyClient.expectString)(output.CalculatorName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntryList = function deserializeAws_restJson1ListRouteCalculatorsResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListRouteCalculatorsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListTrackersResponseEntry = function deserializeAws_restJson1ListTrackersResponseEntry(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        TrackerName: (0, _smithyClient.expectString)(output.TrackerName),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListTrackersResponseEntryList = function deserializeAws_restJson1ListTrackersResponseEntryList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListTrackersResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MapConfiguration = function deserializeAws_restJson1MapConfiguration(output, context) {
    return {
        Style: (0, _smithyClient.expectString)(output.Style)
    };
};
var deserializeAws_restJson1Place = function deserializeAws_restJson1Place(output, context) {
    return {
        AddressNumber: (0, _smithyClient.expectString)(output.AddressNumber),
        Country: (0, _smithyClient.expectString)(output.Country),
        Geometry: output.Geometry != null ? deserializeAws_restJson1PlaceGeometry(output.Geometry, context) : undefined,
        Interpolated: (0, _smithyClient.expectBoolean)(output.Interpolated),
        Label: (0, _smithyClient.expectString)(output.Label),
        Municipality: (0, _smithyClient.expectString)(output.Municipality),
        Neighborhood: (0, _smithyClient.expectString)(output.Neighborhood),
        PostalCode: (0, _smithyClient.expectString)(output.PostalCode),
        Region: (0, _smithyClient.expectString)(output.Region),
        Street: (0, _smithyClient.expectString)(output.Street),
        SubRegion: (0, _smithyClient.expectString)(output.SubRegion),
        TimeZone: output.TimeZone != null ? deserializeAws_restJson1TimeZone(output.TimeZone, context) : undefined,
        UnitNumber: (0, _smithyClient.expectString)(output.UnitNumber),
        UnitType: (0, _smithyClient.expectString)(output.UnitType)
    };
};
var deserializeAws_restJson1PlaceGeometry = function deserializeAws_restJson1PlaceGeometry(output, context) {
    return {
        Point: output.Point != null ? deserializeAws_restJson1Position(output.Point, context) : undefined
    };
};
var deserializeAws_restJson1Position = function deserializeAws_restJson1Position(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PositionalAccuracy = function deserializeAws_restJson1PositionalAccuracy(output, context) {
    return {
        Horizontal: (0, _smithyClient.limitedParseDouble)(output.Horizontal)
    };
};
var deserializeAws_restJson1PositionList = function deserializeAws_restJson1PositionList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PropertyMap = function deserializeAws_restJson1PropertyMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1RouteMatrix = function deserializeAws_restJson1RouteMatrix(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixRow(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1RouteMatrixEntry = function deserializeAws_restJson1RouteMatrixEntry(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        Error: output.Error != null ? deserializeAws_restJson1RouteMatrixEntryError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1RouteMatrixEntryError = function deserializeAws_restJson1RouteMatrixEntryError(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1RouteMatrixRow = function deserializeAws_restJson1RouteMatrixRow(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForPositionResult = function deserializeAws_restJson1SearchForPositionResult(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId)
    };
};
var deserializeAws_restJson1SearchForPositionResultList = function deserializeAws_restJson1SearchForPositionResultList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForPositionResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForSuggestionsResult = function deserializeAws_restJson1SearchForSuggestionsResult(output, context) {
    return {
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchForSuggestionsResultList = function deserializeAws_restJson1SearchForSuggestionsResultList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForSuggestionsResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForTextResult = function deserializeAws_restJson1SearchForTextResult(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Relevance: (0, _smithyClient.limitedParseDouble)(output.Relevance)
    };
};
var deserializeAws_restJson1SearchForTextResultList = function deserializeAws_restJson1SearchForTextResultList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForTextResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchPlaceIndexForPositionSummary = function deserializeAws_restJson1SearchPlaceIndexForPositionSummary(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined
    };
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary = function deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchPlaceIndexForTextSummary = function deserializeAws_restJson1SearchPlaceIndexForTextSummary(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        ResultBBox: output.ResultBBox != null ? deserializeAws_restJson1BoundingBox(output.ResultBBox, context) : undefined,
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1Step = function deserializeAws_restJson1Step(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        GeometryOffset: (0, _smithyClient.expectInt32)(output.GeometryOffset),
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined
    };
};
var deserializeAws_restJson1StepList = function deserializeAws_restJson1StepList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Step(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TagMap = function deserializeAws_restJson1TagMap(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1TimeZone = function deserializeAws_restJson1TimeZone(output, context) {
    return {
        Name: (0, _smithyClient.expectString)(output.Name),
        Offset: (0, _smithyClient.expectInt32)(output.Offset)
    };
};
var deserializeAws_restJson1ValidationExceptionField = function deserializeAws_restJson1ValidationExceptionField(output, context) {
    return {
        Message: (0, _smithyClient.expectString)(output.message),
        Name: (0, _smithyClient.expectString)(output.name)
    };
};
var deserializeAws_restJson1ValidationExceptionFieldList = function deserializeAws_restJson1ValidationExceptionFieldList(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ValidationExceptionField(entry, context);
    });
    return retVal;
};
var deserializeMetadata = function deserializeMetadata(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function collectBody(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function collectBodyString(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function parseBody(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function parseErrorBody(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function loadRestJsonErrorCode(output, data) {
    var findKey = function findKey(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function sanitizeErrorCode(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/smithy-client":"6yS5y","../models/LocationServiceException":"g5vja","../models/models_0":"b7IJ4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6G5dO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchPutGeofenceCommand", function() {
    return BatchPutGeofenceCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchPutGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchPutGeofenceCommand, _super);
    function BatchPutGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchPutGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchPutGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchPutGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchPutGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchPutGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchPutGeofenceCommand)(input, context);
    };
    BatchPutGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchPutGeofenceCommand)(output, context);
    };
    return BatchPutGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Sb9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetGeofenceCommand", function() {
    return GetGeofenceCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(GetGeofenceCommand, _super);
    function GetGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetGeofenceCommand)(input, context);
    };
    GetGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetGeofenceCommand)(output, context);
    };
    return GetGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aCfAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetPlaceCommand", function() {
    return GetPlaceCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetPlaceCommand = function(_super) {
    (0, _tslib.__extends)(GetPlaceCommand, _super);
    function GetPlaceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetPlaceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetPlaceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetPlaceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetPlaceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPlaceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetPlaceCommand)(input, context);
    };
    GetPlaceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetPlaceCommand)(output, context);
    };
    return GetPlaceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c6YDt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListGeofencesCommand", function() {
    return ListGeofencesCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var ListGeofencesCommand = function(_super) {
    (0, _tslib.__extends)(ListGeofencesCommand, _super);
    function ListGeofencesCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListGeofencesCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "ListGeofencesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.ListGeofencesRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.ListGeofencesResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListGeofencesCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1ListGeofencesCommand)(input, context);
    };
    ListGeofencesCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1ListGeofencesCommand)(output, context);
    };
    return ListGeofencesCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uRyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionCommand", function() {
    return SearchPlaceIndexForPositionCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForPositionCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForPositionCommand, _super);
    function SearchPlaceIndexForPositionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForPositionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForPositionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForPositionCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForPositionCommand)(input, context);
    };
    SearchPlaceIndexForPositionCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForPositionCommand)(output, context);
    };
    return SearchPlaceIndexForPositionCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gEjA4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsCommand", function() {
    return SearchPlaceIndexForSuggestionsCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForSuggestionsCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForSuggestionsCommand, _super);
    function SearchPlaceIndexForSuggestionsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForSuggestionsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForSuggestionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(input, context);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(output, context);
    };
    return SearchPlaceIndexForSuggestionsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aO5IJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForTextCommand", function() {
    return SearchPlaceIndexForTextCommand;
});
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForTextCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForTextCommand, _super);
    function SearchPlaceIndexForTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForTextCommand)(input, context);
    };
    SearchPlaceIndexForTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForTextCommand)(output, context);
    };
    return SearchPlaceIndexForTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9llQK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateCoordinates", function() {
    return validateCoordinates;
});
parcelHelpers.export(exports, "validateGeofenceId", function() {
    return validateGeofenceId;
});
parcelHelpers.export(exports, "validateLinearRing", function() {
    return validateLinearRing;
});
parcelHelpers.export(exports, "validatePolygon", function() {
    return validatePolygon;
});
parcelHelpers.export(exports, "validateGeofencesInput", function() {
    return validateGeofencesInput;
});
parcelHelpers.export(exports, "mapSearchOptions", function() {
    return mapSearchOptions;
});
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _booleanClockwise = require("@turf/boolean-clockwise");
var _booleanClockwiseDefault = parcelHelpers.interopDefault(_booleanClockwise);
function validateCoordinates(lng, lat) {
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) throw new Error("Invalid coordinates: [" + lng + "," + lat + "]");
    if (lat < -90 || 90 < lat) throw new Error('Latitude must be between -90 and 90 degrees inclusive.');
    else if (lng < -180 || 180 < lng) throw new Error('Longitude must be between -180 and 180 degrees inclusive.');
}
function validateGeofenceId(geofenceId) {
    var geofenceIdRegex = RegExp("^[-._\\p{L}\\p{N}]+$", "iu");
    // Check if geofenceId is valid
    if (!geofenceIdRegex.test(geofenceId)) throw new Error("Invalid geofenceId: '" + geofenceId + "' - IDs can only contain alphanumeric characters, hyphens, underscores and periods.");
}
function validateLinearRing(linearRing, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : '';
    // Validate LinearRing size, must be at least 4 points
    if (linearRing.length < 4) throw new Error(errorPrefix + "LinearRing must contain 4 or more coordinates.");
    // Validate all coordinates are valid, error with which ones are bad
    var badCoordinates = [];
    linearRing.forEach(function(coordinates) {
        try {
            validateCoordinates(coordinates[0], coordinates[1]);
        } catch (error) {
            badCoordinates.push({
                coordinates: coordinates,
                error: error.message
            });
        }
    });
    if (badCoordinates.length > 0) throw new Error(errorPrefix + "One or more of the coordinates in the Polygon LinearRing are not valid: " + JSON.stringify(badCoordinates));
    // Validate first and last coordinates are the same
    var _a = (0, _tslib.__read)(linearRing[0], 2), lngA = _a[0], latA = _a[1];
    var _b = (0, _tslib.__read)(linearRing[linearRing.length - 1], 2), lngB = _b[0], latB = _b[1];
    if (lngA !== lngB || latA !== latB) throw new Error(errorPrefix + "LinearRing's first and last coordinates are not the same");
    if ((0, _booleanClockwiseDefault.default)(linearRing)) throw new Error(errorPrefix + "LinearRing coordinates must be wound counterclockwise");
}
function validatePolygon(polygon, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : '';
    if (!Array.isArray(polygon)) throw new Error(errorPrefix + "Polygon is of incorrect structure. It should be an array of LinearRings");
    if (polygon.length < 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array.");
    if (polygon.length > 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array. Note: We do not currently support polygons with holes, multipolygons, polygons that are wound clockwise, or that cross the antimeridian.");
    var verticesCount = polygon.reduce(function(prev, linearRing) {
        return prev + linearRing.length;
    }, 0);
    if (verticesCount > 1000) throw new Error(errorPrefix + "Polygon has more than the maximum 1000 vertices.");
    polygon.forEach(function(linearRing) {
        validateLinearRing(linearRing, geofenceId);
    });
}
function validateGeofencesInput(geofences) {
    var geofenceIds = {};
    geofences.forEach(function(geofence) {
        // verify all required properties are present
        // Validate geofenceId exists
        if (!geofence.geofenceId) throw new Error("Geofence '" + geofence + "' is missing geofenceId");
        var geofenceId = geofence.geofenceId;
        validateGeofenceId(geofenceId);
        // Validate geofenceId is unique
        if (geofenceIds[geofenceId]) throw new Error("Duplicate geofenceId: " + geofenceId);
        else geofenceIds[geofenceId] = true;
        // Validate geometry exists
        if (!geofence.geometry) throw new Error("Geofence '" + geofenceId + "' is missing geometry");
        var geometry = geofence.geometry;
        // Validate polygon exists
        if (!geometry.polygon) throw new Error("Geofence '" + geofenceId + "' is missing geometry.polygon");
        var polygon = geometry.polygon;
        // Validate polygon length and structure
        try {
            validatePolygon(polygon, geofenceId);
        } catch (error) {
            if (error.message.includes('Polygon has more than the maximum 1000 vertices.')) throw new Error("Geofence '" + geofenceId + "' has more than the maximum of 1000 vertices");
        }
        // Validate LinearRing length, structure, and coordinates
        var _a = (0, _tslib.__read)(polygon, 1), linearRing = _a[0];
        validateLinearRing(linearRing, geofenceId);
    });
}
function mapSearchOptions(options, locationServiceInput) {
    var locationServiceModifiedInput = (0, _tslib.__assign)({}, locationServiceInput);
    locationServiceModifiedInput.FilterCountries = options.countries;
    locationServiceModifiedInput.MaxResults = options.maxResults;
    if (options.searchIndexName) locationServiceModifiedInput.IndexName = options.searchIndexName;
    if (options['biasPosition'] && options['searchAreaConstraints']) throw new Error('BiasPosition and SearchAreaConstraints are mutually exclusive, please remove one or the other from the options object');
    if (options['biasPosition']) locationServiceModifiedInput.BiasPosition = options['biasPosition'];
    if (options['searchAreaConstraints']) locationServiceModifiedInput.FilterBBox = options['searchAreaConstraints'];
    return locationServiceModifiedInput;
}

},{"tslib":"6BFzs","@turf/boolean-clockwise":"gmdhE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gmdhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return booleanClockwise;
});
var _invariant = require("@turf/invariant");
function booleanClockwise(line) {
    var ring = (0, _invariant.getCoords)(line);
    var sum = 0;
    var i = 1;
    var prev;
    var cur;
    while(i < ring.length){
        prev = cur || ring[0];
        cur = ring[i];
        sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
        i++;
    }
    return sum > 0;
}

},{"@turf/invariant":"r7ipG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"r7ipG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ parcelHelpers.export(exports, "getCoord", function() {
    return getCoord;
});
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ parcelHelpers.export(exports, "getCoords", function() {
    return getCoords;
});
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ parcelHelpers.export(exports, "containsNumber", function() {
    return containsNumber;
});
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "geojsonType", function() {
    return geojsonType;
});
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ parcelHelpers.export(exports, "featureOf", function() {
    return featureOf;
});
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "collectionOf", function() {
    return collectionOf;
});
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ parcelHelpers.export(exports, "getGeom", function() {
    return getGeom;
});
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ parcelHelpers.export(exports, "getType", function() {
    return getType;
});
var _helpers = require("@turf/helpers");
function getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber(coordinates) {
    if (coordinates.length > 1 && (0, _helpers.isNumber)(coordinates[0]) && (0, _helpers.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

},{"@turf/helpers":"8U0ZF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8U0ZF":[function(require,module,exports,__globalThis) {
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "earthRadius", function() {
    return earthRadius;
});
parcelHelpers.export(exports, "factors", function() {
    return factors;
});
parcelHelpers.export(exports, "unitsFactors", function() {
    return unitsFactors;
});
parcelHelpers.export(exports, "areaFactors", function() {
    return areaFactors;
});
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ parcelHelpers.export(exports, "feature", function() {
    return feature;
});
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */ parcelHelpers.export(exports, "geometry", function() {
    return geometry;
});
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ parcelHelpers.export(exports, "point", function() {
    return point;
});
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ parcelHelpers.export(exports, "points", function() {
    return points;
});
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ parcelHelpers.export(exports, "polygon", function() {
    return polygon;
});
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ parcelHelpers.export(exports, "polygons", function() {
    return polygons;
});
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ parcelHelpers.export(exports, "lineString", function() {
    return lineString;
});
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ parcelHelpers.export(exports, "lineStrings", function() {
    return lineStrings;
});
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ parcelHelpers.export(exports, "featureCollection", function() {
    return featureCollection;
});
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ parcelHelpers.export(exports, "multiLineString", function() {
    return multiLineString;
});
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ parcelHelpers.export(exports, "multiPoint", function() {
    return multiPoint;
});
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ parcelHelpers.export(exports, "multiPolygon", function() {
    return multiPolygon;
});
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */ parcelHelpers.export(exports, "geometryCollection", function() {
    return geometryCollection;
});
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ parcelHelpers.export(exports, "round", function() {
    return round;
});
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */ parcelHelpers.export(exports, "radiansToLength", function() {
    return radiansToLength;
});
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */ parcelHelpers.export(exports, "lengthToRadians", function() {
    return lengthToRadians;
});
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */ parcelHelpers.export(exports, "lengthToDegrees", function() {
    return lengthToDegrees;
});
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ parcelHelpers.export(exports, "bearingToAzimuth", function() {
    return bearingToAzimuth;
});
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ parcelHelpers.export(exports, "radiansToDegrees", function() {
    return radiansToDegrees;
});
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ parcelHelpers.export(exports, "degreesToRadians", function() {
    return degreesToRadians;
});
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */ parcelHelpers.export(exports, "convertLength", function() {
    return convertLength;
});
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */ parcelHelpers.export(exports, "convertArea", function() {
    return convertArea;
});
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ parcelHelpers.export(exports, "isNumber", function() {
    return isNumber;
});
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateBBox", function() {
    return validateBBox;
});
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateId", function() {
    return validateId;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var earthRadius = 6371008.8;
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
};
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133
};
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function feature(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function geometry(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function point(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function points(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return point(coords, properties);
    }), options);
}
function polygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function polygons(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return polygon(coords, properties);
    }), options);
}
function lineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return lineString(coords, properties);
    }), options);
}
function featureCollection(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function multiLineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return feature(geom, properties, options);
}
function round(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function lengthToRadians(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
    return !!input && input.constructor === Object;
}
function validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
function validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id === "undefined" ? "undefined" : (0, _typeOf._)(id)) === -1) throw new Error("id must be a number or a string");
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ebRwi":[function(require,module,exports,__globalThis) {
module.exports = require("9f37cef8b0e13afc");

},{"9f37cef8b0e13afc":"5JUlc"}],"5JUlc":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("1137fef34918bf53");
var bind = require("ce63a8247a300202");
var Axios = require("c14c66f4c3ec48a2");
var mergeConfig = require("345f9ec0ee8efc80");
var defaults = require("27bdb15d131780c5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);
    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);
    // Copy context to instance
    utils.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var axios = createInstance(defaults);
// Expose Axios class to allow class inheritance
axios.Axios = Axios;
// Factory for creating new instances
axios.create = function create(instanceConfig) {
    return createInstance(mergeConfig(axios.defaults, instanceConfig));
};
// Expose Cancel & CancelToken
axios.Cancel = require("ae1da7645e57ebca");
axios.CancelToken = require("853fec7db7d524b4");
axios.isCancel = require("322a636c3e2325e1");
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = require("75c7c70e55d88256");
// Expose isAxiosError
axios.isAxiosError = require("543a1da09311ae9b");
module.exports = axios;
// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"1137fef34918bf53":"9h6FO","ce63a8247a300202":"dksnV","c14c66f4c3ec48a2":"ivnjU","345f9ec0ee8efc80":"lk3cu","27bdb15d131780c5":"7sGmZ","ae1da7645e57ebca":"gG3Cf","853fec7db7d524b4":"aAhTh","322a636c3e2325e1":"673ru","75c7c70e55d88256":"Rt4vC","543a1da09311ae9b":"jd0zH"}],"9h6FO":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var bind = require("a7c7b4094caa86ac");
// utils is a library of generic helper functions non-specific to axios
var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
    return toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function isArrayBuffer(val) {
    return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val)) === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
    if (toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function isDate(val) {
    return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function isFile(val) {
    return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function isBlob(val) {
    return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
    return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
    var result = {};
    function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
        else if (isPlainObject(val)) result[key] = merge({}, val);
        else if (isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = bind(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
};

},{"@swc/helpers/_/_type_of":"668P4","a7c7b4094caa86ac":"dksnV"}],"dksnV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

},{}],"ivnjU":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("2cd2d0baba832579");
var buildURL = require("945ebba9256ed84f");
var InterceptorManager = require("fc2d71ae77ba798e");
var dispatchRequest = require("77b4f57f4d663a9b");
var mergeConfig = require("5db81a4f62f8927d");
var validator = require("d0f5147a00cee7c5");
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = mergeConfig(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
        forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
        clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
utils.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
utils.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, data, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = Axios;

},{"2cd2d0baba832579":"9h6FO","945ebba9256ed84f":"3wgcs","fc2d71ae77ba798e":"1zkLW","77b4f57f4d663a9b":"tH08M","5db81a4f62f8927d":"lk3cu","d0f5147a00cee7c5":"inJar"}],"3wgcs":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("d198994ea2a45305");
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if (utils.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) v = v.toISOString();
                else if (utils.isObject(v)) v = JSON.stringify(v);
                parts.push(encode(key) + '=' + encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

},{"d198994ea2a45305":"9h6FO"}],"1zkLW":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("982be9ba543c1801");
function InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = InterceptorManager;

},{"982be9ba543c1801":"9h6FO"}],"tH08M":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("dccb83262660ba2a");
var transformData = require("670a836c9c5a1abe");
var isCancel = require("9b938a75c8452b2f");
var defaults = require("293260d2186f65fb");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = transformData.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    utils.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

},{"dccb83262660ba2a":"9h6FO","670a836c9c5a1abe":"binIL","9b938a75c8452b2f":"673ru","293260d2186f65fb":"7sGmZ"}],"binIL":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("506225f7f22ee5b3");
var defaults = require("5f8f7bd977372ccb");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || defaults;
    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

},{"506225f7f22ee5b3":"9h6FO","5f8f7bd977372ccb":"7sGmZ"}],"7sGmZ":[function(require,module,exports,__globalThis) {
var process = require("1ad3e53325021694");
'use strict';
var utils = require("46f17d5a961ed1b0");
var normalizeHeaderName = require("cc6d63c7870abf00");
var enhanceError = require("381f0945c152ddd3");
var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
    if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}
function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = require("f5547462a34fd4c6");
    else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') // For node use HTTP adapter
    adapter = require("1a73616b0da0ef06");
    return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
    if (utils.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return utils.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            normalizeHeaderName(headers, 'Accept');
            normalizeHeaderName(headers, 'Content-Type');
            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
            if (utils.isArrayBufferView(data)) return data.buffer;
            if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if (utils.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                setContentTypeIfUnset(headers, 'application/json');
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw enhanceError(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
utils.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
});
utils.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

},{"1ad3e53325021694":"4avz9","46f17d5a961ed1b0":"9h6FO","cc6d63c7870abf00":"kbA1r","381f0945c152ddd3":"dzDOs","f5547462a34fd4c6":"6iQqp","1a73616b0da0ef06":"6iQqp"}],"kbA1r":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("5f8afca0889a63e1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

},{"5f8afca0889a63e1":"9h6FO"}],"dzDOs":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

},{}],"6iQqp":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("2bb8b5f6db10dd6d");
var settle = require("a7b983c12bb9f77f");
var cookies = require("19bdb320f45f036e");
var buildURL = require("568f70ee55491398");
var buildFullPath = require("a1fd5a6807469b6d");
var parseHeaders = require("f197d20bdfdcd5a4");
var isURLSameOrigin = require("32737c301de74bf5");
var createError = require("df24397a62f10f34");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if (utils.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            settle(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(createError('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

},{"2bb8b5f6db10dd6d":"9h6FO","a7b983c12bb9f77f":"d0QeT","19bdb320f45f036e":"4SQWF","568f70ee55491398":"3wgcs","a1fd5a6807469b6d":"8uBwh","f197d20bdfdcd5a4":"dEHJn","32737c301de74bf5":"bws7C","df24397a62f10f34":"2k6rs"}],"d0QeT":[function(require,module,exports,__globalThis) {
'use strict';
var createError = require("72d296795d733aeb");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

},{"72d296795d733aeb":"2k6rs"}],"2k6rs":[function(require,module,exports,__globalThis) {
'use strict';
var enhanceError = require("ff529806947600d1");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError(error, config, code, request, response);
};

},{"ff529806947600d1":"dzDOs"}],"4SQWF":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("c987331427b8b2ad");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if (utils.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if (utils.isString(path)) cookie.push('path=' + path);
            if (utils.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

},{"c987331427b8b2ad":"9h6FO"}],"8uBwh":[function(require,module,exports,__globalThis) {
'use strict';
var isAbsoluteURL = require("5ff0e8c05aa13380");
var combineURLs = require("e1ac36eef7d02fa4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
    return requestedURL;
};

},{"5ff0e8c05aa13380":"cP0Db","e1ac36eef7d02fa4":"hIV2h"}],"cP0Db":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],"hIV2h":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

},{}],"dEHJn":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("5802dc5113a634d0");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    utils.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

},{"5802dc5113a634d0":"9h6FO"}],"bws7C":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("c8f79893fd676b4c");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"c8f79893fd676b4c":"9h6FO"}],"673ru":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

},{}],"lk3cu":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("99adbff39af8f677");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
        else if (utils.isPlainObject(source)) return utils.merge({}, source);
        else if (utils.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    utils.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    utils.forEach(otherKeys, mergeDeepProperties);
    return config;
};

},{"99adbff39af8f677":"9h6FO"}],"inJar":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var pkg = require("3c22590bc411b699");
var validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, _typeOf._)(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function assertOptions(options, schema, allowUnknown) {
    if ((typeof options === "undefined" ? "undefined" : (0, _typeOf._)(options)) !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: isOlderVersion,
    assertOptions: assertOptions,
    validators: validators
};

},{"@swc/helpers/_/_type_of":"668P4","3c22590bc411b699":"g3Z65"}],"g3Z65":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

},{}],"gG3Cf":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function Cancel(message) {
    this.message = message;
}
Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
module.exports = Cancel;

},{}],"aAhTh":[function(require,module,exports,__globalThis) {
'use strict';
var Cancel = require("69a8f59e5e2b033");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = CancelToken;

},{"69a8f59e5e2b033":"gG3Cf"}],"Rt4vC":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

},{}],"jd0zH":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return (typeof payload === "undefined" ? "undefined" : (0, _typeOf._)(payload)) === 'object' && payload.isAxiosError === true;
};

},{"@swc/helpers/_/_type_of":"668P4"}],"dTzhW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", function() {
    return App;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _index = require("axios/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _reactstrap = require("reactstrap");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactDeviceDetect = require("react-device-detect");
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";
// core components
// import AdminNavbar from "../../components/Navbars/AdminNavbar.jsx";
var _footerJsx = require("../../components/Footer/Footer.jsx");
var _footerJsxDefault = parcelHelpers.interopDefault(_footerJsx);
var _sidebarJsx = require("../../components/Sidebar/Sidebar.jsx");
var _sidebarJsxDefault = parcelHelpers.interopDefault(_sidebarJsx);
var _leftSidebar = require("../../components/Sidebar/LeftSidebar");
var _leftSidebarDefault = parcelHelpers.interopDefault(_leftSidebar);
// import FixedPlugin from "../../components/FixedPlugin/FixedPlugin.jsx";
var _routesJs = require("../../routes.js");
var _blade = require("../../components/Blade/Blade");
var _bladeDefault = parcelHelpers.interopDefault(_blade);
var _notificationsFeed = require("../../components/Notifications/NotificationsFeed");
var _notificationsFeedDefault = parcelHelpers.interopDefault(_notificationsFeed);
var _appState = require("../../AppState");
var _socketHook = require("../../hooks/SocketHook");
var _notFound = require("../../components/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _tabbedDashboardJsx = require("../../components/Dashboard/TabbedDashboard.jsx");
var _appAlertJsx = require("../../components/AppAlert/AppAlert.jsx");
var _appAlertJsxDefault = parcelHelpers.interopDefault(_appAlertJsx);
var _clickstreamJsx = require("../../components/Clickstream/Clickstream.jsx");
var _clickstreamJsxDefault = parcelHelpers.interopDefault(_clickstreamJsx);
var _enumJs = require("../../utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _spoofBannerJs = require("../../utility/SpoofBanner.js");
var _spoofBannerJsDefault = parcelHelpers.interopDefault(_spoofBannerJs);
var _connectriaAnnoucmentJs = require("../../utility/ConnectriaAnnoucment.js");
var _connectriaAnnoucmentJsDefault = parcelHelpers.interopDefault(_connectriaAnnoucmentJs);
var _miscJsx = require("../../components/misc.jsx");
var _contentBlade = require("../../components/Blade/ContentBlade");
var _contentBladeDefault = parcelHelpers.interopDefault(_contentBlade);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _policyToggleJs = require("../../utility/PolicyToggle.js");
var _policyToggleJsDefault = parcelHelpers.interopDefault(_policyToggleJs);
var _gdprcookiesJsx = require("../../components/GDPRCookies/GDPRCookies.jsx");
var _gdprcookiesJsxDefault = parcelHelpers.interopDefault(_gdprcookiesJsx);
var App = function(props) {
    var _stateApp_notifications_list, _stateApp_notifications, _stateApp_notifications1, _stateApp_notifications2;
    //local state
    var _useState = (0, _slicedToArray._)((0, _react.useState)(document.documentElement.className.indexOf("nav-open") !== -1), 2), sidebarOpened = _useState[0], setSidebarOpened = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(!(0, _reactDeviceDetect.isMobile)), 2), leftSidebarOpened = _useState1[0], setLeftSidebarOpened = _useState1[1]; // useState(!!document.querySelector('.left-sidebar.expanded'));
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)("primary"), 2), backgroundColor = _useState2[0], setBackgroundColor = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)("burger-container"), 2), burgerCssClass = _useState3[0], setBurgerCssClass = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(null), 2), customerMessage = _useState4[0], setCustomerMessage = _useState4[1];
    var source = (0, _indexDefault.default).CancelToken.source();
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var history = (0, _reactRouterDom.useHistory)();
    var _useSocket = (0, _socketHook.useSocket)(), isSocketOpen = _useSocket.isOpen, sendSocketMessage = _useSocket.send, connect = _useSocket.connect, disconnect = _useSocket.disconnect, addMessageHandler = _useSocket.addMessageHandler, removeMessageHandler = _useSocket.removeMessageHandler;
    //un-comment below if we have issues with IE's scrollbar
    //componentDidMount -- notice second arg empty array 
    // useEffect(() => {
    //   if (navigator.platform.indexOf("Win") > -1) {
    //     document.documentElement.className += " perfect-scrollbar-on";
    //     document.documentElement.classList.remove("perfect-scrollbar-off");
    //     ps = new PerfectScrollbar(this.refs.mainPanel, { suppressScrollX: true });
    //     let tables = document.querySelectorAll(".table-responsive");
    //     for (let i = 0; i < tables.length; i++) {
    //       ps = new PerfectScrollbar(tables[i]);
    //     }
    //   }
    // }, []);
    // //componentDidUpdate
    // useEffect(() => {
    //   if (e.history.action === "PUSH") {
    //     if (navigator.platform.indexOf("Win") > -1) {
    //       let tables = document.querySelectorAll(".table-responsive");
    //       for (let i = 0; i < tables.length; i++) {
    //         ps = new PerfectScrollbar(tables[i]);
    //       }
    //     }
    //     document.documentElement.scrollTop = 0;
    //     document.scrollingElement.scrollTop = 0;
    //     this.refs.mainPanel.scrollTop = 0;
    //   }
    //   //old componentWillUnmount support.. might need a different approach if we see perf issues
    //   return () => {
    //     if (navigator.platform.indexOf("Win") > -1) {
    //       ps.destroy();
    //       document.documentElement.className += " perfect-scrollbar-off";
    //       document.documentElement.classList.remove("perfect-scrollbar-on");
    //     }
    //   }
    // });
    // this function opens and closes the sidebar on small devices
    var toggleSidebar = function() {
        document.documentElement.classList.toggle("nav-open");
        if (!sidebarOpened) setBurgerCssClass("burger-container burger-change");
        else setBurgerCssClass("burger-container");
        setSidebarOpened(!sidebarOpened);
    };
    var toggleLeftSidebar = function(open) {
        return setLeftSidebarOpened(typeof open === 'boolean' ? open : function(o) {
            return !o;
        });
    };
    //get the raw routes (excluding groups)
    //only support one level of hierarchy
    var rawRoutes = function() {
        var result = [];
        for(var i = 0; i < (0, _routesJs.routes).length; i++){
            if ((0, _routesJs.routes)[i].group) for(var ii = 0; ii < (0, _routesJs.routes)[i].routes.length; ii++)result.push((0, _routesJs.routes)[i].routes[ii]);
            else result.push((0, _routesJs.routes)[i]);
        }
        return result;
    };
    var handleSocketMessage = (0, _react.useCallback)(function(message) {
        console.log('new message on app: ', message);
        if (message.type === 'feed') stateAppActions.setNotificationsList(message.data);
    }, []);
    (0, _react.useEffect)(function() {
        history.listen(function(location) {
            stateAppActions.setPageNavTitle("");
            stateAppActions.setPageBackTitle("");
            // Refresh session timeout time when user goes to a new page
            if (history.location.pathname !== "/login") {
                var d = new Date();
                d.setMinutes(d.getMinutes() + 720);
                (0, _cookieServiceDefault.default).setCookie("session_timeout_time", d.getTime(), 1, stateApp.env);
                stateAppActions.setSessionTimeoutTime(d.getTime());
            }
        });
        // initiate web socket
        connect();
        return function() {
            disconnect();
        };
    }, []);
    (0, _react.useEffect)(function() {
        console.log('adding socket messgae handler from app.. ');
        addMessageHandler('app', handleSocketMessage);
        return function() {
            removeMessageHandler('app');
        };
    }, [
        handleSocketMessage,
        addMessageHandler,
        removeMessageHandler
    ]);
    (0, _react.useEffect)(function() {
        if (isSocketOpen) {
            console.log('sending feed message...');
            sendSocketMessage({
                action: 'feed'
            });
        }
    }, [
        isSocketOpen,
        sendSocketMessage
    ]);
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            return (0, _tsGenerator._)(this, function(_state) {
                try {
                    //let message = await OrganizationService.customer_message();
                    if (!isMounted()) return [
                        2
                    ];
                // add resource properties to application state
                // let properties = {}
                // for (let resProperty of resourceProps.data) {
                //   properties[resProperty.name] = resProperty.value
                // }
                // stateAppActions.setResourceProperties(properties)
                // if (message.data && message.data.template) {
                //   let replaceIndex = 0;
                //   const formattedMessage = message.data.template.replace(/<([^>]+)>/g, (match, label) => {
                //       if (!message.data.links || replaceIndex >= message.data.links.length) {
                //           return match;
                //       }
                //       const _link = `<a href="${message.data.links[replaceIndex]}" target="_blank">${label}</a>`;
                //       replaceIndex += 1;
                //       return _link;
                //   });
                //   setCustomerMessage(formattedMessage);
                // }
                } catch (error) {
                    if ((0, _indexDefault.default).isCancel(error)) ;
                    else throw error;
                }
                return [
                    2
                ];
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    var hasNewNotification = ((_stateApp_notifications = stateApp.notifications) === null || _stateApp_notifications === void 0 ? void 0 : (_stateApp_notifications_list = _stateApp_notifications.list) === null || _stateApp_notifications_list === void 0 ? void 0 : _stateApp_notifications_list.length) > 0 && (0, _momentDefault.default)().diff((0, _momentDefault.default)((_stateApp_notifications1 = stateApp.notifications) === null || _stateApp_notifications1 === void 0 ? void 0 : _stateApp_notifications1.list[0].timestamp), 'hours') <= 24;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gdprcookiesJsxDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spoofBannerJsDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leftSidebarDefault.default), {
                        isOpen: leftSidebarOpened,
                        setIsOpen: setLeftSidebarOpened,
                        routes: (0, _routesJs.routes)
                    }),
                    stateApp.env === (0, _enumJsDefault.default).Env.DEV && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarJsxDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                        routes: (0, _routesJs.routes),
                        bgColor: backgroundColor,
                        toggleSidebar: toggleSidebar
                    })),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "main-panel",
                        // ref="mainPanel"
                        data: backgroundColor,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaAnnoucmentJsDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appAlertJsxDefault.default), {
                                visible: stateApp.alert.visible,
                                className: stateApp.alert.className,
                                color: stateApp.alert.color,
                                children: stateApp.alert.content
                            }),
                            customerMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "alert alert-danger mb-0 rounded-0",
                                role: "alert",
                                dangerouslySetInnerHTML: {
                                    __html: customerMessage
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    backgroundColor: "#FFFFFF"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "container-fluid",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row py-2 mx-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col-4 col-xl-auto",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "d-flex ml-2 h-100 align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "d-block d-xl-none mr-2",
                                                            children: !leftSidebarOpened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscJsx.HamburgerMenu), {
                                                                onClick: toggleLeftSidebar
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                            className: "m-0 app-back-title",
                                                            children: stateApp.pageBackTitle
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col text-center text-xl-left",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                        to: "/app/dashboard",
                                                        className: "d-none d-md-inline",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "logo-image my-2",
                                                            src: "data:image/png;base64,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"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "h-100 d-flex d-md-none align-items-center",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                            className: "app-nav-title flex-fill m-0",
                                                            children: stateApp.pageNavTitle
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "d-flex mr-2 h-100 align-items-center justify-content-end",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _policyToggleJsDefault.default), {
                                                            policies: [
                                                                (0, _enumJsDefault.default).Policies.NOTIFICATIONS_VIEW
                                                            ],
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                to: "/app/notifications",
                                                                className: "d-none d-md-inline pr-4 position-relative cursor",
                                                                onClick: function() {
                                                                    return stateAppActions.setNotificationsVisible(true);
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                        className: "far fa-bell",
                                                                        id: "notifications-icon",
                                                                        style: {
                                                                            fontSize: "30px",
                                                                            color: "#BFC5D2"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                                        placement: "bottom",
                                                                        target: "notifications-icon",
                                                                        children: "Notifications & Events"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabbedDashboardJsx.TicketTabIndicator), {
                                                                        enabled: hasNewNotification,
                                                                        style: {
                                                                            top: 0,
                                                                            left: 18
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _policyToggleJsDefault.default), {
                                                            policies: [
                                                                (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                                                            ],
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                                                to: "/app/support",
                                                                className: "d-none d-md-inline pr-4 position-relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                        className: "fal fa-headset",
                                                                        id: "support-ticketing-icon",
                                                                        style: {
                                                                            fontSize: "30px",
                                                                            color: "#BFC5D2"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                                        placement: "bottom",
                                                                        target: "support-ticketing-icon",
                                                                        children: "Support & Ticketing"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabbedDashboardJsx.TicketTabIndicator), {
                                                                        enabled: stateApp.inboxCount > 0,
                                                                        style: {
                                                                            top: 0,
                                                                            left: 23
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                                            to: "/app/contact",
                                                            className: "d-none d-md-inline pr-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                    className: "fal fa-phone-volume",
                                                                    id: "contact-us-icon",
                                                                    style: {
                                                                        fontSize: "30px",
                                                                        color: "#BFC5D2"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                                    placement: "bottom",
                                                                    target: "contact-us-icon",
                                                                    children: "Contact Us"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content position-relative",
                                id: "content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                        fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                                            children: [
                                                rawRoutes().filter(function(e) {
                                                    return (e.envs || []).includes((0, _enumJsDefault.default).Env.ALL) || (e.envs || []).includes(stateApp.env);
                                                }).map(function(_param, i) {
                                                    var Cmp = _param.component, route = (0, _objectWithoutProperties._)(_param, [
                                                        "component"
                                                    ]);
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), (0, _objectSpreadProps._)((0, _objectSpread._)({}, route), {
                                                        path: route.layout + (route.path || ''),
                                                        component: route.component,
                                                        render: function(props) {
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickstreamJsxDefault.default), {
                                                                meta: route.clickstreamMeta,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cmp, (0, _objectSpread._)({}, route.props || {}, props))
                                                            });
                                                        }
                                                    }), i);
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                                    component: (0, _notFoundDefault.default)
                                                })
                                            ]
                                        })
                                    }),
                                    props.location.pathname.indexOf("maps") !== -1 ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerJsxDefault.default), {
                                        fluid: true
                                    }),
                                    ((_stateApp_notifications2 = stateApp.notifications) === null || _stateApp_notifications2 === void 0 ? void 0 : _stateApp_notifications2.visible) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationsFeedDefault.default), {
                                        onToggle: function() {
                                            return stateAppActions.setNotificationsVisible(false);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bladeDefault.default), {
                                title: stateApp.blade.title,
                                visible: stateApp.blade.visible,
                                setBladeState: stateAppActions.setBlade,
                                children: stateApp.blade.content
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentBladeDefault.default), {
                        visible: stateApp.contentBlade.visible,
                        className: stateApp.contentBlade.className,
                        headerClassName: stateApp.contentBlade.headerClassName,
                        title: stateApp.contentBlade.title,
                        footer: stateApp.contentBlade.footer,
                        side: stateApp.contentBlade.side,
                        noBackdrop: stateApp.contentBlade.noBackdrop,
                        setPanelState: stateAppActions.setContentBlade,
                        style: stateApp.contentBlade.style,
                        children: stateApp.contentBlade.content
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscJsx.SessionTimeoutModal), {})
        ]
    });
};
var AppWrapper = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _socketHook.SocketProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(App, (0, _objectSpread._)({}, props))
    });
};
exports.default = AppWrapper;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_object_without_properties":"jGp91","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","axios/index":"ebRwi","reactstrap":"774RE","moment":"3xZWN","react-device-detect":"h7vq0","../../components/Footer/Footer.jsx":"7YDxu","../../components/Sidebar/Sidebar.jsx":"81K3c","../../components/Sidebar/LeftSidebar":"03bSu","../../routes.js":"bvYZI","../../components/Blade/Blade":"6XZur","../../components/Notifications/NotificationsFeed":"avrIg","../../AppState":"8UGXH","../../hooks/SocketHook":"fve0v","../../components/NotFound":"3DAIL","../../components/Dashboard/TabbedDashboard.jsx":"dxAM9","../../components/AppAlert/AppAlert.jsx":"8uaDC","../../components/Clickstream/Clickstream.jsx":"9i4UV","../../utility/enum.js":"3A9fW","../../utility/use-async-effect":"fShZN","../../utility/SpoofBanner.js":"bw1bb","../../utility/ConnectriaAnnoucment.js":"4InhH","../../components/misc.jsx":"5OQBQ","../../components/Blade/ContentBlade":"F0RVy","../../services/CookieService":"iKLPT","../../utility/PolicyToggle.js":"21Lcc","../../components/GDPRCookies/GDPRCookies.jsx":"epiwg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jGp91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"jL1IT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jL1IT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"774RE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownContext", function() {
    return 0, _dropdownContext.DropdownContext;
});
parcelHelpers.export(exports, "Container", function() {
    return 0, _containerDefault.default;
});
parcelHelpers.export(exports, "Row", function() {
    return 0, _rowDefault.default;
});
parcelHelpers.export(exports, "Col", function() {
    return 0, _colDefault.default;
});
parcelHelpers.export(exports, "Navbar", function() {
    return 0, _navbarDefault.default;
});
parcelHelpers.export(exports, "NavbarBrand", function() {
    return 0, _navbarBrandDefault.default;
});
parcelHelpers.export(exports, "NavbarText", function() {
    return 0, _navbarTextDefault.default;
});
parcelHelpers.export(exports, "NavbarToggler", function() {
    return 0, _navbarTogglerDefault.default;
});
parcelHelpers.export(exports, "Nav", function() {
    return 0, _navDefault.default;
});
parcelHelpers.export(exports, "NavItem", function() {
    return 0, _navItemDefault.default;
});
parcelHelpers.export(exports, "NavLink", function() {
    return 0, _navLinkDefault.default;
});
parcelHelpers.export(exports, "Breadcrumb", function() {
    return 0, _breadcrumbDefault.default;
});
parcelHelpers.export(exports, "BreadcrumbItem", function() {
    return 0, _breadcrumbItemDefault.default;
});
parcelHelpers.export(exports, "Button", function() {
    return 0, _buttonDefault.default;
});
parcelHelpers.export(exports, "ButtonToggle", function() {
    return 0, _buttonToggleDefault.default;
});
parcelHelpers.export(exports, "ButtonDropdown", function() {
    return 0, _buttonDropdownDefault.default;
});
parcelHelpers.export(exports, "ButtonGroup", function() {
    return 0, _buttonGroupDefault.default;
});
parcelHelpers.export(exports, "ButtonToolbar", function() {
    return 0, _buttonToolbarDefault.default;
});
parcelHelpers.export(exports, "Dropdown", function() {
    return 0, _dropdownDefault.default;
});
parcelHelpers.export(exports, "DropdownItem", function() {
    return 0, _dropdownItemDefault.default;
});
parcelHelpers.export(exports, "DropdownMenu", function() {
    return 0, _dropdownMenuDefault.default;
});
parcelHelpers.export(exports, "DropdownToggle", function() {
    return 0, _dropdownToggleDefault.default;
});
parcelHelpers.export(exports, "Fade", function() {
    return 0, _fadeDefault.default;
});
parcelHelpers.export(exports, "Badge", function() {
    return 0, _badgeDefault.default;
});
parcelHelpers.export(exports, "Card", function() {
    return 0, _cardDefault.default;
});
parcelHelpers.export(exports, "CardGroup", function() {
    return 0, _cardGroupDefault.default;
});
parcelHelpers.export(exports, "CardDeck", function() {
    return 0, _cardDeckDefault.default;
});
parcelHelpers.export(exports, "CardColumns", function() {
    return 0, _cardColumnsDefault.default;
});
parcelHelpers.export(exports, "CardBody", function() {
    return 0, _cardBodyDefault.default;
});
parcelHelpers.export(exports, "CardLink", function() {
    return 0, _cardLinkDefault.default;
});
parcelHelpers.export(exports, "CardFooter", function() {
    return 0, _cardFooterDefault.default;
});
parcelHelpers.export(exports, "CardHeader", function() {
    return 0, _cardHeaderDefault.default;
});
parcelHelpers.export(exports, "CardImg", function() {
    return 0, _cardImgDefault.default;
});
parcelHelpers.export(exports, "CardImgOverlay", function() {
    return 0, _cardImgOverlayDefault.default;
});
parcelHelpers.export(exports, "Carousel", function() {
    return 0, _carouselDefault.default;
});
parcelHelpers.export(exports, "UncontrolledCarousel", function() {
    return 0, _uncontrolledCarouselDefault.default;
});
parcelHelpers.export(exports, "CarouselControl", function() {
    return 0, _carouselControlDefault.default;
});
parcelHelpers.export(exports, "CarouselItem", function() {
    return 0, _carouselItemDefault.default;
});
parcelHelpers.export(exports, "CarouselIndicators", function() {
    return 0, _carouselIndicatorsDefault.default;
});
parcelHelpers.export(exports, "CarouselCaption", function() {
    return 0, _carouselCaptionDefault.default;
});
parcelHelpers.export(exports, "CardSubtitle", function() {
    return 0, _cardSubtitleDefault.default;
});
parcelHelpers.export(exports, "CardText", function() {
    return 0, _cardTextDefault.default;
});
parcelHelpers.export(exports, "CardTitle", function() {
    return 0, _cardTitleDefault.default;
});
parcelHelpers.export(exports, "CustomFileInput", function() {
    return 0, _customFileInputDefault.default;
});
parcelHelpers.export(exports, "CustomInput", function() {
    return 0, _customInputDefault.default;
});
parcelHelpers.export(exports, "PopperContent", function() {
    return 0, _popperContentDefault.default;
});
parcelHelpers.export(exports, "PopperTargetHelper", function() {
    return 0, _popperTargetHelperDefault.default;
});
parcelHelpers.export(exports, "Popover", function() {
    return 0, _popoverDefault.default;
});
parcelHelpers.export(exports, "UncontrolledPopover", function() {
    return 0, _uncontrolledPopoverDefault.default;
});
parcelHelpers.export(exports, "PopoverHeader", function() {
    return 0, _popoverHeaderDefault.default;
});
parcelHelpers.export(exports, "PopoverBody", function() {
    return 0, _popoverBodyDefault.default;
});
parcelHelpers.export(exports, "Progress", function() {
    return 0, _progressDefault.default;
});
parcelHelpers.export(exports, "Modal", function() {
    return 0, _modalDefault.default;
});
parcelHelpers.export(exports, "ModalHeader", function() {
    return 0, _modalHeaderDefault.default;
});
parcelHelpers.export(exports, "ModalBody", function() {
    return 0, _modalBodyDefault.default;
});
parcelHelpers.export(exports, "ModalFooter", function() {
    return 0, _modalFooterDefault.default;
});
parcelHelpers.export(exports, "Tooltip", function() {
    return 0, _tooltipDefault.default;
});
parcelHelpers.export(exports, "Table", function() {
    return 0, _tableDefault.default;
});
parcelHelpers.export(exports, "ListGroup", function() {
    return 0, _listGroupDefault.default;
});
parcelHelpers.export(exports, "Form", function() {
    return 0, _formDefault.default;
});
parcelHelpers.export(exports, "FormFeedback", function() {
    return 0, _formFeedbackDefault.default;
});
parcelHelpers.export(exports, "FormGroup", function() {
    return 0, _formGroupDefault.default;
});
parcelHelpers.export(exports, "FormText", function() {
    return 0, _formTextDefault.default;
});
parcelHelpers.export(exports, "Input", function() {
    return 0, _inputDefault.default;
});
parcelHelpers.export(exports, "InputGroup", function() {
    return 0, _inputGroupDefault.default;
});
parcelHelpers.export(exports, "InputGroupAddon", function() {
    return 0, _inputGroupAddonDefault.default;
});
parcelHelpers.export(exports, "InputGroupButtonDropdown", function() {
    return 0, _inputGroupButtonDropdownDefault.default;
});
parcelHelpers.export(exports, "InputGroupText", function() {
    return 0, _inputGroupTextDefault.default;
});
parcelHelpers.export(exports, "Label", function() {
    return 0, _labelDefault.default;
});
parcelHelpers.export(exports, "Media", function() {
    return 0, _mediaDefault.default;
});
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _paginationDefault.default;
});
parcelHelpers.export(exports, "PaginationItem", function() {
    return 0, _paginationItemDefault.default;
});
parcelHelpers.export(exports, "PaginationLink", function() {
    return 0, _paginationLinkDefault.default;
});
parcelHelpers.export(exports, "TabContent", function() {
    return 0, _tabContentDefault.default;
});
parcelHelpers.export(exports, "TabPane", function() {
    return 0, _tabPaneDefault.default;
});
parcelHelpers.export(exports, "Jumbotron", function() {
    return 0, _jumbotronDefault.default;
});
parcelHelpers.export(exports, "Alert", function() {
    return 0, _alertDefault.default;
});
parcelHelpers.export(exports, "Toast", function() {
    return 0, _toastDefault.default;
});
parcelHelpers.export(exports, "ToastBody", function() {
    return 0, _toastBodyDefault.default;
});
parcelHelpers.export(exports, "ToastHeader", function() {
    return 0, _toastHeaderDefault.default;
});
parcelHelpers.export(exports, "Collapse", function() {
    return 0, _collapseDefault.default;
});
parcelHelpers.export(exports, "ListGroupItem", function() {
    return 0, _listGroupItemDefault.default;
});
parcelHelpers.export(exports, "ListGroupItemHeading", function() {
    return 0, _listGroupItemHeadingDefault.default;
});
parcelHelpers.export(exports, "ListGroupItemText", function() {
    return 0, _listGroupItemTextDefault.default;
});
parcelHelpers.export(exports, "List", function() {
    return 0, _listDefault.default;
});
parcelHelpers.export(exports, "ListInlineItem", function() {
    return 0, _listInlineItemDefault.default;
});
parcelHelpers.export(exports, "UncontrolledAlert", function() {
    return 0, _uncontrolledAlertDefault.default;
});
parcelHelpers.export(exports, "UncontrolledButtonDropdown", function() {
    return 0, _uncontrolledButtonDropdownDefault.default;
});
parcelHelpers.export(exports, "UncontrolledCollapse", function() {
    return 0, _uncontrolledCollapseDefault.default;
});
parcelHelpers.export(exports, "UncontrolledDropdown", function() {
    return 0, _uncontrolledDropdownDefault.default;
});
parcelHelpers.export(exports, "UncontrolledTooltip", function() {
    return 0, _uncontrolledTooltipDefault.default;
});
parcelHelpers.export(exports, "Spinner", function() {
    return 0, _spinnerDefault.default;
});
parcelHelpers.export(exports, "Util", function() {
    return _utils;
});
parcelHelpers.export(exports, "Polyfill", function() {
    return _polyfill;
});
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _row = require("./Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _navbarToggler = require("./NavbarToggler");
var _navbarTogglerDefault = parcelHelpers.interopDefault(_navbarToggler);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _breadcrumb = require("./Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonToggle = require("./ButtonToggle");
var _buttonToggleDefault = parcelHelpers.interopDefault(_buttonToggle);
var _buttonDropdown = require("./ButtonDropdown");
var _buttonDropdownDefault = parcelHelpers.interopDefault(_buttonDropdown);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonToolbar = require("./ButtonToolbar");
var _buttonToolbarDefault = parcelHelpers.interopDefault(_buttonToolbar);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownContext = require("./DropdownContext");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardGroup = require("./CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardDeck = require("./CardDeck");
var _cardDeckDefault = parcelHelpers.interopDefault(_cardDeck);
var _cardColumns = require("./CardColumns");
var _cardColumnsDefault = parcelHelpers.interopDefault(_cardColumns);
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _uncontrolledCarousel = require("./UncontrolledCarousel");
var _uncontrolledCarouselDefault = parcelHelpers.interopDefault(_uncontrolledCarousel);
var _carouselControl = require("./CarouselControl");
var _carouselControlDefault = parcelHelpers.interopDefault(_carouselControl);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _carouselIndicators = require("./CarouselIndicators");
var _carouselIndicatorsDefault = parcelHelpers.interopDefault(_carouselIndicators);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _customFileInput = require("./CustomFileInput");
var _customFileInputDefault = parcelHelpers.interopDefault(_customFileInput);
var _customInput = require("./CustomInput");
var _customInputDefault = parcelHelpers.interopDefault(_customInput);
var _popperContent = require("./PopperContent");
var _popperContentDefault = parcelHelpers.interopDefault(_popperContent);
var _popperTargetHelper = require("./PopperTargetHelper");
var _popperTargetHelperDefault = parcelHelpers.interopDefault(_popperTargetHelper);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _uncontrolledPopover = require("./UncontrolledPopover");
var _uncontrolledPopoverDefault = parcelHelpers.interopDefault(_uncontrolledPopover);
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _progress = require("./Progress");
var _progressDefault = parcelHelpers.interopDefault(_progress);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _listGroup = require("./ListGroup");
var _listGroupDefault = parcelHelpers.interopDefault(_listGroup);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formFeedback = require("./FormFeedback");
var _formFeedbackDefault = parcelHelpers.interopDefault(_formFeedback);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputGroup = require("./InputGroup");
var _inputGroupDefault = parcelHelpers.interopDefault(_inputGroup);
var _inputGroupAddon = require("./InputGroupAddon");
var _inputGroupAddonDefault = parcelHelpers.interopDefault(_inputGroupAddon);
var _inputGroupButtonDropdown = require("./InputGroupButtonDropdown");
var _inputGroupButtonDropdownDefault = parcelHelpers.interopDefault(_inputGroupButtonDropdown);
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _label = require("./Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _media = require("./Media");
var _mediaDefault = parcelHelpers.interopDefault(_media);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _paginationLink = require("./PaginationLink");
var _paginationLinkDefault = parcelHelpers.interopDefault(_paginationLink);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _jumbotron = require("./Jumbotron");
var _jumbotronDefault = parcelHelpers.interopDefault(_jumbotron);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _toast = require("./Toast");
var _toastDefault = parcelHelpers.interopDefault(_toast);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _listGroupItemHeading = require("./ListGroupItemHeading");
var _listGroupItemHeadingDefault = parcelHelpers.interopDefault(_listGroupItemHeading);
var _listGroupItemText = require("./ListGroupItemText");
var _listGroupItemTextDefault = parcelHelpers.interopDefault(_listGroupItemText);
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listInlineItem = require("./ListInlineItem");
var _listInlineItemDefault = parcelHelpers.interopDefault(_listInlineItem);
var _uncontrolledAlert = require("./UncontrolledAlert");
var _uncontrolledAlertDefault = parcelHelpers.interopDefault(_uncontrolledAlert);
var _uncontrolledButtonDropdown = require("./UncontrolledButtonDropdown");
var _uncontrolledButtonDropdownDefault = parcelHelpers.interopDefault(_uncontrolledButtonDropdown);
var _uncontrolledCollapse = require("./UncontrolledCollapse");
var _uncontrolledCollapseDefault = parcelHelpers.interopDefault(_uncontrolledCollapse);
var _uncontrolledDropdown = require("./UncontrolledDropdown");
var _uncontrolledDropdownDefault = parcelHelpers.interopDefault(_uncontrolledDropdown);
var _uncontrolledTooltip = require("./UncontrolledTooltip");
var _uncontrolledTooltipDefault = parcelHelpers.interopDefault(_uncontrolledTooltip);
var _spinner = require("./Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _utils = require("./utils");
var _polyfill = require("./polyfill");

},{"./Container":"lssg4","./Row":"feMQW","./Col":"kb3RQ","./Navbar":"c4YiZ","./NavbarBrand":"finZZ","./NavbarText":"iiDeG","./NavbarToggler":"i5kUI","./Nav":"gxAd3","./NavItem":"4rwVv","./NavLink":"2VNlE","./Breadcrumb":"gsc2f","./BreadcrumbItem":"g1wQs","./Button":"4pJkl","./ButtonToggle":"2wAfE","./ButtonDropdown":"7h9vu","./ButtonGroup":"5IYuG","./ButtonToolbar":"jjmW4","./Dropdown":"9IyKZ","./DropdownItem":"aCCFh","./DropdownMenu":"lv8uF","./DropdownToggle":"aQzhl","./DropdownContext":"ge2gh","./Fade":"8vV1v","./Badge":"4MgDk","./Card":"kkCEm","./CardGroup":"hI19x","./CardDeck":"kSyJH","./CardColumns":"931mj","./CardBody":"10ZSh","./CardLink":"jxmYX","./CardFooter":"bDlo6","./CardHeader":"6H9TY","./CardImg":"mhIu3","./CardImgOverlay":"4JjB8","./Carousel":"jVfRV","./UncontrolledCarousel":"hUrHE","./CarouselControl":"awpJP","./CarouselItem":"aA3j6","./CarouselIndicators":"irxCr","./CarouselCaption":"aHq2o","./CardSubtitle":"imVni","./CardText":"b27ZA","./CardTitle":"iPDUM","./CustomFileInput":"2GB2h","./CustomInput":"ermL6","./PopperContent":"3quYG","./PopperTargetHelper":"igQkg","./Popover":"cWyeN","./UncontrolledPopover":"eXOei","./PopoverHeader":"j4eLo","./PopoverBody":"8nhQB","./Progress":"cMX9w","./Modal":"8tDiG","./ModalHeader":"hPCLT","./ModalBody":"aaWGA","./ModalFooter":"91ciL","./Tooltip":"3Zg6S","./Table":"jvH2l","./ListGroup":"iDJqV","./Form":"2gf62","./FormFeedback":"aMpcp","./FormGroup":"79mrW","./FormText":"iIXko","./Input":"gH52C","./InputGroup":"1kZ4h","./InputGroupAddon":"9Kprt","./InputGroupButtonDropdown":"4aOb8","./InputGroupText":"kmtcq","./Label":"fWy5I","./Media":"ekIhP","./Pagination":"foGKi","./PaginationItem":"8yW3k","./PaginationLink":"49YCh","./TabContent":"aPGhq","./TabPane":"8LEkw","./Jumbotron":"cZbBH","./Alert":"2a0hr","./Toast":"d4Bat","./ToastBody":"dk4p5","./ToastHeader":"8TKxu","./Collapse":"8W5Oc","./ListGroupItem":"lsxVT","./ListGroupItemHeading":"iswj9","./ListGroupItemText":"8g9r0","./List":"kb1Il","./ListInlineItem":"3IDO2","./UncontrolledAlert":"hvzcv","./UncontrolledButtonDropdown":"a3sJ8","./UncontrolledCollapse":"1N0HO","./UncontrolledDropdown":"2XASb","./UncontrolledTooltip":"9Bhl8","./Spinner":"4sl4k","./utils":"ca6o0","./polyfill":"lirjB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lssg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "fluid",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    fluid: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var Container = function Container(props) {
    var className = props.className, cssModule = props.cssModule, fluid = props.fluid, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var containerClass = 'container';
    if (fluid === true) containerClass = 'container-fluid';
    else if (fluid) containerClass = "container-" + fluid;
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, containerClass), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
exports.default = Container;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6P5cq":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg);
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === 'object') {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && (0, _typeOf._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{"@swc/helpers/_/_type_of":"668P4"}],"ca6o0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScrollbarWidth", function() {
    return getScrollbarWidth;
});
parcelHelpers.export(exports, "setScrollbarWidth", function() {
    return setScrollbarWidth;
});
parcelHelpers.export(exports, "isBodyOverflowing", function() {
    return isBodyOverflowing;
});
parcelHelpers.export(exports, "getOriginalBodyPadding", function() {
    return getOriginalBodyPadding;
});
parcelHelpers.export(exports, "conditionallyUpdateScrollbar", function() {
    return conditionallyUpdateScrollbar;
});
parcelHelpers.export(exports, "setGlobalCssModule", function() {
    return setGlobalCssModule;
});
parcelHelpers.export(exports, "mapToCssModules", function() {
    return mapToCssModules;
});
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */ parcelHelpers.export(exports, "omit", function() {
    return omit;
});
/**
 * Returns a filtered copy of an object with only the specified keys.
 */ parcelHelpers.export(exports, "pick", function() {
    return pick;
});
parcelHelpers.export(exports, "warnOnce", function() {
    return warnOnce;
});
parcelHelpers.export(exports, "deprecated", function() {
    return deprecated;
}) // Shim Element if needed (e.g. in Node environment)
;
parcelHelpers.export(exports, "DOMElement", function() {
    return DOMElement;
});
parcelHelpers.export(exports, "targetPropType", function() {
    return targetPropType;
});
parcelHelpers.export(exports, "tagPropType", function() {
    return tagPropType;
});
parcelHelpers.export(exports, "TransitionTimeouts", function() {
    return TransitionTimeouts;
});
parcelHelpers.export(exports, "TransitionPropTypeKeys", function() {
    return TransitionPropTypeKeys;
});
parcelHelpers.export(exports, "TransitionStatuses", function() {
    return TransitionStatuses;
});
parcelHelpers.export(exports, "keyCodes", function() {
    return keyCodes;
});
parcelHelpers.export(exports, "PopperPlacements", function() {
    return PopperPlacements;
});
parcelHelpers.export(exports, "canUseDOM", function() {
    return canUseDOM;
});
parcelHelpers.export(exports, "isReactRefObj", function() {
    return isReactRefObj;
});
parcelHelpers.export(exports, "toNumber", function() {
    return toNumber;
});
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "isFunction", function() {
    return isFunction;
});
parcelHelpers.export(exports, "findDOMElements", function() {
    return findDOMElements;
});
parcelHelpers.export(exports, "isArrayOrNodeList", function() {
    return isArrayOrNodeList;
});
parcelHelpers.export(exports, "getTarget", function() {
    return getTarget;
});
parcelHelpers.export(exports, "defaultToggleEvents", function() {
    return defaultToggleEvents;
});
parcelHelpers.export(exports, "addMultipleEventListeners", function() {
    return addMultipleEventListeners;
});
parcelHelpers.export(exports, "focusableElements", function() {
    return focusableElements;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _propTypes = require("prop-types"); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function getScrollbarWidth() {
    var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
    var style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
    var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
    var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if (isBodyOverflowing()) setScrollbarWidth(bodyPadding + scrollbarWidth);
}
var globalCssModule;
function setGlobalCssModule(cssModule) {
    globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
    if (className === void 0) className = '';
    if (cssModule === void 0) cssModule = globalCssModule;
    if (!cssModule) return className;
    return className.split(' ').map(function(c) {
        return cssModule[c] || c;
    }).join(' ');
}
function omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
function pick(obj, keys) {
    var pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    var length = pickKeys.length;
    var key;
    var result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
var warned = {};
function warnOnce(message) {
    if (!warned[message]) {
        /* istanbul ignore else */ if (typeof console !== 'undefined') console.error(message); // eslint-disable-line no-console
        warned[message] = true;
    }
}
function deprecated(propType, explanation) {
    return function validate(props, propName, componentName) {
        if (props[propName] !== null && typeof props[propName] !== 'undefined') warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
}
var Element = (typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === 'object' && window.Element || function() {};
function DOMElement(props, propName, componentName) {
    if (!(props[propName] instanceof Element)) return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
}
var targetPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).func,
    DOMElement,
    (0, _propTypesDefault.default).shape({
        current: (0, _propTypesDefault.default).any
    })
]);
var tagPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        $$typeof: (0, _propTypesDefault.default).symbol,
        render: (0, _propTypesDefault.default).func
    }),
    (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            $$typeof: (0, _propTypesDefault.default).symbol,
            render: (0, _propTypesDefault.default).func
        })
    ]))
]);
var TransitionTimeouts = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600 // $carousel-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
var TransitionPropTypeKeys = [
    'in',
    'mountOnEnter',
    'unmountOnExit',
    'appear',
    'enter',
    'exit',
    'timeout',
    'onEnter',
    'onEntering',
    'onEntered',
    'onExit',
    'onExiting',
    'onExited'
];
var TransitionStatuses = {
    ENTERING: 'entering',
    ENTERED: 'entered',
    EXITING: 'exiting',
    EXITED: 'exited'
};
var keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
var PopperPlacements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
    if (target && (typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target)) === 'object') return 'current' in target;
    return false;
}
function getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
function toNumber(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    var NAN = 0 / 0;
    if (type === 'number') return value;
    if (type === 'symbol' || type === 'object' && getTag(value) === '[object Symbol]') return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf === 'function' ? value.valueOf() : value;
        value = isObject(other) ? "" + other : other;
    }
    if (type !== 'string') return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, '');
    var isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type === 'object' || type === 'function');
}
function isFunction(value) {
    if (!isObject(value)) return false;
    var tag = getTag(value);
    return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}
function findDOMElements(target) {
    if (isReactRefObj(target)) return target.current;
    if (isFunction(target)) return target();
    if (typeof target === 'string' && canUseDOM) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll("#" + target);
        if (!selection.length) throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        return selection;
    }
    return target;
}
function isArrayOrNodeList(els) {
    if (els === null) return false;
    return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}
function getTarget(target, allElements) {
    var els = findDOMElements(target);
    if (allElements) {
        if (isArrayOrNodeList(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if (isArrayOrNodeList(els)) return els[0];
        return els;
    }
}
var defaultToggleEvents = [
    'touchstart',
    'click'
];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
    var els = _els;
    if (!isArrayOrNodeList(els)) els = [
        els
    ];
    var events = _events;
    if (typeof events === 'string') events = events.split(/\s+/);
    if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
    Array.prototype.forEach.call(events, function(event) {
        Array.prototype.forEach.call(els, function(el) {
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, function(event) {
            Array.prototype.forEach.call(els, function(el) {
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
var focusableElements = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'object',
    'embed',
    '[tabindex]:not(.modal)',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
];

},{"@swc/helpers/_/_type_of":"668P4","prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"feMQW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "noGutters",
    "tag",
    "form",
    "widths"
];
var rowColWidths = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
var rowColsPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var propTypes = {
    tag: (0, _utils.tagPropType),
    noGutters: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    form: (0, _propTypesDefault.default).bool,
    xs: rowColsPropType,
    sm: rowColsPropType,
    md: rowColsPropType,
    lg: rowColsPropType,
    xl: rowColsPropType
};
var defaultProps = {
    tag: 'div',
    widths: rowColWidths
};
var Row = function Row(props) {
    var className = props.className, cssModule = props.cssModule, noGutters = props.noGutters, Tag = props.tag, form = props.form, widths = props.widths, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var colSize = props[colWidth];
        delete attributes[colWidth];
        if (!colSize) return;
        var isXs = !i;
        colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
    });
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
exports.default = Row;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kb3RQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "widths",
    "tag"
];
var colWidths = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
var stringOrNumberProp = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var columnProps = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        size: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        order: stringOrNumberProp,
        offset: stringOrNumberProp
    })
]);
var propTypes = {
    tag: (0, _utils.tagPropType),
    xs: columnProps,
    sm: columnProps,
    md: columnProps,
    lg: columnProps,
    xl: columnProps,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    widths: (0, _propTypesDefault.default).array
};
var defaultProps = {
    tag: 'div',
    widths: colWidths
};
var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === '') return isXs ? 'col' : "col-" + colWidth;
    else if (colSize === 'auto') return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var Col = function Col(props) {
    var className = props.className, cssModule = props.cssModule, widths = props.widths, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== '') return;
        var isXs = !i;
        if ((0, _utils.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
            var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, _utils.mapToCssModules)((0, _classnamesDefault.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
        } else {
            var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(_colClass);
        }
    });
    if (!colClasses.length) colClasses.push('col');
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, colClasses), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
exports.default = Col;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c4YiZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "expand",
    "className",
    "cssModule",
    "light",
    "dark",
    "fixed",
    "sticky",
    "color",
    "tag"
];
var propTypes = {
    light: (0, _propTypesDefault.default).bool,
    dark: (0, _propTypesDefault.default).bool,
    full: (0, _propTypesDefault.default).bool,
    fixed: (0, _propTypesDefault.default).string,
    sticky: (0, _propTypesDefault.default).string,
    color: (0, _propTypesDefault.default).string,
    role: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    expand: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ])
};
var defaultProps = {
    tag: 'nav',
    expand: false
};
var getExpandClass = function getExpandClass(expand) {
    if (expand === false) return false;
    else if (expand === true || expand === 'xs') return 'navbar-expand';
    return "navbar-expand-" + expand;
};
var Navbar = function Navbar(props) {
    var _classNames;
    var expand = props.expand, className = props.className, cssModule = props.cssModule, light = props.light, dark = props.dark, fixed = props.fixed, sticky = props.sticky, color = props.color, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'navbar', getExpandClass(expand), (_classNames = {
        'navbar-light': light,
        'navbar-dark': dark
    }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
exports.default = Navbar;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"finZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'a'
};
var NavbarBrand = function NavbarBrand(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'navbar-brand'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
NavbarBrand.propTypes = propTypes;
NavbarBrand.defaultProps = defaultProps;
exports.default = NavbarBrand;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iiDeG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'span'
};
var NavbarText = function NavbarText(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'navbar-text'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
NavbarText.propTypes = propTypes;
NavbarText.defaultProps = defaultProps;
exports.default = NavbarText;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i5kUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "children",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    type: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node
};
var defaultProps = {
    tag: 'button',
    type: 'button'
};
var NavbarToggler = function NavbarToggler(props) {
    var className = props.className, cssModule = props.cssModule, children = props.children, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'navbar-toggler'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
        "aria-label": "Toggle navigation"
    }, attributes, {
        className: classes
    }), children || /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.mapToCssModules)('navbar-toggler-icon', cssModule)
    }));
};
NavbarToggler.propTypes = propTypes;
NavbarToggler.defaultProps = defaultProps;
exports.default = NavbarToggler;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gxAd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tabs",
    "pills",
    "vertical",
    "horizontal",
    "justified",
    "fill",
    "navbar",
    "card",
    "tag"
];
var propTypes = {
    tabs: (0, _propTypesDefault.default).bool,
    pills: (0, _propTypesDefault.default).bool,
    vertical: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    horizontal: (0, _propTypesDefault.default).string,
    justified: (0, _propTypesDefault.default).bool,
    fill: (0, _propTypesDefault.default).bool,
    navbar: (0, _propTypesDefault.default).bool,
    card: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'ul',
    vertical: false
};
var getVerticalClass = function getVerticalClass(vertical) {
    if (vertical === false) return false;
    else if (vertical === true || vertical === 'xs') return 'flex-column';
    return "flex-" + vertical + "-column";
};
var Nav = function Nav(props) {
    var className = props.className, cssModule = props.cssModule, tabs = props.tabs, pills = props.pills, vertical = props.vertical, horizontal = props.horizontal, justified = props.justified, fill = props.fill, navbar = props.navbar, card = props.card, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, navbar ? 'navbar-nav' : 'nav', horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
        'nav-tabs': tabs,
        'card-header-tabs': card && tabs,
        'nav-pills': pills,
        'card-header-pills': card && pills,
        'nav-justified': justified,
        'nav-fill': fill
    }), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
exports.default = Nav;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rwVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'li'
};
var NavItem = function NavItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'nav-item', active ? 'active' : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
exports.default = NavItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VNlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag",
    "innerRef"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    disabled: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    onClick: (0, _propTypesDefault.default).func,
    href: (0, _propTypesDefault.default).any
};
var defaultProps = {
    tag: 'a'
};
var NavLink = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(NavLink, _React$Component);
    function NavLink(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = NavLink.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.href === '#') e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, active = _this$props.active, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'nav-link', {
            disabled: attributes.disabled,
            active: active
        }), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            onClick: this.onClick,
            className: classes
        }));
    };
    return NavLink;
}((0, _reactDefault.default).Component);
NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;
exports.default = NavLink;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9WRWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _assertThisInitialized;
});
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsc2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "listClassName",
    "cssModule",
    "children",
    "tag",
    "listTag",
    "aria-label"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    listTag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    listClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    'aria-label': (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'nav',
    listTag: 'ol',
    'aria-label': 'breadcrumb'
};
var Breadcrumb = function Breadcrumb(props) {
    var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, children = props.children, Tag = props.tag, ListTag = props.listTag, label = props['aria-label'], attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className), cssModule);
    var listClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('breadcrumb', listClassName), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        "aria-label": label
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ListTag, {
        className: listClasses
    }, children));
};
Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;
exports.default = Breadcrumb;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g1wQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'li'
};
var BreadcrumbItem = function BreadcrumbItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        "aria-current": active ? 'page' : undefined
    }));
};
BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
exports.default = BreadcrumbItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4pJkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "active",
    "aria-label",
    "block",
    "className",
    "close",
    "cssModule",
    "color",
    "outline",
    "size",
    "tag",
    "innerRef"
];
var propTypes = {
    active: (0, _propTypesDefault.default).bool,
    'aria-label': (0, _propTypesDefault.default).string,
    block: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    outline: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    onClick: (0, _propTypesDefault.default).func,
    size: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    close: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    color: 'secondary',
    tag: 'button'
};
var Button = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Button, _React$Component);
    function Button(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Button.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) return this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, ariaLabel = _this$props['aria-label'], block = _this$props.block, className = _this$props.className, close = _this$props.close, cssModule = _this$props.cssModule, color = _this$props.color, outline = _this$props.outline, size = _this$props.size, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        if (close && typeof attributes.children === 'undefined') attributes.children = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": true
        }, "\xD7");
        var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            close: close
        }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
            active: active,
            disabled: this.props.disabled
        }), cssModule);
        if (attributes.href && Tag === 'button') Tag = 'a';
        var defaultAriaLabel = close ? 'Close' : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            type: Tag === 'button' && attributes.onClick ? 'button' : undefined
        }, attributes, {
            className: classes,
            ref: innerRef,
            onClick: this.onClick,
            "aria-label": ariaLabel || defaultAriaLabel
        }));
    };
    return Button;
}((0, _reactDefault.default).Component);
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
exports.default = Button;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2wAfE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className"
];
var propTypes = {
    onClick: (0, _propTypesDefault.default).func,
    onBlur: (0, _propTypesDefault.default).func,
    onFocus: (0, _propTypesDefault.default).func,
    defaultValue: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    defaultValue: false
};
var ButtonToggle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ButtonToggle, _React$Component);
    function ButtonToggle(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            toggled: props.defaultValue,
            focus: false
        };
        _this.onBlur = _this.onBlur.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onFocus = _this.onFocus.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = ButtonToggle.prototype;
    _proto.onBlur = function onBlur(e) {
        if (this.props.onBlur) this.props.onBlur(e);
        this.setState({
            focus: false
        });
    };
    _proto.onFocus = function onFocus(e) {
        if (this.props.onFocus) this.props.onFocus(e);
        this.setState({
            focus: true
        });
    };
    _proto.onClick = function onClick(e) {
        if (this.props.onClick) this.props.onClick(e);
        this.setState(function(_ref) {
            var toggled = _ref.toggled;
            return {
                toggled: !toggled
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            focus: this.state.focus
        }), this.props.cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), (0, _extendsDefault.default)({
            active: this.state.toggled,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            onClick: this.onClick,
            className: classes
        }, attributes));
    };
    return ButtonToggle;
}((0, _reactDefault.default).Component);
ButtonToggle.propTypes = propTypes;
ButtonToggle.defaultProps = defaultProps;
exports.default = ButtonToggle;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Button":"4pJkl","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7h9vu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var propTypes = {
    children: (0, _propTypesDefault.default).node
};
var ButtonDropdown = function ButtonDropdown(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownDefault.default), (0, _extendsDefault.default)({
        group: true
    }, props));
};
ButtonDropdown.propTypes = propTypes;
exports.default = ButtonDropdown;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","./Dropdown":"9IyKZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9IyKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
/* eslint react/no-find-dom-node: 0 */ // https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactPopper = require("react-popper");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "direction",
    "isOpen",
    "group",
    "size",
    "nav",
    "setActiveFromChild",
    "active",
    "addonType",
    "tag",
    "menuRole"
];
var propTypes = {
    a11y: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    direction: (0, _propTypesDefault.default).oneOf([
        'up',
        'down',
        'left',
        'right'
    ]),
    group: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    nav: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    addonType: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).oneOf([
            'prepend',
            'append'
        ])
    ]),
    size: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    toggle: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    inNavbar: (0, _propTypesDefault.default).bool,
    setActiveFromChild: (0, _propTypesDefault.default).bool,
    menuRole: (0, _propTypesDefault.default).oneOf([
        'listbox',
        'menu'
    ])
};
var defaultProps = {
    a11y: true,
    isOpen: false,
    direction: 'down',
    nav: false,
    active: false,
    addonType: false,
    inNavbar: false,
    setActiveFromChild: false
};
var preventDefaultKeys = [
    (0, _utils.keyCodes).space,
    (0, _utils.keyCodes).enter,
    (0, _utils.keyCodes).up,
    (0, _utils.keyCodes).down,
    (0, _utils.keyCodes).end,
    (0, _utils.keyCodes).home
];
var Dropdown = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Dropdown, _React$Component);
    function Dropdown(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.addEvents = _this.addEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleMenuRef = _this.handleMenuRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.containerRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        _this.menuRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.handleMenuRef = function handleMenuRef(menuRef) {
        this.menuRef.current = menuRef;
    };
    _proto.getContextValue = function getContextValue() {
        return {
            toggle: this.toggle,
            isOpen: this.props.isOpen,
            direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
            inNavbar: this.props.inNavbar,
            disabled: this.props.disabled,
            // Callback that should be called by DropdownMenu to provide a ref to
            // a HTML tag that's used for the DropdownMenu
            onMenuRef: this.handleMenuRef,
            menuRole: this.props.menuRole
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.handleProps();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) this.handleProps();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.removeEvents();
    };
    _proto.getContainer = function getContainer() {
        return this.containerRef.current;
    };
    _proto.getMenu = function getMenu() {
        return this.menuRef.current;
    };
    _proto.getMenuCtrl = function getMenuCtrl() {
        if (this._$menuCtrl) return this._$menuCtrl;
        this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
        return this._$menuCtrl;
    };
    _proto.getItemType = function getItemType() {
        if (this.context.menuRole === 'listbox') return 'option';
        return 'menuitem';
    };
    _proto.getMenuItems = function getMenuItems() {
        // In a real menu with a child DropdownMenu, `this.getMenu()` should never
        // be null, but it is sometimes null in tests. To mitigate that, we just
        // use `this.getContainer()` as the fallback `menuContainer`.
        var menuContainer = this.getMenu() || this.getContainer();
        return [].slice.call(menuContainer.querySelectorAll("[role=\"" + this.getItemType() + "\"]"));
    };
    _proto.addEvents = function addEvents() {
        var _this2 = this;
        [
            'click',
            'touchstart',
            'keyup'
        ].forEach(function(event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
        });
    };
    _proto.removeEvents = function removeEvents() {
        var _this3 = this;
        [
            'click',
            'touchstart',
            'keyup'
        ].forEach(function(event) {
            return document.removeEventListener(event, _this3.handleDocumentClick, true);
        });
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        if (e && (e.which === 3 || e.type === 'keyup' && e.which !== (0, _utils.keyCodes).tab)) return;
        var container = this.getContainer();
        var menu = this.getMenu();
        var clickIsInContainer = container.contains(e.target) && container !== e.target;
        var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
        if ((clickIsInContainer || clickIsInMenu) && (e.type !== 'keyup' || e.which === (0, _utils.keyCodes).tab)) return;
        this.toggle(e);
    };
    _proto.handleKeyDown = function handleKeyDown(e) {
        var _this4 = this;
        var isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
        var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
        var isTab = (0, _utils.keyCodes).tab === e.which;
        if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) return;
        if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) e.preventDefault();
        if (this.props.disabled) return;
        if (isTargetMenuCtrl) {
            if ([
                (0, _utils.keyCodes).space,
                (0, _utils.keyCodes).enter,
                (0, _utils.keyCodes).up,
                (0, _utils.keyCodes).down
            ].indexOf(e.which) > -1) {
                // Open the menu (if not open) and focus the first menu item
                if (!this.props.isOpen) this.toggle(e);
                setTimeout(function() {
                    return _this4.getMenuItems()[0].focus();
                });
            } else if (this.props.isOpen && isTab) {
                // Focus the first menu item if tabbing from an open menu. We need this
                // for cases where the DropdownMenu sets a custom container, which may
                // not be the natural next item to tab to from the DropdownToggle.
                e.preventDefault();
                this.getMenuItems()[0].focus();
            } else if (this.props.isOpen && e.which === (0, _utils.keyCodes).esc) this.toggle(e);
        }
        if (this.props.isOpen && isTargetMenuItem) {
            if ([
                (0, _utils.keyCodes).tab,
                (0, _utils.keyCodes).esc
            ].indexOf(e.which) > -1) {
                this.toggle(e);
                this.getMenuCtrl().focus();
            } else if ([
                (0, _utils.keyCodes).space,
                (0, _utils.keyCodes).enter
            ].indexOf(e.which) > -1) {
                e.target.click();
                this.getMenuCtrl().focus();
            } else if ([
                (0, _utils.keyCodes).down,
                (0, _utils.keyCodes).up
            ].indexOf(e.which) > -1 || [
                (0, _utils.keyCodes).n,
                (0, _utils.keyCodes).p
            ].indexOf(e.which) > -1 && e.ctrlKey) {
                var $menuitems = this.getMenuItems();
                var index = $menuitems.indexOf(e.target);
                if ((0, _utils.keyCodes).up === e.which || (0, _utils.keyCodes).p === e.which && e.ctrlKey) index = index !== 0 ? index - 1 : $menuitems.length - 1;
                else if ((0, _utils.keyCodes).down === e.which || (0, _utils.keyCodes).n === e.which && e.ctrlKey) index = index === $menuitems.length - 1 ? 0 : index + 1;
                $menuitems[index].focus();
            } else if ((0, _utils.keyCodes).end === e.which) {
                var _$menuitems = this.getMenuItems();
                _$menuitems[_$menuitems.length - 1].focus();
            } else if ((0, _utils.keyCodes).home === e.which) {
                var _$menuitems2 = this.getMenuItems();
                _$menuitems2[0].focus();
            } else if (e.which >= 48 && e.which <= 90) {
                var _$menuitems3 = this.getMenuItems();
                var charPressed = String.fromCharCode(e.which).toLowerCase();
                for(var i = 0; i < _$menuitems3.length; i += 1){
                    var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
                    if (firstLetter === charPressed) {
                        _$menuitems3[i].focus();
                        break;
                    }
                }
            }
        }
    };
    _proto.handleProps = function handleProps() {
        if (this.props.isOpen) this.addEvents();
        else this.removeEvents();
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _classNames, _ref;
        var _omit = (0, _utils.omit)(this.props, [
            'toggle',
            'disabled',
            'inNavbar',
            'a11y'
        ]), className = _omit.className, cssModule = _omit.cssModule, direction = _omit.direction, isOpen = _omit.isOpen, group = _omit.group, size = _omit.size, nav = _omit.nav, setActiveFromChild = _omit.setActiveFromChild, active = _omit.active, addonType = _omit.addonType, tag = _omit.tag, menuRole = _omit.menuRole, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_omit, _excluded);
        var Tag = tag || (nav ? 'li' : 'div');
        var subItemIsActive = false;
        if (setActiveFromChild) (0, _reactDefault.default).Children.map(this.props.children[1].props.children, function(dropdownItem) {
            if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
        });
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownContext.DropdownContext).Provider, {
            value: this.getContextValue()
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Manager), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
            onKeyDown: this.handleKeyDown,
            className: classes
        }))));
    };
    return Dropdown;
}((0, _reactDefault.default).Component);
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
exports.default = Dropdown;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","react-popper":"41KST","classnames":"6P5cq","./DropdownContext":"ge2gh","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"41KST":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return 0, _popperDefault.default;
}) // Public types
;
parcelHelpers.export(exports, "placements", function() {
    return 0, _popper.placements;
});
parcelHelpers.export(exports, "Manager", function() {
    return 0, _managerDefault.default;
});
parcelHelpers.export(exports, "Reference", function() {
    return 0, _referenceDefault.default;
});
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _manager = require("./Manager");
var _managerDefault = parcelHelpers.interopDefault(_manager);
var _reference = require("./Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);

},{"./Popper":"cruEZ","./Manager":"pf295","./Reference":"bFkHx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cruEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerPopper", function() {
    return InnerPopper;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "default", function() {
    return Popper;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _deepEqual = require("deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _react = require("react");
var _popperJs = require("popper.js");
var _popperJsDefault = parcelHelpers.interopDefault(_popperJs);
var _manager = require("./Manager");
var _utils = require("./utils");
var initialStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerPopper, _React$Component);
    function InnerPopper() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "state", {
            data: undefined,
            placement: undefined
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperInstance", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "arrowNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setPopperNode", function(popperNode) {
            if (!popperNode || _this.popperNode === popperNode) return;
            (0, _utils.setRef)(_this.props.innerRef, popperNode);
            _this.popperNode = popperNode;
            _this.updatePopperInstance();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setArrowNode", function(arrowNode) {
            _this.arrowNode = arrowNode;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updateStateModifier", {
            enabled: true,
            order: 900,
            fn: function fn(data) {
                var placement = data.placement;
                _this.setState({
                    data: data,
                    placement: placement
                });
                return data;
            }
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOptions", function() {
            return {
                placement: _this.props.placement,
                eventsEnabled: _this.props.eventsEnabled,
                positionFixed: _this.props.positionFixed,
                modifiers: (0, _extendsDefault.default)({}, _this.props.modifiers, {
                    arrow: (0, _extendsDefault.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
                        enabled: !!_this.arrowNode,
                        element: _this.arrowNode
                    }),
                    applyStyle: {
                        enabled: false
                    },
                    updateStateModifier: _this.updateStateModifier
                })
            };
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperStyle", function() {
            return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extendsDefault.default)({
                position: _this.state.data.offsets.popper.position
            }, _this.state.data.styles);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperPlacement", function() {
            return !_this.state.data ? undefined : _this.state.placement;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getArrowStyle", function() {
            return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOutOfBoundariesState", function() {
            return _this.state.data ? _this.state.data.hide : undefined;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "destroyPopperInstance", function() {
            if (!_this.popperInstance) return;
            _this.popperInstance.destroy();
            _this.popperInstance = null;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updatePopperInstance", function() {
            _this.destroyPopperInstance();
            var _assertThisInitialize = (0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), popperNode = _assertThisInitialize.popperNode;
            var referenceElement = _this.props.referenceElement;
            if (!referenceElement || !popperNode) return;
            _this.popperInstance = new (0, _popperJsDefault.default)(referenceElement, popperNode, _this.getOptions());
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "scheduleUpdate", function() {
            if (_this.popperInstance) _this.popperInstance.scheduleUpdate();
        });
        return _this;
    }
    var _proto = InnerPopper.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If the Popper.js options have changed, update the instance (destroy + create)
        if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqualDefault.default)(this.props.modifiers, prevProps.modifiers, {
            strict: true
        })) this.updatePopperInstance();
        else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
         // A placement difference in state means popper determined a new placement
        // apart from the props value. By the time the popper element is rendered with
        // the new position Popper has already measured it, if the place change triggers
        // a size change it will result in a misaligned popper. So we schedule an update to be sure.
        if (prevState.placement !== this.state.placement) this.scheduleUpdate();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
        this.destroyPopperInstance();
    };
    _proto.render = function render() {
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.setPopperNode,
            style: this.getPopperStyle(),
            placement: this.getPopperPlacement(),
            outOfBoundaries: this.getOutOfBoundariesState(),
            scheduleUpdate: this.scheduleUpdate,
            arrowProps: {
                ref: this.setArrowNode,
                style: this.getArrowStyle()
            }
        });
    };
    return InnerPopper;
}(_react.Component);
(0, _definePropertyDefault.default)(InnerPopper, "defaultProps", {
    placement: 'bottom',
    eventsEnabled: true,
    referenceElement: undefined,
    positionFixed: false
});
var placements = (0, _popperJsDefault.default).placements;
function Popper(_ref) {
    var referenceElement = _ref.referenceElement, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "referenceElement"
    ]);
    return _react.createElement((0, _manager.ManagerReferenceNodeContext).Consumer, null, function(referenceNode) {
        return _react.createElement(InnerPopper, (0, _extendsDefault.default)({
            referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"6F7Pt","@babel/runtime/helpers/extends":"lKkcq","@babel/runtime/helpers/inheritsLoose":"eFgUx","@babel/runtime/helpers/assertThisInitialized":"LYz4W","@babel/runtime/helpers/defineProperty":"lqVrz","deep-equal":"7Vhim","react":"gVheC","popper.js":"f4rAT","./Manager":"pf295","./utils":"i8iJf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6F7Pt":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lKkcq":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"eFgUx":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"jUFG4"}],"jUFG4":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"LYz4W":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lqVrz":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"gWiZy"}],"gWiZy":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"47zzI","2713647ce51d8c75":"bzAoJ"}],"47zzI":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"bzAoJ":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"47zzI"}],"7Vhim":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var objectKeys = require("69b25d5c5741b949");
var isArguments = require("35e168c0757d86dc");
var is = require("4507ab82af52838e");
var isRegex = require("e39d986f72f520d7");
var flags = require("f60a9f85e965c8db");
var isDate = require("51869b400334d972");
var getTime = Date.prototype.getTime;
function deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || (typeof actual === "undefined" ? "undefined" : (0, _typeOf._)(actual)) !== 'object' && (typeof expected === "undefined" ? "undefined" : (0, _typeOf._)(expected)) !== 'object') return opts.strict ? is(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function isBuffer(x) {
    if (!x || (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b))) return false;
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if (isArguments(a) !== isArguments(b)) return false;
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && flags(a) === flags(b);
    if (isDate(a) && isDate(b)) return getTime.call(a) === getTime.call(b);
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b))) return false;
    try {
        var ka = objectKeys(a);
        var kb = objectKeys(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = deepEqual;

},{"@swc/helpers/_/_type_of":"668P4","69b25d5c5741b949":"cA2oC","35e168c0757d86dc":"iRsRC","4507ab82af52838e":"e0ZHy","e39d986f72f520d7":"fCtC2","f60a9f85e965c8db":"4fMSJ","51869b400334d972":"cYqd0"}],"cA2oC":[function(require,module,exports,__globalThis) {
'use strict';
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"3tS8i","344bb0d7b2568e03":"4Vzup"}],"3tS8i":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

},{"@swc/helpers/_/_type_of":"668P4"}],"4Vzup":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function() {}, 'prototype');
    var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && (0, _typeOf._)(window[k]) === 'object') try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === 'undefined' || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && (typeof object === "undefined" ? "undefined" : (0, _typeOf._)(object)) === 'object';
        var isFunction = toStr.call(object) === '[object Function]';
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"@swc/helpers/_/_type_of":"668P4","b0d8c8b84be91ffd":"3tS8i"}],"iRsRC":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("649cbf9949986a39");
var $toString = callBound('Object.prototype.toString');
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && Symbol.toStringTag in value) return false;
    return $toString(value) === '[object Arguments]';
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"@swc/helpers/_/_type_of":"668P4","e2b01ce809f132fb":"cOgjF","649cbf9949986a39":"8YASK"}],"cOgjF":[function(require,module,exports,__globalThis) {
'use strict';
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"jSUDa"}],"jSUDa":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if ((0, _typeOf._)(Symbol.iterator) === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{"@swc/helpers/_/_type_of":"668P4"}],"8YASK":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"bR8eu","266fc50410cfc4a":"kfZIr"}],"bR8eu":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var _$undefined;
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, '');
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function throwTypeError() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    '%EvalError%': $EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': (typeof JSON === "undefined" ? "undefined" : (0, _typeOf._)(JSON)) === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"@swc/helpers/_/_type_of":"668P4","ff34c740859aa28e":"2imIr","349515b7ea9b6cef":"dZQnX","9da01653b2dd9abf":"cg2yD","68586abd6b0136da":"dCeA0","662263fdbc077fc8":"8CAsM","abdfc34e5f6bb86":"bsQP5","daca1f932429e03e":"fxyj2","1f00f712d594ccf":"fYW5p","23730654306aa64c":"dyGDi","7c5e688e48cd07b0":"98Jyp","af36d49b4b8c6c7c":"7170N"}],"2imIr":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

},{}],"dZQnX":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"cg2yD":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"dCeA0":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"8CAsM":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"bsQP5":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"fxyj2":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"fYW5p":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if ((0, _typeOf._)(origSymbol('foo')) !== 'symbol') return false;
    if ((0, _typeOf._)(Symbol('bar')) !== 'symbol') return false;
    return hasSymbolSham();
};

},{"@swc/helpers/_/_type_of":"668P4","3fb25678c62d2fce":"jSUDa"}],"dyGDi":[function(require,module,exports,__globalThis) {
'use strict';
var test = {
    __proto__: null,
    foo: {}
};
var $Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: test
    }).foo === test.foo && !(test instanceof $Object);
};

},{}],"98Jyp":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"4uoAv"}],"4uoAv":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function joiny(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"7170N":[function(require,module,exports,__globalThis) {
'use strict';
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"98Jyp"}],"kfZIr":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var setFunctionLength = require("f4b53071c102d4e");
var $TypeError = require("761613670c43be80");
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
var $defineProperty = require("3426ee59b177cf96");
var $max = GetIntrinsic('%Math.max%');
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== 'function') throw new $TypeError('a function is required');
    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, 'apply', {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"98Jyp","68d2ad3775278f43":"bR8eu","f4b53071c102d4e":"4KbmD","761613670c43be80":"bsQP5","3426ee59b177cf96":"i706X"}],"4KbmD":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && gOPD) {
        var desc = gOPD(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"bR8eu","37dd1486f0f556ef":"aYLBj","6a9d2b46085df706":"4RlQf","2d412b0f532d1834":"hnIus","4352c534d27fe477":"bsQP5"}],"aYLBj":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object' && typeof obj !== 'function') throw new $TypeError('`obj` must be an object or a function`');
    if (typeof property !== 'string' && (typeof property === "undefined" ? "undefined" : (0, _typeOf._)(property)) !== 'symbol') throw new $TypeError('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

},{"@swc/helpers/_/_type_of":"668P4","f17fd23367965521":"i706X","50f12088ee0f6bb":"8CAsM","45c79de2b2f9c949":"bsQP5","3f9bd39335781ec7":"hnIus"}],"i706X":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8e0b8e4026aaf38a");
/** @type {import('.')} */ var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) try {
    $defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{"8e0b8e4026aaf38a":"bR8eu"}],"hnIus":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) try {
    $gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"bR8eu"}],"4RlQf":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"i706X"}],"e0ZHy":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"jsE29","794ce1103c4a65ba":"kfZIr","f52a71fcf365d3bd":"10jsr","59addbaef079e040":"9jNCq","c0e8b0f7342ba484":"cos7j"}],"jsE29":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === 'function' && (0, _typeOf._)(Symbol('foo')) === 'symbol';
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function isFunction(fn) {
    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"@swc/helpers/_/_type_of":"668P4","7ff177585d1618f0":"cA2oC","84ca194f5a28ce70":"aYLBj","c52d62086511583f":"4RlQf"}],"10jsr":[function(require,module,exports,__globalThis) {
'use strict';
var numberIsNaN = function numberIsNaN(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"9jNCq":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"10jsr"}],"cos7j":[function(require,module,exports,__globalThis) {
'use strict';
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"9jNCq","155865cffc557cd":"jsE29"}],"fCtC2":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var callBound = require("5d96af94ba428cfc");
var hasToStringTag = require("a5e890a505b039e5")();
var has;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag) {
    has = callBound('Object.prototype.hasOwnProperty');
    $exec = callBound('RegExp.prototype.exec');
    isRegexMarker = {};
    var throwRegexMarker = function throwRegexMarker() {
        throw isRegexMarker;
    };
    badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
    };
    if ((0, _typeOf._)(Symbol.toPrimitive) === 'symbol') badStringifier[Symbol.toPrimitive] = throwRegexMarker;
}
var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';
module.exports = hasToStringTag ? function isRegex(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object') return false;
    var descriptor = gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
    if (!hasLastIndexDataProperty) return false;
    try {
        $exec(value, badStringifier);
    } catch (e) {
        return e === isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object' && typeof value !== 'function') return false;
    return $toString(value) === regexClass;
};

},{"@swc/helpers/_/_type_of":"668P4","5d96af94ba428cfc":"8YASK","a5e890a505b039e5":"cOgjF"}],"4fMSJ":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("234cd2776d15a037");
var callBind = require("6f662a760b1534f2");
var implementation = require("92a1454309a44466");
var getPolyfill = require("3ca514117a836edc");
var shim = require("e153862c910219d2");
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = flagsBound;

},{"234cd2776d15a037":"jsE29","6f662a760b1534f2":"kfZIr","92a1454309a44466":"jua6f","3ca514117a836edc":"cnnci","e153862c910219d2":"gGewL"}],"jua6f":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionName = require("73fe2073c023acf2");
var $TypeError = require("426e5953f3236710");
var $Object = Object;
module.exports = setFunctionName(function flags() {
    if (this == null || this !== $Object(this)) throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

},{"73fe2073c023acf2":"io4y5","426e5953f3236710":"bsQP5"}],"io4y5":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("151b89e8a715d4f3");
var hasDescriptors = require("e4d428b901bb50")();
var functionsHaveConfigurableNames = require("ff3f0082d0e55515").functionsHaveConfigurableNames();
var $TypeError = require("e7e6dd6b278b3b4f");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || functionsHaveConfigurableNames) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

},{"151b89e8a715d4f3":"aYLBj","e4d428b901bb50":"4RlQf","ff3f0082d0e55515":"coCIR","e7e6dd6b278b3b4f":"bsQP5"}],"coCIR":[function(require,module,exports,__globalThis) {
'use strict';
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = functionsHaveNames;

},{}],"cnnci":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("758a981608e1eeda");
var supportsDescriptors = require("6f5c0dd77da656ca").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function get() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function get() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return implementation;
};

},{"758a981608e1eeda":"jua6f","6f5c0dd77da656ca":"jsE29"}],"gGewL":[function(require,module,exports,__globalThis) {
'use strict';
var supportsDescriptors = require("d860dcb1943639b0").supportsDescriptors;
var getPolyfill = require("cdfc6652a32f035d");
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

},{"d860dcb1943639b0":"jsE29","cdfc6652a32f035d":"cnnci"}],"cYqd0":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = require("a0fda07f3b6c493a")();
module.exports = function isDateObject(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object' || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

},{"@swc/helpers/_/_type_of":"668P4","a0fda07f3b6c493a":"cOgjF"}],"f4rAT":[function(require,module,exports,__globalThis) {
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, timeoutDuration);
        }
    };
}
var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var _$window = element.ownerDocument.defaultView;
    var css = _$window.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function isIE(version) {
    if (version === 11) return isIE11;
    if (version === 10) return isIE10;
    return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') return getOffsetParent(offsetParent);
    return offsetParent;
}
function isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function getRoot(node) {
    if (node.parentNode !== null) return getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = getRoot(element1);
    if (element1root.host) return findCommonOffsetParent(element1root.host, element2);
    else return findCommonOffsetParent(element1, getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = getScroll(element, 'top');
    var scrollLeft = getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = isIE(10) && getComputedStyle(html);
    return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle)
    };
}
var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function getClientRect(offsets) {
    return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if (isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = getScroll(element, 'top');
            var scrollLeft = getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = getBoundingClientRect(children);
    var parentRect = getBoundingClientRect(parent);
    var scrollParent = getScrollParent(children);
    var styles = getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = includeScroll(offsets, parent);
    return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
    var _$offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return getClientRect(_$offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if (getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = getParentNode(element);
    if (!parentNode) return false;
    return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = getScrollParent(getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
            var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return _extends({
            key: key
        }, rects[key], {
            area: getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function getOuterSizes(element) {
    var _$window = element.ownerDocument.defaultView;
    var styles = _$window.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = getClientRect(data.offsets.popper);
            data.offsets.reference = getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if (isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = getScrollParent(reference);
    attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function removeEventListeners(reference, state) {
    // Remove resize event listener on window
    getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = getOffsetParent(data.instance.popper);
    var offsetParentRect = getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = _extends({}, attributes, data.attributes);
    data.styles = _extends({}, styles, data.styles);
    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = validPlacements.indexOf(placement);
    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if (isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case BEHAVIORS.CLOCKWISE:
            flipOrder = clockwise(placement);
            break;
        case BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf(find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if (isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function offset(data, _ref) {
    var _$offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if (isNumeric(+_$offset)) offsets = [
        +_$offset,
        0
    ];
    else offsets = parseOffset(_$offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = _extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: defineProperty({}, side, reference[side]),
            end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function hide(data) {
    if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = getOppositePlacement(placement);
    data.offsets.popper = getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: applyStyle,
        /** @prop {Function} */ onLoad: applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = _extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return _extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
exports.default = Popper;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"pf295":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", function() {
    return ManagerReferenceNodeContext;
});
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", function() {
    return ManagerReferenceNodeSetterContext;
});
parcelHelpers.export(exports, "default", function() {
    return Manager;
});
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _createReactContext = require("@hypnosphi/create-react-context");
var _createReactContextDefault = parcelHelpers.interopDefault(_createReactContext);
var ManagerReferenceNodeContext = (0, _createReactContextDefault.default)();
var ManagerReferenceNodeSetterContext = (0, _createReactContextDefault.default)();
var Manager = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Manager, _React$Component);
    function Manager() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "referenceNode", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setReferenceNode", function(newReferenceNode) {
            if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
                _this.referenceNode = newReferenceNode;
                _this.forceUpdate();
            }
        });
        return _this;
    }
    var _proto = Manager.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.referenceNode = null;
    };
    _proto.render = function render() {
        return _react.createElement(ManagerReferenceNodeContext.Provider, {
            value: this.referenceNode
        }, _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
            value: this.setReferenceNode
        }, this.props.children));
    };
    return Manager;
}(_react.Component);

},{"@babel/runtime/helpers/inheritsLoose":"eFgUx","@babel/runtime/helpers/assertThisInitialized":"LYz4W","@babel/runtime/helpers/defineProperty":"lqVrz","react":"gVheC","@hypnosphi/create-react-context":"3qKnr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3qKnr":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _react = require("ddac09876d051a09");
var _react2 = _interopRequireDefault(_react);
var _implementation = require("73440850e08f5e9a");
var _implementation2 = _interopRequireDefault(_implementation);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

},{"ddac09876d051a09":"gVheC","73440850e08f5e9a":"12q0V"}],"12q0V":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
exports.__esModule = true;
var _react = require("b66096a24343785f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("9a7f0b75e5abd6be");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _gud = require("c6e18d8274bd2f62");
var _gud2 = _interopRequireDefault(_gud);
var _warning = require("f3c3d30113536d1d");
var _warning2 = _interopRequireDefault(_warning);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
    var Provider = function(_Component) {
        _inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            _classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        _inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            _classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function _ret2(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
exports.default = createReactContext;
module.exports = exports['default'];

},{"@swc/helpers/_/_type_of":"668P4","b66096a24343785f":"gVheC","9a7f0b75e5abd6be":"3KNJy","c6e18d8274bd2f62":"4Dt5O","f3c3d30113536d1d":"5z6Ef"}],"4Dt5O":[function(require,module,exports,__globalThis) {
// @flow
var global = arguments[3];
'use strict';
var key = '__global_unique_id__';
module.exports = function() {
    return global[key] = (global[key] || 0) + 1;
};

},{}],"5z6Ef":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function warning() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"i8iJf":[function(require,module,exports,__globalThis) {
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", function() {
    return unwrapArray;
});
parcelHelpers.export(exports, "safeInvoke", function() {
    return safeInvoke;
});
parcelHelpers.export(exports, "shallowEqual", function() {
    return shallowEqual;
});
parcelHelpers.export(exports, "setRef", function() {
    return setRef;
});
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var shallowEqual = function shallowEqual(objA, objB) {
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (bKeys.length !== aKeys.length) return false;
    for(var i = 0; i < bKeys.length; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bFkHx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Reference;
});
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
var InnerReference = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerReference, _React$Component);
    function InnerReference() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "refHandler", function(node) {
            (0, _utils.setRef)(_this.props.innerRef, node);
            (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
        });
        return _this;
    }
    var _proto = InnerReference.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
    };
    _proto.render = function render() {
        (0, _warningDefault.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.refHandler
        });
    };
    return InnerReference;
}(_react.Component);
function Reference(props) {
    return _react.createElement((0, _manager.ManagerReferenceNodeSetterContext).Consumer, null, function(setReferenceNode) {
        return _react.createElement(InnerReference, (0, _extendsDefault.default)({
            setReferenceNode: setReferenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/extends":"lKkcq","@babel/runtime/helpers/inheritsLoose":"eFgUx","@babel/runtime/helpers/assertThisInitialized":"LYz4W","@babel/runtime/helpers/defineProperty":"lqVrz","react":"gVheC","warning":"5z6Ef","./Manager":"pf295","./utils":"i8iJf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ge2gh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownContext", function() {
    return DropdownContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DropdownContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5IYuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "size",
    "vertical",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    'aria-label': (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    role: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).string,
    vertical: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: 'div',
    role: 'group'
};
var ButtonGroup = function ButtonGroup(props) {
    var className = props.className, cssModule = props.cssModule, size = props.size, vertical = props.vertical, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
exports.default = ButtonGroup;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jjmW4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    'aria-label': (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    role: (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'div',
    role: 'toolbar'
};
var ButtonToolbar = function ButtonToolbar(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'btn-toolbar'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ButtonToolbar.propTypes = propTypes;
ButtonToolbar.defaultProps = defaultProps;
exports.default = ButtonToolbar;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aCCFh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "divider",
    "tag",
    "header",
    "active",
    "text"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    active: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    divider: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    header: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    toggle: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: 'button',
    toggle: true
};
var DropdownItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownItem, _React$Component);
    function DropdownItem(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = DropdownItem.prototype;
    _proto.getRole = function getRole() {
        if (this.context.menuRole === 'listbox') return 'option';
        return 'menuitem';
    };
    _proto.onClick = function onClick(e) {
        var _this$props = this.props, disabled = _this$props.disabled, header = _this$props.header, divider = _this$props.divider, text = _this$props.text;
        if (disabled || header || divider || text) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) this.props.onClick(e);
        if (this.props.toggle) this.context.toggle(e);
    };
    _proto.getTabIndex = function getTabIndex() {
        var _this$props2 = this.props, disabled = _this$props2.disabled, header = _this$props2.header, divider = _this$props2.divider, text = _this$props2.text;
        if (disabled || header || divider || text) return '-1';
        return '0';
    };
    _proto.render = function render() {
        var tabIndex = this.getTabIndex();
        var role = tabIndex > -1 ? this.getRole() : undefined;
        var _omit = (0, _utils.omit)(this.props, [
            'toggle'
        ]), className = _omit.className, cssModule = _omit.cssModule, divider = _omit.divider, Tag = _omit.tag, header = _omit.header, active = _omit.active, text = _omit.text, props = (0, _objectWithoutPropertiesLooseDefault.default)(_omit, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            disabled: props.disabled,
            'dropdown-item': !divider && !header && !text,
            active: active,
            'dropdown-header': header,
            'dropdown-divider': divider,
            'dropdown-item-text': text
        }), cssModule);
        if (Tag === 'button') {
            if (header) Tag = 'h6';
            else if (divider) Tag = 'div';
            else if (props.href) Tag = 'a';
            else if (text) Tag = 'span';
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
        }, props, {
            tabIndex: tabIndex,
            role: role,
            className: classes,
            onClick: this.onClick
        }));
    };
    return DropdownItem;
}((0, _reactDefault.default).Component);
DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;
DropdownItem.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./DropdownContext":"ge2gh","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lv8uF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "right",
    "tag",
    "flip",
    "modifiers",
    "persist",
    "positionFixed",
    "container"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    tag: (0, _utils.tagPropType),
    children: (0, _propTypesDefault.default).node.isRequired,
    right: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).bool,
    modifiers: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    persist: (0, _propTypesDefault.default).bool,
    positionFixed: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType)
};
var defaultProps = {
    tag: 'div',
    flip: true
};
var noFlipModifier = {
    flip: {
        enabled: false
    }
};
var directionPositionMap = {
    up: 'top',
    left: 'left',
    right: 'right',
    down: 'bottom'
};
var DropdownMenu = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownMenu, _React$Component);
    function DropdownMenu() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DropdownMenu.prototype;
    _proto.getRole = function getRole() {
        if (this.context.menuRole === 'listbox') return 'listbox';
        return 'menu';
    };
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, right = _this$props.right, tag = _this$props.tag, flip = _this$props.flip, modifiers = _this$props.modifiers, persist = _this$props.persist, positionFixed = _this$props.positionFixed, container = _this$props.container, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'dropdown-menu', {
            'dropdown-menu-right': right,
            show: this.context.isOpen
        }), cssModule);
        var Tag = tag;
        if (persist || this.context.isOpen && !this.context.inNavbar) {
            var position1 = directionPositionMap[this.context.direction] || 'bottom';
            var position2 = right ? 'end' : 'start';
            var poperPlacement = position1 + "-" + position2;
            var poperModifiers = !flip ? _objectSpread(_objectSpread({}, modifiers), noFlipModifier) : modifiers;
            var popperPositionFixed = !!positionFixed;
            var popper = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Popper), {
                placement: poperPlacement,
                modifiers: poperModifiers,
                positionFixed: popperPositionFixed
            }, function(_ref) {
                var ref = _ref.ref, style = _ref.style, placement = _ref.placement;
                var combinedStyle = _objectSpread(_objectSpread({}, _this.props.style), style);
                var handleRef = function handleRef(tagRef) {
                    // Send the ref to `react-popper`
                    ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
                    // it will cause it to close
                    var onMenuRef = _this.context.onMenuRef;
                    if (onMenuRef) onMenuRef(tagRef);
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
                    tabIndex: "-1",
                    role: _this.getRole(),
                    ref: handleRef
                }, attrs, {
                    style: combinedStyle,
                    "aria-hidden": !_this.context.isOpen,
                    className: classes,
                    "x-placement": placement
                }));
            });
            if (container) return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(popper, (0, _utils.getTarget)(container));
            else return popper;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            tabIndex: "-1",
            role: this.getRole()
        }, attrs, {
            "aria-hidden": !this.context.isOpen,
            className: classes,
            "x-placement": attrs.placement
        }));
    };
    return DropdownMenu;
}((0, _reactDefault.default).Component);
DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
DropdownMenu.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownMenu;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","react-dom":"d8jlt","classnames":"6P5cq","react-popper":"41KST","./DropdownContext":"ge2gh","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5R3Vd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _defineProperty;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"4TadU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TadU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPropertyKey;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"dC70N","./toPrimitive.js":"hDahS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dC70N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _typeof;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hDahS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPrimitive;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"dC70N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aQzhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _excluded = [
    "className",
    "color",
    "cssModule",
    "caret",
    "split",
    "nav",
    "tag",
    "innerRef"
];
var propTypes = {
    caret: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    disabled: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func,
    'aria-haspopup': (0, _propTypesDefault.default).bool,
    split: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    nav: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    color: 'secondary',
    'aria-haspopup': true
};
var DropdownToggle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownToggle, _React$Component);
    function DropdownToggle(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = DropdownToggle.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled || this.context.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.nav && !this.props.tag) e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
        this.context.toggle(e);
    };
    _proto.getRole = function getRole() {
        return this.context.menuRole || this.props['aria-haspopup'];
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, className = _this$props.className, color = _this$props.color, cssModule = _this$props.cssModule, caret = _this$props.caret, split = _this$props.split, nav = _this$props.nav, tag = _this$props.tag, innerRef = _this$props.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            'dropdown-toggle': caret || split,
            'dropdown-toggle-split': split,
            'nav-link': nav
        }), cssModule);
        var children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "sr-only"
        }, ariaLabel);
        var Tag;
        if (nav && !tag) {
            Tag = 'a';
            props.href = '#';
        } else if (!tag) {
            Tag = (0, _buttonDefault.default);
            props.color = color;
            props.cssModule = cssModule;
        } else Tag = tag;
        if (this.context.inNavbar) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, props, {
            className: classes,
            onClick: this.onClick,
            "aria-expanded": this.context.isOpen,
            "aria-haspopup": this.getRole(),
            children: children
        }));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Reference), {
            innerRef: innerRef
        }, function(_ref) {
            var _ref2;
            var ref = _ref.ref;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
                className: classes,
                onClick: _this2.onClick,
                "aria-expanded": _this2.context.isOpen,
                "aria-haspopup": _this2.getRole(),
                children: children
            }));
        });
    };
    return DropdownToggle;
}((0, _reactDefault.default).Component);
DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
DropdownToggle.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownToggle;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","react-popper":"41KST","./DropdownContext":"ge2gh","./utils":"ca6o0","./Button":"4pJkl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8vV1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("./utils");
var _excluded = [
    "tag",
    "baseClass",
    "baseClassActive",
    "className",
    "cssModule",
    "children",
    "innerRef"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).propTypes), {}, {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]),
    tag: (0, _utils.tagPropType),
    baseClass: (0, _propTypesDefault.default).string,
    baseClassActive: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
});
var defaultProps = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).defaultProps), {}, {
    tag: 'div',
    baseClass: 'fade',
    baseClassActive: 'show',
    timeout: (0, _utils.TransitionTimeouts).Fade,
    appear: true,
    enter: true,
    exit: true,
    in: true
});
function Fade(props) {
    var Tag = props.tag, baseClass = props.baseClass, baseClassActive = props.baseClassActive, className = props.className, cssModule = props.cssModule, children = props.children, innerRef = props.innerRef, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var transitionProps = (0, _utils.pick)(otherProps, (0, _utils.TransitionPropTypeKeys));
    var childProps = (0, _utils.omit)(otherProps, (0, _utils.TransitionPropTypeKeys));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), transitionProps, function(status) {
        var isActive = status === 'entered';
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, baseClass, isActive && baseClassActive), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            className: classes
        }, childProps, {
            ref: innerRef
        }), children);
    });
}
Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
exports.default = Fade;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","react-transition-group":"aiK82","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aiK82":[function(require,module,exports,__globalThis) {
"use strict";
var _CSSTransition = _interopRequireDefault(require("8bfee68ff795128d"));
var _ReplaceTransition = _interopRequireDefault(require("c542d7d348a799bc"));
var _TransitionGroup = _interopRequireDefault(require("c0ea70f0f47bc59d"));
var _Transition = _interopRequireDefault(require("f390101c0f4be195"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    Transition: _Transition.default,
    TransitionGroup: _TransitionGroup.default,
    ReplaceTransition: _ReplaceTransition.default,
    CSSTransition: _CSSTransition.default
};

},{"8bfee68ff795128d":"eW3nG","c542d7d348a799bc":"g89wZ","c0ea70f0f47bc59d":"g3Dsy","f390101c0f4be195":"5tuHP"}],"eW3nG":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var PropTypes = _interopRequireWildcard(require("f2a3e50c536fae0f"));
var _addClass = _interopRequireDefault(require("694ed92e2771eec2"));
var _removeClass = _interopRequireDefault(require("14b67602839c359a"));
var _react = _interopRequireDefault(require("f839b546a7c5d008"));
var _Transition = _interopRequireDefault(require("a36057805c73b37"));
var _PropTypes = require("a723ea4b292c544");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClass.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && removeClass(node, className);
        activeClassName && removeClass(node, activeClassName);
        doneClassName && removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = _extends({}, this.props);
        delete props.classNames;
        return _react.default.createElement(_Transition.default, _extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}(_react.default.Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

},{"f2a3e50c536fae0f":"3KNJy","694ed92e2771eec2":"fwPHf","14b67602839c359a":"bTxaS","f839b546a7c5d008":"gVheC","a36057805c73b37":"5tuHP","a723ea4b292c544":"1v6XX"}],"fwPHf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a3ff600ca6bfd2cd");
exports.__esModule = true;
exports.default = addClass;
var _hasClass = _interopRequireDefault(require("460f4cc64e5850f6"));
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = exports["default"];

},{"a3ff600ca6bfd2cd":"6zI5d","460f4cc64e5850f6":"jUg1r"}],"6zI5d":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jUg1r":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = hasClass;
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

},{}],"bTxaS":[function(require,module,exports,__globalThis) {
'use strict';
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

},{}],"5tuHP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
var PropTypes = _interopRequireWildcard(require("e127ce950a0781ce"));
var _react = _interopRequireDefault(require("e965df18f394fb02"));
var _reactDom = _interopRequireDefault(require("fbea1bd81de077af"));
var _reactLifecyclesCompat = require("e061c13ca3e27047");
var _PropTypes = require("8030f812aab3636c");
var _TransitionGroupContext = _interopRequireDefault(require("bbb054715ca992be"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ exports.EXITING = EXITING;
var Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = _reactDom.default.findDOMNode(this);
            if (nextStatus === ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = _objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') // allows for nested Transitions
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: null
        }, children(status, childProps));
        var child = _react.default.Children.only(children);
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: null
        }, _react.default.cloneElement(child, childProps));
    };
    return Transition;
}(_react.default.Component);
Transition.contextType = _TransitionGroupContext.default;
Transition.propTypes = {};
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
exports.default = _default;

},{"e127ce950a0781ce":"3KNJy","e965df18f394fb02":"gVheC","fbea1bd81de077af":"d8jlt","e061c13ca3e27047":"3F3XD","8030f812aab3636c":"1v6XX","bbb054715ca992be":"izHlb"}],"3F3XD":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", function() {
    return polyfill;
});
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1v6XX":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;
var _propTypes = _interopRequireDefault(require("cc5f4aaee211ee"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var timeoutsShape = null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = null;
exports.classNamesShape = classNamesShape;

},{"cc5f4aaee211ee":"3KNJy"}],"izHlb":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("29353d6fc52e19c0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = _react.default.createContext(null);
exports.default = _default;
module.exports = exports["default"];

},{"29353d6fc52e19c0":"gVheC"}],"g89wZ":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("45c9bc64d4d6bccd"));
var _react = _interopRequireDefault(require("b73fe14ab058d72"));
var _reactDom = require("7ff2b3445fa5026e");
var _TransitionGroup = _interopRequireDefault(require("6ce223923339bf27"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = _react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = _objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = _react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : _react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}(_react.default.Component);
ReplaceTransition.propTypes = {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

},{"45c9bc64d4d6bccd":"3KNJy","b73fe14ab058d72":"gVheC","7ff2b3445fa5026e":"d8jlt","6ce223923339bf27":"g3Dsy"}],"g3Dsy":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("2ebcb01af4674c13"));
var _react = _interopRequireDefault(require("5be31f0ea626c7d4"));
var _reactLifecyclesCompat = require("5451653a763ef126");
var _TransitionGroupContext = _interopRequireDefault(require("c0bcd7012e8ff9b5"));
var _ChildMapping = require("38e37bb9524bb96e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = _extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: contextValue
        }, children);
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: contextValue
        }, _react.default.createElement(Component, props, children));
    };
    return TransitionGroup;
}(_react.default.Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
exports.default = _default;
module.exports = exports["default"];

},{"2ebcb01af4674c13":"3KNJy","5be31f0ea626c7d4":"gVheC","5451653a763ef126":"3F3XD","c0bcd7012e8ff9b5":"izHlb","38e37bb9524bb96e":"5fEyG"}],"5fEyG":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;
var _react = require("219f56f8a3fa16bd");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) _react.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"219f56f8a3fa16bd":"gVheC"}],"4MgDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "color",
    "innerRef",
    "pill",
    "tag"
];
var propTypes = {
    color: (0, _propTypesDefault.default).string,
    pill: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    color: 'secondary',
    pill: false,
    tag: 'span'
};
var Badge = function Badge(props) {
    var className = props.className, cssModule = props.cssModule, color = props.color, innerRef = props.innerRef, pill = props.pill, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);
    if (attributes.href && Tag === 'span') Tag = 'a';
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
exports.default = Badge;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kkCEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "color",
    "body",
    "inverse",
    "outline",
    "tag",
    "innerRef"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    inverse: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    body: (0, _propTypesDefault.default).bool,
    outline: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    tag: 'div'
};
var Card = function Card(props) {
    var className = props.className, cssModule = props.cssModule, color = props.color, body = props.body, inverse = props.inverse, outline = props.outline, Tag = props.tag, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
exports.default = Card;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hI19x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardGroup = function CardGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-group'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;
exports.default = CardGroup;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kSyJH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardDeck = function CardDeck(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-deck'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardDeck.propTypes = propTypes;
CardDeck.defaultProps = defaultProps;
exports.default = CardDeck;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"931mj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardColumns = function CardColumns(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-columns'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardColumns.propTypes = propTypes;
CardColumns.defaultProps = defaultProps;
exports.default = CardColumns;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"10ZSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "innerRef",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    tag: 'div'
};
var CardBody = function CardBody(props) {
    var className = props.className, cssModule = props.cssModule, innerRef = props.innerRef, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-body'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;
exports.default = CardBody;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jxmYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "innerRef"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'a'
};
var CardLink = function CardLink(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-link'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        ref: innerRef,
        className: classes
    }));
};
CardLink.propTypes = propTypes;
CardLink.defaultProps = defaultProps;
exports.default = CardLink;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bDlo6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardFooter = function CardFooter(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-footer'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardFooter.propTypes = propTypes;
CardFooter.defaultProps = defaultProps;
exports.default = CardFooter;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6H9TY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardHeader = function CardHeader(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-header'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
exports.default = CardHeader;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"mhIu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "top",
    "bottom",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    top: (0, _propTypesDefault.default).bool,
    bottom: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'img'
};
var CardImg = function CardImg(props) {
    var className = props.className, cssModule = props.cssModule, top = props.top, bottom = props.bottom, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var cardImgClassName = 'card-img';
    if (top) cardImgClassName = 'card-img-top';
    if (bottom) cardImgClassName = 'card-img-bottom';
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, cardImgClassName), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardImg.propTypes = propTypes;
CardImg.defaultProps = defaultProps;
exports.default = CardImg;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4JjB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardImgOverlay = function CardImgOverlay(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-img-overlay'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardImgOverlay.propTypes = propTypes;
CardImgOverlay.defaultProps = defaultProps;
exports.default = CardImgOverlay;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jVfRV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _utils = require("./utils");
var SWIPE_THRESHOLD = 40;
var Carousel = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Carousel, _React$Component);
    function Carousel(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.renderItems = _this.renderItems.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hoverStart = _this.hoverStart.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hoverEnd = _this.hoverEnd.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleTouchStart = _this.handleTouchStart.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleTouchEnd = _this.handleTouchEnd.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.touchStartX = 0;
        _this.touchStartY = 0;
        _this.state = {
            activeIndex: _this.props.activeIndex,
            direction: 'right',
            indicatorClicked: false
        };
        return _this;
    }
    var _proto = Carousel.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            direction: this.state.direction
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        // Set up the cycle
        if (this.props.ride === 'carousel') this.setInterval();
         // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
        document.addEventListener('keyup', this.handleKeyPress);
    };
    Carousel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var newState = null;
        var activeIndex = prevState.activeIndex, direction = prevState.direction, indicatorClicked = prevState.indicatorClicked;
        if (nextProps.activeIndex !== activeIndex) {
            // Calculate the direction to turn
            if (nextProps.activeIndex === activeIndex + 1) direction = 'right';
            else if (nextProps.activeIndex === activeIndex - 1) direction = 'left';
            else if (nextProps.activeIndex < activeIndex) direction = indicatorClicked ? 'left' : 'right';
            else if (nextProps.activeIndex !== activeIndex) direction = indicatorClicked ? 'right' : 'left';
            newState = {
                activeIndex: nextProps.activeIndex,
                direction: direction,
                indicatorClicked: false
            };
        }
        return newState;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevState.activeIndex === this.state.activeIndex) return;
        this.setInterval(this.props);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.clearInterval();
        document.removeEventListener('keyup', this.handleKeyPress);
    };
    _proto.setInterval = function(_setInterval) {
        function setInterval1() {
            return _setInterval.apply(this, arguments);
        }
        setInterval1.toString = function() {
            return _setInterval.toString();
        };
        return setInterval1;
    }(function(props) {
        if (props === void 0) props = this.props;
        // make sure not to have multiple intervals going...
        this.clearInterval();
        if (props.interval) this.cycleInterval = setInterval(function() {
            props.next();
        }, parseInt(props.interval, 10));
    });
    _proto.clearInterval = function(_clearInterval) {
        function clearInterval1() {
            return _clearInterval.apply(this, arguments);
        }
        clearInterval1.toString = function() {
            return _clearInterval.toString();
        };
        return clearInterval1;
    }(function() {
        clearInterval(this.cycleInterval);
    });
    _proto.hoverStart = function hoverStart() {
        if (this.props.pause === 'hover') this.clearInterval();
        if (this.props.mouseEnter) {
            var _this$props;
            (_this$props = this.props).mouseEnter.apply(_this$props, arguments);
        }
    };
    _proto.hoverEnd = function hoverEnd() {
        if (this.props.pause === 'hover') this.setInterval();
        if (this.props.mouseLeave) {
            var _this$props2;
            (_this$props2 = this.props).mouseLeave.apply(_this$props2, arguments);
        }
    };
    _proto.handleKeyPress = function handleKeyPress(evt) {
        if (this.props.keyboard) {
            if (evt.keyCode === 37) this.props.previous();
            else if (evt.keyCode === 39) this.props.next();
        }
    };
    _proto.handleTouchStart = function handleTouchStart(e) {
        if (!this.props.enableTouch) return;
        this.touchStartX = e.changedTouches[0].screenX;
        this.touchStartY = e.changedTouches[0].screenY;
    };
    _proto.handleTouchEnd = function handleTouchEnd(e) {
        if (!this.props.enableTouch) return;
        var currentX = e.changedTouches[0].screenX;
        var currentY = e.changedTouches[0].screenY;
        var diffX = Math.abs(this.touchStartX - currentX);
        var diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement
        if (diffX < diffY) return;
        if (diffX < SWIPE_THRESHOLD) return;
        if (currentX < this.touchStartX) this.props.next();
        else this.props.previous();
    };
    _proto.renderItems = function renderItems(carouselItems, className) {
        var _this2 = this;
        var slide = this.props.slide;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className
        }, carouselItems.map(function(item, index) {
            var isIn = index === _this2.state.activeIndex;
            return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                in: isIn,
                slide: slide
            });
        }));
    };
    _proto.render = function render() {
        var _this3 = this;
        var _this$props3 = this.props, cssModule = _this$props3.cssModule, slide = _this$props3.slide, className = _this$props3.className;
        var outerClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'carousel', slide && 'slide'), cssModule);
        var innerClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('carousel-inner'), cssModule); // filter out booleans, null, or undefined
        var children = this.props.children.filter(function(child) {
            return child !== null && child !== undefined && typeof child !== 'boolean';
        });
        var slidesOnly = children.every(function(child) {
            return child.type === (0, _carouselItemDefault.default);
        }); // Rendering only slides
        if (slidesOnly) return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: outerClasses,
            onMouseEnter: this.hoverStart,
            onMouseLeave: this.hoverEnd
        }, this.renderItems(children, innerClasses));
         // Rendering slides and controls
        if (children[0] instanceof Array) {
            var _carouselItems = children[0];
            var _controlLeft = children[1];
            var _controlRight = children[2];
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: outerClasses,
                onMouseEnter: this.hoverStart,
                onMouseLeave: this.hoverEnd
            }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight);
        } // Rendering indicators, slides and controls
        var indicators = children[0];
        var wrappedOnClick = function wrappedOnClick(e) {
            if (typeof indicators.props.onClickHandler === 'function') _this3.setState({
                indicatorClicked: true
            }, function() {
                return indicators.props.onClickHandler(e);
            });
        };
        var wrappedIndicators = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(indicators, {
            onClickHandler: wrappedOnClick
        });
        var carouselItems = children[1];
        var controlLeft = children[2];
        var controlRight = children[3];
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: outerClasses,
            onMouseEnter: this.hoverStart,
            onMouseLeave: this.hoverEnd,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd
        }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight);
    };
    return Carousel;
}((0, _reactDefault.default).Component);
Carousel.propTypes = {
    // the current active slide of the carousel
    activeIndex: (0, _propTypesDefault.default).number,
    // a function which should advance the carousel to the next slide (via activeIndex)
    next: (0, _propTypesDefault.default).func.isRequired,
    // a function which should advance the carousel to the previous slide (via activeIndex)
    previous: (0, _propTypesDefault.default).func.isRequired,
    // controls if the left and right arrow keys should control the carousel
    keyboard: (0, _propTypesDefault.default).bool,
    /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */ pause: (0, _propTypesDefault.default).oneOf([
        'hover',
        false
    ]),
    // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
    // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
    ride: (0, _propTypesDefault.default).oneOf([
        'carousel'
    ]),
    // the interval at which the carousel automatically cycles (default: 5000)
    // eslint-disable-next-line react/no-unused-prop-types
    interval: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).bool
    ]),
    children: (0, _propTypesDefault.default).array,
    // called when the mouse enters the Carousel
    mouseEnter: (0, _propTypesDefault.default).func,
    // called when the mouse exits the Carousel
    mouseLeave: (0, _propTypesDefault.default).func,
    // controls whether the slide animation on the Carousel works or not
    slide: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).string,
    enableTouch: (0, _propTypesDefault.default).bool
};
Carousel.defaultProps = {
    interval: 5000,
    pause: 'hover',
    keyboard: true,
    slide: true,
    enableTouch: true
};
Carousel.childContextTypes = {
    direction: (0, _propTypesDefault.default).string
};
exports.default = Carousel;

},{"@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./CarouselItem":"aA3j6","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aA3j6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("./utils");
var _excluded = [
    "in",
    "children",
    "cssModule",
    "slide",
    "tag",
    "className"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var CarouselItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CarouselItem, _React$Component);
    function CarouselItem(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            startAnimation: false
        };
        _this.onEnter = _this.onEnter.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onEntering = _this.onEntering.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onExit = _this.onExit.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onExiting = _this.onExiting.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onExited = _this.onExited.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = CarouselItem.prototype;
    _proto.onEnter = function onEnter(node, isAppearing) {
        this.setState({
            startAnimation: false
        });
        this.props.onEnter(node, isAppearing);
    };
    _proto.onEntering = function onEntering(node, isAppearing) {
        // getting this variable triggers a reflow
        var offsetHeight = node.offsetHeight;
        this.setState({
            startAnimation: true
        });
        this.props.onEntering(node, isAppearing);
        return offsetHeight;
    };
    _proto.onExit = function onExit(node) {
        this.setState({
            startAnimation: false
        });
        this.props.onExit(node);
    };
    _proto.onExiting = function onExiting(node) {
        this.setState({
            startAnimation: true
        });
        node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
        this.props.onExiting(node);
    };
    _proto.onExited = function onExited(node) {
        node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
        this.props.onExited(node);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, isIn = _this$props.in, children = _this$props.children, cssModule = _this$props.cssModule, slide = _this$props.slide, Tag = _this$props.tag, className = _this$props.className, transitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), (0, _extendsDefault.default)({}, transitionProps, {
            enter: slide,
            exit: slide,
            in: isIn,
            onEnter: this.onEnter,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }), function(status) {
            var direction = _this2.context.direction;
            var isActive = status === (0, _utils.TransitionStatuses).ENTERED || status === (0, _utils.TransitionStatuses).EXITING;
            var directionClassName = (status === (0, _utils.TransitionStatuses).ENTERING || status === (0, _utils.TransitionStatuses).EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
            var orderClassName = status === (0, _utils.TransitionStatuses).ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
            var itemClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, {
                className: itemClasses
            }, children);
        });
    };
    return CarouselItem;
}((0, _reactDefault.default).Component);
CarouselItem.propTypes = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).propTypes), {}, {
    tag: (0, _utils.tagPropType),
    in: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    slide: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string
});
CarouselItem.defaultProps = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).defaultProps), {}, {
    tag: 'div',
    timeout: (0, _utils.TransitionTimeouts).Carousel,
    slide: true
});
CarouselItem.contextTypes = {
    direction: (0, _propTypesDefault.default).string
};
exports.default = CarouselItem;

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","react-transition-group":"aiK82","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hUrHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _carouselControl = require("./CarouselControl");
var _carouselControlDefault = parcelHelpers.interopDefault(_carouselControl);
var _carouselIndicators = require("./CarouselIndicators");
var _carouselIndicatorsDefault = parcelHelpers.interopDefault(_carouselIndicators);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _excluded = [
    "defaultActiveIndex",
    "autoPlay",
    "indicators",
    "controls",
    "items",
    "goToIndex"
];
var propTypes = {
    items: (0, _propTypesDefault.default).array.isRequired,
    indicators: (0, _propTypesDefault.default).bool,
    controls: (0, _propTypesDefault.default).bool,
    autoPlay: (0, _propTypesDefault.default).bool,
    defaultActiveIndex: (0, _propTypesDefault.default).number,
    activeIndex: (0, _propTypesDefault.default).number,
    next: (0, _propTypesDefault.default).func,
    previous: (0, _propTypesDefault.default).func,
    goToIndex: (0, _propTypesDefault.default).func
};
var UncontrolledCarousel = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledCarousel, _Component);
    function UncontrolledCarousel(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.animating = false;
        _this.state = {
            activeIndex: props.defaultActiveIndex || 0
        };
        _this.next = _this.next.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.previous = _this.previous.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.goToIndex = _this.goToIndex.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onExiting = _this.onExiting.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onExited = _this.onExited.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledCarousel.prototype;
    _proto.onExiting = function onExiting() {
        this.animating = true;
    };
    _proto.onExited = function onExited() {
        this.animating = false;
    };
    _proto.next = function next() {
        if (this.animating) return;
        var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({
            activeIndex: nextIndex
        });
    };
    _proto.previous = function previous() {
        if (this.animating) return;
        var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
        this.setState({
            activeIndex: nextIndex
        });
    };
    _proto.goToIndex = function goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({
            activeIndex: newIndex
        });
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, defaultActiveIndex = _this$props.defaultActiveIndex, autoPlay = _this$props.autoPlay, indicators = _this$props.indicators, controls = _this$props.controls, items = _this$props.items, goToIndex = _this$props.goToIndex, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var activeIndex = this.state.activeIndex;
        var slides = items.map(function(item) {
            var key = item.key || item.src;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselItemDefault.default), {
                onExiting: _this2.onExiting,
                onExited: _this2.onExited,
                key: key
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
                className: "d-block w-100",
                src: item.src,
                alt: item.altText
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselCaptionDefault.default), {
                captionText: item.caption,
                captionHeader: item.header || item.caption
            }));
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselDefault.default), (0, _extendsDefault.default)({
            activeIndex: activeIndex,
            next: this.next,
            previous: this.previous,
            ride: autoPlay ? 'carousel' : undefined
        }, props), indicators && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselIndicatorsDefault.default), {
            items: items,
            activeIndex: props.activeIndex || activeIndex,
            onClickHandler: goToIndex || this.goToIndex
        }), slides, controls && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselControlDefault.default), {
            direction: "prev",
            directionText: "Previous",
            onClickHandler: props.previous || this.previous
        }), controls && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carouselControlDefault.default), {
            direction: "next",
            directionText: "Next",
            onClickHandler: props.next || this.next
        }));
    };
    return UncontrolledCarousel;
}((0, _react.Component));
UncontrolledCarousel.propTypes = propTypes;
UncontrolledCarousel.defaultProps = {
    controls: true,
    indicators: true,
    autoPlay: true
};
exports.default = UncontrolledCarousel;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Carousel":"jVfRV","./CarouselItem":"aA3j6","./CarouselControl":"awpJP","./CarouselIndicators":"irxCr","./CarouselCaption":"aHq2o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"awpJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var CarouselControl = function CarouselControl(props) {
    var direction = props.direction, onClickHandler = props.onClickHandler, cssModule = props.cssModule, directionText = props.directionText, className = props.className;
    var anchorClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "carousel-control-" + direction), cssModule);
    var iconClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("carousel-control-" + direction + "-icon"), cssModule);
    var screenReaderClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('sr-only'), cssModule);
    return(/*#__PURE__*/ // We need to disable this linting rule to use an `<a>` instead of
    // `<button>` because that's what the Bootstrap examples require:
    // https://getbootstrap.com/docs/4.5/components/carousel/#with-controls
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    (0, _reactDefault.default).createElement("a", {
        className: anchorClasses,
        style: {
            cursor: "pointer"
        },
        role: "button",
        tabIndex: "0",
        onClick: function onClick(e) {
            e.preventDefault();
            onClickHandler();
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: iconClasses,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: screenReaderClasses
    }, directionText || direction)));
};
CarouselControl.propTypes = {
    direction: (0, _propTypesDefault.default).oneOf([
        'prev',
        'next'
    ]).isRequired,
    onClickHandler: (0, _propTypesDefault.default).func.isRequired,
    cssModule: (0, _propTypesDefault.default).object,
    directionText: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string
};
exports.default = CarouselControl;

},{"react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irxCr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var CarouselIndicators = function CarouselIndicators(props) {
    var items = props.items, activeIndex = props.activeIndex, cssModule = props.cssModule, onClickHandler = props.onClickHandler, className = props.className;
    var listClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'carousel-indicators'), cssModule);
    var indicators = items.map(function(item, idx) {
        var indicatorClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)({
            active: activeIndex === idx
        }), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: "" + (item.key || Object.values(item).join('')),
            onClick: function onClick(e) {
                e.preventDefault();
                onClickHandler(idx);
            },
            className: indicatorClasses
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ol", {
        className: listClasses
    }, indicators);
};
CarouselIndicators.propTypes = {
    items: (0, _propTypesDefault.default).array.isRequired,
    activeIndex: (0, _propTypesDefault.default).number.isRequired,
    cssModule: (0, _propTypesDefault.default).object,
    onClickHandler: (0, _propTypesDefault.default).func.isRequired,
    className: (0, _propTypesDefault.default).string
};
exports.default = CarouselIndicators;

},{"react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aHq2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var CarouselCaption = function CarouselCaption(props) {
    var captionHeader = props.captionHeader, captionText = props.captionText, cssModule = props.cssModule, className = props.className;
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, captionHeader), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, captionText));
};
CarouselCaption.propTypes = {
    captionHeader: (0, _propTypesDefault.default).node,
    captionText: (0, _propTypesDefault.default).node.isRequired,
    cssModule: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).string
};
exports.default = CarouselCaption;

},{"react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"imVni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardSubtitle = function CardSubtitle(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-subtitle'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardSubtitle.propTypes = propTypes;
CardSubtitle.defaultProps = defaultProps;
exports.default = CardSubtitle;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b27ZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'p'
};
var CardText = function CardText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-text'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardText.propTypes = propTypes;
CardText.defaultProps = defaultProps;
exports.default = CardText;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iPDUM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var CardTitle = function CardTitle(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'card-title'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardTitle.propTypes = propTypes;
CardTitle.defaultProps = defaultProps;
exports.default = CardTitle;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2GB2h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "label",
    "valid",
    "invalid",
    "cssModule",
    "children",
    "bsSize",
    "innerRef",
    "htmlFor",
    "type",
    "onChange",
    "dataBrowse",
    "hidden"
];
var propTypes = {
    className: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    label: (0, _propTypesDefault.default).node,
    valid: (0, _propTypesDefault.default).bool,
    invalid: (0, _propTypesDefault.default).bool,
    bsSize: (0, _propTypesDefault.default).string,
    htmlFor: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    onChange: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).func
    ]),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var CustomFileInput = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CustomFileInput, _React$Component);
    function CustomFileInput(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            files: null
        };
        _this.onChange = _this.onChange.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = CustomFileInput.prototype;
    _proto.onChange = function onChange(e) {
        var input = e.target;
        var onChange = this.props.onChange;
        var files = this.getSelectedFiles(input);
        if (typeof onChange === "function") onChange.apply(void 0, arguments);
        this.setState({
            files: files
        });
    };
    _proto.getSelectedFiles = function getSelectedFiles(input) {
        var multiple = this.props.multiple;
        if (multiple && input.files) {
            var files = [].slice.call(input.files);
            return files.map(function(file) {
                return file.name;
            }).join(", ");
        }
        if (input.value.indexOf("fakepath") !== -1) {
            var parts = input.value.split("\\");
            return parts[parts.length - 1];
        }
        return input.value;
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, label = _this$props.label, valid = _this$props.valid, invalid = _this$props.invalid, cssModule = _this$props.cssModule, children = _this$props.children, bsSize = _this$props.bsSize, innerRef = _this$props.innerRef, htmlFor = _this$props.htmlFor, type = _this$props.type, onChange = _this$props.onChange, dataBrowse = _this$props.dataBrowse, hidden = _this$props.hidden, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var customClass = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "custom-file"), cssModule);
        var validationClassNames = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
        var labelHtmlFor = htmlFor || attributes.id;
        var files = this.state.files;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: customClass,
            hidden: hidden || false
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", (0, _extendsDefault.default)({
            type: "file"
        }, attributes, {
            ref: innerRef,
            "aria-invalid": invalid,
            className: (0, _classnamesDefault.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-file-input", cssModule)),
            onChange: this.onChange
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
            className: (0, _utils.mapToCssModules)("custom-file-label", cssModule),
            htmlFor: labelHtmlFor,
            "data-browse": dataBrowse
        }, files || label || "Choose file"), children);
    };
    return CustomFileInput;
}((0, _reactDefault.default).Component);
CustomFileInput.propTypes = propTypes;
exports.default = CustomFileInput;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ermL6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _customFileInput = require("./CustomFileInput");
var _customFileInputDefault = parcelHelpers.interopDefault(_customFileInput);
var _excluded = [
    "className",
    "label",
    "inline",
    "valid",
    "invalid",
    "cssModule",
    "children",
    "bsSize",
    "innerRef",
    "htmlFor"
], _excluded2 = [
    "type"
], _excluded3 = [
    "hidden"
];
var propTypes = {
    className: (0, _propTypesDefault.default).string,
    id: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]).isRequired,
    type: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).node,
    inline: (0, _propTypesDefault.default).bool,
    valid: (0, _propTypesDefault.default).bool,
    invalid: (0, _propTypesDefault.default).bool,
    bsSize: (0, _propTypesDefault.default).string,
    htmlFor: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).func
    ]),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
function CustomInput(props) {
    var className = props.className, label = props.label, inline = props.inline, valid = props.valid, invalid = props.invalid, cssModule = props.cssModule, children = props.children, bsSize = props.bsSize, innerRef = props.innerRef, htmlFor = props.htmlFor, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var type = attributes.type;
    var customClass = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
    var validationClassNames = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(invalid && "is-invalid", valid && "is-valid"), cssModule);
    var labelHtmlFor = htmlFor || attributes.id;
    if (type === "select") {
        var _type = attributes.type, _rest = (0, _objectWithoutPropertiesLooseDefault.default)(attributes, _excluded2);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("select", (0, _extendsDefault.default)({}, _rest, {
            ref: innerRef,
            className: (0, _classnamesDefault.default)(validationClassNames, customClass),
            "aria-invalid": invalid
        }), children);
    }
    if (type === "file") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _customFileInputDefault.default), props);
    if (type !== "checkbox" && type !== "radio" && type !== "switch") return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", (0, _extendsDefault.default)({}, attributes, {
        ref: innerRef,
        "aria-invalid": invalid,
        className: (0, _classnamesDefault.default)(validationClassNames, customClass)
    }));
    var wrapperClasses = (0, _classnamesDefault.default)(customClass, (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("custom-control", {
        "custom-control-inline": inline
    }), cssModule));
    var hidden = attributes.hidden, rest = (0, _objectWithoutPropertiesLooseDefault.default)(attributes, _excluded3);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperClasses,
        hidden: hidden || false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", (0, _extendsDefault.default)({}, rest, {
        type: type === "switch" ? "checkbox" : type,
        ref: innerRef,
        "aria-invalid": invalid,
        className: (0, _classnamesDefault.default)(validationClassNames, (0, _utils.mapToCssModules)("custom-control-input", cssModule))
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: (0, _utils.mapToCssModules)("custom-control-label", cssModule),
        htmlFor: labelHtmlFor
    }, label), children);
}
CustomInput.propTypes = propTypes;
exports.default = CustomInput;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","./CustomFileInput":"2GB2h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3quYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _utils = require("./utils");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _excluded = [
    "cssModule",
    "children",
    "isOpen",
    "flip",
    "target",
    "offset",
    "fallbackPlacement",
    "placementPrefix",
    "arrowClassName",
    "hideArrow",
    "popperClassName",
    "tag",
    "container",
    "modifiers",
    "positionFixed",
    "boundariesElement",
    "onClosed",
    "fade",
    "transition",
    "placement"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function noop() {}
var propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    popperClassName: (0, _propTypesDefault.default).string,
    placement: (0, _propTypesDefault.default).string,
    placementPrefix: (0, _propTypesDefault.default).string,
    arrowClassName: (0, _propTypesDefault.default).string,
    hideArrow: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    isOpen: (0, _propTypesDefault.default).bool.isRequired,
    cssModule: (0, _propTypesDefault.default).object,
    offset: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    fallbackPlacement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).array
    ]),
    flip: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType),
    target: (0, _utils.targetPropType).isRequired,
    modifiers: (0, _propTypesDefault.default).object,
    positionFixed: (0, _propTypesDefault.default).bool,
    boundariesElement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _utils.DOMElement)
    ]),
    onClosed: (0, _propTypesDefault.default).func,
    fade: (0, _propTypesDefault.default).bool,
    transition: (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes)
};
var defaultProps = {
    boundariesElement: 'scrollParent',
    placement: 'auto',
    hideArrow: false,
    isOpen: false,
    offset: 0,
    fallbackPlacement: 'flip',
    flip: true,
    container: 'body',
    modifiers: {},
    onClosed: noop,
    fade: true,
    transition: _objectSpread({}, (0, _fadeDefault.default).defaultProps)
};
var PopperContent = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(PopperContent, _React$Component);
    function PopperContent(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        return _this;
    }
    PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    var _proto = PopperContent.prototype;
    _proto.componentDidUpdate = function componentDidUpdate() {
        if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) this._element.childNodes[0].focus();
    };
    _proto.setTargetNode = function setTargetNode(node) {
        this.targetNode = typeof node === 'string' ? (0, _utils.getTarget)(node) : node;
    };
    _proto.getTargetNode = function getTargetNode() {
        return this.targetNode;
    };
    _proto.getContainerNode = function getContainerNode() {
        return (0, _utils.getTarget)(this.props.container);
    };
    _proto.getRef = function getRef(ref) {
        this._element = ref;
    };
    _proto.onClosed = function onClosed() {
        this.props.onClosed();
        this.setState({
            isOpen: false
        });
    };
    _proto.renderChildren = function renderChildren() {
        var _this$props = this.props, cssModule = _this$props.cssModule, children = _this$props.children, isOpen = _this$props.isOpen, flip = _this$props.flip, target = _this$props.target, offset = _this$props.offset, fallbackPlacement = _this$props.fallbackPlacement, placementPrefix = _this$props.placementPrefix, _arrowClassName = _this$props.arrowClassName, hideArrow = _this$props.hideArrow, _popperClassName = _this$props.popperClassName, tag = _this$props.tag, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, boundariesElement = _this$props.boundariesElement, onClosed = _this$props.onClosed, fade = _this$props.fade, transition = _this$props.transition, placement = _this$props.placement, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var arrowClassName = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('arrow', _arrowClassName), cssModule);
        var popperClassName = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ''), this.props.cssModule);
        var extendedModifiers = _objectSpread({
            offset: {
                offset: offset
            },
            flip: {
                enabled: flip,
                behavior: fallbackPlacement
            },
            preventOverflow: {
                boundariesElement: boundariesElement
            }
        }, modifiers);
        var popperTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), transition), {}, {
            baseClass: fade ? transition.baseClass : '',
            timeout: fade ? transition.timeout : 0
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, popperTransition, attrs, {
            in: isOpen,
            onExited: this.onClosed,
            tag: tag
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Popper), {
            referenceElement: this.targetNode,
            modifiers: extendedModifiers,
            placement: placement,
            positionFixed: positionFixed
        }, function(_ref) {
            var ref = _ref.ref, style = _ref.style, placement = _ref.placement, outOfBoundaries = _ref.outOfBoundaries, arrowProps = _ref.arrowProps, scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                ref: ref,
                style: style,
                className: popperClassName,
                "x-placement": placement,
                "x-out-of-boundaries": outOfBoundaries ? 'true' : undefined
            }, typeof children === 'function' ? children({
                scheduleUpdate: scheduleUpdate
            }) : children, !hideArrow && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                ref: arrowProps.ref,
                className: arrowClassName,
                style: arrowProps.style
            }));
        }));
    };
    _proto.render = function render() {
        this.setTargetNode(this.props.target);
        if (this.state.isOpen) return this.props.container === 'inline' ? this.renderChildren() : /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.getRef
        }, this.renderChildren()), this.getContainerNode());
        return null;
    };
    return PopperContent;
}((0, _reactDefault.default).Component);
PopperContent.propTypes = propTypes;
PopperContent.defaultProps = defaultProps;
exports.default = PopperContent;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","prop-types":"3KNJy","react-dom":"d8jlt","classnames":"6P5cq","react-popper":"41KST","./utils":"ca6o0","./Fade":"8vV1v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"igQkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("./utils");
var PopperTargetHelper = function PopperTargetHelper(props, context) {
    context.popperManager.setTargetNode((0, _utils.getTarget)(props.target));
    return null;
};
PopperTargetHelper.contextTypes = {
    popperManager: (0, _propTypesDefault.default).object.isRequired
};
PopperTargetHelper.propTypes = {
    target: (0, _utils.targetPropType).isRequired
};
exports.default = PopperTargetHelper;

},{"prop-types":"3KNJy","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cWyeN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tooltipPopoverWrapper = require("./TooltipPopoverWrapper");
var _tooltipPopoverWrapperDefault = parcelHelpers.interopDefault(_tooltipPopoverWrapper);
var defaultProps = {
    placement: 'right',
    placementPrefix: 'bs-popover',
    trigger: 'click'
};
var Popover = function Popover(props) {
    var popperClasses = (0, _classnamesDefault.default)('popover', 'show', props.popperClassName);
    var classes = (0, _classnamesDefault.default)('popover-inner', props.innerClassName);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipPopoverWrapperDefault.default), (0, _extendsDefault.default)({}, props, {
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
Popover.propTypes = (0, _tooltipPopoverWrapper.propTypes);
Popover.defaultProps = defaultProps;
exports.default = Popover;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","classnames":"6P5cq","./TooltipPopoverWrapper":"5CNLJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5CNLJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propTypes", function() {
    return propTypes;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _popperContent = require("./PopperContent");
var _popperContentDefault = parcelHelpers.interopDefault(_popperContent);
var _utils = require("./utils");
var propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    placement: (0, _propTypesDefault.default).oneOf((0, _utils.PopperPlacements)),
    target: (0, _utils.targetPropType).isRequired,
    container: (0, _utils.targetPropType),
    isOpen: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    hideArrow: (0, _propTypesDefault.default).bool,
    boundariesElement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _utils.DOMElement)
    ]),
    className: (0, _propTypesDefault.default).string,
    innerClassName: (0, _propTypesDefault.default).string,
    arrowClassName: (0, _propTypesDefault.default).string,
    popperClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    toggle: (0, _propTypesDefault.default).func,
    autohide: (0, _propTypesDefault.default).bool,
    placementPrefix: (0, _propTypesDefault.default).string,
    delay: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).shape({
            show: (0, _propTypesDefault.default).number,
            hide: (0, _propTypesDefault.default).number
        }),
        (0, _propTypesDefault.default).number
    ]),
    modifiers: (0, _propTypesDefault.default).object,
    positionFixed: (0, _propTypesDefault.default).bool,
    offset: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    trigger: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).bool
};
var DEFAULT_DELAYS = {
    show: 0,
    hide: 50
};
var defaultProps = {
    isOpen: false,
    hideArrow: false,
    autohide: false,
    delay: DEFAULT_DELAYS,
    toggle: function toggle() {},
    trigger: 'click',
    fade: true
};
function isInDOMSubtree(element, subtreeRoot) {
    return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function isInDOMSubtrees(element, subtreeRoots) {
    if (subtreeRoots === void 0) subtreeRoots = [];
    return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(function(subTreeRoot) {
        return isInDOMSubtree(element, subTreeRoot);
    })[0];
}
var TooltipPopoverWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TooltipPopoverWrapper, _React$Component);
    function TooltipPopoverWrapper(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._targets = [];
        _this.currentTargetElement = null;
        _this.addTargetEvents = _this.addTargetEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.removeTargetEvents = _this.removeTargetEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.showWithDelay = _this.showWithDelay.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hideWithDelay = _this.hideWithDelay.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.show = _this.show.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hide = _this.hide.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onEscKeyDown = _this.onEscKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        _this._isMounted = false;
        return _this;
    }
    var _proto = TooltipPopoverWrapper.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.updateTarget();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this.removeTargetEvents();
        this._targets = null;
        this.clearShowTimeout();
        this.clearHideTimeout();
    };
    TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
        if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.state.isOpen && !this.props.isOpen) this.toggle();
        }
    };
    _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
        if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
            if (this._showTimeout) this.clearShowTimeout();
            e.persist();
            this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
        }
    };
    _proto.onEscKeyDown = function onEscKeyDown(e) {
        if (e.key === 'Escape') this.hide(e);
    };
    _proto.getRef = function getRef(ref) {
        var innerRef = this.props.innerRef;
        if (innerRef) {
            if (typeof innerRef === 'function') innerRef(ref);
            else if ((typeof innerRef === "undefined" ? "undefined" : (0, _typeOf._)(innerRef)) === 'object') innerRef.current = ref;
        }
        this._popover = ref;
    };
    _proto.getDelay = function getDelay(key) {
        var delay = this.props.delay;
        if ((typeof delay === "undefined" ? "undefined" : (0, _typeOf._)(delay)) === 'object') return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
        return delay;
    };
    _proto.getCurrentTarget = function getCurrentTarget(target) {
        if (!target) return null;
        var index = this._targets.indexOf(target);
        if (index >= 0) return this._targets[index];
        return this.getCurrentTarget(target.parentElement);
    };
    _proto.show = function show(e) {
        if (!this.props.isOpen) {
            this.clearShowTimeout();
            this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
            if (e && e.composedPath && typeof e.composedPath === 'function') {
                var path = e.composedPath();
                this.currentTargetElement = path && path[0] || this.currentTargetElement;
            }
            this.toggle(e);
        }
    };
    _proto.showWithDelay = function showWithDelay(e) {
        if (this._hideTimeout) this.clearHideTimeout();
        this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
    };
    _proto.hide = function hide(e) {
        if (this.props.isOpen) {
            this.clearHideTimeout();
            this.currentTargetElement = null;
            this.toggle(e);
        }
    };
    _proto.hideWithDelay = function hideWithDelay(e) {
        if (this._showTimeout) this.clearShowTimeout();
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    };
    _proto.clearShowTimeout = function clearShowTimeout() {
        clearTimeout(this._showTimeout);
        this._showTimeout = undefined;
    };
    _proto.clearHideTimeout = function clearHideTimeout() {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = undefined;
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        var triggers = this.props.trigger.split(' ');
        if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) this.hideWithDelay(e);
            else if (!this.props.isOpen) this.showWithDelay(e);
        } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (!this.props.isOpen) this.showWithDelay(e);
            else this.hideWithDelay(e);
        }
    };
    _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.addEventListener(type, handler, isBubble);
        });
    };
    _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.removeEventListener(type, handler, isBubble);
        });
    };
    _proto.addTargetEvents = function addTargetEvents() {
        if (this.props.trigger) {
            var triggers = this.props.trigger.split(' ');
            if (triggers.indexOf('manual') === -1) {
                if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) document.addEventListener('click', this.handleDocumentClick, true);
                if (this._targets && this._targets.length) {
                    if (triggers.indexOf('hover') > -1) {
                        this.addEventOnTargets('mouseover', this.showWithDelay, true);
                        this.addEventOnTargets('mouseout', this.hideWithDelay, true);
                    }
                    if (triggers.indexOf('focus') > -1) {
                        this.addEventOnTargets('focusin', this.show, true);
                        this.addEventOnTargets('focusout', this.hide, true);
                    }
                    this.addEventOnTargets('keydown', this.onEscKeyDown, true);
                }
            }
        }
    };
    _proto.removeTargetEvents = function removeTargetEvents() {
        if (this._targets) {
            this.removeEventOnTargets('mouseover', this.showWithDelay, true);
            this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
            this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
            this.removeEventOnTargets('focusin', this.show, true);
            this.removeEventOnTargets('focusout', this.hide, true);
        }
        document.removeEventListener('click', this.handleDocumentClick, true);
    };
    _proto.updateTarget = function updateTarget() {
        var newTarget = (0, _utils.getTarget)(this.props.target, true);
        if (newTarget !== this._targets) {
            this.removeTargetEvents();
            this._targets = newTarget ? Array.from(newTarget) : [];
            this.currentTargetElement = this.currentTargetElement || this._targets[0];
            this.addTargetEvents();
        }
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled || !this._isMounted) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _this2 = this;
        if (this.props.isOpen) this.updateTarget();
        var target = this.currentTargetElement || this._targets[0];
        if (!target) return null;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, innerClassName = _this$props.innerClassName, isOpen = _this$props.isOpen, hideArrow = _this$props.hideArrow, boundariesElement = _this$props.boundariesElement, placement = _this$props.placement, placementPrefix = _this$props.placementPrefix, arrowClassName = _this$props.arrowClassName, popperClassName = _this$props.popperClassName, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, offset = _this$props.offset, fade = _this$props.fade, flip = _this$props.flip, children = _this$props.children;
        var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
        var popperClasses = (0, _utils.mapToCssModules)(popperClassName, cssModule);
        var classes = (0, _utils.mapToCssModules)(innerClassName, cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popperContentDefault.default), {
            className: className,
            target: target,
            isOpen: isOpen,
            hideArrow: hideArrow,
            boundariesElement: boundariesElement,
            placement: placement,
            placementPrefix: placementPrefix,
            arrowClassName: arrowClassName,
            popperClassName: popperClasses,
            container: container,
            modifiers: modifiers,
            positionFixed: positionFixed,
            offset: offset,
            cssModule: cssModule,
            fade: fade,
            flip: flip
        }, function(_ref) {
            var scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({}, attributes, {
                ref: _this2.getRef,
                className: classes,
                role: "tooltip",
                onMouseOver: _this2.onMouseOverTooltipContent,
                onMouseLeave: _this2.onMouseLeaveTooltipContent,
                onKeyDown: _this2.onEscKeyDown
            }), typeof children === 'function' ? children({
                scheduleUpdate: scheduleUpdate
            }) : children);
        });
    };
    return TooltipPopoverWrapper;
}((0, _reactDefault.default).Component);
TooltipPopoverWrapper.propTypes = propTypes;
TooltipPopoverWrapper.defaultProps = defaultProps;
exports.default = TooltipPopoverWrapper;

},{"@swc/helpers/_/_type_of":"668P4","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./PopperContent":"3quYG","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXOei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UncontrolledPopover;
});
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    'defaultOpen'
];
var UncontrolledPopover = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledPopover, _Component);
    function UncontrolledPopover(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledPopover.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledPopover;
}((0, _react.Component));
UncontrolledPopover.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool
}, (0, _popoverDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Popover":"cWyeN","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j4eLo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'h3'
};
var PopoverHeader = function PopoverHeader(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'popover-header'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
PopoverHeader.propTypes = propTypes;
PopoverHeader.defaultProps = defaultProps;
exports.default = PopoverHeader;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nhQB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var PopoverBody = function PopoverBody(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'popover-body'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
PopoverBody.propTypes = propTypes;
PopoverBody.defaultProps = defaultProps;
exports.default = PopoverBody;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMX9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "children",
    "className",
    "barClassName",
    "cssModule",
    "value",
    "min",
    "max",
    "animated",
    "striped",
    "color",
    "bar",
    "multi",
    "tag",
    "style",
    "barStyle",
    "barAriaValueText",
    "barAriaLabelledBy"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    bar: (0, _propTypesDefault.default).bool,
    multi: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    min: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    max: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    animated: (0, _propTypesDefault.default).bool,
    striped: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    barClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    style: (0, _propTypesDefault.default).object,
    barStyle: (0, _propTypesDefault.default).object,
    barAriaValueText: (0, _propTypesDefault.default).string,
    barAriaLabelledBy: (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'div',
    value: 0,
    min: 0,
    max: 100,
    style: {},
    barStyle: {}
};
var Progress = function Progress(props) {
    var children = props.children, className = props.className, barClassName = props.barClassName, cssModule = props.cssModule, value = props.value, min = props.min, max = props.max, animated = props.animated, striped = props.striped, color = props.color, bar = props.bar, multi = props.multi, Tag = props.tag, style = props.style, barStyle = props.barStyle, barAriaValueText = props.barAriaValueText, barAriaLabelledBy = props.barAriaLabelledBy, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var percent = (0, _utils.toNumber)(value) / (0, _utils.toNumber)(max) * 100;
    var progressClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'progress'), cssModule);
    var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? "bg-" + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);
    var progressBarProps = {
        className: progressBarClasses,
        style: _objectSpread(_objectSpread(_objectSpread({}, bar ? style : {}), barStyle), {}, {
            width: percent + "%"
        }),
        role: 'progressbar',
        'aria-valuenow': value,
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuetext': barAriaValueText,
        'aria-labelledby': barAriaLabelledBy,
        children: children
    };
    if (bar) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, progressBarProps));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        style: style,
        className: progressClasses
    }), multi ? children : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", progressBarProps));
};
Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;
exports.default = Progress;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8tDiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function noop() {}
var FadePropTypes = (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes);
var propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    autoFocus: (0, _propTypesDefault.default).bool,
    centered: (0, _propTypesDefault.default).bool,
    scrollable: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).string,
    toggle: (0, _propTypesDefault.default).func,
    keyboard: (0, _propTypesDefault.default).bool,
    role: (0, _propTypesDefault.default).string,
    labelledBy: (0, _propTypesDefault.default).string,
    backdrop: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).oneOf([
            'static'
        ])
    ]),
    onEnter: (0, _propTypesDefault.default).func,
    onExit: (0, _propTypesDefault.default).func,
    onOpened: (0, _propTypesDefault.default).func,
    onClosed: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    wrapClassName: (0, _propTypesDefault.default).string,
    modalClassName: (0, _propTypesDefault.default).string,
    backdropClassName: (0, _propTypesDefault.default).string,
    contentClassName: (0, _propTypesDefault.default).string,
    external: (0, _propTypesDefault.default).node,
    fade: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    zIndex: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    backdropTransition: FadePropTypes,
    modalTransition: FadePropTypes,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    unmountOnClose: (0, _propTypesDefault.default).bool,
    returnFocusAfterClose: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType),
    trapFocus: (0, _propTypesDefault.default).bool
};
var propsToOmit = Object.keys(propTypes);
var defaultProps = {
    isOpen: false,
    autoFocus: true,
    centered: false,
    scrollable: false,
    role: 'dialog',
    backdrop: true,
    keyboard: true,
    zIndex: 1050,
    fade: true,
    onOpened: noop,
    onClosed: noop,
    modalTransition: {
        timeout: (0, _utils.TransitionTimeouts).Modal
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: (0, _utils.TransitionTimeouts).Fade // uses standard fade transition
    },
    unmountOnClose: true,
    returnFocusAfterClose: true,
    container: 'body',
    trapFocus: false
};
var Modal = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Modal, _React$Component);
    function Modal(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._element = null;
        _this._originalBodyPadding = null;
        _this.getFocusableChildren = _this.getFocusableChildren.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleBackdropClick = _this.handleBackdropClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleTab = _this.handleTab.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onOpened = _this.onOpened.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.trapFocus = _this.trapFocus.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: false,
            showStaticBackdropAnimation: false
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this$props = this.props, isOpen = _this$props.isOpen, autoFocus = _this$props.autoFocus, onEnter = _this$props.onEnter;
        if (isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            if (autoFocus) this.setFocus();
        }
        if (onEnter) onEnter();
         // traps focus inside the Modal, even if the browser address bar is focused
        document.addEventListener('focus', this.trapFocus, true);
        this._isMounted = true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.init();
            this.setState({
                isOpen: true
            }); // let render() renders Modal Dialog first
            return;
        } // now Modal Dialog is rendered and we can refer this._element and this._dialog
        if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) this.setFocus();
        if (this._element && prevProps.zIndex !== this.props.zIndex) this._element.style.zIndex = this.props.zIndex;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.clearBackdropAnimationTimeout();
        if (this.props.onExit) this.props.onExit();
        if (this._element) {
            this.destroy();
            if (this.props.isOpen || this.state.isOpen) this.close();
        }
        document.removeEventListener('focus', this.trapFocus, true);
        this._isMounted = false;
    };
    _proto.trapFocus = function trapFocus(ev) {
        if (!this.props.trapFocus) return;
        if (!this._element) return;
        if (this._dialog && this._dialog.parentNode === ev.target) return;
        if (this.modalIndex < Modal.openCount - 1) return;
        var children = this.getFocusableChildren();
        for(var i = 0; i < children.length; i++){
            // focus is already inside the Modal
            if (children[i] === ev.target) return;
        }
        if (children.length > 0) {
            // otherwise focus the first focusable element in the Modal
            ev.preventDefault();
            ev.stopPropagation();
            children[0].focus();
        }
    };
    _proto.onOpened = function onOpened(node, isAppearing) {
        this.props.onOpened();
        (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    };
    _proto.onClosed = function onClosed(node) {
        var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
        this.props.onClosed();
        (this.props.modalTransition.onExited || noop)(node);
        if (unmountOnClose) this.destroy();
        this.close();
        if (this._isMounted) this.setState({
            isOpen: false
        });
    };
    _proto.setFocus = function setFocus() {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') this._dialog.parentNode.focus();
    };
    _proto.getFocusableChildren = function getFocusableChildren() {
        return this._element.querySelectorAll((0, _utils.focusableElements).join(', '));
    };
    _proto.getFocusedChild = function getFocusedChild() {
        var currentFocus;
        var focusableChildren = this.getFocusableChildren();
        try {
            currentFocus = document.activeElement;
        } catch (err) {
            currentFocus = focusableChildren[0];
        }
        return currentFocus;
    } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
    ;
    _proto.handleBackdropClick = function handleBackdropClick(e) {
        if (e.target === this._mouseDownElement) {
            e.stopPropagation();
            var backdrop = this._dialog ? this._dialog.parentNode : null;
            if (backdrop && e.target === backdrop && this.props.backdrop === 'static') this.handleStaticBackdropAnimation();
            if (!this.props.isOpen || this.props.backdrop !== true) return;
            if (backdrop && e.target === backdrop && this.props.toggle) this.props.toggle(e);
        }
    };
    _proto.handleTab = function handleTab(e) {
        if (e.which !== 9) return;
        if (this.modalIndex < Modal.openCount - 1) return; // last opened modal
        var focusableChildren = this.getFocusableChildren();
        var totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) return;
        var currentFocus = this.getFocusedChild();
        var focusedIndex = 0;
        for(var i = 0; i < totalFocusable; i += 1)if (focusableChildren[i] === currentFocus) {
            focusedIndex = i;
            break;
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    };
    _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
        this._mouseDownElement = e.target;
    };
    _proto.handleEscape = function handleEscape(e) {
        if (this.props.isOpen && e.keyCode === (0, _utils.keyCodes).esc && this.props.toggle) {
            if (this.props.keyboard) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggle(e);
            } else if (this.props.backdrop === 'static') {
                e.preventDefault();
                e.stopPropagation();
                this.handleStaticBackdropAnimation();
            }
        }
    };
    _proto.handleStaticBackdropAnimation = function handleStaticBackdropAnimation() {
        var _this2 = this;
        this.clearBackdropAnimationTimeout();
        this.setState({
            showStaticBackdropAnimation: true
        });
        this._backdropAnimationTimeout = setTimeout(function() {
            _this2.setState({
                showStaticBackdropAnimation: false
            });
        }, 100);
    };
    _proto.init = function init() {
        try {
            this._triggeringElement = document.activeElement;
        } catch (err) {
            this._triggeringElement = null;
        }
        if (!this._element) {
            this._element = document.createElement('div');
            this._element.setAttribute('tabindex', '-1');
            this._element.style.position = 'relative';
            this._element.style.zIndex = this.props.zIndex;
            this._mountContainer = (0, _utils.getTarget)(this.props.container);
            this._mountContainer.appendChild(this._element);
        }
        this._originalBodyPadding = (0, _utils.getOriginalBodyPadding)();
        (0, _utils.conditionallyUpdateScrollbar)();
        if (Modal.openCount === 0) document.body.className = (0, _classnamesDefault.default)(document.body.className, (0, _utils.mapToCssModules)('modal-open', this.props.cssModule));
        this.modalIndex = Modal.openCount;
        Modal.openCount += 1;
    };
    _proto.destroy = function destroy() {
        if (this._element) {
            this._mountContainer.removeChild(this._element);
            this._element = null;
        }
        this.manageFocusAfterClose();
    };
    _proto.manageFocusAfterClose = function manageFocusAfterClose() {
        if (this._triggeringElement) {
            var returnFocusAfterClose = this.props.returnFocusAfterClose;
            if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
            this._triggeringElement = null;
        }
    };
    _proto.close = function close() {
        if (Modal.openCount <= 1) {
            var modalOpenClassName = (0, _utils.mapToCssModules)('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
            var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
            document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        }
        this.manageFocusAfterClose();
        Modal.openCount = Math.max(0, Modal.openCount - 1);
        (0, _utils.setScrollbarWidth)(this._originalBodyPadding);
    };
    _proto.renderModalDialog = function renderModalDialog() {
        var _classNames, _this3 = this;
        var attributes = (0, _utils.omit)(this.props, propsToOmit);
        var dialogBaseClass = 'modal-dialog';
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({}, attributes, {
            className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
            role: "document",
            ref: function ref(c) {
                _this3._dialog = c;
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('modal-content', this.props.contentClassName), this.props.cssModule)
        }, this.props.children));
    };
    _proto.render = function render() {
        var unmountOnClose = this.props.unmountOnClose;
        if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
            var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
            this._element.style.display = isModalHidden ? 'none' : 'block';
            var _this$props2 = this.props, wrapClassName = _this$props2.wrapClassName, modalClassName = _this$props2.modalClassName, backdropClassName = _this$props2.backdropClassName, cssModule = _this$props2.cssModule, isOpen = _this$props2.isOpen, backdrop = _this$props2.backdrop, role = _this$props2.role, labelledBy = _this$props2.labelledBy, external = _this$props2.external, innerRef = _this$props2.innerRef;
            var modalAttributes = {
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown,
                onKeyUp: this.handleEscape,
                onKeyDown: this.handleTab,
                style: {
                    display: 'block'
                },
                'aria-labelledby': labelledBy,
                role: role,
                tabIndex: '-1'
            };
            var hasTransition = this.props.fade;
            var modalTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), this.props.modalTransition), {}, {
                baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
                timeout: hasTransition ? this.props.modalTransition.timeout : 0
            });
            var backdropTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), this.props.backdropTransition), {}, {
                baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
                timeout: hasTransition ? this.props.backdropTransition.timeout : 0
            });
            var Backdrop = backdrop && (hasTransition ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, backdropTransition, {
                in: isOpen && !!backdrop,
                cssModule: cssModule,
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('modal-backdrop', backdropClassName), cssModule)
            })) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('modal-backdrop', 'show', backdropClassName), cssModule)
            }));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalDefault.default), {
                node: this._element
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _utils.mapToCssModules)(wrapClassName)
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, modalAttributes, modalTransition, {
                in: isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
                innerRef: innerRef
            }), external, this.renderModalDialog()), Backdrop));
        }
        return null;
    };
    _proto.clearBackdropAnimationTimeout = function clearBackdropAnimationTimeout() {
        if (this._backdropAnimationTimeout) {
            clearTimeout(this._backdropAnimationTimeout);
            this._backdropAnimationTimeout = undefined;
        }
    };
    return Modal;
}((0, _reactDefault.default).Component);
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.openCount = 0;
exports.default = Modal;

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./Portal":"j8DPH","./Fade":"8vV1v","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8DPH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("./utils");
var propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    node: (0, _propTypesDefault.default).any
};
var Portal = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Portal, _React$Component);
    function Portal() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    };
    _proto.render = function render() {
        if (!(0, _utils.canUseDOM)) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement('div');
            document.body.appendChild(this.defaultNode);
        }
        return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(this.props.children, this.props.node || this.defaultNode);
    };
    return Portal;
}((0, _reactDefault.default).Component);
Portal.propTypes = propTypes;
exports.default = Portal;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","react-dom":"d8jlt","prop-types":"3KNJy","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hPCLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "children",
    "toggle",
    "tag",
    "wrapTag",
    "closeAriaLabel",
    "charCode",
    "close"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    wrapTag: (0, _utils.tagPropType),
    toggle: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    closeAriaLabel: (0, _propTypesDefault.default).string,
    charCode: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    close: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'h5',
    wrapTag: 'div',
    closeAriaLabel: 'Close',
    charCode: 215
};
var ModalHeader = function ModalHeader(props) {
    var closeButton;
    var className = props.className, cssModule = props.cssModule, children = props.children, toggle = props.toggle, Tag = props.tag, WrapTag = props.wrapTag, closeAriaLabel = props.closeAriaLabel, charCode = props.charCode, close = props.close, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'modal-header'), cssModule);
    if (!close && toggle) {
        var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
        closeButton = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            onClick: toggle,
            className: (0, _utils.mapToCssModules)('close', cssModule),
            "aria-label": closeAriaLabel
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true"
        }, closeIcon));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapTag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, {
        className: (0, _utils.mapToCssModules)('modal-title', cssModule)
    }, children), close || closeButton);
};
ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
exports.default = ModalHeader;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aaWGA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var ModalBody = function ModalBody(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'modal-body'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
exports.default = ModalBody;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"91ciL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var ModalFooter = function ModalFooter(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'modal-footer'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
exports.default = ModalFooter;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Zg6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tooltipPopoverWrapper = require("./TooltipPopoverWrapper");
var _tooltipPopoverWrapperDefault = parcelHelpers.interopDefault(_tooltipPopoverWrapper);
var defaultProps = {
    placement: 'top',
    autohide: true,
    placementPrefix: 'bs-tooltip',
    trigger: 'hover focus'
};
var Tooltip = function Tooltip(props) {
    var popperClasses = (0, _classnamesDefault.default)('tooltip', 'show', props.popperClassName);
    var classes = (0, _classnamesDefault.default)('tooltip-inner', props.innerClassName);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipPopoverWrapperDefault.default), (0, _extendsDefault.default)({}, props, {
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
Tooltip.propTypes = (0, _tooltipPopoverWrapper.propTypes);
Tooltip.defaultProps = defaultProps;
exports.default = Tooltip;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","classnames":"6P5cq","./TooltipPopoverWrapper":"5CNLJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jvH2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "size",
    "bordered",
    "borderless",
    "striped",
    "dark",
    "hover",
    "responsive",
    "tag",
    "responsiveTag",
    "innerRef"
];
var propTypes = {
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    size: (0, _propTypesDefault.default).string,
    bordered: (0, _propTypesDefault.default).bool,
    borderless: (0, _propTypesDefault.default).bool,
    striped: (0, _propTypesDefault.default).bool,
    dark: (0, _propTypesDefault.default).bool,
    hover: (0, _propTypesDefault.default).bool,
    responsive: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    tag: (0, _utils.tagPropType),
    responsiveTag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ])
};
var defaultProps = {
    tag: 'table',
    responsiveTag: 'div'
};
var Table = function Table(props) {
    var className = props.className, cssModule = props.cssModule, size = props.size, bordered = props.bordered, borderless = props.borderless, striped = props.striped, dark = props.dark, hover = props.hover, responsive = props.responsive, Tag = props.tag, ResponsiveTag = props.responsiveTag, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);
    var table = /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        ref: innerRef,
        className: classes
    }));
    if (responsive) {
        var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? 'table-responsive' : "table-responsive-" + responsive, cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(ResponsiveTag, {
            className: responsiveClassName
        }, table);
    }
    return table;
};
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
exports.default = Table;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iDJqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "flush",
    "horizontal"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    flush: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    horizontal: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ])
};
var defaultProps = {
    tag: 'ul',
    horizontal: false
};
var getHorizontalClass = function getHorizontalClass(horizontal) {
    if (horizontal === false) return false;
    else if (horizontal === true || horizontal === "xs") return "list-group-horizontal";
    return "list-group-horizontal-" + horizontal;
};
var ListGroup = function ListGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, flush = props.flush, horizontal = props.horizontal, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'list-group', // we only try to apply horizontal classes if flush is false
    flush ? 'list-group-flush' : getHorizontalClass(horizontal)), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ListGroup.propTypes = propTypes;
ListGroup.defaultProps = defaultProps;
exports.default = ListGroup;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2gf62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "inline",
    "tag",
    "innerRef"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    inline: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'form'
};
var Form = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(Form, _Component);
    function Form(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.submit = _this.submit.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Form.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.submit = function submit() {
        if (this.ref) this.ref.submit();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, inline = _this$props.inline, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, inline ? 'form-inline' : false), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            className: classes
        }));
    };
    return Form;
}((0, _react.Component));
Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
exports.default = Form;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aMpcp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "valid",
    "tooltip",
    "tag"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    valid: (0, _propTypesDefault.default).bool,
    tooltip: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: 'div',
    valid: undefined
};
var FormFeedback = function FormFeedback(props) {
    var className = props.className, cssModule = props.cssModule, valid = props.valid, tooltip = props.tooltip, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var validMode = tooltip ? 'tooltip' : 'feedback';
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
FormFeedback.propTypes = propTypes;
FormFeedback.defaultProps = defaultProps;
exports.default = FormFeedback;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"79mrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "row",
    "disabled",
    "check",
    "inline",
    "tag"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    row: (0, _propTypesDefault.default).bool,
    check: (0, _propTypesDefault.default).bool,
    inline: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var FormGroup = function FormGroup(props) {
    var className = props.className, cssModule = props.cssModule, row = props.row, disabled = props.disabled, check = props.check, inline = props.inline, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);
    if (Tag === 'fieldset') attributes.disabled = disabled;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;
exports.default = FormGroup;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iIXko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "inline",
    "color",
    "tag"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    inline: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    color: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'small',
    color: 'muted'
};
var FormText = function FormText(props) {
    var className = props.className, cssModule = props.cssModule, inline = props.inline, color = props.color, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, !inline ? 'form-text' : false, color ? "text-" + color : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
FormText.propTypes = propTypes;
FormText.defaultProps = defaultProps;
exports.default = FormText;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gH52C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
/* eslint react/prefer-stateless-function: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "type",
    "bsSize",
    "valid",
    "invalid",
    "tag",
    "addon",
    "plaintext",
    "innerRef"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    type: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    bsSize: (0, _propTypesDefault.default).string,
    valid: (0, _propTypesDefault.default).bool,
    invalid: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    plaintext: (0, _propTypesDefault.default).bool,
    addon: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    type: 'text'
};
var Input = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Input, _React$Component);
    function Input(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.focus = _this.focus.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Input.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.focus = function focus() {
        if (this.ref) this.ref.focus();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, type = _this$props.type, bsSize = _this$props.bsSize, valid = _this$props.valid, invalid = _this$props.invalid, tag = _this$props.tag, addon = _this$props.addon, plaintext = _this$props.plaintext, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var checkInput = [
            'radio',
            'checkbox'
        ].indexOf(type) > -1;
        var isNotaNumber = new RegExp('\\D', 'g');
        var fileInput = type === 'file';
        var textareaInput = type === 'textarea';
        var selectInput = type === 'select';
        var rangeInput = type === 'range';
        var Tag = tag || (selectInput || textareaInput ? type : 'input');
        var formControlClass = 'form-control';
        if (plaintext) {
            formControlClass = formControlClass + "-plaintext";
            Tag = tag || 'input';
        } else if (fileInput) formControlClass = formControlClass + "-file";
        else if (rangeInput) formControlClass = formControlClass + "-range";
        else if (checkInput) {
            if (addon) formControlClass = null;
            else formControlClass = 'form-check-input';
        }
        if (attributes.size && isNotaNumber.test(attributes.size)) {
            (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
            bsSize = attributes.size;
            delete attributes.size;
        }
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
        if (Tag === 'input' || tag && typeof tag === 'function') attributes.type = type;
        if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
            (0, _utils.warnOnce)("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
            delete attributes.children;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            className: classes,
            "aria-invalid": invalid
        }));
    };
    return Input;
}((0, _reactDefault.default).Component);
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
exports.default = Input;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1kZ4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "size"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    size: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var InputGroup = function InputGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, size = props.size, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'input-group', size ? "input-group-" + size : null), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;
exports.default = InputGroup;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Kprt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "addonType",
    "children"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    addonType: (0, _propTypesDefault.default).oneOf([
        'prepend',
        'append'
    ]).isRequired,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var InputGroupAddon = function InputGroupAddon(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, addonType = props.addonType, children = props.children, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition
    if (typeof children === 'string') return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputGroupTextDefault.default), {
        children: children
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        children: children
    }));
};
InputGroupAddon.propTypes = propTypes;
InputGroupAddon.defaultProps = defaultProps;
exports.default = InputGroupAddon;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","./InputGroupText":"kmtcq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kmtcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'span'
};
var InputGroupText = function InputGroupText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'input-group-text'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
InputGroupText.propTypes = propTypes;
InputGroupText.defaultProps = defaultProps;
exports.default = InputGroupText;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4aOb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var propTypes = {
    addonType: (0, _propTypesDefault.default).oneOf([
        'prepend',
        'append'
    ]).isRequired,
    children: (0, _propTypesDefault.default).node
};
var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownDefault.default), props);
};
InputGroupButtonDropdown.propTypes = propTypes;
exports.default = InputGroupButtonDropdown;

},{"react":"gVheC","prop-types":"3KNJy","./Dropdown":"9IyKZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fWy5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "hidden",
    "widths",
    "tag",
    "check",
    "size",
    "for"
];
var colWidths = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
var stringOrNumberProp = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var columnProps = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).shape({
        size: stringOrNumberProp,
        order: stringOrNumberProp,
        offset: stringOrNumberProp
    })
]);
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    hidden: (0, _propTypesDefault.default).bool,
    check: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).string,
    for: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    xs: columnProps,
    sm: columnProps,
    md: columnProps,
    lg: columnProps,
    xl: columnProps,
    widths: (0, _propTypesDefault.default).array
};
var defaultProps = {
    tag: 'label',
    widths: colWidths
};
var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === '') return isXs ? 'col' : "col-" + colWidth;
    else if (colSize === 'auto') return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var Label = function Label(props) {
    var className = props.className, cssModule = props.cssModule, hidden = props.hidden, widths = props.widths, Tag = props.tag, check = props.check, size = props.size, htmlFor = props.for, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== '') return;
        var isXs = !i;
        var colClass;
        if ((0, _utils.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
            colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, _utils.mapToCssModules)((0, _classnamesDefault.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
        } else {
            colClass = getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
        htmlFor: htmlFor
    }, attributes, {
        className: classes
    }));
};
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
exports.default = Label;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ekIhP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "body",
    "bottom",
    "className",
    "cssModule",
    "heading",
    "left",
    "list",
    "middle",
    "object",
    "right",
    "tag",
    "top"
];
var propTypes = {
    body: (0, _propTypesDefault.default).bool,
    bottom: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    heading: (0, _propTypesDefault.default).bool,
    left: (0, _propTypesDefault.default).bool,
    list: (0, _propTypesDefault.default).bool,
    middle: (0, _propTypesDefault.default).bool,
    object: (0, _propTypesDefault.default).bool,
    right: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    top: (0, _propTypesDefault.default).bool
};
var Media = function Media(props) {
    var body = props.body, bottom = props.bottom, className = props.className, cssModule = props.cssModule, heading = props.heading, left = props.left, list = props.list, middle = props.middle, object = props.object, right = props.right, tag = props.tag, top = props.top, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var defaultTag;
    if (heading) defaultTag = 'h4';
    else if (attributes.href) defaultTag = 'a';
    else if (attributes.src || object) defaultTag = 'img';
    else if (list) defaultTag = 'ul';
    else defaultTag = 'div';
    var Tag = tag || defaultTag;
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
        'media-body': body,
        'media-heading': heading,
        'media-left': left,
        'media-right': right,
        'media-top': top,
        'media-bottom': bottom,
        'media-middle': middle,
        'media-object': object,
        'media-list': list,
        media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
    }), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Media.propTypes = propTypes;
exports.default = Media;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"foGKi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "listClassName",
    "cssModule",
    "size",
    "tag",
    "listTag",
    "aria-label"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    listClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    size: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    listTag: (0, _utils.tagPropType),
    'aria-label': (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'nav',
    listTag: 'ul',
    'aria-label': 'pagination'
};
var Pagination = function Pagination(props) {
    var _classNames;
    var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, size = props.size, Tag = props.tag, ListTag = props.listTag, label = props['aria-label'], attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className), cssModule);
    var listClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(listClassName, 'pagination', (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, {
        className: classes,
        "aria-label": label
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ListTag, (0, _extendsDefault.default)({}, attributes, {
        className: listClasses
    })));
};
Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
exports.default = Pagination;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8yW3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "active",
    "className",
    "cssModule",
    "disabled",
    "tag"
];
var propTypes = {
    active: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    disabled: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType)
};
var defaultProps = {
    tag: 'li'
};
var PaginationItem = function PaginationItem(props) {
    var active = props.active, className = props.className, cssModule = props.cssModule, disabled = props.disabled, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'page-item', {
        active: active,
        disabled: disabled
    }), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;
exports.default = PaginationItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49YCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "next",
    "previous",
    "first",
    "last",
    "tag"
];
var propTypes = {
    'aria-label': (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    next: (0, _propTypesDefault.default).bool,
    previous: (0, _propTypesDefault.default).bool,
    first: (0, _propTypesDefault.default).bool,
    last: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType)
};
var defaultProps = {
    tag: 'a'
};
var PaginationLink = function PaginationLink(props) {
    var className = props.className, cssModule = props.cssModule, next = props.next, previous = props.previous, first = props.first, last = props.last, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'page-link'), cssModule);
    var defaultAriaLabel;
    if (previous) defaultAriaLabel = 'Previous';
    else if (next) defaultAriaLabel = 'Next';
    else if (first) defaultAriaLabel = 'First';
    else if (last) defaultAriaLabel = 'Last';
    var ariaLabel = props['aria-label'] || defaultAriaLabel;
    var defaultCaret;
    if (previous) defaultCaret = "\u2039";
    else if (next) defaultCaret = "\u203A";
    else if (first) defaultCaret = "\xAB";
    else if (last) defaultCaret = "\xBB";
    var children = props.children;
    if (children && Array.isArray(children) && children.length === 0) children = null;
    if (!attributes.href && Tag === 'a') Tag = 'button';
    if (previous || next || first || last) children = [
        /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            key: "caret"
        }, children || defaultCaret),
        /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "sr-only",
            key: "sr"
        }, ariaLabel)
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        "aria-label": ariaLabel
    }), children);
};
PaginationLink.propTypes = propTypes;
PaginationLink.defaultProps = defaultProps;
exports.default = PaginationLink;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPGhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tabContext = require("./TabContext");
var _utils = require("./utils");
var propTypes = {
    tag: (0, _utils.tagPropType),
    activeTab: (0, _propTypesDefault.default).any,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var TabContent = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(TabContent, _Component);
    TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.activeTab !== nextProps.activeTab) return {
            activeTab: nextProps.activeTab
        };
        return null;
    };
    function TabContent(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            activeTab: _this.props.activeTab
        };
        return _this;
    }
    var _proto = TabContent.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, Tag = _this$props.tag;
        var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('tab-content', className), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tabContext.TabContext).Provider, {
            value: {
                activeTabId: this.state.activeTab
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            className: classes
        })));
    };
    return TabContent;
}((0, _react.Component));
exports.default = TabContent;
TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./TabContext":"2DI7s","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2DI7s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabContext", function() {
    return TabContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var TabContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8LEkw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return TabPane;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tabContext = require("./TabContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tabId",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    tabId: (0, _propTypesDefault.default).any
};
var defaultProps = {
    tag: 'div'
};
function TabPane(props) {
    var className = props.className, cssModule = props.cssModule, tabId = props.tabId, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var getClasses = function getClasses(activeTabId) {
        return (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('tab-pane', className, {
            active: tabId === activeTabId
        }), cssModule);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tabContext.TabContext).Consumer, null, function(_ref) {
        var activeTabId = _ref.activeTabId;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            className: getClasses(activeTabId)
        }));
    });
}
TabPane.propTypes = propTypes;
TabPane.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./TabContext":"2DI7s","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZbBH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "fluid"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    fluid: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'div'
};
var Jumbotron = function Jumbotron(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, fluid = props.fluid, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
exports.default = Jumbotron;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2a0hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _excluded = [
    "className",
    "closeClassName",
    "closeAriaLabel",
    "cssModule",
    "tag",
    "color",
    "isOpen",
    "toggle",
    "children",
    "transition",
    "fade",
    "innerRef"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    closeClassName: (0, _propTypesDefault.default).string,
    closeAriaLabel: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    color: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    toggle: (0, _propTypesDefault.default).func,
    tag: (0, _utils.tagPropType),
    transition: (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    color: 'success',
    isOpen: true,
    tag: 'div',
    closeAriaLabel: 'Close',
    fade: true,
    transition: _objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), {}, {
        unmountOnExit: true
    })
};
function Alert(props) {
    var className = props.className, closeClassName = props.closeClassName, closeAriaLabel = props.closeAriaLabel, cssModule = props.cssModule, Tag = props.tag, color = props.color, isOpen = props.isOpen, toggle = props.toggle, children = props.children, transition = props.transition, fade = props.fade, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'alert', "alert-" + color, {
        'alert-dismissible': toggle
    }), cssModule);
    var closeClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)('close', closeClassName), cssModule);
    var alertTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), transition), {}, {
        baseClass: fade ? transition.baseClass : '',
        timeout: fade ? transition.timeout : 0
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, attributes, alertTransition, {
        tag: Tag,
        className: classes,
        in: isOpen,
        role: "alert",
        innerRef: innerRef
    }), toggle ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: closeClasses,
        "aria-label": closeAriaLabel,
        onClick: toggle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true"
    }, "\xD7")) : null, children);
}
Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
exports.default = Alert;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","./Fade":"8vV1v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4Bat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "isOpen",
    "children",
    "transition",
    "fade",
    "innerRef"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    fade: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    transition: (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    isOpen: true,
    tag: 'div',
    fade: true,
    transition: _objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), {}, {
        unmountOnExit: true
    })
};
function Toast(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, isOpen = props.isOpen, children = props.children, transition = props.transition, fade = props.fade, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'toast'), cssModule);
    var toastTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), transition), {}, {
        baseClass: fade ? transition.baseClass : '',
        timeout: fade ? transition.timeout : 0
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, attributes, toastTransition, {
        tag: Tag,
        className: classes,
        in: isOpen,
        role: "alert",
        innerRef: innerRef
    }), children);
}
Toast.propTypes = propTypes;
Toast.defaultProps = defaultProps;
exports.default = Toast;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","./Fade":"8vV1v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dk4p5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "innerRef",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    tag: 'div'
};
var ToastBody = function ToastBody(props) {
    var className = props.className, cssModule = props.cssModule, innerRef = props.innerRef, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'toast-body'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
ToastBody.propTypes = propTypes;
ToastBody.defaultProps = defaultProps;
exports.default = ToastBody;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TKxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "children",
    "toggle",
    "tag",
    "wrapTag",
    "closeAriaLabel",
    "charCode",
    "close",
    "tagClassName",
    "icon"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    icon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    wrapTag: (0, _utils.tagPropType),
    toggle: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    closeAriaLabel: (0, _propTypesDefault.default).string,
    charCode: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    close: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'strong',
    wrapTag: 'div',
    tagClassName: 'mr-auto',
    closeAriaLabel: 'Close',
    charCode: 215
};
var ToastHeader = function ToastHeader(props) {
    var closeButton;
    var icon;
    var className = props.className, cssModule = props.cssModule, children = props.children, toggle = props.toggle, Tag = props.tag, WrapTag = props.wrapTag, closeAriaLabel = props.closeAriaLabel, charCode = props.charCode, close = props.close, tagClassName = props.tagClassName, iconProp = props.icon, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'toast-header'), cssModule);
    if (!close && toggle) {
        var closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
        closeButton = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            onClick: toggle,
            className: (0, _utils.mapToCssModules)('close', cssModule),
            "aria-label": closeAriaLabel
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true"
        }, closeIcon));
    }
    if (typeof iconProp === "string") icon = /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        className: (0, _utils.mapToCssModules)("rounded text-" + iconProp),
        width: "20",
        height: "20",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid slice",
        focusable: "false",
        role: "img"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        fill: "currentColor",
        width: "100%",
        height: "100%"
    }));
    else if (iconProp) icon = iconProp;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapTag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }), icon, /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, {
        className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(tagClassName, {
            "ml-2": icon != null
        }), cssModule)
    }, children), close || closeButton);
};
ToastHeader.propTypes = propTypes;
ToastHeader.defaultProps = defaultProps;
exports.default = ToastHeader;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8W5Oc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("./utils");
var _excluded = [
    "tag",
    "isOpen",
    "className",
    "navbar",
    "cssModule",
    "children",
    "innerRef"
];
var _transitionStatusToCl;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).propTypes), {}, {
    isOpen: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]),
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).node,
    navbar: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ])
});
var defaultProps = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).defaultProps), {}, {
    isOpen: false,
    appear: false,
    enter: true,
    exit: true,
    tag: 'div',
    timeout: (0, _utils.TransitionTimeouts).Collapse
});
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[(0, _utils.TransitionStatuses).ENTERING] = 'collapsing', _transitionStatusToCl[(0, _utils.TransitionStatuses).ENTERED] = 'collapse show', _transitionStatusToCl[(0, _utils.TransitionStatuses).EXITING] = 'collapsing', _transitionStatusToCl[(0, _utils.TransitionStatuses).EXITED] = 'collapse', _transitionStatusToCl);
function getTransitionClass(status) {
    return transitionStatusToClassHash[status] || 'collapse';
}
function getHeight(node) {
    return node.scrollHeight;
}
var Collapse = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(Collapse, _Component);
    function Collapse(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            height: null
        };
        [
            'onEntering',
            'onEntered',
            'onExit',
            'onExiting',
            'onExited'
        ].forEach(function(name) {
            _this[name] = _this[name].bind((0, _assertThisInitializedDefault.default)(_this));
        });
        return _this;
    }
    var _proto = Collapse.prototype;
    _proto.onEntering = function onEntering(node, isAppearing) {
        this.setState({
            height: getHeight(node)
        });
        this.props.onEntering(node, isAppearing);
    };
    _proto.onEntered = function onEntered(node, isAppearing) {
        this.setState({
            height: null
        });
        this.props.onEntered(node, isAppearing);
    };
    _proto.onExit = function onExit(node) {
        this.setState({
            height: getHeight(node)
        });
        this.props.onExit(node);
    };
    _proto.onExiting = function onExiting(node) {
        // getting this variable triggers a reflow
        var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        this.setState({
            height: 0
        });
        this.props.onExiting(node);
    };
    _proto.onExited = function onExited(node) {
        this.setState({
            height: null
        });
        this.props.onExited(node);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, Tag = _this$props.tag, isOpen = _this$props.isOpen, className = _this$props.className, navbar = _this$props.navbar, cssModule = _this$props.cssModule, children = _this$props.children, innerRef = _this$props.innerRef, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var height = this.state.height;
        var transitionProps = (0, _utils.pick)(otherProps, (0, _utils.TransitionPropTypeKeys));
        var childProps = (0, _utils.omit)(otherProps, (0, _utils.TransitionPropTypeKeys));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), (0, _extendsDefault.default)({}, transitionProps, {
            in: isOpen,
            onEntering: this.onEntering,
            onEntered: this.onEntered,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }), function(status) {
            var collapseClass = getTransitionClass(status);
            var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
            var style = height === null ? null : {
                height: height
            };
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, childProps, {
                style: _objectSpread(_objectSpread({}, childProps.style), style),
                className: classes,
                ref: _this2.props.innerRef
            }), children);
        });
    };
    return Collapse;
}((0, _react.Component));
Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
exports.default = Collapse;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","react-transition-group":"aiK82","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lsxVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "active",
    "disabled",
    "action",
    "color"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    active: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    action: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).any,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'li'
};
var handleDisabledOnClick = function handleDisabledOnClick(e) {
    e.preventDefault();
};
var ListGroupItem = function ListGroupItem(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, active = props.active, disabled = props.disabled, action = props.action, color = props.color, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? "list-group-item-" + color : false, 'list-group-item'), cssModule); // Prevent click event when disabled.
    if (disabled) attributes.onClick = handleDisabledOnClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
exports.default = ListGroupItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iswj9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).any,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'h5'
};
var ListGroupItemHeading = function ListGroupItemHeading(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'list-group-item-heading'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ListGroupItemHeading.propTypes = propTypes;
ListGroupItemHeading.defaultProps = defaultProps;
exports.default = ListGroupItemHeading;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8g9r0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).any,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'p'
};
var ListGroupItemText = function ListGroupItemText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'list-group-item-text'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ListGroupItemText.propTypes = propTypes;
ListGroupItemText.defaultProps = defaultProps;
exports.default = ListGroupItemText;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kb1Il":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "type"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    type: (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'ul'
};
var List = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, type = props.type, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, type ? "list-" + type : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: ref
    }));
});
List.propTypes = propTypes;
List.defaultProps = defaultProps;
exports.default = List;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3IDO2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: 'li'
};
var ListInlineItem = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, 'list-inline-item'), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: ref
    }));
});
ListInlineItem.propTypes = propTypes;
ListInlineItem.defaultProps = defaultProps;
exports.default = ListInlineItem;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hvzcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var UncontrolledAlert = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledAlert, _Component);
    function UncontrolledAlert(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledAlert.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, this.props));
    };
    return UncontrolledAlert;
}((0, _react.Component));
exports.default = UncontrolledAlert;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","./Alert":"2a0hr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a3sJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UncontrolledButtonDropdown;
});
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _buttonDropdown = require("./ButtonDropdown");
var _buttonDropdownDefault = parcelHelpers.interopDefault(_buttonDropdown);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    'defaultOpen'
];
var UncontrolledButtonDropdown = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledButtonDropdown, _Component);
    function UncontrolledButtonDropdown(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledButtonDropdown.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDropdownDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledButtonDropdown;
}((0, _react.Component));
UncontrolledButtonDropdown.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool
}, (0, _buttonDropdownDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./ButtonDropdown":"7h9vu","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1N0HO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _utils = require("./utils");
var omitKeys = [
    'toggleEvents',
    'defaultOpen'
];
var propTypes = {
    defaultOpen: (0, _propTypesDefault.default).bool,
    toggler: (0, _propTypesDefault.default).string.isRequired,
    toggleEvents: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
};
var defaultProps = {
    toggleEvents: (0, _utils.defaultToggleEvents)
};
var UncontrolledCollapse = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledCollapse, _Component);
    function UncontrolledCollapse(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.togglers = null;
        _this.removeEventListeners = null;
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        return _this;
    }
    var _proto = UncontrolledCollapse.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.togglers = (0, _utils.findDOMElements)(this.props.toggler);
        if (this.togglers.length) this.removeEventListeners = (0, _utils.addMultipleEventListeners)(this.togglers, this.toggle, this.props.toggleEvents);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.togglers.length && this.removeEventListeners) this.removeEventListeners();
    };
    _proto.toggle = function toggle(e) {
        this.setState(function(_ref) {
            var isOpen = _ref.isOpen;
            return {
                isOpen: !isOpen
            };
        });
        e.preventDefault();
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collapseDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledCollapse;
}((0, _react.Component));
UncontrolledCollapse.propTypes = propTypes;
UncontrolledCollapse.defaultProps = defaultProps;
exports.default = UncontrolledCollapse;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Collapse":"8W5Oc","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2XASb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UncontrolledDropdown;
});
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    'defaultOpen'
];
var UncontrolledDropdown = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledDropdown, _Component);
    function UncontrolledDropdown(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledDropdown.prototype;
    _proto.toggle = function toggle(e) {
        var _this2 = this;
        var isOpen = !this.state.isOpen;
        this.setState({
            isOpen: isOpen
        }, function() {
            if (_this2.props.onToggle) _this2.props.onToggle(e, isOpen);
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledDropdown;
}((0, _react.Component));
UncontrolledDropdown.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool,
    onToggle: (0, _propTypesDefault.default).func
}, (0, _dropdownDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Dropdown":"9IyKZ","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Bhl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return UncontrolledTooltip;
});
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    'defaultOpen'
];
var UncontrolledTooltip = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledTooltip, _Component);
    function UncontrolledTooltip(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledTooltip.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledTooltip;
}((0, _react.Component));
UncontrolledTooltip.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool
}, (0, _tooltipDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Tooltip":"3Zg6S","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4sl4k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "type",
    "size",
    "color",
    "children",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    type: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).string,
    color: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: 'div',
    type: 'border',
    children: 'Loading...'
};
var Spinner = function Spinner(props) {
    var className = props.className, cssModule = props.cssModule, type = props.type, size = props.size, color = props.color, children = props.children, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, size ? "spinner-" + type + "-" + size : false, "spinner-" + type, color ? "text-" + color : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
        role: "status"
    }, attributes, {
        className: classes
    }), children && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _utils.mapToCssModules)('sr-only', cssModule)
    }, children));
};
Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
exports.default = Spinner;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","./utils":"ca6o0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lirjB":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
(function() {
    if ((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) !== 'object' || typeof window.CustomEvent === 'function') return;
    var CustomEvent = function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };
    window.CustomEvent = CustomEvent;
})();
(function() {
    if (typeof Object.values === 'function') return;
    var values = function values(O) {
        return Object.keys(O).map(function(key) {
            return O[key];
        });
    };
    Object.values = values;
})();

},{"@swc/helpers/_/_type_of":"668P4"}],"3xZWN":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var _typeOf = require("@swc/helpers/_/_type_of");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if ((0, _typeOf._)(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (_$format || !formatUpper) return _$format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if ((typeof units === "undefined" ? "undefined" : (0, _typeOf._)(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join('-'));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var _$locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = '+';
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = '-';
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - _$offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if ((typeof duration === "undefined" ? "undefined" : (0, _typeOf._)(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, 'days', true);
        return _$diff < -6 ? 'sameElse' : _$diff < -1 ? 'lastWeek' : _$diff < 0 ? 'lastDay' : _$diff < 1 ? 'sameDay' : _$diff < 2 ? 'nextDay' : _$diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), _$format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch((0, _typeOf._)(eras[i].since)){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch((0, _typeOf._)(eras[i].until)){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), _$weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            'w'
        ] || _$weeks < thresholds.w && [
            'ww',
            _$weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if ((typeof argWithSuffix === "undefined" ? "undefined" : (0, _typeOf._)(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if ((typeof argThresholds === "undefined" ? "undefined" : (0, _typeOf._)(argThresholds)) === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, _$locale);
        if (withSuffix) output = _$locale.pastFuture(+this, output);
        return _$locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{"@swc/helpers/_/_type_of":"668P4"}],"h7vq0":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
function _interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, _typeOf._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require("ae759875120ec061");
var React__default = _interopDefault(React);
var UAParser = require("68b7f5a2ac2b75b2");
var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();
var setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var isIOS13Check = function isIOS13Check(type) {
    var nav = getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
function _typeof(obj) {
    if (typeof Symbol === "function" && (0, _typeOf._)(Symbol.iterator) === "symbol") _typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
var DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Browser: undefined
};
var BrowserTypes = {
    Chrome: 'Chrome',
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: 'IE',
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
    IOS: 'iOS',
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: 'Windows',
    MAC_OS: 'Mac OS'
};
var initialData = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var checkType = function checkType(type) {
    switch(type){
        case DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case DeviceTypes.Console:
            return {
                isConsole: true
            };
        case DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        default:
            return initialData;
    }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: setDefaults(browser.major),
        browserFullVersion: setDefaults(browser.version),
        browserName: setDefaults(browser.name),
        engineName: setDefaults(engine.name),
        engineVersion: setDefaults(engine.version),
        osName: setDefaults(os.name),
        osVersion: setDefaults(os.version),
        userAgent: setDefaults(ua)
    };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
    return _objectSpread2({}, type, {
        vendor: setDefaults(device.vendor),
        model: setDefaults(device.model),
        os: setDefaults(os.name),
        osVersion: setDefaults(os.version),
        ua: setDefaults(ua)
    });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: setDefaults(engine.name),
        engineVersion: setDefaults(engine.version),
        osName: setDefaults(os.name),
        osVersion: setDefaults(os.version),
        userAgent: setDefaults(ua)
    };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: setDefaults(engine.name),
        engineVersion: setDefaults(engine.version),
        osName: setDefaults(os.name),
        osVersion: setDefaults(os.version),
        userAgent: setDefaults(ua)
    };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: setDefaults(engine.name),
        engineVersion: setDefaults(engine.version),
        osName: setDefaults(os.name),
        osVersion: setDefaults(os.version),
        userAgent: setDefaults(ua)
    };
};
var type = checkType(device.type);
function deviceDetect() {
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable;
    if (isBrowser) return broPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return stvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return consolePayload(isConsole, engine, os, ua);
    if (isMobile) return mobilePayload(type, device, os, ua);
    if (isTablet) return mobilePayload(type, device, os, ua);
    if (isWearable) return wearPayload(isWearable, engine, os, ua);
}
var isMobileType = function isMobileType() {
    return device.type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType() {
    return device.type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType() {
    switch(device.type){
        case DeviceTypes.Mobile:
        case DeviceTypes.Tablet:
            return true;
        default:
            return false;
    }
};
var isEdgeChromiumType = function isEdgeChromiumType() {
    return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var isSmartTVType = function isSmartTVType() {
    return device.type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType() {
    return device.type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType() {
    return device.type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType() {
    return device.type === DeviceTypes.Console;
};
var isAndroidType = function isAndroidType() {
    return os.name === OsTypes.Android;
};
var isWindowsType = function isWindowsType() {
    return os.name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType() {
    return os.name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType() {
    return os.name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType() {
    return os.name === OsTypes.IOS;
};
var isChromeType = function isChromeType() {
    return browser.name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType() {
    return browser.name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType() {
    return browser.name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType() {
    return browser.name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType() {
    return browser.name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType() {
    return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType() {
    return browser.name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType() {
    return browser.name === BrowserTypes.Opera;
};
var isIEType = function isIEType() {
    return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType() {
    return browser.name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType() {
    return browser.name === BrowserTypes.SamsungBrowser;
};
var isElectronType = function isElectronType() {
    var nav = getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var getIOS13 = function getIOS13() {
    var nav = getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
    return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
    return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
    return isIOS13Check('iPod');
};
var getBrowserFullVersion = function getBrowserFullVersion() {
    return setDefaults(browser.version);
};
var getBrowserVersion = function getBrowserVersion() {
    return setDefaults(browser.major);
};
var getOsVersion = function getOsVersion() {
    return setDefaults(os.version);
};
var getOsName = function getOsName() {
    return setDefaults(os.name);
};
var getBrowserName = function getBrowserName() {
    return setDefaults(browser.name);
};
var getMobileVendor = function getMobileVendor() {
    return setDefaults(device.vendor);
};
var getMobileModel = function getMobileModel() {
    return setDefaults(device.model);
};
var getEngineName = function getEngineName() {
    return setDefaults(engine.name);
};
var getEngineVersion = function getEngineVersion() {
    return setDefaults(engine.version);
};
var getUseragent = function getUseragent() {
    return setDefaults(ua);
};
var getDeviceType = function getDeviceType() {
    return setDefaults(device.type, 'browser');
};
var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();
var AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, viewClassName = _ref.viewClassName, style = _ref.style, props = _objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, viewClassName = _ref2.viewClassName, style = _ref2.style, props = _objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, viewClassName = _ref3.viewClassName, style = _ref3.style, props = _objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, viewClassName = _ref4.viewClassName, style = _ref4.style, props = _objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, viewClassName = _ref5.viewClassName, style = _ref5.style, props = _objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, viewClassName = _ref6.viewClassName, style = _ref6.style, props = _objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, viewClassName = _ref7.viewClassName, style = _ref7.style, props = _objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = _objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, viewClassName = _ref9.viewClassName, style = _ref9.style, props = _objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, viewClassName = _ref10.viewClassName, style = _ref10.style, props = _objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, viewClassName = _ref11.viewClassName, style = _ref11.style, props = _objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = _objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
        className: viewClassName,
        style: style
    }, props), children) : null;
};
function withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        _inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            _classCallCheck(this, _class);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        _createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return React__default.createElement(WrappedComponent, _extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }(React__default.Component);
}
exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;

},{"@swc/helpers/_/_type_of":"668P4","ae759875120ec061":"gVheC","68b7f5a2ac2b75b2":"1yEZs"}],"1yEZs":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/* UAParser.js v0.7.39
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined1) {
    "use strict";
    var LIBVERSION = "0.7.39", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, _typeOf._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, _typeOf._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, _typeOf._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, _typeOf._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if ((typeof q === "undefined" ? "undefined" : (0, _typeOf._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, _typeOf._)(q[1]) == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if ((0, _typeOf._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            if ((0, _typeOf._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360" + SUFFIX_BROWSER
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        tablet: [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, _typeOf._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, _typeOf._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && (0, _typeOf._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, _typeOf._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, _typeOf._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if ((typeof define === "undefined" ? "undefined" : (0, _typeOf._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, _typeOf._)(window1)) !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, _typeOf._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})((typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" ? window : undefined);

},{"@swc/helpers/_/_type_of":"668P4"}],"7YDxu":[function(require,module,exports,__globalThis) {
/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/ /*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// used for making the prop types of this component
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
// reactstrap components
var _reactstrap = require("reactstrap");
var Footer = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(Footer, _React_Component);
    function Footer() {
        (0, _classCallCheck._)(this, Footer);
        return (0, _callSuper._)(this, Footer, arguments);
    }
    (0, _createClass._)(Footer, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
                    className: "footer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Container), {
                        fluid: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Nav), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.NavItem), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.NavLink), {
                                        href: "https://connectria.com",
                                        target: "_blank",
                                        children: "Connectria"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "copyright",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " made with",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "tim-icons icon-heart-2"
                                    }),
                                    " by the",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "https://connectria.com",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        children: "Connectria Labs Team"
                                    }),
                                    " ",
                                    "for a better cloud."
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Footer;
}((0, _reactDefault.default).Component);
exports.default = Footer;

},{"@swc/helpers/_/_call_super":"j67W7","@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_inherits":"vo5zm","react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","reactstrap":"774RE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j67W7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _call_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _call_super(_this, derived, args) {
    // Super
    derived = (0, _getPrototypeOfJs._)(derived);
    return (0, _possibleConstructorReturnJs._)(_this, (0, _isNativeReflectConstructJs._)() ? Reflect.construct(derived, args || [], (0, _getPrototypeOfJs._)(_this).constructor) : derived.apply(_this, args));
}

},{"./_get_prototype_of.js":"6m8hr","./_is_native_reflect_construct.js":"6SvAq","./_possible_constructor_return.js":"5TUag","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6m8hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6SvAq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5TUag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"hNwTl","./_type_of.js":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNwTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"vo5zm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"d6k5B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d6k5B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"81K3c":[function(require,module,exports,__globalThis) {
/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/ /*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
// nodejs library to set properties for components
var _propTypes = require("prop-types");
var _lodashDebounce = require("lodash.debounce");
var _lodashDebounceDefault = parcelHelpers.interopDefault(_lodashDebounce);
var _ramda = require("ramda");
// javascript plugin used to create scrollbars on windows
var _perfectScrollbar = require("perfect-scrollbar");
var _perfectScrollbarDefault = parcelHelpers.interopDefault(_perfectScrollbar);
// reactstrap components
var _reactstrap = require("reactstrap");
var _logoutNavLink = require("../Logout/LogoutNavLink");
var _logoutNavLinkDefault = parcelHelpers.interopDefault(_logoutNavLink);
var _featureToggle = require("../../utility/FeatureToggle");
var _featureToggleDefault = parcelHelpers.interopDefault(_featureToggle);
var _enum = require("../../utility/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _organizationService = require("../../services/OrganizationService");
var _organizationServiceDefault = parcelHelpers.interopDefault(_organizationService);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _contactDashboard = require("../../components/Contact/ContactDashboard");
var _contactDashboardDefault = parcelHelpers.interopDefault(_contactDashboard);
var _clickstream = require("../Clickstream/Clickstream");
var _appState = require("../../AppState");
var ps;
var RouteLink = function(routeProps) {
    if (routeProps.redirect || routeProps.suppress) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleDefault.default), {
        policies: routeProps.policy || [],
        envs: routeProps.envs,
        clouds: routeProps.clouds,
        integrations: routeProps.integrations,
        children: routeProps.isExternal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
            className: "nav-link",
            href: routeProps.url,
            onClick: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                var clickedMeta;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!routeProps.clickstreamMeta) return [
                                3,
                                2
                            ];
                            clickedMeta = {
                                "event_id": "clicked",
                                "event_target": routeProps.clickstreamMeta.event_target,
                                "event_data": routeProps.clickstreamMeta.event_data
                            };
                            clickedMeta.event_data["source"] = "sidebar";
                            return [
                                4,
                                (0, _clickstream.ClickstreamPush)(routeProps.stateApp, clickedMeta)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            }),
            target: "_blank",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: routeProps.icon
                }),
                routeProps.name
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
            to: routeProps.layout + routeProps.path,
            className: "nav-link",
            activeClassName: "active",
            onClick: function() {
                // Reload the iframe so it goes back to the original legacy page
                if (routeProps.iframe) {
                    var iframe = document.getElementById('legacyFrame');
                    if (iframe) iframe.src = iframe.src;
                }
                routeProps.toggleSidebar();
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: routeProps.icon
                }),
                routeProps.name
            ]
        })
    });
};
var RouteGroup = function(routeProps) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleDefault.default), {
        policies: routeProps.policy || [],
        envs: routeProps.envs,
        clouds: routeProps.clouds,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
            style: {
                marginBottom: 0
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                    onClick: function(e) {
                        if (routeProps.visibleGroup === routeProps.group) routeProps.setVisibleGroup(null);
                        else routeProps.setVisibleGroup(routeProps.group);
                    },
                    className: "nav-group-card-header",
                    "data-event": routeProps.group,
                    "data-type": "collapseBanner",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group-header-title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                style: {
                                    marginRight: 4,
                                    marginLeft: 3
                                },
                                className: routeProps.visibleGroup === routeProps.group ? "fas fa-caret-up" : "fas fa-caret-down"
                            }),
                            " ",
                            routeProps.group
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Collapse), {
                    isOpen: routeProps.visibleGroup === routeProps.group,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            style: {
                                listStyle: "none",
                                padding: 0
                            },
                            className: "nav-group-ul",
                            children: routeProps.routes.map(function(r, k) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteLink, (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                                        activeRoute: routeProps.activeRoute,
                                        toggleSidebar: routeProps.toggleSidebar,
                                        stateApp: routeProps.stateApp
                                    }))
                                }, k);
                            })
                        })
                    })
                })
            ]
        }, routeProps.group)
    });
};
var Sidebar = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(), 2), visibleGroup = _useState[0], setVisibleGroup = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), orgDropdownVisible = _useState1[0], setOrgDropdownVisible = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), orgSearchKeyword = _useState2[0], setOrgSearchKeyword = _useState2[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var refSidebar = (0, _react.useRef)(null);
    var history = (0, _reactRouterDom.useHistory)();
    var filteredOrgs = (0, _react.useMemo)(function() {
        return orgSearchKeyword ? stateApp.organizations.filter(function(org) {
            return (org.name || '').toLowerCase().includes(orgSearchKeyword.toLowerCase());
        }) : stateApp.organizations;
    }, [
        orgSearchKeyword,
        stateApp.organizations
    ]);
    //console.log(stateApp.userInfo);
    // verifies if routeName is the one active (in browser input)
    var activeRoute = function(routeName) {
        return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };
    var toggleOrgDropdown = function() {
        return setOrgDropdownVisible(function(isOpen) {
            return !isOpen;
        });
    };
    var onChangeKeyword = (0, _lodashDebounceDefault.default)(setOrgSearchKeyword, 500);
    var switchOrg = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(org) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _organizationServiceDefault.default).switch_org({
                                payload: {
                                    organization_name: org
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        (0, _cookieServiceDefault.default).eraseCookie("show_skylift", "/");
                        props.toggleSidebar();
                        stateAppActions.setReload();
                        history.push('/');
                        stateAppActions.setCache({
                            key: "costSavings",
                            data: [],
                            loading: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function switchOrg(org) {
            return _ref.apply(this, arguments);
        };
    }();
    var externalToolsRouteGroup = {
        group: "External Tools",
        envs: [
            (0, _enumDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumDefault.default).CloudCategory.ALL
        ],
        routes: [
            {
                url: "https://www.mh.connectria.com",
                name: "Portal",
                envs: [
                    (0, _enumDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumDefault.default).CloudCategory.ALL
                ],
                icon: "fas fa-external-link-alt",
                isExternal: true,
                clickstreamMeta: {
                    "event_id": "clicked",
                    "event_target": "portal",
                    "event_data": {
                        "category": "tria",
                        "source": "sidebar"
                    }
                }
            }
        ].concat((0, _toConsumableArray._)(stateApp.portalCustomerMeta.tria_show_skylift_link === "TRUE" ? [
            {
                url: "https://apps.connectria.com",
                name: "Sky-Lift",
                envs: [
                    (0, _enumDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumDefault.default).CloudCategory.ALL
                ],
                icon: "fas fa-external-link-alt",
                isExternal: true,
                clickstreamMeta: {
                    "event_id": "clicked",
                    "event_target": "skylift",
                    "event_data": {
                        "category": "tria",
                        "source": "sidebar"
                    }
                }
            }
        ] : []))
    };
    var contactUsRoute = {
        path: "/contact",
        name: "Contact Us",
        envs: [
            (0, _enumDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: "fas fa-address-book",
        component: (0, _contactDashboardDefault.default),
        layout: "/app",
        clickstreamMeta: {
            "event_id": "visited",
            "event_target": "contact-us",
            "event_data": {
                "category": "tria"
            }
        }
    };
    var legacyRoute = {
        url: "https://dev.tria.connectria.com",
        name: "TRiA Legacy",
        envs: [
            (0, _enumDefault.default).Env.DEV
        ],
        clouds: [
            (0, _enumDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: "fas fa-external-link-alt",
        isExternal: true,
        clickstreamMeta: {
            "event_id": "clicked",
            "event_target": "tria-legacy",
            "event_data": {
                "category": "tria",
                "source": "sidebar"
            }
        }
    };
    var allRoutes = (0, _toConsumableArray._)(props.routes).concat([
        externalToolsRouteGroup,
        contactUsRoute,
        legacyRoute
    ]);
    var groupRoutes = allRoutes.filter(function(r) {
        return !!r.group;
    });
    var linkRoutes = allRoutes.slice(1).filter(function(r) {
        return !r.group;
    }); // leave home at the top
    var sortedRoutes = [
        allRoutes[0]
    ].concat((0, _toConsumableArray._)((0, _ramda.sort)((0, _ramda.ascend)((0, _ramda.prop)('group')), groupRoutes)), (0, _toConsumableArray._)((0, _ramda.sort)((0, _ramda.ascend)((0, _ramda.prop)('name')), linkRoutes)));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "sidebar",
        data: "primary",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "sidebar-wrapper",
            ref: refSidebar,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    stateApp.userInfo && (stateApp.userInfo.domain_admin || stateApp.userInfo.domain_viewer) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Dropdown), {
                        className: "org-dropdown",
                        isOpen: orgDropdownVisible,
                        toggle: toggleOrgDropdown,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                                tag: "div",
                                "data-toggle": "dropdown",
                                "aria-expanded": orgDropdownVisible,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "d-flex align-items-center px-3 py-2 text-white",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-user fa-2x mr-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-truncate mb-0",
                                                    children: stateApp.userInfo.name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "row",
                                                    style: {
                                                        paddingLeft: "6px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "text-truncate small",
                                                            children: stateApp.userInfo.organization_name
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                            className: "pl-1 fas fa-caret-" + (orgDropdownVisible ? 'up' : 'down')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                        header: true,
                                        children: "Switch Organization"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                        disabled: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                            placeholder: "Search Organization...",
                                            onChange: function(e) {
                                                return onChangeKeyword(e.target.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                        divider: true
                                    }),
                                    filteredOrgs.map(function(org) {
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                            onClick: stateApp.userInfo.organization_id !== org.organization_id ? function() {
                                                return switchOrg(org.name);
                                            } : function() {},
                                            children: stateApp.userInfo.organization_id === org.organization_id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: org.name
                                            }) : org.name
                                        }, org.organization_id);
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "   ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex align-items-center px-3 py-2 text-white",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-user fa-2x mr-2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-truncate mb-0",
                                                children: (stateApp.userInfo || {}).name || ''
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-truncate small",
                                                children: (stateApp.userInfo || {}).organization_name || ''
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    sortedRoutes.map(function(r, key) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                            children: r.group ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteGroup, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                activeRoute: activeRoute
                            }, r), {
                                toggleSidebar: props.toggleSidebar,
                                visibleGroup: visibleGroup,
                                setVisibleGroup: setVisibleGroup,
                                stateApp: stateApp
                            })) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteLink, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                activeRoute: activeRoute
                            }, r), {
                                toggleSidebar: props.toggleSidebar,
                                stateApp: stateApp
                            }))
                        }, key);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoutNavLinkDefault.default), {
                        toggleSidebar: props.toggleSidebar
                    })
                ]
            })
        })
    });
};
exports.default = Sidebar;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","prop-types":"3KNJy","lodash.debounce":"94oQ2","ramda":"2pVIv","perfect-scrollbar":"aZqyP","reactstrap":"774RE","../Logout/LogoutNavLink":"dP94b","../../utility/FeatureToggle":"2vty2","../../utility/enum":"3A9fW","../../services/OrganizationService":"e5ygN","../../services/CookieService":"iKLPT","../../components/Contact/ContactDashboard":"41c0t","../Clickstream/Clickstream":"9i4UV","../../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"94oQ2":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function now() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

},{"@swc/helpers/_/_type_of":"668P4"}],"2pVIv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "F", function() {
    return 0, _fJsDefault.default;
});
parcelHelpers.export(exports, "T", function() {
    return 0, _tJsDefault.default;
});
parcelHelpers.export(exports, "__", function() {
    return 0, _jsDefault.default;
});
parcelHelpers.export(exports, "add", function() {
    return 0, _addJsDefault.default;
});
parcelHelpers.export(exports, "addIndex", function() {
    return 0, _addIndexJsDefault.default;
});
parcelHelpers.export(exports, "adjust", function() {
    return 0, _adjustJsDefault.default;
});
parcelHelpers.export(exports, "all", function() {
    return 0, _allJsDefault.default;
});
parcelHelpers.export(exports, "allPass", function() {
    return 0, _allPassJsDefault.default;
});
parcelHelpers.export(exports, "always", function() {
    return 0, _alwaysJsDefault.default;
});
parcelHelpers.export(exports, "and", function() {
    return 0, _andJsDefault.default;
});
parcelHelpers.export(exports, "any", function() {
    return 0, _anyJsDefault.default;
});
parcelHelpers.export(exports, "anyPass", function() {
    return 0, _anyPassJsDefault.default;
});
parcelHelpers.export(exports, "ap", function() {
    return 0, _apJsDefault.default;
});
parcelHelpers.export(exports, "aperture", function() {
    return 0, _apertureJsDefault.default;
});
parcelHelpers.export(exports, "append", function() {
    return 0, _appendJsDefault.default;
});
parcelHelpers.export(exports, "apply", function() {
    return 0, _applyJsDefault.default;
});
parcelHelpers.export(exports, "applySpec", function() {
    return 0, _applySpecJsDefault.default;
});
parcelHelpers.export(exports, "applyTo", function() {
    return 0, _applyToJsDefault.default;
});
parcelHelpers.export(exports, "ascend", function() {
    return 0, _ascendJsDefault.default;
});
parcelHelpers.export(exports, "assoc", function() {
    return 0, _assocJsDefault.default;
});
parcelHelpers.export(exports, "assocPath", function() {
    return 0, _assocPathJsDefault.default;
});
parcelHelpers.export(exports, "binary", function() {
    return 0, _binaryJsDefault.default;
});
parcelHelpers.export(exports, "bind", function() {
    return 0, _bindJsDefault.default;
});
parcelHelpers.export(exports, "both", function() {
    return 0, _bothJsDefault.default;
});
parcelHelpers.export(exports, "call", function() {
    return 0, _callJsDefault.default;
});
parcelHelpers.export(exports, "chain", function() {
    return 0, _chainJsDefault.default;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _clampJsDefault.default;
});
parcelHelpers.export(exports, "clone", function() {
    return 0, _cloneJsDefault.default;
});
parcelHelpers.export(exports, "comparator", function() {
    return 0, _comparatorJsDefault.default;
});
parcelHelpers.export(exports, "complement", function() {
    return 0, _complementJsDefault.default;
});
parcelHelpers.export(exports, "compose", function() {
    return 0, _composeJsDefault.default;
});
parcelHelpers.export(exports, "composeK", function() {
    return 0, _composeKJsDefault.default;
});
parcelHelpers.export(exports, "composeP", function() {
    return 0, _composePJsDefault.default;
});
parcelHelpers.export(exports, "composeWith", function() {
    return 0, _composeWithJsDefault.default;
});
parcelHelpers.export(exports, "concat", function() {
    return 0, _concatJsDefault.default;
});
parcelHelpers.export(exports, "cond", function() {
    return 0, _condJsDefault.default;
});
parcelHelpers.export(exports, "construct", function() {
    return 0, _constructJsDefault.default;
});
parcelHelpers.export(exports, "constructN", function() {
    return 0, _constructNJsDefault.default;
});
parcelHelpers.export(exports, "contains", function() {
    return 0, _containsJsDefault.default;
});
parcelHelpers.export(exports, "converge", function() {
    return 0, _convergeJsDefault.default;
});
parcelHelpers.export(exports, "countBy", function() {
    return 0, _countByJsDefault.default;
});
parcelHelpers.export(exports, "curry", function() {
    return 0, _curryJsDefault.default;
});
parcelHelpers.export(exports, "curryN", function() {
    return 0, _curryNJsDefault.default;
});
parcelHelpers.export(exports, "dec", function() {
    return 0, _decJsDefault.default;
});
parcelHelpers.export(exports, "defaultTo", function() {
    return 0, _defaultToJsDefault.default;
});
parcelHelpers.export(exports, "descend", function() {
    return 0, _descendJsDefault.default;
});
parcelHelpers.export(exports, "difference", function() {
    return 0, _differenceJsDefault.default;
});
parcelHelpers.export(exports, "differenceWith", function() {
    return 0, _differenceWithJsDefault.default;
});
parcelHelpers.export(exports, "dissoc", function() {
    return 0, _dissocJsDefault.default;
});
parcelHelpers.export(exports, "dissocPath", function() {
    return 0, _dissocPathJsDefault.default;
});
parcelHelpers.export(exports, "divide", function() {
    return 0, _divideJsDefault.default;
});
parcelHelpers.export(exports, "drop", function() {
    return 0, _dropJsDefault.default;
});
parcelHelpers.export(exports, "dropLast", function() {
    return 0, _dropLastJsDefault.default;
});
parcelHelpers.export(exports, "dropLastWhile", function() {
    return 0, _dropLastWhileJsDefault.default;
});
parcelHelpers.export(exports, "dropRepeats", function() {
    return 0, _dropRepeatsJsDefault.default;
});
parcelHelpers.export(exports, "dropRepeatsWith", function() {
    return 0, _dropRepeatsWithJsDefault.default;
});
parcelHelpers.export(exports, "dropWhile", function() {
    return 0, _dropWhileJsDefault.default;
});
parcelHelpers.export(exports, "either", function() {
    return 0, _eitherJsDefault.default;
});
parcelHelpers.export(exports, "empty", function() {
    return 0, _emptyJsDefault.default;
});
parcelHelpers.export(exports, "endsWith", function() {
    return 0, _endsWithJsDefault.default;
});
parcelHelpers.export(exports, "eqBy", function() {
    return 0, _eqByJsDefault.default;
});
parcelHelpers.export(exports, "eqProps", function() {
    return 0, _eqPropsJsDefault.default;
});
parcelHelpers.export(exports, "equals", function() {
    return 0, _equalsJsDefault.default;
});
parcelHelpers.export(exports, "evolve", function() {
    return 0, _evolveJsDefault.default;
});
parcelHelpers.export(exports, "filter", function() {
    return 0, _filterJsDefault.default;
});
parcelHelpers.export(exports, "find", function() {
    return 0, _findJsDefault.default;
});
parcelHelpers.export(exports, "findIndex", function() {
    return 0, _findIndexJsDefault.default;
});
parcelHelpers.export(exports, "findLast", function() {
    return 0, _findLastJsDefault.default;
});
parcelHelpers.export(exports, "findLastIndex", function() {
    return 0, _findLastIndexJsDefault.default;
});
parcelHelpers.export(exports, "flatten", function() {
    return 0, _flattenJsDefault.default;
});
parcelHelpers.export(exports, "flip", function() {
    return 0, _flipJsDefault.default;
});
parcelHelpers.export(exports, "forEach", function() {
    return 0, _forEachJsDefault.default;
});
parcelHelpers.export(exports, "forEachObjIndexed", function() {
    return 0, _forEachObjIndexedJsDefault.default;
});
parcelHelpers.export(exports, "fromPairs", function() {
    return 0, _fromPairsJsDefault.default;
});
parcelHelpers.export(exports, "groupBy", function() {
    return 0, _groupByJsDefault.default;
});
parcelHelpers.export(exports, "groupWith", function() {
    return 0, _groupWithJsDefault.default;
});
parcelHelpers.export(exports, "gt", function() {
    return 0, _gtJsDefault.default;
});
parcelHelpers.export(exports, "gte", function() {
    return 0, _gteJsDefault.default;
});
parcelHelpers.export(exports, "has", function() {
    return 0, _hasJsDefault.default;
});
parcelHelpers.export(exports, "hasIn", function() {
    return 0, _hasInJsDefault.default;
});
parcelHelpers.export(exports, "hasPath", function() {
    return 0, _hasPathJsDefault.default;
});
parcelHelpers.export(exports, "head", function() {
    return 0, _headJsDefault.default;
});
parcelHelpers.export(exports, "identical", function() {
    return 0, _identicalJsDefault.default;
});
parcelHelpers.export(exports, "identity", function() {
    return 0, _identityJsDefault.default;
});
parcelHelpers.export(exports, "ifElse", function() {
    return 0, _ifElseJsDefault.default;
});
parcelHelpers.export(exports, "inc", function() {
    return 0, _incJsDefault.default;
});
parcelHelpers.export(exports, "includes", function() {
    return 0, _includesJsDefault.default;
});
parcelHelpers.export(exports, "indexBy", function() {
    return 0, _indexByJsDefault.default;
});
parcelHelpers.export(exports, "indexOf", function() {
    return 0, _indexOfJsDefault.default;
});
parcelHelpers.export(exports, "init", function() {
    return 0, _initJsDefault.default;
});
parcelHelpers.export(exports, "innerJoin", function() {
    return 0, _innerJoinJsDefault.default;
});
parcelHelpers.export(exports, "insert", function() {
    return 0, _insertJsDefault.default;
});
parcelHelpers.export(exports, "insertAll", function() {
    return 0, _insertAllJsDefault.default;
});
parcelHelpers.export(exports, "intersection", function() {
    return 0, _intersectionJsDefault.default;
});
parcelHelpers.export(exports, "intersperse", function() {
    return 0, _intersperseJsDefault.default;
});
parcelHelpers.export(exports, "into", function() {
    return 0, _intoJsDefault.default;
});
parcelHelpers.export(exports, "invert", function() {
    return 0, _invertJsDefault.default;
});
parcelHelpers.export(exports, "invertObj", function() {
    return 0, _invertObjJsDefault.default;
});
parcelHelpers.export(exports, "invoker", function() {
    return 0, _invokerJsDefault.default;
});
parcelHelpers.export(exports, "is", function() {
    return 0, _isJsDefault.default;
});
parcelHelpers.export(exports, "isEmpty", function() {
    return 0, _isEmptyJsDefault.default;
});
parcelHelpers.export(exports, "isNil", function() {
    return 0, _isNilJsDefault.default;
});
parcelHelpers.export(exports, "join", function() {
    return 0, _joinJsDefault.default;
});
parcelHelpers.export(exports, "juxt", function() {
    return 0, _juxtJsDefault.default;
});
parcelHelpers.export(exports, "keys", function() {
    return 0, _keysJsDefault.default;
});
parcelHelpers.export(exports, "keysIn", function() {
    return 0, _keysInJsDefault.default;
});
parcelHelpers.export(exports, "last", function() {
    return 0, _lastJsDefault.default;
});
parcelHelpers.export(exports, "lastIndexOf", function() {
    return 0, _lastIndexOfJsDefault.default;
});
parcelHelpers.export(exports, "length", function() {
    return 0, _lengthJsDefault.default;
});
parcelHelpers.export(exports, "lens", function() {
    return 0, _lensJsDefault.default;
});
parcelHelpers.export(exports, "lensIndex", function() {
    return 0, _lensIndexJsDefault.default;
});
parcelHelpers.export(exports, "lensPath", function() {
    return 0, _lensPathJsDefault.default;
});
parcelHelpers.export(exports, "lensProp", function() {
    return 0, _lensPropJsDefault.default;
});
parcelHelpers.export(exports, "lift", function() {
    return 0, _liftJsDefault.default;
});
parcelHelpers.export(exports, "liftN", function() {
    return 0, _liftNJsDefault.default;
});
parcelHelpers.export(exports, "lt", function() {
    return 0, _ltJsDefault.default;
});
parcelHelpers.export(exports, "lte", function() {
    return 0, _lteJsDefault.default;
});
parcelHelpers.export(exports, "map", function() {
    return 0, _mapJsDefault.default;
});
parcelHelpers.export(exports, "mapAccum", function() {
    return 0, _mapAccumJsDefault.default;
});
parcelHelpers.export(exports, "mapAccumRight", function() {
    return 0, _mapAccumRightJsDefault.default;
});
parcelHelpers.export(exports, "mapObjIndexed", function() {
    return 0, _mapObjIndexedJsDefault.default;
});
parcelHelpers.export(exports, "match", function() {
    return 0, _matchJsDefault.default;
});
parcelHelpers.export(exports, "mathMod", function() {
    return 0, _mathModJsDefault.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _maxJsDefault.default;
});
parcelHelpers.export(exports, "maxBy", function() {
    return 0, _maxByJsDefault.default;
});
parcelHelpers.export(exports, "mean", function() {
    return 0, _meanJsDefault.default;
});
parcelHelpers.export(exports, "median", function() {
    return 0, _medianJsDefault.default;
});
parcelHelpers.export(exports, "memoizeWith", function() {
    return 0, _memoizeWithJsDefault.default;
});
parcelHelpers.export(exports, "merge", function() {
    return 0, _mergeJsDefault.default;
});
parcelHelpers.export(exports, "mergeAll", function() {
    return 0, _mergeAllJsDefault.default;
});
parcelHelpers.export(exports, "mergeDeepLeft", function() {
    return 0, _mergeDeepLeftJsDefault.default;
});
parcelHelpers.export(exports, "mergeDeepRight", function() {
    return 0, _mergeDeepRightJsDefault.default;
});
parcelHelpers.export(exports, "mergeDeepWith", function() {
    return 0, _mergeDeepWithJsDefault.default;
});
parcelHelpers.export(exports, "mergeDeepWithKey", function() {
    return 0, _mergeDeepWithKeyJsDefault.default;
});
parcelHelpers.export(exports, "mergeLeft", function() {
    return 0, _mergeLeftJsDefault.default;
});
parcelHelpers.export(exports, "mergeRight", function() {
    return 0, _mergeRightJsDefault.default;
});
parcelHelpers.export(exports, "mergeWith", function() {
    return 0, _mergeWithJsDefault.default;
});
parcelHelpers.export(exports, "mergeWithKey", function() {
    return 0, _mergeWithKeyJsDefault.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _minJsDefault.default;
});
parcelHelpers.export(exports, "minBy", function() {
    return 0, _minByJsDefault.default;
});
parcelHelpers.export(exports, "modulo", function() {
    return 0, _moduloJsDefault.default;
});
parcelHelpers.export(exports, "move", function() {
    return 0, _moveJsDefault.default;
});
parcelHelpers.export(exports, "multiply", function() {
    return 0, _multiplyJsDefault.default;
});
parcelHelpers.export(exports, "nAry", function() {
    return 0, _nAryJsDefault.default;
});
parcelHelpers.export(exports, "negate", function() {
    return 0, _negateJsDefault.default;
});
parcelHelpers.export(exports, "none", function() {
    return 0, _noneJsDefault.default;
});
parcelHelpers.export(exports, "not", function() {
    return 0, _notJsDefault.default;
});
parcelHelpers.export(exports, "nth", function() {
    return 0, _nthJsDefault.default;
});
parcelHelpers.export(exports, "nthArg", function() {
    return 0, _nthArgJsDefault.default;
});
parcelHelpers.export(exports, "o", function() {
    return 0, _oJsDefault.default;
});
parcelHelpers.export(exports, "objOf", function() {
    return 0, _objOfJsDefault.default;
});
parcelHelpers.export(exports, "of", function() {
    return 0, _ofJsDefault.default;
});
parcelHelpers.export(exports, "omit", function() {
    return 0, _omitJsDefault.default;
});
parcelHelpers.export(exports, "once", function() {
    return 0, _onceJsDefault.default;
});
parcelHelpers.export(exports, "or", function() {
    return 0, _orJsDefault.default;
});
parcelHelpers.export(exports, "otherwise", function() {
    return 0, _otherwiseJsDefault.default;
});
parcelHelpers.export(exports, "over", function() {
    return 0, _overJsDefault.default;
});
parcelHelpers.export(exports, "pair", function() {
    return 0, _pairJsDefault.default;
});
parcelHelpers.export(exports, "partial", function() {
    return 0, _partialJsDefault.default;
});
parcelHelpers.export(exports, "partialRight", function() {
    return 0, _partialRightJsDefault.default;
});
parcelHelpers.export(exports, "partition", function() {
    return 0, _partitionJsDefault.default;
});
parcelHelpers.export(exports, "path", function() {
    return 0, _pathJsDefault.default;
});
parcelHelpers.export(exports, "paths", function() {
    return 0, _pathsJsDefault.default;
});
parcelHelpers.export(exports, "pathEq", function() {
    return 0, _pathEqJsDefault.default;
});
parcelHelpers.export(exports, "pathOr", function() {
    return 0, _pathOrJsDefault.default;
});
parcelHelpers.export(exports, "pathSatisfies", function() {
    return 0, _pathSatisfiesJsDefault.default;
});
parcelHelpers.export(exports, "pick", function() {
    return 0, _pickJsDefault.default;
});
parcelHelpers.export(exports, "pickAll", function() {
    return 0, _pickAllJsDefault.default;
});
parcelHelpers.export(exports, "pickBy", function() {
    return 0, _pickByJsDefault.default;
});
parcelHelpers.export(exports, "pipe", function() {
    return 0, _pipeJsDefault.default;
});
parcelHelpers.export(exports, "pipeK", function() {
    return 0, _pipeKJsDefault.default;
});
parcelHelpers.export(exports, "pipeP", function() {
    return 0, _pipePJsDefault.default;
});
parcelHelpers.export(exports, "pipeWith", function() {
    return 0, _pipeWithJsDefault.default;
});
parcelHelpers.export(exports, "pluck", function() {
    return 0, _pluckJsDefault.default;
});
parcelHelpers.export(exports, "prepend", function() {
    return 0, _prependJsDefault.default;
});
parcelHelpers.export(exports, "product", function() {
    return 0, _productJsDefault.default;
});
parcelHelpers.export(exports, "project", function() {
    return 0, _projectJsDefault.default;
});
parcelHelpers.export(exports, "prop", function() {
    return 0, _propJsDefault.default;
});
parcelHelpers.export(exports, "propEq", function() {
    return 0, _propEqJsDefault.default;
});
parcelHelpers.export(exports, "propIs", function() {
    return 0, _propIsJsDefault.default;
});
parcelHelpers.export(exports, "propOr", function() {
    return 0, _propOrJsDefault.default;
});
parcelHelpers.export(exports, "propSatisfies", function() {
    return 0, _propSatisfiesJsDefault.default;
});
parcelHelpers.export(exports, "props", function() {
    return 0, _propsJsDefault.default;
});
parcelHelpers.export(exports, "range", function() {
    return 0, _rangeJsDefault.default;
});
parcelHelpers.export(exports, "reduce", function() {
    return 0, _reduceJsDefault.default;
});
parcelHelpers.export(exports, "reduceBy", function() {
    return 0, _reduceByJsDefault.default;
});
parcelHelpers.export(exports, "reduceRight", function() {
    return 0, _reduceRightJsDefault.default;
});
parcelHelpers.export(exports, "reduceWhile", function() {
    return 0, _reduceWhileJsDefault.default;
});
parcelHelpers.export(exports, "reduced", function() {
    return 0, _reducedJsDefault.default;
});
parcelHelpers.export(exports, "reject", function() {
    return 0, _rejectJsDefault.default;
});
parcelHelpers.export(exports, "remove", function() {
    return 0, _removeJsDefault.default;
});
parcelHelpers.export(exports, "repeat", function() {
    return 0, _repeatJsDefault.default;
});
parcelHelpers.export(exports, "replace", function() {
    return 0, _replaceJsDefault.default;
});
parcelHelpers.export(exports, "reverse", function() {
    return 0, _reverseJsDefault.default;
});
parcelHelpers.export(exports, "scan", function() {
    return 0, _scanJsDefault.default;
});
parcelHelpers.export(exports, "sequence", function() {
    return 0, _sequenceJsDefault.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _setJsDefault.default;
});
parcelHelpers.export(exports, "slice", function() {
    return 0, _sliceJsDefault.default;
});
parcelHelpers.export(exports, "sort", function() {
    return 0, _sortJsDefault.default;
});
parcelHelpers.export(exports, "sortBy", function() {
    return 0, _sortByJsDefault.default;
});
parcelHelpers.export(exports, "sortWith", function() {
    return 0, _sortWithJsDefault.default;
});
parcelHelpers.export(exports, "split", function() {
    return 0, _splitJsDefault.default;
});
parcelHelpers.export(exports, "splitAt", function() {
    return 0, _splitAtJsDefault.default;
});
parcelHelpers.export(exports, "splitEvery", function() {
    return 0, _splitEveryJsDefault.default;
});
parcelHelpers.export(exports, "splitWhen", function() {
    return 0, _splitWhenJsDefault.default;
});
parcelHelpers.export(exports, "startsWith", function() {
    return 0, _startsWithJsDefault.default;
});
parcelHelpers.export(exports, "subtract", function() {
    return 0, _subtractJsDefault.default;
});
parcelHelpers.export(exports, "sum", function() {
    return 0, _sumJsDefault.default;
});
parcelHelpers.export(exports, "symmetricDifference", function() {
    return 0, _symmetricDifferenceJsDefault.default;
});
parcelHelpers.export(exports, "symmetricDifferenceWith", function() {
    return 0, _symmetricDifferenceWithJsDefault.default;
});
parcelHelpers.export(exports, "tail", function() {
    return 0, _tailJsDefault.default;
});
parcelHelpers.export(exports, "take", function() {
    return 0, _takeJsDefault.default;
});
parcelHelpers.export(exports, "takeLast", function() {
    return 0, _takeLastJsDefault.default;
});
parcelHelpers.export(exports, "takeLastWhile", function() {
    return 0, _takeLastWhileJsDefault.default;
});
parcelHelpers.export(exports, "takeWhile", function() {
    return 0, _takeWhileJsDefault.default;
});
parcelHelpers.export(exports, "tap", function() {
    return 0, _tapJsDefault.default;
});
parcelHelpers.export(exports, "test", function() {
    return 0, _testJsDefault.default;
});
parcelHelpers.export(exports, "andThen", function() {
    return 0, _andThenJsDefault.default;
});
parcelHelpers.export(exports, "times", function() {
    return 0, _timesJsDefault.default;
});
parcelHelpers.export(exports, "toLower", function() {
    return 0, _toLowerJsDefault.default;
});
parcelHelpers.export(exports, "toPairs", function() {
    return 0, _toPairsJsDefault.default;
});
parcelHelpers.export(exports, "toPairsIn", function() {
    return 0, _toPairsInJsDefault.default;
});
parcelHelpers.export(exports, "toString", function() {
    return 0, _toStringJsDefault.default;
});
parcelHelpers.export(exports, "toUpper", function() {
    return 0, _toUpperJsDefault.default;
});
parcelHelpers.export(exports, "transduce", function() {
    return 0, _transduceJsDefault.default;
});
parcelHelpers.export(exports, "transpose", function() {
    return 0, _transposeJsDefault.default;
});
parcelHelpers.export(exports, "traverse", function() {
    return 0, _traverseJsDefault.default;
});
parcelHelpers.export(exports, "trim", function() {
    return 0, _trimJsDefault.default;
});
parcelHelpers.export(exports, "tryCatch", function() {
    return 0, _tryCatchJsDefault.default;
});
parcelHelpers.export(exports, "type", function() {
    return 0, _typeJsDefault.default;
});
parcelHelpers.export(exports, "unapply", function() {
    return 0, _unapplyJsDefault.default;
});
parcelHelpers.export(exports, "unary", function() {
    return 0, _unaryJsDefault.default;
});
parcelHelpers.export(exports, "uncurryN", function() {
    return 0, _uncurryNJsDefault.default;
});
parcelHelpers.export(exports, "unfold", function() {
    return 0, _unfoldJsDefault.default;
});
parcelHelpers.export(exports, "union", function() {
    return 0, _unionJsDefault.default;
});
parcelHelpers.export(exports, "unionWith", function() {
    return 0, _unionWithJsDefault.default;
});
parcelHelpers.export(exports, "uniq", function() {
    return 0, _uniqJsDefault.default;
});
parcelHelpers.export(exports, "uniqBy", function() {
    return 0, _uniqByJsDefault.default;
});
parcelHelpers.export(exports, "uniqWith", function() {
    return 0, _uniqWithJsDefault.default;
});
parcelHelpers.export(exports, "unless", function() {
    return 0, _unlessJsDefault.default;
});
parcelHelpers.export(exports, "unnest", function() {
    return 0, _unnestJsDefault.default;
});
parcelHelpers.export(exports, "until", function() {
    return 0, _untilJsDefault.default;
});
parcelHelpers.export(exports, "update", function() {
    return 0, _updateJsDefault.default;
});
parcelHelpers.export(exports, "useWith", function() {
    return 0, _useWithJsDefault.default;
});
parcelHelpers.export(exports, "values", function() {
    return 0, _valuesJsDefault.default;
});
parcelHelpers.export(exports, "valuesIn", function() {
    return 0, _valuesInJsDefault.default;
});
parcelHelpers.export(exports, "view", function() {
    return 0, _viewJsDefault.default;
});
parcelHelpers.export(exports, "when", function() {
    return 0, _whenJsDefault.default;
});
parcelHelpers.export(exports, "where", function() {
    return 0, _whereJsDefault.default;
});
parcelHelpers.export(exports, "whereEq", function() {
    return 0, _whereEqJsDefault.default;
});
parcelHelpers.export(exports, "without", function() {
    return 0, _withoutJsDefault.default;
});
parcelHelpers.export(exports, "xor", function() {
    return 0, _xorJsDefault.default;
});
parcelHelpers.export(exports, "xprod", function() {
    return 0, _xprodJsDefault.default;
});
parcelHelpers.export(exports, "zip", function() {
    return 0, _zipJsDefault.default;
});
parcelHelpers.export(exports, "zipObj", function() {
    return 0, _zipObjJsDefault.default;
});
parcelHelpers.export(exports, "zipWith", function() {
    return 0, _zipWithJsDefault.default;
});
parcelHelpers.export(exports, "thunkify", function() {
    return 0, _thunkifyJsDefault.default;
});
var _fJs = require("./F.js");
var _fJsDefault = parcelHelpers.interopDefault(_fJs);
var _tJs = require("./T.js");
var _tJsDefault = parcelHelpers.interopDefault(_tJs);
var _js = require("./__.js");
var _jsDefault = parcelHelpers.interopDefault(_js);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _addIndexJs = require("./addIndex.js");
var _addIndexJsDefault = parcelHelpers.interopDefault(_addIndexJs);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
var _allPassJs = require("./allPass.js");
var _allPassJsDefault = parcelHelpers.interopDefault(_allPassJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _anyJs = require("./any.js");
var _anyJsDefault = parcelHelpers.interopDefault(_anyJs);
var _anyPassJs = require("./anyPass.js");
var _anyPassJsDefault = parcelHelpers.interopDefault(_anyPassJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _apertureJs = require("./aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _applySpecJs = require("./applySpec.js");
var _applySpecJsDefault = parcelHelpers.interopDefault(_applySpecJs);
var _applyToJs = require("./applyTo.js");
var _applyToJsDefault = parcelHelpers.interopDefault(_applyToJs);
var _ascendJs = require("./ascend.js");
var _ascendJsDefault = parcelHelpers.interopDefault(_ascendJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _binaryJs = require("./binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _bindJs = require("./bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _bothJs = require("./both.js");
var _bothJsDefault = parcelHelpers.interopDefault(_bothJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _clampJs = require("./clamp.js");
var _clampJsDefault = parcelHelpers.interopDefault(_clampJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _comparatorJs = require("./comparator.js");
var _comparatorJsDefault = parcelHelpers.interopDefault(_comparatorJs);
var _complementJs = require("./complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _composePJs = require("./composeP.js");
var _composePJsDefault = parcelHelpers.interopDefault(_composePJs);
var _composeWithJs = require("./composeWith.js");
var _composeWithJsDefault = parcelHelpers.interopDefault(_composeWithJs);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _condJs = require("./cond.js");
var _condJsDefault = parcelHelpers.interopDefault(_condJs);
var _constructJs = require("./construct.js");
var _constructJsDefault = parcelHelpers.interopDefault(_constructJs);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
var _countByJs = require("./countBy.js");
var _countByJsDefault = parcelHelpers.interopDefault(_countByJs);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _decJs = require("./dec.js");
var _decJsDefault = parcelHelpers.interopDefault(_decJs);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _descendJs = require("./descend.js");
var _descendJsDefault = parcelHelpers.interopDefault(_descendJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _dissocPathJs = require("./dissocPath.js");
var _dissocPathJsDefault = parcelHelpers.interopDefault(_dissocPathJs);
var _divideJs = require("./divide.js");
var _divideJsDefault = parcelHelpers.interopDefault(_divideJs);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
var _dropLastJs = require("./dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _dropLastWhileJs = require("./dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _dropRepeatsJs = require("./dropRepeats.js");
var _dropRepeatsJsDefault = parcelHelpers.interopDefault(_dropRepeatsJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _dropWhileJs = require("./dropWhile.js");
var _dropWhileJsDefault = parcelHelpers.interopDefault(_dropWhileJs);
var _eitherJs = require("./either.js");
var _eitherJsDefault = parcelHelpers.interopDefault(_eitherJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _endsWithJs = require("./endsWith.js");
var _endsWithJsDefault = parcelHelpers.interopDefault(_endsWithJs);
var _eqByJs = require("./eqBy.js");
var _eqByJsDefault = parcelHelpers.interopDefault(_eqByJs);
var _eqPropsJs = require("./eqProps.js");
var _eqPropsJsDefault = parcelHelpers.interopDefault(_eqPropsJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _evolveJs = require("./evolve.js");
var _evolveJsDefault = parcelHelpers.interopDefault(_evolveJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _findIndexJs = require("./findIndex.js");
var _findIndexJsDefault = parcelHelpers.interopDefault(_findIndexJs);
var _findLastJs = require("./findLast.js");
var _findLastJsDefault = parcelHelpers.interopDefault(_findLastJs);
var _findLastIndexJs = require("./findLastIndex.js");
var _findLastIndexJsDefault = parcelHelpers.interopDefault(_findLastIndexJs);
var _flattenJs = require("./flatten.js");
var _flattenJsDefault = parcelHelpers.interopDefault(_flattenJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);
var _forEachObjIndexedJs = require("./forEachObjIndexed.js");
var _forEachObjIndexedJsDefault = parcelHelpers.interopDefault(_forEachObjIndexedJs);
var _fromPairsJs = require("./fromPairs.js");
var _fromPairsJsDefault = parcelHelpers.interopDefault(_fromPairsJs);
var _groupByJs = require("./groupBy.js");
var _groupByJsDefault = parcelHelpers.interopDefault(_groupByJs);
var _groupWithJs = require("./groupWith.js");
var _groupWithJsDefault = parcelHelpers.interopDefault(_groupWithJs);
var _gtJs = require("./gt.js");
var _gtJsDefault = parcelHelpers.interopDefault(_gtJs);
var _gteJs = require("./gte.js");
var _gteJsDefault = parcelHelpers.interopDefault(_gteJs);
var _hasJs = require("./has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _identicalJs = require("./identical.js");
var _identicalJsDefault = parcelHelpers.interopDefault(_identicalJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _ifElseJs = require("./ifElse.js");
var _ifElseJsDefault = parcelHelpers.interopDefault(_ifElseJs);
var _incJs = require("./inc.js");
var _incJsDefault = parcelHelpers.interopDefault(_incJs);
var _includesJs = require("./includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _indexByJs = require("./indexBy.js");
var _indexByJsDefault = parcelHelpers.interopDefault(_indexByJs);
var _indexOfJs = require("./indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _initJs = require("./init.js");
var _initJsDefault = parcelHelpers.interopDefault(_initJs);
var _innerJoinJs = require("./innerJoin.js");
var _innerJoinJsDefault = parcelHelpers.interopDefault(_innerJoinJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _insertAllJs = require("./insertAll.js");
var _insertAllJsDefault = parcelHelpers.interopDefault(_insertAllJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _intersperseJs = require("./intersperse.js");
var _intersperseJsDefault = parcelHelpers.interopDefault(_intersperseJs);
var _intoJs = require("./into.js");
var _intoJsDefault = parcelHelpers.interopDefault(_intoJs);
var _invertJs = require("./invert.js");
var _invertJsDefault = parcelHelpers.interopDefault(_invertJs);
var _invertObjJs = require("./invertObj.js");
var _invertObjJsDefault = parcelHelpers.interopDefault(_invertObjJs);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
var _isEmptyJs = require("./isEmpty.js");
var _isEmptyJsDefault = parcelHelpers.interopDefault(_isEmptyJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
var _lastIndexOfJs = require("./lastIndexOf.js");
var _lastIndexOfJsDefault = parcelHelpers.interopDefault(_lastIndexOfJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _lensIndexJs = require("./lensIndex.js");
var _lensIndexJsDefault = parcelHelpers.interopDefault(_lensIndexJs);
var _lensPathJs = require("./lensPath.js");
var _lensPathJsDefault = parcelHelpers.interopDefault(_lensPathJs);
var _lensPropJs = require("./lensProp.js");
var _lensPropJsDefault = parcelHelpers.interopDefault(_lensPropJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
var _ltJs = require("./lt.js");
var _ltJsDefault = parcelHelpers.interopDefault(_ltJs);
var _lteJs = require("./lte.js");
var _lteJsDefault = parcelHelpers.interopDefault(_lteJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapAccumJs = require("./mapAccum.js");
var _mapAccumJsDefault = parcelHelpers.interopDefault(_mapAccumJs);
var _mapAccumRightJs = require("./mapAccumRight.js");
var _mapAccumRightJsDefault = parcelHelpers.interopDefault(_mapAccumRightJs);
var _mapObjIndexedJs = require("./mapObjIndexed.js");
var _mapObjIndexedJsDefault = parcelHelpers.interopDefault(_mapObjIndexedJs);
var _matchJs = require("./match.js");
var _matchJsDefault = parcelHelpers.interopDefault(_matchJs);
var _mathModJs = require("./mathMod.js");
var _mathModJsDefault = parcelHelpers.interopDefault(_mathModJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxByJs = require("./maxBy.js");
var _maxByJsDefault = parcelHelpers.interopDefault(_maxByJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _memoizeWithJs = require("./memoizeWith.js");
var _memoizeWithJsDefault = parcelHelpers.interopDefault(_memoizeWithJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _mergeAllJs = require("./mergeAll.js");
var _mergeAllJsDefault = parcelHelpers.interopDefault(_mergeAllJs);
var _mergeDeepLeftJs = require("./mergeDeepLeft.js");
var _mergeDeepLeftJsDefault = parcelHelpers.interopDefault(_mergeDeepLeftJs);
var _mergeDeepRightJs = require("./mergeDeepRight.js");
var _mergeDeepRightJsDefault = parcelHelpers.interopDefault(_mergeDeepRightJs);
var _mergeDeepWithJs = require("./mergeDeepWith.js");
var _mergeDeepWithJsDefault = parcelHelpers.interopDefault(_mergeDeepWithJs);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
var _mergeLeftJs = require("./mergeLeft.js");
var _mergeLeftJsDefault = parcelHelpers.interopDefault(_mergeLeftJs);
var _mergeRightJs = require("./mergeRight.js");
var _mergeRightJsDefault = parcelHelpers.interopDefault(_mergeRightJs);
var _mergeWithJs = require("./mergeWith.js");
var _mergeWithJsDefault = parcelHelpers.interopDefault(_mergeWithJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minByJs = require("./minBy.js");
var _minByJsDefault = parcelHelpers.interopDefault(_minByJs);
var _moduloJs = require("./modulo.js");
var _moduloJsDefault = parcelHelpers.interopDefault(_moduloJs);
var _moveJs = require("./move.js");
var _moveJsDefault = parcelHelpers.interopDefault(_moveJs);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
var _negateJs = require("./negate.js");
var _negateJsDefault = parcelHelpers.interopDefault(_negateJs);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _nthArgJs = require("./nthArg.js");
var _nthArgJsDefault = parcelHelpers.interopDefault(_nthArgJs);
var _oJs = require("./o.js");
var _oJsDefault = parcelHelpers.interopDefault(_oJs);
var _objOfJs = require("./objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _ofJs = require("./of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
var _omitJs = require("./omit.js");
var _omitJsDefault = parcelHelpers.interopDefault(_omitJs);
var _onceJs = require("./once.js");
var _onceJsDefault = parcelHelpers.interopDefault(_onceJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
var _otherwiseJs = require("./otherwise.js");
var _otherwiseJsDefault = parcelHelpers.interopDefault(_otherwiseJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
var _pairJs = require("./pair.js");
var _pairJsDefault = parcelHelpers.interopDefault(_pairJs);
var _partialJs = require("./partial.js");
var _partialJsDefault = parcelHelpers.interopDefault(_partialJs);
var _partialRightJs = require("./partialRight.js");
var _partialRightJsDefault = parcelHelpers.interopDefault(_partialRightJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _pathsJs = require("./paths.js");
var _pathsJsDefault = parcelHelpers.interopDefault(_pathsJs);
var _pathEqJs = require("./pathEq.js");
var _pathEqJsDefault = parcelHelpers.interopDefault(_pathEqJs);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
var _pathSatisfiesJs = require("./pathSatisfies.js");
var _pathSatisfiesJsDefault = parcelHelpers.interopDefault(_pathSatisfiesJs);
var _pickJs = require("./pick.js");
var _pickJsDefault = parcelHelpers.interopDefault(_pickJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _pickByJs = require("./pickBy.js");
var _pickByJsDefault = parcelHelpers.interopDefault(_pickByJs);
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _pipeKJs = require("./pipeK.js");
var _pipeKJsDefault = parcelHelpers.interopDefault(_pipeKJs);
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _productJs = require("./product.js");
var _productJsDefault = parcelHelpers.interopDefault(_productJs);
var _projectJs = require("./project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
var _propEqJs = require("./propEq.js");
var _propEqJsDefault = parcelHelpers.interopDefault(_propEqJs);
var _propIsJs = require("./propIs.js");
var _propIsJsDefault = parcelHelpers.interopDefault(_propIsJs);
var _propOrJs = require("./propOr.js");
var _propOrJsDefault = parcelHelpers.interopDefault(_propOrJs);
var _propSatisfiesJs = require("./propSatisfies.js");
var _propSatisfiesJsDefault = parcelHelpers.interopDefault(_propSatisfiesJs);
var _propsJs = require("./props.js");
var _propsJsDefault = parcelHelpers.interopDefault(_propsJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
var _reduceWhileJs = require("./reduceWhile.js");
var _reduceWhileJsDefault = parcelHelpers.interopDefault(_reduceWhileJs);
var _reducedJs = require("./reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _repeatJs = require("./repeat.js");
var _repeatJsDefault = parcelHelpers.interopDefault(_repeatJs);
var _replaceJs = require("./replace.js");
var _replaceJsDefault = parcelHelpers.interopDefault(_replaceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
var _setJs = require("./set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _sortByJs = require("./sortBy.js");
var _sortByJsDefault = parcelHelpers.interopDefault(_sortByJs);
var _sortWithJs = require("./sortWith.js");
var _sortWithJsDefault = parcelHelpers.interopDefault(_sortWithJs);
var _splitJs = require("./split.js");
var _splitJsDefault = parcelHelpers.interopDefault(_splitJs);
var _splitAtJs = require("./splitAt.js");
var _splitAtJsDefault = parcelHelpers.interopDefault(_splitAtJs);
var _splitEveryJs = require("./splitEvery.js");
var _splitEveryJsDefault = parcelHelpers.interopDefault(_splitEveryJs);
var _splitWhenJs = require("./splitWhen.js");
var _splitWhenJsDefault = parcelHelpers.interopDefault(_splitWhenJs);
var _startsWithJs = require("./startsWith.js");
var _startsWithJsDefault = parcelHelpers.interopDefault(_startsWithJs);
var _subtractJs = require("./subtract.js");
var _subtractJsDefault = parcelHelpers.interopDefault(_subtractJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _symmetricDifferenceJs = require("./symmetricDifference.js");
var _symmetricDifferenceJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceJs);
var _symmetricDifferenceWithJs = require("./symmetricDifferenceWith.js");
var _symmetricDifferenceWithJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceWithJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
var _takeLastWhileJs = require("./takeLastWhile.js");
var _takeLastWhileJsDefault = parcelHelpers.interopDefault(_takeLastWhileJs);
var _takeWhileJs = require("./takeWhile.js");
var _takeWhileJsDefault = parcelHelpers.interopDefault(_takeWhileJs);
var _tapJs = require("./tap.js");
var _tapJsDefault = parcelHelpers.interopDefault(_tapJs);
var _testJs = require("./test.js");
var _testJsDefault = parcelHelpers.interopDefault(_testJs);
var _andThenJs = require("./andThen.js");
var _andThenJsDefault = parcelHelpers.interopDefault(_andThenJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _toLowerJs = require("./toLower.js");
var _toLowerJsDefault = parcelHelpers.interopDefault(_toLowerJs);
var _toPairsJs = require("./toPairs.js");
var _toPairsJsDefault = parcelHelpers.interopDefault(_toPairsJs);
var _toPairsInJs = require("./toPairsIn.js");
var _toPairsInJsDefault = parcelHelpers.interopDefault(_toPairsInJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
var _toUpperJs = require("./toUpper.js");
var _toUpperJsDefault = parcelHelpers.interopDefault(_toUpperJs);
var _transduceJs = require("./transduce.js");
var _transduceJsDefault = parcelHelpers.interopDefault(_transduceJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _traverseJs = require("./traverse.js");
var _traverseJsDefault = parcelHelpers.interopDefault(_traverseJs);
var _trimJs = require("./trim.js");
var _trimJsDefault = parcelHelpers.interopDefault(_trimJs);
var _tryCatchJs = require("./tryCatch.js");
var _tryCatchJsDefault = parcelHelpers.interopDefault(_tryCatchJs);
var _typeJs = require("./type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _unapplyJs = require("./unapply.js");
var _unapplyJsDefault = parcelHelpers.interopDefault(_unapplyJs);
var _unaryJs = require("./unary.js");
var _unaryJsDefault = parcelHelpers.interopDefault(_unaryJs);
var _uncurryNJs = require("./uncurryN.js");
var _uncurryNJsDefault = parcelHelpers.interopDefault(_uncurryNJs);
var _unfoldJs = require("./unfold.js");
var _unfoldJsDefault = parcelHelpers.interopDefault(_unfoldJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _unionWithJs = require("./unionWith.js");
var _unionWithJsDefault = parcelHelpers.interopDefault(_unionWithJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
var _unlessJs = require("./unless.js");
var _unlessJsDefault = parcelHelpers.interopDefault(_unlessJs);
var _unnestJs = require("./unnest.js");
var _unnestJsDefault = parcelHelpers.interopDefault(_unnestJs);
var _untilJs = require("./until.js");
var _untilJsDefault = parcelHelpers.interopDefault(_untilJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
var _valuesJs = require("./values.js");
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
var _valuesInJs = require("./valuesIn.js");
var _valuesInJsDefault = parcelHelpers.interopDefault(_valuesInJs);
var _viewJs = require("./view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _whenJs = require("./when.js");
var _whenJsDefault = parcelHelpers.interopDefault(_whenJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
var _whereEqJs = require("./whereEq.js");
var _whereEqJsDefault = parcelHelpers.interopDefault(_whereEqJs);
var _withoutJs = require("./without.js");
var _withoutJsDefault = parcelHelpers.interopDefault(_withoutJs);
var _xorJs = require("./xor.js");
var _xorJsDefault = parcelHelpers.interopDefault(_xorJs);
var _xprodJs = require("./xprod.js");
var _xprodJsDefault = parcelHelpers.interopDefault(_xprodJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _zipObjJs = require("./zipObj.js");
var _zipObjJsDefault = parcelHelpers.interopDefault(_zipObjJs);
var _zipWithJs = require("./zipWith.js");
var _zipWithJsDefault = parcelHelpers.interopDefault(_zipWithJs);
var _thunkifyJs = require("./thunkify.js");
var _thunkifyJsDefault = parcelHelpers.interopDefault(_thunkifyJs);

},{"./F.js":"TnV4F","./T.js":"keo73","./__.js":"2avp2","./add.js":"eNcrA","./addIndex.js":"fTkxf","./adjust.js":"2Sgcq","./all.js":"ea7cu","./allPass.js":"iBZTn","./always.js":"3eLDH","./and.js":"9wraL","./any.js":"7MRb3","./anyPass.js":"6gkjS","./ap.js":"aJv2g","./aperture.js":"2YZVP","./append.js":"158My","./apply.js":"hcEnh","./applySpec.js":"in1eV","./applyTo.js":"6F9sT","./ascend.js":"hcTtX","./assoc.js":"f0pOo","./assocPath.js":"7pf5a","./binary.js":"dwmvt","./bind.js":"ihRNX","./both.js":"j8MpL","./call.js":"7c2Fy","./chain.js":"7qkkv","./clamp.js":"3cjVH","./clone.js":"8r0RN","./comparator.js":"dmzeT","./complement.js":"ktHkx","./compose.js":"fpPEV","./composeK.js":"lJjd5","./composeP.js":"jhSwh","./composeWith.js":"c2YEw","./concat.js":"4pYwK","./cond.js":"5VFgV","./construct.js":"8iLh3","./constructN.js":"8dXQy","./contains.js":"lAnm1","./converge.js":"gNudl","./countBy.js":"5J2NX","./curry.js":"huwq0","./curryN.js":"1089f","./dec.js":"7vfdC","./defaultTo.js":"ehcjo","./descend.js":"6Jhtf","./difference.js":"4aCCX","./differenceWith.js":"5HnTh","./dissoc.js":"kAfxG","./dissocPath.js":"1YIza","./divide.js":"dq40r","./drop.js":"bAVNE","./dropLast.js":"hg5WS","./dropLastWhile.js":"ldddu","./dropRepeats.js":"7X50c","./dropRepeatsWith.js":"aRqnk","./dropWhile.js":"eTeBS","./either.js":"4Hvd6","./empty.js":"2fsNu","./endsWith.js":"g4PTm","./eqBy.js":"9pDgJ","./eqProps.js":"6MAgl","./equals.js":"8bwpJ","./evolve.js":"5MxIj","./filter.js":"8n0wk","./find.js":"ek6AM","./findIndex.js":"juMlh","./findLast.js":"ihRCF","./findLastIndex.js":"gJ9Z2","./flatten.js":"7Qtf6","./flip.js":"lmDMh","./forEach.js":"3fU0f","./forEachObjIndexed.js":"k4ly5","./fromPairs.js":"eDwVl","./groupBy.js":"kC6uy","./groupWith.js":"6DkLC","./gt.js":"lfcTA","./gte.js":"c5813","./has.js":"3KlrE","./hasIn.js":"1APj0","./hasPath.js":"fbEFL","./head.js":"gAt6i","./identical.js":"7C2sj","./identity.js":"2leO4","./ifElse.js":"25GUO","./inc.js":"dBQrr","./includes.js":"7fVQh","./indexBy.js":"4LbZi","./indexOf.js":"4uj58","./init.js":"h6whh","./innerJoin.js":"juszP","./insert.js":"6Mu3h","./insertAll.js":"aBImw","./intersection.js":"aE53M","./intersperse.js":"iXgP3","./into.js":"7M8aO","./invert.js":"9hJSR","./invertObj.js":"2kHQ1","./invoker.js":"clZFA","./is.js":"d0f7R","./isEmpty.js":"cPhlx","./isNil.js":"gSuX4","./join.js":"kOPCy","./juxt.js":"4ovEn","./keys.js":"5wxve","./keysIn.js":"cAaDH","./last.js":"j5R4G","./lastIndexOf.js":"5UJaK","./length.js":"hdreL","./lens.js":"lPhea","./lensIndex.js":"6HDDJ","./lensPath.js":"hwz8r","./lensProp.js":"azJqO","./lift.js":"4Rog2","./liftN.js":"9ZIxU","./lt.js":"4cMxa","./lte.js":"dBxFj","./map.js":"hpKgE","./mapAccum.js":"8Yc3l","./mapAccumRight.js":"bAT3D","./mapObjIndexed.js":"1UHt0","./match.js":"k124t","./mathMod.js":"iImm8","./max.js":"aFcmh","./maxBy.js":"ib1fl","./mean.js":"drWgi","./median.js":"5Ikxq","./memoizeWith.js":"1PyBb","./merge.js":"d9lap","./mergeAll.js":"b1qD5","./mergeDeepLeft.js":"4BabA","./mergeDeepRight.js":"gAPt2","./mergeDeepWith.js":"bO0i5","./mergeDeepWithKey.js":"kqFTV","./mergeLeft.js":"g13Db","./mergeRight.js":"8jTd6","./mergeWith.js":"j9tgg","./mergeWithKey.js":"2NjHh","./min.js":"2g42k","./minBy.js":"8QWmT","./modulo.js":"1NJtX","./move.js":"hU99G","./multiply.js":"1c4OE","./nAry.js":"jSuGV","./negate.js":"etq5u","./none.js":"60kTX","./not.js":"26zf5","./nth.js":"hPwYk","./nthArg.js":"c6uQ2","./o.js":"lQ7IC","./objOf.js":"aCTkO","./of.js":"2TspE","./omit.js":"gTotB","./once.js":"hT5wM","./or.js":"56VlK","./otherwise.js":"egyuT","./over.js":"lBJVo","./pair.js":"aHm9U","./partial.js":"7YLO8","./partialRight.js":"dkvuN","./partition.js":"63o4v","./path.js":"eCjeb","./paths.js":"iB7V8","./pathEq.js":"d7sm6","./pathOr.js":"i2Kpd","./pathSatisfies.js":"8h2CG","./pick.js":"2dupT","./pickAll.js":"cEUwj","./pickBy.js":"1cJn1","./pipe.js":"3rTWd","./pipeK.js":"cqKZF","./pipeP.js":"AgzvX","./pipeWith.js":"2vSJk","./pluck.js":"fwhlH","./prepend.js":"kLTQv","./product.js":"04qax","./project.js":"gETO4","./prop.js":"ivTW3","./propEq.js":"e1keA","./propIs.js":"atpQi","./propOr.js":"2t0ej","./propSatisfies.js":"3tY2u","./props.js":"1XoGB","./range.js":"gfd2C","./reduce.js":"fcQd3","./reduceBy.js":"4RLcR","./reduceRight.js":"e4xLk","./reduceWhile.js":"2rOEC","./reduced.js":"c2ydK","./reject.js":"4Qqud","./remove.js":"6EAJu","./repeat.js":"gcRIN","./replace.js":"7HY3E","./reverse.js":"cdnM5","./scan.js":"dynnX","./sequence.js":"30aKw","./set.js":"ulqin","./slice.js":"g9mdG","./sort.js":"8FlYr","./sortBy.js":"43MRi","./sortWith.js":"c99T4","./split.js":"2VWfJ","./splitAt.js":"4wmBY","./splitEvery.js":"foTi1","./splitWhen.js":"9FNzW","./startsWith.js":"kJNsI","./subtract.js":"kbS42","./sum.js":"4B9tz","./symmetricDifference.js":"7AxcC","./symmetricDifferenceWith.js":"NDihh","./tail.js":"de6BV","./take.js":"4KGmO","./takeLast.js":"iJ6Qt","./takeLastWhile.js":"3rkOI","./takeWhile.js":"hysaQ","./tap.js":"gXZzP","./test.js":"6Lv9t","./andThen.js":"6PjcE","./times.js":"kmaDe","./toLower.js":"4TT4g","./toPairs.js":"2q2LA","./toPairsIn.js":"gV1yc","./toString.js":"9LIlN","./toUpper.js":"fSibv","./transduce.js":"4rMUa","./transpose.js":"j9JRW","./traverse.js":"bnjIH","./trim.js":"4KiKv","./tryCatch.js":"a3EKw","./type.js":"dV0L0","./unapply.js":"90xvZ","./unary.js":"dyEgf","./uncurryN.js":"aa2OL","./unfold.js":"1KSZ0","./union.js":"hb1kU","./unionWith.js":"46NlM","./uniq.js":"gH9rZ","./uniqBy.js":"qXYkv","./uniqWith.js":"avVxL","./unless.js":"90Ey6","./unnest.js":"g3B0q","./until.js":"hKFRD","./update.js":"6UtHU","./useWith.js":"7YXzh","./values.js":"22gLf","./valuesIn.js":"iQcQC","./view.js":"iJ0Qj","./when.js":"lnhFU","./where.js":"9428U","./whereEq.js":"kCOQd","./without.js":"a69hA","./xor.js":"gdFpj","./xprod.js":"juCdq","./zip.js":"h7lmb","./zipObj.js":"eTk7Z","./zipWith.js":"4u08F","./thunkify.js":"ftjYX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"TnV4F":[function(require,module,exports,__globalThis) {
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var F = function F() {
    return false;
};
exports.default = F;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"keo73":[function(require,module,exports,__globalThis) {
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var T = function T() {
    return true;
};
exports.default = T;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2avp2":[function(require,module,exports,__globalThis) {
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    '@@functional/placeholder': true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eNcrA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var add = /*#__PURE__*/ (0, _curry2JsDefault.default)(function add(a, b) {
    return Number(a) + Number(b);
});
exports.default = add;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ih2jY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _curry2;
});
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f2 : (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f2 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

},{"./_curry1.js":"kkkXm","./_isPlaceholder.js":"29JK5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kkkXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _curry1;
});
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, _isPlaceholderJsDefault.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

},{"./_isPlaceholder.js":"29JK5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"29JK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isPlaceholder;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function _isPlaceholder(a) {
    return a != null && (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === 'object' && a['@@functional/placeholder'] === true;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fTkxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var addIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function addIndex(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, _concatJsDefault.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
exports.default = addIndex;

},{"./internal/_concat.js":"koL0z","./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"koL0z":[function(require,module,exports,__globalThis) {
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _concat;
});
function _concat(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1089f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function curryN(length, fn) {
    if (length === 1) return (0, _curry1JsDefault.default)(fn);
    return (0, _arityJsDefault.default)(length, (0, _curryNJsDefault.default)(length, [], fn));
});
exports.default = curryN;

},{"./internal/_arity.js":"gf9mV","./internal/_curry1.js":"kkkXm","./internal/_curry2.js":"ih2jY","./internal/_curryN.js":"7QaAR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gf9mV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arity;
});
function _arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7QaAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _curryN;
});
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, _isPlaceholderJsDefault.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, _isPlaceholderJsDefault.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, _arityJsDefault.default)(left, _curryN(length, combined, fn));
    };
}

},{"./_arity.js":"gf9mV","./_isPlaceholder.js":"29JK5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Sgcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var adjust = /*#__PURE__*/ (0, _curry3JsDefault.default)(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, _concatJsDefault.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
exports.default = adjust;

},{"./internal/_concat.js":"koL0z","./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8vS4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _curry3;
});
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f3 : (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f3 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? f3 : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

},{"./_curry1.js":"kkkXm","./_curry2.js":"ih2jY","./_isPlaceholder.js":"29JK5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ea7cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xallJs = require("./internal/_xall.js");
var _xallJsDefault = parcelHelpers.interopDefault(_xallJs);
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var all = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'all'
], (0, _xallJsDefault.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
exports.default = all;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xall.js":"kpdVC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bUU8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _dispatchable;
});
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
function _dispatchable(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, _isArrayJsDefault.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, _isTransformerJsDefault.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

},{"./_isArray.js":"eyLWl","./_isTransformer.js":"k8kRm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eyLWl":[function(require,module,exports,__globalThis) {
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k8kRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isTransformer;
});
function _isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kpdVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAll.prototype['@@transducer/result'] = function(result) {
        if (this.all) result = this.xf['@@transducer/step'](result, true);
        return this.xf['@@transducer/result'](result);
    };
    XAll.prototype['@@transducer/step'] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, false));
        }
        return result;
    };
    return XAll;
}();
var _xall = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xall(f, xf) {
    return new XAll(f, xf);
});
exports.default = _xall;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"22n5T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _reduced;
});
function _reduced(x) {
    return x && x['@@transducer/reduced'] ? x : {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6DHDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    init: function init() {
        return this.xf['@@transducer/init']();
    },
    result: function result(_result) {
        return this.xf['@@transducer/result'](_result);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBZTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var allPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function allPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
exports.default = allPass;

},{"./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","./max.js":"aFcmh","./pluck.js":"fwhlH","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aFcmh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var max = /*#__PURE__*/ (0, _curry2JsDefault.default)(function max(a, b) {
    return b > a ? b : a;
});
exports.default = max;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fwhlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var pluck = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pluck(p, list) {
    return (0, _mapJsDefault.default)((0, _propJsDefault.default)(p), list);
});
exports.default = pluck;

},{"./internal/_curry2.js":"ih2jY","./map.js":"hpKgE","./prop.js":"ivTW3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpKgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xmapJs = require("./internal/_xmap.js");
var _xmapJsDefault = parcelHelpers.interopDefault(_xmapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var map = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'fantasy-land/map',
    'map'
], (0, _xmapJsDefault.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return (0, _curryNJsDefault.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return (0, _reduceJsDefault.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, _keysJsDefault.default)(functor));
        default:
            return (0, _mapJsDefault.default)(fn, functor);
    }
}));
exports.default = map;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_map.js":"2ZKac","./internal/_reduce.js":"krsHh","./internal/_xmap.js":"9Y9PK","./curryN.js":"1089f","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ZKac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _map;
});
function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"krsHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _reduce;
});
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _xwrapJs = require("./_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _bindJs = require("../bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]((0, _bindJsDefault.default)(xf['@@transducer/step'], xf), acc));
}
var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _reduce(fn, acc, list) {
    if (typeof fn === 'function') fn = (0, _xwrapJsDefault.default)(fn);
    if ((0, _isArrayLikeJsDefault.default)(list)) return _arrayReduce(fn, acc, list);
    if (typeof list['fantasy-land/reduce'] === 'function') return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    if (list[symIterator] != null) return _iterableReduce(fn, acc, list[symIterator]());
    if (typeof list.next === 'function') return _iterableReduce(fn, acc, list);
    if (typeof list.reduce === 'function') return _methodReduce(fn, acc, list, 'reduce');
    throw new TypeError('reduce: list must be array or iterable');
}

},{"./_isArrayLike.js":"1rAwI","./_xwrap.js":"5Lf4B","../bind.js":"ihRNX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1rAwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isStringJs = require("./_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var _isArrayLike = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isArrayLike(x) {
    if ((0, _isArrayJsDefault.default)(x)) return true;
    if (!x) return false;
    if ((typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) !== 'object') return false;
    if ((0, _isStringJsDefault.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
exports.default = _isArrayLike;

},{"@swc/helpers/_/_type_of":"668P4","./_curry1.js":"kkkXm","./_isArray.js":"eyLWl","./_isString.js":"cBYp5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cBYp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isString;
});
function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Lf4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _xwrap;
});
var XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function _xwrap(fn) {
    return new XWrap(fn);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ihRNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var bind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function bind(fn, thisObj) {
    return (0, _arityJsDefault.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
exports.default = bind;

},{"./internal/_arity.js":"gf9mV","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Y9PK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XMap.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var _xmap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xmap(f, xf) {
    return new XMap(f, xf);
});
exports.default = _xmap;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5wxve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArgumentsJs = require("./internal/_isArguments.js"); // cover IE < 9 keys issues
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
]; // Safari bug
var hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = hasArgsEnumBug && (0, _isArgumentsJsDefault.default)(obj);
    for(prop in obj)if ((0, _hasJsDefault.default)(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = nonEnumerableProps[nIdx];
            if ((0, _hasJsDefault.default)(prop, obj) && !contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
exports.default = keys;

},{"./internal/_curry1.js":"kkkXm","./internal/_has.js":"2pdjN","./internal/_isArguments.js":"bXW8t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2pdjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _has;
});
function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bXW8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/ function() {
    return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return (0, _hasJsDefault.default)('callee', x);
    };
}();
exports.default = _isArguments;

},{"./_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ivTW3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var prop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prop(p, obj) {
    return (0, _pathJsDefault.default)([
        p
    ], obj);
});
exports.default = prop;

},{"./internal/_curry2.js":"ih2jY","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eCjeb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathsJs = require("./paths.js");
var _pathsJsDefault = parcelHelpers.interopDefault(_pathsJs);
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var path = /*#__PURE__*/ (0, _curry2JsDefault.default)(function path(pathAr, obj) {
    return (0, _pathsJsDefault.default)([
        pathAr
    ], obj)[0];
});
exports.default = path;

},{"./internal/_curry2.js":"ih2jY","./paths.js":"iB7V8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iB7V8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var paths = /*#__PURE__*/ (0, _curry2JsDefault.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(_paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < _paths.length){
            if (val == null) return;
            p = _paths[idx];
            val = (0, _isIntegerJsDefault.default)(p) ? (0, _nthJsDefault.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
exports.default = paths;

},{"./internal/_curry2.js":"ih2jY","./internal/_isInteger.js":"jQ1fh","./nth.js":"hPwYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jQ1fh":[function(require,module,exports,__globalThis) {
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hPwYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var nth = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, _isStringJsDefault.default)(list) ? list.charAt(idx) : list[idx];
});
exports.default = nth;

},{"./internal/_curry2.js":"ih2jY","./internal/_isString.js":"cBYp5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fcQd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var reduce = /*#__PURE__*/ (0, _curry3JsDefault.default)((0, _reduceJsDefault.default));
exports.default = reduce;

},{"./internal/_curry3.js":"8vS4N","./internal/_reduce.js":"krsHh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3eLDH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var always = /*#__PURE__*/ (0, _curry1JsDefault.default)(function always(val) {
    return function() {
        return val;
    };
});
exports.default = always;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9wraL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both, R.xor
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var and = /*#__PURE__*/ (0, _curry2JsDefault.default)(function and(a, b) {
    return a && b;
});
exports.default = and;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7MRb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xanyJs = require("./internal/_xany.js");
var _xanyJsDefault = parcelHelpers.interopDefault(_xanyJs);
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var any = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'any'
], (0, _xanyJsDefault.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
exports.default = any;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xany.js":"ccafL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ccafL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAny.prototype['@@transducer/result'] = function(result) {
        if (!this.any) result = this.xf['@@transducer/step'](result, false);
        return this.xf['@@transducer/result'](result);
    };
    XAny.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, true));
        }
        return result;
    };
    return XAny;
}();
var _xany = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xany(f, xf) {
    return new XAny(f, xf);
});
exports.default = _xany;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gkjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var anyPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function anyPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
exports.default = anyPass;

},{"./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","./max.js":"aFcmh","./pluck.js":"fwhlH","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aJv2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var ap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function ap(applyF, applyX) {
    return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, _reduceJsDefault.default)(function(acc, f) {
        return (0, _concatJsDefault.default)(acc, (0, _mapJsDefault.default)(f, applyX));
    }, [], applyF);
});
exports.default = ap;

},{"./internal/_concat.js":"koL0z","./internal/_curry2.js":"ih2jY","./internal/_reduce.js":"krsHh","./map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2YZVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _apertureJs = require("./internal/_aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xapertureJs = require("./internal/_xaperture.js");
var _xapertureJsDefault = parcelHelpers.interopDefault(_xapertureJs);
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var aperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xapertureJsDefault.default), (0, _apertureJsDefault.default)));
exports.default = aperture;

},{"./internal/_aperture.js":"c8s9w","./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xaperture.js":"16Xko","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c8s9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _aperture;
});
function _aperture(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"16Xko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAperture.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XAperture.prototype['@@transducer/step'] = function(result, input) {
        this.store(input);
        return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, _concatJsDefault.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var _xaperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xaperture(n, xf) {
    return new XAperture(n, xf);
});
exports.default = _xaperture;

},{"./_concat.js":"koL0z","./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"158My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var append = /*#__PURE__*/ (0, _curry2JsDefault.default)(function append(el, list) {
    return (0, _concatJsDefault.default)(list, [
        el
    ]);
});
exports.default = append;

},{"./internal/_concat.js":"koL0z","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hcEnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var apply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
exports.default = apply;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"in1eV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _valuesJs = require("./values.js"); // Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
// delegating calls to .map
function mapValues(fn, obj) {
    return (0, _keysJsDefault.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var applySpec = /*#__PURE__*/ (0, _curry1JsDefault.default)(function applySpec(spec) {
    spec = mapValues(function(v) {
        return typeof v == 'function' ? v : applySpec(v);
    }, spec);
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', (0, _valuesJsDefault.default)(spec))), function() {
        var args = arguments;
        return mapValues(function(f) {
            return (0, _applyJsDefault.default)(f, args);
        }, spec);
    });
});
exports.default = applySpec;

},{"./internal/_curry1.js":"kkkXm","./apply.js":"hcEnh","./curryN.js":"1089f","./max.js":"aFcmh","./pluck.js":"fwhlH","./reduce.js":"fcQd3","./keys.js":"5wxve","./values.js":"22gLf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"22gLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var values = /*#__PURE__*/ (0, _curry1JsDefault.default)(function values(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
exports.default = values;

},{"./internal/_curry1.js":"kkkXm","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6F9sT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var applyTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function applyTo(x, f) {
    return f(x);
});
exports.default = applyTo;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hcTtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var ascend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
exports.default = ascend;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f0pOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var assoc = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
exports.default = assoc;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7pf5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var assocPath = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, _isNilJsDefault.default)(obj) && (0, _hasJsDefault.default)(idx, obj) ? obj[idx] : (0, _isIntegerJsDefault.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, _isIntegerJsDefault.default)(idx) && (0, _isArrayJsDefault.default)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, _assocJsDefault.default)(idx, val, obj);
});
exports.default = assocPath;

},{"./internal/_curry3.js":"8vS4N","./internal/_has.js":"2pdjN","./internal/_isArray.js":"eyLWl","./internal/_isInteger.js":"jQ1fh","./assoc.js":"f0pOo","./isNil.js":"gSuX4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gSuX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var isNil = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isNil(x) {
    return x == null;
});
exports.default = isNil;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dwmvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var binary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function binary(fn) {
    return (0, _nAryJsDefault.default)(2, fn);
});
exports.default = binary;

},{"./internal/_curry1.js":"kkkXm","./nAry.js":"jSuGV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jSuGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var nAry = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
    }
});
exports.default = nAry;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8MpL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var both = /*#__PURE__*/ (0, _curry2JsDefault.default)(function both(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _andJsDefault.default))(f, g);
});
exports.default = both;

},{"./internal/_curry2.js":"ih2jY","./internal/_isFunction.js":"6VGyp","./and.js":"9wraL","./lift.js":"4Rog2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6VGyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isFunction;
});
function _isFunction(x) {
    var type = Object.prototype.toString.call(x);
    return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Rog2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var lift = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lift(fn) {
    return (0, _liftNJsDefault.default)(fn.length, fn);
});
exports.default = lift;

},{"./internal/_curry1.js":"kkkXm","./liftN.js":"9ZIxU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ZIxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var liftN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function liftN(arity, fn) {
    var lifted = (0, _curryNJsDefault.default)(arity, fn);
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _reduceJsDefault.default)((0, _apJsDefault.default), (0, _mapJsDefault.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
exports.default = liftN;

},{"./internal/_curry2.js":"ih2jY","./internal/_reduce.js":"krsHh","./ap.js":"aJv2g","./curryN.js":"1089f","./map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7c2Fy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var call = /*#__PURE__*/ (0, _curryJsDefault.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
exports.default = call;

},{"./curry.js":"huwq0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"huwq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curry = /*#__PURE__*/ (0, _curry1JsDefault.default)(function curry(fn) {
    return (0, _curryNJsDefault.default)(fn.length, fn);
});
exports.default = curry;

},{"./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7qkkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
var _xchainJs = require("./internal/_xchain.js");
var _xchainJsDefault = parcelHelpers.interopDefault(_xchainJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var chain = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'fantasy-land/chain',
    'chain'
], (0, _xchainJsDefault.default), function chain(fn, monad) {
    if (typeof monad === 'function') return function(x) {
        return fn(monad(x))(x);
    };
    return (0, _makeFlatJsDefault.default)(false)((0, _mapJsDefault.default)(fn, monad));
}));
exports.default = chain;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_makeFlat.js":"8Jker","./internal/_xchain.js":"11CtC","./map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Jker":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _makeFlat;
});
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
function _makeFlat(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, _isArrayLikeJsDefault.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

},{"./_isArrayLike.js":"1rAwI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"11CtC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flatCatJs = require("./_flatCat.js");
var _flatCatJsDefault = parcelHelpers.interopDefault(_flatCatJs);
var _mapJs = require("../map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _xchain = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xchain(f, xf) {
    return (0, _mapJsDefault.default)(f, (0, _flatCatJsDefault.default)(xf));
});
exports.default = _xchain;

},{"./_curry2.js":"ih2jY","./_flatCat.js":"57NMV","../map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"57NMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _forceReducedJs = require("./_forceReduced.js");
var _forceReducedJsDefault = parcelHelpers.interopDefault(_forceReducedJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var preservingReduced = function preservingReduced(xf) {
    return {
        '@@transducer/init': (0, _xfBaseJsDefault.default).init,
        '@@transducer/result': function(result) {
            return xf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            var ret = xf['@@transducer/step'](result, input);
            return ret['@@transducer/reduced'] ? (0, _forceReducedJsDefault.default)(ret) : ret;
        }
    };
};
var _flatCat = function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
        '@@transducer/init': (0, _xfBaseJsDefault.default).init,
        '@@transducer/result': function(result) {
            return rxf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            return !(0, _isArrayLikeJsDefault.default)(input) ? (0, _reduceJsDefault.default)(rxf, result, [
                input
            ]) : (0, _reduceJsDefault.default)(rxf, result, input);
        }
    };
};
exports.default = _flatCat;

},{"./_forceReduced.js":"cnuvs","./_isArrayLike.js":"1rAwI","./_reduce.js":"krsHh","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cnuvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _forceReduced;
});
function _forceReduced(x) {
    return {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3cjVH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var clamp = /*#__PURE__*/ (0, _curry3JsDefault.default)(function clamp(min, max, value) {
    if (min > max) throw new Error('min must not be greater than max in clamp(min, max, value)');
    return value < min ? min : value > max ? max : value;
});
exports.default = clamp;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8r0RN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var clone = /*#__PURE__*/ (0, _curry1JsDefault.default)(function clone(value) {
    return value != null && typeof value.clone === 'function' ? value.clone() : (0, _cloneJsDefault.default)(value, [], [], true);
});
exports.default = clone;

},{"./internal/_clone.js":"gxJIa","./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gxJIa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _clone;
});
var _cloneRegExpJs = require("./_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
function _clone(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, _typeJsDefault.default)(value)){
        case 'Object':
            return copy({});
        case 'Array':
            return copy([]);
        case 'Date':
            return new Date(value.valueOf());
        case 'RegExp':
            return (0, _cloneRegExpJsDefault.default)(value);
        default:
            return value;
    }
}

},{"./_cloneRegExp.js":"8LoQa","../type.js":"dV0L0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8LoQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _cloneRegExp;
});
function _cloneRegExp(pattern) {
    return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dV0L0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var type = /*#__PURE__*/ (0, _curry1JsDefault.default)(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
exports.default = type;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dmzeT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var comparator = /*#__PURE__*/ (0, _curry1JsDefault.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
exports.default = comparator;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ktHkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var complement = /*#__PURE__*/ (0, _liftJsDefault.default)((0, _notJsDefault.default));
exports.default = complement;

},{"./lift.js":"4Rog2","./not.js":"26zf5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"26zf5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var not = /*#__PURE__*/ (0, _curry1JsDefault.default)(function not(a) {
    return !a;
});
exports.default = not;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fpPEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return compose;
});
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function compose() {
    if (arguments.length === 0) throw new Error('compose requires at least one argument');
    return (0, _pipeJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipe.js":"3rTWd","./reverse.js":"cdnM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rTWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return pipe;
});
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipeJs = require("./internal/_pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipe() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipeJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"gf9mV","./internal/_pipe.js":"emkgG","./reduce.js":"fcQd3","./tail.js":"de6BV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"emkgG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _pipe;
});
function _pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"de6BV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var tail = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('tail', /*#__PURE__*/ (0, _sliceJsDefault.default)(1, Infinity)));
exports.default = tail;

},{"./internal/_checkForMethod.js":"1auFI","./internal/_curry1.js":"kkkXm","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1auFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _checkForMethod;
});
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
function _checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, _isArrayJsDefault.default)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

},{"./_isArray.js":"eyLWl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g9mdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var slice = /*#__PURE__*/ (0, _curry3JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
exports.default = slice;

},{"./internal/_checkForMethod.js":"1auFI","./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cdnM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var reverse = /*#__PURE__*/ (0, _curry1JsDefault.default)(function reverse(list) {
    return (0, _isStringJsDefault.default)(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
exports.default = reverse;

},{"./internal/_curry1.js":"kkkXm","./internal/_isString.js":"cBYp5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lJjd5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return composeK;
});
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
function composeK() {
    if (arguments.length === 0) throw new Error('composeK requires at least one argument');
    var init = Array.prototype.slice.call(arguments);
    var last = init.pop();
    return (0, _composeJsDefault.default)((0, _composeJsDefault.default).apply(this, (0, _mapJsDefault.default)((0, _chainJsDefault.default), init)), last);
}

},{"./chain.js":"7qkkv","./compose.js":"fpPEV","./map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jhSwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return composeP;
});
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function composeP() {
    if (arguments.length === 0) throw new Error('composeP requires at least one argument');
    return (0, _pipePJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipeP.js":"AgzvX","./reverse.js":"cdnM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"AgzvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return pipeP;
});
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipePJs = require("./internal/_pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipeP() {
    if (arguments.length === 0) throw new Error('pipeP requires at least one argument');
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipePJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"gf9mV","./internal/_pipeP.js":"43yNs","./reduce.js":"fcQd3","./tail.js":"de6BV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"43yNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _pipeP;
});
function _pipeP(f, g) {
    return function() {
        var ctx = this;
        return f.apply(ctx, arguments).then(function(x) {
            return g.call(ctx, x);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c2YEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
/**
 * Performs right-to-left function composition using transforming function. The last argument may have
 * any arity; the remaining arguments must be unary.
 *
 * **Note:** The result of compose is not automatically curried. Transforming function is not used on the
 * last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var composeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function composeWith(xf, list) {
    return (0, _pipeWithJsDefault.default).apply(this, [
        xf,
        (0, _reverseJsDefault.default)(list)
    ]);
});
exports.default = composeWith;

},{"./internal/_curry2.js":"ih2jY","./pipeWith.js":"2vSJk","./reverse.js":"cdnM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2vSJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Performs left-to-right function composition using transforming function. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var pipeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, _identityJsDefault.default;
    var headList = (0, _headJsDefault.default)(list);
    var tailList = (0, _tailJsDefault.default)(list);
    return (0, _arityJsDefault.default)(headList.length, function() {
        return (0, _reduceJsDefault.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
exports.default = pipeWith;

},{"./internal/_arity.js":"gf9mV","./internal/_curry2.js":"ih2jY","./head.js":"gAt6i","./internal/_reduce.js":"krsHh","./tail.js":"de6BV","./identity.js":"2leO4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gAt6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var head = /*#__PURE__*/ (0, _nthJsDefault.default)(0);
exports.default = head;

},{"./nth.js":"hPwYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2leO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var identity = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _identityJsDefault.default));
exports.default = identity;

},{"./internal/_curry1.js":"kkkXm","./internal/_identity.js":"67Xcr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"67Xcr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _identity;
});
function _identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4pYwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var concat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function concat(a, b) {
    if ((0, _isArrayJsDefault.default)(a)) {
        if ((0, _isArrayJsDefault.default)(b)) return a.concat(b);
        throw new TypeError((0, _toStringJsDefault.default)(b) + ' is not an array');
    }
    if ((0, _isStringJsDefault.default)(a)) {
        if ((0, _isStringJsDefault.default)(b)) return a + b;
        throw new TypeError((0, _toStringJsDefault.default)(b) + ' is not a string');
    }
    if (a != null && (0, _isFunctionJsDefault.default)(a['fantasy-land/concat'])) return a['fantasy-land/concat'](b);
    if (a != null && (0, _isFunctionJsDefault.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, _toStringJsDefault.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
exports.default = concat;

},{"./internal/_curry2.js":"ih2jY","./internal/_isArray.js":"eyLWl","./internal/_isFunction.js":"6VGyp","./internal/_isString.js":"cBYp5","./toString.js":"9LIlN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9LIlN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _toStringJs = require("./internal/_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var toString = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toString(val) {
    return (0, _toStringJsDefault.default)(val, []);
});
exports.default = toString;

},{"./internal/_curry1.js":"kkkXm","./internal/_toString.js":"1icAJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1icAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _toString;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _mapJs = require("./_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _quoteJs = require("./_quote.js");
var _quoteJsDefault = parcelHelpers.interopDefault(_quoteJs);
var _toISOStringJs = require("./_toISOString.js");
var _toISOStringJsDefault = parcelHelpers.interopDefault(_toISOStringJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _rejectJs = require("../reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
function _toString(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, _includesJsDefault.default)(y, xs) ? '<Circular>' : _toString(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function mapPairs(obj, keys) {
        return (0, _mapJsDefault.default)(function(k) {
            return (0, _quoteJsDefault.default)(k) + ': ' + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case '[object Arguments]':
            return '(function() { return arguments; }(' + (0, _mapJsDefault.default)(recur, x).join(', ') + '))';
        case '[object Array]':
            return '[' + (0, _mapJsDefault.default)(recur, x).concat(mapPairs(x, (0, _rejectJsDefault.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, _keysJsDefault.default)(x)))).join(', ') + ']';
        case '[object Boolean]':
            return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
        case '[object Date]':
            return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : (0, _quoteJsDefault.default)((0, _toISOStringJsDefault.default)(x))) + ')';
        case '[object Null]':
            return 'null';
        case '[object Number]':
            return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
        case '[object String]':
            return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : (0, _quoteJsDefault.default)(x);
        case '[object Undefined]':
            return 'undefined';
        default:
            if (typeof x.toString === 'function') {
                var repr = x.toString();
                if (repr !== '[object Object]') return repr;
            }
            return '{' + mapPairs(x, (0, _keysJsDefault.default)(x)).join(', ') + '}';
    }
}

},{"@swc/helpers/_/_type_of":"668P4","./_includes.js":"1BMJY","./_map.js":"2ZKac","./_quote.js":"60t11","./_toISOString.js":"kSLyJ","../keys.js":"5wxve","../reject.js":"4Qqud","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1BMJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _includes;
});
var _indexOfJs = require("./_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
function _includes(a, list) {
    return (0, _indexOfJsDefault.default)(list, a, 0) >= 0;
}

},{"./_indexOf.js":"6iqzx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6iqzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _indexOf;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _equalsJs = require("../equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
function _indexOf(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === 'function') switch(typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)){
        case 'number':
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === 'number' && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case 'string':
        case 'boolean':
        case 'function':
        case 'undefined':
            return list.indexOf(a, idx);
        case 'object':
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, _equalsJsDefault.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

},{"@swc/helpers/_/_type_of":"668P4","../equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8bwpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./internal/_equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var equals = /*#__PURE__*/ (0, _curry2JsDefault.default)(function equals(a, b) {
    return (0, _equalsJsDefault.default)(a, b, [], []);
});
exports.default = equals;

},{"./internal/_curry2.js":"ih2jY","./internal/_equals.js":"eHXHt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eHXHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _equals;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _arrayFromIteratorJs = require("./_arrayFromIterator.js");
var _arrayFromIteratorJsDefault = parcelHelpers.interopDefault(_arrayFromIteratorJs);
var _includesWithJs = require("./_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _functionNameJs = require("./_functionName.js");
var _functionNameJsDefault = parcelHelpers.interopDefault(_functionNameJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _objectIsJs = require("./_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, _arrayFromIteratorJsDefault.default)(aIterator);
    var b = (0, _arrayFromIteratorJsDefault.default)(bIterator);
    function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, _includesWithJsDefault.default)(function(b, aItem) {
        return !(0, _includesWithJsDefault.default)(eq, aItem, b);
    }, b, a);
}
function _equals(a, b, stackA, stackB) {
    if ((0, _objectIsJsDefault.default)(a, b)) return true;
    var typeA = (0, _typeJsDefault.default)(a);
    if (typeA !== (0, _typeJsDefault.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    if (typeof a.equals === 'function' || typeof b.equals === 'function') return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    switch(typeA){
        case 'Arguments':
        case 'Array':
        case 'Object':
            if (typeof a.constructor === 'function' && (0, _functionNameJsDefault.default)(a.constructor) === 'Promise') return a === b;
            break;
        case 'Boolean':
        case 'Number':
        case 'String':
            if (!((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) && (0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case 'Date':
            if (!(0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case 'Error':
            return a.name === b.name && a.message === b.message;
        case 'RegExp':
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case 'Map':
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Set':
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, _keysJsDefault.default)(a);
    if (keysA.length !== (0, _keysJsDefault.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, _hasJsDefault.default)(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

},{"@swc/helpers/_/_type_of":"668P4","./_arrayFromIterator.js":"8TLsL","./_includesWith.js":"h0hNk","./_functionName.js":"7Azjg","./_has.js":"2pdjN","./_objectIs.js":"adUdn","../keys.js":"5wxve","../type.js":"dV0L0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TLsL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayFromIterator;
});
function _arrayFromIterator(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h0hNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _includesWith;
});
function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Azjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _functionName;
});
function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"adUdn":[function(require,module,exports,__globalThis) {
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
exports.default = typeof Object.is === 'function' ? Object.is : _objectIs;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"60t11":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _quote;
});
function _quote(s) {
    var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kSLyJ":[function(require,module,exports,__globalThis) {
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pad = function pad(n) {
    return (n < 10 ? '0' : '') + n;
};
var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};
exports.default = _toISOString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Qqud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var reject = /*#__PURE__*/ (0, _curry2JsDefault.default)(function reject(pred, filterable) {
    return (0, _filterJsDefault.default)((0, _complementJsDefault.default)(pred), filterable);
});
exports.default = reject;

},{"./internal/_complement.js":"ky7oT","./internal/_curry2.js":"ih2jY","./filter.js":"8n0wk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ky7oT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _complement;
});
function _complement(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8n0wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfilterJs = require("./internal/_xfilter.js");
var _xfilterJsDefault = parcelHelpers.interopDefault(_xfilterJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var filter = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'filter'
], (0, _xfilterJsDefault.default), function(pred, filterable) {
    return (0, _isObjectJsDefault.default)(filterable) ? (0, _reduceJsDefault.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, _keysJsDefault.default)(filterable)) : (0, _filterJsDefault.default)(pred, filterable);
}));
exports.default = filter;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_filter.js":"5K0mc","./internal/_isObject.js":"jDlA4","./internal/_reduce.js":"krsHh","./internal/_xfilter.js":"5mExy","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5K0mc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _filter;
});
function _filter(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDlA4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isObject;
});
function _isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5mExy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFilter.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XFilter.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XFilter;
}();
var _xfilter = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfilter(f, xf) {
    return new XFilter(f, xf);
});
exports.default = _xfilter;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5VFgV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var cond = /*#__PURE__*/ (0, _curry1JsDefault.default)(function cond(pairs) {
    var arity = (0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _mapJsDefault.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, _arityJsDefault.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
exports.default = cond;

},{"./internal/_arity.js":"gf9mV","./internal/_curry1.js":"kkkXm","./map.js":"hpKgE","./max.js":"aFcmh","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8iLh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var construct = /*#__PURE__*/ (0, _curry1JsDefault.default)(function construct(Fn) {
    return (0, _constructNJsDefault.default)(Fn.length, Fn);
});
exports.default = construct;

},{"./internal/_curry1.js":"kkkXm","./constructN.js":"8dXQy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8dXQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var constructN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error('Constructor with greater than ten arguments');
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, _curryJsDefault.default)((0, _nAryJsDefault.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
exports.default = constructN;

},{"./internal/_curry2.js":"ih2jY","./curry.js":"huwq0","./nAry.js":"jSuGV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lAnm1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */ var contains = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = contains;

},{"./internal/_includes.js":"1BMJY","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gNudl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var converge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function converge(after, fns) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, _mapJsDefault.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
exports.default = converge;

},{"./internal/_curry2.js":"ih2jY","./internal/_map.js":"2ZKac","./curryN.js":"1089f","./max.js":"aFcmh","./pluck.js":"fwhlH","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5J2NX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var countBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return acc + 1;
}, 0);
exports.default = countBy;

},{"./reduceBy.js":"4RLcR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4RLcR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xreduceByJs = require("./internal/_xreduceBy.js");
var _xreduceByJsDefault = parcelHelpers.interopDefault(_xreduceByJs);
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var reduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], /*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xreduceByJsDefault.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, _reduceJsDefault.default)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, _hasJsDefault.default)(key, acc) ? acc[key] : (0, _cloneJsDefault.default)(valueAcc, [], [], false), elt);
        return acc;
    }, {}, list);
}));
exports.default = reduceBy;

},{"./internal/_clone.js":"gxJIa","./internal/_curryN.js":"7QaAR","./internal/_dispatchable.js":"bUU8u","./internal/_has.js":"2pdjN","./internal/_reduce.js":"krsHh","./internal/_xreduceBy.js":"2a0TP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2a0TP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XReduceBy.prototype['@@transducer/result'] = function(result) {
        var key;
        for(key in this.inputs)if ((0, _hasJsDefault.default)(key, this.inputs)) {
            result = this.xf['@@transducer/step'](result, this.inputs[key]);
            if (result['@@transducer/reduced']) {
                result = result['@@transducer/value'];
                break;
            }
        }
        this.inputs = null;
        return this.xf['@@transducer/result'](result);
    };
    XReduceBy.prototype['@@transducer/step'] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var _xreduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
exports.default = _xreduceBy;

},{"./_curryN.js":"7QaAR","./_has.js":"2pdjN","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7vfdC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var dec = /*#__PURE__*/ (0, _addJsDefault.default)(-1);
exports.default = dec;

},{"./add.js":"eNcrA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ehcjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var defaultTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
exports.default = defaultTo;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Jhtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var descend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
exports.default = descend;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4aCCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var difference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, _setJsDefault.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
exports.default = difference;

},{"./internal/_curry2.js":"ih2jY","./internal/_Set.js":"6RVQD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6RVQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === 'function' ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item);
    var prevSize, newSize;
    switch(type){
        case 'string':
        case 'number':
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items['-0']) return true;
                else {
                    if (shouldAdd) set._items['-0'] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case 'boolean':
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case 'function':
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case 'undefined':
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case 'object':
            if (item === null) {
                if (!set._items['null']) {
                    if (shouldAdd) set._items['null'] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
exports.default = _Set;

},{"@swc/helpers/_/_type_of":"668P4","./_includes.js":"1BMJY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5HnTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var differenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, _includesWithJsDefault.default)(pred, first[idx], second) && !(0, _includesWithJsDefault.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
exports.default = differenceWith;

},{"./internal/_includesWith.js":"h0hNk","./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kAfxG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var dissoc = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
exports.default = dissoc;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1YIza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var dissocPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, _isIntegerJsDefault.default)(path[0]) && (0, _isArrayJsDefault.default)(obj) ? (0, _removeJsDefault.default)(path[0], 1, obj) : (0, _dissocJsDefault.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, _isIntegerJsDefault.default)(head) && (0, _isArrayJsDefault.default)(obj)) return (0, _updateJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
            else return (0, _assocJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
exports.default = dissocPath;

},{"./internal/_curry2.js":"ih2jY","./internal/_isInteger.js":"jQ1fh","./internal/_isArray.js":"eyLWl","./assoc.js":"f0pOo","./dissoc.js":"kAfxG","./remove.js":"6EAJu","./update.js":"6UtHU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6EAJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var remove = /*#__PURE__*/ (0, _curry3JsDefault.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
exports.default = remove;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6UtHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var update = /*#__PURE__*/ (0, _curry3JsDefault.default)(function update(idx, x, list) {
    return (0, _adjustJsDefault.default)(idx, (0, _alwaysJsDefault.default)(x), list);
});
exports.default = update;

},{"./internal/_curry3.js":"8vS4N","./adjust.js":"2Sgcq","./always.js":"3eLDH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dq40r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var divide = /*#__PURE__*/ (0, _curry2JsDefault.default)(function divide(a, b) {
    return a / b;
});
exports.default = divide;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bAVNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropJs = require("./internal/_xdrop.js");
var _xdropJsDefault = parcelHelpers.interopDefault(_xdropJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var drop = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'drop'
], (0, _xdropJsDefault.default), function drop(n, xs) {
    return (0, _sliceJsDefault.default)(Math.max(0, n), Infinity, xs);
}));
exports.default = drop;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xdrop.js":"ipIqf","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ipIqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDrop.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDrop.prototype['@@transducer/step'] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDrop;
}();
var _xdrop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdrop(n, xf) {
    return new XDrop(n, xf);
});
exports.default = _xdrop;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hg5WS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastJs = require("./internal/_dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _xdropLastJs = require("./internal/_xdropLast.js");
var _xdropLastJsDefault = parcelHelpers.interopDefault(_xdropLastJs);
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var dropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastJsDefault.default), (0, _dropLastJsDefault.default)));
exports.default = dropLast;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_dropLast.js":"fm1OK","./internal/_xdropLast.js":"4WXo8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fm1OK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return dropLast;
});
var _takeJs = require("../take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
function dropLast(n, xs) {
    return (0, _takeJsDefault.default)(n < xs.length ? xs.length - n : 0, xs);
}

},{"../take.js":"4KGmO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KGmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeJs = require("./internal/_xtake.js");
var _xtakeJsDefault = parcelHelpers.interopDefault(_xtakeJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var take = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'take'
], (0, _xtakeJsDefault.default), function take(n, xs) {
    return (0, _sliceJsDefault.default)(0, n < 0 ? Infinity : n, xs);
}));
exports.default = take;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xtake.js":"Hk6x1","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Hk6x1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTake.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTake.prototype['@@transducer/step'] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, _reducedJsDefault.default)(ret) : ret;
    };
    return XTake;
}();
var _xtake = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtake(n, xf) {
    return new XTake(n, xf);
});
exports.default = _xtake;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4WXo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropLast.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.full) result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var _xdropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLast(n, xf) {
    return new XDropLast(n, xf);
});
exports.default = _xdropLast;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ldddu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastWhileJs = require("./internal/_dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _xdropLastWhileJs = require("./internal/_xdropLastWhile.js");
var _xdropLastWhileJsDefault = parcelHelpers.interopDefault(_xdropLastWhileJs);
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var dropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastWhileJsDefault.default), (0, _dropLastWhileJsDefault.default)));
exports.default = dropLastWhile;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_dropLastWhile.js":"j9Pze","./internal/_xdropLastWhile.js":"1NLjA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j9Pze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return dropLastWhile;
});
var _sliceJs = require("../slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
function dropLastWhile(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(0, idx + 1, xs);
}

},{"../slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1NLjA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropLastWhile.prototype['@@transducer/result'] = function(result) {
        this.retained = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, _reduceJsDefault.default)(this.xf['@@transducer/step'], result, this.retained);
        this.retained = [];
        return this.xf['@@transducer/step'](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var _xdropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLastWhile(fn, xf) {
    return new XDropLastWhile(fn, xf);
});
exports.default = _xdropLastWhile;

},{"./_curry2.js":"ih2jY","./_reduce.js":"krsHh","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7X50c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var dropRepeats = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], /*#__PURE__*/ (0, _xdropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default)), /*#__PURE__*/ (0, _dropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default))));
exports.default = dropRepeats;

},{"./internal/_curry1.js":"kkkXm","./internal/_dispatchable.js":"bUU8u","./internal/_xdropRepeatsWith.js":"3Tqm7","./dropRepeatsWith.js":"aRqnk","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Tqm7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropRepeatsWith.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
    };
    return XDropRepeatsWith;
}();
var _xdropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropRepeatsWith(pred, xf) {
    return new XDropRepeatsWith(pred, xf);
});
exports.default = _xdropRepeatsWith;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aRqnk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var dropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropRepeatsWithJsDefault.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, _lastJsDefault.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
exports.default = dropRepeatsWith;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xdropRepeatsWith.js":"3Tqm7","./last.js":"j5R4G","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j5R4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var last = /*#__PURE__*/ (0, _nthJsDefault.default)(-1);
exports.default = last;

},{"./nth.js":"hPwYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eTeBS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropWhileJs = require("./internal/_xdropWhile.js");
var _xdropWhileJsDefault = parcelHelpers.interopDefault(_xdropWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var dropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'dropWhile'
], (0, _xdropWhileJsDefault.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(idx, Infinity, xs);
}));
exports.default = dropWhile;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xdropWhile.js":"hur60","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hur60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropWhile.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDropWhile.prototype['@@transducer/step'] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDropWhile;
}();
var _xdropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropWhile(f, xf) {
    return new XDropWhile(f, xf);
});
exports.default = _xdropWhile;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Hvd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var either = /*#__PURE__*/ (0, _curry2JsDefault.default)(function either(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _orJsDefault.default))(f, g);
});
exports.default = either;

},{"./internal/_curry2.js":"ih2jY","./internal/_isFunction.js":"6VGyp","./lift.js":"4Rog2","./or.js":"56VlK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"56VlK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either, R.xor
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var or = /*#__PURE__*/ (0, _curry2JsDefault.default)(function or(a, b) {
    return a || b;
});
exports.default = or;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2fsNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArgumentsJs = require("./internal/_isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var empty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : (0, _isArrayJsDefault.default)(x) ? [] : (0, _isStringJsDefault.default)(x) ? '' : (0, _isObjectJsDefault.default)(x) ? {} : (0, _isArgumentsJsDefault.default)(x) ? function() {
        return arguments;
    }() : void 0 // else
    ;
});
exports.default = empty;

},{"./internal/_curry1.js":"kkkXm","./internal/_isArguments.js":"bXW8t","./internal/_isArray.js":"eyLWl","./internal/_isObject.js":"jDlA4","./internal/_isString.js":"cBYp5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g4PTm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var endsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(suffix, list) {
    return (0, _equalsJsDefault.default)((0, _takeLastJsDefault.default)(suffix.length, list), suffix);
});
exports.default = endsWith;

},{"./internal/_curry2.js":"ih2jY","./equals.js":"8bwpJ","./takeLast.js":"iJ6Qt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iJ6Qt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var takeLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLast(n, xs) {
    return (0, _dropJsDefault.default)(n >= 0 ? xs.length - n : 0, xs);
});
exports.default = takeLast;

},{"./internal/_curry2.js":"ih2jY","./drop.js":"bAVNE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9pDgJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var eqBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqBy(f, x, y) {
    return (0, _equalsJsDefault.default)(f(x), f(y));
});
exports.default = eqBy;

},{"./internal/_curry3.js":"8vS4N","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6MAgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var eqProps = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqProps(prop, obj1, obj2) {
    return (0, _equalsJsDefault.default)(obj1[prop], obj2[prop]);
});
exports.default = eqProps;

},{"./internal/_curry3.js":"8vS4N","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5MxIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var evolve = /*#__PURE__*/ (0, _curry2JsDefault.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation === "undefined" ? "undefined" : (0, _typeOf._)(transformation);
        result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
exports.default = evolve;

},{"@swc/helpers/_/_type_of":"668P4","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ek6AM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindJs = require("./internal/_xfind.js");
var _xfindJsDefault = parcelHelpers.interopDefault(_xfindJs);
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var find = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'find'
], (0, _xfindJsDefault.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
exports.default = find;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xfind.js":"czGuG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"czGuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFind.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, void 0);
        return this.xf['@@transducer/result'](result);
    };
    XFind.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, input));
        }
        return result;
    };
    return XFind;
}();
var _xfind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfind(f, xf) {
    return new XFind(f, xf);
});
exports.default = _xfind;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"juMlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindIndexJs = require("./internal/_xfindIndex.js");
var _xfindIndexJsDefault = parcelHelpers.interopDefault(_xfindIndexJs);
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindIndexJsDefault.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
exports.default = findIndex;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xfindIndex.js":"isdme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"isdme":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindIndex.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, -1);
        return this.xf['@@transducer/result'](result);
    };
    XFindIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var _xfindIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindIndex(f, xf) {
    return new XFindIndex(f, xf);
});
exports.default = _xfindIndex;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ihRCF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastJs = require("./internal/_xfindLast.js");
var _xfindLastJsDefault = parcelHelpers.interopDefault(_xfindLastJs);
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var findLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastJsDefault.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
exports.default = findLast;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xfindLast.js":"jQKHF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jQKHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindLast.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
    };
    XFindLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var _xfindLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLast(f, xf) {
    return new XFindLast(f, xf);
});
exports.default = _xfindLast;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gJ9Z2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastIndexJs = require("./internal/_xfindLastIndex.js");
var _xfindLastIndexJsDefault = parcelHelpers.interopDefault(_xfindLastIndexJs);
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastIndexJsDefault.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
exports.default = findLastIndex;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xfindLastIndex.js":"3ygHE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ygHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindLastIndex.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
    };
    XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var _xfindLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLastIndex(f, xf) {
    return new XFindLastIndex(f, xf);
});
exports.default = _xfindLastIndex;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Qtf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var flatten = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _makeFlatJsDefault.default)(true));
exports.default = flatten;

},{"./internal/_curry1.js":"kkkXm","./internal/_makeFlat.js":"8Jker","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lmDMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var flip = /*#__PURE__*/ (0, _curry1JsDefault.default)(function flip(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
exports.default = flip;

},{"./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fU0f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var forEach = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('forEach', function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
exports.default = forEach;

},{"./internal/_checkForMethod.js":"1auFI","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k4ly5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var forEachObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, _keysJsDefault.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
exports.default = forEachObjIndexed;

},{"./internal/_curry2.js":"ih2jY","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eDwVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var fromPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
exports.default = fromPairs;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kC6uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var groupBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('groupBy', /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
exports.default = groupBy;

},{"./internal/_checkForMethod.js":"1auFI","./internal/_curry2.js":"ih2jY","./reduceBy.js":"4RLcR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6DkLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var groupWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
exports.default = groupWith;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lfcTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var gt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gt(a, b) {
    return a > b;
});
exports.default = gt;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5813":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var gte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gte(a, b) {
    return a >= b;
});
exports.default = gte;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KlrE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var has = /*#__PURE__*/ (0, _curry2JsDefault.default)(function has(prop, obj) {
    return (0, _hasPathJsDefault.default)([
        prop
    ], obj);
});
exports.default = has;

},{"./internal/_curry2.js":"ih2jY","./hasPath.js":"fbEFL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fbEFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var hasPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, _isNilJsDefault.default)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, _isNilJsDefault.default)(val) && (0, _hasJsDefault.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
exports.default = hasPath;

},{"./internal/_curry2.js":"ih2jY","./internal/_has.js":"2pdjN","./isNil.js":"gSuX4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1APj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var hasIn = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasIn(prop, obj) {
    return prop in obj;
});
exports.default = hasIn;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7C2sj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectIsJs = require("./internal/_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var identical = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _objectIsJsDefault.default));
exports.default = identical;

},{"./internal/_objectIs.js":"adUdn","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"25GUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var ifElse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, _curryNJsDefault.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
exports.default = ifElse;

},{"./internal/_curry3.js":"8vS4N","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dBQrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var inc = /*#__PURE__*/ (0, _addJsDefault.default)(1);
exports.default = inc;

},{"./add.js":"eNcrA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7fVQh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var includes = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = includes;

},{"./internal/_includes.js":"1BMJY","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4LbZi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var indexBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return elem;
}, null);
exports.default = indexBy;

},{"./reduceBy.js":"4RLcR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4uj58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _indexOfJs = require("./internal/_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var indexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === 'function' && !(0, _isArrayJsDefault.default)(xs) ? xs.indexOf(target) : (0, _indexOfJsDefault.default)(xs, target, 0);
});
exports.default = indexOf;

},{"./internal/_curry2.js":"ih2jY","./internal/_indexOf.js":"6iqzx","./internal/_isArray.js":"eyLWl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h6whh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var init = /*#__PURE__*/ (0, _sliceJsDefault.default)(0, -1);
exports.default = init;

},{"./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"juszP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var innerJoin = /*#__PURE__*/ (0, _curry3JsDefault.default)(function innerJoin(pred, xs, ys) {
    return (0, _filterJsDefault.default)(function(x) {
        return (0, _includesWithJsDefault.default)(pred, x, ys);
    }, xs);
});
exports.default = innerJoin;

},{"./internal/_includesWith.js":"h0hNk","./internal/_curry3.js":"8vS4N","./internal/_filter.js":"5K0mc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Mu3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var insert = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
exports.default = insert;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aBImw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var insertAll = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
exports.default = insertAll;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aE53M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var intersection = /*#__PURE__*/ (0, _curry2JsDefault.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, _uniqJsDefault.default)((0, _filterJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(lookupList), filteredList));
});
exports.default = intersection;

},{"./internal/_includes.js":"1BMJY","./internal/_curry2.js":"ih2jY","./internal/_filter.js":"5K0mc","./flip.js":"lmDMh","./uniq.js":"gH9rZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gH9rZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var uniq = /*#__PURE__*/ (0, _uniqByJsDefault.default)((0, _identityJsDefault.default));
exports.default = uniq;

},{"./identity.js":"2leO4","./uniqBy.js":"qXYkv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"qXYkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var uniqBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqBy(fn, list) {
    var set = new (0, _setJsDefault.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
exports.default = uniqBy;

},{"./internal/_Set.js":"6RVQD","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iXgP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var intersperse = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('intersperse', function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
exports.default = intersperse;

},{"./internal/_checkForMethod.js":"1auFI","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7M8aO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isTransformerJs = require("./internal/_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _stepCatJs = require("./internal/_stepCat.js");
var _stepCatJsDefault = parcelHelpers.interopDefault(_stepCatJs);
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var into = /*#__PURE__*/ (0, _curry3JsDefault.default)(function into(acc, xf, list) {
    return (0, _isTransformerJsDefault.default)(acc) ? (0, _reduceJsDefault.default)(xf(acc), acc['@@transducer/init'](), list) : (0, _reduceJsDefault.default)(xf((0, _stepCatJsDefault.default)(acc)), (0, _cloneJsDefault.default)(acc, [], [], false), list);
});
exports.default = into;

},{"./internal/_clone.js":"gxJIa","./internal/_curry3.js":"8vS4N","./internal/_isTransformer.js":"k8kRm","./internal/_reduce.js":"krsHh","./internal/_stepCat.js":"g0ssq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g0ssq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _stepCat;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectAssignJs = require("./_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _identityJs = require("./_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _objOfJs = require("../objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
        xs.push(x);
        return xs;
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
var _stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) {
        return a + b;
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
var _stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
        return (0, _objectAssignJsDefault.default)(result, (0, _isArrayLikeJsDefault.default)(input) ? (0, _objOfJsDefault.default)(input[0], input[1]) : input);
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
function _stepCat(obj) {
    if ((0, _isTransformerJsDefault.default)(obj)) return obj;
    if ((0, _isArrayLikeJsDefault.default)(obj)) return _stepCatArray;
    if (typeof obj === 'string') return _stepCatString;
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object') return _stepCatObject;
    throw new Error('Cannot create transformer for ' + obj);
}

},{"@swc/helpers/_/_type_of":"668P4","./_objectAssign.js":"fiCmP","./_identity.js":"67Xcr","./_isArrayLike.js":"1rAwI","./_isTransformer.js":"k8kRm","../objOf.js":"aCTkO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fiCmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js"); // Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
function _objectAssign(target) {
    if (target == null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, _hasJsDefault.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
exports.default = typeof Object.assign === 'function' ? Object.assign : _objectAssign;

},{"./_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aCTkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var objOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
exports.default = objOf;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9hJSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var invert = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invert(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, _hasJsDefault.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
exports.default = invert;

},{"./internal/_curry1.js":"kkkXm","./internal/_has.js":"2pdjN","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2kHQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var invertObj = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invertObj(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
exports.default = invertObj;

},{"./internal/_curry1.js":"kkkXm","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"clZFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var invoker = /*#__PURE__*/ (0, _curry2JsDefault.default)(function invoker(arity, method) {
    return (0, _curryNJsDefault.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, _isFunctionJsDefault.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, _toStringJsDefault.default)(target) + ' does not have a method named "' + method + '"');
    });
});
exports.default = invoker;

},{"./internal/_curry2.js":"ih2jY","./internal/_isFunction.js":"6VGyp","./curryN.js":"1089f","./toString.js":"9LIlN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d0f7R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var is = /*#__PURE__*/ (0, _curry2JsDefault.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
exports.default = is;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cPhlx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var isEmpty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isEmpty(x) {
    return x != null && (0, _equalsJsDefault.default)(x, (0, _emptyJsDefault.default)(x));
});
exports.default = isEmpty;

},{"./internal/_curry1.js":"kkkXm","./empty.js":"2fsNu","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kOPCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var join = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, 'join');
exports.default = join;

},{"./invoker.js":"clZFA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ovEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var juxt = /*#__PURE__*/ (0, _curry1JsDefault.default)(function juxt(fns) {
    return (0, _convergeJsDefault.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
exports.default = juxt;

},{"./internal/_curry1.js":"kkkXm","./converge.js":"gNudl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cAaDH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var keysIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
exports.default = keysIn;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5UJaK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var lastIndexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === 'function' && !(0, _isArrayJsDefault.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, _equalsJsDefault.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
exports.default = lastIndexOf;

},{"./internal/_curry2.js":"ih2jY","./internal/_isArray.js":"eyLWl","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hdreL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var length = /*#__PURE__*/ (0, _curry1JsDefault.default)(function length(list) {
    return list != null && (0, _isNumberJsDefault.default)(list.length) ? list.length : NaN;
});
exports.default = length;

},{"./internal/_curry1.js":"kkkXm","./internal/_isNumber.js":"dtSKy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dtSKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isNumber;
});
function _isNumber(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lPhea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lens = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, _mapJsDefault.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
exports.default = lens;

},{"./internal/_curry2.js":"ih2jY","./map.js":"hpKgE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6HDDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var lensIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensIndex(n) {
    return (0, _lensJsDefault.default)((0, _nthJsDefault.default)(n), (0, _updateJsDefault.default)(n));
});
exports.default = lensIndex;

},{"./internal/_curry1.js":"kkkXm","./lens.js":"lPhea","./nth.js":"hPwYk","./update.js":"6UtHU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwz8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var lensPath = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensPath(p) {
    return (0, _lensJsDefault.default)((0, _pathJsDefault.default)(p), (0, _assocPathJsDefault.default)(p));
});
exports.default = lensPath;

},{"./internal/_curry1.js":"kkkXm","./assocPath.js":"7pf5a","./lens.js":"lPhea","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"azJqO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lensProp = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensProp(k) {
    return (0, _lensJsDefault.default)((0, _propJsDefault.default)(k), (0, _assocJsDefault.default)(k));
});
exports.default = lensProp;

},{"./internal/_curry1.js":"kkkXm","./assoc.js":"f0pOo","./lens.js":"lPhea","./prop.js":"ivTW3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4cMxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var lt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lt(a, b) {
    return a < b;
});
exports.default = lt;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dBxFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var lte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lte(a, b) {
    return a <= b;
});
exports.default = lte;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Yc3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var mapAccum = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccum;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bAT3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var mapAccumRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccumRight;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1UHt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var mapObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mapObjIndexed(fn, obj) {
    return (0, _reduceJsDefault.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, _keysJsDefault.default)(obj));
});
exports.default = mapObjIndexed;

},{"./internal/_curry2.js":"ih2jY","./internal/_reduce.js":"krsHh","./keys.js":"5wxve","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k124t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var match = /*#__PURE__*/ (0, _curry2JsDefault.default)(function match(rx, str) {
    return str.match(rx) || [];
});
exports.default = match;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iImm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var mathMod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mathMod(m, p) {
    if (!(0, _isIntegerJsDefault.default)(m)) return NaN;
    if (!(0, _isIntegerJsDefault.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
exports.default = mathMod;

},{"./internal/_curry2.js":"ih2jY","./internal/_isInteger.js":"jQ1fh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ib1fl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var maxBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
exports.default = maxBy;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drWgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var mean = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mean(list) {
    return (0, _sumJsDefault.default)(list) / list.length;
});
exports.default = mean;

},{"./internal/_curry1.js":"kkkXm","./sum.js":"4B9tz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4B9tz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var sum = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _addJsDefault.default), 0);
exports.default = sum;

},{"./add.js":"eNcrA","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Ikxq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var median = /*#__PURE__*/ (0, _curry1JsDefault.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, _meanJsDefault.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
exports.default = median;

},{"./internal/_curry1.js":"kkkXm","./mean.js":"drWgi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1PyBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var memoizeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, _arityJsDefault.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, _hasJsDefault.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
exports.default = memoizeWith;

},{"./internal/_arity.js":"gf9mV","./internal/_curry2.js":"ih2jY","./internal/_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9lap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated since v0.26.0
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */ var merge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function merge(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = merge;

},{"./internal/_objectAssign.js":"fiCmP","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b1qD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var mergeAll = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mergeAll(list) {
    return (0, _objectAssignJsDefault.default).apply(null, [
        {}
    ].concat(list));
});
exports.default = mergeAll;

},{"./internal/_objectAssign.js":"fiCmP","./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4BabA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var mergeDeepLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
exports.default = mergeDeepLeft;

},{"./internal/_curry2.js":"ih2jY","./mergeDeepWithKey.js":"kqFTV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kqFTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var mergeDeepWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, _mergeWithKeyJsDefault.default)(function(k, lVal, rVal) {
        if ((0, _isObjectJsDefault.default)(lVal) && (0, _isObjectJsDefault.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWithKey;

},{"./internal/_curry3.js":"8vS4N","./internal/_isObject.js":"jDlA4","./mergeWithKey.js":"2NjHh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2NjHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var mergeWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, _hasJsDefault.default)(k, l)) result[k] = (0, _hasJsDefault.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, _hasJsDefault.default)(k, r) && !(0, _hasJsDefault.default)(k, result)) result[k] = r[k];
    return result;
});
exports.default = mergeWithKey;

},{"./internal/_curry3.js":"8vS4N","./internal/_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gAPt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var mergeDeepRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepRight(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
exports.default = mergeDeepRight;

},{"./internal/_curry2.js":"ih2jY","./mergeDeepWithKey.js":"kqFTV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bO0i5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var mergeDeepWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWith;

},{"./internal/_curry3.js":"8vS4N","./mergeDeepWithKey.js":"kqFTV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g13Db":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var mergeLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeLeft(l, r) {
    return (0, _objectAssignJsDefault.default)({}, r, l);
});
exports.default = mergeLeft;

},{"./internal/_objectAssign.js":"fiCmP","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8jTd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var mergeRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeRight(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = mergeRight;

},{"./internal/_objectAssign.js":"fiCmP","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j9tgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var mergeWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWith(fn, l, r) {
    return (0, _mergeWithKeyJsDefault.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
exports.default = mergeWith;

},{"./internal/_curry3.js":"8vS4N","./mergeWithKey.js":"2NjHh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2g42k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var min = /*#__PURE__*/ (0, _curry2JsDefault.default)(function min(a, b) {
    return b < a ? b : a;
});
exports.default = min;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8QWmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var minBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
exports.default = minBy;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1NJtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var modulo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function modulo(a, b) {
    return a % b;
});
exports.default = modulo;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hU99G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var move = /*#__PURE__*/ (0, _curry3JsDefault.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
exports.default = move;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1c4OE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var multiply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function multiply(a, b) {
    return a * b;
});
exports.default = multiply;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"etq5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var negate = /*#__PURE__*/ (0, _curry1JsDefault.default)(function negate(n) {
    return -n;
});
exports.default = negate;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"60kTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var none = /*#__PURE__*/ (0, _curry2JsDefault.default)(function none(fn, input) {
    return (0, _allJsDefault.default)((0, _complementJsDefault.default)(fn), input);
});
exports.default = none;

},{"./internal/_complement.js":"ky7oT","./internal/_curry2.js":"ih2jY","./all.js":"ea7cu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c6uQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var nthArg = /*#__PURE__*/ (0, _curry1JsDefault.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _nthJsDefault.default)(n, arguments);
    });
});
exports.default = nthArg;

},{"./internal/_curry1.js":"kkkXm","./curryN.js":"1089f","./nth.js":"hPwYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lQ7IC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var o = /*#__PURE__*/ (0, _curry3JsDefault.default)(function o(f, g, x) {
    return f(g(x));
});
exports.default = o;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2TspE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _ofJs = require("./internal/_of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var of = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _ofJsDefault.default));
exports.default = of;

},{"./internal/_curry1.js":"kkkXm","./internal/_of.js":"cDSOU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cDSOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _of;
});
function _of(x) {
    return [
        x
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gTotB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var omit = /*#__PURE__*/ (0, _curry2JsDefault.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
exports.default = omit;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hT5wM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var once = /*#__PURE__*/ (0, _curry1JsDefault.default)(function once(fn) {
    var called = false;
    var result;
    return (0, _arityJsDefault.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
exports.default = once;

},{"./internal/_arity.js":"gf9mV","./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"egyuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.then
 * @example
 *
 *      var failedFetch = (id) => Promise.reject('bad ID');
 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
 *
 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
 *      var recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.then(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log)
 */ var otherwise = /*#__PURE__*/ (0, _curry2JsDefault.default)(function otherwise(f, p) {
    (0, _assertPromiseJsDefault.default)('otherwise', p);
    return p.then(null, f);
});
exports.default = otherwise;

},{"./internal/_curry2.js":"ih2jY","./internal/_assertPromise.js":"iSa7P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iSa7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _assertPromise;
});
var _isFunctionJs = require("./_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _toStringJs = require("./_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
function _assertPromise(name, p) {
    if (p == null || !(0, _isFunctionJsDefault.default)(p.then)) throw new TypeError('`' + name + '` expected a Promise, received ' + (0, _toStringJsDefault.default)(p, []));
}

},{"./_isFunction.js":"6VGyp","./_toString.js":"1icAJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lBJVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js"); // `Identity` is a functor that holds a single value, where `map` simply
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
// transforms the held value with the provided function.
var Identity = function Identity1(x) {
    return {
        value: x,
        map: function map(f) {
            return Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var over = /*#__PURE__*/ (0, _curry3JsDefault.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return Identity(f(y));
    })(x).value;
});
exports.default = over;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aHm9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var pair = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
exports.default = pair;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7YLO8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var partial = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)((0, _concatJsDefault.default));
exports.default = partial;

},{"./internal/_concat.js":"koL0z","./internal/_createPartialApplicator.js":"gWw78","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gWw78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createPartialApplicator;
});
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
function _createPartialApplicator(concat) {
    return (0, _curry2JsDefault.default)(function(fn, args) {
        return (0, _arityJsDefault.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

},{"./_arity.js":"gf9mV","./_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dkvuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var partialRight = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)(/*#__PURE__*/ (0, _flipJsDefault.default)((0, _concatJsDefault.default)));
exports.default = partialRight;

},{"./internal/_concat.js":"koL0z","./internal/_createPartialApplicator.js":"gWw78","./flip.js":"lmDMh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"63o4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var partition = /*#__PURE__*/ (0, _juxtJsDefault.default)([
    (0, _filterJsDefault.default),
    (0, _rejectJsDefault.default)
]);
exports.default = partition;

},{"./filter.js":"8n0wk","./juxt.js":"4ovEn","./reject.js":"4Qqud","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d7sm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var pathEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathEq(_path, val, obj) {
    return (0, _equalsJsDefault.default)((0, _pathJsDefault.default)(_path, obj), val);
});
exports.default = pathEq;

},{"./internal/_curry3.js":"8vS4N","./equals.js":"8bwpJ","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i2Kpd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var pathOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathOr(d, p, obj) {
    return (0, _defaultToJsDefault.default)(d, (0, _pathJsDefault.default)(p, obj));
});
exports.default = pathOr;

},{"./internal/_curry3.js":"8vS4N","./defaultTo.js":"ehcjo","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8h2CG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var pathSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, _pathJsDefault.default)(propPath, obj));
});
exports.default = pathSatisfies;

},{"./internal/_curry3.js":"8vS4N","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2dupT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var pick = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
exports.default = pick;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cEUwj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var pickAll = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
exports.default = pickAll;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1cJn1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var pickBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
exports.default = pickBy;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cqKZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return pipeK;
});
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function pipeK() {
    if (arguments.length === 0) throw new Error('pipeK requires at least one argument');
    return (0, _composeKJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./composeK.js":"lJjd5","./reverse.js":"cdnM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kLTQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var prepend = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prepend(el, list) {
    return (0, _concatJsDefault.default)([
        el
    ], list);
});
exports.default = prepend;

},{"./internal/_concat.js":"koL0z","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"04qax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var product = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _multiplyJsDefault.default), 1);
exports.default = product;

},{"./multiply.js":"1c4OE","./reduce.js":"fcQd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gETO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var project = /*#__PURE__*/ (0, _useWithJsDefault.default)((0, _mapJsDefault.default), [
    (0, _pickAllJsDefault.default),
    (0, _identityJsDefault.default)
]); // passing `identity` gives correct arity
exports.default = project;

},{"./internal/_map.js":"2ZKac","./identity.js":"2leO4","./pickAll.js":"cEUwj","./useWith.js":"7YXzh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7YXzh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var useWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function useWith(fn, transformers) {
    return (0, _curryNJsDefault.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
exports.default = useWith;

},{"./internal/_curry2.js":"ih2jY","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e1keA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var propEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propEq(name, val, obj) {
    return (0, _equalsJsDefault.default)(val, obj[name]);
});
exports.default = propEq;

},{"./internal/_curry3.js":"8vS4N","./equals.js":"8bwpJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"atpQi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var propIs = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propIs(type, name, obj) {
    return (0, _isJsDefault.default)(type, obj[name]);
});
exports.default = propIs;

},{"./internal/_curry3.js":"8vS4N","./is.js":"d0f7R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2t0ej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var propOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propOr(val, p, obj) {
    return (0, _pathOrJsDefault.default)(val, [
        p
    ], obj);
});
exports.default = propOr;

},{"./internal/_curry3.js":"8vS4N","./pathOr.js":"i2Kpd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3tY2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var propSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propSatisfies(pred, name, obj) {
    return pred(obj[name]);
});
exports.default = propSatisfies;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1XoGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var props = /*#__PURE__*/ (0, _curry2JsDefault.default)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, _pathJsDefault.default)([
            p
        ], obj);
    });
});
exports.default = props;

},{"./internal/_curry2.js":"ih2jY","./path.js":"eCjeb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gfd2C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var range = /*#__PURE__*/ (0, _curry2JsDefault.default)(function range(from, to) {
    if (!((0, _isNumberJsDefault.default)(from) && (0, _isNumberJsDefault.default)(to))) throw new TypeError('Both arguments to range must be numbers');
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
exports.default = range;

},{"./internal/_curry2.js":"ih2jY","./internal/_isNumber.js":"dtSKy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e4xLk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var reduceRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        idx -= 1;
    }
    return acc;
});
exports.default = reduceRight;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2rOEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 === 1;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var reduceWhile = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, _reduceJsDefault.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, _reducedJsDefault.default)(acc);
    }, a, list);
});
exports.default = reduceWhile;

},{"./internal/_curryN.js":"7QaAR","./internal/_reduce.js":"krsHh","./internal/_reduced.js":"22n5T","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c2ydK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is only available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var reduced = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _reducedJsDefault.default));
exports.default = reduced;

},{"./internal/_curry1.js":"kkkXm","./internal/_reduced.js":"22n5T","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gcRIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var repeat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function repeat(value, n) {
    return (0, _timesJsDefault.default)((0, _alwaysJsDefault.default)(value), n);
});
exports.default = repeat;

},{"./internal/_curry2.js":"ih2jY","./always.js":"3eLDH","./times.js":"kmaDe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kmaDe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var times = /*#__PURE__*/ (0, _curry2JsDefault.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError('n must be a non-negative number');
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
exports.default = times;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7HY3E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var replace = /*#__PURE__*/ (0, _curry3JsDefault.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
exports.default = replace;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dynnX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var scan = /*#__PURE__*/ (0, _curry3JsDefault.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
exports.default = scan;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"30aKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var sequence = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === 'function' ? traversable.sequence(of) : (0, _reduceRightJsDefault.default)(function(x, acc) {
        return (0, _apJsDefault.default)((0, _mapJsDefault.default)((0, _prependJsDefault.default), x), acc);
    }, of([]), traversable);
});
exports.default = sequence;

},{"./internal/_curry2.js":"ih2jY","./ap.js":"aJv2g","./map.js":"hpKgE","./prepend.js":"kLTQv","./reduceRight.js":"e4xLk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ulqin":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var set = /*#__PURE__*/ (0, _curry3JsDefault.default)(function set(lens, v, x) {
    return (0, _overJsDefault.default)(lens, (0, _alwaysJsDefault.default)(v), x);
});
exports.default = set;

},{"./internal/_curry3.js":"8vS4N","./always.js":"3eLDH","./over.js":"lBJVo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FlYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var sort = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
exports.default = sort;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"43MRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var sortBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
exports.default = sortBy;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c99T4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var sortWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
exports.default = sortWith;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VWfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var split = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, 'split');
exports.default = split;

},{"./invoker.js":"clZFA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4wmBY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var splitAt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitAt(index, array) {
    return [
        (0, _sliceJsDefault.default)(0, index, array),
        (0, _sliceJsDefault.default)(index, (0, _lengthJsDefault.default)(array), array)
    ];
});
exports.default = splitAt;

},{"./internal/_curry2.js":"ih2jY","./length.js":"hdreL","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"foTi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var splitEvery = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error('First argument to splitEvery must be a positive integer');
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, _sliceJsDefault.default)(idx, idx += n, list));
    return result;
});
exports.default = splitEvery;

},{"./internal/_curry2.js":"ih2jY","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9FNzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var splitWhen = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
exports.default = splitWhen;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kJNsI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var startsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(prefix, list) {
    return (0, _equalsJsDefault.default)((0, _takeJsDefault.default)(prefix.length, list), prefix);
});
exports.default = startsWith;

},{"./internal/_curry2.js":"ih2jY","./equals.js":"8bwpJ","./take.js":"4KGmO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbS42":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var subtract = /*#__PURE__*/ (0, _curry2JsDefault.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
exports.default = subtract;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7AxcC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var symmetricDifference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function symmetricDifference(list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceJsDefault.default)(list1, list2), (0, _differenceJsDefault.default)(list2, list1));
});
exports.default = symmetricDifference;

},{"./internal/_curry2.js":"ih2jY","./concat.js":"4pYwK","./difference.js":"4aCCX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"NDihh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var symmetricDifferenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceWithJsDefault.default)(pred, list1, list2), (0, _differenceWithJsDefault.default)(pred, list2, list1));
});
exports.default = symmetricDifferenceWith;

},{"./internal/_curry3.js":"8vS4N","./concat.js":"4pYwK","./differenceWith.js":"5HnTh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rkOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var takeLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(idx + 1, Infinity, xs);
});
exports.default = takeLastWhile;

},{"./internal/_curry2.js":"ih2jY","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hysaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeWhileJs = require("./internal/_xtakeWhile.js");
var _xtakeWhileJsDefault = parcelHelpers.interopDefault(_xtakeWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var takeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'takeWhile'
], (0, _xtakeWhileJsDefault.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(0, idx, xs);
}));
exports.default = takeWhile;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xtakeWhile.js":"2hMpL","./slice.js":"g9mdG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2hMpL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTakeWhile.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : (0, _reducedJsDefault.default)(result);
    };
    return XTakeWhile;
}();
var _xtakeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtakeWhile(f, xf) {
    return new XTakeWhile(f, xf);
});
exports.default = _xtakeWhile;

},{"./_curry2.js":"ih2jY","./_reduced.js":"22n5T","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gXZzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtapJs = require("./internal/_xtap.js");
var _xtapJsDefault = parcelHelpers.interopDefault(_xtapJs);
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var tap = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xtapJsDefault.default), function tap(fn, x) {
    fn(x);
    return x;
}));
exports.default = tap;

},{"./internal/_curry2.js":"ih2jY","./internal/_dispatchable.js":"bUU8u","./internal/_xtap.js":"oxRVT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"oxRVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTap.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTap.prototype['@@transducer/step'] = function(result, input) {
        this.f(input);
        return this.xf['@@transducer/step'](result, input);
    };
    return XTap;
}();
var _xtap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtap(f, xf) {
    return new XTap(f, xf);
});
exports.default = _xtap;

},{"./_curry2.js":"ih2jY","./_xfBase.js":"6DHDR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Lv9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneRegExpJs = require("./internal/_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isRegExpJs = require("./internal/_isRegExp.js");
var _isRegExpJsDefault = parcelHelpers.interopDefault(_isRegExpJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var test = /*#__PURE__*/ (0, _curry2JsDefault.default)(function test(pattern, str) {
    if (!(0, _isRegExpJsDefault.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, _toStringJsDefault.default)(pattern));
    return (0, _cloneRegExpJsDefault.default)(pattern).test(str);
});
exports.default = test;

},{"./internal/_cloneRegExp.js":"8LoQa","./internal/_curry2.js":"ih2jY","./internal/_isRegExp.js":"6Ghv9","./toString.js":"9LIlN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Ghv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isRegExp;
});
function _isRegExp(x) {
    return Object.prototype.toString.call(x) === '[object RegExp]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6PjcE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      var makeQuery = (email) => ({ query: { email }});
 *
 *      //getMemberName :: String -> Promise ({firstName, lastName})
 *      var getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 */ var andThen = /*#__PURE__*/ (0, _curry2JsDefault.default)(function andThen(f, p) {
    (0, _assertPromiseJsDefault.default)('andThen', p);
    return p.then(f);
});
exports.default = andThen;

},{"./internal/_curry2.js":"ih2jY","./internal/_assertPromise.js":"iSa7P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TT4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var toLower = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, 'toLowerCase');
exports.default = toLower;

},{"./invoker.js":"clZFA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2q2LA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var toPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, _hasJsDefault.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairs;

},{"./internal/_curry1.js":"kkkXm","./internal/_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gV1yc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var toPairsIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairsIn;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fSibv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var toUpper = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, 'toUpperCase');
exports.default = toUpper;

},{"./invoker.js":"clZFA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rMUa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xwrapJs = require("./internal/_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 === 1;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var transduce = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, function transduce(xf, fn, acc, list) {
    return (0, _reduceJsDefault.default)(xf(typeof fn === 'function' ? (0, _xwrapJsDefault.default)(fn) : fn), acc, list);
});
exports.default = transduce;

},{"./internal/_reduce.js":"krsHh","./internal/_xwrap.js":"5Lf4B","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j9JRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var transpose = /*#__PURE__*/ (0, _curry1JsDefault.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === 'undefined') result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
exports.default = transpose;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bnjIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var traverse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function traverse(of, f, traversable) {
    return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : (0, _sequenceJsDefault.default)(of, (0, _mapJsDefault.default)(f, traversable));
});
exports.default = traverse;

},{"./internal/_curry3.js":"8vS4N","./map.js":"hpKgE","./sequence.js":"30aKw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KiKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var ws = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var zeroWidth = '\u200b';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var trim = !hasProtoTrim || /*#__PURE__*/ ws.trim() || !/*#__PURE__*/ zeroWidth.trim() ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
    var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
    return str.replace(beginRx, '').replace(endRx, '');
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    return str.trim();
});
exports.default = trim;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a3EKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var tryCatch = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _tryCatch(tryer, catcher) {
    return (0, _arityJsDefault.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, _concatJsDefault.default)([
                e
            ], arguments));
        }
    });
});
exports.default = tryCatch;

},{"./internal/_arity.js":"gf9mV","./internal/_concat.js":"koL0z","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"90xvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var unapply = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
exports.default = unapply;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dyEgf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var unary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unary(fn) {
    return (0, _nAryJsDefault.default)(1, fn);
});
exports.default = unary;

},{"./internal/_curry1.js":"kkkXm","./nAry.js":"jSuGV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aa2OL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var uncurryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uncurryN(depth, fn) {
    return (0, _curryNJsDefault.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === 'function'){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
exports.default = uncurryN;

},{"./internal/_curry2.js":"ih2jY","./curryN.js":"1089f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1KSZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var unfold = /*#__PURE__*/ (0, _curry2JsDefault.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
exports.default = unfold;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hb1kU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var union = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _composeJsDefault.default)((0, _uniqJsDefault.default), (0, _concatJsDefault.default)));
exports.default = union;

},{"./internal/_concat.js":"koL0z","./internal/_curry2.js":"ih2jY","./compose.js":"fpPEV","./uniq.js":"gH9rZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"46NlM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var unionWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unionWith(pred, list1, list2) {
    return (0, _uniqWithJsDefault.default)(pred, (0, _concatJsDefault.default)(list1, list2));
});
exports.default = unionWith;

},{"./internal/_concat.js":"koL0z","./internal/_curry3.js":"8vS4N","./uniqWith.js":"avVxL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"avVxL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var uniqWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqWith(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, _includesWithJsDefault.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
});
exports.default = uniqWith;

},{"./internal/_includesWith.js":"h0hNk","./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"90Ey6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var unless = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
exports.default = unless;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g3B0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var unnest = /*#__PURE__*/ (0, _chainJsDefault.default)((0, _identityJsDefault.default));
exports.default = unnest;

},{"./internal/_identity.js":"67Xcr","./chain.js":"7qkkv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKFRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var until = /*#__PURE__*/ (0, _curry3JsDefault.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
exports.default = until;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iQcQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var valuesIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
exports.default = valuesIn;

},{"./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iJ0Qj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js"); // `Const` is a functor that effectively ignores the function given to `map`.
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var Const = function Const(x) {
    return {
        value: x,
        'fantasy-land/map': function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var view = /*#__PURE__*/ (0, _curry2JsDefault.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
});
exports.default = view;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lnhFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var when = /*#__PURE__*/ (0, _curry3JsDefault.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
exports.default = when;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9428U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var where = /*#__PURE__*/ (0, _curry2JsDefault.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, _hasJsDefault.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
exports.default = where;

},{"./internal/_curry2.js":"ih2jY","./internal/_has.js":"2pdjN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kCOQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var whereEq = /*#__PURE__*/ (0, _curry2JsDefault.default)(function whereEq(spec, testObj) {
    return (0, _whereJsDefault.default)((0, _mapJsDefault.default)((0, _equalsJsDefault.default), spec), testObj);
});
exports.default = whereEq;

},{"./internal/_curry2.js":"ih2jY","./equals.js":"8bwpJ","./map.js":"hpKgE","./where.js":"9428U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a69hA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var without = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(xs, list) {
    return (0, _rejectJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(xs), list);
});
exports.default = without;

},{"./internal/_includes.js":"1BMJY","./internal/_curry2.js":"ih2jY","./flip.js":"lmDMh","./reject.js":"4Qqud","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdFpj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var xor = /*#__PURE__*/ (0, _curry2JsDefault.default)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
exports.default = xor;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"juCdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var xprod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
exports.default = xprod;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h7lmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var zip = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
exports.default = zip;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eTk7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var zipObj = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
exports.default = zipObj;

},{"./internal/_curry2.js":"ih2jY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4u08F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var zipWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
exports.default = zipWith;

},{"./internal/_curry3.js":"8vS4N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ftjYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var thunkify = /*#__PURE__*/ (0, _curry1JsDefault.default)(function thunkify(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
exports.default = thunkify;

},{"./curryN.js":"1089f","./internal/_curry1.js":"kkkXm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZqyP":[function(require,module,exports,__globalThis) {
/*!
 * perfect-scrollbar v1.5.0
 * Copyright 2020 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function get(element) {
    return getComputedStyle(element);
}
function set(element, obj) {
    for(var key in obj){
        var val = obj[key];
        if (typeof val === 'number') val = val + "px";
        element.style[key] = val;
    }
    return element;
}
function div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
}
var elMatches = typeof Element !== 'undefined' && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function matches(element, query) {
    if (!elMatches) throw new Error('No element matching method supported');
    return elMatches.call(element, query);
}
function remove(element) {
    if (element.remove) element.remove();
    else if (element.parentNode) element.parentNode.removeChild(element);
}
function queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function(child) {
        return matches(child, selector);
    });
}
var cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
        thumb: function thumb(x) {
            return "ps__thumb-" + x;
        },
        rail: function rail(x) {
            return "ps__rail-" + x;
        },
        consuming: 'ps__child--consume'
    },
    state: {
        focus: 'ps--focus',
        clicking: 'ps--clicking',
        active: function active(x) {
            return "ps--active-" + x;
        },
        scrolling: function scrolling(x) {
            return "ps--scrolling-" + x;
        }
    }
};
/*
 * Helper methods
 */ var scrollingClassTimeout = {
    x: null,
    y: null
};
function addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = cls.state.scrolling(x);
    if (classList.contains(className)) clearTimeout(scrollingClassTimeout[x]);
    else classList.add(className);
}
function removeScrollingClass(i, x) {
    scrollingClassTimeout[x] = setTimeout(function() {
        return i.isAlive && i.element.classList.remove(cls.state.scrolling(x));
    }, i.settings.scrollingThreshold);
}
function setScrollingClassInstantly(i, x) {
    addScrollingClass(i, x);
    removeScrollingClass(i, x);
}
var EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
};
var prototypeAccessors = {
    isEmpty: {
        configurable: true
    }
};
EventElement.prototype.bind = function bind(eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') this.handlers[eventName] = [];
    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
};
EventElement.prototype.unbind = function unbind(eventName, target) {
    var this$1 = this;
    this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
        if (target && handler !== target) return true;
        this$1.element.removeEventListener(eventName, handler, false);
        return false;
    });
};
EventElement.prototype.unbindAll = function unbindAll() {
    for(var name in this.handlers)this.unbind(name);
};
prototypeAccessors.isEmpty.get = function() {
    var this$1 = this;
    return Object.keys(this.handlers).every(function(key) {
        return this$1.handlers[key].length === 0;
    });
};
Object.defineProperties(EventElement.prototype, prototypeAccessors);
var EventManager = function EventManager() {
    this.eventElements = [];
};
EventManager.prototype.eventElement = function eventElement(element) {
    var ee = this.eventElements.filter(function(ee) {
        return ee.element === element;
    })[0];
    if (!ee) {
        ee = new EventElement(element);
        this.eventElements.push(ee);
    }
    return ee;
};
EventManager.prototype.bind = function bind(element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
};
EventManager.prototype.unbind = function unbind(element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);
    if (ee.isEmpty) // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
};
EventManager.prototype.unbindAll = function unbindAll() {
    this.eventElements.forEach(function(e) {
        return e.unbindAll();
    });
    this.eventElements = [];
};
EventManager.prototype.once = function once(element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function onceHandler1(evt) {
        ee.unbind(eventName, onceHandler);
        handler(evt);
    };
    ee.bind(eventName, onceHandler);
};
function createEvent(name) {
    if (typeof window.CustomEvent === 'function') return new CustomEvent(name);
    else {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(name, false, false, undefined);
        return evt;
    }
}
function processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var fields;
    if (axis === 'top') fields = [
        'contentHeight',
        'containerHeight',
        'scrollTop',
        'y',
        'up',
        'down'
    ];
    else if (axis === 'left') fields = [
        'contentWidth',
        'containerWidth',
        'scrollLeft',
        'x',
        'left',
        'right'
    ];
    else throw new Error('A proper axis should be provided');
    processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function processScrollDiff$1(i, diff, ref, useScrollingClass, forceFireReachEvent) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var element = i.element;
    // reset reach
    i.reach[y] = null;
    // 1 for subpixel rounding
    if (element[scrollTop] < 1) i.reach[y] = 'start';
    // 1 for subpixel rounding
    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) i.reach[y] = 'end';
    if (diff) {
        element.dispatchEvent(createEvent("ps-scroll-" + y));
        if (diff < 0) element.dispatchEvent(createEvent("ps-scroll-" + up));
        else if (diff > 0) element.dispatchEvent(createEvent("ps-scroll-" + down));
        if (useScrollingClass) setScrollingClassInstantly(i, y);
    }
    if (i.reach[y] && (diff || forceFireReachEvent)) element.dispatchEvent(createEvent("ps-" + y + "-reach-" + i.reach[y]));
}
function toInt(x) {
    return parseInt(x, 10) || 0;
}
function isEditable(el) {
    return matches(el, 'input,[contenteditable]') || matches(el, 'select,[contenteditable]') || matches(el, 'textarea,[contenteditable]') || matches(el, 'button,[contenteditable]');
}
function outerWidth(element) {
    var styles = get(element);
    return toInt(styles.width) + toInt(styles.paddingLeft) + toInt(styles.paddingRight) + toInt(styles.borderLeftWidth) + toInt(styles.borderRightWidth);
}
var env = {
    isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
    supportsTouch: typeof window !== 'undefined' && ('ontouchstart' in window || 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== 'undefined' && /Chrome/i.test(navigator && navigator.userAgent)
};
function updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();
    i.containerWidth = Math.ceil(rect.width);
    i.containerHeight = Math.ceil(rect.height);
    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;
    if (!element.contains(i.scrollbarXRail)) {
        // clean up and append
        queryChildren(element, cls.element.rail('x')).forEach(function(el) {
            return remove(el);
        });
        element.appendChild(i.scrollbarXRail);
    }
    if (!element.contains(i.scrollbarYRail)) {
        // clean up and append
        queryChildren(element, cls.element.rail('y')).forEach(function(el) {
            return remove(el);
        });
        element.appendChild(i.scrollbarYRail);
    }
    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
        i.scrollbarXActive = true;
        i.railXWidth = i.containerWidth - i.railXMarginWidth;
        i.railXRatio = i.containerWidth / i.railXWidth;
        i.scrollbarXWidth = getThumbSize(i, toInt(i.railXWidth * i.containerWidth / i.contentWidth));
        i.scrollbarXLeft = toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else i.scrollbarXActive = false;
    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
        i.scrollbarYActive = true;
        i.railYHeight = i.containerHeight - i.railYMarginHeight;
        i.railYRatio = i.containerHeight / i.railYHeight;
        i.scrollbarYHeight = getThumbSize(i, toInt(i.railYHeight * i.containerHeight / i.contentHeight));
        i.scrollbarYTop = toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else i.scrollbarYActive = false;
    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    updateCss(element, i);
    if (i.scrollbarXActive) element.classList.add(cls.state.active('x'));
    else {
        element.classList.remove(cls.state.active('x'));
        i.scrollbarXWidth = 0;
        i.scrollbarXLeft = 0;
        element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) element.classList.add(cls.state.active('y'));
    else {
        element.classList.remove(cls.state.active('y'));
        i.scrollbarYHeight = 0;
        i.scrollbarYTop = 0;
        element.scrollTop = 0;
    }
}
function getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    if (i.settings.maxScrollbarLength) thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    return thumbSize;
}
function updateCss(element, i) {
    var xRailOffset = {
        width: i.railXWidth
    };
    var roundedScrollTop = Math.floor(element.scrollTop);
    if (i.isRtl) xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
    else xRailOffset.left = element.scrollLeft;
    if (i.isScrollbarXUsingBottom) xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    else xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    set(i.scrollbarXRail, xRailOffset);
    var yRailOffset = {
        top: roundedScrollTop,
        height: i.railYHeight
    };
    if (i.isScrollbarYUsingRight) {
        if (i.isRtl) yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
        else yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    } else if (i.isRtl) yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    else yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    set(i.scrollbarYRail, yRailOffset);
    set(i.scrollbarX, {
        left: i.scrollbarXLeft,
        width: i.scrollbarXWidth - i.railBorderXWidth
    });
    set(i.scrollbarY, {
        top: i.scrollbarYTop,
        height: i.scrollbarYHeight - i.railBorderYWidth
    });
}
function clickRail(i) {
    var element = i.element;
    i.event.bind(i.scrollbarY, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarYRail, 'mousedown', function(e) {
        var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
        var direction = positionTop > i.scrollbarYTop ? 1 : -1;
        i.element.scrollTop += direction * i.containerHeight;
        updateGeometry(i);
        e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarXRail, 'mousedown', function(e) {
        var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
        var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
        i.element.scrollLeft += direction * i.containerWidth;
        updateGeometry(i);
        e.stopPropagation();
    });
}
function dragThumb(i) {
    bindMouseScrollHandler(i, [
        'containerWidth',
        'contentWidth',
        'pageX',
        'railXWidth',
        'scrollbarX',
        'scrollbarXWidth',
        'scrollLeft',
        'x',
        'scrollbarXRail'
    ]);
    bindMouseScrollHandler(i, [
        'containerHeight',
        'contentHeight',
        'pageY',
        'railYHeight',
        'scrollbarY',
        'scrollbarYHeight',
        'scrollTop',
        'y',
        'scrollbarYRail'
    ]);
}
function bindMouseScrollHandler(i, ref) {
    var containerHeight = ref[0];
    var contentHeight = ref[1];
    var pageY = ref[2];
    var railYHeight = ref[3];
    var scrollbarY = ref[4];
    var scrollbarYHeight = ref[5];
    var scrollTop = ref[6];
    var y = ref[7];
    var scrollbarYRail = ref[8];
    var element = i.element;
    var startingScrollTop = null;
    var startingMousePageY = null;
    var scrollBy = null;
    function mouseMoveHandler(e) {
        if (e.touches && e.touches[0]) e[pageY] = e.touches[0].pageY;
        element[scrollTop] = startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
        addScrollingClass(i, y);
        updateGeometry(i);
        e.stopPropagation();
        e.preventDefault();
    }
    function mouseUpHandler() {
        removeScrollingClass(i, y);
        i[scrollbarYRail].classList.remove(cls.state.clicking);
        i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    }
    function bindMoves(e, touchMode) {
        startingScrollTop = element[scrollTop];
        if (touchMode && e.touches) e[pageY] = e.touches[0].pageY;
        startingMousePageY = e[pageY];
        scrollBy = (i[contentHeight] - i[containerHeight]) / (i[railYHeight] - i[scrollbarYHeight]);
        if (!touchMode) {
            i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
            i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
            e.preventDefault();
        } else i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
        i[scrollbarYRail].classList.add(cls.state.clicking);
        e.stopPropagation();
    }
    i.event.bind(i[scrollbarY], 'mousedown', function(e) {
        bindMoves(e);
    });
    i.event.bind(i[scrollbarY], 'touchstart', function(e) {
        bindMoves(e, true);
    });
}
function keyboard(i) {
    var element = i.element;
    var elementHovered = function elementHovered() {
        return matches(element, ':hover');
    };
    var scrollbarFocused = function scrollbarFocused() {
        return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus');
    };
    function shouldPreventDefault(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        if (deltaX === 0) {
            if (!i.scrollbarYActive) return false;
            if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) return !i.settings.wheelPropagation;
        }
        var scrollLeft = element.scrollLeft;
        if (deltaY === 0) {
            if (!i.scrollbarXActive) return false;
            if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) return !i.settings.wheelPropagation;
        }
        return true;
    }
    i.event.bind(i.ownerDocument, 'keydown', function(e) {
        if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) return;
        if (!elementHovered() && !scrollbarFocused()) return;
        var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
        if (activeElement) {
            if (activeElement.tagName === 'IFRAME') activeElement = activeElement.contentDocument.activeElement;
            else // go deeper if element is a webcomponent
            while(activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
            if (isEditable(activeElement)) return;
        }
        var deltaX = 0;
        var deltaY = 0;
        switch(e.which){
            case 37:
                if (e.metaKey) deltaX = -i.contentWidth;
                else if (e.altKey) deltaX = -i.containerWidth;
                else deltaX = -30;
                break;
            case 38:
                if (e.metaKey) deltaY = i.contentHeight;
                else if (e.altKey) deltaY = i.containerHeight;
                else deltaY = 30;
                break;
            case 39:
                if (e.metaKey) deltaX = i.contentWidth;
                else if (e.altKey) deltaX = i.containerWidth;
                else deltaX = 30;
                break;
            case 40:
                if (e.metaKey) deltaY = -i.contentHeight;
                else if (e.altKey) deltaY = -i.containerHeight;
                else deltaY = -30;
                break;
            case 32:
                if (e.shiftKey) deltaY = i.containerHeight;
                else deltaY = -i.containerHeight;
                break;
            case 33:
                deltaY = i.containerHeight;
                break;
            case 34:
                deltaY = -i.containerHeight;
                break;
            case 36:
                deltaY = i.contentHeight;
                break;
            case 35:
                deltaY = -i.contentHeight;
                break;
            default:
                return;
        }
        if (i.settings.suppressScrollX && deltaX !== 0) return;
        if (i.settings.suppressScrollY && deltaY !== 0) return;
        element.scrollTop -= deltaY;
        element.scrollLeft += deltaX;
        updateGeometry(i);
        if (shouldPreventDefault(deltaX, deltaY)) e.preventDefault();
    });
}
function wheel(i) {
    var element = i.element;
    function shouldPreventDefault(deltaX, deltaY) {
        var roundedScrollTop = Math.floor(element.scrollTop);
        var isTop = element.scrollTop === 0;
        var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
        var isLeft = element.scrollLeft === 0;
        var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
        var hitsBound;
        // pick axis with primary direction
        if (Math.abs(deltaY) > Math.abs(deltaX)) hitsBound = isTop || isBottom;
        else hitsBound = isLeft || isRight;
        return hitsBound ? !i.settings.wheelPropagation : true;
    }
    function getDeltaFromEvent(e) {
        var deltaX = e.deltaX;
        var deltaY = -1 * e.deltaY;
        if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
            // OS X Safari
            deltaX = -1 * e.wheelDeltaX / 6;
            deltaY = e.wheelDeltaY / 6;
        }
        if (e.deltaMode && e.deltaMode === 1) {
            // Firefox in deltaMode 1: Line scrolling
            deltaX *= 10;
            deltaY *= 10;
        }
        if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */ ) {
            // IE in some mouse drivers
            deltaX = 0;
            deltaY = e.wheelDelta;
        }
        if (e.shiftKey) // reverse axis with shift key
        return [
            -deltaY,
            -deltaX
        ];
        return [
            deltaX,
            deltaY
        ];
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        // FIXME: this is a workaround for <select> issue in FF and IE #571
        if (!env.isWebKit && element.querySelector('select:focus')) return true;
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains(cls.element.consuming)) return true;
            var style = get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function mousewheelHandler(e) {
        var ref = getDeltaFromEvent(e);
        var deltaX = ref[0];
        var deltaY = ref[1];
        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) return;
        var shouldPrevent = false;
        if (!i.settings.useBothWheelAxes) {
            // deltaX will only be used for horizontal scrolling and deltaY will
            // only be used for vertical scrolling - this is the default
            element.scrollTop -= deltaY * i.settings.wheelSpeed;
            element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
            // only vertical scrollbar is active and useBothWheelAxes option is
            // active, so let's scroll vertical bar using both mouse wheel axes
            if (deltaY) element.scrollTop -= deltaY * i.settings.wheelSpeed;
            else element.scrollTop += deltaX * i.settings.wheelSpeed;
            shouldPrevent = true;
        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
            // useBothWheelAxes and only horizontal bar is active, so use both
            // wheel axes for horizontal bar
            if (deltaX) element.scrollLeft += deltaX * i.settings.wheelSpeed;
            else element.scrollLeft -= deltaY * i.settings.wheelSpeed;
            shouldPrevent = true;
        }
        updateGeometry(i);
        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
        if (shouldPrevent && !e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    if (typeof window.onwheel !== 'undefined') i.event.bind(element, 'wheel', mousewheelHandler);
    else if (typeof window.onmousewheel !== 'undefined') i.event.bind(element, 'mousewheel', mousewheelHandler);
}
function touch(i) {
    if (!env.supportsTouch && !env.supportsIePointer) return;
    var element = i.element;
    function shouldPrevent(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        var scrollLeft = element.scrollLeft;
        var magnitudeX = Math.abs(deltaX);
        var magnitudeY = Math.abs(deltaY);
        if (magnitudeY > magnitudeX) {
            // user is perhaps trying to swipe up/down the page
            if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) // set prevent for mobile Chrome refresh
            return window.scrollY === 0 && deltaY > 0 && env.isChrome;
        } else if (magnitudeX > magnitudeY) {
            // user is perhaps trying to swipe left/right across the page
            if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) return true;
        }
        return true;
    }
    function applyTouchMove(differenceX, differenceY) {
        element.scrollTop -= differenceY;
        element.scrollLeft -= differenceX;
        updateGeometry(i);
    }
    var startOffset = {};
    var startTime = 0;
    var speed = {};
    var easingLoop = null;
    function getTouch(e) {
        if (e.targetTouches) return e.targetTouches[0];
        else // Maybe IE pointer
        return e;
    }
    function shouldHandle(e) {
        if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) return false;
        if (e.targetTouches && e.targetTouches.length === 1) return true;
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) return true;
        return false;
    }
    function touchStart(e) {
        if (!shouldHandle(e)) return;
        var _$touch = getTouch(e);
        startOffset.pageX = _$touch.pageX;
        startOffset.pageY = _$touch.pageY;
        startTime = new Date().getTime();
        if (easingLoop !== null) clearInterval(easingLoop);
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains(cls.element.consuming)) return true;
            var style = get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function touchMove(e) {
        if (shouldHandle(e)) {
            var _$touch = getTouch(e);
            var currentOffset = {
                pageX: _$touch.pageX,
                pageY: _$touch.pageY
            };
            var differenceX = currentOffset.pageX - startOffset.pageX;
            var differenceY = currentOffset.pageY - startOffset.pageY;
            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) return;
            applyTouchMove(differenceX, differenceY);
            startOffset = currentOffset;
            var currentTime = new Date().getTime();
            var timeGap = currentTime - startTime;
            if (timeGap > 0) {
                speed.x = differenceX / timeGap;
                speed.y = differenceY / timeGap;
                startTime = currentTime;
            }
            if (shouldPrevent(differenceX, differenceY)) e.preventDefault();
        }
    }
    function touchEnd() {
        if (i.settings.swipeEasing) {
            clearInterval(easingLoop);
            easingLoop = setInterval(function() {
                if (i.isInitialized) {
                    clearInterval(easingLoop);
                    return;
                }
                if (!speed.x && !speed.y) {
                    clearInterval(easingLoop);
                    return;
                }
                if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
                    clearInterval(easingLoop);
                    return;
                }
                applyTouchMove(speed.x * 30, speed.y * 30);
                speed.x *= 0.8;
                speed.y *= 0.8;
            }, 10);
        }
    }
    if (env.supportsTouch) {
        i.event.bind(element, 'touchstart', touchStart);
        i.event.bind(element, 'touchmove', touchMove);
        i.event.bind(element, 'touchend', touchEnd);
    } else if (env.supportsIePointer) {
        if (window.PointerEvent) {
            i.event.bind(element, 'pointerdown', touchStart);
            i.event.bind(element, 'pointermove', touchMove);
            i.event.bind(element, 'pointerup', touchEnd);
        } else if (window.MSPointerEvent) {
            i.event.bind(element, 'MSPointerDown', touchStart);
            i.event.bind(element, 'MSPointerMove', touchMove);
            i.event.bind(element, 'MSPointerUp', touchEnd);
        }
    }
}
var defaultSettings = function defaultSettings() {
    return {
        handlers: [
            'click-rail',
            'drag-thumb',
            'keyboard',
            'wheel',
            'touch'
        ],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1000,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1
    };
};
var handlers = {
    'click-rail': clickRail,
    'drag-thumb': dragThumb,
    keyboard: keyboard,
    wheel: wheel,
    touch: touch
};
var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$1 = this;
    if (userSettings === void 0) userSettings = {};
    if (typeof element === 'string') element = document.querySelector(element);
    if (!element || !element.nodeName) throw new Error('no element is specified to initialize PerfectScrollbar');
    this.element = element;
    element.classList.add(cls.main);
    this.settings = defaultSettings();
    for(var key in userSettings)this.settings[key] = userSettings[key];
    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;
    var focus = function focus() {
        return element.classList.add(cls.state.focus);
    };
    var blur = function blur() {
        return element.classList.remove(cls.state.focus);
    };
    this.isRtl = get(element).direction === 'rtl';
    if (this.isRtl === true) element.classList.add(cls.rtl);
    this.isNegativeScroll = function() {
        var originalScrollLeft = element.scrollLeft;
        var result = null;
        element.scrollLeft = -1;
        result = element.scrollLeft < 0;
        element.scrollLeft = originalScrollLeft;
        return result;
    }();
    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new EventManager();
    this.ownerDocument = element.ownerDocument || document;
    this.scrollbarXRail = div(cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = div(cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
    if (isNaN(this.scrollbarXBottom)) {
        this.isScrollbarXUsingBottom = false;
        this.scrollbarXTop = toInt(railXStyle.top);
    } else this.isScrollbarXUsingBottom = true;
    this.railBorderXWidth = toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
    // Set rail to display:block to calculate margins
    set(this.scrollbarXRail, {
        display: 'block'
    });
    this.railXMarginWidth = toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
    set(this.scrollbarXRail, {
        display: ''
    });
    this.railXWidth = null;
    this.railXRatio = null;
    this.scrollbarYRail = div(cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = div(cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);
    if (isNaN(this.scrollbarYRight)) {
        this.isScrollbarYUsingRight = false;
        this.scrollbarYLeft = toInt(railYStyle.left);
    } else this.isScrollbarYUsingRight = true;
    this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
    set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railYMarginHeight = toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
    set(this.scrollbarYRail, {
        display: ''
    });
    this.railYHeight = null;
    this.railYRatio = null;
    this.reach = {
        x: element.scrollLeft <= 0 ? 'start' : element.scrollLeft >= this.contentWidth - this.containerWidth ? 'end' : null,
        y: element.scrollTop <= 0 ? 'start' : element.scrollTop >= this.contentHeight - this.containerHeight ? 'end' : null
    };
    this.isAlive = true;
    this.settings.handlers.forEach(function(handlerName) {
        return handlers[handlerName](this$1);
    });
    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
    this.lastScrollLeft = element.scrollLeft; // for onScroll only
    this.event.bind(this.element, 'scroll', function(e) {
        return this$1.onScroll(e);
    });
    updateGeometry(this);
};
PerfectScrollbar.prototype.update = function update() {
    if (!this.isAlive) return;
    // Recalcuate negative scrollLeft adjustment
    this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
    // Recalculate rail margins
    set(this.scrollbarXRail, {
        display: 'block'
    });
    set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railXMarginWidth = toInt(get(this.scrollbarXRail).marginLeft) + toInt(get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight = toInt(get(this.scrollbarYRail).marginTop) + toInt(get(this.scrollbarYRail).marginBottom);
    // Hide scrollbars not to affect scrollWidth and scrollHeight
    set(this.scrollbarXRail, {
        display: 'none'
    });
    set(this.scrollbarYRail, {
        display: 'none'
    });
    updateGeometry(this);
    processScrollDiff(this, 'top', 0, false, true);
    processScrollDiff(this, 'left', 0, false, true);
    set(this.scrollbarXRail, {
        display: ''
    });
    set(this.scrollbarYRail, {
        display: ''
    });
};
PerfectScrollbar.prototype.onScroll = function onScroll(e) {
    if (!this.isAlive) return;
    updateGeometry(this);
    processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    processScrollDiff(this, 'left', this.element.scrollLeft - this.lastScrollLeft);
    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
};
PerfectScrollbar.prototype.destroy = function destroy() {
    if (!this.isAlive) return;
    this.event.unbindAll();
    remove(this.scrollbarX);
    remove(this.scrollbarY);
    remove(this.scrollbarXRail);
    remove(this.scrollbarYRail);
    this.removePsClasses();
    // unset elements
    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;
    this.isAlive = false;
};
PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
    this.element.className = this.element.className.split(' ').filter(function(name) {
        return !name.match(/^ps([-_].+|)$/);
    }).join(' ');
};
exports.default = PerfectScrollbar;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dP94b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _loginBoxCss = require("../../assets/css/login-box.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _reactRouterDom = require("react-router-dom");
var _appState = require("../../AppState");
var _userService = require("../../services/UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var _reactstrap = require("reactstrap");
var _clickstream = require("../Clickstream/Clickstream");
var _cognitoAuth = require("../../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _config = require("../../config");
var LogoutNavLink = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var logout = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var error, cookieDomain;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0, _clickstream.ClickstreamPush)(stateApp, {
                                "event_id": "clicked",
                                "event_target": "logout",
                                "event_data": {
                                    "category": "tria"
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).logout()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            (0, _userServiceDefault.default).logout()
                        ];
                    case 4:
                        _state.sent();
                        props.toggleSidebar();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        cookieDomain = (0, _cookieServiceDefault.default).getCookieDomain(stateApp.env);
                        (0, _cookieServiceDefault.default).eraseCookie("session_id", "/", cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie("session_timeout_time", "/", cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie("show_skylift", "/", cookieDomain);
                        stateAppActions.setLogout();
                        window.location.href = (0, _config.ACCOUNTS_URL);
                        return [
                            2
                        ];
                }
            });
        });
        return function logout(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.NavLink), {
            onClick: logout,
            style: {
                cursor: "pointer"
            },
            href: "#",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-sign-out-alt"
                }),
                " Logout"
            ]
        })
    });
};
exports.default = LogoutNavLink;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","../../assets/css/login-box.css":"3ywGJ","react":"gVheC","../../services/CookieService":"iKLPT","react-router-dom":"acq4R","../../AppState":"8UGXH","../../services/UserService":"4Rf9v","reactstrap":"774RE","../Clickstream/Clickstream":"9i4UV","../../utility/CognitoAuth":"cngmx","../../config":"kQzX9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ywGJ":[function() {},{}],"iKLPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CookieService = {
    setCookie: function setCookie(name, value, days, env) {
        var path = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
        var expires = "";
        var domain = '';
        if (days) {
            var envDomain = CookieService.getCookieDomain(env);
            if (envDomain != null) domain = "domain=".concat(envDomain);
        }
        if (path != "") expires = ";path=" + path;
        document.cookie = name + "=" + (value || "") + ";" + domain + expires;
    },
    getCookieDomain: function getCookieDomain(env) {
        //override for qa only to avoid env prod toggles
        if (window.location.hostname.indexOf('qa.') > -1) return '.qa.tria.connectria.com;';
        if (window.location.hostname.indexOf('sandbox.') > -1) return '.sandbox.tria.connectria.com;';
        if (window.location.hostname.indexOf('localhost') == -1) switch(env){
            case 'dev':
                return '.dev.tria.connectria.com;';
            case 'demo':
                return '.demo.tria.connectria.com;';
            case 'prod':
                return '.tria.connectria.com;';
            default:
                break;
        }
    },
    getCookie: function getCookie(name) {
        //fix for multiple cookies with the same name from different domains - return first one that has a value
        var rawCookies = document.cookie.match(new RegExp("".concat(name, "=([^;]*)"), "g"));
        if (rawCookies == null || rawCookies.length == 0) return null;
        for(var i = 0; i < rawCookies.length; i++){
            var v = rawCookies[i].substr(rawCookies[i].indexOf("="));
            if (v != null && v.length > 1) return v.substr(1);
        }
        return null;
    },
    eraseCookie: function eraseCookie(name) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", domain = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        var cookie = name + '=; Max-Age=-99999999';
        if (path) cookie += ";path=" + path;
        if (domain) cookie += ";domain=" + domain;
        document.cookie = cookie;
    },
    deleteAllCookies: function() {
        var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var cookies = document.cookie.split(";");
        for(var i = 0; i < cookies.length; i++){
            var cookie = cookies[i];
            if (prefix != null && cookie.toLowerCase().indexOf(prefix) == -1) continue;
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
};
exports.default = CookieService;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8UGXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appState", function() {
    return appState;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGlobalHook = require("./UseGlobalHook");
var _useGlobalHookDefault = parcelHelpers.interopDefault(_useGlobalHook);
var initialState = {
    env: 'prod',
    inboxCount: 0,
    account_id: null,
    clouds: [],
    cloudAccounts: [],
    roles: [],
    roles_v2: [],
    policies: [],
    cloud_type_id: null,
    date: null,
    pageNavTitle: "",
    pageBackTitle: "",
    notifications: {
        list: [],
        visible: false
    },
    alert: {
        className: "",
        content: "",
        color: "",
        visible: false
    },
    blade: {
        title: "",
        content: "",
        visible: false
    },
    contentBlade: {
        title: "",
        content: "",
        visible: false,
        side: "",
        style: null
    },
    authenticated: false,
    userInfo: null,
    organization: {},
    organizations: [],
    integrations: [],
    portalCustomerMeta: {},
    reload: 0,
    resourceProperties: {},
    superAdmin: false,
    sessionTimeoutTime: null,
    cache: {
        connectriaTicketCC: {
            loading: false,
            data: []
        },
        connectriaTicketCategories: {
            loading: false,
            data: []
        },
        connectriaTicketPreferences: {
            loading: false,
            data: []
        },
        connectriaTicketDevices: {
            loading: false,
            data: []
        },
        costSavings: {
            loading: true,
            data: []
        }
    },
    commserveTimeRange: null
};
var stateActions = {
    setCache: function(store, cache) {
        var updatedState = store.state.cache;
        updatedState[cache.key] = {
            loading: cache.loading || false,
            data: cache.data
        };
        store.setState({
            cache: updatedState
        });
    },
    setPageNavTitle: function(store, newTitle) {
        store.setState({
            pageNavTitle: newTitle
        });
    },
    setPageBackTitle: function(store, newTitle) {
        store.setState({
            pageBackTitle: newTitle
        });
    },
    setRoles: function(store, roles) {
        store.setState({
            roles: roles
        });
    },
    setRoles_v2: function(store, roles) {
        store.setState({
            roles_v2: roles
        });
    },
    setPolicies: function(store, policies) {
        store.setState({
            policies: policies
        });
    },
    setClouds: function(store, clouds) {
        store.setState({
            clouds: clouds
        });
    },
    setCloudAccounts: function(store, accounts) {
        store.setState({
            cloudAccounts: accounts
        });
    },
    setInboxCount: function(store, newCount) {
        store.setState({
            inboxCount: newCount
        });
    },
    setNotificationsList: function(store, list) {
        store.setState({
            notifications: (0, _objectSpreadProps._)((0, _objectSpread._)({}, store.state.notifications), {
                list: list
            })
        });
    },
    setNotificationsVisible: function(store, visible) {
        store.setState({
            notifications: (0, _objectSpreadProps._)((0, _objectSpread._)({}, store.state.notifications), {
                visible: visible
            })
        });
    },
    setBlade: function(store, newBladeState) {
        store.setState({
            blade: newBladeState
        });
    },
    setContentBlade: function(store, newContentBladeState) {
        store.setState({
            contentBlade: newContentBladeState
        });
    },
    setAlert: function(store, newAlertState) {
        store.setState({
            alert: newAlertState
        });
    },
    setLogout: function(store) {
        //reset UI state
        store.setState({
            blade: initialState.blade
        });
        store.setState({
            alert: initialState.alert
        });
        store.setState({
            userInfo: initialState.userInfo
        });
        store.setState({
            authenticated: false
        });
        store.setState({
            organization: initialState.organization
        });
        store.setState({
            organizations: []
        });
        store.setState({
            reload: 0
        });
    },
    setAuthenticated: function(store, userInfo) {
        store.setState({
            authenticated: true
        });
        store.setState({
            userInfo: userInfo
        });
    },
    setOrganization: function(store, org) {
        store.setState({
            organization: org
        });
    },
    setOrganizations: function(store, organizations) {
        store.setState({
            organizations: organizations
        });
    },
    setIntegrations: function(store, integrations) {
        store.setState({
            integrations: integrations
        });
    },
    setPortalCustomerMeta: function(store, metadata) {
        if (metadata.meta_key == null) return;
        store.setState({
            portalCustomerMeta: (0, _objectSpreadProps._)((0, _objectSpread._)({}, store.state.portalCustomerMeta), (0, _defineProperty._)({}, metadata.meta_key.toLowerCase(), metadata.meta_value))
        });
    },
    setReload: function(store) {
        store.setState({
            reload: store.state.reload + 1
        });
    },
    setCloudAccount: function(store, cloud_type_id, account_id) {
        store.setState({
            cloud_type_id: cloud_type_id,
            account_id: account_id
        });
    },
    setDate: function(store, date) {
        store.setState({
            date: date
        });
    },
    setSessionTimeoutTime: function(store, time) {
        store.setState({
            sessionTimeoutTime: time
        });
    },
    setCommserveTimeRange: function(store, timeRange) {
        store.setState({
            commserveTimeRange: timeRange
        });
    },
    setSuperAdmin: function(store, value) {
        store.setState({
            superAdmin: value
        });
    },
    setResourceProperties: function(store, properties) {
        store.setState({
            resourceProperties: properties
        });
    }
};
var appState = (0, _useGlobalHookDefault.default)((0, _reactDefault.default), initialState, stateActions);

},{"@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","react":"gVheC","./UseGlobalHook":"l0Rs8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0Rs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
function setState(store, newState, afterUpdateCallback) {
    store.state = (0, _objectSpread._)({}, store.state, newState);
    store.listeners.forEach(function(listener) {
        listener.run(store.state);
    });
    afterUpdateCallback && afterUpdateCallback();
}
function useCustom(store, React, mapState, mapActions) {
    var _React_useState = (0, _slicedToArray._)(React.useState(Object.create(null)), 2), originalHook = _React_useState[1];
    var state = mapState ? mapState(store.state) : store.state;
    var actions = React.useMemo(function() {
        return mapActions ? mapActions(store.actions) : store.actions;
    }, [
        mapActions,
        store.actions
    ]);
    React.useEffect(function() {
        var newListener = {
            oldState: {}
        };
        newListener.run = mapState ? function(newState) {
            var mappedState = mapState(newState);
            if (mappedState !== newListener.oldState) {
                newListener.oldState = mappedState;
                originalHook(mappedState);
            }
        } : originalHook;
        store.listeners.push(newListener);
        newListener.run(store.state);
        return function() {
            store.listeners = store.listeners.filter(function(listener) {
                return listener !== newListener;
            });
        };
    }, []); // eslint-disable-line
    return [
        state,
        actions
    ];
}
function associateActions(store) {
    var actions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var associatedActions = {};
    Object.keys(actions).forEach(function(key) {
        if (typeof actions[key] === "function") associatedActions[key] = actions[key].bind(null, store);
        if ((0, _typeOf._)(actions[key]) === "object") associatedActions[key] = associateActions(store, actions[key]);
    });
    return associatedActions;
}
var useStore = function(React, initialState, actions, initializer) {
    var store = {
        state: initialState,
        listeners: []
    };
    store.setState = setState.bind(null, store);
    store.actions = associateActions(store, actions);
    if (initializer) initializer(store);
    return useCustom.bind(null, store, React);
};
exports.default = useStore;

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Rf9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var base_api = 'https://tria.connectria.com';
var UserService = {
    cognitoDivvyAuth: function cognitoDivvyAuth(token, customer_id) {
        var data = {
            token: token,
            customer_id: customer_id
        };
        return (0, _axiosDefault.default).post(base_api + "/plugin/tria_interface/cognito/auth", data);
    },
    login: function login(email, password) {
        var request = (0, _axiosDefault.default).post(base_api + "/v2/public/user/login", {
            username: email,
            password: password
        });
        return request;
    },
    user_info: function user_info() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/v2/public/user/info", options);
        return request;
    },
    logout: function logout() {
        return (0, _axiosDefault.default).post(base_api + "/v2/public/user/logout");
    },
    enable_mfa: function enable_mfa(payload) {
        return (0, _axiosDefault.default).post(base_api + "/v2/public/user/tfa_enable", payload);
    },
    disable_mfa: function disable_mfa(payload) {
        return (0, _axiosDefault.default).post(base_api + "/plugin/tria_interface/user/tfa_disable", payload);
    },
    set_mfa_required: function set_mfa_required(payload) {
        return (0, _axiosDefault.default).post(base_api + "/plugin/tria_interface/user/set_tfa_required", payload);
    },
    iniate: function iniate(username) {
        return (0, _axiosDefault.default).post(base_api + "/v3/auth/initiate", {
            username: username
        });
    },
    local_login: function local_login(password, token) {
        return (0, _axiosDefault.default).post(base_api + "/v3/auth/provider/local", {
            password: password,
            token: token
        });
    },
    verify_mfa: function verify_mfa(mfa_code, token) {
        return (0, _axiosDefault.default).post(base_api + "/v3/auth/tfa/verify", {
            tfa_token: mfa_code,
            token: token
        });
    },
    get_session_timeout_time: function get_session_timeout_time() {
        return (0, _axiosDefault.default).get(base_api + "/plugin/tria_interface/session/expiration");
    },
    save_user_session: function save_user_session() {
        return (0, _axiosDefault.default).get(base_api + "/plugin/tria_interface/session/save");
    }
};
exports.default = UserService;

},{"axios":"ebRwi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9i4UV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickstreamPush", function() {
    return ClickstreamPush;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _routesJs = require("../../routes.js");
var _routesJsDefault = parcelHelpers.interopDefault(_routesJs);
var _routerHookJs = require("../../hooks/RouterHook.js");
var _routerHookJsDefault = parcelHelpers.interopDefault(_routerHookJs);
var _clickstreamServiceJs = require("../../services/ClickstreamService.js");
var _clickstreamServiceJsDefault = parcelHelpers.interopDefault(_clickstreamServiceJs);
var _appState = require("../../AppState");
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _index = require("axios/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _cognitoAuth = require("../../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var feature_toggle = "FEATURE_TOGGLE_CLICKSTREAM_TRUE";
function ClickstreamPush(stateApp, meta, pathName) {
    return _ClickstreamPush.apply(this, arguments);
}
function _ClickstreamPush() {
    _ClickstreamPush = (0, _asyncToGenerator._)(function(stateApp, meta, pathName) {
        var uid, sid, t, event_id, event_target, eData, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (feature_toggle !== "FEATURE_TOGGLE_CLICKSTREAM_TRUE") return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    uid = 0;
                    sid = "";
                    if (stateApp.userInfo != null && stateApp.userInfo.user_id != null) uid = stateApp.userInfo.user_id;
                    else uid = 0;
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getAccessTokenDecoded()
                    ];
                case 2:
                    t = _state.sent();
                    sid = t.jti || "Empty";
                    //default event data
                    event_id = "visited";
                    event_target = pathName !== null && pathName !== void 0 ? pathName : "n/a";
                    //check for meta overrides
                    if (meta != null && meta.event_id != null) event_id = meta.event_id;
                    if (meta != null && meta.event_target != null) event_target = meta.event_target;
                    //add current route to event_data
                    eData = {};
                    if (meta != null && meta.event_data != null) eData = meta.event_data;
                    eData["route"] = pathName !== null && pathName !== void 0 ? pathName : "n/a";
                    return [
                        4,
                        (0, _clickstreamServiceJsDefault.default).push(uid, sid, event_id, eData, event_target)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _ClickstreamPush.apply(this, arguments);
}
var Clickstream = function(props) {
    var router = (0, _routerHookJsDefault.default)();
    var source = (0, _indexDefault.default).CancelToken.source();
    //app state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isMounted()) return [
                            2
                        ];
                        return [
                            4,
                            ClickstreamPush(stateApp, props.meta, router.pathname)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.children
    });
};
exports.default = Clickstream;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../../routes.js":"bvYZI","../../hooks/RouterHook.js":"dp8pl","../../services/ClickstreamService.js":"27qTH","../../AppState":"8UGXH","../../services/CookieService":"iKLPT","../../utility/use-async-effect":"fShZN","axios/index":"ebRwi","../../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bvYZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routes", function() {
    return routes;
});
parcelHelpers.export(exports, "dashBoardConfig", function() {
    return dashBoardConfig;
});
parcelHelpers.export(exports, "dashBoardConfigIbmi", function() {
    return dashBoardConfigIbmi;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _enumJs = require("./utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
var _dashboardJsx = require("./views/Dashboard.jsx");
var _dashboardJsxDefault = parcelHelpers.interopDefault(_dashboardJsx);
// import { IBMiLparMonitorDesktopWidget } from './components/IBMiDashboard/IBMiDashboard.jsx';
// import { BlueMatadorWidget } from './components/BlueMatadorDashboard/BlueMatadorDashboard.jsx';
// import { CloudWatchAlarmsWidget } from './components/CloudWatch/CloudWatchAlarmsDashboard.jsx';
// import { AzureAlertsWidget } from './components/AzureAlerts/AzureAlertsDashboard.jsx';
// import { CostSavingsCard } from './costexplorer/components/CostSavingsWidget.jsx';
// import { DevicesWidget } from './components/Devices/DevicesDashboard.jsx';
// import { TrendMicroWidget } from './components/TrendMicro/TrendMicroDashboard.jsx';
// import { ComplianceDashboardCard } from './components/Compliance/ComplianceDashboardCard.jsx';
// import { SecurityAdvisorWidget } from './public_cloud/components/SecurityAdvisorDashboard.jsx';
var _featureToggleJs = require("./utility/FeatureToggle.js");
var _featureToggleJsDefault = parcelHelpers.interopDefault(_featureToggleJs);
var _connectriaTicketsDashboardJsx = require("./components/ConnectriaTickets/ConnectriaTicketsDashboard.jsx");
var _ibmcartCardJsx = require("./components/IBMiCart/IBMCartCard.jsx");
var _backupsDashboardCardJsx = require("./components/BackupJobs/BackupsDashboardCard.jsx");
var _upsellCardContainer = require("./components/Upsell/UpsellCardContainer");
var _upsellCardContainerDefault = parcelHelpers.interopDefault(_upsellCardContainer);
var _resourcesOverview = require("./components/ResourceManagement/ResourcesOverview");
var _resourcesOverviewDefault = parcelHelpers.interopDefault(_resourcesOverview);
var _backupSingleJobJsx = require("./components/BackupJobs/BackupSingleJob.jsx");
var _deviceDetailPage = require("./components/Devices/DeviceDetailPage");
var _config = require("./config");
var _legacyComplianceUrl = 'https://tria.connectria.com/insights/saved?hideside&order=-severity';
var _legacyResourceUrl = 'https://tria.connectria.com/resources?hideside';
var _legacyBotUrl = 'https://tria.connectria.com/bots/listing?hideside';
var _legacyBotTemplatesUrl = 'https://tria.connectria.com/bots/templates?hideside';
var _legacyBotCreateUrl = 'https://tria.connectria.com/bots/factory?hideside';
var _legacyTriaTaggingUrl = 'https://tria.connectria.com/tag-manager/tag-analyzer?hideside';
var _legacyDTaggingUrl = 'https://tria.connectria.com/tags/saved?hideside';
var _legacyTriaResourceGroupsUrl = 'https://tria.connectria.com/groups?hideside';
var _legacyTriaComplianceScorecardUrl = 'https://tria.connectria.com/compliance/summary/scorecard?hideside';
var _legacyExemptionsUrl = 'https://tria.connectria.com/exemptions/list?hideside';
var isNextGen = window.location.hostname.startsWith('next-gen');
// lazy loaded dashboard components
var IBMiLparMonitorDesktopWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("89668153401b312b");
});
var BlueMatadorWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("6653cfba345987fe");
});
var CloudWatchAlarmsWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("bde9fc94ee325088");
});
var AzureAlertsWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("4715d89be92da210");
});
var CostSavingsCard = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("1f19d4cd8c2890b2");
});
var DevicesWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("2d77583756c0c8f1");
});
var TrendMicroWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("fd3a2574f275db14");
});
var ComplianceDashboardCard = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("de390de75ac7a779");
});
var SecurityAdvisorWidget = /*#__PURE__*/ (0, _reactDefault.default).lazy(function() {
    return require("b0ae776c0956f9c3");
});
var routes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'fad fa-fw fa-th-large',
        component: (0, _dashboardJsxDefault.default),
        layout: '/app',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        clickstreamMeta: {
            event_id: 'visited',
            event_target: 'tria-dashboard',
            event_data: {
                category: 'tria'
            }
        }
    },
    {
        group: 'Resources',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.RESOURCES_VIEW
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'fab fa-uncharted',
        routes: [
            {
                path: '/resource-management',
                name: 'Resource Management',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.RESOURCES_VIEW
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("60d6533973573781");
                }),
                layout: '/app',
                exact: true
            }
        ]
    },
    // {
    //   group: "Clouds",
    //   envs: [Enum.Env.ALL],
    //   clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //   icon: "fal fa-clouds",
    //   routes: [
    //     {
    //       path: "/clouds/listing",
    //       name: "Cloud List",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD, Enum.CloudCategory.VMWARE],
    //       icon: "fas fa-cloud",
    //       component: CloudsListing,
    //       layout: "/app"
    //     },
    //     {
    //       path: "/cloud/resources",
    //       name: "Cloud Resources",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-cloud",
    //       props: {url: _legacyResourceUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: false
    //     },
    //     {
    //       path: "/cloud/groups",
    //       name: "Resource Groups",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-layer-group",
    //       props: {url: _legacyTriaResourceGroupsUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: false
    //     },
    //     {
    //       path: "/tag/explorer",
    //       name: "Tag Explorer",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-user-tag",
    //       props: {url: _legacyDTaggingUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: false
    //     },
    //     {
    //       path: "/tag/analyzer",
    //       name: "Tag Analyzer",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-tags",
    //       props: {url: _legacyTriaTaggingUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: false
    //     },
    /*{
        path: "/cloud/cost/:cloud_id/:account_id",
        name: "Cloud Cost Dashboard",
        envs: [Enum.Env.DEV],
        clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
        rtlName: "لوحة القيادة",
        icon: "tim-icons icon-chart-pie-36",
        component: CostResourceDashboard,
        layout: "/app",
        suppress: true  
      },*/ //     {
    //       path: "/cloud/bots_listing",
    //       name: "Bot Factory",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-robot",
    //       props: {url: _legacyBotUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: true
    //     },
    //       {
    //       path: "/cloud/bots_templates",
    //       name: "Bot Factory",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-robot",
    //       props: {url: _legacyBotTemplatesUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: true
    //     },
    //     {
    //       path: "/cloud/exemptions",
    //       name: "Exemptions",
    //       envs: [Enum.Env.ALL],
    //       clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //       rtlName: "لوحة القيادة",
    //       icon: "fas fa-table",
    //       props: {url: _legacyExemptionsUrl},
    //       component: LegacyFrame,
    //       iframe: true,
    //       layout: "/app",
    //       suppress: true
    //     },
    //   ]
    // },
    {
        group: 'Performance',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.MANAGED_DEVICE_VIEW,
            (0, _enumJsDefault.default).Policies.VIEW_LPAR,
            (0, _enumJsDefault.default).Policies.VIEW_CLOUD_MON,
            (0, _enumJsDefault.default).Policies.VIEW_CLOUD_ALARMS,
            ,
            (0, _enumJsDefault.default).Policies.VIEW_BACKUP
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-tachometer-alt-fastest',
        routes: [
            {
                path: '/devices',
                name: 'Managed Devices',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.MANAGED_DEVICE_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-life-ring',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("84dc0a1c930e8d32");
                }),
                layout: '/app',
                exact: true,
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'devices',
                    event_data: {
                        category: 'support'
                    }
                }
            },
            {
                path: '/devices/:id',
                name: 'Node Detail',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.MANAGED_DEVICE_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: (0, _deviceDetailPage.DeviceDetailPage),
                layout: '/app'
            },
            {
                path: '/ibm-dashboard',
                name: 'IBM i LPARs',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_LPAR
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.IBMI
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-server',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("28c15e82a960ad72");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ibmi-dashboard',
                    event_data: {
                        category: 'ibmi'
                    }
                }
            },
            {
                path: '/ibm/host/report/:id',
                name: 'IBM i Report',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_LPAR
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.IBMI
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("75402d1164c544e7");
                }),
                layout: '/app',
                suppress: true,
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ibmi-report',
                    event_data: {
                        category: 'ibmi'
                    }
                }
            },
            {
                path: '/ibm/host/:id',
                name: 'Dashboard',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_LPAR
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.IBMI
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("4e382f3e3224651b");
                }),
                layout: '/app',
                suppress: true,
                key: 'ibm-host-dashboard',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ibmi-host-dashboard',
                    event_data: {
                        category: 'ibmi'
                    }
                }
            },
            {
                path: '/cloud/monitoring',
                name: 'Cloud Monitor',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_CLOUD_MON
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                integrations: [
                    (0, _enumJsDefault.default).Integration.BLUEMATADOR
                ],
                rtlName: "\u0627\u0631 \u062A\u064A \u0627\u0644",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("5e52fa6bbbc632e2");
                }),
                layout: '/app',
                key: 'bluematador-events-inbox',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'bluematador-events-inbox',
                    event_data: {
                        category: 'bluematador'
                    }
                }
            },
            {
                path: '/cloud/cloudwatch',
                name: 'AWS Cloud Alarms',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.AWS
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_CLOUD_ALARMS
                ],
                // integrations: [Enum.Integration.CLOUDWATCH],
                rtlName: "\u0627\u0631 \u062A\u064A \u0627\u0644",
                icon: 'fas fa-bell',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("62b9439f43803c21");
                }),
                layout: '/app',
                key: 'cloudwatch-alarms',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'cloudwatch-alarms',
                    event_data: {
                        category: 'cloudwatch'
                    }
                }
            },
            {
                path: '/cloud/azure-alerts',
                name: 'Azure Monitor',
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_CLOUD_ALARMS
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.AZURE
                ],
                rtlName: "\u0627\u0631 \u062A\u064A \u0627\u0644",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("f4d0c35c07cab585");
                }),
                layout: '/app',
                key: 'azure-alerts',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'azure-alerts',
                    event_data: {
                        category: 'azure'
                    }
                }
            },
            {
                path: '/backup',
                name: 'Backup Jobs',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_BACKUP
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.VMWARE
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-life-ring',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("164f27d3ea6ae4f8");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'backup client',
                    event_data: {
                        category: 'backup'
                    }
                }
            },
            {
                path: '/view/backup/jobs/client/:id',
                name: 'Backup Jobs',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_BACKUP
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("d5f8032b0124d90");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'backup-jobs',
                    event_data: {
                        category: 'backup'
                    }
                }
            },
            {
                path: '/view/backup/job/:id/:status',
                name: 'Backup Job',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.VIEW_BACKUP
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: (0, _backupSingleJobJsx.BackupSingleJob),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'backup-job',
                    event_data: {
                        category: 'backup'
                    }
                }
            }
        ]
    },
    {
        group: 'Spend',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.SPEND_VIEW
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
        ],
        icon: 'fal fa-usd-circle',
        routes: [
            {
                path: '/cloud/cost/dashboard',
                name: 'Spend Dashboard',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SPEND_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("54ae782f73a3745b");
                }),
                layout: '/app',
                suppress: false
            },
            {
                path: '/cloud/cost/spend-resources',
                name: 'Spend By Resources',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SPEND_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("f052b2c31c435c6d");
                }),
                layout: '/app',
                suppress: false
            },
            {
                path: '/cloud/cost/spend-by-tags-report',
                name: 'Spend By Tags',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SPEND_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("624ec929c2224d53");
                }),
                layout: '/app',
                suppress: false
            },
            {
                path: '/cloud/savings/dashboard',
                name: 'Cloud Savings Dashboard',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SPEND_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("ca238d40d2a328ab");
                }),
                layout: '/app',
                suppress: true
            }
        ]
    },
    {
        group: 'Security',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.SECURITY_VIEW,
            (0, _enumJsDefault.default).Policies.MALWARE_VIEW
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD,
            (0, _enumJsDefault.default).CloudCategory.VMWARE
        ],
        icon: 'far fa-shield-alt',
        routes: [
            {
                path: '/anti-malware/events',
                name: 'Anti Malware',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.MALWARE_VIEW
                ],
                integrations: [
                    (0, _enumJsDefault.default).Integration.TRENDMICRO
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-shield-alt',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("dff6e79d99162479");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'anti-malware-events',
                    event_data: {
                        category: 'security'
                    }
                }
            },
            {
                path: '/cloud/aws-security-advisor',
                name: 'AWS Security',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SECURITY_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.AWS
                ],
                rtlName: "\u0627\u0631 \u062A\u064A \u0627\u0644",
                icon: 'fas fa-shield-alt',
                props: {
                    cloudType: 'AWS'
                },
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("942d4a165668fe94");
                }),
                layout: '/app',
                key: 'aws-security-advisor',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'aws-security-advisor',
                    event_data: {
                        category: 'cloud'
                    }
                }
            },
            {
                path: '/cloud/azure-security-advisor',
                name: 'Azure Security',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.SECURITY_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.AZURE
                ],
                rtlName: "\u0627\u0631 \u062A\u064A \u0627\u0644",
                icon: 'fas fa-shield-alt',
                props: {
                    cloudType: 'AZURE'
                },
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("942d4a165668fe94");
                }),
                layout: '/app',
                key: 'security-advisor',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'azure-security-advisor',
                    event_data: {
                        category: 'cloud'
                    }
                }
            }
        ]
    },
    {
        group: 'Compliance',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.COMPLIANCE_VIEW
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
        ],
        icon: 'far fa-user-shield',
        routes: [
            {
                path: '/compliance',
                name: 'Compliance Management',
                policy: [
                    (0, _enumJsDefault.default).Policies.COMPLIANCE_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                ],
                icon: 'tim-icons icon-chart-pie-36',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("d9b7b9be09287196");
                }),
                layout: '/app',
                suppress: false
            }
        ]
    },
    {
        group: 'Notifications',
        policy: [
            (0, _enumJsDefault.default).Policies.NOTIFICATIONS_VIEW
        ],
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'far fa-bell',
        routes: [
            {
                path: '/notifications',
                name: 'Notification Explorer',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.NOTIFICATIONS_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("3c52ced108750191");
                }),
                layout: '/app',
                exact: true
            }
        ]
    },
    {
        group: 'Runbooks',
        envs: [
            (0, _enumJsDefault.default).Env.DEV,
            (0, _enumJsDefault.default).Env.LOCAL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.RUNBOOKS_VIEW
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'far fa-book-spells',
        routes: [
            {
                path: '/runbooks',
                name: 'Runbook Management',
                policy: [
                    (0, _enumJsDefault.default).Policies.RUNBOOKS_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.DEV,
                    (0, _enumJsDefault.default).Env.LOCAL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("e79fe12b711e285d");
                }),
                layout: '/app',
                exact: true
            },
            {
                path: '/runbook/new',
                name: 'Create Runbook',
                policy: [
                    (0, _enumJsDefault.default).Policies.RUNBOOKS_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.DEV,
                    (0, _enumJsDefault.default).Env.LOCAL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("72b91447f922f561");
                }),
                layout: '/app',
                exact: true,
                suppress: true
            },
            {
                path: '/runbook/:id',
                name: 'Runbook Detail',
                policy: [
                    (0, _enumJsDefault.default).Policies.RUNBOOKS_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.DEV,
                    (0, _enumJsDefault.default).Env.LOCAL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("72b91447f922f561");
                }),
                layout: '/app',
                suppress: true
            }
        ]
    },
    // {
    //   path: "/cloud/bots_create",
    //   name: "Bot Factory",
    //   envs: [Enum.Env.ALL],
    //   clouds: [Enum.CloudCategory.PUBLIC_CLOUD],
    //   rtlName: "لوحة القيادة",
    //   icon: "fas fa-robot",
    //   props: {url: _legacyBotCreateUrl},
    //   component: LegacyFrame,
    //   iframe: true,
    //   layout: "/app",
    //   suppress: true
    // },
    {
        group: 'Automation',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        policy: [
            (0, _enumJsDefault.default).Policies.AUTOMATION_VIEW
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fas fa-life-ring',
        resourceProperty: 'autoops',
        routes: [
            {
                path: '/automation/ops',
                name: 'Auto Ops',
                policy: [
                    (0, _enumJsDefault.default).Policies.AUTOMATION_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("cce548b58636037e");
                }),
                layout: '/app',
                exact: true
            },
            {
                path: '/automation/ops/new',
                name: 'Ops Configuration',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.AUTOMATION_MANAGE
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                exact: true,
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("3978b0b0e4a50033");
                }),
                layout: '/app'
            },
            {
                path: '/automation/ops/:id',
                name: 'Ops Configuration',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.AUTOMATION_MANAGE
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("a62ca327b8e1a539");
                }),
                layout: '/app'
            }
        ]
    },
    {
        group: 'Report (Beta)',
        policy: [
            (0, _enumJsDefault.default).Policies.REPORT_VIEW
        ],
        // roles: [Enum.Roles.superAdmin],
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'far fa-file-spreadsheet',
        routes: [
            {
                path: '/environment-report',
                name: 'Environment Report',
                policy: [
                    (0, _enumJsDefault.default).Policies.REPORT_VIEW
                ],
                // roles: [Enum.Roles.superAdmin],
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("428d88d694911143");
                }),
                layout: '/app',
                exact: true
            }
        ]
    },
    {
        group: 'Ticketing & Support',
        policy: [
            (0, _enumJsDefault.default).Policies.TICKETS_VIEW,
            (0, _enumJsDefault.default).Policies.AWS_SUPPORT_TICKETS
        ],
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-headset',
        routes: [
            {
                path: '/support',
                name: 'Support and Ticketing',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-life-ring',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("19b53f705932443e");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ticketing-dashboard',
                    event_data: {
                        category: 'support'
                    }
                }
            },
            {
                path: '/aws-support',
                name: 'AWS Support Tickets',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.AWS
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.AWS_SUPPORT_TICKETS
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fas fa-ticket',
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("b690e9f01e504e4c");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'aws-support-tickets',
                    event_data: {
                        category: 'support'
                    }
                }
            },
            {
                path: '/view/ticket/:id',
                name: 'Ticketing Detail',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("f7bdaa690ef681f7");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ticketing-detail-view',
                    event_data: {
                        category: 'support'
                    }
                }
            },
            {
                path: '/create-ticket',
                name: 'Create Ticket',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                policy: [
                    (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                suppress: true,
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("dc7715ac3875c733");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'create-ticket-view',
                    event_data: {
                        category: 'support'
                    }
                }
            },
            // {
            //   path: "/cloud/aws-tickets",
            //   name: "AWS Support Tickets",
            //   envs: [Enum.Env.ALL],
            //   clouds: [Enum.CloudCategory.AWS],
            //   rtlName: "ار تي ال",
            //   icon: "fas fa-list",
            //   component: AWSTickets,
            //   layout: "/app",
            //   key: "aws-tickets",
            //   clickstreamMeta: {
            //     "event_id": "visited",
            //     "event_target": "aws-tickets",
            //     "event_data": {
            //       "category": "aws"
            //     }
            //   }
            // },
            {
                path: '/tickets',
                name: 'Ticketing',
                policy: [
                    (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                ],
                envs: [
                    (0, _enumJsDefault.default).Env.DEV
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("eac2b23080c5c10a");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'ticketing-page',
                    event_data: {
                        category: 'support'
                    }
                }
            }
        ]
    },
    {
        group: 'Contact Us',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
        icon: 'fal fa-phone-volume',
        routes: [
            {
                path: '/contact',
                name: 'Contact Us',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("759f1cbb6368ab7f");
                }),
                layout: '/app',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'contact-us',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            }
        ]
    },
    {
        group: 'Accounts & Settings',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-user-friends',
        routes: [
            {
                url: (0, _config.ACCOUNTS_URL) + '/account/profile',
                name: 'Profile',
                key: 'profile',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                isExternal: true
            },
            {
                path: '/invoices',
                policy: [
                    (0, _enumJsDefault.default).Policies.BILLING_VIEW
                ],
                name: 'Invoices',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                component: /*#__PURE__*/ (0, _react.lazy)(function() {
                    return require("e34719340fd3db6e");
                }),
                layout: '/app',
                key: 'invoices',
                clickstreamMeta: {
                    event_id: 'visited',
                    event_target: 'invoices',
                    event_data: {
                        category: 'invoices'
                    }
                }
            },
            {
                url: (0, _config.ACCOUNTS_URL) + '/account/organization',
                name: 'Organization',
                key: 'organization',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                isExternal: true
            }
        ]
    },
    {
        group: 'Docs & References',
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-book-spells',
        routes: [
            {
                url: 'https://docs.next-gen.tria.connectria.com',
                name: 'Documentation',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                icon: 'fal fa-external-link-alt',
                isExternal: true,
                clickstreamMeta: {
                    event_id: 'clicked',
                    event_target: 'documentation',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            },
            {
                url: 'https://www.connectria.com/terms-conditions',
                name: 'Legal',
                envs: [
                    (0, _enumJsDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumJsDefault.default).CloudCategory.ALL
                ],
                icon: 'fal fa-external-link-alt',
                isExternal: true,
                clickstreamMeta: {
                    event_id: 'clicked',
                    event_target: 'terms-conditions',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            }
        ]
    },
    {
        name: 'Cloud properties export',
        path: '/admin-tools/export-cloud-properties',
        component: /*#__PURE__*/ (0, _react.lazy)(function() {
            return require("734481b16c239f1c");
        }),
        envs: [
            (0, _enumJsDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumJsDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-cloud-download',
        layout: '/app',
        exact: true,
        suppress: true
    }
];
var dashBoardConfigIbmi = [
    {
        equalHeightCards: false,
        cards: [
            {
                className: 'col-md-12 d-none d-md-block',
                title: 'Resource Management',
                noCard: true,
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.RESOURCES_VIEW
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourcesOverviewDefault.default), {})
                    })
                ]
            }
        ]
    },
    {
        equalHeightCards: false,
        policies: [
            (0, _enumJsDefault.default).Policies.TICKETS_VIEW
        ],
        cards: [
            {
                className: 'col-md-8 d-none d-md-block',
                title: 'Ticketing',
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsDashboardJsx.ConnectriaTicketsDashboardTab), {})
                    })
                ]
            },
            {
                nestedConfig: [
                    {
                        className: 'col-md-4',
                        equalHeightCards: false,
                        cards: [
                            {
                                className: 'col-md-12',
                                title: 'Security & Compliance at a Glance',
                                components: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [
                                            (0, _enumJsDefault.default).Policies.SECURITY_VIEW
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.ALL
                                        ],
                                        integrations: [
                                            (0, _enumJsDefault.default).Integration.TRENDMICRO
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrendMicroWidget, {})
                                    })
                                ]
                            }
                        ]
                    },
                    {
                        equalHeightCards: false,
                        cards: [
                            {
                                className: 'col-md-12',
                                title: 'Operation & Performance at a Glance',
                                components: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [
                                            (0, _enumJsDefault.default).Policies.VIEW_LPAR
                                        ],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.IBMI
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IBMiLparMonitorDesktopWidget, {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [
                                            (0, _enumJsDefault.default).Policies.MANAGED_DEVICE_VIEW
                                        ],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.ALL
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DevicesWidget, {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [
                                            (0, _enumJsDefault.default).Policies.VIEW_BACKUP
                                        ],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.VMWARE
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backupsDashboardCardJsx.BackupsDashboardCard), {})
                                    })
                                ]
                            }
                        ]
                    },
                    {
                        equalHeightCards: false,
                        cards: [
                            {
                                className: 'col-sm-12',
                                noCard: true,
                                components: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.ALL
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upsellCardContainerDefault.default), {})
                                    })
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
var dashBoardConfig = [
    {
        equalHeightCards: false,
        cards: [
            {
                className: 'col-md-12 d-none d-md-block',
                title: 'Resource Management',
                noCard: true,
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.RESOURCES_VIEW
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourcesOverviewDefault.default), {})
                    })
                ]
            }
        ]
    },
    {
        equalHeightCards: true,
        cards: [
            {
                className: 'col-sm-12 col-lg-4',
                title: 'Cost Optimization at a Glance',
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.SPEND_VIEW
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CostSavingsCard, {})
                    })
                ]
            },
            {
                className: 'col-sm-12 col-lg-4',
                title: 'Security & Compliance at a Glance',
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.COMPLIANCE_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComplianceDashboardCard, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.MALWARE_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        integrations: [
                            (0, _enumJsDefault.default).Integration.TRENDMICRO
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrendMicroWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.SECURITY_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.AWS
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurityAdvisorWidget, {
                            cloudType: "AWS"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.SECURITY_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.AZURE
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecurityAdvisorWidget, {
                            cloudType: "AZURE"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_LPAR
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.DEV,
                            (0, _enumJsDefault.default).Env.DEMO
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.IBMI
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ibmcartCardJsx.IBMCartCard), {})
                    })
                ]
            },
            {
                className: 'col-sm-12 col-lg-4',
                title: 'Operation & Performance at a Glance',
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_CLOUD_MON
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        integrations: [
                            (0, _enumJsDefault.default).Integration.BLUEMATADOR
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlueMatadorWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_CLOUD_ALARMS
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.AWS
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        integrations: [
                            (0, _enumJsDefault.default).Integration.CLOUDWATCH
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloudWatchAlarmsWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_CLOUD_ALARMS
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.AZURE
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AzureAlertsWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_LPAR
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.IBMI
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IBMiLparMonitorDesktopWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.MANAGED_DEVICE_VIEW
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DevicesWidget, {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_BACKUP
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.VMWARE
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backupsDashboardCardJsx.BackupsDashboardCard), {})
                    })
                ]
            }
        ]
    },
    {
        equalHeightCards: false,
        cards: [
            {
                className: 'col-lg-8 d-none d-lg-block',
                title: 'Ticketing',
                components: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.TICKETS_VIEW
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.ALL
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.ALL
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsDashboardJsx.ConnectriaTicketsDashboardTab), {})
                    })
                ]
            },
            {
                nestedConfig: [
                    // {
                    //   className: "col-sm-12 col-lg-4",
                    //   equalHeightCards: false,
                    //   cards: [
                    //     {
                    //       className: "col-sm-12",
                    //       title: "Automations",
                    //       components: [
                    //         <FeatureToggle clouds={[Enum.CloudCategory.PUBLIC_CLOUD]} envs={[Enum.Env.ALL]}>
                    //           <div>
                    //             <h3 className="text-left">Bot Factory</h3>
                    //             <ul className="list-unstyled text-center">
                    //               <li><a href="/app/cloud/bots_create" className="btn btn-link" style={{fontSize:"15px"}}><i className="fas fa-plus-square"></i> Create Bot</a></li>
                    //               <li><a href="/app/cloud/bots_listing" className="btn btn-link" style={{fontSize:"15px"}}><i className="fas fa-list"></i> Bot Listing</a></li>
                    //               <li><a href="/app/cloud/bots_templates" className="btn btn-link" style={{fontSize:"15px"}}><i className="fas fa-ruler-combined"></i> Templates</a></li>
                    //             </ul>
                    //           </div>
                    //         </FeatureToggle>
                    //       ]
                    //     }
                    //   ]
                    // },
                    {
                        equalHeightCards: false,
                        className: 'col-sm-12 col-lg-4',
                        cards: [
                            {
                                className: 'col-sm-12',
                                noCard: true,
                                components: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleJsDefault.default), {
                                        policies: [],
                                        clouds: [
                                            (0, _enumJsDefault.default).CloudCategory.ALL
                                        ],
                                        envs: [
                                            (0, _enumJsDefault.default).Env.ALL
                                        ],
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upsellCardContainerDefault.default), {})
                                    })
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

},{"react/jsx-runtime":"1elNt","react":"gVheC","./utility/enum.js":"3A9fW","./views/Dashboard.jsx":"l4dx9","./utility/FeatureToggle.js":"2vty2","./components/ConnectriaTickets/ConnectriaTicketsDashboard.jsx":"21zwt","./components/IBMiCart/IBMCartCard.jsx":"iVpns","./components/BackupJobs/BackupsDashboardCard.jsx":"8NPYu","./components/Upsell/UpsellCardContainer":"1m0GW","./components/ResourceManagement/ResourcesOverview":"93GaJ","./components/BackupJobs/BackupSingleJob.jsx":"5vECt","./components/Devices/DeviceDetailPage":"7zlom","./config":"kQzX9","89668153401b312b":"68ziH","6653cfba345987fe":"9Egq2","bde9fc94ee325088":"cKMKD","4715d89be92da210":"hD1tQ","1f19d4cd8c2890b2":"iDi8Y","2d77583756c0c8f1":"ksJTf","fd3a2574f275db14":"6xmPW","de390de75ac7a779":"lEFox","b0ae776c0956f9c3":"hydcf","60d6533973573781":"edIqY","84dc0a1c930e8d32":"5KuYD","28c15e82a960ad72":"cSpUF","75402d1164c544e7":"6OyA1","4e382f3e3224651b":"iSkuf","5e52fa6bbbc632e2":"jnG20","62b9439f43803c21":"ghmCF","f4d0c35c07cab585":"6ZpKY","164f27d3ea6ae4f8":"7HibE","d5f8032b0124d90":"8UO9s","54ae782f73a3745b":"5I4pj","f052b2c31c435c6d":"f4A2N","624ec929c2224d53":"4ZYIi","ca238d40d2a328ab":"jUYkY","dff6e79d99162479":"3h6M8","942d4a165668fe94":"fPghv","d9b7b9be09287196":"bBFi9","3c52ced108750191":"2WKJs","e79fe12b711e285d":"aOK6j","72b91447f922f561":"7dryn","cce548b58636037e":"az3mT","3978b0b0e4a50033":"eo8fG","a62ca327b8e1a539":"8DEUS","428d88d694911143":"24cqd","19b53f705932443e":"culzg","b690e9f01e504e4c":"1qnxC","f7bdaa690ef681f7":"XYLFx","dc7715ac3875c733":"4Icrv","eac2b23080c5c10a":"jo4hf","759f1cbb6368ab7f":"CCV8b","e34719340fd3db6e":"kTnhr","734481b16c239f1c":"66Rrt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3A9fW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _defineProperty = require("@swc/helpers/_/_define_property");
var Env = {
    LOCAL: 'local',
    DEV: 'dev',
    PROD: 'prod',
    DEMO: 'demo',
    ALL: 'all'
};
var CloudCategory = {
    AWS: 'aws',
    AZURE: 'azure',
    PUBLIC_CLOUD: 'public_cloud',
    VMWARE: 'vmware',
    IBMI: 'ibmi',
    ALL: 'all'
};
var Integration = {
    BLUEMATADOR: 'bluematador',
    CLOUDWATCH: 'cloudwatch',
    TRENDMICRO: 'trendmicro'
};
var Roles = {
    basicUser: 'basic',
    orgAdmin: 'orgAdmin',
    superAdmin: 'superAdmin'
};
var _obj;
var Policies = (_obj = {
    BILLING_VIEW: "B_VIEW",
    COMPLIANCE_VIEW: "C_VIEW",
    NOTIFICATIONS_EXPORT: "N_EXPORT",
    NOTIFICATIONS_VIEW: "N_VIEW",
    VIEW_RESOURCE_PROPERTY: "O_VIEWRESRCPROP",
    ORGANIZATION_DETAIL_VIEW: "O_VIEWDETAIL",
    ADD_PEOPLE: "PEOPLE_ADD",
    RBAC_MOD: "RBAC_MOD",
    VIEW_LPAR: "LPAR_VIEW",
    EXPIRE_MFA: "PEOPLE_MFA",
    VIEW_PEOPLE: "PEOPLE_VIEW",
    RESET_PASSWORD: "PEOPLE_RESTPASSWD",
    EXPORT_DEVICES: "P_EXPORT",
    VIEW_CLOUD_ALARMS: "P_VIEWCLDALARM",
    VIEW_CLOUD_MON: "P_VIEWCLDMON",
    REMOTE_CONSOLE: "R_CONSOLE",
    MANAGED_DEVICE_VIEW: "P_VIEWMNGDEVICE",
    MALWARE_VIEW: "SEC_MALWARE",
    SECURITY_VIEW: "SEC_VIEW",
    SPEND_VIEW: "S_VIEW",
    TICKETS_VIEW: "T_VIEW",
    RESOURCES_VIEW: "R_VIEW",
    RESOURCES_EXPORT: "R_EXPORT",
    RESOURCES_CONSOLE: "R_CONSOLE",
    AUTOMATION_VIEW: "A_VIEW",
    REPORT_VIEW: "RPT_VIEW",
    RUNBOOKS_VIEW: "RNBK_VIEW",
    AUTOMATION_MANAGE: "A_MANAGE"
}, (0, _defineProperty._)(_obj, "AUTOMATION_VIEW", "A_VIEW"), (0, _defineProperty._)(_obj, "VIEW_BACKUP", "P_VIEWBCKUP"), (0, _defineProperty._)(_obj, "AWS_SUPPORT_TICKETS", "AWS_SUPPORT_TICKETS"), _obj);
var Enum = function Enum() {
    "use strict";
    (0, _classCallCheck._)(this, Enum);
};
Enum.Env = Env;
Enum.CloudCategory = CloudCategory;
Enum.Integration = Integration;
Enum.Roles = Roles;
Enum.Policies = Policies;
exports.default = Enum;

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_define_property":"4QmId","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l4dx9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../AppState");
var _tabbedDashboard = require("../components/Dashboard/TabbedDashboard");
var _tabbedDashboardDefault = parcelHelpers.interopDefault(_tabbedDashboard);
var _dynamicDashboard = require("../components/Dashboard/DynamicDashboard");
var _routesJs = require("../routes.js");
var _enumJs = require("../utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
var _connectriaTicketsService = require("../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _featureToggle = require("../utility/FeatureToggle");
var waitForIt;
var _retries = 3;
var retryCount = 0;
// cache function doesn't save data to application state!!!
var loadCache = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function(stateApp, stateAppActions) {
        var isCustomer, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    isCustomer = stateApp.userInfo.organization_id !== 0;
                    console.log('Load users to cache');
                    return [
                        4,
                        (0, _connectriaTicketsServiceDefault.default).getAllUsersLike({}, isCustomer)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0, _connectriaTicketsServiceDefault.default).ticketCategories({})
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        (0, _connectriaTicketsServiceDefault.default).getAllDevicesLike({
                            ar_assoc: 'devicetype',
                            limit: 100
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    if (retryCount < _retries) //loadCache(stateApp, stateAppActions)
                    retryCount++;
                    else {
                        //set to empty
                        console.error('setting empty state');
                        stateAppActions.setCache({
                            key: "connectriaTicketCC",
                            data: []
                        });
                        stateAppActions.setCache({
                            key: "connectriaTicketCategories",
                            data: []
                        });
                        stateAppActions.setCache({
                            key: "connectriaTicketDevices",
                            data: []
                        });
                        stateAppActions.setCache({
                            key: "costSavings",
                            data: []
                        });
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadCache(stateApp, stateAppActions) {
        return _ref.apply(this, arguments);
    };
}();
function ResponsiveDashboard(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var policies = stateApp.policies;
    var user_roles = stateApp.roles_v2;
    (0, _react.useEffect)(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var i, cards, x, comp, y, criteriaMet, i, cards1, x, comp1;
        return (0, _tsGenerator._)(this, function(_state) {
            if (props.width === 0) return [
                2,
                null
            ];
            //if (!stateApp.superAdmin && user_roles.filter((e) => e.RoleName == "OrgAdmin").length == 0){
            for(i = 0; i < (0, _routesJs.dashBoardConfig).length; i++){
                cards = (0, _routesJs.dashBoardConfig)[i].cards;
                for(x = 0; x < cards.length; x++){
                    comp = cards[x].components || [];
                    for(y = 0; y < comp.length; y++){
                        //***curently only has support for one policy
                        criteriaMet = (0, _featureToggle.matchedClouds)(comp[y].props.clouds) && (0, _featureToggle.matchedIntegrations)(comp[y].props.integrations) && (0, _featureToggle.hasPolicies)(comp[y].props.policies, stateApp) && (0, _featureToggle.matchedEnv)(stateApp, comp[y].props.envs);
                        if (!criteriaMet) (0, _routesJs.dashBoardConfig)[i].cards[x].components.splice(y, 1);
                    }
                }
            }
            for(i = 0; i < (0, _routesJs.dashBoardConfig).length; i++){
                cards1 = (0, _routesJs.dashBoardConfig)[i].cards;
                for(x = 0; x < cards1.length; x++){
                    comp1 = cards1[x].components || [];
                    if (comp1.length == 0) (0, _routesJs.dashBoardConfig)[i].cards.splice(x, 1);
                }
            }
            return [
                2
            ];
        });
    }), [
        user_roles
    ]);
    var dconfig = (0, _routesJs.dashBoardConfigIbmi);
    if (stateApp.clouds.includes((0, _enumJsDefault.default).CloudCategory.PUBLIC_CLOUD)) dconfig = (0, _routesJs.dashBoardConfig);
    if (props.width <= 768) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "db-pane",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabbedDashboardDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dynamicDashboard.DynamicDashboardComponents), {
                config: dconfig
            })
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "db-pane",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dynamicDashboard.DynamicDashboardComponents), {
                config: dconfig
            })
        })
    });
}
var Dashboard = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), width = _useState[0], setWidth = _useState[1];
    (0, _react.useEffect)(function() {
        // stateAppActions.setPageNavTitle("TRiA HOME");
        window.addEventListener("resize", function() {
            console.log("resized event caught");
            if (window.innerWidth > 0 && window.innerWidth != width) {
                if (waitForIt) clearTimeout(waitForIt);
                waitForIt = setTimeout(function() {
                    setWidth(window.innerWidth);
                }, 300);
            }
        });
        if (window.innerWidth > 0) setWidth(window.innerWidth);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
            fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResponsiveDashboard, {
                width: width
            })
        })
    });
};
exports.default = Dashboard;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../AppState":"8UGXH","../components/Dashboard/TabbedDashboard":"dxAM9","../components/Dashboard/DynamicDashboard":"dOGxj","../routes.js":"bvYZI","../utility/enum.js":"3A9fW","../services/ConnectriaTicketsService":"l5X0I","../utility/FeatureToggle":"2vty2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxAM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TicketTabIndicator", function() {
    return TicketTabIndicator;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// nodejs library that concatenates classes
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
// reactstrap components
var _reactstrap = require("reactstrap");
var _ibmiDashboard = require("../../components/IBMiDashboard/IBMiDashboard");
var _reactFlippy = require("react-flippy");
var _connectriaTicketsDashboard = require("../../components/ConnectriaTickets/ConnectriaTicketsDashboard");
var _blueMatadorDashboard = require("../../components/BlueMatadorDashboard/BlueMatadorDashboard");
var _appState = require("../../AppState");
var _ibmcartCard = require("../../components/IBMiCart/IBMCartCard");
var _solarwindForecast = require("../VMwareSolarwind/SolarwindForecast");
function TicketTabIndicator(props) {
    if (props.enabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-circle text-blue unread-indicator",
        style: props.style
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}
var TabbedDashboard = function(props) {
    //local state
    var _useState = (0, _slicedToArray._)((0, _react.useState)('1'), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var toggleTab = function(tab) {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ButtonGroup), {
                className: "d-flex",
                role: "group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        color: "neutral",
                        onClick: function() {
                            return setActiveTab('1');
                        },
                        active: activeTab === '1',
                        className: "w-100",
                        children: "Dashboard"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                        color: "neutral",
                        onClick: function() {
                            return setActiveTab('2');
                        },
                        active: activeTab === '2',
                        className: "w-100",
                        children: [
                            "Tickets ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketTabIndicator, {
                                enabled: stateApp.inboxCount > 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.TabContent), {
                activeTab: activeTab,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                        tabId: "1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-2",
                            children: props.children
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                        tabId: "2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsDashboard.ConnectriaTicketsDashboardTab), {})
                    })
                ]
            })
        ]
    });
};
exports.default = TabbedDashboard;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","classnames":"6P5cq","reactstrap":"774RE","../../components/IBMiDashboard/IBMiDashboard":"hJ5SK","react-flippy":"ev7zF","../../components/ConnectriaTickets/ConnectriaTicketsDashboard":"21zwt","../../components/BlueMatadorDashboard/BlueMatadorDashboard":"9FEJa","../../AppState":"8UGXH","../../components/IBMiCart/IBMCartCard":"iVpns","../VMwareSolarwind/SolarwindForecast":"apSqP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hJ5SK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IBMiLPARMonitorBackSide", function() {
    return IBMiLPARMonitorBackSide;
});
parcelHelpers.export(exports, "IBMiLPARMonitorFrontSide", function() {
    return IBMiLPARMonitorFrontSide;
});
parcelHelpers.export(exports, "IBMiDashboardNotificationBlade", function() {
    return IBMiDashboardNotificationBlade;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
// reactstrap components
var _reactstrap = require("reactstrap");
var _ibmservice = require("../../services/IBMService");
var _ibmserviceDefault = parcelHelpers.interopDefault(_ibmservice);
var _ibmUtility = require("../../utility/ibm_utility");
var _ibmUtilityDefault = parcelHelpers.interopDefault(_ibmUtility);
var _featureToggle = require("../../utility/FeatureToggle");
var _featureToggleDefault = parcelHelpers.interopDefault(_featureToggle);
var _enumJs = require("../../utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
function showDashboardBlade(props) {
    props.setBladeState({
        visible: true,
        title: "IBM i LPAR Notifications",
        content: IBMiDashboardNotificationBlade
    });
}
var IBMiDashboardNotificationBlade = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: "Send a notification to:"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
            type: "select",
            name: "selectChannel",
            id: "selectChannel",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    children: "Slack"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    children: "E-mail"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    children: "SMS"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "mt-3",
            children: "When LPARs enter the following states:"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Form), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormGroup), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "position-relative form-check",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "form-check-label",
                            children: [
                                "Warning",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    className: "form-check-input"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form-check-sign",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "check"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormGroup), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "position-relative form-check",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "form-check-label",
                            children: [
                                "Error",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    className: "form-check-input"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form-check-sign",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "check"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                    className: "btn pull-right mt-4",
                    children: "Save"
                })
            ]
        })
    ]
});
var getStatusIcon = function(host, targetDivId) {
    var tooltip = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
        delay: 0,
        target: host.device_id,
        placement: "right",
        children: host.status_text
    });
    // let popId = `popover-statusicon-${host.host_id}`;
    switch(host.status_type){
        case "ok":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                id: host.device_id,
                "data-toggle": "tooltip",
                title: host.status_text,
                className: "fas fa-check text-success"
            });
        case "warning":
            return(// example ticket context approach
            // <UncontrolledButtonDropdown>
            //   <DropdownToggle caret className="btn-link btn-image-dd">
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                id: host.device_id,
                "data-toggle": "tooltip",
                title: host.status_text,
                className: "fas fa-exclamation-triangle text-warning"
            }));
        case "error":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                id: host.device_id,
                "data-toggle": "tooltip",
                title: host.status_text,
                className: "fas fa-exclamation-circle text-danger"
            });
        case "disabled":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                id: host.id,
                "data-toggle": "tooltip",
                title: "LPAR Requires Updates to Display Monitoring",
                className: "fas fa-minus"
            });
    }
};
var IBMiLPARMonitorBackSide = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Form), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                            for: "enableNotification"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CustomInput), {
                                type: "checkbox",
                                id: "switchEnable",
                                name: "switchEnable",
                                label: "Enabled",
                                checked: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("blockquote", {
                className: "success",
                children: 'When an LPAR\'s status is in a warning or error state an email will be sent to "lparsupport@connectria.com".'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                className: "btn pull-right",
                onClick: function() {
                    return showDashboardBlade(props);
                },
                children: "Configure"
            })
        ]
    });
};
var IBMiLparMonitorDesktopWidget = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IBMiLPARMonitorFrontSide, {});
};
var IBMiLPARMonitorFrontSide = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        hosts: [],
        hostEmpty: []
    }), 2), state = _useState[0], setState = _useState[1];
    var history = (0, _reactRouterDom.useHistory)();
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var hosts, i, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _ibmserviceDefault.default).hosts({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        hosts = _state.sent();
                        for(i = 0; i < hosts.data.length; i++)(0, _ibmUtilityDefault.default).getHostStatus(hosts.data[i]);
                        if (!isMounted()) return [
                            2
                        ];
                        setState(function(values) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                hosts: hosts.data
                            });
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    var totalServices = 0, totalCriticals = 0, totalWarnings = 0;
    var warningsCriticals = false;
    state.hosts.forEach(function(host) {
        host.services.forEach(function(service, i) {
            totalServices++;
            var name = service.name;
            var status = service.value.split(': ')[1];
            if (name === "Version Information") host.version = status;
            if (status === undefined) status = "no status";
            else status = String(status);
            if (status) {
                service.status = status;
                if (name === "CPU Utilization") {
                    if (Number(status.substring(0, 2)) > 88) {
                        service.statusIconClass = 'warning';
                        host.warningsErrors = true;
                        warningsCriticals = true;
                        host.warningCount++;
                        totalWarnings++;
                    }
                    if (Number(status.substring(0, 2)) > 96) {
                        service.statusIconClass = 'error';
                        host.warningsErrors = true;
                        warningsCriticals = true;
                        host.warningCount--;
                        totalWarnings--;
                        host.errorCount++;
                        totalCriticals++;
                    }
                    if (Number(status.substring(0, 3)) === 100) //service.statusRowClass = 'iseries-critical';
                    service.statusIconClass = 'error';
                }
                if (name === "Disk Utilization") {
                    if (Number(status.substring(0, 2)) > 74) {
                        //service.statusRowClass = 'iseries-warning';
                        service.statusIconClass = 'warning';
                        host.warningsErrors = true;
                        warningsCriticals = true;
                        host.warningCount++;
                        totalWarnings++;
                    }
                    if (Number(status.substring(0, 2)) > 84) {
                        //service.statusRowClass = 'iseries-critical';
                        service.statusIconClass = 'error';
                        host.warningsErrors = true;
                        warningsCriticals = true;
                        host.warningCount--;
                        totalWarnings--;
                        host.errorCount++;
                        totalCriticals++;
                    }
                    if (Number(status.substring(0, 3)) === 100) //service.statusRowClass = 'iseries-critical';
                    service.statusIconClass = 'error';
                }
                if (status === "WARN") {
                    //service.statusRowClass = 'iseries-warning';
                    service.statusIconClass = 'warning';
                    host.warningsErrors = true;
                    warningsCriticals = true;
                    host.warningCount++;
                    totalWarnings++;
                }
                if (status === "CRITICAL") {
                    //service.statusRowClass = 'iseries-critical';
                    service.statusIconClass = 'error';
                    host.warningsErrors = true;
                    warningsCriticals = true;
                    host.errorCount++;
                    totalCriticals++;
                }
            } else host.services.splice(i, 1);
        });
    });
    var counters = '';
    if (state.hosts.length > 5) counters = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            'fontSize': '20px',
            'paddingTop': '60px'
        },
        children: [
            warningsCriticals && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "mr-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "fas fa-exclamation-triangle text-danger"
                            }),
                            "\xa0",
                            totalCriticals
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "mx-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "fas fa-exclamation-circle text-warning"
                            }),
                            "\xa0",
                            totalWarnings
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "ml-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "fas fa-check text-success"
                            }),
                            "\xa0",
                            state.hosts.length - totalWarnings - totalCriticals
                        ]
                    })
                ]
            }),
            !warningsCriticals && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "fas fa-check text-success"
                    }),
                    " ALL ",
                    state.hosts.length,
                    " LPARS"
                ]
            })
        ]
    });
    var content = '';
    if (state.hosts.length === 0) content = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: "30px"
            }
        })
    });
    else content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "ibmi-lpar-monitors-contain",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                className: state.hosts.length > 5 ? "d-none" : "table",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    style: {
                        fontSize: state.hosts.length < 4 ? "20px" : '16px'
                    },
                    children: state.hosts.filter(function(item) {
                        return item.services.length > 0;
                    }).map(function(object) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    children: (0, _ibmUtilityDefault.default).getHostStatus(object) == "disabled" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: object.host_name
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/app/ibm/host/" + object.device_id,
                                        children: object.host_name
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    children: object.ip_address
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {})
                            ]
                        }, object.device_id);
                    })
                })
            }),
            counters
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "d-flex",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-left",
                            children: "IBM i LPAR Monitoring"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleDefault.default), {
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.IBMI
                        ],
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_LPAR
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.DEV,
                            (0, _enumJsDefault.default).Env.DEMO
                        ],
                        children: content
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleDefault.default), {
                        policies: [
                            (0, _enumJsDefault.default).Policies.VIEW_LPAR
                        ],
                        clouds: [
                            (0, _enumJsDefault.default).CloudCategory.IBMI
                        ],
                        envs: [
                            (0, _enumJsDefault.default).Env.PROD
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "d-flex"
                                }),
                                state.hosts.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-spinner m-3 mt-4 fa-spin",
                                        style: {
                                            fontSize: "30px"
                                        }
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    id: "ibmi-lpar-monitors-contain",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                                        className: state.hosts.length == 0 ? "d-none" : "table",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                            children: state.hosts.filter(function(item) {
                                                return item.services.length > 0;
                                            }).map(function(object) {
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: (0, _ibmUtilityDefault.default).getHostStatus(object) == "disabled" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                                children: object.host_name
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "#",
                                                                onClick: function() {
                                                                    history.push("/app/ibm/host/" + object.device_id);
                                                                },
                                                                children: object.host_name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            children: object.ip_address
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {})
                                                    ]
                                                }, object.device_id);
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "btn btn-light align-self-end btn-sm mt-3",
                onClick: function() {
                    history.push("/app/ibm-dashboard");
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: "inline",
                            verticalAlign: "middle"
                        },
                        className: "fas fa-chart-line"
                    }),
                    " ",
                    "View LPARS"
                ]
            })
        ]
    });
};
exports.default = IBMiLparMonitorDesktopWidget;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","../../utility/use-async-effect":"fShZN","axios":"ebRwi","reactstrap":"774RE","../../services/IBMService":"1UpC4","../../utility/ibm_utility":"8jxvm","../../utility/FeatureToggle":"2vty2","../../utility/enum.js":"3A9fW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fShZN":[function(require,module,exports,__globalThis) {
var _require = require("b1b166774ff65732"), useEffect = _require.useEffect, useRef = _require.useRef;
var useAsyncEffect = function(effect, destroy, inputs) {
    var hasDestroy = typeof destroy === 'function';
    useEffect(function() {
        var result;
        var mounted = true;
        var maybePromise = effect(function() {
            return mounted;
        });
        Promise.resolve(maybePromise).then(function(value) {
            result = value;
        });
        return function() {
            mounted = false;
            if (hasDestroy) destroy(result);
        };
    }, hasDestroy ? inputs : destroy);
};
module.exports = useAsyncEffect;
module.exports.useAsyncEffect = useAsyncEffect;

},{"b1b166774ff65732":"gVheC"}],"1UpC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var base_api = 'https://tria.connectria.com';
var ibmiApiUrl = 'https://e2huugjtug.execute-api.us-east-1.amazonaws.com/prod';
var defaultRequest = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGenerator._)(function() {
        var req, idToken;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = (0, _axiosDefault.default).create({
                        baseURL: ibmiApiUrl
                    });
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    req.defaults.headers['Authorization'] = idToken;
                    return [
                        2,
                        req
                    ];
            }
        });
    });
    return function defaultRequest() {
        return _ref.apply(this, arguments);
    };
}();
var IBMService = {
    hosts: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    request = req.get(ibmiApiUrl + "/iseries", {
                        params: (0, _objectSpread._)({
                            orgId: orgId
                        }, params)
                    });
                    return [
                        2,
                        request
                    ];
            }
        });
    }),
    details: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(device_id) {
            var params, req, orgId, request;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        request = req.get(ibmiApiUrl + "/iseries/detail/" + device_id, {
                            params: (0, _objectSpread._)({
                                orgId: orgId
                            }, params)
                        });
                        return [
                            2,
                            request
                        ];
                }
            });
        });
        return function(device_id) {
            return _ref.apply(this, arguments);
        };
    }(),
    chart_series: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(host, service, start, end) {
            var params, req, orgId, request;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        request = req.get(ibmiApiUrl + "/iseries/export?host_name=".concat(host, "&service_description=").concat(service, "&start=").concat(start, "&end=").concat(end, "&orgId=").concat(orgId), params);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
        return function(host, service, start, end) {
            return _ref.apply(this, arguments);
        };
    }(),
    service_metric_history: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(device_id, service_name, start_date) {
            var days_back, params, req, orgId, request;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        days_back = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 15, params = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        request = req.post(ibmiApiUrl + "/clouds/ibm/servicemetric/history", {
                            device_id: device_id,
                            service_name: service_name,
                            start_date: start_date,
                            days_back: days_back
                        }, {
                            params: (0, _objectSpread._)({
                                orgId: orgId
                            }, params)
                        });
                        return [
                            2,
                            request
                        ];
                }
            });
        });
        return function(device_id, service_name, start_date) {
            return _ref.apply(this, arguments);
        };
    }(),
    setup: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    request = req.get(ibmiApiUrl + "/setup", {
                        params: (0, _objectSpread._)({
                            orgId: orgId
                        }, params)
                    });
                    return [
                        2,
                        request
                    ];
            }
        });
    })
};
exports.default = IBMService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","../utility/CognitoAuth":"cngmx","../services/CookieService":"iKLPT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cngmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _awsAmplify = require("aws-amplify");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _userService = require("../services/UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var _config = require("../config");
var _jwtDecode = require("jwt-decode");
var _jwtDecodeDefault = parcelHelpers.interopDefault(_jwtDecode);
var ACCESS_TOKEN = 'accessToken', ID_TOKEN = 'idToken', ORGANIZATION_COOKIE_NAME = 'OrganizationId', DIVVY_COOKIE = 'session_id', CUSTOMER_COOKIE_NAME = 'CustomerId';
(0, _awsAmplify.Auth).configure({
    aws_project_region: 'us-east-1',
    aws_cognito_identity_pool_id: (0, _config.AWS_IDENTITY_POOL_ID),
    aws_cognito_region: 'us-east-1',
    aws_user_pools_id: (0, _config.AWS_USER_POOL_ID),
    aws_user_pools_web_client_id: (0, _config.AWS_POOL_CLIENT_ID),
    cookieStorage: {
        domain: (0, _config.DOMAIN),
        secure: false
    }
});
var Cognito = {
    getSession: function() {
        return (0, _asyncToGenerator._)(function() {
            var session, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _awsAmplify.Auth).currentSession()
                        ];
                    case 1:
                        session = _state.sent();
                        this.setTokens(session);
                        return [
                            2,
                            {
                                success: true,
                                session: session
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            {
                                success: false,
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    hasMfaEnabled: function() {
        return (0, _asyncToGenerator._)(function() {
            var user, result, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _awsAmplify.Auth).currentAuthenticatedUser()
                        ];
                    case 1:
                        user = _state.sent();
                        return [
                            4,
                            (0, _awsAmplify.Auth).getPreferredMFA(user)
                        ];
                    case 2:
                        result = _state.sent();
                        console.log('MFA Enabled ' + ((result || '') == 'SMS_MFA' || (result || '') == 'SOFTWARE_TOKEN_MFA'));
                        return [
                            2,
                            (result || '') == 'SMS_MFA' || (result || '') == 'SOFTWARE_TOKEN_MFA'
                        ];
                    case 3:
                        err = _state.sent();
                        console.log('Error MFA get preferred: ', err);
                        return [
                            2,
                            false
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getUserInfo: function() {
        return (0, _asyncToGenerator._)(function() {
            var user, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _awsAmplify.Auth).currentAuthenticatedUser()
                        ];
                    case 1:
                        user = _state.sent();
                        return [
                            2,
                            {
                                success: true,
                                user: user
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            {
                                success: false,
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    setTokens: function(session) {
        localStorage.setItem(ACCESS_TOKEN, session.getAccessToken().getJwtToken());
        localStorage.setItem(ID_TOKEN, session.getIdToken().getJwtToken());
    },
    getAccessToken: function() {
        return (0, _asyncToGenerator._)(function() {
            var session;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.getSession()
                        ];
                    case 1:
                        session = _state.sent();
                        if (session.success) return [
                            2,
                            session.session.getAccessToken().getJwtToken()
                        ];
                        return [
                            2,
                            null
                        ];
                }
            });
        }).apply(this);
    },
    getAccessTokenDecoded: function() {
        return (0, _asyncToGenerator._)(function() {
            var session, decoded;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.getSession()
                        ];
                    case 1:
                        session = _state.sent();
                        if (session.success) {
                            decoded = (0, _jwtDecodeDefault.default)(session.session.getAccessToken().getJwtToken());
                            console.log(decoded);
                            return [
                                2,
                                decoded
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        }).apply(this);
    },
    getIdToken: function() {
        return (0, _asyncToGenerator._)(function() {
            var session;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.getSession()
                        ];
                    case 1:
                        session = _state.sent();
                        if (session.success) return [
                            2,
                            session.session.getIdToken().getJwtToken()
                        ];
                        return [
                            2,
                            null
                        ];
                }
            });
        }).apply(this);
    },
    signOut: function() {
        return (0, _asyncToGenerator._)(function() {
            var error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _awsAmplify.Auth).signOut({
                                global: true
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            {
                                success: true
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('Error sign out: ', error);
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    logout: function() {
        return (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.signOut()
                        ];
                    case 1:
                        _state.sent();
                        this.deleteDivvyCookies();
                        this.deleteCookie('TriaAccountsIdToken');
                        this.deleteCookie('TriaAccountsAccessToken');
                        this.deleteCookie(ORGANIZATION_COOKIE_NAME);
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    deleteDivvyCookies: function() {
        this.deleteCookie(DIVVY_COOKIE);
        this.deleteCookie('session_timeout_time');
    },
    checkAuth: function(organization, superAdmin) {
        return (0, _asyncToGenerator._)(function() {
            var token, resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this.getAccessToken()
                        ];
                    case 1:
                        token = _state.sent();
                        if (!token) return [
                            2,
                            null
                        ];
                        console.log('Getting Divvy token from Cognito token', token, organization);
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, _userServiceDefault.default).cognitoDivvyAuth(token, superAdmin ? null : organization.customer_id)
                        ];
                    case 3:
                        resp = _state.sent();
                        return [
                            2,
                            resp.data.session_id
                        ];
                    case 4:
                        err = _state.sent();
                        console.error('Cognito auth respond error', err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2,
                            null
                        ];
                }
            });
        }).apply(this);
    },
    getOrganizations: function(user, superAdmin) {
        return (0, _asyncToGenerator._)(function() {
            var organizations, orgsResp, userDetailResp, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, org;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        organizations = [];
                        if (!superAdmin) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.getAllOrganizations()
                        ];
                    case 1:
                        orgsResp = _state.sent();
                        if (orgsResp.success) organizations = orgsResp.organizations || [];
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.getUserDetail()
                        ];
                    case 3:
                        userDetailResp = _state.sent();
                        if (userDetailResp.success) {
                            organizations = userDetailResp.detail.orgs || [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = organizations[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    org = _step.value;
                                    org.role = org.roles.length > 0 ? org.roles[0] : null;
                                    if (org.roles.indexOf('OrgAdmin') > -1) user.orgAdmin = true;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            organizations
                        ];
                }
            });
        }).apply(this);
    },
    getAllOrganizations: function() {
        return (0, _asyncToGenerator._)(function() {
            var resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).get((0, _config.ACCOUNTS_API) + '/auth/orgs', this.getOptions())
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            2,
                            {
                                success: true,
                                organizations: resp.data
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        console.log('Error get organizations list: ', err);
                        return [
                            2,
                            {
                                success: false,
                                organizations: [],
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getOrganizationById: function(id) {
        return (0, _asyncToGenerator._)(function() {
            var resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).get((0, _config.ACCOUNTS_API) + '/auth/orgs/' + id, this.getOptions())
                        ];
                    case 1:
                        resp = _state.sent();
                        console.log(resp.data);
                        return [
                            2,
                            {
                                success: true,
                                clouds: [].concat(resp.data.cloud_accounts.items)
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        console.log('Error get organizations list: ', err);
                        return [
                            2,
                            {
                                success: false,
                                organization: [],
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getCurrentOrganization: function(organizations) {
        var orgId = this.getOrganizationCookie(), customerId = this.getCustomerCookie();
        var matched = false;
        if (orgId) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = organizations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var org = _step.value;
                    if (org.id === orgId) {
                        if (!customerId) // set customer cookie
                        this.setOrganizationCookie(org);
                        matched = true;
                        return org;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (!matched && organizations.length > 0) {
            // if we don't have organization cookie choose the first organization
            var current_org = organizations[0];
            try {
                var nja = organizations.filter(function(e) {
                    return e.customer_id == 0;
                });
                if (nja.length > 0) current_org = nja[0];
            } catch (e) {
                console.log('error setting current org.');
            }
            this.setOrganizationCookie(current_org);
            return current_org;
        }
        return null;
    },
    getUserDetail: function() {
        return (0, _asyncToGenerator._)(function() {
            var resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).get((0, _config.ACCOUNTS_API) + '/auth/user_detail', this.getOptions())
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            2,
                            {
                                success: resp.data.id !== null,
                                detail: resp.data
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        console.log('Error get user detail: ', err);
                        return [
                            2,
                            {
                                success: false,
                                detail: null,
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getResourceProperties: function(organization) {
        return (0, _asyncToGenerator._)(function() {
            var url, resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        url = (0, _config.ACCOUNTS_API) + '/auth/orgs/' + (organization.id || 'NULL') + '/resource_properties';
                        return [
                            4,
                            (0, _axiosDefault.default).get(url, this.getOptions())
                        ];
                    case 1:
                        resp = _state.sent();
                        return [
                            2,
                            {
                                success: true,
                                resourceProperties: resp.data
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        console.log('Error get resource properties: ', err);
                        return [
                            2,
                            {
                                success: false,
                                resourceProperties: null,
                                error: err
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getCustomerCookie: function() {
        return this.getCookie(CUSTOMER_COOKIE_NAME);
    },
    getOrganizationCookie: function() {
        return this.getCookie(ORGANIZATION_COOKIE_NAME);
    },
    setOrganizationCookie: function(org) {
        this.setCookie(ORGANIZATION_COOKIE_NAME, org.id);
        if (org.customer_id) this.setCookie(CUSTOMER_COOKIE_NAME, "".concat(org.customer_id));
    },
    getDivvyCookie: function() {
        return this.getCookie(DIVVY_COOKIE);
    },
    setDivvyCookie: function(token) {
        this.setCookie(DIVVY_COOKIE, token, 1);
    },
    deleteCookie: function(name) {
        this.setCookie(name, '');
    },
    getCookie: function(name) {
        var _document_cookie_match;
        return ((_document_cookie_match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')) === null || _document_cookie_match === void 0 ? void 0 : _document_cookie_match.pop()) || null;
    },
    setCookie: function(name, value) {
        var days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 364;
        if (value === undefined) value = '';
        var time = 0;
        if (value.length > 0) time = days * 86400;
        document.cookie = name + '=' + value + ';domain=' + (0, _config.DOMAIN) + ';SameSite=None;Secure=1;max-age=' + time + ';path=/';
    },
    getOptions: function() {
        var accessToken = localStorage.getItem(ID_TOKEN);
        var headers = {};
        if (accessToken) headers['Authorization'] = accessToken;
        return {
            headers: headers
        };
    }
};
exports.default = Cognito;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","aws-amplify":"75VoS","axios":"ebRwi","../services/UserService":"4Rf9v","../config":"kQzX9","jwt-decode":"ci9pL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kQzX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCOUNTS_API", function() {
    return ACCOUNTS_API;
});
parcelHelpers.export(exports, "ACCOUNTS_URL", function() {
    return ACCOUNTS_URL;
});
parcelHelpers.export(exports, "DOMAIN", function() {
    return DOMAIN;
});
parcelHelpers.export(exports, "ENV", function() {
    return ENV;
});
parcelHelpers.export(exports, "AWS_IDENTITY_POOL_ID", function() {
    return AWS_IDENTITY_POOL_ID;
});
parcelHelpers.export(exports, "AWS_USER_POOL_ID", function() {
    return AWS_USER_POOL_ID;
});
parcelHelpers.export(exports, "AWS_POOL_CLIENT_ID", function() {
    return AWS_POOL_CLIENT_ID;
});
var CONNECTRIA_DOMAIN = 'tria.connectria.com', hostname = window.location.hostname;
var ACCOUNTS_API = 'https://accounts-dev.' + CONNECTRIA_DOMAIN, ACCOUNTS_URL = 'https://accounts.dev.' + CONNECTRIA_DOMAIN, ENV = 'dev', DOMAIN = 'dev.' + CONNECTRIA_DOMAIN, AWS_IDENTITY_POOL_ID = "us-east-1:2e6d0ea2-1e08-476e-a6df-c4ee1981821b", AWS_USER_POOL_ID = "us-east-1_MVORKBzco", AWS_POOL_CLIENT_ID = "73ce0eb09mvj20o2ir78jn51sh";
if (hostname.indexOf('labs.demo.') > -1) {
    ENV = 'qa';
    ACCOUNTS_API = 'https://accounts-demo.' + CONNECTRIA_DOMAIN;
    ACCOUNTS_URL = 'https://accounts.demo.' + CONNECTRIA_DOMAIN;
    AWS_IDENTITY_POOL_ID = "us-east-1:38abc155-0555-4f34-92dd-7d76b0aae10b";
    AWS_USER_POOL_ID = "us-east-1_vlVCSH4IH";
    AWS_POOL_CLIENT_ID = "213k84a2ftsbhda9i2v7eo9rpp";
}
if (hostname.indexOf('qa.tria') > -1) {
    ENV = 'qa';
    ACCOUNTS_API = 'https://accounts-qa.' + CONNECTRIA_DOMAIN;
    ACCOUNTS_URL = 'https://accounts.qa.' + CONNECTRIA_DOMAIN;
}
if (hostname.indexOf('tria-labs.connectria') > -1) {
    ENV = 'prod';
    ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
    ACCOUNTS_URL = 'https://accounts.' + CONNECTRIA_DOMAIN;
    AWS_IDENTITY_POOL_ID = "us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c";
    AWS_USER_POOL_ID = "us-east-1_pccC7Xpyj";
    AWS_POOL_CLIENT_ID = "39v8p4nn1166aef6s4v1jtcoku";
}
if (hostname.indexOf('next-gen.tria') > -1) {
    ENV = 'prod';
    DOMAIN = CONNECTRIA_DOMAIN;
    ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
    ACCOUNTS_URL = 'https://accounts.' + CONNECTRIA_DOMAIN;
    AWS_IDENTITY_POOL_ID = "us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c";
    AWS_USER_POOL_ID = "us-east-1_pccC7Xpyj";
    AWS_POOL_CLIENT_ID = "39v8p4nn1166aef6s4v1jtcoku";
}
if (hostname.indexOf('labs-prod.tria') > -1) {
    ENV = 'prod';
    DOMAIN = CONNECTRIA_DOMAIN;
    ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
    ACCOUNTS_URL = 'https://accounts.' + CONNECTRIA_DOMAIN;
    AWS_IDENTITY_POOL_ID = "us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c";
    AWS_USER_POOL_ID = "us-east-1_pccC7Xpyj";
    AWS_POOL_CLIENT_ID = "39v8p4nn1166aef6s4v1jtcoku";
}
if (hostname.indexOf('localhost') > -1) {
    DOMAIN = 'localhost';
    ACCOUNTS_API = 'http://localhost:3000';
}
console.log('Domain', DOMAIN);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ci9pL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidTokenError", function() {
    return n;
});
function e(e) {
    this.message = e;
}
e.prototype = new Error, e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var _$n, _$o, a = 0, i = 0, c = ""; _$o = t.charAt(i++); ~_$o && (_$n = a % 4 ? 64 * _$n + _$o : _$o, a++ % 4) && (c += String.fromCharCode(255 & _$n >> (-2 * a & 6))))_$o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(_$o);
    return c;
};
function t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent(r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return r(t);
    }
}
function n(e) {
    this.message = e;
}
function o(e, r) {
    if ("string" != typeof e) throw new n("Invalid token specified");
    var _$o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse(t(e.split(".")[_$o]));
    } catch (e) {
        throw new n("Invalid token specified: " + e.message);
    }
}
n.prototype = new Error, n.prototype.name = "InvalidTokenError";
exports.default = o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8jxvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Utils;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Utils = /*#__PURE__*/ function() {
    "use strict";
    function Utils() {
        (0, _classCallCheck._)(this, Utils);
    }
    (0, _createClass._)(Utils, null, [
        {
            key: "extractIntegers",
            value: function extractIntegers(value) {
                var result = (value || "0").match(/\d+/g).map(Number);
                return result.join('.');
            }
        }
    ]);
    return Utils;
}();
(0, _defineProperty._)(Utils, "getAppended", function(service_name, services, appender) {
    var val = Utils.get(service_name, services);
    if (val == null || val.length === 0) return "";
    return val + appender;
});
(0, _defineProperty._)(Utils, "get", function(service_name, services) {
    var use_status_text_Long = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isString = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, justValue = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (!services) return "";
    var item = Utils.findItem(service_name, services);
    if (item.length === 0) return "";
    if (item[0].value.indexOf('HostConfig-load()') > -1) return "";
    if (isString && use_status_text_Long && justValue) return item[0].status_text_long || '';
    return Utils.parseValue(item[0].value, item[0].status_text_long, use_status_text_Long, isString);
});
(0, _defineProperty._)(Utils, "findItem", function(name, arr) {
    var item = arr.filter(function(obj) {
        return obj.name === name;
    });
    if (item.constructor.name == "Object") return [
        item
    ];
    return item;
});
(0, _defineProperty._)(Utils, "parseValue", function(value, status_text_long, use_status_text_Long, isString) {
    if ((value || "").indexOf("cannot find") > -1) return "";
    if ((status_text_long || "").indexOf("com.ibm") > -1) return "";
    if (use_status_text_Long) value = status_text_long;
    //Steve G changed from a "=" to a ":" no need to replace.
    // value = value.replace("=", ":");
    if (isString) return ((value || ": ").split(':')[1] || '').trim().split(' ')[0] || '';
    if (value.indexOf(":") > -1 || value.indexOf("=") > -1) {
        var stripped = value.indexOf(":") > -1 ? value.split(":")[1].trim() : value.split("=")[1].trim();
        var floatValues = /[+-]?([0-9]*[.])?[0-9]+/;
        if (stripped.match(floatValues)) {
            var parsed = stripped.match(floatValues)[0];
            return parsed;
        }
        return stripped;
    }
    return '';
});
(0, _defineProperty._)(Utils, "getColoredSpan", function(type, value, formatting) {
    var status_type = "";
    switch(type){
        case "CPU Utilization":
            if (value > 88) status_type = "warning";
            if (value > 96) status_type = "error";
            break;
        case "Disk Utilization":
            if (value > 74) status_type = "warning";
            if (value > 84) status_type = "error";
            break;
        case "Jobs in MSGW":
            if (value > 0) status_type = "error";
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            " ",
            value + "" + formatting,
            " "
        ]
    });
});
(0, _defineProperty._)(Utils, "getChart", function(name, host1, data) {
    if (data.error) return;
    var timeseries = data.data.row.map(function(obj) {
        return new Date(parseInt(obj.t) * 1000);
    });
    var dataseries = data.data.row.map(function(obj) {
        return Number(obj.v).toFixed(2);
    });
    var y = {
        labels: timeseries,
        datasets: [
            {
                label: host1.host_name + " " + name,
                fill: false,
                lineTension: 0.1,
                backgroundColor: "rgba(75,192,192,0.4)",
                borderColor: "rgba(75,192,192,1)",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                pointBorderColor: "rgba(75,192,192,1)",
                pointBackgroundColor: "#fff",
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "rgba(75,192,192,1)",
                pointHoverBorderColor: "rgba(220,220,220,1)",
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: dataseries
            }
        ]
    };
    return y;
});
(0, _defineProperty._)(Utils, "getLastDataSetValue", function(array) {
    var qualifier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (array.length === 0) return '';
    if (isNaN(array[array.length - 1]) && isNaN(array[array.length - 2])) return '';
    if (isNaN(array[array.length - 1])) return array[array.length - 2] + qualifier;
    return array[array.length - 1] + qualifier;
});
(0, _defineProperty._)(Utils, "getStatusIcon", function(type, value) {
    var icon = '';
    var status_type = '';
    if (value == null) return '';
    value = value.replace('%', '');
    if (isNaN(value)) return '';
    switch(type){
        case "CPU Utilization":
            if (Number(value) > 88) status_type = "warning";
            if (Number(value) > 96) status_type = "error";
            if (Number(value) === 100) status_type = "error";
            return status_type;
        case "Disk Utilization":
            if (Number(value) > 74) status_type = "warning";
            if (Number(value) > 84) status_type = "error";
            if (Number(value) === 100) host.status_type = "error";
            return status_type;
        case "Jobs in MSGW":
            // if (value > 1) status_type = "warning";
            if (value > 0) status_type = "error";
            return status_type;
        default:
            break;
    }
    return icon;
});
(0, _defineProperty._)(Utils, "getHostStatus", function(host1) {
    //check for disabled monitoring
    var cpu = Utils.get("CPU Utilization", host1.services);
    if (cpu != null && cpu === "") {
        host1.status_type = "disabled";
        return host1.status_type;
    }
    host1.status_type = "ok";
    host1.status_text = "Ok";
    for(var i = 0; i < host1.services.length; ++i){
        var name = host1.services[i].name;
        var status = host1.services[i].value.split(": ")[1];
        if (status != undefined) {
            var cleanStatus = Number(status.replace("%", ""));
            switch(name){
                case "CPU Utilization":
                    host1.status_text = name + " " + Number(status.substring(0, 3));
                    if (cleanStatus > 88) host1.status_type = "warning";
                    if (cleanStatus > 96) {
                        host1.status_type = "error";
                        return host1.status_type;
                    }
                    if (Number(status.substring(0, 3)) === 100) {
                        host1.status_type = "error";
                        return host1.status_type;
                    }
                    break;
                case "Disk Utilization":
                    host1.status_text = name + " " + Number(status.substring(0, 3));
                    if (cleanStatus > 74) host1.status_type = "warning";
                    if (cleanStatus > 84) {
                        host1.status_type = "error";
                        return host1.status_type;
                    }
                    if (Number(status.substring(0, 3)) === 100) {
                        host1.status_type = "error";
                        return host1.status_type;
                    }
                    break;
                case "Jobs in MSGW":
                    if (Number(status.substring(0, 1)) > 0) {
                        host1.status_text = name + " " + Number(status.substring(0, 1));
                        host1.status_type = "error";
                        return host1.status_type;
                    }
                    break;
                default:
                    break;
            }
        }
    }
    return host1.status_type;
});

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_define_property":"4QmId","react/jsx-runtime":"1elNt","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2vty2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matchedEnv", function() {
    return matchedEnv;
});
parcelHelpers.export(exports, "hasPolicies", function() {
    return hasPolicies;
});
parcelHelpers.export(exports, "matchedIntegrations", function() {
    return matchedIntegrations;
});
parcelHelpers.export(exports, "matchedClouds", function() {
    return matchedClouds;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _appState = require("../AppState");
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDeviceDetect = require("react-device-detect");
var FeatureToggle = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var criteriaMet = function(env, cloud, integrations, policies) {
        return matchedEnv(stateApp, env, props) && matchedClouds(stateApp, cloud) && matchedIntegrations(stateApp, integrations) && hasPolicies(policies, stateApp);
    };
    var title = /*#__PURE__*/ (0, _reactDefault.default).createElement('null', {}, '');
    var access = props.showAccessDenied || false;
    var Null = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var result = criteriaMet(props.envs, props.clouds, props.integrations, props.policies);
    var passed = criteriaMet(props.envs, props.clouds, props.integrations, props.policies) ? props.children : null;
    var elm = /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoAccess, {});
    //const title = null;
    // if(passed == null ) console.log(props.children)
    return passed;
//return (access && !passed) ? title : passed
};
var NoAccess = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
            children: "You do not currently have access to this functionality."
        })
    });
};
exports.default = FeatureToggle;
var matchedEnv = function(stateApp, envs) {
    try {
        if (typeof envs == "undefined") return false;
        if (envs.length > 0 && envs[0] == (0, _enumDefault.default).Env.ALL) return true;
        return envs.includes(stateApp.env || (0, _enumDefault.default).Env.DEV);
    } catch (e) {
        return false;
    }
};
function hasPolicies() {
    var policies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], stateApp = arguments.length > 1 ? arguments[1] : void 0;
    var hasPolicy = false;
    if (policies && !Array.isArray(policies)) policies = [
        policies
    ];
    var user_roles = stateApp.roles_v2;
    var policy_codes = stateApp.policies;
    // console.log(user_roles)
    if (policies.length == 0) return true;
    if (stateApp.superAdmin) return true;
    if (user_roles.filter(function(e) {
        return e.RoleName == "OrgAdmin";
    }).length > 0) return true;
    for(var i = 0; i < policies.length; i++)if (policy_codes.includes(policies[i])) hasPolicy = true;
    return hasPolicy;
}
var matchedIntegrations = function(state, integrations) {
    try {
        if (typeof integrations == "undefined") return true;
        for(var i = 0; i < (integrations || []).length; i++){
            if (state.integrations.includes(integrations[i])) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};
function matchedClouds(state, clouds) {
    for(var i = 0; i < (clouds || []).length; i++){
        if (clouds[i] == (0, _enumDefault.default).CloudCategory.ALL) return true;
        if (state.clouds.includes(clouds[i])) return true;
    }
    return false;
}
function flatten(ary, prop) {
    var ret = [];
    for(var i = 0; i < ary.length; i++)if (Array.isArray(ary[i][prop])) ret = ret.concat(flatten(ary[i][prop], prop));
    else ret.push(ary[i]);
    return ret;
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","../AppState":"8UGXH","./enum":"3A9fW","react":"gVheC","react-device-detect":"h7vq0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ev7zF":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
function _interopDefault(ex) {
    return ex && (typeof ex === "undefined" ? "undefined" : (0, _typeOf._)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
}
var _extends = _interopDefault(require("8cfa60aa9284ab6"));
var _defineProperty = _interopDefault(require("78c2f44d9c5d7060"));
var _slicedToArray = _interopDefault(require("6ca34311a1c16420"));
var _objectWithoutProperties = _interopDefault(require("70c9412b53941adc"));
var React = require("d1f71127aa09d6ee");
var React__default = _interopDefault(React);
var _classCallCheck = _interopDefault(require("bb73b4861b4868d0"));
var _createClass = _interopDefault(require("f30619dfc94a66c5"));
var _inherits = _interopDefault(require("37165a957e8a6bd6"));
var _possibleConstructorReturn = _interopDefault(require("d49e61a8ce9d22b4"));
var _getPrototypeOf = _interopDefault(require("87785601272759c2"));
var e = [], t = [];
function n(n, r) {
    if (n && "undefined" != typeof document) {
        var a, s = !0 === r.prepend ? "prepend" : "append", d = !0 === r.singleTag, i = "string" == typeof r.container ? document.querySelector(r.container) : document.getElementsByTagName("head")[0];
        if (d) {
            var u = e.indexOf(i);
            -1 === u && (u = e.push(i) - 1, t[u] = {}), a = t[u] && t[u][s] ? t[u][s] : t[u][s] = c();
        } else a = c();
        65279 === n.charCodeAt(0) && (n = n.substring(1)), a.styleSheet ? a.styleSheet.cssText += n : a.appendChild(document.createTextNode(n));
    }
    function c() {
        var e = document.createElement("style");
        if (e.setAttribute("type", "text/css"), r.attributes) for(var t = Object.keys(r.attributes), _$n = 0; _$n < t.length; _$n++)e.setAttribute(t[_$n], r.attributes[t[_$n]]);
        var a = "prepend" === s ? "afterbegin" : "beforeend";
        return i.insertAdjacentElement(a, e), e;
    }
}
var css = "\n.flippy-container *\n{\n    box-sizing: border-box;\n}\n\n.flippy-cardContainer-wrapper\n{\n\tposition: relative;\n\theight: 100%;\n    width: 100%;\n}\n\n.flippy-cardContainer\n{\n    height: 100%;\n    width: 100%;\n    position: relative;\n\n    -webkit-transition: .6s;\n       -moz-transition: .6s;\n        -ms-transition: .6s;\n         -o-transition: .6s;\n            transition: .6s;\n    -moz-transform: perspective(1000px);\n         transform: perspective(1000px);\n\n    -webkit-transform-style: preserve-3d;\n       -moz-transform-style: preserve-3d;\n        -ms-transform-style: preserve-3d;\n         -o-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n}\n\n.flippy-front,\n.flippy-back\n{\n    position: relative;\n\n    width: 100%;\n    height: 100%;\n    padding: 1em;\n\n    -webkit-transform: rotateY(0deg);\n       -moz-transform: rotateY(0deg);\n        -ms-transform: rotateY(0deg);\n         -o-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n\n    background: transparent;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,.2);\n\n    -webkit-backface-visibility: hidden;\n       -moz-backface-visibility: hidden;\n        -ms-backface-visibility: hidden;\n            backface-visibility: hidden;\n    -webkit-transform-style: preserve-3d;\n       -moz-transform-style: preserve-3d;\n         -o-transform-style: preserve-3d;\n        -ms-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n}\n\n.flippy-front\n{\n    -webkit-transform: rotateY(0deg);\n        -ms-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n}\n\n.flippy-back\n{\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    -webkit-transform: rotateY(-180deg);\n       -moz-transform: rotateY(-180deg);\n        -ms-transform: rotateY(-180deg);\n         -o-transform: rotateY(-180deg);\n            transform: rotateY(-180deg);\n}\n\n.flippy-cardContainer.isActive:not(.istouchdevice) .flippy-back,\n.flippy-cardContainer.isActive.istouchdevice .flippy-back\n{\n    -webkit-transform: rotateY(0deg);\n       -moz-transform: rotateY(0deg);\n        -ms-transform: rotateY(0deg);\n         -o-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n}\n\n.flippy-cardContainer.isActive:not(.istouchdevice) .flippy-front,\n.flippy-cardContainer.isActive.istouchdevice .flippy-front\n{\n    -webkit-transform: rotateY(180deg);\n       -moz-transform: rotateY(180deg);\n        -ms-transform: rotateY(180deg);\n         -o-transform: rotateY(180deg);\n            transform: rotateY(180deg);\n}\n\n.flippy-cardContainer-wrapper.vertical .flippy-back\n{\n    -webkit-transform: rotateX(-180deg);\n       -moz-transform: rotateX(-180deg);\n        -ms-transform: rotateX(-180deg);\n         -o-transform: rotateX(-180deg);\n            transform: rotateX(-180deg);\n}\n\n.flippy-cardContainer-wrapper.vertical .flippy-cardContainer.isActive:not(.istouchdevice) .flippy-back,\n.flippy-cardContainer-wrapper.vertical .flippy-cardContainer.isActive.istouchdevice .flippy-back\n{\n    -webkit-transform: rotateX(0deg);\n       -moz-transform: rotateX(0deg);\n        -ms-transform: rotateX(0deg);\n         -o-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n}\n\n.flippy-cardContainer-wrapper.vertical .flippy-cardContainer.isActive:not(.istouchdevice) .flippy-front,\n.flippy-cardContainer-wrapper.vertical .flippy-cardContainer.isActive.istouchdevice .flippy-front\n{\n    -webkit-transform: rotateX(180deg);\n       -moz-transform: rotateX(180deg);\n         -o-transform: rotateX(180deg);\n            transform: rotateX(180deg);\n            transform: rotateX(180deg);\n}\n";
n(css, {});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Flippy = /*#__PURE__*/ React__default.forwardRef(function(_ref, ref) {
    var _isFlipped = _ref.isFlipped, className = _ref.className, flipDirection = _ref.flipDirection, style = _ref.style, children = _ref.children, flipOnHover = _ref.flipOnHover, flipOnClick = _ref.flipOnClick, onClick = _ref.onClick, onTouchStart = _ref.onTouchStart, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, rest = _objectWithoutProperties(_ref, [
        "isFlipped",
        "className",
        "flipDirection",
        "style",
        "children",
        "flipOnHover",
        "flipOnClick",
        "onClick",
        "onTouchStart",
        "onMouseEnter",
        "onMouseLeave"
    ]);
    var simpleFlag = React.useRef({
        isTouchDevice: false
    });
    var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), isTouchDevice = _useState2[0], setTouchDevice = _useState2[1];
    var _useState3 = React.useState(false), _useState4 = _slicedToArray(_useState3, 2), isFlipped = _useState4[0], setFlipped = _useState4[1];
    var toggle = function toggle() {
        return setFlipped(!isFlipped);
    };
    React.useImperativeHandle(ref, function() {
        return {
            toggle: toggle
        };
    });
    var handleTouchStart = function handleTouchStart(event) {
        if (!isTouchDevice) {
            simpleFlag.current.isTouchDevice = true;
            setTouchDevice(true);
        }
        onTouchStart(event);
    };
    var handleMouseEnter = function handleMouseEnter(event) {
        if (flipOnHover && !simpleFlag.current.isTouchDevice) setFlipped(true);
        onMouseEnter(event);
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (flipOnHover && !simpleFlag.current.isTouchDevice) setFlipped(false);
        onMouseLeave(event);
    };
    var handleClick = function handleClick(event) {
        switch(true){
            case flipOnHover && !simpleFlag.current.isTouchDevice:
            case !flipOnClick && !flipOnHover:
                break;
            default:
                setFlipped(!isFlipped);
                break;
        }
        onClick(event);
    };
    React.useEffect(function() {
        if (typeof _isFlipped === 'boolean' && _isFlipped !== isFlipped) setFlipped(_isFlipped);
    }, [
        _isFlipped
    ]);
    return /*#__PURE__*/ React__default.createElement("div", _extends({}, rest, {
        className: "flippy-container ".concat(className || ''),
        style: _objectSpread({}, style),
        onTouchStart: handleTouchStart,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "flippy-cardContainer-wrapper ".concat(flipDirection)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "flippy-cardContainer ".concat(isFlipped ? 'isActive' : '', " ").concat(isTouchDevice ? 'istouchdevice' : '')
    }, children)));
});
Flippy.defaultProps = {
    flipDirection: 'horizontal',
    flipOnHover: false,
    flipOnClick: true,
    isFlipped: false,
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {},
    onTouchStart: function onTouchStart() {},
    onClick: function onClick() {}
};
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var FlippyCard = /*#__PURE__*/ function(_React$Component) {
    _inherits(FlippyCard, _React$Component);
    var _super = _createSuper(FlippyCard);
    function FlippyCard() {
        _classCallCheck(this, FlippyCard);
        return _super.apply(this, arguments);
    }
    _createClass(FlippyCard, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, cardType = _this$props.cardType, style = _this$props.style, elementType = _this$props.elementType, animationDuration = _this$props.animationDuration, rest = _objectWithoutProperties(_this$props, [
                    "className",
                    "cardType",
                    "style",
                    "elementType",
                    "animationDuration"
                ]);
                return /*#__PURE__*/ React__default.createElement(elementType || 'div', _objectSpread$1(_objectSpread$1({
                    className: "flippy-card flippy-".concat(cardType, " ").concat(className || '')
                }, rest), {}, {
                    style: _objectSpread$1(_objectSpread$1({}, style || {}), {
                        transitionDuration: "".concat(animationDuration / 1000, "s")
                    })
                }), this.props.children);
            }
        }
    ]);
    return FlippyCard;
}(React__default.Component);
var FrontSide = function FrontSide(_ref) {
    var isFlipped = _ref.isFlipped, style = _ref.style, animationDuration = _ref.animationDuration, props = _objectWithoutProperties(_ref, [
        "isFlipped",
        "style",
        "animationDuration"
    ]);
    return /*#__PURE__*/ React__default.createElement(FlippyCard, _extends({}, props, {
        style: _objectSpread$1({}, style || {}),
        animationDuration: animationDuration,
        cardType: "front"
    }));
};
var BackSide = function BackSide(_ref2) {
    var isFlipped = _ref2.isFlipped, style = _ref2.style, props = _objectWithoutProperties(_ref2, [
        "isFlipped",
        "style"
    ]);
    return /*#__PURE__*/ React__default.createElement(FlippyCard, _extends({}, props, {
        style: _objectSpread$1({}, style || {}),
        cardType: "back"
    }));
};
FlippyCard.defaultProps = {
    animationDuration: 600
};
exports.BackSide = BackSide;
exports.Flippy = Flippy;
exports.FrontSide = FrontSide;
exports.default = Flippy;

},{"@swc/helpers/_/_type_of":"668P4","8cfa60aa9284ab6":"lKkcq","78c2f44d9c5d7060":"lqVrz","6ca34311a1c16420":"52IcS","70c9412b53941adc":"5K3de","d1f71127aa09d6ee":"gVheC","bb73b4861b4868d0":"1yyab","f30619dfc94a66c5":"4S2iS","37165a957e8a6bd6":"dK1ZD","d49e61a8ce9d22b4":"kJLEO","87785601272759c2":"6M0Ua"}],"52IcS":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"jDaY8","c109e0e3b1a7ef05":"eR43a","6782568c4383bd49":"ikRAk","1e06d43f4bd6e532":"1757X"}],"jDaY8":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"eR43a":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"ikRAk":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"d7ToU"}],"d7ToU":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1757X":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5K3de":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"6F7Pt"}],"1yyab":[function(require,module,exports,__globalThis) {
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4S2iS":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"gWiZy"}],"dK1ZD":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"jUFG4"}],"kJLEO":[function(require,module,exports,__globalThis) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"47zzI","ca3744a9acc8b6f9":"LYz4W"}],"6M0Ua":[function(require,module,exports,__globalThis) {
function _getPrototypeOf(t) {
    return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"21zwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectriaTicketsDashboardTab", function() {
    return ConnectriaTicketsDashboardTab;
});
parcelHelpers.export(exports, "Inbox", function() {
    return Inbox;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _connectriaTicketsBlade = require("./ConnectriaTicketsBlade");
var _advancedTicketSearch = require("./AdvancedTicketSearch");
var _connectriaTicketsState = require("./ConnectriaTicketsState");
var _connectriaTicketsStateDefault = parcelHelpers.interopDefault(_connectriaTicketsState);
var _appState = require("../../AppState");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactRouterDom = require("react-router-dom");
var _dateUtil = require("../../utility/DateUtil");
// reactstrap components
var _reactstrap = require("reactstrap");
var _newTicketButton = require("../SupportAndTicketing/NewTicketButton");
var _newTicketButtonDefault = parcelHelpers.interopDefault(_newTicketButton);
var _misc = require("../misc");
var _tableToCsv = require("../../utility/table-to-csv");
var _reactWidgetsMoment = require("react-widgets-moment");
var _reactWidgetsMomentDefault = parcelHelpers.interopDefault(_reactWidgetsMoment);
var _dateTimePicker = require("react-widgets/lib/DateTimePicker");
var _dateTimePickerDefault = parcelHelpers.interopDefault(_dateTimePicker);
var _reactWidgetsCss = require("react-widgets/dist/css/react-widgets.css");
(0, _momentDefault.default).locale('en');
(0, _reactWidgetsMomentDefault.default)();
var TICKETPULLSIZE = 25;
var statusFilters = [
    [
        "Open",
        "Scheduled",
        "WaitOnCust",
        "New"
    ],
    [
        "New"
    ],
    [
        "Open"
    ],
    [
        "WaitOnCust"
    ],
    [
        "Scheduled"
    ],
    [
        "Resolved"
    ],
    [
        "Closed"
    ],
    [
        "Suspended"
    ],
    [
        "Cancelled"
    ]
];
function getTickets(stateActions, offset, clearInbox, filterState, statusId) {
    return _getTickets.apply(this, arguments);
}
function _getTickets() {
    _getTickets = (0, _asyncToGenerator._)(function(stateActions, offset, clearInbox, filterState, statusId) {
        var params, _filterState_keyword, filter, userId, filters, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyword, promises, allTickets, tickets, i;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : {};
                    stateActions.setIsLoading(true);
                    if (clearInbox) stateActions.clearTickets();
                    filter = {
                        limit: "".concat(offset, ",").concat(TICKETPULLSIZE),
                        select: "tickets.id,subject,priority,created,status,user_id,ticket_type_id,lastUpdate",
                        ar_assoc: "user"
                    };
                    filter.sort_by = "created desc";
                    if (statusId == 0) filter.sort_by = "case when status = 'New' then '1' when status = 'Open' then '2' when status = 'WaitOnCust' then '3' when status = 'Scheduled' then '4' else status end asc, created desc";
                    filter.status = statusFilters[statusId];
                    if (!filterState.filterMine) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, _connectriaTicketsServiceDefault.default).portalUserId(params)
                    ];
                case 1:
                    userId = _state.sent();
                    filter.user_id = userId;
                    _state.label = 2;
                case 2:
                    filters = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if ((filterState === null || filterState === void 0 ? void 0 : (_filterState_keyword = filterState.keyword) === null || _filterState_keyword === void 0 ? void 0 : _filterState_keyword.length) > 0) try {
                        for(_iterator = filterState.keyword[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            keyword = _step.value;
                            filters = (0, _toConsumableArray._)(filters).concat([
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                                    subject: keyword
                                }),
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                                    issue: keyword
                                })
                            ]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else filters = [
                        filter
                    ];
                    promises = filters.map(function(filter) {
                        return (0, _connectriaTicketsServiceDefault.default).getAllTicketsLike(filter, params);
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 3:
                    allTickets = _state.sent();
                    tickets = allTickets.flat();
                    if (allTickets.length > 1) // mergedArray have duplicates, lets remove the duplicates using Set
                    tickets = removeDuplicateTickets(tickets);
                    for(i = 0; i < tickets.length; i++)stateActions.addTicket(tickets[i]);
                    stateActions.setIsLoading(false);
                    return [
                        2,
                        tickets.length
                    ];
            }
        });
    });
    return _getTickets.apply(this, arguments);
}
function getTicketsAdvancedSearch(stateActions, offset, clearInbox, advancedFilterState, statusId) {
    return _getTicketsAdvancedSearch.apply(this, arguments);
}
function _getTicketsAdvancedSearch() {
    _getTicketsAdvancedSearch = (0, _asyncToGenerator._)(function(stateActions, offset, clearInbox, advancedFilterState, statusId) {
        var params, filter, keywords, searchComments, filters, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyword, promises, allTickets, tickets, i;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : {};
                    stateActions.setIsLoading(true);
                    if (clearInbox) stateActions.clearTickets();
                    filter = (0, _objectSpreadProps._)((0, _objectSpread._)({}, advancedFilterState), {
                        limit: "".concat(offset, ",").concat(TICKETPULLSIZE),
                        select: "tickets.id,subject,priority,created,status,user_id,ticket_type_id,lastUpdate",
                        ar_assoc: "user",
                        sort_by: "created desc"
                    });
                    keywords = filter.keyword;
                    if (filter.keyword) // Remove keyword param left over from advancedFilterState
                    delete filter.keyword;
                    searchComments = filter.searchComments;
                    if (filter.searchComments) {
                        filter.ar_assoc += ",comments";
                        delete filter.searchComments;
                        filter.sort_by = "tickets.created desc";
                    }
                    filters = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if ((keywords === null || keywords === void 0 ? void 0 : keywords.length) > 0) try {
                        for(_iterator = keywords[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            keyword = _step.value;
                            filters = (0, _toConsumableArray._)(filters).concat([
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                                    subject: keyword
                                }),
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                                    issue: keyword
                                })
                            ]);
                            if (searchComments) filters.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
                                select: "tickets.id,subject,priority,tickets.created,tickets.status,tickets.user_id,ticket_type_id,lastUpdate",
                                sort_by: "tickets.created desc",
                                ticket_histories: {
                                    comment: keyword,
                                    pvt: 0
                                }
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else filters = [
                        filter
                    ];
                    promises = filters.map(function(filter) {
                        return (0, _connectriaTicketsServiceDefault.default).getAllTicketsLike(filter, params);
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    allTickets = _state.sent();
                    tickets = allTickets.flat();
                    if (allTickets.length > 1) // mergedArray have duplicates, lets remove the duplicates using Set
                    tickets = removeDuplicateTickets(tickets);
                    // all incoming tickets by their created time
                    tickets = tickets.sort(function(a, b) {
                        return (0, _momentDefault.default)(b.created) - (0, _momentDefault.default)(a.created);
                    });
                    for(i = 0; i < tickets.length; i++)stateActions.addTicket(tickets[i]);
                    stateActions.setIsLoading(false);
                    return [
                        2,
                        tickets.length
                    ];
            }
        });
    });
    return _getTicketsAdvancedSearch.apply(this, arguments);
}
function removeDuplicateTickets(tickets) {
    var set = new Set();
    var unionArray = tickets.filter(function(item) {
        if (!set.has(item.id)) {
            set.add(item.id);
            return true;
        }
        return false;
    }, set);
    return unionArray.slice();
}
function showItemBlade(ticketNo, stateApp, stateAppActions) {
    stateAppActions.setBlade({
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                '#' + ticketNo,
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _misc.ClipboardCopyButton), {
                    value: "".concat(window.location.origin, "/app/view/ticket/").concat(ticketNo),
                    tooltipMessage: "Copy ticket link",
                    target: "copy-ticket-link",
                    alertMessage: "Ticket #".concat(ticketNo, " link copied.")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsBlade.NewTabLink), {
                    link: "/app/view/ticket/".concat(ticketNo),
                    tooltipMessage: "Open In New Tab",
                    target: "open-new-tab-link",
                    alertMessage: ''
                })
            ]
        }),
        visible: true,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsBlade.ConnectriaTicketsDetailBlade), {
            id: ticketNo
        })
    });
}
function PriorityBadge(props) {
    var item = (0, _connectriaTicketsServiceDefault.default).ticketPriority(props.priority);
    switch(item.name){
        case "1 - Emergency":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "danger",
                children: item.name
            });
        case "2 - High":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "warning",
                children: item.name
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "secondary",
                children: item.name
            });
    }
}
function StatusBadge(props) {
    // .ticket-New-background {
    //     color: $blue;
    // }
    // .ticket-Open-background {
    //     color: $green;
    // }
    // .ticket-Resolved-background {
    //     color: $yellow;
    // }
    // .ticket-Scheduled-background {
    //     color: $nav-gray;
    // }
    // .ticket-WaitOnCust-background {
    //     color: $red;
    // }
    switch(props.status){
        case "New":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "primary",
                children: props.status
            });
        case "Open":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "success",
                children: props.status
            });
        case "WaitOnCust":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "danger",
                children: "Input Required"
            });
        case "Scheduled":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "secondary",
                children: props.status
            });
        case "Resolved":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "warning",
                children: props.status
            });
        case "Closed":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "",
                children: props.status
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                color: "secondary",
                children: props.status
            });
    }
}
function InboxItems(props) {
    var items = props.tickets;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), types = _useState1[0], setTypes = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), priorities = _useState2[0], setPriorities = _useState2[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var resp, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketTypes({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        resp = _state.sent();
                        setPriorities((0, _connectriaTicketsServiceDefault.default).ticketPriorities());
                        if (!isMounted()) return [
                            2
                        ];
                        setTypes(resp);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    if (isLoading) return null;
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                onClick: function(e) {
                    e.target.className.includes("copy-clipboard") || showItemBlade(item.id, props.stateApp, props.stateAppActions);
                },
                className: "mt-1 mb-1 list-group-item list-group-item-action pointer flex-column align-items-start ticket-".concat(item.status),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex w-100 justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                                        className: "mb-1 d-block d-sm-none",
                                        children: [
                                            "#",
                                            item.id
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                        className: "mb-1 d-none d-md-block",
                                        children: [
                                            "#",
                                            item.id
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _misc.ClipboardCopyButton), {
                                        className: "ml-1 mt-1",
                                        value: "".concat(window.location.origin, "/app/view/ticket/").concat(item.id),
                                        tooltipMessage: "Copy ticket link",
                                        alertMessage: "Ticket #".concat(item.id, " link copied."),
                                        idx: i
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsBlade.NewTabLink), {
                                        itemId: item.id,
                                        link: "/app/view/ticket/".concat(item.id),
                                        tooltipMessage: "Open In New Tab",
                                        alertMessage: ''
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                className: "d-block d-sm-none pull-right",
                                children: [
                                    "Updated: ",
                                    (0, _dateUtil.getReadableDate)(item.lastUpdate, (0, _momentDefault.default)(item.lastUpdate, "YYYY-MM-DDThh:mm:ss.SSSZ").fromNow())
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                className: "d-block d-sm-none",
                                children: [
                                    "Created: ",
                                    (0, _dateUtil.getReadableDate)(item.created, (0, _momentDefault.default)(item.created, "YYYY-MM-DDThh:mm:ss.SSSZ").fromNow())
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "pull-right d-none d-md-block",
                                children: [
                                    "Updated: ",
                                    (0, _dateUtil.getReadableDate)(item.lastUpdate, (0, _momentDefault.default)(item.lastUpdate, "YYYY-MM-DDThh:mm:ss.SSSZ").fromNow())
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "d-none d-md-block",
                                children: [
                                    "Created: ",
                                    (0, _dateUtil.getReadableDate)(item.created, (0, _momentDefault.default)(item.created, "YYYY-MM-DDThh:mm:ss.SSSZ").fromNow())
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-1",
                        children: item.subject
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lead",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                                    status: item.status
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "pl-3",
                                children: [
                                    "Priority:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PriorityBadge, {
                                        priority: item.priority
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "pl-3",
                                children: [
                                    "Type:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "pl-2",
                                        children: (0, _connectriaTicketsServiceDefault.default).ticketType(item.ticket_type_id).name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-md-inline-block pl-lg-3 pt-1 pt-lg-0",
                                children: [
                                    "Owner:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "pl-2",
                                        children: (0, _connectriaTicketsState.createdBy)(item.user)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, item.id);
        })
    });
}
var TicketExportButton = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), gettingData = _useState[0], setGettingData = _useState[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    function getDevicesString(devices) {
        var devicesString = "";
        for(var i = 0; i < devices.length; i++){
            devicesString += devices[i].assettag;
            if (i < devices.length - 1) devicesString += " - ";
        }
        return devicesString;
    }
    function getPrioritiesMap() {
        var priorities = (0, _connectriaTicketsServiceDefault.default).ticketPriorities();
        var prioritiesMap = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = priorities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                prioritiesMap[p.id] = p.name;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return prioritiesMap;
    }
    function getStatusValue(status) {
        if (status == "New") return 1;
        else if (status == "Open") return 2;
        else if (status == "WaitOnCust") return 3;
        return 4;
    }
    var exportTickets = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(statuses, filename_prefix) {
            var tickets, filename;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).exportAllTickets()
                        ];
                    case 1:
                        tickets = _state.sent();
                        setGettingData(false);
                        if (tickets.length === 0) return [
                            2
                        ];
                        // convert tickets to CSV format
                        tickets = tickets.map(function(ticket) {
                            var created = (0, _momentDefault.default)(ticket.Created).format("MM/DD/YY hh:mm:ss");
                            var lastUpdate = (0, _momentDefault.default)(ticket['Last Update On']).format("MM/DD/YY hh:mm:ss");
                            return {
                                "Id": ticket.Id,
                                "CustomerTicket": ticket.CustomerTicket,
                                "Priority/Type": ticket.Priority + " / " + ticket.Type,
                                "Status": ticket.Status === "WaitOnCust" ? "Input Required" : ticket.Status,
                                "Owner": ticket.Owner,
                                "Team": ticket.Team,
                                "Subject": ticket.Subject,
                                "Created": created + " " + ticket['Last Update By'],
                                "Last Update": created === lastUpdate ? null : lastUpdate,
                                "Devices": ticket.Devices,
                                "Ticket Link": "".concat(window.location.origin, "/app/view/ticket/").concat(ticket.Id)
                            };
                        });
                        tickets.sort(function(a, b) {
                            return getStatusValue(a.Status) - getStatusValue(b.Status);
                        });
                        filename = stateApp.userInfo.organization_name + filename_prefix + (0, _momentDefault.default)().format("YYYY-MM-DD_hh-mm-ss") + ".csv";
                        (0, _tableToCsv.CSVUtility).downloadCSVFromJson(filename, tickets);
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: "white"
                                },
                                children: "Tickets successfully exported"
                            }),
                            className: "success",
                            visible: true
                        });
                        setTimeout(function() {
                            stateAppActions.setAlert(function(prevState) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                    visible: false
                                });
                            });
                        }, 2000);
                        return [
                            2
                        ];
                }
            });
        });
        return function exportTickets(statuses, filename_prefix) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "ml-3 my-auto",
        style: {
            fontSize: "15px"
        },
        children: gettingData ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner fa-spin",
            id: "ticket-export-loading"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-file-export",
                    id: "ticket-export-button",
                    onClick: function() {
                        setGettingData(true);
                        exportTickets([
                            "New",
                            "Open",
                            "Scheduled",
                            "WaitOnCust",
                            "Resolved",
                            "Closed",
                            "Suspended",
                            "Cancelled"
                        ], '_All_Tickets_');
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                    placement: "right",
                    target: "ticket-export-button",
                    children: "Export All Tickets For 3 Months"
                })
            ]
        })
    });
};
function Inbox(props) {
    //plugin state
    // const [state, stateActions] = useTriaTicketsState(["isLoading", "tickets", "ticketTypes", "ticketPriorities", "filterMine", "statusId"]);
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), state = _useTriaTicketsState[0], stateActions = _useTriaTicketsState[1];
    //local state
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), loadMore = _useState[0], setLoadMore = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketNo = _useState1[0], setTicketNo = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(true), 2), dataAvailable = _useState2[0], setDataAvailable = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState3[0], setIsError = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(""), 2), query = _useState4[0], setQuery = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(0), 2), offset = _useState5[0], setOffset = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({}), 2), filterState = _useState6[0], setFilterState = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({}), 2), advancedFilterState = _useState7[0], setAdvancedFilterState = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showAdvancedSearch = _useState8[0], setShowAdvancedSearch = _useState8[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    function handleScroll() {
        var scrollTop = (document.scrollingElement || document.documentElement).scrollTop;
        if (window.innerHeight + scrollTop + 1 < document.documentElement.offsetHeight) return;
        setLoadMore(true);
    }
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var cnt, cnt, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!showAdvancedSearch) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getTicketsAdvancedSearch(stateActions, 0, true, advancedFilterState, state.statusId, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        cnt = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            getTickets(stateActions, 0, true, filterState, state.statusId, {
                                cancelToken: source.token
                            })
                        ];
                    case 3:
                        cnt = _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!isMounted()) return [
                            2
                        ];
                        setOffset(TICKETPULLSIZE);
                        if (cnt > 0) {
                            setDataAvailable(true);
                            window.addEventListener("scroll", handleScroll);
                            return [
                                2,
                                function() {
                                    return window.removeEventListener("scroll", handleScroll);
                                }
                            ];
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        console.log("unmount canceled");
        source.cancel();
    }, [
        filterState,
        advancedFilterState
    ]);
    (0, _react.useEffect)(function() {
        if (!loadMore || !dataAvailable) return;
        getMoreData(loadMore);
        setLoadMore(false);
    }, [
        loadMore,
        dataAvailable
    ]);
    var getMoreData = function(load) {
        if (load && !state.isLoading) (function() {
            var _loadTickets = (0, _asyncToGenerator._)(function() {
                var getTicketsFunction, filter, cnt;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (showAdvancedSearch) {
                                getTicketsFunction = getTicketsAdvancedSearch;
                                filter = advancedFilterState;
                            } else {
                                getTicketsFunction = getTickets;
                                filter = filterState;
                            }
                            return [
                                4,
                                getTicketsFunction(stateActions, offset, null, filter, state.statusId, {
                                    cancelToken: source.token
                                })
                            ];
                        case 1:
                            cnt = _state.sent();
                            setOffset(offset + TICKETPULLSIZE);
                            if (cnt == 0) {
                                setLoadMore(false);
                                setDataAvailable(false);
                                window.removeEventListener("scroll", handleScroll);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            function loadTickets() {
                return _loadTickets.apply(this, arguments);
            }
            return loadTickets;
        })()();
    };
    var toggleAdvancedSearch = function(e) {
        setShowAdvancedSearch(!showAdvancedSearch);
        setOffset(0);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showAdvancedSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _advancedTicketSearch.AdvancedTicketSearch), {
                inboxFilterState: advancedFilterState,
                setInboxFilterState: setAdvancedFilterState
            }),
            !showAdvancedSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketFilters, {
                filterState: filterState,
                setFilterState: setFilterState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "inline form-check",
                style: {
                    paddingLeft: "2px"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    className: "form-check-label",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("nobr", {
                            children: "Advanced Search"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            className: "form-check-input",
                            checked: showAdvancedSearch,
                            onChange: toggleAdvancedSearch
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "form-check-sign",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "check"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "list-group mt-1",
                id: "connectria-db-tickets",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InboxItems, {
                    tickets: state.tickets,
                    stateApp: props.stateApp,
                    stateAppActions: props.stateAppActions,
                    statePlugin: props.statePlugin,
                    statePluginActions: props.statePluginActions
                })
            }),
            !state.isLoading && isError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-center mt-4 text-bold",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-exclamation-triangle"
                    }),
                    " Error Loading Tickets."
                ]
            }),
            !state.isLoading && !isError && state.tickets.length == 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-center mt-4 text-bold",
                children: "No tickets found. Try adjusting your filter."
            }),
            state.isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-spinner m-3 mt-4 fa-spin",
                    style: {
                        fontSize: "30px"
                    }
                })
            })
        ]
    });
}
var ConnectriaTicketsDashboardTab = function(props) {
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    // un-comment to collect WAITONCUST count
    // useEffect(() => {
    //     //use an IIFE for async/await
    //     (async function loadCustCount() {
    //         let wcTickets = await ConnectriaTicketsService.allTicketsByStatus("WaitOnCust");
    //         stateAppActions.setInboxCount(wcTickets.length);
    //     })();
    //   }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                id: "connectria-ticket-db-body-title",
                children: "Ticketing Inbox"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Inbox, {
                stateApp: stateApp,
                stateAppActions: stateAppActions
            })
        ]
    });
};
var TicketFilters = function(props) {
    var filterState = props.filterState, setFilterState = props.setFilterState;
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), state = _useTriaTicketsState[0], stateActions = _useTriaTicketsState[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)("0"), 2), statusId = _useState[0], setStatusId = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(""), 2), ticketNo = _useState1[0], setTicketNo = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), keyword = _useState2[0], setKeyword = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), filterMine = _useState3[0], setFilterMine = _useState3[1];
    var handleStatusChange = function(e) {
        var newStatusId = e.target.value;
        setStatusId(statusId);
        stateActions.setStatusId(e.target.value);
        var sort_by = "created desc";
        if (newStatusId == 0) sort_by = "case when status = 'New' then '1' when status = 'Open' then '2' when status = 'WaitOnCust' then '3' when status = 'Scheduled' then '4' else status end asc, created desc";
        setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
            status: statusFilters[newStatusId],
            sort_by: sort_by
        }));
    };
    var handleFilterMine = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filterMine) {
            return (0, _tsGenerator._)(this, function(_state) {
                setFilterMine(filterMine);
                setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                    filterMine: filterMine
                }));
                return [
                    2
                ];
            });
        });
        return function handleFilterMine(filterMine) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeywordChange = function(e, newKeyword) {
        e.preventDefault();
        setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
            keyword: [
                newKeyword
            ]
        }));
    };
    var ticketEntry = function(e) {
        if (e) e.preventDefault();
        showItemBlade(ticketNo, stateApp, stateAppActions);
        setTicketNo("");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "row col-lg-4 col-sm-6 mt-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                type: "select",
                                name: "filterStatus",
                                id: "filterStatus",
                                onChange: handleStatusChange,
                                value: state.statusId,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "0",
                                        children: "All Open"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "1",
                                        children: "New"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "2",
                                        children: "Open"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "3",
                                        children: "Input Required"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "4",
                                        children: "Scheduled"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "5",
                                        children: "Resolved"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "6",
                                        children: "Closed"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "7",
                                        children: "Suspended"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "8",
                                        children: "Cancelled"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                onSubmit: function(e) {
                                    return ticketEntry(e);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                    onChange: function(e) {
                                        return setTicketNo(e.target.value);
                                    },
                                    type: "text",
                                    placeholder: "Ticket #",
                                    value: ticketNo
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex flex-fill col-lg-auto col-sm-12 mt-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                            className: "flex-fill",
                            onSubmit: function(e) {
                                return handleKeywordChange(e, keyword);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                onChange: function(e) {
                                    return setKeyword(e.target.value);
                                },
                                type: "text",
                                placeholder: "Search Subject and Issue",
                                value: keyword
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fa fa-times mr-2",
                            style: {
                                marginLeft: "-20px",
                                marginTop: "12px",
                                cursor: "pointer"
                            },
                            onClick: function(e) {
                                setKeyword("");
                                handleKeywordChange(e, "");
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col-lg-3 col-sm-6 row justify-content-between mt-2",
                    style: {
                        maxWidth: "175px",
                        marginLeft: "2px"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormGroup), {
                            className: "",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "position-relative form-check",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "form-check-label",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("nobr", {
                                            children: "My Tickets"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            className: "form-check-input",
                                            checked: filterMine,
                                            onChange: function(e) {
                                                return handleFilterMine(e.target.checked);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "form-check-sign",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "check"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "my-auto",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newTicketButtonDefault.default), {
                                    className: "connectria-tickets-inbox-btn",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-plus",
                                        id: "inbox-new-ticket-button"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                    placement: "right",
                                    target: "inbox-new-ticket-button",
                                    children: "Create a ticket"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketExportButton, {})
                    ]
                })
            ]
        })
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../../utility/use-async-effect":"fShZN","axios":"ebRwi","../../services/ConnectriaTicketsService":"l5X0I","./ConnectriaTicketsBlade":"2i91X","./AdvancedTicketSearch":"9jp5S","./ConnectriaTicketsState":"2XBXC","../../AppState":"8UGXH","moment":"3xZWN","react-router-dom":"acq4R","../../utility/DateUtil":"i2XgI","reactstrap":"774RE","../SupportAndTicketing/NewTicketButton":"2b9d2","../misc":"5OQBQ","../../utility/table-to-csv":"aw744","react-widgets-moment":"4UbXs","react-widgets/lib/DateTimePicker":"4KVXE","react-widgets/dist/css/react-widgets.css":"kGl4g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5X0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_removeCachedTicketHistory", function() {
    return _removeCachedTicketHistory;
});
parcelHelpers.export(exports, "_removeCachedUsers", function() {
    return _removeCachedUsers;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _axiosExtensions = require("axios-extensions");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _ramda = require("ramda");
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _misc = require("../utility/misc");
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _base_accounts_url = 'https://accounts-api.tria.connectria.com/labs/portal/';
//create a cache axios instance
function _createCacheCall() {
    var extraConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _axiosDefault.default).create((0, _objectSpread._)({
        baseURL: '/',
        headers: {
            'x-auth-token': (0, _cookieServiceDefault.default).getCookie('session_id')
        },
        // disable the default cache and set the cache flag
        adapter: (0, _axiosExtensions.cacheAdapterEnhancer)((0, _axiosDefault.default).defaults.adapter, {
            enabledByDefault: false,
            cacheFlag: 'useCache'
        })
    }, extraConfig));
}
function _createCacheCallNew() {
    return __createCacheCallNew.apply(this, arguments);
}
function __createCacheCallNew() {
    __createCacheCallNew = (0, _asyncToGenerator._)(function() {
        var extraConfig, _, _tmp, _tmp1;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    extraConfig = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _ = (0, _axiosDefault.default).create;
                    _tmp = {
                        baseURL: _base_accounts_url
                    };
                    _tmp1 = {};
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    return [
                        2,
                        _.apply((0, _axiosDefault.default), [
                            (0, _objectSpread._).apply(void 0, [
                                (_tmp.headers = (_tmp1.Authorization = _state.sent(), _tmp1), _tmp.// disable the default cache and set the cache flag
                                adapter = (0, _axiosExtensions.cacheAdapterEnhancer)((0, _axiosDefault.default).defaults.adapter, {
                                    enabledByDefault: false,
                                    cacheFlag: 'useCache'
                                }), _tmp),
                                extraConfig
                            ])
                        ])
                    ];
            }
        });
    });
    return __createCacheCallNew.apply(this, arguments);
}
function defaultRequest() {
    return _defaultRequest.apply(this, arguments);
}
function _defaultRequest() {
    _defaultRequest = (0, _asyncToGenerator._)(function() {
        var idToken, req;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    req = (0, _axiosDefault.default).create({
                        baseURL: _base_accounts_url,
                        headers: {
                            Authorization: idToken
                        }
                    });
                    //req.defaults.headers['Authorization'] = await Cognito.getIdToken();
                    return [
                        2,
                        req
                    ];
            }
        });
    });
    return _defaultRequest.apply(this, arguments);
}
var base_api = 'https://tria.connectria.com';
var _portalTicketsPlugin = '/plugin/support';
var portal_url = 'https://mh.connectria.com';
var files_url = 'https://files.tria.connectria.com/';
var ticketTypes = [];
var inbox = [];
var ticketsByStatus = {};
var ticketDetail = null;
var ticketHistory = null;
var lastTicketDetailId = null;
var lastTicketHistoryId = null;
var ticketAudits = null;
var ticketPriorityMetrics = null;
var userId = null;
var users = [];
var usersMap = {};
var userRatings = null;
function _inboxReturn(limit, offset) {
    return inbox.slice(offset);
}
function _virtualUpdateUserRating(item) {
    if (userRatings == null) userRatings = [];
    //if item exists update if not add
    var indx = userRatings.findIndex(function(x) {
        return x.id == item.id;
    });
    if (indx > -1) userRatings[indx] = item;
    else userRatings.push(item);
}
function _virtualDeleteUserRating(id) {
    userRatings = userRatings.filter(function(item) {
        return item.id !== id;
    });
}
function _getAnnoucments() {
    return __getAnnoucments.apply(this, arguments);
}
function __getAnnoucments() {
    __getAnnoucments = (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/getAnnoucments/getAllLike"), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAnnoucments.apply(this, arguments);
}
function _getPortalAssumeToken() {
    return __getPortalAssumeToken.apply(this, arguments);
}
function __getPortalAssumeToken() {
    __getPortalAssumeToken = (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("/".concat(orgId, "/get_assume_token"), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getPortalAssumeToken.apply(this, arguments);
}
function _getUserTicketRatings(id) {
    return __getUserTicketRatings.apply(this, arguments);
}
function __getUserTicketRatings() {
    __getUserTicketRatings = (0, _asyncToGenerator._)(function(id) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (userRatings != null) return [
                        2,
                        userRatings
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/ticket_history_ratings/getAll"), params)
                    ];
                case 3:
                    request = _state.sent();
                    userRatings = Array.isArray(request.data.response.data.ticket_history_ratings) ? request.data.response.data.ticket_history_ratings : [];
                    return [
                        2,
                        userRatings
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getUserTicketRatings.apply(this, arguments);
}
function _getTicketDetail(id) {
    return __getTicketDetail.apply(this, arguments);
}
function __getTicketDetail() {
    __getTicketDetail = (0, _asyncToGenerator._)(function(id) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (lastTicketDetailId == id && ticketDetail) return [
                        2,
                        ticketDetail
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("/".concat(orgId, "/tickets/get/").concat(id, "?ar_assoc=user,meta,ticket_attachments,ticketcategory,ticket_type,ticket_carbon_copies,enteredby"), params)
                    ];
                case 3:
                    request = _state.sent();
                    lastTicketDetailId = id;
                    ticketDetail = request.data.response.data.tickets[0];
                    return [
                        2,
                        ticketDetail
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketDetail.apply(this, arguments);
}
function _getDevice(deviceID) {
    return __getDevice.apply(this, arguments);
}
function __getDevice() {
    __getDevice = (0, _asyncToGenerator._)(function(deviceID) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/devices/get/").concat(deviceID, "?ar_assoc=operatingsystems,meta,addresses,devicetype"), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getDevice.apply(this, arguments);
}
function _getPortalDevice(deviceID) {
    return __getPortalDevice.apply(this, arguments);
}
function __getPortalDevice() {
    __getPortalDevice = (0, _asyncToGenerator._)(function(deviceID) {
        var params, orgId, url, req, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    url = "".concat(orgId, "/devices/get");
                    if (deviceID) url += '/' + deviceID;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    return [
                        4,
                        req.get(url, {
                            params: params
                        })
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getPortalDevice.apply(this, arguments);
}
function _getAllDevices() {
    return __getAllDevices.apply(this, arguments);
}
function __getAllDevices() {
    __getAllDevices = (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tria/deviceList"), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.devices || []
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllDevices.apply(this, arguments);
}
function _getAllDevicesLike(payload) {
    return __getAllDevicesLike.apply(this, arguments);
}
function __getAllDevicesLike() {
    __getAllDevicesLike = (0, _asyncToGenerator._)(function(payload) {
        var params, http, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    params.useCache = true;
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    http = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        http.get("".concat(orgId, "/devices/getAllLike?"), (0, _objectSpread._)({
                            params: payload
                        }, params))
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.devices || []
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllDevicesLike.apply(this, arguments);
}
function _getAllDevicesById(payload) {
    return __getAllDevicesById.apply(this, arguments);
}
function __getAllDevicesById() {
    __getAllDevicesById = (0, _asyncToGenerator._)(function(payload) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/devices/getAll?"), (0, _objectSpread._)({
                            params: payload
                        }, params))
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.devices || []
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllDevicesById.apply(this, arguments);
}
function _getAllDeviceCount(payload) {
    return __getAllDeviceCount.apply(this, arguments);
}
function __getAllDeviceCount() {
    __getAllDeviceCount = (0, _asyncToGenerator._)(function(payload) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/devices/getCount"), (0, _objectSpread._)({
                            params: payload
                        }, params))
                    ];
                case 3:
                    request = _state.sent();
                    // let request = await axios.get(base_api + `/plugin/support/portal/devices/getCount`, { params: payload, ...params });
                    return [
                        2,
                        request.data.response.data
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllDeviceCount.apply(this, arguments);
}
function _getAllDeviceTypes(payload) {
    return __getAllDeviceTypes.apply(this, arguments);
}
function __getAllDeviceTypes() {
    __getAllDeviceTypes = (0, _asyncToGenerator._)(function(payload) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/devicetypes/getAll"), (0, _objectSpread._)({
                            params: payload
                        }, params))
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.devicetypes || []
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllDeviceTypes.apply(this, arguments);
}
function _getDeviceOSType(id) {
    return __getDeviceOSType.apply(this, arguments);
}
function __getDeviceOSType() {
    __getDeviceOSType = (0, _asyncToGenerator._)(function(id) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/ostypes/get/").concat(id), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.ostypes[0]
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getDeviceOSType.apply(this, arguments);
}
function _updateDevice(id, data) {
    return __updateDevice.apply(this, arguments);
}
function __updateDevice() {
    __updateDevice = (0, _asyncToGenerator._)(function(id, data) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.put("".concat(orgId, "/devices/update/").concat(id), data, params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __updateDevice.apply(this, arguments);
}
function _getAllTicketsCount(filter) {
    return __getAllTicketsCount.apply(this, arguments);
}
function __getAllTicketsCount() {
    __getAllTicketsCount = (0, _asyncToGenerator._)(function(filter) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tickets/getCount"), filter, params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        request.data.response.data.tickets[0]
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllTicketsCount.apply(this, arguments);
}
function _getAllTicketsLike(filter) {
    return __getAllTicketsLike.apply(this, arguments);
}
function __getAllTicketsLike() {
    __getAllTicketsLike = (0, _asyncToGenerator._)(function(filter) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.post("".concat(orgId, "/tickets/getAllLike"), filter, params)
                    ];
                case 3:
                    request = _state.sent();
                    if (request.data.response.data.tickets == null) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        request.data.response.data.tickets
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllTicketsLike.apply(this, arguments);
}
function _getTicketHistory(id) {
    return __getTicketHistory.apply(this, arguments);
}
function __getTicketHistory() {
    __getTicketHistory = (0, _asyncToGenerator._)(function(id) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (lastTicketHistoryId === id && ticketHistory !== null) return [
                        2,
                        ticketHistory.ticket_histories
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/ticket_histories/getAll?ar_assoc=user&ticket_id=").concat(id), params)
                    ];
                case 3:
                    request = _state.sent();
                    lastTicketHistoryId = id;
                    ticketHistory = request.data.response.data;
                    if (ticketHistory.ticket_histories) return [
                        2,
                        ticketHistory.ticket_histories.reverse()
                    ];
                    return [
                        2,
                        null
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketHistory.apply(this, arguments);
}
function _removeCachedTicketHistory() {
    lastTicketHistoryId = null;
    ticketHistory = null;
}
function _removeCachedUsers() {
    users = [];
    usersMap = {};
}
function _downloadAttachment(id) {
    return __downloadAttachment.apply(this, arguments);
}
function __downloadAttachment() {
    __downloadAttachment = (0, _asyncToGenerator._)(function(id) {
        var req, orgId, request, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/ticket_attachments/getRawFile/").concat(id))
                    ];
                case 2:
                    request = _state.sent();
                    return [
                        2,
                        request
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return __downloadAttachment.apply(this, arguments);
}
function _addCommentAttachment(id, filename, content) {
    return __addCommentAttachment.apply(this, arguments);
}
function __addCommentAttachment() {
    __addCommentAttachment = (0, _asyncToGenerator._)(function(id, filename, content) {
        var hasFile, payload, request, req, orgId, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hasFile = filename && filename.length > 0 && content && content.length > 0;
                    if (!hasFile) return [
                        2,
                        false
                    ];
                    payload = {
                        attachment: {
                            filename: (0, _misc.insertString)(filename, (0, _misc.getDateString)(), '.'),
                            json: content
                        },
                        comment: {
                            comment: 'Attached file: ' + filename
                        }
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.post("".concat(orgId, "/tickets/addAttachment/").concat(id, "?origin=tria"), payload)
                    ];
                case 3:
                    request = _state.sent();
                    // if upload was successful, clear cache
                    if (request.data.response.status) {
                        ticketHistory = null;
                        ticketAudits = null;
                        // clear ticket detail cache when attachments are added
                        if (hasFile) {
                            console.log('clearing ticket cache after attachment');
                            ticketDetail = null;
                        }
                    }
                    return [
                        2,
                        request.data.response.message
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        false
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __addCommentAttachment.apply(this, arguments);
}
function _postNewComment(id, comment) {
    return __postNewComment.apply(this, arguments);
}
function __postNewComment() {
    __postNewComment = (0, _asyncToGenerator._)(function(id, comment) {
        var payload, req, orgId, request, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!comment || comment.length < 3) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    payload = {
                        comment: {
                            comment: comment
                        }
                    };
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.post("".concat(orgId, "/tickets/addComment/").concat(id), payload)
                    ];
                case 3:
                    request = _state.sent();
                    //if update was successful, clear cache
                    if (request.data.response.status) {
                        ticketHistory = null;
                        ticketAudits = null;
                    }
                    return [
                        2,
                        request.data.response.message
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __postNewComment.apply(this, arguments);
}
function _getTicketTypes() {
    return __getTicketTypes.apply(this, arguments);
}
function __getTicketTypes() {
    __getTicketTypes = (0, _asyncToGenerator._)(function() {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if (ticketTypes.length != 0) return [
                        2,
                        ticketTypes
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/ticket_types/getAll"), params)
                    ];
                case 3:
                    request = _state.sent();
                    ticketTypes = request.data.response.data.ticket_types;
                    return [
                        2,
                        ticketTypes
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketTypes.apply(this, arguments);
}
function _getAllTicketsByStatus(status) {
    return __getAllTicketsByStatus.apply(this, arguments);
}
function __getAllTicketsByStatus() {
    __getAllTicketsByStatus = (0, _asyncToGenerator._)(function(status) {
        var req, orgId, request, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (ticketsByStatus[status] != null) return [
                        2,
                        ticketsByStatus[status]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tickets/getAll?limit=100&select=tickets.id,+subject,device,ticket_type_id,priority,created,+status,user_id,+lastUpdate&sort_by=lastUpdate+desc&status=") + status)
                    ];
                case 3:
                    request = _state.sent();
                    ticketsByStatus[status] = request.data.response.data.tickets;
                    return [
                        2,
                        ticketsByStatus[status]
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllTicketsByStatus.apply(this, arguments);
}
function _getTicketAudits(limit) {
    return __getTicketAudits.apply(this, arguments);
}
function __getTicketAudits() {
    __getTicketAudits = (0, _asyncToGenerator._)(function(limit) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (ticketAudits != null) return [
                        2,
                        ticketAudits
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tickets/audit?limit=").concat(limit != null ? limit : 15, "&sort_by=lastUpdate+desc"), params)
                    ];
                case 3:
                    request = _state.sent();
                    ticketAudits = request.data.response.data.ticket_audits;
                    return [
                        2,
                        ticketAudits
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketAudits.apply(this, arguments);
}
function _closeTicket(id, comment, rating) {
    return __closeTicket.apply(this, arguments);
}
function __closeTicket() {
    __closeTicket = (0, _asyncToGenerator._)(function(id, comment, rating) {
        var payload, req, orgId, payloadRating, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    payload = {
                        comment: {
                            comment: comment
                        }
                    };
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.put("".concat(orgId, "/tickets/closeTicket/").concat(id), payload)
                    ];
                case 2:
                    _state.sent();
                    if (!rating) return [
                        3,
                        4
                    ];
                    payloadRating = {
                        closed_ticket_rating: {
                            ticket_id: id,
                            closed_ticket_rating_status_id: rating,
                            comment: comment
                        }
                    };
                    return [
                        4,
                        req.post("".concat(orgId, "/closed_ticket_ratings/create"), payloadRating)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    //clear cache
                    ticketDetail = null;
                    return [
                        3,
                        6
                    ];
                case 5:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return __closeTicket.apply(this, arguments);
}
function _getChildTicket(id) {
    return __getChildTicket.apply(this, arguments);
}
function __getChildTicket() {
    __getChildTicket = (0, _asyncToGenerator._)(function(id) {
        var req, orgId, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tickets/child_ticket/getAll?parent_ticket_id=").concat(id))
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return __getChildTicket.apply(this, arguments);
}
function _reopenTicket(id, comment) {
    return __reopenTicket.apply(this, arguments);
}
function __reopenTicket() {
    __reopenTicket = (0, _asyncToGenerator._)(function(id, comment) {
        var payload, req, orgId, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    payload = {
                        comment: {
                            comment: comment
                        }
                    };
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.put("".concat(orgId, "/tickets/reopenTicket/").concat(id), payload)
                    ];
                case 2:
                    _state.sent();
                    //clear cache
                    ticketDetail = null;
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return __reopenTicket.apply(this, arguments);
}
function _getTicketsFiltered(filter) {
    return __getTicketsFiltered.apply(this, arguments);
}
function __getTicketsFiltered() {
    __getTicketsFiltered = (0, _asyncToGenerator._)(function(filter) {
        var params, req, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.post("".concat(orgId, "/tickets/getAll"), filter, params)
                    ];
                case 3:
                    request = _state.sent();
                    if (request.data.response.data.tickets == null) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        request.data.response.data.tickets
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketsFiltered.apply(this, arguments);
}
function _getTicketCategories() {
    return __getTicketCategories.apply(this, arguments);
}
function __getTicketCategories() {
    __getTicketCategories = (0, _asyncToGenerator._)(function() {
        var params, _request_data_response_data_ticketcategories, _request_data_response_data, http, orgId, request, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    params.useCache = true;
                    return [
                        4,
                        _createCacheCallNew()
                    ];
                case 2:
                    http = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        http.get("".concat(orgId, "/ticketcategories/getAll?customeraccess=1&active=1"), params)
                    ];
                case 3:
                    request = _state.sent();
                    return [
                        2,
                        (_request_data_response_data = request.data.response.data) === null || _request_data_response_data === void 0 ? void 0 : (_request_data_response_data_ticketcategories = _request_data_response_data.ticketcategories) === null || _request_data_response_data_ticketcategories === void 0 ? void 0 : _request_data_response_data_ticketcategories.sort(function(a, b) {
                            return a.name.localeCompare(b.name);
                        })
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getTicketCategories.apply(this, arguments);
}
function _getAllUsersLike() {
    return __getAllUsersLike.apply(this, arguments);
}
function __getAllUsersLike() {
    __getAllUsersLike = (0, _asyncToGenerator._)(function() {
        var params, filterConnectria, http, orgId, customer_id, response, n, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, filterConnectria = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                    if (users.length !== 0) return [
                        2,
                        users
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    params.useCache = true;
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    http = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    customer_id = (0, _cookieServiceDefault.default).getCookie('CustomerId');
                    return [
                        4,
                        http.get("".concat(orgId, "/users/getAllLike"), (0, _objectSpreadProps._)((0, _objectSpread._)({}, params), {
                            params: (0, _objectSpreadProps._)((0, _objectSpread._)({}, params === null || params === void 0 ? void 0 : params.params), {
                                customer_id: customer_id
                            })
                        }))
                    ];
                case 3:
                    response = _state.sent();
                    users = response.data.response.data.users || [];
                    if (filterConnectria) users = (users || []).filter(function(user) {
                        return !user.email.includes('@connectria.com');
                    });
                    for(var n in users)usersMap[users[n].id] = users[n];
                    return [
                        2,
                        users
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getAllUsersLike.apply(this, arguments);
}
function _getPreferences(filter) {
    return __getPreferences.apply(this, arguments);
}
function __getPreferences() {
    __getPreferences = (0, _asyncToGenerator._)(function(filter) {
        var params, req, orgId, response, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/preferences/get"), {
                            params: filter
                        }, params)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.data.response.data.preferences
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getPreferences.apply(this, arguments);
}
function _getParamData() {
    return __getParamData.apply(this, arguments);
}
function __getParamData() {
    __getParamData = (0, _asyncToGenerator._)(function() {
        var params, req, orgId, response, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/get_param_data"), params)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getParamData.apply(this, arguments);
}
function _exportAllTickets(months) {
    return __exportAllTickets.apply(this, arguments);
}
function __exportAllTickets() {
    __exportAllTickets = (0, _asyncToGenerator._)(function(months) {
        var params, req, orgId, response, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/tria/exportAllTickets?months=") + months, params)
                    ];
                case 3:
                    response = _state.sent();
                    if (response.data.response.data.tickets == null) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        response.data.response.data.tickets
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __exportAllTickets.apply(this, arguments);
}
var ConnectriaTicketsService = {
    getAllUsersLike: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params, filterConnectriaUsers;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, filterConnectriaUsers = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                    return [
                        4,
                        _getAllUsersLike(params, filterConnectriaUsers)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    getPreferences: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params, _;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _ = 'user_id';
                        return [
                            4,
                            ConnectriaTicketsService.portalUserId(params)
                        ];
                    case 1:
                        filter[_] = _state.sent();
                        return [
                            4,
                            _getPreferences(filter, params)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTicket: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, data) {
            var req, orgId, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.put("".concat(orgId, "/tickets/update/").concat(id), data)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateUsersTicketCarbonCopies: function updateUsersTicketCarbonCopies(ticket) {
        for(var n in ticket.ticket_carbon_copies)ticket.ticket_carbon_copies[n].user = usersMap[ticket.ticket_carbon_copies[n].user_id];
    },
    deleteTicketCarbonCopy: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(ccID) {
            var req, orgId, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.delete("".concat(orgId, "/ticket_carbon_copies/delete/").concat(ccID))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(ccID) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAttachmentUrl: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(ticket_id, attachment_id) {
            var assumeToken;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _getPortalAssumeToken()
                        ];
                    case 1:
                        assumeToken = _state.sent();
                        return [
                            2,
                            files_url + "?id=".concat(attachment_id, "&tid=").concat(ticket_id, "&api_key=").concat(assumeToken.data.portal_assume_token, "&origin=tria")
                        ];
                }
            });
        //return portal_url + `/support/getAttachment?id=${attachment_id}&tid=${ticket_id}&api_key=${assumeToken.data.portal_assume_token}`;
        });
        return function(ticket_id, attachment_id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getPortalAssumeToken: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _getPortalAssumeToken
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    getAnnoucments: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _getAnnoucments(params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    getTicketCommentRatings: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, params) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _getUserTicketRatings(id, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTicketCommentRating: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, rating) {
            var comment, orgId, url, payload, req, response, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        comment = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : '';
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        url = "".concat(orgId, "/ticket_history_ratings/create");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        payload = {
                            ticket_history_rating: {
                                comment: comment,
                                ticket_history_id: id,
                                rating: rating
                            }
                        };
                        console.log(payload);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        return [
                            4,
                            req.post(url, payload)
                        ];
                    case 3:
                        response = _state.sent();
                        if (response.data.response.status) _virtualUpdateUserRating(response.data.response.data.ticket_history_ratings[0]);
                        return [
                            2,
                            response.data.response.data
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, rating) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTicketCommentRating: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, rating) {
            var comment, orgId, url, payload, req, response, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        comment = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : '';
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        url = "".concat(orgId, "/ticket_history_ratings/update");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        payload = {
                            ticket_history_rating: {
                                comment: comment,
                                id: id,
                                rating: rating
                            }
                        };
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        return [
                            4,
                            req.put(url, payload)
                        ];
                    case 3:
                        response = _state.sent();
                        if (response.data.response.status) _virtualUpdateUserRating(response.data.response.data.ticket_history_ratings[0]);
                        return [
                            2,
                            response.data.response.data.ticket_carbon_copies
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, rating) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTicketCommentRating: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var orgId, url, req, response, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        url = "".concat(orgId, "/ticket_history_ratings/delete/").concat(id);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        return [
                            4,
                            req.delete(url)
                        ];
                    case 3:
                        response = _state.sent();
                        if (response.data.response.status) _virtualDeleteUserRating(id);
                        return [
                            2,
                            response.data.response.data
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    saveTicketCarbonCopies: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, users) {
            var users_params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user_id, orgId, url, req, response, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // create ticket carbon copies
                        users_params = '';
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = users[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                user_id = _step.value;
                                users_params += '&ticket_carbon_copies[][user_id]=' + user_id;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        url = "".concat(orgId, "/ticket_carbon_copies/create?ticket_carbon_copies[][ticket_id]=").concat(id).concat(users_params);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        return [
                            4,
                            req.post(url)
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            2,
                            response.data.response.data.ticket_carbon_copies
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, users) {
            return _ref.apply(this, arguments);
        };
    }(),
    getCustomerShortname: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var orgId, url, req, response, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // create ticket carbon copies
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    url = "".concat(orgId, "/customer/short_name");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    return [
                        4,
                        req.get(url)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    }),
    getCustomerTicketCarbonCopies: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params, _, preferences;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _ = 'user_id';
                        return [
                            4,
                            ConnectriaTicketsService.portalUserId(params)
                        ];
                    case 1:
                        filter[_] = _state.sent();
                        return [
                            4,
                            _getPreferences(filter, params)
                        ];
                    case 2:
                        preferences = _state.sent();
                        if (preferences && preferences.length > 0 && preferences[0].value) return [
                            2,
                            JSON.parse(preferences[0].value)
                        ];
                        else return [
                            2,
                            []
                        ];
                        return [
                            2
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    downloadAttachment: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _downloadAttachment(id)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getDevice: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceID) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getDevice(deviceID, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(deviceID) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllDevices: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        _getAllDevices(params)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    getDeviceOSType: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getDeviceOSType(id, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getDeviceIpBulk: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var host_names, promises, req, orgId, i;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    host_names = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [];
                    promises = [];
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    for(i = 0; i < host_names.length; i++)//name consist of device asset tag and .ipam.connpriv.com
                    promises.push(req.get("".concat(orgId, "/hosts/get?name=").concat(host_names[i].toLowerCase() + '.ipam.connpriv.com'), {}));
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    getAllDevicesLike: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllDevicesLike(filter, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllDevicesById: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllDevicesById(filter, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllDeviceCount: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllDeviceCount(filter, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllDeviceTypes: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllDeviceTypes(filter, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllTicketsCount: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(query) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllTicketsCount(query, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }(),
    getAllTicketsLike: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(query) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllTicketsLike(query, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }(),
    exportAllTickets: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var months, params;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    months = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 3, params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    return [
                        4,
                        _exportAllTickets(months, params)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    portalUserId: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var parmas, req, orgId, request;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parmas = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if (userId != null) return [
                        2,
                        userId
                    ];
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/user_id"), parmas)
                    ];
                case 2:
                    request = _state.sent();
                    userId = request.data.user_id;
                    return [
                        2,
                        userId
                    ];
            }
        });
    }),
    createTicket: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(subject, issue, error, priorityId, typeId, deviceId, carbonCopies, categoryId, ticketMeta) {
            var doSentiment, payload, req, orgId, request;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        doSentiment = _arguments.length > 9 && _arguments[9] !== void 0 ? _arguments[9] : false;
                        payload = {
                            tickets: [
                                {
                                    active: false,
                                    errorDesc: error,
                                    id: null,
                                    issue: issue,
                                    priority: priorityId,
                                    status: null,
                                    subject: subject,
                                    device: deviceId || 'undefined',
                                    ticket_carbon_copies: carbonCopies,
                                    ticket_type_id: typeId,
                                    ticketcategory_id: categoryId,
                                    ticket_meta: ticketMeta
                                }
                            ]
                        };
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.post("".concat(orgId, "/tickets/create"), payload)
                        ];
                    case 2:
                        request = _state.sent();
                        return [
                            2,
                            request.data.response.data.tickets[0].id
                        ];
                }
            });
        });
        return function(subject, issue, error, priorityId, typeId, deviceId, carbonCopies, categoryId, ticketMeta) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTicketMeta: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(ticket_id, key, value) {
            var payload, req, orgId, request;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = {
                            ticket_metum: {
                                meta_key: key,
                                meta_value: value,
                                ticket_id: ticket_id
                            }
                        };
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.post("".concat(orgId, "/ticket_meta/create"), payload)
                        ];
                    case 2:
                        request = _state.sent();
                        return [
                            2,
                            request.data.response.data
                        ];
                }
            });
        });
        return function(ticket_id, key, value) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTicketMeta: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var req, orgId, request;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.delete("".concat(orgId, "/ticket_meta/delete/").concat(id))
                        ];
                    case 2:
                        request = _state.sent();
                        return [
                            2,
                            request.data.response.data
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    ticketPriorityMetric: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(daysToInclude) {
            var params, payload, raw, result, i;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        if (ticketPriorityMetrics != null) return [
                            2,
                            ticketPriorityMetrics
                        ];
                        payload = {
                            select: 'priority,created',
                            limit: '200',
                            sort_by: 'created desc'
                        };
                        return [
                            4,
                            _getTicketsFiltered(payload, params)
                        ];
                    case 1:
                        raw = _state.sent();
                        result = {
                            labels: [
                                'Emergency',
                                'High',
                                'Normal',
                                'Low'
                            ],
                            datasets: [
                                {
                                    data: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    backgroundColor: [
                                        '#dc3545',
                                        '#ffc107',
                                        '#777777',
                                        '#adb5bd'
                                    ],
                                    hoverBackgroundColor: [
                                        '#dc3545',
                                        '#ffc107',
                                        '#777777',
                                        '#adb5bd'
                                    ]
                                }
                            ]
                        };
                        for(i = 0; i < raw.length; i++){
                            if ((0, _momentDefault.default)(raw[i].created, 'YYYY-MM-DDThh:mm:ss.SSSZ').days() > daysToInclude) break;
                            result.datasets[0].data[raw[i].priority - 1] = result.datasets[0].data[raw[i].priority - 1] + 1;
                        }
                        ticketPriorityMetrics = result;
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(daysToInclude) {
            return _ref.apply(this, arguments);
        };
    }(),
    closeTicket: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, comment, rating) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _closeTicket(id, comment, rating)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, comment, rating) {
            return _ref.apply(this, arguments);
        };
    }(),
    getChildTicket: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _getChildTicket(id)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    reopenTicket: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, comment) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _reopenTicket(id, comment)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, comment) {
            return _ref.apply(this, arguments);
        };
    }(),
    ticketAudits: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(limit) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getTicketAudits(limit, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(limit) {
            return _ref.apply(this, arguments);
        };
    }(),
    clearTicketCache: function clearTicketCache() {
        ticketDetail = null;
    },
    ticketDetail: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var params, promises, ticket;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            Promise.all([
                                _getTicketTypes(params),
                                _getAllUsersLike(params),
                                _getTicketDetail(id, params)
                            ])
                        ];
                    case 1:
                        promises = _state.sent();
                        ticket = promises[2];
                        this.updateUsersTicketCarbonCopies(ticket);
                        return [
                            2,
                            ticket
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    ticketHistory: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getTicketHistory(id, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    newComment: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, comment) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // clear ticket cache
                        ticketDetail = null;
                        ticketHistory = null;
                        return [
                            4,
                            _postNewComment(id, comment)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id, comment) {
            return _ref.apply(this, arguments);
        };
    }(),
    addAttachment: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id, filename, content) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _addCommentAttachment(id, filename, content)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id, filename, content) {
            return _ref.apply(this, arguments);
        };
    }(),
    ticketCategories: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _getTicketCategories(params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    allTicketsByStatus: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(status) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getAllTicketsLike({
                                ar_assoc: 'user',
                                limit: '0,100',
                                select: 'tickets.id,subject,device,ticket_type_id,priority,created,status,user_id,lastUpdate',
                                sort_by: 'lastUpdate desc',
                                status: status
                            }, params)
                        ];
                    case 1:
                        // return await _getAllTicketsByStatus(status);
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(status) {
            return _ref.apply(this, arguments);
        };
    }(),
    ticketTypes: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        _getTicketTypes(params)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    ticketType: function ticketType(id) {
        for(var i = 0; i < ticketTypes.length; i++){
            if (ticketTypes[i].id == id) return ticketTypes[i];
        }
    },
    ticketPriorities: function ticketPriorities() {
        return [
            {
                id: 1,
                name: '1 - Emergency'
            },
            {
                id: 2,
                name: '2 - High'
            },
            {
                id: 3,
                name: '3 - Normal'
            },
            {
                id: 4,
                name: '4 - Low'
            }
        ];
    },
    ticketPriority: function ticketPriority(id) {
        var priorities = ConnectriaTicketsService.ticketPriorities();
        for(var i = 0; i < priorities.length; i++){
            if (priorities[i].id == id) return priorities[i];
        }
    },
    inbox: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params, payload, _;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        payload = {
                            limit: filter.limit,
                            select: 'tickets.id,subject,priority,created,status,user_id,ticket_type_id,lastUpdate',
                            sort_by: filter.sort
                        };
                        if (filter.statuses != null) payload['status'] = filter.statuses;
                        if (filter.limit != null) {
                            payload['limit'] = filter.limit;
                            if (filter.offset != null) payload['limit'] = "".concat(filter.offset, ",").concat(filter.limit);
                        }
                        if (!filter.justMine) return [
                            3,
                            2
                        ];
                        _ = 'user_id';
                        return [
                            4,
                            ConnectriaTicketsService.portalUserId(params)
                        ];
                    case 1:
                        payload[_] = _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!(filter.search != '')) return [
                            3,
                            4
                        ];
                        if (filter.subjectOnly) payload['subject'] = filter.search;
                        else payload['issue'] = filter.search;
                        return [
                            4,
                            _getAllTicketsLike(payload, params)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        return [
                            4,
                            _getTicketsFiltered(payload, params)
                        ];
                    case 5:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(),
    getParamData: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        _getParamData(params)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    updateDevice: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(data) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _updateDevice(data, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    getPortalDevice: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var params;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            _getPortalDevice(deviceId, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(deviceId) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = ConnectriaTicketsService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","axios-extensions":"7Yc5V","moment":"3xZWN","ramda":"2pVIv","../services/CookieService":"iKLPT","../utility/misc":"bM8Mk","../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Yc5V":[function(require,module,exports,__globalThis) {
/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-09-28
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cache", function() {
    return 0, _lruCacheDefault.default;
});
parcelHelpers.export(exports, "cacheAdapterEnhancer", function() {
    return 0, _cacheAdapterEnhancerDefault.default;
});
parcelHelpers.export(exports, "throttleAdapterEnhancer", function() {
    return 0, _throttleAdapterEnhancerDefault.default;
});
parcelHelpers.export(exports, "retryAdapterEnhancer", function() {
    return 0, _retryAdapterEnhancerDefault.default;
});
var _lruCache = require("lru-cache");
var _lruCacheDefault = parcelHelpers.interopDefault(_lruCache);
var _cacheAdapterEnhancer = require("./cacheAdapterEnhancer");
var _cacheAdapterEnhancerDefault = parcelHelpers.interopDefault(_cacheAdapterEnhancer);
var _retryAdapterEnhancer = require("./retryAdapterEnhancer");
var _retryAdapterEnhancerDefault = parcelHelpers.interopDefault(_retryAdapterEnhancer);
var _throttleAdapterEnhancer = require("./throttleAdapterEnhancer");
var _throttleAdapterEnhancerDefault = parcelHelpers.interopDefault(_throttleAdapterEnhancer);

},{"lru-cache":false,"./cacheAdapterEnhancer":"lpue9","./retryAdapterEnhancer":false,"./throttleAdapterEnhancer":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1CVBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var process = require("616c66ee1a75bb9e");
var perf = (typeof performance === "undefined" ? "undefined" : (0, _typeOf._)(performance)) === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
var hasAbortController = typeof AbortController === 'function';
// minimal backwards-compatibility polyfill
// this doesn't have nearly all the checks and whatnot that
// actual AbortController/Signal has, but it's enough for
// our purposes, and if used properly, behaves the same.
var AC = hasAbortController ? AbortController : /*#__PURE__*/ function() {
    "use strict";
    function AbortController1() {
        (0, _classCallCheck._)(this, AbortController1);
        this.signal = new AS();
    }
    (0, _createClass._)(AbortController1, [
        {
            key: "abort",
            value: function abort() {
                var reason = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Error('This operation was aborted');
                this.signal.reason = this.signal.reason || reason;
                this.signal.aborted = true;
                this.signal.dispatchEvent({
                    type: 'abort',
                    target: this.signal
                });
            }
        }
    ]);
    return AbortController1;
}();
var hasAbortSignal = typeof AbortSignal === 'function';
// Some polyfills put this on the AC class, not global
var hasACAbortSignal = typeof AC.AbortSignal === 'function';
var AS = hasAbortSignal ? AbortSignal : hasACAbortSignal ? AC.AbortController : /*#__PURE__*/ function() {
    "use strict";
    function AbortSignal1() {
        (0, _classCallCheck._)(this, AbortSignal1);
        this.reason = undefined;
        this.aborted = false;
        this._listeners = [];
    }
    (0, _createClass._)(AbortSignal1, [
        {
            key: "dispatchEvent",
            value: function dispatchEvent(e) {
                if (e.type === 'abort') {
                    this.aborted = true;
                    this.onabort(e);
                    this._listeners.forEach(function(f) {
                        return f(e);
                    }, this);
                }
            }
        },
        {
            key: "onabort",
            value: function onabort() {}
        },
        {
            key: "addEventListener",
            value: function addEventListener(ev, fn) {
                if (ev === 'abort') this._listeners.push(fn);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(ev, fn) {
                if (ev === 'abort') this._listeners = this._listeners.filter(function(f) {
                    return f !== fn;
                });
            }
        }
    ]);
    return AbortSignal1;
}();
var warned = new Set();
var deprecatedOption = function(opt, instead) {
    var code = "LRU_CACHE_OPTION_".concat(opt);
    if (shouldWarn(code)) warn(code, "".concat(opt, " option"), "options.".concat(instead), LRUCache);
};
var deprecatedMethod = function(method, instead) {
    var code = "LRU_CACHE_METHOD_".concat(method);
    if (shouldWarn(code)) {
        var prototype = LRUCache.prototype;
        var get = Object.getOwnPropertyDescriptor(prototype, method).get;
        warn(code, "".concat(method, " method"), "cache.".concat(instead, "()"), get);
    }
};
var deprecatedProperty = function(field, instead) {
    var code = "LRU_CACHE_PROPERTY_".concat(field);
    if (shouldWarn(code)) {
        var prototype = LRUCache.prototype;
        var get = Object.getOwnPropertyDescriptor(prototype, field).get;
        warn(code, "".concat(field, " property"), "cache.".concat(instead), get);
    }
};
var emitWarning = function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    var _process, _console;
    (typeof process === "undefined" ? "undefined" : (0, _typeOf._)(process)) === 'object' && process && typeof process.emitWarning === 'function' ? (_process = process).emitWarning.apply(_process, (0, _toConsumableArray._)(a)) : (_console = console).error.apply(_console, (0, _toConsumableArray._)(a));
};
var shouldWarn = function(code) {
    return !warned.has(code);
};
var warn = function(code, what, instead, fn) {
    warned.add(code);
    var msg = "The ".concat(what, " is deprecated. Please use ").concat(instead, " instead.");
    emitWarning(msg, 'DeprecationWarning', code, fn);
};
var isPosInt = function(n) {
    return n && n === Math.floor(n) && n > 0 && isFinite(n);
};
/* istanbul ignore next - This is a little bit ridiculous, tbh.
 * The maximum array length is 2^32-1 or thereabouts on most JS impls.
 * And well before that point, you're caching the entire world, I mean,
 * that's ~32GB of just integers for the next/prev links, plus whatever
 * else to hold that many keys and values.  Just filling the memory with
 * zeroes at init time is brutal when you get that big.
 * But why not be complete?
 * Maybe in the future, these limits will have expanded. */ var getUintArray = function(max) {
    return !isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? ZeroArray : null;
};
var ZeroArray = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, _inherits._)(ZeroArray, Array1);
    function ZeroArray(size) {
        (0, _classCallCheck._)(this, ZeroArray);
        var _this;
        _this = (0, _callSuper._)(this, ZeroArray, [
            size
        ]);
        _this.fill(0);
        return _this;
    }
    return ZeroArray;
}((0, _wrapNativeSuper._)(Array));
var Stack = /*#__PURE__*/ function() {
    "use strict";
    function Stack(max) {
        (0, _classCallCheck._)(this, Stack);
        if (max === 0) return [];
        var UintArray = getUintArray(max);
        this.heap = new UintArray(max);
        this.length = 0;
    }
    (0, _createClass._)(Stack, [
        {
            key: "push",
            value: function push(n) {
                this.heap[this.length++] = n;
            }
        },
        {
            key: "pop",
            value: function pop() {
                return this.heap[--this.length];
            }
        }
    ]);
    return Stack;
}();
var LRUCache = /*#__PURE__*/ function() {
    "use strict";
    function LRUCache() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, LRUCache);
        var _options_max = options.max, max = _options_max === void 0 ? 0 : _options_max, ttl = options.ttl, _options_ttlResolution = options.ttlResolution, ttlResolution = _options_ttlResolution === void 0 ? 1 : _options_ttlResolution, ttlAutopurge = options.ttlAutopurge, updateAgeOnGet = options.updateAgeOnGet, updateAgeOnHas = options.updateAgeOnHas, allowStale = options.allowStale, dispose = options.dispose, disposeAfter = options.disposeAfter, noDisposeOnSet = options.noDisposeOnSet, noUpdateTTL = options.noUpdateTTL, _options_maxSize = options.maxSize, maxSize = _options_maxSize === void 0 ? 0 : _options_maxSize, _options_maxEntrySize = options.maxEntrySize, maxEntrySize = _options_maxEntrySize === void 0 ? 0 : _options_maxEntrySize, sizeCalculation = options.sizeCalculation, fetchMethod = options.fetchMethod, fetchContext = options.fetchContext, noDeleteOnFetchRejection = options.noDeleteOnFetchRejection, noDeleteOnStaleGet = options.noDeleteOnStaleGet, allowStaleOnFetchRejection = options.allowStaleOnFetchRejection, allowStaleOnFetchAbort = options.allowStaleOnFetchAbort, ignoreFetchAbort = options.ignoreFetchAbort;
        // deprecated options, don't trigger a warning for getting them if
        // the thing being passed in is another LRUCache we're copying.
        var _ref = options instanceof LRUCache ? {} : options, length = _ref.length, maxAge = _ref.maxAge, stale = _ref.stale;
        if (max !== 0 && !isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        var UintArray = max ? getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        this.max = max;
        this.maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.maxSize;
        this.sizeCalculation = sizeCalculation || length;
        if (this.sizeCalculation) {
            if (!this.maxSize && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        this.fetchMethod = fetchMethod || null;
        if (this.fetchMethod && typeof this.fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        this.fetchContext = fetchContext;
        if (!this.fetchMethod && fetchContext !== undefined) throw new TypeError('cannot set fetchContext without fetchMethod');
        this.keyMap = new Map();
        this.keyList = new Array(max).fill(null);
        this.valList = new Array(max).fill(null);
        this.next = new UintArray(max);
        this.prev = new UintArray(max);
        this.head = 0;
        this.tail = 0;
        this.free = new Stack(max);
        this.initialFill = 1;
        this.size = 0;
        if (typeof dispose === 'function') this.dispose = dispose;
        if (typeof disposeAfter === 'function') {
            this.disposeAfter = disposeAfter;
            this.disposed = [];
        } else {
            this.disposeAfter = null;
            this.disposed = null;
        }
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.maxSize !== 0) {
                if (!isPosInt(this.maxSize)) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            this.initializeSizeTracking();
        }
        this.allowStale = !!allowStale || !!stale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || maxAge || 0;
        if (this.ttl) {
            if (!isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            this.initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.max === 0 && this.ttl === 0 && this.maxSize === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !this.max && !this.maxSize) {
            var code = 'LRU_CACHE_UNBOUNDED';
            if (shouldWarn(code)) {
                warned.add(code);
                var msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
        if (stale) deprecatedOption('stale', 'allowStale');
        if (maxAge) deprecatedOption('maxAge', 'ttl');
        if (length) deprecatedOption('length', 'sizeCalculation');
    }
    (0, _createClass._)(LRUCache, [
        {
            key: "getRemainingTTL",
            value: function getRemainingTTL(key) {
                return this.has(key, {
                    updateAgeOnHas: false
                }) ? Infinity : 0;
            }
        },
        {
            key: "initializeTTLTracking",
            value: function initializeTTLTracking() {
                var _this = this;
                var _this1 = this;
                this.ttls = new ZeroArray(this.max);
                this.starts = new ZeroArray(this.max);
                this.setItemTTL = function(index, ttl) {
                    var start = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : perf.now();
                    _this1.starts[index] = ttl !== 0 ? start : 0;
                    _this1.ttls[index] = ttl;
                    if (ttl !== 0 && _this1.ttlAutopurge) {
                        var t = setTimeout(function() {
                            if (_this1.isStale(index)) _this1.delete(_this1.keyList[index]);
                        }, ttl + 1);
                        /* istanbul ignore else - unref() not supported on all platforms */ if (t.unref) t.unref();
                    }
                };
                this.updateItemAge = function(index) {
                    _this.starts[index] = _this.ttls[index] !== 0 ? perf.now() : 0;
                };
                this.statusTTL = function(status, index) {
                    if (status) {
                        status.ttl = _this.ttls[index];
                        status.start = _this.starts[index];
                        status.now = cachedNow || getNow();
                        status.remainingTTL = status.now + status.ttl - status.start;
                    }
                };
                // debounce calls to perf.now() to 1s so we're not hitting
                // that costly call repeatedly.
                var cachedNow = 0;
                var getNow = function() {
                    var n = perf.now();
                    if (_this.ttlResolution > 0) {
                        cachedNow = n;
                        var t = setTimeout(function() {
                            return cachedNow = 0;
                        }, _this.ttlResolution);
                        /* istanbul ignore else - not available on all platforms */ if (t.unref) t.unref();
                    }
                    return n;
                };
                this.getRemainingTTL = function(key) {
                    var index = _this.keyMap.get(key);
                    if (index === undefined) return 0;
                    return _this.ttls[index] === 0 || _this.starts[index] === 0 ? Infinity : _this.starts[index] + _this.ttls[index] - (cachedNow || getNow());
                };
                this.isStale = function(index) {
                    return _this.ttls[index] !== 0 && _this.starts[index] !== 0 && (cachedNow || getNow()) - _this.starts[index] > _this.ttls[index];
                };
            }
        },
        {
            key: "updateItemAge",
            value: function updateItemAge(_index) {}
        },
        {
            key: "statusTTL",
            value: function statusTTL(_status, _index) {}
        },
        {
            key: "setItemTTL",
            value: function setItemTTL(_index, _ttl, _start) {}
        },
        {
            key: "isStale",
            value: function isStale(_index) {
                return false;
            }
        },
        {
            key: "initializeSizeTracking",
            value: function initializeSizeTracking() {
                var _this = this;
                this.calculatedSize = 0;
                this.sizes = new ZeroArray(this.max);
                this.removeItemSize = function(index) {
                    _this.calculatedSize -= _this.sizes[index];
                    _this.sizes[index] = 0;
                };
                this.requireSize = function(k, v, size, sizeCalculation) {
                    // provisionally accept background fetches.
                    // actual value size will be checked when they return.
                    if (_this.isBackgroundFetch(v)) return 0;
                    if (!isPosInt(size)) {
                        if (sizeCalculation) {
                            if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                            size = sizeCalculation(v, k);
                            if (!isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                        } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
                    }
                    return size;
                };
                this.addItemSize = function(index, size, status) {
                    _this.sizes[index] = size;
                    if (_this.maxSize) {
                        var maxSize = _this.maxSize - _this.sizes[index];
                        while(_this.calculatedSize > maxSize)_this.evict(true);
                    }
                    _this.calculatedSize += _this.sizes[index];
                    if (status) {
                        status.entrySize = size;
                        status.totalCalculatedSize = _this.calculatedSize;
                    }
                };
            }
        },
        {
            key: "removeItemSize",
            value: function removeItemSize(_index) {}
        },
        {
            key: "addItemSize",
            value: function addItemSize(_index, _size) {}
        },
        {
            key: "requireSize",
            value: function requireSize(_k, _v, size, sizeCalculation) {
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
            }
        },
        {
            key: "indexes",
            value: function indexes() {
                var _ref, _ref_allowStale, allowStale, i;
                var _arguments = arguments;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                            if (!this.size) return [
                                3,
                                5
                            ];
                            i = this.tail;
                            _state.label = 1;
                        case 1:
                            if (!this.isValidIndex(i)) return [
                                3,
                                5
                            ];
                            if (!(allowStale || !this.isStale(i))) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                i
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            if (i === this.head) return [
                                3,
                                5
                            ];
                            else i = this.prev[i];
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                1
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rindexes",
            value: function rindexes() {
                var _ref, _ref_allowStale, allowStale, i;
                var _arguments = arguments;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                            if (!this.size) return [
                                3,
                                5
                            ];
                            i = this.head;
                            _state.label = 1;
                        case 1:
                            if (!this.isValidIndex(i)) return [
                                3,
                                5
                            ];
                            if (!(allowStale || !this.isStale(i))) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                i
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            if (i === this.tail) return [
                                3,
                                5
                            ];
                            else i = this.next[i];
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                1
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "isValidIndex",
            value: function isValidIndex(index) {
                return index !== undefined && this.keyMap.get(this.keyList[index]) === index;
            }
        },
        {
            key: "entries",
            value: function entries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.indexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.valList[i] !== undefined && this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    this.keyList[i],
                                    this.valList[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rentries",
            value: function rentries() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.rindexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.valList[i] !== undefined && this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                [
                                    this.keyList[i],
                                    this.valList[i]
                                ]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "keys",
            value: function keys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.indexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.keyList[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rkeys",
            value: function rkeys() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.rindexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.keyList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.keyList[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "values",
            value: function values() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.indexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.valList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.valList[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "rvalues",
            value: function rvalues() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, i, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _iterator = this.rindexes()[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            i = _step.value;
                            if (!(this.valList[i] !== undefined && !this.isBackgroundFetch(this.valList[i]))) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.valList[i]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return this.entries();
            }
        },
        {
            key: "find",
            value: function find(fn, getOptions) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.indexes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = this.valList[i];
                        var value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        if (fn(value, this.keyList[i], this)) return this.get(this.keyList[i], getOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.indexes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = this.valList[i];
                        var value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, this.keyList[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "rforEach",
            value: function rforEach(fn) {
                var thisp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.rindexes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var v = this.valList[i];
                        var value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        fn.call(thisp, value, this.keyList[i], this);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "prune",
            get: function get() {
                deprecatedMethod('prune', 'purgeStale');
                return this.purgeStale;
            }
        },
        {
            key: "purgeStale",
            value: function purgeStale() {
                var deleted = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.rindexes({
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        if (this.isStale(i)) {
                            this.delete(this.keyList[i]);
                            deleted = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return deleted;
            }
        },
        {
            key: "dump",
            value: function dump() {
                var arr = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.indexes({
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var key = this.keyList[i];
                        var v = this.valList[i];
                        var value = this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
                        if (value === undefined) continue;
                        var entry = {
                            value: value
                        };
                        if (this.ttls) {
                            entry.ttl = this.ttls[i];
                            // always dump the start relative to a portable timestamp
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = perf.now() - this.starts[i];
                            entry.start = Math.floor(Date.now() - age);
                        }
                        if (this.sizes) entry.size = this.sizes[i];
                        arr.unshift([
                            key,
                            entry
                        ]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return arr;
            }
        },
        {
            key: "load",
            value: function load(arr) {
                this.clear();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], entry = _step_value[1];
                        if (entry.start) {
                            // entry.start is a portable timestamp, but we may be using
                            // node's performance.now(), so calculate the offset.
                            // it's ok for this to be a bit slow, it's a rare operation.
                            var age = Date.now() - entry.start;
                            entry.start = perf.now() - age;
                        }
                        this.set(key, entry.value, entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose(_v, _k, _reason) {}
        },
        {
            key: "set",
            value: function set(k, v) {
                var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_ttl = _ref.ttl, ttl = _ref_ttl === void 0 ? this.ttl : _ref_ttl, start = _ref.start, _ref_noDisposeOnSet = _ref.noDisposeOnSet, noDisposeOnSet = _ref_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref_noDisposeOnSet, _ref_size = _ref.size, size = _ref_size === void 0 ? 0 : _ref_size, _ref_sizeCalculation = _ref.sizeCalculation, sizeCalculation = _ref_sizeCalculation === void 0 ? this.sizeCalculation : _ref_sizeCalculation, _ref_noUpdateTTL = _ref.noUpdateTTL, noUpdateTTL = _ref_noUpdateTTL === void 0 ? this.noUpdateTTL : _ref_noUpdateTTL, status = _ref.status;
                size = this.requireSize(k, v, size, sizeCalculation);
                // if the item doesn't fit, don't do anything
                // NB: maxEntrySize set to maxSize by default
                if (this.maxEntrySize && size > this.maxEntrySize) {
                    if (status) {
                        status.set = 'miss';
                        status.maxEntrySizeExceeded = true;
                    }
                    // have to delete, in case a background fetch is there already.
                    // in non-async cases, this is a no-op
                    this.delete(k);
                    return this;
                }
                var index = this.size === 0 ? undefined : this.keyMap.get(k);
                if (index === undefined) {
                    // addition
                    index = this.newIndex();
                    this.keyList[index] = k;
                    this.valList[index] = v;
                    this.keyMap.set(k, index);
                    this.next[this.tail] = index;
                    this.prev[index] = this.tail;
                    this.tail = index;
                    this.size++;
                    this.addItemSize(index, size, status);
                    if (status) status.set = 'add';
                    noUpdateTTL = false;
                } else {
                    // update
                    this.moveToTail(index);
                    var oldVal = this.valList[index];
                    if (v !== oldVal) {
                        if (this.isBackgroundFetch(oldVal)) oldVal.__abortController.abort(new Error('replaced'));
                        else if (!noDisposeOnSet) {
                            this.dispose(oldVal, k, 'set');
                            if (this.disposeAfter) this.disposed.push([
                                oldVal,
                                k,
                                'set'
                            ]);
                        }
                        this.removeItemSize(index);
                        this.valList[index] = v;
                        this.addItemSize(index, size, status);
                        if (status) {
                            status.set = 'replace';
                            var oldValue = oldVal && this.isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                            if (oldValue !== undefined) status.oldValue = oldValue;
                        }
                    } else if (status) status.set = 'update';
                }
                if (ttl !== 0 && this.ttl === 0 && !this.ttls) this.initializeTTLTracking();
                if (!noUpdateTTL) this.setItemTTL(index, ttl, start);
                this.statusTTL(status, index);
                if (this.disposeAfter) while(this.disposed.length)this.disposeAfter.apply(this, (0, _toConsumableArray._)(this.disposed.shift()));
                return this;
            }
        },
        {
            key: "newIndex",
            value: function newIndex() {
                if (this.size === 0) return this.tail;
                if (this.size === this.max && this.max !== 0) return this.evict(false);
                if (this.free.length !== 0) return this.free.pop();
                // initial fill, just keep writing down the list
                return this.initialFill++;
            }
        },
        {
            key: "pop",
            value: function pop() {
                if (this.size) {
                    var val = this.valList[this.head];
                    this.evict(true);
                    return val;
                }
            }
        },
        {
            key: "evict",
            value: function evict(free) {
                var head = this.head;
                var k = this.keyList[head];
                var v = this.valList[head];
                if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error('evicted'));
                else {
                    this.dispose(v, k, 'evict');
                    if (this.disposeAfter) this.disposed.push([
                        v,
                        k,
                        'evict'
                    ]);
                }
                this.removeItemSize(head);
                // if we aren't about to use the index, then null these out
                if (free) {
                    this.keyList[head] = null;
                    this.valList[head] = null;
                    this.free.push(head);
                }
                this.head = this.next[head];
                this.keyMap.delete(k);
                this.size--;
                return head;
            }
        },
        {
            key: "has",
            value: function has(k) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_updateAgeOnHas = _ref.updateAgeOnHas, updateAgeOnHas = _ref_updateAgeOnHas === void 0 ? this.updateAgeOnHas : _ref_updateAgeOnHas, status = _ref.status;
                var index = this.keyMap.get(k);
                if (index !== undefined) {
                    if (!this.isStale(index)) {
                        if (updateAgeOnHas) this.updateItemAge(index);
                        if (status) status.has = 'hit';
                        this.statusTTL(status, index);
                        return true;
                    } else if (status) {
                        status.has = 'stale';
                        this.statusTTL(status, index);
                    }
                } else if (status) status.has = 'miss';
                return false;
            }
        },
        {
            // like get(), but without any LRU updating or TTL expiration
            key: "peek",
            value: function peek(k) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale;
                var index = this.keyMap.get(k);
                if (index !== undefined && (allowStale || !this.isStale(index))) {
                    var v = this.valList[index];
                    // either stale and allowed, or forcing a refresh of non-stale value
                    return this.isBackgroundFetch(v) ? v.__staleWhileFetching : v;
                }
            }
        },
        {
            key: "backgroundFetch",
            value: function backgroundFetch(k, index, options, context) {
                var _this = this;
                var _this1 = this;
                var v = index === undefined ? undefined : this.valList[index];
                if (this.isBackgroundFetch(v)) return v;
                var ac = new AC();
                if (options.signal) options.signal.addEventListener('abort', function() {
                    return ac.abort(options.signal.reason);
                });
                var fetchOpts = {
                    signal: ac.signal,
                    options: options,
                    context: context
                };
                var cb = function(v) {
                    var updateCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var aborted = ac.signal.aborted;
                    var ignoreAbort = options.ignoreFetchAbort && v !== undefined;
                    if (options.status) {
                        if (aborted && !updateCache) {
                            options.status.fetchAborted = true;
                            options.status.fetchError = ac.signal.reason;
                            if (ignoreAbort) options.status.fetchAbortIgnored = true;
                        } else options.status.fetchResolved = true;
                    }
                    if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
                    // either we didn't abort, and are still here, or we did, and ignored
                    if (_this1.valList[index] === p) {
                        if (v === undefined) {
                            if (p.__staleWhileFetching) _this1.valList[index] = p.__staleWhileFetching;
                            else _this1.delete(k);
                        } else {
                            if (options.status) options.status.fetchUpdated = true;
                            _this1.set(k, v, fetchOpts.options);
                        }
                    }
                    return v;
                };
                var eb = function(er) {
                    if (options.status) {
                        options.status.fetchRejected = true;
                        options.status.fetchError = er;
                    }
                    return fetchFail(er);
                };
                var fetchFail = function(er) {
                    var aborted = ac.signal.aborted;
                    var allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
                    var allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
                    var noDelete = allowStale || options.noDeleteOnFetchRejection;
                    if (_this.valList[index] === p) {
                        // if we allow stale on fetch rejections, then we need to ensure that
                        // the stale value is not removed from the cache when the fetch fails.
                        var del = !noDelete || p.__staleWhileFetching === undefined;
                        if (del) _this.delete(k);
                        else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                        // since we are done with the promise at this point.
                        // leave it untouched if we're still waiting for an
                        // aborted background fetch that hasn't yet returned.
                        _this.valList[index] = p.__staleWhileFetching;
                    }
                    if (allowStale) {
                        if (options.status && p.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                        return p.__staleWhileFetching;
                    } else if (p.__returned === p) throw er;
                };
                var pcall = function(res, rej) {
                    _this.fetchMethod(k, v, fetchOpts).then(function(v) {
                        return res(v);
                    }, rej);
                    // ignored, we go until we finish, regardless.
                    // defer check until we are actually aborting,
                    // so fetchMethod can override.
                    ac.signal.addEventListener('abort', function() {
                        if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                            res();
                            // when it eventually resolves, update the cache.
                            if (options.allowStaleOnFetchAbort) res = function(v) {
                                return cb(v, true);
                            };
                        }
                    });
                };
                if (options.status) options.status.fetchDispatched = true;
                var p = new Promise(pcall).then(cb, eb);
                p.__abortController = ac;
                p.__staleWhileFetching = v;
                p.__returned = null;
                if (index === undefined) {
                    // internal, don't expose status.
                    this.set(k, p, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fetchOpts.options), {
                        status: undefined
                    }));
                    index = this.keyMap.get(k);
                } else this.valList[index] = p;
                return p;
            }
        },
        {
            key: "isBackgroundFetch",
            value: function isBackgroundFetch(p) {
                return p && (typeof p === "undefined" ? "undefined" : (0, _typeOf._)(p)) === 'object' && typeof p.then === 'function' && Object.prototype.hasOwnProperty.call(p, '__staleWhileFetching') && Object.prototype.hasOwnProperty.call(p, '__returned') && (p.__returned === p || p.__returned === null);
            }
        },
        {
            key: "fetch",
            value: // this takes the union of get() and set() opts, because it does both
            function fetch(k) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_allowStale = _ref.// get options
                allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale, _ref_updateAgeOnGet = _ref.updateAgeOnGet, updateAgeOnGet = _ref_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref_updateAgeOnGet, _ref_noDeleteOnStaleGet = _ref.noDeleteOnStaleGet, noDeleteOnStaleGet = _ref_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _ref_noDeleteOnStaleGet, _ref_ttl = _ref.// set options
                ttl, ttl = _ref_ttl === void 0 ? this.ttl : _ref_ttl, _ref_noDisposeOnSet = _ref.noDisposeOnSet, noDisposeOnSet = _ref_noDisposeOnSet === void 0 ? this.noDisposeOnSet : _ref_noDisposeOnSet, _ref_size = _ref.size, size = _ref_size === void 0 ? 0 : _ref_size, _ref_sizeCalculation = _ref.sizeCalculation, sizeCalculation = _ref_sizeCalculation === void 0 ? this.sizeCalculation : _ref_sizeCalculation, _ref_noUpdateTTL = _ref.noUpdateTTL, noUpdateTTL = _ref_noUpdateTTL === void 0 ? this.noUpdateTTL : _ref_noUpdateTTL, _ref_noDeleteOnFetchRejection = _ref.// fetch exclusive options
                noDeleteOnFetchRejection, noDeleteOnFetchRejection = _ref_noDeleteOnFetchRejection === void 0 ? this.noDeleteOnFetchRejection : _ref_noDeleteOnFetchRejection, _ref_allowStaleOnFetchRejection = _ref.allowStaleOnFetchRejection, allowStaleOnFetchRejection = _ref_allowStaleOnFetchRejection === void 0 ? this.allowStaleOnFetchRejection : _ref_allowStaleOnFetchRejection, _ref_ignoreFetchAbort = _ref.ignoreFetchAbort, ignoreFetchAbort = _ref_ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _ref_ignoreFetchAbort, _ref_allowStaleOnFetchAbort = _ref.allowStaleOnFetchAbort, allowStaleOnFetchAbort = _ref_allowStaleOnFetchAbort === void 0 ? this.allowStaleOnFetchAbort : _ref_allowStaleOnFetchAbort, _ref_fetchContext = _ref.fetchContext, fetchContext = _ref_fetchContext === void 0 ? this.fetchContext : _ref_fetchContext, _ref_forceRefresh = _ref.forceRefresh, forceRefresh = _ref_forceRefresh === void 0 ? false : _ref_forceRefresh, status = _ref.status, signal = _ref.signal;
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var options, index, p, v, stale, isStale, p1, hasStale, staleVal;
                    return (0, _tsGenerator._)(this, function(_state) {
                        if (!_this.fetchMethod) {
                            if (status) status.fetch = 'get';
                            return [
                                2,
                                _this.get(k, {
                                    allowStale: allowStale,
                                    updateAgeOnGet: updateAgeOnGet,
                                    noDeleteOnStaleGet: noDeleteOnStaleGet,
                                    status: status
                                })
                            ];
                        }
                        options = {
                            allowStale: allowStale,
                            updateAgeOnGet: updateAgeOnGet,
                            noDeleteOnStaleGet: noDeleteOnStaleGet,
                            ttl: ttl,
                            noDisposeOnSet: noDisposeOnSet,
                            size: size,
                            sizeCalculation: sizeCalculation,
                            noUpdateTTL: noUpdateTTL,
                            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
                            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
                            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
                            ignoreFetchAbort: ignoreFetchAbort,
                            status: status,
                            signal: signal
                        };
                        index = _this.keyMap.get(k);
                        if (index === undefined) {
                            if (status) status.fetch = 'miss';
                            p = _this.backgroundFetch(k, index, options, fetchContext);
                            return [
                                2,
                                p.__returned = p
                            ];
                        } else {
                            // in cache, maybe already fetching
                            v = _this.valList[index];
                            if (_this.isBackgroundFetch(v)) {
                                stale = allowStale && v.__staleWhileFetching !== undefined;
                                if (status) {
                                    status.fetch = 'inflight';
                                    if (stale) status.returnedStale = true;
                                }
                                return [
                                    2,
                                    stale ? v.__staleWhileFetching : v.__returned = v
                                ];
                            }
                            // if we force a refresh, that means do NOT serve the cached value,
                            // unless we are already in the process of refreshing the cache.
                            isStale = _this.isStale(index);
                            if (!forceRefresh && !isStale) {
                                if (status) status.fetch = 'hit';
                                _this.moveToTail(index);
                                if (updateAgeOnGet) _this.updateItemAge(index);
                                _this.statusTTL(status, index);
                                return [
                                    2,
                                    v
                                ];
                            }
                            // ok, it is stale or a forced refresh, and not already fetching.
                            // refresh the cache.
                            p1 = _this.backgroundFetch(k, index, options, fetchContext);
                            hasStale = p1.__staleWhileFetching !== undefined;
                            staleVal = hasStale && allowStale;
                            if (status) {
                                status.fetch = hasStale && isStale ? 'stale' : 'refresh';
                                if (staleVal && isStale) status.returnedStale = true;
                            }
                            return [
                                2,
                                staleVal ? p1.__staleWhileFetching : p1.__returned = p1
                            ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "get",
            value: function get(k) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_allowStale = _ref.allowStale, allowStale = _ref_allowStale === void 0 ? this.allowStale : _ref_allowStale, _ref_updateAgeOnGet = _ref.updateAgeOnGet, updateAgeOnGet = _ref_updateAgeOnGet === void 0 ? this.updateAgeOnGet : _ref_updateAgeOnGet, _ref_noDeleteOnStaleGet = _ref.noDeleteOnStaleGet, noDeleteOnStaleGet = _ref_noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _ref_noDeleteOnStaleGet, status = _ref.status;
                var index = this.keyMap.get(k);
                if (index !== undefined) {
                    var value = this.valList[index];
                    var fetching = this.isBackgroundFetch(value);
                    this.statusTTL(status, index);
                    if (this.isStale(index)) {
                        if (status) status.get = 'stale';
                        // delete only if not an in-flight background fetch
                        if (!fetching) {
                            if (!noDeleteOnStaleGet) this.delete(k);
                            if (status) status.returnedStale = allowStale;
                            return allowStale ? value : undefined;
                        } else {
                            if (status) status.returnedStale = allowStale && value.__staleWhileFetching !== undefined;
                            return allowStale ? value.__staleWhileFetching : undefined;
                        }
                    } else {
                        if (status) status.get = 'hit';
                        // if we're currently fetching it, we don't actually have it yet
                        // it's not stale, which means this isn't a staleWhileRefetching.
                        // If it's not stale, and fetching, AND has a __staleWhileFetching
                        // value, then that means the user fetched with {forceRefresh:true},
                        // so it's safe to return that value.
                        if (fetching) return value.__staleWhileFetching;
                        this.moveToTail(index);
                        if (updateAgeOnGet) this.updateItemAge(index);
                        return value;
                    }
                } else if (status) status.get = 'miss';
            }
        },
        {
            key: "connect",
            value: function connect(p, n) {
                this.prev[n] = p;
                this.next[p] = n;
            }
        },
        {
            key: "moveToTail",
            value: function moveToTail(index) {
                // if tail already, nothing to do
                // if head, move head to next[index]
                // else
                //   move next[prev[index]] to next[index] (head has no prev)
                //   move prev[next[index]] to prev[index]
                // prev[index] = tail
                // next[tail] = index
                // tail = index
                if (index !== this.tail) {
                    if (index === this.head) this.head = this.next[index];
                    else this.connect(this.prev[index], this.next[index]);
                    this.connect(this.tail, index);
                    this.tail = index;
                }
            }
        },
        {
            key: "del",
            get: function get() {
                deprecatedMethod('del', 'delete');
                return this.delete;
            }
        },
        {
            key: "delete",
            value: function _delete(k) {
                var deleted = false;
                if (this.size !== 0) {
                    var index = this.keyMap.get(k);
                    if (index !== undefined) {
                        deleted = true;
                        if (this.size === 1) this.clear();
                        else {
                            this.removeItemSize(index);
                            var v = this.valList[index];
                            if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
                            else {
                                this.dispose(v, k, 'delete');
                                if (this.disposeAfter) this.disposed.push([
                                    v,
                                    k,
                                    'delete'
                                ]);
                            }
                            this.keyMap.delete(k);
                            this.keyList[index] = null;
                            this.valList[index] = null;
                            if (index === this.tail) this.tail = this.prev[index];
                            else if (index === this.head) this.head = this.next[index];
                            else {
                                this.next[this.prev[index]] = this.next[index];
                                this.prev[this.next[index]] = this.prev[index];
                            }
                            this.size--;
                            this.free.push(index);
                        }
                    }
                }
                if (this.disposed) while(this.disposed.length)this.disposeAfter.apply(this, (0, _toConsumableArray._)(this.disposed.shift()));
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.rindexes({
                        allowStale: true
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var index = _step.value;
                        var v = this.valList[index];
                        if (this.isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
                        else {
                            var k = this.keyList[index];
                            this.dispose(v, k, 'delete');
                            if (this.disposeAfter) this.disposed.push([
                                v,
                                k,
                                'delete'
                            ]);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.keyMap.clear();
                this.valList.fill(null);
                this.keyList.fill(null);
                if (this.ttls) {
                    this.ttls.fill(0);
                    this.starts.fill(0);
                }
                if (this.sizes) this.sizes.fill(0);
                this.head = 0;
                this.tail = 0;
                this.initialFill = 1;
                this.free.length = 0;
                this.calculatedSize = 0;
                this.size = 0;
                if (this.disposed) while(this.disposed.length)this.disposeAfter.apply(this, (0, _toConsumableArray._)(this.disposed.shift()));
            }
        },
        {
            key: "reset",
            get: function get() {
                deprecatedMethod('reset', 'clear');
                return this.clear;
            }
        },
        {
            key: "length",
            get: function get() {
                deprecatedProperty('length', 'size');
                return this.size;
            }
        }
    ], [
        {
            key: "AbortController",
            get: function get() {
                return AC;
            }
        },
        {
            key: "AbortSignal",
            get: function get() {
                return AS;
            }
        }
    ]);
    return LRUCache;
}();
exports.default = LRUCache;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_call_super":"j67W7","@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_inherits":"vo5zm","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_type_of":"668P4","@swc/helpers/_/_wrap_native_super":"4i0eR","@swc/helpers/_/_ts_generator":"2jVI5","616c66ee1a75bb9e":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4i0eR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"lFiVW","./_get_prototype_of.js":"6m8hr","./_is_native_function.js":"jrJhQ","./_set_prototype_of.js":"d6k5B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lFiVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"6SvAq","./_set_prototype_of.js":"d6k5B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jrJhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lpue9":[function(require,module,exports,__globalThis) {
/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-10-12
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cacheAdapterEnhancer;
});
var _tslib = require("tslib");
var _lruCache = require("lru-cache");
var _lruCacheDefault = parcelHelpers.interopDefault(_lruCache);
var _buildSortedURL = require("./utils/buildSortedURL");
var _buildSortedURLDefault = parcelHelpers.interopDefault(_buildSortedURL);
var _isCacheLike = require("./utils/isCacheLike");
var _isCacheLikeDefault = parcelHelpers.interopDefault(_isCacheLike);
var FIVE_MINUTES = 300000;
var CAPACITY = 100;
function cacheAdapterEnhancer(adapter, options) {
    var _this = this;
    if (options === void 0) options = {};
    var _a = options.enabledByDefault, enabledByDefault = _a === void 0 ? true : _a, _b = options.cacheFlag, cacheFlag = _b === void 0 ? 'cache' : _b, _c = options.defaultCache, defaultCache = _c === void 0 ? new (0, _lruCacheDefault.default)({
        ttl: FIVE_MINUTES,
        max: CAPACITY
    }) : _c;
    return function(config) {
        var url = config.url, method = config.method, params = config.params, paramsSerializer = config.paramsSerializer, forceUpdate = config.forceUpdate;
        var useCache = config[cacheFlag] !== void 0 && config[cacheFlag] !== null ? config[cacheFlag] : enabledByDefault;
        if (method === 'get' && useCache) {
            // if had provided a specified cache, then use it instead
            var cache_1 = (0, _isCacheLikeDefault.default)(useCache) ? useCache : defaultCache;
            // build the index according to the url and params
            var index_1 = (0, _buildSortedURLDefault.default)(url, params, paramsSerializer);
            var responsePromise = cache_1.get(index_1);
            if (!responsePromise || forceUpdate) {
                responsePromise = function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var reason_1;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        adapter(config)
                                    ];
                                case 1:
                                    return [
                                        2 /*return*/ ,
                                        _a.sent()
                                    ];
                                case 2:
                                    reason_1 = _a.sent();
                                    'delete' in cache_1 ? cache_1.delete(index_1) : cache_1.del(index_1);
                                    throw reason_1;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }();
                // put the promise for the non-transformed response into cache as a placeholder
                cache_1.set(index_1, responsePromise);
                return responsePromise;
            }
            return responsePromise;
        }
        return adapter(config);
    };
}

},{"tslib":"86BcK","lru-cache":"1CVBU","./utils/buildSortedURL":"bGhQF","./utils/isCacheLike":"3LVS0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bGhQF":[function(require,module,exports,__globalThis) {
/**
 * @author Kuitos
 * @homepage https://github.com/kuitos/
 * @since 2017-10-12
 */ // @ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildSortedURL;
});
var _buildURL = require("axios/lib/helpers/buildURL");
var _buildURLDefault = parcelHelpers.interopDefault(_buildURL);
function buildSortedURL() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var builtURL = (0, _buildURLDefault.default).apply(void 0, args);
    var _a = builtURL.split('?'), urlPath = _a[0], queryString = _a[1];
    if (queryString) {
        var paramsPair = queryString.split('&');
        return "".concat(urlPath, "?").concat(paramsPair.sort().join('&'));
    }
    return builtURL;
}

},{"axios/lib/helpers/buildURL":"3wgcs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LVS0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isCacheLike;
});
function isCacheLike(cache) {
    return typeof cache.get === 'function' && typeof cache.set === 'function' && (typeof cache.delete === 'function' || typeof cache.del === 'function');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bM8Mk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryParams", function() {
    return parseQueryParams;
});
parcelHelpers.export(exports, "range", function() {
    return range;
});
parcelHelpers.export(exports, "autosize", function() {
    return autosize;
});
parcelHelpers.export(exports, "buildRurl", function() {
    return buildRurl;
});
parcelHelpers.export(exports, "getDateString", function() {
    return getDateString;
});
parcelHelpers.export(exports, "insertString", function() {
    return insertString;
});
parcelHelpers.export(exports, "text_truncate", function() {
    return text_truncate;
});
parcelHelpers.export(exports, "is_before_date", function() {
    return is_before_date;
});
function parseQueryParams() {
    var queryDict = {};
    window.location.search.substr(1).split('&').forEach(function(item) {
        queryDict[item.split('=')[0]] = item.split('=')[1];
    });
    return queryDict;
}
function buildRurl() {
    if (window.location.pathname == null || window.location.pathname.length == 0 || window.location.pathname == '/' || window.location.href.indexOf('rurl') > -1) return '';
    //is there already a rurl? if so, use it.
    var queryParams = parseQueryParams();
    if (queryParams['rurl'] != null) return queryParams['rurl'];
    //build new rurl
    var rurl = '?rurl=' + window.location.pathname;
    if (window.location.search != null && window.location.search.length > 0) return rurl + '?' + window.location.search;
    return rurl;
}
function range(start, end) {
    var result = [];
    for(var i = start; i < end; i++)result.push(i);
    return result;
}
function autosize() {
    // Computes new height for textboxes when user is typing so they can expand
    var el = this;
    setTimeout(function() {
        el.style.height = 'inherit';
        // Get the computed styles for the element
        var computed = window.getComputedStyle(el);
        // Calculate the height
        var height = parseInt(computed.getPropertyValue('border-top-width'), 10) + parseInt(computed.getPropertyValue('padding-top'), 10) + el.scrollHeight + parseInt(computed.getPropertyValue('padding-bottom'), 10) + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
        el.style.height = height + 'px';
    }, 0);
}
function getDateString() {
    var date = new Date();
    var year = date.getFullYear();
    var month = "".concat(date.getMonth() + 1).padStart(2, '0');
    var day = "".concat(date.getDate()).padStart(2, '0');
    var minutes = date.getMinutes();
    var hour = date.getHours();
    return "_".concat(year).concat(month).concat(day, "_").concat(hour, ":").concat(minutes);
}
function text_truncate(str, length, ending) {
    if (length == null) length = 100;
    if (ending == null) ending = '...';
    if (str.length > length) return str.substring(0, length - ending.length) + ending;
    else return str;
}
function insertString(a, b, at) {
    var position = a.lastIndexOf(at);
    if (position !== -1) return a.substr(0, position) + b + a.substr(position);
    return a;
}
var is_before_date = function(date1, date2) {
    return date1 < date2;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2i91X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectriaTicketsDetailBlade", function() {
    return ConnectriaTicketsDetailBlade;
});
parcelHelpers.export(exports, "BladeTabs", function() {
    return BladeTabs;
});
parcelHelpers.export(exports, "BladeTabDetail", function() {
    return BladeTabDetail;
});
parcelHelpers.export(exports, "BladeTabComments", function() {
    return BladeTabComments;
});
parcelHelpers.export(exports, "NewTabLink", function() {
    return NewTabLink;
});
parcelHelpers.export(exports, "EditTicketSubject", function() {
    return EditTicketSubject;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouterDom = require("react-router-dom");
var _reactstrap = require("reactstrap");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _portalService = require("../../services/PortalService");
var _portalServiceDefault = parcelHelpers.interopDefault(_portalService);
var _connectriaTicketsState = require("./ConnectriaTicketsState");
var _connectriaTicketsStateDefault = parcelHelpers.interopDefault(_connectriaTicketsState);
var _appState = require("../../AppState");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _fileService = require("../../services/FileService");
var _fileServiceDefault = parcelHelpers.interopDefault(_fileService);
var _dateUtil = require("../../utility/DateUtil");
var moment = require("f79734c26c1cb77a");
var ConnectriaResponseRating = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), rating = _useState1[0], setRating = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), comment = _useState2[0], setComment = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState3[0], setIsLoading = _useState3[1];
    var hasRating = props.userRatings.filter(function(e) {
        return e.ticket_history_id == props.commentId;
    });
    var toggle = function(rating) {
        setIsOpen(!isOpen);
        //if closing the rating and there is a historical value check for it first
        setRating(rating == null ? hasRating.length > 0 ? hasRating[0].rating : null : rating);
    };
    (0, _react.useEffect)(function() {
        if (hasRating.length > 0) {
            setRating(hasRating[0].rating);
            setComment(hasRating[0].comment);
        }
    }, []);
    var doRating = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var endpoint, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        endpoint = hasRating.length > 0 ? (0, _connectriaTicketsServiceDefault.default).updateTicketCommentRating(hasRating[0].id, rating, comment) : (0, _connectriaTicketsServiceDefault.default).createTicketCommentRating(props.commentId, rating, comment);
                        setIsLoading(true);
                        return [
                            4,
                            endpoint
                        ];
                    case 1:
                        result = _state.sent();
                        setIsLoading(false);
                        toggle(rating);
                        return [
                            2
                        ];
                }
            });
        });
        return function doRating() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteRating = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).deleteTicketCommentRating(hasRating[0].id)
                        ];
                    case 1:
                        result = _state.sent();
                        toggle(0);
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteRating() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'p2 row ',
        style: {
            backgroundColor: '#e9e9e9',
            paddingLeft: "12px",
            borderTop: "0.0625rem solid #d5d9dd"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            className: "w-100",
            children: [
                "Was the following response helpful? Click here to rate:",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "parent",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            id: "rating-1",
                            onClick: function() {
                                return toggle(1);
                            },
                            className: (rating >= 1 ? 'fas rated' : 'far') + ' fa-star comment-rating'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            id: "rating-2",
                            onClick: function() {
                                return toggle(2);
                            },
                            className: (rating >= 2 ? 'fas rated' : 'far') + ' fa-star comment-rating'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            id: "rating-3",
                            onClick: function() {
                                return toggle(3);
                            },
                            className: (rating >= 3 ? 'fas rated' : 'far') + ' fa-star comment-rating'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            id: "rating-4",
                            onClick: function() {
                                return toggle(4);
                            },
                            className: (rating >= 4 ? 'fas rated' : 'far') + ' fa-star comment-rating'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            id: "rating-5",
                            onClick: function() {
                                return toggle(5);
                            },
                            className: (rating >= 5 ? 'fas rated' : 'far') + ' fa-star comment-rating'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Collapse), {
                    isOpen: isOpen,
                    className: "pr-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                    type: "textarea",
                                    rows: "4",
                                    onChange: function(e) {
                                        return setComment(e.target.value);
                                    },
                                    className: "w-100 form-control",
                                    value: comment,
                                    placeholder: "Add a comment about the quality of support you received."
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardFooter), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-right",
                                    children: [
                                        hasRating.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                lineHeight: "35.6px"
                                            },
                                            className: "pull-left cursor",
                                            onClick: function() {
                                                if (window.confirm('Are you sure you wish to delete this rating?')) deleteRating();
                                            },
                                            children: "[ remove my rating ]"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                            type: "button",
                                            onClick: function() {
                                                return toggle(null);
                                            },
                                            className: "btn-sm btn-danger",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                            disabled: isLoading,
                                            type: "button",
                                            onClick: function() {
                                                return doRating();
                                            },
                                            className: "btn-sm",
                                            children: "Submit"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
function HistoryItem(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var momentTzGuess = moment.tz.guess();
    var commentCreatedTs = props.comment.created;
    var created = moment(commentCreatedTs, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z');
    //if the ticket wasn't created by Connectria assume all commenters from Connectria are "left-side"
    if (props.ticket.customer_id > 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 ".concat(props.comment.user.customer_id > 0 ? 'text-left' : 'text-left'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-2 row",
                style: {
                    backgroundColor: '#e9e9e9',
                    paddingBottom: "0px !important"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            width: "90%"
                        },
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "  mb-0",
                                children: [
                                    "Comment by:",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            textTransform: 'capitalize',
                                            fontWeight: 700
                                        },
                                        children: (0, _connectriaTicketsState.createdBy)(props.comment.user)
                                    }),
                                    " of",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontWeight: 700
                                        },
                                        children: props.comment.user.customer_id > 0 ? stateApp.userInfo.organization_name : 'Connectria'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: " mb-0",
                                children: created
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            maxWidth: "10%"
                        },
                        className: "col center-flex-item",
                        children: props.comment.user.customer_id == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            style: {
                                width: "30px"
                            },
                            src: "data:image/png;base64,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"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                    })
                ]
            }),
            props.comment.user.customer_id == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConnectriaResponseRating, {
                userRatings: props.userRatings,
                commentId: props.comment.id
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "pb-3 pt-1",
                style: {
                    fontSize: "0.97rem",
                    whiteSpace: 'pre-wrap'
                },
                children: props.comment.comment
            })
        ]
    }, props.index);
    else //created by connectria. if comment comes from a different team assume it's "left-side"
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 ".concat(props.comment.user.primary_team_id != props.ticket.team_id ? 'text-left' : 'text-left'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: props.comment.comment
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("blockquote", {
                className: "primary ".concat(props.comment.user.primary_team_id != props.ticket.team_id ? 'right' : ''),
                children: [
                    (0, _connectriaTicketsState.createdBy)(props.comment.user),
                    " - ",
                    moment(props.comment.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').calendar()
                ]
            })
        ]
    }, props.index);
}
var TicketHistories = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isHistoryLoading = _useState[0], setIsHistoryLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), historiesMounted = _useState1[0], setHistoriesMounted = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(null), 2), history = _useState2[0], setHistory = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), historyRatings = _useState3[0], setHistoryRatings = _useState3[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _react.useEffect)(function() {
        setHistoriesMounted(true);
        return function() {
            setHistoriesMounted(false);
        };
    }, []);
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var _ref, history, ratings, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!historiesMounted) return [
                            2
                        ];
                        setIsHistoryLoading(true);
                        return [
                            4,
                            Promise.all([
                                (0, _connectriaTicketsServiceDefault.default).ticketHistory(props.ticketId, {
                                    cancelToken: source.token
                                }),
                                (0, _connectriaTicketsServiceDefault.default).getTicketCommentRatings(props.ticketId, {
                                    cancelToken: source.token
                                })
                            ])
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), history = _ref[0], ratings = _ref[1];
                        if (!isMounted()) return [
                            2
                        ];
                        setHistoryRatings(ratings);
                        setHistory((history || []).filter(function(e) {
                            return e.pvt == false;
                        }));
                        setIsHistoryLoading(false);
                        if (props.setCacheBuster) props.setCacheBuster(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) // request cancelled
                        console.log('canceled');
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        console.log('unmount canceled');
        source.cancel();
    }, [
        historiesMounted,
        props.cacheBuster
    ]);
    if (isHistoryLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: '30px'
            }
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: history == null || history.length == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}) : history.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HistoryItem, {
                userRatings: historyRatings,
                index: index,
                comment: item,
                ticket: props.ticket
            }, index);
        })
    });
};
var FileTypeIcon = function(props) {
    var filenameSplit = props.filename.split('.');
    switch(filenameSplit[filenameSplit.length - 1].toLowerCase()){
        case 'pdf':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file-pdf"
            });
        case 'txt':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file-alt"
            });
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'tif':
        case 'png':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file-image"
            });
        case 'doc':
        case 'docx':
        case 'docm':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file-word"
            });
        case 'xls':
        case 'xlsx':
        case 'xlsm':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file-excel"
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fa fa-file"
            });
    }
};
function saveData(blob, fileName) {
    // does the same as FileSaver.js
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}
var Attachment = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), downloading = _useState[0], setDownloading = _useState[1];
    var download = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e, file) {
            var attachmentUrl, xhr;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDownloading(true);
                        if (e) e.preventDefault();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAttachmentUrl(props.ticketId, file.id)
                        ];
                    case 1:
                        attachmentUrl = _state.sent();
                        //THIS IS SEANS TEST DELETE LATER
                        xhr = new XMLHttpRequest();
                        xhr.open('GET', attachmentUrl);
                        xhr.responseType = 'blob';
                        xhr.onload = function() {
                            saveData(this.response, file.filename); // saveAs is a part of FileSaver.js
                        };
                        xhr.send();
                        //THIS IS SEANS TEST UNCOMMENT LATER
                        //  window.open(attahcmentUrl, "_blank");
                        setDownloading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function download(e, file) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        onClick: function(e) {
            download(e, props.file);
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "attachment-block rounded",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(FileTypeIcon, {
                    filename: props.file.filename,
                    className: "attachment-icon"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            children: props.file.filename
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                            children: moment(props.file.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').calendar()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        margin: 'auto'
                    },
                    children: downloading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-2x fa-spinner fa-spin"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                })
            ]
        })
    });
};
var TicketAttachmentList = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.ticket.ticket_attachments == null || props.ticket.ticket_attachments.length == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "text-center mt-4 text-bold",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-exclamation-triangle"
                }),
                " No Attachments"
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: props.ticket.ticket_attachments.map(function(file, index) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Attachment, {
                    ticketId: props.ticketId,
                    file: file
                }, index);
            })
        })
    });
};
var TicketCloseForm = function(props) {
    //local
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isClosing = _useState[0], setIsClosing = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(6), 2), closeRating = _useState1[0], setCloseRating = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), closeComment = _useState2[0], setCloseComment = _useState2[1];
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    //plugin state
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), stateTickets = _useTriaTicketsState[0], stateTicketActions = _useTriaTicketsState[1];
    var history = (0, _reactRouterDom.useHistory)();
    var closeTicket = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(comment) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).closeTicket(props.id, comment, closeRating)
                        ];
                    case 1:
                        _state.sent();
                        //remove ticket from state and update UI
                        stateTicketActions.removeTicket(props.id);
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                style: {
                                    color: 'white'
                                },
                                children: [
                                    "Ticket #",
                                    props.id,
                                    " closed."
                                ]
                            }),
                            className: 'success',
                            visible: true
                        });
                        setTimeout(function() {
                            stateAppActions.setAlert(function(prevState) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                    visible: false
                                });
                            });
                        }, 2000);
                        return [
                            2
                        ];
                }
            });
        });
        return function closeTicket(comment) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var comment, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        setIsClosing(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!props.reopen) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).reopenTicket(props.id, closeComment)
                        ];
                    case 2:
                        _state.sent();
                        //clear tickets to reset state
                        stateTicketActions.setTicketStatus(props.id, 'Open');
                        //stateTicketActions.setTicketDetail({});
                        props.setReloadDetail(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        comment = closeComment == '' ? 'Closed' : closeComment;
                        return [
                            4,
                            closeTicket(comment)
                        ];
                    case 4:
                        _state.sent();
                        // let ifChildTickets = await ConnectriaTicketsService.getChildTicket(props.id)
                        // console.log(ifChildTickets)
                        // if (ifChildTickets['data']['response']['data'].hasOwnProperty('tickets') && ifChildTickets['data']['response']['data']['tickets'].length > 0) {
                        //   console.log('yes there are child tickets')
                        //   let availableChildTicket = ifChildTickets['data']['response']['data']['tickets'].filter(ticket => {
                        //         return ticket['status'].toLowerCase() === 'open'
                        //             || ticket['status'].toLowerCase() === 'new'
                        //             || ticket['status'].toLowerCase() === 'waitoncust'
                        //             || ticket['status'].toLowerCase() === 'input required'
                        //     })
                        //   console.log("open child ticket are ")
                        //   console.log(availableChildTicket)
                        //   if (availableChildTicket.length > 0){
                        //     stateAppActions.setAlert({
                        //     content: <p style={{color: "white"}} >Ticket #{props.id} cannot be closed. Please try closing this ticket again later.</p>,
                        //     color: "danger",
                        //     visible: true
                        //   });
                        //   setTimeout(() => {
                        //         stateAppActions.setAlert(prevState => ({...prevState, visible: false }))
                        //       }, 10000);
                        //   } else {
                        //     await closeTicket(comment)
                        //   }
                        // } else {
                        //   await closeTicket(comment)
                        // }
                        // reload ticket after close
                        props.setReloadDetail(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.log(error);
                        stateAppActions.setBlade({
                            visible: false,
                            content: '',
                            title: ''
                        });
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: 'white'
                                },
                                children: "Error updating ticket."
                            }),
                            className: 'danger',
                            visible: true
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClose(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        className: "mt-3",
        onSubmit: function(e) {
            return handleClose(e);
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Reason and Rating"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "How would you rate the support you received?",
                    ' ',
                    !props.reopen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "pl-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                className: "btn-sm ".concat(closeRating === 6 ? '' : 'btn-simple'),
                                onClick: function() {
                                    return setCloseRating(6);
                                },
                                active: closeRating === 6,
                                color: "primary",
                                style: {
                                    border: '1px solid',
                                    borderColor: closeRating === 6 ? 'transparent' : ''
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "far fa-thumbs-up"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                className: "btn-sm ".concat(closeRating === 3 ? '' : 'btn-simple'),
                                onClick: function() {
                                    return setCloseRating(3);
                                },
                                active: closeRating === 3,
                                color: "primary",
                                style: {
                                    border: '1px solid',
                                    borderColor: closeRating === 3 ? 'transparent' : ''
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "far fa-thumbs-down"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                type: "textarea",
                placeholder: props.reopen ? 'Re-Open Comment' : 'Please add a reason why this ticket is being closed (optional).',
                onChange: function(e) {
                    return setCloseComment(e.target.value);
                },
                rows: "4",
                value: closeComment
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-right mt-2",
                children: isClosing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                    type: "submit",
                    disabled: isClosing,
                    className: "btn-sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-spinner fa-spin ml-1",
                            style: {
                                fontSize: '15px'
                            }
                        }),
                        "Submit"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        !props.reopen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                            type: "submit",
                            className: "btn-sm",
                            children: "Submit"
                        }),
                        props.reopen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                            type: "submit",
                            disabled: closeComment.trim().split(/[\s\n]+/).length < 4,
                            className: "btn-sm",
                            children: "Submit"
                        })
                    ]
                })
            })
        ]
    });
};
var ConvertedDeviceId = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(props.deviceId), 2), assetTag = _useState[0], setAssetTag = _useState[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var reg, devices, i, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        reg = new RegExp(/^\d+$/);
                        if (!reg.test(props.deviceId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllDevicesLike({
                                ar_assoc: 'devicetype',
                                limit: 100
                            })
                        ];
                    case 1:
                        devices = _state.sent() || [];
                        for(i = 0; i < devices.length; i++)if (devices[i].id == props.deviceId) setAssetTag(devices[i].assettag);
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: assetTag
    });
};
var CCForm = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Edit Ticket CC"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "form-control",
                style: {
                    overflowY: 'scroll',
                    height: "100px",
                    minHeight: "100px"
                },
                children: props.ccUsers.map(function(user, index) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: 'd-flex w-100',
                        onClick: function() {
                            props.handleCCSelect(user);
                        },
                        style: {
                            backgroundColor: user.selected ? 'lightblue' : '',
                            cursor: 'pointer'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    flex: '0 50%'
                                },
                                children: user.fname + ' ' + user.surname
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    flex: '0 50%'
                                },
                                children: '<' + user.email + '>'
                            })
                        ]
                    }, index);
                })
            }),
            props.showCcCsm && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "position-relative form-check ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    className: "form-check-label",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nobr", {
                            children: [
                                "cc ",
                                props.csmInfo.user.fname + ' ' + props.csmInfo.user.surname
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            className: "form-check-input",
                            checked: props.includeCSM,
                            onChange: props.handleCsmSelect
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "form-check-sign",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "check"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                className: "btn-sm",
                style: {
                    minHeight: "18px"
                },
                onClick: function() {
                    props.handleCCSave();
                },
                children: "Save CC"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-3"
            })
        ]
    });
};
var EditTicketDescription = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(props.detail.issue), 2), description = _useState[0], setDescription = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), editMode = _useState1[0], setEditMode = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    if ([
        'New',
        'Open',
        'WaitOnCust'
    ].indexOf(props.detail.status) === -1) // show basic header without editing feature
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "taDescription",
        className: "mt-1 flex-grow-1 rounded mb-3",
        children: props.detail.issue
    });
    var save = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(props.detail.issue !== description)) return [
                            3,
                            2
                        ];
                        setEditMode(false);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).updateTicket(props.detail.id, {
                                issue: description
                            })
                        ];
                    case 1:
                        _state.sent();
                        setIsLoading(false);
                        (0, _connectriaTicketsServiceDefault.default).clearTicketCache();
                        props.setReloadDetail(true);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function save(e) {
            return _ref.apply(this, arguments);
        };
    }();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: '30px'
            }
        })
    });
    else if (editMode) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
        value: description,
        className: "form-control rounded",
        rows: "10",
        onChange: function(e) {
            setDescription(e.target.value);
        },
        onBlur: function(e) {
            return save(e);
        }
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "taDescription",
        onClick: function() {
            return setEditMode(true);
        },
        className: "mt-1 flex-grow-1 rounded mb-3",
        children: props.detail.issue
    });
};
var BladeTabDetail = function(props) {
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), closeFormVisible = _useState[0], setCloseFormVisible = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), reopenFormVisible = _useState1[0], setReopenFormVisible = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), convertedDevice = _useState2[0], setConvertedDevice = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showCCForm = _useState3[0], setShowCCForm = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showCCSaveLoader = _useState4[0], setCCSaveLoader = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), ccUsers = _useState5[0], setCCUsers = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(false), 2), includeCSM = _useState6[0], setIncludeCSM = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({}), 2), csmInfo = _useState7[0], setCsmInfo = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showCcCsm = _useState8[0], setShowCcCsm = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)({}), 2), notifyCsmMeta = _useState9[0], setNotifyCsmMeta = _useState9[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var momentTzGuess = moment.tz.guess();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var isCustomer, users, _ref, accountAgents, metadata, existsCCUsers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, agent, notifyCsmTicketMeta, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        isCustomer = stateApp.userInfo.organization_id != 0;
                        console.log('Load ticket users');
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllUsersLike({
                                cancelToken: source.token
                            }, isCustomer)
                        ];
                    case 1:
                        users = _state.sent();
                        return [
                            4,
                            Promise.all([
                                (0, _connectriaTicketsServiceDefault.default).getParamData({
                                    cancelToken: source.token
                                }),
                                (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                    meta_key: 'tria_show_cc_csm'
                                })
                            ])
                        ];
                    case 2:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), accountAgents = _ref[0], metadata = _ref[1];
                        users.sort(function(a, b) {
                            return a.fname.localeCompare(b.fname);
                        });
                        existsCCUsers = props.detail.ticket_carbon_copies.map(function(item) {
                            return item.user_id;
                        });
                        setCCUsers(users.filter(function(user) {
                            var _stateApp_userInfo, _stateApp_userInfo1;
                            user.selected = existsCCUsers.indexOf(user.id) > -1;
                            return user.active && user.login_supported && !user.serviceUser && (props.detail.user.email !== ((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.email) || user.email !== ((_stateApp_userInfo1 = stateApp.userInfo) === null || _stateApp_userInfo1 === void 0 ? void 0 : _stateApp_userInfo1.email));
                        }));
                        accountAgents = accountAgents.dynamic.response.data.customer_account_agents || [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = accountAgents[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                agent = _step.value;
                                if (agent.agent_type.name == 'Customer Success Manager') setCsmInfo(agent);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        notifyCsmTicketMeta = props.detail.meta.find(function(meta) {
                            return meta.meta_key == 'notify_csm';
                        });
                        if (metadata.meta_value == 'TRUE') {
                            setShowCcCsm(true);
                            if (notifyCsmTicketMeta) {
                                setNotifyCsmMeta(notifyCsmTicketMeta);
                                setIncludeCSM(true);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    var handleCsmSelect = function() {
        setIncludeCSM(!includeCSM);
    };
    var handleCCSave = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var selected_users, selected_user_ids, users, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, err, exists_user_ids, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, user, cc, err, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowCCForm(false);
                        setCCSaveLoader(true);
                        selected_users = ccUsers.filter(function(user) {
                            return user.selected;
                        });
                        selected_user_ids = selected_users.map(function(user) {
                            return user.id;
                        });
                        // delete unselected users
                        users = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = props.detail.ticket_carbon_copies[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        item = _step.value;
                        if (!(selected_user_ids.indexOf(item.user_id) > -1)) return [
                            3,
                            3
                        ];
                        users.push(item);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).deleteTicketCarbonCopy(item.id)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        props.detail.ticket_carbon_copies = users;
                        // add new users
                        exists_user_ids = props.detail.ticket_carbon_copies.map(function(user) {
                            return user.user_id;
                        });
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 10;
                    case 10:
                        _state.trys.push([
                            10,
                            15,
                            16,
                            17
                        ]);
                        _iterator1 = selected_users[Symbol.iterator]();
                        _state.label = 11;
                    case 11:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            14
                        ];
                        user = _step1.value;
                        if (!(exists_user_ids.indexOf(user.id) == -1)) return [
                            3,
                            13
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).saveTicketCarbonCopies(props.detail.id, [
                                user.id
                            ])
                        ];
                    case 12:
                        cc = _state.sent();
                        props.detail.ticket_carbon_copies.push(cc[0]);
                        _state.label = 13;
                    case 13:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            11
                        ];
                    case 14:
                        return [
                            3,
                            17
                        ];
                    case 15:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            17
                        ];
                    case 16:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 17:
                        // update user objects by user_id
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).updateUsersTicketCarbonCopies(props.detail)
                        ];
                    case 18:
                        _state.sent();
                        if (!(includeCSM && Object.keys(notifyCsmMeta).length == 0)) return [
                            3,
                            20
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).createTicketMeta(props.detail.id, 'notify_csm', 1)
                        ];
                    case 19:
                        response = _state.sent();
                        setNotifyCsmMeta(response.ticket_meta[0]);
                        // Leave the checkbox checked
                        setIncludeCSM(true);
                        return [
                            3,
                            22
                        ];
                    case 20:
                        if (!(!includeCSM && Object.keys(notifyCsmMeta).length != 0)) return [
                            3,
                            22
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).deleteTicketMeta(notifyCsmMeta.id)
                        ];
                    case 21:
                        _state.sent();
                        setNotifyCsmMeta({});
                        // Leave the checkbox unchecked
                        setIncludeCSM(false);
                        _state.label = 22;
                    case 22:
                        setCCSaveLoader(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCCSave() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCCSelect = function(selectedUser) {
        var usersCopy = ccUsers;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = usersCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var user = _step.value;
                if (user.id == selectedUser.id) {
                    console.log('selecting user');
                    user.selected = !user.selected;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setCCUsers(usersCopy.slice());
    };
    var getCustomerTicketId = function(detail) {
        var content = '';
        var curuium_id = props.detail.meta.filter(function(e) {
            return e.meta_key == 'curium_sys_id';
        });
        if (curuium_id.length > 0) content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: "Customer Ticket #:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-weight-bold",
                        children: curuium_id[0].meta_value
                    })
                })
            ]
        });
        return content;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "paneDetails",
        className: "flex-fill d-flex flex-column tab-pane",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("blockquote", {
                className: "mt-3 blockquote ticket-".concat(props.detail.status),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                    className: "table table-sm table-borderless mb-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Owner:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: (0, _connectriaTicketsState.createdBy)(props.detail.user)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Created By:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: (0, _connectriaTicketsState.createdBy)(props.detail.enteredby)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Created:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: moment(props.detail.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z')
                                        })
                                    })
                                ]
                            }),
                            getCustomerTicketId(),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-top",
                                        children: "CC:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                        style: {
                                            whiteSpace: 'pre-wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-weight-bold",
                                                children: props.detail.ticket_carbon_copies.map(function(item) {
                                                    return ((item.user || {}).fname || '') + ' ' + ((item.user || {}).surname || '');
                                                }).join(', ')
                                            }),
                                            props.detail.ticket_carbon_copies.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}) : null,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                                href: "#",
                                                onClick: function() {
                                                    return setShowCCForm(!showCCForm);
                                                },
                                                className: "btn-sm",
                                                children: "Edit CC"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Type:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: (0, _connectriaTicketsServiceDefault.default).ticketType(props.detail.ticket_type_id).name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Priority:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: (0, _connectriaTicketsServiceDefault.default).ticketPriority(props.detail.priority).name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Status:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: props.detail.status == 'WaitOnCust' ? 'Input Required' : props.detail.status
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Category:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: props.detail.ticketcategory.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Sub-Category:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: props.detail.ticketcategory.subcategory
                                        })
                                    })
                                ]
                            }),
                            props.detail.device != 'undefined' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: "Device:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-bold",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConvertedDeviceId, {
                                                deviceId: props.detail.device
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                        ]
                    })
                })
            }),
            showCCSaveLoader && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-spinner m-3 mt-4 fa-spin",
                        style: {
                            fontSize: '30px'
                        }
                    })
                })
            }),
            showCCForm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CCForm, {
                    ccUsers: ccUsers,
                    handleCCSave: handleCCSave,
                    handleCCSelect: handleCCSelect,
                    showCcCsm: showCcCsm,
                    csmInfo: csmInfo,
                    includeCSM: includeCSM,
                    notifyCsmMeta: notifyCsmMeta,
                    handleCsmSelect: handleCsmSelect
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                className: "mt-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Ticket Actions"
                })
            }),
            props.detail.status !== 'Closed' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    props.detail.status === 'Resolved' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                            className: "btn-sm",
                            id: "toggleReopen",
                            disabled: closeFormVisible,
                            onClick: function(e) {
                                return setReopenFormVisible(!reopenFormVisible);
                            },
                            children: "Re-Open Ticket"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        id: "toggleClose",
                        className: "btn-sm",
                        disabled: reopenFormVisible,
                        children: "Close Ticket"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledCollapse), {
                        toggler: "#toggleClose",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketCloseForm, {
                            id: props.detail.id,
                            setReloadDetail: props.setReloadDetail,
                            reopen: false,
                            fullPage: props.fullPage
                        })
                    }),
                    props.detail.status == 'Resolved' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledCollapse), {
                        toggler: "#toggleReopen",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketCloseForm, {
                            id: props.detail.id,
                            setReloadDetail: props.setReloadDetail,
                            reopen: true,
                            fullPage: props.fullPage
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "alert alert-success w-auto",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-check-circle"
                        }),
                        " Ticket closed"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                className: "mt-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: "Description"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditTicketDescription, {
                detail: props.detail,
                setReloadDetail: props.setReloadDetail
            }),
            props.detail.errorDesc.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: "Error Description"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: "taDescription",
                        style: {
                            whiteSpace: 'pre-wrap'
                        },
                        className: "mt-1 flex-grow-1 rounded mb-3",
                        children: props.detail.errorDesc
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
            ((props.showCommentsMsg, false), props.showCommentsMsg) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "*You can view ticket history in the Comments tab above."
            })
        ]
    });
};
var BladeTabComments = function(props) {
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), state = _useTriaTicketsState[0], stateActions = _useTriaTicketsState[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPostingComment = _useState[0], setIsPostingComment = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), cacheBuster = _useState1[0], setCacheBuster = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), attachments = _useState2[0], setAttachments = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(state.commentText), 2), newComment = _useState3[0], setNewComment = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(null), 2), attachmentError = _useState4[0], setAttachmentError = _useState4[1];
    var fileInput = document.querySelector('#fileNewComment');
    var changeCommentText = function(text) {
        setNewComment(text);
        setAttachmentError(null);
        stateActions.setCommentText(text);
    };
    var addAttachment = function(e) {
        var _e_target_files, _e_target;
        var file = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_files = _e_target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            if (file.size > 5242880) // check 5mb limit for the file size
            setAttachmentError('File size limit exceeded.');
            else {
                setAttachmentError(null);
                setAttachments((0, _toConsumableArray._)(attachments).concat([
                    file
                ]));
            }
            e.target.value = '';
        }
    };
    var handleNewComment = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var hasAttachment, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, attachment, content, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        setIsPostingComment(true);
                        // save comment text
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).newComment(props.detail.id, newComment)
                        ];
                    case 1:
                        _state.sent();
                        // add attachments
                        hasAttachment = false;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            8,
                            9,
                            10
                        ]);
                        _iterator = attachments[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            7
                        ];
                        attachment = _step.value;
                        hasAttachment = true;
                        return [
                            4,
                            (0, _fileServiceDefault.default).toBase64(attachment)
                        ];
                    case 4:
                        content = _state.sent();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).addAttachment(props.detail.id, attachment.name, content)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 7:
                        return [
                            3,
                            10
                        ];
                    case 8:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            10
                        ];
                    case 9:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 10:
                        setIsPostingComment(false);
                        //if we have an attachement refresh the entire blade
                        if (hasAttachment) props.setReloadDetail(true);
                        else setCacheBuster(true);
                        setNewComment('');
                        stateActions.setCommentText('');
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewComment(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "paneComments",
        className: "flex-fill d-flex flex-column tab-pane",
        children: [
            props.detail.status != 'Closed' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: function(e) {
                    return handleNewComment(e);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: "New Comment"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                        onChange: function(e) {
                            return changeCommentText(e.target.value);
                        },
                        type: "textarea",
                        id: "taNewComment",
                        rows: "4",
                        value: newComment
                    }),
                    attachments.map(function(attachment, i) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                "Attached file: ",
                                attachment.name
                            ]
                        }, i);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                        type: "file",
                        id: "fileNewComment",
                        className: "mt-2 d-inline-block",
                        disabled: newComment.length < 3,
                        onChange: addAttachment,
                        style: {
                            width: '95px'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "(Max File Size: 5MB)"
                    }),
                    attachmentError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-2 text-danger font-italic",
                        children: attachmentError
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-right mt-2",
                        children: isPostingComment ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                            className: "btn-sm",
                            type: "submit",
                            disabled: isPostingComment,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-spinner fa-spin ml-1",
                                    style: {
                                        fontSize: '15px'
                                    }
                                }),
                                " Saving"
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                            className: "btn-sm",
                            type: "submit",
                            disabled: newComment.length < 3,
                            children: "Submit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketHistories, {
                ticket: props.detail,
                ticketId: props.detail.id,
                cacheBuster: cacheBuster,
                setCacheBuster: setCacheBuster
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitialCommentDescription, {
                ticket: props.detail
            })
        ]
    });
};
var BladeTabs = function(props) {
    var _props_showCommentsMsg;
    if (props.activeTab == 1) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BladeTabDetail, {
        detail: props.detail,
        setReloadDetail: props.setReloadDetail,
        showCommentsMsg: (_props_showCommentsMsg = props.showCommentsMsg) !== null && _props_showCommentsMsg !== void 0 ? _props_showCommentsMsg : true,
        fullPage: props.fullPage
    });
    else if (props.activeTab == 2) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BladeTabComments, {
        detail: props.detail,
        setReloadDetail: props.setReloadDetail
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "paneFiles",
        className: "flex-fill d-flex flex-column tab-pane",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TicketAttachmentList, {
            ticket: props.detail,
            ticketId: props.detail.id
        })
    });
};
var InitialCommentDescription = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var momentTzGuess = moment.tz.guess();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 ".concat(props.ticket.customer_id || false ? 'text-left' : 'text-left'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-2 row",
                style: {
                    backgroundColor: '#e9e9e9',
                    paddingBottom: "0px !important"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            width: "90%"
                        },
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "  mb-0",
                                children: [
                                    "Original Ticket created by:",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            textTransform: 'capitalize',
                                            fontWeight: 700
                                        },
                                        children: (0, _connectriaTicketsState.createdBy)(props.ticket.enteredby)
                                    }),
                                    " of",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            fontWeight: 700
                                        },
                                        children: props.ticket.enteredby.customer_id == 0 ? 'Connectria' : stateApp.userInfo.organization_name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: " mb-0",
                                children: moment(props.ticket.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            maxWidth: "10%"
                        },
                        className: "col center-flex-item",
                        children: props.customer_id == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            style: {
                                width: "30px"
                            },
                            src: "data:image/png;base64,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"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "pb-3 pt-1",
                style: {
                    fontSize: "0.97rem",
                    whiteSpace: 'pre-wrap'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: "Description:"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: "taDescription",
                        style: {
                            whiteSpace: 'pre-wrap'
                        },
                        className: "mt-1 rounded mb-3",
                        children: props.ticket.issue
                    }),
                    props.ticket.errorDesc.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Error Description:"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                id: "taDescription",
                                style: {
                                    whiteSpace: 'pre-wrap'
                                },
                                className: "mt-1 rounded mb-3",
                                children: props.ticket.errorDesc
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
                ]
            })
        ]
    }, props.index);
};
var EditTicketSubject = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(props.detail.subject), 2), subject = _useState[0], setSubject = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), editMode = _useState1[0], setEditMode = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    if ([
        'New',
        'Open',
        'WaitOnCust'
    ].indexOf(props.detail.status) === -1) // show basic header without editing feature
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
        children: props.detail.subject
    });
    var style = {
        border: 'solid 1px #ddd',
        borderRadius: '3px',
        padding: '5px',
        fontSize: '18px',
        marginBottom: '15px'
    };
    var save = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(props.detail.subject !== subject)) return [
                            3,
                            2
                        ];
                        setEditMode(false);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).updateTicket(props.detail.id, {
                                subject: subject
                            })
                        ];
                    case 1:
                        _state.sent();
                        setIsLoading(false);
                        (0, _connectriaTicketsServiceDefault.default).clearTicketCache();
                        props.setReloadDetail(true);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function save(e) {
            return _ref.apply(this, arguments);
        };
    }();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: '30px'
            }
        })
    });
    else if (editMode) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        value: subject,
        style: style,
        className: "form-control",
        maxLength: 255,
        onChange: function(e) {
            setSubject(e.target.value);
        },
        onBlur: function(e) {
            return save(e);
        }
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
        style: style,
        onClick: function() {
            return setEditMode(true);
        },
        children: props.detail.subject
    });
};
var ConnectriaTicketsDetailBlade = function(props) {
    //plugin state
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), state = _useTriaTicketsState[0], stateActions = _useTriaTicketsState[1];
    //local state
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), detail = _useState1[0], setDetail = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)('1'), 2), activeTab = _useState2[0], setActiveTab = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(), 2), errMsg = _useState3[0], setErrMsg = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(true), 2), reloadDetail = _useState4[0], setReloadDetail = _useState4[1];
    var history = (0, _reactRouterDom.useHistory)();
    var toggleTab = function(tab) {
        if (activeTab !== tab) setActiveTab(tab);
    };
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var error, error1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!reloadDetail) return [
                            2
                        ];
                        console.log('loading ticket details');
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketDetail(props.id, {
                                cancelToken: source.token
                            })
                        ];
                    case 2:
                        setDetail.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setErrMsg(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center mt-4 text-bold",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-exclamation-triangle"
                                }),
                                " Error pulling ticket #",
                                props.id
                            ]
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (!isMounted()) return [
                            2
                        ];
                        setReloadDetail(false);
                        setIsLoading(false);
                        stateActions.setCommentText('');
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error1 = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error1)) ;
                        else throw error1;
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, [
        reloadDetail
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: '30px'
            }
        })
    });
    else if (errMsg != null) return errMsg;
    else return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "connectria-tickets-detail-blade h-100 d-flex flex-column",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(EditTicketSubject, {
                detail: detail,
                setReloadDetail: setReloadDetail
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ButtonGroup), {
                className: "d-flex mb-2 justify-content-center",
                role: "group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        onClick: function() {
                            return toggleTab('1');
                        },
                        active: activeTab === '1',
                        className: "btn-sm w-100 h-100 ".concat(activeTab !== '1' ? 'btn-simple' : ''),
                        style: {
                            border: 'unset',
                            padding: '5px 10px'
                        },
                        children: "Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        onClick: function() {
                            return toggleTab('2');
                        },
                        active: activeTab === '2',
                        className: "btn-sm w-100 h-100 ".concat(activeTab !== '2' ? 'btn-simple' : ''),
                        style: {
                            border: 'unset',
                            padding: '5px 10px'
                        },
                        children: "Comments"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                        onClick: function() {
                            return toggleTab('3');
                        },
                        active: activeTab === '3',
                        className: "btn-sm w-100 h-100 ".concat(activeTab !== '3' ? 'btn-simple' : ''),
                        style: {
                            border: 'unset',
                            padding: '5px 10px'
                        },
                        children: [
                            "Files",
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Badge), {
                                color: "secondary",
                                style: {
                                    float: 'right',
                                    top: 'unset'
                                },
                                children: detail.ticket_attachments.length
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BladeTabs, {
                activeTab: activeTab,
                detail: detail,
                setReloadDetail: setReloadDetail,
                state: state,
                history: history,
                actions: stateActions
            })
        ]
    });
};
var NewTabLink = function(props) {
    var value = props.value, tooltipMessage = props.tooltipMessage, alertMessage = props.alertMessage, idx = props.idx, className = props.className, style = props.style;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), tooltipOpen = _useState[0], setTooltipOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(tooltipMessage), 2), text = _useState1[0], setText = _useState1[1];
    var toggle = function() {
        setTooltipOpen(!tooltipOpen);
        // When hovering off of tooltip, reset the message
        if (!tooltipOpen) setText(tooltipMessage);
    };
    var openNewTab = function(e) {
        e.preventDefault();
        window.open(props.link, '_blank');
        e.stopPropagation();
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        onClick: function(e) {
            return openNewTab(e);
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: 'fas clickable fa-external-link-alt cursor pt-1 pl-1' + (className ? className : ''),
                id: 'TooltipExample' + (idx + 1 ? idx : ''),
                style: (0, _objectSpread._)({
                    fontSize: '0.9rem'
                }, style)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Tooltip), {
                placement: "right",
                target: 'TooltipExample' + (idx + 1 ? idx : ''),
                isOpen: tooltipOpen,
                toggle: toggle,
                style: {
                    backgroundColor: 'black',
                    color: 'white'
                },
                children: text
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","classnames":"6P5cq","react-router-dom":"acq4R","reactstrap":"774RE","axios":"ebRwi","../../services/ConnectriaTicketsService":"l5X0I","../../services/CookieService":"iKLPT","../../services/PortalService":"9VQnb","./ConnectriaTicketsState":"2XBXC","../../AppState":"8UGXH","../../utility/use-async-effect":"fShZN","../../services/FileService":"iDQLc","../../utility/DateUtil":"i2XgI","f79734c26c1cb77a":"crvQd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9VQnb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _connectriaTicketsService = require("./ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var base_api = 'https://tria.connectria.com';
var _base_accounts_url = 'https://accounts-api.tria.connectria.com/labs/portal/';
function defaultRequest() {
    return _defaultRequest.apply(this, arguments);
}
function _defaultRequest() {
    _defaultRequest = (0, _asyncToGenerator._)(function() {
        var idToken, req;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    req = (0, _axiosDefault.default).create({
                        baseURL: _base_accounts_url,
                        headers: {
                            Authorization: idToken
                        }
                    });
                    //req.defaults.headers['Authorization'] = await Cognito.getIdToken();
                    return [
                        2,
                        req
                    ];
            }
        });
    });
    return _defaultRequest.apply(this, arguments);
}
function _getPortalCustomerMeta(filter) {
    return __getPortalCustomerMeta.apply(this, arguments);
}
function __getPortalCustomerMeta() {
    __getPortalCustomerMeta = (0, _asyncToGenerator._)(function(filter) {
        var params, req, orgId, response, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        defaultRequest()
                    ];
                case 2:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    return [
                        4,
                        req.get("".concat(orgId, "/customer_meta/get"), (0, _objectSpreadProps._)((0, _objectSpread._)({}, params), {
                            params: filter
                        }))
                    ];
                case 3:
                    response = _state.sent();
                    if (response.data.response.errors != null && response.data.response.errors.length > 0) return [
                        2,
                        {
                            metadata: {
                                meta_value: "FALSE"
                            }
                        }
                    ];
                    return [
                        2,
                        response.data.response.data.customer_meta[0]
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __getPortalCustomerMeta.apply(this, arguments);
}
var PortalService = {
    getPortalCustomerMeta: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filter) {
            var params, _;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _ = "customer_id";
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).portalUserId(params)
                        ];
                    case 1:
                        filter[_] = _state.sent();
                        return [
                            4,
                            _getPortalCustomerMeta(filter, params)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = PortalService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","moment":"3xZWN","./ConnectriaTicketsService":"l5X0I","../services/CookieService":"iKLPT","../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2XBXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTriaTicketsState", function() {
    return useTriaTicketsState;
});
parcelHelpers.export(exports, "createdBy", function() {
    return createdBy;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGlobalHook = require("../../UseGlobalHook");
var _useGlobalHookDefault = parcelHelpers.interopDefault(_useGlobalHook);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var initialState = {
    commentText: '',
    tickets: [],
    ticketDetail: {},
    waitOnCustCount: 0,
    isLoading: true,
    filterMine: false,
    statusId: 0
};
var stateActions = {
    clearTickets: function(store) {
        store.setState({
            tickets: []
        });
    },
    addTicket: function(store, ticket) {
        var existingTicket = store.state.tickets.find(function(param) {
            var id = param.id;
            return id === ticket.id;
        });
        if (existingTicket) return;
        store.setState({
            tickets: (0, _toConsumableArray._)(store.state.tickets).concat([
                ticket
            ])
        });
    },
    unshiftTicket: function(store, ticket) {
        var existingTicket = store.state.tickets.find(function(param) {
            var id = param.id;
            return id === ticket.id;
        });
        if (existingTicket) return;
        store.setState({
            tickets: [
                ticket
            ].concat((0, _toConsumableArray._)(store.state.tickets))
        });
    },
    removeTicket: function(store, ticketId) {
        var ticketIndex = store.state.tickets.findIndex(function(param) {
            var id = param.id;
            return id === ticketId;
        });
        if (ticketIndex < 0) return;
        store.state.tickets.splice(ticketIndex, 1);
    },
    setCommentText: function(store, text) {
        store.state.commentText = text;
    },
    setTicketStatus: function(store, ticketId, newStatus) {
        var ticketIndex = store.state.tickets.findIndex(function(param) {
            var id = param.id;
            return id === ticketId;
        });
        if (ticketIndex < 0) return;
        store.state.tickets[ticketIndex].status = newStatus;
    },
    replaceTickets: function(store, tickets) {
        store.setState({
            tickets: (0, _toConsumableArray._)(store.state.tickets).concat([
                tickets
            ])
        });
    },
    setIsLoading: function(store, loadingState) {
        store.setState({
            isLoading: loadingState
        });
    },
    setWaitOnCustCount: function(store, newCount) {
        store.setState({
            waitOnCustCount: newCount
        });
    },
    setTicketDetail: function(store, newDetail) {
        store.setState({
            ticketDetail: newDetail
        });
    },
    setFilterMine: function(store, newFlag) {
        store.setState({
            filterMine: newFlag
        });
    },
    setStatusId: function(store, newId) {
        store.setState({
            statusId: newId
        });
    },
    setSearch: function(store, newSearch) {
        store.setState({
            search: newSearch
        });
    }
};
var useTriaTicketsState = (0, _useGlobalHookDefault.default)((0, _reactDefault.default), initialState, stateActions);
//const [useTriaTicketsState, getTriaTicketsState] = createState(initialState, stateActions);
exports.default = useTriaTicketsState;
//utility function
function createdBy(user) {
    if (!user) return '';
    if (user.fname == null && user.surname == null) return user.login;
    return "".concat(user.fname, " ").concat(user.surname.substring(0, 1) + '.');
}

},{"@swc/helpers/_/_to_consumable_array":"4zJ2w","react":"gVheC","../../UseGlobalHook":"l0Rs8","../../services/ConnectriaTicketsService":"l5X0I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iDQLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileService = {
    toBase64: function toBase64(file) {
        return new Promise(function(resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function() {
                resolve(reader.result.split(',')[1]);
            };
            reader.onerror = function(error) {
                return reject(error);
            };
        });
    }
};
exports.default = FileService;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i2XgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isToday", function() {
    return isToday;
});
parcelHelpers.export(exports, "isYesterday", function() {
    return isYesterday;
});
parcelHelpers.export(exports, "isWithinAWeek", function() {
    return isWithinAWeek;
});
parcelHelpers.export(exports, "isTwoWeeksOrMore", function() {
    return isTwoWeeksOrMore;
});
parcelHelpers.export(exports, "getReadableDate", function() {
    return getReadableDate;
});
parcelHelpers.export(exports, "timezone", function() {
    return timezone;
});
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var REFERENCE = (0, _momentDefault.default)(new Date()); // fixed just for testing, use moment();
var TODAY = REFERENCE.clone().startOf('day');
var MONTH = REFERENCE.clone().startOf('month');
var YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
var A_WEEK_OLD = REFERENCE.clone().subtract(7, 'days').startOf('day');
function isToday(momentDate) {
    return momentDate.isSame(TODAY, 'd');
}
function isYesterday(momentDate) {
    return momentDate.isSame(YESTERDAY, 'd');
}
function isWithinAWeek(momentDate) {
    return momentDate.isAfter(A_WEEK_OLD);
}
function isTwoWeeksOrMore(momentDate) {
    return !isWithinAWeek(momentDate);
}
function getReadableDate(date, momentDate) {
    if (isToday((0, _momentDefault.default)(date))) return momentDate;
    if (isYesterday((0, _momentDefault.default)(date))) return momentDate;
    return (0, _momentDefault.default)(date, "YYYY-MM-DDThh:mm:ss.SSSZ").format('MM/DD/YY');
}
var timezone = function(date) {
    var zone = new Date(date).toLocaleTimeString('en-us', {
        timeZoneName: 'short',
        timeZone: 'America/Chicago'
    }).split(' ')[2];
    return zone;
};

},{"moment":"3xZWN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crvQd":[function(require,module,exports,__globalThis) {
var moment = module.exports = require("a3307e19e25878f5");
moment.tz.load(require("26482b68cc607116"));

},{"a3307e19e25878f5":"27E04","26482b68cc607116":"8HOMJ"}],"27E04":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
//! moment-timezone.js
//! version : 0.5.46
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory(require("782152beb30574e4")); // Node
    else if (typeof define === 'function' && define.amd) define([
        'moment'
    ], factory); // AMD
    else factory(root.moment); // Browser
})(undefined, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.46", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== 'string') logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
    var momentVersion = moment.version.split('.'), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split('.'), whole = parts[0], fractional = parts[1] || '', multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split('|'), offsets = data[2].split(' '), indices = data[3].split(''), untils = data[4].split(' ');
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(' '), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function _set(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function _index(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function countries1() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function parse(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function abbr(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function offset(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function utcOffset(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join('') : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === 'GMT') abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || '').toLowerCase().replace(/\//g, '_');
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split('|');
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(' '));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === 'string') {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split('|');
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split('|');
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(' ');
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === 'X' || m._f === 'x';
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), 'minutes');
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = '';
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), 'minutes');
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== 'string') throw new Error('Time zone name must be a string, got ' + name + ' [' + (typeof name === "undefined" ? "undefined" : (0, _typeOf._)(name)) + ']');
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
        // moment 2.8.1+
        momentProperties.push('_z');
        momentProperties.push('_a');
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

},{"@swc/helpers/_/_type_of":"668P4","782152beb30574e4":"3xZWN"}],"8HOMJ":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"version\":\"2024b\",\"zones\":[\"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5\",\"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5\",\"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5\",\"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6\",\"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4\",\"Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5\",\"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6\",\"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5\",\"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3\",\"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4\",\"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5\",\"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|\",\"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5\",\"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5\",\"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5\",\"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|\",\"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5\",\"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5\",\"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4\",\"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326\",\"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4\",\"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5\",\"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4\",\"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|\",\"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|\",\"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|\",\"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|\",\"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|\",\"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5\",\"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5\",\"America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3\",\"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5\",\"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4\",\"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5\",\"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3\",\"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2\",\"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5\",\"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4\",\"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2\",\"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4\",\"America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4\",\"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5\",\"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3\",\"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5\",\"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4\",\"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5\",\"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5\",\"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4\",\"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8\",\"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3\",\"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2\",\"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5\",\"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5\",\"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5\",\"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3\",\"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5\",\"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5\",\"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2\",\"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5\",\"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3\",\"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2\",\"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2\",\"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5\",\"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5\",\"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4\",\"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4\",\"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5\",\"America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4\",\"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2\",\"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2\",\"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4\",\"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3\",\"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5\",\"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6\",\"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6\",\"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4\",\"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5\",\"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5\",\"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4\",\"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4\",\"America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4\",\"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2\",\"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5\",\"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6\",\"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2\",\"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3\",\"America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5\",\"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5\",\"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5\",\"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\",\"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2\",\"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2\",\"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3\",\"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4\",\"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4\",\"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4\",\"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|\",\"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4\",\"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2\",\"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5\",\"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4\",\"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229\",\"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4\",\"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5\",\"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5\",\"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6\",\"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452\",\"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2\",\"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3\",\"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5\",\"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656\",\"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3\",\"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642\",\"Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10\",\"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70\",\"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4\",\"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1\",\"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60\",\"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5\",\"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40\",\"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130\",\"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5\",\"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40\",\"Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25\",\"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5\",\"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5\",\"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5\",\"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3\",\"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4\",\"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4\",\"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4\",\"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|\",\"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5\",\"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4\",\"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6\",\"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|\",\"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5\",\"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4\",\"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4\",\"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6\",\"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4\",\"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5\",\"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6\",\"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5\",\"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6\",\"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5\",\"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4\",\"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5\",\"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4\",\"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5\",\"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4\",\"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5\",\"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5\",\"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3\",\"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6\",\"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6\",\"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4\",\"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4\",\"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5\",\"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4\",\"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6\",\"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5\",\"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5\",\"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2\",\"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5\",\"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4\",\"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3\",\"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5\",\"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6\",\"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4\",\"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4\",\"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5\",\"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5\",\"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4\",\"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4\",\"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5\",\"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|\",\"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4\",\"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5\",\"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4\",\"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4\",\"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6\",\"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2\",\"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5\",\"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5\",\"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5\",\"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6\",\"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3\",\"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6\",\"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5\",\"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2\",\"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4\",\"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5\",\"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5\",\"Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4\",\"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3\",\"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4\",\"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3\",\"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4\",\"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30\",\"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2\",\"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5\",\"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5\",\"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5\",\"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3\",\"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4\",\"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4\",\"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368\",\"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347\",\"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10\",\"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5\",\"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5\",\"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5\",\"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2\",\"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5\",\"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Etc/GMT-0|GMT|0|0||\",\"Etc/GMT-1|+01|-10|0||\",\"Etc/GMT-10|+10|-a0|0||\",\"Etc/GMT-11|+11|-b0|0||\",\"Etc/GMT-12|+12|-c0|0||\",\"Etc/GMT-13|+13|-d0|0||\",\"Etc/GMT-14|+14|-e0|0||\",\"Etc/GMT-2|+02|-20|0||\",\"Etc/GMT-3|+03|-30|0||\",\"Etc/GMT-4|+04|-40|0||\",\"Etc/GMT-5|+05|-50|0||\",\"Etc/GMT-6|+06|-60|0||\",\"Etc/GMT-7|+07|-70|0||\",\"Etc/GMT-8|+08|-80|0||\",\"Etc/GMT-9|+09|-90|0||\",\"Etc/GMT+1|-01|10|0||\",\"Etc/GMT+10|-10|a0|0||\",\"Etc/GMT+11|-11|b0|0||\",\"Etc/GMT+12|-12|c0|0||\",\"Etc/GMT+2|-02|20|0||\",\"Etc/GMT+3|-03|30|0||\",\"Etc/GMT+4|-04|40|0||\",\"Etc/GMT+5|-05|50|0||\",\"Etc/GMT+6|-06|60|0||\",\"Etc/GMT+7|-07|70|0||\",\"Etc/GMT+8|-08|80|0||\",\"Etc/GMT+9|-09|90|0||\",\"Etc/UTC|UTC|0|0||\",\"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3\",\"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5\",\"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6\",\"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5\",\"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5\",\"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4\",\"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4\",\"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3\",\"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4\",\"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5\",\"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4\",\"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5\",\"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5\",\"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6\",\"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6\",\"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4\",\"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5\",\"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5\",\"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|\",\"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4\",\"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4\",\"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5\",\"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5\",\"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5\",\"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4\",\"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2\",\"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4\",\"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4\",\"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3\",\"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600\",\"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3\",\"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4\",\"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3\",\"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1\",\"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483\",\"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4\",\"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3\",\"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3\",\"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125\",\"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4\",\"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4\",\"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2\",\"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2\",\"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2\",\"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2\",\"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3\",\"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2\",\"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4\",\"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3\",\"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3\",\"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56\",\"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3\",\"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4\",\"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3\"],\"links\":[\"Africa/Abidjan|Africa/Accra\",\"Africa/Abidjan|Africa/Bamako\",\"Africa/Abidjan|Africa/Banjul\",\"Africa/Abidjan|Africa/Conakry\",\"Africa/Abidjan|Africa/Dakar\",\"Africa/Abidjan|Africa/Freetown\",\"Africa/Abidjan|Africa/Lome\",\"Africa/Abidjan|Africa/Nouakchott\",\"Africa/Abidjan|Africa/Ouagadougou\",\"Africa/Abidjan|Africa/Timbuktu\",\"Africa/Abidjan|Atlantic/Reykjavik\",\"Africa/Abidjan|Atlantic/St_Helena\",\"Africa/Abidjan|Iceland\",\"Africa/Cairo|Egypt\",\"Africa/Johannesburg|Africa/Maseru\",\"Africa/Johannesburg|Africa/Mbabane\",\"Africa/Lagos|Africa/Bangui\",\"Africa/Lagos|Africa/Brazzaville\",\"Africa/Lagos|Africa/Douala\",\"Africa/Lagos|Africa/Kinshasa\",\"Africa/Lagos|Africa/Libreville\",\"Africa/Lagos|Africa/Luanda\",\"Africa/Lagos|Africa/Malabo\",\"Africa/Lagos|Africa/Niamey\",\"Africa/Lagos|Africa/Porto-Novo\",\"Africa/Maputo|Africa/Blantyre\",\"Africa/Maputo|Africa/Bujumbura\",\"Africa/Maputo|Africa/Gaborone\",\"Africa/Maputo|Africa/Harare\",\"Africa/Maputo|Africa/Kigali\",\"Africa/Maputo|Africa/Lubumbashi\",\"Africa/Maputo|Africa/Lusaka\",\"Africa/Nairobi|Africa/Addis_Ababa\",\"Africa/Nairobi|Africa/Asmara\",\"Africa/Nairobi|Africa/Asmera\",\"Africa/Nairobi|Africa/Dar_es_Salaam\",\"Africa/Nairobi|Africa/Djibouti\",\"Africa/Nairobi|Africa/Kampala\",\"Africa/Nairobi|Africa/Mogadishu\",\"Africa/Nairobi|Indian/Antananarivo\",\"Africa/Nairobi|Indian/Comoro\",\"Africa/Nairobi|Indian/Mayotte\",\"Africa/Tripoli|Libya\",\"America/Adak|America/Atka\",\"America/Adak|US/Aleutian\",\"America/Anchorage|US/Alaska\",\"America/Argentina/Buenos_Aires|America/Buenos_Aires\",\"America/Argentina/Catamarca|America/Argentina/ComodRivadavia\",\"America/Argentina/Catamarca|America/Catamarca\",\"America/Argentina/Cordoba|America/Cordoba\",\"America/Argentina/Cordoba|America/Rosario\",\"America/Argentina/Jujuy|America/Jujuy\",\"America/Argentina/Mendoza|America/Mendoza\",\"America/Chicago|CST6CDT\",\"America/Chicago|US/Central\",\"America/Denver|America/Shiprock\",\"America/Denver|MST7MDT\",\"America/Denver|Navajo\",\"America/Denver|US/Mountain\",\"America/Detroit|US/Michigan\",\"America/Edmonton|America/Yellowknife\",\"America/Edmonton|Canada/Mountain\",\"America/Fort_Wayne|America/Indiana/Indianapolis\",\"America/Fort_Wayne|America/Indianapolis\",\"America/Fort_Wayne|US/East-Indiana\",\"America/Godthab|America/Nuuk\",\"America/Halifax|Canada/Atlantic\",\"America/Havana|Cuba\",\"America/Indiana/Knox|America/Knox_IN\",\"America/Indiana/Knox|US/Indiana-Starke\",\"America/Iqaluit|America/Pangnirtung\",\"America/Jamaica|Jamaica\",\"America/Kentucky/Louisville|America/Louisville\",\"America/Los_Angeles|PST8PDT\",\"America/Los_Angeles|US/Pacific\",\"America/Manaus|Brazil/West\",\"America/Mazatlan|Mexico/BajaSur\",\"America/Mexico_City|Mexico/General\",\"America/New_York|EST5EDT\",\"America/New_York|US/Eastern\",\"America/Noronha|Brazil/DeNoronha\",\"America/Panama|America/Atikokan\",\"America/Panama|America/Cayman\",\"America/Panama|America/Coral_Harbour\",\"America/Panama|EST\",\"America/Phoenix|America/Creston\",\"America/Phoenix|MST\",\"America/Phoenix|US/Arizona\",\"America/Puerto_Rico|America/Anguilla\",\"America/Puerto_Rico|America/Antigua\",\"America/Puerto_Rico|America/Aruba\",\"America/Puerto_Rico|America/Blanc-Sablon\",\"America/Puerto_Rico|America/Curacao\",\"America/Puerto_Rico|America/Dominica\",\"America/Puerto_Rico|America/Grenada\",\"America/Puerto_Rico|America/Guadeloupe\",\"America/Puerto_Rico|America/Kralendijk\",\"America/Puerto_Rico|America/Lower_Princes\",\"America/Puerto_Rico|America/Marigot\",\"America/Puerto_Rico|America/Montserrat\",\"America/Puerto_Rico|America/Port_of_Spain\",\"America/Puerto_Rico|America/St_Barthelemy\",\"America/Puerto_Rico|America/St_Kitts\",\"America/Puerto_Rico|America/St_Lucia\",\"America/Puerto_Rico|America/St_Thomas\",\"America/Puerto_Rico|America/St_Vincent\",\"America/Puerto_Rico|America/Tortola\",\"America/Puerto_Rico|America/Virgin\",\"America/Regina|Canada/Saskatchewan\",\"America/Rio_Branco|America/Porto_Acre\",\"America/Rio_Branco|Brazil/Acre\",\"America/Santiago|Chile/Continental\",\"America/Sao_Paulo|Brazil/East\",\"America/St_Johns|Canada/Newfoundland\",\"America/Tijuana|America/Ensenada\",\"America/Tijuana|America/Santa_Isabel\",\"America/Tijuana|Mexico/BajaNorte\",\"America/Toronto|America/Montreal\",\"America/Toronto|America/Nassau\",\"America/Toronto|America/Nipigon\",\"America/Toronto|America/Thunder_Bay\",\"America/Toronto|Canada/Eastern\",\"America/Vancouver|Canada/Pacific\",\"America/Whitehorse|Canada/Yukon\",\"America/Winnipeg|America/Rainy_River\",\"America/Winnipeg|Canada/Central\",\"Asia/Ashgabat|Asia/Ashkhabad\",\"Asia/Bangkok|Asia/Phnom_Penh\",\"Asia/Bangkok|Asia/Vientiane\",\"Asia/Bangkok|Indian/Christmas\",\"Asia/Brunei|Asia/Kuching\",\"Asia/Dhaka|Asia/Dacca\",\"Asia/Dubai|Asia/Muscat\",\"Asia/Dubai|Indian/Mahe\",\"Asia/Dubai|Indian/Reunion\",\"Asia/Ho_Chi_Minh|Asia/Saigon\",\"Asia/Hong_Kong|Hongkong\",\"Asia/Jerusalem|Asia/Tel_Aviv\",\"Asia/Jerusalem|Israel\",\"Asia/Kathmandu|Asia/Katmandu\",\"Asia/Kolkata|Asia/Calcutta\",\"Asia/Kuala_Lumpur|Asia/Singapore\",\"Asia/Kuala_Lumpur|Singapore\",\"Asia/Macau|Asia/Macao\",\"Asia/Makassar|Asia/Ujung_Pandang\",\"Asia/Nicosia|Europe/Nicosia\",\"Asia/Qatar|Asia/Bahrain\",\"Asia/Rangoon|Asia/Yangon\",\"Asia/Rangoon|Indian/Cocos\",\"Asia/Riyadh|Antarctica/Syowa\",\"Asia/Riyadh|Asia/Aden\",\"Asia/Riyadh|Asia/Kuwait\",\"Asia/Seoul|ROK\",\"Asia/Shanghai|Asia/Chongqing\",\"Asia/Shanghai|Asia/Chungking\",\"Asia/Shanghai|Asia/Harbin\",\"Asia/Shanghai|PRC\",\"Asia/Taipei|ROC\",\"Asia/Tehran|Iran\",\"Asia/Thimphu|Asia/Thimbu\",\"Asia/Tokyo|Japan\",\"Asia/Ulaanbaatar|Asia/Choibalsan\",\"Asia/Ulaanbaatar|Asia/Ulan_Bator\",\"Asia/Urumqi|Asia/Kashgar\",\"Atlantic/Faroe|Atlantic/Faeroe\",\"Australia/Adelaide|Australia/South\",\"Australia/Brisbane|Australia/Queensland\",\"Australia/Broken_Hill|Australia/Yancowinna\",\"Australia/Darwin|Australia/North\",\"Australia/Hobart|Australia/Currie\",\"Australia/Hobart|Australia/Tasmania\",\"Australia/Lord_Howe|Australia/LHI\",\"Australia/Melbourne|Australia/Victoria\",\"Australia/Perth|Australia/West\",\"Australia/Sydney|Australia/ACT\",\"Australia/Sydney|Australia/Canberra\",\"Australia/Sydney|Australia/NSW\",\"Etc/GMT-0|Etc/GMT\",\"Etc/GMT-0|Etc/GMT+0\",\"Etc/GMT-0|Etc/GMT0\",\"Etc/GMT-0|Etc/Greenwich\",\"Etc/GMT-0|GMT\",\"Etc/GMT-0|GMT+0\",\"Etc/GMT-0|GMT-0\",\"Etc/GMT-0|GMT0\",\"Etc/GMT-0|Greenwich\",\"Etc/UTC|Etc/UCT\",\"Etc/UTC|Etc/Universal\",\"Etc/UTC|Etc/Zulu\",\"Etc/UTC|UCT\",\"Etc/UTC|UTC\",\"Etc/UTC|Universal\",\"Etc/UTC|Zulu\",\"Europe/Athens|EET\",\"Europe/Belgrade|Europe/Ljubljana\",\"Europe/Belgrade|Europe/Podgorica\",\"Europe/Belgrade|Europe/Sarajevo\",\"Europe/Belgrade|Europe/Skopje\",\"Europe/Belgrade|Europe/Zagreb\",\"Europe/Berlin|Arctic/Longyearbyen\",\"Europe/Berlin|Atlantic/Jan_Mayen\",\"Europe/Berlin|Europe/Copenhagen\",\"Europe/Berlin|Europe/Oslo\",\"Europe/Berlin|Europe/Stockholm\",\"Europe/Brussels|CET\",\"Europe/Brussels|Europe/Amsterdam\",\"Europe/Brussels|Europe/Luxembourg\",\"Europe/Brussels|MET\",\"Europe/Chisinau|Europe/Tiraspol\",\"Europe/Dublin|Eire\",\"Europe/Helsinki|Europe/Mariehamn\",\"Europe/Istanbul|Asia/Istanbul\",\"Europe/Istanbul|Turkey\",\"Europe/Kiev|Europe/Kyiv\",\"Europe/Kiev|Europe/Uzhgorod\",\"Europe/Kiev|Europe/Zaporozhye\",\"Europe/Lisbon|Portugal\",\"Europe/Lisbon|WET\",\"Europe/London|Europe/Belfast\",\"Europe/London|Europe/Guernsey\",\"Europe/London|Europe/Isle_of_Man\",\"Europe/London|Europe/Jersey\",\"Europe/London|GB\",\"Europe/London|GB-Eire\",\"Europe/Moscow|W-SU\",\"Europe/Paris|Europe/Monaco\",\"Europe/Prague|Europe/Bratislava\",\"Europe/Rome|Europe/San_Marino\",\"Europe/Rome|Europe/Vatican\",\"Europe/Warsaw|Poland\",\"Europe/Zurich|Europe/Busingen\",\"Europe/Zurich|Europe/Vaduz\",\"Indian/Maldives|Indian/Kerguelen\",\"Pacific/Auckland|Antarctica/McMurdo\",\"Pacific/Auckland|Antarctica/South_Pole\",\"Pacific/Auckland|NZ\",\"Pacific/Chatham|NZ-CHAT\",\"Pacific/Easter|Chile/EasterIsland\",\"Pacific/Enderbury|Pacific/Kanton\",\"Pacific/Guadalcanal|Pacific/Pohnpei\",\"Pacific/Guadalcanal|Pacific/Ponape\",\"Pacific/Guam|Pacific/Saipan\",\"Pacific/Honolulu|HST\",\"Pacific/Honolulu|Pacific/Johnston\",\"Pacific/Honolulu|US/Hawaii\",\"Pacific/Kwajalein|Kwajalein\",\"Pacific/Pago_Pago|Pacific/Midway\",\"Pacific/Pago_Pago|Pacific/Samoa\",\"Pacific/Pago_Pago|US/Samoa\",\"Pacific/Port_Moresby|Antarctica/DumontDUrville\",\"Pacific/Port_Moresby|Pacific/Chuuk\",\"Pacific/Port_Moresby|Pacific/Truk\",\"Pacific/Port_Moresby|Pacific/Yap\",\"Pacific/Tarawa|Pacific/Funafuti\",\"Pacific/Tarawa|Pacific/Majuro\",\"Pacific/Tarawa|Pacific/Wake\",\"Pacific/Tarawa|Pacific/Wallis\"],\"countries\":[\"AD|Europe/Andorra\",\"AE|Asia/Dubai\",\"AF|Asia/Kabul\",\"AG|America/Puerto_Rico America/Antigua\",\"AI|America/Puerto_Rico America/Anguilla\",\"AL|Europe/Tirane\",\"AM|Asia/Yerevan\",\"AO|Africa/Lagos Africa/Luanda\",\"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa\",\"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia\",\"AS|Pacific/Pago_Pago\",\"AT|Europe/Vienna\",\"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla\",\"AW|America/Puerto_Rico America/Aruba\",\"AX|Europe/Helsinki Europe/Mariehamn\",\"AZ|Asia/Baku\",\"BA|Europe/Belgrade Europe/Sarajevo\",\"BB|America/Barbados\",\"BD|Asia/Dhaka\",\"BE|Europe/Brussels\",\"BF|Africa/Abidjan Africa/Ouagadougou\",\"BG|Europe/Sofia\",\"BH|Asia/Qatar Asia/Bahrain\",\"BI|Africa/Maputo Africa/Bujumbura\",\"BJ|Africa/Lagos Africa/Porto-Novo\",\"BL|America/Puerto_Rico America/St_Barthelemy\",\"BM|Atlantic/Bermuda\",\"BN|Asia/Kuching Asia/Brunei\",\"BO|America/La_Paz\",\"BQ|America/Puerto_Rico America/Kralendijk\",\"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco\",\"BS|America/Toronto America/Nassau\",\"BT|Asia/Thimphu\",\"BW|Africa/Maputo Africa/Gaborone\",\"BY|Europe/Minsk\",\"BZ|America/Belize\",\"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston\",\"CC|Asia/Yangon Indian/Cocos\",\"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi\",\"CF|Africa/Lagos Africa/Bangui\",\"CG|Africa/Lagos Africa/Brazzaville\",\"CH|Europe/Zurich\",\"CI|Africa/Abidjan\",\"CK|Pacific/Rarotonga\",\"CL|America/Santiago America/Punta_Arenas Pacific/Easter\",\"CM|Africa/Lagos Africa/Douala\",\"CN|Asia/Shanghai Asia/Urumqi\",\"CO|America/Bogota\",\"CR|America/Costa_Rica\",\"CU|America/Havana\",\"CV|Atlantic/Cape_Verde\",\"CW|America/Puerto_Rico America/Curacao\",\"CX|Asia/Bangkok Indian/Christmas\",\"CY|Asia/Nicosia Asia/Famagusta\",\"CZ|Europe/Prague\",\"DE|Europe/Zurich Europe/Berlin Europe/Busingen\",\"DJ|Africa/Nairobi Africa/Djibouti\",\"DK|Europe/Berlin Europe/Copenhagen\",\"DM|America/Puerto_Rico America/Dominica\",\"DO|America/Santo_Domingo\",\"DZ|Africa/Algiers\",\"EC|America/Guayaquil Pacific/Galapagos\",\"EE|Europe/Tallinn\",\"EG|Africa/Cairo\",\"EH|Africa/El_Aaiun\",\"ER|Africa/Nairobi Africa/Asmara\",\"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary\",\"ET|Africa/Nairobi Africa/Addis_Ababa\",\"FI|Europe/Helsinki\",\"FJ|Pacific/Fiji\",\"FK|Atlantic/Stanley\",\"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei\",\"FO|Atlantic/Faroe\",\"FR|Europe/Paris\",\"GA|Africa/Lagos Africa/Libreville\",\"GB|Europe/London\",\"GD|America/Puerto_Rico America/Grenada\",\"GE|Asia/Tbilisi\",\"GF|America/Cayenne\",\"GG|Europe/London Europe/Guernsey\",\"GH|Africa/Abidjan Africa/Accra\",\"GI|Europe/Gibraltar\",\"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule\",\"GM|Africa/Abidjan Africa/Banjul\",\"GN|Africa/Abidjan Africa/Conakry\",\"GP|America/Puerto_Rico America/Guadeloupe\",\"GQ|Africa/Lagos Africa/Malabo\",\"GR|Europe/Athens\",\"GS|Atlantic/South_Georgia\",\"GT|America/Guatemala\",\"GU|Pacific/Guam\",\"GW|Africa/Bissau\",\"GY|America/Guyana\",\"HK|Asia/Hong_Kong\",\"HN|America/Tegucigalpa\",\"HR|Europe/Belgrade Europe/Zagreb\",\"HT|America/Port-au-Prince\",\"HU|Europe/Budapest\",\"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura\",\"IE|Europe/Dublin\",\"IL|Asia/Jerusalem\",\"IM|Europe/London Europe/Isle_of_Man\",\"IN|Asia/Kolkata\",\"IO|Indian/Chagos\",\"IQ|Asia/Baghdad\",\"IR|Asia/Tehran\",\"IS|Africa/Abidjan Atlantic/Reykjavik\",\"IT|Europe/Rome\",\"JE|Europe/London Europe/Jersey\",\"JM|America/Jamaica\",\"JO|Asia/Amman\",\"JP|Asia/Tokyo\",\"KE|Africa/Nairobi\",\"KG|Asia/Bishkek\",\"KH|Asia/Bangkok Asia/Phnom_Penh\",\"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati\",\"KM|Africa/Nairobi Indian/Comoro\",\"KN|America/Puerto_Rico America/St_Kitts\",\"KP|Asia/Pyongyang\",\"KR|Asia/Seoul\",\"KW|Asia/Riyadh Asia/Kuwait\",\"KY|America/Panama America/Cayman\",\"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral\",\"LA|Asia/Bangkok Asia/Vientiane\",\"LB|Asia/Beirut\",\"LC|America/Puerto_Rico America/St_Lucia\",\"LI|Europe/Zurich Europe/Vaduz\",\"LK|Asia/Colombo\",\"LR|Africa/Monrovia\",\"LS|Africa/Johannesburg Africa/Maseru\",\"LT|Europe/Vilnius\",\"LU|Europe/Brussels Europe/Luxembourg\",\"LV|Europe/Riga\",\"LY|Africa/Tripoli\",\"MA|Africa/Casablanca\",\"MC|Europe/Paris Europe/Monaco\",\"MD|Europe/Chisinau\",\"ME|Europe/Belgrade Europe/Podgorica\",\"MF|America/Puerto_Rico America/Marigot\",\"MG|Africa/Nairobi Indian/Antananarivo\",\"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro\",\"MK|Europe/Belgrade Europe/Skopje\",\"ML|Africa/Abidjan Africa/Bamako\",\"MM|Asia/Yangon\",\"MN|Asia/Ulaanbaatar Asia/Hovd\",\"MO|Asia/Macau\",\"MP|Pacific/Guam Pacific/Saipan\",\"MQ|America/Martinique\",\"MR|Africa/Abidjan Africa/Nouakchott\",\"MS|America/Puerto_Rico America/Montserrat\",\"MT|Europe/Malta\",\"MU|Indian/Mauritius\",\"MV|Indian/Maldives\",\"MW|Africa/Maputo Africa/Blantyre\",\"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana\",\"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur\",\"MZ|Africa/Maputo\",\"NA|Africa/Windhoek\",\"NC|Pacific/Noumea\",\"NE|Africa/Lagos Africa/Niamey\",\"NF|Pacific/Norfolk\",\"NG|Africa/Lagos\",\"NI|America/Managua\",\"NL|Europe/Brussels Europe/Amsterdam\",\"NO|Europe/Berlin Europe/Oslo\",\"NP|Asia/Kathmandu\",\"NR|Pacific/Nauru\",\"NU|Pacific/Niue\",\"NZ|Pacific/Auckland Pacific/Chatham\",\"OM|Asia/Dubai Asia/Muscat\",\"PA|America/Panama\",\"PE|America/Lima\",\"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier\",\"PG|Pacific/Port_Moresby Pacific/Bougainville\",\"PH|Asia/Manila\",\"PK|Asia/Karachi\",\"PL|Europe/Warsaw\",\"PM|America/Miquelon\",\"PN|Pacific/Pitcairn\",\"PR|America/Puerto_Rico\",\"PS|Asia/Gaza Asia/Hebron\",\"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores\",\"PW|Pacific/Palau\",\"PY|America/Asuncion\",\"QA|Asia/Qatar\",\"RE|Asia/Dubai Indian/Reunion\",\"RO|Europe/Bucharest\",\"RS|Europe/Belgrade\",\"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr\",\"RW|Africa/Maputo Africa/Kigali\",\"SA|Asia/Riyadh\",\"SB|Pacific/Guadalcanal\",\"SC|Asia/Dubai Indian/Mahe\",\"SD|Africa/Khartoum\",\"SE|Europe/Berlin Europe/Stockholm\",\"SG|Asia/Singapore\",\"SH|Africa/Abidjan Atlantic/St_Helena\",\"SI|Europe/Belgrade Europe/Ljubljana\",\"SJ|Europe/Berlin Arctic/Longyearbyen\",\"SK|Europe/Prague Europe/Bratislava\",\"SL|Africa/Abidjan Africa/Freetown\",\"SM|Europe/Rome Europe/San_Marino\",\"SN|Africa/Abidjan Africa/Dakar\",\"SO|Africa/Nairobi Africa/Mogadishu\",\"SR|America/Paramaribo\",\"SS|Africa/Juba\",\"ST|Africa/Sao_Tome\",\"SV|America/El_Salvador\",\"SX|America/Puerto_Rico America/Lower_Princes\",\"SY|Asia/Damascus\",\"SZ|Africa/Johannesburg Africa/Mbabane\",\"TC|America/Grand_Turk\",\"TD|Africa/Ndjamena\",\"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen\",\"TG|Africa/Abidjan Africa/Lome\",\"TH|Asia/Bangkok\",\"TJ|Asia/Dushanbe\",\"TK|Pacific/Fakaofo\",\"TL|Asia/Dili\",\"TM|Asia/Ashgabat\",\"TN|Africa/Tunis\",\"TO|Pacific/Tongatapu\",\"TR|Europe/Istanbul\",\"TT|America/Puerto_Rico America/Port_of_Spain\",\"TV|Pacific/Tarawa Pacific/Funafuti\",\"TW|Asia/Taipei\",\"TZ|Africa/Nairobi Africa/Dar_es_Salaam\",\"UA|Europe/Simferopol Europe/Kyiv\",\"UG|Africa/Nairobi Africa/Kampala\",\"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake\",\"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu\",\"UY|America/Montevideo\",\"UZ|Asia/Samarkand Asia/Tashkent\",\"VA|Europe/Rome Europe/Vatican\",\"VC|America/Puerto_Rico America/St_Vincent\",\"VE|America/Caracas\",\"VG|America/Puerto_Rico America/Tortola\",\"VI|America/Puerto_Rico America/St_Thomas\",\"VN|Asia/Bangkok Asia/Ho_Chi_Minh\",\"VU|Pacific/Efate\",\"WF|Pacific/Tarawa Pacific/Wallis\",\"WS|Pacific/Apia\",\"YE|Asia/Riyadh Asia/Aden\",\"YT|Africa/Nairobi Indian/Mayotte\",\"ZA|Africa/Johannesburg\",\"ZM|Africa/Maputo Africa/Lusaka\",\"ZW|Africa/Maputo Africa/Harare\"]}");

},{}],"9jp5S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdvancedTicketSearch", function() {
    return AdvancedTicketSearch;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _appState = require("../../AppState");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
// reactstrap components
var _reactstrap = require("reactstrap");
var _reactWidgetsMoment = require("react-widgets-moment");
var _reactWidgetsMomentDefault = parcelHelpers.interopDefault(_reactWidgetsMoment);
var _dateTimePicker = require("react-widgets/lib/DateTimePicker");
var _dateTimePickerDefault = parcelHelpers.interopDefault(_dateTimePicker);
var _reactWidgetsCss = require("react-widgets/dist/css/react-widgets.css");
(0, _momentDefault.default).locale('en');
(0, _reactWidgetsMomentDefault.default)();
var AdvancedTicketSearch = function(props) {
    var inboxFilterState = props.inboxFilterState, setInboxFilterState = props.setInboxFilterState;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({}), 2), filterState = _useState[0], setFilterState = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), params = _useState1[0], setParams = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)([]), 2), categories = _useState2[0], setCategories = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), uniqueCategoryNames = _useState3[0], setUniqueCategoryNames = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)([]), 2), users = _useState4[0], setUsers = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), ticketTypes = _useState5[0], setTicketTypes = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)([]), 2), priorities = _useState6[0], setPriorities = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(true), 2), showFilters = _useState7[0], setShowFilters = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(""), 2), searchString = _useState8[0], setSearchString = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)([]), 2), keywords = _useState9[0], setKeywords = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)({
        param: "",
        start: null,
        end: null
    }), 2), dateRange = _useState10[0], setDateRange = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)(false), 2), dateRangeIsFull = _useState11[0], setDateRangeIsFull = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)(false), 2), searchComments = _useState12[0], setSearchComments = _useState12[1];
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState13[0], setIsLoading = _useState13[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var isCustomer, _ref, categories, users, ticketTypes, priorities, uniqueCategoryNames, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        isCustomer = stateApp.userInfo.organization_id != 0;
                        return [
                            4,
                            Promise.all([
                                (0, _connectriaTicketsServiceDefault.default).ticketCategories({}),
                                (0, _connectriaTicketsServiceDefault.default).getAllUsersLike({}, isCustomer),
                                (0, _connectriaTicketsServiceDefault.default).ticketTypes({
                                    cancelToken: source.token
                                }),
                                (0, _connectriaTicketsServiceDefault.default).ticketPriorities()
                            ])
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            4
                        ]), categories = _ref[0], users = _ref[1], ticketTypes = _ref[2], priorities = _ref[3];
                        if (!isMounted()) return [
                            2
                        ];
                        uniqueCategoryNames = (0, _toConsumableArray._)(new Set(categories.map(function(category) {
                            return category.name;
                        })));
                        setCategories(categories);
                        setUniqueCategoryNames(uniqueCategoryNames);
                        setUsers(users);
                        setTicketTypes(ticketTypes.filter(function(e) {
                            return e.name != 'Problem';
                        }));
                        setPriorities(priorities);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else {
                            setIsLoading(false);
                            throw error;
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    (0, _react.useEffect)(function() {
        if (params.length > 0) setShowFilters(true);
    }, [
        filterState
    ]);
    // Add the date range to the param list
    (0, _react.useEffect)(function() {
        if (dateRange.param != "" && dateRange.start != null && dateRange.end != null) {
            var start = (0, _momentDefault.default)(dateRange.start).format("YYYY-MM-DD");
            var end = (0, _momentDefault.default)(dateRange.end).format("YYYY-MM-DD");
            // Filter out current date param, we can only use one date range currently
            var newParams = params.filter(function(param) {
                return param.key != "dateRange";
            });
            setParams((0, _toConsumableArray._)(newParams).concat([
                {
                    key: "dateRange",
                    value: "dateRange",
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: dateRange.label
                            }),
                            " between ",
                            start,
                            " - ",
                            end
                        ]
                    })
                }
            ]));
            setDateRangeIsFull(true);
        } else setDateRangeIsFull(false);
    }, [
        dateRange
    ]);
    // Remove the date range param in the list if the date range isn't fully filled out
    (0, _react.useEffect)(function() {
        if (!dateRangeIsFull) setParams((0, _toConsumableArray._)(params.filter(function(param) {
            return param.key != "dateRange";
        })));
    }, [
        dateRangeIsFull
    ]);
    var removeParam = function(key, value, i) {
        var newParams = params;
        var newFilterState = filterState;
        if (Array.isArray(value)) {
            value = value[0];
            newFilterState[key] = newFilterState[key].filter(function(v) {
                return !value.includes(v);
            });
        } else newFilterState[key] = newFilterState[key].filter(function(v) {
            return v != value;
        });
        newParams.splice(i, 1);
        if (newParams.length == 0) setShowFilters(false);
        setParams((0, _toConsumableArray._)(newParams));
        setFilterState((0, _objectSpread._)({}, newFilterState));
    };
    var resetParams = function() {
        setFilterState({});
        setInboxFilterState({});
        setDateRange({
            param: "",
            start: null,
            end: null
        });
        setParams([]);
    };
    var handleStatusChange = function(e) {
        var _filterState_status;
        var statusCustomerName = e.target.value == "WaitOnCust" ? "Input Required" : e.target.value;
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_status = filterState.status) === null || _filterState_status === void 0 ? void 0 : _filterState_status.includes(e.target.value))) {
            var _filterState_status1;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                status: (0, _toConsumableArray._)((_filterState_status1 = filterState.status) !== null && _filterState_status1 !== void 0 ? _filterState_status1 : []).concat([
                    e.target.value
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "status",
                    value: e.target.value,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "Ticket Status"
                            }),
                            ' like "',
                            statusCustomerName,
                            '"'
                        ]
                    })
                }
            ]));
        }
    };
    var handleUserChange = function(e) {
        var _filterState_user_id;
        var index = e.target.value;
        var user = users[index];
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_user_id = filterState.user_id) === null || _filterState_user_id === void 0 ? void 0 : _filterState_user_id.includes(user.id))) {
            var _filterState_user_id1;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                user_id: (0, _toConsumableArray._)((_filterState_user_id1 = filterState.user_id) !== null && _filterState_user_id1 !== void 0 ? _filterState_user_id1 : []).concat([
                    user.id
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "user_id",
                    value: user.id,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "User Login"
                            }),
                            ' like "',
                            user.login,
                            '"'
                        ]
                    })
                }
            ]));
        }
    };
    var handleTicketTypeChange = function(e) {
        var _filterState_ticket_type_id;
        var index = e.target.value;
        var ticketType = ticketTypes[index];
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_ticket_type_id = filterState.ticket_type_id) === null || _filterState_ticket_type_id === void 0 ? void 0 : _filterState_ticket_type_id.includes(ticketType.id))) {
            var _filterState_ticket_type_id1;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                ticket_type_id: (0, _toConsumableArray._)((_filterState_ticket_type_id1 = filterState.ticket_type_id) !== null && _filterState_ticket_type_id1 !== void 0 ? _filterState_ticket_type_id1 : []).concat([
                    ticketType.id
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "ticket_type_id",
                    value: ticketType.id,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "Ticket Type"
                            }),
                            ' like "',
                            ticketType.name,
                            '"'
                        ]
                    })
                }
            ]));
        }
    };
    var handlePriorityChange = function(e) {
        var _filterState_priority;
        var index = e.target.value;
        var priority = priorities[index];
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_priority = filterState.priority) === null || _filterState_priority === void 0 ? void 0 : _filterState_priority.includes(priority.id))) {
            var _filterState_priority1;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                priority: (0, _toConsumableArray._)((_filterState_priority1 = filterState.priority) !== null && _filterState_priority1 !== void 0 ? _filterState_priority1 : []).concat([
                    priority.id
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "priority",
                    value: priority.id,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "Ticket Type"
                            }),
                            ' like "',
                            priority.name,
                            '"'
                        ]
                    })
                }
            ]));
        }
    };
    var handleCategoryChange = function(e) {
        var _filterState_ticketcategory_id;
        var categoryName = e.target.value;
        var categoryIds = categories.filter(function(category) {
            return category.name == categoryName;
        }).map(function(category) {
            return category.id;
        });
        var _filterState_ticketcategory_id1;
        var filterIds = (_filterState_ticketcategory_id1 = filterState.ticketcategory_id) !== null && _filterState_ticketcategory_id1 !== void 0 ? _filterState_ticketcategory_id1 : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = categoryIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_ticketcategory_id = filterState.ticketcategory_id) === null || _filterState_ticketcategory_id === void 0 ? void 0 : _filterState_ticketcategory_id.includes(id))) filterIds.push(id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
            ticketcategory_id: filterIds
        }));
        var newParam = {
            key: "ticketcategory_id",
            value: [
                categoryIds
            ],
            description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        className: "pr-1",
                        children: "Category"
                    }),
                    ' like "',
                    categoryName,
                    '"'
                ]
            })
        };
        var identicalParam = params.find(function(param) {
            return JSON.stringify(param) == JSON.stringify(newParam);
        });
        if (!identicalParam) setParams((0, _toConsumableArray._)(params).concat([
            newParam
        ]));
    };
    var handleSubCategoryChange = function(e) {
        var _filterState_ticketcategory_id;
        var categoryId = parseInt(e.target.value);
        var subcategory = categories.find(function(category) {
            return category.id == categoryId;
        });
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_ticketcategory_id = filterState.ticketcategory_id) === null || _filterState_ticketcategory_id === void 0 ? void 0 : _filterState_ticketcategory_id.includes(categoryId))) {
            var _filterState_ticketcategory_id1;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                ticketcategory_id: (0, _toConsumableArray._)((_filterState_ticketcategory_id1 = filterState.ticketcategory_id) !== null && _filterState_ticketcategory_id1 !== void 0 ? _filterState_ticketcategory_id1 : []).concat([
                    subcategory.id
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "ticketcategory_id",
                    value: subcategory.id,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "Sub-Category"
                            }),
                            ' like "',
                            subcategory.name,
                            ": ",
                            subcategory.subcategory,
                            '"'
                        ]
                    })
                }
            ]));
        }
    };
    var handleDateChange = function(e) {
        var param = e.target.value;
        var label = "";
        switch(param){
            case "created":
                label = "Created";
                break;
            case "lastUpdate":
                label = "Updated";
                break;
            case "cancelled_on":
                label = "Cancelled";
                break;
            case "resolved_on":
                label = "Resolved";
                break;
            case "closed_on":
                label = "Closed";
                break;
            default:
                label = "";
        }
        setDateRange((0, _objectSpreadProps._)((0, _objectSpread._)({}, dateRange), {
            param: param,
            label: label
        }));
    };
    var handleKeywordChange = function(e) {
        var _filterState_keywords;
        e.preventDefault();
        if (!(filterState === null || filterState === void 0 ? void 0 : (_filterState_keywords = filterState.keywords) === null || _filterState_keywords === void 0 ? void 0 : _filterState_keywords.includes(searchString))) {
            var _filterState_keyword;
            setFilterState((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterState), {
                keyword: (0, _toConsumableArray._)((_filterState_keyword = filterState.keyword) !== null && _filterState_keyword !== void 0 ? _filterState_keyword : []).concat([
                    searchString
                ])
            }));
            setParams((0, _toConsumableArray._)(params).concat([
                {
                    key: "keyword",
                    value: searchString,
                    description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                className: "pr-1",
                                children: "Keyword"
                            }),
                            ' like "',
                            searchString,
                            '"'
                        ]
                    })
                }
            ]));
        }
        setSearchString("");
    };
    var submit = function(e) {
        e.preventDefault();
        var fullFilterState = (0, _objectSpread._)({}, filterState);
        if (!(dateRange.param == "" || dateRange.start == null || dateRange.end == null)) fullFilterState[dateRange.param] = [
            (0, _momentDefault.default)(dateRange.start).format("YYYY-MM-DD"),
            (0, _momentDefault.default)(dateRange.end).format("YYYY-MM-DD")
        ];
        if (searchComments) fullFilterState.searchComments = true;
        // Set the actual filter for the ticketing inbox. Go get tickets
        setInboxFilterState(fullFilterState);
    };
    var toggleSearchComments = function(e) {
        setSearchComments(!searchComments);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchTicketCommentsWarning, {
                searchTicketComments: searchComments
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-spinner m-3 mt-4 fa-spin",
                    style: {
                        fontSize: "30px"
                    }
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "col-lg-6 col-sm-12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-12",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "col-8",
                                                        style: {
                                                            maxWidth: "70%",
                                                            flex: "0 0 70%"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                                className: "m-0",
                                                                children: "Keyword"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                                                onSubmit: handleKeywordChange,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                                    id: "aKeyword",
                                                                    placeholder: "Search subject or description",
                                                                    value: searchString,
                                                                    onChange: function(e) {
                                                                        setSearchString(e.target.value);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "col-4",
                                                        style: {
                                                            maxWidth: "30%",
                                                            flex: "0 0 30%"
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                                            id: "aAddKeyword",
                                                            size: "sm",
                                                            className: "keyword-search-btn",
                                                            disabled: searchString.length == 0,
                                                            onClick: handleKeywordChange,
                                                            style: {
                                                                marginTop: "1.6rem",
                                                                maxWidth: "100%"
                                                            },
                                                            children: "Add Keyword"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row pt-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        for: "startDatePicker",
                                                        children: "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aDatePicker",
                                                        bsSize: "sm",
                                                        value: dateRange.param,
                                                        onChange: handleDateChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "created",
                                                                children: "Created"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "lastUpdate",
                                                                children: "Updated"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "cancelled_on",
                                                                children: "Cancelled"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "resolved_on",
                                                                children: "Resolved"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "closed_on",
                                                                children: "Closed"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col",
                                                style: {
                                                    paddingTop: "1.25rem"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                                    id: "startDatePicker",
                                                    format: 'YYYY-MM-DD',
                                                    value: dateRange.start,
                                                    max: new Date(),
                                                    time: false,
                                                    placeholder: "YYYY-MM-DD",
                                                    onChange: function(value) {
                                                        setDateRange((0, _objectSpreadProps._)((0, _objectSpread._)({}, dateRange), {
                                                            start: value == "Invalid Date" ? "" : value
                                                        }));
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col",
                                                style: {
                                                    paddingTop: "1.25rem"
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                                    id: "endDatePicker",
                                                    format: 'YYYY-MM-DD',
                                                    value: dateRange.end,
                                                    min: dateRange.start,
                                                    max: new Date(),
                                                    time: false,
                                                    placeholder: "YYYY-MM-DD",
                                                    onChange: function(value) {
                                                        setDateRange((0, _objectSpreadProps._)((0, _objectSpread._)({}, dateRange), {
                                                            end: value == "Invalid Date" ? "" : value
                                                        }));
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "col-lg-6 col-sm-12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aStatus",
                                                        value: "",
                                                        onChange: handleStatusChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "New",
                                                                children: "New"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Open",
                                                                children: "Open"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "WaitOnCust",
                                                                children: "Input Required"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Scheduled",
                                                                children: "Scheduled"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Resolved",
                                                                children: "Resolved"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Closed",
                                                                children: "Closed"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Suspended",
                                                                children: "Suspended"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: "Cancelled",
                                                                children: "Cancelled"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Owner"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aOwner",
                                                        value: "",
                                                        onChange: handleUserChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            users.map(function(user, i) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: i,
                                                                    children: user.login
                                                                }, i);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Ticket Type"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aTicketType",
                                                        value: "",
                                                        onChange: handleTicketTypeChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            ticketTypes.map(function(type, i) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: i,
                                                                    children: type.name
                                                                }, i);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row pt-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Current Priority"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aCurrentPriority",
                                                        value: "",
                                                        onChange: handlePriorityChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            priorities.map(function(priority, i) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: i,
                                                                    children: priority.name
                                                                }, i);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Category"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aCategory",
                                                        value: "",
                                                        onChange: handleCategoryChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            (0, _toConsumableArray._)(new Set(categories.map(function(category) {
                                                                return category.name;
                                                            }))).map(function(category) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: category.name,
                                                                    children: category
                                                                });
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "col-4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "m-0",
                                                        children: "Sub-Category"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "aSubCategory",
                                                        value: "",
                                                        onChange: handleSubCategoryChange,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                disabled: true
                                                            }),
                                                            uniqueCategoryNames.map(function(categoryName, i) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("optgroup", {
                                                                    label: categoryName,
                                                                    children: (0, _toConsumableArray._)(categories).sort(function(a, b) {
                                                                        return a.subcategory.localeCompare(b.subcategory);
                                                                    }).map(function(category, i) {
                                                                        return category.name == categoryName && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                            value: category.id,
                                                                            children: category.subcategory
                                                                        }, i);
                                                                    })
                                                                }, i);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex justify-content-between pt-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                                id: "aShowFilters",
                                size: "sm",
                                onClick: function() {
                                    return setShowFilters(!showFilters);
                                },
                                children: [
                                    "Show Filters (",
                                    params.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "row d-flex",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "inline form-check pr-2 hide-sm",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "form-check-label",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("nobr", {
                                                    children: "Search Ticket Comments"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    checked: searchComments,
                                                    onChange: toggleSearchComments
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "form-check-sign",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "check"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        id: "aReset",
                                        size: "sm",
                                        onClick: resetParams,
                                        children: "Reset"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        id: "aSubmit",
                                        size: "sm",
                                        color: "primary",
                                        className: "mx-1",
                                        onClick: submit,
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "inline form-check d-lg-none",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "form-check-label",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("nobr", {
                                    children: "Search Ticket Comments"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    className: "form-check-input",
                                    checked: searchComments,
                                    onChange: toggleSearchComments
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "form-check-sign",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "check"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Collapse), {
                        isOpen: showFilters,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Card), {
                            style: {
                                backgroundColor: "#e6e5e5"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                                children: params.map(function(param, i) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-times text-danger cursor my-auto pr-1",
                                                onClick: function() {
                                                    removeParam(param.key, param.value, i);
                                                }
                                            }),
                                            param.description
                                        ]
                                    });
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var SearchTicketCommentsWarning = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), modal = _useState[0], setModal = _useState[1];
    (0, _react.useEffect)(function() {
        setModal(props.searchTicketComments);
    }, [
        props.searchTicketComments
    ]);
    var toggle = function() {
        return setModal(!modal);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: modal,
        toggle: toggle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                children: "Search Ticket Comments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: "Including ticket comments in your search parameters may cause extended delays in retrieving your information"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "right",
                        color: "secondary",
                        onClick: toggle,
                        children: "Ok"
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../../utility/use-async-effect":"fShZN","axios":"ebRwi","../../services/ConnectriaTicketsService":"l5X0I","../../AppState":"8UGXH","moment":"3xZWN","reactstrap":"774RE","react-widgets-moment":"4UbXs","react-widgets/lib/DateTimePicker":"4KVXE","react-widgets/dist/css/react-widgets.css":"kGl4g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4UbXs":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = momentLocalizer;
var _moment = _interopRequireDefault(require("309ee9423caa4a03"));
var _configure = _interopRequireDefault(require("bb8b5001c175b993"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
if (typeof _moment.default !== 'function') throw new TypeError('You must provide a valid moment object');
var localField = typeof (0, _moment.default)().locale === 'function' ? 'locale' : 'lang', hasLocaleData = !!_moment.default.localeData;
if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');
function getMoment(culture, value, format) {
    return culture ? (0, _moment.default)(value, format, true)[localField](culture) : (0, _moment.default)(value, format, true);
}
function endOfDecade(date) {
    return (0, _moment.default)(date).add(10, 'year').add(-1, 'millisecond').toDate();
}
function endOfCentury(date) {
    return (0, _moment.default)(date).add(100, 'year').add(-1, 'millisecond').toDate();
}
function momentLocalizer() {
    var localizer = {
        formats: {
            date: 'L',
            time: 'LT',
            default: 'lll',
            header: 'MMMM YYYY',
            footer: 'LL',
            weekday: 'dd',
            dayOfMonth: 'DD',
            month: 'MMM',
            year: 'YYYY',
            decade: function decade(date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
            },
            century: function century(date, culture, localizer) {
                return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
            }
        },
        firstOfWeek: function firstOfWeek(culture) {
            return _moment.default.localeData(culture).firstDayOfWeek();
        },
        parse: function parse(value, format, culture) {
            if (!value) return null;
            var m = getMoment(culture, value, format);
            if (m.isValid()) return m.toDate();
            return null;
        },
        format: function format(value, _format, culture) {
            return getMoment(culture, value).format(_format);
        }
    };
    _configure.default.setDateLocalizer(localizer);
}
module.exports = exports["default"];

},{"309ee9423caa4a03":"3xZWN","bb8b5001c175b993":"74fHT"}],"74fHT":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var localizers = _interopRequireWildcard(require("1aa2624f66cb01a3"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
var _default = {
    setLocalizers: function setLocalizers(_ref) {
        var date = _ref.date, number = _ref.number;
        date && this.setDateLocalizer(date);
        number && this.setNumberLocalizer(number);
    },
    setDateLocalizer: localizers.setDate,
    setNumberLocalizer: localizers.setNumber
};
exports.default = _default;
module.exports = exports["default"];

},{"1aa2624f66cb01a3":"hIvMI"}],"hIvMI":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.setNumber = setNumber;
exports.setDate = setDate;
exports.date = exports.number = void 0;
var _invariant = _interopRequireDefault(require("73dee4c0aba605e8"));
var _ = require("b122dbcb2296d5ad");
var _propTypes = _interopRequireDefault(require("68b4e22c93ff307a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var localePropType = _propTypes.default.oneOfType([
    _propTypes.default.string,
    _propTypes.default.func
]);
var REQUIRED_NUMBER_FORMATS = [
    'default'
];
var REQUIRED_DATE_FORMATS = [
    'default',
    'date',
    'time',
    'header',
    'footer',
    'weekday',
    'dayOfMonth',
    'month',
    'year',
    'decade',
    'century'
];
var _numberLocalizer = createWrapper('NumberPicker');
var number = {
    propType: function propType() {
        var _numberLocalizer2;
        return (_numberLocalizer2 = _numberLocalizer).propType.apply(_numberLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || _numberLocalizer.formats[key];
    },
    parse: function parse() {
        var _numberLocalizer3;
        return (_numberLocalizer3 = _numberLocalizer).parse.apply(_numberLocalizer3, arguments);
    },
    format: function format() {
        var _numberLocalizer4;
        return (_numberLocalizer4 = _numberLocalizer).format.apply(_numberLocalizer4, arguments);
    },
    decimalChar: function decimalChar() {
        var _numberLocalizer5;
        return (_numberLocalizer5 = _numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
    },
    precision: function precision() {
        var _numberLocalizer6;
        return (_numberLocalizer6 = _numberLocalizer).precision.apply(_numberLocalizer6, arguments);
    }
};
exports.number = number;
function setNumber(_ref) {
    var format = _ref.format, _parse = _ref.parse, formats = _ref.formats, _ref$propType = _ref.propType, propType = _ref$propType === void 0 ? localePropType : _ref$propType, _ref$decimalChar = _ref.decimalChar, decimalChar = _ref$decimalChar === void 0 ? function decimalChar() {
        return '.';
    } : _ref$decimalChar, _ref$precision = _ref.precision, precision = _ref$precision === void 0 ? function precision() {
        return null;
    } : _ref$precision;
    checkFormats(REQUIRED_NUMBER_FORMATS, formats);
    _numberLocalizer = {
        formats: formats,
        precision: precision,
        decimalChar: decimalChar,
        propType: propType,
        format: wrapFormat(format),
        parse: function parse(value, culture, format) {
            var result = _parse.call(this, value, culture, format);
            !(result == null || typeof result === 'number') && invariant(false);
            return result;
        }
    };
}
var _dateLocalizer = createWrapper('DateTimePicker');
var date = {
    propType: function propType() {
        var _dateLocalizer2;
        return (_dateLocalizer2 = _dateLocalizer).propType.apply(_dateLocalizer2, arguments);
    },
    getFormat: function getFormat(key, format) {
        return format || _dateLocalizer.formats[key];
    },
    parse: function parse() {
        var _dateLocalizer3;
        return (_dateLocalizer3 = _dateLocalizer).parse.apply(_dateLocalizer3, arguments);
    },
    format: function format() {
        var _dateLocalizer4;
        return (_dateLocalizer4 = _dateLocalizer).format.apply(_dateLocalizer4, arguments);
    },
    firstOfWeek: function firstOfWeek() {
        var _dateLocalizer5;
        return (_dateLocalizer5 = _dateLocalizer).firstOfWeek.apply(_dateLocalizer5, arguments);
    }
};
exports.date = date;
function setDate(_ref2) {
    var formats = _ref2.formats, format = _ref2.format, _parse2 = _ref2.parse, firstOfWeek = _ref2.firstOfWeek, _ref2$propType = _ref2.propType, propType = _ref2$propType === void 0 ? localePropType : _ref2$propType;
    checkFormats(REQUIRED_DATE_FORMATS, formats);
    _dateLocalizer = {
        formats: formats,
        propType: propType,
        firstOfWeek: firstOfWeek,
        format: wrapFormat(format),
        parse: function parse(value, format, culture) {
            var result = _parse2.call(this, value, format, culture);
            !(result == null || result instanceof Date && !isNaN(result.getTime())) && invariant(false);
            return result;
        }
    };
}
var wrapFormat = function wrapFormat(formatter) {
    return function(value, format, culture) {
        var result = typeof format === 'function' ? format(value, culture, this) : formatter.call(this, value, format, culture);
        !(result == null || typeof result === 'string') && invariant(false);
        return result;
    };
};
function checkFormats(required, formats) {}
function createWrapper() {
    var dummy = {};
    return dummy;
}

},{"73dee4c0aba605e8":"6fstw","b122dbcb2296d5ad":"lDW6z","68b4e22c93ff307a":"3KNJy"}],"6fstw":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"lDW6z":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
exports.__esModule = true;
exports.isShallowEqual = isShallowEqual;
exports.chunk = chunk;
exports.groupBySortedKeys = groupBySortedKeys;
exports.has = exports.makeArray = void 0;
var _warning = _interopRequireDefault(require("990c37da557f9765"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var makeArray = function makeArray(obj) {
    return obj == null ? [] : [].concat(obj);
};
exports.makeArray = makeArray;
var has = function has(o, k) {
    return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
};
exports.has = has;
function isShallowEqual(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return +a === +b;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== 'object' && (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== 'object') return a === b;
    if ((typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b))) return false;
    if (a == null || b == null) return false; // if they were both null we wouldn't be here
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!has(b, keysA[i]) || a[keysA[i]] !== b[keysA[i]]) return false;
    }
    return true;
}
function chunk(array, chunkSize) {
    var index = 0, length = array ? array.length : 0;
    var result = [];
    chunkSize = Math.max(+chunkSize || 1, 1);
    while(index < length)result.push(array.slice(index, index += chunkSize));
    return result;
}
function groupBySortedKeys(groupBy, data, keys) {
    var iter = typeof groupBy === 'function' ? groupBy : function iter(item) {
        return item[groupBy];
    }; // the keys array ensures that groups are rendered in the order they came in
    // which means that if you sort the data array it will render sorted,
    // so long as you also sorted by group
    keys = keys || [];
    return data.reduce(function(grps, item) {
        var group = iter(item);
        if (has(grps, group)) grps[group].push(item);
        else {
            keys.push(group);
            grps[group] = [
                item
            ];
        }
        return grps;
    }, {});
}

},{"@swc/helpers/_/_type_of":"668P4","990c37da557f9765":"jGHBq"}],"jGHBq":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var warning = function warning() {};
module.exports = warning;

},{}],"4KVXE":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _invariant = _interopRequireDefault(require("46962cbec2019867"));
var _propTypes = _interopRequireDefault(require("e5eb827e2833f680"));
var _react = _interopRequireDefault(require("12b7ef48a73d324b"));
var _reactDom = require("1cb03fd09ac0b964");
var _reactLifecyclesCompat = require("3059fa90b22817ea");
var _activeElement = _interopRequireDefault(require("8e79d0881df09d22"));
var _classnames = _interopRequireDefault(require("caddf76e86744d08"));
var _deprecated = _interopRequireDefault(require("a61c66d6b8619b49"));
var _uncontrollable = require("bba55658fd655d28");
var _Widget = _interopRequireDefault(require("9395353deba81ac5"));
var _WidgetPicker = _interopRequireDefault(require("5373f176a741ad89"));
var _Popup = _interopRequireDefault(require("dc892ea063b01200"));
var _Button = _interopRequireDefault(require("9ee89772b8a81291"));
var _Calendar = _interopRequireDefault(require("b51262325533fa1d"));
var _DateTimePickerInput = _interopRequireDefault(require("642957f30fcea1f9"));
var _Select = _interopRequireDefault(require("ed55641580c87979"));
var _TimeList = _interopRequireDefault(require("fc5cc2fea50480f0"));
var _messages = require("58bc5f117b5ceea6");
var Props = _interopRequireWildcard(require("4bca4265757420ae"));
var CustomPropTypes = _interopRequireWildcard(require("5632504ebf4b37ae"));
var _focusManager = _interopRequireDefault(require("2e06c7354f8fc318"));
var _scrollManager = _interopRequireDefault(require("c7fbc79b58fd747f"));
var _interaction = require("d7b3e91a9d273c3f");
var _dates = _interopRequireDefault(require("a538ee05850420e1"));
var _localizers = require("271dd614790d271b");
var _widgetHelpers = require("24f9181754d1ab32");
var _Icon = require("6fc732cb6150daa8");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class3, _temp;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _initializerDefineProperty(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function _initializerWarningHelper(descriptor, context) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and set to use loose mode. To use proposal-class-properties in spec mode with decorators, wait for the next major version of decorators in stage 2.");
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var NEXT_VIEW = {
    date: 'time',
    time: 'date'
};
var isBothOrNeither = function isBothOrNeither(a, b) {
    return a && b || !a && !b;
};
var propTypes = _extends({}, _Calendar.default.ControlledComponent.propTypes, {
    /**
   * @example ['valuePicker', [ ['new Date()', null] ]]
   */ value: _propTypes.default.instanceOf(Date),
    /**
   * @example ['onChangePicker', [ ['new Date()', null] ]]
   */ onChange: _propTypes.default.func,
    /**
   * @type {(false | 'time' | 'date')}
   * @example ['openDateTime']
   */ open: _propTypes.default.oneOf([
        false,
        'time',
        'date'
    ]),
    onToggle: _propTypes.default.func,
    /**
   * Default current date at which the calendar opens. If none is provided, opens at today's date or the `value` date (if any).
   */ currentDate: _propTypes.default.instanceOf(Date),
    /**
   * Change event Handler that is called when the currentDate is changed. The handler is called with the currentDate object.
   */ onCurrentDateChange: _propTypes.default.func,
    onSelect: _propTypes.default.func,
    /**
   * The minimum Date that can be selected. Min only limits selection, it doesn't constrain the date values that
   * can be typed or pasted into the widget. If you need this behavior you can constrain values via
   * the `onChange` handler.
   *
   * @example ['prop', ['min', 'new Date()']]
   */ min: _propTypes.default.instanceOf(Date),
    /**
   * The maximum Date that can be selected. Max only limits selection, it doesn't constrain the date values that
   * can be typed or pasted into the widget. If you need this behavior you can constrain values via
   * the `onChange` handler.
   *
   * @example ['prop', ['max', 'new Date()']]
   */ max: _propTypes.default.instanceOf(Date),
    /**
   * The amount of minutes between each entry in the time list.
   *
   * @example ['prop', { step: 90 }]
   */ step: _propTypes.default.number,
    culture: _propTypes.default.string,
    /**
   * A formatter used to display the date value. For more information about formats
   * visit the [Localization page](/localization)
   *
   * @example ['dateFormat', ['format', "{ raw: 'MMM dd, yyyy' }", null, { defaultValue: 'new Date()', time: 'false' }]]
   */ format: CustomPropTypes.dateFormat,
    /**
   * A formatter used by the time dropdown to render times. For more information about formats visit
   * the [Localization page](/localization).
   *
   * @example ['dateFormat', ['timeFormat', "{ time: 'medium' }", null, { date: 'false', open: '"time"' }]]
   */ timeFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter to be used while the date input has focus. Useful for showing a simpler format for inputing.
   * For more information about formats visit the [Localization page](/localization)
   *
   * @example ['dateFormat', ['editFormat', "{ date: 'short' }", null, { defaultValue: 'new Date()', format: "{ raw: 'MMM dd, yyyy' }", time: 'false' }]]
   */ editFormat: CustomPropTypes.dateFormat,
    /**
   * Enable the calendar component of the picker.
   */ date: _propTypes.default.bool,
    /**
   * Enable the time list component of the picker.
   */ time: _propTypes.default.bool,
    /** @ignore */ calendar: (0, _deprecated.default)(_propTypes.default.bool, 'Use `date` instead'),
    /**
   * A customize the rendering of times but providing a custom component.
   */ timeComponent: CustomPropTypes.elementType,
    /** Specify the element used to render the calendar dropdown icon. */ dateIcon: _propTypes.default.node,
    /** Specify the element used to render the time list dropdown icon. */ timeIcon: _propTypes.default.node,
    dropUp: _propTypes.default.bool,
    popupTransition: CustomPropTypes.elementType,
    placeholder: _propTypes.default.string,
    name: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    /**
   * @example ['disabled', ['new Date()']]
   */ disabled: CustomPropTypes.disabled,
    /**
   * @example ['readOnly', ['new Date()']]
   */ readOnly: CustomPropTypes.disabled,
    /**
   * Determines how the widget parses the typed date string into a Date object. You can provide an array of formats to try,
   * or provide a function that returns a date to handle parsing yourself. When `parse` is unspecified and
   * the `format` prop is a `string` parse will automatically use that format as its default.
   */ parse: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.string),
        _propTypes.default.string,
        _propTypes.default.func
    ]),
    /** @ignore */ tabIndex: _propTypes.default.any,
    /** @ignore */ 'aria-labelledby': _propTypes.default.string,
    /** @ignore */ 'aria-describedby': _propTypes.default.string,
    onKeyDown: _propTypes.default.func,
    onKeyPress: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    /** Adds a css class to the input container element. */ containerClassName: _propTypes.default.string,
    inputProps: _propTypes.default.object,
    isRtl: _propTypes.default.bool,
    messages: _propTypes.default.shape({
        dateButton: _propTypes.default.string,
        timeButton: _propTypes.default.string
    })
});
var DateTimePicker = (0, _reactLifecyclesCompat.polyfill)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(DateTimePicker, _React$Component);
    function DateTimePicker() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _initializerDefineProperty(_this, "handleChange", _descriptor, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleKeyDown", _descriptor2, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleKeyPress", _descriptor3, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleDateSelect", _descriptor4, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleTimeSelect", _descriptor5, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleCalendarClick", _descriptor6, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleTimeClick", _descriptor7, _assertThisInitialized(_assertThisInitialized(_this)));
        _this.attachCalRef = function(ref) {
            return _this.calRef = ref;
        };
        _this.attachTimeRef = function(ref) {
            return _this.timeRef = ref;
        };
        _this.attachInputRef = function(ref) {
            return _this.inputRef = ref;
        };
        _this.parse = function(string) {
            var _this$props = _this.props, parse = _this$props.parse, culture = _this$props.culture, editFormat = _this$props.editFormat;
            var format = getFormat(_this.props, true);
            !(parse || format || editFormat) && invariant(false);
            var date;
            var formats = [
                format,
                editFormat
            ];
            if (typeof parse == 'function') {
                date = parse(string, culture);
                if (date) return date;
            } else // parse is a string format or array of string formats
            formats = formats.concat(parse).filter(Boolean);
            for(var i = 0; i < formats.length; i++){
                date = _localizers.date.parse(string, formats[i], culture);
                if (date) return date;
            }
            return null;
        };
        _this.inputId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_input');
        _this.dateId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_date');
        _this.listId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox');
        _this.activeCalendarId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_calendar_active_cell');
        _this.activeOptionId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox_active_option');
        _this.handleScroll = (0, _scrollManager.default)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.focusManager = (0, _focusManager.default)(_assertThisInitialized(_assertThisInitialized(_this)), {
            didHandle: function didHandle(focused) {
                if (!focused) _this.close();
            }
        });
        _this.state = {
            focused: false,
            messages: (0, _messages.getMessages)(_this.props.messages)
        };
        return _this;
    }
    DateTimePicker.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
        var messages = _ref.messages;
        return {
            messages: (0, _messages.getMessages)(messages)
        };
    };
    var _proto = DateTimePicker.prototype;
    _proto.renderInput = function renderInput(owns) {
        var _this$props2 = this.props, open = _this$props2.open, value = _this$props2.value, editFormat = _this$props2.editFormat, culture = _this$props2.culture, placeholder = _this$props2.placeholder, disabled = _this$props2.disabled, readOnly = _this$props2.readOnly, name = _this$props2.name, tabIndex = _this$props2.tabIndex, autoFocus = _this$props2.autoFocus, inputProps = _this$props2.inputProps, ariaLabelledby = _this$props2['aria-labelledby'], ariaDescribedby = _this$props2['aria-describedby'];
        var focused = this.state.focused;
        var inputReadOnly = inputProps ? inputProps.readOnly : null;
        var activeId = null;
        if (open === 'time') activeId = this.activeOptionId;
        else if (open === 'date') activeId = this.activeCalendarId;
        return _react.default.createElement(_DateTimePickerInput.default, _extends({}, inputProps, {
            id: this.inputId,
            ref: this.attachInputRef,
            role: "combobox",
            name: name,
            value: value,
            tabIndex: tabIndex,
            autoFocus: autoFocus,
            placeholder: placeholder,
            disabled: disabled,
            readOnly: inputReadOnly != null ? inputReadOnly : readOnly,
            format: getFormat(this.props),
            editFormat: editFormat,
            editing: focused,
            culture: culture,
            parse: this.parse,
            onChange: this.handleChange,
            "aria-haspopup": true,
            "aria-activedescendant": activeId,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            "aria-expanded": !!open,
            "aria-owns": owns
        }));
    };
    _proto.renderButtons = function renderButtons() {
        var _this$props3 = this.props, date = _this$props3.date, dateIcon = _this$props3.dateIcon, time = _this$props3.time, timeIcon = _this$props3.timeIcon, disabled = _this$props3.disabled, readOnly = _this$props3.readOnly;
        if (!date && !time) return null;
        var messages = this.state.messages;
        return _react.default.createElement(_Select.default, {
            bordered: true
        }, date && _react.default.createElement(_Button.default, {
            icon: dateIcon,
            label: messages.dateButton(),
            disabled: disabled || readOnly,
            onClick: this.handleCalendarClick
        }), time && _react.default.createElement(_Button.default, {
            icon: timeIcon,
            label: messages.timeButton(),
            disabled: disabled || readOnly,
            onClick: this.handleTimeClick
        }));
    };
    _proto.renderCalendar = function renderCalendar() {
        var _this2 = this;
        var activeCalendarId = this.activeCalendarId, inputId = this.inputId, dateId = this.dateId;
        var _this$props4 = this.props, open = _this$props4.open, value = _this$props4.value, popupTransition = _this$props4.popupTransition, dropUp = _this$props4.dropUp, onCurrentDateChange = _this$props4.onCurrentDateChange, currentDate = _this$props4.currentDate;
        var calendarProps = Props.pick(this.props, _Calendar.default.ControlledComponent); // manually include the last controlled default Props
        calendarProps.defaultView = this.props.defaultView;
        return _react.default.createElement(_Popup.default, {
            dropUp: dropUp,
            open: open === 'date',
            className: "rw-calendar-popup",
            transition: popupTransition
        }, _react.default.createElement(_Calendar.default, _extends({}, calendarProps, {
            id: dateId,
            activeId: activeCalendarId,
            tabIndex: "-1",
            value: value,
            autoFocus: false,
            onChange: this.handleDateSelect // #75: need to aggressively reclaim focus from the calendar otherwise
            ,
            onNavigate: function onNavigate() {
                return _this2.focus();
            },
            currentDate: currentDate,
            onCurrentDateChange: onCurrentDateChange,
            "aria-hidden": !open,
            "aria-live": "polite",
            "aria-labelledby": inputId,
            ref: this.attachCalRef
        })));
    };
    _proto.renderTimeList = function renderTimeList() {
        var _this3 = this;
        var activeOptionId = this.activeOptionId, inputId = this.inputId, listId = this.listId;
        var _this$props5 = this.props, open = _this$props5.open, value = _this$props5.value, min = _this$props5.min, max = _this$props5.max, step = _this$props5.step, currentDate = _this$props5.currentDate, dropUp = _this$props5.dropUp, date = _this$props5.date, culture = _this$props5.culture, timeFormat = _this$props5.timeFormat, timeComponent = _this$props5.timeComponent, timeListProps = _this$props5.timeListProps, popupTransition = _this$props5.popupTransition;
        return _react.default.createElement(_Popup.default, {
            dropUp: dropUp,
            transition: popupTransition,
            open: open === 'time',
            onEntering: function onEntering() {
                return _this3.timeRef.forceUpdate();
            }
        }, _react.default.createElement("div", null, _react.default.createElement(_TimeList.default, {
            id: listId,
            min: min,
            max: max,
            step: step,
            listProps: timeListProps,
            currentDate: currentDate,
            activeId: activeOptionId,
            format: timeFormat,
            culture: culture,
            value: dateOrNull(value),
            onMove: this.handleScroll,
            onSelect: this.handleTimeSelect,
            preserveDate: !!date,
            itemComponent: timeComponent,
            "aria-labelledby": inputId,
            "aria-live": open && 'polite',
            "aria-hidden": !open,
            messages: this.state.messages,
            ref: this.attachTimeRef
        })));
    };
    _proto.render = function render() {
        var _this$props6 = this.props, className = _this$props6.className, date = _this$props6.date, time = _this$props6.time, open = _this$props6.open, disabled = _this$props6.disabled, readOnly = _this$props6.readOnly, dropUp = _this$props6.dropUp, containerClassName = _this$props6.containerClassName;
        var focused = this.state.focused;
        var elementProps = Props.pickElementProps(this, _Calendar.default.ControlledComponent);
        var shouldRenderList = (0, _widgetHelpers.isFirstFocusedRender)(this);
        var shouldRenderTimeList = !!(shouldRenderList && time);
        var shouldRenderCalendar = !!(shouldRenderList && date);
        var owns = '';
        if (shouldRenderCalendar && open === 'date') owns += this.dateId;
        if (shouldRenderTimeList && open === 'time') owns += ' ' + this.listId;
        return _react.default.createElement(_Widget.default, _extends({}, elementProps, {
            open: !!open,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            onBlur: this.focusManager.handleBlur,
            onFocus: this.focusManager.handleFocus,
            className: (0, _classnames.default)(className, 'rw-datetime-picker')
        }), _react.default.createElement(_WidgetPicker.default, {
            className: containerClassName
        }, this.renderInput(owns.trim()), this.renderButtons()), shouldRenderTimeList && this.renderTimeList(), shouldRenderCalendar && this.renderCalendar());
    };
    _proto.focus = function focus() {
        if (this.inputRef && (0, _activeElement.default)() !== (0, _reactDom.findDOMNode)(this.inputRef)) this.inputRef.focus();
    };
    _proto.toggle = function toggle(view) {
        var open = this.props.open;
        if (!open || open !== view) this.open(view);
        else this.close();
    };
    _proto.open = function open(view) {
        var _this$props7 = this.props, open = _this$props7.open, date = _this$props7.date, time = _this$props7.time, onToggle = _this$props7.onToggle;
        if (!view) {
            if (time) view = 'time';
            if (date) view = 'date';
            if (isBothOrNeither(date, time)) view = NEXT_VIEW[open] || 'date';
        }
        if (open !== view) (0, _widgetHelpers.notify)(onToggle, view);
    };
    _proto.close = function close() {
        if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
    };
    _proto.inRangeValue = function inRangeValue(value) {
        if (value == null) return value;
        return _dates.default.max(_dates.default.min(value, this.props.max), this.props.min);
    };
    return DateTimePicker;
}(_react.default.Component), _class3.displayName = 'DateTimePicker', _class3.propTypes = propTypes, _class3.defaultProps = _extends({}, _Calendar.default.ControlledComponent.defaultProps, {
    value: null,
    min: new Date(1900, 0, 1),
    max: new Date(2099, 11, 31),
    date: true,
    time: true,
    open: false,
    dateIcon: _Icon.calendar,
    timeIcon: _Icon.clock
}), _temp), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "handleChange", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this4 = this;
        return function(date, str, constrain) {
            var _this4$props = _this4.props, onChange = _this4$props.onChange, value = _this4$props.value;
            if (constrain) date = _this4.inRangeValue(date);
            if (onChange) {
                if (date == null || value == null) {
                    if (date != value //eslint-disable-line eqeqeq
                    ) onChange(date, str);
                } else if (!_dates.default.eq(date, value)) onChange(date, str);
            }
        };
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyDown", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this5 = this;
        return function(e) {
            var _this5$props = _this5.props, open = _this5$props.open, onKeyDown = _this5$props.onKeyDown;
            (0, _widgetHelpers.notify)(onKeyDown, [
                e
            ]);
            if (e.defaultPrevented) return;
            if (e.key === 'Escape' && open) _this5.close();
            else if (e.altKey) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    _this5.open();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    _this5.close();
                }
            } else if (open) {
                if (open === 'date') _this5.calRef.handleKeyDown(e);
                if (open === 'time') _this5.timeRef.handleKeyDown(e);
            }
        };
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyPress", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this6 = this;
        return function(e) {
            (0, _widgetHelpers.notify)(_this6.props.onKeyPress, [
                e
            ]);
            if (e.defaultPrevented) return;
        };
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "handleDateSelect", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this7 = this;
        return function(date) {
            var format = getFormat(_this7.props), dateTime = _dates.default.merge(date, _this7.props.value, _this7.props.currentDate), dateStr = formatDate(date, format, _this7.props.culture);
            _this7.close();
            (0, _widgetHelpers.notify)(_this7.props.onSelect, [
                dateTime,
                dateStr
            ]);
            _this7.handleChange(dateTime, dateStr, true);
            _this7.focus();
        };
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "handleTimeSelect", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this8 = this;
        return function(datum) {
            var format = getFormat(_this8.props), dateTime = _dates.default.merge(_this8.props.value, datum.date, _this8.props.currentDate), dateStr = formatDate(datum.date, format, _this8.props.culture);
            _this8.close();
            (0, _widgetHelpers.notify)(_this8.props.onSelect, [
                dateTime,
                dateStr
            ]);
            _this8.handleChange(dateTime, dateStr, true);
            _this8.focus();
        };
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "handleCalendarClick", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this9 = this;
        return function() {
            _this9.focus();
            _this9.toggle('date');
        };
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "handleTimeClick", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this10 = this;
        return function() {
            _this10.focus();
            _this10.toggle('time');
        };
    }
}), _class2)) || _class;
var _default = (0, _uncontrollable.uncontrollable)(DateTimePicker, {
    open: 'onToggle',
    value: 'onChange',
    currentDate: 'onCurrentDateChange'
}, [
    'focus'
]);
exports.default = _default;
function getFormat(props) {
    var isDate = props.date != null ? props.date : true;
    var isTime = props.time != null ? props.time : true;
    return props.format ? props.format : isDate && isTime || !isDate && !isTime ? _localizers.date.getFormat('default') : _localizers.date.getFormat(isDate ? 'date' : 'time');
}
function formatDate(date, format, culture) {
    var val = '';
    if (date instanceof Date && !isNaN(date.getTime())) val = _localizers.date.format(date, format, culture);
    return val;
}
function dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
module.exports = exports["default"];

},{"46962cbec2019867":"6fstw","e5eb827e2833f680":"3KNJy","12b7ef48a73d324b":"gVheC","1cb03fd09ac0b964":"d8jlt","3059fa90b22817ea":"3F3XD","8e79d0881df09d22":"e18vI","caddf76e86744d08":"6P5cq","a61c66d6b8619b49":"8xwB1","bba55658fd655d28":"ePx5f","9395353deba81ac5":"kwrMv","5373f176a741ad89":"2Vzpm","dc892ea063b01200":"kvIc9","9ee89772b8a81291":"6M58T","b51262325533fa1d":"6gUgQ","642957f30fcea1f9":"5dCQF","ed55641580c87979":"iRwQF","fc5cc2fea50480f0":"erMc2","58bc5f117b5ceea6":"fEqYz","4bca4265757420ae":"2s4vq","5632504ebf4b37ae":"8HlUx","2e06c7354f8fc318":"htUOG","c7fbc79b58fd747f":"43Cr9","d7b3e91a9d273c3f":"qGuYY","a538ee05850420e1":"4EPGV","271dd614790d271b":"hIvMI","24f9181754d1ab32":"fu3eM","6fc732cb6150daa8":"5bZrH"}],"e18vI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c5f5b91c38426c0");
exports.__esModule = true;
exports.default = activeElement;
var _ownerDocument = _interopRequireDefault(require("ec80b4971526dde7"));
function activeElement(doc) {
    if (doc === void 0) doc = (0, _ownerDocument.default)();
    try {
        return doc.activeElement;
    } catch (e) {
    /* ie throws if no active element */ }
}
module.exports = exports["default"];

},{"c5f5b91c38426c0":"6zI5d","ec80b4971526dde7":"7oM4A"}],"7oM4A":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = ownerDocument;
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}
module.exports = exports["default"];

},{}],"8xwB1":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecated;
var _warning = require("d72ed8e69cd27866");
var _warning2 = _interopRequireDefault(_warning);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var warned = {};
function deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] != null) {
            var messageKey = componentName + '.' + propName;
            (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
            warned[messageKey] = true;
        }
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
/* eslint-disable no-underscore-dangle */ function _resetWarned() {
    warned = {};
}
deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */ module.exports = exports['default'];

},{"d72ed8e69cd27866":"5z6Ef"}],"ePx5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolled", function() {
    return 0, _hookDefault.default;
});
parcelHelpers.export(exports, "useUncontrolledProp", function() {
    return 0, _hook.useUncontrolledProp;
});
parcelHelpers.export(exports, "uncontrollable", function() {
    return 0, _uncontrollableDefault.default;
});
var _hook = require("./hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _uncontrollable = require("./uncontrollable");
var _uncontrollableDefault = parcelHelpers.interopDefault(_uncontrollable);

},{"./hook":"56NMy","./uncontrollable":"8lFXa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"56NMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolledProp", function() {
    return useUncontrolledProp;
});
parcelHelpers.export(exports, "default", function() {
    return useUncontrolled;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("./utils");
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, _typeOf._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    var wasPropRef = (0, _react.useRef)(propValue !== undefined);
    var _useState = (0, _react.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[_utils.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            _utils.defaultKey(fieldName),
            fieldName
        ].map(_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, _extendsDefault.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

},{"@swc/helpers/_/_type_of":"668P4","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","./utils":"fdFC0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fdFC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uncontrolledPropTypes", function() {
    return uncontrolledPropTypes;
});
parcelHelpers.export(exports, "isProp", function() {
    return isProp;
});
parcelHelpers.export(exports, "defaultKey", function() {
    return defaultKey;
});
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ parcelHelpers.export(exports, "canAcceptRef", function() {
    return canAcceptRef;
});
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var noop = function noop() {};
function readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function uncontrolledPropTypes(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[defaultKey(prop)] = noop;
        var handler;
    });
    return propTypes;
}
function isProp(props, prop) {
    return props[prop] !== undefined;
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function canAcceptRef(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

},{"invariant":"6fstw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8lFXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return uncontrollable;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _utils = require("./utils");
var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function uncontrollable(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = _utils.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map(_utils.defaultKey);
    !(canAcceptRef || !methods.length) && (0, _invariantDefault.default)(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, _extendsDefault.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[_utils.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, _extendsDefault.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!_utils.isProp(props, key) && _utils.isProp(prevProps, key)) nextState.values[key] = props[_utils.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, _reactDefault.default).Component);
    (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, _extendsDefault.default)({
        innerRef: function innerRef() {}
    }, _utils.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, _reactDefault.default).forwardRef) {
        WrappedComponent = (0, _reactDefault.default).forwardRef(function(props, ref) {
            return (0, _reactDefault.default).createElement(UncontrolledComponent, (0, _extendsDefault.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return uncontrollable(newComponent, (0, _extendsDefault.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","react-lifecycles-compat":"3F3XD","invariant":"6fstw","./utils":"fdFC0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kwrMv":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("8c54be1481d12d77"));
var _propTypes = _interopRequireDefault(require("f0dab3dc38b8afed"));
var _classnames = _interopRequireDefault(require("a1991c0355471394"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var Widget = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Widget, _React$Component);
    function Widget() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Widget.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, tabIndex = _this$props.tabIndex, focused = _this$props.focused, open = _this$props.open, dropUp = _this$props.dropUp, disabled = _this$props.disabled, readOnly = _this$props.readOnly, autofilling = _this$props.autofilling, _this$props$isRtl = _this$props.isRtl, isRtl = _this$props$isRtl === void 0 ? this.context.isRtl : _this$props$isRtl, props = _objectWithoutProperties(_this$props, [
            "className",
            "tabIndex",
            "focused",
            "open",
            "dropUp",
            "disabled",
            "readOnly",
            "autofilling",
            "isRtl"
        ]);
        tabIndex = tabIndex != null ? tabIndex : '-1';
        return _react.default.createElement("div", _extends({}, props, {
            tabIndex: tabIndex,
            className: (0, _classnames.default)(className, 'rw-widget', isRtl && 'rw-rtl', disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly', focused && 'rw-state-focus', autofilling && 'rw-webkit-autofill', open && "rw-open" + (dropUp ? '-up' : ''))
        }));
    };
    return Widget;
}(_react.default.Component);
Widget.contextTypes = {
    isRtl: _propTypes.default.bool
};
Widget.propTypes = {
    tabIndex: _propTypes.default.node,
    focused: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    readOnly: _propTypes.default.bool,
    autofilling: _propTypes.default.bool,
    open: _propTypes.default.bool,
    dropUp: _propTypes.default.bool,
    isRtl: _propTypes.default.bool
};
var _default = Widget;
exports.default = _default;
module.exports = exports["default"];

},{"8c54be1481d12d77":"gVheC","f0dab3dc38b8afed":"3KNJy","a1991c0355471394":"6P5cq"}],"2Vzpm":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("c1948e58baea6474"));
var _propTypes = _interopRequireDefault(require("58f7913f92023919"));
var _classnames = _interopRequireDefault(require("bcd450898654ec7a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var WidgetPicker = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(WidgetPicker, _React$Component);
    function WidgetPicker() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = WidgetPicker.prototype;
    _proto.render = function render() {
        var _this$props = this.props, open = _this$props.open, dropUp = _this$props.dropUp, className = _this$props.className, disabled = _this$props.disabled, readOnly = _this$props.readOnly, focused = _this$props.focused, props = _objectWithoutProperties(_this$props, [
            "open",
            "dropUp",
            "className",
            "disabled",
            "readOnly",
            "focused"
        ]);
        var openClass = "rw-open" + (dropUp ? '-up' : '');
        return _react.default.createElement("div", _extends({}, props, {
            className: (0, _classnames.default)(className, 'rw-widget-picker', 'rw-widget-container', open && openClass, disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly', focused && 'rw-state-focus')
        }));
    };
    return WidgetPicker;
}(_react.default.Component);
WidgetPicker.propTypes = {
    tabIndex: _propTypes.default.node,
    focused: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    readOnly: _propTypes.default.bool,
    open: _propTypes.default.bool,
    dropUp: _propTypes.default.bool,
    picker: _propTypes.default.bool
};
var _default = WidgetPicker;
exports.default = _default;
module.exports = exports["default"];

},{"c1948e58baea6474":"gVheC","58f7913f92023919":"3KNJy","bcd450898654ec7a":"6P5cq"}],"kvIc9":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("bf6e0e7f01001fda"));
var _propTypes = _interopRequireDefault(require("42fc1d93d772abdb"));
var _react = _interopRequireWildcard(require("6a3c1803c9f79495"));
var _SlideDownTransition = _interopRequireDefault(require("8bd8fb4d5e5550c"));
var _PropTypes = require("f06c6d5bd1e61958");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var StaticContainer = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(StaticContainer, _React$Component);
    function StaticContainer() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = StaticContainer.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
        var shouldUpdate = _ref.shouldUpdate;
        return !!shouldUpdate;
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, children = _this$props.children, props = _objectWithoutProperties(_this$props, [
            "className",
            "children"
        ]);
        delete props.shouldUpdate;
        return (0, _react.cloneElement)(children, _extends({}, props, {
            className: (0, _classnames.default)(className, children.props.className, 'rw-popup')
        }));
    };
    return StaticContainer;
}(_react.default.Component);
StaticContainer.propTypes = {
    shouldUpdate: function shouldUpdate() {}
};
var Popup = /*#__PURE__*/ function(_React$Component2) {
    _inheritsLoose(Popup, _React$Component2);
    function Popup() {
        return _React$Component2.apply(this, arguments) || this;
    }
    var _proto2 = Popup.prototype;
    _proto2.render = function render() {
        var _this$props2 = this.props, className = _this$props2.className, dropUp = _this$props2.dropUp, open = _this$props2.open, Transition = _this$props2.transition, props = _objectWithoutProperties(_this$props2, [
            "className",
            "dropUp",
            "open",
            "transition"
        ]);
        return _react.default.createElement(Transition, _extends({}, props, {
            in: open,
            dropUp: dropUp,
            className: (0, _classnames.default)(className, 'rw-popup-container')
        }), _react.default.createElement(StaticContainer, {
            shouldUpdate: open
        }, _react.default.Children.only(this.props.children)));
    };
    return Popup;
}(_react.default.Component);
Popup.defaultProps = {
    open: false,
    transition: _SlideDownTransition.default
};
Popup.propTypes = {
    open: _propTypes.default.bool,
    dropUp: _propTypes.default.bool,
    onEntering: _propTypes.default.func,
    onEntered: _propTypes.default.func,
    transition: _PropTypes.elementType
};
var _default = Popup;
exports.default = _default;
module.exports = exports["default"];

},{"bf6e0e7f01001fda":"6P5cq","42fc1d93d772abdb":"3KNJy","6a3c1803c9f79495":"gVheC","8bd8fb4d5e5550c":"3gmoR","f06c6d5bd1e61958":"8HlUx"}],"3gmoR":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("ecb6e1122d7c6bbd"));
var _events = _interopRequireDefault(require("77e02189754c2585"));
var _style = _interopRequireDefault(require("bc2a955f14e29296"));
var _height = _interopRequireDefault(require("69bf07013faa0c13"));
var _properties = require("57b791bcb8603f30");
var _propTypes = _interopRequireDefault(require("a9f356dabe0abeb2"));
var _react = _interopRequireDefault(require("68adaeb58a16f3b1"));
var _Transition = _interopRequireWildcard(require("44ff467c3122bc9a"));
var _transitionClasses;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var transitionClasses = (_transitionClasses = {}, _transitionClasses[_Transition.ENTERING] = 'rw-popup-transition-entering', _transitionClasses[_Transition.EXITING] = 'rw-popup-transition-exiting', _transitionClasses[_Transition.EXITED] = 'rw-popup-transition-exited', _transitionClasses);
var propTypes = {
    in: _propTypes.default.bool.isRequired,
    dropUp: _propTypes.default.bool,
    onEntering: _propTypes.default.func,
    onEntered: _propTypes.default.func
};
function parseDuration(node) {
    var str = (0, _style.default)(node, _properties.transitionDuration);
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
var SlideDownTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(SlideDownTransition, _React$Component);
    function SlideDownTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.setContainerHeight = function(elem) {
            elem.style.height = _this.getHeight() + 'px';
        };
        _this.clearContainerHeight = function(elem) {
            elem.style.height = '';
        };
        _this.handleEntered = function(elem) {
            _this.clearContainerHeight(elem);
            if (_this.props.onEntered) _this.props.onEntered();
        };
        _this.handleEntering = function() {
            if (_this.props.onEntering) _this.props.onEntering();
        };
        _this.handleTransitionEnd = function(node, done) {
            var duration = parseDuration(node.lastChild) || 0;
            var handler = function handler() {
                _events.default.off(node, _properties.transitionEnd, handler, false);
                done();
            };
            setTimeout(handler, duration * 1.5);
            _events.default.on(node, _properties.transitionEnd, handler, false);
        };
        _this.attachRef = function(ref) {
            return _this.element = ref;
        };
        return _this;
    }
    var _proto = SlideDownTransition.prototype;
    _proto.getHeight = function getHeight() {
        var container = this.element;
        var content = container.firstChild;
        var margin = parseInt((0, _style.default)(content, 'margin-top'), 10) + parseInt((0, _style.default)(content, 'margin-bottom'), 10);
        var old = container.style.display;
        var height;
        container.style.display = 'block';
        height = ((0, _height.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
        container.style.display = old;
        return height;
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, children = _this$props.children, className = _this$props.className, dropUp = _this$props.dropUp;
        return _react.default.createElement(_Transition.default, {
            appear: true,
            in: this.props.in,
            timeout: 5000,
            onEnter: this.setContainerHeight,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered,
            onExit: this.setContainerHeight,
            onExited: this.clearContainerHeight,
            addEndListener: this.handleTransitionEnd
        }, function(status, innerProps) {
            return _react.default.createElement("div", _extends({}, innerProps, {
                ref: _this2.attachRef,
                className: (0, _classnames.default)(className, dropUp && 'rw-dropup', transitionClasses[status])
            }), _react.default.createElement("div", {
                className: "rw-popup-transition"
            }, children));
        });
    };
    return SlideDownTransition;
}(_react.default.Component);
SlideDownTransition.propTypes = propTypes;
var _default = SlideDownTransition;
exports.default = _default;
module.exports = exports["default"];

},{"ecb6e1122d7c6bbd":"6P5cq","77e02189754c2585":"ipwsW","bc2a955f14e29296":"jZvdW","69bf07013faa0c13":"hhPzJ","57b791bcb8603f30":"7R9cR","a9f356dabe0abeb2":"3KNJy","68adaeb58a16f3b1":"gVheC","44ff467c3122bc9a":"1qmG6"}],"ipwsW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("42ffc642f5b9c86c");
exports.__esModule = true;
exports.default = void 0;
var _on = _interopRequireDefault(require("27e2a7ceb518e355"));
exports.on = _on.default;
var _off = _interopRequireDefault(require("adebb32b1efd571d"));
exports.off = _off.default;
var _filter = _interopRequireDefault(require("2892216815a0993"));
exports.filter = _filter.default;
var _listen = _interopRequireDefault(require("8a3db8af1ea7911e"));
exports.listen = _listen.default;
var _default = {
    on: _on.default,
    off: _off.default,
    filter: _filter.default,
    listen: _listen.default
};
exports.default = _default;

},{"42ffc642f5b9c86c":"6zI5d","27e2a7ceb518e355":"bvlyu","adebb32b1efd571d":"ax8B1","2892216815a0993":"cRYP7","8a3db8af1ea7911e":"fcjMF"}],"bvlyu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2a74297d6119b00a");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("6073da5a99ec58ab"));
var on = function on() {};
if (_inDOM.default) on = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.addEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.attachEvent('on' + eventName, function(e) {
            e = e || window.event;
            e.target = e.target || e.srcElement;
            e.currentTarget = node;
            handler.call(node, e);
        });
    };
}();
var _default = on;
exports.default = _default;
module.exports = exports["default"];

},{"2a74297d6119b00a":"6zI5d","6073da5a99ec58ab":"3hMod"}],"3hMod":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.default = _default;
module.exports = exports["default"];

},{}],"ax8B1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4327157f011e73e3");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("21dd3e8595908024"));
var off = function off() {};
if (_inDOM.default) off = function() {
    if (document.addEventListener) return function(node, eventName, handler, capture) {
        return node.removeEventListener(eventName, handler, capture || false);
    };
    else if (document.attachEvent) return function(node, eventName, handler) {
        return node.detachEvent('on' + eventName, handler);
    };
}();
var _default = off;
exports.default = _default;
module.exports = exports["default"];

},{"4327157f011e73e3":"6zI5d","21dd3e8595908024":"3hMod"}],"cRYP7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("67ae26f847044716");
exports.__esModule = true;
exports.default = filterEvents;
var _contains = _interopRequireDefault(require("6929979decdce66"));
var _querySelectorAll = _interopRequireDefault(require("44eac3bfa05bf68f"));
function filterEvents(selector, handler) {
    return function filterHandler(e) {
        var top = e.currentTarget, target = e.target, matches = (0, _querySelectorAll.default)(top, selector);
        if (matches.some(function(match) {
            return (0, _contains.default)(match, target);
        })) handler.call(this, e);
    };
}
module.exports = exports["default"];

},{"67ae26f847044716":"6zI5d","6929979decdce66":"j0fCr","44eac3bfa05bf68f":"5N9WT"}],"j0fCr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a657cbcc65d1f080");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("a18bd703b23bca6b"));
var _default = function() {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    return _inDOM.default ? function(context, node) {
        if (context.contains) return context.contains(node);
        else if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
        else return fallback(context, node);
    } : fallback;
}();
exports.default = _default;
function fallback(context, node) {
    if (node) do {
        if (node === context) return true;
    }while (node = node.parentNode);
    return false;
}
module.exports = exports["default"];

},{"a657cbcc65d1f080":"6zI5d","a18bd703b23bca6b":"3hMod"}],"5N9WT":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function qsa(element, selector) {
    var maybeID = selector[0] === '#', maybeClass = selector[0] === '.', nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, isSimple = simpleSelectorRE.test(nameOnly), found;
    if (isSimple) {
        if (maybeID) {
            element = element.getElementById ? element : document;
            return (found = element.getElementById(nameOnly)) ? [
                found
            ] : [];
        }
        if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
        return toArray(element.getElementsByTagName(selector));
    }
    return toArray(element.querySelectorAll(selector));
}
module.exports = exports["default"];

},{}],"fcjMF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("99da842de1dfabdb");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("1eeb2f38f8791ab7"));
var _on = _interopRequireDefault(require("5d86982a424430d"));
var _off = _interopRequireDefault(require("e3974197a035d5"));
var listen = function listen() {};
if (_inDOM.default) listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function() {
        (0, _off.default)(node, eventName, handler, capture);
    };
};
var _default = listen;
exports.default = _default;
module.exports = exports["default"];

},{"99da842de1dfabdb":"6zI5d","1eeb2f38f8791ab7":"3hMod","5d86982a424430d":"bvlyu","e3974197a035d5":"ax8B1"}],"jZvdW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9ee78da2d5307371");
exports.__esModule = true;
exports.default = style;
var _camelizeStyle = _interopRequireDefault(require("7bbf4e3325928856"));
var _hyphenateStyle = _interopRequireDefault(require("e3ec2c4f669b7b5c"));
var _getComputedStyle2 = _interopRequireDefault(require("2a20d862abb8a976"));
var _removeStyle = _interopRequireDefault(require("bde90e5f908c35ec"));
var _properties = require("ffda26e6580c80b6");
var _isTransform = _interopRequireDefault(require("d3f424f1ec040f69"));
function style(node, property, value) {
    var css = '';
    var transforms = '';
    var props = property;
    if (typeof property === 'string') {
        if (value === undefined) return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
        else (props = {})[property] = value;
    }
    Object.keys(props).forEach(function(key) {
        var _$value = props[key];
        if (!_$value && _$value !== 0) (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
        else if ((0, _isTransform.default)(key)) transforms += key + "(" + _$value + ") ";
        else css += (0, _hyphenateStyle.default)(key) + ": " + _$value + ";";
    });
    if (transforms) css += _properties.transform + ": " + transforms + ";";
    node.style.cssText += ';' + css;
}
module.exports = exports["default"];

},{"9ee78da2d5307371":"6zI5d","7bbf4e3325928856":"eYMK2","e3ec2c4f669b7b5c":"c7RnP","2a20d862abb8a976":"5Zuxj","bde90e5f908c35ec":"9N1Qi","ffda26e6580c80b6":"7R9cR","d3f424f1ec040f69":"eDSZ4"}],"eYMK2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a2d960e160404fe8");
exports.__esModule = true;
exports.default = camelizeStyleName;
var _camelize = _interopRequireDefault(require("f9d38ee751ee6fee"));
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */ var msPattern = /^-ms-/;
function camelizeStyleName(string) {
    return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports["default"];

},{"a2d960e160404fe8":"6zI5d","f9d38ee751ee6fee":"7MbaE"}],"7MbaE":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;
function camelize(string) {
    return string.replace(rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}
module.exports = exports["default"];

},{}],"c7RnP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1126341910ca3605");
exports.__esModule = true;
exports.default = hyphenateStyleName;
var _hyphenate = _interopRequireDefault(require("b851b5e291df3cc8"));
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var msPattern = /^ms-/;
function hyphenateStyleName(string) {
    return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports["default"];

},{"1126341910ca3605":"6zI5d","b851b5e291df3cc8":"7QIcc"}],"7QIcc":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;
function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports["default"];

},{}],"5Zuxj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4b4b6185062c18ed");
exports.__esModule = true;
exports.default = _getComputedStyle;
var _camelizeStyle = _interopRequireDefault(require("9d700e3605616db0"));
var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
function _getComputedStyle(node) {
    if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
    var doc = node.ownerDocument;
    return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
        //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
        getPropertyValue: function getPropertyValue(prop) {
            var style = node.style;
            prop = (0, _camelizeStyle.default)(prop);
            if (prop == 'float') prop = 'styleFloat';
            var current = node.currentStyle[prop] || null;
            if (current == null && style && style[prop]) current = style[prop];
            if (rnumnonpx.test(current) && !rposition.test(prop)) {
                // Remember the original values
                var left = style.left;
                var runStyle = node.runtimeStyle;
                var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
                if (rsLeft) runStyle.left = node.currentStyle.left;
                style.left = prop === 'fontSize' ? '1em' : current;
                current = style.pixelLeft + 'px'; // Revert the changed values
                style.left = left;
                if (rsLeft) runStyle.left = rsLeft;
            }
            return current;
        }
    };
}
module.exports = exports["default"];

},{"4b4b6185062c18ed":"6zI5d","9d700e3605616db0":"eYMK2"}],"9N1Qi":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = removeStyle;
function removeStyle(node, key) {
    return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports["default"];

},{}],"7R9cR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("62c3741cdf61b4bf");
exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
var _inDOM = _interopRequireDefault(require("103a8b04b12c1f63"));
var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;
if (_inDOM.default) {
    var _getTransitionPropert = getTransitionProperties();
    prefix = _getTransitionPropert.prefix;
    exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
    exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
    exports.transform = transform = prefix + "-" + transform;
    exports.transitionProperty = transitionProperty = prefix + "-transition-property";
    exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
    exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
    exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
    exports.animationName = animationName = prefix + "-animation-name";
    exports.animationDuration = animationDuration = prefix + "-animation-duration";
    exports.animationTiming = animationTiming = prefix + "-animation-delay";
    exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}
var _default = {
    transform: transform,
    end: transitionEnd,
    property: transitionProperty,
    timing: transitionTiming,
    delay: transitionDelay,
    duration: transitionDuration
};
exports.default = _default;
function getTransitionProperties() {
    var style = document.createElement('div').style;
    var vendorMap = {
        O: function O(e) {
            return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
            return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
            return "webkit" + e;
        },
        ms: function ms(e) {
            return "MS" + e;
        }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = '';
    for(var i = 0; i < vendors.length; i++){
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
            prefix = "-" + vendor.toLowerCase();
            transitionEnd = vendorMap[vendor]('TransitionEnd');
            animationEnd = vendorMap[vendor]('AnimationEnd');
            break;
        }
    }
    if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
    if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
    style = null;
    return {
        animationEnd: animationEnd,
        transitionEnd: transitionEnd,
        prefix: prefix
    };
}

},{"62c3741cdf61b4bf":"6zI5d","103a8b04b12c1f63":"3hMod"}],"eDSZ4":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(property) {
    return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

},{}],"hhPzJ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("73cdcaf45d9dcc48");
exports.__esModule = true;
exports.default = height;
var _offset = _interopRequireDefault(require("d827449f7f4c25df"));
var _isWindow = _interopRequireDefault(require("fc1389a0f30d100d"));
function height(node, client) {
    var win = (0, _isWindow.default)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
}
module.exports = exports["default"];

},{"73cdcaf45d9dcc48":"6zI5d","d827449f7f4c25df":"j5gx5","fc1389a0f30d100d":"90siz"}],"j5gx5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a3dd919a1f964f53");
exports.__esModule = true;
exports.default = offset;
var _contains = _interopRequireDefault(require("b13ebc2b8ce5866d"));
var _isWindow = _interopRequireDefault(require("800b68e302e1300b"));
var _ownerDocument = _interopRequireDefault(require("d691e58fbd7b77c1"));
function offset(node) {
    var doc = (0, _ownerDocument.default)(node), win = (0, _isWindow.default)(doc), docElem = doc && doc.documentElement, box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    if (!doc) return; // Make sure it's not a disconnected DOM node
    if (!(0, _contains.default)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
    box = {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: (box.width == null ? node.offsetWidth : box.width) || 0,
        height: (box.height == null ? node.offsetHeight : box.height) || 0
    };
    return box;
}
module.exports = exports["default"];

},{"a3dd919a1f964f53":"6zI5d","b13ebc2b8ce5866d":"j0fCr","800b68e302e1300b":"90siz","d691e58fbd7b77c1":"7oM4A"}],"90siz":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = getWindow;
function getWindow(node) {
    return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

},{}],"1qmG6":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
var PropTypes = _interopRequireWildcard(require("98bed42691c5513d"));
var _react = _interopRequireDefault(require("470ae1c15d8a6dc8"));
var _reactDom = _interopRequireDefault(require("6291c0c39d4e84c6"));
var _reactLifecyclesCompat = require("79cc519f3263e3d4");
var _PropTypes = require("1bb047c0e4ace13b");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ exports.EXITING = EXITING;
var Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = _reactDom.default.findDOMNode(this);
            if (nextStatus === ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = _objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = _react.default.Children.only(children);
        return _react.default.cloneElement(child, childProps);
    };
    return Transition;
}(_react.default.Component);
Transition.contextTypes = {
    transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
Transition.propTypes = {};
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
exports.default = _default;

},{"98bed42691c5513d":"3KNJy","470ae1c15d8a6dc8":"gVheC","6291c0c39d4e84c6":"d8jlt","79cc519f3263e3d4":"3F3XD","1bb047c0e4ace13b":"9Hvwh"}],"9Hvwh":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;
var _propTypes = _interopRequireDefault(require("3ea30e1bd8492f86"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var timeoutsShape = null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = null;
exports.classNamesShape = classNamesShape;

},{"3ea30e1bd8492f86":"3KNJy"}],"8HlUx":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.message = exports.accessor = exports.disabled = exports.dateFormat = exports.numberFormat = void 0;
var _propTypes = _interopRequireDefault(require("15a9a6a007c19017"));
var _elementType = _interopRequireDefault(require("fa02fbfbb4f03ae3"));
exports.elementType = _elementType.default;
var _createChainableTypeChecker = _interopRequireDefault(require("ded97e9f037ccd00"));
var _localizers = require("2db4e5c85697ee35");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var numberFormat = (0, _createChainableTypeChecker.default)(function() {
    return _localizers.number.propType.apply(_localizers.number, arguments);
});
exports.numberFormat = numberFormat;
var dateFormat = (0, _createChainableTypeChecker.default)(function() {
    return _localizers.date.propType.apply(_localizers.date, arguments);
});
exports.dateFormat = dateFormat;
var disabled = (0, _createChainableTypeChecker.default)(function() {
    return _propTypes.default.bool.apply(_propTypes.default, arguments);
});
exports.disabled = disabled;
disabled.acceptsArray = _propTypes.default.oneOfType([
    disabled,
    _propTypes.default.array
]);
var accessor = _propTypes.default.oneOfType([
    _propTypes.default.string,
    _propTypes.default.func
]);
exports.accessor = accessor;
var message = _propTypes.default.oneOfType([
    _propTypes.default.node,
    _propTypes.default.string,
    _propTypes.default.func
]);
exports.message = message;

},{"15a9a6a007c19017":"3KNJy","fa02fbfbb4f03ae3":"fDROF","ded97e9f037ccd00":"4k5BH","2db4e5c85697ee35":"hIvMI"}],"fDROF":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("7e87d84155e83a8b");
var _react2 = _interopRequireDefault(_react);
var _reactIs = require("ae273bc97480019b");
var _createChainableTypeChecker = require("98e724f0bd94dc3");
var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function elementType(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (_react2.default.isValidElement(propValue)) return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
    if (!(0, _reactIs.isValidElementType)(propValue)) return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
    return null;
}
exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

},{"7e87d84155e83a8b":"gVheC","ae273bc97480019b":"5PEu1","98e724f0bd94dc3":"4k5BH"}],"5PEu1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("b328edf116ff6d1e");

},{"b328edf116ff6d1e":"43sPX"}],"43sPX":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{"@swc/helpers/_/_type_of":"668P4"}],"4k5BH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = exports['default'];

},{}],"6M58T":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("458381c4acd144e5"));
var _propTypes = _interopRequireDefault(require("1f03928bae343109"));
var _classnames = _interopRequireDefault(require("c9a7f22705e7efd3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var Loading = function Loading() {
    return _react.default.createElement("span", {
        "aria-hidden": "true",
        className: "rw-i rw-loading"
    });
};
var Button = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Button, _React$Component);
    function Button() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, disabled = _this$props.disabled, label = _this$props.label, icon = _this$props.icon, busy = _this$props.busy, active = _this$props.active, children = _this$props.children, _this$props$variant = _this$props.variant, variant = _this$props$variant === void 0 ? 'primary' : _this$props$variant, _this$props$spinner = _this$props.spinner, spinner = _this$props$spinner === void 0 ? _react.default.createElement(Loading, null) : _this$props$spinner, _this$props$component = _this$props.component, Tag = _this$props$component === void 0 ? 'button' : _this$props$component, props = _objectWithoutProperties(_this$props, [
            "className",
            "disabled",
            "label",
            "icon",
            "busy",
            "active",
            "children",
            "variant",
            "spinner",
            "component"
        ]);
        var type = props.type;
        if (Tag === 'button') type = type || 'button';
        return _react.default.createElement(Tag, _extends({}, props, {
            tabIndex: "-1",
            title: label,
            type: type,
            disabled: disabled,
            "aria-disabled": disabled,
            "aria-label": label,
            className: (0, _classnames.default)(className, 'rw-btn', active && !disabled && 'rw-state-active', variant && 'rw-btn-' + variant)
        }), busy ? spinner : icon, children);
    };
    return Button;
}(_react.default.Component);
Button.propTypes = {
    disabled: _propTypes.default.bool,
    label: _propTypes.default.string,
    icon: _propTypes.default.node,
    busy: _propTypes.default.bool,
    active: _propTypes.default.bool,
    variant: _propTypes.default.oneOf([
        'primary',
        'select'
    ]),
    component: _propTypes.default.any,
    spinner: _propTypes.default.node
};
var _default = Button;
exports.default = _default;
module.exports = exports["default"];

},{"458381c4acd144e5":"gVheC","1f03928bae343109":"3KNJy","c9a7f22705e7efd3":"6P5cq"}],"6gUgQ":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("a3cd62bbc714c298"));
var _reactDom = require("e7b8cf7664bf45ab");
var _propTypes = _interopRequireDefault(require("1c92f74bf0d448e4"));
var _classnames = _interopRequireDefault(require("9508668948556753"));
var _uncontrollable = require("578d184c93803a69");
var _reactLifecyclesCompat = require("2e4cbe1ca137f842");
var _reactComponentManagers = require("23d39b7c662e7623");
var _Widget = _interopRequireDefault(require("24089a1ea973887d"));
var _Header = _interopRequireDefault(require("6c04e272adff460b"));
var _Footer = _interopRequireDefault(require("f80839053533566f"));
var _Month = _interopRequireDefault(require("aa7986ce989a16c3"));
var _Year = _interopRequireDefault(require("f302356c43ba6495"));
var _Decade = _interopRequireDefault(require("2367860591ef9f13"));
var _Century = _interopRequireDefault(require("6d6edc89cd2c90d9"));
var _messages = require("176efc92c20b3268");
var _SlideTransitionGroup = _interopRequireDefault(require("bfee7f27e2600a36"));
var _focusManager = _interopRequireDefault(require("b4730c194ef10ef5"));
var _localizers = require("b38f66e5adcf4d8e");
var CustomPropTypes = _interopRequireWildcard(require("d29dc756f3c7ae64"));
var Props = _interopRequireWildcard(require("192df3b12acf3a67"));
var _dates = _interopRequireDefault(require("ea3d6e9923ae913e"));
var _widgetHelpers = require("d449c122798cadae");
var _interaction = require("e26efc1c91334951");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class3, _temp;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _initializerDefineProperty(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function _initializerWarningHelper(descriptor, context) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and set to use loose mode. To use proposal-class-properties in spec mode with decorators, wait for the next major version of decorators in stage 2.");
}
var last = function last(a) {
    return a[a.length - 1];
};
var VIEW_UNIT = {
    month: 'day',
    year: 'month',
    decade: 'year',
    century: 'decade'
};
var VIEW_OPTIONS = [
    'month',
    'year',
    'decade',
    'century'
];
var VIEW = {
    month: _Month.default,
    year: _Year.default,
    decade: _Decade.default,
    century: _Century.default
};
var ARROWS_TO_DIRECTION = {
    ArrowDown: 'DOWN',
    ArrowUp: 'UP',
    ArrowRight: 'RIGHT',
    ArrowLeft: 'LEFT'
};
var OPPOSITE_DIRECTION = {
    LEFT: 'RIGHT',
    RIGHT: 'LEFT'
};
var MULTIPLIER = {
    year: 1,
    decade: 10,
    century: 100
};
function inRangeValue(_value, min, max) {
    var value = dateOrNull(_value);
    if (value === null) return value;
    return _dates.default.max(_dates.default.min(value, max), min);
}
var propTypes = {
    /** @ignore */ activeId: _propTypes.default.string,
    /**
   * @example ['disabled', ['new Date()']]
   */ disabled: CustomPropTypes.disabled,
    /**
   * @example ['readOnly', ['new Date()']]
   */ readOnly: CustomPropTypes.disabled,
    /**
   * @example ['onChangePicker', [ ['new Date()'] ]]
   */ onChange: _propTypes.default.func,
    /**
   * @example ['valuePicker', [ ['new Date()'] ]]
   */ value: _propTypes.default.instanceOf(Date),
    /**
   * The minimum date that the Calendar can navigate from.
   *
   * @example ['prop', ['min', 'new Date()']]
   */ min: _propTypes.default.instanceOf(Date).isRequired,
    /**
   * The maximum date that the Calendar can navigate to.
   *
   * @example ['prop', ['max', 'new Date()']]
   */ max: _propTypes.default.instanceOf(Date).isRequired,
    /**
   * Default current date at which the calendar opens. If none is provided, opens at today's date or the `value` date (if any).
   */ currentDate: _propTypes.default.instanceOf(Date),
    /**
   * Change event Handler that is called when the currentDate is changed. The handler is called with the currentDate object.
   */ onCurrentDateChange: _propTypes.default.func,
    /** Specify the navigate into the past header icon */ navigatePrevIcon: _propTypes.default.node,
    /** Specify the navigate into the future header icon */ navigateNextIcon: _propTypes.default.node,
    /**
   * Controls the currently displayed calendar view. Use `defaultView` to set a unique starting view.
   *
   * @type {("month"|"year"|"decade"|"century")}
   * @controllable onViewChange
   */ view: function view(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return _propTypes.default.oneOf(props.views || VIEW_OPTIONS).apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Defines a list of views the Calendar can traverse through, starting with the
   * first in the list to the last.
   *
   * @type array<"month"|"year"|"decade"|"century">
   */ views: _propTypes.default.arrayOf(_propTypes.default.oneOf(VIEW_OPTIONS)).isRequired,
    /**
   * A callback fired when the `view` changes.
   *
   * @controllable view
   */ onViewChange: _propTypes.default.func,
    /**
   * Callback fired when the Calendar navigates between views, or forward and backwards in time.
   *
   * @type function(date: ?Date, direction: string, view: string)
   */ onNavigate: _propTypes.default.func,
    culture: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    /**
   * Show or hide the Calendar footer.
   *
   * @example ['prop', ['footer', true]]
   */ footer: _propTypes.default.bool,
    /**
   * Provide a custom component to render the days of the month. The Component is provided the following props
   *
   * - `date`: a `Date` object for the day of the month to render
   * - `label`: a formatted `string` of the date to render. To adjust the format of the `label` string use the `dateFormat` prop, listed below.
   */ dayComponent: CustomPropTypes.elementType,
    /**
   * A formatter for the header button of the month view.
   *
   * @example ['dateFormat', ['headerFormat', "{ date: 'medium' }"]]
   */ headerFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for the Calendar footer, formats today's Date as a string.
   *
   * @example ['dateFormat', ['footerFormat', "{ date: 'medium' }", "date => 'Today is: ' + formatter(date)"]]
   */ footerFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter calendar days of the week, the default formats each day as a Narrow name: "Mo", "Tu", etc.
   *
   * @example ['prop', { dayFormat: "day => \n['🎉', 'M', 'T','W','Th', 'F', '🎉'][day.getDay()]" }]
   */ dayFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for day of the month
   *
   * @example ['prop', { dateFormat: "dt => String(dt.getDate())" }]
   */ dateFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for month name.
   *
   * @example ['dateFormat', ['monthFormat', "{ raw: 'MMMM' }", null, { defaultView: '"year"' }]]
   */ monthFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for month name.
   *
   * @example ['dateFormat', ['yearFormat', "{ raw: 'yy' }", null, { defaultView: '"decade"' }]]
   */ yearFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for decade, the default formats the first and last year of the decade like: 2000 - 2009.
   */ decadeFormat: CustomPropTypes.dateFormat,
    /**
   * A formatter for century, the default formats the first and last year of the century like: 1900 - 1999.
   */ centuryFormat: CustomPropTypes.dateFormat,
    isRtl: _propTypes.default.bool,
    messages: _propTypes.default.shape({
        moveBack: _propTypes.default.string,
        moveForward: _propTypes.default.string
    }),
    onKeyDown: _propTypes.default.func,
    /** @ignore */ tabIndex: _propTypes.default.any
};
var Calendar = (0, _reactLifecyclesCompat.polyfill)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Calendar, _React$Component);
    Calendar.move = function move(date, min, max, unit, direction) {
        var isMonth = unit === 'month';
        var isUpOrDown = direction === 'UP' || direction === 'DOWN';
        var rangeUnit = VIEW_UNIT[unit];
        var addUnit = isMonth && isUpOrDown ? 'week' : VIEW_UNIT[unit];
        var amount = isMonth || !isUpOrDown ? 1 : 4;
        var newDate;
        if (direction === 'UP' || direction === 'LEFT') amount *= -1;
        newDate = _dates.default.add(date, amount, addUnit);
        return _dates.default.inRange(newDate, min, max, rangeUnit) ? newDate : date;
    };
    function Calendar() {
        var _this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleFocusWillChange = function() {
            if (_this.props.tabIndex == -1) return false;
        };
        _initializerDefineProperty(_this, "handleViewChange", _descriptor, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleMoveBack", _descriptor2, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleMoveForward", _descriptor3, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleChange", _descriptor4, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleFooterClick", _descriptor5, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleKeyDown", _descriptor6, _assertThisInitialized(_assertThisInitialized(_this)));
        _this.viewId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_calendar');
        _this.labelId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_calendar_label');
        _this.activeId = _this.props.activeId || (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_calendar_active_cell');
        (0, _reactComponentManagers.autoFocus)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.focusManager = (0, _focusManager.default)(_assertThisInitialized(_assertThisInitialized(_this)), {
            willHandle: _this.handleFocusWillChange
        });
        var _this$props = _this.props, view = _this$props.view, views = _this$props.views;
        _this.state = {
            selectedIndex: 0,
            view: view || views[0]
        };
        return _this;
    }
    Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var messages = _ref.messages, view = _ref.view, views = _ref.views, value = _ref.value, currentDate = _ref.currentDate;
        view = view || views[0];
        var slideDirection = prevState.slideDirection, lastView = prevState.view, lastDate = prevState.currentDate;
        if (lastView !== view) slideDirection = views.indexOf(lastView) > views.indexOf(view) ? 'top' : 'bottom';
        else if (lastDate !== currentDate) slideDirection = _dates.default.gt(currentDate, lastDate) ? 'left' : 'right';
        return {
            view: view,
            slideDirection: slideDirection,
            messages: (0, _messages.getMessages)(messages),
            currentDate: currentDate || value || new Date()
        };
    };
    var _proto = Calendar.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this$props2 = this.props, value = _this$props2.value, min = _this$props2.min, max = _this$props2.max;
        var view = this.state.view;
        value = inRangeValue(value, min, max);
        if (!_dates.default.eq(value, dateOrNull(prevProps.value), VIEW_UNIT[view])) this.maybeSetCurrentDate(value);
    };
    _proto.render = function render() {
        var _this$props3 = this.props, className = _this$props3.className, value = _this$props3.value, footerFormat = _this$props3.footerFormat, disabled = _this$props3.disabled, readOnly = _this$props3.readOnly, footer = _this$props3.footer, views = _this$props3.views, min = _this$props3.min, max = _this$props3.max, culture = _this$props3.culture, tabIndex = _this$props3.tabIndex, navigatePrevIcon = _this$props3.navigatePrevIcon, navigateNextIcon = _this$props3.navigateNextIcon;
        var _this$state = this.state, currentDate = _this$state.currentDate, view = _this$state.view, slideDirection = _this$state.slideDirection, focused = _this$state.focused, messages = _this$state.messages;
        var View = VIEW[view], todaysDate = new Date(), todayNotInRange = !_dates.default.inRange(todaysDate, min, max, view);
        var key = view + '_' + _dates.default[view](currentDate);
        var elementProps = Props.pickElementProps(this), viewProps = Props.pick(this.props, View);
        var isDisabled = disabled || readOnly;
        return _react.default.createElement(_Widget.default, _extends({}, elementProps, {
            role: "group",
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            tabIndex: tabIndex || 0,
            onKeyDown: this.handleKeyDown,
            onBlur: this.focusManager.handleBlur,
            onFocus: this.focusManager.handleFocus,
            className: (0, _classnames.default)(className, 'rw-calendar rw-widget-container'),
            "aria-activedescendant": this.activeId
        }), _react.default.createElement(_Header.default, {
            isRtl: this.isRtl(),
            label: this.getHeaderLabel(),
            labelId: this.labelId,
            messages: messages,
            upDisabled: isDisabled || view === last(views),
            prevDisabled: isDisabled || !_dates.default.inRange(this.nextDate('LEFT'), min, max, view),
            nextDisabled: isDisabled || !_dates.default.inRange(this.nextDate('RIGHT'), min, max, view),
            onViewChange: this.handleViewChange,
            onMoveLeft: this.handleMoveBack,
            onMoveRight: this.handleMoveForward,
            navigatePrevIcon: navigatePrevIcon,
            navigateNextIcon: navigateNextIcon
        }), _react.default.createElement(Calendar.Transition, {
            direction: slideDirection
        }, _react.default.createElement(View, _extends({}, viewProps, {
            key: key,
            id: this.viewId,
            activeId: this.activeId,
            value: value,
            today: todaysDate,
            disabled: disabled,
            focused: currentDate,
            onChange: this.handleChange,
            onKeyDown: this.handleKeyDown,
            "aria-labelledby": this.labelId
        }))), footer && _react.default.createElement(_Footer.default, {
            value: todaysDate,
            format: footerFormat,
            culture: culture,
            disabled: disabled || todayNotInRange,
            readOnly: readOnly,
            onClick: this.handleFooterClick
        }));
    };
    _proto.navigate = function navigate(direction, date) {
        var _this$props4 = this.props, views = _this$props4.views, min = _this$props4.min, max = _this$props4.max, onNavigate = _this$props4.onNavigate, onViewChange = _this$props4.onViewChange;
        var _this$state2 = this.state, view = _this$state2.view, currentDate = _this$state2.currentDate;
        var slideDir = direction === 'LEFT' || direction === 'UP' ? 'right' : 'left';
        if (direction === 'UP') view = views[views.indexOf(view) + 1] || view;
        if (direction === 'DOWN') view = views[views.indexOf(view) - 1] || view;
        if (!date) date = [
            'LEFT',
            'RIGHT'
        ].indexOf(direction) !== -1 ? this.nextDate(direction) : currentDate;
        if (_dates.default.inRange(date, min, max, view)) {
            (0, _widgetHelpers.notify)(onNavigate, [
                date,
                slideDir,
                view
            ]);
            this.focus(true);
            this.maybeSetCurrentDate(date);
            (0, _widgetHelpers.notify)(onViewChange, [
                view
            ]);
        }
    };
    _proto.focus = function focus() {
        if (+this.props.tabIndex > -1) (0, _reactDom.findDOMNode)(this).focus();
    };
    _proto.maybeSetCurrentDate = function maybeSetCurrentDate(date) {
        var _this$props5 = this.props, min = _this$props5.min, max = _this$props5.max;
        var _this$state3 = this.state, view = _this$state3.view, currentDate = _this$state3.currentDate;
        var inRangeDate = inRangeValue(date ? new Date(date) : currentDate, min, max);
        if (date === currentDate || _dates.default.eq(inRangeDate, dateOrNull(currentDate), VIEW_UNIT[view])) return;
        (0, _widgetHelpers.notify)(this.props.onCurrentDateChange, inRangeDate);
    };
    _proto.nextDate = function nextDate(direction) {
        var method = direction === 'LEFT' ? 'subtract' : 'add';
        var _this$state4 = this.state, currentDate = _this$state4.currentDate, view = _this$state4.view;
        var unit = view === 'month' ? view : 'year';
        var multi = MULTIPLIER[view] || 1;
        return _dates.default[method](currentDate, 1 * multi, unit);
    };
    _proto.getHeaderLabel = function getHeaderLabel() {
        var _this$props6 = this.props, culture = _this$props6.culture, decadeFormat = _this$props6.decadeFormat, yearFormat = _this$props6.yearFormat, headerFormat = _this$props6.headerFormat, centuryFormat = _this$props6.centuryFormat;
        var _this$state5 = this.state, currentDate = _this$state5.currentDate, view = _this$state5.view;
        switch(view){
            case 'month':
                headerFormat = _localizers.date.getFormat('header', headerFormat);
                return _localizers.date.format(currentDate, headerFormat, culture);
            case 'year':
                yearFormat = _localizers.date.getFormat('year', yearFormat);
                return _localizers.date.format(currentDate, yearFormat, culture);
            case 'decade':
                decadeFormat = _localizers.date.getFormat('decade', decadeFormat);
                return _localizers.date.format(_dates.default.startOf(currentDate, 'decade'), decadeFormat, culture);
            case 'century':
                centuryFormat = _localizers.date.getFormat('century', centuryFormat);
                return _localizers.date.format(_dates.default.startOf(currentDate, 'century'), centuryFormat, culture);
        }
    };
    _proto.isRtl = function isRtl() {
        return !!(this.props.isRtl || this.context && this.context.isRtl);
    };
    _proto.isValidView = function isValidView(next, views) {
        if (views === void 0) views = this.props.views;
        return views.indexOf(next) !== -1;
    };
    return Calendar;
}(_react.default.Component), _class3.displayName = 'Calendar', _class3.propTypes = propTypes, _class3.defaultProps = {
    value: null,
    min: new Date(1900, 0, 1),
    max: new Date(2099, 11, 31),
    views: VIEW_OPTIONS,
    tabIndex: '0',
    footer: true
}, _class3.contextTypes = {
    isRtl: _propTypes.default.bool
}, _class3.Transition = _SlideTransitionGroup.default, _temp), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "handleViewChange", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this2 = this;
        return function() {
            _this2.navigate('UP');
        };
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "handleMoveBack", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this3 = this;
        return function() {
            _this3.navigate('LEFT');
        };
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "handleMoveForward", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this4 = this;
        return function() {
            _this4.navigate('RIGHT');
        };
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "handleChange", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this5 = this;
        return function(date) {
            var _this5$props = _this5.props, views = _this5$props.views, onChange = _this5$props.onChange;
            var view = _this5.state.view;
            if (views[0] === view) {
                _this5.maybeSetCurrentDate(date);
                (0, _widgetHelpers.notify)(onChange, date);
                _this5.focus();
                return;
            }
            _this5.navigate('DOWN', date);
        };
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "handleFooterClick", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this6 = this;
        return function(date) {
            var _this6$props = _this6.props, views = _this6$props.views, min = _this6$props.min, max = _this6$props.max, onViewChange = _this6$props.onViewChange;
            var firstView = views[0];
            (0, _widgetHelpers.notify)(_this6.props.onChange, date);
            if (_dates.default.inRange(date, min, max, firstView)) {
                _this6.focus();
                _this6.maybeSetCurrentDate(date);
                (0, _widgetHelpers.notify)(onViewChange, [
                    firstView
                ]);
            }
        };
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyDown", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this7 = this;
        return function(e) {
            var _this7$state = _this7.state, currentDate = _this7$state.currentDate, view = _this7$state.view;
            var ctrl = e.ctrlKey || e.metaKey;
            var key = e.key;
            var direction = ARROWS_TO_DIRECTION[key];
            var unit = VIEW_UNIT[view];
            if (key === 'Enter') {
                e.preventDefault();
                return _this7.handleChange(currentDate);
            }
            if (direction) {
                if (ctrl) {
                    e.preventDefault();
                    _this7.navigate(direction);
                } else {
                    if (_this7.isRtl() && OPPOSITE_DIRECTION[direction]) direction = OPPOSITE_DIRECTION[direction];
                    var nextDate = Calendar.move(currentDate, _this7.props.min, _this7.props.max, view, direction);
                    if (!_dates.default.eq(currentDate, nextDate, unit)) {
                        e.preventDefault();
                        if (_dates.default.gt(nextDate, currentDate, view)) _this7.navigate('RIGHT', nextDate);
                        else if (_dates.default.lt(nextDate, currentDate, view)) _this7.navigate('LEFT', nextDate);
                        else _this7.maybeSetCurrentDate(nextDate);
                    }
                }
            }
            (0, _widgetHelpers.notify)(_this7.props.onKeyDown, [
                e
            ]);
        };
    }
}), _class2)) || _class;
function dateOrNull(dt) {
    if (dt && !isNaN(dt.getTime())) return dt;
    return null;
}
var _default = (0, _uncontrollable.uncontrollable)(Calendar, {
    value: 'onChange',
    currentDate: 'onCurrentDateChange',
    view: 'onViewChange'
}, [
    'focus'
]);
exports.default = _default;
module.exports = exports["default"];

},{"a3cd62bbc714c298":"gVheC","e7b8cf7664bf45ab":"d8jlt","1c92f74bf0d448e4":"3KNJy","9508668948556753":"6P5cq","578d184c93803a69":"ePx5f","2e4cbe1ca137f842":"3F3XD","23d39b7c662e7623":"bMv3b","24089a1ea973887d":"kwrMv","6c04e272adff460b":"61TDB","f80839053533566f":"6ZLTN","aa7986ce989a16c3":"0ejrx","f302356c43ba6495":"fYmuV","2367860591ef9f13":"jdnmh","6d6edc89cd2c90d9":"36dpm","176efc92c20b3268":"fEqYz","bfee7f27e2600a36":"l0yDT","b4730c194ef10ef5":"htUOG","b38f66e5adcf4d8e":"hIvMI","d29dc756f3c7ae64":"8HlUx","192df3b12acf3a67":"2s4vq","ea3d6e9923ae913e":"4EPGV","d449c122798cadae":"fu3eM","e26efc1c91334951":"qGuYY"}],"bMv3b":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _spyOnComponent = _interopRequireDefault(require("aa1fec3c710825b0"));
exports.spyOnComponent = _spyOnComponent.default;
var _autoFocus = _interopRequireDefault(require("47cd0a5c19606b3c"));
exports.autoFocus = _autoFocus.default;
var _focusManager = _interopRequireDefault(require("f3aa0700365043c7"));
exports.focusManager = _focusManager.default;
var _mountManager = _interopRequireDefault(require("14692017b8c4f2fc"));
exports.mountManager = _mountManager.default;
var _timeoutManager = _interopRequireDefault(require("bba488ca22f74af7"));
exports.timeoutManager = _timeoutManager.default;
var _mixin = _interopRequireDefault(require("776fe5fb993889a8"));
exports.mixin = _mixin.default;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"aa1fec3c710825b0":"lq1Jo","47cd0a5c19606b3c":"5E4ER","f3aa0700365043c7":"loUeV","14692017b8c4f2fc":"6UKUw","bba488ca22f74af7":"bV5Hz","776fe5fb993889a8":"fc77U"}],"lq1Jo":[function(require,module,exports,__globalThis) {
var LIFECYCLE_HOOKS = {
    componentWillMount: true,
    componentDidMount: true,
    componentWillReceiveProps: true,
    getSnapshotBeforeUpdate: true,
    shouldComponentUpdate: true,
    componentWillUpdate: true,
    componentDidUpdate: true,
    componentWillUnmount: true
};
var STATIC_HOOKS = {
    getDerivedStateFromProps: true
};
function wrap(base, method, isStatic) {
    var before = true;
    if (Array.isArray(method)) {
        before = method[0] !== 'after';
        method = method[1];
    }
    if (!base) return method;
    return function wrappedLifecyclehook() {
        var ctx = isStatic ? null : this;
        before && method.apply(ctx, arguments);
        base.apply(ctx, arguments);
        !before && method.apply(ctx, arguments);
    };
}
module.exports = function spyOnComponent1(component, hooks) {
    var originals = Object.create(null);
    for(var key in hooks)if (STATIC_HOOKS[key]) component.constructor[key] = wrap(originals[key] = component.constructor[key], hooks[key], true);
    for(var key in hooks)if (LIFECYCLE_HOOKS[key]) component[key] = wrap(originals[key] = component[key], hooks[key]);
    return function reset(key) {
        var subject = STATIC_HOOKS[key] ? component.constructor : component;
        if (key && key in originals) subject[key] = originals[key];
        else for(key in originals)subject[key] = originals[key];
    };
};
module.exports.mixin = function mixinIntoComponent(componentClass, hooks) {
    spyOnComponent(componentClass.prototype, hooks);
    return componentClass;
};

},{}],"5E4ER":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = makeAutoFocusable;
exports.PropTypes = void 0;
var _propTypes = require("5b660d65db26d4e5");
var _reactDom = require("32c14221a7a6a378");
var _spyOnComponent = _interopRequireDefault(require("eb94c553ed3ec8a0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var PropTypes = {
    autoFocus: _propTypes.bool
};
exports.PropTypes = PropTypes;
function makeAutoFocusable(instance) {
    (0, _spyOnComponent.default)(instance, {
        componentDidMount: function componentDidMount() {
            var autoFocus = this.props.autoFocus;
            if (autoFocus) this.focus ? this.focus() : (0, _reactDom.findDOMNode)(this).focus();
        }
    });
}

},{"5b660d65db26d4e5":"3KNJy","32c14221a7a6a378":"d8jlt","eb94c553ed3ec8a0":"lq1Jo"}],"loUeV":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.callFocusEventHandler = callFocusEventHandler;
exports.default = createFocusManager;
var _reactDom = require("f2a9126ce987d773");
var _timeoutManager = _interopRequireDefault(require("2f2b4fde11a69ae4"));
var _mountManager = _interopRequireDefault(require("671e4fa9dd5fd85"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function callFocusEventHandler(inst, focused, e) {
    var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
    handler && handler(e);
}
function createFocusManager(instance, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, willHandle = _ref.willHandle, didHandle = _ref.didHandle, onChange = _ref.onChange, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? function isDisabled() {
        return !!instance.props.disabled;
    } : _ref$isDisabled;
    var lastFocused;
    var timeouts = (0, _timeoutManager.default)(instance);
    var isMounted = (0, _mountManager.default)(instance);
    function _handleFocus(focused, event) {
        if (event && event.persist) event.persist();
        if (willHandle && willHandle(focused, event) === false) return;
        timeouts.set('focus', function() {
            (0, _reactDom.unstable_batchedUpdates)(function() {
                if (focused !== lastFocused) {
                    if (didHandle) didHandle.call(instance, focused, event); // only fire a change when unmounted if its a blur
                    if (isMounted() || !focused) {
                        lastFocused = focused;
                        onChange && onChange(focused, event);
                    }
                }
            });
        });
    }
    return {
        handleBlur: function handleBlur(event) {
            if (!isDisabled()) _handleFocus(false, event);
        },
        handleFocus: function handleFocus(event) {
            if (!isDisabled()) _handleFocus(true, event);
        }
    };
}

},{"f2a9126ce987d773":"d8jlt","2f2b4fde11a69ae4":"bV5Hz","671e4fa9dd5fd85":"6UKUw"}],"bV5Hz":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = createTimeoutManager;
var _spyOnComponent = _interopRequireDefault(require("1153d59efb96b0a5"));
var _mountManager = _interopRequireDefault(require("186071dc33c03a24"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createTimeoutManager(componentInstance) {
    var isMounted = (0, _mountManager.default)(componentInstance);
    var timers = Object.create(null);
    var manager;
    (0, _spyOnComponent.default)(componentInstance, {
        componentWillUnmount: function componentWillUnmount() {
            for(var k in timers)clearTimeout(timers[k]);
            timers = null;
        }
    });
    return manager = {
        clear: function clear(key) {
            clearTimeout(timers[key]);
        },
        set: function set(key, fn, ms) {
            if (!isMounted()) return;
            manager.clear(key);
            timers[key] = setTimeout(fn, ms);
        }
    };
}
module.exports = exports["default"];

},{"1153d59efb96b0a5":"lq1Jo","186071dc33c03a24":"6UKUw"}],"6UKUw":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = spyOnMount;
var _spyOnComponent = _interopRequireDefault(require("4376f569a9879143"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function spyOnMount(componentInstance) {
    var mounted = true;
    (0, _spyOnComponent.default)(componentInstance, {
        componentWillUnmount: function componentWillUnmount() {
            mounted = false;
        }
    });
    return function() {
        return mounted;
    };
}
module.exports = exports["default"];

},{"4376f569a9879143":"lq1Jo"}],"fc77U":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.mixin = mixin;
exports.default = mixIntoClass;
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function mixin(componentClass, _ref) {
    var propTypes = _ref.propTypes, contextTypes = _ref.contextTypes, childContextTypes = _ref.childContextTypes, getChildContext = _ref.getChildContext, protoSpec = _objectWithoutProperties(_ref, [
        "propTypes",
        "contextTypes",
        "childContextTypes",
        "getChildContext"
    ]);
    if (propTypes) componentClass.propTypes = _extends({}, componentClass.propTypes, propTypes);
    if (contextTypes) componentClass.contextTypes = _extends({}, componentClass.contextTypes, contextTypes);
    if (childContextTypes) componentClass.childContextTypes = _extends({}, componentClass.childContextTypes, childContextTypes);
    if (getChildContext) {
        var baseGCContext = componentClass.prototype.getChildContext;
        componentClass.prototype.getChildContext = function $getChildContext() {
            return _extends({}, baseGCContext && baseGCContext.call(this), getChildContext.call(this));
        };
    }
    _extends(componentClass.prototype, protoSpec);
    return componentClass;
}
function mixIntoClass(spec) {
    return function(componentClass) {
        return mixin(componentClass, spec);
    };
}

},{}],"61TDB":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("4ca22432bdaead3f"));
var _propTypes = _interopRequireDefault(require("39b80841f5bd11ff"));
var _Button = _interopRequireDefault(require("89a25413eeecdba7"));
var _Icon = require("fbbb54c60b034fd3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var Header = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Header, _React$Component);
    function Header() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Header.prototype;
    _proto.render = function render() {
        var _this$props = this.props, messages = _this$props.messages, label = _this$props.label, labelId = _this$props.labelId, onMoveRight = _this$props.onMoveRight, onMoveLeft = _this$props.onMoveLeft, onViewChange = _this$props.onViewChange, prevDisabled = _this$props.prevDisabled, upDisabled = _this$props.upDisabled, nextDisabled = _this$props.nextDisabled, _this$props$navigateP = _this$props.navigatePrevIcon, navigatePrevIcon = _this$props$navigateP === void 0 ? _Icon.chevronLeft : _this$props$navigateP, _this$props$navigateN = _this$props.navigateNextIcon, navigateNextIcon = _this$props$navigateN === void 0 ? _Icon.chevronRight : _this$props$navigateN, isRtl = _this$props.isRtl;
        return _react.default.createElement("div", {
            className: "rw-calendar-header"
        }, _react.default.createElement(_Button.default, {
            className: "rw-calendar-btn-left",
            onClick: onMoveLeft,
            disabled: prevDisabled,
            label: messages.moveBack(),
            icon: isRtl ? navigateNextIcon : navigatePrevIcon
        }), _react.default.createElement(_Button.default, {
            id: labelId,
            onClick: onViewChange,
            className: "rw-calendar-btn-view",
            disabled: upDisabled,
            "aria-live": "polite",
            "aria-atomic": "true"
        }, label), _react.default.createElement(_Button.default, {
            className: "rw-calendar-btn-right",
            onClick: onMoveRight,
            disabled: nextDisabled,
            label: messages.moveForward(),
            icon: isRtl ? navigatePrevIcon : navigateNextIcon
        }));
    };
    return Header;
}(_react.default.Component);
Header.propTypes = {
    label: _propTypes.default.string.isRequired,
    labelId: _propTypes.default.string,
    upDisabled: _propTypes.default.bool.isRequired,
    prevDisabled: _propTypes.default.bool.isRequired,
    nextDisabled: _propTypes.default.bool.isRequired,
    onViewChange: _propTypes.default.func.isRequired,
    onMoveLeft: _propTypes.default.func.isRequired,
    onMoveRight: _propTypes.default.func.isRequired,
    navigatePrevIcon: _propTypes.default.node,
    navigateNextIcon: _propTypes.default.node,
    messages: _propTypes.default.shape({
        moveBack: _propTypes.default.func.isRequired,
        moveForward: _propTypes.default.func.isRequired
    }),
    isRtl: _propTypes.default.bool
};
var _default = Header;
exports.default = _default;
module.exports = exports["default"];

},{"4ca22432bdaead3f":"gVheC","39b80841f5bd11ff":"3KNJy","89a25413eeecdba7":"6M58T","fbbb54c60b034fd3":"5bZrH"}],"5bZrH":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = exports.search = exports.clock = exports.calendar = exports.chevronLeft = exports.chevronRight = exports.caretDown = exports.caretUp = void 0;
var _propTypes = _interopRequireDefault(require("15baf3625092a8d0"));
var _react = _interopRequireDefault(require("cf8f3572bedfee47"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var propTypes = {
    icon: _propTypes.default.string.isRequired
};
var Icon = function Icon(_ref) {
    var icon = _ref.icon;
    return _react.default.createElement("span", {
        "aria-hidden": "true",
        className: "rw-i rw-i-" + icon
    });
};
Icon.propTypes = propTypes;
var caretUp = _react.default.createElement(Icon, {
    icon: "caret-up"
});
exports.caretUp = caretUp;
var caretDown = _react.default.createElement(Icon, {
    icon: "caret-down"
});
exports.caretDown = caretDown;
var chevronRight = _react.default.createElement(Icon, {
    icon: "chevron-right"
});
exports.chevronRight = chevronRight;
var chevronLeft = _react.default.createElement(Icon, {
    icon: "chevron-left"
});
exports.chevronLeft = chevronLeft;
var calendar = _react.default.createElement(Icon, {
    icon: "calendar"
});
exports.calendar = calendar;
var clock = _react.default.createElement(Icon, {
    icon: "clock-o"
});
exports.clock = clock;
var search = _react.default.createElement(Icon, {
    icon: "search"
});
exports.search = search;
var _default = Icon;
exports.default = _default;

},{"15baf3625092a8d0":"3KNJy","cf8f3572bedfee47":"gVheC"}],"6ZLTN":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = Footer;
var _react = _interopRequireDefault(require("789e17be2177ed7d"));
var _propTypes = _interopRequireDefault(require("8a2cca8b14a558e5"));
var _Button = _interopRequireDefault(require("37b6f0d0d7e97e6a"));
var _localizers = require("b6bd3a971a0c0849");
var CustomPropTypes = _interopRequireWildcard(require("f47bb9955ee4123c"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var propTypes = {
    disabled: _propTypes.default.bool,
    readOnly: _propTypes.default.bool,
    value: _propTypes.default.instanceOf(Date),
    onClick: _propTypes.default.func.isRequired,
    culture: _propTypes.default.string,
    format: CustomPropTypes.dateFormat
};
function Footer(_ref) {
    var disabled = _ref.disabled, readOnly = _ref.readOnly, value = _ref.value, onClick = _ref.onClick, culture = _ref.culture, format = _ref.format;
    return _react.default.createElement("div", {
        className: "rw-calendar-footer"
    }, _react.default.createElement(_Button.default, {
        disabled: !!(disabled || readOnly),
        onClick: onClick.bind(null, value)
    }, _localizers.date.format(value, _localizers.date.getFormat('footer', format), culture)));
}
Footer.propTypes = propTypes;
module.exports = exports["default"];

},{"789e17be2177ed7d":"gVheC","8a2cca8b14a558e5":"3KNJy","37b6f0d0d7e97e6a":"6M58T","b6bd3a971a0c0849":"hIvMI","f47bb9955ee4123c":"8HlUx"}],"0ejrx":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("5d8de94eccbe8e5b"));
var _propTypes = _interopRequireDefault(require("23f113e83f9cfe3f"));
var _react = _interopRequireDefault(require("f27425205014244b"));
var _CalendarView = _interopRequireDefault(require("381b215ffe63a626"));
var _dates = _interopRequireDefault(require("196bfd7e7dea75f8"));
var _localizers = require("3727f59228b8c8e1");
var CustomPropTypes = _interopRequireWildcard(require("f2e4f3a9442f21bb"));
var _ = require("e1db491c7b76970f");
var Props = _interopRequireWildcard(require("80e7b92f5faf25ec"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var isEqual = function isEqual(dateA, dateB) {
    return _dates.default.eq(dateA, dateB, 'day');
};
var MonthView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(MonthView, _React$Component);
    function MonthView() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.renderRow = function(row, rowIdx) {
            var _this$props = _this.props, focused = _this$props.focused, today = _this$props.today, activeId = _this$props.activeId, disabled = _this$props.disabled, onChange = _this$props.onChange, value = _this$props.value, culture = _this$props.culture, min = _this$props.min, max = _this$props.max, footerFormat = _this$props.footerFormat, dateFormat = _this$props.dateFormat, Day = _this$props.dayComponent;
            footerFormat = _localizers.date.getFormat('footer', footerFormat);
            dateFormat = _localizers.date.getFormat('dayOfMonth', dateFormat);
            return _react.default.createElement(_CalendarView.default.Row, {
                key: rowIdx
            }, row.map(function(date, colIdx) {
                var formattedDate = _localizers.date.format(date, dateFormat, culture);
                var label = _localizers.date.format(date, footerFormat, culture);
                return _react.default.createElement(_CalendarView.default.Cell, {
                    key: colIdx,
                    activeId: activeId,
                    label: label,
                    date: date,
                    now: today,
                    min: min,
                    max: max,
                    unit: "day",
                    viewUnit: "month",
                    onChange: onChange,
                    focused: focused,
                    selected: value,
                    disabled: disabled
                }, Day ? _react.default.createElement(Day, {
                    date: date,
                    label: formattedDate
                }) : formattedDate);
            }));
        };
        return _this;
    }
    var _proto = MonthView.prototype;
    _proto.renderHeaders = function renderHeaders(week, format, culture) {
        var firstOfWeek = _localizers.date.firstOfWeek(culture);
        return week.map(function(date) {
            return _react.default.createElement("th", {
                className: "rw-head-cell",
                key: 'header_' + _dates.default.weekday(date, undefined, firstOfWeek)
            }, _localizers.date.format(date, format, culture));
        });
    };
    _proto.render = function render() {
        var _this$props2 = this.props, className = _this$props2.className, focused = _this$props2.focused, culture = _this$props2.culture, activeId = _this$props2.activeId, dayFormat = _this$props2.dayFormat;
        var month = _dates.default.visibleDays(focused, culture);
        var rows = (0, _.chunk)(month, 7);
        dayFormat = _localizers.date.getFormat('weekday', dayFormat);
        return _react.default.createElement(_CalendarView.default, _extends({}, Props.omitOwn(this), {
            activeId: activeId,
            className: (0, _classnames.default)(className, 'rw-calendar-month')
        }), _react.default.createElement("thead", {
            className: "rw-calendar-head"
        }, _react.default.createElement("tr", {
            className: "rw-calendar-row"
        }, this.renderHeaders(rows[0], dayFormat, culture))), _react.default.createElement(_CalendarView.default.Body, null, rows.map(this.renderRow)));
    };
    return MonthView;
}(_react.default.Component);
MonthView.isEqual = isEqual;
MonthView.propTypes = {
    activeId: _propTypes.default.string,
    culture: _propTypes.default.string,
    today: _propTypes.default.instanceOf(Date),
    value: _propTypes.default.instanceOf(Date),
    focused: _propTypes.default.instanceOf(Date),
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    onChange: _propTypes.default.func.isRequired,
    dayComponent: CustomPropTypes.elementType,
    dayFormat: CustomPropTypes.dateFormat,
    dateFormat: CustomPropTypes.dateFormat,
    footerFormat: CustomPropTypes.dateFormat,
    disabled: _propTypes.default.bool
};
var _default = MonthView;
exports.default = _default;
module.exports = exports["default"];

},{"5d8de94eccbe8e5b":"6P5cq","23f113e83f9cfe3f":"3KNJy","f27425205014244b":"gVheC","381b215ffe63a626":"j7hQF","196bfd7e7dea75f8":"4EPGV","3727f59228b8c8e1":"hIvMI","f2e4f3a9442f21bb":"8HlUx","e1db491c7b76970f":"lDW6z","80e7b92f5faf25ec":"2s4vq"}],"j7hQF":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("ea4cbb058fa6e906"));
var _propTypes = _interopRequireDefault(require("c2b8b17dd5ef5f0e"));
var _classnames = _interopRequireDefault(require("4d59f985f88eae58"));
var _dates = _interopRequireDefault(require("cadab8cd63d4801c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var VIEW_UNITS = [
    'month',
    'year',
    'decade',
    'century'
];
function clamp(date, min, max) {
    return _dates.default.max(_dates.default.min(date, max), min);
}
var CalendarView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CalendarView, _React$Component);
    function CalendarView() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = CalendarView.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, activeId = _this$props.activeId, props = _objectWithoutProperties(_this$props, [
            "className",
            "activeId"
        ]);
        return _react.default.createElement("table", _extends({}, props, {
            role: "grid",
            tabIndex: "-1",
            "aria-activedescendant": activeId || null,
            className: (0, _classnames.default)(className, 'rw-nav-view', 'rw-calendar-grid')
        }));
    };
    return CalendarView;
}(_react.default.Component);
CalendarView.propTypes = {
    activeId: _propTypes.default.string
};
var CalendarViewCell = /*#__PURE__*/ function(_React$Component2) {
    _inheritsLoose(CalendarViewCell, _React$Component2);
    function CalendarViewCell() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args)) || this;
        _this.handleChange = function() {
            var _this$props2 = _this.props, onChange = _this$props2.onChange, min = _this$props2.min, max = _this$props2.max, date = _this$props2.date;
            onChange(clamp(date, min, max));
        };
        return _this;
    }
    var _proto2 = CalendarViewCell.prototype;
    _proto2.isEmpty = function isEmpty() {
        var _this$props3 = this.props, unit = _this$props3.unit, min = _this$props3.min, max = _this$props3.max, date = _this$props3.date;
        return !_dates.default.inRange(date, min, max, unit);
    };
    _proto2.isEqual = function isEqual(date) {
        return _dates.default.eq(this.props.date, date, this.props.unit);
    };
    _proto2.isFocused = function isFocused() {
        return !this.props.disabled && !this.isEmpty() && this.isEqual(this.props.focused);
    };
    _proto2.isNow = function isNow() {
        return this.props.now && this.isEqual(this.props.now);
    };
    _proto2.isOffView = function isOffView() {
        var _this$props4 = this.props, viewUnit = _this$props4.viewUnit, focused = _this$props4.focused, date = _this$props4.date;
        return date && focused && viewUnit && _dates.default[viewUnit](date) !== _dates.default[viewUnit](focused);
    };
    _proto2.isSelected = function isSelected() {
        return this.props.selected && this.isEqual(this.props.selected);
    };
    _proto2.render = function render() {
        var _this$props5 = this.props, children = _this$props5.children, activeId = _this$props5.activeId, label = _this$props5.label, disabled = _this$props5.disabled;
        var isDisabled = disabled || this.isEmpty();
        return _react.default.createElement("td", {
            role: "gridcell",
            id: this.isFocused() ? activeId : null,
            title: label,
            "aria-label": label,
            "aria-readonly": disabled,
            "aria-selected": this.isSelected(),
            onClick: !isDisabled ? this.handleChange : undefined,
            className: (0, _classnames.default)('rw-cell', this.isNow() && 'rw-now', isDisabled && 'rw-state-disabled', this.isEmpty() && 'rw-cell-not-allowed', this.isOffView() && 'rw-cell-off-range', this.isFocused() && 'rw-state-focus', this.isSelected() && 'rw-state-selected')
        }, children);
    };
    return CalendarViewCell;
}(_react.default.Component);
CalendarViewCell.propTypes = {
    id: _propTypes.default.string,
    activeId: _propTypes.default.string.isRequired,
    label: _propTypes.default.string,
    now: _propTypes.default.instanceOf(Date),
    date: _propTypes.default.instanceOf(Date),
    selected: _propTypes.default.instanceOf(Date),
    focused: _propTypes.default.instanceOf(Date),
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    unit: _propTypes.default.oneOf([
        'day'
    ].concat(VIEW_UNITS)),
    viewUnit: _propTypes.default.oneOf(VIEW_UNITS),
    onChange: _propTypes.default.func.isRequired,
    disabled: _propTypes.default.bool
};
CalendarView.Body = function(props) {
    return _react.default.createElement("tbody", _extends({
        className: "rw-calendar-body"
    }, props));
};
CalendarView.Row = function(props) {
    return _react.default.createElement("tr", _extends({
        role: "row",
        className: "rw-calendar-row"
    }, props));
};
CalendarView.Cell = CalendarViewCell;
var _default = CalendarView;
exports.default = _default;
module.exports = exports["default"];

},{"ea4cbb058fa6e906":"gVheC","c2b8b17dd5ef5f0e":"3KNJy","4d59f985f88eae58":"6P5cq","cadab8cd63d4801c":"4EPGV"}],"4EPGV":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _dateArithmetic = _interopRequireDefault(require("9155d7c9db3448c4"));
var _localizers = require("c2ccd3f20520ef68");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var dates = _extends({}, _dateArithmetic.default, {
    monthsInYear: function monthsInYear(year) {
        var date = new Date(year, 0, 1);
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(function(i) {
            return dates.month(date, i);
        });
    },
    firstVisibleDay: function firstVisibleDay(date, culture) {
        var firstOfMonth = dates.startOf(date, 'month');
        return dates.startOf(firstOfMonth, 'week', _localizers.date.firstOfWeek(culture));
    },
    lastVisibleDay: function lastVisibleDay(date, culture) {
        var endOfMonth = dates.endOf(date, 'month');
        return dates.endOf(endOfMonth, 'week', _localizers.date.firstOfWeek(culture));
    },
    visibleDays: function visibleDays(date, culture) {
        var current = dates.firstVisibleDay(date, culture);
        var last = dates.lastVisibleDay(date, culture);
        var days = [];
        while(dates.lte(current, last, 'day')){
            days.push(current);
            current = dates.add(current, 1, 'day');
        }
        return days;
    },
    merge: function merge(date, time, defaultDate) {
        if (time == null && date == null) return null;
        if (time == null) time = defaultDate || new Date();
        if (date == null) date = defaultDate || new Date();
        date = dates.startOf(date, 'day');
        date = dates.hours(date, dates.hours(time));
        date = dates.minutes(date, dates.minutes(time));
        date = dates.seconds(date, dates.seconds(time));
        return dates.milliseconds(date, dates.milliseconds(time));
    },
    today: function today() {
        return dates.startOf(new Date(), 'day');
    },
    tomorrow: function tomorrow() {
        return dates.add(dates.startOf(new Date(), 'day'), 1, 'day');
    }
});
var _default = dates;
exports.default = _default;
module.exports = exports["default"];

},{"9155d7c9db3448c4":"6TNvE","c2ccd3f20520ef68":"hIvMI"}],"6TNvE":[function(require,module,exports,__globalThis) {
var MILI = 'milliseconds', SECONDS = 'seconds', MINUTES = 'minutes', HOURS = 'hours', DAY = 'day', WEEK = 'week', MONTH = 'month', YEAR = 'year', DECADE = 'decade', CENTURY = 'century';
var dates = module.exports = {
    add: function add(date, num, unit) {
        date = new Date(date);
        switch(unit){
            case MILI:
            case SECONDS:
            case MINUTES:
            case HOURS:
            case YEAR:
                return dates[unit](date, dates[unit](date) + num);
            case DAY:
                return dates.date(date, dates.date(date) + num);
            case WEEK:
                return dates.date(date, dates.date(date) + 7 * num);
            case MONTH:
                return monthMath(date, num);
            case DECADE:
                return dates.year(date, dates.year(date) + num * 10);
            case CENTURY:
                return dates.year(date, dates.year(date) + num * 100);
        }
        throw new TypeError('Invalid units: "' + unit + '"');
    },
    subtract: function subtract(date, num, unit) {
        return dates.add(date, -num, unit);
    },
    startOf: function startOf(date, unit, firstOfWeek) {
        date = new Date(date);
        switch(unit){
            case 'century':
            case 'decade':
            case 'year':
                date = dates.month(date, 0);
            case 'month':
                date = dates.date(date, 1);
            case 'week':
            case 'day':
                date = dates.hours(date, 0);
            case 'hours':
                date = dates.minutes(date, 0);
            case 'minutes':
                date = dates.seconds(date, 0);
            case 'seconds':
                date = dates.milliseconds(date, 0);
        }
        if (unit === DECADE) date = dates.subtract(date, dates.year(date) % 10, 'year');
        if (unit === CENTURY) date = dates.subtract(date, dates.year(date) % 100, 'year');
        if (unit === WEEK) date = dates.weekday(date, 0, firstOfWeek);
        return date;
    },
    endOf: function endOf(date, unit, firstOfWeek) {
        date = new Date(date);
        date = dates.startOf(date, unit, firstOfWeek);
        date = dates.add(date, 1, unit);
        date = dates.subtract(date, 1, MILI);
        return date;
    },
    eq: createComparer(function(a, b) {
        return a === b;
    }),
    neq: createComparer(function(a, b) {
        return a !== b;
    }),
    gt: createComparer(function(a, b) {
        return a > b;
    }),
    gte: createComparer(function(a, b) {
        return a >= b;
    }),
    lt: createComparer(function(a, b) {
        return a < b;
    }),
    lte: createComparer(function(a, b) {
        return a <= b;
    }),
    min: function min() {
        return new Date(Math.min.apply(Math, arguments));
    },
    max: function max() {
        return new Date(Math.max.apply(Math, arguments));
    },
    inRange: function inRange(day, min, max, unit) {
        unit = unit || 'day';
        return (!min || dates.gte(day, min, unit)) && (!max || dates.lte(day, max, unit));
    },
    milliseconds: createAccessor('Milliseconds'),
    seconds: createAccessor('Seconds'),
    minutes: createAccessor('Minutes'),
    hours: createAccessor('Hours'),
    day: createAccessor('Day'),
    date: createAccessor('Date'),
    month: createAccessor('Month'),
    year: createAccessor('FullYear'),
    decade: function decade(date, val) {
        return val === undefined ? dates.year(dates.startOf(date, DECADE)) : dates.add(date, val + 10, YEAR);
    },
    century: function century(date, val) {
        return val === undefined ? dates.year(dates.startOf(date, CENTURY)) : dates.add(date, val + 100, YEAR);
    },
    weekday: function weekday(date, val, firstDay) {
        var weekday = (dates.day(date) + 7 - (firstDay || 0)) % 7;
        return val === undefined ? weekday : dates.add(date, val - weekday, DAY);
    },
    diff: function diff(date1, date2, unit, asFloat) {
        var dividend, divisor, result;
        switch(unit){
            case MILI:
            case SECONDS:
            case MINUTES:
            case HOURS:
            case DAY:
            case WEEK:
                dividend = date2.getTime() - date1.getTime();
                break;
            case MONTH:
            case YEAR:
            case DECADE:
            case CENTURY:
                dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1);
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        switch(unit){
            case MILI:
                divisor = 1;
                break;
            case SECONDS:
                divisor = 1000;
                break;
            case MINUTES:
                divisor = 60000;
                break;
            case HOURS:
                divisor = 3600000;
                break;
            case DAY:
                divisor = 86400000;
                break;
            case WEEK:
                divisor = 604800000;
                break;
            case MONTH:
                divisor = 1;
                break;
            case YEAR:
                divisor = 12;
                break;
            case DECADE:
                divisor = 120;
                break;
            case CENTURY:
                divisor = 1200;
                break;
            default:
                throw new TypeError('Invalid units: "' + unit + '"');
        }
        result = dividend / divisor;
        return asFloat ? result : absoluteFloor(result);
    }
};
function absoluteFloor(number) {
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function monthMath(date, val) {
    var current = dates.month(date), newMonth = current + val;
    date = dates.month(date, newMonth);
    while(newMonth < 0)newMonth = 12 + newMonth;
    //month rollover
    if (dates.month(date) !== newMonth % 12) date = dates.date(date, 0) //move to last of month
    ;
    return date;
}
function createAccessor(method) {
    return function(date, val) {
        if (val === undefined) return date['get' + method]();
        date = new Date(date);
        date['set' + method](val);
        return date;
    };
}
function createComparer(operator) {
    return function(a, b, unit) {
        return operator(+dates.startOf(a, unit), +dates.startOf(b, unit));
    };
}

},{}],"2s4vq":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.pick = pick;
exports.pickElementProps = pickElementProps;
exports.omitOwn = omitOwn;
var whitelist = [
    'style',
    'className',
    'role',
    'id',
    'autocomplete',
    'size',
    'tabIndex',
    'maxLength',
    'name'
];
var whitelistRegex = [
    /^aria-/,
    /^data-/,
    /^on[A-Z]\w+/
];
function pick(props, componentClass) {
    var keys = Object.keys(componentClass.propTypes);
    var result = {};
    Object.keys(props).forEach(function(key) {
        if (keys.indexOf(key) === -1) return;
        result[key] = props[key];
    });
    return result;
}
function pickElementProps(component) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)others[_key - 1] = arguments[_key];
    var props = omitOwn.apply(void 0, [
        component
    ].concat(others));
    var result = {};
    Object.keys(props).forEach(function(key) {
        if (whitelist.indexOf(key) !== -1 || whitelistRegex.some(function(r) {
            return !!key.match(r);
        })) result[key] = props[key];
    });
    return result;
}
function omitOwn(component) {
    var initial = Object.keys(component.constructor.propTypes);
    for(var _len2 = arguments.length, others = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)others[_key2 - 1] = arguments[_key2];
    var keys = others.reduce(function(arr, compClass) {
        return arr.concat(Object.keys(compClass.propTypes));
    }, initial);
    var result = {};
    Object.keys(component.props).forEach(function(key) {
        if (keys.indexOf(key) !== -1) return;
        result[key] = component.props[key];
    });
    return result;
}

},{}],"fYmuV":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("9336af683af5a4de"));
var _propTypes = _interopRequireDefault(require("46b67498f314bc98"));
var _CalendarView = _interopRequireDefault(require("38235aff59ed01a7"));
var _dates = _interopRequireDefault(require("93e779b32ad298be"));
var _localizers = require("99086afe76ca1d07");
var _ = require("cdafd032a2624f89");
var Props = _interopRequireWildcard(require("aea75113e040fda6"));
var CustomPropTypes = _interopRequireWildcard(require("65bb6e5eee474bc8"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var YearView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(YearView, _React$Component);
    function YearView() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.renderRow = function(row, rowIdx) {
            var _this$props = _this.props, focused = _this$props.focused, activeId = _this$props.activeId, disabled = _this$props.disabled, onChange = _this$props.onChange, value = _this$props.value, today = _this$props.today, culture = _this$props.culture, headerFormat = _this$props.headerFormat, monthFormat = _this$props.monthFormat, min = _this$props.min, max = _this$props.max;
            headerFormat = _localizers.date.getFormat('header', headerFormat);
            monthFormat = _localizers.date.getFormat('month', monthFormat);
            return _react.default.createElement(_CalendarView.default.Row, {
                key: rowIdx
            }, row.map(function(date, colIdx) {
                var label = _localizers.date.format(date, headerFormat, culture);
                return _react.default.createElement(_CalendarView.default.Cell, {
                    key: colIdx,
                    activeId: activeId,
                    label: label,
                    date: date,
                    now: today,
                    min: min,
                    max: max,
                    unit: "month",
                    onChange: onChange,
                    focused: focused,
                    selected: value,
                    disabled: disabled
                }, _localizers.date.format(date, monthFormat, culture));
            }));
        };
        return _this;
    }
    var _proto = YearView.prototype;
    _proto.render = function render() {
        var _this$props2 = this.props, focused = _this$props2.focused, activeId = _this$props2.activeId, months = _dates.default.monthsInYear(_dates.default.year(focused));
        return _react.default.createElement(_CalendarView.default, _extends({}, Props.omitOwn(this), {
            activeId: activeId
        }), _react.default.createElement(_CalendarView.default.Body, null, (0, _.chunk)(months, 4).map(this.renderRow)));
    };
    return YearView;
}(_react.default.Component);
YearView.propTypes = {
    activeId: _propTypes.default.string,
    culture: _propTypes.default.string,
    today: _propTypes.default.instanceOf(Date),
    value: _propTypes.default.instanceOf(Date),
    focused: _propTypes.default.instanceOf(Date),
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    onChange: _propTypes.default.func.isRequired,
    headerFormat: CustomPropTypes.dateFormat,
    monthFormat: CustomPropTypes.dateFormat,
    disabled: _propTypes.default.bool
};
var _default = YearView;
exports.default = _default;
module.exports = exports["default"];

},{"9336af683af5a4de":"gVheC","46b67498f314bc98":"3KNJy","38235aff59ed01a7":"j7hQF","93e779b32ad298be":"4EPGV","99086afe76ca1d07":"hIvMI","cdafd032a2624f89":"lDW6z","aea75113e040fda6":"2s4vq","65bb6e5eee474bc8":"8HlUx"}],"jdnmh":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("a704541726dae13b"));
var _propTypes = _interopRequireDefault(require("e9f8b1bfb97dd13b"));
var _CalendarView = _interopRequireDefault(require("be813646d245b5cf"));
var _dates = _interopRequireDefault(require("37d1043cdf4c013c"));
var _localizers = require("d76955bd8990ad41");
var _ = require("aa73ab8b380b163b");
var Props = _interopRequireWildcard(require("aec4e57a858d31ed"));
var CustomPropTypes = _interopRequireWildcard(require("5ff2f5ab8617bdd8"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var DecadeView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(DecadeView, _React$Component);
    function DecadeView() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.renderRow = function(row, rowIdx) {
            var _this$props = _this.props, focused = _this$props.focused, activeId = _this$props.activeId, disabled = _this$props.disabled, onChange = _this$props.onChange, yearFormat = _this$props.yearFormat, value = _this$props.value, today = _this$props.today, culture = _this$props.culture, min = _this$props.min, max = _this$props.max;
            return _react.default.createElement(_CalendarView.default.Row, {
                key: rowIdx
            }, row.map(function(date, colIdx) {
                var label = _localizers.date.format(date, _localizers.date.getFormat('year', yearFormat), culture);
                return _react.default.createElement(_CalendarView.default.Cell, {
                    key: colIdx,
                    unit: "year",
                    activeId: activeId,
                    label: label,
                    date: date,
                    now: today,
                    min: min,
                    max: max,
                    onChange: onChange,
                    focused: focused,
                    selected: value,
                    disabled: disabled
                }, label);
            }));
        };
        return _this;
    }
    var _proto = DecadeView.prototype;
    _proto.render = function render() {
        var _this$props2 = this.props, focused = _this$props2.focused, activeId = _this$props2.activeId;
        return _react.default.createElement(_CalendarView.default, _extends({}, Props.omitOwn(this), {
            activeId: activeId
        }), _react.default.createElement(_CalendarView.default.Body, null, (0, _.chunk)(getDecadeYears(focused), 4).map(this.renderRow)));
    };
    return DecadeView;
}(_react.default.Component);
DecadeView.propTypes = {
    activeId: _propTypes.default.string,
    culture: _propTypes.default.string,
    today: _propTypes.default.instanceOf(Date),
    value: _propTypes.default.instanceOf(Date),
    focused: _propTypes.default.instanceOf(Date),
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    onChange: _propTypes.default.func.isRequired,
    yearFormat: CustomPropTypes.dateFormat,
    disabled: _propTypes.default.bool
};
function getDecadeYears(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = _dates.default.add(_dates.default.startOf(_date, 'decade'), -2, 'year');
    return days.map(function() {
        return date = _dates.default.add(date, 1, 'year');
    });
}
var _default = DecadeView;
exports.default = _default;
module.exports = exports["default"];

},{"a704541726dae13b":"gVheC","e9f8b1bfb97dd13b":"3KNJy","be813646d245b5cf":"j7hQF","37d1043cdf4c013c":"4EPGV","d76955bd8990ad41":"hIvMI","aa73ab8b380b163b":"lDW6z","aec4e57a858d31ed":"2s4vq","5ff2f5ab8617bdd8":"8HlUx"}],"36dpm":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("2d65a1ea17eb64a0"));
var _propTypes = _interopRequireDefault(require("8cb01176b4d136b9"));
var _CalendarView = _interopRequireDefault(require("c6d7418d11738229"));
var _dates = _interopRequireDefault(require("aa3eef9d4f78f97d"));
var _localizers = require("fefff10661639241");
var _ = require("cf7beb8730662c4");
var Props = _interopRequireWildcard(require("63f787b2127caf54"));
var CustomPropTypes = _interopRequireWildcard(require("90fb7e629e564dc1"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var CenturyView = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CenturyView, _React$Component);
    function CenturyView() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.renderRow = function(row, rowIdx) {
            var _this$props = _this.props, focused = _this$props.focused, activeId = _this$props.activeId, disabled = _this$props.disabled, onChange = _this$props.onChange, value = _this$props.value, today = _this$props.today, culture = _this$props.culture, min = _this$props.min, decadeFormat = _this$props.decadeFormat, max = _this$props.max;
            decadeFormat = _localizers.date.getFormat('decade', decadeFormat);
            return _react.default.createElement(_CalendarView.default.Row, {
                key: rowIdx
            }, row.map(function(date, colIdx) {
                var label = _localizers.date.format(_dates.default.startOf(date, 'decade'), decadeFormat, culture);
                return _react.default.createElement(_CalendarView.default.Cell, {
                    key: colIdx,
                    unit: "decade",
                    activeId: activeId,
                    label: label,
                    date: date,
                    now: today,
                    min: min,
                    max: max,
                    onChange: onChange,
                    focused: focused,
                    selected: value,
                    disabled: disabled
                }, label);
            }));
        };
        return _this;
    }
    var _proto = CenturyView.prototype;
    _proto.render = function render() {
        var _this$props2 = this.props, focused = _this$props2.focused, activeId = _this$props2.activeId;
        return _react.default.createElement(_CalendarView.default, _extends({}, Props.omitOwn(this), {
            activeId: activeId
        }), _react.default.createElement(_CalendarView.default.Body, null, (0, _.chunk)(getCenturyDecades(focused), 4).map(this.renderRow)));
    };
    return CenturyView;
}(_react.default.Component);
CenturyView.propTypes = {
    activeId: _propTypes.default.string,
    culture: _propTypes.default.string,
    today: _propTypes.default.instanceOf(Date),
    value: _propTypes.default.instanceOf(Date),
    focused: _propTypes.default.instanceOf(Date),
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    onChange: _propTypes.default.func.isRequired,
    decadeFormat: CustomPropTypes.dateFormat,
    disabled: _propTypes.default.bool
};
function getCenturyDecades(_date) {
    var days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ], date = _dates.default.add(_dates.default.startOf(_date, 'century'), -20, 'year');
    return days.map(function() {
        return date = _dates.default.add(date, 10, 'year');
    });
}
var _default = CenturyView;
exports.default = _default;
module.exports = exports["default"];

},{"2d65a1ea17eb64a0":"gVheC","8cb01176b4d136b9":"3KNJy","c6d7418d11738229":"j7hQF","aa3eef9d4f78f97d":"4EPGV","fefff10661639241":"hIvMI","cf7beb8730662c4":"lDW6z","63f787b2127caf54":"2s4vq","90fb7e629e564dc1":"8HlUx"}],"fEqYz":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.getMessages = getMessages;
var _react = _interopRequireDefault(require("c543f705256745c6"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var messages = {
    moveBack: 'Navigate back',
    moveForward: 'Navigate forward',
    dateButton: 'Select date',
    timeButton: 'Select time',
    openCombobox: 'open combobox',
    openDropdown: 'open dropdown',
    placeholder: '',
    filterPlaceholder: '',
    emptyList: 'There are no items in this list',
    emptyFilter: 'The filter returned no results',
    createOption: function createOption(_ref) {
        var searchTerm = _ref.searchTerm;
        return [
            ' Create option',
            searchTerm && ' ',
            searchTerm && _react.default.createElement("strong", {
                key: "_"
            }, "\"" + searchTerm + "\"")
        ];
    },
    tagsLabel: 'Selected items',
    removeLabel: 'Remove selected item',
    noneSelected: 'no selected items',
    selectedItems: function selectedItems(labels) {
        return "Selected items: " + labels.join(', ');
    },
    // number
    increment: 'Increment value',
    decrement: 'Decrement value'
};
function getMessages(defaults) {
    if (defaults === void 0) defaults = {};
    var processed = {};
    Object.keys(messages).forEach(function(message) {
        var value = defaults[message];
        if (value == null) value = messages[message];
        processed[message] = typeof value === 'function' ? value : function() {
            return value;
        };
    });
    return processed;
}

},{"c543f705256745c6":"gVheC"}],"l0yDT":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("7d28dfd5e8457a69"));
var _events = _interopRequireDefault(require("d545b9a9085c05b8"));
var _style = _interopRequireDefault(require("a5a04463234973ce"));
var _height = _interopRequireDefault(require("d0f0ecaecae41e6b"));
var _properties = require("e2c7376c5cbafb7");
var _propTypes = _interopRequireDefault(require("11d5472e8c969048"));
var _TransitionGroup = _interopRequireDefault(require("d5feb392abfef930"));
var _Transition = _interopRequireWildcard(require("c70e39c8111c688"));
var _react = _interopRequireDefault(require("9bdbfcfefbfd767a"));
var _reactDom = require("62f1c0ed7376fef4");
var Props = _interopRequireWildcard(require("9177ee8a2d3f2cc7"));
var _transitionStyle, _transitionClasses;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var DirectionPropType = _propTypes.default.oneOf([
    'left',
    'right',
    'top',
    'bottom'
]);
var transitionStyle = (_transitionStyle = {}, _transitionStyle[_Transition.ENTERING] = {
    position: 'absolute'
}, _transitionStyle[_Transition.EXITING] = {
    position: 'absolute'
}, _transitionStyle);
var transitionClasses = (_transitionClasses = {}, _transitionClasses[_Transition.ENTERED] = 'rw-calendar-transition-entered', _transitionClasses[_Transition.ENTERING] = 'rw-calendar-transition-entering', _transitionClasses[_Transition.EXITING] = 'rw-calendar-transition-exiting', _transitionClasses[_Transition.EXITED] = 'rw-calendar-transition-exited', _transitionClasses);
function parseDuration(node) {
    var str = (0, _style.default)(node, _properties.transitionDuration);
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
var SlideTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(SlideTransition, _React$Component);
    function SlideTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleTransitionEnd = function(node, done) {
            var duration = parseDuration(node) || 300;
            var handler = function handler() {
                _events.default.off(node, _properties.transitionEnd, handler, false);
                done();
            };
            setTimeout(handler, duration * 1.5);
            _events.default.on(node, _properties.transitionEnd, handler, false);
        };
        return _this;
    }
    var _proto = SlideTransition.prototype;
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, props = _objectWithoutProperties(_this$props, [
            "children"
        ]);
        var direction = this.context.direction;
        var child = _react.default.Children.only(children);
        return _react.default.createElement(_Transition.default, _extends({}, props, {
            timeout: 5000,
            addEndListener: this.handleTransitionEnd
        }), function(status, innerProps) {
            return _react.default.cloneElement(child, _extends({}, innerProps, {
                style: transitionStyle[status],
                className: (0, _classnames.default)(child.props.className, 'rw-calendar-transition', "rw-calendar-transition-" + direction, transitionClasses[status])
            }));
        });
    };
    return SlideTransition;
}(_react.default.Component);
SlideTransition.contextTypes = {
    direction: DirectionPropType
};
var SlideTransitionGroup = /*#__PURE__*/ function(_React$Component2) {
    _inheritsLoose(SlideTransitionGroup, _React$Component2);
    function SlideTransitionGroup() {
        var _this2;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _React$Component2.call.apply(_React$Component2, [
            this
        ].concat(args)) || this;
        _this2.handleEnter = function(child) {
            var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_assertThisInitialized(_this2)));
            if (!child) return;
            var height = (0, _height.default)(child) + 'px';
            (0, _style.default)(node, {
                height: height,
                overflow: 'hidden'
            });
        };
        _this2.handleExited = function() {
            var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_assertThisInitialized(_this2)));
            (0, _style.default)(node, {
                overflow: '',
                height: ''
            });
        };
        return _this2;
    }
    var _proto2 = SlideTransitionGroup.prototype;
    _proto2.getChildContext = function getChildContext() {
        return {
            direction: this.props.direction
        };
    };
    _proto2.render = function render() {
        var _this$props2 = this.props, children = _this$props2.children, direction = _this$props2.direction;
        return _react.default.createElement(_TransitionGroup.default, _extends({}, Props.omitOwn(this), {
            component: "div",
            className: "rw-calendar-transition-group"
        }), _react.default.createElement(SlideTransition, {
            key: children.key,
            direction: direction,
            onEnter: this.handleEnter,
            onExited: this.handleExited
        }, children));
    };
    return SlideTransitionGroup;
}(_react.default.Component);
SlideTransitionGroup.childContextTypes = {
    direction: DirectionPropType
};
SlideTransitionGroup.defaultProps = {
    direction: 'left'
};
SlideTransitionGroup.propTypes = {
    direction: DirectionPropType
};
var _default = SlideTransitionGroup;
exports.default = _default;
module.exports = exports["default"];

},{"7d28dfd5e8457a69":"6P5cq","d545b9a9085c05b8":"ipwsW","a5a04463234973ce":"jZvdW","d0f0ecaecae41e6b":"hhPzJ","e2c7376c5cbafb7":"7R9cR","11d5472e8c969048":"3KNJy","d5feb392abfef930":"3VUbg","c70e39c8111c688":"1qmG6","9bdbfcfefbfd767a":"gVheC","62f1c0ed7376fef4":"d8jlt","9177ee8a2d3f2cc7":"2s4vq"}],"3VUbg":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("226a2406d28d54fa"));
var _react = _interopRequireDefault(require("812ffed903f56470"));
var _reactLifecyclesCompat = require("bd24a80ef34b0414");
var _ChildMapping = require("7fbe5a91ebb2e280");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = _extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return _react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}(_react.default.Component);
TransitionGroup.childContextTypes = {
    transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
exports.default = _default;
module.exports = exports["default"];

},{"226a2406d28d54fa":"3KNJy","812ffed903f56470":"gVheC","bd24a80ef34b0414":"3F3XD","7fbe5a91ebb2e280":"Qnk4z"}],"Qnk4z":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;
var _react = require("487c95fd3afb1e69");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) _react.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"487c95fd3afb1e69":"gVheC"}],"htUOG":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = createFocusManager;
var _reactComponentManagers = require("abc3c02bbe14a0b");
var _interaction = require("9fc07af71b687aaa");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function createFocusManager(inst, options) {
    var _didHandle = options.didHandle;
    return (0, _reactComponentManagers.focusManager)(inst, _extends({}, options, {
        onChange: function onChange(focused) {
            inst.setState({
                focused: focused
            });
        },
        isDisabled: function isDisabled() {
            return inst.props.disabled === true || (0, _interaction.isInDisabledFieldset)(inst);
        },
        didHandle: function didHandle(focused, event) {
            var handler = this.props[focused ? 'onFocus' : 'onBlur'];
            handler && handler(event);
            if (_didHandle && !event.isWidgetDefaultPrevented) _didHandle(focused, event);
        }
    }));
}
module.exports = exports["default"];

},{"abc3c02bbe14a0b":"bMv3b","9fc07af71b687aaa":"qGuYY"}],"qGuYY":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.widgetEditable = exports.widgetEnabled = exports.isInDisabledFieldset = void 0;
var _reactDom = require("ae9d9891e5037cd3");
var _matches = _interopRequireDefault(require("1c21330ebf71ba13"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isInDisabledFieldset = function isInDisabledFieldset(inst) {
    var node;
    try {
        node = (0, _reactDom.findDOMNode)(inst);
    } catch (err) {
    /* ignore */ }
    return !!node && (0, _matches.default)(node, 'fieldset[disabled] *');
};
exports.isInDisabledFieldset = isInDisabledFieldset;
var widgetEnabled = interactionDecorator(true);
exports.widgetEnabled = widgetEnabled;
var widgetEditable = interactionDecorator(false);
exports.widgetEditable = widgetEditable;
function interactionDecorator(disabledOnly) {
    function wrap(method) {
        return function decoratedMethod() {
            var _this$props = this.props, disabled = _this$props.disabled, readOnly = _this$props.readOnly;
            disabled = isInDisabledFieldset(this) || disabled == true || !disabledOnly && readOnly === true;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!disabled) return method.apply(this, args);
        };
    }
    return function decorate(target, key, desc) {
        if (desc.initializer) {
            var init = desc.initializer;
            desc.initializer = function() {
                return wrap(init.call(this)).bind(this);
            };
        } else desc.value = wrap(desc.value);
        return desc;
    };
}

},{"ae9d9891e5037cd3":"d8jlt","1c21330ebf71ba13":"lNn4D"}],"lNn4D":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("36ba576a82c1be93");
exports.__esModule = true;
exports.default = matches;
var _inDOM = _interopRequireDefault(require("9ab8d6c975ba0e0d"));
var _querySelectorAll = _interopRequireDefault(require("73588c6f1f88cb2b"));
var matchesCache;
function matches(node, selector) {
    if (!matchesCache && _inDOM.default) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        matchesCache = nativeMatch ? function matchesCache(node, selector) {
            return nativeMatch.call(node, selector);
        } : ie8MatchesSelector;
    }
    return matchesCache ? matchesCache(node, selector) : null;
}
function ie8MatchesSelector(node, selector) {
    var _$matches = (0, _querySelectorAll.default)(node.document || node.ownerDocument, selector), i = 0;
    while(_$matches[i] && _$matches[i] !== node)i++;
    return !!_$matches[i];
}
module.exports = exports["default"];

},{"36ba576a82c1be93":"6zI5d","9ab8d6c975ba0e0d":"3hMod","73588c6f1f88cb2b":"5N9WT"}],"fu3eM":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.notify = notify;
exports.instanceId = instanceId;
exports.isFirstFocusedRender = isFirstFocusedRender;
var idCount = 0;
function uniqueId(prefix) {
    return '' + ((prefix == null ? '' : prefix) + ++idCount);
}
function notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
function instanceId(component, suffix) {
    if (suffix === void 0) suffix = '';
    component.__id || (component.__id = uniqueId('rw_'));
    return (component.props.id || component.__id) + suffix;
}
/**
 * Allows for defering popup rendering untill the widget is focused,
 * or has been opened (in order to not remove it suddenly on close)
 */ function isFirstFocusedRender(component) {
    return component._firstFocus || (component.state.focused || !!component.props.open) && (component._firstFocus = true);
}

},{}],"5dCQF":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("1767fb715338eb60"));
var _react = _interopRequireDefault(require("b46199e1fc6490b0"));
var _reactLifecyclesCompat = require("2981b932843e3a72");
var _reactDom = require("10190eeb5da5197");
var _Input = _interopRequireDefault(require("67f6a881f1a2e8da"));
var _localizers = require("7a349ed9be9ccf78");
var CustomPropTypes = _interopRequireWildcard(require("54a8006d2cb3ed39"));
var Props = _interopRequireWildcard(require("8e4608a2e553f57c"));
var _class, _class2, _temp;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var DateTimePickerInput = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp = _class2 = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(DateTimePickerInput, _React$Component);
    function DateTimePickerInput() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {};
        _this.handleBlur = function(event) {
            var _this$props = _this.props, format = _this$props.format, culture = _this$props.culture, parse = _this$props.parse, onChange = _this$props.onChange, onBlur = _this$props.onBlur;
            onBlur && onBlur(event);
            if (_this._needsFlush) {
                var date = parse(event.target.value);
                var dateIsInvalid = event.target.value != '' && date == null;
                if (dateIsInvalid) _this.setState({
                    textValue: ''
                });
                _this._needsFlush = false;
                onChange(date, formatDate(date, format, culture));
            }
        };
        _this.handleChange = function(_ref) {
            var value = _ref.target.value;
            _this._needsFlush = true;
            _this.setState({
                textValue: value
            });
        };
        return _this;
    }
    DateTimePickerInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var value = nextProps.value, editing = nextProps.editing, editFormat = nextProps.editFormat, format = nextProps.format, culture = nextProps.culture;
        var textValue = formatDate(value, editing && editFormat ? editFormat : format, culture);
        if (prevState.lastValueFromProps !== textValue) return {
            textValue: textValue,
            lastValueFromProps: textValue
        };
        return null;
    };
    var _proto = DateTimePickerInput.prototype;
    _proto.focus = function focus() {
        (0, _reactDom.findDOMNode)(this).focus();
    };
    _proto.render = function render() {
        var _this$props2 = this.props, disabled = _this$props2.disabled, readOnly = _this$props2.readOnly;
        var textValue = this.state.textValue;
        var props = Props.omitOwn(this);
        return _react.default.createElement(_Input.default, _extends({}, props, {
            type: "text",
            className: "rw-widget-input",
            value: textValue,
            disabled: disabled,
            readOnly: readOnly,
            onChange: this.handleChange,
            onBlur: this.handleBlur
        }));
    };
    return DateTimePickerInput;
}(_react.default.Component), _class2.propTypes = {
    format: CustomPropTypes.dateFormat.isRequired,
    editing: _propTypes.default.bool,
    editFormat: CustomPropTypes.dateFormat,
    parse: _propTypes.default.func.isRequired,
    value: _propTypes.default.instanceOf(Date),
    onChange: _propTypes.default.func.isRequired,
    onBlur: _propTypes.default.func,
    culture: _propTypes.default.string,
    disabled: CustomPropTypes.disabled,
    readOnly: CustomPropTypes.disabled
}, _temp)) || _class;
var _default = DateTimePickerInput;
exports.default = _default;
function isValid(d) {
    return !isNaN(d.getTime());
}
function formatDate(date, format, culture) {
    var val = '';
    if (date instanceof Date && isValid(date)) val = _localizers.date.format(date, format, culture);
    return val;
}
module.exports = exports["default"];

},{"1767fb715338eb60":"3KNJy","b46199e1fc6490b0":"gVheC","2981b932843e3a72":"3F3XD","10190eeb5da5197":"d8jlt","67f6a881f1a2e8da":"iwPB6","7a349ed9be9ccf78":"hIvMI","54a8006d2cb3ed39":"8HlUx","8e4608a2e553f57c":"2s4vq"}],"iwPB6":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("400b93486a596d49"));
var _propTypes = _interopRequireDefault(require("23d20bc5cbb765e8"));
var _classnames = _interopRequireDefault(require("8a8e7d2514d835e8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
Input.propTypes = {
    disabled: _propTypes.default.bool,
    readOnly: _propTypes.default.bool,
    value: _propTypes.default.string,
    type: _propTypes.default.string,
    tabIndex: _propTypes.default.string,
    component: _propTypes.default.any,
    nodeRef: _propTypes.default.func
};
function Input(_ref) {
    var className = _ref.className, disabled = _ref.disabled, readOnly = _ref.readOnly, value = _ref.value, tabIndex = _ref.tabIndex, nodeRef = _ref.nodeRef, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'input' : _ref$component, props = _objectWithoutProperties(_ref, [
        "className",
        "disabled",
        "readOnly",
        "value",
        "tabIndex",
        "nodeRef",
        "type",
        "component"
    ]);
    return _react.default.createElement(Component, _extends({}, props, {
        type: type,
        ref: nodeRef,
        tabIndex: tabIndex || 0,
        autoComplete: "off",
        disabled: disabled,
        readOnly: readOnly,
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        value: value == null ? '' : value,
        className: (0, _classnames.default)(className, 'rw-input')
    }));
}
var _default = Input;
exports.default = _default;
module.exports = exports["default"];

},{"400b93486a596d49":"gVheC","23d20bc5cbb765e8":"3KNJy","8a8e7d2514d835e8":"6P5cq"}],"iRwQF":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("cd73390b109d8231"));
var _propTypes = _interopRequireDefault(require("fce7cce34e6744b1"));
var _classnames = _interopRequireDefault(require("56ca4b76ce034da0"));
var _Button = _interopRequireDefault(require("a5bc19950612f138"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var Select = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Select, _React$Component);
    function Select() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Select.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, bordered = _this$props.bordered, children = _this$props.children, props = _objectWithoutProperties(_this$props, [
            "className",
            "bordered",
            "children"
        ]);
        return _react.default.createElement("span", {
            className: (0, _classnames.default)(className, 'rw-select', bordered && 'rw-select-bordered')
        }, children ? _react.default.Children.map(children, function(child) {
            return child && _react.default.cloneElement(child, {
                variant: 'select'
            });
        }) : _react.default.createElement(_Button.default, _extends({}, props, {
            variant: "select"
        })));
    };
    return Select;
}(_react.default.Component);
Select.propTypes = {
    bordered: _propTypes.default.bool
};
var _default = Select;
exports.default = _default;
module.exports = exports["default"];

},{"cd73390b109d8231":"gVheC","fce7cce34e6744b1":"3KNJy","56ca4b76ce034da0":"6P5cq","a5bc19950612f138":"6M58T"}],"erMc2":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("510576fafca7f2d6"));
var _reactLifecyclesCompat = require("82267d18b8409bd5");
var _propTypes = _interopRequireDefault(require("1f9bf8dc25f759c5"));
var _List = _interopRequireDefault(require("8a035fef6b152f4b"));
var _dates = _interopRequireDefault(require("a2d7ce59df2ad764"));
var _reduceToListState = _interopRequireDefault(require("5f37ca623c9472f"));
var _localizers = require("8bc98052b3371406");
var CustomPropTypes = _interopRequireWildcard(require("bd95b37174c981d1"));
var _class, _class2, _temp;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var format = function format(props) {
    return _localizers.date.getFormat('time', props.format);
};
var accessors = {
    text: function text(item) {
        return item.label;
    },
    value: function value(item) {
        return item.date;
    }
};
var find = function find(arr, fn) {
    for(var i = 0; i < arr.length; i++){
        if (fn(arr[i])) return arr[i];
    }
    return null;
};
function getBounds(_ref) {
    var min = _ref.min, max = _ref.max, currentDate = _ref.currentDate, value = _ref.value, preserveDate = _ref.preserveDate;
    //compare just the time regradless of whether they fall on the same day
    if (!preserveDate) {
        var _start = _dates.default.startOf(_dates.default.merge(new Date(), min, currentDate), 'minutes');
        var _end = _dates.default.startOf(_dates.default.merge(new Date(), max, currentDate), 'minutes');
        if (_dates.default.lte(_end, _start) && _dates.default.gt(max, min, 'day')) _end = _dates.default.tomorrow();
        return {
            min: _start,
            max: _end
        };
    }
    var start = _dates.default.today();
    var end = _dates.default.tomorrow();
    value = value || currentDate || start; //date parts are equal
    return {
        min: _dates.default.eq(value, min, 'day') ? _dates.default.merge(start, min, currentDate) : start,
        max: _dates.default.eq(value, max, 'day') ? _dates.default.merge(start, max, currentDate) : end
    };
}
function getDates(_ref2) {
    var step = _ref2.step, culture = _ref2.culture, props = _objectWithoutProperties(_ref2, [
        "step",
        "culture"
    ]);
    var times = [];
    var _getBounds = getBounds(props), min = _getBounds.min, max = _getBounds.max;
    var startDay = _dates.default.date(min);
    while(_dates.default.date(min) === startDay && _dates.default.lte(min, max)){
        times.push({
            date: min,
            label: _localizers.date.format(min, format(props), culture)
        });
        min = _dates.default.add(min, step || 30, 'minutes');
    }
    return times;
}
var TimeList = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp = _class2 = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TimeList, _React$Component);
    function TimeList() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {};
        _this.handleKeyDown = function(e) {
            var key = e.key;
            var _this$state = _this.state, focusedItem = _this$state.focusedItem, list = _this$state.list;
            if (key === 'End') {
                e.preventDefault();
                _this.setState({
                    focusedItem: list.last()
                });
            } else if (key === 'Home') {
                e.preventDefault();
                _this.setState({
                    focusedItem: list.first()
                });
            } else if (key === 'Enter') _this.props.onSelect(focusedItem);
            else if (key === 'ArrowDown') {
                e.preventDefault();
                _this.setState({
                    focusedItem: list.next(focusedItem)
                });
            } else if (key === 'ArrowUp') {
                e.preventDefault();
                _this.setState({
                    focusedItem: list.prev(focusedItem)
                });
            }
        };
        return _this;
    }
    TimeList.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var value = nextProps.value, currentDate = nextProps.currentDate, step = nextProps.step;
        var data = getDates(nextProps);
        var currentValue = value || currentDate;
        var valueChanged = !prevState.lastValue || !_dates.default.eq(currentValue, prevState.lastValue, 'minutes');
        var list = (0, _reduceToListState.default)(data, prevState.list, {
            nextProps: nextProps
        });
        var selectedItem = find(data, function(t) {
            return _dates.default.eq(t.date, currentValue, 'minutes');
        });
        var closestDate = find(data, function(t) {
            var relativeDate = new Date(t.date);
            relativeDate.setFullYear(currentValue.getFullYear(), currentValue.getMonth(), currentValue.getDate());
            var diff = _dates.default.diff(relativeDate, currentValue, 'minutes');
            return Math.abs(diff) < step;
        });
        return {
            data: data,
            list: list,
            lastValue: currentValue,
            selectedItem: list.nextEnabled(selectedItem),
            focusedItem: valueChanged || !prevState.focusedItem ? list.nextEnabled(selectedItem || closestDate || data[0]) : find(data, function(t) {
                return _dates.default.eq(t.date, prevState.focusedItem.date, 'minutes');
            })
        };
    };
    var _proto = TimeList.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
    };
    _proto.render = function render() {
        var _this$props = this.props, listProps = _this$props.listProps, props = _objectWithoutProperties(_this$props, [
            "listProps"
        ]);
        var _this$state2 = this.state, data = _this$state2.data, list = _this$state2.list, focusedItem = _this$state2.focusedItem, selectedItem = _this$state2.selectedItem;
        delete props.currentDate;
        delete props.min;
        delete props.max;
        delete props.step;
        delete props.format;
        delete props.culture;
        delete props.preserveDate;
        delete props.value;
        return _react.default.createElement(_List.default, _extends({}, props, listProps, {
            data: data,
            dataState: list.dataState,
            isDisabled: list.isDisabled,
            textAccessor: accessors.text,
            valueAccessor: accessors.value,
            selectedItem: selectedItem,
            focusedItem: focusedItem
        }));
    };
    return TimeList;
}(_react.default.Component), _class2.defaultProps = {
    step: 30,
    currentDate: new Date(),
    min: new Date(1900, 0, 1),
    max: new Date(2099, 11, 31),
    preserveDate: true
}, _class2.propTypes = {
    value: _propTypes.default.instanceOf(Date),
    step: _propTypes.default.number,
    min: _propTypes.default.instanceOf(Date),
    max: _propTypes.default.instanceOf(Date),
    currentDate: _propTypes.default.instanceOf(Date),
    itemComponent: CustomPropTypes.elementType,
    listProps: _propTypes.default.object,
    format: CustomPropTypes.dateFormat,
    onSelect: _propTypes.default.func,
    preserveDate: _propTypes.default.bool,
    culture: _propTypes.default.string
}, _temp)) || _class;
var _default = TimeList;
exports.default = _default;
module.exports = exports["default"];

},{"510576fafca7f2d6":"gVheC","82267d18b8409bd5":"3F3XD","1f9bf8dc25f759c5":"3KNJy","8a035fef6b152f4b":"l4cBu","a2d7ce59df2ad764":"4EPGV","5f37ca623c9472f":"dlO4J","8bc98052b3371406":"hIvMI","bd95b37174c981d1":"8HlUx"}],"l4cBu":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("64d3df01bdc94b2c"));
var _react = _interopRequireDefault(require("a3481ba2ce1e0a9f"));
var _reactDom = require("932ac1d7b3c9c79e");
var CustomPropTypes = _interopRequireWildcard(require("7d14f86b7b39df39"));
var Props = _interopRequireWildcard(require("4ecb30b3c929140e"));
var _widgetHelpers = require("8db25e66d684e0fa");
var _reduceToListState = require("e16aefe4423087c3");
var _Listbox = _interopRequireDefault(require("b0538e4bc7fe625c"));
var _ListOption = _interopRequireDefault(require("c531e7337ed895b"));
var _ListOptionGroup = _interopRequireDefault(require("a8ccca785f0addae"));
var _messages = require("d55e4dff138b4830");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var EMPTY_DATA_STATE = {};
var propTypes = {
    data: _propTypes.default.array,
    dataState: _propTypes.default.shape({
        sortedKeys: _propTypes.default.array,
        groups: _propTypes.default.object,
        data: _propTypes.default.array,
        sequentialData: _propTypes.default.array
    }),
    valueAccessor: CustomPropTypes.accessor,
    textAccessor: CustomPropTypes.accessor,
    onSelect: _propTypes.default.func,
    onMove: _propTypes.default.func,
    activeId: _propTypes.default.string,
    itemComponent: CustomPropTypes.elementType,
    groupComponent: CustomPropTypes.elementType,
    optionComponent: CustomPropTypes.elementType,
    renderItem: _propTypes.default.func,
    renderGroup: _propTypes.default.func,
    focusedItem: _propTypes.default.any,
    selectedItem: _propTypes.default.any,
    searchTerm: _propTypes.default.string,
    isDisabled: _propTypes.default.func.isRequired,
    messages: _propTypes.default.shape({
        emptyList: _propTypes.default.func.isRequired
    })
};
var defaultProps = {
    onSelect: function onSelect() {},
    data: [],
    dataState: EMPTY_DATA_STATE,
    optionComponent: _ListOption.default
};
var List = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(List, _React$Component);
    function List() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.renderItem = function(_ref) {
            var item = _ref.item, rest = _objectWithoutProperties(_ref, [
                "item"
            ]);
            var _this$props = _this.props, isDisabled = _this$props.isDisabled, renderItem = _this$props.renderItem, textAccessor = _this$props.textAccessor, valueAccessor = _this$props.valueAccessor;
            var Component = _this.props.itemComponent;
            if (renderItem) return renderItem(_extends({
                item: item
            }, rest));
            else if (Component) return _react.default.createElement(Component, _extends({
                item: item,
                value: valueAccessor(item),
                text: textAccessor(item),
                disabled: isDisabled(item)
            }, rest));
            return textAccessor(item);
        };
        _this.renderGroup = function(group) {
            var _this$props2 = _this.props, renderGroup = _this$props2.renderGroup, Component = _this$props2.groupComponent;
            if (renderGroup) return renderGroup({
                group: group
            });
            else if (Component) return _react.default.createElement(Component, {
                item: group
            });
            return group;
        };
        return _this;
    }
    var _proto = List.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.move();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.move();
    };
    _proto.mapItems = function mapItems(fn) {
        var _this$props3 = this.props, data = _this$props3.data, dataState = _this$props3.dataState;
        var sortedKeys = dataState.sortedKeys, groups = dataState.groups;
        if (!groups) return data.map(function(item, idx) {
            return fn(item, idx, false);
        });
        var idx = -1;
        return sortedKeys.reduce(function(items, key) {
            var group = groups[key];
            return items.concat(fn(key, idx, true), group.map(function(item) {
                return fn(item, ++idx, false);
            }));
        }, []);
    };
    _proto.move = function move() {
        var _this$props4 = this.props, focusedItem = _this$props4.focusedItem, onMove = _this$props4.onMove, data = _this$props4.data, dataState = _this$props4.dataState;
        var list = (0, _reactDom.findDOMNode)(this);
        var idx = renderedIndexOf(focusedItem, list, data, dataState);
        var selectedItem = list.children[idx];
        if (selectedItem) (0, _widgetHelpers.notify)(onMove, [
            selectedItem,
            list,
            focusedItem
        ]);
    };
    _proto.renderOption = function renderOption(item, index) {
        var _this$props5 = this.props, activeId = _this$props5.activeId, focusedItem = _this$props5.focusedItem, selectedItem = _this$props5.selectedItem, onSelect = _this$props5.onSelect, isDisabled = _this$props5.isDisabled, searchTerm = _this$props5.searchTerm, Option = _this$props5.optionComponent;
        var isFocused = focusedItem === item;
        return _react.default.createElement(Option, {
            dataItem: item,
            key: 'item_' + index,
            index: index,
            activeId: activeId,
            focused: isFocused,
            onSelect: onSelect,
            disabled: isDisabled(item),
            selected: selectedItem === item
        }, this.renderItem({
            item: item,
            index: index,
            searchTerm: searchTerm
        }));
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props6 = this.props, className = _this$props6.className, messages = _this$props6.messages;
        var elementProps = Props.pickElementProps(this);
        var _getMessages = (0, _messages.getMessages)(messages), emptyList = _getMessages.emptyList;
        return _react.default.createElement(_Listbox.default, _extends({}, elementProps, {
            className: className,
            emptyListMessage: emptyList(this.props)
        }), this.mapItems(function(item, idx, isHeader) {
            return isHeader ? _react.default.createElement(_ListOptionGroup.default, {
                key: 'group_' + item,
                group: item
            }, _this2.renderGroup(item)) : _this2.renderOption(item, idx);
        }));
    };
    return List;
}(_react.default.Component);
List.getDataState = _reduceToListState.defaultGetDataState;
function renderedIndexOf(item, list, data, dataState) {
    var groups = dataState.groups, sortedKeys = dataState.sortedKeys;
    if (!groups) return data.indexOf(item);
    var runningIdx = -1;
    var idx = -1;
    sortedKeys.some(function(group) {
        var itemIdx = groups[group].indexOf(item);
        runningIdx++;
        if (itemIdx !== -1) {
            idx = runningIdx + itemIdx + 1;
            return true;
        }
        runningIdx += groups[group].length;
    });
    return idx;
}
List.propTypes = propTypes;
List.defaultProps = defaultProps;
var _default = List;
exports.default = _default;
module.exports = exports["default"];

},{"64d3df01bdc94b2c":"3KNJy","a3481ba2ce1e0a9f":"gVheC","932ac1d7b3c9c79e":"d8jlt","7d14f86b7b39df39":"8HlUx","4ecb30b3c929140e":"2s4vq","8db25e66d684e0fa":"fu3eM","e16aefe4423087c3":"dlO4J","b0538e4bc7fe625c":"5xc41","c531e7337ed895b":"CNE20","a8ccca785f0addae":"kewuP","d55e4dff138b4830":"fEqYz"}],"dlO4J":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.defaultGetDataState = defaultGetDataState;
exports.getCommonListProps = getCommonListProps;
exports.default = reduceToListState;
var _Filter = require("f937f3074af45f8b");
var _ = require("f3aac07a87e906fe");
var _dataHelpers = require("42ac9bdec2280ace");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var EMPTY_VALUE = {};
var returnFalse = function returnFalse() {
    return false;
};
function defaultGetDataState(data, _ref, lastState) {
    var groupBy = _ref.groupBy;
    if (lastState === void 0) lastState = {};
    if (lastState.data !== data || lastState.groupBy !== groupBy) {
        if (!groupBy) return {};
        var keys = [];
        var groups = (0, _.groupBySortedKeys)(groupBy, data, keys);
        return {
            data: data,
            groupBy: groupBy,
            groups: groups,
            sortedKeys: keys,
            sequentialData: Object.keys(groups).reduce(function(flat, grp) {
                return flat.concat(groups[grp]);
            }, [])
        };
    }
    return lastState;
}
var getStateGetterFromList = function getStateGetterFromList(_ref2) {
    var l = _ref2.listComponent;
    return l && l.getDataState;
};
var getIsDisabled = function getIsDisabled(disabledProp, valueField) {
    return !Array.isArray(disabledProp) ? returnFalse : function(item) {
        return disabledProp.some(function(i) {
            return (0, _dataHelpers.dataValue)(item, valueField) === (0, _dataHelpers.dataValue)(i, valueField);
        });
    };
};
function getCommonListProps(list, accessors, _ref3) {
    var groupBy = _ref3.groupBy, optionComponent = _ref3.optionComponent, itemComponent = _ref3.itemComponent, groupComponent = _ref3.groupComponent, searchTerm = _ref3.searchTerm, listProps = _ref3.listProps;
    return _extends({
        searchTerm: searchTerm,
        groupBy: groupBy,
        groupComponent: groupComponent,
        itemComponent: itemComponent,
        optionComponent: optionComponent
    }, listProps, {
        data: list.data,
        dataState: list.state,
        textAccessor: accessors.text,
        valueAccessor: accessors.value
    });
}
function reduceToListState(nextListData, prevList, _temp) {
    var _ref4 = _temp === void 0 ? {} : _temp, nextProps = _ref4.nextProps, getDataState = _ref4.getDataState;
    var disabled = nextProps.disabled, valueField = nextProps.valueField, textField = nextProps.textField;
    getDataState = getDataState || getStateGetterFromList(nextProps) || defaultGetDataState;
    var dataState = getDataState(nextListData, nextProps, prevList && prevList.dataState);
    var data = dataState && dataState.sequentialData || nextListData;
    var isDisabled = getIsDisabled(disabled, valueField);
    var moveNext = function moveNext(item, word) {
        return isDisabled(item) || word && !_Filter.presets.startsWith((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word.toLowerCase());
    };
    var list = {
        dataState: dataState,
        isDisabled: isDisabled,
        first: function first() {
            return list.next(EMPTY_VALUE);
        },
        last: function last() {
            return list.prevEnabled(data[data.length - 1]);
        },
        prev: function prev(item, word) {
            var nextIdx = Math.max(0, data.indexOf(item)) - 1;
            while(nextIdx > -1 && moveNext(data[nextIdx], word))nextIdx--;
            if (nextIdx >= 0) return data[nextIdx];
            return isDisabled(item) ? null : item;
        },
        next: function next(item, word) {
            var nextIdx = data.indexOf(item) + 1;
            while(nextIdx < data.length && moveNext(data[nextIdx], word))nextIdx++;
            if (nextIdx < data.length) return data[nextIdx];
            return isDisabled(item) ? null : item;
        },
        prevEnabled: function prevEnabled(item) {
            return isDisabled(item) ? list.prev(item) : item;
        },
        nextEnabled: function nextEnabled(item) {
            return isDisabled(item) ? list.next(item) : item;
        }
    };
    return list;
}

},{"f937f3074af45f8b":"cJxm3","f3aac07a87e906fe":"lDW6z","42ac9bdec2280ace":"7jDuP"}],"cJxm3":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.indexOf = indexOf;
exports.filter = filter;
exports.suggest = suggest;
exports.propTypes = exports.presets = void 0;
var _propTypes = _interopRequireDefault(require("236f0b5fe1506cd4"));
var CustomPropTypes = _interopRequireWildcard(require("9361ce7643f45b24"));
var _dataHelpers = require("b1002342b32481c2");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var presets = {
    eq: function eq(a, b) {
        return a === b;
    },
    neq: function neq(a, b) {
        return a !== b;
    },
    gt: function gt(a, b) {
        return a > b;
    },
    gte: function gte(a, b) {
        return a >= b;
    },
    lt: function lt(a, b) {
        return a < b;
    },
    lte: function lte(a, b) {
        return a <= b;
    },
    contains: function contains(a, b) {
        return a.indexOf(b) !== -1;
    },
    startsWith: function startsWith(a, b) {
        return a.lastIndexOf(b, 0) === 0;
    },
    endsWith: function endsWith(a, b) {
        var pos = a.length - b.length;
        var lastIndex = a.indexOf(b, pos);
        return lastIndex !== -1 && lastIndex === pos;
    }
};
exports.presets = presets;
function normalizeFilterType(type) {
    if (type === false) return null;
    if (type === true) return 'startsWith';
    return type || 'eq';
}
function normalizeFilter(_ref) {
    var _$filter = _ref.filter, _ref$caseSensitive = _ref.caseSensitive, caseSensitive = _ref$caseSensitive === void 0 ? false : _ref$caseSensitive, textField = _ref.textField;
    _$filter = normalizeFilterType(_$filter);
    if (typeof _$filter === 'function' || !_$filter) return _$filter;
    _$filter = presets[_$filter];
    return function(item, searchTerm) {
        var textValue = (0, _dataHelpers.dataText)(item, textField);
        if (!caseSensitive) {
            textValue = textValue.toLowerCase();
            searchTerm = searchTerm.toLowerCase();
        }
        return _$filter(textValue, searchTerm);
    };
}
function normalizeOptions(nextOptions) {
    var options = _extends({}, nextOptions);
    options.minLengh = options.minLengh || 0;
    options.filter = normalizeFilter(options);
    return options;
}
var propTypes = {
    textField: CustomPropTypes.accessor,
    caseSensitive: _propTypes.default.bool,
    minLength: _propTypes.default.number,
    filter: _propTypes.default.oneOfType([
        _propTypes.default.func,
        _propTypes.default.bool,
        _propTypes.default.oneOf(Object.keys(presets))
    ])
};
exports.propTypes = propTypes;
function indexOf(data, _ref2) {
    var _ref2$searchTerm = _ref2.searchTerm, searchTerm = _ref2$searchTerm === void 0 ? '' : _ref2$searchTerm, options = _objectWithoutProperties(_ref2, [
        "searchTerm"
    ]);
    var _normalizeOptions = normalizeOptions(options), _$filter = _normalizeOptions.filter, minLength = _normalizeOptions.minLength;
    if (!_$filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return -1;
    for(var idx = 0; idx < data.length; idx++){
        if (_$filter(data[idx], searchTerm, idx)) return idx;
    }
    return -1;
}
function filter(data, _ref3) {
    var _ref3$searchTerm = _ref3.searchTerm, searchTerm = _ref3$searchTerm === void 0 ? '' : _ref3$searchTerm, options = _objectWithoutProperties(_ref3, [
        "searchTerm"
    ]);
    var _normalizeOptions2 = normalizeOptions(options), _$filter = _normalizeOptions2.filter, minLength = _normalizeOptions2.minLength;
    if (!_$filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return data;
    return data.filter(function(item, idx) {
        return _$filter(item, searchTerm, idx);
    });
}
function suggest(data, _ref4) {
    var _ref4$searchTerm = _ref4.searchTerm, searchTerm = _ref4$searchTerm === void 0 ? '' : _ref4$searchTerm, options = _objectWithoutProperties(_ref4, [
        "searchTerm"
    ]);
    var _normalizeOptions3 = normalizeOptions(options), _$filter = _normalizeOptions3.filter, minLength = _normalizeOptions3.minLength;
    if (!_$filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return searchTerm;
    for(var idx = 0; idx < data.length; idx++){
        if (_$filter(data[idx], searchTerm, idx)) return data[idx];
    }
    return searchTerm;
}

},{"236f0b5fe1506cd4":"3KNJy","9361ce7643f45b24":"8HlUx","b1002342b32481c2":"7jDuP"}],"7jDuP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
exports.__esModule = true;
exports.dataIndexOf = dataIndexOf;
exports.valueMatcher = valueMatcher;
exports.dataItem = dataItem;
exports.dataText = exports.dataValue = void 0;
var _ = require("3af520a223ea0fd5");
var dataValue = function dataValue(data, field) {
    var value = data;
    if (typeof field === 'function') value = field(data);
    else if (data == null) value = data;
    else if (typeof field === 'string' && (typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' && field in data) value = data[field];
    return value;
};
exports.dataValue = dataValue;
var dataText = function dataText(item, textField) {
    var value = dataValue(item, textField);
    return value == null ? '' : value + '';
};
exports.dataText = dataText;
function dataIndexOf(data, item, valueField) {
    var idx = -1;
    var isValueEqual = function isValueEqual(datum) {
        return valueMatcher(item, datum, valueField);
    };
    while(++idx < data.length){
        var datum = data[idx];
        if (datum === item || isValueEqual(datum)) return idx;
    }
    return -1;
}
/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */ function valueMatcher(a, b, valueField) {
    return (0, _.isShallowEqual)(dataValue(a, valueField), dataValue(b, valueField));
}
function dataItem(data, item, valueField) {
    var idx = dataIndexOf(data, item, valueField);
    return idx !== -1 ? data[idx] : item;
}

},{"@swc/helpers/_/_type_of":"668P4","3af520a223ea0fd5":"lDW6z"}],"5xc41":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("8a952dabaaebab9f"));
var _propTypes = _interopRequireDefault(require("b99ce9bced58fcb6"));
var _classnames = _interopRequireDefault(require("bfdb7f95b28ebd70"));
var _widgetHelpers = require("ba9e423829b01b4a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var propTypes = {
    className: _propTypes.default.string,
    role: _propTypes.default.string,
    nodeRef: _propTypes.default.func,
    emptyListMessage: _propTypes.default.node
};
var Listbox = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Listbox, _React$Component);
    function Listbox() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Listbox.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, role = _this$props.role, children = _this$props.children, emptyListMessage = _this$props.emptyListMessage, nodeRef = _this$props.nodeRef, props = _objectWithoutProperties(_this$props, [
            "className",
            "role",
            "children",
            "emptyListMessage",
            "nodeRef"
        ]);
        var id = (0, _widgetHelpers.instanceId)(this);
        return _react.default.createElement("ul", _extends({
            id: id,
            tabIndex: "-1",
            ref: nodeRef,
            className: (0, _classnames.default)(className, 'rw-list'),
            role: role === undefined ? 'listbox' : role
        }, props), _react.default.Children.count(children) ? children : _react.default.createElement("li", {
            className: "rw-list-empty"
        }, emptyListMessage));
    };
    return Listbox;
}(_react.default.Component);
Listbox.propTypes = propTypes;
var _default = Listbox;
exports.default = _default;
module.exports = exports["default"];

},{"8a952dabaaebab9f":"gVheC","b99ce9bced58fcb6":"3KNJy","bfdb7f95b28ebd70":"6P5cq","ba9e423829b01b4a":"fu3eM"}],"CNE20":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("d796396dd50939d6"));
var _propTypes = _interopRequireDefault(require("49f97b91daa5bf30"));
var _classnames = _interopRequireDefault(require("fa3d9bfb8f7038a9"));
var Props = _interopRequireWildcard(require("9acb4cb4b2b59752"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var ListOption = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ListOption, _React$Component);
    function ListOption() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleSelect = function(event) {
            var _this$props = _this.props, onSelect = _this$props.onSelect, disabled = _this$props.disabled, dataItem = _this$props.dataItem;
            if (onSelect && !disabled) onSelect(dataItem, event);
        };
        return _this;
    }
    var _proto = ListOption.prototype;
    _proto.render = function render() {
        var _this$props2 = this.props, className = _this$props2.className, children = _this$props2.children, focused = _this$props2.focused, selected = _this$props2.selected, disabled = _this$props2.disabled, activeId = _this$props2.activeId;
        var Tag = this.props.component || 'li';
        var props = Props.omitOwn(this);
        var classes = {
            'rw-state-focus': focused,
            'rw-state-selected': selected,
            'rw-state-disabled': disabled
        };
        var id = focused ? activeId : undefined;
        return _react.default.createElement(Tag, _extends({
            id: id,
            role: "option",
            tabIndex: !disabled ? '-1' : undefined,
            "aria-selected": !!selected,
            className: (0, _classnames.default)('rw-list-option', className, classes),
            onClick: this.handleSelect
        }, props), children);
    };
    return ListOption;
}(_react.default.Component);
ListOption.propTypes = {
    activeId: _propTypes.default.string,
    dataItem: _propTypes.default.any,
    index: _propTypes.default.number,
    focused: _propTypes.default.bool,
    selected: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    onSelect: _propTypes.default.func,
    component: _propTypes.default.string
};
var _default = ListOption;
exports.default = _default;
module.exports = exports["default"];

},{"d796396dd50939d6":"gVheC","49f97b91daa5bf30":"3KNJy","fa3d9bfb8f7038a9":"6P5cq","9acb4cb4b2b59752":"2s4vq"}],"kewuP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("b76a67802bf706e7"));
var _react = _interopRequireDefault(require("58b330b947ddecfa"));
var _propTypes = _interopRequireDefault(require("1c2439210401d46a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var propTypes = {
    className: _propTypes.default.string,
    component: _propTypes.default.string
};
function ListOptionGroup(_ref) {
    var children = _ref.children, className = _ref.className, _ref$component = _ref.component, component = _ref$component === void 0 ? 'li' : _ref$component;
    var Tag = component;
    return _react.default.createElement(Tag, {
        tabIndex: "-1",
        role: "separator",
        className: (0, _classnames.default)(className, 'rw-list-optgroup')
    }, children);
}
ListOptionGroup.propTypes = propTypes;
var _default = ListOptionGroup;
exports.default = _default;
module.exports = exports["default"];

},{"b76a67802bf706e7":"6P5cq","58b330b947ddecfa":"gVheC","1c2439210401d46a":"3KNJy"}],"43Cr9":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = createScrollManager;
var _scrollTo = _interopRequireDefault(require("36abf027501680d6"));
var _reactComponentManagers = require("b0b48d446b8eacd4");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createScrollManager(inst, getScrollParent) {
    if (getScrollParent === void 0) getScrollParent = function getScrollParent(list) {
        return list.parentNode;
    };
    var isMounted = (0, _reactComponentManagers.mountManager)(inst);
    var currentFocused, currentVisible, cancelScroll;
    function handleScroll(selected, list, nextFocused) {
        if (!isMounted()) return;
        var lastVisible = currentVisible;
        var lastItem = currentFocused;
        var shown, changed;
        currentVisible = !(!list.offsetWidth || !list.offsetHeight);
        currentFocused = nextFocused;
        changed = lastItem !== nextFocused;
        shown = currentVisible && !lastVisible;
        if (shown || currentVisible && changed) {
            if (this.props.onMove) this.props.onMove(selected, list, nextFocused);
            else {
                cancelScroll && cancelScroll();
                cancelScroll = (0, _scrollTo.default)(selected, false);
            }
        }
    }
    return handleScroll.bind(inst);
}
module.exports = exports["default"];

},{"36abf027501680d6":"eCd7V","b0b48d446b8eacd4":"bMv3b"}],"eCd7V":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("58943b9989350b9f");
exports.__esModule = true;
exports.default = scrollTo;
var _offset = _interopRequireDefault(require("7426ca17a416a246"));
var _height = _interopRequireDefault(require("88a01d045af49e1a"));
var _scrollParent = _interopRequireDefault(require("1798ea0f6f8bbe9a"));
var _scrollTop = _interopRequireDefault(require("fc995b97fe4084db"));
var _requestAnimationFrame = _interopRequireDefault(require("5b5bf809707939d3"));
var _isWindow = _interopRequireDefault(require("8d804f24cb9990b2"));
function scrollTo(selected, scrollParent) {
    var offset = (0, _offset.default)(selected);
    var poff = {
        top: 0,
        left: 0
    };
    var list, listScrollTop, selectedTop, isWin;
    var selectedHeight, listHeight, bottom;
    if (!selected) return;
    list = scrollParent || (0, _scrollParent.default)(selected);
    isWin = (0, _isWindow.default)(list);
    listScrollTop = (0, _scrollTop.default)(list);
    listHeight = (0, _height.default)(list, true);
    isWin = (0, _isWindow.default)(list);
    if (!isWin) poff = (0, _offset.default)(list);
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    selectedHeight = offset.height;
    selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
    var id = (0, _requestAnimationFrame.default)(function() {
        return (0, _scrollTop.default)(list, listScrollTop);
    });
    return function() {
        return _requestAnimationFrame.default.cancel(id);
    };
}
module.exports = exports["default"];

},{"58943b9989350b9f":"6zI5d","7426ca17a416a246":"j5gx5","88a01d045af49e1a":"hhPzJ","1798ea0f6f8bbe9a":"ciWuD","fc995b97fe4084db":"9D5LL","5b5bf809707939d3":"8i1rr","8d804f24cb9990b2":"90siz"}],"ciWuD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("44b3899801312e4e");
exports.__esModule = true;
exports.default = scrollPrarent;
var _style = _interopRequireDefault(require("f1cf532497025928"));
var _height = _interopRequireDefault(require("2c8c0c005dac8c2a"));
function scrollPrarent(node) {
    var position = (0, _style.default)(node, 'position'), excludeStatic = position === 'absolute', ownerDoc = node.ownerDocument;
    if (position === 'fixed') return ownerDoc || document;
    while((node = node.parentNode) && node.nodeType !== 9){
        var isStatic = excludeStatic && (0, _style.default)(node, 'position') === 'static', style = (0, _style.default)(node, 'overflow') + (0, _style.default)(node, 'overflow-y') + (0, _style.default)(node, 'overflow-x');
        if (isStatic) continue;
        if (/(auto|scroll)/.test(style) && (0, _height.default)(node) < node.scrollHeight) return node;
    }
    return document;
}
module.exports = exports["default"];

},{"44b3899801312e4e":"6zI5d","f1cf532497025928":"jZvdW","2c8c0c005dac8c2a":"hhPzJ"}],"9D5LL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6ebb0abd943fa1f6");
exports.__esModule = true;
exports.default = scrollTop;
var _isWindow = _interopRequireDefault(require("5c1057427d422aea"));
function scrollTop(node, val) {
    var win = (0, _isWindow.default)(node);
    if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
    if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);
    else node.scrollTop = val;
}
module.exports = exports["default"];

},{"6ebb0abd943fa1f6":"6zI5d","5c1057427d422aea":"90siz"}],"8i1rr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8f459dcdf6181d9");
exports.__esModule = true;
exports.default = void 0;
var _inDOM = _interopRequireDefault(require("c0311960b42473c"));
var vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;
var getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};
if (_inDOM.default) vendors.some(function(vendor) {
    var rafKey = getKey(vendor, 'request');
    if (rafKey in window) {
        cancel = getKey(vendor, 'cancel');
        return raf = function raf(cb) {
            return window[rafKey](cb);
        };
    }
});
/* https://github.com/component/raf */ var prev = new Date().getTime();
function fallback(fn) {
    var curr = new Date().getTime(), ms = Math.max(0, 16 - (curr - prev)), req = setTimeout(fn, ms);
    prev = curr;
    return req;
}
compatRaf = function compatRaf(cb) {
    return raf(cb);
};
compatRaf.cancel = function(id) {
    window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

},{"8f459dcdf6181d9":"6zI5d","c0311960b42473c":"3hMod"}],"kGl4g":[function() {},{}],"2b9d2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../../AppState");
var _connectriaTicketsSupportDashboard = require("../ConnectriaTickets/ConnectriaTicketsSupportDashboard");
var _reactRouterDom = require("react-router-dom");
var NewTicketButton = function(props) {
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var history = (0, _reactRouterDom.useHistory)();
    var handleBtnClick = function(e) {
        if (e != null) e.preventDefault();
        if (props.onBladeShow) props.onBladeShow();
        stateAppActions.setBlade({
            title: "Create New Ticket",
            visible: true,
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsSupportDashboard.NewTicketForm), {
                closeOnSuccess: true,
                subject: props.subject,
                description: props.description,
                attachmentElementId: props.attachmentElementId,
                deviceId: props.deviceId
            })
        });
    };
    var goToFullPageView = function(e) {
        history.push({
            pathname: "/app/create-ticket",
            state: {
                closeOnSuccess: true,
                subject: props.subject,
                description: props.description,
                attachmentElementId: props.attachmentElementId,
                deviceId: props.deviceId
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            onClick: function(e) {
                return goToFullPageView(e);
            },
            className: "new-ticket-button ".concat(props.className),
            style: props.style,
            children: props.children
        })
    });
};
exports.default = NewTicketButton;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","../../AppState":"8UGXH","../ConnectriaTickets/ConnectriaTicketsSupportDashboard":"bSLbt","react-router-dom":"acq4R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bSLbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewTicketForm", function() {
    return NewTicketForm;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _connectriaTicketsState = require("./ConnectriaTicketsState");
var _connectriaTicketsStateDefault = parcelHelpers.interopDefault(_connectriaTicketsState);
var _misc = require("../misc");
var _appState = require("../../AppState");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _ramda = require("ramda");
var _connectriaTicketsDashboard = require("../ConnectriaTickets/ConnectriaTicketsDashboard");
var _connectriaTicketsBlade = require("./ConnectriaTicketsBlade");
var _reactChartjs2 = require("react-chartjs-2");
var _fileService = require("../../services/FileService");
var _fileServiceDefault = parcelHelpers.interopDefault(_fileService);
var _sentimentService = require("../../services/SentimentService");
var _sentimentServiceDefault = parcelHelpers.interopDefault(_sentimentService);
var _portalService = require("../../services/PortalService");
var _portalServiceDefault = parcelHelpers.interopDefault(_portalService);
// reactstrap components
var _reactstrap = require("reactstrap");
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _screenshotService = require("../../services/ScreenshotService");
var _screenshotServiceDefault = parcelHelpers.interopDefault(_screenshotService);
var _chartjsPluginLabels = require("chartjs-plugin-labels");
var NewTicketForm = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), types = _useState1[0], setTypes = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), priorities = _useState2[0], setPriorities = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(), 2), categories = _useState3[0], setCategories = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(), 2), subCategories = _useState4[0], setSubCategories = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)([]), 2), devices = _useState5[0], setDevices = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({}), 2), deviceTypes = _useState6[0], setDeviceTypes = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(), 2), subject = _useState7[0], setSubject = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(), 2), cc = _useState8[0], setCC = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(null), 2), ticketType = _useState9[0], setTicketType = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketPriority = _useState10[0], setTicketPriority = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketCategory = _useState11[0], setTicketCategory = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketSubCategory = _useState12[0], setTicketSubCategory = _useState12[1];
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketDevice = _useState13[0], setTicketDevice = _useState13[1];
    var _useState14 = (0, _slicedToArray._)((0, _react.useState)(), 2), description = _useState14[0], setDescription = _useState14[1];
    var _useState15 = (0, _slicedToArray._)((0, _react.useState)(), 2), ticketError = _useState15[0], setTicketError = _useState15[1];
    var _useState16 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isCreating = _useState16[0], setIsCreating = _useState16[1];
    var _useState17 = (0, _slicedToArray._)((0, _react.useState)(), 2), attachmentElementId = _useState17[0], setAttachmentElementId = _useState17[1];
    var _useState18 = (0, _slicedToArray._)((0, _react.useState)([]), 2), carbonCopies = _useState18[0], setCarbonCopies = _useState18[1];
    var _useState19 = (0, _slicedToArray._)((0, _react.useState)([]), 2), defaultCarbonCopies = _useState19[0], setDefaultCarbonCopies = _useState19[1];
    var _useState20 = (0, _slicedToArray._)((0, _react.useState)([]), 2), customerActiveUsers = _useState20[0], setCustomerActiveUsers = _useState20[1];
    var _useState21 = (0, _slicedToArray._)((0, _react.useState)([]), 2), ticketMeta = _useState21[0], setTicketMeta = _useState21[1];
    var _useState22 = (0, _slicedToArray._)((0, _react.useState)(false), 2), includeCSM = _useState22[0], setIncludeCSM = _useState22[1];
    var _useState23 = (0, _slicedToArray._)((0, _react.useState)(null), 2), csmInfo = _useState23[0], setCsmInfo = _useState23[1];
    var _useState24 = (0, _slicedToArray._)((0, _react.useState)(false), 2), hasIncludeCsmMeta = _useState24[0], setHasIncludeCsmMeta = _useState24[1];
    var _useState25 = (0, _slicedToArray._)((0, _react.useState)(false), 2), descriptionInvalid = _useState25[0], setDescriptionInvalid = _useState25[1];
    var _useState26 = (0, _slicedToArray._)((0, _react.useState)(false), 2), errorsInvalid = _useState26[0], setErrorsInvalid = _useState26[1];
    var _useState27 = (0, _slicedToArray._)((0, _react.useState)(null), 2), attachment = _useState27[0], setAttachment = _useState27[1];
    var _useState28 = (0, _slicedToArray._)((0, _react.useState)(null), 2), attachmentError = _useState28[0], setAttachmentError = _useState28[1];
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    //plugin state
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), stateTickets = _useTriaTicketsState[0], stateTicketActions = _useTriaTicketsState[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    var history = (0, _reactRouterDom.useHistory)();
    var devicesMap = (0, _react.useMemo)(function() {
        return (0, _ramda.groupBy)(function(d) {
            return deviceTypes[d.devicetype_id] || 'UNKNOWN';
        })(devices);
    }, [
        devices,
        deviceTypes
    ]);
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var _stateApp_userInfo, types, priorities, preferences, CCs, _devices, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!isMounted() || !((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.organization_id)) return [
                            2
                        ];
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketTypes({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        types = _state.sent();
                        priorities = (0, _connectriaTicketsServiceDefault.default).ticketPriorities();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getCustomerTicketCarbonCopies({
                                name: 'customerTicketsCarbonCopy'
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 2:
                        preferences = _state.sent();
                        return [
                            4,
                            Promise.all([
                                setCacheUsers(preferences),
                                setCacheCategories(),
                                setCacheDevices(),
                                setCsmInfoAndMeta()
                            ])
                        ];
                    case 3:
                        _state.sent();
                        CCs = preferences.map(function(cc) {
                            return {
                                user_id: cc
                            };
                        });
                        setCarbonCopies(CCs);
                        setDefaultCarbonCopies(CCs);
                        setTypes(types.filter(function(e) {
                            return e.name != 'Problem';
                        }));
                        setPriorities(priorities);
                        setFormDefaults(types[0].id, priorities[2].id);
                        //check for passed-in default values
                        if (props.subject != null) setSubject(props.subject);
                        if (props.category != null) setTicketCategory(props.category);
                        if (props.subCategory != null) setTicketSubCategory(props.subCategory);
                        if (props.type != null) setTicketType(props.type);
                        if (props.description != null) setDescription(props.description);
                        if (props.attachmentElementId != null) setAttachmentElementId(props.attachmentElementId);
                        if (!props.deviceId) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllDevicesLike({
                                select: 'id,assettag,servicetag,devicetype_id',
                                id: props.deviceId,
                                limit: 1
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 4:
                        _devices = _state.sent() || [];
                        if (_devices.length > 0) {
                            setDevices(function(ds) {
                                return (ds === null || ds === void 0 ? void 0 : ds.find(function(d) {
                                    return "".concat(d.id) === "".concat(props.deviceId);
                                })) ? ds : (0, _toConsumableArray._)(_devices).concat((0, _toConsumableArray._)(ds));
                            });
                            setTicketDevice(_devices[0].assettag);
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, [
        stateApp.userInfo
    ]);
    var setCacheCategories = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var categories;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketCategories({})
                        ];
                    case 1:
                        categories = _state.sent();
                        categories.names = (0, _toConsumableArray._)(new Set(categories.map(function(category) {
                            return category.name;
                        })));
                        setCategories(categories);
                        return [
                            2
                        ];
                }
            });
        });
        return function setCacheCategories() {
            return _ref.apply(this, arguments);
        };
    }();
    var setCacheDevices = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var _devices, allDeviceTypes, deviceTypes;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllDevicesLike({
                                select: 'id,assettag,servicetag,devicetype_id',
                                limit: 10000,
                                sort_by: 'assettag'
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        _devices = _state.sent();
                        if (!(_devices === null || _devices === void 0 ? void 0 : _devices.length)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllDeviceTypes({
                                select: 'id,category',
                                limit: 10000
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 2:
                        allDeviceTypes = _state.sent();
                        deviceTypes = allDeviceTypes.reduce(function(r, dt) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), (0, _defineProperty._)({}, dt.id, dt.category));
                        }, {});
                        setDeviceTypes(deviceTypes);
                        _state.label = 3;
                    case 3:
                        setDevices(_devices || []);
                        return [
                            2
                        ];
                }
            });
        });
        return function setCacheDevices() {
            return _ref.apply(this, arguments);
        };
    }();
    var setCacheUsers = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(preferences) {
            var isCustomer, users, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user, ccUsers;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isCustomer = stateApp.userInfo.organization_id != 0;
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllUsersLike({}, isCustomer)
                        ];
                    case 1:
                        users = _state.sent();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = users[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                user = _step.value;
                                if (preferences.includes(user.id)) user['selected'] = true;
                                else user['selected'] = false;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        users.sort(function(a, b) {
                            return a.fname.localeCompare(b.fname);
                        });
                        ccUsers = users.filter(function(user) {
                            var _stateApp_userInfo;
                            return user.active && user.login_supported && !user.serviceUser && user.email !== ((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.email);
                        });
                        preferences = preferences.filter(function(p) {
                            return ccUsers.findIndex(function(u) {
                                return u.id === p;
                            }) !== -1;
                        });
                        setCustomerActiveUsers(ccUsers);
                        return [
                            2
                        ];
                }
            });
        });
        return function setCacheUsers(preferences) {
            return _ref.apply(this, arguments);
        };
    }();
    var setFormDefaults = function(ticketTypeId, ticketPriorityId) {
        setTicketType(null);
        setTicketPriority(ticketPriorityId);
        setTicketCategory('');
        setTicketSubCategory('');
        setTicketDevice('');
        setSubject('');
        setDescription('');
        setIncludeCSM(false);
        setTicketError('');
        setDescriptionInvalid(false);
        setErrorsInvalid(false);
        setIncludeCSM(false);
        setIsLoading(false);
    };
    var createSentimentMeta = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(ticket_id, text) {
            var sentiment, value;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _sentimentServiceDefault.default).getSentiment(text)
                        ];
                    case 1:
                        sentiment = _state.sent();
                        value = JSON.stringify((0, _objectSpreadProps._)((0, _objectSpread._)({}, sentiment.data.SentimentScore), {
                            readable: sentiment.data.Sentiment
                        }));
                        //fire and forget
                        (0, _connectriaTicketsServiceDefault.default).createTicketMeta(ticket_id, 'sentiment', value);
                        return [
                            2
                        ];
                }
            });
        });
        return function createSentimentMeta(ticket_id, text) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreate = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var ticketId, detail, fileBase64, attachmentResponse, ssData, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        setIsCreating(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).createTicket(subject, description, ticketError, ticketPriority, ticketType, ticketDevice, carbonCopies, ticketSubCategory, ticketMeta)
                        ];
                    case 2:
                        ticketId = _state.sent();
                        createSentimentMeta(ticketId, description);
                        setFormDefaults(null, priorities[2].id);
                        resetDefaultCarbonCopies();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketDetail(ticketId)
                        ];
                    case 3:
                        detail = _state.sent();
                        stateTicketActions.unshiftTicket(detail);
                        if (!attachment) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            (0, _fileServiceDefault.default).toBase64(attachment)
                        ];
                    case 4:
                        fileBase64 = _state.sent();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).addAttachment(ticketId, attachment.name, fileBase64)
                        ];
                    case 5:
                        attachmentResponse = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!attachmentElementId) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            (0, _screenshotServiceDefault.default).createScreenshotBase64(attachmentElementId)
                        ];
                    case 7:
                        ssData = _state.sent();
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).newComment(ticketId, 'Auto-generated screenshot.', 'TRiAScreenshot.png', ssData)
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        if (props.closeOnSuccess) stateAppActions.setBlade({
                            visible: false,
                            content: '',
                            title: ''
                        });
                        if (props.fullPage) history.push("/app/view/ticket/".concat(ticketId));
                        else {
                            stateAppActions.setAlert({
                                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    style: {
                                        color: 'white'
                                    },
                                    children: [
                                        "Ticket #",
                                        ticketId,
                                        " created successfully."
                                    ]
                                }),
                                className: 'success',
                                visible: true
                            });
                            setTimeout(function() {
                                stateAppActions.setAlert(function(prevState) {
                                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                        visible: false
                                    });
                                });
                            }, 2000);
                        }
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        console.log(error);
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: 'white'
                                },
                                children: "Error creating ticket."
                            }),
                            color: 'danger',
                            visible: true
                        });
                        setTimeout(function() {
                            stateAppActions.setAlert(function(prevState) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                    visible: false
                                });
                            });
                        }, 2000);
                        return [
                            3,
                            11
                        ];
                    case 11:
                        setIsCreating(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreate(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetDefaultCarbonCopies = function() {
        var users = (0, _toConsumableArray._)(customerActiveUsers);
        var preferences = defaultCarbonCopies.map(function(cc) {
            return cc.user_id;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = users[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var user = _step.value;
                if (preferences.includes(user.id)) user.selected = true;
                else user.selected = false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setCustomerActiveUsers(users);
    };
    var handleCCSelect = function(selectedUser) {
        var usersCopy = (0, _toConsumableArray._)(customerActiveUsers);
        var newCarbonCopies = [];
        if (selectedUser === 'Select All') {
            usersCopy.map(function(user) {
                user.selected = true;
            });
            newCarbonCopies = usersCopy.map(function(user) {
                return {
                    user_id: user.id
                };
            });
            setCarbonCopies(newCarbonCopies);
        } else if (selectedUser === 'Deselect All') {
            usersCopy.map(function(user) {
                user.selected = false;
            });
            setCarbonCopies([]);
        } else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = usersCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var user = _step.value;
                    if (user.id == selectedUser.id) user.selected = !user.selected;
                    if (user.selected) newCarbonCopies.push({
                        user_id: user.id
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            setCarbonCopies(newCarbonCopies);
        }
        setCustomerActiveUsers(usersCopy);
    };
    var handleCsmSelect = function() {
        if (includeCSM) setTicketMeta(ticketMeta.filter(function(meta) {
            return meta.meta_key != 'notify_csm';
        }));
        else setTicketMeta((0, _toConsumableArray._)(ticketMeta).concat([
            {
                meta_key: 'notify_csm',
                meta_value: '1'
            }
        ]));
        setIncludeCSM(!includeCSM);
    };
    var setCsmInfoAndMeta = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var _ref, accountAgents, metadata, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, agent, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            Promise.all([
                                (0, _connectriaTicketsServiceDefault.default).getParamData({
                                    cancelToken: source.token
                                }),
                                (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                    meta_key: 'tria_show_cc_csm'
                                })
                            ])
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            2
                        ]), accountAgents = _ref[0], metadata = _ref[1];
                        accountAgents = accountAgents.dynamic.response.data.customer_account_agents || [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = accountAgents[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                agent = _step.value;
                                if (agent.agent_type.name == 'Customer Success Manager') setCsmInfo(agent);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (metadata.meta_value == 'TRUE') setHasIncludeCsmMeta(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function setCsmInfoAndMeta() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDescriptionChange = function(value) {
        try {
            // Check if string is valid utf-8
            decodeURIComponent(escape(value));
            // If so, the text is valid
            setDescriptionInvalid(false);
        } catch (e) {
            // If the text is not valid utf-8 then display message to user
            setDescriptionInvalid(true);
        }
        setDescription(value);
    };
    var handleErrorsChange = function(value) {
        try {
            // Check if string is valid utf-8
            decodeURIComponent(escape(value));
            // If so, the text is valid
            setErrorsInvalid(false);
        } catch (e) {
            // If the text is not valid utf-8 then display message to user
            setErrorsInvalid(true);
        }
        setTicketError(value);
    };
    var addAttachment = function(e) {
        var _e_target_files, _e_target;
        var file = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_files = _e_target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file) {
            if (file.size > 5242880) {
                // check 5mb limit for the file size
                setAttachmentError('File size limit exceeded.');
                setAttachment(null);
                e.target.value = '';
            } else {
                setAttachmentError(null);
                setAttachment(file);
            }
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center w-100 h-100",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-spinner m-3 mt-4 fa-spin",
            style: {
                fontSize: '30px'
            }
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-100 w-100 d-flex connectria-new-ticket-form-contain",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Form), {
                onSubmit: function(e) {
                    return handleCreate(e);
                },
                className: "d-flex w-100 flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                        className: "h-100",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                lg: props.fullPage ? '7' : '6',
                                md: "12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                        className: "font-weight-bold",
                                        children: "Subject*"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                        type: "text",
                                        id: "txtSubject",
                                        maxLength: 255,
                                        onChange: function(e) {
                                            return setSubject(e.target.value);
                                        },
                                        value: subject,
                                        autoComplete: "off",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                className: "font-weight-bold",
                                                for: "txtDescription",
                                                children: "Description*"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _misc.ExpandingTextArea), {
                                                id: "txtDescription",
                                                onChange: function(e) {
                                                    return handleDescriptionChange(e.target.value);
                                                },
                                                value: description,
                                                rows: props.textAreaRows,
                                                required: true,
                                                valid: !descriptionInvalid,
                                                invalid: descriptionInvalid
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormFeedback), {
                                                invalid: "true",
                                                children: "This text is not valid UTF-8. Ticket creation might fail."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                for: "txtErrors",
                                                children: "Error(s)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _misc.ExpandingTextArea), {
                                                id: "txtErrors",
                                                onChange: function(e) {
                                                    return handleErrorsChange(e.target.value);
                                                },
                                                value: ticketError,
                                                rows: props.textAreaRows,
                                                valid: !errorsInvalid,
                                                invalid: errorsInvalid
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormFeedback), {
                                                invalid: "true",
                                                children: "This text is not valid UTF-8. Ticket creation might fail."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                lg: props.fullPage ? '5' : '6',
                                md: "12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Label), {
                                        children: [
                                            "cc",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                className: "ml-1",
                                                onClick: function() {
                                                    handleCCSelect('Select All');
                                                },
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                children: "(Select all)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                className: "ml-1",
                                                onClick: function() {
                                                    handleCCSelect('Deselect All');
                                                },
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                children: "(Deselect all)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-control resizable",
                                        style: {
                                            overflowY: 'scroll',
                                            height: "100px"
                                        },
                                        children: customerActiveUsers.map(function(user, index) {
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: 'd-flex w-100',
                                                onClick: function(e) {
                                                    handleCCSelect(user);
                                                },
                                                style: {
                                                    backgroundColor: user.selected ? 'lightblue' : '',
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        style: {
                                                            flex: '0 50%'
                                                        },
                                                        children: user.fname + ' ' + user.surname
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        style: {
                                                            flex: '0 50%'
                                                        },
                                                        children: '<' + user.email + '>'
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    hasIncludeCsmMeta && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "position-relative form-check mb-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "form-check-label",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nobr", {
                                                    children: [
                                                        "cc ",
                                                        csmInfo.user.fname + ' ' + csmInfo.user.surname
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    checked: includeCSM,
                                                    onChange: handleCsmSelect
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "form-check-sign",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "check"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                                md: "6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "font-weight-bold",
                                                        children: "Type*"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        required: true,
                                                        type: "select",
                                                        id: "ddTicketType",
                                                        onChange: function(e) {
                                                            return setTicketType(e.target.value);
                                                        },
                                                        value: ticketType == null ? '' : ticketType,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: '',
                                                                "data-content": '<span>Relish ex</span>'
                                                            }),
                                                            types.map(function(type, index) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: type.id,
                                                                    children: type.name
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                                md: "6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "font-weight-bold",
                                                        children: "Priority*"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "ddTicketPriority",
                                                        onChange: function(e) {
                                                            return setTicketPriority(e.target.value);
                                                        },
                                                        value: ticketPriority,
                                                        children: priorities.map(function(priority, index) {
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: priority.id,
                                                                children: priority.name
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                                md: "6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "font-weight-bold",
                                                        children: "Category*"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "ddTicketCategory",
                                                        required: true,
                                                        onChange: function(e) {
                                                            return setTicketCategory(e.target.value);
                                                        },
                                                        value: ticketCategory,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            categories.names.map(function(name, index) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: name,
                                                                    children: name
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                                md: "6",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "font-weight-bold",
                                                        children: "Sub-Category*"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                        type: "select",
                                                        id: "ddTicketSubCategory",
                                                        required: true,
                                                        onChange: function(e) {
                                                            return setTicketSubCategory(e.target.value);
                                                        },
                                                        value: ticketSubCategory,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            categories.filter(function(category) {
                                                                return category.name == ticketCategory;
                                                            }).sort(function(a, b) {
                                                                return a.subcategory.localeCompare(b.subcategory);
                                                            }).map(function(category, index) {
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                    value: category.id,
                                                                    children: category.subcategory
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                    children: "Device (Asset Tag - Service Tag)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Input), {
                                                    type: "select",
                                                    id: "ddTicketDevice",
                                                    onChange: function(e) {
                                                        return setTicketDevice(e.target.value);
                                                    },
                                                    value: ticketDevice,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                            value: "",
                                                            children: "Choose a device..."
                                                        }),
                                                        Object.keys(devicesMap).map(function(cat) {
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("optgroup", {
                                                                label: cat,
                                                                children: devicesMap[cat].map(function(dv) {
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                                                        value: dv.assettag,
                                                                        children: [
                                                                            dv.assettag,
                                                                            " - ",
                                                                            dv.servicetag
                                                                        ]
                                                                    }, dv.id);
                                                                })
                                                            }, cat);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Col), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        children: "Attachment"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                        type: "file",
                                                        name: "fileCreate",
                                                        id: "fileCreate",
                                                        className: "mb-1",
                                                        onChange: addAttachment
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "(Max File Size: 5MB)"
                                                    }),
                                                    attachmentError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "mt-2 text-danger font-italic",
                                                        children: attachmentError
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                                                sm: "12",
                                                md: "6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "text-right mt-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                            children: " "
                                                        }),
                                                        isCreating ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                                                            type: "submit",
                                                            disabled: isCreating,
                                                            className: "btn-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                    className: "fas fa-spinner fa-spin ml-1",
                                                                    style: {
                                                                        fontSize: '15px'
                                                                    }
                                                                }),
                                                                " Creating"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                                            type: "submit",
                                                            className: "btn-sm",
                                                            children: "Submit"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        className: "font-weight-bold",
                        style: {
                            color: '#0C618D'
                        },
                        children: "* Required"
                    })
                ]
            })
        })
    });
};
function showItemBlade(item, stateApp, stateAppActions) {
    stateAppActions.setBlade({
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                '#' + item.ticket_id,
                ' ',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _misc.ClipboardCopyButton), {
                    className: "mb-1",
                    value: "".concat(window.location.origin, "/app/support/ticket/").concat(item.ticket_id),
                    tooltipMessage: 'Copy ticket link',
                    alertMessage: "Ticket #".concat(item.ticket_id, " link copied.")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsBlade.NewTabLink), {
                    tooltipMessage: 'Open In New Tab',
                    link: "/app/view/ticket/".concat(item.ticket_id),
                    alertMessage: ''
                })
            ]
        }),
        visible: true,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsBlade.ConnectriaTicketsDetailBlade), {
            id: item.ticket_id
        })
    });
}
var PriorityPieChart = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), metrics = _useState1[0], setMetrics = _useState1[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var resp, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketPriorityMetric(30, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        resp = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        setMetrics(resp);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
        className: "card-minimal mb-0",
        id: "connectria-ticket-priority-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                className: "card-header-minimal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                    className: "card-title-minimal",
                    tag: "h3",
                    children: "Ticket Priorities"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                style: {
                    height: '350px'
                },
                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-spinner m-3 mt-4 fa-spin",
                        style: {
                            fontSize: '30px'
                        }
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            children: "All Tickets Over the Last 30 Days"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                height: '265px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Doughnut), {
                                data: metrics,
                                options: {
                                    maintainAspectRatio: false,
                                    plugins: {
                                        labels: {
                                            render: 'percentage',
                                            fontColor: 'white',
                                            fontSize: 14,
                                            fontStyle: 'bold'
                                        },
                                        datalabels: {
                                            display: false
                                        }
                                    }
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var RecentUpdates = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), didLoad = _useState1[0], setDidLoad = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), audit = _useState2[0], setAudit = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(), 2), cardBodyStyle = _useState3[0], setCardBodyStyle = _useState3[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var resp, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!props.visible) return [
                            3,
                            2
                        ];
                        if (didLoad) return [
                            2
                        ];
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).ticketAudits(15, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        resp = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        setAudit(resp);
                        setIsLoading(false);
                        setDidLoad(true);
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, [
        props.visible
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
        className: "card-minimal mb-0",
        style: cardBodyStyle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                className: "card-header-minimal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                    className: "card-title-minimal",
                    tag: "h3",
                    children: "Recent Updates"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                id: "connectria-support-recent-updates-body",
                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-spinner m-3 mt-4 fa-spin",
                        style: {
                            fontSize: '30px'
                        }
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "list-group",
                    style: cardBodyStyle,
                    children: audit.map(function(item, index) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            onClick: function() {
                                return showItemBlade(item, props.stateApp, props.stateAppActions);
                            },
                            className: "list-group-item list-group-item-action flex-column align-items-start",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-1",
                                    children: item.log
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    children: (0, _momentDefault.default)(item.date, 'YYYY-MM-DDThh:mm:ss.SSSZ').fromNow()
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
var ConnectriaTicketsSupportDashboard = function(props) {
    //local state
    var _useState = (0, _slicedToArray._)((0, _react.useState)('1'), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    //plugin state
    var _useTriaTicketsState = (0, _slicedToArray._)((0, _connectriaTicketsStateDefault.default)(), 2), state = _useTriaTicketsState[0], stateActions = _useTriaTicketsState[1];
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _react.useEffect)(function() {
        //check for ticket route
        var paths = window.location.pathname.split('/');
        if (paths != null && paths.length > 2 && paths[paths.length - 2] === 'ticket') showItemBlade({
            ticket_id: paths[paths.length - 1]
        }, stateAppActions, stateAppActions);
    }, []);
    var toggleTab = function(tab) {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "mb-3 mt-4 tria-header-class",
                children: "Support & Ticketing"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Row), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                        md: "12",
                        lg: "8",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                            className: "card-minimal mb-0 h-100",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                                    className: "card-header-minimal",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                                        className: "card-title-minimal",
                                        tag: "h3",
                                        children: "Create New Ticket"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                                    id: "connectria-support-new-ticket-body",
                                    className: "d-flex flex-column",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NewTicketForm, {
                                        textAreaRows: 4
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                        md: "12",
                        lg: "4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PriorityPieChart, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                className: "card-minimal mb-0 mt-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                        className: "card-header-minimal",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                            className: "card-title-minimal",
                            tag: "h3",
                            children: "Ticketing Inbox"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                        id: "connectria-support-inbox-body",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectriaTicketsDashboard.Inbox), {
                            isLoading: state.isLoading,
                            tickets: state.tickets,
                            statePlugin: state,
                            statePluginActions: stateActions,
                            stateApp: stateApp,
                            stateAppActions: stateAppActions
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = ConnectriaTicketsSupportDashboard;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","../../utility/use-async-effect":"fShZN","axios":"ebRwi","./ConnectriaTicketsState":"2XBXC","../misc":"5OQBQ","../../AppState":"8UGXH","moment":"3xZWN","ramda":"2pVIv","../ConnectriaTickets/ConnectriaTicketsDashboard":"21zwt","./ConnectriaTicketsBlade":"2i91X","react-chartjs-2":"gpEym","../../services/FileService":"iDQLc","../../services/SentimentService":"4JTPi","../../services/PortalService":"9VQnb","reactstrap":"774RE","../../services/ConnectriaTicketsService":"l5X0I","../../services/ScreenshotService":"lF4GL","chartjs-plugin-labels":"65WNy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5OQBQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpandingTextArea", function() {
    return ExpandingTextArea;
});
parcelHelpers.export(exports, "NavBarBackButton", function() {
    return NavBarBackButton;
});
parcelHelpers.export(exports, "ClipboardCopyButton", function() {
    return ClipboardCopyButton;
});
parcelHelpers.export(exports, "SessionTimeoutModal", function() {
    return SessionTimeoutModal;
});
parcelHelpers.export(exports, "HamburgerMenu", function() {
    return HamburgerMenu;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAsyncEffect = require("../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _reactRouterDom = require("react-router-dom");
var _appState = require("../AppState");
var _misc = require("../utility/misc");
var _userService = require("../services/UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var _login = require("../layouts/Login/Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _config = require("../config");
var _reactstrap = require("reactstrap");
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var ExpandingTextArea = function(props) {
    var textarea = document.querySelector("textarea#".concat(props.id));
    if (textarea) textarea.addEventListener('keydown', (0, _misc.autosize));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            props.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Label, {
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), (0, _objectSpreadProps._)((0, _objectSpread._)({
                type: "textarea"
            }, props), {
                className: "expandable resizable".concat(props.className ? props.className : "")
            }))
        ]
    });
};
var NavBarBackButton = function(props) {
    var history = (0, _reactRouterDom.useHistory)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            href: "#",
            onClick: function() {
                history.push(props.route);
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "row text-primary navbarexample",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-chevron-left mr-1",
                        style: {
                            paddingRight: "2px",
                            marginTop: "auto",
                            marginBottom: "auto"
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-primary",
                            children: props.text
                        })
                    })
                ]
            })
        })
    });
};
var ClipboardCopyButton = function(props) {
    var value = props.value, tooltipMessage = props.tooltipMessage, alertMessage = props.alertMessage, idx = props.idx, className = props.className, style = props.style;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), tooltipOpen = _useState[0], setTooltipOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(tooltipMessage), 2), text = _useState1[0], setText = _useState1[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var toggle = function() {
        setTooltipOpen(!tooltipOpen);
        // When hovering off of tooltip, reset the message
        if (!tooltipOpen) setText(tooltipMessage);
    };
    var copyToClipboard = function() {
        try {
            navigator.clipboard.writeText(value);
            setText("Copied!");
            // Show app level alert if message is given
            if (alertMessage) {
                stateAppActions.setAlert({
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        style: {
                            color: "white"
                        },
                        children: alertMessage
                    }),
                    className: "success",
                    visible: true
                });
                setTimeout(function() {
                    stateAppActions.setAlert(function(prevState) {
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                            visible: false
                        });
                    });
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            setText('Failed to copy');
        }
    };
    var _props_target, _props_target1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "far fa-copy clickable copy-clipboard cursor " + (className ? className : ""),
                id: ((_props_target = props.target) !== null && _props_target !== void 0 ? _props_target : "TooltipExample") + (idx + 1 ? idx : ""),
                onClick: copyToClipboard,
                style: (0, _objectSpread._)({
                    fontSize: "0.9rem"
                }, style)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Tooltip), {
                placement: "right",
                target: ((_props_target1 = props.target) !== null && _props_target1 !== void 0 ? _props_target1 : "TooltipExample") + (idx + 1 ? idx : ""),
                isOpen: tooltipOpen,
                toggle: toggle,
                style: {
                    backgroundColor: "black",
                    color: "white"
                },
                children: text
            })
        ]
    });
};
var SessionTimeoutModal = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), minutes = _useState[0], setMinutes = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), sessionExpired = _useState1[0], setSessionExpired = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), intervalId = _useState2[0], setIntervalId = _useState2[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), modal = _useState3[0], setModal = _useState3[1];
    var history = (0, _reactRouterDom.useHistory)();
    (0, _react.useEffect)(function() {
        if (stateApp.sessionTimeoutTime != null) {
            var timeoutTime = parseInt((0, _cookieServiceDefault.default).getCookie("session_timeout_time"));
            var d = new Date();
            var minutes = Math.ceil((timeoutTime - d.getTime()) / 60000);
            setMinutes(minutes);
        }
    }, [
        stateApp.sessionTimeoutTime
    ]);
    (0, _react.useEffect)(function() {
        if (stateApp.sessionTimeoutTime != null) {
            clearInterval(intervalId);
            var id = setInterval(function() {
                var d = new Date();
                var sessionTimeoutTime = parseInt((0, _cookieServiceDefault.default).getCookie("session_timeout_time"));
                var minutes = Math.ceil((sessionTimeoutTime - d.getTime()) / 60000);
                if (d > stateApp.sessionTimeoutTime && stateApp.sessionTimeoutTime != null) {
                    //do logout
                    setSessionExpired(true);
                    setModal(true);
                    clearInterval(intervalId);
                }
                setMinutes(minutes);
            }, 60000);
            setIntervalId(id);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        stateApp.sessionTimeoutTime
    ]);
    (0, _react.useEffect)(function() {
        if (minutes == 5) {
            setModal(true);
            setSessionExpired(true);
        }
    }, [
        minutes
    ]);
    var logout = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var error, cookieDomain;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        clearInterval(intervalId);
                        setModal(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _userServiceDefault.default).logout()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        cookieDomain = (0, _cookieServiceDefault.default).getCookieDomain(stateApp.env);
                        (0, _cookieServiceDefault.default).eraseCookie("session_id", "/", cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie("session_timeout_time", "/", cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie("show_skylift", "/", cookieDomain);
                        stateAppActions.setLogout();
                        window.location.href = (0, _config.ACCOUNTS_URL);
                        return [
                            2
                        ];
                }
            });
        //history.push("/login");
        });
        return function logout(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggle = function() {
        setModal(!modal);
    };
    var resetSessionTimeout = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var timeoutTime, d;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _userServiceDefault.default).save_user_session()
                        ];
                    case 1:
                        timeoutTime = _state.sent();
                        d = Date.parse(timeoutTime.data.expiration);
                        (0, _cookieServiceDefault.default).setCookie("session_timeout_time", d, 1, stateApp.env);
                        stateAppActions.setSessionTimeoutTime(d);
                        setModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function resetSessionTimeout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
            isOpen: modal,
            toggle: sessionExpired ? logout : toggle,
            className: props.className,
            children: [
                sessionExpired ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                    toggle: logout,
                    children: "You have been logged out due to inactivity."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                    toggle: toggle,
                    children: [
                        "In ",
                        minutes,
                        " minutes, you will be logged out due to inactivity."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                    children: sessionExpired ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        color: "secondary",
                        onClick: logout,
                        children: "Go to the login page"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                color: "secondary",
                                onClick: resetSessionTimeout,
                                children: "Stay in TRiA"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                color: "secondary",
                                onClick: logout,
                                children: "Log out"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var HamburgerMenu = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "hamburger-menu",
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../utility/use-async-effect":"fShZN","axios":"ebRwi","react-router-dom":"acq4R","../AppState":"8UGXH","../utility/misc":"bM8Mk","../services/UserService":"4Rf9v","../layouts/Login/Login":"tLiGr","../config":"kQzX9","reactstrap":"774RE","../services/CookieService":"iKLPT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tLiGr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _loginBoxCss = require("../../assets/css/login-box.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _chatService = require("../../services/ChatService");
var _chatServiceDefault = parcelHelpers.interopDefault(_chatService);
var _reactRouterDom = require("react-router-dom");
var _service = require("../../public_cloud/services/service");
var _serviceDefault = parcelHelpers.interopDefault(_service);
var _userService = require("../../services/UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var _ibmservice = require("../../services/IBMService");
var _ibmserviceDefault = parcelHelpers.interopDefault(_ibmservice);
var _organizationService = require("../../services/OrganizationService");
var _organizationServiceDefault = parcelHelpers.interopDefault(_organizationService);
var _blueMatadorService = require("../../services/BlueMatadorService");
var _blueMatadorServiceDefault = parcelHelpers.interopDefault(_blueMatadorService);
var _cloudWatchService = require("../../services/CloudWatchService");
var _cloudWatchServiceDefault = parcelHelpers.interopDefault(_cloudWatchService);
var _trendMicroService = require("../../services/TrendMicroService");
var _trendMicroServiceDefault = parcelHelpers.interopDefault(_trendMicroService);
var _portalService = require("../../services/PortalService");
var _portalServiceDefault = parcelHelpers.interopDefault(_portalService);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _ramda = require("ramda");
var _config = require("../../config");
var _appState = require("../../AppState");
var _enum = require("../../utility/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _reactstrap = require("reactstrap");
var _misc = require("../../utility/misc");
var _browserSupport = require("../../utility/BrowserSupport");
var _browserSupportDefault = parcelHelpers.interopDefault(_browserSupport);
var Login = function() {
    // redirect to accounts with return param
    window.location.href = (0, _config.ACCOUNTS_URL) + '/sign-in?next=https://' + window.location.hostname;
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), errorVisible = _useState[0], setErrorVisible = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), inFlight = _useState1[0], setInFlight = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), returnUrl = _useState2[0], setReturnUrl = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), loginFlow = _useState3[0], setLoginflow = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showMfa = _useState4[0], setShowMfa = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showForgotPassword = _useState5[0], setShowForgotPassword = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)("Invalid Username/Password"), 2), errorMessage = _useState6[0], setErrorMessage = _useState6[1];
    var history = (0, _reactRouterDom.useHistory)();
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({
        email: "",
        password: "",
        mfa: ""
    }), 2), stateLocal = _useState7[0], setLocalState = _useState7[1];
    (0, _react.useEffect)(function() {
        var queryDict = (0, _misc.parseQueryParams)();
        setReturnUrl(queryDict["rurl"]);
    }, []);
    (0, _react.useEffect)(function() {
        document.body.classList.add("background-blue");
        return function() {
            return document.body.classList.remove("background-blue");
        };
    });
    var validateForm = function() {
        if (stateLocal.email && stateLocal.password) return true;
    };
    var setEmail = function(email) {
        return setLocalState(function(values) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                email: email
            });
        });
    };
    var setMfa = function(mfa) {
        return setLocalState(function(values) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                mfa: mfa
            });
        });
    };
    var setPassword = function(password) {
        return setLocalState(function(values) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                password: password
            });
        });
    };
    var doLogin = function(result) {
        return new Promise(function(resolve, reject) {
            stateAppActions.setAuthenticated(result.data);
            resolve();
        });
    };
    function determineClouds() {
        return _determineClouds.apply(this, arguments);
    }
    function _determineClouds() {
        _determineClouds = (0, _asyncToGenerator._)(function() {
            var ibmi, params, cloud_types, e, types, i;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ibmi = {}, params = {
                            headers: {
                                "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                            }
                        };
                        return [
                            4,
                            (0, _serviceDefault.default).list_clouds(params)
                        ];
                    case 1:
                        cloud_types = _state.sent();
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, _ibmserviceDefault.default).hosts(params)
                        ];
                    case 3:
                        ibmi = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        ibmi = {
                            data: []
                        };
                        return [
                            3,
                            5
                        ];
                    case 5:
                        types = [];
                        for(i = 0; i < cloud_types.data.clouds.length; i++){
                            if (cloud_types.data.clouds[i].cloud_type_id.includes("AWS")) {
                                types.push((0, _enumDefault.default).CloudCategory.AWS);
                                types.push((0, _enumDefault.default).CloudCategory.PUBLIC_CLOUD);
                            }
                            if (cloud_types.data.clouds[i].cloud_type_id.includes("AZURE")) {
                                types.push((0, _enumDefault.default).CloudCategory.AZURE);
                                types.push((0, _enumDefault.default).CloudCategory.PUBLIC_CLOUD);
                            }
                            if (cloud_types.data.clouds[i].cloud_type_id.includes("VMWARE")) types.push((0, _enumDefault.default).CloudCategory.VMWARE);
                        }
                        if (ibmi.data.length > 0) types.push((0, _enumDefault.default).CloudCategory.IBMI);
                        stateAppActions.setClouds((0, _toConsumableArray._)(new Set(types)));
                        stateAppActions.setCloudAccounts(cloud_types.data.clouds);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve("resolved");
                            })
                        ];
                }
            });
        });
        return _determineClouds.apply(this, arguments);
    }
    function determineOrgs() {
        return _determineOrgs.apply(this, arguments);
    }
    function _determineOrgs() {
        _determineOrgs = (0, _asyncToGenerator._)(function() {
            var orgs, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _organizationServiceDefault.default).list_orgs({
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 1:
                        orgs = _state.sent();
                        stateAppActions.setOrganizations((0, _ramda.sortBy)((0, _ramda.compose)((0, _ramda.toLower), (0, _ramda.prop)('name')))(orgs.data));
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve("resolved");
                            })
                        ];
                    case 2:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineOrgs.apply(this, arguments);
    }
    function determineIntegrations() {
        return _determineIntegrations.apply(this, arguments);
    }
    function _determineIntegrations() {
        _determineIntegrations = (0, _asyncToGenerator._)(function() {
            var integrations, hasBlueMatador, hasTrendMicro, cloudWatchAlarms, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        integrations = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0, _blueMatadorServiceDefault.default).checkSetup({
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 2:
                        hasBlueMatador = _state.sent();
                        if (hasBlueMatador.data.has_bluematador) integrations.push((0, _enumDefault.default).Integration.BLUEMATADOR);
                        return [
                            4,
                            (0, _trendMicroServiceDefault.default).checkSetup({
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 3:
                        hasTrendMicro = _state.sent();
                        if (hasTrendMicro.data.has_trendmicro) integrations.push((0, _enumDefault.default).Integration.TRENDMICRO);
                        return [
                            4,
                            (0, _cloudWatchServiceDefault.default).getAlarms([
                                'us-east-1',
                                'us-east-2'
                            ], {
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 4:
                        cloudWatchAlarms = _state.sent();
                        if (cloudWatchAlarms.data.clouds_alarms_list.length > 0) integrations.push((0, _enumDefault.default).Integration.CLOUDWATCH);
                        stateAppActions.setIntegrations(integrations);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve("resolved");
                            })
                        ];
                    case 5:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineIntegrations.apply(this, arguments);
    }
    function determineSkyLiftLink() {
        return _determineSkyLiftLink.apply(this, arguments);
    }
    function _determineSkyLiftLink() {
        _determineSkyLiftLink = (0, _asyncToGenerator._)(function() {
            var metadata, show_skylift, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        (0, _cookieServiceDefault.default).eraseCookie("show_skylift", "/");
                        return [
                            4,
                            (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                meta_key: 'tria_show_skylift_link'
                            }, {
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 1:
                        metadata = _state.sent();
                        show_skylift = metadata.meta_value == "TRUE" ? 1 : 0;
                        (0, _cookieServiceDefault.default).setCookie("show_skylift", show_skylift, 0, stateApp.env, '/');
                        stateAppActions.setPortalCustomerMeta(metadata);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve("resolved");
                            })
                        ];
                    case 2:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineSkyLiftLink.apply(this, arguments);
    }
    function determineUpsellsEnabled() {
        return _determineUpsellsEnabled.apply(this, arguments);
    }
    function _determineUpsellsEnabled() {
        _determineUpsellsEnabled = (0, _asyncToGenerator._)(function() {
            var metadata, upsellsEnabled, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        metadata = {};
                        upsellsEnabled = (0, _cookieServiceDefault.default).getCookie("tria_upsell_ads");
                        if (!!upsellsEnabled) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                meta_key: 'tria_upsell_ads'
                            }, {
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 1:
                        metadata = _state.sent();
                        (0, _cookieServiceDefault.default).setCookie("tria_upsell_ads", metadata.meta_value, 0, stateApp.env, '/');
                        return [
                            3,
                            3
                        ];
                    case 2:
                        metadata = {
                            meta_key: 'tria_upsell_ads',
                            meta_value: upsellsEnabled
                        };
                        _state.label = 3;
                    case 3:
                        stateAppActions.setPortalCustomerMeta(metadata);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve("resolved");
                            })
                        ];
                    case 4:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineUpsellsEnabled.apply(this, arguments);
    }
    var showErrorMessage = function(msg) {
        setErrorMessage(msg);
        setErrorVisible(true);
        setTimeout(function() {
            setErrorVisible(false);
        }, 2000);
        setInFlight(false);
    };
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var result, _, userResult, passResult, mfaResult, e1, user_info, session_timeout_time, d, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setInFlight(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            17,
                            ,
                            18
                        ]);
                        result = null;
                        _ = e.target.id;
                        switch(_){
                            case "userpass-submit":
                                return [
                                    3,
                                    2
                                ];
                            case "mfa-submit":
                                return [
                                    3,
                                    5
                                ];
                        }
                        return [
                            3,
                            10
                        ];
                    case 2:
                        return [
                            4,
                            (0, _userServiceDefault.default).iniate(stateLocal.email)
                        ];
                    case 3:
                        userResult = _state.sent();
                        return [
                            4,
                            (0, _userServiceDefault.default).local_login(stateLocal.password, userResult.data.token)
                        ];
                    case 4:
                        passResult = _state.sent();
                        if (passResult.data.hasOwnProperty("user_id")) {
                            result = passResult.data;
                            return [
                                3,
                                11
                            ];
                        }
                        //otherwise mfa store above in state and send to mfa screen //return;
                        setLoginflow(function(values) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                userResult: userResult.data,
                                passResult: passResult.data,
                                step: "v3_tfa_attempt"
                            });
                        });
                        setInFlight(false);
                        setShowMfa(true);
                        return [
                            2
                        ];
                    case 5:
                        setInFlight(true);
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0, _userServiceDefault.default).verify_mfa(stateLocal.mfa, loginFlow.passResult.token)
                        ];
                    case 7:
                        mfaResult = _state.sent();
                        if (!mfaResult.data.hasOwnProperty("user_id")) throw Error("Invalid Code");
                        result = mfaResult.data;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e1 = _state.sent();
                        showErrorMessage("Invalid MFA Token");
                        return [
                            2
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        return [
                            3,
                            11
                        ];
                    case 11:
                        if (!result.session_id) return [
                            3,
                            16
                        ];
                        (0, _axiosDefault.default).defaults.headers.common["x-auth-token"] = result.session_id;
                        (0, _cookieServiceDefault.default).setCookie("session_id", result.session_id, 1, stateApp.env, '/');
                        return [
                            4,
                            (0, _userServiceDefault.default).user_info({
                                headers: {
                                    "x-auth-token": (0, _cookieServiceDefault.default).getCookie("session_id")
                                }
                            })
                        ];
                    case 12:
                        user_info = _state.sent();
                        return [
                            4,
                            (0, _userServiceDefault.default).get_session_timeout_time()
                        ];
                    case 13:
                        session_timeout_time = _state.sent();
                        d = Date.parse(session_timeout_time.data.expiration);
                        (0, _cookieServiceDefault.default).setCookie("session_timeout_time", d, 1, stateApp.env);
                        stateAppActions.setSessionTimeoutTime(d);
                        return [
                            4,
                            Promise.all([
                                determineClouds(),
                                determineOrgs(),
                                determineIntegrations(),
                                determineSkyLiftLink(),
                                determineUpsellsEnabled()
                            ]).then() // 1,Error: 2,3
                            .catch(function(e) {
                                return console.log(e);
                            })
                        ];
                    case 14:
                        _state.sent();
                        //determin what clouds a customer has
                        return [
                            4,
                            doLogin(user_info)
                        ];
                    case 15:
                        _state.sent();
                        (0, _chatServiceDefault.default).getChatCustomer(result.user_name);
                        setInFlight(false);
                        if (returnUrl != null) history.push(returnUrl);
                        else history.push("/app/dashboard");
                        _state.label = 16;
                    case 16:
                        return [
                            3,
                            18
                        ];
                    case 17:
                        error = _state.sent();
                        console.log(error);
                        showErrorMessage("Invalid Username/Password");
                        return [
                            3,
                            18
                        ];
                    case 18:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
};
var ForgotPasswordScreen = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "For your convenience Portal and TRiA use the same password. To reset your Portal password click the link below.",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "pb-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://www.mh.connectria.com/account/forgotpassword",
                    target: "_blank",
                    children: "Click Here To Reset Password"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "lead",
                children: [
                    "If you have any questions please feel free to reach out to us via Chat located in the lower right area of the screen or call ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "tel:+18007817178",
                        children: "+1-800-781-7178 "
                    }),
                    "or email us at ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        href: "mailto:support@connectria.com",
                        children: [
                            "support@connectria.com ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fa fa-envelope",
                                "aria-hidden": "true"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "#",
                onClick: function() {
                    return props.setShowForgotPassword(false);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-arrow-circle-left"
                    }),
                    " Back To Login"
                ]
            })
        ]
    });
};
var MfaForm = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: props.handleSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: "MFA Token"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                autoFocus: true,
                type: "input",
                pattern: "\\d{1,5}",
                value: props.stateLocal.mfa,
                onChange: function(e) {
                    return props.setMfa(e.target.value);
                },
                placeholder: "Enter MFA"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                block: true,
                className: "mt-3",
                disabled: !props.validateForm() || props.inFlight,
                onClick: props.handleSubmit,
                id: "mfa-submit",
                type: "submit",
                children: "Submit"
            })
        ]
    });
};
exports.default = Login;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","../../assets/css/login-box.css":"3ywGJ","react":"gVheC","../../services/CookieService":"iKLPT","../../services/ChatService":"jjcOS","react-router-dom":"acq4R","../../public_cloud/services/service":"7jZw4","../../services/UserService":"4Rf9v","../../services/IBMService":"1UpC4","../../services/OrganizationService":"e5ygN","../../services/BlueMatadorService":"75h8Q","../../services/CloudWatchService":"kxdTC","../../services/TrendMicroService":"4MauW","../../services/PortalService":"9VQnb","axios":"ebRwi","ramda":"2pVIv","../../config":"kQzX9","../../AppState":"8UGXH","../../utility/enum":"3A9fW","reactstrap":"774RE","../../utility/misc":"bM8Mk","../../utility/BrowserSupport":"bugUS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ywGJ":[function() {},{}],"jjcOS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var ChatService = {
    getChatCustomer: function getChatCustomer(username) {
        console.log('chat service');
        console.log(username);
        var customer_chat_lookup = {
            'josbornibmi': "T3U2SMKHAGRYFL5B8X",
            'Sean Alsup': "T099JFQ3TGRK5H081Z",
            'seanalsup314': "T099JFQ3TGRK5H081Z"
        };
        if (customer_chat_lookup[username]) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://embed.small.chat/".concat(customer_chat_lookup[username], ".js");
            setTimeout(function() {
                document.head.appendChild(script);
            }, 3000);
            script.onload = function() {
                var styles = document.createElement('link');
                styles.rel = 'stylesheet';
                styles.href = 'https://static.small.chat/messenger.css';
                document.head.appendChild(styles);
                var script = document.createElement('script');
                script.async = true;
                script.src = 'https://static.small.chat/messenger.js';
                document.body.appendChild(script);
            };
        }
    }
};
exports.default = ChatService;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7jZw4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var base_api = 'https://tria.connectria.com';
var PublicCloudService = {
    resource_query: function resource_query(payload) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var request = (0, _axiosDefault.default).post(base_api + "/v2/public/resource/query", (0, _objectSpread._)({}, payload, params));
        return request;
    },
    list_clouds: function list_clouds() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/v2/public/clouds/list", params);
        return request;
    },
    resourcegroup_list: function resourcegroup_list() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/v2/public/resourcegroups/list", params);
        return request;
    },
    resourcematrix_list: function resourcematrix_list() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/v2/public/resource-matrix", params);
        return request;
    },
    list_clouds_filtered: function list_clouds_filtered() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).post(base_api + "/v2/public/clouds/list", params.payload, params.headers);
        return request;
    },
    list_badge_count_for_resources: function list_badge_count_for_resources() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).post(base_api + "/v2/public/badges/count", params.payload, params.headers);
        return request;
    },
    cloud_types_list: function cloud_types_list() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + '/v2/public/cloudtypes/list', params);
        return request;
    },
    cloud_badges_list: function cloud_badges_list() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + '/v2/public/badge/clouds/assigned/list', params);
        return request;
    }
};
exports.default = PublicCloudService;

},{"@swc/helpers/_/_object_spread":"awG4j","axios":"ebRwi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e5ygN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _userService = require("./UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var base_api = 'https://tria.connectria.com';
var OrganizationService = {
    customer_type: function customer_type() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/plugin/tria_interface/customer_type", params);
        return request;
    },
    customer_message: function customer_message() {
        return (0, _axiosDefault.default).get(base_api + "/plugin/tria_interface/customer_message");
    },
    list_orgs: function list_orgs() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).get(base_api + "/v2/prototype/domain/organizations/get", params);
        return request;
    },
    switch_org: function switch_org() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var request = (0, _axiosDefault.default).post(base_api + "/v2/prototype/domain/switch_organization", params.payload, params.headers);
        return request;
    },
    switchOrganization: function(customer_id, divvyToken) {
        return (0, _asyncToGenerator._)(function() {
            var data, config, resp, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = {
                            customer_id: customer_id
                        };
                        config = {
                            headers: {
                                'x-auth-token': divvyToken
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).post(base_api + "/plugin/tria_interface/switch-organization-new", data, config)
                        ];
                    case 2:
                        resp = _state.sent();
                        return [
                            2,
                            {
                                success: resp.data.success
                            }
                        ];
                    case 3:
                        err = _state.sent();
                        console.error('Error switch Divvy organization', err);
                        return [
                            2,
                            {
                                success: false,
                                error: err
                            }
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
};
exports.default = OrganizationService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","./UserService":"4Rf9v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75h8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _cookieService = require("./CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var blueMatadorApiUrl = 'https://3dxgzxfaa4.execute-api.us-east-1.amazonaws.com/prod';
var cloudAdvisorUrl = 'https://dlfh0e351j.execute-api.us-east-1.amazonaws.com/prod';
var BlueMatadorService = {
    _get: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(endpoint, params) {
            var idToken, orgId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(blueMatadorApiUrl, "/").concat(orgId, "/").concat(endpoint), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: params
                            })
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(endpoint, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    _post: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(url, data) {
            var idToken, orgId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            (0, _axiosDefault.default).post(cloudAdvisorUrl + url, data, {
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    orgId: orgId
                                }
                            })
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(url, data) {
            return _ref.apply(this, arguments);
        };
    }(),
    graphs: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this._get("graphs", params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        ex = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    openedEvents: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var endpoint, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        endpoint = params.id ? "events/" + params.id : "events";
                        return [
                            4,
                            this._get(endpoint, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        ex = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    activeEvents: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this._get("events", params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        ex = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    checkSetup: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var ex;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        this._get("setup")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    ex = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }),
    pageContent: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(url) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            this._post("/bluematador/content", {
                                url: url
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = BlueMatadorService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","../utility/CognitoAuth":"cngmx","./CookieService":"iKLPT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kxdTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var base_api = 'https://tria.connectria.com';
var cloudAdvisorUrl = 'https://dlfh0e351j.execute-api.us-east-1.amazonaws.com/prod';
var CloudWatchService = {
    getAlarms: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(regions) {
            var params, idToken, orgId;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        regions = regions.join(",") || "";
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(cloudAdvisorUrl, "/operations/get/cloudwatchalarms"), {
                                params: {
                                    regions: regions,
                                    orgId: orgId
                                },
                                headers: {
                                    Authorization: idToken
                                }
                            })
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(regions) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = CloudWatchService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","../utility/CognitoAuth":"cngmx","../services/CookieService":"iKLPT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4MauW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _cookieService = require("./CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var cloudAdvisorUrl = 'https://dlfh0e351j.execute-api.us-east-1.amazonaws.com/prod';
var TrendMicroService = {
    _get: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(url, params, config) {
            var idToken, orgId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent(), orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            (0, _axiosDefault.default).get(cloudAdvisorUrl + url, (0, _objectSpread._)({
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    orgId: orgId
                                }, params)
                            }, config))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(url, params, config) {
            return _ref.apply(this, arguments);
        };
    }(),
    _post: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(url, data, config) {
            var idToken, orgId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent(), orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            (0, _axiosDefault.default).post(cloudAdvisorUrl + url, data, (0, _objectSpread._)({
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    orgId: orgId
                                }
                            }, config))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(url, data, config) {
            return _ref.apply(this, arguments);
        };
    }(),
    checkSetup: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        this._get('/trendmicro/setup')
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    computers: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        this._get('/trendmicro/computers', params)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }),
    antimalware: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(date, operator, max) {
            var config, handleException, ex;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, handleException = _arguments.length > 4 ? _arguments[4] : void 0;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this._get('/trendmicro/antimalware', {
                                dateToSearch: date,
                                dateOperator: operator,
                                maxItems: max
                            }, config)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        ex = _state.sent();
                        if (handleException) return [
                            2,
                            null
                        ];
                        else throw ex;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(date, operator, max) {
            return _ref.apply(this, arguments);
        };
    }(),
    antimalwareEvent: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(eventId) {
            var params, config;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, config = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                        return [
                            4,
                            this._get("/trendmicro/antimalwareEvent", {
                                eventId: eventId
                            }, config)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(eventId) {
            return _ref.apply(this, arguments);
        };
    }(),
    integrity: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(date, operator, max) {
            var config;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                        return [
                            4,
                            this._get('/trendmicro/integrity', {
                                dateToSearch: date,
                                dateOperator: operator,
                                maxItems: max
                            }, config)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(date, operator, max) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = TrendMicroService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","../utility/CognitoAuth":"cngmx","./CookieService":"iKLPT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bugUS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var detect = require("aa6ee8476a71a7d7").detect;
var BrowserSupport = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), showMsg = _useState[0], setShowMsg = _useState[1];
    (0, _react.useEffect)(function() {
        var browser = detect();
        switch(browser && browser.name){
            case "chrome":
            case "firefox":
                setShowMsg(false);
                break;
            case "edge":
            case "ie":
                setShowMsg(true);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: !showMsg ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "alert alert-danger",
            role: "alert",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "h4 text-center",
                    style: {
                        color: 'white'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-info-circle"
                        }),
                        " Internet Explorer is currently not compatible with our application - Please use Chrome, Firefox, or Safari."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "close",
                    onClick: function() {
                        setShowMsg(false);
                    },
                    "data-dismiss": "alert",
                    "aria-label": "Close",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        children: "\xd7"
                    })
                })
            ]
        })
    });
};
exports.default = BrowserSupport;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","aa6ee8476a71a7d7":"9rtYB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9rtYB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserInfo", function() {
    return BrowserInfo;
});
parcelHelpers.export(exports, "NodeInfo", function() {
    return NodeInfo;
});
parcelHelpers.export(exports, "SearchBotDeviceInfo", function() {
    return SearchBotDeviceInfo;
});
parcelHelpers.export(exports, "BotInfo", function() {
    return BotInfo;
});
parcelHelpers.export(exports, "ReactNativeInfo", function() {
    return ReactNativeInfo;
});
parcelHelpers.export(exports, "detect", function() {
    return detect;
});
parcelHelpers.export(exports, "browserName", function() {
    return browserName;
});
parcelHelpers.export(exports, "parseUserAgent", function() {
    return parseUserAgent;
});
parcelHelpers.export(exports, "detectOS", function() {
    return detectOS;
});
parcelHelpers.export(exports, "getNodeVersion", function() {
    return getNodeVersion;
});
var process = require("333d4e2381a056a9");
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}();
var NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}();
var SearchBotDeviceInfo = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}();
var BotInfo = /** @class */ function() {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var ReactNativeInfo = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    [
        'aol',
        /AOLShield\/([0-9\._]+)/
    ],
    [
        'edge',
        /Edge\/([0-9\._]+)/
    ],
    [
        'edge-ios',
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        'yandexbrowser',
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        'kakaotalk',
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        'samsung',
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        'silk',
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        'miui',
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        'beaker',
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        'edge-chromium',
        /EdgA?\/([0-9\.]+)/
    ],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'chrome',
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'phantomjs',
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'crios',
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'firefox',
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'fxios',
        /FxiOS\/([0-9\.]+)/
    ],
    [
        'opera-mini',
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        'opera',
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        'opera',
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        'pie',
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        'pie',
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        'netfront',
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        'ie',
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        'ie',
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        'ie',
        /MSIE\s(7\.0)/
    ],
    [
        'bb10',
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        'android',
        /Android\s([0-9\.]+)/
    ],
    [
        'ios',
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        'safari',
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        'facebook',
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        'instagram',
        /Instagram\s([0-9\.]+)/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        'ios-webview',
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        'curl',
        /^curl\/([0-9\.]+)$/
    ],
    [
        'searchbot',
        SEARCHBOX_UA_REGEX
    ]
];
var operatingSystemRules = [
    [
        'iOS',
        /iP(hone|od|ad)/
    ],
    [
        'Android OS',
        /Android/
    ],
    [
        'BlackBerry OS',
        /BlackBerry|BB10/
    ],
    [
        'Windows Mobile',
        /IEMobile/
    ],
    [
        'Amazon OS',
        /Kindle/
    ],
    [
        'Windows 3.11',
        /Win16/
    ],
    [
        'Windows 95',
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        'Windows 98',
        /(Windows 98)|(Win98)/
    ],
    [
        'Windows 2000',
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        'Windows XP',
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        'Windows Server 2003',
        /(Windows NT 5.2)/
    ],
    [
        'Windows Vista',
        /(Windows NT 6.0)/
    ],
    [
        'Windows 7',
        /(Windows NT 6.1)/
    ],
    [
        'Windows 8',
        /(Windows NT 6.2)/
    ],
    [
        'Windows 8.1',
        /(Windows NT 6.3)/
    ],
    [
        'Windows 10',
        /(Windows NT 10.0)/
    ],
    [
        'Windows ME',
        /Windows ME/
    ],
    [
        'Windows CE',
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        'Open BSD',
        /OpenBSD/
    ],
    [
        'Sun OS',
        /SunOS/
    ],
    [
        'Chrome OS',
        /CrOS/
    ],
    [
        'Linux',
        /(Linux)|(X11)/
    ],
    [
        'Mac OS',
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        'QNX',
        /QNX/
    ],
    [
        'BeOS',
        /BeOS/
    ],
    [
        'OS/2',
        /OS\/2/
    ]
];
function detect(userAgent) {
    if (!!userAgent) return parseUserAgent(userAgent);
    if (typeof document === 'undefined' && typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return new ReactNativeInfo();
    if (typeof navigator !== 'undefined') return parseUserAgent(navigator.userAgent);
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== '' && userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') return new BotInfo();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) versionParts = __spreadArray(__spreadArray([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join('.');
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for(var ii = 0, count = operatingSystemRules.length; ii < count; ii++){
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push('0');
    return output;
}

},{"333d4e2381a056a9":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gpEym":[function(require,module,exports,__globalThis) {
var process = require("7ed205b82ac06eb0");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
        return _chart["default"];
    }
});
exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
var _react = _interopRequireDefault(require("2175fdc2d27598a9"));
var _propTypes = _interopRequireDefault(require("655d83f0faa32c07"));
var _chart = _interopRequireDefault(require("1e351b52fa7d3315"));
var _isEqual = _interopRequireDefault(require("9e9bfa8868fcaf9a"));
var _keyBy = _interopRequireDefault(require("da700f9ac95240f2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var NODE_ENV = typeof process !== 'undefined' && process.env && "production";
var ChartComponent = /*#__PURE__*/ function(_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        _classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        _defineProperty(_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    _createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, _isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, _isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, _isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == 'function') {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return _objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = _objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return _objectSpread(_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = _objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new _chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ _react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}(_react["default"].Component);
_defineProperty(ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
_defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([
        _propTypes["default"].object,
        _propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!_chart["default"].controllers[props[propName]]) return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
});
_defineProperty(ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
});
var _default = ChartComponent;
exports["default"] = _default;
var Doughnut = /*#__PURE__*/ function(_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
        _classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}(_react["default"].Component);
exports.Doughnut = Doughnut;
var Pie = /*#__PURE__*/ function(_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
        _classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    _createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}(_react["default"].Component);
exports.Pie = Pie;
var Line = /*#__PURE__*/ function(_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
        _classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    _createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}(_react["default"].Component);
exports.Line = Line;
var Bar = /*#__PURE__*/ function(_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
        _classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    _createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}(_react["default"].Component);
exports.Bar = Bar;
var HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
        _classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}(_react["default"].Component);
exports.HorizontalBar = HorizontalBar;
var Radar = /*#__PURE__*/ function(_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
        _classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    _createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}(_react["default"].Component);
exports.Radar = Radar;
var Polar = /*#__PURE__*/ function(_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
        _classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    _createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}(_react["default"].Component);
exports.Polar = Polar;
var Bubble = /*#__PURE__*/ function(_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
        _classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}(_react["default"].Component);
exports.Bubble = Bubble;
var Scatter = /*#__PURE__*/ function(_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
        _classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ _react["default"].createElement(ChartComponent, _extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}(_react["default"].Component);
exports.Scatter = Scatter;
var defaults = _chart["default"].defaults;
exports.defaults = defaults;

},{"7ed205b82ac06eb0":"4avz9","2175fdc2d27598a9":"gVheC","655d83f0faa32c07":"3KNJy","1e351b52fa7d3315":"lnZVo","9e9bfa8868fcaf9a":"6bbKw","da700f9ac95240f2":"2V8lJ"}],"lnZVo":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return require("dcf84c2b8d413eca");
        } catch (e) {}
    }());
})(undefined, function(moment) {
    'use strict';
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: 'rgb'
            },
            hsl: {
                channels: 3,
                labels: 'hsl'
            },
            hsv: {
                channels: 3,
                labels: 'hsv'
            },
            hwb: {
                channels: 3,
                labels: 'hwb'
            },
            cmyk: {
                channels: 4,
                labels: 'cmyk'
            },
            xyz: {
                channels: 3,
                labels: 'xyz'
            },
            lab: {
                channels: 3,
                labels: 'lab'
            },
            lch: {
                channels: 3,
                labels: 'lch'
            },
            hex: {
                channels: 1,
                labels: [
                    'hex'
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    'keyword'
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    'ansi16'
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    'ansi256'
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    'h',
                    'c',
                    'g'
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    'r16',
                    'g16',
                    'b16'
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    'gray'
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
            if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
                value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function diffc(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var _$keyword in colorName)if (colorName.hasOwnProperty(_$keyword)) {
                var value = colorName[_$keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = _$keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
                return char + char;
            }).join('');
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function route(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function wrappedFn(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function wrappedFn(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if ((typeof result === "undefined" ? "undefined" : (0, _typeOf._)(result)) === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, _$keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(_$keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function Color1(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === 'string') {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues('rgb', vals);
            else if (vals = colorString.getHsla(obj)) this.setValues('hsl', vals);
            else if (vals = colorString.getHwb(obj)) this.setValues('hwb', vals);
        } else if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) === 'object') {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        }
    };
    Color.prototype = {
        isValid: function isValid() {
            return this.valid;
        },
        rgb: function rgb() {
            return this.setSpace('rgb', arguments);
        },
        hsl: function hsl() {
            return this.setSpace('hsl', arguments);
        },
        hsv: function hsv() {
            return this.setSpace('hsv', arguments);
        },
        hwb: function hwb() {
            return this.setSpace('hwb', arguments);
        },
        cmyk: function cmyk() {
            return this.setSpace('cmyk', arguments);
        },
        rgbArray: function rgbArray() {
            return this.values.rgb;
        },
        hslArray: function hslArray() {
            return this.values.hsl;
        },
        hsvArray: function hsvArray() {
            return this.values.hsv;
        },
        hwbArray: function hwbArray() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function cmykArray() {
            return this.values.cmyk;
        },
        rgbaArray: function rgbaArray() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function hslaArray() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function alpha(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues('alpha', val);
            return this;
        },
        red: function red(val) {
            return this.setChannel('rgb', 0, val);
        },
        green: function green(val) {
            return this.setChannel('rgb', 1, val);
        },
        blue: function blue(val) {
            return this.setChannel('rgb', 2, val);
        },
        hue: function hue(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel('hsl', 0, val);
        },
        saturation: function saturation(val) {
            return this.setChannel('hsl', 1, val);
        },
        lightness: function lightness(val) {
            return this.setChannel('hsl', 2, val);
        },
        saturationv: function saturationv(val) {
            return this.setChannel('hsv', 1, val);
        },
        whiteness: function whiteness(val) {
            return this.setChannel('hwb', 1, val);
        },
        blackness: function blackness(val) {
            return this.setChannel('hwb', 2, val);
        },
        value: function value(val) {
            return this.setChannel('hsv', 2, val);
        },
        cyan: function cyan(val) {
            return this.setChannel('cmyk', 0, val);
        },
        magenta: function magenta(val) {
            return this.setChannel('cmyk', 1, val);
        },
        yellow: function yellow(val) {
            return this.setChannel('cmyk', 2, val);
        },
        black: function black(val) {
            return this.setChannel('cmyk', 3, val);
        },
        hexString: function hexString() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function rgbString() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function rgbaString() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function percentString() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function hslString() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function hslaString() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function hwbString() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function keyword() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function rgbNumber() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function luminosity() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function contrast(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function level(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return 'AAA';
            return contrastRatio >= 4.5 ? 'AA' : '';
        },
        dark: function dark() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function light() {
            return !this.dark();
        },
        negate: function negate() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues('rgb', rgb);
            return this;
        },
        lighten: function lighten(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        darken: function darken(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        saturate: function saturate(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        desaturate: function desaturate(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        whiten: function whiten(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        blacken: function blacken(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        greyscale: function greyscale() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues('rgb', [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function clearer(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha - alpha * ratio);
            return this;
        },
        opaquer: function opaquer(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha + alpha * ratio);
            return this;
        },
        rotate: function rotate(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues('hsl', hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function mix(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function toJSON() {
            return this.rgb();
        },
        clone: function clone() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === '[object Array]') target[prop] = value.slice(0);
                else if (type === '[object Number]') target[prop] = value;
                else console.error('unexpected color value:', value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === 'alpha') alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === 'alpha') return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== 'undefined') window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            '__proto__',
            'prototype',
            'constructor'
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function noop() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function isNullOrUndef(value) {
            return value === null || typeof value === 'undefined';
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function isArray(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function isObject(value) {
            return value !== null && Object.prototype.toString.call(value) === '[object Object]';
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function isFinite1(value) {
            return (typeof value === 'number' || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function valueOrDefault(value, defaultValue) {
            return typeof value === 'undefined' ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function callback(fn, args, thisArg) {
            if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function each(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function arrayEquals(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function clone(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function _merger(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function _mergerIf(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function merge(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function mergeIf(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function merger(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function inherits(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function ChartElement() {
                return me.apply(this, arguments);
            };
            var Surrogate = function Surrogate() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function _deprecated(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function linear(t) {
            return t;
        },
        easeInQuad: function easeInQuad(t) {
            return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function easeInOutQuad(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function easeInCubic(t) {
            return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function easeInQuart(t) {
            return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function easeInOutQuart(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function easeInQuint(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function easeInOutQuint(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function easeInSine(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function easeOutSine(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function easeInOutSine(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function easeInExpo(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function easeOutExpo(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function easeInOutExpo(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function easeInCirc(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function easeOutCirc(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function easeInOutCirc(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function easeInElastic(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function easeOutElastic(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function easeInOutElastic(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function easeInBack(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function easeOutBack(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function easeInOutBack(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function easeInBounce(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function easeOutBounce(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function easeInOutBounce(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function clear(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && (typeof style === "undefined" ? "undefined" : (0, _typeOf._)(style)) === 'object') {
                type = style.toString();
                if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case 'triangle':
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case 'rectRounded':
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case 'rect':
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case 'rectRot':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case 'crossRot':
                    rad += QUARTER_PI;
                /* falls through */ case 'cross':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'star':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'line':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case 'dash':
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function _isPointInArea(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function clipArea(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function unclipArea(ctx) {
            ctx.restore();
        },
        lineTo: function lineTo(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === 'middle') {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function _set(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set('global', {
        defaultColor: 'rgba(0,0,0,0.1)',
        defaultFontColor: '#666',
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: 'normal',
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function toLineHeight(value, size) {
            var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === 'normal') return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case 'px':
                    return value;
                case '%':
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function toPadding(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function _parseFont(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ''
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function resolve(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === 'function') {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function _factorize(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
        return {
            x: function x(_x) {
                return rectX + rectX + width - _x;
            },
            setWidth: function setWidth(w) {
                width = w;
            },
            textAlign: function textAlign(align) {
                if (align === 'center') return align;
                return align === 'right' ? 'left' : 'right';
            },
            xPlus: function xPlus(x, value) {
                return x - value;
            },
            leftForLtr: function leftForLtr(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function getLtrAdapter() {
        return {
            x: function x(_x) {
                return _x;
            },
            setWidth: function setWidth(w) {},
            textAlign: function textAlign(align) {
                return align;
            },
            xPlus: function xPlus(x, value) {
                return x + value;
            },
            leftForLtr: function leftForLtr(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
        var style, original;
        if (direction === 'ltr' || direction === 'rtl') {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue('direction'),
                style.getPropertyPriority('direction')
            ];
            style.setProperty('direction', direction, 'important');
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty('direction', original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === '_') continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target === "undefined" ? "undefined" : (0, _typeOf._)(target);
            if (type === (typeof origin === "undefined" ? "undefined" : (0, _typeOf._)(origin))) {
                if (type === 'string') {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function Element(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function initialize() {
            this.hidden = false;
        },
        pivot: function pivot() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function transition(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function tooltipPosition() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function hasValue() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: '',
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'animationObject', {
        get: function get() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'chartInstance', {
        get: function get() {
            return this.chart;
        },
        set: function set(value) {
            this.chart = value;
        }
    });
    core_defaults._set('global', {
        animation: {
            duration: 1000,
            easing: 'easeOutQuart',
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function addAnimation(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function cancelAnimation(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function requestAnimationFrame() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function startDigest() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function advance() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        'push',
        'pop',
        'shift',
        'splice',
        'unshift'
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, '_chartjs', {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function value() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === 'function') object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function DatasetController(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth'
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'pointStyle'
        ],
        initialize: function initialize(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function updateIndex(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function linkScales() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function getDataset() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function getMeta() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function getScaleForId(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function _getValueScaleId() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function _getIndexScaleId() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function _getValueScale() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function _getIndexScale() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function reset() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function destroy() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function createMetaDataset() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function createMetaData(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function addElements() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function addElementAndReset(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function buildOrUpdateElements() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function _configure() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function merger(key, target, source) {
                    if (key !== '_meta' && key !== 'data') helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function _update(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function transition(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function draw() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function getStyle(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function removeHoverStyle(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function setHoverStyle(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function _setDatasetHoverStyle() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function resyncElements() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function insertElements(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function onDataPush() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function onDataPop() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function onDataShift() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function onDataSplice(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function onDataUnshift() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
                borderAlign: 'center'
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === 'inner';
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = 'round';
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = 'bevel';
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: 'arc',
        inLabelRange: function inLabelRange(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function inRange(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function getCenterPoint() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function getArea() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function tooltipPosition() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function draw() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: 'line',
        draw: function draw() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: 'point',
        inRange: function inRange(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function getCenterPoint() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function getArea() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function tooltipPosition() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function draw(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: 'bottom',
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, 'left', 'right');
        } else if (vm.base < vm.y) edge = swap(edge, 'bottom', 'top');
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: 'rectangle',
        draw: function draw() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill('evenodd');
            ctx.restore();
        },
        height: function height() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function inRange1(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function inLabelRange(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function inXRange(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function inYRange(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function getCenterPoint() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function getArea() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function tooltipPosition() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear'
                }
            ]
        }
    });
    core_defaults._set('global', {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderSkipped',
            'borderWidth',
            'barPercentage',
            'barThickness',
            'categoryPercentage',
            'maxBarThickness',
            'minBarLength'
        ],
        initialize: function initialize() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
            deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
            deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
            deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
            deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
        },
        update: function update(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function updateElement(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function _getStacks(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function getStackCount() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function getStackIndex(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function getRuler() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function draw() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function _resolveDataElementOptions() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom',
                    id: 'x-axis-0' // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-0'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function title() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return '';
                },
                label: function label(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || '';
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth',
            'hoverRadius',
            'hitRadius',
            'pointStyle',
            'rotation'
        ],
        /**
	 * @protected
	 */ update: function update(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function updateElement(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue((typeof data === "undefined" ? "undefined" : (0, _typeOf._)(data)) === 'object' ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function setHoverStyle(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: 'single'
        },
        legendCallback: function legendCallback(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function generateLabels(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function onClick(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function title() {
                    return '';
                },
                label: function label(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function getRingIndex(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function update(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function updateElement(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function calculateTotal() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function calculateCircumference(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function getMaxBorderWidth(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== 'inner') {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function setHoverStyle(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function _getRingWeight(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set('horizontalBar', {
        hover: {
            mode: 'index',
            axis: 'y'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    type: 'category',
                    position: 'left',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: 'left'
            }
        },
        tooltips: {
            mode: 'index',
            axis: 'y'
        }
    });
    core_defaults._set('global', {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function _getValueScaleId() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function _getIndexScaleId() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    id: 'x-axis-0'
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    id: 'y-axis-0'
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth',
            'cubicInterpolationMode',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        update: function update(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function updateElement(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function calculatePointY(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function updateBezierControlPoints() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === 'monotone') helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function draw() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function setHoverStyle(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
        scale: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function legendCallback(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function generateLabels(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function onClick(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function title() {
                    return '';
                },
                label: function label(item, data) {
                    return data.labels[item.index] + ': ' + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function _getIndexScaleId() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function _getValueScaleId() {
            return this.chart.scale.id;
        },
        update: function update(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function _updateRadius() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function updateElement(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function countVisibleElements() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function setHoverStyle(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function _computeAngle(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
        spanGaps: false,
        scale: {
            type: 'radialLinear'
        },
        elements: {
            line: {
                fill: 'start',
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderWidth',
            'borderColor',
            'borderCapStyle',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        /**
	 * @private
	 */ _getIndexScaleId: function _getIndexScaleId() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function _getValueScaleId() {
            return this.chart.scale.id;
        },
        update: function update(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function updateElement(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function updateBezierControlPoints() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function setHoverStyle(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set('scatter', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    id: 'x-axis-1',
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    id: 'y-axis-1',
                    type: 'linear',
                    position: 'left'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function title() {
                    return ''; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function label(item) {
                    return '(' + item.xLabel + ', ' + item.yLabel + ')';
                }
            }
        }
    });
    core_defaults._set('global', {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf('x') !== -1;
        var useY = axis.indexOf('y') !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || 'x';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function single(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function dataset(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ 'x-axis': function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function point(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function nearest(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function x(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function y(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
        var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, 'chartArea'),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos('top');
        chartArea.x += updatePos('left');
        updatePos('right');
        updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            'left',
            'right'
        ]) : marginForPositions([
            'top',
            'bottom'
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set('global', {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function addBox(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || 'top';
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function draw() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function removeBox(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function configure(chart, item, options) {
            var props = [
                'fullWidth',
                'position',
                'weight'
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function update(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function acquireContext(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext('2d') || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = [
        'animationstart',
        'webkitAnimationStart'
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
        pointerenter: 'mouseenter',
        pointerdown: 'mousedown',
        pointermove: 'mousemove',
        pointerup: 'mouseup',
        pointerleave: 'mouseout',
        pointerout: 'mouseout'
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute('height');
        var renderWidth = canvas.getAttribute('width');
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || 'block';
        if (renderWidth === null || renderWidth === '') {
            var displayWidth = readUsedSize(canvas, 'width');
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === '') {
            if (canvas.style.height === '') // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, 'height');
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, 'passive', {
                // eslint-disable-next-line getter-return
                get: function get() {
                    supports = true;
                }
            });
            window.addEventListener('e', null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement('div');
        el.className = cls || '';
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
        var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function onScroll() {
            resizer._reset();
            handler();
        };
        addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
        addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function proxy(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent('resize', chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent('resize', chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = '/* Chart.js */\n' + css;
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function _ensureLoaded(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function acquireContext(item, config) {
            if (typeof item === 'string') item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext('2d');
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function releaseContext(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                'height',
                'width'
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function addEventListener(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + '_' + type] = function proxy(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function removeEventListener(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + '_' + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function initialize() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function acquireContext() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function releaseContext() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function addEventListener() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function register(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function unregister(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function clear() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function count() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function getAll() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function notify(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === 'function') {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function descriptors(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function _invalidate(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function getScaleConstructor(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function getScaleDefaults(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function updateScaleDefaults(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function addScalesToLayout(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
        tooltips: {
            enabled: true,
            custom: null,
            mode: 'nearest',
            position: 'average',
            intersect: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleFontStyle: 'bold',
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: '#fff',
            titleAlign: 'left',
            bodySpacing: 2,
            bodyFontColor: '#fff',
            bodyAlign: 'left',
            footerFontStyle: 'bold',
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: '#fff',
            footerAlign: 'left',
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: '#fff',
            displayColors: true,
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function title(tooltipItems, data) {
                    var title = '';
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function label(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label += ': ';
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function labelColor(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function labelTextColor() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function average(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function nearest(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
            label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
            value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function maxLineWidth(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = 'center';
        var yAlign = 'center';
        if (model.y < size.height) yAlign = 'top';
        else if (model.y > chart.height - size.height) yAlign = 'bottom';
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === 'center') {
            lf = function lf(x) {
                return x <= midX;
            };
            rf = function rf(x) {
                return x > midX;
            };
        } else {
            lf = function lf(x) {
                return x <= size.width / 2;
            };
            rf = function rf(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function olf(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function orf(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function yf(y) {
            return y <= midY ? 'top' : 'bottom';
        };
        if (lf(model.x)) {
            xAlign = 'left';
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = 'right';
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === 'right') x -= size.width;
        else if (xAlign === 'center') {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === 'top') y += paddingAndSize;
        else if (yAlign === 'bottom') y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === 'center') {
            if (xAlign === 'left') x += paddingAndSize;
            else if (xAlign === 'right') x -= paddingAndSize;
        } else if (xAlign === 'left') x -= radiusAndPadding;
        else if (xAlign === 'right') x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function initialize() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function getTitle() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function getBeforeBody() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function getBody(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function getAfterBody() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function getFooter() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function update(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function drawCaret(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === 'center') {
                y2 = ptY + height / 2;
                if (xAlign === 'left') {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === 'left') {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === 'right') {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === 'top') {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function drawTitle(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = 'middle';
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function drawBody(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function fillLineOfText(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = 'middle';
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function drawFooter(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = 'middle';
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === 'top') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === 'bottom') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function draw() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function handleEvent(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === 'mouseout') me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        elements: {},
        events: [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ],
        hover: {
            onHover: null,
            mode: 'nearest',
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function merger(key, target, source, options) {
                if (key === 'xAxes' || key === 'yAxes') {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function merger(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === 'scales') // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === 'scale') // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function hasId(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function Chart(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function construct(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, 'data', {
                get: function get() {
                    return me.config.data;
                },
                set: function set(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function initialize() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, 'beforeInit');
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, 'afterInit');
            return me;
        },
        clear: function clear() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function stop() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function resize(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + 'px';
            canvas.style.height = newHeight + 'px';
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, 'resize', [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function ensureScalesHaveIDs() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || 'scale';
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function buildOrUpdateScales() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: 'category',
                    dposition: 'bottom'
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: 'linear',
                    dposition: 'left'
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: 'radialLinear',
                isDefault: true,
                dposition: 'chartArea'
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function buildOrUpdateControllers() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function resetElements() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function reset() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function update(config) {
            var me = this;
            var i, ilen;
            if (!config || (typeof config === "undefined" ? "undefined" : (0, _typeOf._)(config)) !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, 'beforeUpdate') === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, 'afterUpdate');
            me._layers.sort(compare2Level('z', '_idx'));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function updateLayout() {
            var me = this;
            if (core_plugins.notify(me, 'beforeLayout') === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, 'afterScaleUpdate');
            core_plugins.notify(me, 'afterLayout');
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function updateDatasets() {
            var me = this;
            if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, 'afterDatasetsUpdate');
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function updateDataset(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, 'beforeDatasetUpdate', [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, 'afterDatasetUpdate', [
                args
            ]);
        },
        render: function render(config) {
            var me = this;
            if (!config || (typeof config === "undefined" ? "undefined" : (0, _typeOf._)(config)) !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, 'beforeRender') === false) return;
            var onComplete = function onComplete(animation) {
                core_plugins.notify(me, 'afterRender');
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function render(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function draw(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, 'beforeDraw', [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, 'afterDraw', [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function transition(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level('order', 'index'));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function drawDatasets(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, 'beforeDatasetsDraw', [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, 'afterDatasetsDraw', [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function drawDataset(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeDatasetDraw', [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, 'afterDatasetDraw', [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function _drawTooltip(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeTooltipDraw', [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, 'afterTooltipDraw', [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function getElementAtEvent(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function getElementsAtEvent(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function getElementsAtXAxis(e) {
            return core_interaction.modes['x-axis'](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === 'function') return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function getDatasetAtEvent(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function getDatasetMeta(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function getVisibleDatasetCount() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function isDatasetVisible(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function generateLegend() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function destroy() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, 'destroy');
            delete Chart.instances[me.id];
        },
        toBase64Image: function toBase64Image() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function initToolTip() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function bindEvents() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function listener() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function listener() {
                    me.resize();
                };
                platform.addEventListener(me, 'resize', listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function unbindEvents() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
            var prefix = enabled ? 'set' : 'remove';
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
            }
            if (mode === 'dataset') this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        },
        /**
	 * @private
	 */ eventHandler: function eventHandler(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, 'beforeEvent', [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, 'afterEvent', [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function handleEvent(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === 'mouseout') me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === 'mouseup' || e.type === 'click') {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === 'undefined') return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === 'string') {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== 'none';
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return 'none';
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, 'max-width', 'clientWidth');
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, 'max-height', 'clientHeight');
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + 'px';
                canvas.style.width = width + 'px';
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error('Color.js not found!');
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function _create(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function values(value) {
                return helpers$1.isArray(value) ? value : '' + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function linear(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = '';
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = '0'; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function logarithmic(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return '0';
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return '';
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
        display: true,
        position: 'left',
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: 'rgba(0,0,0,0.25)',
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: '',
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== 'undefined') filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function getPadding() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function getTicks() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function _getLabels() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function mergeTicksOptions() {
        // noop
        },
        beforeUpdate: function beforeUpdate() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function update(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function _configure() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function afterUpdate() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function beforeSetDimensions() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function setDimensions() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function afterSetDimensions() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function beforeDataLimits() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function afterDataLimits() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function beforeBuildTicks() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function afterBuildTicks(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function beforeTickToLabelConversion() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function convertTicksToLabels() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function afterTickToLabelConversion() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function beforeCalculateTickRotation() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function calculateTickRotation() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function afterCalculateTickRotation() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function beforeFit() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function fit() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === 'bottom';
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function handleMargins() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function afterFit() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function isHorizontal() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        isFullWidth: function isFullWidth() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function getRightValue(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function _convertTicksToLabels(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function _getLabelSizes() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function _parseValue(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function _getScaleLabel(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return '[' + v.start + ', ' + v.end + ']';
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function getPixelForTick(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function getPixelForDecimal(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function getDecimalForPixel(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function getBasePixel() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function getBaseValue() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function _autoSkip(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function _tickSize() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function _isVisible() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== 'auto') return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function _computeGridLineItems(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function alignBorderValue(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === 'top') {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === 'bottom') {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === 'left') {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function _computeLabelItems() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === 'top') {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? 'center' : 'left';
            } else if (position === 'bottom') {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? 'center' : 'right';
            } else if (position === 'left') {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? 'left' : 'right';
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? 'right' : 'left';
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function _drawGrid(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function _drawLabels() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = 'middle';
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText('' + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function _drawTitle() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === 'left';
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function draw(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function _layers() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function draw() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function draw() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function draw() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: 'bottom'
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function determineDataLimits() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function buildTicks() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function _configure() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function getPixelForTick(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function getValueForPixel(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function getBasePixel() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function getRightValue(value) {
            if (typeof value === 'string') return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function handleTickRangeOptions() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function getTickLimit() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function _computeTickLimit() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function buildTicks() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function convertTicksToLabels() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function _configure() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: 'left',
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : '',
            meta.stack
        ].join('.');
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function determineDataLimits() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function _computeTickLimit() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function handleDirectionalChanges() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function getPixelForValue(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function getValueForPixel(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function getPixelForTick(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: 'left',
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function determineDataLimits() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '',
                        meta.stack
                    ].join('.');
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function handleTickRangeOptions() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function buildTicks() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function convertTicksToLabels() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function getPixelForTick(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function _getFirstTickValue(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function _configure() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function getPixelForValue(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function getValueForPixel(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: 'rgba(255,255,255,0.75)',
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function callback(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return 'center';
        else if (angle < 180) return 'left';
        return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = 'middle';
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function setDimensions() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function determineDataLimits() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function _computeTickLimit() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function convertTicksToLabels() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : '';
            });
        },
        getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function fit() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function getIndexAngle(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function getPointPosition(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function getPointPositionForValue(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function getBasePosition(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function _drawGrid() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function _drawLabels() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === 'linear' || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === 'function') value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === 'function') {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? 'day' : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === 'ticks') ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, 'time', ticks[0], 'pos');
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
            last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: 'bottom',
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: 'linear',
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: 'auto',
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function initialize() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function update() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1('time scale', time.format, 'time.format', 'time.parser');
            deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
            deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function getRightValue(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function determineDataLimits() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || 'day';
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function buildTicks() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === 'data' || source === 'auto' && distribution === 'series') timestamps = timestamps.data;
            else if (source === 'labels') timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === 'ticks' && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : '';
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === 'string') return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function convertTicksToLabels(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function getPixelForOffset(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, 'time', time, 'pos');
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function getPixelForTick(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function getValueForPixel(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, 'pos', pos, 'time');
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function _getLabelSize(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function getLabelWidth(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function getLabelCapacity(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: 'MMM D, YYYY, h:mm:ss a',
        millisecond: 'h:mm:ss.SSS a',
        second: 'h:mm:ss a',
        minute: 'h:mm a',
        hour: 'hA',
        day: 'MMM D',
        week: 'll',
        month: 'MMM YYYY',
        quarter: '[Q]Q - YYYY',
        year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
        _id: 'moment',
        formats: function formats() {
            return FORMATS;
        },
        parse: function parse(value, format) {
            if (typeof value === 'string' && typeof format === 'string') value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function format(time, _format) {
            return moment(time).format(_format);
        },
        add: function add(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function diff(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function startOf(time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function endOf(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function _create(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set('global', {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function dataset(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function boundary(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return 'origin';
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === '-' || fill[0] === '+') target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case 'bottom':
                return 'start';
            case 'top':
                return 'end';
            case 'zero':
                return 'origin';
            // supported boundaries
            case 'origin':
            case 'start':
            case 'end':
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === 'start') target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === 'end') target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = 'dataset';
        if (fill === false) return null;
        if (!isFinite(fill)) type = 'boundary';
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: 'filler',
        afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        legend: {
            display: true,
            position: 'top',
            align: 'center',
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function onClick(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function generateLabels(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function legendCallback(chart) {
            var list = document.createElement('ul');
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function initialize(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function update(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function setDimensions() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function buildLabels() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function fit() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function isHorizontal() {
            return this.options.position === 'top' || this.options.position === 'bottom';
        },
        // Actually draw the legend on the canvas
        draw: function draw() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign('left');
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function drawLegendBox(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function fillText(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function alignmentOffset(dimension, blockSize) {
                switch(opts.align){
                    case 'start':
                        return labelOpts.padding;
                    case 'end':
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function _getLegendItemAt(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function handleEvent(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === 'mouseup' ? 'click' : e.type;
            var hoveredItem;
            if (type === 'mousemove') {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === 'click') {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === 'click') {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: 'legend',
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function beforeInit(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function beforeUpdate(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function afterEvent(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
        title: {
            display: false,
            fontStyle: 'bold',
            fullWidth: true,
            padding: 10,
            position: 'top',
            text: '',
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function initialize(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function update(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function setDimensions() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function fit() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function isHorizontal() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        // Actually draw the title block on the canvas
        draw: function draw() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === 'left' ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: 'title',
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function beforeInit(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function beforeUpdate(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        'Bar',
        'Bubble',
        'Doughnut',
        'Line',
        'PolarArea',
        'Radar',
        'Scatter'
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

},{"@swc/helpers/_/_type_of":"668P4","dcf84c2b8d413eca":"3xZWN"}],"2V8lJ":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("c46c3767ff672674"), createAggregator = require("6b8d7408337ccc56");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var keyBy = createAggregator(function(result, value, key) {
    baseAssignValue(result, key, value);
});
module.exports = keyBy;

},{"c46c3767ff672674":"8nNdL","6b8d7408337ccc56":"ckIws"}],"8nNdL":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"2iIpD"}],"2iIpD":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bRlM4"}],"ckIws":[function(require,module,exports,__globalThis) {
var arrayAggregator = require("64738ab87169df22"), baseAggregator = require("d5eaf98cd48e9d0f"), baseIteratee = require("161d63ee0d95ee81"), isArray = require("3ebefba2225c8b9e");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
module.exports = createAggregator;

},{"64738ab87169df22":"6ov0I","d5eaf98cd48e9d0f":"1FhrN","161d63ee0d95ee81":"exkHY","3ebefba2225c8b9e":"jQGs4"}],"6ov0I":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = arrayAggregator;

},{}],"1FhrN":[function(require,module,exports,__globalThis) {
var baseEach = require("b2d4f581dd6625d8");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = baseAggregator;

},{"b2d4f581dd6625d8":"eUqSn"}],"eUqSn":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"aVySe","f1e3fc84161ef3ec":"7xdi9"}],"aVySe":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"37PNv","1fb77c53defe5720":"kLvI9"}],"37PNv":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"6xv8f"}],"6xv8f":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"7xdi9":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"mL7I2"}],"exkHY":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"@swc/helpers/_/_type_of":"668P4","30aeab910fab669":"kQvtM","4f010869f7b63154":"40Y25","28f06147d1eb9502":"6wIyV","3c56f88c4debf449":"jQGs4","aee920e0ef5bf111":"bqkBM"}],"kQvtM":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"6SF7t","89e9034a8071e297":"8Db3c","782598b150762386":"kQM3q"}],"6SF7t":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"hxIkB","9003c0cc8ac007b6":"aP9FI"}],"8Db3c":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"lUKa0","94ffded3a85af2f6":"kLvI9"}],"lUKa0":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"8ffGS"}],"kQM3q":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"40Y25":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"aP9FI","d5ca180f7d6f956a":"jeneQ","3462bb3f546fa1f7":"bW9UX","f5fef07966a1c4ee":"gbNmb","2a1cd212d48516":"lUKa0","885e72ee7fc6d296":"kQM3q","cd65eaf4a3af29f6":"ih6jk"}],"bW9UX":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"doFfX","b0aefd36de99e579":"9BvOi"}],"doFfX":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"9BvOi":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"cLKKN","47ffafdab3ba0d6f":"jmDAu","93ebd263ff0131c1":"jQGs4","252ef74480e01958":"heeP8","23c2f64e75e90a2":"f9Q8Z","af5ade297cb685ee":"ih6jk"}],"6wIyV":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"bqkBM":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"4T5ep","abf31da39349df22":"d0kRt","a387ef4a4373de2c":"gbNmb","9315973458389ae7":"ih6jk"}],"4T5ep":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"d0kRt":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"3bgbL"}],"4JTPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var sentiment_url = 'https://rn672kihzg.execute-api.us-east-1.amazonaws.com/Prod';
//example function call: ScreenshotService.createScreenshot('root')
//TODO: Lock down sentiment urls
var SentimentService = {
    getSentiment: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(input) {
            var request;
            return (0, _tsGenerator._)(this, function(_state) {
                request = (0, _axiosDefault.default).post(sentiment_url, {
                    input: input
                });
                return [
                    2,
                    request
                ];
            });
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = SentimentService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lF4GL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _html2Canvas = require("html2canvas");
var _html2CanvasDefault = parcelHelpers.interopDefault(_html2Canvas);
//example function call: ScreenshotService.createScreenshot('root')
var ScreenshotService = {
    createScreenshotBase64: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(divId) {
            var canvas, rawDataWithHeader;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _html2CanvasDefault.default)(document.querySelector("#" + divId))
                        ];
                    case 1:
                        canvas = _state.sent();
                        rawDataWithHeader = canvas.toDataURL("image/png");
                        //strip header and return
                        return [
                            2,
                            rawDataWithHeader.replace(/^data:image\/(png|jpg);base64,/, "")
                        ];
                }
            });
        });
        return function(divId) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = ScreenshotService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","html2canvas":"fw7z9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fw7z9":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function __assign1() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(_deg) {
        return Math.PI * _deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function parse(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function testRangeBounds(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function testSVG(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function transform(text, _transform) {
        switch(_transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function parseNodeTree1(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return (0, _typeOf._)(element.className) === 'object';
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var _$window = node.ownerDocument.defaultView;
            if (_$window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = _$window.getComputedStyle(node);
                var styleBefore = _$window.getComputedStyle(node, ':before');
                var styleAfter = _$window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var _$document = clone.ownerDocument;
            if (!_$document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = _$document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = _$document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(_$document.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(_$document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(_$document.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var _$document = body.ownerDocument;
        if (_$document) {
            var style = _$document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree1(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || (typeof element === "undefined" ? "undefined" : (0, _typeOf._)(element)) !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

},{"@swc/helpers/_/_type_of":"668P4"}],"65WNy":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
/**
 * [chartjs-plugin-labels]{@link https://github.com/emn178/chartjs-plugin-labels}
 *
 * @version 1.1.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2017-2018
 * @license MIT
 */ (function() {
    'use strict';
    if (typeof Chart === 'undefined') {
        console.error('Can not find Chart object.');
        return;
    }
    if (typeof Object.assign != 'function') Object.assign = function(target, varArgs) {
        if (target == null) throw new TypeError('Cannot convert undefined or null to object');
        var to = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var nextSource = arguments[index];
            if (nextSource != null) {
                for(var nextKey in nextSource)if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
            }
        }
        return to;
    };
    var SUPPORTED_TYPES = {};
    [
        'pie',
        'doughnut',
        'polarArea',
        'bar'
    ].forEach(function(t) {
        SUPPORTED_TYPES[t] = true;
    });
    function Label() {
        this.renderToDataset = this.renderToDataset.bind(this);
    }
    Label.prototype.setup = function(chart, options) {
        this.chart = chart;
        this.ctx = chart.ctx;
        this.args = {};
        this.barTotal = {};
        var chartOptions = chart.config.options;
        this.options = Object.assign({
            position: 'default',
            precision: 0,
            fontSize: chartOptions.defaultFontSize,
            fontColor: chartOptions.defaultFontColor,
            fontStyle: chartOptions.defaultFontStyle,
            fontFamily: chartOptions.defaultFontFamily,
            shadowOffsetX: 3,
            shadowOffsetY: 3,
            shadowColor: 'rgba(0,0,0,0.3)',
            shadowBlur: 6,
            images: [],
            outsidePadding: 2,
            textMargin: 2,
            overlap: true
        }, options);
        if (chart.config.type === 'bar') {
            this.options.position = 'default';
            this.options.arc = false;
            this.options.overlap = true;
        }
    };
    Label.prototype.render = function() {
        this.labelBounds = [];
        this.chart.data.datasets.forEach(this.renderToDataset);
    };
    Label.prototype.renderToDataset = function(dataset, index) {
        this.totalPercentage = 0;
        this.total = null;
        var arg = this.args[index];
        arg.meta.data.forEach((function(element, index) {
            this.renderToElement(dataset, arg, element, index);
        }).bind(this));
    };
    Label.prototype.renderToElement = function(dataset, arg, element, index) {
        if (!this.shouldRenderToElement(arg.meta, element)) return;
        this.percentage = null;
        var label = this.getLabel(dataset, element, index);
        if (!label) return;
        var ctx = this.ctx;
        ctx.save();
        ctx.font = Chart.helpers.fontString(this.options.fontSize, this.options.fontStyle, this.options.fontFamily);
        var renderInfo = this.getRenderInfo(element, label);
        if (!this.drawable(element, label, renderInfo)) {
            ctx.restore();
            return;
        }
        ctx.beginPath();
        ctx.fillStyle = this.getFontColor(dataset, element, index);
        this.renderLabel(label, renderInfo);
        ctx.restore();
    };
    Label.prototype.renderLabel = function(label, renderInfo) {
        return this.options.arc ? this.renderArcLabel(label, renderInfo) : this.renderBaseLabel(label, renderInfo);
    };
    Label.prototype.renderBaseLabel = function(label, position) {
        var ctx = this.ctx;
        if ((typeof label === "undefined" ? "undefined" : (0, _typeOf._)(label)) === 'object') ctx.drawImage(label, position.x - label.width / 2, position.y - label.height / 2, label.width, label.height);
        else {
            ctx.save();
            ctx.textBaseline = 'top';
            ctx.textAlign = 'center';
            if (this.options.textShadow) {
                ctx.shadowOffsetX = this.options.shadowOffsetX;
                ctx.shadowOffsetY = this.options.shadowOffsetY;
                ctx.shadowColor = this.options.shadowColor;
                ctx.shadowBlur = this.options.shadowBlur;
            }
            var lines = label.split('\n');
            for(var i = 0; i < lines.length; i++){
                var y = position.y - this.options.fontSize / 2 * lines.length + this.options.fontSize * i;
                ctx.fillText(lines[i], position.x, y);
            }
            ctx.restore();
        }
    };
    Label.prototype.renderArcLabel = function(label, renderInfo) {
        var ctx = this.ctx, radius = renderInfo.radius, view = renderInfo.view;
        ctx.save();
        ctx.translate(view.x, view.y);
        if (typeof label === 'string') {
            ctx.rotate(renderInfo.startAngle);
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'left';
            var lines = label.split('\n'), max = 0, widths = [], offset = 0;
            if (this.options.position === 'border') offset = (lines.length - 1) * this.options.fontSize / 2;
            for(var j = 0; j < lines.length; ++j){
                var mertrics = ctx.measureText(lines[j]);
                if (mertrics.width > max) max = mertrics.width;
                widths.push(mertrics.width);
            }
            for(var j = 0; j < lines.length; ++j){
                var line = lines[j];
                var y = (lines.length - 1 - j) * -this.options.fontSize + offset;
                ctx.save();
                var padding = (max - widths[j]) / 2;
                ctx.rotate(padding / radius);
                for(var i = 0; i < line.length; i++){
                    var char = line.charAt(i);
                    mertrics = ctx.measureText(char);
                    ctx.save();
                    ctx.translate(0, -1 * radius);
                    ctx.fillText(char, 0, y);
                    ctx.restore();
                    ctx.rotate(mertrics.width / radius);
                }
                ctx.restore();
            }
        } else {
            ctx.rotate((view.startAngle + Math.PI / 2 + renderInfo.endAngle) / 2);
            ctx.translate(0, -1 * radius);
            this.renderLabel(label, {
                x: 0,
                y: 0
            });
        }
        ctx.restore();
    };
    Label.prototype.shouldRenderToElement = function(meta, element) {
        return !meta.hidden && !element.hidden && (this.options.showZero || this.chart.config.type === 'polarArea' ? element._view.outerRadius !== 0 : element._view.circumference !== 0);
    };
    Label.prototype.getLabel = function(dataset, element, index) {
        var label;
        if (typeof this.options.render === 'function') label = this.options.render({
            label: this.chart.config.data.labels[index],
            value: dataset.data[index],
            percentage: this.getPercentage(dataset, element, index),
            dataset: dataset,
            index: index
        });
        else switch(this.options.render){
            case 'value':
                label = dataset.data[index];
                break;
            case 'label':
                label = this.chart.config.data.labels[index];
                break;
            case 'image':
                label = this.options.images[index] ? this.loadImage(this.options.images[index]) : '';
                break;
            case 'percentage':
            default:
                label = this.getPercentage(dataset, element, index) + '%';
                break;
        }
        if ((typeof label === "undefined" ? "undefined" : (0, _typeOf._)(label)) === 'object') label = this.loadImage(label);
        else if (label !== null && label !== undefined) label = label.toString();
        return label;
    };
    Label.prototype.getFontColor = function(dataset, element, index) {
        var fontColor = this.options.fontColor;
        if (typeof fontColor === 'function') fontColor = fontColor({
            label: this.chart.config.data.labels[index],
            value: dataset.data[index],
            percentage: this.getPercentage(dataset, element, index),
            backgroundColor: dataset.backgroundColor[index],
            dataset: dataset,
            index: index
        });
        else if (typeof fontColor !== 'string') fontColor = fontColor[index] || this.chart.config.options.defaultFontColor;
        return fontColor;
    };
    Label.prototype.getPercentage = function(dataset, element, index) {
        if (this.percentage !== null) return this.percentage;
        var percentage;
        if (this.chart.config.type === 'polarArea') {
            if (this.total === null) {
                this.total = 0;
                for(var i = 0; i < dataset.data.length; ++i)this.total += dataset.data[i];
            }
            percentage = dataset.data[index] / this.total * 100;
        } else if (this.chart.config.type === 'bar') {
            if (this.barTotal[index] === undefined) {
                this.barTotal[index] = 0;
                for(var i = 0; i < this.chart.data.datasets.length; ++i)this.barTotal[index] += this.chart.data.datasets[i].data[index];
            }
            percentage = dataset.data[index] / this.barTotal[index] * 100;
        } else percentage = element._view.circumference / this.chart.config.options.circumference * 100;
        percentage = parseFloat(percentage.toFixed(this.options.precision));
        if (!this.options.showActualPercentages) {
            if (this.chart.config.type === 'bar') this.totalPercentage = this.barTotalPercentage[index] || 0;
            this.totalPercentage += percentage;
            if (this.totalPercentage > 100) {
                percentage -= this.totalPercentage - 100;
                percentage = parseFloat(percentage.toFixed(this.options.precision));
            }
            if (this.chart.config.type === 'bar') this.barTotalPercentage[index] = this.totalPercentage;
        }
        this.percentage = percentage;
        return percentage;
    };
    Label.prototype.getRenderInfo = function(element, label) {
        if (this.chart.config.type === 'bar') return this.getBarRenderInfo(element, label);
        else return this.options.arc ? this.getArcRenderInfo(element, label) : this.getBaseRenderInfo(element, label);
    };
    Label.prototype.getBaseRenderInfo = function(element, label) {
        if (this.options.position === 'outside' || this.options.position === 'border') {
            var renderInfo, rangeFromCentre, view = element._view, centreAngle = view.startAngle + (view.endAngle - view.startAngle) / 2, innerRadius = view.outerRadius / 2;
            if (this.options.position === 'border') rangeFromCentre = (view.outerRadius - innerRadius) / 2 + innerRadius;
            else if (this.options.position === 'outside') rangeFromCentre = view.outerRadius - innerRadius + innerRadius + this.options.textMargin;
            renderInfo = {
                x: view.x + Math.cos(centreAngle) * rangeFromCentre,
                y: view.y + Math.sin(centreAngle) * rangeFromCentre
            };
            if (this.options.position === 'outside') {
                var offset = this.options.textMargin + this.measureLabel(label).width / 2;
                renderInfo.x += renderInfo.x < view.x ? -offset : offset;
            }
            return renderInfo;
        } else return element.tooltipPosition();
    };
    Label.prototype.getArcRenderInfo = function(element, label) {
        var radius, view = element._view;
        if (this.options.position === 'outside') radius = view.outerRadius + this.options.fontSize + this.options.textMargin;
        else if (this.options.position === 'border') radius = (view.outerRadius / 2 + view.outerRadius) / 2;
        else radius = (view.innerRadius + view.outerRadius) / 2;
        var startAngle = view.startAngle, endAngle = view.endAngle;
        var totalAngle = endAngle - startAngle;
        startAngle += Math.PI / 2;
        endAngle += Math.PI / 2;
        var mertrics = this.measureLabel(label);
        startAngle += (endAngle - (mertrics.width / radius + startAngle)) / 2;
        return {
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            totalAngle: totalAngle,
            view: view
        };
    };
    Label.prototype.getBarRenderInfo = function(element, label) {
        var renderInfo = element.tooltipPosition();
        renderInfo.y -= this.measureLabel(label).height / 2 + this.options.textMargin;
        return renderInfo;
    };
    Label.prototype.drawable = function(element, label, renderInfo) {
        if (this.options.overlap) return true;
        else if (this.options.arc) return renderInfo.endAngle - renderInfo.startAngle <= renderInfo.totalAngle;
        else {
            var mertrics = this.measureLabel(label), left = renderInfo.x - mertrics.width / 2, right = renderInfo.x + mertrics.width / 2, top = renderInfo.y - mertrics.height / 2, bottom = renderInfo.y + mertrics.height / 2;
            if (this.options.renderInfo === 'outside') return this.outsideInRange(left, right, top, bottom);
            else return element.inRange(left, top) && element.inRange(left, bottom) && element.inRange(right, top) && element.inRange(right, bottom);
        }
    };
    Label.prototype.outsideInRange = function(left, right, top, bottom) {
        var labelBounds = this.labelBounds;
        for(var i = 0; i < labelBounds.length; ++i){
            var bound = labelBounds[i];
            var potins = [
                [
                    left,
                    top
                ],
                [
                    left,
                    bottom
                ],
                [
                    right,
                    top
                ],
                [
                    right,
                    bottom
                ]
            ];
            for(var j = 0; j < potins.length; ++j){
                var x = potins[j][0];
                var y = potins[j][1];
                if (x >= bound.left && x <= bound.right && y >= bound.top && y <= bound.bottom) return false;
            }
            potins = [
                [
                    bound.left,
                    bound.top
                ],
                [
                    bound.left,
                    bound.bottom
                ],
                [
                    bound.right,
                    bound.top
                ],
                [
                    bound.right,
                    bound.bottom
                ]
            ];
            for(var j = 0; j < potins.length; ++j){
                var x = potins[j][0];
                var y = potins[j][1];
                if (x >= left && x <= right && y >= top && y <= bottom) return false;
            }
        }
        labelBounds.push({
            left: left,
            right: right,
            top: top,
            bottom: bottom
        });
        return true;
    };
    Label.prototype.measureLabel = function(label) {
        if ((typeof label === "undefined" ? "undefined" : (0, _typeOf._)(label)) === 'object') return {
            width: label.width,
            height: label.height
        };
        else {
            var width = 0;
            var lines = label.split('\n');
            for(var i = 0; i < lines.length; ++i){
                var result = this.ctx.measureText(lines[i]);
                if (result.width > width) width = result.width;
            }
            return {
                width: width,
                height: this.options.fontSize * lines.length
            };
        }
    };
    Label.prototype.loadImage = function(obj) {
        var image = new Image();
        image.src = obj.src;
        image.width = obj.width;
        image.height = obj.height;
        return image;
    };
    Chart.plugins.register({
        id: 'labels',
        beforeDatasetsUpdate: function beforeDatasetsUpdate(chart, options) {
            if (!SUPPORTED_TYPES[chart.config.type]) return;
            if (!Array.isArray(options)) options = [
                options
            ];
            var count = options.length;
            if (!chart._labels || count !== chart._labels.length) chart._labels = options.map(function() {
                return new Label();
            });
            var someOutside = false, maxPadding = 0;
            for(var i = 0; i < count; ++i){
                var label = chart._labels[i];
                label.setup(chart, options[i]);
                if (label.options.position === 'outside') {
                    someOutside = true;
                    var padding = label.options.fontSize * 1.5 + label.options.outsidePadding;
                    if (padding > maxPadding) maxPadding = padding;
                }
            }
            if (someOutside) {
                chart.chartArea.top += maxPadding;
                chart.chartArea.bottom -= maxPadding;
            }
        },
        afterDatasetUpdate: function afterDatasetUpdate(chart, args, options) {
            if (!SUPPORTED_TYPES[chart.config.type]) return;
            chart._labels.forEach(function(label) {
                label.args[args.index] = args;
            });
        },
        beforeDraw: function beforeDraw(chart) {
            if (!SUPPORTED_TYPES[chart.config.type]) return;
            chart._labels.forEach(function(label) {
                label.barTotalPercentage = {};
            });
        },
        afterDatasetsDraw: function afterDatasetsDraw(chart) {
            if (!SUPPORTED_TYPES[chart.config.type]) return;
            chart._labels.forEach(function(label) {
                label.render();
            });
        }
    });
})();

},{"@swc/helpers/_/_type_of":"668P4"}],"aw744":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSVUtility", function() {
    return CSVUtility;
});
var CSVUtility = {
    downloadCSV: function(filename) {
        var csv = CSVUtility.exportTableToCSV();
        var downloadLink;
        var csvFile = new Blob([
            csv
        ], {
            type: "text/csv"
        });
        downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    },
    exportTableToCSV: function() {
        var csv = [];
        var rows = document.querySelectorAll("table:not(.no-csv) tr");
        for(var i = 0; i < rows.length; i++){
            var row = [], cols = rows[i].querySelectorAll("td, th");
            for(var j = 0; j < cols.length; j++)row.push("\"" + cols[j].innerText.trim() + "\"");
            csv.push(row.join(","));
        }
        return csv.join("\n");
    },
    attachCSV: function() {
        var csv = exportTableToCSV();
        sessionStorage.setItem("costadvisor", csv);
        window.location.replace("#/ticket");
    },
    attachCSVToSession: function() {
        var csv = exportTableToCSV();
        sessionStorage.setItem("costadvisor", csv);
    },
    downloadCSVFromJson: function(filename, json) {
        var csv = CSVUtility.jsonToCsv(json);
        var downloadLink;
        var csvFile = new Blob([
            csv
        ], {
            type: "text/csv"
        });
        downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    },
    jsonToCsv: function(json) {
        var items = json;
        var replacer = function(key, value) {
            return value === null ? '' : value // specify how you want to handle null values here
            ;
        };
        var header = Object.keys(items[0]);
        var csv = items.map(function(row) {
            return header.map(function(fieldName) {
                return JSON.stringify(row[fieldName], replacer);
            }).join(',');
        });
        csv.unshift(header.join(','));
        csv = csv.join('\r\n');
        return csv;
    },
    downloadCSVFromUrl: function(url) {
        var downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.click();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kGl4g":[function() {},{}],"9FEJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlueMatadorDashboardCharts", function() {
    return BlueMatadorDashboardCharts;
});
parcelHelpers.export(exports, "BlueMatadorLineChart", function() {
    return BlueMatadorLineChart;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactChartjs2 = require("react-chartjs-2");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
// reactstrap components
var _reactstrap = require("reactstrap");
var _blueMatadorService = require("../../services/BlueMatadorService");
var _blueMatadorServiceDefault = parcelHelpers.interopDefault(_blueMatadorService);
var _genericBrandText = require("../../utility/GenericBrandText");
var _genericBrandTextDefault = parcelHelpers.interopDefault(_genericBrandText);
var BlueMatadorLineChart = function(props) {
    var options = {
        plugins: {
            labels: {
                render: function() {}
            },
            datalabels: {
                display: false
            }
        },
        title: {
            text: ""
        },
        responsive: true,
        legend: {
            display: true
        },
        tooltips: {
            callbacks: {
                label: function label(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label = label.split(' ')[0] + " " + tooltipItem.value;
                    return label;
                }
            }
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 7
                    }
                }
            ],
            xAxes: [
                {
                    title: "time",
                    type: "time",
                    gridLines: {
                        lineWidth: 2
                    },
                    time: (0, _objectSpread._)({
                        unit: "day",
                        unitStepSize: 7,
                        displayFormats: {
                            millisecond: "MMM DD",
                            second: "MMM DD",
                            minute: "MMM DD",
                            hour: "MMM DD",
                            day: "MMM DD",
                            week: "MMM DD",
                            month: "MMM DD",
                            quarter: "MMM DD",
                            year: "MMM DD"
                        }
                    }, props.labels && props.labels.length > 0 ? {
                        min: (0, _momentDefault.default)(props.labels[0]).startOf('day')
                    } : {})
                }
            ]
        }
    };
    var label = props.type + ': ' + props.activeCount;
    var chartData = {
        'labels': props.labels,
        'datasets': [
            {
                'label': label,
                'backgroundColor': props.backgroundColor,
                'borderColor': props.borderColor,
                'data': props.data
            }
        ]
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Line), {
        data: chartData,
        options: options,
        height: 120
    });
};
var BlueMatadorDashboardCharts = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), labels = _useState[0], setLabels = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        data: []
    }), 2), alerts = _useState1[0], setAlerts = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        data: []
    }), 2), warnings = _useState2[0], setWarnings = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({
        data: []
    }), 2), anomalies = _useState3[0], setAnomalies = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)((0, _momentDefault.default)().toISOString()), 2), start = _useState4[0], setStart = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)((0, _momentDefault.default)().toISOString()), 2), end = _useState5[0], setEnd = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({}), 2), activeCounts = _useState6[0], setActiveCounts = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)('1'), 2), activeTab = _useState7[0], setActiveTab = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState8[0], setLoading = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(false), 2), notConfigured = _useState9[0], setNotConfigured = _useState9[1];
    var toggleTab = function(tab) {
        if (activeTab !== tab) setActiveTab(tab);
    };
    var source = (0, _axiosDefault.default).CancelToken.source();
    var history = (0, _reactRouterDom.useHistory)();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var end, start, openedRes, activeRes, alertData, warningData, anomalyData, sortedDates, activeCountsMap, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        end = (0, _momentDefault.default)().utc().startOf('day').toISOString().split('.')[0] + 'Z';
                        start = (0, _momentDefault.default)().utc().startOf('day').subtract(1, 'months').toISOString().split('.')[0] + 'Z';
                        return [
                            4,
                            (0, _blueMatadorServiceDefault.default).graphs({
                                start: start,
                                end: end
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 2:
                        openedRes = _state.sent();
                        return [
                            4,
                            (0, _blueMatadorServiceDefault.default).activeEvents({
                                state: 'acknowledged'
                            }, {
                                cancelToken: source.token
                            })
                        ];
                    case 3:
                        activeRes = _state.sent();
                        if (openedRes.data.triaerrormessage) {
                            // we got an error. It means integration is broken or doesn't exist.
                            setNotConfigured(true);
                            setLoading(false);
                        }
                        alertData = [];
                        warningData = [];
                        anomalyData = [];
                        sortedDates = Object.keys(openedRes.data.opened.alert).sort(function(a, b) {
                            a = Date.parse(a);
                            b = Date.parse(b);
                            return a < b ? -1 : a > b ? 1 : 0;
                        });
                        sortedDates.forEach(function(date) {
                            alertData.push(openedRes.data.opened.alert[date]);
                            warningData.push(openedRes.data.opened.warning[date]);
                            anomalyData.push(openedRes.data.opened.anomaly[date]);
                        });
                        sortedDates = sortedDates.map(Date.parse);
                        activeCountsMap = {
                            alert: 0,
                            warning: 0,
                            anomaly: 0
                        };
                        (Array.isArray(activeRes.data) ? activeRes.data : []).map(function(event) {
                            activeCountsMap[event.severity] += 1;
                        });
                        setActiveCounts(activeCountsMap);
                        if (!isMounted()) return [
                            2
                        ];
                        setLabels(sortedDates);
                        setAlerts({
                            data: alertData
                        });
                        setWarnings({
                            data: warningData
                        });
                        setAnomalies({
                            data: anomalyData
                        });
                        setLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column h-100",
        style: {
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-100 mb-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "text-left",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericBrandTextDefault.default), {
                        children: "Cloud Monitoring"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-fill",
                children: [
                    notConfigured && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "mt-5",
                        children: "Monitoring system isn't configured."
                    }),
                    !notConfigured && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ButtonGroup), {
                                className: "d-flex",
                                role: "group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            return toggleTab('1');
                                        },
                                        active: activeTab === '1',
                                        className: "btn-sm w-100 ".concat(activeTab !== '1' ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "250px",
                                            border: "unset"
                                        },
                                        children: [
                                            "Alerts: ",
                                            activeCounts.alert
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            return toggleTab('2');
                                        },
                                        active: activeTab === '2',
                                        className: "btn-sm w-100 ".concat(activeTab !== '2' ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "250px",
                                            border: "unset"
                                        },
                                        children: [
                                            "Warnings: ",
                                            activeCounts.warning
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            return toggleTab('3');
                                        },
                                        active: activeTab === '3',
                                        className: "btn-sm w-100 ".concat(activeTab !== '3' ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "250px",
                                            border: "unset"
                                        },
                                        children: [
                                            "Anomalies: ",
                                            activeCounts.anomaly
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.TabContent), {
                                activeTab: activeTab,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                                        tabId: "1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                                                sm: "12",
                                                children: alerts.data.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "mt-3",
                                                    children: "There are no alerts."
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlueMatadorLineChart, {
                                                    type: "Alerts",
                                                    data: alerts.data,
                                                    activeCount: activeCounts.alert,
                                                    labels: labels,
                                                    backgroundColor: "rgba(235, 64, 52, 0.4)",
                                                    borderColor: "rgba(235, 64, 52, 1)"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                                        tabId: "2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                                                sm: "12",
                                                children: warnings.data.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "mt-3",
                                                    children: "There are no warnings"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlueMatadorLineChart, {
                                                    type: "Warnings",
                                                    data: warnings.data,
                                                    activeCount: activeCounts.warning,
                                                    labels: labels,
                                                    backgroundColor: "rgba(255, 236, 0, 0.4)",
                                                    borderColor: "rgba(255, 236, 0, 1)"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                                        tabId: "3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Row), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Col), {
                                                sm: "12",
                                                children: anomalies.data.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "mt-3",
                                                    children: "There are no anomalies"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlueMatadorLineChart, {
                                                    type: "Anomalies",
                                                    data: anomalies.data,
                                                    activeCount: activeCounts.anomaly,
                                                    labels: labels,
                                                    backgroundColor: "rgba(145, 240, 244, 0.4)",
                                                    borderColor: "rgba(145, 240, 244, 1)"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-spinner m-3 mt-4 fa-spin",
                    style: {
                        fontSize: "30px"
                    }
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "bluematador-charts-contain",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                    className: alerts.data.length == 0 ? "d-none" : "table",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "btn btn-light align-self-end btn-sm mt-3",
                onClick: function() {
                    history.push("/app/cloud/monitoring");
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: "inline",
                            verticalAlign: "middle"
                        },
                        className: "fas fa-chart-line"
                    }),
                    " ",
                    "View Detail"
                ]
            })
        ]
    });
};
var BlueMatadorWidget = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlueMatadorDashboardCharts, {});
};
exports.default = BlueMatadorWidget;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","react-chartjs-2":"gpEym","../../utility/use-async-effect":"fShZN","axios":"ebRwi","moment":"3xZWN","reactstrap":"774RE","../../services/BlueMatadorService":"75h8Q","../../utility/GenericBrandText":"ixy4M","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ixy4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../AppState");
var GenericBrand = function(props) {
    return props.children;
//not needed for now... post-AWS demo
// const [stateApp, stateAppActions] = appState();
// let text = props.children;
// if(stateApp.env.toLowerCase() != 'demo') return text;
// switch (text){
//     case 'Blue Matador Cloud Monitoring':
//         return 'Cloud Monitoring';
//     case 'CloudCheckr':
//     return 'TRiA';
//     default: return text;
// }
};
exports.default = GenericBrand;

},{"react":"gVheC","../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iVpns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IBMCartCard", function() {
    return IBMCartCard;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
// reactstrap components
var _reactstrap = require("reactstrap");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _ibmservice = require("../../services/IBMService");
var _ibmserviceDefault = parcelHelpers.interopDefault(_ibmservice);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var IBMCartCard = function(props) {
    var history = (0, _reactRouterDom.useHistory)();
    var reports = [
        {
            value: "CART01",
            label: "CART01",
            files: [
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(1, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(2, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(3, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                }
            ]
        },
        {
            value: "CCSS01",
            label: "CCSS01",
            files: [
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(1, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(2, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(3, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                }
            ]
        },
        {
            value: "CCSS02",
            label: "CCSS02",
            files: [
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(1, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(2, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                },
                {
                    name: "All Item Analysis",
                    date: (0, _momentDefault.default)().subtract(3, 'days').format("MM/DD/YYYY"),
                    path: "https://tria-images.s3.amazonaws.com/ALL+Item+Analysis+-+CART01.xlsx"
                }
            ]
        }
    ];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(reports), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), index = _useState1[0], setIndex = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState2[0], setLoading = _useState2[1];
    var handleChange = function(selectedOption) {
        console.log(selectedOption);
        console.log(reports);
        // setLoading(true);
        var idx = reports.findIndex(function(x) {
            return x.value == selectedOption.value;
        });
        console.log(idx);
        // setTimeout(function(){ setIndex(idx); setLoading(false);}, 500);
        setIndex(idx);
    };
    var saveFile = function(file) {
        console.log(file);
        var link = document.createElement("a"); // Or maybe get it from the current document
        link.href = file;
        link.download = "ALL Item Analysis.xlsx";
        document.body.appendChild(link); // Or append it whereever you want
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "d-flex",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "w-100",
                            children: "Compliance Reports"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: "basic-single",
                        classNamePrefix: "select",
                        defaultValue: reports[0],
                        options: reports,
                        onChange: handleChange,
                        isSearchable: true,
                        name: "LPARS"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-spinner m-3 mt-4 fa-spin",
                            style: {
                                fontSize: "30px"
                            }
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            minHeight: "130px"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                            className: state.length == 0 ? "d-none" : "table table-borderless",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: state[index].files.map(function(object, idx) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: object.date
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: object.label
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "All Item Analysis"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: object.path,
                                                    download: true,
                                                    onClick: function() {
                                                        saveFile(object.path);
                                                    },
                                                    role: "button",
                                                    "aria-pressed": "true",
                                                    children: "Download"
                                                })
                                            })
                                        ]
                                    }, idx);
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "btn btn-light align-self-end btn-sm mt-3",
                onClick: function() {
                    history.push("/app/ibm-dashboard");
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: "inline",
                            verticalAlign: "middle"
                        },
                        className: "fas fa-chart-line"
                    }),
                    " ",
                    "View LPARS"
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","reactstrap":"774RE","react-select":"aGRC1","../../services/IBMService":"1UpC4","moment":"3xZWN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGRC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilter", function() {
    return 0, _selectDbb12E54EsmJs.c;
});
parcelHelpers.export(exports, "defaultTheme", function() {
    return 0, _selectDbb12E54EsmJs.d;
});
parcelHelpers.export(exports, "mergeStyles", function() {
    return 0, _selectDbb12E54EsmJs.m;
});
parcelHelpers.export(exports, "components", function() {
    return 0, _index4Bd03571EsmJs.c;
});
parcelHelpers.export(exports, "NonceProvider", function() {
    return NonceProvider;
});
var _selectDbb12E54EsmJs = require("./Select-dbb12e54.esm.js");
var _stateManager845A3300EsmJs = require("./stateManager-845a3300.esm.js");
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _index4Bd03571EsmJs = require("./index-4bd03571.esm.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _extends = require("@babel/runtime/helpers/extends");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _typeof = require("@babel/runtime/helpers/typeof");
var _reactInputAutosize = require("react-input-autosize");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var NonceProvider = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(NonceProvider, _Component);
    var _super = (0, _index4Bd03571EsmJs._)(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce, key) {
            return (0, _cacheDefault.default)({
                nonce: nonce,
                key: key
            });
        };
        _this.createEmotionCache = (0, _memoizeOneDefault.default)(_this.createEmotionCache);
        return _this;
    }
    (0, _createClassDefault.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react1.CacheProvider), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, _react.Component));
var index = (0, _stateManager845A3300EsmJs.m)((0, _selectDbb12E54EsmJs.S));
exports.default = index;

},{"./Select-dbb12e54.esm.js":"kMdP5","./stateManager-845a3300.esm.js":"1KGIi","@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/inherits":"iKolg","./index-4bd03571.esm.js":"6kitb","react":"gVheC","@emotion/react":"7pFGT","@emotion/cache":"2pdTq","memoize-one":"fGicq","@babel/runtime/helpers/extends":"lKkcq","@babel/runtime/helpers/toConsumableArray":"fjEoh","@babel/runtime/helpers/objectWithoutProperties":"5K3de","@babel/runtime/helpers/taggedTemplateLiteral":"397zc","@babel/runtime/helpers/typeof":"47zzI","react-input-autosize":"fD5wY","@babel/runtime/helpers/defineProperty":"lqVrz","react-dom":"d8jlt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kMdP5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", function() {
    return Select;
});
parcelHelpers.export(exports, "a", function() {
    return getOptionLabel;
});
parcelHelpers.export(exports, "b", function() {
    return defaultProps;
});
parcelHelpers.export(exports, "c", function() {
    return createFilter;
});
parcelHelpers.export(exports, "d", function() {
    return defaultTheme;
});
parcelHelpers.export(exports, "g", function() {
    return getOptionValue;
});
parcelHelpers.export(exports, "m", function() {
    return mergeStyles;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _index4Bd03571EsmJs = require("./index-4bd03571.esm.js");
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, _props$focused = props.focused, focused = _props$focused === void 0 ? {} : _props$focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _index4Bd03571EsmJs.a)((0, _index4Bd03571EsmJs.a)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]); // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, removedValue = ariaSelection.removedValue, value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            var selected = removedValue || option || asOption(value);
            var onChangeProps = (0, _index4Bd03571EsmJs.a)({
                isDisabled: selected && isOptionDisabled(selected),
                label: selected ? getOptionLabel(selected) : ''
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        isOptionDisabled,
        getOptionLabel,
        messages
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused),
                isSelected: isSelected,
                options: options,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        options,
        selectValue
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    return (0, _react1.jsx)(A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && (0, _react1.jsx)((0, _reactDefault.default).Fragment, null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-context"
    }, ariaContext)));
};
var diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = (0, _index4Bd03571EsmJs.a)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function DummyInput(_ref) {
    _ref.in;
    _ref.out;
    _ref.onExited;
    _ref.appear;
    _ref.enter;
    _ref.exit;
    var innerRef = _ref.innerRef;
    _ref.emotion;
    var props = (0, _objectWithoutPropertiesDefault.default)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: 'inherit',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(0)'
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        // Reference should never be `null` at this point, but flow complains otherwise
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        } // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        } // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, []);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _index4Bd03571EsmJs.s) ? {
            passive: false
        } : false; // all the if statements are to appease Flow 😢
        if (typeof el.addEventListener === 'function') el.addEventListener('wheel', onWheel, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchstart', onTouchStart, notPassive);
        if (typeof el.addEventListener === 'function') el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return; // all the if statements are to appease Flow 😢
        if (typeof el.removeEventListener === 'function') el.removeEventListener('wheel', onWheel, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchstart', onTouchStart, false);
        if (typeof el.removeEventListener === 'function') el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
         // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        } // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        } // increment active scroll locks
        activeScrollLocks += 1;
    }, []);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
         // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, []);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var _ref2 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _reactDefault.default).Fragment, null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2
    }), children(targetRef));
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _index4Bd03571EsmJs.b),
    container: (0, _index4Bd03571EsmJs.d),
    control: (0, _index4Bd03571EsmJs.e),
    dropdownIndicator: (0, _index4Bd03571EsmJs.f),
    group: (0, _index4Bd03571EsmJs.g),
    groupHeading: (0, _index4Bd03571EsmJs.h),
    indicatorsContainer: (0, _index4Bd03571EsmJs.i),
    indicatorSeparator: (0, _index4Bd03571EsmJs.j),
    input: (0, _index4Bd03571EsmJs.k),
    loadingIndicator: (0, _index4Bd03571EsmJs.l),
    loadingMessage: (0, _index4Bd03571EsmJs.m),
    menu: (0, _index4Bd03571EsmJs.n),
    menuList: (0, _index4Bd03571EsmJs.o),
    menuPortal: (0, _index4Bd03571EsmJs.p),
    multiValue: (0, _index4Bd03571EsmJs.q),
    multiValueLabel: (0, _index4Bd03571EsmJs.r),
    multiValueRemove: (0, _index4Bd03571EsmJs.t),
    noOptionsMessage: (0, _index4Bd03571EsmJs.u),
    option: (0, _index4Bd03571EsmJs.v),
    placeholder: (0, _index4Bd03571EsmJs.w),
    singleValue: (0, _index4Bd03571EsmJs.x),
    valueContainer: (0, _index4Bd03571EsmJs.y)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _index4Bd03571EsmJs.a)({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements
var baseUnit = 4; // The minimum height of the control
var controlHeight = 38; // The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _index4Bd03571EsmJs.z)(),
    captureMenuScroll: !(0, _index4Bd03571EsmJs.z)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _index4Bd03571EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel$1(props, option);
    var value = getOptionValue$1(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if (groupOrOption.options) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }) // Flow limitation (see https://github.com/facebook/flow/issues/1414)
    .filter(function(categorizedOption) {
        return !!categorizedOption;
    });
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel$1 = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue$1 = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue$1(props, option);
    return selectValue.some(function(i) {
        return getOptionValue$1(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _index4Bd03571EsmJs._)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange('', {
                action: 'set-value'
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                }), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ]), 'select-option', newValue);
                else _this.setValue(newValue, 'select-option');
            } else {
                _this.ariaOnChange(newValue, {
                    action: 'select-option',
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange(_this.props.isMulti ? [] : null, {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = isMulti ? newValueArray : newValueArray[0] || null;
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _index4Bd03571EsmJs.B).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel$1(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue$1(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var base = defaultStyles[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _index4Bd03571EsmJs.C)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _index4Bd03571EsmJs.a)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _index4Bd03571EsmJs.D)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change'
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur'
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close'
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _index4Bd03571EsmJs.E)(_props.value);
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _index4Bd03571EsmJs.F)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            } // ==============================
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close'
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return defaultTheme;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme(defaultTheme);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _index4Bd03571EsmJs.a)((0, _index4Bd03571EsmJs.a)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            value: // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    'aria-autocomplete': 'list',
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby']
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _index4Bd03571EsmJs.G),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this3.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this3.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this3.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this3.formatOptionLabel(opt, 'value'));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function onHover() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function onSelect() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, _reactDefault.default).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index4Bd03571EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, focusedOption = _this$state5.focusedOption, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(LiveRegion, (0, _extendsDefault.default)({}, commonProps, {
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, _reactDefault.default).createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, _reactDefault.default).createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue;
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var selectValue = (0, _index4Bd03571EsmJs.E)(value);
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                } // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                return (0, _index4Bd03571EsmJs.a)((0, _index4Bd03571EsmJs.a)((0, _index4Bd03571EsmJs.a)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./index-4bd03571.esm.js":"6kitb","@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/toConsumableArray":"588Uu","react":"gVheC","@emotion/react":"7pFGT","memoize-one":"fGicq","@babel/runtime/helpers/esm/objectWithoutProperties":"5MbDA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6kitb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", function() {
    return isMobileDevice;
});
parcelHelpers.export(exports, "B", function() {
    return classNames;
});
parcelHelpers.export(exports, "C", function() {
    return defaultComponents;
});
parcelHelpers.export(exports, "D", function() {
    return isDocumentElement;
});
parcelHelpers.export(exports, "E", function() {
    return cleanValue;
});
parcelHelpers.export(exports, "F", function() {
    return scrollIntoView;
});
parcelHelpers.export(exports, "G", function() {
    return noop;
});
parcelHelpers.export(exports, "H", function() {
    return handleInputChange;
});
parcelHelpers.export(exports, "M", function() {
    return MenuPlacer;
});
parcelHelpers.export(exports, "_", function() {
    return _createSuper;
});
parcelHelpers.export(exports, "a", function() {
    return _objectSpread2;
});
parcelHelpers.export(exports, "b", function() {
    return clearIndicatorCSS;
});
parcelHelpers.export(exports, "c", function() {
    return components;
});
parcelHelpers.export(exports, "d", function() {
    return containerCSS;
});
parcelHelpers.export(exports, "e", function() {
    return css;
});
parcelHelpers.export(exports, "f", function() {
    return dropdownIndicatorCSS;
});
parcelHelpers.export(exports, "g", function() {
    return groupCSS;
});
parcelHelpers.export(exports, "h", function() {
    return groupHeadingCSS;
});
parcelHelpers.export(exports, "i", function() {
    return indicatorsContainerCSS;
});
parcelHelpers.export(exports, "j", function() {
    return indicatorSeparatorCSS;
});
parcelHelpers.export(exports, "k", function() {
    return inputCSS;
});
parcelHelpers.export(exports, "l", function() {
    return loadingIndicatorCSS;
});
parcelHelpers.export(exports, "m", function() {
    return loadingMessageCSS;
});
parcelHelpers.export(exports, "n", function() {
    return menuCSS;
});
parcelHelpers.export(exports, "o", function() {
    return menuListCSS;
});
parcelHelpers.export(exports, "p", function() {
    return menuPortalCSS;
});
parcelHelpers.export(exports, "q", function() {
    return multiValueCSS;
});
parcelHelpers.export(exports, "r", function() {
    return multiValueLabelCSS;
});
parcelHelpers.export(exports, "s", function() {
    return supportsPassiveEvents;
});
parcelHelpers.export(exports, "t", function() {
    return multiValueRemoveCSS;
});
parcelHelpers.export(exports, "u", function() {
    return noOptionsMessageCSS;
});
parcelHelpers.export(exports, "v", function() {
    return optionCSS;
});
parcelHelpers.export(exports, "w", function() {
    return placeholderCSS;
});
parcelHelpers.export(exports, "x", function() {
    return css$1;
});
parcelHelpers.export(exports, "y", function() {
    return valueContainerCSS;
});
parcelHelpers.export(exports, "z", function() {
    return isTouchCapable;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _reactInputAutosize = require("react-input-autosize");
var _reactInputAutosizeDefault = parcelHelpers.interopDefault(_reactInputAutosize);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
function _defineProperty1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
} // ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, [
        "className",
        "clearValue",
        "cx",
        "getStyles",
        "getValue",
        "hasValue",
        "isMulti",
        "isRtl",
        "options",
        "selectOption",
        "selectProps",
        "setValue",
        "theme"
    ]);
    return _objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === 'fixed') return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
}; // check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener('p', noop, options);
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: 'menu'
    }, (0, _definePropertyDefault.default)(_ref3, alignToControl(placement), '100%'), (0, _definePropertyDefault.default)(_ref3, "backgroundColor", colors.neutral0), (0, _definePropertyDefault.default)(_ref3, "borderRadius", borderRadius), (0, _definePropertyDefault.default)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0, _definePropertyDefault.default)(_ref3, "marginBottom", spacing.menuGutter), (0, _definePropertyDefault.default)(_ref3, "marginTop", spacing.menuGutter), (0, _definePropertyDefault.default)(_ref3, "position", 'absolute'), (0, _definePropertyDefault.default)(_ref3, "width", '100%'), (0, _definePropertyDefault.default)(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var MenuPlacer = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(MenuPlacer, _Component);
    var _super = _createSuper(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === 'fixed';
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || coercePlacement(menuPlacement);
            return _objectSpread2(_objectSpread2({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, _createClassDefault.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, _react1.Component));
MenuPlacer.contextType = PortalPlacementContext;
var Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('menu', props),
        className: cx({
            menu: true
        }, className),
        ref: innerRef
    }, innerProps), children);
};
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: 'auto',
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    };
};
var MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('menuList', props),
        className: cx({
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: 'center'
    };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('noOptionsMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--no-options': true
        }, className)
    }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('loadingMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--loading': true
        }, className)
    }, innerProps), children);
};
LoadingMessage.defaultProps = {
    children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, _inheritsDefault.default)(MenuPortal, _Component2);
    var _super2 = _createSuper(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, _createClassDefault.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === 'fixed'; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || coercePlacement(menuPlacement);
                var rect = getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
                    css: getStyles('menuPortal', state),
                    className: cx({
                        'menu-portal': true
                    }, className)
                }, innerProps), children);
                return (0, _react.jsx)(PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, _react1.Component));
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : null,
        pointerEvents: isDisabled ? 'none' : null,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('container', props),
        className: cx({
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    };
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('valueContainer', props),
        className: cx({
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        }, className)
    }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('indicatorsContainer', props),
        className: cx({
            indicators: true
        }, className)
    }, innerProps), children);
};
var _templateObject;
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, [
        "size"
    ]);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: 'indicatorContainer',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('dropdownIndicator', props),
        className: cx({
            indicator: true,
            'dropdown-indicator': true
        }, className)
    }, innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('clearIndicator', props),
        className: cx({
            indicator: true,
            'clear-indicator': true
        }, className)
    }, innerProps), children || (0, _react.jsx)(CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, {
        css: getStyles('indicatorSeparator', props),
        className: cx({
            'indicator-separator': true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: 'loadingIndicator',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    };
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : null,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('loadingIndicator', props),
        className: cx({
            indicator: true,
            'loading-indicator': true
        }, className)
    }, innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
LoadingIndicator.defaultProps = {
    size: 4
};
var css = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: 'control',
        alignItems: 'center',
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef,
        css: getStyles('control', props),
        className: cx({
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }, className)
    }, innerProps), children);
};
var groupCSS = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('group', props),
        className: cx({
            group: true
        }, className)
    }, innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: 'group',
        color: '#999',
        cursor: 'default',
        display: 'block',
        fontSize: '75%',
        fontWeight: '500',
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    };
};
var GroupHeading = function GroupHeading(props) {
    var getStyles = props.getStyles, cx = props.cx, className = props.className;
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, [
        "data"
    ]);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('groupHeading', props),
        className: cx({
            'group-heading': true
        }, className)
    }, innerProps));
};
var inputCSS = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? 'hidden' : 'visible',
        color: colors.neutral80
    };
};
var inputStyle = function inputStyle(isHidden) {
    return {
        label: 'input',
        background: 0,
        border: 0,
        fontSize: 'inherit',
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: 'inherit'
    };
};
var Input = function Input(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, [
        "innerRef",
        "isDisabled",
        "isHidden"
    ]);
    return (0, _react.jsx)("div", {
        css: getStyles('input', props)
    }, (0, _react.jsx)((0, _reactInputAutosizeDefault.default), (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var multiValueCSS = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: 'multiValue',
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: 'flex',
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        overflow: 'hidden',
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? 'ellipsis' : null,
        whiteSpace: 'nowrap'
    };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: 'center',
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: 'flex',
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", innerProps, children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)((0, _react.ClassNames), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, _react.jsx)(Container, {
            data: data,
            innerProps: _objectSpread2({
                className: emotionCx(css(getStyles('multiValue', props)), cx({
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }, className))
            }, innerProps),
            selectProps: selectProps
        }, (0, _react.jsx)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
                    'multi-value__label': true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, _react.jsx)(Remove, {
            data: data,
            innerProps: _objectSpread2({
                className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
                    'multi-value__remove': true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var optionCSS = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'option',
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('option', props),
        className: cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var placeholderCSS = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'placeholder',
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('placeholder', props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var css$1 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'singleValue',
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        css: getStyles('singleValue', props),
        className: cx({
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }, className)
    }, innerProps), children);
};
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option,
    Placeholder: Placeholder,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return _objectSpread2(_objectSpread2({}, components), props.components);
};

},{"@swc/helpers/_/_type_of":"668P4","@babel/runtime/helpers/esm/extends":"d4f7v","@emotion/react":"7pFGT","@babel/runtime/helpers/esm/taggedTemplateLiteral":"lbke9","@babel/runtime/helpers/esm/objectWithoutProperties":"5MbDA","@babel/runtime/helpers/esm/typeof":"dC70N","react-input-autosize":"fD5wY","@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","react":"gVheC","react-dom":"d8jlt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7pFGT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", function() {
    return 0, _emotionElementB4C8B265EsmJs.C;
});
parcelHelpers.export(exports, "ThemeContext", function() {
    return 0, _emotionElementB4C8B265EsmJs.T;
});
parcelHelpers.export(exports, "ThemeProvider", function() {
    return 0, _emotionElementB4C8B265EsmJs.b;
});
parcelHelpers.export(exports, "__unsafe_useEmotionCache", function() {
    return 0, _emotionElementB4C8B265EsmJs._;
});
parcelHelpers.export(exports, "useTheme", function() {
    return 0, _emotionElementB4C8B265EsmJs.u;
});
parcelHelpers.export(exports, "withEmotionCache", function() {
    return 0, _emotionElementB4C8B265EsmJs.w;
});
parcelHelpers.export(exports, "withTheme", function() {
    return 0, _emotionElementB4C8B265EsmJs.d;
});
parcelHelpers.export(exports, "ClassNames", function() {
    return ClassNames;
});
parcelHelpers.export(exports, "Global", function() {
    return Global;
});
parcelHelpers.export(exports, "createElement", function() {
    return jsx;
});
parcelHelpers.export(exports, "css", function() {
    return css;
});
parcelHelpers.export(exports, "jsx", function() {
    return jsx;
});
parcelHelpers.export(exports, "keyframes", function() {
    return keyframes;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _emotionElementB4C8B265EsmJs = require("./emotion-element-b4c8b265.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElementB4C8B265EsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementB4C8B265EsmJs.E);
    createElementArgArray[1] = (0, _emotionElementB4C8B265EsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementB4C8B265EsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementB4C8B265EsmJs.T)));
    if (!(0, _emotionElementB4C8B265EsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function css() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var keyframes = function /*: Keyframes */ keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementB4C8B265EsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementB4C8B265EsmJs.i)) return rules;
    });
    if (!(0, _emotionElementB4C8B265EsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var ClassNames = /* #__PURE__ */ (0, _emotionElementB4C8B265EsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementB4C8B265EsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementB4C8B265EsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementB4C8B265EsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"@swc/helpers/_/_type_of":"668P4","./emotion-element-b4c8b265.esm.js":"lBRlQ","react":"gVheC","@emotion/utils":"cKAIq","@emotion/use-insertion-effect-with-fallbacks":"48XGi","@emotion/serialize":"2fcjR","@emotion/cache":"2pdTq","@babel/runtime/helpers/extends":"lKkcq","@emotion/weak-memoize":"lX8fW","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"eUIAB","hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lBRlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", function() {
    return CacheProvider;
});
parcelHelpers.export(exports, "E", function() {
    return Emotion$1;
});
parcelHelpers.export(exports, "T", function() {
    return ThemeContext;
});
parcelHelpers.export(exports, "_", function() {
    return __unsafe_useEmotionCache;
});
parcelHelpers.export(exports, "a", function() {
    return isDevelopment;
});
parcelHelpers.export(exports, "b", function() {
    return ThemeProvider;
});
parcelHelpers.export(exports, "c", function() {
    return createEmotionProps;
});
parcelHelpers.export(exports, "d", function() {
    return withTheme;
});
parcelHelpers.export(exports, "h", function() {
    return hasOwn;
});
parcelHelpers.export(exports, "i", function() {
    return isBrowser;
});
parcelHelpers.export(exports, "u", function() {
    return useTheme;
});
parcelHelpers.export(exports, "w", function() {
    return withEmotionCache;
});
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
/* import { type EmotionCache } from '@emotion/utils' */ var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && !isDevelopment) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"gVheC","@emotion/cache":"2pdTq","@babel/runtime/helpers/esm/extends":"d4f7v","@emotion/weak-memoize":"lX8fW","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"eUIAB","@emotion/utils":"cKAIq","@emotion/serialize":"2fcjR","@emotion/use-insertion-effect-with-fallbacks":"48XGi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2pdTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createCache;
});
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"gTsiC","stylis":"g41Db","@emotion/weak-memoize":"lX8fW","@emotion/memoize":"961va","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gTsiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", function() {
    return StyleSheet;
});
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g41Db":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", function() {
    return f;
});
parcelHelpers.export(exports, "COMMENT", function() {
    return n;
});
parcelHelpers.export(exports, "COUNTER_STYLE", function() {
    return w;
});
parcelHelpers.export(exports, "DECLARATION", function() {
    return s;
});
parcelHelpers.export(exports, "DOCUMENT", function() {
    return v;
});
parcelHelpers.export(exports, "FONT_FACE", function() {
    return b;
});
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", function() {
    return d;
});
parcelHelpers.export(exports, "IMPORT", function() {
    return i;
});
parcelHelpers.export(exports, "KEYFRAMES", function() {
    return h;
});
parcelHelpers.export(exports, "LAYER", function() {
    return $;
});
parcelHelpers.export(exports, "MEDIA", function() {
    return u;
});
parcelHelpers.export(exports, "MOZ", function() {
    return r;
});
parcelHelpers.export(exports, "MS", function() {
    return e;
});
parcelHelpers.export(exports, "NAMESPACE", function() {
    return p;
});
parcelHelpers.export(exports, "PAGE", function() {
    return t;
});
parcelHelpers.export(exports, "RULESET", function() {
    return c;
});
parcelHelpers.export(exports, "SUPPORTS", function() {
    return l;
});
parcelHelpers.export(exports, "VIEWPORT", function() {
    return o;
});
parcelHelpers.export(exports, "WEBKIT", function() {
    return a;
});
parcelHelpers.export(exports, "abs", function() {
    return g;
});
parcelHelpers.export(exports, "alloc", function() {
    return V;
});
parcelHelpers.export(exports, "append", function() {
    return q;
});
parcelHelpers.export(exports, "assign", function() {
    return m;
});
parcelHelpers.export(exports, "caret", function() {
    return R;
});
parcelHelpers.export(exports, "char", function() {
    return L;
});
parcelHelpers.export(exports, "character", function() {
    return H;
});
parcelHelpers.export(exports, "characters", function() {
    return I;
});
parcelHelpers.export(exports, "charat", function() {
    return O;
});
parcelHelpers.export(exports, "column", function() {
    return E;
});
parcelHelpers.export(exports, "combine", function() {
    return B;
});
parcelHelpers.export(exports, "comment", function() {
    return ue;
});
parcelHelpers.export(exports, "commenter", function() {
    return ae;
});
parcelHelpers.export(exports, "compile", function() {
    return ce;
});
parcelHelpers.export(exports, "copy", function() {
    return K;
});
parcelHelpers.export(exports, "dealloc", function() {
    return W;
});
parcelHelpers.export(exports, "declaration", function() {
    return ie;
});
parcelHelpers.export(exports, "delimit", function() {
    return X;
});
parcelHelpers.export(exports, "delimiter", function() {
    return re;
});
parcelHelpers.export(exports, "escaping", function() {
    return ee;
});
parcelHelpers.export(exports, "from", function() {
    return k;
});
parcelHelpers.export(exports, "hash", function() {
    return x;
});
parcelHelpers.export(exports, "identifier", function() {
    return ne;
});
parcelHelpers.export(exports, "indexof", function() {
    return C;
});
parcelHelpers.export(exports, "length", function() {
    return F;
});
parcelHelpers.export(exports, "line", function() {
    return D;
});
parcelHelpers.export(exports, "match", function() {
    return j;
});
parcelHelpers.export(exports, "middleware", function() {
    return ve;
});
parcelHelpers.export(exports, "namespace", function() {
    return be;
});
parcelHelpers.export(exports, "next", function() {
    return P;
});
parcelHelpers.export(exports, "node", function() {
    return J;
});
parcelHelpers.export(exports, "parse", function() {
    return se;
});
parcelHelpers.export(exports, "peek", function() {
    return Q;
});
parcelHelpers.export(exports, "position", function() {
    return G;
});
parcelHelpers.export(exports, "prefix", function() {
    return fe;
});
parcelHelpers.export(exports, "prefixer", function() {
    return he;
});
parcelHelpers.export(exports, "prev", function() {
    return N;
});
parcelHelpers.export(exports, "replace", function() {
    return z;
});
parcelHelpers.export(exports, "ruleset", function() {
    return te;
});
parcelHelpers.export(exports, "rulesheet", function() {
    return pe;
});
parcelHelpers.export(exports, "serialize", function() {
    return oe;
});
parcelHelpers.export(exports, "sizeof", function() {
    return S;
});
parcelHelpers.export(exports, "slice", function() {
    return T;
});
parcelHelpers.export(exports, "stringify", function() {
    return le;
});
parcelHelpers.export(exports, "strlen", function() {
    return M;
});
parcelHelpers.export(exports, "substr", function() {
    return A;
});
parcelHelpers.export(exports, "token", function() {
    return U;
});
parcelHelpers.export(exports, "tokenize", function() {
    return Y;
});
parcelHelpers.export(exports, "tokenizer", function() {
    return _;
});
parcelHelpers.export(exports, "trim", function() {
    return y;
});
parcelHelpers.export(exports, "whitespace", function() {
    return Z;
});
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lX8fW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return weakMemoize;
});
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"961va":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoize;
});
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eUIAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoistNonReactStatics;
});
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cKAIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", function() {
    return getRegisteredStyles;
});
parcelHelpers.export(exports, "insertStyles", function() {
    return insertStyles;
});
parcelHelpers.export(exports, "registerStyles", function() {
    return registerStyles;
});
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2fcjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", function() {
    return serializeStyles;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, _typeOf._)(interpolation)){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && (0, _typeOf._)(args[0]) === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@swc/helpers/_/_type_of":"668P4","@emotion/hash":"99Ynz","@emotion/unitless":"2lYut","@emotion/memoize":"961va","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"99Ynz":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return murmur2;
});
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2lYut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return unitlessKeys;
});
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"48XGi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", function() {
    return useInsertionEffectAlwaysWithSyncFallback;
});
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", function() {
    return useInsertionEffectWithLayoutFallback;
});
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lbke9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _taggedTemplateLiteral;
});
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5MbDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutProperties;
});
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"8FYSI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fD5wY":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("1cbc09d5599cfa0b");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("f906c25cd271bc94");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    visibility: 'hidden',
    height: 0,
    overflow: 'scroll',
    whiteSpace: 'pre'
};
var INPUT_PROPS_BLACKLIST = [
    'extraWidth',
    'injectStyles',
    'inputClassName',
    'inputRef',
    'inputStyle',
    'minWidth',
    'onAutosize',
    'placeholderIsMinWidth'
];
var cleanInputProps = function cleanInputProps(inputProps) {
    INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};
var AutosizeInput = function(_Component) {
    _inherits(AutosizeInput, _Component);
    _createClass(AutosizeInput, null, [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        _classCallCheck(this, AutosizeInput);
        var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === 'function') _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || generateId(),
            prevId: props.id
        };
        return _this;
    }
    _createClass(AutosizeInput, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === 'function') this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: 'copyInputStyles',
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: 'updateInputWidth',
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: 'blur',
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: 'select',
            value: function select() {
                this.input.select();
            }
        },
        {
            key: 'renderStyles',
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return isIE && injectStyles ? _react2.default.createElement('style', {
                    dangerouslySetInnerHTML: {
                        __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
                    }
                }) : null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ''
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = _extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
                var inputStyle = _extends({
                    boxSizing: 'content-box',
                    width: this.state.inputWidth + 'px'
                }, this.props.inputStyle);
                var inputProps = _objectWithoutProperties(this.props, []);
                cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return _react2.default.createElement('div', {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), _react2.default.createElement('input', _extends({}, inputProps, {
                    ref: this.inputRef
                })), _react2.default.createElement('div', {
                    ref: this.sizerRef,
                    style: sizerStyle
                }, sizerValue), this.props.placeholder ? _react2.default.createElement('div', {
                    ref: this.placeHolderSizerRef,
                    style: sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}(_react.Component);
AutosizeInput.propTypes = {
    className: _propTypes2.default.string,
    defaultValue: _propTypes2.default.any,
    extraWidth: _propTypes2.default.oneOfType([
        _propTypes2.default.number,
        _propTypes2.default.string
    ]),
    id: _propTypes2.default.string,
    injectStyles: _propTypes2.default.bool,
    inputClassName: _propTypes2.default.string,
    inputRef: _propTypes2.default.func,
    inputStyle: _propTypes2.default.object,
    minWidth: _propTypes2.default.oneOfType([
        _propTypes2.default.number,
        _propTypes2.default.string
    ]),
    onAutosize: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    placeholder: _propTypes2.default.string,
    placeholderIsMinWidth: _propTypes2.default.bool,
    style: _propTypes2.default.object,
    value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
exports.default = AutosizeInput;

},{"@swc/helpers/_/_type_of":"668P4","1cbc09d5599cfa0b":"gVheC","f906c25cd271bc94":"3KNJy"}],"gYHBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _classCallCheck;
});
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7OgJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createClass;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"4TadU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iKolg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"hyVPU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"588Uu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _toConsumableArray;
});
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"eExlf","./iterableToArray.js":"a4LG6","./unsupportedIterableToArray.js":"cMuX5","./nonIterableSpread.js":"4IUUG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eExlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayWithoutHoles;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"3QwAN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3QwAN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayLikeToArray;
});
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a4LG6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _iterableToArray;
});
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMuX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _unsupportedIterableToArray;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"3QwAN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4IUUG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _nonIterableSpread;
});
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGicq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1KGIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m", function() {
    return manageState;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _index4Bd03571EsmJs = require("./index-4bd03571.esm.js");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
};
var manageState = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, _inheritsDefault.default)(StateManager, _Component);
        var _super = (0, _index4Bd03571EsmJs._)(StateManager);
        function StateManager() {
            var _this;
            (0, _classCallCheckDefault.default)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp('onChange', value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp('onInputChange', value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp('onMenuOpen');
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp('onMenuClose');
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, _createClassDefault.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === 'function') {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props;
                    _this$props2.defaultInputValue;
                    _this$props2.defaultMenuIsOpen;
                    _this$props2.defaultValue;
                    var props = (0, _objectWithoutPropertiesDefault.default)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SelectComponent, (0, _extendsDefault.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp('inputValue'),
                        menuIsOpen: this.getProp('menuIsOpen'),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp('value')
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, _react.Component)), _class.defaultProps = defaultProps, _temp;
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutProperties":"5MbDA","@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/inherits":"iKolg","./index-4bd03571.esm.js":"6kitb","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fjEoh":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"dB9pw","4f1268a27b81f1fd":"70Gju","bfa7725fe5f724b":"ikRAk","24ae2b6222a85da6":"duKGY"}],"dB9pw":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"d7ToU"}],"70Gju":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"duKGY":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"397zc":[function(require,module,exports,__globalThis) {
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"apSqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SolarwindForecast", function() {
    return SolarwindForecast;
});
parcelHelpers.export(exports, "SolarWindsDesktopWidget", function() {
    return SolarWindsDesktopWidget;
});
parcelHelpers.export(exports, "SolarWindsDetailWidget", function() {
    return SolarWindsDetailWidget;
});
parcelHelpers.export(exports, "SolarWindsDetailLayout", function() {
    return SolarWindsDetailLayout;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// used for making the prop types of this component
var _reactstrap = require("reactstrap");
var _solarwind = require("../../services/Solarwind");
var _solarwindDefault = parcelHelpers.interopDefault(_solarwind);
var _misc = require("../../utility/misc");
var _index = require("axios/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _reactRouterDom = require("react-router-dom");
var _appState = require("../../AppState");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _connectriaTicketsSupportDashboard = require("../ConnectriaTickets/ConnectriaTicketsSupportDashboard");
var renderTableHeader = function renderTableHeader() {
    var columns = [
        'VM',
        'Warning Date',
        'Critical Date',
        ' At Capacity',
        "Create Ticket"
    ];
    return columns.map(function(column, index) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
            id: index,
            children: column
        }, index);
    });
};
var hasNegativeTrend = function(metric) {
    var DaysToWarningAvg = metric.DaysToWarningAvg, DaysToCriticalAvg = metric.DaysToCriticalAvg, DaysToCapacityAvg = metric.DaysToCapacityAvg;
    if (DaysToWarningAvg == null || isNaN(DaysToWarningAvg) || DaysToCriticalAvg == null || isNaN(DaysToCriticalAvg) || DaysToCapacityAvg == null || isNaN(DaysToCapacityAvg)) return true;
    return false;
};
var getMetricLevel = function(metric) {
    var result = "";
    var DaysToWarningAvg = metric.DaysToWarningAvg, DaysToCriticalAvg = metric.DaysToCriticalAvg, DaysToCapacityAvg = metric.DaysToCapacityAvg;
    if (hasNegativeTrend(metric)) return result;
    //capacity
    if (0 < DaysToCapacityAvg && DaysToCapacityAvg < 180) return "capacity";
    //critical
    if (0 < DaysToCriticalAvg && DaysToCriticalAvg < 180) return "critical";
    //warning
    if (0 < DaysToWarningAvg && DaysToWarningAvg < 180) //console.log('warning metric: ', metric);
    return "warning";
    return result;
};
var addDays = function addDays(d) {
    if (d <= 0) return 'Now';
    else if (d == 1) return "In 1 day";
    else if (d > 365) return 'More than a year out';
    var months = Math.floor(d / 30);
    if (months > 1) return "In ".concat(months, " months");
    var weeks = Math.floor(d / 7);
    if (weeks > 1) return "In ".concat(weeks, " weeks");
    return "In ".concat(d, " days");
};
var rollupTotals = function(forecastData) {
    var result = {
        "cpu": {
            ok: 0,
            warning: 0,
            critical: 0,
            capacity: 0
        },
        "mem": {
            ok: 0,
            warning: 0,
            critical: 0,
            capacity: 0
        }
    };
    for(var i = 0; i < forecastData.length; i++)for(var m = 0; m < forecastData[i].forecast.results.length; m++){
        var metric = forecastData[i].forecast.results[m];
        var isCPU = metric.MetricName === "Forecast.Metric.CpuLoad";
        var level = getMetricLevel(metric);
        if (level === "") level = "ok";
        if (isCPU) result.cpu[level]++;
        else result.mem[level]++;
    }
    return result;
};
var getRowStatusIcon = function(metric, index) {
    var icon, iconColor;
    var tooltipMessage = "";
    if (metric.statusType == "ok") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-check text-success"
    });
    else if (metric.statusType == "warning") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-triangle text-warning"
    });
    else if (metric.statusType == "critical") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-circle text-warning"
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-circle text-danger"
    });
};
var getDashboardIcon = function(type, number) {
    if (number == 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-check text-success",
        style: {
            paddingLeft: "2px"
        }
    });
    if (type == "warning") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-triangle text-warning",
        style: {
            paddingLeft: "2px"
        }
    });
    else if (type == "critical") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-circle  text-warning",
        style: {
            paddingLeft: "2px"
        }
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
        className: "fas fa-exclamation-circle  text-danger",
        style: {
            paddingLeft: "2px"
        }
    });
};
var getPushedState = function(metric, type, number) {
    var state = {};
    var statusType;
    if (number == 0) statusType = "ok";
    else statusType = type;
    state = {
        vmCapacityFilter: statusType,
        vmMetricType: metric
    };
    return state;
};
var getTicketDescriptionByStatus = function(result) {
    if (result.statusType == "ok") return "";
    else return "TRiA shows that we may have capacity planning needs for VM ".concat(result.DisplayName, ". What are our options?");
};
var SolarwindForecast = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        devices: []
    }), 2), state = _useState1[0], setState = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({
        devices: []
    }), 2), filteredDevices = _useState2[0], setFilteredDevices = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([]), 2), items = _useState3[0], setItems = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(0), 2), pagesCount = _useState4[0], setPagesCount = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(0), 2), currentPage = _useState5[0], setCurrentPage = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)([]), 2), paginationRange = _useState6[0], setPaginationRange = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)({
        "ok": 0,
        "warning": 0,
        "critical": 0,
        "capacity": 0
    }), 2), statusTypeNums = _useState7[0], setStatusTypeNums = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)("All"), 2), statusType = _useState8[0], setStatusType = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(""), 2), query = _useState9[0], setQuery = _useState9[1];
    var _useState10 = (0, _slicedToArray._)((0, _react.useState)(""), 2), search = _useState10[0], setSearch = _useState10[1];
    var _useState11 = (0, _slicedToArray._)((0, _react.useState)(''), 2), sortBy = _useState11[0], setSortBy = _useState11[1];
    var _useState12 = (0, _slicedToArray._)((0, _react.useState)(false), 2), sortByDesc = _useState12[0], setSortByDesc = _useState12[1];
    var history = (0, _reactRouterDom.useHistory)();
    var source = (0, _indexDefault.default).CancelToken.source();
    var _useState13 = (0, _slicedToArray._)((0, _react.useState)({
        "cpu": {
            ok: 0,
            warning: 0,
            critical: 0,
            capacity: 0
        },
        "mem": {
            ok: 0,
            warning: 0,
            critical: 0,
            capacity: 0
        }
    }), 2), rollups = _useState13[0], setRollups = _useState13[1];
    var offset = 50;
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var forecast, forecastWithStatusTypes, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _solarwindDefault.default).forecast({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        forecast = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        forecastWithStatusTypes = markMetricStatusTypes(forecast.data);
                        setState(function(values) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                devices: forecastWithStatusTypes
                            });
                        });
                        setFilteredDevices(function(values) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                devices: forecastWithStatusTypes
                            });
                        });
                        setRollups(rollupTotals(forecast.data));
                        if (history.location.state != null) setStatusType(history.location.state.vmCapacityFilter ? history.location.state.vmCapacityFilter : 'All');
                        else setStatusType('All');
                        // reset the pushed state to be blank
                        history.replace(history.location.pathname, {});
                        setPagination(forecastWithStatusTypes);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _indexDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    (0, _react.useEffect)(function() {
        if (props.metric === "CpuLoad") setStatusTypeNums(rollups.cpu);
        else setStatusTypeNums(rollups.mem);
    }, [
        rollups
    ]);
    (0, _react.useEffect)(function() {
        var items = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var device = _step.value;
                device.forecast.results.map(function(result, idx) {
                    if (result.MetricName === 'Forecast.Metric.' + props.metric) {
                        result.deviceID = device.device_id;
                        items.push(result);
                    }
                });
            };
            for(var _iterator = filteredDevices.devices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setItems(items);
    }, [
        filteredDevices
    ]);
    (0, _react.useEffect)(function() {
        var devices = state.devices;
        var metrics = state.devices.map(function(device) {
            return device.forecast.results[device.forecast.results.findIndex(function(r) {
                return props.metric == "CpuLoad" ? r.MetricId === 1 : r.MetricId === 2;
            })];
        });
        if (search != "") devices = devices.filter(function(device, idx) {
            return metrics[idx].DisplayName.toLowerCase().includes(search.toLowerCase());
        });
        if (props.metric === "CpuLoad") setStatusTypeNums(rollups.cpu);
        else setStatusTypeNums(rollups.mem);
        if (statusType != "All") devices = devices.filter(function(device, idx) {
            return metrics[idx].statusType == statusType;
        });
        setPagination(devices);
        setFilteredDevices(function(values) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                devices: devices
            });
        });
    }, [
        statusType,
        search
    ]);
    var setPagination = function(data) {
        var numPages = Math.ceil(data.length / offset);
        setPagesCount(numPages);
        if (numPages >= 5) setPaginationRange((0, _misc.range)(0, 5));
        else setPaginationRange((0, _misc.range)(0, numPages));
        setCurrentPage(0);
    };
    var markMetricStatusTypes = function(forecast) {
        var devices = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = forecast[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var device = _step.value;
                var metrics = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = device.forecast.results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var result = _step1.value;
                        var statusType = "ok";
                        var level = getMetricLevel(result);
                        if (level !== "") statusType = level;
                        metrics.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
                            statusType: statusType,
                            tooltipOpen: false
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                devices.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, device), {
                    forecast: {
                        results: metrics
                    }
                }));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return devices;
    };
    var toggleStatusType = function(status) {
        if (status == statusType) setStatusType("All");
        else setStatusType(status);
    };
    var handlePageClick = function(e, index) {
        e.preventDefault();
        setCurrentPage(index);
        if (index > 2 && index < pagesCount - 2) setPaginationRange((0, _misc.range)(index - 2, index + 3));
        else if (index <= 2) {
            if (pagesCount <= 5) setPaginationRange((0, _misc.range)(0, pagesCount));
            else setPaginationRange((0, _misc.range)(0, 5));
        } else setPaginationRange((0, _misc.range)(pagesCount - 5, pagesCount));
    };
    var sortFields = [
        'DisplayName',
        'DaysToWarningAvg',
        'DaysToCriticalAvg',
        'DaysToCapacityAvg'
    ];
    // set order field and ascending or descending flag
    var sortItems = function(field) {
        if (field === sortBy) // change ascending or descending flag
        setSortByDesc(!sortByDesc);
        else {
            if (!sortFields.includes(field)) field = sortFields[0];
            setSortByDesc(false);
            setSortBy(field);
        }
        var desc = sortByDesc ? -1 : 1;
        items.sort(function(a, b) {
            var item1 = a[sortBy], item2 = b[sortBy];
            if (typeof item1 === 'string') item1 = item1.toLowerCase();
            if (typeof item2 === 'string') item2 = item2.toLowerCase();
            if (item1 < item2) return -1 * desc;
            else if (item1 > item2) return desc;
            else return 0;
        });
        setItems(items);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-spinner m-3 mt-4 fa-spin",
                style: {
                    fontSize: "30px"
                }
            })
        }) : props.rollup ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Table), {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Warning"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Critical"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "At Capacity"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            className: "text-right",
                                            children: "CPU"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("cpu", "warning", rollups.cpu.warning));
                                                },
                                                children: [
                                                    rollups.cpu.warning,
                                                    " ",
                                                    getDashboardIcon("warning", rollups.cpu.warning)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("cpu", "critical", rollups.cpu.critical));
                                                },
                                                children: [
                                                    rollups.cpu.critical,
                                                    " ",
                                                    getDashboardIcon("critical", rollups.cpu.critical)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("cpu", "capacity", rollups.cpu.capacity));
                                                },
                                                children: [
                                                    rollups.cpu.capacity,
                                                    " ",
                                                    getDashboardIcon("capacity", rollups.cpu.capacity)
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            className: "text-right",
                                            children: "Memory"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("mem", "warning", rollups.mem.warning));
                                                },
                                                children: [
                                                    rollups.mem.warning,
                                                    " ",
                                                    getDashboardIcon("warning", rollups.mem.warning)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("mem", "critical", rollups.mem.critical));
                                                },
                                                children: [
                                                    rollups.mem.critical,
                                                    " ",
                                                    getDashboardIcon("critical", rollups.mem.critical)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "cursor",
                                                onClick: function() {
                                                    history.push("/app/vm/capacity", getPushedState("mem", "capacity", rollups.mem.capacity));
                                                },
                                                children: [
                                                    rollups.mem.capacity,
                                                    " ",
                                                    getDashboardIcon("capacity", rollups.mem.capacity)
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-left",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        children: "Number of virtual machines approaching capacity issues."
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "row small-desktop-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-md-3 pl-0",
                            style: {
                                paddingBottom: "15px"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                    onSubmit: function(e) {
                                        setSearch(query);
                                        e.preventDefault();
                                    },
                                    style: {
                                        maxWidth: "250px",
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                            onChange: function(e) {
                                                return setQuery(e.target.value);
                                            },
                                            value: query,
                                            type: "text",
                                            placeholder: "Search for VMs",
                                            style: {
                                                paddingRight: "60px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-times-circle",
                                            id: "clearButton",
                                            style: {
                                                cursor: "pointer",
                                                position: "absolute",
                                                right: "10px",
                                                top: "12px"
                                            },
                                            onClick: function() {
                                                setQuery("");
                                                setSearch("");
                                            }
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-md-9 col-xl-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ButtonGroup), {
                                size: "sm",
                                className: "d-flex w-100 justify-content-center",
                                role: "group",
                                style: {
                                    paddingBottom: "15px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            toggleStatusType("ok");
                                        },
                                        className: "bm-status-btn btn-sm w-100 ".concat(statusType !== "ok" ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "190px",
                                            border: "unset"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row justify-content-center fas",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "text-success fas fa-check mr-1"
                                                }),
                                                " Ok (".concat(statusTypeNums.ok, ")")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            toggleStatusType("warning");
                                        },
                                        className: "bm-status-btn btn-sm w-100 ".concat(statusType !== "warning" ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "190px",
                                            border: "unset"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row justify-content-center fas",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "text-warning fas fa-exclamation-triangle mr-1"
                                                }),
                                                " Warning (".concat(statusTypeNums.warning, ")")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            toggleStatusType("critical");
                                        },
                                        className: "bm-status-btn btn-sm w-100 ".concat(statusType !== "critical" ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "190px",
                                            border: "unset"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row justify-content-center fas",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "text-warning fas fa-exclamation-circle mr-1"
                                                }),
                                                " Critical (".concat(statusTypeNums.critical, ")")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        onClick: function() {
                                            toggleStatusType("capacity");
                                        },
                                        className: "bm-status-btn btn-sm w-100 ".concat(statusType !== "capacity" ? "btn-simple" : ""),
                                        style: {
                                            maxWidth: "190px",
                                            border: "unset"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row justify-content-center fas",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "text-danger fas fa-exclamation-circle mr-1"
                                                }),
                                                " Capacity (".concat(statusTypeNums.capacity, ")")
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "table-responsive-sm justify-content-center small-desktop-table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Table), {
                            bordered: true,
                            id: 'solarwind-' + props.metric,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                onClick: function() {
                                                    sortItems("DisplayName");
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    "VM",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "ml-1 fas fa-long-arrow-alt-" + (sortByDesc ? "up" : "down")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                onClick: function() {
                                                    sortItems("DaysToWarningAvg");
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    "Warning Date",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "ml-1 fas fa-long-arrow-alt-" + (sortByDesc ? "up" : "down")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                onClick: function() {
                                                    sortItems("DaysToCriticalAvg");
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    "Critical Date",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "ml-1 fas fa-long-arrow-alt-" + (sortByDesc ? "up" : "down")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                                onClick: function() {
                                                    sortItems("DaysToCapacityAvg");
                                                },
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    "At Capacity",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "ml-1 fas fa-long-arrow-alt-" + (sortByDesc ? "up" : "down")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                className: "text-center",
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                    children: items.slice(currentPage * offset, (currentPage + 1) * offset).map(function(item, idx) {
                                        var DaysToWarningAvg = item.DaysToWarningAvg, DaysToCriticalAvg = item.DaysToCriticalAvg, DaysToCapacityAvg = item.DaysToCapacityAvg;
                                        var highestPriorityThreshold = getMetricLevel(item);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                    children: [
                                                        getRowStatusIcon(item, idx),
                                                        " ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: highestPriorityThreshold != "" ? "font-weight-bold" : "",
                                                            children: item.DisplayName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: highestPriorityThreshold == "warning" ? "font-weight-bold" : "",
                                                        children: hasNegativeTrend(item) ? 'N/A' : addDays(DaysToWarningAvg)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: highestPriorityThreshold == "critical" ? "font-weight-bold" : "",
                                                        children: hasNegativeTrend(item) ? 'N/A' : addDays(DaysToCriticalAvg)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: highestPriorityThreshold == "capacity" ? "font-weight-bold" : "",
                                                        children: hasNegativeTrend(item) ? 'N/A' : addDays(DaysToCapacityAvg)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    className: "dropdown-cell text-center",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionsDropdown, {
                                                        deviceID: item.deviceID
                                                    })
                                                })
                                            ]
                                        }, item.DisplayName + '-' + props.metric);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pt-3 d-flex w-100 justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Pagination), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                        disabled: currentPage <= 0,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                            first: true,
                                            href: "#",
                                            onClick: function(e) {
                                                return handlePageClick(e, 0);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                        disabled: currentPage <= 0,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                            previous: true,
                                            href: "#",
                                            onClick: function(e) {
                                                return handlePageClick(e, currentPage - 1);
                                            }
                                        })
                                    }),
                                    paginationRange.map(function(page, i) {
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                            active: page === currentPage,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                                onClick: function(e) {
                                                    return handlePageClick(e, page);
                                                },
                                                href: "#",
                                                children: page + 1
                                            })
                                        }, page);
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                        disabled: currentPage >= pagesCount - 1,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                            next: true,
                                            href: "#",
                                            onClick: function(e) {
                                                return handlePageClick(e, currentPage + 1);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                        disabled: currentPage >= pagesCount - 1,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                            last: true,
                                            href: "#",
                                            onClick: function(e) {
                                                return handlePageClick(e, pagesCount - 1);
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var createNewTicket = function(e, deviceID, history) {
    if (e != null) e.preventDefault();
    history.push({
        pathname: "/app/create-ticket",
        state: {
            closeOnSuccess: true,
            subject: '',
            description: '',
            attachmentElementId: '',
            deviceId: deviceID
        }
    });
};
var ActionsDropdown = function(props) {
    var history = (0, _reactRouterDom.useHistory)();
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), dropdownOpen = _useState[0], setDropdownOpen = _useState[1];
    var toggle = function(item) {
        setDropdownOpen(!dropdownOpen);
        if ((typeof item === "undefined" ? "undefined" : (0, _typeOf._)(item)) === "object") return;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Dropdown), {
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownToggle), {
                tag: "span",
                "data-toggle": "dropdown",
                "aria-expanded": dropdownOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: "Actions"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: " fas fa-caret-" + (dropdownOpen ? 'up' : 'down'),
                        style: {
                            paddingLeft: "3px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        onClick: function(e) {
                            createNewTicket(e, props.deviceID, history);
                        },
                        children: "Create Ticket"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        onClick: function() {
                            history.push("/app/devices", {
                                deviceID: props.deviceID
                            });
                        },
                        children: "View Device"
                    })
                ]
            })
        ]
    });
};
var SolarWindsDetailWidget = function(props) {
    var types = {
        CpuLoad: 'CPU Utilization',
        PercentMemoryUsed: 'Memory Utilization'
    };
    var targetPart = types[props.type].split(' ')[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Card), {
        className: "card-home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SolarwindForecast, {
                    metric: props.type
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        marginLeft: "10%"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "text-left mt-2 ",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    fontSize: "1rem"
                                },
                                children: "N/A"
                            }),
                            " = Usage has decreased over time."
                        ]
                    })
                })
            ]
        })
    }, props.id);
};
var SolarWindsDesktopWidget = function(props) {
    var history = (0, _reactRouterDom.useHistory)();
    var types = {
        CpuLoad: 'CPU Utilization',
        PercentMemoryUsed: 'Memory Utilization'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "text-left",
                        children: "VMware Capacity"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SolarwindForecast, {
                        rollup: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "btn btn-light align-self-end btn-sm mt-3",
                onClick: function() {
                    history.push("/app/vm/capacity", {
                        vmCapacityFilter: "All"
                    });
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: "inline",
                            verticalAlign: "middle"
                        },
                        className: "fas fa-chart-line"
                    }),
                    " ",
                    "View Detail"
                ]
            })
        ]
    });
};
var SolarWindsDetailLayout = function(props) {
    //global state
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var history = (0, _reactRouterDom.useHistory)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)("1"), 2), activeTab = _useState[0], setActiveTab = _useState[1];
    //const [activeTab, setActiveTab] = useState("1");
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), cpuTabLoaded = _useState1[0], setCpuTabLoaded = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), memoryTabLoaded = _useState2[0], setMemoryTabLoaded = _useState2[1];
    (0, _react.useEffect)(function() {
        if (history.location.state != null && history.location.state.hasOwnProperty("vmMetricType")) {
            if (history.location.state.vmMetricType == "cpu") setActiveTab("1");
            else setActiveTab("2");
        }
    }, []);
    var toggleTab = function(tab) {
        setActiveTab(tab);
        if (tab == "1") setCpuTabLoaded(true);
        if (tab == "2") setMemoryTabLoaded(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "mb-3 mt-4 tria-header-class",
                children: "VMware Capacity"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ButtonGroup), {
                role: "group",
                className: "d-flex mb-3 justify-content-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        onClick: function() {
                            return toggleTab('1');
                        },
                        active: activeTab === '1',
                        className: "btn-sm w-100 ".concat(activeTab !== '1' ? "btn-simple" : ""),
                        style: {
                            maxWidth: "250px",
                            border: "unset"
                        },
                        children: "CPU Utilization"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        onClick: function() {
                            return toggleTab('2');
                        },
                        active: activeTab === '2',
                        className: "btn-sm w-100 ".concat(activeTab !== '2' ? "btn-simple" : ""),
                        style: {
                            maxWidth: "250px",
                            border: "unset"
                        },
                        children: "Memory Utilization"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.TabContent), {
                activeTab: activeTab,
                id: "tab-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                        tabId: "1",
                        children: (activeTab == "1" || cpuTabLoaded) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SolarWindsDetailWidget, {
                            type: 'CpuLoad',
                            id: 'cpu-solarwinds'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.TabPane), {
                        tabId: "2",
                        children: (activeTab == "2" || memoryTabLoaded) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SolarWindsDetailWidget, {
                            type: 'PercentMemoryUsed',
                            id: 'disk-solarwinds'
                        })
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","reactstrap":"774RE","../../services/Solarwind":"bT5YJ","../../utility/misc":"bM8Mk","axios/index":"ebRwi","../../utility/use-async-effect":"fShZN","react-router-dom":"acq4R","../../AppState":"8UGXH","moment":"3xZWN","../ConnectriaTickets/ConnectriaTicketsSupportDashboard":"bSLbt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bT5YJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var base_api = 'https://tria.connectria.com';
var swapi_url = 'https://casauaqdo6.execute-api.us-east-1.amazonaws.com/prod';
function defaultRequest() {
    return _defaultRequest.apply(this, arguments);
}
function _defaultRequest() {
    _defaultRequest = (0, _asyncToGenerator._)(function() {
        var idToken, req;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    req = (0, _axiosDefault.default).create({
                        baseURL: swapi_url,
                        headers: {
                            Authorization: idToken
                        }
                    });
                    //req.defaults.headers['Authorization'] = await Cognito.getIdToken();
                    return [
                        2,
                        req
                    ];
            }
        });
    });
    return _defaultRequest.apply(this, arguments);
}
var SolarwindService = {
    forecast: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params, req, orgId, res;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                    res = req.get("/org/".concat(orgId, "/forecast"), params);
                    return [
                        2,
                        res
                    ];
            }
        });
    }),
    get_device_metrics: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var options, _res_data, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.get("/org/".concat(orgId, "/devices"), (0, _objectSpread._)({
                                params: params
                            }, options))
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.nodes
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(),
    device_detail: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var params, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.get("/org/".concat(orgId, "/device/").concat(deviceId), params)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(deviceId) {
            return _ref.apply(this, arguments);
        };
    }(),
    get_device_maintenance_window: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var params, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.get("/org/".concat(orgId, "/device/").concat(deviceId, "/mm"), params)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(deviceId) {
            return _ref.apply(this, arguments);
        };
    }(),
    get_device_volume_info: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var params, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.get("/org/".concat(orgId, "/device/").concat(deviceId, "/volume"), params)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(deviceId) {
            return _ref.apply(this, arguments);
        };
    }(),
    create_device_maintenance_window: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId, payload) {
            var params, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.post("/org/".concat(orgId, "/device/").concat(deviceId, "/mm"), payload, params)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(deviceId, payload) {
            return _ref.apply(this, arguments);
        };
    }(),
    delete_device_maintenance_window: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var params, req, orgId, res, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 2:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        return [
                            4,
                            req.delete("/org/".concat(orgId, "/device/").concat(deviceId, "/mm"), params)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(deviceId) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = SolarwindService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","../services/CookieService":"iKLPT","../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dOGxj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicDashboardComponents", function() {
    return DynamicDashboardComponents;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _reactstrap = require("reactstrap");
var _carouselMinCss = require("react-responsive-carousel/lib/styles/carousel.min.css");
var _reactResponsiveCarousel = require("react-responsive-carousel");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../../AppState");
var _enumJs = require("../../utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
var _ramda = require("ramda");
var _featureToggle = require("../../utility/FeatureToggle");
var DynamicDashboardCardBodyCarousel = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 1), stateApp = _appState1[0];
    // Update the index in the card header
    var updateCarouselIndex = function(index) {
        props.setCarouselIndex(index);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactResponsiveCarousel.Carousel), {
        selectedItem: props.carouselIndex,
        showStatus: false,
        showThumbs: false,
        onChange: updateCarouselIndex,
        className: "carousel-control-dots-abs",
        children: props.components.map(function(comp, index) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-100",
                children: comp
            }, index);
        })
    });
};
function flatten(ary, prop) {
    var ret = [];
    for(var i = 0; i < ary.length; i++)if (Array.isArray(ary[i][prop])) ret = ret.concat(flatten(ary[i][prop], prop));
    else ret.push(ary[i]);
    return ret;
}
var DynamicDashboardCard = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 1), stateApp = _appState1[0];
    var user_roles = stateApp.roles_v2;
    var policies = stateApp.policies;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), matches = _useState[0], setMatches = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), carouselIndex = _useState1[0], setCarouselIndex = _useState1[1];
    var noCard = (0, _react.useMemo)(function() {
        return typeof props.noCard === 'function' ? props.noCard(stateApp.env, stateApp.clouds) : props.noCard;
    }, [
        stateApp.env,
        stateApp.clouds,
        props.noCard
    ]);
    (0, _react.useEffect)(function() {
        var m = props.components.filter(function(c) {
            var matchCloud = false;
            var matchEnv = false;
            var matchPolicies = (0, _featureToggle.hasPolicies)(c.props.policies, stateApp);
            var matchIntegration = true;
            for(var i = 0; i < (c.props.clouds || []).length; i++){
                if (c.props.clouds[i] == (0, _enumJsDefault.default).CloudCategory.ALL) {
                    matchCloud = true;
                    break;
                }
                if (stateApp.clouds.includes(c.props.clouds[i])) {
                    matchCloud = true;
                    break;
                }
            }
            for(var i = 0; i < (c.props.envs || []).length; i++)if (c.props.envs[i] == (0, _enumJsDefault.default).Env.ALL || c.props.envs[i] === stateApp.env) {
                matchEnv = true;
                break;
            }
            for(var i = 0; i < (c.props.integrations || []).length; i++)if (!stateApp.integrations.includes(c.props.integrations[i])) {
                matchIntegration = false;
                break;
            }
            return matchCloud && matchEnv && matchIntegration && matchPolicies;
        });
        //    if (!stateApp.superAdmin && user_roles.filter((e) => e.RoleName == "OrgAdmin").length == 0){
        //     m = (props.components.filter(c => {
        //     if(c.props.policies){
        //       if(!policies.includes(c.props.policies[0]))
        //       return false;
        //     }
        //     return true;
        //   }));
        // }
        setMatches(m);
    }, []);
    var hasContent = matches !== null && (matches || []).length > 0;
    var content = hasContent && (matches.length > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DynamicDashboardCardBodyCarousel, {
        components: matches,
        carouselIndex: carouselIndex,
        setCarouselIndex: setCarouselIndex
    }) : matches[0]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: hasContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: props.className,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: props.equalHeightCards ? 'd-flex h-100' : '',
                children: noCard ? content : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                    className: "card-chart card-home",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                            className: "card-header",
                            style: {
                                background: 'white',
                                borderBottom: 'none',
                                boxShadow: 'none'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardTitle), {
                                className: "tria-card-title",
                                tag: "h3",
                                children: [
                                    props.title,
                                    matches.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "pull-right",
                                        children: [
                                            carouselIndex + 1,
                                            "/",
                                            matches.length
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                            children: content
                        })
                    ]
                })
            })
        })
    });
};
var DynamicDashboardRow = function(props) {
    //  if(!hasPolicies(props.policies)) return <></>
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.cards.map(function(c, i) {
            //check for nesting - only support one-level
            //take the col class from the first row
            if (c.nestedConfig) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: c.nestedConfig[0].className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DynamicDashboardComponents, {
                    config: c.nestedConfig
                })
            }, i);
            else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DynamicDashboardCard, {
                title: c.title,
                className: c.className,
                components: c.components,
                noCard: c.noCard,
                equalHeightCards: props.equalHeightCards
            }, i);
        })
    });
};
var DynamicDashboardComponents = function(props) {
    var components = props.config.map(function(c, i) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DynamicDashboardRow, {
            policies: c.policies || [],
            cards: c.cards,
            equalHeightCards: c.equalHeightCards
        }, i);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: components
    });
};

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","reactstrap":"774RE","react-responsive-carousel/lib/styles/carousel.min.css":"b05hn","react-responsive-carousel":"8MeK4","react":"gVheC","../../AppState":"8UGXH","../../utility/enum.js":"3A9fW","ramda":"2pVIv","../../utility/FeatureToggle":"2vty2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b05hn":[function() {},{}],"8MeK4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Carousel", {
    enumerable: true,
    get: function get() {
        return _Carousel.default;
    }
});
Object.defineProperty(exports, "CarouselProps", {
    enumerable: true,
    get: function get() {
        return _types.CarouselProps;
    }
});
Object.defineProperty(exports, "Thumbs", {
    enumerable: true,
    get: function get() {
        return _Thumbs.default;
    }
});
var _Carousel = _interopRequireDefault(require("c33098d82c8ce142"));
var _types = require("bd9f417a95000df2");
var _Thumbs = _interopRequireDefault(require("937256a94cd477ae"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"c33098d82c8ce142":"cgBfh","bd9f417a95000df2":"8QK98","937256a94cd477ae":"evH87"}],"cgBfh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("e2611443e8028246"));
var _reactEasySwipe = _interopRequireDefault(require("c9f393140c21d47c"));
var _cssClasses = _interopRequireDefault(require("bfde4611b5f50ef5"));
var _Thumbs = _interopRequireDefault(require("b5b4d5c8066c3b98"));
var _document = _interopRequireDefault(require("3cc2caaea439419b"));
var _window = _interopRequireDefault(require("6b21b5fb06ba11ba"));
var _utils = require("f8d1320c11caaf95");
var _animations = require("25ba500bca28f86f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Carousel = /*#__PURE__*/ function(_React$Component) {
    _inherits(Carousel, _React$Component);
    var _super = _createSuper(Carousel);
    // @ts-ignore
    function Carousel(props) {
        var _this;
        _classCallCheck(this, Carousel);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "listRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "timer", void 0);
        _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);
        _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function(node) {
            _this.thumbsRef = node;
        });
        _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function(node) {
            _this.carouselWrapperRef = node;
        });
        _defineProperty(_assertThisInitialized(_this), "setListRef", function(node) {
            _this.listRef = node;
        });
        _defineProperty(_assertThisInitialized(_this), "setItemsRef", function(node, index) {
            if (!_this.itemsRef) _this.itemsRef = [];
            _this.itemsRef[index] = node;
        });
        _defineProperty(_assertThisInitialized(_this), "autoPlay", function() {
            if (_react.Children.count(_this.props.children) <= 1) return;
            _this.clearAutoPlay();
            if (!_this.props.autoPlay) return;
            _this.timer = setTimeout(function() {
                _this.increment();
            }, _this.props.interval);
        });
        _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function() {
            if (_this.timer) clearTimeout(_this.timer);
        });
        _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function() {
            _this.clearAutoPlay();
            _this.autoPlay();
        });
        _defineProperty(_assertThisInitialized(_this), "stopOnHover", function() {
            _this.setState({
                isMouseEntered: true
            }, _this.clearAutoPlay);
        });
        _defineProperty(_assertThisInitialized(_this), "startOnLeave", function() {
            _this.setState({
                isMouseEntered: false
            }, _this.autoPlay);
        });
        _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function() {
            if (!_this.carouselWrapperRef) return false;
            if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) return true;
            return false;
        });
        _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function(e) {
            if (!_this.isFocusWithinTheCarousel()) return;
            var axis = _this.props.axis;
            var isHorizontal = axis === 'horizontal';
            var keyNames = {
                ArrowUp: 38,
                ArrowRight: 39,
                ArrowDown: 40,
                ArrowLeft: 37
            };
            var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
            var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
            if (nextKey === e.keyCode) _this.increment();
            else if (prevKey === e.keyCode) _this.decrement();
        });
        _defineProperty(_assertThisInitialized(_this), "updateSizes", function() {
            if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) return;
            var isHorizontal = _this.props.axis === 'horizontal';
            var firstItem = _this.itemsRef[0];
            if (!firstItem) return;
            var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
            _this.setState({
                itemSize: itemSize
            });
            if (_this.thumbsRef) _this.thumbsRef.updateSizes();
        });
        _defineProperty(_assertThisInitialized(_this), "setMountState", function() {
            _this.setState({
                hasMount: true
            });
            _this.updateSizes();
        });
        _defineProperty(_assertThisInitialized(_this), "handleClickItem", function(index, item) {
            if (_react.Children.count(_this.props.children) === 0) return;
            if (_this.state.cancelClick) {
                _this.setState({
                    cancelClick: false
                });
                return;
            }
            _this.props.onClickItem(index, item);
            if (index !== _this.state.selectedItem) _this.setState({
                selectedItem: index
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleOnChange", function(index, item) {
            if (_react.Children.count(_this.props.children) <= 1) return;
            _this.props.onChange(index, item);
        });
        _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function(index, item) {
            _this.props.onClickThumb(index, item);
            _this.moveTo(index);
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function(event) {
            _this.setState({
                swiping: true
            });
            _this.props.onSwipeStart(event);
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function(event) {
            _this.setState({
                swiping: false,
                cancelClick: false,
                swipeMovementStarted: false
            });
            _this.props.onSwipeEnd(event);
            _this.clearAutoPlay();
            if (_this.state.autoPlay) _this.autoPlay();
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function(delta, event) {
            _this.props.onSwipeMove(event);
            var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));
            _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
            // Return false to allow scrolling when not swiping
            return !!Object.keys(animationHandlerResponse).length;
        });
        _defineProperty(_assertThisInitialized(_this), "decrement", function() {
            var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
        });
        _defineProperty(_assertThisInitialized(_this), "increment", function() {
            var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
        });
        _defineProperty(_assertThisInitialized(_this), "moveTo", function(position) {
            if (typeof position !== 'number') return;
            var lastPosition = _react.Children.count(_this.props.children) - 1;
            if (position < 0) position = _this.props.infiniteLoop ? lastPosition : 0;
            if (position > lastPosition) position = _this.props.infiniteLoop ? 0 : lastPosition;
            _this.selectItem({
                // if it's not a slider, we don't need to set position here
                selectedItem: position
            }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
            // and will result in the interval function not being cleared correctly.
            if (_this.state.autoPlay && _this.state.isMouseEntered === false) _this.resetAutoPlay();
        });
        _defineProperty(_assertThisInitialized(_this), "onClickNext", function() {
            _this.increment(1);
        });
        _defineProperty(_assertThisInitialized(_this), "onClickPrev", function() {
            _this.decrement(1);
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function() {
            _this.increment(1);
            if (_this.props.emulateTouch) _this.setState({
                cancelClick: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function() {
            _this.decrement(1);
            if (_this.props.emulateTouch) _this.setState({
                cancelClick: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "changeItem", function(newIndex) {
            return function(e) {
                if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') _this.moveTo(newIndex);
            };
        });
        _defineProperty(_assertThisInitialized(_this), "selectItem", function(state) {
            // Merge in the new state while updating updating previous item
            _this.setState(_objectSpread({
                previousItem: _this.state.selectedItem
            }, state), function() {
                // Run animation handler and update styles based on it
                _this.setState(_this.animationHandler(_this.props, _this.state));
            });
            _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
        });
        _defineProperty(_assertThisInitialized(_this), "getInitialImage", function() {
            var selectedItem = _this.props.selectedItem;
            var item = _this.itemsRef && _this.itemsRef[selectedItem];
            var images = item && item.getElementsByTagName('img') || [];
            return images[0];
        });
        _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function(position) {
            var item = _this.itemsRef && _this.itemsRef[position];
            if (_this.state.hasMount && item && item.children.length) {
                var slideImages = item.children[0].getElementsByTagName('img') || [];
                if (slideImages.length > 0) {
                    var image = slideImages[0];
                    if (!image.complete) {
                        // if the image is still loading, the size won't be available so we trigger a new render after it's done
                        var onImageLoad = function onImageLoad() {
                            _this.forceUpdate();
                            image.removeEventListener('load', onImageLoad);
                        };
                        image.addEventListener('load', onImageLoad);
                    }
                } // try to get img first, if img not there find first display tag
                var displayItem = slideImages[0] || item.children[0];
                var height = displayItem.clientHeight;
                return height > 0 ? height : null;
            }
            return null;
        });
        var initState = {
            initialized: false,
            previousItem: props.selectedItem,
            selectedItem: props.selectedItem,
            hasMount: false,
            isMouseEntered: false,
            autoPlay: props.autoPlay,
            swiping: false,
            swipeMovementStarted: false,
            cancelClick: false,
            itemSize: 1,
            itemListStyle: {},
            slideStyle: {},
            selectedStyle: {},
            prevStyle: {}
        };
        _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
        _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
        return _this;
    }
    _createClass(Carousel, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.children) return;
                this.setupCarousel();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!prevProps.children && this.props.children && !this.state.initialized) this.setupCarousel();
                if (!prevProps.autoFocus && this.props.autoFocus) this.forceFocus();
                if (prevState.swiping && !this.state.swiping) // We stopped swiping, ensure we are heading to the new/current slide and not stuck
                this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
                if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
                    this.updateSizes();
                    this.moveTo(this.props.selectedItem);
                }
                if (prevProps.autoPlay !== this.props.autoPlay) {
                    if (this.props.autoPlay) this.setupAutoPlay();
                    else this.destroyAutoPlay();
                    this.setState({
                        autoPlay: this.props.autoPlay
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyCarousel();
            }
        },
        {
            key: "setupCarousel",
            value: function setupCarousel() {
                var _this2 = this;
                this.bindEvents();
                if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) this.setupAutoPlay();
                if (this.props.autoFocus) this.forceFocus();
                this.setState({
                    initialized: true
                }, function() {
                    var initialImage = _this2.getInitialImage();
                    if (initialImage && !initialImage.complete) // if it's a carousel of images, we set the mount state after the first image is loaded
                    initialImage.addEventListener('load', _this2.setMountState);
                    else _this2.setMountState();
                });
            }
        },
        {
            key: "destroyCarousel",
            value: function destroyCarousel() {
                if (this.state.initialized) {
                    this.unbindEvents();
                    this.destroyAutoPlay();
                }
            }
        },
        {
            key: "setupAutoPlay",
            value: function setupAutoPlay() {
                this.autoPlay();
                var carouselWrapper = this.carouselWrapperRef;
                if (this.props.stopOnHover && carouselWrapper) {
                    carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
                    carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
                }
            }
        },
        {
            key: "destroyAutoPlay",
            value: function destroyAutoPlay() {
                this.clearAutoPlay();
                var carouselWrapper = this.carouselWrapperRef;
                if (this.props.stopOnHover && carouselWrapper) {
                    carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
                    carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
                }
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                // as the widths are calculated, we need to resize
                // the carousel when the window is resized
                (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller
                (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);
                if (this.props.useKeyboardArrows) (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
            }
        },
        {
            key: "unbindEvents",
            value: function unbindEvents() {
                // removing listeners
                (0, _window.default)().removeEventListener('resize', this.updateSizes);
                (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
                var initialImage = this.getInitialImage();
                if (initialImage) initialImage.removeEventListener('load', this.setMountState);
                if (this.props.useKeyboardArrows) (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
            }
        },
        {
            key: "forceFocus",
            value: function forceFocus() {
                var _this$carouselWrapper;
                (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 || _this$carouselWrapper.focus();
            }
        },
        {
            key: "renderItems",
            value: function renderItems(isClone) {
                var _this3 = this;
                if (!this.props.children) return [];
                return _react.Children.map(this.props.children, function(item, index) {
                    var isSelected = index === _this3.state.selectedItem;
                    var isPrevious = index === _this3.state.previousItem;
                    var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};
                    if (_this3.props.centerMode && _this3.props.axis === 'horizontal') style = _objectSpread(_objectSpread({}, style), {}, {
                        minWidth: _this3.props.centerSlidePercentage + '%'
                    });
                    if (_this3.state.swiping && _this3.state.swipeMovementStarted) style = _objectSpread(_objectSpread({}, style), {}, {
                        pointerEvents: 'none'
                    });
                    var slideProps = {
                        ref: function ref(e) {
                            return _this3.setItemsRef(e, index);
                        },
                        key: 'itemKey' + index + (isClone ? 'clone' : ''),
                        className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
                        onClick: _this3.handleClickItem.bind(_this3, index, item),
                        style: style
                    };
                    return /*#__PURE__*/ _react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
                        isSelected: index === _this3.state.selectedItem,
                        isPrevious: index === _this3.state.previousItem
                    }));
                });
            }
        },
        {
            key: "renderControls",
            value: function renderControls() {
                var _this4 = this;
                var _this$props = this.props, showIndicators = _this$props.showIndicators, labels = _this$props.labels, renderIndicator = _this$props.renderIndicator, children = _this$props.children;
                if (!showIndicators) return null;
                return /*#__PURE__*/ _react.default.createElement("ul", {
                    className: "control-dots"
                }, _react.Children.map(children, function(_, index) {
                    return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
                }));
            }
        },
        {
            key: "renderStatus",
            value: function renderStatus() {
                if (!this.props.showStatus) return null;
                return /*#__PURE__*/ _react.default.createElement("p", {
                    className: "carousel-status"
                }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
            }
        },
        {
            key: "renderThumbs",
            value: function renderThumbs() {
                if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) return null;
                return /*#__PURE__*/ _react.default.createElement(_Thumbs.default, {
                    ref: this.setThumbsRef,
                    onSelectItem: this.handleClickThumb,
                    selectedItem: this.state.selectedItem,
                    transitionTime: this.props.transitionTime,
                    thumbWidth: this.props.thumbWidth,
                    labels: this.props.labels,
                    emulateTouch: this.props.emulateTouch
                }, this.props.renderThumbs(this.props.children));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                if (!this.props.children || _react.Children.count(this.props.children) === 0) return null;
                var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
                var isHorizontal = this.props.axis === 'horizontal';
                var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?
                var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow
                var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
                var itemsClone = this.renderItems(true);
                var firstClone = itemsClone.shift();
                var lastClone = itemsClone.pop();
                var swiperProps = {
                    className: _cssClasses.default.SLIDER(true, this.state.swiping),
                    onSwipeMove: this.onSwipeMove,
                    onSwipeStart: this.onSwipeStart,
                    onSwipeEnd: this.onSwipeEnd,
                    style: this.state.itemListStyle,
                    tolerance: this.props.swipeScrollTolerance
                };
                var containerStyles = {};
                if (isHorizontal) {
                    swiperProps.onSwipeLeft = this.onSwipeForward;
                    swiperProps.onSwipeRight = this.onSwipeBackwards;
                    if (this.props.dynamicHeight) {
                        var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';
                        containerStyles.height = itemHeight || 'auto';
                    }
                } else {
                    swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
                    swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
                    swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
                        height: this.state.itemSize
                    });
                    containerStyles.height = this.state.itemSize;
                }
                return /*#__PURE__*/ _react.default.createElement("div", {
                    "aria-label": this.props.ariaLabel,
                    className: _cssClasses.default.ROOT(this.props.className),
                    ref: this.setCarouselWrapperRef,
                    tabIndex: this.props.useKeyboardArrows ? 0 : undefined
                }, /*#__PURE__*/ _react.default.createElement("div", {
                    className: _cssClasses.default.CAROUSEL(true),
                    style: {
                        width: this.props.width
                    }
                }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/ _react.default.createElement("div", {
                    className: _cssClasses.default.WRAPPER(true, this.props.axis),
                    style: containerStyles
                }, isSwipeable ? /*#__PURE__*/ _react.default.createElement(_reactEasySwipe.default, _extends({
                    tagName: "ul",
                    innerRef: this.setListRef
                }, swiperProps, {
                    allowMouseEvents: this.props.emulateTouch
                }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/ _react.default.createElement("ul", {
                    className: _cssClasses.default.SLIDER(true, this.state.swiping),
                    ref: function ref(node) {
                        return _this5.setListRef(node);
                    },
                    style: this.state.itemListStyle || {}
                }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
            }
        }
    ]);
    return Carousel;
}(_react.default.Component);
exports.default = Carousel;
_defineProperty(Carousel, "displayName", 'Carousel');
_defineProperty(Carousel, "defaultProps", {
    ariaLabel: undefined,
    axis: 'horizontal',
    centerSlidePercentage: 80,
    interval: 3000,
    labels: {
        leftArrow: 'previous slide / item',
        rightArrow: 'next slide / item',
        item: 'slide item'
    },
    onClickItem: _utils.noop,
    onClickThumb: _utils.noop,
    onChange: _utils.noop,
    onSwipeStart: function onSwipeStart() {},
    onSwipeEnd: function onSwipeEnd() {},
    onSwipeMove: function onSwipeMove() {
        return false;
    },
    preventMovementUntilSwipeScrollTolerance: false,
    renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
        return /*#__PURE__*/ _react.default.createElement("button", {
            type: "button",
            "aria-label": label,
            className: _cssClasses.default.ARROW_PREV(!hasPrev),
            onClick: onClickHandler
        });
    },
    renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
        return /*#__PURE__*/ _react.default.createElement("button", {
            type: "button",
            "aria-label": label,
            className: _cssClasses.default.ARROW_NEXT(!hasNext),
            onClick: onClickHandler
        });
    },
    renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
        return /*#__PURE__*/ _react.default.createElement("li", {
            className: _cssClasses.default.DOT(isSelected),
            onClick: onClickHandler,
            onKeyDown: onClickHandler,
            value: index,
            key: index,
            role: "button",
            tabIndex: 0,
            "aria-label": "".concat(label, " ").concat(index + 1)
        });
    },
    renderItem: function renderItem(item) {
        return item;
    },
    renderThumbs: function renderThumbs(children) {
        var images = _react.Children.map(children, function(item) {
            var img = item; // if the item is not an image, try to find the first image in the item's children.
            if (item.type !== 'img') img = _react.Children.toArray(item.props.children).find(function(children) {
                return children.type === 'img';
            });
            if (!img) return undefined;
            return img;
        });
        if (images.filter(function(image) {
            return image;
        }).length === 0) {
            console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
            return [];
        }
        return images;
    },
    statusFormatter: _utils.defaultStatusFormatter,
    selectedItem: 0,
    showArrows: true,
    showIndicators: true,
    showStatus: true,
    showThumbs: true,
    stopOnHover: true,
    swipeScrollTolerance: 5,
    swipeable: true,
    transitionTime: 350,
    verticalSwipe: 'standard',
    width: '100%',
    animationHandler: 'slide',
    swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
    stopSwipingHandler: _animations.slideStopSwipingHandler
});

},{"e2611443e8028246":"gVheC","c9f393140c21d47c":"9fDov","bfde4611b5f50ef5":"962NS","b5b4d5c8066c3b98":"evH87","3cc2caaea439419b":"l5KG8","6b21b5fb06ba11ba":"1tUg1","f8d1320c11caaf95":"sivJF","25ba500bca28f86f":"41IUs"}],"9fDov":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'exports',
        './react-swipe'
    ], factory);
    else {
        var mod;
        factory(exports, require("dbf559a38a8c3be0"));
    }
})(this, function(exports1, _reactSwipe) {
    'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    exports1.default = _reactSwipe2.default;
});

},{"dbf559a38a8c3be0":"jhbmx"}],"jhbmx":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'exports',
        'react',
        'prop-types'
    ], factory);
    else {
        var mod;
        factory(exports, require("f4303922a055a6cd"), require("a45b0606b32d2698"));
    }
})(undefined, function(exports1, _react, _propTypes) {
    'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var supportsCaptureOption = false;
    function setHasSupportToCaptureOption(hasSupport) {
        supportsCaptureOption = hasSupport;
    }
    try {
        addEventListener('test', null, Object.defineProperty({}, 'capture', {
            get: function get() {
                setHasSupportToCaptureOption(true);
            }
        }));
    } catch (e) {} // eslint-disable-line no-empty
    function getSafeEventHandlerOpts() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            capture: true
        };
        return supportsCaptureOption ? options : options.capture;
    }
    /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */ function getPosition(event) {
        if ('touches' in event) {
            var _event$touches$ = event.touches[0], pageX = _event$touches$.pageX, pageY = _event$touches$.pageY;
            return {
                x: pageX,
                y: pageY
            };
        }
        var screenX = event.screenX, screenY = event.screenY;
        return {
            x: screenX,
            y: screenY
        };
    }
    var ReactSwipe = function(_Component) {
        _inherits(ReactSwipe, _Component);
        function ReactSwipe() {
            var _ref;
            _classCallCheck(this, ReactSwipe);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [
                this
            ].concat(args)));
            _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
            _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
            _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
            _this._onMouseDown = _this._onMouseDown.bind(_this);
            _this._onMouseMove = _this._onMouseMove.bind(_this);
            _this._onMouseUp = _this._onMouseUp.bind(_this);
            _this._setSwiperRef = _this._setSwiperRef.bind(_this);
            return _this;
        }
        _createClass(ReactSwipe, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (this.swiper) this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
                        capture: true,
                        passive: false
                    }));
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (this.swiper) this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
                        capture: true,
                        passive: false
                    }));
                }
            },
            {
                key: '_onMouseDown',
                value: function _onMouseDown(event) {
                    if (!this.props.allowMouseEvents) return;
                    this.mouseDown = true;
                    document.addEventListener('mouseup', this._onMouseUp);
                    document.addEventListener('mousemove', this._onMouseMove);
                    this._handleSwipeStart(event);
                }
            },
            {
                key: '_onMouseMove',
                value: function _onMouseMove(event) {
                    if (!this.mouseDown) return;
                    this._handleSwipeMove(event);
                }
            },
            {
                key: '_onMouseUp',
                value: function _onMouseUp(event) {
                    this.mouseDown = false;
                    document.removeEventListener('mouseup', this._onMouseUp);
                    document.removeEventListener('mousemove', this._onMouseMove);
                    this._handleSwipeEnd(event);
                }
            },
            {
                key: '_handleSwipeStart',
                value: function _handleSwipeStart(event) {
                    var _getPosition = getPosition(event), x = _getPosition.x, y = _getPosition.y;
                    this.moveStart = {
                        x: x,
                        y: y
                    };
                    this.props.onSwipeStart(event);
                }
            },
            {
                key: '_handleSwipeMove',
                value: function _handleSwipeMove(event) {
                    if (!this.moveStart) return;
                    var _getPosition2 = getPosition(event), x = _getPosition2.x, y = _getPosition2.y;
                    var deltaX = x - this.moveStart.x;
                    var deltaY = y - this.moveStart.y;
                    this.moving = true;
                    // handling the responsability of cancelling the scroll to
                    // the component handling the event
                    var shouldPreventDefault = this.props.onSwipeMove({
                        x: deltaX,
                        y: deltaY
                    }, event);
                    if (shouldPreventDefault && event.cancelable) event.preventDefault();
                    this.movePosition = {
                        deltaX: deltaX,
                        deltaY: deltaY
                    };
                }
            },
            {
                key: '_handleSwipeEnd',
                value: function _handleSwipeEnd(event) {
                    this.props.onSwipeEnd(event);
                    var tolerance = this.props.tolerance;
                    if (this.moving && this.movePosition) {
                        if (this.movePosition.deltaX < -tolerance) this.props.onSwipeLeft(1, event);
                        else if (this.movePosition.deltaX > tolerance) this.props.onSwipeRight(1, event);
                        if (this.movePosition.deltaY < -tolerance) this.props.onSwipeUp(1, event);
                        else if (this.movePosition.deltaY > tolerance) this.props.onSwipeDown(1, event);
                    }
                    this.moveStart = null;
                    this.moving = false;
                    this.movePosition = null;
                }
            },
            {
                key: '_setSwiperRef',
                value: function _setSwiperRef(node) {
                    this.swiper = node;
                    this.props.innerRef(node);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, tagName = _props.tagName, className = _props.className, style = _props.style, children = _props.children, allowMouseEvents = _props.allowMouseEvents, onSwipeUp = _props.onSwipeUp, onSwipeDown = _props.onSwipeDown, onSwipeLeft = _props.onSwipeLeft, onSwipeRight = _props.onSwipeRight, onSwipeStart = _props.onSwipeStart, onSwipeMove = _props.onSwipeMove, onSwipeEnd = _props.onSwipeEnd, innerRef = _props.innerRef, tolerance = _props.tolerance, props = _objectWithoutProperties(_props, [
                        'tagName',
                        'className',
                        'style',
                        'children',
                        'allowMouseEvents',
                        'onSwipeUp',
                        'onSwipeDown',
                        'onSwipeLeft',
                        'onSwipeRight',
                        'onSwipeStart',
                        'onSwipeMove',
                        'onSwipeEnd',
                        'innerRef',
                        'tolerance'
                    ]);
                    return _react2.default.createElement(this.props.tagName, _extends({
                        ref: this._setSwiperRef,
                        onMouseDown: this._onMouseDown,
                        onTouchStart: this._handleSwipeStart,
                        onTouchEnd: this._handleSwipeEnd,
                        className: className,
                        style: style
                    }, props), children);
                }
            }
        ]);
        return ReactSwipe;
    }(_react.Component);
    ReactSwipe.displayName = 'ReactSwipe';
    ReactSwipe.propTypes = {
        tagName: _propTypes2.default.string,
        className: _propTypes2.default.string,
        style: _propTypes2.default.object,
        children: _propTypes2.default.node,
        allowMouseEvents: _propTypes2.default.bool,
        onSwipeUp: _propTypes2.default.func,
        onSwipeDown: _propTypes2.default.func,
        onSwipeLeft: _propTypes2.default.func,
        onSwipeRight: _propTypes2.default.func,
        onSwipeStart: _propTypes2.default.func,
        onSwipeMove: _propTypes2.default.func,
        onSwipeEnd: _propTypes2.default.func,
        innerRef: _propTypes2.default.func,
        tolerance: _propTypes2.default.number.isRequired
    };
    ReactSwipe.defaultProps = {
        tagName: 'div',
        allowMouseEvents: false,
        onSwipeUp: function onSwipeUp() {},
        onSwipeDown: function onSwipeDown() {},
        onSwipeLeft: function onSwipeLeft() {},
        onSwipeRight: function onSwipeRight() {},
        onSwipeStart: function onSwipeStart() {},
        onSwipeMove: function onSwipeMove() {},
        onSwipeEnd: function onSwipeEnd() {},
        innerRef: function innerRef() {},
        tolerance: 0
    };
    exports1.default = ReactSwipe;
});

},{"@swc/helpers/_/_type_of":"668P4","f4303922a055a6cd":"gVheC","a45b0606b32d2698":"3KNJy"}],"962NS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("99104ff522e78b01"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var _default = {
    ROOT: function ROOT(customClassName) {
        return (0, _classnames.default)(_defineProperty({
            'carousel-root': true
        }, customClassName || '', !!customClassName));
    },
    CAROUSEL: function CAROUSEL(isSlider) {
        return (0, _classnames.default)({
            carousel: true,
            'carousel-slider': isSlider
        });
    },
    WRAPPER: function WRAPPER(isSlider, axis) {
        return (0, _classnames.default)({
            'thumbs-wrapper': !isSlider,
            'slider-wrapper': isSlider,
            'axis-horizontal': axis === 'horizontal',
            'axis-vertical': axis !== 'horizontal'
        });
    },
    SLIDER: function SLIDER(isSlider, isSwiping) {
        return (0, _classnames.default)({
            thumbs: !isSlider,
            slider: isSlider,
            animated: !isSwiping
        });
    },
    ITEM: function ITEM(isSlider, selected, previous) {
        return (0, _classnames.default)({
            thumb: !isSlider,
            slide: isSlider,
            selected: selected,
            previous: previous
        });
    },
    ARROW_PREV: function ARROW_PREV(disabled) {
        return (0, _classnames.default)({
            'control-arrow control-prev': true,
            'control-disabled': disabled
        });
    },
    ARROW_NEXT: function ARROW_NEXT(disabled) {
        return (0, _classnames.default)({
            'control-arrow control-next': true,
            'control-disabled': disabled
        });
    },
    DOT: function DOT(selected) {
        return (0, _classnames.default)({
            dot: true,
            selected: selected
        });
    }
};
exports.default = _default;

},{"99104ff522e78b01":"6P5cq"}],"evH87":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("7e3cfefc7c6a52b8"));
var _cssClasses = _interopRequireDefault(require("a081a5244f3d429f"));
var _dimensions = require("3d0246f53d8a58de");
var _CSSTranslate = _interopRequireDefault(require("bcc1f3e4f087dd65"));
var _reactEasySwipe = _interopRequireDefault(require("8ab658bbe4f746a0"));
var _window = _interopRequireDefault(require("70286c4d89adeedc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var isKeyboardEvent = function isKeyboardEvent(e) {
    return e.hasOwnProperty('key');
};
var Thumbs = /*#__PURE__*/ function(_Component) {
    _inherits(Thumbs, _Component);
    var _super = _createSuper(Thumbs);
    function Thumbs(_props) {
        var _this;
        _classCallCheck(this, Thumbs);
        _this = _super.call(this, _props);
        _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);
        _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function(node) {
            _this.itemsWrapperRef = node;
        });
        _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function(node) {
            _this.itemsListRef = node;
        });
        _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function(node, index) {
            if (!_this.thumbsRef) _this.thumbsRef = [];
            _this.thumbsRef[index] = node;
        });
        _defineProperty(_assertThisInitialized(_this), "updateSizes", function() {
            if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) return;
            var total = _react.Children.count(_this.props.children);
            var wrapperSize = _this.itemsWrapperRef.clientWidth;
            var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
            var visibleItems = Math.floor(wrapperSize / itemSize);
            var showArrows = visibleItems < total;
            var lastPosition = showArrows ? total - visibleItems : 0;
            _this.setState(function(_state, props) {
                return {
                    itemSize: itemSize,
                    visibleItems: visibleItems,
                    firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
                    lastPosition: lastPosition,
                    showArrows: showArrows
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleClickItem", function(index, item, e) {
            if (!isKeyboardEvent(e) || e.key === 'Enter') {
                var handler = _this.props.onSelectItem;
                if (typeof handler === 'function') handler(index, item);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function() {
            _this.setState({
                swiping: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function() {
            _this.setState({
                swiping: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function(delta) {
            var deltaX = delta.x;
            if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) return false;
            var leftBoundary = 0;
            var childrenLength = _react.Children.count(_this.props.children);
            var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
            var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
            var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries
            if (currentPosition === leftBoundary && deltaX > 0) deltaX = 0;
             // prevent user from swiping right out of boundaries
            if (currentPosition === lastLeftBoundary && deltaX < 0) deltaX = 0;
            var wrapperSize = _this.itemsWrapperRef.clientWidth;
            var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move
            if (_this.itemsListRef) [
                'WebkitTransform',
                'MozTransform',
                'MsTransform',
                'OTransform',
                'transform',
                'msTransform'
            ].forEach(function(prop) {
                _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
            });
            return true;
        });
        _defineProperty(_assertThisInitialized(_this), "slideRight", function(positions) {
            _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
        });
        _defineProperty(_assertThisInitialized(_this), "slideLeft", function(positions) {
            _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
        });
        _defineProperty(_assertThisInitialized(_this), "moveTo", function(position) {
            // position can't be lower than 0
            position = position < 0 ? 0 : position; // position can't be higher than last postion
            position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;
            _this.setState({
                firstItem: position
            });
        });
        _this.state = {
            selectedItem: _props.selectedItem,
            swiping: false,
            showArrows: false,
            firstItem: 0,
            visibleItems: 0,
            lastPosition: 0
        };
        return _this;
    }
    _createClass(Thumbs, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setupThumbs();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.selectedItem !== this.state.selectedItem) this.setState({
                    selectedItem: this.props.selectedItem,
                    firstItem: this.getFirstItem(this.props.selectedItem)
                });
                if (this.props.children === prevProps.children) return;
                 // This will capture any size changes for arrow adjustments etc.
                // usually in the same render cycle so we don't see any flickers
                this.updateSizes();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyThumbs();
            }
        },
        {
            key: "setupThumbs",
            value: function setupThumbs() {
                // as the widths are calculated, we need to resize
                // the carousel when the window is resized
                (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller
                (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
                // the container size to adjust the responsive behaviour
                this.updateSizes();
            }
        },
        {
            key: "destroyThumbs",
            value: function destroyThumbs() {
                // removing listeners
                (0, _window.default)().removeEventListener('resize', this.updateSizes);
                (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
            }
        },
        {
            key: "getFirstItem",
            value: function getFirstItem(selectedItem) {
                var firstItem = selectedItem;
                if (selectedItem >= this.state.lastPosition) firstItem = this.state.lastPosition;
                if (selectedItem < this.state.firstItem + this.state.visibleItems) firstItem = this.state.firstItem;
                if (selectedItem < this.state.firstItem) firstItem = selectedItem;
                return firstItem;
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this2 = this;
                return this.props.children.map(function(img, index) {
                    var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);
                    var thumbProps = {
                        key: index,
                        ref: function ref(e) {
                            return _this2.setThumbsRef(e, index);
                        },
                        className: itemClass,
                        onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
                        onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
                        'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
                        style: {
                            width: _this2.props.thumbWidth
                        }
                    };
                    return /*#__PURE__*/ _react.default.createElement("li", _extends({}, thumbProps, {
                        role: "button",
                        tabIndex: 0
                    }), img);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                if (!this.props.children) return null;
                var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?
                var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow
                var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles
                var itemListStyles = {};
                var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
                var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
                var transitionTime = this.props.transitionTime + 'ms';
                itemListStyles = {
                    WebkitTransform: transformProp,
                    MozTransform: transformProp,
                    MsTransform: transformProp,
                    OTransform: transformProp,
                    transform: transformProp,
                    msTransform: transformProp,
                    WebkitTransitionDuration: transitionTime,
                    MozTransitionDuration: transitionTime,
                    MsTransitionDuration: transitionTime,
                    OTransitionDuration: transitionTime,
                    transitionDuration: transitionTime,
                    msTransitionDuration: transitionTime
                };
                return /*#__PURE__*/ _react.default.createElement("div", {
                    className: _cssClasses.default.CAROUSEL(false)
                }, /*#__PURE__*/ _react.default.createElement("div", {
                    className: _cssClasses.default.WRAPPER(false),
                    ref: this.setItemsWrapperRef
                }, /*#__PURE__*/ _react.default.createElement("button", {
                    type: "button",
                    className: _cssClasses.default.ARROW_PREV(!hasPrev),
                    onClick: function onClick() {
                        return _this3.slideRight();
                    },
                    "aria-label": this.props.labels.leftArrow
                }), isSwipeable ? /*#__PURE__*/ _react.default.createElement(_reactEasySwipe.default, {
                    tagName: "ul",
                    className: _cssClasses.default.SLIDER(false, this.state.swiping),
                    onSwipeLeft: this.slideLeft,
                    onSwipeRight: this.slideRight,
                    onSwipeMove: this.onSwipeMove,
                    onSwipeStart: this.onSwipeStart,
                    onSwipeEnd: this.onSwipeEnd,
                    style: itemListStyles,
                    innerRef: this.setItemsListRef,
                    allowMouseEvents: this.props.emulateTouch
                }, this.renderItems()) : /*#__PURE__*/ _react.default.createElement("ul", {
                    className: _cssClasses.default.SLIDER(false, this.state.swiping),
                    ref: function ref(node) {
                        return _this3.setItemsListRef(node);
                    },
                    style: itemListStyles
                }, this.renderItems()), /*#__PURE__*/ _react.default.createElement("button", {
                    type: "button",
                    className: _cssClasses.default.ARROW_NEXT(!hasNext),
                    onClick: function onClick() {
                        return _this3.slideLeft();
                    },
                    "aria-label": this.props.labels.rightArrow
                })));
            }
        }
    ]);
    return Thumbs;
}(_react.Component);
exports.default = Thumbs;
_defineProperty(Thumbs, "displayName", 'Thumbs');
_defineProperty(Thumbs, "defaultProps", {
    axis: 'horizontal',
    labels: {
        leftArrow: 'previous slide / item',
        rightArrow: 'next slide / item',
        item: 'slide item'
    },
    selectedItem: 0,
    thumbWidth: 80,
    transitionTime: 350
});

},{"7e3cfefc7c6a52b8":"gVheC","a081a5244f3d429f":"962NS","3d0246f53d8a58de":"lhoCr","bcc1f3e4f087dd65":"krUAH","8ab658bbe4f746a0":"9fDov","70286c4d89adeedc":"1tUg1"}],"lhoCr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outerWidth = void 0;
var outerWidth = function outerWidth(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
};
exports.outerWidth = outerWidth;

},{}],"krUAH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = function _default(position, metric, axis) {
    var positionPercent = position === 0 ? position : position + metric;
    var positionCss = axis === 'horizontal' ? [
        positionPercent,
        0,
        0
    ] : [
        0,
        positionPercent,
        0
    ];
    var transitionProp = 'translate3d';
    var translatedPosition = '(' + positionCss.join(',') + ')';
    return transitionProp + translatedPosition;
};
exports.default = _default;

},{}],"1tUg1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = function _default() {
    return window;
};
exports.default = _default;

},{}],"l5KG8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = function _default() {
    return document;
};
exports.default = _default;

},{}],"sivJF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setPosition = exports.getPosition = exports.isKeyboardEvent = exports.defaultStatusFormatter = exports.noop = void 0;
var _react = require("109f003d9499b423");
var _CSSTranslate = _interopRequireDefault(require("c4fa6f5ef2ee411f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var noop = function noop() {};
exports.noop = noop;
var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
    return "".concat(current, " of ").concat(total);
};
exports.defaultStatusFormatter = defaultStatusFormatter;
var isKeyboardEvent = function isKeyboardEvent(e) {
    return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */ exports.isKeyboardEvent = isKeyboardEvent;
var getPosition = function getPosition(index, props) {
    if (props.infiniteLoop) // index has to be added by 1 because of the first cloned slide
    ++index;
    if (index === 0) return 0;
    var childrenLength = _react.Children.count(props.children);
    if (props.centerMode && props.axis === 'horizontal') {
        var currentPosition = -index * props.centerSlidePercentage;
        var lastPosition = childrenLength - 1;
        if (index && (index !== lastPosition || props.infiniteLoop)) currentPosition += (100 - props.centerSlidePercentage) / 2;
        else if (index === lastPosition) currentPosition += 100 - props.centerSlidePercentage;
        return currentPosition;
    }
    return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */ exports.getPosition = getPosition;
var setPosition = function setPosition(position, axis) {
    var style = {};
    [
        'WebkitTransform',
        'MozTransform',
        'MsTransform',
        'OTransform',
        'transform',
        'msTransform'
    ].forEach(function(prop) {
        // @ts-ignore
        style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
    });
    return style;
};
exports.setPosition = setPosition;

},{"109f003d9499b423":"gVheC","c4fa6f5ef2ee411f":"krUAH"}],"41IUs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fadeAnimationHandler = exports.slideStopSwipingHandler = exports.slideSwipeAnimationHandler = exports.slideAnimationHandler = void 0;
var _react = require("304221a9115d231d");
var _CSSTranslate = _interopRequireDefault(require("90ee154d1d153634"));
var _utils = require("ba9602e6f910f7f4");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */ var slideAnimationHandler = function slideAnimationHandler(props, state) {
    var returnStyles = {};
    var selectedItem = state.selectedItem;
    var previousItem = selectedItem;
    var lastPosition = _react.Children.count(props.children) - 1;
    var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone
    if (needClonedSlide) {
        if (previousItem < 0) {
            if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
            else returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
        } else if (previousItem > lastPosition) returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
        return returnStyles;
    }
    var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform
    var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
    var transitionTime = props.transitionTime + 'ms';
    returnStyles.itemListStyle = {
        WebkitTransform: transformProp,
        msTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp
    };
    if (!state.swiping) returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
    });
    return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */ exports.slideAnimationHandler = slideAnimationHandler;
var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
    var returnStyles = {};
    var isHorizontal = props.axis === 'horizontal';
    var childrenLength = _react.Children.count(props.children);
    var initialBoundry = 0;
    var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
    var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
    var axisDelta = isHorizontal ? delta.x : delta.y;
    var handledDelta = axisDelta; // prevent user from swiping left out of boundaries
    if (currentPosition === initialBoundry && axisDelta > 0) handledDelta = 0;
     // prevent user from swiping right out of boundaries
    if (currentPosition === finalBoundry && axisDelta < 0) handledDelta = 0;
    var position = currentPosition + 100 / (state.itemSize / handledDelta);
    var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;
    if (props.infiniteLoop && hasMoved) {
        // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
        // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
        if (state.selectedItem === 0 && position > -100) position -= childrenLength * 100;
        else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) position += childrenLength * 100;
    }
    if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
        if (!state.swipeMovementStarted) setState({
            swipeMovementStarted: true
        });
        returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
    } //allows scroll if the swipe was within the tolerance
    if (hasMoved && !state.cancelClick) setState({
        cancelClick: true
    });
    return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */ exports.slideSwipeAnimationHandler = slideSwipeAnimationHandler;
var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
    var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
    var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
    return {
        itemListStyle: itemListStyle
    };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */ exports.slideStopSwipingHandler = slideStopSwipingHandler;
var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
    var transitionTime = props.transitionTime + 'ms';
    var transitionTimingFunction = 'ease-in-out';
    var slideStyle = {
        position: 'absolute',
        display: 'block',
        zIndex: -2,
        minHeight: '100%',
        opacity: 0,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        transitionTimingFunction: transitionTimingFunction,
        msTransitionTimingFunction: transitionTimingFunction,
        MozTransitionTimingFunction: transitionTimingFunction,
        WebkitTransitionTimingFunction: transitionTimingFunction,
        OTransitionTimingFunction: transitionTimingFunction
    };
    if (!state.swiping) slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
    });
    return {
        slideStyle: slideStyle,
        selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
            opacity: 1,
            position: 'relative'
        }),
        prevStyle: _objectSpread({}, slideStyle)
    };
};
exports.fadeAnimationHandler = fadeAnimationHandler;

},{"304221a9115d231d":"gVheC","90ee154d1d153634":"krUAH","ba9602e6f910f7f4":"sivJF"}],"8QK98":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"8NPYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackupsDashboardCard", function() {
    return BackupsDashboardCard;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _reactstrap = require("reactstrap");
var _appState = require("../../AppState");
var _connectriaBackupService = require("../../services/ConnectriaBackupService");
var _connectriaBackupServiceDefault = parcelHelpers.interopDefault(_connectriaBackupService);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactDeviceDetect = require("react-device-detect");
var _victory = require("victory");
var colors = [
    '#006494',
    '#f8ca24',
    '#1bc5bd',
    '#24aece',
    '#d24727' //Unsuccessful
];
//CustomLabel.defaultEvents = VictoryTooltip.defaultEvents;
var BackupsDashboardCard = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), jobs = _useState[0], setJobs = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({}), 2), groupStats = _useState1[0], setGroupStats = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(stateApp.commserveTimeRange || "Last 7 Days"), 2), timeRange = _useState2[0], setTimeRange = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), dropdownOpen = _useState3[0], setDropdownOpen = _useState3[1];
    var history = (0, _reactRouterDom.useHistory)();
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState5[0], setIsError = _useState5[1];
    var legendLabels = [
        {
            name: "Completed"
        },
        {
            name: "Completed With Errors"
        },
        {
            name: "In Progess"
        },
        {
            name: "No Backups"
        },
        {
            name: "Unsuccessful"
        }
    ];
    var findNullJobCounts = function(counts) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(counts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                if (value != null) // Not all values are null
                return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // All values were null
        return true;
    };
    var createNewTicket = function(e) {
        if (e != null) e.preventDefault();
        history.push({
            pathname: "/app/create-ticket",
            state: {
                closeOnSuccess: true,
                subject: 'TRiA did not identify Backup services associated with my account and this is an error.',
                description: 'TRiA did not identify Backup services associated with my account and this is an error.',
                attachmentElementId: ''
            }
        });
    };
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var clientsRes, clients, clientGroupId, groupStatsRes, groupStats, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaBackupServiceDefault.default).getCommServeClientGroup({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        clientsRes = _state.sent();
                        clients = clientsRes['data'];
                        if (clients.length == 0) {
                            setIsError(true);
                            return [
                                2
                            ];
                        }
                        clientGroupId = clients[0].GroupId;
                        return [
                            4,
                            (0, _connectriaBackupServiceDefault.default).getCommServeClientGroupStats(clientGroupId, {
                                cancelToken: source.token
                            })
                        ];
                    case 2:
                        groupStatsRes = _state.sent();
                        if (groupStatsRes.data.message || findNullJobCounts(groupStatsRes.data[0])) {
                            setIsError(true);
                            return [
                                2
                            ];
                        }
                        groupStats = groupStatsRes.data[0];
                        if (!isMounted()) return [
                            2
                        ];
                        setGroupStats(groupStats);
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) console.log(error);
                        else {
                            console.log(error);
                            setIsError(true);
                            setIsLoading(false);
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    var toggleTimeRange = function(newRange) {
        setTimeRange(newRange);
        stateAppActions.setCommserveTimeRange(newRange);
    };
    (0, _react.useEffect)(function() {
        var numDays;
        if (timeRange == "Last 24 Hours") numDays = "1";
        else if (timeRange == "Last 7 Days") numDays = "7";
        else if (timeRange == "Last 30 Days") numDays = "30";
        var statusCounts = {
            "Completed": groupStats["completed_" + numDays],
            "In Progress": groupStats["inProgress_" + numDays],
            "Completed With Errors": groupStats["completedWithErrors_" + numDays],
            "No Backups": groupStats["noBackups_" + numDays],
            "Unsuccessful": groupStats["unsuccessful_" + numDays]
        };
        var data = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Get the data in the format our chart will recognize (specified by the chart's 'x' and 'y' props)
            for(var _iterator = Object.entries(statusCounts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                data.push({
                    status: key,
                    count: value
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Sort the data alphabetically by status
        data.sort(function(a, b) {
            return a.status > b.status ? 1 : -1;
        });
        setJobs(data);
    }, [
        timeRange,
        groupStats
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "text-left",
                        children: "Backups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "row",
                                children: !isError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Dropdown), {
                                    isOpen: dropdownOpen,
                                    toggle: function() {
                                        return setDropdownOpen(!dropdownOpen);
                                    },
                                    style: {
                                        position: "relative",
                                        right: "0px",
                                        top: "0px",
                                        paddingLeft: "7px"
                                    },
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownToggle), {
                                            tag: "span",
                                            "data-toggle": "dropdown",
                                            "aria-expanded": dropdownOpen,
                                            children: [
                                                timeRange,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-caret-" + (dropdownOpen ? 'up' : 'down'),
                                                    style: {
                                                        paddingLeft: "3px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                    onClick: function() {
                                                        toggleTimeRange("Last 24 Hours");
                                                    },
                                                    children: "Last 24 Hours"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                    onClick: function() {
                                                        toggleTimeRange("Last 7 Days");
                                                    },
                                                    children: "Last 7 Days"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                    onClick: function() {
                                                        toggleTimeRange("Last 30 Days");
                                                    },
                                                    children: "Last 30 Days"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-spinner m-3 mt-4 fa-spin",
                                style: {
                                    fontSize: "30px"
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: isError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "pt-3 pb-3",
                                            children: "TRiA did not identify Backup services associated with your account. Please contact us if this is an error."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                            className: "btn-report",
                                            size: "md",
                                            onClick: createNewTicket,
                                            children: "Report an Error"
                                        })
                                    ]
                                }) : jobs.length == 0 && !isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center mt-4 text-bold",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-exclamation-triangle"
                                        }),
                                        " No cloud alarms found. Try adjusting your filter."
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: (0, _reactDeviceDetect.isMobile) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(VDoughnutChart, {
                                                data: jobs
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(VChartLegend, {
                                                legendLabels: legendLabels,
                                                itemsPerRow: 3,
                                                height: 50
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col-8 p-0 pt-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VDoughnutChart, {
                                                    data: jobs
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "col-4 p-0",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VChartLegend, {
                                                    legendLabels: legendLabels,
                                                    orientation: "vertical",
                                                    width: 175,
                                                    height: 50,
                                                    y: -50
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "btn btn-light align-self-end btn-sm mt-3",
                onClick: function() {
                    history.push("/app/backup");
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            display: "inline",
                            verticalAlign: "middle"
                        },
                        className: "fas fa-chart-line"
                    }),
                    " ",
                    "View Detail"
                ]
            })
        ]
    });
};
var VChartLegend = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _victory.VictoryLegend), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        style: {
            border: {
                stroke: "none"
            }
        },
        colorScale: colors,
        data: props.legendLabels
    }));
};
var VDoughnutChart = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(props.data[0].status || ""), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(props.data[0].count || ""), 2), count = _useState1[0], setCount = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(0), 2), index = _useState2[0], setIndex = _useState2[1];
    (0, _react.useEffect)(function() {
        setState(props.data[index].status);
        setCount(props.data[index].count);
    }, [
        props.data
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _victory.VictoryChart), {
        height: 400,
        width: 400,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _victory.VictoryPie), {
                data: props.data,
                x: "status",
                y: "count",
                colorScale: colors,
                labels: function() {
                    return null;
                },
                radius: function(param) {
                    var datum = param.datum;
                    return datum.status == "Completed" ? 175 : 150;
                },
                innerRadius: 125,
                height: 400,
                width: 400,
                events: [
                    {
                        target: [
                            "data"
                        ],
                        eventHandlers: {
                            onClick: function(_, selectedSlice) {
                                return {
                                    target: [
                                        "data"
                                    ],
                                    eventKey: "all",
                                    mutation: function(nextSlice) {
                                        var radius;
                                        if (selectedSlice.index == index) {
                                            setIndex(-1);
                                            setState("");
                                            setCount("");
                                            radius = 150;
                                        } else {
                                            setIndex(selectedSlice.index);
                                            setState(selectedSlice.datum.status);
                                            setCount(selectedSlice.datum.count);
                                            if (index == nextSlice.index) radius = 150;
                                            else if ((typeof nextSlice.radius === "function" || nextSlice.radius == 150) && nextSlice.index == selectedSlice.index) radius = 175;
                                            else radius = 150;
                                        }
                                        return {
                                            radius: radius
                                        };
                                    }
                                };
                            }
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _victory.VictoryLabel), {
                textAnchor: "middle",
                style: {
                    fontSize: 40
                },
                x: 200,
                y: 180,
                text: count
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _victory.VictoryLabel), {
                textAnchor: "middle",
                style: {
                    fontSize: 18,
                    color: "gray"
                },
                x: 200,
                y: 220,
                text: state.toUpperCase()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _victory.VictoryAxis), {
                style: {
                    axis: {
                        stroke: "transparent"
                    },
                    ticks: {
                        stroke: "transparent"
                    },
                    tickLabels: {
                        fill: "transparent"
                    }
                }
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","axios":"ebRwi","../../utility/use-async-effect":"fShZN","reactstrap":"774RE","../../AppState":"8UGXH","../../services/ConnectriaBackupService":"l48ci","moment":"3xZWN","react-device-detect":"h7vq0","victory":"jVPWl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l48ci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _connectriaTicketsService = require("./ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var backup_api = 'https://brunb7jtj7.execute-api.us-east-1.amazonaws.com/prod';
function defaultRequest() {
    return _defaultRequest.apply(this, arguments);
}
function _defaultRequest() {
    _defaultRequest = (0, _asyncToGenerator._)(function() {
        var idToken, req;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    req = (0, _axiosDefault.default).create({
                        baseURL: backup_api,
                        headers: {
                            Authorization: idToken
                        }
                    });
                    //req.defaults.headers['Authorization'] = await Cognito.getIdToken();
                    return [
                        2,
                        req
                    ];
            }
        });
    });
    return _defaultRequest.apply(this, arguments);
}
var ConnectriaBackupService = {
    getJobsApiCallBody: function getJobsApiCallBody() {
        var body = {
            pagingConfig: {
                sortDirection: 1,
                offset: 0,
                sortField: "jobStartTime",
                limit: 100
            },
            jobFilter: {
                endTimeRange: {
                    fromTime: (0, _momentDefault.default)().unix() - 604800,
                    toTime: (0, _momentDefault.default)().unix()
                },
                showAgedJobs: false,
                entity: {
                    clientId: 0
                }
            }
        };
        return JSON.parse(JSON.stringify(body));
    },
    getCommServeJobs: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(body) {
            var params, req, orgId, res;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                        res = req.post("commserve/jobs", body, params);
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(body) {
            return _ref.apply(this, arguments);
        };
    }(),
    getCommServeJobDetails: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(jobId) {
            var params, req, orgId, res;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                        res = req.get("commserve/jobDetails/" + jobId, params);
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(jobId) {
            return _ref.apply(this, arguments);
        };
    }(),
    getCommServeClient: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(id) {
            var params, req, orgId, res;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                        res = req.get("commserve/client/" + id, params);
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getCommServeClientGroup: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var params, req, orgId, shortname, res;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        defaultRequest()
                    ];
                case 1:
                    req = _state.sent();
                    orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                    return [
                        4,
                        (0, _connectriaTicketsServiceDefault.default).getCustomerShortname()
                    ];
                case 2:
                    shortname = _state.sent();
                    res = req.get("commserve/clientgroup?name=".concat(shortname.shortName, "&orgId=").concat(orgId), params);
                    return [
                        2,
                        res
                    ];
            }
        });
    }),
    getCommServeClientGroupStats: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(clientGroupId) {
            var params, req, orgId, res;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                        res = req.get("commserve/clientGroupStats?cgid=".concat(clientGroupId), params);
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(clientGroupId) {
            return _ref.apply(this, arguments);
        };
    }(),
    getCommServeSubclientDetails: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(subclientId) {
            var params, req, orgId, res;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            defaultRequest()
                        ];
                    case 1:
                        req = _state.sent();
                        orgId = (0, _cookieServiceDefault.default).getCookie("OrganizationId");
                        console.log("commserve/subClient/" + subclientId);
                        res = req.get("commserve/subClient/" + subclientId, params);
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function(subclientId) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = ConnectriaBackupService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","moment":"3xZWN","../services/CookieService":"iKLPT","../utility/CognitoAuth":"cngmx","./ConnectriaTicketsService":"l5X0I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jVPWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Background", function() {
    return 0, _victoryCore.Background;
});
parcelHelpers.export(exports, "Border", function() {
    return 0, _victoryCore.Border;
});
parcelHelpers.export(exports, "Box", function() {
    return 0, _victoryCore.Box;
});
parcelHelpers.export(exports, "ClipPath", function() {
    return 0, _victoryCore.ClipPath;
});
parcelHelpers.export(exports, "LineSegment", function() {
    return 0, _victoryCore.LineSegment;
});
parcelHelpers.export(exports, "Whisker", function() {
    return 0, _victoryCore.Whisker;
});
parcelHelpers.export(exports, "Circle", function() {
    return 0, _victoryCore.Circle;
});
parcelHelpers.export(exports, "Rect", function() {
    return 0, _victoryCore.Rect;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _victoryCore.Line;
});
parcelHelpers.export(exports, "Path", function() {
    return 0, _victoryCore.Path;
});
parcelHelpers.export(exports, "TSpan", function() {
    return 0, _victoryCore.TSpan;
});
parcelHelpers.export(exports, "Text", function() {
    return 0, _victoryCore.Text;
});
parcelHelpers.export(exports, "Point", function() {
    return 0, _victoryCore.Point;
});
parcelHelpers.export(exports, "VictoryAnimation", function() {
    return 0, _victoryCore.VictoryAnimation;
});
parcelHelpers.export(exports, "VictoryContainer", function() {
    return 0, _victoryCore.VictoryContainer;
});
parcelHelpers.export(exports, "VictoryLabel", function() {
    return 0, _victoryCore.VictoryLabel;
});
parcelHelpers.export(exports, "VictoryTheme", function() {
    return 0, _victoryCore.VictoryTheme;
});
parcelHelpers.export(exports, "VictoryTransition", function() {
    return 0, _victoryCore.VictoryTransition;
});
parcelHelpers.export(exports, "VictoryPortal", function() {
    return 0, _victoryCore.VictoryPortal;
});
parcelHelpers.export(exports, "Portal", function() {
    return 0, _victoryCore.Portal;
});
parcelHelpers.export(exports, "VictoryClipContainer", function() {
    return 0, _victoryCore.VictoryClipContainer;
});
parcelHelpers.export(exports, "addEvents", function() {
    return 0, _victoryCore.addEvents;
});
parcelHelpers.export(exports, "Collection", function() {
    return 0, _victoryCore.Collection;
});
parcelHelpers.export(exports, "Data", function() {
    return 0, _victoryCore.Data;
});
parcelHelpers.export(exports, "DefaultTransitions", function() {
    return 0, _victoryCore.DefaultTransitions;
});
parcelHelpers.export(exports, "Domain", function() {
    return 0, _victoryCore.Domain;
});
parcelHelpers.export(exports, "Events", function() {
    return 0, _victoryCore.Events;
});
parcelHelpers.export(exports, "Helpers", function() {
    return 0, _victoryCore.Helpers;
});
parcelHelpers.export(exports, "Log", function() {
    return 0, _victoryCore.Log;
});
parcelHelpers.export(exports, "PropTypes", function() {
    return 0, _victoryCore.PropTypes;
});
parcelHelpers.export(exports, "Scale", function() {
    return 0, _victoryCore.Scale;
});
parcelHelpers.export(exports, "Style", function() {
    return 0, _victoryCore.Style;
});
parcelHelpers.export(exports, "TextSize", function() {
    return 0, _victoryCore.TextSize;
});
parcelHelpers.export(exports, "Transitions", function() {
    return 0, _victoryCore.Transitions;
});
parcelHelpers.export(exports, "Selection", function() {
    return 0, _victoryCore.Selection;
});
parcelHelpers.export(exports, "LabelHelpers", function() {
    return 0, _victoryCore.LabelHelpers;
});
parcelHelpers.export(exports, "Axis", function() {
    return 0, _victoryCore.Axis;
});
parcelHelpers.export(exports, "Wrapper", function() {
    return 0, _victoryCore.Wrapper;
});
parcelHelpers.export(exports, "VictoryAccessibleGroup", function() {
    return 0, _victoryCore.VictoryAccessibleGroup;
});
parcelHelpers.export(exports, "VictoryChart", function() {
    return 0, _victoryChart.VictoryChart;
});
parcelHelpers.export(exports, "VictoryGroup", function() {
    return 0, _victoryGroup.VictoryGroup;
});
parcelHelpers.export(exports, "VictoryStack", function() {
    return 0, _victoryStack.VictoryStack;
});
parcelHelpers.export(exports, "VictoryPie", function() {
    return 0, _victoryPie.VictoryPie;
});
parcelHelpers.export(exports, "Slice", function() {
    return 0, _victoryPie.Slice;
});
parcelHelpers.export(exports, "VictoryArea", function() {
    return 0, _victoryArea.VictoryArea;
});
parcelHelpers.export(exports, "Area", function() {
    return 0, _victoryArea.Area;
});
parcelHelpers.export(exports, "VictoryBar", function() {
    return 0, _victoryBar.VictoryBar;
});
parcelHelpers.export(exports, "Bar", function() {
    return 0, _victoryBar.Bar;
});
parcelHelpers.export(exports, "VictoryCandlestick", function() {
    return 0, _victoryCandlestick.VictoryCandlestick;
});
parcelHelpers.export(exports, "Candle", function() {
    return 0, _victoryCandlestick.Candle;
});
parcelHelpers.export(exports, "VictoryErrorBar", function() {
    return 0, _victoryErrorbar.VictoryErrorBar;
});
parcelHelpers.export(exports, "ErrorBar", function() {
    return 0, _victoryErrorbar.ErrorBar;
});
parcelHelpers.export(exports, "VictoryHistogram", function() {
    return 0, _victoryHistogram.VictoryHistogram;
});
parcelHelpers.export(exports, "VictoryLine", function() {
    return 0, _victoryLine.VictoryLine;
});
parcelHelpers.export(exports, "Curve", function() {
    return 0, _victoryLine.Curve;
});
parcelHelpers.export(exports, "VictoryScatter", function() {
    return 0, _victoryScatter.VictoryScatter;
});
parcelHelpers.export(exports, "VictoryBoxPlot", function() {
    return 0, _victoryBoxPlot.VictoryBoxPlot;
});
parcelHelpers.export(exports, "VictoryVoronoi", function() {
    return 0, _victoryVoronoi.VictoryVoronoi;
});
parcelHelpers.export(exports, "Voronoi", function() {
    return 0, _victoryVoronoi.Voronoi;
});
parcelHelpers.export(exports, "VictoryBrushLine", function() {
    return 0, _victoryBrushLine.VictoryBrushLine;
});
parcelHelpers.export(exports, "VictoryBrushContainer", function() {
    return 0, _victoryBrushContainer.VictoryBrushContainer;
});
parcelHelpers.export(exports, "BrushHelpers", function() {
    return 0, _victoryBrushContainer.BrushHelpers;
});
parcelHelpers.export(exports, "brushContainerMixin", function() {
    return 0, _victoryBrushContainer.brushContainerMixin;
});
parcelHelpers.export(exports, "VictoryCursorContainer", function() {
    return 0, _victoryCursorContainer.VictoryCursorContainer;
});
parcelHelpers.export(exports, "CursorHelpers", function() {
    return 0, _victoryCursorContainer.CursorHelpers;
});
parcelHelpers.export(exports, "cursorContainerMixin", function() {
    return 0, _victoryCursorContainer.cursorContainerMixin;
});
parcelHelpers.export(exports, "VictorySelectionContainer", function() {
    return 0, _victorySelectionContainer.VictorySelectionContainer;
});
parcelHelpers.export(exports, "SelectionHelpers", function() {
    return 0, _victorySelectionContainer.SelectionHelpers;
});
parcelHelpers.export(exports, "selectionContainerMixin", function() {
    return 0, _victorySelectionContainer.selectionContainerMixin;
});
parcelHelpers.export(exports, "VictoryVoronoiContainer", function() {
    return 0, _victoryVoronoiContainer.VictoryVoronoiContainer;
});
parcelHelpers.export(exports, "VoronoiHelpers", function() {
    return 0, _victoryVoronoiContainer.VoronoiHelpers;
});
parcelHelpers.export(exports, "voronoiContainerMixin", function() {
    return 0, _victoryVoronoiContainer.voronoiContainerMixin;
});
parcelHelpers.export(exports, "VictoryZoomContainer", function() {
    return 0, _victoryZoomContainer.VictoryZoomContainer;
});
parcelHelpers.export(exports, "ZoomHelpers", function() {
    return 0, _victoryZoomContainer.ZoomHelpers;
});
parcelHelpers.export(exports, "zoomContainerMixin", function() {
    return 0, _victoryZoomContainer.zoomContainerMixin;
});
parcelHelpers.export(exports, "RawZoomHelpers", function() {
    return 0, _victoryZoomContainer.RawZoomHelpers;
});
parcelHelpers.export(exports, "combineContainerMixins", function() {
    return 0, _victoryCreateContainer.combineContainerMixins;
});
parcelHelpers.export(exports, "makeCreateContainerFunction", function() {
    return 0, _victoryCreateContainer.makeCreateContainerFunction;
});
parcelHelpers.export(exports, "createContainer", function() {
    return 0, _victoryCreateContainer.createContainer;
});
parcelHelpers.export(exports, "VictoryTooltip", function() {
    return 0, _victoryTooltip.VictoryTooltip;
});
parcelHelpers.export(exports, "Flyout", function() {
    return 0, _victoryTooltip.Flyout;
});
parcelHelpers.export(exports, "VictoryLegend", function() {
    return 0, _victoryLegend.VictoryLegend;
});
parcelHelpers.export(exports, "VictorySharedEvents", function() {
    return 0, _victorySharedEvents.VictorySharedEvents;
});
parcelHelpers.export(exports, "VictoryAxis", function() {
    return 0, _victoryAxis.VictoryAxis;
});
parcelHelpers.export(exports, "VictoryPolarAxis", function() {
    return 0, _victoryPolarAxis.VictoryPolarAxis;
});
var _victoryCore = require("victory-core");
var _victoryChart = require("victory-chart");
var _victoryGroup = require("victory-group");
var _victoryStack = require("victory-stack");
var _victoryPie = require("victory-pie");
var _victoryArea = require("victory-area");
var _victoryBar = require("victory-bar");
var _victoryCandlestick = require("victory-candlestick");
var _victoryErrorbar = require("victory-errorbar");
var _victoryHistogram = require("victory-histogram");
var _victoryLine = require("victory-line");
var _victoryScatter = require("victory-scatter");
var _victoryBoxPlot = require("victory-box-plot");
var _victoryVoronoi = require("victory-voronoi");
var _victoryBrushLine = require("victory-brush-line");
var _victoryBrushContainer = require("victory-brush-container");
var _victoryCursorContainer = require("victory-cursor-container");
var _victorySelectionContainer = require("victory-selection-container");
var _victoryVoronoiContainer = require("victory-voronoi-container");
var _victoryZoomContainer = require("victory-zoom-container");
var _victoryCreateContainer = require("victory-create-container");
var _victoryTooltip = require("victory-tooltip");
var _victoryLegend = require("victory-legend");
var _victorySharedEvents = require("victory-shared-events");
var _victoryAxis = require("victory-axis");
var _victoryPolarAxis = require("victory-polar-axis");

},{"victory-core":"2Y5GL","victory-chart":"fl6rx","victory-group":false,"victory-stack":false,"victory-pie":"iQMO3","victory-area":false,"victory-bar":false,"victory-candlestick":false,"victory-errorbar":false,"victory-histogram":false,"victory-line":false,"victory-scatter":false,"victory-box-plot":false,"victory-voronoi":false,"victory-brush-line":false,"victory-brush-container":false,"victory-cursor-container":false,"victory-selection-container":false,"victory-voronoi-container":false,"victory-zoom-container":false,"victory-create-container":false,"victory-tooltip":false,"victory-legend":"19GQ1","victory-shared-events":false,"victory-axis":"auE0z","victory-polar-axis":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Y5GL":[function(require,module,exports,__globalThis) {
// This rule doesn't play well with namespaced exports
/* eslint-disable import/export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryAccessibleGroup", function() {
    return 0, _victoryAccessibleGroupDefault.default;
});
parcelHelpers.export(exports, "VictoryAnimation", function() {
    return 0, _victoryAnimationDefault.default;
});
parcelHelpers.export(exports, "VictoryContainer", function() {
    return 0, _victoryContainerDefault.default;
});
parcelHelpers.export(exports, "VictoryLabel", function() {
    return 0, _victoryLabelDefault.default;
});
parcelHelpers.export(exports, "VictoryTransition", function() {
    return 0, _victoryTransitionDefault.default;
});
parcelHelpers.export(exports, "VictoryClipContainer", function() {
    return 0, _victoryClipContainerDefault.default;
});
parcelHelpers.export(exports, "VictoryTheme", function() {
    return 0, _victoryThemeDefault.default;
});
parcelHelpers.export(exports, "VictoryPortal", function() {
    return 0, _victoryPortalDefault.default;
});
parcelHelpers.export(exports, "Portal", function() {
    return 0, _portalDefault.default;
});
parcelHelpers.export(exports, "Arc", function() {
    return 0, _arcDefault.default;
});
parcelHelpers.export(exports, "Background", function() {
    return 0, _backgroundDefault.default;
});
parcelHelpers.export(exports, "Border", function() {
    return 0, _borderDefault.default;
});
parcelHelpers.export(exports, "Box", function() {
    return 0, _borderDefault.default;
});
parcelHelpers.export(exports, "Circle", function() {
    return 0, _circleDefault.default;
});
parcelHelpers.export(exports, "ClipPath", function() {
    return 0, _clipPathDefault.default;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _lineDefault.default;
});
parcelHelpers.export(exports, "LineSegment", function() {
    return 0, _lineSegmentDefault.default;
});
parcelHelpers.export(exports, "Path", function() {
    return 0, _pathDefault.default;
});
parcelHelpers.export(exports, "Point", function() {
    return 0, _pointDefault.default;
});
parcelHelpers.export(exports, "Rect", function() {
    return 0, _rectDefault.default;
});
parcelHelpers.export(exports, "Text", function() {
    return 0, _textDefault.default;
});
parcelHelpers.export(exports, "TSpan", function() {
    return 0, _tspanDefault.default;
});
parcelHelpers.export(exports, "Whisker", function() {
    return 0, _whiskerDefault.default;
});
parcelHelpers.export(exports, "addEvents", function() {
    return 0, _addEventsDefault.default;
});
parcelHelpers.export(exports, "Timer", function() {
    return 0, _timerDefault.default;
});
parcelHelpers.export(exports, "Wrapper", function() {
    return 0, _wrapperDefault.default;
});
parcelHelpers.export(exports, "TimerContext", function() {
    return 0, _timerContextDefault.default;
});
parcelHelpers.export(exports, "PortalContext", function() {
    return 0, _portalContextDefault.default;
});
parcelHelpers.export(exports, "Collection", function() {
    return _collection;
});
parcelHelpers.export(exports, "Data", function() {
    return _data;
});
parcelHelpers.export(exports, "DefaultTransitions", function() {
    return _defaultTransitions;
});
parcelHelpers.export(exports, "Domain", function() {
    return _domain;
});
parcelHelpers.export(exports, "Events", function() {
    return _events;
});
parcelHelpers.export(exports, "Helpers", function() {
    return _helpers;
});
parcelHelpers.export(exports, "Immutable", function() {
    return _immutable;
});
parcelHelpers.export(exports, "LabelHelpers", function() {
    return _labelHelpers;
});
parcelHelpers.export(exports, "Log", function() {
    return _log;
});
parcelHelpers.export(exports, "PropTypes", function() {
    return _propTypes;
});
parcelHelpers.export(exports, "Scale", function() {
    return _scale;
});
parcelHelpers.export(exports, "Selection", function() {
    return _selection;
});
parcelHelpers.export(exports, "Style", function() {
    return _style;
});
parcelHelpers.export(exports, "TextSize", function() {
    return _textsize;
});
parcelHelpers.export(exports, "Transitions", function() {
    return _transitions;
});
parcelHelpers.export(exports, "CommonProps", function() {
    return _commonProps;
});
parcelHelpers.export(exports, "Axis", function() {
    return _axis;
});
var _victoryAccessibleGroup = require("./victory-accessible-group/victory-accessible-group");
var _victoryAccessibleGroupDefault = parcelHelpers.interopDefault(_victoryAccessibleGroup);
var _victoryAnimation = require("./victory-animation/victory-animation");
var _victoryAnimationDefault = parcelHelpers.interopDefault(_victoryAnimation);
var _victoryContainer = require("./victory-container/victory-container");
var _victoryContainerDefault = parcelHelpers.interopDefault(_victoryContainer);
var _victoryLabel = require("./victory-label/victory-label");
var _victoryLabelDefault = parcelHelpers.interopDefault(_victoryLabel);
var _victoryTransition = require("./victory-transition/victory-transition");
var _victoryTransitionDefault = parcelHelpers.interopDefault(_victoryTransition);
var _victoryClipContainer = require("./victory-clip-container/victory-clip-container");
var _victoryClipContainerDefault = parcelHelpers.interopDefault(_victoryClipContainer);
var _victoryTheme = require("./victory-theme/victory-theme");
var _victoryThemeDefault = parcelHelpers.interopDefault(_victoryTheme);
var _victoryPortal = require("./victory-portal/victory-portal");
var _victoryPortalDefault = parcelHelpers.interopDefault(_victoryPortal);
var _portal = require("./victory-portal/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _arc = require("./victory-primitives/arc");
var _arcDefault = parcelHelpers.interopDefault(_arc);
var _background = require("./victory-primitives/background");
var _backgroundDefault = parcelHelpers.interopDefault(_background);
var _border = require("./victory-primitives/border");
var _borderDefault = parcelHelpers.interopDefault(_border);
var _circle = require("./victory-primitives/circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _clipPath = require("./victory-primitives/clip-path");
var _clipPathDefault = parcelHelpers.interopDefault(_clipPath);
var _line = require("./victory-primitives/line");
var _lineDefault = parcelHelpers.interopDefault(_line);
var _lineSegment = require("./victory-primitives/line-segment");
var _lineSegmentDefault = parcelHelpers.interopDefault(_lineSegment);
var _path = require("./victory-primitives/path");
var _pathDefault = parcelHelpers.interopDefault(_path);
var _point = require("./victory-primitives/point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _rect = require("./victory-primitives/rect");
var _rectDefault = parcelHelpers.interopDefault(_rect);
var _text = require("./victory-primitives/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _tspan = require("./victory-primitives/tspan");
var _tspanDefault = parcelHelpers.interopDefault(_tspan);
var _whisker = require("./victory-primitives/whisker");
var _whiskerDefault = parcelHelpers.interopDefault(_whisker);
var _addEvents = require("./victory-util/add-events");
var _addEventsDefault = parcelHelpers.interopDefault(_addEvents);
var _collection = require("./victory-util/collection");
var _data = require("./victory-util/data");
var _defaultTransitions = require("./victory-util/default-transitions");
var _domain = require("./victory-util/domain");
var _events = require("./victory-util/events");
var _helpers = require("./victory-util/helpers");
var _immutable = require("./victory-util/immutable");
var _labelHelpers = require("./victory-util/label-helpers");
var _log = require("./victory-util/log");
var _propTypes = require("./victory-util/prop-types");
var _scale = require("./victory-util/scale");
var _selection = require("./victory-util/selection");
var _style = require("./victory-util/style");
var _textsize = require("./victory-util/textsize");
var _timer = require("./victory-util/timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _transitions = require("./victory-util/transitions");
var _commonProps = require("./victory-util/common-props");
var _wrapper = require("./victory-util/wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _axis = require("./victory-util/axis");
var _timerContext = require("./victory-util/timer-context");
var _timerContextDefault = parcelHelpers.interopDefault(_timerContext);
var _portalContext = require("./victory-portal/portal-context");
var _portalContextDefault = parcelHelpers.interopDefault(_portalContext);

},{"./victory-accessible-group/victory-accessible-group":false,"./victory-animation/victory-animation":false,"./victory-container/victory-container":"lxNwa","./victory-label/victory-label":"3hHmd","./victory-transition/victory-transition":false,"./victory-clip-container/victory-clip-container":false,"./victory-theme/victory-theme":"l5j1f","./victory-portal/victory-portal":false,"./victory-portal/portal":false,"./victory-primitives/arc":"dEQ25","./victory-primitives/background":"7Yw7D","./victory-primitives/border":"JJcbF","./victory-primitives/circle":false,"./victory-primitives/clip-path":false,"./victory-primitives/line":false,"./victory-primitives/line-segment":"bAwh7","./victory-primitives/path":"j4JEi","./victory-primitives/point":"gBM4p","./victory-primitives/rect":false,"./victory-primitives/text":false,"./victory-primitives/tspan":false,"./victory-primitives/whisker":false,"./victory-util/add-events":"l4shl","./victory-util/collection":false,"./victory-util/data":"5rlHC","./victory-util/default-transitions":false,"./victory-util/domain":false,"./victory-util/events":"bDJ4N","./victory-util/helpers":"8ABme","./victory-util/immutable":false,"./victory-util/label-helpers":"6P27s","./victory-util/log":false,"./victory-util/prop-types":"88bb9","./victory-util/scale":"je6Bi","./victory-util/selection":false,"./victory-util/style":"aPnOz","./victory-util/textsize":"iUBgJ","./victory-util/timer":false,"./victory-util/transitions":false,"./victory-util/common-props":"fsKbU","./victory-util/wrapper":"aKPMP","./victory-util/axis":"8lzBT","./victory-util/timer-context":"hLkTS","./victory-portal/portal-context":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ehNoG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictoryAnimation;
});
var _typeOf = require("@swc/helpers/_/_type_of");
/*global setTimeout:false */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _d3Ease = require("d3-ease");
var _util = require("./util");
var _timerContext = require("../victory-util/timer-context");
var _timerContextDefault = parcelHelpers.interopDefault(_timerContext);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var VictoryAnimation = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryAnimation, _React$Component);
    function VictoryAnimation(props, context) {
        var _this;
        _classCallCheck(this, VictoryAnimation);
        _this = _possibleConstructorReturn(this, (VictoryAnimation.__proto__ || Object.getPrototypeOf(VictoryAnimation)).call(this, props, context));
        /* defaults */ _this.state = {
            data: Array.isArray(_this.props.data) ? _this.props.data[0] : _this.props.data,
            animationInfo: {
                progress: 0,
                animating: false
            }
        };
        _this.interpolator = null;
        _this.queue = Array.isArray(_this.props.data) ? _this.props.data.slice(1) : [];
        /* build easing function */ _this.ease = _d3Ease[_this.toNewName(_this.props.easing)];
        /*
      There is no autobinding of this in ES6 classes
      so we bind functionToBeRunEachFrame to current instance of victory animation class
    */ _this.functionToBeRunEachFrame = _this.functionToBeRunEachFrame.bind(_assertThisInitialized(_this));
        _this.timer = _this.context.animationTimer;
        return _this;
    }
    _createClass(VictoryAnimation, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Length check prevents us from triggering `onEnd` in `traverseQueue`.
                if (this.queue.length) this.traverseQueue();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var equalProps = (0, _reactFastCompareDefault.default)(this.props, prevProps);
                if (!equalProps) {
                    /* If the previous animation didn't finish, force it to complete before starting a new one */ if (this.interpolator && this.state.animationInfo && this.state.animationInfo.progress < 1) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        data: this.interpolator(1),
                        animationInfo: {
                            progress: 1,
                            animating: false,
                            terminating: true
                        }
                    });
                    else {
                        /* cancel existing loop if it exists */ this.timer.unsubscribe(this.loopID);
                        /* If an object was supplied */ if (!Array.isArray(this.props.data)) {
                            // Replace the tween queue. Could set `this.queue = [nextProps.data]`,
                            // but let's reuse the same array.
                            this.queue.length = 0;
                            this.queue.push(this.props.data);
                        /* If an array was supplied */ } else {
                            var _queue;
                            /* Extend the tween queue */ (_queue = this.queue).push.apply(_queue, _toConsumableArray(this.props.data));
                        }
                        /* Start traversing the tween queue */ this.traverseQueue();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.loopID) this.timer.unsubscribe(this.loopID);
                else this.timer.stop();
            }
        },
        {
            key: "toNewName",
            value: function toNewName(ease) {
                // d3-ease changed the naming scheme for ease from "linear" -> "easeLinear" etc.
                var capitalize = function capitalize(s) {
                    return s && s[0].toUpperCase() + s.slice(1);
                };
                return "ease".concat(capitalize(ease));
            }
        },
        {
            key: "traverseQueue",
            value: function traverseQueue() {
                var _this2 = this;
                if (this.queue.length) {
                    /* Get the next index */ var data = this.queue[0];
                    /* compare cached version to next props */ this.interpolator = (0, _util.victoryInterpolator)(this.state.data, data);
                    /* reset step to zero */ if (this.props.delay) setTimeout(function() {
                        _this2.loopID = _this2.timer.subscribe(_this2.functionToBeRunEachFrame, _this2.props.duration);
                    }, this.props.delay);
                    else this.loopID = this.timer.subscribe(this.functionToBeRunEachFrame, this.props.duration);
                } else if (this.props.onEnd) this.props.onEnd();
            }
        },
        {
            key: "functionToBeRunEachFrame",
            value: function functionToBeRunEachFrame(elapsed, duration) {
                /*
        step can generate imprecise values, sometimes greater than 1
        if this happens set the state to 1 and return, cancelling the timer
      */ duration = duration !== undefined ? duration : this.props.duration;
                var step = duration ? elapsed / duration : 1;
                if (step >= 1) {
                    this.setState({
                        data: this.interpolator(1),
                        animationInfo: {
                            progress: 1,
                            animating: false,
                            terminating: true
                        }
                    });
                    if (this.loopID) this.timer.unsubscribe(this.loopID);
                    this.queue.shift();
                    this.traverseQueue();
                    return;
                }
                /*
        if we're not at the end of the timer, set the state by passing
        current step value that's transformed by the ease function to the
        interpolator, which is cached for performance whenever props are received
      */ this.setState({
                    data: this.interpolator(this.ease(step)),
                    animationInfo: {
                        progress: step,
                        animating: step < 1
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.state.data, this.state.animationInfo);
            }
        }
    ]);
    return VictoryAnimation;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryAnimation, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryAnimation"
});
Object.defineProperty(VictoryAnimation, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        children: (0, _propTypesDefault.default).func,
        data: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).array
        ]),
        delay: (0, _propTypesDefault.default).number,
        duration: (0, _propTypesDefault.default).number,
        easing: (0, _propTypesDefault.default).oneOf([
            "back",
            "backIn",
            "backOut",
            "backInOut",
            "bounce",
            "bounceIn",
            "bounceOut",
            "bounceInOut",
            "circle",
            "circleIn",
            "circleOut",
            "circleInOut",
            "linear",
            "linearIn",
            "linearOut",
            "linearInOut",
            "cubic",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "elastic",
            "elasticIn",
            "elasticOut",
            "elasticInOut",
            "exp",
            "expIn",
            "expOut",
            "expInOut",
            "poly",
            "polyIn",
            "polyOut",
            "polyInOut",
            "quad",
            "quadIn",
            "quadOut",
            "quadInOut",
            "sin",
            "sinIn",
            "sinOut",
            "sinInOut"
        ]),
        onEnd: (0, _propTypesDefault.default).func
    }
});
Object.defineProperty(VictoryAnimation, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        data: {},
        delay: 0,
        duration: 1000,
        easing: "quadInOut"
    }
});
Object.defineProperty(VictoryAnimation, "contextType", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _timerContextDefault.default)
});

},{"@swc/helpers/_/_type_of":"668P4","react":"gVheC","prop-types":"3KNJy","d3-ease":"cqlxX","./util":"5IYgG","../victory-util/timer-context":"hLkTS","react-fast-compare":"jGkHB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cqlxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", function() {
    return 0, _linearJs.linear;
});
parcelHelpers.export(exports, "easeQuad", function() {
    return 0, _quadJs.quadInOut;
});
parcelHelpers.export(exports, "easeQuadIn", function() {
    return 0, _quadJs.quadIn;
});
parcelHelpers.export(exports, "easeQuadOut", function() {
    return 0, _quadJs.quadOut;
});
parcelHelpers.export(exports, "easeQuadInOut", function() {
    return 0, _quadJs.quadInOut;
});
parcelHelpers.export(exports, "easeCubic", function() {
    return 0, _cubicJs.cubicInOut;
});
parcelHelpers.export(exports, "easeCubicIn", function() {
    return 0, _cubicJs.cubicIn;
});
parcelHelpers.export(exports, "easeCubicOut", function() {
    return 0, _cubicJs.cubicOut;
});
parcelHelpers.export(exports, "easeCubicInOut", function() {
    return 0, _cubicJs.cubicInOut;
});
parcelHelpers.export(exports, "easePoly", function() {
    return 0, _polyJs.polyInOut;
});
parcelHelpers.export(exports, "easePolyIn", function() {
    return 0, _polyJs.polyIn;
});
parcelHelpers.export(exports, "easePolyOut", function() {
    return 0, _polyJs.polyOut;
});
parcelHelpers.export(exports, "easePolyInOut", function() {
    return 0, _polyJs.polyInOut;
});
parcelHelpers.export(exports, "easeSin", function() {
    return 0, _sinJs.sinInOut;
});
parcelHelpers.export(exports, "easeSinIn", function() {
    return 0, _sinJs.sinIn;
});
parcelHelpers.export(exports, "easeSinOut", function() {
    return 0, _sinJs.sinOut;
});
parcelHelpers.export(exports, "easeSinInOut", function() {
    return 0, _sinJs.sinInOut;
});
parcelHelpers.export(exports, "easeExp", function() {
    return 0, _expJs.expInOut;
});
parcelHelpers.export(exports, "easeExpIn", function() {
    return 0, _expJs.expIn;
});
parcelHelpers.export(exports, "easeExpOut", function() {
    return 0, _expJs.expOut;
});
parcelHelpers.export(exports, "easeExpInOut", function() {
    return 0, _expJs.expInOut;
});
parcelHelpers.export(exports, "easeCircle", function() {
    return 0, _circleJs.circleInOut;
});
parcelHelpers.export(exports, "easeCircleIn", function() {
    return 0, _circleJs.circleIn;
});
parcelHelpers.export(exports, "easeCircleOut", function() {
    return 0, _circleJs.circleOut;
});
parcelHelpers.export(exports, "easeCircleInOut", function() {
    return 0, _circleJs.circleInOut;
});
parcelHelpers.export(exports, "easeBounce", function() {
    return 0, _bounceJs.bounceOut;
});
parcelHelpers.export(exports, "easeBounceIn", function() {
    return 0, _bounceJs.bounceIn;
});
parcelHelpers.export(exports, "easeBounceOut", function() {
    return 0, _bounceJs.bounceOut;
});
parcelHelpers.export(exports, "easeBounceInOut", function() {
    return 0, _bounceJs.bounceInOut;
});
parcelHelpers.export(exports, "easeBack", function() {
    return 0, _backJs.backInOut;
});
parcelHelpers.export(exports, "easeBackIn", function() {
    return 0, _backJs.backIn;
});
parcelHelpers.export(exports, "easeBackOut", function() {
    return 0, _backJs.backOut;
});
parcelHelpers.export(exports, "easeBackInOut", function() {
    return 0, _backJs.backInOut;
});
parcelHelpers.export(exports, "easeElastic", function() {
    return 0, _elasticJs.elasticOut;
});
parcelHelpers.export(exports, "easeElasticIn", function() {
    return 0, _elasticJs.elasticIn;
});
parcelHelpers.export(exports, "easeElasticOut", function() {
    return 0, _elasticJs.elasticOut;
});
parcelHelpers.export(exports, "easeElasticInOut", function() {
    return 0, _elasticJs.elasticInOut;
});
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":"2JVGB","./quad.js":"g9oPk","./cubic.js":"1EAB8","./poly.js":"2ohK0","./sin.js":"hiqBf","./exp.js":"8SrfZ","./circle.js":"924yU","./bounce.js":"eleF6","./back.js":"620Bb","./elastic.js":"G2mcc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2JVGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", function() {
    return linear;
});
function linear(t) {
    return +t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g9oPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadIn", function() {
    return quadIn;
});
parcelHelpers.export(exports, "quadOut", function() {
    return quadOut;
});
parcelHelpers.export(exports, "quadInOut", function() {
    return quadInOut;
});
function quadIn(t) {
    return t * t;
}
function quadOut(t) {
    return t * (2 - t);
}
function quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1EAB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", function() {
    return cubicIn;
});
parcelHelpers.export(exports, "cubicOut", function() {
    return cubicOut;
});
parcelHelpers.export(exports, "cubicInOut", function() {
    return cubicInOut;
});
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ohK0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyIn", function() {
    return polyIn;
});
parcelHelpers.export(exports, "polyOut", function() {
    return polyOut;
});
parcelHelpers.export(exports, "polyInOut", function() {
    return polyInOut;
});
var exponent = 3;
var polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}(exponent);
var polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}(exponent);
var polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}(exponent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hiqBf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinIn", function() {
    return sinIn;
});
parcelHelpers.export(exports, "sinOut", function() {
    return sinOut;
});
parcelHelpers.export(exports, "sinInOut", function() {
    return sinInOut;
});
var pi = Math.PI, halfPi = pi / 2;
function sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
    return Math.sin(t * halfPi);
}
function sinInOut(t) {
    return (1 - Math.cos(pi * t)) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8SrfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expIn", function() {
    return expIn;
});
parcelHelpers.export(exports, "expOut", function() {
    return expOut;
});
parcelHelpers.export(exports, "expInOut", function() {
    return expInOut;
});
var _mathJs = require("./math.js");
function expIn(t) {
    return (0, _mathJs.tpmt)(1 - +t);
}
function expOut(t) {
    return 1 - (0, _mathJs.tpmt)(t);
}
function expInOut(t) {
    return ((t *= 2) <= 1 ? (0, _mathJs.tpmt)(1 - t) : 2 - (0, _mathJs.tpmt)(t - 1)) / 2;
}

},{"./math.js":"a5InD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a5InD":[function(require,module,exports,__globalThis) {
// tpmt is two power minus ten times t scaled to [0,1]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tpmt", function() {
    return tpmt;
});
function tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"924yU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circleIn", function() {
    return circleIn;
});
parcelHelpers.export(exports, "circleOut", function() {
    return circleOut;
});
parcelHelpers.export(exports, "circleInOut", function() {
    return circleInOut;
});
function circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eleF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bounceIn", function() {
    return bounceIn;
});
parcelHelpers.export(exports, "bounceOut", function() {
    return bounceOut;
});
parcelHelpers.export(exports, "bounceInOut", function() {
    return bounceInOut;
});
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t) {
    return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
    return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"620Bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", function() {
    return backIn;
});
parcelHelpers.export(exports, "backOut", function() {
    return backOut;
});
parcelHelpers.export(exports, "backInOut", function() {
    return backInOut;
});
var overshoot = 1.70158;
var backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}(overshoot);
var backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}(overshoot);
var backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}(overshoot);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"G2mcc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elasticIn", function() {
    return elasticIn;
});
parcelHelpers.export(exports, "elasticOut", function() {
    return elasticOut;
});
parcelHelpers.export(exports, "elasticInOut", function() {
    return elasticInOut;
});
var _mathJs = require("./math.js");
var tau = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticIn(t) {
        return a * (0, _mathJs.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}(amplitude, period);
var elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticOut(t) {
        return 1 - a * (0, _mathJs.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}(amplitude, period);
var elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, _mathJs.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, _mathJs.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}(amplitude, period);

},{"./math.js":"a5InD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5IYgG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInterpolatable", function() {
    return isInterpolatable;
});
parcelHelpers.export(exports, "interpolateImmediate", function() {
    return interpolateImmediate;
});
parcelHelpers.export(exports, "interpolateFunction", function() {
    return interpolateFunction;
});
parcelHelpers.export(exports, "interpolateObject", function() {
    return interpolateObject;
});
parcelHelpers.export(exports, "interpolateString", function() {
    return interpolateString;
});
parcelHelpers.export(exports, "victoryInterpolator", function() {
    return victoryInterpolator;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _orderBy = require("lodash/orderBy");
var _orderByDefault = parcelHelpers.interopDefault(_orderBy);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _d3Interpolate = require("d3-interpolate");
var isInterpolatable = function isInterpolatable(obj) {
    // d3 turns null into 0 and undefined into NaN, which we don't want.
    if (obj !== null) switch(typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)){
        case "undefined":
            return false;
        case "number":
            // The standard `isNaN` is fine in this case since we already know the
            // type is number.
            return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;
        case "string":
            // d3 might not *actually* be able to interpolate the string, but it
            // won't cause any issues to let it try.
            return true;
        case "boolean":
            // d3 turns Booleans into integers, which we don't want. Sure, we could
            // interpolate from 0 -> 1, but we'd be sending a non-Boolean to
            // something expecting a Boolean.
            return false;
        case "object":
            // Don't try to interpolate class instances (except Date or Array).
            return obj instanceof Date || Array.isArray(obj) || (0, _isPlainObjectDefault.default)(obj);
        case "function":
            // Careful! There may be extra properties on function objects that the
            // component expects to access - for instance, it may be a `d3.scale()`
            // function, which has its own methods attached. We don't know if the
            // component is only going to call the function (in which case it's
            // safely interpolatable) or if it's going to access special properties
            // (in which case our function generated from `interpolateFunction` will
            // most likely cause an error. We could check for enumerable properties
            // on the function object here to see if it's a "plain" function, but
            // let's just require that components prevent such function props from
            // being animated in the first place.
            return true;
    }
    return false;
};
var interpolateImmediate = function interpolateImmediate(a, b) {
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return function(t) {
        return t < when ? a : b;
    };
};
var interpolateFunction = function interpolateFunction(a, b) {
    return function(t) {
        if (t >= 1) return b;
        return function() {
            /* eslint-disable no-invalid-this */ var aval = typeof a === "function" ? a.apply(this, arguments) : a;
            var bval = typeof b === "function" ? b.apply(this, arguments) : b;
            return (0, _d3Interpolate.interpolate)(aval, bval)(t);
        };
    };
};
var interpolateObject = function interpolateObject1(a, b) {
    var interpolateTypes = function interpolateTypes(x, y) {
        if (x === y || !isInterpolatable(x) || !isInterpolatable(y)) return interpolateImmediate(x, y);
        if (typeof x === "function" || typeof y === "function") return interpolateFunction(x, y);
        if ((typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "object" && (0, _isPlainObjectDefault.default)(x) || (typeof y === "undefined" ? "undefined" : (0, _typeOf._)(y)) === "object" && (0, _isPlainObjectDefault.default)(y)) return interpolateObject(x, y);
        return (0, _d3Interpolate.interpolate)(x, y);
    }; // When the value is an array, attempt to sort by "key" so that animating nodes may be identified
    // based on "key" instead of index
    var keyData = function keyData(val) {
        return Array.isArray(val) ? (0, _orderByDefault.default)(val, "key") : val;
    };
    var i = {};
    var c = {};
    var k;
    if (a === null || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== "object") a = {};
    if (b === null || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== "object") b = {};
    for(k in b)if (k in a) i[k] = interpolateTypes(keyData(a[k]), keyData(b[k]));
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
};
var interpolateString = function interpolateString(a, b) {
    var format = function format(val) {
        return typeof val === "string" ? val.replace(/,/g, "") : val;
    };
    return (0, _d3Interpolate.interpolate)(format(a), format(b));
};
var victoryInterpolator = function victoryInterpolator(a, b) {
    // If the values are strictly equal, or either value is not interpolatable,
    // just use either the start value `a` or end value `b` at every step, as
    // there is no reasonable in-between value.
    if (a === b || !isInterpolatable(a) || !isInterpolatable(b)) return interpolateImmediate(a, b);
    if (typeof a === "function" || typeof b === "function") return interpolateFunction(a, b);
    if ((0, _isPlainObjectDefault.default)(a) || (0, _isPlainObjectDefault.default)(b)) return interpolateObject(a, b);
    if (typeof a === "string" || typeof b === "string") return interpolateString(a, b);
    return (0, _d3Interpolate.interpolate)(a, b);
};

},{"@swc/helpers/_/_type_of":"668P4","lodash/orderBy":"kNMvc","lodash/isPlainObject":"2RXyg","d3-interpolate":"fifMh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNMvc":[function(require,module,exports,__globalThis) {
var baseOrderBy = require("9824fb2bf691dd6b"), isArray = require("68c07660ca0a6ddb");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    return baseOrderBy(collection, iteratees, orders);
}
module.exports = orderBy;

},{"9824fb2bf691dd6b":"92uga","68c07660ca0a6ddb":"jQGs4"}],"92uga":[function(require,module,exports,__globalThis) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"5ZiZU","56eb179604ce4d19":"3bgbL","41950d167c7e12b5":"exkHY","b09740a39499ec43":"eccnZ","35a9013ca73ef017":"aR6RG","b387a5b76e29e664":"8g9lw","2ab709818f44804c":"3HLhZ","5cb379329c706719":"6wIyV","8acdbb462385356c":"jQGs4"}],"eccnZ":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"eUqSn","2924e2db4bb5430d":"mL7I2"}],"aR6RG":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"3HLhZ":[function(require,module,exports,__globalThis) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"GV1mH"}],"GV1mH":[function(require,module,exports,__globalThis) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"5eB4J"}],"2RXyg":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"iuqvy","2ca5b85a120835de":"fiIZQ","963b65e043435612":"lm2eo"}],"fiIZQ":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"2fV7A"}],"fifMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", function() {
    return 0, _valueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateArray", function() {
    return 0, _arrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasis", function() {
    return 0, _basisJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasisClosed", function() {
    return 0, _basisClosedJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDate", function() {
    return 0, _dateJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDiscrete", function() {
    return 0, _discreteJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHue", function() {
    return 0, _hueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumber", function() {
    return 0, _numberJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumberArray", function() {
    return 0, _numberArrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateObject", function() {
    return 0, _objectJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRound", function() {
    return 0, _roundJsDefault.default;
});
parcelHelpers.export(exports, "interpolateString", function() {
    return 0, _stringJsDefault.default;
});
parcelHelpers.export(exports, "interpolateTransformCss", function() {
    return 0, _indexJs.interpolateTransformCss;
});
parcelHelpers.export(exports, "interpolateTransformSvg", function() {
    return 0, _indexJs.interpolateTransformSvg;
});
parcelHelpers.export(exports, "interpolateZoom", function() {
    return 0, _zoomJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgb", function() {
    return 0, _rgbJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgbBasis", function() {
    return 0, _rgbJs.rgbBasis;
});
parcelHelpers.export(exports, "interpolateRgbBasisClosed", function() {
    return 0, _rgbJs.rgbBasisClosed;
});
parcelHelpers.export(exports, "interpolateHsl", function() {
    return 0, _hslJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHslLong", function() {
    return 0, _hslJs.hslLong;
});
parcelHelpers.export(exports, "interpolateLab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHcl", function() {
    return 0, _hclJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHclLong", function() {
    return 0, _hclJs.hclLong;
});
parcelHelpers.export(exports, "interpolateCubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
parcelHelpers.export(exports, "interpolateCubehelixLong", function() {
    return 0, _cubehelixJs.cubehelixLong;
});
parcelHelpers.export(exports, "piecewise", function() {
    return 0, _piecewiseJsDefault.default;
});
parcelHelpers.export(exports, "quantize", function() {
    return 0, _quantizeJsDefault.default;
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"hIFde","./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"1gGMh","./numberArray.js":false,"./object.js":false,"./round.js":"fKQDq","./string.js":"4lm4K","./transform/index.js":"8szkg","./zoom.js":"ftjTu","./rgb.js":"djUAU","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":"f2cY7","./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hIFde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var t = typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b), c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    };
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"@swc/helpers/_/_type_of":"668P4","d3-color":"d2vOO","./rgb.js":"djUAU","./array.js":"2s7X1","./date.js":"j6RQb","./number.js":"1gGMh","./object.js":"fc9R1","./string.js":"4lm4K","./constant.js":"ljgoc","./numberArray.js":"3c1Lz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d2vOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", function() {
    return 0, _colorJsDefault.default;
});
parcelHelpers.export(exports, "rgb", function() {
    return 0, _colorJs.rgb;
});
parcelHelpers.export(exports, "hsl", function() {
    return 0, _colorJs.hsl;
});
parcelHelpers.export(exports, "lab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "hcl", function() {
    return 0, _labJs.hcl;
});
parcelHelpers.export(exports, "lch", function() {
    return 0, _labJs.lch;
});
parcelHelpers.export(exports, "gray", function() {
    return 0, _labJs.gray;
});
parcelHelpers.export(exports, "cubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"ftTsI","./lab.js":false,"./cubehelix.js":"7jKyO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ftTsI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", function() {
    return Color;
});
parcelHelpers.export(exports, "darker", function() {
    return darker;
});
parcelHelpers.export(exports, "brighter", function() {
    return brighter;
});
parcelHelpers.export(exports, "default", function() {
    return color;
});
parcelHelpers.export(exports, "rgbConvert", function() {
    return rgbConvert;
});
parcelHelpers.export(exports, "rgb", function() {
    return rgb;
});
parcelHelpers.export(exports, "Rgb", function() {
    return Rgb;
});
parcelHelpers.export(exports, "hslConvert", function() {
    return hslConvert;
});
parcelHelpers.export(exports, "hsl", function() {
    return hsl;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function copy(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function displayable() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function brighter1(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function darker1(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function rgb() {
        return this;
    },
    displayable: function displayable() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function brighter1(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker1(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function formatHsl() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"3muMa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3muMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    };
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7jKyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cubehelix;
});
parcelHelpers.export(exports, "Cubehelix", function() {
    return Cubehelix;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.rad2deg) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function brighter(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"3muMa","./color.js":"ftTsI","./math.js":"kEW1G","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kEW1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deg2rad", function() {
    return deg2rad;
});
parcelHelpers.export(exports, "rad2deg", function() {
    return rad2deg;
});
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"djUAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", function() {
    return rgbBasis;
});
parcelHelpers.export(exports, "rgbBasisClosed", function() {
    return rgbBasisClosed;
});
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"d2vOO","./basis.js":"hkx2t","./basisClosed.js":"dJ4tL","./color.js":"4rgzv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hkx2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", function() {
    return basis;
});
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dJ4tL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
var _basisJs = require("./basis.js");

},{"./basis.js":"hkx2t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rgzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", function() {
    return hue;
});
parcelHelpers.export(exports, "gamma", function() {
    return gamma;
});
parcelHelpers.export(exports, "default", function() {
    return nogamma;
});
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"ljgoc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ljgoc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2s7X1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    };
});
parcelHelpers.export(exports, "genericArray", function() {
    return genericArray;
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"hIFde","./numberArray.js":"3c1Lz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3c1Lz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    };
});
parcelHelpers.export(exports, "isNumberArray", function() {
    return isNumberArray;
});
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j6RQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1gGMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fc9R1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== "object") a = {};
        if (b === null || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    };
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"@swc/helpers/_/_type_of":"668P4","./value.js":"hIFde","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4lm4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    };
});
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"1gGMh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKQDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8szkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", function() {
    return interpolateTransformCss;
});
parcelHelpers.export(exports, "interpolateTransformSvg", function() {
    return interpolateTransformSvg;
});
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"1gGMh","./parse.js":"Vu2Cz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Vu2Cz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCss", function() {
    return parseCss;
});
parcelHelpers.export(exports, "parseSvg", function() {
    return parseSvg;
});
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var cssNode, cssRoot, cssView, svgNode;
function parseCss(value) {
    if (value === "none") return 0, _decomposeJs.identity;
    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
    cssNode.style.transform = value;
    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
    cssRoot.removeChild(cssNode);
    value = value.slice(7, -1).split(",");
    return (0, _decomposeJsDefault.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"gBRl0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gBRl0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", function() {
    return identity;
});
parcelHelpers.export(exports, "default", function() {
    return function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    };
});
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ftjTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
parcelHelpers.export(exports, "default", function() {
    return function(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function i(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function i(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000;
        return i;
    };
});
var rho = Math.SQRT2, rho2 = 2, rho4 = 4, epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f2cY7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", function() {
    return cubehelixLong;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"d2vOO","./color.js":"4rgzv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hLkTS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _timer = require("./timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
/**
 * The React context object consumers may use to access or override the global
 * timer.
 */ var TimerContext = (0, _reactDefault.default).createContext({
    transitionTimer: new (0, _timerDefault.default)(),
    animationTimer: new (0, _timerDefault.default)()
});
TimerContext.displayName = "TimerContext";
exports.default = TimerContext;

},{"react":"gVheC","./timer":"dWrer","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dWrer":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Timer;
});
var _d3Timer = require("d3-timer");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Timer = /*#__PURE__*/ function() {
    function Timer() {
        _classCallCheck(this, Timer);
        this.shouldAnimate = true;
        this.subscribers = [];
        this.loop = this.loop.bind(this);
        this.timer = null;
        this.activeSubscriptions = 0;
    }
    _createClass(Timer, [
        {
            key: "bypassAnimation",
            value: function bypassAnimation() {
                this.shouldAnimate = false;
            }
        },
        {
            key: "resumeAnimation",
            value: function resumeAnimation() {
                this.shouldAnimate = true;
            }
        },
        {
            key: "loop",
            value: function loop() {
                this.subscribers.forEach(function(s) {
                    s.callback((0, _d3Timer.now)() - s.startTime, s.duration);
                });
            }
        },
        {
            key: "start",
            value: function start() {
                if (!this.timer) this.timer = (0, _d3Timer.timer)(this.loop);
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.timer) {
                    this.timer.stop();
                    this.timer = null;
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback, duration) {
                duration = this.shouldAnimate ? duration : 0;
                var subscriptionID = this.subscribers.push({
                    startTime: (0, _d3Timer.now)(),
                    callback: callback,
                    duration: duration
                });
                this.activeSubscriptions++;
                this.start();
                return subscriptionID;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(id) {
                if (id !== null && this.subscribers[id - 1]) {
                    delete this.subscribers[id - 1];
                    this.activeSubscriptions--;
                }
                if (this.activeSubscriptions === 0) this.stop();
            }
        }
    ]);
    return Timer;
}();

},{"d3-timer":"hNZFJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNZFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", function() {
    return 0, _timerJs.now;
});
parcelHelpers.export(exports, "timer", function() {
    return 0, _timerJs.timer;
});
parcelHelpers.export(exports, "timerFlush", function() {
    return 0, _timerJs.timerFlush;
});
parcelHelpers.export(exports, "timeout", function() {
    return 0, _timeoutJsDefault.default;
});
parcelHelpers.export(exports, "interval", function() {
    return 0, _intervalJsDefault.default;
});
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"9KTOw","./timeout.js":"6j9N8","./interval.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9KTOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", function() {
    return now;
});
parcelHelpers.export(exports, "Timer", function() {
    return Timer;
});
parcelHelpers.export(exports, "timer", function() {
    return timer;
});
parcelHelpers.export(exports, "timerFlush", function() {
    return timerFlush;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = (typeof performance === "undefined" ? "undefined" : (0, _typeOf._)(performance)) === "object" && performance.now ? performance : Date, setFrame = (typeof window === "undefined" ? "undefined" : (0, _typeOf._)(window)) === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function setFrame(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function restart(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function stop() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6j9N8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart(function(elapsed) {
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    };
});
var _timerJs = require("./timer.js");

},{"./timer.js":"9KTOw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jGkHB":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';
function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) == 'object') {
        var arrA = isArray(a), arrB = isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = keyList(a);
        length = keys.length;
        if (length !== keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{"@swc/helpers/_/_type_of":"668P4"}],"lxNwa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictoryContainer;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _uniqueId = require("lodash/uniqueId");
var _uniqueIdDefault = parcelHelpers.interopDefault(_uniqueId);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _propTypes1 = require("../victory-util/prop-types");
var _portal = require("../victory-portal/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _portalContext = require("../victory-portal/portal-context");
var _portalContextDefault = parcelHelpers.interopDefault(_portalContext);
var _timerContext = require("../victory-util/timer-context");
var _timerContextDefault = parcelHelpers.interopDefault(_timerContext);
var _helpers = require("../victory-util/helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var VictoryContainer = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryContainer, _React$Component);
    function VictoryContainer(props) {
        var _this;
        _classCallCheck(this, VictoryContainer);
        _this = _possibleConstructorReturn(this, (VictoryContainer.__proto__ || Object.getPrototypeOf(VictoryContainer)).call(this, props));
        _this.containerId = !(0, _isObjectDefault.default)(props) || props.containerId === undefined ? (0, _uniqueIdDefault.default)("victory-container-") : props.containerId;
        _this.savePortalRef = function(portal) {
            _this.portalRef = portal;
            return portal;
        };
        _this.portalUpdate = function(key, el) {
            return _this.portalRef.portalUpdate(key, el);
        };
        _this.portalRegister = function() {
            return _this.portalRef.portalRegister();
        };
        _this.portalDeregister = function(key) {
            return _this.portalRef.portalDeregister(key);
        };
        _this.saveContainerRef = props && (0, _isFunctionDefault.default)(props.containerRef) ? props.containerRef : function(container) {
            _this.containerRef = container;
            return container;
        };
        _this.shouldHandleWheel = props && props.events && props.events.onWheel;
        if (_this.shouldHandleWheel) _this.handleWheel = function(e) {
            return e.preventDefault();
        };
        return _this;
    }
    _createClass(VictoryContainer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.shouldHandleWheel && this.containerRef) this.containerRef.addEventListener("wheel", this.handleWheel);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.shouldHandleWheel && this.containerRef) this.containerRef.removeEventListener("wheel", this.handleWheel);
            }
        },
        {
            key: "getIdForElement",
            value: function getIdForElement(elementName) {
                return "".concat(this.containerId, "-").concat(elementName);
            } // overridden in custom containers
        },
        {
            key: "getChildren",
            value: function getChildren(props) {
                return props.children;
            } // Get props defined by the Open UI Automation (OUIA) 1.0-RC spec
        },
        {
            key: "getOUIAProps",
            value: function getOUIAProps(props) {
                var ouiaId = props.ouiaId, ouiaSafe = props.ouiaSafe, ouiaType = props.ouiaType;
                return _objectSpread({}, ouiaId && {
                    "data-ouia-component-id": ouiaId
                }, ouiaType && {
                    "data-ouia-component-type": ouiaType
                }, ouiaSafe !== undefined && {
                    "data-ouia-safe": ouiaSafe
                });
            }
        },
        {
            key: "renderContainer",
            value: function renderContainer(props, svgProps, style) {
                var title = props.title, desc = props.desc, portalComponent = props.portalComponent, className = props.className, width = props.width, height = props.height, portalZIndex = props.portalZIndex, responsive = props.responsive;
                var children = this.getChildren(props);
                var dimensions = responsive ? {
                    width: "100%",
                    height: "100%"
                } : {
                    width: width,
                    height: height
                };
                var divStyle = (0, _assignDefault.default)({
                    pointerEvents: "none",
                    touchAction: "none",
                    position: "relative"
                }, dimensions);
                var portalDivStyle = (0, _assignDefault.default)({
                    zIndex: portalZIndex,
                    position: "absolute",
                    top: 0,
                    left: 0
                }, dimensions);
                var svgStyle = (0, _assignDefault.default)({
                    pointerEvents: "all"
                }, dimensions);
                var portalSvgStyle = (0, _assignDefault.default)({
                    overflow: "visible"
                }, dimensions);
                var portalProps = {
                    width: width,
                    height: height,
                    viewBox: svgProps.viewBox,
                    preserveAspectRatio: svgProps.preserveAspectRatio,
                    style: portalSvgStyle
                };
                return (0, _reactDefault.default).createElement((0, _portalContextDefault.default).Provider, {
                    value: {
                        portalUpdate: this.portalUpdate,
                        portalRegister: this.portalRegister,
                        portalDeregister: this.portalDeregister
                    }
                }, (0, _reactDefault.default).createElement("div", _extends({
                    style: (0, _defaultsDefault.default)({}, style, divStyle),
                    className: className,
                    ref: this.saveContainerRef
                }, this.getOUIAProps(props)), (0, _reactDefault.default).createElement("svg", _extends({}, svgProps, {
                    style: svgStyle
                }), title ? (0, _reactDefault.default).createElement("title", {
                    id: this.getIdForElement("title")
                }, title) : null, desc ? (0, _reactDefault.default).createElement("desc", {
                    id: this.getIdForElement("desc")
                }, desc) : null, children), (0, _reactDefault.default).createElement("div", {
                    style: portalDivStyle
                }, (0, _reactDefault.default).cloneElement(portalComponent, _objectSpread({}, portalProps, {
                    ref: this.savePortalRef
                })))));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, width = _props.width, height = _props.height, responsive = _props.responsive, events = _props.events, title = _props.title, desc = _props.desc, tabIndex = _props.tabIndex, preserveAspectRatio = _props.preserveAspectRatio, role = _props.role;
                var style = responsive ? this.props.style : _helpers.omit(this.props.style, [
                    "height",
                    "width"
                ]);
                var svgProps = (0, _assignDefault.default)({
                    width: width,
                    height: height,
                    tabIndex: tabIndex,
                    role: role,
                    "aria-labelledby": [
                        title && this.getIdForElement("title"),
                        this.props["aria-labelledby"]
                    ].filter(Boolean).join(" ") || undefined,
                    "aria-describedby": [
                        desc && this.getIdForElement("desc"),
                        this.props["aria-describedby"]
                    ].filter(Boolean).join(" ") || undefined,
                    viewBox: responsive ? "0 0 ".concat(width, " ").concat(height) : undefined,
                    preserveAspectRatio: responsive ? preserveAspectRatio : undefined
                }, events);
                return this.renderContainer(this.props, svgProps, style);
            }
        }
    ]);
    return VictoryContainer;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryContainer, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryContainer"
});
Object.defineProperty(VictoryContainer, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "container"
});
Object.defineProperty(VictoryContainer, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        "aria-describedby": (0, _propTypesDefault.default).string,
        "aria-labelledby": (0, _propTypesDefault.default).string,
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        className: (0, _propTypesDefault.default).string,
        containerId: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        containerRef: (0, _propTypesDefault.default).func,
        desc: (0, _propTypesDefault.default).string,
        events: (0, _propTypesDefault.default).object,
        height: _propTypes1.nonNegative,
        name: (0, _propTypesDefault.default).string,
        origin: (0, _propTypesDefault.default).shape({
            x: _propTypes1.nonNegative,
            y: _propTypes1.nonNegative
        }),
        ouiaId: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        ouiaSafe: (0, _propTypesDefault.default).bool,
        ouiaType: (0, _propTypesDefault.default).string,
        polar: (0, _propTypesDefault.default).bool,
        portalComponent: (0, _propTypesDefault.default).element,
        portalZIndex: _propTypes1.integer,
        preserveAspectRatio: (0, _propTypesDefault.default).string,
        responsive: (0, _propTypesDefault.default).bool,
        role: (0, _propTypesDefault.default).string,
        style: (0, _propTypesDefault.default).object,
        tabIndex: (0, _propTypesDefault.default).number,
        theme: (0, _propTypesDefault.default).object,
        title: (0, _propTypesDefault.default).string,
        width: _propTypes1.nonNegative
    }
});
Object.defineProperty(VictoryContainer, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        className: "VictoryContainer",
        portalComponent: (0, _reactDefault.default).createElement((0, _portalDefault.default), null),
        portalZIndex: 99,
        responsive: true,
        role: "img"
    }
});
Object.defineProperty(VictoryContainer, "contextType", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _timerContextDefault.default)
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/isFunction":"8ck2f","lodash/isObject":"8ffGS","lodash/uniqueId":"9xtWm","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/prop-types":"88bb9","../victory-portal/portal":"BrUvi","../victory-portal/portal-context":"1m20y","../victory-util/timer-context":"hLkTS","../victory-util/helpers":"8ABme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9xtWm":[function(require,module,exports,__globalThis) {
var toString = require("44aae548b0667b1d");
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"44aae548b0667b1d":"23Zly"}],"eWhnr":[function(require,module,exports,__globalThis) {
var baseRest = require("7185e90d741afd2a"), eq = require("c7442b0697635fa9"), isIterateeCall = require("4bcb10da45efc3b8"), keysIn = require("4217ca21be56753d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var defaults = baseRest(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = defaults;

},{"7185e90d741afd2a":"7EAh7","c7442b0697635fa9":"8Gfg3","4bcb10da45efc3b8":"936XO","4217ca21be56753d":"fCgzE"}],"7EAh7":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"6wIyV","ff7d23ff2a2ea6f8":"kFCQg","a11d545e809d14f7":"14wda"}],"kFCQg":[function(require,module,exports,__globalThis) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"fNr5H"}],"fNr5H":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"14wda":[function(require,module,exports,__globalThis) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"1uXz0","9114f59293388d49":"9ZlLb"}],"1uXz0":[function(require,module,exports,__globalThis) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"jESKB","eff1240bc0447727":"2iIpD","b00d1e57326793e1":"6wIyV"}],"jESKB":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9ZlLb":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"936XO":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index === "undefined" ? "undefined" : (0, _typeOf._)(index);
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"@swc/helpers/_/_type_of":"668P4","a8ec2a011d2eca69":"8Gfg3","616bc732534dffe0":"mL7I2","e781332a36d1bd7":"heeP8","c8548bf6929b8a5d":"8ffGS"}],"fCgzE":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"vD0Yx","194eb1a802636842":"9Ymm9","ac15afdc3ddd76cd":"mL7I2"}],"9Ymm9":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"8ffGS","f7d53cd92b2b977b":"36IG4","c039208a16eb68bd":"gGURQ"}],"gGURQ":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"xTxAt":[function(require,module,exports,__globalThis) {
var assignValue = require("cd50f116bb7c0628"), copyObject = require("7bcaa9d60d9bad0c"), createAssigner = require("db25c5a8055340d4"), isArrayLike = require("b829ba96c1ea24e1"), isPrototype = require("add8cc04c06f0a24"), keys = require("3f4056e956015995");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var assign = createAssigner(function(object, source) {
    if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
    }
    for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
});
module.exports = assign;

},{"cd50f116bb7c0628":"5IHI0","7bcaa9d60d9bad0c":"hqcwa","db25c5a8055340d4":"8LCsj","b829ba96c1ea24e1":"mL7I2","add8cc04c06f0a24":"36IG4","3f4056e956015995":"kLvI9"}],"5IHI0":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"8nNdL","b62ef95b3cf1cde1":"8Gfg3"}],"hqcwa":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"5IHI0","9cddf6ac1a092765":"8nNdL"}],"8LCsj":[function(require,module,exports,__globalThis) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"7EAh7","4f5832110eba92d3":"936XO"}],"88bb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a new validator based on `propType` but which logs a `console.error`
 * with `explanation` if used.
 * @param {Function} propType The old, deprecated propType.
 * @param {String} explanation The message to provide the user of the deprecated propType.
 * @returns {Function} Validator which logs usage of this propType
 */ parcelHelpers.export(exports, "deprecated", function() {
    return deprecated;
});
/**
 * Return a new validator which returns true
 * if and only if all validators passed as arguments return true.
 * Like React.propTypes.oneOfType, except "all" instead of "any"
 * @param {Array} validators Validation functions.
 * @returns {Function} Combined validator function
 */ parcelHelpers.export(exports, "allOfType", function() {
    return allOfType;
});
parcelHelpers.export(exports, "nonNegative", function() {
    return nonNegative;
});
parcelHelpers.export(exports, "integer", function() {
    return integer;
});
parcelHelpers.export(exports, "greaterThanZero", function() {
    return greaterThanZero;
});
parcelHelpers.export(exports, "domain", function() {
    return domain;
});
parcelHelpers.export(exports, "scale", function() {
    return scale;
});
parcelHelpers.export(exports, "homogeneousArray", function() {
    return homogeneousArray;
});
parcelHelpers.export(exports, "matchDataLength", function() {
    return matchDataLength;
});
parcelHelpers.export(exports, "regExp", function() {
    return regExp;
});
var _isRegExp = require("lodash/isRegExp");
var _isRegExpDefault = parcelHelpers.interopDefault(_isRegExp);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _log = require("./log");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Return a new validator based on `validator` but with the option to chain
 * `isRequired` onto the validation. This is nearly identical to how React
 * does it internally, but they don't expose their helper for us to use.
 * @param {Function} validator Validation function.
 * @returns {Function} Validator with `isRequired` option.
 */ var makeChainable = function makeChainable(validator) {
    /* eslint-disable max-params */ var _chainable = function _chainable(isRequired, props, propName, componentName) {
        var value = props[propName];
        if (value === undefined || value === null) {
            if (isRequired) return new Error("Required `".concat(propName, "` was not specified in `").concat(componentName, "`."));
            return null;
        }
        for(var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++)rest[_key - 4] = arguments[_key];
        return validator.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
    var chainable = _chainable.bind(null, false);
    chainable.isRequired = _chainable.bind(null, true);
    return chainable;
};
var nullConstructor = function nullConstructor() {
    return null;
};
var undefinedConstructor = function undefinedConstructor() {
    return undefined;
};
/**
 * Get the constructor of `value`. If `value` is null or undefined, return the
 * special singletons `nullConstructor` or `undefinedConstructor`, respectively.
 * @param {*} value Instance to return the constructor of.
 * @returns {Function} Constructor of `value`.
 */ var getConstructor = function getConstructor(value) {
    if (value === undefined) return undefinedConstructor;
    else if (value === null) return nullConstructor;
    else return value.constructor;
};
/**
 * Get the name of the constructor used to create `value`, using
 * `Object.protoype.toString`. If the value is null or undefined, return
 * "null" or "undefined", respectively.
 * @param {*} value Instance to return the constructor name of.
 * @returns {String} Name of the constructor.
 */ var getConstructorName = function getConstructorName(value) {
    if (value === undefined) return "undefined";
    else if (value === null) return "null";
    return Object.prototype.toString.call(value).slice(8, -1); // eslint-disable-line no-magic-numbers
};
function deprecated(propType, explanation) {
    return function(props, propName, componentName) {
        var value = props[propName];
        if (value !== null && value !== undefined) _log.warn("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated ").concat(explanation));
        return (0, _propTypesDefault.default).checkPropTypes(_defineProperty({}, propName, propType), props, propName, componentName);
    };
}
function allOfType(validators) {
    return makeChainable(function(props, propName, componentName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
        return validators.reduce(function(result, validator) {
            return result || validator.apply(void 0, [
                props,
                propName,
                componentName
            ].concat(rest));
        }, undefined);
    });
}
var nonNegative = makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value < 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a non-negative number."));
    return undefined;
});
var integer = makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value % 1 !== 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an integer."));
    return undefined;
});
var greaterThanZero = makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (typeof value !== "number" || value <= 0) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a number greater than zero."));
    return undefined;
});
var domain = makeChainable(function(props, propName, componentName) {
    var value = props[propName];
    if (!Array.isArray(value) || value.length !== 2 || value[1] === value[0]) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array of two unique numeric values."));
    return undefined;
});
var scale = makeChainable(function(props, propName, componentName) {
    var supportedScaleStrings = [
        "linear",
        "time",
        "log",
        "sqrt"
    ];
    var validScale = function validScale(scl) {
        if ((0, _isFunctionDefault.default)(scl)) return (0, _isFunctionDefault.default)(scl.copy) && (0, _isFunctionDefault.default)(scl.domain) && (0, _isFunctionDefault.default)(scl.range);
        else if (typeof scl === "string") return supportedScaleStrings.indexOf(scl) !== -1;
        return false;
    };
    var value = props[propName];
    if (!validScale(value)) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a d3 scale."));
    return undefined;
});
var homogeneousArray = makeChainable(function(props, propName, componentName) {
    var values = props[propName];
    if (!Array.isArray(values)) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be an array."));
    if (values.length < 2) return undefined;
    var comparisonConstructor = getConstructor(values[0]);
    var typeMismatchedValue = (0, _findDefault.default)(values, function(value) {
        return comparisonConstructor !== getConstructor(value);
    });
    if (typeMismatchedValue) {
        var constructorName = getConstructorName(values[0]);
        var otherConstructorName = getConstructorName(typeMismatchedValue);
        return new Error("Expected `".concat(propName, "` in `").concat(componentName, "` to be a ") + "homogeneous array, but found types `".concat(constructorName, "` and ") + "`".concat(otherConstructorName, "`."));
    }
    return undefined;
});
var matchDataLength = makeChainable(function(props, propName) {
    if (props[propName] && Array.isArray(props[propName]) && props[propName].length !== props.data.length) return new Error("Length of data and ".concat(propName, " arrays must match."));
    return undefined;
});
var regExp = makeChainable(function(props, propName, componentName) {
    if (props[propName] && !(0, _isRegExpDefault.default)(props[propName])) return new Error("`".concat(propName, "` in `").concat(componentName, "` must be a regular expression."));
    return undefined;
});

},{"lodash/isRegExp":"dY2uq","lodash/find":"50FsZ","lodash/isFunction":"8ck2f","./log":"dgIVr","prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dY2uq":[function(require,module,exports,__globalThis) {
var baseIsRegExp = require("36a2693d4173542"), baseUnary = require("effaa876cd30b882"), nodeUtil = require("4cee4fa1e8734775");
/* Node.js helper references. */ var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
module.exports = isRegExp;

},{"36a2693d4173542":"DBnZt","effaa876cd30b882":"8g9lw","4cee4fa1e8734775":"hZg2H"}],"DBnZt":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7087d9a4570feb6a"), isObjectLike = require("d35660d37f3f2e0");
/** `Object#toString` result references. */ var regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function baseIsRegExp(value) {
    return isObjectLike(value) && baseGetTag(value) == regexpTag;
}
module.exports = baseIsRegExp;

},{"7087d9a4570feb6a":"iuqvy","d35660d37f3f2e0":"lm2eo"}],"50FsZ":[function(require,module,exports,__globalThis) {
var createFind = require("f180f4459f295340"), findIndex = require("5af87c887948f3ca");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"f180f4459f295340":"88vIf","5af87c887948f3ca":"QMNTH"}],"88vIf":[function(require,module,exports,__globalThis) {
var baseIteratee = require("ad0cafc4de9b66e6"), isArrayLike = require("cfacddc571674e4b"), keys = require("847fe2f1205991cd");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function predicate(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"ad0cafc4de9b66e6":"exkHY","cfacddc571674e4b":"mL7I2","847fe2f1205991cd":"kLvI9"}],"QMNTH":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("c4739d82cf87a9be"), baseIteratee = require("a250b62014668b1"), toInteger = require("8b47b48a148e503b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"c4739d82cf87a9be":"lGn6o","a250b62014668b1":"exkHY","8b47b48a148e503b":"fVns0"}],"lGn6o":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"fVns0":[function(require,module,exports,__globalThis) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"01pTU"}],"01pTU":[function(require,module,exports,__globalThis) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"6gmL5"}],"6gmL5":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"czHua","faaa289d287a34a5":"8ffGS","47b3bd23f771891":"5eB4J"}],"czHua":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"8vWos"}],"8vWos":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"dgIVr":[function(require,module,exports,__globalThis) {
/* global console */ /* eslint-disable no-console */ // TODO: Use "warning" npm module like React is switching to.
// eslint-disable-next-line func-style
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", function() {
    return warn;
});
function warn(message) {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"BrUvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Portal;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _propTypes1 = require("../victory-util/prop-types");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var Portal = /*#__PURE__*/ function(_React$Component) {
    _inherits(Portal, _React$Component);
    function Portal(props) {
        var _this;
        _classCallCheck(this, Portal);
        _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
        _this.map = {};
        _this.index = 1;
        _this.portalUpdate = _this.portalUpdate.bind(_assertThisInitialized(_this));
        _this.portalRegister = _this.portalRegister.bind(_assertThisInitialized(_this));
        _this.portalDeregister = _this.portalDeregister.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(Portal, [
        {
            key: "portalRegister",
            value: function portalRegister() {
                return ++this.index;
            }
        },
        {
            key: "portalUpdate",
            value: function portalUpdate(key, element) {
                this.map[key] = element;
                this.forceUpdate();
            }
        },
        {
            key: "portalDeregister",
            value: function portalDeregister(key) {
                delete this.map[key];
                this.forceUpdate();
            }
        },
        {
            key: "getChildren",
            value: function getChildren() {
                var _this2 = this;
                return (0, _keysDefault.default)(this.map).map(function(key) {
                    var el = _this2.map[key];
                    return el ? (0, _reactDefault.default).cloneElement(el, {
                        key: key
                    }) : el;
                });
            } // Overridden in victory-core-native
        },
        {
            key: "render",
            value: function render() {
                return (0, _reactDefault.default).createElement("svg", this.props, this.getChildren());
            }
        }
    ]);
    return Portal;
}((0, _reactDefault.default).Component);
Object.defineProperty(Portal, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "Portal"
});
Object.defineProperty(Portal, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        className: (0, _propTypesDefault.default).string,
        height: _propTypes1.nonNegative,
        style: (0, _propTypesDefault.default).object,
        viewBox: (0, _propTypesDefault.default).string,
        width: _propTypes1.nonNegative
    }
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/keys":"kLvI9","react":"gVheC","prop-types":"3KNJy","../victory-util/prop-types":"88bb9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1m20y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * The React context object consumers may use to access the context of the
 * portal.
 */ var PortalContext = (0, _reactDefault.default).createContext({});
PortalContext.displayName = "PortalContext";
exports.default = PortalContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ABme":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates an object with some keys excluded
 * replacement for lodash.omit for performance. does not mimick the entire lodash.omit api
 * @param {Object} originalObject: created object will be based on this object
 * @param {Array<String>} ks: an array of keys to omit from the new object
 * @returns {Object} new object with same properties as originalObject
 */ parcelHelpers.export(exports, "omit", function() {
    return omit;
});
parcelHelpers.export(exports, "getPoint", function() {
    return getPoint;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return scalePoint;
});
parcelHelpers.export(exports, "getPadding", function() {
    return getPadding;
});
parcelHelpers.export(exports, "isTooltip", function() {
    return isTooltip;
});
parcelHelpers.export(exports, "getDefaultStyles", function() {
    return getDefaultStyles;
});
parcelHelpers.export(exports, "getStyles", function() {
    return getStyles;
});
parcelHelpers.export(exports, "evaluateProp", function() {
    return evaluateProp;
});
parcelHelpers.export(exports, "evaluateStyle", function() {
    return evaluateStyle;
});
parcelHelpers.export(exports, "degreesToRadians", function() {
    return degreesToRadians;
});
parcelHelpers.export(exports, "radiansToDegrees", function() {
    return radiansToDegrees;
});
parcelHelpers.export(exports, "getRadius", function() {
    return getRadius;
});
parcelHelpers.export(exports, "getPolarOrigin", function() {
    return getPolarOrigin;
});
parcelHelpers.export(exports, "getRange", function() {
    return getRange;
});
parcelHelpers.export(exports, "createAccessor", function() {
    return createAccessor;
});
parcelHelpers.export(exports, "modifyProps", function() {
    return modifyProps;
});
/**
 * Returns the given axis or the opposite axis when horizontal
 * @param {string} axis: the given axis, either "x" pr "y"
 * @param {Boolean} horizontal: true when the chart is flipped to the horizontal orientation
 * @returns {String} the dimension appropriate for the axis given its props "x" or "y"
 */ parcelHelpers.export(exports, "getCurrentAxis", function() {
    return getCurrentAxis;
});
/**
 * @param {Array} children: an array of child components
 * @param {Function} iteratee: a function with arguments "child", "childName", and "parent"
 * @param {Object} parentProps: props from the parent that are applied to children
 * @param {any}  initialMemo: The object in which the iteration results are combined.
 * @param {Function} combine: Combines the result of the iteratee with the current memo
 *   to the memo for the next iteration step
 * @returns {Array} returns an array of results from calling the iteratee on all nested children
 */ /* eslint-disable max-params */ parcelHelpers.export(exports, "reduceChildren", function() {
    return reduceChildren;
});
/**
 * @param {Object} props: the props object
 * @returns {Boolean} returns true if the props object contains `horizontal: true` of if any
 * children or nested children are hoizontal
 */ parcelHelpers.export(exports, "isHorizontal", function() {
    return isHorizontal;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _property = require("lodash/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Private Functions
function getCartesianRange(props, axis) {
    // determine how to lay the axis and what direction positive and negative are
    var vertical = axis !== "x";
    var padding = getPadding(props);
    if (vertical) return [
        props.height - padding.bottom,
        padding.top
    ];
    return [
        padding.left,
        props.width - padding.right
    ];
}
function getPolarRange(props, axis) {
    if (axis === "x") {
        var startAngle = degreesToRadians(props.startAngle || 0);
        var endAngle = degreesToRadians(props.endAngle || 360);
        return [
            startAngle,
            endAngle
        ];
    }
    return [
        props.innerRadius || 0,
        getRadius(props)
    ];
} // Exported Functions
function omit(originalObject) {
    var ks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // code based on babel's _objectWithoutProperties
    var newObject = {};
    for(var key in originalObject){
        if (ks.indexOf(key) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(originalObject, key)) continue;
        newObject[key] = originalObject[key];
    }
    return newObject;
}
function getPoint(datum) {
    var exists = function exists(val) {
        return val !== undefined;
    };
    var _x = datum._x, _x1 = datum._x1, _x0 = datum._x0, _voronoiX = datum._voronoiX, _y = datum._y, _y1 = datum._y1, _y0 = datum._y0, _voronoiY = datum._voronoiY;
    var defaultX = exists(_x1) ? _x1 : _x;
    var defaultY = exists(_y1) ? _y1 : _y;
    var point = {
        x: exists(_voronoiX) ? _voronoiX : defaultX,
        x0: exists(_x0) ? _x0 : _x,
        y: exists(_voronoiY) ? _voronoiY : defaultY,
        y0: exists(_y0) ? _y0 : _y
    };
    return (0, _defaultsDefault.default)({}, point, datum);
}
function scalePoint(props, datum) {
    var scale = props.scale, polar = props.polar, horizontal = props.horizontal;
    var d = getPoint(datum);
    var origin = props.origin || {
        x: 0,
        y: 0
    };
    var x = horizontal ? scale.y(d.y) : scale.x(d.x);
    var x0 = horizontal ? scale.y(d.y0) : scale.x(d.x0);
    var y = horizontal ? scale.x(d.x) : scale.y(d.y);
    var y0 = horizontal ? scale.x(d.x0) : scale.y(d.y0);
    return {
        x: polar ? y * Math.cos(x) + origin.x : x,
        x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
        y: polar ? -y * Math.sin(x) + origin.y : y,
        y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
    };
}
function getPadding(props) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "padding";
    var padding = props[name];
    var paddingVal = typeof padding === "number" ? padding : 0;
    var paddingObj = (typeof padding === "undefined" ? "undefined" : (0, _typeOf._)(padding)) === "object" ? padding : {};
    return {
        top: paddingObj.top || paddingVal,
        bottom: paddingObj.bottom || paddingVal,
        left: paddingObj.left || paddingVal,
        right: paddingObj.right || paddingVal
    };
}
function isTooltip(component) {
    var labelRole = component && component.type && component.type.role;
    return labelRole === "tooltip";
}
function getDefaultStyles(props, role) {
    var _props$theme = props.theme, theme = _props$theme === void 0 ? {} : _props$theme, labelComponent = props.labelComponent;
    var defaultStyles = theme[role] && theme[role].style || {};
    if (!isTooltip(labelComponent)) return defaultStyles;
    var tooltipStyle = theme.tooltip && theme.tooltip.style || {};
    var labelStyle = (0, _defaultsDefault.default)({}, tooltipStyle, defaultStyles.labels);
    return (0, _defaultsDefault.default)({}, {
        labels: labelStyle
    }, defaultStyles);
}
function getStyles(style, defaultStyles) {
    var width = "100%";
    var height = "100%";
    if (!style) return (0, _defaultsDefault.default)({
        parent: {
            height: height,
            width: width
        }
    }, defaultStyles);
    var data = style.data, labels = style.labels, parent = style.parent;
    var defaultParent = defaultStyles && defaultStyles.parent || {};
    var defaultLabels = defaultStyles && defaultStyles.labels || {};
    var defaultData = defaultStyles && defaultStyles.data || {};
    return {
        parent: (0, _defaultsDefault.default)({}, parent, defaultParent, {
            width: width,
            height: height
        }),
        labels: (0, _defaultsDefault.default)({}, labels, defaultLabels),
        data: (0, _defaultsDefault.default)({}, data, defaultData)
    };
}
function evaluateProp(prop, props) {
    return (0, _isFunctionDefault.default)(prop) ? prop(props) : prop;
}
function evaluateStyle(style, props) {
    if (props.disableInlineStyles) return {};
    if (!style || !(0, _keysDefault.default)(style).some(function(value) {
        return (0, _isFunctionDefault.default)(style[value]);
    })) return style;
    return (0, _keysDefault.default)(style).reduce(function(prev, curr) {
        prev[curr] = evaluateProp(style[curr], props);
        return prev;
    }, {});
}
function degreesToRadians(degrees) {
    return typeof degrees === "number" ? degrees * (Math.PI / 180) : degrees;
}
function radiansToDegrees(radians) {
    return typeof radians === "number" ? radians / (Math.PI / 180) : radians;
}
function getRadius(props) {
    var _getPadding = getPadding(props), left = _getPadding.left, right = _getPadding.right, top = _getPadding.top, bottom = _getPadding.bottom;
    var width = props.width, height = props.height;
    return Math.min(width - left - right, height - top - bottom) / 2;
}
function getPolarOrigin(props) {
    var width = props.width, height = props.height;
    var _getPadding2 = getPadding(props), top = _getPadding2.top, bottom = _getPadding2.bottom, left = _getPadding2.left, right = _getPadding2.right;
    var radius = Math.min(width - left - right, height - top - bottom) / 2;
    var offsetWidth = width / 2 + left - right;
    var offsetHeight = height / 2 + top - bottom;
    return {
        x: offsetWidth + radius > width ? radius + left - right : offsetWidth,
        y: offsetHeight + radius > height ? radius + top - bottom : offsetHeight
    };
}
function getRange(props, axis) {
    if (props.range && props.range[axis]) return props.range[axis];
    else if (props.range && Array.isArray(props.range)) return props.range;
    return props.polar ? getPolarRange(props, axis) : getCartesianRange(props, axis);
}
function createAccessor(key) {
    // creates a data accessor function
    // given a property key, path, array index, or null for identity.
    if ((0, _isFunctionDefault.default)(key)) return key;
    else if (key === null || key === undefined) // null/undefined means "return the data item itself"
    return function(x) {
        return x;
    };
     // otherwise, assume it is an array index, property key or path (_.property handles all three)
    return (0, _propertyDefault.default)(key);
}
function modifyProps(props, fallbackProps, role) {
    var theme = props.theme && props.theme[role] ? props.theme[role] : {};
    var themeProps = omit(theme, [
        "style"
    ]);
    var horizontal = isHorizontal(props);
    var defaultObject = horizontal === undefined ? {} : {
        horizontal: horizontal
    };
    return (0, _defaultsDefault.default)(defaultObject, props, themeProps, fallbackProps);
}
function getCurrentAxis(axis, horizontal) {
    var otherAxis = axis === "x" ? "y" : "x";
    return horizontal ? otherAxis : axis;
}
function reduceChildren(children, iteratee) {
    var parentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var initialMemo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var combine = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function combine(memo, item) {
        return memo.concat(item);
    };
    var sharedProps = [
        "data",
        "domain",
        "categories",
        "polar",
        "startAngle",
        "endAngle",
        "minDomain",
        "maxDomain",
        "horizontal"
    ];
    var traverseChildren = function traverseChildren1(childArray, names, parent) {
        return childArray.reduce(function(memo, child, index) {
            var childRole = child.type && child.type.role;
            var childName = child.props.name || "".concat(childRole, "-").concat(names[index]);
            if (child.props && child.props.children) {
                var childProps = (0, _assignDefault.default)({}, child.props, (0, _pickDefault.default)(parentProps, sharedProps));
                var nestedChildren = child.type && child.type.role === "stack" && (0, _isFunctionDefault.default)(child.type.getChildren) ? child.type.getChildren(childProps) : (0, _reactDefault.default).Children.toArray(child.props.children).map(function(c) {
                    var nestedChildProps = (0, _assignDefault.default)({}, c.props, (0, _pickDefault.default)(childProps, sharedProps));
                    return (0, _reactDefault.default).cloneElement(c, nestedChildProps);
                });
                var _childNames = nestedChildren.map(function(c, i) {
                    return "".concat(childName, "-").concat(i);
                });
                var nestedResults = traverseChildren(nestedChildren, _childNames, child);
                memo = combine(memo, nestedResults);
            } else {
                var result = iteratee(child, childName, parent);
                if (result) memo = combine(memo, result);
            }
            return memo;
        }, initialMemo);
    };
    var childNames = children.map(function(c, i) {
        return i;
    });
    return traverseChildren(children, childNames);
}
function isHorizontal(props) {
    if (props.horizontal !== undefined || !props.children) return props.horizontal;
    var traverseChildren = function traverseChildren1(childArray) {
        return childArray.reduce(function(memo, child) {
            var childProps = child.props || {};
            if (memo || childProps.horizontal || !childProps.children) {
                memo = memo || childProps.horizontal;
                return memo;
            }
            return traverseChildren((0, _reactDefault.default).Children.toArray(childProps.children));
        }, false);
    };
    return traverseChildren((0, _reactDefault.default).Children.toArray(props.children));
}

},{"@swc/helpers/_/_type_of":"668P4","lodash/keys":"kLvI9","lodash/assign":"xTxAt","lodash/pick":"7HV03","lodash/property":"bqkBM","lodash/isFunction":"8ck2f","lodash/defaults":"eWhnr","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7HV03":[function(require,module,exports,__globalThis) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"esUyP","7f4b4cdb31764f87":"11HI2"}],"esUyP":[function(require,module,exports,__globalThis) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"ftzWM","c697490fd5f67a25":"bW9UX"}],"ftzWM":[function(require,module,exports,__globalThis) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"3bgbL","b07dbab95dca4167":"dfWQP","64b51364f27b9088":"cLKKN"}],"dfWQP":[function(require,module,exports,__globalThis) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"5IHI0","56e0b8a492d56399":"cLKKN","d1eb8acc5a65dc38":"heeP8","dfb182b16ef275c0":"8ffGS","6a51dc787ca5b6e3":"ih6jk"}],"11HI2":[function(require,module,exports,__globalThis) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
}
module.exports = flatRest;

},{"199f7cbd69032298":"b7fAH","aa5c38699e42775a":"kFCQg","6a66c8b3fbd122d5":"14wda"}],"3hHmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
/*eslint no-magic-numbers: ["error", { "ignore": [-0.5, 0.5, 0, 1, 2] }]*/ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryPortal = require("../victory-portal/victory-portal");
var _victoryPortalDefault = parcelHelpers.interopDefault(_victoryPortal);
var _rect = require("../victory-primitives/rect");
var _rectDefault = parcelHelpers.interopDefault(_rect);
var _propTypes1 = require("../victory-util/prop-types");
var _helpers = require("../victory-util/helpers");
var _labelHelpers = require("../victory-util/label-helpers");
var _style = require("../victory-util/style");
var _log = require("../victory-util/log");
var _textsize = require("../victory-util/textsize");
var _tspan = require("../victory-primitives/tspan");
var _tspanDefault = parcelHelpers.interopDefault(_tspan);
var _text = require("../victory-primitives/text");
var _textDefault = parcelHelpers.interopDefault(_text);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var defaultStyles = {
    fill: "#252525",
    fontSize: 14,
    fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser\xadavek', 'Trebuchet MS', sans-serif",
    stroke: "transparent"
};
var getPosition = function getPosition(props, dimension) {
    if (!props.datum) return 0;
    var scaledPoint = _helpers.scalePoint(props, props.datum);
    return scaledPoint[dimension];
};
var getFontSize = function getFontSize(style) {
    var baseSize = style && style.fontSize;
    if (typeof baseSize === "number") return baseSize;
    else if (baseSize === undefined || baseSize === null) return defaultStyles.fontSize;
    else if (typeof baseSize === "string") {
        var fontSize = +baseSize.replace("px", "");
        if (!isNaN(fontSize)) return fontSize;
        else {
            _log.warn("fontSize should be expressed as a number of pixels");
            return defaultStyles.fontSize;
        }
    }
    return defaultStyles.fontSize;
};
var getSingleValue = function getSingleValue(prop) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.isArray(prop) ? prop[index] || prop[0] : prop;
};
var useMultiLineBackgrounds = function useMultiLineBackgrounds(props) {
    var backgroundStyle = props.backgroundStyle, backgroundPadding = props.backgroundPadding;
    return Array.isArray(backgroundStyle) && !(0, _isEmptyDefault.default)(backgroundStyle) || Array.isArray(backgroundPadding) && !(0, _isEmptyDefault.default)(backgroundPadding);
};
var getStyles = function getStyles(style, props) {
    if (props.disableInlineStyles) {
        var baseStyles = _helpers.evaluateStyle(style, props);
        return {
            // Font size is necessary to calculate the y position of the label
            fontSize: getFontSize(baseStyles)
        };
    }
    var getSingleStyle = function getSingleStyle(s) {
        s = s ? (0, _defaultsDefault.default)({}, s, defaultStyles) : defaultStyles;
        var baseStyles = _helpers.evaluateStyle(s, props);
        return (0, _assignDefault.default)({}, baseStyles, {
            fontSize: getFontSize(baseStyles)
        });
    };
    return Array.isArray(style) && !(0, _isEmptyDefault.default)(style) ? style.map(function(s) {
        return getSingleStyle(s);
    }) : getSingleStyle(style);
};
var getBackgroundStyles = function getBackgroundStyles(style, props) {
    if (!style) return undefined;
    return Array.isArray(style) && !(0, _isEmptyDefault.default)(style) ? style.map(function(s) {
        return _helpers.evaluateStyle(s, props);
    }) : _helpers.evaluateStyle(style, props);
};
var getBackgroundPadding = function getBackgroundPadding(props) {
    if (props.backgroundPadding && Array.isArray(props.backgroundPadding)) return props.backgroundPadding.map(function(backgroundPadding) {
        var padding = _helpers.evaluateProp(backgroundPadding, props);
        return _helpers.getPadding({
            padding: padding
        });
    });
    else {
        var padding = _helpers.evaluateProp(props.backgroundPadding, props);
        return _helpers.getPadding({
            padding: padding
        });
    }
};
var getLineHeight = function getLineHeight(props) {
    var lineHeight = _helpers.evaluateProp(props.lineHeight, props);
    if (Array.isArray(lineHeight)) return (0, _isEmptyDefault.default)(lineHeight) ? [
        1
    ] : lineHeight;
    else return lineHeight;
};
var getContent = function getContent(text, props) {
    if (text === undefined || text === null) return undefined;
    if (Array.isArray(text)) return text.map(function(line) {
        return _helpers.evaluateProp(line, props);
    });
    var child = _helpers.evaluateProp(text, props);
    if (child === undefined || child === null) return undefined;
    return Array.isArray(child) ? child : "".concat(child).split("\n");
};
var getDy = function getDy(props, verticalAnchor, lineHeight) {
    var dy = props.dy ? _helpers.evaluateProp(props.dy, props) : 0;
    var length = props.inline ? 1 : props.text.length;
    var capHeight = _helpers.evaluateProp(props.capHeight, props);
    var anchor = verticalAnchor ? _helpers.evaluateProp(verticalAnchor, props) : "middle";
    var fontSizes = _toConsumableArray(Array(length).keys()).map(function(i) {
        return getSingleValue(props.style, i).fontSize;
    });
    var lineHeights = _toConsumableArray(Array(length).keys()).map(function(i) {
        return getSingleValue(lineHeight, i);
    });
    if (anchor === "start") return dy + (capHeight / 2 + lineHeights[0] / 2) * fontSizes[0];
    else if (props.inline) return anchor === "end" ? dy + (capHeight / 2 - lineHeights[0] / 2) * fontSizes[0] : dy + capHeight / 2 * fontSizes[0];
    else if (length === 1) return anchor === "end" ? dy + (capHeight / 2 + (0.5 - length) * lineHeights[0]) * fontSizes[0] : dy + (capHeight / 2 + (0.5 - length / 2) * lineHeights[0]) * fontSizes[0];
    else {
        var allHeights = _toConsumableArray(Array(length).keys()).reduce(function(memo, i) {
            return memo + (capHeight / 2 + (0.5 - length) * lineHeights[i]) * fontSizes[i] / length;
        }, 0);
        return anchor === "end" ? dy + allHeights : dy + allHeights / 2 + capHeight / 2 * lineHeights[length - 1] * fontSizes[length - 1];
    }
};
var getTransform = function getTransform(props, x, y) {
    var polar = props.polar;
    var style = getSingleValue(props.style);
    var defaultAngle = polar ? _labelHelpers.getPolarAngle(props) : 0;
    var baseAngle = style.angle === undefined ? _helpers.evaluateProp(props.angle, props) : style.angle;
    var angle = baseAngle === undefined ? defaultAngle : baseAngle;
    var transform = props.transform || style.transform;
    var transformPart = transform && _helpers.evaluateProp(transform, props);
    var rotatePart = angle && {
        rotate: [
            angle,
            x,
            y
        ]
    };
    return transformPart || angle ? _style.toTransformString(transformPart, rotatePart) : undefined;
};
var getXCoordinate = function getXCoordinate(calculatedProps, labelSizeWidth) {
    var direction = calculatedProps.direction, textAnchor = calculatedProps.textAnchor, x = calculatedProps.x, dx = calculatedProps.dx;
    if (direction === "rtl") return x - labelSizeWidth;
    switch(textAnchor){
        case "middle":
            return Math.round(x - labelSizeWidth / 2);
        case "end":
            return Math.round(x - labelSizeWidth);
        default:
            // start
            return x + (dx || 0);
    }
};
var getYCoordinate = function getYCoordinate(calculatedProps, textHeight) {
    var verticalAnchor = calculatedProps.verticalAnchor, y = calculatedProps.y, _calculatedProps$orig = calculatedProps.originalDy, originalDy = _calculatedProps$orig === void 0 ? 0 : _calculatedProps$orig;
    var offset = y + originalDy;
    switch(verticalAnchor){
        case "start":
            return Math.floor(offset);
        case "end":
            return Math.ceil(offset - textHeight);
        default:
            // middle
            return Math.floor(offset - textHeight / 2);
    }
};
var getFullBackground = function getFullBackground(calculatedProps, tspanValues) {
    var _calculatedProps$dx = calculatedProps.dx, dx = _calculatedProps$dx === void 0 ? 0 : _calculatedProps$dx, transform = calculatedProps.transform, backgroundComponent = calculatedProps.backgroundComponent, backgroundStyle = calculatedProps.backgroundStyle, inline = calculatedProps.inline, backgroundPadding = calculatedProps.backgroundPadding, capHeight = calculatedProps.capHeight;
    var textSizes = tspanValues.map(function(tspan) {
        return tspan.textSize;
    });
    var height = inline ? Math.max.apply(Math, _toConsumableArray(textSizes.map(function(size) {
        return size.height;
    }))) : textSizes.reduce(function(memo, size, i) {
        var capHeightAdjustment = i ? 0 : capHeight / 2;
        return memo + size.height * (tspanValues[i].lineHeight - capHeightAdjustment);
    }, 0);
    var width = inline ? textSizes.reduce(function(memo, size, index) {
        var offset = index ? dx : 0;
        return memo + size.width + offset;
    }, 0) : Math.max.apply(Math, _toConsumableArray(textSizes.map(function(size) {
        return size.width;
    })));
    var xCoordinate = getXCoordinate(calculatedProps, width);
    var yCoordinate = getYCoordinate(calculatedProps, height);
    var backgroundProps = {
        key: "background",
        height: height + backgroundPadding.top + backgroundPadding.bottom,
        style: backgroundStyle,
        transform: transform,
        width: width + backgroundPadding.left + backgroundPadding.right,
        x: inline ? xCoordinate - backgroundPadding.left : xCoordinate + dx - backgroundPadding.left,
        y: yCoordinate
    };
    return (0, _reactDefault.default).cloneElement(backgroundComponent, (0, _defaultsDefault.default)({}, backgroundComponent.props, backgroundProps));
};
var getInlineXOffset = function getInlineXOffset(calculatedProps, textElements, index) {
    var textAnchor = calculatedProps.textAnchor;
    var widths = textElements.map(function(t) {
        return t.widthWithPadding;
    });
    var totalWidth = widths.reduce(function(memo, width) {
        return memo + width;
    }, 0);
    var centerOffset = -totalWidth / 2;
    switch(textAnchor){
        case "start":
            return widths.reduce(function(memo, width, i) {
                memo = i < index ? memo + width : memo;
                return memo;
            }, 0);
        case "end":
            return widths.reduce(function(memo, width, i) {
                memo = i > index ? memo - width : memo;
                return memo;
            }, 0);
        default:
            // middle
            return widths.reduce(function(memo, width, i) {
                var offsetWidth = i < index ? width : 0;
                memo = i === index ? memo + width / 2 : memo + offsetWidth;
                return memo;
            }, centerOffset);
    }
};
var getChildBackgrounds = function getChildBackgrounds(calculatedProps, tspanValues) {
    var dy = calculatedProps.dy, dx = calculatedProps.dx, transform = calculatedProps.transform, backgroundStyle = calculatedProps.backgroundStyle, backgroundPadding = calculatedProps.backgroundPadding, backgroundComponent = calculatedProps.backgroundComponent, inline = calculatedProps.inline, y = calculatedProps.y;
    var textElements = tspanValues.map(function(current, i) {
        var previous = getSingleValue(tspanValues, i - 1);
        var labelSize = current.textSize;
        var totalLineHeight = current.fontSize * current.lineHeight;
        var textHeight = Math.ceil(totalLineHeight);
        var padding = getSingleValue(backgroundPadding, i);
        var prevPadding = getSingleValue(backgroundPadding, i - 1);
        var xOffset = inline ? dx || 0 : 0;
        var childDy = i && !inline ? previous.fontSize * previous.lineHeight + prevPadding.top + prevPadding.bottom : dy - totalLineHeight * 0.5 - (current.fontSize - current.capHeight);
        return {
            textHeight: textHeight,
            labelSize: labelSize,
            heightWithPadding: textHeight + padding.top + padding.bottom,
            widthWithPadding: labelSize.width + padding.left + padding.right + xOffset,
            y: y,
            fontSize: current.fontSize,
            dy: childDy
        };
    });
    return textElements.map(function(textElement, i) {
        var xCoordinate = getXCoordinate(calculatedProps, textElement.labelSize.width);
        var yCoordinate = textElements.slice(0, i + 1).reduce(function(prev, curr) {
            return prev + curr.dy;
        }, y);
        var padding = getSingleValue(backgroundPadding, i);
        var height = textElement.heightWithPadding;
        var xCoord = inline ? getInlineXOffset(calculatedProps, textElements, i) + xCoordinate - padding.left : xCoordinate;
        var yCoord = inline ? getYCoordinate(calculatedProps, height) - padding.top : yCoordinate;
        var backgroundProps = {
            key: "tspan-background-".concat(i),
            height: height,
            style: getSingleValue(backgroundStyle, i),
            width: textElement.widthWithPadding,
            transform: transform,
            x: xCoord - padding.left,
            y: yCoord
        };
        return (0, _reactDefault.default).cloneElement(backgroundComponent, (0, _defaultsDefault.default)({}, backgroundComponent.props, backgroundProps));
    });
};
var getBackgroundElement = function getBackgroundElement(calculatedProps, tspanValues) {
    return useMultiLineBackgrounds(calculatedProps) ? getChildBackgrounds(calculatedProps, tspanValues) : getFullBackground(calculatedProps, tspanValues);
};
var calculateSpanDy = function calculateSpanDy(tspanValues, i, calculatedProps) {
    var current = getSingleValue(tspanValues, i);
    var previous = getSingleValue(tspanValues, i - 1);
    var previousHeight = previous.fontSize * previous.lineHeight;
    var currentHeight = current.fontSize * current.lineHeight;
    var previousCaps = previous.fontSize - previous.capHeight;
    var currentCaps = current.fontSize - current.capHeight;
    var textHeight = previousHeight - previous.fontSize / 2 + current.fontSize / 2 - previousHeight / 2 + currentHeight / 2 - currentCaps / 2 + previousCaps / 2;
    return useMultiLineBackgrounds(calculatedProps) ? textHeight + current.backgroundPadding.top + previous.backgroundPadding.bottom : textHeight;
};
var getTSpanDy = function getTSpanDy(tspanValues, calculatedProps, i) {
    var inline = calculatedProps.inline;
    var current = getSingleValue(tspanValues, i);
    if (i && !inline) return calculateSpanDy(tspanValues, i, calculatedProps);
    else if (inline) return i === 0 ? current.backgroundPadding.top : undefined;
    else return current.backgroundPadding.top;
};
var evaluateProps = function evaluateProps(props) {
    /* Potential evaluated props are
    1) text
    2) style
    3) everything else
  */ var text = getContent(props.text, props);
    var style = getStyles(props.style, (0, _assignDefault.default)({}, props, {
        text: text
    }));
    var backgroundStyle = getBackgroundStyles(props.backgroundStyle, (0, _assignDefault.default)({}, props, {
        text: text,
        style: style
    }));
    var backgroundPadding = getBackgroundPadding((0, _assignDefault.default)({}, props, {
        text: text,
        style: style,
        backgroundStyle: backgroundStyle
    }));
    var id = _helpers.evaluateProp(props.id, props);
    return (0, _assignDefault.default)({}, props, {
        backgroundStyle: backgroundStyle,
        backgroundPadding: backgroundPadding,
        style: style,
        text: text,
        id: id
    });
};
var getCalculatedProps = function getCalculatedProps(props) {
    var ariaLabel = _helpers.evaluateProp(props.ariaLabel, props);
    var style = getSingleValue(props.style);
    var lineHeight = getLineHeight(props);
    var direction = props.direction ? _helpers.evaluateProp(props.direction, props) : "inherit";
    var textAnchor = props.textAnchor ? _helpers.evaluateProp(props.textAnchor, props) : style.textAnchor || "start";
    var verticalAnchor = props.verticalAnchor ? _helpers.evaluateProp(props.verticalAnchor, props) : style.verticalAnchor || "middle";
    var dx = props.dx ? _helpers.evaluateProp(props.dx, props) : 0;
    var dy = getDy(props, verticalAnchor, lineHeight);
    var x = props.x !== undefined ? props.x : getPosition(props, "x");
    var y = props.y !== undefined ? props.y : getPosition(props, "y");
    var transform = getTransform(props, x, y);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        lineHeight: lineHeight,
        direction: direction,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        dx: dx,
        dy: dy,
        originalDy: props.dy,
        transform: transform,
        x: x,
        y: y
    });
};
var renderLabel = function renderLabel(calculatedProps, tspanValues) {
    var ariaLabel = calculatedProps.ariaLabel, inline = calculatedProps.inline, className = calculatedProps.className, title = calculatedProps.title, events = calculatedProps.events, direction = calculatedProps.direction, text = calculatedProps.text, textAnchor = calculatedProps.textAnchor, dx = calculatedProps.dx, dy = calculatedProps.dy, transform = calculatedProps.transform, x = calculatedProps.x, y = calculatedProps.y, desc = calculatedProps.desc, id = calculatedProps.id, tabIndex = calculatedProps.tabIndex, tspanComponent = calculatedProps.tspanComponent, textComponent = calculatedProps.textComponent;
    var textProps = _objectSpread({
        "aria-label": ariaLabel,
        key: "text"
    }, events, {
        direction: direction,
        dx: dx,
        x: x,
        y: y + dy,
        transform: transform,
        className: className,
        title: title,
        desc: _helpers.evaluateProp(desc, calculatedProps),
        tabIndex: _helpers.evaluateProp(tabIndex, calculatedProps),
        id: id
    });
    var tspans = text.map(function(line, i) {
        var currentStyle = tspanValues[i].style;
        var tspanProps = {
            key: "".concat(id, "-key-").concat(i),
            x: !inline ? x : undefined,
            dx: inline ? dx + tspanValues[i].backgroundPadding.left : dx,
            dy: getTSpanDy(tspanValues, calculatedProps, i),
            textAnchor: currentStyle.textAnchor || textAnchor,
            style: currentStyle,
            children: line
        };
        return (0, _reactDefault.default).cloneElement(tspanComponent, tspanProps);
    });
    return (0, _reactDefault.default).cloneElement(textComponent, textProps, tspans);
};
var VictoryLabel = function VictoryLabel(props) {
    props = evaluateProps(props);
    if (props.text === null || props.text === undefined) return null;
    var calculatedProps = getCalculatedProps(props);
    var text = calculatedProps.text, style = calculatedProps.style, capHeight = calculatedProps.capHeight, backgroundPadding = calculatedProps.backgroundPadding, lineHeight = calculatedProps.lineHeight;
    var tspanValues = text.map(function(line, i) {
        var currentStyle = getSingleValue(style, i);
        var capHeightPx = _textsize.convertLengthToPixels("".concat(capHeight, "em"), currentStyle.fontSize);
        var currentLineHeight = getSingleValue(lineHeight, i);
        return {
            style: currentStyle,
            fontSize: currentStyle.fontSize || defaultStyles.fontSize,
            capHeight: capHeightPx,
            text: line,
            textSize: _textsize.approximateTextSize(line, currentStyle),
            lineHeight: currentLineHeight,
            backgroundPadding: getSingleValue(backgroundPadding, i)
        };
    });
    var label = renderLabel(calculatedProps, tspanValues);
    if (props.backgroundStyle) {
        var backgroundElement = getBackgroundElement(calculatedProps, tspanValues);
        var children = [
            backgroundElement,
            label
        ];
        var backgroundWithLabel = (0, _reactDefault.default).cloneElement(props.groupComponent, {}, children);
        return props.renderInPortal ? (0, _reactDefault.default).createElement((0, _victoryPortalDefault.default), null, backgroundWithLabel) : backgroundWithLabel;
    }
    return props.renderInPortal ? (0, _reactDefault.default).createElement((0, _victoryPortalDefault.default), null, label) : label;
};
VictoryLabel.displayName = "VictoryLabel";
VictoryLabel.role = "label";
VictoryLabel.defaultStyles = defaultStyles;
VictoryLabel.propTypes = {
    active: (0, _propTypesDefault.default).bool,
    angle: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    ariaLabel: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    backgroundComponent: (0, _propTypesDefault.default).element,
    backgroundPadding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array
    ]),
    backgroundStyle: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array
    ]),
    capHeight: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        _propTypes1.nonNegative,
        (0, _propTypesDefault.default).func
    ]),
    className: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).array,
    datum: (0, _propTypesDefault.default).any,
    desc: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    direction: (0, _propTypesDefault.default).oneOf([
        "rtl",
        "ltr",
        "inherit"
    ]),
    dx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    dy: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    events: (0, _propTypesDefault.default).object,
    groupComponent: (0, _propTypesDefault.default).element,
    id: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    index: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    inline: (0, _propTypesDefault.default).bool,
    labelPlacement: (0, _propTypesDefault.default).oneOf([
        "parallel",
        "perpendicular",
        "vertical"
    ]),
    lineHeight: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        _propTypes1.nonNegative,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).array
    ]),
    origin: (0, _propTypesDefault.default).shape({
        x: _propTypes1.nonNegative,
        y: _propTypes1.nonNegative
    }),
    polar: (0, _propTypesDefault.default).bool,
    renderInPortal: (0, _propTypesDefault.default).bool,
    scale: (0, _propTypesDefault.default).shape({
        x: _propTypes1.scale,
        y: _propTypes1.scale
    }),
    style: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array
    ]),
    tabIndex: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    text: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).array
    ]),
    textAnchor: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            "start",
            "middle",
            "end",
            "inherit"
        ]),
        (0, _propTypesDefault.default).func
    ]),
    textComponent: (0, _propTypesDefault.default).element,
    title: (0, _propTypesDefault.default).string,
    transform: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ]),
    tspanComponent: (0, _propTypesDefault.default).element,
    verticalAnchor: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            "start",
            "middle",
            "end"
        ]),
        (0, _propTypesDefault.default).func
    ]),
    x: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    y: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ])
};
VictoryLabel.defaultProps = {
    backgroundComponent: (0, _reactDefault.default).createElement((0, _rectDefault.default), null),
    groupComponent: (0, _reactDefault.default).createElement("g", null),
    direction: "inherit",
    textComponent: (0, _reactDefault.default).createElement((0, _textDefault.default), null),
    tspanComponent: (0, _reactDefault.default).createElement((0, _tspanDefault.default), null),
    capHeight: 0.71,
    // Magic number from d3.
    lineHeight: 1
};
exports.default = VictoryLabel;

},{"lodash/isEmpty":"15wZF","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-portal/victory-portal":"hi7RY","../victory-primitives/rect":"3KA3C","../victory-util/prop-types":"88bb9","../victory-util/helpers":"8ABme","../victory-util/label-helpers":"6P27s","../victory-util/style":"aPnOz","../victory-util/log":"dgIVr","../victory-util/textsize":"iUBgJ","../victory-primitives/tspan":"gH14S","../victory-primitives/text":"bjYnd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hi7RY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictoryPortal;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _log = require("../victory-util/log");
var _helpers = require("../victory-util/helpers");
var _portalContext = require("./portal-context");
var _portalContextDefault = parcelHelpers.interopDefault(_portalContext);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var VictoryPortal = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryPortal, _React$Component);
    function VictoryPortal() {
        _classCallCheck(this, VictoryPortal);
        return _possibleConstructorReturn(this, (VictoryPortal.__proto__ || Object.getPrototypeOf(VictoryPortal)).apply(this, arguments));
    }
    _createClass(VictoryPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.checkedContext) {
                    if (typeof this.context.portalUpdate !== "function") {
                        var msg = "`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place";
                        _log.warn(msg);
                        this.renderInPlace = true;
                    }
                    this.checkedContext = true;
                }
                this.forceUpdate();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.renderInPlace) {
                    this.portalKey = this.portalKey || this.context.portalRegister();
                    this.context.portalUpdate(this.portalKey, this.element);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.context && this.context.portalDeregister) this.context.portalDeregister(this.portalKey);
            } // Overridden in victory-core-native
        },
        {
            key: "renderPortal",
            value: function renderPortal(child) {
                if (this.renderInPlace) return child;
                this.element = child;
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
                var groupComponent = this.props.groupComponent;
                var childProps = children && children.props || {};
                var standardProps = childProps.groupComponent ? {
                    groupComponent: groupComponent,
                    standalone: false
                } : {};
                var newProps = (0, _defaultsDefault.default)(standardProps, childProps, _helpers.omit(this.props, [
                    "children",
                    "groupComponent"
                ]));
                var child = children && (0, _reactDefault.default).cloneElement(children, newProps);
                return this.renderPortal(child);
            }
        }
    ]);
    return VictoryPortal;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryPortal, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryPortal"
});
Object.defineProperty(VictoryPortal, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "portal"
});
Object.defineProperty(VictoryPortal, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        children: (0, _propTypesDefault.default).node,
        groupComponent: (0, _propTypesDefault.default).element
    }
});
Object.defineProperty(VictoryPortal, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        groupComponent: (0, _reactDefault.default).createElement("g", null)
    }
});
Object.defineProperty(VictoryPortal, "contextType", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _portalContextDefault.default)
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/defaults":"eWhnr","react":"gVheC","prop-types":"3KNJy","../victory-util/log":"dgIVr","../victory-util/helpers":"8ABme","./portal-context":"1m20y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KA3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var Rect = function Rect(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = _objectWithoutProperties(props, [
        "desc"
    ]);
    return desc ? (0, _reactDefault.default).createElement("rect", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), (0, _reactDefault.default).createElement("desc", null, desc)) : (0, _reactDefault.default).createElement("rect", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};
exports.default = Rect;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6P27s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getText", function() {
    return getText;
});
parcelHelpers.export(exports, "getPolarTextAnchor", function() {
    return getPolarTextAnchor;
});
parcelHelpers.export(exports, "getPolarVerticalAnchor", function() {
    return getPolarVerticalAnchor;
});
parcelHelpers.export(exports, "getPolarAngle", function() {
    return getPolarAngle;
});
parcelHelpers.export(exports, "getDegrees", function() {
    return getDegrees;
});
parcelHelpers.export(exports, "getProps", function() {
    return getProps;
});
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ var _helpers = require("./helpers");
// Private Functions
function getVerticalAnchor(props, datum) {
    datum = datum || {};
    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = props.style && props.style.labels || {};
    if (datum.verticalAnchor || labelStyle.verticalAnchor) return datum.verticalAnchor || labelStyle.verticalAnchor;
    else if (!props.horizontal) return sign >= 0 ? "end" : "start";
    else return "middle";
}
function getTextAnchor(props, datum) {
    datum = datum || {};
    var style = props.style, horizontal = props.horizontal;
    var sign = datum._y >= 0 ? 1 : -1;
    var labelStyle = style && style.labels || {};
    if (datum.verticalAnchor || labelStyle.verticalAnchor) return datum.verticalAnchor || labelStyle.verticalAnchor;
    else if (!horizontal) return "middle";
    else return sign >= 0 ? "start" : "end";
}
function getAngle(props, datum) {
    datum = datum || {};
    var labelStyle = props.style && props.style.labels || {};
    return datum.angle === undefined ? labelStyle.angle : datum.angle;
}
function getPadding(props, datum) {
    datum = datum || {};
    var horizontal = props.horizontal, style = props.style;
    var labelStyle = style.labels || {};
    var defaultPadding = _helpers.evaluateProp(labelStyle.padding, props) || 0;
    var sign = datum._y < 0 ? -1 : 1;
    return {
        x: horizontal ? sign * defaultPadding : 0,
        y: horizontal ? 0 : -1 * sign * defaultPadding
    };
}
function getOffset(props, datum) {
    if (props.polar) return {};
    var padding = getPadding(props, datum);
    return {
        dx: padding.x,
        dy: padding.y
    };
}
function getPosition(props, datum) {
    var polar = props.polar;
    var _Helpers$scalePoint = _helpers.scalePoint(props, datum), x = _Helpers$scalePoint.x, y = _Helpers$scalePoint.y;
    if (!polar) return {
        x: x,
        y: y
    };
    else {
        var polarPadding = getPolarPadding(props, datum);
        return {
            x: x + polarPadding.x,
            y: y + polarPadding.y
        };
    }
}
function getPolarPadding(props, datum) {
    var style = props.style;
    var degrees = getDegrees(props, datum);
    var labelStyle = style.labels || {};
    var padding = _helpers.evaluateProp(labelStyle.padding, props) || 0;
    var angle = _helpers.degreesToRadians(degrees);
    return {
        x: padding * Math.cos(angle),
        y: -padding * Math.sin(angle)
    };
}
function getLabelPlacement(props) {
    var labelComponent = props.labelComponent, labelPlacement = props.labelPlacement, polar = props.polar;
    var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
    return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
}
function getPolarOrientation(degrees) {
    // eslint-disable-next-line no-magic-numbers
    if (degrees < 45 || degrees > 315) return "right"; // eslint-disable-next-line no-magic-numbers
    else if (degrees >= 45 && degrees <= 135) return "top"; // eslint-disable-next-line no-magic-numbers
    else if (degrees > 135 && degrees < 225) return "left";
    else return "bottom";
} // Exported Functions
function getText(props, datum, index) {
    datum = datum || {};
    if (datum.label !== undefined) return datum.label;
    return Array.isArray(props.labels) ? props.labels[index] : props.labels;
}
function getPolarTextAnchor(props, degrees) {
    var labelPlacement = getLabelPlacement(props);
    if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) return "middle";
    return degrees <= 90 || degrees > 270 ? "start" : "end";
}
function getPolarVerticalAnchor(props, degrees) {
    var labelPlacement = getLabelPlacement(props);
    var orientation = getPolarOrientation(degrees);
    if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") return "middle";
    return orientation === "top" ? "end" : "start";
}
function getPolarAngle(props, baseAngle) {
    var labelPlacement = props.labelPlacement, datum = props.datum;
    if (!labelPlacement || labelPlacement === "vertical") return 0;
    var degrees = baseAngle !== undefined ? baseAngle % 360 : getDegrees(props, datum);
    var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
    var angle = 0;
    if (degrees === 0 || degrees === 180) angle = 90;
    else if (degrees > 0 && degrees < 180) angle = 90 - degrees;
    else if (degrees > 180 && degrees < 360) angle = 270 - degrees;
    var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
    return angle + sign * labelRotation;
}
function getDegrees(props, datum) {
    var _Helpers$getPoint = _helpers.getPoint(datum), x = _Helpers$getPoint.x;
    return _helpers.radiansToDegrees(props.scale.x(x)) % 360;
}
function getProps(props, index) {
    var scale = props.scale, data = props.data, style = props.style, horizontal = props.horizontal, polar = props.polar, width = props.width, height = props.height, theme = props.theme, labelComponent = props.labelComponent, disableInlineStyles = props.disableInlineStyles;
    var datum = data[index];
    var degrees = getDegrees(props, datum);
    var textAnchor = polar ? getPolarTextAnchor(props, degrees) : getTextAnchor(props, datum);
    var verticalAnchor = polar ? getPolarVerticalAnchor(props, degrees) : getVerticalAnchor(props, datum);
    var angle = getAngle(props, datum);
    var text = getText(props, datum, index);
    var labelPlacement = getLabelPlacement(props);
    var _getPosition = getPosition(props, datum), x = _getPosition.x, y = _getPosition.y;
    var _getOffset = getOffset(props, datum), dx = _getOffset.dx, dy = _getOffset.dy;
    var labelProps = {
        angle: angle,
        data: data,
        datum: datum,
        disableInlineStyles: disableInlineStyles,
        horizontal: horizontal,
        index: index,
        polar: polar,
        scale: scale,
        labelPlacement: labelPlacement,
        text: text,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        width: width,
        height: height,
        style: style.labels
    };
    if (!_helpers.isTooltip(labelComponent)) return labelProps;
    var tooltipTheme = theme && theme.tooltip || {};
    return (0, _defaultsDefault.default)({}, labelProps, _helpers.omit(tooltipTheme, [
        "style"
    ]));
}

},{"lodash/defaults":"eWhnr","./helpers":"8ABme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPnOz":[function(require,module,exports,__globalThis) {
/* eslint-disable func-style */ /**
 * Given an object with CSS/SVG transform definitions, return the string value
 * for use with the `transform` CSS property or SVG attribute. Note that we
 * can't always guarantee the order will match the author's intended order, so
 * authors should only use the object notation if they know that their transform
 * is commutative or that there is only one.
 * @param {Object} obj An object of transform definitions.
 * @returns {String} The generated transform string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toTransformString", function() {
    return toTransformString;
});
/**
 * Given the name of a color scale, getColorScale will return an array
 * of 5 hex string values in that color scale. If no 'name' parameter
 * is given, it will return the Victory default grayscale.
 * @param {String} name The name of the color scale to return (optional).
 * @returns {Array} An array of 5 hex string values composing a color scale.
 */ parcelHelpers.export(exports, "getColorScale", function() {
    return getColorScale;
});
var toTransformString = function toTransformString1(obj) {
    for(var _len = arguments.length, more = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)more[_key - 1] = arguments[_key];
    if (more.length > 0) return more.reduce(function(memo, currentObj) {
        return [
            memo,
            toTransformString(currentObj)
        ].join(" ");
    }, toTransformString(obj)).trim();
    else {
        if (obj === undefined || obj === null || typeof obj === "string") return obj;
        var transforms = [];
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            var value = obj[key];
            transforms.push("".concat(key, "(").concat(value, ")"));
        }
        return transforms.join(" ").trim();
    }
};
function getColorScale(name) {
    var scales = {
        grayscale: [
            "#cccccc",
            "#969696",
            "#636363",
            "#252525"
        ],
        qualitative: [
            "#334D5C",
            "#45B29D",
            "#EFC94C",
            "#E27A3F",
            "#DF5A49",
            "#4F7DA1",
            "#55DBC1",
            "#EFDA97",
            "#E2A37F",
            "#DF948A"
        ],
        heatmap: [
            "#428517",
            "#77D200",
            "#D6D305",
            "#EC8E19",
            "#C92B05"
        ],
        warm: [
            "#940031",
            "#C43343",
            "#DC5429",
            "#FF821D",
            "#FFAF55"
        ],
        cool: [
            "#2746B9",
            "#0B69D4",
            "#2794DB",
            "#31BB76",
            "#60E83B"
        ],
        red: [
            "#FCAE91",
            "#FB6A4A",
            "#DE2D26",
            "#A50F15",
            "#750B0E"
        ],
        blue: [
            "#002C61",
            "#004B8F",
            "#006BC9",
            "#3795E5",
            "#65B4F4"
        ],
        green: [
            "#354722",
            "#466631",
            "#649146",
            "#8AB25C",
            "#A9C97E"
        ]
    };
    return name ? scales[name] : scales.grayscale;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iUBgJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertLengthToPixels", function() {
    return convertLengthToPixels;
});
parcelHelpers.export(exports, "_approximateTextSizeInternal", function() {
    return _approximateTextSizeInternal;
});
parcelHelpers.export(exports, "approximateTextSize", function() {
    return approximateTextSize;
});
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
// Based on measuring specific character widths
// as in the following example https://bl.ocks.org/tophtucker/62f93a4658387bb61e4510c37e2e97cf
//prettier-ignore
var fonts = {
    "American Typewriter": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.4203125,
            0.3296875,
            0.6,
            0.6375,
            0.8015625,
            0.8203125,
            0.1875,
            0.45625,
            0.45625,
            0.6375,
            0.5,
            0.2734375,
            0.309375,
            0.2734375,
            0.4390625,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.6375,
            0.2734375,
            0.2734375,
            0.5,
            0.5,
            0.5,
            0.6,
            0.6921875,
            0.7640625,
            0.6921875,
            0.6375,
            0.728125,
            0.6734375,
            0.6203125,
            0.7109375,
            0.784375,
            0.3828125,
            0.6421875,
            0.7859375,
            0.6375,
            0.9484375,
            0.7640625,
            0.65625,
            0.6375,
            0.65625,
            0.7296875,
            0.6203125,
            0.6375,
            0.7109375,
            0.740625,
            0.940625,
            0.784375,
            0.7578125,
            0.6203125,
            0.4375,
            0.5,
            0.4375,
            0.5,
            0.5,
            0.4921875,
            0.5734375,
            0.5890625,
            0.5109375,
            0.6,
            0.528125,
            0.43125,
            0.5578125,
            0.6375,
            0.3109375,
            0.40625,
            0.6234375,
            0.309375,
            0.928125,
            0.6375,
            0.546875,
            0.6,
            0.58125,
            0.4921875,
            0.4921875,
            0.4,
            0.6203125,
            0.625,
            0.825,
            0.6375,
            0.640625,
            0.528125,
            0.5,
            0.5,
            0.5,
            0.6671875
        ],
        avg: 0.5793421052631578
    },
    Arial: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.278125,
            0.35625,
            0.55625,
            0.55625,
            0.890625,
            0.6671875,
            0.1921875,
            0.334375,
            0.334375,
            0.390625,
            0.584375,
            0.278125,
            0.334375,
            0.278125,
            0.278125,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.584375,
            0.584375,
            0.584375,
            0.55625,
            1.015625,
            0.6703125,
            0.6671875,
            0.7234375,
            0.7234375,
            0.6671875,
            0.6109375,
            0.778125,
            0.7234375,
            0.278125,
            0.5,
            0.6671875,
            0.55625,
            0.834375,
            0.7234375,
            0.778125,
            0.6671875,
            0.778125,
            0.7234375,
            0.6671875,
            0.6109375,
            0.7234375,
            0.6671875,
            0.9453125,
            0.6671875,
            0.6671875,
            0.6109375,
            0.278125,
            0.278125,
            0.278125,
            0.4703125,
            0.584375,
            0.334375,
            0.55625,
            0.55625,
            0.5,
            0.55625,
            0.55625,
            0.3125,
            0.55625,
            0.55625,
            0.2234375,
            0.2703125,
            0.5,
            0.2234375,
            0.834375,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.346875,
            0.5,
            0.278125,
            0.55625,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.5,
            0.334375,
            0.2609375,
            0.334375,
            0.584375
        ],
        avg: 0.528733552631579
    },
    "Arial Black": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.33125,
            0.334375,
            0.5,
            0.6609375,
            0.6671875,
            1,
            0.890625,
            0.278125,
            0.390625,
            0.390625,
            0.55625,
            0.6609375,
            0.334375,
            0.334375,
            0.334375,
            0.28125,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.334375,
            0.334375,
            0.6609375,
            0.6609375,
            0.6609375,
            0.6109375,
            0.7453125,
            0.78125,
            0.778125,
            0.778125,
            0.778125,
            0.7234375,
            0.6671875,
            0.834375,
            0.834375,
            0.390625,
            0.6671875,
            0.834375,
            0.6671875,
            0.9453125,
            0.834375,
            0.834375,
            0.7234375,
            0.834375,
            0.78125,
            0.7234375,
            0.7234375,
            0.834375,
            0.7796875,
            1.003125,
            0.78125,
            0.78125,
            0.7234375,
            0.390625,
            0.28125,
            0.390625,
            0.6609375,
            0.5125,
            0.334375,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.41875,
            0.6671875,
            0.6671875,
            0.334375,
            0.384375,
            0.6671875,
            0.334375,
            1,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.4703125,
            0.6109375,
            0.4453125,
            0.6671875,
            0.6140625,
            0.946875,
            0.6671875,
            0.615625,
            0.55625,
            0.390625,
            0.278125,
            0.390625,
            0.6609375
        ],
        avg: 0.6213157894736842
    },
    Baskerville: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.25,
            0.40625,
            0.6671875,
            0.490625,
            0.875,
            0.7015625,
            0.178125,
            0.2453125,
            0.246875,
            0.4171875,
            0.6671875,
            0.25,
            0.3125,
            0.25,
            0.521875,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.25,
            0.25,
            0.6671875,
            0.6671875,
            0.6671875,
            0.396875,
            0.9171875,
            0.684375,
            0.615625,
            0.71875,
            0.7609375,
            0.625,
            0.553125,
            0.771875,
            0.803125,
            0.3546875,
            0.515625,
            0.78125,
            0.6046875,
            0.928125,
            0.75,
            0.8234375,
            0.5625,
            0.96875,
            0.7296875,
            0.5421875,
            0.6984375,
            0.771875,
            0.7296875,
            0.9484375,
            0.771875,
            0.678125,
            0.6359375,
            0.3640625,
            0.521875,
            0.3640625,
            0.46875,
            0.5125,
            0.334375,
            0.46875,
            0.521875,
            0.428125,
            0.521875,
            0.4375,
            0.3890625,
            0.4765625,
            0.53125,
            0.25,
            0.359375,
            0.4640625,
            0.240625,
            0.803125,
            0.53125,
            0.5,
            0.521875,
            0.521875,
            0.365625,
            0.334375,
            0.2921875,
            0.521875,
            0.4640625,
            0.678125,
            0.4796875,
            0.465625,
            0.428125,
            0.4796875,
            0.5109375,
            0.4796875,
            0.6671875
        ],
        avg: 0.5323519736842108
    },
    Courier: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6078125,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.61875,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.615625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6140625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6020559210526316
    },
    "Courier New": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6015296052631579
    },
    cursive: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.1921875,
            0.24375,
            0.40625,
            0.5671875,
            0.3984375,
            0.721875,
            0.909375,
            0.2328125,
            0.434375,
            0.365625,
            0.4734375,
            0.5578125,
            0.19375,
            0.3484375,
            0.19375,
            0.7734375,
            0.503125,
            0.4171875,
            0.5453125,
            0.45,
            0.6046875,
            0.4703125,
            0.5984375,
            0.55625,
            0.503125,
            0.5546875,
            0.20625,
            0.2,
            0.5625,
            0.5546875,
            0.546875,
            0.403125,
            0.70625,
            0.734375,
            0.7078125,
            0.64375,
            0.85,
            0.753125,
            0.75,
            0.6484375,
            1.0765625,
            0.44375,
            0.5359375,
            0.8359375,
            0.653125,
            1.0109375,
            1.1515625,
            0.6796875,
            0.6984375,
            1.0625,
            0.8234375,
            0.5125,
            0.9234375,
            0.8546875,
            0.70625,
            0.9109375,
            0.7421875,
            0.715625,
            0.6015625,
            0.4640625,
            0.3359375,
            0.4109375,
            0.5421875,
            0.5421875,
            0.4328125,
            0.5125,
            0.5,
            0.3859375,
            0.7375,
            0.359375,
            0.75625,
            0.540625,
            0.5328125,
            0.3203125,
            0.5296875,
            0.5015625,
            0.484375,
            0.7890625,
            0.5640625,
            0.4203125,
            0.703125,
            0.471875,
            0.4734375,
            0.35,
            0.4125,
            0.5640625,
            0.471875,
            0.6484375,
            0.5296875,
            0.575,
            0.4140625,
            0.415625,
            0.20625,
            0.3796875,
            0.5421875
        ],
        avg: 0.5604440789473684
    },
    fantasy: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.215625,
            0.2625,
            0.3265625,
            0.6109375,
            0.534375,
            0.7625,
            0.7828125,
            0.2,
            0.4359375,
            0.4359375,
            0.3765625,
            0.5109375,
            0.2796875,
            0.4609375,
            0.2796875,
            0.5296875,
            0.6640625,
            0.253125,
            0.521875,
            0.4765625,
            0.6640625,
            0.490625,
            0.528125,
            0.5546875,
            0.496875,
            0.5421875,
            0.2796875,
            0.2796875,
            0.5625,
            0.4609375,
            0.5625,
            0.4828125,
            0.609375,
            0.740625,
            0.7234375,
            0.740625,
            0.8265625,
            0.7234375,
            0.6171875,
            0.7359375,
            0.765625,
            0.240625,
            0.5453125,
            0.715625,
            0.6078125,
            0.8640625,
            0.653125,
            0.9125,
            0.6484375,
            0.946875,
            0.6921875,
            0.653125,
            0.6953125,
            0.8015625,
            0.58125,
            0.784375,
            0.671875,
            0.6265625,
            0.690625,
            0.4359375,
            0.5296875,
            0.4359375,
            0.53125,
            0.5,
            0.2875,
            0.5375,
            0.603125,
            0.4984375,
            0.60625,
            0.53125,
            0.434375,
            0.6421875,
            0.56875,
            0.209375,
            0.4671875,
            0.5484375,
            0.2203125,
            0.709375,
            0.55,
            0.5984375,
            0.6140625,
            0.5765625,
            0.40625,
            0.4734375,
            0.3734375,
            0.559375,
            0.4421875,
            0.6421875,
            0.4890625,
            0.578125,
            0.4484375,
            0.2546875,
            0.2203125,
            0.2546875,
            0.55
        ],
        avg: 0.536496710526316
    },
    Geneva: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3328125,
            0.3046875,
            0.5,
            0.6671875,
            0.6671875,
            0.90625,
            0.728125,
            0.3046875,
            0.446875,
            0.446875,
            0.5078125,
            0.6671875,
            0.3046875,
            0.3796875,
            0.3046875,
            0.5390625,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.3046875,
            0.3046875,
            0.6671875,
            0.6671875,
            0.6671875,
            0.56875,
            0.871875,
            0.728125,
            0.6375,
            0.6515625,
            0.7015625,
            0.5765625,
            0.5546875,
            0.675,
            0.690625,
            0.2421875,
            0.4921875,
            0.6640625,
            0.584375,
            0.7890625,
            0.709375,
            0.7359375,
            0.584375,
            0.78125,
            0.60625,
            0.60625,
            0.640625,
            0.6671875,
            0.728125,
            0.946875,
            0.6109375,
            0.6109375,
            0.5765625,
            0.446875,
            0.5390625,
            0.446875,
            0.6671875,
            0.6671875,
            0.5921875,
            0.5546875,
            0.6109375,
            0.546875,
            0.603125,
            0.5765625,
            0.390625,
            0.6109375,
            0.584375,
            0.2359375,
            0.334375,
            0.5390625,
            0.2359375,
            0.8953125,
            0.584375,
            0.60625,
            0.603125,
            0.603125,
            0.3875,
            0.509375,
            0.44375,
            0.584375,
            0.565625,
            0.78125,
            0.53125,
            0.571875,
            0.5546875,
            0.4515625,
            0.246875,
            0.4515625,
            0.6671875
        ],
        avg: 0.5762664473684211
    },
    Georgia: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2421875,
            0.33125,
            0.4125,
            0.64375,
            0.6109375,
            0.81875,
            0.7109375,
            0.215625,
            0.375,
            0.375,
            0.4734375,
            0.64375,
            0.2703125,
            0.375,
            0.2703125,
            0.46875,
            0.6140625,
            0.4296875,
            0.559375,
            0.553125,
            0.565625,
            0.5296875,
            0.5671875,
            0.503125,
            0.596875,
            0.5671875,
            0.3125,
            0.3125,
            0.64375,
            0.64375,
            0.64375,
            0.4796875,
            0.9296875,
            0.715625,
            0.6546875,
            0.6421875,
            0.75,
            0.6546875,
            0.6,
            0.7265625,
            0.815625,
            0.390625,
            0.51875,
            0.7203125,
            0.6046875,
            0.928125,
            0.7671875,
            0.7453125,
            0.6109375,
            0.7453125,
            0.7234375,
            0.5625,
            0.61875,
            0.7578125,
            0.70625,
            0.99375,
            0.7125,
            0.6640625,
            0.6015625,
            0.375,
            0.46875,
            0.375,
            0.64375,
            0.65,
            0.5,
            0.5046875,
            0.56875,
            0.4546875,
            0.575,
            0.484375,
            0.39375,
            0.509375,
            0.5828125,
            0.29375,
            0.3671875,
            0.546875,
            0.2875,
            0.88125,
            0.5921875,
            0.5390625,
            0.571875,
            0.5640625,
            0.4109375,
            0.4328125,
            0.3453125,
            0.5765625,
            0.5203125,
            0.75625,
            0.50625,
            0.5171875,
            0.4453125,
            0.43125,
            0.375,
            0.43125,
            0.64375
        ],
        avg: 0.5551809210526316
    },
    "Gill Sans": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2765625,
            0.271875,
            0.3546875,
            0.584375,
            0.5421875,
            0.6765625,
            0.625,
            0.1890625,
            0.3234375,
            0.3234375,
            0.4171875,
            0.584375,
            0.2203125,
            0.3234375,
            0.2203125,
            0.28125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.2203125,
            0.2296875,
            0.584375,
            0.584375,
            0.584375,
            0.334375,
            1.0109375,
            0.6671875,
            0.5640625,
            0.709375,
            0.75,
            0.5,
            0.4703125,
            0.740625,
            0.7296875,
            0.25,
            0.3125,
            0.65625,
            0.490625,
            0.78125,
            0.78125,
            0.8234375,
            0.5109375,
            0.8234375,
            0.6046875,
            0.459375,
            0.6046875,
            0.709375,
            0.6046875,
            1.0421875,
            0.709375,
            0.6046875,
            0.646875,
            0.334375,
            0.28125,
            0.334375,
            0.4703125,
            0.5828125,
            0.334375,
            0.428125,
            0.5,
            0.4390625,
            0.5109375,
            0.4796875,
            0.296875,
            0.428125,
            0.5,
            0.2203125,
            0.2265625,
            0.5,
            0.2203125,
            0.771875,
            0.5,
            0.553125,
            0.5,
            0.5,
            0.3984375,
            0.3859375,
            0.334375,
            0.5,
            0.4390625,
            0.7203125,
            0.5,
            0.4390625,
            0.4171875,
            0.334375,
            0.2609375,
            0.334375,
            0.584375
        ],
        avg: 0.4933717105263159
    },
    Helvetica: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2796875,
            0.2765625,
            0.3546875,
            0.5546875,
            0.5546875,
            0.8890625,
            0.665625,
            0.190625,
            0.3328125,
            0.3328125,
            0.3890625,
            0.5828125,
            0.2765625,
            0.3328125,
            0.2765625,
            0.3015625,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.2765625,
            0.2765625,
            0.584375,
            0.5828125,
            0.584375,
            0.5546875,
            1.0140625,
            0.665625,
            0.665625,
            0.721875,
            0.721875,
            0.665625,
            0.609375,
            0.7765625,
            0.721875,
            0.2765625,
            0.5,
            0.665625,
            0.5546875,
            0.8328125,
            0.721875,
            0.7765625,
            0.665625,
            0.7765625,
            0.721875,
            0.665625,
            0.609375,
            0.721875,
            0.665625,
            0.94375,
            0.665625,
            0.665625,
            0.609375,
            0.2765625,
            0.3546875,
            0.2765625,
            0.4765625,
            0.5546875,
            0.3328125,
            0.5546875,
            0.5546875,
            0.5,
            0.5546875,
            0.5546875,
            0.2765625,
            0.5546875,
            0.5546875,
            0.221875,
            0.240625,
            0.5,
            0.221875,
            0.8328125,
            0.5546875,
            0.5546875,
            0.5546875,
            0.5546875,
            0.3328125,
            0.5,
            0.2765625,
            0.5546875,
            0.5,
            0.721875,
            0.5,
            0.5,
            0.5,
            0.3546875,
            0.259375,
            0.353125,
            0.5890625
        ],
        avg: 0.5279276315789471
    },
    "Helvetica Neue": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.259375,
            0.4265625,
            0.55625,
            0.55625,
            1,
            0.6453125,
            0.278125,
            0.2703125,
            0.26875,
            0.353125,
            0.6,
            0.278125,
            0.3890625,
            0.278125,
            0.36875,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.6,
            0.6,
            0.6,
            0.55625,
            0.8,
            0.6625,
            0.6859375,
            0.7234375,
            0.7046875,
            0.6125,
            0.575,
            0.759375,
            0.7234375,
            0.259375,
            0.5203125,
            0.6703125,
            0.55625,
            0.871875,
            0.7234375,
            0.7609375,
            0.6484375,
            0.7609375,
            0.6859375,
            0.6484375,
            0.575,
            0.7234375,
            0.6140625,
            0.9265625,
            0.6125,
            0.6484375,
            0.6125,
            0.259375,
            0.36875,
            0.259375,
            0.6,
            0.5,
            0.25625,
            0.5375,
            0.59375,
            0.5375,
            0.59375,
            0.5375,
            0.2984375,
            0.575,
            0.55625,
            0.2234375,
            0.2375,
            0.5203125,
            0.2234375,
            0.853125,
            0.55625,
            0.575,
            0.59375,
            0.59375,
            0.334375,
            0.5,
            0.315625,
            0.55625,
            0.5,
            0.759375,
            0.51875,
            0.5,
            0.48125,
            0.334375,
            0.2234375,
            0.334375,
            0.6
        ],
        avg: 0.5279440789473684
    },
    "Hoefler Text": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2359375,
            0.2234375,
            0.3921875,
            0.7125,
            0.49375,
            0.8859375,
            0.771875,
            0.2125,
            0.3078125,
            0.309375,
            0.375,
            0.4234375,
            0.234375,
            0.3125,
            0.234375,
            0.3,
            0.5828125,
            0.365625,
            0.434375,
            0.3921875,
            0.5234375,
            0.3984375,
            0.5125,
            0.4328125,
            0.46875,
            0.5125,
            0.234375,
            0.234375,
            0.515625,
            0.4234375,
            0.515625,
            0.340625,
            0.7609375,
            0.7359375,
            0.6359375,
            0.721875,
            0.8125,
            0.6375,
            0.5875,
            0.8078125,
            0.853125,
            0.4296875,
            0.503125,
            0.78125,
            0.609375,
            0.9609375,
            0.8515625,
            0.8140625,
            0.6125,
            0.8140625,
            0.71875,
            0.49375,
            0.7125,
            0.76875,
            0.771875,
            1.125,
            0.7765625,
            0.7734375,
            0.65625,
            0.321875,
            0.3078125,
            0.321875,
            0.3546875,
            0.5,
            0.3375,
            0.446875,
            0.5359375,
            0.45,
            0.5296875,
            0.4546875,
            0.425,
            0.4921875,
            0.54375,
            0.2671875,
            0.240625,
            0.5390625,
            0.25,
            0.815625,
            0.5375,
            0.5234375,
            0.5390625,
            0.5421875,
            0.365625,
            0.36875,
            0.35625,
            0.5171875,
            0.5015625,
            0.75,
            0.5,
            0.509375,
            0.44375,
            0.2421875,
            0.14375,
            0.2421875,
            0.35
        ],
        avg: 0.5116447368421051
    },
    "Montserrat": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2625,
            0.2609375,
            0.3734375,
            0.696875,
            0.615625,
            0.8296875,
            0.6703125,
            0.203125,
            0.3296875,
            0.3296875,
            0.3875,
            0.575,
            0.2125,
            0.3828125,
            0.2125,
            0.3953125,
            0.6625,
            0.3625,
            0.56875,
            0.5640625,
            0.6625,
            0.5671875,
            0.609375,
            0.5890625,
            0.6390625,
            0.609375,
            0.2125,
            0.2125,
            0.575,
            0.575,
            0.575,
            0.5671875,
            1.034375,
            0.7171875,
            0.7546875,
            0.7203125,
            0.8265625,
            0.6703125,
            0.634375,
            0.7734375,
            0.8140625,
            0.303125,
            0.5078125,
            0.7125,
            0.5890625,
            0.95625,
            0.8140625,
            0.8390625,
            0.71875,
            0.8390625,
            0.7234375,
            0.615625,
            0.575,
            0.7921875,
            0.6984375,
            1.1125,
            0.65625,
            0.6359375,
            0.6515625,
            0.31875,
            0.396875,
            0.31875,
            0.5765625,
            0.5,
            0.6,
            0.590625,
            0.678125,
            0.5640625,
            0.678125,
            0.6046875,
            0.375,
            0.6875,
            0.678125,
            0.2703125,
            0.365625,
            0.6015625,
            0.2703125,
            1.0625,
            0.678125,
            0.628125,
            0.678125,
            0.678125,
            0.4015625,
            0.4890625,
            0.40625,
            0.6734375,
            0.5421875,
            0.8796875,
            0.534375,
            0.5671875,
            0.5125,
            0.334375,
            0.2953125,
            0.334375,
            0.575
        ],
        avg: 0.571792763157895
    },
    monospace: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.5984375,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6078125,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.61875,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.615625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6140625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625,
            0.6015625
        ],
        avg: 0.6020559210526316
    },
    Overpass: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2296875,
            0.2765625,
            0.4203125,
            0.68125,
            0.584375,
            0.8515625,
            0.7015625,
            0.2203125,
            0.3453125,
            0.3453125,
            0.53125,
            0.63125,
            0.2234375,
            0.3953125,
            0.2234375,
            0.509375,
            0.65,
            0.4046875,
            0.6171875,
            0.60625,
            0.6484375,
            0.60625,
            0.6015625,
            0.5375,
            0.615625,
            0.6015625,
            0.2234375,
            0.2234375,
            0.63125,
            0.63125,
            0.63125,
            0.5015625,
            0.8203125,
            0.696875,
            0.6671875,
            0.65,
            0.6859375,
            0.6015625,
            0.559375,
            0.690625,
            0.7078125,
            0.2953125,
            0.565625,
            0.678125,
            0.58125,
            0.8046875,
            0.7109375,
            0.740625,
            0.6421875,
            0.740625,
            0.6765625,
            0.6046875,
            0.590625,
            0.696875,
            0.6640625,
            0.853125,
            0.65,
            0.6671875,
            0.6625,
            0.3734375,
            0.509375,
            0.3734375,
            0.63125,
            0.5125,
            0.4,
            0.5328125,
            0.5625,
            0.51875,
            0.5625,
            0.546875,
            0.3359375,
            0.5625,
            0.565625,
            0.25625,
            0.3203125,
            0.55,
            0.265625,
            0.85,
            0.565625,
            0.5671875,
            0.5625,
            0.5625,
            0.4046875,
            0.4765625,
            0.3796875,
            0.565625,
            0.521875,
            0.7265625,
            0.53125,
            0.5390625,
            0.5125,
            0.3671875,
            0.275,
            0.3671875,
            0.63125
        ],
        avg: 0.5430756578947369
    },
    Palatino: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.25,
            0.278125,
            0.371875,
            0.60625,
            0.5,
            0.840625,
            0.778125,
            0.209375,
            0.334375,
            0.334375,
            0.390625,
            0.60625,
            0.2578125,
            0.334375,
            0.25,
            0.60625,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.25,
            0.25,
            0.60625,
            0.60625,
            0.60625,
            0.4453125,
            0.7484375,
            0.778125,
            0.6109375,
            0.709375,
            0.775,
            0.6109375,
            0.55625,
            0.7640625,
            0.8328125,
            0.3375,
            0.346875,
            0.7265625,
            0.6109375,
            0.946875,
            0.83125,
            0.7875,
            0.6046875,
            0.7875,
            0.66875,
            0.525,
            0.6140625,
            0.778125,
            0.7234375,
            1,
            0.6671875,
            0.6671875,
            0.6671875,
            0.334375,
            0.60625,
            0.334375,
            0.60625,
            0.5,
            0.334375,
            0.5,
            0.565625,
            0.4453125,
            0.6109375,
            0.4796875,
            0.340625,
            0.55625,
            0.5828125,
            0.2921875,
            0.2671875,
            0.5640625,
            0.2921875,
            0.8828125,
            0.5828125,
            0.546875,
            0.6015625,
            0.5609375,
            0.3953125,
            0.425,
            0.3265625,
            0.603125,
            0.565625,
            0.834375,
            0.5171875,
            0.55625,
            0.5,
            0.334375,
            0.60625,
            0.334375,
            0.60625
        ],
        avg: 0.5408552631578947
    },
    "RedHatText": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2328125,
            0.2203125,
            0.35625,
            0.6890625,
            0.55,
            0.7390625,
            0.6703125,
            0.2140625,
            0.4015625,
            0.4015625,
            0.4546875,
            0.53125,
            0.2203125,
            0.45625,
            0.2203125,
            0.515625,
            0.6609375,
            0.3078125,
            0.5484375,
            0.5875,
            0.61875,
            0.5703125,
            0.6203125,
            0.559375,
            0.6140625,
            0.6203125,
            0.2203125,
            0.2234375,
            0.465625,
            0.534375,
            0.465625,
            0.5125,
            0.7671875,
            0.6609375,
            0.6703125,
            0.7265625,
            0.728125,
            0.6203125,
            0.6109375,
            0.8,
            0.73125,
            0.253125,
            0.6,
            0.6125,
            0.6078125,
            0.8625,
            0.7390625,
            0.8109375,
            0.6546875,
            0.809375,
            0.6484375,
            0.6234375,
            0.6171875,
            0.7125,
            0.6609375,
            0.8984375,
            0.6546875,
            0.646875,
            0.60625,
            0.3625,
            0.5203125,
            0.3625,
            0.540625,
            0.4609375,
            0.5234375,
            0.5265625,
            0.584375,
            0.509375,
            0.5828125,
            0.5578125,
            0.3703125,
            0.5828125,
            0.553125,
            0.2234375,
            0.24375,
            0.4890625,
            0.2234375,
            0.8453125,
            0.553125,
            0.58125,
            0.584375,
            0.5828125,
            0.353125,
            0.453125,
            0.378125,
            0.553125,
            0.5015625,
            0.6984375,
            0.4875,
            0.4984375,
            0.459375,
            0.3953125,
            0.2921875,
            0.3953125,
            0.58125
        ],
        avg: 0.5341940789473685
    },
    "sans-serif": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.278125,
            0.278125,
            0.35625,
            0.55625,
            0.55625,
            0.890625,
            0.6671875,
            0.1921875,
            0.334375,
            0.334375,
            0.390625,
            0.584375,
            0.278125,
            0.334375,
            0.278125,
            0.303125,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.278125,
            0.278125,
            0.5859375,
            0.584375,
            0.5859375,
            0.55625,
            1.015625,
            0.6671875,
            0.6671875,
            0.7234375,
            0.7234375,
            0.6671875,
            0.6109375,
            0.778125,
            0.7234375,
            0.278125,
            0.5,
            0.6671875,
            0.55625,
            0.834375,
            0.7234375,
            0.778125,
            0.6671875,
            0.778125,
            0.7234375,
            0.6671875,
            0.6109375,
            0.7234375,
            0.6671875,
            0.9453125,
            0.6671875,
            0.6671875,
            0.6109375,
            0.278125,
            0.35625,
            0.278125,
            0.478125,
            0.55625,
            0.334375,
            0.55625,
            0.55625,
            0.5,
            0.55625,
            0.55625,
            0.278125,
            0.55625,
            0.55625,
            0.2234375,
            0.2421875,
            0.5,
            0.2234375,
            0.834375,
            0.55625,
            0.55625,
            0.55625,
            0.55625,
            0.334375,
            0.5,
            0.278125,
            0.55625,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.5,
            0.35625,
            0.2609375,
            0.3546875,
            0.590625
        ],
        avg: 0.5293256578947368
    },
    Seravek: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.215625,
            0.296875,
            0.4171875,
            0.6734375,
            0.4953125,
            0.9125,
            0.740625,
            0.2421875,
            0.3375,
            0.3375,
            0.409375,
            0.60625,
            0.2609375,
            0.35625,
            0.25625,
            0.41875,
            0.5921875,
            0.3515625,
            0.475,
            0.4875,
            0.5375,
            0.509375,
            0.5484375,
            0.4546875,
            0.5421875,
            0.5484375,
            0.25625,
            0.2546875,
            0.5875,
            0.6171875,
            0.5875,
            0.4578125,
            0.8140625,
            0.6765625,
            0.5703125,
            0.6109375,
            0.684375,
            0.5109375,
            0.4953125,
            0.678125,
            0.6859375,
            0.2625,
            0.2625,
            0.5859375,
            0.4734375,
            0.846875,
            0.709375,
            0.740625,
            0.509375,
            0.740625,
            0.584375,
            0.5015625,
            0.528125,
            0.675,
            0.5953125,
            0.9453125,
            0.596875,
            0.540625,
            0.540625,
            0.359375,
            0.4203125,
            0.359375,
            0.5109375,
            0.421875,
            0.4046875,
            0.5015625,
            0.5421875,
            0.446875,
            0.5453125,
            0.484375,
            0.38125,
            0.5140625,
            0.5546875,
            0.240625,
            0.2640625,
            0.490625,
            0.2765625,
            0.8625,
            0.5546875,
            0.546875,
            0.5453125,
            0.5453125,
            0.3625,
            0.41875,
            0.3890625,
            0.5453125,
            0.4703125,
            0.7546875,
            0.4921875,
            0.4609375,
            0.453125,
            0.4015625,
            0.2640625,
            0.4015625,
            0.58125
        ],
        avg: 0.5044078947368421
    },
    serif: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2484375,
            0.334375,
            0.409375,
            0.5,
            0.5,
            0.834375,
            0.778125,
            0.18125,
            0.334375,
            0.334375,
            0.5,
            0.5640625,
            0.25,
            0.334375,
            0.25,
            0.278125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.278125,
            0.278125,
            0.5640625,
            0.5640625,
            0.5640625,
            0.4453125,
            0.921875,
            0.7234375,
            0.6671875,
            0.6671875,
            0.7234375,
            0.6109375,
            0.55625,
            0.7234375,
            0.7234375,
            0.334375,
            0.390625,
            0.7234375,
            0.6109375,
            0.890625,
            0.7234375,
            0.7234375,
            0.55625,
            0.7234375,
            0.6671875,
            0.55625,
            0.6109375,
            0.7234375,
            0.7234375,
            0.9453125,
            0.7234375,
            0.7234375,
            0.6109375,
            0.334375,
            0.340625,
            0.334375,
            0.4703125,
            0.5,
            0.3453125,
            0.4453125,
            0.5,
            0.4453125,
            0.5,
            0.4453125,
            0.3828125,
            0.5,
            0.5,
            0.278125,
            0.3359375,
            0.5,
            0.278125,
            0.778125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.3375,
            0.390625,
            0.2796875,
            0.5,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.4453125,
            0.48125,
            0.2015625,
            0.48125,
            0.5421875
        ],
        avg: 0.5126315789473684
    },
    Tahoma: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3109375,
            0.3328125,
            0.4015625,
            0.728125,
            0.546875,
            0.9765625,
            0.70625,
            0.2109375,
            0.3828125,
            0.3828125,
            0.546875,
            0.728125,
            0.303125,
            0.3640625,
            0.303125,
            0.3953125,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.546875,
            0.3546875,
            0.3546875,
            0.728125,
            0.728125,
            0.728125,
            0.475,
            0.909375,
            0.6109375,
            0.590625,
            0.6015625,
            0.6796875,
            0.5625,
            0.521875,
            0.66875,
            0.6765625,
            0.3734375,
            0.4171875,
            0.6046875,
            0.4984375,
            0.771875,
            0.66875,
            0.7078125,
            0.5515625,
            0.7078125,
            0.6375,
            0.5578125,
            0.5875,
            0.65625,
            0.60625,
            0.903125,
            0.58125,
            0.5890625,
            0.559375,
            0.3828125,
            0.39375,
            0.3828125,
            0.728125,
            0.5625,
            0.546875,
            0.525,
            0.553125,
            0.4625,
            0.553125,
            0.5265625,
            0.3546875,
            0.553125,
            0.5578125,
            0.2296875,
            0.328125,
            0.51875,
            0.2296875,
            0.840625,
            0.5578125,
            0.54375,
            0.553125,
            0.553125,
            0.3609375,
            0.446875,
            0.3359375,
            0.5578125,
            0.4984375,
            0.7421875,
            0.4953125,
            0.4984375,
            0.4453125,
            0.48125,
            0.3828125,
            0.48125,
            0.728125
        ],
        avg: 0.5384374999999998
    },
    "Times New Roman": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.2484375,
            0.334375,
            0.409375,
            0.5,
            0.5,
            0.834375,
            0.778125,
            0.18125,
            0.334375,
            0.334375,
            0.5,
            0.5640625,
            0.25,
            0.334375,
            0.25,
            0.28125,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.5,
            0.278125,
            0.278125,
            0.5640625,
            0.5640625,
            0.5640625,
            0.4453125,
            0.921875,
            0.7234375,
            0.6671875,
            0.6671875,
            0.7234375,
            0.6109375,
            0.55625,
            0.7234375,
            0.7234375,
            0.334375,
            0.390625,
            0.73125,
            0.6109375,
            0.890625,
            0.7375,
            0.7234375,
            0.55625,
            0.7234375,
            0.6765625,
            0.55625,
            0.6109375,
            0.7234375,
            0.7234375,
            0.9453125,
            0.7234375,
            0.7234375,
            0.6109375,
            0.334375,
            0.28125,
            0.334375,
            0.4703125,
            0.51875,
            0.334375,
            0.4453125,
            0.503125,
            0.4453125,
            0.503125,
            0.4453125,
            0.4359375,
            0.5,
            0.5,
            0.278125,
            0.35625,
            0.50625,
            0.278125,
            0.778125,
            0.5,
            0.5,
            0.5046875,
            0.5,
            0.340625,
            0.390625,
            0.2796875,
            0.5,
            0.5,
            0.7234375,
            0.5,
            0.5,
            0.4453125,
            0.48125,
            0.2015625,
            0.48125,
            0.5421875
        ],
        avg: 0.5134375
    },
    "Trebuchet MS": {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.3015625,
            0.3671875,
            0.325,
            0.53125,
            0.525,
            0.6015625,
            0.70625,
            0.1609375,
            0.3671875,
            0.3671875,
            0.3671875,
            0.525,
            0.3671875,
            0.3671875,
            0.3671875,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.525,
            0.3671875,
            0.3671875,
            0.525,
            0.525,
            0.525,
            0.3671875,
            0.771875,
            0.590625,
            0.5671875,
            0.5984375,
            0.6140625,
            0.5359375,
            0.525,
            0.6765625,
            0.6546875,
            0.2796875,
            0.4765625,
            0.5765625,
            0.5078125,
            0.7109375,
            0.6390625,
            0.675,
            0.5578125,
            0.7421875,
            0.5828125,
            0.48125,
            0.58125,
            0.6484375,
            0.5875,
            0.853125,
            0.5578125,
            0.5703125,
            0.5515625,
            0.3671875,
            0.3578125,
            0.3671875,
            0.525,
            0.53125,
            0.525,
            0.5265625,
            0.5578125,
            0.4953125,
            0.5578125,
            0.546875,
            0.375,
            0.503125,
            0.546875,
            0.2859375,
            0.3671875,
            0.5046875,
            0.2953125,
            0.83125,
            0.546875,
            0.5375,
            0.5578125,
            0.5578125,
            0.3890625,
            0.40625,
            0.396875,
            0.546875,
            0.490625,
            0.7453125,
            0.5015625,
            0.49375,
            0.475,
            0.3671875,
            0.525,
            0.3671875,
            0.525
        ],
        avg: 0.5085197368421052
    },
    Verdana: {
        widths: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0.35,
            0.39375,
            0.459375,
            0.81875,
            0.6359375,
            1.0765625,
            0.759375,
            0.26875,
            0.4546875,
            0.4546875,
            0.6359375,
            0.81875,
            0.3640625,
            0.4546875,
            0.3640625,
            0.4703125,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.6359375,
            0.4546875,
            0.4546875,
            0.81875,
            0.81875,
            0.81875,
            0.546875,
            1,
            0.684375,
            0.6859375,
            0.6984375,
            0.771875,
            0.6328125,
            0.575,
            0.7765625,
            0.7515625,
            0.421875,
            0.4546875,
            0.69375,
            0.5578125,
            0.84375,
            0.7484375,
            0.7875,
            0.603125,
            0.7875,
            0.7,
            0.684375,
            0.6171875,
            0.7328125,
            0.684375,
            0.9890625,
            0.6859375,
            0.615625,
            0.6859375,
            0.4546875,
            0.46875,
            0.4546875,
            0.81875,
            0.6421875,
            0.6359375,
            0.6015625,
            0.6234375,
            0.521875,
            0.6234375,
            0.596875,
            0.384375,
            0.6234375,
            0.6328125,
            0.275,
            0.3765625,
            0.5921875,
            0.275,
            0.9734375,
            0.6328125,
            0.6078125,
            0.6234375,
            0.6234375,
            0.43125,
            0.521875,
            0.3953125,
            0.6328125,
            0.5921875,
            0.81875,
            0.5921875,
            0.5921875,
            0.5265625,
            0.6359375,
            0.4546875,
            0.6359375,
            0.81875
        ],
        avg: 0.6171875000000003
    } //https://developer.mozilla.org/en/docs/Web/CSS/length
};
var absoluteMeasurementUnitsToPixels = {
    mm: 3.8,
    sm: 38,
    pt: 1.33,
    pc: 16,
    in: 96,
    px: 1
};
var relativeMeasurementUnitsCoef = {
    em: 1,
    ex: 0.5
};
var coefficients = {
    heightOverlapCoef: 1.05,
    // Coefficient for height value to prevent overlap.
    lineCapitalCoef: 1.15 // Coefficient for height value. Reserve space for capital chars.
};
var defaultStyle = {
    lineHeight: 1,
    letterSpacing: "0px",
    fontSize: 0,
    angle: 0,
    fontFamily: ""
};
var _degreeToRadian = function _degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var _getFontData = function _getFontData(fontFamily) {
    var possibleFonts = fontFamily.split(",").map(function(f) {
        return f.replace(/'|"/g, "");
    });
    var fontMatch = possibleFonts.find(function(f) {
        return fonts[f];
    }) || "Helvetica";
    return fonts[fontMatch];
};
var _splitToLines = function _splitToLines(text) {
    return Array.isArray(text) ? text : text.toString().split(/\r\n|\r|\n/g);
};
var _getSizeWithRotate = function _getSizeWithRotate(axisSize, dependentSize, angle) {
    var angleInRadian = _degreeToRadian(angle);
    return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
};
var convertLengthToPixels = function convertLengthToPixels(length, fontSize) {
    var attribute = length.match(/[a-zA-Z%]+/) && length.match(/[a-zA-Z%]+/)[0];
    var value = length.match(/[0-9.,]+/);
    var result;
    if (!attribute) result = value || 0;
    else if (absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) result = value * absoluteMeasurementUnitsToPixels[attribute];
    else if (relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) result = (fontSize ? value * fontSize : value * defaultStyle.fontSize) * relativeMeasurementUnitsCoef[attribute];
    else result = value;
    return result;
};
var _prepareParams = function _prepareParams(inputStyle, index) {
    var lineStyle = Array.isArray(inputStyle) ? inputStyle[index] : inputStyle;
    var style = (0, _defaultsDefault.default)({}, lineStyle, defaultStyle);
    return (0, _assignDefault.default)({}, style, {
        fontFamily: style.fontFamily,
        letterSpacing: typeof style.letterSpacing === "number" ? style.letterSpacing : convertLengthToPixels(String(style.letterSpacing), style.fontSize),
        fontSize: typeof style.fontSize === "number" ? style.fontSize : convertLengthToPixels(String(style.fontSize))
    });
};
var _approximateTextWidthInternal = function _approximateTextWidthInternal(text, style) {
    if (text === undefined || text === "" || text === null) return 0;
    var widths = _splitToLines(text).map(function(line, index) {
        var len = line.toString().length;
        var _prepareParams2 = _prepareParams(style, index), fontSize = _prepareParams2.fontSize, letterSpacing = _prepareParams2.letterSpacing, fontFamily = _prepareParams2.fontFamily;
        var fontData = _getFontData(fontFamily);
        var width = line.toString().split("").map(function(c) {
            return c.charCodeAt(0) < fontData.widths.length ? fontData.widths[c.charCodeAt(0)] : fontData.avg;
        }).reduce(function(cur, acc) {
            return acc + cur;
        }, 0) * fontSize;
        return width + letterSpacing * Math.max(len - 1, 0);
    });
    return Math.max.apply(Math, _toConsumableArray(widths));
};
var _approximateTextHeightInternal = function _approximateTextHeightInternal(text, style) {
    if (text === undefined || text === "" || text === null) return 0;
    return _splitToLines(text).reduce(function(total, line, index) {
        var lineStyle = _prepareParams(style, index);
        var containsCaps = line.toString().match(/[(A-Z)(0-9)]/);
        var height = containsCaps ? lineStyle.fontSize * coefficients.lineCapitalCoef : lineStyle.fontSize;
        return total + lineStyle.lineHeight * height;
    }, 0);
}; // Stubbable implementation.
var _approximateTextSizeInternal = {
    impl: function impl(text, style) {
        var angle = Array.isArray(style) ? style[0] && style[0].angle : style && style.angle;
        var height = _approximateTextHeightInternal(text, style);
        var width = _approximateTextWidthInternal(text, style);
        var widthWithRotate = angle ? _getSizeWithRotate(width, height, angle) : width;
        var heightWithRotate = angle ? _getSizeWithRotate(height, width, angle) : height;
        return {
            width: widthWithRotate,
            height: heightWithRotate * coefficients.heightOverlapCoef
        };
    }
};
var approximateTextSize = function approximateTextSize(text, style) {
    return _approximateTextSizeInternal.impl(text, style);
};

},{"lodash/defaults":"eWhnr","lodash/assign":"xTxAt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gH14S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var TSpan = function TSpan(props) {
    return (0, _reactDefault.default).createElement("tspan", props);
};
exports.default = TSpan;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bjYnd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var Text = function Text(props) {
    var children = props.children, title = props.title, desc = props.desc, rest = _objectWithoutProperties(props, [
        "children",
        "title",
        "desc"
    ]);
    return (0, _reactDefault.default).createElement("text", rest, title && (0, _reactDefault.default).createElement("title", null, title), desc && (0, _reactDefault.default).createElement("desc", null, desc), children);
};
Text.propTypes = {
    children: (0, _propTypesDefault.default).node,
    desc: (0, _propTypesDefault.default).string,
    title: (0, _propTypesDefault.default).string
};
exports.default = Text;

},{"react":"gVheC","prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Ib0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictoryTransition;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryAnimation = require("../victory-animation/victory-animation");
var _victoryAnimationDefault = parcelHelpers.interopDefault(_victoryAnimation);
var _collection = require("../victory-util/collection");
var _helpers = require("../victory-util/helpers");
var _timerContext = require("../victory-util/timer-context");
var _timerContextDefault = parcelHelpers.interopDefault(_timerContext);
var _transitions = require("../victory-util/transitions");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var VictoryTransition = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryTransition, _React$Component);
    function VictoryTransition(props, context) {
        var _this;
        _classCallCheck(this, VictoryTransition);
        _this = _possibleConstructorReturn(this, (VictoryTransition.__proto__ || Object.getPrototypeOf(VictoryTransition)).call(this, props, context));
        _this.state = {
            nodesShouldLoad: false,
            nodesDoneLoad: false
        };
        var child = _this.props.children;
        var polar = child.props.polar;
        _this.continuous = !polar && child.type && child.type.continuous === true;
        _this.getTransitionState = _this.getTransitionState.bind(_assertThisInitialized(_this));
        _this.timer = _this.context.transitionTimer;
        return _this;
    }
    _createClass(VictoryTransition, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    nodesShouldLoad: true
                }); //eslint-disable-line react/no-did-mount-set-state
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                if (!(0, _reactFastCompareDefault.default)(this.props, nextProps)) {
                    this.timer.bypassAnimation();
                    this.setState(this.getTransitionState(this.props, nextProps), function() {
                        return _this2.timer.resumeAnimation();
                    });
                }
                return true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.timer.stop();
            }
        },
        {
            key: "getTransitionState",
            value: function getTransitionState(props, nextProps) {
                var animate = props.animate;
                if (!animate) return {};
                else if (animate.parentState) {
                    var state = animate.parentState;
                    var oldProps = state.nodesWillExit ? props : null;
                    return {
                        oldProps: oldProps,
                        nextProps: nextProps
                    };
                } else {
                    var oldChildren = (0, _reactDefault.default).Children.toArray(props.children);
                    var nextChildren = (0, _reactDefault.default).Children.toArray(nextProps.children);
                    var _Transitions$getIniti = _transitions.getInitialTransitionState(oldChildren, nextChildren), nodesWillExit = _Transitions$getIniti.nodesWillExit, nodesWillEnter = _Transitions$getIniti.nodesWillEnter, childrenTransitions = _Transitions$getIniti.childrenTransitions, nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
                    return {
                        nodesWillExit: nodesWillExit,
                        nodesWillEnter: nodesWillEnter,
                        childrenTransitions: childrenTransitions,
                        nodesShouldEnter: nodesShouldEnter,
                        oldProps: nodesWillExit ? props : null,
                        nextProps: nextProps
                    };
                }
            }
        },
        {
            key: "getDomainFromChildren",
            value: function getDomainFromChildren(props, axis) {
                var getChildDomains = function getChildDomains1(children) {
                    return children.reduce(function(memo, child) {
                        if (child.type && (0, _isFunctionDefault.default)(child.type.getDomain)) {
                            var childDomain = child.props && child.type.getDomain(child.props, axis);
                            return childDomain ? memo.concat(childDomain) : memo;
                        } else if (child.props && child.props.children) return memo.concat(getChildDomains((0, _reactDefault.default).Children.toArray(child.props.children)));
                        return memo;
                    }, []);
                };
                var child = (0, _reactDefault.default).Children.toArray(props.children)[0];
                var childProps = child.props || {};
                var domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];
                if (!childProps.children && domain) return domain;
                else {
                    var childDomains = getChildDomains([
                        child
                    ]);
                    return childDomains.length === 0 ? [
                        0,
                        1
                    ] : [
                        _collection.getMinValue(childDomains),
                        _collection.getMaxValue(childDomains)
                    ];
                }
            }
        },
        {
            key: "pickProps",
            value: function pickProps() {
                if (!this.state) return this.props;
                return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
            }
        },
        {
            key: "pickDomainProps",
            value: function pickDomainProps(props) {
                var parentState = (0, _isObjectDefault.default)(props.animate) && props.animate.parentState;
                if (parentState && parentState.nodesWillExit) return this.continous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props : props;
                return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props : props;
            }
        },
        {
            key: "getClipWidth",
            value: function getClipWidth(props, child) {
                var getDefaultClipWidth = function getDefaultClipWidth() {
                    var range = _helpers.getRange(child.props, "x");
                    return range ? Math.abs(range[1] - range[0]) : props.width;
                };
                var clipWidth = this.transitionProps ? this.transitionProps.clipWidth : undefined;
                return clipWidth !== undefined ? clipWidth : getDefaultClipWidth();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var props = this.pickProps();
                var getTransitionProps = (0, _isObjectDefault.default)(this.props.animate) && this.props.animate.getTransitions ? this.props.animate.getTransitions : _transitions.getTransitionPropsFactory(props, this.state, function(newState) {
                    return _this3.setState(newState);
                });
                var child = (0, _reactDefault.default).Children.toArray(props.children)[0];
                var transitionProps = getTransitionProps(child);
                this.transitionProps = transitionProps;
                var domain = {
                    x: this.getDomainFromChildren(this.pickDomainProps(props), "x"),
                    y: this.getDomainFromChildren(props, "y")
                };
                var clipWidth = this.getClipWidth(props, child);
                var combinedProps = (0, _defaultsDefault.default)({
                    domain: domain,
                    clipWidth: clipWidth
                }, transitionProps, child.props);
                var animationWhitelist = props.animationWhitelist || [];
                var whitelist = animationWhitelist.concat([
                    "clipWidth"
                ]);
                var propsToAnimate = whitelist.length ? (0, _pickDefault.default)(combinedProps, whitelist) : combinedProps;
                return (0, _reactDefault.default).createElement((0, _victoryAnimationDefault.default), _extends({}, combinedProps.animate, {
                    data: propsToAnimate
                }), function(newProps) {
                    if (child.props.groupComponent) {
                        var groupComponent = _this3.continuous ? (0, _reactDefault.default).cloneElement(child.props.groupComponent, {
                            clipWidth: newProps.clipWidth || 0
                        }) : child.props.groupComponent;
                        return (0, _reactDefault.default).cloneElement(child, (0, _defaultsDefault.default)({
                            animate: null,
                            animating: true,
                            groupComponent: groupComponent
                        }, newProps, combinedProps));
                    }
                    return (0, _reactDefault.default).cloneElement(child, (0, _defaultsDefault.default)({
                        animate: null,
                        animating: true
                    }, newProps, combinedProps));
                });
            }
        }
    ]);
    return VictoryTransition;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryTransition, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryTransition"
});
Object.defineProperty(VictoryTransition, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        animate: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).object
        ]),
        animationWhitelist: (0, _propTypesDefault.default).array,
        children: (0, _propTypesDefault.default).node
    }
});
Object.defineProperty(VictoryTransition, "contextType", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _timerContextDefault.default)
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/isObject":"8ffGS","lodash/pick":"7HV03","lodash/isFunction":"8ck2f","lodash/defaults":"eWhnr","react":"gVheC","prop-types":"3KNJy","../victory-animation/victory-animation":"ehNoG","../victory-util/collection":"4mxxX","../victory-util/helpers":"8ABme","../victory-util/timer-context":"hLkTS","../victory-util/transitions":"iXuWj","react-fast-compare":"jGkHB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4mxxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "containsStrings", function() {
    return containsStrings;
});
parcelHelpers.export(exports, "containsDates", function() {
    return containsDates;
});
parcelHelpers.export(exports, "containsNumbers", function() {
    return containsNumbers;
});
parcelHelpers.export(exports, "containsOnlyStrings", function() {
    return containsOnlyStrings;
});
parcelHelpers.export(exports, "isArrayOfArrays", function() {
    return isArrayOfArrays;
});
parcelHelpers.export(exports, "removeUndefined", function() {
    return removeUndefined;
});
parcelHelpers.export(exports, "getMaxValue", function() {
    return getMaxValue;
});
parcelHelpers.export(exports, "getMinValue", function() {
    return getMinValue;
});
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ function isNonEmptyArray(collection) {
    return Array.isArray(collection) && collection.length > 0;
}
function containsStrings(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return typeof value === "string";
    });
}
function containsDates(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return value instanceof Date;
    });
}
function containsNumbers(collection) {
    return Array.isArray(collection) && collection.some(function(value) {
        return typeof value === "number";
    });
}
function containsOnlyStrings(collection) {
    return isNonEmptyArray(collection) && collection.every(function(value) {
        return typeof value === "string";
    });
}
function isArrayOfArrays(collection) {
    return isNonEmptyArray(collection) && collection.every(Array.isArray);
}
function removeUndefined(arr) {
    return arr.filter(function(el) {
        return el !== undefined;
    });
}
function getMaxValue(arr) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    var array = arr.concat(values);
    return containsDates(array) ? new Date(Math.max.apply(Math, _toConsumableArray(array))) : Math.max.apply(Math, _toConsumableArray(array));
}
function getMinValue(arr) {
    for(var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)values[_key2 - 1] = arguments[_key2];
    var array = arr.concat(values);
    return containsDates(array) ? new Date(Math.min.apply(Math, _toConsumableArray(array))) : Math.min.apply(Math, _toConsumableArray(array));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iXuWj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * If a parent component has animation enabled, calculate the transitions
 * for any data of any child component that supports data transitions
 * Data transitions are defined as any two datasets where data nodes exist
 * in the first set and not the second, in the second and not the first,
 * or both.
 *
 * @param  {Children}  oldChildren   this.props.children from old props
 * @param  {Children}  nextChildren  this.props.children from next props
 *
 * @return {Object}                  Object with the following properties:
 *                                    - nodesWillExit
 *                                    - nodesWillEnter
 *                                    - childrenTransitions
 *                                    - nodesShouldEnter
 */ parcelHelpers.export(exports, "getInitialTransitionState", function() {
    return getInitialTransitionState;
});
/**
 * getTransitionPropsFactory - putting the Java in JavaScript.  This will return a
 * function that returns prop transformations for a child, given that child's props
 * and its index in the parent's children array.
 *
 * In particular, this will include an `animate` object that is set appropriately
 * so that each child will be synchoronized for each stage of a transition
 * animation.  It will also include a transformed `data` object, where each datum
 * is transformed by `animate.onExit` and `animate.onEnter` `before` and `after`
 * functions.
 *
 * @param  {Object}  props       `this.props` for the parent component.
 * @param  {Object} state        `this.state` for the parent component.
 * @param  {Function} setState    Function that, when called, will `this.setState` on
 *                                 the parent component with the provided object.
 *
 * @return {Function}              Child-prop transformation function.
 */ parcelHelpers.export(exports, "getTransitionPropsFactory", function() {
    return getTransitionPropsFactory;
});
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _identity = require("lodash/identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function getDatumKey(datum, idx) {
    return (datum.key || idx).toString();
}
function getKeyedData(data) {
    return data.reduce(function(keyedData, datum, idx) {
        var key = getDatumKey(datum, idx);
        keyedData[key] = datum;
        return keyedData;
    }, {});
}
function getKeyedDataDifference(a, b) {
    var hasDifference = false;
    var difference = (0, _keysDefault.default)(a).reduce(function(_difference, key) {
        if (!(key in b)) {
            hasDifference = true;
            _difference[key] = true;
        }
        return _difference;
    }, {});
    return hasDifference && difference;
}
/**
 * Calculate which data-points exist in oldData and not nextData -
 * these are the `exiting` data-points.  Also calculate which
 * data-points exist in nextData and not oldData - these are the
 * `entering` data-points.
 *
 * @param  {Array} oldData   this.props.data Array
 * @param  {Array} nextData  this.props.data Array
 *
 * @return {Object}          Object with `entering` and `exiting` properties.
 *                           entering[datum.key] will be true if the data is
 *                           entering, and similarly for `exiting`.
 */ function getNodeTransitions(oldData, nextData) {
    var oldDataKeyed = oldData && getKeyedData(oldData);
    var nextDataKeyed = nextData && getKeyedData(nextData);
    return {
        entering: oldDataKeyed && getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
        exiting: nextDataKeyed && getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
    };
}
function getChildData(child) {
    if (child.type && child.type.getData) return child.type.getData(child.props);
    return child.props && child.props.data || false;
}
function getInitialTransitionState(oldChildren, nextChildren) {
    var nodesWillExit = false;
    var nodesWillEnter = false;
    var getTransition = function getTransition(oldChild, newChild) {
        if (!newChild || oldChild.type !== newChild.type) return {};
        var _ref = getNodeTransitions(getChildData(oldChild), getChildData(newChild)) || {}, entering = _ref.entering, exiting = _ref.exiting;
        nodesWillExit = nodesWillExit || !!exiting;
        nodesWillEnter = nodesWillEnter || !!entering;
        return {
            entering: entering || false,
            exiting: exiting || false
        };
    };
    var getTransitionsFromChildren = function getTransitionsFromChildren1(old, next) {
        return old.map(function(child, idx) {
            if (child && child.props && child.props.children && next[idx]) return getTransitionsFromChildren((0, _reactDefault.default).Children.toArray(old[idx].props.children), (0, _reactDefault.default).Children.toArray(next[idx].props.children));
             // get Transition entering and exiting nodes
            return getTransition(child, next[idx]);
        });
    };
    var childrenTransitions = getTransitionsFromChildren((0, _reactDefault.default).Children.toArray(oldChildren), (0, _reactDefault.default).Children.toArray(nextChildren));
    return {
        nodesWillExit: nodesWillExit,
        nodesWillEnter: nodesWillEnter,
        childrenTransitions: childrenTransitions,
        // TODO: This may need to be refactored for the following situation.
        //       The component receives new props, and the data provided
        //       is a perfect match for the previous data and domain except
        //       for new nodes. In this case, we wouldn't want a delay before
        //       the new nodes appear.
        nodesShouldEnter: false
    };
}
function getInitialChildProps(animate, data) {
    var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : (0, _identityDefault.default);
    return {
        data: data.map(function(datum, idx) {
            return (0, _assignDefault.default)({}, datum, after(datum, idx, data));
        })
    };
} // eslint-disable-next-line max-params
function getChildBeforeLoad(animate, child, data, cb) {
    animate = (0, _assignDefault.default)({}, animate, {
        onEnd: cb
    });
    if (animate && animate.onLoad && !animate.onLoad.duration) return {
        animate: animate,
        data: data
    };
    var before = animate.onLoad && animate.onLoad.before ? animate.onLoad.before : (0, _identityDefault.default); // If nodes need to exit, transform them with the provided onLoad.before function.
    data = data.map(function(datum, idx) {
        return (0, _assignDefault.default)({}, datum, before(datum, idx, data));
    });
    return {
        animate: animate,
        data: data,
        clipWidth: 0
    };
} // eslint-disable-next-line max-params
function getChildOnLoad(animate, data, cb) {
    animate = (0, _assignDefault.default)({}, animate, {
        onEnd: cb
    });
    if (animate && animate.onLoad && !animate.onLoad.duration) return {
        animate: animate,
        data: data
    };
    var after = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : (0, _identityDefault.default); // If nodes need to exit, transform them with the provided onLoad.after function.
    data = data.map(function(datum, idx) {
        return (0, _assignDefault.default)({}, datum, after(datum, idx, data));
    });
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params, max-len
function getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
    // Whether or not _this_ child has exiting nodes, we want the exit-
    // transition for all children to have the same duration, delay, etc.
    var onExit = animate && animate.onExit;
    animate = (0, _assignDefault.default)({}, animate, onExit);
    if (exitingNodes) {
        // After the exit transition occurs, trigger the animations for
        // nodes that are neither exiting or entering.
        animate.onEnd = cb;
        var before = animate.onExit && animate.onExit.before ? animate.onExit.before : (0, _identityDefault.default); // If nodes need to exit, transform them with the provided onExit.before function.
        data = data.map(function(datum, idx) {
            var key = (datum.key || idx).toString();
            return exitingNodes[key] ? (0, _assignDefault.default)({}, datum, before(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params,max-len
function getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
    if (enteringNodes) {
        // Perform a normal animation here, except - when it finishes - trigger
        // the transition for entering nodes.
        animate = (0, _assignDefault.default)({}, animate, {
            onEnd: cb
        });
        var before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : (0, _identityDefault.default); // We want the entering nodes to be included in the transition target
        // domain.  However, we may not want these nodes to be displayed initially,
        // so perform the `onEnter.before` transformation on each node.
        data = data.map(function(datum, idx) {
            var key = (datum.key || idx).toString();
            return enteringNodes[key] ? (0, _assignDefault.default)({}, datum, before(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
} // eslint-disable-next-line max-params, max-len
function getChildPropsOnEnter(animate, data, enteringNodes, cb) {
    // Whether or not _this_ child has entering nodes, we want the entering-
    // transition for all children to have the same duration, delay, etc.
    var onEnter = animate && animate.onEnter;
    animate = (0, _assignDefault.default)({}, animate, onEnter);
    if (enteringNodes) {
        // Old nodes have been transitioned to their new values, and the
        // domain should encompass the nodes that will now enter. So perform
        // the `onEnter.after` transformation on each node.
        animate.onEnd = cb;
        var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : (0, _identityDefault.default);
        data = data.map(function(datum, idx) {
            var key = getDatumKey(datum, idx);
            return enteringNodes[key] ? (0, _assignDefault.default)({}, datum, after(datum, idx, data)) : datum;
        });
    }
    return {
        animate: animate,
        data: data
    };
}
function getTransitionPropsFactory(props, state, setState) {
    var nodesWillExit = state && state.nodesWillExit;
    var nodesWillEnter = state && state.nodesWillEnter;
    var nodesShouldEnter = state && state.nodesShouldEnter;
    var nodesShouldLoad = state && state.nodesShouldLoad;
    var nodesDoneLoad = state && state.nodesDoneLoad;
    var childrenTransitions = state && state.childrenTransitions || [];
    var transitionDurations = {
        enter: props.animate && props.animate.onEnter && props.animate.onEnter.duration,
        exit: props.animate && props.animate.onExit && props.animate.onExit.duration,
        load: props.animate && props.animate.onLoad && props.animate.onLoad.duration,
        move: props.animate && props.animate.duration
    };
    var onLoad = function onLoad(child, data, animate) {
        if (nodesShouldLoad) return getChildOnLoad(animate, data, function() {
            setState({
                nodesShouldLoad: false,
                nodesDoneLoad: true
            });
        });
        return getChildBeforeLoad(animate, child, data, function() {
            setState({
                nodesDoneLoad: true
            });
        });
    }; // eslint-disable-next-line max-params
    var onExit = function onExit(nodes, child, data, animate) {
        return getChildPropsOnExit(animate, child, data, nodes, function() {
            setState({
                nodesWillExit: false
            });
        });
    }; // eslint-disable-next-line max-params
    var onEnter = function onEnter(nodes, child, data, animate) {
        if (nodesShouldEnter) return getChildPropsOnEnter(animate, data, nodes, function() {
            setState({
                nodesWillEnter: false
            });
        });
        return getChildPropsBeforeEnter(animate, child, data, nodes, function() {
            setState({
                nodesShouldEnter: true
            });
        });
    };
    var getChildTransitionDuration = function getChildTransitionDuration(child, type) {
        var animate = child.props.animate;
        if (!child.type) return {};
        var defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
        if (defaultTransitions) {
            var animationDuration = animate[type] && animate[type].duration;
            return animationDuration !== undefined ? animationDuration : defaultTransitions[type] && defaultTransitions[type].duration;
        } else return {};
    }; // eslint-disable-next-line max-statements, complexity, max-len
    return function getTransitionProps(child, index) {
        var data = getChildData(child) || [];
        var animate = (0, _defaultsDefault.default)({}, props.animate, child.props.animate);
        var defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
        animate.onExit = (0, _defaultsDefault.default)({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
        animate.onEnter = (0, _defaultsDefault.default)({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
        animate.onLoad = (0, _defaultsDefault.default)({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
        var childTransitions = childrenTransitions[index] || childrenTransitions[0];
        if (!nodesDoneLoad) {
            // should do onLoad animation
            var load = transitionDurations.load !== undefined ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
            var animation = {
                duration: load
            };
            return onLoad(child, data, (0, _assignDefault.default)({}, animate, animation));
        } else if (nodesWillExit) {
            var exitingNodes = childTransitions && childTransitions.exiting;
            var exit = transitionDurations.exit !== undefined ? transitionDurations.exit : getChildTransitionDuration(child, "onExit"); // if nodesWillExit, but this child has no exiting nodes, set a delay instead of a duration
            var _animation = exitingNodes ? {
                duration: exit
            } : {
                delay: exit
            };
            return onExit(exitingNodes, child, data, (0, _assignDefault.default)({}, animate, _animation));
        } else if (nodesWillEnter) {
            var enteringNodes = childTransitions && childTransitions.entering;
            var enter = transitionDurations.enter !== undefined ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
            var move = transitionDurations.move !== undefined ? transitionDurations.move : child.props.animate && child.props.animate.duration;
            var _animation2 = {
                duration: nodesShouldEnter && enteringNodes ? enter : move
            };
            return onEnter(enteringNodes, child, data, (0, _assignDefault.default)({}, animate, _animation2));
        } else if (!state && animate && animate.onExit) // This is the initial render, and nodes may enter when props change. Because
        // animation interpolation is determined by old- and next- props, data may need
        // to be augmented with certain properties.
        //
        // For example, it may be desired that exiting nodes go from `opacity: 1` to
        // `opacity: 0`. Without setting this on a per-datum basis, the interpolation
        // might go from `opacity: undefined` to `opacity: 0`, which would result in
        // interpolated `opacity: NaN` values.
        //
        return getInitialChildProps(animate, data);
        return {
            animate: animate,
            data: data
        };
    };
}

},{"lodash/keys":"kLvI9","lodash/identity":"6wIyV","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5j1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _material = require("./material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _grayscale = require("./grayscale");
var _grayscaleDefault = parcelHelpers.interopDefault(_grayscale);
exports.default = {
    material: (0, _materialDefault.default),
    grayscale: (0, _grayscaleDefault.default)
};

},{"./material":"lOr5x","./grayscale":"2tCkf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lOr5x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
// *
// * Colors
// *
var yellow200 = "#FFF59D";
var deepOrange600 = "#F4511E";
var lime300 = "#DCE775";
var lightGreen500 = "#8BC34A";
var teal700 = "#00796B";
var cyan900 = "#006064";
var colors = [
    deepOrange600,
    yellow200,
    lime300,
    lightGreen500,
    teal700,
    cyan900
];
var blueGrey50 = "#ECEFF1";
var blueGrey300 = "#90A4AE";
var blueGrey700 = "#455A64";
var grey900 = "#212121"; // *
// * Typography
// *
var sansSerif = "'Helvetica Neue', 'Helvetica', sans-serif";
var letterSpacing = "normal";
var fontSize = 12; // *
// * Layout
// *
var padding = 8;
var baseProps = {
    width: 350,
    height: 350,
    padding: 50
}; // *
// * Labels
// *
var baseLabelStyles = {
    fontFamily: sansSerif,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    padding: padding,
    fill: blueGrey700,
    stroke: "transparent",
    strokeWidth: 0
};
var centeredLabelStyles = (0, _assignDefault.default)({
    textAnchor: "middle"
}, baseLabelStyles); // *
// * Strokes
// *
var strokeDasharray = "10, 5";
var strokeLinecap = "round";
var strokeLinejoin = "round";
exports.default = {
    area: (0, _assignDefault.default)({
        style: {
            data: {
                fill: grey900
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    axis: (0, _assignDefault.default)({
        style: {
            axis: {
                fill: "transparent",
                stroke: blueGrey300,
                strokeWidth: 2,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin
            },
            axisLabel: (0, _assignDefault.default)({}, centeredLabelStyles, {
                padding: padding,
                stroke: "transparent"
            }),
            grid: {
                fill: "none",
                stroke: blueGrey50,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin,
                pointerEvents: "painted"
            },
            ticks: {
                fill: "transparent",
                size: 5,
                stroke: blueGrey300,
                strokeWidth: 1,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin
            },
            tickLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                fill: blueGrey700
            })
        }
    }, baseProps),
    polarDependentAxis: (0, _assignDefault.default)({
        style: {
            ticks: {
                fill: "transparent",
                size: 1,
                stroke: "transparent"
            }
        }
    }),
    bar: (0, _assignDefault.default)({
        style: {
            data: {
                fill: blueGrey700,
                padding: padding,
                strokeWidth: 0
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    boxplot: (0, _assignDefault.default)({
        style: {
            max: {
                padding: padding,
                stroke: blueGrey700,
                strokeWidth: 1
            },
            maxLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            median: {
                padding: padding,
                stroke: blueGrey700,
                strokeWidth: 1
            },
            medianLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            min: {
                padding: padding,
                stroke: blueGrey700,
                strokeWidth: 1
            },
            minLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            q1: {
                padding: padding,
                fill: blueGrey700
            },
            q1Labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            q3: {
                padding: padding,
                fill: blueGrey700
            },
            q3Labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            })
        },
        boxWidth: 20
    }, baseProps),
    candlestick: (0, _assignDefault.default)({
        style: {
            data: {
                stroke: blueGrey700
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5
            })
        },
        candleColors: {
            positive: "#ffffff",
            negative: blueGrey700
        }
    }, baseProps),
    chart: baseProps,
    errorbar: (0, _assignDefault.default)({
        borderWidth: 8,
        style: {
            data: {
                fill: "transparent",
                opacity: 1,
                stroke: blueGrey700,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    group: (0, _assignDefault.default)({
        colorScale: colors
    }, baseProps),
    histogram: (0, _assignDefault.default)({
        style: {
            data: {
                fill: blueGrey700,
                stroke: grey900,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    legend: {
        colorScale: colors,
        gutter: 10,
        orientation: "vertical",
        titleOrientation: "top",
        style: {
            data: {
                type: "circle"
            },
            labels: baseLabelStyles,
            title: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5
            })
        }
    },
    line: (0, _assignDefault.default)({
        style: {
            data: {
                fill: "transparent",
                opacity: 1,
                stroke: blueGrey700,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    pie: (0, _assignDefault.default)({
        colorScale: colors,
        style: {
            data: {
                padding: padding,
                stroke: blueGrey50,
                strokeWidth: 1
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 20
            })
        }
    }, baseProps),
    scatter: (0, _assignDefault.default)({
        style: {
            data: {
                fill: blueGrey700,
                opacity: 1,
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    stack: (0, _assignDefault.default)({
        colorScale: colors
    }, baseProps),
    tooltip: {
        style: (0, _assignDefault.default)({}, baseLabelStyles, {
            padding: 0,
            pointerEvents: "none"
        }),
        flyoutStyle: {
            stroke: grey900,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
        },
        flyoutPadding: 5,
        cornerRadius: 5,
        pointerLength: 10
    },
    voronoi: (0, _assignDefault.default)({
        style: {
            data: {
                fill: "transparent",
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5,
                pointerEvents: "none"
            }),
            flyout: {
                stroke: grey900,
                strokeWidth: 1,
                fill: "#f0f0f0",
                pointerEvents: "none"
            }
        }
    }, baseProps)
};

},{"lodash/assign":"xTxAt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2tCkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
// *
// * Colors
// *
var colors = [
    "#252525",
    "#525252",
    "#737373",
    "#969696",
    "#bdbdbd",
    "#d9d9d9",
    "#f0f0f0"
];
var charcoal = "#252525";
var grey = "#969696"; // *
// * Typography
// *
var sansSerif = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif";
var letterSpacing = "normal";
var fontSize = 14; // *
// * Layout
// *
var baseProps = {
    width: 450,
    height: 300,
    padding: 50,
    colorScale: colors
}; // *
// * Labels
// *
var baseLabelStyles = {
    fontFamily: sansSerif,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    padding: 10,
    fill: charcoal,
    stroke: "transparent"
};
var centeredLabelStyles = (0, _assignDefault.default)({
    textAnchor: "middle"
}, baseLabelStyles); // *
// * Strokes
// *
var strokeLinecap = "round";
var strokeLinejoin = "round";
exports.default = {
    area: (0, _assignDefault.default)({
        style: {
            data: {
                fill: charcoal
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    axis: (0, _assignDefault.default)({
        style: {
            axis: {
                fill: "transparent",
                stroke: charcoal,
                strokeWidth: 1,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin
            },
            axisLabel: (0, _assignDefault.default)({}, centeredLabelStyles, {
                padding: 25
            }),
            grid: {
                fill: "none",
                stroke: "none",
                pointerEvents: "painted"
            },
            ticks: {
                fill: "transparent",
                size: 1,
                stroke: "transparent"
            },
            tickLabels: baseLabelStyles
        }
    }, baseProps),
    bar: (0, _assignDefault.default)({
        style: {
            data: {
                fill: charcoal,
                padding: 8,
                strokeWidth: 0
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    boxplot: (0, _assignDefault.default)({
        style: {
            max: {
                padding: 8,
                stroke: charcoal,
                strokeWidth: 1
            },
            maxLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            median: {
                padding: 8,
                stroke: charcoal,
                strokeWidth: 1
            },
            medianLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            min: {
                padding: 8,
                stroke: charcoal,
                strokeWidth: 1
            },
            minLabels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            q1: {
                padding: 8,
                fill: grey
            },
            q1Labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            }),
            q3: {
                padding: 8,
                fill: grey
            },
            q3Labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 3
            })
        },
        boxWidth: 20
    }, baseProps),
    candlestick: (0, _assignDefault.default)({
        style: {
            data: {
                stroke: charcoal,
                strokeWidth: 1
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5
            })
        },
        candleColors: {
            positive: "#ffffff",
            negative: charcoal
        }
    }, baseProps),
    chart: baseProps,
    errorbar: (0, _assignDefault.default)({
        borderWidth: 8,
        style: {
            data: {
                fill: "transparent",
                stroke: charcoal,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    group: (0, _assignDefault.default)({
        colorScale: colors
    }, baseProps),
    histogram: (0, _assignDefault.default)({
        style: {
            data: {
                fill: grey,
                stroke: charcoal,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    legend: {
        colorScale: colors,
        gutter: 10,
        orientation: "vertical",
        titleOrientation: "top",
        style: {
            data: {
                type: "circle"
            },
            labels: baseLabelStyles,
            title: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5
            })
        }
    },
    line: (0, _assignDefault.default)({
        style: {
            data: {
                fill: "transparent",
                stroke: charcoal,
                strokeWidth: 2
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    pie: {
        style: {
            data: {
                padding: 10,
                stroke: "transparent",
                strokeWidth: 1
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 20
            })
        },
        colorScale: colors,
        width: 400,
        height: 400,
        padding: 50
    },
    scatter: (0, _assignDefault.default)({
        style: {
            data: {
                fill: charcoal,
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: baseLabelStyles
        }
    }, baseProps),
    stack: (0, _assignDefault.default)({
        colorScale: colors
    }, baseProps),
    tooltip: {
        style: (0, _assignDefault.default)({}, baseLabelStyles, {
            padding: 0,
            pointerEvents: "none"
        }),
        flyoutStyle: {
            stroke: charcoal,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
        },
        flyoutPadding: 5,
        cornerRadius: 5,
        pointerLength: 10
    },
    voronoi: (0, _assignDefault.default)({
        style: {
            data: {
                fill: "transparent",
                stroke: "transparent",
                strokeWidth: 0
            },
            labels: (0, _assignDefault.default)({}, baseLabelStyles, {
                padding: 5,
                pointerEvents: "none"
            }),
            flyout: {
                stroke: charcoal,
                strokeWidth: 1,
                fill: "#f0f0f0",
                pointerEvents: "none"
            }
        }
    }, baseProps)
};

},{"lodash/assign":"xTxAt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dEQ25":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
/*eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2, 180] }]*/ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helpers = require("../victory-util/helpers");
var _commonProps = require("../victory-util/common-props");
var _path = require("./path");
var _pathDefault = parcelHelpers.interopDefault(_path);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var getArcPath = function getArcPath(props) {
    var cx = props.cx, cy = props.cy, r = props.r, startAngle = props.startAngle, endAngle = props.endAngle, closedPath = props.closedPath; // Always draw the path as two arcs so that complete circles may be rendered.
    var halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
    var x1 = cx + r * Math.cos(_helpers.degreesToRadians(startAngle));
    var y1 = cy - r * Math.sin(_helpers.degreesToRadians(startAngle));
    var x2 = cx + r * Math.cos(_helpers.degreesToRadians(halfAngle));
    var y2 = cy - r * Math.sin(_helpers.degreesToRadians(halfAngle));
    var x3 = cx + r * Math.cos(_helpers.degreesToRadians(endAngle));
    var y3 = cy - r * Math.sin(_helpers.degreesToRadians(endAngle));
    var largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
    var largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
    var arcStart = closedPath ? " M ".concat(cx, ", ").concat(cy, " L ").concat(x1, ", ").concat(y1) : "M ".concat(x1, ", ").concat(y1);
    var arc1 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag1, ", 0, ").concat(x2, ", ").concat(y2);
    var arc2 = "A ".concat(r, ", ").concat(r, ", 0, ").concat(largerArcFlag2, ", 0, ").concat(x3, ", ").concat(y3);
    var arcEnd = closedPath ? "Z" : "";
    return "".concat(arcStart, " ").concat(arc1, " ").concat(arc2, " ").concat(arcEnd);
};
var evaluateProps = function evaluateProps(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */ var ariaLabel = _helpers.evaluateProp(props.ariaLabel, props);
    var desc = _helpers.evaluateProp(props.desc, props);
    var id = _helpers.evaluateProp(props.id, props);
    var style = _helpers.evaluateStyle((0, _assignDefault.default)({
        stroke: "black",
        fill: "none"
    }, props.style), props);
    var tabIndex = _helpers.evaluateProp(props.tabIndex, props);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        style: style,
        tabIndex: tabIndex
    });
};
var Arc = function Arc(props) {
    props = evaluateProps(props);
    return (0, _reactDefault.default).cloneElement(props.pathComponent, _objectSpread({}, props.events, {
        "aria-label": props.ariaLabel,
        d: getArcPath(props),
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        transform: props.transform,
        clipPath: props.clipPath
    }));
};
Arc.propTypes = _objectSpread({}, _commonProps.primitiveProps, {
    closedPath: (0, _propTypesDefault.default).bool,
    cx: (0, _propTypesDefault.default).number,
    cy: (0, _propTypesDefault.default).number,
    datum: (0, _propTypesDefault.default).any,
    endAngle: (0, _propTypesDefault.default).number,
    pathComponent: (0, _propTypesDefault.default).element,
    r: (0, _propTypesDefault.default).number,
    startAngle: (0, _propTypesDefault.default).number
});
Arc.defaultProps = {
    pathComponent: (0, _reactDefault.default).createElement((0, _pathDefault.default), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = Arc;

},{"lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/helpers":"8ABme","../victory-util/common-props":"fsKbU","./path":"j4JEi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fsKbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dataProps", function() {
    return dataProps;
});
parcelHelpers.export(exports, "baseProps", function() {
    return baseProps;
});
parcelHelpers.export(exports, "primitiveProps", function() {
    return primitiveProps;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _propTypes1 = require("./prop-types");
var dataProps = {
    categories: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
        (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
            y: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        })
    ]),
    data: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).object
    ]),
    dataComponent: (0, _propTypesDefault.default).element,
    disableInlineStyles: (0, _propTypesDefault.default).bool,
    labelComponent: (0, _propTypesDefault.default).element,
    labels: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).array
    ]),
    samples: _propTypes1.nonNegative,
    sortKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        _propTypes1.allOfType([
            _propTypes1.integer,
            _propTypes1.nonNegative
        ]),
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    sortOrder: (0, _propTypesDefault.default).oneOf([
        "ascending",
        "descending"
    ]),
    style: (0, _propTypesDefault.default).shape({
        parent: (0, _propTypesDefault.default).object,
        data: (0, _propTypesDefault.default).object,
        labels: (0, _propTypesDefault.default).object
    }),
    x: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        _propTypes1.allOfType([
            _propTypes1.integer,
            _propTypes1.nonNegative
        ]),
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    y: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        _propTypes1.allOfType([
            _propTypes1.integer,
            _propTypes1.nonNegative
        ]),
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    y0: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        _propTypes1.allOfType([
            _propTypes1.integer,
            _propTypes1.nonNegative
        ]),
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ])
};
var baseProps = {
    animate: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).object
    ]),
    containerComponent: (0, _propTypesDefault.default).element,
    domain: (0, _propTypesDefault.default).oneOfType([
        _propTypes1.domain,
        (0, _propTypesDefault.default).shape({
            x: _propTypes1.domain,
            y: _propTypes1.domain
        })
    ]),
    maxDomain: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).instanceOf(Date),
        (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).instanceOf(Date)
            ]),
            y: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).instanceOf(Date)
            ])
        })
    ]),
    minDomain: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).instanceOf(Date),
        (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).instanceOf(Date)
            ]),
            y: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).instanceOf(Date)
            ])
        })
    ]),
    domainPadding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number)
            ]),
            y: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number)
            ])
        }),
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number)
    ]),
    eventKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        _propTypes1.allOfType([
            _propTypes1.integer,
            _propTypes1.nonNegative
        ]),
        (0, _propTypesDefault.default).string
    ]),
    events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        target: (0, _propTypesDefault.default).oneOf([
            "data",
            "labels",
            "parent"
        ]),
        eventKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).array,
            _propTypes1.allOfType([
                _propTypes1.integer,
                _propTypes1.nonNegative
            ]),
            (0, _propTypesDefault.default).string
        ]),
        eventHandlers: (0, _propTypesDefault.default).object
    })),
    externalEventMutations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        callback: (0, _propTypesDefault.default).function,
        childName: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).array
        ]),
        eventKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).array,
            _propTypes1.allOfType([
                _propTypes1.integer,
                _propTypes1.nonNegative
            ]),
            (0, _propTypesDefault.default).string
        ]),
        mutation: (0, _propTypesDefault.default).function,
        target: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).array
        ])
    })),
    groupComponent: (0, _propTypesDefault.default).element,
    height: _propTypes1.nonNegative,
    name: (0, _propTypesDefault.default).string,
    origin: (0, _propTypesDefault.default).shape({
        x: (0, _propTypesDefault.default).number,
        y: (0, _propTypesDefault.default).number
    }),
    padding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).shape({
            top: (0, _propTypesDefault.default).number,
            bottom: (0, _propTypesDefault.default).number,
            left: (0, _propTypesDefault.default).number,
            right: (0, _propTypesDefault.default).number
        })
    ]),
    polar: (0, _propTypesDefault.default).bool,
    range: (0, _propTypesDefault.default).oneOfType([
        _propTypes1.domain,
        (0, _propTypesDefault.default).shape({
            x: _propTypes1.domain,
            y: _propTypes1.domain
        })
    ]),
    scale: (0, _propTypesDefault.default).oneOfType([
        _propTypes1.scale,
        (0, _propTypesDefault.default).shape({
            x: _propTypes1.scale,
            y: _propTypes1.scale
        })
    ]),
    sharedEvents: (0, _propTypesDefault.default).shape({
        events: (0, _propTypesDefault.default).array,
        getEventState: (0, _propTypesDefault.default).func
    }),
    singleQuadrantDomainPadding: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).bool
            ]),
            y: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).bool
            ])
        })
    ]),
    standalone: (0, _propTypesDefault.default).bool,
    theme: (0, _propTypesDefault.default).object,
    width: _propTypes1.nonNegative
};
var primitiveProps = {
    active: (0, _propTypesDefault.default).bool,
    ariaLabel: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    className: (0, _propTypesDefault.default).string,
    clipPath: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).object
    ]),
    desc: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    disableInlineStyles: (0, _propTypesDefault.default).bool,
    events: (0, _propTypesDefault.default).object,
    id: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    index: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    origin: (0, _propTypesDefault.default).shape({
        x: (0, _propTypesDefault.default).number,
        y: (0, _propTypesDefault.default).number
    }),
    polar: (0, _propTypesDefault.default).bool,
    role: (0, _propTypesDefault.default).string,
    scale: (0, _propTypesDefault.default).oneOfType([
        _propTypes1.scale,
        (0, _propTypesDefault.default).shape({
            x: _propTypes1.scale,
            y: _propTypes1.scale
        })
    ]),
    shapeRendering: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    tabIndex: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    transform: (0, _propTypesDefault.default).string
};

},{"prop-types":"3KNJy","./prop-types":"88bb9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j4JEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var Path = function Path(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = _objectWithoutProperties(props, [
        "desc"
    ]);
    return desc ? (0, _reactDefault.default).createElement("path", rest, (0, _reactDefault.default).createElement("desc", null, desc)) : (0, _reactDefault.default).createElement("path", rest);
};
exports.default = Path;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Yw7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helpers = require("../victory-util/helpers");
var _commonProps = require("../victory-util/common-props");
var _rect = require("./rect");
var _rectDefault = parcelHelpers.interopDefault(_rect);
var _circle = require("./circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var evaluateProps = function evaluateProps(props) {
    /**
   * Potential evaluated prop is:
   * `id`
   */ var id = _helpers.evaluateProp(props.id, props);
    return (0, _assignDefault.default)({}, props, {
        id: id
    });
};
var Background = function Background(props) {
    props = evaluateProps(props);
    return props.polar ? (0, _reactDefault.default).cloneElement(props.circleComponent, _objectSpread({}, props.events, {
        style: props.style,
        role: props.role,
        shapeRendering: props.shapeRendering,
        cx: props.x,
        cy: props.y,
        r: props.height,
        className: props.className
    })) : (0, _reactDefault.default).cloneElement(props.rectComponent, _objectSpread({}, props.events, {
        style: props.style,
        role: props.role,
        shapeRendering: props.shapeRendering,
        x: props.x,
        y: props.y,
        rx: props.rx,
        ry: props.ry,
        width: props.width,
        height: props.height,
        className: props.className
    }));
};
Background.propTypes = _objectSpread({}, _commonProps.primitiveProps, {
    circleComponent: (0, _propTypesDefault.default).element,
    height: (0, _propTypesDefault.default).number,
    rectComponent: (0, _propTypesDefault.default).element,
    rx: (0, _propTypesDefault.default).number,
    ry: (0, _propTypesDefault.default).number,
    width: (0, _propTypesDefault.default).number,
    x: (0, _propTypesDefault.default).number,
    y: (0, _propTypesDefault.default).number
});
Background.defaultProps = {
    circleComponent: (0, _reactDefault.default).createElement((0, _circleDefault.default), null),
    rectComponent: (0, _reactDefault.default).createElement((0, _rectDefault.default), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = Background;

},{"lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/helpers":"8ABme","../victory-util/common-props":"fsKbU","./rect":"3KA3C","./circle":"1ze2g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ze2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var Circle = function Circle(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = _objectWithoutProperties(props, [
        "desc"
    ]);
    return desc ? (0, _reactDefault.default).createElement("circle", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), (0, _reactDefault.default).createElement("desc", null, desc)) : (0, _reactDefault.default).createElement("circle", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};
exports.default = Circle;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"JJcbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helpers = require("../victory-util/helpers");
var _commonProps = require("../victory-util/common-props");
var _rect = require("./rect");
var _rectDefault = parcelHelpers.interopDefault(_rect);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var evaluateProps = function evaluateProps(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */ var ariaLabel = _helpers.evaluateProp(props.ariaLabel, props);
    var desc = _helpers.evaluateProp(props.desc, props);
    var id = _helpers.evaluateProp(props.id, props);
    var style = _helpers.evaluateStyle((0, _assignDefault.default)({
        fill: "none"
    }, props.style), props);
    var tabIndex = _helpers.evaluateProp(props.tabIndex, props);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        style: style,
        tabIndex: tabIndex
    });
};
var Border = function Border(props) {
    props = evaluateProps(props);
    return (0, _reactDefault.default).cloneElement(props.rectComponent, _objectSpread({}, props.events, {
        "aria-label": props.ariaLabel,
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        transform: props.transform,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        clipPath: props.clipPath
    }));
};
Border.propTypes = _objectSpread({}, _commonProps.primitiveProps, {
    height: (0, _propTypesDefault.default).number,
    rectComponent: (0, _propTypesDefault.default).element,
    width: (0, _propTypesDefault.default).number,
    x: (0, _propTypesDefault.default).number,
    y: (0, _propTypesDefault.default).number
});
Border.defaultProps = {
    rectComponent: (0, _reactDefault.default).createElement((0, _rectDefault.default), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = Border;

},{"lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/helpers":"8ABme","../victory-util/common-props":"fsKbU","./rect":"3KA3C","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fFlgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var Line = function Line(props) {
    // eslint-disable-next-line react/prop-types
    var desc = props.desc, rest = _objectWithoutProperties(props, [
        "desc"
    ]);
    return desc ? (0, _reactDefault.default).createElement("line", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest), (0, _reactDefault.default).createElement("desc", null, desc)) : (0, _reactDefault.default).createElement("line", _extends({
        vectorEffect: "non-scaling-stroke"
    }, rest));
};
exports.default = Line;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bAwh7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helpers = require("../victory-util/helpers");
var _commonProps = require("../victory-util/common-props");
var _line = require("./line");
var _lineDefault = parcelHelpers.interopDefault(_line);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var evaluateProps = function evaluateProps(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `style`
   * `tabIndex`
   */ var ariaLabel = _helpers.evaluateProp(props.ariaLabel, props);
    var desc = _helpers.evaluateProp(props.desc, props);
    var id = _helpers.evaluateProp(props.id, props);
    var style = _helpers.evaluateStyle((0, _assignDefault.default)({
        stroke: "black"
    }, props.style), props);
    var tabIndex = _helpers.evaluateProp(props.tabIndex, props);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        style: style,
        tabIndex: tabIndex
    });
};
var LineSegment = function LineSegment(props) {
    props = evaluateProps(props);
    return (0, _reactDefault.default).cloneElement(props.lineComponent, _objectSpread({}, props.events, {
        "aria-label": props.ariaLabel,
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        x1: props.x1,
        x2: props.x2,
        y1: props.y1,
        y2: props.y2,
        transform: props.transform,
        clipPath: props.clipPath
    }));
};
LineSegment.propTypes = _objectSpread({}, _commonProps.primitiveProps, {
    datum: (0, _propTypesDefault.default).any,
    lineComponent: (0, _propTypesDefault.default).element,
    x1: (0, _propTypesDefault.default).number,
    x2: (0, _propTypesDefault.default).number,
    y1: (0, _propTypesDefault.default).number,
    y2: (0, _propTypesDefault.default).number
});
LineSegment.defaultProps = {
    lineComponent: (0, _reactDefault.default).createElement((0, _lineDefault.default), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = LineSegment;

},{"lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/helpers":"8ABme","../victory-util/common-props":"fsKbU","./line":"fFlgS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gBM4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helpers = require("../victory-util/helpers");
var _pathHelpers = require("./path-helpers");
var _pathHelpersDefault = parcelHelpers.interopDefault(_pathHelpers);
var _commonProps = require("../victory-util/common-props");
var _path = require("./path");
var _pathDefault = parcelHelpers.interopDefault(_path);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var getPath = function getPath(props) {
    var x = props.x, y = props.y, size = props.size, symbol = props.symbol;
    if (props.getPath) return props.getPath(x, y, size);
    var pathFunctions = {
        circle: (0, _pathHelpersDefault.default).circle,
        square: (0, _pathHelpersDefault.default).square,
        diamond: (0, _pathHelpersDefault.default).diamond,
        triangleDown: (0, _pathHelpersDefault.default).triangleDown,
        triangleUp: (0, _pathHelpersDefault.default).triangleUp,
        plus: (0, _pathHelpersDefault.default).plus,
        minus: (0, _pathHelpersDefault.default).minus,
        star: (0, _pathHelpersDefault.default).star,
        cross: (0, _pathHelpersDefault.default).cross
    };
    var symbolFunction = typeof pathFunctions[symbol] === "function" ? pathFunctions[symbol] : pathFunctions.circle;
    return symbolFunction(x, y, size);
};
var evaluateProps = function evaluateProps(props) {
    /**
   * Potential evaluated props are:
   * `ariaLabel`
   * `desc`
   * `id`
   * `size`
   * `style`
   * `symbol`
   * `tabIndex`
   */ var ariaLabel = _helpers.evaluateProp(props.ariaLabel, props);
    var desc = _helpers.evaluateProp(props.desc, props);
    var id = _helpers.evaluateProp(props.id, props);
    var size = _helpers.evaluateProp(props.size, props);
    var style = _helpers.evaluateStyle(props.style, props);
    var symbol = _helpers.evaluateProp(props.symbol, props);
    var tabIndex = _helpers.evaluateProp(props.tabIndex, props);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        desc: desc,
        id: id,
        size: size,
        style: style,
        symbol: symbol,
        tabIndex: tabIndex
    });
};
var Point = function Point(props) {
    props = evaluateProps(props);
    return (0, _reactDefault.default).cloneElement(props.pathComponent, _objectSpread({}, props.events, {
        "aria-label": props.ariaLabel,
        d: getPath(props),
        style: props.style,
        desc: props.desc,
        tabIndex: props.tabIndex,
        role: props.role,
        shapeRendering: props.shapeRendering,
        className: props.className,
        transform: props.transform,
        clipPath: props.clipPath
    }));
};
Point.propTypes = _objectSpread({}, _commonProps.primitiveProps, {
    datum: (0, _propTypesDefault.default).object,
    getPath: (0, _propTypesDefault.default).func,
    pathComponent: (0, _propTypesDefault.default).element,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    symbol: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            "circle",
            "cross",
            "diamond",
            "plus",
            "minus",
            "square",
            "star",
            "triangleDown",
            "triangleUp"
        ]),
        (0, _propTypesDefault.default).func
    ]),
    x: (0, _propTypesDefault.default).number,
    y: (0, _propTypesDefault.default).number
});
Point.defaultProps = {
    pathComponent: (0, _reactDefault.default).createElement((0, _pathDefault.default), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = Point;

},{"lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","../victory-util/helpers":"8ABme","./path-helpers":"cPaEh","../victory-util/common-props":"fsKbU","./path":"j4JEi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cPaEh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
exports.default = {
    circle: function circle(x, y, size) {
        return "M ".concat(x, ", ").concat(y, "\n      m ").concat(-size, ", 0\n      a ").concat(size, ", ").concat(size, " 0 1,0 ").concat(size * 2, ",0\n      a ").concat(size, ", ").concat(size, " 0 1,0 ").concat(-size * 2, ",0");
    },
    square: function square(x, y, size) {
        var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
        var x0 = x - baseSize;
        var y1 = y + baseSize;
        var distance = x + baseSize - x0;
        return "M ".concat(x0, ", ").concat(y1, "\n      h").concat(distance, "\n      v-").concat(distance, "\n      h-").concat(distance, "\n      z");
    },
    diamond: function diamond(x, y, size) {
        var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
        var length = Math.sqrt(2 * (baseSize * baseSize));
        return "M ".concat(x, ", ").concat(y + length, "\n      l ").concat(length, ", -").concat(length, "\n      l -").concat(length, ", -").concat(length, "\n      l -").concat(length, ", ").concat(length, "\n      l ").concat(length, ", ").concat(length, "\n      z");
    },
    triangleDown: function triangleDown(x, y, size) {
        var height = size / 2 * Math.sqrt(3);
        var x0 = x - size;
        var x1 = x + size;
        var y0 = y - size;
        var y1 = y + height;
        return "M ".concat(x0, ", ").concat(y0, "\n      L ").concat(x1, ", ").concat(y0, "\n      L ").concat(x, ", ").concat(y1, "\n      z");
    },
    triangleUp: function triangleUp(x, y, size) {
        var height = size / 2 * Math.sqrt(3);
        var x0 = x - size;
        var x1 = x + size;
        var y0 = y - height;
        var y1 = y + size;
        return "M ".concat(x0, ", ").concat(y1, "\n      L ").concat(x1, ", ").concat(y1, "\n      L ").concat(x, ", ").concat(y0, "\n      z");
    },
    plus: function plus(x, y, size) {
        var baseSize = 1.1 * size; // eslint-disable-line no-magic-numbers
        var distance = baseSize / 1.5; // eslint-disable-line no-magic-numbers
        return "\n      M ".concat(x - distance / 2, ", ").concat(y + baseSize, "\n      v-").concat(distance, "\n      h-").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h-").concat(distance, "\n      v").concat(distance, "\n      z");
    },
    cross: function cross(x, y, size) {
        var baseSize = 0.8 * size; // eslint-disable-line no-magic-numbers
        var distance = baseSize / 1.5; // eslint-disable-line no-magic-numbers
        return "\n      M ".concat(x - distance / 2, ", ").concat(y + baseSize + distance, "\n      v-").concat(distance * 2, "\n      h-").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v-").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h").concat(distance, "\n      v").concat(distance, "\n      h-").concat(distance, "\n      v").concat(distance * 2, "\n      z");
    },
    minus: function minus(x, y, size) {
        var baseSize = 1.1 * size; // eslint-disable-line no-magic-numbers
        var lineHeight = baseSize - baseSize * 0.3; // eslint-disable-line no-magic-numbers
        var x0 = x - baseSize;
        var y1 = y + lineHeight / 2;
        var distance = x + baseSize - x0;
        return "M ".concat(x0, ", ").concat(y1, "\n      h").concat(distance, "\n      v-").concat(lineHeight, "\n      h-").concat(distance, "\n      z");
    },
    star: function star(x, y, size) {
        var baseSize = 1.35 * size; // eslint-disable-line no-magic-numbers
        var angle = Math.PI / 5; // eslint-disable-line no-magic-numbers
        // eslint-disable-next-line no-magic-numbers
        var starCoords = (0, _rangeDefault.default)(10).map(function(index) {
            var length = index % 2 === 0 ? baseSize : baseSize / 2;
            return "".concat(length * Math.sin(angle * (index + 1)) + x, ",\n        ").concat(length * Math.cos(angle * (index + 1)) + y);
        });
        return "M ".concat(starCoords.join("L"), " z");
    }
};

},{"lodash/range":"3wXYB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3wXYB":[function(require,module,exports,__globalThis) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"em8Dr"}],"em8Dr":[function(require,module,exports,__globalThis) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"j593Q","ae36f017fbc9946":"936XO","c59818521cb53c6a":"01pTU"}],"j593Q":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"l4shl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _difference = require("lodash/difference");
var _differenceDefault = parcelHelpers.interopDefault(_difference);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
/*global window:false */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _events = require("./events");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _victoryTransition = require("../victory-transition/victory-transition");
var _victoryTransitionDefault = parcelHelpers.interopDefault(_victoryTransition);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var datumHasXandY = function datumHasXandY(datum) {
    return !(0, _isNilDefault.default)(datum._x) && !(0, _isNilDefault.default)(datum._y);
}; //  used for checking state changes. Expected components can be passed in via options
var defaultComponents = [
    {
        name: "parent",
        index: "parent"
    },
    {
        name: "data"
    },
    {
        name: "labels"
    }
];
exports.default = function(WrappedComponent, options) {
    return /*#__PURE__*/ function(_WrappedComponent) {
        _inherits(addEvents, _WrappedComponent);
        function addEvents(props) {
            var _this;
            _classCallCheck(this, addEvents);
            _this = _possibleConstructorReturn(this, (addEvents.__proto__ || Object.getPrototypeOf(addEvents)).call(this, props));
            var getScopedEvents = _events.getScopedEvents.bind(_assertThisInitialized(_this));
            var boundGetEvents = _events.getEvents.bind(_assertThisInitialized(_this));
            _this.state = {};
            _this.getEvents = function(p, target, eventKey) {
                return boundGetEvents(p, target, eventKey, getScopedEvents);
            };
            _this.getEventState = _events.getEventState.bind(_assertThisInitialized(_this));
            var calculatedValues = _this.getCalculatedValues(props);
            _this.cacheValues(calculatedValues);
            _this.externalMutations = _this.getExternalMutations(props);
            _this.calculatedState = _this.getStateChanges(props);
            _this.globalEvents = {};
            _this.prevGlobalEventKeys = [];
            _this.boundGlobalEvents = {};
            return _this;
        }
        _createClass(addEvents, [
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps) {
                    var externalMutations = this.getExternalMutations(nextProps);
                    var animating = this.props.animating || this.props.animate;
                    var newMutation = !(0, _reactFastCompareDefault.default)(externalMutations, this.externalMutations);
                    if (animating || newMutation) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        this.externalMutations = externalMutations;
                        this.applyExternalMutations(nextProps, externalMutations);
                        return true;
                    }
                    var calculatedState = this.getStateChanges(nextProps);
                    if (!(0, _reactFastCompareDefault.default)(this.calculatedState, calculatedState)) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        return true;
                    }
                    if (!(0, _reactFastCompareDefault.default)(this.props, nextProps)) {
                        this.cacheValues(this.getCalculatedValues(nextProps));
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var globalEventKeys = (0, _keysDefault.default)(this.globalEvents);
                    globalEventKeys.forEach(function(key) {
                        return _this2.addGlobalListener(key);
                    });
                    this.prevGlobalEventKeys = globalEventKeys;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _this3 = this;
                    var calculatedState = this.getStateChanges(prevProps);
                    this.calculatedState = calculatedState;
                    var globalEventKeys = (0, _keysDefault.default)(this.globalEvents);
                    var removedGlobalEventKeys = (0, _differenceDefault.default)(this.prevGlobalEventKeys, globalEventKeys);
                    removedGlobalEventKeys.forEach(function(key) {
                        return _this3.removeGlobalListener(key);
                    });
                    var addedGlobalEventKeys = (0, _differenceDefault.default)(globalEventKeys, this.prevGlobalEventKeys);
                    addedGlobalEventKeys.forEach(function(key) {
                        return _this3.addGlobalListener(key);
                    });
                    this.prevGlobalEventKeys = globalEventKeys;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this4 = this;
                    this.prevGlobalEventKeys.forEach(function(key) {
                        return _this4.removeGlobalListener(key);
                    });
                }
            },
            {
                key: "addGlobalListener",
                value: function addGlobalListener(key) {
                    var _this5 = this;
                    var boundListener = function boundListener(event) {
                        var listener = _this5.globalEvents[key];
                        return listener && listener(_events.emulateReactEvent(event));
                    };
                    this.boundGlobalEvents[key] = boundListener;
                    window.addEventListener(_events.getGlobalEventNameFromKey(key), boundListener);
                }
            },
            {
                key: "removeGlobalListener",
                value: function removeGlobalListener(key) {
                    window.removeEventListener(_events.getGlobalEventNameFromKey(key), this.boundGlobalEvents[key]);
                } // compile all state changes from own and parent state. Order doesn't matter, as any state
            },
            {
                key: "getStateChanges",
                value: function getStateChanges(props) {
                    var _this6 = this;
                    if (!this.hasEvents) return {};
                    var getState = function getState(key, type) {
                        var result = (0, _defaultsDefault.default)({}, _this6.getEventState(key, type), _this6.getSharedEventState(key, type));
                        return (0, _isEmptyDefault.default)(result) ? undefined : result;
                    };
                    options = options || {};
                    var components = options.components || defaultComponents;
                    var stateChanges = components.map(function(component) {
                        if (!props.standalone && component.name === "parent") // don't check for changes on parent props for non-standalone components
                        return undefined;
                        else return component.index !== undefined ? getState(component.index, component.name) : _this6.dataKeys.map(function(key) {
                            return getState(key, component.name);
                        }).filter(Boolean);
                    }).filter(Boolean);
                    return stateChanges;
                }
            },
            {
                key: "applyExternalMutations",
                value: function applyExternalMutations(props, externalMutations) {
                    if (!(0, _isEmptyDefault.default)(externalMutations)) {
                        var callbacks = props.externalEventMutations.reduce(function(memo, mutation) {
                            memo = (0, _isFunctionDefault.default)(mutation.callback) ? memo.concat(mutation.callback) : memo;
                            return memo;
                        }, []);
                        var compiledCallbacks = callbacks.length ? function compiledCallbacks() {
                            callbacks.forEach(function(c) {
                                return c();
                            });
                        } : undefined;
                        this.setState(externalMutations, compiledCallbacks);
                    }
                }
            },
            {
                key: "getCalculatedValues",
                value: function getCalculatedValues(props) {
                    var sharedEvents = props.sharedEvents;
                    var components = WrappedComponent.expectedComponents;
                    var componentEvents = _events.getComponentEvents(props, components);
                    var getSharedEventState = sharedEvents && (0, _isFunctionDefault.default)(sharedEvents.getEventState) ? sharedEvents.getEventState : function getSharedEventState() {
                        return undefined;
                    };
                    var baseProps = this.getBaseProps(props, getSharedEventState);
                    var dataKeys = (0, _keysDefault.default)(baseProps).filter(function(key) {
                        return key !== "parent";
                    });
                    var hasEvents = props.events || props.sharedEvents || componentEvents;
                    var events = this.getAllEvents(props);
                    return {
                        componentEvents: componentEvents,
                        getSharedEventState: getSharedEventState,
                        baseProps: baseProps,
                        dataKeys: dataKeys,
                        hasEvents: hasEvents,
                        events: events
                    };
                }
            },
            {
                key: "getExternalMutations",
                value: function getExternalMutations(props) {
                    var sharedEvents = props.sharedEvents, externalEventMutations = props.externalEventMutations;
                    return (0, _isEmptyDefault.default)(externalEventMutations) || sharedEvents ? undefined : _events.getExternalMutations(externalEventMutations, this.baseProps, this.state);
                }
            },
            {
                key: "cacheValues",
                value: function cacheValues(obj) {
                    var _this7 = this;
                    (0, _keysDefault.default)(obj).forEach(function(key) {
                        _this7[key] = obj[key];
                    });
                }
            },
            {
                key: "getBaseProps",
                value: function getBaseProps(props, getSharedEventState) {
                    getSharedEventState = getSharedEventState || this.getSharedEventState;
                    var sharedParentState = getSharedEventState("parent", "parent");
                    var parentState = this.getEventState("parent", "parent");
                    var baseParentProps = (0, _defaultsDefault.default)({}, parentState, sharedParentState);
                    var parentPropsList = baseParentProps.parentControlledProps;
                    var parentProps = parentPropsList ? (0, _pickDefault.default)(baseParentProps, parentPropsList) : {};
                    var modifiedProps = (0, _defaultsDefault.default)({}, parentProps, props);
                    return (0, _isFunctionDefault.default)(WrappedComponent.getBaseProps) ? WrappedComponent.getBaseProps(modifiedProps) : {};
                }
            },
            {
                key: "getAllEvents",
                value: function getAllEvents(props) {
                    if (Array.isArray(this.componentEvents)) {
                        var _componentEvents;
                        return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
                    }
                    return props.events;
                }
            },
            {
                key: "getComponentProps",
                value: function getComponentProps(component, type, index) {
                    var name = this.props.name || WrappedComponent.role;
                    var key = this.dataKeys && this.dataKeys[index] || index;
                    var id = "".concat(name, "-").concat(type, "-").concat(key);
                    var baseProps = this.baseProps[key] && this.baseProps[key][type] || this.baseProps[key];
                    if (!baseProps && !this.hasEvents) return undefined;
                    if (this.hasEvents) {
                        var baseEvents = this.getEvents(this.props, type, key);
                        var componentProps = (0, _defaultsDefault.default)({
                            index: index,
                            key: id
                        }, this.getEventState(key, type), this.getSharedEventState(key, type), component.props, baseProps, {
                            id: id
                        });
                        var events = (0, _defaultsDefault.default)({}, _events.getPartialEvents(baseEvents, key, componentProps), componentProps.events);
                        return (0, _assignDefault.default)({}, componentProps, {
                            events: events
                        });
                    }
                    return (0, _defaultsDefault.default)({
                        index: index,
                        key: id
                    }, component.props, baseProps, {
                        id: id
                    });
                }
            },
            {
                key: "renderContainer",
                value: function renderContainer(component, children) {
                    var isContainer = component.type && component.type.role === "container";
                    var parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
                    if (parentProps.events) {
                        this.globalEvents = _events.getGlobalEvents(parentProps.events);
                        parentProps.events = _events.omitGlobalEvents(parentProps.events);
                    }
                    return (0, _reactDefault.default).cloneElement(component, parentProps, children);
                }
            },
            {
                key: "animateComponent",
                value: function animateComponent(props, defaultAnimationWhitelist) {
                    var animationWhitelist = props.animate && props.animate.animationWhitelist ? props.animate.animationWhitelist : defaultAnimationWhitelist;
                    return (0, _reactDefault.default).createElement((0, _victoryTransitionDefault.default), {
                        animate: props.animate,
                        animationWhitelist: animationWhitelist
                    }, (0, _reactDefault.default).createElement(this.constructor, props));
                } // Used by `VictoryLine` and `VictoryArea`
            },
            {
                key: "renderContinuousData",
                value: function renderContinuousData(props) {
                    var _this8 = this;
                    var dataComponent = props.dataComponent, labelComponent = props.labelComponent, groupComponent = props.groupComponent;
                    var dataKeys = (0, _withoutDefault.default)(this.dataKeys, "all");
                    var labelComponents = dataKeys.reduce(function(memo, key) {
                        var labelProps = _this8.getComponentProps(labelComponent, "labels", key);
                        if (labelProps && labelProps.text !== undefined && labelProps.text !== null) memo = memo.concat((0, _reactDefault.default).cloneElement(labelComponent, labelProps));
                        return memo;
                    }, []);
                    var dataProps = this.getComponentProps(dataComponent, "data", "all");
                    var children = [
                        (0, _reactDefault.default).cloneElement(dataComponent, dataProps)
                    ].concat(_toConsumableArray(labelComponents));
                    return this.renderContainer(groupComponent, children);
                }
            },
            {
                key: "renderData",
                value: function renderData(props) {
                    var _this9 = this;
                    var shouldRenderDatum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : datumHasXandY;
                    var dataComponent = props.dataComponent, labelComponent = props.labelComponent, groupComponent = props.groupComponent;
                    var dataComponents = this.dataKeys.reduce(function(validDataComponents, _dataKey, index) {
                        var dataProps = _this9.getComponentProps(dataComponent, "data", index);
                        if (shouldRenderDatum(dataProps.datum)) validDataComponents.push((0, _reactDefault.default).cloneElement(dataComponent, dataProps));
                        return validDataComponents;
                    }, []);
                    var labelComponents = this.dataKeys.map(function(_dataKey, index) {
                        var labelProps = _this9.getComponentProps(labelComponent, "labels", index);
                        if (labelProps.text !== undefined && labelProps.text !== null) return (0, _reactDefault.default).cloneElement(labelComponent, labelProps);
                        return undefined;
                    }).filter(Boolean);
                    var children = _toConsumableArray(dataComponents).concat(_toConsumableArray(labelComponents));
                    return this.renderContainer(groupComponent, children);
                }
            }
        ]);
        return addEvents;
    }(WrappedComponent);
};

},{"@swc/helpers/_/_type_of":"668P4","lodash/difference":"4LrTi","lodash/isNil":"beGyX","lodash/isEmpty":"15wZF","lodash/without":"dIbEO","lodash/pick":"7HV03","lodash/isFunction":"8ck2f","lodash/keys":"kLvI9","lodash/assign":"xTxAt","lodash/defaults":"eWhnr","react":"gVheC","./events":"bDJ4N","react-fast-compare":"jGkHB","../victory-transition/victory-transition":"3Ib0s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4LrTi":[function(require,module,exports,__globalThis) {
var baseDifference = require("68ad3ed657165894"), baseFlatten = require("274eacf6c5db21d1"), baseRest = require("f81b002f05d9fa3d"), isArrayLikeObject = require("c0d5ae8b8d1e5645");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var difference = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});
module.exports = difference;

},{"68ad3ed657165894":"ffiVE","274eacf6c5db21d1":"8iQ0s","f81b002f05d9fa3d":"7EAh7","c0d5ae8b8d1e5645":"eiZps"}],"ffiVE":[function(require,module,exports,__globalThis) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"h6Zwg","81e4fe535468d831":"GaZbL","90bb2140eaac029e":"aqxyp","7436ea7dfb9a8bab":"5ZiZU","c466a3eeaa8c48da":"8g9lw","aea8a6a021670ce5":"dF80X"}],"GaZbL":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"1vhOt"}],"1vhOt":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"lGn6o","c991ed2b82d165b":"7tiNp","c0bb8190b05a00a5":"3pvun"}],"7tiNp":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"3pvun":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"aqxyp":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"eiZps":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"mL7I2","639a4883b097af28":"lm2eo"}],"beGyX":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"dIbEO":[function(require,module,exports,__globalThis) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"ffiVE","b2f01aa6851573dc":"7EAh7","15809c5e06486880":"eiZps"}],"bDJ4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* Returns all own and shared events that should be attached to a single target element,
 * i.e. an individual bar specified by target: "data", eventKey: [index].
 * Returned events are scoped to the appropriate state. Either that of the component itself
 * (i.e. VictoryBar) in the case of own events, or that of the parent component
 * (i.e. VictoryChart) in the case of shared events
 */ // eslint-disable-next-line max-params,no-shadow
parcelHelpers.export(exports, "getEvents", function() {
    return getEvents;
});
/* Returns a modified events object where each event handler is replaced by a new
 * function that calls the original handler and then calls setState with the return
 * of the original event handler assigned to state property that maps to the target
 * element.
 */ // eslint-disable-next-line max-params
parcelHelpers.export(exports, "getScopedEvents", function() {
    return getScopedEvents;
});
/* Returns a partially applied event handler for a specific target element
 * This allows event handlers to have access to props controlling each element
 */ parcelHelpers.export(exports, "getPartialEvents", function() {
    return getPartialEvents;
});
/* Returns the property of the state object corresponding to event changes for
 * a particular element
 */ parcelHelpers.export(exports, "getEventState", function() {
    return getEventState;
});
/**
 * Returns a set of all mutations for shared events
 *
 * @param  {Array} mutations an array of mutations objects
 * @param  {Object} baseProps an object that describes all props for children of VictorySharedEvents
 * @param  {Object} baseState an object that describes state for children of VictorySharedEvents
 * @param  {Array} childNames an array of childNames
 *
 * @return {Object} a object describing all mutations for VictorySharedEvents
 */ // eslint-disable-next-line max-params
parcelHelpers.export(exports, "getExternalMutationsWithChildren", function() {
    return getExternalMutationsWithChildren;
});
/**
 * Returns a set of all mutations for a component
 *
 * @param  {Array} mutations an array of mutations objects
 * @param  {Object} baseProps a props object (scoped to a childName when used by shared events)
 * @param  {Object} baseState a state object (scoped to a childName when used by shared events)
 * @param  {String} childName an optional childName
 *
 * @return {Object} a object describing mutations for a given component
 */ // eslint-disable-next-line max-params
parcelHelpers.export(exports, "getExternalMutations", function() {
    return getExternalMutations;
});
/**
 * Returns a set of mutations for a particular element given scoped baseProps and baseState
 *
 * @param  {Array} mutations an array of mutations objects
 * @param  {Object} baseProps a props object (scoped the element specified by the identifier)
 * @param  {Object} baseState a state object (scoped the element specified by the identifier)
 * @param  {Object} identifier { eventKey, target, childName }
 *
 * @return {Object | undefined} a object describing mutations for a given element, or undefined
 */ // eslint-disable-next-line max-params
parcelHelpers.export(exports, "getExternalMutation", function() {
    return getExternalMutation;
});
/* Returns an array of defaultEvents from sub-components of a given component.
 * i.e. any static `defaultEvents` on `labelComponent` will be returned
 */ parcelHelpers.export(exports, "getComponentEvents", function() {
    return getComponentEvents;
});
parcelHelpers.export(exports, "getGlobalEventNameFromKey", function() {
    return getGlobalEventNameFromKey;
});
parcelHelpers.export(exports, "getGlobalEvents", function() {
    return getGlobalEvents;
});
parcelHelpers.export(exports, "omitGlobalEvents", function() {
    return omitGlobalEvents;
});
parcelHelpers.export(exports, "emulateReactEvent", function() {
    return emulateReactEvent;
});
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _pickBy = require("lodash/pickBy");
var _pickByDefault = parcelHelpers.interopDefault(_pickBy);
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var GLOBAL_EVENT_REGEX = /^onGlobal(.*)$/;
function getEvents(props, target, eventKey, getScopedEvents) {
    var _this = this;
    // Returns all events that apply to a particular target element
    var getEventsByTarget = function getEventsByTarget(events) {
        var getSelectedEvents = function getSelectedEvents() {
            var targetEvents = events.reduce(function(memo, event) {
                if (event.target !== undefined) {
                    var matchesTarget = Array.isArray(event.target) ? (0, _includesDefault.default)(event.target, target) : "".concat(event.target) === "".concat(target);
                    return matchesTarget ? memo.concat(event) : memo;
                }
                return memo.concat(event);
            }, []);
            if (eventKey !== undefined && target !== "parent") return targetEvents.filter(function(obj) {
                var targetKeys = obj.eventKey;
                var useKey = function useKey(key) {
                    return key ? "".concat(key) === "".concat(eventKey) : true;
                };
                return Array.isArray(targetKeys) ? targetKeys.some(function(k) {
                    return useKey(k);
                }) : useKey(targetKeys);
            });
            return targetEvents;
        };
        var selectedEvents = getSelectedEvents();
        return Array.isArray(selectedEvents) && selectedEvents.reduce(function(memo, event) {
            return event ? (0, _assignDefault.default)(memo, event.eventHandlers) : memo;
        }, {});
    };
    /* Returns all events from props and defaultEvents from components. Events handlers
   * specified in props will override handlers for the same event if they are also
   * specified in defaultEvents of a sub-component
   */ var getAllEvents = function getAllEvents() {
        // Mandatory usage: `getEvents.bind(this)`
        /* eslint-disable no-invalid-this */ if (Array.isArray(_this.componentEvents)) {
            var _this$componentEvents;
            return Array.isArray(props.events) ? (_this$componentEvents = _this.componentEvents).concat.apply(_this$componentEvents, _toConsumableArray(props.events)) : _this.componentEvents;
        }
        /* eslint-enable no-invalid-this */ return props.events;
    };
    var allEvents = getAllEvents();
    var ownEvents = allEvents && (0, _isFunctionDefault.default)(getScopedEvents) ? getScopedEvents(getEventsByTarget(allEvents), target) : undefined;
    if (!props.sharedEvents) return ownEvents;
    var getSharedEvents = props.sharedEvents.getEvents;
    var sharedEvents = props.sharedEvents.events && getSharedEvents(getEventsByTarget(props.sharedEvents.events), target);
    return (0, _assignDefault.default)({}, sharedEvents, ownEvents);
}
function getScopedEvents(events, namespace, childType, baseProps) {
    var _this2 = this;
    if ((0, _isEmptyDefault.default)(events)) return {};
     // Mandatory usage: `getScopedEvents.bind(this)`
    // eslint-disable-next-line no-invalid-this
    baseProps = baseProps || this.baseProps; // returns the original base props or base state of a given target element
    var getTargetProps = function getTargetProps(identifier, type) {
        var childName = identifier.childName, target = identifier.target, key = identifier.key; // eslint-disable-next-line no-invalid-this
        var baseType = type === "props" ? baseProps : _this2.state || {};
        var base = childName === undefined || childName === null || !baseType[childName] ? baseType : baseType[childName];
        return key === "parent" ? base.parent : base[key] && base[key][target];
    }; // Returns the state object with the mutation caused by a given eventReturn
    // applied to the appropriate property on the state object
    var parseEvent = function parseEvent(eventReturn, eventKey) {
        var childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
        var target = eventReturn.target || namespace; // returns all eventKeys to modify for a targeted childName
        var getKeys = function getKeys(childName) {
            if (target === "parent") return "parent";
            if (eventReturn.eventKey === "all") return baseProps[childName] ? (0, _withoutDefault.default)((0, _keysDefault.default)(baseProps[childName]), "parent") : (0, _withoutDefault.default)((0, _keysDefault.default)(baseProps), "parent");
            else if (eventReturn.eventKey === undefined && eventKey === "parent") return baseProps[childName] ? (0, _keysDefault.default)(baseProps[childName]) : (0, _keysDefault.default)(baseProps);
            return eventReturn.eventKey !== undefined ? eventReturn.eventKey : eventKey;
        }; // returns the state object with mutated props applied for a single key
        var getMutationObject = function getMutationObject(key, childName) {
            // eslint-disable-next-line no-invalid-this
            var baseState = _this2.state || {};
            if (!(0, _isFunctionDefault.default)(eventReturn.mutation)) return baseState;
            var mutationTargetProps = getTargetProps({
                childName: childName,
                key: key,
                target: target
            }, "props");
            var mutationTargetState = getTargetProps({
                childName: childName,
                key: key,
                target: target
            }, "state");
            var mutatedProps = eventReturn.mutation((0, _assignDefault.default)({}, mutationTargetProps, mutationTargetState), baseProps);
            var childState = baseState[childName] || {};
            var filterState = function filterState(state) {
                if (state[key] && state[key][target]) delete state[key][target];
                if (state[key] && !(0, _keysDefault.default)(state[key]).length) delete state[key];
                return state;
            };
            var extendState = function extendState(state) {
                return target === "parent" ? (0, _assignDefault.default)(state, _defineProperty({}, key, (0, _assignDefault.default)(state[key], mutatedProps))) : (0, _assignDefault.default)(state, _defineProperty({}, key, (0, _assignDefault.default)(state[key], _defineProperty({}, target, mutatedProps))));
            };
            var updateState = function updateState(state) {
                return mutatedProps ? extendState(state) : filterState(state);
            };
            return childName !== undefined && childName !== null ? (0, _assignDefault.default)(baseState, _defineProperty({}, childName, updateState(childState))) : updateState(baseState);
        }; // returns entire mutated state for a given childName
        var getReturnByChild = function getReturnByChild(childName) {
            var mutationKeys = getKeys(childName);
            return Array.isArray(mutationKeys) ? mutationKeys.reduce(function(memo, key) {
                return (0, _assignDefault.default)(memo, getMutationObject(key, childName));
            }, {}) : getMutationObject(mutationKeys, childName);
        }; // returns an entire mutated state for all children
        var allChildNames = childNames === "all" ? (0, _withoutDefault.default)((0, _keysDefault.default)(baseProps), "parent") : childNames;
        return Array.isArray(allChildNames) ? allChildNames.reduce(function(memo, childName) {
            return (0, _assignDefault.default)(memo, getReturnByChild(childName));
        }, {}) : getReturnByChild(allChildNames);
    }; // Parses an array of event returns into a single state mutation
    var parseEventReturn = function parseEventReturn(eventReturn, eventKey) {
        return Array.isArray(eventReturn) ? eventReturn.reduce(function(memo, props) {
            memo = (0, _assignDefault.default)({}, memo, parseEvent(props, eventKey));
            return memo;
        }, {}) : parseEvent(eventReturn, eventKey);
    };
    var compileCallbacks = function compileCallbacks(eventReturn) {
        var getCallback = function getCallback(obj) {
            return (0, _isFunctionDefault.default)(obj.callback) && obj.callback;
        };
        var callbacks = Array.isArray(eventReturn) ? eventReturn.map(function(evtObj) {
            return getCallback(evtObj);
        }) : [
            getCallback(eventReturn)
        ];
        var callbackArray = callbacks.filter(function(callback) {
            return callback !== false;
        });
        return callbackArray.length ? function() {
            return callbackArray.forEach(function(callback) {
                return callback();
            });
        } : undefined;
    }; // A function that calls a particular event handler, parses its return
    // into a state mutation, and calls setState
    // eslint-disable-next-line max-params
    var onEvent = function onEvent(evt, childProps, eventKey, eventName) {
        // eslint-disable-next-line no-invalid-this
        var eventReturn = events[eventName](evt, childProps, eventKey, _this2);
        if (!(0, _isEmptyDefault.default)(eventReturn)) {
            var callbacks = compileCallbacks(eventReturn); // eslint-disable-next-line no-invalid-this
            _this2.setState(parseEventReturn(eventReturn, eventKey), callbacks);
        }
    }; // returns a new events object with enhanced event handlers
    return (0, _keysDefault.default)(events).reduce(function(memo, event) {
        memo[event] = onEvent;
        return memo;
    }, {});
}
function getPartialEvents(events, eventKey, childProps) {
    return events ? (0, _keysDefault.default)(events).reduce(function(memo, eventName) {
        var appliedEvent = function appliedEvent(evt) {
            return events[eventName](evt, childProps, eventKey, eventName);
        };
        memo[eventName] = appliedEvent;
        return memo;
    }, {}) : {};
}
function getEventState(eventKey, namespace, childType) {
    // Mandatory usage: `getEventState.bind(this)`
    // eslint-disable-next-line no-invalid-this
    var state = this.state || {};
    if (!childType) return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
    return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
}
function getExternalMutationsWithChildren(mutations, baseProps, baseState, childNames) {
    baseProps = baseProps || {};
    baseState = baseState || {};
    return childNames.reduce(function(memo, childName) {
        var childState = baseState[childName];
        var mutation = getExternalMutations(mutations, baseProps[childName], baseState[childName], childName);
        memo[childName] = mutation ? mutation : childState;
        return (0, _pickByDefault.default)(memo, function(v) {
            return !(0, _isEmptyDefault.default)(v);
        });
    }, {});
}
function getExternalMutations(mutations, baseProps, baseState, childName) {
    baseProps = baseProps || {};
    baseState = baseState || {};
    var eventKeys = (0, _keysDefault.default)(baseProps);
    return eventKeys.reduce(function(memo, eventKey) {
        var keyState = baseState[eventKey] || {};
        var keyProps = baseProps[eventKey] || {};
        if (eventKey === "parent") {
            var identifier = {
                eventKey: eventKey,
                target: "parent"
            };
            var mutation = getExternalMutation(mutations, keyProps, keyState, identifier);
            memo[eventKey] = mutation !== undefined ? (0, _assignDefault.default)({}, keyState, mutation) : keyState;
        } else {
            // use keys from both state and props so that elements not intially included in baseProps
            // will be used. (i.e. labels)
            var targets = (0, _uniqDefault.default)((0, _keysDefault.default)(keyProps).concat((0, _keysDefault.default)(keyState)));
            memo[eventKey] = targets.reduce(function(m, target) {
                var identifier = {
                    eventKey: eventKey,
                    target: target,
                    childName: childName
                };
                var mutation = getExternalMutation(mutations, keyProps[target], keyState[target], identifier);
                m[target] = mutation !== undefined ? (0, _assignDefault.default)({}, keyState[target], mutation) : keyState[target];
                return (0, _pickByDefault.default)(m, function(v) {
                    return !(0, _isEmptyDefault.default)(v);
                });
            }, {});
        }
        return (0, _pickByDefault.default)(memo, function(v) {
            return !(0, _isEmptyDefault.default)(v);
        });
    }, {});
}
function getExternalMutation(mutations, baseProps, baseState, identifier) {
    var filterMutations = function filterMutations(mutation, type) {
        if (typeof mutation[type] === "string") return mutation[type] === "all" || mutation[type] === identifier[type];
        else if (Array.isArray(mutation[type])) {
            // coerce arrays to strings before matching
            var stringArray = mutation[type].map(function(m) {
                return "".concat(m);
            });
            return (0, _includesDefault.default)(stringArray, identifier[type]);
        } else return false;
    };
    mutations = Array.isArray(mutations) ? mutations : [
        mutations
    ];
    var scopedMutations = mutations;
    if (identifier.childName) scopedMutations = mutations.filter(function(m) {
        return filterMutations(m, "childName");
    });
     // find any mutation objects that match the target
    var targetMutations = scopedMutations.filter(function(m) {
        return filterMutations(m, "target");
    });
    if ((0, _isEmptyDefault.default)(targetMutations)) return undefined;
    var keyMutations = targetMutations.filter(function(m) {
        return filterMutations(m, "eventKey");
    });
    if ((0, _isEmptyDefault.default)(keyMutations)) return undefined;
    return keyMutations.reduce(function(memo, curr) {
        var mutationFunction = curr && (0, _isFunctionDefault.default)(curr.mutation) ? curr.mutation : function mutationFunction() {
            return undefined;
        };
        var currentMutation = mutationFunction((0, _assignDefault.default)({}, baseProps, baseState));
        return (0, _assignDefault.default)({}, memo, currentMutation);
    }, {});
}
function getComponentEvents(props, components) {
    var events = Array.isArray(components) && components.reduce(function(memo, componentName) {
        var _memo;
        var component = props[componentName];
        var defaultEvents = component && component.type && component.type.defaultEvents;
        var componentEvents = (0, _isFunctionDefault.default)(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
        memo = Array.isArray(componentEvents) ? (_memo = memo).concat.apply(_memo, _toConsumableArray(componentEvents)) : memo;
        return memo;
    }, []);
    return events && events.length ? events : undefined;
}
function getGlobalEventNameFromKey(key) {
    var match = key.match(GLOBAL_EVENT_REGEX);
    return match && match[1] && match[1].toLowerCase();
}
var getGlobalEvents = function getGlobalEvents(events) {
    return (0, _pickByDefault.default)(events, function(_, key) {
        return GLOBAL_EVENT_REGEX.test(key);
    });
};
var omitGlobalEvents = function omitGlobalEvents(events) {
    return (0, _omitByDefault.default)(events, function(_, key) {
        return GLOBAL_EVENT_REGEX.test(key);
    });
};
var emulateReactEvent = function emulateReactEvent(event) {
    return (0, _assignDefault.default)(event, {
        nativeEvent: event
    });
};

},{"lodash/keys":"kLvI9","lodash/includes":"2bZ7U","lodash/uniq":"2LHAg","lodash/omitBy":"2Sfz5","lodash/pickBy":"fTum2","lodash/without":"dIbEO","lodash/isFunction":"8ck2f","lodash/isEmpty":"15wZF","lodash/assign":"xTxAt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2bZ7U":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("be21b9c147562b02"), isArrayLike = require("6b484a793d8b5ea9"), isString = require("bdb00e2bd146c748"), toInteger = require("c8f4f1fcd82bd63e"), values = require("2f52c3a6f24a285e");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
module.exports = includes;

},{"be21b9c147562b02":"1vhOt","6b484a793d8b5ea9":"mL7I2","bdb00e2bd146c748":"kZIz1","c8f4f1fcd82bd63e":"fVns0","2f52c3a6f24a285e":"lKyoC"}],"kZIz1":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"iuqvy","46fdd4d2c5d7b4ab":"jQGs4","36ebbb6a9d8b3fe4":"lm2eo"}],"lKyoC":[function(require,module,exports,__globalThis) {
var baseValues = require("f4ee8afbcaba5363"), keys = require("4f6b7e914d03d8e3");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"f4ee8afbcaba5363":"btAiH","4f6b7e914d03d8e3":"kLvI9"}],"btAiH":[function(require,module,exports,__globalThis) {
var arrayMap = require("2696d06e8e2fc398");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"2696d06e8e2fc398":"5ZiZU"}],"2LHAg":[function(require,module,exports,__globalThis) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"lUDFb"}],"lUDFb":[function(require,module,exports,__globalThis) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"h6Zwg","a1d85be956e037a9":"GaZbL","8cd18f86a4a2c118":"aqxyp","3acf9f4a3a78c511":"dF80X","19b77385b4f7775a":"jSEaB","4568580f7416eb83":"3eQLH"}],"jSEaB":[function(require,module,exports,__globalThis) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function createSet(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"lp29B","a02c367b3608ccee":"dS0xS","cd8d0af6a14b2f7d":"3eQLH"}],"2Sfz5":[function(require,module,exports,__globalThis) {
var baseIteratee = require("4f51b0fed4eb5815"), negate = require("2e30ffcdce37b156"), pickBy = require("8525cfbf72d27786");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function omitBy(object, predicate) {
    return pickBy(object, negate(baseIteratee(predicate)));
}
module.exports = omitBy;

},{"4f51b0fed4eb5815":"exkHY","2e30ffcdce37b156":"joH1K","8525cfbf72d27786":"fTum2"}],"joH1K":[function(require,module,exports,__globalThis) {
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = negate;

},{}],"fTum2":[function(require,module,exports,__globalThis) {
var arrayMap = require("6fd113b3f5002de4"), baseIteratee = require("1e32e0d8feab18e"), basePickBy = require("85ba60b03da46517"), getAllKeysIn = require("86922ee5dcf85621");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6fd113b3f5002de4":"5ZiZU","1e32e0d8feab18e":"exkHY","85ba60b03da46517":"ftzWM","86922ee5dcf85621":"7M3rF"}],"7M3rF":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"1VPsK","feede5d0a2d06427":"iT0tM","287f70f798405911":"fCgzE"}],"iT0tM":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"iS8Vi","6ccae2aa7cfa3c66":"fiIZQ","bdb501682ee9305d":"9pWhx","7641fe4ae6d2cc96":"hZ3M8"}],"5rlHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This method will remove data points that fall outside of the desired domain (non-continuous charts only)
parcelHelpers.export(exports, "formatDataFromDomain", function() {
    return formatDataFromDomain;
});
/**
 * Returns an object mapping string data to numeric data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Object} an object mapping string data to numeric data
 */ parcelHelpers.export(exports, "createStringMap", function() {
    return createStringMap;
});
/**
 * Reduces the size of a data array, such that it is <= maxPoints.
 * @param {Array} data: an array of data; must be sorted
 * @param {Number} maxPoints: maximum number of data points to return
 * @param {Number} startingIndex: the index of the data[0] *in the entire dataset*; this function
                   assumes `data` param is a subset of larger dataset that has been zoommed
  * @returns {Array} an array of data, a subset of data param
  */ parcelHelpers.export(exports, "downsample", function() {
    return downsample;
});
/**
 * Returns formatted data. Data accessors are applied, and string values are replaced.
 * @param {Array} dataset: the original domain
 * @param {Object} props: the props object
 * @param {Array} expectedKeys: an array of expected data keys
 * @returns {Array} the formatted data
 */ parcelHelpers.export(exports, "formatData", function() {
    return formatData;
});
/**
 * Returns generated x and y data based on domain and sample from props
 * @param {Object} props: the props object
 * @returns {Array} an array of data
 */ parcelHelpers.export(exports, "generateData", function() {
    return generateData;
});
/**
 * Returns an array of categories for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of categories
 */ parcelHelpers.export(exports, "getCategories", function() {
    return getCategories;
});
/**
 * Returns an array of formatted data
 * @param {Object} props: the props object
 * @returns {Array} an array of data
 */ parcelHelpers.export(exports, "getData", function() {
    return getData;
});
/**
 * Returns an array of strings from axis tickValues for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */ parcelHelpers.export(exports, "getStringsFromAxes", function() {
    return getStringsFromAxes;
});
/**
 * Returns an array of strings from categories for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */ parcelHelpers.export(exports, "getStringsFromCategories", function() {
    return getStringsFromCategories;
});
/**
 * Returns an array of strings from data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} an array of strings
 */ parcelHelpers.export(exports, "getStringsFromData", function() {
    return getStringsFromData;
});
/**
 * Checks whether a given component can be used to calculate data
 * @param {Component} component: a React component instance
 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
 */ parcelHelpers.export(exports, "isDataComponent", function() {
    return isDataComponent;
});
var _omitBy = require("lodash/omitBy");
var _omitByDefault = parcelHelpers.interopDefault(_omitBy);
var _isUndefined = require("lodash/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _orderBy = require("lodash/orderBy");
var _orderByDefault = parcelHelpers.interopDefault(_orderBy);
var _property = require("lodash/property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _helpers = require("./helpers");
var _collection = require("./collection");
var _scale = require("./scale");
var _immutable = require("./immutable"); // Private Functions
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function parseDatum(datum) {
    var immutableDatumWhitelist = {
        errorX: true,
        errorY: true
    };
    return _immutable.isImmutable(datum) ? _immutable.shallowToJS(datum, immutableDatumWhitelist) : datum;
}
function getLength(data) {
    return _immutable.isIterable(data) ? data.size : data.length;
} // Returns generated data for a given axis based on domain and sample from props
function generateDataArray(props, axis) {
    var propsDomain = (0, _isPlainObjectDefault.default)(props.domain) ? props.domain[axis] : props.domain;
    var domain = propsDomain || _scale.getBaseScale(props, axis).domain();
    var samples = props.samples || 1;
    var domainMax = Math.max.apply(Math, _toConsumableArray(domain));
    var domainMin = Math.min.apply(Math, _toConsumableArray(domain));
    var step = (domainMax - domainMin) / samples;
    var values = (0, _rangeDefault.default)(domainMin, domainMax, step);
    return (0, _lastDefault.default)(values) === domainMax ? values : values.concat(domainMax);
} // Returns sorted data. If no sort keys are provided, data is returned unaltered.
function sortData(dataset, sortKey) {
    var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
    if (!sortKey) return dataset;
     // Ensures previous VictoryLine api for sortKey prop stays consistent
    if (sortKey === "x" || sortKey === "y") sortKey = "_".concat(sortKey);
    var order = sortOrder === "ascending" ? "asc" : "desc";
    return (0, _orderByDefault.default)(dataset, sortKey, order);
} // This method will remove data points that break certain scales. (log scale only)
function cleanData(dataset, props) {
    var smallNumber = 1 / Number.MAX_SAFE_INTEGER;
    var scaleType = {
        x: _scale.getScaleType(props, "x"),
        y: _scale.getScaleType(props, "y")
    };
    if (scaleType.x !== "log" && scaleType.y !== "log") return dataset;
    var rules = function rules(datum, axis) {
        return scaleType[axis] === "log" ? datum["_".concat(axis)] !== 0 : true;
    };
    var sanitize = function sanitize(datum) {
        var _x = rules(datum, "x") ? datum._x : smallNumber;
        var _y = rules(datum, "y") ? datum._y : smallNumber;
        var _y0 = rules(datum, "y0") ? datum._y0 : smallNumber;
        return (0, _assignDefault.default)({}, datum, {
            _x: _x,
            _y: _y,
            _y0: _y0
        });
    };
    return dataset.map(function(datum) {
        if (rules(datum, "x") && rules(datum, "y") && rules(datum, "y0")) return datum;
        return sanitize(datum);
    });
} // Returns a data accessor given an eventKey prop
function getEventKey(key) {
    // creates a data accessor function
    // given a property key, path, array index, or null for identity.
    if ((0, _isFunctionDefault.default)(key)) return key;
    else if (key === null || key === undefined) return function() {
        return undefined;
    };
     // otherwise, assume it is an array index, property key or path (_.property handles all three)
    return (0, _propertyDefault.default)(key);
} // Returns data with an eventKey prop added to each datum
function addEventKeys(props, data) {
    var hasEventKeyAccessor = !!props.eventKey;
    var eventKeyAccessor = getEventKey(props.eventKey);
    return data.map(function(datum, index) {
        if (datum.eventKey !== undefined) return datum;
        else if (hasEventKeyAccessor) {
            var eventKey = eventKeyAccessor(datum, index);
            return eventKey !== undefined ? (0, _assignDefault.default)({
                eventKey: eventKey
            }, datum) : datum;
        } else return datum;
    });
} // Exported Functions
function formatDataFromDomain(dataset, domain, defaultBaseline) {
    var exists = function exists(val) {
        return val !== undefined;
    };
    var minDomainX = _collection.getMinValue(domain.x);
    var maxDomainX = _collection.getMaxValue(domain.x);
    var minDomainY = _collection.getMinValue(domain.y);
    var maxDomainY = _collection.getMaxValue(domain.y);
    var underMin = function underMin(min) {
        return function(val) {
            return exists(val) && val < min;
        };
    };
    var overMax = function overMax(max) {
        return function(val) {
            return exists(val) && val > max;
        };
    };
    var isUnderMinX = underMin(minDomainX);
    var isUnderMinY = underMin(minDomainY);
    var isOverMaxX = overMax(maxDomainX);
    var isOverMaxY = overMax(maxDomainY); // eslint-disable-next-line complexity
    return dataset.map(function(datum) {
        var _x = datum._x, _y = datum._y, _y0 = datum._y0, _y1 = datum._y1; // single x point less than min domain
        if (isUnderMinX(_x) || isOverMaxX(_x)) _x = null;
        var baseline = exists(_y0) ? _y0 : defaultBaseline;
        var value = exists(_y1) ? _y1 : _y;
        if (!exists(value)) return datum; // value only and less than min domain or greater than max domain
        if (!exists(baseline) && (isUnderMinY(value) || isOverMaxY(value))) _y = null; // baseline and value are both less than min domain or both greater than max domain
        if (isUnderMinY(baseline) && isUnderMinY(value) || isOverMaxY(baseline) && isOverMaxY(value)) _y = _y0 = _y1 = null; // baseline and value with only baseline below min, set baseline to minDomainY
        if (isUnderMinY(baseline) && !isUnderMinY(value)) _y0 = minDomainY; // baseline and value with only baseline above max, set baseline to maxDomainY
        if (isOverMaxY(baseline) && !isOverMaxY(value)) _y0 = maxDomainY;
        return (0, _assignDefault.default)({}, datum, (0, _omitByDefault.default)({
            _x: _x,
            _y: _y,
            _y0: _y0,
            _y1: _y1
        }, (0, _isUndefinedDefault.default)));
    });
}
function createStringMap(props, axis) {
    var stringsFromAxes = getStringsFromAxes(props, axis);
    var stringsFromCategories = getStringsFromCategories(props, axis);
    var stringsFromData = getStringsFromData(props, axis);
    var allStrings = (0, _uniqDefault.default)(_toConsumableArray(stringsFromAxes).concat(_toConsumableArray(stringsFromCategories), _toConsumableArray(stringsFromData)));
    return allStrings.length === 0 ? null : allStrings.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
}
function downsample(data, maxPoints) {
    var startingIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // ensures that the downampling of data while zooming looks good.
    var dataLength = getLength(data);
    if (dataLength > maxPoints) {
        // limit k to powers of 2, e.g. 64, 128, 256
        // so that the same points will be chosen reliably, reducing flicker on zoom
        var k = Math.pow(2, Math.ceil(Math.log2(dataLength / maxPoints)));
        return data.filter(function(d, i) {
            return (i + startingIndex) % k === 0;
        });
    }
    return data;
}
function formatData(dataset, props, expectedKeys) {
    var isArrayOrIterable = Array.isArray(dataset) || _immutable.isIterable(dataset);
    if (!isArrayOrIterable || getLength(dataset) < 1) return [];
    var defaultKeys = [
        "x",
        "y",
        "y0"
    ];
    expectedKeys = Array.isArray(expectedKeys) ? expectedKeys : defaultKeys;
    var createAccessor = function createAccessor(name) {
        return _helpers.createAccessor(props[name] !== undefined ? props[name] : name);
    };
    var accessor = expectedKeys.reduce(function(memo, type) {
        memo[type] = createAccessor(type);
        return memo;
    }, {});
    var preformattedData = (0, _isEqualDefault.default)(expectedKeys, defaultKeys) && props.x === "_x" && props.y === "_y" && props.y0 === "_y0";
    var stringMap;
    if (preformattedData === false) // stringMap is not required if the data is preformatted
    stringMap = {
        x: expectedKeys.indexOf("x") !== -1 ? createStringMap(props, "x") : undefined,
        y: expectedKeys.indexOf("y") !== -1 ? createStringMap(props, "y") : undefined,
        y0: expectedKeys.indexOf("y0") !== -1 ? createStringMap(props, "y") : undefined
    };
    var data = preformattedData ? dataset : dataset.reduce(function(dataArr, datum, index) {
        // eslint-disable-line complexity
        datum = parseDatum(datum);
        var fallbackValues = {
            x: index,
            y: datum
        };
        var processedValues = expectedKeys.reduce(function(memo, type) {
            var processedValue = accessor[type](datum);
            var value = processedValue !== undefined ? processedValue : fallbackValues[type];
            if (value !== undefined) {
                if (typeof value === "string" && stringMap[type]) {
                    memo["".concat(type, "Name")] = value;
                    memo["_".concat(type)] = stringMap[type][value];
                } else memo["_".concat(type)] = value;
            }
            return memo;
        }, {});
        var formattedDatum = (0, _assignDefault.default)({}, processedValues, datum);
        if (!(0, _isEmptyDefault.default)(formattedDatum)) dataArr.push(formattedDatum);
        return dataArr;
    }, []);
    var sortedData = sortData(data, props.sortKey, props.sortOrder);
    var cleanedData = cleanData(sortedData, props);
    return addEventKeys(props, cleanedData);
}
function generateData(props) {
    var xValues = generateDataArray(props, "x");
    var yValues = generateDataArray(props, "y");
    var values = xValues.map(function(x, i) {
        return {
            x: x,
            y: yValues[i]
        };
    });
    return values;
}
function getCategories(props, axis) {
    return props.categories && !Array.isArray(props.categories) ? props.categories[axis] : props.categories;
}
function getData(props) {
    return props.data ? formatData(props.data, props) : formatData(generateData(props), props);
}
function getStringsFromAxes(props, axis) {
    var tickValues = props.tickValues, tickFormat = props.tickFormat;
    var tickValueArray;
    if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) tickValueArray = tickFormat && Array.isArray(tickFormat) ? tickFormat : [];
    else tickValueArray = tickValues[axis] || tickValues;
    return tickValueArray.filter(function(val) {
        return typeof val === "string";
    });
}
function getStringsFromCategories(props, axis) {
    if (!props.categories) return [];
    var categories = getCategories(props, axis);
    var categoryStrings = categories && categories.filter(function(val) {
        return typeof val === "string";
    });
    return categoryStrings ? _collection.removeUndefined(categoryStrings) : [];
}
function getStringsFromData(props, axis) {
    var isArrayOrIterable = Array.isArray(props.data) || _immutable.isIterable(props.data);
    if (!isArrayOrIterable) return [];
    var key = props[axis] === undefined ? axis : props[axis];
    var accessor = _helpers.createAccessor(key); // support immutable data
    var data = props.data.reduce(function(memo, d) {
        memo.push(parseDatum(d));
        return memo;
    }, []);
    var sortedData = sortData(data, props.sortKey, props.sortOrder);
    var dataStrings = sortedData.reduce(function(dataArr, datum) {
        datum = parseDatum(datum);
        dataArr.push(accessor(datum));
        return dataArr;
    }, []).filter(function(datum) {
        return typeof datum === "string";
    }); // return a unique set of strings
    return dataStrings.reduce(function(prev, curr) {
        if (curr !== undefined && curr !== null && prev.indexOf(curr) === -1) prev.push(curr);
        return prev;
    }, []);
}
function isDataComponent(component) {
    var getRole = function getRole(child) {
        return child && child.type ? child.type.role : "";
    };
    var role = getRole(component);
    if (role === "portal") {
        var children = (0, _reactDefault.default).Children.toArray(component.props.children);
        role = children.length ? getRole(children[0]) : "";
    }
    var whitelist = [
        "area",
        "bar",
        "boxplot",
        "candlestick",
        "errorbar",
        "group",
        "histogram",
        "line",
        "pie",
        "scatter",
        "stack",
        "voronoi"
    ];
    return (0, _includesDefault.default)(whitelist, role);
}

},{"lodash/omitBy":"2Sfz5","lodash/isUndefined":"2LsMf","lodash/includes":"2bZ7U","lodash/isEqual":"6bbKw","lodash/isEmpty":"15wZF","lodash/orderBy":"kNMvc","lodash/property":"bqkBM","lodash/isPlainObject":"2RXyg","lodash/isFunction":"8ck2f","lodash/last":"7crLt","lodash/range":"3wXYB","lodash/uniq":"2LHAg","lodash/assign":"xTxAt","react":"gVheC","./helpers":"8ABme","./collection":"4mxxX","./scale":"je6Bi","./immutable":"iHQOu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LsMf":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
    return value === undefined;
}
module.exports = isUndefined;

},{}],"7crLt":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"je6Bi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScaleFromName", function() {
    return getScaleFromName;
});
parcelHelpers.export(exports, "getBaseScale", function() {
    return getBaseScale;
});
parcelHelpers.export(exports, "getDefaultScale", function() {
    return getDefaultScale;
});
parcelHelpers.export(exports, "getScaleFromProps", function() {
    return getScaleFromProps;
});
parcelHelpers.export(exports, "getScaleType", function() {
    return getScaleType;
});
parcelHelpers.export(exports, "getType", function() {
    return getType;
});
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _helpers = require("./helpers");
var _collection = require("./collection");
var _d3Scale = require("d3-scale");
var supportedScaleStrings = [
    "linear",
    "time",
    "log",
    "sqrt"
]; // Private Functions
function toNewName(scale) {
    // d3 scale changed the naming scheme for scale from "linear" -> "scaleLinear" etc.
    var capitalize = function capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    };
    return "scale".concat(capitalize(scale));
}
function validScale(scale) {
    if (typeof scale === "function") return (0, _isFunctionDefault.default)(scale.copy) && (0, _isFunctionDefault.default)(scale.domain) && (0, _isFunctionDefault.default)(scale.range);
    else if (typeof scale === "string") return (0, _includesDefault.default)(supportedScaleStrings, scale);
    return false;
}
function isScaleDefined(props, axis) {
    if (!props.scale) return false;
    else if (props.scale.x || props.scale.y) return props.scale[axis] ? true : false;
    return true;
}
function getScaleTypeFromProps(props, axis) {
    if (!isScaleDefined(props, axis)) return undefined;
    var scale = props.scale[axis] || props.scale;
    return typeof scale === "string" ? scale : getType(scale);
}
function getScaleFromDomain(props, axis) {
    var domain;
    if (props.domain && props.domain[axis]) domain = props.domain[axis];
    else if (props.domain && Array.isArray(props.domain)) domain = props.domain;
    if (!domain) return undefined;
    return _collection.containsDates(domain) ? "time" : "linear";
}
function getScaleTypeFromData(props, axis) {
    if (!props.data) return "linear";
    var accessor = _helpers.createAccessor(props[axis]);
    var axisData = props.data.map(function(datum) {
        var processedData = (0, _isPlainObjectDefault.default)(accessor(datum)) ? accessor(datum)[axis] : accessor(datum);
        return processedData !== undefined ? processedData : datum[axis];
    });
    return _collection.containsDates(axisData) ? "time" : "linear";
} // Exported Functions
function getScaleFromName(name) {
    return validScale(name) ? _d3Scale[toNewName(name)]() : _d3Scale.scaleLinear();
}
function getBaseScale(props, axis) {
    var scale = getScaleFromProps(props, axis);
    if (scale) return typeof scale === "string" ? getScaleFromName(scale) : scale;
    var defaultScale = getScaleFromDomain(props, axis) || getScaleTypeFromData(props, axis);
    return _d3Scale[toNewName(defaultScale)]();
}
function getDefaultScale() {
    return _d3Scale.scaleLinear();
}
function getScaleFromProps(props, axis) {
    if (!isScaleDefined(props, axis)) return undefined;
    var scale = props.scale[axis] || props.scale;
    if (validScale(scale)) return (0, _isFunctionDefault.default)(scale) ? scale : _d3Scale[toNewName(scale)]();
    return undefined;
}
function getScaleType(props, axis) {
    // if the scale was not given in props, it will be set to linear or time depending on data
    return getScaleTypeFromProps(props, axis) || getScaleTypeFromData(props, axis);
}
function getType(scale) {
    if (typeof scale === "string") return scale;
    var duckTypes = [
        {
            name: "log",
            method: "base"
        },
        {
            name: "ordinal",
            method: "unknown"
        },
        {
            name: "pow-sqrt",
            method: "exponent"
        },
        {
            name: "quantile",
            method: "quantiles"
        },
        {
            name: "quantize-threshold",
            method: "invertExtent"
        }
    ];
    var scaleType = duckTypes.filter(function(type) {
        return scale[type.method] !== undefined;
    })[0];
    return scaleType ? scaleType.name : undefined;
}

},{"lodash/isPlainObject":"2RXyg","lodash/isFunction":"8ck2f","lodash/includes":"2bZ7U","./helpers":"8ABme","./collection":"4mxxX","d3-scale":"6gvDa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gvDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", function() {
    return 0, _bandDefault.default;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return 0, _band.point;
});
parcelHelpers.export(exports, "scaleIdentity", function() {
    return 0, _identityDefault.default;
});
parcelHelpers.export(exports, "scaleLinear", function() {
    return 0, _linearDefault.default;
});
parcelHelpers.export(exports, "scaleLog", function() {
    return 0, _logDefault.default;
});
parcelHelpers.export(exports, "scaleOrdinal", function() {
    return 0, _ordinalDefault.default;
});
parcelHelpers.export(exports, "scaleImplicit", function() {
    return 0, _ordinal.implicit;
});
parcelHelpers.export(exports, "scalePow", function() {
    return 0, _powDefault.default;
});
parcelHelpers.export(exports, "scaleSqrt", function() {
    return 0, _pow.sqrt;
});
parcelHelpers.export(exports, "scaleQuantile", function() {
    return 0, _quantileDefault.default;
});
parcelHelpers.export(exports, "scaleQuantize", function() {
    return 0, _quantizeDefault.default;
});
parcelHelpers.export(exports, "scaleThreshold", function() {
    return 0, _thresholdDefault.default;
});
parcelHelpers.export(exports, "scaleTime", function() {
    return 0, _timeDefault.default;
});
parcelHelpers.export(exports, "scaleUtc", function() {
    return 0, _utcTimeDefault.default;
});
parcelHelpers.export(exports, "schemeCategory10", function() {
    return 0, _category10Default.default;
});
parcelHelpers.export(exports, "schemeCategory20b", function() {
    return 0, _category20BDefault.default;
});
parcelHelpers.export(exports, "schemeCategory20c", function() {
    return 0, _category20CDefault.default;
});
parcelHelpers.export(exports, "schemeCategory20", function() {
    return 0, _category20Default.default;
});
parcelHelpers.export(exports, "interpolateCubehelixDefault", function() {
    return 0, _cubehelixDefault.default;
});
parcelHelpers.export(exports, "interpolateRainbow", function() {
    return 0, _rainbowDefault.default;
});
parcelHelpers.export(exports, "interpolateWarm", function() {
    return 0, _rainbow.warm;
});
parcelHelpers.export(exports, "interpolateCool", function() {
    return 0, _rainbow.cool;
});
parcelHelpers.export(exports, "interpolateViridis", function() {
    return 0, _viridisDefault.default;
});
parcelHelpers.export(exports, "interpolateMagma", function() {
    return 0, _viridis.magma;
});
parcelHelpers.export(exports, "interpolateInferno", function() {
    return 0, _viridis.inferno;
});
parcelHelpers.export(exports, "interpolatePlasma", function() {
    return 0, _viridis.plasma;
});
parcelHelpers.export(exports, "scaleSequential", function() {
    return 0, _sequentialDefault.default;
});
var _band = require("./src/band");
var _bandDefault = parcelHelpers.interopDefault(_band);
var _identity = require("./src/identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _linear = require("./src/linear");
var _linearDefault = parcelHelpers.interopDefault(_linear);
var _log = require("./src/log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _ordinal = require("./src/ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
var _pow = require("./src/pow");
var _powDefault = parcelHelpers.interopDefault(_pow);
var _quantile = require("./src/quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _quantize = require("./src/quantize");
var _quantizeDefault = parcelHelpers.interopDefault(_quantize);
var _threshold = require("./src/threshold");
var _thresholdDefault = parcelHelpers.interopDefault(_threshold);
var _time = require("./src/time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _utcTime = require("./src/utcTime");
var _utcTimeDefault = parcelHelpers.interopDefault(_utcTime);
var _category10 = require("./src/category10");
var _category10Default = parcelHelpers.interopDefault(_category10);
var _category20B = require("./src/category20b");
var _category20BDefault = parcelHelpers.interopDefault(_category20B);
var _category20C = require("./src/category20c");
var _category20CDefault = parcelHelpers.interopDefault(_category20C);
var _category20 = require("./src/category20");
var _category20Default = parcelHelpers.interopDefault(_category20);
var _cubehelix = require("./src/cubehelix");
var _cubehelixDefault = parcelHelpers.interopDefault(_cubehelix);
var _rainbow = require("./src/rainbow");
var _rainbowDefault = parcelHelpers.interopDefault(_rainbow);
var _viridis = require("./src/viridis");
var _viridisDefault = parcelHelpers.interopDefault(_viridis);
var _sequential = require("./src/sequential");
var _sequentialDefault = parcelHelpers.interopDefault(_sequential);

},{"./src/band":"i8KYH","./src/identity":"kKiEt","./src/linear":"8ILtO","./src/log":"cQwdA","./src/ordinal":"3DaDh","./src/pow":"cWMIf","./src/quantile":"e3INQ","./src/quantize":"ltcWX","./src/threshold":"eXbkx","./src/time":"lAxfT","./src/utcTime":"bs4rK","./src/category10":"aWERQ","./src/category20b":"2j9rf","./src/category20c":"4sYxy","./src/category20":"eW0O9","./src/cubehelix":"hDJXw","./src/rainbow":"11acP","./src/viridis":"iv3B5","./src/sequential":"99iTD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8KYH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return band;
});
parcelHelpers.export(exports, "point", function() {
    return point;
});
var _d3Array = require("d3-array");
var _ordinal = require("./ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
function band() {
    var scale = (0, _ordinalDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band().paddingInner(1));
}

},{"d3-array":"epkQ7","./ordinal":"3DaDh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"epkQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", function() {
    return 0, _bisectDefault.default;
});
parcelHelpers.export(exports, "bisectRight", function() {
    return 0, _bisect.bisectRight;
});
parcelHelpers.export(exports, "bisectLeft", function() {
    return 0, _bisect.bisectLeft;
});
parcelHelpers.export(exports, "ascending", function() {
    return 0, _ascendingDefault.default;
});
parcelHelpers.export(exports, "bisector", function() {
    return 0, _bisectorDefault.default;
});
parcelHelpers.export(exports, "cross", function() {
    return 0, _crossDefault.default;
});
parcelHelpers.export(exports, "descending", function() {
    return 0, _descendingDefault.default;
});
parcelHelpers.export(exports, "deviation", function() {
    return 0, _deviationDefault.default;
});
parcelHelpers.export(exports, "extent", function() {
    return 0, _extentDefault.default;
});
parcelHelpers.export(exports, "histogram", function() {
    return 0, _histogramDefault.default;
});
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", function() {
    return 0, _freedmanDiaconisDefault.default;
});
parcelHelpers.export(exports, "thresholdScott", function() {
    return 0, _scottDefault.default;
});
parcelHelpers.export(exports, "thresholdSturges", function() {
    return 0, _sturgesDefault.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _maxDefault.default;
});
parcelHelpers.export(exports, "mean", function() {
    return 0, _meanDefault.default;
});
parcelHelpers.export(exports, "median", function() {
    return 0, _medianDefault.default;
});
parcelHelpers.export(exports, "merge", function() {
    return 0, _mergeDefault.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _minDefault.default;
});
parcelHelpers.export(exports, "pairs", function() {
    return 0, _pairsDefault.default;
});
parcelHelpers.export(exports, "permute", function() {
    return 0, _permuteDefault.default;
});
parcelHelpers.export(exports, "quantile", function() {
    return 0, _quantileDefault.default;
});
parcelHelpers.export(exports, "range", function() {
    return 0, _rangeDefault.default;
});
parcelHelpers.export(exports, "scan", function() {
    return 0, _scanDefault.default;
});
parcelHelpers.export(exports, "shuffle", function() {
    return 0, _shuffleDefault.default;
});
parcelHelpers.export(exports, "sum", function() {
    return 0, _sumDefault.default;
});
parcelHelpers.export(exports, "ticks", function() {
    return 0, _ticksDefault.default;
});
parcelHelpers.export(exports, "tickIncrement", function() {
    return 0, _ticks.tickIncrement;
});
parcelHelpers.export(exports, "tickStep", function() {
    return 0, _ticks.tickStep;
});
parcelHelpers.export(exports, "transpose", function() {
    return 0, _transposeDefault.default;
});
parcelHelpers.export(exports, "variance", function() {
    return 0, _varianceDefault.default;
});
parcelHelpers.export(exports, "zip", function() {
    return 0, _zipDefault.default;
});
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var _cross = require("./cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _descending = require("./descending");
var _descendingDefault = parcelHelpers.interopDefault(_descending);
var _deviation = require("./deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _histogram = require("./histogram");
var _histogramDefault = parcelHelpers.interopDefault(_histogram);
var _freedmanDiaconis = require("./threshold/freedmanDiaconis");
var _freedmanDiaconisDefault = parcelHelpers.interopDefault(_freedmanDiaconis);
var _scott = require("./threshold/scott");
var _scottDefault = parcelHelpers.interopDefault(_scott);
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);
var _max = require("./max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _mean = require("./mean");
var _meanDefault = parcelHelpers.interopDefault(_mean);
var _median = require("./median");
var _medianDefault = parcelHelpers.interopDefault(_median);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _pairs = require("./pairs");
var _pairsDefault = parcelHelpers.interopDefault(_pairs);
var _permute = require("./permute");
var _permuteDefault = parcelHelpers.interopDefault(_permute);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _scan = require("./scan");
var _scanDefault = parcelHelpers.interopDefault(_scan);
var _shuffle = require("./shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _sum = require("./sum");
var _sumDefault = parcelHelpers.interopDefault(_sum);
var _ticks = require("./ticks");
var _ticksDefault = parcelHelpers.interopDefault(_ticks);
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);
var _zip = require("./zip");
var _zipDefault = parcelHelpers.interopDefault(_zip);

},{"./bisect":"juTh1","./ascending":"lbwVs","./bisector":"fM6oX","./cross":"apE40","./descending":"hVZ6Z","./deviation":"6Xs9l","./extent":"iO8CF","./histogram":"l4PxY","./threshold/freedmanDiaconis":"zEJGO","./threshold/scott":"23MQr","./threshold/sturges":"g5uRO","./max":"fRj91","./mean":"i2ZxK","./median":"fjnwa","./merge":"bTqx8","./min":"17SzC","./pairs":"4bjHL","./permute":"e74ql","./quantile":"cssN4","./range":"hRt1u","./scan":"ekQrE","./shuffle":"9W8nK","./sum":"dIR3o","./ticks":"bCIPZ","./transpose":"utmHU","./variance":"7lStN","./zip":"dsflt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"juTh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", function() {
    return bisectRight;
});
parcelHelpers.export(exports, "bisectLeft", function() {
    return bisectLeft;
});
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var ascendingBisect = (0, _bisectorDefault.default)((0, _ascendingDefault.default));
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
exports.default = bisectRight;

},{"./ascending":"lbwVs","./bisector":"fM6oX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lbwVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fM6oX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(compare) {
        if (compare.length === 1) compare = ascendingComparator(compare);
        return {
            left: function left(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }
                return lo;
            },
            right: function right(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) > 0) hi = mid;
                    else lo = mid + 1;
                }
                return lo;
            }
        };
    };
});
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
function ascendingComparator(f) {
    return function(d, x) {
        return (0, _ascendingDefault.default)(f(d), x);
    };
}

},{"./ascending":"lbwVs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"apE40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values0, values1, reduce) {
        var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
        if (reduce == null) reduce = (0, _pairs.pair);
        for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
        return values;
    };
});
var _pairs = require("./pairs");

},{"./pairs":"4bjHL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4bjHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(array, f) {
        if (f == null) f = pair;
        var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
        while(i < n)pairs[i] = f(p, p = array[++i]);
        return pairs;
    };
});
parcelHelpers.export(exports, "pair", function() {
    return pair;
});
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVZ6Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Xs9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(array, f) {
        var v = (0, _varianceDefault.default)(array, f);
        return v ? Math.sqrt(v) : v;
    };
});
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);

},{"./variance":"7lStN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7lStN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        }
        if (m > 1) return sum / (m - 1);
    };
});
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"9lt9h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9lt9h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x === null ? NaN : +x;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iO8CF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, i = -1, value, min, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = values[i]) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l4PxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var value = (0, _identityDefault.default), domain = (0, _extentDefault.default), threshold = (0, _sturgesDefault.default);
        function histogram(data) {
            var i, n = data.length, x, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                tz = (0, _ticks.tickStep)(x0, x1, tz);
                tz = (0, _rangeDefault.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while(tz[0] <= x0)tz.shift(), --m;
            while(tz[m - 1] > x1)tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for(i = 0; i < n; ++i){
                x = values[i];
                if (x0 <= x && x <= x1) bins[(0, _bisectDefault.default)(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantDefault.default)(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantDefault.default)([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantDefault.default)((0, _array.slice).call(_)) : (0, _constantDefault.default)(_), histogram) : threshold;
        };
        return histogram;
    };
});
var _array = require("./array");
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _identity = require("./identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _ticks = require("./ticks");
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);

},{"./array":"gN5wc","./bisect":"juTh1","./constant":"swTiD","./extent":"iO8CF","./identity":"h3MH6","./range":"hRt1u","./ticks":"bCIPZ","./threshold/sturges":"g5uRO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gN5wc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", function() {
    return slice;
});
parcelHelpers.export(exports, "map", function() {
    return map;
});
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"swTiD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h3MH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hRt1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bCIPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            start = Math.ceil(start / step);
            stop = Math.floor(stop / step);
            ticks = new Array(n = Math.ceil(stop - start + 1));
            while(++i < n)ticks[i] = (start + i) * step;
        } else {
            start = Math.floor(start * step);
            stop = Math.ceil(stop * step);
            ticks = new Array(n = Math.ceil(start - stop + 1));
            while(++i < n)ticks[i] = (start - i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    };
});
parcelHelpers.export(exports, "tickIncrement", function() {
    return tickIncrement;
});
parcelHelpers.export(exports, "tickStep", function() {
    return tickStep;
});
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g5uRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"zEJGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, min, max) {
        values = (0, _array.map).call(values, (0, _numberDefault.default)).sort((0, _ascendingDefault.default));
        return Math.ceil((max - min) / (2 * ((0, _quantileDefault.default)(values, 0.75) - (0, _quantileDefault.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
    };
});
var _array = require("../array");
var _ascending = require("../ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("../number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("../quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"../array":"gN5wc","../ascending":"lbwVs","../number":"9lt9h","../quantile":"cssN4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cssN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, p, valueof) {
        if (valueof == null) valueof = (0, _numberDefault.default);
        if (!(n = values.length)) return;
        if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    };
});
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"9lt9h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"23MQr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, min, max) {
        return Math.ceil((max - min) / (3.5 * (0, _deviationDefault.default)(values) * Math.pow(values.length, -1 / 3)));
    };
});
var _deviation = require("../deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);

},{"../deviation":"6Xs9l","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fRj91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, i = -1, value, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = values[i]) != null && value > max) max = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
            }
        }
        return max;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i2ZxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, m = n, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) sum += value;
            else --m;
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) sum += value;
            else --m;
        }
        if (m) return sum / m;
    };
});
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"9lt9h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fjnwa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, i = -1, value, numbers = [];
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) numbers.push(value);
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) numbers.push(value);
        }
        return (0, _quantileDefault.default)(numbers.sort((0, _ascendingDefault.default)), 0.5);
    };
});
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"./ascending":"lbwVs","./number":"9lt9h","./quantile":"cssN4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bTqx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(arrays) {
        var n = arrays.length, m, i = -1, j = 0, merged, array;
        while(++i < n)j += arrays[i].length;
        merged = new Array(j);
        while(--n >= 0){
            array = arrays[n];
            m = array.length;
            while(--m >= 0)merged[--j] = array[m];
        }
        return merged;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17SzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, i = -1, value, min;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = values[i]) != null && min > value) min = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
            }
        }
        return min;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e74ql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(array, indexes) {
        var i = indexes.length, permutes = new Array(i);
        while(i--)permutes[i] = array[indexes[i]];
        return permutes;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ekQrE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, compare) {
        if (!(n = values.length)) return;
        var n, i = 0, j = 0, xi, xj = values[j];
        if (compare == null) compare = (0, _ascendingDefault.default);
        while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
        if (compare(xj, xj) === 0) return j;
    };
});
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);

},{"./ascending":"lbwVs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9W8nK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(array, i0, i1) {
        var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
        while(m){
            i = Math.random() * m-- | 0;
            t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dIR3o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values, valueof) {
        var n = values.length, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
        } else {
            while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
        }
        return sum;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"utmHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = (0, _minDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    };
});
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
function length(d) {
    return d.length;
}

},{"./min":"17SzC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dsflt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        return (0, _transposeDefault.default)(arguments);
    };
});
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);

},{"./transpose":"utmHU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3DaDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", function() {
    return implicit;
});
parcelHelpers.export(exports, "default", function() {
    return ordinal;
});
var _d3Collection = require("d3-collection");
var _array = require("./array");
var implicit = {
    name: "implicit"
};
function ordinal(range) {
    var index = (0, _d3Collection.map)(), domain = [], unknown = implicit;
    range = range == null ? [] : (0, _array.slice).call(range);
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== implicit) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, _d3Collection.map)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal().domain(domain).range(range).unknown(unknown);
    };
    return scale;
}

},{"d3-collection":"aFbPW","./array":"eP8dh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aFbPW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nest", function() {
    return 0, _nestDefault.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _setDefault.default;
});
parcelHelpers.export(exports, "map", function() {
    return 0, _mapDefault.default;
});
parcelHelpers.export(exports, "keys", function() {
    return 0, _keysDefault.default;
});
parcelHelpers.export(exports, "values", function() {
    return 0, _valuesDefault.default;
});
parcelHelpers.export(exports, "entries", function() {
    return 0, _entriesDefault.default;
});
var _nest = require("./nest");
var _nestDefault = parcelHelpers.interopDefault(_nest);
var _set = require("./set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _keys = require("./keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _values = require("./values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _entries = require("./entries");
var _entriesDefault = parcelHelpers.interopDefault(_entries);

},{"./nest":"blAPk","./set":"caPZC","./map":"4CEbq","./keys":"bCG1C","./values":"afSnR","./entries":"bN8dB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"blAPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var keys = [], sortKeys = [], sortValues, rollup, nest;
        function apply(array, depth, createResult, setResult) {
            if (depth >= keys.length) {
                if (sortValues != null) array.sort(sortValues);
                return rollup != null ? rollup(array) : array;
            }
            var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, _mapDefault.default)(), values, result = createResult();
            while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
            else valuesByKey.set(keyValue, [
                value
            ]);
            valuesByKey.each(function(values, key) {
                setResult(result, key, apply(values, depth, createResult, setResult));
            });
            return result;
        }
        function entries(map, depth) {
            if (++depth > keys.length) return map;
            var array, sortKey = sortKeys[depth - 1];
            if (rollup != null && depth >= keys.length) array = map.entries();
            else array = [], map.each(function(v, k) {
                array.push({
                    key: k,
                    values: entries(v, depth)
                });
            });
            return sortKey != null ? array.sort(function(a, b) {
                return sortKey(a.key, b.key);
            }) : array;
        }
        return nest = {
            object: function object(array) {
                return apply(array, 0, createObject, setObject);
            },
            map: function map(array) {
                return apply(array, 0, createMap, setMap);
            },
            entries: function entries1(array) {
                return entries(apply(array, 0, createMap, setMap), 0);
            },
            key: function key(d) {
                keys.push(d);
                return nest;
            },
            sortKeys: function sortKeys1(order) {
                sortKeys[keys.length - 1] = order;
                return nest;
            },
            sortValues: function sortValues1(order) {
                sortValues = order;
                return nest;
            },
            rollup: function rollup1(f) {
                rollup = f;
                return nest;
            }
        };
    };
});
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function createObject() {
    return {};
}
function setObject(object, key, value) {
    object[key] = value;
}
function createMap() {
    return (0, _mapDefault.default)();
}
function setMap(map, key, value) {
    map.set(key, value);
}

},{"./map":"4CEbq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4CEbq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefix", function() {
    return prefix;
});
var prefix = "$";
function Map() {}
Map.prototype = map.prototype = {
    constructor: Map,
    has: function has(key) {
        return prefix + key in this;
    },
    get: function get(key) {
        return this[prefix + key];
    },
    set: function set(key, value) {
        this[prefix + key] = value;
        return this;
    },
    remove: function remove(key) {
        var property = prefix + key;
        return property in this && delete this[property];
    },
    clear: function clear() {
        for(var property in this)if (property[0] === prefix) delete this[property];
    },
    keys: function keys() {
        var keys = [];
        for(var property in this)if (property[0] === prefix) keys.push(property.slice(1));
        return keys;
    },
    values: function values() {
        var values = [];
        for(var property in this)if (property[0] === prefix) values.push(this[property]);
        return values;
    },
    entries: function entries() {
        var entries = [];
        for(var property in this)if (property[0] === prefix) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function size() {
        var size = 0;
        for(var property in this)if (property[0] === prefix) ++size;
        return size;
    },
    empty: function empty() {
        for(var property in this)if (property[0] === prefix) return false;
        return true;
    },
    each: function each(f) {
        for(var property in this)if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
};
function map(object, f) {
    var _$map = new Map;
    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) {
        _$map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)_$map.set(i, object[i]);
        else while(++i < n)_$map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)_$map.set(key, object[key]);
    return _$map;
}
exports.default = map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"caPZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function Set() {}
var proto = (0, _mapDefault.default).prototype;
Set.prototype = set.prototype = {
    constructor: Set,
    has: proto.has,
    add: function add(value) {
        value += "";
        this[(0, _map.prefix) + value] = value;
        return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
};
function set(object, f) {
    var _$set = new Set;
    // Copy constructor.
    if (object instanceof Set) object.each(function(value) {
        _$set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)_$set.add(object[i]);
        else while(++i < n)_$set.add(f(object[i], i, object));
    }
    return _$set;
}
exports.default = set;

},{"./map":"4CEbq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bCG1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(map) {
        var keys = [];
        for(var key in map)keys.push(key);
        return keys;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"afSnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(map) {
        var values = [];
        for(var key in map)values.push(map[key]);
        return values;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bN8dB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(map) {
        var entries = [];
        for(var key in map)entries.push({
            key: key,
            value: map[key]
        });
        return entries;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eP8dh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "slice", function() {
    return slice;
});
var array = Array.prototype;
var map = array.map;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kKiEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return identity;
});
var _array = require("./array");
var _linear = require("./linear");
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
function identity() {
    var domain = [
        0,
        1
    ];
    function scale(x) {
        return +x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), scale) : domain.slice();
    };
    scale.copy = function() {
        return identity().domain(domain);
    };
    return (0, _linear.linearish)(scale);
}

},{"./array":"eP8dh","./linear":"8ILtO","./number":"bo5qk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ILtO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", function() {
    return linearish;
});
parcelHelpers.export(exports, "default", function() {
    return linear;
});
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _tickFormat = require("./tickFormat");
var _tickFormatDefault = parcelHelpers.interopDefault(_tickFormat);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        return (0, _tickFormatDefault.default)(domain(), count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, _d3Array.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousDefault.default)((0, _continuous.deinterpolateLinear), (0, _d3Interpolate.interpolateNumber));
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    return linearish(scale);
}

},{"d3-array":"epkQ7","d3-interpolate":"fifMh","./continuous":"iufei","./tickFormat":"86mUY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iufei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deinterpolateLinear", function() {
    return deinterpolateLinear;
});
parcelHelpers.export(exports, "copy", function() {
    return copy;
});
parcelHelpers.export(exports, "default", function() {
    return continuous;
});
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _array = require("./array");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var unit = [
    0,
    1
];
function deinterpolateLinear(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantDefault.default)(b);
}
function deinterpolateClamp(deinterpolate) {
    return function(a, b) {
        var d = deinterpolate(a = +a, b = +b);
        return function(x) {
            return x <= a ? 0 : x >= b ? 1 : d(x);
        };
    };
}
function reinterpolateClamp(reinterpolate) {
    return function(a, b) {
        var r = reinterpolate(a = +a, b = +b);
        return function(t) {
            return t <= 0 ? a : t >= 1 ? b : r(t);
        };
    };
}
function bimap(domain, range, deinterpolate, reinterpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, deinterpolate, reinterpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = deinterpolate(domain[i], domain[i + 1]);
        r[i] = reinterpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
}
function continuous(deinterpolate, reinterpolate) {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), clamp = false, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
    }
    scale.invert = function(y) {
        return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, _array.slice).call(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, rescale()) : clamp;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    return rescale();
}

},{"d3-array":"epkQ7","d3-interpolate":"fifMh","./array":"eP8dh","./constant":"kqAHF","./number":"bo5qk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kqAHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bo5qk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return +x;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86mUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(domain, count, specifier) {
        var start = domain[0], stop = domain[domain.length - 1], step = (0, _d3Array.tickStep)(start, stop, count == null ? 10 : count), precision;
        specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
                return (0, _d3Format.formatPrefix)(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return (0, _d3Format.format)(specifier);
    };
});
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");

},{"d3-array":"epkQ7","d3-format":"e5rm4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e5rm4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", function() {
    return 0, _defaultLocaleJsDefault.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _defaultLocaleJs.format;
});
parcelHelpers.export(exports, "formatPrefix", function() {
    return 0, _defaultLocaleJs.formatPrefix;
});
parcelHelpers.export(exports, "formatLocale", function() {
    return 0, _localeJsDefault.default;
});
parcelHelpers.export(exports, "formatSpecifier", function() {
    return 0, _formatSpecifierJsDefault.default;
});
parcelHelpers.export(exports, "FormatSpecifier", function() {
    return 0, _formatSpecifierJs.FormatSpecifier;
});
parcelHelpers.export(exports, "precisionFixed", function() {
    return 0, _precisionFixedJsDefault.default;
});
parcelHelpers.export(exports, "precisionPrefix", function() {
    return 0, _precisionPrefixJsDefault.default;
});
parcelHelpers.export(exports, "precisionRound", function() {
    return 0, _precisionRoundJsDefault.default;
});
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"4p7dC","./locale.js":false,"./formatSpecifier.js":"5arUu","./precisionFixed.js":"8zoW7","./precisionPrefix.js":"cGXKR","./precisionRound.js":"eqLc5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4p7dC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", function() {
    return format;
});
parcelHelpers.export(exports, "formatPrefix", function() {
    return formatPrefix;
});
parcelHelpers.export(exports, "default", function() {
    return defaultLocale;
});
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"gsouR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsouR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"5bnnG","./formatGroup.js":"5LCuf","./formatNumerals.js":"35t0E","./formatSpecifier.js":"5arUu","./formatTrim.js":"ghOGz","./formatTypes.js":"ibTeb","./formatPrefixAuto.js":"7BP1n","./identity.js":"jCnYO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5bnnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    };
});
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"4Y95s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Y95s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    };
});
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", function() {
    return formatDecimalParts;
});
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5LCuf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"35t0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5arUu":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatSpecifier;
});
parcelHelpers.export(exports, "FormatSpecifier", function() {
    return FormatSpecifier;
});
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ghOGz":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ibTeb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"4Y95s","./formatPrefixAuto.js":"7BP1n","./formatRounded.js":"ajdiY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7BP1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", function() {
    return prefixExponent;
});
parcelHelpers.export(exports, "default", function() {
    return function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    };
});
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"4Y95s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ajdiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    };
});
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"4Y95s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jCnYO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8zoW7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"5bnnG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGXKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"5bnnG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eqLc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"5bnnG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQwdA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return log;
});
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
function deinterpolate(a, b) {
    return (b = Math.log(b / a)) ? function(x) {
        return Math.log(x / a) / b;
    } : (0, _constantDefault.default)(b);
}
function reinterpolate(a, b) {
    return a < 0 ? function(t) {
        return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
    } : function(t) {
        return Math.pow(b, t) * Math.pow(a, 1 - t);
    };
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function log() {
    var scale = (0, _continuousDefault.default)(deinterpolate, reinterpolate).domain([
        1,
        10
    ]), domain = scale.domain, base = 10, logs = logp(10), pows = powp(10);
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _niceDefault.default)(domain(), {
            floor: function floor(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function ceil(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, log().base(base));
    };
    return scale;
}

},{"d3-array":"epkQ7","d3-format":"e5rm4","./constant":"kqAHF","./nice":"dc09s","./continuous":"iufei","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dc09s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cWMIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return pow;
});
parcelHelpers.export(exports, "sqrt", function() {
    return sqrt;
});
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _linear = require("./linear");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
function raise(x, exponent) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}
function pow() {
    var exponent = 1, scale = (0, _continuousDefault.default)(deinterpolate, reinterpolate), domain = scale.domain;
    function deinterpolate(a, b) {
        return (b = raise(b, exponent) - (a = raise(a, exponent))) ? function(x) {
            return (raise(x, exponent) - a) / b;
        } : (0, _constantDefault.default)(b);
    }
    function reinterpolate(a, b) {
        b = raise(b, exponent) - (a = raise(a, exponent));
        return function(t) {
            return raise(a + b * t, 1 / exponent);
        };
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, domain(domain())) : exponent;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow().exponent(exponent));
    };
    return (0, _linear.linearish)(scale);
}
function sqrt() {
    return pow().exponent(0.5);
}

},{"./constant":"kqAHF","./linear":"8ILtO","./continuous":"iufei","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e3INQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return quantile;
});
var _d3Array = require("d3-array");
var _array = require("./array");
function quantile() {
    var domain = [], range = [], thresholds = [];
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantile)(domain, i / n);
        return scale;
    }
    function scale(x) {
        if (!isNaN(x = +x)) return range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range);
    };
    return scale;
}

},{"d3-array":"epkQ7","./array":"eP8dh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ltcWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return quantize;
});
var _d3Array = require("d3-array");
var _array = require("./array");
var _linear = require("./linear");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ];
    function scale(x) {
        if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, _array.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range);
    };
    return (0, _linear.linearish)(scale);
}

},{"d3-array":"epkQ7","./array":"eP8dh","./linear":"8ILtO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXbkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return threshold;
});
var _d3Array = require("d3-array");
var _array = require("./array");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], n = 1;
    function scale(x) {
        if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range);
    };
    return scale;
}

},{"d3-array":"epkQ7","./array":"eP8dh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lAxfT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", function() {
    return calendar;
});
parcelHelpers.export(exports, "default", function() {
    return function() {
        return calendar((0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3Time.timeMillisecond), (0, _d3TimeFormat.timeFormat)).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]);
    };
});
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _array = require("./array");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var durationSecond = 1000, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365;
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, _continuousDefault.default)((0, _continuous.deinterpolateLinear), (0, _d3Interpolate.interpolateNumber)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            durationSecond
        ],
        [
            second,
            5,
            5 * durationSecond
        ],
        [
            second,
            15,
            15 * durationSecond
        ],
        [
            second,
            30,
            30 * durationSecond
        ],
        [
            minute,
            1,
            durationMinute
        ],
        [
            minute,
            5,
            5 * durationMinute
        ],
        [
            minute,
            15,
            15 * durationMinute
        ],
        [
            minute,
            30,
            30 * durationMinute
        ],
        [
            hour,
            1,
            durationHour
        ],
        [
            hour,
            3,
            3 * durationHour
        ],
        [
            hour,
            6,
            6 * durationHour
        ],
        [
            hour,
            12,
            12 * durationHour
        ],
        [
            day,
            1,
            durationDay
        ],
        [
            day,
            2,
            2 * durationDay
        ],
        [
            week,
            1,
            durationWeek
        ],
        [
            month,
            1,
            durationMonth
        ],
        [
            month,
            3,
            3 * durationMonth
        ],
        [
            year,
            1,
            durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, _d3Array.bisector)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, _d3Array.tickStep)(start / durationYear, stop / durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, _d3Array.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, _array.map).call(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, _niceDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}

},{"d3-array":"epkQ7","d3-interpolate":"fifMh","d3-time":"bHijz","d3-time-format":"9IPCY","./array":"eP8dh","./continuous":"iufei","./nice":"dc09s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bHijz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", function() {
    return 0, _intervalJsDefault.default;
});
parcelHelpers.export(exports, "timeMillisecond", function() {
    return 0, _millisecondJsDefault.default;
});
parcelHelpers.export(exports, "timeMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "utcMillisecond", function() {
    return 0, _millisecondJsDefault.default;
});
parcelHelpers.export(exports, "utcMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "timeSecond", function() {
    return 0, _secondJsDefault.default;
});
parcelHelpers.export(exports, "timeSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "utcSecond", function() {
    return 0, _secondJsDefault.default;
});
parcelHelpers.export(exports, "utcSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "timeMinute", function() {
    return 0, _minuteJsDefault.default;
});
parcelHelpers.export(exports, "timeMinutes", function() {
    return 0, _minuteJs.minutes;
});
parcelHelpers.export(exports, "timeHour", function() {
    return 0, _hourJsDefault.default;
});
parcelHelpers.export(exports, "timeHours", function() {
    return 0, _hourJs.hours;
});
parcelHelpers.export(exports, "timeDay", function() {
    return 0, _dayJsDefault.default;
});
parcelHelpers.export(exports, "timeDays", function() {
    return 0, _dayJs.days;
});
parcelHelpers.export(exports, "timeWeek", function() {
    return 0, _weekJs.sunday;
});
parcelHelpers.export(exports, "timeWeeks", function() {
    return 0, _weekJs.sundays;
});
parcelHelpers.export(exports, "timeSunday", function() {
    return 0, _weekJs.sunday;
});
parcelHelpers.export(exports, "timeSundays", function() {
    return 0, _weekJs.sundays;
});
parcelHelpers.export(exports, "timeMonday", function() {
    return 0, _weekJs.monday;
});
parcelHelpers.export(exports, "timeMondays", function() {
    return 0, _weekJs.mondays;
});
parcelHelpers.export(exports, "timeTuesday", function() {
    return 0, _weekJs.tuesday;
});
parcelHelpers.export(exports, "timeTuesdays", function() {
    return 0, _weekJs.tuesdays;
});
parcelHelpers.export(exports, "timeWednesday", function() {
    return 0, _weekJs.wednesday;
});
parcelHelpers.export(exports, "timeWednesdays", function() {
    return 0, _weekJs.wednesdays;
});
parcelHelpers.export(exports, "timeThursday", function() {
    return 0, _weekJs.thursday;
});
parcelHelpers.export(exports, "timeThursdays", function() {
    return 0, _weekJs.thursdays;
});
parcelHelpers.export(exports, "timeFriday", function() {
    return 0, _weekJs.friday;
});
parcelHelpers.export(exports, "timeFridays", function() {
    return 0, _weekJs.fridays;
});
parcelHelpers.export(exports, "timeSaturday", function() {
    return 0, _weekJs.saturday;
});
parcelHelpers.export(exports, "timeSaturdays", function() {
    return 0, _weekJs.saturdays;
});
parcelHelpers.export(exports, "timeMonth", function() {
    return 0, _monthJsDefault.default;
});
parcelHelpers.export(exports, "timeMonths", function() {
    return 0, _monthJs.months;
});
parcelHelpers.export(exports, "timeYear", function() {
    return 0, _yearJsDefault.default;
});
parcelHelpers.export(exports, "timeYears", function() {
    return 0, _yearJs.years;
});
parcelHelpers.export(exports, "utcMinute", function() {
    return 0, _utcMinuteJsDefault.default;
});
parcelHelpers.export(exports, "utcMinutes", function() {
    return 0, _utcMinuteJs.utcMinutes;
});
parcelHelpers.export(exports, "utcHour", function() {
    return 0, _utcHourJsDefault.default;
});
parcelHelpers.export(exports, "utcHours", function() {
    return 0, _utcHourJs.utcHours;
});
parcelHelpers.export(exports, "utcDay", function() {
    return 0, _utcDayJsDefault.default;
});
parcelHelpers.export(exports, "utcDays", function() {
    return 0, _utcDayJs.utcDays;
});
parcelHelpers.export(exports, "utcWeek", function() {
    return 0, _utcWeekJs.utcSunday;
});
parcelHelpers.export(exports, "utcWeeks", function() {
    return 0, _utcWeekJs.utcSundays;
});
parcelHelpers.export(exports, "utcSunday", function() {
    return 0, _utcWeekJs.utcSunday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return 0, _utcWeekJs.utcSundays;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return 0, _utcWeekJs.utcMonday;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return 0, _utcWeekJs.utcMondays;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return 0, _utcWeekJs.utcTuesday;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return 0, _utcWeekJs.utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return 0, _utcWeekJs.utcWednesday;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return 0, _utcWeekJs.utcWednesdays;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return 0, _utcWeekJs.utcThursday;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return 0, _utcWeekJs.utcThursdays;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return 0, _utcWeekJs.utcFriday;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return 0, _utcWeekJs.utcFridays;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return 0, _utcWeekJs.utcSaturday;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return 0, _utcWeekJs.utcSaturdays;
});
parcelHelpers.export(exports, "utcMonth", function() {
    return 0, _utcMonthJsDefault.default;
});
parcelHelpers.export(exports, "utcMonths", function() {
    return 0, _utcMonthJs.utcMonths;
});
parcelHelpers.export(exports, "utcYear", function() {
    return 0, _utcYearJsDefault.default;
});
parcelHelpers.export(exports, "utcYears", function() {
    return 0, _utcYearJs.utcYears;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);

},{"./interval.js":false,"./millisecond.js":"80T1S","./second.js":"1tm74","./minute.js":"gQtCq","./hour.js":"aD7Pm","./day.js":"8Dij7","./week.js":"alveJ","./month.js":"gV3DW","./year.js":"8ZH0N","./utcMinute.js":"j5QJV","./utcHour.js":"5pE5u","./utcDay.js":"3gPxS","./utcWeek.js":"jHXCC","./utcMonth.js":"889d1","./utcYear.js":"3e1zD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VcD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return newInterval;
});
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"80T1S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", function() {
    return milliseconds;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"2VcD6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1tm74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", function() {
    return seconds;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9dSjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", function() {
    return durationSecond;
});
parcelHelpers.export(exports, "durationMinute", function() {
    return durationMinute;
});
parcelHelpers.export(exports, "durationHour", function() {
    return durationHour;
});
parcelHelpers.export(exports, "durationDay", function() {
    return durationDay;
});
parcelHelpers.export(exports, "durationWeek", function() {
    return durationWeek;
});
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gQtCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", function() {
    return minutes;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aD7Pm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", function() {
    return hours;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Dij7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", function() {
    return days;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"alveJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", function() {
    return sunday;
});
parcelHelpers.export(exports, "monday", function() {
    return monday;
});
parcelHelpers.export(exports, "tuesday", function() {
    return tuesday;
});
parcelHelpers.export(exports, "wednesday", function() {
    return wednesday;
});
parcelHelpers.export(exports, "thursday", function() {
    return thursday;
});
parcelHelpers.export(exports, "friday", function() {
    return friday;
});
parcelHelpers.export(exports, "saturday", function() {
    return saturday;
});
parcelHelpers.export(exports, "sundays", function() {
    return sundays;
});
parcelHelpers.export(exports, "mondays", function() {
    return mondays;
});
parcelHelpers.export(exports, "tuesdays", function() {
    return tuesdays;
});
parcelHelpers.export(exports, "wednesdays", function() {
    return wednesdays;
});
parcelHelpers.export(exports, "thursdays", function() {
    return thursdays;
});
parcelHelpers.export(exports, "fridays", function() {
    return fridays;
});
parcelHelpers.export(exports, "saturdays", function() {
    return saturdays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gV3DW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", function() {
    return months;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"2VcD6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ZH0N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", function() {
    return years;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"2VcD6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j5QJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", function() {
    return utcMinutes;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5pE5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", function() {
    return utcHours;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3gPxS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", function() {
    return utcDays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jHXCC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", function() {
    return utcSunday;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return utcMonday;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return utcTuesday;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return utcWednesday;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return utcThursday;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return utcFriday;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return utcSaturday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return utcSundays;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return utcMondays;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return utcWednesdays;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return utcThursdays;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return utcFridays;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return utcSaturdays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"2VcD6","./duration.js":"9dSjQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"889d1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", function() {
    return utcMonths;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"2VcD6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3e1zD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", function() {
    return utcYears;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"2VcD6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9IPCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", function() {
    return 0, _defaultLocaleJsDefault.default;
});
parcelHelpers.export(exports, "timeFormat", function() {
    return 0, _defaultLocaleJs.timeFormat;
});
parcelHelpers.export(exports, "timeParse", function() {
    return 0, _defaultLocaleJs.timeParse;
});
parcelHelpers.export(exports, "utcFormat", function() {
    return 0, _defaultLocaleJs.utcFormat;
});
parcelHelpers.export(exports, "utcParse", function() {
    return 0, _defaultLocaleJs.utcParse;
});
parcelHelpers.export(exports, "timeFormatLocale", function() {
    return 0, _localeJsDefault.default;
});
parcelHelpers.export(exports, "isoFormat", function() {
    return 0, _isoFormatJsDefault.default;
});
parcelHelpers.export(exports, "isoParse", function() {
    return 0, _isoParseJsDefault.default;
});
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"lw4sP","./locale.js":false,"./isoFormat.js":false,"./isoParse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lw4sP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", function() {
    return timeFormat;
});
parcelHelpers.export(exports, "timeParse", function() {
    return timeParse;
});
parcelHelpers.export(exports, "utcFormat", function() {
    return utcFormat;
});
parcelHelpers.export(exports, "utcParse", function() {
    return utcParse;
});
parcelHelpers.export(exports, "default", function() {
    return defaultLocale;
});
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"hrMWa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hrMWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatLocale;
});
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function format(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function parse(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function utcFormat(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function utcParse(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"bHijz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bs4rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        return (0, _time.calendar)((0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3Time.utcMillisecond), (0, _d3TimeFormat.utcFormat)).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]);
    };
});
var _time = require("./time");
var _d3TimeFormat = require("d3-time-format");
var _d3Time = require("d3-time");

},{"./time":"lAxfT","d3-time-format":"9IPCY","d3-time":"bHijz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aWERQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"./colors":"45307","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"45307":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(s) {
        return s.match(/.{6}/g).map(function(x) {
            return "#" + x;
        });
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2j9rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

},{"./colors":"45307","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4sYxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

},{"./colors":"45307","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eW0O9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

},{"./colors":"45307","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hDJXw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"d2vOO","d3-interpolate":"fifMh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"11acP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", function() {
    return warm;
});
parcelHelpers.export(exports, "cool", function() {
    return cool;
});
parcelHelpers.export(exports, "default", function() {
    return function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        rainbow.h = 360 * t - 100;
        rainbow.s = 1.5 - 1.5 * ts;
        rainbow.l = 0.8 - 0.9 * ts;
        return rainbow + "";
    };
});
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var rainbow = (0, _d3Color.cubehelix)();

},{"d3-color":"d2vOO","d3-interpolate":"fifMh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iv3B5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", function() {
    return magma;
});
parcelHelpers.export(exports, "inferno", function() {
    return inferno;
});
parcelHelpers.export(exports, "plasma", function() {
    return plasma;
});
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"./colors":"45307","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"99iTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return sequential;
});
var _linear = require("./linear");
function sequential(interpolator) {
    var x0 = 0, x1 = 1, clamp = false;
    function scale(x) {
        var t = (x - x0) / (x1 - x0);
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return sequential(interpolator).domain([
            x0,
            x1
        ]).clamp(clamp);
    };
    return (0, _linear.linearish)(scale);
}

},{"./linear":"8ILtO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iHQOu":[function(require,module,exports,__globalThis) {
/* eslint-disable func-style */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IMMUTABLE_ITERABLE", function() {
    return IMMUTABLE_ITERABLE;
});
parcelHelpers.export(exports, "IMMUTABLE_RECORD", function() {
    return IMMUTABLE_RECORD;
});
parcelHelpers.export(exports, "IMMUTABLE_LIST", function() {
    return IMMUTABLE_LIST;
});
parcelHelpers.export(exports, "IMMUTABLE_MAP", function() {
    return IMMUTABLE_MAP;
});
parcelHelpers.export(exports, "isIterable", function() {
    return isIterable;
});
parcelHelpers.export(exports, "isRecord", function() {
    return isRecord;
});
parcelHelpers.export(exports, "isImmutable", function() {
    return isImmutable;
});
parcelHelpers.export(exports, "isList", function() {
    return isList;
});
parcelHelpers.export(exports, "isMap", function() {
    return isMap;
});
parcelHelpers.export(exports, "shallowToJS", function() {
    return shallowToJS;
});
var IMMUTABLE_ITERABLE = "@@__IMMUTABLE_ITERABLE__@@";
var IMMUTABLE_RECORD = "@@__IMMUTABLE_RECORD__@@";
var IMMUTABLE_LIST = "@@__IMMUTABLE_LIST__@@";
var IMMUTABLE_MAP = "@@__IMMUTABLE_MAP__@@";
function isIterable(x) {
    return !!(x && x[IMMUTABLE_ITERABLE]);
}
function isRecord(x) {
    return !!(x && x[IMMUTABLE_RECORD]);
}
function isImmutable(x) {
    return isIterable(x) || isRecord(x);
}
function isList(x) {
    return !!(x && x[IMMUTABLE_LIST]);
}
function isMap(x) {
    return !!(x && x[IMMUTABLE_MAP]);
}
function shallowToJS(x, whitelist) {
    return isIterable(x) ? x.reduce(function(prev, curr, key) {
        if (whitelist && whitelist[key]) curr = shallowToJS(curr);
        prev[key] = curr;
        return prev;
    }, isList(x) ? [] : {}) : x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bCD2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a getDomain function
 * @param {Function} getDomainFromDataFunction: a function that takes props and axis and
 * returns a domain based on data
 * @param {Function} formatDomainFunction: a function that takes domain, props, and axis and
 * returns a formatted domain
 * @returns {Function} a function that takes props and axis and returns a formatted domain
 */ parcelHelpers.export(exports, "createDomainFunction", function() {
    return createDomainFunction;
});
/**
 * Returns a formatted domain.
 * @param {Array} domain: a domain in the form of a two element array
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} a domain in the form of a two element array
 */ parcelHelpers.export(exports, "formatDomain", function() {
    return formatDomain;
});
/**
 * Returns a domain for a given axis based on props, category, or data
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} the domain for the given axis
 */ parcelHelpers.export(exports, "getDomain", function() {
    return getDomain;
});
/**
 * Returns a domain based on categories if they exist
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @param {Array} categories: an array of categories corresponding to a given axis
 * @returns {Array|undefined} returns a domain from categories or undefined
 */ parcelHelpers.export(exports, "getDomainFromCategories", function() {
    return getDomainFromCategories;
});
/**
 * Returns a domain from a dataset for a given axis
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @param {Array} dataset: an array of data
 * @returns {Array} the domain based on data
 */ parcelHelpers.export(exports, "getDomainFromData", function() {
    return getDomainFromData;
});
/**
 * Returns a domain in the form of a two element array given a min and max value.
 * @param {Number|Date} min: the props object
 * @param {Number|Date} max: the current axis
 * @returns {Array} the minDomain based on props
 */ parcelHelpers.export(exports, "getDomainFromMinMax", function() {
    return getDomainFromMinMax;
});
/**
 * Returns a the domain for a given axis if domain is given in props
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array|undefined} the domain based on props
 */ parcelHelpers.export(exports, "getDomainFromProps", function() {
    return getDomainFromProps;
});
/**
 * Returns a domain for a given axis. This method forces the domain to include
 * zero unless the domain is explicitly specified in props.
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Array} the domain for the given axis
 */ parcelHelpers.export(exports, "getDomainWithZero", function() {
    return getDomainWithZero;
});
/**
 * Returns the maxDomain from props if it exists
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Number|Date|undefined} the maxDomain based on props
 */ parcelHelpers.export(exports, "getMaxFromProps", function() {
    return getMaxFromProps;
});
/**
 * Returns the minDomain from props if it exists
 * @param {Object} props: the props object
 * @param {String} axis: the current axis
 * @returns {Number|Date|undefined} the minDomain based on props
 */ parcelHelpers.export(exports, "getMinFromProps", function() {
    return getMinFromProps;
});
/**
 * Returns a symmetrically padded domain for polar charts
 * @param {Array} domain: the original domain
 * @param {Array} values: a flat array of values corresponding to either tickValues, or data values
 * for a given dimension i.e. only x values.
 * @returns {Array} the symmetric domain
 */ parcelHelpers.export(exports, "getSymmetricDomain", function() {
    return getSymmetricDomain;
});
/**
 * Checks whether a given component can be used to calculate domain
 * @param {Component} component: a React component instance
 * @returns {Boolean} Returns true if the given component has a role included in the whitelist
 */ parcelHelpers.export(exports, "isDomainComponent", function() {
    return isDomainComponent;
});
var _isDate = require("lodash/isDate");
var _isDateDefault = parcelHelpers.interopDefault(_isDate);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _sortedUniq = require("lodash/sortedUniq");
var _sortedUniqDefault = parcelHelpers.interopDefault(_sortedUniq);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _data = require("./data");
var _scale = require("./scale");
var _helpers = require("./helpers");
var _collection = require("./collection"); // Private Methods
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function cleanDomain(domain, props, axis) {
    var scaleType = _scale.getScaleType(props, axis);
    if (scaleType !== "log") return domain;
    var rules = function rules(dom) {
        var almostZero = dom[0] < 0 || dom[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
        var domainOne = dom[0] === 0 ? almostZero : dom[0];
        var domainTwo = dom[1] === 0 ? almostZero : dom[1];
        return [
            domainOne,
            domainTwo
        ];
    };
    return rules(domain);
}
function getDomainPadding(props, axis) {
    var formatPadding = function formatPadding(padding) {
        return Array.isArray(padding) ? {
            left: padding[0],
            right: padding[1]
        } : {
            left: padding,
            right: padding
        };
    };
    return (0, _isPlainObjectDefault.default)(props.domainPadding) ? formatPadding(props.domainPadding[axis]) : formatPadding(props.domainPadding);
}
function getFlatData(dataset, axis) {
    return (0, _flattenDefault.default)(dataset).map(function(datum) {
        return datum["_".concat(axis)] && datum["_".concat(axis)][1] !== undefined ? datum["_".concat(axis)][1] : datum["_".concat(axis)];
    });
}
function getExtremeFromData(dataset, axis) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "min";
    var getExtreme = function getExtreme(arr) {
        return type === "max" ? Math.max.apply(Math, _toConsumableArray(arr)) : Math.min.apply(Math, _toConsumableArray(arr));
    };
    var initialValue = type === "max" ? -Infinity : Infinity;
    var containsDate = false;
    var result = (0, _flattenDefault.default)(dataset).reduce(function(memo, datum) {
        var current0 = datum["_".concat(axis, "0")] !== undefined ? datum["_".concat(axis, "0")] : datum["_".concat(axis)];
        var current1 = datum["_".concat(axis, "1")] !== undefined ? datum["_".concat(axis, "1")] : datum["_".concat(axis)];
        var current = getExtreme([
            current0,
            current1
        ]);
        containsDate = containsDate || current0 instanceof Date || current1 instanceof Date;
        return getExtreme([
            memo,
            current
        ]);
    }, initialValue);
    return containsDate ? new Date(result) : result;
} //eslint-disable-next-line max-statements
function padDomain(domain, props, axis) {
    if (!props.domainPadding) return domain;
    var minDomain = getMinFromProps(props, axis);
    var maxDomain = getMaxFromProps(props, axis);
    var padding = getDomainPadding(props, axis);
    if (!padding.left && !padding.right) return domain;
    var min = _collection.getMinValue(domain);
    var max = _collection.getMaxValue(domain);
    var currentAxis = _helpers.getCurrentAxis(axis, props.horizontal);
    var range = _helpers.getRange(props, currentAxis);
    var rangeExtent = Math.abs(range[0] - range[1]);
    var paddedRangeExtent = Math.max(rangeExtent - padding.left - padding.right, 1);
    var paddedDomainExtent = Math.abs(max.valueOf() - min.valueOf()) / paddedRangeExtent * rangeExtent;
    var simplePadding = {
        left: paddedDomainExtent * padding.left / rangeExtent,
        right: paddedDomainExtent * padding.right / rangeExtent
    };
    var paddedDomain = {
        min: min.valueOf() - simplePadding.left,
        max: max.valueOf() + simplePadding.right
    };
    var singleQuadrantDomainPadding = (0, _isPlainObjectDefault.default)(props.singleQuadrantDomainPadding) ? props.singleQuadrantDomainPadding[axis] : props.singleQuadrantDomainPadding;
    var addsQuadrants = min >= 0 && paddedDomain.min <= 0 || max <= 0 && paddedDomain.max >= 0;
    var adjust = function adjust(val, type) {
        var coerce = type === "min" && min >= 0 && val <= 0 || type === "max" && max <= 0 && val >= 0;
        return coerce ? 0 : val;
    };
    if (addsQuadrants && singleQuadrantDomainPadding !== false) {
        // Naive initial padding calculation
        var initialPadding = {
            left: Math.abs(max - min) * padding.left / rangeExtent,
            right: Math.abs(max - min) * padding.right / rangeExtent
        }; // Adjust the domain by the initial padding
        var adjustedDomain = {
            min: adjust(min.valueOf() - initialPadding.left, "min"),
            max: adjust(max.valueOf() + initialPadding.right, "max")
        }; // re-calculate padding, taking the adjusted domain into account
        var finalPadding = {
            left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.left / rangeExtent,
            right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.right / rangeExtent
        }; // Adjust the domain by the final padding
        paddedDomain = {
            min: adjust(min.valueOf() - finalPadding.left, "min"),
            max: adjust(max.valueOf() + finalPadding.right, "max")
        };
    } // default to minDomain / maxDomain if they exist
    var finalDomain = {
        min: minDomain !== undefined ? minDomain : paddedDomain.min,
        max: maxDomain !== undefined ? maxDomain : paddedDomain.max
    };
    return min instanceof Date || max instanceof Date ? getDomainFromMinMax(new Date(finalDomain.min), new Date(finalDomain.max)) : getDomainFromMinMax(finalDomain.min, finalDomain.max);
} // Public Methods
function createDomainFunction(getDomainFromDataFunction, formatDomainFunction) {
    getDomainFromDataFunction = (0, _isFunctionDefault.default)(getDomainFromDataFunction) ? getDomainFromDataFunction : getDomainFromData;
    formatDomainFunction = (0, _isFunctionDefault.default)(formatDomainFunction) ? formatDomainFunction : formatDomain;
    return function(props, axis) {
        var propsDomain = getDomainFromProps(props, axis);
        if (propsDomain) return formatDomainFunction(propsDomain, props, axis);
        var categories = _data.getCategories(props, axis);
        var domain = categories ? getDomainFromCategories(props, axis, categories) : getDomainFromDataFunction(props, axis);
        return domain ? formatDomainFunction(domain, props, axis) : undefined;
    };
}
function formatDomain(domain, props, axis) {
    return cleanDomain(padDomain(domain, props, axis), props, axis);
}
function getDomain(props, axis) {
    return createDomainFunction()(props, axis);
}
function getDomainFromCategories(props, axis, categories) {
    categories = categories || _data.getCategories(props, axis);
    var polar = props.polar, _props$startAngle = props.startAngle, startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle, _props$endAngle = props.endAngle, endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
    if (!categories) return undefined;
    var minDomain = getMinFromProps(props, axis);
    var maxDomain = getMaxFromProps(props, axis);
    var stringArray = _collection.containsStrings(categories) ? _data.getStringsFromCategories(props, axis) : [];
    var stringMap = stringArray.length === 0 ? null : stringArray.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    var categoryValues = stringMap ? categories.map(function(value) {
        return stringMap[value];
    }) : categories;
    var min = minDomain !== undefined ? minDomain : _collection.getMinValue(categoryValues);
    var max = maxDomain !== undefined ? maxDomain : _collection.getMaxValue(categoryValues);
    var categoryDomain = getDomainFromMinMax(min, max);
    return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(categoryDomain, categoryValues) : categoryDomain;
}
function getDomainFromData(props, axis, dataset) {
    dataset = dataset || _data.getData(props);
    var polar = props.polar, _props$startAngle2 = props.startAngle, startAngle = _props$startAngle2 === void 0 ? 0 : _props$startAngle2, _props$endAngle2 = props.endAngle, endAngle = _props$endAngle2 === void 0 ? 360 : _props$endAngle2;
    var minDomain = getMinFromProps(props, axis);
    var maxDomain = getMaxFromProps(props, axis);
    if (dataset.length < 1) return minDomain !== undefined && maxDomain !== undefined ? getDomainFromMinMax(minDomain, maxDomain) : undefined;
    var min = minDomain !== undefined ? minDomain : getExtremeFromData(dataset, axis, "min");
    var max = maxDomain !== undefined ? maxDomain : getExtremeFromData(dataset, axis, "max");
    var domain = getDomainFromMinMax(min, max);
    return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(domain, getFlatData(dataset, axis)) : domain;
}
function getDomainFromMinMax(min, max) {
    var getSinglePointDomain = function getSinglePointDomain(val) {
        // d3-scale does not properly resolve very small differences.
        var verySmallNumber = val === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10);
        var verySmallDate = 1;
        var minVal = val instanceof Date ? new Date(+val - verySmallDate) : +val - verySmallNumber;
        var maxVal = val instanceof Date ? new Date(+val + verySmallDate) : +val + verySmallNumber;
        return val === 0 ? [
            0,
            maxVal
        ] : [
            minVal,
            maxVal
        ];
    };
    return +min === +max ? getSinglePointDomain(max) : [
        min,
        max
    ];
}
function getDomainFromProps(props, axis) {
    var minDomain = getMinFromProps(props, axis);
    var maxDomain = getMaxFromProps(props, axis);
    if ((0, _isPlainObjectDefault.default)(props.domain) && props.domain[axis]) return props.domain[axis];
    else if (Array.isArray(props.domain)) return props.domain;
    else if (minDomain !== undefined && maxDomain !== undefined) return getDomainFromMinMax(minDomain, maxDomain);
    return undefined;
}
function getDomainWithZero(props, axis) {
    var propsDomain = getDomainFromProps(props, axis);
    if (propsDomain) return propsDomain;
    var dataset = _data.getData(props);
    var y0Min = dataset.reduce(function(min, datum) {
        return datum._y0 < min ? datum._y0 : min;
    }, Infinity);
    var ensureZero = function ensureZero(domain) {
        if (axis === "x") return domain;
        var defaultMin = y0Min !== Infinity ? y0Min : 0;
        var maxDomainProp = getMaxFromProps(props, axis);
        var minDomainProp = getMinFromProps(props, axis);
        var max = maxDomainProp !== undefined ? maxDomainProp : _collection.getMaxValue(domain, defaultMin);
        var min = minDomainProp !== undefined ? minDomainProp : _collection.getMinValue(domain, defaultMin);
        return getDomainFromMinMax(min, max);
    };
    var getDomainFunction = function getDomainFunction() {
        return getDomainFromData(props, axis, dataset);
    };
    var formatDomainFunction = function formatDomainFunction(domain) {
        return formatDomain(ensureZero(domain), props, axis);
    };
    return createDomainFunction(getDomainFunction, formatDomainFunction)(props, axis);
}
function getMaxFromProps(props, axis) {
    if ((0, _isPlainObjectDefault.default)(props.maxDomain) && props.maxDomain[axis] !== undefined) return props.maxDomain[axis];
    return typeof props.maxDomain === "number" || (0, _isDateDefault.default)(props.maxDomain) ? props.maxDomain : undefined;
}
function getMinFromProps(props, axis) {
    if ((0, _isPlainObjectDefault.default)(props.minDomain) && props.minDomain[axis] !== undefined) return props.minDomain[axis];
    return typeof props.minDomain === "number" || (0, _isDateDefault.default)(props.minDomain) ? props.minDomain : undefined;
}
function getSymmetricDomain(domain, values) {
    var processedData = (0, _sortedUniqDefault.default)(values.sort(function(a, b) {
        return a - b;
    }));
    var step = processedData[1] - processedData[0];
    return [
        domain[0],
        domain[1] + step
    ];
}
function isDomainComponent(component) {
    var getRole = function getRole(child) {
        return child && child.type ? child.type.role : "";
    };
    var role = getRole(component);
    if (role === "portal") {
        var children = (0, _reactDefault.default).Children.toArray(component.props.children);
        role = children.length ? getRole(children[0]) : "";
    }
    var whitelist = [
        "area",
        "axis",
        "bar",
        "boxplot",
        "candlestick",
        "errorbar",
        "group",
        "histogram",
        "line",
        "pie",
        "scatter",
        "stack",
        "voronoi"
    ];
    return (0, _includesDefault.default)(whitelist, role);
}

},{"lodash/isDate":"7dQM0","lodash/includes":"2bZ7U","lodash/isFunction":"8ck2f","lodash/sortedUniq":"ljMLk","lodash/isPlainObject":"2RXyg","lodash/flatten":"b7fAH","react":"gVheC","./data":"5rlHC","./scale":"je6Bi","./helpers":"8ABme","./collection":"4mxxX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7dQM0":[function(require,module,exports,__globalThis) {
var baseIsDate = require("2e5c3fd587c080ab"), baseUnary = require("b707197710f20e35"), nodeUtil = require("50ae594eda1f7546");
/* Node.js helper references. */ var nodeIsDate = nodeUtil && nodeUtil.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
module.exports = isDate;

},{"2e5c3fd587c080ab":"2M6Pw","b707197710f20e35":"8g9lw","50ae594eda1f7546":"hZg2H"}],"2M6Pw":[function(require,module,exports,__globalThis) {
var baseGetTag = require("fee9a83fca9b4491"), isObjectLike = require("e3e4be03f1e35653");
/** `Object#toString` result references. */ var dateTag = '[object Date]';
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function baseIsDate(value) {
    return isObjectLike(value) && baseGetTag(value) == dateTag;
}
module.exports = baseIsDate;

},{"fee9a83fca9b4491":"iuqvy","e3e4be03f1e35653":"lm2eo"}],"ljMLk":[function(require,module,exports,__globalThis) {
var baseSortedUniq = require("cfd47be82d40df0c");
/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */ function sortedUniq(array) {
    return array && array.length ? baseSortedUniq(array) : [];
}
module.exports = sortedUniq;

},{"cfd47be82d40df0c":"6xNg6"}],"6xNg6":[function(require,module,exports,__globalThis) {
var eq = require("4be9dadff85d8def");
/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseSortedUniq(array, iteratee) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
        }
    }
    return result;
}
module.exports = baseSortedUniq;

},{"4be9dadff85d8def":"8Gfg3"}],"aKPMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _values = require("lodash/values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _groupBy = require("lodash/groupBy");
var _groupByDefault = parcelHelpers.interopDefault(_groupBy);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axis = require("./axis");
var _style = require("./style");
var _transitions = require("./transitions");
var _data = require("./data");
var _domain = require("./domain");
var _events = require("./events");
var _collection = require("./collection");
var _helpers = require("./helpers");
var _scale = require("./scale");
var _log = require("./log");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
exports.default = {
    getData: function getData(props, childComponents) {
        if (props.data) return _data.getData(props);
        childComponents = childComponents || (0, _reactDefault.default).Children.toArray(props.children);
        return this.getDataFromChildren(childComponents);
    },
    getDefaultDomainPadding: function getDefaultDomainPadding(props, axis, childComponents) {
        if (props.polar || axis !== "x") return undefined;
        var groupComponent = childComponents.filter(function(child) {
            return child.type && child.type.role && child.type.role === "group";
        });
        if (groupComponent.length < 1) return undefined;
        var _groupComponent$0$pro = groupComponent[0].props, offset = _groupComponent$0$pro.offset, children = _groupComponent$0$pro.children;
        if (!offset) return undefined;
        var firstChild = Array.isArray(children) && children[0];
        if (!firstChild) return undefined;
        var barWidth = firstChild.props.barWidth;
        var dataLength = firstChild.props.data && firstChild.props.data.length || 1;
        if (firstChild && firstChild.type.role === "stack") {
            var nestedChild = firstChild.props.children && firstChild.props.children[0];
            if (!nestedChild) return undefined;
            barWidth = nestedChild.props.barWidth;
            dataLength = firstChild.props.children.length;
        }
        var width = barWidth || this.getWidth(props, children.length, dataLength);
        return {
            x: width * children.length / 2 + (offset - width * ((children.length - 1) / 2))
        };
    },
    getDomain: function getDomain(props, axis, childComponents) {
        childComponents = childComponents || (0, _reactDefault.default).Children.toArray(props.children);
        var propsDomain = _domain.getDomainFromProps(props, axis);
        var domainPadding = this.getDefaultDomainPadding(props, axis, childComponents);
        var domain;
        if (propsDomain) domain = propsDomain;
        else {
            var minDomain = _domain.getMinFromProps(props, axis);
            var maxDomain = _domain.getMaxFromProps(props, axis);
            var dataset = (props.data || props.y) && _data.getData(props);
            var dataDomain = dataset ? _domain.getDomainFromData(props, axis, dataset) : [];
            var childDomain = this.getDomainFromChildren(props, axis, childComponents);
            var min = minDomain || _collection.getMinValue(_toConsumableArray(dataDomain).concat(_toConsumableArray(childDomain)));
            var max = maxDomain || _collection.getMaxValue(_toConsumableArray(dataDomain).concat(_toConsumableArray(childDomain)));
            domain = _domain.getDomainFromMinMax(min, max);
        }
        return _domain.formatDomain(domain, (0, _assignDefault.default)({
            domainPadding: domainPadding
        }, props), axis);
    },
    getScale: function getScale(props, axis, childComponents) {
        if (props.data) return _scale.getBaseScale(props, axis);
        var children = childComponents ? childComponents.slice(0) : (0, _reactDefault.default).Children.toArray(props.children);
        var iteratee = function iteratee(child) {
            var sharedProps = (0, _assignDefault.default)({}, child.props, {
                horizontal: props.horizontal
            });
            return _scale.getScaleType(sharedProps, axis);
        };
        var childScale = (0, _uniqDefault.default)(_helpers.reduceChildren(children, iteratee, props)); // default to linear scale if more than one uniq scale type is given by children
        return childScale.length > 1 ? _scale.getScaleFromName("linear") : _scale.getScaleFromName(childScale[0]);
    },
    setAnimationState: function setAnimationState(props, nextProps) {
        if (!props.animate) return;
        if (props.animate.parentState) {
            var nodesWillExit = props.animate.parentState.nodesWillExit;
            var oldProps = nodesWillExit ? props : null;
            this.setState((0, _defaultsDefault.default)({
                oldProps: oldProps,
                nextProps: nextProps
            }, props.animate.parentState));
        } else {
            var oldChildren = (0, _reactDefault.default).Children.toArray(props.children);
            var nextChildren = (0, _reactDefault.default).Children.toArray(nextProps.children);
            var isContinuous = function isContinuous(child) {
                var check = function check(c) {
                    return c.type && c.type.continuous;
                };
                return Array.isArray(child) ? (0, _someDefault.default)(child, check) : check(child);
            };
            var continuous = !props.polar && (0, _someDefault.default)(oldChildren, function(child) {
                return isContinuous(child) || child.props.children && isContinuous(child.props.children);
            });
            var _Transitions$getIniti = _transitions.getInitialTransitionState(oldChildren, nextChildren), _nodesWillExit = _Transitions$getIniti.nodesWillExit, nodesWillEnter = _Transitions$getIniti.nodesWillEnter, childrenTransitions = _Transitions$getIniti.childrenTransitions, nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
            this.setState({
                nodesWillExit: _nodesWillExit,
                nodesWillEnter: nodesWillEnter,
                nodesShouldEnter: nodesShouldEnter,
                childrenTransitions: _collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
                oldProps: _nodesWillExit ? props : null,
                nextProps: nextProps,
                continuous: continuous
            });
        }
    },
    getAllEvents: function getAllEvents(props) {
        var components = [
            "groupComponent",
            "containerComponent",
            "labelComponent"
        ];
        this.componentEvents = _events.getComponentEvents(props, components);
        var events = props.events;
        if (Array.isArray(this.componentEvents)) {
            var _componentEvents;
            events = Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
        }
        return events || [];
    },
    getAnimationProps: function getAnimationProps(props, child, index) {
        var _this = this;
        if (!props.animate) return child.props.animate;
        var getFilteredState = function getFilteredState() {
            var childrenTransitions = _this.state && _this.state.childrenTransitions;
            childrenTransitions = _collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[index] : childrenTransitions;
            return (0, _defaultsDefault.default)({
                childrenTransitions: childrenTransitions
            }, _this.state);
        };
        var getTransitions = props.animate && props.animate.getTransitions;
        var state = getFilteredState();
        var parentState = props.animate && props.animate.parentState || state;
        if (!getTransitions) {
            var getTransitionProps = _transitions.getTransitionPropsFactory(props, state, function(newState) {
                return _this.setState(newState);
            });
            getTransitions = function getTransitions(childComponent) {
                return getTransitionProps(childComponent, index);
            };
        }
        return (0, _defaultsDefault.default)({
            getTransitions: getTransitions,
            parentState: parentState
        }, props.animate, child.props.animate);
    },
    getDomainFromChildren: function getDomainFromChildren(props, axis, childComponents) {
        // eslint-disable-line max-statements, complexity, max-len
        var children = childComponents ? childComponents.slice(0) : (0, _reactDefault.default).Children.toArray(props.children);
        var parentData = props.data ? _data.getData(props, axis) : undefined;
        var polar = props.polar, startAngle = props.startAngle, endAngle = props.endAngle, categories = props.categories, minDomain = props.minDomain, maxDomain = props.maxDomain, horizontal = props.horizontal;
        var baseParentProps = {
            horizontal: horizontal,
            polar: polar,
            startAngle: startAngle,
            endAngle: endAngle,
            minDomain: minDomain,
            maxDomain: maxDomain,
            categories: categories
        };
        var parentProps = parentData ? (0, _assignDefault.default)(baseParentProps, {
            data: parentData
        }) : baseParentProps;
        var iteratee = function iteratee(child) {
            var sharedProps = (0, _assignDefault.default)({}, child.props, parentProps);
            if (!_domain.isDomainComponent(child)) return null;
            else if (child.type && (0, _isFunctionDefault.default)(child.type.getDomain)) return child.props && child.type.getDomain(sharedProps, axis);
            else return _domain.getDomain(sharedProps, axis);
        };
        var childDomains = _helpers.reduceChildren(children, iteratee, props);
        var min = childDomains.length === 0 ? 0 : _collection.getMinValue(childDomains);
        var max = childDomains.length === 0 ? 1 : _collection.getMaxValue(childDomains);
        return [
            min,
            max
        ];
    },
    addBinsToParentPropsIfHistogram: function addBinsToParentPropsIfHistogram(_ref) {
        var children = _ref.children, props = _ref.props, childComponents = _ref.childComponents, parentProps = _ref.parentProps;
        var someChildrenAreHistograms = children.some(function(child) {
            return child.type && child.type.role === "histogram";
        });
        var allChildrenAreHistograms = someChildrenAreHistograms && children.length && children.every(function(child) {
            return child.type && child.type.role === "histogram";
        });
        if (someChildrenAreHistograms && !allChildrenAreHistograms) _log.warn("VictoryHistogram only supports being stacked with other VictoryHistogram components. Check to make sure that you are only passing VictoryHistogram components to VictoryStack");
         // if we are stacking histograms, we need to generate explicit bins
        // or else each histogram may end up having different bins
        if (!allChildrenAreHistograms) return parentProps;
        var childBins = props.bins || childComponents[0].props.bins; // if we have explicit bins then we don't need to calculate them
        if (!Array.isArray(childBins)) {
            var combinedData = children.reduce(function(memo, child) {
                var xAccessor = _helpers.createAccessor(child.props.x || "x");
                return memo.concat(child.props.data.map(function(datum) {
                    return {
                        x: xAccessor(datum)
                    };
                }));
            }, []); // use the same function to generate bins as VictoryHistogram but with
            // the combined data from above, then get explicit bins from that
            var getFormattedHistogramData = children[0].type.getFormattedData;
            childBins = getFormattedHistogramData({
                data: combinedData,
                bins: childBins
            }).reduce(function(memo, _ref2, index) {
                var x0 = _ref2.x0, x1 = _ref2.x1;
                return index === 0 ? memo.concat([
                    x0,
                    x1
                ]) : memo.concat(x1);
            }, []);
        }
        return _objectSpread({}, parentProps, {
            bins: childBins
        });
    },
    getDataFromChildren: function getDataFromChildren(props, childComponents) {
        var polar = props.polar, startAngle = props.startAngle, endAngle = props.endAngle, categories = props.categories, minDomain = props.minDomain, maxDomain = props.maxDomain;
        var parentProps = {
            polar: polar,
            startAngle: startAngle,
            endAngle: endAngle,
            categories: categories,
            minDomain: minDomain,
            maxDomain: maxDomain
        };
        var stack = 0;
        var children = childComponents ? childComponents.slice(0) : (0, _reactDefault.default).Children.toArray(props.children);
        parentProps = this.addBinsToParentPropsIfHistogram({
            children: children,
            props: props,
            childComponents: childComponents,
            parentProps: parentProps
        });
        var iteratee = function iteratee(child, childName, parent) {
            var childProps = (0, _assignDefault.default)({}, child.props, parentProps);
            var childData;
            if (!_data.isDataComponent(child)) return null;
            else if (child.type && (0, _isFunctionDefault.default)(child.type.getData)) {
                child = parent ? (0, _reactDefault.default).cloneElement(child, parent.props) : child;
                childData = child.type.getData(childProps);
            } else childData = _data.getData(childProps);
            stack += 1;
            return childData.map(function(datum, index) {
                return (0, _assignDefault.default)({
                    _stack: stack,
                    _group: index
                }, datum);
            });
        };
        var stacked = children.filter(function(c) {
            return c.type && c.type.role === "stack";
        }).length;
        var combine = function combine(memo, val) {
            return memo.concat((0, _uniqByDefault.default)(val, "_group"));
        };
        var datasets = _helpers.reduceChildren(children, iteratee, props, [], combine);
        var group = stacked ? "_group" : "_stack";
        return (0, _valuesDefault.default)((0, _groupByDefault.default)(datasets, group));
    },
    getColor: function getColor(calculatedProps, child, index) {
        // check for styles first
        var style = calculatedProps.style;
        var colorScale = calculatedProps.colorScale, color = calculatedProps.color;
        if (style && style.data && style.data.fill) return style.data.fill;
        colorScale = child.props && child.props.colorScale ? child.props.colorScale : colorScale;
        color = child.props && child.props.color ? child.props.color : color;
        if (!colorScale && !color) return undefined;
        var colors = Array.isArray(colorScale) ? colorScale : _style.getColorScale(colorScale);
        return color || colors[index % colors.length];
    },
    getWidth: function getWidth(props, groupLength, seriesLength) {
        var datasets = props.datasets, horizontal = props.horizontal;
        var range = horizontal ? _helpers.getRange(props, "y") : _helpers.getRange(props, "x");
        var extent = Math.abs(range[1] - range[0]);
        seriesLength = seriesLength !== undefined ? seriesLength : Array.isArray(datasets[0]) && datasets[0].length || 1;
        groupLength = groupLength || datasets.length;
        var bars = groupLength * seriesLength;
        var barRatio = 0.5;
        return Math.round(barRatio * extent / bars);
    },
    getStyle: function getStyle(theme, style, role) {
        var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
        return _helpers.getStyles(style, defaultStyle);
    },
    getChildStyle: function getChildStyle(child, index, calculatedProps) {
        var style = calculatedProps.style, role = calculatedProps.role;
        var childStyle = child.props.style || {};
        if (Array.isArray(childStyle)) return childStyle;
        var childRole = child.type && child.type.role;
        var defaultFill = childRole === "stack" ? undefined : this.getColor(calculatedProps, child, index);
        var defaultColor = childRole === "line" ? {
            fill: "none",
            stroke: defaultFill
        } : {
            fill: defaultFill
        };
        var dataWidth = role === "stack" ? {} : {
            width: this.getWidth(calculatedProps)
        };
        var dataStyle = (0, _defaultsDefault.default)({}, childStyle.data, (0, _assignDefault.default)({}, dataWidth, style.data, defaultColor));
        var labelsStyle = (0, _defaultsDefault.default)({}, childStyle.labels, style.labels);
        return {
            parent: style.parent,
            data: dataStyle,
            labels: labelsStyle
        };
    },
    getStringsFromCategories: function getStringsFromCategories(childComponents, axis) {
        var iteratee = function iteratee(child) {
            var childProps = child.props || {};
            if (!_domain.isDomainComponent(child) || !childProps.categories) return null;
            else {
                var categories = childProps.categories && !Array.isArray(childProps.categories) ? childProps.categories[axis] : childProps.props.categories;
                var categoryStrings = categories && categories.filter(function(val) {
                    return typeof val === "string";
                });
                return categoryStrings ? _collection.removeUndefined(categoryStrings) : [];
            }
        };
        return _helpers.reduceChildren(childComponents.slice(0), iteratee);
    },
    getStringsFromData: function getStringsFromData(childComponents) {
        var iteratee = function iteratee(child) {
            var childProps = child.props || {};
            var data;
            if (!_data.isDataComponent(child)) return null;
            else if (child.type && (0, _isFunctionDefault.default)(child.type.getData)) data = child.type.getData(childProps);
            else data = _data.getData(childProps);
            return data.map(function(d) {
                return {
                    x: d.xName,
                    y: d.yName
                };
            });
        };
        var initialMemo = {
            x: [],
            y: []
        };
        var combine = function combine(memo, datum) {
            var x = Array.isArray(datum) ? datum.map(function(d) {
                return d.x;
            }).filter(Boolean) : datum.x;
            var y = Array.isArray(datum) ? datum.map(function(d) {
                return d.y;
            }).filter(Boolean) : datum.y;
            return {
                x: x !== undefined ? memo.x.concat(x) : memo.x,
                y: y !== undefined ? memo.y.concat(y) : memo.y
            };
        };
        return _helpers.reduceChildren(childComponents.slice(0), iteratee, {}, initialMemo, combine);
    },
    getCategoryAndAxisStringsFromChildren: function getCategoryAndAxisStringsFromChildren(props, axis, childComponents) {
        var categories = (0, _isPlainObjectDefault.default)(props.categories) ? props.categories[axis] : props.categories;
        var axisComponent = _axis.getAxisComponent(childComponents, axis);
        var axisStrings = axisComponent ? _data.getStringsFromAxes(axisComponent.props, axis) : [];
        var categoryStrings = categories || this.getStringsFromCategories(childComponents, axis);
        return (0, _uniqDefault.default)((0, _flattenDefault.default)(_toConsumableArray(categoryStrings).concat(_toConsumableArray(axisStrings))));
    },
    getStringsFromChildren: function getStringsFromChildren(props, childComponents) {
        childComponents = childComponents || (0, _reactDefault.default).Children.toArray(props.children);
        var xStrings = this.getCategoryAndAxisStringsFromChildren(props, "x", childComponents);
        var yStrings = this.getCategoryAndAxisStringsFromChildren(props, "y", childComponents);
        var dataStrings = this.getStringsFromData(childComponents);
        return {
            x: (0, _uniqDefault.default)((0, _flattenDefault.default)(_toConsumableArray(xStrings).concat(_toConsumableArray(dataStrings.x)))),
            y: (0, _uniqDefault.default)((0, _flattenDefault.default)(_toConsumableArray(yStrings).concat(_toConsumableArray(dataStrings.y))))
        };
    },
    getCategories: function getCategories(props, childComponents, allStrings) {
        var xPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.x : props.categories;
        var yPropCategories = props.categories && !Array.isArray(props.categories) ? props.categories.y : props.categories;
        var fallbackRequired = !xPropCategories || !yPropCategories;
        var fallbackProps = fallbackRequired ? allStrings || this.getStringsFromChildren(props, childComponents) : {};
        var xCategories = xPropCategories || fallbackProps.x;
        var yCategories = yPropCategories || fallbackProps.y;
        return {
            x: xCategories.length > 0 ? xCategories : undefined,
            y: yCategories.length > 0 ? yCategories : undefined
        };
    }
};

},{"lodash/isPlainObject":"2RXyg","lodash/values":"lKyoC","lodash/uniqBy":"2YIDS","lodash/groupBy":"agwIt","lodash/some":"6aioB","lodash/uniq":"2LHAg","lodash/isFunction":"8ck2f","lodash/flatten":"b7fAH","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","react":"gVheC","./axis":"8lzBT","./style":"aPnOz","./transitions":"iXuWj","./data":"5rlHC","./domain":"bCD2e","./events":"bDJ4N","./collection":"4mxxX","./helpers":"8ABme","./scale":"je6Bi","./log":"dgIVr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2YIDS":[function(require,module,exports,__globalThis) {
var baseIteratee = require("ce9604aad32f97ab"), baseUniq = require("9fbd8e46e11f49c4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"ce9604aad32f97ab":"exkHY","9fbd8e46e11f49c4":"lUDFb"}],"agwIt":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("45224c2cbc26a385"), createAggregator = require("54112449397fdfd2");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) result[key].push(value);
    else baseAssignValue(result, key, [
        value
    ]);
});
module.exports = groupBy;

},{"45224c2cbc26a385":"8nNdL","54112449397fdfd2":"ckIws"}],"6aioB":[function(require,module,exports,__globalThis) {
var arraySome = require("499d9ae1b712c84d"), baseIteratee = require("6137baa4d335eb2f"), baseSome = require("dffda66140b0b703"), isArray = require("21c688a994e48617"), isIterateeCall = require("86e6a8e9c3fc8343");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"499d9ae1b712c84d":"3m5PV","6137baa4d335eb2f":"exkHY","dffda66140b0b703":"3fsx8","21c688a994e48617":"jQGs4","86e6a8e9c3fc8343":"936XO"}],"3fsx8":[function(require,module,exports,__globalThis) {
var baseEach = require("fbf6b3dce93949f8");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"fbf6b3dce93949f8":"eUqSn"}],"8lzBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the axis (x or y) of a particular axis component
 * @param {Object} props: the props object.
 * @param {Boolean} horizontal: true for horizontal charts
 * @returns {String} the dimension appropriate for the axis given its props
 */ parcelHelpers.export(exports, "getAxis", function() {
    return getAxis;
});
/**
 * Returns all axis components that pass a given predicate
 * @param {Array} childComponents: an array of children
 * @param {Function} predicate: a predicate function that will be called with each
 * @returns {Array} all axis components that pass the given predicate or []
 */ parcelHelpers.export(exports, "findAxisComponents", function() {
    return findAxisComponents;
});
/**
 * Returns a single axis component of the desired axis type (x or y)
 * @param {Array} childComponents: an array of children
 * @param {String} axis: desired axis either "x" or "y".
 * @returns {ReactComponent} an axis component of the desired axis or undefined
 */ parcelHelpers.export(exports, "getAxisComponent", function() {
    return getAxisComponent;
});
/**
 * Returns all axis components of the desired axis type (x or y) along with any
 * parent components excluding VictoryChart
 * @param {Array} childComponents: an optional array of children.
 * @param {String} type: desired axis either "dependent" or "independent".
 * @returns {ReactComponent} an axis component of the desired type or undefined
 */ parcelHelpers.export(exports, "getAxisComponentsWithParent", function() {
    return getAxisComponentsWithParent;
});
parcelHelpers.export(exports, "getOrigin", function() {
    return getOrigin;
});
parcelHelpers.export(exports, "getOriginSign", function() {
    return getOriginSign;
});
/**
 * @param {Object} props: axis component props
 * @returns {Boolean} true when the axis is vertical
 */ parcelHelpers.export(exports, "isVertical", function() {
    return isVertical;
});
/**
 * @param {Object} props: axis component props
 * @returns {Boolean} true when tickValues contain strings
 */ parcelHelpers.export(exports, "stringTicks", function() {
    return stringTicks;
});
parcelHelpers.export(exports, "getTickFormat", function() {
    return getTickFormat;
});
parcelHelpers.export(exports, "getTicks", function() {
    return getTicks;
});
parcelHelpers.export(exports, "getDomain", function() {
    return getDomain;
});
parcelHelpers.export(exports, "getAxisValue", function() {
    return getAxisValue;
});
parcelHelpers.export(exports, "modifyProps", function() {
    return modifyProps;
});
var _without = require("lodash/without");
var _withoutDefault = parcelHelpers.interopDefault(_without);
var _includes = require("lodash/includes");
var _includesDefault = parcelHelpers.interopDefault(_includes);
var _values = require("lodash/values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _orderBy = require("lodash/orderBy");
var _orderByDefault = parcelHelpers.interopDefault(_orderBy);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _invert = require("lodash/invert");
var _invertDefault = parcelHelpers.interopDefault(_invert);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _identity = require("lodash/identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
/* eslint-disable func-style */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _collection = require("./collection");
var _domain = require("./domain");
var _helpers = require("./helpers");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function getAxis(props) {
    var dependentAxis = props.dependentAxis;
    return dependentAxis ? "y" : "x";
}
function findAxisComponents(childComponents, predicate) {
    predicate = predicate || (0, _identityDefault.default);
    var findAxes = function findAxes1(children) {
        return children.reduce(function(memo, child) {
            if (child.type && child.type.role === "axis" && predicate(child)) return memo.concat(child);
            else if (child.props && child.props.children) return memo.concat(findAxes((0, _reactDefault.default).Children.toArray(child.props.children)));
            return memo;
        }, []);
    };
    return findAxes(childComponents);
}
function getAxisComponent(childComponents, axis) {
    var matchesAxis = function matchesAxis(component) {
        var type = component.type.getAxis(component.props);
        return type === axis;
    };
    return findAxisComponents(childComponents, matchesAxis)[0];
}
function getAxisComponentsWithParent(childComponents, type) {
    var matchesType = function matchesType(child) {
        return type === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
    };
    var findComponents = function findComponents1(children) {
        return children.reduce(function(memo, child) {
            if (child.type && child.type.role === "axis" && matchesType(child)) return memo.concat(child);
            else if (child.props && child.props.children) {
                var childAxis = findComponents((0, _reactDefault.default).Children.toArray(child.props.children));
                return childAxis.length > 0 ? memo.concat(child) : memo;
            }
            return memo;
        }, []);
    };
    return findComponents(childComponents);
}
function getOrigin(domain) {
    var getSingleOrigin = function getSingleOrigin(d) {
        var domainMin = Math.min.apply(Math, _toConsumableArray(d));
        var domainMax = Math.max.apply(Math, _toConsumableArray(d));
        return domainMax < 0 ? domainMax : Math.max(0, domainMin);
    };
    return {
        x: _collection.containsDates(domain.x) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.x))) : getSingleOrigin(domain.x),
        y: _collection.containsDates(domain.y) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.y))) : getSingleOrigin(domain.y)
    };
}
function getOriginSign(origin, domain) {
    var getSign = function getSign() {
        return origin <= 0 && Math.max.apply(Math, _toConsumableArray(domain)) <= 0 ? "negative" : "positive";
    };
    return _collection.containsDates(domain) ? "positive" : getSign();
}
function isVertical(props) {
    var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
    var vertical = {
        top: false,
        bottom: false,
        left: true,
        right: true
    };
    return vertical[orientation];
}
function stringTicks(props) {
    return props.tickValues !== undefined && _collection.containsStrings(props.tickValues);
}
function getDefaultTickFormat(props) {
    var tickValues = props.tickValues;
    var axis = getAxis(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var fallbackFormat = tickValues && !_collection.containsDates(tickValues) ? function fallbackFormat(x) {
        return x;
    } : undefined;
    if (!stringMap) return stringTicks(props) ? function(x, index) {
        return tickValues[index];
    } : fallbackFormat;
    else {
        var invertedStringMap = stringMap && (0, _invertDefault.default)(stringMap);
        var tickValueArray = (0, _orderByDefault.default)((0, _valuesDefault.default)(stringMap), function(n) {
            return n;
        });
        var dataNames = tickValueArray.map(function(tick) {
            return invertedStringMap[tick];
        }); // string ticks should have one tick of padding at the beginning
        var dataTicks = [
            ""
        ].concat(_toConsumableArray(dataNames), [
            ""
        ]);
        return function(x) {
            return dataTicks[x];
        };
    }
}
function getStringTicks(props) {
    var axis = getAxis(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var categories = Array.isArray(props.categories) ? props.categories : props.categories && props.categories[axis];
    var ticksFromCategories = categories && _collection.containsOnlyStrings(categories) ? categories.map(function(tick) {
        return stringMap[tick];
    }) : undefined;
    var ticksFromStringMap = stringMap && (0, _valuesDefault.default)(stringMap);
    return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
}
function getTickArray(props) {
    var tickValues = props.tickValues, tickFormat = props.tickFormat;
    var axis = getAxis(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    var getTicksFromFormat = function getTicksFromFormat() {
        if (!tickFormat || !Array.isArray(tickFormat)) return undefined;
        return _collection.containsStrings(tickFormat) ? tickFormat.map(function(t, i) {
            return i;
        }) : tickFormat;
    };
    var ticks = tickValues;
    if (stringMap) ticks = getStringTicks(props);
    if (tickValues && _collection.containsStrings(tickValues)) ticks = stringMap ? tickValues.map(function(tick) {
        return stringMap[tick];
    }) : (0, _rangeDefault.default)(1, tickValues.length + 1);
    var tickArray = ticks ? (0, _uniqDefault.default)(ticks) : getTicksFromFormat(props);
    var buildTickArray = function buildTickArray(arr) {
        var newTickArray = [];
        var domain = props.domain && props.domain[axis] || props.domain;
        if (arr) {
            arr.forEach(function(t, index) {
                if (Array.isArray(domain)) {
                    if (t >= _collection.getMinValue(domain) && t <= _collection.getMaxValue(domain)) newTickArray.push({
                        value: t,
                        index: index
                    });
                } else newTickArray.push({
                    value: t,
                    index: index
                });
            });
            return newTickArray;
        } else return undefined;
    };
    return Array.isArray(tickArray) && tickArray.length ? buildTickArray(tickArray) : undefined;
}
function getTickFormat(props, scale) {
    var tickFormat = props.tickFormat;
    var axis = getAxis(props);
    var stringMap = props.stringMap && props.stringMap[axis];
    if (!tickFormat) {
        var defaultTickFormat = getDefaultTickFormat(props);
        var scaleTickFormat = scale.tickFormat && (0, _isFunctionDefault.default)(scale.tickFormat) ? scale.tickFormat() : function scaleTickFormat(x) {
            return x;
        };
        return defaultTickFormat || scaleTickFormat;
    } else if (tickFormat && Array.isArray(tickFormat)) {
        var tickArray = getTickArray(props);
        var tickArrayIndices = tickArray ? tickArray.map(function(v) {
            return v.index;
        }) : undefined;
        var filteredTickFormat = tickFormat.filter(function(t, index) {
            return tickArrayIndices.includes(index);
        });
        return function(x, index) {
            return filteredTickFormat[index];
        };
    } else if (tickFormat && (0, _isFunctionDefault.default)(tickFormat)) {
        var applyStringTicks = function applyStringTicks(tick, index, ticks) {
            var invertedStringMap = (0, _invertDefault.default)(stringMap);
            var stringTickArray = ticks.map(function(t) {
                return invertedStringMap[t];
            });
            return props.tickFormat(invertedStringMap[tick], index, stringTickArray);
        };
        return stringMap ? applyStringTicks : tickFormat;
    } else return function(x) {
        return x;
    };
}
function downsampleTicks(ticks, tickCount) {
    if (!tickCount || !Array.isArray(ticks) || ticks.length <= tickCount) return ticks;
    var k = Math.floor(ticks.length / tickCount);
    return ticks.filter(function(d, i) {
        return i % k === 0;
    });
}
function getTicks(props, scale, filterZero) {
    var tickCount = props.tickCount;
    var tickArray = getTickArray(props);
    var tickValues = tickArray ? tickArray.map(function(v) {
        return v.value;
    }) : undefined;
    if (tickValues) return downsampleTicks(tickValues, tickCount);
    else if (scale.ticks && (0, _isFunctionDefault.default)(scale.ticks)) {
        // eslint-disable-next-line no-magic-numbers
        var defaultTickCount = tickCount || 5;
        var scaleTicks = scale.ticks(defaultTickCount);
        var scaledTickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
        var ticks = downsampleTicks(scaledTickArray, tickCount);
        if (filterZero) {
            var filteredTicks = (0, _includesDefault.default)(ticks, 0) ? (0, _withoutDefault.default)(ticks, 0) : ticks;
            return filteredTicks.length ? filteredTicks : ticks;
        }
        return ticks;
    }
    return scale.domain();
}
/**
 * Returns a domain based tickValues
 * @param {Object} props: the props object
 * @param {String} axis: either x or y
 * @returns {Array} returns a domain from tickValues
 */ //eslint-disable-next-line max-statements
function getDomainFromData(props, axis) {
    var polar = props.polar, _props$startAngle = props.startAngle, startAngle = _props$startAngle === void 0 ? 0 : _props$startAngle, _props$endAngle = props.endAngle, endAngle = _props$endAngle === void 0 ? 360 : _props$endAngle;
    var tickArray = getTickArray(props);
    var tickValues = tickArray ? tickArray.map(function(v) {
        return v.value;
    }) : undefined;
    if (!Array.isArray(tickValues)) return undefined;
    var minDomain = _domain.getMinFromProps(props, axis);
    var maxDomain = _domain.getMaxFromProps(props, axis);
    var tickStrings = stringTicks(props);
    var ticks = tickValues.map(function(value) {
        return +value;
    });
    var defaultMin = tickStrings ? 1 : _collection.getMinValue(ticks);
    var defaultMax = tickStrings ? tickValues.length : _collection.getMaxValue(ticks);
    var min = minDomain !== undefined ? minDomain : defaultMin;
    var max = maxDomain !== undefined ? maxDomain : defaultMax;
    var initialDomain = _domain.getDomainFromMinMax(min, max);
    var domain = polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? _domain.getSymmetricDomain(initialDomain, ticks) : initialDomain;
    if (isVertical(props) && !polar) domain.reverse();
    return domain;
} // exposed for use by VictoryChart
function getDomain(props, axis) {
    var inherentAxis = getAxis(props);
    if (axis && axis !== inherentAxis) return undefined;
    return _domain.createDomainFunction(getDomainFromData)(props, inherentAxis);
}
function getAxisValue(props, axis) {
    if (!props.axisValue) return undefined;
    var scaleAxis = axis === "x" ? "y" : "x";
    var scale = (0, _isObjectDefault.default)(props.scale) && (0, _isFunctionDefault.default)(props.scale[scaleAxis]) ? props.scale[scaleAxis] : undefined;
    if (!scale) return undefined;
    var stringMapAxis = axis === "x" ? "y" : "x";
    var stringMap = (0, _isObjectDefault.default)(props.stringMap) && props.stringMap[stringMapAxis];
    var axisValue = stringMap && typeof props.axisValue === "string" ? stringMap[props.axisValue] : props.axisValue;
    return scale(axisValue);
}
function modifyProps(props, fallbackProps) {
    if (!(0, _isObjectDefault.default)(props.theme)) return _helpers.modifyProps(props, fallbackProps, "axis");
    var role = "axis";
    if (props.dependentAxis && props.theme.dependentAxis) role = "dependentAxis";
    else if (!props.dependentAxis && props.theme.independentAxis) role = "independentAxis";
    if (role === "axis") return _helpers.modifyProps(props, fallbackProps, "axis");
    var axisTheme = (0, _defaultsDefault.default)({}, props.theme[role], props.theme.axis);
    var theme = (0, _assignDefault.default)({}, props.theme, {
        axis: axisTheme
    });
    return _helpers.modifyProps((0, _assignDefault.default)({}, props, {
        theme: theme
    }), fallbackProps, "axis");
}

},{"lodash/without":"dIbEO","lodash/includes":"2bZ7U","lodash/values":"lKyoC","lodash/orderBy":"kNMvc","lodash/range":"3wXYB","lodash/uniq":"2LHAg","lodash/invert":"fPMP0","lodash/isObject":"8ffGS","lodash/isFunction":"8ck2f","lodash/identity":"6wIyV","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","react":"gVheC","./collection":"4mxxX","./domain":"bCD2e","./helpers":"8ABme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPMP0":[function(require,module,exports,__globalThis) {
var constant = require("35dfae1ccf99615e"), createInverter = require("b3c38231992fdf8a"), identity = require("950a01341ce58064");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var invert = createInverter(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
    result[value] = key;
}, constant(identity));
module.exports = invert;

},{"35dfae1ccf99615e":"jESKB","b3c38231992fdf8a":"eP4aD","950a01341ce58064":"6wIyV"}],"eP4aD":[function(require,module,exports,__globalThis) {
var baseInverter = require("c7762abf8d97d8c");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = createInverter;

},{"c7762abf8d97d8c":"eNV8R"}],"eNV8R":[function(require,module,exports,__globalThis) {
var baseForOwn = require("f61ffd7f99fe42b");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function baseInverter(object, setter, iteratee, accumulator) {
    baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = baseInverter;

},{"f61ffd7f99fe42b":"aVySe"}],"fl6rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryChart", function() {
    return 0, _victoryChartDefault.default;
});
var _victoryChart = require("./victory-chart");
var _victoryChartDefault = parcelHelpers.interopDefault(_victoryChart);

},{"./victory-chart":"4X1no","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4X1no":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictoryChart;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _victoryCore = require("victory-core");
var _victorySharedEvents = require("victory-shared-events");
var _victoryAxis = require("victory-axis");
var _victoryPolarAxis = require("victory-polar-axis");
var _helperMethods = require("./helper-methods");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var VictoryChart = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryChart, _React$Component);
    function VictoryChart(props) {
        var _this;
        _classCallCheck(this, VictoryChart);
        _this = _possibleConstructorReturn(this, (VictoryChart.__proto__ || Object.getPrototypeOf(VictoryChart)).call(this, props));
        _this.state = {};
        if (props.animate) {
            _this.state = {
                nodesShouldLoad: false,
                nodesDoneLoad: false,
                animating: true
            };
            _this.setAnimationState = (0, _victoryCore.Wrapper).setAnimationState.bind(_assertThisInitialized(_this));
        }
        return _this;
    }
    _createClass(VictoryChart, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.animate) {
                    if (!(0, _reactFastCompareDefault.default)(this.props, nextProps)) {
                        this.setAnimationState(this.props, nextProps);
                        return false;
                    }
                }
                return true;
            }
        },
        {
            key: "getNewChildren",
            value: function getNewChildren(props, childComponents, calculatedProps) {
                var children = (0, _helperMethods.getChildren)(props, childComponents, calculatedProps);
                var getAnimationProps = (0, _victoryCore.Wrapper).getAnimationProps.bind(this);
                var newChildren = children.map(function(child, index) {
                    var childProps = (0, _assignDefault.default)({
                        animate: getAnimationProps(props, child, index)
                    }, child.props);
                    return (0, _reactDefault.default).cloneElement(child, childProps);
                });
                if (props.style && props.style.background) {
                    var backgroundComponent = (0, _helperMethods.getBackgroundWithProps)(props, calculatedProps);
                    newChildren.unshift(backgroundComponent);
                }
                return newChildren;
            }
        },
        {
            key: "renderContainer",
            value: function renderContainer(containerComponent, props) {
                var containerProps = (0, _defaultsDefault.default)({}, containerComponent.props, props);
                return (0, _reactDefault.default).cloneElement(containerComponent, containerProps);
            }
        },
        {
            key: "getContainerProps",
            value: function getContainerProps(props, calculatedProps) {
                var width = props.width, height = props.height, standalone = props.standalone, theme = props.theme, polar = props.polar, name = props.name;
                var domain = calculatedProps.domain, scale = calculatedProps.scale, style = calculatedProps.style, origin = calculatedProps.origin, radius = calculatedProps.radius, horizontal = calculatedProps.horizontal;
                return {
                    domain: domain,
                    scale: scale,
                    width: width,
                    height: height,
                    standalone: standalone,
                    theme: theme,
                    style: style.parent,
                    horizontal: horizontal,
                    name: name,
                    polar: polar,
                    radius: radius,
                    origin: polar ? origin : undefined
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
                var modifiedProps = (0, _victoryCore.Helpers).modifyProps(props, fallbackProps, "chart");
                var eventKey = modifiedProps.eventKey, containerComponent = modifiedProps.containerComponent, groupComponent = modifiedProps.groupComponent, standalone = modifiedProps.standalone, externalEventMutations = modifiedProps.externalEventMutations;
                var axes = props.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
                var childComponents = (0, _helperMethods.getChildComponents)(modifiedProps, axes);
                var calculatedProps = (0, _helperMethods.getCalculatedProps)(modifiedProps, childComponents);
                var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
                var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
                var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
                var events = (0, _victoryCore.Wrapper).getAllEvents(props);
                if (!(0, _isEmptyDefault.default)(events)) return (0, _reactDefault.default).createElement((0, _victorySharedEvents.VictorySharedEvents), {
                    container: container,
                    eventKey: eventKey,
                    events: events,
                    externalEventMutations: externalEventMutations
                }, newChildren);
                return (0, _reactDefault.default).cloneElement(container, container.props, newChildren);
            }
        }
    ]);
    return VictoryChart;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryChart, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryChart"
});
Object.defineProperty(VictoryChart, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _objectSpread({}, (0, _victoryCore.CommonProps).baseProps, {
        backgroundComponent: (0, _propTypesDefault.default).element,
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        defaultAxes: (0, _propTypesDefault.default).shape({
            independent: (0, _propTypesDefault.default).element,
            dependent: (0, _propTypesDefault.default).element
        }),
        defaultPolarAxes: (0, _propTypesDefault.default).shape({
            independent: (0, _propTypesDefault.default).element,
            dependent: (0, _propTypesDefault.default).element
        }),
        endAngle: (0, _propTypesDefault.default).number,
        innerRadius: (0, _victoryCore.PropTypes).nonNegative,
        prependDefaultAxes: (0, _propTypesDefault.default).bool,
        startAngle: (0, _propTypesDefault.default).number
    })
});
Object.defineProperty(VictoryChart, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        backgroundComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Background), null),
        containerComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryContainer), null),
        defaultAxes: {
            independent: (0, _reactDefault.default).createElement((0, _victoryAxis.VictoryAxis), null),
            dependent: (0, _reactDefault.default).createElement((0, _victoryAxis.VictoryAxis), {
                dependentAxis: true
            })
        },
        defaultPolarAxes: {
            independent: (0, _reactDefault.default).createElement((0, _victoryPolarAxis.VictoryPolarAxis), null),
            dependent: (0, _reactDefault.default).createElement((0, _victoryPolarAxis.VictoryPolarAxis), {
                dependentAxis: true
            })
        },
        groupComponent: (0, _reactDefault.default).createElement("g", null),
        standalone: true,
        theme: (0, _victoryCore.VictoryTheme).grayscale
    }
});
Object.defineProperty(VictoryChart, "expectedComponents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "groupComponent",
        "containerComponent"
    ]
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/isEmpty":"15wZF","lodash/assign":"xTxAt","lodash/defaults":"eWhnr","prop-types":"3KNJy","react":"gVheC","victory-core":"2Y5GL","victory-shared-events":"5n6Gr","victory-axis":"auE0z","victory-polar-axis":"bdCpQ","./helper-methods":"gWDhr","react-fast-compare":"jGkHB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5n6Gr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictorySharedEvents", function() {
    return 0, _victorySharedEventsDefault.default;
});
var _victorySharedEvents = require("./victory-shared-events");
var _victorySharedEventsDefault = parcelHelpers.interopDefault(_victorySharedEvents);

},{"./victory-shared-events":"cZ0Zy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZ0Zy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return VictorySharedEvents;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _difference = require("lodash/difference");
var _differenceDefault = parcelHelpers.interopDefault(_difference);
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _fromPairs = require("lodash/fromPairs");
var _fromPairsDefault = parcelHelpers.interopDefault(_fromPairs);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryCore = require("victory-core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _jsonStringifySafe = require("json-stringify-safe");
var _jsonStringifySafeDefault = parcelHelpers.interopDefault(_jsonStringifySafe);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var VictorySharedEvents = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictorySharedEvents, _React$Component);
    function VictorySharedEvents(props) {
        var _this;
        _classCallCheck(this, VictorySharedEvents);
        _this = _possibleConstructorReturn(this, (VictorySharedEvents.__proto__ || Object.getPrototypeOf(VictorySharedEvents)).call(this, props));
        _this.state = _this.state || {};
        _this.getScopedEvents = (0, _victoryCore.Events).getScopedEvents.bind(_assertThisInitialized(_this));
        _this.getEventState = (0, _victoryCore.Events).getEventState.bind(_assertThisInitialized(_this));
        _this.baseProps = _this.getBaseProps(props);
        _this.sharedEventsCache = {};
        _this.globalEvents = {};
        _this.prevGlobalEventKeys = [];
        _this.boundGlobalEvents = {};
        return _this;
    }
    _createClass(VictorySharedEvents, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (!(0, _reactFastCompareDefault.default)(this.props, nextProps)) {
                    this.baseProps = this.getBaseProps(nextProps);
                    var externalMutations = this.getExternalMutations(nextProps, this.baseProps);
                    this.applyExternalMutations(nextProps, externalMutations);
                }
                return true;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var globalEventKeys = (0, _keysDefault.default)(this.globalEvents);
                globalEventKeys.forEach(function(key) {
                    return _this2.addGlobalListener(key);
                });
                this.prevGlobalEventKeys = globalEventKeys;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this3 = this;
                var globalEventKeys = (0, _keysDefault.default)(this.globalEvents);
                var removedGlobalEventKeys = (0, _differenceDefault.default)(this.prevGlobalEventKeys, globalEventKeys);
                removedGlobalEventKeys.forEach(function(key) {
                    return _this3.removeGlobalListener(key);
                });
                var addedGlobalEventKeys = (0, _differenceDefault.default)(globalEventKeys, this.prevGlobalEventKeys);
                addedGlobalEventKeys.forEach(function(key) {
                    return _this3.addGlobalListener(key);
                });
                this.prevGlobalEventKeys = globalEventKeys;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this4 = this;
                this.prevGlobalEventKeys.forEach(function(key) {
                    return _this4.removeGlobalListener(key);
                });
            }
        },
        {
            key: "addGlobalListener",
            value: function addGlobalListener(key) {
                var _this5 = this;
                var boundListener = function boundListener(event) {
                    var listener = _this5.globalEvents[key];
                    return listener && listener((0, _victoryCore.Events).emulateReactEvent(event));
                };
                this.boundGlobalEvents[key] = boundListener;
                window.addEventListener((0, _victoryCore.Events).getGlobalEventNameFromKey(key), boundListener);
            }
        },
        {
            key: "removeGlobalListener",
            value: function removeGlobalListener(key) {
                window.removeEventListener((0, _victoryCore.Events).getGlobalEventNameFromKey(key), this.boundGlobalEvents[key]);
            }
        },
        {
            key: "getAllEvents",
            value: function getAllEvents(props) {
                var components = [
                    "container",
                    "groupComponent"
                ];
                var componentEvents = (0, _victoryCore.Events).getComponentEvents(props, components);
                if (Array.isArray(componentEvents)) return Array.isArray(props.events) ? componentEvents.concat.apply(componentEvents, _toConsumableArray(props.events)) : componentEvents;
                return props.events;
            }
        },
        {
            key: "applyExternalMutations",
            value: function applyExternalMutations(props, externalMutations) {
                if (!(0, _isEmptyDefault.default)(externalMutations)) {
                    var callbacks = props.externalEventMutations.reduce(function(memo, mutation) {
                        memo = (0, _isFunctionDefault.default)(mutation.callback) ? memo.concat(mutation.callback) : memo;
                        return memo;
                    }, []);
                    var compiledCallbacks = callbacks.length ? function compiledCallbacks() {
                        callbacks.forEach(function(c) {
                            return c();
                        });
                    } : undefined;
                    this.setState(externalMutations, compiledCallbacks);
                }
            }
        },
        {
            key: "getExternalMutations",
            value: function getExternalMutations(props, baseProps) {
                return !(0, _isEmptyDefault.default)(props.externalEventMutations) ? (0, _victoryCore.Events).getExternalMutationsWithChildren(props.externalEventMutations, baseProps, this.state, (0, _keysDefault.default)(baseProps)) : undefined;
            }
        },
        {
            key: "cacheSharedEvents",
            value: function cacheSharedEvents(name, sharedEvents, cacheValues) {
                this.sharedEventsCache[name] = [
                    sharedEvents,
                    cacheValues
                ];
            }
        },
        {
            key: "getCachedSharedEvents",
            value: function getCachedSharedEvents(name, cacheValues) {
                var _ref = this.sharedEventsCache[name] || [], _ref2 = _slicedToArray(_ref, 2), sharedEvents = _ref2[0], prevCacheValues = _ref2[1];
                if (sharedEvents && (0, _reactFastCompareDefault.default)(cacheValues, prevCacheValues)) return sharedEvents;
                return undefined;
            }
        },
        {
            key: "getBaseProps",
            value: function getBaseProps(props) {
                var container = props.container;
                var children = (0, _reactDefault.default).Children.toArray(this.props.children);
                var childBaseProps = this.getBasePropsFromChildren(children);
                var parentBaseProps = container ? container.props : {};
                return (0, _assignDefault.default)({}, childBaseProps, {
                    parent: parentBaseProps
                });
            }
        },
        {
            key: "getBasePropsFromChildren",
            value: function getBasePropsFromChildren(childComponents) {
                var iteratee = function iteratee(child, childName) {
                    if (child.type && (0, _isFunctionDefault.default)(child.type.getBaseProps)) {
                        var _baseProps = child.props && child.type.getBaseProps(child.props);
                        return _baseProps ? [
                            [
                                childName,
                                _baseProps
                            ]
                        ] : null;
                    } else return null;
                };
                var baseProps = (0, _victoryCore.Helpers).reduceChildren(childComponents, iteratee);
                return (0, _fromPairsDefault.default)(baseProps);
            }
        },
        {
            key: "getNewChildren",
            value: function getNewChildren(props, baseProps) {
                var _this6 = this;
                var events = props.events, eventKey = props.eventKey;
                var alterChildren = function alterChildren1(children, childNames) {
                    return children.reduce(function(memo, child, index) {
                        if (child.props.children) {
                            var newChildren = (0, _reactDefault.default).Children.toArray(child.props.children);
                            var names = childNames.slice(index, index + newChildren.length);
                            var results = (0, _reactDefault.default).cloneElement(child, child.props, alterChildren(newChildren, names));
                            return memo.concat(results);
                        } else if (childNames[index] !== "parent" && child.type && (0, _isFunctionDefault.default)(child.type.getBaseProps)) {
                            var name = child.props.name || childNames[index];
                            var childEvents = Array.isArray(events) && events.filter(function(event) {
                                if (event.target === "parent") return false;
                                return Array.isArray(event.childName) ? event.childName.indexOf(name) > -1 : event.childName === name || event.childName === "all";
                            });
                            var sharedEventsCacheValues = [
                                name,
                                baseProps,
                                childEvents,
                                (0, _jsonStringifySafeDefault.default)(_this6.state[name])
                            ];
                            var sharedEvents = _this6.getCachedSharedEvents(name, sharedEventsCacheValues) || {
                                events: childEvents,
                                // partially apply child name and baseProps,
                                getEvents: function getEvents(evts, target) {
                                    return _this6.getScopedEvents(evts, target, name, baseProps);
                                },
                                // partially apply child name
                                getEventState: function getEventState(key, target) {
                                    return _this6.getEventState(key, target, name);
                                }
                            };
                            _this6.cacheSharedEvents(name, sharedEvents, sharedEventsCacheValues);
                            return memo.concat((0, _reactDefault.default).cloneElement(child, (0, _assignDefault.default)({
                                key: "events-".concat(name),
                                sharedEvents: sharedEvents,
                                eventKey: eventKey,
                                name: name
                            }, child.props)));
                        } else return memo.concat(child);
                    }, []);
                };
                var childNames = (0, _keysDefault.default)(baseProps);
                var childComponents = (0, _reactDefault.default).Children.toArray(props.children);
                return alterChildren(childComponents, childNames);
            }
        },
        {
            key: "getContainer",
            value: function getContainer(props, baseProps, events) {
                var _this7 = this;
                var children = this.getNewChildren(props, baseProps);
                var parents = Array.isArray(events) && events.filter(function(event) {
                    return event.target === "parent";
                });
                var sharedEvents = parents.length > 0 ? {
                    events: parents,
                    // partially apply childName (null) and baseProps,
                    getEvents: function getEvents(evts, target) {
                        return _this7.getScopedEvents(evts, target, null, baseProps);
                    },
                    getEventState: this.getEventState
                } : null;
                var container = props.container || props.groupComponent;
                var role = container.type && container.type.role;
                var containerProps = container.props || {};
                var boundGetEvents = (0, _victoryCore.Events).getEvents.bind(this);
                var parentEvents = sharedEvents && boundGetEvents({
                    sharedEvents: sharedEvents
                }, "parent");
                var parentProps = (0, _defaultsDefault.default)({}, this.getEventState("parent", "parent"), containerProps, baseProps.parent, {
                    children: children
                });
                var containerEvents = (0, _defaultsDefault.default)({}, (0, _victoryCore.Events).getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);
                this.globalEvents = (0, _victoryCore.Events).getGlobalEvents(containerEvents);
                var localEvents = (0, _victoryCore.Events).omitGlobalEvents(containerEvents);
                return role === "container" ? (0, _reactDefault.default).cloneElement(container, (0, _assignDefault.default)({}, parentProps, {
                    events: localEvents
                })) : (0, _reactDefault.default).cloneElement(container, localEvents, children);
            }
        },
        {
            key: "render",
            value: function render() {
                var events = this.getAllEvents(this.props);
                if (events) return this.getContainer(this.props, this.baseProps, events);
                return (0, _reactDefault.default).cloneElement(this.props.container, {
                    children: this.props.children
                });
            }
        }
    ]);
    return VictorySharedEvents;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictorySharedEvents, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictorySharedEvents"
});
Object.defineProperty(VictorySharedEvents, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "shared-event-wrapper"
});
Object.defineProperty(VictorySharedEvents, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        container: (0, _propTypesDefault.default).node,
        eventKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).array,
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string
        ]),
        events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            childName: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ]),
            eventHandlers: (0, _propTypesDefault.default).object,
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _propTypesDefault.default).func,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            target: (0, _propTypesDefault.default).string
        })),
        externalEventMutations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            callback: (0, _propTypesDefault.default).function,
            childName: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            mutation: (0, _propTypesDefault.default).function,
            target: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ])
        })),
        groupComponent: (0, _propTypesDefault.default).node
    }
});
Object.defineProperty(VictorySharedEvents, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        groupComponent: (0, _reactDefault.default).createElement("g", null)
    }
});
Object.defineProperty(VictorySharedEvents, "contextType", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.TimerContext)
});

},{"@swc/helpers/_/_type_of":"668P4","lodash/difference":"4LrTi","lodash/keys":"kLvI9","lodash/fromPairs":"ldgm6","lodash/isEmpty":"15wZF","lodash/defaults":"eWhnr","lodash/isFunction":"8ck2f","lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","victory-core":"2Y5GL","react-fast-compare":"jGkHB","json-stringify-safe":"fH1ce","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ldgm6":[function(require,module,exports,__globalThis) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = fromPairs;

},{}],"fH1ce":[function(require,module,exports,__globalThis) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function cycleReplacer(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

},{}],"auE0z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryAxis", function() {
    return 0, _victoryAxisDefault.default;
});
var _victoryAxis = require("./victory-axis");
var _victoryAxisDefault = parcelHelpers.interopDefault(_victoryAxis);

},{"./victory-axis":"aeVzU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aeVzU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _victoryCore = require("victory-core");
var _helperMethods = require("./helper-methods");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var options = {
    components: [
        {
            name: "axis",
            index: 0
        },
        {
            name: "axisLabel",
            index: 0
        },
        {
            name: "grid"
        },
        {
            name: "parent",
            index: "parent"
        },
        {
            name: "ticks"
        },
        {
            name: "tickLabels"
        }
    ]
};
var VictoryAxis = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryAxis, _React$Component);
    function VictoryAxis() {
        _classCallCheck(this, VictoryAxis);
        return _possibleConstructorReturn(this, (VictoryAxis.__proto__ || Object.getPrototypeOf(VictoryAxis)).apply(this, arguments));
    }
    _createClass(VictoryAxis, [
        {
            key: "renderLine",
            value: function renderLine(props) {
                var axisComponent = props.axisComponent;
                var axisProps = this.getComponentProps(axisComponent, "axis", 0);
                return (0, _reactDefault.default).cloneElement(axisComponent, axisProps);
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel(props) {
                var axisLabelComponent = props.axisLabelComponent, label = props.label;
                if (!label) return null;
                var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
                return (0, _reactDefault.default).cloneElement(axisLabelComponent, axisLabelProps);
            }
        },
        {
            key: "renderGridAndTicks",
            value: function renderGridAndTicks(props) {
                var _this = this;
                var tickComponent = props.tickComponent, tickLabelComponent = props.tickLabelComponent, gridComponent = props.gridComponent, name = props.name;
                var shouldRender = function shouldRender(componentProps) {
                    var _componentProps$style = componentProps.style, style = _componentProps$style === void 0 ? {} : _componentProps$style, _componentProps$event = componentProps.events, events = _componentProps$event === void 0 ? {} : _componentProps$event;
                    var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
                    return visible || !(0, _isEmptyDefault.default)(events);
                };
                return this.dataKeys.map(function(key, index) {
                    var tickProps = _this.getComponentProps(tickComponent, "ticks", index);
                    var BaseTickComponent = (0, _reactDefault.default).cloneElement(tickComponent, tickProps);
                    var TickComponent = shouldRender(BaseTickComponent.props) ? BaseTickComponent : undefined;
                    var gridProps = _this.getComponentProps(gridComponent, "grid", index);
                    var BaseGridComponent = (0, _reactDefault.default).cloneElement(gridComponent, gridProps);
                    var GridComponent = shouldRender(BaseGridComponent.props) ? BaseGridComponent : undefined;
                    var tickLabelProps = _this.getComponentProps(tickLabelComponent, "tickLabels", index);
                    var TickLabel = (0, _reactDefault.default).cloneElement(tickLabelComponent, tickLabelProps);
                    var children = [
                        GridComponent,
                        TickComponent,
                        TickLabel
                    ].filter(Boolean);
                    return (0, _reactDefault.default).cloneElement(props.groupComponent, {
                        key: "".concat(name, "-tick-group-").concat(key)
                    }, children);
                });
            }
        },
        {
            key: "fixLabelOverlap",
            value: function fixLabelOverlap(gridAndTicks, props) {
                var isVertical = (0, _victoryCore.Axis).isVertical(props);
                var size = isVertical ? props.height : props.width;
                var isVictoryLabel = function isVictoryLabel(child) {
                    return child.type && child.type.role === "label";
                };
                var labels = gridAndTicks.map(function(gridAndTick) {
                    return gridAndTick.props.children;
                }).reduce(function(accumulator, childArr) {
                    return accumulator.concat(childArr);
                }, []).filter(isVictoryLabel).map(function(child) {
                    return child.props;
                });
                var paddingToObject = function paddingToObject(padding) {
                    return (typeof padding === "undefined" ? "undefined" : (0, _typeOf._)(padding)) === "object" ? (0, _assignDefault.default)({}, {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }, padding) : {
                        top: padding,
                        right: padding,
                        bottom: padding,
                        left: padding
                    };
                };
                var labelsSumSize = labels.reduce(function(sum, label) {
                    var padding = paddingToObject(label.style.padding);
                    var labelSize = (0, _victoryCore.TextSize).approximateTextSize(label.text, {
                        angle: label.angle,
                        fontSize: label.style.fontSize,
                        letterSpacing: label.style.letterSpacing,
                        fontFamily: label.style.fontFamily
                    });
                    return sum + (isVertical ? labelSize.height + padding.top + padding.bottom : labelSize.width + padding.right + padding.left);
                }, 0);
                var availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
                var divider = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;
                var getLabelCoord = function getLabelCoord(gridAndTick) {
                    return gridAndTick.props.children.filter(isVictoryLabel).reduce(function(prev, child) {
                        return (isVertical ? child.props.y : child.props.x) || 0;
                    }, 0);
                };
                var sorted = gridAndTicks.sort(function(a, b) {
                    return isVertical ? getLabelCoord(b) - getLabelCoord(a) //ordinary axis has top-bottom orientation
                     : getLabelCoord(a) - getLabelCoord(b);
                } //ordinary axis has left-right orientation
                );
                return sorted.filter(function(gridAndTick, index) {
                    return index % divider === 0;
                });
            } // Overridden in native versions
        },
        {
            key: "shouldAnimate",
            value: function shouldAnimate() {
                return !!this.props.animate;
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = VictoryAxis.animationWhitelist;
                var props = (0, _victoryCore.Axis).modifyProps(this.props, fallbackProps);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var gridAndTicks = this.renderGridAndTicks(props);
                var modifiedGridAndTicks = props.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props) : gridAndTicks;
                var children = [
                    this.renderLine(props),
                    this.renderLabel(props)
                ].concat(_toConsumableArray(modifiedGridAndTicks));
                return props.standalone ? this.renderContainer(props.containerComponent, children) : (0, _reactDefault.default).cloneElement(props.groupComponent, {}, children);
            }
        }
    ]);
    return VictoryAxis;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryAxis, "animationWhitelist", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "style",
        "domain",
        "range",
        "tickCount",
        "tickValues",
        "offsetX",
        "offsetY",
        "padding",
        "width",
        "height"
    ]
});
Object.defineProperty(VictoryAxis, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryAxis"
});
Object.defineProperty(VictoryAxis, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "axis"
});
Object.defineProperty(VictoryAxis, "defaultTransitions", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        onExit: {
            duration: 500
        },
        onEnter: {
            duration: 500
        }
    }
});
Object.defineProperty(VictoryAxis, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _objectSpread({}, (0, _victoryCore.CommonProps).baseProps, {
        axisComponent: (0, _propTypesDefault.default).element,
        axisLabelComponent: (0, _propTypesDefault.default).element,
        axisValue: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).object
        ]),
        categories: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
            (0, _propTypesDefault.default).shape({
                x: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
                y: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
            })
        ]),
        crossAxis: (0, _propTypesDefault.default).bool,
        dependentAxis: (0, _propTypesDefault.default).bool,
        events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            target: (0, _propTypesDefault.default).oneOf([
                "axis",
                "axisLabel",
                "grid",
                "ticks",
                "tickLabels"
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            eventHandlers: (0, _propTypesDefault.default).object
        })),
        fixLabelOverlap: (0, _propTypesDefault.default).bool,
        gridComponent: (0, _propTypesDefault.default).element,
        groupComponent: (0, _propTypesDefault.default).element,
        invertAxis: (0, _propTypesDefault.default).bool,
        label: (0, _propTypesDefault.default).any,
        offsetX: (0, _propTypesDefault.default).number,
        offsetY: (0, _propTypesDefault.default).number,
        orientation: (0, _propTypesDefault.default).oneOf([
            "top",
            "bottom",
            "left",
            "right"
        ]),
        origin: (0, _propTypesDefault.default).shape({
            x: (0, _propTypesDefault.default).number,
            y: (0, _propTypesDefault.default).number
        }),
        stringMap: (0, _propTypesDefault.default).object,
        style: (0, _propTypesDefault.default).shape({
            parent: (0, _propTypesDefault.default).object,
            axis: (0, _propTypesDefault.default).object,
            axisLabel: (0, _propTypesDefault.default).object,
            grid: (0, _propTypesDefault.default).object,
            ticks: (0, _propTypesDefault.default).object,
            tickLabels: (0, _propTypesDefault.default).object
        }),
        tickComponent: (0, _propTypesDefault.default).element,
        tickCount: (0, _victoryCore.PropTypes).allOfType([
            (0, _victoryCore.PropTypes).integer,
            (0, _victoryCore.PropTypes).greaterThanZero
        ]),
        tickFormat: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).homogeneousArray
        ]),
        tickLabelComponent: (0, _propTypesDefault.default).element,
        tickValues: (0, _victoryCore.PropTypes).homogeneousArray
    })
});
Object.defineProperty(VictoryAxis, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        axisComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        axisLabelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null),
        tickLabelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null),
        tickComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        gridComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        standalone: true,
        theme: (0, _victoryCore.VictoryTheme).grayscale,
        containerComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryContainer), null),
        groupComponent: (0, _reactDefault.default).createElement("g", {
            role: "presentation"
        }),
        fixLabelOverlap: false
    }
});
Object.defineProperty(VictoryAxis, "getDomain", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.Axis).getDomain
});
Object.defineProperty(VictoryAxis, "getAxis", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.Axis).getAxis
});
Object.defineProperty(VictoryAxis, "getStyles", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getStyles)(props, fallbackProps.style);
    }
});
Object.defineProperty(VictoryAxis, "getBaseProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getBaseProps)(props, fallbackProps);
    }
});
Object.defineProperty(VictoryAxis, "expectedComponents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "axisComponent",
        "axisLabelComponent",
        "groupComponent",
        "containerComponent",
        "tickComponent",
        "tickLabelComponent",
        "gridComponent"
    ]
});
exports.default = (0, _victoryCore.addEvents)(VictoryAxis, options);

},{"@swc/helpers/_/_type_of":"668P4","lodash/isEmpty":"15wZF","lodash/assign":"xTxAt","prop-types":"3KNJy","react":"gVheC","victory-core":"2Y5GL","./helper-methods":"hEA7M","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hEA7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyles", function() {
    return getStyles;
});
parcelHelpers.export(exports, "getBaseProps", function() {
    return getBaseProps;
});
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _victoryCore = require("victory-core");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var orientationSign = {
    top: -1,
    left: -1,
    right: 1,
    bottom: 1
};
var exists = function exists(val) {
    return val !== null && val !== undefined;
};
var getCurrentAxis = function getCurrentAxis(props, axis) {
    var orientation = props.orientation, horizontal = props.horizontal;
    if (orientation) {
        var dimensions = {
            top: "x",
            bottom: "x",
            left: "y",
            right: "y"
        };
        return dimensions[orientation];
    }
    var otherAxis = axis === "x" ? "y" : "x";
    return horizontal ? otherAxis : axis;
};
var getScale = function getScale(props) {
    var axis = (0, _victoryCore.Axis).getAxis(props);
    var currentAxis = getCurrentAxis(props, axis);
    var scale = (0, _victoryCore.Scale).getBaseScale(props, axis);
    var propsDomain = props.domain && props.domain[axis];
    var domain = propsDomain || (0, _victoryCore.Axis).getDomain(props) || scale.domain();
    scale.range((0, _victoryCore.Helpers).getRange(props, currentAxis));
    scale.domain(domain);
    return scale;
};
var getStyleObject = function getStyleObject(props) {
    var theme = props.theme, dependentAxis = props.dependentAxis;
    var generalAxisStyle = theme && theme.axis && theme.axis.style;
    var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
    var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
    var mergeStyles = function mergeStyles() {
        var styleNamespaces = [
            "axis",
            "axisLabel",
            "grid",
            "parent",
            "tickLabels",
            "ticks"
        ];
        return styleNamespaces.reduce(function(memo, curr) {
            memo[curr] = (0, _defaultsDefault.default)({}, specificAxisStyle[curr], generalAxisStyle[curr]);
            return memo;
        }, {});
    };
    return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
var getStyles = function getStyles(props, styleObject) {
    var style = props.style || {};
    styleObject = styleObject || {};
    var parentStyleProps = {
        height: "100%",
        width: "100%"
    };
    return {
        parent: (0, _defaultsDefault.default)(style.parent, styleObject.parent, parentStyleProps),
        axis: (0, _defaultsDefault.default)({}, style.axis, styleObject.axis),
        axisLabel: (0, _defaultsDefault.default)({}, style.axisLabel, styleObject.axisLabel),
        grid: (0, _defaultsDefault.default)({}, style.grid, styleObject.grid),
        ticks: (0, _defaultsDefault.default)({}, style.ticks, styleObject.ticks),
        tickLabels: (0, _defaultsDefault.default)({}, style.tickLabels, styleObject.tickLabels)
    };
};
var getTickProps = function getTickProps(layout, style, datum) {
    var position = layout.position, transform = layout.transform;
    return {
        x1: transform.x,
        y1: transform.y,
        x2: transform.x + position.x2,
        y2: transform.y + position.y2,
        style: style,
        datum: datum
    };
}; // eslint-disable-next-line max-params
var getTickLabelProps = function getTickLabelProps(layout, style, anchors, datum, text) {
    var position = layout.position, transform = layout.transform;
    return {
        style: style,
        x: transform.x + position.x,
        y: transform.y + position.y,
        verticalAnchor: anchors.verticalAnchor,
        textAnchor: anchors.textAnchor,
        angle: style.angle,
        text: text,
        datum: datum
    };
};
var getGridProps = function getGridProps(layout, style, datum) {
    var edge = layout.edge, transform = layout.transform;
    return {
        x1: transform.x,
        y1: transform.y,
        x2: edge.x + transform.x,
        y2: edge.y + transform.y,
        style: style,
        datum: datum
    };
};
var getAxisProps = function getAxisProps(modifiedProps, calculatedValues, globalTransform) {
    var style = calculatedValues.style, padding = calculatedValues.padding, isVertical = calculatedValues.isVertical;
    var width = modifiedProps.width, height = modifiedProps.height;
    return {
        style: style.axis,
        x1: isVertical ? globalTransform.x : padding.left + globalTransform.x,
        x2: isVertical ? globalTransform.x : width - padding.right + globalTransform.x,
        y1: isVertical ? padding.top + globalTransform.y : globalTransform.y,
        y2: isVertical ? height - padding.bottom + globalTransform.y : globalTransform.y
    };
};
var getEvaluatedStyles = function getEvaluatedStyles(style, props) {
    return {
        tickStyle: (0, _victoryCore.Helpers).evaluateStyle(style.ticks, props),
        labelStyle: (0, _victoryCore.Helpers).evaluateStyle(style.tickLabels, props),
        gridStyle: (0, _victoryCore.Helpers).evaluateStyle(style.grid, props)
    };
};
var getAxisLabelProps = function getAxisLabelProps(props, calculatedValues, globalTransform) {
    var style = calculatedValues.style, orientation = calculatedValues.orientation, padding = calculatedValues.padding, labelPadding = calculatedValues.labelPadding, isVertical = calculatedValues.isVertical;
    var sign = orientationSign[orientation];
    var hPadding = padding.left + padding.right;
    var vPadding = padding.top + padding.bottom;
    var verticalAnchor = sign < 0 ? "end" : "start";
    var labelStyle = style.axisLabel;
    var angle = isVertical ? -90 : 0; // eslint-disable-line no-magic-numbers
    var x = isVertical ? globalTransform.x + sign * labelPadding : (props.width - hPadding) / 2 + padding.left + globalTransform.x;
    var y = isVertical ? (props.height - vPadding) / 2 + padding.top + globalTransform.y : sign * labelPadding + globalTransform.y;
    return {
        x: x,
        y: y,
        verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
        textAnchor: labelStyle.textAnchor || "middle",
        angle: labelStyle.angle === undefined ? angle : labelStyle.angle,
        style: labelStyle,
        text: props.label
    };
};
var getAnchors = function getAnchors(orientation, isVertical) {
    var anchorOrientation = {
        top: "end",
        left: "end",
        right: "start",
        bottom: "start"
    };
    var anchor = anchorOrientation[orientation];
    return {
        textAnchor: isVertical ? anchor : "middle",
        verticalAnchor: isVertical ? "middle" : anchor
    };
};
var getLabelPadding = function getLabelPadding(props, style) {
    var labelStyle = style.axisLabel || {};
    if (labelStyle.padding !== undefined && labelStyle.padding !== null) return labelStyle.padding;
    var isVertical = (0, _victoryCore.Axis).isVertical(props); // TODO: magic numbers
    /*eslint-disable no-magic-numbers*/ var fontSize = labelStyle.fontSize || 14;
    return props.label ? fontSize * (isVertical ? 2.3 : 1.6) : 0;
/*eslint-enable no-magic-numbers*/ };
var getDefaultOrientations = function getDefaultOrientations(axis, originSign, horizontal) {
    var sign = originSign || "positive";
    var orientations = {
        positive: {
            x: "bottom",
            y: "left"
        },
        negative: {
            x: "top",
            y: "right"
        }
    };
    var horizontalOrientations = {
        positive: {
            x: "left",
            y: "bottom"
        },
        negative: {
            x: "right",
            y: "top"
        }
    };
    return horizontal ? horizontalOrientations[sign][axis] : orientations[sign][axis];
};
var getStandaloneOffset = function getStandaloneOffset(props, calculatedValues) {
    var style = calculatedValues.style, scale = calculatedValues.scale, orientation = calculatedValues.orientation, padding = calculatedValues.padding, axis = calculatedValues.axis, ticks = calculatedValues.ticks, stringTicks = calculatedValues.stringTicks, isVertical = calculatedValues.isVertical, labelPadding = calculatedValues.labelPadding;
    var polar = props.polar, horizontal = props.horizontal;
    var sharedProps = {
        scale: _defineProperty({}, axis, scale),
        polar: polar,
        horizontal: horizontal,
        ticks: ticks,
        stringTicks: stringTicks
    };
    var xPadding = orientation === "right" ? padding.right : padding.left;
    var yPadding = orientation === "top" ? padding.top : padding.bottom;
    var offsetX = props.offsetX !== null && props.offsetX !== undefined ? props.offsetX : xPadding;
    var offsetY = props.offsetY !== null && props.offsetY !== undefined ? props.offsetY : yPadding;
    var fontSize = style.axisLabel.fontSize || 14; // eslint-disable-line no-magic-numbers
    var tickSizes = ticks.map(function(data, index) {
        var tick = stringTicks ? props.tickValues[data - 1] : data;
        var tickStyle = (0, _victoryCore.Helpers).evaluateStyle(style.ticks, (0, _assignDefault.default)({}, sharedProps, {
            tick: tick,
            index: index
        }));
        return tickStyle.size || 0;
    });
    var totalPadding = fontSize + 2 * Math.max.apply(Math, _toConsumableArray(tickSizes)) + labelPadding;
    var minimumPadding = 1.2 * fontSize; // eslint-disable-line no-magic-numbers
    var x = isVertical ? totalPadding : minimumPadding;
    var y = isVertical ? minimumPadding : totalPadding;
    return {
        x: offsetX !== null && offsetX !== undefined ? offsetX : x,
        y: offsetY !== null && offsetY !== undefined ? offsetY : y
    };
}; // eslint-disable-next-line complexity
var getOffset = function getOffset(props, calculatedValues) {
    var scale = calculatedValues.scale, origin = calculatedValues.origin, orientation = calculatedValues.orientation, orientations = calculatedValues.orientations, domain = calculatedValues.domain, padding = calculatedValues.padding;
    var top = padding.top, bottom = padding.bottom, left = padding.left, right = padding.right;
    var calculatedOrientation = {
        x: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
        y: orientation === "left" || orientation === "right" ? orientation : orientations.y
    }; // make the axes line up, and cross when appropriate
    var orientationOffset = {
        x: calculatedOrientation.y === "left" ? left : right,
        y: calculatedOrientation.x === "bottom" ? bottom : top
    };
    var originOffset = {
        x: calculatedOrientation.y === "left" ? 0 : props.width,
        y: calculatedOrientation.x === "bottom" ? props.height : 0
    };
    var originPosition = {
        x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
        y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
    };
    var x = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
    var y = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
    var offsetX = exists(props.offsetX) ? props.offsetX : x;
    var offsetY = exists(props.offsetY) ? props.offsetY : y;
    return {
        x: offsetX,
        y: offsetY
    };
}; // eslint-disable-next-line complexity
var getHorizontalOffset = function getHorizontalOffset(props, calculatedValues) {
    var scale = calculatedValues.scale, origin = calculatedValues.origin, orientation = calculatedValues.orientation, orientations = calculatedValues.orientations, domain = calculatedValues.domain, padding = calculatedValues.padding;
    var top = padding.top, bottom = padding.bottom, left = padding.left, right = padding.right;
    var calculatedOrientation = {
        y: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
        x: orientation === "left" || orientation === "right" ? orientation : orientations.y
    }; // make the axes line up, and cross when appropriate
    var orientationOffset = {
        x: calculatedOrientation.y === "bottom" ? bottom : top,
        y: calculatedOrientation.x === "left" ? left : right
    };
    var originOffset = {
        y: calculatedOrientation.x === "left" ? 0 : props.width,
        x: calculatedOrientation.y === "bottom" ? props.height : 0
    };
    var originPosition = {
        x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
        y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
    };
    var y = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
    var x = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
    var offsetX = exists(props.offsetX) ? props.offsetX : x;
    var offsetY = exists(props.offsetY) ? props.offsetY : y;
    return {
        x: offsetX,
        y: offsetY
    };
};
var getTransform = function getTransform(props, calculatedValues, offset) {
    var orientation = calculatedValues.orientation, axis = calculatedValues.axis;
    var axisValue = (0, _victoryCore.Axis).getAxisValue(props, axis);
    return ({
        top: {
            x: 0,
            y: axisValue !== undefined ? axisValue : offset.y
        },
        bottom: {
            x: 0,
            y: axisValue !== undefined ? axisValue : props.height - offset.y
        },
        left: {
            x: axisValue !== undefined ? axisValue : offset.x,
            y: 0
        },
        right: {
            x: axisValue !== undefined ? axisValue : props.width - offset.x,
            y: 0
        }
    })[orientation];
};
var getTickPosition = function getTickPosition(style, orientation, isVertical) {
    var tickStyle = style.tickStyle, labelStyle = style.labelStyle;
    var size = tickStyle.size || 0;
    var tickPadding = tickStyle.padding || 0;
    var labelPadding = labelStyle.padding || 0;
    var tickSpacing = size + tickPadding + labelPadding;
    var sign = orientationSign[orientation];
    return {
        x: isVertical ? sign * tickSpacing : 0,
        x2: isVertical ? sign * size : 0,
        y: isVertical ? 0 : sign * tickSpacing,
        y2: isVertical ? 0 : sign * size
    };
};
var getTickTransform = function getTickTransform(tick, globalTransform, isVertical) {
    return {
        x: isVertical ? globalTransform.x : tick + globalTransform.x,
        y: isVertical ? tick + globalTransform.y : globalTransform.y
    };
};
var getGridEdge = function getGridEdge(props, calculatedValues) {
    var orientation = calculatedValues.orientation, padding = calculatedValues.padding, isVertical = calculatedValues.isVertical;
    var sign = -orientationSign[orientation];
    var x = isVertical ? sign * (props.width - (padding.left + padding.right)) : 0;
    var y = isVertical ? 0 : sign * (props.height - (padding.top + padding.bottom));
    return {
        x: x,
        y: y
    };
};
var getGridOffset = function getGridOffset(calculatedValues, offset) {
    var padding = calculatedValues.padding, orientation = calculatedValues.orientation, crossAxis = calculatedValues.crossAxis;
    var xPadding = orientation === "right" ? padding.right : padding.left;
    var yPadding = orientation === "top" ? padding.top : padding.bottom;
    return {
        x: crossAxis ? offset.x - xPadding : 0,
        y: crossAxis ? offset.y - yPadding : 0
    };
};
var getLayoutProps = function getLayoutProps(modifiedProps, calculatedValues) {
    var offset;
    if (calculatedValues.domain.x && calculatedValues.domain.y) offset = modifiedProps.horizontal ? getHorizontalOffset(modifiedProps, calculatedValues) : getOffset(modifiedProps, calculatedValues);
    else offset = getStandaloneOffset(modifiedProps, calculatedValues);
    return {
        globalTransform: getTransform(modifiedProps, calculatedValues, offset),
        gridOffset: getGridOffset(calculatedValues, offset),
        gridEdge: getGridEdge(modifiedProps, calculatedValues)
    };
};
var getOrientation = function getOrientation(props) {
    if (props.orientation) return props.orientation;
    var defaultOrientations = {
        dependent: props.horizontal ? "bottom" : "left",
        independent: props.horizontal ? "left" : "bottom"
    };
    return props.dependentAxis ? defaultOrientations.dependent : defaultOrientations.independent;
}; // eslint-disable-next-line complexity
var getCalculatedValues = function getCalculatedValues(props) {
    var defaultStyles = getStyleObject(props);
    var style = getStyles(props, defaultStyles);
    var padding = (0, _victoryCore.Helpers).getPadding(props);
    var labelPadding = getLabelPadding(props, style);
    var stringTicks = (0, _victoryCore.Axis).stringTicks(props) ? props.tickValues : undefined;
    var axis = (0, _victoryCore.Axis).getAxis(props);
    var axisDomain = (0, _victoryCore.Axis).getDomain(props);
    var axisScale = getScale(props);
    var xAxisDomain = axis === "x" ? axisDomain : undefined;
    var yAxisDomain = axis === "y" ? axisDomain : undefined;
    var xAxisScale = axis === "x" ? axisScale : undefined;
    var yAxisScale = axis === "y" ? axisScale : undefined;
    var crossAxis = props.crossAxis === false || props.standalone === true ? false : true;
    var ticks = (0, _victoryCore.Axis).getTicks(props, axisScale, crossAxis);
    var tickFormat = (0, _victoryCore.Axis).getTickFormat(props, axisScale);
    var range = {
        x: (0, _victoryCore.Helpers).getRange(props, "x"),
        y: (0, _victoryCore.Helpers).getRange(props, "y")
    }; // use full domain if passed in from parent,
    // otherwise use the just the one axis available
    var domain = {
        x: props.domain && props.domain.x ? props.domain.x : xAxisDomain,
        y: props.domain && props.domain.y ? props.domain.y : yAxisDomain
    }; // use full scale if passed in from parent,
    // otherwise use the just the one axis available
    var scale = {
        x: props.domain && props.domain.x ? (0, _victoryCore.Scale).getBaseScale(props, "x").domain(props.domain.x).range(props.horizontal ? range.y : range.x) : xAxisScale,
        y: props.domain && props.domain.y ? (0, _victoryCore.Scale).getBaseScale(props, "y").domain(props.domain.y).range(props.horizontal ? range.x : range.y) : yAxisScale
    };
    var origin = domain.x && domain.y ? (0, _victoryCore.Axis).getOrigin(domain) : undefined;
    var originSign = origin ? {
        x: (0, _victoryCore.Axis).getOriginSign(origin.x, domain.x),
        y: (0, _victoryCore.Axis).getOriginSign(origin.y, domain.y)
    } : undefined;
    var orientations = originSign ? {
        x: getDefaultOrientations("x", originSign.y, props.horizontal),
        y: getDefaultOrientations("y", originSign.x, props.horizontal)
    } : undefined;
    var orientation = orientations ? props.orientation || orientations[axis] : getOrientation(props);
    var isVertical = (0, _victoryCore.Axis).isVertical(Object.assign({}, props, {
        orientation: orientation
    }));
    var anchors = getAnchors(orientation, isVertical);
    return {
        anchors: anchors,
        axis: axis,
        crossAxis: crossAxis,
        domain: domain,
        isVertical: isVertical,
        labelPadding: labelPadding,
        orientation: orientation,
        orientations: orientations,
        origin: origin,
        padding: padding,
        scale: scale,
        stringTicks: stringTicks,
        style: style,
        tickFormat: tickFormat,
        ticks: ticks
    };
};
var getBaseProps = function getBaseProps(props, fallbackProps) {
    props = (0, _victoryCore.Axis).modifyProps(props, fallbackProps);
    var calculatedValues = getCalculatedValues(props);
    var axis = calculatedValues.axis, style = calculatedValues.style, orientation = calculatedValues.orientation, isVertical = calculatedValues.isVertical, scale = calculatedValues.scale, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, anchors = calculatedValues.anchors, domain = calculatedValues.domain, stringTicks = calculatedValues.stringTicks, name = calculatedValues.name;
    var otherAxis = axis === "x" ? "y" : "x";
    var _props = props, width = _props.width, height = _props.height, standalone = _props.standalone, theme = _props.theme, polar = _props.polar, padding = _props.padding, horizontal = _props.horizontal;
    var _getLayoutProps = getLayoutProps(props, calculatedValues), globalTransform = _getLayoutProps.globalTransform, gridOffset = _getLayoutProps.gridOffset, gridEdge = _getLayoutProps.gridEdge;
    var sharedProps = {
        scale: _defineProperty({}, axis, scale[axis]),
        polar: polar,
        horizontal: horizontal,
        ticks: ticks,
        stringTicks: stringTicks
    };
    var axisProps = getAxisProps(props, calculatedValues, globalTransform);
    var axisLabelProps = getAxisLabelProps(props, calculatedValues, globalTransform);
    var initialChildProps = {
        parent: (0, _assignDefault.default)({
            style: style.parent,
            ticks: ticks,
            standalone: standalone,
            theme: theme,
            width: width,
            height: height,
            padding: padding,
            domain: domain,
            name: name
        }, sharedProps)
    };
    var gridProps = {
        dimension: otherAxis,
        range: _defineProperty({}, otherAxis, (0, _victoryCore.Helpers).getRange(props, otherAxis)),
        scale: props.scale && props.scale[otherAxis] ? _defineProperty({}, otherAxis, props.scale[otherAxis]) : undefined
    };
    return ticks.reduce(function(childProps, tickValue, index) {
        var tick = stringTicks ? stringTicks[index] : tickValue;
        var text = tickFormat(tickValue, index, ticks);
        var styles = getEvaluatedStyles(style, (0, _assignDefault.default)({}, sharedProps, {
            tick: tick,
            tickValue: tickValue,
            index: index,
            text: text
        }));
        var tickLayout = {
            position: getTickPosition(styles, orientation, isVertical),
            transform: getTickTransform(scale[axis](tickValue), globalTransform, isVertical)
        };
        var gridLayout = {
            edge: gridEdge,
            transform: {
                x: isVertical ? -gridOffset.x + globalTransform.x : scale[axis](tickValue) + globalTransform.x,
                y: isVertical ? scale[axis](tickValue) + globalTransform.y : gridOffset.y + globalTransform.y
            }
        };
        childProps[index] = {
            axis: (0, _assignDefault.default)({
                dimension: axis
            }, sharedProps, axisProps),
            axisLabel: (0, _assignDefault.default)({}, sharedProps, axisLabelProps),
            ticks: (0, _assignDefault.default)({}, sharedProps, getTickProps(tickLayout, styles.tickStyle, tickValue)),
            tickLabels: (0, _assignDefault.default)({}, sharedProps, getTickLabelProps(tickLayout, styles.labelStyle, anchors, tickValue, text)),
            grid: (0, _assignDefault.default)({}, sharedProps, gridProps, getGridProps(gridLayout, styles.gridStyle, tickValue))
        };
        return childProps;
    }, initialChildProps);
};

},{"lodash/defaults":"eWhnr","lodash/assign":"xTxAt","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bdCpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryPolarAxis", function() {
    return 0, _victoryPolarAxisDefault.default;
});
var _victoryPolarAxis = require("./victory-polar-axis");
var _victoryPolarAxisDefault = parcelHelpers.interopDefault(_victoryPolarAxis);

},{"./victory-polar-axis":"gbj1V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gbj1V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryCore = require("victory-core");
var _helperMethods = require("./helper-methods");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
var options = {
    components: [
        {
            name: "axis",
            index: 0
        },
        {
            name: "axisLabel",
            index: 0
        },
        {
            name: "grid"
        },
        {
            name: "parent",
            index: "parent"
        },
        {
            name: "ticks"
        },
        {
            name: "tickLabels"
        }
    ]
};
var VictoryPolarAxis = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryPolarAxis, _React$Component);
    function VictoryPolarAxis() {
        _classCallCheck(this, VictoryPolarAxis);
        return _possibleConstructorReturn(this, (VictoryPolarAxis.__proto__ || Object.getPrototypeOf(VictoryPolarAxis)).apply(this, arguments));
    }
    _createClass(VictoryPolarAxis, [
        {
            key: "renderAxisLine",
            value: function renderAxisLine(props) {
                var dependentAxis = props.dependentAxis;
                var axisComponent = dependentAxis ? props.axisComponent : props.circularAxisComponent;
                var axisProps = this.getComponentProps(axisComponent, "axis", 0);
                return (0, _reactDefault.default).cloneElement(axisComponent, axisProps);
            }
        },
        {
            key: "renderLabel",
            value: function renderLabel(props) {
                var axisLabelComponent = props.axisLabelComponent, dependentAxis = props.dependentAxis, label = props.label;
                if (!label || !dependentAxis) return null;
                var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
                return (0, _reactDefault.default).cloneElement(axisLabelComponent, axisLabelProps);
            }
        },
        {
            key: "renderAxis",
            value: function renderAxis(props) {
                var _this = this;
                var tickComponent = props.tickComponent, tickLabelComponent = props.tickLabelComponent, name = props.name;
                var shouldRender = function shouldRender(componentProps) {
                    var _componentProps$style = componentProps.style, style = _componentProps$style === void 0 ? {} : _componentProps$style, _componentProps$event = componentProps.events, events = _componentProps$event === void 0 ? {} : _componentProps$event;
                    var visible = style.stroke !== "transparent" && style.stroke !== "none" && style.strokeWidth !== 0;
                    return visible || !(0, _isEmptyDefault.default)(events);
                };
                var axisType = props.dependentAxis ? "radial" : "angular";
                var gridComponent = axisType === "radial" ? props.circularGridComponent : props.gridComponent;
                var tickComponents = this.dataKeys.map(function(key, index) {
                    var tickProps = (0, _assignDefault.default)({
                        key: "".concat(name, "-tick-").concat(key)
                    }, _this.getComponentProps(tickComponent, "ticks", index));
                    var TickComponent = (0, _reactDefault.default).cloneElement(tickComponent, tickProps);
                    return shouldRender(TickComponent.props) ? TickComponent : undefined;
                }).filter(Boolean);
                var gridComponents = this.dataKeys.map(function(key, index) {
                    var gridProps = (0, _assignDefault.default)({
                        key: "".concat(name, "-grid-").concat(key)
                    }, _this.getComponentProps(gridComponent, "grid", index));
                    var GridComponent = (0, _reactDefault.default).cloneElement(gridComponent, gridProps);
                    return shouldRender(GridComponent.props) ? GridComponent : undefined;
                }).filter(Boolean);
                var tickLabelComponents = this.dataKeys.map(function(key, index) {
                    var tickLabelProps = (0, _assignDefault.default)({
                        key: "".concat(name, "-tick-").concat(key)
                    }, _this.getComponentProps(tickLabelComponent, "tickLabels", index));
                    return (0, _reactDefault.default).cloneElement(tickLabelComponent, tickLabelProps);
                });
                var axis = this.renderAxisLine(props);
                var axisLabel = this.renderLabel(props);
                var children = [
                    axis,
                    axisLabel
                ].concat(_toConsumableArray(tickComponents), _toConsumableArray(gridComponents), _toConsumableArray(tickLabelComponents));
                return this.renderGroup(props, children);
            } // Overridden in victory-native
        },
        {
            key: "renderGroup",
            value: function renderGroup(props, children) {
                var groupComponent = props.groupComponent;
                return (0, _reactDefault.default).cloneElement(groupComponent, {}, children);
            }
        },
        {
            key: "shouldAnimate",
            value: function shouldAnimate() {
                return !!this.props.animate;
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = VictoryPolarAxis.animationWhitelist;
                var props = (0, _victoryCore.Axis).modifyProps(this.props, fallbackProps);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var children = this.renderAxis(props);
                return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
            }
        }
    ]);
    return VictoryPolarAxis;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryPolarAxis, "animationWhitelist", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "style",
        "domain",
        "range",
        "tickCount",
        "tickValues",
        "padding",
        "width",
        "height"
    ]
});
Object.defineProperty(VictoryPolarAxis, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryAxis"
});
Object.defineProperty(VictoryPolarAxis, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "axis"
});
Object.defineProperty(VictoryPolarAxis, "defaultTransitions", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        onExit: {
            duration: 500
        },
        onEnter: {
            duration: 500
        }
    }
});
Object.defineProperty(VictoryPolarAxis, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _objectSpread({}, (0, _victoryCore.CommonProps).baseProps, {
        axisAngle: (0, _propTypesDefault.default).number,
        axisComponent: (0, _propTypesDefault.default).element,
        axisLabelComponent: (0, _propTypesDefault.default).element,
        axisValue: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).object
        ]),
        categories: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
            (0, _propTypesDefault.default).shape({
                x: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
                y: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
            })
        ]),
        circularAxisComponent: (0, _propTypesDefault.default).element,
        circularGridComponent: (0, _propTypesDefault.default).element,
        containerComponent: (0, _propTypesDefault.default).element,
        dependentAxis: (0, _propTypesDefault.default).bool,
        disableInlineStyles: (0, _propTypesDefault.default).bool,
        endAngle: (0, _propTypesDefault.default).number,
        events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            target: (0, _propTypesDefault.default).oneOf([
                "axis",
                "axisLabel",
                "grid",
                "ticks",
                "tickLabels"
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            eventHandlers: (0, _propTypesDefault.default).object
        })),
        gridComponent: (0, _propTypesDefault.default).element,
        innerRadius: (0, _victoryCore.PropTypes).nonNegative,
        labelPlacement: (0, _propTypesDefault.default).oneOf([
            "parallel",
            "perpendicular",
            "vertical"
        ]),
        startAngle: (0, _propTypesDefault.default).number,
        stringMap: (0, _propTypesDefault.default).object,
        style: (0, _propTypesDefault.default).shape({
            parent: (0, _propTypesDefault.default).object,
            axis: (0, _propTypesDefault.default).object,
            axisLabel: (0, _propTypesDefault.default).object,
            grid: (0, _propTypesDefault.default).object,
            ticks: (0, _propTypesDefault.default).object,
            tickLabels: (0, _propTypesDefault.default).object
        }),
        tickComponent: (0, _propTypesDefault.default).element,
        tickCount: (0, _victoryCore.PropTypes).allOfType([
            (0, _victoryCore.PropTypes).integer,
            (0, _victoryCore.PropTypes).greaterThanZero
        ]),
        tickFormat: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).homogeneousArray
        ]),
        tickLabelComponent: (0, _propTypesDefault.default).element,
        tickValues: (0, _victoryCore.PropTypes).homogeneousArray
    })
});
Object.defineProperty(VictoryPolarAxis, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        axisComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        axisLabelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null),
        circularAxisComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Arc), null),
        circularGridComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Arc), null),
        containerComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryContainer), null),
        endAngle: 360,
        gridComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        groupComponent: (0, _reactDefault.default).createElement("g", {
            role: "presentation"
        }),
        labelPlacement: "parallel",
        startAngle: 0,
        standalone: true,
        theme: (0, _victoryCore.VictoryTheme).grayscale,
        tickComponent: (0, _reactDefault.default).createElement((0, _victoryCore.LineSegment), null),
        tickLabelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null)
    }
});
Object.defineProperty(VictoryPolarAxis, "getDomain", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.Axis).getDomain
});
Object.defineProperty(VictoryPolarAxis, "getAxis", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.Axis).getAxis
});
Object.defineProperty(VictoryPolarAxis, "getScale", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _helperMethods.getScale)
});
Object.defineProperty(VictoryPolarAxis, "getStyles", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getStyles)(props, fallbackProps.style);
    }
});
Object.defineProperty(VictoryPolarAxis, "getBaseProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getBaseProps)(props, fallbackProps);
    }
});
Object.defineProperty(VictoryPolarAxis, "expectedComponents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "axisComponent",
        "circularAxisComponent",
        "groupComponent",
        "containerComponent",
        "tickComponent",
        "tickLabelComponent",
        "gridComponent",
        "circularGridComponent"
    ]
});
exports.default = (0, _victoryCore.addEvents)(VictoryPolarAxis, options);

},{"@swc/helpers/_/_type_of":"668P4","lodash/isEmpty":"15wZF","lodash/assign":"xTxAt","react":"gVheC","prop-types":"3KNJy","victory-core":"2Y5GL","./helper-methods":"dtuRb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dtuRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScale", function() {
    return getScale;
});
parcelHelpers.export(exports, "getStyles", function() {
    return getStyles;
});
parcelHelpers.export(exports, "getBaseProps", function() {
    return getBaseProps;
});
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _victoryCore = require("victory-core");
var getPosition = function getPosition(r, angle, axis) {
    return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
};
var getAxisType = function getAxisType(props) {
    var typicalType = props.dependentAxis ? "radial" : "angular";
    var invertedType = typicalType === "angular" ? "radial" : "angular";
    return props.horizontal ? invertedType : typicalType;
};
var filterTicks = function filterTicks(ticks, scale) {
    var compareTicks = function compareTicks(t) {
        return scale(t) % (2 * Math.PI);
    };
    return (0, _uniqByDefault.default)(ticks, compareTicks);
};
var getEvaluatedStyles = function getEvaluatedStyles(style, props) {
    return {
        tickStyle: (0, _victoryCore.Helpers).evaluateStyle(style.ticks, props),
        labelStyle: (0, _victoryCore.Helpers).evaluateStyle(style.tickLabels, props),
        gridStyle: (0, _victoryCore.Helpers).evaluateStyle(style.grid, props)
    };
};
var getStyleObject = function getStyleObject(props) {
    var _props$theme = props.theme, theme = _props$theme === void 0 ? {} : _props$theme, dependentAxis = props.dependentAxis;
    var generalAxisStyle = theme.polarAxis && theme.polarAxis.style || theme.axis && theme.axis.style;
    var polarAxisType = dependentAxis ? "polarDependentAxis" : "polarIndependentAxis";
    var standardAxisType = dependentAxis ? "dependentAxis" : "independentAxis";
    var specificAxisStyle = theme[polarAxisType] && theme[polarAxisType].style || theme[standardAxisType] && theme[standardAxisType].style;
    var mergeStyles = function mergeStyles() {
        var styleNamespaces = [
            "axis",
            "axisLabel",
            "grid",
            "parent",
            "tickLabels",
            "ticks"
        ];
        return styleNamespaces.reduce(function(memo, curr) {
            memo[curr] = (0, _defaultsDefault.default)({}, specificAxisStyle[curr], generalAxisStyle[curr]);
            return memo;
        }, {});
    };
    return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
var getRadius = function getRadius(props) {
    var _Helpers$getPadding = (0, _victoryCore.Helpers).getPadding(props), left = _Helpers$getPadding.left, right = _Helpers$getPadding.right, top = _Helpers$getPadding.top, bottom = _Helpers$getPadding.bottom;
    var width = props.width, height = props.height;
    return Math.min(width - left - right, height - top - bottom) / 2;
};
var getRange = function getRange(props, axis) {
    // Return the range from props if one is given.
    if (props.range && props.range[axis]) return props.range[axis];
    else if (props.range && Array.isArray(props.range)) return props.range;
    var axisType = getAxisType(props);
    if (axisType === "angular") {
        var startAngle = (0, _victoryCore.Helpers).degreesToRadians(props.startAngle);
        var endAngle = (0, _victoryCore.Helpers).degreesToRadians(props.endAngle);
        return [
            startAngle,
            endAngle
        ];
    }
    var radius = getRadius(props);
    return [
        props.innerRadius || 0,
        radius
    ];
}; // exposed for use by VictoryChart (necessary?)
var getScale = function getScale(props) {
    var axis = (0, _victoryCore.Axis).getAxis(props);
    var scale = (0, _victoryCore.Scale).getBaseScale(props, axis);
    var domain = (0, _victoryCore.Axis).getDomain(props, axis) || scale.domain();
    var range = getRange(props, axis);
    scale.range(range);
    scale.domain(domain);
    return scale;
};
var getStyles = function getStyles(props, styleObject) {
    if (props.disableInlineStyles) return {};
    var style = props.style || {};
    styleObject = styleObject || {};
    var parentStyleProps = {
        height: "auto",
        width: "100%"
    };
    return {
        parent: (0, _defaultsDefault.default)(parentStyleProps, style.parent, styleObject.parent),
        axis: (0, _defaultsDefault.default)({}, style.axis, styleObject.axis),
        axisLabel: (0, _defaultsDefault.default)({}, style.axisLabel, styleObject.axisLabel),
        grid: (0, _defaultsDefault.default)({}, style.grid, styleObject.grid),
        ticks: (0, _defaultsDefault.default)({}, style.ticks, styleObject.ticks),
        tickLabels: (0, _defaultsDefault.default)({}, style.tickLabels, styleObject.tickLabels)
    };
};
var getAxisAngle = function getAxisAngle(props) {
    var axisAngle = props.axisAngle, startAngle = props.startAngle, dependentAxis = props.dependentAxis;
    var axis = (0, _victoryCore.Axis).getAxis(props);
    var axisValue = (0, _victoryCore.Axis).getAxisValue(props, axis);
    if (axisValue === undefined || !dependentAxis) return axisAngle === undefined ? startAngle : axisAngle;
    return (0, _victoryCore.Helpers).radiansToDegrees(axisValue);
}; //eslint-disable-next-line max-params
var getTickProps = function getTickProps(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, scale = calculatedValues.scale, style = calculatedValues.style, stringTicks = calculatedValues.stringTicks, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles = getEvaluatedStyles(style, {
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType,
        text: text
    }), tickStyle = _getEvaluatedStyles.tickStyle;
    var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
    var tickPadding = tickStyle.padding || tickStyle.size || 0;
    var padAngle = (0, _victoryCore.Helpers).degreesToRadians(90 - axisAngle);
    var tickAngle = axisType === "angular" ? scale(tickValue) : (0, _victoryCore.Helpers).degreesToRadians(-1 * axisAngle);
    var tickRadius = axisType === "angular" ? radius : scale(tickValue);
    return axisType === "angular" ? {
        index: index,
        datum: tick,
        style: tickStyle,
        x1: getPosition(tickRadius, tickAngle, "x") + origin.x,
        y1: getPosition(tickRadius, tickAngle, "y") + origin.y,
        x2: getPosition(tickRadius + tickPadding, tickAngle, "x") + origin.x,
        y2: getPosition(tickRadius + tickPadding, tickAngle, "y") + origin.y
    } : {
        index: index,
        datum: tick,
        style: tickStyle,
        x1: tickRadius * Math.cos(tickAngle) + Math.cos(padAngle) * tickPadding + origin.x,
        x2: tickRadius * Math.cos(tickAngle) - Math.cos(padAngle) * tickPadding + origin.x,
        y1: tickRadius * Math.sin(tickAngle) + Math.sin(padAngle) * tickPadding + origin.y,
        y2: tickRadius * Math.sin(tickAngle) - Math.sin(padAngle) * tickPadding + origin.y
    };
}; //eslint-disable-next-line max-params
var getTickLabelProps = function getTickLabelProps(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, tickFormat = calculatedValues.tickFormat, style = calculatedValues.style, scale = calculatedValues.scale, ticks = calculatedValues.ticks, stringTicks = calculatedValues.stringTicks, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles2 = getEvaluatedStyles(style, {
        text: text,
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType
    }), labelStyle = _getEvaluatedStyles2.labelStyle;
    var tickLabelComponent = props.tickLabelComponent;
    var labelPlacement = tickLabelComponent.props && tickLabelComponent.props.labelPlacement ? tickLabelComponent.props.labelPlacement : props.labelPlacement;
    var tickPadding = labelStyle.padding || 0;
    var angularPadding = 0; // TODO: do some geometry
    var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
    var labelAngle = axisType === "angular" ? (0, _victoryCore.Helpers).radiansToDegrees(scale(tickValue)) : axisAngle + angularPadding;
    var textAngle = labelStyle.angle === undefined ? (0, _victoryCore.LabelHelpers).getPolarAngle((0, _assignDefault.default)({}, props, {
        labelPlacement: labelPlacement
    }), labelAngle) : labelStyle.angle;
    var labelRadius = axisType === "angular" ? radius + tickPadding : scale(tickValue);
    var textAnchor = labelStyle.textAnchor || (0, _victoryCore.LabelHelpers).getPolarTextAnchor((0, _assignDefault.default)({}, props, {
        labelPlacement: labelPlacement
    }), labelAngle);
    return {
        index: index,
        datum: tick,
        style: labelStyle,
        angle: textAngle,
        textAnchor: textAnchor,
        text: text,
        x: labelRadius * Math.cos((0, _victoryCore.Helpers).degreesToRadians(labelAngle)) + origin.x,
        y: -labelRadius * Math.sin((0, _victoryCore.Helpers).degreesToRadians(labelAngle)) + origin.y
    };
}; //eslint-disable-next-line max-params
var getGridProps = function getGridProps(props, calculatedValues, tickValue, index) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, style = calculatedValues.style, scale = calculatedValues.scale, stringTicks = calculatedValues.stringTicks, ticks = calculatedValues.ticks, tickFormat = calculatedValues.tickFormat, origin = calculatedValues.origin;
    var text = tickFormat(tickValue, index, ticks);
    var startAngle = props.startAngle, endAngle = props.endAngle, _props$innerRadius = props.innerRadius, innerRadius = _props$innerRadius === void 0 ? 0 : _props$innerRadius;
    var tick = stringTicks ? stringTicks[index] : tickValue;
    var _getEvaluatedStyles3 = getEvaluatedStyles(style, {
        tick: tick,
        tickValue: tickValue,
        index: index,
        ticks: ticks,
        stringTicks: stringTicks,
        radius: radius,
        scale: scale,
        axisType: axisType,
        text: text
    }), gridStyle = _getEvaluatedStyles3.gridStyle;
    var angle = scale(tickValue);
    return axisType === "angular" ? {
        index: index,
        datum: tick,
        style: gridStyle,
        x1: getPosition(radius, angle, "x") + origin.x,
        y1: getPosition(radius, angle, "y") + origin.y,
        x2: getPosition(innerRadius, angle, "x") + origin.x,
        y2: getPosition(innerRadius, angle, "y") + origin.y
    } : {
        style: gridStyle,
        index: index,
        datum: tick,
        cx: origin.x,
        cy: origin.y,
        r: scale(tickValue),
        startAngle: startAngle,
        endAngle: endAngle
    };
};
var getAxisLabelProps = function getAxisLabelProps(props, calculatedValues) {
    var axisType = calculatedValues.axisType, radius = calculatedValues.radius, style = calculatedValues.style, scale = calculatedValues.scale, origin = calculatedValues.origin;
    var axisLabelComponent = props.axisLabelComponent;
    if (axisType !== "radial") return {};
    var labelPlacement = axisLabelComponent.props && axisLabelComponent.props.labelPlacement ? axisLabelComponent.props.labelPlacement : props.labelPlacement;
    var labelStyle = style && style.axisLabel || {};
    var axisAngle = axisType === "radial" ? getAxisAngle(props, scale) : undefined;
    var textAngle = labelStyle.angle === undefined ? (0, _victoryCore.LabelHelpers).getPolarAngle((0, _assignDefault.default)({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle) : labelStyle.angle;
    var labelRadius = radius + (labelStyle.padding || 0);
    var textAnchor = labelStyle.textAnchor || (0, _victoryCore.LabelHelpers).getPolarTextAnchor((0, _assignDefault.default)({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle);
    var verticalAnchor = labelStyle.verticalAnchor || (0, _victoryCore.LabelHelpers).getPolarVerticalAnchor((0, _assignDefault.default)({}, props, {
        labelPlacement: labelPlacement
    }), axisAngle);
    return {
        style: labelStyle,
        angle: textAngle,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        text: props.label,
        x: getPosition(labelRadius, (0, _victoryCore.Helpers).degreesToRadians(axisAngle), "x") + origin.x,
        y: getPosition(labelRadius, (0, _victoryCore.Helpers).degreesToRadians(axisAngle), "y") + origin.y
    };
};
var getAxisProps = function getAxisProps(modifiedProps, calculatedValues) {
    var style = calculatedValues.style, axisType = calculatedValues.axisType, radius = calculatedValues.radius, scale = calculatedValues.scale, origin = calculatedValues.origin;
    var startAngle = modifiedProps.startAngle, endAngle = modifiedProps.endAngle, _modifiedProps$innerR = modifiedProps.innerRadius, innerRadius = _modifiedProps$innerR === void 0 ? 0 : _modifiedProps$innerR;
    var axisAngle = axisType === "radial" ? (0, _victoryCore.Helpers).degreesToRadians(getAxisAngle(modifiedProps, scale)) : undefined;
    return axisType === "radial" ? {
        style: style.axis,
        x1: getPosition(innerRadius, axisAngle, "x") + origin.x,
        x2: getPosition(radius, axisAngle, "x") + origin.x,
        y1: getPosition(innerRadius, axisAngle, "y") + origin.y,
        y2: getPosition(radius, axisAngle, "y") + origin.y
    } : {
        style: style.axis,
        cx: origin.x,
        cy: origin.y,
        r: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
};
var getCalculatedValues = function getCalculatedValues(props) {
    props = (0, _assignDefault.default)({
        polar: true
    }, props);
    var defaultStyles = getStyleObject(props);
    var style = getStyles(props, defaultStyles);
    var padding = (0, _victoryCore.Helpers).getPadding(props);
    var axis = (0, _victoryCore.Axis).getAxis(props);
    var axisType = getAxisType(props);
    var stringTicks = (0, _victoryCore.Axis).stringTicks(props) ? props.tickValues : undefined;
    var domain = (0, _victoryCore.Axis).getDomain(props, axis);
    var range = getRange(props, axis);
    var scale = getScale(props);
    var initialTicks = (0, _victoryCore.Axis).getTicks(props, scale);
    var ticks = axisType === "angular" ? filterTicks(initialTicks, scale) : initialTicks;
    var tickFormat = (0, _victoryCore.Axis).getTickFormat(props, scale);
    var radius = getRadius(props);
    var origin = (0, _victoryCore.Helpers).getPolarOrigin(props);
    return {
        axis: axis,
        style: style,
        padding: padding,
        stringTicks: stringTicks,
        axisType: axisType,
        scale: scale,
        ticks: ticks,
        tickFormat: tickFormat,
        domain: domain,
        range: range,
        radius: radius,
        origin: origin
    };
};
var getBaseProps = function getBaseProps(props, fallbackProps) {
    props = (0, _victoryCore.Axis).modifyProps(props, fallbackProps);
    var calculatedValues = getCalculatedValues(props);
    var style = calculatedValues.style, scale = calculatedValues.scale, ticks = calculatedValues.ticks, domain = calculatedValues.domain;
    var _props = props, width = _props.width, height = _props.height, standalone = _props.standalone, theme = _props.theme, name = _props.name;
    var axisProps = getAxisProps(props, calculatedValues);
    var axisLabelProps = getAxisLabelProps(props, calculatedValues);
    var initialChildProps = {
        parent: {
            style: style.parent,
            ticks: ticks,
            scale: scale,
            width: width,
            height: height,
            domain: domain,
            standalone: standalone,
            theme: theme,
            name: name
        }
    };
    return ticks.reduce(function(childProps, tick, index) {
        childProps[index] = {
            axis: axisProps,
            axisLabel: axisLabelProps,
            ticks: getTickProps(props, calculatedValues, tick, index),
            tickLabels: getTickLabelProps(props, calculatedValues, tick, index),
            grid: getGridProps(props, calculatedValues, tick, index)
        };
        return childProps;
    }, initialChildProps);
};

},{"lodash/defaults":"eWhnr","lodash/uniqBy":"2YIDS","lodash/assign":"xTxAt","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gWDhr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBackgroundWithProps", function() {
    return getBackgroundWithProps;
});
parcelHelpers.export(exports, "getCalculatedProps", function() {
    return getCalculatedProps;
});
parcelHelpers.export(exports, "getChildren", function() {
    return getChildren;
});
parcelHelpers.export(exports, "getChildComponents", function() {
    return getChildComponents;
});
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
/* eslint-disable func-style */ /* eslint-disable no-use-before-define */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _victoryCore = require("victory-core");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var fallbackProps = {
    width: 450,
    height: 300,
    padding: 50
};
function getAxisProps(child, props, calculatedProps) {
    var domain = calculatedProps.domain, scale = calculatedProps.scale, stringMap = calculatedProps.stringMap, categories = calculatedProps.categories, horizontal = calculatedProps.horizontal;
    return {
        stringMap: stringMap,
        horizontal: horizontal,
        categories: categories,
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        innerRadius: props.innerRadius,
        domain: domain,
        scale: scale
    };
}
function getBackgroundWithProps(props, calculatedProps) {
    var backgroundElement = props.backgroundComponent;
    var height = props.polar ? calculatedProps.range.y[1] : calculatedProps.range.y[0] - calculatedProps.range.y[1];
    var width = calculatedProps.range.x[1] - calculatedProps.range.x[0];
    var xScale = props.horizontal ? calculatedProps.scale.y.range()[0] : calculatedProps.scale.x.range()[0];
    var yScale = props.horizontal ? calculatedProps.scale.x.range()[1] : calculatedProps.scale.y.range()[1];
    var xCoordinate = props.polar ? calculatedProps.origin.x : xScale;
    var yCoordinate = props.polar ? calculatedProps.origin.y : yScale;
    var parentName = props.name || "chart";
    var backgroundProps = {
        height: height,
        polar: props.polar,
        scale: calculatedProps.scale,
        style: props.style.background,
        x: xCoordinate,
        y: yCoordinate,
        key: "".concat(parentName, "-background"),
        width: width
    };
    return (0, _reactDefault.default).cloneElement(backgroundElement, (0, _defaultsDefault.default)({}, backgroundElement.props, backgroundProps));
}
function getChildProps(child, props, calculatedProps) {
    var axisChild = (0, _victoryCore.Axis).findAxisComponents([
        child
    ]);
    if (axisChild.length > 0) return getAxisProps(axisChild[0], props, calculatedProps);
    var categories = calculatedProps.categories, domain = calculatedProps.domain, range = calculatedProps.range, scale = calculatedProps.scale, stringMap = calculatedProps.stringMap, horizontal = calculatedProps.horizontal;
    return {
        categories: categories,
        domain: domain,
        range: range,
        scale: scale,
        stringMap: stringMap,
        horizontal: horizontal
    };
}
function getStyles(props) {
    var styleProps = props.style && props.style.parent;
    return {
        parent: (0, _defaultsDefault.default)({}, styleProps, {
            height: "100%",
            width: "100%",
            userSelect: "none"
        })
    };
}
function getCalculatedProps(props, childComponents) {
    var style = getStyles(props);
    props = (0, _victoryCore.Helpers).modifyProps(props, fallbackProps, "chart");
    var _props = props, horizontal = _props.horizontal, polar = _props.polar;
    var allStrings = (0, _victoryCore.Wrapper).getStringsFromChildren(props, childComponents);
    var categories = (0, _victoryCore.Wrapper).getCategories(props, childComponents, allStrings);
    var stringMap = createStringMap(props, childComponents, allStrings);
    var domain = {
        x: getDomain((0, _assignDefault.default)({}, props, {
            categories: categories
        }), "x", childComponents),
        y: getDomain((0, _assignDefault.default)({}, props, {
            categories: categories
        }), "y", childComponents)
    };
    var range = {
        x: (0, _victoryCore.Helpers).getRange(props, "x"),
        y: (0, _victoryCore.Helpers).getRange(props, "y")
    };
    var baseScale = {
        x: (0, _victoryCore.Scale).getScaleFromProps(props, "x") || (0, _victoryCore.Wrapper).getScale(props, "x"),
        y: (0, _victoryCore.Scale).getScaleFromProps(props, "y") || (0, _victoryCore.Wrapper).getScale(props, "y")
    };
    var scale = {
        x: baseScale.x.domain(domain.x).range(horizontal ? range.y : range.x),
        y: baseScale.y.domain(domain.y).range(horizontal ? range.x : range.y)
    };
    var origin = polar ? (0, _victoryCore.Helpers).getPolarOrigin(props) : (0, _victoryCore.Axis).getOrigin(domain);
    var padding = (0, _victoryCore.Helpers).getPadding(props);
    return {
        categories: categories,
        domain: domain,
        range: range,
        horizontal: horizontal,
        scale: scale,
        stringMap: stringMap,
        style: style,
        origin: origin,
        padding: padding
    };
}
function getChildren(props, childComponents, calculatedProps) {
    childComponents = childComponents || getChildComponents(props);
    calculatedProps = calculatedProps || getCalculatedProps(props, childComponents);
    var baseStyle = calculatedProps.style.parent;
    var height = props.height, polar = props.polar, theme = props.theme, width = props.width;
    var _calculatedProps = calculatedProps, origin = _calculatedProps.origin, horizontal = _calculatedProps.horizontal;
    var parentName = props.name || "chart";
    return childComponents.map(function(child, index) {
        var role = child.type && child.type.role;
        var style = Array.isArray(child.props.style) ? child.props.style : (0, _defaultsDefault.default)({}, child.props.style, {
            parent: baseStyle
        });
        var childProps = getChildProps(child, props, calculatedProps);
        var name = child.props.name || "".concat(parentName, "-").concat(role, "-").concat(index);
        var newProps = (0, _defaultsDefault.default)({
            horizontal: horizontal,
            height: height,
            polar: polar,
            theme: theme,
            width: width,
            style: style,
            name: name,
            origin: polar ? origin : undefined,
            padding: calculatedProps.padding,
            key: "".concat(name, "-key-").concat(index),
            standalone: false
        }, childProps);
        return (0, _reactDefault.default).cloneElement(child, newProps);
    });
}
var getChildComponents = function getChildComponents(props, defaultAxes) {
    var childComponents = (0, _reactDefault.default).Children.toArray(props.children);
    var newChildComponents = _toConsumableArray(childComponents);
    if (childComponents.length === 0) newChildComponents.push(defaultAxes.independent, defaultAxes.dependent);
    else {
        var axisComponents = {
            dependent: (0, _victoryCore.Axis).getAxisComponentsWithParent(childComponents, "dependent"),
            independent: (0, _victoryCore.Axis).getAxisComponentsWithParent(childComponents, "independent")
        };
        if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) newChildComponents = props.prependDefaultAxes ? [
            defaultAxes.independent,
            defaultAxes.dependent
        ].concat(newChildComponents) : newChildComponents.concat([
            defaultAxes.independent,
            defaultAxes.dependent
        ]);
    }
    return newChildComponents;
};
var getDomain = function getDomain(props, axis, childComponents) {
    childComponents = childComponents || (0, _reactDefault.default).Children.toArray(props.children);
    var domain = (0, _victoryCore.Wrapper).getDomain(props, axis, childComponents);
    var axisComponent = (0, _victoryCore.Axis).getAxisComponent(childComponents, axis);
    var invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
    return invertDomain ? domain.concat().reverse() : domain;
};
var createStringMap = function createStringMap(props, childComponents, allStrings) {
    var x = !allStrings.x || allStrings.x.length === 0 ? null : allStrings.x.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    var y = !allStrings.y || allStrings.y.length === 0 ? null : allStrings.y.reduce(function(memo, string, index) {
        memo[string] = index + 1;
        return memo;
    }, {});
    return {
        x: x,
        y: y
    };
};

},{"lodash/assign":"xTxAt","lodash/defaults":"eWhnr","react":"gVheC","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iQMO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryPie", function() {
    return 0, _victoryPieDefault.default;
});
parcelHelpers.export(exports, "Slice", function() {
    return 0, _sliceDefault.default;
});
var _victoryPie = require("./victory-pie");
var _victoryPieDefault = parcelHelpers.interopDefault(_victoryPie);
var _slice = require("./slice");
var _sliceDefault = parcelHelpers.interopDefault(_slice);

},{"./victory-pie":"9qig0","./slice":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9qig0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
/*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryCore = require("victory-core");
var _slice = require("./slice");
var _sliceDefault = parcelHelpers.interopDefault(_slice);
var _helperMethods = require("./helper-methods");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var fallbackProps = {
    endAngle: 360,
    height: 400,
    innerRadius: 0,
    cornerRadius: 0,
    padAngle: 0,
    padding: 30,
    width: 400,
    startAngle: 0,
    colorScale: [
        "#ffffff",
        "#f0f0f0",
        "#d9d9d9",
        "#bdbdbd",
        "#969696",
        "#737373",
        "#525252",
        "#252525",
        "#000000"
    ],
    labelPosition: "centroid"
};
var VictoryPie = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryPie, _React$Component);
    function VictoryPie() {
        _classCallCheck(this, VictoryPie);
        return _possibleConstructorReturn(this, (VictoryPie.__proto__ || Object.getPrototypeOf(VictoryPie)).apply(this, arguments));
    }
    _createClass(VictoryPie, [
        {
            key: "shouldAnimate",
            // Overridden in victory-native
            value: function shouldAnimate() {
                return Boolean(this.props.animate);
            }
        },
        {
            key: "render",
            value: function render() {
                var animationWhitelist = VictoryPie.animationWhitelist, role = VictoryPie.role;
                var props = (0, _victoryCore.Helpers).modifyProps(this.props, fallbackProps, role);
                if (this.shouldAnimate()) return this.animateComponent(props, animationWhitelist);
                var children = this.renderData(props);
                return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
            }
        }
    ]);
    return VictoryPie;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryPie, "animationWhitelist", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "data",
        "endAngle",
        "height",
        "innerRadius",
        "cornerRadius",
        "padAngle",
        "padding",
        "colorScale",
        "startAngle",
        "style",
        "width"
    ]
});
Object.defineProperty(VictoryPie, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryPie"
});
Object.defineProperty(VictoryPie, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "pie"
});
Object.defineProperty(VictoryPie, "defaultTransitions", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        onExit: {
            duration: 500,
            before: function before() {
                return {
                    _y: 0,
                    label: " "
                };
            }
        },
        onEnter: {
            duration: 500,
            before: function before() {
                return {
                    _y: 0,
                    label: " "
                };
            },
            after: function after(datum) {
                return {
                    y_: datum._y,
                    label: datum.label
                };
            }
        }
    }
});
Object.defineProperty(VictoryPie, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        animate: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).object
        ]),
        colorScale: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
            (0, _propTypesDefault.default).oneOf([
                "grayscale",
                "qualitative",
                "heatmap",
                "warm",
                "cool",
                "red",
                "green",
                "blue"
            ])
        ]),
        containerComponent: (0, _propTypesDefault.default).element,
        cornerRadius: (0, _propTypesDefault.default).oneOfType([
            (0, _victoryCore.PropTypes).nonNegative,
            (0, _propTypesDefault.default).func
        ]),
        data: (0, _propTypesDefault.default).array,
        dataComponent: (0, _propTypesDefault.default).element,
        disableInlineStyes: (0, _propTypesDefault.default).bool,
        endAngle: (0, _propTypesDefault.default).number,
        eventKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string
        ]),
        events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            target: (0, _propTypesDefault.default).oneOf([
                "data",
                "labels",
                "parent"
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).func,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            eventHandlers: (0, _propTypesDefault.default).object
        })),
        externalEventMutations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            callback: (0, _propTypesDefault.default).function,
            childName: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            mutation: (0, _propTypesDefault.default).function,
            target: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ])
        })),
        groupComponent: (0, _propTypesDefault.default).element,
        height: (0, _victoryCore.PropTypes).nonNegative,
        innerRadius: (0, _propTypesDefault.default).oneOfType([
            (0, _victoryCore.PropTypes).nonNegative,
            (0, _propTypesDefault.default).func
        ]),
        labelComponent: (0, _propTypesDefault.default).element,
        labelPlacement: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).oneOf([
                "parallel",
                "perpendicular",
                "vertical"
            ])
        ]),
        labelPosition: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).oneOf([
                "startAngle",
                "centroid",
                "endAngle"
            ])
        ]),
        labelRadius: (0, _propTypesDefault.default).oneOfType([
            (0, _victoryCore.PropTypes).nonNegative,
            (0, _propTypesDefault.default).func
        ]),
        labels: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).array
        ]),
        name: (0, _propTypesDefault.default).string,
        origin: (0, _propTypesDefault.default).shape({
            x: (0, _victoryCore.PropTypes).nonNegative,
            y: (0, _victoryCore.PropTypes).nonNegative
        }),
        padAngle: (0, _propTypesDefault.default).oneOfType([
            (0, _victoryCore.PropTypes).nonNegative,
            (0, _propTypesDefault.default).func
        ]),
        padding: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                top: (0, _propTypesDefault.default).number,
                bottom: (0, _propTypesDefault.default).number,
                left: (0, _propTypesDefault.default).number,
                right: (0, _propTypesDefault.default).number
            })
        ]),
        radius: (0, _propTypesDefault.default).oneOfType([
            (0, _victoryCore.PropTypes).nonNegative,
            (0, _propTypesDefault.default).func
        ]),
        sharedEvents: (0, _propTypesDefault.default).shape({
            events: (0, _propTypesDefault.default).array,
            getEventState: (0, _propTypesDefault.default).func
        }),
        sortKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        ]),
        sortOrder: (0, _propTypesDefault.default).oneOf([
            "ascending",
            "descending"
        ]),
        standalone: (0, _propTypesDefault.default).bool,
        startAngle: (0, _propTypesDefault.default).number,
        style: (0, _propTypesDefault.default).shape({
            parent: (0, _propTypesDefault.default).object,
            data: (0, _propTypesDefault.default).object,
            labels: (0, _propTypesDefault.default).object
        }),
        theme: (0, _propTypesDefault.default).object,
        width: (0, _victoryCore.PropTypes).nonNegative,
        x: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        ]),
        y: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        ])
    }
});
Object.defineProperty(VictoryPie, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        data: [
            {
                x: "A",
                y: 1
            },
            {
                x: "B",
                y: 2
            },
            {
                x: "C",
                y: 3
            },
            {
                x: "D",
                y: 1
            },
            {
                x: "E",
                y: 2
            }
        ],
        standalone: true,
        dataComponent: (0, _reactDefault.default).createElement((0, _sliceDefault.default), null),
        labelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null),
        containerComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryContainer), null),
        groupComponent: (0, _reactDefault.default).createElement("g", null),
        sortOrder: "ascending",
        theme: (0, _victoryCore.VictoryTheme).grayscale
    }
});
Object.defineProperty(VictoryPie, "getBaseProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getBaseProps)(props, fallbackProps);
    }
});
Object.defineProperty(VictoryPie, "getData", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: (0, _victoryCore.Data).getData
});
Object.defineProperty(VictoryPie, "expectedComponents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "dataComponent",
        "labelComponent",
        "groupComponent",
        "containerComponent"
    ]
});
exports.default = (0, _victoryCore.addEvents)(VictoryPie);

},{"@swc/helpers/_/_type_of":"668P4","react":"gVheC","prop-types":"3KNJy","victory-core":"2Y5GL","./slice":"enEov","./helper-methods":"9z4On","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"enEov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _victoryCore = require("victory-core");
var _d3Shape = require("d3-shape");
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var getPath = function getPath(props) {
    var slice = props.slice, radius = props.radius, innerRadius = props.innerRadius, cornerRadius = props.cornerRadius;
    if ((0, _isFunctionDefault.default)(props.pathFunction)) return props.pathFunction(slice);
    var padAngle = (0, _victoryCore.Helpers).degreesToRadians(props.padAngle);
    var startAngle = (0, _victoryCore.Helpers).degreesToRadians(props.sliceStartAngle);
    var endAngle = (0, _victoryCore.Helpers).degreesToRadians(props.sliceEndAngle);
    var pathFunction = _d3Shape.arc().cornerRadius(cornerRadius).outerRadius(radius).innerRadius(innerRadius || 0);
    return pathFunction((0, _defaultsDefault.default)({
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle
    }, slice));
};
var evaluateProps = function evaluateProps(props) {
    /**
   * * Potential evaluated props of following must be evaluated in this order:
   * 1) `style`
   * 2) `radius`
   * 3) `innerRadius`
   *
   * Everything else does not have to be evaluated in a particular order:
   * `ariaLabel`
   * `id`
   * `cornerRadius`
   * `padAngle`
   * `sliceStartAngle`
   * `sliceEndAngle`
   * `tabIndex`
   */ var style = (0, _victoryCore.Helpers).evaluateStyle(props.style, props);
    var radius = (0, _victoryCore.Helpers).evaluateProp(props.radius, (0, _assignDefault.default)({}, props, {
        style: style
    }));
    var innerRadius = (0, _victoryCore.Helpers).evaluateProp(props.innerRadius, (0, _assignDefault.default)({}, props, {
        style: style,
        radius: radius
    }));
    var ariaLabel = (0, _victoryCore.Helpers).evaluateProp(props.ariaLabel, props);
    var id = (0, _victoryCore.Helpers).evaluateProp(props.id, props);
    var cornerRadius = (0, _victoryCore.Helpers).evaluateProp(props.cornerRadius, props);
    var padAngle = (0, _victoryCore.Helpers).evaluateProp(props.padAngle, props);
    var sliceStartAngle = (0, _victoryCore.Helpers).evaluateProp(props.sliceStartAngle, props);
    var sliceEndAngle = (0, _victoryCore.Helpers).evaluateProp(props.sliceEndAngle, props);
    var tabIndex = (0, _victoryCore.Helpers).evaluateProp(props.tabIndex, props);
    return (0, _assignDefault.default)({}, props, {
        ariaLabel: ariaLabel,
        style: style,
        radius: radius,
        innerRadius: innerRadius,
        id: id,
        cornerRadius: cornerRadius,
        padAngle: padAngle,
        sliceStartAngle: sliceStartAngle,
        sliceEndAngle: sliceEndAngle,
        tabIndex: tabIndex
    });
};
var Slice = function Slice(props) {
    props = evaluateProps(props);
    var defaultTransform = props.origin ? "translate(".concat(props.origin.x, ", ").concat(props.origin.y, ")") : undefined;
    return (0, _reactDefault.default).cloneElement(props.pathComponent, _objectSpread({}, props.events, {
        "aria-label": props.ariaLabel,
        d: getPath(props),
        style: props.style,
        transform: props.transform || defaultTransform,
        className: props.className,
        role: props.role,
        shapeRendering: props.shapeRendering,
        clipPath: props.clipPath,
        tabIndex: props.tabIndex
    }));
};
Slice.propTypes = _objectSpread({}, (0, _victoryCore.CommonProps).primitiveProps, {
    cornerRadius: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    datum: (0, _propTypesDefault.default).object,
    innerRadius: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    padAngle: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    pathComponent: (0, _propTypesDefault.default).element,
    pathFunction: (0, _propTypesDefault.default).func,
    radius: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    slice: (0, _propTypesDefault.default).object,
    sliceEndAngle: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ]),
    sliceStartAngle: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).func
    ])
});
Slice.defaultProps = {
    pathComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Path), null),
    role: "presentation",
    shapeRendering: "auto"
};
exports.default = Slice;

},{"lodash/assign":"xTxAt","lodash/isFunction":"8ck2f","lodash/defaults":"eWhnr","react":"gVheC","prop-types":"3KNJy","victory-core":"2Y5GL","d3-shape":"60fur","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"60fur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", function() {
    return 0, _arcJsDefault.default;
});
parcelHelpers.export(exports, "area", function() {
    return 0, _areaJsDefault.default;
});
parcelHelpers.export(exports, "line", function() {
    return 0, _lineJsDefault.default;
});
parcelHelpers.export(exports, "pie", function() {
    return 0, _pieJsDefault.default;
});
parcelHelpers.export(exports, "areaRadial", function() {
    return 0, _areaRadialJsDefault.default;
}) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", function() {
    return 0, _areaRadialJsDefault.default;
});
parcelHelpers.export(exports, "lineRadial", function() {
    return 0, _lineRadialJsDefault.default;
}) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", function() {
    return 0, _lineRadialJsDefault.default;
});
parcelHelpers.export(exports, "pointRadial", function() {
    return 0, _pointRadialJsDefault.default;
});
parcelHelpers.export(exports, "linkHorizontal", function() {
    return 0, _indexJs.linkHorizontal;
});
parcelHelpers.export(exports, "linkVertical", function() {
    return 0, _indexJs.linkVertical;
});
parcelHelpers.export(exports, "linkRadial", function() {
    return 0, _indexJs.linkRadial;
});
parcelHelpers.export(exports, "symbol", function() {
    return 0, _symbolJsDefault.default;
});
parcelHelpers.export(exports, "symbols", function() {
    return 0, _symbolJs.symbols;
});
parcelHelpers.export(exports, "symbolCircle", function() {
    return 0, _circleJsDefault.default;
});
parcelHelpers.export(exports, "symbolCross", function() {
    return 0, _crossJsDefault.default;
});
parcelHelpers.export(exports, "symbolDiamond", function() {
    return 0, _diamondJsDefault.default;
});
parcelHelpers.export(exports, "symbolSquare", function() {
    return 0, _squareJsDefault.default;
});
parcelHelpers.export(exports, "symbolStar", function() {
    return 0, _starJsDefault.default;
});
parcelHelpers.export(exports, "symbolTriangle", function() {
    return 0, _triangleJsDefault.default;
});
parcelHelpers.export(exports, "symbolWye", function() {
    return 0, _wyeJsDefault.default;
});
parcelHelpers.export(exports, "curveBasisClosed", function() {
    return 0, _basisClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveBasisOpen", function() {
    return 0, _basisOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveBasis", function() {
    return 0, _basisJsDefault.default;
});
parcelHelpers.export(exports, "curveBundle", function() {
    return 0, _bundleJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinalClosed", function() {
    return 0, _cardinalClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinalOpen", function() {
    return 0, _cardinalOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinal", function() {
    return 0, _cardinalJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRomClosed", function() {
    return 0, _catmullRomClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRomOpen", function() {
    return 0, _catmullRomOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRom", function() {
    return 0, _catmullRomJsDefault.default;
});
parcelHelpers.export(exports, "curveLinearClosed", function() {
    return 0, _linearClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveLinear", function() {
    return 0, _linearJsDefault.default;
});
parcelHelpers.export(exports, "curveMonotoneX", function() {
    return 0, _monotoneJs.monotoneX;
});
parcelHelpers.export(exports, "curveMonotoneY", function() {
    return 0, _monotoneJs.monotoneY;
});
parcelHelpers.export(exports, "curveNatural", function() {
    return 0, _naturalJsDefault.default;
});
parcelHelpers.export(exports, "curveStep", function() {
    return 0, _stepJsDefault.default;
});
parcelHelpers.export(exports, "curveStepAfter", function() {
    return 0, _stepJs.stepAfter;
});
parcelHelpers.export(exports, "curveStepBefore", function() {
    return 0, _stepJs.stepBefore;
});
parcelHelpers.export(exports, "stack", function() {
    return 0, _stackJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetExpand", function() {
    return 0, _expandJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetDiverging", function() {
    return 0, _divergingJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetNone", function() {
    return 0, _noneJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetSilhouette", function() {
    return 0, _silhouetteJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetWiggle", function() {
    return 0, _wiggleJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderAppearance", function() {
    return 0, _appearanceJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderAscending", function() {
    return 0, _ascendingJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderDescending", function() {
    return 0, _descendingJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderInsideOut", function() {
    return 0, _insideOutJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderNone", function() {
    return 0, _noneJsDefault1.default;
});
parcelHelpers.export(exports, "stackOrderReverse", function() {
    return 0, _reverseJsDefault.default;
});
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _indexJs = require("./link/index.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"jX2Qs","./area.js":"apPUx","./line.js":"8tBOu","./pie.js":"7y2JF","./areaRadial.js":"eAqEW","./lineRadial.js":"aDuQ6","./pointRadial.js":"eI8tQ","./link/index.js":"iRe0O","./symbol.js":"9XFPq","./symbol/circle.js":"aTdnq","./symbol/cross.js":"auiWy","./symbol/diamond.js":"cNcjq","./symbol/square.js":"7o29a","./symbol/star.js":"2Fc8O","./symbol/triangle.js":"8YtTb","./symbol/wye.js":"cerxQ","./curve/basisClosed.js":"613Oa","./curve/basisOpen.js":"jREY5","./curve/basis.js":"h1JUf","./curve/bundle.js":"iNK5r","./curve/cardinalClosed.js":"eRtxE","./curve/cardinalOpen.js":"8Rtji","./curve/cardinal.js":"axcyy","./curve/catmullRomClosed.js":"9DCso","./curve/catmullRomOpen.js":"1JyW0","./curve/catmullRom.js":"bYdLQ","./curve/linearClosed.js":"5RFAl","./curve/linear.js":"f5nD0","./curve/monotone.js":"bp8Rc","./curve/natural.js":"jvevB","./curve/step.js":"9SfPw","./stack.js":"7bvkK","./offset/expand.js":"digu0","./offset/diverging.js":"gMjoi","./offset/none.js":"cagj8","./offset/silhouette.js":"kIHBV","./offset/wiggle.js":"3rSC0","./order/appearance.js":"1J5aQ","./order/ascending.js":"bcRaF","./order/descending.js":"dX7Aj","./order/insideOut.js":"aUUNC","./order/none.js":"55act","./order/reverse.js":"7KkrX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jX2Qs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = (0, _d3Path.path)();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < (0, _mathJs.pi) && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"d3-path":"3TxOH","./constant.js":"d08CK","./math.js":"12AfF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3TxOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", function() {
    return 0, _pathJsDefault.default;
});
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);

},{"./path.js":"jlXNJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jlXNJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function moveTo(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function lineTo(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function rect(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function toString() {
        return this._;
    }
};
exports.default = path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d08CK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function constant() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"12AfF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", function() {
    return abs;
});
parcelHelpers.export(exports, "atan2", function() {
    return atan2;
});
parcelHelpers.export(exports, "cos", function() {
    return cos;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "sin", function() {
    return sin;
});
parcelHelpers.export(exports, "sqrt", function() {
    return sqrt;
});
parcelHelpers.export(exports, "epsilon", function() {
    return epsilon;
});
parcelHelpers.export(exports, "pi", function() {
    return pi;
});
parcelHelpers.export(exports, "halfPi", function() {
    return halfPi;
});
parcelHelpers.export(exports, "tau", function() {
    return tau;
});
parcelHelpers.export(exports, "acos", function() {
    return acos;
});
parcelHelpers.export(exports, "asin", function() {
    return asin;
});
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"apPUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var x0 = (0, _pointJs.x), x1 = null, y0 = (0, _constantJsDefault.default)(0), y1 = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function area(data) {
            var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pointJs = require("./point.js");

},{"d3-path":"3TxOH","./constant.js":"d08CK","./curve/linear.js":"f5nD0","./line.js":"8tBOu","./point.js":"cbAGp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f5nD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new Linear(context);
    };
});
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8tBOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var x = (0, _pointJs.x), y = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function line(data) {
            var i, n = data.length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pointJs = require("./point.js");

},{"d3-path":"3TxOH","./constant.js":"d08CK","./curve/linear.js":"f5nD0","./point.js":"cbAGp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cbAGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", function() {
    return x;
});
parcelHelpers.export(exports, "y", function() {
    return y;
});
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7y2JF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    };
});
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./constant.js":"d08CK","./descending.js":"gsBVl","./identity.js":"cr2Y1","./math.js":"12AfF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsBVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cr2Y1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(d) {
        return d;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eAqEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var a = (0, _areaJsDefault.default)().curve((0, _radialJs.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
        };
        return a;
    };
});
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineRadialJs = require("./lineRadial.js");

},{"./curve/radial.js":"giekQ","./area.js":"apPUx","./lineRadial.js":"aDuQ6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"giekQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", function() {
    return curveRadialLinear;
});
parcelHelpers.export(exports, "default", function() {
    return curveRadial;
});
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function areaStart() {
        this._curve.areaStart();
    },
    areaEnd: function areaEnd() {
        this._curve.areaEnd();
    },
    lineStart: function lineStart() {
        this._curve.lineStart();
    },
    lineEnd: function lineEnd() {
        this._curve.lineEnd();
    },
    point: function point(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"f5nD0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aDuQ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", function() {
    return lineRadial;
});
parcelHelpers.export(exports, "default", function() {
    return function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    };
});
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"giekQ","./line.js":"8tBOu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eI8tQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iRe0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linkHorizontal", function() {
    return linkHorizontal;
});
parcelHelpers.export(exports, "linkVertical", function() {
    return linkVertical;
});
parcelHelpers.export(exports, "linkRadial", function() {
    return linkRadial;
});
var _d3Path = require("d3-path");
var _arrayJs = require("../array.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pointJs = require("../point.js");
var _pointRadialJs = require("../pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    var source = linkSource, target = linkTarget, x = (0, _pointJs.x), y = (0, _pointJs.y), context = null;
    function link() {
        var buffer, argv = (0, _arrayJs.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, _d3Path.path)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, _pointRadialJsDefault.default)(x0, y0), p1 = (0, _pointRadialJsDefault.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, _pointRadialJsDefault.default)(x1, y0), p3 = (0, _pointRadialJsDefault.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function linkHorizontal() {
    return link(curveHorizontal);
}
function linkVertical() {
    return link(curveVertical);
}
function linkRadial() {
    var l = link(curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"d3-path":"3TxOH","../array.js":"5SoAR","../constant.js":"d08CK","../point.js":"cbAGp","../pointRadial.js":"eI8tQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5SoAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", function() {
    return slice;
});
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9XFPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbols", function() {
    return symbols;
});
parcelHelpers.export(exports, "default", function() {
    return function() {
        var type = (0, _constantJsDefault.default)((0, _circleJsDefault.default)), size = (0, _constantJsDefault.default)(64), context = null;
        function symbol() {
            var buffer;
            if (!context) context = buffer = (0, _d3Path.path)();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    };
});
var _d3Path = require("d3-path");
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var symbols = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];

},{"d3-path":"3TxOH","./symbol/circle.js":"aTdnq","./symbol/cross.js":"auiWy","./symbol/diamond.js":"cNcjq","./symbol/star.js":"2Fc8O","./symbol/square.js":"7o29a","./symbol/triangle.js":"8YtTb","./symbol/wye.js":"cerxQ","./constant.js":"d08CK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aTdnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw: function draw(context, size) {
        var r = Math.sqrt(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"12AfF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"auiWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function draw(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cNcjq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tan30 = Math.sqrt(1 / 3), tan30_2 = tan30 * 2;
exports.default = {
    draw: function draw(context, size) {
        var y = Math.sqrt(size / tan30_2), x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Fc8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
var ka = 0.89081309152928522810, kr = Math.sin((0, _mathJs.pi) / 10) / Math.sin(7 * (0, _mathJs.pi) / 10), kx = Math.sin((0, _mathJs.tau) / 10) * kr, ky = -Math.cos((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw: function draw(context, size) {
        var r = Math.sqrt(size * ka), x = kx * r, y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, _mathJs.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"12AfF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7o29a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function draw(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8YtTb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var sqrt3 = Math.sqrt(3);
exports.default = {
    draw: function draw(context, size) {
        var y = -Math.sqrt(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cerxQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var c = -0.5, s = Math.sqrt(3) / 2, k = 1 / Math.sqrt(12), a = (k / 2 + 1) * 3;
exports.default = {
    draw: function draw(context, size) {
        var r = Math.sqrt(size / a), x0 = r / 2, y0 = r * k, x1 = x0, y1 = r * k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"613Oa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new BasisClosed(context);
    };
});
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"cDqg0","./basis.js":"h1JUf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cDqg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {};
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h1JUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", function() {
    return point;
});
parcelHelpers.export(exports, "Basis", function() {
    return Basis;
});
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new Basis(context);
    };
});
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jREY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new BasisOpen(context);
    };
});
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"h1JUf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iNK5r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"h1JUf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eRtxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", function() {
    return CardinalClosed;
});
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"cDqg0","./cardinal.js":"axcyy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"axcyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", function() {
    return point;
});
parcelHelpers.export(exports, "Cardinal", function() {
    return Cardinal;
});
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Rtji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", function() {
    return CardinalOpen;
});
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"axcyy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9DCso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"eRtxE","../noop.js":"cDqg0","./catmullRom.js":"bYdLQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bYdLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", function() {
    return point;
});
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"12AfF","./cardinal.js":"axcyy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1JyW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"8Rtji","./catmullRom.js":"bYdLQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RFAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new LinearClosed(context);
    };
});
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._point) this._context.closePath();
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"cDqg0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bp8Rc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", function() {
    return monotoneX;
});
parcelHelpers.export(exports, "monotoneY", function() {
    return monotoneY;
});
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function moveTo(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function closePath() {
        this._context.closePath();
    },
    lineTo: function lineTo(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jvevB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new Natural(context);
    };
});
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9SfPw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new Step(context, 0.5);
    };
});
parcelHelpers.export(exports, "stepBefore", function() {
    return stepBefore;
});
parcelHelpers.export(exports, "stepAfter", function() {
    return stepAfter;
});
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7bvkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
            for(i = 0; i < n; ++i){
                for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                    si[j] = sij = [
                        0,
                        +value(data[j], ki, j, data)
                    ];
                    sij.data = data[j];
                }
                si.key = ki;
            }
            for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    };
});
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}

},{"./array.js":"5SoAR","./constant.js":"d08CK","./offset/none.js":"cagj8","./order/none.js":"55act","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cagj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"55act":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"digu0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"cagj8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMjoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kIHBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"cagj8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rSC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"cagj8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1J5aQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"55act","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bcRaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    };
});
parcelHelpers.export(exports, "sum", function() {
    return sum;
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"55act","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dX7Aj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    };
});
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"bcRaF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aUUNC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    };
});
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"1J5aQ","./ascending.js":"bcRaF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7KkrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"55act","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9z4On":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBaseProps", function() {
    return getBaseProps;
});
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _d3Shape = require("d3-shape");
var _victoryCore = require("victory-core");
var checkForValidText = function checkForValidText(text) {
    if (text === undefined || text === null || (0, _isFunctionDefault.default)(text)) return text;
    else return "".concat(text);
};
var getColor = function getColor(style, colors, index) {
    if (style && style.data && style.data.fill) return style.data.fill;
    return colors && colors[index % colors.length];
};
var getRadius = function getRadius(props, padding) {
    if (typeof props.radius === "number") return props.radius;
    return Math.min(props.width - padding.left - padding.right, props.height - padding.top - padding.bottom) / 2;
};
var getOrigin = function getOrigin(props, padding) {
    var width = props.width, height = props.height;
    var origin = (0, _isPlainObjectDefault.default)(props.origin) ? props.origin : {};
    return {
        x: origin.x !== undefined ? origin.x : (padding.left - padding.right + width) / 2,
        y: origin.y !== undefined ? origin.y : (padding.top - padding.bottom + height) / 2
    };
};
var getSlices = function getSlices(props, data) {
    var padAngle = (0, _isFunctionDefault.default)(props.padAngle) ? 0 : props.padAngle;
    var layoutFunction = _d3Shape.pie().sort(null).startAngle((0, _victoryCore.Helpers).degreesToRadians(props.startAngle)).endAngle((0, _victoryCore.Helpers).degreesToRadians(props.endAngle)).padAngle((0, _victoryCore.Helpers).degreesToRadians(padAngle)).value(function(datum) {
        return datum._y;
    });
    return layoutFunction(data);
};
var getCalculatedValues = function getCalculatedValues(props) {
    var colorScale = props.colorScale;
    var styleObject = (0, _victoryCore.Helpers).getDefaultStyles(props, "pie");
    var style = (0, _victoryCore.Helpers).getStyles(props.style, styleObject, "auto", "100%");
    var colors = Array.isArray(colorScale) ? colorScale : (0, _victoryCore.Style).getColorScale(colorScale);
    var padding = (0, _victoryCore.Helpers).getPadding(props);
    var defaultRadius = getRadius(props, padding);
    var origin = getOrigin(props, padding);
    var data = (0, _victoryCore.Data).getData(props);
    var slices = getSlices(props, data);
    return (0, _assignDefault.default)({}, props, {
        style: style,
        colors: colors,
        padding: padding,
        defaultRadius: defaultRadius,
        data: data,
        slices: slices,
        origin: origin
    });
};
var getSliceStyle = function getSliceStyle(index, calculatedValues) {
    var style = calculatedValues.style, colors = calculatedValues.colors;
    var fill = getColor(style, colors, index);
    return (0, _assignDefault.default)({
        fill: fill
    }, style.data);
};
var getLabelText = function getLabelText(props, datum, index) {
    var text;
    if (datum.label) text = datum.label;
    else if (Array.isArray(props.labels)) text = props.labels[index];
    else text = (0, _isFunctionDefault.default)(props.labels) ? props.labels : datum.xName || datum._x;
    return checkForValidText(text);
};
var getLabelArc = function getLabelArc(radius, labelRadius, style) {
    var padding = style && style.padding || 0;
    var arcRadius = labelRadius || radius + padding;
    return _d3Shape.arc().outerRadius(arcRadius).innerRadius(arcRadius);
};
var getLabelPosition = function getLabelPosition(arc, slice, position) {
    var construct = {
        startAngle: position === "startAngle" ? slice.startAngle : slice.endAngle,
        endAngle: position === "endAngle" ? slice.endAngle : slice.startAngle
    };
    var clonedArc = (0, _assignDefault.default)({}, slice, construct);
    return arc.centroid(clonedArc);
};
var getLabelOrientation = function getLabelOrientation(degree, labelPlacement) {
    if (labelPlacement === "perpendicular") return degree > 90 && degree < 270 ? "bottom" : "top";
    else if (labelPlacement === "parallel") return degree >= 0 && degree <= 180 ? "right" : "left";
    if (degree < 45 || degree > 315) return "top";
    else if (degree >= 45 && degree < 135) return "right";
    else if (degree >= 135 && degree < 225) return "bottom";
    else return "left";
};
var getTextAnchor = function getTextAnchor(orientation) {
    if (orientation === "top" || orientation === "bottom") return "middle";
    return orientation === "right" ? "start" : "end";
};
var getVerticalAnchor = function getVerticalAnchor(orientation) {
    if (orientation === "left" || orientation === "right") return "middle";
    return orientation === "bottom" ? "start" : "end";
};
var getBaseLabelAngle = function getBaseLabelAngle(slice, labelPosition, labelStyle) {
    var baseAngle = 0;
    if (labelPosition.angle !== undefined) baseAngle = labelStyle.angle;
    else if (labelPosition === "centroid") baseAngle = (0, _victoryCore.Helpers).radiansToDegrees((slice.startAngle + slice.endAngle) / 2);
    else baseAngle = labelPosition === "startAngle" ? (0, _victoryCore.Helpers).radiansToDegrees(slice.startAngle) : (0, _victoryCore.Helpers).radiansToDegrees(slice.endAngle);
    var positiveAngle = baseAngle < 0 ? 360 - baseAngle : baseAngle;
    return positiveAngle % 360;
};
var getLabelAngle = function getLabelAngle(baseAngle, labelPlacement) {
    if (labelPlacement === "vertical") return 0;
    if (labelPlacement === "parallel") return baseAngle > 180 && baseAngle < 360 ? baseAngle + 90 : baseAngle - 90;
    return baseAngle > 90 && baseAngle < 270 ? baseAngle - 180 : baseAngle;
};
var getLabelProps = function getLabelProps(text, dataProps, calculatedValues) {
    var index = dataProps.index, datum = dataProps.datum, data = dataProps.data, slice = dataProps.slice, labelComponent = dataProps.labelComponent, theme = dataProps.theme;
    var style = calculatedValues.style, defaultRadius = calculatedValues.defaultRadius, origin = calculatedValues.origin, width = calculatedValues.width, height = calculatedValues.height;
    var labelRadius = (0, _victoryCore.Helpers).evaluateProp(calculatedValues.labelRadius, (0, _assignDefault.default)({
        text: text
    }, dataProps));
    var labelPosition = (0, _victoryCore.Helpers).evaluateProp(calculatedValues.labelPosition, (0, _assignDefault.default)({
        text: text
    }, dataProps)) || "centroid";
    var labelPlacement = (0, _victoryCore.Helpers).evaluateProp(calculatedValues.labelPlacement, (0, _assignDefault.default)({
        text: text
    }, dataProps)) || "vertical";
    var labelStyle = (0, _assignDefault.default)({
        padding: 0
    }, style.labels);
    var evaluatedStyle = (0, _victoryCore.Helpers).evaluateStyle(labelStyle, (0, _assignDefault.default)({
        labelRadius: labelRadius,
        text: text
    }, dataProps));
    var labelArc = getLabelArc(defaultRadius, labelRadius, evaluatedStyle);
    var position = getLabelPosition(labelArc, slice, labelPosition);
    var baseAngle = getBaseLabelAngle(slice, labelPosition, labelStyle);
    var labelAngle = getLabelAngle(baseAngle, labelPlacement);
    var orientation = getLabelOrientation(baseAngle, labelPlacement);
    var textAnchor = labelStyle.textAnchor || getTextAnchor(orientation);
    var verticalAnchor = labelStyle.verticalAnchor || getVerticalAnchor(orientation);
    var labelProps = {
        width: width,
        height: height,
        index: index,
        datum: datum,
        data: data,
        slice: slice,
        orientation: orientation,
        text: text,
        style: labelStyle,
        x: Math.round(position[0]) + origin.x,
        y: Math.round(position[1]) + origin.y,
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor,
        angle: labelAngle
    };
    if (!(0, _victoryCore.Helpers).isTooltip(labelComponent)) return labelProps;
    var tooltipTheme = theme && theme.tooltip || {};
    return (0, _defaultsDefault.default)({}, labelProps, (0, _victoryCore.Helpers).omit(tooltipTheme, [
        "style"
    ]));
};
var getBaseProps = function getBaseProps(props, fallbackProps) {
    props = (0, _victoryCore.Helpers).modifyProps(props, fallbackProps, "pie");
    var calculatedValues = getCalculatedValues(props);
    var slices = calculatedValues.slices, style = calculatedValues.style, data = calculatedValues.data, origin = calculatedValues.origin, defaultRadius = calculatedValues.defaultRadius, labels = calculatedValues.labels, events = calculatedValues.events, sharedEvents = calculatedValues.sharedEvents, height = calculatedValues.height, width = calculatedValues.width, standalone = calculatedValues.standalone, name = calculatedValues.name, innerRadius = calculatedValues.innerRadius, cornerRadius = calculatedValues.cornerRadius, padAngle = calculatedValues.padAngle, disableInlineStyles = calculatedValues.disableInlineStyles;
    var radius = props.radius || defaultRadius;
    var initialChildProps = {
        parent: {
            standalone: standalone,
            height: height,
            width: width,
            slices: slices,
            name: name,
            style: style.parent
        }
    };
    return slices.reduce(function(childProps, slice, index) {
        var datum = (0, _defaultsDefault.default)({}, data[index], {
            startAngle: (0, _victoryCore.Helpers).radiansToDegrees(slice.startAngle),
            endAngle: (0, _victoryCore.Helpers).radiansToDegrees(slice.endAngle),
            padAngle: (0, _victoryCore.Helpers).radiansToDegrees(slice.padAngle)
        });
        var eventKey = !(0, _isNilDefault.default)(datum.eventKey) ? datum.eventKey : index;
        var dataProps = {
            index: index,
            slice: slice,
            datum: datum,
            data: data,
            origin: origin,
            innerRadius: innerRadius,
            radius: radius,
            cornerRadius: cornerRadius,
            padAngle: padAngle,
            style: disableInlineStyles ? {} : getSliceStyle(index, calculatedValues),
            disableInlineStyles: disableInlineStyles
        };
        childProps[eventKey] = {
            data: dataProps
        };
        var text = getLabelText(props, datum, index);
        if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
            var evaluatedText = (0, _victoryCore.Helpers).evaluateProp(text, dataProps);
            childProps[eventKey].labels = getLabelProps(evaluatedText, (0, _assignDefault.default)({}, props, dataProps), calculatedValues);
        }
        return childProps;
    }, initialChildProps);
};

},{"lodash/isNil":"beGyX","lodash/isPlainObject":"2RXyg","lodash/isFunction":"8ck2f","lodash/defaults":"eWhnr","lodash/assign":"xTxAt","d3-shape":"60fur","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"19GQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VictoryLegend", function() {
    return 0, _victoryLegendDefault.default;
});
var _victoryLegend = require("./victory-legend");
var _victoryLegendDefault = parcelHelpers.interopDefault(_victoryLegend);

},{"./victory-legend":"gYAgj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gYAgj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _helperMethods = require("./helper-methods");
var _victoryCore = require("victory-core");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((typeof call === "undefined" ? "undefined" : (0, _typeOf._)(call)) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var fallbackProps = {
    orientation: "vertical",
    titleOrientation: "top",
    width: 450,
    height: 300,
    x: 0,
    y: 0
};
var defaultLegendData = [
    {
        name: "Series 1"
    },
    {
        name: "Series 2"
    }
];
var VictoryLegend = /*#__PURE__*/ function(_React$Component) {
    _inherits(VictoryLegend, _React$Component);
    function VictoryLegend() {
        _classCallCheck(this, VictoryLegend);
        return _possibleConstructorReturn(this, (VictoryLegend.__proto__ || Object.getPrototypeOf(VictoryLegend)).apply(this, arguments));
    }
    _createClass(VictoryLegend, [
        {
            key: "renderChildren",
            value: function renderChildren(props) {
                var _this = this;
                var dataComponent = props.dataComponent, labelComponent = props.labelComponent, title = props.title;
                var dataComponents = this.dataKeys.map(function(_dataKey, index) {
                    if (_dataKey === "all") return undefined;
                    var dataProps = _this.getComponentProps(dataComponent, "data", index);
                    return (0, _reactDefault.default).cloneElement(dataComponent, dataProps);
                }).filter(Boolean);
                var labelComponents = this.dataKeys.map(function(_dataKey, index) {
                    if (_dataKey === "all") return undefined;
                    var labelProps = _this.getComponentProps(labelComponent, "labels", index);
                    if (labelProps.text !== undefined && labelProps.text !== null) return (0, _reactDefault.default).cloneElement(labelComponent, labelProps);
                    return undefined;
                }).filter(Boolean);
                var borderProps = this.getComponentProps(props.borderComponent, "border", "all");
                var borderComponent = (0, _reactDefault.default).cloneElement(props.borderComponent, borderProps);
                if (title) {
                    var titleProps = this.getComponentProps(props.title, "title", "all");
                    var titleComponent = (0, _reactDefault.default).cloneElement(props.titleComponent, titleProps);
                    return [
                        borderComponent
                    ].concat(_toConsumableArray(dataComponents), [
                        titleComponent
                    ], _toConsumableArray(labelComponents));
                }
                return [
                    borderComponent
                ].concat(_toConsumableArray(dataComponents), _toConsumableArray(labelComponents));
            }
        },
        {
            key: "render",
            value: function render() {
                var role = this.constructor.role;
                var props = (0, _victoryCore.Helpers).modifyProps(this.props, fallbackProps, role);
                var children = [
                    this.renderChildren(props)
                ];
                return props.standalone ? this.renderContainer(props.containerComponent, children) : (0, _reactDefault.default).cloneElement(props.groupComponent, {}, children);
            }
        }
    ]);
    return VictoryLegend;
}((0, _reactDefault.default).Component);
Object.defineProperty(VictoryLegend, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "VictoryLegend"
});
Object.defineProperty(VictoryLegend, "role", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "legend"
});
Object.defineProperty(VictoryLegend, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        borderComponent: (0, _propTypesDefault.default).element,
        borderPadding: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                top: (0, _propTypesDefault.default).number,
                bottom: (0, _propTypesDefault.default).number,
                left: (0, _propTypesDefault.default).number,
                right: (0, _propTypesDefault.default).number
            })
        ]),
        centerTitle: (0, _propTypesDefault.default).bool,
        colorScale: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
            (0, _propTypesDefault.default).oneOf([
                "grayscale",
                "qualitative",
                "heatmap",
                "warm",
                "cool",
                "red",
                "green",
                "blue"
            ])
        ]),
        containerComponent: (0, _propTypesDefault.default).element,
        data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            name: (0, _propTypesDefault.default).string.isRequired,
            label: (0, _propTypesDefault.default).object,
            symbol: (0, _propTypesDefault.default).object
        })),
        dataComponent: (0, _propTypesDefault.default).element,
        eventKey: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _victoryCore.PropTypes).allOfType([
                (0, _victoryCore.PropTypes).integer,
                (0, _victoryCore.PropTypes).nonNegative
            ]),
            (0, _propTypesDefault.default).string
        ]),
        events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            target: (0, _propTypesDefault.default).oneOf([
                "data",
                "labels",
                "parent"
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            eventHandlers: (0, _propTypesDefault.default).object
        })),
        externalEventMutations: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            callback: (0, _propTypesDefault.default).function,
            childName: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ]),
            eventKey: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).array,
                (0, _victoryCore.PropTypes).allOfType([
                    (0, _victoryCore.PropTypes).integer,
                    (0, _victoryCore.PropTypes).nonNegative
                ]),
                (0, _propTypesDefault.default).string
            ]),
            mutation: (0, _propTypesDefault.default).function,
            target: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).array
            ])
        })),
        groupComponent: (0, _propTypesDefault.default).element,
        gutter: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                left: (0, _propTypesDefault.default).number,
                right: (0, _propTypesDefault.default).number
            })
        ]),
        height: (0, _victoryCore.PropTypes).nonNegative,
        itemsPerRow: (0, _victoryCore.PropTypes).nonNegative,
        labelComponent: (0, _propTypesDefault.default).element,
        name: (0, _propTypesDefault.default).string,
        orientation: (0, _propTypesDefault.default).oneOf([
            "horizontal",
            "vertical"
        ]),
        padding: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                top: (0, _propTypesDefault.default).number,
                bottom: (0, _propTypesDefault.default).number,
                left: (0, _propTypesDefault.default).number,
                right: (0, _propTypesDefault.default).number
            })
        ]),
        rowGutter: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                top: (0, _propTypesDefault.default).number,
                bottom: (0, _propTypesDefault.default).number
            })
        ]),
        sharedEvents: (0, _propTypesDefault.default).shape({
            events: (0, _propTypesDefault.default).array,
            getEventState: (0, _propTypesDefault.default).func
        }),
        standalone: (0, _propTypesDefault.default).bool,
        style: (0, _propTypesDefault.default).shape({
            border: (0, _propTypesDefault.default).object,
            data: (0, _propTypesDefault.default).object,
            labels: (0, _propTypesDefault.default).object,
            parent: (0, _propTypesDefault.default).object,
            title: (0, _propTypesDefault.default).object
        }),
        symbolSpacer: (0, _propTypesDefault.default).number,
        theme: (0, _propTypesDefault.default).object,
        title: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).array
        ]),
        titleComponent: (0, _propTypesDefault.default).element,
        titleOrientation: (0, _propTypesDefault.default).oneOf([
            "top",
            "bottom",
            "left",
            "right"
        ]),
        width: (0, _victoryCore.PropTypes).nonNegative,
        x: (0, _victoryCore.PropTypes).nonNegative,
        y: (0, _victoryCore.PropTypes).nonNegative
    }
});
Object.defineProperty(VictoryLegend, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: {
        borderComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Border), null),
        data: defaultLegendData,
        containerComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryContainer), null),
        dataComponent: (0, _reactDefault.default).createElement((0, _victoryCore.Point), null),
        groupComponent: (0, _reactDefault.default).createElement("g", null),
        labelComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null),
        standalone: true,
        theme: (0, _victoryCore.VictoryTheme).grayscale,
        titleComponent: (0, _reactDefault.default).createElement((0, _victoryCore.VictoryLabel), null)
    }
});
Object.defineProperty(VictoryLegend, "getBaseProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getBaseProps)(props, fallbackProps);
    }
});
Object.defineProperty(VictoryLegend, "getDimensions", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(props) {
        return (0, _helperMethods.getDimensions)(props, fallbackProps);
    }
});
Object.defineProperty(VictoryLegend, "expectedComponents", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: [
        "borderComponent",
        "containerComponent",
        "dataComponent",
        "groupComponent",
        "labelComponent",
        "titleComponent"
    ]
});
exports.default = (0, _victoryCore.addEvents)(VictoryLegend);

},{"@swc/helpers/_/_type_of":"668P4","react":"gVheC","prop-types":"3KNJy","./helper-methods":"8yvUv","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8yvUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDimensions", function() {
    return getDimensions;
});
parcelHelpers.export(exports, "getBaseProps", function() {
    return getBaseProps;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _sum = require("lodash/sum");
var _sumDefault = parcelHelpers.interopDefault(_sum);
var _keys = require("lodash/keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _groupBy = require("lodash/groupBy");
var _groupByDefault = parcelHelpers.interopDefault(_groupBy);
var _assign = require("lodash/assign");
var _assignDefault = parcelHelpers.interopDefault(_assign);
var _defaults = require("lodash/defaults");
var _defaultsDefault = parcelHelpers.interopDefault(_defaults);
var _victoryCore = require("victory-core");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var getColorScale = function getColorScale(props) {
    var colorScale = props.colorScale;
    return typeof colorScale === "string" ? (0, _victoryCore.Style).getColorScale(colorScale) : colorScale || [];
};
var getLabelStyles = function getLabelStyles(props) {
    var data = props.data, style = props.style;
    return data.map(function(datum, index) {
        var baseLabelStyles = (0, _defaultsDefault.default)({}, datum.labels, style.labels);
        return (0, _victoryCore.Helpers).evaluateStyle(baseLabelStyles, {
            datum: datum,
            index: index,
            data: data
        });
    });
};
var getStyles = function getStyles(props, styleObject) {
    var style = props.style || {};
    styleObject = styleObject || {};
    var parentStyleProps = {
        height: "100%",
        width: "100%"
    };
    return {
        parent: (0, _defaultsDefault.default)(style.parent, styleObject.parent, parentStyleProps),
        data: (0, _defaultsDefault.default)({}, style.data, styleObject.data),
        labels: (0, _defaultsDefault.default)({}, style.labels, styleObject.labels),
        border: (0, _defaultsDefault.default)({}, style.border, styleObject.border),
        title: (0, _defaultsDefault.default)({}, style.title, styleObject.title)
    };
};
var getCalculatedValues = function getCalculatedValues(props) {
    var orientation = props.orientation, theme = props.theme;
    var defaultStyles = theme && theme.legend && theme.legend.style ? theme.legend.style : {};
    var style = getStyles(props, defaultStyles);
    var colorScale = getColorScale(props);
    var isHorizontal = orientation === "horizontal";
    var borderPadding = (0, _victoryCore.Helpers).getPadding({
        padding: props.borderPadding
    });
    return (0, _assignDefault.default)({}, props, {
        style: style,
        isHorizontal: isHorizontal,
        colorScale: colorScale,
        borderPadding: borderPadding
    });
};
var getColumn = function getColumn(props, index) {
    var itemsPerRow = props.itemsPerRow, isHorizontal = props.isHorizontal;
    if (!itemsPerRow) return isHorizontal ? index : 0;
    return isHorizontal ? index % itemsPerRow : Math.floor(index / itemsPerRow);
};
var getRow = function getRow(props, index) {
    var itemsPerRow = props.itemsPerRow, isHorizontal = props.isHorizontal;
    if (!itemsPerRow) return isHorizontal ? 0 : index;
    return isHorizontal ? Math.floor(index / itemsPerRow) : index % itemsPerRow;
};
var groupData = function groupData(props) {
    var data = props.data;
    var style = props.style && props.style.data || {};
    var labelStyles = getLabelStyles(props);
    return data.map(function(datum, index) {
        var symbol = datum.symbol || {};
        var fontSize = labelStyles[index].fontSize; // eslint-disable-next-line no-magic-numbers
        var size = symbol.size || style.size || fontSize / 2.5;
        var symbolSpacer = props.symbolSpacer || Math.max(size, fontSize);
        return _objectSpread({}, datum, {
            size: size,
            symbolSpacer: symbolSpacer,
            fontSize: fontSize,
            textSize: (0, _victoryCore.TextSize).approximateTextSize(datum.name, labelStyles[index]),
            column: getColumn(props, index),
            row: getRow(props, index)
        });
    });
};
var getColumnWidths = function getColumnWidths(props, data) {
    var gutter = props.gutter || {};
    var gutterWidth = (typeof gutter === "undefined" ? "undefined" : (0, _typeOf._)(gutter)) === "object" ? (gutter.left || 0) + (gutter.right || 0) : gutter || 0;
    var dataByColumn = (0, _groupByDefault.default)(data, "column");
    var columns = (0, _keysDefault.default)(dataByColumn);
    return columns.reduce(function(memo, curr, index) {
        var lengths = dataByColumn[curr].map(function(d) {
            return d.textSize.width + d.size + d.symbolSpacer + gutterWidth;
        });
        memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
        return memo;
    }, []);
};
var getRowHeights = function getRowHeights(props, data) {
    var gutter = props.rowGutter || {};
    var gutterHeight = (typeof gutter === "undefined" ? "undefined" : (0, _typeOf._)(gutter)) === "object" ? (gutter.top || 0) + (gutter.bottom || 0) : gutter || 0;
    var dataByRow = (0, _groupByDefault.default)(data, "row");
    return (0, _keysDefault.default)(dataByRow).reduce(function(memo, curr, index) {
        var rows = dataByRow[curr];
        var lengths = rows.map(function(d) {
            return d.textSize.height + d.symbolSpacer + gutterHeight;
        });
        memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
        return memo;
    }, []);
};
var getTitleDimensions = function getTitleDimensions(props) {
    var style = props.style && props.style.title || {};
    var textSize = (0, _victoryCore.TextSize).approximateTextSize(props.title, style);
    var padding = style.padding || 0;
    return {
        height: textSize.height + 2 * padding || 0,
        width: textSize.width + 2 * padding || 0
    };
};
var getOffset = function getOffset(datum, rowHeights, columnWidths) {
    var column = datum.column, row = datum.row;
    return {
        x: (0, _rangeDefault.default)(column).reduce(function(memo, curr) {
            memo += columnWidths[curr];
            return memo;
        }, 0),
        y: (0, _rangeDefault.default)(row).reduce(function(memo, curr) {
            memo += rowHeights[curr];
            return memo;
        }, 0)
    };
};
var getAnchors = function getAnchors(titleOrientation, centerTitle) {
    var standardAnchors = {
        textAnchor: titleOrientation === "right" ? "end" : "start",
        verticalAnchor: titleOrientation === "bottom" ? "end" : "start"
    };
    if (centerTitle) {
        var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
        return {
            textAnchor: horizontal ? "middle" : standardAnchors.textAnchor,
            verticalAnchor: horizontal ? standardAnchors.verticalAnchor : "middle"
        };
    } else return standardAnchors;
};
var getTitleStyle = function getTitleStyle(props) {
    var titleOrientation = props.titleOrientation, centerTitle = props.centerTitle, titleComponent = props.titleComponent;
    var baseStyle = props.style && props.style.title || {};
    var componentStyle = titleComponent.props && titleComponent.props.style || {};
    var anchors = getAnchors(titleOrientation, centerTitle);
    return Array.isArray(componentStyle) ? componentStyle.map(function(obj) {
        return (0, _defaultsDefault.default)({}, obj, baseStyle, anchors);
    }) : (0, _defaultsDefault.default)({}, componentStyle, baseStyle, anchors);
}; // eslint-disable-next-line complexity
var getTitleProps = function getTitleProps(props, borderProps) {
    var title = props.title, titleOrientation = props.titleOrientation, centerTitle = props.centerTitle, borderPadding = props.borderPadding;
    var height = borderProps.height, width = borderProps.width;
    var style = getTitleStyle(props);
    var padding = Array.isArray(style) ? style[0].padding : style.padding;
    var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
    var xOrientation = titleOrientation === "bottom" ? "bottom" : "top";
    var yOrientation = titleOrientation === "right" ? "right" : "left";
    var standardPadding = {
        x: centerTitle ? width / 2 : borderPadding[xOrientation] + (padding || 0),
        y: centerTitle ? height / 2 : borderPadding[yOrientation] + (padding || 0)
    };
    var getPadding = function getPadding() {
        return borderPadding[titleOrientation] + (padding || 0);
    };
    var xOffset = horizontal ? standardPadding.x : getPadding();
    var yOffset = horizontal ? getPadding() : standardPadding.y;
    return {
        x: titleOrientation === "right" ? props.x + width - xOffset : props.x + xOffset,
        y: titleOrientation === "bottom" ? props.y + height - yOffset : props.y + yOffset,
        style: style,
        text: title
    };
};
var getBorderProps = function getBorderProps(props, contentHeight, contentWidth) {
    var x = props.x, y = props.y, borderPadding = props.borderPadding, style = props.style;
    var height = (contentHeight || 0) + borderPadding.top + borderPadding.bottom;
    var width = (contentWidth || 0) + borderPadding.left + borderPadding.right;
    return {
        x: x,
        y: y,
        height: height,
        width: width,
        style: (0, _assignDefault.default)({
            fill: "none"
        }, style.border)
    };
};
var getDimensions = function getDimensions(props, fallbackProps) {
    var modifiedProps = (0, _victoryCore.Helpers).modifyProps(props, fallbackProps, "legend");
    props = (0, _assignDefault.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
    var _props = props, title = _props.title, titleOrientation = _props.titleOrientation;
    var groupedData = groupData(props);
    var columnWidths = getColumnWidths(props, groupedData);
    var rowHeights = getRowHeights(props, groupedData);
    var titleDimensions = title ? getTitleDimensions(props) : {
        height: 0,
        width: 0
    };
    return {
        height: titleOrientation === "left" || titleOrientation === "right" ? Math.max((0, _sumDefault.default)(rowHeights), titleDimensions.height) : (0, _sumDefault.default)(rowHeights) + titleDimensions.height,
        width: titleOrientation === "left" || titleOrientation === "right" ? (0, _sumDefault.default)(columnWidths) + titleDimensions.width : Math.max((0, _sumDefault.default)(columnWidths), titleDimensions.width)
    };
};
var getBaseProps = function getBaseProps(props, fallbackProps) {
    var modifiedProps = (0, _victoryCore.Helpers).modifyProps(props, fallbackProps, "legend");
    props = (0, _assignDefault.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
    var _props2 = props, data = _props2.data, standalone = _props2.standalone, theme = _props2.theme, padding = _props2.padding, style = _props2.style, colorScale = _props2.colorScale, gutter = _props2.gutter, rowGutter = _props2.rowGutter, borderPadding = _props2.borderPadding, title = _props2.title, titleOrientation = _props2.titleOrientation, name = _props2.name, _props2$x = _props2.x, x = _props2$x === void 0 ? 0 : _props2$x, _props2$y = _props2.y, y = _props2$y === void 0 ? 0 : _props2$y;
    var groupedData = groupData(props);
    var columnWidths = getColumnWidths(props, groupedData);
    var rowHeights = getRowHeights(props, groupedData);
    var labelStyles = getLabelStyles(props);
    var titleDimensions = title ? getTitleDimensions(props) : {
        height: 0,
        width: 0
    };
    var titleOffset = {
        x: titleOrientation === "left" ? titleDimensions.width : 0,
        y: titleOrientation === "top" ? titleDimensions.height : 0
    };
    var gutterOffset = {
        x: gutter && (typeof gutter === "undefined" ? "undefined" : (0, _typeOf._)(gutter)) === "object" ? gutter.left || 0 : 0,
        y: rowGutter && (typeof rowGutter === "undefined" ? "undefined" : (0, _typeOf._)(rowGutter)) === "object" ? rowGutter.top || 0 : 0
    };
    var _getDimensions = getDimensions(props, fallbackProps), height = _getDimensions.height, width = _getDimensions.width;
    var borderProps = getBorderProps(props, height, width);
    var titleProps = getTitleProps(props, borderProps);
    var initialProps = {
        parent: {
            data: data,
            standalone: standalone,
            theme: theme,
            padding: padding,
            name: name,
            height: props.height,
            width: props.width,
            style: style.parent
        },
        all: {
            border: borderProps,
            title: titleProps
        }
    };
    return groupedData.reduce(function(childProps, datum, i) {
        var color = colorScale[i % colorScale.length];
        var dataStyle = (0, _defaultsDefault.default)({}, datum.symbol, style.data, {
            fill: color
        });
        var eventKey = !(0, _isNilDefault.default)(datum.eventKey) ? datum.eventKey : i;
        var offset = getOffset(datum, rowHeights, columnWidths);
        var originY = y + borderPadding.top + datum.symbolSpacer;
        var originX = x + borderPadding.left + datum.symbolSpacer;
        var dataProps = {
            index: i,
            data: data,
            datum: datum,
            symbol: dataStyle.type || dataStyle.symbol || "circle",
            size: datum.size,
            style: dataStyle,
            y: originY + offset.y + titleOffset.y + gutterOffset.y,
            x: originX + offset.x + titleOffset.x + gutterOffset.x
        };
        var labelProps = {
            datum: datum,
            data: data,
            text: datum.name,
            style: labelStyles[i],
            y: dataProps.y,
            x: dataProps.x + datum.symbolSpacer + datum.size / 2
        };
        childProps[eventKey] = {
            data: dataProps,
            labels: labelProps
        };
        return childProps;
    }, initialProps);
};

},{"@swc/helpers/_/_type_of":"668P4","lodash/isNil":"beGyX","lodash/range":"3wXYB","lodash/sum":"cGP1n","lodash/keys":"kLvI9","lodash/groupBy":"agwIt","lodash/assign":"xTxAt","lodash/defaults":"eWhnr","victory-core":"2Y5GL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGP1n":[function(require,module,exports,__globalThis) {
var baseSum = require("8241ee195ff63cba"), identity = require("d10ed43a5819425e");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function sum(array) {
    return array && array.length ? baseSum(array, identity) : 0;
}
module.exports = sum;

},{"8241ee195ff63cba":"cI0lk","d10ed43a5819425e":"6wIyV"}],"cI0lk":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = baseSum;

},{}],"1m0GW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _upsellCard = require("./UpsellCard");
var _upsellCardDefault = parcelHelpers.interopDefault(_upsellCard);
var _appState = require("../../AppState");
var UpsellCardContainer = function() {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 1), stateApp = _appState1[0];
    var targets = stateApp.portalCustomerMeta.tria_upsell_ads ? stateApp.portalCustomerMeta.tria_upsell_ads.split(',') : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: targets.map(function(target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upsellCardDefault.default), {
                target: target
            }, target);
        })
    });
};
exports.default = UpsellCardContainer;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","./UpsellCard":"fRETN","../../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fRETN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _reactstrap = require("reactstrap");
var _reactDeviceDetect = require("react-device-detect");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _feedService = require("../../services/FeedService");
var _feedServiceDefault = parcelHelpers.interopDefault(_feedService);
var UpsellCard = function(param) {
    var target = param.target;
    var _cardDetails_background, _cardDetails_background1, _cardDetails_background_image, _cardDetails_background2, _cardDetails_hero, _cardDetails_content, _cardDetails_content1, _cardDetails_content_button, _cardDetails_content2, _cardDetails_content_button1, _cardDetails_content3, _cardDetails_content_button2, _cardDetails_content4, _cardDetails_heading, _cardDetails_hero1, _cardDetails_hero_image, _cardDetails_hero2, _cardDetails_content5, _cardDetails_content6, _cardDetails_content_button3, _cardDetails_content7, _cardDetails_content_button4, _cardDetails_content8;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), cardDetails = _useState1[0], setCardDetails = _useState1[1];
    var imageBaseUrl = "".concat((0, _feedService.feed_api), "/upsells/").concat(target, "/");
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var resp, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            (0, _feedServiceDefault.default).loadUpsellCard(target, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        resp = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        setCardDetails(resp);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    if (!isLoading && !cardDetails) return null;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Card), {
        className: "card-chart card-home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
            className: "p-0 text-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-spinner m-3 mt-4 fa-spin",
                style: {
                    fontSize: 30
                }
            })
        })
    });
    var containerStyle = (0, _objectSpread._)({
        backgroundColor: (_cardDetails_background = cardDetails.background) === null || _cardDetails_background === void 0 ? void 0 : _cardDetails_background.color
    }, ((_cardDetails_background1 = cardDetails.background) === null || _cardDetails_background1 === void 0 ? void 0 : _cardDetails_background1.image) ? {
        backgroundImage: "url(".concat(imageBaseUrl, "background").concat((_cardDetails_background2 = cardDetails.background) === null || _cardDetails_background2 === void 0 ? void 0 : (_cardDetails_background_image = _cardDetails_background2.image) === null || _cardDetails_background_image === void 0 ? void 0 : _cardDetails_background_image.ext, ")")
    } : {});
    console.log('container style: ', containerStyle.backgroundImage);
    var textStyleFn = function(styleObj) {
        var _styleObj_font, _styleObj_font1, _styleObj_font2, _styleObj_font_styles, _styleObj_font3, _styleObj_font_styles1, _styleObj_font4;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            color: styleObj === null || styleObj === void 0 ? void 0 : styleObj.color
        }, !(0, _reactDeviceDetect.isMobile) && {
            textAlign: styleObj === null || styleObj === void 0 ? void 0 : styleObj.alignment
        }), {
            fontFamily: styleObj === null || styleObj === void 0 ? void 0 : (_styleObj_font = styleObj.font) === null || _styleObj_font === void 0 ? void 0 : _styleObj_font.family,
            fontSize: (styleObj === null || styleObj === void 0 ? void 0 : (_styleObj_font1 = styleObj.font) === null || _styleObj_font1 === void 0 ? void 0 : _styleObj_font1.size) * ((0, _reactDeviceDetect.isMobile) ? 0.8 : 1),
            lineHeight: "".concat((styleObj === null || styleObj === void 0 ? void 0 : (_styleObj_font2 = styleObj.font) === null || _styleObj_font2 === void 0 ? void 0 : _styleObj_font2.lineHeight) * ((0, _reactDeviceDetect.isMobile) ? 0.8 : 1), "px"),
            fontWeight: (styleObj === null || styleObj === void 0 ? void 0 : (_styleObj_font3 = styleObj.font) === null || _styleObj_font3 === void 0 ? void 0 : (_styleObj_font_styles = _styleObj_font3.styles) === null || _styleObj_font_styles === void 0 ? void 0 : _styleObj_font_styles.includes('bold')) ? 'bold' : 'normal',
            fontStyle: (styleObj === null || styleObj === void 0 ? void 0 : (_styleObj_font4 = styleObj.font) === null || _styleObj_font4 === void 0 ? void 0 : (_styleObj_font_styles1 = _styleObj_font4.styles) === null || _styleObj_font_styles1 === void 0 ? void 0 : _styleObj_font_styles1.includes('italic')) ? 'italic' : 'normal'
        });
    };
    var bodyClass = !(0, _reactDeviceDetect.isMobile) && ((_cardDetails_hero = cardDetails.hero) === null || _cardDetails_hero === void 0 ? void 0 : _cardDetails_hero.placement) === 'right' ? 'row-reverse' : '';
    var flexAlignmentMap = {
        left: 'flex-start',
        top: 'flex-start',
        center: 'center',
        right: 'flex-end',
        bottom: 'flex-end',
        fill: 'stretch'
    };
    var contentStyle = !(0, _reactDeviceDetect.isMobile) ? {
        flex: 1,
        justifyContent: flexAlignmentMap[(_cardDetails_content = cardDetails.content) === null || _cardDetails_content === void 0 ? void 0 : _cardDetails_content.alignment] || ((_cardDetails_content1 = cardDetails.content) === null || _cardDetails_content1 === void 0 ? void 0 : _cardDetails_content1.alignment)
    } : {};
    var buttonStyle = !(0, _reactDeviceDetect.isMobile) ? (0, _objectSpread._)({
        alignSelf: flexAlignmentMap[(_cardDetails_content2 = cardDetails.content) === null || _cardDetails_content2 === void 0 ? void 0 : (_cardDetails_content_button = _cardDetails_content2.button) === null || _cardDetails_content_button === void 0 ? void 0 : _cardDetails_content_button.position]
    }, ((_cardDetails_content3 = cardDetails.content) === null || _cardDetails_content3 === void 0 ? void 0 : (_cardDetails_content_button1 = _cardDetails_content3.button) === null || _cardDetails_content_button1 === void 0 ? void 0 : _cardDetails_content_button1.position) !== 'fill' && {
        width: (_cardDetails_content4 = cardDetails.content) === null || _cardDetails_content4 === void 0 ? void 0 : (_cardDetails_content_button2 = _cardDetails_content4.button) === null || _cardDetails_content_button2 === void 0 ? void 0 : _cardDetails_content_button2.width
    }) : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Card), {
        className: "card-chart card-home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
            className: "p-0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "upsell-card ".concat(!(0, _reactDeviceDetect.isMobile) ? 'desktop' : ''),
                style: containerStyle,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "title",
                        style: textStyleFn(cardDetails.heading),
                        children: (_cardDetails_heading = cardDetails.heading) === null || _cardDetails_heading === void 0 ? void 0 : _cardDetails_heading.text
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "body ".concat(bodyClass),
                        children: [
                            ((_cardDetails_hero1 = cardDetails.hero) === null || _cardDetails_hero1 === void 0 ? void 0 : _cardDetails_hero1.image) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "hero-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: "".concat(imageBaseUrl, "hero").concat((_cardDetails_hero2 = cardDetails.hero) === null || _cardDetails_hero2 === void 0 ? void 0 : (_cardDetails_hero_image = _cardDetails_hero2.image) === null || _cardDetails_hero_image === void 0 ? void 0 : _cardDetails_hero_image.ext),
                                    className: "hero",
                                    alt: "Upsell"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content",
                                style: contentStyle,
                                children: [
                                    (((_cardDetails_content5 = cardDetails.content) === null || _cardDetails_content5 === void 0 ? void 0 : _cardDetails_content5.descriptions) || []).map(function(d, i) {
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "description",
                                            style: textStyleFn(d),
                                            children: d.text
                                        }, i);
                                    }),
                                    ((_cardDetails_content6 = cardDetails.content) === null || _cardDetails_content6 === void 0 ? void 0 : _cardDetails_content6.button) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "btn btn-lg tria-btn tria-btn-blue action-btn",
                                        href: (_cardDetails_content7 = cardDetails.content) === null || _cardDetails_content7 === void 0 ? void 0 : (_cardDetails_content_button3 = _cardDetails_content7.button) === null || _cardDetails_content_button3 === void 0 ? void 0 : _cardDetails_content_button3.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, buttonStyle), {
                                            lineHeight: '10px'
                                        }),
                                        children: (_cardDetails_content8 = cardDetails.content) === null || _cardDetails_content8 === void 0 ? void 0 : (_cardDetails_content_button4 = _cardDetails_content8.button) === null || _cardDetails_content_button4 === void 0 ? void 0 : _cardDetails_content_button4.title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
UpsellCard.propTypes = {
    target: (0, _propTypesDefault.default).string
};
exports.default = UpsellCard;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","axios":"ebRwi","reactstrap":"774RE","react-device-detect":"h7vq0","../../utility/use-async-effect":"fShZN","../../services/FeedService":"6gczS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gczS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "feed_api", function() {
    return feed_api;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var feed_api = 'https://feed.tria.connectria.com';
var FeedService = {
    loadUpsellCard: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(target) {
            var options, resp, error;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(feed_api, "/upsell/").concat(target, "/index.json"), options)
                        ];
                    case 2:
                        resp = _state.sent();
                        return [
                            2,
                            resp.data.frontmatter
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(target) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = FeedService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"93GaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _startCase = require("lodash/startCase");
var _startCaseDefault = parcelHelpers.interopDefault(_startCase);
var _triaCard = require("../Cards/TriaCard");
var _componnents = require("../Notifications/componnents");
var _resourcesService = require("../../services/ResourcesService");
var _resourcesServiceDefault = parcelHelpers.interopDefault(_resourcesService);
var _ibmservice = require("../../services/IBMService");
var _ibmserviceDefault = parcelHelpers.interopDefault(_ibmservice);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _appState = require("../../AppState");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _enumJs = require("../../utility/enum.js");
var _enumJsDefault = parcelHelpers.interopDefault(_enumJs);
var _rbacHOC = require("../RBAC/RbacHOC");
var cloudTypeNameMapping = {
    aws: 'AWS',
    azure: 'Azure',
    gcp: 'Google Cloud',
    vmware: 'VMWare',
    k8s: 'Kubernetes',
    ibmi: 'IBMi'
};
var cloudTypeRouteMapping = {
    aws: '/app/resource-management',
    azure: '/app/resource-management',
    vmware: '/app/resource-management',
    ibmi: '/app/ibm-dashboard'
};
var ResourcesOverview = function(props) {
    var history = (0, _reactRouterDom.useHistory)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), clouds = _useState[0], setClouds = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var cloudsResult, overviewResult, error, devicesResult, error1, _hostsResult_data, _hostsResult_data1, hostsResult, error2;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isMounted()) return [
                            2
                        ];
                        setLoading(true);
                        cloudsResult = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _resourcesServiceDefault.default).getOverview(source.token)
                        ];
                    case 2:
                        overviewResult = _state.sent();
                        cloudsResult = (Array.isArray(overviewResult) ? overviewResult : []).filter(function(c) {
                            return !!c.cloud_type;
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAllDeviceCount({}, {
                                cancelToken: source.token
                            })
                        ];
                    case 5:
                        devicesResult = _state.sent();
                        cloudsResult.push({
                            cloud_type: 'vmware',
                            compute: ((devicesResult === null || devicesResult === void 0 ? void 0 : devicesResult.devices) || [])[0] || 0,
                            total: ((devicesResult === null || devicesResult === void 0 ? void 0 : devicesResult.devices) || [])[0] || 0
                        });
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error1 = _state.sent();
                        console.log(error1);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        if (!stateApp.clouds.includes((0, _enumJsDefault.default).CloudCategory.IBMI)) return [
                            3,
                            11
                        ];
                        _state.label = 8;
                    case 8:
                        _state.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4,
                            (0, _ibmserviceDefault.default).hosts({
                                cancelToken: source.token
                            })
                        ];
                    case 9:
                        hostsResult = _state.sent();
                        cloudsResult.push({
                            cloud_type: 'ibmi',
                            compute: ((_hostsResult_data = hostsResult.data) === null || _hostsResult_data === void 0 ? void 0 : _hostsResult_data.length) || 0,
                            total: ((_hostsResult_data1 = hostsResult.data) === null || _hostsResult_data1 === void 0 ? void 0 : _hostsResult_data1.length) || 0
                        });
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error2 = _state.sent();
                        console.log(error2);
                        return [
                            3,
                            11
                        ];
                    case 11:
                        cloudsResult = cloudsResult.filter(function(item) {
                            // Extract keys except for cloud_type
                            var keys = Object.keys(item).filter(function(key) {
                                return key !== "cloud_type";
                            });
                            // Check if every property except cloud_type is 0
                            return !keys.every(function(key) {
                                return item[key] === 0;
                            });
                        });
                        setClouds(cloudsResult);
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        return source.cancel();
    }, [
        stateApp.clouds
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "RESOURCE OVERVIEW"
                }),
                loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-spinner fa-spin tria-icon large ml-3",
                    style: {
                        verticalAlign: 'middle'
                    }
                })
            ]
        }),
        className: "mb-3",
        bodyClassName: "px-lg-4 pt-0",
        titleClassName: "mb-0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "mb-2",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "table tria-table compact-header white table-indent",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor",
                                    children: "CLOUD"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "COMPUTE"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "STORAGE"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "NETWORK"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "CONTAINERS"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "IDENTITY"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "OTHER"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "cursor text-center",
                                    children: "TOTAL"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: clouds === null || clouds === void 0 ? void 0 : clouds.map(function(cloud) {
                            var navRoute = cloudTypeRouteMapping[cloud.cloud_type];
                            if (navRoute != null) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                className: "hovered cursor",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componnents.CloudLogo), {
                                                    type: cloud.cloud_type,
                                                    size: "sm"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "roboto-15 text-dark font-weight-normal ml-2 mb-0",
                                                    children: cloudTypeNameMapping[cloud.cloud_type] || (0, _startCaseDefault.default)(cloud.cloud_type)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.compute || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.storage || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.network || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.container || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.identity || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.other || 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            to: navRoute,
                                            className: "encode-sans-15 text-blue",
                                            children: cloud.total || 0
                                        })
                                    })
                                ]
                            }, cloud.cloud_type);
                        })
                    })
                ]
            })
        })
    });
};
exports.default = ResourcesOverview;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","axios":"ebRwi","lodash/startCase":"1nhSn","../Cards/TriaCard":"9XO2Y","../Notifications/componnents":"icHxk","../../services/ResourcesService":"gQb5w","../../services/IBMService":"1UpC4","../../services/ConnectriaTicketsService":"l5X0I","../../AppState":"8UGXH","../../utility/use-async-effect":"fShZN","../../utility/enum.js":"3A9fW","../RBAC/RbacHOC":"1LDrg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nhSn":[function(require,module,exports,__globalThis) {
var createCompounder = require("f10c909a79ea4596"), upperFirst = require("2ac04918aee4665e");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var startCase = createCompounder(function(result, word, index) {
    return result + (index ? ' ' : '') + upperFirst(word);
});
module.exports = startCase;

},{"f10c909a79ea4596":"3pq26","2ac04918aee4665e":"8ljuM"}],"3pq26":[function(require,module,exports,__globalThis) {
var arrayReduce = require("cfc95c8ee08dfd6b"), deburr = require("b60ce6efa81a3cef"), words = require("40ddea9252aefad9");
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    };
}
module.exports = createCompounder;

},{"cfc95c8ee08dfd6b":"bEGfj","b60ce6efa81a3cef":"hfdYZ","40ddea9252aefad9":"9cLXy"}],"bEGfj":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"hfdYZ":[function(require,module,exports,__globalThis) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = '[' + rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
module.exports = deburr;

},{"86c70dfa448b37ae":"l6pcw","f68583105b85d455":"23Zly"}],"l6pcw":[function(require,module,exports,__globalThis) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"gHP3m"}],"gHP3m":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"9cLXy":[function(require,module,exports,__globalThis) {
var asciiWords = require("14a2bcc60f9c8c58"), hasUnicodeWord = require("12a5a56673332993"), toString = require("efbc56b55844c665"), unicodeWords = require("e27193a0a134859e");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = words;

},{"14a2bcc60f9c8c58":"2ttwo","12a5a56673332993":"ixhS6","efbc56b55844c665":"23Zly","e27193a0a134859e":"8Be4W"}],"2ttwo":[function(require,module,exports,__globalThis) {
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;

},{}],"ixhS6":[function(require,module,exports,__globalThis) {
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
module.exports = hasUnicodeWord;

},{}],"8Be4W":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
        rsBreak,
        rsUpper,
        '$'
    ].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
        rsBreak,
        rsUpper + rsMiscLower,
        '$'
    ].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
module.exports = unicodeWords;

},{}],"8ljuM":[function(require,module,exports,__globalThis) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst('toUpperCase');
module.exports = upperFirst;

},{"9f71ec962d19127":"driRS"}],"driRS":[function(require,module,exports,__globalThis) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"lThjH","e28707473345265":"9QNhN","32980b84821a53a0":"8X6PW","e00796f8e204e98":"23Zly"}],"lThjH":[function(require,module,exports,__globalThis) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"huYjQ"}],"huYjQ":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"9QNhN":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"8X6PW":[function(require,module,exports,__globalThis) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"1agc8","d3e31b390208b2ca":"9QNhN","2a468ebcd49732b9":"grXjJ"}],"1agc8":[function(require,module,exports,__globalThis) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;

},{}],"grXjJ":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"9XO2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TriaCard", function() {
    return TriaCard;
});
parcelHelpers.export(exports, "CardFieldValue", function() {
    return CardFieldValue;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var TriaCard = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: props.id || "",
        className: "tria-card " + (props.className || ""),
        style: (0, _objectSpread._)({}, props.style || null),
        onClick: props.onClick || null,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tria-card-header " + (props.headerClassName || ""),
                style: (0, _objectSpread._)({}, props.headerStyle || null),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "tria-card-title d-flex flex-wrap " + (props.titleClassName || ""),
                    style: (0, _objectSpread._)({}, props.titleStyle || null),
                    children: [
                        props.title || "",
                        props.sideButton || /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fal fa-ellipsis-h align-self-start my-auto ml-auto cursor tria-card-ellipsis"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tria-card-body " + (props.bodyClassName || ""),
                style: (0, _objectSpread._)({}, props.bodyStyle || null),
                children: props.children
            }),
            props.footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tria-card-footer " + (props.footerClassName || ""),
                style: (0, _objectSpread._)({}, props.footerStyle || null),
                children: props.footer
            })
        ]
    });
};
var CardFieldValue = function(param) {
    var field = param.field, fieldClassName = param.fieldClassName, value = param.value, valueClassName = param.valueClassName, valueStyle = param.valueStyle, defaultValue = param.defaultValue, id = param.id, tooltip = param.tooltip;
    var sanitizeValue = function(value) {
        if (value === 'n/a') return defaultValue || '';
        if (typeof value === 'string') return value.replace(/\\n/g, '\n');
        if (Array.isArray(value) && value.length > 0 && (typeof value[0] === 'string' || typeof value[0] === 'number')) return value.join(', ');
        return value;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "card-field-value d-flex mb-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-md-4 col-lg-5 p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    id: id,
                    className: (0, _classnamesDefault.default)('field-label', fieldClassName),
                    children: field
                })
            }),
            id && tooltip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                placement: "right",
                target: id,
                children: tooltip || value || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-md-8 col-lg-7 p-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)('field-value', valueClassName),
                    style: valueStyle || {},
                    children: sanitizeValue(value)
                })
            })
        ]
    });
};
CardFieldValue.propTypes = {
    field: (0, _propTypesDefault.default).node,
    fieldClassName: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).node,
    valueClassName: (0, _propTypesDefault.default).string,
    defaultValue: (0, _propTypesDefault.default).node,
    id: (0, _propTypesDefault.default).string,
    tooltip: (0, _propTypesDefault.default).string
};

},{"@swc/helpers/_/_object_spread":"awG4j","react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","reactstrap":"774RE","classnames":"6P5cq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icHxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloudIcons", function() {
    return cloudIcons;
});
parcelHelpers.export(exports, "CloudLogo", function() {
    return CloudLogo;
});
parcelHelpers.export(exports, "AlertStatus", function() {
    return AlertStatus;
});
parcelHelpers.export(exports, "AlertSymbol", function() {
    return AlertSymbol;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _snakeCase = require("lodash/snakeCase");
var _snakeCaseDefault = parcelHelpers.interopDefault(_snakeCase);
var _ibmiSvg = require("../../assets/img/IBMi.svg");
var _ibmiSvgDefault = parcelHelpers.interopDefault(_ibmiSvg);
var _connectriaLogoCPng = require("../../assets/img/connectria-logo-c.png");
var _connectriaLogoCPngDefault = parcelHelpers.interopDefault(_connectriaLogoCPng);
var _cloudIconMapping = require("../../utility/cloudIconMapping");
var cloudIcons = {
    aws: (0, _cloudIconMapping.cloudIconMapping)['aws'],
    azure: (0, _cloudIconMapping.cloudIconMapping)['azure_arm'],
    gcp: (0, _cloudIconMapping.cloudIconMapping)['gce'],
    kubernetes: (0, _cloudIconMapping.cloudIconMapping)['k8s'],
    k8s: (0, _cloudIconMapping.cloudIconMapping)['k8s'],
    vmware: (0, _cloudIconMapping.cloudIconMapping)['vmware_vsphere'],
    ibmi: (0, _ibmiSvgDefault.default),
    connectria: (0, _connectriaLogoCPngDefault.default),
    all: (0, _connectriaLogoCPngDefault.default)
};
var alertIcons = {
    critical_error: 'far fa-engine-warning',
    critical_warning: 'far fa-siren-on',
    alert: 'far fa-clipboard-list-check',
    important_alert: 'far fa-exclamation-triangle',
    non_critical_event: 'fas fa-bolt',
    automation_event: 'far fa-magic',
    resolved: 'far fa-check',
    default: 'far fa-bell-exclamation'
};
var CloudLogo = function(param) {
    var type = param.type, size = param.size;
    var iconSize = 45;
    switch(size){
        case 'sm':
            iconSize = 30;
            break;
        case 'xs':
            iconSize = 24;
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: cloudIcons[type],
        alt: type,
        height: iconSize
    });
};
CloudLogo.propTypes = {
    type: (0, _propTypesDefault.default).string.isRequired,
    size: (0, _propTypesDefault.default).string
};
var AlertStatus = function(param) {
    var status = param.status, label = param.label, size = param.size;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-inline-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "\n        ".concat(status === 'resolved' ? 'far fa-check' : 'fas fa-circle', "\n        ").concat(status === 'awaiting_your_input' ? 'text-red' : status === 'in_progress' ? 'text-header' : 'text-blue', "\n        tria-icon ").concat(size || '', " text-blue mr-2 mr-lg-3\n      ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "encode-sans-15 text-capitalize text-header",
                children: label
            })
        ]
    });
};
AlertStatus.propTypes = {
    status: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).string
};
AlertStatus.defaultProps = {
    size: 'small'
};
var AlertSymbol = function(param) {
    var icon = param.icon, category = param.category, label = param.label, className = param.className, dense = param.dense;
    var iconBgColor = 'light-gray';
    var iconColor = null;
    var iconBadgeColor = 'text-blue';
    var categoryStr = (0, _snakeCaseDefault.default)(category);
    if (categoryStr === 'critical_error' || categoryStr === 'critical_alert') iconBgColor = 'red';
    else if (categoryStr === 'important_alert') iconBgColor = 'blue';
    if (categoryStr === 'critical_warning' || categoryStr === 'alert') iconColor = 'red';
    else if (categoryStr === 'non_critical_event' || categoryStr === 'resolved') iconColor = 'blue';
    if (categoryStr.startsWith('critical') || categoryStr === 'alert') iconBadgeColor = 'text-red';
    else if (categoryStr === 'automation_event') iconBadgeColor = 'text-header';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-inline-flex align-items-center ".concat(className || ''),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-inline-block position-relative",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "status-icon-token",
                        sz: "sm",
                        color: iconBgColor,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", (0, _objectSpread._)({
                            className: "".concat(icon || alertIcons[categoryStr] || alertIcons.default, " status-icon")
                        }, iconColor ? {
                            color: iconColor
                        } : {}))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-circle tria-icon xs position-absolute ".concat(iconBadgeColor)
                    })
                ]
            }),
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "ml-2 ml-lg-3 ".concat(dense ? 'encode-sans-12 text-header text-uppercase' : 'encode-sans-15'),
                children: label
            })
        ]
    });
};
AlertSymbol.propTypes = {
    icon: (0, _propTypesDefault.default).string,
    category: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    dense: (0, _propTypesDefault.default).bool
};
AlertSymbol.defaultProps = {
    dense: false
};

},{"@swc/helpers/_/_object_spread":"awG4j","react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","lodash/snakeCase":"6nVSV","../../assets/img/IBMi.svg":"7VUsQ","../../assets/img/connectria-logo-c.png":"kkavH","../../utility/cloudIconMapping":"FuebL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6nVSV":[function(require,module,exports,__globalThis) {
var createCompounder = require("ef91f217da7929bd");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var snakeCase = createCompounder(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
module.exports = snakeCase;

},{"ef91f217da7929bd":"3pq26"}],"7VUsQ":[function(require,module,exports,__globalThis) {
module.exports = require("acee6afa2404945").getBundleURL('hmjwG') + "IBMi.1bcde794.svg";

},{"acee6afa2404945":"fGflc"}],"kkavH":[function(require,module,exports,__globalThis) {
module.exports = require("3874639fce3497b7").getBundleURL('hmjwG') + "connectria-logo-c.237aabf7.png";

},{"3874639fce3497b7":"fGflc"}],"FuebL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloudIconMapping", function() {
    return cloudIconMapping;
});
var _awsLogoPng = require("../assets/img/icons/clouds/aws-logo.png");
var _awsLogoPngDefault = parcelHelpers.interopDefault(_awsLogoPng);
var _awsGovLogoPng = require("../assets/img/icons/clouds/aws_gov-logo.png");
var _awsGovLogoPngDefault = parcelHelpers.interopDefault(_awsGovLogoPng);
var _azureArmLogoPng = require("../assets/img/icons/clouds/azure_arm-logo.png");
var _azureArmLogoPngDefault = parcelHelpers.interopDefault(_azureArmLogoPng);
var _gceLogoPng = require("../assets/img/icons/clouds/gce-logo.png");
var _gceLogoPngDefault = parcelHelpers.interopDefault(_gceLogoPng);
var _ibmIPng = require("../assets/img/icons/clouds/IBM_i.png");
var _ibmIPngDefault = parcelHelpers.interopDefault(_ibmIPng);
var _k8SLogoPng = require("../assets/img/icons/clouds/k8s-logo.png");
var _k8SLogoPngDefault = parcelHelpers.interopDefault(_k8SLogoPng);
var _vmwareVsphereLogoPng = require("../assets/img/icons/clouds/vmware_vsphere-logo.png");
var _vmwareVsphereLogoPngDefault = parcelHelpers.interopDefault(_vmwareVsphereLogoPng);
var cloudIconMapping = {
    'aws': (0, _awsLogoPngDefault.default),
    'azure': (0, _azureArmLogoPngDefault.default),
    'azure_arm': (0, _azureArmLogoPngDefault.default),
    'aws_gov': (0, _awsGovLogoPngDefault.default),
    'gce': (0, _gceLogoPngDefault.default),
    'ibmi': (0, _ibmIPngDefault.default),
    'k8s': (0, _k8SLogoPngDefault.default),
    'vmware_vsphere': (0, _vmwareVsphereLogoPngDefault.default)
};

},{"../assets/img/icons/clouds/aws-logo.png":"k3GYK","../assets/img/icons/clouds/aws_gov-logo.png":"k2p6O","../assets/img/icons/clouds/azure_arm-logo.png":"3JOYh","../assets/img/icons/clouds/gce-logo.png":"aMePj","../assets/img/icons/clouds/IBM_i.png":"lyN9Y","../assets/img/icons/clouds/k8s-logo.png":"cShEd","../assets/img/icons/clouds/vmware_vsphere-logo.png":"4HO1D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k3GYK":[function(require,module,exports,__globalThis) {
module.exports = require("7e84c73731f1d86c").getBundleURL('hmjwG') + "aws-logo.9b34d3da.png";

},{"7e84c73731f1d86c":"fGflc"}],"k2p6O":[function(require,module,exports,__globalThis) {
module.exports = require("6da036c84984ae6f").getBundleURL('hmjwG') + "aws_gov-logo.74a59d52.png";

},{"6da036c84984ae6f":"fGflc"}],"3JOYh":[function(require,module,exports,__globalThis) {
module.exports = require("bf0553e3e39983d9").getBundleURL('hmjwG') + "azure_arm-logo.987077d6.png";

},{"bf0553e3e39983d9":"fGflc"}],"aMePj":[function(require,module,exports,__globalThis) {
module.exports = require("13f569cae466e07f").getBundleURL('hmjwG') + "gce-logo.562570c9.png";

},{"13f569cae466e07f":"fGflc"}],"lyN9Y":[function(require,module,exports,__globalThis) {
module.exports = require("2f0a1ec5c0a61070").getBundleURL('hmjwG') + "IBM_i.c69401d6.png";

},{"2f0a1ec5c0a61070":"fGflc"}],"cShEd":[function(require,module,exports,__globalThis) {
module.exports = require("7a1f4a1797b09583").getBundleURL('hmjwG') + "k8s-logo.723aeb15.png";

},{"7a1f4a1797b09583":"fGflc"}],"4HO1D":[function(require,module,exports,__globalThis) {
module.exports = require("a4a0fa9776ecbdff").getBundleURL('hmjwG') + "vmware_vsphere-logo.86c962ec.png";

},{"a4a0fa9776ecbdff":"fGflc"}],"gQb5w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _cookieService = require("./CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var resources_api = 'https://u8v3tg4h98.execute-api.us-east-1.amazonaws.com/prod';
var ResourcesService = {
    elasticSearchResources: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filterParams, cancelToken) {
            var idToken, response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hit;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/es/resources"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, filterParams),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = response.data.hits[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                hit = _step.value;
                                hit.resource_type = hit.resource_type == "docdb" ? "rds" : hit.resource_type;
                                hit.service = hit.service == "docdb" ? "rds" : hit.service;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return [
                            2,
                            response.data
                        ];
                }
            });
        });
        return function(filterParams, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    elasticSearchResourceCounts: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filterParams, cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/es/resources/counts"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, filterParams),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response.data
                        ];
                }
            });
        });
        return function(filterParams, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    exportEndpoint: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filterParams, cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/es/resources/export/get"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, filterParams),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response.data
                        ];
                }
            });
        });
        return function(filterParams, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    checkExportStatus: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(filename) {
            var params, idToken, response;
            var _arguments = arguments;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/es/resources/export/status"), (0, _objectSpread._)({
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId'),
                                    filename: filename
                                }
                            }, params))
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function(filename) {
            return _ref.apply(this, arguments);
        };
    }(),
    getOverview: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/stats/overview"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                },
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.errors.length > 0) {
                            console.log(response.data.errors);
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            2,
                            response.data.data || []
                        ];
                }
            });
        });
        return function(cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    getClouds: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/stats/clouds"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                },
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.errors.length > 0) {
                            console.log(response.data.errors);
                            return [
                                2,
                                []
                            ];
                        }
                        return [
                            2,
                            response.data.data || []
                        ];
                }
            });
        });
        return function(cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    getResourceCategories: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params, cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/stats/categories"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, params),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.data) {
                            console.log('resource catgory response: ', response.data.data);
                            return [
                                2,
                                response.data.data
                            ];
                        }
                        return [
                            2,
                            {}
                        ];
                }
            });
        });
        return function(params, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    getFilterOptions: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params, cancelToken) {
            var _response_data, idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/stats/options"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, params),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            ((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) || {}
                        ];
                }
            });
        });
        return function(params, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    getResources: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params, cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/resources"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, params),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response.data || {}
                        ];
                }
            });
        });
        return function(params, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    getResourceDetail: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(resourceId, cancelToken) {
            var idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/resource/").concat(resourceId), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: {
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                },
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.data.data) return [
                            2,
                            response.data.data
                        ];
                        return [
                            2,
                            {}
                        ];
                }
            });
        });
        return function(resourceId, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    exportResources: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params, cancelToken) {
            var _response_data, idToken, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        idToken = _state.sent();
                        return [
                            4,
                            (0, _axiosDefault.default).get("".concat(resources_api, "/export"), {
                                headers: {
                                    Authorization: idToken
                                },
                                params: (0, _objectSpread._)({
                                    org_id: (0, _cookieServiceDefault.default).getCookie('OrganizationId')
                                }, params),
                                cancelToken: cancelToken
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            ((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) || null
                        ];
                }
            });
        });
        return function(params, cancelToken) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = ResourcesService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","./CookieService":"iKLPT","../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1LDrg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withRole", function() {
    return withRole;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../../AppState");
var withRole = function(roles) {
    return function(Component) {
        return function(props) {
            var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
            console.log(stateApp);
            var userRoles = stateApp.roles;
            var userHasPermission = false;
            if (stateApp.superAdmin) userHasPermission = true;
            else {
                console.log("here are our roles that must be present");
                console.log(roles);
            }
            if (userHasPermission) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpread._)({}, props));
            return null;
        };
    };
};

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","../../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5vECt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackupSingleJob", function() {
    return BackupSingleJob;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../../AppState");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _connectriaBackupService = require("../../services/ConnectriaBackupService");
var _connectriaBackupServiceDefault = parcelHelpers.interopDefault(_connectriaBackupService);
// reactstrap components
var _reactstrap = require("reactstrap");
var _newTabComponent = require("../../utility/NewTabComponent");
var _reactRouterDom = require("react-router-dom");
var _allJobsReusable = require("./AllJobsReusable");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _newTicketButton = require("../SupportAndTicketing/NewTicketButton");
var _newTicketButtonDefault = parcelHelpers.interopDefault(_newTicketButton);
var BackupSingleJob = function(props) {
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), singleJob = _useState[0], setSingleJob = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), IsLoadingSubClient = _useState2[0], setIsLoadingSubClient = _useState2[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    function formatBytes(bytes) {
        var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        if (bytes === 0) return '0 Bytes';
        var k = 1024;
        var dm = decimals < 0 ? 0 : decimals;
        var sizes = [
            'Bytes',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    function showItemBlade(job, stateApp, stateAppActions) {
        return _showItemBlade.apply(this, arguments);
    }
    function _showItemBlade() {
        _showItemBlade = (0, _asyncToGenerator._)(function(job, stateApp, stateAppActions) {
            var details, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _connectriaBackupServiceDefault.default).getCommServeSubclientDetails(job['subclientId'], {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        details = _state.sent();
                        data = details['data']['subClientProperties'].map(function(client) {
                            var clientContent = client['content'] || client['vmContent']['children'];
                            return clientContent.map(function(c) {
                                return c.hasOwnProperty('mssqlDbContent') ? c['mssqlDbContent']['databaseName'] : c['displayName'];
                            });
                        }).flat();
                        stateAppActions.setBlade({
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    "#SubClient Name: ",
                                    job['subclientName']
                                ]
                            }),
                            visible: true,
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "table-responsive-sm",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: "Contents"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                                        className: "table table-hover",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                            children: data[0] ? data.map(function(item, index) {
                                                console.log(item);
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                        children: item
                                                    })
                                                }, index);
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                    children: "No Contents found"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _showItemBlade.apply(this, arguments);
    }
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var details, data, dataKey, uiData, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        console.log("loading single job" + props.match.params.id);
                        console.log(props.match.params.id);
                        document.title = "Job ID#" + props.match.params.id;
                        stateAppActions.setPageBackTitle(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: "/app/backup",
                            className: "text-primary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-left mr-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Backup Jobs"
                                })
                            ]
                        }));
                        setIsLoading(true);
                        return [
                            4,
                            (0, _connectriaBackupServiceDefault.default).getCommServeJobDetails(props.match.params.id, {
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        details = _state.sent();
                        data = details['data']['job']['jobDetail'];
                        dataKey = '';
                        uiData = {};
                        //if job is running there is no detailInfo key , instead data has progessInfo
                        props.match.params.status.toLowerCase() === 'running' ? dataKey = 'progressInfo' : dataKey = 'detailInfo';
                        uiData['sizeOfApplication'] = data[dataKey]['sizeOfApplication'];
                        uiData['appName'] = data['generalInfo']['subclient']['appName'];
                        uiData['failures'] = data[dataKey]['failures'];
                        uiData['transferTime'] = data[dataKey]['transferTime'];
                        uiData['dataWritten'] = data[dataKey]['dataWritten'];
                        uiData['throughPut'] = data[dataKey]['throughPut'] + 'GB/hr';
                        uiData['encrypted'] = data['generalInfo']['encrypted'];
                        uiData['jobStartedFrom'] = data['generalInfo']['jobStartedFrom'];
                        uiData['status'] = data['progressInfo']['state'];
                        uiData['status'].toLowerCase().indexOf('error') > -1 ? uiData['errorInJob'] = true : uiData['errorInJob'] = false;
                        uiData['subclientName'] = data['generalInfo']['subclient']['subclientName'];
                        uiData['destClientId'] = data['generalInfo']['subclient']['clientId'];
                        uiData['destClientName'] = data['generalInfo']['subclient']['clientName'];
                        uiData['subclientId'] = data['generalInfo']['subclient']['subclientId'];
                        uiData['startTime'] = data[dataKey]['startTime'];
                        uiData['endTime'] = data[dataKey]['endTime'];
                        setSingleJob(uiData);
                        stateAppActions.setPageBackTitle(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: "/app/view/backup/jobs/client/".concat(uiData['destClientId']),
                            className: "text-primary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-left mr-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Backup Jobs"
                                })
                            ]
                        }));
                        if (!isMounted()) return [
                            2
                        ];
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) console.log(error);
                        else console.log(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "row justify-content-center mt-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "col-lg-12",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                className: "card-minimal",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                        className: "card-header-minimal mb-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardTitle), {
                            className: "card-title-minimal",
                            tag: "h3",
                            style: {
                                fontSize: "2rem"
                            },
                            children: [
                                "Job ID#: ",
                                props.match.params.id
                            ]
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-spinner m-3 mt-4 fa-spin",
                            style: {
                                fontSize: "30px"
                            }
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "table-responsive-sm",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                            className: "table table-hover",
                            id: "csDetails",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Job Start Time:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['startTime'] > 0 ? (0, _momentDefault.default)(singleJob['startTime'], 'X').format('lll') : "N/A"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Job End Time:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['endTime'] > 0 ? (0, _momentDefault.default)(singleJob['endTime'], 'X').format('lll') : "N/A"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Size of Application:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: formatBytes(parseInt(singleJob['sizeOfApplication']))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Agent:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['appName']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Failures:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['failures']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Transfer Time:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['transferTime']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Data Written:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: formatBytes(parseInt(singleJob['dataWritten']))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Average Throughput:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['throughPut']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Status:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-weight-bold",
                                                        children: singleJob['status']
                                                    }),
                                                    singleJob['errorInJob'] ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newTicketButtonDefault.default), {
                                                        className: "connectria-tickets-inbox-btn my-1",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                            className: "fas fa-plus",
                                                            id: "inbox-new-ticket-button"
                                                        })
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {})
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Source Client computer:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['destClientName']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Subclient:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: function(e) {
                                                        return showItemBlade(singleJob, stateApp, stateAppActions);
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-weight-bold",
                                                        children: singleJob['subclientName']
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Encryption Enabled:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['encrypted']
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: "Job Started From:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-weight-bold",
                                                    children: singleJob['jobStartedFrom']
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../../AppState":"8UGXH","../../utility/use-async-effect":"fShZN","axios":"ebRwi","../../services/ConnectriaBackupService":"l48ci","reactstrap":"774RE","../../utility/NewTabComponent":"eZnaG","react-router-dom":"acq4R","./AllJobsReusable":"6JnXO","moment":"3xZWN","../SupportAndTicketing/NewTicketButton":"2b9d2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eZnaG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewTabComponent", function() {
    return NewTabComponent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _appState = require("../AppState");
var NewTabComponent = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var value = props.value, tooltipMessage = props.tooltipMessage, alertMessage = props.alertMessage, idx = props.idx, className = props.className, style = props.style;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), tooltipOpen = _useState[0], setTooltipOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(tooltipMessage), 2), text = _useState1[0], setText = _useState1[1];
    var toggle = function() {
        setTooltipOpen(!tooltipOpen);
        // When hovering off of tooltip, reset the message
        if (!tooltipOpen) setText(tooltipMessage);
    };
    var openNewTab = function(e) {
        e.preventDefault();
        window.open(props.link, "_blank");
        e.stopPropagation();
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        onClick: function(e) {
            return openNewTab(e);
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas clickable fa-external-link-alt cursor pt-1 pl-1" + (className ? className : ""),
                id: "TooltipExample" + (idx + 1 ? idx : ""),
                style: (0, _objectSpread._)({
                    fontSize: "0.9rem"
                }, style)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Tooltip), {
                placement: "right",
                target: "TooltipExample" + (idx + 1 ? idx : ""),
                isOpen: tooltipOpen,
                toggle: toggle,
                style: {
                    backgroundColor: "black",
                    color: "white"
                },
                children: text
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","reactstrap":"774RE","../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6JnXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AllJobsReusable", function() {
    return AllJobsReusable;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
// reactstrap components
var _reactstrap = require("reactstrap");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _ramda = require("ramda");
var _newTabComponent = require("../../utility/NewTabComponent");
var AllJobsReusable = function(props) {
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(1), 2), currentPage = _useState[0], setCurrentPage = _useState[1];
    var history = (0, _reactRouterDom.useHistory)();
    var handleClick = function(e, index) {
        e.preventDefault();
        setCurrentPage(index);
    };
    var convertSecToMinutes = function(value) {
        return Math.floor(value / 60) + ":" + (value % 60 ? value % 60 : '00');
    };
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            return (0, _tsGenerator._)(this, function(_state) {
                try {
                    if (!isMounted()) return [
                        2
                    ];
                } catch (error) {
                    if ((0, _axiosDefault.default).isCancel(error)) console.log(error);
                    else console.log(error);
                }
                return [
                    2
                ];
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "table-responsive-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "table table-hover",
                id: "csJobs",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "ID"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "JobType"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Backup Type"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Percent Completed"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Server"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Start Time"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Last Update"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Elapsed Time"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "End Time"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: props.allJobs.slice((currentPage - 1) * props.pageSize, currentPage * props.pageSize).map(function(job, index) {
                            // console.log(job)
                            var pathForJob = "/app/view/backup/job/".concat(job.jobSummary.jobId, "/").concat(job.jobSummary.status);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                className: "cursor",
                                role: "button",
                                onClick: function() {
                                    return history.push(pathForJob);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: job.jobSummary.jobId
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newTabComponent.NewTabComponent), {
                                                itemId: job.jobSummary.jobId,
                                                link: pathForJob,
                                                tooltipMessage: "Show Job In New Tab",
                                                alertMessage: ''
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.status
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.appTypeName
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.backupLevelName
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.percentComplete
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.destinationClient.displayName
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.jobStartTime > 0 ? (0, _momentDefault.default)(job.jobSummary.jobStartTime, 'X').format('lll') : "N/A"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.lastUpdateTime > 0 ? (0, _momentDefault.default)(job.jobSummary.lastUpdateTime, 'X').format('lll') : "N/A"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.jobElapsedTime > 0 ? convertSecToMinutes(job.jobSummary.jobElapsedTime) : "N/A"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: job.jobSummary.jobEndTime > 0 ? (0, _momentDefault.default)(job.jobSummary.jobEndTime, 'X').format('lll') : "N/A"
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pagination-wrapper mt-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Pagination), {
                    "aria-label": "Resource Spend",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                            disabled: currentPage <= 1,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                onClick: function(e) {
                                    return handleClick(e, currentPage - 1);
                                },
                                previous: true,
                                href: "#"
                            })
                        }),
                        (0, _ramda.range)(Math.max(1, Math.min(currentPage - 2, props.pagesCount - 4)), Math.min(props.pagesCount + 1, Math.max(6, currentPage + 3))).map(function(page, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                                active: page === currentPage,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                    onClick: function(e) {
                                        return handleClick(e, page);
                                    },
                                    href: "#",
                                    children: page
                                })
                            }, i);
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationItem), {
                            disabled: currentPage >= props.pagesCount - 1,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.PaginationLink), {
                                onClick: function(e) {
                                    return handleClick(e, currentPage + 1);
                                },
                                next: true,
                                href: "#"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","../../utility/use-async-effect":"fShZN","axios":"ebRwi","reactstrap":"774RE","moment":"3xZWN","ramda":"2pVIv","../../utility/NewTabComponent":"eZnaG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7zlom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeviceDetailPage", function() {
    return DeviceDetailPage;
});
parcelHelpers.export(exports, "AddMaintenanceWindowButton", function() {
    return AddMaintenanceWindowButton;
});
parcelHelpers.export(exports, "CustomerDescription", function() {
    return CustomerDescription;
});
parcelHelpers.export(exports, "EnvironmentTags", function() {
    return EnvironmentTags;
});
parcelHelpers.export(exports, "GaugeGrid", function() {
    return GaugeGrid;
});
parcelHelpers.export(exports, "MaintenanceWindowCard", function() {
    return MaintenanceWindowCard;
});
parcelHelpers.export(exports, "PollingDetails", function() {
    return PollingDetails;
});
parcelHelpers.export(exports, "VirtualMachineDetails", function() {
    return VirtualMachineDetails;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _appState = require("../../AppState");
var _solarwind = require("../../services/Solarwind");
var _solarwindDefault = parcelHelpers.interopDefault(_solarwind);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _reactstrap = require("reactstrap");
var _recharts = require("recharts");
var _triaCard = require("../Cards/TriaCard");
var _reactDeviceDetect = require("react-device-detect");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactWidgetsMoment = require("react-widgets-moment");
var _reactWidgetsMomentDefault = parcelHelpers.interopDefault(_reactWidgetsMoment);
var _dateTimePicker = require("react-widgets/lib/DateTimePicker");
var _dateTimePickerDefault = parcelHelpers.interopDefault(_dateTimePicker);
var _dropdownList = require("react-widgets/lib/DropdownList");
var _dropdownListDefault = parcelHelpers.interopDefault(_dropdownList);
var _buttonDropdown = require("../Buttons/ButtonDropdown");
var _toggleSwitch = require("../InputComponents/ToggleSwitch");
var _reactWidgetsCss = require("react-widgets/dist/css/react-widgets.css");
(0, _momentDefault.default).locale('en');
(0, _reactWidgetsMomentDefault.default)();
var DeviceDetailPage = function(props) {
    var _props_history_location_state, _props_match_params, _nodeDetail_properties_vmHost, _nodeDetail_properties, _nodeDetail_properties_vmHost1, _nodeDetail_properties1;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState1[0], setError = _useState1[1];
    var history = (0, _reactRouterDom.useHistory)();
    var source = (0, _axiosDefault.default).CancelToken.source();
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), pageExpanded = _useState2[0], setPageExpanded = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)({
        metrics: {},
        properties: {}
    }), 2), nodeDetail = _useState3[0], setNodeDetail = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)({}), 2), currentMaintenanceWindow = _useState4[0], setCurrentMaintenanceWindow = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(((_props_history_location_state = props.history.location.state) === null || _props_history_location_state === void 0 ? void 0 : _props_history_location_state.assetTag) || ""), 2), assetTag = _useState5[0], setAssetTag = _useState5[1];
    var deviceId = ((_props_match_params = props.match.params) === null || _props_match_params === void 0 ? void 0 : _props_match_params.id) || "";
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(null), 2), diskInfo = _useState6[0], setDiskInfo = _useState6[1];
    var toggleExpandPage = function(e) {
        e.preventDefault();
        setPageExpanded(!pageExpanded);
    };
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var _props_history_location_state, volumeDetail, nodeDetail, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setIsLoading(true);
                        setError(false);
                        setAssetTag(((_props_history_location_state = props.history.location.state) === null || _props_history_location_state === void 0 ? void 0 : _props_history_location_state.assetTag) || "");
                        volumeDetail = null;
                        return [
                            4,
                            (0, _solarwindDefault.default).device_detail(deviceId)
                        ];
                    case 1:
                        nodeDetail = _state.sent();
                        try {
                            //wrapped in try do to only disk info will come back if a device has a disk.. i.e Network devices will not.
                            volumeDetail = null; //await SolarwindService.get_device_volume_info(deviceId);
                        } catch (e) {
                            console.error(e);
                        }
                        if (!isMounted()) return [
                            2
                        ];
                        setNodeDetail(nodeDetail.data);
                        setCurrentMaintenanceWindow(nodeDetail.data.properties.currentMaintenanceWindow);
                        setAssetTag(nodeDetail.data.properties.information.AssetTag);
                        if (volumeDetail != null) setDiskInfo(volumeDetail.data);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) console.log(error);
                        else {
                            console.log(error);
                            setError(true);
                        }
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, [
        props.match.params.id
    ]);
    var createNewTicket = function(e) {
        if (e != null) e.preventDefault();
        history.push({
            pathname: "/app/create-ticket"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "content-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "d-sm-flex justify-content-between tria-header-container",
                    style: {
                        padding: "0px 10px"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            className: "my-auto tria-header mobile-hidden",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "/app/devices",
                                    children: "Devices"
                                }),
                                "\xa0 ",
                                assetTag
                            ]
                        }),
                        !isLoading && !isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddMaintenanceWindowButton, {
                            deviceId: deviceId,
                            updateMaintenanceWindow: setCurrentMaintenanceWindow
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-spinner m-3 mt-4 fa-spin",
                            style: {
                                fontSize: "30px"
                            }
                        }),
                        " "
                    ]
                }) : isError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "text-center roboto-15 my-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-ban blue my-1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "my-1",
                            children: "TRiA did not identify Device data with this ID. Please contact us if this is an error."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-action my-1",
                            onClick: createNewTicket,
                            children: "Report if this is an error"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeList, {
                            nodeStatus: nodeDetail.properties.Status,
                            diskInfo: diskInfo,
                            metrics: nodeDetail.metrics,
                            cpuAlertDetails: nodeDetail.properties.cpuAlertDetails,
                            memoryAlertDetails: nodeDetail.properties.memoryAlertDetails
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "d-flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-sm-6 d-flex",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                                        title: "Device Properties",
                                        className: "w-100",
                                        footer: !pageExpanded && (0, _reactDeviceDetect.isMobile) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandTableButton, {
                                            toggle: toggleExpandPage
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeviceProperties, {
                                            data: nodeDetail.properties
                                        })
                                    })
                                }),
                                (!(0, _reactDeviceDetect.isMobile) || (0, _reactDeviceDetect.isMobile) && pageExpanded) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-sm-6",
                                    children: [
                                        nodeDetail.properties.virtualMachine && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                                            title: "Virtual Machine Details",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VirtualMachineDetails, {
                                                data: nodeDetail.properties.virtualMachine
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                                            title: "Maintenance Window",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaintenanceWindowCard, {
                                                currentWindow: currentMaintenanceWindow,
                                                deviceId: deviceId
                                            })
                                        }),
                                        ((_nodeDetail_properties = nodeDetail.properties) === null || _nodeDetail_properties === void 0 ? void 0 : (_nodeDetail_properties_vmHost = _nodeDetail_properties.vmHost) === null || _nodeDetail_properties_vmHost === void 0 ? void 0 : _nodeDetail_properties_vmHost.children) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                                            title: "VMWare Children",
                                            bodyClassName: "px-0",
                                            id: "vmwareChildrenCard",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(VMWareChildrenTable, {
                                                data: (_nodeDetail_properties1 = nodeDetail.properties) === null || _nodeDetail_properties1 === void 0 ? void 0 : (_nodeDetail_properties_vmHost1 = _nodeDetail_properties1.vmHost) === null || _nodeDetail_properties_vmHost1 === void 0 ? void 0 : _nodeDetail_properties_vmHost1.children,
                                                setLoading: setIsLoading,
                                                setError: setError,
                                                setAssetTag: setAssetTag
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var getNodeMetricGaugeColor = function(metric, threshold) {
    if (threshold < 0) threshold = 90;
    var thresholdDifference = threshold - metric;
    if (thresholdDifference < 0) return "red";
    else if (thresholdDifference <= 5) return "yellow";
    else return "blue";
};
var getResponseTimePct = function(responseTime) {
    // Value shown as the "max" in Solarwinds gauges
    var maxResponseTime = 2500;
    return responseTime / maxResponseTime * 100;
};
var getResponseTimeColor = function(responseTime) {
    if (responseTime >= 1500) return "red";
    else if (responseTime >= 750) return "yellow";
    else return "blue";
};
var getPacketLossColor = function(packetLoss) {
    return packetLoss == 100 ? "red" : "blue";
};
// Memoize becuase using 'stateAppActions' seems to remove fill color of Gauges
var ParseDiskName = function(data) {
    if (data.DeviceId == null) return data.DisplayName.split(':')[0] + ':';
    return data.DeviceId;
};
var GaugeList = /*#__PURE__*/ (0, _reactDefault.default).memo(function(param) {
    var nodeStatus = param.nodeStatus, diskInfo = param.diskInfo, metrics = param.metrics, cpuAlertDetails = param.cpuAlertDetails, memoryAlertDetails = param.memoryAlertDetails;
    var _diskInfo_diskIndex, _diskInfo_diskIndex1;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), dropdownOpen = _useState[0], setDropdownOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), diskIndex = _useState1[0], setDiskIndex = _useState1[1];
    var toggle = function() {
        return setDropdownOpen(function(prevState) {
            return !prevState;
        });
    };
    var toggleClick = function(val) {
        setDiskIndex(val);
        setDropdownOpen(function(prevState) {
            return !prevState;
        });
    };
    var cols = 4;
    var MenuItem = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (diskInfo != null) {
        cols = 5;
        MenuItem = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Dropdown), {
            className: "align-self-start my-auto ml-auto cursor",
            isOpen: dropdownOpen,
            toggle: toggle,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                    tag: "span",
                    "data-toggle": "dropdown",
                    "aria-expanded": dropdownOpen,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-ellipsis-h align-self-start my-auto ml-auto cursor"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownMenu), {
                    children: diskInfo.map(function(e, ix) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                            disabled: ix == diskIndex,
                            value: ix,
                            onClick: function(e) {
                                return toggleClick(ix);
                            },
                            children: ParseDiskName(e)
                        });
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "d-flex justify-content-between overflow-x-scroll-lg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "gauge-col-wrapper " + (cols === 5 ? 'col-5-width' : ''),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Average CPU Load",
                        id: "avgCpuLoadCard",
                        style: {
                            margin: "10px"
                        },
                        children: nodeStatus !== 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                            message: "Not Available"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !metrics.CPULoad ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: 0,
                                value: 0,
                                unit: "%",
                                width: 203,
                                height: 161
                            }) : metrics.CPULoad >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: metrics.CPULoad,
                                value: metrics.CPULoad,
                                unit: "%",
                                width: 203,
                                height: 161,
                                color: getNodeMetricGaugeColor(metrics.CPULoad, cpuAlertDetails.AlertCPUThreshold)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                                message: "This node was not configured to report Average CPU"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "gauge-col-wrapper " + (cols === 5 ? 'col-5-width' : ''),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Average Memory Used",
                        id: "avgMemUsedCard",
                        style: {
                            margin: "10px"
                        },
                        children: nodeStatus !== 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                            message: "Not Available"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: !metrics.PercentMemoryUsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: 0,
                                value: 0,
                                unit: "%",
                                width: 203,
                                height: 161
                            }) : metrics.PercentMemoryUsed >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: metrics.PercentMemoryUsed,
                                value: metrics.PercentMemoryUsed,
                                unit: "%",
                                width: 203,
                                height: 161,
                                color: getNodeMetricGaugeColor(metrics.PercentMemoryUsed, memoryAlertDetails.AlertRAMThreshold)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                                message: "This node was not configured to report Average Memory Used"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "gauge-col-wrapper " + (cols === 5 ? 'col-5-width' : ''),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Response Time",
                        id: "responseTimeCard",
                        style: {
                            margin: "10px"
                        },
                        children: nodeStatus !== 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                            message: "Not Available"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: metrics.ResponseTime >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: getResponseTimePct(metrics.ResponseTime),
                                value: metrics.ResponseTime,
                                unit: "MS",
                                width: 203,
                                height: 161,
                                color: getResponseTimeColor(metrics.ResponseTime)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                                message: "This node was not configured to report Response Time"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "gauge-col-wrapper " + (cols === 5 ? 'col-5-width' : ''),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Packet Loss",
                        id: "packetLossCard",
                        style: {
                            margin: "10px"
                        },
                        children: nodeStatus !== 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                            message: "Not Available"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: metrics.PercentLoss >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: metrics.PercentLoss,
                                value: metrics.PercentLoss,
                                unit: "%",
                                width: 203,
                                height: 161,
                                color: getPacketLossColor(metrics.PercentLoss)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                                message: "This node was not configured to report Packet Loss"
                            })
                        })
                    })
                }),
                cols === 5 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "gauge-col-wrapper " + (cols === 5 ? 'col-5-width ' : ' ') + (cols === 4 ? 'd-none ' : ' '),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Disk Used " + ParseDiskName(diskInfo[diskIndex]),
                        menuItem: MenuItem,
                        id: "diskUsed",
                        style: {
                            margin: "10px"
                        },
                        children: nodeStatus !== 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                            message: "Not Available"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: (diskInfo === null || diskInfo === void 0 ? void 0 : diskInfo.length) == 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: 0,
                                value: 0,
                                unit: "%",
                                width: 203,
                                height: 161
                            }) : (diskInfo === null || diskInfo === void 0 ? void 0 : diskInfo.length) > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                                percentageFilled: Math.round((_diskInfo_diskIndex = diskInfo[diskIndex]) === null || _diskInfo_diskIndex === void 0 ? void 0 : _diskInfo_diskIndex.VolumePercentUsed),
                                value: Math.round((_diskInfo_diskIndex1 = diskInfo[diskIndex]) === null || _diskInfo_diskIndex1 === void 0 ? void 0 : _diskInfo_diskIndex1.VolumePercentUsed),
                                unit: "%",
                                width: 203,
                                height: 161,
                                color: getNodeMetricGaugeColor(Math.round(diskInfo[diskIndex].VolumePercentUsed), cpuAlertDetails.AlertCPUThreshold)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeErrorMessage, {
                                message: "This node was not configured to report disk info"
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
            ]
        })
    });
});
var GaugeErrorMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-center pt-4",
        style: {
            minWidth: "200px",
            height: "160px"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "tria-input-font",
                children: message
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: "fas fa-ban blue"
            })
        ]
    });
};
var DeviceProperties = function(props) {
    var _cpuAlertDetails_AlertCPUSuppression, _cpuAlertDetails_AlertCPUCustom, _memoryAlertDetails_AlertRAMSuppression, _memoryAlertDetails_AlertRAMCustom;
    var status = props.data.Status;
    var _props_data = props.data, information = _props_data.information, pollingDetails = _props_data.pollingDetails, cpuAlertDetails = _props_data.cpuAlertDetails, memoryAlertDetails = _props_data.memoryAlertDetails;
    var nodeStatus = nodeStatuses.find(function(nodeStatus) {
        return nodeStatus.StatusId == status;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex justify-content-between card-content",
                id: "devicePropertiesCard",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "sub-header my-auto",
                        children: [
                            "Node Status is ",
                            nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.ShortDescription
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "",
                        children: (nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.Color) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIconToken, {
                            color: nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.Color
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "card-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "card-sub-header",
                        children: "Device Information"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Assettag",
                        value: information.AssetTag,
                        id: "dp-assettag"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Datacenter",
                        value: information.Datacenter == "n/a" ? "" : information.Datacenter,
                        id: "dp-datacenter"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Vendor",
                        value: information.Vendor,
                        id: "dp-vendor"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Machine Type",
                        value: information.MachineType,
                        id: "dp-machine-type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "System Name",
                        value: information.SysName,
                        id: "dp-system-name"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Version",
                        value: information.IOSVersion,
                        id: "dp-version"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "DNS Name",
                        value: information.DNS,
                        id: "dp-dns-name"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Last Boot",
                        value: information.LastBoot ? formatSolarwindsApiDate(information.LastBoot, "M/D/YYYY h:mm A") : "",
                        id: "dp-last-boot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Sysobject ID",
                        value: information.SysObjectID,
                        id: "dp-sysobject-id"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Description",
                        value: information.NodeDescription,
                        id: "dp-description"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "card-sub-header",
                        children: "Environment Tags"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Primary",
                        value: information.Application_Environment,
                        id: "dp-primary"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Secondary",
                        value: information.Sub_Application_Environment,
                        id: "dp-secondary"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Tertiary",
                        value: information.Sub_Sub_Application_Environment,
                        id: "dp-tertiary"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "card-sub-header",
                        children: "Polling Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "IP Address",
                        value: pollingDetails.IP_Address || "",
                        id: "dp-ip-address"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Ping Only",
                        value: (information.ObjectSubType.toLowerCase() == "icmp").toString().toUpperCase(),
                        id: "dp-ping-only"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Next Poll",
                        value: (pollingDetails === null || pollingDetails === void 0 ? void 0 : pollingDetails.NextPoll) ? formatSolarwindsApiDate(pollingDetails.NextPoll, "M/D/YYYY h:mm A") : "",
                        id: "dp-next-poll"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Last DB Update",
                        value: (pollingDetails === null || pollingDetails === void 0 ? void 0 : pollingDetails.LastSync) ? formatSolarwindsApiDate(pollingDetails.LastSync, "M/D/YYYY h:mm A") : "",
                        id: "dp-last-db-update"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "card-sub-header",
                        children: "CPU Alert Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Threshold",
                        value: cpuAlertDetails.AlertCPUThreshold < 1 ? "90%" : cpuAlertDetails.AlertCPUThreshold + "%",
                        id: "dp-cpu-threshold"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Suppressed",
                        value: (_cpuAlertDetails_AlertCPUSuppression = cpuAlertDetails.AlertCPUSuppression) === null || _cpuAlertDetails_AlertCPUSuppression === void 0 ? void 0 : _cpuAlertDetails_AlertCPUSuppression.toString(),
                        valueClassName: "text-capitalize",
                        id: "dp-cpu-surpressed"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Custom Alert",
                        value: (_cpuAlertDetails_AlertCPUCustom = cpuAlertDetails.AlertCPUCustom) === null || _cpuAlertDetails_AlertCPUCustom === void 0 ? void 0 : _cpuAlertDetails_AlertCPUCustom.toString(),
                        valueClassName: "text-capitalize",
                        id: "dp-cpu-custom-alert"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Assoc. Ticket",
                        value: cpuAlertDetails.AlertCPUPortalTicket || "",
                        id: "dp-cpu-assoc-ticket"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "card-sub-header",
                        children: "Memory Alert Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Threshold",
                        value: memoryAlertDetails.AlertRAMThreshold < 1 ? "90%" : memoryAlertDetails.AlertRAMThreshold + "%",
                        id: "dp-mem-threshold"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Suppressed",
                        value: (_memoryAlertDetails_AlertRAMSuppression = memoryAlertDetails.AlertRAMSuppression) === null || _memoryAlertDetails_AlertRAMSuppression === void 0 ? void 0 : _memoryAlertDetails_AlertRAMSuppression.toString(),
                        valueClassName: "text-capitalize",
                        id: "dp-mem-description"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Custom Alert",
                        value: (_memoryAlertDetails_AlertRAMCustom = memoryAlertDetails.AlertRAMCustom) === null || _memoryAlertDetails_AlertRAMCustom === void 0 ? void 0 : _memoryAlertDetails_AlertRAMCustom.toString(),
                        valueClassName: "text-capitalize",
                        id: "dp-mem-custom-alert"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                        field: "Assoc. Ticket",
                        value: memoryAlertDetails.AlertRAMPortalTicket || "",
                        id: "dp-mem-assoc-ticket"
                    })
                ]
            })
        ]
    });
};
var StatusIconToken = function(props) {
    var getIcon = function(color) {
        switch(color){
            case "green":
                return "fas fa-check";
            case "yellow":
                return "fas fa-exclamation-triangle";
            case "red":
                return "fas fa-exclamation";
            case "blue":
                return "fas fa-ban";
            default:
                return "fas fa-question";
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "status-icon-token",
        color: props.color || "gray",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: getIcon(props.color || "gray")
        })
    });
};
var VirtualMachineDetails = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "card-content",
            id: "virtualMachineDetailsCard",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "ESX Host",
                    value: data.HostName,
                    id: "vmd-esx-host"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "Operational State",
                    value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-circle status-icon my-auto px-2",
                                color: VirtualMachineGuestStateIconColor[data.GuestState]
                            }),
                            VirtualMachineGuestStateMapping[data.GuestState]
                        ]
                    }),
                    id: "vmd-operational-state"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "Guest Status",
                    value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-circle status-icon my-auto px-2",
                                color: nodeStatuses[data.ManagedStatus].Color
                            }),
                            nodeStatuses[data.ManagedStatus].ShortDescription
                        ]
                    }),
                    id: "vmd-guest-status"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "VMware tools version & status",
                    value: data.GuestVmWareToolsVersion + " | " + (VmWareToolsStatusMapping[data.GuestVmWareToolsStatus] || ""),
                    id: "vmd-tools-version"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "Memory Configured",
                    value: data.MemoryConfigured ? (data.MemoryConfigured / Math.pow(1024, 3)).toFixed(1) + " GB" : "",
                    id: "vmd-mem-config"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                    field: "Boot Time",
                    value: data.BootTime ? formatSolarwindsApiDate(data.BootTime, "M/D/YYYY h:mm A") : "",
                    id: "vmd-boot-time"
                })
            ]
        })
    });
};
var VmWareToolsStatusMapping = {
    toolsOk: "Tools are ok",
    toolsOld: "Tools are old",
    toolsNotRunning: "Tools are not running",
    toolsNotInstalled: "Tools are not installed"
};
var VirtualMachineGuestStateMapping = {
    unknown: "Unknown",
    notRunning: "Not running",
    shuttingDown: "Shutting down",
    running: "Running"
};
var VirtualMachineGuestStateIconColor = {
    unknown: "gray",
    notRunning: "red",
    shuttingDown: "blue",
    running: "green"
};
var MaintenanceWindowCard = function(param) {
    var currentWindow = param.currentWindow, deviceId = param.deviceId;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isWaiting = _useState[0], setWaiting = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), hasWindow = _useState1[0], setHasWindow = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState2[0], setError = _useState2[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _react.useEffect)(function() {
        if (currentWindow.UnManaged == null) setHasWindow(false);
        else {
            var startTime = (0, _momentDefault.default)(parseSolarwindsApiDate(currentWindow.UnManageFrom));
            var endTime = (0, _momentDefault.default)(parseSolarwindsApiDate(currentWindow.UnManageUntil));
            if (endTime < startTime || endTime < (0, _momentDefault.default)()) setHasWindow(false);
            else setHasWindow(true);
        }
    }, [
        currentWindow
    ]);
    var deleteDeviceMaintenanceWindow = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(deviceId) {
            var alertMessage, alertColor, response, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isWaiting) return [
                            2
                        ];
                        setWaiting(true);
                        alertMessage = "Successfully deleted maintenance window for device #".concat(deviceId);
                        alertColor = "success";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _solarwindDefault.default).delete_device_maintenance_window(deviceId)
                        ];
                    case 2:
                        response = _state.sent();
                        setHasWindow(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log(e);
                        setError(true);
                        alertMessage = "Error while deleting maintenance window for device #".concat(deviceId);
                        alertColor = "danger";
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setWaiting(false);
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: "white"
                                },
                                children: alertMessage
                            }),
                            className: alertColor + " tria-alert",
                            visible: true
                        });
                        setTimeout(function() {
                            stateAppActions.setAlert(function(prevState) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                    visible: false
                                });
                            });
                        }, 3000);
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteDeviceMaintenanceWindow(deviceId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: hasWindow ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mw-card-content",
            id: "maintenanceWindowCard",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex justify-content-between mb-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "sub-header mb-0",
                                    children: "Start Date"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "helvetica-font",
                                    children: currentWindow.UnManageFrom ? formatSolarwindsApiDate(currentWindow.UnManageFrom, "MM/DD/YYYY") : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-right",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "sub-header mb-0",
                                    children: "End Date"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "helvetica-font",
                                    children: currentWindow.UnManageUntil ? formatSolarwindsApiDate(currentWindow.UnManageUntil, "MM/DD/YYYY") : ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "d-flex justify-content-between mb-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "sub-header mb-0",
                                    children: "Start Time"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "helvetica-font",
                                    children: currentWindow.UnManageFrom ? formatSolarwindsApiDate(currentWindow.UnManageFrom, "h:mmA") : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-right",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "sub-header mb-0",
                                    children: "End Time"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "helvetica-font",
                                    children: currentWindow.UnManageUntil ? formatSolarwindsApiDate(currentWindow.UnManageUntil, "h:mmA") : ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-right",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "d-inline-block text-action",
                        onClick: function() {
                            return deleteDeviceMaintenanceWindow(deviceId);
                        },
                        children: [
                            isWaiting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-spinner fa-spin mr-1"
                            }),
                            "Delete"
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "pb-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row justify-content-center mt-3 mb-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "tria-input-font",
                        style: {
                            fontWeight: "500"
                        },
                        children: "No Maintenance Window Set"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row justify-content-center mb-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-ban blue my-auto px-2"
                    })
                })
            ]
        })
    });
};
var VMWareChildrenTable = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(5), 2), numberShown = _useState[0], setNumberShown = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(true), 2), sortOrder = _useState1[0], setSortOrder = _useState1[1]; // false = descending, true = ascending
    var pageSize = 5;
    var expandTable = function(e) {
        setNumberShown(numberShown + pageSize);
    };
    var toggleSortOrder = function(e) {
        e.preventDefault();
        setSortOrder(!sortOrder);
    };
    var sortAscending = function(a, b) {
        return a.Name > b.Name ? 1 : b.Name > a.Name ? -1 : 0;
    };
    var sortDescending = function(a, b) {
        return a.Name > b.Name ? -1 : b.Name > a.Name ? 1 : 0;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "table tria-table",
                id: "vmwareChildrenTable",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                    className: "cursor",
                                    style: {
                                        paddingLeft: "20px"
                                    },
                                    onClick: toggleSortOrder,
                                    children: [
                                        "Name and ID",
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "fas fa-chevron-" + (sortOrder ? "up" : "down"),
                                            style: {
                                                color: "#2E5BFF"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "tablet-hidden",
                                    style: {
                                        width: "160px"
                                    },
                                    children: "Operating System"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "mobile-hidden text-center",
                                    children: "State"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "IP Address"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: props.data.sort(sortOrder ? sortAscending : sortDescending).slice(0, numberShown).map(function(child, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VMChildRow, {
                                data: child,
                                i: i,
                                setLoading: props.setLoading,
                                setError: props.setError,
                                setAssetTag: props.setAssetTag
                            });
                        })
                    })
                ]
            }),
            props.data.length > numberShown && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandTableButton, {
                toggle: expandTable
            })
        ]
    });
};
var VMChildRow = function(props) {
    var source = (0, _axiosDefault.default).CancelToken.source();
    var history = (0, _reactRouterDom.useHistory)();
    var nodeStatus = nodeStatuses.find(function(nodeStatus) {
        return nodeStatus.StatusId == props.data.Status;
    });
    var goToChildPage = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e, i) {
            var responseData, deviceId, e1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        props.setAssetTag(props.data.Name);
                        props.setLoading(true);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getPortalDevice(null, {
                                assetTag: props.data.Name
                            })
                        ];
                    case 1:
                        responseData = _state.sent();
                        if (Object.entries(responseData).length == 0) throw 'No portal device with that name found';
                        deviceId = responseData.devices[0].id;
                        history.push("/app/devices/".concat(deviceId), {
                            assetTag: props.data.Name
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e1 = _state.sent();
                        console.log(e1);
                        props.setError(true);
                        props.setAssetTag("");
                        props.setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function goToChildPage(e, i) {
            return _ref.apply(this, arguments);
        };
    }();
    var getIcon = function(color) {
        switch(color){
            case "blue":
                return "fas fa-ban";
            default:
                return "fas fa-circle";
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                style: {
                    paddingLeft: "20px"
                },
                onClick: goToChildPage,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "break-word d-inline-block cursor",
                    style: {
                        color: "black",
                        fontWeight: "400"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "my-auto px-2 status-icon " + getIcon(nodeStatus.Color),
                            color: nodeStatus.Color
                        }),
                        props.data.Name
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                className: "tablet-hidden",
                children: props.data.GuestName
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                className: "mobile-hidden text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        id: "vmchild" + props.i,
                        className: "fas fa-power-off " + (props.data.PowerState == "poweredOn" ? "blue" : "gray")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledTooltip), {
                        placement: "right",
                        target: "vmchild" + props.i,
                        children: [
                            "This VM is powered ",
                            props.data.PowerState == "poweredOn" ? "ON" : "OFF"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: props.data.IpAddress == "n/a" ? "" : props.data.IpAddress
            })
        ]
    });
};
var ExpandTableButton = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "expand-table-btn cursor",
        onClick: props.toggle,
        children: "EXPAND TABLE"
    });
};
var formatSolarwindsApiDate = function(solarwindsDate, format) {
    var milliseconds = parseSolarwindsApiDate(solarwindsDate);
    return formatMillisecondsToDateTime(milliseconds, format);
};
var parseSolarwindsApiDate = function(solarwindsDate) {
    // Solarwinds API Datetime example: "/Date(1604344612497)/"
    // Return milliseconds in between parentheses
    var milliseconds = solarwindsDate.match(/\(([^)]+)\)/)[1];
    return parseInt(milliseconds);
};
var formatMillisecondsToDateTime = function(milliseconds, format) {
    // Example format: 10/5/2020 12:21:53 AM
    return (0, _momentDefault.default)(milliseconds).format(format);
};
var AddMaintenanceWindowButton = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setOpen = _useState[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _react.useEffect)(function() {
        if ((0, _reactDeviceDetect.isMobile) || (0, _reactDeviceDetect.isTablet)) stateAppActions.setContentBlade({
            title: "SET MAINTENTANCE WINDOW",
            visible: isOpen,
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaintenanceWindowForm, (0, _objectSpread._)({}, props))
        });
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(function() {
        setOpen(stateApp.contentBlade.visible);
    }, [
        stateApp.contentBlade.visible
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !(0, _reactDeviceDetect.isMobile) && !(0, _reactDeviceDetect.isTablet) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDropdown.ButtonDropdown), {
                label: "Maintenance Window",
                title: "SET MAINTENTANCE WINDOW",
                isOpen: isOpen,
                setIsOpen: setOpen,
                iconPos: "left",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaintenanceWindowForm, (0, _objectSpread._)({}, props))
            }),
            ((0, _reactDeviceDetect.isMobile) || (0, _reactDeviceDetect.isTablet)) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: "tria-btn w-sm-100 mr-1",
                onClick: function() {
                    return setOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fa fa-plus"
                    }),
                    "Maintenance Window"
                ]
            })
        ]
    });
};
var MaintenanceWindowForm = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(new Date()), 2), startDate = _useState[0], setStartDate = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(new Date()), 2), startTime = _useState1[0], setStartTime = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(null), 2), endDate = _useState2[0], setEndDate = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), endTime = _useState3[0], setEndTime = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isWaiting = _useState4[0], setWaiting = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState5[0], setError = _useState5[1];
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)({
        start: false,
        end: false
    }), 2), openCalendar = _useState6[0], setOpenCalendar = _useState6[1];
    // Refresh date fields when closing/re-opening
    (0, _react.useEffect)(function() {
        setStartDate(new Date());
        setStartTime(new Date());
        setEndDate(null);
        setEndTime(null);
    }, [
        props.isOpen
    ]);
    var addMaintenanceWindow = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var startDateStr, startTimeStr, endDateStr, endTimeStr, startTimeUTC, endTimeUTC, payload, alertMessage, alertColor, createResponse, updatedDetailResponse, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // UTC Format 2020-11-01 12:00 -0600
                        startDateStr = (0, _momentDefault.default)(startDate).format("MM/DD/YYYY");
                        startTimeStr = (0, _momentDefault.default)(startTime).format("HH:mm");
                        endDateStr = (0, _momentDefault.default)(endDate).format("MM/DD/YYYY");
                        endTimeStr = (0, _momentDefault.default)(endTime).format("HH:mm");
                        startTimeUTC = (0, _momentDefault.default)(startDateStr + " " + startTimeStr, "MM/DD/YYYY HH:mm").format("YYYY-MM-DD HH:mm ZZ");
                        endTimeUTC = (0, _momentDefault.default)(endDateStr + " " + endTimeStr, "MM/DD/YYYY HH:mm").format("YYYY-MM-DD HH:mm ZZ");
                        console.log('startTimeUTC: ', startTimeUTC);
                        console.log('endTimeUTC: ', endTimeUTC);
                        payload = {
                            windowType: "date",
                            startTimeUTC: startTimeUTC,
                            endTimeUTC: endTimeUTC,
                            reason: "Patching Window"
                        };
                        setWaiting(true);
                        alertMessage = "Successfully set maintenance window for device #".concat(props.deviceId);
                        alertColor = "success";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, _solarwindDefault.default).create_device_maintenance_window(props.deviceId, payload)
                        ];
                    case 2:
                        createResponse = _state.sent();
                        if (createResponse.data.status != "ok") throw "Create maintenance window - status not 'ok'";
                        return [
                            4,
                            (0, _solarwindDefault.default).device_detail(props.deviceId)
                        ];
                    case 3:
                        updatedDetailResponse = _state.sent();
                        props.updateMaintenanceWindow((0, _objectSpread._)({}, updatedDetailResponse.data.properties.currentMaintenanceWindow));
                        setStartDate(new Date());
                        setStartTime(new Date());
                        setEndDate(null);
                        setEndTime(null);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.log(e);
                        setError(true);
                        alertMessage = "Error while setting maintenance window for device #".concat(props.deviceId);
                        alertColor = "danger";
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setWaiting(false);
                        stateAppActions.setAlert({
                            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: "white"
                                },
                                children: alertMessage
                            }),
                            color: alertColor + " tria-alert",
                            visible: true
                        });
                        setTimeout(function() {
                            stateAppActions.setAlert(function(prevState) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prevState), {
                                    visible: false
                                });
                            });
                        }, 5000);
                        return [
                            2
                        ];
                }
            });
        });
        return function addMaintenanceWindow() {
            return _ref.apply(this, arguments);
        };
    }();
    var isInvalidInput = function() {
        if (startDate == "Invalid date" || startDate == null || startTime == "Invalid date" || startTime == null || endDate == "Invalid date" || endDate == null || endTime == "Invalid date" || endTime == null) return true;
        // Turn start and end dates/times to strings and put corresponding values together. Then convert into moment object to compare them
        var startDateTime = (0, _momentDefault.default)((0, _momentDefault.default)(startDate).format("MM/DD/YYYY") + " " + (0, _momentDefault.default)(startTime).format("HH:mm"), "MM/DD/YYYY HH:mm");
        var endDateTime = (0, _momentDefault.default)((0, _momentDefault.default)(endDate).format("MM/DD/YYYY") + " " + (0, _momentDefault.default)(endTime).format("HH:mm"), "MM/DD/YYYY HH:mm");
        // Invalid input if the start date comes after the end date
        if (startDateTime >= endDateTime) return true;
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "sub-header py-2",
                children: "Only one maintenance window can be set at a time"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "sub-header",
                        children: "Start of Maintenance:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row",
                        style: {
                            height: "40px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                id: "startDatePicker",
                                date: true,
                                time: false,
                                placeholder: "",
                                format: "MM/DD/YYYY",
                                defaultValue: new Date(),
                                value: startDate,
                                min: new Date(),
                                className: "col-6 mw-rw-datetime-picker",
                                containerClassName: "tria-input input-font rw-dropdown-font rw-container rw-no-btn",
                                onChange: function(value) {
                                    setStartDate(value);
                                },
                                onFocus: function() {
                                    return setOpenCalendar((0, _objectSpreadProps._)((0, _objectSpread._)({}, setOpenCalendar), {
                                        start: "date"
                                    }));
                                },
                                defaultOpen: false,
                                onBlur: function() {
                                    return setOpenCalendar((0, _objectSpreadProps._)((0, _objectSpread._)({}, setOpenCalendar), {
                                        start: false
                                    }));
                                },
                                open: openCalendar.start
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                id: "startTimePicker",
                                date: false,
                                placeholder: "",
                                defaultValue: new Date(),
                                value: startTime,
                                className: "col-6 mw-rw-datetime-picker",
                                containerClassName: "rw-dropdown-font rw-container",
                                timeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-down",
                                    style: {
                                        color: "#BFC5D2"
                                    }
                                }),
                                onChange: function(value) {
                                    setStartTime(value);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "sub-header",
                        children: "End of Maintenance:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row",
                        style: {
                            height: "40px"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                id: "endDatePicker",
                                value: endDate,
                                date: true,
                                time: false,
                                placeholder: "",
                                min: new Date(),
                                format: "MM/DD/YYYY",
                                className: "col-6 mw-rw-datetime-picker",
                                containerClassName: "tria-input input-font rw-dropdown-font rw-container rw-no-btn",
                                onChange: function(value) {
                                    setEndDate(value);
                                },
                                onFocus: function() {
                                    return setOpenCalendar((0, _objectSpreadProps._)((0, _objectSpread._)({}, setOpenCalendar), {
                                        end: "date"
                                    }));
                                },
                                defaultOpen: false,
                                onBlur: function() {
                                    return setOpenCalendar((0, _objectSpreadProps._)((0, _objectSpread._)({}, setOpenCalendar), {
                                        end: false
                                    }));
                                },
                                open: openCalendar.end
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateTimePickerDefault.default), {
                                id: "endTimePicker",
                                value: endTime,
                                date: false,
                                placeholder: "",
                                className: "col-6 mw-rw-datetime-picker",
                                containerClassName: "rw-dropdown-font rw-container",
                                timeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-chevron-down",
                                    style: {
                                        color: "#BFC5D2"
                                    }
                                }),
                                onChange: function(value) {
                                    setEndTime(value);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-flex mt-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                    className: "encode-sans-15 tria-btn-blue ml-auto",
                    size: "sm",
                    style: {
                        minWidth: "85px",
                        color: "white"
                    },
                    onClick: addMaintenanceWindow,
                    disabled: isInvalidInput() || isWaiting,
                    children: isWaiting ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fas fa-spinner fa-spin",
                        style: {
                            color: "white"
                        }
                    }) : "Schedule"
                })
            })
        ]
    });
};
var Gauge = function(props) {
    var numTicks = 35;
    // Create 35 ticks in the graph. The "value" key is used for the "dataKey" below
    var mydata = (0, _toConsumableArray._)(new Array(numTicks)).map(function(_) {
        return {
            value: 1
        };
    });
    var numTicksFilled = Math.round((props.percentageFilled / 100 || 0) * numTicks);
    var getOuterTicksColor = function(colorName) {
        switch(colorName){
            case "yellow":
                return "#F0E65B";
            case "red":
                return "#D63649";
            default:
                return "#2E5BFF";
        }
    };
    var _obj, _obj1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "d-flex justify-content-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.PieChart), {
            width: props.width,
            height: props.height,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Pie), (_obj = {
                    className: "gauge-inner-dots",
                    data: mydata,
                    dataKey: "value",
                    cx: 98,
                    cy: 90,
                    startAngle: 180,
                    endAngle: 0,
                    innerRadius: 56,
                    outerRadius: 59,
                    paddingAngle: 3.5
                }, (0, _defineProperty._)(_obj, "startAngle", 190), (0, _defineProperty._)(_obj, "endAngle", -10), (0, _defineProperty._)(_obj, "fill", "#E0E7FF"), _obj)),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.Pie), (_obj1 = {
                    className: "gauge-outer-ticks",
                    data: mydata,
                    dataKey: "value",
                    cx: 98,
                    cy: 90,
                    startAngle: 180,
                    endAngle: 0,
                    innerRadius: 65,
                    outerRadius: 90,
                    paddingAngle: 3.25
                }, (0, _defineProperty._)(_obj1, "startAngle", 190), (0, _defineProperty._)(_obj1, "endAngle", -10), (0, _defineProperty._)(_obj1, "children", [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Label), {
                        value: props.value || "0",
                        position: "centerBottom"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Label), {
                        value: props.unit || "",
                        position: "centerTop"
                    }),
                    mydata.map(function(_, i) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Cell), {
                            fill: i < numTicksFilled ? getOuterTicksColor(props.color) : "#E0E7FF"
                        });
                    })
                ]), _obj1))
            ]
        })
    });
};
var PollingDetails = function(props) {
    var _props_data = props.data, information = _props_data.information, pollingDetails = _props_data.pollingDetails;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "card-content",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "IP Address",
                value: pollingDetails.IP_Address || "",
                id: "dp-ip-address"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Ping Only",
                value: (information.ObjectSubType.toLowerCase() == "icmp").toString().toUpperCase(),
                id: "dp-ping-only"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Next Poll",
                value: (pollingDetails === null || pollingDetails === void 0 ? void 0 : pollingDetails.NextPoll) ? formatSolarwindsApiDate(pollingDetails.NextPoll, "M/D/YYYY h:mm A") : "",
                id: "dp-next-poll"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Last DB Update",
                value: (pollingDetails === null || pollingDetails === void 0 ? void 0 : pollingDetails.LastSync) ? formatSolarwindsApiDate(pollingDetails.LastSync, "M/D/YYYY h:mm A") : "",
                id: "dp-last-db-update"
            })
        ]
    });
};
var EnvironmentTags = function(props) {
    var information = props.data.information;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "card-content",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Primary",
                value: information.Application_Environment,
                id: "dp-primary"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Secondary",
                value: information.Sub_Application_Environment,
                id: "dp-secondary"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Tertiary",
                value: information.Sub_Sub_Application_Environment,
                id: "dp-tertiary"
            })
        ]
    });
};
var CustomerDescription = function(param) {
    var data = param.data, operatingSystem = param.operatingSystem, serviceTag = param.serviceTag;
    var information = data.information, pollingDetails = data.pollingDetails, cpuAlertDetails = data.cpuAlertDetails, memoryAlertDetails = data.memoryAlertDetails;
    var status = data.Status;
    var nodeStatus = nodeStatuses.find(function(nodeStatus) {
        return nodeStatus.StatusId == status;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "card-content",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex justify-content-between mb-2",
                id: "devicePropertiesCard",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "my-auto",
                        children: [
                            "Node Status is ",
                            nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.ShortDescription
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "",
                        children: (nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.Color) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIconToken, {
                            color: nodeStatus === null || nodeStatus === void 0 ? void 0 : nodeStatus.Color
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Assettag",
                value: information.AssetTag,
                id: "dp-assettag"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Servicetag",
                value: serviceTag,
                id: "dp-servicetag"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "OS",
                value: operatingSystem,
                id: "dp-operatingsystem"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Last Boot",
                value: information.LastBoot ? formatSolarwindsApiDate(information.LastBoot, "M/D/YYYY h:mm A") : "",
                id: "dp-last-boot"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "Description",
                value: information.NodeDescription,
                id: "dp-description"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.CardFieldValue), {
                field: "DNS Name",
                value: information.DNS,
                id: "dp-dns-name"
            })
        ]
    });
};
var GaugeGrid = /*#__PURE__*/ (0, _reactDefault.default).memo(function(param) {
    var diskInfo = param.diskInfo, metrics = param.metrics, cpuAlertDetails = param.cpuAlertDetails, memoryAlertDetails = param.memoryAlertDetails;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex justify-content-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Average CPU Load",
                        id: "avgCpuLoadCard",
                        style: {
                            margin: "10px"
                        },
                        children: !metrics.CPULoad ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: 0,
                            value: 0,
                            unit: "%",
                            width: 203,
                            height: 161
                        }) : metrics.CPULoad >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: metrics.CPULoad,
                            value: metrics.CPULoad,
                            unit: "%",
                            width: 203,
                            height: 161,
                            color: getNodeMetricGaugeColor(metrics.CPULoad, cpuAlertDetails.AlertCPUThreshold)
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center pt-4",
                            style: {
                                minWidth: "200px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "tria-input-font",
                                    children: "This node was not configured to report Average CPU"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-ban blue"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Average Memory Used",
                        id: "avgMemUsedCard",
                        style: {
                            margin: "10px"
                        },
                        children: !metrics.PercentMemoryUsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: 0,
                            value: 0,
                            unit: "%",
                            width: 203,
                            height: 161
                        }) : metrics.PercentMemoryUsed >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: metrics.PercentMemoryUsed,
                            value: metrics.PercentMemoryUsed,
                            unit: "%",
                            width: 203,
                            height: 161,
                            color: getNodeMetricGaugeColor(metrics.PercentMemoryUsed, memoryAlertDetails.AlertRAMThreshold)
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center pt-4",
                            style: {
                                minWidth: "200px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "tria-input-font",
                                    children: "This node was not configured to report Average Memory Used"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-ban blue"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex justify-content-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Response Time",
                        id: "responseTimeCard",
                        style: {
                            margin: "10px"
                        },
                        children: metrics.ResponseTime >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: getResponseTimePct(metrics.ResponseTime),
                            value: metrics.ResponseTime,
                            unit: "MS",
                            width: 203,
                            height: 161,
                            color: getResponseTimeColor(metrics.ResponseTime)
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center pt-4",
                            style: {
                                minWidth: "200px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "tria-input-font",
                                    children: "This node was not configured to report Response Time"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-ban blue"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triaCard.TriaCard), {
                        title: "Packet Loss",
                        id: "packetLossCard",
                        style: {
                            margin: "10px"
                        },
                        children: metrics.PercentLoss >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Gauge, {
                            percentageFilled: metrics.PercentLoss,
                            value: metrics.PercentLoss,
                            unit: "%",
                            width: 203,
                            height: 161,
                            color: getPacketLossColor(metrics.PercentLoss)
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center pt-4",
                            style: {
                                minWidth: "200px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "tria-input-font",
                                    children: "This node was not configured to report Packet Loss"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-ban blue"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});
var nodeStatuses = [
    {
        "StatusId": 0,
        "StatusName": "Unknown",
        "ShortDescription": "Unknown",
        "Color": "gray"
    },
    {
        "StatusId": 1,
        "StatusName": "Up",
        "ShortDescription": "Up",
        "Color": "green"
    },
    {
        "StatusId": 2,
        "StatusName": "Down",
        "ShortDescription": "Down",
        "Color": "red"
    },
    {
        "StatusId": 3,
        "StatusName": "Warning",
        "ShortDescription": "Warning",
        "Color": "yellow"
    },
    {
        "StatusId": 4,
        "StatusName": "Shutdown",
        "ShortDescription": "Shutdown",
        "Color": "gray"
    },
    {
        "StatusId": 5,
        "StatusName": "Testing",
        "ShortDescription": "Testing",
        "Color": "gray"
    },
    {
        "StatusId": 6,
        "StatusName": "Dormant",
        "ShortDescription": "Dormant",
        "Color": "gray"
    },
    {
        "StatusId": 7,
        "StatusName": "NotPresent",
        "ShortDescription": "Not Present",
        "Color": "gray"
    },
    {
        "StatusId": 8,
        "StatusName": "LowerLayerDown",
        "ShortDescription": "Lower Layer Down",
        "Color": "red"
    },
    {
        "StatusId": 9,
        "StatusName": "Unmanaged",
        "ShortDescription": "Unmanaged",
        "Color": "blue"
    },
    {
        "StatusId": 10,
        "StatusName": "Unplugged",
        "ShortDescription": "Unplugged",
        "Color": "blue"
    },
    {
        "StatusId": 11,
        "StatusName": "External",
        "ShortDescription": "External",
        "Color": "purple"
    },
    {
        "StatusId": 12,
        "StatusName": "Unreachable",
        "ShortDescription": "Unreachable",
        "Color": "gray"
    },
    {
        "StatusId": 14,
        "StatusName": "Critical",
        "ShortDescription": "Critical",
        "Color": "red"
    },
    {
        "StatusId": 15,
        "StatusName": "PartlyAvailable",
        "ShortDescription": "Partly Available",
        "Color": "yellow"
    },
    {
        "StatusId": 16,
        "StatusName": "Misconfigured",
        "ShortDescription": "Misconfigured",
        "Color": "gray"
    },
    {
        "StatusId": 17,
        "StatusName": "Undefined",
        "ShortDescription": "Could Not Poll",
        "Color": "gray"
    },
    {
        "StatusId": 19,
        "StatusName": "Unconfirmed",
        "ShortDescription": "Unconfirmed",
        "Color": "yellow"
    },
    {
        "StatusId": 22,
        "StatusName": "Active",
        "ShortDescription": "Active",
        "Color": "green"
    },
    {
        "StatusId": 24,
        "StatusName": "Inactive",
        "ShortDescription": "Inactive",
        "Color": "gray"
    },
    {
        "StatusId": 25,
        "StatusName": "Expired",
        "ShortDescription": "Expired",
        "Color": "gray"
    },
    {
        "StatusId": 26,
        "StatusName": "MonitoringDisabled",
        "ShortDescription": "Monitoring Disabled",
        "Color": "gray"
    },
    {
        "StatusId": 27,
        "StatusName": "Disabled",
        "ShortDescription": "Disabled",
        "Color": "gray"
    },
    {
        "StatusId": 28,
        "StatusName": "NotLicensed",
        "ShortDescription": "Not Licensed",
        "Color": "gray"
    },
    {
        "StatusId": 29,
        "StatusName": "OtherCategory",
        "ShortDescription": "Other",
        "Color": "gray"
    },
    {
        "StatusId": 30,
        "StatusName": "NotRunning",
        "ShortDescription": "Not Running",
        "Color": "blue"
    },
    {
        "StatusId": 31,
        "StatusName": "Online",
        "ShortDescription": "Online",
        "Color": "green"
    },
    {
        "StatusId": 32,
        "StatusName": "OnBattery",
        "ShortDescription": "On Battery",
        "Color": "yellow"
    },
    {
        "StatusId": 33,
        "StatusName": "OnSmartBoost",
        "ShortDescription": "On Smart Boost",
        "Color": "yellow"
    },
    {
        "StatusId": 34,
        "StatusName": "TimedSleeping",
        "ShortDescription": "Timed Sleeping",
        "Color": "blue"
    },
    {
        "StatusId": 35,
        "StatusName": "SoftwareBypass",
        "ShortDescription": "Software Bypass",
        "Color": "blue"
    },
    {
        "StatusId": 36,
        "StatusName": "Off",
        "ShortDescription": "Off",
        "Color": "red"
    },
    {
        "StatusId": 37,
        "StatusName": "Rebooting",
        "ShortDescription": "Rebooting",
        "Color": "yellow"
    },
    {
        "StatusId": 38,
        "StatusName": "SwitchedBypass",
        "ShortDescription": "Switched Bypass",
        "Color": "blue"
    },
    {
        "StatusId": 39,
        "StatusName": "HardwareFailureBypass",
        "ShortDescription": "Hardware Failure Bypass",
        "Color": "blue"
    },
    {
        "StatusId": 40,
        "StatusName": "SleepingUntilPowerReturn",
        "ShortDescription": "Sleeping Until Power Return",
        "Color": "blue"
    },
    {
        "StatusId": 41,
        "StatusName": "OnSmartTrim",
        "ShortDescription": "On Smart Trim",
        "Color": "yellow"
    },
    {
        "StatusId": 42,
        "StatusName": "EcoMode",
        "ShortDescription": "Eco Mode",
        "Color": "green"
    },
    {
        "StatusId": 43,
        "StatusName": "HotStandBy",
        "ShortDescription": "Hot Stand By",
        "Color": "green"
    },
    {
        "StatusId": 44,
        "StatusName": "OnBatteryTest",
        "ShortDescription": "On Battery Test",
        "Color": "gray"
    }
];

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","../../AppState":"8UGXH","../../services/Solarwind":"bT5YJ","../../services/ConnectriaTicketsService":"l5X0I","axios":"ebRwi","../../utility/use-async-effect":"fShZN","reactstrap":"774RE","recharts":"fAd5I","../Cards/TriaCard":"9XO2Y","react-device-detect":"h7vq0","moment":"3xZWN","react-widgets-moment":"4UbXs","react-widgets/lib/DateTimePicker":"4KVXE","react-widgets/lib/DropdownList":"2yyA9","../Buttons/ButtonDropdown":"EUzlk","../InputComponents/ToggleSwitch":"hSoEx","react-widgets/dist/css/react-widgets.css":"kGl4g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fAd5I":[function(require,module,exports,__globalThis) {
// "export type" declarations on separate lines are in use
// to workaround babel issue(s) 11465 12578
//
// see https://github.com/babel/babel/issues/11464#issuecomment-617606898
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", function() {
    return 0, _surface.Surface;
});
parcelHelpers.export(exports, "Layer", function() {
    return 0, _layer.Layer;
});
parcelHelpers.export(exports, "Legend", function() {
    return 0, _legend.Legend;
});
parcelHelpers.export(exports, "DefaultLegendContent", function() {
    return 0, _defaultLegendContent.DefaultLegendContent;
});
parcelHelpers.export(exports, "Tooltip", function() {
    return 0, _tooltip.Tooltip;
});
parcelHelpers.export(exports, "DefaultTooltipContent", function() {
    return 0, _defaultTooltipContent.DefaultTooltipContent;
});
parcelHelpers.export(exports, "ResponsiveContainer", function() {
    return 0, _responsiveContainer.ResponsiveContainer;
});
parcelHelpers.export(exports, "Cell", function() {
    return 0, _cell.Cell;
});
parcelHelpers.export(exports, "Text", function() {
    return 0, _text.Text;
});
parcelHelpers.export(exports, "Label", function() {
    return 0, _label.Label;
});
parcelHelpers.export(exports, "LabelList", function() {
    return 0, _labelList.LabelList;
});
parcelHelpers.export(exports, "Customized", function() {
    return 0, _customized.Customized;
});
parcelHelpers.export(exports, "Sector", function() {
    return 0, _sector.Sector;
});
parcelHelpers.export(exports, "Curve", function() {
    return 0, _curve.Curve;
});
parcelHelpers.export(exports, "Rectangle", function() {
    return 0, _rectangle.Rectangle;
});
parcelHelpers.export(exports, "Polygon", function() {
    return 0, _polygon.Polygon;
});
parcelHelpers.export(exports, "Dot", function() {
    return 0, _dot.Dot;
});
parcelHelpers.export(exports, "Cross", function() {
    return 0, _cross.Cross;
});
parcelHelpers.export(exports, "Symbols", function() {
    return 0, _symbols.Symbols;
});
parcelHelpers.export(exports, "PolarGrid", function() {
    return 0, _polarGrid.PolarGrid;
});
parcelHelpers.export(exports, "PolarRadiusAxis", function() {
    return 0, _polarRadiusAxis.PolarRadiusAxis;
});
parcelHelpers.export(exports, "PolarAngleAxis", function() {
    return 0, _polarAngleAxis.PolarAngleAxis;
});
parcelHelpers.export(exports, "Pie", function() {
    return 0, _pie.Pie;
});
parcelHelpers.export(exports, "Radar", function() {
    return 0, _radar.Radar;
});
parcelHelpers.export(exports, "RadialBar", function() {
    return 0, _radialBar.RadialBar;
});
parcelHelpers.export(exports, "Brush", function() {
    return 0, _brush.Brush;
});
parcelHelpers.export(exports, "ReferenceLine", function() {
    return 0, _referenceLine.ReferenceLine;
});
parcelHelpers.export(exports, "ReferenceDot", function() {
    return 0, _referenceDot.ReferenceDot;
});
parcelHelpers.export(exports, "ReferenceArea", function() {
    return 0, _referenceArea.ReferenceArea;
});
parcelHelpers.export(exports, "CartesianAxis", function() {
    return 0, _cartesianAxis.CartesianAxis;
});
parcelHelpers.export(exports, "CartesianGrid", function() {
    return 0, _cartesianGrid.CartesianGrid;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _line.Line;
});
parcelHelpers.export(exports, "Area", function() {
    return 0, _area.Area;
});
parcelHelpers.export(exports, "Bar", function() {
    return 0, _bar.Bar;
});
parcelHelpers.export(exports, "Scatter", function() {
    return 0, _scatter.Scatter;
});
parcelHelpers.export(exports, "XAxis", function() {
    return 0, _xaxis.XAxis;
});
parcelHelpers.export(exports, "YAxis", function() {
    return 0, _yaxis.YAxis;
});
parcelHelpers.export(exports, "ZAxis", function() {
    return 0, _zaxis.ZAxis;
});
parcelHelpers.export(exports, "ErrorBar", function() {
    return 0, _errorBar.ErrorBar;
});
parcelHelpers.export(exports, "LineChart", function() {
    return 0, _lineChart.LineChart;
});
parcelHelpers.export(exports, "BarChart", function() {
    return 0, _barChart.BarChart;
});
parcelHelpers.export(exports, "PieChart", function() {
    return 0, _pieChart.PieChart;
});
parcelHelpers.export(exports, "Treemap", function() {
    return 0, _treemap.Treemap;
});
parcelHelpers.export(exports, "Sankey", function() {
    return 0, _sankey.Sankey;
});
parcelHelpers.export(exports, "RadarChart", function() {
    return 0, _radarChart.RadarChart;
});
parcelHelpers.export(exports, "ScatterChart", function() {
    return 0, _scatterChart.ScatterChart;
});
parcelHelpers.export(exports, "AreaChart", function() {
    return 0, _areaChart.AreaChart;
});
parcelHelpers.export(exports, "RadialBarChart", function() {
    return 0, _radialBarChart.RadialBarChart;
});
parcelHelpers.export(exports, "ComposedChart", function() {
    return 0, _composedChart.ComposedChart;
});
parcelHelpers.export(exports, "SunburstChart", function() {
    return 0, _sunburstChart.SunburstChart;
});
parcelHelpers.export(exports, "Funnel", function() {
    return 0, _funnel.Funnel;
});
parcelHelpers.export(exports, "FunnelChart", function() {
    return 0, _funnelChart.FunnelChart;
});
parcelHelpers.export(exports, "Trapezoid", function() {
    return 0, _trapezoid.Trapezoid;
});
parcelHelpers.export(exports, "Global", function() {
    return 0, _global.Global;
});
var _surface = require("./container/Surface");
var _layer = require("./container/Layer");
var _legend = require("./component/Legend");
var _defaultLegendContent = require("./component/DefaultLegendContent");
var _tooltip = require("./component/Tooltip");
var _defaultTooltipContent = require("./component/DefaultTooltipContent");
var _responsiveContainer = require("./component/ResponsiveContainer");
var _cell = require("./component/Cell");
var _text = require("./component/Text");
var _label = require("./component/Label");
var _labelList = require("./component/LabelList");
var _customized = require("./component/Customized");
var _sector = require("./shape/Sector");
var _curve = require("./shape/Curve");
var _rectangle = require("./shape/Rectangle");
var _polygon = require("./shape/Polygon");
var _dot = require("./shape/Dot");
var _cross = require("./shape/Cross");
var _symbols = require("./shape/Symbols");
var _polarGrid = require("./polar/PolarGrid");
var _polarRadiusAxis = require("./polar/PolarRadiusAxis");
var _polarAngleAxis = require("./polar/PolarAngleAxis");
var _pie = require("./polar/Pie");
var _radar = require("./polar/Radar");
var _radialBar = require("./polar/RadialBar");
var _brush = require("./cartesian/Brush");
var _referenceLine = require("./cartesian/ReferenceLine");
var _referenceDot = require("./cartesian/ReferenceDot");
var _referenceArea = require("./cartesian/ReferenceArea");
var _cartesianAxis = require("./cartesian/CartesianAxis");
var _cartesianGrid = require("./cartesian/CartesianGrid");
var _line = require("./cartesian/Line");
var _area = require("./cartesian/Area");
var _bar = require("./cartesian/Bar");
var _scatter = require("./cartesian/Scatter");
var _xaxis = require("./cartesian/XAxis");
var _yaxis = require("./cartesian/YAxis");
var _zaxis = require("./cartesian/ZAxis");
var _errorBar = require("./cartesian/ErrorBar");
var _lineChart = require("./chart/LineChart");
var _barChart = require("./chart/BarChart");
var _pieChart = require("./chart/PieChart");
var _treemap = require("./chart/Treemap");
var _sankey = require("./chart/Sankey");
var _radarChart = require("./chart/RadarChart");
var _scatterChart = require("./chart/ScatterChart");
var _areaChart = require("./chart/AreaChart");
var _radialBarChart = require("./chart/RadialBarChart");
var _composedChart = require("./chart/ComposedChart");
var _sunburstChart = require("./chart/SunburstChart");
var _funnel = require("./numberAxis/Funnel");
var _funnelChart = require("./chart/FunnelChart");
var _trapezoid = require("./shape/Trapezoid");
var _global = require("./util/Global");

},{"./container/Surface":false,"./container/Layer":false,"./component/Legend":"m2stU","./component/DefaultLegendContent":false,"./component/Tooltip":"1ICZQ","./component/DefaultTooltipContent":false,"./component/ResponsiveContainer":"9rd5w","./component/Cell":"7blff","./component/Text":false,"./component/Label":"fRyNr","./component/LabelList":false,"./component/Customized":false,"./shape/Sector":false,"./shape/Curve":false,"./shape/Rectangle":false,"./shape/Polygon":false,"./shape/Dot":false,"./shape/Cross":false,"./shape/Symbols":false,"./polar/PolarGrid":false,"./polar/PolarRadiusAxis":false,"./polar/PolarAngleAxis":false,"./polar/Pie":"uKsmb","./polar/Radar":false,"./polar/RadialBar":false,"./cartesian/Brush":false,"./cartesian/ReferenceLine":false,"./cartesian/ReferenceDot":false,"./cartesian/ReferenceArea":false,"./cartesian/CartesianAxis":false,"./cartesian/CartesianGrid":"f7ava","./cartesian/Line":false,"./cartesian/Area":"WLMlZ","./cartesian/Bar":false,"./cartesian/Scatter":false,"./cartesian/XAxis":"dxKXf","./cartesian/YAxis":"dWDOf","./cartesian/ZAxis":false,"./cartesian/ErrorBar":false,"./chart/LineChart":false,"./chart/BarChart":false,"./chart/PieChart":"kZkME","./chart/Treemap":false,"./chart/Sankey":false,"./chart/RadarChart":false,"./chart/ScatterChart":false,"./chart/AreaChart":"5G9vU","./chart/RadialBarChart":false,"./chart/ComposedChart":false,"./chart/SunburstChart":false,"./numberAxis/Funnel":false,"./chart/FunnelChart":false,"./shape/Trapezoid":false,"./util/Global":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bKX4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", function() {
    return Surface;
});
/**
 * @fileOverview Surface
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Surface(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties(props, _excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, _clsxDefault.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({}, (0, _reactUtils.filterProps)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("desc", null, desc), children);
}

},{"react":"gVheC","clsx":"aGWRz","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGWRz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", function() {
    return clsx;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e))) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bLejJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALE_TYPES", function() {
    return SCALE_TYPES;
});
parcelHelpers.export(exports, "LEGEND_TYPES", function() {
    return LEGEND_TYPES;
});
parcelHelpers.export(exports, "TOOLTIP_TYPES", function() {
    return TOOLTIP_TYPES;
});
parcelHelpers.export(exports, "getDisplayName", function() {
    return getDisplayName;
});
parcelHelpers.export(exports, "toArray", function() {
    return toArray;
});
/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findAllByType", function() {
    return findAllByType;
});
/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findChildByType", function() {
    return findChildByType;
});
parcelHelpers.export(exports, "withoutType", function() {
    return withoutType;
});
parcelHelpers.export(exports, "validateWidthHeight", function() {
    return validateWidthHeight;
});
parcelHelpers.export(exports, "hasClipDot", function() {
    return hasClipDot;
});
parcelHelpers.export(exports, "isValidSpreadableProp", function() {
    return isValidSpreadableProp;
});
parcelHelpers.export(exports, "filterSvgElements", function() {
    return filterSvgElements;
});
parcelHelpers.export(exports, "filterProps", function() {
    return filterProps;
});
parcelHelpers.export(exports, "isChildrenEqual", function() {
    return isChildrenEqual;
});
parcelHelpers.export(exports, "isSingleChildEqual", function() {
    return isSingleChildEqual;
});
parcelHelpers.export(exports, "renderByOrder", function() {
    return renderByOrder;
});
parcelHelpers.export(exports, "getReactEventByType", function() {
    return getReactEventByType;
});
parcelHelpers.export(exports, "parseChildIndex", function() {
    return parseChildIndex;
});
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _react = require("react");
var _reactIs = require("react-is");
var _dataUtils = require("./DataUtils");
var _shallowEqual = require("./ShallowEqual");
var _types = require("./types");
var _excluded = [
    "children"
], _excluded2 = [
    "children"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var SCALE_TYPES = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var LEGEND_TYPES = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var TOOLTIP_TYPES = [
    'none'
];
var getDisplayName = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
    if (children === lastChildren && Array.isArray(lastResult)) return lastResult;
    var result = [];
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _isNilDefault.default)(child)) return;
        if ((0, _reactIs.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    lastResult = result;
    lastChildren = children;
    return result;
};
function findAllByType(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var childType = (0, _getDefault.default)(child, 'type.displayName') || (0, _getDefault.default)(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function findChildByType(children, type) {
    var result = findAllByType(children, type);
    return result && result[0];
}
var withoutType = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var displayName = (0, _getDefault.default)(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var validateWidthHeight = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0) return false;
    return true;
};
var SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, _isStringDefault.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var hasClipDot = function hasClipDot(dot) {
    return dot && _typeof(dot) === 'object' && 'clipDot' in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, _types.FilteredElementKeyMap) === null || (0, _types.FilteredElementKeyMap) === void 0 ? void 0 : (0, _types.FilteredElementKeyMap)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, _isFunctionDefault.default)(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, _types.SVGElementPropKeys).includes(key)) || includeEvents && (0, _types.EventKeys).includes(key);
};
var filterSvgElements = function filterSvgElements(children) {
    var svgElements = [];
    toArray(children).forEach(function(entry) {
        if (isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var filterProps = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, _react.Children).count(nextChildren);
    if (count !== (0, _react.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!isSingleChildEqual(nextChild, prevChild)) return false;
    }
    return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, _isNilDefault.default)(nextChild) && (0, _isNilDefault.default)(prevChild)) return true;
    if (!(0, _isNilDefault.default)(nextChild) && !(0, _isNilDefault.default)(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties(_ref, _excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties(_ref2, _excluded2);
        if (nextChildren && prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps);
        return false;
    }
    return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    toArray(children).forEach(function(child, index) {
        if (isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = getDisplayName(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var getReactEventByType = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && REACT_BROWSER_EVENT_MAP[type]) return REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
    return toArray(children).indexOf(child);
};

},{"lodash/get":"jeneQ","lodash/isNil":"beGyX","lodash/isString":"kZIz1","lodash/isFunction":"8ck2f","lodash/isObject":"8ffGS","react":"gVheC","react-is":"gwxSk","./DataUtils":"c1vtt","./ShallowEqual":"gpRqq","./types":"fLu4V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gwxSk":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("89e91c2f3d031081");

},{"89e91c2f3d031081":"22QRq"}],"22QRq":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{"@swc/helpers/_/_type_of":"668P4"}],"c1vtt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathSign", function() {
    return mathSign;
});
parcelHelpers.export(exports, "isPercent", function() {
    return isPercent;
});
parcelHelpers.export(exports, "isNumber", function() {
    return isNumber;
});
parcelHelpers.export(exports, "isNumOrStr", function() {
    return isNumOrStr;
});
parcelHelpers.export(exports, "uniqueId", function() {
    return uniqueId;
});
parcelHelpers.export(exports, "getPercentValue", function() {
    return getPercentValue;
});
parcelHelpers.export(exports, "getAnyElementOfObject", function() {
    return getAnyElementOfObject;
});
parcelHelpers.export(exports, "hasDuplicate", function() {
    return hasDuplicate;
});
parcelHelpers.export(exports, "interpolateNumber", function() {
    return interpolateNumber;
});
parcelHelpers.export(exports, "findEntryInArray", function() {
    return findEntryInArray;
});
parcelHelpers.export(exports, "getLinearRegression", function() {
    return getLinearRegression;
});
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var mathSign = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var isPercent = function isPercent(value) {
    return (0, _isStringDefault.default)(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
    return (0, _isNumberDefault.default)(value) && !(0, _isNaNDefault.default)(value);
};
var isNumOrStr = function isNumOrStr(value) {
    return isNumber(value) || (0, _isStringDefault.default)(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
    var id = ++idCounter;
    return "".concat(prefix || '').concat(id);
};
var getPercentValue = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isNumber(percent) && !(0, _isStringDefault.default)(percent)) return defaultValue;
    var value;
    if (isPercent(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, _isNaNDefault.default)(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var hasDuplicate = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
    if (isNumber(numberA) && isNumber(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _getDefault.default)(entry, specifiedKey)) === specifiedValue;
    });
}
var getLinearRegression = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};

},{"lodash/isString":"kZIz1","lodash/isNaN":"4ILIm","lodash/get":"jeneQ","lodash/isNumber":"f04rq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ILIm":[function(require,module,exports,__globalThis) {
var isNumber = require("3426dfbd8f8be7c7");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
}
module.exports = isNaN;

},{"3426dfbd8f8be7c7":"f04rq"}],"f04rq":[function(require,module,exports,__globalThis) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"iuqvy","6ae0825ac2dae50f":"lm2eo"}],"gpRqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", function() {
    return shallowEqual;
});
function shallowEqual(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fLu4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGElementPropKeys", function() {
    return SVGElementPropKeys;
});
parcelHelpers.export(exports, "FilteredElementKeyMap", function() {
    return FilteredElementKeyMap;
});
parcelHelpers.export(exports, "EventKeys", function() {
    return EventKeys;
});
parcelHelpers.export(exports, "adaptEventHandlers", function() {
    return adaptEventHandlers;
});
parcelHelpers.export(exports, "adaptEventsOfChild", function() {
    return adaptEventsOfChild;
});
var _react = require("react");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var PolyElementKeys = [
    'points',
    'pathLength'
];
var FilteredElementKeyMap = {
    svg: SVGContainerPropKeys,
    polygon: PolyElementKeys,
    polyline: PolyElementKeys
};
var EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if (EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
    if (!(0, _isObjectDefault.default)(props) || _typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if (EventKeys.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};

},{"react":"gVheC","lodash/isObject":"8ffGS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4SHHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", function() {
    return Layer;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Layer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = _objectWithoutProperties(props, _excluded);
    var layerClass = (0, _clsxDefault.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", _extends({
        className: layerClass
    }, (0, _reactUtils.filterProps)(others, true), {
        ref: ref
    }), children);
});

},{"react":"gVheC","clsx":"aGWRz","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"m2stU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Legend", function() {
    return Legend;
});
/**
 * @fileOverview Legend
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultLegendContent = require("./DefaultLegendContent");
var _dataUtils = require("../util/DataUtils");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "ref"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function defaultUniqBy(entry) {
    return entry.value;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    var ref = props.ref, otherProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultLegendContent.DefaultLegendContent), otherProps);
}
var EPS = 1;
var Legend = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        _classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Legend, [].concat(args));
        _defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    _inherits(Legend, _PureComponent);
    return _createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return _objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return _objectSpread(_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = _objectSpread(_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: (0, _getUniqPayload.getUniqPayload)(payload, payloadUniqBy, defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = _objectSpread(_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, _dataUtils.isNumber)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Legend, "displayName", 'Legend');
_defineProperty(Legend, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});

},{"react":"gVheC","./DefaultLegendContent":"94uHR","../util/DataUtils":"c1vtt","../util/payload/getUniqPayload":"d0DrX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"94uHR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultLegendContent", function() {
    return DefaultLegendContent;
});
/**
 * @fileOverview Default Legend Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _logUtils = require("../util/LogUtils");
var _surface = require("../container/Surface");
var _symbols = require("../shape/Symbols");
var _types = require("../util/types");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        _classCallCheck(this, DefaultLegendContent);
        return _callSuper(this, DefaultLegendContent, arguments);
    }
    _inherits(DefaultLegendContent, _PureComponent);
    return _createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = SIZE / 2;
                var sixthSize = SIZE / 6;
                var thirdSize = SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(data.legendIcon)) {
                    var iconProps = _objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: SIZE,
                    height: SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, _clsxDefault.default)(_defineProperty(_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, _isFunctionDefault.default)(entry.value) ? entry.value : null;
                    (0, _logUtils.warn)(!(0, _isFunctionDefault.default)(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", _extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(DefaultLegendContent, "displayName", 'Legend');
_defineProperty(DefaultLegendContent, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","clsx":"aGWRz","../util/LogUtils":"6J16n","../container/Surface":"bKX4y","../shape/Symbols":"ewu2Y","../util/types":"fLu4V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6J16n":[function(require,module,exports,__globalThis) {
/* eslint no-console: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", function() {
    return warn;
});
var isDev = false;
var warn = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ewu2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Symbols", function() {
    return Symbols;
});
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "type",
    "size",
    "sizeType"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var symbolFactories = {
    symbolCircle: (0, _d3Shape.symbolCircle),
    symbolCross: (0, _d3Shape.symbolCross),
    symbolDiamond: (0, _d3Shape.symbolDiamond),
    symbolSquare: (0, _d3Shape.symbolSquare),
    symbolStar: (0, _d3Shape.symbolStar),
    symbolTriangle: (0, _d3Shape.symbolTriangle),
    symbolWye: (0, _d3Shape.symbolWye)
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, _upperFirstDefault.default)(type));
    return symbolFactories[name] || (0, _d3Shape.symbolCircle);
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var registerSymbol = function registerSymbol(key, factory) {
    symbolFactories["symbol".concat((0, _upperFirstDefault.default)(key))] = factory;
};
var Symbols = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = getSymbolFactory(type);
        var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, _reactUtils.filterProps)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, filteredProps, {
        className: (0, _clsxDefault.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
Symbols.registerSymbol = registerSymbol;

},{"react":"gVheC","lodash/upperFirst":"8ljuM","victory-vendor/d3-shape":"4FHVD","clsx":"aGWRz","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4FHVD":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("19271802296fa753");

},{"19271802296fa753":"echE0"}],"echE0":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("176bd3ee52fdecae");

},{"176bd3ee52fdecae":"8Lp0j"}],"8Lp0j":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arc", {
    enumerable: true,
    get: function get() {
        return _arc.default;
    }
});
Object.defineProperty(exports, "area", {
    enumerable: true,
    get: function get() {
        return _area.default;
    }
});
Object.defineProperty(exports, "areaRadial", {
    enumerable: true,
    get: function get() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "curveBasis", {
    enumerable: true,
    get: function get() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "curveBasisClosed", {
    enumerable: true,
    get: function get() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "curveBasisOpen", {
    enumerable: true,
    get: function get() {
        return _basisOpen.default;
    }
});
Object.defineProperty(exports, "curveBumpX", {
    enumerable: true,
    get: function get() {
        return _bump.bumpX;
    }
});
Object.defineProperty(exports, "curveBumpY", {
    enumerable: true,
    get: function get() {
        return _bump.bumpY;
    }
});
Object.defineProperty(exports, "curveBundle", {
    enumerable: true,
    get: function get() {
        return _bundle.default;
    }
});
Object.defineProperty(exports, "curveCardinal", {
    enumerable: true,
    get: function get() {
        return _cardinal.default;
    }
});
Object.defineProperty(exports, "curveCardinalClosed", {
    enumerable: true,
    get: function get() {
        return _cardinalClosed.default;
    }
});
Object.defineProperty(exports, "curveCardinalOpen", {
    enumerable: true,
    get: function get() {
        return _cardinalOpen.default;
    }
});
Object.defineProperty(exports, "curveCatmullRom", {
    enumerable: true,
    get: function get() {
        return _catmullRom.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function get() {
        return _catmullRomClosed.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function get() {
        return _catmullRomOpen.default;
    }
});
Object.defineProperty(exports, "curveLinear", {
    enumerable: true,
    get: function get() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "curveLinearClosed", {
    enumerable: true,
    get: function get() {
        return _linearClosed.default;
    }
});
Object.defineProperty(exports, "curveMonotoneX", {
    enumerable: true,
    get: function get() {
        return _monotone.monotoneX;
    }
});
Object.defineProperty(exports, "curveMonotoneY", {
    enumerable: true,
    get: function get() {
        return _monotone.monotoneY;
    }
});
Object.defineProperty(exports, "curveNatural", {
    enumerable: true,
    get: function get() {
        return _natural.default;
    }
});
Object.defineProperty(exports, "curveStep", {
    enumerable: true,
    get: function get() {
        return _step.default;
    }
});
Object.defineProperty(exports, "curveStepAfter", {
    enumerable: true,
    get: function get() {
        return _step.stepAfter;
    }
});
Object.defineProperty(exports, "curveStepBefore", {
    enumerable: true,
    get: function get() {
        return _step.stepBefore;
    }
});
Object.defineProperty(exports, "line", {
    enumerable: true,
    get: function get() {
        return _line.default;
    }
});
Object.defineProperty(exports, "lineRadial", {
    enumerable: true,
    get: function get() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "link", {
    enumerable: true,
    get: function get() {
        return _link.link;
    }
});
Object.defineProperty(exports, "linkHorizontal", {
    enumerable: true,
    get: function get() {
        return _link.linkHorizontal;
    }
});
Object.defineProperty(exports, "linkRadial", {
    enumerable: true,
    get: function get() {
        return _link.linkRadial;
    }
});
Object.defineProperty(exports, "linkVertical", {
    enumerable: true,
    get: function get() {
        return _link.linkVertical;
    }
});
Object.defineProperty(exports, "pie", {
    enumerable: true,
    get: function get() {
        return _pie.default;
    }
});
Object.defineProperty(exports, "pointRadial", {
    enumerable: true,
    get: function get() {
        return _pointRadial.default;
    }
});
Object.defineProperty(exports, "radialArea", {
    enumerable: true,
    get: function get() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "radialLine", {
    enumerable: true,
    get: function get() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "stack", {
    enumerable: true,
    get: function get() {
        return _stack.default;
    }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function get() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "stackOffsetExpand", {
    enumerable: true,
    get: function get() {
        return _expand.default;
    }
});
Object.defineProperty(exports, "stackOffsetNone", {
    enumerable: true,
    get: function get() {
        return _none.default;
    }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function get() {
        return _silhouette.default;
    }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function get() {
        return _wiggle.default;
    }
});
Object.defineProperty(exports, "stackOrderAppearance", {
    enumerable: true,
    get: function get() {
        return _appearance.default;
    }
});
Object.defineProperty(exports, "stackOrderAscending", {
    enumerable: true,
    get: function get() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "stackOrderDescending", {
    enumerable: true,
    get: function get() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function get() {
        return _insideOut.default;
    }
});
Object.defineProperty(exports, "stackOrderNone", {
    enumerable: true,
    get: function get() {
        return _none2.default;
    }
});
Object.defineProperty(exports, "stackOrderReverse", {
    enumerable: true,
    get: function get() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "symbol", {
    enumerable: true,
    get: function get() {
        return _symbol.default;
    }
});
Object.defineProperty(exports, "symbolAsterisk", {
    enumerable: true,
    get: function get() {
        return _asterisk.default;
    }
});
Object.defineProperty(exports, "symbolCircle", {
    enumerable: true,
    get: function get() {
        return _circle.default;
    }
});
Object.defineProperty(exports, "symbolCross", {
    enumerable: true,
    get: function get() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "symbolDiamond", {
    enumerable: true,
    get: function get() {
        return _diamond.default;
    }
});
Object.defineProperty(exports, "symbolDiamond2", {
    enumerable: true,
    get: function get() {
        return _diamond2.default;
    }
});
Object.defineProperty(exports, "symbolPlus", {
    enumerable: true,
    get: function get() {
        return _plus.default;
    }
});
Object.defineProperty(exports, "symbolSquare", {
    enumerable: true,
    get: function get() {
        return _square.default;
    }
});
Object.defineProperty(exports, "symbolSquare2", {
    enumerable: true,
    get: function get() {
        return _square2.default;
    }
});
Object.defineProperty(exports, "symbolStar", {
    enumerable: true,
    get: function get() {
        return _star.default;
    }
});
Object.defineProperty(exports, "symbolTriangle", {
    enumerable: true,
    get: function get() {
        return _triangle.default;
    }
});
Object.defineProperty(exports, "symbolTriangle2", {
    enumerable: true,
    get: function get() {
        return _triangle2.default;
    }
});
Object.defineProperty(exports, "symbolWye", {
    enumerable: true,
    get: function get() {
        return _wye.default;
    }
});
Object.defineProperty(exports, "symbolX", {
    enumerable: true,
    get: function get() {
        return _x.default;
    }
});
Object.defineProperty(exports, "symbols", {
    enumerable: true,
    get: function get() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsFill", {
    enumerable: true,
    get: function get() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsStroke", {
    enumerable: true,
    get: function get() {
        return _symbol.symbolsStroke;
    }
});
var _arc = _interopRequireDefault(require("2d3f5974235d4d97"));
var _area = _interopRequireDefault(require("e7d6d9d0e4901d2e"));
var _line = _interopRequireDefault(require("bce35bc16739dbe5"));
var _pie = _interopRequireDefault(require("74b9b0848a30f56d"));
var _areaRadial = _interopRequireDefault(require("795a4987e33fc84"));
var _lineRadial = _interopRequireDefault(require("b1ce66d1195c070b"));
var _pointRadial = _interopRequireDefault(require("18b93f5355310e1c"));
var _link = require("661c14c96c31c97d");
var _symbol = _interopRequireWildcard(require("974cd54b219b5407"));
var _asterisk = _interopRequireDefault(require("3237a04f4f14fca5"));
var _circle = _interopRequireDefault(require("d06ad8106b0de21c"));
var _cross = _interopRequireDefault(require("871a2983fe1eb51f"));
var _diamond = _interopRequireDefault(require("d1ef85359a4dd212"));
var _diamond2 = _interopRequireDefault(require("3dea65984f117ec1"));
var _plus = _interopRequireDefault(require("1565ec3cf1a7613a"));
var _square = _interopRequireDefault(require("9285c34ad7b613e4"));
var _square2 = _interopRequireDefault(require("c6e9c9d35fa5b5cb"));
var _star = _interopRequireDefault(require("815abfb8fc8798e0"));
var _triangle = _interopRequireDefault(require("431e53334965b545"));
var _triangle2 = _interopRequireDefault(require("64d0ff16b783fd6c"));
var _wye = _interopRequireDefault(require("6bcb4260ac11e7b8"));
var _x = _interopRequireDefault(require("f8ed4fd677a8b4d9"));
var _basisClosed = _interopRequireDefault(require("91e47160fd76a75d"));
var _basisOpen = _interopRequireDefault(require("3cfac39a85530a37"));
var _basis = _interopRequireDefault(require("f697ba81082957cf"));
var _bump = require("2bea78dcacfdca47");
var _bundle = _interopRequireDefault(require("e82aff58f59c7695"));
var _cardinalClosed = _interopRequireDefault(require("c72e75e517eac392"));
var _cardinalOpen = _interopRequireDefault(require("9217e81617e05b4"));
var _cardinal = _interopRequireDefault(require("1dd79a3764c6f2bf"));
var _catmullRomClosed = _interopRequireDefault(require("aee7da70ecf7456b"));
var _catmullRomOpen = _interopRequireDefault(require("6d5f31fa960dcbe2"));
var _catmullRom = _interopRequireDefault(require("3a4d3052f18b3d40"));
var _linearClosed = _interopRequireDefault(require("46142d6a54d00966"));
var _linear = _interopRequireDefault(require("e55fce1282a99ed7"));
var _monotone = require("fad9762fa89b7933");
var _natural = _interopRequireDefault(require("188623ab79fe5f6b"));
var _step = _interopRequireWildcard(require("48bb2877ede27508"));
var _stack = _interopRequireDefault(require("39fd6af83767c8b0"));
var _expand = _interopRequireDefault(require("17e05ad95922030d"));
var _diverging = _interopRequireDefault(require("a216beddff4c3a08"));
var _none = _interopRequireDefault(require("b09a2130bd13b1e0"));
var _silhouette = _interopRequireDefault(require("70400e7acef40477"));
var _wiggle = _interopRequireDefault(require("b9b44fd8f75e0415"));
var _appearance = _interopRequireDefault(require("fd3023466e7ac9e7"));
var _ascending = _interopRequireDefault(require("46c02ef8fc93b026"));
var _descending = _interopRequireDefault(require("a5a0ae33dd14b3b0"));
var _insideOut = _interopRequireDefault(require("43469f5cea84b12e"));
var _none2 = _interopRequireDefault(require("68f36eef1efe200b"));
var _reverse = _interopRequireDefault(require("a5f086840207a549"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"@swc/helpers/_/_type_of":"668P4","2d3f5974235d4d97":"h2K15","e7d6d9d0e4901d2e":"a8UVq","bce35bc16739dbe5":"6DwWL","74b9b0848a30f56d":"5zEUJ","795a4987e33fc84":"jNLQO","b1ce66d1195c070b":"94Ctw","18b93f5355310e1c":"lkCW3","661c14c96c31c97d":"apP9P","974cd54b219b5407":"aHtDT","3237a04f4f14fca5":"b6Ie7","d06ad8106b0de21c":"apPKE","871a2983fe1eb51f":"9cREc","d1ef85359a4dd212":"iraCK","3dea65984f117ec1":"5kSy4","1565ec3cf1a7613a":"dE5N3","9285c34ad7b613e4":"gKFmO","c6e9c9d35fa5b5cb":"37FQo","815abfb8fc8798e0":"4gjEl","431e53334965b545":"9wVCg","64d0ff16b783fd6c":"5yYd6","6bcb4260ac11e7b8":"kQDst","f8ed4fd677a8b4d9":"fOzg2","91e47160fd76a75d":"d4PbN","3cfac39a85530a37":"9Mz1c","f697ba81082957cf":"hMhZU","2bea78dcacfdca47":"aXMF2","e82aff58f59c7695":"u3ccf","c72e75e517eac392":"2Xj5R","9217e81617e05b4":"cSYgf","1dd79a3764c6f2bf":"3gmJK","aee7da70ecf7456b":"bBP9D","6d5f31fa960dcbe2":"cNhv6","3a4d3052f18b3d40":"gu9M9","46142d6a54d00966":"lyU1b","e55fce1282a99ed7":"7rriC","fad9762fa89b7933":"4CDdG","188623ab79fe5f6b":"cUiSY","48bb2877ede27508":"lhY2c","39fd6af83767c8b0":"cWpd1","17e05ad95922030d":"lU9y0","a216beddff4c3a08":"avTNv","b09a2130bd13b1e0":"8pV8q","70400e7acef40477":"3LMtt","b9b44fd8f75e0415":"5GlKH","fd3023466e7ac9e7":"3XG3H","46c02ef8fc93b026":"9fEH8","a5a0ae33dd14b3b0":"gLh5c","43469f5cea84b12e":"b5EQm","68f36eef1efe200b":"hxV4c","a5f086840207a549":"iJICc"}],"h2K15":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("9b71135f97bb0843");
var _constant = _interopRequireDefault(require("b66d56b93af4da33"));
var _math = require("53b6f54f25927f26");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < _math.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function _default() {
    var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constant.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - _math.halfPi, a1 = endAngle.apply(this, arguments) - _math.halfPi, da = (0, _math.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, _index.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > _math.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > _math.tau - _math.epsilon) {
            context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > _math.epsilon) {
                context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > _math.epsilon) {
                var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)), p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
                if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, _math.cos)(a01), y01 = r1 * (0, _math.sin)(a01), x10 = r0 * (0, _math.cos)(a10), y10 = r0 * (0, _math.sin)(a10); // Apply rounded corners?
            if (rc > _math.epsilon) {
                var x11 = r1 * (0, _math.cos)(a11), y11 = r1 * (0, _math.sin)(a11), x00 = r0 * (0, _math.cos)(a00), y00 = r0 * (0, _math.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < _math.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2), lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > _math.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > _math.epsilon) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > _math.epsilon) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
        return [
            (0, _math.cos)(a) * r,
            (0, _math.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

},{"9b71135f97bb0843":"2bsTn","b66d56b93af4da33":"gLf2W","53b6f54f25927f26":"fZ5Fm"}],"2bsTn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "path", {
    enumerable: true,
    get: function get() {
        return _path.default;
    }
});
var _path = _interopRequireDefault(require("3b0cf72f61f38e1e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"3b0cf72f61f38e1e":"5wKcQ"}],"5wKcQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path();
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function moveTo(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function lineTo(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function rect(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function toString() {
        return this._;
    }
};
var _default = path;
exports.default = _default;

},{}],"gLf2W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return function constant() {
        return x;
    };
}

},{}],"fZ5Fm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abs = void 0;
exports.acos = acos;
exports.asin = asin;
exports.tau = exports.sqrt = exports.sin = exports.pi = exports.min = exports.max = exports.halfPi = exports.epsilon = exports.cos = exports.atan2 = void 0;
var abs = Math.abs;
exports.abs = abs;
var atan2 = Math.atan2;
exports.atan2 = atan2;
var cos = Math.cos;
exports.cos = cos;
var max = Math.max;
exports.max = max;
var min = Math.min;
exports.min = min;
var sin = Math.sin;
exports.sin = sin;
var sqrt = Math.sqrt;
exports.sqrt = sqrt;
var epsilon = 1e-12;
exports.epsilon = epsilon;
var pi = Math.PI;
exports.pi = pi;
var halfPi = pi / 2;
exports.halfPi = halfPi;
var tau = 2 * pi;
exports.tau = tau;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{}],"a8UVq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("500493761fddc3b8");
var _array = _interopRequireDefault(require("bbf8fdbd92f1ebcd"));
var _constant = _interopRequireDefault(require("a5b783eee5be8fa0"));
var _linear = _interopRequireDefault(require("f4129b2496ff7a8b"));
var _line = _interopRequireDefault(require("b3caf3b68a2e9f58"));
var _point = require("ea923553657b0095");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x0, y0, y1) {
    var x1 = null, defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point.x : (0, _constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant.default)(0) : (0, _constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point.y : (0, _constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, _line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

},{"500493761fddc3b8":"2bsTn","bbf8fdbd92f1ebcd":"fTam0","a5b783eee5be8fa0":"gLf2W","f4129b2496ff7a8b":"7rriC","b3caf3b68a2e9f58":"6DwWL","ea923553657b0095":"fwxPe"}],"fTam0":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.slice = void 0;
var slice = Array.prototype.slice;
exports.slice = slice;
function _default(x) {
    return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

},{"@swc/helpers/_/_type_of":"668P4"}],"7rriC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function _default(context) {
    return new Linear(context);
}

},{}],"6DwWL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("98710a8cd2690312");
var _array = _interopRequireDefault(require("71eeea1751dcd149"));
var _constant = _interopRequireDefault(require("9083cb1503140862"));
var _linear = _interopRequireDefault(require("c81bc5ab811126a3"));
var _point = require("552145ba71b64707");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x, y) {
    var defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? _point.x : (0, _constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? _point.y : (0, _constant.default)(y);
    function line(data) {
        var i, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

},{"98710a8cd2690312":"2bsTn","71eeea1751dcd149":"fTam0","9083cb1503140862":"gLf2W","c81bc5ab811126a3":"7rriC","552145ba71b64707":"fwxPe"}],"fwxPe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.x = x;
exports.y = y;
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{}],"5zEUJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("b67e0ae37b57d123"));
var _constant = _interopRequireDefault(require("37710d2df9ce0c7a"));
var _descending = _interopRequireDefault(require("a28172d9eab0febf"));
var _identity = _interopRequireDefault(require("e5c1f58030d4bf4f"));
var _math = require("496c2d9cd8d2f75c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default() {
    var value = _identity.default, sortValues = _descending.default, sort = null, startAngle = (0, _constant.default)(0), endAngle = (0, _constant.default)(_math.tau), padAngle = (0, _constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, _array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

},{"b67e0ae37b57d123":"fTam0","37710d2df9ce0c7a":"gLf2W","a28172d9eab0febf":"cbGM6","e5c1f58030d4bf4f":"h2YSd","496c2d9cd8d2f75c":"fZ5Fm"}],"cbGM6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"h2YSd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(d) {
    return d;
}

},{}],"jNLQO":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _radial = _interopRequireWildcard(require("d5f2199be7e4428"));
var _area = _interopRequireDefault(require("9fd6b69a882b62b9"));
var _lineRadial = require("4727a97bf0f56e5e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _default() {
    var a = (0, _area.default)().curve(_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, _lineRadial.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, _lineRadial.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, _lineRadial.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, _lineRadial.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return a;
}

},{"@swc/helpers/_/_type_of":"668P4","d5f2199be7e4428":"fGUE9","9fd6b69a882b62b9":"a8UVq","4727a97bf0f56e5e":"94Ctw"}],"fGUE9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.curveRadialLinear = void 0;
exports.default = curveRadial;
var _linear = _interopRequireDefault(require("fcbc4ed98c33ce63"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var curveRadialLinear = curveRadial(_linear.default);
exports.curveRadialLinear = curveRadialLinear;
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function areaStart() {
        this._curve.areaStart();
    },
    areaEnd: function areaEnd() {
        this._curve.areaEnd();
    },
    lineStart: function lineStart() {
        this._curve.lineStart();
    },
    lineEnd: function lineEnd() {
        this._curve.lineEnd();
    },
    point: function point(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"fcbc4ed98c33ce63":"7rriC"}],"94Ctw":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.lineRadial = lineRadial;
var _radial = _interopRequireWildcard(require("467073d1fc4d6144"));
var _line = _interopRequireDefault(require("b165a0178810938"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return l;
}
function _default() {
    return lineRadial((0, _line.default)().curve(_radial.curveRadialLinear));
}

},{"@swc/helpers/_/_type_of":"668P4","467073d1fc4d6144":"fGUE9","b165a0178810938":"6DwWL"}],"lkCW3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

},{}],"apP9P":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.link = link;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
var _index = require("ae6bae8009c48266");
var _array = require("3bac10be5f465a96");
var _constant = _interopRequireDefault(require("35364e9c346d01b7"));
var _bump = require("ce2d1a2cbddf3802");
var _point = require("be0eb0a3ebd67c05");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    var source = linkSource;
    var target = linkTarget;
    var x = _point.x;
    var y = _point.y;
    var context = null;
    var output = null;
    function link() {
        var buffer;
        var argv = _array.slice.call(arguments);
        var s = source.apply(this, argv);
        var t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, _index.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link(_bump.bumpX);
}
function linkVertical() {
    return link(_bump.bumpY);
}
function linkRadial() {
    var l = link(_bump.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"ae6bae8009c48266":"2bsTn","3bac10be5f465a96":"fTam0","35364e9c346d01b7":"gLf2W","ce2d1a2cbddf3802":"aXMF2","be0eb0a3ebd67c05":"fwxPe"}],"aXMF2":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bumpRadial = bumpRadial;
exports.bumpX = bumpX;
exports.bumpY = bumpY;
var _pointRadial = _interopRequireDefault(require("b619d14f2ed97e73"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Bump = /*#__PURE__*/ function() {
    function Bump(context, x) {
        (0, _classCallCheck._)(this, Bump);
        this._context = context;
        this._x = x;
    }
    (0, _createClass._)(Bump, [
        {
            key: "areaStart",
            value: function areaStart() {
                this._line = 0;
            }
        },
        {
            key: "areaEnd",
            value: function areaEnd() {
                this._line = NaN;
            }
        },
        {
            key: "lineStart",
            value: function lineStart() {
                this._point = 0;
            }
        },
        {
            key: "lineEnd",
            value: function lineEnd() {
                if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
                this._line = 1 - this._line;
            }
        },
        {
            key: "point",
            value: function point(x, y) {
                x = +x, y = +y;
                switch(this._point){
                    case 0:
                        this._point = 1;
                        if (this._line) this._context.lineTo(x, y);
                        else this._context.moveTo(x, y);
                        break;
                    case 1:
                        this._point = 2;
                    // falls through
                    default:
                        if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                        else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                        break;
                }
                this._x0 = x, this._y0 = y;
            }
        }
    ]);
    return Bump;
}();
var BumpRadial = /*#__PURE__*/ function() {
    function BumpRadial(context) {
        (0, _classCallCheck._)(this, BumpRadial);
        this._context = context;
    }
    (0, _createClass._)(BumpRadial, [
        {
            key: "lineStart",
            value: function lineStart() {
                this._point = 0;
            }
        },
        {
            key: "lineEnd",
            value: function lineEnd() {}
        },
        {
            key: "point",
            value: function point(x, y) {
                x = +x, y = +y;
                if (this._point++ === 0) this._x0 = x, this._y0 = y;
                else {
                    var _this__context, _this__context1;
                    var p0 = (0, _pointRadial.default)(this._x0, this._y0);
                    var p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
                    var p2 = (0, _pointRadial.default)(x, this._y0);
                    var p3 = (0, _pointRadial.default)(x, y);
                    (_this__context = this._context).moveTo.apply(_this__context, (0, _toConsumableArray._)(p0));
                    (_this__context1 = this._context).bezierCurveTo.apply(_this__context1, (0, _toConsumableArray._)(p1).concat((0, _toConsumableArray._)(p2), (0, _toConsumableArray._)(p3)));
                }
            }
        }
    ]);
    return BumpRadial;
}();
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_to_consumable_array":"4zJ2w","b619d14f2ed97e73":"lkCW3"}],"aHtDT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Symbol;
exports.symbolsStroke = exports.symbolsFill = void 0;
var _index = require("ed221954c3cadd8c");
var _constant = _interopRequireDefault(require("a318f579ae289bb4"));
var _asterisk = _interopRequireDefault(require("4f836b828c4aee2"));
var _circle = _interopRequireDefault(require("a3d59dddf62412f7"));
var _cross = _interopRequireDefault(require("b51ad47cf070e0d4"));
var _diamond = _interopRequireDefault(require("a8375ed091b8d08a"));
var _diamond2 = _interopRequireDefault(require("7c0f9eaf6c7614f0"));
var _plus = _interopRequireDefault(require("459ff396a52f1e2d"));
var _square = _interopRequireDefault(require("174dac6271fe5f76"));
var _square2 = _interopRequireDefault(require("444710f2180a0669"));
var _star = _interopRequireDefault(require("1f31f8ec57f98fa6"));
var _triangle = _interopRequireDefault(require("f4d77aaf9ffb5dbd"));
var _triangle2 = _interopRequireDefault(require("80c17c4ac5160020"));
var _wye = _interopRequireDefault(require("2da15e99e0fdb804"));
var _x = _interopRequireDefault(require("67fc72d8d3ef7cbf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
var symbolsFill = [
    _circle.default,
    _cross.default,
    _diamond.default,
    _square.default,
    _star.default,
    _triangle.default,
    _wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
exports.symbolsFill = symbolsFill;
var symbolsStroke = [
    _circle.default,
    _plus.default,
    _x.default,
    _triangle2.default,
    _asterisk.default,
    _square2.default,
    _diamond2.default
];
exports.symbolsStroke = symbolsStroke;
function Symbol(type, size) {
    var context = null;
    type = typeof type === "function" ? type : (0, _constant.default)(type || _circle.default);
    size = typeof size === "function" ? size : (0, _constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, _index.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"ed221954c3cadd8c":"2bsTn","a318f579ae289bb4":"gLf2W","4f836b828c4aee2":"b6Ie7","a3d59dddf62412f7":"apPKE","b51ad47cf070e0d4":"9cREc","a8375ed091b8d08a":"iraCK","7c0f9eaf6c7614f0":"5kSy4","459ff396a52f1e2d":"dE5N3","174dac6271fe5f76":"gKFmO","444710f2180a0669":"37FQo","1f31f8ec57f98fa6":"4gjEl","f4d77aaf9ffb5dbd":"9wVCg","80c17c4ac5160020":"5yYd6","2da15e99e0fdb804":"kQDst","67fc72d8d3ef7cbf":"fOzg2"}],"b6Ie7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("48d3e9f7df1a172c");
var sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size + (0, _math.min)(size / 28, 0.75)) * 0.59436;
        var t = r / 2;
        var u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
exports.default = _default;

},{"48d3e9f7df1a172c":"fZ5Fm"}],"apPKE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("8ed2e3009b93c9bf");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size / _math.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, _math.tau);
    }
};
exports.default = _default;

},{"8ed2e3009b93c9bf":"fZ5Fm"}],"9cREc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("69815bae4b0787ae");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"69815bae4b0787ae":"fZ5Fm"}],"iraCK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("856b74e87be6d6a0");
var tan30 = (0, _math.sqrt)(1 / 3);
var tan30_2 = tan30 * 2;
var _default = {
    draw: function(context, size) {
        var y = (0, _math.sqrt)(size / tan30_2);
        var x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"856b74e87be6d6a0":"fZ5Fm"}],"5kSy4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("c8441956b7ca25b0");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"c8441956b7ca25b0":"fZ5Fm"}],"dE5N3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a4abcfa52e8b0f37");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size - (0, _math.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
exports.default = _default;

},{"a4abcfa52e8b0f37":"fZ5Fm"}],"gKFmO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("e72da19a42674d7c");
var _default = {
    draw: function(context, size) {
        var w = (0, _math.sqrt)(size);
        var x = -w / 2;
        context.rect(x, x, w, w);
    }
};
exports.default = _default;

},{"e72da19a42674d7c":"fZ5Fm"}],"37FQo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("1c9d5bda227640bf");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"1c9d5bda227640bf":"fZ5Fm"}],"4gjEl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("751667ddf3bfbdc1");
var ka = 0.89081309152928522810;
var kr = (0, _math.sin)(_math.pi / 10) / (0, _math.sin)(7 * _math.pi / 10);
var kx = (0, _math.sin)(_math.tau / 10) * kr;
var ky = -(0, _math.cos)(_math.tau / 10) * kr;
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size * ka);
        var x = kx * r;
        var y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = _math.tau * i / 5;
            var c = (0, _math.cos)(a);
            var s = (0, _math.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
exports.default = _default;

},{"751667ddf3bfbdc1":"fZ5Fm"}],"9wVCg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7bc957b4c8d38817");
var sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw: function(context, size) {
        var y = -(0, _math.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};
exports.default = _default;

},{"7bc957b4c8d38817":"fZ5Fm"}],"5yYd6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7e4bb208ad9cf3ec");
var sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw: function(context, size) {
        var s = (0, _math.sqrt)(size) * 0.6824;
        var t = s / 2;
        var u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
exports.default = _default;

},{"7e4bb208ad9cf3ec":"fZ5Fm"}],"kQDst":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("812e1ff9b9a68f0d");
var c = -0.5;
var s = (0, _math.sqrt)(3) / 2;
var k = 1 / (0, _math.sqrt)(12);
var a = (k / 2 + 1) * 3;
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size / a);
        var x0 = r / 2, y0 = r * k;
        var x1 = x0, y1 = r * k + r;
        var x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};
exports.default = _default;

},{"812e1ff9b9a68f0d":"fZ5Fm"}],"fOzg2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("6e8e98e197afefc3");
var _default = {
    draw: function(context, size) {
        var r = (0, _math.sqrt)(size - (0, _math.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
exports.default = _default;

},{"6e8e98e197afefc3":"fZ5Fm"}],"d4PbN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("8620520ba80e006a"));
var _basis = require("87413069402f4f60");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisClosed(context);
}

},{"8620520ba80e006a":"j1KDx","87413069402f4f60":"hMhZU"}],"j1KDx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default() {}

},{}],"hMhZU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Basis = Basis;
exports.default = _default;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new Basis(context);
}

},{}],"9Mz1c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("580a0e4914be358e");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisOpen(context);
}

},{"580a0e4914be358e":"hMhZU"}],"u3ccf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _basis = require("202e66c93596d8c0");
function Bundle(context, beta) {
    this._basis = new _basis.Basis(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var _default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
exports.default = _default;

},{"202e66c93596d8c0":"hMhZU"}],"2Xj5R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalClosed = CardinalClosed;
exports.default = void 0;
var _noop = _interopRequireDefault(require("3ac7c5e1248dc9ae"));
var _cardinal = require("cfbcda1bc3207e7e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"3ac7c5e1248dc9ae":"j1KDx","cfbcda1bc3207e7e":"3gmJK"}],"3gmJK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cardinal = Cardinal;
exports.default = void 0;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{}],"cSYgf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalOpen = CardinalOpen;
exports.default = void 0;
var _cardinal = require("cf4363a3b836d23a");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"cf4363a3b836d23a":"3gmJK"}],"bBP9D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalClosed = require("f5ae01d2345d4943");
var _noop = _interopRequireDefault(require("82484b434a1d31db"));
var _catmullRom = require("3bd3d5af820e50ff");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"f5ae01d2345d4943":"2Xj5R","82484b434a1d31db":"j1KDx","3bd3d5af820e50ff":"gu9M9"}],"gu9M9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;
var _math = require("d464c344292067de");
var _cardinal = require("2f2af409b067cecd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > _math.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > _math.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"d464c344292067de":"fZ5Fm","2f2af409b067cecd":"3gmJK"}],"cNhv6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalOpen = require("97b1c5692429330d");
var _catmullRom = require("9847de9b9e7ea36b");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"97b1c5692429330d":"cSYgf","9847de9b9e7ea36b":"gu9M9"}],"lyU1b":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("bb3255f3276eba36"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._point) this._context.closePath();
    },
    point: function point(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function _default(context) {
    return new LinearClosed(context);
}

},{"bb3255f3276eba36":"j1KDx"}],"4CDdG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monotoneX = monotoneX;
exports.monotoneY = monotoneY;
function sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point1(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function moveTo(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function closePath() {
        this._context.closePath();
    },
    lineTo: function lineTo(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{}],"cUiSY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function lineEnd() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function point(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function _default(context) {
    return new Natural(context);
}

},{}],"lhY2c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.stepAfter = stepAfter;
exports.stepBefore = stepBefore;
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function _default(context) {
    return new Step(context, 0.5);
}
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{}],"cWpd1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("8b3b605fa9e4fac5"));
var _constant = _interopRequireDefault(require("e744701481d85f49"));
var _none = _interopRequireDefault(require("e54b6b0ae39944a2"));
var _none2 = _interopRequireDefault(require("e9814568a9c80598"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    var series = [];
    series.key = key;
    return series;
}
function _default() {
    var keys = (0, _constant.default)([]), order = _none2.default, offset = _none.default, value = stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                    0,
                    +value(d, sz[i].key, j, data)
                ]).data = d;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(i = 0, oz = (0, _array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? _none.default : _, stack) : offset;
    };
    return stack;
}

},{"8b3b605fa9e4fac5":"fTam0","e744701481d85f49":"gLf2W","e54b6b0ae39944a2":"8pV8q","e9814568a9c80598":"hxV4c"}],"8pV8q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

},{}],"hxV4c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

},{}],"lU9y0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("d8cdcff221711407"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, _none.default)(series, order);
}

},{"d8cdcff221711407":"8pV8q"}],"avTNv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

},{}],"3LMtt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("af9c5fa37c1b1d9e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, _none.default)(series, order);
}

},{"af9c5fa37c1b1d9e":"8pV8q"}],"5GlKH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("56eb12e1b2174aaf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, _none.default)(series, order);
}

},{"56eb12e1b2174aaf":"8pV8q"}],"3XG3H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("4494c675f3e20319"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var peaks = series.map(peak);
    return (0, _none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"4494c675f3e20319":"hxV4c"}],"9fEH8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.sum = sum;
var _none = _interopRequireDefault(require("4a7d728f9a184a25"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var sums = series.map(sum);
    return (0, _none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"4a7d728f9a184a25":"hxV4c"}],"gLh5c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _ascending = _interopRequireDefault(require("d39a3ba1232418c4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _ascending.default)(series).reverse();
}

},{"d39a3ba1232418c4":"9fEH8"}],"b5EQm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _appearance = _interopRequireDefault(require("7e770dfcdf2ff59a"));
var _ascending = require("12f0fe8581e206");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var n = series.length, i, j, sums = series.map(_ascending.sum), order = (0, _appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

},{"7e770dfcdf2ff59a":"3XG3H","12f0fe8581e206":"9fEH8"}],"iJICc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("175f4f386d8ceefb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _none.default)(series).reverse();
}

},{"175f4f386d8ceefb":"hxV4c"}],"d0DrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */ parcelHelpers.export(exports, "getUniqPayload", function() {
    return getUniqPayload;
});
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
function getUniqPayload(payload, option, defaultUniqBy) {
    if (option === true) return (0, _uniqByDefault.default)(payload, defaultUniqBy);
    if ((0, _isFunctionDefault.default)(option)) return (0, _uniqByDefault.default)(payload, option);
    return payload;
}

},{"lodash/uniqBy":"2YIDS","lodash/isFunction":"8ck2f","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ICZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", function() {
    return Tooltip;
});
/**
 * @fileOverview Tooltip
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultTooltipContent = require("./DefaultTooltipContent");
var _tooltipBoundingBox = require("./TooltipBoundingBox");
var _global = require("../util/Global");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultUniqBy(entry) {
    return entry.dataKey;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultTooltipContent.DefaultTooltipContent), props);
}
var Tooltip = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        _classCallCheck(this, Tooltip);
        return _callSuper(this, Tooltip, arguments);
    }
    _inherits(Tooltip, _PureComponent);
    return _createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, _getUniqPayload.getUniqPayload)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipBoundingBox.TooltipBoundingBox), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Tooltip, "displayName", 'Tooltip');
_defineProperty(Tooltip, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, _global.Global).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});

},{"react":"gVheC","./DefaultTooltipContent":"hTy6n","./TooltipBoundingBox":"baQok","../util/Global":"h7WEa","../util/payload/getUniqPayload":"d0DrX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hTy6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTooltipContent", function() {
    return DefaultTooltipContent;
});
/**
 * @fileOverview Default Tooltip Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultFormatter(value) {
    return Array.isArray(value) && (0, _dataUtils.isNumOrStr)(value[0]) && (0, _dataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
var DefaultTooltipContent = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, _sortByDefault.default)(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = _objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = _slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, _reactDefault.default).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = _objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, _isNilDefault.default)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, _clsxDefault.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, _clsxDefault.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

},{"react":"gVheC","lodash/sortBy":"4jc9z","lodash/isNil":"beGyX","clsx":"aGWRz","../util/DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4jc9z":[function(require,module,exports,__globalThis) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"8iQ0s","2553e45e897c3cba":"92uga","9df1e918b0eea173":"7EAh7","36218471fd8f4dda":"936XO"}],"baQok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipBoundingBox", function() {
    return TooltipBoundingBox;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _translate = require("../util/tooltip/translate");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var EPSILON = 1;
var TooltipBoundingBox = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        _classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TooltipBoundingBox, [].concat(args));
        _defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        _defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    _inherits(TooltipBoundingBox, _PureComponent);
    return _createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, _translate.getTooltipTranslate)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = _objectSpread(_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, _reactDefault.default).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, _react.PureComponent));

},{"react":"gVheC","../util/tooltip/translate":"eaapv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eaapv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipCSSClassName", function() {
    return getTooltipCSSClassName;
});
parcelHelpers.export(exports, "getTooltipTranslateXY", function() {
    return getTooltipTranslateXY;
});
parcelHelpers.export(exports, "getTransformStyle", function() {
    return getTransformStyle;
});
parcelHelpers.export(exports, "getTooltipTranslate", function() {
    return getTooltipTranslate;
});
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function getTooltipCSSClassName(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, _clsxDefault.default)(CSS_CLASS_PREFIX, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(CSS_CLASS_PREFIX, "-right"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, _dataUtils.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function getTooltipTranslate(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = getTransformStyle({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: getTooltipCSSClassName({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

},{"clsx":"aGWRz","../DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h7WEa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Global", function() {
    return Global;
});
var parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
    isSsr: parseIsSsrByDefault(),
    get: function get(key) {
        return Global[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') Global[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                Global[k] = key[k];
            });
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9rd5w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainer", function() {
    return ResponsiveContainer;
});
/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */ var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, _react.useRef)(null);
    var onResizeRef = (0, _react.useRef)();
    onResizeRef.current = onResize;
    (0, _react.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, _react.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = _slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, _react.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, _react.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, _throttleDefault.default)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, _react.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, _logUtils.warn)((0, _dataUtils.isPercent)(width) || (0, _dataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, _logUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, _dataUtils.isPercent)(width) ? containerWidth : width;
        var calculatedHeight = (0, _dataUtils.isPercent)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, _logUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, _reactUtils.getDisplayName)(children.type).endsWith('Chart');
        return (0, _reactDefault.default).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) return /*#__PURE__*/ (0, _react.cloneElement)(child, _objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: _objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, _clsxDefault.default)('recharts-responsive-container', className),
        style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

},{"clsx":"aGWRz","react":"gVheC","lodash/throttle":"6S8E3","../util/DataUtils":"c1vtt","../util/LogUtils":"6J16n","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6S8E3":[function(require,module,exports,__globalThis) {
var debounce = require("5b383646e2c7b4c6"), isObject = require("a29ce0b3e78d037d");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = throttle;

},{"5b383646e2c7b4c6":"2YGZm","a29ce0b3e78d037d":"8ffGS"}],"2YGZm":[function(require,module,exports,__globalThis) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"8ffGS","575b2317167ce20d":"2h8oL","a13332670c5c0f63":"6gmL5"}],"2h8oL":[function(require,module,exports,__globalThis) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function now() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"cN4l5"}],"7blff":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Cross
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", function() {
    return Cell;
});
var Cell = function Cell(_props) {
    return null;
};
Cell.displayName = 'Cell';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"31dv8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", function() {
    return Text;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _reactUtils = require("../util/ReactUtils");
var _domutils = require("../util/DOMUtils");
var _reduceCSSCalc = require("../util/ReduceCSSCalc");
var _excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], _excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, _isNilDefault.default)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split(BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, _domutils.getStringSize)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, _domutils.getStringSize)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, _dataUtils.isNumber)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, _isNilDefault.default)(children) ? children.toString().split(BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, _global.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return getWordsWithoutCalculate(children);
        return calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = '#808080';
var Text = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties(_ref5, _excluded);
    var wordsByLines = (0, _react.useMemo)(function() {
        return getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties(props, _excluded2);
    if (!(0, _dataUtils.isNumOrStr)(propsX) || !(0, _dataUtils.isNumOrStr)(propsY)) return null;
    var x = propsX + ((0, _dataUtils.isNumber)(dx) ? dx : 0);
    var y = propsY + ((0, _dataUtils.isNumber)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, _dataUtils.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, (0, _reactUtils.filterProps)(textProps, true), {
        x: x,
        y: y,
        className: (0, _clsxDefault.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, _reactDefault.default).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};

},{"react":"gVheC","lodash/isNil":"beGyX","clsx":"aGWRz","../util/DataUtils":"c1vtt","../util/Global":"h7WEa","../util/ReactUtils":"bLejJ","../util/DOMUtils":"427P0","../util/ReduceCSSCalc":"igixC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"427P0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleString", function() {
    return getStyleString;
});
parcelHelpers.export(exports, "getStringSize", function() {
    return getStringSize;
});
parcelHelpers.export(exports, "getOffset", function() {
    return getOffset;
});
var _global = require("./Global");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var stringCache = {
    widthCache: {},
    cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function autoCompleteStyle(name, value) {
    if (STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat(_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat(_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var getStyleString = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function removeInvalidKeys(obj) {
    var copyObj = _objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var getStringSize = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, _global.Global).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if (stringCache.widthCache[cacheKey]) return stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = _objectSpread(_objectSpread({}, SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        stringCache.widthCache[cacheKey] = result;
        if (++stringCache.cacheCount > MAX_CACHE_NUM) {
            stringCache.cacheCount = 0;
            stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var getOffset = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};

},{"./Global":"h7WEa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"igixC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeEvaluateExpression", function() {
    return safeEvaluateExpression;
});
parcelHelpers.export(exports, "reduceCSSCalc", function() {
    return reduceCSSCalc;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = 'NaN';
function convertToPx(value, unit) {
    return value * CONVERSION_RATES[unit];
}
var DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        _classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if (FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return _createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function calculateArithmetic(expr) {
    if (expr.includes(STR_NAN)) return STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = calculateParentheses(newExpr);
    newExpr = calculateArithmetic(newExpr);
    return newExpr;
}
function safeEvaluateExpression(expression) {
    try {
        return evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return STR_NAN;
    }
}
function reduceCSSCalc(expression) {
    var result = safeEvaluateExpression(expression.slice(5, -1));
    if (result === STR_NAN) // notify the user
    return '';
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fRyNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", function() {
    return Label;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("./Text");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "offset"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, _isNilDefault.default)(props.children) ? value : props.children;
    if ((0, _isFunctionDefault.default)(formatter)) return formatter(label);
    return label;
};
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, _isNilDefault.default)(labelProps.id) ? (0, _dataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, _clsxDefault.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, _polarUtils.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return _objectSpread(_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return _objectSpread(_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return _objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return _objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, _isObjectDefault.default)(position) && ((0, _dataUtils.isNumber)(position.x) || (0, _dataUtils.isPercent)(position.x)) && ((0, _dataUtils.isNumber)(position.y) || (0, _dataUtils.isPercent)(position.y))) return _objectSpread({
        x: x + (0, _dataUtils.getPercentValue)(position.x, width),
        y: y + (0, _dataUtils.getPercentValue)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return _objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, _dataUtils.isNumber)(viewBox.cx);
};
function Label(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties(_ref4, _excluded);
    var props = _objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, _isNilDefault.default)(value) && (0, _isNilDefault.default)(children) && !/*#__PURE__*/ (0, _react.isValidElement)(content) && !(0, _isFunctionDefault.default)(content)) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(content)) return /*#__PURE__*/ (0, _react.cloneElement)(content, props);
    var label;
    if ((0, _isFunctionDefault.default)(content)) {
        label = /*#__PURE__*/ (0, _react.createElement)(content, props);
        if (/*#__PURE__*/ (0, _react.isValidElement)(label)) return label;
    } else label = getLabel(props);
    var isPolarLabel = isPolar(viewBox);
    var attrs = (0, _reactUtils.filterProps)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        className: (0, _clsxDefault.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
Label.displayName = 'Label';
var parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, _dataUtils.isNumber)(width) && (0, _dataUtils.isNumber)(height)) {
        if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, _dataUtils.isNumber)(top) && (0, _dataUtils.isNumber)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, _dataUtils.isNumOrStr)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, _react.isValidElement)(label)) {
        if (label.type === Label) return /*#__PURE__*/ (0, _react.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, _extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = parseViewBox(parentProps);
    var explicitChildren = (0, _reactUtils.findAllByType)(children, Label).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat(_toConsumableArray(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

},{"react":"gVheC","lodash/isNil":"beGyX","lodash/isFunction":"8ck2f","lodash/isObject":"8ffGS","clsx":"aGWRz","./Text":"31dv8","../util/ReactUtils":"bLejJ","../util/DataUtils":"c1vtt","../util/PolarUtils":"b4tu9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b4tu9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIAN", function() {
    return RADIAN;
});
parcelHelpers.export(exports, "degreeToRadian", function() {
    return degreeToRadian;
});
parcelHelpers.export(exports, "radianToDegree", function() {
    return radianToDegree;
});
parcelHelpers.export(exports, "polarToCartesian", function() {
    return polarToCartesian;
});
parcelHelpers.export(exports, "getMaxRadius", function() {
    return getMaxRadius;
});
parcelHelpers.export(exports, "formatAxisMap", function() {
    return formatAxisMap;
});
parcelHelpers.export(exports, "distanceBetweenPoints", function() {
    return distanceBetweenPoints;
});
parcelHelpers.export(exports, "getAngleOfPoint", function() {
    return getAngleOfPoint;
});
parcelHelpers.export(exports, "formatAngleOfSector", function() {
    return formatAngleOfSector;
});
parcelHelpers.export(exports, "inRangeOfSector", function() {
    return inRangeOfSector;
});
parcelHelpers.export(exports, "getTickClassName", function() {
    return getTickClassName;
});
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _react = require("react");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("./DataUtils");
var _chartUtils = require("./ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-RADIAN * angle) * radius,
        y: cy + Math.sin(-RADIAN * angle) * radius
    };
};
var getMaxRadius = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, _dataUtils.getPercentValue)(props.cx, width, width / 2);
    var cy = (0, _dataUtils.getPercentValue)(props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, offset);
    var innerRadius = (0, _dataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, _isNilDefault.default)(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = _slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: radianToDegree(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = getAngleOfPoint({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return _objectSpread(_objectSpread({}, sector), {}, {
        radius: radius,
        angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var getTickClassName = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, _react.isValidElement)(tick) && !(0, _isFunctionDefault.default)(tick) && typeof tick !== 'boolean' ? tick.className : '';
};

},{"lodash/isNil":"beGyX","react":"gVheC","lodash/isFunction":"8ck2f","./DataUtils":"c1vtt","./ChartUtils":"5VwLU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5VwLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for backwards compatibility
parcelHelpers.export(exports, "getLegendProps", function() {
    return 0, _getLegendProps.getLegendProps;
});
parcelHelpers.export(exports, "getValueByDataKey", function() {
    return getValueByDataKey;
});
/**
 * Get domain of data by key.
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */ parcelHelpers.export(exports, "getDomainOfDataByKey", function() {
    return getDomainOfDataByKey;
});
parcelHelpers.export(exports, "calculateActiveTickIndex", function() {
    return calculateActiveTickIndex;
});
parcelHelpers.export(exports, "getMainColorOfGraphicItem", function() {
    return getMainColorOfGraphicItem;
});
parcelHelpers.export(exports, "getBarSizeList", function() {
    return getBarSizeList;
});
parcelHelpers.export(exports, "getBarPosition", function() {
    return getBarPosition;
});
parcelHelpers.export(exports, "appendOffsetOfLegend", function() {
    return appendOffsetOfLegend;
});
parcelHelpers.export(exports, "getDomainOfErrorBars", function() {
    return getDomainOfErrorBars;
});
parcelHelpers.export(exports, "parseErrorBarsOfAxis", function() {
    return parseErrorBarsOfAxis;
});
parcelHelpers.export(exports, "getDomainOfItemsWithSameAxis", function() {
    return getDomainOfItemsWithSameAxis;
});
parcelHelpers.export(exports, "isCategoricalAxis", function() {
    return isCategoricalAxis;
});
parcelHelpers.export(exports, "getCoordinatesOfGrid", function() {
    return getCoordinatesOfGrid;
});
parcelHelpers.export(exports, "getTicksOfAxis", function() {
    return getTicksOfAxis;
});
parcelHelpers.export(exports, "combineEventHandlers", function() {
    return combineEventHandlers;
});
parcelHelpers.export(exports, "parseScale", function() {
    return parseScale;
});
parcelHelpers.export(exports, "checkDomainOfScale", function() {
    return checkDomainOfScale;
});
parcelHelpers.export(exports, "findPositionOfBar", function() {
    return findPositionOfBar;
});
parcelHelpers.export(exports, "truncateByDomain", function() {
    return truncateByDomain;
});
parcelHelpers.export(exports, "offsetSign", function() {
    return offsetSign;
});
parcelHelpers.export(exports, "offsetPositive", function() {
    return offsetPositive;
});
parcelHelpers.export(exports, "getStackedData", function() {
    return getStackedData;
});
parcelHelpers.export(exports, "getStackGroupsByAxisId", function() {
    return getStackGroupsByAxisId;
});
parcelHelpers.export(exports, "getTicksOfScale", function() {
    return getTicksOfScale;
});
parcelHelpers.export(exports, "getCateCoordinateOfLine", function() {
    return getCateCoordinateOfLine;
});
parcelHelpers.export(exports, "getCateCoordinateOfBar", function() {
    return getCateCoordinateOfBar;
});
parcelHelpers.export(exports, "getBaseValueOfBar", function() {
    return getBaseValueOfBar;
});
parcelHelpers.export(exports, "getStackedDataOfItem", function() {
    return getStackedDataOfItem;
});
parcelHelpers.export(exports, "getDomainOfStackGroups", function() {
    return getDomainOfStackGroups;
});
parcelHelpers.export(exports, "MIN_VALUE_REG", function() {
    return MIN_VALUE_REG;
});
parcelHelpers.export(exports, "MAX_VALUE_REG", function() {
    return MAX_VALUE_REG;
});
parcelHelpers.export(exports, "parseSpecifiedDomain", function() {
    return parseSpecifiedDomain;
});
parcelHelpers.export(exports, "getBandSizeOfAxis", function() {
    return getBandSizeOfAxis;
});
parcelHelpers.export(exports, "parseDomainOfCategoryAxis", function() {
    return parseDomainOfCategoryAxis;
});
parcelHelpers.export(exports, "getTooltipItem", function() {
    return getTooltipItem;
});
var _d3Scale = require("victory-vendor/d3-scale");
var _d3Shape = require("victory-vendor/d3-shape");
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _flatMap = require("lodash/flatMap");
var _flatMapDefault = parcelHelpers.interopDefault(_flatMap);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _rechartsScale = require("recharts-scale");
var _errorBar = require("../cartesian/ErrorBar");
var _dataUtils = require("./DataUtils");
var _reactUtils = require("./ReactUtils");
// TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';
var _getLegendProps = require("./getLegendProps");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getValueByDataKey(obj, dataKey, defaultValue) {
    if ((0, _isNilDefault.default)(obj) || (0, _isNilDefault.default)(dataKey)) return defaultValue;
    if ((0, _dataUtils.isNumOrStr)(dataKey)) return (0, _getDefault.default)(obj, dataKey, defaultValue);
    if ((0, _isFunctionDefault.default)(dataKey)) return dataKey(obj);
    return defaultValue;
}
function getDomainOfDataByKey(data, key, type, filterNil) {
    var flattenData = (0, _flatMapDefault.default)(data, function(entry) {
        return getValueByDataKey(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, _dataUtils.isNumber)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, _minDefault.default)(domain),
            (0, _maxDefault.default)(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, _dataUtils.isNumOrStr)(entry) || entry instanceof Date ? entry : '';
    });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, _dataUtils.mathSign)(cur - before) !== (0, _dataUtils.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, _dataUtils.mathSign)(after - cur) === (0, _dataUtils.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var getBarSizeList = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, _isNilDefault.default)(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, _isNilDefault.default)(barSize) ? undefined : (0, _dataUtils.getPercentValue)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var getBarPosition = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, _dataUtils.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat(_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, _dataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat(_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, _getLegendProps.getLegendProps)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, _dataUtils.isNumber)(offset[align])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, _dataUtils.isNumber)(offset[verticalAlign])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, _isNilDefault.default)(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar)).filter(function(errorBarChild) {
        return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = getValueByDataKey(entry, dataKey);
            if ((0, _isNilDefault.default)(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, _minDefault.default)(entryValue),
                (0, _maxDefault.default)(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = getValueByDataKey(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
        return getDomainOfDataByKey(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, _isNaNDefault.default)(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var handlerWeakMap = new WeakMap();
var combineEventHandlers = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!handlerWeakMap.has(defaultHandler)) handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var parseScale = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: _d3Scale.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, _isStringDefault.default)(scale)) {
        var name = "scale".concat((0, _upperFirstDefault.default)(scale));
        return {
            scale: (_d3Scale[name] || _d3Scale.scalePoint)(),
            realScaleType: _d3Scale[name] ? name : 'point'
        };
    }
    return (0, _isFunctionDefault.default)(scale) ? {
        scale: scale
    } : {
        scale: _d3Scale.scalePoint(),
        realScaleType: 'point'
    };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - EPS;
    var maxValue = Math.max(range[0], range[1]) + EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, _dataUtils.isNumber)(domain[0]) || !(0, _dataUtils.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, _dataUtils.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, _dataUtils.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var offsetSign = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var offsetPositive = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var STACK_OFFSET_MAP = {
    sign: offsetSign,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, _d3Shape.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, _d3Shape.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, _d3Shape.stackOffsetWiggle),
    positive: offsetPositive
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = STACK_OFFSET_MAP[offsetType];
    var stack = (0, _d3Shape.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +getValueByDataKey(d, key, 0);
    }).order((0, _d3Shape.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, _dataUtils.isNumOrStr)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, _dataUtils.uniqueId)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: getStackedData(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, _minDefault.default)(tickValues),
            (0, _maxDefault.default)(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNilDefault.default)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, _dataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = getValueByDataKey(entry, !(0, _isNilDefault.default)(dataKey) ? dataKey : axis.dataKey);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) : null;
}
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, _dataUtils.isNumOrStr)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, _minDefault.default)(entry.concat([
                result[0]
            ]).filter((0, _dataUtils.isNumber))),
            (0, _maxDefault.default)(entry.concat([
                result[1]
            ]).filter((0, _dataUtils.isNumber)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, _isFunctionDefault.default)(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, _dataUtils.isNumber)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
        var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, _dataUtils.isNumber)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
        var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, _sortByDefault.default)(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, _isEqualDefault.default)(specifiedDomain, (0, _getDefault.default)(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? _objectSpread(_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: getMainColorOfGraphicItem(graphicalItem),
        value: getValueByDataKey(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};

},{"victory-vendor/d3-scale":"kc5nZ","victory-vendor/d3-shape":"4FHVD","lodash/max":"1ecOu","lodash/min":"eA2id","lodash/isNil":"beGyX","lodash/isFunction":"8ck2f","lodash/isString":"kZIz1","lodash/get":"jeneQ","lodash/flatMap":"26i2l","lodash/isNaN":"4ILIm","lodash/upperFirst":"8ljuM","lodash/isEqual":"6bbKw","lodash/sortBy":"4jc9z","recharts-scale":"9ZOqi","../cartesian/ErrorBar":"gEFRh","./DataUtils":"c1vtt","./ReactUtils":"bLejJ","./getLegendProps":"aUyfM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kc5nZ":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("ea85efe7e401a98a");

},{"ea85efe7e401a98a":"hu5M2"}],"hu5M2":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("9f3e91243b64b1b0");

},{"9f3e91243b64b1b0":"87nPU"}],"87nPU":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scaleBand", {
    enumerable: true,
    get: function get() {
        return _band.default;
    }
});
Object.defineProperty(exports, "scaleDiverging", {
    enumerable: true,
    get: function get() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "scaleDivergingLog", {
    enumerable: true,
    get: function get() {
        return _diverging.divergingLog;
    }
});
Object.defineProperty(exports, "scaleDivergingPow", {
    enumerable: true,
    get: function get() {
        return _diverging.divergingPow;
    }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function get() {
        return _diverging.divergingSqrt;
    }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function get() {
        return _diverging.divergingSymlog;
    }
});
Object.defineProperty(exports, "scaleIdentity", {
    enumerable: true,
    get: function get() {
        return _identity.default;
    }
});
Object.defineProperty(exports, "scaleImplicit", {
    enumerable: true,
    get: function get() {
        return _ordinal.implicit;
    }
});
Object.defineProperty(exports, "scaleLinear", {
    enumerable: true,
    get: function get() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "scaleLog", {
    enumerable: true,
    get: function get() {
        return _log.default;
    }
});
Object.defineProperty(exports, "scaleOrdinal", {
    enumerable: true,
    get: function get() {
        return _ordinal.default;
    }
});
Object.defineProperty(exports, "scalePoint", {
    enumerable: true,
    get: function get() {
        return _band.point;
    }
});
Object.defineProperty(exports, "scalePow", {
    enumerable: true,
    get: function get() {
        return _pow.default;
    }
});
Object.defineProperty(exports, "scaleQuantile", {
    enumerable: true,
    get: function get() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "scaleQuantize", {
    enumerable: true,
    get: function get() {
        return _quantize.default;
    }
});
Object.defineProperty(exports, "scaleRadial", {
    enumerable: true,
    get: function get() {
        return _radial.default;
    }
});
Object.defineProperty(exports, "scaleSequential", {
    enumerable: true,
    get: function get() {
        return _sequential.default;
    }
});
Object.defineProperty(exports, "scaleSequentialLog", {
    enumerable: true,
    get: function get() {
        return _sequential.sequentialLog;
    }
});
Object.defineProperty(exports, "scaleSequentialPow", {
    enumerable: true,
    get: function get() {
        return _sequential.sequentialPow;
    }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function get() {
        return _sequentialQuantile.default;
    }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function get() {
        return _sequential.sequentialSqrt;
    }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function get() {
        return _sequential.sequentialSymlog;
    }
});
Object.defineProperty(exports, "scaleSqrt", {
    enumerable: true,
    get: function get() {
        return _pow.sqrt;
    }
});
Object.defineProperty(exports, "scaleSymlog", {
    enumerable: true,
    get: function get() {
        return _symlog.default;
    }
});
Object.defineProperty(exports, "scaleThreshold", {
    enumerable: true,
    get: function get() {
        return _threshold.default;
    }
});
Object.defineProperty(exports, "scaleTime", {
    enumerable: true,
    get: function get() {
        return _time.default;
    }
});
Object.defineProperty(exports, "scaleUtc", {
    enumerable: true,
    get: function get() {
        return _utcTime.default;
    }
});
Object.defineProperty(exports, "tickFormat", {
    enumerable: true,
    get: function get() {
        return _tickFormat.default;
    }
});
var _band = _interopRequireWildcard(require("b63efb80eb4f3997"));
var _identity = _interopRequireDefault(require("599666f8569781e"));
var _linear = _interopRequireDefault(require("81a646a660f644b0"));
var _log = _interopRequireDefault(require("86d5f4344a349716"));
var _symlog = _interopRequireDefault(require("b710ccde4c0e48a2"));
var _ordinal = _interopRequireWildcard(require("64b86754e86644bb"));
var _pow = _interopRequireWildcard(require("b1b95f640cc918be"));
var _radial = _interopRequireDefault(require("a92c7cfb56bc5881"));
var _quantile = _interopRequireDefault(require("592c2efd5d96bbdb"));
var _quantize = _interopRequireDefault(require("e52ffbce45f03bde"));
var _threshold = _interopRequireDefault(require("d72c59b81e30fbb0"));
var _time = _interopRequireDefault(require("8a3bda0d92036416"));
var _utcTime = _interopRequireDefault(require("889651fd1a77d2be"));
var _sequential = _interopRequireWildcard(require("fd5b5906f4fcb1c8"));
var _sequentialQuantile = _interopRequireDefault(require("4430958b59fb539b"));
var _diverging = _interopRequireWildcard(require("f8014e5ceaa878fb"));
var _tickFormat = _interopRequireDefault(require("1391cb83b35daafe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"@swc/helpers/_/_type_of":"668P4","b63efb80eb4f3997":"8lGXN","599666f8569781e":"b4ghE","81a646a660f644b0":"eXfiU","86d5f4344a349716":"5ejhR","b710ccde4c0e48a2":"3jBKh","64b86754e86644bb":"56YIM","b1b95f640cc918be":"3Pw1H","a92c7cfb56bc5881":"5dm4I","592c2efd5d96bbdb":"4yWqJ","e52ffbce45f03bde":"7bjcZ","d72c59b81e30fbb0":"hZ9Js","8a3bda0d92036416":"lBwlP","889651fd1a77d2be":"4gX2g","fd5b5906f4fcb1c8":"6VmBY","4430958b59fb539b":"j8QuB","f8014e5ceaa878fb":"1f3f6","1391cb83b35daafe":"8gLwW"}],"8lGXN":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = band;
exports.point = point;
var _index = require("c83c4aaf4d4f3e6c");
var _init = require("691f3ba4feec551a");
var _ordinal = _interopRequireDefault(require("933dd1d51fe58981"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function band() {
    var scale = (0, _ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _index.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        var ref;
        return arguments.length ? (ref = (0, _slicedToArray._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        var ref;
        return ref = (0, _slicedToArray._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return _init.initRange.apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","c83c4aaf4d4f3e6c":"fO0ka","691f3ba4feec551a":"XU8ch","933dd1d51fe58981":"56YIM"}],"fO0ka":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Adder", {
    enumerable: true,
    get: function get() {
        return _fsum.Adder;
    }
});
Object.defineProperty(exports, "InternMap", {
    enumerable: true,
    get: function get() {
        return _index.InternMap;
    }
});
Object.defineProperty(exports, "InternSet", {
    enumerable: true,
    get: function get() {
        return _index.InternSet;
    }
});
Object.defineProperty(exports, "ascending", {
    enumerable: true,
    get: function get() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "bin", {
    enumerable: true,
    get: function get() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "bisect", {
    enumerable: true,
    get: function get() {
        return _bisect.default;
    }
});
Object.defineProperty(exports, "bisectCenter", {
    enumerable: true,
    get: function get() {
        return _bisect.bisectCenter;
    }
});
Object.defineProperty(exports, "bisectLeft", {
    enumerable: true,
    get: function get() {
        return _bisect.bisectLeft;
    }
});
Object.defineProperty(exports, "bisectRight", {
    enumerable: true,
    get: function get() {
        return _bisect.bisectRight;
    }
});
Object.defineProperty(exports, "bisector", {
    enumerable: true,
    get: function get() {
        return _bisector.default;
    }
});
Object.defineProperty(exports, "count", {
    enumerable: true,
    get: function get() {
        return _count.default;
    }
});
Object.defineProperty(exports, "cross", {
    enumerable: true,
    get: function get() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "cumsum", {
    enumerable: true,
    get: function get() {
        return _cumsum.default;
    }
});
Object.defineProperty(exports, "descending", {
    enumerable: true,
    get: function get() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "deviation", {
    enumerable: true,
    get: function get() {
        return _deviation.default;
    }
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function get() {
        return _difference.default;
    }
});
Object.defineProperty(exports, "disjoint", {
    enumerable: true,
    get: function get() {
        return _disjoint.default;
    }
});
Object.defineProperty(exports, "every", {
    enumerable: true,
    get: function get() {
        return _every.default;
    }
});
Object.defineProperty(exports, "extent", {
    enumerable: true,
    get: function get() {
        return _extent.default;
    }
});
Object.defineProperty(exports, "fcumsum", {
    enumerable: true,
    get: function get() {
        return _fsum.fcumsum;
    }
});
Object.defineProperty(exports, "filter", {
    enumerable: true,
    get: function get() {
        return _filter.default;
    }
});
Object.defineProperty(exports, "flatGroup", {
    enumerable: true,
    get: function get() {
        return _group.flatGroup;
    }
});
Object.defineProperty(exports, "flatRollup", {
    enumerable: true,
    get: function get() {
        return _group.flatRollup;
    }
});
Object.defineProperty(exports, "fsum", {
    enumerable: true,
    get: function get() {
        return _fsum.fsum;
    }
});
Object.defineProperty(exports, "greatest", {
    enumerable: true,
    get: function get() {
        return _greatest.default;
    }
});
Object.defineProperty(exports, "greatestIndex", {
    enumerable: true,
    get: function get() {
        return _greatestIndex.default;
    }
});
Object.defineProperty(exports, "group", {
    enumerable: true,
    get: function get() {
        return _group.default;
    }
});
Object.defineProperty(exports, "groupSort", {
    enumerable: true,
    get: function get() {
        return _groupSort.default;
    }
});
Object.defineProperty(exports, "groups", {
    enumerable: true,
    get: function get() {
        return _group.groups;
    }
});
Object.defineProperty(exports, "histogram", {
    enumerable: true,
    get: function get() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "index", {
    enumerable: true,
    get: function get() {
        return _group.index;
    }
});
Object.defineProperty(exports, "indexes", {
    enumerable: true,
    get: function get() {
        return _group.indexes;
    }
});
Object.defineProperty(exports, "intersection", {
    enumerable: true,
    get: function get() {
        return _intersection.default;
    }
});
Object.defineProperty(exports, "least", {
    enumerable: true,
    get: function get() {
        return _least.default;
    }
});
Object.defineProperty(exports, "leastIndex", {
    enumerable: true,
    get: function get() {
        return _leastIndex.default;
    }
});
Object.defineProperty(exports, "map", {
    enumerable: true,
    get: function get() {
        return _map.default;
    }
});
Object.defineProperty(exports, "max", {
    enumerable: true,
    get: function get() {
        return _max.default;
    }
});
Object.defineProperty(exports, "maxIndex", {
    enumerable: true,
    get: function get() {
        return _maxIndex.default;
    }
});
Object.defineProperty(exports, "mean", {
    enumerable: true,
    get: function get() {
        return _mean.default;
    }
});
Object.defineProperty(exports, "median", {
    enumerable: true,
    get: function get() {
        return _median.default;
    }
});
Object.defineProperty(exports, "merge", {
    enumerable: true,
    get: function get() {
        return _merge.default;
    }
});
Object.defineProperty(exports, "min", {
    enumerable: true,
    get: function get() {
        return _min.default;
    }
});
Object.defineProperty(exports, "minIndex", {
    enumerable: true,
    get: function get() {
        return _minIndex.default;
    }
});
Object.defineProperty(exports, "mode", {
    enumerable: true,
    get: function get() {
        return _mode.default;
    }
});
Object.defineProperty(exports, "nice", {
    enumerable: true,
    get: function get() {
        return _nice.default;
    }
});
Object.defineProperty(exports, "pairs", {
    enumerable: true,
    get: function get() {
        return _pairs.default;
    }
});
Object.defineProperty(exports, "permute", {
    enumerable: true,
    get: function get() {
        return _permute.default;
    }
});
Object.defineProperty(exports, "quantile", {
    enumerable: true,
    get: function get() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "quantileSorted", {
    enumerable: true,
    get: function get() {
        return _quantile.quantileSorted;
    }
});
Object.defineProperty(exports, "quickselect", {
    enumerable: true,
    get: function get() {
        return _quickselect.default;
    }
});
Object.defineProperty(exports, "range", {
    enumerable: true,
    get: function get() {
        return _range.default;
    }
});
Object.defineProperty(exports, "rank", {
    enumerable: true,
    get: function get() {
        return _rank.default;
    }
});
Object.defineProperty(exports, "reduce", {
    enumerable: true,
    get: function get() {
        return _reduce.default;
    }
});
Object.defineProperty(exports, "reverse", {
    enumerable: true,
    get: function get() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "rollup", {
    enumerable: true,
    get: function get() {
        return _group.rollup;
    }
});
Object.defineProperty(exports, "rollups", {
    enumerable: true,
    get: function get() {
        return _group.rollups;
    }
});
Object.defineProperty(exports, "scan", {
    enumerable: true,
    get: function get() {
        return _scan.default;
    }
});
Object.defineProperty(exports, "shuffle", {
    enumerable: true,
    get: function get() {
        return _shuffle.default;
    }
});
Object.defineProperty(exports, "shuffler", {
    enumerable: true,
    get: function get() {
        return _shuffle.shuffler;
    }
});
Object.defineProperty(exports, "some", {
    enumerable: true,
    get: function get() {
        return _some.default;
    }
});
Object.defineProperty(exports, "sort", {
    enumerable: true,
    get: function get() {
        return _sort.default;
    }
});
Object.defineProperty(exports, "subset", {
    enumerable: true,
    get: function get() {
        return _subset.default;
    }
});
Object.defineProperty(exports, "sum", {
    enumerable: true,
    get: function get() {
        return _sum.default;
    }
});
Object.defineProperty(exports, "superset", {
    enumerable: true,
    get: function get() {
        return _superset.default;
    }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function get() {
        return _freedmanDiaconis.default;
    }
});
Object.defineProperty(exports, "thresholdScott", {
    enumerable: true,
    get: function get() {
        return _scott.default;
    }
});
Object.defineProperty(exports, "thresholdSturges", {
    enumerable: true,
    get: function get() {
        return _sturges.default;
    }
});
Object.defineProperty(exports, "tickIncrement", {
    enumerable: true,
    get: function get() {
        return _ticks.tickIncrement;
    }
});
Object.defineProperty(exports, "tickStep", {
    enumerable: true,
    get: function get() {
        return _ticks.tickStep;
    }
});
Object.defineProperty(exports, "ticks", {
    enumerable: true,
    get: function get() {
        return _ticks.default;
    }
});
Object.defineProperty(exports, "transpose", {
    enumerable: true,
    get: function get() {
        return _transpose.default;
    }
});
Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function get() {
        return _union.default;
    }
});
Object.defineProperty(exports, "variance", {
    enumerable: true,
    get: function get() {
        return _variance.default;
    }
});
Object.defineProperty(exports, "zip", {
    enumerable: true,
    get: function get() {
        return _zip.default;
    }
});
var _bisect = _interopRequireWildcard(require("30e30fd80e01d017"));
var _ascending = _interopRequireDefault(require("ba6e167afdeaab0b"));
var _bisector = _interopRequireDefault(require("a8afbc207886cfe5"));
var _count = _interopRequireDefault(require("1ec4d87c2d530b17"));
var _cross = _interopRequireDefault(require("e60cb580083b63b4"));
var _cumsum = _interopRequireDefault(require("2ed7a3899076eb06"));
var _descending = _interopRequireDefault(require("b44226224b8ee28a"));
var _deviation = _interopRequireDefault(require("3bfdfde74e5e3893"));
var _extent = _interopRequireDefault(require("e0c64cb1665c42fc"));
var _fsum = require("8239d81e924c7f9b");
var _group = _interopRequireWildcard(require("e133ef73b59e280f"));
var _groupSort = _interopRequireDefault(require("3c1ee14e652a9a74"));
var _bin = _interopRequireDefault(require("1c3fea00392fd51a"));
var _freedmanDiaconis = _interopRequireDefault(require("39d93dd913508747"));
var _scott = _interopRequireDefault(require("876933b3acb155ad"));
var _sturges = _interopRequireDefault(require("d1e08dd0d72014d7"));
var _max = _interopRequireDefault(require("5653c1d333b623cc"));
var _maxIndex = _interopRequireDefault(require("e384106528492a4"));
var _mean = _interopRequireDefault(require("e8829bf9149c3ef0"));
var _median = _interopRequireDefault(require("d00dfb19fe2fa3dd"));
var _merge = _interopRequireDefault(require("f8db612b317ca902"));
var _min = _interopRequireDefault(require("23890540251f6e67"));
var _minIndex = _interopRequireDefault(require("b9d42ff8895c4de8"));
var _mode = _interopRequireDefault(require("85fe3d40f6f5138d"));
var _nice = _interopRequireDefault(require("e8d14d9a3dedafe6"));
var _pairs = _interopRequireDefault(require("177b2ef4b4963970"));
var _permute = _interopRequireDefault(require("365c2a51c1482713"));
var _quantile = _interopRequireWildcard(require("1d56df0071525856"));
var _quickselect = _interopRequireDefault(require("1d2b63add15610db"));
var _range = _interopRequireDefault(require("879f1890a7517024"));
var _rank = _interopRequireDefault(require("912567809e44cbf8"));
var _least = _interopRequireDefault(require("c6b4300bede89d14"));
var _leastIndex = _interopRequireDefault(require("38f5be9e3fad1ac0"));
var _greatest = _interopRequireDefault(require("7fdad0a7cfab2520"));
var _greatestIndex = _interopRequireDefault(require("acba90bb290c79e9"));
var _scan = _interopRequireDefault(require("4a0a3c353076d5f7"));
var _shuffle = _interopRequireWildcard(require("ca2fb5eb530363f6"));
var _sum = _interopRequireDefault(require("fcc170790ec9f19b"));
var _ticks = _interopRequireWildcard(require("cd372a8370da3735"));
var _transpose = _interopRequireDefault(require("fece81f7cb114699"));
var _variance = _interopRequireDefault(require("68a6cbe5f6ed9d0b"));
var _zip = _interopRequireDefault(require("a43b4c003dde8ae5"));
var _every = _interopRequireDefault(require("aa419cb489a22141"));
var _some = _interopRequireDefault(require("2d20a8f791fd5767"));
var _filter = _interopRequireDefault(require("32260c06b0e9256d"));
var _map = _interopRequireDefault(require("6071cde151b05eb9"));
var _reduce = _interopRequireDefault(require("12d8fb254953b9bd"));
var _reverse = _interopRequireDefault(require("a0b2aacd1379b178"));
var _sort = _interopRequireDefault(require("68390ceda5e75df5"));
var _difference = _interopRequireDefault(require("e3b896de066f5364"));
var _disjoint = _interopRequireDefault(require("a4315b63bcb13bca"));
var _intersection = _interopRequireDefault(require("9f70d47eae5d7300"));
var _subset = _interopRequireDefault(require("56df3047d82ddba3"));
var _superset = _interopRequireDefault(require("f70ec3fe7b14f6c5"));
var _union = _interopRequireDefault(require("7c20e02710d1b117"));
var _index = require("5307d8bb084e9ec1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"@swc/helpers/_/_type_of":"668P4","30e30fd80e01d017":"l7ICO","ba6e167afdeaab0b":"q72OA","a8afbc207886cfe5":"elomQ","1ec4d87c2d530b17":"0k6Dg","e60cb580083b63b4":"4cGva","2ed7a3899076eb06":"Yrixb","b44226224b8ee28a":"6BBf4","3bfdfde74e5e3893":"cMMng","e0c64cb1665c42fc":"b5KIk","8239d81e924c7f9b":"fKfd6","e133ef73b59e280f":"cS0jw","3c1ee14e652a9a74":"g7mWK","1c3fea00392fd51a":"3U227","39d93dd913508747":"3YjGQ","876933b3acb155ad":"5oww4","d1e08dd0d72014d7":"gUGOF","5653c1d333b623cc":"bADc8","e384106528492a4":"hVjCv","e8829bf9149c3ef0":"ew9JW","d00dfb19fe2fa3dd":"3szrk","f8db612b317ca902":"d64vB","23890540251f6e67":"9ymHA","b9d42ff8895c4de8":"4kuJw","85fe3d40f6f5138d":"jnuCw","e8d14d9a3dedafe6":"lCQh5","177b2ef4b4963970":"3NOE6","365c2a51c1482713":"dNu2O","1d56df0071525856":"64fLL","1d2b63add15610db":"k89o7","879f1890a7517024":"hUoRo","912567809e44cbf8":"5oVuZ","c6b4300bede89d14":"6aspS","38f5be9e3fad1ac0":"eZWQ7","7fdad0a7cfab2520":"eaw9O","acba90bb290c79e9":"gF8Kn","4a0a3c353076d5f7":"9iRat","ca2fb5eb530363f6":"dja0F","fcc170790ec9f19b":"6hxmx","cd372a8370da3735":"7BBOR","fece81f7cb114699":"5dj8v","68a6cbe5f6ed9d0b":"NRLtp","a43b4c003dde8ae5":"8FCnK","aa419cb489a22141":"8Wdis","2d20a8f791fd5767":"gLkev","32260c06b0e9256d":"jkii5","6071cde151b05eb9":"9ddXF","12d8fb254953b9bd":"fEuiq","a0b2aacd1379b178":"hD8Wh","68390ceda5e75df5":"5d7ik","e3b896de066f5364":"vPkLT","a4315b63bcb13bca":"cXICD","9f70d47eae5d7300":"cCPUJ","56df3047d82ddba3":"42ifm","f70ec3fe7b14f6c5":"T8HNk","7c20e02710d1b117":"6mvSG","5307d8bb084e9ec1":"iM71D"}],"l7ICO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.bisectRight = exports.bisectLeft = exports.bisectCenter = void 0;
var _ascending = _interopRequireDefault(require("c1f158b330aaa13c"));
var _bisector = _interopRequireDefault(require("ae9e5922ca82e11d"));
var _number = _interopRequireDefault(require("7b6cc53664acedc3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ascendingBisect = (0, _bisector.default)(_ascending.default);
var bisectRight = ascendingBisect.right;
exports.bisectRight = bisectRight;
var bisectLeft = ascendingBisect.left;
exports.bisectLeft = bisectLeft;
var bisectCenter = (0, _bisector.default)(_number.default).center;
exports.bisectCenter = bisectCenter;
var _default = bisectRight;
exports.default = _default;

},{"c1f158b330aaa13c":"q72OA","ae9e5922ca82e11d":"elomQ","7b6cc53664acedc3":"4gLCK"}],"q72OA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ascending;
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{}],"elomQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bisector;
var _ascending = _interopRequireDefault(require("7cbc9edd390ae8bb"));
var _descending = _interopRequireDefault(require("bbf176e93324968c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bisector(f) {
    var compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = _ascending.default;
        compare2 = function(d, x) {
            return (0, _ascending.default)(f(d), x);
        };
        delta = function(d, x) {
            return f(d) - x;
        };
    } else {
        compare1 = f === _ascending.default || f === _descending.default ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        var i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function zero() {
    return 0;
}

},{"7cbc9edd390ae8bb":"q72OA","bbf176e93324968c":"6BBf4"}],"6BBf4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = descending;
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"4gLCK":[function(require,module,exports,__globalThis) {
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
exports.numbers = numbers;
function number(x) {
    return x === null ? NaN : +x;
}
function numbers(values, valueof) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, err, index, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, value1, err;
    return (0, _tsGenerator._)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(valueof === undefined)) return [
                    3,
                    9
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = values[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                value = _step.value;
                if (!(value != null && (value = +value) >= value)) return [
                    3,
                    4
                ];
                return [
                    4,
                    value
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    3,
                    17
                ];
            case 9:
                index = -1;
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 10;
            case 10:
                _state.trys.push([
                    10,
                    15,
                    16,
                    17
                ]);
                _iterator1 = values[Symbol.iterator]();
                _state.label = 11;
            case 11:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    14
                ];
                value1 = _step1.value;
                if (!((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1)) return [
                    3,
                    13
                ];
                return [
                    4,
                    value1
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    11
                ];
            case 14:
                return [
                    3,
                    17
                ];
            case 15:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    17
                ];
            case 16:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 17:
                return [
                    2
                ];
        }
    });
}

},{"@swc/helpers/_/_ts_generator":"2jVI5"}],"0k6Dg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = count;
function count(values, valueof) {
    var _$count = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) ++_$count;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) ++_$count;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$count;
}

},{}],"4cGva":[function(require,module,exports,__globalThis) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cross;
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return (typeof values === "undefined" ? "undefined" : (0, _typeOf._)(values)) !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return function(values) {
        return reduce.apply(void 0, (0, _toConsumableArray._)(values));
    };
}
function cross() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
        values[_key] = arguments[_key];
    }
    var reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    var lengths = values.map(length);
    var j = values.length - 1;
    var index = new Array(j + 1).fill(0);
    var product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map(function(j, i) {
            return values[i][j];
        }));
        var i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_type_of":"668P4"}],"Yrixb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cumsum;
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? function(v) {
        return sum += +v || 0;
    } : function(v) {
        return sum += +valueof(v, index++, values) || 0;
    });
}

},{}],"cMMng":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deviation;
var _variance = _interopRequireDefault(require("51ae5f4f20d14175"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function deviation(values, valueof) {
    var v = (0, _variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"51ae5f4f20d14175":"NRLtp"}],"NRLtp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = variance;
function variance(values, valueof) {
    var count = 0;
    var delta;
    var mean = 0;
    var sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) {
                    delta = value - mean;
                    mean += delta / ++count;
                    sum += delta * (value - mean);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) {
                    delta = value1 - mean;
                    mean += delta / ++count;
                    sum += delta * (value1 - mean);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{}],"b5KIk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extent;
function extent(values, valueof) {
    var min;
    var max;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null) {
                    if (min === undefined) {
                        if (value >= value) min = max = value;
                    } else {
                        if (min > value) min = value;
                        if (max < value) max = value;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null) {
                    if (min === undefined) {
                        if (value1 >= value1) min = max = value1;
                    } else {
                        if (min > value1) min = value1;
                        if (max < value1) max = value1;
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return [
        min,
        max
    ];
}

},{}],"fKfd6":[function(require,module,exports,__globalThis) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adder = void 0;
exports.fcumsum = fcumsum;
exports.fsum = fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var Adder = /*#__PURE__*/ function() {
    function Adder() {
        (0, _classCallCheck._)(this, Adder);
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    (0, _createClass._)(Adder, [
        {
            key: "add",
            value: function add(x) {
                var p = this._partials;
                var i = 0;
                for(var j = 0; j < this._n && j < 32; j++){
                    var y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                    if (lo) p[i++] = lo;
                    x = hi;
                }
                p[i] = x;
                this._n = i + 1;
                return this;
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                var p = this._partials;
                var n = this._n, x, y, lo, hi = 0;
                if (n > 0) {
                    hi = p[--n];
                    while(n > 0){
                        x = hi;
                        y = p[--n];
                        hi = x + y;
                        lo = y - (hi - x);
                        if (lo) break;
                    }
                    if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                        y = lo * 2;
                        x = hi + y;
                        if (y == x - hi) hi = x;
                    }
                }
                return hi;
            }
        }
    ]);
    return Adder;
}();
exports.Adder = Adder;
function fsum(values, valueof) {
    var adder = new Adder();
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value = +value) adder.add(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (value1 = +valueof(value1, ++index, values)) adder.add(value1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return +adder;
}
function fcumsum(values, valueof) {
    var adder = new Adder();
    var index = -1;
    return Float64Array.from(values, valueof === undefined ? function(v) {
        return adder.add(+v || 0);
    } : function(v) {
        return adder.add(+valueof(v, ++index, values) || 0);
    });
}

},{"@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL"}],"cS0jw":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = group;
exports.flatGroup = flatGroup;
exports.flatRollup = flatRollup;
exports.groups = groups;
exports.index = index;
exports.indexes = indexes;
exports.rollup = rollup;
exports.rollups = rollups;
var _index = require("48004d0dfe52b7a6");
var _identity = _interopRequireDefault(require("3cf6030d781ef6b2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function group(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return nest(values, _identity.default, _identity.default, keys);
}
function groups(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return nest(values, Array.from, _identity.default, keys);
}
function flatten(groups, keys) {
    for(var i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap(function(g) {
        return g.pop().map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            return (0, _toConsumableArray._)(g).concat([
                key,
                value
            ]);
        });
    });
    return groups;
}
function flatGroup(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return flatten(groups.apply(void 0, [
        values
    ].concat((0, _toConsumableArray._)(keys))), keys);
}
function flatRollup(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return flatten(rollups.apply(void 0, [
        values,
        reduce
    ].concat((0, _toConsumableArray._)(keys))), keys);
}
function rollup(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return nest(values, _identity.default, reduce, keys);
}
function rollups(values, reduce) {
    for(var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        keys[_key - 2] = arguments[_key];
    }
    return nest(values, Array.from, reduce, keys);
}
function index(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return nest(values, _identity.default, unique, keys);
}
function indexes(values) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        var _$groups = new _index.InternMap();
        var keyof = keys[i++];
        var _$index = -1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                var key = keyof(value, ++_$index, values);
                var _$group = _$groups.get(key);
                if (_$group) _$group.push(value);
                else _$groups.set(key, [
                    value
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = _$groups[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, _slicedToArray._)(_step1.value, 2), key1 = _step_value[0], _$values = _step_value[1];
                _$groups.set(key1, regroup(_$values, i));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return map(_$groups);
    }(values, 0);
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","48004d0dfe52b7a6":"iM71D","3cf6030d781ef6b2":"1nsOk"}],"iM71D":[function(require,module,exports,__globalThis) {
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternSet = exports.InternMap = void 0;
var InternMap = /*#__PURE__*/ function(Map1) {
    (0, _inherits._)(InternMap, Map1);
    function InternMap(entries) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : keyof;
        (0, _classCallCheck._)(this, InternMap);
        var _this;
        _this = (0, _callSuper._)(this, InternMap);
        Object.defineProperties(_this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (entries != null) try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key1 = _step_value[0], value = _step_value[1];
                _this.set(key1, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, _createClass._)(InternMap, [
        {
            key: "get",
            value: function get(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "get", this).call(this, intern_get(this, key));
            }
        },
        {
            key: "has",
            value: function has(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "has", this).call(this, intern_get(this, key));
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "set", this).call(this, intern_set(this, key), value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "delete", this).call(this, intern_delete(this, key));
            }
        }
    ]);
    return InternMap;
}((0, _wrapNativeSuper._)(Map));
exports.InternMap = InternMap;
var InternSet = /*#__PURE__*/ function(Set1) {
    (0, _inherits._)(InternSet, Set1);
    function InternSet(values) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : keyof;
        (0, _classCallCheck._)(this, InternSet);
        var _this;
        _this = (0, _callSuper._)(this, InternSet);
        Object.defineProperties(_this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (values != null) try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                _this.add(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, _createClass._)(InternSet, [
        {
            key: "has",
            value: function has(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "has", this).call(this, intern_get(this, value));
            }
        },
        {
            key: "add",
            value: function add(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "add", this).call(this, intern_set(this, value));
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "delete", this).call(this, intern_delete(this, value));
            }
        }
    ]);
    return InternSet;
}((0, _wrapNativeSuper._)(Set));
exports.InternSet = InternSet;
function intern_get(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" ? value.valueOf() : value;
}

},{"@swc/helpers/_/_call_super":"j67W7","@swc/helpers/_/_class_call_check":"9EBwV","@swc/helpers/_/_create_class":"k7tiL","@swc/helpers/_/_get":"dFcfq","@swc/helpers/_/_get_prototype_of":"6m8hr","@swc/helpers/_/_inherits":"vo5zm","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","@swc/helpers/_/_wrap_native_super":"4i0eR"}],"dFcfq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get;
});
var _superPropBaseJs = require("./_super_prop_base.js");
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function get(target, property, receiver) {
        var base = (0, _superPropBaseJs._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}

},{"./_super_prop_base.js":"fuxM0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fuxM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _super_prop_base;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, _getPrototypeOfJs._)(object);
        if (object === null) break;
    }
    return object;
}

},{"./_get_prototype_of.js":"6m8hr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nsOk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
function identity(x) {
    return x;
}

},{}],"g7mWK":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = groupSort;
var _ascending = _interopRequireDefault(require("325640508c2e43b"));
var _group = _interopRequireWildcard(require("57a8d19e7d7a16cf"));
var _sort = _interopRequireDefault(require("a759bcb922f07eb1"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sort.default)((0, _group.rollup)(values, reduce, key), function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 2), ak = _param[0], av = _param[1], _param1 = (0, _slicedToArray._)(param1, 2), bk = _param1[0], bv = _param1[1];
        return (0, _ascending.default)(av, bv) || (0, _ascending.default)(ak, bk);
    }) : (0, _sort.default)((0, _group.default)(values, key), function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 2), ak = _param[0], av = _param[1], _param1 = (0, _slicedToArray._)(param1, 2), bk = _param1[0], bv = _param1[1];
        return reduce(av, bv) || (0, _ascending.default)(ak, bk);
    })).map(function(param) {
        var _param = (0, _slicedToArray._)(param, 1), _$key = _param[0];
        return _$key;
    });
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","325640508c2e43b":"q72OA","57a8d19e7d7a16cf":"cS0jw","a759bcb922f07eb1":"5d7ik"}],"5d7ik":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ascendingDefined = ascendingDefined;
exports.compareDefined = compareDefined;
exports.default = sort;
var _ascending = _interopRequireDefault(require("17dda5769044e4af"));
var _permute = _interopRequireDefault(require("45ed8435c3fc2fdf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function sort(values) {
    for(var _len = arguments.length, F = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        F[_key - 1] = arguments[_key];
    }
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    var _F = (0, _slicedToArray._)(F, 1), f = _F[0];
    if (f && f.length !== 2 || F.length > 1) {
        var index = Uint32Array.from(values, function(d, i) {
            return i;
        });
        if (F.length > 1) {
            F = F.map(function(f) {
                return values.map(f);
            });
            index.sort(function(i, j) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = F[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var f = _step.value;
                        var c = ascendingDefined(f[i], f[j]);
                        if (c) return c;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        } else {
            f = values.map(f);
            index.sort(function(i, j) {
                return ascendingDefined(f[i], f[j]);
            });
        }
        return (0, _permute.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined() {
    var compare = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _ascending.default;
    if (compare === _ascending.default) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return function(a, b) {
        var x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","17dda5769044e4af":"q72OA","45ed8435c3fc2fdf":"dNu2O"}],"dNu2O":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = permute;
function permute(source, keys) {
    return Array.from(keys, function(key) {
        return source[key];
    });
}

},{}],"3U227":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bin;
var _array = require("2e045be59e43c77");
var _bisect = _interopRequireDefault(require("319eb924a032034c"));
var _constant = _interopRequireDefault(require("2d6358dd303eb77c"));
var _extent = _interopRequireDefault(require("b715ed473e0ab15b"));
var _identity = _interopRequireDefault(require("f9340ffc2d80b8ca"));
var _nice = _interopRequireDefault(require("c13788fe41624795"));
var _ticks = _interopRequireWildcard(require("b122967555bb47b9"));
var _sturges = _interopRequireDefault(require("3587d7f4446a1fc2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bin() {
    var value = _identity.default, domain = _extent.default, threshold = _sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            var max = x1, tn = +tz;
            var ref;
            if (domain === _extent.default) ref = (0, _slicedToArray._)((0, _nice.default)(x0, x1, tn), 2), x0 = ref[0], x1 = ref[1], ref;
            tz = (0, _ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === _extent.default) {
                    var step1 = (0, _ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step1)) {
                        if (step1 > 0) x1 = (Math.floor(x1 / step1) + 1) * step1;
                        else if (step1 < 0) x1 = (Math.ceil(x1 * -step1) + 1) / -step1;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), _$bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            _$bin = bins[i] = [];
            _$bin.x0 = i > 0 ? tz[i - 1] : x0;
            _$bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    var j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant.default)(_array.slice.call(_)) : (0, _constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_type_of":"668P4","2e045be59e43c77":"ds1F9","319eb924a032034c":"l7ICO","2d6358dd303eb77c":"liOTi","b715ed473e0ab15b":"b5KIk","f9340ffc2d80b8ca":"1nsOk","c13788fe41624795":"lCQh5","b122967555bb47b9":"7BBOR","3587d7f4446a1fc2":"gUGOF"}],"ds1F9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slice = exports.map = void 0;
var array = Array.prototype;
var slice = array.slice;
exports.slice = slice;
var map = array.map;
exports.map = map;

},{}],"liOTi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constant;
function constant(x) {
    return function() {
        return x;
    };
}

},{}],"lCQh5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
var _ticks = require("82883d5f91d2ba9");
function nice(start, stop, count) {
    var prestep;
    while(true){
        var step = (0, _ticks.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"82883d5f91d2ba9":"7BBOR"}],"7BBOR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start, stop, count) {
    var reverse, i = -1, n, _$ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        var r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        _$ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)_$ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        var r01 = Math.round(start * step), r11 = Math.round(stop * step);
        if (r01 / step < start) ++r01;
        if (r11 / step > stop) --r11;
        _$ticks = new Array(n = r11 - r01 + 1);
        while(++i < n)_$ticks[i] = (r01 + i) / step;
    }
    if (reverse) _$ticks.reverse();
    return _$ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{}],"gUGOF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdSturges;
var _count = _interopRequireDefault(require("d856b0d375bb9b61"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdSturges(values) {
    return Math.ceil(Math.log((0, _count.default)(values)) / Math.LN2) + 1;
}

},{"d856b0d375bb9b61":"0k6Dg"}],"3YjGQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdFreedmanDiaconis;
var _count = _interopRequireDefault(require("84a2a08734413081"));
var _quantile = _interopRequireDefault(require("b453688def319e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, _quantile.default)(values, 0.75) - (0, _quantile.default)(values, 0.25)) * Math.pow((0, _count.default)(values), -1 / 3)));
}

},{"84a2a08734413081":"0k6Dg","b453688def319e0":"64fLL"}],"64fLL":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
exports.quantileSorted = quantileSorted;
var _max = _interopRequireDefault(require("6377896bac51b475"));
var _min = _interopRequireDefault(require("7403c617ea3dc723"));
var _quickselect = _interopRequireDefault(require("fa6451b912e13124"));
var _number = _interopRequireWildcard(require("de13410c4756be71"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _min.default)(values);
    if (p >= 1) return (0, _max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _max.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p) {
    var valueof = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _number.default;
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"@swc/helpers/_/_type_of":"668P4","6377896bac51b475":"bADc8","7403c617ea3dc723":"9ymHA","fa6451b912e13124":"k89o7","de13410c4756be71":"4gLCK"}],"bADc8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = max;
function max(values, valueof) {
    var _$max;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (_$max < value || _$max === undefined && value >= value)) _$max = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (_$max < value1 || _$max === undefined && value1 >= value1)) _$max = value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$max;
}

},{}],"9ymHA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = min;
function min(values, valueof) {
    var _$min;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (_$min > value || _$min === undefined && value >= value)) _$min = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (_$min > value1 || _$min === undefined && value1 >= value1)) _$min = value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$min;
}

},{}],"k89o7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quickselect;
var _sort = require("c4d7054457278972");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k) {
    var left = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, right = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : array.length - 1, compare = arguments.length > 4 ? arguments[4] : void 0;
    compare = compare === undefined ? _sort.ascendingDefined : (0, _sort.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        var t = array[k];
        var i = left;
        var j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    var t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"c4d7054457278972":"5d7ik"}],"5oww4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdScott;
var _count = _interopRequireDefault(require("544301f03b7cfef6"));
var _deviation = _interopRequireDefault(require("9c084667c87040d5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

},{"544301f03b7cfef6":"0k6Dg","9c084667c87040d5":"cMMng"}],"hVjCv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maxIndex;
function maxIndex(values, valueof) {
    var max;
    var _$maxIndex = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (valueof === undefined) try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (value != null && (max < value || max === undefined && value >= value)) max = value, _$maxIndex = index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (max < value1 || max === undefined && value1 >= value1)) max = value1, _$maxIndex = index;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$maxIndex;
}

},{}],"ew9JW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mean;
function mean(values, valueof) {
    var count = 0;
    var sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && (value = +value) >= value) ++count, sum += value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1) ++count, sum += value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (count) return sum / count;
}

},{}],"3szrk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = median;
var _quantile = _interopRequireDefault(require("73b253d4e179eac9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function median(values, valueof) {
    return (0, _quantile.default)(values, 0.5, valueof);
}

},{"73b253d4e179eac9":"64fLL"}],"d64vB":[function(require,module,exports,__globalThis) {
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = merge;
function flatten(arrays) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, array, err;
    return (0, _tsGenerator._)(this, function(_state) {
        switch(_state.label){
            case 0:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = arrays[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                array = _step.value;
                return [
                    5,
                    (0, _tsValues._)(array)
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@swc/helpers/_/_ts_generator":"2jVI5","@swc/helpers/_/_ts_values":"ynngT"}],"4kuJw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = minIndex;
function minIndex(values, valueof) {
    var min;
    var _$minIndex = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (valueof === undefined) try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (value != null && (min > value || min === undefined && value >= value)) min = value, _$minIndex = index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && (min > value1 || min === undefined && value1 >= value1)) min = value1, _$minIndex = index;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$minIndex;
}

},{}],"jnuCw":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mode;
var _index = require("cc79d9604cb49161");
function mode(values, valueof) {
    var counts = new _index.InternMap();
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if ((value1 = valueof(value1, ++index, values)) != null && value1 >= value1) counts.set(value1, (counts.get(value1) || 0) + 1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var modeValue;
    var modeCount = 0;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = counts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value = (0, _slicedToArray._)(_step2.value, 2), value2 = _step_value[0], count = _step_value[1];
            if (count > modeCount) {
                modeCount = count;
                modeValue = value2;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return modeValue;
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","cc79d9604cb49161":"iM71D"}],"3NOE6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pairs;
exports.pair = pair;
function pairs(values) {
    var pairof = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pair;
    var _$pairs = [];
    var previous;
    var first = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (first) _$pairs.push(pairof(previous, value));
            previous = value;
            first = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return _$pairs;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{}],"hUoRo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, _$range = new Array(n);
    while(++i < n)_$range[i] = start + i * step;
    return _$range;
}

},{}],"5oVuZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rank;
var _ascending = _interopRequireDefault(require("3d6b2e0137da2f5f"));
var _sort = require("baf9f3a118e8a4c3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function rank(values) {
    var valueof = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _ascending.default;
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    var V = Array.from(values);
    var R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending.default;
    var compareIndex = function(i, j) {
        return valueof(V[i], V[j]);
    };
    var k, r;
    Uint32Array.from(V, function(_, i) {
        return i;
    }).sort(valueof === _ascending.default ? function(i, j) {
        return (0, _sort.ascendingDefined)(V[i], V[j]);
    } : (0, _sort.compareDefined)(compareIndex)).forEach(function(j, i) {
        var c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"3d6b2e0137da2f5f":"q72OA","baf9f3a118e8a4c3":"5d7ik"}],"6aspS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = least;
var _ascending = _interopRequireDefault(require("86cd41303b4be24c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function least(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _ascending.default;
    var min;
    var defined = false;
    if (compare.length === 1) {
        var minValue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var value = compare(element);
                if (defined ? (0, _ascending.default)(value, minValue) < 0 : (0, _ascending.default)(value, value) === 0) {
                    min = element;
                    minValue = value;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (defined ? compare(value1, min) < 0 : compare(value1, value1) === 0) {
                    min = value1;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return min;
}

},{"86cd41303b4be24c":"q72OA"}],"eZWQ7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leastIndex;
var _ascending = _interopRequireDefault(require("3a70505afbae26e3"));
var _minIndex = _interopRequireDefault(require("7863dae356808098"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function leastIndex(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _ascending.default;
    if (compare.length === 1) return (0, _minIndex.default)(values, compare);
    var minValue;
    var min = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                minValue = value;
                min = index;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return min;
}

},{"3a70505afbae26e3":"q72OA","7863dae356808098":"4kuJw"}],"eaw9O":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatest;
var _ascending = _interopRequireDefault(require("7e4721a4d28ff20a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatest(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _ascending.default;
    var max;
    var defined = false;
    if (compare.length === 1) {
        var maxValue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                var value = compare(element);
                if (defined ? (0, _ascending.default)(value, maxValue) > 0 : (0, _ascending.default)(value, value) === 0) {
                    max = element;
                    maxValue = value;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (defined ? compare(value1, max) > 0 : compare(value1, value1) === 0) {
                    max = value1;
                    defined = true;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return max;
}

},{"7e4721a4d28ff20a":"q72OA"}],"gF8Kn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatestIndex;
var _ascending = _interopRequireDefault(require("a08614b50d783d7f"));
var _maxIndex = _interopRequireDefault(require("c1f809321f205561"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatestIndex(values) {
    var compare = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _ascending.default;
    if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
    var maxValue;
    var max = -1;
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            ++index;
            if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                maxValue = value;
                max = index;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return max;
}

},{"a08614b50d783d7f":"q72OA","c1f809321f205561":"hVjCv"}],"9iRat":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scan;
var _leastIndex = _interopRequireDefault(require("620579109956e518"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function scan(values, compare) {
    var index = (0, _leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"620579109956e518":"eZWQ7"}],"dja0F":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.shuffler = shuffler;
var _default = shuffler(Math.random);
exports.default = _default;
function shuffler(random) {
    return function shuffle(array) {
        var i0 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : array.length;
        var m = i1 - (i0 = +i0);
        while(m){
            var i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{}],"6hxmx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sum;
function sum(values, valueof) {
    var _$sum = 0;
    if (valueof === undefined) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value = +value) _$sum += value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        var index = -1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                if (value1 = +valueof(value1, ++index, values)) _$sum += value1;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return _$sum;
}

},{}],"5dj8v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transpose;
var _min = _interopRequireDefault(require("e91a8bba11a65cd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _min.default)(matrix, length), _$transpose = new Array(m); ++i < m;)for(var j = -1, n, row = _$transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return _$transpose;
}
function length(d) {
    return d.length;
}

},{"e91a8bba11a65cd":"9ymHA"}],"8FCnK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zip;
var _transpose = _interopRequireDefault(require("f5cee9197fcba405"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function zip() {
    return (0, _transpose.default)(arguments);
}

},{"f5cee9197fcba405":"5dj8v"}],"8Wdis":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = every;
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (!test(value, ++index, values)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

},{}],"gLkev":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = some;
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (test(value, ++index, values)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}

},{}],"jkii5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filter;
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    var array = [];
    var index = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (test(value, ++index, values)) array.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return array;
}

},{}],"9ddXF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, function(value, index) {
        return mapper(value, index, values);
    });
}

},{}],"fEuiq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    var iterator = values[Symbol.iterator]();
    var done, next, index = -1;
    if (arguments.length < 3) {
        var ref;
        ref = iterator.next(), done = ref.done, value = ref.value, ref;
        if (done) return;
        ++index;
    }
    var ref1;
    while(ref1 = iterator.next(), done = ref1.done, next = ref1.value, ref1, !done)value = reducer(value, next, ++index, values);
    return value;
}

},{}],"hD8Wh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reverse;
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{}],"vPkLT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = difference;
var _index = require("53f785431e2265c8");
function difference(values) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        others[_key - 1] = arguments[_key];
    }
    values = new _index.InternSet(values);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var other = _step.value;
            try {
                for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var value = _step1.value;
                    values.delete(value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return values;
}

},{"53f785431e2265c8":"iM71D"}],"cXICD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = disjoint;
var _index = require("fd3ab907acc87368");
function disjoint(values, other) {
    var iterator = other[Symbol.iterator](), set = new _index.InternSet();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            if (set.has(v)) return false;
            var value = void 0, done = void 0;
            var ref;
            while(ref = iterator.next(), value = ref.value, done = ref.done, ref){
                if (done) break;
                if (Object.is(v, value)) return false;
                set.add(value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

},{"fd3ab907acc87368":"iM71D"}],"cCPUJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = intersection;
var _index = require("57400e6933e84289");
function intersection(values) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        others[_key - 1] = arguments[_key];
    }
    values = new _index.InternSet(values);
    others = others.map(set);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        out: for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = others[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var other = _step1.value;
                    if (!other.has(value)) {
                        values.delete(value);
                        continue out;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return values;
}
function set(values) {
    return values instanceof _index.InternSet ? values : new _index.InternSet(values);
}

},{"57400e6933e84289":"iM71D"}],"42ifm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subset;
var _superset = _interopRequireDefault(require("642286ff2d84a077"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function subset(values, other) {
    return (0, _superset.default)(other, values);
}

},{"642286ff2d84a077":"T8HNk"}],"T8HNk":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = superset;
function superset(values, other) {
    var iterator = values[Symbol.iterator](), set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = other[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            var io = intern(o);
            if (set.has(io)) continue;
            var value = void 0, done = void 0;
            var ref;
            while(ref = iterator.next(), value = ref.value, done = ref.done, ref){
                if (done) return false;
                var ivalue = intern(value);
                set.add(ivalue);
                if (Object.is(io, ivalue)) break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function intern(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === "object" ? value.valueOf() : value;
}

},{"@swc/helpers/_/_type_of":"668P4"}],"6mvSG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = union;
var _index = require("c01638dea2a1bd81");
function union() {
    for(var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++){
        others[_key] = arguments[_key];
    }
    var set = new _index.InternSet();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var other = _step.value;
            try {
                for(var _iterator1 = other[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var o = _step1.value;
                    set.add(o);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return set;
}

},{"c01638dea2a1bd81":"iM71D"}],"XU8ch":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInterpolator = initInterpolator;
exports.initRange = initRange;
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{}],"56YIM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _index = require("fcba4401bac5bf73");
var _init = require("cc7553c4008fe238");
var implicit = Symbol("implicit");
exports.implicit = implicit;
function ordinal() {
    var index = new _index.InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new _index.InternMap();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"fcba4401bac5bf73":"fO0ka","cc7553c4008fe238":"XU8ch"}],"b4ghE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
var _linear = require("f84b1fa17c06395b");
var _number = _interopRequireDefault(require("b36082d6f802f397"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, _number.default) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"f84b1fa17c06395b":"eXfiU","b36082d6f802f397":"lNmRJ"}],"eXfiU":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linear;
exports.linearish = linearish;
var _index = require("1483cc73fade9a0f");
var _continuous = _interopRequireWildcard(require("b89b32e6dad66d07"));
var _init = require("a628a2e1a79e7cdb");
var _tickFormat = _interopRequireDefault(require("a55604f9dbd11e62"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _index.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _index.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuous.default)();
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    _init.initRange.apply(scale, arguments);
    return linearish(scale);
}

},{"@swc/helpers/_/_type_of":"668P4","1483cc73fade9a0f":"fO0ka","b89b32e6dad66d07":"xvfJf","a628a2e1a79e7cdb":"XU8ch","a55604f9dbd11e62":"8gLwW"}],"xvfJf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = continuous;
exports.identity = identity;
exports.transformer = transformer;
var _index = require("b27e55bf39279c79");
var _index2 = require("ba6b5a0092937a29");
var _constant = _interopRequireDefault(require("e75211b791b964e7"));
var _number = _interopRequireDefault(require("d695e4a3f96a954d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _index.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = _index2.interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = _index2.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"b27e55bf39279c79":"fO0ka","ba6b5a0092937a29":"hkHcp","e75211b791b964e7":"260eK","d695e4a3f96a954d":"lNmRJ"}],"hkHcp":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "interpolate", {
    enumerable: true,
    get: function get() {
        return _value.default;
    }
});
Object.defineProperty(exports, "interpolateArray", {
    enumerable: true,
    get: function get() {
        return _array.default;
    }
});
Object.defineProperty(exports, "interpolateBasis", {
    enumerable: true,
    get: function get() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function get() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelix", {
    enumerable: true,
    get: function get() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function get() {
        return _cubehelix.cubehelixLong;
    }
});
Object.defineProperty(exports, "interpolateDate", {
    enumerable: true,
    get: function get() {
        return _date.default;
    }
});
Object.defineProperty(exports, "interpolateDiscrete", {
    enumerable: true,
    get: function get() {
        return _discrete.default;
    }
});
Object.defineProperty(exports, "interpolateHcl", {
    enumerable: true,
    get: function get() {
        return _hcl.default;
    }
});
Object.defineProperty(exports, "interpolateHclLong", {
    enumerable: true,
    get: function get() {
        return _hcl.hclLong;
    }
});
Object.defineProperty(exports, "interpolateHsl", {
    enumerable: true,
    get: function get() {
        return _hsl.default;
    }
});
Object.defineProperty(exports, "interpolateHslLong", {
    enumerable: true,
    get: function get() {
        return _hsl.hslLong;
    }
});
Object.defineProperty(exports, "interpolateHue", {
    enumerable: true,
    get: function get() {
        return _hue.default;
    }
});
Object.defineProperty(exports, "interpolateLab", {
    enumerable: true,
    get: function get() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "interpolateNumber", {
    enumerable: true,
    get: function get() {
        return _number.default;
    }
});
Object.defineProperty(exports, "interpolateNumberArray", {
    enumerable: true,
    get: function get() {
        return _numberArray.default;
    }
});
Object.defineProperty(exports, "interpolateObject", {
    enumerable: true,
    get: function get() {
        return _object.default;
    }
});
Object.defineProperty(exports, "interpolateRgb", {
    enumerable: true,
    get: function get() {
        return _rgb.default;
    }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function get() {
        return _rgb.rgbBasis;
    }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function get() {
        return _rgb.rgbBasisClosed;
    }
});
Object.defineProperty(exports, "interpolateRound", {
    enumerable: true,
    get: function get() {
        return _round.default;
    }
});
Object.defineProperty(exports, "interpolateString", {
    enumerable: true,
    get: function get() {
        return _string.default;
    }
});
Object.defineProperty(exports, "interpolateTransformCss", {
    enumerable: true,
    get: function get() {
        return _index.interpolateTransformCss;
    }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function get() {
        return _index.interpolateTransformSvg;
    }
});
Object.defineProperty(exports, "interpolateZoom", {
    enumerable: true,
    get: function get() {
        return _zoom.default;
    }
});
Object.defineProperty(exports, "piecewise", {
    enumerable: true,
    get: function get() {
        return _piecewise.default;
    }
});
Object.defineProperty(exports, "quantize", {
    enumerable: true,
    get: function get() {
        return _quantize.default;
    }
});
var _value = _interopRequireDefault(require("18a1769b74308b38"));
var _array = _interopRequireDefault(require("f99323a27aa06a8c"));
var _basis = _interopRequireDefault(require("66bb1ae08d550d2f"));
var _basisClosed = _interopRequireDefault(require("e0f8689cd9a4ed85"));
var _date = _interopRequireDefault(require("938cc47dd24b27f"));
var _discrete = _interopRequireDefault(require("6ee3a660784662db"));
var _hue = _interopRequireDefault(require("c97b3402df3264f1"));
var _number = _interopRequireDefault(require("c4605d70387a9f89"));
var _numberArray = _interopRequireDefault(require("f5b9681bf316d3c8"));
var _object = _interopRequireDefault(require("2a8363d30def3d49"));
var _round = _interopRequireDefault(require("132735e62b44017c"));
var _string = _interopRequireDefault(require("5f79c0b417d7ffb1"));
var _index = require("9cd31cac42489c2d");
var _zoom = _interopRequireDefault(require("829022ddb9572f68"));
var _rgb = _interopRequireWildcard(require("a08467c6d9046172"));
var _hsl = _interopRequireWildcard(require("1b2f37b38b1c2632"));
var _lab = _interopRequireDefault(require("76284b3c5d04b53e"));
var _hcl = _interopRequireWildcard(require("361bffab7c7a6e6a"));
var _cubehelix = _interopRequireWildcard(require("c6d6249c783d060a"));
var _piecewise = _interopRequireDefault(require("cb02924b4c722e0d"));
var _quantize = _interopRequireDefault(require("d55fda9f4fcff7dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"@swc/helpers/_/_type_of":"668P4","18a1769b74308b38":"k9h7J","f99323a27aa06a8c":"3hes7","66bb1ae08d550d2f":"9KX67","e0f8689cd9a4ed85":"lVgYo","938cc47dd24b27f":"aDTqI","6ee3a660784662db":"6evyD","c97b3402df3264f1":"eWwNl","c4605d70387a9f89":"5Hy6c","f5b9681bf316d3c8":"4BElO","2a8363d30def3d49":"hjekh","132735e62b44017c":"8DvGp","5f79c0b417d7ffb1":"6pliq","9cd31cac42489c2d":"4z8bE","829022ddb9572f68":"2lBLS","a08467c6d9046172":"adLsn","1b2f37b38b1c2632":"9OqdP","76284b3c5d04b53e":"jqNvC","361bffab7c7a6e6a":"k51uF","c6d6249c783d060a":"8vnNn","cb02924b4c722e0d":"2ts0r","d55fda9f4fcff7dd":"g2BHW"}],"k9h7J":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("6b00cb8a35cd7eca");
var _rgb = _interopRequireDefault(require("2f5b9308d0021b3f"));
var _array = require("858d92aa5fbe2d16");
var _date = _interopRequireDefault(require("3b5f3eaf3c70c4df"));
var _number = _interopRequireDefault(require("7aa3212a6360303f"));
var _object = _interopRequireDefault(require("4512622efcc3e244"));
var _string = _interopRequireDefault(require("4f6ec7c7e2d116a"));
var _constant = _interopRequireDefault(require("49fed36e04134ce7"));
var _numberArray = _interopRequireWildcard(require("7635b225e783f2fb"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var t = typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b), c;
    return b == null || t === "boolean" ? (0, _constant.default)(b) : (t === "number" ? _number.default : t === "string" ? (c = (0, _index.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number.default)(a, b);
}

},{"@swc/helpers/_/_type_of":"668P4","6b00cb8a35cd7eca":"hOYaa","2f5b9308d0021b3f":"adLsn","858d92aa5fbe2d16":"3hes7","3b5f3eaf3c70c4df":"aDTqI","7aa3212a6360303f":"5Hy6c","4512622efcc3e244":"hjekh","4f6ec7c7e2d116a":"6pliq","49fed36e04134ce7":"5Tj34","7635b225e783f2fb":"4BElO"}],"hOYaa":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "color", {
    enumerable: true,
    get: function get() {
        return _color.default;
    }
});
Object.defineProperty(exports, "cubehelix", {
    enumerable: true,
    get: function get() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "gray", {
    enumerable: true,
    get: function get() {
        return _lab.gray;
    }
});
Object.defineProperty(exports, "hcl", {
    enumerable: true,
    get: function get() {
        return _lab.hcl;
    }
});
Object.defineProperty(exports, "hsl", {
    enumerable: true,
    get: function get() {
        return _color.hsl;
    }
});
Object.defineProperty(exports, "lab", {
    enumerable: true,
    get: function get() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "lch", {
    enumerable: true,
    get: function get() {
        return _lab.lch;
    }
});
Object.defineProperty(exports, "rgb", {
    enumerable: true,
    get: function get() {
        return _color.rgb;
    }
});
var _color = _interopRequireWildcard(require("60878dcd6741cbf6"));
var _lab = _interopRequireWildcard(require("19fbdf90fb32e3fb"));
var _cubehelix = _interopRequireDefault(require("84a7e361b17f11ef"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"@swc/helpers/_/_type_of":"668P4","60878dcd6741cbf6":"erbiK","19fbdf90fb32e3fb":"kJyeX","84a7e361b17f11ef":"k4Wdv"}],"erbiK":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;
var _define = _interopRequireWildcard(require("1d30727e3b2969dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(".concat(reI, ",").concat(reI, ",").concat(reI, "\\)$")), reRgbPercent = new RegExp("^rgb\\(".concat(reP, ",").concat(reP, ",").concat(reP, "\\)$")), reRgbaInteger = new RegExp("^rgba\\(".concat(reI, ",").concat(reI, ",").concat(reI, ",").concat(reN, "\\)$")), reRgbaPercent = new RegExp("^rgba\\(".concat(reP, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$")), reHslPercent = new RegExp("^hsl\\(".concat(reN, ",").concat(reP, ",").concat(reP, "\\)$")), reHslaPercent = new RegExp("^hsla\\(".concat(reN, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$"));
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    clamp: function() {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b));
}
function rgb_formatHex8() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b)).concat(hex((isNaN(this.opacity) ? 1 : this.opacity) * 255));
}
function rgb_formatRgb() {
    var a = clampa(this.opacity);
    return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp: function() {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = clampa(this.opacity);
        return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"@swc/helpers/_/_type_of":"668P4","1d30727e3b2969dd":"5xaPy"}],"5xaPy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.extend = extend;
function _default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{}],"kJyeX":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hcl = Hcl;
exports.Lab = Lab;
exports.default = lab;
exports.gray = gray;
exports.hcl = hcl;
exports.lch = lch;
var _define = _interopRequireWildcard(require("9a3353011f08cad1"));
var _color = require("3650f0b1e5700098");
var _math = require("ef21497f13ac1079");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Lab, lab, (0, _define.extend)(_color.Color, {
    brighter: function(k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * _math.degrees;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * _math.radians;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _define.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
    brighter: function(k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return hcl2lab(this).rgb();
    }
}));

},{"@swc/helpers/_/_type_of":"668P4","9a3353011f08cad1":"5xaPy","3650f0b1e5700098":"erbiK","ef21497f13ac1079":"btxjU"}],"btxjU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.radians = exports.degrees = void 0;
var radians = Math.PI / 180;
exports.radians = radians;
var degrees = 180 / Math.PI;
exports.degrees = degrees;

},{}],"k4Wdv":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cubehelix = Cubehelix;
exports.default = cubehelix;
var _define = _interopRequireWildcard(require("4abcf1c064e6684a"));
var _color = require("88aa652eacec148e");
var _math = require("7e69901a6e423f00");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
    brighter: function(k) {
        k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? _color.darker : Math.pow(_color.darker, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"@swc/helpers/_/_type_of":"668P4","4abcf1c064e6684a":"5xaPy","88aa652eacec148e":"erbiK","7e69901a6e423f00":"btxjU"}],"adLsn":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rgbBasisClosed = exports.rgbBasis = exports.default = void 0;
var _index = require("a71c13c6f95adbd4");
var _basis = _interopRequireDefault(require("6a332a97102860d7"));
var _basisClosed = _interopRequireDefault(require("9304424e5c9a17cf"));
var _color = _interopRequireWildcard(require("7dffa81f3b4437d6"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function rgbGamma(y) {
    var color = (0, _color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _index.rgb)(start)).r, (end = (0, _index.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
exports.default = _default;
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _index.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline(_basis.default);
exports.rgbBasis = rgbBasis;
var rgbBasisClosed = rgbSpline(_basisClosed.default);
exports.rgbBasisClosed = rgbBasisClosed;

},{"@swc/helpers/_/_type_of":"668P4","a71c13c6f95adbd4":"hOYaa","6a332a97102860d7":"9KX67","9304424e5c9a17cf":"lVgYo","7dffa81f3b4437d6":"10gZF"}],"9KX67":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basis = basis;
exports.default = _default;
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function _default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{}],"lVgYo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("fa54a771ab54df01");
function _default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{"fa54a771ab54df01":"9KX67"}],"10gZF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nogamma;
exports.gamma = gamma;
exports.hue = hue;
var _constant = _interopRequireDefault(require("c45f0b08e65bfe9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constant.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constant.default)(isNaN(a) ? b : a);
}

},{"c45f0b08e65bfe9d":"5Tj34"}],"5Tj34":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = function(x) {
    return function() {
        return x;
    };
};
exports.default = _default;

},{}],"3hes7":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.genericArray = genericArray;
var _value = _interopRequireDefault(require("b86da8c7688bb1d9"));
var _numberArray = _interopRequireWildcard(require("505aa46a393cd613"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    return ((0, _numberArray.isNumberArray)(b) ? _numberArray.default : genericArray)(a, b);
}
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"@swc/helpers/_/_type_of":"668P4","b86da8c7688bb1d9":"k9h7J","505aa46a393cd613":"4BElO"}],"4BElO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.isNumberArray = isNumberArray;
function _default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{}],"aDTqI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

},{}],"5Hy6c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

},{}],"hjekh":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _value = _interopRequireDefault(require("ff3c10c6ba896e53"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== "object") a = {};
    if (b === null || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, _value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

},{"@swc/helpers/_/_type_of":"668P4","ff3c10c6ba896e53":"k9h7J"}],"6pliq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _number = _interopRequireDefault(require("1ec1f242696e82fa"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function _default(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = reA.exec(a)) && (bm = reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, _number.default)(am, bm)
            });
        }
        bi = reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

},{"1ec1f242696e82fa":"5Hy6c"}],"6evyD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

},{}],"eWwNl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _color = require("f9552f2567e33cad");
function _default(a, b) {
    var i = (0, _color.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

},{"f9552f2567e33cad":"10gZF"}],"8DvGp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

},{}],"4z8bE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateTransformSvg = exports.interpolateTransformCss = void 0;
var _number = _interopRequireDefault(require("3e2d37e598810190"));
var _parse = require("4b3d6acbd4a3c21a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
exports.interpolateTransformCss = interpolateTransformCss;
var interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");
exports.interpolateTransformSvg = interpolateTransformSvg;

},{"3e2d37e598810190":"5Hy6c","4b3d6acbd4a3c21a":"gG8cc"}],"gG8cc":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCss = parseCss;
exports.parseSvg = parseSvg;
var _decompose = _interopRequireWildcard(require("6801e9b7b9a8c06f"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var svgNode;
/* eslint-disable no-undef */ function parseCss(value) {
    var m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return _decompose.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
    value = value.matrix;
    return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"@swc/helpers/_/_type_of":"668P4","6801e9b7b9a8c06f":"dNXhN"}],"dNXhN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.identity = void 0;
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
exports.identity = identity;
function _default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

},{}],"2lBLS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var _default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function i(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function i(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
exports.default = _default;

},{}],"9OqdP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hslLong = exports.default = void 0;
var _index = require("8527dae26181d5cf");
var _color = _interopRequireWildcard(require("45faacac073e112a"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hsl)(start)).h, (end = (0, _index.hsl)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hsl(_color.hue);
exports.default = _default;
var hslLong = hsl(_color.default);
exports.hslLong = hslLong;

},{"@swc/helpers/_/_type_of":"668P4","8527dae26181d5cf":"hOYaa","45faacac073e112a":"10gZF"}],"jqNvC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = lab;
var _index = require("bb962b0e100409c3");
var _color = _interopRequireDefault(require("39c4c5a5fff46e6a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function lab(start, end) {
    var l = (0, _color.default)((start = (0, _index.lab)(start)).l, (end = (0, _index.lab)(end)).l), a = (0, _color.default)(start.a, end.a), b = (0, _color.default)(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"bb962b0e100409c3":"hOYaa","39c4c5a5fff46e6a":"10gZF"}],"k51uF":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hclLong = exports.default = void 0;
var _index = require("5dab9e1ee5c5ab5d");
var _color = _interopRequireWildcard(require("4a63660e3a72d4d2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hcl)(start)).h, (end = (0, _index.hcl)(end)).h), c = (0, _color.default)(start.c, end.c), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hcl(_color.hue);
exports.default = _default;
var hclLong = hcl(_color.default);
exports.hclLong = hclLong;

},{"@swc/helpers/_/_type_of":"668P4","5dab9e1ee5c5ab5d":"hOYaa","4a63660e3a72d4d2":"10gZF"}],"8vnNn":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.cubehelixLong = void 0;
var _index = require("981aef0afb354b0c");
var _color = _interopRequireWildcard(require("f9336ad633bd893d"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _index.cubehelix)(start)).h, (end = (0, _index.cubehelix)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var _default = cubehelix(_color.hue);
exports.default = _default;
var cubehelixLong = cubehelix(_color.default);
exports.cubehelixLong = cubehelixLong;

},{"@swc/helpers/_/_type_of":"668P4","981aef0afb354b0c":"hOYaa","f9336ad633bd893d":"10gZF"}],"2ts0r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = piecewise;
var _value = _interopRequireDefault(require("5c06b65a4f09269b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = _value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"5c06b65a4f09269b":"k9h7J"}],"g2BHW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

},{}],"260eK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constants;
function constants(x) {
    return function() {
        return x;
    };
}

},{}],"lNmRJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
function number(x) {
    return +x;
}

},{}],"8gLwW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tickFormat;
var _index = require("a4043605242eb496");
var _index2 = require("8da1e3e06f47624b");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _index.tickStep)(start, stop, count), precision;
    specifier = (0, _index2.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _index2.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _index2.format)(specifier);
}

},{"a4043605242eb496":"fO0ka","8da1e3e06f47624b":"jFQcG"}],"jFQcG":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
    enumerable: true,
    get: function get() {
        return _formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(exports, "format", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.format;
    }
});
Object.defineProperty(exports, "formatDefaultLocale", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "formatLocale", {
    enumerable: true,
    get: function get() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "formatPrefix", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.formatPrefix;
    }
});
Object.defineProperty(exports, "formatSpecifier", {
    enumerable: true,
    get: function get() {
        return _formatSpecifier.default;
    }
});
Object.defineProperty(exports, "precisionFixed", {
    enumerable: true,
    get: function get() {
        return _precisionFixed.default;
    }
});
Object.defineProperty(exports, "precisionPrefix", {
    enumerable: true,
    get: function get() {
        return _precisionPrefix.default;
    }
});
Object.defineProperty(exports, "precisionRound", {
    enumerable: true,
    get: function get() {
        return _precisionRound.default;
    }
});
var _defaultLocale = _interopRequireWildcard(require("2ee0c7b1a22e44e6"));
var _locale = _interopRequireDefault(require("ff358412e51164cd"));
var _formatSpecifier = _interopRequireWildcard(require("60d6396182b4fde8"));
var _precisionFixed = _interopRequireDefault(require("792b165b9b0bcf2d"));
var _precisionPrefix = _interopRequireDefault(require("f2702d774fe2085c"));
var _precisionRound = _interopRequireDefault(require("492f493218059efd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"@swc/helpers/_/_type_of":"668P4","2ee0c7b1a22e44e6":"72H6K","ff358412e51164cd":"kFYIe","60d6396182b4fde8":"9sZSa","792b165b9b0bcf2d":"3m7G8","f2702d774fe2085c":"cMRGu","492f493218059efd":"cyW3X"}],"72H6K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.formatPrefix = exports.format = void 0;
var _locale = _interopRequireDefault(require("317c67875ded3d99"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var format;
exports.format = format;
var formatPrefix;
exports.formatPrefix = formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.format = format = locale.format;
    exports.formatPrefix = formatPrefix = locale.formatPrefix;
    return locale;
}

},{"317c67875ded3d99":"kFYIe"}],"kFYIe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("f55671e2db2b86ef"));
var _formatGroup = _interopRequireDefault(require("e366a511ee4b4f2f"));
var _formatNumerals = _interopRequireDefault(require("86155372ae3c6f7e"));
var _formatSpecifier = _interopRequireDefault(require("1b6c7d0076b09661"));
var _formatTrim = _interopRequireDefault(require("8fea1479564cd384"));
var _formatTypes = _interopRequireDefault(require("8cc741dcfb99dfd9"));
var _formatPrefixAuto = require("10cbdd8f7ac88548");
var _identity = _interopRequireDefault(require("efeab53251079183"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function _default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, _formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = _formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, _formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

},{"f55671e2db2b86ef":"a5Div","e366a511ee4b4f2f":"2jONG","86155372ae3c6f7e":"3I8s2","1b6c7d0076b09661":"9sZSa","8fea1479564cd384":"5WrUk","8cc741dcfb99dfd9":"55t3N","10cbdd8f7ac88548":"6fAX1","efeab53251079183":"3TVWx"}],"a5Div":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("bc7d6f0e0b7ad989");
function _default(x) {
    return x = (0, _formatDecimal.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

},{"bc7d6f0e0b7ad989":"1HCFa"}],"1HCFa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.formatDecimalParts = formatDecimalParts;
function _default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{}],"2jONG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

},{}],"3I8s2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

},{}],"9sZSa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatSpecifier = FormatSpecifier;
exports.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{}],"5WrUk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

},{}],"55t3N":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatDecimal = _interopRequireDefault(require("feafbe2a554fb639"));
var _formatPrefixAuto = _interopRequireDefault(require("8d1082b790377352"));
var _formatRounded = _interopRequireDefault(require("35a9fc35835a2a14"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": _formatDecimal.default,
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRounded.default)(x * 100, p);
    },
    "r": _formatRounded.default,
    "s": _formatPrefixAuto.default,
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};
exports.default = _default;

},{"feafbe2a554fb639":"1HCFa","8d1082b790377352":"6fAX1","35a9fc35835a2a14":"bB293"}],"6fAX1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.prefixExponent = void 0;
var _formatDecimal = require("c968343e236e1eff");
var prefixExponent;
exports.prefixExponent = prefixExponent;
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

},{"c968343e236e1eff":"1HCFa"}],"bB293":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("8a356ace3ecb0657");
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

},{"8a356ace3ecb0657":"1HCFa"}],"3TVWx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return x;
}

},{}],"3m7G8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("10ac7ec4cef9eac2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step) {
    return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}

},{"10ac7ec4cef9eac2":"a5Div"}],"cMRGu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a74b6430297cf90d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}

},{"a74b6430297cf90d":"a5Div"}],"cyW3X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("152cf0fffe5db4dc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

},{"152cf0fffe5db4dc":"a5Div"}],"5ejhR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
exports.loggish = loggish;
var _index = require("c2225ae6830156cb");
var _index2 = require("9fe16242a20f801");
var _nice = _interopRequireDefault(require("e1f7cd4bad5fecf5"));
var _continuous = require("cdd2320c22aee987");
var _init = require("54c81c620622cc22");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x, k) {
        return -f(-x, k);
    };
}
function loggish(transform) {
    var scale = transform(transformLog, transformExp);
    var domain = scale.domain;
    var base = 10;
    var logs;
    var pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain();
        var u = d[0];
        var v = d[d.length - 1];
        var r = v < u;
        var ref;
        if (r) ref = [
            v,
            u
        ], u = ref[0], v = ref[1], ref;
        var i = logs(u);
        var j = logs(v);
        var k;
        var t;
        var n = count == null ? 10 : +count;
        var z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _index.ticks)(u, v, n);
        } else z = (0, _index.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _index2.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _index2.format)(specifier);
        }
        if (count === Infinity) return specifier;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _nice.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function log() {
    var scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _continuous.copy)(scale, log()).base(scale.base());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"c2225ae6830156cb":"fO0ka","9fe16242a20f801":"jFQcG","e1f7cd4bad5fecf5":"bhdW1","cdd2320c22aee987":"xvfJf","54c81c620622cc22":"XU8ch"}],"bhdW1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{}],"3jBKh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = symlog;
exports.symlogish = symlogish;
var _linear = require("6b7bc111d415c072");
var _continuous = require("f781e5664611d9c0");
var _init = require("499d293100f0413a");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return _init.initRange.apply(scale, arguments);
}

},{"6b7bc111d415c072":"eXfiU","f781e5664611d9c0":"xvfJf","499d293100f0413a":"XU8ch"}],"3Pw1H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pow;
exports.powish = powish;
exports.sqrt = sqrt;
var _linear = require("94b90569504e034e");
var _continuous = require("6297cca891d63c37");
var _init = require("1b7874ad495edb4c");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform(_continuous.identity, _continuous.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform(_continuous.identity, _continuous.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"94b90569504e034e":"eXfiU","6297cca891d63c37":"xvfJf","1b7874ad495edb4c":"XU8ch"}],"5dm4I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = radial;
var _continuous = _interopRequireDefault(require("9cc3a5098e156c85"));
var _init = require("116f55aac82ec8e9");
var _linear = require("b2719a0a78ca2805");
var _number = _interopRequireDefault(require("aa73717e632c4a05"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return (0, _linear.linearish)(scale);
}

},{"9cc3a5098e156c85":"xvfJf","116f55aac82ec8e9":"XU8ch","b2719a0a78ca2805":"eXfiU","aa73717e632c4a05":"lNmRJ"}],"4yWqJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
var _index = require("1587656407247c17");
var _init = require("e93efb9761f1f003");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _index.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _index.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d != null && !isNaN(d = +d)) domain.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        domain.sort(_index.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"1587656407247c17":"fO0ka","e93efb9761f1f003":"XU8ch"}],"7bjcZ":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantize;
var _index = require("61f3ae9aeeace72a");
var _linear = require("19f450ffb9fe0ee8");
var _init = require("97a4ee1bb0f33f6b");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, _slicedToArray._)(_, 2), x0 = ref[0], x1 = ref[1], ref, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return _init.initRange.apply((0, _linear.linearish)(scale), arguments);
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","61f3ae9aeeace72a":"fO0ka","19f450ffb9fe0ee8":"eXfiU","97a4ee1bb0f33f6b":"XU8ch"}],"hZ9Js":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = threshold;
var _index = require("4b6954aba910b52b");
var _init = require("5769040792c8fbdc");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"4b6954aba910b52b":"fO0ka","5769040792c8fbdc":"XU8ch"}],"lBwlP":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calendar = calendar;
exports.default = time;
var _index = require("d6f26b6733e27d9f");
var _index2 = require("2c6c21fb5fc82ed8");
var _continuous = _interopRequireWildcard(require("33f8922a5dd4a530"));
var _init = require("2234a07f2ca64e26");
var _nice = _interopRequireDefault(require("c7d75e934f92c19f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return _init.initRange.apply(calendar(_index.timeTicks, _index.timeTickInterval, _index.timeYear, _index.timeMonth, _index.timeWeek, _index.timeDay, _index.timeHour, _index.timeMinute, _index.timeSecond, _index2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"@swc/helpers/_/_type_of":"668P4","d6f26b6733e27d9f":"g2pn8","2c6c21fb5fc82ed8":"8rlIf","33f8922a5dd4a530":"xvfJf","2234a07f2ca64e26":"XU8ch","c7d75e934f92c19f":"bhdW1"}],"g2pn8":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "timeDay", {
    enumerable: true,
    get: function get() {
        return _day.default;
    }
});
Object.defineProperty(exports, "timeDays", {
    enumerable: true,
    get: function get() {
        return _day.days;
    }
});
Object.defineProperty(exports, "timeFriday", {
    enumerable: true,
    get: function get() {
        return _week.friday;
    }
});
Object.defineProperty(exports, "timeFridays", {
    enumerable: true,
    get: function get() {
        return _week.fridays;
    }
});
Object.defineProperty(exports, "timeHour", {
    enumerable: true,
    get: function get() {
        return _hour.default;
    }
});
Object.defineProperty(exports, "timeHours", {
    enumerable: true,
    get: function get() {
        return _hour.hours;
    }
});
Object.defineProperty(exports, "timeInterval", {
    enumerable: true,
    get: function get() {
        return _interval.default;
    }
});
Object.defineProperty(exports, "timeMillisecond", {
    enumerable: true,
    get: function get() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "timeMilliseconds", {
    enumerable: true,
    get: function get() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "timeMinute", {
    enumerable: true,
    get: function get() {
        return _minute.default;
    }
});
Object.defineProperty(exports, "timeMinutes", {
    enumerable: true,
    get: function get() {
        return _minute.minutes;
    }
});
Object.defineProperty(exports, "timeMonday", {
    enumerable: true,
    get: function get() {
        return _week.monday;
    }
});
Object.defineProperty(exports, "timeMondays", {
    enumerable: true,
    get: function get() {
        return _week.mondays;
    }
});
Object.defineProperty(exports, "timeMonth", {
    enumerable: true,
    get: function get() {
        return _month.default;
    }
});
Object.defineProperty(exports, "timeMonths", {
    enumerable: true,
    get: function get() {
        return _month.months;
    }
});
Object.defineProperty(exports, "timeSaturday", {
    enumerable: true,
    get: function get() {
        return _week.saturday;
    }
});
Object.defineProperty(exports, "timeSaturdays", {
    enumerable: true,
    get: function get() {
        return _week.saturdays;
    }
});
Object.defineProperty(exports, "timeSecond", {
    enumerable: true,
    get: function get() {
        return _second.default;
    }
});
Object.defineProperty(exports, "timeSeconds", {
    enumerable: true,
    get: function get() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "timeSunday", {
    enumerable: true,
    get: function get() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeSundays", {
    enumerable: true,
    get: function get() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeThursday", {
    enumerable: true,
    get: function get() {
        return _week.thursday;
    }
});
Object.defineProperty(exports, "timeThursdays", {
    enumerable: true,
    get: function get() {
        return _week.thursdays;
    }
});
Object.defineProperty(exports, "timeTickInterval", {
    enumerable: true,
    get: function get() {
        return _ticks.timeTickInterval;
    }
});
Object.defineProperty(exports, "timeTicks", {
    enumerable: true,
    get: function get() {
        return _ticks.timeTicks;
    }
});
Object.defineProperty(exports, "timeTuesday", {
    enumerable: true,
    get: function get() {
        return _week.tuesday;
    }
});
Object.defineProperty(exports, "timeTuesdays", {
    enumerable: true,
    get: function get() {
        return _week.tuesdays;
    }
});
Object.defineProperty(exports, "timeWednesday", {
    enumerable: true,
    get: function get() {
        return _week.wednesday;
    }
});
Object.defineProperty(exports, "timeWednesdays", {
    enumerable: true,
    get: function get() {
        return _week.wednesdays;
    }
});
Object.defineProperty(exports, "timeWeek", {
    enumerable: true,
    get: function get() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeWeeks", {
    enumerable: true,
    get: function get() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeYear", {
    enumerable: true,
    get: function get() {
        return _year.default;
    }
});
Object.defineProperty(exports, "timeYears", {
    enumerable: true,
    get: function get() {
        return _year.years;
    }
});
Object.defineProperty(exports, "utcDay", {
    enumerable: true,
    get: function get() {
        return _utcDay.default;
    }
});
Object.defineProperty(exports, "utcDays", {
    enumerable: true,
    get: function get() {
        return _utcDay.utcDays;
    }
});
Object.defineProperty(exports, "utcFriday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcFriday;
    }
});
Object.defineProperty(exports, "utcFridays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcFridays;
    }
});
Object.defineProperty(exports, "utcHour", {
    enumerable: true,
    get: function get() {
        return _utcHour.default;
    }
});
Object.defineProperty(exports, "utcHours", {
    enumerable: true,
    get: function get() {
        return _utcHour.utcHours;
    }
});
Object.defineProperty(exports, "utcMillisecond", {
    enumerable: true,
    get: function get() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "utcMilliseconds", {
    enumerable: true,
    get: function get() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "utcMinute", {
    enumerable: true,
    get: function get() {
        return _utcMinute.default;
    }
});
Object.defineProperty(exports, "utcMinutes", {
    enumerable: true,
    get: function get() {
        return _utcMinute.utcMinutes;
    }
});
Object.defineProperty(exports, "utcMonday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcMonday;
    }
});
Object.defineProperty(exports, "utcMondays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcMondays;
    }
});
Object.defineProperty(exports, "utcMonth", {
    enumerable: true,
    get: function get() {
        return _utcMonth.default;
    }
});
Object.defineProperty(exports, "utcMonths", {
    enumerable: true,
    get: function get() {
        return _utcMonth.utcMonths;
    }
});
Object.defineProperty(exports, "utcSaturday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSaturday;
    }
});
Object.defineProperty(exports, "utcSaturdays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSaturdays;
    }
});
Object.defineProperty(exports, "utcSecond", {
    enumerable: true,
    get: function get() {
        return _second.default;
    }
});
Object.defineProperty(exports, "utcSeconds", {
    enumerable: true,
    get: function get() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "utcSunday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcSundays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcThursday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcThursday;
    }
});
Object.defineProperty(exports, "utcThursdays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcThursdays;
    }
});
Object.defineProperty(exports, "utcTickInterval", {
    enumerable: true,
    get: function get() {
        return _ticks.utcTickInterval;
    }
});
Object.defineProperty(exports, "utcTicks", {
    enumerable: true,
    get: function get() {
        return _ticks.utcTicks;
    }
});
Object.defineProperty(exports, "utcTuesday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcTuesday;
    }
});
Object.defineProperty(exports, "utcTuesdays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcTuesdays;
    }
});
Object.defineProperty(exports, "utcWednesday", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcWednesday;
    }
});
Object.defineProperty(exports, "utcWednesdays", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcWednesdays;
    }
});
Object.defineProperty(exports, "utcWeek", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcWeeks", {
    enumerable: true,
    get: function get() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcYear", {
    enumerable: true,
    get: function get() {
        return _utcYear.default;
    }
});
Object.defineProperty(exports, "utcYears", {
    enumerable: true,
    get: function get() {
        return _utcYear.utcYears;
    }
});
var _interval = _interopRequireDefault(require("792c68a3f8a1926"));
var _millisecond = _interopRequireWildcard(require("2357def356bae18"));
var _second = _interopRequireWildcard(require("1c57489bc0aa2095"));
var _minute = _interopRequireWildcard(require("29ed17b274422d68"));
var _hour = _interopRequireWildcard(require("24ed79de6f4f26d"));
var _day = _interopRequireWildcard(require("82753f475a698669"));
var _week = require("a7e60f089113fd37");
var _month = _interopRequireWildcard(require("340ea3bf33812c65"));
var _year = _interopRequireWildcard(require("e014d3654a0b00fb"));
var _utcMinute = _interopRequireWildcard(require("5ff1ef18d2410f37"));
var _utcHour = _interopRequireWildcard(require("2822e085c5125d78"));
var _utcDay = _interopRequireWildcard(require("ff909be541c31c33"));
var _utcWeek = require("70b57967fcafbaa5");
var _utcMonth = _interopRequireWildcard(require("e41feff472794f13"));
var _utcYear = _interopRequireWildcard(require("9b0775a896f4b4dc"));
var _ticks = require("af413f597619bd05");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"@swc/helpers/_/_type_of":"668P4","792c68a3f8a1926":"iHUmu","2357def356bae18":"2wDBs","1c57489bc0aa2095":"czdSd","29ed17b274422d68":"altCZ","24ed79de6f4f26d":"9jUjq","82753f475a698669":"bPKcP","a7e60f089113fd37":"9oWC7","340ea3bf33812c65":"kwGPJ","e014d3654a0b00fb":"1lvNX","5ff1ef18d2410f37":"edXnG","2822e085c5125d78":"eBriX","ff909be541c31c33":"bRaqo","70b57967fcafbaa5":"hcltQ","e41feff472794f13":"cSFvl","9b0775a896f4b4dc":"2DyhW","af413f597619bd05":"5U7F5"}],"iHUmu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = newInterval;
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{}],"2wDBs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.milliseconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("47fef281020880de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var millisecond = (0, _interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var _default = millisecond;
exports.default = _default;
var milliseconds = millisecond.range;
exports.milliseconds = milliseconds;

},{"47fef281020880de":"iHUmu"}],"czdSd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("b059f221ba83fd2b"));
var _duration = require("4b017018381ce3ad");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var second = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * _duration.durationSecond);
}, function(start, end) {
    return (end - start) / _duration.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var _default = second;
exports.default = _default;
var seconds = second.range;
exports.seconds = seconds;

},{"b059f221ba83fd2b":"iHUmu","4b017018381ce3ad":"a7Lft"}],"a7Lft":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.durationYear = exports.durationWeek = exports.durationSecond = exports.durationMonth = exports.durationMinute = exports.durationHour = exports.durationDay = void 0;
var durationSecond = 1000;
exports.durationSecond = durationSecond;
var durationMinute = durationSecond * 60;
exports.durationMinute = durationMinute;
var durationHour = durationMinute * 60;
exports.durationHour = durationHour;
var durationDay = durationHour * 24;
exports.durationDay = durationDay;
var durationWeek = durationDay * 7;
exports.durationWeek = durationWeek;
var durationMonth = durationDay * 30;
exports.durationMonth = durationMonth;
var durationYear = durationDay * 365;
exports.durationYear = durationYear;

},{}],"altCZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("5b81b309635f37c2"));
var _duration = require("52c486da961f0d2c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var minute = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var _default = minute;
exports.default = _default;
var minutes = minute.range;
exports.minutes = minutes;

},{"5b81b309635f37c2":"iHUmu","52c486da961f0d2c":"a7Lft"}],"9jUjq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hours = exports.default = void 0;
var _interval = _interopRequireDefault(require("d36c991e94b8c5d6"));
var _duration = require("b17b3dbdbc5c799e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hour = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond - date.getMinutes() * _duration.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getHours();
});
var _default = hour;
exports.default = _default;
var hours = hour.range;
exports.hours = hours;

},{"d36c991e94b8c5d6":"iHUmu","b17b3dbdbc5c799e":"a7Lft"}],"bPKcP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.days = void 0;
var _interval = _interopRequireDefault(require("c559f97c050225d3"));
var _duration = require("93d679bd1def1b3c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var day = (0, _interval.default)(function(date) {
    return date.setHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay;
}, function(date) {
    return date.getDate() - 1;
});
var _default = day;
exports.default = _default;
var days = day.range;
exports.days = days;

},{"c559f97c050225d3":"iHUmu","93d679bd1def1b3c":"a7Lft"}],"9oWC7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wednesdays = exports.wednesday = exports.tuesdays = exports.tuesday = exports.thursdays = exports.thursday = exports.sundays = exports.sunday = exports.saturdays = exports.saturday = exports.mondays = exports.monday = exports.fridays = exports.friday = void 0;
var _interval = _interopRequireDefault(require("fb608840fab065f0"));
var _duration = require("136ded3f760de188");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function weekday(i) {
    return (0, _interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
    });
}
var sunday = weekday(0);
exports.sunday = sunday;
var monday = weekday(1);
exports.monday = monday;
var tuesday = weekday(2);
exports.tuesday = tuesday;
var wednesday = weekday(3);
exports.wednesday = wednesday;
var thursday = weekday(4);
exports.thursday = thursday;
var friday = weekday(5);
exports.friday = friday;
var saturday = weekday(6);
exports.saturday = saturday;
var sundays = sunday.range;
exports.sundays = sundays;
var mondays = monday.range;
exports.mondays = mondays;
var tuesdays = tuesday.range;
exports.tuesdays = tuesdays;
var wednesdays = wednesday.range;
exports.wednesdays = wednesdays;
var thursdays = thursday.range;
exports.thursdays = thursdays;
var fridays = friday.range;
exports.fridays = fridays;
var saturdays = saturday.range;
exports.saturdays = saturdays;

},{"fb608840fab065f0":"iHUmu","136ded3f760de188":"a7Lft"}],"kwGPJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.months = exports.default = void 0;
var _interval = _interopRequireDefault(require("7e198ba28f0e25de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var month = (0, _interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var _default = month;
exports.default = _default;
var months = month.range;
exports.months = months;

},{"7e198ba28f0e25de":"iHUmu"}],"1lvNX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.years = exports.default = void 0;
var _interval = _interopRequireDefault(require("699a5bdfd0c77e2e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var year = (0, _interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var _default = year;
exports.default = _default;
var years = year.range;
exports.years = years;

},{"699a5bdfd0c77e2e":"iHUmu"}],"edXnG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMinutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("64b6a8f5c9bd1c96"));
var _duration = require("32c01369d4e699fb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMinute = (0, _interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var _default = utcMinute;
exports.default = _default;
var utcMinutes = utcMinute.range;
exports.utcMinutes = utcMinutes;

},{"64b6a8f5c9bd1c96":"iHUmu","32c01369d4e699fb":"a7Lft"}],"eBriX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcHours = exports.default = void 0;
var _interval = _interopRequireDefault(require("8c74396d670977a"));
var _duration = require("6c82203e6970a1bc");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcHour = (0, _interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var _default = utcHour;
exports.default = _default;
var utcHours = utcHour.range;
exports.utcHours = utcHours;

},{"8c74396d670977a":"iHUmu","6c82203e6970a1bc":"a7Lft"}],"bRaqo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcDays = exports.default = void 0;
var _interval = _interopRequireDefault(require("1f97a562b3e12493"));
var _duration = require("4c0ac820095fab8f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcDay = (0, _interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / _duration.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var _default = utcDay;
exports.default = _default;
var utcDays = utcDay.range;
exports.utcDays = utcDays;

},{"1f97a562b3e12493":"iHUmu","4c0ac820095fab8f":"a7Lft"}],"hcltQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcWednesdays = exports.utcWednesday = exports.utcTuesdays = exports.utcTuesday = exports.utcThursdays = exports.utcThursday = exports.utcSundays = exports.utcSunday = exports.utcSaturdays = exports.utcSaturday = exports.utcMondays = exports.utcMonday = exports.utcFridays = exports.utcFriday = void 0;
var _interval = _interopRequireDefault(require("e95c6c72a9a72603"));
var _duration = require("b3779dea703b5e01");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function utcWeekday(i) {
    return (0, _interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / _duration.durationWeek;
    });
}
var utcSunday = utcWeekday(0);
exports.utcSunday = utcSunday;
var utcMonday = utcWeekday(1);
exports.utcMonday = utcMonday;
var utcTuesday = utcWeekday(2);
exports.utcTuesday = utcTuesday;
var utcWednesday = utcWeekday(3);
exports.utcWednesday = utcWednesday;
var utcThursday = utcWeekday(4);
exports.utcThursday = utcThursday;
var utcFriday = utcWeekday(5);
exports.utcFriday = utcFriday;
var utcSaturday = utcWeekday(6);
exports.utcSaturday = utcSaturday;
var utcSundays = utcSunday.range;
exports.utcSundays = utcSundays;
var utcMondays = utcMonday.range;
exports.utcMondays = utcMondays;
var utcTuesdays = utcTuesday.range;
exports.utcTuesdays = utcTuesdays;
var utcWednesdays = utcWednesday.range;
exports.utcWednesdays = utcWednesdays;
var utcThursdays = utcThursday.range;
exports.utcThursdays = utcThursdays;
var utcFridays = utcFriday.range;
exports.utcFridays = utcFridays;
var utcSaturdays = utcSaturday.range;
exports.utcSaturdays = utcSaturdays;

},{"e95c6c72a9a72603":"iHUmu","b3779dea703b5e01":"a7Lft"}],"cSFvl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMonths = exports.default = void 0;
var _interval = _interopRequireDefault(require("9fc54a6c7da64a87"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMonth = (0, _interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var _default = utcMonth;
exports.default = _default;
var utcMonths = utcMonth.range;
exports.utcMonths = utcMonths;

},{"9fc54a6c7da64a87":"iHUmu"}],"2DyhW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcYears = exports.default = void 0;
var _interval = _interopRequireDefault(require("8be30e72f54134d4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcYear = (0, _interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var _default = utcYear;
exports.default = _default;
var utcYears = utcYear.range;
exports.utcYears = utcYears;

},{"8be30e72f54134d4":"iHUmu"}],"5U7F5":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcTicks = exports.utcTickInterval = exports.timeTicks = exports.timeTickInterval = void 0;
var _index = require("d7f21fd662cddf99");
var _duration = require("aa18ef34c0be11bc");
var _millisecond = _interopRequireDefault(require("dac51414a1e8276b"));
var _second = _interopRequireDefault(require("d68afea8416c3f1a"));
var _minute = _interopRequireDefault(require("404a139d621a9db2"));
var _hour = _interopRequireDefault(require("9a0bf4314f401b0c"));
var _day = _interopRequireDefault(require("3f04924c68533af9"));
var _week = require("b2b29cfa1ce6c7da");
var _month = _interopRequireDefault(require("5ceb61e7c9c807ec"));
var _year = _interopRequireDefault(require("dd0ef245ed62fdbf"));
var _utcMinute = _interopRequireDefault(require("1e46f3d232f79e5e"));
var _utcHour = _interopRequireDefault(require("3d1ae5dfacd220b4"));
var _utcDay = _interopRequireDefault(require("5fb1b56afb7033e1"));
var _utcWeek = require("536323b8c7eb14e3");
var _utcMonth = _interopRequireDefault(require("856c2c54a9da13b6"));
var _utcYear = _interopRequireDefault(require("f5ebb8abb03b9dec"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ticker(year, month, week, day, hour, minute) {
    var tickIntervals = [
        [
            _second.default,
            1,
            _duration.durationSecond
        ],
        [
            _second.default,
            5,
            5 * _duration.durationSecond
        ],
        [
            _second.default,
            15,
            15 * _duration.durationSecond
        ],
        [
            _second.default,
            30,
            30 * _duration.durationSecond
        ],
        [
            minute,
            1,
            _duration.durationMinute
        ],
        [
            minute,
            5,
            5 * _duration.durationMinute
        ],
        [
            minute,
            15,
            15 * _duration.durationMinute
        ],
        [
            minute,
            30,
            30 * _duration.durationMinute
        ],
        [
            hour,
            1,
            _duration.durationHour
        ],
        [
            hour,
            3,
            3 * _duration.durationHour
        ],
        [
            hour,
            6,
            6 * _duration.durationHour
        ],
        [
            hour,
            12,
            12 * _duration.durationHour
        ],
        [
            day,
            1,
            _duration.durationDay
        ],
        [
            day,
            2,
            2 * _duration.durationDay
        ],
        [
            week,
            1,
            _duration.durationWeek
        ],
        [
            month,
            1,
            _duration.durationMonth
        ],
        [
            month,
            3,
            3 * _duration.durationMonth
        ],
        [
            year,
            1,
            _duration.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        var reverse = stop < start;
        var ref;
        if (reverse) ref = [
            stop,
            start
        ], start = ref[0], stop = ref[1], ref;
        var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        var _$ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? _$ticks.reverse() : _$ticks;
    }
    function tickInterval(start, stop, count) {
        var target = Math.abs(stop - start) / count;
        var i = (0, _index.bisector)(function(param) {
            var _param = (0, _slicedToArray._)(param, 3), step = _param[2];
            return step;
        }).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _index.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
        if (i === 0) return _millisecond.default.every(Math.max((0, _index.tickStep)(start, stop, count), 1));
        var _tickIntervals_ = (0, _slicedToArray._)(tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], 2), t = _tickIntervals_[0], step = _tickIntervals_[1];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
var _ticker = (0, _slicedToArray._)(ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default), 2), utcTicks = _ticker[0], utcTickInterval = _ticker[1];
exports.utcTickInterval = utcTickInterval;
exports.utcTicks = utcTicks;
var _ticker1 = (0, _slicedToArray._)(ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default), 2), timeTicks = _ticker1[0], timeTickInterval = _ticker1[1];
exports.timeTickInterval = timeTickInterval;
exports.timeTicks = timeTicks;

},{"@swc/helpers/_/_sliced_to_array":"byksX","d7f21fd662cddf99":"fO0ka","aa18ef34c0be11bc":"a7Lft","dac51414a1e8276b":"2wDBs","d68afea8416c3f1a":"czdSd","404a139d621a9db2":"altCZ","9a0bf4314f401b0c":"9jUjq","3f04924c68533af9":"bPKcP","b2b29cfa1ce6c7da":"9oWC7","5ceb61e7c9c807ec":"kwGPJ","dd0ef245ed62fdbf":"1lvNX","1e46f3d232f79e5e":"edXnG","3d1ae5dfacd220b4":"eBriX","5fb1b56afb7033e1":"bRaqo","536323b8c7eb14e3":"hcltQ","856c2c54a9da13b6":"cSFvl","f5ebb8abb03b9dec":"2DyhW"}],"8rlIf":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isoFormat", {
    enumerable: true,
    get: function get() {
        return _isoFormat.default;
    }
});
Object.defineProperty(exports, "isoParse", {
    enumerable: true,
    get: function get() {
        return _isoParse.default;
    }
});
Object.defineProperty(exports, "timeFormat", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.timeFormat;
    }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "timeFormatLocale", {
    enumerable: true,
    get: function get() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "timeParse", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.timeParse;
    }
});
Object.defineProperty(exports, "utcFormat", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.utcFormat;
    }
});
Object.defineProperty(exports, "utcParse", {
    enumerable: true,
    get: function get() {
        return _defaultLocale.utcParse;
    }
});
var _defaultLocale = _interopRequireWildcard(require("e254c805352cbe79"));
var _locale = _interopRequireDefault(require("a2049a4646cad099"));
var _isoFormat = _interopRequireDefault(require("8485f996f4dff29b"));
var _isoParse = _interopRequireDefault(require("e2c3ab8c9c293ff5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"@swc/helpers/_/_type_of":"668P4","e254c805352cbe79":"c49Ij","a2049a4646cad099":"GzfBo","8485f996f4dff29b":"lNLq6","e2c3ab8c9c293ff5":"eFnP3"}],"c49Ij":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = void 0;
var _locale = _interopRequireDefault(require("8c8d5f4601afc09e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var timeFormat;
exports.timeFormat = timeFormat;
var timeParse;
exports.timeParse = timeParse;
var utcFormat;
exports.utcFormat = utcFormat;
var utcParse;
exports.utcParse = utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.timeFormat = timeFormat = locale.format;
    exports.timeParse = timeParse = locale.parse;
    exports.utcFormat = utcFormat = locale.utcFormat;
    exports.utcParse = utcParse = locale.utcParse;
    return locale;
}

},{"8c8d5f4601afc09e":"GzfBo"}],"GzfBo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatLocale;
var _index = require("da76bc1e0eef4658");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? _index.utcMonday.ceil(week) : (0, _index.utcMonday)(week);
                    week = _index.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? _index.timeMonday.ceil(week) : (0, _index.timeMonday)(week);
                    week = _index.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            } // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function format(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function parse(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function utcFormat(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function utcParse(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, // note: ignores next directive
percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map(function(name, i) {
        return [
            name.toLowerCase(),
            i
        ];
    }));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + _index.timeDay.count((0, _index.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad(_index.timeSunday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(_index.timeThursday.count((0, _index.timeYear)(d), d) + ((0, _index.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad(_index.timeMonday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + _index.utcDay.count((0, _index.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad(_index.utcSunday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(_index.utcThursday.count((0, _index.utcYear)(d), d) + ((0, _index.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad(_index.utcMonday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"da76bc1e0eef4658":"g2pn8"}],"lNLq6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isoSpecifier = exports.default = void 0;
var _defaultLocale = require("2f8f6a7c55a265a7");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
exports.isoSpecifier = isoSpecifier;
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
var _default = formatIso;
exports.default = _default;

},{"2f8f6a7c55a265a7":"c49Ij"}],"eFnP3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isoFormat = require("c9c0e033b3f4cd7a");
var _defaultLocale = require("717272dfdfdf9f58");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default = parseIso;
exports.default = _default;

},{"c9c0e033b3f4cd7a":"lNLq6","717272dfdfdf9f58":"c49Ij"}],"4gX2g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = utcTime;
var _index = require("ea22621463423769");
var _index2 = require("df08fa54879bdddf");
var _time = require("3d474b4ac409608e");
var _init = require("f5277d460a04562a");
function utcTime() {
    return _init.initRange.apply((0, _time.calendar)(_index.utcTicks, _index.utcTickInterval, _index.utcYear, _index.utcMonth, _index.utcWeek, _index.utcDay, _index.utcHour, _index.utcMinute, _index.utcSecond, _index2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"ea22621463423769":"g2pn8","df08fa54879bdddf":"8rlIf","3d474b4ac409608e":"lBwlP","f5277d460a04562a":"XU8ch"}],"6VmBY":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = sequential;
exports.sequentialLog = sequentialLog;
exports.sequentialPow = sequentialPow;
exports.sequentialSqrt = sequentialSqrt;
exports.sequentialSymlog = sequentialSymlog;
var _index = require("576a63ed61017ad0");
var _continuous = require("367c19cf7640115e");
var _init = require("4d9ecd8e312987f2");
var _linear = require("7aa8dc079711aa38");
var _log = require("9675a35c284dba6f");
var _symlog = require("e5e6e98809c25bc3");
var _pow = require("814ae7ed84550652");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = _continuous.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, _slicedToArray._)(_, 2), x0 = ref[0], x1 = ref[1], ref, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            var ref;
            return arguments.length ? (ref = (0, _slicedToArray._)(_, 2), r0 = ref[0], r1 = ref[1], ref, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","576a63ed61017ad0":"hkHcp","367c19cf7640115e":"xvfJf","4d9ecd8e312987f2":"XU8ch","7aa8dc079711aa38":"eXfiU","9675a35c284dba6f":"5ejhR","e5e6e98809c25bc3":"3jBKh","814ae7ed84550652":"3Pw1H"}],"j8QuB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequentialQuantile;
var _index = require("eed0055976263d50");
var _continuous = require("21618a239c62366b");
var _init = require("92ad1cf8524c146");
function sequentialQuantile() {
    var domain = [], interpolator = _continuous.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _index.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                if (d != null && !isNaN(d = +d)) domain.push(d);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        domain.sort(_index.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map(function(d, i) {
            return interpolator(i / (domain.length - 1));
        });
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, function(_, i) {
            return (0, _index.quantile)(domain, i / n);
        });
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return _init.initInterpolator.apply(scale, arguments);
}

},{"eed0055976263d50":"fO0ka","21618a239c62366b":"xvfJf","92ad1cf8524c146":"XU8ch"}],"1f3f6":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diverging;
exports.divergingLog = divergingLog;
exports.divergingPow = divergingPow;
exports.divergingSqrt = divergingSqrt;
exports.divergingSymlog = divergingSymlog;
var _index = require("915e51d9b913a910");
var _continuous = require("bf6a55aee26f6305");
var _init = require("dafbeaec64c427e8");
var _linear = require("367c88af554f4c81");
var _log = require("f1b41897387bed31");
var _sequential = require("478631d13f9292c0");
var _symlog = require("f1514783e2b3953d");
var _pow = require("2cbbbabc7f04bb29");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = _continuous.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        var ref;
        return arguments.length ? (ref = (0, _slicedToArray._)(_, 3), x0 = ref[0], x1 = ref[1], x2 = ref[2], ref, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            var ref;
            return arguments.length ? (ref = (0, _slicedToArray._)(_, 3), r0 = ref[0], r1 = ref[1], r2 = ref[2], ref, interpolator = (0, _index.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","915e51d9b913a910":"hkHcp","bf6a55aee26f6305":"xvfJf","dafbeaec64c427e8":"XU8ch","367c88af554f4c81":"eXfiU","f1b41897387bed31":"5ejhR","478631d13f9292c0":"6VmBY","f1514783e2b3953d":"3jBKh","2cbbbabc7f04bb29":"3Pw1H"}],"1ecOu":[function(require,module,exports,__globalThis) {
var baseExtremum = require("c7d87741ab4129b0"), baseGt = require("dbeef59341d150f4"), identity = require("3c95c3c9fbe3850f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function max(array) {
    return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
}
module.exports = max;

},{"c7d87741ab4129b0":"eGQGj","dbeef59341d150f4":"kFJAu","3c95c3c9fbe3850f":"6wIyV"}],"eGQGj":[function(require,module,exports,__globalThis) {
var isSymbol = require("6a2d056d200c4854");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = baseExtremum;

},{"6a2d056d200c4854":"5eB4J"}],"kFJAu":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
module.exports = baseGt;

},{}],"eA2id":[function(require,module,exports,__globalThis) {
var baseExtremum = require("122393f3e0d791dc"), baseLt = require("8122a719ac68b5c4"), identity = require("3161b76b624de11a");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}
module.exports = min;

},{"122393f3e0d791dc":"eGQGj","8122a719ac68b5c4":"9bKID","3161b76b624de11a":"6wIyV"}],"9bKID":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function baseLt(value, other) {
    return value < other;
}
module.exports = baseLt;

},{}],"26i2l":[function(require,module,exports,__globalThis) {
var baseFlatten = require("727a074274bef45"), map = require("19e2d816e1d885f8");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function flatMap(collection, iteratee) {
    return baseFlatten(map(collection, iteratee), 1);
}
module.exports = flatMap;

},{"727a074274bef45":"8iQ0s","19e2d816e1d885f8":"04FNS"}],"04FNS":[function(require,module,exports,__globalThis) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"5ZiZU","8bad46685c8864d":"exkHY","51c76ab24fdb66f9":"eccnZ","7cb4cacc4dea406c":"jQGs4"}],"9ZOqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTickValues", function() {
    return 0, _getNiceTickValues.getTickValues;
});
parcelHelpers.export(exports, "getNiceTickValues", function() {
    return 0, _getNiceTickValues.getNiceTickValues;
});
parcelHelpers.export(exports, "getTickValuesFixedDomain", function() {
    return 0, _getNiceTickValues.getTickValuesFixedDomain;
});
var _getNiceTickValues = require("./getNiceTickValues");

},{"./getNiceTickValues":"4tJUJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tJUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNiceTickValues", function() {
    return getNiceTickValues;
});
parcelHelpers.export(exports, "getTickValues", function() {
    return getTickValues;
});
parcelHelpers.export(exports, "getTickValuesFixedDomain", function() {
    return getTickValuesFixedDomain;
});
/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./util/utils");
var _arithmetic = require("./util/arithmetic");
var _arithmeticDefault = parcelHelpers.interopDefault(_arithmetic);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function getValidInterval(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, _decimalJsLightDefault.default)(0);
    var digitCount = (0, _arithmeticDefault.default).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, _decimalJsLightDefault.default)(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, _decimalJsLightDefault.default)(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, _decimalJsLightDefault.default)(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, _decimalJsLightDefault.default)(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, _decimalJsLightDefault.default)(10).pow((0, _arithmeticDefault.default).getDigitCount(value) - 1);
            middle = new (0, _decimalJsLightDefault.default)(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    } else if (value === 0) middle = new (0, _decimalJsLightDefault.default)(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return middle.add(new (0, _decimalJsLightDefault.default)(n - middleIndex).mul(step)).toNumber();
    }), (0, _utils.range));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, _decimalJsLightDefault.default)(0),
        tickMin: new (0, _decimalJsLightDefault.default)(0),
        tickMax: new (0, _decimalJsLightDefault.default)(0)
    };
     // The step which is easy to understand between two ticks
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, _decimalJsLightDefault.default)(0);
    else {
        // calculate the middle value
        middle = new (0, _decimalJsLightDefault.default)(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, _decimalJsLightDefault.default)(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, _decimalJsLightDefault.default)(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, _decimalJsLightDefault.default)(belowCount).mul(step)),
        tickMax: middle.add(new (0, _decimalJsLightDefault.default)(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getNiceTickValuesFn(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = getValidInterval([
        min,
        max
    ]), _getValidInterval2 = _slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, _utils.reverse)(_values) : _values;
    }
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, _arithmeticDefault.default).rangeStep(tickMin, tickMax.add(new (0, _decimalJsLightDefault.default)(0.1).mul(step)), step);
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFn(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = getValidInterval([
        min,
        max
    ]), _getValidInterval4 = _slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return new (0, _decimalJsLightDefault.default)(cormin).add(new (0, _decimalJsLightDefault.default)(n).mul(step)).toNumber();
    }), (0, _utils.range));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = _slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = getValidInterval([
        min,
        max
    ]), _getValidInterval6 = _slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat(_toConsumableArray((0, _arithmeticDefault.default).rangeStep(new (0, _decimalJsLightDefault.default)(cormin), new (0, _decimalJsLightDefault.default)(cormax).sub(new (0, _decimalJsLightDefault.default)(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, _utils.reverse)(values) : values;
}
var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

},{"decimal.js-light":"8uRNy","./util/utils":"5BjZ2","./util/arithmetic":"hGp84","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uRNy":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || (typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})(undefined);

},{"@swc/helpers/_/_type_of":"668P4"}],"5BjZ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACE_HOLDER", function() {
    return PLACE_HOLDER;
});
parcelHelpers.export(exports, "curry", function() {
    return curry;
});
parcelHelpers.export(exports, "range", function() {
    return range;
});
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "compose", function() {
    return compose;
});
parcelHelpers.export(exports, "reverse", function() {
    return reverse;
});
parcelHelpers.export(exports, "memoize", function() {
    return memoize;
});
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var identity = function identity(i) {
    return i;
};
var PLACE_HOLDER = {
    '@@functional/placeholder': true
};
var isPlaceHolder = function isPlaceHolder(val) {
    return val === PLACE_HOLDER;
};
var curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== PLACE_HOLDER;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var curry = function curry(fn) {
    return curryN(fn.length, fn);
};
var range = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var map = curry(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var compose = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var reverse = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var memoize = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hGp84":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./utils");
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, _decimalJsLightDefault.default)(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function rangeStep(start, end, step) {
    var num = new (0, _decimalJsLightDefault.default)(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var interpolateNumber = (0, _utils.curry)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var uninterpolateNumber = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var uninterpolateTruncation = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
exports.default = {
    rangeStep: rangeStep,
    getDigitCount: getDigitCount,
    interpolateNumber: interpolateNumber,
    uninterpolateNumber: uninterpolateNumber,
    uninterpolateTruncation: uninterpolateTruncation
};

},{"decimal.js-light":"8uRNy","./utils":"5BjZ2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gEFRh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBar", function() {
    return ErrorBar;
});
/**
 * @fileOverview Render a group of error bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ErrorBar = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        _classCallCheck(this, ErrorBar);
        return _callSuper(this, ErrorBar, arguments);
    }
    _inherits(ErrorBar, _React$Component);
    return _createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = _objectWithoutProperties(_this$props, _excluded);
                var svgProps = (0, _reactUtils.filterProps)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, _tinyInvariantDefault.default)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = _slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ErrorBar, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
_defineProperty(ErrorBar, "displayName", 'ErrorBar');

},{"react":"gVheC","tiny-invariant":"01Hp1","../container/Layer":"4SHHK","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aUyfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLegendProps", function() {
    return getLegendProps;
});
var _legend = require("../component/Legend");
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getLegendProps = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    if (!legendItem) return null;
    var legendDefaultProps = (0, _legend.Legend).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? _objectSpread(_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, _chartUtils.getMainColorOfGraphicItem)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return _objectSpread(_objectSpread(_objectSpread({}, legendProps), (0, _legend.Legend).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};

},{"../component/Legend":"m2stU","./ChartUtils":"5VwLU","./ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eDANL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabelList", function() {
    return LabelList;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _label = require("./Label");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "valueAccessor"
], _excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, _lastDefault.default)(entry.value) : entry.value;
};
function LabelList(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties(_ref, _excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties(restProps, _excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, _isNilDefault.default)(dataKey) ? valueAccessor(entry, index) : (0, _chartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, _isNilDefault.default)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), _extends({}, (0, _reactUtils.filterProps)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, _label.Label).parseViewBox((0, _isNilDefault.default)(clockWise) ? entry : _objectSpread(_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
LabelList.displayName = 'LabelList';
function parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label) || (0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, _extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, _reactUtils.findAllByType)(children, LabelList).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat(_toConsumableArray(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;

},{"react":"gVheC","lodash/isNil":"beGyX","lodash/isObject":"8ffGS","lodash/isFunction":"8ck2f","lodash/last":"7crLt","./Label":"fRyNr","../container/Layer":"4SHHK","../util/ReactUtils":"bLejJ","../util/ChartUtils":"5VwLU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lEd0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sector", function() {
    return Sector;
});
/**
 * @fileOverview Sector
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, _polarUtils.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, _polarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, _polarUtils.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var _getTangentCircle = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var Sector = function Sector(sectorProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, _dataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};

},{"react":"gVheC","clsx":"aGWRz","../util/ReactUtils":"bLejJ","../util/PolarUtils":"b4tu9","../util/DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l4o9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", function() {
    return getPath;
});
parcelHelpers.export(exports, "Curve", function() {
    return Curve;
});
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _d3Shape = require("victory-vendor/d3-shape");
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CURVE_FACTORIES = {
    curveBasisClosed: (0, _d3Shape.curveBasisClosed),
    curveBasisOpen: (0, _d3Shape.curveBasisOpen),
    curveBasis: (0, _d3Shape.curveBasis),
    curveBumpX: (0, _d3Shape.curveBumpX),
    curveBumpY: (0, _d3Shape.curveBumpY),
    curveLinearClosed: (0, _d3Shape.curveLinearClosed),
    curveLinear: (0, _d3Shape.curveLinear),
    curveMonotoneX: (0, _d3Shape.curveMonotoneX),
    curveMonotoneY: (0, _d3Shape.curveMonotoneY),
    curveNatural: (0, _d3Shape.curveNatural),
    curveStep: (0, _d3Shape.curveStep),
    curveStepAfter: (0, _d3Shape.curveStepAfter),
    curveStepBefore: (0, _d3Shape.curveStepBefore)
};
var defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
    return p.x;
};
var getY = function getY(p) {
    return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, _isFunctionDefault.default)(type)) return type;
    var name = "curve".concat((0, _upperFirstDefault.default)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return CURVE_FACTORIES[name] || (0, _d3Shape.curveLinear);
};
var getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return _objectSpread(_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
    else if ((0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
    else lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var Curve = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? getPath(props) : path;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: (0, _clsxDefault.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};

},{"react":"gVheC","victory-vendor/d3-shape":"4FHVD","lodash/upperFirst":"8ljuM","lodash/isFunction":"8ck2f","clsx":"aGWRz","../util/types":"fLu4V","../util/ReactUtils":"bLejJ","../util/DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2vZys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInRectangle", function() {
    return isInRectangle;
});
parcelHelpers.export(exports, "Rectangle", function() {
    return Rectangle;
});
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var isInRectangle = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Rectangle = function Rectangle(rectangleProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), rectangleProps);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
            className: layerClass,
            d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};

},{"react":"gVheC","clsx":"aGWRz","react-smooth":"ffKTh","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ffKTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configSpring", function() {
    return 0, _easing.configSpring;
});
parcelHelpers.export(exports, "configBezier", function() {
    return 0, _easing.configBezier;
});
parcelHelpers.export(exports, "AnimateGroup", function() {
    return 0, _animateGroupDefault.default;
});
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _easing = require("./easing");
var _animateGroup = require("./AnimateGroup");
var _animateGroupDefault = parcelHelpers.interopDefault(_animateGroup);
exports.default = (0, _animateDefault.default);

},{"./Animate":"e2fPG","./easing":"efuEZ","./AnimateGroup":"aKXyR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e2fPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fastEquals = require("fast-equals");
var _animateManager = require("./AnimateManager");
var _animateManagerDefault = parcelHelpers.interopDefault(_animateManager);
var _easing = require("./easing");
var _configUpdate = require("./configUpdate");
var _configUpdateDefault = parcelHelpers.interopDefault(_configUpdate);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var Animate = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Animate, _PureComponent);
    var _super = _createSuper(Animate);
    function Animate(props, context) {
        var _this;
        _classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return _possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return _possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? _defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    _createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? _defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, _fastEquals.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? _defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation(_objectSpread(_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, _configUpdateDefault.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat(_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, _util.getTransitionVal)(properties, duration, easing);
                    var newStyle = _objectSpread(_objectSpread(_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat(_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, _util.identity));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat(_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, _animateManagerDefault.default)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    _objectSpread(_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = _objectWithoutProperties(_this$props4, _excluded);
                var count = (0, _react.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, _react.cloneElement)(container, _objectSpread(_objectSpread({}, others), {}, {
                        style: _objectSpread(_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, _react.Children).only(children));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, (0, _react.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, _react.PureComponent));
Animate.displayName = 'Animate';
Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
Animate.propTypes = {
    from: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    to: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    attributeName: (0, _propTypesDefault.default).string,
    // animation duration
    duration: (0, _propTypesDefault.default).number,
    begin: (0, _propTypesDefault.default).number,
    easing: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    steps: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        duration: (0, _propTypesDefault.default).number.isRequired,
        style: (0, _propTypesDefault.default).object.isRequired,
        easing: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, _propTypesDefault.default).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, _propTypesDefault.default).arrayOf('string'),
        onAnimationEnd: (0, _propTypesDefault.default).func
    })),
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    isActive: (0, _propTypesDefault.default).bool,
    canBegin: (0, _propTypesDefault.default).bool,
    onAnimationEnd: (0, _propTypesDefault.default).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, _propTypesDefault.default).bool,
    onAnimationStart: (0, _propTypesDefault.default).func,
    onAnimationReStart: (0, _propTypesDefault.default).func
};
exports.default = Animate;

},{"react":"gVheC","prop-types":"3KNJy","fast-equals":"iHkim","./AnimateManager":"akYQd","./easing":"efuEZ","./configUpdate":"gCP7t","./util":"5tZD3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iHkim":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
(function(global, factory) {
    factory(exports);
})(undefined, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== 'object' || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) !== 'object' || (typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)) !== 'object') return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _$_a = createState(), _b = _$_a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _$_a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function createInternalComparator() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

},{"@swc/helpers/_/_type_of":"668P4"}],"akYQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createAnimateManager;
});
var _setRafTimeout = require("./setRafTimeout");
var _setRafTimeoutDefault = parcelHelpers.interopDefault(_setRafTimeout);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles));
            return;
        }
        if (_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}

},{"./setRafTimeout":"klJr8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"klJr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setRafTimeout;
});
function safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"efuEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configBezier", function() {
    return configBezier;
});
parcelHelpers.export(exports, "configSpring", function() {
    return configSpring;
});
parcelHelpers.export(exports, "configEasing", function() {
    return configEasing;
});
var _util = require("./util");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        return multyTime(params, t);
    };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        var newParams = [].concat(_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return multyTime(newParams, t);
    };
};
var configBezier = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, _util.warn)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, _util.warn)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = cubicBezier(x1, x2);
    var curveY = cubicBezier(y1, y2);
    var derCurveX = derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var configSpring = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var configEasing = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return configBezier(easing);
        case 'spring':
            return configSpring();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return configBezier(easing);
            (0, _util.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, _util.warn)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};

},{"./util":"5tZD3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5tZD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntersectionKeys", function() {
    return getIntersectionKeys;
});
parcelHelpers.export(exports, "identity", function() {
    return identity;
});
parcelHelpers.export(exports, "getDashCase", function() {
    return getDashCase;
});
parcelHelpers.export(exports, "log", function() {
    return log;
});
parcelHelpers.export(exports, "debug", function() {
    return debug;
});
parcelHelpers.export(exports, "debugf", function() {
    return debugf;
});
parcelHelpers.export(exports, "mapObject", function() {
    return mapObject;
});
parcelHelpers.export(exports, "getTransitionVal", function() {
    return getTransitionVal;
});
parcelHelpers.export(exports, "warn", function() {
    return warn;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var identity = function identity(param) {
    return param;
};
var getDashCase = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var log = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var debug = function debug(name) {
    return function(item) {
        log(name, item);
        return item;
    };
};
var debugf = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var mapObject = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var isDev = false;
var warn = function warn(condition, format, a, b, c, d, e, f) {
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCP7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return _objectSpread(_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) return _objectSpread(_objectSpread({}, val), {}, {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
// configure update function
exports.default = function(from, to, easing, duration, render) {
    var interKeys = (0, _util.getIntersectionKeys)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, _util.mapObject)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter(needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, _util.mapObject)(function(key, val) {
            return alpha.apply(void 0, _toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, _util.mapObject)(function(key, val) {
                return alpha.apply(void 0, _toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render(_objectSpread(_objectSpread(_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};

},{"./util":"5tZD3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aKXyR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animateGroupChild = require("./AnimateGroupChild");
var _animateGroupChildDefault = parcelHelpers.interopDefault(_animateGroupChild);
function AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.TransitionGroup), {
        component: component
    }, (0, _react.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateGroupChildDefault.default), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
AnimateGroup.propTypes = {
    appear: (0, _propTypesDefault.default).object,
    enter: (0, _propTypesDefault.default).object,
    leave: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).element
    ]),
    component: (0, _propTypesDefault.default).any
};
AnimateGroup.defaultProps = {
    component: 'span'
};
exports.default = AnimateGroup;

},{"react":"gVheC","react-transition-group":"5ABiG","prop-types":"3KNJy","./AnimateGroupChild":"5BnRL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ABiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", function() {
    return 0, _csstransitionDefault.default;
});
parcelHelpers.export(exports, "ReplaceTransition", function() {
    return 0, _replaceTransitionDefault.default;
});
parcelHelpers.export(exports, "SwitchTransition", function() {
    return 0, _switchTransitionDefault.default;
});
parcelHelpers.export(exports, "TransitionGroup", function() {
    return 0, _transitionGroupDefault.default;
});
parcelHelpers.export(exports, "Transition", function() {
    return 0, _transitionDefault.default;
});
parcelHelpers.export(exports, "config", function() {
    return 0, _configDefault.default;
});
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"8qhYY","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":"bR9Bj","./Transition":"30G8b","./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qhYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","dom-helpers/addClass":"15llo","dom-helpers/removeClass":"kFGmR","react":"gVheC","./Transition":"30G8b","./utils/PropTypes":"4Vflm","./utils/reflow":"lXLaD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15llo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addClass;
});
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"8TcJP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TcJP":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hasClass;
});
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kFGmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return removeClass;
});
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"30G8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", function() {
    return UNMOUNTED;
});
parcelHelpers.export(exports, "EXITED", function() {
    return EXITED;
});
parcelHelpers.export(exports, "ENTERING", function() {
    return ENTERING;
});
parcelHelpers.export(exports, "ENTERED", function() {
    return ENTERED;
});
parcelHelpers.export(exports, "EXITING", function() {
    return EXITING;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","react":"gVheC","react-dom":"d8jlt","./config":"DaODG","./utils/PropTypes":"4Vflm","./TransitionGroupContext":"boqFo","./utils/reflow":"lXLaD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"DaODG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Vflm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", function() {
    return timeoutsShape;
});
parcelHelpers.export(exports, "classNamesShape", function() {
    return classNamesShape;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boqFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lXLaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", function() {
    return forceReflow;
});
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bR9Bj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","react":"gVheC","./TransitionGroupContext":"boqFo","./utils/ChildMapping":"bRz9r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bRz9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", function() {
    return getChildMapping;
});
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", function() {
    return mergeChildMappings;
});
parcelHelpers.export(exports, "getInitialChildMapping", function() {
    return getInitialChildMapping;
});
parcelHelpers.export(exports, "getNextChildMapping", function() {
    return getNextChildMapping;
});
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5BnRL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    _inherits(AnimateGroupChild, _Component);
    var _super = _createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        _classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        _defineProperty(_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    _createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function onAnimationEnd() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState(_objectSpread(_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = _objectWithoutProperties(_this$props3, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), _extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateDefault.default), _this2.state, (0, _react.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, _react.Component));
AnimateGroupChild.propTypes = {
    appearOptions: (0, _propTypesDefault.default).object,
    enterOptions: (0, _propTypesDefault.default).object,
    leaveOptions: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).element
};
exports.default = AnimateGroupChild;

},{"react":"gVheC","react-transition-group":"5ABiG","prop-types":"3KNJy","./Animate":"e2fPG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"brBgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polygon", function() {
    return Polygon;
});
/**
 * @fileOverview Polygon
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if (isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if (isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat(_toConsumableArray(res), _toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties(props, _excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};

},{"react":"gVheC","clsx":"aGWRz","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Xk21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", function() {
    return Dot;
});
/**
 * @fileOverview Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Dot = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, _clsxDefault.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

},{"react":"gVheC","clsx":"aGWRz","../util/types":"fLu4V","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZzoK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", function() {
    return Cross;
});
/**
 * @fileOverview Cross
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var Cross = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || !(0, _dataUtils.isNumber)(top) || !(0, _dataUtils.isNumber)(left)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: (0, _clsxDefault.default)('recharts-cross', className),
        d: getPath(x, y, width, height, top, left)
    }));
};

},{"react":"gVheC","clsx":"aGWRz","../util/DataUtils":"c1vtt","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7j4lw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarRadiusAxis", function() {
    return PolarRadiusAxis;
});
/**
 * @fileOverview The axis of polar coordinate system
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _maxBy = require("lodash/maxBy");
var _maxByDefault = parcelHelpers.interopDefault(_maxBy);
var _minBy = require("lodash/minBy");
var _minByDefault = parcelHelpers.interopDefault(_minBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("../component/Text");
var _label = require("../component/Label");
var _layer = require("../container/Layer");
var _polarUtils = require("../util/PolarUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], _excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PolarRadiusAxis = /*#__PURE__*/ function(_PureComponent) {
    function PolarRadiusAxis() {
        _classCallCheck(this, PolarRadiusAxis);
        return _callSuper(this, PolarRadiusAxis, arguments);
    }
    _inherits(PolarRadiusAxis, _PureComponent);
    return _createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, _polarUtils.polarToCartesian)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, _maxByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, _minByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties(_this$props3, _excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[0], angle);
                var point1 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[1], angle);
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(others, false)), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = _objectWithoutProperties(_this$props4, _excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, _reactUtils.filterProps)(others, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)('recharts-polar-radius-axis-tick', (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-polar-radius-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, _label.Label).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(PolarRadiusAxis, "displayName", 'PolarRadiusAxis');
_defineProperty(PolarRadiusAxis, "axisType", 'radiusAxis');
_defineProperty(PolarRadiusAxis, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});

},{"react":"gVheC","lodash/maxBy":"l5j5S","lodash/minBy":"jIXcQ","lodash/isFunction":"8ck2f","clsx":"aGWRz","../component/Text":"31dv8","../component/Label":"fRyNr","../container/Layer":"4SHHK","../util/PolarUtils":"b4tu9","../util/types":"fLu4V","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5j5S":[function(require,module,exports,__globalThis) {
var baseExtremum = require("dba025d59f90321a"), baseGt = require("d445a3f41a3424f9"), baseIteratee = require("3271a4dbe265890");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function maxBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt) : undefined;
}
module.exports = maxBy;

},{"dba025d59f90321a":"eGQGj","d445a3f41a3424f9":"kFJAu","3271a4dbe265890":"exkHY"}],"jIXcQ":[function(require,module,exports,__globalThis) {
var baseExtremum = require("515d8abb123de545"), baseIteratee = require("e7a24e488e92031a"), baseLt = require("cba661d625852896");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function minBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt) : undefined;
}
module.exports = minBy;

},{"515d8abb123de545":"eGQGj","e7a24e488e92031a":"exkHY","cba661d625852896":"9bKID"}],"lso03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarAngleAxis", function() {
    return PolarAngleAxis;
});
/**
 * @fileOverview Axis of radial direction
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _polygon = require("../shape/Polygon");
var _text = require("../component/Text");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var RADIAN = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /*#__PURE__*/ function(_PureComponent) {
    function PolarAngleAxis() {
        _classCallCheck(this, PolarAngleAxis);
        return _callSuper(this, PolarAngleAxis, arguments);
    }
    _inherits(PolarAngleAxis, _PureComponent);
    return _createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, _polarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
                var p2 = (0, _polarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * RADIAN);
                var textAnchor;
                if (cos > eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, _polarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _polygon.Polygon), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)('recharts-polar-angle-axis-tick', (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-polar-angle-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(PolarAngleAxis, "displayName", 'PolarAngleAxis');
_defineProperty(PolarAngleAxis, "axisType", 'angleAxis');
_defineProperty(PolarAngleAxis, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","clsx":"aGWRz","../container/Layer":"4SHHK","../shape/Dot":"4Xk21","../shape/Polygon":"brBgP","../component/Text":"31dv8","../util/types":"fLu4V","../util/ReactUtils":"bLejJ","../util/PolarUtils":"b4tu9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"uKsmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pie", function() {
    return Pie;
});
/**
 * @fileOverview Render sectors of a pie
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _curve = require("../shape/Curve");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _labelList = require("../component/LabelList");
var _cell = require("../component/Cell");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _logUtils = require("../util/LogUtils");
var _types = require("../util/types");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _Pie;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Pie = /*#__PURE__*/ function(_PureComponent) {
    function Pie(props) {
        var _this;
        _classCallCheck(this, Pie);
        _this = _callSuper(this, Pie, [
            props
        ]);
        _defineProperty(_this, "pieRef", null);
        _defineProperty(_this, "sectorRefs", []);
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-pie-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    _inherits(Pie, _PureComponent);
    return _createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, _reactUtils.filterProps)(this.props, false);
                var customLabelProps = (0, _reactUtils.filterProps)(label, false);
                var customLabelLineProps = (0, _reactUtils.filterProps)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ]
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) realDataKey = 'value';
                    else if ((0, _isNilDefault.default)(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps, 'line'), Pie.renderLabelItem(label, labelProps, (0, _chartUtils.getValueByDataKey)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = _objectSpread(_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, _getDefault.default)(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, _dataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, _dataUtils.interpolateNumber)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqualDefault.default)(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, _dataUtils.isNumber)(cx) || !(0, _dataUtils.isNumber)(cy) || !(0, _dataUtils.isNumber)(innerRadius) || !(0, _dataUtils.isNumber)(outerRadius)) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-pie', className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, _label.Label).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props, key) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                if ((0, _isFunctionDefault.default)(option)) return option(props);
                var className = (0, _clsxDefault.default)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, props, {
                    key: key,
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                var label = value;
                if ((0, _isFunctionDefault.default)(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label)) return label;
                }
                var className = (0, _clsxDefault.default)('recharts-pie-label-text', typeof option !== 'boolean' && !(0, _isFunctionDefault.default)(option) ? option.className : '');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
}((0, _react.PureComponent));
_Pie = Pie;
_defineProperty(Pie, "displayName", 'Pie');
_defineProperty(Pie, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
_defineProperty(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
_defineProperty(Pie, "getRealPieData", function(itemProps) {
    var data = itemProps.data, children = itemProps.children;
    var presentationProps = (0, _reactUtils.filterProps)(itemProps, false);
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    if (data && data.length) return data.map(function(entry, index) {
        return _objectSpread(_objectSpread(_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return _objectSpread(_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
_defineProperty(Pie, "parseCoordinateOfPie", function(itemProps, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, _polarUtils.getMaxRadius)(width, height);
    var cx = left + (0, _dataUtils.getPercentValue)(itemProps.cx, width, width / 2);
    var cy = top + (0, _dataUtils.getPercentValue)(itemProps.cy, height, height / 2);
    var innerRadius = (0, _dataUtils.getPercentValue)(itemProps.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
_defineProperty(Pie, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var pieData = _Pie.getRealPieData(itemProps);
    if (!pieData || !pieData.length) return null;
    var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
    var minAngle = Math.abs(itemProps.minAngle);
    var coordinate = _Pie.parseCoordinateOfPie(itemProps, offset);
    var deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) {
        (0, _logUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, _isNilDefault.default)(dataKey)) {
        (0, _logUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
        return result + ((0, _dataUtils.isNumber)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
            var name = (0, _chartUtils.getValueByDataKey)(entry, nameKey, i);
            var percent = ((0, _dataUtils.isNumber)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, _dataUtils.mathSign)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, _polarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = _objectSpread(_objectSpread(_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, _chartUtils.getValueByDataKey)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return _objectSpread(_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

},{"react":"gVheC","react-smooth":"ffKTh","lodash/get":"jeneQ","lodash/isEqual":"6bbKw","lodash/isNil":"beGyX","lodash/isFunction":"8ck2f","clsx":"aGWRz","../container/Layer":"4SHHK","../shape/Curve":"l4o9x","../component/Text":"31dv8","../component/Label":"fRyNr","../component/LabelList":"eDANL","../component/Cell":"7blff","../util/ReactUtils":"bLejJ","../util/Global":"h7WEa","../util/PolarUtils":"b4tu9","../util/DataUtils":"c1vtt","../util/ChartUtils":"5VwLU","../util/LogUtils":"6J16n","../util/types":"fLu4V","../util/ActiveShapeUtils":"caqGA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"caqGA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsFromShapeOption", function() {
    return getPropsFromShapeOption;
});
parcelHelpers.export(exports, "Shape", function() {
    return Shape;
});
/**
 * This is an abstraction to handle identifying the active index from a tooltip mouse interaction
 */ parcelHelpers.export(exports, "isFunnel", function() {
    return isFunnel;
});
parcelHelpers.export(exports, "isPie", function() {
    return isPie;
});
parcelHelpers.export(exports, "isScatter", function() {
    return isScatter;
});
parcelHelpers.export(exports, "compareFunnel", function() {
    return compareFunnel;
});
parcelHelpers.export(exports, "comparePie", function() {
    return comparePie;
});
parcelHelpers.export(exports, "compareScatter", function() {
    return compareScatter;
});
/**
 *
 * @param {GetActiveShapeIndexForTooltip} arg an object of incoming attributes from Tooltip
 * @returns {number}
 *
 * To handle possible duplicates in the data set,
 * match both the data value of the active item to a data value on a graph item,
 * and match the mouse coordinates of the active item to the coordinates of in a particular components shape data.
 * This assumes equal lengths of shape objects to data items.
 */ parcelHelpers.export(exports, "getActiveShapeIndexForTooltip", function() {
    return getActiveShapeIndexForTooltip;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isBoolean = require("lodash/isBoolean");
var _isBooleanDefault = parcelHelpers.interopDefault(_isBoolean);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _rectangle = require("../shape/Rectangle");
var _trapezoid = require("../shape/Trapezoid");
var _sector = require("../shape/Sector");
var _layer = require("../container/Layer");
var _symbols = require("../shape/Symbols");
var _excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function defaultPropTransformer(option, props) {
    return _objectSpread(_objectSpread({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapezoid.Trapezoid), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sector.Sector), elementProps);
        case 'symbols':
            if (isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), elementProps);
            break;
        default:
            return null;
    }
}
function getPropsFromShapeOption(option) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option.props;
    return option;
}
function Shape(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties(_ref2, _excluded);
    var shape;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) shape = /*#__PURE__*/ (0, _react.cloneElement)(option, _objectSpread(_objectSpread({}, props), getPropsFromShapeOption(option)));
    else if ((0, _isFunctionDefault.default)(option)) shape = option(props);
    else if ((0, _isPlainObjectDefault.default)(option) && !(0, _isBooleanDefault.default)(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}
function isFunnel(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if (isFunnel(graphicalItem, activeItem)) comparison = compareFunnel;
    else if (isPie(graphicalItem, activeItem)) comparison = comparePie;
    else if (isScatter(graphicalItem, activeItem)) comparison = compareScatter;
    return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if (isFunnel(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if (isPie(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if (isScatter(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if (isFunnel(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if (isPie(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if (isScatter(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, _isEqualDefault.default)(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}

},{"react":"gVheC","lodash/isFunction":"8ck2f","lodash/isPlainObject":"2RXyg","lodash/isBoolean":"io38r","lodash/isEqual":"6bbKw","../shape/Rectangle":"2vZys","../shape/Trapezoid":"8g6Q9","../shape/Sector":"lEd0X","../container/Layer":"4SHHK","../shape/Symbols":"ewu2Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"io38r":[function(require,module,exports,__globalThis) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"iuqvy","37c1c7912587466b":"lm2eo"}],"8g6Q9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trapezoid", function() {
    return Trapezoid;
});
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Trapezoid = function Trapezoid(props) {
    var trapezoidProps = _objectSpread(_objectSpread({}, defaultProps), props);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
        className: layerClass,
        d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
            className: layerClass,
            d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};

},{"react":"gVheC","clsx":"aGWRz","react-smooth":"ffKTh","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kGIgf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Brush", function() {
    return Brush;
});
/**
 * @fileOverview Brush
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _d3Scale = require("victory-vendor/d3-scale");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _chartUtils = require("../util/ChartUtils");
var _dataUtils = require("../util/DataUtils");
var _cssPrefixUtils = require("../util/CssPrefixUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, _d3Scale.scalePoint)().domain((0, _rangeDefault.default)(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        _classCallCheck(this, Brush);
        _this = _callSuper(this, Brush, [
            props
        ]);
        _defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        _defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        _defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        _defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        _defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        _defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        _defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    _inherits(Brush, _PureComponent);
    return _createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, _chartUtils.getValueByDataKey)(data[index], dataKey, index);
                return (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState(_defineProperty(_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState(_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, _react.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-brush', className);
                var isPanoramic = (0, _reactDefault.default).Children.count(children) === 1;
                var style = (0, _cssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rectangle = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return _objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Brush, "displayName", 'Brush');
_defineProperty(Brush, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

},{"react":"gVheC","clsx":"aGWRz","victory-vendor/d3-scale":"kc5nZ","lodash/isFunction":"8ck2f","lodash/range":"3wXYB","../container/Layer":"4SHHK","../component/Text":"31dv8","../util/ChartUtils":"5VwLU","../util/DataUtils":"c1vtt","../util/CssPrefixUtils":"kvYRY","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kvYRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePrefixStyle", function() {
    return generatePrefixStyle;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = PREFIX_LIST.reduce(function(res, entry) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lcQGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndPoints", function() {
    return getEndPoints;
});
parcelHelpers.export(exports, "ReferenceLine", function() {
    return ReferenceLine;
});
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartLayoutContext = require("../context/chartLayoutContext");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) line = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) line = option(props);
    else line = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (0, _someDefault.default)(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, _chartLayoutContext.useClipPathId)();
    var xAxis = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    var yAxis = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    if (!clipPathId || !viewBox) return null;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, _dataUtils.isNumOrStr)(fixedX);
    var isY = (0, _dataUtils.isNumOrStr)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = _slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)('recharts-reference-line', className)
    }, renderLine(shape, lineProps), (0, _label.Label).renderCallByParent(props, (0, _cartesianUtils.rectWithCoords)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var ReferenceLine = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        _classCallCheck(this, ReferenceLine);
        return _callSuper(this, ReferenceLine, arguments);
    }
    _inherits(ReferenceLine, _React$Component);
    return _createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceLine, "displayName", 'ReferenceLine');
_defineProperty(ReferenceLine, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","lodash/some":"6aioB","clsx":"aGWRz","../container/Layer":"4SHHK","../component/Label":"fRyNr","../util/IfOverflowMatches":"kNnc1","../util/DataUtils":"c1vtt","../util/CartesianUtils":"fREAQ","../util/LogUtils":"6J16n","../util/ReactUtils":"bLejJ","../context/chartLayoutContext":"aO2w6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNnc1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ifOverflowMatches", function() {
    return ifOverflowMatches;
});
var ifOverflowMatches = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fREAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatAxisMap", function() {
    return formatAxisMap;
});
parcelHelpers.export(exports, "rectWithPoints", function() {
    return rectWithPoints;
});
parcelHelpers.export(exports, "rectWithCoords", function() {
    return rectWithCoords;
});
parcelHelpers.export(exports, "ScaleHelper", function() {
    return ScaleHelper;
});
parcelHelpers.export(exports, "createLabeledScales", function() {
    return createLabeledScales;
});
/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */ parcelHelpers.export(exports, "normalizeAngle", function() {
    return normalizeAngle;
});
parcelHelpers.export(exports, "getAngledRectangleWidth", function() {
    return getAngledRectangleWidth;
});
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
var _bar = require("../cartesian/Bar");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, _reactUtils.findChildByType)(children, (0, _bar.Bar));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, _dataUtils.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, _chartUtils.getBandSizeOfAxis)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var rectWithCoords = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return rectWithPoints({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var ScaleHelper = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        _classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return _createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
_defineProperty(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, ScaleHelper.create(options[key])));
    }, {});
    return _objectSpread(_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, _mapValuesDefault.default)(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, _everyDefault.default)(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function normalizeAngle(angle) {
    return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = normalizeAngle(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

},{"lodash/mapValues":"cNXIl","lodash/every":"1lro4","./ChartUtils":"5VwLU","./ReactUtils":"bLejJ","./DataUtils":"c1vtt","../cartesian/Bar":"ayugp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cNXIl":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("a3dd03284854d1b5"), baseForOwn = require("3fe946fb5f45d4e9"), baseIteratee = require("8671a2b480ab95e2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"a3dd03284854d1b5":"8nNdL","3fe946fb5f45d4e9":"aVySe","8671a2b480ab95e2":"exkHY"}],"1lro4":[function(require,module,exports,__globalThis) {
var arrayEvery = require("35998aa94ab060f1"), baseEvery = require("44e7ab95f8b26a55"), baseIteratee = require("1d5621a35ca53be0"), isArray = require("e0e4c2e424adb44f"), isIterateeCall = require("2f9b3b0ab0300132");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = every;

},{"35998aa94ab060f1":"9WAnJ","44e7ab95f8b26a55":"j3bHd","1d5621a35ca53be0":"exkHY","e0e4c2e424adb44f":"jQGs4","2f9b3b0ab0300132":"936XO"}],"9WAnJ":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = arrayEvery;

},{}],"j3bHd":[function(require,module,exports,__globalThis) {
var baseEach = require("88b2ceed9e7ead7a");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = baseEvery;

},{"88b2ceed9e7ead7a":"eUqSn"}],"ayugp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", function() {
    return Bar;
});
/**
 * @fileOverview Render a group of bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _layer = require("../container/Layer");
var _errorBar = require("./ErrorBar");
var _cell = require("../component/Cell");
var _labelList = require("../component/LabelList");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _barUtils = require("../util/BarUtils");
var _excluded = [
    "value",
    "background"
];
var _Bar;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Bar = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        _classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Bar, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-bar-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    _inherits(Bar, _PureComponent);
    return _createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, _reactUtils.filterProps)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = _objectSpread(_objectSpread(_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-bar-rectangle"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            var interpolatorWidth = (0, _dataUtils.interpolateNumber)(prev.width, entry.width);
                            var interpolatorHeight = (0, _dataUtils.interpolateNumber)(prev.height, entry.height);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, _dataUtils.interpolateNumber)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, _dataUtils.interpolateNumber)(0, entry.width);
                        var w = interpolator(t);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqualDefault.default)(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, _reactUtils.filterProps)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = _objectWithoutProperties(entry, _excluded);
                    if (!background) return null;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, _types.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), _extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Bar = Bar;
_defineProperty(Bar, "displayName", 'Bar');
_defineProperty(Bar, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ _defineProperty(Bar, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, _chartUtils.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, _chartUtils.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, _chartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, _barUtils.minPointSizeCallback)(minPointSizeProp, _Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, _dataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, _dataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return _objectSpread(_objectSpread(_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, _chartUtils.getTooltipItem)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return _objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

},{"react":"gVheC","clsx":"aGWRz","react-smooth":"ffKTh","lodash/isEqual":"6bbKw","lodash/isNil":"beGyX","../container/Layer":"4SHHK","./ErrorBar":"gEFRh","../component/Cell":"7blff","../component/LabelList":"eDANL","../util/DataUtils":"c1vtt","../util/ReactUtils":"bLejJ","../util/Global":"h7WEa","../util/ChartUtils":"5VwLU","../util/types":"fLu4V","../util/BarUtils":"fcki9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fcki9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarRectangle", function() {
    return BarRectangle;
});
parcelHelpers.export(exports, "minPointSizeCallback", function() {
    return minPointSizeCallback;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _activeShapeUtils = require("./ActiveShapeUtils");
var _excluded = [
    "x",
    "y"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties(_ref, _excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function BarRectangle(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "rectangle",
        propTransformer: typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var minPointSizeCallback = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, _tinyInvariantDefault.default)(false);
        return defaultValue;
    };
};

},{"react":"gVheC","tiny-invariant":"01Hp1","./ActiveShapeUtils":"caqGA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aO2w6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxisContext", function() {
    return XAxisContext;
});
parcelHelpers.export(exports, "YAxisContext", function() {
    return YAxisContext;
});
parcelHelpers.export(exports, "ViewBoxContext", function() {
    return ViewBoxContext;
});
parcelHelpers.export(exports, "OffsetContext", function() {
    return OffsetContext;
});
parcelHelpers.export(exports, "ClipPathIdContext", function() {
    return ClipPathIdContext;
});
parcelHelpers.export(exports, "ChartHeightContext", function() {
    return ChartHeightContext;
});
parcelHelpers.export(exports, "ChartWidthContext", function() {
    return ChartWidthContext;
});
parcelHelpers.export(exports, "ChartLayoutContextProvider", function() {
    return ChartLayoutContextProvider;
});
parcelHelpers.export(exports, "useClipPathId", function() {
    return useClipPathId;
});
parcelHelpers.export(exports, "useXAxisOrThrow", function() {
    return useXAxisOrThrow;
});
parcelHelpers.export(exports, "useArbitraryXAxis", function() {
    return useArbitraryXAxis;
});
parcelHelpers.export(exports, "useArbitraryYAxis", function() {
    return useArbitraryYAxis;
});
parcelHelpers.export(exports, "useYAxisWithFiniteDomainOrRandom", function() {
    return useYAxisWithFiniteDomainOrRandom;
});
parcelHelpers.export(exports, "useYAxisOrThrow", function() {
    return useYAxisOrThrow;
});
parcelHelpers.export(exports, "useViewBox", function() {
    return useViewBox;
});
parcelHelpers.export(exports, "useOffset", function() {
    return useOffset;
});
parcelHelpers.export(exports, "useChartWidth", function() {
    return useChartWidth;
});
parcelHelpers.export(exports, "useChartHeight", function() {
    return useChartHeight;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _calculateViewBox = require("../util/calculateViewBox");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var XAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var YAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ViewBoxContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var OffsetContext = /*#__PURE__*/ (0, _react.createContext)({});
var ClipPathIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ChartHeightContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartWidthContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartLayoutContextProvider = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, _calculateViewBox.calculateViewBox)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, _reactDefault.default).createElement(XAxisContext.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(YAxisContext.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(OffsetContext.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ViewBoxContext.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartHeightContext.Provider, {
        value: height
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartWidthContext.Provider, {
        value: width
    }, children)))))));
};
var useClipPathId = function useClipPathId() {
    return (0, _react.useContext)(ClipPathIdContext);
};
function getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var useXAxisOrThrow = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    !(xAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return xAxis;
};
var useArbitraryXAxis = function useArbitraryXAxis() {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(xAxisMap);
};
var useArbitraryYAxis = function useArbitraryYAxis() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    var yAxisWithFiniteDomain = (0, _findDefault.default)(yAxisMap, function(axis) {
        return (0, _everyDefault.default)(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisOrThrow = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    !(yAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return yAxis;
};
var useViewBox = function useViewBox() {
    var viewBox = (0, _react.useContext)(ViewBoxContext);
    return viewBox;
};
var useOffset = function useOffset() {
    return (0, _react.useContext)(OffsetContext);
};
var useChartWidth = function useChartWidth() {
    return (0, _react.useContext)(ChartWidthContext);
};
var useChartHeight = function useChartHeight() {
    return (0, _react.useContext)(ChartHeightContext);
};

},{"react":"gVheC","tiny-invariant":"01Hp1","lodash/find":"50FsZ","lodash/every":"1lro4","../util/calculateViewBox":"7LWfL","../util/DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7LWfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateViewBox", function() {
    return calculateViewBox;
});
var _memoize = require("lodash/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var calculateViewBox = (0, _memoizeDefault.default)(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});

},{"lodash/memoize":"ajNZD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8s4HM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceDot", function() {
    return ReferenceDot;
});
/**
 * @fileOverview Reference Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var ReferenceDot = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        _classCallCheck(this, ReferenceDot);
        return _callSuper(this, ReferenceDot, arguments);
    }
    _inherits(ReferenceDot, _React$Component);
    return _createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, _dataUtils.isNumOrStr)(x);
                var isY = (0, _dataUtils.isNumOrStr)(y);
                (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = _objectSpread(_objectSpread({
                    clipPath: clipPath
                }, (0, _reactUtils.filterProps)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, _label.Label).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceDot, "displayName", 'ReferenceDot');
_defineProperty(ReferenceDot, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
_defineProperty(ReferenceDot, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dot = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","clsx":"aGWRz","../container/Layer":"4SHHK","../shape/Dot":"4Xk21","../component/Label":"fRyNr","../util/DataUtils":"c1vtt","../util/IfOverflowMatches":"kNnc1","../util/CartesianUtils":"fREAQ","../util/LogUtils":"6J16n","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0beG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceArea", function() {
    return ReferenceArea;
});
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _cartesianUtils = require("../util/CartesianUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, _cartesianUtils.rectWithPoints)(p1, p2);
};
var ReferenceArea = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        _classCallCheck(this, ReferenceArea);
        return _callSuper(this, ReferenceArea, arguments);
    }
    _inherits(ReferenceArea, _React$Component);
    return _createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, _dataUtils.isNumOrStr)(x1);
                var hasX2 = (0, _dataUtils.isNumOrStr)(x2);
                var hasY1 = (0, _dataUtils.isNumOrStr)(y1);
                var hasY2 = (0, _dataUtils.isNumOrStr)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, _objectSpread(_objectSpread({
                    clipPath: clipPath
                }, (0, _reactUtils.filterProps)(this.props, true)), rect)), (0, _label.Label).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceArea, "displayName", 'ReferenceArea');
_defineProperty(ReferenceArea, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
_defineProperty(ReferenceArea, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rect = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","clsx":"aGWRz","../container/Layer":"4SHHK","../component/Label":"fRyNr","../util/CartesianUtils":"fREAQ","../util/IfOverflowMatches":"kNnc1","../util/DataUtils":"c1vtt","../util/LogUtils":"6J16n","../shape/Rectangle":"2vZys","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bFqCJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianAxis", function() {
    return CartesianAxis;
});
/**
 * @fileOverview Cartesian Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _shallowEqual = require("../util/ShallowEqual");
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _getTicks = require("./getTicks");
var _excluded = [
    "viewBox"
], _excluded2 = [
    "viewBox"
], _excluded3 = [
    "ticks"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CartesianAxis = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        _classCallCheck(this, CartesianAxis);
        _this = _callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    _inherits(CartesianAxis, _Component);
    return _createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = _objectWithoutProperties(_ref, _excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties(_this$props, _excluded2);
                return !(0, _shallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _shallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _shallowEqual.shallowEqual)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, _dataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis-line', (0, _getDefault.default)(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, _getTicks.getTicks)(_objectSpread(_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, tickLineProps, lineCoord, {
                        className: (0, _clsxDefault.default)('recharts-cartesian-axis-tick-line', (0, _getDefault.default)(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = _objectWithoutProperties(_this$props8, _excluded3);
                var finalTicks = ticks;
                if ((0, _isFunctionDefault.default)(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, _label.Label).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.Component));
_defineProperty(CartesianAxis, "displayName", 'CartesianAxis');
_defineProperty(CartesianAxis, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});

},{"react":"gVheC","lodash/isFunction":"8ck2f","lodash/get":"jeneQ","clsx":"aGWRz","../util/ShallowEqual":"gpRqq","../container/Layer":"4SHHK","../component/Text":"31dv8","../component/Label":"fRyNr","../util/DataUtils":"c1vtt","../util/types":"fLu4V","../util/ReactUtils":"bLejJ","./getTicks":"jUY4S","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jUY4S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTicks", function() {
    return getTicks;
});
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _tickUtils = require("../util/TickUtils");
var _getEquidistantTicks = require("./getEquidistantTicks");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread(_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, _tickUtils.isVisible)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = _objectSpread(_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function getTicks(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, _dataUtils.isNumber)(interval) || (0, _global.Global).isSsr) return (0, _tickUtils.getNumberIntervalTicks)(ticks, typeof interval === 'number' && (0, _dataUtils.isNumber)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, _domutils.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, _tickUtils.getAngledTickWidth)((0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, _dataUtils.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, _tickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}

},{"lodash/isFunction":"8ck2f","../util/DataUtils":"c1vtt","../util/DOMUtils":"427P0","../util/Global":"h7WEa","../util/TickUtils":"7XhjS","./getEquidistantTicks":"aDC08","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7XhjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAngledTickWidth", function() {
    return getAngledTickWidth;
});
parcelHelpers.export(exports, "getTickBoundaries", function() {
    return getTickBoundaries;
});
parcelHelpers.export(exports, "isVisible", function() {
    return isVisible;
});
parcelHelpers.export(exports, "getNumberIntervalTicks", function() {
    return getNumberIntervalTicks;
});
var _cartesianUtils = require("./CartesianUtils");
var _getEveryNthWithCondition = require("./getEveryNthWithCondition");
function getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, _cartesianUtils.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function isVisible(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
    return (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, interval + 1);
}

},{"./CartesianUtils":"fREAQ","./getEveryNthWithCondition":"fXW3X","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fXW3X":[function(require,module,exports,__globalThis) {
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEveryNthWithCondition", function() {
    return getEveryNthWithCondition;
});
function getEveryNthWithCondition(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aDC08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEquidistantTicks", function() {
    return getEquidistantTicks;
});
var _tickUtils = require("../util/TickUtils");
var _getEveryNthWithCondition = require("../util/getEveryNthWithCondition");
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}

},{"../util/TickUtils":"7XhjS","../util/getEveryNthWithCondition":"fXW3X","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f7ava":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianGrid", function() {
    return CartesianGrid;
});
/**
 * @fileOverview Cartesian Grid
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _logUtils = require("../util/LogUtils");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
var _getTicks = require("./getTicks");
var _cartesianAxis = require("./CartesianAxis");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], _excluded2 = [
    "offset"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = _objectWithoutProperties(props, _excluded);
        var _filterProps = (0, _reactUtils.filterProps)(others, false), __ = _filterProps.offset, restOfFilteredProps = _objectWithoutProperties(_filterProps, _excluded2);
        lineItem = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), xAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), yAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function CartesianGrid(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, _chartLayoutContext.useChartWidth)();
    var chartHeight = (0, _chartLayoutContext.useChartHeight)();
    var offset = (0, _chartLayoutContext.useOffset)();
    var propsIncludingDefaults = _objectSpread(_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps.verticalFill,
        x: (0, _dataUtils.isNumber)(props.x) ? props.x : offset.left,
        y: (0, _dataUtils.isNumber)(props.y) ? props.y : offset.top,
        width: (0, _dataUtils.isNumber)(props.width) ? props.width : offset.width,
        height: (0, _dataUtils.isNumber)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, _chartLayoutContext.useArbitraryXAxis)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, _chartLayoutContext.useYAxisWithFiniteDomainOrRandom)();
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0 || !(0, _dataUtils.isNumber)(x) || x !== +x || !(0, _dataUtils.isNumber)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunctionDefault.default)(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? _objectSpread(_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, _isFunctionDefault.default)(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? _objectSpread(_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalStripes, _extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalStripes, _extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
CartesianGrid.displayName = 'CartesianGrid';

},{"react":"gVheC","lodash/isFunction":"8ck2f","../util/LogUtils":"6J16n","../util/DataUtils":"c1vtt","../util/ReactUtils":"bLejJ","../util/ChartUtils":"5VwLU","./getTicks":"jUY4S","./CartesianAxis":"bFqCJ","../context/chartLayoutContext":"aO2w6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"WLMlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Area", function() {
    return Area;
});
/**
 * @fileOverview Area
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _curve = require("../shape/Curve");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _global = require("../util/Global");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], _excluded2 = [
    "key"
];
var _Area;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Area = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        _classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Area, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-area-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _inherits(Area, _PureComponent);
    return _createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, _reactUtils.filterProps)(this.props, false);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, _dataUtils.isNumber)(maxY)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, _dataUtils.isNumber)(maxX)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = _objectWithoutProperties(_this$props4, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, _isNilDefault.default)(baseLine) || (0, _isNaNDefault.default)(baseLine)) {
                            var _interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqualDefault.default)(prevPoints, points) || !(0, _isEqualDefault.default)(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, _clsxDefault.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, _reactUtils.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, _reactUtils.hasClipDot)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Area = Area;
_defineProperty(Area, "displayName", 'Area');
_defineProperty(Area, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
_defineProperty(Area, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, _dataUtils.isNumber)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
_defineProperty(Area, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = _Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, _chartUtils.getValueByDataKey)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return _objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
_defineProperty(Area, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
    else {
        var className = (0, _clsxDefault.default)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        var key = props.key, rest = _objectWithoutProperties(props, _excluded2);
        dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});

},{"react":"gVheC","clsx":"aGWRz","react-smooth":"ffKTh","lodash/isFunction":"8ck2f","lodash/max":"1ecOu","lodash/isNil":"beGyX","lodash/isNaN":"4ILIm","lodash/isEqual":"6bbKw","../shape/Curve":"l4o9x","../shape/Dot":"4Xk21","../container/Layer":"4SHHK","../component/LabelList":"eDANL","../util/Global":"h7WEa","../util/DataUtils":"c1vtt","../util/ChartUtils":"5VwLU","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxKXf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxis", function() {
    return XAxis;
});
/**
 * @fileOverview X Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/** Define of XAxis props */ function XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, _reactDefault.default).createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
}
var XAxis = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        _classCallCheck(this, XAxis);
        return _callSuper(this, XAxis, arguments);
    }
    _inherits(XAxis, _React$Component);
    return _createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(XAxisImpl, this.props);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(XAxis, "displayName", 'XAxis');
_defineProperty(XAxis, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});

},{"react":"gVheC","clsx":"aGWRz","../context/chartLayoutContext":"aO2w6","./CartesianAxis":"bFqCJ","../util/ChartUtils":"5VwLU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dWDOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YAxis", function() {
    return YAxis;
});
/**
 * @fileOverview Y Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, _reactDefault.default).createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
};
var YAxis = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        _classCallCheck(this, YAxis);
        return _callSuper(this, YAxis, arguments);
    }
    _inherits(YAxis, _React$Component);
    return _createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(YAxisImpl, this.props);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(YAxis, "displayName", 'YAxis');
_defineProperty(YAxis, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});

},{"react":"gVheC","clsx":"aGWRz","../context/chartLayoutContext":"aO2w6","./CartesianAxis":"bFqCJ","../util/ChartUtils":"5VwLU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kZkME":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Pie Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieChart", function() {
    return PieChart;
});
var _generateCategoricalChart = require("./generateCategoricalChart");
var _polarAngleAxis = require("../polar/PolarAngleAxis");
var _polarRadiusAxis = require("../polar/PolarRadiusAxis");
var _polarUtils = require("../util/PolarUtils");
var _pie = require("../polar/Pie");
var PieChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'PieChart',
    GraphicalChild: (0, _pie.Pie),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, _polarAngleAxis.PolarAngleAxis)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, _polarRadiusAxis.PolarRadiusAxis)
        }
    ],
    formatAxisMap: (0, _polarUtils.formatAxisMap),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});

},{"./generateCategoricalChart":"aTpZ9","../polar/PolarAngleAxis":"lso03","../polar/PolarRadiusAxis":"7j4lw","../util/PolarUtils":"b4tu9","../polar/Pie":"uKsmb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aTpZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAxisMapByAxes", function() {
    return getAxisMapByAxes;
});
parcelHelpers.export(exports, "createDefaultState", function() {
    return createDefaultState;
});
parcelHelpers.export(exports, "generateCategoricalChart", function() {
    return generateCategoricalChart;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
// eslint-disable-next-line no-restricted-imports
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _tooltip = require("../component/Tooltip");
var _legend = require("../component/Legend");
var _dot = require("../shape/Dot");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
var _brush = require("../cartesian/Brush");
var _domutils = require("../util/DOMUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _detectReferenceElementsDomain = require("../util/DetectReferenceElementsDomain");
var _polarUtils = require("../util/PolarUtils");
var _shallowEqual = require("../util/ShallowEqual");
var _events = require("../util/Events");
var _types = require("../util/types");
var _accessibilityManager = require("./AccessibilityManager");
var _isDomainSpecifiedByUser = require("../util/isDomainSpecifiedByUser");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _cursor = require("../component/Cursor");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "item"
], _excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function renderAsIs(element) {
    return element;
}
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, _dataUtils.isNumber)(dataStartIndex) && (0, _dataUtils.isNumber)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, _dataUtils.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat(_toConsumableArray(result), [
            (0, _chartUtils.getTooltipItem)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, _chartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, _isDomainSpecifiedByUser.isDomainSpecifiedByUser)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, _chartUtils.parseSpecifiedDomain)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, _dataUtils.hasDuplicate)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, _rangeDefault.default)(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNilDefault.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, _isNilDefault.default)(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, _chartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, _chartUtils.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            } else {
                domain = (0, _chartUtils.parseSpecifiedDomain)(originalDomain, (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            }
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, _getDefault.default)(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, _reactUtils.findAllByType)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, _dataUtils.getAnyElementOfObject)(axisMap);
    var tooltipTicks = (0, _chartUtils.getTicksOfAxis)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, _sortByDefault.default)(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, _chartUtils.getBandSizeOfAxis)(axis, tooltipTicks)
    };
};
var createDefaultState = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, _reactUtils.getDisplayName)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, (0, _getDefault.default)(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = _objectSpread(_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, _brush.Brush).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, _chartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return _objectSpread(_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var generateCategoricalChart = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, _tinyInvariantDefault.default)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return _objectSpread(_objectSpread({}, result), {}, _defineProperty(_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, _chartUtils.getTicksOfAxis)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _chartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, _chartUtils.getBarSizeList)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, _isNilDefault.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, _chartUtils.getBarPosition)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return _objectSpread(_objectSpread({}, pos), {}, {
                        position: _objectSpread(_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, _defineProperty(_defineProperty(_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, _reactUtils.parseChildIndex)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, _reactUtils.validateWidthHeight)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, _reactUtils.findAllByType)(children, GraphicalChild);
        var stackGroups = (0, _chartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return _objectSpread(_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            _classCallCheck(this, CategoricalChartWrapper);
            _this = _callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            _defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            _defineProperty(_this, "accessibilityManager", new (0, _accessibilityManager.AccessibilityManager)());
            _defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState(_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, _objectSpread(_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            _defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            _defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return _objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ _defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, _isFunctionDefault.default)(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            _defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, _isFunctionDefault.default)(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ _defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ _defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ _defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ _defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, _isFunctionDefault.default)(onMouseLeave)) onMouseLeave(nextState, e);
            });
            _defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, _reactUtils.getReactEventByType)(e);
                var event = (0, _getDefault.default)(_this.props, "".concat(eventName));
                if (eventName && (0, _isFunctionDefault.default)(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            _defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, _isFunctionDefault.default)(onClick)) onClick(_nextState2, e);
                }
            });
            _defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, _isFunctionDefault.default)(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            _defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, _isFunctionDefault.default)(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            _defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            _defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            _defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            _defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, _events.eventCenter).emit((0, _events.SYNC_EVENT), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            _defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState(_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : originCoordinate;
                    _this.setState(_objectSpread(_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            _defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cursor.Cursor), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            _defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, _getDefault.default)(element, 'type.axisType');
                var axisMap = (0, _getDefault.default)(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? _objectSpread(_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, axisOption), {}, {
                    className: (0, _clsxDefault.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, _chartUtils.getTicksOfAxis)(axisOption, true)
                }));
            });
            _defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, _dataUtils.getAnyElementOfObject)(radiusAxisMap);
                var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, _chartUtils.getTicksOfAxis)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, _chartUtils.getTicksOfAxis)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ _defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, _chartUtils.getLegendProps)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
                return /*#__PURE__*/ (0, _react.cloneElement)(item, _objectSpread(_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ _defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, _react.cloneElement)(tooltipItem, {
                    viewBox: _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            _defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, _chartUtils.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, _dataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
                    y: (0, _dataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, _dataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            _defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            _defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = _objectSpread(_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, _chartUtils.getMainColorOfGraphicItem)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, _reactUtils.filterProps)(activeDot, false)), (0, _types.adaptEventHandlers)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            _defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, _dataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, _dataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, _isNilDefault.default)(activePoint)) return [
                            graphicalItem
                        ].concat(_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, _react.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            _defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: renderAsIs
                },
                YAxis: {
                    handler: renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, _dataUtils.uniqueId)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, _throttleDefault.default)(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        _inherits(CategoricalChartWrapper, _Component);
        return _createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = _objectSpread(_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, _reactUtils.isChildrenEqual)([
                        (0, _reactUtils.findChildByType)(prevProps.children, (0, _tooltip.Tooltip))
                    ], [
                        (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, _domutils.getOffset)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, _dataUtils.getAnyElementOfObject)(xAxisMap).scale;
                        var yScale = (0, _dataUtils.getAnyElementOfObject)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return _objectSpread(_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return _objectSpread(_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                        return (0, _polarUtils.inRangeOfSector)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, _types.adaptEventHandlers)(this.props, this.handleOuterEvent);
                    return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, _events.eventCenter).on((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, _events.eventCenter).removeListener((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, _reactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = _slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = _slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, _reactUtils.getDisplayName)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _rectangle.isInRectangle)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _polarUtils.inRangeOfSector)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, _activeShapeUtils.isFunnel)(graphicalItem, activeItem) || (0, _activeShapeUtils.isPie)(graphicalItem, activeItem) || (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem)) {
                            var activeIndex = (0, _activeShapeUtils.getActiveShapeIndexForTooltip)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2);
                    var attrs = (0, _reactUtils.filterProps)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
                        className: (0, _clsxDefault.default)('recharts-wrapper', className),
                        style: _objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, _react.Component));
    _defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    _defineProperty(CategoricalChartWrapper, "defaultProps", _objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    _defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = createDefaultState(nextProps);
            return _objectSpread(_objectSpread(_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, _shallowEqual.shallowEqual)(margin, prevState.prevMargin)) {
            var _defaultState = createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, _reactUtils.isChildrenEqual)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, _isNilDefault.default)(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return _objectSpread(_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    _defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, _react.isValidElement)(option)) dot = /*#__PURE__*/ (0, _react.cloneElement)(option, props);
        else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), props);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, _react.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CategoricalChartWrapper, _extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};

},{"react":"gVheC","lodash/isNil":"beGyX","lodash/isFunction":"8ck2f","lodash/range":"3wXYB","lodash/get":"jeneQ","lodash/sortBy":"4jc9z","lodash/throttle":"6S8E3","clsx":"aGWRz","tiny-invariant":"01Hp1","../container/Surface":"bKX4y","../container/Layer":"4SHHK","../component/Tooltip":"1ICZQ","../component/Legend":"m2stU","../shape/Dot":"4Xk21","../shape/Rectangle":"2vZys","../util/ReactUtils":"bLejJ","../cartesian/Brush":"kGIgf","../util/DOMUtils":"427P0","../util/DataUtils":"c1vtt","../util/ChartUtils":"5VwLU","../util/DetectReferenceElementsDomain":"anMIa","../util/PolarUtils":"b4tu9","../util/ShallowEqual":"gpRqq","../util/Events":"fxFqi","../util/types":"fLu4V","./AccessibilityManager":"exsIV","../util/isDomainSpecifiedByUser":"bubGf","../util/ActiveShapeUtils":"caqGA","../component/Cursor":"gy0EU","../context/chartLayoutContext":"aO2w6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"anMIa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectReferenceElementsDomain", function() {
    return detectReferenceElementsDomain;
});
var _referenceDot = require("../cartesian/ReferenceDot");
var _referenceLine = require("../cartesian/ReferenceLine");
var _referenceArea = require("../cartesian/ReferenceArea");
var _ifOverflowMatches = require("./IfOverflowMatches");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, _reactUtils.findAllByType)(children, (0, _referenceLine.ReferenceLine));
    var dots = (0, _reactUtils.findAllByType)(children, (0, _referenceDot.ReferenceDot));
    var elements = [].concat(_toConsumableArray(lines), _toConsumableArray(dots));
    var areas = (0, _reactUtils.findAllByType)(children, (0, _referenceArea.ReferenceArea));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[key1]) && (0, _dataUtils.isNumber)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, _dataUtils.isNumber)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};

},{"../cartesian/ReferenceDot":"8s4HM","../cartesian/ReferenceLine":"lcQGt","../cartesian/ReferenceArea":"l0beG","./IfOverflowMatches":"kNnc1","./ReactUtils":"bLejJ","./DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxFqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCenter", function() {
    return eventCenter;
});
parcelHelpers.export(exports, "SYNC_EVENT", function() {
    return SYNC_EVENT;
});
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var eventCenter = new (0, _eventemitter3Default.default)();
var SYNC_EVENT = 'recharts.syncMouseEvents';

},{"eventemitter3":"kmgfd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kmgfd":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"exsIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityManager", function() {
    return AccessibilityManager;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var AccessibilityManager = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        _classCallCheck(this, AccessibilityManager);
        _defineProperty(this, "activeIndex", 0);
        _defineProperty(this, "coordinateList", []);
        _defineProperty(this, "layout", 'horizontal');
    }
    return _createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bubGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ parcelHelpers.export(exports, "isDomainSpecifiedByUser", function() {
    return isDomainSpecifiedByUser;
});
var _dataUtils = require("./DataUtils");
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, _dataUtils.isNumber)(domainStart) && (0, _dataUtils.isNumber)(domainEnd)) return true;
    }
    return false;
}

},{"./DataUtils":"c1vtt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gy0EU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Cursor is the background, or a highlight,
 * that shows when user mouses over or activates
 * an area.
 *
 * It usually shows together with a tooltip
 * to emphasise which part of the chart does the tooltip refer to.
 */ parcelHelpers.export(exports, "Cursor", function() {
    return Cursor;
});
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _curve = require("../shape/Curve");
var _cross = require("../shape/Cross");
var _getCursorRectangle = require("../util/cursor/getCursorRectangle");
var _rectangle = require("../shape/Rectangle");
var _getRadialCursorPoints = require("../util/cursor/getRadialCursorPoints");
var _sector = require("../shape/Sector");
var _getCursorPoints = require("../util/cursor/getCursorPoints");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Cursor(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, _curve.Curve);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, _cross.Cross);
    } else if (chartName === 'BarChart') {
        restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, _rectangle.Rectangle);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, _sector.Sector);
    } else {
        restProps = {
            points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, _curve.Curve);
    }
    var cursorProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, _reactUtils.filterProps)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, _clsxDefault.default)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, _react.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, _react.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, _react.createElement)(cursorComp, cursorProps);
}

},{"react":"gVheC","clsx":"aGWRz","../shape/Curve":"l4o9x","../shape/Cross":"gZzoK","../util/cursor/getCursorRectangle":"3u8WB","../shape/Rectangle":"2vZys","../util/cursor/getRadialCursorPoints":"YR4y5","../shape/Sector":"lEd0X","../util/cursor/getCursorPoints":"j1k6L","../util/ReactUtils":"bLejJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3u8WB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorRectangle", function() {
    return getCursorRectangle;
});
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"YR4y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */ parcelHelpers.export(exports, "getRadialCursorPoints", function() {
    return getRadialCursorPoints;
});
var _polarUtils = require("../PolarUtils");
function getRadialCursorPoints(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

},{"../PolarUtils":"b4tu9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j1k6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorPoints", function() {
    return getCursorPoints;
});
var _polarUtils = require("../PolarUtils");
var _getRadialCursorPoints = require("./getRadialCursorPoints");
function getCursorPoints(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}

},{"../PolarUtils":"b4tu9","./getRadialCursorPoints":"YR4y5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5G9vU":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Area Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AreaChart", function() {
    return AreaChart;
});
var _generateCategoricalChart = require("./generateCategoricalChart");
var _area = require("../cartesian/Area");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var AreaChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'AreaChart',
    GraphicalChild: (0, _area.Area),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"aTpZ9","../cartesian/Area":"WLMlZ","../cartesian/XAxis":"dxKXf","../cartesian/YAxis":"dWDOf","../util/CartesianUtils":"fREAQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2yyA9":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("102dac2c5b43ba07"));
var _reactDom = require("2d12a11897a90108");
var _propTypes = _interopRequireDefault(require("2d6196332782ea09"));
var _activeElement = _interopRequireDefault(require("2c484f0416a2ccd1"));
var _classnames = _interopRequireDefault(require("2dc339ed7c3c9432"));
var _reactComponentManagers = require("6333faea9963e16c");
var _reactLifecyclesCompat = require("89e8b631954879a5");
var _uncontrollable = require("845515c3fda27b81");
var _Widget = _interopRequireDefault(require("1a93f32c8b19b7b9"));
var _WidgetPicker = _interopRequireDefault(require("693a287276a8459f"));
var _Select = _interopRequireDefault(require("bc64811e66785da1"));
var _Popup = _interopRequireDefault(require("fea4a276ba2de159"));
var _List = _interopRequireDefault(require("29f69bd201a4b58a"));
var _AddToListOption = _interopRequireDefault(require("bd28eae5800c06b9"));
var _DropdownListInput = _interopRequireDefault(require("d38a3fb1a4d2ef4e"));
var _messages = require("dd06bf59a16d2e06");
var Props = _interopRequireWildcard(require("93ea8187f01a44e4"));
var Filter = _interopRequireWildcard(require("e9270e7de9b58459"));
var _focusManager = _interopRequireDefault(require("fb5f001934ac9099"));
var CustomPropTypes = _interopRequireWildcard(require("6e1bccc841955a61"));
var _reduceToListState = _interopRequireDefault(require("eb6be642838fb340"));
var _getAccessors = _interopRequireDefault(require("5fcd159ae1cdd85d"));
var _scrollManager = _interopRequireDefault(require("611c0359030d42b9"));
var _interaction = require("c1637f8069178455");
var _widgetHelpers = require("b344044325b3878e");
var _dataHelpers = require("fd3897b758c3d16d");
var _Icon = require("fe400d2c9ef792b8");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _initializerDefineProperty(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
function _initializerWarningHelper(descriptor, context) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and set to use loose mode. To use proposal-class-properties in spec mode with decorators, wait for the next major version of decorators in stage 2.");
}
var CREATE_OPTION = {};
/**
 * ---
 * shortcuts:
 *   - { key: alt + down arrow, label: open dropdown }
 *   - { key: alt + up arrow, label: close dropdown }
 *   - { key: down arrow, label: move focus to next item }
 *   - { key: up arrow, label: move focus to previous item }
 *   - { key: home, label: move focus to first item }
 *   - { key: end, label: move focus to last item }
 *   - { key: enter, label: select focused item }
 *   - { key: ctrl + enter, label: create new option from current searchTerm }
 *   - { key: any key, label: search list for item starting with key }
 * ---
 *
 * A `<select>` replacement for single value lists.
 * @public
 */ var DropdownList = (0, _reactLifecyclesCompat.polyfill)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(DropdownList, _React$Component);
    function DropdownList() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleFocusChanged = function(focused) {
            if (!focused) _this.close();
        };
        _initializerDefineProperty(_this, "handleSelect", _descriptor, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleCreate", _descriptor2, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleClick", _descriptor3, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleKeyDown", _descriptor4, _assertThisInitialized(_assertThisInitialized(_this)));
        _initializerDefineProperty(_this, "handleKeyPress", _descriptor5, _assertThisInitialized(_assertThisInitialized(_this)));
        _this.handleInputChange = function(e) {
            _this.search(e.target.value, e, 'input');
        };
        _this.handleAutofillChange = function(e) {
            var data = _this.props.data;
            var filledValue = e.target.value.toLowerCase();
            if (filledValue === '') return void _this.change(null);
            for(var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }
                var item = _ref;
                var value = (0, _dataHelpers.dataValue)(item);
                if (String(value).toLowerCase() === filledValue || (0, _dataHelpers.dataText)(item).toLowerCase() === filledValue) {
                    _this.change(item, e);
                    break;
                }
            }
        };
        _this.handleAutofill = function(autofilling) {
            _this.setState({
                autofilling: autofilling
            });
        };
        _this.attachInputRef = function(ref) {
            return _this.inputRef = ref;
        };
        _this.attachFilterRef = function(ref) {
            return _this.filterRef = ref;
        };
        _this.attachListRef = function(ref) {
            return _this.listRef = ref;
        };
        _this.focus = function(target) {
            var _this$props = _this.props, filter = _this$props.filter, open = _this$props.open;
            var inst = target || (filter && open ? _this.filterRef : _this.inputRef);
            inst = (0, _reactDom.findDOMNode)(inst);
            if (inst && (0, _activeElement.default)() !== inst) inst.focus();
        };
        (0, _reactComponentManagers.autoFocus)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.inputId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_input');
        _this.listId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox');
        _this.activeId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox_active_option');
        _this.mounted = (0, _reactComponentManagers.mountManager)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.timeouts = (0, _reactComponentManagers.timeoutManager)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.handleScroll = (0, _scrollManager.default)(_assertThisInitialized(_assertThisInitialized(_this)));
        _this.focusManager = (0, _focusManager.default)(_assertThisInitialized(_assertThisInitialized(_this)), {
            didHandle: _this.handleFocusChanged
        });
        _this.state = {};
        return _this;
    }
    DropdownList.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var open = nextProps.open, value = nextProps.value, data = nextProps.data, messages = nextProps.messages, searchTerm = nextProps.searchTerm, filter = nextProps.filter, minLength = nextProps.minLength, caseSensitive = nextProps.caseSensitive;
        var focusedItem = prevState.focusedItem;
        var accessors = (0, _getAccessors.default)(nextProps);
        var valueChanged = value !== prevState.lastValue;
        var initialIdx = valueChanged && accessors.indexOf(data, value);
        if (open) data = Filter.filter(data, {
            filter: filter,
            searchTerm: searchTerm,
            minLength: minLength,
            caseSensitive: caseSensitive,
            textField: accessors.text
        });
        var list = (0, _reduceToListState.default)(data, prevState.list, {
            nextProps: nextProps
        });
        var selectedItem = data[initialIdx];
        var nextFocusedItem = ~data.indexOf(focusedItem) ? focusedItem : data[0];
        return {
            data: data,
            list: list,
            accessors: accessors,
            lastValue: value,
            messages: (0, _messages.getMessages)(messages),
            selectedItem: valueChanged ? list.nextEnabled(selectedItem) : prevState.selectedItem,
            focusedItem: valueChanged || focusedItem === undefined ? list.nextEnabled(selectedItem !== undefined ? selectedItem : nextFocusedItem) : nextFocusedItem
        };
    };
    var _proto = DropdownList.prototype;
    _proto.change = function change(nextValue, originalEvent) {
        var _this$props2 = this.props, onChange = _this$props2.onChange, searchTerm = _this$props2.searchTerm, lastValue = _this$props2.value;
        if (!this.state.accessors.matches(nextValue, lastValue)) {
            (0, _widgetHelpers.notify)(onChange, [
                nextValue,
                {
                    originalEvent: originalEvent,
                    lastValue: lastValue,
                    searchTerm: searchTerm
                }
            ]);
            this.clearSearch(originalEvent);
            this.close();
        }
    };
    _proto.renderList = function renderList() {
        var _this$props3 = this.props, open = _this$props3.open, filter = _this$props3.filter, data = _this$props3.data, searchTerm = _this$props3.searchTerm, searchIcon = _this$props3.searchIcon, optionComponent = _this$props3.optionComponent, itemComponent = _this$props3.itemComponent, groupComponent = _this$props3.groupComponent, listProps = _this$props3.listProps;
        var _this$state = this.state, list = _this$state.list, accessors = _this$state.accessors, focusedItem = _this$state.focusedItem, selectedItem = _this$state.selectedItem, messages = _this$state.messages, filteredData = _this$state.data;
        var List = this.props.listComponent;
        return _react.default.createElement("div", null, filter && _react.default.createElement(_WidgetPicker.default, {
            className: "rw-filter-input rw-input"
        }, _react.default.createElement("input", {
            "aria-activedescendant": open ? this.activeId : null,
            "aria-autocomplete": "list",
            "aria-controls": open ? this.listId : null,
            value: searchTerm,
            className: "rw-input-reset",
            onChange: this.handleInputChange,
            placeholder: messages.filterPlaceholder(this.props),
            ref: this.attachFilterRef
        }), _react.default.createElement(_Select.default, {
            icon: searchIcon,
            role: "presentation",
            "aria-hidden": "true"
        })), _react.default.createElement(List, _extends({}, listProps, {
            id: this.listId,
            activeId: this.activeId,
            data: filteredData,
            dataState: list.dataState,
            isDisabled: list.isDisabled,
            searchTerm: searchTerm,
            textAccessor: accessors.text,
            valueAccessor: accessors.value,
            itemComponent: itemComponent,
            groupComponent: groupComponent,
            optionComponent: optionComponent,
            selectedItem: selectedItem,
            focusedItem: open ? focusedItem : null,
            onSelect: this.handleSelect,
            onMove: this.handleScroll,
            "aria-live": open && 'polite',
            "aria-labelledby": this.inputId,
            "aria-hidden": !this.props.open,
            ref: this.attachListRef,
            messages: {
                emptyList: data.length ? messages.emptyFilter : messages.emptyList
            }
        })), this.allowCreate() && _react.default.createElement(_AddToListOption.default, {
            id: this.createId,
            searchTerm: searchTerm,
            onSelect: this.handleCreate,
            focused: !focusedItem || focusedItem === CREATE_OPTION
        }, messages.createOption(this.props)));
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props4 = this.props, className = _this$props4.className, tabIndex = _this$props4.tabIndex, popupTransition = _this$props4.popupTransition, textField = _this$props4.textField, data = _this$props4.data, busy = _this$props4.busy, dropUp = _this$props4.dropUp, placeholder = _this$props4.placeholder, value = _this$props4.value, open = _this$props4.open, isRtl = _this$props4.isRtl, filter = _this$props4.filter, inputProps = _this$props4.inputProps, selectIcon = _this$props4.selectIcon, busySpinner = _this$props4.busySpinner, containerClassName = _this$props4.containerClassName, valueComponent = _this$props4.valueComponent;
        var _this$state2 = this.state, focused = _this$state2.focused, accessors = _this$state2.accessors, messages = _this$state2.messages, autofilling = _this$state2.autofilling;
        var disabled = this.props.disabled === true;
        var readOnly = this.props.readOnly === true;
        var valueItem = accessors.findOrSelf(data, value);
        var shouldRenderPopup = (0, _widgetHelpers.isFirstFocusedRender)(this);
        var elementProps = _extends(Props.pickElementProps(this), {
            name: undefined,
            role: 'combobox',
            id: this.inputId,
            tabIndex: open && filter ? -1 : tabIndex || 0,
            'aria-owns': this.listId,
            'aria-expanded': !!open,
            'aria-haspopup': true,
            'aria-busy': !!busy,
            'aria-live': !open && 'polite',
            'aria-disabled': disabled,
            'aria-readonly': readOnly
        });
        return _react.default.createElement(_Widget.default, _extends({}, elementProps, {
            open: open,
            isRtl: isRtl,
            dropUp: dropUp,
            focused: focused,
            disabled: disabled,
            readOnly: readOnly,
            autofilling: autofilling,
            onBlur: this.focusManager.handleBlur,
            onFocus: this.focusManager.handleFocus,
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
            className: (0, _classnames.default)(className, 'rw-dropdown-list'),
            ref: this.attachInputRef
        }), _react.default.createElement(_WidgetPicker.default, {
            onClick: this.handleClick,
            className: (0, _classnames.default)(containerClassName, 'rw-widget-input')
        }, _react.default.createElement(_DropdownListInput.default, _extends({}, inputProps, {
            value: valueItem,
            textField: textField,
            name: this.props.name,
            autoComplete: this.props.autoComplete,
            onAutofill: this.handleAutofill,
            onAutofillChange: this.handleAutofillChange,
            placeholder: placeholder,
            valueComponent: valueComponent
        })), _react.default.createElement(_Select.default, {
            busy: busy,
            icon: selectIcon,
            spinner: busySpinner,
            role: "presentational",
            "aria-hidden": "true",
            disabled: disabled || readOnly,
            label: messages.openDropdown(this.props)
        })), shouldRenderPopup && _react.default.createElement(_Popup.default, {
            open: open,
            dropUp: dropUp,
            transition: popupTransition,
            onEntered: function onEntered() {
                return _this2.focus();
            },
            onEntering: function onEntering() {
                return _this2.listRef.forceUpdate();
            }
        }, this.renderList(messages)));
    };
    _proto.findOption = function findOption(character, cb) {
        var _this3 = this;
        var word = ((this._currentWord || '') + character).toLowerCase();
        if (!character) return;
        this._currentWord = word;
        this.timeouts.set('search', function() {
            var list = _this3.state.list;
            var key = _this3.props.open ? 'focusedItem' : 'selectedItem';
            var item = list.next(_this3.state[key], word);
            if (item === _this3.state[key]) item = list.next(null, word);
            _this3._currentWord = '';
            if (item) cb(item);
        }, this.props.delay);
    };
    _proto.clearSearch = function clearSearch(originalEvent) {
        this.search('', originalEvent, 'clear');
    };
    _proto.search = function search(searchTerm, originalEvent, action) {
        if (action === void 0) action = 'input';
        var _this$props5 = this.props, onSearch = _this$props5.onSearch, lastSearchTerm = _this$props5.searchTerm;
        if (searchTerm !== lastSearchTerm) (0, _widgetHelpers.notify)(onSearch, [
            searchTerm,
            {
                action: action,
                lastSearchTerm: lastSearchTerm,
                originalEvent: originalEvent
            }
        ]);
    };
    _proto.open = function open() {
        if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
    };
    _proto.close = function close() {
        if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
    };
    _proto.toggle = function toggle() {
        this.props.open ? this.close() : this.open();
    };
    _proto.allowCreate = function allowCreate() {
        var _this$props6 = this.props, searchTerm = _this$props6.searchTerm, onCreate = _this$props6.onCreate, allowCreate = _this$props6.allowCreate;
        return !!(onCreate && (allowCreate === true || allowCreate === 'onFilter' && searchTerm) && !this.hasExtactMatch());
    };
    _proto.hasExtactMatch = function hasExtactMatch() {
        var _this$props7 = this.props, searchTerm = _this$props7.searchTerm, caseSensitive = _this$props7.caseSensitive, filter = _this$props7.filter;
        var _this$state3 = this.state, data = _this$state3.data, accessors = _this$state3.accessors;
        var lower = function lower(text) {
            return caseSensitive ? text : text.toLowerCase();
        }; // if there is an exact match on textFields:
        return filter && data.some(function(v) {
            return lower(accessors.text(v)) === lower(searchTerm);
        });
    };
    return DropdownList;
}(_react.default.Component), _class3.propTypes = _extends({}, Filter.propTypes, {
    value: _propTypes.default.any,
    /**
   * @type {function (
   *  dataItems: ?any,
   *  metadata: {
   *    lastValue: ?any,
   *    searchTerm: ?string
   *    originalEvent: SyntheticEvent,
   *  }
   * ): void}
   */ onChange: _propTypes.default.func,
    open: _propTypes.default.bool,
    onToggle: _propTypes.default.func,
    data: _propTypes.default.array,
    valueField: CustomPropTypes.accessor,
    textField: CustomPropTypes.accessor,
    allowCreate: _propTypes.default.oneOf([
        true,
        false,
        'onFilter'
    ]),
    /**
   * A React component for customizing the rendering of the DropdownList
   * value
   */ valueComponent: CustomPropTypes.elementType,
    itemComponent: CustomPropTypes.elementType,
    listComponent: CustomPropTypes.elementType,
    optionComponent: CustomPropTypes.elementType,
    groupComponent: CustomPropTypes.elementType,
    groupBy: CustomPropTypes.accessor,
    /**
   *
   * @type {(dataItem: ?any, metadata: { originalEvent: SyntheticEvent }) => void}
   */ onSelect: _propTypes.default.func,
    onCreate: _propTypes.default.func,
    /**
   * @type function(searchTerm: string, metadata: { action, lastSearchTerm, originalEvent? })
   */ onSearch: _propTypes.default.func,
    searchTerm: _propTypes.default.string,
    busy: _propTypes.default.bool,
    /** Specify the element used to render the select (down arrow) icon. */ selectIcon: _propTypes.default.node,
    searchIcon: _propTypes.default.node,
    /** Specify the element used to render the busy indicator */ busySpinner: _propTypes.default.node,
    placeholder: _propTypes.default.string,
    dropUp: _propTypes.default.bool,
    popupTransition: CustomPropTypes.elementType,
    disabled: CustomPropTypes.disabled.acceptsArray,
    readOnly: CustomPropTypes.disabled,
    /** Adds a css class to the input container element. */ containerClassName: _propTypes.default.string,
    inputProps: _propTypes.default.object,
    listProps: _propTypes.default.object,
    isRtl: _propTypes.default.bool,
    messages: _propTypes.default.shape({
        open: _propTypes.default.string,
        emptyList: CustomPropTypes.message,
        emptyFilter: CustomPropTypes.message,
        filterPlaceholder: _propTypes.default.string,
        createOption: CustomPropTypes.message
    })
}), _class3.defaultProps = {
    data: [],
    delay: 500,
    searchTerm: '',
    allowCreate: false,
    searchIcon: _Icon.search,
    selectIcon: _Icon.caretDown,
    listComponent: _List.default
}, _temp), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "handleSelect", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this4 = this;
        return function(dataItem, originalEvent) {
            if (dataItem === undefined || dataItem === CREATE_OPTION) {
                _this4.handleCreate(_this4.props.searchTerm);
                return;
            }
            (0, _widgetHelpers.notify)(_this4.props.onSelect, [
                dataItem,
                {
                    originalEvent: originalEvent
                }
            ]);
            _this4.change(dataItem, originalEvent);
            _this4.close();
            _this4.focus(_this4);
        };
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "handleCreate", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this5 = this;
        return function(searchTerm, event) {
            if (searchTerm === void 0) searchTerm = '';
            (0, _widgetHelpers.notify)(_this5.props.onCreate, searchTerm);
            _this5.clearSearch(event);
            _this5.close();
            _this5.focus(_this5);
        };
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "handleClick", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this6 = this;
        return function(e) {
            _this6.focus();
            _this6.toggle();
            (0, _widgetHelpers.notify)(_this6.props.onClick, e);
        };
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyDown", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this7 = this;
        return function(e) {
            var key = e.key, altKey = e.altKey, ctrlKey = e.ctrlKey;
            var _this7$props = _this7.props, open = _this7$props.open, onKeyDown = _this7$props.onKeyDown, filter = _this7$props.filter, searchTerm = _this7$props.searchTerm;
            var _this7$state = _this7.state, focusedItem = _this7$state.focusedItem, selectedItem = _this7$state.selectedItem, list = _this7$state.list;
            var createIsFocused = focusedItem === CREATE_OPTION;
            var canCreate = _this7.allowCreate();
            (0, _widgetHelpers.notify)(onKeyDown, [
                e
            ]);
            var closeWithFocus = function closeWithFocus() {
                _this7.close();
                (0, _reactDom.findDOMNode)(_this7).focus();
            };
            var change = function change(item) {
                return item != null && _this7.change(item, e);
            };
            var focusItem = function focusItem(item) {
                return _this7.setState({
                    focusedItem: item
                });
            };
            if (e.defaultPrevented) return;
            if (key === 'End') {
                e.preventDefault();
                if (open) focusItem(list.last());
                else change(list.last());
            } else if (key === 'Home') {
                e.preventDefault();
                if (open) focusItem(list.first());
                else change(list.first());
            } else if (key === 'Escape' && open) {
                e.preventDefault();
                closeWithFocus();
            } else if (key === 'Enter' && open && ctrlKey && canCreate) {
                e.preventDefault();
                _this7.handleCreate(searchTerm, e);
            } else if ((key === 'Enter' || key === ' ' && !filter) && open) {
                e.preventDefault();
                _this7.handleSelect(focusedItem, e);
            } else if (key === ' ' && !open) {
                e.preventDefault();
                _this7.open();
            } else if (key === 'ArrowDown') {
                e.preventDefault();
                if (altKey) return _this7.open();
                if (!open) change(list.next(selectedItem));
                var next = list.next(focusedItem);
                var creating = createIsFocused || canCreate && focusedItem === next;
                focusItem(creating ? CREATE_OPTION : next);
            } else if (key === 'ArrowUp') {
                e.preventDefault();
                if (altKey) return closeWithFocus();
                if (!open) return change(list.prev(selectedItem));
                focusItem(createIsFocused ? list.last() : list.prev(focusedItem));
            }
        };
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyPress", [
    _interaction.widgetEditable
], {
    enumerable: true,
    initializer: function initializer() {
        var _this8 = this;
        return function(e) {
            (0, _widgetHelpers.notify)(_this8.props.onKeyPress, [
                e
            ]);
            if (e.defaultPrevented) return;
            if (!(_this8.props.filter && _this8.props.open)) _this8.findOption(String.fromCharCode(e.which), function(item) {
                _this8.mounted() && _this8.props.open ? _this8.setState({
                    focusedItem: item
                }) : item && _this8.change(item, e);
            });
        };
    }
}), _class2)) || _class;
var _default = (0, _uncontrollable.uncontrollable)(DropdownList, {
    open: 'onToggle',
    value: 'onChange',
    searchTerm: 'onSearch'
}, [
    'focus'
]);
exports.default = _default;
module.exports = exports["default"];

},{"102dac2c5b43ba07":"gVheC","2d12a11897a90108":"d8jlt","2d6196332782ea09":"3KNJy","2c484f0416a2ccd1":"e18vI","2dc339ed7c3c9432":"6P5cq","6333faea9963e16c":"bMv3b","89e8b631954879a5":"3F3XD","845515c3fda27b81":"ePx5f","1a93f32c8b19b7b9":"kwrMv","693a287276a8459f":"2Vzpm","bc64811e66785da1":"iRwQF","fea4a276ba2de159":"kvIc9","29f69bd201a4b58a":"l4cBu","bd28eae5800c06b9":"gWq2b","d38a3fb1a4d2ef4e":"lP17Z","dd06bf59a16d2e06":"fEqYz","93ea8187f01a44e4":"2s4vq","e9270e7de9b58459":"cJxm3","fb5f001934ac9099":"htUOG","6e1bccc841955a61":"8HlUx","eb6be642838fb340":"dlO4J","5fcd159ae1cdd85d":"fK5xu","611c0359030d42b9":"43Cr9","c1637f8069178455":"qGuYY","b344044325b3878e":"fu3eM","fd3897b758c3d16d":"7jDuP","fe400d2c9ef792b8":"5bZrH"}],"gWq2b":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var PropTypes = _interopRequireWildcard(require("3c93c4f93fca4ce8"));
var _react = _interopRequireDefault(require("8254220417db243b"));
var _Listbox = _interopRequireDefault(require("78cfe04d64175a15"));
var _ListOption = _interopRequireDefault(require("778632494daf40e2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var propTypes = {
    searchTerm: PropTypes.string,
    focused: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    activeId: PropTypes.string
};
function AddToListOption(_ref) {
    var searchTerm = _ref.searchTerm, onSelect = _ref.onSelect, focused = _ref.focused, children = _ref.children, activeId = _ref.activeId, props = _objectWithoutProperties(_ref, [
        "searchTerm",
        "onSelect",
        "focused",
        "children",
        "activeId"
    ]);
    return _react.default.createElement(_Listbox.default, _extends({}, props, {
        className: "rw-list-option-create"
    }), _react.default.createElement(_ListOption.default, {
        onSelect: onSelect,
        focused: focused,
        activeId: activeId,
        dataItem: searchTerm
    }, children));
}
AddToListOption.propTypes = propTypes;
var _default = AddToListOption;
exports.default = _default;
module.exports = exports["default"];

},{"3c93c4f93fca4ce8":"3KNJy","8254220417db243b":"gVheC","78cfe04d64175a15":"5xc41","778632494daf40e2":"CNE20"}],"lP17Z":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("3f30d2039d3a4625"));
var _classnames = _interopRequireDefault(require("c835ddbfa5946f29"));
var _propTypes = _interopRequireDefault(require("6b664b1b5f269a3b"));
var CustomPropTypes = _interopRequireWildcard(require("60ce1bb901107fc"));
var _dataHelpers = require("1b496d562abaf4c8");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var DropdownListInput = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(DropdownListInput, _React$Component);
    function DropdownListInput() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            autofilling: false
        };
        _this.handleAutofillDetect = function(_ref) {
            var animationName = _ref.animationName;
            var autofilling;
            if (animationName === 'react-widgets-autofill-start') autofilling = true;
            else if (animationName === 'react-widgets-autofill-cancel') autofilling = false;
            else return;
            _this.setState({
                autofilling: autofilling
            });
            _this.props.onAutofill(autofilling);
        };
        _this.handleAutofill = function(e) {
            _this.setState({
                autofilling: false
            });
            _this.props.onAutofillChange(e);
        };
        return _this;
    }
    var _proto = DropdownListInput.prototype;
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, placeholder = _this$props.placeholder, value = _this$props.value, textField = _this$props.textField, autoComplete = _this$props.autoComplete, Component = _this$props.valueComponent;
        var autofilling = this.state.autofilling;
        var child = null;
        if (!autofilling && autoComplete !== 'off') child = !value && placeholder ? _react.default.createElement("span", {
            className: "rw-placeholder"
        }, placeholder) : Component ? _react.default.createElement(Component, {
            item: value
        }) : (0, _dataHelpers.dataText)(value, textField);
        var val = (0, _dataHelpers.dataValue)(value, textField);
        return _react.default.createElement("div", {
            className: "rw-input rw-dropdown-list-input"
        }, autoComplete !== 'off' && _react.default.createElement("input", {
            tabIndex: "-1",
            name: name,
            value: val == null ? '' : val,
            autoComplete: autoComplete,
            onChange: this.handleAutofill,
            onAnimationStart: this.handleAutofillDetect,
            className: (0, _classnames.default)('rw-dropdown-list-autofill rw-detect-autofill', !autofilling && 'rw-sr')
        }), child);
    };
    return DropdownListInput;
}(_react.default.Component);
DropdownListInput.propTypes = {
    value: _propTypes.default.any,
    placeholder: _propTypes.default.string,
    name: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    textField: CustomPropTypes.accessor,
    valueComponent: CustomPropTypes.elementType,
    onAutofill: _propTypes.default.func.isRequired,
    onAutofillChange: _propTypes.default.func.isRequired
};
var _default = DropdownListInput;
exports.default = _default;
module.exports = exports["default"];

},{"3f30d2039d3a4625":"gVheC","c835ddbfa5946f29":"6P5cq","6b664b1b5f269a3b":"3KNJy","60ce1bb901107fc":"8HlUx","1b496d562abaf4c8":"7jDuP"}],"fK5xu":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = createAccessors;
var helpers = _interopRequireWildcard(require("2f2c776bd961c171"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function createAccessors(_ref) {
    var textField = _ref.textField, valueField = _ref.valueField;
    return {
        text: function text(item) {
            return helpers.dataText(item, textField);
        },
        value: function value(item) {
            return helpers.dataValue(item, valueField);
        },
        indexOf: function indexOf(data, item) {
            return helpers.dataIndexOf(data, item, valueField);
        },
        matches: function matches(a, b) {
            return helpers.valueMatcher(a, b, valueField);
        },
        findOrSelf: function findOrSelf(data, item) {
            return helpers.dataItem(data, item, valueField);
        },
        includes: function includes(data, item) {
            return helpers.dataIndexOf(data, item, valueField) !== -1;
        }
    };
}
module.exports = exports["default"];

},{"2f2c776bd961c171":"7jDuP"}],"EUzlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleSwitch", function() {
    return ToggleSwitch;
});
parcelHelpers.export(exports, "ButtonDropdown", function() {
    return ButtonDropdown;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../../AppState");
var _reactstrap = require("reactstrap");
var _reactDeviceDetect = require("react-device-detect");
var ToggleSwitch = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: "switch",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                type: "checkbox"
            }, props)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "slider round"
            })
        ]
    });
};
var ButtonDropdown = function(_param) {
    var label = _param.label, title = _param.title, icon = _param.icon, className = _param.className, children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "label",
        "title",
        "icon",
        "className",
        "children"
    ]);
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var buttonRef = (0, _react.useRef)(null);
    var containerRef = (0, _react.useRef)(null);
    var handleDocumentClick = function(e) {
        var button = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (button && container && e.target !== container && !container.contains(e.target) && !button.contains(e.target)) props.setIsOpen(!props.isOpen);
    };
    var toggle = function() {
        props.setIsOpen(!props.isOpen);
    };
    (0, _react.useEffect)(function() {
        if (!(0, _reactDeviceDetect.isMobile) && !(0, _reactDeviceDetect.isTablet)) props.isOpen ? document.addEventListener('click', handleDocumentClick, true) : document.removeEventListener('click', handleDocumentClick, true);
    }, [
        props.isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (className || "") + " position-relative",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                ref: buttonRef,
                className: "tria-btn w-sm-100",
                color: props.color || "",
                "icon-pos": props.iconPos || "",
                sz: "lg",
                onClick: toggle,
                style: props.buttonStyle || null,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: icon || "far fa-plus",
                        style: {
                            marginTop: 2
                        }
                    }),
                    label || ""
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: containerRef,
                className: props.isOpen && !(0, _reactDeviceDetect.isMobile) && !(0, _reactDeviceDetect.isTablet) ? '' : 'd-none',
                style: {
                    zIndex: "999",
                    position: "absolute",
                    right: "0px",
                    width: props.cardWidth || "315px"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                    className: "card-minimal button-dropdown-card",
                    style: {
                        top: "15px"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                            className: "card-header-minimal",
                            style: {
                                paddingLeft: "25px",
                                paddingTop: "30px"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                                className: "card-title-minimal tria-card-title",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                            style: {
                                paddingLeft: "30px",
                                paddingRight: "35px"
                            },
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_without_properties":"jGp91","@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","../../AppState":"8UGXH","reactstrap":"774RE","react-device-detect":"h7vq0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hSoEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleSwitch", function() {
    return ToggleSwitch;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ToggleSwitch = function(_param) {
    var checked = _param.checked, onChange = _param.onChange, props = (0, _objectWithoutProperties._)(_param, [
        "checked",
        "onChange"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: "switch",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                type: "checkbox",
                checked: checked || false,
                onChange: onChange || false
            }, props || false)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "slider round"
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_without_properties":"jGp91","react/jsx-runtime":"1elNt","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kGl4g":[function() {},{}],"68ziH":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("hJ5SK"));

},{}],"9Egq2":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("9FEJa"));

},{}],"cKMKD":[function(require,module,exports,__globalThis) {
module.exports = require("905308ec2b5a0c17")(require("25ee942568d27108").resolve("K7gaz")).then(function() {
    return module.bundle.root('2gIre');
});

},{"905308ec2b5a0c17":"saBRa","25ee942568d27108":"dixf5"}],"saBRa":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"jaPgN"}],"jaPgN":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"hD1tQ":[function(require,module,exports,__globalThis) {
module.exports = require("abba35c1e041fe2a")(require("7fbf85d0f836df99").resolve("rHy52")).then(function() {
    return module.bundle.root('gXP40');
});

},{"abba35c1e041fe2a":"saBRa","7fbf85d0f836df99":"dixf5"}],"iDi8Y":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6fc80e0a26ee0c37")(require("a0c43943903fb301").resolve("jNO3W")),
    require("ccc476b60155837c")(require("a0c43943903fb301").resolve("dPHxE")),
    require("ccc476b60155837c")(require("a0c43943903fb301").resolve("QOOw3"))
]).then(function() {
    return module.bundle.root('fkRGS');
});

},{"6fc80e0a26ee0c37":"eahth","a0c43943903fb301":"dixf5","ccc476b60155837c":"saBRa"}],"eahth":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"jaPgN"}],"ksJTf":[function(require,module,exports,__globalThis) {
module.exports = require("900f95d8f68e3980")(require("bb2e0fee50d94e22").resolve("itGhn")).then(function() {
    return module.bundle.root('bo0Hu');
});

},{"900f95d8f68e3980":"saBRa","bb2e0fee50d94e22":"dixf5"}],"6xmPW":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("f248d297d4dddbb9")(require("625ece12e23f755e").resolve("5Sf2N")),
    require("f248d297d4dddbb9")(require("625ece12e23f755e").resolve("fkLYS"))
]).then(function() {
    return module.bundle.root('mASA4');
});

},{"f248d297d4dddbb9":"saBRa","625ece12e23f755e":"dixf5"}],"lEFox":[function(require,module,exports,__globalThis) {
module.exports = require("3051ee27e77a76b2")(require("5396d369de67d85c").resolve("hNch6")).then(function() {
    return module.bundle.root('jrqbr');
});

},{"3051ee27e77a76b2":"saBRa","5396d369de67d85c":"dixf5"}],"hydcf":[function(require,module,exports,__globalThis) {
module.exports = require("d03e41d4979f9d36")(require("5b34f378d9f0ab4").resolve("4FO1N")).then(function() {
    return module.bundle.root('dRS47');
});

},{"d03e41d4979f9d36":"saBRa","5b34f378d9f0ab4":"dixf5"}],"edIqY":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("89c74869337db742")(require("42e456482b704e4f").resolve("1JJpK")),
    require("89c74869337db742")(require("42e456482b704e4f").resolve("5Sf2N")),
    require("89c74869337db742")(require("42e456482b704e4f").resolve("6fUB8")),
    require("89c74869337db742")(require("42e456482b704e4f").resolve("kcSmY"))
]).then(function() {
    return module.bundle.root('6AX6V');
});

},{"89c74869337db742":"saBRa","42e456482b704e4f":"dixf5"}],"5KuYD":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5c040ddf4001b94b")(require("b8d83e5f3a0e551a").resolve("5Sf2N")),
    require("5c040ddf4001b94b")(require("b8d83e5f3a0e551a").resolve("6fUB8"))
]).then(function() {
    return module.bundle.root('BqAL3');
});

},{"5c040ddf4001b94b":"saBRa","b8d83e5f3a0e551a":"dixf5"}],"cSpUF":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("2582a125e7581fdf")(require("c2574eff9286ad69").resolve("hrZSR")),
    require("4b1719a67e72253c")(require("c2574eff9286ad69").resolve("hTl6g")),
    require("4b1719a67e72253c")(require("c2574eff9286ad69").resolve("kImt5"))
]).then(function() {
    return module.bundle.root('h1SQg');
});

},{"2582a125e7581fdf":"eahth","c2574eff9286ad69":"dixf5","4b1719a67e72253c":"saBRa"}],"6OyA1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("8a3f662151da2744")(require("d4828c92867b1e48").resolve("41EKD")),
    require("59edef4f3b176fd")(require("d4828c92867b1e48").resolve("hyhOp"))
]).then(function() {
    return module.bundle.root('gJWrk');
});

},{"8a3f662151da2744":"eahth","d4828c92867b1e48":"dixf5","59edef4f3b176fd":"saBRa"}],"iSkuf":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("73c1a7b751d9d25f")(require("73754abb87e88d66").resolve("hTl6g")),
    require("f734fff0fa844abc")(require("73754abb87e88d66").resolve("41EKD")),
    require("73c1a7b751d9d25f")(require("73754abb87e88d66").resolve("hyhOp")),
    require("73c1a7b751d9d25f")(require("73754abb87e88d66").resolve("iWm9i"))
]).then(function() {
    return module.bundle.root('LH5Ma');
});

},{"73c1a7b751d9d25f":"saBRa","73754abb87e88d66":"dixf5","f734fff0fa844abc":"eahth"}],"jnG20":[function(require,module,exports,__globalThis) {
module.exports = require("6277e07804c3c54e")(require("3957931d0eda38f7").resolve("jOqYm")).then(function() {
    return module.bundle.root('11AtV');
});

},{"6277e07804c3c54e":"saBRa","3957931d0eda38f7":"dixf5"}],"ghmCF":[function(require,module,exports,__globalThis) {
module.exports = require("15a66bc56a3d9afb")(require("3519d8ee9e2b9d50").resolve("l4sqK")).then(function() {
    return module.bundle.root('a8Ddp');
});

},{"15a66bc56a3d9afb":"saBRa","3519d8ee9e2b9d50":"dixf5"}],"6ZpKY":[function(require,module,exports,__globalThis) {
module.exports = require("4eee31cded01d6c1")(require("26574044bd7ce5ad").resolve("dJ1KK")).then(function() {
    return module.bundle.root('7iqUL');
});

},{"4eee31cded01d6c1":"saBRa","26574044bd7ce5ad":"dixf5"}],"7HibE":[function(require,module,exports,__globalThis) {
module.exports = require("6ca94baa4bd97719")(require("abd5aa6c375eed32").resolve("dtdNv")).then(function() {
    return module.bundle.root('gPd6y');
});

},{"6ca94baa4bd97719":"saBRa","abd5aa6c375eed32":"dixf5"}],"8UO9s":[function(require,module,exports,__globalThis) {
module.exports = require("75346903d2d1cc5e")(require("a2551361f0ff0399").resolve("5kAkc")).then(function() {
    return module.bundle.root('4px45');
});

},{"75346903d2d1cc5e":"saBRa","a2551361f0ff0399":"dixf5"}],"5I4pj":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("516d6030660d5232")(require("85b308d538029465").resolve("bgfX8")),
    require("a284cdda72fb3e3e")(require("85b308d538029465").resolve("eKyJe")),
    require("a284cdda72fb3e3e")(require("85b308d538029465").resolve("1Fp5x")),
    require("a284cdda72fb3e3e")(require("85b308d538029465").resolve("dPHxE")),
    require("a284cdda72fb3e3e")(require("85b308d538029465").resolve("6P6YR"))
]).then(function() {
    return module.bundle.root('QsQ1G');
});

},{"516d6030660d5232":"eahth","85b308d538029465":"dixf5","a284cdda72fb3e3e":"saBRa"}],"f4A2N":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("d9236b667fbe3c25")(require("c6540361ff31f0ec").resolve("6o8se")),
    require("a6a9110de4379fad")(require("c6540361ff31f0ec").resolve("cGrnM")),
    require("a6a9110de4379fad")(require("c6540361ff31f0ec").resolve("eKyJe")),
    require("a6a9110de4379fad")(require("c6540361ff31f0ec").resolve("dPHxE")),
    require("a6a9110de4379fad")(require("c6540361ff31f0ec").resolve("kxFyJ"))
]).then(function() {
    return module.bundle.root('6m4k0');
});

},{"d9236b667fbe3c25":"eahth","c6540361ff31f0ec":"dixf5","a6a9110de4379fad":"saBRa"}],"4ZYIi":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("d269214111d0ace5")(require("3f6ce343725e29f8").resolve("BegZJ")),
    require("dd56b336447f6315")(require("3f6ce343725e29f8").resolve("cGrnM")),
    require("dd56b336447f6315")(require("3f6ce343725e29f8").resolve("eKyJe")),
    require("dd56b336447f6315")(require("3f6ce343725e29f8").resolve("dPHxE")),
    require("dd56b336447f6315")(require("3f6ce343725e29f8").resolve("6C52O"))
]).then(function() {
    return module.bundle.root('cNSTV');
});

},{"d269214111d0ace5":"eahth","3f6ce343725e29f8":"dixf5","dd56b336447f6315":"saBRa"}],"jUYkY":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5b1e0a01d5f1799")(require("5f2ce48bc659c501").resolve("1Fp5x")),
    require("5b1e0a01d5f1799")(require("5f2ce48bc659c501").resolve("dPHxE")),
    require("5b1e0a01d5f1799")(require("5f2ce48bc659c501").resolve("gWRhS"))
]).then(function() {
    return module.bundle.root('7MtMc');
});

},{"5b1e0a01d5f1799":"saBRa","5f2ce48bc659c501":"dixf5"}],"3h6M8":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("fd44ef9450f79d8d")(require("915b3346a489e2f").resolve("1JJpK")),
    require("fd44ef9450f79d8d")(require("915b3346a489e2f").resolve("7Wht9"))
]).then(function() {
    return module.bundle.root('3FjdB');
});

},{"fd44ef9450f79d8d":"saBRa","915b3346a489e2f":"dixf5"}],"fPghv":[function(require,module,exports,__globalThis) {
module.exports = require("f3e979e7099e1cf6")(require("b59ecea34e0f5eca").resolve("jKMDA")).then(function() {
    return module.bundle.root('64iyS');
});

},{"f3e979e7099e1cf6":"saBRa","b59ecea34e0f5eca":"dixf5"}],"bBFi9":[function(require,module,exports,__globalThis) {
module.exports = require("58b26957cea5e213")(require("c8d870f2de7479f9").resolve("lNDvf")).then(function() {
    return module.bundle.root('hAPos');
});

},{"58b26957cea5e213":"saBRa","c8d870f2de7479f9":"dixf5"}],"2WKJs":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("86b9eff0bcd4e91c")(require("cd6f2c2140b0c4df").resolve("eKyJe")),
    require("86b9eff0bcd4e91c")(require("cd6f2c2140b0c4df").resolve("1JJpK")),
    require("86b9eff0bcd4e91c")(require("cd6f2c2140b0c4df").resolve("k1a9N"))
]).then(function() {
    return module.bundle.root('jGtDR');
});

},{"86b9eff0bcd4e91c":"saBRa","cd6f2c2140b0c4df":"dixf5"}],"aOK6j":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("8e4176722d1c6a67")(require("a5460da34bacaa8c").resolve("3Lyer")),
    require("8e4176722d1c6a67")(require("a5460da34bacaa8c").resolve("1JJpK")),
    require("8e4176722d1c6a67")(require("a5460da34bacaa8c").resolve("5Sf2N")),
    require("8e4176722d1c6a67")(require("a5460da34bacaa8c").resolve("6fUB8")),
    require("8e4176722d1c6a67")(require("a5460da34bacaa8c").resolve("72D6V"))
]).then(function() {
    return module.bundle.root('l1Sb9');
});

},{"8e4176722d1c6a67":"saBRa","a5460da34bacaa8c":"dixf5"}],"7dryn":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("fbbab4b6a8b1ea20")(require("fa56f12a26d797d9").resolve("3Lyer")),
    require("fbbab4b6a8b1ea20")(require("fa56f12a26d797d9").resolve("24loL"))
]).then(function() {
    return module.bundle.root('ciK2U');
});

},{"fbbab4b6a8b1ea20":"saBRa","fa56f12a26d797d9":"dixf5"}],"az3mT":[function(require,module,exports,__globalThis) {
module.exports = require("59d879b405f76d9f")(require("667b5166cdf49b7d").resolve("dT9qh")).then(function() {
    return module.bundle.root('iMsLz');
});

},{"59d879b405f76d9f":"saBRa","667b5166cdf49b7d":"dixf5"}],"eo8fG":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("65a9b0927834d607")(require("709225c7492ff548").resolve("58xf6")),
    require("65a9b0927834d607")(require("709225c7492ff548").resolve("1JJpK")),
    require("65a9b0927834d607")(require("709225c7492ff548").resolve("asNW6"))
]).then(function() {
    return module.bundle.root('018UE');
});

},{"65a9b0927834d607":"saBRa","709225c7492ff548":"dixf5"}],"8DEUS":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("d6d00519f5dfa5aa")(require("f4aa8fe06ff6bbca").resolve("58xf6")),
    require("d6d00519f5dfa5aa")(require("f4aa8fe06ff6bbca").resolve("1JJpK")),
    require("d6d00519f5dfa5aa")(require("f4aa8fe06ff6bbca").resolve("aGzbt"))
]).then(function() {
    return module.bundle.root('hNEk1');
});

},{"d6d00519f5dfa5aa":"saBRa","f4aa8fe06ff6bbca":"dixf5"}],"24cqd":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("79cf1a3a6c8456a5")(require("b6c501d3e75f28f8").resolve("dPHxE")),
    require("79cf1a3a6c8456a5")(require("b6c501d3e75f28f8").resolve("jvf7B"))
]).then(function() {
    return module.bundle.root('3zG9r');
});

},{"79cf1a3a6c8456a5":"saBRa","b6c501d3e75f28f8":"dixf5"}],"culzg":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("bSLbt"));

},{}],"1qnxC":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("c8144ad326214b9d")(require("ce4e2ececfaa21cf").resolve("1JJpK")),
    require("c8144ad326214b9d")(require("ce4e2ececfaa21cf").resolve("bL7BP"))
]).then(function() {
    return module.bundle.root('mfq20');
});

},{"c8144ad326214b9d":"saBRa","ce4e2ececfaa21cf":"dixf5"}],"XYLFx":[function(require,module,exports,__globalThis) {
module.exports = require("f97e4e1fd42beeea")(require("167edc64009a8b97").resolve("lNGDC")).then(function() {
    return module.bundle.root('2V5eg');
});

},{"f97e4e1fd42beeea":"saBRa","167edc64009a8b97":"dixf5"}],"4Icrv":[function(require,module,exports,__globalThis) {
module.exports = require("c2ccf408a5aa1e32")(require("bc868e53695e96a7").resolve("2on7u")).then(function() {
    return module.bundle.root('241cx');
});

},{"c2ccf408a5aa1e32":"saBRa","bc868e53695e96a7":"dixf5"}],"jo4hf":[function(require,module,exports,__globalThis) {
module.exports = require("b5c7cb4fc4750090")(require("faa18fe4670db19f").resolve("adJh5")).then(function() {
    return module.bundle.root('7rtbH');
});

},{"b5c7cb4fc4750090":"saBRa","faa18fe4670db19f":"dixf5"}],"CCV8b":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("41c0t"));

},{}],"kTnhr":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6282c68b26730c64")(require("39e309e447257a0a").resolve("1JJpK")),
    require("6282c68b26730c64")(require("39e309e447257a0a").resolve("lLLVA"))
]).then(function() {
    return module.bundle.root('bD5LQ');
});

},{"6282c68b26730c64":"saBRa","39e309e447257a0a":"dixf5"}],"66Rrt":[function(require,module,exports,__globalThis) {
module.exports = require("a00d8ef1a47c9ce5")(require("7c23f232e9850ed").resolve("kCwWs")).then(function() {
    return module.bundle.root('iP8b8');
});

},{"a00d8ef1a47c9ce5":"saBRa","7c23f232e9850ed":"dixf5"}],"dp8pl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var useRouter = function() {
    var params = (0, _reactRouterDom.useParams)();
    var location = (0, _reactRouterDom.useLocation)();
    var history = (0, _reactRouterDom.useHistory)();
    var match = (0, _reactRouterDom.useRouteMatch)();
    return (0, _react.useMemo)(function() {
        return {
            push: history.push,
            replace: history.replace,
            pathname: location.pathname,
            // Merge params and parsed query string into single "query" object
            // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
            query: (0, _objectSpread._)({}, (0, _queryStringDefault.default).parse(location.search), params),
            params: params,
            match: match,
            location: location,
            history: history
        };
    }, [
        params,
        match,
        location,
        history
    ]);
};
exports.default = useRouter;

},{"@swc/helpers/_/_object_spread":"awG4j","react":"gVheC","react-router-dom":"acq4R","query-string":"1Bmpm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Bmpm":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var strictUriEncode = require("5752d3663915398f");
var decodeComponent = require("4cbbda34882b91a3");
var splitOnFirst = require("53494decacb36d1b");
var filterObject = require("dfb8fa56cbbad4a5");
var isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[',
                            encode(index, options),
                            ']=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'bracket':
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[]'
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '[]=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'colon-list-separator':
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            ':list='
                        ].join('')
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            ':list=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return function(key) {
                    return function(result, value) {
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSep,
                                encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
                };
            }
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return (0, _toConsumableArray._)(result).concat([
                        encode(key, options)
                    ]);
                    return (0, _toConsumableArray._)(result).concat([
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ]);
                };
            };
    }
}
function parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return function(key, value, accumulator) {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return function(key, value, accumulator) {
                var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return decode(item, options);
                }) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return function(key, value, accumulator) {
                var isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function(item) {
                    return decode(item, options);
                });
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if ((typeof input === "undefined" ? "undefined" : (0, _typeOf._)(input)) === 'object') return keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split('&')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === '') continue;
            var _splitOnFirst = (0, _slicedToArray._)(splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                'comma',
                'separator',
                'bracket-separator'
            ].includes(options.arrayFormat) ? value : decode(value, options);
            formatter(decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if ((typeof value1 === "undefined" ? "undefined" : (0, _typeOf._)(value1)) === 'object' && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = function(object, options) {
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return '';
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return encode(key, options) + '=' + encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&');
};
exports.parseUrl = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, _slicedToArray._)(splitOnFirst(url, '#'), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = function(object, options) {
    options = Object.assign((0, _defineProperty._)({
        encode: true,
        strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    return "".concat(url).concat(queryString).concat(hash);
};
exports.pick = function(input, filter, options) {
    options = Object.assign((0, _defineProperty._)({
        parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports_parseUrl = exports.parseUrl(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
        url: url,
        query: filterObject(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
exports.exclude = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
};

},{"@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_type_of":"668P4","5752d3663915398f":"ceQBv","4cbbda34882b91a3":"HC2Zh","53494decacb36d1b":"k3PcE","dfb8fa56cbbad4a5":"8pc8v"}],"ceQBv":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
        return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
    });
};

},{}],"HC2Zh":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + (typeof encodedURI === "undefined" ? "undefined" : (0, _typeOf._)(encodedURI)) + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{"@swc/helpers/_/_type_of":"668P4"}],"k3PcE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    var separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"8pc8v":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"27qTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var clickstream_url = 'https://81z7p60ky4.execute-api.us-east-1.amazonaws.com/prod/stream';
var ClickstreamService = {
    push: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(uid, sid, eventId, eventData, eventTarget) {
            var payload;
            return (0, _tsGenerator._)(this, function(_state) {
                payload = {
                    "Data": {
                        "timestamp": (0, _momentDefault.default)().toISOString(),
                        "user_id": uid,
                        "device": window.navigator.userAgent,
                        "app_id": "TRiA 2",
                        "event_id": eventId,
                        "event_target": eventTarget,
                        "event_data_json": JSON.stringify(eventData),
                        "session_id": sid
                    },
                    "PartitionKey": 1
                };
                //fire and forget
                (0, _axiosDefault.default).put(clickstream_url, payload);
                return [
                    2
                ];
            });
        });
        return function(uid, sid, eventId, eventData, eventTarget) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = ClickstreamService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","moment":"3xZWN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"41c0t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _useAsyncEffect = require("../../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var _reactstrap = require("reactstrap");
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var ContactDashboard = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), dynamicContacts = _useState[0], setDynamicContacts = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), staticContacts = _useState1[0], setStaticContacts = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(true), 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isError = _useState3[0], setIsError = _useState3[1];
    var source = (0, _axiosDefault.default).CancelToken.source();
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var contacts, contactTypes, dynamicContacts, staticFilteredTypes, staticContacts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contact, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getParamData({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        contacts = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        // Only get contacts with these titles
                        contactTypes = [
                            'TAM',
                            'Account Manager',
                            'Customer Success Manager'
                        ];
                        dynamicContacts = contacts.dynamic.response.data.customer_account_agents;
                        dynamicContacts = dynamicContacts.filter(function(contact) {
                            return contactTypes.includes(contact['agent_type']['name']);
                        });
                        // Filter out these titles, feedback was they are redundant
                        staticFilteredTypes = [
                            'Sales Questions',
                            'Technical Support'
                        ];
                        staticContacts = contacts.static;
                        staticContacts = staticContacts.filter(function(contact) {
                            return !staticFilteredTypes.includes(contact.title);
                        });
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // Find Connectria Helpdesk and change to Command Center
                            for(_iterator = staticContacts[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                contact = _step.value;
                                if (contact.title == "Connectria Helpdesk") {
                                    contact.title = "Connectria Command Center";
                                    contact.name = "Command Center";
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        setDynamicContacts(dynamicContacts);
                        setStaticContacts(staticContacts);
                        setIsLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _axiosDefault.default).isCancel(error)) console.log(error);
                        else {
                            console.log(error);
                            setIsError(true);
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: "fas fa-spinner m-3 mt-4 fa-spin",
                    style: {
                        fontSize: '30px'
                    }
                })
            }),
            !isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "row",
                children: [
                    dynamicContacts.map(function(contact, i) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactCard, {
                            title: contact['agent_type']['name'] + (contact['customer_service_primary'] === true ? " - Primary Contact" : ""),
                            phone: [
                                contact['user']['phone']
                            ],
                            email: contact['user']['email'],
                            name: contact['user']['fname'] + ' ' + contact['user']['surname']
                        }, i);
                    }),
                    staticContacts.map(function(contact, i) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactCard, {
                            title: contact.title,
                            phone: contact.phone,
                            email: contact.email,
                            name: contact.name
                        }, i);
                    })
                ]
            })
        ]
    });
};
var ContactCard = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "col-md-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
            className: "card-minimal",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardHeader), {
                    className: "card-header-minimal",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardTitle), {
                        className: "card-title-minimal",
                        tag: "h3",
                        children: props.title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
                    children: [
                        props.name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-4 font-weight-bold",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-md-8 pl-3",
                                    children: props.name
                                })
                            ]
                        }),
                        props.phone.map(function(number, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "col-4 font-weight-bold",
                                        children: "Phone"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "col-md-8 pl-3",
                                        children: number
                                    })
                                ]
                            }, i);
                        }),
                        props.email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-4 font-weight-bold",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-md-8 pl-3",
                                    children: props.email
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = ContactDashboard;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","axios":"ebRwi","../../utility/use-async-effect":"fShZN","reactstrap":"774RE","../../services/ConnectriaTicketsService":"l5X0I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"03bSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _appState = require("../../AppState");
var _enum = require("../../utility/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _featureToggle = require("../../utility/FeatureToggle");
var _featureToggleDefault = parcelHelpers.interopDefault(_featureToggle);
var _miscJsx = require("../../components/misc.jsx");
var _clickstream = require("../Clickstream/Clickstream");
var _userService = require("../../services/UserService");
var _userServiceDefault = parcelHelpers.interopDefault(_userService);
var _cookieService = require("../../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _organizationService = require("../../services/OrganizationService");
var _organizationServiceDefault = parcelHelpers.interopDefault(_organizationService);
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var _cognitoAuth = require("../../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _config = require("../../config");
var Sidebar = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, routes = param.routes;
    var _stateApp_userInfo, _stateApp_organizations, _stateApp_organization, _stateApp_organizations1, _stateApp_userInfo1;
    var menuRef = (0, _react.useRef)();
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), visibleGroups = _useState[0], setVisibleGroups = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), showOrgDropdown = _useState1[0], setShowOrgDropdown = _useState1[1];
    var handleOutsideClick = function(e) {
        var menu = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current;
        if (isOpen && menu && !menu.contains(e.target)) toggleSidebar(false);
    };
    var toggleSidebar = function() {
        // toggle the side bar open/closed
        setIsOpen(!isOpen);
    };
    var onLinkClick = function(isIframe) {
        // Reload the iframe so it goes back to the original legacy page
        if (isIframe) {
            var iframe = document.getElementById('legacyFrame');
            if (iframe) iframe.src = iframe.src;
        }
        // Anytime an internal link is clicked, close the sidebar
        setIsOpen(false);
        setVisibleGroups([]);
    };
    var onGroupClick = function(group) {
        // Ensure the sidebar is open when clicking on a group
        setIsOpen(true);
        // If the group is already open, close it. Otherwise, open it
        visibleGroups.includes(group) ? setVisibleGroups((0, _toConsumableArray._)(visibleGroups.filter(function(g) {
            return g != group;
        }))) : setVisibleGroups((0, _toConsumableArray._)(visibleGroups).concat([
            group
        ]));
    };
    var toggleOrgDropdown = function() {
        var _stateApp_organizations;
        // Show the org list and search input if the user is a domain admin and there are multiple orgs to search for
        if (((_stateApp_organizations = stateApp.organizations) === null || _stateApp_organizations === void 0 ? void 0 : _stateApp_organizations.length) > 1) setShowOrgDropdown(!showOrgDropdown);
    };
    (0, _react.useEffect)(function() {
        // add when mounted
        document.addEventListener('mousedown', handleOutsideClick);
        // return function to be called when unmounted
        return function() {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    (0, _react.useEffect)(function() {
        // Ensure all groups and the org search list are closed when the sidebar closes
        if (!isOpen) {
            setVisibleGroups([]);
            setShowOrgDropdown(false);
        }
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(function() {
        if (showOrgDropdown) document.getElementById('org-search-input').focus();
    }, [
        showOrgDropdown
    ]);
    // Routes going outside of TRiA
    // Cannot put in routes.js becuase we need stateApp for the skylift link
    var externalToolsRouteGroup = {
        group: 'Settings & Portals',
        envs: [
            (0, _enumDefault.default).Env.ALL
        ],
        clouds: [
            (0, _enumDefault.default).CloudCategory.ALL
        ],
        icon: 'fal fa-cog',
        routes: [
            {
                url: 'https://www.mh.connectria.com',
                name: 'Portal',
                envs: [
                    (0, _enumDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumDefault.default).CloudCategory.ALL
                ],
                icon: 'fal fa-external-link-alt',
                isExternal: true,
                clickstreamMeta: {
                    event_id: 'clicked',
                    event_target: 'portal',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            }
        ].concat((0, _toConsumableArray._)(stateApp.portalCustomerMeta.tria_show_skylift_link === 'TRUE' ? [
            {
                url: 'https://apps.connectria.com',
                name: 'Sky-Lift',
                envs: [
                    (0, _enumDefault.default).Env.ALL
                ],
                clouds: [
                    (0, _enumDefault.default).CloudCategory.ALL
                ],
                icon: 'fal fa-external-link-alt',
                isExternal: true,
                clickstreamMeta: {
                    event_id: 'clicked',
                    event_target: 'skylift',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            }
        ] : []), [
            {
                url: 'https://dev.tria.connectria.com',
                name: 'TRiA Legacy',
                envs: [
                    (0, _enumDefault.default).Env.DEV
                ],
                clouds: [
                    (0, _enumDefault.default).CloudCategory.ALL
                ],
                rtlName: "\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629",
                icon: 'fal fa-external-link-alt',
                isExternal: true,
                clickstreamMeta: {
                    event_id: 'clicked',
                    event_target: 'tria-legacy',
                    event_data: {
                        category: 'tria',
                        source: 'sidebar'
                    }
                }
            }
        ])
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // change suppress flag by resource property value
        for(var _iterator = routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var route = _step.value;
            if (route.resourceProperty !== undefined) {
                var key = route.resourceProperty.toLowerCase();
                var value = stateApp.resourceProperties[key] || '';
                route.suppress = !!!(parseInt(value) || value === 'true');
            }
            if (route.routes) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = route.routes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var subroute = _step1.value;
                        if (subroute.resourceProperty !== undefined) {
                            var key1 = subroute.resourceProperty.toLowerCase();
                            var value1 = stateApp.resourceProperties[key1] || '';
                            subroute.suppress = !!!(parseInt(value1) || value1 === 'true');
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Append the external links to the other routes
    var allRoutes = routes; // [...routes, externalToolsRouteGroup];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: menuRef,
        className: "left-sidebar ".concat(isOpen ? 'expanded' : '', " py-3"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "burger-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscJsx.HamburgerMenu), {
                    onClick: toggleSidebar
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "sidebar-thumbnail d-flex align-items-center my-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "burger-thumbnail d-flex align-items-center justify-content-center flex-shrink-0 text-uppercase",
                        role: "button",
                        children: (((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.name) || 'User').substr(0, 2)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: 'ml-2 slidable w-100' + (((_stateApp_organizations = stateApp.organizations) === null || _stateApp_organizations === void 0 ? void 0 : _stateApp_organizations.length) > 1 ? ' cursor' : ''),
                        onClick: toggleOrgDropdown,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-truncate text-dark mb-0",
                                        style: {
                                            maxWidth: '120px'
                                        },
                                        children: (_stateApp_organization = stateApp.organization) === null || _stateApp_organization === void 0 ? void 0 : _stateApp_organization.name
                                    }),
                                    ((_stateApp_organizations1 = stateApp.organizations) === null || _stateApp_organizations1 === void 0 ? void 0 : _stateApp_organizations1.length) > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-caret-down",
                                        style: {
                                            color: '#BFC5D2'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-truncate text-header m b small mb-0",
                                children: (_stateApp_userInfo1 = stateApp.userInfo) === null || _stateApp_userInfo1 === void 0 ? void 0 : _stateApp_userInfo1.name
                            })
                        ]
                    })
                ]
            }),
            showOrgDropdown ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrgList, {
                isOpen: showOrgDropdown,
                setSidebarOpen: setIsOpen
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allRoutes.map(function(r, key) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                            children: r.group ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteGroup, (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                                isOpen: visibleGroups.includes(r.group),
                                onGroupClick: onGroupClick,
                                onLinkClick: onLinkClick
                            })) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteLink, (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                                onLinkClick: onLinkClick,
                                linkIcon: r.icon
                            }))
                        }, key);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(LogoutNavLink, {
                        toggleSidebar: toggleSidebar
                    })
                ]
            })
        ]
    });
};
Sidebar.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleSidebar: (0, _propTypesDefault.default).func
};
var OrgList = function(param) {
    var isOpen = param.isOpen, setSidebarOpen = param.setSidebarOpen;
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var history = (0, _reactRouterDom.useHistory)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(stateApp.organizations), 2), orgs = _useState[0], setOrgs = _useState[1];
    var switchOrg = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(org) {
            var divvySession;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, _cognitoAuthDefault.default).setOrganizationCookie(org);
                        if (!stateApp.superAdmin) return [
                            3,
                            3
                        ];
                        divvySession = (0, _cognitoAuthDefault.default).getDivvyCookie();
                        if (!divvySession) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _organizationServiceDefault.default).switchOrganization(org.customer_id, divvySession)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        (0, _cognitoAuthDefault.default).deleteDivvyCookies();
                        _state.label = 4;
                    case 4:
                        (0, _cookieServiceDefault.default).eraseCookie('show_skylift', '/');
                        stateAppActions.setReload();
                        setSidebarOpen(false);
                        history.push('/');
                        stateAppActions.setCache({
                            key: 'costSavings',
                            data: [],
                            loading: true
                        });
                        (0, _connectriaTicketsService._removeCachedUsers)();
                        return [
                            2
                        ];
                }
            });
        });
        return function switchOrg(org) {
            return _ref.apply(this, arguments);
        };
    }();
    var searchOrgs = function(e) {
        var keyword = e.target.value;
        keyword ? setOrgs(stateApp.organizations.filter(function(org) {
            return (org.name || '').toLowerCase().includes(keyword.toLowerCase());
        })) : setOrgs(stateApp.organizations);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "org-list-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "search-input-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        id: "org-search-input",
                        type: "text",
                        className: "search-input",
                        onChange: searchOrgs,
                        placeholder: "Search"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        className: "fal fa-search"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: orgs.map(function(org, key) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "sidebar-item",
                        role: "button",
                        onClick: function() {
                            return switchOrg(org);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "sidebar-item-text slidable text-truncate",
                            children: org.name
                        })
                    }, key);
                })
            })
        ]
    });
};
var RouteGroup = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    // Determines whether the group should be highlighted or not
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isActive = _useState[0], setIsActive = _useState[1];
    // Get information about the current url the user is at
    var match = (0, _reactRouterDom.useRouteMatch)();
    (0, _react.useEffect)(function() {
        var routeUrls = props.routes.map(function(r) {
            return r.layout + r.path;
        });
        // If the group is not open and the current route is inside this group, highlight it
        // If the group is open and the route matches, page will be highlighted
        if (!props.isOpen && routeUrls.includes(match.url)) setIsActive(true);
        else setIsActive(false);
    }, [
        props.isOpen,
        match
    ]);
    if (props.roles) {
        var _stateApp_userInfo, _stateApp_userInfo1;
        var orgAdminCanSee = props.roles.includes((0, _enumDefault.default).Roles.orgAdmin) && ((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.orgAdmin), superAdminCanSee = props.roles.includes((0, _enumDefault.default).Roles.superAdmin) && ((_stateApp_userInfo1 = stateApp.userInfo) === null || _stateApp_userInfo1 === void 0 ? void 0 : _stateApp_userInfo1.superAdmin);
        if (!(orgAdminCanSee || superAdminCanSee)) return null;
    }
    // hide menu group
    if (props.suppress) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _featureToggleDefault.default), {
        policies: (props === null || props === void 0 ? void 0 : props.policy) || [],
        envs: props.envs,
        clouds: props.clouds,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarItem, {
                linkIcon: props.icon,
                name: props.group,
                onClick: function() {
                    props.onGroupClick(props.group);
                },
                className: isActive ? 'active-link' : ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Collapse), {
                isOpen: props.isOpen,
                children: props.routes.map(function(r, key) {
                    if (r.redirect || r.suppress) return null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RouteLink, (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                            onLinkClick: props.onLinkClick
                        }))
                    }, key);
                })
            })
        ]
    });
};
var RouteLink = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    if (props.redirect || props.suppress) return null;
    if (props.roles) {
        var _stateApp_userInfo, _stateApp_userInfo1;
        var orgAdminCanSee = props.roles.includes((0, _enumDefault.default).Roles.orgAdmin) && ((_stateApp_userInfo = stateApp.userInfo) === null || _stateApp_userInfo === void 0 ? void 0 : _stateApp_userInfo.orgAdmin), superAdminCanSee = props.roles.includes((0, _enumDefault.default).Roles.superAdmin) && ((_stateApp_userInfo1 = stateApp.userInfo) === null || _stateApp_userInfo1 === void 0 ? void 0 : _stateApp_userInfo1.superAdmin);
        if (!(orgAdminCanSee || superAdminCanSee)) return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureToggleDefault.default), {
        policies: (props === null || props === void 0 ? void 0 : props.policy) || [],
        envs: props.envs,
        clouds: props.clouds,
        integrations: props.integrations,
        children: props.isExternal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExternalRouteLink, {
            url: props.url,
            name: props.name,
            linkIcon: props.linkIcon,
            routeClickstreamMeta: props.clickstreamMeta
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalRouteLink, {
            layout: props.layout,
            path: props.path,
            name: props.name,
            onLinkClick: props.onLinkClick,
            linkIcon: props.linkIcon,
            isIframe: props.iframe
        })
    });
};
var SidebarItem = function(_param) {
    var linkIcon = _param.linkIcon, name = _param.name, onClick = _param.onClick, props = (0, _objectWithoutProperties._)(_param, [
        "linkIcon",
        "name",
        "onClick"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: 'sidebar-item ' + (props.className || ''),
        role: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sidebar-item-icon",
                children: linkIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    className: linkIcon
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "sidebar-item-text slidable",
                children: name
            })
        ]
    });
};
var InternalRouteLink = function(param) {
    var layout = param.layout, path = param.path, name = param.name, onLinkClick = param.onLinkClick, linkIcon = param.linkIcon, isIframe = param.isIframe;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
        to: layout + path,
        activeClassName: "active-link",
        onClick: function() {
            onLinkClick(isIframe);
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarItem, {
            linkIcon: linkIcon,
            name: name
        })
    });
};
var ExternalRouteLink = function(param) {
    var url = param.url, name = param.name, linkIcon = param.linkIcon, routeClickstreamMeta = param.routeClickstreamMeta;
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var clickstreamPushForExternalLink = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(clickstreamMeta) {
            var clickedMeta;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!clickstreamMeta) return [
                            3,
                            2
                        ];
                        clickedMeta = {
                            event_id: 'clicked',
                            event_target: clickstreamMeta.event_target,
                            event_data: clickstreamMeta.event_data
                        };
                        clickedMeta.event_data['source'] = 'sidebar';
                        return [
                            4,
                            (0, _clickstream.ClickstreamPush)(stateApp, clickedMeta)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function clickstreamPushForExternalLink(clickstreamMeta) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: url,
        onClick: function() {
            clickstreamPushForExternalLink(routeClickstreamMeta);
        },
        target: "_blank",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarItem, {
            linkIcon: linkIcon,
            name: name
        })
    });
};
var LogoutNavLink = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var logout = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(e) {
            var error, cookieDomain;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) e.preventDefault();
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).logout()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0, _clickstream.ClickstreamPush)(stateApp, {
                                event_id: 'clicked',
                                event_target: 'logout',
                                event_data: {
                                    category: 'tria'
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            (0, _userServiceDefault.default).logout()
                        ];
                    case 4:
                        _state.sent();
                        props.toggleSidebar();
                        (0, _connectriaTicketsService._removeCachedTicketHistory)();
                        (0, _connectriaTicketsService._removeCachedUsers)();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.log('Error logout', error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        cookieDomain = (0, _cookieServiceDefault.default).getCookieDomain(stateApp.env);
                        (0, _cookieServiceDefault.default).eraseCookie('session_id', '/', cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie('session_timeout_time', '/', cookieDomain);
                        (0, _cookieServiceDefault.default).eraseCookie('show_skylift', '/', cookieDomain);
                        stateAppActions.setLogout();
                        window.location.href = (0, _config.ACCOUNTS_URL) + '/sign-in?next=' + window.location.href;
                        return [
                            2
                        ];
                }
            });
        });
        return function logout(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        onClick: logout,
        style: {
            cursor: 'pointer'
        },
        href: '#',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarItem, {
            linkIcon: "far fa-power-off",
            name: "Logout"
        })
    });
};
exports.default = Sidebar;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_object_without_properties":"jGp91","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","prop-types":"3KNJy","reactstrap":"774RE","../../AppState":"8UGXH","../../utility/enum":"3A9fW","../../utility/FeatureToggle":"2vty2","../../components/misc.jsx":"5OQBQ","../Clickstream/Clickstream":"9i4UV","../../services/UserService":"4Rf9v","../../services/CookieService":"iKLPT","../../services/OrganizationService":"e5ygN","../../services/ConnectriaTicketsService":"l5X0I","../../utility/CognitoAuth":"cngmx","../../config":"kQzX9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6XZur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bodyScrollLock = require("body-scroll-lock");
var _reactstrap = require("reactstrap");
var _connectriaTicketsService = require("../../services/ConnectriaTicketsService");
var bladeElementId;
function _hideBlade(props) {
    props.setBladeState({
        visible: false
    });
    (0, _bodyScrollLock.enableBodyScroll)(bladeElementId);
    removeCachedData();
}
function removeCachedData() {
    (0, _connectriaTicketsService._removeCachedTicketHistory)();
}
var Blade = function(props) {
    (0, _react.useEffect)(function() {
        bladeElementId = document.querySelector("#blade-panel");
    }, []);
    (0, _react.useEffect)(function() {
        if (props.visible) (0, _bodyScrollLock.disableBodyScroll)(bladeElementId);
        else (0, _bodyScrollLock.enableBodyScroll)(bladeElementId);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                onClick: function() {
                    return _hideBlade(props);
                },
                className: props.visible ? "blade-backdrop" : "d-none"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: props.visible ? "blade-panel blade-panel--is-visible" : "blade-panel",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "blade-panel-container",
                    id: "app-blade",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "blade-panel-header d-flex",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "w-100",
                                    children: props.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                    className: "btn btn-link blade-panel-close-button",
                                    onClick: function() {
                                        return _hideBlade(props);
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "tim-icons icon-simple-remove"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "blade-panel-content",
                            children: props.children
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = Blade;

},{"react/jsx-runtime":"1elNt","react":"gVheC","body-scroll-lock":"9nYps","reactstrap":"774RE","../../services/ConnectriaTicketsService":"l5X0I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9nYps":[function(require,module,exports,__globalThis) {
!function(e, t) {
    if ("function" == typeof define && define.amd) define([
        "exports"
    ], t);
    else {
        var o;
        t(exports);
    }
}(this, function(exports1) {
    "use strict";
    function i(e) {
        if (Array.isArray(e)) {
            for(var t = 0, o = Array(e.length); t < e.length; t++)o[t] = e[t];
            return o;
        }
        return Array.from(e);
    }
    Object.defineProperty(exports1, "__esModule", {
        value: !0
    });
    var l = !1;
    if ("undefined" != typeof window) {
        var e = {
            get passive () {
                l = !0;
            }
        };
        window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
    }
    function d(t) {
        return u.some(function(e) {
            return !(!e.options.allowTouchMove || !e.options.allowTouchMove(t));
        });
    }
    function c(e) {
        var t = e || window.event;
        return !!d(t.target) || 1 < t.touches.length || (t.preventDefault && t.preventDefault(), !1);
    }
    function o() {
        setTimeout(function() {
            void 0 !== m && (document.body.style.paddingRight = m, m = void 0), void 0 !== f && (document.body.style.overflow = f, f = void 0);
        });
    }
    var a = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), u = [], s = !1, v = -1, f = void 0, m = void 0;
    exports1.disableBodyScroll = function(r, e) {
        if (a) {
            if (!r) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            if (r && !u.some(function(e) {
                return e.targetElement === r;
            })) {
                var t = {
                    targetElement: r,
                    options: e || {}
                };
                u = [].concat(i(u), [
                    t
                ]), r.ontouchstart = function(e) {
                    1 === e.targetTouches.length && (v = e.targetTouches[0].clientY);
                }, r.ontouchmove = function(e) {
                    var t, o, n, _$i;
                    1 === e.targetTouches.length && (o = r, _$i = (t = e).targetTouches[0].clientY - v, d(t.target) || (o && 0 === o.scrollTop && 0 < _$i || (n = o) && n.scrollHeight - n.scrollTop <= n.clientHeight && _$i < 0 ? c(t) : t.stopPropagation()));
                }, s || (document.addEventListener("touchmove", c, l ? {
                    passive: !1
                } : void 0), s = !0);
            }
        } else {
            n = e, setTimeout(function() {
                if (void 0 === m) {
                    var _$e = !!n && !0 === n.reserveScrollBarGap, t = window.innerWidth - document.documentElement.clientWidth;
                    _$e && 0 < t && (m = document.body.style.paddingRight, document.body.style.paddingRight = t + "px");
                }
                void 0 === f && (f = document.body.style.overflow, document.body.style.overflow = "hidden");
            });
            var o = {
                targetElement: r,
                options: e || {}
            };
            u = [].concat(i(u), [
                o
            ]);
        }
        var n;
    }, exports1.clearAllBodyScrollLocks = function() {
        a ? (u.forEach(function(e) {
            e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null;
        }), s && (document.removeEventListener("touchmove", c, l ? {
            passive: !1
        } : void 0), s = !1), u = [], v = -1) : (o(), u = []);
    }, exports1.enableBodyScroll = function(t) {
        if (a) {
            if (!t) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            t.ontouchstart = null, t.ontouchmove = null, u = u.filter(function(e) {
                return e.targetElement !== t;
            }), s && 0 === u.length && (document.removeEventListener("touchmove", c, l ? {
                passive: !1
            } : void 0), s = !1);
        } else (u = u.filter(function(e) {
            return e.targetElement !== t;
        })).length || o();
    };
});

},{}],"avrIg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _truncate = require("lodash/truncate");
var _truncateDefault = parcelHelpers.interopDefault(_truncate);
var _componnents = require("./componnents");
var _domHook = require("../../hooks/DomHook");
var _appState = require("../../AppState");
var _socketHook = require("../../hooks/SocketHook");
var NotificationsFeed = function(param) {
    var onToggle = param.onToggle;
    var _stateApp_notifications_list, _stateApp_notifications;
    var wrapperRef = (0, _react.useRef)(null);
    var history = (0, _reactRouterDom.useHistory)();
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _domHook.useOutsideClick)(wrapperRef, onToggle);
    var handleSocketMessage = (0, _react.useCallback)(function(message) {
        console.log('new message on sidebar feed: ', message);
        if (message.type === 'feed') stateAppActions.setNotificationsList(message.data);
    }, []);
    var _useSocket = (0, _socketHook.useSocket)(), isOpen = _useSocket.isOpen, sendSocketMessage = _useSocket.send, addMessageHandler = _useSocket.addMessageHandler, removeMessageHandler = _useSocket.removeMessageHandler;
    var onClickItem = function(alert) {
        history.push({
            pathname: '/app/notifications',
            state: {
                targetEvent: alert.event_id
            }
        });
        onToggle();
    };
    (0, _react.useEffect)(function() {
        addMessageHandler('feed', handleSocketMessage);
        return function() {
            removeMessageHandler('feed');
        };
    }, [
        handleSocketMessage,
        addMessageHandler,
        removeMessageHandler
    ]);
    (0, _react.useEffect)(function() {
        if (isOpen) {
            console.log('sending feed message...');
            sendSocketMessage({
                action: 'feed'
            });
        }
    }, [
        isOpen,
        sendSocketMessage
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tria-notifications",
        ref: wrapperRef,
        children: [
            (_stateApp_notifications = stateApp.notifications) === null || _stateApp_notifications === void 0 ? void 0 : (_stateApp_notifications_list = _stateApp_notifications.list) === null || _stateApp_notifications_list === void 0 ? void 0 : _stateApp_notifications_list.map(function(alert) {
                var _alert_style;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "tria-card border-top border-secondary cursor my-0",
                    onClick: function() {
                        return onClickItem(alert);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tria-card-body d-flex align-items-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _componnents.AlertSymbol), {
                                className: "mt-4",
                                icon: (_alert_style = alert.style) === null || _alert_style === void 0 ? void 0 : _alert_style.icon,
                                category: alert.event_category,
                                dense: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ml-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "encode-sans-12 text-header text-uppercase font-weight-normal mb-1",
                                        children: alert.event_category === 'Billing Event' ? alert.event_category : alert.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "roboto-15 text-dark",
                                        children: (0, _truncateDefault.default)(alert.description, {
                                            length: 100
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "helvetica-12 text-header",
                                        children: (0, _momentDefault.default)(alert.timestamp).fromNow()
                                    })
                                ]
                            })
                        ]
                    })
                }, alert.event_id);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tria-card border-top border-secondary text-center my-0 py-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/app/notifications",
                    className: "text-blue",
                    onClick: onToggle,
                    children: "View All Notifications"
                })
            })
        ]
    });
};
NotificationsFeed.propTypes = {
    onToggle: (0, _propTypesDefault.default).func
};
exports.default = NotificationsFeed;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","react-router-dom":"acq4R","moment":"3xZWN","lodash/truncate":"aD1qE","./componnents":"icHxk","../../hooks/DomHook":"fPAyt","../../AppState":"8UGXH","../../hooks/SocketHook":"fve0v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aD1qE":[function(require,module,exports,__globalThis) {
var baseToString = require("889029e8b91e6c55"), castSlice = require("a58b0b3e0146e4ff"), hasUnicode = require("70fca84c4eb77428"), isObject = require("4e45dce5ee93d519"), isRegExp = require("24e9eba2b027c997"), stringSize = require("914dd9a5b789704c"), stringToArray = require("84927f60d67c77a3"), toInteger = require("61927f737df8ab09"), toString = require("c2845b32c3f77871");
/** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function truncate(string, options) {
    var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
    if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
    }
    string = toString(string);
    var strLength = string.length;
    if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - stringSize(omission);
    if (end < 1) return omission;
    var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = truncate;

},{"889029e8b91e6c55":"33R5Z","a58b0b3e0146e4ff":"lThjH","70fca84c4eb77428":"9QNhN","4e45dce5ee93d519":"8ffGS","24e9eba2b027c997":"dY2uq","914dd9a5b789704c":"2g6jO","84927f60d67c77a3":"8X6PW","61927f737df8ab09":"fVns0","c2845b32c3f77871":"23Zly"}],"2g6jO":[function(require,module,exports,__globalThis) {
var asciiSize = require("e059612a0c57b006"), hasUnicode = require("47804eb9cd4baae7"), unicodeSize = require("ed6324400286f1de");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
module.exports = stringSize;

},{"e059612a0c57b006":"9r8uE","47804eb9cd4baae7":"9QNhN","ed6324400286f1de":"7OtuI"}],"9r8uE":[function(require,module,exports,__globalThis) {
var baseProperty = require("915f17501141a880");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var asciiSize = baseProperty('length');
module.exports = asciiSize;

},{"915f17501141a880":"4T5ep"}],"7OtuI":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while(reUnicode.test(string))++result;
    return result;
}
module.exports = unicodeSize;

},{}],"fPAyt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook that alerts clicks outside of the passed ref
 */ parcelHelpers.export(exports, "useOutsideClick", function() {
    return useOutsideClick;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useOutsideClick(ref, handler) {
    (0, _react.useEffect)(function() {
        /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target) && handler) handler(event);
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fve0v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "socket_api", function() {
    return socket_api;
});
parcelHelpers.export(exports, "useSocket", function() {
    return useSocket;
});
parcelHelpers.export(exports, "useProvideSocket", function() {
    return useProvideSocket;
});
parcelHelpers.export(exports, "SocketProvider", function() {
    return SocketProvider;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _omit = require("ramda/src/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _appState = require("../AppState");
var _cognitoAuth = require("../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var socket_api = 'wss://axf0zigbuk.execute-api.us-east-1.amazonaws.com/prod';
/**
 * Hook that manage websockets
 */ var socketContext = /*#__PURE__*/ (0, _react.createContext)();
var useSocket = function() {
    return (0, _react.useContext)(socketContext);
};
function useProvideSocket() {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 1), stateApp = _appState1[0];
    var ws = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(0), 2), retryCount = _useState1[0], setRetryCount = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)({}), 2), callbacks = _useState2[0], setCallbacks = _useState2[1];
    var onSocketClose = (0, _react.useCallback)(function(e) {
        // console.log('=== closing socket...', retryCount, ws.current);
        setIsOpen(false);
        if (ws.current && retryCount < 5) {
            // console.log('=== socket closed. reconnecting...', e);
            connect();
            setRetryCount(function(c) {
                return c + 1;
            });
        }
    }, [
        retryCount
    ]);
    var onSocketMessage = (0, _react.useCallback)(function(res) {
        try {
            console.log('socket message: ', res, callbacks);
            var msg = JSON.parse(res.data);
            if (msg) {
                for(var source in callbacks)if (typeof callbacks[source] === 'function') callbacks[source](msg);
            }
        } catch (e) {
            console.error('original payload', res.data);
            console.error(e);
        }
    }, [
        callbacks
    ]);
    var connect = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function() {
            var _ws_current, token;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!ws.current || ((_ws_current = ws.current) === null || _ws_current === void 0 ? void 0 : _ws_current.readyState) !== 1)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getIdToken()
                        ];
                    case 1:
                        token = _state.sent();
                        ws.current = new WebSocket("".concat(socket_api, "?org_id=").concat((0, _cookieServiceDefault.default).getCookie('OrganizationId'), "&token=").concat(token));
                        ws.current.onopen = function(e) {
                            if (ws.current) {
                                console.log('=== socket opened ===', e, ws.current.readyState);
                                setIsOpen(ws.current.readyState === 1);
                                setRetryCount(0);
                            }
                        };
                        ws.current.onclose = onSocketClose;
                        ws.current.onerror = function(e) {
                            console.log('=== Socket connection error. retrying to connect in 5s', e);
                            setTimeout(function() {
                            // ws.current.close();
                            }, 5000);
                        };
                        ws.current.onmessage = onSocketMessage;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function connect() {
            return _ref.apply(this, arguments);
        };
    }();
    var disconnect = function() {
        console.log('disconnecting the websocket... ');
        ws.current.close();
        ws.current = null;
    };
    var send = (0, _react.useCallback)(function(data) {
        if (ws.current && isOpen) ws.current.send(JSON.stringify(data));
    }, [
        ws,
        isOpen
    ]);
    var addMessageHandler = (0, _react.useCallback)(function(source, cb) {
        return setCallbacks(function(cs) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, cs), (0, _defineProperty._)({}, source, cb));
        });
    }, []);
    var removeMessageHandler = (0, _react.useCallback)(function(source) {
        return setCallbacks(function(cs) {
            return (0, _omitDefault.default)([
                source
            ], cs);
        });
    }, []);
    (0, _react.useEffect)(function() {
        if (ws.current) ws.current.onmessage = onSocketMessage;
    }, [
        ws,
        onSocketMessage
    ]);
    (0, _react.useEffect)(function() {
        if (ws.current) ws.current.onclose = onSocketClose;
    }, [
        ws,
        onSocketClose
    ]);
    return {
        isOpen: isOpen,
        connect: connect,
        disconnect: disconnect,
        send: send,
        addMessageHandler: addMessageHandler,
        removeMessageHandler: removeMessageHandler
    };
}
var SocketProvider = function(param) {
    var children = param.children;
    var socket = useProvideSocket();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(socketContext.Provider, {
        value: socket,
        children: children
    });
};

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_define_property":"4QmId","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","ramda/src/omit":"12Qqu","../services/CookieService":"iKLPT","../AppState":"8UGXH","../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"12Qqu":[function(require,module,exports,__globalThis) {
var _curry2 = /*#__PURE__*/ require("7be39dbcadb5397");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var omit = /*#__PURE__*/ _curry2(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
module.exports = omit;

},{"7be39dbcadb5397":"4s7GP"}],"4s7GP":[function(require,module,exports,__globalThis) {
var _curry1 = /*#__PURE__*/ require("5d81ba6725eb6e5a");
var _isPlaceholder = /*#__PURE__*/ require("45704e06c11545be");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return _isPlaceholder(a) ? f2 : _curry1(function(_b) {
                    return fn(a, _b);
                });
            default:
                return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function(_a) {
                    return fn(_a, b);
                }) : _isPlaceholder(b) ? _curry1(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = _curry2;

},{"5d81ba6725eb6e5a":"aBt5Q","45704e06c11545be":"h9Lig"}],"aBt5Q":[function(require,module,exports,__globalThis) {
var _isPlaceholder = /*#__PURE__*/ require("823fa2c75953ce67");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = _curry1;

},{"823fa2c75953ce67":"h9Lig"}],"h9Lig":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
function _isPlaceholder(a) {
    return a != null && (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;

},{"@swc/helpers/_/_type_of":"668P4"}],"3DAIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var NotFound = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "col-md-12 text-center",
            children: [
                window.location.href.indexOf('app/') > -1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        width: "80px",
                        style: {
                            paddingBottom: "10px",
                            paddingTop: "20px"
                        },
                        className: "mt-2 mb-2",
                        src: "data:image/png;base64,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"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "error-template",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "404 Page Not Found"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/",
                    children: "Go Back Home"
                })
            ]
        })
    });
};
exports.default = NotFound;

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uaDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var AppAlert = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.visible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "alert-app" + (props.visible ? '' : 'alert-hidden'),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledAlert), {
                className: "".concat(props.className),
                color: props.color,
                children: props.children
            })
        })
    });
};
exports.default = AppAlert;

},{"react/jsx-runtime":"1elNt","react":"gVheC","reactstrap":"774RE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bw1bb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../AppState");
var detect = require("26f3d5a0dbf868b").detect;
var SpoofBanner = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), showMsg = _useState[0], setShowMsg = _useState[1];
    var spoofEnv = "Production";
    var showSpoof = function(org_name) {
        if (org_name != "Default Organization" && (stateApp.userInfo || {}).domain_admin || false) return true;
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: showSpoof((stateApp.userInfo || {}).organization_name || '') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: stateApp.env == 'dev' ? 'alert-spoof-dev' : "alert-spoof alert",
            style: {
                padding: 0,
                paddingBottom: "10px",
                paddingTop: "10px"
            },
            role: "alert",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "h4 text-center",
                style: {
                    color: 'white',
                    marginBottom: 0
                },
                children: [
                    "You are viewing ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            fontWeight: 800,
                            fontSize: "1.2rem"
                        },
                        children: (stateApp.userInfo || {}).organization_name || ''
                    }),
                    " in ",
                    spoofEnv,
                    " as User ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            fontWeight: 800
                        },
                        children: stateApp.userInfo.username
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
    });
};
exports.default = SpoofBanner;

},{"@swc/helpers/_/_sliced_to_array":"byksX","react/jsx-runtime":"1elNt","react":"gVheC","26f3d5a0dbf868b":"9rtYB","../AppState":"8UGXH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4InhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appState = require("../AppState");
var _index = require("axios/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _useAsyncEffect = require("./use-async-effect");
var _connectriaTicketsService = require("../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var detect = require("4574c9e4ea337a20").detect;
var getStyle = function(item) {
    switch(item){
        case "INFO":
            return "alert-info";
        case "NOTICE":
            return "alert-notice";
        case "WARNING":
            return "alert-warning";
        case "OUTAGE":
            return "alert-outage";
        default:
            break;
    }
};
var ConnectriaAnnoucement = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), annoucments = _useState[0], setAnnoucments = _useState[1];
    var source = (0, _indexDefault.default).CancelToken.source();
    (0, _useAsyncEffect.useAsyncEffect)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            var annoucments, error;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _connectriaTicketsServiceDefault.default).getAnnoucments({
                                cancelToken: source.token
                            })
                        ];
                    case 1:
                        annoucments = _state.sent();
                        if (!isMounted()) return [
                            2
                        ];
                        setAnnoucments(annoucments.data);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if ((0, _indexDefault.default).isCancel(error)) ;
                        else throw error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {
        source.cancel();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (annoucments || []).length > 0 ? annoucments.map(function(item, i) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "alert-dismissible fade show alert " + getStyle(item.title),
                style: {
                    padding: 0,
                    paddingBottom: "10px",
                    paddingTop: "10px",
                    marginBottom: 0
                },
                role: "alert",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "h4 text-center",
                    style: {
                        color: "white",
                        marginBottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                            style: {
                                paddingRight: "3px"
                            },
                            children: [
                                item.title,
                                ":  "
                            ]
                        }),
                        "  ",
                        item.announcement
                    ]
                })
            });
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
    });
};
exports.default = ConnectriaAnnoucement;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","4574c9e4ea337a20":"9rtYB","../AppState":"8UGXH","axios/index":"ebRwi","./use-async-effect":"fShZN","../services/ConnectriaTicketsService":"l5X0I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"F0RVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var ContentBlade = function(param) {
    var visible = param.visible, className = param.className, headerClassName = param.headerClassName, side = param.side, noBackdrop = param.noBackdrop, title = param.title, children = param.children, footer = param.footer, setPanelState = param.setPanelState, style = param.style;
    return visible && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)('content-blade-backdrop', {
                    'no-backdrop': noBackdrop
                }),
                onClick: function() {
                    return setPanelState({
                        visible: false
                    });
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content-blade ".concat(className || ''),
                side: side || "left",
                style: style || null,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content-blade-header ".concat(headerClassName || ''),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "tria-card-title d-flex justify-content-between align-items-center flex-wrap",
                            children: title || ""
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content-blade-body",
                        children: children
                    }),
                    footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "tria-card-footer",
                        children: footer
                    })
                ]
            })
        ]
    });
};
ContentBlade.propTypes = {
    visible: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    headerClassName: (0, _propTypesDefault.default).string,
    side: (0, _propTypesDefault.default).string,
    noBackdrop: (0, _propTypesDefault.default).bool,
    title: (0, _propTypesDefault.default).node,
    children: (0, _propTypesDefault.default).node,
    footer: (0, _propTypesDefault.default).node,
    setPanelState: (0, _propTypesDefault.default).func,
    style: (0, _propTypesDefault.default).object
};
ContentBlade.defaultProps = {
    side: 'left',
    setPanelState: function() {}
};
exports.default = ContentBlade;

},{"react/jsx-runtime":"1elNt","react":"gVheC","prop-types":"3KNJy","classnames":"6P5cq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"21Lcc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _appState = require("../AppState");
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var PolicyToggle = function(props) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var user_roles = stateApp.roles_v2;
    var policy_codes = stateApp.policies;
    var hasPolicies = function() {
        var policies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (policies.length == 0) return true;
        if (user_roles.filter(function(e) {
            return e.RoleName == "OrgAdmin";
        }).length > 0) return true;
        if (stateApp.superAdmin) return true;
        for(var i = 0; i < policies.length; i++)if (!policy_codes.includes(policies[i])) {
            console.log('returnign false');
            return false;
        }
        return true;
    };
    var criteriaMet = function(policies) {
        return hasPolicies(policies);
    };
    return criteriaMet(props.policies) ? props.children : null;
};
exports.default = PolicyToggle;
function flatten(ary, prop) {
    var ret = [];
    for(var i = 0; i < ary.length; i++)if (Array.isArray(ary[i][prop])) ret = ret.concat(flatten(ary[i][prop], prop));
    else ret.push(ary[i]);
    return ret;
}

},{"@swc/helpers/_/_sliced_to_array":"byksX","../AppState":"8UGXH","./enum":"3A9fW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"epiwg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clickstreamService = require("../../services/ClickstreamService");
var _clickstreamServiceDefault = parcelHelpers.interopDefault(_clickstreamService);
var _appState = require("../../AppState");
var _cognitoAuth = require("../../utility/CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var useHeadScript = function(src, onLoad) {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    (0, _react.useEffect)(function() {
        // Check if the script is already present in the head
        var existingScript = document.head.querySelector('script[src="'.concat(src, '"]'));
        if (!existingScript) {
            var script = document.createElement('script');
            script.src = src;
            script.async = true;
            // Set the onload callback
            script.onload = onLoad;
            // Append script to the head
            document.head.appendChild(script);
            // Clean up the script on unmount
            return function() {
                document.head.removeChild(script);
            };
        } else // If the script is already loaded and the onLoad function is provided
        // we call it immediately.
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    }, [
        src,
        onLoad
    ]);
};
var CookieHubComponent = function() {
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var scriptUrl = 'https://cdn.cookiehub.eu/c2/57517c59.js';
    var handleScriptLoad = function() {
        // Define the callback methods
        var asyncFunction = /*#__PURE__*/ function() {
            var _ref = (0, _asyncToGenerator._)(function(event_id, eData, event_target) {
                var uid, sid, email, orgId, orgName, _stateApp_userInfo_user_id, _stateApp_userInfo_organization_id, t, event_id, event_target;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Your async code here
                            console.log('Running async operation');
                            uid = 0;
                            sid = "";
                            email = "";
                            orgId = "";
                            orgName = "";
                            if (stateApp.userInfo != null) {
                                ;
                                uid = (_stateApp_userInfo_user_id = stateApp.userInfo.user_id) !== null && _stateApp_userInfo_user_id !== void 0 ? _stateApp_userInfo_user_id : 0;
                                ;
                                orgId = (_stateApp_userInfo_organization_id = stateApp.userInfo.organization_id) !== null && _stateApp_userInfo_organization_id !== void 0 ? _stateApp_userInfo_organization_id : "";
                                orgName = stateApp.userInfo.organization_name != null ? stateApp.userInfo.organization_name.trim() : "";
                                email = stateApp.userInfo.email != null ? stateApp.userInfo.email : "";
                            }
                            return [
                                4,
                                (0, _cognitoAuthDefault.default).getAccessTokenDecoded()
                            ];
                        case 1:
                            t = _state.sent();
                            sid = t.jti || "Empty";
                            //default event data
                            event_id = event_id;
                            event_target = "cookies";
                            return [
                                4,
                                (0, _clickstreamServiceDefault.default).push(uid, sid, event_id, eData, event_target, email, orgId, orgName)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function asyncFunction(event_id, eData, event_target) {
                return _ref.apply(this, arguments);
            };
        }();
        var cpm = {
            onInitialise: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(status) {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.hasConsented('analytics')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    asyncFunction('analytics accepted', {
                                        action: 'consented',
                                        category: 'analytics'
                                    }, 'cookie-consent')
                                ];
                            case 1:
                                _state.sent();
                                console.log('The analytics category is allowed');
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(status) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onStatusChange: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(status, previousStatus) {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.hasConsented("analytics")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    asyncFunction("analytics consented ".concat(status), {
                                        action: 'consented',
                                        category: 'analytics'
                                    }, 'cookie-consent')
                                ];
                            case 1:
                                _state.sent();
                                console.log('The analytics category is allowed');
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(status, previousStatus) {
                    return _ref.apply(this, arguments);
                };
            }(),
            hasConsented: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(category) {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    asyncFunction("consented ".concat(category), {}, 'cookie-consent')
                                ];
                            case 1:
                                _state.sent();
                                if (category == 'analytics') console.log('The analytics category was just allowed');
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(category) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onAllow: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(category) {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    asyncFunction("allowed ".concat(category), {
                                        action: 'allowed',
                                        category: category
                                    }, 'cookie-consent')
                                ];
                            case 1:
                                _state.sent();
                                if (!(category == 'analytics')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    asyncFunction('analytics consented', {}, 'cookie-consent')
                                ];
                            case 2:
                                _state.sent();
                                console.log('The analytics category was just allowed');
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(category) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onRevoke: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(category) {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    asyncFunction("revoked ".concat(category), {
                                        action: 'revoked',
                                        category: category
                                    }, 'cookie-consent')
                                ];
                            case 1:
                                _state.sent();
                                if (!(category == 'analytics')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    asyncFunction('analytics revoked', {}, 'cookie-consent')
                                ];
                            case 2:
                                _state.sent();
                                console.log('The analytics category was just revoked');
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(category) {
                    return _ref.apply(this, arguments);
                };
            }()
        };
        if (window.cookiehub) window.cookiehub.load(cpm);
        else document.addEventListener("DOMContentLoaded", function() {
            window.cookiehub.load(cpm);
        });
    };
    useHeadScript(scriptUrl, handleScriptLoad);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
};
exports.default = CookieHubComponent;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../../services/ClickstreamService":"27qTH","../../AppState":"8UGXH","../../utility/CognitoAuth":"cngmx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kpn7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _cookieService = require("../services/CookieService");
var _cookieServiceDefault = parcelHelpers.interopDefault(_cookieService);
var _blueMatadorService = require("../services/BlueMatadorService");
var _blueMatadorServiceDefault = parcelHelpers.interopDefault(_blueMatadorService);
var _connectriaBackupService = require("../services/ConnectriaBackupService");
var _connectriaBackupServiceDefault = parcelHelpers.interopDefault(_connectriaBackupService);
var _connectriaTicketsService = require("../services/ConnectriaTicketsService");
var _connectriaTicketsServiceDefault = parcelHelpers.interopDefault(_connectriaTicketsService);
var _cloudWatchService = require("../services/CloudWatchService");
var _cloudWatchServiceDefault = parcelHelpers.interopDefault(_cloudWatchService);
var _trendMicroService = require("../services/TrendMicroService");
var _trendMicroServiceDefault = parcelHelpers.interopDefault(_trendMicroService);
var _portalService = require("../services/PortalService");
var _portalServiceDefault = parcelHelpers.interopDefault(_portalService);
var _enum = require("../utility/enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _appState = require("../AppState");
var _misc = require("../utility/misc");
var _misc1 = require("./misc");
var _ibmservice = require("../services/IBMService");
var _ibmserviceDefault = parcelHelpers.interopDefault(_ibmservice);
var _cognitoAuth = require("./CognitoAuth");
var _cognitoAuthDefault = parcelHelpers.interopDefault(_cognitoAuth);
var _config = require("../config");
var _policyRouteGuard = require("./PolicyRouteGuard");
var _policyRouteGuardDefault = parcelHelpers.interopDefault(_policyRouteGuard);
var _useQuery = require("../hooks/useQuery");
var _useQueryDefault = parcelHelpers.interopDefault(_useQuery);
function PrivateRoute(_param) {
    var Component = _param.component, rest = (0, _objectWithoutProperties._)(_param, [
        "component"
    ]);
    var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), inFlight = _useState[0], setInFlight = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _misc1.buildRurl)()), 1), rurl = _useState1[0];
    var urlQuery = (0, _useQueryDefault.default)();
    var _superAdmin = false;
    var _org = null;
    clearCookies();
    function determineClouds() {
        return _determineClouds.apply(this, arguments);
    }
    function _determineClouds() {
        _determineClouds = (0, _asyncToGenerator._)(function() {
            var orgId, ibmi, clouds, _roles_, _roles_1, roles, flat_policies, policy_codes, e, org, _org_, cloud_accounts, selected_org, types, i, clientGroupsRes;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        orgId = (0, _cookieServiceDefault.default).getCookie('OrganizationId');
                        ibmi = {
                            data: []
                        };
                        clouds = {
                            data: []
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getUserDetail()
                        ];
                    case 2:
                        clouds = _state.sent();
                        return [
                            4,
                            (0, _ibmserviceDefault.default).setup()
                        ];
                    case 3:
                        ibmi = _state.sent();
                        roles = clouds.detail.orgs.filter(function(e) {
                            return e.id == orgId;
                        });
                        flat_policies = flatten(((_roles_ = roles[0]) === null || _roles_ === void 0 ? void 0 : _roles_.roles_v2) || [], 'Policies');
                        policy_codes = flat_policies.map(function(e) {
                            return e.code;
                        });
                        stateAppActions.setPolicies(policy_codes);
                        stateAppActions.setRoles_v2(((_roles_1 = roles[0]) === null || _roles_1 === void 0 ? void 0 : _roles_1.roles_v2) || []);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        org = clouds.detail.orgs.filter(function(e) {
                            return e.id == orgId;
                        });
                        cloud_accounts = ((_org_ = org[0]) !== null && _org_ !== void 0 ? _org_ : {}).cloud_accounts || [];
                        if (!_superAdmin) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getOrganizationById((0, _cookieServiceDefault.default).getCookie('OrganizationId'))
                        ];
                    case 6:
                        selected_org = _state.sent();
                        cloud_accounts = [];
                        cloud_accounts = cloud_accounts.concat(selected_org.clouds);
                        _state.label = 7;
                    case 7:
                        types = [];
                        for(i = 0; i < cloud_accounts.length; i++){
                            if (cloud_accounts[i].cloud_type.includes('AWS')) {
                                types.push((0, _enumDefault.default).CloudCategory.AWS);
                                types.push((0, _enumDefault.default).CloudCategory.PUBLIC_CLOUD);
                            }
                            if (cloud_accounts[i].cloud_type.includes('AZURE')) {
                                types.push((0, _enumDefault.default).CloudCategory.AZURE);
                                types.push((0, _enumDefault.default).CloudCategory.PUBLIC_CLOUD);
                            }
                        }
                        return [
                            4,
                            (0, _connectriaBackupServiceDefault.default).getCommServeClientGroup()
                        ];
                    case 8:
                        clientGroupsRes = _state.sent();
                        if ((clientGroupsRes.data || []).length > 0) types.push((0, _enumDefault.default).CloudCategory.VMWARE);
                        if (orgId === '3e52ce4e-ced3-41c3-8499-803b227689c5') types.push((0, _enumDefault.default).CloudCategory.VMWARE);
                        if (ibmi.data.has_ibmi) types.push((0, _enumDefault.default).CloudCategory.IBMI);
                        stateAppActions.setClouds((0, _toConsumableArray._)(new Set(types)));
                        stateAppActions.setCloudAccounts(cloud_accounts.map(function(c) {
                            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, c), {
                                id: c.id,
                                cloud_type_id: c.cloud_type
                            });
                        }));
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve('resolved');
                            })
                        ];
                }
            });
        });
        return _determineClouds.apply(this, arguments);
    }
    function determineIntegrations() {
        return _determineIntegrations.apply(this, arguments);
    }
    function _determineIntegrations() {
        _determineIntegrations = (0, _asyncToGenerator._)(function() {
            var integrations, hasBlueMatador, ex, hasTrendMicro, ex1, cloudWatchAlarms, ex2;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        integrations = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, _blueMatadorServiceDefault.default).checkSetup()
                        ];
                    case 2:
                        hasBlueMatador = _state.sent();
                        if (hasBlueMatador.data.has_bluematador) integrations.push((0, _enumDefault.default).Integration.BLUEMATADOR);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            (0, _trendMicroServiceDefault.default).checkSetup()
                        ];
                    case 5:
                        hasTrendMicro = _state.sent();
                        if (hasTrendMicro.data.has_trendmicro) integrations.push((0, _enumDefault.default).Integration.TRENDMICRO);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        ex1 = _state.sent();
                        console.log(ex1);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        _state.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            (0, _cloudWatchServiceDefault.default).getAlarms([
                                'us-east-1',
                                'us-east-2'
                            ])
                        ];
                    case 8:
                        cloudWatchAlarms = _state.sent();
                        if (cloudWatchAlarms.data.clouds_alarms_list.length > 0) integrations.push((0, _enumDefault.default).Integration.CLOUDWATCH);
                        return [
                            3,
                            10
                        ];
                    case 9:
                        ex2 = _state.sent();
                        console.log(ex2);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        stateAppActions.setIntegrations(integrations);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve('resolved');
                            })
                        ];
                }
            });
        });
        return _determineIntegrations.apply(this, arguments);
    }
    function determineSkyLiftLink() {
        return _determineSkyLiftLink.apply(this, arguments);
    }
    function _determineSkyLiftLink() {
        _determineSkyLiftLink = (0, _asyncToGenerator._)(function() {
            var metadata, show_skylift, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        show_skylift = (0, _cookieServiceDefault.default).getCookie('show_skylift');
                        if (!(show_skylift == null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                meta_key: 'tria_show_skylift_link'
                            })
                        ];
                    case 1:
                        metadata = _state.sent();
                        show_skylift = metadata.meta_value === 'TRUE' ? 1 : 0;
                        (0, _cookieServiceDefault.default).setCookie('show_skylift', show_skylift, 0, stateApp.env, '/');
                        return [
                            3,
                            3
                        ];
                    case 2:
                        metadata = {
                            meta_key: 'Tria_Show_Skylift_Link',
                            meta_value: show_skylift ? 'TRUE' : 'FALSE'
                        };
                        _state.label = 3;
                    case 3:
                        stateAppActions.setPortalCustomerMeta(metadata);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve('resolved');
                            })
                        ];
                    case 4:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineSkyLiftLink.apply(this, arguments);
    }
    function determineUpsellsEnabled() {
        return _determineUpsellsEnabled.apply(this, arguments);
    }
    function _determineUpsellsEnabled() {
        _determineUpsellsEnabled = (0, _asyncToGenerator._)(function() {
            var metadata, upsellsEnabled, ex;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        upsellsEnabled = (0, _cookieServiceDefault.default).getCookie('tria_upsell_ads');
                        if (!!upsellsEnabled) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0, _portalServiceDefault.default).getPortalCustomerMeta({
                                meta_key: 'tria_upsell_ads'
                            })
                        ];
                    case 1:
                        metadata = _state.sent();
                        (0, _cookieServiceDefault.default).setCookie('tria_upsell_ads', metadata.meta_value, 0, stateApp.env, '/');
                        return [
                            3,
                            3
                        ];
                    case 2:
                        metadata = {
                            meta_key: 'tria_upsell_ads',
                            meta_value: upsellsEnabled
                        };
                        _state.label = 3;
                    case 3:
                        stateAppActions.setPortalCustomerMeta(metadata);
                        return [
                            2,
                            new Promise(function(resolve) {
                                resolve('resolved');
                            })
                        ];
                    case 4:
                        ex = _state.sent();
                        console.log(ex);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _determineUpsellsEnabled.apply(this, arguments);
    }
    function determineResourceProperties() {
        return _determineResourceProperties.apply(this, arguments);
    }
    function _determineResourceProperties() {
        _determineResourceProperties = (0, _asyncToGenerator._)(function() {
            var resPropsResp, props, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, prop;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _cognitoAuthDefault.default).getResourceProperties(_org)
                        ];
                    case 1:
                        resPropsResp = _state.sent();
                        if (resPropsResp != null && resPropsResp.success && resPropsResp.resourceProperties != null) {
                            props = {};
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = resPropsResp.resourceProperties[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    prop = _step.value;
                                    props[prop.name] = prop.value;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            stateAppActions.setResourceProperties(props);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _determineResourceProperties.apply(this, arguments);
    }
    function clearCookies() {
        var validTime = (0, _misc.is_before_date)(new Date(), new Date(2021, 10, 31));
        var hasCookiesCleared = localStorage.getItem('TRIA_COOKIES_CLEARED');
        if (hasCookiesCleared == null && validTime) {
            (0, _cookieServiceDefault.default).deleteAllCookies('cognito');
            localStorage.setItem('TRIA_COOKIES_CLEARED', true);
        }
    }
    function loadData() {
        return _loadData.apply(this, arguments);
    }
    function _loadData() {
        _loadData = (0, _asyncToGenerator._)(function() {
            var d;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                determineClouds(),
                                determineIntegrations(),
                                determineSkyLiftLink(),
                                determineUpsellsEnabled(),
                                determineResourceProperties()
                            ]).then() // 1,Error: 2,3
                            .catch(function(e) {
                                return console.log(e);
                            })
                        ];
                    case 1:
                        _state.sent();
                        d = new Date();
                        d.setMinutes(d.getMinutes() + 720);
                        (0, _cookieServiceDefault.default).setCookie('session_timeout_time', d.getTime(), 1, stateApp.env);
                        stateAppActions.setSessionTimeoutTime(d.getTime());
                        setInFlight(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _loadData.apply(this, arguments);
    }
    (0, _react.useEffect)(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var org, superAdmin, sessionResponse, mfaEnabled, user, respOrgsAndUser, orgs, orgId, userResp, userAttrs;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setInFlight(true);
                    // refresh cognito token and info when refresh every page
                    org = null, superAdmin = false;
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).getSession()
                    ];
                case 1:
                    sessionResponse = _state.sent();
                    if (!sessionResponse.success) return [
                        3,
                        4
                    ];
                    console.log('We have Cognito cookies');
                    console.debug('Make Sure MFA is Enabled');
                    return [
                        4,
                        (0, _cognitoAuthDefault.default).hasMfaEnabled()
                    ];
                case 2:
                    mfaEnabled = _state.sent();
                    if (!mfaEnabled) window.location.href = (0, _config.ACCOUNTS_URL) + '/sign-in?next=' + window.location.href;
                    try {
                        if (sessionResponse.session.idToken.payload['cognito:groups']) {
                            console.log('** cognito groups: ', sessionResponse.session.idToken.payload['cognito:groups']);
                            superAdmin = sessionResponse.session.idToken.payload['cognito:groups'].indexOf('SuperAdmin') > -1;
                            _superAdmin = superAdmin;
                        }
                    } catch (e) {
                        console.error('Error to parse cognito:groups', e);
                    }
                    user = {
                        superAdmin: superAdmin,
                        orgAdmin: false
                    };
                    stateAppActions.setSuperAdmin(superAdmin);
                    return [
                        4,
                        Promise.all([
                            (0, _cognitoAuthDefault.default).getOrganizations(user, user.superAdmin),
                            (0, _cognitoAuthDefault.default).getUserInfo()
                        ]).then() // 1,Error: 2,3
                        .catch(function(e) {
                            return console.log(e);
                        })
                    ];
                case 3:
                    respOrgsAndUser = _state.sent();
                    // load organizations
                    orgs = respOrgsAndUser[0];
                    stateAppActions.setOrganizations(orgs);
                    orgId = urlQuery.get('org_id');
                    if (orgId) (0, _cognitoAuthDefault.default).setOrganizationCookie({
                        id: orgId
                    });
                    org = (0, _cognitoAuthDefault.default).getCurrentOrganization(orgs);
                    stateAppActions.setOrganization(org);
                    _org = org;
                    userResp = respOrgsAndUser[1];
                    if (userResp.success) {
                        userAttrs = userResp.user.attributes;
                        user.name = userAttrs.name;
                        user.id = userAttrs.sub;
                        user.user_id = userAttrs.sub;
                        user.email = userAttrs.email;
                        user.user_id = userAttrs.sub;
                        user.username = userAttrs.email;
                        // add legacy fields
                        user.organization_id = org ? org.id : null;
                        user.organization_name = org ? org.name : '';
                        stateAppActions.setAuthenticated(user);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    // here we don't have valid Divvy cookie and Cognito token
                    // need to authorize
                    console.log('We dont have valid Cognito token. Redirect to auth app');
                    window.location.href = (0, _config.ACCOUNTS_URL) + '/sign-in?next=' + window.location.href;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        loadData()
                    ];
                case 6:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        stateApp.reload
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        render: function(props) {
            return inFlight ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : stateApp.authenticated ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _policyRouteGuardDefault.default), {
                route: props.location.pathname,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpread._)({}, props, rest))
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: "/login".concat(rurl)
            });
        }
    }));
}
function flatten(ary, prop) {
    var ret = [];
    for(var i = 0; i < ary.length; i++)if (Array.isArray(ary[i][prop])) ret = ret.concat(flatten(ary[i][prop], prop));
    else ret.push(ary[i]);
    return ret;
}
exports.default = PrivateRoute;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_object_spread":"awG4j","@swc/helpers/_/_object_spread_props":"bAOpW","@swc/helpers/_/_object_without_properties":"jGp91","@swc/helpers/_/_sliced_to_array":"byksX","@swc/helpers/_/_to_consumable_array":"4zJ2w","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"acq4R","../services/CookieService":"iKLPT","../services/BlueMatadorService":"75h8Q","../services/ConnectriaBackupService":"l48ci","../services/ConnectriaTicketsService":"l5X0I","../services/CloudWatchService":"kxdTC","../services/TrendMicroService":"4MauW","../services/PortalService":"9VQnb","../utility/enum":"3A9fW","../AppState":"8UGXH","../utility/misc":"bM8Mk","./misc":"bM8Mk","../services/IBMService":"1UpC4","./CognitoAuth":"cngmx","../config":"kQzX9","./PolicyRouteGuard":"2B72e","../hooks/useQuery":"8J5ku","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2B72e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _appState = require("../AppState");
var _routes = require("../routes");
var checkPermissions = function(userPermissions, allowedPermissions) {
    if (allowedPermissions.length === 0) return true;
    return userPermissions.some(function(permission) {
        return allowedPermissions.includes(permission);
    });
};
var PolicyRouteGuard = function(param) {
    var user = param.user, userPermissions = param.userPermissions, allowedPermissions = param.allowedPermissions, children = param.children, renderNoAccess = param.renderNoAccess, accessCheck = param.accessCheck, extraAccessData = param.extraAccessData, route = param.route;
    try {
        var permitted;
        var _appState1 = (0, _slicedToArray._)((0, _appState.appState)(), 2), stateApp = _appState1[0], stateAppActions = _appState1[1];
        if (stateApp.superAdmin) return children;
        var flatRoutes = flatten((0, _routes.routes), "routes");
        var reg1 = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        var reg2 = /^[0-9]*$/;
        var parameterizedUrl = false;
        var routeParts = route.split('/');
        var endPart = routeParts[routeParts.length - 1];
        var newPath = '';
        if (reg1.test(endPart) || reg2.test(endPart)) //since this is a parameterized url lets set a bool to use for our replace logic
        parameterizedUrl = true;
        // const routeUrls = flatRoutes.map((r) => "".concat(r.layout, (r.path.indexOf(':') >-1   ?  (r.path.split(':')[0] + endPart) : r.path)));
        for(var i = 0; i < flatRoutes.length; i++)if ((flatRoutes[i].path || '').indexOf(':') > -1 && parameterizedUrl) flatRoutes[i].newPath = flatRoutes[i].path.split(':')[0] + endPart;
        else flatRoutes[i].newPath = flatRoutes[i].path;
        var routeUrls = flatRoutes.map(function(r) {
            return "".concat(r.layout, r.newPath);
        });
        var routePolicies = [];
        try {
            routePolicies = flatRoutes[routeUrls.indexOf(route)].policy || [];
        } catch (e) {
            console.error(e);
        }
        // console.log('Here is the route')
        // console.log(route)
        // console.log('Here is the routes')
        // console.log(routes)
        // console.log('Here is the flat routes')
        // console.log('Here is the route url')
        // console.log(routeUrls)
        // console.log(routeUrls.indexOf(route))
        //return children;
        // when an accessCheck function is provided, ensure that passes as well as the permissions
        if (accessCheck) permitted = accessCheck(extraAccessData, user) && checkPolicies(userPermissions, allowedPermissions);
        else // otherwise only check permissions
        permitted = checkPolicies(routePolicies);
        if (stateApp.superAdmin || permitted) return children;
        //if everything fails direct to access denied
        window.location.href = "/access-denied";
        //
        function checkPolicies(routePolicies) {
            var user_roles = stateApp.roles_v2;
            if (routePolicies.length == 0) return true;
            if (stateApp.superAdmin) return true;
            if (user_roles.filter(function(e) {
                return e.RoleName == "OrgAdmin";
            }).length > 0) return true;
            var flat_policies = flatten(user_roles, "Policies");
            var policy_codes = flat_policies.map(function(e) {
                return e.code;
            });
            for(var i = 0; i < routePolicies.length; i++){
                if (!policy_codes.includes(routePolicies[i])) return false;
            }
            return true;
        }
    } catch (ex) {
        console.log(ex);
    //window.location.href = "/access-denied";
    }
};
// EXAMPLE:
// <AccessControl
// extraAccessData={{ allowedNationality: "USA" }}
// accessCheck={(extraAccessData, user) =>
//   user && user.nationality === extraAccessData.allowedNationality
// }
// renderNoAccess={() => (
//   <View style={styles.countryWarning}>
//     <Text style={styles.noAccessText}>
//       Only Nuclear engineers from the USA 🇺🇸 can access this system.
//     </Text>
//   </View>
// )}
// >
// <AccessControl
// allowedPermissions={["read:stats"]}
// renderNoAccess={() => <NoAccess permissionsNeeded="read:stats" />}
// >
// <StatsPanel />
// </AccessControl>
function flatten(ary, prop) {
    var ret = [];
    for(var i = 0; i < ary.length; i++)if (Array.isArray(ary[i][prop])) ret = ret.concat(flatten(ary[i][prop], prop));
    else ret.push(ary[i]);
    return ret;
}
exports.default = PolicyRouteGuard;

},{"@swc/helpers/_/_sliced_to_array":"byksX","lodash":"iWrtO","react":"gVheC","react-redux":"7o5Bg","../AppState":"8UGXH","../routes":"bvYZI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iWrtO":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(_$Object, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)['delete'](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data['delete'](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if ((typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join('') : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) _$result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + '', array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case 'drop':
                        start += _$size;
                        break;
                    case 'dropRight':
                        end -= _$size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + _$size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, _typeOf._)(index);
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == 'function' ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + 'return ' + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (_$result.__dir__ < 0 ? 'Right' : '')
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == 'function' && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && (0, _typeOf._)(define.amd) == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

},{"@swc/helpers/_/_type_of":"668P4"}],"7o5Bg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", function() {
    return 0, _reactBatchedUpdates.unstable_batchedUpdates;
});
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch"); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"./exports":"8cR5k","./utils/reactBatchedUpdates":"dFAPQ","./utils/batch":"dSIRg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8cR5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return 0, _providerDefault.default;
});
parcelHelpers.export(exports, "connectAdvanced", function() {
    return 0, _connectAdvancedDefault.default;
});
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return 0, _context.ReactReduxContext;
});
parcelHelpers.export(exports, "connect", function() {
    return 0, _connectDefault.default;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return 0, _useDispatch.useDispatch;
});
parcelHelpers.export(exports, "createDispatchHook", function() {
    return 0, _useDispatch.createDispatchHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return 0, _useSelector.useSelector;
});
parcelHelpers.export(exports, "createSelectorHook", function() {
    return 0, _useSelector.createSelectorHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return 0, _useStore.useStore;
});
parcelHelpers.export(exports, "createStoreHook", function() {
    return 0, _useStore.createStoreHook;
});
parcelHelpers.export(exports, "shallowEqual", function() {
    return 0, _shallowEqualDefault.default;
});
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _context = require("./components/Context");
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);

},{"./components/Provider":"40QUl","./components/connectAdvanced":"d7zs2","./components/Context":"affTT","./connect/connect":"7uxTE","./hooks/useDispatch":"g19Yb","./hooks/useSelector":"bq0lC","./hooks/useStore":"lqYP7","./utils/shallowEqual":"k4mVL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40QUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, _react.useMemo)(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, _react.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"gVheC","prop-types":"3KNJy","./Context":"affTT","../utils/Subscription":"6liEf","../utils/useIsomorphicLayoutEffect":"jLVDw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"affTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return ReactReduxContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ReactReduxContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = ReactReduxContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6liEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", function() {
    return createSubscription;
});
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"dSIRg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dSIRg":[function(require,module,exports,__globalThis) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", function() {
    return setBatch;
});
parcelHelpers.export(exports, "getBatch", function() {
    return getBatch;
});
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function setBatch(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function getBatch() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jLVDw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d7zs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return connectAdvanced;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("./Context"); // Define some constant arrays just to avoid re-creating these
var _excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], _excluded2 = [
    "reactReduxForwardedRef"
];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function getDisplayName(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, _context.ReactReduxContext) : _ref2$context, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, _react.useMemo) : function usePureOnlyMemo(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, _react.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, _react.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, _react.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, _react.useMemo)(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, _react.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, _react.useRef)();
            var lastWrapperProps = (0, _react.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, _react.useRef)();
            var renderIsScheduled = (0, _react.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, _react.useMemo)(function() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, _react.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, _reactDefault.default).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","hoist-non-react-statics":"d2C2V","react":"gVheC","react-is":"3fr5l","../utils/Subscription":"6liEf","../utils/useIsomorphicLayoutEffect":"jLVDw","./Context":"affTT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fr5l":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"78bQy"}],"78bQy":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
'use strict';
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === (typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)) && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{"@swc/helpers/_/_type_of":"668P4"}],"7uxTE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", function() {
    return createConnect;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + (typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)) + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, _excluded);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = /*#__PURE__*/ createConnect();

},{"@swc/helpers/_/_type_of":"668P4","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","../components/connectAdvanced":"d7zs2","../utils/shallowEqual":"k4mVL","./mapDispatchToProps":"jCjOf","./mapStateToProps":"8TdlI","./mergeProps":"2lppN","./selectorFactory":"ig3CN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k4mVL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return shallowEqual;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, _typeOf._)(objA)) !== 'object' || objA === null || (typeof objB === "undefined" ? "undefined" : (0, _typeOf._)(objB)) !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jCjOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", function() {
    return whenMapDispatchToPropsIsFunction;
});
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", function() {
    return whenMapDispatchToPropsIsMissing;
});
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", function() {
    return whenMapDispatchToPropsIsObject;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, _typeOf._)(mapDispatchToProps)) === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"@swc/helpers/_/_type_of":"668P4","../utils/bindActionCreators":"8yZkl","./wrapMapToProps":"dBdZS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8yZkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return bindActionCreators;
});
function bindActionCreators(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dBdZS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", function() {
    return wrapMapToPropsConstant;
}) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", function() {
    return getDependsOnOwnProps;
}) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", function() {
    return wrapMapToPropsFunc;
});
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"8Gb9w","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Gb9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifyPlainObject;
});
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"g9zPN","./warning":"iTNv0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g9zPN":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPlainObject;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj)) !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@swc/helpers/_/_type_of":"668P4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iTNv0":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return warning;
});
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TdlI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", function() {
    return whenMapStateToPropsIsFunction;
});
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", function() {
    return whenMapStateToPropsIsMissing;
});
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"dBdZS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2lppN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", function() {
    return defaultMergeProps;
});
parcelHelpers.export(exports, "wrapMergePropsFunc", function() {
    return wrapMergePropsFunc;
});
parcelHelpers.export(exports, "whenMergePropsIsFunction", function() {
    return whenMergePropsIsFunction;
});
parcelHelpers.export(exports, "whenMergePropsIsOmitted", function() {
    return whenMergePropsIsOmitted;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../utils/verifyPlainObject":"8Gb9w","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ig3CN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", function() {
    return impureFinalPropsSelectorFactory;
});
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", function() {
    return pureFinalPropsSelectorFactory;
}) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", function() {
    return finalPropsSelectorFactory;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","./verifySubselectors":"dD35q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dD35q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifySubselectors;
});
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, 'mapStateToProps', displayName);
    verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    verify(mergeProps, 'mergeProps', displayName);
}

},{"../utils/warning":"iTNv0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g19Yb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", function() {
    return createDispatchHook;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return useDispatch;
});
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"affTT","./useStore":"lqYP7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lqYP7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", function() {
    return createStoreHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return useStore;
});
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function useReduxContext() {
        return (0, _react.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"react":"gVheC","../components/Context":"affTT","./useReduxContext":"HotAo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"HotAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", function() {
    return useReduxContext;
});
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    var contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"gVheC","../components/Context":"affTT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bq0lC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", function() {
    return createSelectorHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return useSelector;
});
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("../components/Context");
var refEquality = function refEquality(a, b) {
    return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, _react.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, _react.useMemo)(function() {
        return (0, _subscription.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, _react.useRef)();
    var latestSelector = (0, _react.useRef)();
    var latestStoreState = (0, _react.useRef)();
    var latestSelectedState = (0, _react.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function createSelectorHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function useReduxContext() {
        return (0, _react.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"gVheC","./useReduxContext":"HotAo","../utils/Subscription":"6liEf","../utils/useIsomorphicLayoutEffect":"jLVDw","../components/Context":"affTT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dFAPQ":[function(require,module,exports,__globalThis) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", function() {
    return 0, _reactDom.unstable_batchedUpdates;
});
var _reactDom = require("react-dom");

},{"react-dom":"d8jlt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8J5ku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useQuery;
});
var _reactRouterDom = require("react-router-dom");
function useQuery() {
    return new URLSearchParams((0, _reactRouterDom.useLocation)().search);
}

},{"react-router-dom":"acq4R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9DECy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var base_api = 'https://tria.connectria.com';
var CommonService = {
    getResProperties: function getResProperties(orgId) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (0, _axiosDefault.default).get(base_api + "/plugin/tria_interface/resource_properties/" + orgId, params);
    },
    setResProperty: function setResProperty(params) {
        console.log(params);
        return (0, _axiosDefault.default).post(base_api + '/plugin/tria_interface/set_resource_property', params);
    },
    addCloud: function addCloud(params) {
        return (0, _axiosDefault.default).post(base_api + '/v2/prototype/cloud/add', params);
    },
    status: function status(params) {
        return (0, _axiosDefault.default).get(base_api + '/Status', params);
    },
    statusOk: /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var res, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, _axiosDefault.default).get(base_api + '/Status', params)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data === '<STATUS>OK</STATUS>'
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            false
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()
};
exports.default = CommonService;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","axios":"ebRwi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sBwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonService = require("../services/CommonService");
var _commonServiceDefault = parcelHelpers.interopDefault(_commonService);
var _useAsyncEffect = require("../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var Maintenance = function(props) {
    var successAttempts = 0;
    (0, _useAsyncEffectDefault.default)(/*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(isMounted) {
            function HealthCheck() {
                return _HealthCheck.apply(this, arguments);
            }
            function _HealthCheck() {
                _HealthCheck = // setInterval(async () => {
                //   await HealthCheck();
                // }, 30000);
                (0, _asyncToGenerator._)(function() {
                    var status;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, _commonServiceDefault.default).statusOk()
                                ];
                            case 1:
                                status = _state.sent();
                                if (successAttempts == 2) window.location.href = "/";
                                if (status) successAttempts++;
                                return [
                                    2
                                ];
                        }
                    });
                });
                return _HealthCheck.apply(this, arguments);
            }
            return (0, _tsGenerator._)(this, function(_state) {
                try {
                    // let resp = await CommonService.status();
                    // console.log(resp)
                    // if(resp.data == '<STATUS>OK</STATUS>') window.location.href ="/"
                    if (!isMounted()) return [
                        2
                    ];
                    ;
                    ;
                } catch (error) {}
                return [
                    2
                ];
            });
        });
        return function(isMounted) {
            return _ref.apply(this, arguments);
        };
    }(), function() {}, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
            className: "construction",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    style: {
                        width: "300px"
                    },
                    src: "https://s3.amazonaws.com/connectria-branding/Connectria_logo.png"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    style: {
                        fontSize: "50px"
                    },
                    children: "TRiA will be back soon!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "TRiA is currently unavailable at this time due to scheduled maintenance. Please contact our Connectria Command Center for any of your questions or ticketing needs while the site is down. Thank you for your patience."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Connectria Command Center",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    className: "contrsuction-a ",
                                    href: "tel:1-800-781-7178",
                                    children: "1-800-781-7178"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "- TRIA Team"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = Maintenance;

},{"@swc/helpers/_/_async_to_generator":"3uGjr","@swc/helpers/_/_ts_generator":"2jVI5","react/jsx-runtime":"1elNt","react":"gVheC","../services/CommonService":"9DECy","../utility/use-async-effect":"fShZN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7GYCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonService = require("../services/CommonService");
var _commonServiceDefault = parcelHelpers.interopDefault(_commonService);
var _useAsyncEffect = require("../utility/use-async-effect");
var _useAsyncEffectDefault = parcelHelpers.interopDefault(_useAsyncEffect);
var AccessDenied = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
            className: "construction",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            style: {
                                width: "300px"
                            },
                            src: "https://s3.amazonaws.com/connectria-branding/Connectria_logo.png"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    style: {
                        fontSize: "35px"
                    },
                    children: "You currently do not have access to this page"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "/app/dashboard",
                                children: "Click here to Return Home"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Please contact your TRiA Organization Administrator for any of your questions around access and policies. Thank you for your patience."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Connectria Command Center",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    className: "contrsuction-a ",
                                    href: "tel:1-800-781-7178",
                                    children: "1-800-781-7178"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "- TRIA Team"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = AccessDenied;

},{"react/jsx-runtime":"1elNt","react":"gVheC","../services/CommonService":"9DECy","../utility/use-async-effect":"fShZN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ep8Cn":[function() {},{}],"jwREl":[function() {},{}],"jmQHV":[function() {},{}],"778iy":[function() {},{}],"OsGbX":[function() {},{}],"3T38Z":[function() {},{}]},["kyVrY","2MXAg"], "2MXAg", "parcelRequire94c2")

//# sourceMappingURL=index.1777760e.js.map
